webpackJsonp([2],Array(31).concat([
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export convertToPDFProducts */
/* unused harmony export convertToDairyPDFProducts */
/* unused harmony export getCustomerDetails */
/* unused harmony export convertToPDFProductWithExtraDetails */
/* unused harmony export convertToGST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return convertToEwayBillType1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return convertToBasicInvoice; });
/* unused harmony export toBase64 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return convertToBasicShortInvoice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return convertToBasicInvoiceHorizontal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return convertToBasicShortInvoiceHorizontal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return convertToBasicInvoiceWithoutGST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return convertToBasicInvoiceForDairyWithoutGST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return convertToBasicShortInvoiceWithoutGST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return convertToPDFGST_1_individual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return convertToPDFGST_1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return convertToPDFGST_3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buyerStatement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return buyerStatementDetailed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return convertToEwayBillType2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return convertToEwayBillType3; });
/* unused harmony export convertToPDFProductForSimplePrint */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return convertToSimpleInvoicePrint; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__digitsToWords_js__ = __webpack_require__(35);
var _this=this;// playground requires you to assign document definition to a variable called dd
// playground requires you to assign document definition to a variable called dd
var convertToPDFProducts=function convertToPDFProducts(items,isGST,invoiceData,metaData){var productList=[];var totalObj={quantity:0,basicPrice:0,totlePrice:0,CGST_val:0,SGST_val:0,IGST_val:0};var lastIndex=0;items.map(function(item,index){var product=[];lastIndex=index;product.push({text:index+1,style:"product"});// product.push({ text: item.productName, style: "product" });
product.push({text:item.productName+(item.subDescription?"\n"+item.subDescription+"\n":""),alignment:'left',style:'product'});if(isGST){product.push({text:item.HSN_code,style:"product"});}product.push({text:item.quantity,style:"productRight"});var unit=item.unit;if(metaData.terms.isMajorUnitDisplay&&metaData.productObj&&metaData.productObj[item.productId]&&metaData.productObj[item.productId].majorUnit){var text="("+item.quantity/metaData.productObj[item.productId].majorUnitQuantity+" "+metaData.productObj[item.productId].majorUnit+")";unit=unit+text;}product.push({text:unit,style:"product"});product.push({text:item.rate,style:"productRight"});// product.push({ text: item.basicPrice, style: "product" });
if(isGST){product.push({text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.basicPrice).toFixed(2),style:"productRight"});}if(isGST){product.push({text:item.CGST,style:"product"});product.push({text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.CGST_val).toFixed(2),style:"productRight"});product.push({text:item.SGST,style:"product"});product.push({text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.SGST_val).toFixed(2),style:"productRight"});product.push({text:item.IGST,style:"product"});product.push({text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.IGST_val).toFixed(2),style:"productRight"});}product.push({text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.totlePrice).toFixed(2),style:"productRight"});totalObj.quantity+=item.quantity;totalObj.basicPrice+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.basicPrice);totalObj.CGST_val+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.CGST_val);totalObj.SGST_val+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.SGST_val);totalObj.IGST_val+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.IGST_val);totalObj.totlePrice+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.totlePrice);productList.push(product);});if(invoiceData.gstOnExtraChanrges){var isIGST=invoiceData.gstType=='IGST'?true:false;invoiceData.extraCharges.map(function(item,index){lastIndex++;var product=[];product.push({text:lastIndex+1,style:"product"});// product.push({ text: item.productName, style: "product" });
product.push({text:item.name,alignment:'left',style:'product'});if(isGST){product.push({text:"",style:"product"});}product.push({text:"",style:"productRight"});product.push({text:"",style:"product"});product.push({text:"",style:"productRight"});// product.push({ text: item.basicPrice, style: "product" });
if(isGST){product.push({text:" ₹ "+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.amount).toFixed(2),style:"productRight"});}if(isGST){if(isIGST){product.push({text:"",style:"product"});product.push({text:"",style:"productRight"});product.push({text:"",style:"product"});product.push({text:"",style:"productRight"});product.push({text:item.gst,style:"product"});product.push({text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.gstAmount).toFixed(2),style:"productRight"});totalObj.IGST_val+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.gstAmount);}else{product.push({text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.gst/2).toFixed(2),style:"product"});product.push({text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.gstAmount/2).toFixed(2),style:"productRight"});product.push({text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.gst/2).toFixed(2),style:"product"});product.push({text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.gstAmount/2).toFixed(2),style:"productRight"});product.push({text:"",style:"product"});product.push({text:"",style:"productRight"});totalObj.CGST_val+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.gstAmount/2);totalObj.SGST_val+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.gstAmount/2);}}product.push({text:" ₹ "+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.gstAmount)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.amount)).toFixed(2),style:"productRight"});totalObj.quantity+=1;totalObj.basicPrice+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.amount);totalObj.totlePrice+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.gstAmount)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.amount);productList.push(product);});}if(isGST){productList.push([{text:'',style:"product"},{text:'Total',style:"total"},{text:'',style:"product"},{text:totalObj.quantity,style:"total"},{text:'',style:"product"},{text:'',style:"product"},{text:totalObj.basicPrice.toFixed(2),style:"totalRight"},{text:'',style:"totalRight"},{text:totalObj.CGST_val.toFixed(2),style:"totalRight"},{text:'',style:"totalRight"},{text:totalObj.SGST_val.toFixed(2),style:"totalRight"},{text:'',style:"totalright"},{text:totalObj.IGST_val.toFixed(2),style:"totalRight"},{text:totalObj.totlePrice.toFixed(2),style:"totalRight"}]);return productList;}else{productList.push([{text:'',style:"product"},{text:'Total',style:"total"},// { text: '', style: "product" },
{text:totalObj.quantity.toFixed(2),style:"totalRight"},{text:'',style:"product"},{text:'',style:"product"},{text:totalObj.basicPrice.toFixed(2),style:"totalRight"}]);//{ text: totalObj.totlePrice.toFixed(2), style: "total" }]);
return productList;}};// New Development For Dairy Business
var convertToDairyPDFProducts=function convertToDairyPDFProducts(items,isGST,invoiceData,metaData){var productList=[];var totalObj={quantity:0,fat:0,basicPrice:0,totlePrice:0,CGST_val:0,SGST_val:0,IGST_val:0};var lastIndex=0;items.map(function(item,index){var product=[];lastIndex=index;product.push({text:index+1,style:"product"});// product.push({ text: item.productName, style: "product" });
product.push({text:item.productName+(item.subDescription?"\n"+item.subDescription+"\n":""),alignment:'left',style:'product'});if(isGST){product.push({text:item.HSN_code,style:"product"});}product.push({text:item.quantity,style:"productRight"});var unit=item.unit;if(metaData.terms.isMajorUnitDisplay&&metaData.productObj&&metaData.productObj[item.productId]&&metaData.productObj[item.productId].majorUnit){var text="("+item.quantity/metaData.productObj[item.productId].majorUnitQuantity+" "+metaData.productObj[item.productId].majorUnit+")";unit=unit+text;}product.push({text:unit,style:"product"});product.push({text:item.fat,style:"productRight"});product.push({text:item.rate,style:"productRight"});// product.push({ text: item.basicPrice, style: "product" });
if(isGST){product.push({text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.basicPrice).toFixed(2),style:"productRight"});}if(isGST){product.push({text:item.CGST,style:"product"});product.push({text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.CGST_val).toFixed(2),style:"productRight"});product.push({text:item.SGST,style:"product"});product.push({text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.SGST_val).toFixed(2),style:"productRight"});product.push({text:item.IGST,style:"product"});product.push({text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.IGST_val).toFixed(2),style:"productRight"});}product.push({text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.totlePrice).toFixed(2),style:"productRight"});totalObj.quantity+=item.quantity;totalObj.fat+=item.fat;totalObj.basicPrice+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.basicPrice);totalObj.CGST_val+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.CGST_val);totalObj.SGST_val+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.SGST_val);totalObj.IGST_val+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.IGST_val);totalObj.totlePrice+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.totlePrice);productList.push(product);});if(invoiceData.gstOnExtraChanrges){var isIGST=invoiceData.gstType=='IGST'?true:false;invoiceData.extraCharges.map(function(item,index){lastIndex++;var product=[];product.push({text:lastIndex+1,style:"product"});// product.push({ text: item.productName, style: "product" });
product.push({text:item.name,alignment:'left',style:'product'});if(isGST){product.push({text:"",style:"product"});}product.push({text:"",style:"productRight"});product.push({text:"",style:"product"});product.push({text:"",style:"productRight"});product.push({text:"",style:"product"});if(isGST){product.push({text:" ₹ "+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.amount).toFixed(2),style:"productRight"});}if(isGST){if(isIGST){product.push({text:"",style:"product"});product.push({text:"",style:"productRight"});product.push({text:"",style:"product"});product.push({text:"",style:"productRight"});product.push({text:"",style:"productRight"});product.push({text:item.gst,style:"product"});product.push({text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.gstAmount).toFixed(2),style:"productRight"});totalObj.IGST_val+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.gstAmount);}else{product.push({text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.gst/2).toFixed(2),style:"product"});product.push({text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.gstAmount/2).toFixed(2),style:"productRight"});product.push({text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.gst/2).toFixed(2),style:"product"});product.push({text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.gstAmount/2).toFixed(2),style:"productRight"});product.push({text:"",style:"product"});product.push({text:"",style:"productRight"});totalObj.CGST_val+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.gstAmount/2);totalObj.SGST_val+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.gstAmount/2);}}product.push({text:" ₹ "+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.gstAmount)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.amount)).toFixed(2),style:"productRight"});totalObj.quantity+=1;totalObj.basicPrice+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.amount);totalObj.totlePrice+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.gstAmount)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.amount);productList.push(product);});}if(isGST){productList.push([{text:'',style:"product"},{text:'Total',style:"total"},{text:totalObj.quantity,style:"total"},{text:'',style:"product"},{text:'',style:"product"},{text:'',style:"product"},{text:'',style:"product"},{text:totalObj.basicPrice.toFixed(2),style:"totalRight"},{text:'',style:"totalRight"},{text:totalObj.CGST_val.toFixed(2),style:"totalRight"},{text:'',style:"totalRight"},{text:totalObj.SGST_val.toFixed(2),style:"totalRight"},{text:'',style:"totalright"},{text:totalObj.IGST_val.toFixed(2),style:"totalRight"},{text:totalObj.totlePrice.toFixed(2),style:"totalRight"}]);return productList;}else{productList.push([{text:'',style:"product"},{text:'Total',style:"total"},{text:totalObj.quantity.toFixed(2),style:"totalRight"},{text:'',style:"product"},{text:totalObj.fat.toFixed(2),style:"product"},{text:'',style:"product"},{text:totalObj.basicPrice.toFixed(2),style:"totalRight"}]);//{ text: totalObj.totlePrice.toFixed(2), style: "total" }]);
return productList;}};// End of New Development For Dairy Business
var getCustomerDetails=function getCustomerDetails(metaData,type){if(metaData.invoiceData.billingDetails){return metaData.invoiceData.billingDetails[type]?metaData.invoiceData.billingDetails[type]:'';}else{return metaData.customer[type]?metaData.customer[type]:'';}};// playground requires you to assign document definition to a variable called dd
var convertToPDFProductWithExtraDetails=function convertToPDFProductWithExtraDetails(businessType,items,isGST,invoiceData){var productList=[];var totalObj={quantity:0,basicPrice:0,totlePrice:0,CGST_val:0,SGST_val:0,IGST_val:0};var getBusinessfields=function getBusinessfields(businessType,item,index){switch(businessType){case'Jwellery':{switch(index){case 1:{return item['grossWeight']+" gm";break;}case 2:{return item['netWeight']+" gm";break;}case 3:{return item['purity']+" %";break;}}break;}case'Grain':{switch(index){// case 1 : {
// 	return item['grossWeight'] + " gm";
// 	break;
// }
case 2:{return item['netWeight']+item.unit;break;}case 3:{return item['purity']+" %";break;}}break;}case'Medical/Pesticides':{switch(index){case 1:{return item['batchNumber'];break;}case 2:{return item['manufacturingDate'];break;}case 3:{return item['expiryDate'];break;}}break;}case'Clothes':{switch(index){case 1:{return item['productBrandName'];break;}case 2:{return item['color'];break;}case 3:{return item['size'];break;}}break;}case'Automobile/Spare Parts':{switch(index){case 1:{return item['engineNumber'];break;}case 2:{return item['chasisNumber'];break;}case 3:{return item['extra'];break;}}break;}default:{switch(index){case 1:{return item['extra'];break;}case 2:{return item['extra'];break;}case 3:{return item['extra'];break;}}break;}}};var lastIndex=0;items.map(function(item,index){lastIndex=index;var product=[];product.push({text:index+1,style:"product"});// product.push({ text: item.productName, style: "product" });
product.push({text:item.productName+(item.subDescription?"\n( "+item.subDescription+") \n":""),style:"subproduct"});product.push({text:item.HSN_code,style:"product"});product.push({text:item.quantity,style:"product"});product.push({text:item.unit,style:"product"});product.push({text:"₹ "+item.rate,style:"product"});product.push({text:getBusinessfields(businessType,item,1),style:"product"});product.push({text:getBusinessfields(businessType,item,2),style:"product"});product.push({text:getBusinessfields(businessType,item,3),style:"product"});product.push({text:"₹ "+item.basicPrice,style:"productRight"});product.push({text:item.CGST,style:"product"});product.push({text:item.CGST_val,style:"productRight"});product.push({text:item.SGST,style:"product"});product.push({text:item.SGST_val,style:"productRight"});product.push({text:item.IGST,style:"product"});product.push({text:item.IGST_val,style:"productRight"});product.push({text:"₹ "+item.totlePrice,style:"productRight"});totalObj.quantity+=item.quantity;totalObj.basicPrice+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.basicPrice);totalObj.totlePrice+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.totlePrice);totalObj.CGST_val+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.CGST_val);totalObj.SGST_val+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.SGST_val);totalObj.IGST_val+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.IGST_val);productList.push(product);});if(invoiceData.gstOnExtraChanrges){var isIGST=invoiceData.gstType=='IGST'?true:false;invoiceData.extraCharges.map(function(item,index){var product=[];lastIndex++;product.push({text:lastIndex+1,style:"product"});// product.push({ text: item.productName, style: "product" });
product.push({text:item.name+(item.subDescription?"\n( "+item.subDescription+") \n":""),style:"subproduct"});product.push({text:"",style:"product"});product.push({text:"",style:"product"});product.push({text:"",style:"product"});product.push({text:"",style:"product"});product.push({text:"",style:"product"});product.push({text:"",style:"product"});product.push({text:"",style:"product"});product.push({text:"₹ "+item.amount,style:"productRight"});if(!isIGST){product.push({text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.gst/2).toFixed(2),style:"product"});product.push({text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.gstAmount/2).toFixed(2),style:"productRight"});product.push({text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.gst/2).toFixed(2),style:"product"});product.push({text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.gstAmount/2).toFixed(2),style:"productRight"});totalObj.CGST_val+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.gstAmount/2);totalObj.SGST_val+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.gstAmount/2);roduct.push({text:0,style:"product"});product.push({text:0,style:"productRight"});}else{product.push({text:"",style:"product"});product.push({text:"",style:"productRight"});product.push({text:"",style:"product"});product.push({text:"",style:"productRight"});product.push({text:item.gst,style:"product"});product.push({text:item.gstAmount,style:"productRight"});totalObj.IGST_val+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.gstAmount);}product.push({text:"₹ "+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.gstAmount)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.amount)).toFixed(2),style:"productRight"});totalObj.quantity+=0;totalObj.basicPrice+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.amount);totalObj.totlePrice+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.gstAmount)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.amount));productList.push(product);});}productList.push([{text:'',style:"product"},{text:'Total',style:"total"},{text:'',style:"product"},{text:totalObj.quantity,style:"total"},{text:'',style:"product"},{text:'',style:"product"},{text:'',style:"product"},{text:'',style:"product"},{text:'',style:"product"},{text:"₹ "+totalObj.basicPrice.toFixed(2),style:"totalRight"},{text:'',style:"totalRight"},{text:"₹ "+totalObj.CGST_val.toFixed(2),style:"totalRight"},{text:'',style:"totalRight"},{text:"₹ "+totalObj.SGST_val.toFixed(2),style:"totalRight"},{text:'',style:"totalRight"},{text:"₹ "+totalObj.IGST_val.toFixed(2),style:"totalRight"},{text:"₹ "+totalObj.totlePrice.toFixed(2),style:"totalRight"}]);return productList;};var convertToGST=function convertToGST(items){var totalObj={quantity:0,basicPrice:0,GSTValue:0,CGST_val:0,SGST_val:0,IGST_val:0};var result=items.reduce(function(r,a){if(r[a.HSN_code]){r[a.HSN_code].quantity+=a.quantity;r[a.HSN_code].basicPrice+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(a.basicPrice);r[a.HSN_code].GSTValue+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(a.GSTValue);r[a.HSN_code].CGST_val+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(a.CGST_val);r[a.HSN_code].SGST_val+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(a.SGST_val);r[a.HSN_code].IGST_val+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(a.IGST_val);}else{r[a.HSN_code]={quantity:a.quantity,basicPrice:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(a.basicPrice),GSTValue:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(a.GSTValue),CGST_val:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(a.CGST_val),SGST_val:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(a.SGST_val),IGST_val:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(a.IGST_val),CGST:a.CGST,SGST:a.SGST,IGST:a.IGST};}totalObj.quantity+=a.quantity;totalObj.basicPrice+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(a.basicPrice);totalObj.GSTValue+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(a.GSTValue);totalObj.CGST_val+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(a.CGST_val);totalObj.SGST_val+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(a.SGST_val);totalObj.IGST_val+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(a.IGST_val);return r;},__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(null));result.totalObj=totalObj;return result;};var convertToEwayBillType1=function convertToEwayBillType1(metaData){var pdfDoc={content:[{text:'TAX INVOICE\n',style:"bigger"},{table:{widths:['67.5%','32.5%'],body:[[{text:'FIRM DETAILS',style:"topHeader"},{text:'INVOICE  DETAILS',style:"topHeader"}],[{text:[{text:' ',bold:true,style:"topFirmHeader"},{text:'Google\n',style:"topFirmHeader"},{text:' ',bold:true,style:"firmHeader"},{text:'1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n',style:"firmHeader"},{text:' ',bold:true,style:"firmHeader"},{text:'88776655\n',style:"firmHeader"},{text:'  ',bold:true,style:"firmHeader"},{text:'123456\n',style:"firmHeader"},{text:'  ',bold:true,style:"firmHeader"},{text:'\n',style:"firmHeader"},{text:' ',bold:true,style:"firmHeader"},{text:'\n',style:"firmHeader"},{text:' ',bold:true,style:"firmHeader"},{text:'\n',style:"firmHeader"}]},{text:[{text:'Invoice No        :  ',bold:true,style:"firmHeader"},{text:'787878\n',style:"firmHeader"},{text:'Invoice Date     :  ',bold:true,style:"firmHeader"},{text:'12/12/90 \n',style:"firmHeader"},{text:'Invoice Status  :  ',bold:true,style:'firmHeader'},{text:'12/12/90 \n',style:'topRemainingHeader'},{text:'Payment Date  :  ',bold:true,style:"firmHeader"},{text:'13/12/90\n',style:"firmHeader"},{text:'E-Way Bill No   :  ',bold:true,style:'firmHeader'},{text:'787878\n',style:'firmHeader'},{text:'Order Number  :  ',bold:true,style:'firmHeader'},{text:'787878\n',style:'firmHeader'},{text:'Order Date        :   ',bold:true,style:'firmHeader'},{text:'12/12/90 \n',style:'firmHeader'}]}]]}},{table:{widths:['*','*','*'],body:[[{text:'RECIPIENT DETAILS',style:"topHeader"},{text:'CONSIGNEE DETAILS',style:"topHeader"},{text:'TRANSPORT DETAILS',style:"topHeader"}],[{text:[{text:' ',bold:true,style:"topFirmHeader1"},{text:'Google\n',style:"topFirmHeader1"},{text:' ',bold:true,style:"firmHeader"},{text:'1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n',style:"firmHeader"},{text:' ',bold:true,style:"firmHeader"},{text:'7788996655\n',style:"firmHeader"},{text:' ',bold:true,style:"firmHeader"},{text:'7788996655\n',style:"firmHeader"},{text:'Contact Number : ',bold:true,style:"firmHeader"},{text:'1679905\n',style:"firmHeader"},{text:'Place of Supply  : ',bold:true,style:"firmHeader"},{text:'23\n',style:"firmHeader"},{text:'State Code          : ',bold:true,style:"firmHeader"},{text:'23\n',style:"firmHeader"}]},{text:[{text:' ',bold:true,style:"topfirmHeader1"},{text:'Google\n',style:"topFirmHeader1"},{text:' ',bold:true,style:"firmHeader"},{text:'1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n',style:"firmHeader"},{text:' ',bold:true,style:"firmHeader"},{text:'7788996655\n',style:"firmHeader"},{text:' ',bold:true,style:"firmHeader"},{text:'7788996655\n',style:"firmHeader"},{text:'Contact Number : ',bold:true,style:"firmHeader"},{text:'1679905\n',style:"firmHeader"},{text:'Place of Supply  : ',bold:true,style:"firmHeader"},{text:'23\n',style:"firmHeader"},{text:'State Code          : ',bold:true,style:"firmHeader"},{text:'23\n',style:"firmHeader"}]},{text:[{text:'Transporter   :   ',bold:true,style:"firmHeader"},{text:'San Jose. \n',style:"firmHeader"},{text:'GR/LR No       :   ',bold:true,style:"firmHeader"},{text:'88776655\n',style:"firmHeader"},{text:'Vehicle No     :   ',bold:true,style:"firmHeader"},{text:'Google\n',style:"firmHeader"},{text:'Driver Name  :   ',bold:true,style:"firmHeader"},{text:'San Jose. \n',style:"firmHeader"},{text:'Driver M.No   :   ',bold:true,style:"firmHeader"},{text:'88776655\n',style:"firmHeader"},{text:' ',bold:true,style:"firmHeader"},{text:'12/06/89\n',style:"firmHeader"}]}]]}},{table:{body:[[{text:'S.No',style:"productHeader",rowSpan:2},{text:'Product Name',style:"productHeader",rowSpan:2},{text:'HSN code',style:"productHeader",rowSpan:2},{text:'Qty',style:"productHeader",rowSpan:2},{text:'Units',style:"productHeader",rowSpan:2},{text:'Rate',style:"productHeader",rowSpan:2},{text:'Taxable  Amount',style:"productHeader",rowSpan:2},{text:'CGST',style:"productHeader",colSpan:2,rowSpan:1},{text:'',style:"productHeader"},{text:'SGST',style:"productHeader",colSpan:2,rowSpan:1},{text:'',style:"productHeader"},{text:'IGST',style:"productHeader",colSpan:2,rowSpan:1},{text:'',style:"productHeader"},{text:'Total Amount',style:"productHeader",rowSpan:2}],[{text:'S.No',style:"productHeader"},{text:'Product Name',style:"productHeader"},{text:'HSN code',style:"productHeader"},{text:'Qty',style:"productHeader"},{text:'Units',style:"productHeader"},{text:'Rate',style:"productHeader"},{text:'Taxable Amount',style:"productHeader"},{text:'%',style:"productHeader"},{text:'₹',style:"productHeader"},{text:'%',style:"productHeader"},{text:'₹',style:"productHeader"},{text:'%',style:"productHeader"},{text:'₹',style:"productHeader"},{text:'Total Amount',style:"productHeader"}]]}},{table:{body:[[{text:'HSN SUMMARY',style:"topHeader",colSpan:10,decoration:'underline'},{text:'',style:"topHeader"},{text:'',style:"topHeader"},{text:'',style:"topHeader"},{text:'',style:"topHeader"},{text:'',style:"topHeader"},{text:'',style:"topHeader"},{text:'',style:"topHeader"},{text:'',style:"topHeader"},{text:'',style:"topHeader"}],[{text:'HSN/SAC',style:"gstHeader",rowSpan:2},{text:'QUANTITY',style:"gstHeader",rowSpan:2},{text:'TAXABLE AMOUNT',style:"gstHeader",rowSpan:2},{text:'CGST',style:"gstHeader",colSpan:2,rowSpan:1},{text:'',style:"gstHeader",rowSpan:2},{text:'SGST',style:"gstHeader",colSpan:2,rowSpan:1},{text:'',style:"gstHeader",rowSpan:2},{text:'IGST',style:"gstHeader",colSpan:2,rowSpan:1},{text:'',style:"gstHeader",rowSpan:2},{text:'TAX AMOUNT',style:"gstHeader",rowSpan:2}],[{text:'HSN/SAC',style:"gstHeader"},{text:'QUANTITY',style:"gstHeader"},{text:'TAXABLE AMOUNT ',style:"gstHeader"},{text:'%',style:"gstHeader"},{text:'AMOUNT',style:"gstHeader"},{text:'%',style:"gstHeader"},{text:'AMOUNT',style:"gstHeader"},{text:'%',style:"gstHeader"},{text:'AMOUNT',style:"gstHeader"},{text:'TAX AMOUNT',style:"gstHeader"}]]}},{table:{widths:['65%','*'],body:[[[{table:{widths:['*'],body:[[{text:'PAYMENT DETAILS',style:"topHeader"}]]},style:'tab2Head'},{table:{widths:['*'],body:[[{text:[]}]]},style:'tab2'},{table:{widths:['*'],body:[[{text:'TERMS & CONDITIONS',style:"topHeader"}]]},style:'tab2Head'},{table:{widths:['*'],body:[[{text:""}]]},style:'tab2'}],{text:[{text:'Taxable Amount:    ',bold:true,style:"firmHeader"},{text:'12122\n',style:"firmHeader"},{text:'CGST Amount:        ',bold:true,style:"firmHeader"},{text:'12122\n',style:"firmHeader"},{text:'SGST Amount:        ',bold:true,style:"firmHeader"},{text:'12122\n',style:"firmHeader"},{text:'IGST Amount:         ',bold:true,style:"firmHeader"},{text:'12122\n',style:"firmHeader"},// { text: 'Labour Charge:-                ', bold: true },
// { text: '12122\n' },
{text:'Discount:                 ',bold:true,style:"firmHeader"},{text:'12122\n',style:"firmHeader"},{text:'RoundOff:                ',bold:true,style:"firmHeader"},{text:'12122\n',style:"firmHeader"},{text:'Total Amount:         ',bold:true,style:"firmHeader"},{text:'12122\n',style:"firmHeader"},{text:'Paid Amount:          ',bold:true,style:"firmHeader"},{text:'12122\n',style:"firmHeader"},{text:'Due Amount:           ',bold:true,style:"firmHeader"},{text:'12122\n',style:"firmHeader"}]}]]},style:'tab2'},{table:{widths:['60%','*'],body:[[{text:[]},{text:[{text:''},{text:'Firm Name  ',bold:true,alignment:'center',style:'topFirmBasicAuthority'},{text:'\n\n\n'},{text:'AUTHORITY SIGNATURE  ',bold:true,alignment:'center',style:'topFirmBasicAuthority'},{text:'\n'}]}]]},style:'tab2'},{table:{widths:['*'],body:[[{text:'Thank you',alignment:'center'}]]},style:'tab2',pageBreak:'after'},{table:{widths:['*','*'],body:[[{text:'BASIC DETAILS',style:"header"},{text:'PART A',style:"header"}],[{text:[{text:'E-way Bill No:-     ',bold:true},{text:'Google\n'},{text:'E-way Bill Date:-  ',bold:true},{text:'1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n'},{text:'Generated By:-     ',bold:true},{text:'88776655\n'},{text:'Valid From:           ',bold:true},{text:'123456\n'},{text:'Valid Till:-              ',bold:true},{text:'njnjn@jnn.com\n'}]},{text:[{text:'GSTIN of Supplier:-    ',bold:true},{text:'Google\n'},{text:'Place Of Dispatch:-    ',bold:true},{text:'1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n'},{text:'GSTIN of Recipient:-  ',bold:true},{text:'88776655\n'},{text:'Place of Delivery:-     ',bold:true},{text:'123456\n'},{text:'Document No:-            ',bold:true},{text:'njnjn@jnn.com\n'},{text:'Value of Goods:-         ',bold:true},{text:'123456\n'},{text:'Reason of Transportation:-  ',bold:true},{text:'www.123456.com\n'},{text:'Document Date:-         ',bold:true},{text:'www.123456.com\n'},{text:'HSN code:-                   ',bold:true},{text:'www.123456.com\n'}]}]]}},{table:{body:[[{text:'PART B',style:"header",colSpan:7},{text:'',style:"header"},{text:'',style:"header"},{text:'',style:"header"},{text:'',style:"header"},{text:'',style:"header"},{text:'',style:"header"}],[{text:'Mode',style:"gstHeader"},{text:'Vehicle No',style:"gstHeader"},{text:'Entered By',style:"gstHeader"},{text:'Date &Time',style:"gstHeader"},{text:'From',style:"gstHeader"},{text:'To',style:"gstHeader"},{text:'CEWB No.',style:"gstHeader"}]]}}],footer:{columns:[{text:'Powered By ACUIFY',alignment:'right',color:'#160091'}],margin:[10,10]},styles:{header:{fontSize:10,bold:true,alignment:'center'},productHeader:{fontSize:10,color:'#160091',bold:true,alignment:'center'},gstHeader:{fontSize:10,bold:true,alignment:'center'},product:{fontSize:9,alignment:'center'},total:{fontSize:10,alignment:'center',bold:true},topFirmBasicAuthority:{color:'#160091',fontSize:10,bold:true},topRemainingHeader:{color:'#FF0000',fontSize:10,bold:true},topHeader:{color:'white',fontSize:10,alignment:'center',bold:true,fillColor:'#15155d'},firmHeader:{fontSize:10,bold:true},bankDetails:{fontSize:10,bold:true},topFirmHeader:{color:'#160091',fontSize:12,bold:true},topFirmHeader1:{color:'#160091',fontSize:11,bold:true},bigger:{fontSize:14,bold:true,color:"#160091",alignment:'center',// decoration: 'underline',
decorationStyle:'solid'// decorationColor: 'black'
}}//Firm Details 
};pdfDoc.content[1].table.body[1][0].text[1].text=(metaData.firm.name?metaData.firm.name.toUpperCase():'')+"\n";pdfDoc.content[1].table.body[1][0].text[3].text=(metaData.firm.GST_number?metaData.firm.GST_number:'')+"\n";pdfDoc.content[1].table.body[1][0].text[5].text=(metaData.firm.liveAddress?metaData.firm.liveAddress:'')+"\n";pdfDoc.content[1].table.body[1][0].text[7].text=(metaData.firm.address?metaData.firm.address:'')+"\n";pdfDoc.content[1].table.body[1][0].text[9].text=(metaData.firm.mobileNumber?metaData.firm.mobileNumber:'')+"\n";// pdfDoc.content[1].table.body[1][0].text[7].text = (metaData.firm.panNumber ? metaData.firm.panNumber : '') + "\n";
pdfDoc.content[1].table.body[1][0].text[11].text=(metaData.firm.email?metaData.firm.email:'')+"\n";pdfDoc.content[1].table.body[1][0].text[13].text=(metaData.firm.website?metaData.firm.website:'')+"\n";//Invoice Details
var date=new Date(metaData.invoiceData.date);var paymentDueDate=date.setDate(date.getDate()+(metaData.invoiceData.duration?parseInt(metaData.invoiceData.duration):0));pdfDoc.content[1].table.body[1][1].text[1].text=metaData.invoiceData.invoiceId+"\n";pdfDoc.content[1].table.body[1][1].text[3].text=new Date(metaData.invoiceData.date).toLocaleDateString('en-GB').toString()+"\n";pdfDoc.content[1].table.body[1][1].text[5].text=(metaData.invoiceData.status?metaData.invoiceData.status.toUpperCase():'')+"\n";pdfDoc.content[1].table.body[1][1].text[7].text=new Date(paymentDueDate).toLocaleDateString('en-GB').toString()+"\n";pdfDoc.content[1].table.body[1][1].text[9].text=(metaData.ebillDetails.billNo?metaData.ebillDetails.billNo:'')+"\n";//E-Way Bill NUMBER
pdfDoc.content[1].table.body[1][1].text[11].text=(metaData.invoiceData.orderNumber?metaData.invoiceData.orderNumber:'-')+"\n";pdfDoc.content[1].table.body[1][1].text[13].text=(metaData.invoiceData.orderDate?new Date(metaData.invoiceData.orderDate).toLocaleDateString('en-GB').toString():'-')+"\n";//Receipient Details
pdfDoc.content[2].table.body[1][0].text[1].text=(metaData.customer.name?metaData.customer.name:'')+"\n";pdfDoc.content[2].table.body[1][0].text[3].text=(metaData.customer.GST_number?metaData.customer.GST_number:'')+"\n";pdfDoc.content[2].table.body[1][0].text[5].text=(metaData.customer.localAddress?metaData.customer.localAddress:'')+"\n";pdfDoc.content[2].table.body[1][0].text[7].text=(metaData.customer.address?metaData.customer.address:'')+"\n";pdfDoc.content[2].table.body[1][0].text[9].text=(metaData.customer.mobile?metaData.customer.mobile:'')+"\n";pdfDoc.content[2].table.body[1][0].text[11].text=(metaData.invoiceData.placeOfSupply?metaData.invoiceData.placeOfSupply:'')+"\n";pdfDoc.content[2].table.body[1][0].text[13].text=(metaData.customer.stateCode?metaData.customer.stateCode:'')+"\n";//Consignee Details
pdfDoc.content[2].table.body[1][1].text[1].text=(metaData.consignee.name?metaData.consignee.name:'')+"\n";pdfDoc.content[2].table.body[1][1].text[3].text=(metaData.consignee.GST_number?metaData.consignee.GST_number:'')+"\n";pdfDoc.content[2].table.body[1][1].text[5].text=(metaData.customer.localAddress?metaData.consignee.localAddress:'')+"\n";pdfDoc.content[2].table.body[1][1].text[7].text=(metaData.consignee.address?metaData.consignee.address:'')+"\n";pdfDoc.content[2].table.body[1][1].text[9].text=(metaData.consignee.mobile?metaData.consignee.mobile:'')+"\n";pdfDoc.content[2].table.body[1][1].text[11].text=(metaData.invoiceData.placeOfSupply?metaData.invoiceData.placeOfSupply:'')+"\n";pdfDoc.content[2].table.body[1][1].text[13].text=(metaData.consignee.stateCode?metaData.consignee.stateCode:'')+"\n";//transpotation Details
pdfDoc.content[2].table.body[1][2].text[1].text=(metaData.transportationDetails.transporterName?metaData.transportationDetails.transporterName:'')+"\n";pdfDoc.content[2].table.body[1][2].text[3].text=(metaData.transportationDetails.goodsReceiptNumber?metaData.transportationDetails.goodsReceiptNumber:'')+"\n";pdfDoc.content[2].table.body[1][2].text[5].text=(metaData.transportationDetails.vehicleNo?metaData.transportationDetails.vehicleNo:'')+"\n";pdfDoc.content[2].table.body[1][2].text[7].text=(metaData.transportationDetails.driverName?metaData.transportationDetails.driverName:'')+"\n";pdfDoc.content[2].table.body[1][2].text[9].text=(metaData.transportationDetails.driverNumber?metaData.transportationDetails.driverNumber:'')+"\n";pdfDoc.content[2].table.body[1][2].text[11].text=(metaData.transportationDetails.supplyDate?new Date(metaData.transportationDetails.supplyDate).toLocaleDateString('en-GB').toString():'')+"\n";// pdfDoc.content[2].table.body[1][2].text[13].text = (metaData.consignee.address ? metaData.consignee.address : '') + "\n";
//Products
// let productList = convertToPDFProducts(metaData.invoiceData.items,true);
var productList=convertToPDFProducts(metaData.invoiceData.items,true,metaData.invoiceData,metaData);productList.map(function(item){pdfDoc.content[3].table.body.push(item);});var gstObj=convertToGST(metaData.invoiceData.items);__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(gstObj).forEach(function(key){if(key!="totalObj"){pdfDoc.content[4].table.body.push([{text:key,style:"product"},{text:gstObj[key].quantity,style:"product"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj[key].basicPrice).toFixed(2),style:"total"},{text:gstObj[key].CGST+'%',style:"product"},{text:gstObj[key].CGST_val,style:"product"},{text:gstObj[key].SGST+'%',style:"product"},{text:gstObj[key].SGST_val,style:"product"},{text:gstObj[key].IGST+'%',style:"product"},{text:gstObj[key].IGST_val,style:"product"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj[key].basicPrice)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj[key].GSTValue)).toFixed(2),style:"product"}]);}});pdfDoc.content[4].table.body.push([{text:'Total',style:"total"},{text:gstObj.totalObj.quantity,style:"total"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj.totalObj.basicPrice).toFixed(2),style:"total"},{text:'',style:"total"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj.totalObj.CGST_val).toFixed(2),style:"total"},{text:'',style:"total"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj.totalObj.SGST_val).toFixed(2),style:"total"},{text:'',style:"total"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj.totalObj.IGST_val).toFixed(2),style:"total"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj.totalObj.basicPrice)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj.totalObj.GSTValue)).toFixed(2),style:"total"}]);//Bank Account Details
if(metaData.terms.banks.length){metaData.terms.banks.map(function(bankDetails){pdfDoc.content[5].table.body[0][0][1].table.body[0][0].text.push({text:bankDetails.bankName+"\n",style:'bankDetails'});pdfDoc.content[5].table.body[0][0][1].table.body[0][1].text.push({text:"NAME: "+bankDetails.accountHolderName+"\n",style:'bankDetails'});pdfDoc.content[5].table.body[0][0][1].table.body[0][0].text.push({text:"A/C NO: "+bankDetails.accountnumber+"\n",style:'bankDetails'});pdfDoc.content[5].table.body[0][0][1].table.body[0][0].text.push({text:"IFSC: "+bankDetails.ifsccode+"\n",style:'bankDetails'});pdfDoc.content[5].table.body[0][0][1].table.body[0][0].text.push({text:bankDetails.address+"\n",style:'bankDetails'});});}//Terms and cond
pdfDoc.content[5].table.body[0][0][3].table.body[0][0]=metaData.terms.termsAndConditions;//gst details
// pdfDoc.content[5].table.body[0][1].text[1].text = (metaData.invoiceData.totalAmount ? Number.parseFloat(metaData.invoiceData.totalAmount).toFixed(2) - Number.parseFloat(metaData.gstTotal.CGST_val + metaData.gstTotal.SGST_val + metaData.gstTotal.IGST_val).toFixed(2) : '0') + "\n";
// pdfDoc.content[5].table.body[0][1].text[1].text = (metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount ? Number.parseFloat(metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount).toFixed(2) - Number.parseFloat(metaData.gstTotal.CGST_val + metaData.gstTotal.SGST_val + metaData.gstTotal.IGST_val).toFixed(2) : '0').toFixed(2) + "\n";
pdfDoc.content[5].table.body[0][1].text[1].text=(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalAmount)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.discountAmount||0)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?0:-__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraCharges))-__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraChargesGST):0)-__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.roundOffAmount||0)-(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.SGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.CGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.IGST_val))).toFixed(2)+"\n";// pdfDoc.content[5].table.body[0][1].text[3].text = (metaData.gstTotal.CGST_val ? Number.parseFloat(metaData.gstTotal.CGST_val).toFixed(2) : '0') + "\n";
// pdfDoc.content[5].table.body[0][1].text[5].text = (metaData.gstTotal.SGST_val ? Number.parseFloat(metaData.gstTotal.SGST_val).toFixed(2) : '0') + "\n";
// pdfDoc.content[5].table.body[0][1].text[7].text = (metaData.gstTotal.IGST_val ? Number.parseFloat(metaData.gstTotal.IGST_val).toFixed(2) : '0') + "\n";
pdfDoc.content[5].table.body[0][1].text[3].text=(metaData.gstTotal.CGST_val?(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.CGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraChargesGST)/2:0)).toFixed(2):'0.00')+"\n";pdfDoc.content[5].table.body[0][1].text[5].text=(metaData.gstTotal.SGST_val?(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.SGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraChargesGST)/2:0)).toFixed(2):'0.00')+"\n";pdfDoc.content[5].table.body[0][1].text[7].text=(metaData.gstTotal.IGST_val?(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.IGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraChargesGST):0)).toFixed(2):'0.00')+"\n";// pdfDoc.content[5].table.body[0][1].text[9].text = (metaData.invoiceData.labourAmount ? Number.parseFloat(metaData.invoiceData.labourAmount).toFixed(2) : '0') + "\n";
var offset=0;// if(metaData.invoiceData.extraCharges && metaData.invoiceData.extraCharges.length) {
if(!metaData.invoiceData.gstOnExtraChanrges&&metaData.invoiceData.extraCharges&&metaData.invoiceData.extraCharges.length){metaData.invoiceData.extraCharges.map(function(charge){pdfDoc.content[5].table.body[0][1].text.splice(8+offset,0,{text:''+charge.name+':        ',bold:true,style:'firmHeader'});offset++;pdfDoc.content[5].table.body[0][1].text.splice(8+offset,0,{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(charge.amount).toFixed(2)+'\n',style:'firmHeader'});offset++;});}pdfDoc.content[5].table.body[0][1].text[9+offset].text=(metaData.invoiceData.discountAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.discountAmount).toFixed(2):'0')+"\n";pdfDoc.content[5].table.body[0][1].text[11+offset].text=(metaData.invoiceData.roundOffAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.roundOffAmount).toFixed(2):'0')+"\n";pdfDoc.content[5].table.body[0][1].text[13+offset].text=(metaData.invoiceData.totalAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalAmount).toFixed(2):'0')+"\n";pdfDoc.content[5].table.body[0][1].text[15+offset].text=(metaData.invoiceData.paidAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.paidAmount).toFixed(2):'0')+"\n";pdfDoc.content[5].table.body[0][1].text[17+offset].text=(metaData.invoiceData.remainingAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.remainingAmount).toFixed(2):'')+"\n";// if(metaData.invoiceData.extraCharges && metaData.invoiceData.extraCharges.length) {
// 						metaData.invoiceData.extraCharges.map((charge)=>{
// 							pdfDoc.content[5].table.body[0][1].text.push({ text: ''+charge.name+':-          ', bold: true })
// 							pdfDoc.content[5].table.body[0][1].text.push({ text:charge.amount+'\n' })
// 						})
// 					}
// pdfDoc.content[6].table.body[0][1].text[17].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";
//authority
pdfDoc.content[6].table.body[0][1].text[1].text=metaData.firm.name?metaData.firm.name.toUpperCase():'';//thank you
// pdfDoc.content[7].table.body[0][0].text =  "Thank You " + (metaData.customer.name.toUpperCase() ? metaData.customer.name.toUpperCase() : '') +" For Choosing us!" ;
pdfDoc.content[7].table.body[0][0].text=metaData.terms.termsAndConditions.greetingMessage||"Thank You "+(metaData.customer&&metaData.customer.name?metaData.customer.name.toUpperCase():'')+" For Choosing us!";//Basic Details
pdfDoc.content[8].table.body[1][0].text[1].text=(metaData.ebillDetails.billNo?metaData.ebillDetails.billNo:'')+"\n";//eway bill number
pdfDoc.content[8].table.body[1][0].text[3].text=(metaData.ebillDetails.billDate?new Date(metaData.ebillDetails.billDate).toLocaleDateString('en-GB').toString():'')+"\n";//e-way bill date
pdfDoc.content[8].table.body[1][0].text[5].text=(metaData.ebillDetails.generatedBy?metaData.ebillDetails.generatedBy:'')+"\n";//generated by
pdfDoc.content[8].table.body[1][0].text[7].text=(metaData.invoiceData.date?new Date(metaData.ebillDetails.date).toLocaleDateString('en-GB').toString():'')+"\n";//Valid from
pdfDoc.content[8].table.body[1][0].text[9].text=(metaData.ebillDetails.validUntil?new Date(metaData.ebillDetails.validUntil).toLocaleDateString('en-GB').toString():'')+"\n";//Valid Till
//Part A
pdfDoc.content[8].table.body[1][1].text[1].text=(metaData.ebillDetails.GSTofSupplier?metaData.ebillDetails.GSTofSupplier:'')+"\n";//gstin of supplier
pdfDoc.content[8].table.body[1][1].text[3].text=(metaData.ebillDetails.placeOfDispatch?metaData.ebillDetails.placeOfDispatch:'')+"\n";//place of dispatch
pdfDoc.content[8].table.body[1][1].text[5].text=(metaData.ebillDetails.GSTofReceipient?metaData.ebillDetails.GSTofReceipient:'')+"\n";//gstin of receipent
pdfDoc.content[8].table.body[1][1].text[7].text=(metaData.ebillDetails.placeOfDelivery?metaData.ebillDetails.placeOfDelivery:'')+"\n";//place of delivary
pdfDoc.content[8].table.body[1][1].text[9].text=(metaData.ebillDetails.documentNo?metaData.ebillDetails.documentNo:'')+"\n";//document number
pdfDoc.content[8].table.body[1][1].text[11].text=(metaData.ebillDetails.valueOfGoods?metaData.ebillDetails.valueOfGoods:'')+"\n";//value of goods
pdfDoc.content[8].table.body[1][1].text[13].text=(metaData.ebillDetails.reasonOfTransportation?metaData.ebillDetails.reasonOfTransportation:'')+"\n";//reason of transpotation
pdfDoc.content[8].table.body[1][1].text[15].text=(metaData.ebillDetails.documentDate?new Date(metaData.ebillDetails.documentDate).toLocaleDateString('en-GB').toString():'')+"\n";//document date
pdfDoc.content[8].table.body[1][1].text[17].text=''+"\n";//hsn code
//part b
pdfDoc.content[9].table.body.push([{text:metaData.ebillDetails.transportationDetails.mode,style:"Header3"},//mode
{text:metaData.ebillDetails.transportationDetails.vehicleNo,style:"Header3"},//vehicle no
{text:metaData.ebillDetails.transportationDetails.enteredBy,style:"Header3"},//entered by
{text:metaData.ebillDetails.transportationDetails.departureDate,style:"Header3"},//time and date
{text:metaData.ebillDetails.transportationDetails.from,style:"Header3"},//from
{text:metaData.ebillDetails.transportationDetails.to,style:"Header3"},//to
{text:metaData.ebillDetails.transportationDetails.CEWBno,style:"Header3"}]//cewb no
);return pdfDoc;};var convertToBasicInvoice=function(){var _ref=__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(metaData){var pdfDoc,date,paymentDueDate,productList,offset,logoData,invoiceImages,temp,_temp,imgToExport,canvas,base64,_invoiceImages,_temp2,_temp3;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:pdfDoc={content:[{table:{widths:['*'],body:[[{text:'TAX INVOICE',style:"topHeader1"}]]},layout:'noBorders'},{table:{widths:['0%','45%','*'],body:[[{text:''},{image:'',width:100,height:80},{text:[{text:' ',bold:true,style:'topFirmAuthorityRight'},{text:'\n',style:'topFirmAuthorityRight'},{text:' ',bold:true,style:'topHeaderRight'},{text:'1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n',style:'topHeaderRight'},{text:' ',bold:true,style:'topHeaderRight'},{text:'1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n',style:'topHeaderRight'},{text:'',bold:true,style:'topHeaderRight'},{text:'88776655\n',style:'topHeaderRight'},{text:'',bold:true,style:'topHeaderRight'},//icon gift
{text:'njnjn@jnn.com\n',style:'topHeaderRight'},{text:' ',bold:true,style:'topHeaderRight'},{text:'123456\n',style:'topHeaderRight'}]}]]},layout:'noBorders',style:"topTab"},{table:{widths:['0%','65%','*'],body:[[{text:'',style:"billToHeader"},{text:'BILL TO',style:"billToHeader"},{text:'INVOICE DETAILS',style:"invoiceDetailHeader"}]]},style:'tab2Head',layout:'noBorders'},{table:{widths:['0%','65%','*'],body:[[{text:''},{text:[{text:' ',bold:true,style:'topCustomerHeader'},{text:'Google\n',style:'topCustomerHeader'},{text:' ',bold:true,style:'topHeader'},{text:'1679905\n',style:'topHeader'},{text:'  ',bold:true,style:'topHeader'},{text:'7788996655\n',style:'topHeader'},{text:'  ',bold:true,style:'topHeader'},{text:'1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n',style:'topHeader'},{text:'Mobile Number: ',bold:true,style:'topHeader'},{text:'23\n',style:'topHeader'},{text:'Place of supply:   ',bold:true,style:'topHeader'},{text:'13/12/90\n',style:'topHeader'},{text:'State Code:   ',bold:true,style:'topHeader'},{text:'13/12/90\n',style:'topHeader'}]},{text:[{text:'Invoice No:                  ',bold:true,style:'topHeader'},{text:'787878\n',style:'topHeader'},{text:'Invoice Date:               ',bold:true,style:'topHeader'},{text:'12/12/90 \n',style:'topHeader'},{text:'Invoice Status:            ',bold:true,style:'topHeader'},{text:'12/12/90 \n',style:'topRemainingHeader'},{text:'Payment Due Date:    ',bold:true,style:'topHeader'},{text:'13/12/90\n',style:'topHeader'},{text:'Remark:    ',bold:true,style:'topHeader'},{text:'13/12/90\n',style:'topHeader'}]}]]},style:'tab2',layout:'noBorders'},{table:{widths:['*','*'],body:[[{text:'PRODUCT DETAILS',style:"emptyHeader"},{text:'',style:"emptyHeader"}]]},layout:'noBorders'},{table:{body:[[{text:'S.No',style:"productHeader",rowSpan:2},{text:'Product Name',style:"productHeader",rowSpan:2},{text:'HSN code',style:"productHeader",rowSpan:2},{text:'Qty',style:"productHeader",rowSpan:2},{text:'Units',style:"productHeader",rowSpan:2},{text:'Unit Price',style:"productHeader",rowSpan:2},{text:'Taxable  Amount',style:"productHeader",rowSpan:2},{text:'CGST',style:"productHeader",colSpan:2,rowSpan:1},{text:'',style:"productHeader"},{text:'SGST',style:"productHeader",colSpan:2,rowSpan:1},{text:'',style:"productHeader"},{text:'IGST',style:"productHeader",colSpan:2,rowSpan:1},{text:'',style:"productHeader"},{text:'Total Amount',style:"productHeader",rowSpan:2}],[{text:'S.No',style:"productHeader"},{text:'Product Name',style:"productHeader"},{text:'HSN code',style:"productHeader"},{text:'Qty',style:"productHeader"},{text:'Units',style:"productHeader"},{text:'Rate',style:"productHeader"},{text:'Taxable Amount',style:"productHeader"},{text:'%',style:"productHeader"},{text:'₹',style:"productHeader"},{text:'%',style:"productHeader"},{text:'₹',style:"productHeader"},{text:'%',style:"productHeader"},{text:'₹',style:"productHeader"},{text:'Total Amount',style:"productHeader"}]]}},{table:{widths:['70%','*'],body:[[[{table:{widths:['*'],body:[[{text:'PAYMENT DETAILS',style:"leftHeader"}]]},style:'tab2Head',layout:'noBorders'},{table:{widths:['3%','*'],body:[[{text:''},{text:[]}]]},style:'tab2',layout:'noBorders'},{table:{widths:['*'],body:[[{text:'TERMS & CONDITIONS',style:"leftHeader"}]]},style:'tab2Head',layout:'noBorders'},{table:{widths:['3%','*'],body:[[{text:''},{text:""}]]},style:'tab2',layout:'noBorders'}],{text:[{text:'Taxable Amount:     ',bold:true,style:'topHeader'},{text:'12122\n',style:'topHeader'},{text:'CGST Amount:         ',bold:true,style:'topHeader'},{text:'12122\n',style:'topHeader'},{text:'SGST Amount:         ',bold:true,style:'topHeader'},{text:'12122\n',style:'topHeader'},{text:'IGST Amount:          ',bold:true,style:'topHeader'},{text:'12122\n',style:'topHeader'},// { text: 'Labour Charge:       ', bold: true, style: 'topHeader' },
// { text: '12122\n', style: 'topHeader' },
{text:'Discount:                  ',bold:true,style:'topHeader'},{text:'12122\n',style:'topHeader'},{text:'RoundOff:                 ',bold:true,style:'topHeader'},{text:'12122\n',style:'topHeader'},{text:'Total Amount:          ',bold:true,style:'topHeader11'},{text:'12122\n',style:'topHeader11'},{text:'Paid Amount:           ',bold:true,style:'topHeader'},{text:'12122\n',style:'topHeader'},{text:'Due Amount:            ',bold:true,style:'topRemainingHeader'},{text:'12122\n',style:'topRemainingHeader'}]}]]},style:'tab2',layout:'lightHorizontalLines'},{table:{widths:['*','*'],body:[[{text:'OUTSTANDING DETAILS',style:"emptyHeader"},{text:'',style:"emptyHeader"}]]},layout:'noBorders'},// Start of Previous + current = Total Column
{table:{widths:['34%','39%','27%'],body:[[{text:'',style:"topBlankHeader"},{text:'',style:"topMainHeader"},{text:'',style:"topBlankHeader"}],[{text:[{text:'PREVIOUS BALANCE :  ',bold:true,style:'topHeader11'},{text:'\n',style:'topHeader11'}]},{text:[{text:'CURRENT BALANCE :  ',bold:true,style:'topHeader11'},{text:'\n',style:'topHeader11'}]},{text:[{text:'TOTAL BALANCE :  ',bold:true,style:'topRemainingHeader'},{text:'\n',style:'topRemainingHeader'}]}]]},layout:{hLineWidth:function hLineWidth(i,node){return i===0||i===node.table.body.length?1:0;},vLineWidth:function vLineWidth(i,node){return i===0||i===node.table.widths.length?1:0;},hLineColor:function hLineColor(i,node){return i===0||i===node.table.body.length?'black':'black';},vLineColor:function vLineColor(i,node){return i===0||i===node.table.widths.length?'black':'black';}}},// End of Previous + current = Total Column
{table:{widths:['60%','*'],body:[[{text:[]},[{text:''},{text:'Firm Name  ',bold:true,alignment:'center',style:'topFirmBasicAuthority'},{text:'\n\n\n'},{text:'AUTHORITY SIGNATURE  ',bold:true,alignment:'center',style:'topFirmBasicAuthority'},{text:'\n'}]]]},style:'tab2',layout:'noBorders'},{table:{widths:['*'],body:[[{text:'Thank you',alignment:'center'}]]},layout:'noBorders',style:'tab2'}],footer:{columns:[{text:'Powered By ACUIFY',alignment:'right',color:'#160091'}],margin:[10,10]},styles:{header:{fontSize:10,bold:true,alignment:'center'},billToHeader:{fontSize:12,bold:true,alignment:'left'},invoiceDetailHeader:{fontSize:12,bold:true,alignment:'left'},header1:{color:'#160091',fontSize:10,bold:true,fillColor:'#15155d'},product:{fontSize:9,alignment:'center'},productRight:{fontSize:10,alignment:'right'// bold: true
},totalRight:{fontSize:10,alignment:'right',bold:true},total:{fontSize:10,alignment:'center',bold:true},topHeader:{fontSize:10,bold:true,fillColor:'#15155d'},topHeaderRight:{fontSize:10,bold:true,fillColor:'#15155d',alignment:'right'},topCustomerHeader:{fontSize:12,bold:true,color:'#160091'},topHeader1:{color:'white',fontSize:14,bold:true,alignment:'center',fillColor:'#15155d'},topHeader11:{color:'#160091',fontSize:10,bold:true},topRemainingHeader:{color:'#FF0000',fontSize:10,bold:true},topFirmAuthority:{color:'#160091',fontSize:12,bold:true},topFirmAuthorityRight:{color:'#160091',fontSize:14,bold:true,alignment:'right'},topFirmBasicAuthority:{color:'#160091',fontSize:10,bold:true},leftHeader:{fontSize:10,bold:true,alignment:'left'},emptyHeader:{fontSize:10,color:'white',fillColor:'#15155d',bold:true},topTab:{fillColor:'#ececec'},tab2Head:{color:'white',fillColor:'#015155d'},tab2:{fillColor:'#ececec'},bankDetails:{fontSize:10,bold:true},productHeader:{fontSize:10,bold:true,alignment:'center',color:'#160091'},hiddenTab:{fillColor:'#ececec',color:'#ececec'}}//Firm Details 
// pdfDoc.content[1].table.body[0][2].text[1].text = (metaData.firm.name.toUpperCase() ? metaData.firm.name.toUpperCase() : '') + "\n";
};pdfDoc.content[1].table.body[0][2].text[1].text=(metaData.firm&&metaData.firm.name?metaData.firm.name.toUpperCase():'')+"\n";pdfDoc.content[1].table.body[0][2].text[3].text=(metaData.firm.GST_number?metaData.firm.GST_number:'')+"\n";pdfDoc.content[1].table.body[0][2].text[5].text=(metaData.firm.liveAddress?metaData.firm.liveAddress:'')+"\n";pdfDoc.content[1].table.body[0][2].text[7].text=(metaData.firm.address?metaData.firm.address:'')+"\n";pdfDoc.content[1].table.body[0][2].text[9].text=(metaData.firm.mobileNumber?metaData.firm.mobileNumber:'')+"\n";pdfDoc.content[1].table.body[0][2].text[11].text=(metaData.firm.email?metaData.firm.email:'')+"\n";//Receipient Details
// pdfDoc.content[3].table.body[0][1].text[1].text = (metaData.customer.name.toUpperCase() ? metaData.customer.name.toUpperCase() : '') + "\n";
// pdfDoc.content[3].table.body[0][1].text[1].text = ((metaData.customer.name && metaData.customer.name )? metaData.customer.name.toUpperCase() : '') + "\n";
pdfDoc.content[3].table.body[0][1].text[1].text=getCustomerDetails(metaData,'name').toUpperCase()+"\n";pdfDoc.content[3].table.body[0][1].text[3].text=(metaData.customer.GST_number?metaData.customer.GST_number:'')+"\n";pdfDoc.content[3].table.body[0][1].text[5].text=(metaData.customer.localAddress?metaData.customer.localAddress:'')+"\n";// pdfDoc.content[3].table.body[0][1].text[7].text = (metaData.customer.address ? metaData.customer.address : '') + "\n";	
pdfDoc.content[3].table.body[0][1].text[7].text=getCustomerDetails(metaData,'address')+"\n";pdfDoc.content[3].table.body[0][1].text[9].text=getCustomerDetails(metaData,'mobile').toUpperCase()+"\n";// pdfDoc.content[3].table.body[0][1].text[9].text = (metaData.customer.mobile ? metaData.customer.mobile : '') + "\n";
// pdfDoc.content[3].table.body[0][1].text[9].text = (metaData.customer.placeOfSupply ? metaData.customer.placeOfSupply : '') + "\n";
pdfDoc.content[3].table.body[0][1].text[11].text=(metaData.invoiceData.placeOfSupply?metaData.invoiceData.placeOfSupply:'')+"\n";pdfDoc.content[3].table.body[0][1].text[13].text=(metaData.customer.stateCode?metaData.customer.stateCode:'')+"\n";//Invoice Details
date=new Date(metaData.invoiceData.date);paymentDueDate=date.setDate(date.getDate()+(metaData.invoiceData.duration?parseInt(metaData.invoiceData.duration):0));pdfDoc.content[3].table.body[0][2].text[1].text=metaData.invoiceData.invoiceId+"\n";pdfDoc.content[3].table.body[0][2].text[3].text=new Date(metaData.invoiceData.date).toLocaleDateString('en-GB').toString()+"\n";pdfDoc.content[3].table.body[0][2].text[5].text=(metaData.invoiceData.status?metaData.invoiceData.status.toUpperCase():'')+"\n";pdfDoc.content[3].table.body[0][2].text[7].text=new Date(paymentDueDate).toLocaleDateString('en-GB').toString()+"\n";pdfDoc.content[3].table.body[0][2].text[9].text=(metaData.invoiceData.remark?metaData.invoiceData.remark:'')+"\n";// Products
// let productList = convertToPDFProducts(metaData.invoiceData.items,true);
productList=convertToPDFProducts(metaData.invoiceData.items,true,metaData.invoiceData,metaData);productList.map(function(item){pdfDoc.content[5].table.body.push(item);});// Payment Details
// pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text[1].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";
// pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text[3].text = (metaData.invoiceData.transactionType ? metaData.invoiceData.transactionType : '') + "\n";
// Bank Account Details
if(metaData.terms.banks.length){metaData.terms.banks.map(function(bankDetails){pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({text:bankDetails.bankName+" \n",style:'bankDetails'});pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({text:"NAME: "+bankDetails.accountHolderName+"\n",style:'bankDetails'});pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({text:"A/C No: "+bankDetails.accountnumber+"\n",style:'bankDetails'});pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({text:"IFSC: "+bankDetails.ifsccode+"\n",style:'bankDetails'});pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({text:bankDetails.address+"\n",style:'bankDetails'});});}// Terms and cond
pdfDoc.content[6].table.body[0][0][3].table.body[0][1]=metaData.terms.termsAndConditions;// gst details
// pdfDoc.content[6].table.body[0][1].text[1].text = ((metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount ? Number.parseFloat(metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount).toFixed(2) - Number.parseFloat(metaData.gstTotal.CGST_val + metaData.gstTotal.SGST_val + metaData.gstTotal.IGST_val).toFixed(2) : '0')).toFixed(2) + "\n";
pdfDoc.content[6].table.body[0][1].text[1].text=(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalAmount)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.discountAmount||0)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?0:-__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraCharges))-__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraChargesGST):0)-__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.roundOffAmount||0)-(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.SGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.CGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.IGST_val))).toFixed(2)+"\n";pdfDoc.content[6].table.body[0][1].text[3].text=(metaData.gstTotal.CGST_val?(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.CGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraChargesGST)/2:0)).toFixed(2):'0.00')+"\n";pdfDoc.content[6].table.body[0][1].text[5].text=(metaData.gstTotal.SGST_val?(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.SGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraChargesGST)/2:0)).toFixed(2):'0.00')+"\n";pdfDoc.content[6].table.body[0][1].text[7].text=(metaData.gstTotal.IGST_val?(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.IGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraChargesGST):0)).toFixed(2):'0.00')+"\n";// pdfDoc.content[6].table.body[0][1].text[9].text = (metaData.invoiceData.labourAmount ? Number.parseFloat(metaData.invoiceData.labourAmount).toFixed(2) : '0.00') + "\n";
offset=0;if(!metaData.invoiceData.gstOnExtraChanrges&&metaData.invoiceData.extraCharges&&metaData.invoiceData.extraCharges.length){metaData.invoiceData.extraCharges.map(function(charge){pdfDoc.content[6].table.body[0][1].text.splice(8+offset,0,{text:''+charge.name+':        ',bold:true,style:'topHeader'});offset++;pdfDoc.content[6].table.body[0][1].text.splice(8+offset,0,{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(charge.amount).toFixed(2)+'\n',style:'topHeader'});offset++;});}pdfDoc.content[6].table.body[0][1].text[9+offset].text=(metaData.invoiceData.discountAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.discountAmount).toFixed(2):'0.00')+"\n";pdfDoc.content[6].table.body[0][1].text[11+offset].text=(metaData.invoiceData.roundOffAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.roundOffAmount).toFixed(2):'0.00')+"\n";// pdfDoc.content[6].table.body[0][1].text[15].text = (metaData.invoiceData.totalAmount + metaData.invoiceData.labourAmount -  metaData.invoiceData.discountAmount ? Number.parseFloat(Number.parseFloat(metaData.invoiceData.totalAmount) + Number.parseFloat(metaData.invoiceData.labourAmount) - Number.parseFloat(metaData.invoiceData.discountAmount)).toFixed(2) : '0') + "\n";
pdfDoc.content[6].table.body[0][1].text[13+offset].text=(metaData.invoiceData.totalAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalAmount).toFixed(2):'0.00')+"\n";pdfDoc.content[6].table.body[0][1].text[15+offset].text=(metaData.invoiceData.paidAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.paidAmount).toFixed(2):'0.00')+"\n";pdfDoc.content[6].table.body[0][1].text[17+offset].text=(metaData.invoiceData.remainingAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.remainingAmount).toFixed(2):'0.00')+"\n";// pdfDoc.content[6].table.body[0][1].text[17].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";
// if(metaData.invoiceData.extraCharges && metaData.invoiceData.extraCharges.length) {
// 	metaData.invoiceData.extraCharges.map((charge)=>{
// 	pdfDoc.content[6].table.body[0][1].text.push({ text: ''+charge.name+':        ', bold: true, style: 'topHeader' })
// 	pdfDoc.content[6].table.body[0][1].text.push({ text: Number.parseFloat(charge.amount).toFixed(2)+'\n', bold: true, style: 'topHeader' })
// 	})
// }
if(metaData.balance&&metaData.terms.isPreviousCurrentTotalBalance){pdfDoc.content[8].table.body[1][0].text[1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.balance)-__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.remainingAmount).toFixed(2)).toFixed(2)+"\n";pdfDoc.content[8].table.body[1][1].text[1].text=(metaData.invoiceData.remainingAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.remainingAmount).toFixed(2):'0.00')+"\n";pdfDoc.content[8].table.body[1][2].text[1].text=(metaData.balance?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.balance).toFixed(2):'0.00')+"\n";}else{pdfDoc.content[8]={};pdfDoc.content[7]={};}//authority
pdfDoc.content[9].table.body[0][1][1].text=metaData.firm.name?metaData.firm.name.toUpperCase():'';//thank you
// pdfDoc.content[9].table.body[0][0].text =  metaData.terms.termsAndConditions.greetingMessage || ("Thank You " + ((metaData.customer && metaData.customer.name )? metaData.customer.name.toUpperCase() : '') +" For Choosing us!" )
// pdfDoc.content[9].table.body[0][0].text =  "Thank You " + (metaData.customer.name.toUpperCase() ? metaData.customer.name.toUpperCase() : '') +" For Choosing us!" 
pdfDoc.content[10].table.body[0][0].text=metaData.terms.greetingMessage||"Thank You "+getCustomerDetails(metaData,'name').toUpperCase()+" for doing business with us!";if(!metaData.terms.isBlankHeader){_context.next=45;break;}pdfDoc.content[1].table.body[0][1]={text:''};pdfDoc.content[1].style='hiddenTab';pdfDoc.content[1].table.body[0][2].text[1].style='hiddenTab';_context.next=125;break;case 45:if(!metaData.terms.printLogo){_context.next=93;break;}_context.prev=46;_context.next=49;return getBase64ImageFromURL(metaData.terms.printLogo);case 49:logoData=_context.sent;pdfDoc.content[1].table.body[0][1].image=logoData;invoiceImages=document.getElementById('invoiceImages');if(!(invoiceImages&&invoiceImages.files&&invoiceImages.files.length)){_context.next=76;break;}temp={columns:[]};if(!invoiceImages.files[0]){_context.next=61;break;}_context.t0=temp.columns;_context.next=58;return toBase64(invoiceImages.files[0]).catch(function(e){return Error(e);});case 58:_context.t1=_context.sent;_context.t2={image:_context.t1,width:150};_context.t0.push.call(_context.t0,_context.t2);case 61:if(!invoiceImages.files[1]){_context.next=68;break;}_context.t3=temp.columns;_context.next=65;return toBase64(invoiceImages.files[1]).catch(function(e){return Error(e);});case 65:_context.t4=_context.sent;_context.t5={image:_context.t4,width:150};_context.t3.push.call(_context.t3,_context.t5);case 68:if(!invoiceImages.files[2]){_context.next=75;break;}_context.t6=temp.columns;_context.next=72;return toBase64(invoiceImages.files[2]).catch(function(e){return Error(e);});case 72:_context.t7=_context.sent;_context.t8={image:_context.t7,width:150};_context.t6.push.call(_context.t6,_context.t8);case 75:pdfDoc.content.push(temp);case 76:if(!metaData.terms.signature){_context.next=85;break;}_temp={columns:[]};_context.t9=_temp.columns;_context.next=81;return getBase64ImageFromURL(metaData.terms.signature);case 81:_context.t10=_context.sent;_context.t11={image:_context.t10,width:150,height:40,alignment:'right'};_context.t9.push.call(_context.t9,_context.t11);//pdfDoc.content.push(temp)
pdfDoc.content[9].table.body[0][1][2]=_temp.columns[0];case 85:return _context.abrupt("return",pdfDoc);case 88:_context.prev=88;_context.t12=_context["catch"](46);console.log(_context.t12);case 91:_context.next=125;break;case 93:imgToExport=document.getElementById('pdfimgToExport');canvas=document.createElement('canvas');canvas.width=imgToExport.width;canvas.height=imgToExport.height;canvas.getContext('2d').drawImage(imgToExport,0,0);base64=canvas.toDataURL('image/png');pdfDoc.content[1].table.body[0][1].image=base64;_invoiceImages=document.getElementById('invoiceImages');if(!(_invoiceImages&&_invoiceImages.files&&_invoiceImages.files.length)){_context.next=125;break;}_temp2={columns:[]};if(!_invoiceImages.files[0]){_context.next=110;break;}_context.t13=_temp2.columns;_context.next=107;return toBase64(_invoiceImages.files[0]).catch(function(e){return Error(e);});case 107:_context.t14=_context.sent;_context.t15={image:_context.t14,width:150};_context.t13.push.call(_context.t13,_context.t15);case 110:if(!_invoiceImages.files[1]){_context.next=117;break;}_context.t16=_temp2.columns;_context.next=114;return toBase64(_invoiceImages.files[1]).catch(function(e){return Error(e);});case 114:_context.t17=_context.sent;_context.t18={image:_context.t17,width:150};_context.t16.push.call(_context.t16,_context.t18);case 117:if(!_invoiceImages.files[2]){_context.next=124;break;}_context.t19=_temp2.columns;_context.next=121;return toBase64(_invoiceImages.files[2]).catch(function(e){return Error(e);});case 121:_context.t20=_context.sent;_context.t21={image:_context.t20,width:150};_context.t19.push.call(_context.t19,_context.t21);case 124:pdfDoc.content.push(_temp2);case 125:if(!metaData.terms.signature){_context.next=134;break;}_temp3={columns:[]};_context.t22=_temp3.columns;_context.next=130;return getBase64ImageFromURL(metaData.terms.signature);case 130:_context.t23=_context.sent;_context.t24={image:_context.t23,width:150,alignment:'right'};_context.t22.push.call(_context.t22,_context.t24);pdfDoc.content[9].table.body[0][1][2]=_temp3.columns[0];//pdfDoc.content.push(temp)
case 134:return _context.abrupt("return",pdfDoc);case 135:case"end":return _context.stop();}}},_callee,_this,[[46,88]]);}));return function convertToBasicInvoice(_x){return _ref.apply(this,arguments);};}();var toBase64=function toBase64(file){return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function(resolve,reject){var reader=new FileReader();reader.readAsDataURL(file);reader.onload=function(){return resolve(reader.result);};reader.onerror=function(error){return reject(error);};});};// Start of New Photo Resize Format
var convertToBasicShortInvoice=function(){var _ref2=__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(metaData){var pdfDoc,vdate,vpaymentDueDate,date,paymentDueDate,productList,offset,logoData,invoiceImages,temp,_temp4,imgToExport,canvas,base64,_invoiceImages2,_temp5,_temp6;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:pdfDoc={content:[{table:{widths:['*'],body:[[{text:'TRAIL INVOICE',style:"topHeader1"}]]},layout:'noBorders'},{table:{widths:['25%','25%','25%','25%'],body:[[{text:''},{image:'',width:100,height:80},{text:[{text:' ',bold:true,style:'topFirmAuthorityRight'},{text:'\n',style:'topFirmAuthorityRight'},{text:' ',bold:true,style:'topHeaderRight'},{text:'1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n',style:'topHeaderRight'},{text:' ',bold:true,style:'topHeaderRight'},{text:'1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n',style:'topHeaderRight'},{text:'',bold:true,style:'topHeaderRight'},{text:'88776655\n',style:'topHeaderRight'},{text:'',bold:true,style:'topHeaderRight'},//icon gift
{text:'njnjn@jnn.com\n',style:'topHeaderRight'},{text:' ',bold:true,style:'topHeaderRight'},{text:'123456\n',style:'topHeaderRight'}]},{text:[{text:' ',bold:true,style:'topCustomerHeader'},{text:'Google\n',style:'topCustomerHeader'},{text:' ',bold:true,style:'topHeader'},{text:'1679905\n',style:'topHeader'},{text:'  ',bold:true,style:'topHeader'},{text:'7788996655\n',style:'topHeader'},{text:'  ',bold:true,style:'topHeader'},{text:'1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n',style:'topHeader'},{text:'Mobile Number: ',bold:true,style:'topHeader'},{text:'23\n',style:'topHeader'},{text:'Place of supply:   ',bold:true,style:'topHeader'},{text:'13/12/90\n',style:'topHeader'},{text:'State Code:   ',bold:true,style:'topHeader'},{text:'13/12/90\n',style:'topHeader'}]},{text:[{text:'Invoice No:                  ',bold:true,style:'topHeader'},{text:'787878\n',style:'topHeader'},{text:'Invoice Date:               ',bold:true,style:'topHeader'},{text:'12/12/90 \n',style:'topHeader'},{text:'Invoice Status:            ',bold:true,style:'topHeader'},{text:'12/12/90 \n',style:'topRemainingHeader'},{text:'Payment Due Date:    ',bold:true,style:'topHeader'},{text:'13/12/90\n',style:'topHeader'}]}]]},layout:'noBorders',style:"topTab"},{table:{widths:['0%','65%','*'],body:[[{text:'',style:"billToHeader"},{text:'BILL TO',style:"billToHeader"},{text:'INVOICE DETAILS',style:"invoiceDetailHeader"}]]},style:'tab2Head',layout:'noBorders'},{table:{widths:['0%','65%','*'],body:[[{text:''},{text:[{text:' ',bold:true,style:'topCustomerHeader'},{text:'Google\n',style:'topCustomerHeader'},{text:' ',bold:true,style:'topHeader'},{text:'1679905\n',style:'topHeader'},{text:'  ',bold:true,style:'topHeader'},{text:'7788996655\n',style:'topHeader'},{text:'  ',bold:true,style:'topHeader'},{text:'1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n',style:'topHeader'},{text:'Mobile Number: ',bold:true,style:'topHeader'},{text:'23\n',style:'topHeader'},{text:'Place of supply:   ',bold:true,style:'topHeader'},{text:'13/12/90\n',style:'topHeader'},{text:'State Code:   ',bold:true,style:'topHeader'},{text:'13/12/90\n',style:'topHeader'}]},{text:[{text:'Invoice No:                  ',bold:true,style:'topHeader'},{text:'787878\n',style:'topHeader'},{text:'Invoice Date:               ',bold:true,style:'topHeader'},{text:'12/12/90 \n',style:'topHeader'},{text:'Invoice Status:            ',bold:true,style:'topHeader'},{text:'12/12/90 \n',style:'topRemainingHeader'},{text:'Payment Due Date:    ',bold:true,style:'topHeader'},{text:'13/12/90\n',style:'topHeader'}]}]]},style:'tab2',layout:'noBorders'},{table:{widths:['*','*'],body:[[{text:'PRODUCT DETAILS',style:"emptyHeader"},{text:'',style:"emptyHeader"}]]},layout:'noBorders'},{table:{body:[[{text:'S.No',style:"productHeader",rowSpan:2},{text:'Product Name',style:"productHeader",rowSpan:2},{text:'HSN code',style:"productHeader",rowSpan:2},{text:'Qty',style:"productHeader",rowSpan:2},{text:'Units',style:"productHeader",rowSpan:2},{text:'Unit Price',style:"productHeader",rowSpan:2},{text:'Taxable  Amount',style:"productHeader",rowSpan:2},{text:'CGST',style:"productHeader",colSpan:2,rowSpan:1},{text:'',style:"productHeader"},{text:'SGST',style:"productHeader",colSpan:2,rowSpan:1},{text:'',style:"productHeader"},{text:'IGST',style:"productHeader",colSpan:2,rowSpan:1},{text:'',style:"productHeader"},{text:'Total Amount',style:"productHeader",rowSpan:2}],[{text:'S.No',style:"productHeader"},{text:'Product Name',style:"productHeader"},{text:'HSN code',style:"productHeader"},{text:'Qty',style:"productHeader"},{text:'Units',style:"productHeader"},{text:'Rate',style:"productHeader"},{text:'Taxable Amount',style:"productHeader"},{text:'%',style:"productHeader"},{text:'₹',style:"productHeader"},{text:'%',style:"productHeader"},{text:'₹',style:"productHeader"},{text:'%',style:"productHeader"},{text:'₹',style:"productHeader"},{text:'Total Amount',style:"productHeader"}]]}},{table:{widths:['70%','*'],body:[[[{table:{widths:['*'],body:[[{text:'PAYMENT DETAILS',style:"leftHeader"}]]},style:'tab2Head',layout:'noBorders'},{table:{widths:['3%','*'],body:[[{text:''},{text:[]}]]},style:'tab2',layout:'noBorders'},{table:{widths:['*'],body:[[{text:'TERMS & CONDITIONS',style:"leftHeader"}]]},style:'tab2Head',layout:'noBorders'},{table:{widths:['3%','*'],body:[[{text:''},{text:""}]]},style:'tab2',layout:'noBorders'}],{text:[{text:'Taxable Amount:     ',bold:true,style:'topHeader'},{text:'12122\n',style:'topHeader'},{text:'CGST Amount:         ',bold:true,style:'topHeader'},{text:'12122\n',style:'topHeader'},{text:'SGST Amount:         ',bold:true,style:'topHeader'},{text:'12122\n',style:'topHeader'},{text:'IGST Amount:          ',bold:true,style:'topHeader'},{text:'12122\n',style:'topHeader'},// { text: 'Labour Charge:       ', bold: true, style: 'topHeader' },
// { text: '12122\n', style: 'topHeader' },
{text:'Discount:                  ',bold:true,style:'topHeader'},{text:'12122\n',style:'topHeader'},{text:'RoundOff:                 ',bold:true,style:'topHeader'},{text:'12122\n',style:'topHeader'},{text:'Total Amount:          ',bold:true,style:'topHeader11'},{text:'12122\n',style:'topHeader11'},{text:'Paid Amount:           ',bold:true,style:'topHeader'},{text:'12122\n',style:'topHeader'},{text:'Due Amount:            ',bold:true,style:'topRemainingHeader'},{text:'12122\n',style:'topRemainingHeader'}]}]]},style:'tab2',layout:'lightHorizontalLines'},{table:{widths:['*','*'],body:[[{text:'OUTSTANDING DETAILS',style:"emptyHeader"},{text:'',style:"emptyHeader"}]]},layout:'noBorders'},// Start of Previous + current = Total Column
{table:{widths:['34%','39%','27%'],body:[[{text:'',style:"topBlankHeader"},{text:'',style:"topMainHeader"},{text:'',style:"topBlankHeader"}],[{text:[{text:'PREVIOUS BALANCE :  ',bold:true,style:'topHeader11'},{text:'\n',style:'topHeader11'}]},{text:[{text:'CURRENT BALANCE :  ',bold:true,style:'topHeader11'},{text:'\n',style:'topHeader11'}]},{text:[{text:'TOTAL BALANCE :  ',bold:true,style:'topRemainingHeader'},{text:'\n',style:'topRemainingHeader'}]}]]},layout:{hLineWidth:function hLineWidth(i,node){return i===0||i===node.table.body.length?1:0;},vLineWidth:function vLineWidth(i,node){return i===0||i===node.table.widths.length?1:0;},hLineColor:function hLineColor(i,node){return i===0||i===node.table.body.length?'black':'black';},vLineColor:function vLineColor(i,node){return i===0||i===node.table.widths.length?'black':'black';}}},// End of Previous + current = Total Column
{table:{widths:['60%','*'],body:[[{text:[]},[{text:''},{text:'Firm Name  ',bold:true,alignment:'center',style:'topFirmBasicAuthority'},{text:'\n\n\n'},{text:'AUTHORITY SIGNATURE  ',bold:true,alignment:'center',style:'topFirmBasicAuthority'},{text:'\n'}]]]},style:'tab2',layout:'noBorders'},{table:{widths:['*'],body:[[{text:'Thank you',alignment:'center'}]]},layout:'noBorders',style:'tab2'}],footer:{columns:[{text:'Powered By ACUIFY',alignment:'right',color:'#160091'}],margin:[10,10]},styles:{header:{fontSize:10,bold:true,alignment:'center'},billToHeader:{fontSize:12,bold:true,alignment:'left'},invoiceDetailHeader:{fontSize:12,bold:true,alignment:'left'},header1:{color:'#160091',fontSize:10,bold:true,fillColor:'#15155d'},product:{fontSize:9,alignment:'center'},productRight:{fontSize:10,alignment:'right'// bold: true
},totalRight:{fontSize:10,alignment:'right',bold:true},total:{fontSize:10,alignment:'center',bold:true},topHeader:{fontSize:10,bold:true,fillColor:'#15155d'},topHeaderRight:{fontSize:10,bold:true,fillColor:'#15155d',alignment:'right'},topCustomerHeader:{fontSize:12,bold:true,color:'#160091'},topHeader1:{color:'white',fontSize:14,bold:true,alignment:'center',fillColor:'#15155d'},topHeader11:{color:'#160091',fontSize:10,bold:true},topRemainingHeader:{color:'#FF0000',fontSize:10,bold:true},topFirmAuthority:{color:'#160091',fontSize:12,bold:true},topFirmAuthorityRight:{color:'#160091',fontSize:14,bold:true,alignment:'right'},topFirmBasicAuthority:{color:'#160091',fontSize:10,bold:true},leftHeader:{fontSize:10,bold:true,alignment:'left'},emptyHeader:{fontSize:10,color:'white',fillColor:'#15155d',bold:true},topTab:{fillColor:'#ececec'},tab2Head:{color:'white',fillColor:'#015155d'},tab2:{fillColor:'#ececec'},bankDetails:{fontSize:10,bold:true},productHeader:{fontSize:10,bold:true,alignment:'center',color:'#160091'},hiddenTab:{fillColor:'#ececec',color:'#ececec'}}//Firm Details 
// pdfDoc.content[1].table.body[0][2].text[1].text = (metaData.firm.name.toUpperCase() ? metaData.firm.name.toUpperCase() : '') + "\n";
};pdfDoc.content[1].table.body[0][2].text[1].text=(metaData.firm&&metaData.firm.name?metaData.firm.name.toUpperCase():'')+"\n";pdfDoc.content[1].table.body[0][2].text[3].text=(metaData.firm.GST_number?metaData.firm.GST_number:'')+"\n";pdfDoc.content[1].table.body[0][2].text[5].text=(metaData.firm.liveAddress?metaData.firm.liveAddress:'')+"\n";pdfDoc.content[1].table.body[0][2].text[7].text=(metaData.firm.address?metaData.firm.address:'')+"\n";pdfDoc.content[1].table.body[0][2].text[9].text=(metaData.firm.mobileNumber?metaData.firm.mobileNumber:'')+"\n";pdfDoc.content[1].table.body[0][2].text[11].text=(metaData.firm.email?metaData.firm.email:'')+"\n";// Start of Trail New Code
//Receipient Details
// pdfDoc.content[3].table.body[0][1].text[1].text = (metaData.customer.name.toUpperCase() ? metaData.customer.name.toUpperCase() : '') + "\n";
// pdfDoc.content[3].table.body[0][1].text[1].text = ((metaData.customer.name && metaData.customer.name )? metaData.customer.name.toUpperCase() : '') + "\n";
pdfDoc.content[1].table.body[0][3].text[1].text=getCustomerDetails(metaData,'name').toUpperCase()+"\n";pdfDoc.content[1].table.body[0][3].text[3].text=(metaData.customer.GST_number?metaData.customer.GST_number:'')+"\n";pdfDoc.content[1].table.body[0][3].text[5].text=(metaData.customer.localAddress?metaData.customer.localAddress:'')+"\n";// pdfDoc.content[3].table.body[0][1].text[7].text = (metaData.customer.address ? metaData.customer.address : '') + "\n";	
pdfDoc.content[1].table.body[0][3].text[7].text=getCustomerDetails(metaData,'address')+"\n";pdfDoc.content[1].table.body[0][3].text[9].text=getCustomerDetails(metaData,'mobile').toUpperCase()+"\n";// pdfDoc.content[3].table.body[0][1].text[9].text = (metaData.customer.mobile ? metaData.customer.mobile : '') + "\n";
// pdfDoc.content[3].table.body[0][1].text[9].text = (metaData.customer.placeOfSupply ? metaData.customer.placeOfSupply : '') + "\n";
pdfDoc.content[1].table.body[0][3].text[11].text=(metaData.invoiceData.placeOfSupply?metaData.invoiceData.placeOfSupply:'')+"\n";pdfDoc.content[1].table.body[0][3].text[13].text=(metaData.customer.stateCode?metaData.customer.stateCode:'')+"\n";//Invoice Details
vdate=new Date(metaData.invoiceData.date);vpaymentDueDate=vdate.setDate(vdate.getDate()+(metaData.invoiceData.duration?parseInt(metaData.invoiceData.duration):0));pdfDoc.content[1].table.body[0][4].text[1].text=metaData.invoiceData.invoiceId+"\n";pdfDoc.content[1].table.body[0][4].text[3].text=new Date(metaData.invoiceData.date).toLocaleDateString('en-GB').toString()+"\n";pdfDoc.content[1].table.body[0][4].text[5].text=(metaData.invoiceData.status?metaData.invoiceData.status.toUpperCase():'')+"\n";pdfDoc.content[1].table.body[0][4].text[7].text=new Date(vpaymentDueDate).toLocaleDateString('en-GB').toString()+"\n";// End of Trail New Code
//Receipient Details
// pdfDoc.content[3].table.body[0][1].text[1].text = (metaData.customer.name.toUpperCase() ? metaData.customer.name.toUpperCase() : '') + "\n";
// pdfDoc.content[3].table.body[0][1].text[1].text = ((metaData.customer.name && metaData.customer.name )? metaData.customer.name.toUpperCase() : '') + "\n";
pdfDoc.content[3].table.body[0][1].text[1].text=getCustomerDetails(metaData,'name').toUpperCase()+"\n";pdfDoc.content[3].table.body[0][1].text[3].text=(metaData.customer.GST_number?metaData.customer.GST_number:'')+"\n";pdfDoc.content[3].table.body[0][1].text[5].text=(metaData.customer.localAddress?metaData.customer.localAddress:'')+"\n";// pdfDoc.content[3].table.body[0][1].text[7].text = (metaData.customer.address ? metaData.customer.address : '') + "\n";	
pdfDoc.content[3].table.body[0][1].text[7].text=getCustomerDetails(metaData,'address')+"\n";pdfDoc.content[3].table.body[0][1].text[9].text=getCustomerDetails(metaData,'mobile').toUpperCase()+"\n";// pdfDoc.content[3].table.body[0][1].text[9].text = (metaData.customer.mobile ? metaData.customer.mobile : '') + "\n";
// pdfDoc.content[3].table.body[0][1].text[9].text = (metaData.customer.placeOfSupply ? metaData.customer.placeOfSupply : '') + "\n";
pdfDoc.content[3].table.body[0][1].text[11].text=(metaData.invoiceData.placeOfSupply?metaData.invoiceData.placeOfSupply:'')+"\n";pdfDoc.content[3].table.body[0][1].text[13].text=(metaData.customer.stateCode?metaData.customer.stateCode:'')+"\n";//Invoice Details
date=new Date(metaData.invoiceData.date);paymentDueDate=date.setDate(date.getDate()+(metaData.invoiceData.duration?parseInt(metaData.invoiceData.duration):0));pdfDoc.content[3].table.body[0][2].text[1].text=metaData.invoiceData.invoiceId+"\n";pdfDoc.content[3].table.body[0][2].text[3].text=new Date(metaData.invoiceData.date).toLocaleDateString('en-GB').toString()+"\n";pdfDoc.content[3].table.body[0][2].text[5].text=(metaData.invoiceData.status?metaData.invoiceData.status.toUpperCase():'')+"\n";pdfDoc.content[3].table.body[0][2].text[7].text=new Date(paymentDueDate).toLocaleDateString('en-GB').toString()+"\n";// Products
// let productList = convertToPDFProducts(metaData.invoiceData.items,true);
productList=convertToPDFProducts(metaData.invoiceData.items,true,metaData.invoiceData,metaData);productList.map(function(item){pdfDoc.content[5].table.body.push(item);});// Payment Details
// pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text[1].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";
// pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text[3].text = (metaData.invoiceData.transactionType ? metaData.invoiceData.transactionType : '') + "\n";
// Bank Account Details
if(metaData.terms.banks.length){metaData.terms.banks.map(function(bankDetails){pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({text:bankDetails.bankName+" \n",style:'bankDetails'});pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({text:"NAME: "+bankDetails.accountHolderName+"\n",style:'bankDetails'});pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({text:"A/C No: "+bankDetails.accountnumber+"\n",style:'bankDetails'});pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({text:"IFSC: "+bankDetails.ifsccode+"\n",style:'bankDetails'});pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({text:bankDetails.address+"\n",style:'bankDetails'});});}// Terms and cond
pdfDoc.content[6].table.body[0][0][3].table.body[0][1]=metaData.terms.termsAndConditions;// gst details
// pdfDoc.content[6].table.body[0][1].text[1].text = ((metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount ? Number.parseFloat(metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount).toFixed(2) - Number.parseFloat(metaData.gstTotal.CGST_val + metaData.gstTotal.SGST_val + metaData.gstTotal.IGST_val).toFixed(2) : '0')).toFixed(2) + "\n";
pdfDoc.content[6].table.body[0][1].text[1].text=(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalAmount)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.discountAmount||0)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?0:-__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraCharges))-__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraChargesGST):0)-__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.roundOffAmount||0)-(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.SGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.CGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.IGST_val))).toFixed(2)+"\n";pdfDoc.content[6].table.body[0][1].text[3].text=(metaData.gstTotal.CGST_val?(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.CGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraChargesGST)/2:0)).toFixed(2):'0.00')+"\n";pdfDoc.content[6].table.body[0][1].text[5].text=(metaData.gstTotal.SGST_val?(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.SGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraChargesGST)/2:0)).toFixed(2):'0.00')+"\n";pdfDoc.content[6].table.body[0][1].text[7].text=(metaData.gstTotal.IGST_val?(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.IGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraChargesGST):0)).toFixed(2):'0.00')+"\n";// pdfDoc.content[6].table.body[0][1].text[9].text = (metaData.invoiceData.labourAmount ? Number.parseFloat(metaData.invoiceData.labourAmount).toFixed(2) : '0.00') + "\n";
offset=0;if(!metaData.invoiceData.gstOnExtraChanrges&&metaData.invoiceData.extraCharges&&metaData.invoiceData.extraCharges.length){metaData.invoiceData.extraCharges.map(function(charge){pdfDoc.content[6].table.body[0][1].text.splice(8+offset,0,{text:''+charge.name+':        ',bold:true,style:'topHeader'});offset++;pdfDoc.content[6].table.body[0][1].text.splice(8+offset,0,{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(charge.amount).toFixed(2)+'\n',style:'topHeader'});offset++;});}pdfDoc.content[6].table.body[0][1].text[9+offset].text=(metaData.invoiceData.discountAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.discountAmount).toFixed(2):'0.00')+"\n";pdfDoc.content[6].table.body[0][1].text[11+offset].text=(metaData.invoiceData.roundOffAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.roundOffAmount).toFixed(2):'0.00')+"\n";// pdfDoc.content[6].table.body[0][1].text[15].text = (metaData.invoiceData.totalAmount + metaData.invoiceData.labourAmount -  metaData.invoiceData.discountAmount ? Number.parseFloat(Number.parseFloat(metaData.invoiceData.totalAmount) + Number.parseFloat(metaData.invoiceData.labourAmount) - Number.parseFloat(metaData.invoiceData.discountAmount)).toFixed(2) : '0') + "\n";
pdfDoc.content[6].table.body[0][1].text[13+offset].text=(metaData.invoiceData.totalAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalAmount).toFixed(2):'0.00')+"\n";pdfDoc.content[6].table.body[0][1].text[15+offset].text=(metaData.invoiceData.paidAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.paidAmount).toFixed(2):'0.00')+"\n";pdfDoc.content[6].table.body[0][1].text[17+offset].text=(metaData.invoiceData.remainingAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.remainingAmount).toFixed(2):'0.00')+"\n";// pdfDoc.content[6].table.body[0][1].text[17].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";
// if(metaData.invoiceData.extraCharges && metaData.invoiceData.extraCharges.length) {
// 	metaData.invoiceData.extraCharges.map((charge)=>{
// 	pdfDoc.content[6].table.body[0][1].text.push({ text: ''+charge.name+':        ', bold: true, style: 'topHeader' })
// 	pdfDoc.content[6].table.body[0][1].text.push({ text: Number.parseFloat(charge.amount).toFixed(2)+'\n', bold: true, style: 'topHeader' })
// 	})
// }
if(metaData.balance&&metaData.terms.isPreviousCurrentTotalBalance){pdfDoc.content[8].table.body[1][0].text[1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.balance)-__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.remainingAmount).toFixed(2)).toFixed(2)+"\n";pdfDoc.content[8].table.body[1][1].text[1].text=(metaData.invoiceData.remainingAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.remainingAmount).toFixed(2):'0.00')+"\n";pdfDoc.content[8].table.body[1][2].text[1].text=(metaData.balance?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.balance).toFixed(2):'0.00')+"\n";}else{pdfDoc.content[8]={};pdfDoc.content[7]={};}//authority
pdfDoc.content[9].table.body[0][1][1].text=metaData.firm.name?metaData.firm.name.toUpperCase():'';//thank you
// pdfDoc.content[9].table.body[0][0].text =  metaData.terms.termsAndConditions.greetingMessage || ("Thank You " + ((metaData.customer && metaData.customer.name )? metaData.customer.name.toUpperCase() : '') +" For Choosing us!" )
// pdfDoc.content[9].table.body[0][0].text =  "Thank You " + (metaData.customer.name.toUpperCase() ? metaData.customer.name.toUpperCase() : '') +" For Choosing us!" 
pdfDoc.content[10].table.body[0][0].text=metaData.terms.greetingMessage||"Thank You "+getCustomerDetails(metaData,'name').toUpperCase()+" for doing business with us!";if(!metaData.terms.isBlankHeader){_context2.next=57;break;}pdfDoc.content[1].table.body[0][1]={text:''};pdfDoc.content[1].style='hiddenTab';pdfDoc.content[1].table.body[0][2].text[1].style='hiddenTab';_context2.next=137;break;case 57:if(!metaData.terms.printLogo){_context2.next=105;break;}_context2.prev=58;_context2.next=61;return getBase64ImageFromURL(metaData.terms.printLogo);case 61:logoData=_context2.sent;pdfDoc.content[1].table.body[0][1].image=logoData;invoiceImages=document.getElementById('invoiceImages');if(!(invoiceImages&&invoiceImages.files&&invoiceImages.files.length)){_context2.next=88;break;}temp={columns:[]};if(!invoiceImages.files[0]){_context2.next=73;break;}_context2.t0=temp.columns;_context2.next=70;return toBase64(invoiceImages.files[0]).catch(function(e){return Error(e);});case 70:_context2.t1=_context2.sent;_context2.t2={image:_context2.t1,width:150};_context2.t0.push.call(_context2.t0,_context2.t2);case 73:if(!invoiceImages.files[1]){_context2.next=80;break;}_context2.t3=temp.columns;_context2.next=77;return toBase64(invoiceImages.files[1]).catch(function(e){return Error(e);});case 77:_context2.t4=_context2.sent;_context2.t5={image:_context2.t4,width:150};_context2.t3.push.call(_context2.t3,_context2.t5);case 80:if(!invoiceImages.files[2]){_context2.next=87;break;}_context2.t6=temp.columns;_context2.next=84;return toBase64(invoiceImages.files[2]).catch(function(e){return Error(e);});case 84:_context2.t7=_context2.sent;_context2.t8={image:_context2.t7,width:150};_context2.t6.push.call(_context2.t6,_context2.t8);case 87:pdfDoc.content.push(temp);case 88:if(!metaData.terms.signature){_context2.next=97;break;}_temp4={columns:[]};_context2.t9=_temp4.columns;_context2.next=93;return getBase64ImageFromURL(metaData.terms.signature);case 93:_context2.t10=_context2.sent;_context2.t11={image:_context2.t10,width:150,alignment:'right'};_context2.t9.push.call(_context2.t9,_context2.t11);//pdfDoc.content.push(temp)
pdfDoc.content[9].table.body[0][1][2]=_temp4.columns[0];case 97:return _context2.abrupt("return",pdfDoc);case 100:_context2.prev=100;_context2.t12=_context2["catch"](58);console.log(_context2.t12);case 103:_context2.next=137;break;case 105:imgToExport=document.getElementById('pdfimgToExport');canvas=document.createElement('canvas');canvas.width=imgToExport.width;canvas.height=imgToExport.height;canvas.getContext('2d').drawImage(imgToExport,0,0);base64=canvas.toDataURL('image/png');pdfDoc.content[1].table.body[0][1].image=base64;_invoiceImages2=document.getElementById('invoiceImages');if(!(_invoiceImages2&&_invoiceImages2.files&&_invoiceImages2.files.length)){_context2.next=137;break;}_temp5={columns:[]};if(!_invoiceImages2.files[0]){_context2.next=122;break;}_context2.t13=_temp5.columns;_context2.next=119;return toBase64(_invoiceImages2.files[0]).catch(function(e){return Error(e);});case 119:_context2.t14=_context2.sent;_context2.t15={image:_context2.t14,width:150};_context2.t13.push.call(_context2.t13,_context2.t15);case 122:if(!_invoiceImages2.files[1]){_context2.next=129;break;}_context2.t16=_temp5.columns;_context2.next=126;return toBase64(_invoiceImages2.files[1]).catch(function(e){return Error(e);});case 126:_context2.t17=_context2.sent;_context2.t18={image:_context2.t17,width:150};_context2.t16.push.call(_context2.t16,_context2.t18);case 129:if(!_invoiceImages2.files[2]){_context2.next=136;break;}_context2.t19=_temp5.columns;_context2.next=133;return toBase64(_invoiceImages2.files[2]).catch(function(e){return Error(e);});case 133:_context2.t20=_context2.sent;_context2.t21={image:_context2.t20,width:150};_context2.t19.push.call(_context2.t19,_context2.t21);case 136:pdfDoc.content.push(_temp5);case 137:if(!metaData.terms.signature){_context2.next=146;break;}_temp6={columns:[]};_context2.t22=_temp6.columns;_context2.next=142;return getBase64ImageFromURL(metaData.terms.signature);case 142:_context2.t23=_context2.sent;_context2.t24={image:_context2.t23,width:150,alignment:'right'};_context2.t22.push.call(_context2.t22,_context2.t24);pdfDoc.content[9].table.body[0][1][2]=_temp6.columns[0];//pdfDoc.content.push(temp)
case 146:return _context2.abrupt("return",pdfDoc);case 147:case"end":return _context2.stop();}}},_callee2,_this,[[58,100]]);}));return function convertToBasicShortInvoice(_x2){return _ref2.apply(this,arguments);};}();// export const toBase64 = file => new Promise((resolve, reject) => {
// 	const reader = new FileReader();
// 	reader.readAsDataURL(file);
// 	reader.onload = () => resolve(reader.result);
// 	reader.onerror = error => reject(error);
// });
// End of New Photo Resize Format 
var convertToBasicInvoiceHorizontal=function(){var _ref3=__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(metaData){var pdfDoc,date,paymentDueDate,productList,gstObj,offset,imgToExport,canvas,invoiceImages,temp,_temp7,_invoiceImages3,_temp8,_temp9;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:pdfDoc={pageOrientation:'landscape',content:[{table:{widths:['44%','45%','11%'],body:[[{//   image: '',
//   width: 120,
//   height: 65,
},{text:[{text:'TAX INVOICE',style:'topHeaderHead'}]},//   {
// 	  text:
// 		  [
// 			  { text: 'ADDRESS\n' ,style:'topHeader'},
// 			  { text: 'address\n', style:'topHeader22' },
// 		  ]
//   },
{text:[//   { text: '' ,style:'topHeader22'},
//   { text: 'mobile\n', style:'topHeader22' },
//   { text: 'email\n', style:'topHeader22'},
//   { text: 'website\n', style:'topHeader22'},									  
]}]]},layout:{hLineWidth:function hLineWidth(i,node){return i===0||i===node.table.body.length?2:0;},vLineWidth:function vLineWidth(i,node){return i===0||i===node.table.widths.length?2:0;},hLineColor:function hLineColor(i,node){return i===0||i===node.table.body.length?'black':'white';},vLineColor:function vLineColor(i,node){return i===0||i===node.table.widths.length?'black':'white';}}},{table:{widths:['*','*','*','*','*'],body:[[{text:'FROM',style:"topHeader"},{text:'BILL TO',style:"topHeader"},{text:'SHIP TO',style:"topHeader"},{text:'INVOICE DETAILS',style:"topHeader"},{text:'OTHER DETAILS',style:"topHeader"}],[{text:[{text:' ',bold:true,style:'topCustomerHeader'},{text:'Google\n',style:'topCustomerHeader'},{text:' ',bold:true,style:'topHeader22'},{text:'1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n',style:'topHeader22'},{text:' ',bold:true,style:'topHeader22'},{text:'7788996655\n',style:'topHeader22'},{text:' ',bold:true,style:'topHeader22'},{text:'7788996655\n',style:'topHeader22'},{text:' ',bold:true,style:'topHeader22'},{text:'1679905\n',style:'topHeader22'},{text:' ',bold:true,style:'topHeader22'},{text:'23\n',style:'topHeader22'}]},// End of NEw of Development
{text:[{text:' ',bold:true,style:'topCustomerHeader'},{text:'Google\n',style:'topCustomerHeader'},{text:' ',bold:true,style:'topHeader22'},{text:'1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n',style:'topHeader22'},{text:' ',bold:true,style:'topHeader22'},{text:'7788996655\n',style:'topHeader22'},{text:' ',bold:true,style:'topHeader22'},{text:'7788996655\n',style:'topHeader22'},{text:' ',bold:true,style:'topHeader22'},{text:'1679905\n',style:'topHeader22'},{text:' ',bold:true,style:'topHeader22'},{text:'23\n',style:'topHeader22'}]},{text:[{text:' ',bold:true,style:'topCustomerHeader'},{text:'Google\n',style:'topCustomerHeader'},{text:' ',bold:true,style:'topHeader22'},{text:'1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n',style:'topHeader22'},{text:' ',bold:true,style:'topHeader22'},{text:'7788996655\n',style:'topHeader22'},{text:' ',bold:true,style:'topHeader22'},{text:'7788996655\n',style:'topHeader22'},{text:' ',bold:true,style:'topHeader22'},{text:'1679905\n',style:'topHeader22'},{text:' ',bold:true,style:'topHeader22'},{text:'23\n',style:'topHeader22'}]},{text:[{text:'Invoice No    :  ',bold:true,style:'topHeader22'},{text:'787878\n',style:'topHeader22'},{text:'Invoice Date :  ',bold:true,style:'topHeader22'},{text:'12/12/90 \n',style:'topHeader22'},{text:'Status            :  ',bold:true,style:'topHeader22'},{text:'12/12/90 \n',style:'topRemainingHeader'},{text:'Due Date       :   ',bold:true,style:'topHeader22'},{text:'13/12/90 \n',style:'topHeader22'}]},{text:[{text:'Order No           :  	',bold:true,style:'topHeader22'},{text:'787878\n',style:'topHeader22'},{text:'Order Date        :      ',bold:true,style:'topHeader22'},{text:'12/12/90 \n',style:'topHeader22'},{text:'Application No :      ',bold:true,style:'topHeader22'},{text:'12/12/90 \n',style:'topHeader22'},{text:'Sanction Date   :      ',bold:true,style:'topHeader22'},{text:'13/12/90\n',style:'topHeader22'}]}]]}},{table:{body:[[{text:'S.No',style:"productHeader",rowSpan:2},{text:'Product Description',style:"productHeader",rowSpan:2},{text:'HSN',style:"productHeader",rowSpan:2},{text:'Qty',style:"productHeader",rowSpan:2},{text:'Units',style:"productHeader",rowSpan:2},{text:'Unit Price',style:"productHeader",rowSpan:2},{text:'Gross weight',style:"productHeader",rowSpan:2},{text:'Net weight',style:"productHeader",rowSpan:2},{text:'Purity',style:"productHeader",rowSpan:2},{text:'Taxable  Amount',style:"productHeader",rowSpan:2},{text:'CGST',style:"productHeader",colSpan:2,rowSpan:1},{text:'',style:"productHeader"},{text:'SGST',style:"productHeader",colSpan:2,rowSpan:1},{text:'',style:"productHeader"},{text:'IGST',style:"productHeader",colSpan:2,rowSpan:1},{text:'',style:"productHeader"},{text:'Total Amount',style:"productHeader",rowSpan:2}],[{text:'S.No',style:"productHeader"},{text:'Product Description',style:"productHeader"},{text:'HSN',style:"productHeader"},{text:'Qty',style:"productHeader"},{text:'Units',style:"productHeader"},{text:'Unit Price',style:"productHeader"},{text:'Gross weight',style:"productHeader"},{text:'Net weight',style:"productHeader"},{text:'Purity',style:"productHeader"},{text:'Taxable Amount',style:"productHeader"},{text:'%',style:"productHeader"},{text:'₹',style:"productHeader"},{text:'%',style:"productHeader"},{text:'₹',style:"productHeader"},{text:'%',style:"productHeader"},{text:'₹',style:"productHeader"},{text:'Total Amount',style:"productHeader"}]]}},{table:{widths:['75%','*'],body:[[[{table:{body:[[{text:'HSN SUMMARY',style:"gstHeader",colSpan:10},{text:'QUANTITY',style:"gstHeader"},{text:'TAXABLE AMOUNT',style:"gstHeader"},{text:'%',style:"gstHeader"},{text:'AMOUNT',style:"gstHeader"},{text:'%',style:"gstHeader"},{text:'AMOUNT',style:"gstHeader"},{text:'%',style:"gstHeader"},{text:'AMOUNT',style:"gstHeader"},{text:'TOTAL TAX AMOUNT',style:"gstHeader"}],[{text:'HSN/SAC',style:"gstHeader",rowSpan:2},{text:'QUANTITY',style:"gstHeader",rowSpan:2},{text:'TAXABLE AMOUNT',style:"gstHeader",rowSpan:2},{text:'CGST',style:"gstHeader",colSpan:2,rowSpan:1},{text:'',style:"gstHeader",rowSpan:2},{text:'SGST',style:"gstHeader",colSpan:2,rowSpan:1},{text:'',style:"gstHeader",rowSpan:2},{text:'IGST',style:"gstHeader",colSpan:2,rowSpan:1},{text:'',style:"gstHeader",rowSpan:2},{text:'TOTAL TAX AMOUNT',style:"gstHeader",rowSpan:2}],[{text:'HSN/SAC',style:"gstHeader"},{text:'QUANTITY',style:"gstHeader"},{text:'TAXABLE AMOUNT',style:"gstHeader"},{text:'%',style:"gstHeader"},{text:'AMOUNT',style:"gstHeader"},{text:'%',style:"gstHeader"},{text:'AMOUNT',style:"gstHeader"},{text:'%',style:"gstHeader"},{text:'AMOUNT',style:"gstHeader"},{text:'TAX AMOUNT',style:"gstHeader"}]]}},{table:{widths:['30%','40%','30%'],body:[[[{text:'PAYMENT DETAILS',style:"topHeader"}],[{text:'TERMS & CONDITIONS',style:"topHeader"}],[{text:'AUTHORITY SIGNATURE',style:"topHeader"}]]]},style:'tab2Head'},{table:{widths:['30%','40%','30%'],body:[[[],[{text:""}],// {
// 	text:
[{text:''},{text:'Firm Name  ',bold:true,alignment:'center',style:'topFirmAuthority'},{text:'\n\n\n\n'},{text:'AUTHORITY SIGNATURE  ',bold:true,alignment:'center',style:'topFirmAuthority'},{text:'\n'}]// },
]]},style:'tab2'}],{text:[{text:'Taxable Amount:       ',bold:true,style:'topHeader33'},{text:'12122\n',style:'topHeader33'},{text:'CGST Amount:           ',bold:true,style:'topHeader33'},{text:'12122\n',style:'topHeader33'},{text:'SGST Amount:           ',bold:true,style:'topHeader33'},{text:'12122\n',style:'topHeader33'},{text:'IGST Amount:            ',bold:true,style:'topHeader33'},{text:'12122\n',style:'topHeader33'},//   { text: 'Extra Charge:             ', bold: true, style:'topHeader33' },
//   { text: '12122\n', style:'topHeader33' },
{text:'Discount:                    ',bold:true,style:'topHeader33'},{text:'12122\n',style:'topHeader33'},{text:'RoundOff:                   ',bold:true,style:'topHeader33'},{text:'12122\n',style:'topHeader33'},{text:'Total Amount:            ',style:'topHeader11'},{text:'12122\n',style:'topHeader11'},{text:'Paid Amount:             ',bold:true,style:'topHeader33'},{text:'12122\n',style:'topHeader33'},{text:'Due Amount:              ',bold:true,style:'topRemainingHeader'},{text:'12122\n',style:'topRemainingHeader'}]}]]}//style:'tab2', pageBreak: 'after'
},{table:{widths:['15%','60%','25%'],body:[[{// image: '',
// width: 110,
// height: 70,
},{text:[// { text: '' ,style:'topHeader'},
// { text: 'For More Information, Visit\n', style: 'topLeftHeader'},
// { text: 'https://info.parvsacuify.com\n' },
// { text: 'https://parvsacuify.com\n' },
// { text: '+91 6232623333\n'},
// { text: 'careacuify@gmail.com \n' },
]},{text:[//   { text: '' },
//   { text: 'Firm Name  ', bold: true,	alignment: 'center', style: 'topFirmAuthority' },
//   { text: '\n\n\n\n' }, 
//   { text: 'AUTHORITY SIGNATURE  ', bold: true, alignment: 'center',style: 'topFirmAuthority'},
//   { text: '\n' },
]}]]},layout:{hLineWidth:function hLineWidth(i,node){return i===0||i===node.table.body.length?2:0;},vLineWidth:function vLineWidth(i,node){return i===0||i===node.table.widths.length?2:0;},hLineColor:function hLineColor(i,node){return i===0||i===node.table.body.length?'black':'white';},vLineColor:function vLineColor(i,node){return i===0||i===node.table.widths.length?'black':'white';}}}],footer:{columns:[{text:'Powered By ACUIFY',alignment:'right',color:'#160091'}],margin:[10,10]},styles:{header:{fontSize:10,bold:true,alignment:'center'},productHeader:{fontSize:10,bold:true,alignment:'center',color:'#160091'},gstHeader:{fontSize:10,color:'#160091',bold:true,alignment:'center'},product:{fontSize:9,alignment:'center'},total:{fontSize:10,alignment:'center',bold:true},productRight:{fontSize:10,alignment:'right'// bold: true
},totalRight:{fontSize:10,alignment:'right',bold:true},topHeader:{color:'#160091',fontSize:10,alignment:'center',bold:true},topLeftHeader:{color:'#160091',fontSize:12,alignment:'left',bold:true},topHeader22:{fontSize:10,bold:true},topHeaderHead:{fontSize:14,bold:true,color:'#160091'},topCustomerHeader:{color:'#160091',fontSize:10,bold:true},topHeader33:{fontSize:10,bold:true},topHeader11:{color:'#160091',fontSize:10,bold:true},topRemainingHeader:{color:'#FF0000',fontSize:10,bold:true},bankDetails:{fontSize:10,bold:true},topFirmAuthority:{color:'#160091',fontSize:11,bold:true}}//Firm Details 
// pdfDoc.content[0].table.body[0][1].text[1].text = (metaData.firm.name.toUpperCase() ? metaData.firm.name.toUpperCase() : '') + "\n";
};pdfDoc.content[1].table.body[1][0].text[1].text=(metaData.firm&&metaData.firm.name?metaData.firm.name.toUpperCase():'')+"\n";pdfDoc.content[1].table.body[1][0].text[3].text=(metaData.firm.GST_number?metaData.firm.GST_number:'')+"\n";pdfDoc.content[1].table.body[1][0].text[5].text=(metaData.firm.liveAddress?metaData.firm.liveAddress:'')+"\n";pdfDoc.content[1].table.body[1][0].text[7].text=(metaData.firm.address?metaData.firm.address:'')+"\n";pdfDoc.content[1].table.body[1][0].text[9].text=(metaData.firm.mobileNumber?metaData.firm.mobileNumber:'')+"\n";pdfDoc.content[1].table.body[1][0].text[11].text=(metaData.firm.email?metaData.firm.email:'')+"\n";// pdfDoc.content[1].table.body[1][0].text[13].text = (metaData.firm.website ? metaData.firm.website : '') + "\n";
//Bill to Details
// pdfDoc.content[1].table.body[1][0].text[1].text = (metaData.customer.name.toUpperCase() ? metaData.customer.name.toUpperCase() : '') + "\n";
// pdfDoc.content[1].table.body[1][0].text[1].text = ((metaData.customer && metaData.customer.name )? metaData.customer.name.toUpperCase() : '') + "\n";
pdfDoc.content[1].table.body[1][1].text[1].text=getCustomerDetails(metaData,'name').toUpperCase()+"\n";pdfDoc.content[1].table.body[1][1].text[3].text=(metaData.customer.GST_number?metaData.customer.GST_number:'')+"\n";// pdfDoc.content[1].table.body[1][1].text[5].text= (metaData.customer.address ? metaData.customer.address : '') + "\n";
// pdfDoc.content[1].table.body[1][1].text[7].text = (metaData.customer.mobile ? metaData.customer.mobile : '') + "\n";
pdfDoc.content[1].table.body[1][1].text[5].text=(metaData.customer.localAddress?metaData.customer.localAddress:'')+"\n";pdfDoc.content[1].table.body[1][1].text[7].text=getCustomerDetails(metaData,'address')+"\n";pdfDoc.content[1].table.body[1][1].text[9].text=getCustomerDetails(metaData,'mobile').toUpperCase()+"\n";pdfDoc.content[1].table.body[1][1].text[11].text=(metaData.invoiceData.placeOfSupply?metaData.invoiceData.placeOfSupply:'')+"\n";//SHIP TO Details
// pdfDoc.content[1].table.body[1][1].text[1].text = ((metaData.customer && metaData.customer.name )? metaData.customer.name.toUpperCase() : '') + "\n";
pdfDoc.content[1].table.body[1][2].text[1].text=(metaData.customer.name.toUpperCase()?metaData.customer.name.toUpperCase():'')+"\n";pdfDoc.content[1].table.body[1][2].text[3].text=(metaData.customer.GST_number?metaData.customer.GST_number:'')+"\n";pdfDoc.content[1].table.body[1][2].text[5].text=(metaData.customer.localAddress?metaData.customer.localAddress:'')+"\n";pdfDoc.content[1].table.body[1][2].text[7].text=(metaData.customer.address?metaData.customer.address:'')+"\n";pdfDoc.content[1].table.body[1][2].text[9].text=(metaData.customer.mobile?metaData.customer.mobile:'')+"\n";pdfDoc.content[1].table.body[1][2].text[11].text=(metaData.invoiceData.placeOfSupply?metaData.invoiceData.placeOfSupply:'')+"\n";//Invoice Details
date=new Date(metaData.invoiceData.date);paymentDueDate=date.setDate(date.getDate()+(metaData.invoiceData.duration?parseInt(metaData.invoiceData.duration):0));pdfDoc.content[1].table.body[1][3].text[1].text=metaData.invoiceData.invoiceId+"\n";pdfDoc.content[1].table.body[1][3].text[3].text=new Date(metaData.invoiceData.date).toLocaleDateString('en-GB').toString()+"\n";pdfDoc.content[1].table.body[1][3].text[5].text=(metaData.invoiceData.status?metaData.invoiceData.status.toUpperCase():'')+"\n";pdfDoc.content[1].table.body[1][3].text[7].text=new Date(paymentDueDate).toLocaleDateString('en-GB').toString()+"\n";//extra details
pdfDoc.content[1].table.body[1][4].text[1].text=(metaData.invoiceData.orderNumber?metaData.invoiceData.orderNumber:'-')+"\n";pdfDoc.content[1].table.body[1][4].text[3].text=(metaData.invoiceData.orderDate?new Date(metaData.invoiceData.orderDate).toLocaleDateString('en-GB').toString():'-')+"\n";pdfDoc.content[1].table.body[1][4].text[5].text=(metaData.invoiceData.applicationNumber?metaData.invoiceData.applicationNumber:'-')+"\n";pdfDoc.content[1].table.body[1][4].text[7].text=(metaData.invoiceData.sanctionDate?new Date(metaData.invoiceData.sanctionDate).toLocaleDateString('en-GB').toString():'-')+"\n";//pending
_context3.t0=metaData.firm.businessType;_context3.next=_context3.t0==='Jwellery'?32:_context3.t0==='Grain'?36:_context3.t0==='Medical/Pesticides'?39:_context3.t0==='Clothes'?43:_context3.t0==='Automobile/Spare Parts'?47:51;break;case 32:pdfDoc.content[2].table.body[0][6].text="Gross weight";pdfDoc.content[2].table.body[0][7].text="Net weight";pdfDoc.content[2].table.body[0][8].text="Purity";return _context3.abrupt("break",55);case 36://pdfDoc.content[2].table.body[0][6].text = "Gross weight";
pdfDoc.content[2].table.body[0][7].text="Net weight";pdfDoc.content[2].table.body[0][8].text="Packing";return _context3.abrupt("break",55);case 39:pdfDoc.content[2].table.body[0][6].text="Batch";pdfDoc.content[2].table.body[0][7].text="MFG Date";pdfDoc.content[2].table.body[0][8].text="EXP Date";return _context3.abrupt("break",55);case 43:pdfDoc.content[2].table.body[0][6].text="Brand";pdfDoc.content[2].table.body[0][7].text="Color";pdfDoc.content[2].table.body[0][8].text="Size";return _context3.abrupt("break",55);case 47:pdfDoc.content[2].table.body[0][6].text="ENG No.";pdfDoc.content[2].table.body[0][7].text="Chasis No.";pdfDoc.content[2].table.body[0][8].text="Extra";return _context3.abrupt("break",55);case 51:pdfDoc.content[2].table.body[0][6].text="Extra";pdfDoc.content[2].table.body[0][7].text="Extra";pdfDoc.content[2].table.body[0][8].text="Extra";return _context3.abrupt("break",55);case 55:// Products
// let productList = convertToPDFProductWithExtraDetails(metaData.firm.businessType,metaData.invoiceData.items,true);
productList=convertToPDFProductWithExtraDetails(metaData.firm.businessType,metaData.invoiceData.items,true,metaData.invoiceData);productList.map(function(item){pdfDoc.content[2].table.body.push(item);});gstObj=convertToGST(metaData.invoiceData.items);__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(gstObj).forEach(function(key){if(key!="totalObj"){pdfDoc.content[3].table.body[0][0][0].table.body.push([{text:key,style:"product"},{text:gstObj[key].quantity,style:"product"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj[key].basicPrice).toFixed(2),style:"total"},{text:gstObj[key].CGST+'%',style:"product"},{text:gstObj[key].CGST_val,style:"product"},{text:gstObj[key].SGST+'%',style:"product"},{text:gstObj[key].SGST_val,style:"product"},{text:gstObj[key].IGST+'%',style:"product"},{text:gstObj[key].IGST_val,style:"product"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj[key].GSTValue).toFixed(2),style:"product"}]);}});pdfDoc.content[3].table.body[0][0][0].table.body.push([{text:'Total',style:"total"},{text:gstObj.totalObj.quantity,style:"total"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj.totalObj.basicPrice).toFixed(2),style:"total"},{text:'',style:"total"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj.totalObj.CGST_val).toFixed(2),style:"total"},{text:'',style:"total"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj.totalObj.SGST_val).toFixed(2),style:"total"},{text:'',style:"total"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj.totalObj.IGST_val).toFixed(2),style:"total"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj.totalObj.GSTValue).toFixed(2),style:"total"}]);// Payment Details
// pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text[1].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";
// pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text[3].text = (metaData.invoiceData.transactionType ? metaData.invoiceData.transactionType : '') + "\n";
//authority
pdfDoc.content[3].table.body[0][0][2].table.body[0][2][1].text=metaData.firm.name?metaData.firm.name.toUpperCase():'';// Terms and cond
pdfDoc.content[3].table.body[0][0][2].table.body[0][1][0].text=metaData.terms.termsAndConditions;//Bank Account Details
if(metaData.terms.banks.length){metaData.terms.banks.map(function(bankDetails){pdfDoc.content[3].table.body[0][0][2].table.body[0][0].push({text:bankDetails.bankName+"\n",style:'bankDetails'});pdfDoc.content[3].table.body[0][0][2].table.body[0][0].push({text:"NAME: "+bankDetails.accountHolderName+"\n",style:'bankDetails'});pdfDoc.content[3].table.body[0][0][2].table.body[0][0].push({text:"A/C NO: "+bankDetails.accountnumber+"\n",style:'bankDetails'});pdfDoc.content[3].table.body[0][0][2].table.body[0][0].push({text:"IFSC:   "+bankDetails.ifsccode+"\n",style:'bankDetails'});pdfDoc.content[3].table.body[0][0][2].table.body[0][0].push({text:bankDetails.address+"\n",style:'bankDetails'});});}// pdfDoc.content[3].table.body[0][0][2].table.body[0][0].text = metaData.terms.termsAndConditions;
// gst details
// pdfDoc.content[3].table.body[0][1].text[1].text = ((metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount ? Number.parseFloat(metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount).toFixed(2) - Number.parseFloat(metaData.gstTotal.CGST_val + metaData.gstTotal.SGST_val + metaData.gstTotal.IGST_val).toFixed(2) : '0')).toFixed(2) + "\n";
pdfDoc.content[3].table.body[0][1].text[1].text=(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalAmount)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.discountAmount||0)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?0:-__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraCharges))-__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraChargesGST):0)-__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.roundOffAmount||0)-(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.SGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.CGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.IGST_val))).toFixed(2)+"\n";pdfDoc.content[3].table.body[0][1].text[3].text=(metaData.gstTotal.CGST_val?(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.CGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraChargesGST)/2:0)).toFixed(2):'0.00')+"\n";pdfDoc.content[3].table.body[0][1].text[5].text=(metaData.gstTotal.SGST_val?(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.SGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraChargesGST)/2:0)).toFixed(2):'0.00')+"\n";pdfDoc.content[3].table.body[0][1].text[7].text=(metaData.gstTotal.IGST_val?(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.IGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraChargesGST):0)).toFixed(2):'0.00')+"\n";offset=0;if(!metaData.invoiceData.gstOnExtraChanrges&&metaData.invoiceData.extraCharges&&metaData.invoiceData.extraCharges.length){metaData.invoiceData.extraCharges.map(function(charge){pdfDoc.content[3].table.body[0][1].text.splice(8+offset,0,{text:''+charge.name+':         ',bold:true,style:'topHeader33'});offset++;pdfDoc.content[3].table.body[0][1].text.splice(8+offset,0,{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(charge.amount).toFixed(2)+'\n',style:'topHeader33'});offset++;});}// pdfDoc.content[3].table.body[0][1].text[9].text = (metaData.invoiceData.labourAmount ? Number.parseFloat(metaData.invoiceData.labourAmount).toFixed(2) : '0.00') + "\n";
pdfDoc.content[3].table.body[0][1].text[9+offset].text=(metaData.invoiceData.discountAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.discountAmount).toFixed(2):'0.00')+"\n";pdfDoc.content[3].table.body[0][1].text[11+offset].text=(metaData.invoiceData.roundOffAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.roundOffAmount).toFixed(2):'0.00')+"\n";// pdfDoc.content[6].table.body[0][1].text[15].text = (metaData.invoiceData.totalAmount + metaData.invoiceData.labourAmount -  metaData.invoiceData.discountAmount ? Number.parseFloat(Number.parseFloat(metaData.invoiceData.totalAmount) + Number.parseFloat(metaData.invoiceData.labourAmount) - Number.parseFloat(metaData.invoiceData.discountAmount)).toFixed(2) : '0') + "\n";
pdfDoc.content[3].table.body[0][1].text[13+offset].text=(metaData.invoiceData.totalAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalAmount).toFixed(2):'0.00')+"\n";pdfDoc.content[3].table.body[0][1].text[15+offset].text=(metaData.invoiceData.paidAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.paidAmount).toFixed(2):'0.00')+"\n";pdfDoc.content[3].table.body[0][1].text[17+offset].text=(metaData.invoiceData.remainingAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.remainingAmount).toFixed(2):'0.00')+"\n";// pdfDoc.content[4].table.body[0][3].text[1].text = (metaData.invoiceData.paidAmount ? metaData.invoiceData.paidAmount : '0') + "\n";
// pdfDoc.content[4].table.body[0][3].text[3].text = (metaData.invoiceData.remainingAmount ? metaData.invoiceData.remainingAmount : '') + "\n";
// pdfDoc.content[6].table.body[0][1].text[17].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";
// if(metaData.invoiceData.extraCharges && metaData.invoiceData.extraCharges.length) {
// 		metaData.invoiceData.extraCharges.map((charge)=>{
// 		pdfDoc.content[3].table.body[0][1].text.push({ text: ''+charge.name+':          ', bold: true, style:'topHeader33' })
// 		pdfDoc.content[3].table.body[0][1].text.push({ text:Number.parseFloat(charge.amount).toFixed(2)+'\n', style:'topHeader33' })
// 	})
// }
//authority
//pdfDoc.content[4].table.body[0][2].text[1].text =  (metaData.firm.name ? (metaData.firm.name).toUpperCase() : '');
if(!metaData.terms.printLogo){_context3.next=123;break;}_context3.prev=75;// let logoData = await getBase64ImageFromURL(metaData.terms.printLogo)
// pdfDoc.content[0].table.body[0][0].image = logoData;
imgToExport=document.getElementById('pdfimgToExport');canvas=document.createElement('canvas');canvas.width=imgToExport.width;canvas.height=imgToExport.height;canvas.getContext('2d').drawImage(imgToExport,0,0);invoiceImages=document.getElementById('invoiceImages');if(!(invoiceImages&&invoiceImages.files&&invoiceImages.files.length)){_context3.next=106;break;}temp={columns:[]};if(!invoiceImages.files[0]){_context3.next=91;break;}_context3.t1=temp.columns;_context3.next=88;return toBase64(invoiceImages.files[0]).catch(function(e){return Error(e);});case 88:_context3.t2=_context3.sent;_context3.t3={image:_context3.t2,width:150};_context3.t1.push.call(_context3.t1,_context3.t3);case 91:if(!invoiceImages.files[1]){_context3.next=98;break;}_context3.t4=temp.columns;_context3.next=95;return toBase64(invoiceImages.files[1]).catch(function(e){return Error(e);});case 95:_context3.t5=_context3.sent;_context3.t6={image:_context3.t5,width:150};_context3.t4.push.call(_context3.t4,_context3.t6);case 98:if(!invoiceImages.files[2]){_context3.next=105;break;}_context3.t7=temp.columns;_context3.next=102;return toBase64(invoiceImages.files[2]).catch(function(e){return Error(e);});case 102:_context3.t8=_context3.sent;_context3.t9={image:_context3.t8,width:150};_context3.t7.push.call(_context3.t7,_context3.t9);case 105:pdfDoc.content.push(temp);case 106:if(!metaData.terms.signature){_context3.next=115;break;}_temp7={columns:[]};_context3.t10=_temp7.columns;_context3.next=111;return getBase64ImageFromURL(metaData.terms.signature);case 111:_context3.t11=_context3.sent;_context3.t12={image:_context3.t11,width:150,alignment:'right'};_context3.t10.push.call(_context3.t10,_context3.t12);//pdfDoc.content.push(temp)
pdfDoc.content[3].table.body[0][2][2]=_temp7.columns[0];case 115:return _context3.abrupt("return",pdfDoc);case 118:_context3.prev=118;_context3.t13=_context3["catch"](75);console.log(_context3.t13);case 121:_context3.next=153;break;case 123:imgToExport=document.getElementById('pdfimgToExport');canvas=document.createElement('canvas');canvas.width=imgToExport.width;canvas.height=imgToExport.height;canvas.getContext('2d').drawImage(imgToExport,0,0);_invoiceImages3=document.getElementById('invoiceImages');if(!(_invoiceImages3&&_invoiceImages3.files&&_invoiceImages3.files.length)){_context3.next=153;break;}_temp8={columns:[]};if(!_invoiceImages3.files[0]){_context3.next=138;break;}_context3.t14=_temp8.columns;_context3.next=135;return toBase64(_invoiceImages3.files[0]).catch(function(e){return Error(e);});case 135:_context3.t15=_context3.sent;_context3.t16={image:_context3.t15,width:150};_context3.t14.push.call(_context3.t14,_context3.t16);case 138:if(!_invoiceImages3.files[1]){_context3.next=145;break;}_context3.t17=_temp8.columns;_context3.next=142;return toBase64(_invoiceImages3.files[1]).catch(function(e){return Error(e);});case 142:_context3.t18=_context3.sent;_context3.t19={image:_context3.t18,width:150};_context3.t17.push.call(_context3.t17,_context3.t19);case 145:if(!_invoiceImages3.files[2]){_context3.next=152;break;}_context3.t20=_temp8.columns;_context3.next=149;return toBase64(_invoiceImages3.files[2]).catch(function(e){return Error(e);});case 149:_context3.t21=_context3.sent;_context3.t22={image:_context3.t21,width:150};_context3.t20.push.call(_context3.t20,_context3.t22);case 152:pdfDoc.content.push(_temp8);case 153:if(!metaData.terms.signature){_context3.next=162;break;}_temp9={columns:[]};_context3.t23=_temp9.columns;_context3.next=158;return getBase64ImageFromURL(metaData.terms.signature);case 158:_context3.t24=_context3.sent;_context3.t25={image:_context3.t24,width:150,alignment:'right'};_context3.t23.push.call(_context3.t23,_context3.t25);//pdfDoc.content.push(temp)
pdfDoc.content[3].table.body[0][2][2]=_temp9.columns[0];case 162:return _context3.abrupt("return",pdfDoc);case 163:case"end":return _context3.stop();}}},_callee3,_this,[[75,118]]);}));return function convertToBasicInvoiceHorizontal(_x3){return _ref3.apply(this,arguments);};}();// Start of New Photo Resize Format Second
var convertToBasicShortInvoiceHorizontal=function(){var _ref4=__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(metaData){var pdfDoc,date,paymentDueDate,productList,gstObj,offset,imgToExport,canvas,invoiceImages,temp,_temp10,_invoiceImages4,_temp11,_temp12;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:pdfDoc={pageOrientation:'landscape',content:[{table:{widths:['44%','45%','11%'],body:[[{//   image: '',
//   width: 120,
//   height: 65,
},{text:[{text:'TRAIL INVOICE',style:'topHeaderHead'}]},//   {
// 	  text:
// 		  [
// 			  { text: 'ADDRESS\n' ,style:'topHeader'},
// 			  { text: 'address\n', style:'topHeader22' },
// 		  ]
//   },
{text:[//   { text: '' ,style:'topHeader22'},
//   { text: 'mobile\n', style:'topHeader22' },
//   { text: 'email\n', style:'topHeader22'},
//   { text: 'website\n', style:'topHeader22'},									  
]}]]},layout:{hLineWidth:function hLineWidth(i,node){return i===0||i===node.table.body.length?2:0;},vLineWidth:function vLineWidth(i,node){return i===0||i===node.table.widths.length?2:0;},hLineColor:function hLineColor(i,node){return i===0||i===node.table.body.length?'black':'white';},vLineColor:function vLineColor(i,node){return i===0||i===node.table.widths.length?'black':'white';}}},{table:{widths:['*','*','*','*','*'],body:[[{text:'FROM',style:"topHeader"},{text:'BILL TO',style:"topHeader"},{text:'SHIP TO',style:"topHeader"},{text:'INVOICE DETAILS',style:"topHeader"},{text:'OTHER DETAILS',style:"topHeader"}],[{text:[{text:' ',bold:true,style:'topCustomerHeader'},{text:'Google\n',style:'topCustomerHeader'},{text:' ',bold:true,style:'topHeader22'},{text:'1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n',style:'topHeader22'},{text:' ',bold:true,style:'topHeader22'},{text:'7788996655\n',style:'topHeader22'},{text:' ',bold:true,style:'topHeader22'},{text:'7788996655\n',style:'topHeader22'},{text:' ',bold:true,style:'topHeader22'},{text:'1679905\n',style:'topHeader22'},{text:' ',bold:true,style:'topHeader22'},{text:'23\n',style:'topHeader22'}]},// End of NEw of Development
{text:[{text:' ',bold:true,style:'topCustomerHeader'},{text:'Google\n',style:'topCustomerHeader'},{text:' ',bold:true,style:'topHeader22'},{text:'1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n',style:'topHeader22'},{text:' ',bold:true,style:'topHeader22'},{text:'7788996655\n',style:'topHeader22'},{text:' ',bold:true,style:'topHeader22'},{text:'7788996655\n',style:'topHeader22'},{text:' ',bold:true,style:'topHeader22'},{text:'1679905\n',style:'topHeader22'},{text:' ',bold:true,style:'topHeader22'},{text:'23\n',style:'topHeader22'}]},{text:[{text:' ',bold:true,style:'topCustomerHeader'},{text:'Google\n',style:'topCustomerHeader'},{text:' ',bold:true,style:'topHeader22'},{text:'1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n',style:'topHeader22'},{text:' ',bold:true,style:'topHeader22'},{text:'7788996655\n',style:'topHeader22'},{text:' ',bold:true,style:'topHeader22'},{text:'7788996655\n',style:'topHeader22'},{text:' ',bold:true,style:'topHeader22'},{text:'1679905\n',style:'topHeader22'},{text:' ',bold:true,style:'topHeader22'},{text:'23\n',style:'topHeader22'}]},{text:[{text:'Invoice No    :  ',bold:true,style:'topHeader22'},{text:'787878\n',style:'topHeader22'},{text:'Invoice Date :  ',bold:true,style:'topHeader22'},{text:'12/12/90 \n',style:'topHeader22'},{text:'Status            :  ',bold:true,style:'topHeader22'},{text:'12/12/90 \n',style:'topRemainingHeader'},{text:'Due Date       :   ',bold:true,style:'topHeader22'},{text:'13/12/90 \n',style:'topHeader22'}]},{text:[{text:'Order No           :  	',bold:true,style:'topHeader22'},{text:'787878\n',style:'topHeader22'},{text:'Order Date        :      ',bold:true,style:'topHeader22'},{text:'12/12/90 \n',style:'topHeader22'},{text:'Application No :      ',bold:true,style:'topHeader22'},{text:'12/12/90 \n',style:'topHeader22'},{text:'Sanction Date   :      ',bold:true,style:'topHeader22'},{text:'13/12/90\n',style:'topHeader22'}]}]]}},{table:{body:[[{text:'S.No',style:"productHeader",rowSpan:2},{text:'Product Description',style:"productHeader",rowSpan:2},{text:'HSN',style:"productHeader",rowSpan:2},{text:'Qty',style:"productHeader",rowSpan:2},{text:'Units',style:"productHeader",rowSpan:2},{text:'Unit Price',style:"productHeader",rowSpan:2},{text:'Gross weight',style:"productHeader",rowSpan:2},{text:'Net weight',style:"productHeader",rowSpan:2},{text:'Purity',style:"productHeader",rowSpan:2},{text:'Taxable  Amount',style:"productHeader",rowSpan:2},{text:'CGST',style:"productHeader",colSpan:2,rowSpan:1},{text:'',style:"productHeader"},{text:'SGST',style:"productHeader",colSpan:2,rowSpan:1},{text:'',style:"productHeader"},{text:'IGST',style:"productHeader",colSpan:2,rowSpan:1},{text:'',style:"productHeader"},{text:'Total Amount',style:"productHeader",rowSpan:2}],[{text:'S.No',style:"productHeader"},{text:'Product Description',style:"productHeader"},{text:'HSN',style:"productHeader"},{text:'Qty',style:"productHeader"},{text:'Units',style:"productHeader"},{text:'Unit Price',style:"productHeader"},{text:'Gross weight',style:"productHeader"},{text:'Net weight',style:"productHeader"},{text:'Purity',style:"productHeader"},{text:'Taxable Amount',style:"productHeader"},{text:'%',style:"productHeader"},{text:'₹',style:"productHeader"},{text:'%',style:"productHeader"},{text:'₹',style:"productHeader"},{text:'%',style:"productHeader"},{text:'₹',style:"productHeader"},{text:'Total Amount',style:"productHeader"}]]}},{table:{widths:['75%','*'],body:[[[{table:{body:[[{text:'HSN SUMMARY',style:"gstHeader",colSpan:10},{text:'QUANTITY',style:"gstHeader"},{text:'TAXABLE AMOUNT',style:"gstHeader"},{text:'%',style:"gstHeader"},{text:'AMOUNT',style:"gstHeader"},{text:'%',style:"gstHeader"},{text:'AMOUNT',style:"gstHeader"},{text:'%',style:"gstHeader"},{text:'AMOUNT',style:"gstHeader"},{text:'TOTAL TAX AMOUNT',style:"gstHeader"}],[{text:'HSN/SAC',style:"gstHeader",rowSpan:2},{text:'QUANTITY',style:"gstHeader",rowSpan:2},{text:'TAXABLE AMOUNT',style:"gstHeader",rowSpan:2},{text:'CGST',style:"gstHeader",colSpan:2,rowSpan:1},{text:'',style:"gstHeader",rowSpan:2},{text:'SGST',style:"gstHeader",colSpan:2,rowSpan:1},{text:'',style:"gstHeader",rowSpan:2},{text:'IGST',style:"gstHeader",colSpan:2,rowSpan:1},{text:'',style:"gstHeader",rowSpan:2},{text:'TOTAL TAX AMOUNT',style:"gstHeader",rowSpan:2}],[{text:'HSN/SAC',style:"gstHeader"},{text:'QUANTITY',style:"gstHeader"},{text:'TAXABLE AMOUNT',style:"gstHeader"},{text:'%',style:"gstHeader"},{text:'AMOUNT',style:"gstHeader"},{text:'%',style:"gstHeader"},{text:'AMOUNT',style:"gstHeader"},{text:'%',style:"gstHeader"},{text:'AMOUNT',style:"gstHeader"},{text:'TAX AMOUNT',style:"gstHeader"}]]}},{table:{widths:['30%','40%','30%'],body:[[[{text:'PAYMENT DETAILS',style:"topHeader"}],[{text:'TERMS & CONDITIONS',style:"topHeader"}],[{text:'AUTHORITY SIGNATURE',style:"topHeader"}]]]},style:'tab2Head'},{table:{widths:['30%','40%','30%'],body:[[[],[{text:""}],// {
// 	text:
[{text:''},{text:'Firm Name  ',bold:true,alignment:'center',style:'topFirmAuthority'},{text:'\n\n\n\n'},{text:'AUTHORITY SIGNATURE  ',bold:true,alignment:'center',style:'topFirmAuthority'},{text:'\n'}]// },
]]},style:'tab2'}],{text:[{text:'Taxable Amount:       ',bold:true,style:'topHeader33'},{text:'12122\n',style:'topHeader33'},{text:'CGST Amount:           ',bold:true,style:'topHeader33'},{text:'12122\n',style:'topHeader33'},{text:'SGST Amount:           ',bold:true,style:'topHeader33'},{text:'12122\n',style:'topHeader33'},{text:'IGST Amount:            ',bold:true,style:'topHeader33'},{text:'12122\n',style:'topHeader33'},//   { text: 'Extra Charge:             ', bold: true, style:'topHeader33' },
//   { text: '12122\n', style:'topHeader33' },
{text:'Discount:                    ',bold:true,style:'topHeader33'},{text:'12122\n',style:'topHeader33'},{text:'RoundOff:                   ',bold:true,style:'topHeader33'},{text:'12122\n',style:'topHeader33'},{text:'Total Amount:            ',style:'topHeader11'},{text:'12122\n',style:'topHeader11'},{text:'Paid Amount:             ',bold:true,style:'topHeader33'},{text:'12122\n',style:'topHeader33'},{text:'Due Amount:              ',bold:true,style:'topRemainingHeader'},{text:'12122\n',style:'topRemainingHeader'}]}]]}//style:'tab2', pageBreak: 'after'
},{table:{widths:['15%','60%','25%'],body:[[{// image: '',
// width: 110,
// height: 70,
},{text:[// { text: '' ,style:'topHeader'},
// { text: 'For More Information, Visit\n', style: 'topLeftHeader'},
// { text: 'https://info.parvsacuify.com\n' },
// { text: 'https://parvsacuify.com\n' },
// { text: '+91 6232623333\n'},
// { text: 'careacuify@gmail.com \n' },
]},{text:[//   { text: '' },
//   { text: 'Firm Name  ', bold: true,	alignment: 'center', style: 'topFirmAuthority' },
//   { text: '\n\n\n\n' }, 
//   { text: 'AUTHORITY SIGNATURE  ', bold: true, alignment: 'center',style: 'topFirmAuthority'},
//   { text: '\n' },
]}]]},layout:{hLineWidth:function hLineWidth(i,node){return i===0||i===node.table.body.length?2:0;},vLineWidth:function vLineWidth(i,node){return i===0||i===node.table.widths.length?2:0;},hLineColor:function hLineColor(i,node){return i===0||i===node.table.body.length?'black':'white';},vLineColor:function vLineColor(i,node){return i===0||i===node.table.widths.length?'black':'white';}}}],footer:{columns:[{text:'Powered By ACUIFY',alignment:'right',color:'#160091'}],margin:[10,10]},styles:{header:{fontSize:10,bold:true,alignment:'center'},productHeader:{fontSize:10,bold:true,alignment:'center',color:'#160091'},gstHeader:{fontSize:10,color:'#160091',bold:true,alignment:'center'},product:{fontSize:9,alignment:'center'},total:{fontSize:10,alignment:'center',bold:true},productRight:{fontSize:10,alignment:'right'// bold: true
},totalRight:{fontSize:10,alignment:'right',bold:true},topHeader:{color:'#160091',fontSize:10,alignment:'center',bold:true},topLeftHeader:{color:'#160091',fontSize:12,alignment:'left',bold:true},topHeader22:{fontSize:10,bold:true},topHeaderHead:{fontSize:14,bold:true,color:'#160091'},topCustomerHeader:{color:'#160091',fontSize:10,bold:true},topHeader33:{fontSize:10,bold:true},topHeader11:{color:'#160091',fontSize:10,bold:true},topRemainingHeader:{color:'#FF0000',fontSize:10,bold:true},bankDetails:{fontSize:10,bold:true},topFirmAuthority:{color:'#160091',fontSize:11,bold:true}}//Firm Details 
// pdfDoc.content[0].table.body[0][1].text[1].text = (metaData.firm.name.toUpperCase() ? metaData.firm.name.toUpperCase() : '') + "\n";
};pdfDoc.content[1].table.body[1][0].text[1].text=(metaData.firm&&metaData.firm.name?metaData.firm.name.toUpperCase():'')+"\n";pdfDoc.content[1].table.body[1][0].text[3].text=(metaData.firm.GST_number?metaData.firm.GST_number:'')+"\n";pdfDoc.content[1].table.body[1][0].text[5].text=(metaData.firm.liveAddress?metaData.firm.liveAddress:'')+"\n";pdfDoc.content[1].table.body[1][0].text[7].text=(metaData.firm.address?metaData.firm.address:'')+"\n";pdfDoc.content[1].table.body[1][0].text[9].text=(metaData.firm.mobileNumber?metaData.firm.mobileNumber:'')+"\n";pdfDoc.content[1].table.body[1][0].text[11].text=(metaData.firm.email?metaData.firm.email:'')+"\n";// pdfDoc.content[1].table.body[1][0].text[13].text = (metaData.firm.website ? metaData.firm.website : '') + "\n";
//Bill to Details
// pdfDoc.content[1].table.body[1][0].text[1].text = (metaData.customer.name.toUpperCase() ? metaData.customer.name.toUpperCase() : '') + "\n";
// pdfDoc.content[1].table.body[1][0].text[1].text = ((metaData.customer && metaData.customer.name )? metaData.customer.name.toUpperCase() : '') + "\n";
pdfDoc.content[1].table.body[1][1].text[1].text=getCustomerDetails(metaData,'name').toUpperCase()+"\n";pdfDoc.content[1].table.body[1][1].text[3].text=(metaData.customer.GST_number?metaData.customer.GST_number:'')+"\n";// pdfDoc.content[1].table.body[1][1].text[5].text= (metaData.customer.address ? metaData.customer.address : '') + "\n";
// pdfDoc.content[1].table.body[1][1].text[7].text = (metaData.customer.mobile ? metaData.customer.mobile : '') + "\n";
pdfDoc.content[1].table.body[1][1].text[5].text=(metaData.customer.localAddress?metaData.customer.localAddress:'')+"\n";pdfDoc.content[1].table.body[1][1].text[7].text=getCustomerDetails(metaData,'address')+"\n";pdfDoc.content[1].table.body[1][1].text[9].text=getCustomerDetails(metaData,'mobile').toUpperCase()+"\n";pdfDoc.content[1].table.body[1][1].text[11].text=(metaData.invoiceData.placeOfSupply?metaData.invoiceData.placeOfSupply:'')+"\n";//SHIP TO Details
// pdfDoc.content[1].table.body[1][1].text[1].text = ((metaData.customer && metaData.customer.name )? metaData.customer.name.toUpperCase() : '') + "\n";
pdfDoc.content[1].table.body[1][2].text[1].text=(metaData.customer.name.toUpperCase()?metaData.customer.name.toUpperCase():'')+"\n";pdfDoc.content[1].table.body[1][2].text[3].text=(metaData.customer.GST_number?metaData.customer.GST_number:'')+"\n";pdfDoc.content[1].table.body[1][2].text[5].text=(metaData.customer.localAddress?metaData.customer.localAddress:'')+"\n";pdfDoc.content[1].table.body[1][2].text[7].text=(metaData.customer.address?metaData.customer.address:'')+"\n";pdfDoc.content[1].table.body[1][2].text[9].text=(metaData.customer.mobile?metaData.customer.mobile:'')+"\n";pdfDoc.content[1].table.body[1][2].text[11].text=(metaData.invoiceData.placeOfSupply?metaData.invoiceData.placeOfSupply:'')+"\n";//Invoice Details
date=new Date(metaData.invoiceData.date);paymentDueDate=date.setDate(date.getDate()+(metaData.invoiceData.duration?parseInt(metaData.invoiceData.duration):0));pdfDoc.content[1].table.body[1][3].text[1].text=metaData.invoiceData.invoiceId+"\n";pdfDoc.content[1].table.body[1][3].text[3].text=new Date(metaData.invoiceData.date).toLocaleDateString('en-GB').toString()+"\n";pdfDoc.content[1].table.body[1][3].text[5].text=(metaData.invoiceData.status?metaData.invoiceData.status.toUpperCase():'')+"\n";pdfDoc.content[1].table.body[1][3].text[7].text=new Date(paymentDueDate).toLocaleDateString('en-GB').toString()+"\n";//extra details
pdfDoc.content[1].table.body[1][4].text[1].text=(metaData.invoiceData.orderNumber?metaData.invoiceData.orderNumber:'-')+"\n";pdfDoc.content[1].table.body[1][4].text[3].text=(metaData.invoiceData.orderDate?new Date(metaData.invoiceData.orderDate).toLocaleDateString('en-GB').toString():'-')+"\n";pdfDoc.content[1].table.body[1][4].text[5].text=(metaData.invoiceData.applicationNumber?metaData.invoiceData.applicationNumber:'-')+"\n";pdfDoc.content[1].table.body[1][4].text[7].text=(metaData.invoiceData.sanctionDate?new Date(metaData.invoiceData.sanctionDate).toLocaleDateString('en-GB').toString():'-')+"\n";//pending
_context4.t0=metaData.firm.businessType;_context4.next=_context4.t0==='Jwellery'?32:_context4.t0==='Grain'?36:_context4.t0==='Medical/Pesticides'?39:_context4.t0==='Clothes'?43:_context4.t0==='Automobile/Spare Parts'?47:51;break;case 32:pdfDoc.content[2].table.body[0][6].text="Gross weight";pdfDoc.content[2].table.body[0][7].text="Net weight";pdfDoc.content[2].table.body[0][8].text="Purity";return _context4.abrupt("break",55);case 36://pdfDoc.content[2].table.body[0][6].text = "Gross weight";
pdfDoc.content[2].table.body[0][7].text="Net weight";pdfDoc.content[2].table.body[0][8].text="Packing";return _context4.abrupt("break",55);case 39:pdfDoc.content[2].table.body[0][6].text="Batch";pdfDoc.content[2].table.body[0][7].text="MFG Date";pdfDoc.content[2].table.body[0][8].text="EXP Date";return _context4.abrupt("break",55);case 43:pdfDoc.content[2].table.body[0][6].text="Brand";pdfDoc.content[2].table.body[0][7].text="Color";pdfDoc.content[2].table.body[0][8].text="Size";return _context4.abrupt("break",55);case 47:pdfDoc.content[2].table.body[0][6].text="ENG No.";pdfDoc.content[2].table.body[0][7].text="Chasis No.";pdfDoc.content[2].table.body[0][8].text="Extra";return _context4.abrupt("break",55);case 51:pdfDoc.content[2].table.body[0][6].text="Extra";pdfDoc.content[2].table.body[0][7].text="Extra";pdfDoc.content[2].table.body[0][8].text="Extra";return _context4.abrupt("break",55);case 55:// Products
// let productList = convertToPDFProductWithExtraDetails(metaData.firm.businessType,metaData.invoiceData.items,true);
productList=convertToPDFProductWithExtraDetails(metaData.firm.businessType,metaData.invoiceData.items,true,metaData.invoiceData);productList.map(function(item){pdfDoc.content[2].table.body.push(item);});gstObj=convertToGST(metaData.invoiceData.items);__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(gstObj).forEach(function(key){if(key!="totalObj"){pdfDoc.content[3].table.body[0][0][0].table.body.push([{text:key,style:"product"},{text:gstObj[key].quantity,style:"product"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj[key].basicPrice).toFixed(2),style:"total"},{text:gstObj[key].CGST+'%',style:"product"},{text:gstObj[key].CGST_val,style:"product"},{text:gstObj[key].SGST+'%',style:"product"},{text:gstObj[key].SGST_val,style:"product"},{text:gstObj[key].IGST+'%',style:"product"},{text:gstObj[key].IGST_val,style:"product"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj[key].GSTValue).toFixed(2),style:"product"}]);}});pdfDoc.content[3].table.body[0][0][0].table.body.push([{text:'Total',style:"total"},{text:gstObj.totalObj.quantity,style:"total"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj.totalObj.basicPrice).toFixed(2),style:"total"},{text:'',style:"total"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj.totalObj.CGST_val).toFixed(2),style:"total"},{text:'',style:"total"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj.totalObj.SGST_val).toFixed(2),style:"total"},{text:'',style:"total"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj.totalObj.IGST_val).toFixed(2),style:"total"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj.totalObj.GSTValue).toFixed(2),style:"total"}]);// Payment Details
// pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text[1].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";
// pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text[3].text = (metaData.invoiceData.transactionType ? metaData.invoiceData.transactionType : '') + "\n";
//authority
pdfDoc.content[3].table.body[0][0][2].table.body[0][2][1].text=metaData.firm.name?metaData.firm.name.toUpperCase():'';// Terms and cond
pdfDoc.content[3].table.body[0][0][2].table.body[0][1][0].text=metaData.terms.termsAndConditions;//Bank Account Details
if(metaData.terms.banks.length){metaData.terms.banks.map(function(bankDetails){pdfDoc.content[3].table.body[0][0][2].table.body[0][0].push({text:bankDetails.bankName+"\n",style:'bankDetails'});pdfDoc.content[3].table.body[0][0][2].table.body[0][0].push({text:"NAME: "+bankDetails.accountHolderName+"\n",style:'bankDetails'});pdfDoc.content[3].table.body[0][0][2].table.body[0][0].push({text:"A/C NO: "+bankDetails.accountnumber+"\n",style:'bankDetails'});pdfDoc.content[3].table.body[0][0][2].table.body[0][0].push({text:"IFSC:   "+bankDetails.ifsccode+"\n",style:'bankDetails'});pdfDoc.content[3].table.body[0][0][2].table.body[0][0].push({text:bankDetails.address+"\n",style:'bankDetails'});});}// pdfDoc.content[3].table.body[0][0][2].table.body[0][0].text = metaData.terms.termsAndConditions;
// gst details
// pdfDoc.content[3].table.body[0][1].text[1].text = ((metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount ? Number.parseFloat(metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount).toFixed(2) - Number.parseFloat(metaData.gstTotal.CGST_val + metaData.gstTotal.SGST_val + metaData.gstTotal.IGST_val).toFixed(2) : '0')).toFixed(2) + "\n";
pdfDoc.content[3].table.body[0][1].text[1].text=(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalAmount)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.discountAmount||0)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?0:-__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraCharges))-__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraChargesGST):0)-__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.roundOffAmount||0)-(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.SGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.CGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.IGST_val))).toFixed(2)+"\n";pdfDoc.content[3].table.body[0][1].text[3].text=(metaData.gstTotal.CGST_val?(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.CGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraChargesGST)/2:0)).toFixed(2):'0.00')+"\n";pdfDoc.content[3].table.body[0][1].text[5].text=(metaData.gstTotal.SGST_val?(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.SGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraChargesGST)/2:0)).toFixed(2):'0.00')+"\n";pdfDoc.content[3].table.body[0][1].text[7].text=(metaData.gstTotal.IGST_val?(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.IGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraChargesGST):0)).toFixed(2):'0.00')+"\n";offset=0;if(!metaData.invoiceData.gstOnExtraChanrges&&metaData.invoiceData.extraCharges&&metaData.invoiceData.extraCharges.length){metaData.invoiceData.extraCharges.map(function(charge){pdfDoc.content[3].table.body[0][1].text.splice(8+offset,0,{text:''+charge.name+':         ',bold:true,style:'topHeader33'});offset++;pdfDoc.content[3].table.body[0][1].text.splice(8+offset,0,{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(charge.amount).toFixed(2)+'\n',style:'topHeader33'});offset++;});}// pdfDoc.content[3].table.body[0][1].text[9].text = (metaData.invoiceData.labourAmount ? Number.parseFloat(metaData.invoiceData.labourAmount).toFixed(2) : '0.00') + "\n";
pdfDoc.content[3].table.body[0][1].text[9+offset].text=(metaData.invoiceData.discountAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.discountAmount).toFixed(2):'0.00')+"\n";pdfDoc.content[3].table.body[0][1].text[11+offset].text=(metaData.invoiceData.roundOffAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.roundOffAmount).toFixed(2):'0.00')+"\n";// pdfDoc.content[6].table.body[0][1].text[15].text = (metaData.invoiceData.totalAmount + metaData.invoiceData.labourAmount -  metaData.invoiceData.discountAmount ? Number.parseFloat(Number.parseFloat(metaData.invoiceData.totalAmount) + Number.parseFloat(metaData.invoiceData.labourAmount) - Number.parseFloat(metaData.invoiceData.discountAmount)).toFixed(2) : '0') + "\n";
pdfDoc.content[3].table.body[0][1].text[13+offset].text=(metaData.invoiceData.totalAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalAmount).toFixed(2):'0.00')+"\n";pdfDoc.content[3].table.body[0][1].text[15+offset].text=(metaData.invoiceData.paidAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.paidAmount).toFixed(2):'0.00')+"\n";pdfDoc.content[3].table.body[0][1].text[17+offset].text=(metaData.invoiceData.remainingAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.remainingAmount).toFixed(2):'0.00')+"\n";// pdfDoc.content[4].table.body[0][3].text[1].text = (metaData.invoiceData.paidAmount ? metaData.invoiceData.paidAmount : '0') + "\n";
// pdfDoc.content[4].table.body[0][3].text[3].text = (metaData.invoiceData.remainingAmount ? metaData.invoiceData.remainingAmount : '') + "\n";
// pdfDoc.content[6].table.body[0][1].text[17].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";
// if(metaData.invoiceData.extraCharges && metaData.invoiceData.extraCharges.length) {
// 		metaData.invoiceData.extraCharges.map((charge)=>{
// 		pdfDoc.content[3].table.body[0][1].text.push({ text: ''+charge.name+':          ', bold: true, style:'topHeader33' })
// 		pdfDoc.content[3].table.body[0][1].text.push({ text:Number.parseFloat(charge.amount).toFixed(2)+'\n', style:'topHeader33' })
// 	})
// }
//authority
//pdfDoc.content[4].table.body[0][2].text[1].text =  (metaData.firm.name ? (metaData.firm.name).toUpperCase() : '');
if(!metaData.terms.printLogo){_context4.next=123;break;}_context4.prev=75;// let logoData = await getBase64ImageFromURL(metaData.terms.printLogo)
// pdfDoc.content[0].table.body[0][0].image = logoData;
imgToExport=document.getElementById('pdfimgToExport');canvas=document.createElement('canvas');canvas.width=imgToExport.width;canvas.height=imgToExport.height;canvas.getContext('2d').drawImage(imgToExport,0,0);invoiceImages=document.getElementById('invoiceImages');if(!(invoiceImages&&invoiceImages.files&&invoiceImages.files.length)){_context4.next=106;break;}temp={columns:[]};if(!invoiceImages.files[0]){_context4.next=91;break;}_context4.t1=temp.columns;_context4.next=88;return toBase64(invoiceImages.files[0]).catch(function(e){return Error(e);});case 88:_context4.t2=_context4.sent;_context4.t3={image:_context4.t2,width:150};_context4.t1.push.call(_context4.t1,_context4.t3);case 91:if(!invoiceImages.files[1]){_context4.next=98;break;}_context4.t4=temp.columns;_context4.next=95;return toBase64(invoiceImages.files[1]).catch(function(e){return Error(e);});case 95:_context4.t5=_context4.sent;_context4.t6={image:_context4.t5,width:150};_context4.t4.push.call(_context4.t4,_context4.t6);case 98:if(!invoiceImages.files[2]){_context4.next=105;break;}_context4.t7=temp.columns;_context4.next=102;return toBase64(invoiceImages.files[2]).catch(function(e){return Error(e);});case 102:_context4.t8=_context4.sent;_context4.t9={image:_context4.t8,width:150};_context4.t7.push.call(_context4.t7,_context4.t9);case 105:pdfDoc.content.push(temp);case 106:if(!metaData.terms.signature){_context4.next=115;break;}_temp10={columns:[]};_context4.t10=_temp10.columns;_context4.next=111;return getBase64ImageFromURL(metaData.terms.signature);case 111:_context4.t11=_context4.sent;_context4.t12={image:_context4.t11,width:150,alignment:'right'};_context4.t10.push.call(_context4.t10,_context4.t12);//pdfDoc.content.push(temp)
pdfDoc.content[3].table.body[0][2][2]=_temp10.columns[0];case 115:return _context4.abrupt("return",pdfDoc);case 118:_context4.prev=118;_context4.t13=_context4["catch"](75);console.log(_context4.t13);case 121:_context4.next=153;break;case 123:imgToExport=document.getElementById('pdfimgToExport');canvas=document.createElement('canvas');canvas.width=imgToExport.width;canvas.height=imgToExport.height;canvas.getContext('2d').drawImage(imgToExport,0,0);_invoiceImages4=document.getElementById('invoiceImages');if(!(_invoiceImages4&&_invoiceImages4.files&&_invoiceImages4.files.length)){_context4.next=153;break;}_temp11={columns:[]};if(!_invoiceImages4.files[0]){_context4.next=138;break;}_context4.t14=_temp11.columns;_context4.next=135;return toBase64(_invoiceImages4.files[0]).catch(function(e){return Error(e);});case 135:_context4.t15=_context4.sent;_context4.t16={image:_context4.t15,width:150};_context4.t14.push.call(_context4.t14,_context4.t16);case 138:if(!_invoiceImages4.files[1]){_context4.next=145;break;}_context4.t17=_temp11.columns;_context4.next=142;return toBase64(_invoiceImages4.files[1]).catch(function(e){return Error(e);});case 142:_context4.t18=_context4.sent;_context4.t19={image:_context4.t18,width:150};_context4.t17.push.call(_context4.t17,_context4.t19);case 145:if(!_invoiceImages4.files[2]){_context4.next=152;break;}_context4.t20=_temp11.columns;_context4.next=149;return toBase64(_invoiceImages4.files[2]).catch(function(e){return Error(e);});case 149:_context4.t21=_context4.sent;_context4.t22={image:_context4.t21,width:150};_context4.t20.push.call(_context4.t20,_context4.t22);case 152:pdfDoc.content.push(_temp11);case 153:if(!metaData.terms.signature){_context4.next=162;break;}_temp12={columns:[]};_context4.t23=_temp12.columns;_context4.next=158;return getBase64ImageFromURL(metaData.terms.signature);case 158:_context4.t24=_context4.sent;_context4.t25={image:_context4.t24,width:150,alignment:'right'};_context4.t23.push.call(_context4.t23,_context4.t25);//pdfDoc.content.push(temp)
pdfDoc.content[3].table.body[0][2][2]=_temp12.columns[0];case 162:return _context4.abrupt("return",pdfDoc);case 163:case"end":return _context4.stop();}}},_callee4,_this,[[75,118]]);}));return function convertToBasicShortInvoiceHorizontal(_x4){return _ref4.apply(this,arguments);};}();// End of New Photo Resize Format Second
var convertToBasicInvoiceWithoutGST=function(){var _ref5=__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(metaData){var pdfDoc,date,paymentDueDate,productList,offset,logoData,invoiceImages,temp,_temp13,imgToExport,canvas,base64,_invoiceImages5,_temp14,_temp15;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:pdfDoc={content:[{table:{widths:['*'],body:[[{text:'PROFORMA INVOICE',style:"topHeader"}]]},layout:'noBorders'},{table:{widths:['0%','48%','*'],body:[[{text:''},{image:'',width:140,height:100},{text:[{text:' ',bold:true,style:'topFirmAuthorityRight'},{text:'\n',style:'topFirmAuthorityRight'},{text:'',bold:true,style:'firmHeaderOneRight'},{text:'88776655\n',style:'firmHeaderOneRight'},// { text: ' ', bold: true, style: 'icon' },
// { text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \nRight'},
{text:'',bold:true,style:'firmHeaderOneRight'},{text:'88776655\n',style:'firmHeaderOneRight'},{text:'',bold:true,style:'firmHeaderOneRight'},//icon gift
{text:'njnjn@jnn.com\n',style:'firmHeaderOneRight'},{text:' ',bold:true,style:'firmHeaderOneRight'},{text:'123456\n',style:'firmHeaderOneRight'}]}]]},layout:'noBorders',style:"topTab"},{table:{widths:['60%','*'],body:[[{text:'BILL TO',style:"billHeader"},{text:'INVOICE DETAILS',style:"billHeader"}]]},style:'tab2Head',layout:'noBorders'},{table:{widths:['0%','55%','*'],body:[[{text:''},{text:[{text:' ',bold:true,style:'topFirmAuthority'},{text:'Google\n',style:'topFirmAuthority'},{text:' ',bold:true,style:'firmHeaderOne'},{text:'1679905\n',style:'firmHeaderOne'},{text:'  ',bold:true,style:'firmHeaderOne'},{text:'7788996655\n',style:'firmHeaderOne'},{text:'Mobile Number :   ',bold:true,style:'firmHeaderOne'},{text:'1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n',style:'firmHeaderOne'},{text:'Place of Supply :   ',bold:true,style:'firmHeaderOne'},{text:'13/12/90\n',style:'firmHeaderOne'},{text:'State Code         :   ',bold:true,style:'firmHeaderOne'},{text:'23\n',style:'firmHeaderOne'}]},{text:[{text:'Invoice No                :   ',bold:true,style:'firmHeaderOne'},{text:'787878\n',style:'firmHeaderOne'},{text:'Invoice Date             :   ',bold:true,style:'firmHeaderOne'},{text:'12/12/90 \n',style:'firmHeaderOne'},{text:'Invoice Status          :   ',bold:true,style:'topRemainingHeader'},{text:'12/12/90 \n',style:'topRemainingHeader'},{text:'Payment Due Date  :   ',bold:true,style:'firmHeaderOne'},{text:'13/12/90\n',style:'firmHeaderOne'},{text:'Remark  :   ',bold:true,style:'firmHeaderOne'},{text:'13/12/90\n',style:'firmHeaderOne'}]}]]},style:'tab2',layout:'noBorders'},{table:{widths:['*','*'],body:[[{text:'ITEMS',style:"emptyHeader1"},{text:'',style:"emptyHeader1"}]]},layout:'noBorders'},{table:{body:[[{text:'S.NO',style:"productHeader11",rowSpan:2},{text:'DESCRIPTION OF PRODUCTS',style:"productHeader11",rowSpan:2},// { text: 'HSN/SAC', style: "productHeader1", rowSpan: 2 },
{text:'QUANTITY',style:"productHeader11",rowSpan:2},{text:'UNITS',style:"productHeader11",rowSpan:2},{text:'PRODUCTS RATE',style:"productHeader11",rowSpan:2},// { text: 'Basic  Amount', style: "productHeader", rowSpan: 2 },
{text:'TOTAL AMOUNT',style:"productHeader11",rowSpan:2}],[{text:'S.NO',style:"productHeader11"},{text:'DESCRIPTION OF PRODUCTS',style:"productHeader11"},// { text: 'HSN/SAC', style: "productHeader1" },
{text:'QUANTITY',style:"productHeader11"},{text:'UNITS',style:"productHeader11"},{text:'PRODUCTS RATE',style:"productHeader11"},// { text: 'Basic Amount', style: "productHeader" },
{text:'TOTAL AMOUNT',style:"productHeader11"}]]}},{table:{widths:['65%','*'],body:[[[{table:{widths:['*'],body:[[{text:'PAYMENT DETAILS',style:"topHeader1"}]]},style:'tab2Head',layout:'noBorders'},{table:{widths:['3%','*'],body:[[{text:''},{text:[]}]]},style:'tab2',layout:'noBorders'},{table:{widths:['*'],body:[[{text:'TERMS & CONDITIONS',style:"topHeader1"}]]},style:'tab2Head',layout:'noBorders'},{table:{widths:['3%','*'],body:[[{text:''},{text:""}]]},style:'tab2',layout:'noBorders'}],{text:[{text:'Basic Amount   :   ',bold:true,style:'headerOne'},{text:'12122\n',style:'headerOne'},// { text: 'Labour Charge:      ', bold: true, style:'headerOne' },
// { text: '12122\n', style:'headerOne' },
{text:'Discount            :   ',bold:true,style:'headerOne'},{text:'12122\n',style:'headerOne'},{text:'RoundOff           :   ',bold:true,style:'headerOne'},{text:'12122\n',style:'headerOne'},{text:'Total Amount    :   ',bold:true,style:'topTotalAmount'},{text:'12122\n',style:'topTotalAmount'},{text:'Paid Amount     :   ',bold:true,style:'headerOne'},{text:'12122\n',style:'headerOne'},{text:'Due Amount      :   ',bold:true,style:'topRemainingHeader'},{text:'12122\n',style:'topRemainingHeader'}]}]]},style:'tab2',layout:'lightHorizontalLines'},{table:{widths:['*','*'],body:[[{text:'OUTSTANDING DETAILS',style:"emptyHeader"},{text:'he',style:"emptyHeader1"}]]},layout:'noBorders'},// Start of Previous + current = Total Column
{table:{widths:['34%','39%','27%'],body:[[{text:'',style:"topBlankHeader"},{text:'',style:"topMainHeader"},{text:'',style:"topBlankHeader"}],[{text:[{text:'PREVIOUS BALANCE :  ',bold:true,style:'topHeader11'},{text:'\n',style:'topHeader11'}]},{text:[{text:'CURRENT BALANCE :  ',bold:true,style:'topHeader11'},{text:'\n',style:'topHeader11'}]},{text:[{text:'TOTAL BALANCE :  ',bold:true,style:'topRemainingHeader1'},{text:'\n',style:'topRemainingHeader1'}]}]]},layout:{hLineWidth:function hLineWidth(i,node){return i===0||i===node.table.body.length?1:0;},vLineWidth:function vLineWidth(i,node){return i===0||i===node.table.widths.length?1:0;},hLineColor:function hLineColor(i,node){return i===0||i===node.table.body.length?'black':'black';},vLineColor:function vLineColor(i,node){return i===0||i===node.table.widths.length?'black':'black';}}},// End of Previous + current = Total Column
{table:{widths:['*'],body:[[{text:'Authority',style:'emptyHeader1'}]]},layout:'noBorders',style:'tab2'},{table:{widths:['70%','*'],body:[[{text:[]},// {
// 	text:
[{text:''},{text:'Firm Name  ',bold:true,alignment:'center',style:'topFirmAuthority'},{text:'\n\n\n\n\n'},{text:'AUTHORITY SIGNAUTRE  ',bold:true,alignment:'center',style:'topFirmAuthority'},{text:'\n'}]// },
]]},style:'tab2',layout:'noBorders'},{table:{widths:['*'],body:[[{text:'Thank you \n',style:'emptyHeader2'}]]},layout:'noBorders',style:'tab2'}],footer:{columns:[{text:'Powered By ACUIFY',alignment:'right',color:'#160091'}],margin:[10,10]},styles:{header:{fontSize:12,bold:true,alignment:'center'},headerOne:{fontSize:12,bold:true},firmHeaderOne:{fontSize:12,bold:true},firmHeaderOneRight:{fontSize:12,bold:true,alignment:'right'},billHeader:{color:'white',fontSize:12,bold:true,alignment:'left',fillColor:'#15155d'},product:{fontSize:12,alignment:'center'},total:{fontSize:12,alignment:'center',bold:true},productRight:{fontSize:12,alignment:'right'// bold: true
},totalRight:{fontSize:12,alignment:'right',bold:true},topHeader:{color:'white',fontSize:14,alignment:'center',bold:true,fillColor:'#15155d'},topHeader1:{color:'white',fontSize:12,alignment:'left',bold:true,fillColor:'#15155d'},emptyHeader:{color:'white',fillColor:'#15155d',alignment:'left',bold:true},emptyHeader1:{color:'#15155d',fillColor:'#15155d',alignment:'left'},emptyHeader2:{color:'white',fillColor:'#15155d',alignment:'center',bold:true},topTab:{// fillColor: '#ececec',
},tab2Head:{color:'white'// fillColor: '#015155d',
},tab2:{// fillColor: '#ececec',
},topFirmAuthority:{color:'#160091',fontSize:12,bold:true},topFirmAuthorityRight:{color:'#160091',fontSize:14,bold:true,alignment:'right'},topTotalAmount:{color:'#160091',fontSize:12,bold:true},topRemainingHeader:{color:'#FF0000',fontSize:12,bold:true},topRemainingHeader1:{color:'#FF0000',fontSize:10,bold:true},bankDetails:{fontSize:12,bold:true},productHeader:{color:'#160091',fontSize:12,bold:true,alignment:'center'},productHeader1:{fontSize:12,bold:true,alignment:'center'},topHeader11:{color:'#160091',fontSize:10,bold:true},productHeader11:{fontSize:12,color:'#160091',bold:true,alignment:'center'},hiddenTab:{fillColor:'#ffffff',color:'#ffffff'}}//Firm Details 
// pdfDoc.content[1].table.body[0][2].text[1].text = (metaData.firm.name.toUpperCase() ? metaData.firm.name.toUpperCase() : '') + "\n";
};pdfDoc.content[1].table.body[0][2].text[1].text=(metaData.firm&&metaData.firm.name?metaData.firm.name.toUpperCase():'')+"\n";// pdfDoc.content[1].table.body[0][2].text[3].text = (metaData.firm.GST_number ? metaData.firm.GST_number : '') + "\n";
pdfDoc.content[1].table.body[0][2].text[3].text=(metaData.firm.liveAddress?metaData.firm.liveAddress:'')+"\n";pdfDoc.content[1].table.body[0][2].text[5].text=(metaData.firm.address?metaData.firm.address:'')+"\n";pdfDoc.content[1].table.body[0][2].text[7].text=(metaData.firm.mobileNumber?metaData.firm.mobileNumber:'')+"\n";pdfDoc.content[1].table.body[0][2].text[9].text=(metaData.firm.email?metaData.firm.email:'')+"\n";//Receipient Details
// pdfDoc.content[3].table.body[0][1].text[1].text = (metaData.customer.name.toUpperCase() ? metaData.customer.name.toUpperCase() : '') + "\n";
// pdfDoc.content[3].table.body[0][1].text[1].text = ((metaData.customer && metaData.customer.name )? metaData.customer.name.toUpperCase() : '') + "\n";
pdfDoc.content[3].table.body[0][1].text[1].text=getCustomerDetails(metaData,'name').toUpperCase()+"\n";// pdfDoc.content[3].table.body[0][1].text[3].text = (metaData.customer.GST_number ? metaData.customer.GST_number : '') + "\n";
// pdfDoc.content[3].table.body[0][1].text[5].text = (metaData.customer.address ? metaData.customer.address : '') + "\n";
// pdfDoc.content[3].table.body[0][1].text[7].text = (metaData.customer.mobile ? metaData.customer.mobile : '') + "\n";
pdfDoc.content[3].table.body[0][1].text[3].text=(metaData.customer.localAddress?metaData.customer.localAddress:'')+"\n";pdfDoc.content[3].table.body[0][1].text[5].text=getCustomerDetails(metaData,'address')+"\n";pdfDoc.content[3].table.body[0][1].text[7].text=getCustomerDetails(metaData,'mobile').toUpperCase()+"\n";pdfDoc.content[3].table.body[0][1].text[9].text=(metaData.invoiceData.placeOfSupply?metaData.invoiceData.placeOfSupply:'')+"\n";pdfDoc.content[3].table.body[0][1].text[11].text=(metaData.customer.stateCode?metaData.customer.stateCode:'')+"\n";//Invoice Details
date=new Date(metaData.invoiceData.date);paymentDueDate=date.setDate(date.getDate()+(metaData.invoiceData.duration?parseInt(metaData.invoiceData.duration):0));pdfDoc.content[3].table.body[0][2].text[1].text=metaData.invoiceData.invoiceId+"\n";pdfDoc.content[3].table.body[0][2].text[3].text=new Date(metaData.invoiceData.date).toLocaleDateString('en-GB').toString()+"\n";pdfDoc.content[3].table.body[0][2].text[5].text=(metaData.invoiceData.status?metaData.invoiceData.status.toUpperCase():'')+"\n";pdfDoc.content[3].table.body[0][2].text[7].text=new Date(paymentDueDate).toLocaleDateString('en-GB').toString()+"\n";pdfDoc.content[3].table.body[0][2].text[9].text=(metaData.invoiceData.remark?metaData.invoiceData.remark:'')+"\n";//Products
productList=convertToPDFProducts(metaData.invoiceData.items,false,metaData.invoiceData,metaData);productList.map(function(item){pdfDoc.content[5].table.body.push(item);});// Payment Details
// pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text[1].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";
// pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text[3].text = (metaData.invoiceData.transactionType ? metaData.invoiceData.transactionType : '') + "\n";
// Bank Details
if(metaData.terms.banks.length){metaData.terms.banks.map(function(bankDetails){pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({text:bankDetails.bankName+" \n",style:"bankDetails"});pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({text:"NAME: "+bankDetails.accountHolderName+"\n",style:'bankDetails'});pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({text:"A/C No: "+bankDetails.accountnumber+"\n",style:"bankDetails"});pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({text:"IFSC: "+bankDetails.ifsccode+"\n",style:"bankDetails"});pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({text:bankDetails.address+" \n",style:"bankDetails"});});}// Terms and cond
pdfDoc.content[6].table.body[0][0][3].table.body[0][1]=metaData.terms.termsAndConditions;// gst details
// pdfDoc.content[6].table.body[0][1].text[1].text = ((metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount ? Number.parseFloat(metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount).toFixed(2) - Number.parseFloat(metaData.gstTotal.CGST_val + metaData.gstTotal.SGST_val + metaData.gstTotal.IGST_val).toFixed(2) : '0')).toFixed(2) + "\n";
pdfDoc.content[6].table.body[0][1].text[1].text=(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalAmount)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.discountAmount||0)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?0:-__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraCharges))-__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraChargesGST):0)-__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.roundOffAmount||0)-(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.SGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.CGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.IGST_val))).toFixed(2)+"\n";offset=0;if(!metaData.invoiceData.gstOnExtraChanrges&&metaData.invoiceData.extraCharges&&metaData.invoiceData.extraCharges.length){metaData.invoiceData.extraCharges.map(function(charge){pdfDoc.content[6].table.body[0][1].text.splice(2+offset,0,{text:''+charge.name+' :   ',bold:true,style:'headerOne'});offset++;pdfDoc.content[6].table.body[0][1].text.splice(2+offset,0,{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(charge.amount).toFixed(2)+'\n',style:'headerOne'});offset++;});}// pdfDoc.content[6].table.body[0][1].text[3].text = (metaData.invoiceData.labourAmount ? Number.parseFloat(metaData.invoiceData.labourAmount).toFixed(2) : '0.00') + "\n";
pdfDoc.content[6].table.body[0][1].text[3+offset].text=(metaData.invoiceData.discountAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.discountAmount).toFixed(2):'0.00')+"\n";pdfDoc.content[6].table.body[0][1].text[5+offset].text=(metaData.invoiceData.roundOffAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.roundOffAmount).toFixed(2):'0.00')+"\n";// pdfDoc.content[6].table.body[0][1].text[9].text = (metaData.invoiceData.totalAmount ? Number.parseFloat(metaData.invoiceData.totalAmount).toFixed(2) : '0') + "\n";
// pdfDoc.content[6].table.body[0][1].text[9].text = (metaData.invoiceData.totalAmount + metaData.invoiceData.labourAmount -  metaData.invoiceData.discountAmount ? Number.parseFloat(Number.parseFloat(metaData.invoiceData.totalAmount) + Number.parseFloat(metaData.invoiceData.labourAmount) - Number.parseFloat(metaData.invoiceData.discountAmount)).toFixed(2) : '0') + "\n";
pdfDoc.content[6].table.body[0][1].text[7+offset].text=(metaData.invoiceData.totalAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalAmount):'0.00').toFixed(2)+"\n";pdfDoc.content[6].table.body[0][1].text[9+offset].text=(metaData.invoiceData.paidAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.paidAmount).toFixed(2):'0.00')+"\n";pdfDoc.content[6].table.body[0][1].text[11+offset].text=(metaData.invoiceData.remainingAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.remainingAmount).toFixed(2):'0.00')+"\n";// pdfDoc.content[6].table.body[0][1].text[17].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";
// if(metaData.invoiceData.extraCharges && metaData.invoiceData.extraCharges.length) {
// 	metaData.invoiceData.extraCharges.map((charge)=>{
// 				pdfDoc.content[6].table.body[0][1].text.push({ text: ''+charge.name+':-          ', bold: true })
// 				pdfDoc.content[6].table.body[0][1].text.push({ text:charge.amount+'\n' })
// 	})
// }
// Overall Balance
if(metaData.balance&&metaData.terms.isPreviousCurrentTotalBalance){pdfDoc.content[8].table.body[1][0].text[1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.balance)-__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.remainingAmount).toFixed(2)).toFixed(2)+"\n";pdfDoc.content[8].table.body[1][1].text[1].text=(metaData.invoiceData.remainingAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.remainingAmount).toFixed(2):'0.00')+"\n";pdfDoc.content[8].table.body[1][2].text[1].text=(metaData.balance?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.balance).toFixed(2):'0.00')+"\n";}else{pdfDoc.content[8]={};pdfDoc.content[7]={};}// authority
pdfDoc.content[10].table.body[0][1][1].text=metaData.firm.name?metaData.firm.name.toUpperCase():'';// thank you
// pdfDoc.content[9].table.body[0][0].text =  "Thank You " + (metaData.customer.name.toUpperCase() ? metaData.customer.name.toUpperCase() : '') +" For Choosing us!" 
// pdfDoc.content[9].table.body[0][0].text =  metaData.terms.termsAndConditions.greetingMessage || ("Thank You " + ((metaData.customer && metaData.customer.name )? metaData.customer.name.toUpperCase() : '') +" For Choosing us!" )
pdfDoc.content[11].table.body[0][0].text=metaData.terms.greetingMessage||"Thank You "+getCustomerDetails(metaData,'name').toUpperCase()+" for doing business with us!";if(!metaData.terms.isBlankHeader){_context5.next=40;break;}pdfDoc.content[1].table.body[0][1]={text:''};pdfDoc.content[1].style='hiddenTab';pdfDoc.content[1].table.body[0][2].text[1].style='hiddenTab';_context5.next=120;break;case 40:if(!metaData.terms.printLogo){_context5.next=88;break;}_context5.prev=41;_context5.next=44;return getBase64ImageFromURL(metaData.terms.printLogo);case 44:logoData=_context5.sent;pdfDoc.content[1].table.body[0][1].image=logoData;invoiceImages=document.getElementById('invoiceImages');if(!(invoiceImages&&invoiceImages.files&&invoiceImages.files.length)){_context5.next=71;break;}temp={columns:[]};if(!invoiceImages.files[0]){_context5.next=56;break;}_context5.t0=temp.columns;_context5.next=53;return toBase64(invoiceImages.files[0]).catch(function(e){return Error(e);});case 53:_context5.t1=_context5.sent;_context5.t2={image:_context5.t1,width:150};_context5.t0.push.call(_context5.t0,_context5.t2);case 56:if(!invoiceImages.files[1]){_context5.next=63;break;}_context5.t3=temp.columns;_context5.next=60;return toBase64(invoiceImages.files[1]).catch(function(e){return Error(e);});case 60:_context5.t4=_context5.sent;_context5.t5={image:_context5.t4,width:150};_context5.t3.push.call(_context5.t3,_context5.t5);case 63:if(!invoiceImages.files[2]){_context5.next=70;break;}_context5.t6=temp.columns;_context5.next=67;return toBase64(invoiceImages.files[2]).catch(function(e){return Error(e);});case 67:_context5.t7=_context5.sent;_context5.t8={image:_context5.t7,width:150};_context5.t6.push.call(_context5.t6,_context5.t8);case 70:pdfDoc.content.push(temp);case 71:if(!metaData.terms.signature){_context5.next=80;break;}_temp13={columns:[]};_context5.t9=_temp13.columns;_context5.next=76;return getBase64ImageFromURL(metaData.terms.signature);case 76:_context5.t10=_context5.sent;_context5.t11={image:_context5.t10,width:150,height:40,alignment:'right'};_context5.t9.push.call(_context5.t9,_context5.t11);//pdfDoc.content.push(temp)
pdfDoc.content[10].table.body[0][1][2]=_temp13.columns[0];case 80:return _context5.abrupt("return",pdfDoc);case 83:_context5.prev=83;_context5.t12=_context5["catch"](41);console.log(_context5.t12);case 86:_context5.next=120;break;case 88:imgToExport=document.getElementById('pdfimgToExport');canvas=document.createElement('canvas');canvas.width=imgToExport.width;canvas.height=imgToExport.height;canvas.getContext('2d').drawImage(imgToExport,0,0);base64=canvas.toDataURL('image/png');pdfDoc.content[1].table.body[0][1].image=base64;_invoiceImages5=document.getElementById('invoiceImages');if(!(_invoiceImages5&&_invoiceImages5.files&&_invoiceImages5.files.length)){_context5.next=120;break;}_temp14={columns:[]};if(!_invoiceImages5.files[0]){_context5.next=105;break;}_context5.t13=_temp14.columns;_context5.next=102;return toBase64(_invoiceImages5.files[0]).catch(function(e){return Error(e);});case 102:_context5.t14=_context5.sent;_context5.t15={image:_context5.t14,width:150};_context5.t13.push.call(_context5.t13,_context5.t15);case 105:if(!_invoiceImages5.files[1]){_context5.next=112;break;}_context5.t16=_temp14.columns;_context5.next=109;return toBase64(_invoiceImages5.files[1]).catch(function(e){return Error(e);});case 109:_context5.t17=_context5.sent;_context5.t18={image:_context5.t17,width:150};_context5.t16.push.call(_context5.t16,_context5.t18);case 112:if(!_invoiceImages5.files[2]){_context5.next=119;break;}_context5.t19=_temp14.columns;_context5.next=116;return toBase64(_invoiceImages5.files[2]).catch(function(e){return Error(e);});case 116:_context5.t20=_context5.sent;_context5.t21={image:_context5.t20,width:150};_context5.t19.push.call(_context5.t19,_context5.t21);case 119:pdfDoc.content.push(_temp14);case 120:if(!metaData.terms.signature){_context5.next=129;break;}_temp15={columns:[]};_context5.t22=_temp15.columns;_context5.next=125;return getBase64ImageFromURL(metaData.terms.signature);case 125:_context5.t23=_context5.sent;_context5.t24={image:_context5.t23,width:150,height:40,alignment:'right'};_context5.t22.push.call(_context5.t22,_context5.t24);//pdfDoc.content.push(temp)
pdfDoc.content[10].table.body[0][1][2]=_temp15.columns[0];case 129:return _context5.abrupt("return",pdfDoc);case 130:case"end":return _context5.stop();}}},_callee5,_this,[[41,83]]);}));return function convertToBasicInvoiceWithoutGST(_x5){return _ref5.apply(this,arguments);};}();// End of Without GST Invoice-Format
// New Format Without GST For Dairy Business 
var convertToBasicInvoiceForDairyWithoutGST=function(){var _ref6=__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6(metaData){var pdfDoc,date,paymentDueDate,productList,offset,logoData,invoiceImages,temp,_temp16,imgToExport,canvas,base64,_invoiceImages6,_temp17,_temp18;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:pdfDoc={content:[{table:{widths:['*'],body:[[{text:'INVOICE',style:"topHeader"}]]},layout:'noBorders'},{table:{widths:['0%','48%','*'],body:[[{text:''},{image:'',width:140,height:100},{text:[{text:' ',bold:true,style:'topFirmAuthorityRight'},{text:'\n',style:'topFirmAuthorityRight'},{text:'',bold:true,style:'firmHeaderOneRight'},{text:'88776655\n',style:'firmHeaderOneRight'},// { text: ' ', bold: true, style: 'icon' },
// { text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \nRight'},
{text:'',bold:true,style:'firmHeaderOneRight'},{text:'88776655\n',style:'firmHeaderOneRight'},{text:'',bold:true,style:'firmHeaderOneRight'},//icon gift
{text:'njnjn@jnn.com\n',style:'firmHeaderOneRight'},{text:' ',bold:true,style:'firmHeaderOneRight'},{text:'123456\n',style:'firmHeaderOneRight'}]}]]},layout:'noBorders',style:"topTab"},{table:{widths:['60%','*'],body:[[{text:'BILL TO',style:"billHeader"},{text:'INVOICE DETAILS',style:"billHeader"}]]},style:'tab2Head',layout:'noBorders'},{table:{widths:['0%','55%','*'],body:[[{text:''},{text:[{text:' ',bold:true,style:'topFirmAuthority'},{text:'Google\n',style:'topFirmAuthority'},{text:' ',bold:true,style:'firmHeaderOne'},{text:'1679905\n',style:'firmHeaderOne'},{text:'  ',bold:true,style:'firmHeaderOne'},{text:'7788996655\n',style:'firmHeaderOne'},{text:'Mobile Number :   ',bold:true,style:'firmHeaderOne'},{text:'1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n',style:'firmHeaderOne'},{text:'Place of Supply :   ',bold:true,style:'firmHeaderOne'},{text:'13/12/90\n',style:'firmHeaderOne'},{text:'State Code         :   ',bold:true,style:'firmHeaderOne'},{text:'23\n',style:'firmHeaderOne'}]},{text:[{text:'Invoice No                :   ',bold:true,style:'firmHeaderOne'},{text:'787878\n',style:'firmHeaderOne'},{text:'Invoice Date             :   ',bold:true,style:'firmHeaderOne'},{text:'12/12/90 \n',style:'firmHeaderOne'},{text:'Invoice Status          :   ',bold:true,style:'topRemainingHeader'},{text:'12/12/90 \n',style:'topRemainingHeader'},{text:'Payment Due Date  :   ',bold:true,style:'firmHeaderOne'},{text:'13/12/90\n',style:'firmHeaderOne'}]}]]},style:'tab2',layout:'noBorders'},{table:{widths:['*','*'],body:[[{text:'ITEMS',style:"emptyHeader1"},{text:'',style:"emptyHeader1"}]]},layout:'noBorders'},{table:{body:[[{text:'S.NO',style:"productHeader11",rowSpan:2},{text:'DESCRIPTION OF PRODUCTS',style:"productHeader11",rowSpan:2},// { text: 'HSN/SAC', style: "productHeader1", rowSpan: 2 },
{text:'QUANTITY',style:"productHeader11",rowSpan:2},{text:'UNITS',style:"productHeader11",rowSpan:2},{text:'FAT',style:"productHeader11",rowSpan:2},{text:'PRODUCTS RATE',style:"productHeader11",rowSpan:2},// { text: 'Basic  Amount', style: "productHeader", rowSpan: 2 },
{text:'TOTAL AMOUNT',style:"productHeader11",rowSpan:2}],[{text:'S.NO',style:"productHeader11"},{text:'DESCRIPTION OF PRODUCTS',style:"productHeader11"},// { text: 'HSN/SAC', style: "productHeader1" },
{text:'QUANTITY',style:"productHeader11"},{text:'UNITS',style:"productHeader11"},{text:'FAT',style:"productHeader11",rowSpan:2},{text:'PRODUCTS RATE',style:"productHeader11"},// { text: 'Basic Amount', style: "productHeader" },
{text:'TOTAL AMOUNT',style:"productHeader11"}]]}},{table:{widths:['65%','*'],body:[[[{table:{widths:['*'],body:[[{text:'PAYMENT DETAILS',style:"topHeader1"}]]},style:'tab2Head',layout:'noBorders'},{table:{widths:['3%','*'],body:[[{text:''},{text:[]}]]},style:'tab2',layout:'noBorders'},{table:{widths:['*'],body:[[{text:'TERMS & CONDITIONS',style:"topHeader1"}]]},style:'tab2Head',layout:'noBorders'},{table:{widths:['3%','*'],body:[[{text:''},{text:""}]]},style:'tab2',layout:'noBorders'}],{text:[{text:'Basic Amount   :   ',bold:true,style:'headerOne'},{text:'12122\n',style:'headerOne'},// { text: 'Labour Charge:      ', bold: true, style:'headerOne' },
// { text: '12122\n', style:'headerOne' },
{text:'Discount            :   ',bold:true,style:'headerOne'},{text:'12122\n',style:'headerOne'},{text:'RoundOff           :   ',bold:true,style:'headerOne'},{text:'12122\n',style:'headerOne'},{text:'Total Amount    :   ',bold:true,style:'topTotalAmount'},{text:'12122\n',style:'topTotalAmount'},{text:'Paid Amount     :   ',bold:true,style:'headerOne'},{text:'12122\n',style:'headerOne'},{text:'Due Amount      :   ',bold:true,style:'topRemainingHeader'},{text:'12122\n',style:'topRemainingHeader'}]}]]},style:'tab2',layout:'lightHorizontalLines'},{table:{widths:['*','*'],body:[[{text:'OUTSTANDING DETAILS',style:"emptyHeader"},{text:'he',style:"emptyHeader1"}]]},layout:'noBorders'},// Start of Previous + current = Total Column
{table:{widths:['34%','39%','27%'],body:[[{text:'',style:"topBlankHeader"},{text:'',style:"topMainHeader"},{text:'',style:"topBlankHeader"}],[{text:[{text:'PREVIOUS BALANCE :  ',bold:true,style:'topHeader11'},{text:'\n',style:'topHeader11'}]},{text:[{text:'CURRENT BALANCE :  ',bold:true,style:'topHeader11'},{text:'\n',style:'topHeader11'}]},{text:[{text:'TOTAL BALANCE :  ',bold:true,style:'topRemainingHeader1'},{text:'\n',style:'topRemainingHeader1'}]}]]},layout:{hLineWidth:function hLineWidth(i,node){return i===0||i===node.table.body.length?1:0;},vLineWidth:function vLineWidth(i,node){return i===0||i===node.table.widths.length?1:0;},hLineColor:function hLineColor(i,node){return i===0||i===node.table.body.length?'black':'black';},vLineColor:function vLineColor(i,node){return i===0||i===node.table.widths.length?'black':'black';}}},// End of Previous + current = Total Column
{table:{widths:['*'],body:[[{text:'Authority',style:'emptyHeader1'}]]},layout:'noBorders',style:'tab2'},{table:{widths:['70%','*'],body:[[{text:[]},// {
// 	text:
[{text:''},{text:'Firm Name  ',bold:true,alignment:'center',style:'topFirmAuthority'},{text:'\n\n\n\n\n'},{text:'AUTHORITY SIGNAUTRE  ',bold:true,alignment:'center',style:'topFirmAuthority'},{text:'\n'}]// },
]]},style:'tab2',layout:'noBorders'},{table:{widths:['*'],body:[[{text:'Thank you \n',style:'emptyHeader2'}]]},layout:'noBorders',style:'tab2'}],footer:{columns:[{text:'Powered By ACUIFY',alignment:'right',color:'#160091'}],margin:[10,10]},styles:{header:{fontSize:12,bold:true,alignment:'center'},headerOne:{fontSize:12,bold:true},firmHeaderOne:{fontSize:12,bold:true},firmHeaderOneRight:{fontSize:12,bold:true,alignment:'right'},billHeader:{color:'white',fontSize:12,bold:true,alignment:'left',fillColor:'#15155d'},product:{fontSize:12,alignment:'center'},total:{fontSize:12,alignment:'center',bold:true},productRight:{fontSize:12,alignment:'right'// bold: true
},totalRight:{fontSize:12,alignment:'right',bold:true},topHeader:{color:'white',fontSize:14,alignment:'center',bold:true,fillColor:'#15155d'},topHeader1:{color:'white',fontSize:12,alignment:'left',bold:true,fillColor:'#15155d'},emptyHeader:{color:'white',fillColor:'#15155d',alignment:'left',bold:true},emptyHeader1:{color:'#15155d',fillColor:'#15155d',alignment:'left'},emptyHeader2:{color:'white',fillColor:'#15155d',alignment:'center',bold:true},topTab:{// fillColor: '#ececec',
},tab2Head:{color:'white'// fillColor: '#015155d',
},tab2:{// fillColor: '#ececec',
},topFirmAuthority:{color:'#160091',fontSize:12,bold:true},topFirmAuthorityRight:{color:'#160091',fontSize:14,bold:true,alignment:'right'},topTotalAmount:{color:'#160091',fontSize:12,bold:true},topRemainingHeader:{color:'#FF0000',fontSize:12,bold:true},topRemainingHeader1:{color:'#FF0000',fontSize:10,bold:true},bankDetails:{fontSize:12,bold:true},productHeader:{color:'#160091',fontSize:12,bold:true,alignment:'center'},productHeader1:{fontSize:12,bold:true,alignment:'center'},topHeader11:{color:'#160091',fontSize:10,bold:true},productHeader11:{fontSize:12,color:'#160091',bold:true,alignment:'center'},hiddenTab:{fillColor:'#ffffff',color:'#ffffff'}}//Firm Details 
// pdfDoc.content[1].table.body[0][2].text[1].text = (metaData.firm.name.toUpperCase() ? metaData.firm.name.toUpperCase() : '') + "\n";
};pdfDoc.content[1].table.body[0][2].text[1].text=(metaData.firm&&metaData.firm.name?metaData.firm.name.toUpperCase():'')+"\n";// pdfDoc.content[1].table.body[0][2].text[3].text = (metaData.firm.GST_number ? metaData.firm.GST_number : '') + "\n";
pdfDoc.content[1].table.body[0][2].text[3].text=(metaData.firm.liveAddress?metaData.firm.liveAddress:'')+"\n";pdfDoc.content[1].table.body[0][2].text[5].text=(metaData.firm.address?metaData.firm.address:'')+"\n";pdfDoc.content[1].table.body[0][2].text[7].text=(metaData.firm.mobileNumber?metaData.firm.mobileNumber:'')+"\n";pdfDoc.content[1].table.body[0][2].text[9].text=(metaData.firm.email?metaData.firm.email:'')+"\n";//Receipient Details
// pdfDoc.content[3].table.body[0][1].text[1].text = (metaData.customer.name.toUpperCase() ? metaData.customer.name.toUpperCase() : '') + "\n";
// pdfDoc.content[3].table.body[0][1].text[1].text = ((metaData.customer && metaData.customer.name )? metaData.customer.name.toUpperCase() : '') + "\n";
pdfDoc.content[3].table.body[0][1].text[1].text=getCustomerDetails(metaData,'name').toUpperCase()+"\n";// pdfDoc.content[3].table.body[0][1].text[3].text = (metaData.customer.GST_number ? metaData.customer.GST_number : '') + "\n";
// pdfDoc.content[3].table.body[0][1].text[5].text = (metaData.customer.address ? metaData.customer.address : '') + "\n";
// pdfDoc.content[3].table.body[0][1].text[7].text = (metaData.customer.mobile ? metaData.customer.mobile : '') + "\n";
pdfDoc.content[3].table.body[0][1].text[3].text=(metaData.customer.localAddress?metaData.customer.localAddress:'')+"\n";pdfDoc.content[3].table.body[0][1].text[5].text=getCustomerDetails(metaData,'address')+"\n";pdfDoc.content[3].table.body[0][1].text[7].text=getCustomerDetails(metaData,'mobile').toUpperCase()+"\n";pdfDoc.content[3].table.body[0][1].text[9].text=(metaData.invoiceData.placeOfSupply?metaData.invoiceData.placeOfSupply:'')+"\n";pdfDoc.content[3].table.body[0][1].text[11].text=(metaData.customer.stateCode?metaData.customer.stateCode:'')+"\n";//Invoice Details
date=new Date(metaData.invoiceData.date);paymentDueDate=date.setDate(date.getDate()+(metaData.invoiceData.duration?parseInt(metaData.invoiceData.duration):0));pdfDoc.content[3].table.body[0][2].text[1].text=metaData.invoiceData.invoiceId+"\n";pdfDoc.content[3].table.body[0][2].text[3].text=new Date(metaData.invoiceData.date).toLocaleDateString('en-GB').toString()+"\n";pdfDoc.content[3].table.body[0][2].text[5].text=(metaData.invoiceData.status?metaData.invoiceData.status.toUpperCase():'')+"\n";pdfDoc.content[3].table.body[0][2].text[7].text=new Date(paymentDueDate).toLocaleDateString('en-GB').toString()+"\n";//Products
productList=convertToDairyPDFProducts(metaData.invoiceData.items,false,metaData.invoiceData,metaData);productList.map(function(item){pdfDoc.content[5].table.body.push(item);});// Payment Details
// pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text[1].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";
// pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text[3].text = (metaData.invoiceData.transactionType ? metaData.invoiceData.transactionType : '') + "\n";
// Bank Details
if(metaData.terms.banks.length){metaData.terms.banks.map(function(bankDetails){pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({text:bankDetails.bankName+" \n",style:"bankDetails"});pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({text:"NAME: "+bankDetails.accountHolderName+"\n",style:'bankDetails'});pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({text:"A/C No: "+bankDetails.accountnumber+"\n",style:"bankDetails"});pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({text:"IFSC: "+bankDetails.ifsccode+"\n",style:"bankDetails"});pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({text:bankDetails.address+" \n",style:"bankDetails"});});}// Terms and cond
pdfDoc.content[6].table.body[0][0][3].table.body[0][1]=metaData.terms.termsAndConditions;// gst details
// pdfDoc.content[6].table.body[0][1].text[1].text = ((metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount ? Number.parseFloat(metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount).toFixed(2) - Number.parseFloat(metaData.gstTotal.CGST_val + metaData.gstTotal.SGST_val + metaData.gstTotal.IGST_val).toFixed(2) : '0')).toFixed(2) + "\n";
pdfDoc.content[6].table.body[0][1].text[1].text=(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalAmount)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.discountAmount||0)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?0:-__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraCharges))-__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraChargesGST):0)-__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.roundOffAmount||0)-(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.SGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.CGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.IGST_val))).toFixed(2)+"\n";offset=0;if(!metaData.invoiceData.gstOnExtraChanrges&&metaData.invoiceData.extraCharges&&metaData.invoiceData.extraCharges.length){metaData.invoiceData.extraCharges.map(function(charge){pdfDoc.content[6].table.body[0][1].text.splice(2+offset,0,{text:''+charge.name+' :   ',bold:true,style:'headerOne'});offset++;pdfDoc.content[6].table.body[0][1].text.splice(2+offset,0,{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(charge.amount).toFixed(2)+'\n',style:'headerOne'});offset++;});}// pdfDoc.content[6].table.body[0][1].text[3].text = (metaData.invoiceData.labourAmount ? Number.parseFloat(metaData.invoiceData.labourAmount).toFixed(2) : '0.00') + "\n";
pdfDoc.content[6].table.body[0][1].text[3+offset].text=(metaData.invoiceData.discountAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.discountAmount).toFixed(2):'0.00')+"\n";pdfDoc.content[6].table.body[0][1].text[5+offset].text=(metaData.invoiceData.roundOffAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.roundOffAmount).toFixed(2):'0.00')+"\n";// pdfDoc.content[6].table.body[0][1].text[9].text = (metaData.invoiceData.totalAmount ? Number.parseFloat(metaData.invoiceData.totalAmount).toFixed(2) : '0') + "\n";
// pdfDoc.content[6].table.body[0][1].text[9].text = (metaData.invoiceData.totalAmount + metaData.invoiceData.labourAmount -  metaData.invoiceData.discountAmount ? Number.parseFloat(Number.parseFloat(metaData.invoiceData.totalAmount) + Number.parseFloat(metaData.invoiceData.labourAmount) - Number.parseFloat(metaData.invoiceData.discountAmount)).toFixed(2) : '0') + "\n";
pdfDoc.content[6].table.body[0][1].text[7+offset].text=(metaData.invoiceData.totalAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalAmount):'0.00').toFixed(2)+"\n";pdfDoc.content[6].table.body[0][1].text[9+offset].text=(metaData.invoiceData.paidAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.paidAmount).toFixed(2):'0.00')+"\n";pdfDoc.content[6].table.body[0][1].text[11+offset].text=(metaData.invoiceData.remainingAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.remainingAmount).toFixed(2):'0.00')+"\n";// pdfDoc.content[6].table.body[0][1].text[17].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";
// if(metaData.invoiceData.extraCharges && metaData.invoiceData.extraCharges.length) {
// 	metaData.invoiceData.extraCharges.map((charge)=>{
// 				pdfDoc.content[6].table.body[0][1].text.push({ text: ''+charge.name+':-          ', bold: true })
// 				pdfDoc.content[6].table.body[0][1].text.push({ text:charge.amount+'\n' })
// 	})
// }
// Overall Balance
if(metaData.balance&&metaData.terms.isPreviousCurrentTotalBalance){pdfDoc.content[8].table.body[1][0].text[1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.balance)-__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.remainingAmount).toFixed(2)).toFixed(2)+"\n";pdfDoc.content[8].table.body[1][1].text[1].text=(metaData.invoiceData.remainingAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.remainingAmount).toFixed(2):'0.00')+"\n";pdfDoc.content[8].table.body[1][2].text[1].text=(metaData.balance?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.balance).toFixed(2):'0.00')+"\n";}else{pdfDoc.content[8]={};pdfDoc.content[7]={};}// authority
pdfDoc.content[10].table.body[0][1][1].text=metaData.firm.name?metaData.firm.name.toUpperCase():'';// thank you
// pdfDoc.content[9].table.body[0][0].text =  "Thank You " + (metaData.customer.name.toUpperCase() ? metaData.customer.name.toUpperCase() : '') +" For Choosing us!" 
// pdfDoc.content[9].table.body[0][0].text =  metaData.terms.termsAndConditions.greetingMessage || ("Thank You " + ((metaData.customer && metaData.customer.name )? metaData.customer.name.toUpperCase() : '') +" For Choosing us!" )
pdfDoc.content[11].table.body[0][0].text=metaData.terms.greetingMessage||"Thank You "+getCustomerDetails(metaData,'name').toUpperCase()+" for doing business with us!";if(!metaData.terms.isBlankHeader){_context6.next=39;break;}pdfDoc.content[1].table.body[0][1]={text:''};pdfDoc.content[1].style='hiddenTab';pdfDoc.content[1].table.body[0][2].text[1].style='hiddenTab';_context6.next=119;break;case 39:if(!metaData.terms.printLogo){_context6.next=87;break;}_context6.prev=40;_context6.next=43;return getBase64ImageFromURL(metaData.terms.printLogo);case 43:logoData=_context6.sent;pdfDoc.content[1].table.body[0][1].image=logoData;invoiceImages=document.getElementById('invoiceImages');if(!(invoiceImages&&invoiceImages.files&&invoiceImages.files.length)){_context6.next=70;break;}temp={columns:[]};if(!invoiceImages.files[0]){_context6.next=55;break;}_context6.t0=temp.columns;_context6.next=52;return toBase64(invoiceImages.files[0]).catch(function(e){return Error(e);});case 52:_context6.t1=_context6.sent;_context6.t2={image:_context6.t1,width:150};_context6.t0.push.call(_context6.t0,_context6.t2);case 55:if(!invoiceImages.files[1]){_context6.next=62;break;}_context6.t3=temp.columns;_context6.next=59;return toBase64(invoiceImages.files[1]).catch(function(e){return Error(e);});case 59:_context6.t4=_context6.sent;_context6.t5={image:_context6.t4,width:150};_context6.t3.push.call(_context6.t3,_context6.t5);case 62:if(!invoiceImages.files[2]){_context6.next=69;break;}_context6.t6=temp.columns;_context6.next=66;return toBase64(invoiceImages.files[2]).catch(function(e){return Error(e);});case 66:_context6.t7=_context6.sent;_context6.t8={image:_context6.t7,width:150};_context6.t6.push.call(_context6.t6,_context6.t8);case 69:pdfDoc.content.push(temp);case 70:if(!metaData.terms.signature){_context6.next=79;break;}_temp16={columns:[]};_context6.t9=_temp16.columns;_context6.next=75;return getBase64ImageFromURL(metaData.terms.signature);case 75:_context6.t10=_context6.sent;_context6.t11={image:_context6.t10,width:150,height:40,alignment:'right'};_context6.t9.push.call(_context6.t9,_context6.t11);//pdfDoc.content.push(temp)
pdfDoc.content[10].table.body[0][1][2]=_temp16.columns[0];case 79:return _context6.abrupt("return",pdfDoc);case 82:_context6.prev=82;_context6.t12=_context6["catch"](40);console.log(_context6.t12);case 85:_context6.next=119;break;case 87:imgToExport=document.getElementById('pdfimgToExport');canvas=document.createElement('canvas');canvas.width=imgToExport.width;canvas.height=imgToExport.height;canvas.getContext('2d').drawImage(imgToExport,0,0);base64=canvas.toDataURL('image/png');pdfDoc.content[1].table.body[0][1].image=base64;_invoiceImages6=document.getElementById('invoiceImages');if(!(_invoiceImages6&&_invoiceImages6.files&&_invoiceImages6.files.length)){_context6.next=119;break;}_temp17={columns:[]};if(!_invoiceImages6.files[0]){_context6.next=104;break;}_context6.t13=_temp17.columns;_context6.next=101;return toBase64(_invoiceImages6.files[0]).catch(function(e){return Error(e);});case 101:_context6.t14=_context6.sent;_context6.t15={image:_context6.t14,width:150};_context6.t13.push.call(_context6.t13,_context6.t15);case 104:if(!_invoiceImages6.files[1]){_context6.next=111;break;}_context6.t16=_temp17.columns;_context6.next=108;return toBase64(_invoiceImages6.files[1]).catch(function(e){return Error(e);});case 108:_context6.t17=_context6.sent;_context6.t18={image:_context6.t17,width:150};_context6.t16.push.call(_context6.t16,_context6.t18);case 111:if(!_invoiceImages6.files[2]){_context6.next=118;break;}_context6.t19=_temp17.columns;_context6.next=115;return toBase64(_invoiceImages6.files[2]).catch(function(e){return Error(e);});case 115:_context6.t20=_context6.sent;_context6.t21={image:_context6.t20,width:150};_context6.t19.push.call(_context6.t19,_context6.t21);case 118:pdfDoc.content.push(_temp17);case 119:if(!metaData.terms.signature){_context6.next=128;break;}_temp18={columns:[]};_context6.t22=_temp18.columns;_context6.next=124;return getBase64ImageFromURL(metaData.terms.signature);case 124:_context6.t23=_context6.sent;_context6.t24={image:_context6.t23,width:150,height:40,aligment:'right'};_context6.t22.push.call(_context6.t22,_context6.t24);//pdfDoc.content.push(temp)
pdfDoc.content[10].table.body[0][1][2]=_temp18.columns[0];case 128:return _context6.abrupt("return",pdfDoc);case 129:case"end":return _context6.stop();}}},_callee6,_this,[[40,82]]);}));return function convertToBasicInvoiceForDairyWithoutGST(_x6){return _ref6.apply(this,arguments);};}();// End of New Format Without GST For Dairy Business 
// Start of New Photo Resize Format Third
var convertToBasicShortInvoiceWithoutGST=function(){var _ref7=__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7(metaData){var pdfDoc,date,paymentDueDate,productList,logoData,invoiceImages,temp,imgToExport,canvas,base64,_invoiceImages7,_temp19;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:pdfDoc={content:[{table:{widths:['*'],body:[[{text:'INVOICE',style:"topHeader"}]]},layout:'noBorders'},{table:{widths:['0%','20%','35%','5%','40%'],body:[[{text:''},{image:'',width:100,height:100},{text:[{text:' ',bold:true,style:'topFirmAuthorityRight'},{text:'\n',style:'topFirmAuthorityRight'},{text:'',bold:true,style:'firmHeaderOneRight'},{text:'88776655\n',style:'firmHeaderOneRight'},// { text: ' ', bold: true, style: 'icon' },
// { text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \nRight'},
{text:'',bold:true,style:'firmHeaderOneRight'},{text:'88776655\n',style:'firmHeaderOneRight'},{text:'',bold:true,style:'firmHeaderOneRight'},//icon gift
{text:'njnjn@jnn.com\n',style:'firmHeaderOneRight'},{text:' ',bold:true,style:'firmHeaderOneRight'},{text:'123456\n',style:'firmHeaderOneRight'}]},{text:''},{text:[{text:' ',bold:true,style:'topFirmAuthority'},{text:'Google\n',style:'topFirmAuthority'},{text:' ',bold:true,style:'firmHeaderOne'},{text:'1679905\n',style:'firmHeaderOne'},{text:'  ',bold:true,style:'firmHeaderOne'},{text:'7788996655\n',style:'firmHeaderOne'},{text:'Mobile Number :   ',bold:true,style:'firmHeaderOne'},{text:'1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n',style:'firmHeaderOne'},{text:'Place of Supply :   ',bold:true,style:'firmHeaderOne'},{text:'13/12/90\n',style:'firmHeaderOne'},{text:'State Code         :   ',bold:true,style:'firmHeaderOne'},{text:'23\n',style:'firmHeaderOne'},{text:'Remark               :   ',bold:true,style:'firmHeaderOne'},{text:'787878\n',style:'firmHeaderOne'}]}]]},layout:'noBorders',style:"topTab"},{table:{widths:['33%','33%','33%'],body:[[{text:'',style:"billHeader"},{text:'INVOICE DETAILS',style:"billHeader"},{text:'',style:"billHeader"}]]},style:'tab2Head',layout:'noBorders'},{table:{widths:['0%','38%','34%','28%'],body:[[{text:''},// {
// 	text:
// 		[
// 			{ text: ' ', bold: true, style: 'topFirmAuthority' },
// 			{ text: 'Google\n', style: 'topFirmAuthority' },
// 			{ text: ' ', bold: true, style: 'firmHeaderOne' },
// 			{ text: '1679905\n', style: 'firmHeaderOne' },
// 			{ text: '  ', bold: true, style: 'firmHeaderOne' },
// 			{ text: '7788996655\n', style: 'firmHeaderOne' },
// 			{ text: 'Mobile Number :   ', bold: true, style: 'firmHeaderOne' },
// 			{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n', style: 'firmHeaderOne' },
// 			{ text: 'Place of Supply :   ', bold: true, style: 'firmHeaderOne' },
// 			{ text: '13/12/90\n', style: 'firmHeaderOne' },
// 			{ text: 'State Code         :   ', bold: true, style: 'firmHeaderOne' },
// 			{ text: '23\n', style: 'firmHeaderOne' },
// 		]
// },
{text:[{text:'Invoice No:   ',bold:true,style:'firmHeaderOne'},{text:'787878\n',style:'firmHeaderOne'}]},{text:[{text:'Date:   ',bold:true,style:'firmHeaderOne'},{text:'12/12/90 \n',style:'firmHeaderOne'}]},{text:[{text:'Status:   ',bold:true,style:'topRemainingHeader'},{text:'Paid/Pending \n',style:'topRemainingHeader'}]}]]},style:'tab2',layout:'noBorders'},{table:{widths:['*','*'],body:[[{text:'ITEMS',style:"emptyHeader1"},{text:'',style:"emptyHeader1"}]]},layout:'noBorders'},{table:{body:[[{text:'S.NO',style:"productHeader11",rowSpan:2},{text:'PRODUCTS DESCRIPTION',style:"productHeader11",rowSpan:2},// { text: 'HSN/SAC', style: "productHeader1", rowSpan: 2 },
{text:'QUANTITY',style:"productHeader11",rowSpan:2},{text:'UNITS',style:"productHeader11",rowSpan:2},{text:'PRODUCTS RATE',style:"productHeader11",rowSpan:2},// { text: 'Basic  Amount', style: "productHeader", rowSpan: 2 },
{text:'TOTAL AMOUNT',style:"productHeader11",rowSpan:2}],[{text:'S.NO',style:"productHeader11"},{text:'PRODUCTS DESCRIPTION',style:"productHeader11"},// { text: 'HSN/SAC', style: "productHeader1" },
{text:'QUANTITY',style:"productHeader11"},{text:'UNITS',style:"productHeader11"},{text:'PRODUCTS RATE',style:"productHeader11"},// { text: 'Basic Amount', style: "productHeader" },
{text:'AMOUNT',style:"productHeader11"}]]}},{table:{widths:['*'],body:[[{text:"In Words: ",style:'invoiceDetails'}]]}},// {
// 	table: {
// 		widths: ['65%', '*'],
// 		body: [
// 			[
// 				[
// 					{
// 						table: {
// 							widths: ['*'],
// 							body: [
// 								[
// 									{ text: 'PAYMENT DETAILS', style: "topHeader1" }
// 								],
// 							],
// 						},
// 						style: 'tab2Head',
// 						layout: 'noBorders',
// 					}, {
// 						table: {
// 							widths: ['3%', '*'],
// 							body: [
// 								[{
// 									text: ''
// 								},
// 								{
// 									text:
// 										[]
// 								},
// 								]
// 							]
// 						},
// 						style: 'tab2',
// 						layout: 'noBorders',
// 					},
// 					{
// 						table: {
// 							widths: ['*'],
// 							body: [
// 								[
// 									{ text: 'TERMS & CONDITIONS', style: "topHeader1" },
// 								],
// 							],
// 						},
// 						style: 'tab2Head',
// 						layout: 'noBorders',
// 					}, {
// 						table: {
// 							widths: ['3%', '*'],
// 							body: [
// 								[
// 									{
// 										text: ''
// 									},
// 									{
// 										text: "",
// 									},
// 								]
// 							]
// 						},
// 						style: 'tab2',
// 						layout: 'noBorders',
// 					},
// 				],
// 				{
// 					text:
// 						[
// 							{ text: 'Basic Amount   :   ', bold: true, style: 'headerOne' },
// 							{ text: '12122\n', style: 'headerOne' },
// 							// { text: 'Labour Charge:      ', bold: true, style:'headerOne' },
// 							// { text: '12122\n', style:'headerOne' },
// 							{ text: 'Discount            :   ', bold: true, style: 'headerOne' },
// 							{ text: '12122\n', style: 'headerOne' },
// 							{ text: 'RoundOff           :   ', bold: true, style: 'headerOne' },
// 							{ text: '12122\n', style: 'headerOne' },
// 							{ text: 'Total Amount    :   ', bold: true, style: 'topTotalAmount' },
// 							{ text: '12122\n', style: 'topTotalAmount' },
// 							{ text: 'Paid Amount     :   ', bold: true, style: 'headerOne' },
// 							{ text: '12122\n', style: 'headerOne' },
// 							{ text: 'Due Amount      :   ', bold: true, style: 'topRemainingHeader' },
// 							{ text: '12122\n', style: 'topRemainingHeader' },
// 							// 	{ text: 'Payment Type:-       ', bold: true },
// 							// { text: '12122\n' },
// 						]
// 				},
// 			],
// 		],
// 	},
// 	style: 'tab2',
// 	layout: 'lightHorizontalLines',
// },
// {
// 	table: {
// 		widths: ['*', '*',],
// 		body: [
// 			[
// 				{ text: 'OUTSTANDING DETAILS', style: "emptyHeader" },
// 				{ text: 'he', style: "emptyHeader1" },
// 			],
// 		],
// 	},
// 	layout: 'noBorders',
// },
// Start of Previous + current = Total Column
{table:{widths:['34%','39%','27%'],body:[[{text:'',style:"topBlankHeader"},{text:'',style:"topMainHeader"},{text:'',style:"topBlankHeader"}],[{text:[{text:'PREVIOUS BALANCE :  ',bold:true,style:'topHeader11'},{text:'\n',style:'topHeader11'}]},{text:[{text:'CURRENT BALANCE :  ',bold:true,style:'topHeader11'},{text:'\n',style:'topHeader11'}]},{text:[{text:'TOTAL BALANCE :  ',bold:true,style:'topRemainingHeader1'},{text:'\n',style:'topRemainingHeader1'}]}]]},layout:{hLineWidth:function hLineWidth(i,node){return i===0||i===node.table.body.length?1:0;},vLineWidth:function vLineWidth(i,node){return i===0||i===node.table.widths.length?1:0;},hLineColor:function hLineColor(i,node){return i===0||i===node.table.body.length?'black':'black';},vLineColor:function vLineColor(i,node){return i===0||i===node.table.widths.length?'black':'black';}}}],footer:{columns:[{text:'Powered By ACUIFY',alignment:'right',color:'#160091'}],margin:[10,10]},styles:{header:{fontSize:12,bold:true,alignment:'center'},headerOne:{fontSize:12,bold:true},firmHeaderOne:{fontSize:12,bold:true},firmHeaderOneRight:{fontSize:12,bold:true,alignment:'right'},billHeader:{color:'white',fontSize:12,bold:true,alignment:'left',fillColor:'#15155d'},product:{fontSize:12,alignment:'center'},total:{fontSize:12,alignment:'center',bold:true},productRight:{fontSize:12,alignment:'right'// bold: true
},totalRight:{fontSize:12,alignment:'right',bold:true},topHeader:{color:'white',fontSize:14,alignment:'center',bold:true,fillColor:'#15155d'},topHeader1:{color:'white',fontSize:12,alignment:'left',bold:true,fillColor:'#15155d'},emptyHeader:{color:'white',fillColor:'#15155d',alignment:'left',bold:true},emptyHeader1:{color:'#15155d',fillColor:'#15155d',alignment:'left'},emptyHeader2:{color:'white',fillColor:'#15155d',alignment:'center',bold:true},topTab:{// fillColor: '#ececec',
},tab2Head:{color:'white'// fillColor: '#015155d',
},tab2:{// fillColor: '#ececec',
},topFirmAuthority:{color:'#160091',fontSize:12,bold:true},topFirmAuthorityRight:{color:'#160091',fontSize:14,bold:true,alignment:'right'},topTotalAmount:{color:'#160091',fontSize:12,bold:true},topRemainingHeader:{color:'#FF0000',fontSize:12,bold:true},topRemainingHeader1:{color:'#FF0000',fontSize:10,bold:true},bankDetails:{fontSize:12,bold:true},productHeader:{color:'#160091',fontSize:12,bold:true,alignment:'center'},productHeader1:{fontSize:12,bold:true,alignment:'center'},topHeader11:{color:'#160091',fontSize:10,bold:true},productHeader11:{fontSize:12,color:'#160091',bold:true,alignment:'center'},hiddenTab:{fillColor:'#ffffff',color:'#ffffff'}}//Firm Details 
// pdfDoc.content[1].table.body[0][2].text[1].text = (metaData.firm.name.toUpperCase() ? metaData.firm.name.toUpperCase() : '') + "\n";
};pdfDoc.content[1].table.body[0][2].text[1].text=(metaData.firm&&metaData.firm.name?metaData.firm.name.toUpperCase():'')+"\n";// pdfDoc.content[1].table.body[0][2].text[3].text = (metaData.firm.GST_number ? metaData.firm.GST_number : '') + "\n";
pdfDoc.content[1].table.body[0][2].text[3].text=(metaData.firm.liveAddress?metaData.firm.liveAddress:'')+"\n";pdfDoc.content[1].table.body[0][2].text[5].text=(metaData.firm.address?metaData.firm.address:'')+"\n";pdfDoc.content[1].table.body[0][2].text[7].text=(metaData.firm.mobileNumber?metaData.firm.mobileNumber:'')+"\n";pdfDoc.content[1].table.body[0][2].text[9].text=(metaData.firm.email?metaData.firm.email:'')+"\n";//  Start of Trail Code
//Receipient Details
// pdfDoc.content[3].table.body[0][1].text[1].text = (metaData.customer.name.toUpperCase() ? metaData.customer.name.toUpperCase() : '') + "\n";
// pdfDoc.content[3].table.body[0][1].text[1].text = ((metaData.customer && metaData.customer.name )? metaData.customer.name.toUpperCase() : '') + "\n";
pdfDoc.content[1].table.body[0][4].text[1].text=getCustomerDetails(metaData,'name').toUpperCase()+"\n";// pdfDoc.content[3].table.body[0][1].text[3].text = (metaData.customer.GST_number ? metaData.customer.GST_number : '') + "\n";
// pdfDoc.content[3].table.body[0][1].text[5].text = (metaData.customer.address ? metaData.customer.address : '') + "\n";
// pdfDoc.content[3].table.body[0][1].text[7].text = (metaData.customer.mobile ? metaData.customer.mobile : '') + "\n";
pdfDoc.content[1].table.body[0][4].text[3].text=(metaData.customer.localAddress?metaData.customer.localAddress:'')+"\n";pdfDoc.content[1].table.body[0][4].text[5].text=getCustomerDetails(metaData,'address')+"\n";pdfDoc.content[1].table.body[0][4].text[7].text=getCustomerDetails(metaData,'mobile').toUpperCase()+"\n";pdfDoc.content[1].table.body[0][4].text[9].text=(metaData.invoiceData.placeOfSupply?metaData.invoiceData.placeOfSupply:'')+"\n";pdfDoc.content[1].table.body[0][4].text[11].text=(metaData.customer.stateCode?metaData.customer.stateCode:'')+"\n";pdfDoc.content[1].table.body[0][4].text[13].text=(metaData.invoiceData.remark?metaData.invoiceData.remark:'')+"\n";//Invoice Details
// let vdate = new Date(metaData.invoiceData.date)
// let vpaymentDueDate = vdate.setDate(vdate.getDate() + (metaData.invoiceData.duration ? parseInt(metaData.invoiceData.duration) : 0));
// pdfDoc.content[1].table.body[0][3].text[13].text = metaData.invoiceData.invoiceId + "\n";
// pdfDoc.content[1].table.body[0][3].text[15].text = new Date(metaData.invoiceData.date).toLocaleDateString('en-GB').toString() + "\n";
// pdfDoc.content[1].table.body[0][3].text[17].text = (metaData.invoiceData.status ? metaData.invoiceData.status.toUpperCase() : '') + "\n";
// pdfDoc.content[1].table.body[0][3].text[7].text = new Date(vpaymentDueDate).toLocaleDateString('en-GB').toString() + "\n";
// End of Trail Code
//Receipient Details
// pdfDoc.content[3].table.body[0][1].text[1].text = (metaData.customer.name.toUpperCase() ? metaData.customer.name.toUpperCase() : '') + "\n";
// pdfDoc.content[3].table.body[0][1].text[1].text = ((metaData.customer && metaData.customer.name )? metaData.customer.name.toUpperCase() : '') + "\n";
// pdfDoc.content[3].table.body[0][1].text[1].text = (getCustomerDetails(metaData, 'name').toUpperCase()) + "\n";
// pdfDoc.content[3].table.body[0][1].text[3].text = (metaData.customer.GST_number ? metaData.customer.GST_number : '') + "\n";
// pdfDoc.content[3].table.body[0][1].text[5].text = (metaData.customer.address ? metaData.customer.address : '') + "\n";
// pdfDoc.content[3].table.body[0][1].text[7].text = (metaData.customer.mobile ? metaData.customer.mobile : '') + "\n";
// pdfDoc.content[3].table.body[0][1].text[3].text = (metaData.customer.localAddress ? metaData.customer.localAddress : '') + "\n";
// pdfDoc.content[3].table.body[0][1].text[5].text = (getCustomerDetails(metaData, 'address')) + "\n";
// pdfDoc.content[3].table.body[0][1].text[7].text = (getCustomerDetails(metaData, 'mobile').toUpperCase()) + "\n";
// pdfDoc.content[3].table.body[0][1].text[9].text = (metaData.invoiceData.placeOfSupply ? metaData.invoiceData.placeOfSupply : '') + "\n";
// pdfDoc.content[3].table.body[0][1].text[11].text = (metaData.customer.stateCode ? metaData.customer.stateCode : '') + "\n";
//Invoice Details
date=new Date(metaData.invoiceData.date);paymentDueDate=date.setDate(date.getDate()+(metaData.invoiceData.duration?parseInt(metaData.invoiceData.duration):0));pdfDoc.content[3].table.body[0][1].text[1].text=metaData.invoiceData.invoiceId+"\n";pdfDoc.content[3].table.body[0][2].text[1].text=new Date(metaData.invoiceData.date).toLocaleDateString('en-GB').toString()+"\n";pdfDoc.content[3].table.body[0][3].text[1].text=(metaData.invoiceData.status?metaData.invoiceData.status.toUpperCase():'')+"\n";//pdfDoc.content[3].table.body[0][2].text[7].text = new Date(paymentDueDate).toLocaleDateString('en-GB').toString() + "\n";
//Products
productList=convertToPDFProducts(metaData.invoiceData.items,false,metaData.invoiceData,metaData);productList.map(function(item){pdfDoc.content[5].table.body.push(item);});pdfDoc.content[6].table.body[0][0].text="In Words: "+_.startCase(Object(__WEBPACK_IMPORTED_MODULE_6__digitsToWords_js__["a" /* digitsToWords */])(metaData.invoiceData.totalAmount));// Payment Details
// pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text[1].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";
// pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text[3].text = (metaData.invoiceData.transactionType ? metaData.invoiceData.transactionType : '') + "\n";
// Bank Details
// if (metaData.terms.banks.length) {
// 	metaData.terms.banks.map((bankDetails) => {
// 		pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({ text: bankDetails.bankName + " \n", style: "bankDetails" })
// 		pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({ text: "A/C No: " + bankDetails.accountnumber + "\n", style: "bankDetails" })
// 		pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({ text: "IFSC: " + bankDetails.ifsccode + "\n", style: "bankDetails" })
// 		pdfDoc.content[6].table.body[0][0][1].table.body[0][1].text.push({ text: bankDetails.address + " \n", style: "bankDetails" })
// 	})
// }
// Terms and cond
// pdfDoc.content[6].table.body[0][0][3].table.body[0][1] = metaData.terms.termsAndConditions;
// gst details
// pdfDoc.content[6].table.body[0][1].text[1].text = ((metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount ? Number.parseFloat(metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount).toFixed(2) - Number.parseFloat(metaData.gstTotal.CGST_val + metaData.gstTotal.SGST_val + metaData.gstTotal.IGST_val).toFixed(2) : '0')).toFixed(2) + "\n";
// pdfDoc.content[6].table.body[0][1].text[1].text = (
// 	Number.parseFloat(metaData.invoiceData.totalAmount) +
// 	Number.parseFloat(metaData.invoiceData.discountAmount || 0) +
// 	Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? 0 : (-Number.parseFloat(metaData.invoiceData.totalExtraCharges))) -
// 	Number.parseFloat(metaData.invoiceData.gstOnExtraChanrges ? Number.parseFloat(metaData.invoiceData.totalExtraChargesGST) : 0) -
// 	Number.parseFloat(metaData.invoiceData.roundOffAmount || 0) -
// 	(Number.parseFloat(
// 		metaData.gstTotal.SGST_val
// 	) +
// 		Number.parseFloat(
// 			metaData.gstTotal.CGST_val
// 		) +
// 		Number.parseFloat(
// 			metaData.gstTotal.IGST_val
// 		))
// ).toFixed(2) + "\n";
// let offset = 0;
// if (!metaData.invoiceData.gstOnExtraChanrges && metaData.invoiceData.extraCharges && metaData.invoiceData.extraCharges.length) {
// 	metaData.invoiceData.extraCharges.map((charge) => {
// 		pdfDoc.content[6].table.body[0][1].text.splice(2 + offset, 0, { text: '' + charge.name + ' :   ', bold: true, style: 'headerOne' });
// 		offset++;
// 		pdfDoc.content[6].table.body[0][1].text.splice(2 + offset, 0, { text: Number.parseFloat(charge.amount).toFixed(2) + '\n', style: 'headerOne' });
// 		offset++;
// 	})
// }
// pdfDoc.content[6].table.body[0][1].text[3].text = (metaData.invoiceData.labourAmount ? Number.parseFloat(metaData.invoiceData.labourAmount).toFixed(2) : '0.00') + "\n";
// pdfDoc.content[6].table.body[0][1].text[3 + offset].text = (metaData.invoiceData.discountAmount ? Number.parseFloat(metaData.invoiceData.discountAmount).toFixed(2) : '0.00') + "\n";
// pdfDoc.content[6].table.body[0][1].text[5 + offset].text = (metaData.invoiceData.roundOffAmount ? Number.parseFloat(metaData.invoiceData.roundOffAmount).toFixed(2) : '0.00') + "\n";
// pdfDoc.content[6].table.body[0][1].text[9].text = (metaData.invoiceData.totalAmount ? Number.parseFloat(metaData.invoiceData.totalAmount).toFixed(2) : '0') + "\n";
// pdfDoc.content[6].table.body[0][1].text[9].text = (metaData.invoiceData.totalAmount + metaData.invoiceData.labourAmount -  metaData.invoiceData.discountAmount ? Number.parseFloat(Number.parseFloat(metaData.invoiceData.totalAmount) + Number.parseFloat(metaData.invoiceData.labourAmount) - Number.parseFloat(metaData.invoiceData.discountAmount)).toFixed(2) : '0') + "\n";
// pdfDoc.content[6].table.body[0][1].text[7 + offset].text = (metaData.invoiceData.totalAmount ? Number.parseFloat(metaData.invoiceData.totalAmount) : '0.00').toFixed(2) + "\n";
// pdfDoc.content[6].table.body[0][1].text[9 + offset].text = (metaData.invoiceData.paidAmount ? Number.parseFloat(metaData.invoiceData.paidAmount).toFixed(2) : '0.00') + "\n";
// pdfDoc.content[6].table.body[0][1].text[11 + offset].text = (metaData.invoiceData.remainingAmount ? Number.parseFloat(metaData.invoiceData.remainingAmount).toFixed(2) : '0.00') + "\n";
// pdfDoc.content[6].table.body[0][1].text[17].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";
// if(metaData.invoiceData.extraCharges && metaData.invoiceData.extraCharges.length) {
// 	metaData.invoiceData.extraCharges.map((charge)=>{
// 				pdfDoc.content[6].table.body[0][1].text.push({ text: ''+charge.name+':-          ', bold: true })
// 				pdfDoc.content[6].table.body[0][1].text.push({ text:charge.amount+'\n' })
// 	})
// }
// Overall Balance
if(metaData.balance&&metaData.terms.isPreviousCurrentTotalBalance){pdfDoc.content[7].table.body[1][0].text[1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.balance)-__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.remainingAmount).toFixed(2)).toFixed(2)+"\n";pdfDoc.content[7].table.body[1][1].text[1].text=(metaData.invoiceData.remainingAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.remainingAmount).toFixed(2):'0.00')+"\n";pdfDoc.content[7].table.body[1][2].text[1].text=(metaData.balance?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.balance).toFixed(2):'0.00')+"\n";}else{pdfDoc.content[7]={};//pdfDoc.content[6] = {}
}// authority
// pdfDoc.content[10].table.body[0][1].text[1].text = (metaData.firm.name ? (metaData.firm.name).toUpperCase() : '');
// thank you
// pdfDoc.content[9].table.body[0][0].text =  "Thank You " + (metaData.customer.name.toUpperCase() ? metaData.customer.name.toUpperCase() : '') +" For Choosing us!" 
// pdfDoc.content[9].table.body[0][0].text =  metaData.terms.termsAndConditions.greetingMessage || ("Thank You " + ((metaData.customer && metaData.customer.name )? metaData.customer.name.toUpperCase() : '') +" For Choosing us!" )
// pdfDoc.content[11].table.body[0][0].text = metaData.terms.greetingMessage || ("Thank You " + (getCustomerDetails(metaData, 'name').toUpperCase()) + " for doing business with us!")
if(!metaData.terms.isBlankHeader){_context7.next=28;break;}pdfDoc.content[1].table.body[0][1]={text:''};pdfDoc.content[1].style='hiddenTab';pdfDoc.content[1].table.body[0][2].text[1].style='hiddenTab';_context7.next=99;break;case 28:if(!metaData.terms.printLogo){_context7.next=67;break;}_context7.prev=29;_context7.next=32;return getBase64ImageFromURL(metaData.terms.printLogo);case 32:logoData=_context7.sent;pdfDoc.content[1].table.body[0][1].image=logoData;invoiceImages=document.getElementById('invoiceImages');if(!(invoiceImages&&invoiceImages.files&&invoiceImages.files.length)){_context7.next=59;break;}temp={columns:[]};if(!invoiceImages.files[0]){_context7.next=44;break;}_context7.t0=temp.columns;_context7.next=41;return toBase64(invoiceImages.files[0]).catch(function(e){return Error(e);});case 41:_context7.t1=_context7.sent;_context7.t2={image:_context7.t1,width:150};_context7.t0.push.call(_context7.t0,_context7.t2);case 44:if(!invoiceImages.files[1]){_context7.next=51;break;}_context7.t3=temp.columns;_context7.next=48;return toBase64(invoiceImages.files[1]).catch(function(e){return Error(e);});case 48:_context7.t4=_context7.sent;_context7.t5={image:_context7.t4,width:150};_context7.t3.push.call(_context7.t3,_context7.t5);case 51:if(!invoiceImages.files[2]){_context7.next=58;break;}_context7.t6=temp.columns;_context7.next=55;return toBase64(invoiceImages.files[2]).catch(function(e){return Error(e);});case 55:_context7.t7=_context7.sent;_context7.t8={image:_context7.t7,width:150};_context7.t6.push.call(_context7.t6,_context7.t8);case 58:pdfDoc.content.push(temp);case 59:return _context7.abrupt("return",pdfDoc);case 62:_context7.prev=62;_context7.t9=_context7["catch"](29);console.log(_context7.t9);case 65:_context7.next=99;break;case 67:imgToExport=document.getElementById('pdfimgToExport');canvas=document.createElement('canvas');canvas.width=imgToExport.width;canvas.height=imgToExport.height;canvas.getContext('2d').drawImage(imgToExport,0,0);base64=canvas.toDataURL('image/png');pdfDoc.content[1].table.body[0][1].image=base64;_invoiceImages7=document.getElementById('invoiceImages');if(!(_invoiceImages7&&_invoiceImages7.files&&_invoiceImages7.files.length)){_context7.next=99;break;}_temp19={columns:[]};if(!_invoiceImages7.files[0]){_context7.next=84;break;}_context7.t10=_temp19.columns;_context7.next=81;return toBase64(_invoiceImages7.files[0]).catch(function(e){return Error(e);});case 81:_context7.t11=_context7.sent;_context7.t12={image:_context7.t11,width:150};_context7.t10.push.call(_context7.t10,_context7.t12);case 84:if(!_invoiceImages7.files[1]){_context7.next=91;break;}_context7.t13=_temp19.columns;_context7.next=88;return toBase64(_invoiceImages7.files[1]).catch(function(e){return Error(e);});case 88:_context7.t14=_context7.sent;_context7.t15={image:_context7.t14,width:150};_context7.t13.push.call(_context7.t13,_context7.t15);case 91:if(!_invoiceImages7.files[2]){_context7.next=98;break;}_context7.t16=_temp19.columns;_context7.next=95;return toBase64(_invoiceImages7.files[2]).catch(function(e){return Error(e);});case 95:_context7.t17=_context7.sent;_context7.t18={image:_context7.t17,width:150};_context7.t16.push.call(_context7.t16,_context7.t18);case 98:pdfDoc.content.push(_temp19);case 99:return _context7.abrupt("return",pdfDoc);case 100:case"end":return _context7.stop();}}},_callee7,_this,[[29,62]]);}));return function convertToBasicShortInvoiceWithoutGST(_x7){return _ref7.apply(this,arguments);};}();// End of New Photo Resize Format Third	
var convertToPDFGST_1_individual=function convertToPDFGST_1_individual(metaData){var pdfDoc={content:[{text:'GST Report\n\n',style:"bigger"},{table:{widths:['*'],body:[[{text:'Firm Details',style:"header"}],[{text:[{text:'Firm Name:-         ',bold:true},{text:'Google\n'},{text:'Address:-              ',bold:true},{text:'1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n'},{text:'Mobile Number:- ',bold:true},{text:'88776655\n'},{text:'PAN No:-               ',bold:true},{text:'123456\n'},{text:'Email:-                   ',bold:true},{text:'njnjn@jnn.com\n'},{text:'GSTIN:-                 ',bold:true},{text:'123456\n'},{text:'Website:-               ',bold:true},{text:'www.123456.com\n'}]}]]}},{table:{body:[[{text:'HSN SUMMARY',style:"header",colSpan:8},{text:'',style:"header"},{text:'',style:"header"},{text:'',style:"header"},{text:'',style:"header"},{text:'',style:"header"},{text:'',style:"header"},{text:'',style:"header"}],[{text:'Description of Invoices',style:"gstHeader",rowSpan:2},{text:'Voucher Count',style:"gstHeader",rowSpan:2},{text:'Total Taxable Value',style:"gstHeader",rowSpan:2},{text:'TAX Amounts',style:"gstHeader",colSpan:4,rowSpan:1},{text:'',style:"gstHeader",rowSpan:2},{text:'',style:"gstHeader",rowSpan:2},{text:'',style:"gstHeader",rowSpan:2},{text:'Total Invoices',style:"gstHeader",rowSpan:2}],[{text:'Description of Invoices',style:"gstHeader"},{text:'Voucher Count',style:"gstHeader"},{text:'Total Taxable Value',style:"gstHeader"},{text:'IGST A.',style:"gstHeader"},{text:'CGST A.',style:"gstHeader"},{text:'SGST A.',style:"gstHeader"},{text:'CESS',style:"gstHeader"},{text:'Total Invoices',style:"gstHeader"}]]}},{table:{body:[[{text:'GSTR-1',style:"header",colSpan:10,decoration:'underline'},{text:'',style:"header"},{text:'',style:"header"},{text:'',style:"header"},{text:'',style:"header"},{text:'',style:"header"},{text:'',style:"header"},{text:'',style:"header"},{text:'',style:"header"},{text:'',style:"header"}],[{text:'S. No',style:"gstHeader",rowSpan:2},{text:'Customer Name GSTIN/UIN Location',style:"gstHeader",rowSpan:2},{text:'Invoice Number',style:"gstHeader",rowSpan:2},{text:'Date',style:"gstHeader",rowSpan:2},{text:'Taxable Value',style:"gstHeader",rowSpan:2},{text:'TAX Amounts',style:"gstHeader",colSpan:4,rowSpan:1},{text:'',style:"gstHeader",rowSpan:2},{text:'',style:"gstHeader",rowSpan:2},{text:'',style:"gstHeader",rowSpan:2},{text:'Invoice Amount',style:"gstHeader",rowSpan:2}],[{text:'Description of Invoices',style:"gstHeader"},{text:'Voucher Count',style:"gstHeader"},{text:'Total Taxable Value',style:"gstHeader"},{text:'Voucher Count',style:"gstHeader"},{text:'Total Taxable Value',style:"gstHeader"},{text:'IGST A.',style:"gstHeader"},{text:'CGST A.',style:"gstHeader"},{text:'SGST A.',style:"gstHeader"},{text:'CESS',style:"gstHeader"},{text:'Total Invoices',style:"gstHeader"}]]}}],footer:{columns:[{text:'Powered By ACUIFY',alignment:'right',color:'#160091'}],margin:[10,10]},styles:{header:{fontSize:14,bold:true,alignment:'center'},gstHeader:{fontSize:10,bold:true,alignment:'center'},gstData:{fontSize:9,alignment:'center'},bigger:{fontSize:18,bold:true,alignment:'center',decoration:'underline',decorationStyle:'solid',decorationColor:'black'}}//Firm Details 
};pdfDoc.content[1].table.body[1][0].text[1].text=(metaData.firm.name?metaData.firm.name:'')+"\n";pdfDoc.content[1].table.body[1][0].text[3].text=(metaData.firm.address?metaData.firm.address:'')+"\n";pdfDoc.content[1].table.body[1][0].text[5].text=(metaData.firm.mobileNumber?metaData.firm.mobileNumber:'')+"\n";pdfDoc.content[1].table.body[1][0].text[7].text=(metaData.firm.panNumber?metaData.firm.panNumber:'')+"\n";pdfDoc.content[1].table.body[1][0].text[9].text=(metaData.firm.email?metaData.firm.email:'')+"\n";pdfDoc.content[1].table.body[1][0].text[11].text=(metaData.firm.GST_number?metaData.firm.GST_number:'')+"\n";pdfDoc.content[1].table.body[1][0].text[13].text=(metaData.firm.website?metaData.firm.website:'')+"\n";// selected GST Category details
pdfDoc.content[2].table.body.push([{text:metaData.selectedGSTCat.title,style:"gstData"},{text:metaData.selectedGSTCat.voucherCount,style:"gstData"},{text:metaData.selectedGSTCat.totalBaseAmount,style:"gstData"},{text:metaData.selectedGSTCat.IGST,style:"gstData"},{text:metaData.selectedGSTCat.CGST,style:"gstData"},{text:metaData.selectedGSTCat.SGST,style:"gstData"},{text:metaData.selectedGSTCat.CESS,style:"gstData"},{text:metaData.selectedGSTCat.totalInvoice,style:"gstData"}]);metaData.selectedGSTCat.invoices.map(function(invoice,index){pdfDoc.content[3].table.body.push([{text:index+1,style:"gstData"},[{text:invoice.buyer.name,style:"gstHeader"},{text:invoice.buyer.GST_number,style:"gstData"},{text:invoice.buyer.state,style:"gstData"}],{text:invoice.invoiceId,style:"gstData"},{text:new Date(invoice.date).toLocaleDateString('en-GB'),style:"gstData"},{text:invoice.basicAmount,style:"gstData"},{text:invoice.IGST_val,style:"gstData"},{text:invoice.CGST_val,style:"gstData"},{text:invoice.SGST_val,style:"gstData"},{text:invoice.CESS,style:"gstData"},{text:invoice.totalAmount,style:"gstData"}]);});return pdfDoc;};var convertToPDFGST_1=function convertToPDFGST_1(metaData){var pdfDoc={content:[{text:'GST Report\n\n',style:"bigger"},{table:{widths:['*'],body:[[{text:'Firm Details',style:"header"}],[{text:[{text:'Firm Name:-         ',bold:true},{text:'Google\n'},{text:'Address:-              ',bold:true},{text:'1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n'},{text:'Mobile Number:- ',bold:true},{text:'88776655\n'},{text:'PAN No:-               ',bold:true},{text:'123456\n'},{text:'Email:-                   ',bold:true},{text:'njnjn@jnn.com\n'},{text:'GSTIN:-                 ',bold:true},{text:'123456\n'},{text:'Website:-               ',bold:true},{text:'www.123456.com\n'}]}]]}},{table:{body:[[{text:'GST Summary',style:"header",colSpan:7,decoration:'underline'},{text:'',style:"header"},{text:'',style:"header"},{text:'',style:"header"},{text:'',style:"header"},{text:'',style:"header"},{text:'',style:"header"}],[{text:'Description of Invoices',style:"gstHeader",rowSpan:2},{text:'Total Taxable Value',style:"gstHeader",rowSpan:2},{text:'TAX Amounts',style:"gstHeader",colSpan:4,rowSpan:1},{text:'',style:"gstHeader",rowSpan:2},{text:'',style:"gstHeader",rowSpan:2},{text:'',style:"gstHeader",rowSpan:2},{text:'Total Invoices',style:"gstHeader",rowSpan:2}],[{text:'Description of Invoices',style:"gstHeader"},{text:'Total Taxable Value',style:"gstHeader"},{text:'IGST A.',style:"gstHeader"},{text:'CGST A.',style:"gstHeader"},{text:'SGST A.',style:"gstHeader"},{text:'CESS',style:"gstHeader"},{text:'Total Invoices',style:"gstHeader"}],[{text:'OUTWARD SUPPLIES',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"}],[{text:'(A). Intra state',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"}],[{text:'(i). Taxable',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'GST 3%',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'GST 5%',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'GST 12%',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'GST 18%',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'GST 28%',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'(ii). Exempted',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'(iii). Nill Rated',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'(iv). Others',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'(A). Inter state',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"}],[{text:'(i). Taxable',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'GST 3%',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'GST 5%',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'GST 12%',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'GST 18%',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'GST 28%',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'(ii). Exempted',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'(iii). Nill Rated',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'(iv). Others',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}]]}},{table:{body:[[{text:'GSTR-1',style:"header",colSpan:9,decoration:'underline'},{text:'',style:"header"},{text:'',style:"header"},{text:'',style:"header"},{text:'',style:"header"},{text:'',style:"header"},{text:'',style:"header"},{text:'',style:"header"},{text:'',style:"header"}],[{text:'S. No',style:"Header3",rowSpan:2},{text:'Description Of Invoices',style:"Header3",rowSpan:2},{text:'Voucher Count',style:"Header3",rowSpan:2},{text:'Total Taxable Value',style:"Header3",rowSpan:2},{text:'TAX/GST Amounts',style:"Header3",colSpan:4,rowSpan:1},{text:'',style:"Header3",rowSpan:2},{text:'',style:"Header3",rowSpan:2},{text:'',style:"Header3",rowSpan:2},{text:'Invoice Amount',style:"Header3",rowSpan:2}],[{text:'Description of Invoices',style:"Header3"},{text:'Voucher Count',style:"Header3"},{text:'Voucher Count',style:"Header3"},{text:'Total Taxable Value',style:"Header3"},{text:'IGST A.',style:"Header3"},{text:'CGST A.',style:"Header3"},{text:'SGST A.',style:"Header3"},{text:'CESS',style:"Header3"},{text:'Total Invoices',style:"Header3"}]]}}],footer:{columns:[{text:'Powered By ACUIFY',alignment:'right',color:'#160091'}],margin:[10,10]},styles:{header:{fontSize:14,bold:true,alignment:'center'},gstHeader:{fontSize:13,bold:true,alignment:'center'},Header2:{fontSize:12,bold:true,alignment:'center'},Header3:{fontSize:11,bold:true,alignment:'center'},Header4:{fontSize:10,alignment:'center'},gstData:{fontSize:9,alignment:'center'},bigger:{fontSize:18,bold:true,alignment:'center',decoration:'underline',decorationStyle:'solid',decorationColor:'black'}}};//Firm Details 
pdfDoc.content[1].table.body[1][0].text[1].text=(metaData.firm.name?metaData.firm.name:'')+"\n";pdfDoc.content[1].table.body[1][0].text[3].text=(metaData.firm.address?metaData.firm.address:'')+"\n";pdfDoc.content[1].table.body[1][0].text[5].text=(metaData.firm.mobileNumber?metaData.firm.mobileNumber:'')+"\n";pdfDoc.content[1].table.body[1][0].text[7].text=(metaData.firm.panNumber?metaData.firm.panNumber:'')+"\n";pdfDoc.content[1].table.body[1][0].text[9].text=(metaData.firm.email?metaData.firm.email:'')+"\n";pdfDoc.content[1].table.body[1][0].text[11].text=(metaData.firm.GST_number?metaData.firm.GST_number:'')+"\n";pdfDoc.content[1].table.body[1][0].text[13].text=(metaData.firm.website?metaData.firm.website:'')+"\n";//gst summary
//outward
pdfDoc.content[2].table.body[3][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[3][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.IGST).toFixed(2);pdfDoc.content[2].table.body[3][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.CGST).toFixed(2);pdfDoc.content[2].table.body[3][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.SGST).toFixed(2);pdfDoc.content[2].table.body[3][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.CESS).toFixed(2);pdfDoc.content[2].table.body[3][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[4][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[4][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.IGST).toFixed(2);pdfDoc.content[2].table.body[4][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.CGST).toFixed(2);pdfDoc.content[2].table.body[4][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.SGST).toFixed(2);pdfDoc.content[2].table.body[4][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.CESS).toFixed(2);pdfDoc.content[2].table.body[4][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[5][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[5][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.IGST).toFixed(2);pdfDoc.content[2].table.body[5][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.CGST).toFixed(2);pdfDoc.content[2].table.body[5][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.SGST).toFixed(2);pdfDoc.content[2].table.body[5][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.CESS).toFixed(2);pdfDoc.content[2].table.body[5][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[6][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_3.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[6][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_3.IGST).toFixed(2);pdfDoc.content[2].table.body[6][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_3.CGST).toFixed(2);pdfDoc.content[2].table.body[6][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_3.SGST).toFixed(2);pdfDoc.content[2].table.body[6][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_3.CESS).toFixed(2);pdfDoc.content[2].table.body[6][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_3.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[7][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_5.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[7][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_5.IGST).toFixed(2);pdfDoc.content[2].table.body[7][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_5.CGST).toFixed(2);pdfDoc.content[2].table.body[7][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_5.SGST).toFixed(2);pdfDoc.content[2].table.body[7][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_5.CESS).toFixed(2);pdfDoc.content[2].table.body[7][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_5.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[8][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_12.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[8][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_12.IGST).toFixed(2);pdfDoc.content[2].table.body[8][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_12.CGST).toFixed(2);pdfDoc.content[2].table.body[8][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_12.SGST).toFixed(2);pdfDoc.content[2].table.body[8][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_12.CESS).toFixed(2);pdfDoc.content[2].table.body[8][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_12.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[9][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_18.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[9][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_18.IGST).toFixed(2);pdfDoc.content[2].table.body[9][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_18.CGST).toFixed(2);pdfDoc.content[2].table.body[9][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_18.SGST).toFixed(2);pdfDoc.content[2].table.body[9][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_18.CESS).toFixed(2);pdfDoc.content[2].table.body[9][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_18.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[10][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_28.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[10][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_28.IGST).toFixed(2);pdfDoc.content[2].table.body[10][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_28.CGST).toFixed(2);pdfDoc.content[2].table.body[10][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_28.SGST).toFixed(2);pdfDoc.content[2].table.body[10][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_28.CESS).toFixed(2);pdfDoc.content[2].table.body[10][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_28.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[11][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.exempted.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[11][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.exempted.IGST).toFixed(2);pdfDoc.content[2].table.body[11][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.exempted.CGST).toFixed(2);pdfDoc.content[2].table.body[11][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.exempted.SGST).toFixed(2);pdfDoc.content[2].table.body[11][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.exempted.CESS).toFixed(2);pdfDoc.content[2].table.body[11][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.exempted.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[12][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.nillrated.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[12][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.nillrated.IGST).toFixed(2);pdfDoc.content[2].table.body[12][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.nillrated.CGST).toFixed(2);pdfDoc.content[2].table.body[12][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.nillrated.SGST).toFixed(2);pdfDoc.content[2].table.body[12][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.nillrated.CESS).toFixed(2);pdfDoc.content[2].table.body[12][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.nillrated.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[13][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.others.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[13][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.others.IGST).toFixed(2);pdfDoc.content[2].table.body[13][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.others.CGST).toFixed(2);pdfDoc.content[2].table.body[13][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.others.SGST).toFixed(2);pdfDoc.content[2].table.body[13][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.others.CESS).toFixed(2);pdfDoc.content[2].table.body[13][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.others.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[14][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[14][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.IGST).toFixed(2);pdfDoc.content[2].table.body[14][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.CGST).toFixed(2);pdfDoc.content[2].table.body[14][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.SGST).toFixed(2);pdfDoc.content[2].table.body[14][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.CESS).toFixed(2);pdfDoc.content[2].table.body[14][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[15][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[15][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.IGST).toFixed(2);pdfDoc.content[2].table.body[15][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.CGST).toFixed(2);pdfDoc.content[2].table.body[15][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.SGST).toFixed(2);pdfDoc.content[2].table.body[15][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.CESS).toFixed(2);pdfDoc.content[2].table.body[15][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[16][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_3.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[16][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_3.IGST).toFixed(2);pdfDoc.content[2].table.body[16][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_3.CGST).toFixed(2);pdfDoc.content[2].table.body[16][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_3.SGST).toFixed(2);pdfDoc.content[2].table.body[16][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_3.CESS).toFixed(2);pdfDoc.content[2].table.body[16][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_3.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[17][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_5.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[17][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_5.IGST).toFixed(2);pdfDoc.content[2].table.body[17][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_5.CGST).toFixed(2);pdfDoc.content[2].table.body[17][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_5.SGST).toFixed(2);pdfDoc.content[2].table.body[17][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_5.CESS).toFixed(2);pdfDoc.content[2].table.body[17][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_5.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[18][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_12.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[18][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_12.IGST).toFixed(2);pdfDoc.content[2].table.body[18][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_12.CGST).toFixed(2);pdfDoc.content[2].table.body[18][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_12.SGST).toFixed(2);pdfDoc.content[2].table.body[18][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_12.CESS).toFixed(2);pdfDoc.content[2].table.body[18][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_12.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[19][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_18.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[19][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_18.IGST).toFixed(2);pdfDoc.content[2].table.body[19][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_18.CGST).toFixed(2);pdfDoc.content[2].table.body[19][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_18.SGST).toFixed(2);pdfDoc.content[2].table.body[19][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_18.CESS).toFixed(2);pdfDoc.content[2].table.body[19][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_18.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[20][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_28.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[20][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_28.IGST).toFixed(2);pdfDoc.content[2].table.body[20][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_28.CGST).toFixed(2);pdfDoc.content[2].table.body[20][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_28.SGST).toFixed(2);pdfDoc.content[2].table.body[20][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_28.CESS).toFixed(2);pdfDoc.content[2].table.body[20][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_28.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[21][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.exempted.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[21][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.exempted.IGST).toFixed(2);pdfDoc.content[2].table.body[21][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.exempted.CGST).toFixed(2);pdfDoc.content[2].table.body[21][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.exempted.SGST).toFixed(2);pdfDoc.content[2].table.body[21][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.exempted.CESS).toFixed(2);pdfDoc.content[2].table.body[21][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.exempted.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[22][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.nillrated.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[22][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.nillrated.IGST).toFixed(2);pdfDoc.content[2].table.body[22][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.nillrated.CGST).toFixed(2);pdfDoc.content[2].table.body[22][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.nillrated.SGST).toFixed(2);pdfDoc.content[2].table.body[22][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.nillrated.CESS).toFixed(2);pdfDoc.content[2].table.body[22][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.nillrated.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[23][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.others.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[23][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.others.IGST).toFixed(2);pdfDoc.content[2].table.body[23][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.others.CGST).toFixed(2);pdfDoc.content[2].table.body[23][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.others.SGST).toFixed(2);pdfDoc.content[2].table.body[23][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.others.CESS).toFixed(2);pdfDoc.content[2].table.body[23][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.others.totalInvoiceAmount).toFixed(2);//gst1 summary
__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(metaData.gst1).forEach(function(key,index){if(index!=11){pdfDoc.content[3].table.body.push([{text:index+1,style:"Header4"},[{text:metaData.gst1[key].title,style:"Header2"},{text:metaData.gst1[key].description,style:"Header4"}],{text:metaData.gst1[key].voucherCount,style:"Header4"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gst1[key].totalBaseAmount).toFixed(2),style:"Header4"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gst1[key].ICGST).toFixed(2),style:"Header4"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gst1[key].CGST).toFixed(2),style:"Header4"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gst1[key].SGST).toFixed(2),style:"Header4"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gst1[key].CESS).toFixed(2),style:"Header4"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gst1[key].totalInvoice).toFixed(2),style:"Header4"}]);}});return pdfDoc;};var convertToPDFGST_3=function convertToPDFGST_3(metaData){var pdfDoc={content:[{text:'GST Report\n\n',style:"bigger"},{table:{widths:['*'],body:[[{text:'Firm Details',style:"header"}],[{text:[{text:'Firm Name:-         ',bold:true},{text:'Google\n'},{text:'Address:-              ',bold:true},{text:'1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n'},{text:'Mobile Number:- ',bold:true},{text:'88776655\n'},{text:'PAN No:-               ',bold:true},{text:'123456\n'},{text:'Email:-                   ',bold:true},{text:'njnjn@jnn.com\n'},{text:'GSTIN:-                 ',bold:true},{text:'123456\n'},{text:'Website:-               ',bold:true},{text:'www.123456.com\n'}]}]]}},{table:{body:[[{text:'GST Summary',style:"header",colSpan:7,decoration:'underline'},{text:'',style:"header"},{text:'',style:"header"},{text:'',style:"header"},{text:'',style:"header"},{text:'',style:"header"},{text:'',style:"header"}],[{text:'Description of Invoices',style:"gstHeader",rowSpan:2},{text:'Total Taxable Value',style:"gstHeader",rowSpan:2},{text:'TAX Amounts',style:"gstHeader",colSpan:4,rowSpan:1},{text:'',style:"gstHeader",rowSpan:2},{text:'',style:"gstHeader",rowSpan:2},{text:'',style:"gstHeader",rowSpan:2},{text:'Total Invoices',style:"gstHeader",rowSpan:2}],[{text:'Description of Invoices',style:"gstHeader"},{text:'Total Taxable Value',style:"gstHeader"},{text:'IGST A.',style:"gstHeader"},{text:'CGST A.',style:"gstHeader"},{text:'SGST A.',style:"gstHeader"},{text:'CESS',style:"gstHeader"},{text:'Total Invoices',style:"gstHeader"}],[{text:'OUTWARD SUPPLIES',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"}],[{text:'(A). Intra state',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"}],[{text:'(i). Taxable',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'GST 3%',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'GST 5%',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'GST 12%',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'GST 18%',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'GST 28%',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'(ii). Exempted',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'(iii). Nill Rated',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'(iv). Others',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'(A). Inter state',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"}],[{text:'(i). Taxable',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'GST 3%',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'GST 5%',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'GST 12%',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'GST 18%',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'GST 28%',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'(ii). Exempted',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'(iii). Nill Rated',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'(iv). Others',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'INWARD SUPPLIES',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"}],[{text:'(A). Intra state',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"}],[{text:'(i). Taxable',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'GST 3%',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'GST 5%',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'GST 12%',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'GST 18%',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'GST 28%',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'(ii). Exempted',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'(iii). Nill Rated',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'(iv). Others',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'(A). Inter state',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"}],[{text:'(i). Taxable',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'GST 3%',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'GST 5%',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'GST 12%',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'GST 18%',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'GST 28%',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'(ii). Exempted',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'(iii). Nill Rated',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'(iv). Others',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}]]},pageBreak:'after'},{table:{body:[[{text:'GSTR-3',style:"header",colSpan:9,decoration:'underline'},{text:'',style:"header"},{text:'',style:"header"},{text:'',style:"header"},{text:'',style:"header"},{text:'',style:"header"},{text:'',style:"header"},{text:'',style:"header"},{text:'',style:"header"}],[{text:'S. No',style:"gstHeader",rowSpan:2},{text:'Description',style:"gstHeader",rowSpan:2},{text:'Place of Supply',style:"gstHeader",rowSpan:2},{text:'Taxable Value',style:"gstHeader",rowSpan:2},{text:'TAX Amounts',style:"gstHeader",colSpan:4,rowSpan:1},{text:'',style:"gstHeader",rowSpan:2},{text:'',style:"gstHeader",rowSpan:2},{text:'',style:"gstHeader",rowSpan:2},{text:'Invoice Amount',style:"gstHeader",rowSpan:2}],[{text:'Description of Invoices',style:"gstHeader"},{text:'Voucher Count',style:"gstHeader"},{text:'Voucher Count',style:"gstHeader"},{text:'Total Taxable Value',style:"gstHeader"},{text:'IGST A.',style:"gstHeader"},{text:'CGST A.',style:"gstHeader"},{text:'SGST A.',style:"gstHeader"},{text:'CESS',style:"gstHeader"},{text:'Total Invoices',style:"gstHeader"}],[{text:'3.1',style:"Header2"},{text:'OUTWARD & INWARD SUPPLIES',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"}],[{text:'',style:"Header4"},{text:'(A). Outward Taxable Supplies (Taxable)',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header2"}],[{text:'',style:"Header4"},{text:'(B). Outward Taxable Supplies (Zero Rated)',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'',style:"Header4"},{text:'(C). Outward Taxable Supplies (Nill Rated or Exempt)',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'',style:"Header4"},{text:'(D). Inward Taxable Supplies (Liable To Reverse Charge)',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'',style:"Header4"},{text:'(E). NON-GST Outward Supplies',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'3.2',style:"Header2"},{text:'INTER-STATE Supplies Made To Understand Composition Taxable Persons UIN Holders',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"}],[{text:'4',style:"Header2"},{text:'ELIGIABLE ITC',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"}],[{text:'',style:"Header3"},{text:'(A). ITC Available [Full/Part]',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"}],[{text:'',style:"Header4"},{text:'(i). Imports of Goods',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'',style:"Header4"},{text:'(ii). Imports of Services',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'',style:"Header4"},{text:'(iii). Inward Supplies Liable To reverse charges',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'',style:"Header4"},{text:'(iv). Inward Supplies From ISD',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'',style:"Header4"},{text:'(v). All Other ITC',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'',style:"Header3"},{text:'(B). ITC Reserved',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"}],[{text:'',style:"Header4"},{text:'(i). As per Rules 42 & 43 of cost',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'',style:"Header4"},{text:'(ii). Others',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'',style:"Header3"},{text:'(C). Net ITC Available (A) - (B)',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"}],[{text:'',style:"Header3"},{text:'(D). InEligible ITC',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"}],[{text:'',style:"Header4"},{text:'(i). As per Section 17(s)',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'',style:"Header4"},{text:'(ii). Others',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"},{text:'0',style:"Header4"}],[{text:'5',style:"Header2"},{text:'Values Of Exempted Nill rated & NON-GST Inward Supplies',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"},{text:'0',style:"Header2"}],[{text:'',style:"Header3"},{text:'(A). From Supplier Under Composition Scheme, Exempt & Nillrated Supplies',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"}],[{text:'',style:"Header3"},{text:'(B). Non-GST Supplies',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"},{text:'0',style:"Header3"}]]}}],footer:{columns:[{text:'Powered By ACUIFY',alignment:'right',color:'#160091'}],margin:[10,10]},styles:{header:{fontSize:14,bold:true,alignment:'center'},gstHeader:{fontSize:13,bold:true,alignment:'center'},Header2:{fontSize:12,bold:true,alignment:'center'},Header3:{fontSize:11,bold:true,alignment:'center'},Header4:{fontSize:10,alignment:'center'},gstData:{fontSize:9,alignment:'center'},bigger:{fontSize:18,bold:true,alignment:'center',decoration:'underline',decorationStyle:'solid',decorationColor:'black'}}//Firm Details 
};pdfDoc.content[1].table.body[1][0].text[1].text=(metaData.firm.name?metaData.firm.name:'')+"\n";pdfDoc.content[1].table.body[1][0].text[3].text=(metaData.firm.address?metaData.firm.address:'')+"\n";pdfDoc.content[1].table.body[1][0].text[5].text=(metaData.firm.mobileNumber?metaData.firm.mobileNumber:'')+"\n";pdfDoc.content[1].table.body[1][0].text[7].text=(metaData.firm.panNumber?metaData.firm.panNumber:'')+"\n";pdfDoc.content[1].table.body[1][0].text[9].text=(metaData.firm.email?metaData.firm.email:'')+"\n";pdfDoc.content[1].table.body[1][0].text[11].text=(metaData.firm.GST_number?metaData.firm.GST_number:'')+"\n";pdfDoc.content[1].table.body[1][0].text[13].text=(metaData.firm.website?metaData.firm.website:'')+"\n";//gst summary
//outward
pdfDoc.content[2].table.body[3][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[3][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.IGST).toFixed(2);pdfDoc.content[2].table.body[3][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.CGST).toFixed(2);pdfDoc.content[2].table.body[3][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.SGST).toFixed(2);pdfDoc.content[2].table.body[3][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.CESS).toFixed(2);pdfDoc.content[2].table.body[3][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[4][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[4][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.IGST).toFixed(2);pdfDoc.content[2].table.body[4][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.CGST).toFixed(2);pdfDoc.content[2].table.body[4][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.SGST).toFixed(2);pdfDoc.content[2].table.body[4][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.CESS).toFixed(2);pdfDoc.content[2].table.body[4][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[5][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[5][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.IGST).toFixed(2);pdfDoc.content[2].table.body[5][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.CGST).toFixed(2);pdfDoc.content[2].table.body[5][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.SGST).toFixed(2);pdfDoc.content[2].table.body[5][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.CESS).toFixed(2);pdfDoc.content[2].table.body[5][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[6][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_3.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[6][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_3.IGST).toFixed(2);pdfDoc.content[2].table.body[6][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_3.CGST).toFixed(2);pdfDoc.content[2].table.body[6][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_3.SGST).toFixed(2);pdfDoc.content[2].table.body[6][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_3.CESS).toFixed(2);pdfDoc.content[2].table.body[6][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_3.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[7][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_5.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[7][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_5.IGST).toFixed(2);pdfDoc.content[2].table.body[7][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_5.CGST).toFixed(2);pdfDoc.content[2].table.body[7][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_5.SGST).toFixed(2);pdfDoc.content[2].table.body[7][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_5.CESS).toFixed(2);pdfDoc.content[2].table.body[7][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_5.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[8][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_12.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[8][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_12.IGST).toFixed(2);pdfDoc.content[2].table.body[8][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_12.CGST).toFixed(2);pdfDoc.content[2].table.body[8][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_12.SGST).toFixed(2);pdfDoc.content[2].table.body[8][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_12.CESS).toFixed(2);pdfDoc.content[2].table.body[8][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_12.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[9][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_18.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[9][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_18.IGST).toFixed(2);pdfDoc.content[2].table.body[9][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_18.CGST).toFixed(2);pdfDoc.content[2].table.body[9][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_18.SGST).toFixed(2);pdfDoc.content[2].table.body[9][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_18.CESS).toFixed(2);pdfDoc.content[2].table.body[9][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_18.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[10][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_28.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[10][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_28.IGST).toFixed(2);pdfDoc.content[2].table.body[10][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_28.CGST).toFixed(2);pdfDoc.content[2].table.body[10][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_28.SGST).toFixed(2);pdfDoc.content[2].table.body[10][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_28.CESS).toFixed(2);pdfDoc.content[2].table.body[10][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.taxable.GST_28.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[11][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.exempted.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[11][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.exempted.IGST).toFixed(2);pdfDoc.content[2].table.body[11][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.exempted.CGST).toFixed(2);pdfDoc.content[2].table.body[11][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.exempted.SGST).toFixed(2);pdfDoc.content[2].table.body[11][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.exempted.CESS).toFixed(2);pdfDoc.content[2].table.body[11][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.exempted.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[12][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.nillrated.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[12][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.nillrated.IGST).toFixed(2);pdfDoc.content[2].table.body[12][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.nillrated.CGST).toFixed(2);pdfDoc.content[2].table.body[12][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.nillrated.SGST).toFixed(2);pdfDoc.content[2].table.body[12][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.nillrated.CESS).toFixed(2);pdfDoc.content[2].table.body[12][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.nillrated.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[13][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.others.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[13][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.others.IGST).toFixed(2);pdfDoc.content[2].table.body[13][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.others.CGST).toFixed(2);pdfDoc.content[2].table.body[13][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.others.SGST).toFixed(2);pdfDoc.content[2].table.body[13][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.others.CESS).toFixed(2);pdfDoc.content[2].table.body[13][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.intraState.others.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[14][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[14][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.IGST).toFixed(2);pdfDoc.content[2].table.body[14][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.CGST).toFixed(2);pdfDoc.content[2].table.body[14][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.SGST).toFixed(2);pdfDoc.content[2].table.body[14][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.CESS).toFixed(2);pdfDoc.content[2].table.body[14][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[15][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[15][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.IGST).toFixed(2);pdfDoc.content[2].table.body[15][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.CGST).toFixed(2);pdfDoc.content[2].table.body[15][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.SGST).toFixed(2);pdfDoc.content[2].table.body[15][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.CESS).toFixed(2);pdfDoc.content[2].table.body[15][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[16][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_3.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[16][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_3.IGST).toFixed(2);pdfDoc.content[2].table.body[16][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_3.CGST).toFixed(2);pdfDoc.content[2].table.body[16][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_3.SGST).toFixed(2);pdfDoc.content[2].table.body[16][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_3.CESS).toFixed(2);pdfDoc.content[2].table.body[16][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_3.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[17][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_5.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[17][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_5.IGST).toFixed(2);pdfDoc.content[2].table.body[17][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_5.CGST).toFixed(2);pdfDoc.content[2].table.body[17][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_5.SGST).toFixed(2);pdfDoc.content[2].table.body[17][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_5.CESS).toFixed(2);pdfDoc.content[2].table.body[17][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_5.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[18][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_12.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[18][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_12.IGST).toFixed(2);pdfDoc.content[2].table.body[18][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_12.CGST).toFixed(2);pdfDoc.content[2].table.body[18][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_12.SGST).toFixed(2);pdfDoc.content[2].table.body[18][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_12.CESS).toFixed(2);pdfDoc.content[2].table.body[18][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_12.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[19][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_18.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[19][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_18.IGST).toFixed(2);pdfDoc.content[2].table.body[19][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_18.CGST).toFixed(2);pdfDoc.content[2].table.body[19][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_18.SGST).toFixed(2);pdfDoc.content[2].table.body[19][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_18.CESS).toFixed(2);pdfDoc.content[2].table.body[19][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_18.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[20][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_28.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[20][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_28.IGST).toFixed(2);pdfDoc.content[2].table.body[20][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_28.CGST).toFixed(2);pdfDoc.content[2].table.body[20][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_28.SGST).toFixed(2);pdfDoc.content[2].table.body[20][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_28.CESS).toFixed(2);pdfDoc.content[2].table.body[20][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.GST_28.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[21][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.exempted.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[21][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.exempted.IGST).toFixed(2);pdfDoc.content[2].table.body[21][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.exempted.CGST).toFixed(2);pdfDoc.content[2].table.body[21][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.exempted.SGST).toFixed(2);pdfDoc.content[2].table.body[21][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.exempted.CESS).toFixed(2);pdfDoc.content[2].table.body[21][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.exempted.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[22][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.nillrated.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[22][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.nillrated.IGST).toFixed(2);pdfDoc.content[2].table.body[22][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.nillrated.CGST).toFixed(2);pdfDoc.content[2].table.body[22][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.nillrated.SGST).toFixed(2);pdfDoc.content[2].table.body[22][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.nillrated.CESS).toFixed(2);pdfDoc.content[2].table.body[22][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.nillrated.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[23][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.others.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[23][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.others.IGST).toFixed(2);pdfDoc.content[2].table.body[23][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.others.CGST).toFixed(2);pdfDoc.content[2].table.body[23][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.others.SGST).toFixed(2);pdfDoc.content[2].table.body[23][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.others.CESS).toFixed(2);pdfDoc.content[2].table.body[23][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.others.totalInvoiceAmount).toFixed(2);//inward 
pdfDoc.content[2].table.body[24][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[24][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.IGST).toFixed(2);pdfDoc.content[2].table.body[24][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.CGST).toFixed(2);pdfDoc.content[2].table.body[24][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.SGST).toFixed(2);pdfDoc.content[2].table.body[24][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.CESS).toFixed(2);pdfDoc.content[2].table.body[24][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[25][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[25][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.IGST).toFixed(2);pdfDoc.content[2].table.body[25][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.CGST).toFixed(2);pdfDoc.content[2].table.body[25][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.SGST).toFixed(2);pdfDoc.content[2].table.body[25][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.CESS).toFixed(2);pdfDoc.content[2].table.body[25][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[26][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.taxable.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[26][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.taxable.IGST).toFixed(2);pdfDoc.content[2].table.body[26][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.taxable.CGST).toFixed(2);pdfDoc.content[2].table.body[26][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.taxable.SGST).toFixed(2);pdfDoc.content[2].table.body[26][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.taxable.CESS).toFixed(2);pdfDoc.content[2].table.body[26][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.taxable.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[27][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.taxable.GST_3.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[27][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.taxable.GST_3.IGST).toFixed(2);pdfDoc.content[2].table.body[27][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.taxable.GST_3.CGST).toFixed(2);pdfDoc.content[2].table.body[27][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.taxable.GST_3.SGST).toFixed(2);pdfDoc.content[2].table.body[27][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.taxable.GST_3.CESS).toFixed(2);pdfDoc.content[2].table.body[27][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.taxable.GST_3.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[28][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.taxable.GST_5.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[28][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.taxable.GST_5.IGST).toFixed(2);pdfDoc.content[2].table.body[28][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.taxable.GST_5.CGST).toFixed(2);pdfDoc.content[2].table.body[28][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.taxable.GST_5.SGST).toFixed(2);pdfDoc.content[2].table.body[28][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.taxable.GST_5.CESS).toFixed(2);pdfDoc.content[2].table.body[28][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.taxable.GST_5.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[29][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.taxable.GST_12.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[29][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.taxable.GST_12.IGST).toFixed(2);pdfDoc.content[2].table.body[29][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.taxable.GST_12.CGST).toFixed(2);pdfDoc.content[2].table.body[29][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.taxable.GST_12.SGST).toFixed(2);pdfDoc.content[2].table.body[29][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.taxable.GST_12.CESS).toFixed(2);pdfDoc.content[2].table.body[29][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.taxable.GST_12.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[30][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.taxable.GST_18.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[30][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.taxable.GST_18.IGST).toFixed(2);pdfDoc.content[2].table.body[30][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.taxable.GST_18.CGST).toFixed(2);pdfDoc.content[2].table.body[30][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.taxable.GST_18.SGST).toFixed(2);pdfDoc.content[2].table.body[30][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.taxable.GST_18.CESS).toFixed(2);pdfDoc.content[2].table.body[30][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.taxable.GST_18.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[31][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.taxable.GST_28.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[31][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.taxable.GST_28.IGST).toFixed(2);pdfDoc.content[2].table.body[31][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.taxable.GST_28.CGST).toFixed(2);pdfDoc.content[2].table.body[31][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.taxable.GST_28.SGST).toFixed(2);pdfDoc.content[2].table.body[31][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.taxable.GST_28.CESS).toFixed(2);pdfDoc.content[2].table.body[31][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.taxable.GST_28.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[32][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.exempted.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[32][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.exempted.IGST).toFixed(2);pdfDoc.content[2].table.body[32][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.exempted.CGST).toFixed(2);pdfDoc.content[2].table.body[32][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.exempted.SGST).toFixed(2);pdfDoc.content[2].table.body[32][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.exempted.CESS).toFixed(2);pdfDoc.content[2].table.body[32][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.exempted.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[33][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.nillrated.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[33][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.nillrated.IGST).toFixed(2);pdfDoc.content[2].table.body[33][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.nillrated.CGST).toFixed(2);pdfDoc.content[2].table.body[33][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.nillrated.SGST).toFixed(2);pdfDoc.content[2].table.body[33][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.nillrated.CESS).toFixed(2);pdfDoc.content[2].table.body[33][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.nillrated.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[34][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.others.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[34][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.others.IGST).toFixed(2);pdfDoc.content[2].table.body[34][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.others.CGST).toFixed(2);pdfDoc.content[2].table.body[34][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.others.SGST).toFixed(2);pdfDoc.content[2].table.body[34][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.others.CESS).toFixed(2);pdfDoc.content[2].table.body[34][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.intraState.others.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[35][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[35][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.IGST).toFixed(2);pdfDoc.content[2].table.body[35][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.CGST).toFixed(2);pdfDoc.content[2].table.body[35][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.SGST).toFixed(2);pdfDoc.content[2].table.body[35][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.CESS).toFixed(2);pdfDoc.content[2].table.body[35][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[36][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.taxable.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[36][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.taxable.IGST).toFixed(2);pdfDoc.content[2].table.body[36][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.taxable.CGST).toFixed(2);pdfDoc.content[2].table.body[36][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.taxable.SGST).toFixed(2);pdfDoc.content[2].table.body[36][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.taxable.CESS).toFixed(2);pdfDoc.content[2].table.body[36][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.taxable.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[37][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.taxable.GST_3.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[37][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.taxable.GST_3.IGST).toFixed(2);pdfDoc.content[2].table.body[37][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.taxable.GST_3.CGST).toFixed(2);pdfDoc.content[2].table.body[37][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.taxable.GST_3.SGST).toFixed(2);pdfDoc.content[2].table.body[37][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.taxable.GST_3.CESS).toFixed(2);pdfDoc.content[2].table.body[37][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.taxable.GST_3.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[38][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.taxable.GST_5.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[38][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.taxable.GST_5.IGST).toFixed(2);pdfDoc.content[2].table.body[38][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.taxable.GST_5.CGST).toFixed(2);pdfDoc.content[2].table.body[38][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.taxable.GST_5.SGST).toFixed(2);pdfDoc.content[2].table.body[38][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.taxable.GST_5.CESS).toFixed(2);pdfDoc.content[2].table.body[38][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.taxable.GST_5.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[39][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.taxable.GST_12.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[39][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.taxable.GST_12.IGST).toFixed(2);pdfDoc.content[2].table.body[39][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.taxable.GST_12.CGST).toFixed(2);pdfDoc.content[2].table.body[39][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.taxable.GST_12.SGST).toFixed(2);pdfDoc.content[2].table.body[39][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.taxable.GST_12.CESS).toFixed(2);pdfDoc.content[2].table.body[39][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.taxable.GST_12.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[40][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.taxable.GST_18.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[40][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.taxable.GST_18.IGST).toFixed(2);pdfDoc.content[2].table.body[40][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.taxable.GST_18.CGST).toFixed(2);pdfDoc.content[2].table.body[40][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.taxable.GST_18.SGST).toFixed(2);pdfDoc.content[2].table.body[40][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.taxable.GST_18.CESS).toFixed(2);pdfDoc.content[2].table.body[40][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.taxable.GST_18.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[41][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.taxable.GST_28.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[41][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.taxable.GST_28.IGST).toFixed(2);pdfDoc.content[2].table.body[41][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.taxable.GST_28.CGST).toFixed(2);pdfDoc.content[2].table.body[41][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.taxable.GST_28.SGST).toFixed(2);pdfDoc.content[2].table.body[41][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.taxable.GST_28.CESS).toFixed(2);pdfDoc.content[2].table.body[41][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.taxable.GST_28.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[42][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.exempted.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[42][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.exempted.IGST).toFixed(2);pdfDoc.content[2].table.body[42][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.exempted.CGST).toFixed(2);pdfDoc.content[2].table.body[42][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.exempted.SGST).toFixed(2);pdfDoc.content[2].table.body[42][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.exempted.CESS).toFixed(2);pdfDoc.content[2].table.body[42][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.exempted.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[43][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.nillrated.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[43][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.nillrated.IGST).toFixed(2);pdfDoc.content[2].table.body[43][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.nillrated.CGST).toFixed(2);pdfDoc.content[2].table.body[43][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.nillrated.SGST).toFixed(2);pdfDoc.content[2].table.body[43][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.nillrated.CESS).toFixed(2);pdfDoc.content[2].table.body[43][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.nillrated.totalInvoiceAmount).toFixed(2);pdfDoc.content[2].table.body[44][1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.others.totalBaseAmount).toFixed(2);pdfDoc.content[2].table.body[44][2].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.others.IGST).toFixed(2);pdfDoc.content[2].table.body[44][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.others.CGST).toFixed(2);pdfDoc.content[2].table.body[44][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.others.SGST).toFixed(2);pdfDoc.content[2].table.body[44][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.others.CESS).toFixed(2);pdfDoc.content[2].table.body[44][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.interState.others.totalInvoiceAmount).toFixed(2);//gst3
pdfDoc.content[3].table.body[3][2].text='-';pdfDoc.content[3].table.body[3][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.totalBaseAmount+metaData.outwardSupplies.totalBaseAmount).toFixed(2);pdfDoc.content[3].table.body[3][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.IGST+metaData.outwardSupplies.IGST).toFixed(2);pdfDoc.content[3].table.body[3][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.CGST+metaData.outwardSupplies.CGST).toFixed(2);pdfDoc.content[3].table.body[3][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.SGST+metaData.outwardSupplies.SGST).toFixed(2);pdfDoc.content[3].table.body[3][7].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.CESS+metaData.outwardSupplies.CESS).toFixed(2);pdfDoc.content[3].table.body[3][8].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.inwardSupplies.totalInvoiceAmount+metaData.outwardSupplies.totalInvoiceAmount).toFixed(2);pdfDoc.content[3].table.body[4][2].text='-';pdfDoc.content[3].table.body[4][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.totalBaseAmount+metaData.outwardSupplies.intraState.taxable.totalBaseAmount+metaData.inwardSupplies.interState.taxable.totalBaseAmount+metaData.inwardSupplies.intraState.taxable.totalBaseAmount).toFixed(2);pdfDoc.content[3].table.body[4][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.IGST+metaData.outwardSupplies.intraState.taxable.IGST+metaData.inwardSupplies.interState.taxable.IGST+metaData.inwardSupplies.intraState.taxable.IGST).toFixed(2);pdfDoc.content[3].table.body[4][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.CGST+metaData.outwardSupplies.intraState.taxable.CGST+metaData.inwardSupplies.interState.taxable.CGST+metaData.inwardSupplies.intraState.taxable.CGST).toFixed(2);pdfDoc.content[3].table.body[4][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.SGST+metaData.outwardSupplies.intraState.taxable.SGST+metaData.inwardSupplies.interState.taxable.SGST+metaData.inwardSupplies.intraState.taxable.SGST).toFixed(2);pdfDoc.content[3].table.body[4][7].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.CESS+metaData.outwardSupplies.intraState.taxable.CESS+metaData.inwardSupplies.interState.taxable.CESS+metaData.inwardSupplies.intraState.taxable.CESS).toFixed(2);pdfDoc.content[3].table.body[4][8].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.taxable.totalInvoiceAmount+metaData.outwardSupplies.intraState.taxable.totalInvoiceAmount+metaData.inwardSupplies.interState.taxable.totalInvoiceAmount+metaData.inwardSupplies.intraState.taxable.totalInvoiceAmount).toFixed(2);pdfDoc.content[3].table.body[5][2].text='-';pdfDoc.content[3].table.body[5][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.nillrated.totalBaseAmount+metaData.outwardSupplies.intraState.nillrated.totalBaseAmount).toFixed(2);pdfDoc.content[3].table.body[5][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.nillrated.IGST+metaData.outwardSupplies.intraState.nillrated.IGST).toFixed(2);pdfDoc.content[3].table.body[5][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.nillrated.CGST+metaData.outwardSupplies.intraState.nillrated.CGST).toFixed(2);pdfDoc.content[3].table.body[5][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.nillrated.SGST+metaData.outwardSupplies.intraState.nillrated.SGST).toFixed(2);pdfDoc.content[3].table.body[5][7].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.nillrated.CESS+metaData.outwardSupplies.intraState.nillrated.CESS).toFixed(2);pdfDoc.content[3].table.body[5][8].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.nillrated.totalInvoiceAmount+metaData.outwardSupplies.intraState.nillrated.totalInvoiceAmount).toFixed(2);pdfDoc.content[3].table.body[6][2].text='-';pdfDoc.content[3].table.body[6][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.exempted.totalBaseAmount+metaData.outwardSupplies.intraState.exempted.totalBaseAmount).toFixed(2);pdfDoc.content[3].table.body[6][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.exempted.IGST+metaData.outwardSupplies.intraState.exempted.IGST).toFixed(2);pdfDoc.content[3].table.body[6][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.exempted.CGST+metaData.outwardSupplies.intraState.exempted.CGST).toFixed(2);pdfDoc.content[3].table.body[6][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.exempted.SGST+metaData.outwardSupplies.intraState.exempted.SGST).toFixed(2);pdfDoc.content[3].table.body[6][7].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.exempted.CESS+metaData.outwardSupplies.intraState.exempted.CESS).toFixed(2);pdfDoc.content[3].table.body[6][8].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.exempted.totalInvoiceAmount+metaData.outwardSupplies.intraState.exempted.totalInvoiceAmount).toFixed(2);pdfDoc.content[3].table.body[8][2].text='-';pdfDoc.content[3].table.body[8][3].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.others.totalBaseAmount+metaData.outwardSupplies.intraState.others.totalBaseAmount).toFixed(2);pdfDoc.content[3].table.body[8][4].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.others.IGST+metaData.outwardSupplies.intraState.others.IGST).toFixed(2);pdfDoc.content[3].table.body[8][5].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.others.CGST+metaData.outwardSupplies.intraState.others.CGST).toFixed(2);pdfDoc.content[3].table.body[8][6].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.others.SGST+metaData.outwardSupplies.intraState.others.SGST).toFixed(2);pdfDoc.content[3].table.body[8][7].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.others.CESS+metaData.outwardSupplies.intraState.others.CESS).toFixed(2);pdfDoc.content[3].table.body[8][8].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.outwardSupplies.interState.others.totalInvoiceAmount+metaData.outwardSupplies.intraState.others.totalInvoiceAmount).toFixed(2);return pdfDoc;};var buyerStatement=function buyerStatement(metaData){var pdfDoc={content:[{text:'Statement\n\n',style:"bigger"},{table:{widths:['60%','40%'],body:[[{text:'CUSTOMER DETAILS',style:"topHeader"},{text:'FIRM DETAILS',style:"topHeader"}],[{text:[{text:'         ',bold:true},{text:'Google\n'},{text:'                 ',bold:true},{text:'123456\n'},{text:'                 ',bold:true},{text:'123456\n'},{text:'                   ',bold:true},{text:'1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n'},{text:' 		  ',bold:true},{text:'88776655\n'}]},{text:[{text:'                ',bold:true},{text:'Google\n'},{text:'                ',bold:true},{text:'GSTIN\n'},{text:'                 ',bold:true},{text:'123456\n'},{text:'                ',bold:true},{text:'7788996655\n'},{text:'                ',bold:true},{text:'1679905\n'}]}]]}},{table:{body:[[{text:'TRANSACTION SUMMARY',style:"topHeader",colSpan:8},{text:'',style:"topHeader"},{text:'',style:"topHeader"},{text:'',style:"topHeader"},{text:'',style:"topHeader"},{text:'',style:"topHeader"},{text:'',style:"topHeader"},{text:'',style:"topHeader"}],[{text:'From Date',style:"header",colSpan:2},{text:'',style:"header"},{text:'22/3/20',colSpan:2,style:"header"},{text:'',style:"header"},{text:'To Date',colSpan:2,style:"header"},{text:'',style:"header"},{text:'22/3/20',colSpan:2,style:"header"},{text:'',style:"header"}],[{text:'Date',style:"gstHeader"},// { text: 'Invoice Key', style: "gstHeader"},
{text:'Invoice Id',style:"gstHeader"},{text:'Debit',style:"gstHeader"},{text:'Credit',style:"gstHeader"},{text:'Balance',style:"gstHeader"},{text:'Payment',style:"gstHeader"},{text:'Voucher',style:"gstHeader"},{text:'Remark',style:"gstHeader"}]]}}],footer:{columns:[{text:'Powered By ACUIFY',alignment:'right',color:'#160091'}],margin:[10,10]},styles:{header:{fontSize:14,bold:true,alignment:'center'},topHeader:{color:'white',fontSize:12,alignment:'center',bold:true,fillColor:'#15155d'},gstHeader:{fontSize:13,bold:true,alignment:'center'},Header2:{fontSize:12,bold:true,alignment:'center'},Header3:{fontSize:11,bold:true,alignment:'center'},Header4:{fontSize:10,alignment:'center'},gstData:{fontSize:9,alignment:'center'},gstData1:{fontSize:9,alignment:'center',color:'#15155d',bold:true},gstData2:{fontSize:9,alignment:'center',color:'#B71C1C',bold:true},gstData3:{fontSize:9,alignment:'center',color:'#43A047',bold:true},bigger:{fontSize:18,bold:true,alignment:'center',decoration:'underline',decorationStyle:'solid',color:'#15155d'}}//Firm Details 
};pdfDoc.content[1].table.body[1][1].text[1].text=(metaData.firm.name?metaData.firm.name:'')+"\n";pdfDoc.content[1].table.body[1][1].text[3].text=(metaData.firm.GST_number?metaData.firm.GST_number:'')+"\n";pdfDoc.content[1].table.body[1][1].text[5].text=(metaData.customer.address?metaData.customer.localAddress:'')+"\n";pdfDoc.content[1].table.body[1][1].text[7].text=(metaData.firm.address?metaData.firm.address:'')+"\n";pdfDoc.content[1].table.body[1][1].text[9].text=(metaData.firm.mobileNumber?metaData.firm.mobileNumber:'')+"\n";// pdfDoc.content[1].table.body[1][0].text[7].text = (metaData.firm.panNumber ? metaData.firm.panNumber : '') + "\n";
// pdfDoc.content[1].table.body[1][0].text[11].text = (metaData.firm.email ? metaData.firm.email : '') + "\n";
// pdfDoc.content[1].table.body[1][0].text[13].text = (metaData.firm.website ? metaData.firm.website : '') + "\n";		
//Receipient Details
pdfDoc.content[1].table.body[1][0].text[1].text=(metaData.customer.name?metaData.customer.name:'')+"\n";pdfDoc.content[1].table.body[1][0].text[3].text=(metaData.customer.GST_number?metaData.customer.GST_number:'')+"\n";pdfDoc.content[1].table.body[1][0].text[5].text=(metaData.customer.address?metaData.customer.localAddress:'')+"\n";pdfDoc.content[1].table.body[1][0].text[7].text=(metaData.customer.address?metaData.customer.address:'')+"\n";pdfDoc.content[1].table.body[1][0].text[9].text=(metaData.customer.mobile?metaData.customer.mobile:'')+"\n";// pdfDoc.content[1].table.body[1][1].text[9].text = (metaData.customer.stateCode ? metaData.customer.stateCode : '') + "\n";
//from Date
pdfDoc.content[2].table.body[1][2].text=metaData.fromDate?new Date(metaData.fromDate).toLocaleDateString('en-GB'):'';//to Date
pdfDoc.content[2].table.body[1][6].text=metaData.toDate?new Date(metaData.toDate).toLocaleDateString('en-GB'):'';function getVocherType(invoice){if(invoice.return){if(invoice.isBuyer){return"Credit Note";}else{return"Debit Note";}}else if(invoice.transactionType!="Debit"&&invoice["type"]==="Advance"||invoice["type"]==="Opening Balance"||invoice["type"]==="Loan"||invoice["type"]==="Security"){return invoice["type"];}else if(invoice.isBuyer&&invoice.transactionType==="Debit"){return"Sale";}else if(invoice.isBuyer&&invoice.transactionType==="Credit"||!invoice.isBuyer&&invoice.transactionType==="Credit"){return"Receipt";}else if(!invoice.isBuyer&&invoice.transactionType==="Debit"){return"Purchase";}else if(!invoice.isBuyer&&invoice.transactionType==="Credit"||!invoice.isBuyer&&invoice.transactionType==="Credit"){return"Payment";}}//invoices 
metaData.invoices.map(function(invoice){pdfDoc.content[2].table.body.push([// { text: new Date(invoice.date).toLocaleDateString('en-GB'), style: "gstData1" },
// { text: invoice['.key'], style: "gstData" },
{text:invoice.date=='Total'?"Total":new Date(invoice.date).toLocaleDateString('en-GB'),style:"gstData1"},{text:invoice['invoiceId'],style:"gstData"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(invoice['debit']).toFixed(2),style:"gstData3"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(invoice['credit']).toFixed(2),style:"gstData1"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(invoice['RunningBal']).toFixed(2),style:"gstData2"},{text:invoice['paymentType'],style:"gstData"},{text:getVocherType(invoice),style:"gstData"},{text:invoice['remark'],style:"gstData"}]);});return pdfDoc;};// Start of Detailed Buyer Statement
var buyerStatementDetailed=function buyerStatementDetailed(metaData){var pdfDoc={content:[{text:'Statement\n\n',style:"bigger"},{table:{widths:['60%','40%'],body:[[{text:'CUSTOMER DETAILS',style:"topHeader"},{text:'FIRM DETAILS',style:"topHeader"}],[{text:[{text:'         ',bold:true},{text:'Google\n'},{text:'                 ',bold:true},{text:'123456\n'},{text:'                 ',bold:true},{text:'123456\n'},{text:'                   ',bold:true},{text:'1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n'},{text:' 		  ',bold:true},{text:'88776655\n'}]},{text:[{text:'                ',bold:true},{text:'Google\n'},{text:'                ',bold:true},{text:'GSTIN\n'},{text:'                 ',bold:true},{text:'123456\n'},{text:'                ',bold:true},{text:'7788996655\n'},{text:'                ',bold:true},{text:'1679905\n'}]}]]}},{table:{body:[[{text:'TRANSACTION SUMMARY',style:"topHeader",colSpan:8},{text:'',style:"topHeader"},{text:'',style:"topHeader"},{text:'',style:"topHeader"},{text:'',style:"topHeader"},{text:'',style:"topHeader"},{text:'',style:"topHeader"},{text:'',style:"topHeader"}],[{text:'From Date',style:"header",colSpan:2},{text:'',style:"header"},{text:'22/3/20',colSpan:2,style:"header"},{text:'',style:"header"},{text:'To Date',colSpan:2,style:"header"},{text:'',style:"header"},{text:'22/3/20',colSpan:2,style:"header"},{text:'',style:"header"}],[{text:'Date',style:"gstHeader"},// { text: 'Invoice Key', style: "gstHeader"},
{text:'Invoice Id',style:"gstHeader"},{text:'Debit',style:"gstHeader"},{text:'Credit',style:"gstHeader"},{text:'Balance',style:"gstHeader"},{text:'Payment',style:"gstHeader"},{text:'Voucher',style:"gstHeader"},{text:'Remark',style:"gstHeader"}]]}}],footer:{columns:[{text:'Powered By ACUIFY',alignment:'right',color:'#160091'}],margin:[10,10]},styles:{header:{fontSize:14,bold:true,alignment:'center'},topHeader:{color:'white',fontSize:12,alignment:'center',bold:true,fillColor:'#15155d'},topHeaderSmall:{fontSize:7,alignment:'center',bold:true},gstHeader:{fontSize:13,bold:true,alignment:'center'},Header2:{fontSize:12,bold:true,alignment:'center'},Header3:{fontSize:11,bold:true,alignment:'center'},Header4:{fontSize:10,alignment:'center'},gstData:{fontSize:9,alignment:'center',fillColor:'#808080'},gstDataSmall:{fontSize:7,alignment:'center'},gstData1:{fontSize:9,alignment:'center',color:'#15155d',bold:true,fillColor:'#808080'},gstData2:{fontSize:9,alignment:'center',color:'#B71C1C',bold:true,fillColor:'#808080'},gstData3:{fontSize:9,alignment:'center',color:'#00FF00',bold:true,fillColor:'#808080'},bigger:{fontSize:18,bold:true,alignment:'center',decoration:'underline',decorationStyle:'solid',color:'#15155d'}}//Firm Details 
};pdfDoc.content[1].table.body[1][1].text[1].text=(metaData.firm.name?metaData.firm.name:'')+"\n";pdfDoc.content[1].table.body[1][1].text[3].text=(metaData.firm.GST_number?metaData.firm.GST_number:'')+"\n";pdfDoc.content[1].table.body[1][1].text[5].text=(metaData.customer.address?metaData.customer.localAddress:'')+"\n";pdfDoc.content[1].table.body[1][1].text[7].text=(metaData.firm.address?metaData.firm.address:'')+"\n";pdfDoc.content[1].table.body[1][1].text[9].text=(metaData.firm.mobileNumber?metaData.firm.mobileNumber:'')+"\n";// pdfDoc.content[1].table.body[1][0].text[7].text = (metaData.firm.panNumber ? metaData.firm.panNumber : '') + "\n";
// pdfDoc.content[1].table.body[1][0].text[11].text = (metaData.firm.email ? metaData.firm.email : '') + "\n";
// pdfDoc.content[1].table.body[1][0].text[13].text = (metaData.firm.website ? metaData.firm.website : '') + "\n";		
//Receipient Details
pdfDoc.content[1].table.body[1][0].text[1].text=(metaData.customer.name?metaData.customer.name:'')+"\n";pdfDoc.content[1].table.body[1][0].text[3].text=(metaData.customer.GST_number?metaData.customer.GST_number:'')+"\n";pdfDoc.content[1].table.body[1][0].text[5].text=(metaData.customer.address?metaData.customer.localAddress:'')+"\n";pdfDoc.content[1].table.body[1][0].text[7].text=(metaData.customer.address?metaData.customer.address:'')+"\n";pdfDoc.content[1].table.body[1][0].text[9].text=(metaData.customer.mobile?metaData.customer.mobile:'')+"\n";// pdfDoc.content[1].table.body[1][1].text[9].text = (metaData.customer.stateCode ? metaData.customer.stateCode : '') + "\n";
//from Date
pdfDoc.content[2].table.body[1][2].text=metaData.fromDate?new Date(metaData.fromDate).toLocaleDateString('en-GB'):'';//to Date
pdfDoc.content[2].table.body[1][6].text=metaData.toDate?new Date(metaData.toDate).toLocaleDateString('en-GB'):'';function getVocherType(invoice){if(invoice.return){if(invoice.isBuyer){return"Credit Note";}else{return"Debit Note";}}else if(invoice.transactionType!="Debit"&&invoice["type"]==="Advance"||invoice["type"]==="Opening Balance"||invoice["type"]==="Loan"||invoice["type"]==="Security"){return invoice["type"];}else if(invoice.isBuyer&&invoice.transactionType==="Debit"){return"Sale";}else if(invoice.isBuyer&&invoice.transactionType==="Credit"||!invoice.isBuyer&&invoice.transactionType==="Credit"){return"Receipt";}else if(!invoice.isBuyer&&invoice.transactionType==="Debit"){return"Purchase";}else if(!invoice.isBuyer&&invoice.transactionType==="Credit"||!invoice.isBuyer&&invoice.transactionType==="Credit"){return"Payment";}}//invoices 
metaData.invoices.map(function(invoice){pdfDoc.content[2].table.body.push([// { text: new Date(invoice.date).toLocaleDateString('en-GB'), style: "gstData1" },
// { text: invoice['.key'], style: "gstData" },
{text:invoice.date=='Total'?"Total":new Date(invoice.date).toLocaleDateString('en-GB'),style:"gstData1"},{text:invoice['invoiceId'],style:"gstData"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(invoice['debit']).toFixed(2),style:"gstData3"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(invoice['credit']).toFixed(2),style:"gstData1"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(invoice['RunningBal']).toFixed(2),style:"gstData2"},{text:invoice['paymentType'],style:"gstData"},{text:getVocherType(invoice),style:"gstData"},{text:invoice['remark'],style:"gstData"}]);if(invoice.items&&invoice.items.length){pdfDoc.content[2].table.body.push([{text:"Product Name",style:"topHeaderSmall",colSpan:2},{text:"",style:"gstDataSmall"},// { text: invoice['.key'], style: "gstData" },
{text:"HSN",style:"topHeaderSmall",colSpan:2},{text:"Taxable Rate",style:"topHeaderSmall"},{text:"Unit",style:"topHeaderSmall"},{text:"Quantity",style:"topHeaderSmall"},{text:"Fat",style:"gstDataSmall"},{text:"Rate",style:"topHeaderSmall"}]);invoice.items.map(function(item){pdfDoc.content[2].table.body.push([{text:item.productName,style:"gstDataSmall",colSpan:2},{text:item['taxableGST_rate'],style:"gstDataSmall"},// { text: invoice['.key'], style: "gstDataSmall" },
{text:item['HSN_code'],style:"gstDataSmall",colSpan:2},{text:item['taxableGST_rate'],style:"gstDataSmall"},{text:item['productUnit'],style:"gstDataSmall"},{text:item['quantity'],style:"gstDataSmall"},{text:item['fat'],style:"gstDataSmall"},{text:item['rate'],style:"gstDataSmall"}]);});}});return pdfDoc;};// End of Detailed Buyer Statement
var getBase64ImageFromURL=function(){var _ref8=__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8(url){return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:return _context8.abrupt("return",new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function(resolve,reject){var img=new Image();img.setAttribute("crossOrigin","anonymous");img.onload=function(){var canvas=document.createElement("canvas");canvas.width=img.width;canvas.height=img.height;var ctx=canvas.getContext("2d");ctx.drawImage(img,0,0);var dataURL=canvas.toDataURL("image/png");resolve(dataURL);};img.onerror=function(error){reject(error);};img.src=url;}));case 1:case"end":return _context8.stop();}}},_callee8,_this);}));return function getBase64ImageFromURL(_x8){return _ref8.apply(this,arguments);};}();// End of Buyer Statment
var convertToEwayBillType2=function(){var _ref9=__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9(metaData){var pdfDoc,date,paymentDueDate,productList,gstObj,offset,logoData,invoiceImages,temp,_temp20,imgToExport,canvas,base64,_invoiceImages8,_temp21,_temp22;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:pdfDoc={content:[{table:{widths:['50%','50%'],body:[[{image:'',width:120,height:80},{text:[{text:'Firm Name\n',style:'topFirmAuthority1'},{text:'Live Address\n',style:'topFirmHeader'},{text:'Address\n',style:'topFirmHeader'},{text:'GSTIN\n',style:'topFirmHeader'},{text:'MOBILE\n',style:'topFirmHeader'},{text:'EMAIL\n',style:'topFirmHeader'}]}]]},layout:{hLineWidth:function hLineWidth(i,node){return i===0||i===node.table.body.length?2:0;},vLineWidth:function vLineWidth(i,node){return i===0||i===node.table.widths.length?2:0;},hLineColor:function hLineColor(i,node){return i===0||i===node.table.body.length?'black':'white';},vLineColor:function vLineColor(i,node){return i===0||i===node.table.widths.length?'black':'white';}}},{table:{widths:['32%','32%','*'],body:[[{text:'BILL TO',style:"topHeader"},{text:'SHIP TO',style:"topHeader"},{text:'INVOICE DETAILS',style:"topHeader"}],[{text:[{text:' ',bold:true,style:'invoiceDetails'},{text:'Google\n',style:'invoiceDetails'},{text:' ',bold:true,style:'invoiceDetails'},{text:'1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n',style:'invoiceDetails'},{text:' ',bold:true,style:'invoiceDetails'},{text:'1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n',style:'invoiceDetails'},{text:' ',bold:true,style:'invoiceDetails'},{text:'7788996655\n',style:'invoiceDetails'},{text:' ',bold:true,style:'invoiceDetails'},{text:'1679905\n',style:'invoiceDetails'},{text:' ',bold:true,style:'invoiceDetails'},{text:'23\n',style:'invoiceDetails'}]},{text:[{text:' ',bold:true,style:'invoiceDetails'},{text:'Google\n',style:'invoiceDetails'},{text:' ',bold:true,style:'invoiceDetails'},{text:'1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n',style:'invoiceDetails'},{text:' ',bold:true,style:'invoiceDetails'},{text:'1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n',style:'invoiceDetails'},{text:' ',bold:true,style:'invoiceDetails'},{text:'7788996655\n',style:'invoiceDetails'},{text:' ',bold:true,style:'invoiceDetails'},{text:'1679905\n',style:'invoiceDetails'},{text:' ',bold:true,style:'invoiceDetails'},{text:'23\n',style:'invoiceDetails'}]},{text:[{text:'Invoice No:          ',bold:true,style:'invoiceDetails'},{text:'787878\n',style:'invoiceDetails'},{text:'Invoice Date:       ',bold:true,style:'invoiceDetails'},{text:'12/12/90 \n',style:'invoiceDetails'},{text:'Invoice Status:    ',bold:true,style:'invoiceDetails'},{text:'12/12/90 \n',style:'invoiceStatusDetails'},{text:'Payment Date:    ',bold:true,style:'invoiceDetails'},{text:'13/12/90\n',style:'invoiceDetails'},{text:'Order No:             ',bold:true,style:'invoiceDetails'},{text:'787878\n',style:'invoiceDetails'},{text:'Order Date:          ',bold:true,style:'invoiceDetails'},{text:'12/12/90 \n',style:'invoiceDetails'},{text:'E-Way Bill No:     ',bold:true,style:'invoiceDetails'},{text:'787878\n',style:'invoiceDetails'},// { text: 'TRANSPORT DETAILS' ,style:'transpotationDel'},
// { text: '\n',style:'invoiceDetails' },
{text:'Vehicle No:          ',bold:true,style:'invoiceDetails'},{text:'12121212 \n',style:'invoiceDetails'},{text:'Driver Name:       ',bold:true,style:'invoiceDetails'},{text:'12121212 \n',style:'invoiceDetails'},{text:'Driver No:            ',bold:true,style:'invoiceDetails'},{text:'12121212 \n',style:'invoiceDetails'}]}]]}},{table:{widths:['7%','33%','9%','11%','10%','10%','20%'],body:[[{text:'S.NO',style:"productHeader",rowSpan:2},{text:'PRODUCT DESCRIPTION',style:"productHeader",rowSpan:2},{text:'HSN',style:"productHeader",rowSpan:2},{text:'QUANTITY',style:"productHeader",rowSpan:2},{text:'UNIT',style:"productHeader",rowSpan:2},{text:'RATE',style:"productHeader",rowSpan:2},{text:'TAXABLE AMOUNT',style:"productHeader",rowSpan:2}],[{text:'S.NO',style:"productHeader"},{text:'PRODUCT DESCRIPTION',style:"productHeader"},{text:'HSN',style:"productHeader"},{text:'QUANTITY',style:"productHeader"},{text:'UNIT',style:"productHeader"},{text:'RATE',style:"productHeader"},{text:'TAXABLE AMOUNT',style:"productHeader"}]]}},{table:{widths:['70%','*'],body:[[[{table:{body:[[{text:'HSN SUMMARY',style:"gstHeader1",colSpan:10},{text:'Qty',style:"gstHeader"},{text:'TAXABLE AMOUNT',style:"gstHeader"},{text:'%',style:"gstHeader"},{text:'AMOUNT',style:"gstHeader"},{text:'%',style:"gstHeader"},{text:'AMOUNT',style:"gstHeader"},{text:'%',style:"gstHeader"},{text:'AMOUNT',style:"gstHeader"},{text:'TOTAL AMOUNT',style:"gstHeader"}],[{text:'HSN/SAC',style:"gstHeader",rowSpan:2},{text:'QTY',style:"gstHeader",rowSpan:2},{text:'TAXABLE AMOUNT',style:"gstHeader",rowSpan:2},{text:'CGST',style:"gstHeader",colSpan:2,rowSpan:1},{text:'',style:"gstHeader",rowSpan:2},{text:'SGST',style:"gstHeader",colSpan:2,rowSpan:1},{text:'',style:"gstHeader",rowSpan:2},{text:'IGST',style:"gstHeader",colSpan:2,rowSpan:1},{text:'',style:"gstHeader",rowSpan:2},{text:'TOTAL AMOUNT',style:"gstHeader",rowSpan:2}],[{text:'HSN/SAC',style:"gstHeader"},{text:'Qty',style:"gstHeader"},{text:'Taxable Amount',style:"gstHeader"},{text:'%',style:"gstHeader"},{text:'Amount',style:"gstHeader"},{text:'%',style:"gstHeader"},{text:'Amount',style:"gstHeader"},{text:'%',style:"gstHeader"},{text:'Amount',style:"gstHeader"},{text:'Total Amount',style:"gstHeader"}]]}}],{text:[{text:'Taxable Amount     ',bold:true,style:'invoiceDetails'},{text:'12122\n',style:'invoiceDetails'},{text:'CGST Amount         ',bold:true,style:'invoiceDetails'},{text:'12122\n',style:'invoiceDetails'},{text:'SGST Amount         ',bold:true,style:'invoiceDetails'},{text:'12122\n',style:'invoiceDetails'},{text:'IGST Amount          ',bold:true,style:'invoiceDetails'},{text:'12122\n',style:'invoiceDetails'},// { text: 'Labour Charge:-                ', bold: true },
// { text: '12122\n' },
{text:'Discount                  ',bold:true,style:'invoiceDetails'},{text:'12122\n',style:'invoiceDetails'},{text:'RoundOff                 ',bold:true,style:'invoiceDetails'},{text:'12122\n',style:'invoiceDetails'},{text:'Total Amount          ',bold:true,style:'totalAmountHeader'},{text:'12122\n',style:'totalAmountHeader'},{text:'Paid Amount           ',bold:true,style:'invoiceDetails'},{text:'12122\n',style:'invoiceDetails'},{text:'Due Amount            ',bold:true,style:'invoiceStatusDetails'},{text:'12122\n',style:'invoiceStatusDetails'}]}]]},style:'tab2'},{table:{widths:['30%','40%','30%'],body:[[{text:[{text:'PAYMENT DETAILS\n',style:'transpotationDel'},{text:'',style:'invoiceDetails1'}]},{text:[{text:'TERMS AND CONDITIONS\n',style:'transpotationDel'},{text:'',style:'invoiceDetails1'}]},// {
// 	text:
[{text:''},{text:'Firm Name  ',bold:true,alignment:'center',style:'topFirmAuthority'},{text:'\n\n\n'},{text:'AUTHORITY SIGNATURE  ',bold:true,alignment:'center',style:'topFirmAuthority'},{text:'\n'}]// },
]]},layout:{hLineWidth:function hLineWidth(i,node){return i===0||i===node.table.body.length?2:0;},vLineWidth:function vLineWidth(i,node){return i===0||i===node.table.widths.length?2:0;},hLineColor:function hLineColor(i,node){return i===0||i===node.table.body.length?'black':'white';},vLineColor:function vLineColor(i,node){return i===0||i===node.table.widths.length?'black':'white';}}}],footer:{columns:[{text:'Powered By ACUIFY',alignment:'right',color:'#160091'}],margin:[10,10]},styles:{header:{fontSize:10,bold:true,alignment:'center'},productHeader:{fontSize:10,bold:true,alignment:'center',color:'#160091'},transpotationDel:{fontSize:9,bold:true,alignment:'center',color:'#160091'},gstHeader:{fontSize:8,color:'#160091',alignment:'center'},gstHeader1:{fontSize:10,color:'#160091',bold:true,alignment:'center'},product:{fontSize:9,alignment:'center'},product1:{fontSize:7,alignment:'center'},productRight:{fontSize:10,alignment:'right'// bold: true
},totalRight:{fontSize:10,alignment:'right',bold:true},total:{fontSize:10,alignment:'center',bold:true},total1:{fontSize:7,alignment:'center'},topHeader:{color:'#160091',fontSize:10,alignment:'center',bold:true},topFirmAuthority:{color:'#160091',fontSize:9,bold:true},topFirmAuthority1:{color:'#160091',fontSize:12,bold:true},topFirmHeader:{fontSize:10,bold:true},invoiceDetails:{fontSize:10,bold:true},invoiceDetails1:{fontSize:9,bold:true},totalAmountHeader:{color:'#160091',fontSize:10,bold:true},invoiceStatusDetails:{color:'#FF0000',fontSize:10,bold:true}}//Firm Details 
};pdfDoc.content[0].table.body[0][1].text[0].text=(metaData.firm.name?metaData.firm.name.toUpperCase():'')+"\n";pdfDoc.content[0].table.body[0][1].text[1].text=(metaData.firm.liveAddress?metaData.firm.liveAddress:'')+"\n";pdfDoc.content[0].table.body[0][1].text[2].text=(metaData.firm.address?metaData.firm.address:'')+"\n";pdfDoc.content[0].table.body[0][1].text[3].text=(metaData.firm.mobileNumber?metaData.firm.mobileNumber:'')+"\n";// pdfDoc.content[0].table.body[0][1].text[7].text = (metaData.firm.panNumber ? metaData.firm.panNumber : '') + "\n";
pdfDoc.content[0].table.body[0][1].text[4].text=(metaData.firm.email?metaData.firm.email:'')+"\n";pdfDoc.content[0].table.body[0][1].text[5].text=(metaData.firm.GST_number?metaData.firm.GST_number:'')+"\n";// pdfDoc.content[0].table.body[0][1].text[13].text = (metaData.firm.website ? metaData.firm.website : '') + "\n";
//Invoice Details
// let date = new Date(metaData.invoiceData.date)
// let paymentDueDate = date.setDate(date.getDate() + metaData.invoiceData.alertDuration ? metaData.invoiceData.alertDuration : 0);
date=new Date(metaData.invoiceData.date);paymentDueDate=date.setDate(date.getDate()+(metaData.invoiceData.duration?parseInt(metaData.invoiceData.duration):0));pdfDoc.content[1].table.body[1][2].text[1].text=metaData.invoiceData.invoiceId+"\n";pdfDoc.content[1].table.body[1][2].text[3].text=new Date(metaData.invoiceData.date).toLocaleDateString('en-GB').toString()+"\n";pdfDoc.content[1].table.body[1][2].text[5].text=(metaData.invoiceData.status?metaData.invoiceData.status.toUpperCase():'')+"\n";pdfDoc.content[1].table.body[1][2].text[7].text=new Date(paymentDueDate).toLocaleDateString('en-GB').toString()+"\n";pdfDoc.content[1].table.body[1][2].text[9].text=(metaData.invoiceData.orderNumber?metaData.invoiceData.orderNumber:'-')+"\n";pdfDoc.content[1].table.body[1][2].text[11].text=(metaData.invoiceData.orderDate?new Date(metaData.invoiceData.orderDate).toLocaleDateString('en-GB').toString():'-')+"\n";pdfDoc.content[1].table.body[1][2].text[13].text=(metaData.ebillDetails.billNo?metaData.ebillDetails.billNo:'')+"\n";//eway bill nu
pdfDoc.content[1].table.body[1][2].text[15].text=(metaData.transportationDetails.vehicleNo?metaData.transportationDetails.vehicleNo:'')+"\n";pdfDoc.content[1].table.body[1][2].text[17].text=(metaData.transportationDetails.driverName?metaData.transportationDetails.driverName:'')+"\n";pdfDoc.content[1].table.body[1][2].text[19].text=(metaData.transportationDetails.driverNumber?metaData.transportationDetails.driverNumber:'')+"\n";//Receipient Details
// pdfDoc.content[1].table.body[1][0].text[1].text = (metaData.customer.name ? metaData.customer.name : '') + "\n";
pdfDoc.content[1].table.body[1][0].text[1].text=getCustomerDetails(metaData,'name').toUpperCase()+"\n";pdfDoc.content[1].table.body[1][0].text[3].text=(metaData.customer.GST_number?metaData.customer.GST_number:'')+"\n";pdfDoc.content[1].table.body[1][0].text[5].text=(metaData.customer.address?metaData.customer.localAddress:'')+"\n";//pdfDoc.content[1].table.body[1][0].text[7].text = (metaData.customer.address ? metaData.customer.address : '') + "\n";
//pdfDoc.content[1].table.body[1][0].text[9].text = (metaData.customer.mobile ? metaData.customer.mobile : '') + "\n";
pdfDoc.content[1].table.body[1][0].text[7].text=getCustomerDetails(metaData,'address')+"\n";pdfDoc.content[1].table.body[1][0].text[9].text=getCustomerDetails(metaData,'mobile').toUpperCase()+"\n";pdfDoc.content[1].table.body[1][0].text[11].text=(metaData.customer.stateCode?metaData.customer.stateCode:'')+"\n";//Consignee Details
pdfDoc.content[1].table.body[1][1].text[1].text=(metaData.consignee.name?metaData.consignee.name:'')+"\n";pdfDoc.content[1].table.body[1][1].text[3].text=(metaData.consignee.address?metaData.consignee.localAddress:'')+"\n";pdfDoc.content[1].table.body[1][1].text[5].text=(metaData.consignee.address?metaData.consignee.address:'')+"\n";pdfDoc.content[1].table.body[1][1].text[7].text=(metaData.consignee.mobile?metaData.consignee.mobile:'')+"\n";pdfDoc.content[1].table.body[1][1].text[9].text=(metaData.consignee.GST_number?metaData.consignee.GST_number:'')+"\n";pdfDoc.content[1].table.body[1][1].text[11].text=(metaData.consignee.stateCode?metaData.consignee.stateCode:'')+"\n";//Products
// let productList = convertToPDFProducts(metaData.invoiceData.items,false);
productList=convertToPDFProducts(metaData.invoiceData.items,false,metaData.invoiceData,metaData);productList.map(function(item){pdfDoc.content[2].table.body.push(item);});gstObj=convertToGST(metaData.invoiceData.items);__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(gstObj).forEach(function(key){if(key!="totalObj"){pdfDoc.content[3].table.body[0][0][0].table.body.push([{text:key,style:"product1"},{text:gstObj[key].quantity,style:"product1"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj[key].basicPrice).toFixed(2),style:"product1"},{text:gstObj[key].CGST+'%',style:"product1"},{text:gstObj[key].CGST_val,style:"product1"},{text:gstObj[key].SGST+'%',style:"product1"},{text:gstObj[key].SGST_val,style:"product1"},{text:gstObj[key].IGST+'%',style:"product1"},{text:gstObj[key].IGST_val,style:"product1"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj[key].basicPrice)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj[key].GSTValue)).toFixed(2),style:"product1"}]);}});pdfDoc.content[3].table.body[0][0][0].table.body.push([{text:'Total',style:"total1"},{text:gstObj.totalObj.quantity,style:"total1"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj.totalObj.basicPrice).toFixed(2),style:"total1"},{text:'',style:"total1"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj.totalObj.CGST_val).toFixed(2),style:"total1"},{text:'',style:"total1"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj.totalObj.SGST_val).toFixed(2),style:"total1"},{text:'',style:"total1"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj.totalObj.IGST_val).toFixed(2),style:"total1"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj.totalObj.basicPrice)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj.totalObj.GSTValue)).toFixed(2),style:"total1"}]);//Bank Account Details
if(metaData.terms.banks.length){metaData.terms.banks.map(function(bankDetails){pdfDoc.content[4].table.body[0][0].text.push({text:bankDetails.bankName+"\n",style:'invoiceDetails1'});pdfDoc.content[4].table.body[0][0].text.push({text:"NAME: "+bankDetails.accountHolderName+"\n",style:'invoiceDetails1'});pdfDoc.content[4].table.body[0][0].text.push({text:"A/C NO:  "+bankDetails.accountnumber+"\n",style:'invoiceDetails1'});pdfDoc.content[4].table.body[0][0].text.push({text:"IFSC: "+bankDetails.ifsccode+"\n",style:'invoiceDetails1'});pdfDoc.content[4].table.body[0][0].text.push({text:bankDetails.address+"\n",style:'invoiceDetails1'});});}//Terms and cond
pdfDoc.content[4].table.body[0][1].text[1].text=metaData.terms.termsAndConditions;//gst details
// pdfDoc.content[5].table.body[0][1].text[1].text = (metaData.invoiceData.totalAmount ? Number.parseFloat(metaData.invoiceData.totalAmount).toFixed(2) - Number.parseFloat(metaData.gstTotal.CGST_val + metaData.gstTotal.SGST_val + metaData.gstTotal.IGST_val).toFixed(2) : '0') + "\n";
// pdfDoc.content[3].table.body[0][1].text[1].text = (metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount ? Number.parseFloat(metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount).toFixed(2) - Number.parseFloat(metaData.gstTotal.CGST_val + metaData.gstTotal.SGST_val + metaData.gstTotal.IGST_val).toFixed(2) : '0').toFixed(2) + "\n";
pdfDoc.content[3].table.body[0][1].text[1].text=(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalAmount)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.discountAmount||0)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?0:-__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraCharges))-__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraChargesGST):0)-__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.roundOffAmount||0)-(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.SGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.CGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.IGST_val))).toFixed(2)+"\n";pdfDoc.content[3].table.body[0][1].text[3].text=(metaData.gstTotal.CGST_val?(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.CGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraChargesGST)/2:0)).toFixed(2):'0.00')+"\n";pdfDoc.content[3].table.body[0][1].text[5].text=(metaData.gstTotal.SGST_val?(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.SGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraChargesGST)/2:0)).toFixed(2):'0.00')+"\n";pdfDoc.content[3].table.body[0][1].text[7].text=(metaData.gstTotal.IGST_val?(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.IGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraChargesGST):0)).toFixed(2):'0.00')+"\n";offset=0;// if(metaData.invoiceData.extraCharges && metaData.invoiceData.extraCharges.length) {
if(!metaData.invoiceData.gstOnExtraChanrges&&metaData.invoiceData.extraCharges&&metaData.invoiceData.extraCharges.length){metaData.invoiceData.extraCharges.map(function(charge){pdfDoc.content[3].table.body[0][1].text.splice(8+offset,0,{text:''+charge.name+':        ',bold:true,style:'invoiceDetails'});offset++;pdfDoc.content[3].table.body[0][1].text.splice(8+offset,0,{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(charge.amount).toFixed(2)+'\n',style:'invoiceDetails'});offset++;});}// pdfDoc.content[3].table.body[0][1].text[9].text = (metaData.invoiceData.labourAmount ? Number.parseFloat(metaData.invoiceData.labourAmount).toFixed(2) : '0') + "\n";
pdfDoc.content[3].table.body[0][1].text[9+offset].text=(metaData.invoiceData.discountAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.discountAmount).toFixed(2):'0')+"\n";pdfDoc.content[3].table.body[0][1].text[11+offset].text=(metaData.invoiceData.roundOffAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.roundOffAmount).toFixed(2):'0')+"\n";pdfDoc.content[3].table.body[0][1].text[13+offset].text=(metaData.invoiceData.totalAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalAmount).toFixed(2):'0')+"\n";pdfDoc.content[3].table.body[0][1].text[15+offset].text=(metaData.invoiceData.paidAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.paidAmount).toFixed(2):'0')+"\n";pdfDoc.content[3].table.body[0][1].text[17+offset].text=(metaData.invoiceData.remainingAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.remainingAmount).toFixed(2):'')+"\n";// pdfDoc.content[6].table.body[0][1].text[17].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";
//authority
pdfDoc.content[4].table.body[0][2][1].text=metaData.firm.name?metaData.firm.name.toUpperCase():'';if(!metaData.terms.printLogo){_context9.next=98;break;}_context9.prev=51;_context9.next=54;return getBase64ImageFromURL(metaData.terms.printLogo);case 54:logoData=_context9.sent;pdfDoc.content[0].table.body[0][0].image=logoData;invoiceImages=document.getElementById('invoiceImages');if(!(invoiceImages&&invoiceImages.files&&invoiceImages.files.length)){_context9.next=81;break;}temp={columns:[]};if(!invoiceImages.files[0]){_context9.next=66;break;}_context9.t0=temp.columns;_context9.next=63;return toBase64(invoiceImages.files[0]).catch(function(e){return Error(e);});case 63:_context9.t1=_context9.sent;_context9.t2={image:_context9.t1,width:150};_context9.t0.push.call(_context9.t0,_context9.t2);case 66:if(!invoiceImages.files[1]){_context9.next=73;break;}_context9.t3=temp.columns;_context9.next=70;return toBase64(invoiceImages.files[1]).catch(function(e){return Error(e);});case 70:_context9.t4=_context9.sent;_context9.t5={image:_context9.t4,width:150};_context9.t3.push.call(_context9.t3,_context9.t5);case 73:if(!invoiceImages.files[2]){_context9.next=80;break;}_context9.t6=temp.columns;_context9.next=77;return toBase64(invoiceImages.files[2]).catch(function(e){return Error(e);});case 77:_context9.t7=_context9.sent;_context9.t8={image:_context9.t7,width:150};_context9.t6.push.call(_context9.t6,_context9.t8);case 80:pdfDoc.content.push(temp);case 81:if(!metaData.terms.signature){_context9.next=90;break;}_temp20={columns:[]};_context9.t9=_temp20.columns;_context9.next=86;return getBase64ImageFromURL(metaData.terms.signature);case 86:_context9.t10=_context9.sent;_context9.t11={image:_context9.t10,width:150,alignment:'right'};_context9.t9.push.call(_context9.t9,_context9.t11);//pdfDoc.content.push(temp)
pdfDoc.content[4].table.body[0][2][2]=_temp20.columns[0];case 90:return _context9.abrupt("return",pdfDoc);case 93:_context9.prev=93;_context9.t12=_context9["catch"](51);console.log(_context9.t12);case 96:_context9.next=130;break;case 98:imgToExport=document.getElementById('pdfimgToExport');canvas=document.createElement('canvas');canvas.width=imgToExport.width;canvas.height=imgToExport.height;canvas.getContext('2d').drawImage(imgToExport,0,0);base64=canvas.toDataURL('image/png');pdfDoc.content[0].table.body[0][0].image=base64;_invoiceImages8=document.getElementById('invoiceImages');if(!(_invoiceImages8&&_invoiceImages8.files&&_invoiceImages8.files.length)){_context9.next=130;break;}_temp21={columns:[]};if(!_invoiceImages8.files[0]){_context9.next=115;break;}_context9.t13=_temp21.columns;_context9.next=112;return toBase64(_invoiceImages8.files[0]).catch(function(e){return Error(e);});case 112:_context9.t14=_context9.sent;_context9.t15={image:_context9.t14,width:150};_context9.t13.push.call(_context9.t13,_context9.t15);case 115:if(!_invoiceImages8.files[1]){_context9.next=122;break;}_context9.t16=_temp21.columns;_context9.next=119;return toBase64(_invoiceImages8.files[1]).catch(function(e){return Error(e);});case 119:_context9.t17=_context9.sent;_context9.t18={image:_context9.t17,width:150};_context9.t16.push.call(_context9.t16,_context9.t18);case 122:if(!_invoiceImages8.files[2]){_context9.next=129;break;}_context9.t19=_temp21.columns;_context9.next=126;return toBase64(_invoiceImages8.files[2]).catch(function(e){return Error(e);});case 126:_context9.t20=_context9.sent;_context9.t21={image:_context9.t20,width:150};_context9.t19.push.call(_context9.t19,_context9.t21);case 129:pdfDoc.content.push(_temp21);case 130:if(!metaData.terms.signature){_context9.next=139;break;}_temp22={columns:[]};_context9.t22=_temp22.columns;_context9.next=135;return getBase64ImageFromURL(metaData.terms.signature);case 135:_context9.t23=_context9.sent;_context9.t24={image:_context9.t23,width:150,alignment:'right'};_context9.t22.push.call(_context9.t22,_context9.t24);//pdfDoc.content.push(temp)
pdfDoc.content[4].table.body[0][2][2]=_temp22.columns[0];case 139:return _context9.abrupt("return",pdfDoc);case 140:case"end":return _context9.stop();}}},_callee9,_this,[[51,93]]);}));return function convertToEwayBillType2(_x9){return _ref9.apply(this,arguments);};}();// New Developent - part 3 //
var convertToEwayBillType3=function(){var _ref10=__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10(metaData){var pdfDoc,date,paymentDueDate,productList,gstObj,offset,logoData,invoiceImages,temp,_temp23,imgToExport,canvas,base64,_invoiceImages9,_temp24,_temp25;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:pdfDoc={content:[{text:'TAX INVOICE \n',style:'header'},{table:{widths:['20%','43%','37%'],body:[[{image:'sampleImage.jpg',width:100,height:80},{text:[{text:'Firm Name\n',style:'topFirmAuthority1'},{text:'Live Address\n',style:'topFirmHeader'},{text:'Address\n',style:'topFirmHeader'},{text:'GSTIN\n',style:'topFirmHeader'},{text:'MOBILE\n',style:'topFirmHeader'},{text:'EMAIL\n',style:'topFirmHeader'}]},{text:[{text:'Invoice No        :  ',bold:true,style:"invoiceDetails"},{text:'787878\n',style:"invoiceDetailsBlue"},{text:'Invoice Date     :  ',bold:true,style:"invoiceDetails"},{text:'12/12/90 \n',style:"invoiceDetails"},{text:'Invoice Status  :  ',bold:true,style:'invoiceDetails'},{text:'12/12/90 \n',style:'invoiceStatusDetails'},{text:'Due Date           :  ',bold:true,style:"invoiceDetails"},{text:'13/12/90\n',style:"invoiceDetails"},{text:'E-Way Bill No   :  ',bold:true,style:'invoiceDetails'},{text:'787878\n',style:'invoiceDetails'},{text:'Order Number  :  ',bold:true,style:'invoiceDetails'},{text:'787878\n',style:'invoiceDetails'},{text:'Order Date        :  ',bold:true,style:'invoiceDetails'},{text:'12/12/90 \n',style:'invoiceDetails'}]}]]},layout:{hLineWidth:function hLineWidth(i,node){return i===0||i===node.table.body.length?2:0;},vLineWidth:function vLineWidth(i,node){return i===0||i===node.table.widths.length?2:0;},hLineColor:function hLineColor(i,node){return i===0||i===node.table.body.length?'black':'white';},vLineColor:function vLineColor(i,node){return i===0||i===node.table.widths.length?'black':'white';}}},{table:{widths:['*'],body:[[{text:"Invoice Summary",style:'invoiceColorDetails'}]]}},// {text:'\n'},
{table:{widths:['32%','32%','*'],body:[[{text:'BILL TO',style:"topHeader"},{text:'SHIP TO',style:"topHeader"},{text:'TRANSPORTATION DETAILS',style:"topHeader"}],[{text:[{text:' ',bold:true,style:'invoiceDetails'},{text:'Google\n',style:'invoiceDetailsBlueConsignee'},{text:' ',bold:true,style:'invoiceDetails'},{text:'1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n',style:'invoiceDetails'},{text:' ',bold:true,style:'invoiceDetails'},{text:'1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n',style:'invoiceDetails'},{text:' ',bold:true,style:'invoiceDetails'},{text:'7788996655\n',style:'invoiceDetails'},{text:'Mobile Number  : ',bold:true,style:"invoiceDetails"},{text:'1679905\n',style:"invoiceDetails"},{text:'Place of Supply  : ',bold:true,style:"invoiceDetails"},{text:'23\n',style:"invoiceDetails"},{text:'State Code          : ',bold:true,style:"invoiceDetails"},{text:'23\n',style:"invoiceDetails"}]},{text:[{text:' ',bold:true,style:'invoiceDetails'},{text:'Google\n',style:'invoiceDetailsBlueConsignee'},{text:' ',bold:true,style:'invoiceDetails'},{text:'1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n',style:'invoiceDetails'},{text:' ',bold:true,style:'invoiceDetails'},{text:'1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n',style:'invoiceDetails'},{text:' ',bold:true,style:'invoiceDetails'},{text:'7788996655\n',style:'invoiceDetails'},{text:'Mobile Number  : ',bold:true,style:"invoiceDetails"},{text:'1679905\n',style:"invoiceDetails"},{text:'Place of Supply  : ',bold:true,style:"invoiceDetails"},{text:'23\n',style:"invoiceDetails"},{text:'State Code          : ',bold:true,style:"invoiceDetails"},{text:'23\n',style:"invoiceDetails"}]},{table:{widths:['40%','60%'],body:[]},layout:{hLineWidth:function hLineWidth(i,node){return 0;},vLineWidth:function vLineWidth(i,node){return 0;},hLineColor:function hLineColor(i,node){return i===0||i===node.table.body.length?'black':'white';},vLineColor:function vLineColor(i,node){return i===0||i===node.table.widths.length?'black':'white';}}}]]}},{table:{widths:['*'],body:[[{text:"Product Summary",style:'invoiceColorDetails'}]]}},//{text:'\n'},    
{table:{widths:['6%','33%','10%','11%','10%','10%','20%'],body:[[{text:'S.NO',style:"productHeader",rowSpan:2},{text:'PRODUCT DESCRIPTION',style:"productHeader",rowSpan:2},{text:'HSN/SAC',style:"productHeader",rowSpan:2},{text:'QUANTITY',style:"productHeader",rowSpan:2},{text:'UNIT',style:"productHeader",rowSpan:2},{text:'RATE',style:"productHeader",rowSpan:2},{text:'TAXABLE AMOUNT',style:"productHeader",rowSpan:2}],[{text:'S.NO',style:"productHeader"},{text:'PRODUCT DESCRIPTION',style:"productHeader"},{text:'HSN',style:"productHeader"},{text:'QUANTITY',style:"productHeader"},{text:'UNIT',style:"productHeader"},{text:'RATE',style:"productHeader"},{text:'TAXABLE AMOUNT',style:"productHeader"}]]}},{table:{widths:['*'],body:[[{text:"Other Summary",style:'invoiceColorDetails'}]]}},//{text:'\n'},
{table:{widths:['70%','*'],body:[[[{table:{body:[[{text:'HSN SUMMARY',style:"gstHeader1",colSpan:10},{text:'Qty',style:"gstHeader"},{text:'TAXABLE AMOUNT',style:"gstHeader"},{text:'%',style:"gstHeader"},{text:'AMOUNT',style:"gstHeader"},{text:'%',style:"gstHeader"},{text:'AMOUNT',style:"gstHeader"},{text:'%',style:"gstHeader"},{text:'AMOUNT',style:"gstHeader"},{text:'TOTAL TAX AMOUNT',style:"gstHeader"}],[{text:'HSN/SAC',style:"gstHeader",rowSpan:2},{text:'QTY',style:"gstHeader",rowSpan:2},{text:'TAXABLE AMOUNT',style:"gstHeader",rowSpan:2},{text:'CGST',style:"gstHeader",colSpan:2,rowSpan:1},{text:'',style:"gstHeader",rowSpan:2},{text:'SGST',style:"gstHeader",colSpan:2,rowSpan:1},{text:'',style:"gstHeader",rowSpan:2},{text:'IGST',style:"gstHeader",colSpan:2,rowSpan:1},{text:'',style:"gstHeader",rowSpan:2},{text:'TOTAL TAX AMOUNT',style:"gstHeader",rowSpan:2}],[{text:'HSN/SAC',style:"gstHeader"},{text:'Qty',style:"gstHeader"},{text:'Taxable Amount',style:"gstHeader"},{text:'%',style:"gstHeader"},{text:'Amount',style:"gstHeader"},{text:'%',style:"gstHeader"},{text:'Amount',style:"gstHeader"},{text:'%',style:"gstHeader"},{text:'Amount',style:"gstHeader"},{text:'Total Tax Amount',style:"gstHeader"}]]}}],{text:[{text:'Taxable Amount  :   ',bold:true,style:'invoiceDetails'},{text:'12122\n',style:'invoiceDetailsRight'},{text:'CGST Amount      :   ',bold:true,style:'invoiceDetails'},{text:'12122\n',style:'invoiceDetailsRight'},{text:'SGST Amount      :   ',bold:true,style:'invoiceDetails'},{text:'12122\n',style:'invoiceDetailsRight'},{text:'IGST Amount       :   ',bold:true,style:'invoiceDetails'},{text:'12122\n',style:'invoiceDetailsRight'},// { text: 'Labour Charge:-                ', bold: true },
// { text: '12122\n' },
{text:'Discount               :   ',bold:true,style:'invoiceDetails'},{text:'12122\n',style:'invoiceDetailsRight'},{text:'RoundOff              :   ',bold:true,style:'invoiceDetails'},{text:'12122\n',style:'invoiceDetailsRight'},{text:'Total Amount       :   ',bold:true,style:'totalAmountHeader'},{text:'12122\n',style:'totalAmountHeader'},{text:'Paid Amount        :   ',bold:true,style:'invoiceDetails'},{text:'12122\n',style:'invoiceDetailsRight'},{text:'Due Amount         :   ',bold:true,style:'invoiceStatusDetails'},{text:'12122\n',style:'invoiceStatusDetails'}]}]]},style:'tab2'},{table:{widths:['*'],body:[[{text:"In Words: ",style:'invoiceDetails'}]]}},{table:{widths:['30%','40%','30%'],body:[[{text:[{text:'PAYMENT DETAILS\n',style:'transpotationDelLeft'},{text:'',style:'invoiceDetails1'}]},{text:[{text:'TERMS AND CONDITIONS\n',style:'transpotationDelLeft'},{text:'',style:'invoiceDetails1'}]},// {
// 	text:
[{text:''},{text:'Firm Name  ',bold:true,alignment:'center',style:'topFirmAuthority'},{text:'\n\n\n\n'},{text:'AUTHORITY SIGNATURE  ',bold:true,alignment:'center',style:'topFirmAuthority'},{text:'\n'}]// },
]]},layout:{hLineWidth:function hLineWidth(i,node){return i===0||i===node.table.body.length?2:0;},vLineWidth:function vLineWidth(i,node){return i===0||i===node.table.widths.length?2:0;},hLineColor:function hLineColor(i,node){return i===0||i===node.table.body.length?'black':'white';},vLineColor:function vLineColor(i,node){return i===0||i===node.table.widths.length?'black':'white';}}},{table:{widths:['*'],body:[[{text:'Thank you',style:'thankyouMsg'}]]}}],footer:{columns:[{text:'Powered By ACUIFY',alignment:'right',color:'#160091'}],margin:[10,10]},styles:{header:{fontSize:15,bold:true,alignment:'center',color:'#160091'},productHeader:{fontSize:9,bold:true,alignment:'center',color:'#160091'},transpotationDel:{fontSize:9,bold:true,alignment:'center',color:'#160091'},transpotationDelLeft:{fontSize:9,bold:true,alignment:'left',color:'#160091'},gstHeader:{fontSize:8,color:'#160091',alignment:'center'},gstHeader1:{fontSize:10,color:'#160091',bold:true,alignment:'center'},product:{fontSize:9,alignment:'center',bold:true},productRight:{fontSize:10,alignment:'right'// bold: true
},totalRight:{fontSize:10,alignment:'right',bold:true},subproduct:{fontSize:9,alignment:'center'},product1:{fontSize:7,alignment:'center'},total:{fontSize:10,alignment:'center',bold:true},total1:{fontSize:7,alignment:'center'},topHeader:{color:'#160091',fontSize:11,alignment:'center',bold:true},topFirmAuthority:{color:'#160091',fontSize:9,bold:true},topFirmAuthority1:{color:'#160091',fontSize:14,bold:true},topFirmHeader:{fontSize:10,bold:true},invoiceDetails:{fontSize:10,bold:true},invoiceDetailsRight:{fontSize:10,bold:true,alignment:'right'},invoiceColorDetails:{fontSize:12,color:'white',bold:true,alignment:'center'},invoiceDetailsBlue:{fontSize:10,bold:true,color:'#160091'},invoiceDetailsBlueConsignee:{fontSize:11,bold:true,color:'#160091'},invoiceDetails1:{fontSize:9,bold:true},totalAmountHeader:{color:'#160091',fontSize:10,bold:true},invoiceStatusDetails:{color:'#FF0000',fontSize:10,bold:true},thankyouMsg:{color:'#160091',fontSize:12,bold:true,alignment:'center'}}//Firm Details 
};pdfDoc.content[1].table.body[0][1].text[0].text=(metaData.firm.name?metaData.firm.name.toUpperCase():'')+"\n";pdfDoc.content[1].table.body[0][1].text[1].text=(metaData.firm.GST_number?metaData.firm.GST_number:'')+"\n";pdfDoc.content[1].table.body[0][1].text[2].text=(metaData.firm.liveAddress?metaData.firm.liveAddress:'')+"\n";pdfDoc.content[1].table.body[0][1].text[3].text=(metaData.firm.address?metaData.firm.address:'')+"\n";pdfDoc.content[1].table.body[0][1].text[4].text=(metaData.firm.mobileNumber?metaData.firm.mobileNumber:'')+"\n";// pdfDoc.content[0].table.body[0][1].text[7].text = (metaData.firm.panNumber ? metaData.firm.panNumber : '') + "\n";
pdfDoc.content[1].table.body[0][1].text[5].text=(metaData.firm.email?metaData.firm.email:'')+"\n";// pdfDoc.content[0].table.body[0][1].text[13].text = (metaData.firm.website ? metaData.firm.website : '') + "\n";
//Firm Details 
// pdfDoc.content[0].table.body[0][2].text[0].text = (metaData.firm.name ? (metaData.firm.name).toUpperCase() : '') + "\n";
// pdfDoc.content[0].table.body[0][2].text[1].text = (metaData.firm.liveAddress ? metaData.firm.liveAddress : '') + "\n";
// pdfDoc.content[0].table.body[0][2].text[2].text = (metaData.firm.address ? metaData.firm.address : '') + "\n";
// pdfDoc.content[0].table.body[0][2].text[3].text = (metaData.firm.mobileNumber ? metaData.firm.mobileNumber : '') + "\n";
// pdfDoc.content[0].table.body[0][1].text[7].text = (metaData.firm.panNumber ? metaData.firm.panNumber : '') + "\n";
// pdfDoc.content[0].table.body[0][2].text[4].text = (metaData.firm.email ? metaData.firm.email : '') + "\n";
// pdfDoc.content[0].table.body[0][2].text[5].text = (metaData.firm.GST_number ? metaData.firm.GST_number : '') + "\n";
// pdfDoc.content[0].table.body[0][1].text[13].text = (metaData.firm.website ? metaData.firm.website : '') + "\n";
//Invoice Details
// let date = new Date(metaData.invoiceData.date)
// let paymentDueDate = date.setDate(date.getDate() + metaData.invoiceData.duration ? metaData.invoiceData.duration : 0);
date=new Date(metaData.invoiceData.date);paymentDueDate=date.setDate(date.getDate()+(metaData.invoiceData.duration?parseInt(metaData.invoiceData.duration):0));pdfDoc.content[1].table.body[0][2].text[1].text=metaData.invoiceData.invoiceId+"\n";pdfDoc.content[1].table.body[0][2].text[3].text=new Date(metaData.invoiceData.date).toLocaleDateString('en-GB').toString()+"\n";pdfDoc.content[1].table.body[0][2].text[5].text=(metaData.invoiceData.status?metaData.invoiceData.status.toUpperCase():'')+"\n";pdfDoc.content[1].table.body[0][2].text[7].text=new Date(paymentDueDate).toLocaleDateString('en-GB').toString()+"\n";pdfDoc.content[1].table.body[0][2].text[9].text=(metaData.ebillDetails.billNo?metaData.ebillDetails.billNo:'')+"\n";//eway bill nu
pdfDoc.content[1].table.body[0][2].text[11].text=(metaData.invoiceData.orderNumber?metaData.invoiceData.orderNumber:'-')+"\n";pdfDoc.content[1].table.body[0][2].text[13].text=(metaData.invoiceData.orderDate?new Date(metaData.invoiceData.orderDate).toLocaleDateString('en-GB').toString():'-')+"\n";// pdfDoc.content[1].table.body[1][2].text[15].text = (metaData.transportationDetails.vehicleNo ? metaData.transportationDetails.vehicleNo : '') + "\n";
// pdfDoc.content[1].table.body[1][2].text[17].text = (metaData.transportationDetails.driverName ? metaData.transportationDetails.driverName : '') + "\n";
// pdfDoc.content[1].table.body[1][2].text[19].text = (metaData.transportationDetails.driverNumber ? metaData.transportationDetails.driverNumber : '') + "\n";
if(metaData.transportationDetails.transporterName){pdfDoc.content[3].table.body[1][2].table.body.push([{text:'Transporter  :',style:"invoiceDetails"},{text:metaData.transportationDetails.transporterName,style:"invoiceDetails"}]);}if(metaData.transportationDetails.goodsReceiptNumber){pdfDoc.content[3].table.body[1][2].table.body.push([{text:'GR/LR No     :',style:"invoiceDetails"},{text:metaData.transportationDetails.goodsReceiptNumber,style:"invoiceDetails"}]);}if(metaData.transportationDetails.vehicleNo){pdfDoc.content[3].table.body[1][2].table.body.push([{text:'Vehicle No    :',style:"invoiceDetails"},{text:metaData.transportationDetails.vehicleNo.toUpperCase(),style:"invoiceDetails"}]);}if(metaData.transportationDetails.driverName){pdfDoc.content[3].table.body[1][2].table.body.push([{text:'Driver Name :',style:"invoiceDetails"},{text:metaData.transportationDetails.driverName,style:"invoiceDetails"}]);}if(metaData.transportationDetails.driverNumber){pdfDoc.content[3].table.body[1][2].table.body.push([{text:'Driver M.No  :',style:"invoiceDetails"},{text:metaData.transportationDetails.driverNumber,style:"invoiceDetails"}]);}if(metaData.transportationDetails.remark){pdfDoc.content[3].table.body[1][2].table.body.push([{text:'Delivery Terms :',style:"invoiceDetails"},{text:metaData.transportationDetails.remark,style:"invoiceDetails"}]);}if(metaData.transportationDetails.supplyDate){pdfDoc.content[3].table.body[1][2].table.body.push([{text:'Delivery Terms :',style:"invoiceDetails"},{text:new Date(metaData.transportationDetails.supplyDate).toLocaleDateString('en-GB').toString(),style:"invoiceDetails"}]);}// pdfDoc.content[3].table.body[1][2].text[1].text = (metaData.transportationDetails.transporterName ? metaData.transportationDetails.transporterName : '') + "\n";
// pdfDoc.content[3].table.body[1][2].text[3].text = (metaData.transportationDetails.goodsReceiptNumber ? metaData.transportationDetails.goodsReceiptNumber : '') + "\n";
// pdfDoc.content[3].table.body[1][2].text[5].text = (metaData.transportationDetails.vehicleNo ? metaData.transportationDetails.vehicleNo : '').toUpperCase() + "\n";
// pdfDoc.content[3].table.body[1][2].text[7].text = (metaData.transportationDetails.driverName ? metaData.transportationDetails.driverName : '') + "\n";
// pdfDoc.content[3].table.body[1][2].text[9].text = (metaData.transportationDetails.driverNumber ? metaData.transportationDetails.driverNumber : '') + "\n";
// pdfDoc.content[3].table.body[1][2].text[11].text = (metaData.invoiceData.remark ? metaData.invoiceData.remark : '') + "\n";
// pdfDoc.content[3].table.body[1][2].text[13].text = (metaData.transportationDetails.supplyDate ? new Date(metaData.transportationDetails.supplyDate).toLocaleDateString('en-GB').toString() : '') + "\n";
//Receipient Details
// pdfDoc.content[3].table.body[1][0].text[1].text = (metaData.customer.name ? (metaData.customer.name).toUpperCase() : '') + "\n";
pdfDoc.content[3].table.body[1][0].text[1].text=getCustomerDetails(metaData,'name').toUpperCase()+"\n";pdfDoc.content[3].table.body[1][0].text[3].text=(metaData.customer.GST_number?metaData.customer.GST_number:'')+"\n";pdfDoc.content[3].table.body[1][0].text[5].text=(metaData.customer.localAddress?metaData.customer.localAddress:'')+"\n";// pdfDoc.content[3].table.body[1][0].text[7].text = (metaData.customer.address ? metaData.customer.address : '') + "\n";
// pdfDoc.content[3].table.body[1][0].text[9].text = (metaData.customer.mobile ? metaData.customer.mobile : '') + "\n";
pdfDoc.content[3].table.body[1][0].text[7].text=getCustomerDetails(metaData,'address')+"\n";pdfDoc.content[3].table.body[1][0].text[9].text=getCustomerDetails(metaData,'mobile').toUpperCase()+"\n";pdfDoc.content[3].table.body[1][0].text[11].text=(metaData.invoiceData.placeOfSupply?metaData.invoiceData.placeOfSupply:'')+"\n";pdfDoc.content[3].table.body[1][0].text[13].text=(metaData.consignee.stateCode?metaData.consignee.stateCode:'')+"\n";//Consignee Details
pdfDoc.content[3].table.body[1][1].text[1].text=(metaData.consignee.name?metaData.consignee.name.toUpperCase():'')+"\n";pdfDoc.content[3].table.body[1][1].text[3].text=(metaData.consignee.GST_number?metaData.consignee.GST_number:'')+"\n";pdfDoc.content[3].table.body[1][1].text[5].text=(metaData.consignee.localAddress?metaData.consignee.localAddress:metaData.customer.localAddress)+"\n";pdfDoc.content[3].table.body[1][1].text[7].text=(metaData.consignee.address?metaData.consignee.address:'')+"\n";pdfDoc.content[3].table.body[1][1].text[9].text=(metaData.consignee.mobile?metaData.consignee.mobile:'')+"\n";pdfDoc.content[3].table.body[1][1].text[11].text=(metaData.invoiceData.placeOfSupply?metaData.invoiceData.placeOfSupply:'')+"\n";pdfDoc.content[3].table.body[1][1].text[13].text=(metaData.consignee.stateCode?metaData.consignee.stateCode:'')+"\n";//Products
productList=convertToPDFProductForSimplePrint(metaData.invoiceData.items,false,false,false,false,false,false,metaData.invoiceData);productList.map(function(item){pdfDoc.content[5].table.body.push(item);});gstObj=convertToGST(metaData.invoiceData.items);__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(gstObj).forEach(function(key){if(key!="totalObj"){pdfDoc.content[7].table.body[0][0][0].table.body.push([{text:key,style:"product1"},{text:gstObj[key].quantity,style:"product1"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj[key].basicPrice).toFixed(2),style:"product1"},{text:gstObj[key].CGST+'%',style:"product1"},{text:gstObj[key].CGST_val.toFixed(2),style:"product1"},{text:gstObj[key].SGST+'%',style:"product1"},{text:gstObj[key].SGST_val.toFixed(2),style:"product1"},{text:gstObj[key].IGST+'%',style:"product1"},{text:gstObj[key].IGST_val.toFixed(2),style:"product1"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj[key].GSTValue).toFixed(2),style:"product1"}]);}});pdfDoc.content[7].table.body[0][0][0].table.body.push([{text:'Total',style:"total1"},{text:gstObj.totalObj.quantity,style:"total1"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj.totalObj.basicPrice).toFixed(2),style:"total1"},{text:'',style:"total1"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj.totalObj.CGST_val).toFixed(2),style:"total1"},{text:'',style:"total1"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj.totalObj.SGST_val).toFixed(2),style:"total1"},{text:'',style:"total1"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj.totalObj.IGST_val).toFixed(2),style:"total1"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj.totalObj.GSTValue).toFixed(2),style:"total1"}]);//Bank Account Details
if(metaData.terms.banks.length){metaData.terms.banks.map(function(bankDetails){pdfDoc.content[9].table.body[0][0].text.push({text:bankDetails.bankName+"\n",style:'invoiceDetails1'});pdfDoc.content[9].table.body[0][0].text.push({text:"NAME: "+bankDetails.accountHolderName+"\n",style:'invoiceDetails1'});pdfDoc.content[9].table.body[0][0].text.push({text:"A/C NO:  "+bankDetails.accountnumber+"\n",style:'invoiceDetails1'});pdfDoc.content[9].table.body[0][0].text.push({text:"IFSC: "+bankDetails.ifsccode+"\n",style:'invoiceDetails1'});pdfDoc.content[9].table.body[0][0].text.push({text:bankDetails.accountLocation+"\n",style:'invoiceDetails1'});});}pdfDoc.content[8].table.body[0][0].text="In Words: "+_.startCase(Object(__WEBPACK_IMPORTED_MODULE_6__digitsToWords_js__["a" /* digitsToWords */])(metaData.invoiceData.totalAmount));//Terms and cond
pdfDoc.content[9].table.body[0][1].text[1].text=metaData.terms.termsAndConditions;//gst details
// pdfDoc.content[5].table.body[0][1].text[1].text = (metaData.invoiceData.totalAmount ? Number.parseFloat(metaData.invoiceData.totalAmount).toFixed(2) - Number.parseFloat(metaData.gstTotal.CGST_val + metaData.gstTotal.SGST_val + metaData.gstTotal.IGST_val).toFixed(2) : '0') + "\n";
// pdfDoc.content[3].table.body[0][1].text[1].text = (metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount ? Number.parseFloat(metaData.invoiceData.totalAmount - metaData.invoiceData.roundOffAmount).toFixed(2) - Number.parseFloat(metaData.gstTotal.CGST_val + metaData.gstTotal.SGST_val + metaData.gstTotal.IGST_val).toFixed(2) : '0').toFixed(2) + "\n";
pdfDoc.content[7].table.body[0][1].text[1].text=(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalAmount)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.discountAmount||0)-__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraCharges||0)-__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.roundOffAmount||0)-(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.SGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.CGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.IGST_val))).toFixed(2)+"\n";pdfDoc.content[7].table.body[0][1].text[3].text=(metaData.gstTotal.CGST_val?(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.CGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraChargesGST)/2:0)).toFixed(2):'0.00')+"\n";pdfDoc.content[7].table.body[0][1].text[5].text=(metaData.gstTotal.SGST_val?(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.SGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraChargesGST)/2:0)).toFixed(2):'0.00')+"\n";pdfDoc.content[7].table.body[0][1].text[7].text=(metaData.gstTotal.IGST_val?(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.IGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraChargesGST):0)).toFixed(2):'0.00')+"\n";offset=0;if(!metaData.invoiceData.gstOnExtraChanrges&&metaData.invoiceData.extraCharges&&metaData.invoiceData.extraCharges.length){metaData.invoiceData.extraCharges.map(function(charge){pdfDoc.content[7].table.body[0][1].text.splice(8+offset,0,{text:''+charge.name+':        ',bold:true,style:'invoiceDetails'});offset++;pdfDoc.content[7].table.body[0][1].text.splice(8+offset,0,{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(charge.amount).toFixed(2)+'\n',style:'invoiceDetails'});offset++;});}// pdfDoc.content[3].table.body[0][1].text[9].text = (metaData.invoiceData.labourAmount ? Number.parseFloat(metaData.invoiceData.labourAmount).toFixed(2) : '0') + "\n";
pdfDoc.content[7].table.body[0][1].text[9+offset].text=(metaData.invoiceData.discountAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.discountAmount).toFixed(2):'0')+"\n";pdfDoc.content[7].table.body[0][1].text[11+offset].text=(metaData.invoiceData.roundOffAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.roundOffAmount).toFixed(2):'0')+"\n";pdfDoc.content[7].table.body[0][1].text[13+offset].text=(metaData.invoiceData.totalAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalAmount).toFixed(2):'0')+"\n";pdfDoc.content[7].table.body[0][1].text[15+offset].text=(metaData.invoiceData.paidAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.paidAmount).toFixed(2):'0')+"\n";pdfDoc.content[7].table.body[0][1].text[17+offset].text=(metaData.invoiceData.remainingAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.remainingAmount).toFixed(2):'')+"\n";//thank you
// pdfDoc.content[7].table.body[0][0].text =  "Thank You " + (metaData.customer.name.toUpperCase() ? metaData.customer.name.toUpperCase() : '') +" For Choosing us!" ;
// pdfDoc.content[10].table.body[0][0].text =  metaData.terms.termsAndConditions.greetingMessage || ("Thank You " + ((metaData.customer && metaData.customer.name )? metaData.customer.name.toUpperCase() : '') +" For doing business with us!" );
// pdfDoc.content[6].table.body[0][1].text[17].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";
pdfDoc.content[10].table.body[0][0].text=metaData.terms.termsAndConditions.greetingMessage||"Thank You "+getCustomerDetails(metaData,'name').toUpperCase()+" For your business with us!";//authority
pdfDoc.content[9].table.body[0][2][1].text=metaData.firm.name?metaData.firm.name.toUpperCase():'';if(!metaData.terms.printLogo){_context10.next=106;break;}_context10.prev=59;_context10.next=62;return getBase64ImageFromURL(metaData.terms.printLogo);case 62:logoData=_context10.sent;pdfDoc.content[1].table.body[0][0].image=logoData;invoiceImages=document.getElementById('invoiceImages');if(!(invoiceImages&&invoiceImages.files&&invoiceImages.files.length)){_context10.next=89;break;}temp={columns:[]};if(!invoiceImages.files[0]){_context10.next=74;break;}_context10.t0=temp.columns;_context10.next=71;return toBase64(invoiceImages.files[0]).catch(function(e){return Error(e);});case 71:_context10.t1=_context10.sent;_context10.t2={image:_context10.t1,width:150};_context10.t0.push.call(_context10.t0,_context10.t2);case 74:if(!invoiceImages.files[1]){_context10.next=81;break;}_context10.t3=temp.columns;_context10.next=78;return toBase64(invoiceImages.files[1]).catch(function(e){return Error(e);});case 78:_context10.t4=_context10.sent;_context10.t5={image:_context10.t4,width:150};_context10.t3.push.call(_context10.t3,_context10.t5);case 81:if(!invoiceImages.files[2]){_context10.next=88;break;}_context10.t6=temp.columns;_context10.next=85;return toBase64(invoiceImages.files[2]).catch(function(e){return Error(e);});case 85:_context10.t7=_context10.sent;_context10.t8={image:_context10.t7,width:150};_context10.t6.push.call(_context10.t6,_context10.t8);case 88:pdfDoc.content.push(temp);case 89:if(!metaData.terms.signature){_context10.next=98;break;}_temp23={columns:[]};_context10.t9=_temp23.columns;_context10.next=94;return getBase64ImageFromURL(metaData.terms.signature);case 94:_context10.t10=_context10.sent;_context10.t11={image:_context10.t10,width:150,alignment:'right'};_context10.t9.push.call(_context10.t9,_context10.t11);//pdfDoc.content.push(temp)
pdfDoc.content[4].table.body[0][2][2]=_temp23.columns[0];case 98:return _context10.abrupt("return",pdfDoc);case 101:_context10.prev=101;_context10.t12=_context10["catch"](59);console.log(_context10.t12);case 104:_context10.next=138;break;case 106:imgToExport=document.getElementById('pdfimgToExport');canvas=document.createElement('canvas');canvas.width=imgToExport.width;canvas.height=imgToExport.height;canvas.getContext('2d').drawImage(imgToExport,0,0);base64=canvas.toDataURL('image/png');pdfDoc.content[1].table.body[0][0].image=base64;_invoiceImages9=document.getElementById('invoiceImages');if(!(_invoiceImages9&&_invoiceImages9.files&&_invoiceImages9.files.length)){_context10.next=138;break;}_temp24={columns:[]};if(!_invoiceImages9.files[0]){_context10.next=123;break;}_context10.t13=_temp24.columns;_context10.next=120;return toBase64(_invoiceImages9.files[0]).catch(function(e){return Error(e);});case 120:_context10.t14=_context10.sent;_context10.t15={image:_context10.t14,width:150};_context10.t13.push.call(_context10.t13,_context10.t15);case 123:if(!_invoiceImages9.files[1]){_context10.next=130;break;}_context10.t16=_temp24.columns;_context10.next=127;return toBase64(_invoiceImages9.files[1]).catch(function(e){return Error(e);});case 127:_context10.t17=_context10.sent;_context10.t18={image:_context10.t17,width:150};_context10.t16.push.call(_context10.t16,_context10.t18);case 130:if(!_invoiceImages9.files[2]){_context10.next=137;break;}_context10.t19=_temp24.columns;_context10.next=134;return toBase64(_invoiceImages9.files[2]).catch(function(e){return Error(e);});case 134:_context10.t20=_context10.sent;_context10.t21={image:_context10.t20,width:150};_context10.t19.push.call(_context10.t19,_context10.t21);case 137:pdfDoc.content.push(_temp24);case 138:if(!metaData.terms.signature){_context10.next=147;break;}_temp25={columns:[]};_context10.t22=_temp25.columns;_context10.next=143;return getBase64ImageFromURL(metaData.terms.signature);case 143:_context10.t23=_context10.sent;_context10.t24={image:_context10.t23,width:150,alignment:'right'};_context10.t22.push.call(_context10.t22,_context10.t24);//pdfDoc.content.push(temp)
pdfDoc.content[4].table.body[0][2][2]=_temp25.columns[0];case 147:return _context10.abrupt("return",pdfDoc);case 148:case"end":return _context10.stop();}}},_callee10,_this,[[59,101]]);}));return function convertToEwayBillType3(_x10){return _ref10.apply(this,arguments);};}();// end of New Development Part -3 
var convertToPDFProductForSimplePrint=function convertToPDFProductForSimplePrint(items,isTradeDiscount,isSpecialCharge,isGrossWeight,isNetWeight,isLessStone,isPurity,purityRemark,isGSTGroupingDisabled,isTotalAmount,invoiceData){var productList=[];var totalObj={quantity:0,basicPrice:0,totlePrice:0,CGST_val:0,SGST_val:0,IGST_val:0,tradeDiscount:0,specialCharge:0,netWeight:0,purity:100,grossWeight:0,lessStone:0,taxableGST_rate:0,totalAmount:0};var lastIndex=0;items.map(function(item,index){var product=[];lastIndex=index;var totalAmount=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.basicPrice)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);product.push({text:index+1,style:"product"});product.push({text:item.productName+(item.subDescription?"\n"+item.subDescription+"\n":""),alignment:'left',fontSize:'10'});product.push({text:item.HSN_code,style:"product"});if(isGSTGroupingDisabled){product.push({text:item.taxableGST_rate+" %",style:"product"});}product.push({text:item.quantity,style:"productRight"});product.push({text:item.unit,style:"product"});if(isPurity){product.push({text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.purity).toFixed(2),style:"productRight"});}if(purityRemark){product.push({text:item.purityRemark,style:"productRight"});}if(isGrossWeight){product.push({text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.grossWeight).toFixed(3),style:"productRight"});}if(isNetWeight){var netWeight=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()((item.grossWeight-item.lessStone)*(item.purity/100))).toFixed(3);product.push({text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(netWeight).toFixed(3),style:"productRight"});}if(isLessStone){product.push({text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.lessStone).toFixed(3),style:"productRight"});}product.push({text:item.rate,style:"productRight"});if(isSpecialCharge){var percentage=Math.abs(100*item.specialCharge/(item.basicPrice-item.specialCharge)).toFixed(2);product.push({text:percentage,style:"productRight"});}if(isTradeDiscount){product.push({text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.tradeDiscount).toFixed(2),style:"productRight"});}product.push({text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.basicPrice).toFixed(2),style:"productRight"});if(isTotalAmount){product.push({text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2),style:"productRight"});}totalObj.quantity+=item.quantity;totalObj.basicPrice+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.basicPrice);totalObj.CGST_val+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.CGST_val);totalObj.SGST_val+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.SGST_val);totalObj.IGST_val+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.IGST_val);totalObj.tradeDiscount+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.tradeDiscount);totalObj.specialCharge+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.specialCharge);totalObj.grossWeight+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.grossWeight);totalObj.netWeight+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.netWeight);totalObj.totalAmount+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(totalAmount);productList.push(product);});if(invoiceData.gstOnExtraChanrges){var isIGST=invoiceData.gstType=='IGST'?true:false;invoiceData.extraCharges.map(function(item,index){var product=[];var totalAmount=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.amount)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);product.push({text:lastIndex+1,style:"product"});product.push({text:item.name+(item.subDescription?"\n"+item.subDescription+"\n":""),alignment:'left',fontSize:'10'});product.push({text:"",style:"product"});if(isGSTGroupingDisabled){product.push({text:item.gst+" %",style:"product"});}product.push({text:"",style:"productRight"});product.push({text:"",style:"product"});if(isPurity){product.push({text:"",style:"productRight"});}if(purityRemark){product.push({text:"",style:"productRight"});}if(isGrossWeight){product.push({text:"",style:"productRight"});}if(isNetWeight){product.push({text:"",style:"productRight"});}if(isLessStone){product.push({text:"",style:"productRight"});}product.push({text:"",style:"productRight"});if(isSpecialCharge){product.push({text:"",style:"productRight"});}if(isTradeDiscount){product.push({text:"",style:"productRight"});}product.push({text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.amount).toFixed(2),style:"productRight"});if(isTotalAmount){product.push({text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2),style:"productRight"});}totalObj.quantity+=0;totalObj.basicPrice+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.amount);if(isIGST){totalObj.IGST_val+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.gstAmount);}else{totalObj.CGST_val+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.gstAmount/2);totalObj.SGST_val+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.gstAmount/2);}totalObj.tradeDiscount+=0;totalObj.specialCharge+=0;totalObj.netWeight+=0;totalObj.grossWeight+=0;totalObj.totalAmount+=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(totalAmount);productList.push(product);});}var temp=[{text:'',style:"product"},{text:'Total',style:"total"},{text:'',style:"product"}];if(isGSTGroupingDisabled){temp.push({text:'',style:"product"});}temp.push({text:totalObj.quantity.toFixed(2),style:"productRight"});temp.push({text:'',style:"product"});if(isPurity){temp.push({text:'',style:"totalRight"});}if(purityRemark){temp.push({text:'',style:"totalRight"});}if(isGrossWeight){temp.push({text:totalObj.grossWeight.toFixed(3),style:"totalRight"});}if(isNetWeight){temp.push({text:totalObj.netWeight.toFixed(3),style:"totalRight"});}if(isLessStone){temp.push({text:'',style:"totalRight"});}temp.push({text:'',style:"product"});if(isSpecialCharge){temp.push({text:'',style:"totalRight"});}if(isTradeDiscount){temp.push({text:totalObj.tradeDiscount.toFixed(2),style:"totalRight"});}temp.push({text:totalObj.basicPrice.toFixed(2),style:"totalRight"});if(isTotalAmount){temp.push({text:totalObj.totalAmount.toFixed(2),style:"totalRight"});}productList.push(temp);return productList;};// Start - Simple Print
var convertToSimpleInvoicePrint=function(){var _ref11=__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11(metaData){var pdfDoc,date,paymentDueDate,isTradeDiscount,isSpecialCharge,isGrossWeight,isNetWeight,isLessStone,isPurity,purityRemark,isGSTGroupingDisabled,isTotalAmount,productList,gstObj,offset,logoData,invoiceImages,temp,_temp26,imgToExport,canvas,base64,_invoiceImages10,_temp27,_temp28;return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:pdfDoc={content:[{text:'TAX INVOICE',style:'header'},{table:{widths:['50%','50%'],body:[[{image:'sampleImage.jpg',width:100,height:80},{text:[{text:'Firm Name\n',style:'topFirmAuthority1Right'},{text:'Live Address\n',style:'topFirmHeaderRight'},{text:'Address\n',style:'topFirmHeaderRight'},{text:'GSTIN\n',style:'topFirmHeaderRight'},{text:'MOBILE\n',style:'topFirmHeaderRight'},{text:'EMAIL\n',style:'topFirmHeaderRight'}]}]]},layout:{hLineWidth:function hLineWidth(i,node){return i===0||i===node.table.body.length?2:0;},vLineWidth:function vLineWidth(i,node){return i===0||i===node.table.widths.length?2:0;},hLineColor:function hLineColor(i,node){return i===0||i===node.table.body.length?'black':'white';},vLineColor:function vLineColor(i,node){return i===0||i===node.table.widths.length?'black':'white';}}},// {text:'\n'},
{table:{widths:['60%','40%'],body:[[{text:'BILL TO',style:"topCustomerHeader"},{text:'INVOICE DETAILS',style:"topHeader"}],[{text:[{text:' ',bold:true,style:'invoiceDetails'},{text:'Google\n',style:'invoiceDetailsBlueConsignee'},{text:' ',bold:true,style:'invoiceDetails'},{text:'1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n',style:'invoiceDetails'},{text:' ',bold:true,style:'invoiceDetails'},{text:'1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n',style:'invoiceDetails'},{text:' ',bold:true,style:'invoiceDetails'},{text:'7788996655\n',style:'invoiceDetails'},{text:'Mobile Number  : ',bold:true,style:"invoiceDetails"},{text:'1679905\n',style:"invoiceDetails"},{text:'Place of Supply  : ',bold:true,style:"invoiceDetails"},{text:'23\n',style:"invoiceDetails"},{text:'State Code          : ',bold:true,style:"invoiceDetails"},{text:'23\n',style:"invoiceDetails"}]},{text:[{text:'Invoice No        :  ',bold:true,style:"invoiceDetails"},{text:'787878\n',style:"invoiceDetailsBlue"},{text:'Invoice Date     :  ',bold:true,style:"invoiceDetails"},{text:'12/12/90 \n',style:"invoiceDetails"},{text:'Invoice Status  :  ',bold:true,style:'invoiceDetails'},{text:'12/12/90 \n',style:'invoiceStatusDetails'},{text:'Payment Date  :  ',bold:true,style:"invoiceDetails"},{text:'13/12/90\n',style:"invoiceDetails"},{text:'Delivery Terms :  ',bold:true,style:"invoiceDetails"},{text:'13/12/90\n',style:"invoiceDetails"}]}]]}},//{text:'\n'},    
{table:{//widths: ['6%','28%','10%','5%','8%','8%','*'],
widths:['3%','22%','6%'],body:[[{text:'NO.',style:"productHeader"},{text:'PRODUCT DESCRIPTION',style:"productHeader"},{text:'HSN/SAC',style:"productHeader"}]]}},//{text:'\n'},
{table:{widths:['70%','*'],body:[[[{table:{body:[[{text:'HSN SUMMARY',style:"gstHeader1",colSpan:10},{text:'Qty',style:"gstHeader"},{text:'TAXABLE AMOUNT',style:"gstHeader"},{text:'%',style:"gstHeader"},{text:'AMOUNT',style:"gstHeader"},{text:'%',style:"gstHeader"},{text:'AMOUNT',style:"gstHeader"},{text:'%',style:"gstHeader"},{text:'AMOUNT',style:"gstHeader"},{text:'TOTAL TAX AMOUNT',style:"gstHeader"}],[{text:'HSN/SAC',style:"gstHeader",rowSpan:2},{text:'QTY',style:"gstHeader",rowSpan:2},{text:'TAXABLE AMOUNT',style:"gstHeader",rowSpan:2},{text:'CGST',style:"gstHeader",colSpan:2,rowSpan:1},{text:'',style:"gstHeader",rowSpan:2},{text:'SGST',style:"gstHeader",colSpan:2,rowSpan:1},{text:'',style:"gstHeader",rowSpan:2},{text:'IGST',style:"gstHeader",colSpan:2,rowSpan:1},{text:'',style:"gstHeader",rowSpan:2},{text:'TOTAL TAX AMOUNT',style:"gstHeader",rowSpan:2}],[{text:'HSN/SAC',style:"gstHeader"},{text:'Qty',style:"gstHeader"},{text:'Taxable Amount',style:"gstHeader"},{text:'%',style:"gstHeader"},{text:'Amount',style:"gstHeader"},{text:'%',style:"gstHeader"},{text:'Amount',style:"gstHeader"},{text:'%',style:"gstHeader"},{text:'Amount',style:"gstHeader"},{text:'Total Tax Amount',style:"gstHeader"}]]}}],{text:[{text:'Taxable Amount  :   ',bold:true,style:'invoiceDetails'},{text:'12122\n',style:'invoiceDetails'},{text:'CGST Amount      :   ',bold:true,style:'invoiceDetails'},{text:'12122\n',style:'invoiceDetails'},{text:'SGST Amount      :   ',bold:true,style:'invoiceDetails'},{text:'12122\n',style:'invoiceDetails'},{text:'IGST Amount       :   ',bold:true,style:'invoiceDetails'},{text:'12122\n',style:'invoiceDetails'},// { text: 'Labour Charge:-                ', bold: true },
// { text: '12122\n' },
{text:'Discount               :   ',bold:true,style:'invoiceDetails'},{text:'12122\n',style:'invoiceDetails'},{text:'RoundOff              :   ',bold:true,style:'invoiceDetails'},{text:'12122\n',style:'invoiceDetails'},{text:'Total Amount       :   ',bold:true,style:'totalAmountHeader'},{text:'12122\n',style:'totalAmountHeader'},{text:'Paid Amount        :   ',bold:true,style:'invoiceDetails'},{text:'12122\n',style:'invoiceDetails'},{text:'Due Amount         :   ',bold:true,style:'invoiceStatusDetails'},{text:'12122\n',style:'invoiceStatusDetails'}]}]]},style:'tab2'},{table:{widths:['*'],body:[[{text:"In Words: ",style:'invoiceDetails'}]]}},// Start of Previous + current = Total Column
{table:{widths:['34%','39%','27%'],body:[[{text:'',style:"topBlankHeader"},{text:'',style:"topMainHeader"},{text:'',style:"topBlankHeader"}],[{text:[{text:'PREVIOUS BALANCE :  ',bold:true,style:'topHeader11'},{text:'\n',style:'topHeader11'}]},{text:[{text:'CURRENT BALANCE :  ',bold:true,style:'topHeader11'},{text:'\n',style:'topHeader11'}]},{text:[{text:'TOTAL BALANCE :  ',bold:true,style:'topRemainingHeader1'},{text:'\n',style:'topRemainingHeader1'}]}]]},layout:{hLineWidth:function hLineWidth(i,node){return i===0||i===node.table.body.length?1:0;},vLineWidth:function vLineWidth(i,node){return i===0||i===node.table.widths.length?1:0;},hLineColor:function hLineColor(i,node){return i===0||i===node.table.body.length?'black':'black';},vLineColor:function vLineColor(i,node){return i===0||i===node.table.widths.length?'black':'black';}}},// End of Previous + current = Total Column
{table:{widths:['30%','40%','30%'],body:[[{text:[{text:'PAYMENT DETAILS\n',style:'transpotationDel'},{text:'',style:'invoiceDetails1'}]},{text:[{text:'TERMS AND CONDITIONS\n',style:'transpotationDel'},{text:'',style:'invoiceDetails1'}]},// {
// 	text:
[{text:''},{text:'Firm Name  ',bold:true,alignment:'center',style:'topFirmAuthority'},{text:'\n\n\n\n'},{text:'AUTHORITY SIGNATURE  ',bold:true,alignment:'center',style:'topFirmAuthority'},{text:'\n'}]// },
]]},layout:{hLineWidth:function hLineWidth(i,node){return i===0||i===node.table.body.length?2:0;},vLineWidth:function vLineWidth(i,node){return i===0||i===node.table.widths.length?2:0;},hLineColor:function hLineColor(i,node){return i===0||i===node.table.body.length?'black':'white';},vLineColor:function vLineColor(i,node){return i===0||i===node.table.widths.length?'black':'white';}}},{table:{widths:['*'],body:[[{text:'Thank you',style:'thankyouMsg'}]]}}],footer:{columns:[{text:'Powered By ACUIFY',alignment:'right',color:'#160091'}],margin:[10,10]},styles:{header:{fontSize:15,bold:true,alignment:'center',color:'#160091'},productHeader:{fontSize:9,bold:true,alignment:'center',color:'#160091'},transpotationDel:{fontSize:9,bold:true,alignment:'center',color:'#160091'},gstHeader:{fontSize:8,color:'#160091',alignment:'center'},gstHeader1:{fontSize:10,color:'#160091',bold:true,alignment:'center'},product:{fontSize:9,alignment:'center',bold:true},productRight:{fontSize:10,alignment:'right'// bold: true
},totalRight:{fontSize:10,alignment:'right',bold:true},subproduct:{fontSize:9,alignment:'center'},product1:{fontSize:7,alignment:'center'},total:{fontSize:10,alignment:'center',bold:true},total1:{fontSize:7,alignment:'center'},topHeader:{color:'#160091',fontSize:11,alignment:'center',bold:true},topCustomerHeader:{color:'#160091',fontSize:11,alignment:'left',bold:true},topFirmAuthority:{color:'#160091',fontSize:9,bold:true},topFirmAuthority1:{color:'#160091',fontSize:12,bold:true},topFirmAuthority1Right:{color:'#160091',fontSize:12,bold:true,alignment:'right'},topFirmHeaderRight:{fontSize:10,bold:true,alignment:'right'},topFirmHeader:{fontSize:10,bold:true},invoiceDetails:{fontSize:10,bold:true},invoiceDetailsBlue:{fontSize:10,bold:true,color:'#160091'},invoiceDetailsBlueConsignee:{fontSize:11,bold:true,color:'#160091'},invoiceDetails1:{fontSize:9,bold:true},totalAmountHeader:{color:'#160091',fontSize:10,bold:true},invoiceStatusDetails:{color:'#FF0000',fontSize:10,bold:true},thankyouMsg:{color:'#160091',fontSize:12,bold:true,alignment:'center'},topHeader11:{color:'#160091',fontSize:10,bold:true},topRemainingHeader1:{color:'#FF0000',fontSize:10,bold:true},hiddenTab:{fillColor:'#ffffff',color:'#ffffff'}}//Firm Details 
};pdfDoc.content[1].table.body[0][1].text[0].text=(metaData.firm.name?metaData.firm.name.toUpperCase():'')+"\n";pdfDoc.content[1].table.body[0][1].text[1].text=(metaData.firm.GST_number?metaData.firm.GST_number:'')+"\n";pdfDoc.content[1].table.body[0][1].text[2].text=(metaData.firm.liveAddress?metaData.firm.liveAddress:'')+"\n";pdfDoc.content[1].table.body[0][1].text[3].text=(metaData.firm.address?metaData.firm.address:'')+"\n";pdfDoc.content[1].table.body[0][1].text[4].text=(metaData.firm.mobileNumber?metaData.firm.mobileNumber:'')+"\n";pdfDoc.content[1].table.body[0][1].text[5].text=(metaData.firm.email?metaData.firm.email:'')+"\n";//Invoice Details
date=new Date(metaData.invoiceData.date);paymentDueDate=date.setDate(date.getDate()+(metaData.invoiceData.duration?parseInt(metaData.invoiceData.duration):0));pdfDoc.content[2].table.body[1][1].text[1].text=metaData.invoiceData.invoiceId+"\n";pdfDoc.content[2].table.body[1][1].text[3].text=new Date(metaData.invoiceData.date).toLocaleDateString('en-GB').toString()+"\n";pdfDoc.content[2].table.body[1][1].text[5].text=(metaData.invoiceData.status?metaData.invoiceData.status.toUpperCase():'')+"\n";pdfDoc.content[2].table.body[1][1].text[7].text=new Date(paymentDueDate).toLocaleDateString('en-GB').toString()+"\n";pdfDoc.content[2].table.body[1][1].text[9].text=(metaData.invoiceData.remark?metaData.invoiceData.remark:'')+"\n";if(metaData.terms.isPaymentType){pdfDoc.content[2].table.body[1][1].text.push({text:'Payment Type  :  ',bold:true,style:'invoiceDetails'});pdfDoc.content[2].table.body[1][1].text.push({text:metaData.invoiceData.paymentType+'\n',style:'invoiceDetails'});}// pdfDoc.content[2].table.body[1][1].text[11].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";
if(metaData.terms.isPaymentType&&(metaData.invoiceData.paymentType==='cash'||'CashAndBank Account')){pdfDoc.content[2].table.body[1][1].text.push({text:'From Cash 	   :  ',bold:true,style:'invoiceDetails'});pdfDoc.content[2].table.body[1][1].text.push({text:metaData.invoiceData.amountFromCash+'\n',style:'invoiceDetails'});}// 	pdfDoc.content[2].table.body[1][1].text[13].text = (metaData.invoiceData.amountFromCash ? metaData.invoiceData.amountFromCash : '') + "\n";
if(metaData.terms.isPaymentType&&(metaData.invoiceData.paymentType==='bank'||'CashAndBank Account')){pdfDoc.content[2].table.body[1][1].text.push({text:'From Bank   	 :  ',bold:true,style:'invoiceDetails'});pdfDoc.content[2].table.body[1][1].text.push({text:metaData.invoiceData.amountFromBank+'\n',style:'invoiceDetails'});}// 	pdfDoc.content[2].table.body[1][1].text[15].text = (metaData.invoiceData.amountFromBank ? metaData.invoiceData.amountFromBank : '') + "\n";
//Receipient Details
//pdfDoc.content[2].table.body[1][0].text[1].text = (metaData.customer.name ? (metaData.customer.name).toUpperCase() : '') + "\n";
pdfDoc.content[2].table.body[1][0].text[1].text=getCustomerDetails(metaData,'name').toUpperCase()+"\n";pdfDoc.content[2].table.body[1][0].text[3].text=(metaData.customer.GST_number?metaData.customer.GST_number:'')+"\n";pdfDoc.content[2].table.body[1][0].text[5].text=(metaData.customer.localAddress?metaData.customer.localAddress:'')+"\n";pdfDoc.content[2].table.body[1][0].text[7].text=(metaData.customer.address?metaData.customer.address:'')+"\n";pdfDoc.content[2].table.body[1][0].text[9].text=(metaData.customer.mobile?metaData.customer.mobile:'')+"\n";pdfDoc.content[2].table.body[1][0].text[7].text=getCustomerDetails(metaData,'address')+"\n";pdfDoc.content[2].table.body[1][0].text[9].text=getCustomerDetails(metaData,'mobile').toUpperCase()+"\n";pdfDoc.content[2].table.body[1][0].text[11].text=(metaData.invoiceData.placeOfSupply?metaData.invoiceData.placeOfSupply:'')+"\n";pdfDoc.content[2].table.body[1][0].text[13].text=(metaData.customer.stateCode?metaData.customer.stateCode:'')+"\n";isTradeDiscount=metaData.terms.isTradeDiscount;isSpecialCharge=metaData.terms.isSpecialCharge;isGrossWeight=metaData.terms.isGrossWeight;isNetWeight=metaData.terms.isNetWeight;isLessStone=metaData.terms.isLessStone;isPurity=metaData.terms.isPurity;purityRemark=metaData.terms.purityRemark;isGSTGroupingDisabled=metaData.terms.isGSTGroupingDisabled;isTotalAmount=metaData.terms.isTotalAmount;//Products
productList=convertToPDFProductForSimplePrint(metaData.invoiceData.items,isTradeDiscount,isSpecialCharge,isGrossWeight,isLessStone,isNetWeight,isPurity,purityRemark,isGSTGroupingDisabled,isTotalAmount,metaData.invoiceData);if(isGSTGroupingDisabled){pdfDoc.content[3].table.widths.push("5%");pdfDoc.content[3].table.body[0].push({text:'GST',style:"productHeader"});}pdfDoc.content[3].table.widths.push("5%");pdfDoc.content[3].table.body[0].push({text:'QTY',style:"productHeader"});pdfDoc.content[3].table.widths.push("6%*");pdfDoc.content[3].table.body[0].push({text:'UNIT',style:"productHeader"});if(isPurity){pdfDoc.content[3].table.widths.push("9%");pdfDoc.content[3].table.body[0].push({text:'PURITY',style:"productHeader"});}if(purityRemark){pdfDoc.content[3].table.widths.push("9%");pdfDoc.content[3].table.body[0].push({text:'PURITY',style:"productHeader"});}if(isGrossWeight){pdfDoc.content[3].table.widths.push("8%");pdfDoc.content[3].table.body[0].push({text:'G.WT',style:"productHeader"});}if(isNetWeight){pdfDoc.content[3].table.widths.push("8%");pdfDoc.content[3].table.body[0].push({text:'N.WT',style:"productHeader"});}if(isLessStone){pdfDoc.content[3].table.widths.push("8%");pdfDoc.content[3].table.body[0].push({text:'LESS',style:"productHeader"});}pdfDoc.content[3].table.widths.push("7%");pdfDoc.content[3].table.body[0].push({text:'RATE',style:"productHeader"});if(isSpecialCharge){pdfDoc.content[3].table.widths.push("7%");pdfDoc.content[3].table.body[0].push({text:'LC(%)',style:"productHeader"});}if(isTradeDiscount){pdfDoc.content[3].table.widths.push("6%");pdfDoc.content[3].table.body[0].push({text:'DIS',style:"productHeader"});}pdfDoc.content[3].table.widths.push("*");pdfDoc.content[3].table.body[0].push({text:'TAXABLE AMOUNT',style:"productHeader"});if(isTotalAmount){pdfDoc.content[3].table.widths.push("*");pdfDoc.content[3].table.body[0].push({text:'TOTAL AMOUNT',style:"productHeader"});}productList.map(function(item){pdfDoc.content[3].table.body.push(item);});gstObj=convertToGST(metaData.invoiceData.items);__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(gstObj).forEach(function(key){if(key!="totalObj"){pdfDoc.content[4].table.body[0][0][0].table.body.push([{text:key,style:"product1"},{text:gstObj[key].quantity,style:"product1"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj[key].basicPrice).toFixed(2),style:"product1"},{text:gstObj[key].CGST+'%',style:"product1"},{text:gstObj[key].CGST_val.toFixed(2),style:"product1"},{text:gstObj[key].SGST+'%',style:"product1"},{text:gstObj[key].SGST_val.toFixed(2),style:"product1"},{text:gstObj[key].IGST+'%',style:"product1"},{text:gstObj[key].IGST_val.toFixed(2),style:"product1"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj[key].GSTValue).toFixed(2),style:"product1"}]);}});pdfDoc.content[4].table.body[0][0][0].table.body.push([{text:'Total',style:"total1"},{text:gstObj.totalObj.quantity,style:"total1"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj.totalObj.basicPrice).toFixed(2),style:"total1"},{text:'',style:"total1"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj.totalObj.CGST_val).toFixed(2),style:"total1"},{text:'',style:"total1"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj.totalObj.SGST_val).toFixed(2),style:"total1"},{text:'',style:"total1"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj.totalObj.IGST_val).toFixed(2),style:"total1"},{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(gstObj.totalObj.GSTValue).toFixed(2),style:"total1"}]);//gst details
pdfDoc.content[4].table.body[0][1].text[1].text=(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalAmount)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.discountAmount||0)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?0:-__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraCharges))-__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraChargesGST):0)-__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.roundOffAmount||0)-(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.SGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.CGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.IGST_val))).toFixed(2)+"\n";pdfDoc.content[4].table.body[0][1].text[3].text=(metaData.gstTotal.CGST_val?(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.CGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraChargesGST)/2:0)).toFixed(2):'0.00')+"\n";pdfDoc.content[4].table.body[0][1].text[5].text=(metaData.gstTotal.SGST_val?(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.SGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraChargesGST)/2:0)).toFixed(2):'0.00')+"\n";pdfDoc.content[4].table.body[0][1].text[7].text=(metaData.gstTotal.IGST_val?(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.IGST_val)+__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.gstOnExtraChanrges?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalExtraChargesGST):0)).toFixed(2):'0.00')+"\n";offset=0;// if(metaData.invoiceData.extraCharges && metaData.invoiceData.extraCharges.length) {
if(!metaData.invoiceData.gstOnExtraChanrges&&metaData.invoiceData.extraCharges&&metaData.invoiceData.extraCharges.length){metaData.invoiceData.extraCharges.map(function(charge){pdfDoc.content[4].table.body[0][1].text.splice(8+offset,0,{text:''+charge.name+'    :   ',bold:true,style:'invoiceDetails'});offset++;pdfDoc.content[4].table.body[0][1].text.splice(8+offset,0,{text:__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(charge.amount).toFixed(2)+'\n',style:'invoiceDetails'});offset++;});}pdfDoc.content[4].table.body[0][1].text[9+offset].text=(metaData.invoiceData.discountAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.discountAmount).toFixed(2):'0.00')+"\n";pdfDoc.content[4].table.body[0][1].text[11+offset].text=(metaData.invoiceData.roundOffAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.roundOffAmount).toFixed(2):'0.00')+"\n";pdfDoc.content[4].table.body[0][1].text[13+offset].text=(metaData.invoiceData.totalAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.totalAmount).toFixed(2):'0')+"\n";pdfDoc.content[4].table.body[0][1].text[15+offset].text=(metaData.invoiceData.paidAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.paidAmount).toFixed(2):'0')+"\n";pdfDoc.content[4].table.body[0][1].text[17+offset].text=(metaData.invoiceData.remainingAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.remainingAmount).toFixed(2):'')+"\n";// In Words
pdfDoc.content[5].table.body[0][0].text="In Words: "+_.startCase(Object(__WEBPACK_IMPORTED_MODULE_6__digitsToWords_js__["a" /* digitsToWords */])(metaData.invoiceData.totalAmount));// Overall Balance
if(metaData.balance&&metaData.terms.isPreviousCurrentTotalBalance){pdfDoc.content[6].table.body[1][0].text[1].text=__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.balance)-__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.remainingAmount).toFixed(2)).toFixed(2)+"\n";pdfDoc.content[6].table.body[1][1].text[1].text=(metaData.invoiceData.remainingAmount?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.invoiceData.remainingAmount).toFixed(2):'0.00')+"\n";pdfDoc.content[6].table.body[1][2].text[1].text=(metaData.balance?__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(metaData.balance).toFixed(2):'0.00')+"\n";}else{pdfDoc.content[6]={};//pdfDoc.content[5] = {};
}//Bank Account Details
if(metaData.terms.banks.length){metaData.terms.banks.map(function(bankDetails){pdfDoc.content[7].table.body[0][0].text.push({text:bankDetails.bankName+"\n",style:'invoiceDetails1'});pdfDoc.content[7].table.body[0][0].text.push({text:"NAME: "+bankDetails.accountHolderName+"\n",style:'invoiceDetails1'});pdfDoc.content[7].table.body[0][0].text.push({text:"A/C NO:  "+bankDetails.accountnumber+"\n",style:'invoiceDetails1'});pdfDoc.content[7].table.body[0][0].text.push({text:"IFSC: "+bankDetails.ifsccode+"\n",style:'invoiceDetails1'});pdfDoc.content[7].table.body[0][0].text.push({text:bankDetails.address+"\n",style:'invoiceDetails1'});});}//Terms and cond
pdfDoc.content[7].table.body[0][1].text[1].text=metaData.terms.termsAndConditions;//Authority Signature
pdfDoc.content[7].table.body[0][2][1].text=metaData.firm.name?metaData.firm.name.toUpperCase():'';//thank you
// pdfDoc.content[10].table.body[0][0].text =  metaData.terms.termsAndConditions.greetingMessage || ("Thank You " + ((metaData.customer && metaData.customer.name )? metaData.customer.name.toUpperCase() : '') +" For doing business with us!" );
pdfDoc.content[8].table.body[0][0].text=metaData.terms.greetingMessage||"Thank You "+getCustomerDetails(metaData,'name').toUpperCase()+" For your business with us!";// if (metaData.previousDue.length) {
// 	metaData.previousDue.map((invoice, index) => {
// 		pdfDoc.content[9].table.body.push([
// 			{ text: index + 1, style: "product1" },
// 			{ text: new Date(invoice.date).toLocaleDateString('en-GB').toString(), style: "product1" },
// 			{ text: invoice.invoiceId, style: "product1" },
// 			{ text: (invoice.totalAmount ? Number.parseFloat(invoice.totalAmount).toFixed(2) : '0'), style: "product1" },
// 			{ text: (invoice.paidAmount ? Number.parseFloat(invoice.paidAmount).toFixed(2) : '0'), style: "product1" },
// 			{ text: (invoice.remainingAmount ? Number.parseFloat(invoice.remainingAmount).toFixed(2) : '0'), style: "product1" },
// 			{ text: (invoice.duration ? invoice.duration.toUpperCase() : 0), style: "product1" },
// 			{ text: (invoice.status ? invoice.status.toUpperCase() : ''), style: "product1" }
// 		])
// 	})
// } else {
// 	pdfDoc.content.splice(9, 1);
// }
// if(metaData.estimates.length) {
// 	let getTotal = (invoice)=>{
// 		let total = 0;
// 		invoice.items.map((i)=>{
// 		  total += Number.parseFloat((Number.parseFloat(i.rate)) * (Number.parseFloat(i.quantity)))
// 		})
// 		return total;
// 	  }
// 	metaData.estimates.map((invoice,index) => {
// 		pdfDoc.content[9].table.body.push([
// 			{ text: index+1, style: "product1" },
// 			{ text: new Date(invoice.date).toLocaleDateString('en-GB').toString(), style: "product1" },
// 			{ text: (invoice.items.map((item,index)=> item.productName + (index != invoice.items.length-1 ? ' ,' :''))), style: "product1" },
// 			{ text: (getTotal(invoice)), style: "product1" }
// 		])
// 	})
// } else {
// 	pdfDoc.content.splice(9, 1);
// }
if(!metaData.terms.isBlankHeader){_context11.next=80;break;}pdfDoc.content[1].table.body[0][0]={text:''};pdfDoc.content[1].style='hiddenTab';pdfDoc.content[1].table.body[0][1].text[0].style='hiddenTab';_context11.next=160;break;case 80:if(!metaData.terms.printLogo){_context11.next=128;break;}_context11.prev=81;_context11.next=84;return getBase64ImageFromURL(metaData.terms.printLogo);case 84:logoData=_context11.sent;pdfDoc.content[1].table.body[0][0].image=logoData;invoiceImages=document.getElementById('invoiceImages');if(!(invoiceImages&&invoiceImages.files&&invoiceImages.files.length)){_context11.next=111;break;}temp={columns:[]};if(!invoiceImages.files[0]){_context11.next=96;break;}_context11.t0=temp.columns;_context11.next=93;return toBase64(invoiceImages.files[0]).catch(function(e){return Error(e);});case 93:_context11.t1=_context11.sent;_context11.t2={image:_context11.t1,width:150};_context11.t0.push.call(_context11.t0,_context11.t2);case 96:if(!invoiceImages.files[1]){_context11.next=103;break;}_context11.t3=temp.columns;_context11.next=100;return toBase64(invoiceImages.files[1]).catch(function(e){return Error(e);});case 100:_context11.t4=_context11.sent;_context11.t5={image:_context11.t4,width:150};_context11.t3.push.call(_context11.t3,_context11.t5);case 103:if(!invoiceImages.files[2]){_context11.next=110;break;}_context11.t6=temp.columns;_context11.next=107;return toBase64(invoiceImages.files[2]).catch(function(e){return Error(e);});case 107:_context11.t7=_context11.sent;_context11.t8={image:_context11.t7,width:150};_context11.t6.push.call(_context11.t6,_context11.t8);case 110:pdfDoc.content.push(temp);case 111:if(!metaData.terms.signature){_context11.next=120;break;}_temp26={columns:[]};_context11.t9=_temp26.columns;_context11.next=116;return getBase64ImageFromURL(metaData.terms.signature);case 116:_context11.t10=_context11.sent;_context11.t11={image:_context11.t10,width:150,alignment:'right'};_context11.t9.push.call(_context11.t9,_context11.t11);//pdfDoc.content.push(temp)
pdfDoc.content[7].table.body[0][2][2]=_temp26.columns[0];case 120:return _context11.abrupt("return",pdfDoc);case 123:_context11.prev=123;_context11.t12=_context11["catch"](81);console.log(_context11.t12);case 126:_context11.next=160;break;case 128:imgToExport=document.getElementById('pdfimgToExport');canvas=document.createElement('canvas');canvas.width=imgToExport.width;canvas.height=imgToExport.height;canvas.getContext('2d').drawImage(imgToExport,0,0);base64=canvas.toDataURL('image/png');pdfDoc.content[1].table.body[0][0].image=base64;_invoiceImages10=document.getElementById('invoiceImages');if(!(_invoiceImages10&&_invoiceImages10.files&&_invoiceImages10.files.length)){_context11.next=160;break;}_temp27={columns:[]};if(!_invoiceImages10.files[0]){_context11.next=145;break;}_context11.t13=_temp27.columns;_context11.next=142;return toBase64(_invoiceImages10.files[0]).catch(function(e){return Error(e);});case 142:_context11.t14=_context11.sent;_context11.t15={image:_context11.t14,width:150};_context11.t13.push.call(_context11.t13,_context11.t15);case 145:if(!_invoiceImages10.files[1]){_context11.next=152;break;}_context11.t16=_temp27.columns;_context11.next=149;return toBase64(_invoiceImages10.files[1]).catch(function(e){return Error(e);});case 149:_context11.t17=_context11.sent;_context11.t18={image:_context11.t17,width:150};_context11.t16.push.call(_context11.t16,_context11.t18);case 152:if(!_invoiceImages10.files[2]){_context11.next=159;break;}_context11.t19=_temp27.columns;_context11.next=156;return toBase64(_invoiceImages10.files[2]).catch(function(e){return Error(e);});case 156:_context11.t20=_context11.sent;_context11.t21={image:_context11.t20,width:150};_context11.t19.push.call(_context11.t19,_context11.t21);case 159:pdfDoc.content.push(_temp27);case 160:if(!metaData.terms.signature){_context11.next=169;break;}_temp28={columns:[]};_context11.t22=_temp28.columns;_context11.next=165;return getBase64ImageFromURL(metaData.terms.signature);case 165:_context11.t23=_context11.sent;_context11.t24={image:_context11.t23,width:150,alignment:'right'};_context11.t22.push.call(_context11.t22,_context11.t24);pdfDoc.content[7].table.body[0][2][2]=_temp28.columns[0];//pdfDoc.content.push(temp)
case 169:return _context11.abrupt("return",pdfDoc);case 170:case"end":return _context11.stop();}}},_callee11,_this,[[81,123]]);}));return function convertToSimpleInvoicePrint(_x11){return _ref11.apply(this,arguments);};}();

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return digitsToWords; });
var iWords = [' zero', ' one', ' two', ' three', ' four', ' five', ' six', ' seven', ' eight', ' nine'];
var ePlace = [' ten', ' eleven', ' twelve', ' thirteen', ' fourteen', ' fifteen', ' sixteen', ' seventeen', ' eighteen', ' nineteen'];
var tensPlace = ['', ' ten', ' twenty', ' thirty', ' forty', ' fifty', ' sixty', ' seventy', ' eighty', ' ninety'];
var inWords = [];

var numReversed, inWords, actnumber, i, j;

function tensComplication() {
  if (actnumber[i] == 0) {
    inWords[j] = '';
  } else if (actnumber[i] == 1) {
    inWords[j] = ePlace[actnumber[i - 1]];
  } else {
    inWords[j] = tensPlace[actnumber[i]];
  }
}

function convert(numericValue) {
  inWords = [];
  if (numericValue == "00" || numericValue == "0") {
    return ' zero';
  }
  var obStr = numericValue.toString();
  numReversed = obStr.split('');
  actnumber = numReversed.reverse();

  var iWordsLength = numReversed.length;
  var finalWord = '';
  j = 0;
  for (i = 0; i < iWordsLength; i++) {
    switch (i) {
      case 0:
        if (actnumber[i] == '0' || actnumber[i + 1] == '1') {
          inWords[j] = '';
        } else {
          inWords[j] = iWords[actnumber[i]];
        }
        inWords[j] = inWords[j] + '';
        break;
      case 1:
        tensComplication();
        break;
      case 2:
        if (actnumber[i] == '0') {
          inWords[j] = '';
        } else if (actnumber[i - 1] !== '0' && actnumber[i - 2] !== '0') {
          inWords[j] = iWords[actnumber[i]] + ' hundred';
        } else {
          inWords[j] = iWords[actnumber[i]] + ' hundred';
        }
        break;
      case 3:
        if (actnumber[i] == '0' || actnumber[i + 1] == '1') {
          inWords[j] = '';
        } else {
          inWords[j] = iWords[actnumber[i]];
        }
        if (actnumber[i + 1] !== '0' || actnumber[i] > '0') {
          inWords[j] = inWords[j] + ' thousand';
        }
        break;
      case 4:
        tensComplication();
        break;
      case 5:
        if (actnumber[i] == '0' || actnumber[i + 1] == '1') {
          inWords[j] = '';
        } else {
          inWords[j] = iWords[actnumber[i]];
        }
        if (actnumber[i + 1] !== '0' || actnumber[i] > '0') {
          inWords[j] = inWords[j] + ' lakh';
        }
        break;
      case 6:
        tensComplication();
        break;
      case 7:
        if (actnumber[i] == '0' || actnumber[i + 1] == '1') {
          inWords[j] = '';
        } else {
          inWords[j] = iWords[actnumber[i]];
        }
        inWords[j] = inWords[j] + ' crore';
        break;
      case 8:
        tensComplication();
        break;
      default:
        break;
    }
    j++;
  }

  inWords.reverse();
  for (i = 0; i < inWords.length; i++) {
    finalWord += inWords[i];
  }
  return finalWord;
}

var digitsToWords = function digitsToWords(numericValue) {
  numericValue = numericValue.toString();
  numericValue = numericValue.replace(/[,]/g, '');
  numericValue = parseFloat(numericValue).toFixed(2);
  var amount = numericValue.toString().split('.');
  var taka = amount[0];
  var paisa = amount[1];
  // return (convert(taka) + " Rupees and" + convert(paisa) + " paisa only");
  return convert(taka) + " Rupees Only";
};

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expandCard_vue__ = __webpack_require__(558);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0092f821_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_expandCard_vue__ = __webpack_require__(1655);
function injectStyle (ssrContext) {
  __webpack_require__(1654)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0092f821"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expandCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0092f821_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_expandCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cfirebase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);


// Production
var config = {
  apiKey: 'AIzaSyAN93t5tKf6wgSoiuhY4ubPionRyQkiOyk',
  authDomain: 'one-business-1ca39.firebaseapp.com',
  databaseURL: 'https://one-business-1ca39.firebaseio.com',
  storageBucket: 'gs://one-business-1ca39.appspot.com',
  messagingSenderId: '261409205383'

  // testing
  // var config = {
  //   apiKey: 'AIzaSyCnUbXCE4MRZq2_VR5dTLJjN60-4jaEq9U',
  //   authDomain: 'one-bussiness-testing.firebaseapp.com',
  //   databaseURL: 'https://one-bussiness-testing.firebaseio.com/',
  //   storageBucket: 'gs://one-bussiness-testing.appspot.com',
  //   messagingSenderId: '335842623685'
  // }

};__WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp(config);

var cfirebase = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a;

/* harmony default export */ __webpack_exports__["b"] = ({
  database: __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.database(),
  firebase: __WEBPACK_IMPORTED_MODULE_0_firebase___default.a
});

/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return convertToPDFBalanceSheet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return convertToPDFTradingAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return convertToPDFProfitAndLoss; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return convertToPDFProprietor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return convertToCashBook; });
// playground requires you to assign document definition to a variable called dd
var convertToPDFBalanceSheet = function convertToPDFBalanceSheet(_ref) {
    var data = _ref.data,
        firm = _ref.firm,
        dateFrom = _ref.dateFrom,
        dateTo = _ref.dateTo;

    var dd = {
        content: [{ text: 'Balance Sheet', style: 'header' }, {
            table: {
                body: [[{
                    table: {
                        body: []
                    }
                }, {
                    table: {
                        body: []
                    }
                }]]
            }
        }],
        styles: {
            header: {
                fontSize: 14,
                bold: true,
                color: "#160091",
                margin: [0, 0, 0, 10]
            },
            header1: {
                fontSize: 10,
                bold: false,
                color: "#0D47A1"
            },
            header2: {
                fontSize: 10,
                bold: true,
                color: "#160091"
            }
        }

    };
    var flag = 0;
    var tabFlag = 0;
    data.map(function (value, index) {
        if (value == 'Assets') {
            tabFlag = 1;
        }
        if (!tabFlag) {
            if (flag % 2 == 0) {
                dd.content[1].table.body[0][0].table.body.push([{ text: data[index], style: "header1" }, { text: data[index + 1], style: "header2" }]);
            }
        } else {
            if (flag % 2 == 0) {
                dd.content[1].table.body[0][1].table.body.push([{ text: data[index], style: "header1" }, { text: data[index + 1], style: "header2" }]);
            }
        }
        flag++;
    });
    return dd;
};

var convertToPDFTradingAccount = function convertToPDFTradingAccount(_ref2) {
    var data = _ref2.data,
        firm = _ref2.firm,
        dateFrom = _ref2.dateFrom,
        dateTo = _ref2.dateTo;

    var dd = {
        content: [{ text: 'Trading Account', style: 'header' }, {
            table: {
                body: [[{
                    table: {
                        body: []
                    }
                }, {
                    table: {
                        body: []
                    }
                }]]
            }
        }],
        styles: {
            header: {
                fontSize: 14,
                bold: true,
                margin: [0, 0, 0, 10]
            },
            header1: {
                fontSize: 10,
                bold: false,
                color: "#0D47A1"
            },
            header2: {
                fontSize: 10,
                bold: true,
                color: "#160091"
            }
        }

    };
    var flag = 0;
    var tabFlag = 0;
    data.map(function (value, index) {
        if (index != 0 && value == 'Particulars') {
            tabFlag = 1;
        }
        if (!tabFlag) {
            if (flag % 2 == 0) {
                dd.content[1].table.body[0][0].table.body.push([{ text: data[index], style: "header1" }, { text: data[index + 1], style: "header2" }]);
            }
        } else {
            if (flag % 2 == 0) {
                dd.content[1].table.body[0][1].table.body.push([{ text: data[index], style: "header1" }, { text: data[index + 1], style: "header2" }]);
            }
        }
        flag++;
    });
    return dd;
};

var convertToPDFProfitAndLoss = function convertToPDFProfitAndLoss(_ref3) {
    var data = _ref3.data,
        firm = _ref3.firm,
        dateFrom = _ref3.dateFrom,
        dateTo = _ref3.dateTo;

    var dd = {
        content: [{ text: 'Profit and Loss Account', style: 'header' }, {
            table: {
                body: [[{
                    table: {
                        body: []
                    }
                }, {
                    table: {
                        body: []
                    }
                }]]
            }
        }],
        styles: {
            header: {
                fontSize: 14,
                bold: true,
                margin: [0, 0, 0, 10]
            },
            header1: {
                fontSize: 10,
                bold: false,
                color: "#0D47A1"
            },
            header2: {
                fontSize: 10,
                bold: true,
                color: "#160091"
            }
        }

    };
    var flag = 0;
    var tabFlag = 0;
    data.map(function (value, index) {
        if (index != 0 && value == 'Particulars') {
            tabFlag = 1;
        }
        if (!tabFlag) {
            if (flag % 2 == 0) {
                dd.content[1].table.body[0][0].table.body.push([{ text: data[index], style: "header1" }, { text: data[index + 1], style: "header2" }]);
            }
        } else {
            if (flag % 2 == 0) {
                dd.content[1].table.body[0][1].table.body.push([{ text: data[index], style: "header1" }, { text: data[index + 1], style: "header2" }]);
            }
        }
        flag++;
    });
    return dd;
};

var convertToPDFProprietor = function convertToPDFProprietor(_ref4) {
    var data = _ref4.data,
        firm = _ref4.firm,
        dateFrom = _ref4.dateFrom,
        dateTo = _ref4.dateTo;

    var dd = {
        content: [{ text: 'Proprietor Capital Account', style: 'header' }, {
            table: {
                body: [[{
                    table: {
                        body: []
                    }
                }, {
                    table: {
                        body: []
                    }
                }]]
            }
        }],
        styles: {
            header: {
                fontSize: 14,
                bold: true,
                margin: [0, 0, 0, 10]
            },
            header1: {
                fontSize: 10,
                bold: false,
                color: "#0D47A1"
            },
            header2: {
                fontSize: 10,
                bold: true,
                color: "#160091"
            }
        }

    };
    var flag = 0;
    var tabFlag = 0;
    data.map(function (value, index) {
        if (index != 0 && value == 'Particulars') {
            tabFlag = 1;
        }
        if (!tabFlag) {
            if (flag % 2 == 0) {
                dd.content[1].table.body[0][0].table.body.push([{ text: data[index], style: "header1" }, { text: data[index + 1], style: "header2" }]);
            }
        } else {
            if (flag % 2 == 0) {
                dd.content[1].table.body[0][1].table.body.push([{ text: data[index], style: "header1" }, { text: data[index + 1], style: "header2" }]);
            }
        }
        flag++;
    });
    return dd;
};

var convertToCashBook = function convertToCashBook(_ref5) {
    var data = _ref5.data,
        firm = _ref5.firm,
        dateFrom = _ref5.dateFrom,
        dateTo = _ref5.dateTo;

    var dd = {
        content: [{ text: 'Cash Book', style: 'header' }, {
            table: {
                body: [[{
                    table: {
                        body: []
                    }
                }, {
                    table: {
                        body: []
                    }
                }]]
            }
        }],
        styles: {
            header: {
                fontSize: 14,
                bold: true,
                margin: [0, 0, 0, 10]
            },
            header1: {
                fontSize: 10,
                bold: false,
                color: "#0D47A1"
            },
            header2: {
                fontSize: 10,
                bold: true,
                color: "#160091"
            }
        }

    };
    var flag = 0;
    var tabFlag = 0;
    data.map(function (value, index) {
        if (index != 0 && value == 'Particulars') {
            tabFlag = 1;
        }
        if (!tabFlag) {
            if (flag % 2 == 0) {
                dd.content[1].table.body[0][0].table.body.push([{ text: data[index], style: "header1" }, { text: data[index + 1], style: "header2" }]);
            }
        } else {
            if (flag % 2 == 0) {
                dd.content[1].table.body[0][1].table.body.push([{ text: data[index], style: "header1" }, { text: data[index + 1], style: "header2" }]);
            }
        }
        flag++;
    });
    return dd;
};

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export simpleInterest */
/* unused harmony export amountSI */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return amountCompound; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return compoundInterest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getGSTPercentageTotal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);

var simpleInterest = function simpleInterest(principle, rate, time) {
    return principle * rate * time;
};

var amountSI = function amountSI(principle, rate, time) {
    return principle + simpleInterest(principle, rate, time);
};

var amountCompound = function amountCompound(principle, rate, time) {
    var number_of_time_per_time = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    if (time < 1) {
        return amountSI(principle, rate, time);
    } else {
        return principle * Math.pow(1 + rate / number_of_time_per_time, number_of_time_per_time * time);
    }
};

var compoundInterest = function compoundInterest(principle, rate, time) {
    var number_of_time_per_time = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    return amountCompound(principle, rate, time, number_of_time_per_time) - principle;
};

var getGSTPercentageTotal = function getGSTPercentageTotal(products) {
    var GST_Percentage_total = {
        GST_0: 0,
        GST_3: 0,
        GST_5: 0,
        GST_12: 0,
        GST_18: 0,
        GST_28: 0
    };
    products.map(function (product) {
        switch (product.taxableGST_rate) {
            case 0:
                {
                    GST_Percentage_total["GST_0"] += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(product["GSTValue"]);
                    break;
                }
            case 3:
                {
                    GST_Percentage_total["GST_3"] += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(product["GSTValue"]);
                    break;
                }
            case 5:
                {
                    GST_Percentage_total["GST_5"] += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(product["GSTValue"]);
                    break;
                }
            case 12:
                {
                    GST_Percentage_total["GST_12"] += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(product["GSTValue"]);
                    break;
                }
            case 18:
                {
                    GST_Percentage_total["GST_18"] += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(product["GSTValue"]);
                    break;
                }
            case 28:
                {
                    GST_Percentage_total["GST_28"] += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(product["GSTValue"]);
                    break;
                }
        }
    });
    return GST_Percentage_total;
};

/* unused harmony default export */ var _unused_webpack_default_export = ({
    getGSTPercentageTotal: getGSTPercentageTotal,
    simpleInterest: simpleInterest,
    amountSI: amountSI,
    compoundInterest: compoundInterest,
    amountCompound: amountCompound
});

/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductReports_vue__ = __webpack_require__(486);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a66d82f4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductReports_vue__ = __webpack_require__(1484);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductReports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a66d82f4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductReports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return convertToExcelGST_3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return convertToExcelGST_1All; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buyerStatementExcel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_xlsx__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_xlsx__);



var convertToExcelGST_3 = function convertToExcelGST_3(_ref) {
  var selectedFirm = _ref.selectedFirm,
      inwardSupplies = _ref.inwardSupplies,
      outwardSupplies = _ref.outwardSupplies;

  // export json to Worksheet of Excel
  // only array possible
  var gstSummary = {
    description: 'Description of Invoices',
    taxable: 'Total Taxable Value',
    igst: 'IGST A.',
    cgst: 'CGST A.',
    sgst: 'SGST A.',
    cess: 'CESS',
    totalAmount: 'Total Invoices'
  };

  var firmHeader = {
    name: 'Name',
    address: 'Address',
    mobileNumber: 'Mobile',
    panNumber: 'PAN Number',
    email: 'Email',
    GST_number: 'GST Number',
    website: 'Website'
  };

  var firmData = [firmHeader, {
    name: selectedFirm.name,
    address: selectedFirm.address,
    mobileNumber: selectedFirm.mobileNumber,
    panNumber: selectedFirm.panNumber,
    email: selectedFirm.email,
    GST_number: selectedFirm.GST_number,
    website: selectedFirm.website
  }];

  var gstSummaryData = [gstSummary];

  gstSummaryData.push({
    description: 'OUTWARD SUPPLIES',
    taxable: outwardSupplies.totalBaseAmount,
    igst: outwardSupplies.IGST,
    cgst: outwardSupplies.CGST,
    sgst: outwardSupplies.SGST,
    cess: outwardSupplies.CESS,
    totalAmount: outwardSupplies.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: '(A). Intra state',
    taxable: outwardSupplies.intraState.totalBaseAmount,
    igst: outwardSupplies.intraState.IGST,
    cgst: outwardSupplies.intraState.CGST,
    sgst: outwardSupplies.intraState.SGST,
    cess: outwardSupplies.intraState.CESS,
    totalAmount: outwardSupplies.intraState.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: '(i). Taxable',
    taxable: outwardSupplies.intraState.taxable.totalBaseAmount,
    igst: outwardSupplies.intraState.taxable.IGST,
    cgst: outwardSupplies.intraState.taxable.CGST,
    sgst: outwardSupplies.intraState.taxable.SGST,
    cess: outwardSupplies.intraState.taxable.CESS,
    totalAmount: outwardSupplies.intraState.taxable.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: 'GST 0%',
    taxable: outwardSupplies.intraState.taxable.GST_0.totalBaseAmount,
    igst: outwardSupplies.intraState.taxable.GST_0.IGST,
    cgst: outwardSupplies.intraState.taxable.GST_0.CGST,
    sgst: outwardSupplies.intraState.taxable.GST_0.SGST,
    cess: outwardSupplies.intraState.taxable.GST_0.CESS,
    totalAmount: outwardSupplies.intraState.taxable.GST_0.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: 'GST 5%',
    taxable: outwardSupplies.intraState.taxable.GST_5.totalBaseAmount,
    igst: outwardSupplies.intraState.taxable.GST_5.IGST,
    cgst: outwardSupplies.intraState.taxable.GST_5.CGST,
    sgst: outwardSupplies.intraState.taxable.GST_5.SGST,
    cess: outwardSupplies.intraState.taxable.GST_5.CESS,
    totalAmount: outwardSupplies.intraState.taxable.GST_5.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: 'GST 12%',
    taxable: outwardSupplies.intraState.taxable.GST_12.totalBaseAmount,
    igst: outwardSupplies.intraState.taxable.GST_12.IGST,
    cgst: outwardSupplies.intraState.taxable.GST_12.CGST,
    sgst: outwardSupplies.intraState.taxable.GST_12.SGST,
    cess: outwardSupplies.intraState.taxable.GST_12.CESS,
    totalAmount: outwardSupplies.intraState.taxable.GST_12.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: 'GST 18%',
    taxable: outwardSupplies.intraState.taxable.GST_18.totalBaseAmount,
    igst: outwardSupplies.intraState.taxable.GST_18.IGST,
    cgst: outwardSupplies.intraState.taxable.GST_18.CGST,
    sgst: outwardSupplies.intraState.taxable.GST_18.SGST,
    cess: outwardSupplies.intraState.taxable.GST_18.CESS,
    totalAmount: outwardSupplies.intraState.taxable.GST_18.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: 'GST 28%',
    taxable: outwardSupplies.intraState.taxable.GST_28.totalBaseAmount,
    igst: outwardSupplies.intraState.taxable.GST_28.IGST,
    cgst: outwardSupplies.intraState.taxable.GST_28.CGST,
    sgst: outwardSupplies.intraState.taxable.GST_28.SGST,
    cess: outwardSupplies.intraState.taxable.GST_28.CESS,
    totalAmount: outwardSupplies.intraState.taxable.GST_28.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: '(ii). Exempted',
    taxable: outwardSupplies.intraState.exempted.totalBaseAmount,
    igst: outwardSupplies.intraState.exempted.IGST,
    cgst: outwardSupplies.intraState.exempted.CGST,
    sgst: outwardSupplies.intraState.exempted.SGST,
    cess: outwardSupplies.intraState.exempted.CESS,
    totalAmount: outwardSupplies.intraState.exempted.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: '(iii). Nill Rated',
    taxable: outwardSupplies.intraState.nillrated.totalBaseAmount,
    igst: outwardSupplies.intraState.nillrated.IGST,
    cgst: outwardSupplies.intraState.nillrated.CGST,
    sgst: outwardSupplies.intraState.nillrated.SGST,
    cess: outwardSupplies.intraState.nillrated.CESS,
    totalAmount: outwardSupplies.intraState.nillrated.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: '(iv). Others',
    taxable: outwardSupplies.intraState.others.totalBaseAmount,
    igst: outwardSupplies.intraState.others.IGST,
    cgst: outwardSupplies.intraState.others.CGST,
    sgst: outwardSupplies.intraState.others.SGST,
    cess: outwardSupplies.intraState.others.CESS,
    totalAmount: outwardSupplies.intraState.others.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: '(A). Inter state',
    taxable: outwardSupplies.interState.totalBaseAmount,
    igst: outwardSupplies.interState.IGST,
    cgst: outwardSupplies.interState.CGST,
    sgst: outwardSupplies.interState.SGST,
    cess: outwardSupplies.interState.CESS,
    totalAmount: outwardSupplies.interState.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: '(i). Taxable',
    taxable: outwardSupplies.interState.taxable.totalBaseAmount,
    igst: outwardSupplies.interState.taxable.IGST,
    cgst: outwardSupplies.interState.taxable.CGST,
    sgst: outwardSupplies.interState.taxable.SGST,
    cess: outwardSupplies.interState.taxable.CESS,
    totalAmount: outwardSupplies.interState.taxable.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: 'GST 0%',
    taxable: outwardSupplies.interState.taxable.GST_0.totalBaseAmount,
    igst: outwardSupplies.interState.taxable.GST_0.IGST,
    cgst: outwardSupplies.interState.taxable.GST_0.CGST,
    sgst: outwardSupplies.interState.taxable.GST_0.SGST,
    cess: outwardSupplies.interState.taxable.GST_0.CESS,
    totalAmount: outwardSupplies.interState.taxable.GST_0.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: 'GST 5%',
    taxable: outwardSupplies.interState.taxable.GST_5.totalBaseAmount,
    igst: outwardSupplies.interState.taxable.GST_5.IGST,
    cgst: outwardSupplies.interState.taxable.GST_5.CGST,
    sgst: outwardSupplies.interState.taxable.GST_5.SGST,
    cess: outwardSupplies.interState.taxable.GST_5.CESS,
    totalAmount: outwardSupplies.interState.taxable.GST_5.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: 'GST 12%',
    taxable: outwardSupplies.interState.taxable.GST_12.totalBaseAmount,
    igst: outwardSupplies.interState.taxable.GST_12.IGST,
    cgst: outwardSupplies.interState.taxable.GST_12.CGST,
    sgst: outwardSupplies.interState.taxable.GST_12.SGST,
    cess: outwardSupplies.interState.taxable.GST_12.CESS,
    totalAmount: outwardSupplies.interState.taxable.GST_12.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: 'GST 18%',
    taxable: outwardSupplies.interState.taxable.GST_18.totalBaseAmount,
    igst: outwardSupplies.interState.taxable.GST_18.IGST,
    cgst: outwardSupplies.interState.taxable.GST_18.CGST,
    sgst: outwardSupplies.interState.taxable.GST_18.SGST,
    cess: outwardSupplies.interState.taxable.GST_18.CESS,
    totalAmount: outwardSupplies.interState.taxable.GST_18.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: 'GST 28%',
    taxable: outwardSupplies.interState.taxable.GST_28.totalBaseAmount,
    igst: outwardSupplies.interState.taxable.GST_28.IGST,
    cgst: outwardSupplies.interState.taxable.GST_28.CGST,
    sgst: outwardSupplies.interState.taxable.GST_28.SGST,
    cess: outwardSupplies.interState.taxable.GST_28.CESS,
    totalAmount: outwardSupplies.interState.taxable.GST_28.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: '(ii). Exempted',
    taxable: outwardSupplies.interState.exempted.totalBaseAmount,
    igst: outwardSupplies.interState.exempted.IGST,
    cgst: outwardSupplies.interState.exempted.CGST,
    sgst: outwardSupplies.interState.exempted.SGST,
    cess: outwardSupplies.interState.exempted.CESS,
    totalAmount: outwardSupplies.interState.exempted.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: '(iii). Nill Rated',
    taxable: outwardSupplies.interState.nillrated.totalBaseAmount,
    igst: outwardSupplies.interState.nillrated.IGST,
    cgst: outwardSupplies.interState.nillrated.CGST,
    sgst: outwardSupplies.interState.nillrated.SGST,
    cess: outwardSupplies.interState.nillrated.CESS,
    totalAmount: outwardSupplies.interState.nillrated.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: '(iv). Others',
    taxable: outwardSupplies.interState.others.totalBaseAmount,
    igst: outwardSupplies.interState.others.IGST,
    cgst: outwardSupplies.interState.others.CGST,
    sgst: outwardSupplies.interState.others.SGST,
    cess: outwardSupplies.interState.others.CESS,
    totalAmount: outwardSupplies.interState.others.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: 'INWARD SUPPLIES',
    taxable: inwardSupplies.totalBaseAmount,
    igst: inwardSupplies.IGST,
    cgst: inwardSupplies.CGST,
    sgst: inwardSupplies.SGST,
    cess: inwardSupplies.CESS,
    totalAmount: inwardSupplies.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: '(A). Intra state',
    taxable: inwardSupplies.intraState.totalBaseAmount,
    igst: inwardSupplies.intraState.IGST,
    cgst: inwardSupplies.intraState.CGST,
    sgst: inwardSupplies.intraState.SGST,
    cess: inwardSupplies.intraState.CESS,
    totalAmount: inwardSupplies.intraState.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: '(i). Taxable',
    taxable: inwardSupplies.intraState.taxable.totalBaseAmount,
    igst: inwardSupplies.intraState.taxable.IGST,
    cgst: inwardSupplies.intraState.taxable.CGST,
    sgst: inwardSupplies.intraState.taxable.SGST,
    cess: inwardSupplies.intraState.taxable.CESS,
    totalAmount: inwardSupplies.intraState.taxable.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: 'GST 0%',
    taxable: inwardSupplies.intraState.taxable.GST_0.totalBaseAmount,
    igst: inwardSupplies.intraState.taxable.GST_0.IGST,
    cgst: inwardSupplies.intraState.taxable.GST_0.CGST,
    sgst: inwardSupplies.intraState.taxable.GST_0.SGST,
    cess: inwardSupplies.intraState.taxable.GST_0.CESS,
    totalAmount: inwardSupplies.intraState.taxable.GST_0.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: 'GST 5%',
    taxable: inwardSupplies.intraState.taxable.GST_5.totalBaseAmount,
    igst: inwardSupplies.intraState.taxable.GST_5.IGST,
    cgst: inwardSupplies.intraState.taxable.GST_5.CGST,
    sgst: inwardSupplies.intraState.taxable.GST_5.SGST,
    cess: inwardSupplies.intraState.taxable.GST_5.CESS,
    totalAmount: inwardSupplies.intraState.taxable.GST_5.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: 'GST 12%',
    taxable: inwardSupplies.intraState.taxable.GST_12.totalBaseAmount,
    igst: inwardSupplies.intraState.taxable.GST_12.IGST,
    cgst: inwardSupplies.intraState.taxable.GST_12.CGST,
    sgst: inwardSupplies.intraState.taxable.GST_12.SGST,
    cess: inwardSupplies.intraState.taxable.GST_12.CESS,
    totalAmount: inwardSupplies.intraState.taxable.GST_12.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: 'GST 18%',
    taxable: inwardSupplies.intraState.taxable.GST_18.totalBaseAmount,
    igst: inwardSupplies.intraState.taxable.GST_18.IGST,
    cgst: inwardSupplies.intraState.taxable.GST_18.CGST,
    sgst: inwardSupplies.intraState.taxable.GST_18.SGST,
    cess: inwardSupplies.intraState.taxable.GST_18.CESS,
    totalAmount: inwardSupplies.intraState.taxable.GST_18.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: 'GST 28%',
    taxable: inwardSupplies.intraState.taxable.GST_28.totalBaseAmount,
    igst: inwardSupplies.intraState.taxable.GST_28.IGST,
    cgst: inwardSupplies.intraState.taxable.GST_28.CGST,
    sgst: inwardSupplies.intraState.taxable.GST_28.SGST,
    cess: inwardSupplies.intraState.taxable.GST_28.CESS,
    totalAmount: inwardSupplies.intraState.taxable.GST_28.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: '(ii). Exempted',
    taxable: inwardSupplies.intraState.exempted.totalBaseAmount,
    igst: inwardSupplies.intraState.exempted.IGST,
    cgst: inwardSupplies.intraState.exempted.CGST,
    sgst: inwardSupplies.intraState.exempted.SGST,
    cess: inwardSupplies.intraState.exempted.CESS,
    totalAmount: inwardSupplies.intraState.exempted.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: '(iii). Nill Rated',
    taxable: inwardSupplies.intraState.nillrated.totalBaseAmount,
    igst: inwardSupplies.intraState.nillrated.IGST,
    cgst: inwardSupplies.intraState.nillrated.CGST,
    sgst: inwardSupplies.intraState.nillrated.SGST,
    cess: inwardSupplies.intraState.nillrated.CESS,
    totalAmount: inwardSupplies.intraState.nillrated.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: '(iv). Others',
    taxable: inwardSupplies.intraState.others.totalBaseAmount,
    igst: inwardSupplies.intraState.others.IGST,
    cgst: inwardSupplies.intraState.others.CGST,
    sgst: inwardSupplies.intraState.others.SGST,
    cess: inwardSupplies.intraState.others.CESS,
    totalAmount: inwardSupplies.intraState.others.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: '(A). Inter state',
    taxable: inwardSupplies.interState.totalBaseAmount,
    igst: inwardSupplies.interState.IGST,
    cgst: inwardSupplies.interState.CGST,
    sgst: inwardSupplies.interState.SGST,
    cess: inwardSupplies.interState.CESS,
    totalAmount: inwardSupplies.interState.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: '(i). Taxable',
    taxable: inwardSupplies.interState.taxable.totalBaseAmount,
    igst: inwardSupplies.interState.taxable.IGST,
    cgst: inwardSupplies.interState.taxable.CGST,
    sgst: inwardSupplies.interState.taxable.SGST,
    cess: inwardSupplies.interState.taxable.CESS,
    totalAmount: inwardSupplies.interState.taxable.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: 'GST 0%',
    taxable: inwardSupplies.interState.taxable.GST_0.totalBaseAmount,
    igst: inwardSupplies.interState.taxable.GST_0.IGST,
    cgst: inwardSupplies.interState.taxable.GST_0.CGST,
    sgst: inwardSupplies.interState.taxable.GST_0.SGST,
    cess: inwardSupplies.interState.taxable.GST_0.CESS,
    totalAmount: inwardSupplies.interState.taxable.GST_0.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: 'GST 5%',
    taxable: inwardSupplies.interState.taxable.GST_5.totalBaseAmount,
    igst: inwardSupplies.interState.taxable.GST_5.IGST,
    cgst: inwardSupplies.interState.taxable.GST_5.CGST,
    sgst: inwardSupplies.interState.taxable.GST_5.SGST,
    cess: inwardSupplies.interState.taxable.GST_5.CESS,
    totalAmount: inwardSupplies.interState.taxable.GST_5.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: 'GST 12%',
    taxable: inwardSupplies.interState.taxable.GST_12.totalBaseAmount,
    igst: inwardSupplies.interState.taxable.GST_12.IGST,
    cgst: inwardSupplies.interState.taxable.GST_12.CGST,
    sgst: inwardSupplies.interState.taxable.GST_12.SGST,
    cess: inwardSupplies.interState.taxable.GST_12.CESS,
    totalAmount: inwardSupplies.interState.taxable.GST_12.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: 'GST 18%',
    taxable: inwardSupplies.interState.taxable.GST_18.totalBaseAmount,
    igst: inwardSupplies.interState.taxable.GST_18.IGST,
    cgst: inwardSupplies.interState.taxable.GST_18.CGST,
    sgst: inwardSupplies.interState.taxable.GST_18.SGST,
    cess: inwardSupplies.interState.taxable.GST_18.CESS,
    totalAmount: inwardSupplies.interState.taxable.GST_18.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: 'GST 28%',
    taxable: inwardSupplies.interState.taxable.GST_28.totalBaseAmount,
    igst: inwardSupplies.interState.taxable.GST_28.IGST,
    cgst: inwardSupplies.interState.taxable.GST_28.CGST,
    sgst: inwardSupplies.interState.taxable.GST_28.SGST,
    cess: inwardSupplies.interState.taxable.GST_28.CESS,
    totalAmount: inwardSupplies.interState.taxable.GST_28.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: '(ii). Exempted',
    taxable: inwardSupplies.interState.exempted.totalBaseAmount,
    igst: inwardSupplies.interState.exempted.IGST,
    cgst: inwardSupplies.interState.exempted.CGST,
    sgst: inwardSupplies.interState.exempted.SGST,
    cess: inwardSupplies.interState.exempted.CESS,
    totalAmount: inwardSupplies.interState.exempted.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: '(iii). Nill Rated',
    taxable: inwardSupplies.interState.nillrated.totalBaseAmount,
    igst: inwardSupplies.interState.nillrated.IGST,
    cgst: inwardSupplies.interState.nillrated.CGST,
    sgst: inwardSupplies.interState.nillrated.SGST,
    cess: inwardSupplies.interState.nillrated.CESS,
    totalAmount: inwardSupplies.interState.nillrated.totalInvoiceAmount
  });

  gstSummaryData.push({
    description: '(iv). Others',
    taxable: inwardSupplies.interState.others.totalBaseAmount,
    igst: inwardSupplies.interState.others.IGST,
    cgst: inwardSupplies.interState.others.CGST,
    sgst: inwardSupplies.interState.others.SGST,
    cess: inwardSupplies.interState.others.CESS,
    totalAmount: inwardSupplies.interState.others.totalInvoiceAmount
  });

  var gstr3Header = {
    sNo: 'S. No',
    description: 'Description',
    placeOfSupply: "Place of Supply",
    taxable: "Taxable Value",
    igst: 'IGST A.',
    cgst: 'CGST A.',
    sgst: 'SGST A.',
    cess: 'CESS',
    totalAmount: 'Total Invoices'
  };

  var gstr3Data = [gstr3Header];

  gstr3Data.push({
    sNo: '3.1',
    description: 'OUTWARD & INWARD SUPPLIES',
    placeOfSupply: "-",
    taxable: inwardSupplies.totalBaseAmount + outwardSupplies.totalBaseAmount,
    igst: inwardSupplies.IGST + outwardSupplies.IGST,
    cgst: inwardSupplies.CGST + outwardSupplies.CGST,
    sgst: inwardSupplies.SGST + outwardSupplies.SGST,
    cess: inwardSupplies.CESS + outwardSupplies.CESS,
    totalAmount: inwardSupplies.totalInvoiceAmount + outwardSupplies.totalInvoiceAmount
  });

  gstr3Data.push({
    sNo: '',
    description: '(A). Outward Taxable Supplies [Taxable]',
    placeOfSupply: "-",
    taxable: outwardSupplies.interState.taxable.totalBaseAmount + outwardSupplies.intraState.taxable.totalBaseAmount,
    igst: outwardSupplies.interState.taxable.IGST + outwardSupplies.intraState.taxable.IGST,
    cgst: outwardSupplies.interState.taxable.CGST + outwardSupplies.intraState.taxable.CGST,
    sgst: outwardSupplies.interState.taxable.SGST + outwardSupplies.intraState.taxable.SGST,
    cess: outwardSupplies.interState.taxable.CESS + outwardSupplies.intraState.taxable.CESS,
    totalAmount: outwardSupplies.interState.taxable.totalInvoiceAmount + outwardSupplies.intraState.taxable.totalInvoiceAmount
  });

  gstr3Data.push({
    sNo: '',
    description: '(B). Outward Taxable Supplies [Zero Rated]',
    placeOfSupply: "-",
    taxable: outwardSupplies.interState.nillrated.totalBaseAmount + outwardSupplies.intraState.nillrated.totalBaseAmount,
    igst: outwardSupplies.interState.nillrated.IGST + outwardSupplies.intraState.nillrated.IGST,
    cgst: outwardSupplies.interState.nillrated.CGST + outwardSupplies.intraState.nillrated.CGST,
    sgst: outwardSupplies.interState.nillrated.SGST + outwardSupplies.intraState.nillrated.SGST,
    cess: outwardSupplies.interState.nillrated.CESS + outwardSupplies.intraState.nillrated.CESS,
    totalAmount: outwardSupplies.interState.nillrated.totalInvoiceAmount + outwardSupplies.intraState.nillrated.totalInvoiceAmount
  });

  gstr3Data.push({
    sNo: '',
    description: '(C). Outward Taxable Supplies [Nill Rated or Exempt]',
    placeOfSupply: "-",
    taxable: outwardSupplies.interState.exempted.totalBaseAmount + outwardSupplies.intraState.exempted.totalBaseAmount,
    igst: outwardSupplies.interState.exempted.IGST + outwardSupplies.intraState.exempted.IGST,
    cgst: outwardSupplies.interState.exempted.CGST + outwardSupplies.intraState.exempted.CGST,
    sgst: outwardSupplies.interState.exempted.SGST + outwardSupplies.intraState.exempted.SGST,
    cess: outwardSupplies.interState.exempted.CESS + outwardSupplies.intraState.exempted.CESS,
    totalAmount: outwardSupplies.interState.exempted.totalInvoiceAmount + outwardSupplies.intraState.exempted.totalInvoiceAmount
  });

  gstr3Data.push({
    sNo: '',
    description: '(D). Inward Taxable Supplies [Liable To Reverse Charge]',
    placeOfSupply: "-",
    taxable: 0,
    igst: 0,
    cgst: 0,
    sgst: 0,
    cess: 0,
    totalAmount: 0
  });

  gstr3Data.push({
    sNo: '',
    description: '(E). NON-GST Outward Supplies',
    placeOfSupply: "-",
    taxable: outwardSupplies.interState.others.totalBaseAmount + outwardSupplies.intraState.others.totalBaseAmount,
    igst: outwardSupplies.interState.others.IGST + outwardSupplies.intraState.others.IGST,
    cgst: outwardSupplies.interState.others.CGST + outwardSupplies.intraState.others.CGST,
    sgst: outwardSupplies.interState.others.SGST + outwardSupplies.intraState.others.SGST,
    cess: outwardSupplies.interState.others.CESS + outwardSupplies.intraState.others.CESS,
    totalAmount: outwardSupplies.interState.others.totalInvoiceAmount + outwardSupplies.intraState.others.totalInvoiceAmount
  });

  gstr3Data.push({
    sNo: '3.2',
    description: 'INTER-STATE Supplies Made To Understand Composition Taxable Persons UIN Holders',
    placeOfSupply: "-",
    taxable: 0,
    igst: 0,
    cgst: 0,
    sgst: 0,
    cess: 0,
    totalAmount: 0
  });

  gstr3Data.push({
    sNo: '4',
    description: 'ELIGIABLE ITC',
    placeOfSupply: "-",
    taxable: 0,
    igst: 0,
    cgst: 0,
    sgst: 0,
    cess: 0,
    totalAmount: 0
  });

  gstr3Data.push({
    sNo: '',
    description: '(A). ITC Available [Full/Part]',
    placeOfSupply: "-",
    taxable: 0,
    igst: 0,
    cgst: 0,
    sgst: 0,
    cess: 0,
    totalAmount: 0
  });

  gstr3Data.push({
    sNo: '',
    description: '(i). Imports of Goods',
    placeOfSupply: "-",
    taxable: 0,
    igst: 0,
    cgst: 0,
    sgst: 0,
    cess: 0,
    totalAmount: 0
  });

  gstr3Data.push({
    sNo: '',
    description: '(ii). Imports of Services',
    placeOfSupply: "-",
    taxable: 0,
    igst: 0,
    cgst: 0,
    sgst: 0,
    cess: 0,
    totalAmount: 0
  });

  gstr3Data.push({
    sNo: '',
    description: '(iii). Inward Supplies Liable To reverse charges',
    placeOfSupply: "-",
    taxable: 0,
    igst: 0,
    cgst: 0,
    sgst: 0,
    cess: 0,
    totalAmount: 0
  });

  gstr3Data.push({
    sNo: '',
    description: '(iv). Inward Supplies From ISD',
    placeOfSupply: "-",
    taxable: 0,
    igst: 0,
    cgst: 0,
    sgst: 0,
    cess: 0,
    totalAmount: 0
  });

  gstr3Data.push({
    sNo: '',
    description: '(v). All Other ITC',
    placeOfSupply: "-",
    taxable: 0,
    igst: 0,
    cgst: 0,
    sgst: 0,
    cess: 0,
    totalAmount: 0
  });

  gstr3Data.push({
    sNo: '',
    description: '(B). ITC Reserved',
    placeOfSupply: "-",
    taxable: 0,
    igst: 0,
    cgst: 0,
    sgst: 0,
    cess: 0,
    totalAmount: 0
  });

  gstr3Data.push({
    sNo: '',
    description: '(i). As per Rules 42 & 43 of cost',
    placeOfSupply: "-",
    taxable: 0,
    igst: 0,
    cgst: 0,
    sgst: 0,
    cess: 0,
    totalAmount: 0
  });

  gstr3Data.push({
    sNo: '',
    description: '(ii). Others',
    placeOfSupply: "-",
    taxable: 0,
    igst: 0,
    cgst: 0,
    sgst: 0,
    cess: 0,
    totalAmount: 0
  });

  gstr3Data.push({
    sNo: '',
    description: '(C). Net ITC Available (A) - (B)',
    placeOfSupply: "-",
    taxable: 0,
    igst: 0,
    cgst: 0,
    sgst: 0,
    cess: 0,
    totalAmount: 0
  });

  gstr3Data.push({
    sNo: '',
    description: '(D). InEligible ITC',
    placeOfSupply: "-",
    taxable: 0,
    igst: 0,
    cgst: 0,
    sgst: 0,
    cess: 0,
    totalAmount: 0
  });

  gstr3Data.push({
    sNo: '',
    description: '(i). As per Section 17(s)',
    placeOfSupply: "-",
    taxable: 0,
    igst: 0,
    cgst: 0,
    sgst: 0,
    cess: 0,
    totalAmount: 0
  });

  gstr3Data.push({
    sNo: '',
    description: '(ii). Others',
    placeOfSupply: "-",
    taxable: 0,
    igst: 0,
    cgst: 0,
    sgst: 0,
    cess: 0,
    totalAmount: 0
  });

  gstr3Data.push({
    sNo: '5',
    description: 'Values Of Exempted Nill rated & NON-GST Inward Supplies',
    placeOfSupply: "-",
    taxable: 0,
    igst: 0,
    cgst: 0,
    sgst: 0,
    cess: 0,
    totalAmount: 0
  });

  gstr3Data.push({
    sNo: '',
    description: '(A). From Supplier Under Composition Scheme, Exempt & Nillrated Supplies',
    placeOfSupply: "-",
    taxable: 0,
    igst: 0,
    cgst: 0,
    sgst: 0,
    cess: 0,
    totalAmount: 0
  });

  gstr3Data.push({
    sNo: '',
    description: '(B). Non-GST Supplies',
    placeOfSupply: "-",
    taxable: 0,
    igst: 0,
    cgst: 0,
    sgst: 0,
    cess: 0,
    totalAmount: 0
  });

  var gstSummaryWS = __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.json_to_sheet(gstSummaryData, { skipHeader: true });
  var firmWS = __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.json_to_sheet(firmData, { skipHeader: true });
  var gstr3WS = __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.json_to_sheet(gstr3Data, { skipHeader: true });

  // A workbook is the name given to an Excel file
  var wb = __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.book_new(); // make Workbook of Excel

  // add Worksheet to Workbook
  // Workbook contains one or more worksheets
  __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.book_append_sheet(wb, gstSummaryWS, 'GST Summary');
  __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.book_append_sheet(wb, gstr3WS, 'GSTR-3'); // sheetAName is name of Worksheet
  __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.book_append_sheet(wb, firmWS, 'Firm');

  return wb;

  // export Excel file
};

var convertToExcelGST_1All = function convertToExcelGST_1All(_ref2) {
  var selectedFirm = _ref2.selectedFirm,
      B2B_invoices = _ref2.B2B_invoices,
      B2C_invoices_big = _ref2.B2C_invoices_big,
      B2C_invoices_small = _ref2.B2C_invoices_small,
      Nillrated_invoices = _ref2.Nillrated_invoices,
      Export_invoices = _ref2.Export_invoices,
      Adjustment_advance = _ref2.Adjustment_advance,
      Tax_Liability = _ref2.Tax_Liability,
      Credit_Debit_note_reg = _ref2.Credit_Debit_note_reg,
      Credit_Debit_note_unreg = _ref2.Credit_Debit_note_unreg,
      HSN_SAC_Summary = _ref2.HSN_SAC_Summary,
      Document_Summary = _ref2.Document_Summary;

  var wb = __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.book_new(); // make Workbook of Excel

  var firmHeader = {
    name: 'Name',
    address: 'Address',
    mobileNumber: 'Mobile',
    panNumber: 'PAN Number',
    email: 'Email',
    GST_number: 'GST Number',
    website: 'Website'
  };

  var firmData = [firmHeader, {
    name: selectedFirm.name,
    address: selectedFirm.address,
    mobileNumber: selectedFirm.mobileNumber,
    panNumber: selectedFirm.panNumber,
    email: selectedFirm.email,
    GST_number: selectedFirm.GST_number,
    website: selectedFirm.website
  }];
  var firmWS = __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.json_to_sheet(firmData, { skipHeader: true });
  __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.book_append_sheet(wb, firmWS, 'Firm');

  var b2bHeader = {
    gstin: 'GSTIN OR UIN',
    invoiceId: 'INVOICE NUMBER',
    date: 'INVOICE DATE',
    totalAmount: 'INVOICE VALUE',
    location: 'PLACE OF SUPPLY',
    revevrseCharge: 'REVERSE CHARGE',
    applicable_tax_rate: 'APPLICABLE % OF TAX RATE',
    type: 'INVOICE TYPE',
    gstin_op: 'GSTIN OF E-COMMERCE OPERATOR',
    s_no: 'SERIAL NUMBER',
    rate: 'RATE',
    basicAmount: 'TAXABLE VALUE',
    IGST_val: 'INTEGRATED TAX',
    CGST_val: 'CENTRAL TAX',
    SGST_val: 'STATE OR UT TAX',
    CESS: 'CESS'
  };

  var b2bData = [b2bHeader].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(B2B_invoices.invoices.map(function (invoice, index) {
    return {
      gstin: invoice.buyer.GST_number,
      invoiceId: invoice.invoiceId,
      date: new Date(invoice.date).toLocaleDateString('en-GB'),
      totalAmount: invoice.totalAmount,
      location: invoice.buyer.state,
      revevrseCharge: 0,
      applicable_tax_rate: 0,
      type: '-',
      gstin_op: '-',
      s_no: index + 1,
      rate: '-',
      basicAmount: invoice.basicAmount,
      IGST_val: invoice.IGST_val,
      CGST_val: invoice.CGST_val,
      SGST_val: invoice.SGST_val,
      CESS: invoice.CESS
    };
  })));

  var b2bWS = __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.json_to_sheet(b2bData, { skipHeader: true });
  __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.book_append_sheet(wb, b2bWS, 'B2B');

  //B2C_invoices_big
  var b2clHeader = {
    invoiceId: 'INVOICE NUMBER',
    date: 'INVOICE DATE',
    totalAmount: 'INVOICE VALUE',
    location: 'PLACE OF SUPPLY',
    applicable_tax_rate: 'APPLICABLE % OF TAX RATE',
    gstin_op: 'GSTIN OF E-COMMERCE OPERATOR',
    s_no: 'SERIAL NUMBER',
    rate: 'RATE',
    basicAmount: 'TAXABLE VALUE',
    IGST_val: 'INTEGRATED TAX',
    CESS: 'CESS'
  };

  var b2clData = [b2clHeader].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(B2C_invoices_big.invoices.map(function (invoice, index) {
    return {
      invoiceId: invoice.invoiceId,
      date: new Date(invoice.date).toLocaleDateString('en-GB'),
      totalAmount: invoice.totalAmount,
      location: invoice.buyer.state,
      applicable_tax_rate: 0,
      gstin_op: '-',
      s_no: index + 1,
      rate: '-',
      basicAmount: invoice.basicAmount,
      IGST_val: invoice.IGST_val,
      CESS: invoice.CESS
    };
  })));

  var b2clWS = __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.json_to_sheet(b2clData, { skipHeader: true });
  __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.book_append_sheet(wb, b2clWS, 'B2CL');

  //B2C_invoices_small
  var b2csHeader = {
    type: 'TYPE',
    location: 'PLACE OF SUPPLY',
    supplyType: 'SUPPLY TYPE',
    applicable_tax_rate: 'APPLICABLE % OF TAX RATE',
    gstin_op: 'GSTIN OF E-COMMERCE OPERATOR',
    rate: 'RATE',
    basicAmount: 'TAXABLE VALUE',
    IGST_val: 'INTEGRATED TAX',
    CGST_val: 'CENTRAL TAX',
    SGST_val: 'STATE OR UT TAX',
    CESS: 'CESS'
  };

  var b2csData = [b2csHeader].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(B2C_invoices_small.invoices.map(function (invoice, index) {
    return {
      type: '-',
      location: invoice.buyer.state,
      supplyType: '',
      applicable_tax_rate: 0,
      gstin_op: '-',
      rate: '-',
      basicAmount: invoice.basicAmount,
      IGST_val: invoice.IGST_val,
      CGST_val: invoice.CGST_val,
      SGST_val: invoice.SGST_val,
      CESS: invoice.CESS
    };
  })));

  var b2csWS = __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.json_to_sheet(b2csData, { skipHeader: true });
  __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.book_append_sheet(wb, b2csWS, 'B2CS');

  //Nillrated_invoices
  var nillHeader = {
    natureOfSupply: 'NATURE OF SUPPLY',
    nilRatedSupplies: 'NIL RATED SUPPLIES',
    exempted: 'EXEMPTED',
    nonGSTSupplies: 'NON-GST SUPPLIES'
  };

  var nillData = [nillHeader].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(Nillrated_invoices.invoices.map(function (invoice, index) {
    return {
      natureOfSupply: '-',
      nilRatedSupplies: '-',
      exempted: '-',
      nonGSTSupplies: '-'
    };
  })));

  var nillWS = __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.json_to_sheet(nillData, { skipHeader: true });
  __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.book_append_sheet(wb, nillWS, 'NIL');

  //Export_invoices

  var exportHeader = {
    exportType: 'EXPORT TYPE',
    invoiceId: 'INVOICE NUMBER',
    date: 'INVOICE DATE',
    totalAmount: 'INVOICE VALUE',
    shippingBillNo: 'SHIPPING BILL NO. OR BILL OF EXPORT NO.',
    shippingBillDate: 'SHIPPING BILL DATE OR BILL OF EXPORT DATE',
    shippingBillPort: 'SHIPPING BILL PORT CODE',
    applicable_tax_rate: 'APPLICABLE % OF TAX RATE',
    rate: 'RATE',
    basicAmount: 'TAXABLE VALUE',
    IGST_val: 'INTEGRATED TAX',
    CESS: 'CESS'
  };

  var exportData = [exportHeader].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(Export_invoices.invoices.map(function (invoice, index) {
    return {
      exportType: '-',
      invoiceId: invoice.invoiceId,
      date: new Date(invoice.date).toLocaleDateString('en-GB'),
      totalAmount: invoice.totalAmount,
      shippingBillNo: '-',
      shippingBillDate: '-',
      shippingBillPort: '-',
      applicable_tax_rate: 0,
      rate: '-',
      basicAmount: invoice.basicAmount,
      IGST_val: invoice.IGST_val,
      CESS: invoice.CESS
    };
  })));

  var exportWS = __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.json_to_sheet(exportData, { skipHeader: true });
  __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.book_append_sheet(wb, exportWS, 'EXP');

  //Adjustment_advance

  var atHeader = {
    location: 'PLACE OF SUPPLY',
    supplyType: 'SUPPLY TYPE',
    applicable_tax_rate: 'APPLICABLE % OF TAX RATE',
    rate: 'RATE',
    grossAdvanceReceived: 'GROSS ADVANCE RECEIVED',
    IGST_val: 'INTEGRATED TAX',
    CGST_val: 'CENTRAL TAX',
    SGST_val: 'STATE OR UT TAX',
    CESS: 'CESS'
  };

  var atData = [atHeader].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(Adjustment_advance.invoices.map(function (invoice, index) {
    return {
      location: invoice.buyer.state,
      supplyType: '-',
      applicable_tax_rate: '-',
      rate: '-',
      grossAdvanceReceived: '-',
      IGST_val: invoice.IGST_val,
      CGST_val: invoice.CGST_val,
      SGST_val: invoice.SGST_val,
      CESS: invoice.CESS
    };
  })));

  var atWS = __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.json_to_sheet(atData, { skipHeader: true });
  __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.book_append_sheet(wb, atWS, 'AT');

  //Tax_Liability

  var tlHeader = {
    location: 'PLACE OF SUPPLY',
    supplyType: 'SUPPLY TYPE',
    applicable_tax_rate: 'APPLICABLE % OF TAX RATE',
    rate: 'RATE',
    grossAdvanceReceived: 'GROSS ADVANCE RECEIVED',
    IGST_val: 'INTEGRATED TAX',
    CGST_val: 'CENTRAL TAX',
    SGST_val: 'STATE OR UT TAX',
    CESS: 'CESS'
  };

  var tlData = [tlHeader].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(Tax_Liability.invoices.map(function (invoice, index) {
    return {
      location: invoice.buyer.state,
      supplyType: '-',
      applicable_tax_rate: '-',
      rate: '-',
      grossAdvanceReceived: '-',
      IGST_val: invoice.IGST_val,
      CGST_val: invoice.CGST_val,
      SGST_val: invoice.SGST_val,
      CESS: invoice.CESS
    };
  })));

  var tlWS = __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.json_to_sheet(tlData, { skipHeader: true });
  __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.book_append_sheet(wb, tlWS, 'TXP');

  //Credit_Debit_note_reg

  var cdnrHeader = {
    gstin: 'GSTIN OR UIN',
    invoiceId: 'INVOICE NUMBER',
    date: 'INVOICE DATE',
    noteType: 'NOTE TYPE',
    noteNumber: 'NOTE NUMBER',
    noteDate: 'NOTE DATE',
    totalAmount: 'NOTE VALUE',
    preGSTRegime: 'PRE GST REGIME?',
    applicable_tax_rate: 'APPLICABLE % OF TAX RATE',
    s_no: 'SERIAL NUMBER',
    rate: 'RATE',
    basicAmount: 'TAXABLE VALUE',
    IGST_val: 'INTEGRATED TAX',
    CGST_val: 'CENTRAL TAX',
    SGST_val: 'STATE OR UT TAX',
    CESS: 'CESS'
  };

  var cdnrData = [cdnrHeader].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(Credit_Debit_note_reg.invoices.map(function (invoice, index) {
    return {
      gstin: invoice.buyer.GST_number,
      invoiceId: invoice.invoiceId,
      date: new Date(invoice.date).toLocaleDateString('en-GB'),
      noteType: '-',
      noteNumber: '-',
      noteDate: '-',
      totalAmount: invoice.totalAmount,
      preGSTRegime: '-',
      applicable_tax_rate: 0,
      type: '-',
      gstin_op: '-',
      s_no: index + 1,
      rate: '-',
      basicAmount: invoice.basicAmount,
      IGST_val: invoice.IGST_val,
      CGST_val: invoice.CGST_val,
      SGST_val: invoice.SGST_val,
      CESS: invoice.CESS
    };
  })));

  var cdnrWS = __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.json_to_sheet(cdnrData, { skipHeader: true });
  __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.book_append_sheet(wb, cdnrWS, 'CDNR');

  //Credit_Debit_note_unreg


  var cdnurHeader = {
    counterPartyType: 'COUNTER PARTY TYPE',
    invoiceId: 'INVOICE NUMBER',
    date: 'INVOICE DATE',
    noteType: 'NOTE TYPE',
    noteNumber: 'NOTE NUMBER',
    noteDate: 'NOTE DATE',
    totalAmount: 'NOTE VALUE',
    preGSTRegime: 'PRE GST REGIME?',
    applicable_tax_rate: 'APPLICABLE % OF TAX RATE',
    s_no: 'SERIAL NUMBER',
    rate: 'RATE',
    basicAmount: 'TAXABLE VALUE',
    IGST_val: 'INTEGRATED TAX',
    CESS: 'CESS'
  };

  var cdnurData = [cdnurHeader].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(Credit_Debit_note_unreg.invoices.map(function (invoice, index) {
    return {
      counterPartyType: '-',
      invoiceId: invoice.invoiceId,
      date: new Date(invoice.date).toLocaleDateString('en-GB'),
      noteType: '-',
      noteNumber: '-',
      noteDate: '-',
      totalAmount: invoice.totalAmount,
      preGSTRegime: '-',
      applicable_tax_rate: 0,
      type: '-',
      gstin_op: '-',
      s_no: index + 1,
      rate: '-',
      basicAmount: invoice.basicAmount,
      IGST_val: invoice.IGST_val,
      CESS: invoice.CESS
    };
  })));

  var cdnurWS = __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.json_to_sheet(cdnurData, { skipHeader: true });
  __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.book_append_sheet(wb, cdnurWS, 'CDNUR');

  //HSN_SAC_Summary 

  var hsnHeader = {
    s_no: 'SERIAL NUMBER',
    hsnCode: 'HSN OR SAC CODE',
    desc: 'DESCRIPTION',
    uqc: 'UQC',
    quantity: 'TOTAL QUANTITY',
    totalAmount: 'TOTAL VALUE',
    basicAmount: 'TAXABLE VALUE',
    IGST_val: 'INTEGRATED TAX',
    CGST_val: 'CENTRAL TAX',
    SGST_val: 'STATE OR UT TAX',
    CESS: 'CESS'

  };

  var hsnData = [hsnHeader].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(HSN_SAC_Summary.invoices.map(function (invoice, index) {
    return {
      s_no: index + 1,
      hsnCode: '-',
      desc: '-',
      counterPartyType: '-',
      uqc: '-',
      quantity: '-',
      totalAmount: invoice.totalAmount,
      basicAmount: invoice.basicAmount,
      IGST_val: invoice.IGST_val,
      CGST_val: invoice.CGST_val,
      SGST_val: invoice.SGST_val,
      CESS: invoice.CESS
    };
  })));

  var hsnWS = __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.json_to_sheet(hsnData, { skipHeader: true });
  __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.book_append_sheet(wb, hsnWS, 'HSN');

  //Document_Summary

  var docHeader = {
    n_doc: 'NATURE OF DOCUMENT',
    s_no: 'SERIAL NUMBER',
    from_sr: 'FROM SERIAL NUMBER',
    to_sr: 'TO SERIAL NUMBER',
    totalNo: 'TOTAL NUMBER',
    cancelled: 'CANCELLED',
    netIssued: 'NET ISSUED'

  };

  var docData = [docHeader].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(Document_Summary.invoices.map(function (invoice, index) {
    return {
      n_doc: '-',
      s_no: index + 1,
      from_sr: '-',
      to_sr: '-',
      totalNo: '-',
      cancelled: '-',
      netIssued: '-'
    };
  })));

  var docWS = __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.json_to_sheet(docData, { skipHeader: true });
  __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.book_append_sheet(wb, docWS, 'DOC_ISSUED');

  return wb;
};
var buyerStatementExcel = function buyerStatementExcel(_ref3) {
  var selectedFirm = _ref3.selectedFirm,
      invoices = _ref3.invoices;

  var wb = __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.book_new(); // make Workbook of Excel

  var firmHeader = {
    name: 'Name',
    address: 'Address',
    mobileNumber: 'Mobile',
    panNumber: 'PAN Number',
    email: 'Email',
    GST_number: 'GST Number',
    website: 'Website'
  };

  var firmData = [firmHeader, {
    name: selectedFirm.name,
    address: selectedFirm.address,
    mobileNumber: selectedFirm.mobileNumber,
    panNumber: selectedFirm.panNumber,
    email: selectedFirm.email,
    GST_number: selectedFirm.GST_number,
    website: selectedFirm.website
  }];
  var firmWS = __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.json_to_sheet(firmData, { skipHeader: true });
  __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.book_append_sheet(wb, firmWS, 'Info');

  function getVocherType(invoice) {
    if (invoice.return) {
      if (invoice.isBuyer) {
        return "Credit Note";
      } else {
        return "Debit Note";
      }
    } else if (invoice.transactionType != "Debit" && invoice["type"] === "Advance" || invoice["type"] === "Opening Balance" || invoice["type"] === "Loan" || invoice["type"] === "Security") {
      return invoice["type"];
    } else if (invoice.isBuyer && invoice.transactionType === "Debit") {
      return "Sale";
    } else if (invoice.isBuyer && invoice.transactionType === "Credit" || !invoice.isBuyer && invoice.transactionType === "Credit") {
      return "Payment";
    } else if (!invoice.isBuyer && invoice.transactionType === "Debit") {
      return "Purchase";
    }
  }

  var invoiceHeader = {
    date: 'Date',
    invoiceKey: 'Invoice Key',
    invoiceId: 'Invoice ID',
    debit: 'Debit',
    credit: 'Credit',
    runningBal: 'Running Balance',
    paymentType: 'Payment Type',
    voucherType: 'Voucher Type'
  };

  var invoiceData = [invoiceHeader];
  invoices.map(function (invoice) {
    invoiceData.push({
      date: new Date(invoice.date).toLocaleDateString('en-GB'),
      invoiceKey: invoice['.key'],
      invoiceId: invoice['invoiceId'],
      debit: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(invoice['debit']).toFixed(2),
      credit: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(invoice['credit']).toFixed(2),
      runningBal: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(invoice['RunningBal']).toFixed(2),
      paymentType: invoice['paymentType'],
      voucherType: getVocherType(invoice)
    });
  });

  var invoiceWS = __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.json_to_sheet(invoiceData, { skipHeader: true });
  __WEBPACK_IMPORTED_MODULE_2_xlsx___default.a.utils.book_append_sheet(wb, invoiceWS, 'Invoices');

  return wb;
};

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ASSET_TYPE_WITH_DEPRICIATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ASSET_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ASSET_PURCHASE_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PAYMENT_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getFinancialYear; });
var ASSET_TYPE_WITH_DEPRICIATION = [{ text: 'Building', value: 'building', depriciation: false }, { text: 'Computer & Parts', value: 'computerParts', depriciation: [5, 10, 15, 20, 25, 30, 40] }, { text: 'Electrical Equipments', value: 'electricalEquipments', depriciation: [5, 10, 15, 20, 25, 30, 40] }, { text: 'Furniture & Fittings', value: 'furniture', depriciation: [5, 10, 15, 20, 25, 30, 40] }, { text: 'Heavy Machinery and Plant', value: 'heavyMachinery', depriciation: [15, 20, 30, 40, 45, 60] }, { text: 'Investments', value: 'investments', depriciation: false }, { text: 'Intangible Assets', value: 'intangibleAssets', depriciation: 25 }, { text: 'Land', value: 'land', depriciation: false }, { text: 'Plant and Machinery', value: 'plantMachinery', depriciation: [15, 20, 30, 40, 45, 60] }, { text: 'Vehicle', value: 'vehicle', depriciation: [5, 10, 15, 20, 25, 30, 40] }];

var ASSET_CATEGORY = [{ text: 'Business', value: 'business' }, { text: 'Personal', value: 'personal' }, { text: 'Business & Personal', value: 'b&p' }];

var ASSET_PURCHASE_TYPE = [{ text: 'Downpayment', value: 'downpayment' }, { text: 'Partial', value: 'partial' }, { text: 'Installment', value: 'installment' }];

var PAYMENT_OPTIONS = [{ text: 'Cash', value: 'Cash' }, { text: 'Bank Account', value: 'Bank Account' }, { text: 'Cash & Bank Account', value: 'CashAndBank Account' }];

var getFinancialYear = function getFinancialYear() {
    //get current date
    var today = new Date();

    //get current month
    var curMonth = today.getMonth();

    var fiscalYr = "";
    if (curMonth > 3) {
        //
        var nextYr1 = (today.getFullYear() + 1).toString();
        fiscalYr = today.getFullYear().toString() + "-" + nextYr1;
    } else {
        var nextYr2 = today.getFullYear().toString();
        fiscalYr = (today.getFullYear() - 1).toString() + "-" + nextYr2;
    }
    return fiscalYr;
};

/***/ }),
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/horizontalLogo.d7cd283.png";

/***/ }),
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BuyerInfo_vue__ = __webpack_require__(406);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0fa0af8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuyerInfo_vue__ = __webpack_require__(1237);
function injectStyle (ssrContext) {
  __webpack_require__(1236)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BuyerInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0fa0af8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuyerInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return convertToPDFTransactionReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return convertToPDFTransactionReportFirm; });

// playground requires you to assign document definition to a variable called dd
var convertToPDFTransactionReport = function convertToPDFTransactionReport(_ref) {
	var invoiceData = _ref.invoiceData,
	    firm = _ref.firm,
	    date = _ref.date;

	var dd = {
		content: [{ text: 'DAY BOOK\n', style: "topHeader1" }, {
			table: {
				widths: ['*'],
				body: [[{ text: 'DAYBOOK', style: "topHeader2" }], [{
					text: [{ text: 'Firm Name:-    ', bold: true }, { text: 'Google\n' }, { text: 'Date:-               ', bold: true }, { text: '12/12/12\n' }]
				}]]
			}
		}, {
			table: {
				body: [[{ text: 'STATEMENTS', style: "topHeader", colSpan: 8, decoration: 'underline' }, { text: '', style: "header" }, { text: '', style: "header" }, { text: '', style: "header" }, { text: '', style: "header" }, { text: '', style: "header" }, { text: '', style: "header" }, { text: '', style: "header" }], [{ text: 'Firm', style: "gstHeader" }, { text: 'Particulars', style: "gstHeader" }, { text: 'Debit', style: "gstHeader" }, { text: 'Credit', style: "gstHeader" }, { text: 'Voucher Type', style: "gstHeader" }, { text: 'Payment Type', style: "gstHeader" }, { text: 'Status', style: "gstHeader" }, { text: 'Remark', style: "gstHeader" }]]
			}
		}],
		styles: {
			header: {
				fontSize: 13,
				bold: true,
				alignment: 'center'
			},
			gstHeader: {
				fontSize: 14,
				bold: true,
				alignment: 'center'
			},
			data: {
				fontSize: 9,
				alignment: 'center'
			},
			topHeader: {
				color: 'white',
				fontSize: 12,
				alignment: 'center',
				bold: true,
				fillColor: '#15155d'
			},
			topHeader1: {
				color: 'white',
				fontSize: 1,
				alignment: 'center',
				bold: true,
				fillColor: '#15155d'
			},
			topHeader2: {
				color: 'white',
				fontSize: 14,
				alignment: 'center',
				bold: true,
				fillColor: '#15155d'
			},
			gstData1: {
				fontSize: 9,
				alignment: 'center',
				color: '#15155d',
				bold: true
			},
			gstData2: {
				fontSize: 9,
				alignment: 'center',
				color: '#B71C1C',
				bold: true
			},
			gstData3: {
				fontSize: 9,
				alignment: 'center',
				color: '#43A047',
				bold: true
			},
			bigger: {
				fontSize: 18,
				bold: true,
				alignment: 'center',
				decoration: 'underline',
				decorationStyle: 'solid',
				decorationColor: 'black'
			}
		}
	};

	if (firm) {
		dd.content[1].table.body[1][0].text[1].text = firm + "\n";
	}
	if (date) {
		dd.content[1].table.body[1][0].text[3].text = date;
	}

	invoiceData.map(function (invoice) {
		dd.content[2].table.body.push([{ text: invoice[0], style: "data" }, { text: invoice[1], style: "data" }, { text: invoice[2], style: "gstData3" }, { text: invoice[3], style: "gstData2" }, { text: invoice[4], style: "data" }, { text: invoice[5], style: "data" }, { text: invoice[6], style: "data" }, { text: invoice[7], style: "data" }]);
	});
	return dd;
};

// playground requires you to assign document definition to a variable called dd
var convertToPDFTransactionReportFirm = function convertToPDFTransactionReportFirm(_ref2) {
	var invoiceData = _ref2.invoiceData,
	    firm = _ref2.firm,
	    dateFrom = _ref2.dateFrom,
	    dateTo = _ref2.dateTo,
	    bank = _ref2.bank;

	var dd = {
		content: [{
			table: {
				widths: ['50%', '*'],
				body: [[{
					image: '',
					width: 160,
					height: 35
				}, {
					text: [{
						text: [{ text: 'Firm Name:    ', bold: true }, { text: 'Google\n' }, { text: 'From Date:     ', bold: true }, { text: '12/12/12\n' }, { text: 'To Date:          ', bold: true }, { text: '12/12/12\n' }]
					}]

				}]]
			},

			style: "topTab"
		}, {
			table: {
				body: [[{ text: 'STATEMENTS', style: "topHeader", colSpan: 8, decoration: 'underline' }, { text: '', style: "header" }, { text: '', style: "header" }, { text: '', style: "header" }, { text: '', style: "header" }, { text: '', style: "header" }, { text: '', style: "header" }, { text: '', style: "header" }], [{ text: 'Date', style: "gstHeader" }, { text: 'Particulars', style: "gstHeader" }, { text: 'Debit', style: "gstHeader" }, { text: 'Credit', style: "gstHeader" }, { text: 'Voucher Type', style: "gstHeader" }, { text: 'Payment Type', style: "gstHeader" }, { text: 'Status', style: "gstHeader" }, { text: 'Remark', style: "gstHeader" }]]
			}
		}],
		styles: {
			header: {
				fontSize: 13,
				bold: true,
				alignment: 'center'
			},
			gstHeader: {
				fontSize: 14,
				bold: true,
				alignment: 'center'
			},
			data: {
				fontSize: 9,
				alignment: 'center'
			},
			topHeader: {
				color: 'white',
				fontSize: 12,
				alignment: 'center',
				bold: true,
				fillColor: '#15155d'
			},
			gstData1: {
				fontSize: 9,
				alignment: 'center',
				color: '#15155d',
				bold: true
			},
			gstData2: {
				fontSize: 9,
				alignment: 'center',
				color: '#B71C1C',
				bold: true
			},
			gstData3: {
				fontSize: 9,
				alignment: 'center',
				color: '#43A047',
				bold: true
			}
		}
	};

	if (firm) {
		dd.content[0].table.body[0][1].text[0].text[1].text = firm.toUpperCase() + "\n";
	}

	if (bank) {
		dd.content[0].table.body[0][1].text[0].text[0].text = "Bank Name:   ";
		dd.content[0].table.body[0][1].text[0].text[1].text = bank.toUpperCase() + "\n";
	}

	if (dateFrom) {
		dd.content[0].table.body[0][1].text[0].text[3].text = dateFrom + "\n";
	}
	if (dateTo) {
		dd.content[0].table.body[0][1].text[0].text[5].text = dateTo;
	}

	invoiceData.map(function (invoice) {
		dd.content[1].table.body.push([{ text: invoice[0], style: "data" }, { text: invoice[1], style: "data" }, { text: invoice[2], style: "gstData3" }, { text: invoice[3], style: "gstData2" }, { text: invoice[4], style: "data" }, { text: invoice[5], style: "data" }, { text: invoice[6], style: "data" }, { text: invoice[7], style: "data" }]);
	});
	var imgToExport = document.getElementById('pdfimgToExportHorizontal');
	var canvas = document.createElement('canvas');
	canvas.width = imgToExport.width;
	canvas.height = imgToExport.height;
	canvas.getContext('2d').drawImage(imgToExport, 0, 0);
	var base64 = canvas.toDataURL('image/png');
	dd.content[0].table.body[0][0].image = base64;
	return dd;
};

/***/ }),
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 171 */,
/* 172 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(855);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

function loadLocaleMessages() {
  var locales = __webpack_require__(856);
  var messages = {};
  locales.keys().forEach(function (key) {
    var matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      var locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: Object({"NODE_ENV":"production"}).VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: Object({"NODE_ENV":"production"}).VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages()
}));

/***/ }),
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */
/***/ (function(module, exports) {

module.exports = [["0","\u0000",127,"€"],["8140","丂丄丅丆丏丒丗丟丠両丣並丩丮丯丱丳丵丷丼乀乁乂乄乆乊乑乕乗乚乛乢乣乤乥乧乨乪",5,"乲乴",9,"乿",6,"亇亊"],["8180","亐亖亗亙亜亝亞亣亪亯亰亱亴亶亷亸亹亼亽亾仈仌仏仐仒仚仛仜仠仢仦仧仩仭仮仯仱仴仸仹仺仼仾伀伂",6,"伋伌伒",4,"伜伝伡伣伨伩伬伭伮伱伳伵伷伹伻伾",4,"佄佅佇",5,"佒佔佖佡佢佦佨佪佫佭佮佱佲併佷佸佹佺佽侀侁侂侅來侇侊侌侎侐侒侓侕侖侘侙侚侜侞侟価侢"],["8240","侤侫侭侰",4,"侶",8,"俀俁係俆俇俈俉俋俌俍俒",4,"俙俛俠俢俤俥俧俫俬俰俲俴俵俶俷俹俻俼俽俿",11],["8280","個倎倐們倓倕倖倗倛倝倞倠倢倣値倧倫倯",10,"倻倽倿偀偁偂偄偅偆偉偊偋偍偐",4,"偖偗偘偙偛偝",7,"偦",5,"偭",8,"偸偹偺偼偽傁傂傃傄傆傇傉傊傋傌傎",20,"傤傦傪傫傭",4,"傳",6,"傼"],["8340","傽",17,"僐",5,"僗僘僙僛",10,"僨僩僪僫僯僰僱僲僴僶",4,"僼",9,"儈"],["8380","儉儊儌",5,"儓",13,"儢",28,"兂兇兊兌兎兏児兒兓兗兘兙兛兝",4,"兣兤兦內兩兪兯兲兺兾兿冃冄円冇冊冋冎冏冐冑冓冔冘冚冝冞冟冡冣冦",4,"冭冮冴冸冹冺冾冿凁凂凃凅凈凊凍凎凐凒",5],["8440","凘凙凚凜凞凟凢凣凥",5,"凬凮凱凲凴凷凾刄刅刉刋刌刏刐刓刔刕刜刞刟刡刢刣別刦刧刪刬刯刱刲刴刵刼刾剄",5,"剋剎剏剒剓剕剗剘"],["8480","剙剚剛剝剟剠剢剣剤剦剨剫剬剭剮剰剱剳",9,"剾劀劃",4,"劉",6,"劑劒劔",6,"劜劤劥劦劧劮劯劰労",9,"勀勁勂勄勅勆勈勊勌勍勎勏勑勓勔動勗務",5,"勠勡勢勣勥",10,"勱",7,"勻勼勽匁匂匃匄匇匉匊匋匌匎"],["8540","匑匒匓匔匘匛匜匞匟匢匤匥匧匨匩匫匬匭匯",9,"匼匽區卂卄卆卋卌卍卐協単卙卛卝卥卨卪卬卭卲卶卹卻卼卽卾厀厁厃厇厈厊厎厏"],["8580","厐",4,"厖厗厙厛厜厞厠厡厤厧厪厫厬厭厯",6,"厷厸厹厺厼厽厾叀參",4,"収叏叐叒叓叕叚叜叝叞叡叢叧叴叺叾叿吀吂吅吇吋吔吘吙吚吜吢吤吥吪吰吳吶吷吺吽吿呁呂呄呅呇呉呌呍呎呏呑呚呝",4,"呣呥呧呩",7,"呴呹呺呾呿咁咃咅咇咈咉咊咍咑咓咗咘咜咞咟咠咡"],["8640","咢咥咮咰咲咵咶咷咹咺咼咾哃哅哊哋哖哘哛哠",4,"哫哬哯哰哱哴",5,"哻哾唀唂唃唄唅唈唊",4,"唒唓唕",5,"唜唝唞唟唡唥唦"],["8680","唨唩唫唭唲唴唵唶唸唹唺唻唽啀啂啅啇啈啋",4,"啑啒啓啔啗",4,"啝啞啟啠啢啣啨啩啫啯",5,"啹啺啽啿喅喆喌喍喎喐喒喓喕喖喗喚喛喞喠",6,"喨",8,"喲喴営喸喺喼喿",4,"嗆嗇嗈嗊嗋嗎嗏嗐嗕嗗",4,"嗞嗠嗢嗧嗩嗭嗮嗰嗱嗴嗶嗸",4,"嗿嘂嘃嘄嘅"],["8740","嘆嘇嘊嘋嘍嘐",7,"嘙嘚嘜嘝嘠嘡嘢嘥嘦嘨嘩嘪嘫嘮嘯嘰嘳嘵嘷嘸嘺嘼嘽嘾噀",11,"噏",4,"噕噖噚噛噝",4],["8780","噣噥噦噧噭噮噯噰噲噳噴噵噷噸噹噺噽",7,"嚇",6,"嚐嚑嚒嚔",14,"嚤",10,"嚰",6,"嚸嚹嚺嚻嚽",12,"囋",8,"囕囖囘囙囜団囥",5,"囬囮囯囲図囶囷囸囻囼圀圁圂圅圇國",6],["8840","園",9,"圝圞圠圡圢圤圥圦圧圫圱圲圴",4,"圼圽圿坁坃坄坅坆坈坉坋坒",4,"坘坙坢坣坥坧坬坮坰坱坲坴坵坸坹坺坽坾坿垀"],["8880","垁垇垈垉垊垍",4,"垔",6,"垜垝垞垟垥垨垪垬垯垰垱垳垵垶垷垹",8,"埄",6,"埌埍埐埑埓埖埗埛埜埞埡埢埣埥",7,"埮埰埱埲埳埵埶執埻埼埾埿堁堃堄堅堈堉堊堌堎堏堐堒堓堔堖堗堘堚堛堜堝堟堢堣堥",4,"堫",4,"報堲堳場堶",7],["8940","堾",5,"塅",6,"塎塏塐塒塓塕塖塗塙",4,"塟",5,"塦",4,"塭",16,"塿墂墄墆墇墈墊墋墌"],["8980","墍",4,"墔",4,"墛墜墝墠",7,"墪",17,"墽墾墿壀壂壃壄壆",10,"壒壓壔壖",13,"壥",5,"壭壯壱売壴壵壷壸壺",7,"夃夅夆夈",4,"夎夐夑夒夓夗夘夛夝夞夠夡夢夣夦夨夬夰夲夳夵夶夻"],["8a40","夽夾夿奀奃奅奆奊奌奍奐奒奓奙奛",4,"奡奣奤奦",12,"奵奷奺奻奼奾奿妀妅妉妋妌妎妏妐妑妔妕妘妚妛妜妝妟妠妡妢妦"],["8a80","妧妬妭妰妱妳",5,"妺妼妽妿",6,"姇姈姉姌姍姎姏姕姖姙姛姞",4,"姤姦姧姩姪姫姭",11,"姺姼姽姾娀娂娊娋娍娎娏娐娒娔娕娖娗娙娚娛娝娞娡娢娤娦娧娨娪",6,"娳娵娷",4,"娽娾娿婁",4,"婇婈婋",9,"婖婗婘婙婛",5],["8b40","婡婣婤婥婦婨婩婫",8,"婸婹婻婼婽婾媀",17,"媓",6,"媜",13,"媫媬"],["8b80","媭",4,"媴媶媷媹",4,"媿嫀嫃",5,"嫊嫋嫍",4,"嫓嫕嫗嫙嫚嫛嫝嫞嫟嫢嫤嫥嫧嫨嫪嫬",4,"嫲",22,"嬊",11,"嬘",25,"嬳嬵嬶嬸",7,"孁",6],["8c40","孈",7,"孒孖孞孠孡孧孨孫孭孮孯孲孴孶孷學孹孻孼孾孿宂宆宊宍宎宐宑宒宔宖実宧宨宩宬宭宮宯宱宲宷宺宻宼寀寁寃寈寉寊寋寍寎寏"],["8c80","寑寔",8,"寠寢寣實寧審",4,"寯寱",6,"寽対尀専尃尅將專尋尌對導尐尒尓尗尙尛尞尟尠尡尣尦尨尩尪尫尭尮尯尰尲尳尵尶尷屃屄屆屇屌屍屒屓屔屖屗屘屚屛屜屝屟屢層屧",6,"屰屲",6,"屻屼屽屾岀岃",4,"岉岊岋岎岏岒岓岕岝",4,"岤",4],["8d40","岪岮岯岰岲岴岶岹岺岻岼岾峀峂峃峅",5,"峌",5,"峓",5,"峚",6,"峢峣峧峩峫峬峮峯峱",9,"峼",4],["8d80","崁崄崅崈",5,"崏",4,"崕崗崘崙崚崜崝崟",4,"崥崨崪崫崬崯",4,"崵",7,"崿",7,"嵈嵉嵍",10,"嵙嵚嵜嵞",10,"嵪嵭嵮嵰嵱嵲嵳嵵",12,"嶃",21,"嶚嶛嶜嶞嶟嶠"],["8e40","嶡",21,"嶸",12,"巆",6,"巎",12,"巜巟巠巣巤巪巬巭"],["8e80","巰巵巶巸",4,"巿帀帄帇帉帊帋帍帎帒帓帗帞",7,"帨",4,"帯帰帲",4,"帹帺帾帿幀幁幃幆",5,"幍",6,"幖",4,"幜幝幟幠幣",14,"幵幷幹幾庁庂広庅庈庉庌庍庎庒庘庛庝庡庢庣庤庨",4,"庮",4,"庴庺庻庼庽庿",6],["8f40","廆廇廈廋",5,"廔廕廗廘廙廚廜",11,"廩廫",8,"廵廸廹廻廼廽弅弆弇弉弌弍弎弐弒弔弖弙弚弜弝弞弡弢弣弤"],["8f80","弨弫弬弮弰弲",6,"弻弽弾弿彁",14,"彑彔彙彚彛彜彞彟彠彣彥彧彨彫彮彯彲彴彵彶彸彺彽彾彿徃徆徍徎徏徑従徔徖徚徛徝從徟徠徢",5,"復徫徬徯",5,"徶徸徹徺徻徾",4,"忇忈忊忋忎忓忔忕忚忛応忞忟忢忣忥忦忨忩忬忯忰忲忳忴忶忷忹忺忼怇"],["9040","怈怉怋怌怐怑怓怗怘怚怞怟怢怣怤怬怭怮怰",4,"怶",4,"怽怾恀恄",6,"恌恎恏恑恓恔恖恗恘恛恜恞恟恠恡恥恦恮恱恲恴恵恷恾悀"],["9080","悁悂悅悆悇悈悊悋悎悏悐悑悓悕悗悘悙悜悞悡悢悤悥悧悩悪悮悰悳悵悶悷悹悺悽",7,"惇惈惉惌",4,"惒惓惔惖惗惙惛惞惡",4,"惪惱惲惵惷惸惻",4,"愂愃愄愅愇愊愋愌愐",4,"愖愗愘愙愛愜愝愞愡愢愥愨愩愪愬",18,"慀",6],["9140","慇慉態慍慏慐慒慓慔慖",6,"慞慟慠慡慣慤慥慦慩",6,"慱慲慳慴慶慸",18,"憌憍憏",4,"憕"],["9180","憖",6,"憞",8,"憪憫憭",9,"憸",5,"憿懀懁懃",4,"應懌",4,"懓懕",16,"懧",13,"懶",8,"戀",5,"戇戉戓戔戙戜戝戞戠戣戦戧戨戩戫戭戯戰戱戲戵戶戸",4,"扂扄扅扆扊"],["9240","扏扐払扖扗扙扚扜",6,"扤扥扨扱扲扴扵扷扸扺扻扽抁抂抃抅抆抇抈抋",5,"抔抙抜抝択抣抦抧抩抪抭抮抯抰抲抳抴抶抷抸抺抾拀拁"],["9280","拃拋拏拑拕拝拞拠拡拤拪拫拰拲拵拸拹拺拻挀挃挄挅挆挊挋挌挍挏挐挒挓挔挕挗挘挙挜挦挧挩挬挭挮挰挱挳",5,"挻挼挾挿捀捁捄捇捈捊捑捒捓捔捖",7,"捠捤捥捦捨捪捫捬捯捰捲捳捴捵捸捹捼捽捾捿掁掃掄掅掆掋掍掑掓掔掕掗掙",6,"採掤掦掫掯掱掲掵掶掹掻掽掿揀"],["9340","揁揂揃揅揇揈揊揋揌揑揓揔揕揗",6,"揟揢揤",4,"揫揬揮揯揰揱揳揵揷揹揺揻揼揾搃搄搆",4,"損搎搑搒搕",5,"搝搟搢搣搤"],["9380","搥搧搨搩搫搮",5,"搵",4,"搻搼搾摀摂摃摉摋",6,"摓摕摖摗摙",4,"摟",7,"摨摪摫摬摮",9,"摻",6,"撃撆撈",8,"撓撔撗撘撚撛撜撝撟",4,"撥撦撧撨撪撫撯撱撲撳撴撶撹撻撽撾撿擁擃擄擆",6,"擏擑擓擔擕擖擙據"],["9440","擛擜擝擟擠擡擣擥擧",24,"攁",7,"攊",7,"攓",4,"攙",8],["9480","攢攣攤攦",4,"攬攭攰攱攲攳攷攺攼攽敀",4,"敆敇敊敋敍敎敐敒敓敔敗敘敚敜敟敠敡敤敥敧敨敩敪敭敮敯敱敳敵敶數",14,"斈斉斊斍斎斏斒斔斕斖斘斚斝斞斠斢斣斦斨斪斬斮斱",7,"斺斻斾斿旀旂旇旈旉旊旍旐旑旓旔旕旘",7,"旡旣旤旪旫"],["9540","旲旳旴旵旸旹旻",4,"昁昄昅昇昈昉昋昍昐昑昒昖昗昘昚昛昜昞昡昢昣昤昦昩昪昫昬昮昰昲昳昷",4,"昽昿晀時晄",6,"晍晎晐晑晘"],["9580","晙晛晜晝晞晠晢晣晥晧晩",4,"晱晲晳晵晸晹晻晼晽晿暀暁暃暅暆暈暉暊暋暍暎暏暐暒暓暔暕暘",4,"暞",8,"暩",4,"暯",4,"暵暶暷暸暺暻暼暽暿",25,"曚曞",7,"曧曨曪",5,"曱曵曶書曺曻曽朁朂會"],["9640","朄朅朆朇朌朎朏朑朒朓朖朘朙朚朜朞朠",5,"朧朩朮朰朲朳朶朷朸朹朻朼朾朿杁杄杅杇杊杋杍杒杔杕杗",4,"杝杢杣杤杦杧杫杬杮東杴杶"],["9680","杸杹杺杻杽枀枂枃枅枆枈枊枌枍枎枏枑枒枓枔枖枙枛枟枠枡枤枦枩枬枮枱枲枴枹",7,"柂柅",9,"柕柖柗柛柟柡柣柤柦柧柨柪柫柭柮柲柵",7,"柾栁栂栃栄栆栍栐栒栔栕栘",4,"栞栟栠栢",6,"栫",6,"栴栵栶栺栻栿桇桋桍桏桒桖",5],["9740","桜桝桞桟桪桬",7,"桵桸",8,"梂梄梇",7,"梐梑梒梔梕梖梘",9,"梣梤梥梩梪梫梬梮梱梲梴梶梷梸"],["9780","梹",6,"棁棃",5,"棊棌棎棏棐棑棓棔棖棗棙棛",4,"棡棢棤",9,"棯棲棳棴棶棷棸棻棽棾棿椀椂椃椄椆",4,"椌椏椑椓",11,"椡椢椣椥",7,"椮椯椱椲椳椵椶椷椸椺椻椼椾楀楁楃",16,"楕楖楘楙楛楜楟"],["9840","楡楢楤楥楧楨楩楪楬業楯楰楲",4,"楺楻楽楾楿榁榃榅榊榋榌榎",5,"榖榗榙榚榝",9,"榩榪榬榮榯榰榲榳榵榶榸榹榺榼榽"],["9880","榾榿槀槂",7,"構槍槏槑槒槓槕",5,"槜槝槞槡",11,"槮槯槰槱槳",9,"槾樀",9,"樋",11,"標",5,"樠樢",5,"権樫樬樭樮樰樲樳樴樶",6,"樿",4,"橅橆橈",7,"橑",6,"橚"],["9940","橜",4,"橢橣橤橦",10,"橲",6,"橺橻橽橾橿檁檂檃檅",8,"檏檒",4,"檘",7,"檡",5],["9980","檧檨檪檭",114,"欥欦欨",6],["9a40","欯欰欱欳欴欵欶欸欻欼欽欿歀歁歂歄歅歈歊歋歍",11,"歚",7,"歨歩歫",13,"歺歽歾歿殀殅殈"],["9a80","殌殎殏殐殑殔殕殗殘殙殜",4,"殢",7,"殫",7,"殶殸",6,"毀毃毄毆",4,"毌毎毐毑毘毚毜",4,"毢",7,"毬毭毮毰毱毲毴毶毷毸毺毻毼毾",6,"氈",4,"氎氒気氜氝氞氠氣氥氫氬氭氱氳氶氷氹氺氻氼氾氿汃汄汅汈汋",4,"汑汒汓汖汘"],["9b40","汙汚汢汣汥汦汧汫",4,"汱汳汵汷汸決汻汼汿沀沄沇沊沋沍沎沑沒沕沖沗沘沚沜沝沞沠沢沨沬沯沰沴沵沶沷沺泀況泂泃泆泇泈泋泍泎泏泑泒泘"],["9b80","泙泚泜泝泟泤泦泧泩泬泭泲泴泹泿洀洂洃洅洆洈洉洊洍洏洐洑洓洔洕洖洘洜洝洟",5,"洦洨洩洬洭洯洰洴洶洷洸洺洿浀浂浄浉浌浐浕浖浗浘浛浝浟浡浢浤浥浧浨浫浬浭浰浱浲浳浵浶浹浺浻浽",4,"涃涄涆涇涊涋涍涏涐涒涖",4,"涜涢涥涬涭涰涱涳涴涶涷涹",5,"淁淂淃淈淉淊"],["9c40","淍淎淏淐淒淓淔淕淗淚淛淜淟淢淣淥淧淨淩淪淭淯淰淲淴淵淶淸淺淽",7,"渆渇済渉渋渏渒渓渕渘渙減渜渞渟渢渦渧渨渪測渮渰渱渳渵"],["9c80","渶渷渹渻",7,"湅",7,"湏湐湑湒湕湗湙湚湜湝湞湠",10,"湬湭湯",14,"満溁溂溄溇溈溊",4,"溑",6,"溙溚溛溝溞溠溡溣溤溦溨溩溫溬溭溮溰溳溵溸溹溼溾溿滀滃滄滅滆滈滉滊滌滍滎滐滒滖滘滙滛滜滝滣滧滪",5],["9d40","滰滱滲滳滵滶滷滸滺",7,"漃漄漅漇漈漊",4,"漐漑漒漖",9,"漡漢漣漥漦漧漨漬漮漰漲漴漵漷",6,"漿潀潁潂"],["9d80","潃潄潅潈潉潊潌潎",9,"潙潚潛潝潟潠潡潣潤潥潧",5,"潯潰潱潳潵潶潷潹潻潽",6,"澅澆澇澊澋澏",12,"澝澞澟澠澢",4,"澨",10,"澴澵澷澸澺",5,"濁濃",5,"濊",6,"濓",10,"濟濢濣濤濥"],["9e40","濦",7,"濰",32,"瀒",7,"瀜",6,"瀤",6],["9e80","瀫",9,"瀶瀷瀸瀺",17,"灍灎灐",13,"灟",11,"灮灱灲灳灴灷灹灺灻災炁炂炃炄炆炇炈炋炌炍炏炐炑炓炗炘炚炛炞",12,"炰炲炴炵炶為炾炿烄烅烆烇烉烋",12,"烚"],["9f40","烜烝烞烠烡烢烣烥烪烮烰",6,"烸烺烻烼烾",10,"焋",4,"焑焒焔焗焛",10,"焧",7,"焲焳焴"],["9f80","焵焷",13,"煆煇煈煉煋煍煏",12,"煝煟",4,"煥煩",4,"煯煰煱煴煵煶煷煹煻煼煾",5,"熅",4,"熋熌熍熎熐熑熒熓熕熖熗熚",4,"熡",6,"熩熪熫熭",5,"熴熶熷熸熺",8,"燄",9,"燏",4],["a040","燖",9,"燡燢燣燤燦燨",5,"燯",9,"燺",11,"爇",19],["a080","爛爜爞",9,"爩爫爭爮爯爲爳爴爺爼爾牀",6,"牉牊牋牎牏牐牑牓牔牕牗牘牚牜牞牠牣牤牥牨牪牫牬牭牰牱牳牴牶牷牸牻牼牽犂犃犅",4,"犌犎犐犑犓",11,"犠",11,"犮犱犲犳犵犺",6,"狅狆狇狉狊狋狌狏狑狓狔狕狖狘狚狛"],["a1a1","　、。·ˉˇ¨〃々—～‖…‘’“”〔〕〈",7,"〖〗【】±×÷∶∧∨∑∏∪∩∈∷√⊥∥∠⌒⊙∫∮≡≌≈∽∝≠≮≯≤≥∞∵∴♂♀°′″℃＄¤￠￡‰§№☆★○●◎◇◆□■△▲※→←↑↓〓"],["a2a1","ⅰ",9],["a2b1","⒈",19,"⑴",19,"①",9],["a2e5","㈠",9],["a2f1","Ⅰ",11],["a3a1","！＂＃￥％",88,"￣"],["a4a1","ぁ",82],["a5a1","ァ",85],["a6a1","Α",16,"Σ",6],["a6c1","α",16,"σ",6],["a6e0","︵︶︹︺︿﹀︽︾﹁﹂﹃﹄"],["a6ee","︻︼︷︸︱"],["a6f4","︳︴"],["a7a1","А",5,"ЁЖ",25],["a7d1","а",5,"ёж",25],["a840","ˊˋ˙–―‥‵℅℉↖↗↘↙∕∟∣≒≦≧⊿═",35,"▁",6],["a880","█",7,"▓▔▕▼▽◢◣◤◥☉⊕〒〝〞"],["a8a1","āáǎàēéěèīíǐìōóǒòūúǔùǖǘǚǜüêɑ"],["a8bd","ńň"],["a8c0","ɡ"],["a8c5","ㄅ",36],["a940","〡",8,"㊣㎎㎏㎜㎝㎞㎡㏄㏎㏑㏒㏕︰￢￤"],["a959","℡㈱"],["a95c","‐"],["a960","ー゛゜ヽヾ〆ゝゞ﹉",9,"﹔﹕﹖﹗﹙",8],["a980","﹢",4,"﹨﹩﹪﹫"],["a996","〇"],["a9a4","─",75],["aa40","狜狝狟狢",5,"狪狫狵狶狹狽狾狿猀猂猄",5,"猋猌猍猏猐猑猒猔猘猙猚猟猠猣猤猦猧猨猭猯猰猲猳猵猶猺猻猼猽獀",8],["aa80","獉獊獋獌獎獏獑獓獔獕獖獘",7,"獡",10,"獮獰獱"],["ab40","獲",11,"獿",4,"玅玆玈玊玌玍玏玐玒玓玔玕玗玘玙玚玜玝玞玠玡玣",5,"玪玬玭玱玴玵玶玸玹玼玽玾玿珁珃",4],["ab80","珋珌珎珒",6,"珚珛珜珝珟珡珢珣珤珦珨珪珫珬珮珯珰珱珳",4],["ac40","珸",10,"琄琇琈琋琌琍琎琑",8,"琜",5,"琣琤琧琩琫琭琯琱琲琷",4,"琽琾琿瑀瑂",11],["ac80","瑎",6,"瑖瑘瑝瑠",12,"瑮瑯瑱",4,"瑸瑹瑺"],["ad40","瑻瑼瑽瑿璂璄璅璆璈璉璊璌璍璏璑",10,"璝璟",7,"璪",15,"璻",12],["ad80","瓈",9,"瓓",8,"瓝瓟瓡瓥瓧",6,"瓰瓱瓲"],["ae40","瓳瓵瓸",6,"甀甁甂甃甅",7,"甎甐甒甔甕甖甗甛甝甞甠",4,"甦甧甪甮甴甶甹甼甽甿畁畂畃畄畆畇畉畊畍畐畑畒畓畕畖畗畘"],["ae80","畝",7,"畧畨畩畫",6,"畳畵當畷畺",4,"疀疁疂疄疅疇"],["af40","疈疉疊疌疍疎疐疓疕疘疛疜疞疢疦",4,"疭疶疷疺疻疿痀痁痆痋痌痎痏痐痑痓痗痙痚痜痝痟痠痡痥痩痬痭痮痯痲痳痵痶痷痸痺痻痽痾瘂瘄瘆瘇"],["af80","瘈瘉瘋瘍瘎瘏瘑瘒瘓瘔瘖瘚瘜瘝瘞瘡瘣瘧瘨瘬瘮瘯瘱瘲瘶瘷瘹瘺瘻瘽癁療癄"],["b040","癅",6,"癎",5,"癕癗",4,"癝癟癠癡癢癤",6,"癬癭癮癰",7,"癹発發癿皀皁皃皅皉皊皌皍皏皐皒皔皕皗皘皚皛"],["b080","皜",7,"皥",8,"皯皰皳皵",9,"盀盁盃啊阿埃挨哎唉哀皑癌蔼矮艾碍爱隘鞍氨安俺按暗岸胺案肮昂盎凹敖熬翱袄傲奥懊澳芭捌扒叭吧笆八疤巴拔跋靶把耙坝霸罢爸白柏百摆佰败拜稗斑班搬扳般颁板版扮拌伴瓣半办绊邦帮梆榜膀绑棒磅蚌镑傍谤苞胞包褒剥"],["b140","盄盇盉盋盌盓盕盙盚盜盝盞盠",4,"盦",7,"盰盳盵盶盷盺盻盽盿眀眂眃眅眆眊県眎",10,"眛眜眝眞眡眣眤眥眧眪眫"],["b180","眬眮眰",4,"眹眻眽眾眿睂睄睅睆睈",7,"睒",7,"睜薄雹保堡饱宝抱报暴豹鲍爆杯碑悲卑北辈背贝钡倍狈备惫焙被奔苯本笨崩绷甭泵蹦迸逼鼻比鄙笔彼碧蓖蔽毕毙毖币庇痹闭敝弊必辟壁臂避陛鞭边编贬扁便变卞辨辩辫遍标彪膘表鳖憋别瘪彬斌濒滨宾摈兵冰柄丙秉饼炳"],["b240","睝睞睟睠睤睧睩睪睭",11,"睺睻睼瞁瞂瞃瞆",5,"瞏瞐瞓",11,"瞡瞣瞤瞦瞨瞫瞭瞮瞯瞱瞲瞴瞶",4],["b280","瞼瞾矀",12,"矎",8,"矘矙矚矝",4,"矤病并玻菠播拨钵波博勃搏铂箔伯帛舶脖膊渤泊驳捕卜哺补埠不布步簿部怖擦猜裁材才财睬踩采彩菜蔡餐参蚕残惭惨灿苍舱仓沧藏操糙槽曹草厕策侧册测层蹭插叉茬茶查碴搽察岔差诧拆柴豺搀掺蝉馋谗缠铲产阐颤昌猖"],["b340","矦矨矪矯矰矱矲矴矵矷矹矺矻矼砃",5,"砊砋砎砏砐砓砕砙砛砞砠砡砢砤砨砪砫砮砯砱砲砳砵砶砽砿硁硂硃硄硆硈硉硊硋硍硏硑硓硔硘硙硚"],["b380","硛硜硞",11,"硯",7,"硸硹硺硻硽",6,"场尝常长偿肠厂敞畅唱倡超抄钞朝嘲潮巢吵炒车扯撤掣彻澈郴臣辰尘晨忱沉陈趁衬撑称城橙成呈乘程惩澄诚承逞骋秤吃痴持匙池迟弛驰耻齿侈尺赤翅斥炽充冲虫崇宠抽酬畴踌稠愁筹仇绸瞅丑臭初出橱厨躇锄雏滁除楚"],["b440","碄碅碆碈碊碋碏碐碒碔碕碖碙碝碞碠碢碤碦碨",7,"碵碶碷碸確碻碼碽碿磀磂磃磄磆磇磈磌磍磎磏磑磒磓磖磗磘磚",9],["b480","磤磥磦磧磩磪磫磭",4,"磳磵磶磸磹磻",5,"礂礃礄礆",6,"础储矗搐触处揣川穿椽传船喘串疮窗幢床闯创吹炊捶锤垂春椿醇唇淳纯蠢戳绰疵茨磁雌辞慈瓷词此刺赐次聪葱囱匆从丛凑粗醋簇促蹿篡窜摧崔催脆瘁粹淬翠村存寸磋撮搓措挫错搭达答瘩打大呆歹傣戴带殆代贷袋待逮"],["b540","礍",5,"礔",9,"礟",4,"礥",14,"礵",4,"礽礿祂祃祄祅祇祊",8,"祔祕祘祙祡祣"],["b580","祤祦祩祪祫祬祮祰",6,"祹祻",4,"禂禃禆禇禈禉禋禌禍禎禐禑禒怠耽担丹单郸掸胆旦氮但惮淡诞弹蛋当挡党荡档刀捣蹈倒岛祷导到稻悼道盗德得的蹬灯登等瞪凳邓堤低滴迪敌笛狄涤翟嫡抵底地蒂第帝弟递缔颠掂滇碘点典靛垫电佃甸店惦奠淀殿碉叼雕凋刁掉吊钓调跌爹碟蝶迭谍叠"],["b640","禓",6,"禛",11,"禨",10,"禴",4,"禼禿秂秄秅秇秈秊秌秎秏秐秓秔秖秗秙",5,"秠秡秢秥秨秪"],["b680","秬秮秱",6,"秹秺秼秾秿稁稄稅稇稈稉稊稌稏",4,"稕稖稘稙稛稜丁盯叮钉顶鼎锭定订丢东冬董懂动栋侗恫冻洞兜抖斗陡豆逗痘都督毒犊独读堵睹赌杜镀肚度渡妒端短锻段断缎堆兑队对墩吨蹲敦顿囤钝盾遁掇哆多夺垛躲朵跺舵剁惰堕蛾峨鹅俄额讹娥恶厄扼遏鄂饿恩而儿耳尔饵洱二"],["b740","稝稟稡稢稤",14,"稴稵稶稸稺稾穀",5,"穇",9,"穒",4,"穘",16],["b780","穩",6,"穱穲穳穵穻穼穽穾窂窅窇窉窊窋窌窎窏窐窓窔窙窚窛窞窡窢贰发罚筏伐乏阀法珐藩帆番翻樊矾钒繁凡烦反返范贩犯饭泛坊芳方肪房防妨仿访纺放菲非啡飞肥匪诽吠肺废沸费芬酚吩氛分纷坟焚汾粉奋份忿愤粪丰封枫蜂峰锋风疯烽逢冯缝讽奉凤佛否夫敷肤孵扶拂辐幅氟符伏俘服"],["b840","窣窤窧窩窪窫窮",4,"窴",10,"竀",10,"竌",9,"竗竘竚竛竜竝竡竢竤竧",5,"竮竰竱竲竳"],["b880","竴",4,"竻竼竾笀笁笂笅笇笉笌笍笎笐笒笓笖笗笘笚笜笝笟笡笢笣笧笩笭浮涪福袱弗甫抚辅俯釜斧脯腑府腐赴副覆赋复傅付阜父腹负富讣附妇缚咐噶嘎该改概钙盖溉干甘杆柑竿肝赶感秆敢赣冈刚钢缸肛纲岗港杠篙皋高膏羔糕搞镐稿告哥歌搁戈鸽胳疙割革葛格蛤阁隔铬个各给根跟耕更庚羹"],["b940","笯笰笲笴笵笶笷笹笻笽笿",5,"筆筈筊筍筎筓筕筗筙筜筞筟筡筣",10,"筯筰筳筴筶筸筺筼筽筿箁箂箃箄箆",6,"箎箏"],["b980","箑箒箓箖箘箙箚箛箞箟箠箣箤箥箮箯箰箲箳箵箶箷箹",7,"篂篃範埂耿梗工攻功恭龚供躬公宫弓巩汞拱贡共钩勾沟苟狗垢构购够辜菇咕箍估沽孤姑鼓古蛊骨谷股故顾固雇刮瓜剐寡挂褂乖拐怪棺关官冠观管馆罐惯灌贯光广逛瑰规圭硅归龟闺轨鬼诡癸桂柜跪贵刽辊滚棍锅郭国果裹过哈"],["ba40","篅篈築篊篋篍篎篏篐篒篔",4,"篛篜篞篟篠篢篣篤篧篨篩篫篬篭篯篰篲",4,"篸篹篺篻篽篿",7,"簈簉簊簍簎簐",5,"簗簘簙"],["ba80","簚",4,"簠",5,"簨簩簫",12,"簹",5,"籂骸孩海氦亥害骇酣憨邯韩含涵寒函喊罕翰撼捍旱憾悍焊汗汉夯杭航壕嚎豪毫郝好耗号浩呵喝荷菏核禾和何合盒貉阂河涸赫褐鹤贺嘿黑痕很狠恨哼亨横衡恒轰哄烘虹鸿洪宏弘红喉侯猴吼厚候后呼乎忽瑚壶葫胡蝴狐糊湖"],["bb40","籃",9,"籎",36,"籵",5,"籾",9],["bb80","粈粊",6,"粓粔粖粙粚粛粠粡粣粦粧粨粩粫粬粭粯粰粴",4,"粺粻弧虎唬护互沪户花哗华猾滑画划化话槐徊怀淮坏欢环桓还缓换患唤痪豢焕涣宦幻荒慌黄磺蝗簧皇凰惶煌晃幌恍谎灰挥辉徽恢蛔回毁悔慧卉惠晦贿秽会烩汇讳诲绘荤昏婚魂浑混豁活伙火获或惑霍货祸击圾基机畸稽积箕"],["bc40","粿糀糂糃糄糆糉糋糎",6,"糘糚糛糝糞糡",6,"糩",5,"糰",7,"糹糺糼",13,"紋",5],["bc80","紑",14,"紡紣紤紥紦紨紩紪紬紭紮細",6,"肌饥迹激讥鸡姬绩缉吉极棘辑籍集及急疾汲即嫉级挤几脊己蓟技冀季伎祭剂悸济寄寂计记既忌际妓继纪嘉枷夹佳家加荚颊贾甲钾假稼价架驾嫁歼监坚尖笺间煎兼肩艰奸缄茧检柬碱硷拣捡简俭剪减荐槛鉴践贱见键箭件"],["bd40","紷",54,"絯",7],["bd80","絸",32,"健舰剑饯渐溅涧建僵姜将浆江疆蒋桨奖讲匠酱降蕉椒礁焦胶交郊浇骄娇嚼搅铰矫侥脚狡角饺缴绞剿教酵轿较叫窖揭接皆秸街阶截劫节桔杰捷睫竭洁结解姐戒藉芥界借介疥诫届巾筋斤金今津襟紧锦仅谨进靳晋禁近烬浸"],["be40","継",12,"綧",6,"綯",42],["be80","線",32,"尽劲荆兢茎睛晶鲸京惊精粳经井警景颈静境敬镜径痉靖竟竞净炯窘揪究纠玖韭久灸九酒厩救旧臼舅咎就疚鞠拘狙疽居驹菊局咀矩举沮聚拒据巨具距踞锯俱句惧炬剧捐鹃娟倦眷卷绢撅攫抉掘倔爵觉决诀绝均菌钧军君峻"],["bf40","緻",62],["bf80","縺縼",4,"繂",4,"繈",21,"俊竣浚郡骏喀咖卡咯开揩楷凯慨刊堪勘坎砍看康慷糠扛抗亢炕考拷烤靠坷苛柯棵磕颗科壳咳可渴克刻客课肯啃垦恳坑吭空恐孔控抠口扣寇枯哭窟苦酷库裤夸垮挎跨胯块筷侩快宽款匡筐狂框矿眶旷况亏盔岿窥葵奎魁傀"],["c040","繞",35,"纃",23,"纜纝纞"],["c080","纮纴纻纼绖绤绬绹缊缐缞缷缹缻",6,"罃罆",9,"罒罓馈愧溃坤昆捆困括扩廓阔垃拉喇蜡腊辣啦莱来赖蓝婪栏拦篮阑兰澜谰揽览懒缆烂滥琅榔狼廊郎朗浪捞劳牢老佬姥酪烙涝勒乐雷镭蕾磊累儡垒擂肋类泪棱楞冷厘梨犁黎篱狸离漓理李里鲤礼莉荔吏栗丽厉励砾历利傈例俐"],["c140","罖罙罛罜罝罞罠罣",4,"罫罬罭罯罰罳罵罶罷罸罺罻罼罽罿羀羂",7,"羋羍羏",4,"羕",4,"羛羜羠羢羣羥羦羨",6,"羱"],["c180","羳",4,"羺羻羾翀翂翃翄翆翇翈翉翋翍翏",4,"翖翗翙",5,"翢翣痢立粒沥隶力璃哩俩联莲连镰廉怜涟帘敛脸链恋炼练粮凉梁粱良两辆量晾亮谅撩聊僚疗燎寥辽潦了撂镣廖料列裂烈劣猎琳林磷霖临邻鳞淋凛赁吝拎玲菱零龄铃伶羚凌灵陵岭领另令溜琉榴硫馏留刘瘤流柳六龙聋咙笼窿"],["c240","翤翧翨翪翫翬翭翯翲翴",6,"翽翾翿耂耇耈耉耊耎耏耑耓耚耛耝耞耟耡耣耤耫",5,"耲耴耹耺耼耾聀聁聄聅聇聈聉聎聏聐聑聓聕聖聗"],["c280","聙聛",13,"聫",5,"聲",11,"隆垄拢陇楼娄搂篓漏陋芦卢颅庐炉掳卤虏鲁麓碌露路赂鹿潞禄录陆戮驴吕铝侣旅履屡缕虑氯律率滤绿峦挛孪滦卵乱掠略抡轮伦仑沦纶论萝螺罗逻锣箩骡裸落洛骆络妈麻玛码蚂马骂嘛吗埋买麦卖迈脉瞒馒蛮满蔓曼慢漫"],["c340","聾肁肂肅肈肊肍",5,"肔肕肗肙肞肣肦肧肨肬肰肳肵肶肸肹肻胅胇",4,"胏",6,"胘胟胠胢胣胦胮胵胷胹胻胾胿脀脁脃脄脅脇脈脋"],["c380","脌脕脗脙脛脜脝脟",12,"脭脮脰脳脴脵脷脹",4,"脿谩芒茫盲氓忙莽猫茅锚毛矛铆卯茂冒帽貌贸么玫枚梅酶霉煤没眉媒镁每美昧寐妹媚门闷们萌蒙檬盟锰猛梦孟眯醚靡糜迷谜弥米秘觅泌蜜密幂棉眠绵冕免勉娩缅面苗描瞄藐秒渺庙妙蔑灭民抿皿敏悯闽明螟鸣铭名命谬摸"],["c440","腀",5,"腇腉腍腎腏腒腖腗腘腛",4,"腡腢腣腤腦腨腪腫腬腯腲腳腵腶腷腸膁膃",4,"膉膋膌膍膎膐膒",5,"膙膚膞",4,"膤膥"],["c480","膧膩膫",7,"膴",5,"膼膽膾膿臄臅臇臈臉臋臍",6,"摹蘑模膜磨摩魔抹末莫墨默沫漠寞陌谋牟某拇牡亩姆母墓暮幕募慕木目睦牧穆拿哪呐钠那娜纳氖乃奶耐奈南男难囊挠脑恼闹淖呢馁内嫩能妮霓倪泥尼拟你匿腻逆溺蔫拈年碾撵捻念娘酿鸟尿捏聂孽啮镊镍涅您柠狞凝宁"],["c540","臔",14,"臤臥臦臨臩臫臮",4,"臵",5,"臽臿舃與",4,"舎舏舑舓舕",5,"舝舠舤舥舦舧舩舮舲舺舼舽舿"],["c580","艀艁艂艃艅艆艈艊艌艍艎艐",7,"艙艛艜艝艞艠",7,"艩拧泞牛扭钮纽脓浓农弄奴努怒女暖虐疟挪懦糯诺哦欧鸥殴藕呕偶沤啪趴爬帕怕琶拍排牌徘湃派攀潘盘磐盼畔判叛乓庞旁耪胖抛咆刨炮袍跑泡呸胚培裴赔陪配佩沛喷盆砰抨烹澎彭蓬棚硼篷膨朋鹏捧碰坯砒霹批披劈琵毗"],["c640","艪艫艬艭艱艵艶艷艸艻艼芀芁芃芅芆芇芉芌芐芓芔芕芖芚芛芞芠芢芣芧芲芵芶芺芻芼芿苀苂苃苅苆苉苐苖苙苚苝苢苧苨苩苪苬苭苮苰苲苳苵苶苸"],["c680","苺苼",4,"茊茋茍茐茒茓茖茘茙茝",9,"茩茪茮茰茲茷茻茽啤脾疲皮匹痞僻屁譬篇偏片骗飘漂瓢票撇瞥拼频贫品聘乒坪苹萍平凭瓶评屏坡泼颇婆破魄迫粕剖扑铺仆莆葡菩蒲埔朴圃普浦谱曝瀑期欺栖戚妻七凄漆柒沏其棋奇歧畦崎脐齐旗祈祁骑起岂乞企启契砌器气迄弃汽泣讫掐"],["c740","茾茿荁荂荄荅荈荊",4,"荓荕",4,"荝荢荰",6,"荹荺荾",6,"莇莈莊莋莌莍莏莐莑莔莕莖莗莙莚莝莟莡",6,"莬莭莮"],["c780","莯莵莻莾莿菂菃菄菆菈菉菋菍菎菐菑菒菓菕菗菙菚菛菞菢菣菤菦菧菨菫菬菭恰洽牵扦钎铅千迁签仟谦乾黔钱钳前潜遣浅谴堑嵌欠歉枪呛腔羌墙蔷强抢橇锹敲悄桥瞧乔侨巧鞘撬翘峭俏窍切茄且怯窃钦侵亲秦琴勤芹擒禽寝沁青轻氢倾卿清擎晴氰情顷请庆琼穷秋丘邱球求囚酋泅趋区蛆曲躯屈驱渠"],["c840","菮華菳",4,"菺菻菼菾菿萀萂萅萇萈萉萊萐萒",5,"萙萚萛萞",5,"萩",7,"萲",5,"萹萺萻萾",7,"葇葈葉"],["c880","葊",6,"葒",4,"葘葝葞葟葠葢葤",4,"葪葮葯葰葲葴葷葹葻葼取娶龋趣去圈颧权醛泉全痊拳犬券劝缺炔瘸却鹊榷确雀裙群然燃冉染瓤壤攘嚷让饶扰绕惹热壬仁人忍韧任认刃妊纫扔仍日戎茸蓉荣融熔溶容绒冗揉柔肉茹蠕儒孺如辱乳汝入褥软阮蕊瑞锐闰润若弱撒洒萨腮鳃塞赛三叁"],["c940","葽",4,"蒃蒄蒅蒆蒊蒍蒏",7,"蒘蒚蒛蒝蒞蒟蒠蒢",12,"蒰蒱蒳蒵蒶蒷蒻蒼蒾蓀蓂蓃蓅蓆蓇蓈蓋蓌蓎蓏蓒蓔蓕蓗"],["c980","蓘",4,"蓞蓡蓢蓤蓧",4,"蓭蓮蓯蓱",10,"蓽蓾蔀蔁蔂伞散桑嗓丧搔骚扫嫂瑟色涩森僧莎砂杀刹沙纱傻啥煞筛晒珊苫杉山删煽衫闪陕擅赡膳善汕扇缮墒伤商赏晌上尚裳梢捎稍烧芍勺韶少哨邵绍奢赊蛇舌舍赦摄射慑涉社设砷申呻伸身深娠绅神沈审婶甚肾慎渗声生甥牲升绳"],["ca40","蔃",8,"蔍蔎蔏蔐蔒蔔蔕蔖蔘蔙蔛蔜蔝蔞蔠蔢",8,"蔭",9,"蔾",4,"蕄蕅蕆蕇蕋",10],["ca80","蕗蕘蕚蕛蕜蕝蕟",4,"蕥蕦蕧蕩",8,"蕳蕵蕶蕷蕸蕼蕽蕿薀薁省盛剩胜圣师失狮施湿诗尸虱十石拾时什食蚀实识史矢使屎驶始式示士世柿事拭誓逝势是嗜噬适仕侍释饰氏市恃室视试收手首守寿授售受瘦兽蔬枢梳殊抒输叔舒淑疏书赎孰熟薯暑曙署蜀黍鼠属术述树束戍竖墅庶数漱"],["cb40","薂薃薆薈",6,"薐",10,"薝",6,"薥薦薧薩薫薬薭薱",5,"薸薺",6,"藂",6,"藊",4,"藑藒"],["cb80","藔藖",5,"藝",6,"藥藦藧藨藪",14,"恕刷耍摔衰甩帅栓拴霜双爽谁水睡税吮瞬顺舜说硕朔烁斯撕嘶思私司丝死肆寺嗣四伺似饲巳松耸怂颂送宋讼诵搜艘擞嗽苏酥俗素速粟僳塑溯宿诉肃酸蒜算虽隋随绥髓碎岁穗遂隧祟孙损笋蓑梭唆缩琐索锁所塌他它她塔"],["cc40","藹藺藼藽藾蘀",4,"蘆",10,"蘒蘓蘔蘕蘗",15,"蘨蘪",13,"蘹蘺蘻蘽蘾蘿虀"],["cc80","虁",11,"虒虓處",4,"虛虜虝號虠虡虣",7,"獭挞蹋踏胎苔抬台泰酞太态汰坍摊贪瘫滩坛檀痰潭谭谈坦毯袒碳探叹炭汤塘搪堂棠膛唐糖倘躺淌趟烫掏涛滔绦萄桃逃淘陶讨套特藤腾疼誊梯剔踢锑提题蹄啼体替嚏惕涕剃屉天添填田甜恬舔腆挑条迢眺跳贴铁帖厅听烃"],["cd40","虭虯虰虲",6,"蚃",6,"蚎",4,"蚔蚖",5,"蚞",4,"蚥蚦蚫蚭蚮蚲蚳蚷蚸蚹蚻",4,"蛁蛂蛃蛅蛈蛌蛍蛒蛓蛕蛖蛗蛚蛜"],["cd80","蛝蛠蛡蛢蛣蛥蛦蛧蛨蛪蛫蛬蛯蛵蛶蛷蛺蛻蛼蛽蛿蜁蜄蜅蜆蜋蜌蜎蜏蜐蜑蜔蜖汀廷停亭庭挺艇通桐酮瞳同铜彤童桶捅筒统痛偷投头透凸秃突图徒途涂屠土吐兔湍团推颓腿蜕褪退吞屯臀拖托脱鸵陀驮驼椭妥拓唾挖哇蛙洼娃瓦袜歪外豌弯湾玩顽丸烷完碗挽晚皖惋宛婉万腕汪王亡枉网往旺望忘妄威"],["ce40","蜙蜛蜝蜟蜠蜤蜦蜧蜨蜪蜫蜬蜭蜯蜰蜲蜳蜵蜶蜸蜹蜺蜼蜽蝀",6,"蝊蝋蝍蝏蝐蝑蝒蝔蝕蝖蝘蝚",5,"蝡蝢蝦",7,"蝯蝱蝲蝳蝵"],["ce80","蝷蝸蝹蝺蝿螀螁螄螆螇螉螊螌螎",4,"螔螕螖螘",6,"螠",4,"巍微危韦违桅围唯惟为潍维苇萎委伟伪尾纬未蔚味畏胃喂魏位渭谓尉慰卫瘟温蚊文闻纹吻稳紊问嗡翁瓮挝蜗涡窝我斡卧握沃巫呜钨乌污诬屋无芜梧吾吴毋武五捂午舞伍侮坞戊雾晤物勿务悟误昔熙析西硒矽晰嘻吸锡牺"],["cf40","螥螦螧螩螪螮螰螱螲螴螶螷螸螹螻螼螾螿蟁",4,"蟇蟈蟉蟌",4,"蟔",6,"蟜蟝蟞蟟蟡蟢蟣蟤蟦蟧蟨蟩蟫蟬蟭蟯",9],["cf80","蟺蟻蟼蟽蟿蠀蠁蠂蠄",5,"蠋",7,"蠔蠗蠘蠙蠚蠜",4,"蠣稀息希悉膝夕惜熄烯溪汐犀檄袭席习媳喜铣洗系隙戏细瞎虾匣霞辖暇峡侠狭下厦夏吓掀锨先仙鲜纤咸贤衔舷闲涎弦嫌显险现献县腺馅羡宪陷限线相厢镶香箱襄湘乡翔祥详想响享项巷橡像向象萧硝霄削哮嚣销消宵淆晓"],["d040","蠤",13,"蠳",5,"蠺蠻蠽蠾蠿衁衂衃衆",5,"衎",5,"衕衖衘衚",6,"衦衧衪衭衯衱衳衴衵衶衸衹衺"],["d080","衻衼袀袃袆袇袉袊袌袎袏袐袑袓袔袕袗",4,"袝",4,"袣袥",5,"小孝校肖啸笑效楔些歇蝎鞋协挟携邪斜胁谐写械卸蟹懈泄泻谢屑薪芯锌欣辛新忻心信衅星腥猩惺兴刑型形邢行醒幸杏性姓兄凶胸匈汹雄熊休修羞朽嗅锈秀袖绣墟戌需虚嘘须徐许蓄酗叙旭序畜恤絮婿绪续轩喧宣悬旋玄"],["d140","袬袮袯袰袲",4,"袸袹袺袻袽袾袿裀裃裄裇裈裊裋裌裍裏裐裑裓裖裗裚",4,"裠裡裦裧裩",6,"裲裵裶裷裺裻製裿褀褁褃",5],["d180","褉褋",4,"褑褔",4,"褜",4,"褢褣褤褦褧褨褩褬褭褮褯褱褲褳褵褷选癣眩绚靴薛学穴雪血勋熏循旬询寻驯巡殉汛训讯逊迅压押鸦鸭呀丫芽牙蚜崖衙涯雅哑亚讶焉咽阉烟淹盐严研蜒岩延言颜阎炎沿奄掩眼衍演艳堰燕厌砚雁唁彦焰宴谚验殃央鸯秧杨扬佯疡羊洋阳氧仰痒养样漾邀腰妖瑶"],["d240","褸",8,"襂襃襅",24,"襠",5,"襧",19,"襼"],["d280","襽襾覀覂覄覅覇",26,"摇尧遥窑谣姚咬舀药要耀椰噎耶爷野冶也页掖业叶曳腋夜液一壹医揖铱依伊衣颐夷遗移仪胰疑沂宜姨彝椅蚁倚已乙矣以艺抑易邑屹亿役臆逸肄疫亦裔意毅忆义益溢诣议谊译异翼翌绎茵荫因殷音阴姻吟银淫寅饮尹引隐"],["d340","覢",30,"觃觍觓觔觕觗觘觙觛觝觟觠觡觢觤觧觨觩觪觬觭觮觰觱觲觴",6],["d380","觻",4,"訁",5,"計",21,"印英樱婴鹰应缨莹萤营荧蝇迎赢盈影颖硬映哟拥佣臃痈庸雍踊蛹咏泳涌永恿勇用幽优悠忧尤由邮铀犹油游酉有友右佑釉诱又幼迂淤于盂榆虞愚舆余俞逾鱼愉渝渔隅予娱雨与屿禹宇语羽玉域芋郁吁遇喻峪御愈欲狱育誉"],["d440","訞",31,"訿",8,"詉",21],["d480","詟",25,"詺",6,"浴寓裕预豫驭鸳渊冤元垣袁原援辕园员圆猿源缘远苑愿怨院曰约越跃钥岳粤月悦阅耘云郧匀陨允运蕴酝晕韵孕匝砸杂栽哉灾宰载再在咱攒暂赞赃脏葬遭糟凿藻枣早澡蚤躁噪造皂灶燥责择则泽贼怎增憎曾赠扎喳渣札轧"],["d540","誁",7,"誋",7,"誔",46],["d580","諃",32,"铡闸眨栅榨咋乍炸诈摘斋宅窄债寨瞻毡詹粘沾盏斩辗崭展蘸栈占战站湛绽樟章彰漳张掌涨杖丈帐账仗胀瘴障招昭找沼赵照罩兆肇召遮折哲蛰辙者锗蔗这浙珍斟真甄砧臻贞针侦枕疹诊震振镇阵蒸挣睁征狰争怔整拯正政"],["d640","諤",34,"謈",27],["d680","謤謥謧",30,"帧症郑证芝枝支吱蜘知肢脂汁之织职直植殖执值侄址指止趾只旨纸志挚掷至致置帜峙制智秩稚质炙痔滞治窒中盅忠钟衷终种肿重仲众舟周州洲诌粥轴肘帚咒皱宙昼骤珠株蛛朱猪诸诛逐竹烛煮拄瞩嘱主著柱助蛀贮铸筑"],["d740","譆",31,"譧",4,"譭",25],["d780","讇",24,"讬讱讻诇诐诪谉谞住注祝驻抓爪拽专砖转撰赚篆桩庄装妆撞壮状椎锥追赘坠缀谆准捉拙卓桌琢茁酌啄着灼浊兹咨资姿滋淄孜紫仔籽滓子自渍字鬃棕踪宗综总纵邹走奏揍租足卒族祖诅阻组钻纂嘴醉最罪尊遵昨左佐柞做作坐座"],["d840","谸",8,"豂豃豄豅豈豊豋豍",7,"豖豗豘豙豛",5,"豣",6,"豬",6,"豴豵豶豷豻",6,"貃貄貆貇"],["d880","貈貋貍",6,"貕貖貗貙",20,"亍丌兀丐廿卅丕亘丞鬲孬噩丨禺丿匕乇夭爻卮氐囟胤馗毓睾鼗丶亟鼐乜乩亓芈孛啬嘏仄厍厝厣厥厮靥赝匚叵匦匮匾赜卦卣刂刈刎刭刳刿剀剌剞剡剜蒯剽劂劁劐劓冂罔亻仃仉仂仨仡仫仞伛仳伢佤仵伥伧伉伫佞佧攸佚佝"],["d940","貮",62],["d980","賭",32,"佟佗伲伽佶佴侑侉侃侏佾佻侪佼侬侔俦俨俪俅俚俣俜俑俟俸倩偌俳倬倏倮倭俾倜倌倥倨偾偃偕偈偎偬偻傥傧傩傺僖儆僭僬僦僮儇儋仝氽佘佥俎龠汆籴兮巽黉馘冁夔勹匍訇匐凫夙兕亠兖亳衮袤亵脔裒禀嬴蠃羸冫冱冽冼"],["da40","贎",14,"贠赑赒赗赟赥赨赩赪赬赮赯赱赲赸",8,"趂趃趆趇趈趉趌",4,"趒趓趕",9,"趠趡"],["da80","趢趤",12,"趲趶趷趹趻趽跀跁跂跅跇跈跉跊跍跐跒跓跔凇冖冢冥讠讦讧讪讴讵讷诂诃诋诏诎诒诓诔诖诘诙诜诟诠诤诨诩诮诰诳诶诹诼诿谀谂谄谇谌谏谑谒谔谕谖谙谛谘谝谟谠谡谥谧谪谫谮谯谲谳谵谶卩卺阝阢阡阱阪阽阼陂陉陔陟陧陬陲陴隈隍隗隰邗邛邝邙邬邡邴邳邶邺"],["db40","跕跘跙跜跠跡跢跥跦跧跩跭跮跰跱跲跴跶跼跾",6,"踆踇踈踋踍踎踐踑踒踓踕",7,"踠踡踤",4,"踫踭踰踲踳踴踶踷踸踻踼踾"],["db80","踿蹃蹅蹆蹌",4,"蹓",5,"蹚",11,"蹧蹨蹪蹫蹮蹱邸邰郏郅邾郐郄郇郓郦郢郜郗郛郫郯郾鄄鄢鄞鄣鄱鄯鄹酃酆刍奂劢劬劭劾哿勐勖勰叟燮矍廴凵凼鬯厶弁畚巯坌垩垡塾墼壅壑圩圬圪圳圹圮圯坜圻坂坩垅坫垆坼坻坨坭坶坳垭垤垌垲埏垧垴垓垠埕埘埚埙埒垸埴埯埸埤埝"],["dc40","蹳蹵蹷",4,"蹽蹾躀躂躃躄躆躈",6,"躑躒躓躕",6,"躝躟",11,"躭躮躰躱躳",6,"躻",7],["dc80","軃",10,"軏",21,"堋堍埽埭堀堞堙塄堠塥塬墁墉墚墀馨鼙懿艹艽艿芏芊芨芄芎芑芗芙芫芸芾芰苈苊苣芘芷芮苋苌苁芩芴芡芪芟苄苎芤苡茉苷苤茏茇苜苴苒苘茌苻苓茑茚茆茔茕苠苕茜荑荛荜茈莒茼茴茱莛荞茯荏荇荃荟荀茗荠茭茺茳荦荥"],["dd40","軥",62],["dd80","輤",32,"荨茛荩荬荪荭荮莰荸莳莴莠莪莓莜莅荼莶莩荽莸荻莘莞莨莺莼菁萁菥菘堇萘萋菝菽菖萜萸萑萆菔菟萏萃菸菹菪菅菀萦菰菡葜葑葚葙葳蒇蒈葺蒉葸萼葆葩葶蒌蒎萱葭蓁蓍蓐蓦蒽蓓蓊蒿蒺蓠蒡蒹蒴蒗蓥蓣蔌甍蔸蓰蔹蔟蔺"],["de40","轅",32,"轪辀辌辒辝辠辡辢辤辥辦辧辪辬辭辮辯農辳辴辵辷辸辺辻込辿迀迃迆"],["de80","迉",4,"迏迒迖迗迚迠迡迣迧迬迯迱迲迴迵迶迺迻迼迾迿逇逈逌逎逓逕逘蕖蔻蓿蓼蕙蕈蕨蕤蕞蕺瞢蕃蕲蕻薤薨薇薏蕹薮薜薅薹薷薰藓藁藜藿蘧蘅蘩蘖蘼廾弈夼奁耷奕奚奘匏尢尥尬尴扌扪抟抻拊拚拗拮挢拶挹捋捃掭揶捱捺掎掴捭掬掊捩掮掼揲揸揠揿揄揞揎摒揆掾摅摁搋搛搠搌搦搡摞撄摭撖"],["df40","這逜連逤逥逧",5,"逰",4,"逷逹逺逽逿遀遃遅遆遈",4,"過達違遖遙遚遜",5,"遤遦遧適遪遫遬遯",4,"遶",6,"遾邁"],["df80","還邅邆邇邉邊邌",4,"邒邔邖邘邚邜邞邟邠邤邥邧邨邩邫邭邲邷邼邽邿郀摺撷撸撙撺擀擐擗擤擢攉攥攮弋忒甙弑卟叱叽叩叨叻吒吖吆呋呒呓呔呖呃吡呗呙吣吲咂咔呷呱呤咚咛咄呶呦咝哐咭哂咴哒咧咦哓哔呲咣哕咻咿哌哙哚哜咩咪咤哝哏哞唛哧唠哽唔哳唢唣唏唑唧唪啧喏喵啉啭啁啕唿啐唼"],["e040","郂郃郆郈郉郋郌郍郒郔郕郖郘郙郚郞郟郠郣郤郥郩郪郬郮郰郱郲郳郵郶郷郹郺郻郼郿鄀鄁鄃鄅",19,"鄚鄛鄜"],["e080","鄝鄟鄠鄡鄤",10,"鄰鄲",6,"鄺",8,"酄唷啖啵啶啷唳唰啜喋嗒喃喱喹喈喁喟啾嗖喑啻嗟喽喾喔喙嗪嗷嗉嘟嗑嗫嗬嗔嗦嗝嗄嗯嗥嗲嗳嗌嗍嗨嗵嗤辔嘞嘈嘌嘁嘤嘣嗾嘀嘧嘭噘嘹噗嘬噍噢噙噜噌噔嚆噤噱噫噻噼嚅嚓嚯囔囗囝囡囵囫囹囿圄圊圉圜帏帙帔帑帱帻帼"],["e140","酅酇酈酑酓酔酕酖酘酙酛酜酟酠酦酧酨酫酭酳酺酻酼醀",4,"醆醈醊醎醏醓",6,"醜",5,"醤",5,"醫醬醰醱醲醳醶醷醸醹醻"],["e180","醼",10,"釈釋釐釒",9,"針",8,"帷幄幔幛幞幡岌屺岍岐岖岈岘岙岑岚岜岵岢岽岬岫岱岣峁岷峄峒峤峋峥崂崃崧崦崮崤崞崆崛嵘崾崴崽嵬嵛嵯嵝嵫嵋嵊嵩嵴嶂嶙嶝豳嶷巅彳彷徂徇徉後徕徙徜徨徭徵徼衢彡犭犰犴犷犸狃狁狎狍狒狨狯狩狲狴狷猁狳猃狺"],["e240","釦",62],["e280","鈥",32,"狻猗猓猡猊猞猝猕猢猹猥猬猸猱獐獍獗獠獬獯獾舛夥飧夤夂饣饧",5,"饴饷饽馀馄馇馊馍馐馑馓馔馕庀庑庋庖庥庠庹庵庾庳赓廒廑廛廨廪膺忄忉忖忏怃忮怄忡忤忾怅怆忪忭忸怙怵怦怛怏怍怩怫怊怿怡恸恹恻恺恂"],["e340","鉆",45,"鉵",16],["e380","銆",7,"銏",24,"恪恽悖悚悭悝悃悒悌悛惬悻悱惝惘惆惚悴愠愦愕愣惴愀愎愫慊慵憬憔憧憷懔懵忝隳闩闫闱闳闵闶闼闾阃阄阆阈阊阋阌阍阏阒阕阖阗阙阚丬爿戕氵汔汜汊沣沅沐沔沌汨汩汴汶沆沩泐泔沭泷泸泱泗沲泠泖泺泫泮沱泓泯泾"],["e440","銨",5,"銯",24,"鋉",31],["e480","鋩",32,"洹洧洌浃浈洇洄洙洎洫浍洮洵洚浏浒浔洳涑浯涞涠浞涓涔浜浠浼浣渚淇淅淞渎涿淠渑淦淝淙渖涫渌涮渫湮湎湫溲湟溆湓湔渲渥湄滟溱溘滠漭滢溥溧溽溻溷滗溴滏溏滂溟潢潆潇漤漕滹漯漶潋潴漪漉漩澉澍澌潸潲潼潺濑"],["e540","錊",51,"錿",10],["e580","鍊",31,"鍫濉澧澹澶濂濡濮濞濠濯瀚瀣瀛瀹瀵灏灞宀宄宕宓宥宸甯骞搴寤寮褰寰蹇謇辶迓迕迥迮迤迩迦迳迨逅逄逋逦逑逍逖逡逵逶逭逯遄遑遒遐遨遘遢遛暹遴遽邂邈邃邋彐彗彖彘尻咫屐屙孱屣屦羼弪弩弭艴弼鬻屮妁妃妍妩妪妣"],["e640","鍬",34,"鎐",27],["e680","鎬",29,"鏋鏌鏍妗姊妫妞妤姒妲妯姗妾娅娆姝娈姣姘姹娌娉娲娴娑娣娓婀婧婊婕娼婢婵胬媪媛婷婺媾嫫媲嫒嫔媸嫠嫣嫱嫖嫦嫘嫜嬉嬗嬖嬲嬷孀尕尜孚孥孳孑孓孢驵驷驸驺驿驽骀骁骅骈骊骐骒骓骖骘骛骜骝骟骠骢骣骥骧纟纡纣纥纨纩"],["e740","鏎",7,"鏗",54],["e780","鐎",32,"纭纰纾绀绁绂绉绋绌绐绔绗绛绠绡绨绫绮绯绱绲缍绶绺绻绾缁缂缃缇缈缋缌缏缑缒缗缙缜缛缟缡",6,"缪缫缬缭缯",4,"缵幺畿巛甾邕玎玑玮玢玟珏珂珑玷玳珀珉珈珥珙顼琊珩珧珞玺珲琏琪瑛琦琥琨琰琮琬"],["e840","鐯",14,"鐿",43,"鑬鑭鑮鑯"],["e880","鑰",20,"钑钖钘铇铏铓铔铚铦铻锜锠琛琚瑁瑜瑗瑕瑙瑷瑭瑾璜璎璀璁璇璋璞璨璩璐璧瓒璺韪韫韬杌杓杞杈杩枥枇杪杳枘枧杵枨枞枭枋杷杼柰栉柘栊柩枰栌柙枵柚枳柝栀柃枸柢栎柁柽栲栳桠桡桎桢桄桤梃栝桕桦桁桧桀栾桊桉栩梵梏桴桷梓桫棂楮棼椟椠棹"],["e940","锧锳锽镃镈镋镕镚镠镮镴镵長",7,"門",42],["e980","閫",32,"椤棰椋椁楗棣椐楱椹楠楂楝榄楫榀榘楸椴槌榇榈槎榉楦楣楹榛榧榻榫榭槔榱槁槊槟榕槠榍槿樯槭樗樘橥槲橄樾檠橐橛樵檎橹樽樨橘橼檑檐檩檗檫猷獒殁殂殇殄殒殓殍殚殛殡殪轫轭轱轲轳轵轶轸轷轹轺轼轾辁辂辄辇辋"],["ea40","闌",27,"闬闿阇阓阘阛阞阠阣",6,"阫阬阭阯阰阷阸阹阺阾陁陃陊陎陏陑陒陓陖陗"],["ea80","陘陙陚陜陝陞陠陣陥陦陫陭",4,"陳陸",12,"隇隉隊辍辎辏辘辚軎戋戗戛戟戢戡戥戤戬臧瓯瓴瓿甏甑甓攴旮旯旰昊昙杲昃昕昀炅曷昝昴昱昶昵耆晟晔晁晏晖晡晗晷暄暌暧暝暾曛曜曦曩贲贳贶贻贽赀赅赆赈赉赇赍赕赙觇觊觋觌觎觏觐觑牮犟牝牦牯牾牿犄犋犍犏犒挈挲掰"],["eb40","隌階隑隒隓隕隖隚際隝",9,"隨",7,"隱隲隴隵隷隸隺隻隿雂雃雈雊雋雐雑雓雔雖",9,"雡",6,"雫"],["eb80","雬雭雮雰雱雲雴雵雸雺電雼雽雿霂霃霅霊霋霌霐霑霒霔霕霗",4,"霝霟霠搿擘耄毪毳毽毵毹氅氇氆氍氕氘氙氚氡氩氤氪氲攵敕敫牍牒牖爰虢刖肟肜肓肼朊肽肱肫肭肴肷胧胨胩胪胛胂胄胙胍胗朐胝胫胱胴胭脍脎胲胼朕脒豚脶脞脬脘脲腈腌腓腴腙腚腱腠腩腼腽腭腧塍媵膈膂膑滕膣膪臌朦臊膻"],["ec40","霡",8,"霫霬霮霯霱霳",4,"霺霻霼霽霿",18,"靔靕靗靘靚靜靝靟靣靤靦靧靨靪",7],["ec80","靲靵靷",4,"靽",7,"鞆",4,"鞌鞎鞏鞐鞓鞕鞖鞗鞙",4,"臁膦欤欷欹歃歆歙飑飒飓飕飙飚殳彀毂觳斐齑斓於旆旄旃旌旎旒旖炀炜炖炝炻烀炷炫炱烨烊焐焓焖焯焱煳煜煨煅煲煊煸煺熘熳熵熨熠燠燔燧燹爝爨灬焘煦熹戾戽扃扈扉礻祀祆祉祛祜祓祚祢祗祠祯祧祺禅禊禚禧禳忑忐"],["ed40","鞞鞟鞡鞢鞤",6,"鞬鞮鞰鞱鞳鞵",46],["ed80","韤韥韨韮",4,"韴韷",23,"怼恝恚恧恁恙恣悫愆愍慝憩憝懋懑戆肀聿沓泶淼矶矸砀砉砗砘砑斫砭砜砝砹砺砻砟砼砥砬砣砩硎硭硖硗砦硐硇硌硪碛碓碚碇碜碡碣碲碹碥磔磙磉磬磲礅磴礓礤礞礴龛黹黻黼盱眄眍盹眇眈眚眢眙眭眦眵眸睐睑睇睃睚睨"],["ee40","頏",62],["ee80","顎",32,"睢睥睿瞍睽瞀瞌瞑瞟瞠瞰瞵瞽町畀畎畋畈畛畲畹疃罘罡罟詈罨罴罱罹羁罾盍盥蠲钅钆钇钋钊钌钍钏钐钔钗钕钚钛钜钣钤钫钪钭钬钯钰钲钴钶",4,"钼钽钿铄铈",6,"铐铑铒铕铖铗铙铘铛铞铟铠铢铤铥铧铨铪"],["ef40","顯",5,"颋颎颒颕颙颣風",37,"飏飐飔飖飗飛飜飝飠",4],["ef80","飥飦飩",30,"铩铫铮铯铳铴铵铷铹铼铽铿锃锂锆锇锉锊锍锎锏锒",4,"锘锛锝锞锟锢锪锫锩锬锱锲锴锶锷锸锼锾锿镂锵镄镅镆镉镌镎镏镒镓镔镖镗镘镙镛镞镟镝镡镢镤",8,"镯镱镲镳锺矧矬雉秕秭秣秫稆嵇稃稂稞稔"],["f040","餈",4,"餎餏餑",28,"餯",26],["f080","饊",9,"饖",12,"饤饦饳饸饹饻饾馂馃馉稹稷穑黏馥穰皈皎皓皙皤瓞瓠甬鸠鸢鸨",4,"鸲鸱鸶鸸鸷鸹鸺鸾鹁鹂鹄鹆鹇鹈鹉鹋鹌鹎鹑鹕鹗鹚鹛鹜鹞鹣鹦",6,"鹱鹭鹳疒疔疖疠疝疬疣疳疴疸痄疱疰痃痂痖痍痣痨痦痤痫痧瘃痱痼痿瘐瘀瘅瘌瘗瘊瘥瘘瘕瘙"],["f140","馌馎馚",10,"馦馧馩",47],["f180","駙",32,"瘛瘼瘢瘠癀瘭瘰瘿瘵癃瘾瘳癍癞癔癜癖癫癯翊竦穸穹窀窆窈窕窦窠窬窨窭窳衤衩衲衽衿袂袢裆袷袼裉裢裎裣裥裱褚裼裨裾裰褡褙褓褛褊褴褫褶襁襦襻疋胥皲皴矜耒耔耖耜耠耢耥耦耧耩耨耱耋耵聃聆聍聒聩聱覃顸颀颃"],["f240","駺",62],["f280","騹",32,"颉颌颍颏颔颚颛颞颟颡颢颥颦虍虔虬虮虿虺虼虻蚨蚍蚋蚬蚝蚧蚣蚪蚓蚩蚶蛄蚵蛎蚰蚺蚱蚯蛉蛏蚴蛩蛱蛲蛭蛳蛐蜓蛞蛴蛟蛘蛑蜃蜇蛸蜈蜊蜍蜉蜣蜻蜞蜥蜮蜚蜾蝈蜴蜱蜩蜷蜿螂蜢蝽蝾蝻蝠蝰蝌蝮螋蝓蝣蝼蝤蝙蝥螓螯螨蟒"],["f340","驚",17,"驲骃骉骍骎骔骕骙骦骩",6,"骲骳骴骵骹骻骽骾骿髃髄髆",4,"髍髎髏髐髒體髕髖髗髙髚髛髜"],["f380","髝髞髠髢髣髤髥髧髨髩髪髬髮髰",8,"髺髼",6,"鬄鬅鬆蟆螈螅螭螗螃螫蟥螬螵螳蟋蟓螽蟑蟀蟊蟛蟪蟠蟮蠖蠓蟾蠊蠛蠡蠹蠼缶罂罄罅舐竺竽笈笃笄笕笊笫笏筇笸笪笙笮笱笠笥笤笳笾笞筘筚筅筵筌筝筠筮筻筢筲筱箐箦箧箸箬箝箨箅箪箜箢箫箴篑篁篌篝篚篥篦篪簌篾篼簏簖簋"],["f440","鬇鬉",5,"鬐鬑鬒鬔",10,"鬠鬡鬢鬤",10,"鬰鬱鬳",7,"鬽鬾鬿魀魆魊魋魌魎魐魒魓魕",5],["f480","魛",32,"簟簪簦簸籁籀臾舁舂舄臬衄舡舢舣舭舯舨舫舸舻舳舴舾艄艉艋艏艚艟艨衾袅袈裘裟襞羝羟羧羯羰羲籼敉粑粝粜粞粢粲粼粽糁糇糌糍糈糅糗糨艮暨羿翎翕翥翡翦翩翮翳糸絷綦綮繇纛麸麴赳趄趔趑趱赧赭豇豉酊酐酎酏酤"],["f540","魼",62],["f580","鮻",32,"酢酡酰酩酯酽酾酲酴酹醌醅醐醍醑醢醣醪醭醮醯醵醴醺豕鹾趸跫踅蹙蹩趵趿趼趺跄跖跗跚跞跎跏跛跆跬跷跸跣跹跻跤踉跽踔踝踟踬踮踣踯踺蹀踹踵踽踱蹉蹁蹂蹑蹒蹊蹰蹶蹼蹯蹴躅躏躔躐躜躞豸貂貊貅貘貔斛觖觞觚觜"],["f640","鯜",62],["f680","鰛",32,"觥觫觯訾謦靓雩雳雯霆霁霈霏霎霪霭霰霾龀龃龅",5,"龌黾鼋鼍隹隼隽雎雒瞿雠銎銮鋈錾鍪鏊鎏鐾鑫鱿鲂鲅鲆鲇鲈稣鲋鲎鲐鲑鲒鲔鲕鲚鲛鲞",5,"鲥",4,"鲫鲭鲮鲰",7,"鲺鲻鲼鲽鳄鳅鳆鳇鳊鳋"],["f740","鰼",62],["f780","鱻鱽鱾鲀鲃鲄鲉鲊鲌鲏鲓鲖鲗鲘鲙鲝鲪鲬鲯鲹鲾",4,"鳈鳉鳑鳒鳚鳛鳠鳡鳌",4,"鳓鳔鳕鳗鳘鳙鳜鳝鳟鳢靼鞅鞑鞒鞔鞯鞫鞣鞲鞴骱骰骷鹘骶骺骼髁髀髅髂髋髌髑魅魃魇魉魈魍魑飨餍餮饕饔髟髡髦髯髫髻髭髹鬈鬏鬓鬟鬣麽麾縻麂麇麈麋麒鏖麝麟黛黜黝黠黟黢黩黧黥黪黯鼢鼬鼯鼹鼷鼽鼾齄"],["f840","鳣",62],["f880","鴢",32],["f940","鵃",62],["f980","鶂",32],["fa40","鶣",62],["fa80","鷢",32],["fb40","鸃",27,"鸤鸧鸮鸰鸴鸻鸼鹀鹍鹐鹒鹓鹔鹖鹙鹝鹟鹠鹡鹢鹥鹮鹯鹲鹴",9,"麀"],["fb80","麁麃麄麅麆麉麊麌",5,"麔",8,"麞麠",5,"麧麨麩麪"],["fc40","麫",8,"麵麶麷麹麺麼麿",4,"黅黆黇黈黊黋黌黐黒黓黕黖黗黙黚點黡黣黤黦黨黫黬黭黮黰",8,"黺黽黿",6],["fc80","鼆",4,"鼌鼏鼑鼒鼔鼕鼖鼘鼚",5,"鼡鼣",8,"鼭鼮鼰鼱"],["fd40","鼲",4,"鼸鼺鼼鼿",4,"齅",10,"齒",38],["fd80","齹",5,"龁龂龍",11,"龜龝龞龡",4,"郎凉秊裏隣"],["fe40","兀嗀﨎﨏﨑﨓﨔礼﨟蘒﨡﨣﨤﨧﨨﨩"]]

/***/ }),
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addProduct_vue__ = __webpack_require__(458);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83fd7454_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addProduct_vue__ = __webpack_require__(1398);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addProduct_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_83fd7454_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_addProduct_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return barcodePrintPDF; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);



var _this = this;

var barcodePrintPDF = function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(metaData) {
        var pdfDoc, svg, svgData, canvas, ctx, img;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        pdfDoc = {
                            content: [
                                // {
                                //     image: 'sampleImage.jpg',
                                // 	height: 60,            
                                // },

                            ],
                            "pageSize": 'A8',
                            pageOrientation: 'landscape',
                            // footer: {
                            // 	columns: [
                            // 		{ text: 'Powered By ACUIFY', alignment: 'right', color: '#160091' }
                            // 	],
                            // 	margin: [10, 10]
                            // },
                            styles: {
                                barcode: {
                                    fontSize: 22,
                                    // alignment: 'center',
                                    bold: true
                                }
                            }
                        };

                        if (metaData.productName) {
                            pdfDoc.content.push({ text: " " + "N.W : " + metaData.grossWeight + '\n' + " K : " + metaData.purity, style: "barcode" });
                        }
                        // if(metaData.grossWeight) {
                        //     pdfDoc.content.push({text:"Net Weight : " + metaData.grossWeight});
                        // }
                        // if(metaData.purity) {
                        //     pdfDoc.content.push({text:"Purity : " + metaData.purity});
                        // }
                        svg = document.querySelector("#barcode");
                        svgData = new XMLSerializer().serializeToString(svg);
                        canvas = document.createElement("canvas");
                        ctx = canvas.getContext("2d");
                        img = document.createElement("img");

                        img.setAttribute("src", "data:image/svg+xml;base64," + btoa(svgData));

                        img.onload = function () {
                            ctx.drawImage(img, 0, 0);
                            // let imgSource = canvas.toDataURL("image/png")
                            // pdfDoc.content[0].image = imgSource;
                            pdfMake.createPdf(pdfDoc).download('a8');
                        };

                    case 9:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this);
    }));

    return function barcodePrintPDF(_x) {
        return _ref.apply(this, arguments);
    };
}();

/***/ }),
/* 242 */,
/* 243 */,
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sendSms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sendWhatsApp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var sendSms1 = function sendSms1(phone, message) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://us-central1-one-business-1ca39.cloudfunctions.net/widgets/sendSms', {
        message: message,
        phone: phone
    });
    // .then(response => {
    //         console.log(response)
    //     })
};

var sendWhatsApp1 = function sendWhatsApp1(phone, message) {
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post('https://us-central1-one-business-1ca39.cloudfunctions.net/widgets/sendWhatsApp', {
        message: message,
        phone: phone
    }).then(function (response) {
        console.log(response);
    });
};

var sendSms = sendSms1;
var sendWhatsApp = sendWhatsApp1;

/***/ }),
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 251 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'App'
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_firebase_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_permissins__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RateCard__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AlertSidebar__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UnderMaintenance_UnderMaintenance_vue__ = __webpack_require__(825);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var brand = window.localStorage.getItem('brand');
//let brandFinYear = window.localStorage.getItem('brandFinYear');
var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
var mapGlobalActions = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])("Global")["mapActions"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      maintenance: true,
      dialog: false,
      menu: null,
      selectedDefaultFirm: null,
      previousDafaultFirm: null,
      langs: [{ text: 'English',
        value: 'en'
      }, { text: 'हिन्दी',
        value: 'hi' }],
      // currentFinancialYear: new Date().getFullYear() + "-" + ((new Date().getFullYear() + 1) % 100),
      currentFinancialYear: this.getCurrentFinYear(),
      clipped: true,
      alertMode: false,
      drawer: false,
      fixed: true,
      items: [{
        icon: "dashboard",
        title: "Dashboard",
        link: "/"
      }, {
        icon: "people",
        title: "Buyers",
        link: "Buyers"
      }, {
        icon: "list_alt",
        title: "Record",
        link: "Reports"
      }, {
        icon: "swap_horiz",
        title: "Transactions",
        link: "InvoiceManagement"
      }, {
        icon: "settings",
        title: "Settings",
        link: "Settings"
      }, {
        icon: "report",
        title: "Reports",
        link: "Informations"
      }],
      miniVariant: true,
      right: true,
      title: "Acuify",
      alertListOpen: false,
      brands: [],
      operators: []
    };
  },

  name: "Home",
  components: {
    RateCard: __WEBPACK_IMPORTED_MODULE_5__RateCard__["a" /* default */],
    AlertSideBar: __WEBPACK_IMPORTED_MODULE_6__AlertSidebar__["a" /* default */],
    UnderMaintenance: __WEBPACK_IMPORTED_MODULE_7__UnderMaintenance_UnderMaintenance_vue__["a" /* default */]
  },
  created: function created() {
    this.setBrand();
    this.$bindAsObject("brands", this.$root.$firebaseRefs.brand);
    this.$bindAsObject("operators", this.$root.$firebaseRefs.operator);
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(brand));
    this.$bindAsArray("brandPermission", this.$root.$firebaseRefs.brandPermission.orderByChild('brand').equalTo(brand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "adminEmail", "roleAndPermission"]), mapGlobalGetters({
    allBrands: "brands"
  }), {
    hasSettingsPermission: function hasSettingsPermission() {
      if (this.roleAndPermission && this.roleAndPermission.permissions && this.roleAndPermission.permissions.length && this.roleAndPermission.permissions.indexOf('BRAND_SETTINGS') > -1) {
        return true;
      } else {
        return false;
      }
    },
    hasRecordsPermission: function hasRecordsPermission() {
      if (this.roleAndPermission && this.roleAndPermission.permissions && this.roleAndPermission.permissions.length && this.roleAndPermission.permissions.indexOf('BRAND_RECORDS') > -1) {
        return true;
      } else {
        return false;
      }
    },
    hasReportsPermission: function hasReportsPermission() {
      if (this.roleAndPermission && this.roleAndPermission.permissions && this.roleAndPermission.permissions.length && this.roleAndPermission.permissions.indexOf('BRAND_REPORTS') > -1) {
        return true;
      } else {
        return false;
      }
    },
    hasTransactionPermission: function hasTransactionPermission() {
      if (this.roleAndPermission && this.roleAndPermission.permissions && this.roleAndPermission.permissions.length && this.roleAndPermission.permissions.indexOf('BRAND_TRANSACTIONS') > -1) {
        return true;
      } else {
        return false;
      }
    },
    hasDashboardPermission: function hasDashboardPermission() {
      if (this.roleAndPermission && this.roleAndPermission.permissions && this.roleAndPermission.permissions.length && this.roleAndPermission.permissions.indexOf('BRAND_DASHBOARD') > -1) {
        return true;
      } else {
        return false;
      }
    },
    hasBuyerPermission: function hasBuyerPermission() {
      if (this.roleAndPermission && this.roleAndPermission.permissions && this.roleAndPermission.permissions.length && this.roleAndPermission.permissions.indexOf('BRAND_BUYER') > -1) {
        return true;
      } else {
        return false;
      }
    },
    hasRatesPermission: function hasRatesPermission() {
      if (this.roleAndPermission && this.roleAndPermission.permissions && this.roleAndPermission.permissions.length && (this.roleAndPermission.permissions.indexOf('SALE_RATE_VIEW_EDIT') > -1 || this.roleAndPermission.permissions.indexOf('PURCHASE_RATE_VIEW_EDIT') > -1)) {
        return true;
      } else {
        return false;
      }
    },
    hasProductsPermission: function hasProductsPermission() {
      if (this.roleAndPermission && this.roleAndPermission.permissions && this.roleAndPermission.permissions.length && this.roleAndPermission.permissions.indexOf('BRAND_PRODUCTS') > -1) {
        return true;
      } else {
        return false;
      }
    },
    hasTransferPermission: function hasTransferPermission() {
      if (this.roleAndPermission && this.roleAndPermission.permissions && this.roleAndPermission.permissions.length && this.roleAndPermission.permissions.indexOf('AMOUNT_TRANSFER') > -1) {
        return true;
      } else {
        return false;
      }
    },
    hasFirmChangePermission: function hasFirmChangePermission() {
      if (this.roleAndPermission && this.roleAndPermission.permissions && this.roleAndPermission.permissions.length && this.roleAndPermission.permissions.indexOf('CHANGE_DEFAULT_FIRM') > -1) {
        return true;
      } else {
        return false;
      }
    },
    hasFinChangePermission: function hasFinChangePermission() {
      if (this.roleAndPermission && this.roleAndPermission.permissions && this.roleAndPermission.permissions.length && this.roleAndPermission.permissions.indexOf('CHANGE_FIN_YEAR') > -1) {
        return true;
      } else {
        return false;
      }
    },
    firmsByBrand: function firmsByBrand() {
      var _this = this;

      if (this.selectedBrand) {
        return this.firms.filter(function (item) {
          return item["brand"] == brand;
        }).map(function (item) {
          if (item.defaultFirm) {
            console.log(item);
            _this.selectedDefaultFirm = item[".key"];
            _this.previousDafaultFirm = item[".key"];
          }
          return {
            text: item["name"],
            value: item[".key"]
          };
        });
      } else {
        return [];
      }
    },
    getFinList: function getFinList() {
      var finList = [];
      for (var i = -10; i < 10; i++) {
        finList.push(new Date().getFullYear() + i + "-" + (new Date().getFullYear() + (i + 1)) % 100);
      }
      return finList;
    },
    getBrands: function getBrands() {
      console.log(0, this.brands);
      if (this.brands && this.getUserBrands) {
        // console.log(1)
        var result = {};
        for (var key in this.brands) {
          if (this.getUserBrands.indexOf(key) !== -1) {
            result[key] = this.brands[key];
          }
        }
        return result;
      }
      return {};
    },
    getUserBrands: function getUserBrands() {
      var _this2 = this;

      if (this.operators) {
        var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.operators).filter(function (key) {
          return _this2.operators[key]["uid"] === _this2.getUserId;
        });
        if (data) {
          if (this.operators[data[0]]) {
            this.setRolesAndPermission(this.operators[data[0]]);
            return this.operators[data[0]]["brand"];
          }
        }
      }
      return [];
    },
    getUserId: function getUserId() {
      return window.localStorage.getItem("user") || null;
    },
    getSelectedBrandName: function getSelectedBrandName() {
      if (this.selectedBrand && this.allBrands) {
        // let key = Object.keys(this.selectedBrand)[0]
        // return this.selectedBrand[key]
        return this.allBrands[this.selectedBrand];
      }
    }
  }),
  watch: {
    getBrands: function getBrands(val) {
      if (!this.selectedBrand || !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(val).length) {
        var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(val);
        //this.SET_SELECTED_BRAND(keys[0]);
        this.setAdminEmail();
        if (this.currentFinancialYear) {
          this.setFinYear();
        }
      }
      this.SET_BRANDS(val);
    },

    // selectedDefaultFirm: {
    //   handler(newVal, oldVal) {
    //     this.setDefaultFirm(newVal);
    //   },
    //   deep: true,
    // },
    $route: function $route(to, from) {
      // close the alert sheet when route is changed;
      this.alertListOpen = false;
    }
  },
  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalActions(["SET_SELECTED_BRAND", "SET_BRANDS", "SET_ADMIN_EMAIL", "SET_FIN_YEAR", "SET_ROLE_AND_PERMISSIONS", "SET_BRAND_FIN_YEAR"]), {
    changeLocale: function changeLocale() {
      window.localStorage.setItem("locale", this.$i18n.locale);
    },
    getCurrentFinYear: function getCurrentFinYear() {
      // let finYear = window.localStorage.getItem('finYear');
      // if(!finYear) {
      var todayDate = new Date();
      // var from = new Date(0, 1, 2000);
      // var to   = new Date(2, 31, 2000);
      // var check = new Date(todayDate.getMonth(), todayDate.getDate(), 2000);
      // if(check > from && check < to) {
      var finChanginingDate = new Date(2000, 2, 31).getTime();
      var check = new Date(2000, todayDate.getMonth(), todayDate.getDate()).getTime();
      if (finChanginingDate >= check) {
        return new Date().getFullYear() - 1 + "-" + new Date().getFullYear() % 100;
      } else {
        return new Date().getFullYear() + "-" + (new Date().getFullYear() + 1) % 100;
      }
      // }
      // return finYear;
    },
    setRolesAndPermission: function setRolesAndPermission(user) {
      var _this3 = this;

      if (user.role) {
        var obj = {
          role: user.role,
          permissions: user.role != 'admin' ? user.permission : __WEBPACK_IMPORTED_MODULE_4__utils_permissins__["a" /* default */].PERMISSIONS
        };
        if (user.role != 'admin') {
          obj['branch'] = user.branch;
        }
        this.SET_ROLE_AND_PERMISSIONS(obj);
        setTimeout(function () {
          var brandPermissions = _this3.brandPermission.filter(function (item) {
            return item['brand'] == brand;
          });
          if (brandPermissions && brandPermissions.length) {
            if (brandPermissions[0].active) {
              obj['brandPermissions'] = brandPermissions[0].permissions;
              _this3.SET_ROLE_AND_PERMISSIONS(obj);
            } else {
              alert("Sorry! Your Brand is not Active. Please contact Acuify Administrator.");
              __WEBPACK_IMPORTED_MODULE_2__services_firebase_js__["a" /* cfirebase */].auth().signOut();
              _this3.$router.go("/login");
            }
          }
        }, 3000);
      }
    },
    signOut: function signOut() {
      // window.localStorage.removeItem('user')
      console.log("Signing Out");
      __WEBPACK_IMPORTED_MODULE_2__services_firebase_js__["a" /* cfirebase */].auth().signOut();
      this.$router.go("/login");
    },
    setAdminEmail: function setAdminEmail() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2__services_firebase_js__["a" /* cfirebase */].auth().onAuthStateChanged(function (user) {
        _this4.SET_ADMIN_EMAIL(user.email);
      });
    },
    setFinYear: function setFinYear() {
      var start = new Date();
      start.setHours(0, 0, 0, 0);
      start.setYear(this.currentFinancialYear.substring(0, 4));
      start.setMonth(3);
      start.setDate(1);

      var end = new Date();
      end.setHours(23, 59, 59, 999);
      end.setYear("20" + this.currentFinancialYear.substring(5, 7));
      end.setMonth(2);
      end.setDate(31);

      var finYearObj = {
        finYear: this.currentFinancialYear,
        start: start,
        end: end
      };

      this.SET_FIN_YEAR(finYearObj);
      // window.localStorage.setItem('finYear', this.currentFinancialYear)
      // if(this.selectedBrand) {
      //   this.SET_BRAND_FIN_YEAR(this.selectedBrand + "_" + this.currentFinancialYear);
      //    window.localStorage.setItem('brandFinYear', (this.selectedBrand + "_" + this.currentFinancialYear))
      // }
      // if(isRelaod) {
      //   setTimeout(() => {
      //     location.reload();
      //   }, 1000);
      // }      
    },

    // switchBrand(key) {
    //   if (this.getBrands) {
    //     this.SET_SELECTED_BRAND(key);
    //   }
    // },
    switchRoute: function switchRoute(link) {
      console.log(link);
      this.$router.push({ name: link });
      // this.$router.push(`buyer/${link}`)
    },
    toggleAlertList: function toggleAlertList() {
      this.alertListOpen = !this.alertListOpen;
    },
    setBrand: function setBrand() {
      // let brand  = window.localStorage.getItem("brand") || null;
      // this.SET_SELECTED_BRAND(brand);
    },
    setDefaultFirm: function setDefaultFirm(newDefaultFirm) {
      var _this5 = this;

      this.firmsByBrand.map(function (item) {
        _this5.$root.$firebaseRefs.firm.child(item.value).update({
          defaultFirm: false
        }, function () {
          console.info('default remove completed...');
        });
      });
      this.$root.$firebaseRefs.firm.child(newDefaultFirm).update({
        defaultFirm: true
      }, function () {
        console.info('default add completed...');
        _this5.previousDafaultFirm = newDefaultFirm;
      });
    }
  })
});

/***/ }),
/* 288 */,
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_pdf_reports_rates_report__ = __webpack_require__(810);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["rateCard", "brand"],
  data: function data() {
    return {
      snack: false,
      search: null,
      snackColor: "",
      snackText: "",
      bulkPurchaseRate: 0,
      bulkSellingRate: 0,
      bulkHSN: null,
      bulkSpecialChargePercentage: null,
      selectedProductGroup: null,
      headers: [{
        text: "Product",
        align: "left",
        sortable: true,
        value: "name"
      }, {
        text: "Purchase Rate",
        value: "prate",
        sortable: false
      }, {
        text: "Selling Rate",
        value: "srate",
        sortable: false
      }, {
        text: "HSN code",
        value: "hsn",
        sortable: false
      }, {
        text: "Special Charge",
        value: "specialCharge",
        sortable: false
      }, {
        text: "UNIT",
        value: "unit",
        sortable: false
      }],
      onlyNumbers: function onlyNumbers(v) {
        return !isNaN(v) || "Should be a valid Number";
      }
    };
  },
  created: function created() {
    this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("productGroups", this.$root.$firebaseRefs.productGroup.orderByChild("brand").equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "roleAndPermission"]), {
    productsByBrand: function productsByBrand() {
      var _this = this;

      return this.products.filter(function (item) {
        return item["brand"] === _this.selectedBrand && (!item.unitsDetails || !item.unitsDetails.length) && (_this.selectedProductGroup ? item["productGroup"] == _this.selectedProductGroup[".key"] : true) && (!!_this.search ? !!item["name"].toLowerCase().includes(_this.search.toLowerCase()) : true);
      });
    },
    hasSalePermission: function hasSalePermission() {
      if (this.roleAndPermission && this.roleAndPermission.permissions && this.roleAndPermission.permissions.length && this.roleAndPermission.permissions.indexOf("SALE_RATE_VIEW_EDIT") > -1) {
        return true;
      } else {
        return false;
      }
    },
    hasPurchasePermission: function hasPurchasePermission() {
      if (this.roleAndPermission && this.roleAndPermission.permissions && this.roleAndPermission.permissions.length && this.roleAndPermission.permissions.indexOf("PURCHASE_RATE_VIEW_EDIT") > -1) {
        return true;
      } else {
        return false;
      }
    }
  }),
  methods: {
    printReport: function printReport() {
      var doc = Object(__WEBPACK_IMPORTED_MODULE_2__utils_pdf_reports_rates_report__["a" /* ratesReportPDF */])({
        products: this.productsByBrand
      });
      pdfMake.createPdf(doc).download();
    },
    keymonitor: function keymonitor(event) {
      this.search = event.target.value;
    },
    close: function close() {
      this.$emit("close");
    },
    savePurchaseRate: function savePurchaseRate(data) {
      if (isNaN(data.purchasingPrice)) {
        return;
      }
      if (data[".key"]) {
        //Update
        this.$root.$firebaseRefs.products.child(data[".key"]).update({
          purchasingPrice: data.purchasingPrice
        });
      }
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Data saved";
    },
    saveHSN: function saveHSN(data) {
      if (isNaN(data.HSN_code)) {
        return;
      }
      if (data[".key"]) {
        //Update
        this.$root.$firebaseRefs.products.child(data[".key"]).update({
          HSN_code: data.HSN_code
        });
      }
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Data saved";
    },
    saveSpecialChargePercentage: function saveSpecialChargePercentage(data) {
      if (isNaN(data.specialChargePercentage)) {
        return;
      }
      if (data[".key"]) {
        //Update
        this.$root.$firebaseRefs.products.child(data[".key"]).update({
          specialChargePercentage: data.specialChargePercentage
        });
      }
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Data saved";
    },
    saveBulkRate: function saveBulkRate(isPurchase) {
      var _this2 = this;

      var productsToUpdate = this.productsByBrand;
      if (isPurchase) {
        if (isNaN(this.bulkPurchaseRate)) {
          return;
        }
        productsToUpdate.map(function (prod) {
          _this2.$root.$firebaseRefs.products.child(prod[".key"]).update({
            purchasingPrice: _this2.bulkPurchaseRate
          });
        });
        this.snack = true;
        this.snackColor = "success";
        this.snackText = "Data saved";
      } else {
        if (isNaN(this.bulkSellingRate)) {
          return;
        }
        productsToUpdate.map(function (prod) {
          _this2.$root.$firebaseRefs.products.child(prod[".key"]).update({
            sellingPrice: _this2.bulkSellingRate
          });
        });
        this.snack = true;
        this.snackColor = "success";
        this.snackText = "Data saved";
      }
    },
    saveBulkHSN: function saveBulkHSN() {
      var _this3 = this;

      var productsToUpdate = this.productsByBrand;
      if (isNaN(this.bulkHSN)) {
        return;
      }
      productsToUpdate.map(function (prod) {
        _this3.$root.$firebaseRefs.products.child(prod[".key"]).update({
          HSN_code: _this3.bulkHSN
        });
      });
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Data saved";
    },
    saveBulkSpecialChargePercentage: function saveBulkSpecialChargePercentage() {
      var _this4 = this;

      var productsToUpdate = this.productsByBrand;
      if (isNaN(this.bulkSpecialChargePercentage)) {
        return;
      }
      productsToUpdate.map(function (prod) {
        _this4.$root.$firebaseRefs.products.child(prod[".key"]).update({
          specialChargePercentage: _this4.bulkSpecialChargePercentage
        });
      });
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Data saved";
    },
    saveSellingRate: function saveSellingRate(data) {
      if (isNaN(data.sellingPrice)) {
        return;
      }
      if (data[".key"]) {
        //Update
        this.$root.$firebaseRefs.products.child(data[".key"]).update({
          sellingPrice: data.sellingPrice
        });
      }
      this.snack = true;
      this.snackColor = "success";
      this.snackText = "Data saved";
    },
    cancelRateSave: function cancelRateSave() {
      this.snack = true;
      this.snackColor = "error";
      this.snackText = "Canceled";
    },
    openRateSave: function openRateSave() {
      this.snack = true;
      this.snackColor = "info";
      this.snackText = "Dialog opened";
    },
    closeRateSave: function closeRateSave() {}
  }
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_int__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils___ = __webpack_require__(47);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];

var brand = window.localStorage.getItem('brand');
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AlertSidebar',
  data: function data() {
    return {
      dialogOpen: false,
      dialogDetail: null,
      firms: {},
      buyerById: {},
      invoices: []
    };
  },

  props: {
    alertMode: Boolean
  },
  created: function created() {
    // this.$bindAsArray(
    //   'invoices',
    //   this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(brand)
    // )
    this.$bindAsObject('buyerById', this.$root.$firebaseRefs.buyer);
    this.$bindAsObject('sellerById', this.$root.$firebaseRefs.seller);
    this.$bindAsObject('firms', this.$root.$firebaseRefs.firm), this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(brand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand', 'finYear']), {
    filteredAlerts: function filteredAlerts() {
      var _this = this;

      if (!this.invoices) {
        return [];
      }
      var alertItems = [];

      this.invoices.forEach(function (item) {
        if (item.brand !== _this.selectedBrand) {
          return null;
        }
        if (item.status === 'paid' || !item.duration || !item.date) {
          return null;
        }

        var invoice = item;
        // calculate value details
        var dt1 = new Date(invoice.date);
        var dt2 = new Date();
        var daysSpent = Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24));

        if (invoice.date) {
          invoice.dateA = dt1.toLocaleDateString('en-GB');
        }
        var daysLeft = invoice.duration - daysSpent;

        if (daysLeft <= -5 || daysLeft >= 5) {
          return null;
        }
        // Set Item as AlertList 
        invoice.daysLeft = daysLeft;
        invoice.daysSpent = daysSpent;

        // set buyer info
        var buyer = _this.buyerById[invoice.buyerId] || _this.sellerById[invoice.buyerId] || {};
        invoice.buyerName = buyer.name;
        invoice.propName = buyer.propName;
        invoice.village = buyer.village;
        invoice.block = buyer.block;
        invoice.tehsil = buyer.tehsil;
        invoice.district = buyer.district;
        invoice.mobile = buyer.mobile;

        if (invoice.firm) {
          var firm = _this.firms[invoice.firm];
          invoice.firmName = firm && firm.name;
        }
        alertItems.push(item);
      });
      return alertItems;
    },
    filteredProducts: function filteredProducts() {
      var _this2 = this;

      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var products = this.products.filter(function (item) {
        return item['brand'] === _this2.selectedBrand;
      });
      var total = {
        quantity: 0,
        durationQuantity: 0,
        durationAmount: 0,
        saleQuantity: 0,
        durationQtySale: 0,
        durationAmountSale: 0,
        purchaseQuantity: 0,
        durationQtyPurchase: 0,
        durationAmountPurchase: 0,
        openingQuantity: 0,
        openingBalance: 0
      };
      products.map(function (p) {
        p["durationQuantity"] = undefined;
        p["durationAmount"] = 0;
        p["durationQtySale"] = 0;
        p["durationQtyPurchase"] = 0;
        p["durationAmountSale"] = 0;
        p["durationAmountPurchase"] = 0;
        p["stockReportData"] = {
          saleDetails: [],
          purchaseDetails: [],
          lastSalePrice: 0,
          lastPurchasePrice: 0
        };
        if (p.openingBalance && p.openingQuantity) {
          p["stockReportData"]['purchaseDetails'].push({
            // quantity : Number.parseFloat(p.openingQuantity),
            // rate : Number.parseInt(p.openingBalance),
            quantity: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_int___default()(p.openingQuantity),
            rate: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(p.openingBalance) / __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_int___default()(p.openingQuantity),
            date: p.openingDate
          });
          p["stockReportData"]['lastPurchasePrice'] = p.openingBalance;
        }
        total.openingQuantity += parseInt(p["openingQuantity"] ? p["openingQuantity"] : 0);
        total.openingBalance += __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(p["openingBalance"] ? p["openingBalance"] : 0);
      });
      var productGroup = products.reduce(function (r, a) {
        r[a[".key"]] = r[a[".key"]] || [];
        r[a[".key"]].push(a);
        return r;
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default()(null));
      var latestSaleDate = new Date('01-01-1000').getTime();
      var latestPurchaseDate = new Date('01-01-1000').getTime();
      var filteredInvoices = this.invoices.filter(function (item) {
        return item.type != "automatic invoice" && item.items && item.items.length && item.date >= _this2.finYear.start && item.deleted != true && item.date <= _this2.finYear.end && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true);
      });
      this.selectProdList = [];
      filteredInvoices.map(function (invoice) {
        var isBuyer = invoice.isBuyer;
        invoice.items && invoice.items.map(function (item) {
          if (productGroup[item["productId"]]) {
            if (productGroup[item["productId"]][0].durationQuantity != undefined) {
              var durationQuantity = parseInt(productGroup[item["productId"]][0]["durationQuantity"]);
              durationQuantity += !!isBuyer ? -parseInt(item.quantity) : parseInt(item.quantity);
              total.durationQuantity += durationQuantity;
              productGroup[item["productId"]][0]["durationQuantity"] = durationQuantity;
            } else {
              productGroup[item["productId"]][0]["durationQuantity"] = productGroup[item["productId"]][0].openingQuantity ? productGroup[item["productId"]][0].openingQuantity : 0;
              total.durationQuantity += parseInt(productGroup[item["productId"]][0]["durationQuantity"]);
            }
            var rate = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item.rate);
            if (isBuyer) {
              if (invoice.date > latestSaleDate) {
                latestSaleDate = invoice.date;
                productGroup[item["productId"]][0]['stockReportData']['lastSalePrice'] = rate;
              }
              productGroup[item["productId"]][0]['stockReportData']['saleDetails'].push({
                quantity: item.quantity,
                rate: rate,
                date: invoice.date
              });
            } else {
              if (invoice.date > latestPurchaseDate) {
                latestPurchaseDate = invoice.date;
                productGroup[item["productId"]][0]['stockReportData']['lastPurchasePrice'] = rate;
              }
              productGroup[item["productId"]][0]['stockReportData']['purchaseDetails'].push({
                quantity: item.quantity,
                rate: rate,
                date: invoice.date
              });
            }
            productGroup[item["productId"]][0]["durationAmount"] += !!isBuyer ? -__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item.GSTValue) : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
            total.durationAmount += productGroup[item["productId"]][0]["durationAmount"];
            if (!!isBuyer) {
              productGroup[item["productId"]][0]["durationQtySale"] += parseInt(item.quantity);
              total.durationQtySale += parseInt(item.quantity);
              productGroup[item["productId"]][0]["durationAmountSale"] += __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
              total.durationAmountSale += __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
            } else {
              productGroup[item["productId"]][0]["durationQtyPurchase"] += parseInt(item.quantity);
              total.durationQtyPurchase += parseInt(item.quantity);
              productGroup[item["productId"]][0]["durationAmountPurchase"] += __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
              total.durationAmountPurchase += __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
            }
            item['date'] = invoice.date;
            item['invoice'] = invoice;
            item['isBuyer'] = invoice['isBuyer'];
            item['openingBalance'] = productGroup[item["productId"]][0]['openingBalance'];
            item['openingQuantity'] = productGroup[item["productId"]][0]['openingQuantity'];
            if (!(productGroup[item["productId"]][0]['productList'] && productGroup[item["productId"]][0]['productList'].length)) productGroup[item["productId"]][0]['productList'] = [];

            productGroup[item["productId"]][0]['productList'].push(item);
          }
        });
      });
      var results = [];
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(productGroup).length && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(productGroup).map(function (key, index) {
        productGroup[key][".key"] = key;
        results.push(productGroup[key][0]);
        productGroup[key][0]['closingQty'] = _this2.getClosingQtyt(productGroup[key][0]);
      });
      return results;
    }
  }),
  methods: {
    getClosingQtyt: function getClosingQtyt(item) {
      var closingQty = parseInt(item['openingQuantity'] ? item['openingQuantity'] : 0) + parseInt(item['durationQtyPurchase'] ? item['durationQtyPurchase'] : 0) - parseInt(item['durationQtySale'] ? item['durationQtySale'] : 0);

      return closingQty;
    },
    generateAddress: function generateAddress(user) {
      var address = '';
      if (user.block) {
        address = '' + user.block;
      }
      if (user.village) {
        address = '' + (address ? address + ', ' : '') + user.village;
      }
      if (user.tehsil) {
        address = '' + (address ? address + ', ' : '') + user.tehsil;
      }
      if (user.state) {
        address = '' + (address ? address + ', ' : '') + user.state;
      }
      return address;
    },
    getGSTtotal: function getGSTtotal(item) {
      var GSTTotal = 0;
      item && item.items && item.items.map(function (item) {
        GSTTotal += __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
      });
      return GSTTotal;
    }
  }
});

/***/ }),
/* 291 */,
/* 292 */,
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_firebase_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// const mapGlobalGetters = createNamespacedHelpers('Global')['mapGetters']
var mapGlobalActions = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])('Global')['mapActions'];

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      message: null,
      isValid: true,
      snackbar: false,
      show1: false,
      timeout: 1000,
      email: '',
      emailRules: [function (v) {
        return !!v || 'E-mail is required';
      }, function (v) {
        return (/.+@.+/.test(v) || 'E-mail must be valid'
        );
      }],
      password: '',
      passwordRules: [function (v) {
        return !!v || 'Password is required';
      }, function (v) {
        return v && v.length >= 8 || 'Password must be Greater or equal to than 8 characters';
      }]
    };
    checkbox: false;
  },
  created: function created() {
    this.$bindAsArray('operators', this.$root.$firebaseRefs.operator);
    this.$bindAsObject('brands', this.$root.$firebaseRefs.brand);
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalActions('SET_SELECTED_BRAND', 'SET_BRANDS'), {
    isVerified: function isVerified() {
      if (!this.password || !this.email) {
        this.message = 'Wrong Input';
        return false;
      }
      return true;
    },
    signIn: function signIn() {
      var _this = this;

      if (!this.isVerified()) {
        this.snackbar = true;
        return;
      }
      __WEBPACK_IMPORTED_MODULE_1__services_firebase_js__["a" /* cfirebase */].auth().setPersistence(__WEBPACK_IMPORTED_MODULE_1__services_firebase_js__["a" /* cfirebase */].auth.Auth.Persistence.LOCAL).then(function () {
        return __WEBPACK_IMPORTED_MODULE_1__services_firebase_js__["a" /* cfirebase */].auth().signInWithEmailAndPassword(_this.email, _this.password).then(function (userData) {
          _this.onSignedIn(userData);
          return userData;
        }).catch(function (error) {
          _this.message = error.message;
          _this.snackbar = true;
        });
      }).catch(function (error) {
        _this.message = error.message;
        _this.snackbar = true;
      });
    },
    onSignedIn: function onSignedIn(userData) {
      // Set the token and brand details in localstorage
      // let uid = userData.user.uid
      // console.log(userData)
      // // Object.keys(this.operators).filter
      // const userDetail = this.operators.filter((item) => {
      //   return item.uid === uid
      // })

      // console.log(userDetail)

      // if (!userDetail.length) {
      //   this.message = 'No Brands Assigned'
      //   this.snackbar = true
      //   cfirebase.auth().signOut()
      // }

      // if (userDetail[0].brands.length) {
      //   this.SET_BRANDS(this.brands)
      //   this.SET_SELECTED_BRAND(this.userDetail.brands[0])
      // } else {
      //   this.message = 'No Brands Assigned'
      //   this.snackbar = true
      //   cfirebase.auth().signOut()
      //   return
      // }
      var uid = userData.user.uid;
      // let ref = cfirebase.database().ref('/operators')
      // ref.orderByChild("uid").equalTo(uid).on("value",(snapshot)=>{        
      //     console.log(snapshot.val());
      // })

      if (__WEBPACK_IMPORTED_MODULE_1__services_firebase_js__["a" /* cfirebase */].auth().currentUser.emailVerified) {
        var userDetail = this.operators.filter(function (item) {
          return item.uid === uid;
        })[0];
        __WEBPACK_IMPORTED_MODULE_1__services_firebase_js__["a" /* cfirebase */].auth().onAuthStateChanged(function (user) {
          if (user) {
            user.updateProfile({
              displayName: userDetail.brand
            }).then(function () {
              console.log(success);
            }, function (error) {
              console.log(error);
            });
          }
        });
        if (userDetail.isActive != undefined && userDetail.isActive == false) {
          this.message = 'Your account is not active.';
          __WEBPACK_IMPORTED_MODULE_1__services_firebase_js__["a" /* cfirebase */].auth().signOut();
          this.snackbar = true;
        } else {
          this.message = 'Sign In Successful';
          this.snackbar = true;
          // this.$router.go('/')
          this.$router.go('/');
        }
      } else {

        if (confirm("Your Email is not verified. Do you want to receive verification mail again?")) {
          __WEBPACK_IMPORTED_MODULE_1__services_firebase_js__["a" /* cfirebase */].auth().currentUser.sendEmailVerification();
          this.message = 'Verification Email sent.';
        } else {
          this.message = 'Please verify your Email.';
        }
        __WEBPACK_IMPORTED_MODULE_1__services_firebase_js__["a" /* cfirebase */].auth().signOut();
        this.snackbar = true;
      }
    }
  })
});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_firebase_js__ = __webpack_require__(37);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      message: null,
      isValid: true,
      snackbar: false,
      timeout: 5000,
      brand: '',
      zipCode: null,
      nameRules: [function (v) {
        return !!v || 'Brand Name is required';
      }, function (v) {
        return v && v.length <= 50 || 'Name must be less than 50 characters';
      }],
      email: '',
      emailRules: [function (v) {
        return !!v || 'E-mail is required';
      }, function (v) {
        return (/.+@.+/.test(v) || 'E-mail must be valid'
        );
      }],
      password: '',
      rePassword: '',
      passwordRules: [function (v) {
        return !!v || 'Password is required';
      }, function (v) {
        return v && v.length >= 8 || 'Password must be Greater or equal to than 8 characters';
      }],
      liveLocation: '',
      liveLocationRules: [function (v) {
        return !!v || 'Live Location is required';
      }],
      mobile: {
        value: "",
        rules: [function (v) {
          return (/^$/.test(v) || /^(\+91|\+91\-|0)?[6789]\d{9}$/.test(v) || "Mobile number is wrong"
          );
        }]
      },
      // financialYear: {
      //   value: ""
      // },
      // identityType: {
      //   value: ""
      // },
      casteType: {
        value: ""
      },
      village: {
        value: "",
        rules: [function (v) {
          if (_this.liveLocation != 'village') return !!v || 'Village is required';else return true;
        }]
      },
      block: {
        value: ""
      },
      tehsil: {
        value: ""
      },
      district: {
        value: ""
      },
      state: {
        value: ""
      },
      country: {
        value: ""
      },
      select: null,
      items: ['TRAIL PERIOD', '700/MONTH', '1800/QUATERLY', '3000/MONTH', '5000/YEAR'],
      planDetails: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand"]), mapGlobalGetters({
    gVillage: "village",
    gBlock: "block",
    gTehsil: "tehsil",
    gDistrict: "district",
    gState: "state",
    gCountry: "country",
    // gFinancialYear: "financialYear",
    // gIdentityType: "identityType",
    gCasteType: "casteType",
    brandPackageTypes: "brandPackageTypes"
  })),
  watch: {
    liveLocation: function liveLocation(val, newVal) {
      switch (newVal) {
        case 'village':
          {
            if (['block', 'tehsil', 'district', ''].includes(this.liveLocation)) {
              this.village.value = '';
            }
            break;
          }

        case 'block':
          {
            if (['tehsil', 'district', ''].includes(this.liveLocation)) {
              this.block.value = '';
            }
            break;
          }

        case 'tehsil':
          {
            if (['district', ''].includes(this.liveLocation)) {
              this.tehsil.value = '';
            }
            break;
          }
      }
    }
  },
  created: function created() {
    this.$bindAsObject('brands', this.$root.$firebaseRefs.brand);
    this.$bindAsObject('operators', this.$root.$firebaseRefs.operator);
  },
  destroyed: function destroyed() {
    // this.$unbind('brands')
    // this.$unbind('operators')
  },

  methods: {
    setLocationBasedOnZipCode: function setLocationBasedOnZipCode() {
      var _this2 = this;

      var reg = /^[1-9][0-9]{5}$/;
      console.log(this.zipCode);
      if (this.zipCode && reg.test(this.zipCode)) {
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://api.postalpincode.in/pincode/' + this.zipCode).then(function (response) {
          var data = response.data[0].PostOffice[0];
          _this2.gCountry.push(data.Country);
          _this2.gState.push(data.State);
          _this2.gDistrict.push(data.District);
          _this2.gTehsil.push(data.Block);
          setTimeout(function () {
            _this2.country.value = data.Country;
            _this2.district.value = data.District;
            _this2.state.value = data.State;
            _this2.tehsil.value = data.Block;
          }, 100);
        });
      }
    },
    isDisabled: function isDisabled(type) {
      switch (type) {
        case 'village':
          {
            if (['block', 'tehsil', 'district', ''].includes(this.liveLocation)) {
              return true;
            }
            return false;
            break;
          }

        case 'block':
          {
            if (['tehsil', 'district', ''].includes(this.liveLocation)) {
              return true;
            }
            return false;
            break;
          }

        case 'tehsil':
          {
            if (['district', ''].includes(this.liveLocation)) {
              return true;
            }
            return false;
            break;
          }
      }
    },
    isVerified: function isVerified() {
      if (this.password !== this.rePassword) {
        this.message = 'Password didn\'t match';
        return false;
      }
      if (!this.password || !this.brand || !this.email) {
        this.message = 'Wrong Input';
        return false;
      }
      if (this.isBrandExist(this.brand)) {
        this.message = 'Brand name already taken';
        return false;
      }
      return true;
    },
    isBrandExist: function isBrandExist(brand) {
      var _this3 = this;

      var objects = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.brands).filter(function (key) {
        return _this3.brands[key] === brand;
      });
      if (objects.length) {
        return true;
      }
      return false;
    },

    // signUp () {
    //   if (!this.isVerified()) {
    //     this.snackbar = true
    //     return
    //   }
    //   cfirebase.auth().createUserWithEmailAndPassword(this.email, this.password)
    //     .then(data => {
    //       console.log(data)
    //       this.message = 'SignUp Successful'
    //       this.snackbar = true

    //       let brandKey = this.addNewBrand(this.brand)
    //       this.addNewUser(data.user.uid, brandKey)
    //       this.addPlanDetails(brandKey)
    //       this.sendEmailVerification()
    //       this.$router.push('/login')
    //     })
    //     .catch(error => {
    //       this.message = error.message
    //       this.snackbar = true
    //       // Handle Errors here.
    //       var errorCode = error.code
    //       var errorMessage = error.message
    //       console.log(errorCode, errorMessage)
    //     })
    // },
    addNewBrand: function addNewBrand(brand) {
      var createdBrand = this.$root.$firebaseRefs.brand.push(brand);
      console.log('createdBrand', createdBrand);
      return createdBrand['key'];
    },
    addNewUser: function addNewUser(uid, brandKey) {
      this.$root.$firebaseRefs.operator.push({ uid: uid, brand: brandKey, role: 'admin',
        superAdmin: true,
        email: this.email,
        notificationWSAPP: true,
        village: this.village.value,
        block: this.block.value,
        tehsil: this.tehsil.value,
        district: this.district.value,
        state: this.state.value,
        country: this.country.value,
        casteType: this.casteType.value,
        zipCode: this.zipCode,
        mobile: this.mobile.value
      });
    },
    addPlanDetails: function addPlanDetails(brandKey) {
      var brandPermission = {
        active: true,
        plan: this.planDetails,
        permissions: [],
        brand: brandKey
      };
      this.$root.$firebaseRefs.brandPermission.push(brandPermission);
    },
    sendEmailVerification: function sendEmailVerification() {
      __WEBPACK_IMPORTED_MODULE_4__services_firebase_js__["a" /* cfirebase */].auth().currentUser.sendEmailVerification();
    }
  }
});

/***/ }),
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_firebase_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// const mapGlobalGetters = createNamespacedHelpers('Global')['mapGetters']
var mapGlobalActions = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])('Global')['mapActions'];

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      message: null,
      resetSuccess: false,
      snackbar: false,
      timeout: 5000,
      email: '',
      emailRules: [function (v) {
        return !!v || 'E-mail is required';
      }, function (v) {
        return (/.+@.+/.test(v) || 'E-mail must be valid'
        );
      }]
    };
  },
  created: function created() {
    this.$bindAsArray('operators', this.$root.$firebaseRefs.operator);
    this.$bindAsObject('brands', this.$root.$firebaseRefs.brand);
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalActions('SET_SELECTED_BRAND', 'SET_BRANDS'), {
    isVerified: function isVerified() {
      if (!this.email) {
        this.message = 'Wrong Input';
        return false;
      }
      return true;
    },
    sendVerificationLink: function sendVerificationLink() {
      var _this = this;

      if (!this.isVerified()) {
        this.snackbar = true;
        return;
      }
      __WEBPACK_IMPORTED_MODULE_1__services_firebase_js__["a" /* cfirebase */].auth().sendPasswordResetEmail(this.email).then(function () {
        _this.resetSuccess = true;
        // Email sent.
      }).catch(function (error) {
        console.log("err");
        console.log(error);
        // An error happened.
      });
    }
  })
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {},
  components: {},
  data: function data() {
    return {};
  },
  created: function created() {},
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},

  computed: {},
  watch: {},
  methods: {}
});

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_pdf_reports_dashboard_reports__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_pdfmake__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__i18n__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils___ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_apexcharts__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_apexcharts__);










//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import { convertToPDFSaleReport } from "../../utils/pdf-reports/dashboard-reports";




var brand = window.localStorage.getItem('brand');
//let brandFinYear = window.localStorage.getItem('brandFinYear')
var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    apexchart: __WEBPACK_IMPORTED_MODULE_15_vue_apexcharts___default.a
  },
  data: function data() {
    var _this = this,
        _ref;

    return _ref = {
      topCustomerFilter: 'All',
      tradeOptions: {
        chart: {
          id: "vuechart-trade",
          events: {
            click: function click(event, chartContext, config) {
              var index = config.dataPointIndex;
              var month = index + (index < 8 ? 3 : -9);
              if (config.seriesIndex) {
                _this.$router.push({ path: "/purchase-register/" + month + "/0" });
              } else {
                _this.$router.push({ path: "/sale-register/" + month + "/0" });
              }
            }
          }
        },
        xaxis: {
          categories: ["April", "May", "June", "July", "August", "September", "October", "November", "December", "January", "February", "March"]
        }
      },
      tab: null,
      tradeData: [{
        name: "Sale",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      }, {
        name: "Purchase",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      }],
      volumeOptionsDaily: {
        chart: {
          id: "vuechart-daily",
          events: {
            click: function click(event, chartContext, config) {
              var date = config.dataPointIndex;
              var index = new Date().getMonth();
              if (config.seriesIndex) {
                _this.$router.push({ path: "/purchase-register/" + index + "/" + (date + 1) });
              } else {
                _this.$router.push({ path: "/sale-register/" + index + "/" + (date + 1) });
              }
            }
          }
        },
        xaxis: {
          categories: []
        }
      },
      volumeDataDaily: [{
        name: "sale",
        data: []
      }, {
        name: "Purchase",
        data: []
      }],
      volumeOptions: {
        chart: {
          id: "vuechart-volume"
        },
        xaxis: {
          categories: ["April", "May", "June", "July", "August", "September", "October", "November", "December", "January", "February", "March"]
        }
      },
      volumeData: [{
        name: "sale",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      }, {
        name: "Purchase",
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      }],
      cards1: [{
        title: "Customer",
        buyerCount: 0,
        sellerCount: 0
      }, {
        title: "Sales",
        value: 0,
        amount: 0
      }, {
        title: "Purchase",
        value: 0,
        amount: 0
      }, {
        title: "Stock",
        measure: 0.0,
        aggregate: 0.0
      }],
      cards2: [{
        title: "Profit",
        value: 0.0,
        amount: 0.0
      }, {
        title: "Credit Note",
        amount: 0.0,
        count: 0
      }, {
        title: "Debit Note",
        amount: 0.0,
        count: 0
      }],
      topProdHead: [{ text: "Product Name", value: "Product Name", sortable: false }, { text: "Units", value: "Units", sortable: false }, { text: "Quantity", value: "quantity", sortable: true }, { text: "Sold duration", value: "Amount", sortable: false
        // { text: "Amount", value: "Amount", sortable: false }
      }],
      topCustHead: [{ text: "Person Name", value: "name", sortable: true }, { text: "Total Amount", value: "totalAmount", sortable: true }, { text: "Paid Amount", value: "paidAmount", sortable: true }, { text: "Remaining Amount", value: "remainingAmount", sortable: true }],
      buyerHeader: [
      // { text: "Buyer - ID", value: "Buyer - ID" },
      { text: "Name", value: "Name" }, { text: "Prop Name", value: "Father Name" }, { text: "Address", value: "localAddress" },
      // { text: "Village", value: "Village" },
      // { text: "Block", value: "Block" },
      { text: "Tehsil", value: "Tehsil" }, { text: "District", value: "District" }, { text: "Mobile", value: "Mobile" }, { text: "Identity Type", value: "Identity Type" }, { text: "Identity Number", value: "Identity Number" }],
      invoiceHeader: [{ text: "Date", value: "date", sortable: true }, { text: "Action", value: "action" },
      // { text: "Invoice - Key", value: "Name" },
      { text: "Buyer Name", value: "Father Name" }, { text: "Invoice No", value: "invoiceId", sortable: true }, { text: "Total Amount", value: "totalCurrentAmount" }, { text: "Basic Amount", value: "basic amount" }, { text: "GST", value: "GST" }, { text: "Discount", value: "discount" }, { text: "Deposited Amount", value: "Tehsil" }, { text: "Remaining Amount", value: "District" }, { text: "Duration (in Days)", value: "abs" }, { text: "Payment Type", value: "Identity Number" }, { text: "Status", value: "Mobile" },
      // { text: "Transaction Type", sortable: true, value: "paymentType" },
      { text: "GST Type", sortable: true, value: "gstType" }, { text: "IGST Value", sortable: true, value: "gstType" }, { text: "SGST Value", sortable: true, value: "gstType" }, { text: "CGST Value", sortable: true, value: "gstType" }, { text: "GST (0%)", sortable: true, value: "gstType" }, { text: "GST (5%)", sortable: true, value: "gstType" }, { text: "GST (12%)", sortable: true, value: "gstType" }, { text: "GST (18%)", sortable: true, value: "gstType" }, { text: "GST (28%)", sortable: true, value: "gstType" }, { text: "Admin email", sortable: true, value: "gstType" }, { text: "Firm Name", value: "Village" }],
      profitHeader: [{ text: "Date", value: "date", sortable: true }, { text: "Invoice - No", value: "Name" }, { text: "Firm Name", value: "Father Name" }, { text: "Rate of Interest", value: "Village" }, { text: "Principal Value", value: "Block" }, { text: "Interest Value", value: "Tehsil" }, { text: "Total Value", value: "District" }, { text: "Payment Type", value: "Identity Type" }],
      firmHeader: [{ text: "Date", value: "date", sortable: true }, { text: "Firm Name", value: "Name" }, { text: "Customer Name", value: "customerName" }, { text: "Invoice No", value: "Father Name" }, { text: "Debit", value: "Tehsil" }, { text: "Credit", value: "District" }, { text: "Payment Type", value: "paymentType" }, { text: "Status", value: "identityType" }, { text: "Vocher", value: "Vocher Type" }, { text: "Remark", value: "remark" }],
      bankHeader: [{ text: "Date", value: "date", sortable: true }, { text: "Firm Name", value: "Name" },
      // { text: "Transaction -ID", value: "Father Name" },
      { text: "Debit", value: "Tehsil" }, { text: "Credit", value: "District" }, { text: "Transaction Type", value: "Village" }, { text: "Remark", value: "Identity Type" }],
      expenseHeader: [{ text: "Date", value: "date", sortable: true }, { text: "Invoice ID", value: "Name" }, { text: "Firm Name", value: "Father Name" }, { text: "Payment Type", value: "Village" }, { text: "Amount", value: "Block" }, { text: "Remark", value: "Identity Type" }],
      incomeAccHeader: [{ text: "Date", value: "date", sortable: true }, { text: "Invoice ID", value: "Name" }, { text: "Firm Name", value: "Father Name" }, { text: "Payment Type", value: "Village" }, { text: "Amount", value: "Block" }, { text: "Remark", value: "Tehsil" }],
      salaryHeader: [{ text: "Date", value: "date", sortable: true }, { text: "Invoice ID", value: "Name" }, { text: "Firm Name", value: "Father Name" }, { text: "Payment Type", value: "Village" }, { text: "Debit", value: "Tehsil" }, { text: "Credit", value: "District" }, { text: "Remark", value: "Tehsil" }],
      assetHeader: [{ text: "Date", value: "date", sortable: true }, { text: "Invoice ID", value: "Name" }, { text: "Firm Name", value: "Father Name" }, { text: "Payment Type", value: "Village" }, { text: "Debit", value: "Tehsil" }, { text: "Credit", value: "District" }, { text: "Remark", value: "Tehsil" }],
      invoiceProductListHeader: [{ text: "Name", value: "Name", class: "font-weight-bold primary--text" }, { text: "HSN code", value: "HSN", class: "font-weight-bold primary--text" }, { text: "Taxable rate", value: "Taxable", class: "font-weight-bold primary--text" }, { text: "Unit", value: "Unit", class: "font-weight-bold primary--text" }, { text: "Quantity", value: "quantity", class: "font-weight-bold primary--text" }, { text: "Rate", value: "rate", class: "font-weight-bold primary--text" }],
      totalclosingStock: 0,
      selectedInvoice: {},
      firms: [],
      datepickerFrom: false,
      datepickerFrom2: false,
      datepickerFrom3: false,
      datepickerFrom4: false,
      datepickerFrom5: false,
      datepickerFrom6: false,
      datepickerTo: false,
      datepickerTo2: false,
      datepickerTo3: false,
      datepickerTo4: false,
      datepickerTo5: false,
      datepickerTo6: false,
      isFilter: false,
      toDate: null,
      fromDate: null,
      buyers: [],
      items: [],
      invoices: [],
      totalSales: 0,
      totalPurchase: 0,
      totalCreditNote: 0,
      totalDebitNote: 0,
      credited: 0.0,
      debited: 0.0,
      itemsInStock: 0,
      dialog: false,
      dialog1: false,
      dialog11: false,
      currentTitle: null,
      searchInput: null,
      expenseDialog: false,
      currentExpense: null,
      selectedFirm: null,
      totalExpenseAmount: 0.0,
      incomeDialog: false,
      accountDialog: false,
      staffDialog: false,
      assetDialog: false,
      firmDialog: false,
      currentIncome: null,
      currentStaff: null,
      currentAsset: null,
      currentFirm: null,
      currentAccountNumber: null,
      amount: 0.0,
      totalIncomeAmount: 0.0,
      totalStaffAmount: 0.0,
      totalAssetAmount: 0.0
    }, __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_ref, "currentAccountNumber", ""), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_ref, "currentAccountKey", ""), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_ref, "currentFirm", ""), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_ref, "assetRate", []), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_ref, "debitNoteCount", 0), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_ref, "creditNoteCount", 0), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_ref, "topCustomers", []), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_ref, "Sec3DetailsDialog", false), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_ref, "Sec3Type", null), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_ref, "bookExpansion", false), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_ref, "gstrExpansion", false), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_ref, "otherAcctExpansion", false), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_ref, "depositExpansion", false), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_ref, "search", null), __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_defineProperty___default()(_ref, "searchCustomer", null), _ref;
  },
  created: function created() {
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(brand));
    this.$bindAsArray("accounts", this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(brand));
    this.$bindAsArray("buyers", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(brand));
    this.$bindAsArray("sellers", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(brand));
    this.$bindAsObject("buyerById", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(brand));
    this.$bindAsObject("sellerById", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(brand));
    this.$bindAsArray("items", this.$root.$firebaseRefs.item.orderByChild('brand').equalTo(brand));
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(brand));
    this.$bindAsArray("expenses", this.$root.$firebaseRefs.expenses.orderByChild('brand').equalTo(brand));
    this.$bindAsArray("liabilities", this.$root.$firebaseRefs.liabilities.orderByChild('brand').equalTo(brand));
    this.$bindAsArray("incomes", this.$root.$firebaseRefs.incomes.orderByChild('brand').equalTo(brand));
    this.$bindAsArray("staffs", this.$root.$firebaseRefs.staff.orderByChild('brand').equalTo(brand));
    this.$bindAsArray("assets", this.$root.$firebaseRefs.assets.orderByChild('brand').equalTo(brand));
    this.$bindAsArray("assetRate", this.$root.$firebaseRefs.rate.orderByChild('brand').equalTo(brand));
    this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(brand));
    this.$bindAsArray("termsAndConditions", this.$root.$firebaseRefs.termsAndConditions.orderByChild('brand').equalTo(brand));
    this.$bindAsArray("firmSettings", this.$root.$firebaseRefs.firmSettings.orderByChild('brand').equalTo(brand));
    var today = new Date();
    this.date = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
    // this.fromDate = `${today.getFullYear()}-${today.getMonth()+1}-${today.getDate()}`
    // this.toDate = `${today.getFullYear()}-${today.getMonth()+1}-${today.getDate()}`  
  },
  mounted: function mounted() {
    this.updateWidgets();
    this._keyListener = function (e) {
      if (event.altKey && event.key === 'F1') {
        e.preventDefault();
        console.log('Sale Register [Reports]');
        this.$router.push({ path: "/sale-register" });
      } else if (event.altKey && event.key === 'F2') {
        e.preventDefault();
        console.log('Purchase Register [Reports]');
        this.$router.push({ path: "/purchase-register" });
      } else if (event.altKey && event.key === 'F3') {
        e.preventDefault();
        console.log('Stock Register [Reports]');
        this.$router.push({ path: "/reports/stock" });
      } else if (event.altKey && event.key == 'F5') {
        e.preventDefault();
        this.$router.push({ path: "/informations/bsheet" });
        console.log('Balance Sheet');
      } else if (event.altKey && event.key == 'F6') {
        e.preventDefault();
        this.$router.push({ path: "/informations/tradingaccount" });
        console.log('Trading account');
      } else if (event.altKey && event.key == 'F7') {
        e.preventDefault();
        this.$router.push({ path: "/informations/profitandloss" });
        console.log('Profit and loss Account');
      } else if (event.altKey && event.key == 'F8') {
        e.preventDefault();
        this.$router.push({ path: "/informations/proprietor" });
        console.log('Capital Account');
      } else if (event.altKey && event.key == 'F9') {
        e.preventDefault();
        this.$router.push({ path: "/informations/trail-balance-accounts" });
        console.log('Trail Balance');
      } else if (event.altKey && event.key == 'F10') {
        e.preventDefault();
        this.$router.push({ path: "/informations/cashaccount" });
        console.log('Cash Book');
      } else if (event.altKey && event.key === '1') {
        e.preventDefault();
        console.log('GSTR 1');
        this.$router.push({ path: "/gst1-reports" });
      } else if (event.altKey && event.key === '3') {
        e.preventDefault();
        console.log('GSTR 3');
        this.$router.push({ path: "/gst3-reports" });
      } else if (event.altKey && event.key == 'a') {
        e.preventDefault();
        this.$router.push({ path: "/Dashboard" });
        console.log('Dashboard');
      } else if (event.altKey && event.key == 'b') {
        e.preventDefault();
        this.$router.push({ path: "/buyers" });
        console.log('Buyers');
      } else if (event.altKey && event.key == 'c') {
        e.preventDefault();
        this.$router.push({ path: "/informations/collection-book" });
        console.log('Collection Book');
      } else if (event.altKey && event.key == 'd') {
        e.preventDefault();
        this.$router.push({ path: "/daily-transaction-book" });
        console.log('Day Book');
      } else if (event.altKey && event.key == 'e') {
        e.preventDefault();
        this.$router.push({ path: "/recordEstimate" });
        console.log('Estimate');
      } else if (event.altKey && event.key == 'f') {
        e.preventDefault();
        this.$router.push({ path: "/informations" });
        console.log('financial Reports');
      } else if (event.altKey && event.key == 'g') {
        e.preventDefault();
        this.$router.push({ path: "/godawn" });
        console.log('Godawns');
      } else if (event.altKey && event.key == 'h') {
        e.preventDefault();
        this.$router.push({ path: "/godawn" });
        console.log('Godawns');
      } else if (event.altKey && event.key == 'i') {
        e.preventDefault();
        this.$router.push({ path: "/quick-invoice" });
        console.log('New Invoice');
      } else if (event.altKey && event.key == 'j') {
        e.preventDefault();
        this.$router.push({ path: "/godawn" });
        console.log('Godawns');
      } else if (event.altKey && event.key == 'k') {
        e.preventDefault();
        this.$router.push({ path: "/godawn" });
        console.log('Godawns');
      } else if (event.altKey && event.key == 'l') {
        e.preventDefault();
        this.$router.push({ path: "/godawn" });
        console.log('Godawns');
      } else if (event.altKey && event.key == 'm') {
        e.preventDefault();
        this.$router.push({ path: "/godawn" });
        console.log('Godawns');
      } else if (event.altKey && event.key == 'n') {
        e.preventDefault();
        this.$router.push({ path: "/godawn" });
        console.log('Godawns');
      } else if (event.altKey && event.key == 'o') {
        e.preventDefault();
        this.$router.push({ path: "/recordOrder" });
        console.log('Manage Order');
      } else if (event.altKey && event.key == 'p') {
        e.preventDefault();
        this.$router.push({ path: "/products/true" });
        console.log('New Product');
      } else if (event.altKey && event.key == 'q') {
        e.preventDefault();
        this.$router.push({ path: "/quick-invoice" });
        console.log(' Quick Invoice ');
      } else if (event.altKey && event.key == 'r') {
        e.preventDefault();
        this.$router.push({ path: "/customer-payments/null" });
        console.log('Payments');
      } else if (event.altKey && event.key == 's') {
        e.preventDefault();
        this.$router.push({ path: "/settings" });
        console.log('Setting');
      } else if (event.altKey && event.key == 't') {
        e.preventDefault();
        this.$router.push({ path: "/transfer" });
        console.log('Transaction');
      } else if (event.altKey && event.key == 'u') {
        e.preventDefault();
        this.$router.push({ path: "/settings/account/true" });
        console.log('New Account');
      } else if (event.altKey && event.key == 'v') {
        e.preventDefault();
        this.$router.push({ path: "/invoicemanagement" });
        console.log('Invoice Management');
      } else if (event.altKey && event.key == 'w') {
        e.preventDefault();
        this.$router.push({ path: "/buyers" });
        console.log('Buyer');
      } else if (event.altKey && event.key == 'x') {
        e.preventDefault();
        this.$router.push({ path: "/invoicemanagement" });
        console.log('Transaction');
      } else if (event.altKey && event.key == 'y') {
        e.preventDefault();
        this.$router.push({ path: "/buyers" });
        console.log('Buyer');
      } else if (event.altKey && event.key == 'z') {
        e.preventDefault();
        this.$router.push({ path: "/reports" });
        console.log('Transaction');
      }
    };
    document.addEventListener('keydown', this._keyListener.bind(this));
  },
  beforeDestroy: function beforeDestroy() {
    document.removeEventListener('keydown', this._keyListener);
  },

  computed: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear", "brandFinYear"]), {
    firmStockReportType: function firmStockReportType() {
      var _this2 = this;

      var val = 'APP';
      if (this.selectedFirm) {
        var dfirmSetting = this.firmSettings.filter(function (item) {
          return item['firm'] == _this2.selectedFirm;
        })[0];
        if (dfirmSetting && dfirmSetting.stockReportView) {
          val = dfirmSetting.stockReportView;
        }
      }
      return val;
    },
    closingStock: function closingStock() {
      var _this3 = this;

      var toDate = this.toDate ? new Date(this.toDate).getTime() : null;
      var fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
      var products = this.products.filter(function (item) {
        return item['brand'] === _this3.selectedBrand && (_this3.selectedFirm ? item['firm'] === _this3.selectedFirm : true);
      });
      var total = {
        quantity: 0,
        durationQuantity: 0,
        durationAmount: 0,
        saleQuantity: 0,
        durationQtySale: 0,
        durationAmountSale: 0,
        purchaseQuantity: 0,
        durationQtyPurchase: 0,
        durationAmountPurchase: 0,
        openingQuantity: 0,
        openingBalance: 0
      };
      products.map(function (p) {
        p["durationQuantity"] = undefined;
        p["durationAmount"] = 0;
        p["durationQtySale"] = 0;
        p["durationQtyPurchase"] = 0;
        p["durationAmountSale"] = 0;
        p["durationAmountPurchase"] = 0;
        p["stockReportData"] = {
          saleDetails: [],
          purchaseDetails: [],
          lastSalePrice: 0,
          lastPurchasePrice: 0
        };
        if (p.openingBalance && p.openingQuantity) {
          p["stockReportData"]['purchaseDetails'].push({
            quantity: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(p.openingQuantity),
            rate: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(p.openingBalance) / __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(p.openingQuantity),
            date: p.openingDate
          });
          p["stockReportData"]['lastPurchasePrice'] = p.openingBalance;
        }
        total.openingQuantity += parseInt(p["openingQuantity"] ? p["openingQuantity"] : 0);
        total.openingBalance += __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(p["openingBalance"] ? p["openingBalance"] : 0);
      });
      var productGroup = products.reduce(function (r, a) {
        r[a[".key"]] = r[a[".key"]] || [];
        r[a[".key"]].push(a);
        return r;
      }, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_create___default()(null));
      var latestSaleDate = new Date('01-01-1000').getTime();
      var latestPurchaseDate = new Date('01-01-1000').getTime();
      var filteredInvoices = this.invoices.filter(function (item) {
        return item.type != "automatic invoice" && item.items && item.items.length && item.date >= _this3.finYear.start && item.deleted != true && item.date <= _this3.finYear.end && (_this3.selectedFirm ? item['firm'] === _this3.selectedFirm : true) && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true);
      });
      this.selectProdList = [];
      filteredInvoices.map(function (invoice) {
        var invoiceMonth = new Date(invoice.date).getMonth();
        var isBuyer = invoice.isBuyer;
        invoice.items && invoice.items.map(function (item) {
          if (productGroup[item["productId"]]) {
            if (productGroup[item["productId"]][0].durationQuantity != undefined) {
              var durationQuantity = parseInt(productGroup[item["productId"]][0]["durationQuantity"]);
              durationQuantity += !!isBuyer ? -parseInt(item.quantity) : parseInt(item.quantity);
              total.durationQuantity += durationQuantity;
              productGroup[item["productId"]][0]["durationQuantity"] = durationQuantity;
            } else {
              productGroup[item["productId"]][0]["durationQuantity"] = productGroup[item["productId"]][0].openingQuantity ? productGroup[item["productId"]][0].openingQuantity : 0;
              total.durationQuantity += parseInt(productGroup[item["productId"]][0]["durationQuantity"]);
            }
            var rate = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item.rate);
            if (isBuyer) {
              if (invoice.date > latestSaleDate) {
                latestSaleDate = invoice.date;
                productGroup[item["productId"]][0]['stockReportData']['lastSalePrice'] = rate;
              }
              productGroup[item["productId"]][0]['stockReportData']['saleDetails'].push({
                quantity: item.quantity,
                rate: rate,
                date: invoice.date
              });
            } else {
              if (invoice.date > latestPurchaseDate) {
                latestPurchaseDate = invoice.date;
                productGroup[item["productId"]][0]['stockReportData']['lastPurchasePrice'] = rate;
              }
              productGroup[item["productId"]][0]['stockReportData']['purchaseDetails'].push({
                quantity: item.quantity,
                rate: rate,
                date: invoice.date
              });
            }

            productGroup[item["productId"]][0]["durationAmount"] += !!isBuyer ? -__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item.GSTValue) : __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
            total.durationAmount += productGroup[item["productId"]][0]["durationAmount"];
            if (!!isBuyer) {
              productGroup[item["productId"]][0]["durationQtySale"] += parseInt(item.quantity);
              total.durationQtySale += parseInt(item.quantity);
              productGroup[item["productId"]][0]["durationAmountSale"] += __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
              total.durationAmountSale += __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
            } else {
              productGroup[item["productId"]][0]["durationQtyPurchase"] += parseInt(item.quantity);
              total.durationQtyPurchase += parseInt(item.quantity);
              productGroup[item["productId"]][0]["durationAmountPurchase"] += __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
              total.durationAmountPurchase += __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
            }
            item['date'] = invoice.date;
            item['invoice'] = invoice;
            item['isBuyer'] = invoice['isBuyer'];
            item['openingBalance'] = productGroup[item["productId"]][0]['openingBalance'];
            item['openingQuantity'] = productGroup[item["productId"]][0]['openingQuantity'];
            if (!(productGroup[item["productId"]][0]['productList'] && productGroup[item["productId"]][0]['productList'].length)) productGroup[item["productId"]][0]['productList'] = [];

            productGroup[item["productId"]][0]['productList'].push(item);
          }
        });
      });
      this.totalclosingStock = 0;
      var results = [];
      var closingStock = 0;
      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(productGroup).length && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(productGroup).map(function (key, index) {
        productGroup[key][".key"] = key;
        results.push(productGroup[key][0]);
        productGroup[key][0]['closingAmount'] = _this3.getClosingAmount(productGroup[key][0]);
        var closingStockVal = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(productGroup[key][0]['closingAmount']);
        closingStock += isNaN(closingStockVal) ? 0 : closingStockVal;
        productGroup[key][0]['closingQuantity'] = parseInt(productGroup[key][0]['openingQuantity'] ? productGroup[key][0]['openingQuantity'] : 0) + parseInt(productGroup[key][0]['durationQtyPurchase'] ? productGroup[key][0]['durationQtyPurchase'] : 0) - parseInt(productGroup[key][0]['durationQtySale'] ? productGroup[key][0]['durationQtySale'] : 0);
        _this3.totalclosingStock += isNaN(productGroup[key][0]['closingQuantity']) ? 0 : productGroup[key][0]['closingQuantity'];
      });
      return closingStock;
    },
    firmsByBrand: function firmsByBrand() {
      var _this4 = this;

      return this.firms.filter(function (item) {
        return item["brand"] === _this4.selectedBrand;
      }).map(function (item) {
        if (item.defaultFirm) {
          _this4.selectedFirm = item['.key'];
        }
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
    },
    itemList: function itemList() {
      var _this5 = this;

      if (this.buyers && this.selectedBrand) {
        // return this.buyers.filter(item => item["brand"] === this.selectedBrand)
        // &&(!!this.search ? !!item["name"].toLowerCase().includes(this.search.toLowerCase()) : true)
        return this.buyers.filter(function (item) {
          return item["brand"] === _this5.selectedBrand && (!!_this5.searchCustomer ? !!item["name"].toLowerCase().includes(_this5.searchCustomer.toLowerCase()) : true);
        });
      }
    },
    getFirms: function getFirms() {
      var _this6 = this;

      if (this.firms && this.selectedBrand) {
        return this.firms.filter(function (item) {
          return item["brand"] === _this6.selectedBrand;
        });
      }
    },
    getFirmSorted: function getFirmSorted() {
      var firms = this.getFirms;
      return firms.sort(function (a, b) {
        var nameA = a.name.toLowerCase(),
            nameB = b.name.toLowerCase();
        if (nameA < nameB) //sort string ascending
          return -1;
        if (nameA > nameB) return 1;
        return 0; //default return value (no sorting)
      });
    },
    getSortedBankAccounts: function getSortedBankAccounts() {
      var _this7 = this;

      if (this.accounts && this.selectedBrand) {
        return this.accounts.filter(function (item) {
          return item["brand"] === _this7.selectedBrand;
        });
      }
    },
    getSorted: function getSorted() {
      var accounts = this.getAccounts;
      return accounts.sort(function (a, b) {
        var nameA = a.name.toLowerCase(),
            nameB = b.name.toLowerCase();
        if (nameA < nameB) //sort string ascending
          return -1;
        if (nameA > nameB) return 1;
        return 0; //default return value (no sorting)
      });
    },
    getLoanAccount: function getLoanAccount() {
      var _this8 = this;

      if (this.loan && this.selectedBrand) {
        return this.loan.filter(function (item) {
          return item["brand"] === _this8.selectedBrand;
        });
      }
    },
    getLoanAdvancesAccount: function getLoanAdvancesAccount() {
      var _this9 = this;

      if (this.loanadvances && this.selectedBrand) {
        return this.loanadvances.filter(function (item) {
          return item["brand"] === _this9.selectedBrand;
        });
      }
    },
    getAssetAccount: function getAssetAccount() {
      var _this10 = this;

      if (this.asset && this.selectedBrand) {
        return this.asset.filter(function (item) {
          return item["brand"] === _this10.selectedBrand;
        });
      }
    },
    getExpenses: function getExpenses() {
      var _this11 = this;

      if (this.firms && this.selectedBrand) {
        return this.expenses.filter(function (item) {
          return item["brand"] === _this11.selectedBrand;
        });
      }
    },
    getStaffs: function getStaffs() {
      var _this12 = this;

      if (this.firms && this.selectedBrand) {
        return this.staffs.filter(function (item) {
          return item["brand"] === _this12.selectedBrand;
        });
      }
    },
    getAssets: function getAssets() {
      var _this13 = this;

      if (this.firms && this.selectedBrand) {
        return this.assets.filter(function (item) {
          return item["brand"] === _this13.selectedBrand;
        });
      }
    },
    getIncomes: function getIncomes() {
      var _this14 = this;

      if (this.firms && this.selectedBrand) {
        return this.incomes.filter(function (item) {
          return item["brand"] === _this14.selectedBrand;
        });
      }
    },
    itemListCount: function itemListCount() {
      var _this15 = this;

      return this.buyers.filter(function (item) {
        return item["brand"] === _this15.selectedBrand;
      }).length;
    },
    totalSeller: function totalSeller() {
      var _this16 = this;

      return this.sellers.filter(function (item) {
        return item["brand"] === _this16.selectedBrand;
      }).length;
    },
    getItemsCount: function getItemsCount() {
      var _this17 = this;

      return this.items.filter(function (item) {
        return item["brand"] === _this17.selectedBrand;
      }).length;
    },
    getInvoices: function getInvoices() {
      var _this18 = this;

      if (this.selectedBrand) {
        var toDate = this.toDate ? new Date(this.toDate).getTime() : null;
        var fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
        var filteredInvoice = this.invoices.filter(
        // item => item["brand"] === this.selectedBrand
        function (item) {
          return item["brand"] === _this18.selectedBrand && item.deleted != true && item.date >= _this18.finYear.start && item.date <= _this18.finYear.end && (_this18.selectedFirm ? item.firm === _this18.selectedFirm : true) && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true);
        });

        var totalSales = 0.0;
        var totalPurchase = 0.0;
        var totalCreditNote = 0.0;
        var totalDebitNote = 0.0;
        var buyerTotalColumn = {
          totalColumn_buyer: true,
          paidAmount: 0,
          remainingAmount: 0,
          totalAmount: 0,
          basicAmount: 0,
          discountAmount: 0,
          gstTotal: 0,
          GST_3: 0,
          GST_5: 0,
          GST_12: 0,
          GST_18: 0,
          GST_28: 0
        };
        var debitTotalColumn = {
          totalColum_debit: true,
          paidAmount: 0,
          remainingAmount: 0,
          totalAmount: 0,
          basicAmount: 0,
          discountAmount: 0,
          gstTotal: 0,
          GST_3: 0,
          GST_5: 0,
          GST_12: 0,
          GST_18: 0,
          GST_28: 0
        };
        var sellerTotalColumn = {
          totalColum_seller: true,
          paidAmount: 0,
          remainingAmount: 0,
          totalAmount: 0,
          basicAmount: 0,
          discountAmount: 0,
          gstTotal: 0,
          GST_3: 0,
          GST_5: 0,
          GST_12: 0,
          GST_18: 0,
          GST_28: 0
        };
        var creditTotalColumn = {
          totalColum_credit: true,
          paidAmount: 0,
          remainingAmount: 0,
          totalAmount: 0,
          basicAmount: 0,
          discountAmount: 0,
          gstTotal: 0,
          GST_3: 0,
          GST_5: 0,
          GST_12: 0,
          GST_18: 0,
          GST_28: 0
        };
        this.creditNoteCount = 0;
        this.debitNoteCount = 0;
        this.topCustomers = [];
        this.tradeData = [{
          name: "Sale",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }, {
          name: "Purchase",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }];

        this.volumeData = [{
          name: "Credit",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }, {
          name: "Debit",
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        }];

        var date = new Date();
        var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
        var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);

        this.volumeOptionsDaily.xaxis.categories = this.getDates(firstDay, lastDay);
        firstDay = firstDay.getTime();
        lastDay = lastDay.getTime();
        this.volumeDataDaily[0]['data'] = [];
        this.volumeDataDaily[1]['data'] = [];
        this.volumeOptionsDaily.xaxis.categories.map(function (i) {
          return _this18.volumeDataDaily[0]['data'].push(0);
        }, this.volumeDataDaily[1]['data'].push(0));
        console.log(this.volumeOptionsDaily.xaxis.categories);
        filteredInvoice.map(function (item, index) {
          var customer = null;
          var monthAdder = new Date(item.date).getMonth() < 3 ? 9 : -3;
          // let yearToFetch = new Date(item.date).getMonth() < 3 ? (new Date().getFullYear()+1) : new Date().getFullYear();
          var yearToFetchFrom = new Date(_this18.finYear.start).getFullYear();
          var yearToFetchTo = new Date(_this18.finYear.end).getFullYear();
          var itemYear = new Date(item.date).getFullYear();

          if (item.date >= firstDay && item.date <= lastDay) {
            if (item["isBuyer"]) {
              _this18.volumeDataDaily[0]['data'][new Date(item.date).getDate() - 1] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(item["totalAmount"]) > 0 ? __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item["totalAmount"]) : 0;
            } else {
              _this18.volumeDataDaily[1]['data'][new Date(item.date).getDate() - 1] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(item["totalAmount"]) > 0 ? __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item["totalAmount"]) : 0;
            }
          }

          if (item["isBuyer"] === true && ['All', 'Customers'].includes(_this18.topCustomerFilter)) {
            if (itemYear == yearToFetchFrom || itemYear == yearToFetchTo) {
              // this.tradeData[0]["data"][new Date(item.date).getMonth()] +=
              _this18.tradeData[0]["data"][new Date(item.date).getMonth() + monthAdder] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(item["totalAmount"]) > 0 ? __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item["totalAmount"]) : 0;
              //  this.tradeData[0]['data'][new Date(item.date).getMonth()] = Number.parseFloat(this.tradeData[0]['data'][new Date(item.date).getMonth()]).toFixed(2);
            }

            if ((itemYear == yearToFetchFrom || itemYear == yearToFetchTo) && item.status == "paid") {
              // this.volumeData[0]["data"][new Date(item.date).getMonth()] +=
              _this18.volumeData[0]["data"][new Date(item.date).getMonth() + monthAdder] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(item["totalAmount"]) > 0 ? __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item["totalAmount"]) : 0;
              //  this.volumeData[0]['data'][new Date(item.date).getMonth()] = Number.parseFloat(this.volumeData[0]['data'][new Date(item.date).getMonth()]).toFixed(2);
            }

            if ((itemYear == yearToFetchFrom || itemYear == yearToFetchTo) && item.status == "partial") {
              // this.volumeData[0]["data"][new Date(item.date).getMonth()] +=
              _this18.volumeData[0]["data"][new Date(item.date).getMonth() + monthAdder] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(item["paidAmount"]) > 0 ? __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item["paidAmount"]) : 0;
              //this.volumeData[0]['data'][new Date(item.date).getMonth()] = Number.parseFloat(this.volumeData[0]['data'][new Date(item.date).getMonth()]).toFixed(2);
            }
            var _index = _this18.topCustomers.findIndex(function (e) {
              return e["idOfBuyer"] == item.buyerId;
            });
            if (_index != -1) {
              _this18.topCustomers[_index]["totalAmount"] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(item["totalAmount"]) > 0 ? __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item["totalAmount"]) : 0;
              _this18.topCustomers[_index]["paidAmount"] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(item["paidAmount"]) > 0 ? __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item["paidAmount"]) : 0;
              _this18.topCustomers[_index]["remainingAmount"] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(item["remainingAmount"]) > 0 ? __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item["remainingAmount"]) : 0;
              // this.topCustomers[index]["totalAmount"] = Number.parseFloat(
              //   this.topCustomers[index]["totalAmount"]
              // ).toFixed(2);
              // this.topCustomers[index]["paidAmount"] = Number.parseFloat(
              //   this.topCustomers[index]["paidAmount"]
              // ).toFixed(2);
              // this.topCustomers[index]["remainingAmount"] = Number.parseFloat(
              //   this.topCustomers[index]["remainingAmount"]
              // ).toFixed(2);
            } else {
              customer = _this18.buyerById[item.buyerId];
              if (customer) {
                customer["totalAmount"] = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item['totalAmount']);
                customer["idOfBuyer"] = item.buyerId;
                customer["paidAmount"] = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item['paidAmount']);
                customer["remainingAmount"] = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item['remainingAmount']);
                _this18.topCustomers.push(customer);
              }
            }
          } else if (item["isBuyer"] === false && ['All', 'Suppliers'].includes(_this18.topCustomerFilter)) {
            if (itemYear == yearToFetchFrom || itemYear == yearToFetchTo) {
              // this.tradeData[1]["data"][new Date(item.date).getMonth()] +=
              _this18.tradeData[1]["data"][new Date(item.date).getMonth() + monthAdder] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(item["totalAmount"]) > 0 ? __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item["totalAmount"]) : 0;
              //this.tradeData[1]['data'][new Date(item.date).getMonth()] = Number.parseFloat(this.tradeData[0]['data'][new Date(item.date).getMonth()]).toFixed(2);
            }
            if ((itemYear == yearToFetchFrom || itemYear == yearToFetchTo) && item.status == "paid") {
              // this.volumeData[1]["data"][new Date(item.date).getMonth()] +=
              _this18.volumeData[1]["data"][new Date(item.date).getMonth() + monthAdder] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(item["totalAmount"]) > 0 ? __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item["totalAmount"]) : 0;
              //this.volumeData[1]['data'][new Date(item.date).getMonth()] = Number.parseFloat(this.volumeData[0]['data'][new Date(item.date).getMonth()]).toFixed(2);
            }
            if ((itemYear == yearToFetchFrom || itemYear == yearToFetchTo) && item.status == "partial") {
              // this.volumeData[1]["data"][new Date(item.date).getMonth()] +=
              _this18.volumeData[1]["data"][new Date(item.date).getMonth() + monthAdder] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(item["paidAmount"]) > 0 ? __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item["paidAmount"]) : 0;
              //this.volumeData[1]['data'][new Date(item.date).getMonth()] = Number.parseFloat(this.volumeData[0]['data'][new Date(item.date).getMonth()]).toFixed(2);
            }
            var _index2 = _this18.topCustomers.findIndex(function (e) {
              return e["idOfBuyer"] == item.buyerId;
            });
            if (_index2 != -1) {
              _this18.topCustomers[_index2]["totalAmount"] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(item["totalAmount"]) > 0 ? __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item["totalAmount"]) : 0;
              _this18.topCustomers[_index2]["paidAmount"] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(item["paidAmount"]) > 0 ? __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item["paidAmount"]) : 0;
              _this18.topCustomers[_index2]["remainingAmount"] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(item["remainingAmount"]) > 0 ? __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item["remainingAmount"]) : 0;
              // this.topCustomers[index]["totalAmount"] = Number.parseFloat(
              //   this.topCustomers[index]["totalAmount"]
              // ).toFixed(2);
              // this.topCustomers[index]["paidAmount"] = Number.parseFloat(
              //   this.topCustomers[index]["paidAmount"]
              // ).toFixed(2);
              // this.topCustomers[index]["remainingAmount"] = Number.parseFloat(
              //   this.topCustomers[index]["remainingAmount"]
              // ).toFixed(2);
            } else {
              customer = _this18.sellerById[item.buyerId];
              if (customer) {
                customer["totalAmount"] = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item['totalAmount']);
                customer["idOfBuyer"] = item.buyerId;
                customer["paidAmount"] = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item['paidAmount']);
                customer["remainingAmount"] = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item['remainingAmount']);
                _this18.topCustomers.push(customer);
              }
            }
          }
          if (item["items"] && item["items"].length) filteredInvoice[index]["GST_Percentage_total"] = Object(__WEBPACK_IMPORTED_MODULE_14__utils___["c" /* getGSTPercentageTotal */])(item["items"]);else {
            filteredInvoice[index]["GST_Percentage_total"] = {
              GST_3: 0,
              GST_5: 0,
              GST_12: 0,
              GST_18: 0,
              GST_28: 0
            };
          }
          totalSales = totalSales + (item["isBuyer"] === true ? __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item.totalAmount) : 0);
          totalPurchase = totalPurchase + (item["isBuyer"] === false ? __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item.totalAmount) : 0);
          if (item["return"] == true) {
            totalCreditNote = totalCreditNote + (item["isBuyer"] === true ? __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item.totalAmount) : 0);
            _this18.creditNoteCount += item["isBuyer"] === true ? 1 : 0;

            totalDebitNote = totalDebitNote + (item["isBuyer"] === false ? __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item.totalAmount) : 0);
            _this18.debitNoteCount += item["isBuyer"] === false ? 1 : 0;
          }
          if (item.isBuyer === true && !item.return) {
            buyerTotalColumn = _this18.getTotalColumn(item, buyerTotalColumn);
          }
          if (item.isBuyer === true && item.return) {
            creditTotalColumn = _this18.getTotalColumn(item, creditTotalColumn);
          }
          if (item.isBuyer === false && item.return) {
            debitTotalColumn = _this18.getTotalColumn(item, debitTotalColumn);
          }
          if (item.isBuyer === false && !item.return) {
            sellerTotalColumn = _this18.getTotalColumn(item, sellerTotalColumn);
          }
        });

        this.tradeData[0].data.map(function (data, index) {
          _this18.tradeData[0].data[index] = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(data).toFixed(2);
        });

        this.tradeData[1].data.map(function (data, index) {
          _this18.tradeData[1].data[index] = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(data).toFixed(2);
        });

        this.volumeData[0].data.map(function (data, index) {
          _this18.volumeData[0].data[index] = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(data).toFixed(2);
        });

        this.volumeData[1].data.map(function (data, index) {
          _this18.volumeData[1].data[index] = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(data).toFixed(2);
        });

        this.topCustomers.sort(function (a, b) {
          return a.totalAmount < b.totalAmount ? 1 : b.totalAmount < a.totalAmount ? -1 : 0;
        });
        this.totalSales = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(totalSales).toFixed(2);
        this.totalPurchase = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(totalPurchase).toFixed(2);
        this.totalCreditNote = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(totalCreditNote).toFixed(2);
        this.totalDebitNote = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(totalDebitNote).toFixed(2);
        this.updateWidgets();
        filteredInvoice.push(buyerTotalColumn);
        filteredInvoice.push(creditTotalColumn);
        filteredInvoice.push(debitTotalColumn);
        filteredInvoice.push(sellerTotalColumn);

        var firms = this.firms.filter(function (item) {
          return item["brand"] === _this18.selectedBrand;
        });
        firms.map(function (item) {
          var inv = {};
          if (!!item.openingBalance) {
            inv["firm"] = item[".key"];
            inv["totalAmount"] = item["openingBalance"];
            inv["isCredited"] = true;
            inv["remark"] = "Opening Balance";
            inv["date"] = item["openingDate"];
          }
          filteredInvoice.push(inv);

          if (!!item.amountAtCreation) {
            inv["firm"] = item[".key"];
            inv["totalAmount"] = item["amountAtCreation"];
            inv["isCredited"] = true;
            inv["remark"] = "Opening Amount";
            inv["paymentType"] = "Cash";
            inv["date"] = item["openingDate"];
          }
        });

        var banks = this.accounts.filter(function (item) {
          return item["brand"] === _this18.selectedBrand;
        });
        banks.map(function (item) {
          var inv = {};
          if (!!item.openingBalance) {
            inv["bank"] = item[".key"];
            inv["totalAmount"] = item["openingBalance"];
            inv["isCredited"] = true;
            inv["remark"] = "Opening Balance";
            inv["date"] = item["openingDate"];
            inv['accountType'] = item['accountType'];
          }
          filteredInvoice.push(inv);
        });
        return filteredInvoice;
      } else {
        return [];
      }
    },
    getSaleInvoices: function getSaleInvoices() {
      var _this19 = this;

      var toDate = this.toDate ? new Date(this.toDate).getTime() : null;
      var fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
      return this.getInvoices.filter(function (item) {
        var saleOuted = item.isBuyer === true && !item.return || item.totalColumn_buyer;
        if (_this19.selectedFirm && saleOuted) {
          return item.firm === _this19.selectedFirm && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true);
        }
        return saleOuted && (_this19.selectedFirm ? item["firm"] == _this19.selectedFirm : true) && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true);
      });
    },
    getCreditNoteInvoices: function getCreditNoteInvoices() {
      var _this20 = this;

      return this.getInvoices.filter(function (item) {
        // let creditNoteGenerator = (item.isBuyer === true  && (!item.return) || item.totalColumn_buyer)
        var creditNoteGenerator = item.isBuyer === true && item.return || item.totalColum_credit;
        if (_this20.selectedFirm && creditNoteGenerator) {
          return item.firm === _this20.selectedFirm;
        }
        return creditNoteGenerator;
      });
    },
    getDebitNoteInvoices: function getDebitNoteInvoices() {
      var _this21 = this;

      return this.getInvoices.filter(function (item) {
        // let creditNoteGenerator = (item.isBuyer === true  && (!item.return) || item.totalColumn_buyer)
        var debitNoteGenerator = item.isBuyer === false && item.return || item.totalColum_debit;
        if (_this21.selectedFirm && debitNoteGenerator) {
          return item.firm === _this21.selectedFirm;
        }
        return debitNoteGenerator;
      });
    },
    getPurchaseInvoices: function getPurchaseInvoices() {
      var _this22 = this;

      var toDate = this.toDate ? new Date(this.toDate).getTime() : null;
      var fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
      return this.getInvoices.filter(function (item) {
        var purchaseOuted = item.isBuyer === false && !item.return || item.totalColum_seller;
        if (_this22.selectedFirm && purchaseOuted) {
          return item.firm === _this22.selectedFirm && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true);
        }
        return purchaseOuted && (_this22.selectedFirm ? item["firm"] == _this22.selectedFirm : true) && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true);
      });
    },
    getFirmInvoices: function getFirmInvoices() {
      var _this23 = this;

      var toDate = this.toDate ? new Date(this.toDate).getTime() : null;
      var fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
      // return this.getInvoices.filter( item => item.firm === this.currentFirmById
      var brokrageINV = [];
      this.getInvoices.map(function (invoice) {
        if (invoice.brokeragePaid) {
          var inv = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(invoice));
          inv['isCredited'] = false;
          inv['totalAmount'] = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount) * __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(inv.brokerageRate) / 100;
          inv['discountAmount'] = 0;
          inv['date'] = inv['brokeragePayDate'];
          inv['brokrageInvoice'] = true;
          brokrageINV.push(inv);
        }
      });
      brokrageINV = brokrageINV.concat(this.getInvoices);
      return brokrageINV.filter(function (item) {
        return item.firm === _this23.currentFirmById && (_this23.selectedFirm ? item["firm"] == _this23.selectedFirm : true) && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true);
      });
    },
    getCashInvoices: function getCashInvoices() {
      var _this24 = this;

      var toDate = this.toDate ? new Date(this.toDate).getTime() : null;
      var fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;

      return this.getInvoices.filter(function (item) {
        return item.firm === _this24.currentFirmById && ["Cash", "cash"].indexOf(item['paymentType']) > -1 && (_this24.selectedFirm ? item["firm"] == _this24.selectedFirm : true) && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true);
      });
    },
    currentFirmById: function currentFirmById() {
      var _this25 = this;

      if (this.currentFirm) {
        return this.getFirms.find(function (firm) {
          return firm.name === _this25.currentFirm;
        })[".key"];
      }
      return null;
    },
    getBankInvoices: function getBankInvoices() {
      var _this26 = this;

      var toDate = this.toDate ? new Date(this.toDate).getTime() : null;
      var fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
      return this.getInvoices.filter(function (item) {
        return item.bank && item.bank === _this26.currentAccountKey && (_this26.selectedFirm ? item["firm"] == _this26.selectedFirm : true) && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true);
      });
    },
    getExpenseInvoices: function getExpenseInvoices() {
      var _this27 = this;

      return this.getInvoices.filter(function (invoice) {
        return invoice.expenseType === _this27.currentExpense;
      });
    },
    getIncomeInvoices: function getIncomeInvoices() {
      var _this28 = this;

      return this.getInvoices.filter(function (invoice) {
        return invoice.incomeType === _this28.currentIncome;
      });
    },
    getStaffInvoices: function getStaffInvoices() {
      var _this29 = this;

      return this.getInvoices.filter(function (invoice) {
        return invoice.staffkey === _this29.currentStaff;
      });
    },
    getAssetInvoices: function getAssetInvoices() {
      var _this30 = this;

      return this.getInvoices.filter(function (invoice) {
        return invoice.assetType === _this30.currentAsset;
      });
    },
    getPurchaseCount: function getPurchaseCount() {
      var _this31 = this;

      if (this.selectedBrand) {
        var toDate = this.toDate ? new Date(this.toDate).getTime() : null;
        var fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
        return this.invoices.filter(function (item) {
          return item["brand"] === _this31.selectedBrand && item["isBuyer"] === false && item.date >= _this31.finYear.start && item.date <= _this31.finYear.end && (_this31.selectedFirm ? item.firm === _this31.selectedFirm : true) && item.deleted != true && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true);
        }).length;
      } else {
        return 0;
      }
    },
    getSalesCount: function getSalesCount() {
      var _this32 = this;

      if (this.selectedBrand) {
        var toDate = this.toDate ? new Date(this.toDate).getTime() : null;
        var fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
        return this.invoices.filter(function (item) {
          return item["brand"] === _this32.selectedBrand && item["isBuyer"] === true && item.date >= _this32.finYear.start && item.date <= _this32.finYear.end && (_this32.selectedFirm ? item.firm === _this32.selectedFirm : true) && item.deleted != true && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true);
        }).length;
      } else {
        return 0;
      }
    },
    getProductQuantity: function getProductQuantity() {
      var _this33 = this;

      var productCount = 0;
      var products = this.products.filter(function (item) {
        return item["brand"] === _this33.selectedBrand && (_this33.selectedFirm ? item.firm === _this33.selectedFirm : true);
      }
      // &&(item.openingDate >= this.finYear.start) && (item.openingDate <= this.finYear.end))
      );
      products.map(function (prod) {
        productCount += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(prod.quantity);
      });
      return productCount;
    },
    getProductOpening: function getProductOpening() {
      var _this34 = this;

      var openingBal = 0;
      var products = this.products.filter(function (item) {
        return item["brand"] === _this34.selectedBrand;
      }
      // && (item.openingDate >= this.finYear.start) && (item.openingDate <= this.finYear.end))
      );
      products.map(function (prod) {
        openingBal += !!prod.openingBalance ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(prod.openingBalance) : 0;
      });
      return openingBal;
    },
    getTopProducts: function getTopProducts() {
      var _this35 = this;

      var products = this.products.filter(function (item) {
        return item["brand"] === _this35.selectedBrand && (_this35.selectedFirm ? item.firm === _this35.selectedFirm : true);
      }
      // &&(item.openingDate >= this.finYear.start) && (item.openingDate <= this.finYear.end))
      );
      products.sort(function (a, b) {
        return a.saleQuantity < b.saleQuantity ? 1 : b.saleQuantity < a.saleQuantity ? -1 : 0;
      });
      return products;
    },
    printPurchaseReport: function printPurchaseReport() {
      var _this36 = this;

      var purchaseInvoice = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.getPurchaseInvoices));
      purchaseInvoice.map(function (item, index) {
        purchaseInvoice[index]["firmName"] = _this36.getFirmName(item.firm);
        purchaseInvoice[index]["buyerName"] = item.buyerId && _this36.sellerById[item.buyerId] ? _this36.sellerById[item.buyerId].name : '';
        purchaseInvoice[index]["GST_TOTAL"] = _this36.getGSTtotal(item);
        purchaseInvoice[index]["BASIC_AMOUNT"] = item.totalAmount - purchaseInvoice[index]["GST_TOTAL"] || 0;
        purchaseInvoice[index]["IGST"] = item.gstType == 'IGST' ? purchaseInvoice[index]["GST_TOTAL"] : 0;
        purchaseInvoice[index]["CGST"] = item.gstType == 'SGST|CGST' ? purchaseInvoice[index]["GST_TOTAL"] / 2 : 0;
        purchaseInvoice[index]["SGST"] = item.gstType == 'SGST|CGST' ? purchaseInvoice[index]["GST_TOTAL"] / 2 : 0;
        purchaseInvoice[index]["GST_3"] = item.GST_Percentage_total ? item['GST_Percentage_total']['GST_3'] : '';
        purchaseInvoice[index]["GST_5"] = item.GST_Percentage_total ? item['GST_Percentage_total']['GST_5'] : '';
        purchaseInvoice[index]["GST_12"] = item.GST_Percentage_total ? item['GST_Percentage_total']['GST_12'] : '';
        purchaseInvoice[index]["GST_18"] = item.GST_Percentage_total ? item['GST_Percentage_total']['GST_18'] : '';
        purchaseInvoice[index]["GST_28"] = item.GST_Percentage_total ? item['GST_Percentage_total']['GST_28'] : '';
      });
      var doc = Object(__WEBPACK_IMPORTED_MODULE_11__utils_pdf_reports_dashboard_reports__["a" /* convertToPDFReport */])({
        type: 'Purchase Register',
        invoiceData: purchaseInvoice,
        firm: this.selectedFirm ? this.getFirmName(this.selectedFirm) : null,
        fromDate: this.fromDate ? new Date(this.fromDate).toLocaleDateString('en-GB') : null,
        toDate: this.toDate ? new Date(this.toDate).toLocaleDateString('en-GB') : null
      });
      pdfMake.createPdf(doc).download();
    },
    printSaleReport: function printSaleReport() {
      var _this37 = this;

      var saleInvoices = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.getSaleInvoices));
      saleInvoices.map(function (item, index) {
        saleInvoices[index]["firmName"] = _this37.getFirmName(item.firm);
        saleInvoices[index]["buyerName"] = item.buyerId && _this37.buyerById[item.buyerId] ? _this37.buyerById[item.buyerId].name : '';
        saleInvoices[index]["GST_TOTAL"] = _this37.getGSTtotal(item);
        saleInvoices[index]["BASIC_AMOUNT"] = item.totalAmount - saleInvoices[index]["GST_TOTAL"] || 0;
        saleInvoices[index]["IGST"] = item.gstType == 'IGST' ? saleInvoices[index]["GST_TOTAL"] : 0;
        saleInvoices[index]["CGST"] = item.gstType == 'SGST|CGST' ? saleInvoices[index]["GST_TOTAL"] / 2 : 0;
        saleInvoices[index]["SGST"] = item.gstType == 'SGST|CGST' ? saleInvoices[index]["GST_TOTAL"] / 2 : 0;
        saleInvoices[index]["GST_3"] = item.GST_Percentage_total ? item['GST_Percentage_total']['GST_3'] : '';
        saleInvoices[index]["GST_5"] = item.GST_Percentage_total ? item['GST_Percentage_total']['GST_5'] : '';
        saleInvoices[index]["GST_12"] = item.GST_Percentage_total ? item['GST_Percentage_total']['GST_12'] : '';
        saleInvoices[index]["GST_18"] = item.GST_Percentage_total ? item['GST_Percentage_total']['GST_18'] : '';
        saleInvoices[index]["GST_28"] = item.GST_Percentage_total ? item['GST_Percentage_total']['GST_28'] : '';
      });
      var doc = Object(__WEBPACK_IMPORTED_MODULE_11__utils_pdf_reports_dashboard_reports__["a" /* convertToPDFReport */])({
        type: 'Sale Register',
        invoiceData: saleInvoices,
        firm: this.selectedFirm ? this.getFirmName(this.selectedFirm) : null,
        fromDate: this.fromDate ? new Date(this.fromDate).toLocaleDateString('en-GB') : null,
        toDate: this.toDate ? new Date(this.toDate).toLocaleDateString('en-GB') : null
      });
      console.log(doc);
      pdfMake.createPdf(doc).download();
    }
  }),
  watch: {
    isFilter: function isFilter(val) {
      if (val) {
        document.getElementById("dashboard-filters").style.display = "";
      } else {
        document.getElementById("dashboard-filters").style.display = "none";
      }
    },
    buyer: function buyer(val) {
      this.updateWidgets();
    },
    items: function items(val) {
      this.updateWidgets();
    },
    invoices: function invoices(val) {
      this.calculateProfitLoss();
      this.updateWidgets();
    },
    selectedBrand: function selectedBrand(val) {
      console.log("branch change detect");
      console.log(val);
      // document.querySelectorAll('.v-navigation-drawer div.v-list div[role="listitem"] a')[1].click()
      // setTimeout(()=>{
      //   document.querySelectorAll('.v-navigation-drawer div.v-list div[role="listitem"] a')[0].click()
      // })
      this.calculateProfitLoss();
      this.updateWidgets();
    }
  },
  methods: {
    getDates: function getDates(startDate, stopDate) {
      Date.prototype.addDays = function (days) {
        var date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
      };
      var dateArray = new Array();
      var currentDate = startDate;
      while (currentDate <= stopDate) {
        dateArray.push(new Date(currentDate).getDate());
        currentDate = currentDate.addDays(1);
      }
      return dateArray;
    },
    getTranslatedHeaders: function getTranslatedHeaders(header) {
      var header1 = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(header));
      header1.map(function (item, index) {
        header1[index]['text'] = __WEBPACK_IMPORTED_MODULE_13__i18n__["a" /* default */].t(header1[index]['text']);
      });
      return header1;
    },
    getClosingAmount: function getClosingAmount(item) {
      var closingQty = parseInt(item['openingQuantity'] ? item['openingQuantity'] : 0) + parseInt(item['durationQtyPurchase'] ? item['durationQtyPurchase'] : 0) - parseInt(item['durationQtySale'] ? item['durationQtySale'] : 0);
      switch (this.firmStockReportType) {

        case 'APP':
          {
            var amount = 0;
            if (item.stockReportData) {
              var avgPurchasePrice = item.stockReportData.purchaseDetails.reduce(function (a, b) {
                return a + (b['rate'] || 0);
              }, 0) / item.stockReportData.purchaseDetails.length;
              amount = avgPurchasePrice * closingQty;
            }
            return amount;
          }
        case 'LPP':
          {
            var _amount = 0;
            if (item.stockReportData) {
              _amount = item.stockReportData.lastPurchasePrice * closingQty;
            }
            return _amount;
          }
        case 'LSP':
          {
            var _amount2 = 0;
            if (item.stockReportData) {
              _amount2 = item.stockReportData.lastSalePrice * closingQty;
            }
            return _amount2;
          }
        case 'ASP':
          {
            var _amount3 = 0;
            if (item.stockReportData) {
              var avgSalePrice = item.stockReportData.saleDetails.reduce(function (a, b) {
                return a + (b['rate'] || 0);
              }, 0) / item.stockReportData.saleDetails.length;
              _amount3 = avgSalePrice * closingQty;
            }
            return _amount3;
          }
        case 'FIFO':
          {
            var _amount4 = 0;
            if (item.stockReportData) {
              var allTransaction = item.stockReportData.purchaseDetails.sort(function (a, b) {
                return -(new Date(b.date) - new Date(a.date));
              });

              var qntTemp = closingQty;
              allTransaction.map(function (t) {
                if (qntTemp > t.quantity) {
                  _amount4 += t.quantity * t.rate;
                  qntTemp = qntTemp - t.quantity;
                } else if (qntTemp > 0) {
                  _amount4 += t.quantity - qntTemp * t.rate;
                  qntTemp = 0;
                }
              });
            }
            return _amount4;
          }
        case 'LIFO':
          {
            var _amount5 = 0;
            if (item.stockReportData) {
              var _allTransaction = item.stockReportData.purchaseDetails.sort(function (a, b) {
                return new Date(b.date) - new Date(a.date);
              });
              var _qntTemp = closingQty;
              _allTransaction.map(function (t) {
                if (_qntTemp > t.quantity) {
                  _amount5 += t.quantity * t.rate;
                  _qntTemp = _qntTemp - t.quantity;
                } else if (_qntTemp > 0) {
                  _amount5 += t.quantity - _qntTemp * t.rate;
                  _qntTemp = 0;
                }
              });
            }
            return _amount5;
          }
      }
    },
    keymonitor: function keymonitor(event) {
      this.search = event.target.value;
    },
    keymonitorCustomer: function keymonitorCustomer(event) {
      this.searchCustomer = event.target.value;
    },
    dayDiff: function dayDiff(d1) {
      var date1 = new Date(d1);
      var date2 = new Date();
      var diffTime = Math.abs(date2 - date1);
      var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays == 1 ? 'Today' : diffDays + ' Days';
    },
    getTotalColumn: function getTotalColumn(invoice, totalInvoice) {
      var gst = this.getGSTtotal(invoice);
      totalInvoice.paidAmount += parseFloat(invoice.paidAmount);
      totalInvoice.remainingAmount += parseFloat(invoice.remainingAmount);
      totalInvoice.totalAmount += parseFloat(invoice.totalAmount);
      totalInvoice.basicAmount += parseFloat(invoice.totalAmount) - gst;
      totalInvoice.discountAmount += parseFloat(invoice.discountAmount);
      totalInvoice.gstTotal += gst;
      totalInvoice.GST_3 += parseFloat(invoice.GST_Percentage_total.GST_3);
      totalInvoice.GST_5 += parseFloat(invoice.GST_Percentage_total.GST_5);
      totalInvoice.GST_12 += parseFloat(invoice.GST_Percentage_total.GST_12);
      totalInvoice.GST_18 += parseFloat(invoice.GST_Percentage_total.GST_18);
      totalInvoice.GST_28 += parseFloat(invoice.GST_Percentage_total.GST_28);
      return totalInvoice;
    },
    getFirmBalance: function getFirmBalance(firm, type) {
      var _this38 = this;

      var banks = [];
      var totalBankBalance = 0;
      if (this.accounts && this.selectedBrand) {
        banks = this.accounts.filter(function (item) {
          return item["brand"] === _this38.selectedBrand && item["firm"] === firm[".key"];
        });
        banks.map(function (bank) {
          totalBankBalance += __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(bank.amount);
        });
      }
      if (type === "combined") {
        return (__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(firm.amount) + totalBankBalance).toFixed(2);
      } else {
        return totalBankBalance.toFixed(2);
      }
    },
    getRateByBrand: function getRateByBrand() {
      var _this39 = this;

      var assetRateByBrand = null;
      var rateByBrand = this.assetRate.filter(function (item) {
        return item["brand"] === _this39.selectedBrand;
      });
      if (rateByBrand && rateByBrand.length) {
        assetRateByBrand = rateByBrand[0]["rate"];
      }
      return assetRateByBrand;
    },
    calculateProfitLoss: function calculateProfitLoss() {
      var _this40 = this;

      this.credited = 0.0;
      this.debited = 0.0;
      var returnAmount = 0.0;
      var returnItems = 0;
      // console.log("cal")
      // console.log(this.selectedBrand)
      // let itemCount = 0;
      this.selectedBrand && this.invoices.forEach(function (item) {
        if (item["brand"] === _this40.selectedBrand && item.deleted != true && item.date >= _this40.finYear.start && item.date <= _this40.finYear.end) {
          if (item["isCredited"]) {
            _this40.credited = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(_this40.credited) + __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item["profit"] || 0);
            returnAmount = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(returnAmount) + __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item["totalAmount"] || 0) - __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item["profit"] || 0);
            returnItems = returnItems + (item["items"] ? item["items"].length : 0);
          }
          // item.items && item.items.forEach(item => {
          //    this.debited =
          //      Number.parseFloat(this.debited) +
          //      Number.parseFloat(item["principalValue"]);
          //      itemCount ++ ;
          // });
        }
      });
      this.items.forEach(function (item) {
        if (item["brand"] === _this40.selectedBrand) {
          _this40.debited = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(_this40.debited) + __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item["principalValue"]);
        }
      });
      this.credited = this.credited.toFixed(2);
      this.debited = (this.debited - returnAmount).toFixed(2);
      // this.debited = this.debited < 0 ? 0 : this.debited

      this.itemsInStock = this.getItemsCount - returnItems;
    },
    getAbsoluteValue: function getAbsoluteValue(invoice) {
      var absoluteValue = 0;
      var assetRate = 0;
      var assetRateByBrand = this.getRateByBrand();
      if (assetRateByBrand) {
        invoice.items.map(function (item) {
          if (item.type === "Gold" && assetRateByBrand) {
            var rate = parseFloat(assetRateByBrand[item.type.toLowerCase()]);
            assetRate = rate !== -1 ? rate : false;
          } else if (item.type === "Silver" && assetRateByBrand) {
            var _rate = parseFloat(assetRateByBrand[item.type.toLowerCase()]);
            assetRate = _rate !== -1 ? _rate : false;
          } else {
            assetRate = false;
          }
          var absoluteValueLocal = assetRate ? assetRate * parseFloat(item.weight) / 10 : 0;
          absoluteValue = +absoluteValueLocal;
        });
      }
      return absoluteValue;
    },
    updateWidgets: function updateWidgets() {
      this.cards1 = [{
        title: "Customer",
        buyerCount: this.itemListCount,
        sellerCount: this.totalSeller,
        icon: "mdi-account"
      }, {
        title: "Sales",
        value: this.getSalesCount,
        amount: this.totalSales - this.totalCreditNote - this.totalCreditNote,
        icon: "mdi-upload"
      }, {
        title: "Purchase",
        value: this.getPurchaseCount,
        amount: this.totalPurchase - this.totalDebitNote - this.totalDebitNote,
        icon: "mdi-download"
      }, {
        title: "Stock",
        measure: this.totalclosingStock,
        //aggregate: (Number.parseFloat(this.getProductOpening) + Number.parseFloat(this.totalPurchase)) - Number.parseFloat(this.totalSales),
        aggregate: this.closingStock,
        icon: "mdi-currency-usd"
      }];
      this.cards2 = [{
        title: "Profit",
        value: "Rs. " + this.credited
      }, {
        title: "Credit Note",
        amount: this.totalCreditNote,
        count: this.creditNoteCount
      }, {
        title: "Debit Note",
        amount: this.totalDebitNote,
        count: this.debitNoteCount
      }];
    },
    openDialog: function openDialog(e) {
      this.expenseDialog = true;
      this.currentExpense = e;
    },
    openDialog1: function openDialog1(e) {
      this.incomeDialog = true;
      this.currentIncome = e;
    },
    openDialog6: function openDialog6(e) {
      this.staffDialog = true;
      this.currentStaff = e;
    },
    openDialog7: function openDialog7(e) {
      this.assetDialog = true;
      this.currentAsset = e;
    },
    openAccountDialog: function openAccountDialog(key, accountnumber) {
      this.accountDialog = true;
      this.currentAccountNumber = accountnumber;
      this.currentAccountKey = key;
    },
    openFirmDialog: function openFirmDialog(e) {
      this.firmDialog = true;
      this.currentFirm = e;
    },
    openFirstDialog: function openFirstDialog(e) {
      if (e === 'Sales') {
        this.$router.push({ path: "/sale-register" });
      } else if (e === 'Purchase') {
        this.$router.push({ path: "/purchase-register" });
      } else if (e === 'Stock') {
        this.$router.push({ path: "/reports/stock" });
      } else {
        this.dialog = true;
        this.currentTitle = e;
      }
    },

    // buyerById (id) {
    //   return this.buyers[id]
    // },
    getFirmName: function getFirmName(e) {
      var firm = void 0;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter(function (item) {
          return item[".key"] === e;
        })[0];
      }
      if (firm) return firm.name;
    },
    getGSTtotal: function getGSTtotal(item) {
      var GSTTotal = 0;
      item && item.items && item.items.map(function (item) {
        GSTTotal += __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
      });
      return __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(GSTTotal);
    },
    renderDate: function renderDate(timeStamp) {
      if (timeStamp) {
        return new Date(timeStamp).toLocaleDateString("en-GB");
      }
      return "--";
    },
    openProd: function openProd(invoice) {
      this.selectedInvoice = invoice;
      this.dialog11 = true;
    },
    printBasicInvoice: function printBasicInvoice(selectedInvoice) {
      var _this41 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var termsAndConditions, banks, firm, customer, gstInvoice, gstTotal, doc;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                termsAndConditions = _this41.getTermsAndConditions(selectedInvoice);

                if (termsAndConditions.length) {
                  if (termsAndConditions[0].bank) {
                    banks = [];

                    termsAndConditions[0].bank.map(function (bankId) {
                      var bank = _this41.accounts.filter(function (item) {
                        return item['.key'] == bankId;
                      })[0];

                      bank.address = _this41.getAddress(bank);
                      banks.push(bank);
                    });
                    termsAndConditions[0].banks = banks;
                  } else {
                    termsAndConditions[0].banks = [];
                  }
                } else {
                  termsAndConditions = [{
                    termsAndConditions: "",
                    banks: []
                  }];
                }
                firm = _this41.firms.filter(function (item) {
                  return item['.key'] == selectedInvoice.firm;
                })[0];

                firm.address = _this41.getAddress(firm);
                customer = _this41.getCurrentUser(selectedInvoice.buyerId);

                customer.address = _this41.getAddress(customer);
                // selectedInvoice['date'] = selectedInvoice['dateOfInvoice'];
                gstInvoice = firm.GST_user && firm.GST_user == 'Yes' ? true : false;
                gstTotal = _this41.calculateGSTInvoice(customer, selectedInvoice);

                if (!gstInvoice) {
                  _context.next = 14;
                  break;
                }

                _context.next = 11;
                return Object(__WEBPACK_IMPORTED_MODULE_12__utils_pdfmake__["c" /* convertToBasicInvoice */])({
                  invoiceData: selectedInvoice,
                  firm: firm,
                  customer: customer,
                  gstTotal: gstTotal,
                  terms: termsAndConditions[0]
                });

              case 11:
                _context.t0 = _context.sent;
                _context.next = 17;
                break;

              case 14:
                _context.next = 16;
                return Object(__WEBPACK_IMPORTED_MODULE_12__utils_pdfmake__["f" /* convertToBasicInvoiceWithoutGST */])({
                  invoiceData: selectedInvoice,
                  firm: firm,
                  customer: customer,
                  gstTotal: gstTotal,
                  terms: termsAndConditions[0]
                });

              case 16:
                _context.t0 = _context.sent;

              case 17:
                doc = _context.t0;

                pdfMake.createPdf(doc).download();

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this41);
      }))();
    },
    getTermsAndConditions: function getTermsAndConditions(selectedInvoice) {
      var _this42 = this;

      return this.termsAndConditions.filter(function (item) {
        return item["brand"] === _this42.selectedBrand && item['firm'] === selectedInvoice.firmID;
      });
    },
    getAddress: function getAddress(item) {
      var address = (item.village ? item.village + " - " : "") + (item.block ? item.block + " - " : "") + (item.tehsil ? item.tehsil + " - " : "") + (item.district ? item.district + " - " : "") + (item.state ? item.state + " - " : "") + (item.country ? item.country + " - " : "");
      address = address.substring(0, address.length - 2);
      return address;
    },
    calculateGSTInvoice: function calculateGSTInvoice(currentUser, invoice) {
      var SGST_val = 0;
      var CGST_val = 0;
      var IGST_val = 0;
      invoice.items && invoice.items.map(function (item, index) {
        SGST_val += parseFloat(item["SGST_val"]);
        CGST_val += parseFloat(item["CGST_val"]);
        IGST_val += parseFloat(item["IGST_val"]);
      });
      return { SGST_val: SGST_val, CGST_val: CGST_val, IGST_val: IGST_val };
    },
    getCurrentUserName: function getCurrentUserName(buyerId) {
      var buyer = this.buyerById[buyerId];
      var seller = this.sellerById[buyerId];
      var currentUser = buyer ? buyer : seller ? seller : {};
      return currentUser ? currentUser.name : '';
    },
    getStaffName: function getStaffName(staff) {
      return this.staffs.filter(function (item) {
        return item[".key"] === staff;
      })[0].staffName;
    },
    getCurrentUser: function getCurrentUser(buyerId) {
      var buyer = this.buyerById[buyerId];
      var seller = this.sellerById[buyerId];
      var currentUser = buyer ? buyer : seller ? seller : {};
      return currentUser;
    },
    getVocherType: function getVocherType(invoice) {
      if (invoice.brokrageInvoice) {
        return 'Brokrage';
      }
      if (invoice.return) {
        if (invoice.isBuyer) {
          return "Credit Note";
        } else {
          return "Debit Note";
        }
      }
      if (invoice["type"] == "automatic invoice" && invoice.assetType) {
        return "asset";
      }
      if (invoice["type"] == "automatic invoice" && invoice.expenseType) {
        return "expense";
      }
      if (invoice["type"] == "automatic invoice" && invoice.liabilityType) {
        return "liability";
      }
      if (invoice["type"] == "automatic invoice" && invoice.incomeType) {
        return "income";
      }
      if (invoice["type"] == "automatic invoice" && invoice.staffType) {
        return "Staff";
      }
      if (invoice["type"] == "automatic invoice" && invoice.transactionType === "Transfer") {
        return "Transfer";
      } else if (invoice.transactionType != "Debit" && invoice["type"] === "Advance" || invoice["type"] === "Opening Balance" || invoice["type"] === "LoanGiven" || invoice["type"] === "LoanTaken" || invoice["type"] === "Security") {
        return invoice["type"];
      } else if (invoice.isBuyer && invoice.transactionType === "Debit") {
        return "Sale";
      } else if (invoice.isBuyer && invoice.transactionType === "Credit") {
        return "Receipt";
      } else if (invoice.isBuyer && invoice.transactionType === "Partial Paid") {
        return "Receipt";
      } else if (!invoice.isBuyer && invoice.transactionType === "Debit") {
        return "Purchase";
      } else if (!invoice.isBuyer && invoice.transactionType === "Credit") {
        return "Payment";
      } else if (!invoice.isBuyer && invoice.transactionType === "Partial Paid") {
        return "Payment";
      }

      // else if (
      //   (invoice.isBuyer && invoice.transactionType === "Credit") ||
      //   (!invoice.isBuyer && invoice.transactionType === "Credit")
      // ) {
      //   return "Payment";
      // }

      // else if (
      //   (invoice.isBuyer && invoice.transactionType === "Partial Paid") ||
      //   (!invoice.isBuyer && invoice.transactionType === "Partial Paid")
      // ) {
      //   return "Partial Paid";
      // } else if (!invoice.isBuyer && invoice.transactionType === "Debit") {
      //   return "Purchase";
      // }
    }
  }
});

/***/ }),
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return convertToPDFReport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3__ = __webpack_require__(189);

//import { initOnLoad } from "apexcharts";



// playground requires you to assign document definition to a variable called dd
var convertToPDFReport = function convertToPDFReport(_ref) {
    var type = _ref.type,
        invoiceData = _ref.invoiceData,
        firm = _ref.firm,
        fromDate = _ref.fromDate,
        toDate = _ref.toDate;

    var dd = {
        pageOrientation: 'landscape',
        content: [{
            table: {
                widths: ['20%', '30%', '25%', '25%'],
                body: [[{ text: '', style: "reportHeader1" }, { text: 'FIRM NOT SELECTED\n', style: "reportHeader" }, { text: 'From: NOT SELECTED\n', style: "reportHeader" }, { text: 'To: NOT SELECTED\n', style: "reportHeader" }]]
            }

        }, { text: '\n', style: '' }, {
            table: {

                body: [[{ text: 'Invoice Date', style: "gstHeader" }, { text: 'Invoice No.', style: "gstHeader" }, { text: 'Particulars', style: "gstHeaderBuyer1" }, { text: 'Total', style: "gstHeaderTotal1" }, { text: 'Basic', style: "gstHeaderBasic1" }, { text: 'GST', style: "gstHeaderBasic1" }, { text: 'Discount', style: "gstHeaderBasic1" },
                // { text: 'Paid ', style: "gstHeader" },
                // { text: 'Remaining', style: "gstHeader" },
                // { text: 'Duration', style: "gstHeader" },
                // { text: 'Payment Type', style: "gstHeader" },
                // { text: 'Status', style: "gstHeader" },
                // { text: 'Transaction Type', style: "gstHeader" },
                { text: 'GST type', style: "gstHeader" }, { text: 'IGST', style: "gstHeader" }, { text: 'SGST', style: "gstHeader" }, { text: 'CGST', style: "gstHeader" }, { text: 'GST(3%)', style: "gstHeader" }, { text: 'GST(5%)', style: "gstHeader" }, { text: 'GST(12%)', style: "gstHeader" }, { text: 'GST(18%)', style: "gstHeader" }, { text: 'GST(28%)', style: "gstHeader" }, { text: 'Vocher Type', style: "gstHeader" }]]
            }

        }],
        styles: {
            gstHeader: {
                fontSize: 6,
                bold: true,
                alignment: 'center'
            },
            gstHeaderBuyer1: {
                fontSize: 6,
                bold: true,
                alignment: 'center',
                color: '#160091'
            },
            gstHeaderTotal1: {
                fontSize: 6,
                bold: true,
                alignment: 'center',
                color: '#160091'
            },
            gstHeaderBasic1: {
                fontSize: 6,
                bold: true,
                alignment: 'center'
            },
            gstHeaderBuyer: {
                fontSize: 8,
                bold: true,
                alignment: 'left',
                color: '#160091'
            },
            gstHeaderTotal: {
                fontSize: 8,
                bold: true,
                alignment: 'right',
                color: '#160091'
            },
            gstHeaderBasic: {
                fontSize: 7,
                bold: true,
                alignment: 'right'
            },
            gstData: {
                fontSize: 7,
                bold: true,
                alignment: 'center'
            },
            gstHeaderInvoice: {
                fontSize: 7,
                bold: true,
                alignment: 'left'
            },
            reportHeader: {
                fontSize: 12,
                bold: true,
                alignment: 'center'
            },
            reportHeader1: {
                fontSize: 14,
                bold: true,
                alignment: 'left',
                color: "#160091"
            }
        }

    };

    if (type) {
        dd.content[0].table.body[0][0].text = type;
    }
    if (firm) {
        dd.content[0].table.body[0][1].text = '' + firm + '\n';
    }
    if (fromDate) {
        dd.content[0].table.body[0][2].text = 'From ' + fromDate + '\n';
    }
    if (toDate) {
        dd.content[0].table.body[0][3].text = 'To ' + toDate + '\n';
    }

    invoiceData.map(function (invoice) {
        if (!invoice.totalColum_debit && !invoice.totalColum_seller) {
            dd.content[2].table.body.push([{ text: invoice.firmName == 'Total' ? 'Total' : new Date(invoice.date).toLocaleDateString('en-GB'), style: "gstData" }, { text: invoice.invoiceId, style: "gstHeaderInvoice" }, { text: invoice.buyerName, style: "gstHeaderBuyer" }, { text: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(invoice.totalAmount).toFixed(1), style: "gstHeaderTotal" }, { text: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(invoice.BASIC_AMOUNT).toFixed(1), style: "gstHeaderBasic" }, { text: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(invoice.GST_TOTAL).toFixed(1), style: "gstHeaderBasic" }, { text: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(invoice.discountAmount).toFixed(1), style: "gstHeaderBasic" },
            // { text: Number.parseFloat(invoice.paidAmount).toFixed(1), style: "gstData" },
            // { text: Number.parseFloat(invoice.remainingAmount).toFixed(1), style: "gstData" },
            // { text: invoice.duration, style: "gstData" },
            // { text: invoice.paymentType, style: "gstData" },
            // { text: invoice.status, style: "gstData" },
            // { text: invoice.transactionType, style: "gstData" },
            { text: invoice.gstType, style: "gstData" }, { text: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(invoice.IGST).toFixed(1), style: "gstHeaderBasic" }, { text: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(invoice.SGST).toFixed(1), style: "gstHeaderBasic" }, { text: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(invoice.CGST).toFixed(1), style: "gstHeaderBasic" }, { text: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(invoice.GST_3).toFixed(1), style: "gstHeaderBasic" }, { text: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(invoice.GST_5).toFixed(1), style: "gstHeaderBasic" }, { text: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(invoice.GST_12).toFixed(1), style: "gstHeaderBasic" }, { text: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(invoice.GST_18).toFixed(1), style: "gstHeaderBasic" }, { text: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(invoice.GST_28).toFixed(1), style: "gstHeaderBasic" }, { text: invoice.voucherType, style: "gstData" }]
            // { text: invoice.firmName, style: "gstData" },
            );
        }
    });
    return dd;
};

/***/ }),
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Buyer___ = __webpack_require__(1234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BuyerList___ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//





var mapBuyerActions = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])('Buyer')['mapActions'];

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBuyer: true
    };
  },

  components: {
    Buyer: __WEBPACK_IMPORTED_MODULE_1__Buyer___["a" /* default */],
    BuyerList: __WEBPACK_IMPORTED_MODULE_2__BuyerList___["a" /* default */]
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapBuyerActions(['SET_SELECTED_CUSTOMER']), {
    tabSelected: function tabSelected(index) {
      this.isBuyer = index ? false : true;
    }
  }),
  created: function created() {
    var buyerId = this.$route.params.buyerId;

    this.SET_SELECTED_CUSTOMER(buyerId);
    var isBuyer = this.$route.params.isBuyer;

    if (isBuyer != undefined || isBuyer != null) {
      this.isBuyer = isBuyer == 'true' ? true : false;
    }
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    var buyerId = to.params.buyerId;

    this.SET_SELECTED_CUSTOMER(buyerId);
    next();
  }
});

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BuyerInfo_vue__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BuyerItems_vue__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BuyerInvoiceExpansion_vue__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];

var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* createNamespacedHelpers */])('Buyer')['mapGetters'];
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['isBuyer'],
  data: function data() {
    return {
      panel: [false],
      transactionView: false
    };
  },

  components: {
    BuyerInfo: __WEBPACK_IMPORTED_MODULE_1__BuyerInfo_vue__["default"],
    BuyerItems: __WEBPACK_IMPORTED_MODULE_2__BuyerItems_vue__["a" /* default */],
    BuyerInvoiceExpansion: __WEBPACK_IMPORTED_MODULE_3__BuyerInvoiceExpansion_vue__["a" /* default */]
  },
  created: function created() {
    // add 'equalTo' filter for tenant filteration
    this.$bindAsArray('buyers', this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('sellers', this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('firms', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("productRateCategories", this.$root.$firebaseRefs.productRateCategory.orderByChild('brand').equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapBuyerGetters(['selectedBuyer']), mapGlobalGetters(['selectedBrand']), {
    emptyText: function emptyText() {
      if (this.isBuyer) {
        return "Please select a Customer or Create a New Customer";
      } else {
        return "Please select a Supplier or Create a New Supplier";
      }
    }
  }),
  methods: {},
  watch: {
    "$route.params.buyerId": {
      handler: function handler(val) {
        if (this.panel[0] != false) {
          this.panel[0] = false;
        }
        this.transactionView = false;
      },

      deep: true
    }
  }
});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
var mapBuyerActions = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Buyer")["mapActions"];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Buyer")["mapGetters"];

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isBuyer: {},
    newBuyer: {},
    buyers: {
      type: Array
    },
    sellers: {
      type: Array
    },
    firms: {
      type: Array
    },
    buyerIdProvided: {},
    productRateCategories: {
      type: Array
    }
  },
  data: function data() {
    var _this = this;

    return {
      userInfoIsValid: false,
      formHasErrors: false,
      snackbar: false,
      expansion: false,
      timeout: 3000,
      valid: true,
      zipCode: null,
      addressSuggestions: [],
      errorMessages: [],
      name: {
        value: "",
        rules: [function (v) {
          return !!v || "Name is required";
        }, function (v) {
          return v && v.length <= 50 || "Name must be less than 100 characters";
        }, function (v) {
          return v && v.length >= 3 || "Name must be more than 3 characters";
        }]
      },
      propName: {
        value: ""
      },
      localAddress: {
        value: ""
      },
      identityType: {
        value: ""
      },
      identityNumber: {
        value: ""
      },
      mobile: {
        value: "",
        rules: [function (v) {
          if (!v) {
            return true;
          } else {
            return (/^$/.test(v) || /^(\+91|\+91\-|0)?[6789]\d{9}$/.test(v) || "Mobile number is wrong"
            );
          }
        }]
      },
      email: {
        value: "",
        rules: [function (v) {
          if (!v) {
            return true;
          } else {
            return (/^$/.test(v) || /.@./.test(v) || "E-mail must be valid"
            );
          }
        }]
      },
      village: {
        value: ""
      },
      block: {
        value: ""
      },
      tehsil: {
        value: ""
      },
      district: {
        value: ""
      },
      state: {
        value: ""
      },
      country: {
        value: ""
      },
      GST_user: {
        value: ""
      },
      GST_type: {
        value: ""
      },
      openingBalance: {
        value: 0
      },
      openingBalanceDate: {
        value: null
      },
      datepicker: null,
      GST_number: {
        value: "",
        rules: [function (v) {
          var obj = _this.gState.find(function (o) {
            return o.state === _this.state.value;
          });
          var reg = /^$/;
          if (obj && obj.code) {
            reg = new RegExp("^([" + obj.code + "]){2}[A-Z\\a-z]{5}\\d{4}[A-Z\\a-z]{1}[A-Z\\a-z\\d]{1}[Z\\z]{1}[A-Z\\a-z\\d]{1}");
          }
          return v == undefined || /^$/.test(v) || reg.test(v) || "GST number must be Valid";
        }]
      },
      firm_type: {
        value: ""
      },
      category: "",
      purchaseType: {
        value: ""
      },
      age: {
        value: ""
      },
      gender: {
        value: ""
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand"]), mapGlobalGetters({
    gIdentityType: "identityType",
    gVillage: "village",
    gBlock: "block",
    gTehsil: "tehsil",
    gDistrict: "district",
    gState: "state",
    gCountry: "country",
    gGender: "gender",
    gGST_Type: "GST_Type",
    gFirmType: "firmType",
    gPurchaseType: "purchaseType"
  }), mapBuyerGetters(["selectedBuyer"]), {
    form: function form() {
      return {
        name: this.name,
        propName: this.propName,
        localAddress: this.localAddress,
        identityNumber: this.identityNumber,
        mobile: this.mobile
      };
    },
    isCreateOrUpdate: function isCreateOrUpdate() {
      if (this.newBuyer) {
        return "Create & Transfer";
      }
      if (this.selectedBuyer === "-1" || this.buyerIdProvided === "") {
        return "Create";
      } else {
        return "Update";
      }
    },
    getBuyers: function getBuyers() {
      var _this2 = this;

      return this.buyers.filter(function (item) {
        return item["brand"] === _this2.selectedBrand;
      });
    },
    getSeller: function getSeller() {
      var _this3 = this;

      return this.sellers.filter(function (item) {
        return item["brand"] === _this3.selectedBrand;
      });
    },
    filteredProductRateCategories: function filteredProductRateCategories() {
      return this.productRateCategories.map(function (cat) {
        return {
          text: cat.name,
          value: cat['.key']
        };
      });
    },
    candidate: function candidate() {
      if (this.isBuyer) {
        return this.getBuyers;
      } else {
        return this.getSeller;
      }
    },

    // candidate() {
    //   if (this.isBuyer) {
    //     return this.buyers;
    //   } else {
    //     return this.seller;
    //   }
    // },
    identityNumeberError: function identityNumeberError() {
      if (this.identityNumber.value) {
        var error = null;
        switch (this.identityType.value) {
          case "Voter ID":
            // 3 alpha, 7 digit 
            error = /^([a-zA-Z]){3}([0-9]){7}?$/g.test(this.identityNumber.value) ? null : 'Enter valid Voter ID';
            break;
          case "Adhaar ID":
            // 16 or 12 digit number 
            error = /^(\d{16}|\d{12})$/g.test(Number(this.identityNumber.value)) ? null : 'Enter valid Adhaar ID';
            break;
          case "Driving License":
            // 2 alpha, 2 digit, 4 digit, 7 digit  
            error = /^([a-zA-Z]{2})(\d{2})(\d{4})(\d{7})$/g.test(this.identityNumber.value) ? null : 'Enter valid Driving License';
            break;
          case "Pan Card":
            // 5 alpha, 4 digit, 1 alpha 
            error = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}$/g.test(this.identityNumber.value) ? null : 'Enter valid PAN Card';
            break;
          case "Samagra Id":
            // 9 digit number  
            error = /^(\d{9})$/g.test(Number(this.identityNumber.value)) ? null : 'Enter valid Samagra ID';
            break;
          default:
            error = 'Select Identity type';
            break;
        }
        return error;
      }
    }
  }),
  created: function created() {
    var _this4 = this;

    this.addressSuggestions = sessionStorage.getItem("addressSuggestions").split(',');
    setTimeout(function () {
      if (_this4.$route.params.buyerId == -1) {
        _this4.expansion = true;
      } else {
        _this4.loadBuyer(_this4.$route.params.buyerId);
        _this4.expansion = false;
      }

      if (_this4.buyerIdProvided) {
        debugger;
        _this4.SET_SELECTED_CUSTOMER(_this4.buyerIdProvided);
        _this4.loadBuyer(_this4.buyerIdProvided);
        _this4.expansion = true;
      }
    }, 1000);

    if (this.newBuyer) {
      this.selectedBuyer = -1;
    } else {
      var buyerId = this.$route.params.buyerId;

      if (buyerId !== "-1" && buyerId) {
        this.SET_SELECTED_CUSTOMER(buyerId);
      } else {
        this.clear();
      }
    }
  },
  destroyed: function destroyed() {
    // this.$unbind('buyers')
  },

  watch: {
    selectedBuyer: function selectedBuyer(nval, oval) {
      if (oval !== nval) {
        this.loadBuyer(nval);
        if (nval == -1 || this.buyerIdProvided) {
          this.expansion = true;
          // this.getAndSetDefaultValues();
        } else {
          this.expansion = false;
        }
      }
    },
    selectedBrand: function selectedBrand() {
      // this.getAndSetDefaultValues();
    },
    candidate: function candidate(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.loadBuyer(this.selectedBuyer);
      }
    },

    "GST_user.value": {
      handler: function handler(newVal, oldVal) {
        if (newVal === "No") {
          this.GST_type.value = "";
          this.GST_number.value = "";
        }
      },

      deep: true
    },
    '$route.params.buyerId': function $routeParamsBuyerId(id) {
      if (id == -1) {
        this.expansion = true;
        this.clear();
      } else {
        this.expansion = false;
      }
    }
  },
  mounted: function mounted() {
    // this.identityType.value = this.gIdentityType[0];
    // this.village.value = this.gVillage[0];
    // this.block.value = this.gBlock[0];
    // this.tehsil.value = this.gTehsil[0];
    // this.district.value = this.gDistrict[0];
    // this.state.value = this.gState[0];
    // this.country.value = this.gCountry[0];
  },

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapBuyerActions(["ADD_CUSTOMER", "SET_SELECTED_CUSTOMER"]), {
    setLocationBasedOnZipCode: function setLocationBasedOnZipCode() {
      var _this5 = this;

      var reg = /^[1-9][0-9]{5}$/;
      console.log(this.zipCode);
      if (this.zipCode && reg.test(this.zipCode)) {
        console.log("change");
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://api.postalpincode.in/pincode/' + this.zipCode).then(function (response) {
          var data = response.data[0].PostOffice[0];
          _this5.gDistrict.push(data.District);
          _this5.gTehsil.push(data.Block);
          setTimeout(function () {
            _this5.country.value = data.Country;
            _this5.district.value = data.District;
            _this5.state.value = data.State;
            _this5.tehsil.value = data.Block;
          }, 100);
        });
      }
    },
    submit: function submit() {
      var _this6 = this;

      var data = {
        brand: this.selectedBrand,
        name: this.name.value,
        propName: this.propName.value,
        localAddress: this.localAddress.value,
        identityType: this.identityType.value,
        identityNumber: this.identityNumber.value,
        mobile: this.mobile.value,
        village: this.village.value,
        block: this.block.value,
        tehsil: this.tehsil.value,
        district: this.district.value,
        state: this.state.value,
        country: this.country.value,
        age: this.age.value,
        gender: this.gender.value,
        // updatedAt: -1 * new Date().getTime(),
        email: this.email.value,
        firm_type: this.firm_type.value,
        category: this.category,
        GST_user: this.GST_user.value,
        purchaseType: this.purchaseType.value,
        zipCode: this.zipCode
      };
      if (data.identityType && !data.identityNumber) {
        return alert('Identity number is required');
      }
      if (data.identityNumber && !data.identityType) {
        return alert('Identity type is required');
      }
      // if nothing is selected
      if (!data.identityType && !data.identityNumber) {
        delete data.identityType;
        delete data.identityNumber;
      }
      if (this.GST_user.value == "Yes") {
        data["GST_type"] = this.GST_type.value;
        data["GST_number"] = this.GST_number.value;
      }
      if (this.openingBalance.value) {
        data["openingBalance"] = this.openingBalance.value;
      }
      if (this.openingBalanceDate.value) {
        data["openingBalanceDate"] = new Date(this.openingBalanceDate.value).getTime();
      }
      if (this.selectedBuyer === "-1" || this.selectedBuyer === undefined || this.selectedBuyer === null || this.newBuyer) {
        data["createdAt"] = -1 * new Date().getTime();
        this.addBuyer(data);
      } else {
        var candidate = this.candidate.filter(function (item) {
          return item['.key'] == _this6.selectedBuyer;
        })[0];
        var updatedData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
          ".key": this.selectedBuyer,
          updatedAt: -1 * new Date().getTime()
        }, candidate, data);
        this.updateBuyer(updatedData);
      }
    },
    isUnique: function isUnique(buyer) {
      var buyers = this.getBuyers.filter(function (item) {
        return item[".key"] !== buyer[".key"];
      });

      // Mobile Check
      var byMobile = buyers.filter(function (item) {
        return item["mobile"] === buyer["mobile"];
      });

      if (byMobile.length > 0 && !!buyer["mobile"]) {
        return 1;
      }

      // Identity check

      if (buyer['identityNumber'] || buyer['identityType']) {
        var byIdentity = buyers.filter(function (item) {
          return item['identityNumber'] === buyer['identityNumber'] && item['identityType'] === buyer['identityType'];
        });

        if (byIdentity.length > 0 && !!buyer["identityNumber"]) {
          return 2;
        }
      }

      // GST Number
      if (buyer['GST_number'] && buyer['GST_user']) {
        var byGST = buyers.filter(function (item) {
          return item['GST_number'] === buyer['GST_number'] && item['GST_user'] === buyer['GST_user'];
        });
        if (byGST.length > 0 && !!buyer["GST_number"]) {
          return 3;
        }
      }
      return 0;
    },


    addBuyer: function addBuyer(candidate) {
      var code = this.isUnique(candidate);
      if (code != 0) {
        if (code == 1) {
          var byMobile = this.getBuyers.filter(function (item) {
            return item["mobile"] === candidate["mobile"];
          });
          alert("Duplicate Mobile number found -  " + candidate["mobile"] + " already belong to " + byMobile[0]["name"] + ".");
        } else if (code == 2) {
          var byIdentity = this.getBuyers.filter(function (item) {
            return item["identityNumber"] === candidate["identityNumber"];
          });
          alert("Duplicate Identity number found -  " + candidate["identityNumber"] + " already belong to " + byIdentity[0]["name"] + ".");
        } else if (code == 3) {
          var byGST = this.getBuyers.filter(function (item) {
            return item["GST_number"] === candidate["GST_number"];
          });
          alert("Duplicate GST number found -  " + candidate["GST_number"] + " already belong to " + byGST[0]["name"] + ".");
        }
        return;
      }
      var response = null;
      if (this.isBuyer) {
        response = this.$root.$firebaseRefs.buyer.push(candidate);
        this.snackbar = true;
        this.snackbarText = "Buyer added succesfully";
      } else {
        response = this.$root.$firebaseRefs.seller.push(candidate);
        this.snackbar = true;
        this.snackbarText = "Seller added succesfully";
      }
      if (this.newBuyer) {
        // new buyer create to tranfer emit the event
        this.$emit("onCreate", response["key"]);
      } else {
        this.SET_SELECTED_CUSTOMER(response["key"]);
        this.$router.push({ path: "/buyers/" + response["key"] });
      }
    },
    updateBuyer: function updateBuyer(item) {
      var code = this.isUnique(item);
      if (code != 0) {
        if (code == 1) alert("Mobile Number already Exists");else if (code == 2) alert("Identity Number already Exists");else if (code == 3) alert("GST Number already Exists");
        return;
      }
      var copy = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, item);
      delete copy[".key"];
      if (this.isBuyer) {
        this.$root.$firebaseRefs.buyer.child(item[".key"]).set(copy);
        alert("Buyer Updated");
      } else {
        this.$root.$firebaseRefs.seller.child(item[".key"]).set(copy);
        alert("Seller Updated");
      }
    },
    clear: function clear() {
      var _this7 = this;

      var defaultFirm = this.firms.filter(function (item) {
        return item["brand"] === _this7.selectedBrand && !!item["defaultFirm"];
      })[0];
      var selectedFirmState = defaultFirm["state"];
      this.errorMessages = [];
      this.formHasErrors = false;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.form).forEach(function (f) {
        if (_this7.$refs[f]) {
          _this7.$refs[f].reset();
        }
      });
      this.name.value = "";
      this.propName.value = "";
      this.localAddress.value = "";
      this.identityType.value = "";
      this.identityNumber.value = "";
      this.mobile.value = "";
      this.village.value = "";
      this.block.value = "";
      this.tehsil.value = "";
      this.district.value = "";
      this.state.value = selectedFirmState;
      this.country.value = "";
      this.age.value = "";
      this.gender.value = "";
      this.GST_type.value = "";
      this.firm_type.value = "";
      this.category = "";
      this.purchaseType.value = "";
      this.email.value = "";
      this.GST_number.value = "";
      this.GST_user.value = "";
      this.zipCode = "";
      this.openingBalance.value = 0, this.openingBalanceDate.value = null;
    },
    loadBuyer: function loadBuyer(val) {
      if (val !== "-1" && this.candidate) {
        if (this.candidate.length) {
          var candidate = this.candidate.filter(function (item) {
            return item['.key'] == val;
          })[0];
          if (candidate) {
            var name = candidate.name,
                propName = candidate.propName,
                localAddress = candidate.localAddress,
                identityType = candidate.identityType,
                identityNumber = candidate.identityNumber,
                mobile = candidate.mobile,
                village = candidate.village,
                block = candidate.block,
                tehsil = candidate.tehsil,
                district = candidate.district,
                state = candidate.state,
                country = candidate.country,
                age = candidate.age,
                gender = candidate.gender,
                GST_type = candidate.GST_type,
                purchaseType = candidate.purchaseType,
                email = candidate.email,
                GST_number = candidate.GST_number,
                firm_type = candidate.firm_type,
                category = candidate.category,
                GST_user = candidate.GST_user,
                zipCode = candidate.zipCode,
                openingBalance = candidate.openingBalance,
                openingBalanceDate = candidate.openingBalanceDate;


            this.name.value = name;
            this.propName.value = propName || null;
            this.localAddress.value = localAddress || null;
            this.identityType.value = identityType || null;
            this.identityNumber.value = identityNumber || null;
            this.mobile.value = mobile || null;
            this.village.value = village || null;
            this.block.value = block || null;
            this.tehsil.value = tehsil || null;
            this.district.value = district || null;
            this.state.value = state || null;
            this.country.value = country || null;
            this.age.value = age || null;
            this.gender.value = gender || null;
            this.GST_type.value = GST_type || null;
            this.purchaseType.value = purchaseType || null;
            this.email.value = email || null;
            this.GST_number.value = GST_number || null;
            this.firm_type.value = firm_type || null;
            this.category = category || null;
            this.GST_user.value = GST_user || null;
            this.zipCode = zipCode || null;
            this.openingBalance.value = openingBalance || null;
            // this.openingBalanceDate.value = new Date(openingBalanceDate).toISOString().substr(0, 10);
            this.openingBalanceDate.value = openingBalanceDate ? new Date(openingBalanceDate).toISOString().substr(0, 10) : new Date().toISOString().substr(0, 10);
            if (!this.gDistrict.includes(district)) {
              this.gDistrict.push(district);
            }
            if (!this.gTehsil.includes(tehsil)) {
              this.gTehsil.push(tehsil);
            }
            return;
          }
        }
      }
      this.clear();
    }
  }),
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    var buyerId = to.params.buyerId;

    if (buyerId) {
      this.SET_SELECTED_CUSTOMER(buyerId);
    }
    next();
  }
});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


//import Invoice from '../Invoice/'

var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])('Buyer')['mapGetters'];

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    // Invoice
  },
  props: ['isBuyer'],
  data: function data() {
    return {
      dialog: false,
      items: [],
      // invoices: [],
      firms: [],
      firmById: {},
      bankById: {},
      searchtext: ''
    };
  },
  created: function created() {},

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapBuyerGetters(['selectedBuyer']), {
    //...mapGlobalGetters(['selectedBrand','adminEmail','finYear']),
    isBuyerSelected: function isBuyerSelected() {
      if (this.selectedBuyer !== -1 && this.selectedBuyer !== "-1") {
        return true;
      }
      return false;
    }
  }),
  methods: {
    openClosedTransactions: function openClosedTransactions() {
      this.$parent.$emit('buyer.statements.view');
    },
    getCurrentUserDetails: function getCurrentUserDetails() {
      var buyer = this.buyerById[this.selectedBuyer];
      var seller = this.sellerById[this.selectedBuyer];
      this.isBuyer = buyer && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(buyer).length != 0 ? true : false;
    },
    openInvoice: function openInvoice() {
      this.$router.push({ path: '/invoice-create/' + this.selectedBuyer + '/' + this.isBuyer });
    }
  },

  destroyed: function destroyed() {
    // this.$unbind('items')
    // this.$unbind('invoices')
  }
});

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BuyerInvoices_vue__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__BuyerTransactions_vue__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BuyerStatements_vue__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];

var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* createNamespacedHelpers */])('Buyer')['mapGetters'];
/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['isBuyer', 'buyers', 'sellers'],
  data: function data() {
    return {};
  },

  components: {
    BuyerInvoices: __WEBPACK_IMPORTED_MODULE_1__BuyerInvoices_vue__["a" /* default */],
    BuyerTransactions: __WEBPACK_IMPORTED_MODULE_2__BuyerTransactions_vue__["a" /* default */],
    BuyerStatements: __WEBPACK_IMPORTED_MODULE_3__BuyerStatements_vue__["a" /* default */]
  },
  created: function created() {
    // add 'equalTo' filter for tenant filteration
    console.log("invoice is loading");
    this.$bindAsArray('invoices', this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapBuyerGetters(['selectedBuyer']), mapGlobalGetters(['selectedBrand', 'brandFinYear'])),
  methods: {}
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InvoicePayment___ = __webpack_require__(410);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])('Buyer')['mapGetters'];

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    InvoicePayment: __WEBPACK_IMPORTED_MODULE_2__InvoicePayment___["a" /* default */]
  },
  props: {
    isBuyer: {
      type: Boolean
    },
    invoices: {
      type: Array
    }
  },
  data: function data() {
    return {
      dialog: false,
      selectedInvoiceId: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapBuyerGetters(['selectedBuyer']), mapGlobalGetters(['selectedBrand']), {
    invoiceList: function invoiceList() {
      var _this = this;

      // Add group by days also
      // { header: 'Today' }
      if (this.invoices) {
        var inv = this.invoices.filter(function (item) {
          // return item['buyerId'] === this.selectedBuyer && item['brand'] === this.selectedBrand && (item['status'] === 'due' || item['status'] === 'partial') 
          return item['buyerId'] === _this.selectedBuyer && item.deleted != true && item['brand'] === _this.selectedBrand && (item['status'] === 'due' || item['status'] === 'partial');
        });
        return inv.map(function (item) {
          var localDate = new Date(item['date']);
          item['date'] = localDate.toDateString();
          return item;
        });
      }
      return [];
    }
  }),
  methods: {
    openInvoice: function openInvoice(selectedInvoiceId) {
      this.selectedInvoiceId = selectedInvoiceId;
      this.dialog = true;
    },
    updateInvoice: function updateInvoice() {
      console.log('Update Invoice Called');
    },
    openClosedTransactions: function openClosedTransactions() {
      this.$parent.$emit('buyer.statements.view');
    }
  },
  destroyed: function destroyed() {
    // this.$unbind('invoices')
  }
});

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(411);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1757b9d0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1246);
function injectStyle (ssrContext) {
  __webpack_require__(1245)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1757b9d0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_digitsToWords_js__ = __webpack_require__(35);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* createNamespacedHelpers */])("Buyer")["mapGetters"];

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    selectedInvoiceId: {
      required: true
    },
    isBuyer: {
      required: true
    },
    firms: {
      type: Array
    },
    banks: {
      type: Array
    },
    buyers: {
      type: Array
    },
    sellers: {
      type: Array
    }
  },
  data: function data() {
    return {
      invoiceData: null,
      invoiceDataAvailable: false,
      headers: [{
        text: "Name",
        sortable: false,
        value: "productName",
        class: "primary--text font-weight-bold"
      },
      // { text: "HSN code", sortable: false, value: "HSN_code", class: "primary--text font-weight-bold" },
      // { text: "GST", sortable: false, value: "taxableGST_rate", class: "primary--text font-weight-bold" },
      {
        text: "Unit",
        sortable: false,
        value: "unit",
        class: "primary--text font-weight-bold"
      }, {
        text: "Rate",
        sortable: false,
        value: "rate",
        class: "primary--text font-weight-bold"
      }, {
        text: "Quantity",
        sortable: false,
        value: "quantity",
        class: "primary--text font-weight-bold"
      }, {
        text: "Basic Price",
        sortable: false,
        value: "basicPrice",
        class: "primary--text font-weight-bold"
      }, {
        text: "GST value",
        sortable: false,
        value: "GSTValue",
        class: "primary--text font-weight-bold"
      }, {
        text: "Total Price",
        sortable: false,
        value: "totlePrice",
        class: "primary--text font-weight-bold"
      }, {
        text: "CGST value ( %)",
        sortable: false,
        value: "CGST",
        class: "primary--text font-weight-bold"
      }, {
        text: "SGST value ( %)",
        sortable: false,
        value: "SGST",
        class: "primary--text font-weight-bold"
      }, {
        text: "IGST value ( %)",
        sortable: false,
        value: "IGST",
        class: "primary--text font-weight-bold"
      }],
      datepicker: null,
      closedDate: new Date().toISOString().substr(0, 10),
      additionalDiscount: 0,
      transferTypeDialog: false,
      transactionDialog: false,
      GST_Val_total: {
        CGST_val: 0,
        SGST_val: 0,
        IGST_val: 0
      },
      transferDetails: {
        accountNumber: "",
        accountHolderName: "",
        bankName: "",
        IFSCcode: "",
        remark: ""
      },
      roundOff: 2,
      amountFromCashDisabled: true,
      amountFromBankDisabled: true,
      currentUser: {},
      availableBalance: 0,
      nowDepositedIsDirty: false,
      // currentUser: {},
      hintText: null
    };
  },
  mounted: function mounted() {
    this.getCurrentUser();
  },
  created: function created() {
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild("brand").equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, mapBuyerGetters(["selectedBuyer"]), mapGlobalGetters(["selectedBrand"]), {
    firmsByBrand: function firmsByBrand() {
      var _this = this;

      return this.firms.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      }).map(function (item) {
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
    },
    banksByFirms: function banksByFirms() {
      var _this2 = this;

      return this.banks.filter(function (item) {
        return item["brand"] === _this2.selectedBrand && item["firm"] === _this2.invoiceData.firm;
      }).map(function (item) {
        return {
          account: item,
          text: item["bankName"],
          value: item[".key"]
        };
      });
    }
  }),
  watch: {
    selectedInvoiceId: function selectedInvoiceId(oldVal, newVal) {
      var _this3 = this;

      this.invoiceData = null;
      this.invoiceData = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.invoices.filter(function (item) {
        return item[".key"] == _this3.selectedInvoiceId;
      })[0]));
      this.invoiceDataAvailable = true;
      this.invoiceData.status = "paid";
      this.invoiceData.transactionType = "";
      this.invoiceData.amountFromCash = this.invoiceData.remainingAmount;
      this.invoiceData.amountFromBank = 0;
      this.calculateTotal();
    },
    transactionDialog: function transactionDialog(oldVal, newVal) {
      this.nowDepositedIsDirty = true;
    },

    "invoiceData.firm": {
      handler: function handler(newVal, oldVal) {
        if (oldVal !== newVal) {
          this.getFirmAndBankBalance();
          this.calculateGSTType();
        }
      },

      deep: true
    },
    "invoiceData.paymentType": {
      handler: function handler(newVal, oldVal) {
        if (oldVal !== newVal) {
          if (this.firm != "") this.getFirmAndBankBalance();
          this.calculateTotal();
        }
      },

      deep: true
    },
    additionalDiscount: {
      handler: function handler(newVal, oldVal) {
        if (oldVal !== newVal) {
          this.calculateTotal();
        }
      },

      deep: true
    },
    "invoiceData.bank": {
      handler: function handler(newVal, oldVal) {
        if (oldVal !== newVal) {
          this.getFirmAndBankBalance();
        }
      },

      deep: true
    },
    "invoiceData.amountFromCash": {
      handler: function handler(newVal, oldVal) {
        if (oldVal !== newVal) {
          this.calculateTotal();
        }
        this.hintText = this.invoiceData.amountFromCash ? _.startCase(Object(__WEBPACK_IMPORTED_MODULE_6__utils_digitsToWords_js__["a" /* digitsToWords */])(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(this.invoiceData.amountFromCash))) : null;
      },

      deep: true
    },
    "invoiceData.amountFromBank": {
      handler: function handler(newVal, oldVal) {
        if (oldVal !== newVal) {
          this.calculateTotal();
        }
        this.hintText = this.invoiceData.amountFromBank ? _.startCase(Object(__WEBPACK_IMPORTED_MODULE_6__utils_digitsToWords_js__["a" /* digitsToWords */])(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(this.invoiceData.amountFromBank))) : null;
      },

      deep: true
    },
    "invoiceData.discountAmount": {
      handler: function handler(newVal, oldVal) {
        if (oldVal !== newVal) {
          this.invoiceData.amountFromCash = 0;
          this.invoiceData.amountFromBank = 0;
          this.calculateTotal();
        }
      },

      deep: true
    },
    "invoiceData.transactionType": {
      handler: function handler(newVal, oldVal) {
        if (oldVal !== newVal) {
          switch (newVal) {
            case "Partial Paid":
              {
                this.invoiceData.status = "partial";
                this.invoiceData.transactionType = "Partial Paid";
                break;
              }
            case "Credit":
              {
                this.invoiceData.status = "paid";
                this.invoiceData.transactionType = "Credit";
                break;
              }
          }
          this.calculateTotal();
        }
      },

      deep: true
    },
    roundOff: function roundOff(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.calculateTotal();
      }
    }
  },
  methods: {
    calculateTotal: function calculateTotal() {
      var discountAmount = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(this.additionalDiscount);
      var amountFromBank = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(this.invoiceData.amountFromBank);
      var amountFromCash = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(this.invoiceData.amountFromCash);
      var totalAmount = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(this.invoiceData.totalAmount);
      var paidAmount = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(this.invoiceData.paidAmount);
      switch (this.invoiceData.paymentType) {
        case "Cash":
          {
            this.invoiceData.amountFromBank = 0;
            this.amountFromBankDisabled = true;
            this.amountFromCashDisabled = false;
            this.invoiceData.amountToBePaid = totalAmount - (discountAmount + amountFromCash + paidAmount);
            // this.invoiceData.paidAmount = 0;
            break;
          }

        case "Bank Account":
          {
            this.amountFromCashDisabled = true;
            this.amountFromBankDisabled = false;
            this.invoiceData.amountFromCash = 0;
            this.invoiceData.amountToBePaid = totalAmount - (discountAmount + amountFromBank + paidAmount);
            //this.invoiceData.paidAmount = 0;
            break;
          }
        case "CashAndBank Account":
          {
            this.amountFromCashDisabled = false;
            this.amountFromBankDisabled = false;
            var totalBankAndCash = amountFromCash + amountFromBank;
            this.invoiceData.amountToBePaid = totalAmount - (discountAmount + totalBankAndCash + paidAmount);
            //this.paidAmount = 0;
            break;
          }
      }
      this.invoiceData.amountToBePaid = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(this.invoiceData.amountToBePaid).toFixed(this.roundOff);
      this.invoiceData.totalAmount = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(this.invoiceData.totalAmount).toFixed(this.roundOff);
    },
    getFirmAndBankBalance: function getFirmAndBankBalance() {
      var _this4 = this;

      switch (this.invoiceData.paymentType) {
        case "Cash":
          {
            if (this.invoiceData.firm) {
              var firm = this.firms.filter(function (item) {
                return item["brand"] === _this4.selectedBrand && item[".key"] == _this4.invoiceData.firm;
              });
              this.availableBalance = firm.length && (firm[0]["amount"] ? firm[0]["amount"] : 0);
            } else {
              this.availableBalance = 0;
            }
            break;
          }
        case "Bank Account":
          {
            if (this.invoiceData.bank) {
              var bank = this.banks.filter(function (item) {
                return item["brand"] === _this4.selectedBrand && item[".key"] == _this4.invoiceData.bank;
              });
              this.availableBalance = bank.length && (bank[0]["amount"] ? bank[0]["amount"] : 0);
            } else {
              this.availableBalance = 0;
            }
            break;
          }
        case "CashAndBank Account":
          {
            if (this.invoiceData.firm && this.invoiceData.bank) {
              var _firm = this.firms.filter(function (item) {
                return item["brand"] === _this4.selectedBrand && item[".key"] == _this4.invoiceData.firm;
              });
              var _bank = this.banks.filter(function (item) {
                return item["brand"] === _this4.selectedBrand && item[".key"] == _this4.invoiceData.bank;
              });
              this.availableBalance = _firm.length && _bank.length && (_bank[0]["amount"] ? _bank[0]["amount"] : 0) + (_firm[0]["amount"] ? _firm[0]["amount"] : 0);
            } else {
              this.availableBalance = 0;
            }
            break;
          }
      }
    },
    resetAmounts: function resetAmounts() {
      this.amountFromCash = 0;
      this.amountFromBank = 0;
      this.discountAmount = 0;
    },
    calculateGSTType: function calculateGSTType() {
      var _this5 = this;

      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.currentUser).length === 0) {
        this.getCurrentUser();
      }
      this.GST_Val_total.SGST_val = 0;
      this.GST_Val_total.CGST_val = 0;
      this.GST_Val_total.IGST_val = 0;
      this.invoiceData.items.map(function (item, index) {
        var GST = item["taxableGST_rate"];
        var firm = _this5.firms.filter(function (item) {
          return item[".key"] == _this5.invoiceData.firm;
        })[0];
        if (_this5.invoiceData.firm && _this5.currentUser && _this5.currentUser.state && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(GST) && firm.state === _this5.currentUser.state) {
          item["CGST_val"] = item["GSTValue"] / 2;
          item["CGST"] = GST / 2;
          item["SGST_val"] = item["GSTValue"] / 2;
          item["SGST"] = GST / 2;
          item["IGST"] = 0;
          item["IGST_val"] = 0;
          _this5.GST_Val_total.SGST_val += __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item["SGST_val"]);
          _this5.GST_Val_total.CGST_val += __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item["CGST_val"]);
          _this5.GST_Val_total.IGST_val += __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item["IGST_val"]);
          _this5.invoiceData.gstType = "SGST|CGST";
        } else {
          item["IGST"] = GST;
          item["CGST"] = 0;
          item["SGST"] = 0;
          item["IGST_val"] = item["GSTValue"];
          item["CGST_val"] = 0;
          item["SGST_val"] = 0;
          _this5.GST_Val_total.SGST_val += __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item["SGST_val"]);
          _this5.GST_Val_total.CGST_val += __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item["CGST_val"]);
          _this5.GST_Val_total.IGST_val += __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item["IGST_val"]);
          _this5.invoiceData.gstType = "IGST";
        }
        _this5.invoiceData.items[index] = item;
      });
    },
    getCurrentUser: function getCurrentUser() {
      var _this6 = this;

      var buyer = this.buyers.filter(function (item) {
        return item[".key"] === _this6.invoiceData.buyerId;
      })[0];
      var seller = this.sellers.filter(function (item) {
        return item[".key"] === _this6.invoiceData.buyerId;
      })[0];
      this.currentUser = buyer && buyer.state ? buyer : seller && seller.state ? seller : {};
    },

    // getCurrentUserOne() {
    //   let buyer = this.buyerById[this.selectedBuyer];
    //   let seller = this.sellerById[this.selectedBuyer];
    //   this.isUserBuyer = buyer ? true : false;
    //   this.currentUser =
    //     buyer && buyer.state ? buyer : seller && seller.state ? seller : {};
    // },
    createReceipt: function createReceipt(invoiceData) {
      var firm = this.firms.find(function (item) {
        return item[".key"] == invoiceData.firm;
      });
      var firmReceiptCount = invoiceData.isBuyer ? firm.lastReceiptCount ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(firm.lastReceiptCount) + 1 : 1 : firm.lastReceiptCountSeller ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(firm.lastReceiptCountSeller) + 1 : 1;
      var amountToBePaid = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash) + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank);
      var receipt = {
        date: invoiceData.closedDate,
        firm: invoiceData.firm,
        isBuyer: invoiceData.isBuyer,
        buyerId: invoiceData.buyerId,
        brand: invoiceData.brand,
        amount: amountToBePaid,
        remainingAmount: 0,
        receiptNumber: firmReceiptCount,
        paymentType: invoiceData.paymentType,
        settledInvoiceDetails: [{
          invoiceId: invoiceData[".key"],
          settledAmount: amountToBePaid,
          status: invoiceData.status
        }]
      };

      if (invoiceData.paymentType == "Bank") {
        receipt["transferType"] = invoiceData.transferType;
        receipt["transferDetails"] = invoiceData.transferDetails;
      }
      console.log(receipt);
      this.$root.$firebaseRefs.customerPayments.push(receipt);
      if (invoiceData.isBuyer) {
        this.$root.$firebaseRefs.firm.child(receipt.firm).update({
          lastReceiptCount: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(receipt.receiptNumber)
        }, function () {
          //console.info("last receiptNumber updated...");
        });
      } else {
        this.$root.$firebaseRefs.firm.child(receipt.firm).update({
          lastReceiptCountSeller: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(receipt.receiptNumber)
        }, function () {
          //console.info("last receiptNumber updated...");
        });
      }
    },
    updateInvoice: function updateInvoice() {
      var closedDate = new Date(this.closedDate);
      var todayDate = new Date();
      var selectedDate = new Date(closedDate.getFullYear(), closedDate.getMonth(), closedDate.getDate(), todayDate.getHours(), todayDate.getMinutes(), todayDate.getSeconds());
      this.invoiceData.closedDate = new Date(selectedDate).getTime();
      // this.invoiceData.date = this.invoiceData.closedDate;
      if (this.additionalDiscount) {
        this.invoiceData.totalAmount = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(this.invoiceData.totalAmount) - __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(this.additionalDiscount);
        this.invoiceData.discountAmount = (this.invoiceData.discountAmount ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(this.invoiceData.discountAmount) : 0) + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(this.additionalDiscount);
      }
      this.invoiceData[".key"] = this.selectedInvoiceId;
      var amountFromBank = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(this.invoiceData.amountFromBank);
      var amountFromCash = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(this.invoiceData.amountFromCash);
      var totalAmount = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(this.invoiceData.totalAmount);

      var paidAmount = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(this.invoiceData.paidAmount);

      switch (this.invoiceData.paymentType) {
        case "Cash":
          {
            switch (this.invoiceData.transactionType) {
              case "Partial Paid":
                {
                  this.invoiceData.remainingAmount = totalAmount - (amountFromCash + paidAmount);
                  this.invoiceData.paidAmount = paidAmount + amountFromCash;
                  break;
                }
              case "Credit":
                {
                  this.invoiceData.remainingAmount = 0;
                  this.invoiceData.paidAmount = totalAmount;
                  break;
                }
            }
            break;
          }

        case "Bank Account":
          {
            switch (this.invoiceData.transactionType) {
              case "Partial Paid":
                {
                  this.invoiceData.remainingAmount = totalAmount - (amountFromBank + paidAmount);
                  this.invoiceData.paidAmount = paidAmount + amountFromBank;
                  break;
                }
              case "Credit":
                {
                  this.invoiceData.remainingAmount = 0;
                  this.invoiceData.paidAmount = totalAmount;
                  break;
                }
            }
            break;
          }
        case "CashAndBank Account":
          {
            switch (this.invoiceData.transactionType) {
              case "Partial Paid":
                {
                  this.invoiceData.remainingAmount = totalAmount - (amountFromCash + amountFromBank + paidAmount);
                  this.invoiceData.paidAmount = paidAmount + amountFromCash + amountFromBank;
                  break;
                }
              case "Credit":
                {
                  this.invoiceData.remainingAmount = 0;
                  this.invoiceData.paidAmount = totalAmount;
                  break;
                }
            }
            break;
          }
      }
      this.invoiceData.paidAmount = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(this.invoiceData.paidAmount).toFixed(this.roundOff);
      this.invoiceData.remainingAmount = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(this.invoiceData.remainingAmount).toFixed(this.roundOff);
      this.invoiceData["isPayment"] = true;
      this.createReceipt(this.invoiceData);
      this.$emit("updateInvoice", this.invoiceData);
    }
  }
});

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__InvoicePayment___ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__BuyerInfo__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__InvoiceReturn___ = __webpack_require__(1251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_pdfmake__ = __webpack_require__(31);








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* createNamespacedHelpers */])("Buyer")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    InvoicePayment: __WEBPACK_IMPORTED_MODULE_9__InvoicePayment___["a" /* default */],
    BuyerInfo: __WEBPACK_IMPORTED_MODULE_10__BuyerInfo__["default"],
    // InvoiceUpdate,
    InvoiceReturn: __WEBPACK_IMPORTED_MODULE_11__InvoiceReturn___["a" /* default */]
  },
  props: {
    isBuyer: {
      type: Boolean
    },
    invoices: {
      type: Array
    },
    status: {
      type: Array
    },
    header: {
      type: String
    },
    buyers: {
      type: Array
    },
    sellers: {
      type: Array
    },
    returnedInvoices: {
      type: Boolean
    }
  },
  data: function data() {
    var headers = [{ text: "Action", sortable: false, value: "" },
    // { text: 'Invoice Key', sortable: false, value: 'key' },
    { text: "Date", sortable: true, value: "date" }, { text: "Invoice No.", sortable: false, value: "ID" }, { text: "Total Amount", sortable: false, value: "Total" }, { text: "Taxable Amount", sortable: false, value: "Total" }, { text: "GST Amount", sortable: true, value: "gstValue" }, { text: "Paid Amount", sortable: false, value: "Deposite" }, { text: "Due Amount", sortable: false, value: "Remaining" }, { text: "Extra Charge", sortable: false, value: "Total" }, { text: "Discount", sortable: false, value: "Total" }, { text: "Round Off", sortable: false, value: "Total" }, { text: "Duration (in Days)", sortable: false, value: "daysSpent" }, { text: "Days Left", sortable: true, value: "daysLeft" }, { text: "Status", sortable: false, value: "principalValue" }, { text: "Payment Type", sortable: true, value: "paymentType" }, { text: "Firm", sortable: false, value: "firm" },
    // { text: 'Transaction Type', sortable: true, value: 'paymentType' },
    { text: "GST Type", sortable: true, value: "gstType" }, { text: "Place of Supply", sortable: false, value: "Total" }, { text: "Sold By", sortable: false, value: "Total" }, { text: "Transferred From", sortable: false, value: "parentUserName" }];
    if (this.header == "TRANSACTION CLOSE" || this.returnedInvoices) {
      headers.push({ text: "Closed Date", sortable: true, value: "gstType" });
      headers.push({
        text: "Parent Invoice Date (Credit|Debit note)",
        sortable: true,
        value: "gstType"
      });
      headers.push({
        text: "Credit|Debit note ID",
        sortable: true,
        value: "gstType"
      });
    }
    return {
      dialog: false,
      selectedInvoiceId: null,
      assetRate: [],
      remainingAmount: 0,

      updateInvoiceDialog: false,
      returnInvoiceDialog: false,
      updateInvoiceDetail: null,
      returnInvoiceDetail: null,

      transferInvoiceDialog: false,
      transferInvoiceDetail: null,
      transferInvoiceUser: null,
      active: null,
      buyerSelectRequied: [function (v) {
        return !!v || "Select Buyer To transfer invocie";
      }],
      currentUser: null,
      password: null,
      passwordDialog: false,
      currentPasswordReference: null,
      currentPasswordMethod: null,
      headers: headers
    };
  },

  watch: {
    updateInvoiceDialog: function updateInvoiceDialog() {
      if (this.updateInvoiceDialog === false) {
        this.updateInvoiceDetail = null;
      }
    },
    returnInvoiceDialog: function returnInvoiceDialog() {
      if (this.returnInvoiceDialog === false) {
        this.returnInvoiceDetail = null;
      }
    }
  },
  created: function created() {
    this.$bindAsArray("invoiceHistories", this.$root.$firebaseRefs.invoiceHistory.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("customerDeposit", this.$root.$firebaseRefs.customerDeposit.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("termsAndConditions", this.$root.$firebaseRefs.termsAndConditions.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("banks", this.$root.$firebaseRefs.account.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsObject("productById", this.$root.$firebaseRefs.products.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsObject("staff", this.$root.$firebaseRefs.staff.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("estimates", this.$root.$firebaseRefs.estimates.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("customerPayments", this.$root.$firebaseRefs.customerPayments.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("firmSettings", this.$root.$firebaseRefs.firmSettings.orderByChild("brand").equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, mapBuyerGetters(["selectedBuyer"]), mapGlobalGetters(["selectedBrand", "finYear", "roleAndPermission", "brandFinYear"]), mapGlobalGetters({
    gState: "state"
  }), {
    // getDepositeAmount(){
    //   this.getCurrentUserDetails();
    //   return this.currentUser && this.currentUser.remainingAmountFromDeposite;
    // },
    getBalance: function getBalance() {
      // return ((this.remainingAmount ? Number.parseFloat(this.remainingAmount) : 0) + (this.getDepositeAmount ? Number.parseFloat(this.getDepositeAmount) : 0))
      return this.getRemainingBalanceAmount();
    },
    hasInvoiceEditPermission: function hasInvoiceEditPermission() {
      console.log(this.roleAndPermission);
      if (this.roleAndPermission && this.roleAndPermission.permissions && this.roleAndPermission.permissions.length && this.roleAndPermission.permissions.indexOf("INVOICE_EDIT") > -1) {
        return true;
      } else {
        return false;
      }
    },
    hasInvoiceDeletePermission: function hasInvoiceDeletePermission() {
      console.log(this.roleAndPermission);
      if (this.roleAndPermission && this.roleAndPermission.permissions && this.roleAndPermission.permissions.length && this.roleAndPermission.permissions.indexOf("INVOICE_DELETE") > -1) {
        return true;
      } else {
        return false;
      }
    },
    hasInvoiceTransferPermission: function hasInvoiceTransferPermission() {
      if (this.roleAndPermission && this.roleAndPermission.permissions && this.roleAndPermission.permissions.length && this.roleAndPermission.permissions.indexOf("INVOICE_TRANSFER") > -1) {
        return true;
      } else {
        return false;
      }
    },
    invoiceList: function invoiceList() {
      var _this = this;

      var result = [];
      this.remainingAmount = 0;
      if (this.invoices.length && this.finYear) {
        var filteredInvoices = this.invoices.filter(function (item) {
          return item["buyerId"] === _this.selectedBuyer && item["brand"] === _this.selectedBrand && _this.status.includes(item["status"]) && (_this.returnedInvoices ? !!item["return"] : !item["return"]) && item.deleted != true;
        });
        console.log(filteredInvoices);
        filteredInvoices = JSON.parse(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(filteredInvoices));
        // let currentValue = 0;
        // let absoluteValue = 0;
        filteredInvoices.forEach(function (element) {
          // this.remainingAmount += element.remainingAmount ? Number.parseFloat(element.remainingAmount) : 0;
          _this.remainingAmount += element.totalAmount ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(element.totalAmount) : 0;
          _this.remainingAmount -= element.paidAmount ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(element.paidAmount) : 0;
          var localDate = new Date(element["date"]);
          // const localDate2 = element['parentInvoiceDate'] ? new Date(element['parentInvoiceDate']) : null;
          // const localDate3 = element['closedDate'] ? new Date(element['closedDate']) : null;
          var dt2 = new Date();
          var dt1 = localDate;
          var daysSpent = Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24));
          element["dateOfInvoice"] = element["date"];
          // element['date'] = localDate.toLocaleDateString('en-GB')
          // element['parentInvoiceDate'] = localDate2 ? localDate2.toLocaleDateString('en-GB') : '';
          // element['closedDate'] = localDate3 ? localDate3.toLocaleDateString('en-GB') : '';
          element["daysLeft"] = element["duration"] - daysSpent ? element["duration"] - daysSpent : "--";
          element["daysSpent"] = daysSpent;
          element["status"] = element["status"];
          // let time = daysSpent / 365
          var firm = _this.firms.filter(function (item) {
            return item[".key"] == element["firm"];
          })[0];
          if (firm) {
            element["firmID"] = element["firm"];
            element["firm"] = firm["name"];
          } else {
            element["firm"] = "--";
          }

          // New Development
          element["parentUserName"] = "--";
          if (element["originalBuyerId"]) {
            element["parentUserName"] = _this.buyers.filter(function (c) {
              return c[".key"] === String(element["originalBuyerId"]);
            });
            if (element["parentUserName"].length > 0) {
              element["parentUserName"] = element["parentUserName"][0].name;
            } else {
              element["parentUserName"] = "--";
            }
          }
          // End of new Developemt

          result.push(element);
        });
      }
      this.remainingAmount = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.remainingAmount).toFixed(2);
      setTimeout(function () {
        if (result.length && document.getElementById("delete-user-btn")) {
          document.getElementById("delete-user-btn").style.display = "none";
        }
      }, 1000);
      return result;
    },
    transferTo: function transferTo() {
      var _this2 = this;

      if (!this.buyers) return [];
      var buyer = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(this.buyers));
      var sellers = [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(this.sellers));
      var buyerList = buyer.filter(function (c) {
        // return buyer with same brand and remove current user
        return c[".key"] !== _this2.selectedBuyer && c["brand"] === _this2.selectedBrand;
      });
      var sellerList = sellers.filter(function (c) {
        // return sellers with same brand and remove current user
        return c["brand"] === _this2.selectedBrand;
      });
      return [].concat(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(buyerList), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_toConsumableArray___default()(sellerList));
    }
  }),
  methods: {
    getRemainingBalanceAmount: function getRemainingBalanceAmount() {
      var _this3 = this;

      var filteredInvoice = this.invoiceHistories.filter(function (item) {
        return item["brand"] === _this3.selectedBrand && item["buyerId"] === _this3.selectedBuyer &&
        //&& (item.deleted != true)
        !item["deleted"] && (item["returnStatus"] ? item["returnStatus"] == "remaining" && item["status"] == "paid" : true) && (item["isLatest"] != undefined ? item["isLatest"] == true : true);
      });
      var payments = this.customerPayments.filter(function (item) {
        return item["brand"] === _this3.selectedBrand && item["buyerId"] === _this3.selectedBuyer && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item["remainingAmount"]) > 0;
      });

      var customerDeposit = this.customerDeposit.filter(function (item) {
        return item["brand"] === _this3.selectedBrand && item["buyerId"] === _this3.selectedBuyer && (item["type"] === "Advance" || item["type"] === "Opening Balance" || item["type"] === "LoanTaken" || item["type"] === "LoanGiven" || item["type"] === "Security");
      });

      filteredInvoice.map(function (item, index) {
        //if(item.newlyCreated && (item.status === "paid" || item.status === "partial")) {
        if (item.newlyCreated && (item.status === "paid" || item.status === "partial")) {
          var newItem = JSON.parse(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(item));
          newItem.date = newItem.date - 1;
          newItem.transactionType = "Debit";
          newItem.paidAmount = 0;
          newItem.status = "due";
          newItem.remainingAmount = newItem.totalAmount;
          delete newItem["newlyCreated"];
          filteredInvoice.push(newItem);
        }
        if (item.closedDate) {
          filteredInvoice[index].date = item.closedDate;
        }
      });

      customerDeposit.map(function (deposit, index) {
        filteredInvoice.push(deposit);
        if ((deposit["type"] === "LoanTaken" || deposit["type"] === "LoanGiven") && deposit.status == "paid" && !deposit.loanTransaction) {
          customerDeposit[index].status = "due";
        }
      });

      payments.map(function (pay) {
        pay["type"] = "CustomerPayment";
        filteredInvoice.push(pay);
      });
      filteredInvoice.sort(function (a, b) {
        return -(new Date(b.date) - new Date(a.date));
      });

      filteredInvoice.map(function (item, index) {
        filteredInvoice[index]["debit"] = _this3.getDebit(filteredInvoice[index]);
        filteredInvoice[index]["credit"] = _this3.getCredit(filteredInvoice[index]);
        if (item.isBuyer) {
          var temp = filteredInvoice[index]["credit"];
          filteredInvoice[index]["credit"] = filteredInvoice[index]["debit"];
          filteredInvoice[index]["debit"] = temp;
        }
        filteredInvoice[index]["RunningBal"] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(filteredInvoice[index]["debit"] || 0) - __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(filteredInvoice[index]["credit"] || 0) + (index == 0 ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(filteredInvoice[index - 1]["RunningBal"]));
      });
      //return filteredInvoice[filteredInvoice.length-1]["RunningBal"]
      return filteredInvoice && filteredInvoice.length ? filteredInvoice[filteredInvoice.length - 1]["RunningBal"] : 0;
    },
    getDebit: function getDebit(item) {
      if (item.type == "CustomerPayment") {
        if (!item.isBuyer) {
          return 0;
        } else {
          return item["remainingAmount"];
        }
      } else if (["LoanTaken", "LoanGiven", "Opening Balance", "Advance", "Security"].includes(item.type)) {
        switch (item.type) {
          case "LoanTaken":
            {
              if (item.loanTransaction) {
                return 0;
              } else {
                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.amount);
              }
              break;
            }
          case "LoanGiven":
            {
              if (item.loanTransaction) {
                if (item.loanPaymentType == "interest") {
                  return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.paidInterest);
                } else {
                  return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.paidAmount);
                }
              } else {
                return 0;
              }
              break;
            }
          case "Opening Balance":
            {
              return item.isUserCreated ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(0) : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.settledAmount);
              break;
            }
          case "Advance":
            {
              return item.isUserCreated ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.amount) : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(0);
              break;
            }
          case "Security":
            {
              return item.isUserCreated ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.amount) : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(0);
              break;
            }
        }
      } else {
        switch (item.status) {
          case "due":
            {
              return 0;
              break;
            }
          case "paid":
            {
              // return (Number.parseFloat(item['totalAmount']));
              return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item["amountFromBank"]) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item["amountFromCash"]);
              break;
            }
          case "partial":
            {
              return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item["amountFromBank"]) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item["amountFromCash"]);
              break;
            }
        }
      }
    },
    getCredit: function getCredit(item) {
      if (item.type == "CustomerPayment") {
        if (item.isBuyer) {
          return 0;
        } else {
          return item["remainingAmount"];
        }
      } else if (["LoanTaken", "LoanGiven", "Opening Balance", "Advance", "Security"].includes(item.type)) {
        switch (item.type) {
          case "LoanTaken":
            {
              if (item.loanTransaction) {
                if (item.loanPaymentType == "interest") {
                  return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.paidInterest);
                } else {
                  return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.paidAmount);
                }
              } else {
                return 0;
              }
              break;
            }
          case "LoanGiven":
            {
              if (item.loanTransaction) {
                return 0;
              } else {
                return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.amount);
              }
              break;
            }
          case "Opening Balance":
            {
              return item.isUserCreated ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.amount) : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(0);
              break;
            }
          case "Advance":
            {
              return item.isUserCreated ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(0) : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.settledAmount);
              break;
            }
          case "Security":
            {
              return item.isUserCreated ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(0) : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.settledAmount);
              break;
            }
        }
      } else {
        switch (item.status) {
          case "due":
            {
              return item.totalAmount;
              break;
            }
          case "paid":
            {
              return 0;
              break;
            }
          case "partial":
            {
              return 0;
              break;
            }
        }
      }
    },
    deleteFromDialog: function deleteFromDialog() {
      this[this.currentPasswordMethod](this.currentPasswordReference);
    },
    deleteUser: function deleteUser() {
      var firm = this.firms.find(function (i) {
        return !!i["defaultFirm"];
      });
      var firmSettings = this.firmSettings.find(function (i) {
        return i['firm'] == firm['.key'];
      });
      var hasPassword = firmSettings && firmSettings.deleteWithPassword && !!firmSettings.deleteInvoicePassword;
      if (hasPassword && this.password != firmSettings.deleteInvoicePassword && this.passwordDialog) {
        alert("Incorrect Password");
        this.passwordDialog = false;
        this.password = null;
      } else if (hasPassword && !this.passwordDialog) {
        this.passwordDialog = true;
        this.password = null;
        this.currentPasswordReference = null;
        this.currentPasswordMethod = "deleteUser";
      } else if (window.confirm("Do you want to Delete ?")) {
        this.passwordDialog = false;
        this.password = null;
        if (this.isBuyer) {
          this.$root.$firebaseRefs.buyer.child(this.selectedBuyer).remove();
          this.$router.push({ path: "/buyers/" + -1 });
        } else {
          this.$root.$firebaseRefs.seller.child(this.selectedBuyer).remove();
          this.$router.push({ path: "/buyers/" + -1 });
        }
      }
    },
    pushHistory: function pushHistory(inv) {
      inv[".key"];
      var pushInv = this.invoices.filter(function (item) {
        return item[".key"] == inv[".key"];
      })[0];
      if (pushInv) {
        pushInv.parentInvoiceKey = inv[".key"];
        pushInv.newlyCreated = true;
        pushInv.isLatest = true;
        delete pushInv[".key"];
        this.$root.$firebaseRefs.invoiceHistory.push(pushInv);
        console.log("push");
      }
    },
    deleteInvoice: function deleteInvoice(selectedInvoice) {
      var _this4 = this;

      var firmSettings = this.firmSettings.find(function (i) {
        return i['firm'] == selectedInvoice.firmID;
      });
      var hasPassword = firmSettings && firmSettings.deleteWithPassword && !!firmSettings.deleteInvoicePassword;
      if (hasPassword && this.password != firmSettings.deleteInvoicePassword && this.passwordDialog) {
        alert("Incorrect Password");
        this.passwordDialog = false;
        this.password = null;
      } else if (hasPassword && !this.passwordDialog) {
        this.passwordDialog = true;
        this.password = null;
        this.currentPasswordReference = selectedInvoice;
        this.currentPasswordMethod = "deleteInvoice";
      } else if (confirm("Are you sure you want to delete this invoice?")) {
        this.passwordDialog = false;
        this.password = null;
        this.$root.$firebaseRefs.invoice.child(selectedInvoice[".key"]).update({
          deleted: true
        }, function () {
          console.info("Invoice deleted...");
        });

        var invoiceHistory = this.invoiceHistories.filter(function (item) {
          return item["brand"] == _this4.selectedBrand && item["parentInvoiceKey"] == selectedInvoice[".key"];
        });
        invoiceHistory.map(function (invoice) {
          _this4.$root.$firebaseRefs.invoiceHistory.child(invoice[".key"]).update({
            deleted: true
          }, function () {
            console.info("Invoice History deleted...");
          });
        });
      }
    },
    printBasicInvoice: function printBasicInvoice(selectedInvoice) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var termsAndConditions, banks, firm, customer, gstInvoice, gstTotal, productObj, doc;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                termsAndConditions = _this5.getTermsAndConditions(selectedInvoice);

                if (termsAndConditions.length) {
                  if (termsAndConditions[0].bank) {
                    banks = [];

                    termsAndConditions[0].bank.map(function (bankId) {
                      var bank = _this5.banks.filter(function (item) {
                        return item[".key"] == bankId;
                      })[0];

                      bank.address = _this5.getAddress(bank);
                      banks.push(bank);
                    });
                    termsAndConditions[0].banks = banks;
                  } else {
                    termsAndConditions[0].banks = [];
                  }
                } else {
                  termsAndConditions = [{
                    termsAndConditions: "",
                    banks: []
                  }];
                }
                firm = _this5.firms.filter(function (item) {
                  return item[".key"] == selectedInvoice.firmID;
                })[0];

                firm.address = _this5.getAddress(firm);
                _this5.getCurrentUserDetails();
                customer = _this5.currentUser;

                customer.address = _this5.getAddress(customer);
                customer.stateCode = _this5.gState.filter(function (item) {
                  return item.state == customer.state;
                })[0].code;
                selectedInvoice["date"] = selectedInvoice["dateOfInvoice"];
                gstInvoice = firm.GST_user && firm.GST_user == "Yes" ? true : false;
                gstTotal = _this5.calculateGSTInvoice(customer, selectedInvoice);
                productObj = {};

                if (!gstInvoice && termsAndConditions[0].isMajorUnitDisplay) {
                  selectedInvoice.items.map(function (item) {
                    productObj[item['productId']] = _this5.productById[item['productId']];
                  });
                }

                if (!gstInvoice) {
                  _context.next = 19;
                  break;
                }

                _context.next = 16;
                return Object(__WEBPACK_IMPORTED_MODULE_13__utils_pdfmake__["c" /* convertToBasicInvoice */])({
                  invoiceData: selectedInvoice,
                  firm: firm,
                  customer: customer,
                  gstTotal: gstTotal,
                  terms: termsAndConditions[0],
                  balance: _this5.getBalance
                });

              case 16:
                _context.t0 = _context.sent;
                _context.next = 22;
                break;

              case 19:
                _context.next = 21;
                return Object(__WEBPACK_IMPORTED_MODULE_13__utils_pdfmake__["f" /* convertToBasicInvoiceWithoutGST */])({
                  invoiceData: selectedInvoice,
                  firm: firm,
                  customer: customer,
                  gstTotal: gstTotal,
                  terms: termsAndConditions[0],
                  balance: _this5.getBalance,
                  productObj: productObj
                });

              case 21:
                _context.t0 = _context.sent;

              case 22:
                doc = _context.t0;

                pdfMake.createPdf(doc).download(_this5.currentUser.name);

              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this5);
      }))();
    },


    // Start of Dairy Invoice
    printDairyInvoice: function printDairyInvoice(selectedInvoice) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var termsAndConditions, banks, firm, customer, gstInvoice, gstTotal, productObj, doc;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                termsAndConditions = _this6.getTermsAndConditions(selectedInvoice);

                if (termsAndConditions.length) {
                  if (termsAndConditions[0].bank) {
                    banks = [];

                    termsAndConditions[0].bank.map(function (bankId) {
                      var bank = _this6.banks.filter(function (item) {
                        return item[".key"] == bankId;
                      })[0];

                      bank.address = _this6.getAddress(bank);
                      banks.push(bank);
                    });
                    termsAndConditions[0].banks = banks;
                  } else {
                    termsAndConditions[0].banks = [];
                  }
                } else {
                  termsAndConditions = [{
                    termsAndConditions: "",
                    banks: []
                  }];
                }
                firm = _this6.firms.filter(function (item) {
                  return item[".key"] == selectedInvoice.firmID;
                })[0];

                firm.address = _this6.getAddress(firm);
                _this6.getCurrentUserDetails();
                customer = _this6.currentUser;

                customer.address = _this6.getAddress(customer);
                customer.stateCode = _this6.gState.filter(function (item) {
                  return item.state == customer.state;
                })[0].code;
                selectedInvoice["date"] = selectedInvoice["dateOfInvoice"];
                gstInvoice = firm.GST_user && firm.GST_user == "Yes" ? true : false;
                gstTotal = _this6.calculateGSTInvoice(customer, selectedInvoice);
                productObj = {};

                if (!gstInvoice && termsAndConditions[0].isMajorUnitDisplay) {
                  selectedInvoice.items.map(function (item) {
                    productObj[item['productId']] = _this6.productById[item['productId']];
                  });
                }

                if (!gstInvoice) {
                  _context2.next = 19;
                  break;
                }

                _context2.next = 16;
                return Object(__WEBPACK_IMPORTED_MODULE_13__utils_pdfmake__["c" /* convertToBasicInvoice */])({
                  invoiceData: selectedInvoice,
                  firm: firm,
                  customer: customer,
                  gstTotal: gstTotal,
                  terms: termsAndConditions[0],
                  balance: _this6.getBalance
                });

              case 16:
                _context2.t0 = _context2.sent;
                _context2.next = 22;
                break;

              case 19:
                _context2.next = 21;
                return Object(__WEBPACK_IMPORTED_MODULE_13__utils_pdfmake__["d" /* convertToBasicInvoiceForDairyWithoutGST */])({
                  invoiceData: selectedInvoice,
                  firm: firm,
                  customer: customer,
                  gstTotal: gstTotal,
                  terms: termsAndConditions[0],
                  balance: _this6.getBalance,
                  productObj: productObj
                });

              case 21:
                _context2.t0 = _context2.sent;

              case 22:
                doc = _context2.t0;

                pdfMake.createPdf(doc).download(_this6.currentUser.name);

              case 24:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this6);
      }))();
    },

    // End of Dairy Invoice

    printHorizontalInvoice: function printHorizontalInvoice(selectedInvoice) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var termsAndConditions, banks, firm, customer, gstTotal;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                termsAndConditions = _this7.getTermsAndConditions(selectedInvoice);

                if (termsAndConditions.length) {
                  if (termsAndConditions[0].bank) {
                    banks = [];

                    termsAndConditions[0].bank.map(function (bankId) {
                      var bank = _this7.banks.filter(function (item) {
                        return item[".key"] == bankId;
                      })[0];

                      bank.address = _this7.getAddress(bank);
                      banks.push(bank);
                    });
                    termsAndConditions[0].banks = banks;
                  } else {
                    termsAndConditions[0].banks = [];
                  }
                } else {
                  termsAndConditions = [{
                    termsAndConditions: "",
                    banks: []
                  }];
                }
                firm = _this7.firms.filter(function (item) {
                  return item[".key"] == selectedInvoice.firmID;
                })[0];

                firm.address = _this7.getAddress(firm);
                _this7.getCurrentUserDetails();
                customer = _this7.currentUser;

                customer.address = _this7.getAddress(customer);
                customer.stateCode = _this7.gState.filter(function (item) {
                  return item.state == customer.state;
                })[0].code;
                selectedInvoice["date"] = selectedInvoice["dateOfInvoice"];
                gstTotal = _this7.calculateGSTInvoice(customer, selectedInvoice);
                _context3.next = 12;
                return Object(__WEBPACK_IMPORTED_MODULE_13__utils_pdfmake__["e" /* convertToBasicInvoiceHorizontal */])({
                  invoiceData: selectedInvoice,
                  firm: firm,
                  customer: customer,
                  gstTotal: gstTotal,
                  terms: termsAndConditions[0],
                  balance: _this7.getBalance
                }).then(function (doc) {
                  pdfMake.createPdf(doc).download(_this7.currentUser.name);
                });

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this7);
      }))();
    },
    printInvoice4: function printInvoice4(selectedInvoice) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var termsAndConditions, banks, firm, customer, estimates, previousDue, gstTotal;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                termsAndConditions = _this8.getTermsAndConditions(selectedInvoice);

                if (termsAndConditions.length) {
                  if (termsAndConditions[0].bank) {
                    banks = [];

                    termsAndConditions[0].bank.map(function (bankId) {
                      var bank = _this8.banks.filter(function (item) {
                        return item[".key"] == bankId;
                      })[0];

                      bank.address = _this8.getAddress(bank);
                      banks.push(bank);
                    });
                    termsAndConditions[0].banks = banks;
                  } else {
                    termsAndConditions[0].banks = [];
                  }
                } else {
                  termsAndConditions = [{
                    termsAndConditions: "",
                    banks: []
                  }];
                }
                firm = _this8.firms.filter(function (item) {
                  return item[".key"] == selectedInvoice.firmID;
                })[0];

                firm.address = _this8.getAddress(firm);
                _this8.getCurrentUserDetails();
                customer = _this8.currentUser;

                customer.address = _this8.getAddress(customer);
                customer.stateCode = _this8.gState.filter(function (item) {
                  return item.state == customer.state;
                })[0].code;
                estimates = [];
                previousDue = [];

                if (termsAndConditions[0].isPreviousDue) {
                  previousDue = _this8.invoices.filter(function (item) {
                    return item["brand"] == _this8.selectedBrand && item["buyerId"] == _this8.selectedBuyer[".key"] && ["due", "partial"].includes(item["status"]) && !item["deleted"] && !item["return"];
                  });
                }
                if (termsAndConditions[0].isEstimate) {
                  estimates = _this8.estimates.filter(function (item) {
                    return item["brand"] == _this8.selectedBrand && item["buyerId"] == _this8.selectedBuyer[".key"] && ["IN PROGRESS"].includes(item["status"]);
                  });
                }
                selectedInvoice["date"] = selectedInvoice["dateOfInvoice"];
                gstTotal = _this8.calculateGSTInvoice(customer, selectedInvoice);
                _context4.next = 16;
                return Object(__WEBPACK_IMPORTED_MODULE_13__utils_pdfmake__["p" /* convertToSimpleInvoicePrint */])({
                  invoiceData: selectedInvoice,
                  firm: firm,
                  customer: customer,
                  gstTotal: gstTotal,
                  terms: termsAndConditions[0],
                  previousDue: previousDue,
                  estimates: estimates,
                  balance: _this8.getBalance
                }).then(function (doc) {
                  pdfMake.createPdf(doc).download(_this8.currentUser.name);
                });

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this8);
      }))();
    },
    printEwayType1: function printEwayType1(selectedInvoice) {
      var _this9 = this;

      var termsAndConditions = this.getTermsAndConditions(selectedInvoice);
      if (termsAndConditions.length) {
        if (termsAndConditions[0].bank) {
          var banks = [];
          termsAndConditions[0].bank.map(function (bankId) {
            var bank = _this9.banks.filter(function (item) {
              return item[".key"] == bankId;
            })[0];

            bank.address = _this9.getAddress(bank);
            banks.push(bank);
          });
          termsAndConditions[0].banks = banks;
        } else {
          termsAndConditions[0].banks = [];
        }
      } else {
        termsAndConditions = [{
          termsAndConditions: "",
          banks: []
        }];
      }
      var firm = this.firms.filter(function (item) {
        return item[".key"] == selectedInvoice.firmID;
      })[0];
      firm.address = this.getAddress(firm);
      this.getCurrentUserDetails();
      var customer = this.currentUser;
      customer.address = this.getAddress(customer);
      customer.stateCode = this.gState.filter(function (item) {
        return item.state == customer.state;
      })[0].code;
      selectedInvoice["date"] = selectedInvoice["dateOfInvoice"];
      var gstTotal = this.calculateGSTInvoice(customer, selectedInvoice);
      var doc = Object(__WEBPACK_IMPORTED_MODULE_13__utils_pdfmake__["j" /* convertToEwayBillType1 */])({
        invoiceData: selectedInvoice,
        firm: firm,
        customer: customer,
        gstTotal: gstTotal,
        terms: termsAndConditions[0],
        balance: this.getBalance,
        ebillDetails: selectedInvoice.ewayBillDetails.ebillDetails,
        consignee: selectedInvoice.ewayBillDetails.consignee,
        transportationDetails: selectedInvoice.ewayBillDetails.transportationDetails
      });
      pdfMake.createPdf(doc).download(selectedInvoice.invoiceId);
    },
    printEwayType2: function printEwayType2(selectedInvoice) {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var termsAndConditions, banks, firm, customer, gstTotal;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                termsAndConditions = _this10.getTermsAndConditions(selectedInvoice);

                if (termsAndConditions.length) {
                  if (termsAndConditions[0].bank) {
                    banks = [];

                    termsAndConditions[0].bank.map(function (bankId) {
                      var bank = _this10.banks.filter(function (item) {
                        return item[".key"] == bankId;
                      })[0];

                      bank.address = _this10.getAddress(bank);
                      banks.push(bank);
                    });
                    termsAndConditions[0].banks = banks;
                  } else {
                    termsAndConditions[0].banks = [];
                  }
                } else {
                  termsAndConditions = [{
                    termsAndConditions: "",
                    banks: []
                  }];
                }
                firm = _this10.firms.filter(function (item) {
                  return item[".key"] == selectedInvoice.firmID;
                })[0];

                firm.address = _this10.getAddress(firm);
                _this10.getCurrentUserDetails();
                customer = _this10.currentUser;

                customer.address = _this10.getAddress(customer);
                customer.stateCode = _this10.gState.filter(function (item) {
                  return item.state == customer.state;
                })[0].code;
                selectedInvoice["date"] = selectedInvoice["dateOfInvoice"];
                gstTotal = _this10.calculateGSTInvoice(customer, selectedInvoice);
                _context5.next = 12;
                return Object(__WEBPACK_IMPORTED_MODULE_13__utils_pdfmake__["k" /* convertToEwayBillType2 */])({
                  invoiceData: selectedInvoice,
                  firm: firm,
                  customer: customer,
                  gstTotal: gstTotal,
                  balance: _this10.getBalance,
                  terms: termsAndConditions[0],
                  ebillDetails: selectedInvoice.ewayBillDetails.ebillDetails,
                  consignee: selectedInvoice.ewayBillDetails.consignee,
                  transportationDetails: selectedInvoice.ewayBillDetails.transportationDetails
                }).then(function (doc) {
                  pdfMake.createPdf(doc).download(selectedInvoice.invoiceId);
                });

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this10);
      }))();
    },
    printEwayType3: function printEwayType3(selectedInvoice) {
      var _this11 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var termsAndConditions, banks, firm, customer, gstTotal;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                termsAndConditions = _this11.getTermsAndConditions(selectedInvoice);

                if (termsAndConditions.length) {
                  if (termsAndConditions[0].bank) {
                    banks = [];

                    termsAndConditions[0].bank.map(function (bankId) {
                      var bank = _this11.banks.filter(function (item) {
                        return item[".key"] == bankId;
                      })[0];

                      bank.address = _this11.getAddress(bank);
                      banks.push(bank);
                    });
                    termsAndConditions[0].banks = banks;
                  } else {
                    termsAndConditions[0].banks = [];
                  }
                } else {
                  termsAndConditions = [{
                    termsAndConditions: "",
                    banks: []
                  }];
                }
                firm = _this11.firms.filter(function (item) {
                  return item[".key"] == selectedInvoice.firmID;
                })[0];

                firm.address = _this11.getAddress(firm);
                _this11.getCurrentUserDetails();
                customer = _this11.currentUser;

                customer.address = _this11.getAddress(customer);
                customer.stateCode = _this11.gState.filter(function (item) {
                  return item.state == customer.state;
                })[0].code;
                selectedInvoice["date"] = selectedInvoice["dateOfInvoice"];
                gstTotal = _this11.calculateGSTInvoice(customer, selectedInvoice);
                _context6.next = 12;
                return Object(__WEBPACK_IMPORTED_MODULE_13__utils_pdfmake__["l" /* convertToEwayBillType3 */])({
                  invoiceData: selectedInvoice,
                  firm: firm,
                  customer: customer,
                  gstTotal: gstTotal,
                  terms: termsAndConditions[0],
                  balance: _this11.getBalance,
                  ebillDetails: selectedInvoice.ewayBillDetails.ebillDetails,
                  consignee: selectedInvoice.ewayBillDetails.consignee,
                  transportationDetails: selectedInvoice.ewayBillDetails.transportationDetails
                }).then(function (doc) {
                  pdfMake.createPdf(doc).download(selectedInvoice.invoiceId);
                });

              case 12:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this11);
      }))();
    },
    getTermsAndConditions: function getTermsAndConditions(selectedInvoice) {
      var _this12 = this;

      return this.termsAndConditions.filter(function (item) {
        return item["brand"] === _this12.selectedBrand && item["firm"] === selectedInvoice.firmID;
      });
    },
    getAddress: function getAddress(item) {
      var address = (item.village ? item.village + ", " : "") + (item.block ? item.block + ", " : "") + (item.tehsil ? item.tehsil + ", " : "") + (item.district ? item.district + ", " : "") + (item.state ? item.state + ", " : "") + (item.country ? item.country + ", " : "");
      address = address.substring(0, address.length - 2);
      return address;
    },
    calculateGSTInvoice: function calculateGSTInvoice(currentUser, invoice) {
      var SGST_val = 0;
      var CGST_val = 0;
      var IGST_val = 0;
      invoice.items && invoice.items.map(function (item, index) {
        SGST_val += parseFloat(item["SGST_val"]);
        CGST_val += parseFloat(item["CGST_val"]);
        IGST_val += parseFloat(item["IGST_val"]);
      });
      return { SGST_val: SGST_val, CGST_val: CGST_val, IGST_val: IGST_val };
    },
    openInvoice: function openInvoice(selectedInvoice) {
      this.selectedInvoiceId = selectedInvoice[".key"];
      this.dialog = true;
    },
    getGSTtotal: function getGSTtotal(item) {
      var GSTTotal = 0;
      item && item.items && item.items.map(function (item) {
        GSTTotal += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
      });
      if (item.gstOnExtraChanrges) {
        GSTTotal += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.totalExtraChargesGST);
      }
      return GSTTotal;
    },
    openHistory: function openHistory(invoiceId) {
      this.$router.push({ path: "/invoice-history/" + invoiceId });
    },
    getStaffName: function getStaffName(staffId) {
      var staffObj = staffId ? this.staff[staffId] : null;
      return staffObj ? staffObj.staffName : "";
    },
    toggleUnpick: function toggleUnpick(selectedInvoiceId) {
      var flag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.$root.$firebaseRefs.invoice.child(selectedInvoiceId).update({
        isUnpicked: !flag
      }, function () {
        console.info("completed...");
      });
    },

    // open transfer invoice dialog prompt
    transferInvoice: function transferInvoice(invoice) {
      this.transferInvoiceDialog = true;
      this.transferInvoiceDetail = invoice;
      this.transferInvoiceUser = null;
    },
    updateInvoice: function updateInvoice(invoiceData) {
      var _this13 = this;

      console.log("Update Invoice Called");
      this.getCurrentUserDetails();
      this.manageBeforePayments(invoiceData[".key"]);
      // this.dialog = false
      console.info(invoiceData);
      var updated_at = new Date().getTime();
      // debugger
      try {
        invoiceData["items"].forEach(function (item, index) {
          item["date"] = invoiceData["date"];
          if (item.id) {
            item["updated_at"] = updated_at;
            _this13.$root.$firebaseRefs.item.child(item["id"]).update(item, function () {
              console.info("item udpated...");
            });
          } else {
            var response = _this13.$root.$firebaseRefs.item.push(item, function () {
              console.info("item pushed...");
            });
            invoiceData["items"][index]["id"] = response["key"];
          }
        });
        invoiceData["updated_at"] = updated_at;
        var key = invoiceData[".key"];
        delete invoiceData[".key"];

        this.$root.$firebaseRefs.invoice.child(key).update(invoiceData, function () {
          console.info("invoice updated...");
          _this13.updateInvoiceDialog = false;
          if (_this13.dialog) _this13.dialog = false;
          _this13.managePayments(invoiceData);
        });
        invoiceData["parentInvoiceKey"] = key;
        delete invoiceData["newlyCreated"];
        if (invoiceData.isPayment) {
          delete invoiceData["newlyCreated"];
          delete invoiceData["isPayment"];
          this.$root.$firebaseRefs.invoiceHistory.push(invoiceData);
        } else {
          var letestInv = this.invoiceHistories.filter(function (item) {
            return item["brand"] == _this13.selectedBrand && item["isLatest"] == true && item["parentInvoiceKey"] == key;
          })[0];
          var latestInvKey = letestInv[".key"];
          delete letestInv[".key"];
          letestInv["isLatest"] = false;
          this.$root.$firebaseRefs.invoiceHistory.child(latestInvKey).update(letestInv, function () {});
          invoiceData["isLatest"] = true;
          this.$root.$firebaseRefs.invoiceHistory.push(invoiceData);
        }
      } catch (e) {
        console.info("Error at update Invoice", e);
      }
    },
    managePayments: function managePayments(invoiceData) {
      var beforeUpdateInvoice = this.invoices.filter(function (item) {
        return item[".key"] === invoiceData[".key"];
      })[0];
      switch (invoiceData.paymentType) {
        case "Cash":
          {
            if (invoiceData.amountFromCash) {
              var firm = this.firms.filter(function (item) {
                return item[".key"] == invoiceData.firm;
              })[0];
              if (firm && (invoiceData.status == "paid" || invoiceData.status == "partial")) {
                firm.amount = invoiceData.isBuyer ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(firm.amount) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash) : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(firm.amount) - __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash);
                delete firm[".key"];
                this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(firm);
              }
            }
            break;
          }
        case "Bank Account":
          {
            if (invoiceData.amountFromBank) {
              var bank = this.banks.filter(function (item) {
                return item[".key"] == invoiceData.bank;
              })[0];
              if (bank && (invoiceData.status == "paid" || invoiceData.status == "partial")) {
                bank.amount = invoiceData.isBuyer ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(bank.amount) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank) : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(bank.amount) - __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank);
                delete bank[".key"];
                this.$root.$firebaseRefs.account.child(invoiceData.bank).set(bank);
              }
            }
            break;
          }
        case "CashAndBank Account":
          {
            if (invoiceData.amountFromCash && invoiceData.amountFromBank) {
              var _bank = this.banks.filter(function (item) {
                return item[".key"] == invoiceData.bank;
              })[0];
              if (_bank && (invoiceData.status == "paid" || invoiceData.status == "partial")) {
                _bank.amount = invoiceData.isBuyer ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(_bank.amount) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank) : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(_bank.amount) - __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank);
                delete _bank[".key"];
                this.$root.$firebaseRefs.account.child(invoiceData.bank).set(_bank);
              }
              var _firm = this.firms.filter(function (item) {
                return item[".key"] == invoiceData.firm;
              })[0];
              if (_firm && (invoiceData.status == "paid" || invoiceData.status == "partial")) {
                _firm.amount = invoiceData.isBuyer ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(_firm.amount) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash) : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(_firm.amount) - __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash);
                delete _firm[".key"];
                this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(_firm);
              }
            }
            break;
          }
      }
      this.manageProductsQuantity(invoiceData);
    },
    manageProductsQuantity: function manageProductsQuantity(invoiceData) {
      var _this14 = this;

      invoiceData.items.map(function (item) {
        var key = item["productId"];
        var product = _this14.productById[key];
        if (_this14.isBuyer) {
          var saleQuantity = product["saleQuantity"] ? product["saleQuantity"] : 0;
          saleQuantity = saleQuantity + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(item.quantity);
          product["saleQuantity"] = saleQuantity;
        } else {
          var purchaseQuantity = product["purchaseQuantity"] ? product["purchaseQuantity"] : 0;
          purchaseQuantity = purchaseQuantity + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(item.quantity);
          product["purchaseQuantity"] = purchaseQuantity;
        }
        var prodQuantity = product["quantity"];
        prodQuantity = _this14.isBuyer ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(prodQuantity) - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(item.quantity) : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(prodQuantity) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(item.quantity);
        delete product[".key"];
        product["quantity"] = prodQuantity;
        _this14.$root.$firebaseRefs.products.child(key).set(product);
      });
    },
    getCurrentUserDetails: function getCurrentUserDetails() {
      var _this15 = this;

      var buyer = this.buyers.filter(function (item) {
        return item[".key"] === _this15.selectedBuyer;
      })[0];
      var seller = this.sellers.filter(function (item) {
        return item[".key"] === _this15.selectedBuyer;
      })[0];
      this.currentUser = buyer ? buyer : seller;
      this.isBuyer = buyer && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(buyer).length != 0 ? true : false;
    },
    manageBeforePayments: function manageBeforePayments(key) {
      var invoiceData = this.invoices.filter(function (item) {
        return item[".key"] === key;
      })[0];
      switch (invoiceData.paymentType) {
        case "Cash":
          {
            if (invoiceData.amountFromCash) {
              var firm = this.firms.filter(function (item) {
                return item["key"] == invoiceData.firm;
              })[0];
              if (firm && (invoiceData.status == "paid" || invoiceData.status == "partial")) {
                firm.amount = this.isBuyer ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(firm.amount) - __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash) : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(firm.amount) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash);
                delete firm[".key"];
                this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(firm);
              }
            }
            break;
          }
        case "Bank Account":
          {
            if (invoiceData.amountFromBank) {
              var bank = this.banks.filter(function (item) {
                return item["key"] == invoiceData.bank;
              })[0];
              if (bank && (invoiceData.status == "paid" || invoiceData.status == "partial")) {
                bank.amount = this.isBuyer ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(bank.amount) - __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank) : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(bank.amount) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank);
                delete bank[".key"];
                this.$root.$firebaseRefs.account.child(invoiceData.bank).set(bank);
              }
            }
            break;
          }
        case "CashAndBank Account":
          {
            if (invoiceData.amountFromCash && invoiceData.amountFromBank) {
              var _bank2 = this.banks.filter(function (item) {
                return item["key"] == invoiceData.bank;
              })[0];
              if (_bank2 && (invoiceData.status == "paid" || invoiceData.status == "partial")) {
                _bank2.amount = this.isBuyer ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(_bank2.amount) - __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank) : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(_bank2.amount) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank);
                delete _bank2[".key"];
                this.$root.$firebaseRefs.account.child(invoiceData.bank).set(_bank2);
              }
              var _firm2 = this.firms.filter(function (item) {
                return item["key"] == invoiceData.firm;
              })[0];
              if (_firm2 && (invoiceData.status == "paid" || invoiceData.status == "partial")) {
                _firm2.amount = this.isBuyer ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(_firm2.amount) - __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash) : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(_firm2.amount) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash);
                delete _firm2[".key"];
                this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(_firm2);
              }
            }
            break;
          }
      }
      this.manageBeforeProductsQuantity(invoiceData);
    },
    manageBeforeProductsQuantity: function manageBeforeProductsQuantity(invoiceData) {
      var _this16 = this;

      invoiceData.items.map(function (item) {
        var key = item["productId"];
        var product = _this16.productById[key];
        if (_this16.isBuyer) {
          var saleQuantity = product["saleQuantity"] ? product["saleQuantity"] : 0;
          saleQuantity = saleQuantity - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(item.quantity);
          product["saleQuantity"] = saleQuantity;
        } else {
          var purchaseQuantity = product["purchaseQuantity"] ? product["purchaseQuantity"] : 0;
          purchaseQuantity = purchaseQuantity - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(item.quantity);
          product["purchaseQuantity"] = purchaseQuantity;
        }
        var prodQuantity = product["quantity"];
        prodQuantity = _this16.isBuyer ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(prodQuantity) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(item.quantity) : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(prodQuantity) - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(item.quantity);
        delete product[".key"];
        product["quantity"] = prodQuantity;
        _this16.$root.$firebaseRefs.products.child(key).set(product);
      });
    },


    // Transfer user to created user id
    transferInvoiceToUserJustCreated: function transferInvoiceToUserJustCreated(newUserId) {
      this.__updateTranferInvoiceUser(newUserId);
    },


    // transfer user to selected user
    transferInvoiceToUser: function transferInvoiceToUser(user) {
      if (this.transferInvoiceUser) {
        console.info("update invoice to user", this.transferInvoiceUser);
        this.__updateTranferInvoiceUser(this.transferInvoiceUser[".key"]);
      } else {
        console.info("select");
      }
    },

    // handle firebase update method when updating transfer invoice user
    // 1. update buyerId with new selected user/ created user
    __updateTranferInvoiceUser: function __updateTranferInvoiceUser(buyerId) {
      var _this17 = this;

      var newDetail = {
        buyerId: buyerId
      };
      if (!this.transferInvoiceDetail.originalBuyerId) {
        // add original curomerId when transferring invoice for first time
        newDetail.originalBuyerId = this.transferInvoiceDetail.buyerId;
      }
      var letestInv = this.invoiceHistories.filter(function (item) {
        return item["brand"] == _this17.selectedBrand && item["parentInvoiceKey"] == _this17.transferInvoiceDetail[".key"];
      });
      letestInv.map(function (invoice) {
        _this17.$root.$firebaseRefs.invoiceHistory.child(invoice[".key"]).update(newDetail, function () {
          console.info("history invoice updated...");
        });
      });
      this.$root.$firebaseRefs.invoice.child(this.transferInvoiceDetail[".key"]).update(newDetail, function () {
        _this17.transferInvoiceUser = null;
        _this17.transferInvoiceDetail = null;
        _this17.transferInvoiceDialog = false;
        console.info("invoice updated...");
      });
      // newDetail['parentInvoiceKey'] = this.transferInvoiceDetail['.key'];
      // delete newDetail['newlyCreated']
      // this.$root.$firebaseRefs.invoiceHistory.push(newDetail);
    },
    returnInvoice: function returnInvoice(orignalInvoiceData, remainingInvoiceData, returnInvoiceData) {
      // this.getCurrentUserDetails();
      // this.manageBeforeProductsQuantity(invoiceData);
      // invoiceData['items'].forEach((item, index) => {
      //   item['date'] = invoiceData['date'];
      //   delete item['.key'];
      //   const response = this.$root.$firebaseRefs.item.push(item);
      //   invoiceData['items'][index]['id'] = response['key']
      // });
      // invoiceData['parentInvoice'] = invoiceData['.key'];
      // invoiceData['parentInvoiceKey'] = invoiceData['.key'];
      // delete invoiceData['.key'];
      // delete invoiceData['newlyCreated'];
      // this.$root.$firebaseRefs.invoiceHistory.push(invoiceData);
      // delete invoiceData['parentInvoiceKey'];
      // this.$root.$firebaseRefs.invoice.push(invoiceData);
      // this.returnInvoiceDialog = false;
      orignalInvoiceData["returnStatus"] = "orignal";
      remainingInvoiceData["returnStatus"] = "remaining";
      returnInvoiceData["returnStatus"] = "returned";
      this.payInvoice(orignalInvoiceData);
      var creditInvoice = this.createInvoice(remainingInvoiceData);
      this.createInvoice(returnInvoiceData);
      this.payInvoice(creditInvoice);
      this.returnInvoiceDialog = false;
    },
    payInvoice: function payInvoice(invoice) {
      var _this18 = this;

      invoice["status"] = "paid";
      invoice["paidAmount"] = invoice.totalAmount;
      invoice["transactionType"] = "Credit";
      invoice["remainingAmount"] = 0;
      this.managePayments(invoice, false);
      var updated_at = new Date().getTime();
      try {
        invoice["items"].forEach(function (item, index) {
          item["date"] = invoice["date"];
          if (item.id) {
            item["updated_at"] = updated_at;
            _this18.$root.$firebaseRefs.item.child(item["id"]).update(item, function () {
              console.info("item udpated...");
            });
          } else {
            var response = _this18.$root.$firebaseRefs.item.push(item, function () {
              console.info("item pushed...");
            });
            invoice["items"][index]["id"] = response["key"];
          }
        });
        invoice["updated_at"] = updated_at;
        var key = invoice[".key"];
        delete invoice[".key"];

        this.$root.$firebaseRefs.invoice.child(key).update(invoice, function () {
          console.info("invoice updated...");
        });
        invoice["parentInvoiceKey"] = key;
        delete invoice["newlyCreated"];
        this.$root.$firebaseRefs.invoiceHistory.push(invoice);
      } catch (e) {
        console.info("Error at update Invoice", e);
      }
    },
    createInvoice: function createInvoice(invoiceData) {
      var _this19 = this;

      this.dialog = false;
      invoiceData["items"].forEach(function (item, index) {
        item["date"] = invoiceData["date"];
        delete item[".key"];
        var response = _this19.$root.$firebaseRefs.item.push(item);
        invoiceData["items"][index]["id"] = response["key"];
      });
      delete invoiceData[".key"];
      var res = this.$root.$firebaseRefs.invoice.push(invoiceData);
      if (res.key) {
        invoiceData["parentInvoiceKey"] = res.key;
        invoiceData["newlyCreated"] = true;
        var bank = this.banks.filter(function (item) {
          return item[".key"] == invoiceData.bank;
        })[0];
        if (invoiceData.bank && bank && bank.length) {
          invoiceData.accountNumber = bank.accountnumber;
        }
        this.$root.$firebaseRefs.invoiceHistory.push(invoiceData);
      }
      this.getCurrentUserDetails();
      this.managePaymentsCreate(invoiceData);
      this.manageProductsQuantityCreate(invoiceData);
      // this.returnInvoiceDialog = false;

      delete invoiceData["parentInvoiceKey"];
      delete invoiceData["newlyCreated"];
      invoiceData[".key"] = res.key;
      return invoiceData;
    },
    managePaymentsCreate: function managePaymentsCreate(invoiceData) {
      switch (invoiceData.paymentType) {
        case "Cash":
          {
            if (invoiceData.amountFromCash) {
              var firm = this.firms.filter(function (item) {
                return item[".key"] == invoiceData.firm;
              })[0];
              if (firm && (invoiceData.status == "paid" || invoiceData.status == "partial")) {
                firm.amount = this.isBuyer ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(firm.amount) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash) : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(firm.amount) - __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash);
                delete firm[".key"];
                this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(firm);
              }
            }
            break;
          }
        case "Bank Account":
          {
            if (invoiceData.amountFromBank) {
              var bank = this.banks.filter(function (item) {
                return item[".key"] == invoiceData.bank;
              })[0];
              if (bank && (invoiceData.status == "paid" || invoiceData.status == "partial")) {
                bank.amount = this.isBuyer ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(bank.amount) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank) : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(bank.amount) - __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank);
                delete bank[".key"];
                this.$root.$firebaseRefs.account.child(invoiceData.bank).set(bank);
              }
            }
            break;
          }
        case "CashAndBank Account":
          {
            if (invoiceData.amountFromCash && invoiceData.amountFromBank) {
              var _bank3 = this.banks.filter(function (item) {
                return item[".key"] == invoiceData.bank;
              })[0];
              if (_bank3 && (invoiceData.status == "paid" || invoiceData.status == "partial")) {
                _bank3.amount = this.isBuyer ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(_bank3.amount) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank) : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(_bank3.amount) - __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank);
                delete _bank3[".key"];
                this.$root.$firebaseRefs.account.child(invoiceData.bank).set(_bank3);
              }
              var _firm3 = this.firms.filter(function (item) {
                return item[".key"] == invoiceData.firm;
              })[0];
              if (_firm3 && (invoiceData.status == "paid" || invoiceData.status == "partial")) {
                _firm3.amount = this.isBuyer ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(_firm3.amount) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash) : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(_firm3.amount) - __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash);
                delete _firm3[".key"];
                this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(_firm3);
              }
            }
            break;
          }
      }
    },
    manageProductsQuantityCreate: function manageProductsQuantityCreate(invoiceData) {
      var _this20 = this;

      invoiceData.items.map(function (item) {
        var key = item["productId"];
        var product = _this20.productById[key];
        var prodQuantity = product["quantity"];
        if (_this20.isBuyer) {
          var saleQuantity = product["saleQuantity"] ? product["saleQuantity"] : 0;
          saleQuantity = saleQuantity + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(item.quantity);
          product["saleQuantity"] = saleQuantity;
        } else {
          var purchaseQuantity = product["purchaseQuantity"] ? product["purchaseQuantity"] : 0;
          purchaseQuantity = purchaseQuantity + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(item.quantity);
          product["purchaseQuantity"] = purchaseQuantity;
        }
        prodQuantity = _this20.isBuyer ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(prodQuantity) - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(item.quantity) : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(prodQuantity) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(item.quantity);
        delete product[".key"];
        product["quantity"] = prodQuantity;
        _this20.$root.$firebaseRefs.products.child(key).set(product);
      });
    },

    // return user address by generating string
    generateAddress: function generateAddress(user) {
      var address = "";
      if (user.block) {
        address = "" + user.block;
      }
      if (user.village) {
        address = "" + (address ? address + ", " : "") + user.village;
      }
      if (user.tehsil) {
        address = "" + (address ? address + ", " : "") + user.tehsil;
      }
      if (user.state) {
        address = "" + (address ? address + ", " : "") + user.state;
      }
      return address;
    },
    editInvoiceModalOpen: function editInvoiceModalOpen(invoice) {
      // this.updateInvoiceDetail = this.invoices.filter(item => item['.key'] === invoice['.key'])[0];
      // this.updateInvoiceDialog = true;
      // this.updateInvoiceDetail = this.invoices.filter(item => item['.key'] === invoice['.key'])[0];
      // this.updateInvoiceDialog = true;
      this.$router.push({ path: "/update-invoice/" + invoice[".key"] });
    },
    returnInvoiceModalOpen: function returnInvoiceModalOpen(invoice) {
      this.returnInvoiceDetail = this.invoices.filter(function (item) {
        return item[".key"] === invoice[".key"];
      })[0];
      this.returnInvoiceDialog = true;
    }
  }
});

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InvoiceScreen__ = __webpack_require__(1252);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "InvoiceReturn",
  components: {
    InvoiceScreen: __WEBPACK_IMPORTED_MODULE_2__InvoiceScreen__["a" /* default */]
  },
  props: {
    buyerId: {
      required: true
    },
    isBuyer: {
      required: true
    },
    invoiceDetail: {
      required: true,
      type: Object
    },
    firms: {
      type: Array
    },
    banks: {
      type: Array
    },
    buyers: {
      type: Array
    },
    sellers: {
      type: Array
    }
  },
  data: function data() {
    return {
      formIsValid: true,
      form: [{}],
      invoiceData: this.invoiceDetail,
      returnInvoiceData: JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.invoiceDetail)),
      orignalInvoiceData: JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.invoiceDetail))
    };
  },
  created: function created() {
    // this.reset()
  },

  watch: {
    buyerId: function buyerId(val) {
      this.reset();
    }
  },
  methods: {
    reset: function reset() {
      this.invoiceData = {
        items: [],
        buyerId: this.buyerId
      };
    },
    close: function close() {
      console.log("this.isBuyer", this.isBuyer);
      this.invoiceData["return"] = true;
      if (this.isBuyer) {
        this.invoiceData["isCredited"] = false;
        this.invoiceData["isBuyer"] = true;
      } else {
        this.invoiceData["isCredited"] = true;
        this.invoiceData["isBuyer"] = false;
      }
      // this.$emit('returnInvoice', Object.assign({}, this.invoiceData),Object.assign({}, this.returnInvoiceData))
      this.$emit("returnInvoice", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.orignalInvoiceData), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.invoiceData), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.returnInvoiceData));
      this.reset();
    },
    updateInvoiceData: function updateInvoiceData(data) {
      this.invoiceData = data;
    },
    updateInvoiceReturnData: function updateInvoiceReturnData(data) {
      this.returnInvoiceData = data;
    }
  }
});

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UpdateItem__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils___ = __webpack_require__(47);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* createNamespacedHelpers */])("Buyer")["mapGetters"];

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AddItem: __WEBPACK_IMPORTED_MODULE_7__UpdateItem__["a" /* default */]
  },
  props: {
    isSummary: {
      type: Boolean,
      default: false
    },
    invoiceData: {
      type: Object,
      default: function _default() {
        return {
          items: [],
          rate: 2,
          totalAmount: 0,
          buyerId: null
        };
      }
    },
    returnInvoiceData: {
      type: Object,
      default: function _default() {
        return {
          items: [],
          rate: 2,
          totalAmount: 0,
          buyerId: null
        };
      }
    },
    buyerId: String,
    firms: {
      type: Array
    },
    banks: {
      type: Array
    },
    buyers: {
      type: Array
    },
    sellers: {
      type: Array
    }
  },
  data: function data() {
    return {
      tab: null,
      isBuyer: null,
      formIsValid: true,
      dialog: false,
      headers: [{ text: "", value: "name", sortable: false }, { text: "Name", sortable: false, value: "productName" }, { text: "HSN code", sortable: false, value: "HSN_code" }, { text: "GST", sortable: false, value: "taxableGST_rate" }, { text: "Rate", sortable: false, value: "rate" }, { text: "Unit", sortable: false, value: "unit" }, { text: "Quantity", sortable: false, value: "quantity" }, { text: "Basic Price", sortable: false, value: "basicPrice" }, { text: "GST value", sortable: false, value: "GSTValue" }, { text: "Total Price", sortable: false, value: "totlePrice" }, { text: "CGST value ( %)", sortable: false, value: "CGST" }, { text: "SGST value ( %)", sortable: false, value: "SGST" }, { text: "IGST value ( %)", sortable: false, value: "IGST" }],
      items: this.invoiceData.items || [],
      returnItems: this.returnInvoiceData.items || [],
      editedIndex: -1,
      editedItem: {
        productName: "",
        productId: "",
        HSN_code: "",
        taxableGST_rate: 0,
        rate: 0,
        unit: "",
        quantity: 0,
        basicPrice: 0,
        GSTValue: 0,
        totlePrice: 0
      },
      defaultItem: {
        productName: "",
        productId: "",
        HSN_code: "",
        taxableGST_rate: 0,
        rate: 0,
        unit: "",
        quantity: 0,
        basicPrice: 0,
        GSTValue: 0,
        totlePrice: 0
      },
      amountFromCash: this.invoiceData.amountFromCash || 0,
      amountFromBank: this.invoiceData.amountFromBank || 0,

      amountFromCashReturn: this.returnInvoiceData.amountFromCash || 0,
      amountFromBankReturn: this.returnInvoiceData.amountFromBank || 0,

      alertDuration: this.invoiceData.duration || 0,
      paymentType: this.invoiceData.paymentType || "Cash",
      selectedFirm: this.invoiceData.firm || "",
      selectedBank: this.invoiceData.bank || "",
      prevInvoiceDate: this.invoiceData.date ? new Date(this.invoiceData.date).toISOString().substr(0, 10) : new Date().toISOString().substr(0, 10),
      invoiceDate: new Date().toISOString().substr(0, 10),

      datepicker: false,
      datepicker2: false,
      totalAmount: this.invoiceData.totalAmount || 0,
      paidAmount: this.invoiceData.paidAmount || 0,
      remainingAmount: this.invoiceData.remainingAmount || 0,

      totalAmountReturn: this.returnInvoiceData.totalAmount || 0,
      paidAmountReturn: this.returnInvoiceData.paidAmount || 0,
      remainingAmountReturn: this.returnInvoiceData.remainingAmount || 0,

      discountAmount: this.invoiceData.discountAmount || 0,
      invoiceDraft: {},
      returnInvoiceDraft: {},
      availableBalance: 0,
      firms: [],
      banks: [],
      transactionType: this.invoiceData.transactionType || "",
      amountFromCashDisabled: false,
      amountFromBankDisabled: false,
      status: this.invoiceData.status,
      gstType: this.invoiceData.gstType,
      currentUser: {},
      invoiceId: this.invoiceData.invoiceId,
      noteNumber: null,
      GST_Val_total: {
        CGST_val: 0,
        SGST_val: 0,
        IGST_val: 0
      },
      GST_Percentage_total: {
        GST_0: 0,
        GST_5: 0,
        GST_12: 0,
        GST_18: 0,
        GST_28: 0
      },
      R_GST_Val_total: {
        CGST_val: 0,
        SGST_val: 0,
        IGST_val: 0
      },
      R_GST_Percentage_total: {
        GST_0: 0,
        GST_5: 0,
        GST_12: 0,
        GST_18: 0,
        GST_28: 0
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand"]), mapBuyerGetters(["selectedBuyer"]), {
    firmsByBrand: function firmsByBrand() {
      var _this = this;

      return this.firms.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      }).map(function (item) {
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
    },
    banksByFirms: function banksByFirms() {
      var _this2 = this;

      return this.banks.filter(function (item) {
        return item["brand"] === _this2.selectedBrand && item["firm"] === _this2.selectedFirm;
      }).map(function (item) {
        return {
          text: item["bankName"],
          value: item[".key"]
        };
      });
    },
    totalItems: function totalItems() {
      return this.items.length || 0;
    },
    totalItemsRetuen: function totalItemsRetuen() {
      return this.returnItems.length || 0;
    },
    todaysDate: function todaysDate() {
      var date = new Date();
      return date.getDate() + "\\" + date.getMonth() + "\\" + date.getYear();
    },
    principalValueTotal: function principalValueTotal() {
      return this.items.reduce(function (accumulator, currentValue) {
        return accumulator + __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_float___default()(currentValue.totlePrice);
      }, 0);
    },
    principalValueTotalReturn: function principalValueTotalReturn() {
      return this.returnItems.reduce(function (accumulator, currentValue) {
        return accumulator + __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_float___default()(currentValue.totlePrice);
      }, 0);
    }
  }),
  mounted: function mounted() {
    this.getCurrentUser();
  },
  created: function created() {
    this.invoiceDraft = {
      items: this.items,
      amountFromCash: this.amountFromCash || 0,
      amountFromBank: this.amountFromBank || 0,
      buyerId: this.buyerId,
      brand: this.selectedBrand,
      date: new Date().getTime(),
      invoiceDate: new Date(this.invoiceDate).getTime(),
      duration: this.alertDuration, // days
      paymentType: this.paymentType,
      transactionType: this.transactionType,
      isCredited: false,
      firm: this.selectedFirm,
      bank: ["Cash", ""].includes(this.paymentType) ? "0" : this.selectedBank,
      totalAmount: this.principalValueTotal || 0,
      paidAmount: this.paidAmount || 0,
      remainingAmount: this.remainingAmount || 0,
      discountAmount: this.discountAmount || 0,
      status: this.status,
      gstType: this.gstType,
      invoiceId: this.invoiceId
    };
    this.returnInvoiceDraft = {
      items: JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.returnItems)),
      amountFromCash: this.amountFromCash || 0,
      amountFromBank: this.amountFromBank || 0,
      buyerId: this.buyerId,
      brand: this.selectedBrand,
      date: new Date().getTime(),
      invoiceDate: new Date(this.invoiceDate).getTime(),
      duration: this.alertDuration, // days
      paymentType: this.paymentType,
      transactionType: this.transactionType,
      isCredited: false,
      firm: this.selectedFirm,
      bank: ["Cash", ""].includes(this.paymentType) ? "0" : this.selectedBank,
      totalAmount: this.principalValueTotalReturn || 0,
      paidAmount: this.paidAmount || 0,
      remainingAmount: this.remainingAmount || 0,
      discountAmount: this.discountAmount || 0,
      status: this.status,
      gstType: this.gstType,
      invoiceId: this.invoiceId
    };
    this.invoiceDraft[".key"] = this.invoiceData[".key"];
    this.returnInvoiceDraft[".key"] = this.invoiceData[".key"];
    this.calculateGSTType();
    this.getFirmAndBankBalance();
  },

  watch: {
    invoiceData: {
      handler: function handler(newVal, oldVal) {
        this.items = newVal.items || [], this.alertDuration = newVal.duration || 0;
        this.paymentType = newVal.paymentType || "cash";
        this.amountFromCash = newVal.amountFromCash || 0, this.amountFromBank = newVal.amountFromBank || 0, this.transactionType = newVal.transactionType || "", this.rate = newVal.rate || 2;
        this.invoiceDate = newVal.date ? new Date(newVal.date).toISOString().substr(0, 10) : new Date().toISOString().substr(0, 10);
        this.selectedFirm = newVal.firm || 0;
        this.selectedBank = newVal.bank || 0;
        this.totalAmount = newVal.totalAmount || 0, this.paidAmount = newVal.paidAmount || 0, this.remainingAmount = newVal.remainingAmount || 0, this.discountAmount = newVal.discountAmount || 0;
        this.status = newVal.status || "", this.gstType = newVal.gstType || "", this.invoiceId = newVal.invoiceId || "";
      },

      deep: true
    },
    returnInvoiceData: {
      handler: function handler(newVal, oldVal) {
        this.returnItems = newVal.items || [], this.alertDuration = newVal.duration || 0;
        this.paymentType = newVal.paymentType || "cash";
        this.amountFromCashReturn = newVal.amountFromCash || 0, this.amountFromBankReturn = newVal.amountFromBank || 0, this.transactionType = newVal.transactionType || "", this.rate = newVal.rate || 2;
        this.invoiceDate = newVal.date ? new Date(newVal.date).toISOString().substr(0, 10) : new Date().toISOString().substr(0, 10);
        this.selectedFirm = newVal.firm || 0;
        this.selectedBank = newVal.bank || 0;
        this.totalAmountReturn = newVal.totalAmount || 0, this.paidAmountReturn = newVal.paidAmount || 0, this.remainingAmountReturn = newVal.remainingAmount || 0, this.discountAmount = newVal.discountAmount || 0;
        this.status = newVal.status || "", this.gstType = newVal.gstType || "", this.invoiceId = newVal.invoiceId || "";
      },

      deep: true
    },
    items: {
      handler: function handler(newVal, oldVal) {
        this.updateAndEmit("totalAmount", this.principalValueTotal);
        // this.updateAndEmit('totalCurrentAmount', this.currentValueTotal)
      },

      deep: true
    },
    returnItems: {
      handler: function handler(newVal, oldVal) {
        this.updateAndEmitReturn("totalAmount", this.principalValueTotalReturn);
        // this.updateAndEmit('totalCurrentAmount', this.currentValueTotal)
      },

      deep: true
    },
    selectedBrand: function selectedBrand(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("brand", newVal);
        this.updateAndEmitReturn("brand", newVal);
      }
    },
    status: function status(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("status", newVal);
        this.updateAndEmitReturn("status", newVal);
      }
    },
    gstType: function gstType(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("gstType", newVal);
        this.updateAndEmitReturn("gstType", newVal);
      }
    },
    noteNumber: function noteNumber(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("noteNumber", newVal);
        this.updateAndEmitReturn("noteNumber", newVal);
      }
    },
    buyerId: function buyerId(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("buyerId", newVal);
        this.updateAndEmitReturn("buyerId", newVal);
      }
    },
    alertDuration: function alertDuration(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("duration", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int___default()(newVal));
        this.updateAndEmitReturn("duration", __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int___default()(newVal));
      }
    },
    paymentType: function paymentType(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("paymentType", newVal);
        this.updateAndEmitReturn("paymentType", newVal);
        if (this.selectedFirm != "") this.getFirmAndBankBalance();
        this.calculateTotal();
      }
    },
    transactionType: function transactionType(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("transactionType", newVal);
        this.updateAndEmitReturn("transactionType", newVal);
        switch (newVal) {
          case "Debit":
            {
              this.updateAndEmit("status", "due");
              this.updateAndEmitReturn("status", "due");
              break;
            }
          case "Partial Paid":
            {
              this.updateAndEmit("status", "partial");
              this.updateAndEmitReturn("status", "due");
              break;
            }
          case "Credit":
            {
              this.updateAndEmit("status", "paid");
              this.updateAndEmitReturn("status", "due");
              break;
            }
        }
        this.calculateTotal();
      }
    },
    invoiceDate: function invoiceDate(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("date", new Date(newVal).getTime());
        this.updateAndEmitReturn("date", new Date(newVal).getTime());
      }
    },
    prevInvoiceDate: function prevInvoiceDate(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("parentInvoiceDate", new Date(newVal).getTime());
        this.updateAndEmitReturn("parentInvoiceDate", new Date(newVal).getTime());
      }
    },
    invoiceId: function invoiceId(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("invoiceId", newVal);
        this.updateAndEmitReturn("invoiceId", newVal);
      }
    },
    selectedFirm: function selectedFirm(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("firm", newVal);
        this.updateAndEmitReturn("firm", newVal);
        this.getFirmAndBankBalance();
        this.calculateGSTType();
      }
    },
    selectedBank: function selectedBank(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("bank", newVal);
        this.updateAndEmitReturn("bank", newVal);
        if (this.selectedFirm != "") this.getFirmAndBankBalance();
      }
    },
    amountFromCash: function amountFromCash(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.calculateTotal();
      }
    },
    amountFromBank: function amountFromBank(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.calculateTotal();
      }
    },
    discountAmount: function discountAmount(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("discountAmount", newVal);
        this.updateAndEmitReturn("discountAmount", newVal);
        this.calculateTotal();
      }
    }
  },
  methods: {
    resetAmounts: function resetAmounts() {
      this.amountFromCash = 0;
      this.amountFromBank = 0;
      this.discountAmount = 0;

      this.amountFromCashReturn = 0;
      this.amountFromBankReturn = 0;
    },
    getFirmAndBankBalance: function getFirmAndBankBalance() {
      var _this3 = this;

      switch (this.paymentType) {
        case "Cash":
          {
            if (this.selectedFirm) {
              var selectedFirm = this.firms.filter(function (item) {
                return item["brand"] === _this3.selectedBrand && item[".key"] == _this3.selectedFirm;
              });
              this.availableBalance = selectedFirm.length && (selectedFirm[0]["amount"] ? selectedFirm[0]["amount"] : 0);
            } else {
              this.availableBalance = 0;
            }
            break;
          }
        case "Bank Account":
          {
            if (this.selectedBank) {
              var selectedBank = this.banks.filter(function (item) {
                return item["brand"] === _this3.selectedBrand && item[".key"] == _this3.selectedBank;
              });
              this.availableBalance = selectedBank.length && (selectedBank[0]["amount"] ? selectedBank[0]["amount"] : 0);
            } else {
              this.availableBalance = 0;
            }
            break;
          }
        case "CashAndBank Account":
          {
            if (this.selectedFirm && this.selectedBank) {
              var _selectedFirm = this.firms.filter(function (item) {
                return item["brand"] === _this3.selectedBrand && item[".key"] == _this3.selectedFirm;
              });
              var _selectedBank = this.banks.filter(function (item) {
                return item["brand"] === _this3.selectedBrand && item[".key"] == _this3.selectedBank;
              });
              this.availableBalance = _selectedFirm.length && _selectedBank.length && (_selectedBank[0]["amount"] ? _selectedBank[0]["amount"] : 0) + (_selectedFirm[0]["amount"] ? _selectedFirm[0]["amount"] : 0);
            } else {
              this.availableBalance = 0;
            }
            break;
          }
      }
    },
    editItem: function editItem(item) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, item);
      this.dialog = true;
    },
    deleteItem: function deleteItem(item) {
      var index = this.items.indexOf(item);
      confirm("Are you sure you want to delete this item?") && this.items.splice(index, 1);
    },
    close: function close() {
      var _this4 = this;

      this.dialog = false;
      setTimeout(function () {
        _this4.editedItem = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this4.defaultItem);
        _this4.editedIndex = -1;
      }, 300);
    },
    calculateTotal: function calculateTotal() {
      var discountAmount = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_float___default()(this.discountAmount).toFixed(2);
      var amountFromBank = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_float___default()(this.amountFromBank).toFixed(2);
      var amountFromCash = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_float___default()(this.amountFromCash).toFixed(2);

      var amountFromBankReturn = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_float___default()(this.amountFromBankReturn).toFixed(2);
      var amountFromCashReturn = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_float___default()(this.amountFromCashReturn).toFixed(2);
      switch (this.paymentType) {
        case "Cash":
          {
            this.amountFromBank = 0;
            this.amountFromBankReturn = 0;
            this.amountFromBankDisabled = true;
            switch (this.transactionType) {
              case "Debit":
                {
                  this.amountFromCashDisabled = true;
                  this.amountFromCash = this.totalAmount - discountAmount;
                  this.remainingAmount = this.totalAmount - discountAmount;
                  this.amountFromCashReturn = this.totalAmountReturn - discountAmount;
                  this.remainingAmountReturn = this.totalAmountReturn - discountAmount;
                  this.paidAmount = 0;
                  break;
                }
              case "Partial Paid":
                {
                  this.amountFromCashDisabled = false;
                  this.remainingAmount = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_float___default()(this.totalAmount) - __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_float___default()(amountFromCash + discountAmount);
                  this.paidAmount = amountFromCash;

                  this.remainingAmountReturn = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_float___default()(this.totalAmountReturn) - __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_float___default()(amountFromCashReturn + discountAmount);
                  this.paidAmountReturn = amountFromCashReturn;
                  break;
                }
              case "Credit":
                {
                  this.amountFromCashDisabled = true;
                  this.amountFromCash = this.totalAmount - discountAmount;
                  this.remainingAmount = 0;
                  this.paidAmount = this.totalAmount - discountAmount;

                  this.amountFromCashReturn = this.totalAmountReturn - discountAmount;
                  this.remainingAmountReturn = 0;
                  this.paidAmountReturn = this.totalAmountReturn - discountAmount;
                  break;
                }
            }
            break;
          }
        case "Bank Account":
          {
            this.amountFromCashDisabled = true;
            this.amountFromCash = 0;
            this.amountFromCashReturn = 0;
            switch (this.transactionType) {
              case "Debit":
                {
                  this.amountFromBankDisabled = true;
                  this.amountFromBank = this.totalAmount - discountAmount;
                  this.remainingAmount = this.totalAmount - discountAmount;
                  this.paidAmount = 0;

                  this.amountFromBankReturn = this.totalAmountReturn - discountAmount;
                  this.remainingAmountReturn = this.totalAmountReturn - discountAmount;
                  this.paidAmountReturn = 0;
                  break;
                }
              case "Partial Paid":
                {
                  this.amountFromBankDisabled = false;
                  this.remainingAmount = this.totalAmount - __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_float___default()(amountFromBank + discountAmount);
                  this.paidAmount = amountFromBank;

                  this.remainingAmountReturn = this.totalAmountReturn - __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_float___default()(amountFromBankReturn + discountAmount);
                  this.paidAmountReturn = amountFromBankReturn;
                  break;
                }
              case "Credit":
                {
                  this.amountFromBankDisabled = true;
                  this.amountFromBank = this.totalAmount - discountAmount;
                  this.remainingAmount = 0;
                  this.paidAmount = this.totalAmount - discountAmount;

                  this.amountFromBankReturn = this.totalAmountReturn - discountAmount;
                  this.remainingAmountReturn = 0;
                  this.paidAmountReturn = this.totalAmountReturn - discountAmount;
                  break;
                }
            }
            break;
          }
        case "CashAndBank Account":
          {
            this.amountFromCashDisabled = false;
            this.amountFromBankDisabled = false;
            var totalBankAndCash = amountFromCash + amountFromBank;
            var totalBankAndCashReturn = amountFromCashReturn + amountFromBankReturn;
            switch (this.transactionType) {
              case "Debit":
                {
                  this.remainingAmount = this.totalAmount - discountAmount;
                  this.paidAmount = 0;

                  this.remainingAmountReturn = this.totalAmountReturn - discountAmount;
                  this.paidAmountReturn = 0;
                  break;
                }
              case "Partial Paid":
                {
                  this.paidAmount = totalBankAndCash;
                  this.remainingAmount = this.totalAmount - __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_float___default()(this.paidAmount + discountAmount);

                  this.paidAmountReturn = totalBankAndCashReturn;
                  this.remainingAmountReturn = this.totalAmountReturn - __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_float___default()(this.paidAmountReturn + discountAmount);
                  break;
                }
              case "Credit":
                {
                  this.remainingAmount = 0;
                  this.paidAmount = this.totalAmount - discountAmount;

                  this.remainingAmountReturn = 0;
                  this.paidAmountReturn = this.totalAmountReturn - discountAmount;
                  break;
                }
            }
            break;
            break;
          }
      }
      this.updateAndEmit("paidAmount", this.paidAmount);
      this.updateAndEmit("amountFromCash", this.amountFromCash);
      this.updateAndEmit("amountFromBank", this.amountFromBank);
      this.updateAndEmit("remainingAmount", this.remainingAmount);

      this.updateAndEmitReturn("paidAmount", this.paidAmountReturn);
      this.updateAndEmitReturn("amountFromCash", this.amountFromCashReturn);
      this.updateAndEmitReturn("amountFromBank", this.amountFromBankReturn);
      this.updateAndEmitReturn("remainingAmount", this.remainingAmountReturn);
    },
    save: function save(editedItem, returnItem) {
      if (this.editedIndex > -1) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.items[this.editedIndex], editedItem);
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.returnItems[this.editedIndex], returnItem);
      } else {
        this.items.push(editedItem);
      }
      this.calculateTotal();
      this.calculateGSTType();
      this.close();
    },
    calculateGSTType: function calculateGSTType() {
      var _this5 = this;

      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.currentUser).length === 0) {
        this.getCurrentUser();
      }
      this.GST_Val_total.SGST_val = 0;
      this.GST_Val_total.CGST_val = 0;
      this.GST_Val_total.IGST_val = 0;

      this.R_GST_Val_total.SGST_val = 0;
      this.R_GST_Val_total.CGST_val = 0;
      this.R_GST_Val_total.IGST_val = 0;
      this.items.map(function (item, index) {
        var GST = item["taxableGST_rate"];
        var firm = _this5.firms.filter(function (item) {
          return item['.key'] == _this5.selectedFirm;
        })[0];
        if (_this5.selectedFirm && _this5.currentUser.state && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_float___default()(GST) && firm.state === _this5.currentUser.state) {
          item["CGST_val"] = item["GSTValue"] / 2;
          item["CGST"] = GST / 2;
          item["SGST_val"] = item["GSTValue"] / 2;
          item["SGST"] = GST / 2;
          item["IGST"] = 0;
          item["IGST_val"] = 0;
          _this5.GST_Val_total.SGST_val += __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_float___default()(item["SGST_val"]);
          _this5.GST_Val_total.CGST_val += __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_float___default()(item["CGST_val"]);
          _this5.GST_Val_total.IGST_val += __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_float___default()(item["IGST_val"]);
          _this5.updateAndEmit("gstType", "SGST|CGST");
        } else {
          item["IGST"] = GST;
          item["CGST"] = 0;
          item["SGST"] = 0;
          item["IGST_val"] = item["GSTValue"];
          item["CGST_val"] = 0;
          item["SGST_val"] = 0;
          _this5.GST_Val_total.SGST_val += __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_float___default()(item["SGST_val"]);
          _this5.GST_Val_total.CGST_val += __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_float___default()(item["CGST_val"]);
          _this5.GST_Val_total.IGST_val += __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_float___default()(item["IGST_val"]);
          _this5.updateAndEmit("gstType", "IGST");
        }
        _this5.items[index] = item;
      });

      this.returnItems.map(function (item, index) {
        var GST = item["taxableGST_rate"];
        var firm = _this5.firms.filter(function (item) {
          return item['.key'] == _this5.selectedFirm;
        })[0];
        if (_this5.selectedFirm && _this5.currentUser.state && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_float___default()(GST) && firm.state === _this5.currentUser.state) {
          item["CGST_val"] = item["GSTValue"] / 2;
          item["CGST"] = GST / 2;
          item["SGST_val"] = item["GSTValue"] / 2;
          item["SGST"] = GST / 2;
          item["IGST"] = 0;
          item["IGST_val"] = 0;
          _this5.R_GST_Val_total.SGST_val += __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_float___default()(item["SGST_val"]);
          _this5.R_GST_Val_total.CGST_val += __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_float___default()(item["CGST_val"]);
          _this5.R_GST_Val_total.IGST_val += __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_float___default()(item["IGST_val"]);
          _this5.updateAndEmitReturn("gstType", "SGST|CGST");
        } else {
          item["IGST"] = GST;
          item["CGST"] = 0;
          item["SGST"] = 0;
          item["IGST_val"] = item["GSTValue"];
          item["CGST_val"] = 0;
          item["SGST_val"] = 0;
          _this5.R_GST_Val_total.SGST_val += __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_float___default()(item["SGST_val"]);
          _this5.R_GST_Val_total.CGST_val += __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_float___default()(item["CGST_val"]);
          _this5.R_GST_Val_total.IGST_val += __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_float___default()(item["IGST_val"]);
          _this5.updateAndEmitReturn("gstType", "IGST");
        }
        _this5.returnItems[index] = item;
      });

      this.GST_Percentage_total = Object(__WEBPACK_IMPORTED_MODULE_8__utils___["c" /* getGSTPercentageTotal */])(this.items);
      this.R_GST_Percentage_total = Object(__WEBPACK_IMPORTED_MODULE_8__utils___["c" /* getGSTPercentageTotal */])(this.returnItems);
      this.updateAndEmit("items", this.items);
      this.updateAndEmitReturn("items", this.returnItems);
    },
    updateAndEmit: function updateAndEmit(key, value) {
      this.invoiceDraft[key] = value;
      this.$emit("updateInvoiceData", this.invoiceDraft);
    },
    updateAndEmitReturn: function updateAndEmitReturn(key, value) {
      this.returnInvoiceDraft[key] = value;
      this.$emit("updateInvoiceReturnData", this.returnInvoiceDraft);
    },
    saveInvoice: function saveInvoice() {
      this.updateAndEmit("buyerId", this.selectedBuyer);
      //      this.manageUnchangedItems();
      this.$emit("close");
    },
    getCurrentUser: function getCurrentUser() {
      var _this6 = this;

      var buyer = this.buyers.filter(function (item) {
        return item[".key"] === _this6.selectedBuyer;
      })[0];
      var seller = this.sellers.filter(function (item) {
        return item[".key"] === _this6.selectedBuyer;
      })[0];
      this.isBuyer = !!buyer ? true : false;
      this.currentUser = buyer && buyer.state ? buyer : seller && seller.state ? seller : {};
    },
    manageUnchangedItems: function manageUnchangedItems() {
      var _this7 = this;

      this.items.map(function (item, index) {
        if (!item.changed) {
          _this7.items.splice(index, 1);
        }
      });
      this.calculateTotal();
      this.calculateGSTType();
    }
  }
});

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_body_parser__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_body_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_body_parser__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    buyerId: String,
    editedItem: {
      type: Object,
      default: function _default() {
        return {
          productName: "",
          productId: "",
          HSN_code: "",
          taxableGST_rate: 0,
          rate: 0,
          unit: "",
          quantity: 0,
          basicPrice: 0,
          GSTValue: 0,
          totlePrice: 0,
          GST_type: '',
          productUnit: '',
          returnRemark: ''
        };
      }
    }
  },
  data: function data() {
    return {
      actaulQuantity: this.editedItem.quantity,
      item: this.editedItem,
      returnItem: JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.editedItem)),
      selectedProduct: {}
    };
  },

  watch: {
    editedItem: function editedItem(val) {
      this.item = this.editedItem;
      this.returnItem = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.editedItem));
      this.actaulQuantity = this.editedItem.quantity;
    },

    "item.quantity": {
      handler: function handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.calculatePrices();
        }
      },

      deep: true
    }
  },
  created: function created() {
    this.$bindAsArray("rate", this.$root.$firebaseRefs.rate.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("product", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand"]), {
    formTitle: function formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    }
  }),

  methods: {
    close: function close() {
      this.$emit("closeAddItem");
    },

    // productChange(val) {
    //   this.selectedProduct = val;
    //   this.item.productId = val[".key"];
    //   this.item.HSN_code = val["HSN_code"];
    //   this.item.taxableGST_rate = val["taxableGST_rate"];
    // },
    calculatePrices: function calculatePrices() {
      this.item.basicPrice = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.item.rate * this.item.quantity).toFixed(2);
      this.item.GSTValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.item.basicPrice * (parseFloat(this.item.taxableGST_rate) / 100)).toFixed(2);
      this.item.totlePrice = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.item.basicPrice) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.item.GSTValue)).toFixed(2);

      this.returnItem.quantity = this.actaulQuantity - this.item.quantity;
      // console.log(this.returnItem.quantity)
      // console.log(">>>>")
      this.returnItem.basicPrice = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.returnItem.rate * this.returnItem.quantity).toFixed(2);
      this.returnItem.GSTValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.returnItem.basicPrice * (parseFloat(this.returnItem.taxableGST_rate) / 100)).toFixed(2);
      this.returnItem.totlePrice = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.returnItem.basicPrice) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.returnItem.GSTValue)).toFixed(2);
      this.item['changed'] = true;
    },
    save: function save() {
      // this.selectedProduct = this.product[this.item.productId];
      // this.item.productName = this.selectedProduct.name;
      // this.item.GST_type = this.selectedProduct.GST_type;
      // this.item.productUnit = this.selectedProduct.unit;
      this.$emit('saveAddItem', this.item, this.returnItem);
      // this.reset()
    },
    reset: function reset() {
      this.item = {
        productName: "",
        productId: "",
        HSN_code: "",
        taxableGST_rate: 0,
        rate: 0,
        unit: "",
        quantity: 0,
        basicPrice: 0,
        GSTValue: 0,
        totlePrice: 0,
        GST_type: "",
        productUnit: ''
      };
      this.returnItem = {
        productName: "",
        productId: "",
        HSN_code: "",
        taxableGST_rate: 0,
        rate: 0,
        unit: "",
        quantity: 0,
        basicPrice: 0,
        GSTValue: 0,
        totlePrice: 0,
        GST_type: "",
        productUnit: ''
      };
    }
  }
});

/***/ }),
/* 416 */,
/* 417 */,
/* 418 */
/***/ (function(module, exports) {

module.exports = [["a140","",62],["a180","",32],["a240","",62],["a280","",32],["a2ab","",5],["a2e3","€"],["a2ef",""],["a2fd",""],["a340","",62],["a380","",31,"　"],["a440","",62],["a480","",32],["a4f4","",10],["a540","",62],["a580","",32],["a5f7","",7],["a640","",62],["a680","",32],["a6b9","",7],["a6d9","",6],["a6ec",""],["a6f3",""],["a6f6","",8],["a740","",62],["a780","",32],["a7c2","",14],["a7f2","",12],["a896","",10],["a8bc",""],["a8bf","ǹ"],["a8c1",""],["a8ea","",20],["a958",""],["a95b",""],["a95d",""],["a989","〾⿰",11],["a997","",12],["a9f0","",14],["aaa1","",93],["aba1","",93],["aca1","",93],["ada1","",93],["aea1","",93],["afa1","",93],["d7fa","",4],["f8a1","",93],["f9a1","",93],["faa1","",93],["fba1","",93],["fca1","",93],["fda1","",93],["fe50","⺁⺄㑳㑇⺈⺋㖞㘚㘎⺌⺗㥮㤘㧏㧟㩳㧐㭎㱮㳠⺧⺪䁖䅟⺮䌷⺳⺶⺷䎱䎬⺻䏝䓖䙡䙌"],["fe80","䜣䜩䝼䞍⻊䥇䥺䥽䦂䦃䦅䦆䦟䦛䦷䦶䲣䲟䲠䲡䱷䲢䴓",6,"䶮",93]]

/***/ }),
/* 419 */
/***/ (function(module, exports) {

module.exports = [["0","\u0000",127],["a140","　，、。．‧；：？！︰…‥﹐﹑﹒·﹔﹕﹖﹗｜–︱—︳╴︴﹏（）︵︶｛｝︷︸〔〕︹︺【】︻︼《》︽︾〈〉︿﹀「」﹁﹂『』﹃﹄﹙﹚"],["a1a1","﹛﹜﹝﹞‘’“”〝〞‵′＃＆＊※§〃○●△▲◎☆★◇◆□■▽▼㊣℅¯￣＿ˍ﹉﹊﹍﹎﹋﹌﹟﹠﹡＋－×÷±√＜＞＝≦≧≠∞≒≡﹢",4,"～∩∪⊥∠∟⊿㏒㏑∫∮∵∴♀♂⊕⊙↑↓←→↖↗↙↘∥∣／"],["a240","＼∕﹨＄￥〒￠￡％＠℃℉﹩﹪﹫㏕㎜㎝㎞㏎㎡㎎㎏㏄°兙兛兞兝兡兣嗧瓩糎▁",7,"▏▎▍▌▋▊▉┼┴┬┤├▔─│▕┌┐└┘╭"],["a2a1","╮╰╯═╞╪╡◢◣◥◤╱╲╳０",9,"Ⅰ",9,"〡",8,"十卄卅Ａ",25,"ａ",21],["a340","ｗｘｙｚΑ",16,"Σ",6,"α",16,"σ",6,"ㄅ",10],["a3a1","ㄐ",25,"˙ˉˊˇˋ"],["a3e1","€"],["a440","一乙丁七乃九了二人儿入八几刀刁力匕十卜又三下丈上丫丸凡久么也乞于亡兀刃勺千叉口土士夕大女子孑孓寸小尢尸山川工己已巳巾干廾弋弓才"],["a4a1","丑丐不中丰丹之尹予云井互五亢仁什仃仆仇仍今介仄元允內六兮公冗凶分切刈勻勾勿化匹午升卅卞厄友及反壬天夫太夭孔少尤尺屯巴幻廿弔引心戈戶手扎支文斗斤方日曰月木欠止歹毋比毛氏水火爪父爻片牙牛犬王丙"],["a540","世丕且丘主乍乏乎以付仔仕他仗代令仙仞充兄冉冊冬凹出凸刊加功包匆北匝仟半卉卡占卯卮去可古右召叮叩叨叼司叵叫另只史叱台句叭叻四囚外"],["a5a1","央失奴奶孕它尼巨巧左市布平幼弁弘弗必戊打扔扒扑斥旦朮本未末札正母民氐永汁汀氾犯玄玉瓜瓦甘生用甩田由甲申疋白皮皿目矛矢石示禾穴立丞丟乒乓乩亙交亦亥仿伉伙伊伕伍伐休伏仲件任仰仳份企伋光兇兆先全"],["a640","共再冰列刑划刎刖劣匈匡匠印危吉吏同吊吐吁吋各向名合吃后吆吒因回囝圳地在圭圬圯圩夙多夷夸妄奸妃好她如妁字存宇守宅安寺尖屹州帆并年"],["a6a1","式弛忙忖戎戌戍成扣扛托收早旨旬旭曲曳有朽朴朱朵次此死氖汝汗汙江池汐汕污汛汍汎灰牟牝百竹米糸缶羊羽老考而耒耳聿肉肋肌臣自至臼舌舛舟艮色艾虫血行衣西阡串亨位住佇佗佞伴佛何估佐佑伽伺伸佃佔似但佣"],["a740","作你伯低伶余佝佈佚兌克免兵冶冷別判利刪刨劫助努劬匣即卵吝吭吞吾否呎吧呆呃吳呈呂君吩告吹吻吸吮吵吶吠吼呀吱含吟听囪困囤囫坊坑址坍"],["a7a1","均坎圾坐坏圻壯夾妝妒妨妞妣妙妖妍妤妓妊妥孝孜孚孛完宋宏尬局屁尿尾岐岑岔岌巫希序庇床廷弄弟彤形彷役忘忌志忍忱快忸忪戒我抄抗抖技扶抉扭把扼找批扳抒扯折扮投抓抑抆改攻攸旱更束李杏材村杜杖杞杉杆杠"],["a840","杓杗步每求汞沙沁沈沉沅沛汪決沐汰沌汨沖沒汽沃汲汾汴沆汶沍沔沘沂灶灼災灸牢牡牠狄狂玖甬甫男甸皂盯矣私秀禿究系罕肖肓肝肘肛肚育良芒"],["a8a1","芋芍見角言谷豆豕貝赤走足身車辛辰迂迆迅迄巡邑邢邪邦那酉釆里防阮阱阪阬並乖乳事些亞享京佯依侍佳使佬供例來侃佰併侈佩佻侖佾侏侑佺兔兒兕兩具其典冽函刻券刷刺到刮制剁劾劻卒協卓卑卦卷卸卹取叔受味呵"],["a940","咖呸咕咀呻呷咄咒咆呼咐呱呶和咚呢周咋命咎固垃坷坪坩坡坦坤坼夜奉奇奈奄奔妾妻委妹妮姑姆姐姍始姓姊妯妳姒姅孟孤季宗定官宜宙宛尚屈居"],["a9a1","屆岷岡岸岩岫岱岳帘帚帖帕帛帑幸庚店府底庖延弦弧弩往征彿彼忝忠忽念忿怏怔怯怵怖怪怕怡性怩怫怛或戕房戾所承拉拌拄抿拂抹拒招披拓拔拋拈抨抽押拐拙拇拍抵拚抱拘拖拗拆抬拎放斧於旺昔易昌昆昂明昀昏昕昊"],["aa40","昇服朋杭枋枕東果杳杷枇枝林杯杰板枉松析杵枚枓杼杪杲欣武歧歿氓氛泣注泳沱泌泥河沽沾沼波沫法泓沸泄油況沮泗泅泱沿治泡泛泊沬泯泜泖泠"],["aaa1","炕炎炒炊炙爬爭爸版牧物狀狎狙狗狐玩玨玟玫玥甽疝疙疚的盂盲直知矽社祀祁秉秈空穹竺糾罔羌羋者肺肥肢肱股肫肩肴肪肯臥臾舍芳芝芙芭芽芟芹花芬芥芯芸芣芰芾芷虎虱初表軋迎返近邵邸邱邶采金長門阜陀阿阻附"],["ab40","陂隹雨青非亟亭亮信侵侯便俠俑俏保促侶俘俟俊俗侮俐俄係俚俎俞侷兗冒冑冠剎剃削前剌剋則勇勉勃勁匍南卻厚叛咬哀咨哎哉咸咦咳哇哂咽咪品"],["aba1","哄哈咯咫咱咻咩咧咿囿垂型垠垣垢城垮垓奕契奏奎奐姜姘姿姣姨娃姥姪姚姦威姻孩宣宦室客宥封屎屏屍屋峙峒巷帝帥帟幽庠度建弈弭彥很待徊律徇後徉怒思怠急怎怨恍恰恨恢恆恃恬恫恪恤扁拜挖按拼拭持拮拽指拱拷"],["ac40","拯括拾拴挑挂政故斫施既春昭映昧是星昨昱昤曷柿染柱柔某柬架枯柵柩柯柄柑枴柚查枸柏柞柳枰柙柢柝柒歪殃殆段毒毗氟泉洋洲洪流津洌洱洞洗"],["aca1","活洽派洶洛泵洹洧洸洩洮洵洎洫炫為炳炬炯炭炸炮炤爰牲牯牴狩狠狡玷珊玻玲珍珀玳甚甭畏界畎畋疫疤疥疢疣癸皆皇皈盈盆盃盅省盹相眉看盾盼眇矜砂研砌砍祆祉祈祇禹禺科秒秋穿突竿竽籽紂紅紀紉紇約紆缸美羿耄"],["ad40","耐耍耑耶胖胥胚胃胄背胡胛胎胞胤胝致舢苧范茅苣苛苦茄若茂茉苒苗英茁苜苔苑苞苓苟苯茆虐虹虻虺衍衫要觔計訂訃貞負赴赳趴軍軌述迦迢迪迥"],["ada1","迭迫迤迨郊郎郁郃酋酊重閂限陋陌降面革韋韭音頁風飛食首香乘亳倌倍倣俯倦倥俸倩倖倆值借倚倒們俺倀倔倨俱倡個候倘俳修倭倪俾倫倉兼冤冥冢凍凌准凋剖剜剔剛剝匪卿原厝叟哨唐唁唷哼哥哲唆哺唔哩哭員唉哮哪"],["ae40","哦唧唇哽唏圃圄埂埔埋埃堉夏套奘奚娑娘娜娟娛娓姬娠娣娩娥娌娉孫屘宰害家宴宮宵容宸射屑展屐峭峽峻峪峨峰島崁峴差席師庫庭座弱徒徑徐恙"],["aea1","恣恥恐恕恭恩息悄悟悚悍悔悌悅悖扇拳挈拿捎挾振捕捂捆捏捉挺捐挽挪挫挨捍捌效敉料旁旅時晉晏晃晒晌晅晁書朔朕朗校核案框桓根桂桔栩梳栗桌桑栽柴桐桀格桃株桅栓栘桁殊殉殷氣氧氨氦氤泰浪涕消涇浦浸海浙涓"],["af40","浬涉浮浚浴浩涌涊浹涅浥涔烊烘烤烙烈烏爹特狼狹狽狸狷玆班琉珮珠珪珞畔畝畜畚留疾病症疲疳疽疼疹痂疸皋皰益盍盎眩真眠眨矩砰砧砸砝破砷"],["afa1","砥砭砠砟砲祕祐祠祟祖神祝祗祚秤秣秧租秦秩秘窄窈站笆笑粉紡紗紋紊素索純紐紕級紜納紙紛缺罟羔翅翁耆耘耕耙耗耽耿胱脂胰脅胭胴脆胸胳脈能脊胼胯臭臬舀舐航舫舨般芻茫荒荔荊茸荐草茵茴荏茲茹茶茗荀茱茨荃"],["b040","虔蚊蚪蚓蚤蚩蚌蚣蚜衰衷袁袂衽衹記訐討訌訕訊託訓訖訏訑豈豺豹財貢起躬軒軔軏辱送逆迷退迺迴逃追逅迸邕郡郝郢酒配酌釘針釗釜釙閃院陣陡"],["b0a1","陛陝除陘陞隻飢馬骨高鬥鬲鬼乾偺偽停假偃偌做偉健偶偎偕偵側偷偏倏偯偭兜冕凰剪副勒務勘動匐匏匙匿區匾參曼商啪啦啄啞啡啃啊唱啖問啕唯啤唸售啜唬啣唳啁啗圈國圉域堅堊堆埠埤基堂堵執培夠奢娶婁婉婦婪婀"],["b140","娼婢婚婆婊孰寇寅寄寂宿密尉專將屠屜屝崇崆崎崛崖崢崑崩崔崙崤崧崗巢常帶帳帷康庸庶庵庾張強彗彬彩彫得徙從徘御徠徜恿患悉悠您惋悴惦悽"],["b1a1","情悻悵惜悼惘惕惆惟悸惚惇戚戛扈掠控捲掖探接捷捧掘措捱掩掉掃掛捫推掄授掙採掬排掏掀捻捩捨捺敝敖救教敗啟敏敘敕敔斜斛斬族旋旌旎晝晚晤晨晦晞曹勗望梁梯梢梓梵桿桶梱梧梗械梃棄梭梆梅梔條梨梟梡梂欲殺"],["b240","毫毬氫涎涼淳淙液淡淌淤添淺清淇淋涯淑涮淞淹涸混淵淅淒渚涵淚淫淘淪深淮淨淆淄涪淬涿淦烹焉焊烽烯爽牽犁猜猛猖猓猙率琅琊球理現琍瓠瓶"],["b2a1","瓷甜產略畦畢異疏痔痕疵痊痍皎盔盒盛眷眾眼眶眸眺硫硃硎祥票祭移窒窕笠笨笛第符笙笞笮粒粗粕絆絃統紮紹紼絀細紳組累終紲紱缽羞羚翌翎習耜聊聆脯脖脣脫脩脰脤舂舵舷舶船莎莞莘荸莢莖莽莫莒莊莓莉莠荷荻荼"],["b340","莆莧處彪蛇蛀蚶蛄蚵蛆蛋蚱蚯蛉術袞袈被袒袖袍袋覓規訪訝訣訥許設訟訛訢豉豚販責貫貨貪貧赧赦趾趺軛軟這逍通逗連速逝逐逕逞造透逢逖逛途"],["b3a1","部郭都酗野釵釦釣釧釭釩閉陪陵陳陸陰陴陶陷陬雀雪雩章竟頂頃魚鳥鹵鹿麥麻傢傍傅備傑傀傖傘傚最凱割剴創剩勞勝勛博厥啻喀喧啼喊喝喘喂喜喪喔喇喋喃喳單喟唾喲喚喻喬喱啾喉喫喙圍堯堪場堤堰報堡堝堠壹壺奠"],["b440","婷媚婿媒媛媧孳孱寒富寓寐尊尋就嵌嵐崴嵇巽幅帽幀幃幾廊廁廂廄弼彭復循徨惑惡悲悶惠愜愣惺愕惰惻惴慨惱愎惶愉愀愒戟扉掣掌描揀揩揉揆揍"],["b4a1","插揣提握揖揭揮捶援揪換摒揚揹敞敦敢散斑斐斯普晰晴晶景暑智晾晷曾替期朝棺棕棠棘棗椅棟棵森棧棹棒棲棣棋棍植椒椎棉棚楮棻款欺欽殘殖殼毯氮氯氬港游湔渡渲湧湊渠渥渣減湛湘渤湖湮渭渦湯渴湍渺測湃渝渾滋"],["b540","溉渙湎湣湄湲湩湟焙焚焦焰無然煮焜牌犄犀猶猥猴猩琺琪琳琢琥琵琶琴琯琛琦琨甥甦畫番痢痛痣痙痘痞痠登發皖皓皴盜睏短硝硬硯稍稈程稅稀窘"],["b5a1","窗窖童竣等策筆筐筒答筍筋筏筑粟粥絞結絨絕紫絮絲絡給絢絰絳善翔翕耋聒肅腕腔腋腑腎脹腆脾腌腓腴舒舜菩萃菸萍菠菅萋菁華菱菴著萊菰萌菌菽菲菊萸萎萄菜萇菔菟虛蛟蛙蛭蛔蛛蛤蛐蛞街裁裂袱覃視註詠評詞証詁"],["b640","詔詛詐詆訴診訶詖象貂貯貼貳貽賁費賀貴買貶貿貸越超趁跎距跋跚跑跌跛跆軻軸軼辜逮逵週逸進逶鄂郵鄉郾酣酥量鈔鈕鈣鈉鈞鈍鈐鈇鈑閔閏開閑"],["b6a1","間閒閎隊階隋陽隅隆隍陲隄雁雅雄集雇雯雲韌項順須飧飪飯飩飲飭馮馭黃黍黑亂傭債傲傳僅傾催傷傻傯僇剿剷剽募勦勤勢勣匯嗟嗨嗓嗦嗎嗜嗇嗑嗣嗤嗯嗚嗡嗅嗆嗥嗉園圓塞塑塘塗塚塔填塌塭塊塢塒塋奧嫁嫉嫌媾媽媼"],["b740","媳嫂媲嵩嵯幌幹廉廈弒彙徬微愚意慈感想愛惹愁愈慎慌慄慍愾愴愧愍愆愷戡戢搓搾搞搪搭搽搬搏搜搔損搶搖搗搆敬斟新暗暉暇暈暖暄暘暍會榔業"],["b7a1","楚楷楠楔極椰概楊楨楫楞楓楹榆楝楣楛歇歲毀殿毓毽溢溯滓溶滂源溝滇滅溥溘溼溺溫滑準溜滄滔溪溧溴煎煙煩煤煉照煜煬煦煌煥煞煆煨煖爺牒猷獅猿猾瑯瑚瑕瑟瑞瑁琿瑙瑛瑜當畸瘀痰瘁痲痱痺痿痴痳盞盟睛睫睦睞督"],["b840","睹睪睬睜睥睨睢矮碎碰碗碘碌碉硼碑碓硿祺祿禁萬禽稜稚稠稔稟稞窟窠筷節筠筮筧粱粳粵經絹綑綁綏絛置罩罪署義羨群聖聘肆肄腱腰腸腥腮腳腫"],["b8a1","腹腺腦舅艇蒂葷落萱葵葦葫葉葬葛萼萵葡董葩葭葆虞虜號蛹蜓蜈蜇蜀蛾蛻蜂蜃蜆蜊衙裟裔裙補裘裝裡裊裕裒覜解詫該詳試詩詰誇詼詣誠話誅詭詢詮詬詹詻訾詨豢貊貉賊資賈賄貲賃賂賅跡跟跨路跳跺跪跤跦躲較載軾輊"],["b940","辟農運遊道遂達逼違遐遇遏過遍遑逾遁鄒鄗酬酪酩釉鈷鉗鈸鈽鉀鈾鉛鉋鉤鉑鈴鉉鉍鉅鈹鈿鉚閘隘隔隕雍雋雉雊雷電雹零靖靴靶預頑頓頊頒頌飼飴"],["b9a1","飽飾馳馱馴髡鳩麂鼎鼓鼠僧僮僥僖僭僚僕像僑僱僎僩兢凳劃劂匱厭嗾嘀嘛嘗嗽嘔嘆嘉嘍嘎嗷嘖嘟嘈嘐嗶團圖塵塾境墓墊塹墅塽壽夥夢夤奪奩嫡嫦嫩嫗嫖嫘嫣孵寞寧寡寥實寨寢寤察對屢嶄嶇幛幣幕幗幔廓廖弊彆彰徹慇"],["ba40","愿態慷慢慣慟慚慘慵截撇摘摔撤摸摟摺摑摧搴摭摻敲斡旗旖暢暨暝榜榨榕槁榮槓構榛榷榻榫榴槐槍榭槌榦槃榣歉歌氳漳演滾漓滴漩漾漠漬漏漂漢"],["baa1","滿滯漆漱漸漲漣漕漫漯澈漪滬漁滲滌滷熔熙煽熊熄熒爾犒犖獄獐瑤瑣瑪瑰瑭甄疑瘧瘍瘋瘉瘓盡監瞄睽睿睡磁碟碧碳碩碣禎福禍種稱窪窩竭端管箕箋筵算箝箔箏箸箇箄粹粽精綻綰綜綽綾綠緊綴網綱綺綢綿綵綸維緒緇綬"],["bb40","罰翠翡翟聞聚肇腐膀膏膈膊腿膂臧臺與舔舞艋蓉蒿蓆蓄蒙蒞蒲蒜蓋蒸蓀蓓蒐蒼蓑蓊蜿蜜蜻蜢蜥蜴蜘蝕蜷蜩裳褂裴裹裸製裨褚裯誦誌語誣認誡誓誤"],["bba1","說誥誨誘誑誚誧豪貍貌賓賑賒赫趙趕跼輔輒輕輓辣遠遘遜遣遙遞遢遝遛鄙鄘鄞酵酸酷酴鉸銀銅銘銖鉻銓銜銨鉼銑閡閨閩閣閥閤隙障際雌雒需靼鞅韶頗領颯颱餃餅餌餉駁骯骰髦魁魂鳴鳶鳳麼鼻齊億儀僻僵價儂儈儉儅凜"],["bc40","劇劈劉劍劊勰厲嘮嘻嘹嘲嘿嘴嘩噓噎噗噴嘶嘯嘰墀墟增墳墜墮墩墦奭嬉嫻嬋嫵嬌嬈寮寬審寫層履嶝嶔幢幟幡廢廚廟廝廣廠彈影德徵慶慧慮慝慕憂"],["bca1","慼慰慫慾憧憐憫憎憬憚憤憔憮戮摩摯摹撞撲撈撐撰撥撓撕撩撒撮播撫撚撬撙撢撳敵敷數暮暫暴暱樣樟槨樁樞標槽模樓樊槳樂樅槭樑歐歎殤毅毆漿潼澄潑潦潔澆潭潛潸潮澎潺潰潤澗潘滕潯潠潟熟熬熱熨牖犛獎獗瑩璋璃"],["bd40","瑾璀畿瘠瘩瘟瘤瘦瘡瘢皚皺盤瞎瞇瞌瞑瞋磋磅確磊碾磕碼磐稿稼穀稽稷稻窯窮箭箱範箴篆篇篁箠篌糊締練緯緻緘緬緝編緣線緞緩綞緙緲緹罵罷羯"],["bda1","翩耦膛膜膝膠膚膘蔗蔽蔚蓮蔬蔭蔓蔑蔣蔡蔔蓬蔥蓿蔆螂蝴蝶蝠蝦蝸蝨蝙蝗蝌蝓衛衝褐複褒褓褕褊誼諒談諄誕請諸課諉諂調誰論諍誶誹諛豌豎豬賠賞賦賤賬賭賢賣賜質賡赭趟趣踫踐踝踢踏踩踟踡踞躺輝輛輟輩輦輪輜輞"],["be40","輥適遮遨遭遷鄰鄭鄧鄱醇醉醋醃鋅銻銷鋪銬鋤鋁銳銼鋒鋇鋰銲閭閱霄霆震霉靠鞍鞋鞏頡頫頜颳養餓餒餘駝駐駟駛駑駕駒駙骷髮髯鬧魅魄魷魯鴆鴉"],["bea1","鴃麩麾黎墨齒儒儘儔儐儕冀冪凝劑劓勳噙噫噹噩噤噸噪器噥噱噯噬噢噶壁墾壇壅奮嬝嬴學寰導彊憲憑憩憊懍憶憾懊懈戰擅擁擋撻撼據擄擇擂操撿擒擔撾整曆曉暹曄曇暸樽樸樺橙橫橘樹橄橢橡橋橇樵機橈歙歷氅濂澱澡"],["bf40","濃澤濁澧澳激澹澶澦澠澴熾燉燐燒燈燕熹燎燙燜燃燄獨璜璣璘璟璞瓢甌甍瘴瘸瘺盧盥瞠瞞瞟瞥磨磚磬磧禦積穎穆穌穋窺篙簑築篤篛篡篩篦糕糖縊"],["bfa1","縑縈縛縣縞縝縉縐罹羲翰翱翮耨膳膩膨臻興艘艙蕊蕙蕈蕨蕩蕃蕉蕭蕪蕞螃螟螞螢融衡褪褲褥褫褡親覦諦諺諫諱謀諜諧諮諾謁謂諷諭諳諶諼豫豭貓賴蹄踱踴蹂踹踵輻輯輸輳辨辦遵遴選遲遼遺鄴醒錠錶鋸錳錯錢鋼錫錄錚"],["c040","錐錦錡錕錮錙閻隧隨險雕霎霑霖霍霓霏靛靜靦鞘頰頸頻頷頭頹頤餐館餞餛餡餚駭駢駱骸骼髻髭鬨鮑鴕鴣鴦鴨鴒鴛默黔龍龜優償儡儲勵嚎嚀嚐嚅嚇"],["c0a1","嚏壕壓壑壎嬰嬪嬤孺尷屨嶼嶺嶽嶸幫彌徽應懂懇懦懋戲戴擎擊擘擠擰擦擬擱擢擭斂斃曙曖檀檔檄檢檜櫛檣橾檗檐檠歜殮毚氈濘濱濟濠濛濤濫濯澀濬濡濩濕濮濰燧營燮燦燥燭燬燴燠爵牆獰獲璩環璦璨癆療癌盪瞳瞪瞰瞬"],["c140","瞧瞭矯磷磺磴磯礁禧禪穗窿簇簍篾篷簌篠糠糜糞糢糟糙糝縮績繆縷縲繃縫總縱繅繁縴縹繈縵縿縯罄翳翼聱聲聰聯聳臆臃膺臂臀膿膽臉膾臨舉艱薪"],["c1a1","薄蕾薜薑薔薯薛薇薨薊虧蟀蟑螳蟒蟆螫螻螺蟈蟋褻褶襄褸褽覬謎謗謙講謊謠謝謄謐豁谿豳賺賽購賸賻趨蹉蹋蹈蹊轄輾轂轅輿避遽還邁邂邀鄹醣醞醜鍍鎂錨鍵鍊鍥鍋錘鍾鍬鍛鍰鍚鍔闊闋闌闈闆隱隸雖霜霞鞠韓顆颶餵騁"],["c240","駿鮮鮫鮪鮭鴻鴿麋黏點黜黝黛鼾齋叢嚕嚮壙壘嬸彝懣戳擴擲擾攆擺擻擷斷曜朦檳檬櫃檻檸櫂檮檯歟歸殯瀉瀋濾瀆濺瀑瀏燻燼燾燸獷獵璧璿甕癖癘"],["c2a1","癒瞽瞿瞻瞼礎禮穡穢穠竄竅簫簧簪簞簣簡糧織繕繞繚繡繒繙罈翹翻職聶臍臏舊藏薩藍藐藉薰薺薹薦蟯蟬蟲蟠覆覲觴謨謹謬謫豐贅蹙蹣蹦蹤蹟蹕軀轉轍邇邃邈醫醬釐鎔鎊鎖鎢鎳鎮鎬鎰鎘鎚鎗闔闖闐闕離雜雙雛雞霤鞣鞦"],["c340","鞭韹額顏題顎顓颺餾餿餽餮馥騎髁鬃鬆魏魎魍鯊鯉鯽鯈鯀鵑鵝鵠黠鼕鼬儳嚥壞壟壢寵龐廬懲懷懶懵攀攏曠曝櫥櫝櫚櫓瀛瀟瀨瀚瀝瀕瀘爆爍牘犢獸"],["c3a1","獺璽瓊瓣疇疆癟癡矇礙禱穫穩簾簿簸簽簷籀繫繭繹繩繪羅繳羶羹羸臘藩藝藪藕藤藥藷蟻蠅蠍蟹蟾襠襟襖襞譁譜識證譚譎譏譆譙贈贊蹼蹲躇蹶蹬蹺蹴轔轎辭邊邋醱醮鏡鏑鏟鏃鏈鏜鏝鏖鏢鏍鏘鏤鏗鏨關隴難霪霧靡韜韻類"],["c440","願顛颼饅饉騖騙鬍鯨鯧鯖鯛鶉鵡鵲鵪鵬麒麗麓麴勸嚨嚷嚶嚴嚼壤孀孃孽寶巉懸懺攘攔攙曦朧櫬瀾瀰瀲爐獻瓏癢癥礦礪礬礫竇競籌籃籍糯糰辮繽繼"],["c4a1","纂罌耀臚艦藻藹蘑藺蘆蘋蘇蘊蠔蠕襤覺觸議譬警譯譟譫贏贍躉躁躅躂醴釋鐘鐃鏽闡霰飄饒饑馨騫騰騷騵鰓鰍鹹麵黨鼯齟齣齡儷儸囁囀囂夔屬巍懼懾攝攜斕曩櫻欄櫺殲灌爛犧瓖瓔癩矓籐纏續羼蘗蘭蘚蠣蠢蠡蠟襪襬覽譴"],["c540","護譽贓躊躍躋轟辯醺鐮鐳鐵鐺鐸鐲鐫闢霸霹露響顧顥饗驅驃驀騾髏魔魑鰭鰥鶯鶴鷂鶸麝黯鼙齜齦齧儼儻囈囊囉孿巔巒彎懿攤權歡灑灘玀瓤疊癮癬"],["c5a1","禳籠籟聾聽臟襲襯觼讀贖贗躑躓轡酈鑄鑑鑒霽霾韃韁顫饕驕驍髒鬚鱉鰱鰾鰻鷓鷗鼴齬齪龔囌巖戀攣攫攪曬欐瓚竊籤籣籥纓纖纔臢蘸蘿蠱變邐邏鑣鑠鑤靨顯饜驚驛驗髓體髑鱔鱗鱖鷥麟黴囑壩攬灞癱癲矗罐羈蠶蠹衢讓讒"],["c640","讖艷贛釀鑪靂靈靄韆顰驟鬢魘鱟鷹鷺鹼鹽鼇齷齲廳欖灣籬籮蠻觀躡釁鑲鑰顱饞髖鬣黌灤矚讚鑷韉驢驥纜讜躪釅鑽鑾鑼鱷鱸黷豔鑿鸚爨驪鬱鸛鸞籲"],["c940","乂乜凵匚厂万丌乇亍囗兀屮彳丏冇与丮亓仂仉仈冘勼卬厹圠夃夬尐巿旡殳毌气爿丱丼仨仜仩仡仝仚刌匜卌圢圣夗夯宁宄尒尻屴屳帄庀庂忉戉扐氕"],["c9a1","氶汃氿氻犮犰玊禸肊阞伎优伬仵伔仱伀价伈伝伂伅伢伓伄仴伒冱刓刉刐劦匢匟卍厊吇囡囟圮圪圴夼妀奼妅奻奾奷奿孖尕尥屼屺屻屾巟幵庄异弚彴忕忔忏扜扞扤扡扦扢扙扠扚扥旯旮朾朹朸朻机朿朼朳氘汆汒汜汏汊汔汋"],["ca40","汌灱牞犴犵玎甪癿穵网艸艼芀艽艿虍襾邙邗邘邛邔阢阤阠阣佖伻佢佉体佤伾佧佒佟佁佘伭伳伿佡冏冹刜刞刡劭劮匉卣卲厎厏吰吷吪呔呅吙吜吥吘"],["caa1","吽呏呁吨吤呇囮囧囥坁坅坌坉坋坒夆奀妦妘妠妗妎妢妐妏妧妡宎宒尨尪岍岏岈岋岉岒岊岆岓岕巠帊帎庋庉庌庈庍弅弝彸彶忒忑忐忭忨忮忳忡忤忣忺忯忷忻怀忴戺抃抌抎抏抔抇扱扻扺扰抁抈扷扽扲扴攷旰旴旳旲旵杅杇"],["cb40","杙杕杌杈杝杍杚杋毐氙氚汸汧汫沄沋沏汱汯汩沚汭沇沕沜汦汳汥汻沎灴灺牣犿犽狃狆狁犺狅玕玗玓玔玒町甹疔疕皁礽耴肕肙肐肒肜芐芏芅芎芑芓"],["cba1","芊芃芄豸迉辿邟邡邥邞邧邠阰阨阯阭丳侘佼侅佽侀侇佶佴侉侄佷佌侗佪侚佹侁佸侐侜侔侞侒侂侕佫佮冞冼冾刵刲刳剆刱劼匊匋匼厒厔咇呿咁咑咂咈呫呺呾呥呬呴呦咍呯呡呠咘呣呧呤囷囹坯坲坭坫坱坰坶垀坵坻坳坴坢"],["cc40","坨坽夌奅妵妺姏姎妲姌姁妶妼姃姖妱妽姀姈妴姇孢孥宓宕屄屇岮岤岠岵岯岨岬岟岣岭岢岪岧岝岥岶岰岦帗帔帙弨弢弣弤彔徂彾彽忞忥怭怦怙怲怋"],["cca1","怴怊怗怳怚怞怬怢怍怐怮怓怑怌怉怜戔戽抭抴拑抾抪抶拊抮抳抯抻抩抰抸攽斨斻昉旼昄昒昈旻昃昋昍昅旽昑昐曶朊枅杬枎枒杶杻枘枆构杴枍枌杺枟枑枙枃杽极杸杹枔欥殀歾毞氝沓泬泫泮泙沶泔沭泧沷泐泂沺泃泆泭泲"],["cd40","泒泝沴沊沝沀泞泀洰泍泇沰泹泏泩泑炔炘炅炓炆炄炑炖炂炚炃牪狖狋狘狉狜狒狔狚狌狑玤玡玭玦玢玠玬玝瓝瓨甿畀甾疌疘皯盳盱盰盵矸矼矹矻矺"],["cda1","矷祂礿秅穸穻竻籵糽耵肏肮肣肸肵肭舠芠苀芫芚芘芛芵芧芮芼芞芺芴芨芡芩苂芤苃芶芢虰虯虭虮豖迒迋迓迍迖迕迗邲邴邯邳邰阹阽阼阺陃俍俅俓侲俉俋俁俔俜俙侻侳俛俇俖侺俀侹俬剄剉勀勂匽卼厗厖厙厘咺咡咭咥哏"],["ce40","哃茍咷咮哖咶哅哆咠呰咼咢咾呲哞咰垵垞垟垤垌垗垝垛垔垘垏垙垥垚垕壴复奓姡姞姮娀姱姝姺姽姼姶姤姲姷姛姩姳姵姠姾姴姭宨屌峐峘峌峗峋峛"],["cea1","峞峚峉峇峊峖峓峔峏峈峆峎峟峸巹帡帢帣帠帤庰庤庢庛庣庥弇弮彖徆怷怹恔恲恞恅恓恇恉恛恌恀恂恟怤恄恘恦恮扂扃拏挍挋拵挎挃拫拹挏挌拸拶挀挓挔拺挕拻拰敁敃斪斿昶昡昲昵昜昦昢昳昫昺昝昴昹昮朏朐柁柲柈枺"],["cf40","柜枻柸柘柀枷柅柫柤柟枵柍枳柷柶柮柣柂枹柎柧柰枲柼柆柭柌枮柦柛柺柉柊柃柪柋欨殂殄殶毖毘毠氠氡洨洴洭洟洼洿洒洊泚洳洄洙洺洚洑洀洝浂"],["cfa1","洁洘洷洃洏浀洇洠洬洈洢洉洐炷炟炾炱炰炡炴炵炩牁牉牊牬牰牳牮狊狤狨狫狟狪狦狣玅珌珂珈珅玹玶玵玴珫玿珇玾珃珆玸珋瓬瓮甮畇畈疧疪癹盄眈眃眄眅眊盷盻盺矧矨砆砑砒砅砐砏砎砉砃砓祊祌祋祅祄秕种秏秖秎窀"],["d040","穾竑笀笁籺籸籹籿粀粁紃紈紁罘羑羍羾耇耎耏耔耷胘胇胠胑胈胂胐胅胣胙胜胊胕胉胏胗胦胍臿舡芔苙苾苹茇苨茀苕茺苫苖苴苬苡苲苵茌苻苶苰苪"],["d0a1","苤苠苺苳苭虷虴虼虳衁衎衧衪衩觓訄訇赲迣迡迮迠郱邽邿郕郅邾郇郋郈釔釓陔陏陑陓陊陎倞倅倇倓倢倰倛俵俴倳倷倬俶俷倗倜倠倧倵倯倱倎党冔冓凊凄凅凈凎剡剚剒剞剟剕剢勍匎厞唦哢唗唒哧哳哤唚哿唄唈哫唑唅哱"],["d140","唊哻哷哸哠唎唃唋圁圂埌堲埕埒垺埆垽垼垸垶垿埇埐垹埁夎奊娙娖娭娮娕娏娗娊娞娳孬宧宭宬尃屖屔峬峿峮峱峷崀峹帩帨庨庮庪庬弳弰彧恝恚恧"],["d1a1","恁悢悈悀悒悁悝悃悕悛悗悇悜悎戙扆拲挐捖挬捄捅挶捃揤挹捋捊挼挩捁挴捘捔捙挭捇挳捚捑挸捗捀捈敊敆旆旃旄旂晊晟晇晑朒朓栟栚桉栲栳栻桋桏栖栱栜栵栫栭栯桎桄栴栝栒栔栦栨栮桍栺栥栠欬欯欭欱欴歭肂殈毦毤"],["d240","毨毣毢毧氥浺浣浤浶洍浡涒浘浢浭浯涑涍淯浿涆浞浧浠涗浰浼浟涂涘洯浨涋浾涀涄洖涃浻浽浵涐烜烓烑烝烋缹烢烗烒烞烠烔烍烅烆烇烚烎烡牂牸"],["d2a1","牷牶猀狺狴狾狶狳狻猁珓珙珥珖玼珧珣珩珜珒珛珔珝珚珗珘珨瓞瓟瓴瓵甡畛畟疰痁疻痄痀疿疶疺皊盉眝眛眐眓眒眣眑眕眙眚眢眧砣砬砢砵砯砨砮砫砡砩砳砪砱祔祛祏祜祓祒祑秫秬秠秮秭秪秜秞秝窆窉窅窋窌窊窇竘笐"],["d340","笄笓笅笏笈笊笎笉笒粄粑粊粌粈粍粅紞紝紑紎紘紖紓紟紒紏紌罜罡罞罠罝罛羖羒翃翂翀耖耾耹胺胲胹胵脁胻脀舁舯舥茳茭荄茙荑茥荖茿荁茦茜茢"],["d3a1","荂荎茛茪茈茼荍茖茤茠茷茯茩荇荅荌荓茞茬荋茧荈虓虒蚢蚨蚖蚍蚑蚞蚇蚗蚆蚋蚚蚅蚥蚙蚡蚧蚕蚘蚎蚝蚐蚔衃衄衭衵衶衲袀衱衿衯袃衾衴衼訒豇豗豻貤貣赶赸趵趷趶軑軓迾迵适迿迻逄迼迶郖郠郙郚郣郟郥郘郛郗郜郤酐"],["d440","酎酏釕釢釚陜陟隼飣髟鬯乿偰偪偡偞偠偓偋偝偲偈偍偁偛偊偢倕偅偟偩偫偣偤偆偀偮偳偗偑凐剫剭剬剮勖勓匭厜啵啶唼啍啐唴唪啑啢唶唵唰啒啅"],["d4a1","唌唲啥啎唹啈唭唻啀啋圊圇埻堔埢埶埜埴堀埭埽堈埸堋埳埏堇埮埣埲埥埬埡堎埼堐埧堁堌埱埩埰堍堄奜婠婘婕婧婞娸娵婭婐婟婥婬婓婤婗婃婝婒婄婛婈媎娾婍娹婌婰婩婇婑婖婂婜孲孮寁寀屙崞崋崝崚崠崌崨崍崦崥崏"],["d540","崰崒崣崟崮帾帴庱庴庹庲庳弶弸徛徖徟悊悐悆悾悰悺惓惔惏惤惙惝惈悱惛悷惊悿惃惍惀挲捥掊掂捽掽掞掭掝掗掫掎捯掇掐据掯捵掜捭掮捼掤挻掟"],["d5a1","捸掅掁掑掍捰敓旍晥晡晛晙晜晢朘桹梇梐梜桭桮梮梫楖桯梣梬梩桵桴梲梏桷梒桼桫桲梪梀桱桾梛梖梋梠梉梤桸桻梑梌梊桽欶欳欷欸殑殏殍殎殌氪淀涫涴涳湴涬淩淢涷淶淔渀淈淠淟淖涾淥淜淝淛淴淊涽淭淰涺淕淂淏淉"],["d640","淐淲淓淽淗淍淣涻烺焍烷焗烴焌烰焄烳焐烼烿焆焓焀烸烶焋焂焎牾牻牼牿猝猗猇猑猘猊猈狿猏猞玈珶珸珵琄琁珽琇琀珺珼珿琌琋珴琈畤畣痎痒痏"],["d6a1","痋痌痑痐皏皉盓眹眯眭眱眲眴眳眽眥眻眵硈硒硉硍硊硌砦硅硐祤祧祩祪祣祫祡离秺秸秶秷窏窔窐笵筇笴笥笰笢笤笳笘笪笝笱笫笭笯笲笸笚笣粔粘粖粣紵紽紸紶紺絅紬紩絁絇紾紿絊紻紨罣羕羜羝羛翊翋翍翐翑翇翏翉耟"],["d740","耞耛聇聃聈脘脥脙脛脭脟脬脞脡脕脧脝脢舑舸舳舺舴舲艴莐莣莨莍荺荳莤荴莏莁莕莙荵莔莩荽莃莌莝莛莪莋荾莥莯莈莗莰荿莦莇莮荶莚虙虖蚿蚷"],["d7a1","蛂蛁蛅蚺蚰蛈蚹蚳蚸蛌蚴蚻蚼蛃蚽蚾衒袉袕袨袢袪袚袑袡袟袘袧袙袛袗袤袬袌袓袎覂觖觙觕訰訧訬訞谹谻豜豝豽貥赽赻赹趼跂趹趿跁軘軞軝軜軗軠軡逤逋逑逜逌逡郯郪郰郴郲郳郔郫郬郩酖酘酚酓酕釬釴釱釳釸釤釹釪"],["d840","釫釷釨釮镺閆閈陼陭陫陱陯隿靪頄飥馗傛傕傔傞傋傣傃傌傎傝偨傜傒傂傇兟凔匒匑厤厧喑喨喥喭啷噅喢喓喈喏喵喁喣喒喤啽喌喦啿喕喡喎圌堩堷"],["d8a1","堙堞堧堣堨埵塈堥堜堛堳堿堶堮堹堸堭堬堻奡媯媔媟婺媢媞婸媦婼媥媬媕媮娷媄媊媗媃媋媩婻婽媌媜媏媓媝寪寍寋寔寑寊寎尌尰崷嵃嵫嵁嵋崿崵嵑嵎嵕崳崺嵒崽崱嵙嵂崹嵉崸崼崲崶嵀嵅幄幁彘徦徥徫惉悹惌惢惎惄愔"],["d940","惲愊愖愅惵愓惸惼惾惁愃愘愝愐惿愄愋扊掔掱掰揎揥揨揯揃撝揳揊揠揶揕揲揵摡揟掾揝揜揄揘揓揂揇揌揋揈揰揗揙攲敧敪敤敜敨敥斌斝斞斮旐旒"],["d9a1","晼晬晻暀晱晹晪晲朁椌棓椄棜椪棬棪棱椏棖棷棫棤棶椓椐棳棡椇棌椈楰梴椑棯棆椔棸棐棽棼棨椋椊椗棎棈棝棞棦棴棑椆棔棩椕椥棇欹欻欿欼殔殗殙殕殽毰毲毳氰淼湆湇渟湉溈渼渽湅湢渫渿湁湝湳渜渳湋湀湑渻渃渮湞"],["da40","湨湜湡渱渨湠湱湫渹渢渰湓湥渧湸湤湷湕湹湒湦渵渶湚焠焞焯烻焮焱焣焥焢焲焟焨焺焛牋牚犈犉犆犅犋猒猋猰猢猱猳猧猲猭猦猣猵猌琮琬琰琫琖"],["daa1","琚琡琭琱琤琣琝琩琠琲瓻甯畯畬痧痚痡痦痝痟痤痗皕皒盚睆睇睄睍睅睊睎睋睌矞矬硠硤硥硜硭硱硪确硰硩硨硞硢祴祳祲祰稂稊稃稌稄窙竦竤筊笻筄筈筌筎筀筘筅粢粞粨粡絘絯絣絓絖絧絪絏絭絜絫絒絔絩絑絟絎缾缿罥"],["db40","罦羢羠羡翗聑聏聐胾胔腃腊腒腏腇脽腍脺臦臮臷臸臹舄舼舽舿艵茻菏菹萣菀菨萒菧菤菼菶萐菆菈菫菣莿萁菝菥菘菿菡菋菎菖菵菉萉萏菞萑萆菂菳"],["dba1","菕菺菇菑菪萓菃菬菮菄菻菗菢萛菛菾蛘蛢蛦蛓蛣蛚蛪蛝蛫蛜蛬蛩蛗蛨蛑衈衖衕袺裗袹袸裀袾袶袼袷袽袲褁裉覕覘覗觝觚觛詎詍訹詙詀詗詘詄詅詒詈詑詊詌詏豟貁貀貺貾貰貹貵趄趀趉跘跓跍跇跖跜跏跕跙跈跗跅軯軷軺"],["dc40","軹軦軮軥軵軧軨軶軫軱軬軴軩逭逴逯鄆鄬鄄郿郼鄈郹郻鄁鄀鄇鄅鄃酡酤酟酢酠鈁鈊鈥鈃鈚鈦鈏鈌鈀鈒釿釽鈆鈄鈧鈂鈜鈤鈙鈗鈅鈖镻閍閌閐隇陾隈"],["dca1","隉隃隀雂雈雃雱雰靬靰靮頇颩飫鳦黹亃亄亶傽傿僆傮僄僊傴僈僂傰僁傺傱僋僉傶傸凗剺剸剻剼嗃嗛嗌嗐嗋嗊嗝嗀嗔嗄嗩喿嗒喍嗏嗕嗢嗖嗈嗲嗍嗙嗂圔塓塨塤塏塍塉塯塕塎塝塙塥塛堽塣塱壼嫇嫄嫋媺媸媱媵媰媿嫈媻嫆"],["dd40","媷嫀嫊媴媶嫍媹媐寖寘寙尟尳嵱嵣嵊嵥嵲嵬嵞嵨嵧嵢巰幏幎幊幍幋廅廌廆廋廇彀徯徭惷慉慊愫慅愶愲愮慆愯慏愩慀戠酨戣戥戤揅揱揫搐搒搉搠搤"],["dda1","搳摃搟搕搘搹搷搢搣搌搦搰搨摁搵搯搊搚摀搥搧搋揧搛搮搡搎敯斒旓暆暌暕暐暋暊暙暔晸朠楦楟椸楎楢楱椿楅楪椹楂楗楙楺楈楉椵楬椳椽楥棰楸椴楩楀楯楄楶楘楁楴楌椻楋椷楜楏楑椲楒椯楻椼歆歅歃歂歈歁殛嗀毻毼"],["de40","毹毷毸溛滖滈溏滀溟溓溔溠溱溹滆滒溽滁溞滉溷溰滍溦滏溲溾滃滜滘溙溒溎溍溤溡溿溳滐滊溗溮溣煇煔煒煣煠煁煝煢煲煸煪煡煂煘煃煋煰煟煐煓"],["dea1","煄煍煚牏犍犌犑犐犎猼獂猻猺獀獊獉瑄瑊瑋瑒瑑瑗瑀瑏瑐瑎瑂瑆瑍瑔瓡瓿瓾瓽甝畹畷榃痯瘏瘃痷痾痼痹痸瘐痻痶痭痵痽皙皵盝睕睟睠睒睖睚睩睧睔睙睭矠碇碚碔碏碄碕碅碆碡碃硹碙碀碖硻祼禂祽祹稑稘稙稒稗稕稢稓"],["df40","稛稐窣窢窞竫筦筤筭筴筩筲筥筳筱筰筡筸筶筣粲粴粯綈綆綀綍絿綅絺綎絻綃絼綌綔綄絽綒罭罫罧罨罬羦羥羧翛翜耡腤腠腷腜腩腛腢腲朡腞腶腧腯"],["dfa1","腄腡舝艉艄艀艂艅蓱萿葖葶葹蒏蒍葥葑葀蒆葧萰葍葽葚葙葴葳葝蔇葞萷萺萴葺葃葸萲葅萩菙葋萯葂萭葟葰萹葎葌葒葯蓅蒎萻葇萶萳葨葾葄萫葠葔葮葐蜋蜄蛷蜌蛺蛖蛵蝍蛸蜎蜉蜁蛶蜍蜅裖裋裍裎裞裛裚裌裐覅覛觟觥觤"],["e040","觡觠觢觜触詶誆詿詡訿詷誂誄詵誃誁詴詺谼豋豊豥豤豦貆貄貅賌赨赩趑趌趎趏趍趓趔趐趒跰跠跬跱跮跐跩跣跢跧跲跫跴輆軿輁輀輅輇輈輂輋遒逿"],["e0a1","遄遉逽鄐鄍鄏鄑鄖鄔鄋鄎酮酯鉈鉒鈰鈺鉦鈳鉥鉞銃鈮鉊鉆鉭鉬鉏鉠鉧鉯鈶鉡鉰鈱鉔鉣鉐鉲鉎鉓鉌鉖鈲閟閜閞閛隒隓隑隗雎雺雽雸雵靳靷靸靲頏頍頎颬飶飹馯馲馰馵骭骫魛鳪鳭鳧麀黽僦僔僗僨僳僛僪僝僤僓僬僰僯僣僠"],["e140","凘劀劁勩勫匰厬嘧嘕嘌嘒嗼嘏嘜嘁嘓嘂嗺嘝嘄嗿嗹墉塼墐墘墆墁塿塴墋塺墇墑墎塶墂墈塻墔墏壾奫嫜嫮嫥嫕嫪嫚嫭嫫嫳嫢嫠嫛嫬嫞嫝嫙嫨嫟孷寠"],["e1a1","寣屣嶂嶀嵽嶆嵺嶁嵷嶊嶉嶈嵾嵼嶍嵹嵿幘幙幓廘廑廗廎廜廕廙廒廔彄彃彯徶愬愨慁慞慱慳慒慓慲慬憀慴慔慺慛慥愻慪慡慖戩戧戫搫摍摛摝摴摶摲摳摽摵摦撦摎撂摞摜摋摓摠摐摿搿摬摫摙摥摷敳斠暡暠暟朅朄朢榱榶槉"],["e240","榠槎榖榰榬榼榑榙榎榧榍榩榾榯榿槄榽榤槔榹槊榚槏榳榓榪榡榞槙榗榐槂榵榥槆歊歍歋殞殟殠毃毄毾滎滵滱漃漥滸漷滻漮漉潎漙漚漧漘漻漒滭漊"],["e2a1","漶潳滹滮漭潀漰漼漵滫漇漎潃漅滽滶漹漜滼漺漟漍漞漈漡熇熐熉熀熅熂熏煻熆熁熗牄牓犗犕犓獃獍獑獌瑢瑳瑱瑵瑲瑧瑮甀甂甃畽疐瘖瘈瘌瘕瘑瘊瘔皸瞁睼瞅瞂睮瞀睯睾瞃碲碪碴碭碨硾碫碞碥碠碬碢碤禘禊禋禖禕禔禓"],["e340","禗禈禒禐稫穊稰稯稨稦窨窫窬竮箈箜箊箑箐箖箍箌箛箎箅箘劄箙箤箂粻粿粼粺綧綷緂綣綪緁緀緅綝緎緄緆緋緌綯綹綖綼綟綦綮綩綡緉罳翢翣翥翞"],["e3a1","耤聝聜膉膆膃膇膍膌膋舕蒗蒤蒡蒟蒺蓎蓂蒬蒮蒫蒹蒴蓁蓍蒪蒚蒱蓐蒝蒧蒻蒢蒔蓇蓌蒛蒩蒯蒨蓖蒘蒶蓏蒠蓗蓔蓒蓛蒰蒑虡蜳蜣蜨蝫蝀蜮蜞蜡蜙蜛蝃蜬蝁蜾蝆蜠蜲蜪蜭蜼蜒蜺蜱蜵蝂蜦蜧蜸蜤蜚蜰蜑裷裧裱裲裺裾裮裼裶裻"],["e440","裰裬裫覝覡覟覞觩觫觨誫誙誋誒誏誖谽豨豩賕賏賗趖踉踂跿踍跽踊踃踇踆踅跾踀踄輐輑輎輍鄣鄜鄠鄢鄟鄝鄚鄤鄡鄛酺酲酹酳銥銤鉶銛鉺銠銔銪銍"],["e4a1","銦銚銫鉹銗鉿銣鋮銎銂銕銢鉽銈銡銊銆銌銙銧鉾銇銩銝銋鈭隞隡雿靘靽靺靾鞃鞀鞂靻鞄鞁靿韎韍頖颭颮餂餀餇馝馜駃馹馻馺駂馽駇骱髣髧鬾鬿魠魡魟鳱鳲鳵麧僿儃儰僸儆儇僶僾儋儌僽儊劋劌勱勯噈噂噌嘵噁噊噉噆噘"],["e540","噚噀嘳嘽嘬嘾嘸嘪嘺圚墫墝墱墠墣墯墬墥墡壿嫿嫴嫽嫷嫶嬃嫸嬂嫹嬁嬇嬅嬏屧嶙嶗嶟嶒嶢嶓嶕嶠嶜嶡嶚嶞幩幝幠幜緳廛廞廡彉徲憋憃慹憱憰憢憉"],["e5a1","憛憓憯憭憟憒憪憡憍慦憳戭摮摰撖撠撅撗撜撏撋撊撌撣撟摨撱撘敶敺敹敻斲斳暵暰暩暲暷暪暯樀樆樗槥槸樕槱槤樠槿槬槢樛樝槾樧槲槮樔槷槧橀樈槦槻樍槼槫樉樄樘樥樏槶樦樇槴樖歑殥殣殢殦氁氀毿氂潁漦潾澇濆澒"],["e640","澍澉澌潢潏澅潚澖潶潬澂潕潲潒潐潗澔澓潝漀潡潫潽潧澐潓澋潩潿澕潣潷潪潻熲熯熛熰熠熚熩熵熝熥熞熤熡熪熜熧熳犘犚獘獒獞獟獠獝獛獡獚獙"],["e6a1","獢璇璉璊璆璁瑽璅璈瑼瑹甈甇畾瘥瘞瘙瘝瘜瘣瘚瘨瘛皜皝皞皛瞍瞏瞉瞈磍碻磏磌磑磎磔磈磃磄磉禚禡禠禜禢禛歶稹窲窴窳箷篋箾箬篎箯箹篊箵糅糈糌糋緷緛緪緧緗緡縃緺緦緶緱緰緮緟罶羬羰羭翭翫翪翬翦翨聤聧膣膟"],["e740","膞膕膢膙膗舖艏艓艒艐艎艑蔤蔻蔏蔀蔩蔎蔉蔍蔟蔊蔧蔜蓻蔫蓺蔈蔌蓴蔪蓲蔕蓷蓫蓳蓼蔒蓪蓩蔖蓾蔨蔝蔮蔂蓽蔞蓶蔱蔦蓧蓨蓰蓯蓹蔘蔠蔰蔋蔙蔯虢"],["e7a1","蝖蝣蝤蝷蟡蝳蝘蝔蝛蝒蝡蝚蝑蝞蝭蝪蝐蝎蝟蝝蝯蝬蝺蝮蝜蝥蝏蝻蝵蝢蝧蝩衚褅褌褔褋褗褘褙褆褖褑褎褉覢覤覣觭觰觬諏諆誸諓諑諔諕誻諗誾諀諅諘諃誺誽諙谾豍貏賥賟賙賨賚賝賧趠趜趡趛踠踣踥踤踮踕踛踖踑踙踦踧"],["e840","踔踒踘踓踜踗踚輬輤輘輚輠輣輖輗遳遰遯遧遫鄯鄫鄩鄪鄲鄦鄮醅醆醊醁醂醄醀鋐鋃鋄鋀鋙銶鋏鋱鋟鋘鋩鋗鋝鋌鋯鋂鋨鋊鋈鋎鋦鋍鋕鋉鋠鋞鋧鋑鋓"],["e8a1","銵鋡鋆銴镼閬閫閮閰隤隢雓霅霈霂靚鞊鞎鞈韐韏頞頝頦頩頨頠頛頧颲餈飺餑餔餖餗餕駜駍駏駓駔駎駉駖駘駋駗駌骳髬髫髳髲髱魆魃魧魴魱魦魶魵魰魨魤魬鳼鳺鳽鳿鳷鴇鴀鳹鳻鴈鴅鴄麃黓鼏鼐儜儓儗儚儑凞匴叡噰噠噮"],["e940","噳噦噣噭噲噞噷圜圛壈墽壉墿墺壂墼壆嬗嬙嬛嬡嬔嬓嬐嬖嬨嬚嬠嬞寯嶬嶱嶩嶧嶵嶰嶮嶪嶨嶲嶭嶯嶴幧幨幦幯廩廧廦廨廥彋徼憝憨憖懅憴懆懁懌憺"],["e9a1","憿憸憌擗擖擐擏擉撽撉擃擛擳擙攳敿敼斢曈暾曀曊曋曏暽暻暺曌朣樴橦橉橧樲橨樾橝橭橶橛橑樨橚樻樿橁橪橤橐橏橔橯橩橠樼橞橖橕橍橎橆歕歔歖殧殪殫毈毇氄氃氆澭濋澣濇澼濎濈潞濄澽澞濊澨瀄澥澮澺澬澪濏澿澸"],["ea40","澢濉澫濍澯澲澰燅燂熿熸燖燀燁燋燔燊燇燏熽燘熼燆燚燛犝犞獩獦獧獬獥獫獪瑿璚璠璔璒璕璡甋疀瘯瘭瘱瘽瘳瘼瘵瘲瘰皻盦瞚瞝瞡瞜瞛瞢瞣瞕瞙"],["eaa1","瞗磝磩磥磪磞磣磛磡磢磭磟磠禤穄穈穇窶窸窵窱窷篞篣篧篝篕篥篚篨篹篔篪篢篜篫篘篟糒糔糗糐糑縒縡縗縌縟縠縓縎縜縕縚縢縋縏縖縍縔縥縤罃罻罼罺羱翯耪耩聬膱膦膮膹膵膫膰膬膴膲膷膧臲艕艖艗蕖蕅蕫蕍蕓蕡蕘"],["eb40","蕀蕆蕤蕁蕢蕄蕑蕇蕣蔾蕛蕱蕎蕮蕵蕕蕧蕠薌蕦蕝蕔蕥蕬虣虥虤螛螏螗螓螒螈螁螖螘蝹螇螣螅螐螑螝螄螔螜螚螉褞褦褰褭褮褧褱褢褩褣褯褬褟觱諠"],["eba1","諢諲諴諵諝謔諤諟諰諈諞諡諨諿諯諻貑貒貐賵賮賱賰賳赬赮趥趧踳踾踸蹀蹅踶踼踽蹁踰踿躽輶輮輵輲輹輷輴遶遹遻邆郺鄳鄵鄶醓醐醑醍醏錧錞錈錟錆錏鍺錸錼錛錣錒錁鍆錭錎錍鋋錝鋺錥錓鋹鋷錴錂錤鋿錩錹錵錪錔錌"],["ec40","錋鋾錉錀鋻錖閼闍閾閹閺閶閿閵閽隩雔霋霒霐鞙鞗鞔韰韸頵頯頲餤餟餧餩馞駮駬駥駤駰駣駪駩駧骹骿骴骻髶髺髹髷鬳鮀鮅鮇魼魾魻鮂鮓鮒鮐魺鮕"],["eca1","魽鮈鴥鴗鴠鴞鴔鴩鴝鴘鴢鴐鴙鴟麈麆麇麮麭黕黖黺鼒鼽儦儥儢儤儠儩勴嚓嚌嚍嚆嚄嚃噾嚂噿嚁壖壔壏壒嬭嬥嬲嬣嬬嬧嬦嬯嬮孻寱寲嶷幬幪徾徻懃憵憼懧懠懥懤懨懞擯擩擣擫擤擨斁斀斶旚曒檍檖檁檥檉檟檛檡檞檇檓檎"],["ed40","檕檃檨檤檑橿檦檚檅檌檒歛殭氉濌澩濴濔濣濜濭濧濦濞濲濝濢濨燡燱燨燲燤燰燢獳獮獯璗璲璫璐璪璭璱璥璯甐甑甒甏疄癃癈癉癇皤盩瞵瞫瞲瞷瞶"],["eda1","瞴瞱瞨矰磳磽礂磻磼磲礅磹磾礄禫禨穜穛穖穘穔穚窾竀竁簅簏篲簀篿篻簎篴簋篳簂簉簃簁篸篽簆篰篱簐簊糨縭縼繂縳顈縸縪繉繀繇縩繌縰縻縶繄縺罅罿罾罽翴翲耬膻臄臌臊臅臇膼臩艛艚艜薃薀薏薧薕薠薋薣蕻薤薚薞"],["ee40","蕷蕼薉薡蕺蕸蕗薎薖薆薍薙薝薁薢薂薈薅蕹蕶薘薐薟虨螾螪螭蟅螰螬螹螵螼螮蟉蟃蟂蟌螷螯蟄蟊螴螶螿螸螽蟞螲褵褳褼褾襁襒褷襂覭覯覮觲觳謞"],["eea1","謘謖謑謅謋謢謏謒謕謇謍謈謆謜謓謚豏豰豲豱豯貕貔賹赯蹎蹍蹓蹐蹌蹇轃轀邅遾鄸醚醢醛醙醟醡醝醠鎡鎃鎯鍤鍖鍇鍼鍘鍜鍶鍉鍐鍑鍠鍭鎏鍌鍪鍹鍗鍕鍒鍏鍱鍷鍻鍡鍞鍣鍧鎀鍎鍙闇闀闉闃闅閷隮隰隬霠霟霘霝霙鞚鞡鞜"],["ef40","鞞鞝韕韔韱顁顄顊顉顅顃餥餫餬餪餳餲餯餭餱餰馘馣馡騂駺駴駷駹駸駶駻駽駾駼騃骾髾髽鬁髼魈鮚鮨鮞鮛鮦鮡鮥鮤鮆鮢鮠鮯鴳鵁鵧鴶鴮鴯鴱鴸鴰"],["efa1","鵅鵂鵃鴾鴷鵀鴽翵鴭麊麉麍麰黈黚黻黿鼤鼣鼢齔龠儱儭儮嚘嚜嚗嚚嚝嚙奰嬼屩屪巀幭幮懘懟懭懮懱懪懰懫懖懩擿攄擽擸攁攃擼斔旛曚曛曘櫅檹檽櫡櫆檺檶檷櫇檴檭歞毉氋瀇瀌瀍瀁瀅瀔瀎濿瀀濻瀦濼濷瀊爁燿燹爃燽獶"],["f040","璸瓀璵瓁璾璶璻瓂甔甓癜癤癙癐癓癗癚皦皽盬矂瞺磿礌礓礔礉礐礒礑禭禬穟簜簩簙簠簟簭簝簦簨簢簥簰繜繐繖繣繘繢繟繑繠繗繓羵羳翷翸聵臑臒"],["f0a1","臐艟艞薴藆藀藃藂薳薵薽藇藄薿藋藎藈藅薱薶藒蘤薸薷薾虩蟧蟦蟢蟛蟫蟪蟥蟟蟳蟤蟔蟜蟓蟭蟘蟣螤蟗蟙蠁蟴蟨蟝襓襋襏襌襆襐襑襉謪謧謣謳謰謵譇謯謼謾謱謥謷謦謶謮謤謻謽謺豂豵貙貘貗賾贄贂贀蹜蹢蹠蹗蹖蹞蹥蹧"],["f140","蹛蹚蹡蹝蹩蹔轆轇轈轋鄨鄺鄻鄾醨醥醧醯醪鎵鎌鎒鎷鎛鎝鎉鎧鎎鎪鎞鎦鎕鎈鎙鎟鎍鎱鎑鎲鎤鎨鎴鎣鎥闒闓闑隳雗雚巂雟雘雝霣霢霥鞬鞮鞨鞫鞤鞪"],["f1a1","鞢鞥韗韙韖韘韺顐顑顒颸饁餼餺騏騋騉騍騄騑騊騅騇騆髀髜鬈鬄鬅鬩鬵魊魌魋鯇鯆鯃鮿鯁鮵鮸鯓鮶鯄鮹鮽鵜鵓鵏鵊鵛鵋鵙鵖鵌鵗鵒鵔鵟鵘鵚麎麌黟鼁鼀鼖鼥鼫鼪鼩鼨齌齕儴儵劖勷厴嚫嚭嚦嚧嚪嚬壚壝壛夒嬽嬾嬿巃幰"],["f240","徿懻攇攐攍攉攌攎斄旞旝曞櫧櫠櫌櫑櫙櫋櫟櫜櫐櫫櫏櫍櫞歠殰氌瀙瀧瀠瀖瀫瀡瀢瀣瀩瀗瀤瀜瀪爌爊爇爂爅犥犦犤犣犡瓋瓅璷瓃甖癠矉矊矄矱礝礛"],["f2a1","礡礜礗礞禰穧穨簳簼簹簬簻糬糪繶繵繸繰繷繯繺繲繴繨罋罊羃羆羷翽翾聸臗臕艤艡艣藫藱藭藙藡藨藚藗藬藲藸藘藟藣藜藑藰藦藯藞藢蠀蟺蠃蟶蟷蠉蠌蠋蠆蟼蠈蟿蠊蠂襢襚襛襗襡襜襘襝襙覈覷覶觶譐譈譊譀譓譖譔譋譕"],["f340","譑譂譒譗豃豷豶貚贆贇贉趬趪趭趫蹭蹸蹳蹪蹯蹻軂轒轑轏轐轓辴酀鄿醰醭鏞鏇鏏鏂鏚鏐鏹鏬鏌鏙鎩鏦鏊鏔鏮鏣鏕鏄鏎鏀鏒鏧镽闚闛雡霩霫霬霨霦"],["f3a1","鞳鞷鞶韝韞韟顜顙顝顗颿颽颻颾饈饇饃馦馧騚騕騥騝騤騛騢騠騧騣騞騜騔髂鬋鬊鬎鬌鬷鯪鯫鯠鯞鯤鯦鯢鯰鯔鯗鯬鯜鯙鯥鯕鯡鯚鵷鶁鶊鶄鶈鵱鶀鵸鶆鶋鶌鵽鵫鵴鵵鵰鵩鶅鵳鵻鶂鵯鵹鵿鶇鵨麔麑黀黼鼭齀齁齍齖齗齘匷嚲"],["f440","嚵嚳壣孅巆巇廮廯忀忁懹攗攖攕攓旟曨曣曤櫳櫰櫪櫨櫹櫱櫮櫯瀼瀵瀯瀷瀴瀱灂瀸瀿瀺瀹灀瀻瀳灁爓爔犨獽獼璺皫皪皾盭矌矎矏矍矲礥礣礧礨礤礩"],["f4a1","禲穮穬穭竷籉籈籊籇籅糮繻繾纁纀羺翿聹臛臙舋艨艩蘢藿蘁藾蘛蘀藶蘄蘉蘅蘌藽蠙蠐蠑蠗蠓蠖襣襦覹觷譠譪譝譨譣譥譧譭趮躆躈躄轙轖轗轕轘轚邍酃酁醷醵醲醳鐋鐓鏻鐠鐏鐔鏾鐕鐐鐨鐙鐍鏵鐀鏷鐇鐎鐖鐒鏺鐉鏸鐊鏿"],["f540","鏼鐌鏶鐑鐆闞闠闟霮霯鞹鞻韽韾顠顢顣顟飁飂饐饎饙饌饋饓騲騴騱騬騪騶騩騮騸騭髇髊髆鬐鬒鬑鰋鰈鯷鰅鰒鯸鱀鰇鰎鰆鰗鰔鰉鶟鶙鶤鶝鶒鶘鶐鶛"],["f5a1","鶠鶔鶜鶪鶗鶡鶚鶢鶨鶞鶣鶿鶩鶖鶦鶧麙麛麚黥黤黧黦鼰鼮齛齠齞齝齙龑儺儹劘劗囃嚽嚾孈孇巋巏廱懽攛欂櫼欃櫸欀灃灄灊灈灉灅灆爝爚爙獾甗癪矐礭礱礯籔籓糲纊纇纈纋纆纍罍羻耰臝蘘蘪蘦蘟蘣蘜蘙蘧蘮蘡蘠蘩蘞蘥"],["f640","蠩蠝蠛蠠蠤蠜蠫衊襭襩襮襫觺譹譸譅譺譻贐贔趯躎躌轞轛轝酆酄酅醹鐿鐻鐶鐩鐽鐼鐰鐹鐪鐷鐬鑀鐱闥闤闣霵霺鞿韡顤飉飆飀饘饖騹騽驆驄驂驁騺"],["f6a1","騿髍鬕鬗鬘鬖鬺魒鰫鰝鰜鰬鰣鰨鰩鰤鰡鶷鶶鶼鷁鷇鷊鷏鶾鷅鷃鶻鶵鷎鶹鶺鶬鷈鶱鶭鷌鶳鷍鶲鹺麜黫黮黭鼛鼘鼚鼱齎齥齤龒亹囆囅囋奱孋孌巕巑廲攡攠攦攢欋欈欉氍灕灖灗灒爞爟犩獿瓘瓕瓙瓗癭皭礵禴穰穱籗籜籙籛籚"],["f740","糴糱纑罏羇臞艫蘴蘵蘳蘬蘲蘶蠬蠨蠦蠪蠥襱覿覾觻譾讄讂讆讅譿贕躕躔躚躒躐躖躗轠轢酇鑌鑐鑊鑋鑏鑇鑅鑈鑉鑆霿韣顪顩飋饔饛驎驓驔驌驏驈驊"],["f7a1","驉驒驐髐鬙鬫鬻魖魕鱆鱈鰿鱄鰹鰳鱁鰼鰷鰴鰲鰽鰶鷛鷒鷞鷚鷋鷐鷜鷑鷟鷩鷙鷘鷖鷵鷕鷝麶黰鼵鼳鼲齂齫龕龢儽劙壨壧奲孍巘蠯彏戁戃戄攩攥斖曫欑欒欏毊灛灚爢玂玁玃癰矔籧籦纕艬蘺虀蘹蘼蘱蘻蘾蠰蠲蠮蠳襶襴襳觾"],["f840","讌讎讋讈豅贙躘轤轣醼鑢鑕鑝鑗鑞韄韅頀驖驙鬞鬟鬠鱒鱘鱐鱊鱍鱋鱕鱙鱌鱎鷻鷷鷯鷣鷫鷸鷤鷶鷡鷮鷦鷲鷰鷢鷬鷴鷳鷨鷭黂黐黲黳鼆鼜鼸鼷鼶齃齏"],["f8a1","齱齰齮齯囓囍孎屭攭曭曮欓灟灡灝灠爣瓛瓥矕礸禷禶籪纗羉艭虃蠸蠷蠵衋讔讕躞躟躠躝醾醽釂鑫鑨鑩雥靆靃靇韇韥驞髕魙鱣鱧鱦鱢鱞鱠鸂鷾鸇鸃鸆鸅鸀鸁鸉鷿鷽鸄麠鼞齆齴齵齶囔攮斸欘欙欗欚灢爦犪矘矙礹籩籫糶纚"],["f940","纘纛纙臠臡虆虇虈襹襺襼襻觿讘讙躥躤躣鑮鑭鑯鑱鑳靉顲饟鱨鱮鱭鸋鸍鸐鸏鸒鸑麡黵鼉齇齸齻齺齹圞灦籯蠼趲躦釃鑴鑸鑶鑵驠鱴鱳鱱鱵鸔鸓黶鼊"],["f9a1","龤灨灥糷虪蠾蠽蠿讞貜躩軉靋顳顴飌饡馫驤驦驧鬤鸕鸗齈戇欞爧虌躨钂钀钁驩驨鬮鸙爩虋讟钃鱹麷癵驫鱺鸝灩灪麤齾齉龘碁銹裏墻恒粧嫺╔╦╗╠╬╣╚╩╝╒╤╕╞╪╡╘╧╛╓╥╖╟╫╢╙╨╜║═╭╮╰╯▓"]]

/***/ }),
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BuyerStatements_vue__ = __webpack_require__(430);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13a0d832_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuyerStatements_vue__ = __webpack_require__(1331);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BuyerStatements_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13a0d832_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuyerStatements_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_pdfmake__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_excelExport__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_xlsx__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_xlsx__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* createNamespacedHelpers */])("Buyer")["mapGetters"];

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "BuyerTransactionStatements",

  mounted: function mounted() {
    this.getCurrentUser();
  },
  created: function created() {
    this.$bindAsArray("invoiceHistory", this.$root.$firebaseRefs.invoiceHistory.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsObject("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray("firmList", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsObject("buyerById", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsObject("sellerById", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray("deposit", this.$root.$firebaseRefs.customerDeposit.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("customerPayments", this.$root.$firebaseRefs.customerPayments.orderByChild('brand').equalTo(this.selectedBrand));
    // let today = new Date()
    // this.toDate = `${today.getFullYear()}-${today.getMonth()+1}-${today.getDate()}`
  },
  data: function data() {
    return {
      invoiceHeader: [{ text: "View Invoice", value: "" }, { text: "Date", value: "date", sortable: true, sort: function sort(a, b) {
          return console.log(a);
        } },
      // { text: "Invoice - Key", value: "Name" },
      // { text: "Firm Name", value: "Village" },
      { text: "Invoice No", value: "Block" }, { text: "Debit", value: "Block" }, { text: "Credit", value: "Block" }, { text: "Running Balance", value: "Block" }, { text: "Payment Type", value: "Identity Number" }, { text: "Vocher type", value: "Vocher type" }],
      dialog: false,
      isUserBuyer: null,
      selectedInvoice: {},
      selectedFirm: null,
      toDate: null,
      fromDate: null,
      datepickerFrom: null,
      datepickerTo: null,
      filteredInvoice: [],
      payments: [],
      customerPayments: [],
      prevRunningBal: 0,
      currentUser: {},
      voucherTypeFilter: [],
      total: {
        credit: 0,
        debit: 0,
        RunningBal: 0
      },
      invoiceProductListHeader: [{ text: "Name", value: "Name" }, { text: "HSN code", value: "HSN" }, { text: "Taxable rate", value: "Taxable" }, { text: "Unit", value: "Unit" }, { text: "Quantity", value: "quantity" }, { text: "Fat", value: "quantity" }, { text: "Rate", value: "rate" }]
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "brandFinYear"]), mapBuyerGetters(["selectedBuyer"]), mapGlobalGetters({
    gState: 'state'
  }), {
    invoiceList: function invoiceList() {
      var _this = this;

      this.total = {
        credit: 0,
        debit: 0,
        RunningBal: 0,
        date: 'Total'
      };
      this.getCurrentUser();

      // let filteredInvoice = this.invoices.filter(
      //   item =>
      //     item["brand"] === this.selectedBrand &&
      //     item["buyerId"] === this.$route.params.customerId
      // );
      this.filteredInvoice = [];
      this.payments = [];
      this.customerDeposit = [];

      var toDate = this.toDate ? new Date(this.toDate).getTime() : null;
      var fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;

      this.filteredInvoice = this.invoiceHistory.filter(function (item) {
        return item["brand"] === _this.selectedBrand && item["buyerId"] === _this.$route.params.customerId && (!!_this.selectedFirm ? item["firm"] === _this.selectedFirm['.key'] : true) && item.deleted != true && (
        // (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true)
        item['returnStatus'] ? item['returnStatus'] == 'remaining' && item['status'] == 'paid' : true) && (item['isLatest'] != undefined ? item['isLatest'] == true : true);
      });
      if (!this.payments.length) {
        this.payments = this.customerPayments.filter(function (item) {
          return item["brand"] === _this.selectedBrand && (!!_this.selectedFirm ? item["firm"] === _this.selectedFirm['.key'] : true) && item["buyerId"] === _this.$route.params.customerId && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item["remainingAmount"]) > 0;
        });
      }

      if (!this.customerDeposit.length) {
        this.customerDeposit = this.deposit.filter(function (item) {
          return item["brand"] === _this.selectedBrand && (!!_this.selectedFirm ? item["firm"] === _this.selectedFirm['.key'] : true) && item["buyerId"] === _this.$route.params.customerId && (item["type"] === "Advance" || item["type"] === "Opening Balance" || item["type"] === "LoanTaken" || item["type"] === "LoanGiven" || item["type"] === "Security");
        });
      }
      this.filteredInvoice.map(function (item, index) {
        //if(item.newlyCreated && (item.status === "paid" || item.status === "partial")) {
        if (item.newlyCreated && (item.status === "paid" || item.status === "partial")) {
          var newItem = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(item));
          newItem.date = newItem.date - 1;
          newItem.transactionType = "Debit";
          newItem.paidAmount = 0;
          newItem.status = 'due';
          newItem.remainingAmount = newItem.totalAmount;
          delete newItem['newlyCreated'];
          newItem['.key'] = new Date().getTime();
          _this.filteredInvoice.push(newItem);
        }
        if (item.closedDate) {
          _this.filteredInvoice[index].date = item.closedDate;
        }
      });

      this.customerDeposit.map(function (deposit, index) {
        _this.filteredInvoice.push(deposit);
        if ((deposit["type"] === "LoanTaken" || deposit["type"] === "LoanGiven") && deposit.status == "paid" && !deposit.loanTransaction) {
          _this.customerDeposit[index].status = 'due';
        }
      });

      this.payments.map(function (pay) {
        pay['type'] = 'CustomerPayment';
        _this.filteredInvoice.push(pay);
      });
      //     this.filteredInvoice = this.customerDeposit.concat(this.filteredInvoice);

      this.filteredInvoice.map(function (item, index) {
        _this.filteredInvoice[index]['voucherType'] = _this.getVocherType(item);
      });
      if (this.voucherTypeFilter.length) {
        this.filteredInvoice = this.filteredInvoice.filter(function (it) {
          return _this.voucherTypeFilter.indexOf(it['voucherType']) > -1;
        });
      }

      this.filteredInvoice.sort(function (a, b) {
        return -(new Date(b.date) - new Date(a.date));
      });

      this.filteredInvoice.map(function (item, index) {
        if (item["items"] && item["items"].length) _this.filteredInvoice[index]["GST_Percentage_total"] = Object(__WEBPACK_IMPORTED_MODULE_5__utils__["c" /* getGSTPercentageTotal */])(item["items"]);else {
          _this.filteredInvoice[index]["GST_Percentage_total"] = {
            GST_3: 0,
            GST_5: 0,
            GST_12: 0,
            GST_18: 0,
            GST_28: 0
          };
        }
        // if(this.filteredInvoice[index]['.key'] == "-M1dKDXv7immzLNuRDZA") {
        //   console.log(JSON.stringify(this.filteredInvoice[index],null,4))
        // }
        _this.filteredInvoice[index]["customer"] = _this.buyerById[item.buyerId] || _this.sellerById[item.buyerId] || {};
        _this.filteredInvoice[index]["debit"] = _this.getDebit(_this.filteredInvoice[index]);
        _this.filteredInvoice[index]["credit"] = _this.getCredit(_this.filteredInvoice[index]);
        if (_this.isUserBuyer) {
          var temp = _this.filteredInvoice[index]["credit"];
          _this.filteredInvoice[index]["credit"] = _this.filteredInvoice[index]["debit"];
          _this.filteredInvoice[index]["debit"] = temp;
        }
        _this.filteredInvoice[index]["RunningBal"] = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(_this.filteredInvoice[index]["debit"] || 0) - __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(_this.filteredInvoice[index]["credit"] || 0) + (index == 0 ? 0 : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(_this.filteredInvoice[index - 1]["RunningBal"]));
        _this.total.debit += __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(_this.filteredInvoice[index]["debit"]);
        _this.total.credit += __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(_this.filteredInvoice[index]["credit"]);
        // this.total.RunningBal += Number.parseFloat(this.filteredInvoice[index]["RunningBal"]);
        _this.total.RunningBal += __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(_this.filteredInvoice[index]["debit"]) - __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(_this.filteredInvoice[index]["credit"]));
      });

      this.prevRunningBal = 0;
      var actualFiltered = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.filteredInvoice.filter(function (item) {
        return (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true);
      })));

      this.filteredInvoice.map(function (inv, index) {
        if (actualFiltered.length && inv['.key'] == actualFiltered[0]['.key'] && index > 0) {
          _this.prevRunningBal = _this.filteredInvoice[index - 1]["RunningBal"];
        }
      });
      this.total = {
        credit: 0,
        debit: 0,
        RunningBal: 0,
        date: 'Total'
      };
      actualFiltered.map(function (invoice, index) {
        _this.total.debit += __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(actualFiltered[index]["debit"]);
        _this.total.credit += __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(actualFiltered[index]["credit"]);
        // this.total.RunningBal += Number.parseFloat(this.filteredInvoice[index]["RunningBal"]);
        _this.total.RunningBal += __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(actualFiltered[index]["debit"]) - __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(actualFiltered[index]["credit"]));
      });
      this.selectedInvoice = actualFiltered[0];
      return actualFiltered;
    },
    firmsByBrand1: function firmsByBrand1() {
      var _this2 = this;

      return this.firmList.filter(function (item) {
        return item["brand"] === _this2.selectedBrand;
      });
    },

    // current brands firm list
    firmsByBrand: function firmsByBrand() {
      var _this3 = this;

      // return selected brand firms
      var firmsB = this.firmList.filter(function (item) {
        return item['brand'] === _this3.selectedBrand;
      });
      firmsB.map(function (item) {
        if (item.defaultFirm) {
          _this3.selectedFirm = item;
        }
      });
      return firmsB;
    }
  }),
  methods: {
    removeMinus: function removeMinus(value) {
      if (value == 0) {
        return 0;
      }
      value = value.toString();
      if (value.charAt(0) == '-') {
        return value.slice(1);
      }
    },
    print: function print() {
      var firm = this.selectedFirm || { name: '-' };
      firm.address = this.selectedFirm ? this.generateAddress(this.selectedFirm) : '-';
      var customer = this.currentUser;
      customer.address = this.generateAddress(customer);
      var invoices = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.invoiceList));
      invoices.push(this.total);
      var doc = Object(__WEBPACK_IMPORTED_MODULE_6__utils_pdfmake__["a" /* buyerStatement */])({
        firm: firm,
        customer: customer,
        // invoices : this.filteredInvoice,
        invoices: invoices,
        toDate: this.toDate ? new Date(this.toDate).getTime() : null,
        fromDate: this.fromDate ? new Date(this.fromDate).getTime() : null
      });
      pdfMake.createPdf(doc).download();
    },
    printDetailed: function printDetailed() {
      var firm = this.selectedFirm || { name: '-' };
      firm.address = this.selectedFirm ? this.generateAddress(this.selectedFirm) : '-';
      var customer = this.currentUser;
      customer.address = this.generateAddress(customer);
      var invoices = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.invoiceList));
      invoices.push(this.total);
      var doc = Object(__WEBPACK_IMPORTED_MODULE_6__utils_pdfmake__["b" /* buyerStatementDetailed */])({
        firm: firm,
        customer: customer,
        // invoices : this.filteredInvoice,
        invoices: invoices,
        toDate: this.toDate ? new Date(this.toDate).getTime() : null,
        fromDate: this.fromDate ? new Date(this.fromDate).getTime() : null
      });
      pdfMake.createPdf(doc).download(this.customer);
    },
    exportXLS: function exportXLS() {
      var firm = this.selectedFirm;
      firm.address = this.generateAddress(firm);
      var wb = Object(__WEBPACK_IMPORTED_MODULE_7__utils_excelExport__["a" /* buyerStatementExcel */])({ selectedFirm: firm, invoices: this.filteredInvoice });
      __WEBPACK_IMPORTED_MODULE_8_xlsx___default.a.writeFile(wb, 'Statements_' + new Date().getTime() + '.xlsx');
      // name of the file is 'book.xlsx'
    },
    generateAddress: function generateAddress(user) {
      var address = "";
      if (user.block) {
        address = "" + user.block;
      }
      if (user.village) {
        address = "" + (address ? address + " - " : "") + user.village;
      }
      if (user.tehsil) {
        address = "" + (address ? address + " - " : "") + user.tehsil;
      }
      if (user.state) {
        address = "" + (address ? address + " - " : "") + user.state;
      }
      return address;
    },
    getVocherType: function getVocherType(invoice) {
      if (invoice.type == 'CustomerPayment') {
        if (invoice.isBuyer) {
          return "Receipt";
        } else {
          return "Payment";
        }
      }
      if (invoice.return) {
        if (invoice.isBuyer) {
          return "Credit Note";
        } else {
          return "Debit Note";
        }
      } else if (invoice.transactionType != "Debit" && invoice["type"] === "Advance" || invoice["type"] === "Opening Balance" || invoice["type"] === "LoanGiven" || invoice["type"] === "LoanTaken" || invoice["type"] === "Security") {
        // debugger
        // if((invoice["type"] === "LoanTaken" || invoice["type"] === "LoanGiven") && invoice.status =="paid") {
        if ((invoice["type"] === "LoanTaken" || invoice["type"] === "LoanGiven" || invoice["type"] === "Opening Balance") && invoice.status == "paid") {
          return invoice["type"] + " (paid)";
        } else {
          return invoice["type"];
        }
      }
      // else if (invoice.isBuyer && invoice.status === "due") {
      //   return "Sale";
      // }
      // else if (invoice.isBuyer && invoice.status === "paid" || "partial") {
      //   return "Receipt";
      // }
      // else if (!invoice.isBuyer && invoice.status === "due") {
      //   return "Purchase";
      // }
      // else if (!invoice.isBuyer && invoice.status === "paid" || "partial") {
      //   return "Payment";
      // } 
      else if (invoice.isBuyer && invoice.transactionType === "Debit") {
          return "Sale";
        } else if (invoice.isBuyer && invoice.transactionType === "Credit" || invoice.isBuyer && invoice.transactionType === "Partial Paid") {
          return "Receipt";
        } else if (!invoice.isBuyer && invoice.transactionType === "Debit") {
          return "Purchase";
        } else if (!invoice.isBuyer && invoice.transactionType === "Credit" || !invoice.isBuyer && invoice.transactionType === "Partial Paid") {
          return "Payment";
        }
    },
    openProd: function openProd(invoice) {
      this.selectedInvoice = invoice;
      this.dialog = true;
    },
    getFirmName: function getFirmName(firmId) {
      if (this.firms && this.firms[firmId]) {
        return this.firms[firmId]["name"];
      }
      return "--";
    },
    getCurrentUser: function getCurrentUser() {
      var buyer = this.buyerById[this.selectedBuyer];
      var seller = this.sellerById[this.selectedBuyer];
      this.isUserBuyer = buyer ? true : false;
      this.currentUser = this.isUserBuyer ? buyer : seller;
    },
    getGSTtotal: function getGSTtotal(item) {
      var GSTTotal = 0;
      item && item.items && item.items.map(function (item) {
        GSTTotal += __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
      });
      return GSTTotal;
    },
    getDebit: function getDebit(item) {
      if (item.type == 'CustomerPayment') {
        if (!item.isBuyer) {
          return 0;
        } else {
          return item['remainingAmount'];
        }
      } else if (['LoanTaken', 'LoanGiven', 'Opening Balance', 'Advance', 'Security'].includes(item.type)) {
        switch (item.type) {
          case 'LoanTaken':
            {
              if (item.loanTransaction) {
                return 0;
              } else {
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item.amount);
              }
              break;
            }
          case 'LoanGiven':
            {
              if (item.loanTransaction) {
                if (item.loanPaymentType == 'interest') {
                  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item.paidInterest);
                } else {
                  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item.paidAmount);
                }
              } else {
                return 0;
              }
              break;
            }
          case 'Opening Balance':
            {
              return item.isUserCreated ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(0) : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item.settledAmount);
              break;
            }
          case 'Advance':
            {
              return item.isUserCreated ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item.amount) : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(0);
              break;
            }
          case 'Security':
            {
              return item.isUserCreated ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item.amount) : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(0);
              break;
            }
        }
      } else {
        switch (item.status) {
          case 'due':
            {
              return 0;
              break;
            }
          case 'paid':
            {
              // return (Number.parseFloat(item['totalAmount']));
              return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item['amountFromBank']) + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item['amountFromCash']);
              break;
            }
          case 'partial':
            {
              return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item['amountFromBank']) + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item['amountFromCash']);
              break;
            }
        }
      }

      // if(item.status == 'due' || item.status == 'partial') {
      //   if(item.type === "LoanTaken" && (item.status == 'due' || item.status == 'partial' )) {
      //     return Number.parseFloat(item.amount);
      //   } else if(item.type === "LoanTaken") {
      //     return 0 ;
      //   } else if (item.type == "Opening Balance") {
      //     return item.isUserCreated ? Number.parseFloat(0) : Number.parseFloat(item.settledAmount);
      //   }
      // } else if(item.type === "LoanGiven" && item.status == 'paid') {
      //   return Number.parseFloat(item.amount) + Number.parseFloat(item.paidAmount);
      // } else if(item.type === "LoanTaken" && item.status == 'paid') {
      //   return 0;
      // } else if(item.status) {
      //   return (Number.parseFloat(item['amountFromBank']) + Number.parseFloat(item['amountFromCash']));
      // } else {
      //   if (item.type == "Opening Balance") {
      //     return item.isUserCreated ? Number.parseFloat(0) : Number.parseFloat(item.settledAmount);
      //   }
      //   else if(item.type == "Advance" || item.type == "Security") {          
      //     return item.isUserCreated ? Number.parseFloat(item.amount) : Number.parseFloat(0);
      //   } 
      //   else {
      //     return 0;
      //   }
      // }
    },
    getCredit: function getCredit(item) {
      if (item.type == 'CustomerPayment') {
        if (item.isBuyer) {
          return 0;
        } else {
          return item['remainingAmount'];
        }
      } else if (['LoanTaken', 'LoanGiven', 'Opening Balance', 'Advance', 'Security'].includes(item.type)) {
        switch (item.type) {
          case 'LoanTaken':
            {
              if (item.loanTransaction) {
                if (item.loanPaymentType == 'interest') {
                  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item.paidInterest);
                } else {
                  return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item.paidAmount);
                }
              } else {
                return 0;
              }
              break;
            }
          case 'LoanGiven':
            {
              if (item.loanTransaction) {
                return 0;
              } else {
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item.amount);
              }
              break;
            }
          case 'Opening Balance':
            {
              // return item.isUserCreated ? Number.parseFloat(item.amount) : Number.parseFloat(0);
              return item.isUserCreated ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item.amount) : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(0);

              break;
            }
          case 'Advance':
            {
              return item.isUserCreated ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(0) : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item.settledAmount);
              break;
            }
          case 'Security':
            {
              return item.isUserCreated ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(0) : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item.settledAmount);
              break;
            }
        }
      } else {
        switch (item.status) {
          case 'due':
            {
              return item.totalAmount;
              break;
            }
          case 'paid':
            {
              return 0;
              break;
            }
          case 'partial':
            {
              return 0;
              break;
            }
        }
      }

      // if(item.status == 'due' || item.status == 'partial') {
      //   if(item.type === "LoanGiven" && (item.status == 'due' || item.status == 'partial' )) {
      //     return Number.parseFloat(item.amount);
      //   } else if(item.type === "LoanGiven") {
      //     return 0 ;
      //   } else if (item.type == "Opening Balance") {
      //     return item.isUserCreated ? Number.parseFloat(item.amount) : Number.parseFloat(0);
      //   } else {
      //     return item["remainingAmount"];
      //   }
      // } else if(item.type === "LoanTaken" && item.status == 'paid') {
      //   return Number.parseFloat(item.amount) + Number.parseFloat(item.paidAmount);
      // } else if(item.status) {
      //   return 0;
      // }  else {
      //   if (item.type == "Opening Balance"){
      //     return item.isUserCreated ? Number.parseFloat(item.amount) : Number.parseFloat(0);
      //   } 
      //   else if(item.type == "Advance" || item.type == "Security") {
      //     return item.isUserCreated ? Number.parseFloat(0) : Number.parseFloat(item.settledAmount);
      //   } 
      //   else {
      //     return 0;
      //   }
      // }
    }
  }
});

/***/ }),
/* 431 */,
/* 432 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tabs: ["Customer", "Supplier"],
      selectedTab: 0,
      buyers: [],
      seller: [],
      searchtext: '',
      isBuyerTab: true,
      addText: 'New Customer'
    };
  },
  created: function created() {
    this.$bindAsArray('buyers', this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('seller', this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    console.log(this.$route.params);
    if (this.$route.params.isBuyer == 'false') {
      console.log(this.selectedTab);
      this.selectedTab = 1;
      this.isBuyerTab = false;
      this.$emit('tabSelected', index);
    }
  },

  watch: {
    selectedTab: function selectedTab(index) {
      // this.searchtext = ''
      // if (index == 0) {
      //   this.isBuyerTab = true
      //   this.addText = 'New Buyer'
      //   this.$router.push({path: `/buyers/${-1}` })
      // } else {
      //   this.isBuyerTab = false
      //   this.addText = 'New Supplier'
      //   this.$router.push({path: `/buyers/${-1}` })
      // }
      // this.$emit('tabSelected', index)
    },

    buyers: {
      handler: function handler(newVal, oldVal) {
        var _this = this;

        sessionStorage.removeItem("addressSuggestions");
        var addressSuggestions = [];
        newVal.map(function (item) {
          if (item.localAddress && item.localAddress != "") addressSuggestions.push(item.localAddress);
        });
        sessionStorage.setItem("addressSuggestions", addressSuggestions);
        if (this.buyers.length && this.$route.params.buyerId) {
          var buyer = this.buyers.find(function (b) {
            return b['.key'] == _this.$route.params.buyerId;
          });
          if (!buyer) {
            this.selectedTab = 1;
            this.isBuyerTab = false;
            this.$emit('tabSelected', 1);
          }
        }
      },

      deep: true
    }
  },
  methods: {
    onEnterBuyer: function onEnterBuyer() {
      this.$router.push({ path: '/buyers/' + this.getCandidate[0]['.key'] });
    },
    changeTabs: function changeTabs(index) {
      this.searchtext = '';
      console.log(index);
      if (index == 0) {
        this.isBuyerTab = true;
        this.addText = 'New Customer';
        this.$router.push({ path: '/buyers/' + -1 });
      } else {
        this.isBuyerTab = false;
        this.addText = 'New Supplier';
        this.$router.push({ path: '/buyers/' + -1 });
      }
      this.$emit('tabSelected', index);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand']), {
    getBuyers: function getBuyers() {
      var _this2 = this;

      return this.buyers.filter(function (item) {
        if (!_this2.searchtext) {
          return item['brand'] === _this2.selectedBrand;
        } else {
          return item.name && item.name.toLowerCase().includes(_this2.searchtext.toLowerCase()) && item['brand'] === _this2.selectedBrand || item.localAddress && item.localAddress.toLowerCase().includes(_this2.searchtext.toLowerCase()) && item['brand'] === _this2.selectedBrand || item.village && item.village.toLowerCase().includes(_this2.searchtext.toLowerCase()) && item['brand'] === _this2.selectedBrand || item.block && item.block.toLowerCase().includes(_this2.searchtext.toLowerCase()) && item['brand'] === _this2.selectedBrand || item.tehsil && item.tehsil.toLowerCase().includes(_this2.searchtext.toLowerCase()) && item['brand'] === _this2.selectedBrand || item.district && item.district.toLowerCase().includes(_this2.searchtext.toLowerCase()) && item['brand'] === _this2.selectedBrand;
        }
      });
    },
    getSeller: function getSeller() {
      var _this3 = this;

      return this.seller.filter(function (item) {
        if (!_this3.searchtext) {
          return item['brand'] === _this3.selectedBrand;
        } else {
          return item.name && item.name.toLowerCase().includes(_this3.searchtext.toLowerCase()) && item['brand'] === _this3.selectedBrand || item.localAddress && item.localAddress.toLowerCase().includes(_this3.searchtext.toLowerCase()) && item['brand'] === _this3.selectedBrand || item.village && item.village.toLowerCase().includes(_this3.searchtext.toLowerCase()) && item['brand'] === _this3.selectedBrand || item.block && item.block.toLowerCase().includes(_this3.searchtext.toLowerCase()) && item['brand'] === _this3.selectedBrand || item.tehsil && item.tehsil.toLowerCase().includes(_this3.searchtext.toLowerCase()) && item['brand'] === _this3.selectedBrand || item.district && item.district.toLowerCase().includes(_this3.searchtext.toLowerCase()) && item['brand'] === _this3.selectedBrand;
        }
      });
    },
    getCandidate: function getCandidate() {
      if (this.isBuyerTab) {
        return this.getBuyers.sort(function (a, b) {
          return a.name >= b.name ? 1 : -1;
        });
        // return this.getBuyers.reverse()
      } else {
        return this.getSeller.sort(function (a, b) {
          return a.name >= b.name ? 1 : -1;
        });
        // return this.getSeller.reverse()
      }
    }
  }),

  // watch: {
  //   buyers: {
  //     deep: true,
  //     handler (val) {

  //     }
  //   }
  // },
  destroyed: function destroyed() {
    // this.$unbind('buyers')
  }
});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_LoanReceipt__ = __webpack_require__(1341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_digitsToWords_js__ = __webpack_require__(35);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* createNamespacedHelpers */])("Buyer")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isSummary: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      addDipositDialog: false,
      defaultFirm: null,
      isOpeningBalance: false,
      loanPayment: false,
      previousType: null,
      hintText: null,
      password: null,
      passwordDialog: false,
      currentPasswordReference: null,
      currentPasswordMethod: null,
      currentDeposite: {
        amount: "",
        paymentType: "",
        mortgage: "",
        product: "",
        type: "",
        firm: "",
        quantity: 0,
        rate: 0,
        transferType: "",
        date: null,
        paid: null,
        amountFromCash: 0,
        amountFromBank: 0,
        bank: null,
        interest: 0
      },
      currentUser: {},
      loanPaymentType: null,
      loanToPay: null,
      datepicker: null,
      depositList: [],
      AdvancedDepositeHeader: [
      // { text: "Deposit- ID", value: "deposit - ID" },
      { text: "Date", value: "date" }, { text: "Debit", value: "amount" }, { text: "Credit", value: "amount" }, { text: "Payment Type", value: "type" }, { text: "Edit", value: "edit" }, { text: "Delete", value: "delete" }, { text: "Remark", value: "remark" }, { text: "Firm", value: "quantity" }],
      SecurityDepositeHeader: [{ text: "Date", value: "date" },
      // { text: "Deposit- ID", value: "deposit - ID" },
      { text: "Debit", value: "amount" }, { text: "Credit", value: "amount" }, { text: "Mortgage", value: "Mortgage" }, { text: "Edit", value: "edit" }, { text: "Delete", value: "delete" }, { text: "Firm", value: "quantity" }],
      OpeningBalanceHeader: [
      // { text: "Deposit- ID", value: "deposit - ID" },
      { text: "Date", value: "date" }, { text: "Debit", value: "amount" }, { text: "Credit", value: "amount" }, { text: "Interest Rate", value: "rate" }, { text: "Interest Amount", value: "amount" }, { text: "Edit", value: "edit" }, { text: "Delete", value: "delete" }, { text: "Firm", value: "name" }],
      LoanTakenHeader: [
      // { text: "Deposit- ID", value: "deposit - ID" },
      { text: "Pay", value: "Pay" }, { text: "Date", value: "date" }, { text: "Amount", value: "amount" }, { text: "Interest Rate", value: "rate" }, { text: "Interest Amount", value: "interest" }, { text: "Duration", value: "duration" }, { text: "Paid Amount", value: "amount" }, { text: "Paid Interest", value: "amount" }, { text: "Payment Type", value: "paymentType" }, { text: "Status", value: "status" }, { text: "Remark", value: "remark" }, { text: "Print", value: "print" }, { text: "Edit", value: "edit" }, { text: "Delete", value: "delete" }, { text: "Interest Date", value: "date" }, { text: "Transfer Type", value: "transferType" }, { text: "Firm", value: "name" }],
      LoanGivenHeader: [
      // { text: "Deposit- ID", value: "deposit - ID" },
      { text: "Pay", value: "Pay" }, { text: "Date", value: "date" }, { text: "Amount", value: "amount" }, { text: "Interest Rate", value: "rate" }, { text: "Interest Amount", value: "interest" }, { text: "Duration", value: "duration" }, { text: "Paid Amount", value: "amount" }, { text: "Paid Interest", value: "amount" }, { text: "Payment Type", value: "paymentType" }, { text: "Status", value: "status" }, { text: "Remark", value: "remark" }, { text: "Print", value: "print" }, { text: "Edit", value: "edit" }, { text: "Delete", value: "delete" }, { text: "Interest Date", value: "date" }, { text: "Transfer Type", value: "transferType" }, { text: "Firm", value: "name" }],
      orderHeader: [{ text: "Order- ID", value: "deposit - ID" }, { text: "Quantity", value: "quantity" }, { text: "Product", value: "product" }, { text: "Date", value: "quantity" }, { text: "Edit", value: "edit" }, { text: "Delete", value: "delete" }]
    };
  },
  mounted: function mounted() {
    this.getCurrentUser();
  },
  created: function created() {
    this.$bindAsArray("customerDeposit", this.$root.$firebaseRefs.customerDeposit.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsObject("buyerById", this.$root.$firebaseRefs.buyer.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsObject("sellerById", this.$root.$firebaseRefs.seller.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsObject("firmById", this.$root.$firebaseRefs.firm.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsObject("bankById", this.$root.$firebaseRefs.account.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("banks", this.$root.$firebaseRefs.account.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("customerDeposit", this.$root.$firebaseRefs.customerDeposit.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("termsAndConditions", this.$root.$firebaseRefs.termsAndConditions.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("bankById", this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("firmSettings", this.$root.$firebaseRefs.firmSettings.orderByChild("brand").equalTo(this.selectedBrand));
  },

  watch: {
    "currentDeposite.date": {
      handler: function handler(newVal, oldVal) {
        if (this.loanPayment) {
          var dayDiff = this.dayDiff(new Date(this.loanToPay.interestDate), new Date(this.currentDeposite.date));
          // console.log(dayDiff)
          this.currentDeposite.interestAmount = this.calculateInterest(this.loanToPay.amount, this.loanToPay.interest, dayDiff);
          var total = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.currentDeposite.interestAmount) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.currentDeposite.amount);
          var newtotal = Math.round(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(total));
          this.currentDeposite.roundOffAmount = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(newtotal - total).toFixed(2);
          this.calculateAmounts();
        }
      },

      deep: true
    },
    "currentDeposite.amount": {
      handler: function handler() {
        this.hintText = this.currentDeposite.amount ? _.startCase(Object(__WEBPACK_IMPORTED_MODULE_9__utils_digitsToWords_js__["a" /* digitsToWords */])(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.currentDeposite.amount))) : null;
      },

      deep: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear"]), mapBuyerGetters(["selectedBuyer"]), {
    depositListByBrand: function depositListByBrand() {
      var _this = this;

      return this.depositList.filter(function (item) {
        return item["brand"] === _this.selectedBrand && item.date >= _this.finYear.start && item.date <= _this.finYear.end;
      });
    },
    banksByFirms: function banksByFirms() {
      var _this2 = this;

      return this.banks.filter(function (item) {
        return item["brand"] === _this2.selectedBrand && item["firm"] === _this2.currentDeposite.firm;
      }).map(function (item) {
        return {
          account: item,
          text: item["bankName"],
          value: item[".key"]
        };
      });
    },

    // banksByFirms() {
    //   return this.banks
    //     .filter(item => {
    //       return (
    //         item["brand"] === this.selectedBrand &&
    //         item["firm"] === this.currentDeposite['firm']
    //       );
    //     })
    //     .map(item => {
    //       return {
    //         account: item,
    //         text: item["bankName"],
    //         value: item[".key"]
    //       };
    //     });
    // },
    firmsByBrand: function firmsByBrand() {
      var _this3 = this;

      return this.firms.filter(function (item) {
        return item["brand"] === _this3.selectedBrand;
      }).map(function (item) {
        if (item.defaultFirm) {
          _this3.defaultFirm = item[".key"];
        }
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
    },
    productsByBrand: function productsByBrand() {
      var _this4 = this;

      return this.products.filter(function (item) {
        return item["brand"] === _this4.selectedBrand;
      });
    },
    advanceDepositListByCustomer: function advanceDepositListByCustomer() {
      var _this5 = this;

      return this.customerDeposit.filter(function (item) {
        return item["brand"] === _this5.selectedBrand && item["buyerId"] === _this5.$route.params.customerId && item.date >= _this5.finYear.start && item.date <= _this5.finYear.end && (item["type"] === "Advance" || item["parentType"] === "Advance" && item["type"] === "Opening Balance");
      });
    },
    openingBalanceListByCustomer: function openingBalanceListByCustomer() {
      var _this6 = this;

      return this.customerDeposit.filter(function (item) {
        return item["brand"] === _this6.selectedBrand && item["buyerId"] === _this6.$route.params.customerId && item.date >= _this6.finYear.start && item.date <= _this6.finYear.end && item["type"] === "Opening Balance" && !item["parentType"];
      });
    },
    givenLoanListByCustomer: function givenLoanListByCustomer() {
      var _this7 = this;

      var loan = this.customerDeposit.filter(function (item) {
        return item["brand"] === _this7.selectedBrand && item["buyerId"] === _this7.$route.params.customerId && item.date >= _this7.finYear.start && item.date <= _this7.finYear.end && (item["type"] === "LoanGiven" || item["parentType"] === "LoanGiven" && item["type"] === "Opening Balance");
      });
      loan.map(function (l, index) {
        var transactions = loan.filter(function (item) {
          return item["loanId"] == l[".key"];
        });
        loan[index]["transactions"] = transactions;
      });
      return loan;
    },
    takenLoanListByCustomer: function takenLoanListByCustomer() {
      var _this8 = this;

      var loan = this.customerDeposit.filter(function (item) {
        return item["brand"] === _this8.selectedBrand && item["buyerId"] === _this8.$route.params.customerId && item.date >= _this8.finYear.start && item.date <= _this8.finYear.end && (item["type"] === "LoanTaken" || item["parentType"] === "LoanTaken" && item["type"] === "Opening Balance");
      });
      loan.map(function (l, index) {
        var transactions = loan.filter(function (item) {
          return item["loanId"] == l[".key"];
        });
        loan[index]["transactions"] = transactions;
      });
      return loan;
    },
    securityDepositListByCustomer: function securityDepositListByCustomer() {
      var _this9 = this;

      return this.customerDeposit.filter(function (item) {
        return item["brand"] === _this9.selectedBrand && item["buyerId"] === _this9.$route.params.customerId && item.date >= _this9.finYear.start && item.date <= _this9.finYear.end && (item["type"] === "Security" || item["parentType"] === "Security" && item["type"] === "Opening Balance");
      });
    },
    sendOrderListByCustomer: function sendOrderListByCustomer() {
      var _this10 = this;

      return this.customerDeposit.filter(function (item) {
        return item["brand"] === _this10.selectedBrand && item["buyerId"] === _this10.$route.params.customerId && item.date >= _this10.finYear.start && item.date <= _this10.finYear.end && item["type"] === "Send Order";
      });
    },
    isBuyer: function isBuyer() {
      var buyer = this.buyerById[this.$route.params.customerId];
      var seller = this.sellerById[this.$route.params.customerId];
      return buyer && __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(buyer).length != 0 ? true : false;
    },
    placeOrderListByCustomer: function placeOrderListByCustomer() {
      var _this11 = this;

      return this.customerDeposit.filter(function (item) {
        return item["brand"] === _this11.selectedBrand && item["buyerId"] === _this11.$route.params.customerId && item.date >= _this11.finYear.start && item.date <= _this11.finYear.end && item["type"] === "Place Order";
      });
    }
  }),
  methods: {
    calculateAmounts: function calculateAmounts() {
      var total = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.currentDeposite.interestAmount) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.currentDeposite.amount) - __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.currentDeposite.paidAmount);
      var newtotal = Math.round(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(total));
      switch (this.currentDeposite.paymentType) {
        case "Cash":
          {
            if (this.loanPaymentType == "full") {
              this.currentDeposite.amountFromCash = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(newtotal);
              this.currentDeposite.amountFromBank = 0;
            }

            if (this.loanPaymentType == "interest") {
              this.currentDeposite.amountFromCash = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.currentDeposite.interestAmount);
              this.currentDeposite.amountFromBank = 0;
            }
            break;
          }
        case "Bank Account":
          {
            if (this.loanPaymentType == "full") {
              this.currentDeposite.amountFromBank = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(newtotal);
              this.currentDeposite.amountFromCash = 0;
            }

            if (this.loanPaymentType == "interest") {
              this.currentDeposite.amountFromBank = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.currentDeposite.interestAmount);
              this.currentDeposite.amountFromCash = 0;
            }
            break;
          }
        case "CashAndBank Account":
          {
            if (this.loanPaymentType == "full") {
              this.currentDeposite.amountFromBank = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(newtotal) / 2;
              this.currentDeposite.amountFromCash = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(newtotal) / 2;
            }

            if (this.loanPaymentType == "interest") {
              this.currentDeposite.amountFromBank = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.currentDeposite.interestAmount) / 2;
              this.currentDeposite.amountFromCash = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.currentDeposite.interestAmount) / 2;
            }
            break;
          }
      }
    },
    backToPrevious: function backToPrevious() {
      this.isOpeningBalance = false;
      this.openingBalanceSwitcherChange();
    },
    getDuration: function getDuration(inv) {
      var date1 = new Date(inv.interestDate);
      var date2 = new Date();
      var diffTime = Math.abs(date2 - date1);
      var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      return diffDays + " Days";
    },


    // Start of New Development 03/06/21
    printLoanReceipt: function printLoanReceipt(item) {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var termsAndConditions;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // console.log(item)
                termsAndConditions = _this12.getTermsAndConditions(item);

                if (item.multiFirm) {
                  _context.next = 4;
                  break;
                }

                _context.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_8__utils_LoanReceipt__["a" /* loanReceiptPDF */])({
                  firm: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this12.firms.filter(function (item1) {
                    return item1['.key'] == item.firm;
                  })[0]),
                  customer: _this12.currentUser,
                  terms: termsAndConditions[0],
                  payment: item
                }).then(function (doc) {
                  pdfMake.createPdf(doc).download(_this12.currentUser.name + "_Receipt");
                });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this12);
      }))();
    },
    getTermsAndConditions: function getTermsAndConditions(invoiceData) {
      var _this13 = this;

      var termsAndConditions = this.termsAndConditions.filter(function (item) {
        return item["brand"] === _this13.selectedBrand && item["firm"] === invoiceData.firm;
      });
      if (termsAndConditions.length) {
        if (termsAndConditions[0].bank) {
          var banks = [];
          termsAndConditions[0].bank.map(function (bankId) {
            var bank = _this13.bankById[bankId];
            bank.address = _this13.getAddress(bank);
            banks.push(bank);
          });
          termsAndConditions[0].banks = banks;
        } else {
          termsAndConditions[0].banks = [];
        }
      } else {
        termsAndConditions = [{
          termsAndConditions: "",
          banks: []
        }];
      }
      return termsAndConditions;
    },
    getAddress: function getAddress(item) {
      if (!item) {
        return "";
      }
      var address = (item.village ? item.village + " - " : "") + (item.block ? item.block + " - " : "") + (item.tehsil ? item.tehsil + " - " : "") + (item.district ? item.district + " - " : "") + (item.state ? item.state + " - " : "") + (item.country ? item.country + " - " : "");
      address = address.substring(0, address.length - 2);
      return address;
    },

    // end of New Development 03/06/21
    openingBalanceSwitcherChange: function openingBalanceSwitcherChange() {
      if (this.isOpeningBalance) {
        this.previousType = this.currentDeposite.type;
        this.addDiposit("Opening Balance");
      } else {
        this.addDiposit(this.previousType);
        this.previousType = null;
      }
    },
    saveDiposit: function saveDiposit() {
      this.currentDeposite.brand = this.selectedBrand;
      this.customer = this.$route.params.customerId;
      if (["Security", "Opening Balance", "Advance", "LoanGiven", "LoanTaken"].includes(this.currentDeposite.type)) {
        this.currentDeposite["isUserCreated"] = true;
        this.currentDeposite["remainingAmount"] = this.currentDeposite["amount"];
      }
      if (this.isOpeningBalance && this.previousType != null) {
        this.currentDeposite["parentType"] = this.previousType;
      }
      if (["LoanGiven", "LoanTaken", "Opening Balance"].includes(this.currentDeposite.type)) {
        this.currentDeposite["status"] = "due";
        this.currentDeposite["interestDate"] = new Date(this.currentDeposite.date).getTime();
        this.currentDeposite["paidAmount"] = 0;
      } else {
        delete this.currentDeposite["interest"];
      }
      this.currentDeposite.date = new Date(this.currentDeposite.date).getTime();
      this.currentDeposite["isBuyer"] = this.isBuyer;
      if (this.currentDeposite["bank"]) {
        this.currentDeposite["bank"] = this.currentDeposite["bank"]["value"] || this.currentDeposite["bank"][".key"];
      }
      this.$root.$firebaseRefs.customerDeposit.push(this.currentDeposite);
      if (["Security", "Advance", "LoanGiven", "LoanTaken"].includes(this.currentDeposite.type)) {
        this.handleTransaction();
      }
      //this.addRemainingBalance();
      this.addDipositDialog = false;
    },
    payLoan: function payLoan() {
      this.currentDeposite.brand = this.selectedBrand;
      this.customer = this.$route.params.customerId;
      switch (this.loanPaymentType) {
        case "custom":
          {
            this.currentDeposite.status = "partial";
            this.currentDeposite["paidAmount"] = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.currentDeposite.amountFromCash) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.currentDeposite.amountFromBank);
            this.currentDeposite.paidInterest = this.loanToPay.paidInterest ? this.loanToPay.paidInterest : 0;
            break;
          }
        case "interest":
          {
            this.currentDeposite.status = "partial";
            this.currentDeposite.paidInterest = this.loanToPay.paidInterest ? this.loanToPay.paidInterest + this.currentDeposite.amountFromCash + this.currentDeposite.amountFromBank : this.currentDeposite.amountFromCash + this.currentDeposite.amountFromBank;
            this.currentDeposite.interestDate = new Date(this.currentDeposite.date).getTime();
            this.currentDeposite["paidAmount"] = 0;
            break;
          }
        case "full":
          {
            this.currentDeposite.status = "paid";
            this.currentDeposite.paidInterest = this.loanToPay.paidInterest ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.loanToPay.paidInterest) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.currentDeposite.interestAmount) : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.currentDeposite.interestAmount);
            this.currentDeposite["paidAmount"] = this.currentDeposite.amountFromCash + this.currentDeposite.amountFromBank;
            // + (this.currentDeposite.paidInterest || 0)
            break;
          }
      }
      this.currentDeposite.date = new Date(this.currentDeposite.date).getTime();
      this.currentDeposite["loanPaymentType"] = this.loanPaymentType;
      if (this.currentDeposite["bank"]) {
        this.currentDeposite["bank"] = this.currentDeposite["bank"][".key"];
      }
      //this.currentDeposite['principalAmount'] = this.currentDeposite['amount'];

      //console.log(JSON.stringify(this.currentDeposite,null,4))
      this.currentDeposite["loanTransaction"] = true;
      this.currentDeposite["loanId"] = this.loanToPay[".key"];
      this.currentDeposite["isBuyer"] = this.isBuyer;
      this.$root.$firebaseRefs.customerDeposit.push(this.currentDeposite);
      this.loanToPay.paidInterest = this.currentDeposite["paidInterest"];
      this.loanToPay.paidAmount = this.currentDeposite["paidAmount"];
      this.loanToPay.status = this.currentDeposite["status"];
      delete this.loanToPay[".key"];
      this.$root.$firebaseRefs.customerDeposit.child(this.currentDeposite["loanId"]).set(this.loanToPay);
      this.addDipositDialog = false;
      this.handleLoanPayment();
    },

    // addRemainingBalance(){
    //   let advanceDeposit = this.customerDeposit.filter(
    //     item =>
    //       item["brand"] === this.selectedBrand &&
    //       item["buyerId"] === this.$route.params.customerId &&
    //       item["type"] === "Advance" &&
    //       !!item["isUserCreated"] &&
    //       (parseInt(item["remainingAmount"]) > 0)
    //   );
    //   let advanceDepositTotal = 0;
    //   advanceDeposit.map((inv,index)  => {
    //     advanceDepositTotal += Number.parseFloat(inv.remainingAmount);
    //   });
    //   let openingBalance = this.customerDeposit.filter(
    //     item =>
    //       item["brand"] === this.selectedBrand &&
    //       item["buyerId"] === this.$route.params.customerId &&
    //       item["type"] === "Opening Balance" &&
    //        !!item["isUserCreated"] &&
    //       (parseInt(item["remainingAmount"]) > 0)
    //   );
    //   let openingBalanceTotal = 0;
    //   openingBalance.map((inv,index) => {
    //     openingBalanceTotal += Number.parseFloat(inv.remainingAmount);
    //   });
    //   let securityDeposit = this.customerDeposit.filter(
    //     item =>
    //       item["brand"] === this.selectedBrand &&
    //       item["buyerId"] === this.$route.params.customerId &&
    //       item["type"] === "Security" &&
    //        !!item["isUserCreated"] &&
    //       (parseInt(item["remainingAmount"]) > 0)
    //   );
    //   let securityDepositTotal = 0;
    //   securityDeposit.map((inv,index) => {
    //     securityDepositTotal += Number.parseFloat(inv.remainingAmount);
    //   });
    //   let totalAmount = ((Number.parseFloat(openingBalanceTotal)) - (Number.parseFloat(advanceDepositTotal) + Number.parseFloat(securityDepositTotal)))
    //   if(this.isBuyer) {
    //     let buyer = this.buyerById[this.$route.params.customerId];
    //     if(buyer) {
    //       buyer.remainingAmountFromDeposite = totalAmount
    //       delete buyer['.key']
    //       this.$root.$firebaseRefs.buyer.child(this.$route.params.customerId).set(buyer);
    //     }
    //   } else {
    //     let seller = this.sellerById[this.$route.params.customerId];
    //     if(seller) {
    //       seller.remainingAmountFromDeposite = totalAmount
    //       delete seller['.key']
    //       this.$root.$firebaseRefs.seller.child(this.$route.params.customerId).set(seller);
    //     }
    //   }
    // },
    handleLoanPayment: function handleLoanPayment() {
      var LoanType = this.currentDeposite.type == "Opening Balance" ? this.currentDeposite.parentType : this.currentDeposite.type;
      var multiple = LoanType == "LoanGiven" ? 1 : -1;
      if (this.currentDeposite.type == "Advance") {
        multiple = this.currentDeposite.isBuyer ? 1 : -1;
      }
      switch (this.currentDeposite.paymentType) {
        case "Cash":
          {
            if (this.currentDeposite.amountFromCash) {
              var firm = this.firmById[this.currentDeposite.firm];
              // console.log(JSON.stringify(firm,null,4))
              if (firm) {
                firm.amount = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(firm.amount) + multiple * __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.currentDeposite.amountFromCash);
                var key = firm[".key"];
                delete firm[".key"];
                this.$root.$firebaseRefs.firm.child(this.currentDeposite.firm).set(firm);
              }
            }
            break;
          }
        case "Bank Account":
          {
            if (this.currentDeposite.amountFromBank) {
              var bank = this.bankById[this.currentDeposite.bank];
              //  console.log(JSON.stringify(bank,null,4))
              if (bank) {
                bank.amount = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(bank.amount) + multiple * __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.currentDeposite.amountFromBank);
                var _key = bank[".key"];
                delete bank[".key"];
                this.$root.$firebaseRefs.account.child(this.currentDeposite.bank).set(bank);
              }
            }
            break;
          }
        case "CashAndBank Account":
          {
            if (this.currentDeposite.amountFromCash && this.currentDeposite.amountFromBank) {
              var _bank = this.bankById[this.currentDeposite.bank];
              if (_bank) {
                _bank.amount = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_bank.amount) + multiple * __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.currentDeposite.amountFromBank);
                var _key2 = _bank[".key"];
                delete _bank[".key"];
                this.$root.$firebaseRefs.account.child(this.currentDeposite.bank).set(_bank);
              }
              var _firm = this.firmById[this.currentDeposite.firm];
              if (_firm) {
                _firm.amount = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_firm.amount) + multiple * __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.currentDeposite.amountFromCash);
                var _key3 = _firm[".key"];
                delete _firm[".key"];
                this.$root.$firebaseRefs.firm.child(this.currentDeposite.firm).set(_firm);
              }
            }
            break;
          }
      }
    },
    handleTransaction: function handleTransaction() {
      var isBuyer = this.isBuyer;
      if (this.currentDeposite.type == "LoanTaken") {
        var firm = this.firmById[this.currentDeposite.firm];
        firm.amount = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(firm.amount) + (isBuyer ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.currentDeposite.amount) : -__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.currentDeposite.amount));
        this.$root.$firebaseRefs.firm.child(this.currentDeposite.firm).set(firm);
      } else if (this.currentDeposite.type == "LoanGiven") {
        var _firm2 = this.firmById[this.currentDeposite.firm];
        _firm2.amount = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_firm2.amount) + (isBuyer ? -__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.currentDeposite.amount) : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.currentDeposite.amount));
        this.$root.$firebaseRefs.firm.child(this.currentDeposite.firm).set(_firm2);
      } else if (this.currentDeposite.type == "Advance") {
        this.handleLoanPayment();
      }
    },
    getFirmName: function getFirmName(firm) {
      return firm ? this.firmById[firm].name : "";
    },
    getCurrentUser: function getCurrentUser() {
      var buyer = this.buyerById[this.selectedBuyer];
      var seller = this.sellerById[this.selectedBuyer];
      this.isUserBuyer = buyer ? true : false;
      this.currentUser = buyer && buyer.state ? buyer : seller && seller.state ? seller : {};
    },

    // isBuyer(){
    //   let buyer = this.buyerById[this.$route.params.customerId];
    //   let seller = this.sellerById[this.$route.params.customerId];
    //   return buyer && Object.keys(buyer).length != 0 ? true : false;
    // },
    addDiposit: function addDiposit(type, pay) {
      console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(type));
      this.currentDeposite = {
        amount: "",
        paymentType: "",
        mortgage: "",
        product: "",
        // firm : '',
        firm: this.defaultFirm || null,
        type: type,
        quantity: 0,
        transferType: "",
        rate: 0,
        date: new Date().toISOString().substr(0, 10),
        buyerId: this.$route.params.customerId,
        brand: this.selectedBrand,
        paid: null
      };
      if (pay) {
        this.loanPayment = true;
        this.loanToPay = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, pay);
        this.currentDeposite.firm = this.loanToPay.firm;
        this.currentDeposite.amount = this.loanToPay.amount;
        this.currentDeposite.type = this.loanToPay.type;
        this.currentDeposite.interestDate = this.loanToPay.interestDate;
        this.currentDeposite.paidAmount = this.loanToPay.paidAmount;
        //this.currentDeposite.date = new Date(this.loanToPay.date).toISOString().substr(0, 10);
        if (this.loanToPay.parentType) {
          this.currentDeposite.parentType = this.loanToPay.parentType;
        }
        if (this.loanToPay.interest) {
          this.currentDeposite.interest = this.loanToPay.interest;
          this.loanPaymentType = "full";
          this.currentDeposite.paymentType = "Cash";
          var dayDiff = this.dayDiff(new Date(this.loanToPay.interestDate), new Date(this.currentDeposite.date));
          this.currentDeposite.interestAmount = this.calculateInterest(this.loanToPay.amount, this.loanToPay.interest, dayDiff);
          var total = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.currentDeposite.interestAmount) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.currentDeposite.amount) - __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.currentDeposite.paidAmount);
          var newtotal = Math.round(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(total));
          //this.currentDeposite.amountFromCash = newtotal;
          this.currentDeposite.roundOffAmount = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(newtotal - total).toFixed(2);
        }
      } else {
        this.loanPayment = false;
        this.loanToPay = null;
      }
      this.addDipositDialog = true;
    },
    dayDiff: function dayDiff(dt1, dt2) {
      return Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24));
    },
    getInterest: function getInterest(loan) {
      var dayDiff = this.dayDiff(new Date(loan.interestDate), new Date());
      return this.calculateInterest(loan.amount, loan.interest, dayDiff);
    },
    calculateInterest: function calculateInterest(P, R, N) {
      var interestRate = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(P) * __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(R) / 3000 * N;
      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(interestRate).toFixed(2);
    },
    updateDeposit: function updateDeposit() {
      var key = this.currentDeposite[".key"];
      delete this.currentDeposite[".key"];
      this.currentDeposite.brand = this.selectedBrand;
      this.customer = this.$route.params.customerId;
      this.currentDeposite.date = new Date(this.currentDeposite.date).getTime();
      this.$root.$firebaseRefs.customerDeposit.child(key).set(this.currentDeposite);
      this.currentDeposite = {
        amount: "",
        paymentType: "",
        mortgage: "",
        product: "",
        quantity: 0,
        firm: "",
        transferType: "",
        type: "",
        date: new Date().toISOString().substr(0, 10),
        brand: this.selectedBrand,
        buyerId: this.$route.params.customerId,
        paid: null
      };
      this.addDipositDialog = false;
    },
    editDeposite: function editDeposite(deposit) {
      this.currentDeposite = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(deposit));
      this.currentDeposite.date = new Date(this.currentDeposite.date).toISOString().substr(0, 10);
      this.addDipositDialog = true;
    },
    deleteFromDialog: function deleteFromDialog() {
      this[this.currentPasswordMethod](this.currentPasswordReference);
    },
    deleteDeposit: function deleteDeposit(deposit) {
      var firmSettings = this.firmSettings.find(function (i) {
        return deposit.firm == i['firm'];
      });
      var hasPassword = firmSettings && firmSettings.deleteWithPassword && !!firmSettings.deleteInvoicePassword;
      if (hasPassword && this.password != firmSettings.deleteInvoicePassword && this.passwordDialog) {
        alert("Incorrect Password");
        this.passwordDialog = false;
        this.password = null;
      } else if (hasPassword && !this.passwordDialog) {
        this.passwordDialog = true;
        this.password = null;
        this.currentPasswordReference = deposit;
        this.currentPasswordMethod = "deleteDeposit";
      } else if (window.confirm("Do you want to Delete ?")) {
        this.passwordDialog = false;
        this.password = null;
        this.$root.$firebaseRefs.customerDeposit.child(deposit[".key"]).remove();
        //this.addRemainingBalance();
      }
    }
  }
});

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Sidebar__ = __webpack_require__(1344);
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Sidebar: __WEBPACK_IMPORTED_MODULE_0__Sidebar__["a" /* default */]
  }
});

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      items: [{
        header: 'Settings'
      }, {
        title: 'Brand Management',
        style: 'padding-right: 20px; margin-right: 15px;  font-size:25px',
        subtitle: 'Manage Firm Data, Add Permissions to Staff users',
        icon: 'shopping_basket',
        isMultiple: true,
        children: [{
          title: 'Admin Accounts',
          subtitle: 'Create & Manage User accounts',
          link: 'AdminAccounts',
          icon: 'admin_panel_settings'
        }, { divider: true, inset: true }, {
          title: 'Data Management',
          subtitle: 'Manage your data',
          link: 'DataManagement',
          icon: 'article'
        }, { divider: true, inset: true }, {
          title: 'Product Import',
          subtitle: 'Import your Product',
          link: 'ImportFromExcel',
          icon: 'shopping_basket'
        }, { divider: true, inset: true }, {
          title: 'Customer Import',
          subtitle: 'Import your Customer',
          link: 'ImportCustomerFromExcel',
          icon: 'account_circle'
        }, { divider: true, inset: true }, {
          title: 'Supplier Import',
          subtitle: 'Import your Supplier',
          link: 'ImportSupplierFromExcel',
          icon: 'supervised_user_circle'
        }, { divider: true, inset: true }]
      }, {
        title: 'Firm Management',
        style: 'padding-right: 20px; margin-right: 15px;  font-size:25px',
        subtitle: 'Manage Firms, Branches, Invoices and Print Options',
        icon: 'domain',
        isMultiple: true,
        children: [{
          title: 'Firms',
          subtitle: 'Create & Manage Firm',
          link: 'Firms',
          icon: 'add_task'
        }, { divider: true, inset: true }, {
          title: 'Print Settings',
          subtitle: 'Create and Manage Print Format',
          link: 'Print',
          icon: 'print'
        }, { divider: true, inset: true }, {
          title: 'Invoice Settings',
          subtitle: 'Create Customized Invoice Id',
          link: 'FirmSettings',
          icon: 'note_add'
        }, { divider: true, inset: true }, {
          title: 'Branch Settings',
          subtitle: 'Create & Manage Branch',
          link: 'Branch',
          icon: 'storefront'
        }]
      }, { divider: true, inset: true }, {
        title: 'Bank Account Management',
        subtitle: 'Create & Manage Bank Accounts',
        link: 'Account',
        icon: 'account_balance'
      }, { divider: true, inset: true },
      // {
      //   title: 'Assets Accounts',
      //   subtitle: 'Manage assets',
      //   link: 'Asset',
      //   icon: 'account_balance_wallet'
      // },
      // { divider: true, inset: true },
      // {
      //   title: 'Loan Accounts',
      //   subtitle: 'Manage Loans',
      //   link: 'Loan',
      //   icon: 'account_balance_wallet'
      // },
      // { divider: true, inset: true },
      // {
      //   title: 'Loan & Advances Accounts',
      //   subtitle: 'Manage Loans & Advances',
      //   link: 'Loanadvances',
      //   icon: 'account_balance_wallet'
      // },
      // { divider: true, inset: true },
      {
        title: 'Team Management',
        subtitle: 'Create & Manage Team',
        link: 'Staff',
        icon: 'addchart'
      },
      // { divider: true, inset: true },
      // {
      //   title: 'Print',
      //   subtitle: 'Create and Manage Print Format',
      //   link: 'Print',
      //   icon: 'print'
      // },
      { divider: true, inset: true }, {
        title: 'Product Management',
        style: 'padding-right: 20px; margin-right: 15px;  font-size:25px',
        subtitle: 'Manage Products via Category, Group, Set and Type',
        icon: 'open_with',
        isMultiple: true,
        children: [{
          title: 'Product Category',
          subtitle: 'Create Categories to Differentiate Products',
          link: 'ProductCategory',
          icon: 'category'
        }, { divider: true, inset: true }, {
          title: 'Product Group',
          subtitle: 'Create Groups to Differentiate Products',
          link: 'ProductGroup',
          icon: 'group_work'
        }, { divider: true, inset: true }, {
          title: 'Product Set',
          subtitle: 'Create Multiple Products',
          link: 'ProductSet',
          icon: 'merge_type'
        }, { divider: true, inset: true }, {
          title: 'Product Type',
          subtitle: 'Create Types to Differentiate Products',
          link: 'ProductType',
          icon: 'pie_chart'
        }, { divider: true, inset: true }, {
          title: 'Rate Category',
          subtitle: 'Create Categories to add Multiple Rates',
          link: 'ProductRateCategory',
          icon: 'category'
        }, { divider: true, inset: true }, {
          title: 'Product Unique ID',
          subtitle: 'Add Unique Ids ( HUID | RFID )',
          link: 'ProductUniqueId',
          icon: 'group_work'
        }, { divider: true, inset: true }, {
          title: 'Product Offers',
          subtitle: 'Add Update Product Offers',
          link: 'ProductOffers',
          icon: 'group_work'
        }, { divider: true, inset: true }, {
          title: 'Product Manufacturing',
          subtitle: 'Convert Products for manufacturing',
          link: 'ProductManufacturing',
          icon: 'group_work'
        }, { divider: true, inset: true }, {
          title: 'Product Damage',
          subtitle: 'Remove Damaged product',
          link: 'ProductDamage',
          icon: 'group_work'
        }, { divider: true, inset: true }, {
          title: 'Product Replacement',
          subtitle: 'Product Replacement',
          link: 'ProductReplacement',
          icon: 'group_work'
        }, { divider: true, inset: true }, {
          title: 'Product Repair',
          subtitle: 'Product Repair',
          link: 'ProductRepair',
          icon: 'group_work'
        }, { divider: true, inset: true }, {
          title: 'Product Drawer',
          subtitle: 'Product Drawer',
          link: 'productDrawer',
          icon: 'group_work'
        }]
      },
      // { divider: true, inset: true },
      // {
      //   title: 'Employee Management',
      //   style: 'padding-right: 20px; margin-right: 15px;  font-size:25px',
      //   subtitle: 'Manage Employee Information, Attendance, Reports',
      //   icon: 'group',
      //   isMultiple : true,
      //   children: [
      //     { divider: true, inset: true },
      //     {
      //       title: 'Staff Information',
      //       subtitle: 'Create & Manage Staff',
      //       link: 'HumanResource',
      //       icon: 'support'
      //     },
      //     { divider: true, inset: true },
      //     {
      //       title: 'Staff Attendance',
      //       subtitle: 'Manage Staff Attendance',
      //       link: 'StaffAttendance',
      //       icon: 'support'
      //     },
      //     { divider: true, inset: true },
      //     {
      //       title: 'Payroll Report',
      //       subtitle: 'Create and View Payroll',
      //       link: 'Payroll',
      //       icon: 'support'
      //     },
      //     { divider: true, inset: true },
      //     {
      //       title: 'Letter Head',
      //       subtitle: 'Create Letter Head',
      //       link: 'LetterHead',
      //       icon: 'email'
      //     },
      //     { divider: true, inset: true },
      //     {
      //       title: 'ToDo List',
      //       subtitle: 'Create To Do List',
      //       link: 'Todo',
      //       icon: 'work'
      //     },    
      //   ]
      // },
      { divider: true, inset: true }, {
        title: 'Operational Management',
        style: 'padding-right: 20px; margin-right: 15px;  font-size:25px',
        subtitle: 'Manage Operationals via Lead, Order and Invoice',
        icon: 'list_alt',
        isMultiple: true,
        children: [{
          title: 'Order Management',
          subtitle: 'Create Settings to manage orders',
          link: 'OrderSettings',
          icon: 'content_paste'
        }, { divider: true, inset: true }, {
          title: 'Lead Management',
          subtitle: 'Create Settings to manage leads',
          link: 'LeadSettings',
          icon: 'repeat_on'
        }, { divider: true, inset: true }, {
          title: 'Todo Work Management',
          subtitle: 'Create & Manage Todo List',
          link: 'Todo',
          icon: 'assignment'
        }]
      }, { divider: true, inset: true }, {
        title: 'Store Management',
        style: 'padding-right: 20px; margin-right: 15px;  font-size:25px',
        subtitle: 'Create, Manage and Transfer Product within Godown',
        icon: 'store',
        isMultiple: true,
        children: [{
          title: 'Godown',
          subtitle: 'Create & Manage Godowns',
          link: 'Godawn',
          icon: 'store'
        }, { divider: true, inset: true }, {
          title: 'GodownTransfer',
          subtitle: 'Transfer Products',
          link: 'GodawnBulkTransfer',
          icon: 'group_work'
        }]
      },
      // Start of Transactions:
      // {
      //   title: 'Transactions',
      //   style: 'padding-right: 20px; margin-right: 15px;  font-size:25px',
      //   subtitle: 'Create and Manage Cash Transfer, Bank Account Transfer',
      //   icon: 'shopping_basket',
      //   isMultiple : true,
      //   children: [
      //     {
      //       title: 'Transfer',
      //       subtitle: 'Transfer amount',
      //       link: 'Transfer',
      //       icon: 'admin_panel_settings'
      //      },
      //     { divider: true, inset: true },
      //   ]
      // },
      // Start of Shop Setting:  
      { divider: true, inset: true }, {
        title: 'Image Store Management',
        subtitle: 'Add Images for Product',
        link: 'ShopSettings',
        icon: 'collections'
      }, { divider: true, inset: true }, {
        title: 'Infrastructure Management',
        subtitle: 'Add Edit floors and tables',
        link: 'Infrastructure',
        icon: 'workspaces'
      }]
    };
  }
});

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Filters__ = __webpack_require__(1349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GridView__ = __webpack_require__(1351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Filters: __WEBPACK_IMPORTED_MODULE_1__Filters__["a" /* default */],
    GridView: __WEBPACK_IMPORTED_MODULE_2__GridView__["a" /* default */]
  },
  data: function data() {
    return {
      filters: {},
      reportTab: 0,
      reportType: "sale"
    };
  },

  methods: {
    updateFilters: function updateFilters(filters) {
      this.filters = filters;
    },
    resetTabs: function resetTabs() {
      this.reportType = 'sale';
      this.reportTab = 0;
    }
  },
  created: function created() {
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("firmSettings", this.$root.$firebaseRefs.firmSettings.orderByChild('brand').equalTo(this.selectedBrand));
    if (this.$route.params.reportType) {
      switch (this.$route.params.reportType) {
        case 'purchase':
          {
            this.reportType = "purchase";
            this.reportTab = 1;
            break;
          }
        case 'stock':
          {
            this.reportType = "stock";
            this.reportTab = 2;
            setTimeout(function () {
              document.querySelector(".full-screen-view").click();
            }, 1000);
            break;
          }
        case 'productGroup':
          {
            this.reportType = "productGroup";
            this.reportTab = 3;
            break;
          }
      }
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", 'productUnit']), {
    getDefaultStockReportType: function getDefaultStockReportType() {
      var _this = this;

      var val = 'APP';
      if (this.firms.length) {
        var defaultFirm = this.firms.filter(function (item) {
          return item["brand"] === _this.selectedBrand && !!item["defaultFirm"];
        })[0];
        if (defaultFirm) {
          var dfirmSetting = this.firmSettings.filter(function (item) {
            return item['firm'] == defaultFirm['.key'];
          })[0];
          if (dfirmSetting && dfirmSetting.stockReportView) {
            val = dfirmSetting.stockReportView;
          }
        }
      }
      return val;
    }
  }),
  watch: {
    reportTab: function reportTab(index) {
      switch (index) {
        case 0:
          {
            this.reportType = "sale";
            break;
          }
        case 1:
          {
            this.reportType = "purchase";
            break;
          }
        case 2:
          {
            this.reportType = "stock";
            break;
          }
        case 3:
          {
            this.reportType = "productGroup";
            break;
          }
      }
    }
  }
});

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["reportType", "units", "selectedBrand", "brandFinYear"],
  data: function data() {
    return {
      filters: {
        date: {
          name: 'Date/ From Date',
          model: null,
          type: 'date-range',
          placeholder: 'Select Date',
          options: [{
            text: '',
            value: ''
          }],
          reportType: ["sale", "purchase", "stock", "productGroup"]
        },
        tillDate: {
          name: 'To Date',
          model: null,
          type: 'date-range',
          placeholder: 'Select Date',
          options: [{
            text: '',
            value: ''
          }],
          reportType: ["sale", "purchase", "stock", "productGroup"]
        },
        month: {
          name: 'Month',
          model: null,
          type: 'select',
          placeholder: 'Select Month',
          options: [{
            text: 'January',
            value: 0
          }, {
            text: 'February',
            value: 1
          }, {
            text: 'March',
            value: 2
          }, {
            text: 'April',
            value: 3
          }, {
            text: 'May',
            value: 4
          }, {
            text: 'June',
            value: 5
          }, {
            text: 'July',
            value: 6
          }, {
            text: 'August',
            value: 7
          }, {
            text: 'September',
            value: 8
          }, {
            text: 'October',
            value: 9
          }, {
            text: 'November',
            value: 10
          }, {
            text: 'December',
            value: 11
          }],
          reportType: ["sale", "purchase", "stock", "productGroup"]
        },
        firms: {
          name: 'Firms',
          model: null,
          type: 'select',
          placeholder: 'Select a firm',
          options: [{
            text: '',
            value: ''
          }],
          reportType: ["sale", "purchase", "stock", "productGroup"]
        },
        productGroups: {
          name: 'Product Group',
          model: null,
          type: 'select',
          placeholder: 'Select a Group',
          options: [{
            text: '',
            value: ''
          }],
          reportType: ["stock"]
        },
        stockReportType: {
          name: 'Stock Report Type',
          model: 'quantity',
          type: 'select',
          placeholder: 'Select Type',
          options: [{
            text: 'Quantity',
            value: 'quantity'
          }, {
            text: 'Weight',
            value: 'grossWeight'
          }],
          reportType: []
        },
        paymentType: {
          name: 'Payment Type',
          model: null,
          type: 'select',
          placeholder: 'Select a Item Type',
          options: [{
            text: 'Cash',
            value: 'Cash'
          }, {
            text: 'Bank Account',
            value: 'Bank Account'
          }, {
            text: 'Cash Bank Account',
            value: 'CashAndBank Account'
          }],
          reportType: ["sale", "purchase"]
        },
        invoiceStatus: {
          name: 'Invoice Status Type',
          model: null,
          type: 'select',
          placeholder: 'Select Invoice Status',
          options: [{
            text: 'Due',
            value: 'due'
          }, {
            text: 'Partial',
            value: 'partial'
          }, {
            text: 'Paid',
            value: 'paid'
          }],
          reportType: ["sale", "purchase"]
        },
        invoiceNumber: {
          name: 'Invoice Number',
          model: null,
          type: 'search',
          input: null,
          placeholder: 'Search for Invoice',
          options: [{
            text: '',
            value: ''
          }],
          reportType: ["sale", "purchase"]
        },
        buyerName: {
          name: 'Person Name',
          model: null,
          type: 'search',
          input: null,
          placeholder: 'Search by Buyer name',
          options: [{
            text: '',
            value: ''
          }],
          reportType: ["sale", "purchase", "stock"]
        },
        gstPercentage: {
          name: 'GST %',
          model: null,
          type: 'select',
          placeholder: 'Select GST %',
          options: [0, 5, 12, 18, 28],
          reportType: ["sale", "purchase", "stock", "productGroup"]
        },
        // isActive: {
        //   name: 'Status',
        //   model: null,
        //   type: 'select',
        //   placeholder: 'Select Status',
        //   options: ["Active", "Inactive"],
        //   reportType : ["sale","purchase","stock", "productGroup"]
        // },
        gstType: {
          name: 'GST Type',
          model: null,
          type: 'select',
          placeholder: 'Select Type',
          options: ["SGST|CGST", "IGST"],
          reportType: ["sale", "purchase"]
        },
        gstCategory: {
          name: 'GST Category',
          model: null,
          type: 'select',
          placeholder: 'GST Category',
          options: [{
            text: "Exempt",
            value: "EXEMPT"
          }, {
            text: "Nil Rated",
            value: "NILL"
          }, {
            text: "Taxable",
            value: "TAXABLE"
          }, {
            text: "Others",
            value: "OTHER"
          }],
          reportType: ["sale", "purchase", "stock", "productGroup"]
        },
        isActive: {
          name: 'Product Status',
          model: null,
          type: 'select',
          placeholder: 'Product Status',
          options: [{
            text: "Active",
            value: true
          }, {
            text: "Inactive",
            value: false
          }],
          reportType: ["sale", "purchase", "stock", "productGroup"]
        },
        unit: {
          name: 'Units',
          model: null,
          type: 'select',
          placeholder: 'Units',
          options: this.getUnits(),
          reportType: ["sale", "purchase", "stock", "productGroup"]
        },
        quantity: {
          name: 'Quantity',
          model: null,
          type: 'number-range',
          label: 'Quantity',
          min: 0,
          max: 5000,
          reportType: ["sale", "purchase", "stock", "productGroup"]
        },
        hsnCode: {
          name: 'HSN Code',
          model: null,
          type: 'search',
          input: null,
          placeholder: 'Search for HSN code',
          options: [{
            text: '',
            value: ''
          }],
          reportType: ["sale", "purchase", "stock", "productGroup"]
        },
        duration: {
          name: 'Duration',
          model: null,
          type: 'number-range',
          label: 'Duration',
          min: 0,
          max: 200,
          reportType: ["sale", "purchase"]
        },
        openingQuantity: {
          name: 'Opening Quantity',
          model: null,
          type: 'number-range',
          label: 'Opening Quantity',
          min: 0,
          max: 5000,
          reportType: ["stock", "productGroup"]
        },
        saleQuantity: {
          name: 'Sale Quantity',
          model: null,
          type: 'number-range',
          label: 'Sale Quantity',
          min: 0,
          max: 5000,
          reportType: ["stock", "productGroup"]
        },
        purchaseQuantity: {
          name: 'Purchase Quantity',
          model: null,
          type: 'number-range',
          label: 'Purchase Quantity',
          min: 0,
          max: 5000,
          reportType: ["stock", "productGroup"]
        },
        village: {
          name: 'Village',
          model: null,
          type: 'search',
          input: null,
          placeholder: 'Search by Village Name',
          options: [{
            text: '',
            value: ''
          }],
          reportType: ["sale", "purchase"]
        },
        block: {
          name: 'Block',
          model: null,
          type: 'search',
          input: null,
          placeholder: 'Search by Block Name',
          options: [{
            text: '',
            value: ''
          }],
          reportType: ["sale", "purchase"]
        },
        tehsil: {
          name: 'Tehsil',
          model: null,
          type: 'search',
          input: null,
          placeholder: 'Search by Tehsil Name',
          options: [{
            text: '',
            value: ''
          }],
          reportType: ["sale", "purchase"]
        },
        district: {
          name: 'District',
          model: null,
          type: 'search',
          input: null,
          placeholder: 'Search by District Name',
          options: [{
            text: '',
            value: ''
          }],
          reportType: ["sale", "purchase"]
        },
        state: {
          name: 'State',
          model: null,
          type: 'search',
          input: null,
          placeholder: 'Search by State Name',
          options: [{
            text: '',
            value: ''
          }],
          reportType: ["sale", "purchase"]
        }
      },
      firms: [],
      invoices: [],
      buyers: [],
      sellers: [],
      products: [],
      productGroups: []
    };
  },
  created: function created() {
    this.$bindAsArray('firms', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('buyers', this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('sellers', this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('invoices', this.$root.$firebaseRefs.invoice.orderByChild('brandFinYear').equalTo(this.brandFinYear)), this.$bindAsArray('products', this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('productGroups', this.$root.$firebaseRefs.productGroup.orderByChild('brand').equalTo(this.selectedBrand));
  },

  watch: {
    firms: function firms(val) {
      var _this = this;

      val.map(function (firm) {
        if (firm.defaultFirm) {
          _this.filters.firms.model = firm['.key'];
          if (firm.businessType == 'Jwellery') {
            _this.filters.stockReportType.model = 'weight';
          }
        }
      });
      this.mapFilterOptions(val, 'firms', 'name', '.key');
    },
    productGroups: function productGroups(val) {
      this.mapFilterOptions(val, 'productGroups', 'name', '.key');
    },
    invoices: function invoices(val) {
      this.mapFilterOptions(val, 'invoiceNumber', 'invoiceId', '.key');
    },
    buyers: function buyers(val) {
      this.handleBuyerSeller();
    },
    selectedBrand: function selectedBrand(val) {
      this.mapFilterOptions(this.firms, 'firms', 'name', '.key');
      this.handleBuyerSeller();
      this.mapFilterOptions(this.invoices, 'invoiceNumber', '.key', '.key');
      this.mapFilterOptions(this.products, 'hsnCode', 'HSN_code', 'HSN_code');
    },
    products: function products(val) {
      this.mapFilterOptions(this.products, 'hsnCode', 'HSN_code', 'HSN_code');
    },

    filters: {
      handler: function handler(val) {
        this.$emit('update', val);
      },
      deep: true
    },
    reportType: function reportType(val) {
      this.handleBuyerSeller();
    }
  },

  methods: {
    mapFilterOptions: function mapFilterOptions(array, filterLabel, textLabel, valLabel) {
      var _this2 = this;

      if (this.selectedBrand && array) {
        var result = array.filter(function (item) {
          return item['brand'] === _this2.selectedBrand;
        }).map(function (item) {
          return {
            text: item[textLabel],
            value: item[valLabel]
          };
        });
        this.filters[filterLabel].options = result;
      }
    },
    getUnits: function getUnits() {
      return this.units;
    },
    mapFilterRange: function mapFilterRange(filterLabel, max, min) {},
    clearFilter: function clearFilter() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.filters).forEach(function (key) {
        if (key != 'stockReportType' || key != 'firms') {
          _this3.filters[key]['model'] = null;
        }
      });
      this.$emit('resetTabs');
    },
    handleBuyerSeller: function handleBuyerSeller() {
      switch (this.reportType) {
        case 'sale':
          {
            this.filters.buyerName = {
              name: 'Buyer Name',
              model: null,
              type: 'search',
              input: null,
              placeholder: 'Search by Buyer name',
              options: [{
                text: '',
                value: ''
              }],
              reportType: ["sale", "purchase", "stock"]
            };
            this.filters.state.options = [{
              text: '',
              value: ''
            }];
            this.filters.district.options = [{
              text: '',
              value: ''
            }];
            this.filters.tehsil.options = [{
              text: '',
              value: ''
            }];
            this.filters.block.options = [{
              text: '',
              value: ''
            }];
            this.filters.village.options = [{
              text: '',
              value: ''
            }];
            this.mapFilterOptions(this.buyers, 'state', 'state', 'state');
            this.mapFilterOptions(this.buyers, 'district', 'district', 'district');
            this.mapFilterOptions(this.buyers, 'tehsil', 'tehsil', 'tehsil');
            this.mapFilterOptions(this.buyers, 'block', 'block', 'block');
            this.mapFilterOptions(this.buyers, 'village', 'village', 'village');
            this.mapFilterOptions(this.buyers, 'buyerName', 'name', '.key');
            break;
          }
        case 'purchase':
          {
            this.filters.buyerName = {
              name: 'Seller Name',
              model: null,
              type: 'search',
              input: null,
              placeholder: 'Search by Seller name',
              options: [{
                text: '',
                value: ''
              }],
              reportType: ["sale", "purchase", "stock"]
            };
            this.filters.state.options = [{
              text: '',
              value: ''
            }];
            this.filters.district.options = [{
              text: '',
              value: ''
            }];
            this.filters.tehsil.options = [{
              text: '',
              value: ''
            }];
            this.filters.block.options = [{
              text: '',
              value: ''
            }];
            this.filters.village.options = [{
              text: '',
              value: ''
            }];
            this.mapFilterOptions(this.sellers, 'state', 'state', 'state');
            this.mapFilterOptions(this.sellers, 'district', 'district', 'district');
            this.mapFilterOptions(this.sellers, 'tehsil', 'tehsil', 'tehsil');
            this.mapFilterOptions(this.sellers, 'block', 'block', 'block');
            this.mapFilterOptions(this.sellers, 'village', 'village', 'village');
            this.mapFilterOptions(this.sellers, 'buyerName', 'name', '.key');
            break;
          }
      }
    }
  }
});

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_number_parse_int__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_pdf_reports_stocks_reports__ = __webpack_require__(1358);










//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_10_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["filters", "reportType", 'selectedClosingStockType'],
  data: function data() {
    return {
      headers: [{ text: "Products", value: "action" }, { text: "Date", value: "date", sortable: true },
      // { text: "Invoice-Key", value: "Name" },
      { text: "Buyer Name", value: "Father Name" }, { text: "Invoice ID", value: "Block" }, { text: "Total Amount", value: "totalCurrentAmount" }, { text: "Basic Amount", value: "basic" }, { text: "GST", value: "GST" }, { text: "Discount", value: "totalCurrentAmount" }, { text: "Paid Amount", value: "Tehsil" }, { text: "Due Amount", value: "District" }, { text: "Duration (in Days)", value: "abs" }, { text: "Days Left", sortable: true, value: "daysLeft" }, { text: "Payment Type", value: "Identity Number" }, { text: "Status", value: "Mobile" }, { text: "GST type", value: "gst type" },
      // { text: "Transaction Type", sortable: true, value: "paymentType" },
      { text: "Mobile", value: "mobile" },
      // { text: "Village", value: "village" },
      // { text: "Block", value: "block" },
      { text: "Tehsil", value: "tehsil" }, { text: "District", value: "district" }, { text: "State", value: "state" }, { text: "Firm Name", value: "Village" }],
      productListHeader: [{ text: "Invoices", value: "action" }, { text: "Name, Description, HSN, GST type, Rate, Unit", value: "Name" }, { text: "Quantity", value: "quantity" }, { text: "Duration quantity", value: "quantity" }, { text: "Amount", value: "quantity" }, { text: "Opening Quantity", value: "quantity" }, { text: "Sale Quantity", value: "quantity" }, { text: "Duration Sale quantity", value: "quantity" }, { text: "Sale Amount", value: "quantity" }, { text: "Purchase Quantity", value: "quantity" }, {
        text: "Duration Purchase quantity",
        value: "quantity"
      }, { text: "Purchase Amount", value: "quantity" }],

      productItemListHeader: [{ text: "Invoices", value: "action" }, { text: "Date", value: "Name" }, { text: "Amount", value: "quantity" }, { text: "Opening Quantity", value: "quantity" }, { text: "Sale Quantity", value: "quantity" }, { text: "Duration Sale quantity", value: "quantity" }, { text: "Sale Amount", value: "quantity" }, { text: "Purchase Quantity", value: "quantity" }, { text: "Duration Purchase quantity", value: "quantity" }, { text: "Purchase Amount", value: "quantity" }],
      invoiceProductListHeader: [{ text: "Product Name", value: "productName" }, { text: "HSN code", value: "HSN" }, { text: "Product rate", value: "rate" }, { text: "GST %", value: "GST Rate" }, { text: "Unit", value: "Unit" }, { text: "Quantity", value: "quantity" }],
      firms: {},
      search: null,
      buyerById: {},
      selectedInvoice: {},
      dialog: false,
      selectedProdInvoices: [],
      selectProdList: [],
      prodListDialog: false,
      selectedProduct: {},
      dialogInvoice: false,
      dialogStockReports: false
    };
  },
  created: function created() {
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("firms", this.$root.$firebaseRefs.firm);
    this.$bindAsObject("buyerById", this.$root.$firebaseRefs.buyer);
    this.$bindAsObject("sellerById", this.$root.$firebaseRefs.seller);
    this.$bindAsArray("productList", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('productGroups', this.$root.$firebaseRefs.productGroup.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('productMenufs', this.$root.$firebaseRefs.productManufactureTransaction.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('productDmg', this.$root.$firebaseRefs.productDamageTransaction.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('productRep', this.$root.$firebaseRefs.productReplaceTransaction.orderByChild('brand').equalTo(this.selectedBrand));
  },

  methods: {
    getClosingAmount: function getClosingAmount(item) {
      var closingQty = item['closingQuantity'];
      switch (this.selectedClosingStockType) {

        case 'APP':
          {
            var avgPurchasePrice = item.stockReportData.purchaseDetails.length ? item.stockReportData.purchaseDetails.reduce(function (a, b) {
              return a + (b['rate'] || 0);
            }, 0) / item.stockReportData.purchaseDetails.length : 0;
            return avgPurchasePrice * closingQty;
          }
        case 'LPP':
          {
            return item.stockReportData.lastPurchasePrice * closingQty;
          }
        case 'LSP':
          {
            return item.stockReportData.lastSalePrice * closingQty;
          }
        case 'ASP':
          {
            var avgSalePrice = item.stockReportData.saleDetails.reduce(function (a, b) {
              return a + (b['rate'] || 0);
            }, 0) / item.stockReportData.saleDetails.length;
            return avgSalePrice * closingQty;
          }
        case 'FIFO':
          {

            var allTransaction = item.stockReportData.purchaseDetails.sort(function (a, b) {
              return -(new Date(b.date) - new Date(a.date));
            });
            var amount = 0;
            var qntTemp = closingQty;
            allTransaction.map(function (t) {
              if (qntTemp > t.quantity) {
                amount += t.quantity * t.rate;
                qntTemp = qntTemp - t.quantity;
              } else if (qntTemp > 0) {
                amount += t.quantity - qntTemp * t.rate;
                qntTemp = 0;
              }
            });
            return amount;
          }
        case 'LIFO':
          {
            var _allTransaction = item.stockReportData.purchaseDetails.sort(function (a, b) {
              return new Date(b.date) - new Date(a.date);
            });
            var _amount = 0;
            var _qntTemp = closingQty;
            _allTransaction.map(function (t) {
              if (_qntTemp > t.quantity) {
                _amount += t.quantity * t.rate;
                _qntTemp = _qntTemp - t.quantity;
              } else if (_qntTemp > 0) {
                _amount += t.quantity - _qntTemp * t.rate;
                _qntTemp = 0;
              }
            });
            return _amount;
          }
      }
    },
    renderDate: function renderDate(timeStamp) {
      if (timeStamp) {
        return new Date(timeStamp).toLocaleDateString("en-GB");
      }
      return "--";
    },
    printStockReports: function printStockReports() {
      var htmlToArray = function htmlToArray(tableElement) {
        var thead = tableElement.querySelector("thead");
        var tbody = tableElement.querySelector("tbody");
        // Assumes there's only one header row
        var columns = thead.querySelectorAll("tr th");
        var columnNames = [];
        columns.forEach(function (c) {
          return columnNames.push(c.innerText);
        });
        var result = [];
        var bodyRows = tbody.querySelectorAll("tr");
        bodyRows.forEach(function (r) {
          var tds = r.querySelectorAll("td");
          var arr = [];
          tds.forEach(function (td, idx) {
            arr.push(td.innerText);
          });
          result.push(arr);
        });
        return result;
      };
      var table = document.querySelector(".stocks-reports");
      var invoices = htmlToArray(table);
      var doc = Object(__WEBPACK_IMPORTED_MODULE_11__utils_pdf_reports_stocks_reports__["a" /* convertToPDFStockReport */])({
        invoiceData: invoices,
        firm: this.filters.firms.model ? this.getFirmName(this.filters.firms.model) : '',
        fromDate: this.filters.date.model ? new Date(this.filters.date.model).toLocaleDateString('en-GB') : '',
        toDate: this.filters.tillDate.model ? new Date(this.filters.tillDate.model).toLocaleDateString('en-GB') : ''
      });
      pdfMake.createPdf(doc).download('Stock Register');
    },
    getFilteredQuantity: function getFilteredQuantity(product, qty) {
      var quantity = qty;
      var string = "";
      product.unitsDetails.sort(function (a, b) {
        return b.order - a.order;
      });
      for (var i = 0; i < product.unitsDetails.length; i++) {
        if (quantity > __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(product.unitsDetails[i].quantity) && i + 1 < product.unitsDetails.length) {
          var temp = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(quantity) % __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(product.unitsDetails[i].quantity);
          var temp1 = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(quantity) / __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(product.unitsDetails[i].quantity);
          string = "(" + temp + " " + product.unitsDetails[i].unit + ") " + string;
          quantity = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_number_parse_int___default()(temp1.toString().split(".")[0]);
        } else {
          string = "(" + quantity + " " + product.unitsDetails[i].unit + ") " + string;
          break;
        }
      }
      console.log(string);
      return string;
    },

    // productListByBrand() {
    //   return this.productList.filter(
    //     item => {
    //       return (item["brand"] === this.selectedBrand && 
    //       (item.openingDate ? (item.openingDate >= this.finYear.start) && (item.openingDate <= this.finYear.end) : true) &&
    //       (!!this.search ? !!item["name"].toLowerCase().includes(this.search.toLowerCase()) : true))
    //     }
    //   );
    // },
    keymonitor: function keymonitor(event) {
      this.search = event.target.value;
    },
    getFirmName: function getFirmName(firmId) {
      if (this.firms && this.firms[firmId]) {
        return this.firms[firmId]["name"];
      }
      return "--";
    },
    getCustomerName: function getCustomerName(id) {
      var buyer = this.buyerById[id];
      var seller = this.sellerById[id];
      return buyer ? buyer.name : seller.name;
    },
    openProd: function openProd(invoice) {
      this.selectedInvoice = invoice;
      this.dialog = true;
    },
    openProdInvoice: function openProdInvoice(product) {
      this.selectedProdInvoices = [product.invoice];
      this.dialogInvoice = true;
    },
    openProdItems: function openProdItems(product) {
      var _this = this;

      this.selectProdList = product.productList ? __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_array_from___default()(product.productList) : [];
      this.selectProdList.sort(function (a, b) {
        return -(new Date(b.date) - new Date(a.date));
      });
      this.selectedProduct = product;
      // let total = {
      //   date : 'Total',
      //   openingQuantity :0,
      //   openingBalance : 0,
      //   quantitySale : 0,
      //   quantityPurchase : 0,
      //   balanceSale : 0,
      //   balancePurchase : 0 ,
      //   quantityClosing : 0,
      //   balanceCloseing : 0
      // };
      var isQuantity = this.filters.stockReportType.model == 'quantity';
      this.selectProdList.map(function (product, index) {
        _this.selectProdList[index]['openingQuantity'] = index == 0 ? product['openingQuantity'] : _this.selectProdList[index - 1]['quantityClosing'];
        //total['openingQuantity'] += parseInt(this.selectProdList[index]['openingQuantity']);

        _this.selectProdList[index]['openingBalance'] = index == 0 ? product['openingBalance'] : _this.selectProdList[index - 1]['balanceCloseing'];
        // total['openingBalance'] += Number.parseFloat(this.selectProdList[index]['openingBalance']);

        _this.selectProdList[index]['quantitySale'] = product.isBuyer ? isQuantity ? product['quantity'] : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(product['netWeight']).toFixed(3) : 0;
        //total['quantitySale'] +=  parseInt(this.selectProdList[index]['quantitySale']);

        _this.selectProdList[index]['quantityPurchase'] = !product.isBuyer ? isQuantity ? product['quantity'] : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(product['netWeight']).toFixed(3) : 0;
        //total['quantityPurchase'] +=  parseInt(this.selectProdList[index]['quantityPurchase']);

        _this.selectProdList[index]['balanceSale'] = product.isBuyer ? (__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(product['basicPrice']) + __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(product['GSTValue'])).toFixed(2) : 0;
        //total['balanceSale'] += isNaN(Number.parseFloat(this.selectProdList[index]['balanceSale'])) ? 0 : Number.parseFloat(this.selectProdList[index]['balanceSale']);

        _this.selectProdList[index]['balancePurchase'] = !product.isBuyer ? (__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(product['basicPrice']) + __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(product['GSTValue'])).toFixed(2) : 0;
        //total['balancePurchase'] += isNaN(Number.parseFloat(this.selectProdList[index]['balancePurchase'])) ? 0 : Number.parseFloat(this.selectProdList[index]['balancePurchase']);

        _this.selectProdList[index]['quantityClosing'] = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_number_parse_int___default()(product['openingQuantity']) + __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(product.isBuyer ? -(isQuantity ? product['quantity'] : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(product['netWeight']).toFixed(3)) : isQuantity ? product['quantity'] : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(product['netWeight']))).toFixed(3);
        //total['quantityClosing'] +=  parseInt(this.selectProdList[index]['quantityClosing']);

        _this.selectProdList[index]['balanceCloseing'] = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(product['openingBalance']) + (product.isBuyer ? -(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(product['basicPrice']) + __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(product['GSTValue'])) : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(product['basicPrice']) + __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(product['GSTValue']));
        //total['balanceCloseing'] += Number.parseFloat(this.selectProdList[index]['balanceCloseing']);
      });

      // this.selectProdList.push(total)
      this.prodListDialog = true;
      if (product.openingDate && product.openingQuantity) {
        if (this.filters.tillDate.model && this.filters.date.model) {
          var fromDate = new Date(this.filters.date.model.split("-")).getTime();
          var tillDate = new Date(this.filters.tillDate.model.split("-")).getTime();
          var itemDate = new Date(product.openingDate).getTime();

          if (fromDate <= itemDate && tillDate >= itemDate) {
            this.selectProdList.splice(0, 0, {
              date: product.openingDate,
              openingQuantity: product.openingQuantity,
              openingBalance: product.openingBalance,
              quantitySale: 0,
              quantityPurchase: 0,
              balanceSale: 0,
              balancePurchase: 0,
              quantityClosing: 0,
              balanceCloseing: 0
            });
          }
        }
      }
    }
  },

  watch: {
    filters: function filters(val) {},
    reportType: function reportType(val) {
      if (val == "sale") {
        this.headers.splice(2, 1, { text: "Buyer Name", value: "Father Name" });
      } else if (val == "purchase") {
        this.headers.splice(2, 1, {
          text: "Seller Name",
          value: "Father Name"
        });
      }
    },
    dialogStockReports: function dialogStockReports(val) {
      if (val) {
        setTimeout(function () {
          document.querySelector('.product-report-search input').click();
        }, 500);
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear", "stockReportTypes", "brandFinYear"]), {
    invoiceList: function invoiceList() {
      var _this2 = this;

      var result = [];
      if (this.invoices) {
        var filteredInvoices = this.invoices.filter(function (item) {
          // return item["brand"] === this.selectedBrand;
          return item["brand"] === _this2.selectedBrand && item.deleted != true;
          // && (item.date >= this.finYear.start) 
          // && (item.date <= this.finYear.end))
        });
        filteredInvoices.forEach(function (element) {
          if (element.items) {
            var GSTTotal = 0;
            element.items.map(function (item) {
              GSTTotal += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
            });
            element["GSTTotal"] = GSTTotal;
          }
          var localDate = new Date(element["date"]);
          var dt2 = new Date();
          var dt1 = localDate;
          var daysSpent = Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24));

          element["dateCompare"] = new Date(element["date"]).toLocaleDateString("en-GB");
          element["closedDate"] = element["closedDate"] ? new Date(element["closedDate"]).toLocaleDateString("en-GB") : null;
          element["daysLeft"] = element["duration"] - daysSpent;
          element["duration"] = daysSpent;
          var rate = element["rate"] * 12 / 100;
          var time = element["duration"] / 365;
          var principal = element["totalAmount"];
          var amount = principal * (1 + rate * time);
          element["interestValue"] = (amount - element["totalAmount"]).toFixed(2);
          element["totalValue"] = amount.toFixed(2);
          time = daysSpent / 365;
          amount = principal * (1 + rate * time);
          element["currentInterestValue"] = (amount - element["totalAmount"]).toFixed(2);
          element["currentTotalValue"] = amount.toFixed(2);

          var firm = _this2.firms[element["firm"]];
          if (_this2.firms[element["firm"]]) {
            element["firmName"] = firm["name"];
          } else {
            element["firmName"] = "--";
          }

          if (element["isBuyer"] == true && _this2.reportType == "sale") {
            var buyerId = element["buyerId"];
            var buyer = _this2.buyerById[buyerId];

            if (buyer) {
              element["buyerName"] = buyer["name"] || "-";
              element["propName"] = buyer["propName"] || "-";
              element["village"] = buyer["village"] || "-";
              element["block"] = buyer["block"] || "-";
              element["mobile"] = buyer["mobile"] || "-";
              element["state"] = buyer["state"] || "-";
              element["district"] = buyer["district"] || "-";
              element["tehsil"] = buyer["tehsil"] || "-";
            }
            result.push(element);
          }

          if (element["isBuyer"] == false && _this2.reportType == "purchase") {
            var sellerID = element["buyerId"];
            var seller = _this2.sellerById[sellerID];

            if (seller) {
              element["buyerName"] = seller["name"] || "-";
              element["propName"] = seller["propName"] || "-";
              element["village"] = seller["village"] || "-";
              element["block"] = seller["block"] || "-";
              element["mobile"] = seller["mobile"] || "-";
              element["state"] = seller["state"] || "-";
              element["district"] = seller["district"] || "-";
              element["tehsil"] = seller["tehsil"] || "-";
            }
            result.push(element);
          }
        });
      }
      return result;
    },

    // productListByBrand() {
    //   return this.productList.filter(
    //     item => (item["brand"] === this.selectedBrand &&        
    //     (item.openingDate ? (item.openingDate >= this.finYear.start) && (item.openingDate <= this.finYear.end) : true))
    //   );
    // },
    productListByBrand: function productListByBrand() {
      var _this3 = this;

      return this.productList.filter(function (item) {
        return item["brand"] === _this3.selectedBrand && (
        // (item.openingDate ? (item.openingDate >= this.finYear.start) && (item.openingDate <= this.finYear.end) : true) &&
        !!_this3.search ? !!item["name"].toLowerCase().includes(_this3.search.toLowerCase()) : true);
      });
    },
    filteredProduct: function filteredProduct() {
      var _this4 = this;

      var products = this.productListByBrand.filter(function (item) {
        if (!__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(_this4.filters).length) {
          return true;
        }

        if (_this4.filters.gstPercentage.model) {
          if (_this4.filters.gstPercentage.model !== item["taxableGST_rate"]) {
            return false;
          }
        } else if (_this4.filters.gstPercentage.model == 0) {
          if (_this4.filters.gstPercentage.model !== item["taxableGST_rate"]) {
            return false;
          }
        }

        if (_this4.filters.firms.model) {
          if (_this4.filters.firms.model !== item["firm"]) {
            return false;
          }
        }

        if (_this4.filters.productGroups.model) {
          if (_this4.filters.productGroups.model !== item["productGroup"]) {
            return false;
          }
        }

        if (_this4.filters.isActive.model) {
          if (_this4.filters.isActive.model !== item["isActive"]) {
            return false;
          }
        }

        if (_this4.filters.gstCategory.model) {
          if (_this4.filters.gstCategory.model !== item["GST_type"]) {
            return false;
          }
        }

        if (_this4.filters.unit.model) {
          if (_this4.filters.unit.model !== item["unit"]) {
            return false;
          }
        }

        if (_this4.filters.hsnCode.model) {
          if (_this4.filters.hsnCode.model !== item["HSN_code"]) {
            return false;
          }
        }

        if (_this4.filters.quantity.model) {
          if (item["quantity"] >= _this4.filters.quantity.model) {
            return true;
          } else {
            return false;
          }
        }

        if (_this4.filters.openingQuantity.model) {
          if (item["openingQuantity"] >= _this4.filters.openingQuantity.model) {
            return true;
          } else {
            return false;
          }
        }

        if (_this4.filters.saleQuantity.model) {
          if (item["saleQuantity"] >= _this4.filters.saleQuantity.model) {
            return true;
          } else {
            return false;
          }
        }

        if (_this4.filters.purchaseQuantity.model) {
          if (item["purchaseQuantity"] >= _this4.filters.purchaseQuantity.model) {
            return true;
          } else {
            return false;
          }
        }
        return true;
      });
      var total = {
        quantity: 0,
        durationQuantity: 0,
        durationAmount: 0,
        saleQuantity: 0,
        durationQtySale: 0,
        durationAmountSale: 0,
        purchaseQuantity: 0,
        durationQtyPurchase: 0,
        durationAmountPurchase: 0,
        openingQuantity: 0,
        openingBalance: 0,
        closingAmount: 0,
        closingQuantity: 0
      };
      products.map(function (p) {
        p["durationQuantity"] = undefined;
        p["durationAmount"] = 0;
        p["durationQtySale"] = 0;
        p["durationQtyPurchase"] = 0;
        p["durationAmountSale"] = 0;
        p["durationAmountPurchase"] = 0;
        p["closingAmount"] = 0;
        p["closingQuantity"] = 0;
        p["stockReportData"] = {
          saleDetails: [],
          purchaseDetails: [],
          lastSalePrice: 0,
          lastPurchasePrice: 0
        };
        if (p.openingBalance && p.openingQuantity) {
          p["stockReportData"]['purchaseDetails'].push({
            quantity: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_number_parse_int___default()(p.openingQuantity),
            rate: __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(p.openingBalance) / __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_number_parse_int___default()(p.openingQuantity),
            date: p.openingDate
          });
          p["stockReportData"]['lastPurchasePrice'] = p.openingBalance;
        }
        total.openingQuantity += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(p["openingQuantity"] ? p["openingQuantity"] : 0);
        total.openingBalance += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(p["openingBalance"] ? p["openingBalance"] : 0);
      });
      var productGroup = products.reduce(function (r, a) {
        r[a[".key"]] = r[a[".key"]] || [];
        r[a[".key"]].push(a);
        return r;
      }, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(null));
      __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(productGroup).forEach(function (key) {
        productGroup[key][0]['productList'] = [];
      });
      var latestSaleDate = new Date('01-01-1000').getTime();
      var latestPurchaseDate = new Date('01-01-1000').getTime();
      var filteredInvoices = this.invoices.filter(function (item) {

        if (!__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(_this4.filters).length) {
          return true;
        }

        if (item.type == "automatic invoice") {
          return false;
        }

        if (!item.items || !item.items.length) {
          return false;
        }

        if (item.deleted) {
          return false;
        }

        if (_this4.filters.tillDate.model && _this4.filters.date.model) {
          var fromDate = new Date(_this4.filters.date.model.split("-")).getTime();
          var tillDate = new Date(_this4.filters.tillDate.model.split("-")).getTime();
          var itemDate = new Date(item["date"]).getTime();

          if (fromDate > itemDate || tillDate < itemDate) {
            return false;
          }
        } else if (_this4.filters.date.model) {
          var _filters$date$model$s = _this4.filters.date.model.split("-"),
              _filters$date$model$s2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_filters$date$model$s, 3),
              year = _filters$date$model$s2[0],
              month = _filters$date$model$s2[1],
              day = _filters$date$model$s2[2];

          var date = day + "/" + month + "/" + year;
          if (item["dateCompare"] !== date) {
            return false;
          }
        }

        if (!item["date"]) {
          return false;
        }

        if (_this4.filters.month.model) {
          var _month = _this4.filters.month.model;
          if (!(new Date(item["date"]).getMonth() == _month)) {
            return false;
          }
        }

        if (_this4.filters.duration.model) {
          if (item["duration"] >= _this4.filters.duration.model) {
            return true;
          } else {
            return false;
          }
        }

        if (_this4.filters.firms.model) {
          if (_this4.filters.firms.model !== item["firm"]) {
            return false;
          }
        }

        if (_this4.filters.gstType.model) {
          if (_this4.filters.gstType.model !== item["gstType"]) {
            return false;
          }
        }

        // if (this.filters.amount.model) {
        //   if (item["totalValue"] >= this.filters.amount.model) {
        //     return true;
        //   } else {
        //     return false;
        //   }
        // }
        // if (this.filters.duration.model) {
        //   if (item["duration"] >= this.filters.duration.model) {
        //     return true;
        //   } else {
        //     return false;
        //   }
        // }

        // if (this.filters.rate.model) {
        //   if (this.filters.rate.model !== item["rate"]) {
        //     return false;
        //   }
        // }

        if (_this4.filters.paymentType.model) {
          if (item["paymentType"] === _this4.filters.paymentType.model) {
            return true;
          } else {
            return false;
          }
        }
        if (_this4.filters.invoiceStatus.model) {
          if (item["status"] === _this4.filters.invoiceStatus.model) {
            return true;
          } else {
            return false;
          }
        }

        if (_this4.filters.invoiceNumber.model) {
          if (item[".key"] !== _this4.filters.invoiceNumber.model) {
            return false;
          }
        }

        if (_this4.filters.buyerName.model) {
          if (item["buyerId"] !== _this4.filters.buyerName.model) {
            return false;
          }
        }

        if (_this4.filters.gstPercentage.model) {
          if (!item.items.find(function (p) {
            return p["taxableGST_rate"] === _this4.filters.gstPercentage.model;
          })) {
            return false;
          }
        }

        if (_this4.filters.gstCategory.model) {
          if (!item.items.find(function (p) {
            return p["GST_type"] === _this4.filters.gstCategory.model;
          })) {
            return false;
          }
        }

        if (_this4.filters.isActive.model) {
          if (!item.items.find(function (p) {
            return p["isActive"] === _this4.filters.isActive.model;
          })) {
            return false;
          }
        }

        if (_this4.filters.hsnCode.model && item.items) {
          if (!item.items.find(function (p) {
            return p["HSN_code"] == _this4.filters.hsnCode.model;
          })) {
            return false;
          }
        }

        if (_this4.filters.unit.model) {
          if (!item.items.find(function (p) {
            return p["productUnit"] === _this4.filters.unit.model;
          })) {
            return false;
          }
        }

        if (_this4.filters.quantity.model) {
          if (item.items.find(function (p) {
            return p["quantity"] >= _this4.filters.quantity.model;
          })) {
            return true;
          } else {
            return false;
          }
        }

        // if (this.filters.gstPercentage.model) {
        //   // if (item["buyerId"] !== this.filters.buyerName.model) {
        //   //   return false;
        //   // }
        // }
        return true;
      });
      this.selectProdList = [];

      this.productMenufs.map(function (pmf) {
        //let product = this.productListByBrand.find(item => item['.key'] == pmf.productId);
        filteredInvoices.push({
          isBuyer: false,
          date: pmf.date,
          type: 'menufacture',
          items: [{
            productId: pmf.productId,
            quantity: pmf.quantity,
            basicPrice: 0,
            GSTValue: 0,
            type: 'menufacture'

          }]
        });
        pmf.rawMaterials.map(function (raw) {
          filteredInvoices.push({
            isBuyer: true,
            date: pmf.date,
            type: 'menufacture',
            items: [{
              productId: raw.productId,
              quantity: raw.quantity,
              basicPrice: 0,
              GSTValue: 0,
              type: 'menufacture'

            }]
          });
        });
      });
      this.productDmg.map(function (pmf) {
        //let product = this.productListByBrand.find(item => item['.key'] == pmf.productId);
        filteredInvoices.push({
          isBuyer: true,
          date: pmf.date,
          type: 'damage',
          items: [{
            productId: pmf.productId,
            quantity: pmf.quantity,
            basicPrice: 0,
            GSTValue: 0,
            type: 'damage'

          }]
        });
      });

      this.productRep.map(function (pmf) {
        filteredInvoices.push({
          isBuyer: true,
          date: pmf.date,
          type: 'replace',
          items: [{
            productId: pmf.productId,
            quantity: pmf.quantity,
            basicPrice: 0,
            GSTValue: 0,
            type: 'replace'

          }]
        });
        filteredInvoices.push({
          isBuyer: false,
          date: pmf.date,
          type: 'replace',
          items: [{
            productId: pmf.newProductId,
            quantity: pmf.newProductQuantity,
            basicPrice: 0,
            GSTValue: 0,
            type: 'replace'

          }]
        });
      });

      filteredInvoices.map(function (invoice) {
        var invoiceMonth = new Date(invoice.date).getMonth();
        if ((!!_this4.filters.month.model ? invoiceMonth <= _this4.filters.month.model : true) && !invoice.return && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(productGroup).length) {

          var isBuyer = invoice.isBuyer;
          invoice.items && invoice.items.map(function (item) {
            if (productGroup[item["productId"]]) {
              if (productGroup[item["productId"]][0].durationQuantity != undefined) {
                var durationQuantity = parseInt(productGroup[item["productId"]][0]["durationQuantity"]);
                durationQuantity += !!isBuyer ? -parseInt(item.quantity) : parseInt(item.quantity);
                total.durationQuantity += durationQuantity;
                productGroup[item["productId"]][0]["durationQuantity"] = durationQuantity;
              } else {
                productGroup[item["productId"]][0]["durationQuantity"] = productGroup[item["productId"]][0].openingQuantity ? productGroup[item["productId"]][0].openingQuantity : 0;
                total.durationQuantity += parseInt(productGroup[item["productId"]][0]["durationQuantity"]);
              }
              // if (productGroup[item["productId"]][0]["invoices"] && productGroup[item["productId"]][0]["invoices"].length) {
              //   productGroup[item["productId"]][0]["invoices"].push(invoice);
              // } else {
              //   productGroup[item["productId"]][0]["invoices"] = [];
              //   productGroup[item["productId"]][0]["invoices"].push(invoice);
              // }
              if (productGroup[item["productId"]][0].unitsDeatilsAdded) {
                var units = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(productGroup[item["productId"]][0].unitsDetails));
                units.sort(function (a, b) {
                  return parseFloat(a.order) - parseFloat(b.order);
                });

                var isSelectedUnit = false;
                var multiplayer = 1;
                units.map(function (unit) {
                  if (isSelectedUnit && parseInt(unit.quantity) > 0) {
                    multiplayer = multiplayer * parseInt(unit.quantity);
                  }
                  if (unit.unit == item.unit) {
                    isSelectedUnit = true;
                  }
                });
                item.quantity = item.quantity * multiplayer;
              }

              var rate = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(item.rate);
              if (isBuyer) {
                if (invoice.date > latestSaleDate) {
                  latestSaleDate = invoice.date;
                  productGroup[item["productId"]][0]['stockReportData']['lastSalePrice'] = rate;
                }
                productGroup[item["productId"]][0]['stockReportData']['saleDetails'].push({
                  quantity: item.quantity,
                  rate: rate,
                  date: invoice.date
                });
              } else {
                if (invoice.date > latestPurchaseDate) {
                  latestPurchaseDate = invoice.date;
                  productGroup[item["productId"]][0]['stockReportData']['lastPurchasePrice'] = rate;
                }
                productGroup[item["productId"]][0]['stockReportData']['purchaseDetails'].push({
                  quantity: item.quantity,
                  rate: rate,
                  date: invoice.date
                });
              }
              productGroup[item["productId"]][0]["durationAmount"] += !!isBuyer ? -__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(item.basicPrice);
              total.durationAmount += productGroup[item["productId"]][0]["durationAmount"];
              if (!!isBuyer) {
                productGroup[item["productId"]][0]["durationQtySale"] += parseInt(item.quantity);
                total.durationQtySale += parseInt(item.quantity);
                productGroup[item["productId"]][0]["durationAmountSale"] += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(item.basicPrice);
                total.durationAmountSale += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(item.basicPrice);
              } else {
                productGroup[item["productId"]][0]["durationQtyPurchase"] += parseInt(item.quantity);
                total.durationQtyPurchase += parseInt(item.quantity);
                productGroup[item["productId"]][0]["durationAmountPurchase"] += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(item.basicPrice);
                total.durationAmountPurchase += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(item.basicPrice);
              }
              item['date'] = invoice.date;
              item['invoice'] = invoice;
              item['isBuyer'] = invoice['isBuyer'];
              item['openingBalance'] = productGroup[item["productId"]][0]['openingBalance'];
              item['openingQuantity'] = productGroup[item["productId"]][0]['openingQuantity'];

              if (!(productGroup[item["productId"]][0]['productList'] && productGroup[item["productId"]][0]['productList'].length)) {
                productGroup[item["productId"]][0]['productList'] = [];
              }
              productGroup[item["productId"]][0]['productList'].push(item);
            }
          });
        }
      });
      var results = [];
      var self = this;
      __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(productGroup).length && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(productGroup).map(function (key, index) {
        productGroup[key][".key"] = key;

        if (productGroup[key][0].unitsDeatilsAdded) {
          productGroup[key][0]['openingQuantityTitle'] = self.getFilteredQuantity(productGroup[key][0], productGroup[key][0]['openingQuantity']);
          productGroup[key][0]['purchaseQuantityTitle'] = self.getFilteredQuantity(productGroup[key][0], productGroup[key][0]['durationQtyPurchase']);
          productGroup[key][0]['saleQuantityTitle'] = self.getFilteredQuantity(productGroup[key][0], productGroup[key][0]['durationQtySale']);
          productGroup[key][0]['closingQuantityTitle'] = self.getFilteredQuantity(productGroup[key][0], __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(productGroup[key][0]['openingQuantity']) + __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(productGroup[key][0]['durationQtyPurchase']) - __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(productGroup[key][0]['durationQtySale']));
        }
        productGroup[key][0]['closingQuantity'] = parseInt(productGroup[key][0]['openingQuantity'] ? productGroup[key][0]['openingQuantity'] : 0) + parseInt(productGroup[key][0]['durationQtyPurchase'] ? productGroup[key][0]['durationQtyPurchase'] : 0) - parseInt(productGroup[key][0]['durationQtySale'] ? productGroup[key][0]['durationQtySale'] : 0);
        total.closingQuantity += isNaN(productGroup[key][0]['closingQuantity']) ? 0 : productGroup[key][0]['closingQuantity'];

        productGroup[key][0]['closingAmount'] = self.getClosingAmount(productGroup[key][0]);
        // total.closingAmount += Number.parseFloat(productGroup[key][0]['closingAmount'])
        var closingStockVal = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(productGroup[key][0]['closingAmount']);
        total.closingAmount += isNaN(closingStockVal) ? 0 : closingStockVal;
        // productGroup[key][0]['closingQuantity'] = (parseInt(productGroup[key][0]['openingQuantity'] ?  productGroup[key][0]['openingQuantity'] : 0) + parseInt(productGroup[key][0]['durationQtyPurchase'] ?  productGroup[key][0]['durationQtyPurchase'] : 0)) - parseInt( productGroup[key][0]['durationQtySale'] ?  productGroup[key][0]['durationQtySale'] : 0)
        // total.closingQuantity += isNaN(productGroup[key][0]['closingQuantity']) ? 0 : productGroup[key][0]['closingQuantity'];
        results.push(productGroup[key][0]);
      });
      results.push({
        name: 'Total',
        ".key": 'total',
        quantity: total.quantity,
        durationQuantity: total.durationQuantity,
        durationAmount: total.durationAmount,
        saleQuantity: total.saleQuantity,
        durationQtySale: total.durationQtySale,
        durationAmountSale: total.durationAmountSale,
        purchaseQuantity: total.purchaseQuantity,
        durationQtyPurchase: total.durationQtyPurchase,
        durationAmountPurchase: total.durationAmountPurchase,
        openingQuantity: total.openingQuantity,
        openingBalance: total.openingBalance,
        closingAmount: total.closingAmount,
        closingQuantity: total.closingQuantity
      });
      return results;
    },
    filteredProductByWeight: function filteredProductByWeight() {
      var _this5 = this;

      var products = this.productListByBrand.filter(function (item) {
        if (!__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(_this5.filters).length) {
          return true;
        }

        if (_this5.filters.gstPercentage.model) {
          if (_this5.filters.gstPercentage.model !== item["taxableGST_rate"]) {
            return false;
          }
        } else if (_this5.filters.gstPercentage.model == 0) {
          if (_this5.filters.gstPercentage.model !== item["taxableGST_rate"]) {
            return false;
          }
        }

        if (_this5.filters.firms.model) {
          if (_this5.filters.firms.model !== item["firm"]) {
            return false;
          }
        }

        if (_this5.filters.productGroups.model) {
          if (_this5.filters.productGroups.model !== item["productGroup"]) {
            return false;
          }
        }

        if (_this5.filters.gstCategory.model) {
          if (_this5.filters.gstCategory.model !== item["GST_type"]) {
            return false;
          }
        }

        if (_this5.filters.isActive.model) {
          if (_this5.filters.isActive.model !== item["isActive"]) {
            return false;
          }
        }

        if (_this5.filters.unit.model) {
          if (_this5.filters.unit.model !== item["unit"]) {
            return false;
          }
        }

        if (_this5.filters.hsnCode.model) {
          if (_this5.filters.hsnCode.model !== item["HSN_code"]) {
            return false;
          }
        }

        if (_this5.filters.quantity.model) {
          if (item["quantity"] >= _this5.filters.quantity.model) {
            return true;
          } else {
            return false;
          }
        }

        if (_this5.filters.openingQuantity.model) {
          if (item["openingQuantity"] >= _this5.filters.openingQuantity.model) {
            return true;
          } else {
            return false;
          }
        }

        if (_this5.filters.saleQuantity.model) {
          if (item["saleQuantity"] >= _this5.filters.saleQuantity.model) {
            return true;
          } else {
            return false;
          }
        }

        if (_this5.filters.purchaseQuantity.model) {
          if (item["purchaseQuantity"] >= _this5.filters.purchaseQuantity.model) {
            return true;
          } else {
            return false;
          }
        }
        return true;
      });
      var total = {
        quantity: 0,
        durationQuantity: 0,
        durationAmount: 0,
        saleQuantity: 0,
        durationQtySale: 0,
        durationAmountSale: 0,
        purchaseQuantity: 0,
        durationQtyPurchase: 0,
        durationAmountPurchase: 0,
        openingQuantity: 0,
        openingBalance: 0,
        closingAmount: 0,
        closingQuantity: 0
      };
      products.map(function (p, index) {
        p["durationQuantity"] = undefined;
        p["durationAmount"] = 0;
        p["durationQtySale"] = 0;
        p["durationQtyPurchase"] = 0;
        p["durationAmountSale"] = 0;
        p["durationAmountPurchase"] = 0;
        p["closingAmount"] = 0;
        p["closingQuantity"] = 0;
        p["stockReportData"] = {
          saleDetails: [],
          purchaseDetails: [],
          lastSalePrice: 0,
          lastPurchasePrice: 0
        };

        var prodG = {
          weight: 0,
          openingBalance: 0
        };
        if (_this5.reportType == 'productGroup') {
          if (p.productGroup) {
            prodG = _this5.productGroups.find(function (item) {
              return item['.key'] == p.productGroup;
            });
          }
          products[index]['openingQuantity'] = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prodG.weight || 0);
          products[index]['openingBalance'] = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prodG.openingBalance || 0);
        } else {
          products[index]['openingQuantity'] = 0;
          products[index]['openingBalance'] = 0;
        }

        if (p.openingBalance && p.openingQuantity) {
          p["stockReportData"]['purchaseDetails'].push({
            quantity: __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(p.openingQuantity),
            rate: __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(p.openingBalance) / __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(p.openingQuantity),
            date: p.openingDate
          });
          p["stockReportData"]['lastPurchasePrice'] = p.openingBalance;
        }
        total.openingQuantity = '34821.947';
        total.openingBalance = '5414046.90';
      });
      var productGroup = products.reduce(function (r, a) {
        r[a[".key"]] = r[a[".key"]] || [];
        r[a[".key"]].push(a);
        return r;
      }, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(null));
      __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(productGroup).forEach(function (key) {
        productGroup[key][0]['productList'] = [];
      });
      var latestSaleDate = new Date('01-01-1000').getTime();
      var latestPurchaseDate = new Date('01-01-1000').getTime();
      var filteredInvoices = this.invoices.filter(function (item) {

        if (!__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(_this5.filters).length) {
          return true;
        }

        if (item.type == "automatic invoice") {
          return false;
        }

        if (!item.items || !item.items.length) {
          return false;
        }

        if (item.deleted) {
          return false;
        }

        if (_this5.filters.tillDate.model && _this5.filters.date.model) {
          var fromDate = new Date(_this5.filters.date.model.split("-")).getTime();
          var tillDate = new Date(_this5.filters.tillDate.model.split("-")).getTime();
          var itemDate = new Date(item["date"]).getTime();

          if (fromDate > itemDate || tillDate < itemDate) {
            return false;
          }
        } else if (_this5.filters.date.model) {
          var _filters$date$model$s3 = _this5.filters.date.model.split("-"),
              _filters$date$model$s4 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_filters$date$model$s3, 3),
              year = _filters$date$model$s4[0],
              month = _filters$date$model$s4[1],
              day = _filters$date$model$s4[2];

          var date = day + "/" + month + "/" + year;
          if (item["dateCompare"] !== date) {
            return false;
          }
        }

        if (!item["date"]) {
          return false;
        }

        if (_this5.filters.month.model) {
          var _month2 = _this5.filters.month.model;
          if (!(new Date(item["date"]).getMonth() == _month2)) {
            return false;
          }
        }

        if (_this5.filters.duration.model) {
          if (item["duration"] >= _this5.filters.duration.model) {
            return true;
          } else {
            return false;
          }
        }

        if (_this5.filters.firms.model) {
          if (_this5.filters.firms.model !== item["firm"]) {
            return false;
          }
        }

        if (_this5.filters.gstType.model) {
          if (_this5.filters.gstType.model !== item["gstType"]) {
            return false;
          }
        }

        if (_this5.filters.paymentType.model) {
          if (item["paymentType"] === _this5.filters.paymentType.model) {
            return true;
          } else {
            return false;
          }
        }
        if (_this5.filters.invoiceStatus.model) {
          if (item["status"] === _this5.filters.invoiceStatus.model) {
            return true;
          } else {
            return false;
          }
        }

        if (_this5.filters.invoiceNumber.model) {
          if (item[".key"] !== _this5.filters.invoiceNumber.model) {
            return false;
          }
        }

        if (_this5.filters.buyerName.model) {
          if (item["buyerId"] !== _this5.filters.buyerName.model) {
            return false;
          }
        }

        if (_this5.filters.gstPercentage.model) {
          if (!item.items.find(function (p) {
            return p["taxableGST_rate"] === _this5.filters.gstPercentage.model;
          })) {
            return false;
          }
        }

        if (_this5.filters.gstCategory.model) {
          if (!item.items.find(function (p) {
            return p["GST_type"] === _this5.filters.gstCategory.model;
          })) {
            return false;
          }
        }

        if (_this5.filters.isActive.model) {
          if (!item.items.find(function (p) {
            return p["isActive"] === _this5.filters.isActive.model;
          })) {
            return false;
          }
        }

        if (_this5.filters.hsnCode.model && item.items) {
          if (!item.items.find(function (p) {
            return p["HSN_code"] == _this5.filters.hsnCode.model;
          })) {
            return false;
          }
        }

        if (_this5.filters.unit.model) {
          if (!item.items.find(function (p) {
            return p["productUnit"] === _this5.filters.unit.model;
          })) {
            return false;
          }
        }

        if (_this5.filters.quantity.model) {
          if (item.items.find(function (p) {
            return p["quantity"] >= _this5.filters.quantity.model;
          })) {
            return true;
          } else {
            return false;
          }
        }

        return true;
      });
      this.selectProdList = [];
      filteredInvoices.map(function (invoice) {
        var invoiceMonth = new Date(invoice.date).getMonth();
        if ((!!_this5.filters.month.model ? invoiceMonth <= _this5.filters.month.model : true) && !invoice.return && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(productGroup).length) {

          var isBuyer = invoice.isBuyer;
          invoice.items && invoice.items.map(function (item) {
            if (productGroup[item["productId"]]) {
              if (productGroup[item["productId"]][0].durationQuantity != undefined) {
                var durationQuantity = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(productGroup[item["productId"]][0]["durationQuantity"]);
                durationQuantity += !!isBuyer ? -__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(item.netWeight) : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(item.netWeight);
                total.durationQuantity += durationQuantity;
                productGroup[item["productId"]][0]["durationQuantity"] = durationQuantity;
              } else {
                productGroup[item["productId"]][0]["durationQuantity"] = productGroup[item["productId"]][0].openingQuantity ? productGroup[item["productId"]][0].openingQuantity : 0;
                total.durationQuantity += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(productGroup[item["productId"]][0]["durationQuantity"]);
              }
              if (productGroup[item["productId"]][0].unitsDeatilsAdded) {
                var units = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(productGroup[item["productId"]][0].unitsDetails));
                units.sort(function (a, b) {
                  return parseFloat(a.order) - parseFloat(b.order);
                });

                var isSelectedUnit = false;
                var multiplayer = 1;
                units.map(function (unit) {
                  if (isSelectedUnit && parseInt(unit.quantity) > 0) {
                    multiplayer = multiplayer * parseInt(unit.quantity);
                  }
                  if (unit.unit == item.unit) {
                    isSelectedUnit = true;
                  }
                });
                item.quantity = item.quantity * multiplayer;
              }
              var rate = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(item.rate);
              if (isBuyer) {
                if (invoice.date > latestSaleDate) {
                  latestSaleDate = invoice.date;
                  productGroup[item["productId"]][0]['stockReportData']['lastSalePrice'] = rate;
                }
                productGroup[item["productId"]][0]['stockReportData']['saleDetails'].push({
                  quantity: item.netWeight,
                  rate: rate,
                  date: invoice.date
                });
              } else {
                if (invoice.date > latestPurchaseDate) {
                  latestPurchaseDate = invoice.date;
                  productGroup[item["productId"]][0]['stockReportData']['lastPurchasePrice'] = rate;
                }
                productGroup[item["productId"]][0]['stockReportData']['purchaseDetails'].push({
                  quantity: item.netWeight,
                  rate: rate,
                  date: invoice.date
                });
              }
              productGroup[item["productId"]][0]["durationAmount"] += !!isBuyer ? -__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(item.basicPrice);
              total.durationAmount += productGroup[item["productId"]][0]["durationAmount"];
              if (!!isBuyer) {
                productGroup[item["productId"]][0]["durationQtySale"] += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(item.netWeight);
                total.durationQtySale += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(item.netWeight);
                productGroup[item["productId"]][0]["durationAmountSale"] += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(item.basicPrice);
                total.durationAmountSale += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(item.basicPrice);
              } else {
                productGroup[item["productId"]][0]["durationQtyPurchase"] += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(item.netWeight);
                total.durationQtyPurchase += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(item.netWeight);
                productGroup[item["productId"]][0]["durationAmountPurchase"] += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(item.basicPrice);
                total.durationAmountPurchase += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(item.basicPrice);
              }
              item['date'] = invoice.date;
              item['invoice'] = invoice;
              item['isBuyer'] = invoice['isBuyer'];
              item['openingBalance'] = productGroup[item["productId"]][0]['openingBalance'];
              item['openingQuantity'] = productGroup[item["productId"]][0]['openingQuantity'];

              if (!(productGroup[item["productId"]][0]['productList'] && productGroup[item["productId"]][0]['productList'].length)) {
                productGroup[item["productId"]][0]['productList'] = [];
              }
              productGroup[item["productId"]][0]['productList'].push(item);
            }
          });
        }
      });
      var results = [];
      var self = this;
      __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(productGroup).length && __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(productGroup).map(function (key, index) {
        productGroup[key][".key"] = key;

        if (productGroup[key][0].unitsDeatilsAdded) {
          productGroup[key][0]['openingQuantityTitle'] = self.getFilteredQuantity(productGroup[key][0], productGroup[key][0]['openingQuantity']);
          productGroup[key][0]['purchaseQuantityTitle'] = self.getFilteredQuantity(productGroup[key][0], productGroup[key][0]['durationQtyPurchase']);
          productGroup[key][0]['saleQuantityTitle'] = self.getFilteredQuantity(productGroup[key][0], productGroup[key][0]['durationQtySale']);
          productGroup[key][0]['closingQuantityTitle'] = self.getFilteredQuantity(productGroup[key][0], __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(productGroup[key][0]['openingQuantity']) + __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(productGroup[key][0]['durationQtyPurchase']) - __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(productGroup[key][0]['durationQtySale']));
        }
        productGroup[key][0]['closingAmount'] = self.getClosingAmount(productGroup[key][0]);
        // total.closingAmount += Number.parseFloat(productGroup[key][0]['closingAmount'])
        var closingStockVal = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(productGroup[key][0]['closingAmount']);
        total.closingAmount += isNaN(closingStockVal) ? 0 : closingStockVal;
        productGroup[key][0]['closingQuantity'] = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(productGroup[key][0]['openingQuantity'] ? productGroup[key][0]['openingQuantity'] : 0) + __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(productGroup[key][0]['durationQtyPurchase'] ? productGroup[key][0]['durationQtyPurchase'] : 0) - __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(productGroup[key][0]['durationQtySale'] ? productGroup[key][0]['durationQtySale'] : 0);
        total.closingQuantity += isNaN(productGroup[key][0]['closingQuantity']) ? 0 : __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(productGroup[key][0]['closingQuantity']);
        results.push(productGroup[key][0]);
      });
      results.push({
        name: 'Total',
        ".key": 'total',
        quantity: total.quantity,
        durationQuantity: total.durationQuantity,
        durationAmount: total.durationAmount,
        saleQuantity: total.saleQuantity,
        durationQtySale: total.durationQtySale,
        durationAmountSale: total.durationAmountSale,
        purchaseQuantity: total.purchaseQuantity,
        durationQtyPurchase: total.durationQtyPurchase,
        durationAmountPurchase: total.durationAmountPurchase,
        openingQuantity: total.openingQuantity,
        openingBalance: total.openingBalance,
        closingAmount: total.closingAmount,
        closingQuantity: total.closingQuantity
      });
      results.map(function (prod, index) {
        results[index]['quantity'] = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['quantity']).toFixed(3);
        results[index]['durationQuantity'] = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['durationQuantity']).toFixed(3);
        results[index]['durationAmount'] = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['durationAmount']).toFixed(3);
        results[index]['saleQuantity'] = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['saleQuantity']).toFixed(3);
        results[index]['durationQtySale'] = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['durationQtySale']).toFixed(3);
        results[index]['durationAmountSale'] = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['durationAmountSale']).toFixed(3);
        results[index]['purchaseQuantity'] = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['purchaseQuantity']).toFixed(3);
        results[index]['durationQtyPurchase'] = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['durationQtyPurchase']).toFixed(3);
        results[index]['durationAmountPurchase'] = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['durationAmountPurchase']).toFixed(3);
        results[index]['openingQuantity'] = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['openingQuantity']).toFixed(3);
        results[index]['openingBalance'] = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['openingBalance']).toFixed(3);
        results[index]['closingAmount'] = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['closingAmount']).toFixed(3);
        results[index]['closingQuantity'] = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['closingQuantity']).toFixed(3);
      });
      return results;
    },
    filteredGroups: function filteredGroups() {
      var _this6 = this;

      var products = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], this.filters.stockReportType.model == 'quantity' ? this.filteredProduct : this.filteredProductByWeight);
      var total = products.pop();
      var groups = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.productGroups));
      groups.push({
        name: 'Non group Products',
        ".key": 'Nongroup',
        quantity: 0,
        durationQuantity: 0,
        durationAmount: 0,
        saleQuantity: 0,
        durationQtySale: 0,
        durationAmountSale: 0,
        purchaseQuantity: 0,
        durationQtyPurchase: 0,
        durationAmountPurchase: 0,
        openingQuantity: 0,
        openingBalance: 0,
        closingAmount: 0,
        closingQuantity: 0
      });
      groups.map(function (item, index) {
        groups[index]['productList'] = [];
        groups[index]['quantity'] = 0;
        groups[index]['durationQuantity'] = 0;
        groups[index]['durationAmount'] = 0;
        groups[index]['saleQuantity'] = 0;
        groups[index]['durationQtySale'] = 0;
        groups[index]['durationAmountSale'] = 0;
        groups[index]['purchaseQuantity'] = 0;
        groups[index]['durationQtyPurchase'] = 0;
        groups[index]['durationAmountPurchase'] = 0;
        if (_this6.filters.stockReportType.model == 'weight' && item['.key'] != 'Nongroup') {
          groups[index]['openingQuantity'] = item.weight;
          groups[index]['openingBalance'] = item.openingBalance;
        } else {
          groups[index]['openingQuantity'] = 0;
          groups[index]['openingBalance'] = 0;
        }

        groups[index]['closingAmount'] = 0;
        groups[index]['closingQuantity'] = 0;
      });
      groups.map(function (item, index) {
        products.map(function (prod) {
          if (prod.productGroup && prod.productGroup == item['.key']) {
            groups[index]['productList'] = groups[index]['productList'].concat(prod.productList);
            groups[index]['quantity'] += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['quantity']);
            groups[index]['durationQuantity'] += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['durationQuantity']);
            groups[index]['durationAmount'] += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['durationAmount']);
            groups[index]['saleQuantity'] += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['saleQuantity']);
            groups[index]['durationQtySale'] += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['durationQtySale']);
            groups[index]['durationAmountSale'] += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['durationAmountSale']);
            groups[index]['purchaseQuantity'] += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['purchaseQuantity']);
            groups[index]['durationQtyPurchase'] += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['durationQtyPurchase']);
            groups[index]['durationAmountPurchase'] += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['durationAmountPurchase']);
            if (_this6.filters.stockReportType.model != 'weight') {
              groups[index]['openingQuantity'] += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['openingQuantity']);
              groups[index]['openingBalance'] += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['openingBalance']);
            }
            groups[index]['closingAmount'] += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['closingAmount']);
            groups[index]['closingQuantity'] += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['closingQuantity']);
          } else if (!prod.productGroup && item['.key'] == 'Nongroup') {
            groups[index]['productList'] = groups[index]['productList'].concat(prod.productList);
            groups[index]['quantity'] += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['quantity']);
            groups[index]['durationQuantity'] += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['durationQuantity']);
            groups[index]['durationAmount'] += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['durationAmount']);
            groups[index]['saleQuantity'] += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['saleQuantity']);
            groups[index]['durationQtySale'] += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['durationQtySale']);
            groups[index]['durationAmountSale'] += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['durationAmountSale']);
            groups[index]['purchaseQuantity'] += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['purchaseQuantity']);
            groups[index]['durationQtyPurchase'] += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['durationQtyPurchase']);
            groups[index]['durationAmountPurchase'] += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['durationAmountPurchase']);
            groups[index]['openingQuantity'] += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['openingQuantity']);
            groups[index]['openingBalance'] += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['openingBalance']);
            groups[index]['closingAmount'] += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['closingAmount']);
            groups[index]['closingQuantity'] += __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['closingQuantity']);
          }
        });
      });
      groups.push(total);
      groups.map(function (prod, index) {
        groups[index]['closingAmount'] = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['openingBalance']) + __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['durationAmountPurchase']) - __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['durationAmountSale']);
        groups[index]['closingQuantity'] = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['openingQuantity']) + __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['durationQtyPurchase']) - __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['durationQtySale']);
      });
      if (this.filters.stockReportType.model == 'weight') {
        groups.map(function (prod, index) {
          groups[index]['quantity'] = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['quantity']).toFixed(3);
          groups[index]['durationQuantity'] = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['durationQuantity']).toFixed(3);
          groups[index]['durationAmount'] = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['durationAmount']).toFixed(3);
          groups[index]['saleQuantity'] = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['saleQuantity']).toFixed(3);
          groups[index]['durationQtySale'] = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['durationQtySale']).toFixed(3);
          groups[index]['durationAmountSale'] = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['durationAmountSale']).toFixed(3);
          groups[index]['purchaseQuantity'] = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['purchaseQuantity']).toFixed(3);
          groups[index]['durationQtyPurchase'] = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['durationQtyPurchase']).toFixed(3);
          groups[index]['durationAmountPurchase'] = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['durationAmountPurchase']).toFixed(3);
          groups[index]['openingQuantity'] = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['openingQuantity']).toFixed(3);
          groups[index]['openingBalance'] = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['openingBalance']).toFixed(3);
          groups[index]['closingAmount'] = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['closingAmount']).toFixed(3);
          groups[index]['closingQuantity'] = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_number_parse_float___default()(prod['closingQuantity']).toFixed(3);
        });
      }

      return groups;
    },
    filteredInvoices: function filteredInvoices() {
      var _this7 = this;

      return this.invoiceList.filter(function (item) {
        if (!__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(_this7.filters).length) {
          return true;
        }

        if (!item.items || !item.items.length) {
          return false;
        }

        if (_this7.filters.tillDate.model && _this7.filters.date.model) {
          var fromDate = new Date(_this7.filters.date.model.split("-")).getTime();
          var tillDateTemp = new Date(_this7.filters.tillDate.model.split("-"));
          var tillDate = new Date(new Date(_this7.filters.tillDate.model.split("-")).setDate(tillDateTemp.getDate() + 1)).getTime();
          var itemDate = new Date(item["date"]).getTime();

          if (!(fromDate < itemDate && tillDate > itemDate)) {
            return false;
          }
        } else if (_this7.filters.date.model) {
          var _filters$date$model$s5 = _this7.filters.date.model.split("-"),
              _filters$date$model$s6 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_slicedToArray___default()(_filters$date$model$s5, 3),
              year = _filters$date$model$s6[0],
              month = _filters$date$model$s6[1],
              day = _filters$date$model$s6[2];

          var date = day + "/" + month + "/" + year;
          if (item["dateCompare"] !== date) {
            return false;
          }
        }

        if (_this7.filters.month.model) {
          if (!(new Date(item["date"]).getMonth() == _this7.filters.month.model)) {
            return false;
          }
        }

        if (_this7.filters.duration.model) {
          if (item["duration"] >= _this7.filters.duration.model) {
            return true;
          } else {
            return false;
          }
        }

        if (_this7.filters.firms.model) {
          if (_this7.filters.firms.model !== item["firm"]) {
            return false;
          }
        }

        if (_this7.filters.gstType.model) {
          if (_this7.filters.gstType.model !== item["gstType"]) {
            return false;
          }
        }

        // if (this.filters.amount.model) {
        //   if (item["totalValue"] >= this.filters.amount.model) {
        //     return true;
        //   } else {
        //     return false;
        //   }
        // }
        // if (this.filters.duration.model) {
        //   if (item["duration"] >= this.filters.duration.model) {
        //     return true;
        //   } else {
        //     return false;
        //   }
        // }

        // if (this.filters.rate.model) {
        //   if (this.filters.rate.model !== item["rate"]) {
        //     return false;
        //   }
        // }

        if (_this7.filters.paymentType.model) {
          if (item["paymentType"] === _this7.filters.paymentType.model) {
            return true;
          } else {
            return false;
          }
        }
        if (_this7.filters.invoiceStatus.model) {
          if (item["status"] === _this7.filters.invoiceStatus.model) {
            return true;
          } else {
            return false;
          }
        }

        if (_this7.filters.invoiceNumber.model) {
          if (item[".key"] !== _this7.filters.invoiceNumber.model) {
            return false;
          }
        }

        if (_this7.filters.buyerName.model) {
          if (item["buyerId"] !== _this7.filters.buyerName.model) {
            return false;
          }
        }

        if (_this7.filters.gstPercentage.model) {
          if (!item.items.find(function (p) {
            return p["taxableGST_rate"] === _this7.filters.gstPercentage.model;
          })) {
            return false;
          }
        }

        if (_this7.filters.gstCategory.model) {
          if (!item.items.find(function (p) {
            return p["GST_type"] === _this7.filters.gstCategory.model;
          })) {
            return false;
          }
        }

        if (_this7.filters.isActive.model) {
          if (!item.items.find(function (p) {
            return p["isActive"] === _this7.filters.isActive.model;
          })) {
            return false;
          }
        }

        if (_this7.filters.hsnCode.model && item.items) {
          if (!item.items.find(function (p) {
            return p["HSN_code"] == _this7.filters.hsnCode.model;
          })) {
            return false;
          }
        }

        if (_this7.filters.unit.model) {
          if (!item.items.find(function (p) {
            return p["productUnit"] === _this7.filters.unit.model;
          })) {
            return false;
          }
        }

        if (_this7.filters.quantity.model) {
          if (item.items.find(function (p) {
            return p["quantity"] >= _this7.filters.quantity.model;
          })) {
            return true;
          } else {
            return false;
          }
        }

        if (_this7.filters.state.model) {
          if (item["state"] === _this7.filters.state.model) {
            return true;
          } else {
            return false;
          }
        }

        if (_this7.filters.district.model) {
          if (item["district"] === _this7.filters.district.model) {
            return true;
          } else {
            return false;
          }
        }

        if (_this7.filters.block.model) {
          if (item["block"] === _this7.filters.block.model) {
            return true;
          } else {
            return false;
          }
        }

        if (_this7.filters.tehsil.model) {
          if (item["tehsil"] === _this7.filters.tehsil.model) {
            return true;
          } else {
            return false;
          }
        }

        if (_this7.filters.village.model) {
          if (item["village"] === _this7.filters.village.model) {
            return true;
          } else {
            return false;
          }
        }

        // if (this.filters.gstPercentage.model) {
        //   // if (item["buyerId"] !== this.filters.buyerName.model) {
        //   //   return false;
        //   // }
        // }
        return true;
      });
    }
  })
});

/***/ }),
/* 440 */,
/* 441 */,
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      productListHeader: [{ text: "Product- ID", value: "Product - ID" }, { text: "Name", value: "Name" }, { text: "Description", value: "Description" }, { text: "HSN code", value: "HSN" }, { text: "GST Category", value: "GST" }, { text: "Taxable rate", value: "Taxable" }, { text: "Unit", value: "Unit" }, { text: "Quantity", value: "quantity" }, { text: "Opening Quantity", value: "quantity" }, { text: "Month Quantity", value: "quantity" }],
      show: true,
      toDate: null,
      fromDate: null,
      datepickerFrom: null,
      datepickerTo: null,
      filters: {
        fromDate: {
          name: "From Date",
          model: null,
          type: "date-range",
          placeholder: "Select Date",
          options: [{
            text: "",
            value: ""
          }]
        },
        toDate: {
          name: "To Date",
          model: null,
          type: "date-range",
          placeholder: "Select Till Date",
          options: [{
            text: "",
            value: ""
          }]
        },
        month: {
          name: "Month",
          model: null,
          type: "select",
          placeholder: "Select Month",
          options: [{
            text: "January",
            value: 0
          }, {
            text: "February",
            value: 1
          }, {
            text: "March",
            value: 2
          }, {
            text: "April",
            value: 3
          }, {
            text: "May",
            value: 4
          }, {
            text: "June",
            value: 5
          }, {
            text: "July",
            value: 6
          }, {
            text: "August",
            value: 7
          }, {
            text: "September",
            value: 8
          }, {
            text: "October",
            value: 9
          }, {
            text: "November",
            value: 10
          }, {
            text: "December",
            value: 11
          }],
          reportType: ["sale", "purchase"]
        },
        gstPercentage: {
          name: "GST %",
          model: null,
          type: "select",
          placeholder: "Select GST %",
          options: [0, 5, 12, 18, 28]
        },
        gstCategory: {
          name: "GST Category",
          model: null,
          type: "select",
          placeholder: "GST Category",
          options: [{
            text: "Exempt",
            value: "EXEMPT"
          }, {
            text: "Nil Rated",
            value: "NILL"
          }, {
            text: "Taxable",
            value: "TAXABLE"
          }, {
            text: "Others",
            value: "OTHER"
          }]
        },
        unit: {
          name: "Units",
          model: null,
          type: "select",
          placeholder: "Units",
          options: units
        },
        quantity: {
          name: "Quantity",
          model: null,
          type: "number-range",
          label: "Quantity",
          min: 0,
          max: 5000
        },
        hsnCode: {
          name: "HSN Code",
          model: null,
          type: "search",
          input: null,
          placeholder: "Search for HSN code",
          options: [{
            text: "",
            value: ""
          }]
        },

        openingQuantity: {
          name: "Opening Quantity",
          model: null,
          type: "number-range",
          label: "Opening Quantity",
          min: 0,
          max: 5000
        },
        saleQuantity: {
          name: "Sale Quantity",
          model: null,
          type: "number-range",
          label: "Sale Quantity",
          min: 0,
          max: 5000
        },
        purchaseQuantity: {
          name: "Purchase Quantity",
          model: null,
          type: "number-range",
          label: "Purchase Quantity",
          min: 0,
          max: 5000
        }
      }
    };
  },
  created: function created() {
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("productList", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand));
  },

  methods: {},
  watch: {},
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "brandFinYear"]), mapGlobalGetters({ units: "productUnit" }), {
    productListByBrand: function productListByBrand() {
      var _this = this;

      return this.productList.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      });
    },
    filteredProduct: function filteredProduct() {
      var _this2 = this;

      var products = this.productListByBrand.filter(function (item) {

        if (!__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(_this2.filters).length) {
          return true;
        }

        if (_this2.filters.gstPercentage.model) {
          if (_this2.filters.gstPercentage.model !== item["taxableGST_rate"]) {
            return false;
          }
        } else if (_this2.filters.gstPercentage.model == 0) {
          if (_this2.filters.gstPercentage.model !== item["taxableGST_rate"]) {
            return false;
          }
        }

        if (_this2.filters.gstCategory.model) {
          if (_this2.filters.gstCategory.model !== item["GST_type"]) {
            return false;
          }
        }

        if (_this2.filters.unit.model) {
          if (_this2.filters.unit.model !== item["unit"]) {
            return false;
          }
        }

        if (_this2.filters.hsnCode.model) {
          if (_this2.filters.hsnCode.model !== item["HSN_code"]) {
            return false;
          }
        }

        if (_this2.filters.quantity.model) {
          if (item["quantity"] >= _this2.filters.quantity.model) {
            return true;
          } else {
            return false;
          }
        }

        if (_this2.filters.openingQuantity.model) {
          if (item["openingQuantity"] >= _this2.filters.openingQuantity.model) {
            return true;
          } else {
            return false;
          }
        }

        if (_this2.filters.saleQuantity.model) {
          if (item["saleQuantity"] >= _this2.filters.saleQuantity.model) {
            return true;
          } else {
            return false;
          }
        }

        if (_this2.filters.purchaseQuantity.model) {
          if (item["purchaseQuantity"] >= _this2.filters.purchaseQuantity.model) {
            return true;
          } else {
            return false;
          }
        }
        return true;
      });
      products.map(function (p) {
        p["monthlyQuantity"] = undefined;
      });
      var productGroup = products.reduce(function (r, a) {
        r[a[".key"]] = r[a[".key"]] || [];
        r[a[".key"]].push(a);
        return r;
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_create___default()(null));
      var filteredInvoices = this.invoices.filter(function (item) {
        return item["brand"] === _this2.selectedBrand;
      });

      var toDate = this.filters.toDate.model ? new Date(this.filters.toDate.model).getTime() : null;
      var fromDate = this.filters.fromDate.model ? new Date(this.filters.fromDate.model).getTime() : null;

      filteredInvoices.map(function (invoice) {
        var invoiceMonth = new Date(invoice.date).getMonth();
        if (invoiceMonth <= _this2.filters.month.model && !invoice.return && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(productGroup).length && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true)) {
          var isBuyer = invoice.isBuyer;
          invoice.items && invoice.items.map(function (item) {
            if (productGroup[item["productId"]][0].monthlyQuantity != undefined) {
              var monthlyQuantity = parseInt(productGroup[item["productId"]][0]["monthlyQuantity"]);
              monthlyQuantity += isBuyer ? -parseInt(item.quantity) : parseInt(item.quantity);
              productGroup[item["productId"]][0]["monthlyQuantity"] = monthlyQuantity;
            } else {
              productGroup[item["productId"]][0]["monthlyQuantity"] = productGroup[item["productId"]][0].openingQuantity ? productGroup[item["productId"]][0].openingQuantity : 0;
            }
          });
        }
      });
      var results = [];
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(productGroup).length && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(productGroup).map(function (key, index) {
        productGroup[key][".key"] = key;
        results.push(productGroup[key][0]);
      });
      if (results.length) {
        this.show = false;
      } else {
        this.show = true;
      }
      return results;
    }
  })
});

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3__ = __webpack_require__(189);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'items',
    data: function data() {
        return {
            firms: [],
            items: [],
            selectFirm: null
        };
    },
    created: function created() {
        // this.$bindAsArray(
        //     'items',
        //     this.$root.$firebaseRefs.item
        // )
        this.$bindAsArray('firms', this.$root.$firebaseRefs.firm);
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand']), {
        getFirms: function getFirms() {
            var _this = this;

            if (this.firms && this.selectedBrand) {
                return this.firms.filter(function (item) {
                    return item['brand'] === _this.selectedBrand;
                }).map(function (item) {
                    return { text: item.name, value: item['.key'] };
                });
            }
        },
        processedItems: function processedItems() {
            var _this2 = this;

            if (this.items.length) {
                var filteredItems = this.items.filter(function (item) {
                    return item['brand'] === _this2.selectedBrand && item['status'] !== 'closed';
                }).filter(function (_ref) {
                    var firm = _ref.firm;
                    return _this2.selectFirm ? _this2.selectFirm == firm : true;
                });
                var data = __WEBPACK_IMPORTED_MODULE_3_d3__["a" /* nest */]().key(function (d) {
                    return d.type;
                }).key(function (d) {
                    return d.subType;
                }).rollup(function (v) {
                    return __WEBPACK_IMPORTED_MODULE_3_d3__["b" /* sum */](v, function (d) {
                        return d.quantity;
                    });
                }).entries(filteredItems);

                data = data.filter(function (_ref2) {
                    var key = _ref2.key;
                    return key && key.trim() != "";
                }).map(function (_ref3) {
                    var key = _ref3.key,
                        values = _ref3.values;
                    return {
                        name: key, values: values.filter(function (_ref4) {
                            var key = _ref4.key;
                            return key && key.trim() != "";
                        })
                        // .map(({key, value}) => ({[key]: value}))
                    };
                });
                // console.log('med', JSON.stringify(data));
                // data = data.map(({name, values})=> {
                //     let result = {
                //         name
                //     }
                //     values.forEach(value => {
                //         result = {...result, ...value}
                //     })
                //     return result
                // })
                console.log('final', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));

                return data;
            }
            return [];
        }
    })
});

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tabs_utils__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_timers__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tabs_expense__ = __webpack_require__(1366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__tabs_income__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tabs_asset__ = __webpack_require__(1376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__tabs_salary__ = __webpack_require__(1381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__tabs_liability__ = __webpack_require__(1385);



var _extends2;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ExpenseTab: __WEBPACK_IMPORTED_MODULE_6__tabs_expense__["a" /* default */],
    IncomeTab: __WEBPACK_IMPORTED_MODULE_7__tabs_income__["a" /* default */],
    AssetTab: __WEBPACK_IMPORTED_MODULE_8__tabs_asset__["a" /* default */],
    SalaryTab: __WEBPACK_IMPORTED_MODULE_9__tabs_salary__["a" /* default */],
    LiabilityTab: __WEBPACK_IMPORTED_MODULE_10__tabs_liability__["a" /* default */]
  },
  data: function data() {
    var _ref;

    return _ref = {
      tabs: ['transfer', 'deposit', 'withdrawl', 'expense', 'income', 'asset', 'salary', 'liability'],
      transferType: 'Transfer',
      transferCategory: 'B2B',
      bankTransferData: {
        firm: null,
        dipositeVia: null,
        remark: null
      },
      bankTransferType: null,
      color: null,
      timeout: 3000,
      transferdatepicker: false,
      depositdatepicker: false,
      withdrawldatepicker: false,
      incomedatepicker: false,
      staffdatepicker: false,
      transferInvoiceDate: null,
      depostInvoiceDate: null,
      withdrawlInvoiceDate: null,
      incomeInvoiceDate: null,
      staffInvoiceDate: null,
      depositVia: 'cash',
      withdrawlVia: 'cash',
      expenseVia: 'cash',
      incomeVia: 'cash',
      assetVia: 'cash',
      staffVia: 'cash',
      transferTotalAmount: null,
      depositTotalAmount: null,
      withdrawlTotalAmount: null,
      expenseAmount: null,
      incomeAmount: null,
      staffAmount: null,
      assetAmount: null,
      snackbarSuccessText: null,
      snackbarText: null,
      snackbar: false,
      snackbarSuccess: false,
      transfer: false,
      deposit: false,
      withdrawl: false,
      expense: true,
      income: false,
      asset: false,
      staff: false,
      liability: false,
      depositType: null,
      date: null,
      firms: [],
      accounts: [],
      expenses: [],
      liabilities: [],
      incomes: [],
      assets: [],
      staffs: []
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'liabilities', []), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'selectExpense', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'selectIncome', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'selectAsset', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'selectStaff', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'selectedFirm', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'selectedAccountFromAccount', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'selectedAccountToAccount', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'selectAccountToDeposit', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'selectedFirmToDeposit', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'selectAccountToWithdrawl', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'selectedFirmToWithdrawl', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'searchInput', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'searchInputFromAccount', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'searchInputToAccount', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'selectedFirmFromExpense', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'selectAccountFromExpense', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'selectedFirmFromIncome', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'selectAccountFromIncome', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'selectedFirmFromStaff', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'selectAccountFromStaff', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'expenseRemark', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'withdrawlRemark', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'depositRemark', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'incomeRemark', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'assetRemark', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'staffRemark', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'debitStatus', ['Due', 'Paid', 'Partial Paid']), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'dialog12', false), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'salaryInvoiceDate', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'salaryTransactionType', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'salaryOperationAccountForTransaction', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'salaryOperationAmountFromCash', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'salaryOperationAmountFromBank', null), _ref;
  },
  created: function created() {
    this.$bindAsArray('firms', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('accounts', this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('expenses', this.$root.$firebaseRefs.expenses.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('liabilities', this.$root.$firebaseRefs.liabilities.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('incomes', this.$root.$firebaseRefs.incomes.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('staffs', this.$root.$firebaseRefs.staffs.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('assets', this.$root.$firebaseRefs.assets.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('staffaccount', this.$root.$firebaseRefs.staff.orderByChild('brand').equalTo(this.selectedBrand));
    var today = new Date();
    this.date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    this.salaryInvoiceDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    this.transferInvoiceDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    if (this.$route.params.type) {
      switch (this.$route.params.type) {
        case 'expenses':
          {
            this.transfer = false;
            this.deposit = false;
            this.expense = true;
            this.withdrawl = false;
            this.income = false;
            this.asset = false;
            this.staff = false;
            this.liability = false;
            break;
          }
      }
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand', 'brandFinYear']), (_extends2 = {
    accountsByFirm: function accountsByFirm() {
      var _this = this;

      if (this.selectedFirmFromAsset) {
        return this.accountsByBrand.filter(function (item) {
          return item.account.firm === _this.selectedFirmFromAsset;
        });
      }
      return [];
    },
    otherAccountByBrand: function otherAccountByBrand() {
      return this.accountsByFirm.filter(function (account) {
        return account.account.accountType !== 'Loan A/C';
      });
    },
    loanAccountByBrand: function loanAccountByBrand() {
      return this.accountsByFirm.filter(function (account) {
        return account.account.accountType === 'Loan A/C';
      });
    },
    paymentOptions: function paymentOptions() {
      console.log(__WEBPACK_IMPORTED_MODULE_2__tabs_utils__["d" /* PAYMENT_OPTIONS */]);
      return __WEBPACK_IMPORTED_MODULE_2__tabs_utils__["d" /* PAYMENT_OPTIONS */];
    },
    getTransactionTypeOptions: function getTransactionTypeOptions() {
      return [{ text: 'Salary', value: 'salary' }, { text: 'Advance', value: 'advance' }, { text: 'Commission', value: 'commission' }, { text: 'Return', value: 'Return' }];
    },
    firmsByBrand: function firmsByBrand() {
      var _this2 = this;

      return this.firms.filter(function (item) {
        return item['brand'] === _this2.selectedBrand;
      }).map(function (item) {
        return {
          firm: item,
          text: item['name'],
          value: item['.key'],
          defaultFirm: item['defaultFirm']
        };
      });
    },
    accountsByBrand: function accountsByBrand() {
      var _this3 = this;

      return this.accounts.filter(function (item) {
        return item['brand'] === _this3.selectedBrand;
      }).map(function (item) {
        return {
          account: item,
          text: item['accountnumber'],
          value: item['.key']
        };
      });
    }
  }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, 'accountsByFirm', function accountsByFirm() {
    var _this4 = this;

    return this.accounts.filter(function (item) {
      return item['brand'] === _this4.selectedBrand && item['firm'] === _this4.bankTransferData.firm;
    }).map(function (item) {
      return {
        account: item,
        text: item['accountnumber'],
        value: item['.key']
      };
    });
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, 'expenseByBrand', function expenseByBrand() {
    var _this5 = this;

    return this.expenses.filter(function (item) {
      return item['brand'] === _this5.selectedBrand;
    }).map(function (item) {
      return {
        text: item['expense'],
        value: item['.key']
      };
    });
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, 'liabilityByBrand', function liabilityByBrand() {
    var _this6 = this;

    return this.liabilities.filter(function (item) {
      return item['brand'] === _this6.selectedBrand;
    }).map(function (item) {
      return {
        text: item['liability'],
        value: item['.key']
      };
    });
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, 'incomeByBrand', function incomeByBrand() {
    var _this7 = this;

    return this.incomes.filter(function (item) {
      return item['brand'] === _this7.selectedBrand;
    }).map(function (item) {
      return {
        text: item['income'],
        value: item['.key']
      };
    });
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, 'assetByBrand', function assetByBrand() {
    var _this8 = this;

    return this.assets.filter(function (item) {
      return item['brand'] === _this8.selectedBrand;
    }).map(function (item) {
      return {
        asset: item,
        text: item['asset'],
        value: item['.key']
      };
    });
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, 'staffByBrand', function staffByBrand() {
    var _this9 = this;

    return this.staffs.filter(function (item) {
      return item['brand'] === _this9.selectedBrand;
    }).map(function (item) {
      return {

        text: item['staff'],
        value: item['.key']
      };
    });
  }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_extends2, 'getStaff', function getStaff() {
    var _this10 = this;

    return this.staffaccount.filter(function (item) {
      return item['brand'] === _this10.selectedBrand;
    }).map(function (item) {
      return {
        staff: item,
        text: item['staffName'],
        value: item['.key']
      };
    });
  }), _extends2)),
  methods: {
    notify: function notify(message, isSuccess) {
      if (isSuccess) {
        this.snackbarSuccess = true;
        this.snackbarSuccessText = message;
      } else {
        this.snackbar = true;
        this.snackbarText = message;
      }
    },
    closeDialog: function closeDialog() {},
    firmNameById: function firmNameById(id) {
      return this.firms.filter(function (item) {
        return item['.key'] == id;
      })[0].name;
    },
    addInvoice: function addInvoice(accountFromFirm, accountToFirm, fromAccount, toAccount, transferTotalAmount, transactionType, fromAccountKey, toAccountKey) {
      var invoiceDataCredit = {
        brand: this.selectedBrand,
        brandFinYear: this.brandFinYear,
        type: 'automatic invoice',
        transactionType: transactionType,
        firm: accountToFirm,
        paymentType: 'bank',
        accountNumber: toAccount,
        isCredited: true,
        totalAmount: Number(transferTotalAmount),
        date: this.transferInvoiceDate ? Date.parse(this.transferInvoiceDate) : Date.now(),
        transferCategory: this.transferCategory
      };
      var invoiceDataDebit = {
        brand: this.selectedBrand,
        brandFinYear: this.brandFinYear,
        type: 'automatic invoice',
        transactionType: transactionType,
        firm: accountFromFirm,
        paymentType: 'bank',
        accountNumber: fromAccount,
        isCredited: false,
        totalAmount: Number(transferTotalAmount),
        date: this.transferInvoiceDate ? Date.parse(this.transferInvoiceDate) : Date.now(),
        transferCategory: this.transferCategory
      };

      if (this.transferCategory == 'B2B') {
        invoiceDataCredit['transferType'] = this.bankTransferType;
        invoiceDataCredit['bank'] = toAccountKey;
        invoiceDataDebit['transferType'] = this.bankTransferType;
        invoiceDataDebit['bank'] = fromAccountKey;
        invoiceDataCredit['remark'] = this.bankTransferData.remark;
        invoiceDataDebit['remark'] = this.bankTransferData.remark;
      } else if (this.transferCategory == "B2C") {
        invoiceDataCredit['depositVia'] = this.bankTransferData.depositVia;
        invoiceDataCredit['remark'] = this.bankTransferData.remark;
        invoiceDataDebit['bank'] = fromAccountKey;

        invoiceDataDebit['depositVia'] = this.bankTransferData.depositVia;
        invoiceDataDebit['remark'] = this.bankTransferData.remark;
      } else if (this.transferCategory == "C2B") {
        invoiceDataCredit['depositVia'] = this.bankTransferData.depositVia;
        invoiceDataCredit['remark'] = this.bankTransferData.remark;
        invoiceDataCredit['bank'] = toAccountKey;

        invoiceDataDebit['depositVia'] = this.bankTransferData.depositVia;
        invoiceDataDebit['remark'] = this.bankTransferData.remark;
      }
      this.$root.$firebaseRefs.invoice.push(invoiceDataCredit);
      this.$root.$firebaseRefs.invoice.push(invoiceDataDebit);
      this.closeDialog();
    },


    // Deposit Invoice 

    addInvoiceDeposit: function addInvoiceDeposit(depositVia, selectedFirmToDeposit, depositTotalAmount, depositRemark, fromAccount) {
      var invoiceViaCash = {
        brand: this.selectedBrand,
        brandFinYear: this.brandFinYear,
        type: 'automatic invoice',
        transactionType: 'Deposit',
        firm: selectedFirmToDeposit,
        paymentType: depositVia,
        accountNumber: '',
        depositVia: this.bankTransferData.depositVia,
        isCredited: true,
        totalAmount: Number(depositTotalAmount),
        remark: depositRemark,
        date: this.depositInvoiceDate ? Date.parse(this.depositInvoiceDate) : Date.now()
      };
      var invoiceViaAccount = {
        brand: this.selectedBrand,
        brandFinYear: this.brandFinYear,
        type: 'automatic invoice',
        transactionType: 'Deposit',
        firm: selectedFirmToDeposit,
        paymentType: depositVia,
        depositVia: this.bankTransferData.depositVia,
        accountNumber: fromAccount,
        isCredited: true,
        totalAmount: Number(depositTotalAmount),
        remark: depositRemark,
        date: this.depositInvoiceDate ? Date.parse(this.depositInvoiceDate) : Date.now()
      };
      if (depositVia == 'cash') {
        this.$root.$firebaseRefs.invoice.push(invoiceViaCash);
      } else {
        this.$root.$firebaseRefs.invoice.push(invoiceViaAccount);
      }
    },


    // Withdrawl Invoice 

    addInvoiceWithdrawl: function addInvoiceWithdrawl(withdrawlVia, selectedFirmToWithdrawl, withdrawlTotalAmount, withdrawlRemark, fromAccount) {
      var invoiceViaCash = {
        brand: this.selectedBrand,
        brandFinYear: this.brandFinYear,
        type: 'automatic invoice',
        transactionType: 'With Drawl',
        firm: selectedFirmToWithdrawl,
        paymentType: withdrawlVia,
        accountNumber: '',
        isCredited: false,
        totalAmount: Number(withdrawlTotalAmount),
        remark: withdrawlRemark,
        date: this.withdrawlInvoiceDate ? Date.parse(this.withdrawlInvoiceDate) : Date.now()
      };
      var invoiceViaAccount = {
        brand: this.selectedBrand,
        brandFinYear: this.brandFinYear,
        type: 'automatic invoice',
        transactionType: 'With Drawl',
        firm: selectedFirmToWithdrawl,
        paymentType: withdrawlVia,
        accountNumber: fromAccount,
        isCredited: false,
        totalAmount: Number(withdrawlTotalAmount),
        remark: withdrawlRemark,
        date: this.withdrawlInvoiceDate ? Date.parse(this.withdrawlInvoiceDate) : Date.now()
      };
      if (withdrawlVia == 'cash') {
        this.$root.$firebaseRefs.invoice.push(invoiceViaCash);
      } else {
        this.$root.$firebaseRefs.invoice.push(invoiceViaAccount);
      }
    },


    // Income Invoice 
    addInvoiceIncome: function addInvoiceIncome(incomeVia, incomeType, firmOfIncome, incomeAmount, incomeRemark, accountOfIncome) {
      var invoiceViaCash = {
        brand: this.selectedBrand,
        brandFinYear: this.brandFinYear,
        type: 'automatic invoice',
        transactionType: 'Income',
        firm: firmOfIncome,
        paymentType: incomeVia,
        accountNumber: '',
        isCredited: true,
        totalAmount: Number(incomeAmount),
        remark: incomeRemark,
        incomeType: incomeType,
        date: this.incomeInvoiceDate ? Date.parse(this.incomeInvoiceDate) : Date.now()
      };
      var invoiceViaAccount = {
        brand: this.selectedBrand,
        brandFinYear: this.brandFinYear,
        type: 'automatic invoice',
        transactionType: 'Income',
        firm: firmOfIncome,
        paymentType: incomeVia,
        accountNumber: accountOfIncome,
        isCredited: true,
        totalAmount: Number(incomeAmount),
        remark: incomeRemark,
        incomeType: incomeType,
        date: this.incomeInvoiceDate ? Date.parse(this.incomeInvoiceDate) : Date.now()
      };
      if (incomeVia == 'cash') {
        this.$root.$firebaseRefs.invoice.push(invoiceViaCash);
      } else {
        this.$root.$firebaseRefs.invoice.push(invoiceViaAccount);
      }
    },


    // Staff Invoice 
    addInvoiceStaff: function addInvoiceStaff(staffVia, staffType, firmOfStaff, staffAmount, staffRemark, accountOfStaff) {
      var invoiceViaCash = {
        brand: this.selectedBrand,
        brandFinYear: this.brandFinYear,
        type: 'automatic invoice',
        transactionType: 'Staff',
        firm: firmOfStaff,
        paymentType: staffVia,
        accountNumber: '',
        isCredited: false,
        totalAmount: Number(staffAmount),
        remark: staffRemark,
        staffType: staffType,
        date: this.staffInvoiceDate ? Date.parse(this.staffInvoiceDate) : Date.now()
      };
      var invoiceViaAccount = {
        brand: this.selectedBrand,
        brandFinYear: this.brandFinYear,
        type: 'automatic invoice',
        transactionType: 'Staff',
        firm: firmOfStaff,
        paymentType: staffVia,
        accountNumber: accountOfStaff,
        isCredited: false,
        totalAmount: Number(staffAmount),
        remark: staffRemark,
        staffType: staffType,
        date: this.staffInvoiceDate ? Date.parse(this.staffInvoiceDate) : Date.now()
      };
      if (staffVia == 'cash') {
        this.$root.$firebaseRefs.invoice.push(invoiceViaCash);
      } else {
        this.$root.$firebaseRefs.invoice.push(invoiceViaAccount);
      }
    },


    // Transfer Functionality

    transferAmount: function transferAmount() {
      switch (this.transferCategory) {
        case 'B2B':
          {
            this.bankToBank();
            break;
          }
        case 'C2B':
          {
            this.cashToBank();
            break;
          }
        case 'B2C':
          {
            this.bankToCash();
            break;
          }
      }
    },
    bankToBank: function bankToBank() {
      var self = this;
      var result = this.checkForSameAccount();
      var accountFromFirm = null,
          fromAccount = null,
          accountToFirm = null,
          toAccount = null;
      if (result) {
        if (this.transferTotalAmount == null) {
          this.snackbar = true;
          this.snackbarText = 'Amount cannot be empty';
        } else {
          this.$root.$firebaseRefs.account.child(this.selectedAccountFromAccount).once('value').then(function (snap) {
            accountFromFirm = snap.val().firm;
            fromAccount = snap.val().accountnumber;
            if (Number(snap.val().amount) >= Number(self.transferTotalAmount)) {
              var amount = Number(self.transferTotalAmount);
              self.$root.$firebaseRefs.account.child(self.selectedAccountFromAccount).update({
                amount: Number(snap.val().amount) - Number(self.transferTotalAmount)
              });
              self.$root.$firebaseRefs.account.child(self.selectedAccountToAccount).once('value').then(function (snap) {
                accountToFirm = snap.val().firm;
                toAccount = snap.val().accountnumber;
                self.$root.$firebaseRefs.account.child(self.selectedAccountToAccount).update({
                  amount: Number(snap.val().amount) + Number(self.transferTotalAmount)
                });
              });
              Object(__WEBPACK_IMPORTED_MODULE_5_timers__["setTimeout"])(function () {
                self.addInvoice(self.bankTransferData.firm, self.bankTransferData.firm, fromAccount, toAccount, self.transferTotalAmount, 'Transfer', self.selectedAccountFromAccount, self.selectedAccountToAccount);
                self.reduceFromToAccount();
              }, 1000);
            } else {
              self.snackbar = true;
              self.snackbarText = 'Insufficient Balance';
            }
          });
        }
      } else {
        this.snackbar = true;
        this.snackbarText = 'Both Accounts cannot be same';
      }
    },
    bankToCash: function bankToCash() {
      var self = this;
      var fromAccount = null;
      if (this.transferTotalAmount == null) {
        this.snackbar = true;
        this.snackbarText = 'Amount cannot be empty';
      } else {
        this.$root.$firebaseRefs.account.child(this.selectedAccountFromAccount).once('value').then(function (snap) {
          fromAccount = snap.val().accountnumber;
          if (Number(snap.val().amount) >= Number(self.transferTotalAmount)) {
            var amount = Number(self.transferTotalAmount);
            self.$root.$firebaseRefs.account.child(self.selectedAccountFromAccount).update({
              amount: Number(snap.val().amount) - Number(self.transferTotalAmount)
            });

            self.$root.$firebaseRefs.firm.child(self.bankTransferData.firm).once('value').then(function (snap) {
              self.$root.$firebaseRefs.firm.child(self.bankTransferData.firm).update({
                amount: Number(snap.val().amount) + Number(self.transferTotalAmount)
              });
            });
            Object(__WEBPACK_IMPORTED_MODULE_5_timers__["setTimeout"])(function () {
              self.addInvoice(self.bankTransferData.firm, self.bankTransferData.firm, fromAccount, '', self.transferTotalAmount, 'Transfer', self.selectedAccountFromAccount, null);
              self.reduceFromToAccount();
            }, 1000);
          } else {
            self.snackbar = true;
            self.snackbarText = 'Insufficient Balance';
          }
        });
      }
    },
    cashToBank: function cashToBank() {
      var self = this;
      var toAccount = null;
      if (this.transferTotalAmount == null) {
        this.snackbar = true;
        this.snackbarText = 'Amount cannot be empty';
      } else {
        this.$root.$firebaseRefs.firm.child(this.bankTransferData.firm).once('value').then(function (snap) {

          if (Number(snap.val().amount) >= Number(self.transferTotalAmount)) {
            var amount = Number(self.transferTotalAmount);
            self.$root.$firebaseRefs.firm.child(self.bankTransferData.firm).update({
              amount: Number(snap.val().amount) - Number(self.transferTotalAmount)
            });

            self.$root.$firebaseRefs.account.child(self.selectedAccountToAccount).once('value').then(function (snap) {
              toAccount = snap.val().accountnumber;
              self.$root.$firebaseRefs.account.child(self.selectedAccountToAccount).update({
                amount: Number(snap.val().amount) + Number(self.transferTotalAmount)
              });
            });
            Object(__WEBPACK_IMPORTED_MODULE_5_timers__["setTimeout"])(function () {
              self.addInvoice(self.bankTransferData.firm, self.bankTransferData.firm, '', toAccount, self.transferTotalAmount, 'Transfer', null, self.selectedAccountToAccount);
              self.reduceFromToAccount();
            }, 1000);
          } else {
            self.snackbar = true;
            self.snackbarText = 'Insufficient Balance';
          }
        });
      }
    },
    reduceFromToAccount: function reduceFromToAccount() {
      var self = this;
      self.snackbarSuccess = true;
      self.snackbarSuccessText = 'Amount Transfered';
      self.transferTotalAmount = null;
      self.selectedAccountFromAccount = null;
      self.selectedAccountToAccount = null;
      self.bankTransferData.firm = null;
      self.bankTransferData.dipositeVia = null;
      self.bankTransferData.remark = null;
      self.bankTransferType = null;
    },
    checkForSameAccount: function checkForSameAccount() {
      if (this.selectedAccountToAccount != null && this.selectedAccountFromAccount != null) {
        if (this.selectedAccountFromAccount == this.selectedAccountToAccount) {
          this.snackbar = true;
          this.snackbarText = 'Both Accounts cannot be same';
          return false;
        } else {
          return true;
        }
      }
    },


    // Deposit Functionality

    depositAmount: function depositAmount() {
      var self = this;
      if (this.depositRemark != null) {
        if (this.depositTotalAmount != null) {
          if (this.depositVia == 'cash') {
            if (this.selectedFirmToDeposit != null) {
              this.$root.$firebaseRefs.firm.child(this.selectedFirmToDeposit).once('value').then(function (snap) {
                self.$root.$firebaseRefs.firm.child(self.selectedFirmToDeposit).update({
                  amount: Number(snap.val().amount) + Number(self.depositTotalAmount)
                });
              });
              self.snackbarSuccess = true;
              self.snackbarSuccessText = "Amount Deposited";
              Object(__WEBPACK_IMPORTED_MODULE_5_timers__["setTimeout"])(function () {
                self.addInvoiceDeposit(self.depositVia, self.selectedFirmToDeposit, self.depositTotalAmount, self.depositRemark);
                self.depositTotalAmount = null;
                self.depositRemark = null;
                self.selectedFirmToDeposit = null;
              }, 1000);
            } else {
              this.snackbar = true;
              this.snackbarText = 'Please select firm to deposit';
            }
          } else {
            var depositAccountFirm = null;
            var depositAccountNumber = null;
            if (this.selectAccountToDeposit != null) {
              if (this.depositTotalAmount != null) {
                this.$root.$firebaseRefs.account.child(this.selectAccountToDeposit).once('value').then(function (snap) {
                  depositAccountFirm = snap.val().firm;
                  depositAccountNumber = snap.val().accountnumber;
                  self.$root.$firebaseRefs.account.child(self.selectAccountToDeposit).update({
                    amount: Number(snap.val().amount) + Number(self.depositTotalAmount)
                  });
                  self.snackbarSuccess = true;
                  self.snackbarSuccessText = "Amount Deposited";
                  Object(__WEBPACK_IMPORTED_MODULE_5_timers__["setTimeout"])(function () {
                    self.addInvoiceDeposit(self.depositVia, depositAccountFirm, self.depositTotalAmount, self.depositRemark, depositAccountNumber);
                    self.depositTotalAmount = null;
                    self.depositRemark = null;
                    self.selectAccountToDeposit = null;
                  });
                });
              } else {
                this.snackbar = true;
                this.snackbarText = 'Please enter an amount';
              }
            } else {
              this.snackbar = true;
              this.snackbarText = 'Please select account to deposit';
            }
          }
        }
      }
    },


    // Withdrawl Functionality

    withdrawlAmount: function withdrawlAmount() {
      var self = this;
      if (this.withdrawlRemark != null) {
        if (this.withdrawlTotalAmount != null) {
          if (this.withdrawlVia == 'cash') {
            this.$root.$firebaseRefs.firm.child(this.selectedFirmToWithdrawl).once('value').then(function (snap) {
              if (Number(snap.val().amount) >= self.withdrawlTotalAmount) {
                self.$root.$firebaseRefs.firm.child(self.selectedFirmToWithdrawl).update({
                  amount: Number(snap.val().amount) - Number(self.withdrawlTotalAmount)
                });
                self.snackbarSuccess = true;
                self.snackbarSuccessText = "amount Withdrawn";
                Object(__WEBPACK_IMPORTED_MODULE_5_timers__["setTimeout"])(function () {
                  self.addInvoiceWithdrawl(self.withdrawlVia, self.selectedFirmToWithdrawl, self.withdrawlTotalAmount, self.withdrawlRemark);
                  self.withdrawlTotalAmount = null;
                  self.withdrawlRemark = null;
                  self.selectedFirmToWithdrawl = null;
                }, 1000);
              } else {
                self.snackbar = true;
                self.snackbarText = 'Insufficient Balance to Withdraw';
              }
            });
          } else {
            var withdrawlAccountNumber = null;
            var withdrawlAccountFirm = null;
            this.$root.$firebaseRefs.account.child(this.selectAccountToWithdrawl).once('value').then(function (snap) {
              withdrawlAccountFirm = snap.val().firm;
              withdrawlAccountNumber = snap.val().accountnumber;
              if (Number(snap.val().amount) >= self.withdrawlTotalAmount) {
                self.$root.$firebaseRefs.account.child(self.selectAccountToWithdrawl).update({
                  amount: Number(snap.val().amount) - Number(self.withdrawlTotalAmount)
                });
                self.snackbarSuccess = true;
                self.snackbarSuccessText = "amount withdrawn";
                Object(__WEBPACK_IMPORTED_MODULE_5_timers__["setTimeout"])(function () {
                  self.addInvoiceWithdrawl(self.withdrawlVia, withdrawlAccountFirm, self.withdrawlTotalAmount, self.withdrawlRemark, withdrawlAccountNumber);
                  self.withdrawlTotalAmount = null;
                  self.withdrawlRemark = null;
                  self.selectAccountToWithdrawl = null;
                });
              } else {
                self.snackbar = true;
                self.snackbarText = 'Insufficient Balance to Withdraw';
              }
            });
          }
        }
      }
    },


    // Expense Functionality

    expenseAmountClick: function expenseAmountClick(e) {
      var self = this;
      if (this.expenseRemark != null) {
        if (this.expenseAmount != null) {
          if (this.selectExpense != null) {
            if (this.expenseVia == 'cash') {
              this.$root.$firebaseRefs.firm.child(this.selectedFirmFromExpense).once('value').then(function (snap) {
                if (Number(snap.val().amount) >= self.expenseAmount) {
                  self.$root.$firebaseRefs.firm.child(self.selectedFirmFromExpense).update({
                    amount: Number(snap.val().amount) - Number(self.expenseAmount)
                  });
                  self.snackbarSuccess = true;
                  self.snackbarSuccessText = "expense amount paid";
                  Object(__WEBPACK_IMPORTED_MODULE_5_timers__["setTimeout"])(function () {
                    self.addInvoiceExpense(self.expenseVia, self.selectExpense, self.selectedFirmFromExpense, self.expenseAmount, self.expenseRemark);
                    self.expenseAmount = null;
                    self.selectedFirmFromExpense = null;
                    self.expenseRemark = null;
                    self.selectExpense = null;
                  });
                } else {
                  self.snackbar = true;
                  self.snackbarText = 'Insufficient Balance';
                }
              });
            } else {
              var expenseAccountFirm = null;
              var expenseAccountNumber = null;
              this.$root.$firebaseRefs.account.child(this.selectAccountFromExpense).once('value').then(function (snap) {
                expenseAccountFirm = snap.val().firm;
                expenseAccountNumber = snap.val().accountnumber;
                if (Number(snap.val().amount) >= self.expenseAmount) {
                  self.$root.$firebaseRefs.account.child(self.selectAccountFromExpense).update({
                    amount: Number(snap.val().amount) - Number(self.expenseAmount)
                  });
                  self.snackbarSuccess = true;
                  self.snackbarSuccessText = "expense amount paid";
                  Object(__WEBPACK_IMPORTED_MODULE_5_timers__["setTimeout"])(function () {
                    self.addInvoiceExpense(self.expenseVia, self.selectExpense, expenseAccountFirm, self.expenseAmount, self.expenseRemark, expenseAccountNumber);
                    self.expenseAmount = null;
                    self.selectAccountFromExpense = null;
                    self.expenseRemark = null;
                    self.selectExpense = null;
                  });
                } else {
                  self.snackbar = true;
                  self.snackbarText = 'Insufficient Balance';
                }
              });
            }
          } else {
            this.snackbar = true;
            this.snackbarText = 'Please enter a expense type';
          }
        } else {
          this.snackbar = true;
          this.snackbarText = 'Please enter an amount';
        }
      } else {
        this.snackbar = true;
        this.snackbarText = 'Please enter a remark';
      }
    },
    addExpense: function addExpense(e) {
      var expenseData = {
        brand: this.selectedBrand,
        expense: e.target.value
      };
      this.$root.$firebaseRefs.expenses.push(expenseData);
    },

    // Staff Functionality

    staffAmountClick: function staffAmountClick(e) {
      var self = this;
      if (this.staffRemark != null) {
        if (this.staffAmount != null) {
          if (this.selectStaff != null) {
            if (this.staffVia == 'cash') {
              this.$root.$firebaseRefs.firm.child(this.selectedFirmFromStaff).once('value').then(function (snap) {
                if (Number(snap.val().amount) >= self.staffAmount) {
                  self.$root.$firebaseRefs.firm.child(self.selectedFirmFromStaff).update({
                    amount: Number(snap.val().amount) - Number(self.staffAmount)
                  });
                  self.snackbarSuccess = true;
                  self.snackbarSuccessText = "staff amount paid";
                  Object(__WEBPACK_IMPORTED_MODULE_5_timers__["setTimeout"])(function () {
                    self.addInvoiceStaff(self.staffVia, self.selectStaff, self.selectedFirmFromStaff, self.staffAmount, self.staffRemark);
                    self.staffAmount = null;
                    self.selectedFirmFromStaff = null;
                    self.staffRemark = null;
                    self.selectStaff = null;
                  });
                } else {
                  self.snackbar = true;
                  self.snackbarText = 'Insufficient Balance To Pay';
                }
              });
            } else {
              var staffAccountFirm = null;
              var staffAccountNumber = null;
              this.$root.$firebaseRefs.account.child(this.selectAccountFromStaff).once('value').then(function (snap) {
                staffAccountFirm = snap.val().firm;
                staffAccountNumber = snap.val().accountnumber;
                if (Number(snap.val().amount) >= self.staffAmount) {
                  self.$root.$firebaseRefs.account.child(self.selectAccountFromStaff).update({
                    amount: Number(snap.val().amount) - Number(self.staffAmount)
                  });
                  self.snackbarSuccess = true;
                  self.snackbarSuccessText = "staff amount paid";
                  Object(__WEBPACK_IMPORTED_MODULE_5_timers__["setTimeout"])(function () {
                    self.addInvoiceStaff(self.staffVia, self.selectStaff, staffAccountFirm, self.staffAmount, self.staffRemark, staffAccountNumber);
                    self.staffAmount = null;
                    self.selectAccountFromStaff = null;
                    self.staffRemark = null;
                    self.selectStaff = null;
                  });
                } else {
                  self.snackbar = true;
                  self.snackbarText = 'Insufficient Balance To Pay';
                }
              });
            }
          } else {
            this.snackbar = true;
            this.snackbarText = 'Please enter a staff Name';
          }
        } else {
          this.snackbar = true;
          this.snackbarText = 'Please enter an amount';
        }
      } else {
        this.snackbar = true;
        this.snackbarText = 'Please enter a remark';
      }
    },
    addStaff: function addStaff(e) {
      var staffData = {
        brand: this.selectedBrand,
        staff: e.target.value
      };
      this.$root.$firebaseRefs.staffs.push(staffData);
    },

    // Income Functionality
    incomeAmountClick: function incomeAmountClick(e) {
      var self = this;
      if (this.incomeRemark != null) {
        if (this.incomeAmount != null) {
          if (this.selectIncome != null) {
            if (this.incomeVia == 'cash') {
              this.$root.$firebaseRefs.firm.child(this.selectedFirmFromIncome).once('value').then(function (snap) {
                // if(Number(snap.val().amount) >= self.incomeAmount) 
                {
                  self.$root.$firebaseRefs.firm.child(self.selectedFirmFromIncome).update({
                    amount: Number(snap.val().amount) + Number(self.incomeAmount)
                  });
                  self.snackbarSuccess = true;
                  self.snackbarSuccessText = "Income Received";
                  Object(__WEBPACK_IMPORTED_MODULE_5_timers__["setTimeout"])(function () {
                    self.addInvoiceIncome(self.incomeVia, self.selectIncome, self.selectedFirmFromIncome, self.incomeAmount, self.incomeRemark);
                    self.incomeAmount = null;
                    self.selectedFirmFromIncome = null;
                    self.incomeRemark = null;
                    self.selectIncome = null;
                  });
                }
              });
            } else {
              var incomeAccountFirm = null;
              var incomeAccountNumber = null;
              this.$root.$firebaseRefs.account.child(this.selectAccountFromIncome).once('value').then(function (snap) {
                incomeAccountFirm = snap.val().firm;
                incomeAccountNumber = snap.val().accountnumber;
                // if(Number(snap.val().amount) >= self.incomeAmount)
                {
                  self.$root.$firebaseRefs.account.child(self.selectAccountFromIncome).update({
                    amount: Number(snap.val().amount) + Number(self.incomeAmount)
                  });
                  self.snackbarSuccess = true;
                  self.snackbarSuccessText = "Income Received";
                  Object(__WEBPACK_IMPORTED_MODULE_5_timers__["setTimeout"])(function () {
                    self.addInvoiceIncome(self.incomeVia, self.selectIncome, incomeAccountFirm, self.incomeAmount, self.incomeRemark, incomeAccountNumber);
                    self.incomeAmount = null;
                    self.selectAccountFromIncome = null;
                    self.incomeRemark = null;
                    self.selectIncome = null;
                  });
                }
              });
            }
          } else {
            this.snackbar = true;
            this.snackbarText = 'Please enter Income Source';
          }
        } else {
          this.snackbar = true;
          this.snackbarText = 'Please enter an Amount Recieved';
        }
      } else {
        this.snackbar = true;
        this.snackbarText = 'Please enter a Remark';
      }
    },
    addIncome: function addIncome(e) {
      var incomeData = {
        brand: this.selectedBrand,
        income: e.target.value
      };
      this.$root.$firebaseRefs.incomes.push(incomeData);
    },

    // Income Functionality
    assetAmountClick: function assetAmountClick(e) {
      var self = this;
      if (this.assetRemark != null) {
        if (this.assetAmount != null) {
          if (this.selectAsset != null) {
            if (this.assetVia == 'cash') {
              this.$root.$firebaseRefs.firm.child(this.selectedFirmFromAsset).once('value').then(function (snap) {
                // if(Number(snap.val().amount) >= self.incomeAmount) 
                {
                  self.$root.$firebaseRefs.firm.child(self.selectedFirmFromAsset).update({
                    amount: Number(snap.val().amount) + Number(self.assetAmount)
                  });
                  self.snackbarSuccess = true;
                  self.snackbarSuccessText = "assets Received";
                  Object(__WEBPACK_IMPORTED_MODULE_5_timers__["setTimeout"])(function () {
                    self.addInvoiceAsset(self.assetVia, self.selectAsset, self.selectedFirmFromAsset, self.assetAmount, self.assetRemark);
                    self.assetAmount = null;
                    self.selectedFirmFromAsset = null;
                    self.assetRemark = null;
                    self.selectAsset = null;
                  });
                }
              });
            } else {
              var assetAccountFirm = null;
              var assetAccountNumber = null;
              this.$root.$firebaseRefs.account.child(this.selectAccountFromAsset).once('value').then(function (snap) {
                assetAccountFirm = snap.val().firm;
                assetAccountNumber = snap.val().accountnumber;
                // if(Number(snap.val().amount) >= self.incomeAmount)
                {
                  self.$root.$firebaseRefs.account.child(self.selectAccountFromAsset).update({
                    amount: Number(snap.val().amount) + Number(self.assetAmount)
                  });
                  self.snackbarSuccess = true;
                  self.snackbarSuccessText = "Assets Maintained";
                  Object(__WEBPACK_IMPORTED_MODULE_5_timers__["setTimeout"])(function () {
                    self.addInvoiceAsset(self.assetVia, self.selectAsset, assetAccountFirm, self.assetAmount, self.assetRemark, assetAccountNumber);
                    self.assetAmount = null;
                    self.selectAccountFromAsset = null;
                    self.assetRemark = null;
                    self.selectAsset = null;
                  });
                }
              });
            }
          } else {
            this.snackbar = true;
            this.snackbarText = 'Please enter Asset Source';
          }
        } else {
          this.snackbar = true;
          this.snackbarText = 'Please enter an Asset Amount';
        }
      } else {
        this.snackbar = true;
        this.snackbarText = 'Please enter a Remark';
      }
    },
    addAsset: function addAsset(e) {
      var assetData = {
        brand: this.selectedBrand,
        asset: e.target.value
      };
      this.$root.$firebaseRefs.assets.push(assetData);
    }
  },
  watch: {
    transferType: function transferType(newVal, oldVal) {
      console.log(newVal);
      if (oldVal !== newVal) {
        switch (newVal) {

          case 'Transfer':
            {
              this.transfer = true;
              this.deposit = false;
              this.withdrawl = false;
              break;
            }
          case 'Deposit':
            {
              this.transfer = false;
              this.deposit = true;
              this.withdrawl = false;
              break;
            }
          case 'Withdrawl':
            {
              this.transfer = false;
              this.deposit = false;
              this.withdrawl = true;
              break;
            }
        }
      }
    }
  }
});

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__table_expenseTable_vue__ = __webpack_require__(1367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_digitsToWords_js__ = __webpack_require__(35);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'ExpenseTab',
    props: {
        selectedBrand: { type: String },
        accountsByBrand: { type: Array },
        firmsByBrand: { type: Array }
    },
    components: {
        ExpenseTableInfo: __WEBPACK_IMPORTED_MODULE_3__table_expenseTable_vue__["a" /* default */]
    },
    data: function data() {
        return {
            openExpenseTable: false,
            openProvisionTable: false,
            datepicker: false,
            hintText: null,
            selectedFirm: this.firmsByBrand[0].value,
            selectedFirmFromExpense: this.firmsByBrand[0].value,
            isOpeningBalance: null,
            isGSTApplicable: null,
            taxableGST_rate: null,
            GST_type: null,
            isRCMApplicable: null,
            taxableAmount: null,
            GST_types_list: ['CGST|SGST', 'IGST'],
            // GST_types_list:['IGST','SGST|CGST'],
            selectAccountFromExpense: null,
            categotyList: ['Direct', 'Indirect'],
            underHeadList: ['Prop Capital A/C', 'Profit and Loss'],
            expenseInvoiceDate: null,
            expenseVia: 'cash',
            addError: null,
            selectExpense: null,
            expenseCategory: null,
            expenseUnderHead: null,
            expenseOpeningBalance: null,
            expenseRemark: null,
            expenseAmount: null,
            selectedFirmOpeningBalance: null,
            firmExpense: [],
            selectedFirmProvisionFilter: null,
            provisionHeader: [{ text: "Id", value: ".key", sortable: false }, { text: "Firm Name", value: "firm", sortable: true }, { text: "Date", value: "expense", sortable: true }, { text: "Opening WDV", value: "openingBalance", sortable: false }, { text: "Credit", value: "totalAmount", sortable: false }, { text: "Debit", value: "totalAmount", sortable: false }, { text: "Running Balance", value: "totalAmount", sortable: false }, { text: "Closing WDV", sortable: false }, { text: "paymentType", value: ".key", sortable: false }, { text: "remark", value: "type", sortable: true }, { text: "paymentTypeStatus", value: "paymentTypeStatus", sortable: false }]
        };
    },
    created: function created() {
        this.$bindAsArray('provisionExpense', this.$root.$firebaseRefs.provisionExpense.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray('banks', this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray("firmList", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray("expenses", this.$root.$firebaseRefs.expenses.orderByChild('brand').equalTo(this.selectedBrand));
        var today = new Date();
        this.expenseInvoiceDate = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["brandFinYear"]), {
        expenseByBrand: function expenseByBrand() {
            var _this = this;

            return this.expenses.filter(function (item) {
                return item['brand'] === _this.selectedBrand;
            }).map(function (item) {
                return {
                    expense: item,
                    text: item['expense'],
                    value: item['.key']
                };
            });
        },
        banksByFirm: function banksByFirm() {
            var _this2 = this;

            return this.banks.filter(function (item) {
                return item['brand'] === _this2.selectedBrand && item['firm'] == _this2.selectedFirmFromExpense;
            }).map(function (item) {
                return {
                    account: item,
                    text: item['accountnumber'],
                    value: item['.key']
                };
            });
        },
        provisionByBrand: function provisionByBrand() {
            var _this3 = this;

            var provision = this.provisionExpense.filter(function (item) {
                return item['brand'] === _this3.selectedBrand && (_this3.selectedFirmProvisionFilter ? _this3.selectedFirmProvisionFilter === item["firm"] : true);
            });
            provision.map(function (p, index) {
                if (p.isCredited) {
                    provision[index]["debit"] = provision[index]["totalAmount"];
                    provision[index]["credit"] = 0;
                } else {
                    provision[index]["credit"] = provision[index]["totalAmount"];
                    provision[index]["debit"] = 0;
                }
                provision[index]["RunningBal"] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(provision[index]["debit"]) - __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(provision[index]["credit"]) + (index == 0 ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(provision[index]["RunningBal"]));
            });
            return provision;
        },
        selectedExpenseType: function selectedExpenseType() {
            var _this4 = this;

            if (this.selectExpense) {
                var expense = this.expenses.find(function (item) {
                    return item['.key'] === _this4.selectExpense;
                });
                this.expenseUnderHead = expense.underHead;
                this.expenseCategory = expense.category;
                return expense;
            }
            return {};
        }
    }),
    watch: {
        "selectedFirmFromExpense": {
            handler: function handler(newVal, oldVal) {
                if (newVal != oldVal) {
                    // let firm = this.firmList.filter(item => item[".key"] === newVal)[0];  
                    // this.selectedFirmOpeningBalance = firm.openingBalance
                    this.getFirmExpense();
                }
            },

            deep: true
        },
        "selectExpense": {
            handler: function handler(newVal, oldVal) {
                if (newVal != oldVal) {
                    this.getFirmExpense();
                }
            },

            deep: true
        },
        "expenseAmount": {
            handler: function handler() {
                this.hintText = this.expenseAmount ? _.startCase(Object(__WEBPACK_IMPORTED_MODULE_4__utils_digitsToWords_js__["a" /* digitsToWords */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.expenseAmount))) : null;
            },

            deep: true
        }
    },
    methods: {
        getFirmExpense: function getFirmExpense() {
            var _this5 = this;

            this.selectedFirm = this.firmsByBrand.filter(function (item) {
                return item['value'] == _this5.selectedFirmFromExpense;
            })[0];
            console.log(this.selectedFirm);
            var firmExpense = this.invoices.filter(function (item) {
                return item["firm"] === _this5.selectedFirmFromExpense && item["expenseType"] === _this5.selectExpense;
            });
            this.firmExpense = firmExpense;
            var openingBalance = 0;
            firmExpense.map(function (inv) {
                openingBalance += inv.openingBalance ? parseInt(inv.openingBalance) : 0;
            });
            this.selectedFirmOpeningBalance = openingBalance;
            if (firmExpense.length && firmExpense[0].isGSTApplicable) {
                this.isGSTApplicable = firmExpense[0].isGSTApplicable;
            }
            if (firmExpense.length && firmExpense[0].taxableGST_rate) {
                this.taxableGST_rate = firmExpense[0].taxableGST_rate;
            }
            if (firmExpense.length && firmExpense[0].GST_type) {
                this.GST_type = firmExpense[0].GST_type;
            }
            if (firmExpense.length && firmExpense[0].isRCMApplicable) {
                this.isRCMApplicable = firmExpense[0].isRCMApplicable;
            }
        },
        getFirmName: function getFirmName(e) {
            var firm = void 0;
            if (this.firmList && this.selectedBrand) {
                firm = this.firmList.filter(function (item) {
                    return item['.key'] === e;
                })[0];
            }
            if (firm) return firm.name;
        },
        reset: function reset() {
            this.expenseAmount = null;
            this.selectedFirmFromExpense = null;
            this.selectAccountFromExpense = null;
            this.expenseRemark = null;
            this.selectExpense = null;
            this.expenseVia = null;
            this.expenseCategory = null;
            this.expenseUnderHead = null;
            this.expenseOpeningBalance = null;
            // this.GST_type = '';
            this.GST_types_list = ['CGST|SGST', 'IGST'];
            this.taxableGST_rate = null;
            this.taxableAmount = null;
            var today = new Date();
            this.expenseInvoiceDate = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
            this.firmExpense = [];
            this.selectedFirmOpeningBalance = null;
            this.$emit('closedialog');
        },

        expenseAmountClick: function expenseAmountClick(e) {
            var _this6 = this;

            if (this.expenseRemark != null) {
                if (this.selectExpense != null) {
                    // expenseData updated with category and underhead on expense create
                    if (this.expenseCategory !== this.selectedExpenseType.category || this.expenseUnderHead !== this.selectedExpenseType.underHead) {
                        this.$root.$firebaseRefs.expenses.child(this.selectExpense).update({
                            category: this.expenseCategory,
                            underHead: this.expenseUnderHead
                        });
                    }
                    if (this.expenseVia == 'cash') {
                        // let expenseAmount = Number.parseFloat(this.isGSTApplicable && this.isRCMApplicable ? this.taxableAmount : ((this.isGSTApplicable && !this.isRCMApplicable) ? (this.taxableAmount+ ((this.taxableAmount* this.taxableGST_rate)/100)) :this.expenseAmount));
                        var expenseAmount = this.isGSTApplicable && this.isRCMApplicable ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.taxableAmount) : this.isGSTApplicable && !this.isRCMApplicable ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.taxableAmount) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.taxableAmount) * this.taxableGST_rate / 100 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.expenseAmount);
                        this.$root.$firebaseRefs.firm.child(this.selectedFirmFromExpense).once('value').then(function (snap) {
                            if (Number(snap.val().amount) >= expenseAmount) {
                                _this6.$root.$firebaseRefs.firm.child(_this6.selectedFirmFromExpense).update({
                                    amount: Number(snap.val().amount) - Number(expenseAmount)
                                });
                                setTimeout(function () {
                                    _this6.addInvoiceExpense({
                                        expenseVia: _this6.expenseVia,
                                        expenseType: _this6.selectExpense,
                                        firmOfExpense: _this6.selectedFirmFromExpense,
                                        expenseAmount: _this6.expenseAmount,
                                        expenseRemark: _this6.expenseRemark,
                                        openingBalance: _this6.expenseOpeningBalance
                                    });
                                });
                            } else {
                                _this6.$emit('notify', 'Insufficient Balance');
                            }
                        });
                    } else if (this.expenseVia == 'account') {
                        var expenseAccountFirm = null;
                        var expenseAccountNumber = null;
                        // let expenseAmount = this.isGSTApplicable && this.isRCMApplicable ? this.taxableAmount : ((this.isGSTApplicable && !this.isRCMApplicable) ? (this.taxableAmount+ ((this.taxableAmount* this.taxableGST_rate)/100)) :this.expenseAmount);
                        var _expenseAmount = this.isGSTApplicable && this.isRCMApplicable ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.taxableAmount) : this.isGSTApplicable && !this.isRCMApplicable ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.taxableAmount) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.taxableAmount) * this.taxableGST_rate / 100 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.expenseAmount);
                        this.$root.$firebaseRefs.account.child(this.selectAccountFromExpense).once('value').then(function (snap) {
                            expenseAccountFirm = snap.val().firm;
                            expenseAccountNumber = snap.val().accountnumber;
                            if (Number(snap.val().amount) >= _expenseAmount) {
                                _this6.$root.$firebaseRefs.account.child(_this6.selectAccountFromExpense).update({
                                    amount: Number(snap.val().amount) - Number(_expenseAmount)
                                });
                                _this6.$emit('notify', "expense amount paid", true);
                                setTimeout(function () {
                                    _this6.addInvoiceExpense({
                                        expenseVia: _this6.expenseVia,
                                        expenseType: _this6.selectExpense,
                                        firmOfExpense: expenseAccountFirm,
                                        expenseAmount: _this6.expenseAmount,
                                        expenseRemark: _this6.expenseRemark,
                                        accountOfExpense: expenseAccountNumber,
                                        openingBalance: _this6.expenseOpeningBalance
                                    });
                                });
                            } else {
                                _this6.$emit('notify', 'Insufficient Balance');
                            }
                        });
                    } else {
                        this.addInvoiceExpense({
                            expenseVia: this.expenseVia,
                            expenseType: this.selectExpense,
                            firmOfExpense: this.selectedFirmFromExpense,
                            expenseAmount: this.expenseAmount,
                            expenseRemark: this.expenseRemark,
                            openingBalance: this.expenseOpeningBalance
                        });
                    }
                } else {
                    this.$emit('notify', 'Please enter a expense type');
                }
            } else {
                this.$emit('notify', 'Please enter a remark');
            }
        },
        addExpense: function addExpense(e) {
            var _this7 = this;

            var expenseData = {
                brand: this.selectedBrand,
                expense: e.target.value,
                category: null,
                underHead: null
            };
            var availableExpensis = this.expenses.filter(function (item) {
                return item.expense == e.target.value && item['brand'] === _this7.selectedBrand;
            });
            if (availableExpensis.length) {
                this.addError = 'Expense with name ' + e.target.value + ' Already exist.';
                setTimeout(function () {
                    _this7.addError = null;
                }, 3000);
            } else {
                this.$root.$firebaseRefs.expenses.push(expenseData);
            }
            // push expense without category and underhead
        },
        // Expense Invoice
        addInvoiceExpense: function addInvoiceExpense(_ref) {
            var _this8 = this;

            var expenseVia = _ref.expenseVia,
                expenseType = _ref.expenseType,
                firmOfExpense = _ref.firmOfExpense,
                expenseAmount = _ref.expenseAmount,
                expenseRemark = _ref.expenseRemark,
                accountOfExpense = _ref.accountOfExpense,
                openingBalance = _ref.openingBalance;

            if (expenseVia == 'cash') {
                var invoiceViaCash = {
                    brand: this.selectedBrand,
                    brandFinYear: this.brandFinYear,
                    type: 'automatic invoice',
                    transactionType: 'Expense',
                    firm: firmOfExpense,
                    paymentType: expenseVia,
                    accountNumber: '',
                    paymentTypeStatus: 'confirm',
                    isCredited: false,
                    totalAmount: Number(expenseAmount),
                    remark: expenseRemark,
                    expenseType: expenseType,
                    openingBalance: openingBalance,
                    date: this.expenseInvoiceDate ? Date.parse(this.expenseInvoiceDate) : Date.now()
                };

                if (this.isGSTApplicable) {
                    invoiceViaCash['isGSTApplicable'] = this.isGSTApplicable;
                }

                if (this.taxableGST_rate) {
                    invoiceViaCash['taxableGST_rate'] = this.taxableGST_rate;
                }

                if (this.GST_type) {
                    invoiceViaCash['GST_type'] = this.GST_type;
                }

                if (this.isRCMApplicable) {
                    invoiceViaCash['isRCMApplicable'] = this.isRCMApplicable;
                }

                if (this.taxableAmount) {
                    invoiceViaCash['taxableAmount'] = this.taxableAmount;
                }
                this.$root.$firebaseRefs.invoice.push(invoiceViaCash, function () {
                    _this8.$emit('notify', "expense amount paid", true);
                    _this8.reset();
                });
            } else if (expenseVia == 'account') {
                var invoiceViaAccount = {
                    brand: this.selectedBrand,
                    brandFinYear: this.brandFinYear,
                    type: 'automatic invoice',
                    transactionType: 'Expense',
                    firm: firmOfExpense,
                    paymentType: expenseVia,
                    accountNumber: accountOfExpense,
                    isCredited: false,
                    bank: this.selectAccountFromExpense,
                    paymentTypeStatus: 'confirm',
                    totalAmount: Number(expenseAmount),
                    remark: expenseRemark,
                    expenseType: expenseType,
                    openingBalance: openingBalance,
                    date: this.expenseInvoiceDate ? Date.parse(this.expenseInvoiceDate) : Date.now()
                };

                if (this.isGSTApplicable) {
                    invoiceViaAccount['isGSTApplicable'] = this.isGSTApplicable;
                }

                if (this.taxableGST_rate) {
                    invoiceViaAccount['taxableGST_rate'] = this.taxableGST_rate;
                }

                if (this.GST_type) {
                    invoiceViaAccount['GST_type'] = this.GST_type;
                }

                if (this.isRCMApplicable) {
                    invoiceViaAccount['isRCMApplicable'] = this.isRCMApplicable;
                }

                if (this.taxableAmount) {
                    invoiceViaAccount['taxableAmount'] = this.taxableAmount;
                }
                this.$root.$firebaseRefs.invoice.push(invoiceViaAccount, function () {
                    _this8.$emit('notify', "expense amount paid", true);
                    _this8.reset();
                });
            } else {
                var _invoiceViaAccount = {
                    brand: this.selectedBrand,
                    brandFinYear: this.brandFinYear,
                    type: 'automatic invoice',
                    transactionType: 'Expense',
                    firm: firmOfExpense,
                    paymentType: expenseVia,
                    accountNumber: '',
                    isCredited: false,
                    paymentTypeStatus: 'yet to confirm',
                    totalAmount: Number(expenseAmount),
                    remark: expenseRemark,
                    expenseType: expenseType,
                    openingBalance: openingBalance,
                    date: this.expenseInvoiceDate ? Date.parse(this.expenseInvoiceDate) : Date.now()
                };

                if (this.isGSTApplicable) {
                    _invoiceViaAccount['isGSTApplicable'] = this.isGSTApplicable;
                }

                if (this.taxableGST_rate) {
                    _invoiceViaAccount['taxableGST_rate'] = this.taxableGST_rate;
                }

                if (this.GST_type) {
                    _invoiceViaAccount['GST_type'] = this.GST_type;
                }

                if (this.isRCMApplicable) {
                    _invoiceViaAccount['isRCMApplicable'] = this.isRCMApplicable;
                }

                if (this.taxableAmount) {
                    _invoiceViaAccount['taxableAmount'] = this.taxableAmount;
                }
                var res = this.$root.$firebaseRefs.invoice.push(_invoiceViaAccount);
                console.log(res);
                if (res.key) {
                    _invoiceViaAccount['invoiceId'] = res.key;
                    this.$root.$firebaseRefs.provisionExpense.push(_invoiceViaAccount, function () {
                        _this8.$emit('notify', "expense amount paid", true);
                        _this8.reset();
                    });
                }
            }
        }
    }
});

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_pdf_reports_expenseOverallReport_js__ = __webpack_require__(1368);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ExpenseTableInfo",
  props: {
    accountsByBrand: { type: Array },
    firmsByBrand: { type: Array }
  },
  created: function created() {
    this.$bindAsArray("expenses", this.$root.$firebaseRefs.expenses.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('firms', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('banks', this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear"]), {
    banksByFirm: function banksByFirm() {
      var _this = this;

      return this.banks.filter(function (item) {
        return item['brand'] === _this.selectedBrand && item['firm'] == _this.selectedExpenseInvoice.firm;
      });
    },
    list: function list() {
      var _this2 = this;

      var expenses = this.expenses.filter(function (expense) {
        return expense.brand === _this2.selectedBrand;
      });
      expenses = expenses.filter(function (expense) {
        return !!expense['.key'];
      });
      expenses.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var taxableAmount = 0;
        var paymentTypeStatus = 'confirm';
        var invoices = _this2.invoices.filter(function (invoice) {
          return invoice.brand === _this2.selectedBrand && invoice["expenseType"] === ex['.key'] && invoice.date >= _this2.finYear.start && invoice.date <= _this2.finYear.end;
        });
        console.log(invoices);
        invoices.map(function (inv) {
          openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
          taxableAmount += __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(inv.taxableAmount);
          totalAmount += __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          if (paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        expenses[index].paymentTypeStatus = paymentTypeStatus;
        expenses[index].taxableAmount = isNaN(taxableAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(taxableAmount).toFixed(2);
        expenses[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        expenses[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
      });
      return expenses.filter(function (e) {
        if (_this2.hideZero) {
          return parseFloat(e.totalAmount) > 0 || parseFloat(e.openingBalance) > 0;
        }
        return true;
      });
    }
  }),
  data: function data() {
    return {
      selectedExpense: [],
      selectedExpenseInvoice: {},
      selectAccountFromExpense: null,
      isConfirm: false,
      datepicker: false,
      headers: [
      // { text: "Id", value: ".key", sortable: false },
      { text: "Name", value: "expense", sortable: true }, { text: "Category", value: "category", sortable: true }, { text: "Underhead", value: "underHead", sortable: false }, { text: "Opening WDV", value: "openingBalance", sortable: false }, { text: "Amount", value: "taxableAmount", sortable: false }, { text: "Amount", value: "totalAmount", sortable: false }, { text: "Closing WDV", sortable: false }, { text: "Status", value: "paymentTypeStatus", sortable: false }, { text: "Action", sortable: false }, { text: "Edit", sortable: false }],
      expenseHeader: [
      // { text: "Id", value: ".key", sortable: false },
      { text: "Firm Name", value: "firm", sortable: true }, { text: "Date", value: "expense", sortable: true }, { text: "Opening WDV", value: "openingBalance", sortable: false }, { text: "Basic Amount", value: "taxableAmount", sortable: false }, { text: "Amount", value: "totalAmount", sortable: false }, { text: "Closing WDV", sortable: false }, { text: "Payment Type", value: ".key", sortable: false }, { text: "Remark", value: "type", sortable: true }, { text: "Status", value: "paymentTypeStatus", sortable: false }, { text: "Edit", sortable: false }, { text: "Delete", sortable: false }],
      dialog: false,
      dialogEdit: false,
      dialogEditInvoice: false,
      categotyList: ['Direct', 'Indirect'],
      underHeadList: ['Prop Capital A/C', 'Profit and Loss'],
      selectedExpenses: [],
      hideZero: false
    };
  },

  methods: {
    // getDepAmount(expense, type) {
    //   let depriciation = null;
    //   if (expense.isVerified && expense.depriciation) {
    //     const totalAmount = this.getTotalAmount(expense);
    //     depriciation = Number((totalAmount * expense.depriciation) / 100);
    //     return depriciation;
    //   }
    //   return 0;
    // },
    printOverallExpense: function printOverallExpense(expense) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var firm;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                firm = _this3.firms.filter(function (item) {
                  return item['.key'] === expense['firm'];
                })[0];
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_5__utils_pdf_reports_expenseOverallReport_js__["a" /* expenseOverallReport */])({
                  // school: this.schools.filter((item) => item.id == this.defaultSchool)[0],
                  firm: _this3.firm,
                  list: _this3.list
                }).then(function (doc) {
                  pdfMake.createPdf(doc).download('EXPENSE_REPORT_' + new Date().toLocaleDateString('en-GB'));
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    getTotalAmount: function getTotalAmount(expense) {
      return Number(expense.totalamount);
    },
    getClosingWdv: function getClosingWdv(expense) {
      return this.getTotalAmount(expense);
    },
    saveExpense: function saveExpense() {
      var _this4 = this;

      var key = this.selectedExpense['.key'];
      delete this.selectedExpense['.key'];
      this.$root.$firebaseRefs.expenses.child(key).update(this.selectedExpense).then(function (snap) {
        _this4.dialogEdit = false;
      });
    },
    saveExpenseInvoice: function saveExpenseInvoice() {
      var _this5 = this;

      this.selectedExpenseInvoice.date = new Date(this.selectedExpenseInvoice.date).getTime();
      if (this.selectedExpenseInvoice.paymentType == 'cash') {
        this.$root.$firebaseRefs.firm.child(this.selectedExpenseInvoice.firm).once('value').then(function (snap) {
          if (Number(snap.val().amount) >= _this5.selectedExpenseInvoice.totalAmount) {
            _this5.$root.$firebaseRefs.firm.child(_this5.selectedExpenseInvoice.firm).update({
              amount: Number(snap.val().amount) - Number(_this5.selectedExpenseInvoice.totalAmount)
            });
            setTimeout(function () {
              var key = _this5.selectedExpenseInvoice['.key'];
              delete _this5.selectedExpenseInvoice['.key'];
              if (_this5.isConfirm) {
                _this5.selectedExpenseInvoice['paymentTypeStatus'] = 'confirm';
              }

              _this5.$root.$firebaseRefs.invoice.child(key).update(_this5.selectedExpenseInvoice, function () {
                if (_this5.isConfirm) {
                  _this5.selectedExpenseInvoice.isCredited = true;
                  _this5.$root.$firebaseRefs.provisionExpense.push(_this5.selectedExpenseInvoice);
                }
                _this5.dialogEditInvoice = false;
              });
            });
          } else {
            console.log('Insufficient Balance');
          }
        });
      } else if (this.selectedExpenseInvoice.paymentType == 'account') {
        var expenseAccountFirm = null;
        var expenseAccountNumber = null;
        this.$root.$firebaseRefs.account.child(this.selectAccountFromExpense['.key']).once('value').then(function (snap) {
          _this5.selectedExpenseInvoice['accountNumber'] = snap.val().accountnumber;
          _this5.selectedExpenseInvoice['bank'] = _this5.selectAccountFromExpense['.key'];
          if (Number(snap.val().amount) >= _this5.selectedExpenseInvoice.totalAmount) {
            _this5.$root.$firebaseRefs.account.child(_this5.selectAccountFromExpense['.key']).update({
              amount: Number(snap.val().amount) - Number(_this5.selectedExpenseInvoice.totalAmount)
            });
            console.log("expense amount paid");
            setTimeout(function () {
              var key = _this5.selectedExpenseInvoice['.key'];
              delete _this5.selectedExpenseInvoice['.key'];
              if (_this5.isConfirm) {
                _this5.selectedExpenseInvoice['paymentTypeStatus'] = 'confirm';
              }
              _this5.$root.$firebaseRefs.invoice.child(key).update(_this5.selectedExpenseInvoice, function () {
                if (_this5.isConfirm) {
                  _this5.selectedExpenseInvoice.isCredited = true;
                  _this5.$root.$firebaseRefs.provisionExpense.push(_this5.selectedExpenseInvoice);
                }
                _this5.dialogEditInvoice = false;
              });
            });
          } else {
            console.log('Insufficient Balance');
          }
        });
      } else {
        var key = this.selectedExpenseInvoice['.key'];
        delete this.selectedExpenseInvoice['.key'];
        this.$root.$firebaseRefs.invoice.child(key).update(this.selectedExpenseInvoice).then(function (snap) {
          _this5.selectedExpenseInvoice['.key'] = key;
          _this5.dialogEditInvoice = false;
        });
      }
    },
    openExpenseDialog: function openExpenseDialog(expense) {
      var _this6 = this;

      if (expense) {
        var invoice = this.invoices.filter(function (invoice) {
          return invoice.brand === _this6.selectedBrand && invoice.transactionType === "Expense" && invoice.expenseType == expense[".key"] && invoice.date >= _this6.finYear.start && invoice.date <= _this6.finYear.end;
        });
        invoice.sort(function (a, b) {
          return -(new Date(b.date) - new Date(a.date));
        });
        this.selectedExpenses = invoice;
        this.selectedExpense = expense["expense"];
        this.dialog = true;
      }
    },
    openExpenseEdit: function openExpenseEdit(expense) {
      this.selectedExpense = expense;
      this.dialogEdit = true;
    },
    openExpenseInvoiceEdit: function openExpenseInvoiceEdit(invoice, confirmDialog) {
      this.selectedExpenseInvoice = invoice;
      this.selectedExpenseInvoice.date = new Date(this.selectedExpenseInvoice.date).toISOString("en-GB").substr(0, 10);
      this.dialogEditInvoice = true;
      this.isConfirm = confirmDialog;
    },
    openExpenseInvoiceDelete: function openExpenseInvoiceDelete(selectedExpenseInvoice) {
      if (window.confirm("Do you want to delete expense created on " + new Date(selectedExpenseInvoice['date']).toLocaleDateString('en-GB') + "?")) {
        this.$root.$firebaseRefs.invoice.child(selectedExpenseInvoice[".key"]).remove();
      }
      this.dialog = false;
    },
    getFirmName: function getFirmName(e) {
      var firm = void 0;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter(function (item) {
          return item['.key'] === e;
        })[0];
      }
      if (firm) return firm.name;
    }
  }
});

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__table_incomeTable_vue__ = __webpack_require__(1372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_digitsToWords_js__ = __webpack_require__(35);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'incomeTab',
    props: {
        selectedBrand: { type: String },
        accountsByBrand: { type: Array },
        firmsByBrand: { type: Array }
    },
    components: {
        incomeTableInfo: __WEBPACK_IMPORTED_MODULE_3__table_incomeTable_vue__["a" /* default */]
    },
    data: function data() {
        return {
            openIncomeTable: false,
            openProvisionTable: false,
            datepicker: false,
            selectedFirm: this.firmsByBrand[0].value,
            selectedFirmFromIncome: this.firmsByBrand[0].value,
            isOpeningBalance: null,
            selectAccountFromIncome: null,
            categotyList: ['Direct', 'Indirect'],
            underHeadList: ['Prop Capital A/C', 'Profit and Loss'],
            incomeInvoiceDate: null,
            hintText: null,
            incomeVia: 'cash',
            addError: null,
            selectIncome: null,
            incomeCategory: null,
            incomeUnderHead: null,
            incomeOpeningBalance: null,
            incomeRemark: null,
            incomeAmount: null,
            selectedFirmOpeningBalance: null,
            firmIncame: [],
            selectedFirmProvisionFilter: null,
            provisionHeader: [{ text: "Id", value: ".key", sortable: false }, { text: "Firm Name", value: "firm", sortable: true }, { text: "Date", value: "income", sortable: true }, { text: "Opening WDV", value: "openingBalance", sortable: false }, { text: "Credit", value: "totalAmount", sortable: false }, { text: "Debit", value: "totalAmount", sortable: false }, { text: "Running Balance", value: "totalAmount", sortable: false }, { text: "Closing WDV", sortable: false }, { text: "paymentType", value: ".key", sortable: false }, { text: "remark", value: "type", sortable: true }, { text: "paymentTypeStatus", value: "paymentTypeStatus", sortable: false }]
        };
    },
    created: function created() {
        this.$bindAsArray('provisionIncome', this.$root.$firebaseRefs.provisionIncome.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray('banks', this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray("firmList", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray("incomes", this.$root.$firebaseRefs.incomes.orderByChild('brand').equalTo(this.selectedBrand));
        var today = new Date();
        this.incomeInvoiceDate = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["brandFinYear"]), {
        incomeByBrand: function incomeByBrand() {
            var _this = this;

            return this.incomes.filter(function (item) {
                return item['brand'] === _this.selectedBrand;
            }).map(function (item) {
                return {
                    income: item,
                    text: item['income'],
                    value: item['.key']
                };
            });
        },
        banksByFirm: function banksByFirm() {
            var _this2 = this;

            return this.banks.filter(function (item) {
                return item['brand'] === _this2.selectedBrand && item['firm'] == (_this2.selectedFirmFromIncome.value || _this2.selectedFirmFromIncome);
            }).map(function (item) {
                return {
                    account: item,
                    text: item['accountnumber'],
                    value: item['.key']
                };
            });
        },
        provisionByBrand: function provisionByBrand() {
            var _this3 = this;

            var provision = this.provisionIncome.filter(function (item) {
                return item['brand'] === _this3.selectedBrand && (_this3.selectedFirmProvisionFilter ? _this3.selectedFirmProvisionFilter === item["firm"] : true);
            });
            provision.map(function (p, index) {
                if (p.isCredited) {
                    provision[index]["debit"] = provision[index]["totalAmount"];
                    provision[index]["credit"] = 0;
                } else {
                    provision[index]["credit"] = provision[index]["totalAmount"];
                    provision[index]["debit"] = 0;
                }
                provision[index]["RunningBal"] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(provision[index]["debit"]) - __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(provision[index]["credit"]) + (index == 0 ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(provision[index]["RunningBal"]));
            });
            return provision;
        },
        selectedIncomeType: function selectedIncomeType() {
            var _this4 = this;

            if (this.selectIncome) {
                var income = this.incomes.find(function (item) {
                    return item['.key'] === _this4.selectIncome;
                });
                this.incomeUnderHead = income.underHead;
                this.incomeCategory = income.category;
                return income;
            }
            return {};
        }
    }),
    watch: {
        "selectedFirmFromIncome": {
            handler: function handler(newVal, oldVal) {
                if (newVal != oldVal) {
                    // let firm = this.firmList.filter(item => item[".key"] === newVal)[0];  
                    // this.selectedFirmOpeningBalance = firm.openingBalance
                    this.getFirmIncome();
                }
            },

            deep: true
        },
        "selectIncome": {
            handler: function handler(newVal, oldVal) {
                if (newVal != oldVal) {
                    this.getFirmIncome();
                }
            },

            deep: true
        },
        "incomeAmount": {
            handler: function handler() {
                this.hintText = this.incomeAmount ? _.startCase(Object(__WEBPACK_IMPORTED_MODULE_4__utils_digitsToWords_js__["a" /* digitsToWords */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.incomeAmount))) : null;
            },

            deep: true
        }
    },
    methods: {
        getFirmIncome: function getFirmIncome() {
            var _this5 = this;

            this.selectedFirm = this.firmsByBrand.filter(function (item) {
                return item['value'] == _this5.selectedFirmFromIncome;
            })[0];
            console.log(this.selectedFirm);
            var firmIncome = this.invoices.filter(function (item) {
                return item["firm"] === _this5.selectedFirmFromIncome && item["incomeType"] === _this5.selectIncome;
            });
            this.firmIncame = firmIncome;
            var openingBalance = 0;
            firmIncome.map(function (inv) {
                openingBalance += inv.openingBalance ? parseInt(inv.openingBalance) : 0;
            });
            this.selectedFirmOpeningBalance = openingBalance;
        },
        getFirmName: function getFirmName(e) {
            var firm = void 0;
            if (this.firmList && this.selectedBrand) {
                firm = this.firmList.filter(function (item) {
                    return item['.key'] === e;
                })[0];
            }
            if (firm) return firm.name;
        },
        reset: function reset() {
            this.incomeAmount = null;
            this.selectedFirmFromIncome = null;
            this.selectAccountFromIncome = null;
            this.incomeRemark = null;
            this.selectIncome = null;
            this.incomeVia = null;
            this.incomeCategory = null;
            this.incomeUnderHead = null;
            this.incomeOpeningBalance = null;
            var today = new Date();
            this.incomeInvoiceDate = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
            this.firmIncame = [];
            this.selectedFirmOpeningBalance = null;
            this.$emit('closedialog');
        },

        incomeAmountClick: function incomeAmountClick(e) {
            var _this6 = this;

            if (this.incomeRemark != null) {
                if (this.selectIncome != null) {
                    // incomeData updated with category and underhead on income create
                    if (this.IncomeCategory !== this.selectedIncomeType.category || this.incomeUnderHead !== this.selectedIncomeType.underHead) {
                        this.$root.$firebaseRefs.incomes.child(this.selectIncome).update({
                            category: this.incomeCategory,
                            underHead: this.incomeUnderHead
                        });
                    }
                    if (this.incomeVia == 'cash') {
                        this.$root.$firebaseRefs.firm.child(this.selectedFirmFromIncome).once('value').then(function (snap) {
                            // if(Number(snap.val().amount) >= this.incomeAmount){
                            _this6.$root.$firebaseRefs.firm.child(_this6.selectedFirmFromIncome).update({
                                amount: Number(snap.val().amount) + Number(_this6.incomeAmount)
                            });
                            setTimeout(function () {
                                _this6.addInvoiceIncome({
                                    incomeVia: _this6.incomeVia,
                                    incomeType: _this6.selectIncome,
                                    firmOfIncome: _this6.selectedFirmFromIncome,
                                    incomeAmount: _this6.incomeAmount,
                                    incomeRemark: _this6.incomeRemark,
                                    openingBalance: _this6.incomeOpeningBalance
                                });
                            });
                            // } else{
                            //     this.$emit('notify','Insufficient Balance')
                            // }
                        });
                    } else if (this.incomeVia == 'account') {
                        var incomeAccountFirm = null;
                        var incomeAccountNumber = null;
                        this.$root.$firebaseRefs.account.child(this.selectAccountFromIncome).once('value').then(function (snap) {
                            incomeAccountFirm = snap.val().firm;
                            incomeAccountNumber = snap.val().accountnumber;
                            // if(Number(snap.val().amount) >= this.incomeAmount){
                            _this6.$root.$firebaseRefs.account.child(_this6.selectAccountFromIncome).update({
                                amount: Number(snap.val().amount) + Number(_this6.incomeAmount)
                            });
                            _this6.$emit('notify', "income amount Received", true);
                            setTimeout(function () {
                                _this6.addInvoiceIncome({
                                    incomeVia: _this6.incomeVia,
                                    incomeType: _this6.selectIncome,
                                    firmOfIncome: incomeAccountFirm,
                                    incomeAmount: _this6.incomeAmount,
                                    incomeRemark: _this6.incomeRemark,
                                    accountOfIncome: incomeAccountNumber,
                                    openingBalance: _this6.incomeOpeningBalance
                                });
                            });
                            // } else{
                            //     this.$emit('notify','Insufficient Balance')
                            // }
                        });
                    } else {
                        this.addInvoiceIncome({
                            incomeVia: this.incomeVia,
                            incomeType: this.selectIncome,
                            firmOfIncome: this.selectedFirmFromIncome,
                            incomeAmount: this.incomeAmount,
                            incomeRemark: this.incomeRemark,
                            openingBalance: this.incomeOpeningBalance
                        });
                    }
                } else {
                    this.$emit('notify', 'Please enter a Income type');
                }
            } else {
                this.$emit('notify', 'Please enter a Remark');
            }
        },
        addIncome: function addIncome(e) {
            var _this7 = this;

            var incomeData = {
                brand: this.selectedBrand,
                income: e.target.value,
                category: null,
                underHead: null
            };
            var availableIncomes = this.incomes.filter(function (item) {
                return item.income == e.target.value && item['brand'] === _this7.selectedBrand;
            });
            if (availableIncomes.length) {
                this.addError = 'Income with name ' + e.target.value + ' Already exist.';
                setTimeout(function () {
                    _this7.addError = null;
                }, 3000);
            } else {
                this.$root.$firebaseRefs.incomes.push(incomeData);
            }
            // push income without category and underhead
        },
        // income Invoice
        addInvoiceIncome: function addInvoiceIncome(_ref) {
            var _this8 = this;

            var incomeVia = _ref.incomeVia,
                incomeType = _ref.incomeType,
                firmOfIncome = _ref.firmOfIncome,
                incomeAmount = _ref.incomeAmount,
                incomeRemark = _ref.incomeRemark,
                accountOfIncome = _ref.accountOfIncome,
                openingBalance = _ref.openingBalance;

            if (incomeVia == 'cash') {
                var invoiceViaCash = {
                    brand: this.selectedBrand,
                    brandFinYear: this.brandFinYear,
                    type: 'automatic invoice',
                    transactionType: 'income',
                    firm: firmOfIncome,
                    paymentType: incomeVia,
                    accountNumber: '',
                    paymentTypeStatus: 'confirm',
                    isCredited: true,
                    totalAmount: Number(incomeAmount),
                    remark: incomeRemark,
                    incomeType: incomeType,
                    openingBalance: openingBalance,
                    date: this.incomeInvoiceDate ? Date.parse(this.incomeInvoiceDate) : Date.now()
                };
                this.$root.$firebaseRefs.invoice.push(invoiceViaCash, function () {
                    _this8.$emit('notify', "Amount received", true);
                    _this8.reset();
                });
            } else if (incomeVia == 'account') {
                var invoiceViaAccount = {
                    brand: this.selectedBrand,
                    brandFinYear: this.brandFinYear,
                    type: 'automatic invoice',
                    transactionType: 'income',
                    firm: firmOfIncome,
                    paymentType: incomeVia,
                    accountNumber: accountOfIncome,
                    isCredited: true,
                    bank: this.selectAccountFromIncome,
                    paymentTypeStatus: 'confirm',
                    totalAmount: Number(incomeAmount),
                    remark: incomeRemark,
                    incomeType: incomeType,
                    openingBalance: openingBalance,
                    date: this.incomeInvoiceDate ? Date.parse(this.incomeInvoiceDate) : Date.now()
                };
                this.$root.$firebaseRefs.invoice.push(invoiceViaAccount, function () {
                    _this8.$emit('notify', "Amount received", true);
                    _this8.reset();
                });
            } else {
                var _invoiceViaAccount = {
                    brand: this.selectedBrand,
                    brandFinYear: this.brandFinYear,
                    type: 'automatic invoice',
                    transactionType: 'income',
                    firm: firmOfIncome,
                    paymentType: incomeVia,
                    accountNumber: '',
                    isCredited: true,
                    paymentTypeStatus: 'yet to confirm',
                    totalAmount: Number(incomeAmount),
                    remark: incomeRemark,
                    incomeType: incomeType,
                    openingBalance: openingBalance,
                    date: this.incomeInvoiceDate ? Date.parse(this.incomeInvoiceDate) : Date.now()
                };
                var res = this.$root.$firebaseRefs.invoice.push(_invoiceViaAccount);
                console.log(res);
                if (res.key) {
                    _invoiceViaAccount['invoiceId'] = res.key;
                    this.$root.$firebaseRefs.provisionIncome.push(_invoiceViaAccount, function () {
                        _this8.$emit('notify', "Amount received", true);
                        _this8.reset();
                    });
                }
            }
        }
    }
});

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_pdf_reports_incomeOverallReport_js__ = __webpack_require__(1373);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "incomeTableInfo",
  props: {
    accountsByBrand: { type: Array },
    firmsByBrand: { type: Array }
  },
  created: function created() {
    this.$bindAsArray("incomes", this.$root.$firebaseRefs.incomes.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('firms', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('banks', this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear"]), {
    banksByFirm: function banksByFirm() {
      var _this = this;

      return this.banks.filter(function (item) {
        return item['brand'] === _this.selectedBrand && item['firm'] == _this.selectedIncomeInvoice.firm;
      });
    },
    list: function list() {
      var _this2 = this;

      var incomes = this.incomes.filter(function (income) {
        return income.brand === _this2.selectedBrand;
      });
      incomes = incomes.filter(function (income) {
        return !!income['.key'];
      });
      incomes.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = 'confirm';
        var invoices = _this2.invoices.filter(function (invoice) {
          return invoice.brand === _this2.selectedBrand && invoice["incomeType"] === ex['.key'] && invoice.date >= _this2.finYear.start && invoice.date <= _this2.finYear.end;
        });
        console.log(invoices);
        invoices.map(function (inv) {
          openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
          totalAmount += __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          if (paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        incomes[index].paymentTypeStatus = paymentTypeStatus;
        incomes[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        incomes[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
      });
      return incomes.filter(function (e) {
        if (_this2.hideZero) {
          return parseFloat(e.totalAmount) > 0 || parseFloat(e.openingBalance) > 0;
        }
        return true;
      });
    }
  }),
  data: function data() {
    return {
      selectedIncome: [],
      selectedIncomeInvoice: {},
      isConfirm: false,
      datepicker: false,
      selectAccountFromIncome: null,
      headers: [
      // { text: "Id", value: ".key", sortable: false },
      { text: "Name", value: "income", sortable: true }, { text: "Category", value: "category", sortable: true }, { text: "Underhead", value: "underHead", sortable: false }, { text: "Opening WDV", value: "openingBalance", sortable: false }, { text: "Amount", value: "totalAmount", sortable: false }, { text: "Closing WDV", sortable: false }, { text: "Status", value: "paymentTypeStatus", sortable: false }, { text: "Action", sortable: false }, { text: "Edit", sortable: false }],
      incomeHeader: [
      // { text: "Id", value: ".key", sortable: false },
      { text: "Firm Name", value: "firm", sortable: true }, { text: "Date", value: "date", sortable: true }, { text: "Opening WDV", value: "openingBalance", sortable: false }, { text: "Amount", value: "totalAmount", sortable: false }, { text: "Closing WDV", sortable: false }, { text: "Payment Type", value: "paymentType", sortable: false }, { text: "Remark", value: "type", sortable: false }, { text: "Status", value: "paymentTypeStatus", sortable: false }, { text: "Edit", sortable: false }, { text: "Delete", sortable: false }],
      dialog: false,
      dialogEdit: false,
      dialogEditInvoice: false,
      categotyList: ['Direct', 'Indirect'],
      underHeadList: ['Prop Capital A/C', 'Profit and Loss'],
      selectedIncomes: []
    };
  },

  methods: {
    // getDepAmount(income, type) {
    //   let depriciation = null;
    //   if (income.isVerified && income.depriciation) {
    //     const totalAmount = this.getTotalAmount(income);
    //     depriciation = Number((totalAmount * income.depriciation) / 100);
    //     return depriciation;
    //   }
    //   return 0;
    // },
    printOverallIncome: function printOverallIncome(income) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var firm;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                firm = _this3.firms.filter(function (item) {
                  return item['.key'] === income['firm'];
                })[0];
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_5__utils_pdf_reports_incomeOverallReport_js__["a" /* incomeOverallReport */])({
                  // school: this.schools.filter((item) => item.id == this.defaultSchool)[0],
                  firm: _this3.firm,
                  list: _this3.list
                }).then(function (doc) {
                  pdfMake.createPdf(doc).download('INCOME_REPORT_' + new Date().toLocaleDateString('en-GB'));
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    getTotalAmount: function getTotalAmount(income) {
      return Number(income.totalamount);
    },
    getClosingWdv: function getClosingWdv(income) {
      return this.getTotalAmount(income);
    },
    saveIncome: function saveIncome() {
      var _this4 = this;

      var key = this.selectedIncome['.key'];
      delete this.selectedIncome['.key'];
      this.$root.$firebaseRefs.incomes.child(key).update(this.selectedIncome).then(function (snap) {
        _this4.dialogEdit = false;
      });
    },
    saveIncomeInvoice: function saveIncomeInvoice() {
      var _this5 = this;

      this.selectedIncomeInvoice.date = new Date(this.selectedIncomeInvoice.date).getTime();
      if (this.selectedIncomeInvoice.paymentType == 'cash' && this.isConfirm) {
        this.$root.$firebaseRefs.firm.child(this.selectedIncomeInvoice.firm).once('value').then(function (snap) {
          if (Number(snap.val().amount) >= _this5.selectedIncomeInvoice.totalAmount) {
            _this5.$root.$firebaseRefs.firm.child(_this5.selectedIncomeInvoice.firm).update({
              amount: Number(snap.val().amount) + Number(_this5.selectedIncomeInvoice.totalAmount)
            });
            setTimeout(function () {
              var key = _this5.selectedIncomeInvoice['.key'];
              delete _this5.selectedIncomeInvoice['.key'];
              _this5.selectedIncomeInvoice['paymentTypeStatus'] = 'confirm';
              _this5.$root.$firebaseRefs.invoice.child(key).update(_this5.selectedIncomeInvoice, function () {
                _this5.selectedIncomeInvoice.isCredited = false;
                _this5.$root.$firebaseRefs.provisionIncome.push(_this5.selectedIncomeInvoice);
                _this5.dialogEditInvoice = false;
              });
            });
          } else {
            console.log('Insufficient Balance');
          }
        });
      } else if (this.selectedIncomeInvoice.paymentType == 'account' && this.isConfirm) {
        var incomeAccountFirm = null;
        var incomeAccountNumber = null;
        this.$root.$firebaseRefs.account.child(this.selectAccountFromIncome['.key']).once('value').then(function (snap) {
          _this5.selectedIncomeInvoice['accountNumber'] = snap.val().accountnumber;
          _this5.selectedIncomeInvoice['bank'] = _this5.selectAccountFromIncome['.key'];
          if (Number(snap.val().amount) >= _this5.selectedIncomeInvoice.totalAmount) {
            _this5.$root.$firebaseRefs.account.child(_this5.selectAccountFromIncome['.key']).update({
              amount: Number(snap.val().amount) + Number(_this5.selectedIncomeInvoice.totalAmount)
            });
            console.log("income amount paid");
            setTimeout(function () {
              var key = _this5.selectedIncomeInvoice['.key'];
              delete _this5.selectedIncomeInvoice['.key'];
              _this5.selectedIncomeInvoice['paymentTypeStatus'] = 'confirm';
              _this5.$root.$firebaseRefs.invoice.child(key).update(_this5.selectedIncomeInvoice, function () {
                _this5.selectedIncomeInvoice.isCredited = false;
                _this5.$root.$firebaseRefs.provisionIncome.push(_this5.selectedIncomeInvoice);
                _this5.dialogEditInvoice = false;
              });
            });
          } else {
            console.log('Insufficient Balance');
          }
        });
      } else {
        var key = this.selectedIncomeInvoice['.key'];
        delete this.selectedIncomeInvoice['.key'];
        this.$root.$firebaseRefs.invoice.child(key).update(this.selectedIncomeInvoice).then(function (snap) {
          _this5.selectedIncomeInvoice['.key'] = key;
          _this5.dialogEditInvoice = false;
        });
      }
    },
    openIncomeDialog: function openIncomeDialog(income) {
      var _this6 = this;

      if (income) {
        var invoice = this.invoices.filter(function (invoice) {
          return invoice.brand === _this6.selectedBrand && invoice.transactionType === "income" && invoice.incomeType == income[".key"] && invoice.date >= _this6.finYear.start && invoice.date <= _this6.finYear.end;
        });
        invoice.sort(function (a, b) {
          return -(new Date(b.date) - new Date(a.date));
        });
        this.selectedIncomes = invoice;
        this.selectedIncome = income["income"];
        this.dialog = true;
      }
    },
    openIncomeEdit: function openIncomeEdit(income) {
      this.selectedIncome = income;
      this.dialogEdit = true;
    },
    openIncomeInvoiceEdit: function openIncomeInvoiceEdit(invoice, confirmDialog) {
      this.selectedIncomeInvoice = invoice;
      this.selectedIncomeInvoice.date = new Date(this.selectedIncomeInvoice.date).toISOString().substr(0, 10);
      this.dialogEditInvoice = true;
      this.isConfirm = confirmDialog;
    },
    openIncomeInvoiceDelete: function openIncomeInvoiceDelete(selectedIncomeInvoice) {
      if (window.confirm("Do you want to delete income created on " + new Date(selectedIncomeInvoice['date']).toLocaleDateString('en-GB') + "?")) {
        this.$root.$firebaseRefs.invoice.child(selectedIncomeInvoice[".key"]).remove();
      }
    },
    getFirmName: function getFirmName(e) {
      var firm = void 0;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter(function (item) {
          return item['.key'] === e;
        })[0];
      }
      if (firm) return firm.name;
    }
  }
});

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__table_assetTable_vue__ = __webpack_require__(1377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_digitsToWords_js__ = __webpack_require__(35);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];



/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'AsseetTab',
    props: {
        selectedBrand: { type: String, default: '' },
        accountsByBrand: { type: Array },
        firmsByBrand: { type: Array },
        assetByBrand: { type: Array }
    },
    components: {
        AssetTableInfo: __WEBPACK_IMPORTED_MODULE_6__table_assetTable_vue__["a" /* default */]
    },
    data: function data() {
        return {
            requiredRule: [function (v) {
                return !!v || 'Field is Required';
            }],
            hintText: null,
            downPaymentHintText: null,
            installmentHintText: null,
            dialog: false,
            addNewAccountValid: false,
            itemsForLoan: [],
            itemsEditForLoan: [],
            currentFirm: '',
            bankNameForLoan: '',
            accountCategoryForLoan: '',
            accountHolderName: '',
            accholderdisabled: false,
            accountTypeForLoan: '',
            accountnumberForLoan: '',
            ifsccode: '',
            datepicker1: false,
            accountLocation: '',
            accountOpeningDate: '',
            initialamount: 0,
            IFSC_Rules: [function (v) {
                // let reg = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
                var reg = /^([a-zA-Z]){4}([0]){1}([a-zA-Z0-9]){6}?$/;
                return v == undefined || /^$/.test(v) || reg.test(v) || "IFSC must be Valid";
            }],
            currentAccountCategoryForLoan: ['Firm A/C', 'Prop A/C', 'Normal A/C'],
            currentBankName: ['Allahabad Bank', 'Andhra Bank', 'Axis Bank', 'Bandhan Bank', 'Bank of India', 'Bank Of Baroda', 'Bank Of Maharastra', 'Canara Bank', 'Central Bank Of India', 'Corporation Bank', 'Dena Bank', 'DCB bank', 'HDFC bank', 'ICICI Bank', 'Indian Overseas Bank', 'Kotak Mahindra Bank', 'Oriental Bank Of Commerce', 'Punjab National Bank', 'Punjab and Sind Bank', 'State Bank Of India', 'UCO Bank', 'Union Bank Of India', 'Vijaya Bank', 'Yes Bank'],
            currentAccountType: ['Loan A/C'],
            // open asset table dialog
            openAssetTable: false,
            assetdatepicker: false,

            isOpeningBalance: null,
            firmAsset: [],
            selectedFirmOpeningBalance: 0,

            assetInvoiceDate: null,
            selectedFirmFromAsset: this.firmsByBrand[0],

            // when asset age is new: account id from which money will be deducted
            selectAccountFromAsset: null,

            selectAsset: null,
            assetRemark: null,

            operationPaymentType: null,
            amountFromCash: null,
            amountFromBank: null,
            addError: null,

            addition: null,
            additionAmount: null,
            deletionAmount: null,
            operationAccountForTransaction: null,
            operationAmountFromCash: null,
            operationAmountFromBank: null,

            asset: {
                totalAmount: null
            },

            GST_types_list: ['CGST|SGST', 'IGST'],
            isGSTApplicable: null,
            taxableGST_rate: null,
            GST_type: null,
            // isRCMApplicable : null,
            taxableAmount: null
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["brandFinYear"]), {
        getOperationOptions: function getOperationOptions() {
            return this.asset.age === false && this.asset.isVerified ? [{ text: 'Addition', value: 'addition' }, { text: 'Deletion', value: 'deletion' }, { text: 'No Operation', value: 'noOp' }] : [{ text: 'Addition', value: 'addition' }, { text: 'Deletion', value: 'deletion' }, { text: 'No Operation', value: 'noOp' }];
        },
        assetTypeList: function assetTypeList() {
            return __WEBPACK_IMPORTED_MODULE_4__utils__["c" /* ASSET_TYPE_WITH_DEPRICIATION */];
        },
        assetCategoryList: function assetCategoryList() {
            return __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* ASSET_CATEGORY */];
        },
        assetPurchaseType: function assetPurchaseType() {
            return __WEBPACK_IMPORTED_MODULE_4__utils__["b" /* ASSET_PURCHASE_TYPE */];
        },
        paymentOptions: function paymentOptions() {
            return __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* PAYMENT_OPTIONS */];
        },
        financialYear: function financialYear() {
            return Object(__WEBPACK_IMPORTED_MODULE_4__utils__["e" /* getFinancialYear */])();
        },
        isAssetPurchaedInfinancialYear: function isAssetPurchaedInfinancialYear() {
            if (this.selectAsset && this.assetPurchaseDate && this.selectedAssetDetail.isVerified) {
                return this.financialYear.includes(this.assetPurchaseDate.split('-')[0]);
            }
            return false;
        },
        accountsByFirm: function accountsByFirm() {
            var _this = this;

            if (this.selectedFirmFromAsset) {
                // return this.accountsByBrand.filter(item => item.account.firm === this.selectedFirmFromAsset)
                // return this.accountsByBrand.filter(item => item.account.firm === (this.selectedFirmFromAsset.value || this.selectedFirmFromAsset.value ))
                return this.accountsByBrand.filter(function (item) {
                    return item.account.firm === _this.selectedFirmFromAsset.value;
                });
            }
            return [];
        },
        otherAccountByBrand: function otherAccountByBrand() {
            return this.accountsByFirm.filter(function (account) {
                return account.account.accountType !== 'Loan A/C';
            });
        },
        loanAccountByBrand: function loanAccountByBrand() {
            return this.accountsByFirm.filter(function (account) {
                return account.account.accountType === 'Loan A/C';
            });
        },
        allowDepriciation: function allowDepriciation() {
            var _this2 = this;

            var list = this.assetTypeList.find(function (item) {
                return item.value === _this2.asset.type;
            });
            if (list) {
                return !!list.depriciation;
            }
            return false;
        },
        depriciationList: function depriciationList() {
            var _this3 = this;

            var list = this.assetTypeList.find(function (item) {
                return item.value === _this3.asset.type;
            });
            if (list && list.depriciation !== false) {
                return list.depriciation;
            }
            return [];
        },
        selectedAssetDetail: function selectedAssetDetail() {
            var _this4 = this;

            var asset = this.assetByBrand.find(function (asset) {
                return asset['value'] === _this4.selectAsset;
            });
            if (asset) {
                this.asset = asset.asset;
                return asset.asset;
            }
            return null;
        },
        assetEditDisabled: function assetEditDisabled() {
            if (this.selectedAssetDetail) {
                return !!this.selectedAssetDetail.isVerified;
            }
            return false;
        },
        selectedFirmDetailToPay: function selectedFirmDetailToPay() {
            var _this5 = this;

            if (this.selectedFirmFromAsset) {
                return this.firmsByBrand.find(function (item) {
                    return item.value === _this5.selectedFirmFromAsset.value;
                }).firm;
            }
            return null;
        },
        selectedBankAccountDetailToPay: function selectedBankAccountDetailToPay() {
            var _this6 = this;

            if (this.selectAccountFromAsset) {
                return this.accountsByBrand.find(function (item) {
                    return item.value === _this6.selectAccountFromAsset;
                }).account;
            }
            return null;
        }
    }),
    created: function created() {
        // this.$bindAsObject('firmById', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand))
        this.$bindAsObject('bankById', this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
        this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));
        this.$bindAsObject("assetOfBrand", this.$root.$firebaseRefs.assets.orderByChild('brand').equalTo(this.selectedBrand));
        this.$bindAsArray("assetList", this.$root.$firebaseRefs.assets.orderByChild('brand').equalTo(this.selectedBrand));
        // this.$bindAsArray('firms', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand))
        var today = new Date();
        this.assetInvoiceDate = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
    },


    watch: {
        "selectedFirmFromAsset": {
            handler: function handler(newVal, oldVal) {
                this.currentFirm = newVal;
                if (newVal != oldVal) {
                    this.getFirmAsset();
                }
            },

            deep: true
        },
        "selectAsset": {
            handler: function handler(newVal, oldVal) {
                if (newVal != oldVal) {
                    this.getFirmAsset();
                }
            },

            deep: true
        },
        "asset.totalAmount": {
            handler: function handler() {
                this.hintText = this.asset.totalAmount ? _.startCase(Object(__WEBPACK_IMPORTED_MODULE_7__utils_digitsToWords_js__["a" /* digitsToWords */])(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(this.asset.totalAmount))) : null;
            },

            deep: true
        },
        "asset.downPaymentAmount": {
            handler: function handler() {
                this.downPaymentHintText = this.asset.downPaymentAmount ? _.startCase(Object(__WEBPACK_IMPORTED_MODULE_7__utils_digitsToWords_js__["a" /* digitsToWords */])(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(this.asset.downPaymentAmount))) : null;
            },

            deep: true
        },
        "asset.installmentAmount": {
            handler: function handler() {
                this.installmentHintText = this.asset.installmentAmount ? _.startCase(Object(__WEBPACK_IMPORTED_MODULE_7__utils_digitsToWords_js__["a" /* digitsToWords */])(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(this.asset.installmentAmount))) : null;
            },

            deep: true
        }
    },
    methods: {
        getFirmbyId: function getFirmbyId(id) {
            // return this.firms.filter(item => item['.key'] == id)[0].name
            return this.firmsByBrand.finc(function (item) {
                return item['value'] == id;
            }).name;
        },
        propbyId: function propbyId(id) {
            // return this.firmsByBrand.finc(item => item['value'] == id).proprietor
            return this.firms.filter(function (item) {
                return item['.key'] == id;
            })[0].proprietor;
        },
        cancelDialog: function cancelDialog() {
            this.dialog = false;
            if (this.$refs.addAccount) {
                this.$refs.addAccount.reset();
                this.currentFirm = this.selectedFirmFromAsset;
            }
        },
        categoryChange: function categoryChange() {
            var self = this;
            setTimeout(function () {
                if (self.accountCategoryForLoan == "Firm A/C" && self.selectedFirmFromAsset) {
                    self.accountHolderName = self.getFirmbyId(self.selectedFirmFromAsset);
                    self.accholderdisabled = true;
                } else if (self.accountCategoryForLoan == "Prop A/C" && self.selectedFirmFromAsset) {
                    self.accountHolderName = self.propbyId(self.selectedFirmFromAsset);
                    self.accholderdisabled = true;
                } else {
                    self.accountHolderName = "";
                    self.accholderdisabled = false;
                }
            }, 1000);
        },
        getFirms: function getFirms() {
            this.dialog = true;
        },
        addNewAccount: function addNewAccount() {
            var _this7 = this;

            if (!this.$refs.addAccount.validate()) {
                return console.info('not vlaid....');
            }
            var data = {
                brand: this.selectedBrand,
                brandFinYear: this.brandFinYear,
                firm: this.currentFirm,
                bankName: this.bankNameForLoan,
                accountCategory: this.accountCategoryForLoan,
                accountHolderName: this.accountHolderName,
                accountnumber: this.accountnumberForLoan,
                ifsccode: this.ifsccode,
                accountLocation: this.accountLocation,
                accountType: this.accountTypeForLoan,
                amount: Number(this.initialamount),
                openingDate: new Date(this.accountOpeningDate).toISOString().substr(0, 10)
                //   openingBalance:Number(this.openingBalance),
            };

            this.$root.$firebaseRefs.account.push(data, function () {
                _this7.clearForm();
                _this7.cancelDialog();
            });
        },
        clearForm: function clearForm() {
            this.dialog = false;
            this.bankNameForLoan = "";
            this.accountCategoryForLoan = "";
            this.ifsccode = null;
            this.accountHolderName = null;
            this.accountTypeForLoan = "";
            this.accountLocation = null;
            this.accountnumberForLoan = "";
            this.amount = 0;
            this.accountOpeningDate = null;
            this.initialamount = 0;
        },
        getFirmAsset: function getFirmAsset() {
            var _this8 = this;

            // this.selectedFirm = this.firmsByBrand.filter(item => item['value'] == this.selectedFirmFromAsset)[0]
            this.selectedFirm = this.selectedFirmFromAsset.firm;
            console.log(this.selectedFirm);
            var firmAsset = this.invoices.filter(function (item) {
                return item["firm"] === _this8.selectedFirmFromAsset.value && item['assetType'] === _this8.selectAsset && item['brand'] === _this8.selectedBrand;
            });
            this.firmAsset = firmAsset;
            var openingBalance = 0;
            firmAsset.map(function (inv) {
                openingBalance = inv.assetInfo.openingBalance ? parseInt(inv.assetInfo.openingBalance) : 0;
            });
            this.selectedFirmOpeningBalance = openingBalance;
        },

        // Income Functionality
        assetAmountClick: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(e) {
                var _this9 = this;

                var asset, purchaseAmountError, loanAccounBalance, _loanAccounBalance, paymentMethodError, firmBalance, accountBalance, assetGet, maxDeletionAmount, transactionError, _firmBalance, _accountBalance, assetToUpdate, invoiceData;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (this.selectedFirmFromAsset) {
                                    _context.next = 2;
                                    break;
                                }

                                return _context.abrupt("return", this.$emit('notify', 'select firm'));

                            case 2:
                                if (this.selectAsset) {
                                    _context.next = 4;
                                    break;
                                }

                                return _context.abrupt("return", this.$emit('notify', 'Please enter Asset Source'));

                            case 4:
                                asset = {
                                    category: this.asset.category,
                                    type: this.asset.type,
                                    asset: this.asset.asset,
                                    brand: this.selectedBrand
                                };

                                if (asset.category) {
                                    _context.next = 7;
                                    break;
                                }

                                return _context.abrupt("return", this.$emit('notify', 'Please select category'));

                            case 7:
                                if (asset.type) {
                                    _context.next = 9;
                                    break;
                                }

                                return _context.abrupt("return", this.$emit('notify', 'Please select asset type'));

                            case 9:
                                if (!this.allowDepriciation) {
                                    _context.next = 13;
                                    break;
                                }

                                if (this.asset.depriciation) {
                                    _context.next = 12;
                                    break;
                                }

                                return _context.abrupt("return", this.$emit('notify', 'Select Depriciation for asset'));

                            case 12:
                                asset.depriciation = this.asset.depriciation;

                            case 13:
                                if (!this.asset.age) {
                                    _context.next = 87;
                                    break;
                                }

                                if (this.asset.totalAmount) {
                                    _context.next = 16;
                                    break;
                                }

                                return _context.abrupt("return", this.$emit('notify', 'Please add asset Purchase amount'));

                            case 16:
                                if (this.asset.purchaseType) {
                                    _context.next = 18;
                                    break;
                                }

                                return _context.abrupt("return", this.$emit('notify', 'Please select asset Purchase type'));

                            case 18:
                                // check is it possible to deduct money from account and purchase type
                                asset.totalAmount = Number(this.asset.totalAmount);
                                asset.totalAdditionAmount = asset.totalAmount;
                                asset.purchaseType = this.asset.purchaseType;
                                _context.prev = 21;

                                // get info for purchase type of asset
                                purchaseAmountError = false;
                                _context.t0 = this.asset.purchaseType;
                                _context.next = _context.t0 === this.assetPurchaseType[0].value ? 26 : _context.t0 === this.assetPurchaseType[1].value ? 28 : _context.t0 === this.assetPurchaseType[2].value ? 33 : 36;
                                break;

                            case 26:
                                asset.downPaymentAmount = Number(this.asset.totalAmount);
                                return _context.abrupt("break", 36);

                            case 28:
                                if (asset.totalAmount !== Number(this.asset.downPaymentAmount) + Number(this.asset.installmentAmount)) {
                                    purchaseAmountError = 'total of downpayment and EMI amount should be equal to total Amount';
                                }
                                asset.downPaymentAmount = Number(this.asset.downPaymentAmount);
                                asset.installmentAmount = Number(this.asset.installmentAmount);
                                if (!this.asset.loanAccount) {
                                    purchaseAmountError = 'Select loan account to pay EMI';
                                } else {
                                    loanAccounBalance = this.asset.loanAccount ? this.bankById[this.asset.loanAccount].amount : 0;

                                    if (asset.installmentAmount > loanAccounBalance) {
                                        purchaseAmountError = 'Insufficient balance in loan account';
                                    }
                                }
                                return _context.abrupt("break", 36);

                            case 33:
                                asset.installmentAmount = Number(this.asset.totalAmount);
                                if (!this.asset.loanAccount) {
                                    purchaseAmountError = 'Select loan account to pay EMI';
                                } else {
                                    _loanAccounBalance = this.asset.loanAccount ? this.bankById[this.asset.loanAccount].amount : 0;

                                    if (asset.installmentAmount > _loanAccounBalance) {
                                        purchaseAmountError = 'Insufficient balance in loan account';
                                    }
                                }
                                return _context.abrupt("break", 36);

                            case 36:
                                if (!purchaseAmountError) {
                                    _context.next = 38;
                                    break;
                                }

                                return _context.abrupt("return", this.$emit('notify', purchaseAmountError));

                            case 38:
                                // get info asset payment information
                                paymentMethodError = false;
                                // asset information added by user is valid check for validation for amount calculation

                                firmBalance = this.selectedFirmFromAsset.firm.amount || 0;
                                //let firmBalance = this.firmById[this.selectedFirmFromAsset].amount || 0;

                                accountBalance = this.selectAccountFromAsset ? this.bankById[this.selectAccountFromAsset].amount : 0;

                                if (this.asset.purchaseType) {
                                    _context.next = 43;
                                    break;
                                }

                                return _context.abrupt("return", this.$emit('notify', 'select asset purchase method'));

                            case 43:
                                _context.t1 = this.asset.paymentType;
                                _context.next = _context.t1 === this.paymentOptions[0].value ? 46 : _context.t1 === this.paymentOptions[1].value ? 48 : _context.t1 === this.paymentOptions[2].value ? 55 : 71;
                                break;

                            case 46:
                                if (asset.downPaymentAmount >= firmBalance) {
                                    paymentMethodError = "Insufficient balance in firm " + firmBalance;
                                }
                                return _context.abrupt("break", 73);

                            case 48:
                                if (this.selectAccountFromAsset) {
                                    _context.next = 51;
                                    break;
                                }

                                paymentMethodError = 'Select bank account to pay';
                                return _context.abrupt("break", 73);

                            case 51:
                                if (!(asset.downPaymentAmount >= accountBalance)) {
                                    _context.next = 54;
                                    break;
                                }

                                // Insufficient balance in bank account
                                paymentMethodError = "Insufficient balance in bank Account " + accountBalance + " to pay downpayment";
                                return _context.abrupt("break", 73);

                            case 54:
                                return _context.abrupt("break", 73);

                            case 55:
                                if (this.asset.amountFromCash) {
                                    _context.next = 58;
                                    break;
                                }

                                paymentMethodError = 'enter amount to pay as cash';
                                return _context.abrupt("break", 73);

                            case 58:
                                if (this.asset.amountFromBank) {
                                    _context.next = 61;
                                    break;
                                }

                                paymentMethodError = 'enter amount to pay from bank';
                                return _context.abrupt("break", 73);

                            case 61:
                                if (this.selectAccountFromAsset) {
                                    _context.next = 64;
                                    break;
                                }

                                paymentMethodError = 'Select bank account to pay';
                                return _context.abrupt("break", 73);

                            case 64:
                                if (!(this.asset.amountFromBank >= accountBalance)) {
                                    _context.next = 67;
                                    break;
                                }

                                // Insufficient balance in bank account
                                paymentMethodError = "Insufficient balance in bank Account " + accountBalance + " to pay downpayment";
                                return _context.abrupt("break", 73);

                            case 67:
                                if (!(this.asset.amountFromCash >= firmBalance)) {
                                    _context.next = 70;
                                    break;
                                }

                                paymentMethodError = "Insufficient balance in firm " + firmBalance;
                                return _context.abrupt("break", 73);

                            case 70:
                                return _context.abrupt("break", 73);

                            case 71:
                                paymentMethodError = 'Select asset payment Method';
                                return _context.abrupt("break", 73);

                            case 73:
                                // clear payment related error is purchase by EMI
                                if (this.asset.purchaseType === 'installment') {
                                    paymentMethodError = false;
                                }

                                if (!paymentMethodError) {
                                    _context.next = 76;
                                    break;
                                }

                                return _context.abrupt("return", this.$emit('notify', paymentMethodError));

                            case 76:
                                if (this.assetRemark) {
                                    _context.next = 78;
                                    break;
                                }

                                return _context.abrupt("return", this.$emit('notify', 'Add Remark detail'));

                            case 78:
                                _context.next = 83;
                                break;

                            case 80:
                                _context.prev = 80;
                                _context.t2 = _context["catch"](21);
                                return _context.abrupt("return", console.info(_context.t2));

                            case 83:
                                // this.asset.openingBalance = 0;
                                asset.openingBalance = Number(0);
                                asset.disableOpeningBalance = true;
                                _context.next = 146;
                                break;

                            case 87:
                                if (!(!this.asset.openingBalance && !this.asset.totalAmount)) {
                                    _context.next = 91;
                                    break;
                                }

                                return _context.abrupt("return", this.$emit('notify', 'Enter Asset opening Balance'));

                            case 91:
                                if (this.selectedFirmOpeningBalance) {
                                    asset.openingBalance = this.asset.openingBalance;
                                    asset.invoiceOpeningBalance = 0;
                                } else {
                                    if (asset.age) {
                                        asset.openingBalance = 0;
                                        asset.invoiceOpeningBalance = 0;
                                    } else {
                                        assetGet = this.assetOfBrand[this.selectAsset];

                                        if (assetGet && assetGet.openingBalance) {
                                            asset.openingBalance = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(this.asset.openingBalance) || 0);
                                        } else {
                                            asset.openingBalance = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(this.asset.openingBalance || 0);
                                        }
                                        asset.invoiceOpeningBalance = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(this.asset.openingBalance || 0);
                                    }
                                }
                                asset.disableOpeningBalance = true;

                            case 93:
                                if (this.addition) {
                                    _context.next = 95;
                                    break;
                                }

                                return _context.abrupt("return", this.$emit('notify', 'Select operation type for asset'));

                            case 95:
                                if (!(this.addition !== 'noOp')) {
                                    _context.next = 117;
                                    break;
                                }

                                if (this.operationPaymentType) {
                                    _context.next = 98;
                                    break;
                                }

                                return _context.abrupt("return", this.$emit('notify', 'Select Payment Method type for operation'));

                            case 98:
                                if (!(this.addition === 'addition')) {
                                    _context.next = 104;
                                    break;
                                }

                                if (this.additionAmount) {
                                    _context.next = 103;
                                    break;
                                }

                                return _context.abrupt("return", this.$emit('notify', 'Add addtition amount'));

                            case 103:
                                asset.totalAdditionAmount = (this.asset.totalAdditionAmount || 0) + Number(this.additionAmount);

                            case 104:
                                if (!(this.addition === 'deletion')) {
                                    _context.next = 113;
                                    break;
                                }

                                if (this.deletionAmount) {
                                    _context.next = 109;
                                    break;
                                }

                                return _context.abrupt("return", this.$emit('notify', 'Add deletion amount'));

                            case 109:
                                asset.totalDeletionAmount = (this.asset.totalDeletionAmount || 0) + Number(this.deletionAmount);

                            case 110:
                                maxDeletionAmount = Number(this.asset.openingBalance) + Number(this.asset.totalAdditionAmount) - Number(this.asset.totalDeletionAmount);

                                if (!(this.deletionAmount > maxDeletionAmount)) {
                                    _context.next = 113;
                                    break;
                                }

                                return _context.abrupt("return", this.$emit('notify', "Max Deletion amont allowed is " + maxDeletionAmount + "/-"));

                            case 113:
                                if (!(this.operationPaymentType === 'CashAndBank Account' && (!this.operationAmountFromCash || !this.operationAmountFromBank))) {
                                    _context.next = 115;
                                    break;
                                }

                                return _context.abrupt("return", this.$emit('notify', 'Enter amount to pay from bank and cash for operation'));

                            case 115:
                                if (!(this.operationPaymentType !== 'Cash' && !this.operationAccountForTransaction)) {
                                    _context.next = 117;
                                    break;
                                }

                                return _context.abrupt("return", this.$emit('notify', 'Select Bank account for operation'));

                            case 117:
                                if (this.assetRemark) {
                                    _context.next = 119;
                                    break;
                                }

                                return _context.abrupt("return", this.$emit('notify', 'Add Remark detail'));

                            case 119:
                                transactionError = false;

                                if (!(this.addition === 'addition')) {
                                    _context.next = 144;
                                    break;
                                }

                                //const firmBalance = this.firmById[this.selectedFirmFromAsset].amount;
                                _firmBalance = this.selectedFirmFromAsset.firm.amount;
                                _accountBalance = this.operationAccountForTransaction ? this.bankById[this.operationAccountForTransaction].amount : 0;
                                _context.t3 = this.operationPaymentType;
                                _context.next = _context.t3 === 'Cash' ? 126 : _context.t3 === "Bank Account" ? 130 : _context.t3 === "CashAndBank Account" ? 134 : 144;
                                break;

                            case 126:
                                if (!(this.additionAmount > _firmBalance)) {
                                    _context.next = 129;
                                    break;
                                }

                                transactionError = "Insufficiant balance in firm " + _firmBalance;
                                return _context.abrupt("break", 144);

                            case 129:
                                return _context.abrupt("break", 144);

                            case 130:
                                if (!(this.additionAmount > _accountBalance)) {
                                    _context.next = 133;
                                    break;
                                }

                                // Insufficient balance in bank account
                                transactionError = "Insufficient balance in bank Account " + _accountBalance + " to pay";
                                return _context.abrupt("break", 144);

                            case 133:
                                return _context.abrupt("break", 144);

                            case 134:
                                if (!(Number(this.additionAmount) !== Number(this.operationAmountFromCash) + Number(this.operationAmountFromBank))) {
                                    _context.next = 137;
                                    break;
                                }

                                transactionError = 'Total of by cash and bank amount should be same as operation Amount!';
                                return _context.abrupt("break", 144);

                            case 137:
                                if (!(this.operationAmountFromCash > _firmBalance)) {
                                    _context.next = 140;
                                    break;
                                }

                                transactionError = "Insufficiant balance in firm " + _firmBalance;
                                return _context.abrupt("break", 144);

                            case 140:
                                if (!(this.operationAmountFromBank > _accountBalance)) {
                                    _context.next = 143;
                                    break;
                                }

                                // Insufficient balance in bank account
                                transactionError = "Insufficient balance in bank Account " + _accountBalance + " to pay";
                                return _context.abrupt("break", 144);

                            case 143:
                                return _context.abrupt("break", 144);

                            case 144:
                                if (!transactionError) {
                                    _context.next = 146;
                                    break;
                                }

                                return _context.abrupt("return", this.$emit('notify', transactionError));

                            case 146:
                                assetToUpdate = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, this.selectedAssetDetail, asset);

                                delete assetToUpdate['.key'];

                                // create a invoice data now
                                invoiceData = {
                                    firm: this.selectedFirmFromAsset.value,
                                    brand: this.selectedBrand,
                                    brandFinYear: this.brandFinYear,
                                    type: 'automatic invoice',
                                    remark: this.assetRemark,

                                    // assetId and assetInfo
                                    assetType: this.selectAsset
                                };

                                invoiceData.assetInfo = assetToUpdate;

                                if (!this.asset.age) {
                                    _context.next = 173;
                                    break;
                                }

                                invoiceData.paymentType = this.asset.paymentType;
                                invoiceData.isCredited = false;
                                _context.t4 = invoiceData.paymentType;
                                _context.next = _context.t4 === "Cash" ? 156 : _context.t4 === "Bank Account" ? 159 : _context.t4 === "CashAndBank Account" ? 163 : 168;
                                break;

                            case 156:
                                invoiceData.totalAmount = assetToUpdate.totalAmount;
                                invoiceData.amountFromCash = Number(assetToUpdate.totalAmount);
                                return _context.abrupt("break", 168);

                            case 159:
                                invoiceData.totalAmount = assetToUpdate.totalAmount;
                                invoiceData.amountFromBank = invoiceData.totalAmount;
                                invoiceData.bank = this.selectAccountFromAsset;
                                return _context.abrupt("break", 168);

                            case 163:
                                invoiceData.bank = this.selectAccountFromAsset;
                                invoiceData.totalAmount = assetToUpdate.totalAmount;
                                invoiceData.amountFromBank = Number(this.asset.amountFromBank);
                                invoiceData.amountFromCash = Number(this.asset.amountFromCash);
                                return _context.abrupt("break", 168);

                            case 168:
                                if (this.asset.purchaseType === 'partial') {

                                    invoiceData.loanAccount = this.asset.loanAccount;
                                    invoiceData.installmentAmount = Number(this.asset.installmentAmount);
                                    invoiceData.downPaymentAmount = Number(this.asset.downPaymentAmount);
                                }
                                if (this.asset.purchaseType === 'installment') {
                                    invoiceData.bank = this.asset.loanAccount;
                                    invoiceData.totalAmount = invoiceData.installmentAmount;
                                    invoiceData.loanAccount = this.asset.loanAccount;
                                    invoiceData.installmentAmount = Number(this.asset.totalAmount);
                                }
                                if (this.asset.purchaseType === 'downpayment') {
                                    invoiceData.downPaymentAmount = Number(this.asset.totalAmount);
                                }
                                _context.next = 188;
                                break;

                            case 173:
                                if (!(this.addition !== 'noOp')) {
                                    _context.next = 188;
                                    break;
                                }

                                invoiceData.paymentType = this.operationPaymentType;
                                if (this.addition === 'addition') {
                                    // deduct money
                                    invoiceData.isCredited = false;
                                    invoiceData.totalAmount = Number(this.additionAmount);
                                } else {
                                    // credit money
                                    invoiceData.isCredited = true;
                                    invoiceData.totalAmount = Number(this.deletionAmount);
                                }
                                _context.t5 = invoiceData.paymentType;
                                _context.next = _context.t5 === "Cash" ? 179 : _context.t5 === "Bank Account" ? 181 : _context.t5 === "CashAndBank Account" ? 184 : 188;
                                break;

                            case 179:
                                invoiceData.amountFromCash = invoiceData.totalAmount;
                                return _context.abrupt("break", 188);

                            case 181:
                                invoiceData.amountFromBank = invoiceData.totalAmount;
                                invoiceData.bank = this.operationAccountForTransaction;
                                return _context.abrupt("break", 188);

                            case 184:
                                invoiceData.bank = this.operationAccountForTransaction;
                                invoiceData.amountFromBank = Number(this.operationAmountFromBank);
                                invoiceData.amountFromCash = Number(this.operationAmountFromCash);
                                return _context.abrupt("break", 188);

                            case 188:

                                // update asset flag with age as false and isVerfied as true
                                assetToUpdate.age = false;
                                assetToUpdate.isVerified = true;

                                this.$root.$firebaseRefs.assets.child(this.selectAsset).update(assetToUpdate, function () {
                                    if (_this9.addition === 'noOp') {
                                        invoiceData.totalAmount = 0;
                                        _this9.generateInvoice(invoiceData);
                                    }
                                    // if cash or cashAndBank
                                    if (invoiceData.amountFromCash) {
                                        var invoice = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, invoiceData);
                                        if (invoice.paymentType == "CashAndBank Account") {
                                            invoice.totalAmount = invoice.amountFromCash;
                                        } else {
                                            invoice.totalAmount = invoice.downPaymentAmount ? invoice.downPaymentAmount : invoice.amountFromCash;
                                        }
                                        invoice.paymentType = "Cash";
                                        // invoice.totalAmount = invoice.amountFromCash;
                                        delete invoice.amountFromCash;
                                        delete invoice.amountFromBank;
                                        delete invoice.loanAccount;
                                        delete invoice.installmentAmount;
                                        delete invoice.downPaymentAmount;
                                        delete invoice.bank;
                                        _this9.generateInvoice(invoice);
                                    }
                                    // if bank or cashAndBank
                                    if (invoiceData.amountFromBank) {
                                        var _invoice = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, invoiceData);
                                        if (_invoice.paymentType == "CashAndBank Account") {
                                            _invoice.totalAmount = _invoice.amountFromBank;
                                        } else {
                                            _invoice.totalAmount = _invoice.downPaymentAmount ? _invoice.downPaymentAmount : _invoice.amountFromBank;
                                        }
                                        _invoice.paymentType = "Bank Account";
                                        // invoice.totalAmount = invoice.amountFromBank;
                                        delete _invoice.amountFromCash;
                                        delete _invoice.amountFromBank;
                                        delete _invoice.loanAccount;
                                        delete _invoice.installmentAmount;
                                        delete _invoice.downPaymentAmount;
                                        _this9.generateInvoice(_invoice);
                                    }
                                    // if paid by EMI
                                    if (invoiceData.installmentAmount) {
                                        var _invoice2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, invoiceData);
                                        _invoice2.totalAmount = _invoice2.installmentAmount;
                                        _invoice2.bank = _invoice2.loanAccount;
                                        _invoice2.paymentType = "Bank Account";
                                        delete _invoice2.amountFromCash;
                                        delete _invoice2.amountFromBank;
                                        delete _invoice2.loanAccount;
                                        delete _invoice2.installmentAmount;
                                        delete _invoice2.downPaymentAmount;
                                        _this9.generateInvoice(_invoice2);
                                    }
                                });

                            case 191:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[21, 80]]);
            }));

            function assetAmountClick(_x) {
                return _ref.apply(this, arguments);
            }

            return assetAmountClick;
        }(),
        generateInvoice: function generateInvoice(invoiceData) {
            var _this10 = this;

            invoiceData.type = 'automatic invoice', invoiceData.transactionType = 'Asset', invoiceData.date = this.assetInvoiceDate ? Date.parse(this.assetInvoiceDate) : Date.now();
            // add account Number of bank account in invoice
            if (invoiceData.bank) {
                invoiceData.accountNumber = this.bankById[invoiceData.bank].accountnumber;
            }
            try {
                invoiceData['openingBalance'] = this.asset.invoiceOpeningBalance ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(this.asset.invoiceOpeningBalance) : 0;
                if (this.isGSTApplicable) {
                    invoiceData['isGSTApplicable'] = this.isGSTApplicable;
                }

                if (this.taxableGST_rate) {
                    invoiceData['taxableGST_rate'] = this.taxableGST_rate;
                }

                if (this.GST_type) {
                    invoiceData['GST_type'] = this.GST_type;
                }

                // if(this.isRCMApplicable) {
                //     invoiceViaCash['isRCMApplicable'] = this.isRCMApplicable;
                // }

                if (this.taxableAmount) {
                    invoiceData['taxableAmount'] = this.taxableAmount;
                }
                this.$root.$firebaseRefs.invoice.push(invoiceData, function () {
                    _this10.managePayments(invoiceData);
                });
            } catch (e) {
                console.error(invoiceData, e);
                this.$emit('notify', 'Error while generating Invoice...!');
            }
        },
        addAsset: function addAsset(e) {
            var _this11 = this;

            var availableAsset = this.assetList.filter(function (item) {
                return item.asset == e.target.value && item['brand'] === _this11.selectedBrand;
            });
            if (availableAsset.length) {
                this.addError = 'Asset with name ' + e.target.value + ' Already exist.';
                setTimeout(function () {
                    _this11.addError = null;
                }, 3000);
            } else {
                var assetData = {
                    brand: this.selectedBrand,
                    asset: e.target.value,
                    age: true,
                    isVerified: false,
                    disableOpeningBalance: false,
                    totalAdditionAmount: 0,
                    totalDeletionAmount: 0,
                    createdAt: Date.now()
                };
                this.$root.$firebaseRefs.assets.push(assetData);
            }
            /**
             * Create asset with 
             * asset: name of asset
             * brand: brandID of customer
             * isVerified: falg to decide is asset has all detail or not
             * age: set age asset as new for default
             * totalAdditionAmount : 0
             * totalDeletionAmount: 0
             */
        },
        reset: function reset() {
            var close = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            this.selectedFirmFromAsset = this.firmsByBrand[0];
            this.selectAccountFromAsset = null;
            this.selectAsset = null;
            this.assetRemark = null;
            this.operationPaymentType = null;
            this.amountFromCash = null;
            this.amountFromBank = null;
            this.addition = null;
            this.additionAmount = null;
            this.deletionAmount = null;
            this.operationAccountForTransaction = null;
            this.operationAmountFromCash = null;
            this.operationAmountFromBank = null;
            var today = new Date();
            this.assetInvoiceDate = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
            this.asset = {};
            if (close) {
                this.$emit('closeDialog');
            }
        },

        /**
         * @param {Object} invoiceData
         * @param {String} invoiceData.firm firmId
         * @param {String} invoiceData.paymentType type of payment method
         * @param {String} invoiceData.bank bankId
         * @param {Number} invoiceData.totalAmount totalAmount of invoice
         * @param {Number} invoiceData.amountFromBank money to deduct from bank
         * @param {Number} invoiceData.amountFromCash money to deduct dfrom firm
         */
        managePayments: function managePayments(invoiceData) {
            // let firm = this.firmById[invoiceData.firm]
            var firm = this.firmsByBrand.find(function (item) {
                return item.value == invoiceData.firm;
            }).firm;
            var bank = this.bankById[invoiceData.bank];
            var loanBank = null;
            if (invoiceData.loanAccount) {
                loanBank = this.bankById[invoiceData.loanAccount];
            }
            /*
            NOT USED ANYMORE: EMI Will generate invoice as BANK ACCOUNT
            if(invoiceData.loanAccount) {
                // deduct loan amount from 
                let loan = this.bankById[invoiceData.loanAccount]
                loan.amount = loan && loan.amount - invoiceData.installmentAmount;
                this.$root.$firebaseRefs.account.child(invoiceData.loanAccount).set(loan)
            }
            */
            try {
                switch (invoiceData.paymentType) {
                    case 'Cash':
                        {
                            if (this.asset.age && this.asset.purchaseType) {
                                if (this.asset.purchaseType === 'partial' && loanBank) {
                                    firm.amount = firm && firm.amount - invoiceData.downPaymentAmount;
                                    loanBank.amount = loanBank && loanBank.amount - invoiceData.installmentAmount;
                                } else if (this.asset.purchaseType === 'installment' && loanBank) {
                                    loanBank.amount = loanBank && loanBank.amount - invoiceData.installmentAmount;
                                } else if (this.asset.purchaseType === 'downpayment') {
                                    firm.amount = firm && firm.amount - invoiceData.totalAmount;
                                } else {
                                    if (invoiceData.isCredited) {
                                        firm.amount = firm && firm.amount + invoiceData.totalAmount;
                                    } else {
                                        firm.amount = firm && firm.amount - invoiceData.totalAmount;
                                    }
                                }
                            } else {
                                if (invoiceData.isCredited) {
                                    firm.amount = firm && firm.amount + invoiceData.totalAmount;
                                } else {
                                    firm.amount = firm && firm.amount - invoiceData.totalAmount;
                                }
                            }
                            if (loanBank) {
                                this.$root.$firebaseRefs.account.child(invoiceData.loanBank).set(loanBank);
                            }
                            delete firm['.key'];
                            this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(firm);
                            break;
                        }
                    case 'Bank Account':
                        {
                            if (this.asset.age && this.asset.purchaseType) {
                                if (this.asset.purchaseType === 'partial' && loanBank) {
                                    bank.amount = bank && bank.amount - invoiceData.downPaymentAmount;
                                    loanBank.amount = loanBank && loanBank.amount - invoiceData.installmentAmount;
                                } else if (this.asset.purchaseType === 'installment' && loanBank) {
                                    loanBank.amount = loanBank && loanBank.amount - invoiceData.installmentAmount;
                                } else if (this.asset.purchaseType === 'downpayment') {
                                    bank.amount = bank && bank.amount - invoiceData.totalAmount;
                                } else {
                                    if (invoiceData.isCredited) {
                                        bank.amount = bank && bank.amount + invoiceData.totalAmount;
                                    } else {
                                        bank.amount = bank && bank.amount - invoiceData.totalAmount;
                                    }
                                }
                            } else {
                                if (invoiceData.isCredited) {
                                    bank.amount = bank && bank.amount + invoiceData.totalAmount;
                                } else {
                                    bank.amount = bank && bank.amount - invoiceData.totalAmount;
                                }
                            }
                            if (loanBank) {
                                this.$root.$firebaseRefs.account.child(invoiceData.loanBank).set(loanBank);
                            }
                            this.$root.$firebaseRefs.account.child(invoiceData.bank).set(bank);
                            break;
                        }
                    // not used as cashAndBank will create two seperate invoice
                    case 'CashAndBank Account':
                        {
                            if (this.asset.age && this.asset.purchaseType) {
                                if (this.asset.purchaseType === 'partial' && loanBank) {
                                    bank.amount = bank && bank.amount - invoiceData.amountFromBank;
                                    firm.amount = firm && firm.amount - invoiceData.amountFromCash;
                                    loanBank.amount = loanBank && loanBank.amount - invoiceData.installmentAmount;
                                } else if (this.asset.purchaseType === 'installment' && loanBank) {
                                    loanBank.amount = loanBank && loanBank.amount - invoiceData.installmentAmount;
                                } else if (this.asset.purchaseType === 'downpayment') {
                                    bank.amount = bank && bank.amount - invoiceData.amountFromBank;
                                    firm.amount = firm && firm.amount - invoiceData.amountFromCash;
                                } else {
                                    if (invoiceData.isCredited) {
                                        bank.amount = bank && bank.amount + invoiceData.amountFromBank;
                                        firm.amount = firm && firm.amount + invoiceData.amountFromCash;
                                    } else {
                                        bank.amount = bank && bank.amount - invoiceData.amountFromBank;
                                        firm.amount = firm && firm.amount - invoiceData.amountFromCash;
                                    }
                                }
                            } else {
                                if (invoiceData.isCredited) {
                                    bank.amount = bank && bank.amount + invoiceData.amountFromBank;
                                    firm.amount = firm && firm.amount + invoiceData.amountFromCash;
                                } else {
                                    bank.amount = bank && bank.amount - invoiceData.amountFromBank;
                                    firm.amount = firm && firm.amount - invoiceData.amountFromCash;
                                }
                            }
                            delete firm['.key'];
                            this.$root.$firebaseRefs.account.child(invoiceData.bank).set(bank);
                            this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(firm);
                            if (loanBank) {
                                this.$root.$firebaseRefs.account.child(invoiceData.loanBank).set(loanBank);
                            }
                            break;
                        }
                }
                // close modal
                this.$emit('notify', "Invoice Created for Asset", true);
                this.reset(true);
            } catch (e) {
                console.error(invoiceData, e);
                this.$emit('notify', 'Error Occured while calulating money...!');
            }
        }
    }
});

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tabs_utils__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_pdf_reports_assetOverallReport_js__ = __webpack_require__(1378);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AssetTableInfo",
  props: {
    // selectedBrand: { type: String, default: '' },
    accountsByBrand: { type: Array },
    firmsByBrand: { type: Array },
    assetByBrand: { type: Array }
  },
  created: function created() {
    this.$bindAsArray("assets", this.$root.$firebaseRefs.assets.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('firms', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear", "brandFinYear"]), {
    assetTypeList: function assetTypeList() {
      return __WEBPACK_IMPORTED_MODULE_4__tabs_utils__["c" /* ASSET_TYPE_WITH_DEPRICIATION */];
    },
    assetCategoryList: function assetCategoryList() {
      return __WEBPACK_IMPORTED_MODULE_4__tabs_utils__["a" /* ASSET_CATEGORY */];
    },
    assetPurchaseType: function assetPurchaseType() {
      return __WEBPACK_IMPORTED_MODULE_4__tabs_utils__["b" /* ASSET_PURCHASE_TYPE */];
    },
    list: function list() {
      var _this = this;

      if (this.assets) {
        var selectedAssets = this.assets.filter(function (asset) {
          return asset.brand === _this.selectedBrand;
        });
        selectedAssets.map(function (ast, index) {
          var firmAsset = _this.invoices.filter(function (item) {
            return item['assetType'] === ast['.key'] && item['brand'] === _this.selectedBrand && item.date >= _this.finYear.start && item.date <= _this.finYear.end;
          });
          var openingBalance = 0;
          firmAsset.map(function (inv) {
            openingBalance += inv.openingBalance ? parseInt(inv.openingBalance) : 0;
          });
          selectedAssets[index]['openingBalance'] = openingBalance;
        });
        return selectedAssets;
      }
      return [];
    },
    allowDepriciation: function allowDepriciation() {
      var _this2 = this;

      var list = this.assetTypeList.find(function (item) {
        return item.value === _this2.asset.type;
      });
      if (list) {
        return !!list.depriciation;
      }
      return false;
    },
    depriciationList: function depriciationList() {
      var _this3 = this;

      var list = this.assetTypeList.find(function (item) {
        return item.value === _this3.asset.type;
      });
      if (list && list.depriciation !== false) {
        return list.depriciation;
      }
      return [];
    }
  }),
  data: function data() {
    return {
      asset: {},
      selectedAsset: [],
      selectedAssetInvoice: {},
      selectAccountFromAsset: null,
      isConfirm: false,
      datepicker: false,
      headers: [{ text: "Name", value: "asset", sortable: true },
      // { text: "Id", value: ".key", sortable: false },
      { text: "Type", value: "type", sortable: true }, { text: "Category", value: "category", sortable: false }, { text: "Dep %", value: "depriciation", sortable: false }, { text: "Opening WDV", value: "openingBalance", sortable: false }, { text: "Addition", value: "additionAmount", sortable: false }, { text: "Deletion", value: "deletionAmount", sortable: false }, { text: "Total", value: "totalAmount", sortable: false }, { text: "Dep Amount", sortable: false }, { text: "Closing WDV", value: "closingAmount", sortable: false }, { text: "View", sortable: false }, { text: "Edit", sortable: false }],
      assetHeader: [{ text: "Date", value: "date", sortable: true },
      // { text: "Id", value: ".key", sortable: false },
      { text: "Firm", value: "firm", sortable: true }, { text: "Opening WDV", value: "openingBalance", sortable: false },
      // { text: "totalAmount", value: "depriciation", sortable: false },
      { text: "Addition", value: "additionAmount", sortable: false }, { text: "Deletion", value: "deletionAmount", sortable: false }, { text: "Payment Type", value: ".key", sortable: false }, { text: "Remark", value: "type", sortable: true }, { text: "Action", value: "action", sortable: true }],
      dialog: false,
      dialogEdit: false,
      dialogEditInvoice: false,
      selectedAssets: []
    };
  },

  methods: {
    printOverallAsset: function printOverallAsset(asset) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var firm;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                firm = _this4.firms.filter(function (item) {
                  return item['.key'] === asset['firm'];
                })[0];
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_6__utils_pdf_reports_assetOverallReport_js__["a" /* assetOverallReport */])({
                  // school: this.schools.filter((item) => item.id == this.defaultSchool)[0],
                  firm: _this4.firm,
                  list: _this4.list
                }).then(function (doc) {
                  pdfMake.createPdf(doc).download('ASSET_REPORT_' + new Date().toLocaleDateString('en-GB'));
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    getDepAmount: function getDepAmount(asset, type) {
      var depriciation = null;
      if (asset.isVerified && asset.depriciation) {
        var totalAmount = this.getTotalAmount(asset);
        depriciation = Number(totalAmount * asset.depriciation / 100);
        return depriciation;
      }
      return 0;
    },
    getClosingWdv: function getClosingWdv(asset) {
      return this.getTotalAmount(asset) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(asset.openingBalance || 0) - this.getDepAmount(asset, asset.category);
    },
    getTotalAmount: function getTotalAmount(asset) {
      var _this5 = this;

      // if (asset.isVerified) {
      //   return (
      //     Number(asset.openingBalance || 0) +
      //     Number(asset.totalAdditionAmount) -
      //     Number(asset.totalDeletionAmount)
      //   );
      // }
      // return (
      //   Number(asset.totalAdditionAmount) - Number(asset.totalDeletionAmount)
      // );
      var total = 0;
      this.invoices.filter(function (invoice) {
        return invoice.brand === _this5.selectedBrand && invoice.transactionType === "Asset" && invoice.assetType == asset[".key"];
      }).map(function (i) {
        console.log(i);
        total += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(i.totalAmount);
      });
      return total;
    },
    openAssetDialog: function openAssetDialog(asset) {
      var _this6 = this;

      var invoice = this.invoices.filter(function (invoice) {
        return invoice.brand === _this6.selectedBrand && invoice.transactionType === "Asset" && invoice.assetType == asset[".key"] && invoice.date >= _this6.finYear.start && invoice.date <= _this6.finYear.end;
      });
      console.log(invoice);
      invoice.sort(function (a, b) {
        return -(new Date(b.date) - new Date(a.date));
      });
      this.selectedAssets = invoice;
      this.selectedAsset = asset["asset"];
      this.dialog = true;
    },
    getFirmName: function getFirmName(e) {
      var firm = void 0;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter(function (item) {
          return item['.key'] === e;
        })[0];
      }
      if (firm) return firm.name;
    },
    renderDate: function renderDate(timeStamp) {
      if (timeStamp) {
        return new Date(timeStamp).toLocaleDateString('en-GB');
      }
      return '--';
    },
    saveAsset: function saveAsset() {
      var _this7 = this;

      var key = this.selectedAsset['.key'];
      delete this.selectedAsset['.key'];
      this.$root.$firebaseRefs.assets.child(key).update(this.selectedAsset).then(function (snap) {
        _this7.dialogEdit = false;
      });
    },
    saveAssetInvoice: function saveAssetInvoice() {
      var _this8 = this;

      this.selectedAssetInvoice.date = new Date(this.selectedAssetInvoice.date).getTime();
      if (this.selectedAssetInvoice.paymentType == 'cash' && this.isConfirm) {
        this.$root.$firebaseRefs.firm.child(this.selectedAssetInvoice.firm).once('value').then(function (snap) {
          if (Number(snap.val().amount) >= _this8.selectedAssetInvoice.totalAmount) {
            _this8.$root.$firebaseRefs.firm.child(_this8.selectedAssetInvoice.firm).update({
              amount: Number(snap.val().amount) - Number(_this8.selectedAssetInvoice.totalAmount)
            });
            setTimeout(function () {
              var key = _this8.selectedAssetInvoice['.key'];
              delete _this8.selectedAssetInvoice['.key'];
              _this8.selectedAssetInvoice['paymentTypeStatus'] = 'confirm';
              _this8.$root.$firebaseRefs.invoice.child(key).update(_this8.selectedAssetInvoice, function () {
                _this8.selectedAssetInvoice.isCredited = true;
                _this8.$root.$firebaseRefs.provisionAsset.push(_this8.selectedAssetInvoice);
                _this8.dialogEditInvoice = false;
              });
            });
          } else {
            console.log('Insufficient Balance');
          }
        });
      } else if (this.selectedAssetInvoice.paymentType == 'account' && this.isConfirm) {
        var assetAccountFirm = null;
        var assetAccountNumber = null;
        this.$root.$firebaseRefs.account.child(this.selectAccountFromAsset['.key']).once('value').then(function (snap) {
          _this8.selectedAssetInvoice['accountNumber'] = snap.val().accountnumber;
          _this8.selectedAssetInvoice['bank'] = _this8.selectAccountFromAsset['.key'];
          if (Number(snap.val().amount) >= _this8.selectedAssetInvoice.totalAmount) {
            _this8.$root.$firebaseRefs.account.child(_this8.selectAccountFromAsset['.key']).update({
              amount: Number(snap.val().amount) - Number(_this8.selectedAssetInvoice.totalAmount)
            });
            console.log("asset amount paid");
            setTimeout(function () {
              var key = _this8.selectedAssetInvoice['.key'];
              delete _this8.selectedAssetInvoice['.key'];
              _this8.selectedassetInvoice['paymentTypeStatus'] = 'confirm';
              _this8.$root.$firebaseRefs.invoice.child(key).update(_this8.selectedAssetInvoice, function () {
                _this8.selectedAssetInvoice.isCredited = true;
                _this8.$root.$firebaseRefs.provisionAsset.push(_this8.selectedAssetInvoice);
                _this8.dialogEditInvoice = false;
              });
            });
          } else {
            console.log('Insufficient Balance');
          }
        });
      } else {
        var key = this.selectedAssetInvoice['.key'];
        delete this.selectedAssetInvoice['.key'];
        this.$root.$firebaseRefs.invoice.child(key).update(this.selectedAssetInvoice).then(function (snap) {
          _this8.selectedAssetInvoice['.key'] = key;
          _this8.dialogEditInvoice = false;
        });
      }
    },
    openAssetEdit: function openAssetEdit(asset) {
      this.selectedAsset = asset;
      this.dialogEdit = true;
    },
    openAssetInvoiceEdit: function openAssetInvoiceEdit(invoice, confirmDialog) {
      this.selectedAssetInvoice = invoice;
      this.selectedAssetInvoice.date = new Date(this.selectedAssetInvoice.date).toISOString("en-GB").substr(0, 10);
      this.dialogEditInvoice = true;
      this.isConfirm = confirmDialog;
    }
  }
});

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__table_salaryTable_vue__ = __webpack_require__(1382);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'SalaryTab',
    props: {
        selectedBrand: { type: String, default: '' },
        accountsByBrand: { type: Array },
        firmsByBrand: { type: Array },
        assetByBrand: { type: Array },
        staffAccount: { type: Array }
    },
    components: {
        SalaryTableInfo: __WEBPACK_IMPORTED_MODULE_5__table_salaryTable_vue__["a" /* default */]
    },
    data: function data() {
        return {
            // open asset table dialog
            openSalaryTable: false,
            assetdatepicker: false,

            salaryInvoiceDate: null,
            selectedFirmFromAsset: this.firmsByBrand.find(function (item) {
                return item.defaultFirm;
            }),

            // when asset age is new: account id from which money will be deducted
            selectAccountFromAsset: null,

            selectAsset: null,
            staffRemark: null,

            operationPaymentType: null,
            amountFromCash: null,
            amountFromBank: null,

            addition: null,
            additionAmount: null,
            operationAccountForTransaction: null,
            operationAmountFromCash: null,
            operationAmountFromBank: null,
            selectStaff: null,
            asset: {}
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["brandFinYear"]), {
        staffByBrand: function staffByBrand() {
            var _this = this;

            if (this.selectedFirmFromAsset) {
                return this.staffAccount.filter(function (item) {
                    return item.staff.firm === _this.selectedFirmFromAsset;
                });
            }
            return [];
        },
        getTransactionTypeOptions: function getTransactionTypeOptions() {
            return [{ text: 'Salary', value: 'salary' }, { text: 'Advance', value: 'advance' }, { text: 'Commission', value: 'commission' }, { text: 'Return', value: 'return' }];
        },
        assetTypeList: function assetTypeList() {
            return __WEBPACK_IMPORTED_MODULE_4__utils__["c" /* ASSET_TYPE_WITH_DEPRICIATION */];
        },
        assetCategoryList: function assetCategoryList() {
            return __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* ASSET_CATEGORY */];
        },
        assetPurchaseType: function assetPurchaseType() {
            return __WEBPACK_IMPORTED_MODULE_4__utils__["b" /* ASSET_PURCHASE_TYPE */];
        },
        paymentOptions: function paymentOptions() {
            return __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* PAYMENT_OPTIONS */];
        },
        financialYear: function financialYear() {
            return Object(__WEBPACK_IMPORTED_MODULE_4__utils__["e" /* getFinancialYear */])();
        },
        isAssetPurchaedInfinancialYear: function isAssetPurchaedInfinancialYear() {
            if (this.selectAsset && this.assetPurchaseDate && this.selectedAssetDetail.isVerified) {
                return this.financialYear.includes(this.assetPurchaseDate.split('-')[0]);
            }
            return false;
        },
        accountsByFirm: function accountsByFirm() {
            var _this2 = this;

            if (this.selectedFirmFromAsset) {
                return this.accountsByBrand.filter(function (item) {
                    return item.account.firm === _this2.selectedFirmFromAsset;
                });
            }
            return [];
        },
        otherAccountByBrand: function otherAccountByBrand() {
            return this.accountsByFirm.filter(function (account) {
                return account.account.accountType !== 'Loan A/C';
            });
        },
        loanAccountByBrand: function loanAccountByBrand() {
            return this.accountsByFirm.filter(function (account) {
                return account.account.accountType === 'Loan A/C';
            });
        },
        allowDepriciation: function allowDepriciation() {
            var _this3 = this;

            var list = this.assetTypeList.find(function (item) {
                return item.value === _this3.asset.type;
            });
            if (list) {
                return !!list.depriciation;
            }
            return false;
        },
        depriciationList: function depriciationList() {
            var _this4 = this;

            var list = this.assetTypeList.find(function (item) {
                return item.value === _this4.asset.type;
            });
            if (list && list.depriciation !== false) {
                return list.depriciation;
            }
            return [];
        },
        selectedAssetDetail: function selectedAssetDetail() {
            var _this5 = this;

            var asset = this.assetByBrand.find(function (asset) {
                return asset['value'] === _this5.selectAsset;
            });
            if (asset) {
                this.asset = asset.asset;
                return asset.asset;
            }
            return null;
        },
        assetEditDisabled: function assetEditDisabled() {
            if (this.selectedAssetDetail) {
                return !!this.selectedAssetDetail.isVerified;
            }
            return false;
        },
        selectedFirmDetailToPay: function selectedFirmDetailToPay() {
            var _this6 = this;

            if (this.selectedFirmFromAsset) {
                return this.firmsByBrand.find(function (item) {
                    return item.value === _this6.selectedFirmFromAsset;
                }).firm;
            }
            return null;
        },
        selectedBankAccountDetailToPay: function selectedBankAccountDetailToPay() {
            var _this7 = this;

            if (this.selectAccountFromAsset) {
                return this.accountsByBrand.find(function (item) {
                    return item.value === _this7.selectAccountFromAsset;
                }).account;
            }
            return null;
        }
    }),
    created: function created() {
        this.$bindAsObject('firmById', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
        this.$bindAsObject('bankById', this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
        this.$bindAsObject('staffById', this.$root.$firebaseRefs.staff.orderByChild('brand').equalTo(this.selectedBrand));
        var today = new Date();
        this.salaryInvoiceDate = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
    },

    methods: {

        // Income Functionality
        salaryAmountClick: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(e) {
                var self, asset, transactionError, firmBalance, accountBalance, globStaffType, salaryData, invoiceCashData, firm, res, invoiceViaAccount, bank, _res, invoiceData, invoiceCash, _res2, invoiceBank, _invoiceCashData, _res3, _invoiceViaAccount, _res4, _invoiceData, _invoiceCash, _res5, _invoiceBank;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                self = this;
                                asset = {
                                    brand: this.selectedBrand
                                };

                                if (this.selectedFirmFromAsset) {
                                    _context.next = 4;
                                    break;
                                }

                                return _context.abrupt("return", this.$emit('notify', 'select firm'));

                            case 4:
                                if (this.addition) {
                                    _context.next = 6;
                                    break;
                                }

                                return _context.abrupt("return", this.$emit('notify', 'Select transaction type'));

                            case 6:
                                if (this.additionAmount) {
                                    _context.next = 10;
                                    break;
                                }

                                return _context.abrupt("return", this.$emit('notify', 'Add amount'));

                            case 10:
                                asset.totalAdditionAmount = (this.asset.totalAdditionAmount || 0) + Number(this.additionAmount);

                            case 11:
                                if (!(this.operationPaymentType === 'CashAndBank Account' && (!this.operationAmountFromCash || !this.operationAmountFromBank))) {
                                    _context.next = 13;
                                    break;
                                }

                                return _context.abrupt("return", this.$emit('notify', 'Enter amount to pay from bank and cash for operation'));

                            case 13:
                                if (!(this.operationPaymentType !== 'Cash' && !this.operationAccountForTransaction)) {
                                    _context.next = 15;
                                    break;
                                }

                                return _context.abrupt("return", this.$emit('notify', 'Select Bank account for operation'));

                            case 15:
                                transactionError = false;

                                if (!(this.addition != 'return')) {
                                    _context.next = 40;
                                    break;
                                }

                                firmBalance = this.firmById[this.selectedFirmFromAsset].amount;
                                accountBalance = this.operationAccountForTransaction ? this.bankById[this.operationAccountForTransaction].amount : 0;
                                _context.t0 = this.operationPaymentType;
                                _context.next = _context.t0 === 'Cash' ? 22 : _context.t0 === "Bank Account" ? 26 : _context.t0 === "CashAndBank Account" ? 30 : 40;
                                break;

                            case 22:
                                if (!(this.additionAmount > firmBalance)) {
                                    _context.next = 25;
                                    break;
                                }

                                transactionError = "Insufficiant balance in firm " + firmBalance;
                                return _context.abrupt("break", 40);

                            case 25:
                                return _context.abrupt("break", 40);

                            case 26:
                                if (!(this.additionAmount > accountBalance)) {
                                    _context.next = 29;
                                    break;
                                }

                                // Insufficient balance in bank account
                                transactionError = "Insufficient balance in bank Account " + accountBalance + " to pay";
                                return _context.abrupt("break", 40);

                            case 29:
                                return _context.abrupt("break", 40);

                            case 30:
                                if (!(Number(this.additionAmount) !== Number(this.operationAmountFromCash) + Number(this.operationAmountFromBank))) {
                                    _context.next = 33;
                                    break;
                                }

                                transactionError = 'Total of by cash and bank amount should be same as operation Amount!';
                                return _context.abrupt("break", 40);

                            case 33:
                                if (!(this.operationAmountFromCash > firmBalance)) {
                                    _context.next = 36;
                                    break;
                                }

                                transactionError = "Insufficiant balance in firm " + firmBalance;
                                return _context.abrupt("break", 40);

                            case 36:
                                if (!(this.operationAmountFromBank > accountBalance)) {
                                    _context.next = 39;
                                    break;
                                }

                                // Insufficient balance in bank account
                                transactionError = "Insufficient balance in bank Account " + accountBalance + " to pay";
                                return _context.abrupt("break", 40);

                            case 39:
                                return _context.abrupt("break", 40);

                            case 40:
                                if (!transactionError) {
                                    _context.next = 42;
                                    break;
                                }

                                return _context.abrupt("return", this.$emit('notify', transactionError));

                            case 42:

                                // salary adance commostion debite
                                globStaffType = this.staffById[this.selectStaff].staffRole;
                                salaryData = {
                                    brand: this.selectedBrand,
                                    firm: this.selectedFirmFromAsset,
                                    staffId: this.selectStaff,
                                    staffType: globStaffType,
                                    transactionType: this.addition, //salary etc
                                    paymentType: this.operationPaymentType,
                                    amount: Number(this.additionAmount),
                                    date: this.salaryInvoiceDate ? Date.parse(this.salaryInvoiceDate) : Date.now(),
                                    remark: this.staffRemark
                                };


                                if (this.addition != 'return') {

                                    salaryData.isCredited = true;

                                    // create a invoice data now
                                    if (this.operationPaymentType == 'Cash') {
                                        invoiceCashData = {
                                            brand: this.selectedBrand,
                                            brandFinYear: this.brandFinYear,
                                            firm: this.selectedFirmFromAsset,
                                            type: 'automatic invoice',
                                            transactionType: 'Staff',
                                            paymentType: this.operationPaymentType,
                                            accountNumber: '',
                                            isCredited: false,
                                            totalAmount: Number(this.additionAmount),
                                            remark: this.staffRemark,
                                            staffkey: this.selectStaff,
                                            staffType: globStaffType,
                                            date: this.salaryInvoiceDate ? Date.parse(this.salaryInvoiceDate) : Date.now()
                                        };
                                        firm = this.firmById[invoiceCashData.firm];

                                        firm.amount = firm && firm.amount - invoiceCashData.totalAmount;
                                        this.$root.$firebaseRefs.firm.child(invoiceCashData.firm).set(firm);

                                        invoiceCashData.amountFromCash = invoiceCashData.totalAmount;
                                        invoiceCashData.salaryType = this.addition;
                                        res = self.$root.$firebaseRefs.invoice.push(invoiceCashData);

                                        salaryData['invoiceIdCash'] = res.key;
                                        salaryData['amountFromCash'] = invoiceCashData['totalAmount'];

                                        //   this.$root.$firebaseRefs.firm.child(this.selectedFirmFromAsset).once('value').then( function(snap) {
                                        //       if(Number(snap.val().amount) >= invoiceCashData.totalAmount){
                                        //           self.$root.$firebaseRefs.firm.child(invoiceCashData.firm).update({
                                        //                   amount: Number(snap.val().amount) - Number(invoiceCashData.totalAmount)
                                        //           });

                                        //           self.snackbarSuccess=true;
                                        //           self.snackbarSuccessText = "staff amount paid";

                                        //           invoiceCashData.amountFromCash = invoiceCashData.totalAmount;
                                        //           self.$root.$firebaseRefs.invoice.push(invoiceCashData);

                                        //           self.additionAmount = null;
                                        //           self.selectedFirmFromAsset = null;
                                        //           self.staffRemark = null;
                                        //       }else{
                                        //           return this.$emit('notify', 'Insufficient Balance To Pay');
                                        //       }
                                        //   })
                                    } else if (this.operationPaymentType == 'Bank Account') {
                                        invoiceViaAccount = {
                                            brand: this.selectedBrand,
                                            brandFinYear: this.brandFinYear,
                                            firm: this.selectedFirmFromAsset,
                                            type: 'automatic invoice',
                                            transactionType: 'Staff',
                                            paymentType: this.operationPaymentType,
                                            isCredited: false,
                                            totalAmount: Number(this.additionAmount),
                                            remark: this.staffRemark,
                                            staffkey: this.selectStaff,
                                            staffType: globStaffType,
                                            date: this.salaryInvoiceDate ? Date.parse(this.salaryInvoiceDate) : Date.now()
                                        };


                                        invoiceViaAccount.amountFromBank = invoiceViaAccount.totalAmount;
                                        invoiceViaAccount.bank = this.operationAccountForTransaction;

                                        if (invoiceViaAccount.bank) {
                                            invoiceViaAccount.accountNumber = this.bankById[invoiceViaAccount.bank].accountnumber;
                                        }

                                        firm = this.firmById[invoiceViaAccount.firm];
                                        bank = this.bankById[invoiceViaAccount.bank];


                                        bank.amount = bank && bank.amount - invoiceViaAccount.totalAmount;
                                        this.$root.$firebaseRefs.account.child(invoiceViaAccount.bank).set(bank);
                                        invoiceViaAccount.salaryType = this.addition;
                                        _res = self.$root.$firebaseRefs.invoice.push(invoiceViaAccount);

                                        salaryData['invoiceIdBank'] = _res.key;
                                        salaryData['amountFromBank'] = invoiceViaAccount['totalAmount'];
                                        salaryData['bank'] = invoiceViaAccount['bank'];
                                        self.additionAmount = null;
                                        self.selectedFirmFromAsset = null;
                                        self.staffRemark = null;
                                    } else {

                                        // CASHwithBank Account    

                                        invoiceData = {
                                            brand: this.selectedBrand,
                                            brandFinYear: this.brandFinYear,
                                            firm: this.selectedFirmFromAsset,
                                            type: 'automatic invoice',
                                            transactionType: 'Staff',
                                            isCredited: false,
                                            remark: this.staffRemark,
                                            staffkey: this.selectStaff,
                                            staffType: globStaffType,
                                            date: this.salaryInvoiceDate ? Date.parse(this.salaryInvoiceDate) : Date.now()

                                            //CASH *************************************
                                        };
                                        firm = this.firmById[invoiceData.firm];
                                        invoiceCash = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, invoiceData);

                                        invoiceCash.paymentType = "CashAndBank Account";
                                        invoiceCash.totalAmount = Number(this.operationAmountFromCash);
                                        invoiceCash.amountFromCash = Number(this.operationAmountFromCash);

                                        firm.amount = firm && firm.amount - invoiceCash.totalAmount;
                                        this.$root.$firebaseRefs.firm.child(invoiceCash.firm).set(firm);
                                        invoiceCash.salaryType = this.addition;
                                        _res2 = self.$root.$firebaseRefs.invoice.push(invoiceCash);

                                        salaryData['invoiceIdCash'] = _res2.key;
                                        salaryData['amountFromCash'] = invoiceCash['totalAmount'];
                                        // BANK **************************************
                                        invoiceBank = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, invoiceData);

                                        invoiceBank.paymentType = "Bank Account";
                                        invoiceBank.totalAmount = Number(this.operationAmountFromBank);
                                        invoiceBank.amountFromBank = Number(this.operationAmountFromBank);
                                        invoiceBank.bank = this.operationAccountForTransaction;

                                        if (invoiceBank.bank) {
                                            invoiceBank.accountNumber = this.bankById[invoiceBank.bank].accountnumber;
                                        }

                                        bank = this.bankById[invoiceBank.bank];

                                        bank.amount = bank && bank.amount - invoiceBank.totalAmount;
                                        this.$root.$firebaseRefs.account.child(invoiceBank.bank).set(bank);
                                        invoiceBank.salaryType = this.addition;
                                        _res2 = self.$root.$firebaseRefs.invoice.push(invoiceBank);
                                        salaryData['invoiceIdBank'] = _res2.key;
                                        salaryData['amountFromBank'] = invoiceBank['totalAmount'];
                                        salaryData['bank'] = invoiceBank['bank'];
                                        self.additionAmount = null;
                                        self.selectedFirmFromAsset = null;
                                        self.staffRemark = null;
                                    }
                                } else {

                                    salaryData.isCredited = false;

                                    if (this.operationPaymentType == 'Cash') {
                                        _invoiceCashData = {
                                            brand: this.selectedBrand,
                                            brandFinYear: this.brandFinYear,
                                            firm: this.selectedFirmFromAsset,
                                            type: 'automatic invoice',
                                            transactionType: 'Staff',
                                            paymentType: this.operationPaymentType,
                                            accountNumber: '',
                                            isCredited: true,
                                            totalAmount: Number(this.additionAmount),
                                            remark: this.staffRemark,
                                            staffkey: this.selectStaff,
                                            staffType: globStaffType,
                                            date: this.salaryInvoiceDate ? Date.parse(this.salaryInvoiceDate) : Date.now()
                                        };
                                        firm = this.firmById[_invoiceCashData.firm];

                                        firm.amount = firm && firm.amount + _invoiceCashData.totalAmount;
                                        this.$root.$firebaseRefs.firm.child(_invoiceCashData.firm).set(firm);

                                        _invoiceCashData.amountFromCash = _invoiceCashData.totalAmount;
                                        _invoiceCashData.salaryType = this.addition;
                                        _res3 = self.$root.$firebaseRefs.invoice.push(_invoiceCashData);

                                        salaryData['amountFromCash'] = _invoiceCashData['totalAmount'];
                                        salaryData['invoiceIdCash'] = _res3.key;
                                    } else if (this.operationPaymentType == 'Bank Account') {
                                        _invoiceViaAccount = {
                                            brand: this.selectedBrand,
                                            brandFinYear: this.brandFinYear,
                                            firm: this.selectedFirmFromAsset,
                                            type: 'automatic invoice',
                                            transactionType: 'Staff',
                                            paymentType: this.operationPaymentType,
                                            isCredited: true,
                                            totalAmount: Number(this.additionAmount),
                                            remark: this.staffRemark,
                                            staffkey: this.selectStaff,
                                            staffType: globStaffType,
                                            date: this.salaryInvoiceDate ? Date.parse(this.salaryInvoiceDate) : Date.now()
                                        };


                                        _invoiceViaAccount.amountFromBank = _invoiceViaAccount.totalAmount;
                                        _invoiceViaAccount.bank = this.operationAccountForTransaction;

                                        if (_invoiceViaAccount.bank) {
                                            _invoiceViaAccount.accountNumber = this.bankById[_invoiceViaAccount.bank].accountnumber;
                                        }

                                        firm = this.firmById[_invoiceViaAccount.firm];
                                        bank = this.bankById[_invoiceViaAccount.bank];


                                        bank.amount = bank && bank.amount + _invoiceViaAccount.totalAmount;
                                        this.$root.$firebaseRefs.account.child(_invoiceViaAccount.bank).set(bank);
                                        _invoiceViaAccount.salaryType = this.addition;
                                        _res4 = self.$root.$firebaseRefs.invoice.push(_invoiceViaAccount);

                                        salaryData['invoiceIdBank'] = _res4.key;
                                        salaryData['amountFromBank'] = _invoiceViaAccount['totalAmount'];
                                        salaryData['bank'] = _invoiceViaAccount['bank'];
                                        self.additionAmount = null;
                                        self.selectedFirmFromAsset = null;
                                        self.staffRemark = null;
                                    } else {

                                        // CASHwithBank Account    

                                        _invoiceData = {
                                            brand: this.selectedBrand,
                                            brandFinYear: this.brandFinYear,
                                            firm: this.selectedFirmFromAsset,
                                            type: 'automatic invoice',
                                            transactionType: 'Staff',
                                            isCredited: true,
                                            remark: this.staffRemark,
                                            staffkey: this.selectStaff,
                                            staffType: globStaffType,
                                            date: this.salaryInvoiceDate ? Date.parse(this.salaryInvoiceDate) : Date.now()

                                            //CASH *************************************
                                        };
                                        firm = this.firmById[_invoiceData.firm];
                                        _invoiceCash = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _invoiceData);

                                        _invoiceCash.paymentType = "CashAndBank Account";
                                        _invoiceCash.totalAmount = Number(this.operationAmountFromCash);
                                        _invoiceCash.amountFromCash = Number(this.operationAmountFromCash);

                                        firm.amount = firm && firm.amount + _invoiceCash.totalAmount;
                                        this.$root.$firebaseRefs.firm.child(_invoiceCash.firm).set(firm);
                                        _invoiceCash.salaryType = this.addition;
                                        _res5 = self.$root.$firebaseRefs.invoice.push(_invoiceCash);

                                        salaryData['amountFromCash'] = _invoiceCash['totalAmount'];
                                        salaryData['invoiceIdCash'] = _res5.key;
                                        // BANK **************************************
                                        _invoiceBank = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _invoiceData);

                                        _invoiceBank.paymentType = "Bank Account";
                                        _invoiceBank.totalAmount = Number(this.operationAmountFromBank);
                                        _invoiceBank.amountFromBank = Number(this.operationAmountFromBank);
                                        _invoiceBank.bank = this.operationAccountForTransaction;

                                        if (_invoiceBank.bank) {
                                            _invoiceBank.accountNumber = this.bankById[_invoiceBank.bank].accountnumber;
                                        }

                                        bank = this.bankById[_invoiceBank.bank];

                                        bank.amount = bank && bank.amount + _invoiceBank.totalAmount;
                                        this.$root.$firebaseRefs.account.child(_invoiceBank.bank).set(bank);
                                        _invoiceBank.salaryType = this.addition;
                                        _res5 = self.$root.$firebaseRefs.invoice.push(_invoiceBank);
                                        salaryData['invoiceIdBank'] = _res5.key;
                                        salaryData['amountFromBank'] = _invoiceBank['totalAmount'];
                                        salaryData['bank'] = _invoiceBank['bank'];
                                        self.additionAmount = null;
                                        self.selectedFirmFromAsset = null;
                                        self.staffRemark = null;
                                    }
                                }

                                this.$root.$firebaseRefs.salarys.push(salaryData);
                                // close modal
                                this.$emit('notify', "salary account credited", true);
                                this.reset(true);

                            case 48:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function salaryAmountClick(_x) {
                return _ref.apply(this, arguments);
            }

            return salaryAmountClick;
        }(),
        notify: function notify(ar1, ar2) {
            this.$emit('notify', ar1, ar2);
        },
        reset: function reset() {
            var close = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            this.selectedFirmFromAsset = null;
            this.selectAccountFromAsset = null;
            this.selectAsset = null;
            this.staffRemark = null;
            this.operationPaymentType = null;
            this.amountFromCash = null;
            this.amountFromBank = null;
            this.addition = null;
            this.additionAmount = null;
            this.deletionAmount = null;
            this.operationAccountForTransaction = null;
            this.operationAmountFromCash = null;
            this.operationAmountFromBank = null;
            var today = new Date();
            this.salaryInvoiceDate = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
            this.asset = {};
            if (close) {
                this.$emit('closedialog');
            }
        }
    }
});

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "SalaryTableInfo",
  props: {
    accountsByBrand: { type: Array },
    firmsByBrand: { type: Array },
    staffAccount: { type: Array },
    paymentOptions: { type: Array }
  },
  created: function created() {
    this.$bindAsArray("salarys", this.$root.$firebaseRefs.salarys.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("staff", this.$root.$firebaseRefs.staff.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsObject("firmById", this.$root.$firebaseRefs.firm.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsObject("bankById", this.$root.$firebaseRefs.account.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsObject("staffById", this.$root.$firebaseRefs.staff.orderByChild("brand").equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear"]), {
    getStaffAccount: function getStaffAccount() {
      var _this = this;

      if (this.selectedBrand) {
        var staffList = this.staff.filter(function (item) {
          return item["brand"] === _this.selectedBrand && item["firm"] != "";
        });

        var result = staffList.map(function (e) {
          var salaryList = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.filter(_this.salarys, { staffId: e[".key"] }, e.date >= _this.finYear.start, e.date <= _this.finYear.end);
          e.salaryList = salaryList;
          var debitTotal = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.sumBy(salaryList, function (s) {
            if (!s.isCredited) return s.amount;
          });

          e.debitTotal = debitTotal ? debitTotal : 0;

          var creditTotal = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.sumBy(salaryList, function (s) {
            if (s.isCredited) return s.amount;
          });
          if (e.openingBalance) {
            creditTotal += __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(e.openingBalance);
            e.salaryList.push({
              "isCredited": true,
              amount: e.openingBalance,
              isOpening: true,
              transactionType: "Opening Balance"
            });
          }

          e.creditTotal = creditTotal ? creditTotal : 0;
          return e;
        });

        return result;
      }
    },
    accountsByFirm: function accountsByFirm() {
      var _this2 = this;

      if (this.selectedFirmFromAsset) {
        return this.accountsByBrand.filter(function (item) {
          return item.account.firm === _this2.selectedFirmFromAsset;
        });
      }
      return [];
    },
    staffByBrand: function staffByBrand() {
      var _this3 = this;

      if (this.selectedFirmFromAsset) {
        return this.staffAccount.filter(function (item) {
          return item.staff.firm === _this3.selectedFirmFromAsset;
        });
      }
      return [];
    },
    otherAccountByBrand: function otherAccountByBrand() {
      return this.accountsByFirm.filter(function (account) {
        return account.account.accountType !== "Loan A/C";
      });
    },
    getTransactionTypeOptions: function getTransactionTypeOptions() {
      return [{ text: "Salary", value: "salary" }, { text: "Advance", value: "advance" }, { text: "Commission", value: "commission" }, { text: "Return", value: "return" }];
    }
  }),
  data: function data() {
    var _ref;

    return _ref = {
      dialog: false,
      selectedSalaryList: [],
      selectedStaffName: "",
      asset: {},
      selectedAsset: [],
      selectedSalary: null,
      selectedCashInvoice: null,
      selectedBankInvoice: null,
      selectStaff: null,
      dialogEditInvoice: false,
      additionAmount: null,
      operationPaymentType: null,
      operationAmountFromCash: 0,
      operationAmountFromBank: 0,
      selectedFirmFromAsset: null,
      operationAccountForTransaction: null,
      staffRemark: null,
      addition: null
    }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectStaff", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "salaryInvoiceDate", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "assetdatepicker", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "headers", [
    // { text: "Id", value: ".key", sortable: false },
    { text: "Name", value: "staffName", sortable: false }, { text: "Role", value: "staffRole", sortable: false }, { text: "Firm", value: "firm", sortable: false }, { text: "Debit", value: "amount", sortable: false }, { text: "Credit", value: "amount", sortable: false }, { text: "Running Balance", value: "amount", sortable: false }, { text: "Action", value: "paymentType", sortable: false }]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "salaryListHeaders", [
    // { text: "Id", value: ".key", sortable: false },
    { text: "Date", value: "date", sortable: true }, { text: "Firm", value: "firm", sortable: true }, { text: "Transaction type", value: "transactionType", sortable: false }, { text: "Debit", value: "amount", sortable: false }, { text: "Credit", value: "amount", sortable: false }, { text: "Payment Type", value: "paymentType", sortable: false }, { text: "Action", value: "paymentType", sortable: false }]), _ref;
  },

  methods: {
    openSalaryDialog: function openSalaryDialog(payload) {
      this.selectedSalaryList = payload.salaryList;
      this.selectedStaffName = payload.staffName + " |" + payload.staffRole;
      this.dialog = true;
    },
    firmbyId: function firmbyId(id) {
      return this.firms.filter(function (item) {
        return item[".key"] == id;
      })[0].name;
    },
    getFirmName: function getFirmName(e) {
      var firm = void 0;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter(function (item) {
          return item[".key"] === e;
        })[0];
      }
      if (firm) return firm.name;
    },
    deleteSalary: function deleteSalary(salary) {
      if (confirm("Are you sure?")) {
        this.$root.$firebaseRefs.salarys.child(salary[".key"]).remove();
        this.$root.$firebaseRefs.invoice.child(salary.invoiceIdCash).remove();
        this.$root.$firebaseRefs.invoice.child(salary.invoiceIdBank).remove();
        this.dialogEditInvoice = false;
      }
    },
    openAssetInvoiceEdit: function openAssetInvoiceEdit(salary) {
      this.selectedSalary = salary;
      this.selectedCashInvoice = salary.invoiceIdCash;
      this.selectedBankInvoice = salary.invoiceIdBank;
      this.additionAmount = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(salary.amount);
      this.operationAmountFromCash = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(salary.amountFromCash || 0);
      this.operationAmountFromBank = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(salary.amountFromBank || 0);
      this.operationAccountForTransaction = salary.bank;
      var today = new Date(salary.date);
      this.salaryInvoiceDate = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
      this.selectedFirmFromAsset = salary.firm;
      this.selectStaff = salary.staffId;
      this.addition = salary.transactionType;
      this.additionAmount = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(salary.amount || 0);
      this.operationPaymentType = salary.paymentType;
      this.staffRemark = salary.remark;

      this.dialogEditInvoice = true;
    },


    salaryAmountClick: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(e) {
        var additionAmount, operationAmountFromCash, operationAmountFromBank, self, asset, transactionError, firmBalance, accountBalance, globStaffType, salaryData, invoiceCashData, firm, invoiceViaAccount, bank, invoiceData, invoiceCash, invoiceBank, _invoiceCashData, _invoiceViaAccount, _invoiceData, _invoiceCash, _invoiceBank;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                additionAmount = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.additionAmount) - __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.selectedSalary.amount);
                operationAmountFromCash = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.operationAmountFromCash) - __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.selectedSalary.amountFromCash);
                operationAmountFromBank = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.operationAmountFromBank) - __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.selectedSalary.amountFromBank);
                self = this;
                asset = {
                  brand: this.selectedBrand
                };

                if (this.selectedFirmFromAsset) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", this.$emit("notify", "select firm"));

              case 7:
                if (this.addition) {
                  _context.next = 9;
                  break;
                }

                return _context.abrupt("return", this.$emit("notify", "Select transaction type"));

              case 9:
                if (this.additionAmount) {
                  _context.next = 13;
                  break;
                }

                return _context.abrupt("return", this.$emit("notify", "Add amount"));

              case 13:
                asset.totalAdditionAmount = (this.asset.totalAdditionAmount || 0) + Number(this.additionAmount);

              case 14:
                if (!(this.operationPaymentType === "CashAndBank Account" && (!this.operationAmountFromCash || !this.operationAmountFromBank))) {
                  _context.next = 16;
                  break;
                }

                return _context.abrupt("return", this.$emit("notify", "Enter amount to pay from bank and cash for operation"));

              case 16:
                if (!(this.operationPaymentType !== "Cash" && !this.operationAccountForTransaction)) {
                  _context.next = 18;
                  break;
                }

                return _context.abrupt("return", this.$emit("notify", "Select Bank account for operation"));

              case 18:
                transactionError = false;

                if (!(this.addition != "return")) {
                  _context.next = 43;
                  break;
                }

                firmBalance = this.firmById[this.selectedFirmFromAsset].amount;
                accountBalance = this.operationAccountForTransaction ? this.bankById[this.operationAccountForTransaction].amount : 0;
                _context.t0 = this.operationPaymentType;
                _context.next = _context.t0 === "Cash" ? 25 : _context.t0 === "Bank Account" ? 29 : _context.t0 === "CashAndBank Account" ? 33 : 43;
                break;

              case 25:
                if (!(additionAmount > firmBalance)) {
                  _context.next = 28;
                  break;
                }

                transactionError = "Insufficiant balance in firm " + firmBalance;
                return _context.abrupt("break", 43);

              case 28:
                return _context.abrupt("break", 43);

              case 29:
                if (!(additionAmount > accountBalance)) {
                  _context.next = 32;
                  break;
                }

                // Insufficient balance in bank account
                transactionError = "Insufficient balance in bank Account " + accountBalance + " to pay";
                return _context.abrupt("break", 43);

              case 32:
                return _context.abrupt("break", 43);

              case 33:
                if (!(Number(additionAmount) !== Number(operationAmountFromCash) + Number(operationAmountFromBank))) {
                  _context.next = 36;
                  break;
                }

                transactionError = "Total of by cash and bank amount should be same as operation Amount!";
                return _context.abrupt("break", 43);

              case 36:
                if (!(operationAmountFromCash > firmBalance)) {
                  _context.next = 39;
                  break;
                }

                transactionError = "Insufficiant balance in firm " + firmBalance;
                return _context.abrupt("break", 43);

              case 39:
                if (!(operationAmountFromBank > accountBalance)) {
                  _context.next = 42;
                  break;
                }

                // Insufficient balance in bank account
                transactionError = "Insufficient balance in bank Account " + accountBalance + " to pay";
                return _context.abrupt("break", 43);

              case 42:
                return _context.abrupt("break", 43);

              case 43:
                if (!transactionError) {
                  _context.next = 45;
                  break;
                }

                return _context.abrupt("return", this.$emit("notify", transactionError));

              case 45:

                // salary adance commostion debite
                globStaffType = this.staffById[this.selectStaff].staffRole;
                salaryData = {
                  brand: this.selectedBrand,
                  firm: this.selectedFirmFromAsset,
                  staffId: this.selectStaff,
                  staffType: globStaffType,
                  transactionType: this.addition, //salary etc
                  paymentType: this.operationPaymentType,
                  amount: Number(this.additionAmount),
                  date: this.salaryInvoiceDate ? Date.parse(this.salaryInvoiceDate) : Date.now(),
                  remark: this.staffRemark
                };


                if (this.addition != "return") {
                  salaryData.isCredited = true;

                  // create a invoice data now
                  if (this.operationPaymentType == "Cash") {
                    invoiceCashData = {
                      brand: this.selectedBrand,
                      firm: this.selectedFirmFromAsset,
                      type: "automatic invoice",
                      transactionType: "Staff",
                      paymentType: this.operationPaymentType,
                      accountNumber: "",
                      isCredited: false,
                      totalAmount: Number(this.additionAmount),
                      remark: this.staffRemark,
                      staffkey: this.selectStaff,
                      staffType: globStaffType,
                      date: this.salaryInvoiceDate ? Date.parse(this.salaryInvoiceDate) : Date.now()
                    };
                    firm = this.firmById[invoiceCashData.firm];

                    firm.amount = firm && firm.amount - additionAmount;
                    this.$root.$firebaseRefs.firm.child(invoiceCashData.firm).set(firm);

                    invoiceCashData.amountFromCash = invoiceCashData.totalAmount;
                    invoiceCashData.salaryType = this.addition;
                    this.$root.$firebaseRefs.invoice.child(this.selectedCashInvoice).set(invoiceCashData);
                    //let res = self.$root.$firebaseRefs.invoice.push(invoiceCashData);
                    salaryData["invoiceIdCash"] = this.selectedCashInvoice;
                    salaryData["amountFromCash"] = invoiceCashData["totalAmount"];

                    //   this.$root.$firebaseRefs.firm.child(this.selectedFirmFromAsset).once('value').then( function(snap) {
                    //       if(Number(snap.val().amount) >= invoiceCashData.totalAmount){
                    //           self.$root.$firebaseRefs.firm.child(invoiceCashData.firm).update({
                    //                   amount: Number(snap.val().amount) - Number(invoiceCashData.totalAmount)
                    //           });

                    //           self.snackbarSuccess=true;
                    //           self.snackbarSuccessText = "staff amount paid";

                    //           invoiceCashData.amountFromCash = invoiceCashData.totalAmount;
                    //           self.$root.$firebaseRefs.invoice.push(invoiceCashData);

                    //           self.additionAmount = null;
                    //           self.selectedFirmFromAsset = null;
                    //           self.staffRemark = null;
                    //       }else{
                    //           return this.$emit('notify', 'Insufficient Balance To Pay');
                    //       }
                    //   })
                  } else if (this.operationPaymentType == "Bank Account") {
                    invoiceViaAccount = {
                      brand: this.selectedBrand,
                      firm: this.selectedFirmFromAsset,
                      type: "automatic invoice",
                      transactionType: "Staff",
                      paymentType: this.operationPaymentType,
                      isCredited: false,
                      totalAmount: Number(this.additionAmount),
                      remark: this.staffRemark,
                      staffkey: this.selectStaff,
                      staffType: globStaffType,
                      date: this.salaryInvoiceDate ? Date.parse(this.salaryInvoiceDate) : Date.now()
                    };


                    invoiceViaAccount.amountFromBank = additionAmount;
                    invoiceViaAccount.bank = this.operationAccountForTransaction;

                    if (invoiceViaAccount.bank) {
                      invoiceViaAccount.accountNumber = this.bankById[invoiceViaAccount.bank].accountnumber;
                    }

                    firm = this.firmById[invoiceViaAccount.firm];
                    bank = this.bankById[invoiceViaAccount.bank];


                    bank.amount = bank && bank.amount - invoiceViaAccount.totalAmount;
                    this.$root.$firebaseRefs.account.child(invoiceViaAccount.bank).set(bank);
                    invoiceViaAccount.salaryType = this.addition;
                    // let res = self.$root.$firebaseRefs.invoice.push(invoiceViaAccount);
                    this.$root.$firebaseRefs.invoice.child(this.selectedBankInvoice).set(invoiceViaAccount);
                    salaryData["invoiceIdBank"] = this.selectedBankInvoice;
                    salaryData["amountFromBank"] = invoiceViaAccount["totalAmount"];
                    salaryData["bank"] = invoiceViaAccount["bank"];
                    self.additionAmount = null;
                    self.selectedFirmFromAsset = null;
                    self.staffRemark = null;
                  } else {
                    // CASHwithBank Account

                    invoiceData = {
                      brand: this.selectedBrand,
                      firm: this.selectedFirmFromAsset,
                      type: "automatic invoice",
                      transactionType: "Staff",
                      isCredited: false,
                      remark: this.staffRemark,
                      staffkey: this.selectStaff,
                      staffType: globStaffType,
                      date: this.salaryInvoiceDate ? Date.parse(this.salaryInvoiceDate) : Date.now()
                    };

                    //CASH *************************************

                    firm = this.firmById[invoiceData.firm];
                    invoiceCash = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, invoiceData);

                    invoiceCash.paymentType = "CashAndBank Account";
                    invoiceCash.totalAmount = Number(this.operationAmountFromCash);
                    invoiceCash.amountFromCash = Number(this.operationAmountFromCash);

                    firm.amount = firm && firm.amount - operationAmountFromCash;
                    this.$root.$firebaseRefs.firm.child(invoiceCash.firm).set(firm);
                    invoiceCash.salaryType = this.addition;
                    //let res = self.$root.$firebaseRefs.invoice.push(invoiceCash);
                    salaryData["invoiceIdCash"] = this.selectedCashInvoice;
                    this.$root.$firebaseRefs.invoice.child(this.selectedCashInvoice).set(invoiceCash);
                    salaryData["amountFromCash"] = invoiceCash["totalAmount"];
                    // BANK **************************************
                    invoiceBank = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, invoiceData);

                    invoiceBank.paymentType = "Bank Account";
                    invoiceBank.totalAmount = Number(this.operationAmountFromBank);
                    invoiceBank.amountFromBank = Number(this.operationAmountFromBank);
                    invoiceBank.bank = this.operationAccountForTransaction;

                    if (invoiceBank.bank) {
                      invoiceBank.accountNumber = this.bankById[invoiceBank.bank].accountnumber;
                    }

                    bank = this.bankById[invoiceBank.bank];

                    bank.amount = bank && bank.amount - operationAmountFromBank;
                    this.$root.$firebaseRefs.account.child(invoiceBank.bank).set(bank);
                    invoiceBank.salaryType = this.addition;
                    //res = self.$root.$firebaseRefs.invoice.push(invoiceBank);
                    salaryData["invoiceIdBank"] = this.selectedBankInvoice;
                    this.$root.$firebaseRefs.invoice.child(this.selectedBankInvoice).set(invoiceBank);
                    salaryData["amountFromBank"] = invoiceBank["totalAmount"];
                    salaryData["bank"] = invoiceBank["bank"];
                    self.additionAmount = null;
                    self.selectedFirmFromAsset = null;
                    self.staffRemark = null;
                  }
                } else {
                  salaryData.isCredited = false;

                  if (this.operationPaymentType == "Cash") {
                    _invoiceCashData = {
                      brand: this.selectedBrand,
                      firm: this.selectedFirmFromAsset,
                      type: "automatic invoice",
                      transactionType: "Staff",
                      paymentType: this.operationPaymentType,
                      accountNumber: "",
                      isCredited: true,
                      totalAmount: Number(this.additionAmount),
                      remark: this.staffRemark,
                      staffkey: this.selectStaff,
                      staffType: globStaffType,
                      date: this.salaryInvoiceDate ? Date.parse(this.salaryInvoiceDate) : Date.now()
                    };
                    firm = this.firmById[_invoiceCashData.firm];

                    firm.amount = firm && firm.amount + additionAmount;
                    this.$root.$firebaseRefs.firm.child(_invoiceCashData.firm).set(firm);

                    _invoiceCashData.amountFromCash = _invoiceCashData.totalAmount;
                    _invoiceCashData.salaryType = this.addition;
                    //let res = self.$root.$firebaseRefs.invoice.push(invoiceCashData);
                    this.$root.$firebaseRefs.invoice.child(this.selectedCashInvoice).set(_invoiceCashData);
                    salaryData["amountFromCash"] = _invoiceCashData["totalAmount"];
                    salaryData["invoiceIdCash"] = this.selectedCashInvoice;
                  } else if (this.operationPaymentType == "Bank Account") {
                    _invoiceViaAccount = {
                      brand: this.selectedBrand,
                      firm: this.selectedFirmFromAsset,
                      type: "automatic invoice",
                      transactionType: "Staff",
                      paymentType: this.operationPaymentType,
                      isCredited: true,
                      totalAmount: Number(this.additionAmount),
                      remark: this.staffRemark,
                      staffkey: this.selectStaff,
                      staffType: globStaffType,
                      date: this.salaryInvoiceDate ? Date.parse(this.salaryInvoiceDate) : Date.now()
                    };


                    _invoiceViaAccount.amountFromBank = _invoiceViaAccount.totalAmount;
                    _invoiceViaAccount.bank = this.operationAccountForTransaction;

                    if (_invoiceViaAccount.bank) {
                      _invoiceViaAccount.accountNumber = this.bankById[_invoiceViaAccount.bank].accountnumber;
                    }

                    firm = this.firmById[_invoiceViaAccount.firm];
                    bank = this.bankById[_invoiceViaAccount.bank];


                    bank.amount = bank && bank.amount + additionAmount;
                    this.$root.$firebaseRefs.account.child(_invoiceViaAccount.bank).set(bank);
                    _invoiceViaAccount.salaryType = this.addition;
                    //let res = self.$root.$firebaseRefs.invoice.push(invoiceViaAccount);
                    salaryData["invoiceIdBank"] = this.selectedBankInvoice;
                    this.$root.$firebaseRefs.invoice.child(this.selectedBankInvoice).set(_invoiceViaAccount);
                    salaryData["amountFromBank"] = _invoiceViaAccount["totalAmount"];
                    salaryData["bank"] = _invoiceViaAccount["bank"];
                    self.additionAmount = null;
                    self.selectedFirmFromAsset = null;
                    self.staffRemark = null;
                  } else {
                    // CASHwithBank Account

                    _invoiceData = {
                      brand: this.selectedBrand,
                      firm: this.selectedFirmFromAsset,
                      type: "automatic invoice",
                      transactionType: "Staff",
                      isCredited: true,
                      remark: this.staffRemark,
                      staffkey: this.selectStaff,
                      staffType: globStaffType,
                      date: this.salaryInvoiceDate ? Date.parse(this.salaryInvoiceDate) : Date.now()
                    };

                    //CASH *************************************

                    firm = this.firmById[_invoiceData.firm];
                    _invoiceCash = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, _invoiceData);

                    _invoiceCash.paymentType = "CashAndBank Account";
                    _invoiceCash.totalAmount = Number(this.operationAmountFromCash);
                    _invoiceCash.amountFromCash = Number(this.operationAmountFromCash);

                    firm.amount = firm && firm.amount + operationAmountFromCash;
                    this.$root.$firebaseRefs.firm.child(_invoiceCash.firm).set(firm);
                    _invoiceCash.salaryType = this.addition;
                    //let res = self.$root.$firebaseRefs.invoice.push(invoiceCash);
                    this.$root.$firebaseRefs.invoice.child(this.selectedCashInvoice).set(_invoiceCash);
                    salaryData["amountFromCash"] = _invoiceCash["totalAmount"];
                    salaryData["invoiceIdCash"] = this.selectedCashInvoice;
                    // BANK **************************************
                    _invoiceBank = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, _invoiceData);

                    _invoiceBank.paymentType = "Bank Account";
                    _invoiceBank.totalAmount = Number(this.operationAmountFromBank);
                    _invoiceBank.amountFromBank = Number(this.operationAmountFromBank);
                    _invoiceBank.bank = this.operationAccountForTransaction;

                    if (_invoiceBank.bank) {
                      _invoiceBank.accountNumber = this.bankById[_invoiceBank.bank].accountnumber;
                    }

                    bank = this.bankById[_invoiceBank.bank];

                    bank.amount = bank && bank.amount + operationAmountFromBank;
                    this.$root.$firebaseRefs.account.child(_invoiceBank.bank).set(bank);
                    _invoiceBank.salaryType = this.addition;
                    //res = self.$root.$firebaseRefs.invoice.push(invoiceBank);
                    salaryData["invoiceIdBank"] = this.selectedBankInvoice;
                    this.$root.$firebaseRefs.invoice.child(this.selectedBankInvoice).set(_invoiceBank);
                    salaryData["amountFromBank"] = _invoiceBank["totalAmount"];
                    salaryData["bank"] = _invoiceBank["bank"];
                    self.additionAmount = null;
                    self.selectedFirmFromAsset = null;
                    self.staffRemark = null;
                  }
                }

                this.$root.$firebaseRefs.salarys.child(this.selectedSalary[".key"]).set(salaryData);
                // close modal
                this.$emit("notify", "salary account edited", true);
                this.dialog = false;
                this.dialogEditInvoice = false;
                //this.reset(true);

              case 52:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function salaryAmountClick(_x) {
        return _ref2.apply(this, arguments);
      }

      return salaryAmountClick;
    }()
  }
});

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__table_liabilityTable_vue__ = __webpack_require__(1386);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];




/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'liabilityTab',
    props: {
        selectedBrand: { type: String, default: '' },
        accountsByBrand: { type: Array },
        firmsByBrand: { type: Array },
        assetByBrand: { type: Array },
        staffAccount: { type: Array }
    },
    components: {
        liabilityTableInfo: __WEBPACK_IMPORTED_MODULE_5__table_liabilityTable_vue__["a" /* default */]
    },
    data: function data() {
        return {
            // open asset table dialog
            openLiabilityTable: false,
            assetdatepicker: false,

            liabilityInvoiceDate: null,
            selectedFirmFromAsset: this.firmsByBrand.find(function (item) {
                return item.defaultFirm;
            }),

            // when asset age is new: account id from which money will be deducted
            selectAccountFromAsset: null,

            selectAsset: null,
            staffRemark: null,

            operationPaymentType: null,
            amountFromCash: null,
            amountFromBank: null,

            addition: null,
            additionAmount: null,
            operationAccountForTransaction: null,
            operationAmountFromCash: null,
            operationAmountFromBank: null,
            selectStaff: null,
            asset: {}
        };
    },

    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["brandFinYear"]), {
        staffByBrand: function staffByBrand() {
            var _this = this;

            if (this.selectedFirmFromAsset) {
                return this.staffAccount.filter(function (item) {
                    return item.staff.firm === _this.selectedFirmFromAsset;
                });
            }
            return [];
        },
        getTransactionTypeOptions: function getTransactionTypeOptions() {
            return [{ text: 'Debit', value: 'liability' },
            // {text: 'Advance', value: 'advance'},
            // {text: 'Commission', value: 'commission'},
            { text: 'Credit', value: 'return' }];
        },
        assetTypeList: function assetTypeList() {
            return __WEBPACK_IMPORTED_MODULE_4__utils__["c" /* ASSET_TYPE_WITH_DEPRICIATION */];
        },
        assetCategoryList: function assetCategoryList() {
            return __WEBPACK_IMPORTED_MODULE_4__utils__["a" /* ASSET_CATEGORY */];
        },
        assetPurchaseType: function assetPurchaseType() {
            return __WEBPACK_IMPORTED_MODULE_4__utils__["b" /* ASSET_PURCHASE_TYPE */];
        },
        paymentOptions: function paymentOptions() {
            return __WEBPACK_IMPORTED_MODULE_4__utils__["d" /* PAYMENT_OPTIONS */];
        },
        financialYear: function financialYear() {
            return Object(__WEBPACK_IMPORTED_MODULE_4__utils__["e" /* getFinancialYear */])();
        },
        isAssetPurchaedInfinancialYear: function isAssetPurchaedInfinancialYear() {
            if (this.selectAsset && this.assetPurchaseDate && this.selectedAssetDetail.isVerified) {
                return this.financialYear.includes(this.assetPurchaseDate.split('-')[0]);
            }
            return false;
        },
        accountsByFirm: function accountsByFirm() {
            var _this2 = this;

            if (this.selectedFirmFromAsset) {
                return this.accountsByBrand.filter(function (item) {
                    return item.account.firm === _this2.selectedFirmFromAsset;
                });
            }
            return [];
        },
        otherAccountByBrand: function otherAccountByBrand() {
            return this.accountsByFirm.filter(function (account) {
                return account.account.accountType !== 'Loan A/C';
            });
        },
        loanAccountByBrand: function loanAccountByBrand() {
            return this.accountsByFirm.filter(function (account) {
                return account.account.accountType === 'Loan A/C';
            });
        },
        allowDepriciation: function allowDepriciation() {
            var _this3 = this;

            var list = this.assetTypeList.find(function (item) {
                return item.value === _this3.asset.type;
            });
            if (list) {
                return !!list.depriciation;
            }
            return false;
        },
        depriciationList: function depriciationList() {
            var _this4 = this;

            var list = this.assetTypeList.find(function (item) {
                return item.value === _this4.asset.type;
            });
            if (list && list.depriciation !== false) {
                return list.depriciation;
            }
            return [];
        },
        selectedAssetDetail: function selectedAssetDetail() {
            var _this5 = this;

            var asset = this.assetByBrand.find(function (asset) {
                return asset['value'] === _this5.selectAsset;
            });
            if (asset) {
                this.asset = asset.asset;
                return asset.asset;
            }
            return null;
        },
        assetEditDisabled: function assetEditDisabled() {
            if (this.selectedAssetDetail) {
                return !!this.selectedAssetDetail.isVerified;
            }
            return false;
        },
        selectedFirmDetailToPay: function selectedFirmDetailToPay() {
            var _this6 = this;

            if (this.selectedFirmFromAsset) {
                return this.firmsByBrand.find(function (item) {
                    return item.value === _this6.selectedFirmFromAsset;
                }).firm;
            }
            return null;
        },
        selectedBankAccountDetailToPay: function selectedBankAccountDetailToPay() {
            var _this7 = this;

            if (this.selectAccountFromAsset) {
                return this.accountsByBrand.find(function (item) {
                    return item.value === _this7.selectAccountFromAsset;
                }).account;
            }
            return null;
        }
    }),
    created: function created() {
        this.$bindAsObject('firmById', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
        this.$bindAsObject('bankById', this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
        this.$bindAsObject('staffById', this.$root.$firebaseRefs.staff.orderByChild('brand').equalTo(this.selectedBrand));
        var today = new Date();
        this.liabilityInvoiceDate = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
    },

    methods: {

        // Income Functionality
        liabilityAmountClick: function () {
            var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(e) {
                var self, asset, transactionError, firmBalance, accountBalance, globStaffType, liabilityData, invoiceCashData, firm, res, invoiceViaAccount, bank, _res, invoiceData, invoiceCash, _res2, invoiceBank, _invoiceCashData, _res3, _invoiceViaAccount, _res4, _invoiceData, _invoiceCash, _res5, _invoiceBank;

                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                self = this;
                                asset = {
                                    brand: this.selectedBrand
                                };

                                if (this.selectedFirmFromAsset) {
                                    _context.next = 4;
                                    break;
                                }

                                return _context.abrupt("return", this.$emit('notify', 'select firm'));

                            case 4:
                                if (this.addition) {
                                    _context.next = 6;
                                    break;
                                }

                                return _context.abrupt("return", this.$emit('notify', 'Select transaction type'));

                            case 6:
                                if (this.additionAmount) {
                                    _context.next = 10;
                                    break;
                                }

                                return _context.abrupt("return", this.$emit('notify', 'Add amount'));

                            case 10:
                                asset.totalAdditionAmount = (this.asset.totalAdditionAmount || 0) + Number(this.additionAmount);

                            case 11:
                                if (!(this.operationPaymentType === 'CashAndBank Account' && (!this.operationAmountFromCash || !this.operationAmountFromBank))) {
                                    _context.next = 13;
                                    break;
                                }

                                return _context.abrupt("return", this.$emit('notify', 'Enter amount to pay from bank and cash for operation'));

                            case 13:
                                if (!(this.operationPaymentType !== 'Cash' && !this.operationAccountForTransaction)) {
                                    _context.next = 15;
                                    break;
                                }

                                return _context.abrupt("return", this.$emit('notify', 'Select Bank account for operation'));

                            case 15:
                                transactionError = false;

                                if (!(this.addition != 'return')) {
                                    _context.next = 40;
                                    break;
                                }

                                firmBalance = this.firmById[this.selectedFirmFromAsset].amount;
                                accountBalance = this.operationAccountForTransaction ? this.bankById[this.operationAccountForTransaction].amount : 0;
                                _context.t0 = this.operationPaymentType;
                                _context.next = _context.t0 === 'Cash' ? 22 : _context.t0 === "Bank Account" ? 26 : _context.t0 === "CashAndBank Account" ? 30 : 40;
                                break;

                            case 22:
                                if (!(this.additionAmount > firmBalance)) {
                                    _context.next = 25;
                                    break;
                                }

                                transactionError = "Insufficiant balance in firm " + firmBalance;
                                return _context.abrupt("break", 40);

                            case 25:
                                return _context.abrupt("break", 40);

                            case 26:
                                if (!(this.additionAmount > accountBalance)) {
                                    _context.next = 29;
                                    break;
                                }

                                // Insufficient balance in bank account
                                transactionError = "Insufficient balance in bank Account " + accountBalance + " to pay";
                                return _context.abrupt("break", 40);

                            case 29:
                                return _context.abrupt("break", 40);

                            case 30:
                                if (!(Number(this.additionAmount) !== Number(this.operationAmountFromCash) + Number(this.operationAmountFromBank))) {
                                    _context.next = 33;
                                    break;
                                }

                                transactionError = 'Total of by cash and bank amount should be same as operation Amount!';
                                return _context.abrupt("break", 40);

                            case 33:
                                if (!(this.operationAmountFromCash > firmBalance)) {
                                    _context.next = 36;
                                    break;
                                }

                                transactionError = "Insufficiant balance in firm " + firmBalance;
                                return _context.abrupt("break", 40);

                            case 36:
                                if (!(this.operationAmountFromBank > accountBalance)) {
                                    _context.next = 39;
                                    break;
                                }

                                // Insufficient balance in bank account
                                transactionError = "Insufficient balance in bank Account " + accountBalance + " to pay";
                                return _context.abrupt("break", 40);

                            case 39:
                                return _context.abrupt("break", 40);

                            case 40:
                                if (!transactionError) {
                                    _context.next = 42;
                                    break;
                                }

                                return _context.abrupt("return", this.$emit('notify', transactionError));

                            case 42:

                                // liability adance commostion debite
                                globStaffType = this.staffById[this.selectStaff].staffRole;
                                liabilityData = {
                                    brand: this.selectedBrand,
                                    firm: this.selectedFirmFromAsset,
                                    staffId: this.selectStaff,
                                    staffType: globStaffType,
                                    transactionType: this.addition, //liability etc
                                    paymentType: this.operationPaymentType,
                                    amount: Number(this.additionAmount),
                                    date: this.liabilityInvoiceDate ? Date.parse(this.liabilityInvoiceDate) : Date.now(),
                                    remark: this.staffRemark
                                };


                                if (this.addition != 'return') {

                                    liabilityData.isCredited = true;

                                    // create a invoice data now
                                    if (this.operationPaymentType == 'Cash') {
                                        invoiceCashData = {
                                            brand: this.selectedBrand,
                                            brandFinYear: this.brandFinYear,
                                            firm: this.selectedFirmFromAsset,
                                            type: 'automatic invoice',
                                            transactionType: 'Staff',
                                            paymentType: this.operationPaymentType,
                                            accountNumber: '',
                                            isCredited: false,
                                            totalAmount: Number(this.additionAmount),
                                            remark: this.staffRemark,
                                            staffkey: this.selectStaff,
                                            staffType: globStaffType,
                                            date: this.liabilityInvoiceDate ? Date.parse(this.liabilityInvoiceDate) : Date.now()
                                        };
                                        firm = this.firmById[invoiceCashData.firm];

                                        firm.amount = firm && firm.amount - invoiceCashData.totalAmount;
                                        this.$root.$firebaseRefs.firm.child(invoiceCashData.firm).set(firm);

                                        invoiceCashData.amountFromCash = invoiceCashData.totalAmount;
                                        invoiceCashData.liabilityType = this.addition;
                                        res = self.$root.$firebaseRefs.invoice.push(invoiceCashData);

                                        liabilityData['invoiceIdCash'] = res.key;
                                        liabilityData['amountFromCash'] = invoiceCashData['totalAmount'];

                                        //   this.$root.$firebaseRefs.firm.child(this.selectedFirmFromAsset).once('value').then( function(snap) {
                                        //       if(Number(snap.val().amount) >= invoiceCashData.totalAmount){
                                        //           self.$root.$firebaseRefs.firm.child(invoiceCashData.firm).update({
                                        //                   amount: Number(snap.val().amount) - Number(invoiceCashData.totalAmount)
                                        //           });

                                        //           self.snackbarSuccess=true;
                                        //           self.snackbarSuccessText = "staff amount paid";

                                        //           invoiceCashData.amountFromCash = invoiceCashData.totalAmount;
                                        //           self.$root.$firebaseRefs.invoice.push(invoiceCashData);

                                        //           self.additionAmount = null;
                                        //           self.selectedFirmFromAsset = null;
                                        //           self.staffRemark = null;
                                        //       }else{
                                        //           return this.$emit('notify', 'Insufficient Balance To Pay');
                                        //       }
                                        //   })
                                    } else if (this.operationPaymentType == 'Bank Account') {
                                        invoiceViaAccount = {
                                            brand: this.selectedBrand,
                                            brandFinYear: this.brandFinYear,
                                            firm: this.selectedFirmFromAsset,
                                            type: 'automatic invoice',
                                            transactionType: 'Staff',
                                            paymentType: this.operationPaymentType,
                                            isCredited: false,
                                            totalAmount: Number(this.additionAmount),
                                            remark: this.staffRemark,
                                            staffkey: this.selectStaff,
                                            staffType: globStaffType,
                                            date: this.liabilityInvoiceDate ? Date.parse(this.liabilityInvoiceDate) : Date.now()
                                        };


                                        invoiceViaAccount.amountFromBank = invoiceViaAccount.totalAmount;
                                        invoiceViaAccount.bank = this.operationAccountForTransaction;

                                        if (invoiceViaAccount.bank) {
                                            invoiceViaAccount.accountNumber = this.bankById[invoiceViaAccount.bank].accountnumber;
                                        }

                                        firm = this.firmById[invoiceViaAccount.firm];
                                        bank = this.bankById[invoiceViaAccount.bank];


                                        bank.amount = bank && bank.amount - invoiceViaAccount.totalAmount;
                                        this.$root.$firebaseRefs.account.child(invoiceViaAccount.bank).set(bank);
                                        invoiceViaAccount.liabilityType = this.addition;
                                        _res = self.$root.$firebaseRefs.invoice.push(invoiceViaAccount);

                                        liabilityData['invoiceIdBank'] = _res.key;
                                        liabilityData['amountFromBank'] = invoiceViaAccount['totalAmount'];
                                        liabilityData['bank'] = invoiceViaAccount['bank'];
                                        self.additionAmount = null;
                                        self.selectedFirmFromAsset = null;
                                        self.staffRemark = null;
                                    } else {

                                        // CASHwithBank Account    

                                        invoiceData = {
                                            brand: this.selectedBrand,
                                            brandFinYear: this.brandFinYear,
                                            firm: this.selectedFirmFromAsset,
                                            type: 'automatic invoice',
                                            transactionType: 'Staff',
                                            isCredited: false,
                                            remark: this.staffRemark,
                                            staffkey: this.selectStaff,
                                            staffType: globStaffType,
                                            date: this.liabilityInvoiceDate ? Date.parse(this.liabilityInvoiceDate) : Date.now()

                                            //CASH *************************************
                                        };
                                        firm = this.firmById[invoiceData.firm];
                                        invoiceCash = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, invoiceData);

                                        invoiceCash.paymentType = "CashAndBank Account";
                                        invoiceCash.totalAmount = Number(this.operationAmountFromCash);
                                        invoiceCash.amountFromCash = Number(this.operationAmountFromCash);

                                        firm.amount = firm && firm.amount - invoiceCash.totalAmount;
                                        this.$root.$firebaseRefs.firm.child(invoiceCash.firm).set(firm);
                                        invoiceCash.liabilityType = this.addition;
                                        _res2 = self.$root.$firebaseRefs.invoice.push(invoiceCash);

                                        liabilityData['invoiceIdCash'] = _res2.key;
                                        liabilityData['amountFromCash'] = invoiceCash['totalAmount'];
                                        // BANK **************************************
                                        invoiceBank = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, invoiceData);

                                        invoiceBank.paymentType = "Bank Account";
                                        invoiceBank.totalAmount = Number(this.operationAmountFromBank);
                                        invoiceBank.amountFromBank = Number(this.operationAmountFromBank);
                                        invoiceBank.bank = this.operationAccountForTransaction;

                                        if (invoiceBank.bank) {
                                            invoiceBank.accountNumber = this.bankById[invoiceBank.bank].accountnumber;
                                        }

                                        bank = this.bankById[invoiceBank.bank];

                                        bank.amount = bank && bank.amount - invoiceBank.totalAmount;
                                        this.$root.$firebaseRefs.account.child(invoiceBank.bank).set(bank);
                                        invoiceBank.liabilityType = this.addition;
                                        _res2 = self.$root.$firebaseRefs.invoice.push(invoiceBank);
                                        liabilityData['invoiceIdBank'] = _res2.key;
                                        liabilityData['amountFromBank'] = invoiceBank['totalAmount'];
                                        liabilityData['bank'] = invoiceBank['bank'];
                                        self.additionAmount = null;
                                        self.selectedFirmFromAsset = null;
                                        self.staffRemark = null;
                                    }
                                } else {

                                    liabilityData.isCredited = false;

                                    if (this.operationPaymentType == 'Cash') {
                                        _invoiceCashData = {
                                            brand: this.selectedBrand,
                                            brandFinYear: this.brandFinYear,
                                            firm: this.selectedFirmFromAsset,
                                            type: 'automatic invoice',
                                            transactionType: 'Staff',
                                            paymentType: this.operationPaymentType,
                                            accountNumber: '',
                                            isCredited: true,
                                            totalAmount: Number(this.additionAmount),
                                            remark: this.staffRemark,
                                            staffkey: this.selectStaff,
                                            staffType: globStaffType,
                                            date: this.liabilityInvoiceDate ? Date.parse(this.liabilityInvoiceDate) : Date.now()
                                        };
                                        firm = this.firmById[_invoiceCashData.firm];

                                        firm.amount = firm && firm.amount + _invoiceCashData.totalAmount;
                                        this.$root.$firebaseRefs.firm.child(_invoiceCashData.firm).set(firm);

                                        _invoiceCashData.amountFromCash = _invoiceCashData.totalAmount;
                                        _invoiceCashData.liabilityType = this.addition;
                                        _res3 = self.$root.$firebaseRefs.invoice.push(_invoiceCashData);

                                        liabilityData['amountFromCash'] = _invoiceCashData['totalAmount'];
                                        liabilityData['invoiceIdCash'] = _res3.key;
                                    } else if (this.operationPaymentType == 'Bank Account') {
                                        _invoiceViaAccount = {
                                            brand: this.selectedBrand,
                                            brandFinYear: this.brandFinYear,
                                            firm: this.selectedFirmFromAsset,
                                            type: 'automatic invoice',
                                            transactionType: 'Staff',
                                            paymentType: this.operationPaymentType,
                                            isCredited: true,
                                            totalAmount: Number(this.additionAmount),
                                            remark: this.staffRemark,
                                            staffkey: this.selectStaff,
                                            staffType: globStaffType,
                                            date: this.liabilityInvoiceDate ? Date.parse(this.liabilityInvoiceDate) : Date.now()
                                        };


                                        _invoiceViaAccount.amountFromBank = _invoiceViaAccount.totalAmount;
                                        _invoiceViaAccount.bank = this.operationAccountForTransaction;

                                        if (_invoiceViaAccount.bank) {
                                            _invoiceViaAccount.accountNumber = this.bankById[_invoiceViaAccount.bank].accountnumber;
                                        }

                                        firm = this.firmById[_invoiceViaAccount.firm];
                                        bank = this.bankById[_invoiceViaAccount.bank];


                                        bank.amount = bank && bank.amount + _invoiceViaAccount.totalAmount;
                                        this.$root.$firebaseRefs.account.child(_invoiceViaAccount.bank).set(bank);
                                        _invoiceViaAccount.liabilityType = this.addition;
                                        _res4 = self.$root.$firebaseRefs.invoice.push(_invoiceViaAccount);

                                        liabilityData['invoiceIdBank'] = _res4.key;
                                        liabilityData['amountFromBank'] = _invoiceViaAccount['totalAmount'];
                                        liabilityData['bank'] = _invoiceViaAccount['bank'];
                                        self.additionAmount = null;
                                        self.selectedFirmFromAsset = null;
                                        self.staffRemark = null;
                                    } else {

                                        // CASHwithBank Account    

                                        _invoiceData = {
                                            brand: this.selectedBrand,
                                            brandFinYear: this.brandFinYear,
                                            firm: this.selectedFirmFromAsset,
                                            type: 'automatic invoice',
                                            transactionType: 'Staff',
                                            isCredited: true,
                                            remark: this.staffRemark,
                                            staffkey: this.selectStaff,
                                            staffType: globStaffType,
                                            date: this.liabilityInvoiceDate ? Date.parse(this.liabilityInvoiceDate) : Date.now()

                                            //CASH *************************************
                                        };
                                        firm = this.firmById[_invoiceData.firm];
                                        _invoiceCash = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _invoiceData);

                                        _invoiceCash.paymentType = "CashAndBank Account";
                                        _invoiceCash.totalAmount = Number(this.operationAmountFromCash);
                                        _invoiceCash.amountFromCash = Number(this.operationAmountFromCash);

                                        firm.amount = firm && firm.amount + _invoiceCash.totalAmount;
                                        this.$root.$firebaseRefs.firm.child(_invoiceCash.firm).set(firm);
                                        _invoiceCash.liabilityType = this.addition;
                                        _res5 = self.$root.$firebaseRefs.invoice.push(_invoiceCash);

                                        liabilityData['amountFromCash'] = _invoiceCash['totalAmount'];
                                        liabilityData['invoiceIdCash'] = _res5.key;
                                        // BANK **************************************
                                        _invoiceBank = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _invoiceData);

                                        _invoiceBank.paymentType = "Bank Account";
                                        _invoiceBank.totalAmount = Number(this.operationAmountFromBank);
                                        _invoiceBank.amountFromBank = Number(this.operationAmountFromBank);
                                        _invoiceBank.bank = this.operationAccountForTransaction;

                                        if (_invoiceBank.bank) {
                                            _invoiceBank.accountNumber = this.bankById[_invoiceBank.bank].accountnumber;
                                        }

                                        bank = this.bankById[_invoiceBank.bank];

                                        bank.amount = bank && bank.amount + _invoiceBank.totalAmount;
                                        this.$root.$firebaseRefs.account.child(_invoiceBank.bank).set(bank);
                                        _invoiceBank.liabilityType = this.addition;
                                        _res5 = self.$root.$firebaseRefs.invoice.push(_invoiceBank);
                                        liabilityData['invoiceIdBank'] = _res5.key;
                                        liabilityData['amountFromBank'] = _invoiceBank['totalAmount'];
                                        liabilityData['bank'] = _invoiceBank['bank'];
                                        self.additionAmount = null;
                                        self.selectedFirmFromAsset = null;
                                        self.staffRemark = null;
                                    }
                                }

                                this.$root.$firebaseRefs.liabilitys.push(liabilityData);
                                // close modal
                                this.$emit('notify', "Transaction Successful", true);
                                this.reset(true);

                            case 48:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function liabilityAmountClick(_x) {
                return _ref.apply(this, arguments);
            }

            return liabilityAmountClick;
        }(),
        notify: function notify(ar1, ar2) {
            this.$emit('notify', ar1, ar2);
        },
        reset: function reset() {
            var close = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            this.selectedFirmFromAsset = null;
            this.selectAccountFromAsset = null;
            this.selectAsset = null;
            this.staffRemark = null;
            this.operationPaymentType = null;
            this.amountFromCash = null;
            this.amountFromBank = null;
            this.addition = null;
            this.additionAmount = null;
            this.deletionAmount = null;
            this.operationAccountForTransaction = null;
            this.operationAmountFromCash = null;
            this.operationAmountFromBank = null;
            var today = new Date();
            this.liabilityInvoiceDate = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
            this.asset = {};
            if (close) {
                this.$emit('closedialog');
            }
        }
    }
});

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_pdf_reports_liabilityOverallReport_js__ = __webpack_require__(1387);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "liabilityTableInfo",
  props: {
    accountsByBrand: { type: Array },
    firmsByBrand: { type: Array },
    staffAccount: { type: Array },
    paymentOptions: { type: Array }
  },
  created: function created() {
    this.$bindAsArray("liabilitys", this.$root.$firebaseRefs.liabilitys.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("staff", this.$root.$firebaseRefs.staff.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsObject("firmById", this.$root.$firebaseRefs.firm.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsObject("bankById", this.$root.$firebaseRefs.account.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsObject("staffById", this.$root.$firebaseRefs.staff.orderByChild("brand").equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear"]), {
    getStaffAccount: function getStaffAccount() {
      var _this = this;

      if (this.selectedBrand) {
        var staffList = this.staff.filter(function (item) {
          return item["brand"] === _this.selectedBrand && item["firm"] != "";
        });

        var result = staffList.map(function (e) {
          var liabilityList = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.filter(_this.liabilitys, { staffId: e[".key"] }, e.date >= _this.finYear.start, e.date <= _this.finYear.end);
          e.liabilityList = liabilityList;
          var debitTotal = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.sumBy(liabilityList, function (s) {
            if (!s.isCredited) return s.amount;
          });

          e.debitTotal = debitTotal ? debitTotal : 0;

          var creditTotal = __WEBPACK_IMPORTED_MODULE_6_lodash___default.a.sumBy(liabilityList, function (s) {
            if (s.isCredited) return s.amount;
          });
          if (e.openingBalance) {
            creditTotal += __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(e.openingBalance);
            e.liabilityList.push({
              "isCredited": true,
              amount: e.openingBalance,
              isOpening: true,
              transactionType: "Opening Balance"
            });
          }

          e.creditTotal = creditTotal ? creditTotal : 0;
          return e;
        });

        return result;
      }
    },
    accountsByFirm: function accountsByFirm() {
      var _this2 = this;

      if (this.selectedFirmFromAsset) {
        return this.accountsByBrand.filter(function (item) {
          return item.account.firm === _this2.selectedFirmFromAsset;
        });
      }
      return [];
    },
    staffByBrand: function staffByBrand() {
      var _this3 = this;

      if (this.selectedFirmFromAsset) {
        return this.staffAccount.filter(function (item) {
          return item.staff.firm === _this3.selectedFirmFromAsset;
        });
      }
      return [];
    },
    otherAccountByBrand: function otherAccountByBrand() {
      return this.accountsByFirm.filter(function (account) {
        return account.account.accountType !== "Loan A/C";
      });
    },
    getTransactionTypeOptions: function getTransactionTypeOptions() {
      return [{ text: "liability", value: "liability" }, { text: "Advance", value: "advance" }, { text: "Commission", value: "commission" }, { text: "Return", value: "return" }];
    }
  }),
  data: function data() {
    var _ref;

    return _ref = {
      dialog: false,
      selectedLiabilityList: [],
      selectedStaffName: "",
      asset: {},
      selectedAsset: [],
      selectedLiability: null,
      selectedCashInvoice: null,
      selectedBankInvoice: null,
      selectStaff: null,
      dialogEditInvoice: false,
      additionAmount: null,
      operationPaymentType: null,
      operationAmountFromCash: 0,
      operationAmountFromBank: 0,
      selectedFirmFromAsset: null,
      operationAccountForTransaction: null,
      staffRemark: null,
      addition: null
    }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "selectStaff", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "liabilityInvoiceDate", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "assetdatepicker", false), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "headers", [
    // { text: "Id", value: ".key", sortable: false },
    { text: "Name", value: "staffName", sortable: false }, { text: "Role", value: "staffRole", sortable: false }, { text: "Firm", value: "firm", sortable: false }, { text: "Debit", value: "amount", sortable: false }, { text: "Credit", value: "amount", sortable: false }, { text: "Running Balance", value: "amount", sortable: false }, { text: "Action", value: "paymentType", sortable: false }]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "liabilityListHeaders", [
    // { text: "Id", value: ".key", sortable: false },
    { text: "Date", value: "date", sortable: true }, { text: "Firm", value: "firm", sortable: true }, { text: "Transaction type", value: "transactionType", sortable: false }, { text: "Debit", value: "amount", sortable: false }, { text: "Credit", value: "amount", sortable: false }, { text: "Payment Type", value: "paymentType", sortable: false }, { text: "Action", value: "paymentType", sortable: false }]), _ref;
  },

  methods: {
    openLiabilityDialog: function openLiabilityDialog(payload) {
      this.selectedLiabilityList = payload.liabilityList;
      this.selectedStaffName = payload.staffName + " |" + payload.staffRole;
      this.dialog = true;
    },
    printOverallLiability: function printOverallLiability(liability) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var firm;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                firm = _this4.firms.filter(function (item) {
                  return item['.key'] === liability['firm'];
                })[0];
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_7__utils_pdf_reports_liabilityOverallReport_js__["a" /* liabilityOverallReport */])({
                  // school: this.schools.filter((item) => item.id == this.defaultSchool)[0],
                  firm: _this4.firm,
                  list: _this4.getStaffAccount
                }).then(function (doc) {
                  pdfMake.createPdf(doc).download('LIABILITY_REPORT_' + new Date().toLocaleDateString('en-GB'));
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    firmbyId: function firmbyId(id) {
      return this.firms.filter(function (item) {
        return item[".key"] == id;
      })[0].name;
    },
    getFirmName: function getFirmName(e) {
      var firm = void 0;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter(function (item) {
          return item[".key"] === e;
        })[0];
      }
      if (firm) return firm.name;
    },
    deleteLiability: function deleteLiability(liability) {
      if (confirm("Are you sure?")) {
        this.$root.$firebaseRefs.liabilitys.child(liability[".key"]).remove();
        this.$root.$firebaseRefs.invoice.child(liability.invoiceIdCash).remove();
        this.$root.$firebaseRefs.invoice.child(liability.invoiceIdBank).remove();
        this.dialogEditInvoice = false;
      }
    },
    openAssetInvoiceEdit: function openAssetInvoiceEdit(liability) {
      this.selectedLiability = liability;
      this.selectedCashInvoice = liability.invoiceIdCash;
      this.selectedBankInvoice = liability.invoiceIdBank;
      this.additionAmount = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(liability.amount);
      this.operationAmountFromCash = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(liability.amountFromCash || 0);
      this.operationAmountFromBank = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(liability.amountFromBank || 0);
      this.operationAccountForTransaction = liability.bank;
      var today = new Date(liability.date);
      this.liabilityInvoiceDate = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
      this.selectedFirmFromAsset = liability.firm;
      this.selectStaff = liability.staffId;
      this.addition = liability.transactionType;
      this.additionAmount = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(liability.amount || 0);
      this.operationPaymentType = liability.paymentType;
      this.staffRemark = liability.remark;

      this.dialogEditInvoice = true;
    },


    liabilityAmountClick: function () {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(e) {
        var additionAmount, operationAmountFromCash, operationAmountFromBank, self, asset, transactionError, firmBalance, accountBalance, globStaffType, liabilityData, invoiceCashData, firm, invoiceViaAccount, bank, invoiceData, invoiceCash, invoiceBank, _invoiceCashData, _invoiceViaAccount, _invoiceData, _invoiceCash, _invoiceBank;

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                additionAmount = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.additionAmount) - __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.selectedLiability.amount);
                operationAmountFromCash = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.operationAmountFromCash) - __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.selectedLiability.amountFromCash);
                operationAmountFromBank = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.operationAmountFromBank) - __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.selectedLiability.amountFromBank);
                self = this;
                asset = {
                  brand: this.selectedBrand
                };

                if (this.selectedFirmFromAsset) {
                  _context2.next = 7;
                  break;
                }

                return _context2.abrupt("return", this.$emit("notify", "select firm"));

              case 7:
                if (this.addition) {
                  _context2.next = 9;
                  break;
                }

                return _context2.abrupt("return", this.$emit("notify", "Select transaction type"));

              case 9:
                if (this.additionAmount) {
                  _context2.next = 13;
                  break;
                }

                return _context2.abrupt("return", this.$emit("notify", "Add amount"));

              case 13:
                asset.totalAdditionAmount = (this.asset.totalAdditionAmount || 0) + Number(this.additionAmount);

              case 14:
                if (!(this.operationPaymentType === "CashAndBank Account" && (!this.operationAmountFromCash || !this.operationAmountFromBank))) {
                  _context2.next = 16;
                  break;
                }

                return _context2.abrupt("return", this.$emit("notify", "Enter amount to pay from bank and cash for operation"));

              case 16:
                if (!(this.operationPaymentType !== "Cash" && !this.operationAccountForTransaction)) {
                  _context2.next = 18;
                  break;
                }

                return _context2.abrupt("return", this.$emit("notify", "Select Bank account for operation"));

              case 18:
                transactionError = false;

                if (!(this.addition != "return")) {
                  _context2.next = 43;
                  break;
                }

                firmBalance = this.firmById[this.selectedFirmFromAsset].amount;
                accountBalance = this.operationAccountForTransaction ? this.bankById[this.operationAccountForTransaction].amount : 0;
                _context2.t0 = this.operationPaymentType;
                _context2.next = _context2.t0 === "Cash" ? 25 : _context2.t0 === "Bank Account" ? 29 : _context2.t0 === "CashAndBank Account" ? 33 : 43;
                break;

              case 25:
                if (!(additionAmount > firmBalance)) {
                  _context2.next = 28;
                  break;
                }

                transactionError = "Insufficiant balance in firm " + firmBalance;
                return _context2.abrupt("break", 43);

              case 28:
                return _context2.abrupt("break", 43);

              case 29:
                if (!(additionAmount > accountBalance)) {
                  _context2.next = 32;
                  break;
                }

                // Insufficient balance in bank account
                transactionError = "Insufficient balance in bank Account " + accountBalance + " to pay";
                return _context2.abrupt("break", 43);

              case 32:
                return _context2.abrupt("break", 43);

              case 33:
                if (!(Number(additionAmount) !== Number(operationAmountFromCash) + Number(operationAmountFromBank))) {
                  _context2.next = 36;
                  break;
                }

                transactionError = "Total of by cash and bank amount should be same as operation Amount!";
                return _context2.abrupt("break", 43);

              case 36:
                if (!(operationAmountFromCash > firmBalance)) {
                  _context2.next = 39;
                  break;
                }

                transactionError = "Insufficiant balance in firm " + firmBalance;
                return _context2.abrupt("break", 43);

              case 39:
                if (!(operationAmountFromBank > accountBalance)) {
                  _context2.next = 42;
                  break;
                }

                // Insufficient balance in bank account
                transactionError = "Insufficient balance in bank Account " + accountBalance + " to pay";
                return _context2.abrupt("break", 43);

              case 42:
                return _context2.abrupt("break", 43);

              case 43:
                if (!transactionError) {
                  _context2.next = 45;
                  break;
                }

                return _context2.abrupt("return", this.$emit("notify", transactionError));

              case 45:

                // liability adance commostion debite
                globStaffType = this.staffById[this.selectStaff].staffRole;
                liabilityData = {
                  brand: this.selectedBrand,
                  firm: this.selectedFirmFromAsset,
                  staffId: this.selectStaff,
                  staffType: globStaffType,
                  transactionType: this.addition, //liability etc
                  paymentType: this.operationPaymentType,
                  amount: Number(this.additionAmount),
                  date: this.liabilityInvoiceDate ? Date.parse(this.liabilityInvoiceDate) : Date.now(),
                  remark: this.staffRemark
                };


                if (this.addition != "return") {
                  liabilityData.isCredited = true;

                  // create a invoice data now
                  if (this.operationPaymentType == "Cash") {
                    invoiceCashData = {
                      brand: this.selectedBrand,
                      firm: this.selectedFirmFromAsset,
                      type: "automatic invoice",
                      transactionType: "Staff",
                      paymentType: this.operationPaymentType,
                      accountNumber: "",
                      isCredited: false,
                      totalAmount: Number(this.additionAmount),
                      remark: this.staffRemark,
                      staffkey: this.selectStaff,
                      staffType: globStaffType,
                      date: this.liabilityInvoiceDate ? Date.parse(this.liabilityInvoiceDate) : Date.now()
                    };
                    firm = this.firmById[invoiceCashData.firm];

                    firm.amount = firm && firm.amount - additionAmount;
                    this.$root.$firebaseRefs.firm.child(invoiceCashData.firm).set(firm);

                    invoiceCashData.amountFromCash = invoiceCashData.totalAmount;
                    invoiceCashData.liabilityType = this.addition;
                    this.$root.$firebaseRefs.invoice.child(this.selectedCashInvoice).set(invoiceCashData);
                    //let res = self.$root.$firebaseRefs.invoice.push(invoiceCashData);
                    liabilityData["invoiceIdCash"] = this.selectedCashInvoice;
                    liabilityData["amountFromCash"] = invoiceCashData["totalAmount"];
                  } else if (this.operationPaymentType == "Bank Account") {
                    invoiceViaAccount = {
                      brand: this.selectedBrand,
                      firm: this.selectedFirmFromAsset,
                      type: "automatic invoice",
                      transactionType: "Staff",
                      paymentType: this.operationPaymentType,
                      isCredited: false,
                      totalAmount: Number(this.additionAmount),
                      remark: this.staffRemark,
                      staffkey: this.selectStaff,
                      staffType: globStaffType,
                      date: this.liabilityInvoiceDate ? Date.parse(this.liabilityInvoiceDate) : Date.now()
                    };


                    invoiceViaAccount.amountFromBank = additionAmount;
                    invoiceViaAccount.bank = this.operationAccountForTransaction;

                    if (invoiceViaAccount.bank) {
                      invoiceViaAccount.accountNumber = this.bankById[invoiceViaAccount.bank].accountnumber;
                    }

                    firm = this.firmById[invoiceViaAccount.firm];
                    bank = this.bankById[invoiceViaAccount.bank];


                    bank.amount = bank && bank.amount - invoiceViaAccount.totalAmount;
                    this.$root.$firebaseRefs.account.child(invoiceViaAccount.bank).set(bank);
                    invoiceViaAccount.liabilityType = this.addition;
                    // let res = self.$root.$firebaseRefs.invoice.push(invoiceViaAccount);
                    this.$root.$firebaseRefs.invoice.child(this.selectedBankInvoice).set(invoiceViaAccount);
                    liabilityData["invoiceIdBank"] = this.selectedBankInvoice;
                    liabilityData["amountFromBank"] = invoiceViaAccount["totalAmount"];
                    liabilityData["bank"] = invoiceViaAccount["bank"];
                    self.additionAmount = null;
                    self.selectedFirmFromAsset = null;
                    self.staffRemark = null;
                  } else {
                    // CASHwithBank Account

                    invoiceData = {
                      brand: this.selectedBrand,
                      firm: this.selectedFirmFromAsset,
                      type: "automatic invoice",
                      transactionType: "Staff",
                      isCredited: false,
                      remark: this.staffRemark,
                      staffkey: this.selectStaff,
                      staffType: globStaffType,
                      date: this.liabilityInvoiceDate ? Date.parse(this.liabilityInvoiceDate) : Date.now()
                    };

                    //CASH *************************************

                    firm = this.firmById[invoiceData.firm];
                    invoiceCash = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, invoiceData);

                    invoiceCash.paymentType = "CashAndBank Account";
                    invoiceCash.totalAmount = Number(this.operationAmountFromCash);
                    invoiceCash.amountFromCash = Number(this.operationAmountFromCash);

                    firm.amount = firm && firm.amount - operationAmountFromCash;
                    this.$root.$firebaseRefs.firm.child(invoiceCash.firm).set(firm);
                    invoiceCash.liabilityType = this.addition;
                    //let res = self.$root.$firebaseRefs.invoice.push(invoiceCash);
                    liabilityData["invoiceIdCash"] = this.selectedCashInvoice;
                    this.$root.$firebaseRefs.invoice.child(this.selectedCashInvoice).set(invoiceCash);
                    liabilityData["amountFromCash"] = invoiceCash["totalAmount"];
                    // BANK **************************************
                    invoiceBank = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, invoiceData);

                    invoiceBank.paymentType = "Bank Account";
                    invoiceBank.totalAmount = Number(this.operationAmountFromBank);
                    invoiceBank.amountFromBank = Number(this.operationAmountFromBank);
                    invoiceBank.bank = this.operationAccountForTransaction;

                    if (invoiceBank.bank) {
                      invoiceBank.accountNumber = this.bankById[invoiceBank.bank].accountnumber;
                    }

                    bank = this.bankById[invoiceBank.bank];

                    bank.amount = bank && bank.amount - operationAmountFromBank;
                    this.$root.$firebaseRefs.account.child(invoiceBank.bank).set(bank);
                    invoiceBank.liabilityType = this.addition;
                    //res = self.$root.$firebaseRefs.invoice.push(invoiceBank);
                    liabilityData["invoiceIdBank"] = this.selectedBankInvoice;
                    this.$root.$firebaseRefs.invoice.child(this.selectedBankInvoice).set(invoiceBank);
                    liabilityData["amountFromBank"] = invoiceBank["totalAmount"];
                    liabilityData["bank"] = invoiceBank["bank"];
                    self.additionAmount = null;
                    self.selectedFirmFromAsset = null;
                    self.staffRemark = null;
                  }
                } else {
                  liabilityData.isCredited = false;

                  if (this.operationPaymentType == "Cash") {
                    _invoiceCashData = {
                      brand: this.selectedBrand,
                      firm: this.selectedFirmFromAsset,
                      type: "automatic invoice",
                      transactionType: "Staff",
                      paymentType: this.operationPaymentType,
                      accountNumber: "",
                      isCredited: true,
                      totalAmount: Number(this.additionAmount),
                      remark: this.staffRemark,
                      staffkey: this.selectStaff,
                      staffType: globStaffType,
                      date: this.liabilityInvoiceDate ? Date.parse(this.liabilityInvoiceDate) : Date.now()
                    };
                    firm = this.firmById[_invoiceCashData.firm];

                    firm.amount = firm && firm.amount + additionAmount;
                    this.$root.$firebaseRefs.firm.child(_invoiceCashData.firm).set(firm);

                    _invoiceCashData.amountFromCash = _invoiceCashData.totalAmount;
                    _invoiceCashData.liabilityType = this.addition;
                    //let res = self.$root.$firebaseRefs.invoice.push(invoiceCashData);
                    this.$root.$firebaseRefs.invoice.child(this.selectedCashInvoice).set(_invoiceCashData);
                    liabilityData["amountFromCash"] = _invoiceCashData["totalAmount"];
                    liabilityData["invoiceIdCash"] = this.selectedCashInvoice;
                  } else if (this.operationPaymentType == "Bank Account") {
                    _invoiceViaAccount = {
                      brand: this.selectedBrand,
                      firm: this.selectedFirmFromAsset,
                      type: "automatic invoice",
                      transactionType: "Staff",
                      paymentType: this.operationPaymentType,
                      isCredited: true,
                      totalAmount: Number(this.additionAmount),
                      remark: this.staffRemark,
                      staffkey: this.selectStaff,
                      staffType: globStaffType,
                      date: this.liabilityInvoiceDate ? Date.parse(this.liabilityInvoiceDate) : Date.now()
                    };


                    _invoiceViaAccount.amountFromBank = _invoiceViaAccount.totalAmount;
                    _invoiceViaAccount.bank = this.operationAccountForTransaction;

                    if (_invoiceViaAccount.bank) {
                      _invoiceViaAccount.accountNumber = this.bankById[_invoiceViaAccount.bank].accountnumber;
                    }

                    firm = this.firmById[_invoiceViaAccount.firm];
                    bank = this.bankById[_invoiceViaAccount.bank];


                    bank.amount = bank && bank.amount + additionAmount;
                    this.$root.$firebaseRefs.account.child(_invoiceViaAccount.bank).set(bank);
                    _invoiceViaAccount.liabilityType = this.addition;
                    //let res = self.$root.$firebaseRefs.invoice.push(invoiceViaAccount);
                    liabilityData["invoiceIdBank"] = this.selectedBankInvoice;
                    this.$root.$firebaseRefs.invoice.child(this.selectedBankInvoice).set(_invoiceViaAccount);
                    liabilityData["amountFromBank"] = _invoiceViaAccount["totalAmount"];
                    liabilityData["bank"] = _invoiceViaAccount["bank"];
                    self.additionAmount = null;
                    self.selectedFirmFromAsset = null;
                    self.staffRemark = null;
                  } else {
                    // CASHwithBank Account

                    _invoiceData = {
                      brand: this.selectedBrand,
                      firm: this.selectedFirmFromAsset,
                      type: "automatic invoice",
                      transactionType: "Staff",
                      isCredited: true,
                      remark: this.staffRemark,
                      staffkey: this.selectStaff,
                      staffType: globStaffType,
                      date: this.liabilityInvoiceDate ? Date.parse(this.liabilityInvoiceDate) : Date.now()
                    };

                    //CASH *************************************

                    firm = this.firmById[_invoiceData.firm];
                    _invoiceCash = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, _invoiceData);

                    _invoiceCash.paymentType = "CashAndBank Account";
                    _invoiceCash.totalAmount = Number(this.operationAmountFromCash);
                    _invoiceCash.amountFromCash = Number(this.operationAmountFromCash);

                    firm.amount = firm && firm.amount + operationAmountFromCash;
                    this.$root.$firebaseRefs.firm.child(_invoiceCash.firm).set(firm);
                    _invoiceCash.liabilityType = this.addition;
                    //let res = self.$root.$firebaseRefs.invoice.push(invoiceCash);
                    this.$root.$firebaseRefs.invoice.child(this.selectedCashInvoice).set(_invoiceCash);
                    liabilityData["amountFromCash"] = _invoiceCash["totalAmount"];
                    liabilityData["invoiceIdCash"] = this.selectedCashInvoice;
                    // BANK **************************************
                    _invoiceBank = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, _invoiceData);

                    _invoiceBank.paymentType = "Bank Account";
                    _invoiceBank.totalAmount = Number(this.operationAmountFromBank);
                    _invoiceBank.amountFromBank = Number(this.operationAmountFromBank);
                    _invoiceBank.bank = this.operationAccountForTransaction;

                    if (_invoiceBank.bank) {
                      _invoiceBank.accountNumber = this.bankById[_invoiceBank.bank].accountnumber;
                    }

                    bank = this.bankById[_invoiceBank.bank];

                    bank.amount = bank && bank.amount + operationAmountFromBank;
                    this.$root.$firebaseRefs.account.child(_invoiceBank.bank).set(bank);
                    _invoiceBank.liabilityType = this.addition;
                    //res = self.$root.$firebaseRefs.invoice.push(invoiceBank);
                    liabilityData["invoiceIdBank"] = this.selectedBankInvoice;
                    this.$root.$firebaseRefs.invoice.child(this.selectedBankInvoice).set(_invoiceBank);
                    liabilityData["amountFromBank"] = _invoiceBank["totalAmount"];
                    liabilityData["bank"] = _invoiceBank["bank"];
                    self.additionAmount = null;
                    self.selectedFirmFromAsset = null;
                    self.staffRemark = null;
                  }
                }

                this.$root.$firebaseRefs.liabilitys.child(this.selectedliability[".key"]).set(liabilityData);
                // close modal
                this.$emit("notify", "liability account edited", true);
                this.dialog = false;
                this.dialogEditInvoice = false;
                //this.reset(true);

              case 52:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function liabilityAmountClick(_x) {
        return _ref2.apply(this, arguments);
      }

      return liabilityAmountClick;
    }()
  }
});

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Sidebar__ = __webpack_require__(1392);

//
//
//
//
//
//
//
//
//
//
//
//



var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Sidebar: __WEBPACK_IMPORTED_MODULE_2__Sidebar__["a" /* default */]
  },
  created: function created() {
    this.$bindAsArray("accounts", this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand"]), {
    bankByBrand: function bankByBrand() {
      var _this = this;

      return this.accounts.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      });
    }
  })
});

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      items: [{
        header: 'Reports'
      },
      // {
      //   title: 'Balance Sheet',
      //   subtitle: 'Manage Balance sheet',
      //   link: 'Balancesheet',
      //   icon: 'account_balance'
      // },
      { divider: true, inset: true }, {
        title: 'Financial Reports',
        style: 'padding-right: 20px; margin-right: 15px;  font-size:25px',
        subtitle: 'View Balance Sheet, Trading A/C, Capital A/C, P&L Account',
        icon: 'api',
        isMultiple: true,
        children: [{
          title: 'Balance Sheet',
          subtitle: 'View Balance Sheet',
          link: 'Bsheet',
          icon: 'format_bold'
        }, { divider: true, inset: true }, {
          title: 'Trading Account',
          subtitle: 'View Trading Account',
          link: 'Tradingaccount',
          icon: 'analytics'
        }, { divider: true, inset: true }, {
          title: 'Profit & Loss Account',
          subtitle: 'View Profit and Loss Summary',
          link: 'Profitandloss',
          icon: 'local_parking'
        }, { divider: true, inset: true }, {
          title: 'Capital Account',
          subtitle: 'View Proprietor Capital Account',
          link: 'Proprietor',
          icon: 'assignment_ind'
        }, { divider: true, inset: true }, {
          title: 'Trail Balance',
          subtitle: 'View and Manage Trail Balance',
          link: 'TrailBalanceAccounts',
          icon: 'title'
        }]
      },

      // Other Accounts
      { divider: true, inset: true }, {
        title: 'Other Reports',
        style: 'padding-right: 20px; margin-right: 15px;  font-size:25px',
        subtitle: 'Extra Charges, Sales Team and Other Accounts ',
        icon: 'open_with',
        isMultiple: true,
        children: [{ divider: true, inset: true }, {
          title: 'Cash Book',
          subtitle: 'View Cash Account',
          link: 'CashAccount',
          icon: 'luggage'
        }, { divider: true, inset: true }, {
          title: 'Product Order Report',
          subtitle: 'View Product Order Report',
          link: 'ProductOrderReport',
          icon: 'agriculture'
        }, { divider: true, inset: true }, {
          title: 'Batch Report',
          subtitle: 'View Batch Report',
          link: 'BatchReport',
          icon: 'agriculture'
        }, { divider: true, inset: true }, {
          title: 'Extra Charges Account',
          subtitle: 'View Extra Charges Invoices',
          link: 'ExtraChargesInvoices',
          icon: 'copyright'
        }, { divider: true, inset: true }, {
          title: 'Incentive Account',
          subtitle: 'View Incentive Invoices',
          link: 'IncentiveInvoices',
          icon: 'note_add'
        }, { divider: true, inset: true }, {
          title: 'Discount Account',
          subtitle: 'View Discount Accounts',
          link: 'DiscountAccounts',
          icon: 'feedback'
        }, { divider: true, inset: true }, {
          title: 'Interest Account',
          subtitle: 'View Interest Accounts',
          link: 'interestAccounts',
          icon: 'format_italic'
        }, { divider: true, inset: true }, {
          title: 'Team Members Account',
          subtitle: 'View & Manage Sales Team Transactions',
          link: 'Staffs',
          icon: 'engineering'
        }]
      },

      //Registers
      { divider: true, inset: true }, {
        title: 'Enterprise Registers',
        style: 'padding-right: 20px; margin-right: 15px;  font-size:25px',
        subtitle: 'Sales, Purchase, Stock, Receipt, Order, Dispatch, Delivery Registers',
        icon: 'all_out',
        isMultiple: true,
        children: [{ divider: true, inset: true },
        // {
        //   title: 'Sale Register',
        //   subtitle: 'View Sale Register Report',
        //   link: '/sale-register',
        //   icon: 'grading'
        // },
        // { divider: true, inset: true },
        // {
        //   title: 'Purchase Register',
        //   subtitle: 'View Purchase Register',
        //   link: 'SalePurchaseStatements',
        //   icon: 'summarize'
        // },
        { divider: true, inset: true }, {
          title: 'Stock Register',
          subtitle: 'View Stock Register Report',
          link: 'Reports',
          icon: 'view_comfy'
        }, { divider: true, inset: true }, {
          title: 'Order Register',
          subtitle: 'Manage Order Register',
          link: 'RecordOrder',
          icon: 'content_paste'
        }, { divider: true, inset: true },
        // {
        //   title: 'Dispatch Register',
        //   subtitle: 'View Dispatch Register',
        //   link: 'RecordDispatch',
        //   icon: 'fact_check'
        // },
        // { divider: true, inset: true },
        // {
        //   title: 'Delivery Register',
        //   subtitle: 'Manage Delivery Registeer',
        //   link: 'RecordDelivery',
        //   icon: 'commute'
        // },
        { divider: true, inset: true }, {
          title: 'Receipt Register',
          subtitle: 'View & Manage Receipt Register',
          link: 'ReceiptRegister',
          icon: 'chrome_reader_mode'
        }, { divider: true, inset: true }, {
          title: 'Payment Register',
          subtitle: 'View & Manage Payment Register',
          link: 'PaymentRegister',
          icon: 'menu_book'
        }]
      },

      // Invoices Categories
      { divider: true, inset: true }, {
        title: 'Invoices Categories',
        style: 'padding-right: 20px; margin-right: 15px;  font-size:25px',
        subtitle: 'View Invoices - Unpicked, Alert, To Restore, To Delete',
        icon: 'repeat',
        isMultiple: true,
        children: [{ divider: true, inset: true }, {
          title: 'Alert Invoices',
          subtitle: 'View Alert List',
          link: 'Alertsheet',
          icon: 'notification_important'
        }, { divider: true, inset: true }, {
          title: 'Unpaid Invoices',
          subtitle: 'View Due Invoices [Marked] ',
          link: 'Unpickupsheet',
          icon: 'warning'
        }, { divider: true, inset: true }, {
          title: 'Restore Invoice',
          subtitle: 'View Deleted Invoices',
          link: 'DeletedInvoiceBook',
          icon: 'wifi_protected_setup'
        }, { divider: true, inset: true }, {
          title: 'Multi Print Invoices',
          subtitle: 'Download Multiple Invoices',
          link: 'MultiPrintInvoices',
          icon: 'print'
        }]
      },
      // End of Transactions


      // Product Categories
      // { divider: true, inset: true },
      // {
      //   title: 'Product Reports',
      //   style: 'padding-right: 20px; margin-right: 15px;  font-size:25px',
      //   subtitle: 'Product Reports By - Group, Category, Type, Set',
      //   icon: 'repeat',
      //   isMultiple : true,
      //   children: [
      //     { divider: true, inset: true },
      //     {
      //       title: 'Product Group',
      //       subtitle: 'View Reports Via Product Group',
      //       link: 'ProductGroupReports',
      //       icon: 'notification_important'
      //     },
      //     { divider: true, inset: true },
      //     {
      //       title: 'Product Category',
      //       subtitle: 'View Reports Via Product Category',
      //       link: 'ProductCategoryReports',
      //       icon: 'notification_important'
      //     },
      //     { divider: true, inset: true },
      //     {
      //       title: 'Product Type',
      //       subtitle: 'View Reports Via Product Type',
      //       link: 'ProductTypeReports',
      //       icon: 'notification_important'
      //     },
      //     { divider: true, inset: true },
      //     {
      //       title: 'Product Set',
      //       subtitle: 'View Reports via Product Set',
      //       link: 'ProductSetReports',
      //       icon: 'notification_important'
      //     },
      //   ]
      // },

      // GST Reports
      { divider: true, inset: true }, {
        title: 'GST Reports',
        style: 'padding-right: 20px; margin-right: 15px;  font-size:25px',
        subtitle: 'View GSTR-1, GSTR-3B, All GST Accounts, View ITC',
        icon: 'shopping_basket',
        isMultiple: true,
        children: [{ divider: true, inset: true }, {
          title: 'GST RATE WISE REPORT',
          subtitle: 'View GST Report via rate',
          link: 'GSTAccounts',
          icon: 'backup_table'
        }, { divider: true, inset: true }, {
          title: 'GSTR MONTHLY',
          subtitle: 'View GSTR Monthly, Quaterly',
          link: 'GSTMonthly',
          icon: 'backup_table'
        }, { divider: true, inset: true }, {
          title: 'GSTR-1',
          subtitle: 'View GSTR-1',
          link: 'GST1Reports',
          icon: 'backup_table'
        }, { divider: true, inset: true }, {
          title: 'GSTR-3B',
          subtitle: 'View GST Accounts',
          link: 'GST3Reports',
          icon: 'backup_table'
        }, { divider: true, inset: true }, {
          title: 'ITC',
          subtitle: 'View ITC Summary',
          link: 'IST',
          icon: 'backup_table'
        }]
      },

      // { divider: true, inset: true },
      // {
      //   title: 'P & L Account',
      //   subtitle: 'Manage P&L',
      //   link: 'PandL',
      //   icon: 'domain'
      // },

      // { divider: true, inset: true },
      // {
      //   title: 'Prop Account',
      //   subtitle: 'Manage Prop Account',
      //   link: 'Prop',
      //   icon: 'person'
      // },


      // {
      //   title: 'Defaulter Buyer',
      //   subtitle: 'View Defaulter List',
      //   link: 'Defaultersheet',
      //   icon: 'cancel_presentation'
      // },
      // { divider: true, inset: true },
      // { divider: true, inset: true },
      // {
      //   title: 'Item Sheet',
      //   subtitle: 'View Item Summary',
      //   link: 'Itemsheet',
      //   icon: 'border_all'
      // },

      { divider: true, inset: true }, {
        title: 'Collection Book',
        subtitle: 'View Collection Book',
        link: 'CollectionBook',
        icon: 'agriculture'
      }, { divider: true, inset: true }, {
        title: 'SMS Book',
        subtitle: 'Manage SMS',
        link: 'SMSBook',
        icon: 'sms'
      }, { divider: true, inset: true }, {
        title: 'Help Book',
        subtitle: 'View Help Book',
        link: 'HelpBook',
        icon: 'contact_support'
      }]
    };
  }
});

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__addProduct__ = __webpack_require__(240);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    AddProduct: __WEBPACK_IMPORTED_MODULE_5__addProduct__["a" /* default */]
  },
  data: function data() {
    return {
      isBuyer: true,
      search: null,
      selectedGroup: null,
      stepperValue: 1,
      compositionSuggestions: [],
      suggestionAdded: false,
      showOnlyActiveProd: true,
      transferDialog: false,
      branchDialog: false,
      viewBatchDialog: false,
      batchDialog: false,
      damageDialog: false,
      isOpeningBalance: false,
      isStanderedPrice: false,
      addProductDialog: false,
      productToTansfer: null,
      productToBranch: null,
      productToBatch: null,
      productToDamage: null,
      datepickerTransfer: false,
      datepickerBranch: false,
      datepickerBatch: false,
      todatepickerBatch: false,
      datepickerDamage: false,
      currentGodawn: null,
      currentBranch: null,
      transferQuantity: 0,
      branchQuantity: 0,
      batchQuantity: 0,
      damageQuantity: 0,
      batchNumber: "",
      brand: {},
      datepicker: false,
      duplicateError: null,
      transferDate: new Date().toISOString().substr(0, 10),
      branchDate: new Date().toISOString().substr(0, 10),
      manufacuturingDate: new Date().toISOString().substr(0, 10),
      expiryDate: new Date().toISOString().substr(0, 10),
      damageDate: new Date().toISOString().substr(0, 10),
      currentProduct: {
        name: "",
        description: "",
        HSN_code: 0,
        GST_type: "",
        taxableGST_rate: 0,
        unit: "",
        quantity: 0,
        brand: "",
        openingDate: new Date().toISOString().substr(0, 10),
        purchasingPrice: null,
        sellingPrice: null,
        openingBalance: null,
        gstValue: 0,
        basicPrice: 0,
        barcode: "",
        productGroup: null,
        productCategory: null,
        productType: null,
        unitsDetails: [{
          unit: '',
          isLast: true,
          isFirst: true,
          order: 1,
          quantity: 0,
          rate: true
        }],
        unitsDeatilsAdded: false,
        isActive: true
      },
      timeout: 3000,
      snackbar: false,
      productList: [],
      productListHeader: [
      // { text: "Product- ID", value: "Product - ID" },
      { text: "Product Name", value: "name", sortable: true }, { text: "Description", value: "Description" },
      // { text: "HSN code", value: "HSN" },
      // { text: "GST type", value: "GST" },
      // { text: "Taxable rate", value: "Taxable" },
      { text: "Unit", value: "Unit" },
      // { text: "Opening Date", value: "quantity" },
      // { text: "Opening Quantity", value: "quantity" },
      // { text: "Purchase Quantity", value: "quantity" },
      // { text: "Sale Quantity", value: "quantity" },
      // { text: "Available Quantity", value: "quantity" },
      // { text: "Opening Balance", value: "quantity" },
      // { text: "Purchase Balance", value: "quantity" },
      // { text: "Sale Balance", value: "quantity" },
      // { text: "Closing Balance", value: "quantity" },
      // { text: "Purchasing Price", value: "quantity" },
      // { text: "Selling Price", value: "quantity" },
      // { text: "Basic Price", value: "quantity" },
      // { text: "Gst Value", value: "quantity" },
      { text: "Transfer", value: "transfer" }, { text: "Branch", value: "branch" }, { text: "Batch", value: "transfer" }, { text: "Edit", value: "edit" }, { text: "Delete", value: "delete" }, { text: "Damage", value: "transfer" }],
      productListHeaderByBatch: [{ text: "Batch", value: "batch" }, { text: "Manufacturing Date", value: "manuDate" }, { text: "Expiry Date", value: "expiryDate" }, { text: "Quantity", value: "quantity" }],
      bachList: [],
      batchSelectedProduct: null,
      password: null,
      passwordDialog: false,
      currentPasswordReference: null,
      currentPasswordMethod: null
    };
  },
  created: function created() {
    this.$bindAsArray("productList", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("godawns", this.$root.$firebaseRefs.godawn.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("godawnTrans", this.$root.$firebaseRefs.godawnTransaction.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("branchs", this.$root.$firebaseRefs.branch.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("branchTrans", this.$root.$firebaseRefs.branchTransaction.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('productGroups', this.$root.$firebaseRefs.productGroup.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('productCategories', this.$root.$firebaseRefs.productCategory.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('productTypes', this.$root.$firebaseRefs.productType.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("batch", this.$root.$firebaseRefs.batchTransaction.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("damage", this.$root.$firebaseRefs.damageTransaction.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("firmSettings", this.$root.$firebaseRefs.firmSettings.orderByChild("brand").equalTo(this.selectedBrand));
    if (this.$route.params.isNew) {
      this.addProduct();
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear", "roleAndPermission"]), mapGlobalGetters({ units: "productUnit" }), {
    productGroupListByBrand: function productGroupListByBrand() {
      var _this = this;

      return this.productGroups.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      }).map(function (item) {
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
    },
    hasProductAddPermission: function hasProductAddPermission() {
      if (this.roleAndPermission && this.roleAndPermission.permissions && this.roleAndPermission.permissions.length && this.roleAndPermission.permissions.indexOf('PRODUCT_ADD') > -1) {
        return true;
      } else {
        return false;
      }
    },
    hasProductEditPermission: function hasProductEditPermission() {
      if (this.roleAndPermission && this.roleAndPermission.permissions && this.roleAndPermission.permissions.length && this.roleAndPermission.permissions.indexOf('PRODUCT_EDIT') > -1) {
        return true;
      } else {
        return false;
      }
    },
    hasProductDeletePermission: function hasProductDeletePermission() {
      if (this.roleAndPermission && this.roleAndPermission.permissions && this.roleAndPermission.permissions.length && this.roleAndPermission.permissions.indexOf('PRODUCT_DELETE') > -1) {
        return true;
      } else {
        return false;
      }
    },
    hasProductTransferPermission: function hasProductTransferPermission() {
      if (this.roleAndPermission && this.roleAndPermission.permissions && this.roleAndPermission.permissions.length && this.roleAndPermission.permissions.indexOf('PRODUCT_TRANSFER') > -1) {
        return true;
      } else {
        return false;
      }
    },
    productListByBrand: function productListByBrand() {
      var _this2 = this;

      var prod = this.productList.filter(function (item) {
        return item["brand"] === _this2.selectedBrand && (
        // (item.openingDate ? (item.openingDate >= this.finYear.start) 
        // && (item.openingDate <= this.finYear.end) : true) 
        _this2.selectedGroup ? item['productGroup'] == _this2.selectedGroup : true) && (_this2.showOnlyActiveProd ? item['isActive'] == true : true) && (!!_this2.search ? !!item["name"].toLowerCase().includes(_this2.search.toLowerCase()) : true);
      });
      if (!this.suggestionAdded) {
        this.compositionSuggestions = [];
      }
      prod.map(function (p) {
        if (!_this2.suggestionAdded) {
          if (p.composition && _this2.compositionSuggestions.indexOf(p.composition) == -1) {
            _this2.compositionSuggestions.push(p.composition);
          }
        }
        if (p.unitsDeatilsAdded && p.unitsDetails && p.unitsDetails.length) {
          p['openingQuantityTitle'] = _this2.getFilteredQuantity(p, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(p['openingQuantity']));
          p['purchaseQuantityTitle'] = _this2.getFilteredQuantity(p, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(p['purchaseQuantity']));
          p['saleQuantityTitle'] = _this2.getFilteredQuantity(p, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(p['saleQuantity']));
          p['closingQuantityTitle'] = _this2.getFilteredQuantity(p, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(p['openingQuantity']) + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(p['purchaseQuantity']) - __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(p['saleQuantity']));
        }
      });
      return prod;
    },
    godawnByBrand: function godawnByBrand() {
      var _this3 = this;

      return this.godawns.filter(function (item) {
        return item["brand"] === _this3.selectedBrand;
      });
    },
    branchByBrand: function branchByBrand() {
      var _this4 = this;

      return this.branchs.filter(function (item) {
        return item["brand"] === _this4.selectedBrand;
      });
    }
  }),
  methods: {
    getFilteredQuantity: function getFilteredQuantity(product, qty) {
      var quantity = qty;
      var string = "";
      product.unitsDetails.sort(function (a, b) {
        return new Date(b.order) - new Date(a.order);
      });
      for (var i = 0; i < product.unitsDetails.length; i++) {
        if (quantity > __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(product.unitsDetails[i].quantity) && i + 1 < product.unitsDetails.length) {
          var temp = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(quantity) / __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(product.unitsDetails[i].quantity);
          string = "(" + (temp.toString().split(".")[1] ? temp.toString().split(".")[1] : 0) + " " + product.unitsDetails[i].unit + ") " + string;
          quantity = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(temp.toString().split(".")[0]);
        } else {
          string = "(" + quantity + " " + product.unitsDetails[i].unit + ") " + string;
          break;
        }
      }
      // console.log(string)
      return string;
    },
    transferToGodawn: function transferToGodawn() {
      var transferObj = {
        quantity: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(this.transferQuantity),
        date: new Date(this.transferDate).getTime(),
        product: this.productToTansfer['.key'],
        godawn: this.currentGodawn['.key'],
        brand: this.selectedBrand
      };
      this.$root.$firebaseRefs.godawnTransaction.push(transferObj);
      var key = this.productToTansfer[".key"];
      delete this.productToTansfer[".key"];

      this.transferDialog = false;
      this.transferQuantity = 0;
      this.currentGodawn = null;
      this.productToTansfer = null;
      this.transferDate = new Date().toISOString().substr(0, 10);
    },
    transferToBranch: function transferToBranch() {
      var branchObj = {
        quantity: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(this.branchQuantity),
        date: new Date(this.branchDate).getTime(),
        product: this.productToBranch['.key'],
        branch: this.currentBranch['.key'],
        brand: this.selectedBrand
      };
      this.$root.$firebaseRefs.branchTransaction.push(branchObj);
      var key = this.productToBranch[".key"];
      delete this.productToBranch[".key"];
      this.branchDialog = false;
      this.branchQuantity = 0;
      this.currentBranch = null;
      this.productToBranch = null;
      this.branchDate = new Date().toISOString().substr(0, 10);
    },
    transferToDamage: function transferToDamage() {
      var damageObj = {
        quantity: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(this.damageQuantity),
        date: new Date(this.damageDate).getTime(),
        product: this.productToDamage['.key'],
        // godawn : this.currentGodawn['.key'],
        brand: this.selectedBrand
      };
      this.$root.$firebaseRefs.damageTransaction.push(damageObj);
      var key = this.productToDamage[".key"];
      delete this.productToDamage[".key"];
      // productToDamage['quantity'] = productToDamage['quantity'] - damageObj.quantity;
      // this.$root.$firebaseRefs.products.child(key).set(productToDamage);
      this.productToDamage['quantity'] = this.productToDamage['quantity'] - damageObj.quantity;
      this.$root.$firebaseRefs.products.child(key).set(this.productToDamage);

      this.damageDialog = false;
      this.damageQuantity = 0;
      // this.currentGodawn = null;
      this.productToDamage = null;
      this.damageDate = new Date().toISOString().substr(0, 10);
    },
    addToBatch: function addToBatch() {
      var batchObj = {
        quantity: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(this.batchQuantity),
        openingQuantity: parseInt(this.batchQuantity),
        manufacturingDate: new Date(this.manufacuturingDate).getTime(),
        expiryDate: new Date(this.expiryDate).getTime(),
        product: this.productToBatch['.key'],
        batchNumber: this.batchNumber,
        // godawn : this.currentGodawn['.key'],
        brand: this.selectedBrand
      };
      this.$root.$firebaseRefs.batchTransaction.push(batchObj);
      var key = this.productToBatch[".key"];
      delete this.productToBatch[".key"];
      // productToBatch['quantity'] = productToBatch['quantity'] - transferObj.quantity;
      // this.$root.$firebaseRefs.products.child(key).set(productToBatch);

      // this.productToBatch['quantity'] = this.productToBatch['quantity'] - transferObj.quantity;
      // this.$root.$firebaseRefs.products.child(key).set(this.productToBatch);

      this.batchDialog = false;
      this.batchQuantity = 0;
      this.batchNumber = "";
      // this.currentGodawn = null;
      this.productToBatch = null;
      this.manufacuturingDate = new Date().toISOString().substr(0, 10);
      this.expiryDate = new Date().toISOString().substr(0, 10);
    },
    openTansferDialog: function openTansferDialog(product) {
      this.productToTansfer = product;
      this.transferDialog = true;
    },
    openBranchDialog: function openBranchDialog(product) {
      this.productToBranch = product;
      this.branchDialog = true;
    },
    openBatchDialog: function openBatchDialog(product) {
      this.productToBatch = product;
      this.batchDialog = true;
    },
    viewProductByBatch: function viewProductByBatch(product) {
      var _this5 = this;

      this.batchSelectedProduct = product;
      this.viewBatchDialog = true;
      this.bachList = this.batch.filter(function (item) {
        return item["brand"] === _this5.selectedBrand && item['product'] == product['.key'];
      });
    },
    openDamageDialog: function openDamageDialog(product) {
      this.productToDamage = product;
      this.damageDialog = true;
    },
    duplicateCheck: function duplicateCheck() {
      var _this6 = this;

      var duplicateCheck = this.productList.filter(function (item) {
        return item["brand"] === _this6.selectedBrand && item['name'] == _this6.currentProduct.name;
      });
      if (duplicateCheck.length) {
        this.duplicateError = 'Product with name ' + this.currentProduct.name + ' Already exist.';
        setTimeout(function () {
          _this6.duplicateError = null;
        }, 3000);
      }
    },
    saveProduct: function saveProduct(saveAndAdd) {
      var _this7 = this;

      this.addProductDialog = false;
      this.snackbar = true;
      if (saveAndAdd) {
        setTimeout(function () {
          _this7.addProduct();
        }, 1500);
      } else {
        this.stepperValue = 1;
      }
    },
    keymonitor: function keymonitor(event) {
      this.search = event.target.value;
    },
    addProduct: function addProduct() {
      this.stepperValue = 1;
      this.currentProduct = {
        firm: null,
        name: "",
        description: "",
        HSN_code: 0,
        GST_type: "",
        taxableGST_rate: 0,
        barcode: "",
        productType: null,
        productGroup: null,
        productCategory: null,
        unit: "",
        quantity: 0,
        batchNumber: "",
        openingDate: new Date().toISOString().substr(0, 10),
        brand: "",
        basicPrice: 0,
        gstValue: 0,
        purchasingPrice: null,
        sellingPrice: null,
        openingBalance: null,
        purchasingPricePerProduct: null,
        isActive: true,
        unitsDetails: [{
          unit: '',
          isLast: true,
          isFirst: true,
          order: 1,
          quantity: 0
        }],
        sellingPriceByCategories: {}
      };
      this.addProductDialog = true;
    },
    updateProduct: function updateProduct() {
      this.addProductDialog = false;
      this.snackbar = true;
      this.stepperValue = 1;
    },
    editProduct: function editProduct(product) {
      this.stepperValue = 1;
      this.currentProduct = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(product));
      this.currentProduct.openingDate = this.currentProduct.openingDate ? new Date(this.currentProduct.openingDate).toISOString().substr(0, 10) : new Date().toISOString().substr(0, 10);
      this.currentProduct.quantity = this.currentProduct.openingQuantity;
      this.currentProduct.openingBalance = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(this.currentProduct.openingBalance);
      this.addProductDialog = true;
      if (!this.currentProduct.sellingPriceByCategories) {
        this.currentProduct.sellingPriceByCategories = {};
      }
      if (!this.currentProduct.unitsDeatilsAdded) {
        this.currentProduct.unitsDetails = [{
          unit: '',
          isLast: true,
          isFirst: true,
          order: 1,
          quantity: 0
        }];
      }
    },
    deleteFromDialog: function deleteFromDialog() {
      this[this.currentPasswordMethod](this.currentPasswordReference);
    },
    deleteProduct: function deleteProduct(product) {
      var firmSettings = this.firmSettings.find(function (i) {
        return i['firm'] == product.firm;
      });
      var hasPassword = firmSettings && firmSettings.deleteWithPassword && !!firmSettings.deleteInvoicePassword;
      if (hasPassword && this.password != firmSettings.deleteInvoicePassword && this.passwordDialog) {
        alert("Incorrect Password");
        this.passwordDialog = false;
        this.password = null;
      } else if (hasPassword && !this.passwordDialog) {
        this.passwordDialog = true;
        this.password = null;
        this.currentPasswordReference = product;
        this.currentPasswordMethod = "deleteProduct";
      } else if (window.confirm("Do you want to Delete ?")) {
        this.passwordDialog = false;
        this.password = null;
        this.$root.$firebaseRefs.products.child(product[".key"]).remove();
        this.stepperValue = 1;
      }
    }
  }
});

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_barcodePrint__ = __webpack_require__(241);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    currentProduct: Object,
    stepperValue: Number
  },
  data: function data() {
    return {
      defaultFirm: null,
      compositionSuggestions: [],
      suggestionAdded: false,
      stepValue: 1,
      isOpeningBalance: false,
      isStanderedPrice: false,
      addProductDialog: false,
      sellingPriceInc: 0,
      purchasingPriceInc: 0,
      addIncPrice: false,
      datepicker: false,
      duplicateError: null,
      productList: [],
      currentProd: null,
      GST_types: [{
        text: "Exempt",
        value: "EXEMPT"
      }, {
        text: "Nil Rated",
        value: "NILL"
      }, {
        text: "Taxable",
        value: "TAXABLE"
      }, {
        text: "Non-GST",
        value: "OTHER"
      }]
    };
  },
  created: function created() {
    this.stepValue = this.stepperValue;
    this.currentProd = this.currentProduct;
    this.$bindAsArray("productList", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('productGroups', this.$root.$firebaseRefs.productGroup.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('productCategories', this.$root.$firebaseRefs.productCategory.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('productTypes', this.$root.$firebaseRefs.productType.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("productRateCategories", this.$root.$firebaseRefs.productRateCategory.orderByChild('brand').equalTo(this.selectedBrand));
    if (this.$route.params.isNew) {
      this.addProduct();
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand"]), mapGlobalGetters({ units: "productUnit" }), {
    firmsByBrand: function firmsByBrand() {
      var _this = this;

      var firmsB = this.firms.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      }).map(function (item) {
        if (item.defaultFirm && !_this.currentProd.firm) {
          _this.currentProd.firm = item[".key"];
          _this.currentProd.businessType = item["businessType"];
        }
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
      return firmsB;
    },
    productListByBrand: function productListByBrand() {
      var _this2 = this;

      var prod = this.productList.filter(function (item) {
        return item["brand"] === _this2.selectedBrand && (
        // (item.openingDate ? (item.openingDate >= this.finYear.start) 
        // && (item.openingDate <= this.finYear.end) : true) 
        !!_this2.search ? !!item["name"].toLowerCase().includes(_this2.search.toLowerCase()) : true);
      });
      if (!this.suggestionAdded) {
        this.compositionSuggestions = [];
      }
      prod.map(function (p) {
        if (!_this2.suggestionAdded) {
          if (p.composition && _this2.compositionSuggestions.indexOf(p.composition) == -1) {
            _this2.compositionSuggestions.push(p.composition);
          }
        }
        if (p.unitsDeatilsAdded) {
          p['openingQuantityTitle'] = _this2.getFilteredQuantity(p, p['openingQuantity']);
          p['purchaseQuantityTitle'] = _this2.getFilteredQuantity(p, p['purchaseQuantity']);
          p['saleQuantityTitle'] = _this2.getFilteredQuantity(p, p['saleQuantity']);
          p['closingQuantityTitle'] = _this2.getFilteredQuantity(p, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(p['openingQuantity']) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(p['purchaseQuantity']) - __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(p['saleQuantity']));
        }
      });
      return prod;
    },
    productGroupListByBrand: function productGroupListByBrand() {
      var _this3 = this;

      return this.productGroups.filter(function (item) {
        return item["brand"] === _this3.selectedBrand;
      }).map(function (item) {
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
    },
    productCategoryListByBrand: function productCategoryListByBrand() {
      var _this4 = this;

      return this.productCategories.filter(function (item) {
        return item["brand"] === _this4.selectedBrand;
      }).map(function (item) {
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
    },
    productTypeListByBrand: function productTypeListByBrand() {
      var _this5 = this;

      return this.productTypes.filter(function (item) {
        return item["brand"] === _this5.selectedBrand;
      }).map(function (item) {
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
    },
    getLastUnit: function getLastUnit() {
      var lastUnit = _.maxBy(this.currentProd.unitsDetails, 'order');
      return lastUnit ? lastUnit.unit : '';
    },
    getLastRate: function getLastRate() {
      var lastUnit = _.maxBy(this.currentProd.unitsDetails, 'order');
      return lastUnit ? lastUnit.rate : '';
    }
  }),
  methods: {
    generateBarcode: function generateBarcode(barcode) {
      if (barcode == null) {
        this.currentProd.barcode = new Date().getTime() + "";
      }
    },
    printBarcode: function printBarcode() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_6__utils_barcodePrint__["a" /* barcodePrintPDF */])({});

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this6);
      }))();
    },
    close: function close() {
      this.$emit("close");
    },
    addComposition: function addComposition(e) {
      this.suggestionAdded = true;
      this.compositionSuggestions.push(e.target.value);
    },
    getBusinessType: function getBusinessType() {
      var _this7 = this;

      var firm = this.firms.filter(function (item) {
        return item[".key"] === _this7.currentProd['firm'];
      })[0];
      this.currentProd.businessType = firm['businessType'];
    },
    getFilteredQuantity: function getFilteredQuantity(product, qty) {
      var quantity = qty;
      var string = "";
      product.unitsDetails.sort(function (a, b) {
        return new Date(b.order) - new Date(a.order);
      });
      for (var i = 0; i < product.unitsDetails.length; i++) {
        if (quantity > __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(product.unitsDetails[i].quantity) && i + 1 < product.unitsDetails.length) {
          var temp = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(quantity) / __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(product.unitsDetails[i].quantity);
          string = "(" + (temp.toString().split(".")[1] ? temp.toString().split(".")[1] : 0) + " " + product.unitsDetails[i].unit + ") " + string;
          quantity = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(temp.toString().split(".")[0]);
        } else {
          string = "(" + quantity + " " + product.unitsDetails[i].unit + ") " + string;
          break;
        }
      }
      // console.log(string)
      return string;
    },
    addUnitData: function addUnitData(data) {
      delete data['isLast'];
      this.currentProd.unitsDetails.push({
        unit: '',
        order: data.order + 1,
        quantity: 0,
        isLast: true
      });
    },
    removeUnitData: function removeUnitData() {
      this.currentProd.unitsDetails.pop();
      this.currentProd.unitsDetails[this.currentProd.unitsDetails.length - 1]['isLast'] = true;
    },
    duplicateCheck: function duplicateCheck() {
      var _this8 = this;

      var duplicateCheck = this.productList.filter(function (item) {
        return item["brand"] === _this8.selectedBrand && item['name'] == _this8.currentProd.name;
      });
      if (duplicateCheck.length) {
        this.duplicateError = 'Product with name ' + this.currentProd.name + ' Already exist.';
        setTimeout(function () {
          _this8.duplicateError = null;
        }, 3000);
      }
    },
    saveProduct: function saveProduct(saveAndAdd) {
      var _this9 = this;

      if (this.currentProd.unitsDeatilsAdded) {
        this.currentProd.unit = this.getLastUnit;
      } else {
        delete this.currentProd['unitsDetails'];
      }
      var duplicateCheck = this.productList.filter(function (item) {
        return item["brand"] === _this9.selectedBrand && item['name'] == _this9.currentProd.name;
      });
      if (duplicateCheck.length) {
        this.duplicateError = 'Product with name ' + this.currentProd.name + ' Already exist.';
        setTimeout(function () {
          _this9.duplicateError = null;
        }, 3000);
      } else {
        this.currentProd["brand"] = this.selectedBrand;
        this.currentProd["HSN_code"] = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.currentProd.HSN_code);
        this.currentProd["taxableGST_rate"] = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.currentProd.taxableGST_rate);
        this.currentProd.purchaseQuantity = 0;
        this.currentProd.saleQuantity = 0;
        this.currentProd.openingQuantity = this.currentProd.quantity;
        this.currentProd.openingDate = new Date(this.currentProd.openingDate).getTime();
        delete this.currentProd['openingQuantityTitle'];
        delete this.currentProd['purchaseQuantityTitle'];
        delete this.currentProd['saleQuantityTitle'];
        delete this.currentProd['closingQuantityTitle'];
        this.$root.$firebaseRefs.products.push(this.currentProd);
        this.$emit("saveProduct", saveAndAdd);
      }
    },
    updateProduct: function updateProduct() {
      if (this.currentProd.unitsDeatilsAdded) {
        this.currentProd.unit = this.getLastUnit;
      } else {
        delete this.currentProd['unitsDetails'];
      }
      var key = this.currentProd[".key"];
      delete this.currentProd[".key"];
      this.currentProd.openingDate = new Date(this.currentProd.openingDate).getTime();
      this.currentProd.openingQuantity = this.currentProd.quantity;
      this.currentProd.quantity = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.currentProd.openingQuantity) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.currentProd.purchaseQuantity) - __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.currentProd.saleQuantity);
      delete this.currentProd['openingQuantityTitle'];
      delete this.currentProd['purchaseQuantityTitle'];
      delete this.currentProd['saleQuantityTitle'];
      delete this.currentProd['closingQuantityTitle'];
      this.$root.$firebaseRefs.products.child(key).set(this.currentProd);
      this.currentProd = {
        name: "",
        description: "",
        HSN_code: 0,
        GST_type: "",
        taxableGST_rate: 0,
        barcode: "",
        quantity: 0,
        unit: "",
        openingDate: new Date().toISOString().substr(0, 10),
        brand: "",
        basicPrice: 0,
        gstValue: 0,
        purchasingPrice: null,
        sellingPrice: null,
        openingBalance: null
      };
      this.$emit("updateProduct");
    },
    calculateOpeningBalance: function calculateOpeningBalance() {
      if (this.currentProd.basicPrice != 0 && this.currentProd.gstValue != 0) {
        this.currentProd.openingBalance = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.currentProd.basicPrice) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.currentProd.gstValue);
      }
    }
  },
  watch: {
    "currentProd.purchasingPrice": {
      handler: function handler(newVal, oldVal) {
        if (!this.addIncPrice) {
          this.purchasingPriceInc = this.currentProd.taxableGST_rate ? (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.currentProd.purchasingPrice * this.currentProd.taxableGST_rate / 100) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.currentProd.purchasingPrice)).toFixed(2) : this.currentProd.purchasingPrice;
        }
      },

      deep: true
    },
    "currentProd.sellingPrice": {
      handler: function handler(newVal, oldVal) {
        if (!this.addIncPrice) {
          this.sellingPriceInc = this.currentProd.taxableGST_rate ? (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.currentProd.sellingPrice * this.currentProd.taxableGST_rate / 100) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.currentProd.sellingPrice)).toFixed(2) : this.currentProd.sellingPrice;
        }
      },

      deep: true
    },
    "sellingPriceInc": {
      handler: function handler(newVal, oldVal) {
        if (this.currentProduct.taxableGST_rate && this.addIncPrice) {
          var amount = this.sellingPriceInc * this.currentProduct.taxableGST_rate / 100;
          this.currentProduct.sellingPrice = this.sellingPriceInc - amount;
        }
      },

      deep: true
    },
    "purchasingPriceInc": {
      handler: function handler(newVal, oldVal) {
        if (this.currentProduct.taxableGST_rate && this.addIncPrice) {
          var amount = this.purchasingPriceInc * this.currentProduct.taxableGST_rate / 100;
          this.currentProduct.purchasingPrice = this.purchasingPriceInc - amount;
        }
      },

      deep: true
    },
    "currentProd.GST_type": {
      handler: function handler(newVal, oldVal) {
        if (newVal != "TAXABLE") {
          this.currentProd.taxableGST_rate = 0;
        }
      },

      deep: true
    },
    "currentProd.barcode": {
      handler: function handler(newVal, oldVal) {
        if (this.currentProd.barcode) {
          JsBarcode("#barcode", this.currentProd.barcode);
        }
      },

      deep: true
    },
    stepperValue: function stepperValue(val) {
      console.log("sdsd");
      this.stepValue = val;
    },

    "currentProduct": {
      handler: function handler(newVal, oldVal) {
        this.currentProd = newVal;
      },

      deep: true
    },
    "currentProd.basicPrice": {
      handler: function handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.calculateOpeningBalance();
        }
      },

      deep: true
    },
    "currentProd.firm": {
      handler: function handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.getBusinessType();
        }
      },

      deep: true
    },
    "currentProd.gstValue": {
      handler: function handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.calculateOpeningBalance();
        }
      },

      deep: true
    }
  }
});

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_digitsToWords_js__ = __webpack_require__(35);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      transferDialog: false,
      currentTransfer: {},
      transferdatepicker: null,
      snackbarSuccessText: null,
      snackbarText: null,
      hintText: null,
      snackbar: false,
      snackbarSuccess: false,
      termsList: [],
      password: null,
      passwordDialog: false,
      currentPasswordReference: null,
      currentPasswordMethod: null,
      transferHeader: [{ text: "Date", value: "Name" }, { text: "From", value: "bankFrom" }, { text: "To", value: "bankTo" }, { text: "Transfer Category", value: "Description" }, { text: "Amount", value: "Description" }, { text: "Edit", value: "edit" }, { text: "Delete", value: "delete" }, { text: "Firm", value: "Name" }]
    };
  },
  created: function created() {
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("banks", this.$root.$firebaseRefs.account.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("transactions", this.$root.$firebaseRefs.transaction.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("firmSettings", this.$root.$firebaseRefs.firmSettings.orderByChild("brand").equalTo(this.selectedBrand));
  },

  watch: {
    "currentTransfer.amount": {
      handler: function handler() {
        this.hintText = this.currentTransfer.amount ? _.startCase(Object(__WEBPACK_IMPORTED_MODULE_4__utils_digitsToWords_js__["a" /* digitsToWords */])(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(this.currentTransfer.amount))) : null;
      },

      deep: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "brandFinYear"]), {
    firmsByBrand: function firmsByBrand() {
      var _this = this;

      return this.firms.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      }).map(function (item) {
        if (item.defaultFirm) {
          _this.currentTransfer.firm = item[".key"];
        }
        return {
          firm: item,
          text: item["name"],
          value: item[".key"]
        };
      });
    },
    banksByFirms: function banksByFirms() {
      var _this2 = this;

      return this.banks.filter(function (item) {
        return item["brand"] === _this2.selectedBrand && item["firm"] == _this2.currentTransfer.firm;
      }).map(function (item) {
        return {
          account: item,
          text: item["accountnumber"],
          value: item[".key"]
        };
      });
    },
    transferListByBrand: function transferListByBrand() {
      var _this3 = this;

      return this.transactions.filter(function (item) {
        return item["brand"] === _this3.selectedBrand;
      });
    }
  }),
  methods: {
    saveTerms: function saveTerms() {
      console.log(this.currentTransfer);
      this.transferAmount(false, false);

      this.transferDialog = false;
    },
    checkForSameAccount: function checkForSameAccount() {
      if (this.currentTransfer.bankFrom != null && this.currentTransfer.bankTo != null) {
        if (this.currentTransfer.bankFrom == this.currentTransfer.bankTo) {
          this.snackbar = true;
          this.snackbarText = "Both Accounts cannot be same";
          return false;
        } else {
          return true;
        }
      }
    },
    transferAmount: function transferAmount(reverse, isDelete) {
      switch (this.currentTransfer.transferCategory) {
        case "B2B":
          {
            this.bankToBank(reverse, isDelete);
            break;
          }
        case "C2B":
          {
            reverse ? this.bankToCash(reverse, isDelete) : this.cashToBank(reverse);
            break;
          }
        case "B2C":
          {
            reverse ? this.cashToBank(reverse, isDelete) : this.bankToCash(reverse);
            break;
          }
      }
    },
    addTerm: function addTerm() {
      this.currentTransfer = {
        firm: null,
        bankFrom: null,
        bankTo: null,
        amount: 0,
        paymentType: "cash",
        date: new Date().toISOString().substr(0, 10),
        transferCategory: "B2B",
        brand: this.selectedBrand,
        remark: ""
      };
      this.transferDialog = true;
    },
    addInvoice: function addInvoice() {
      if (this.currentTransfer[".key"]) {
        this.$root.$firebaseRefs.invoice.child(this.currentTransfer["creditInvoiceId"]).remove();
        this.$root.$firebaseRefs.invoice.child(this.currentTransfer["debitInvoiceId"]).remove();
      }
      var invoiceDataCredit = {
        brand: this.selectedBrand,
        brandFinYear: this.brandFinYear,
        type: "automatic invoice",
        transactionType: "Transfer",
        firm: this.currentTransfer.firm,
        paymentType: "bank",
        isCredited: true,
        totalAmount: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(this.currentTransfer.amount),
        date: new Date(this.currentTransfer.date).getTime(),
        transferCategory: this.currentTransfer.transferCategory
      };
      var invoiceDataDebit = {
        brand: this.selectedBrand,
        brandFinYear: this.brandFinYear,
        type: "automatic invoice",
        transactionType: "Transfer",
        firm: this.currentTransfer.firm,
        paymentType: "bank",
        isCredited: false,
        totalAmount: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(this.currentTransfer.amount),
        date: new Date(this.currentTransfer.date).getTime(),
        transferCategory: this.currentTransfer.transferCategory
      };

      if (this.currentTransfer.transferCategory == "B2B") {
        invoiceDataCredit["transferType"] = this.currentTransfer.bankTransferType;
        invoiceDataCredit["bank"] = this.currentTransfer.bankTo;
        invoiceDataDebit["transferType"] = this.currentTransfer.bankTransferType;
        invoiceDataDebit["bank"] = this.currentTransfer.bankFrom;
        invoiceDataCredit["remark"] = this.currentTransfer.remark;
        invoiceDataDebit["remark"] = this.currentTransfer.remark;
      } else if (this.currentTransfer.transferCategory == "B2C") {
        invoiceDataCredit["depositVia"] = this.currentTransfer.depositVia;
        invoiceDataCredit["remark"] = this.currentTransfer.remark;
        invoiceDataDebit["bank"] = this.currentTransfer.bankFrom;

        invoiceDataDebit["depositVia"] = this.currentTransfer.depositVia;
        invoiceDataDebit["remark"] = this.currentTransfer.remark;
      } else if (this.currentTransfer.transferCategory == "C2B") {
        invoiceDataCredit["depositVia"] = this.currentTransfer.depositVia;
        invoiceDataCredit["remark"] = this.currentTransfer.remark;
        invoiceDataCredit["bank"] = this.currentTransfer.bankTo;

        invoiceDataDebit["depositVia"] = this.currentTransfer.depositVia;
        invoiceDataDebit["remark"] = this.currentTransfer.remark;
      }
      var res1 = this.$root.$firebaseRefs.invoice.push(invoiceDataCredit);
      var res2 = this.$root.$firebaseRefs.invoice.push(invoiceDataDebit);
      this.currentTransfer["creditInvoiceId"] = res1["key"];
      this.currentTransfer["debitInvoiceId"] = res2["key"];
      this.currentTransfer["date"] = new Date(this.currentTransfer.date).getTime();
      if (this.currentTransfer[".key"]) {
        var key = this.currentTransfer[".key"];
        delete this.currentTransfer[".key"];
        this.$root.$firebaseRefs.transaction.child(key).set(this.currentTransfer);
      } else {
        this.$root.$firebaseRefs.transaction.push(this.currentTransfer);
      }
    },
    bankToBank: function bankToBank(reverse, isDelete) {
      var _this4 = this;

      var self = this;
      var result = this.checkForSameAccount();
      var bankFrom = reverse ? this.currentTransfer.bankTo : this.currentTransfer.bankFrom;
      var bankTo = reverse ? this.currentTransfer.bankFrom : this.currentTransfer.bankTo;
      if (result) {
        if (this.currentTransfer.amount == null) {
          this.snackbar = true;
          this.snackbarText = "Amount cannot be empty";
        } else {
          this.$root.$firebaseRefs.account.child(bankFrom).once("value").then(function (snap) {
            if (Number(snap.val().amount) >= Number(self.currentTransfer.amount)) {
              self.$root.$firebaseRefs.account.child(bankFrom).update({
                amount: Number(snap.val().amount) - Number(self.currentTransfer.amount)
              });
              self.$root.$firebaseRefs.account.child(bankTo).once("value").then(function (snap) {
                self.$root.$firebaseRefs.account.child(bankTo).update({
                  amount: Number(snap.val().amount) + Number(self.currentTransfer.amount)
                });
              });
              setTimeout(function () {
                if (!reverse) {
                  self.addInvoice();
                }
                if (isDelete) {
                  self.$root.$firebaseRefs.invoice.child(self.currentTransfer["creditInvoiceId"]).remove();
                  self.$root.$firebaseRefs.invoice.child(self.currentTransfer["debitInvoiceId"]).remove();
                  self.$root.$firebaseRefs.transaction.child(self.currentTransfer[".key"]).remove();
                }
                if (reverse && !isDelete) {
                  _this4.transferAmount(false, false);
                }
              }, 1000);
            } else {
              self.snackbar = true;
              self.snackbarText = "Insufficient Balance";
            }
          });
        }
      } else {
        this.snackbar = true;
        this.snackbarText = "Both Accounts cannot be same";
      }
    },
    bankToCash: function bankToCash(reverse, isDelete) {
      var _this5 = this;

      var self = this;
      if (this.currentTransfer.amount == null) {
        this.snackbar = true;
        this.snackbarText = "Amount cannot be empty";
      } else {
        var bankFrom = reverse ? this.currentTransfer.bankTo : this.currentTransfer.bankFrom;
        this.$root.$firebaseRefs.account.child(bankFrom).once("value").then(function (snap) {
          if (Number(snap.val().amount) >= Number(self.currentTransfer.amount)) {
            self.$root.$firebaseRefs.account.child(bankFrom).update({
              amount: Number(snap.val().amount) - Number(self.currentTransfer.amount)
            });
            self.$root.$firebaseRefs.firm.child(self.currentTransfer.firm).once("value").then(function (snap) {
              self.$root.$firebaseRefs.firm.child(self.currentTransfer.firm).update({
                amount: Number(snap.val().amount) + Number(self.currentTransfer.amount)
              });
            });
            setTimeout(function () {
              if (!reverse) {
                self.addInvoice();
              }
              if (isDelete) {
                self.$root.$firebaseRefs.invoice.child(self.currentTransfer["creditInvoiceId"]).remove();
                self.$root.$firebaseRefs.invoice.child(self.currentTransfer["debitInvoiceId"]).remove();
                self.$root.$firebaseRefs.transaction.child(self.currentTransfer[".key"]).remove();
              }
              if (reverse && !isDelete) {
                _this5.transferAmount(false, false);
              }
            }, 1000);
          } else {
            self.snackbar = true;
            self.snackbarText = "Insufficient Balance";
          }
        });
      }
    },
    cashToBank: function cashToBank(reverse, isDelete) {
      var _this6 = this;

      var self = this;
      if (this.currentTransfer.amount == null) {
        this.snackbar = true;
        this.snackbarText = "Amount cannot be empty";
      } else {
        var bankTo = reverse ? this.currentTransfer.bankFrom : this.currentTransfer.bankTo;
        this.$root.$firebaseRefs.firm.child(this.currentTransfer.firm).once("value").then(function (snap) {
          if (Number(snap.val().amount) >= Number(self.currentTransfer.amount)) {
            self.$root.$firebaseRefs.firm.child(self.currentTransfer.firm).update({
              amount: Number(snap.val().amount) - Number(self.currentTransfer.amount)
            });

            self.$root.$firebaseRefs.account.child(bankTo).once("value").then(function (snap) {
              self.$root.$firebaseRefs.account.child(bankTo).update({
                amount: Number(snap.val().amount) + Number(self.currentTransfer.amount)
              });
            });
            setTimeout(function () {
              if (!reverse) {
                self.addInvoice();
              }
              if (isDelete) {
                self.$root.$firebaseRefs.invoice.child(self.currentTransfer["creditInvoiceId"]).remove();
                self.$root.$firebaseRefs.invoice.child(self.currentTransfer["debitInvoiceId"]).remove();
                self.$root.$firebaseRefs.transaction.child(self.currentTransfer[".key"]).remove();
              }
              if (reverse && !isDelete) {
                _this6.transferAmount(false, false);
              }
            }, 1000);
          } else {
            self.snackbar = true;
            self.snackbarText = "Insufficient Balance";
          }
        });
      }
    },
    getFirmName: function getFirmName(e) {
      var firm = void 0;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter(function (item) {
          return item[".key"] === e;
        })[0];
      }
      if (firm) return firm.name;
    },
    getBankName: function getBankName(e) {
      var bank = this.banks.filter(function (item) {
        return item[".key"] === e;
      })[0];
      if (bank) return bank.bankName + " | " + bank["accountnumber"];
    },
    updateTransfer: function updateTransfer() {
      this.transferAmount(true, false);
      this.transferDialog = false;
    },
    editTransfer: function editTransfer(term) {
      this.currentTransfer = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(term));
      this.currentTransfer["date"] = new Date(this.currentTransfer["date"]).toISOString().substr(0, 10), this.transferDialog = true;
    },
    deleteFromDialog: function deleteFromDialog() {
      this[this.currentPasswordMethod](this.currentPasswordReference);
    },
    deleteTerm: function deleteTerm(term) {
      var firmSettings = term.firm ? this.firmSettings.find(function (i) {
        return i['firm'] == term.firm;
      }) : null;
      var hasPassword = firmSettings && firmSettings.deleteWithPassword && !!firmSettings.deleteInvoicePassword;
      if (hasPassword && this.password != firmSettings.deleteInvoicePassword && this.passwordDialog) {
        alert("Incorrect Password");
        this.passwordDialog = false;
        this.password = null;
      } else if (hasPassword && !this.passwordDialog) {
        this.passwordDialog = true;
        this.password = null;
        this.currentPasswordReference = term;
        this.currentPasswordMethod = "deleteTerm";
      } else if (window.confirm("Do you want to Delete ?")) {
        this.passwordDialog = false;
        this.password = null;
        this.currentTransfer = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(term));
        this.transferAmount(true, true);
      }
    }
  }
});

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _this = this;

    return {
      selectedFirm: null,
      e1: 1,
      steps: 3,
      payMode: null,
      dialog: false,
      paymentType: '',
      selectedBank: null,
      transferType: 0,
      amountFromCash: 0,
      amountFromBank: 0,
      insufficientError: null,
      transferTypeDialog: false,
      datepicker: false,
      selectedDate: new Date().toISOString().substr(0, 10),
      toDate: null,
      fromDate: null,
      datepickerFrom: null,
      datepickerTo: null,
      isPaidVisible: false,
      invoiceOfFirm: [],
      transferDetails: {
        accountNumber: "",
        accountHolderName: "",
        bankName: "",
        IFSCcode: "",
        remark: ""
      },
      payableAmount: 0,
      selectedInvoices: [],
      currentPaymentGSTType: '',
      inputGST: {
        IGST: 0,
        CGST: 0,
        SGST: 0
      },
      outputGST: {
        IGST: 0,
        CGST: 0,
        SGST: 0
      },
      expenseGST: {
        inputGST: {
          IGST: 0,
          CGST: 0,
          SGST: 0
        },
        outputGST: {
          IGST: 0,
          CGST: 0,
          SGST: 0
        }
      },
      assetsGST: {
        inputGST: {
          IGST: 0,
          CGST: 0,
          SGST: 0
        },
        outputGST: {
          IGST: 0,
          CGST: 0,
          SGST: 0
        }
      },
      availableBalance: {
        inputGST: {
          IGST: 0,
          CGST: 0,
          SGST: 0
        },
        outputGST: {
          IGST: 0,
          CGST: 0,
          SGST: 0
        }
      },
      settleBalance: {
        inputGST: {
          IGST: 0,
          CGST: 0,
          SGST: 0
        },
        outputGST: {
          IGST: 0,
          CGST: 0,
          SGST: 0
        }
      },
      settleOutputCGST: [function (v) {
        return v < _this.availableBalance.outputGST.CGST || _this.availableBalance.outputGST.IGST >= _this.availableBalance.inputGST.IGST || "Should be less or Equal to available";
      }],
      settleOutputSGST: [function (v) {
        return v < _this.availableBalance.outputGST.SGST || _this.availableBalance.outputGST.IGST >= _this.availableBalance.inputGST.IGST || "Should be less or Equal to available";
      }],
      expenseHeader: [{ text: "Pay", value: ".key", sortable: false }, { text: "Expense", value: ".key", sortable: false }, { text: "Firm Name", value: "firm", sortable: true }, { text: "Date", value: "expense", sortable: true }, { text: "GST Amount", value: "totalAmount", sortable: false }, { text: "GST Type", value: "totalAmount", sortable: false }, { text: "Opening WDV", value: "openingBalance", sortable: false }, { text: "Amount", value: "totalAmount", sortable: false }, { text: "Closing WDV", sortable: false }, { text: "paymentType", value: ".key", sortable: false }, { text: "remark", value: "type", sortable: true }, { text: "Id", value: ".key", sortable: false }]
    };
  },
  created: function created() {
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brandFinYear').equalTo(this.brandFinYear));
    this.$bindAsArray("banks", this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("expenses", this.$root.$firebaseRefs.expenses.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("assets", this.$root.$firebaseRefs.assets.orderByChild('brand').equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear", "brandFinYear"]), {
    firmsByBrand: function firmsByBrand() {
      var _this2 = this;

      return this.firms.filter(function (item) {
        return item["brand"] === _this2.selectedBrand;
      }).map(function (item) {
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
    },
    expensesINV: function expensesINV() {
      var _this3 = this;

      var toDate = this.toDate ? new Date(this.toDate).getTime() : null;
      var fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
      var expenses = this.expenses.filter(function (expense) {
        return expense.brand === _this3.selectedBrand;
      });
      expenses = expenses.filter(function (expense) {
        return !!expense['.key'];
      });
      var allInvoices = [];
      this.expenseGST = {
        inputGST: {
          IGST: 0,
          CGST: 0,
          SGST: 0
        },
        outputGST: {
          IGST: 0,
          CGST: 0,
          SGST: 0
        }
      };
      expenses.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = 'confirm';
        var invoices = _this3.invoices.filter(function (invoice) {
          return invoice.brand === _this3.selectedBrand && invoice["expenseType"] === ex['.key'] && invoice.date >= _this3.finYear.start && invoice.date <= _this3.finYear.end && invoice['isGSTApplicable'] == true && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true) && invoice["firm"] === _this3.selectedFirm && invoice["ITC_paid"] != true;
        });
        invoices.map(function (inv, invIndex) {
          openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
          totalAmount += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          paymentTypeStatus = inv.paymentTypeStatus;
          invoices[invIndex]['expense'] = ex.expense;
          invoices[invIndex]['gstAmount'] = inv.taxableAmount * inv.taxableGST_rate / 100;
          if (inv['paid'] == true) {
            if (inv.GST_type == 'CGST|SGST') {
              _this3.expenseGST.inputGST['SGST'] += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(invoices[invIndex]['gstAmount']) / 2;
              _this3.expenseGST.inputGST['CGST'] += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(invoices[invIndex]['gstAmount']) / 2;
            } else {
              _this3.expenseGST.inputGST['IGST'] += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(invoices[invIndex]['gstAmount']);
            }
          } else {
            if (inv.GST_type == 'CGST|SGST') {
              _this3.expenseGST.outputGST['SGST'] += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(invoices[invIndex]['gstAmount']) / 2;
              _this3.expenseGST.outputGST['CGST'] += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(invoices[invIndex]['gstAmount']) / 2;
            } else {
              _this3.expenseGST.outputGST['IGST'] += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(invoices[invIndex]['gstAmount']);
            }
          }
        });
        invoices = invoices.filter(function (inv, invIndex) {
          if (!_this3.isPaidVisible) {
            return inv['paid'] != true && inv['isRCMApplicable'] == true;
          } else {
            return inv['paid'] == true && inv['isRCMApplicable'] == true;
          }
        });
        expenses[index].paymentTypeStatus = paymentTypeStatus;
        expenses[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        expenses[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        allInvoices = allInvoices.concat(invoices);
      });
      //this.setData();
      this.assetsINV();
      return allInvoices;
    },
    banksByFirms: function banksByFirms() {
      var _this4 = this;

      return this.banks.filter(function (item) {
        return item["brand"] === _this4.selectedBrand && item["firm"] === _this4.selectedFirm;
      });
    }
  }),
  methods: {
    assetsINV: function assetsINV() {
      var _this5 = this;

      var toDate = this.toDate ? new Date(this.toDate).getTime() : null;
      var fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
      var assets = this.assets.filter(function (asset) {
        return asset.brand === _this5.selectedBrand;
      });
      assets = assets.filter(function (asset) {
        return !!asset['.key'];
      });
      this.assetsGST = {
        inputGST: {
          IGST: 0,
          CGST: 0,
          SGST: 0
        },
        outputGST: {
          IGST: 0,
          CGST: 0,
          SGST: 0
        }
      };
      var allIVN = [];
      //console.log(assets)
      assets.map(function (ast, index) {
        var invoices = _this5.invoices.filter(function (invoice) {
          return invoice.brand === _this5.selectedBrand && invoice["assetType"] === ast['.key'] && invoice.date >= _this5.finYear.start && invoice.date <= _this5.finYear.end && invoice['isGSTApplicable'] == true && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true) && invoice["firm"] === _this5.selectedFirm && invoice["ITC_paid"] != true;
        });
        invoices.map(function (inv, invIndex) {
          var gstAmount = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv.taxableAmount) * __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv.taxableGST_rate) / 100;
          if (inv.GST_type == 'CGST|SGST') {
            _this5.assetsGST.inputGST['SGST'] += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(gstAmount) / 2;
            _this5.assetsGST.inputGST['CGST'] += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(gstAmount) / 2;
          } else {
            _this5.assetsGST.inputGST['IGST'] += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(gstAmount);
          }
        });
        allIVN = allIVN.concat(invoices);
      });
      this.setData();
      return allIVN;
    },
    getFirmName: function getFirmName(e) {
      var firm = void 0;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter(function (item) {
          return item['.key'] === e;
        })[0];
      }
      if (firm) return firm.name;
    },
    payExpense: function payExpense(expenseInv) {
      if (confirm('Are you sure you want pay?')) {
        var key = expenseInv['.key'];
        delete expenseInv['.key'];
        expenseInv['paid'] = true;
        this.$root.$firebaseRefs.invoice.child(key).update(expenseInv, function () {
          console.info('item udpated...');
        });
      } else {
        event.preventDefault();
      }
    },
    isOpDisabled: function isOpDisabled() {
      if (this.availableBalance.outputGST.IGST > this.availableBalance.inputGST.IGST) {
        this.settleBalance.outputGST.CGST = 0;
        this.settleBalance.outputGST.SGST = 0;
        return true;
      }
      return false;
    },
    payITC: function payITC() {
      var _this6 = this;

      if (this.payMode == 'ITC') {
        var itcObject = {};
        itcObject['date'] = new Date(this.selectedDate).getTime();
        itcObject['firm'] = this.selectedFirm;
        itcObject['paidAmount'] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.amountFromCash) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.amountFromBank);
        itcObject['gstType'] = this.currentPaymentGSTType;
        itcObject['paymentType'] = this.paymentType;
        if (['Bank Account', 'CashAndBank Account'].includes(this.paymentType)) {
          itcObject['bank'] = this.selectedBank['.key'];
          itcObject['transferType'] = this.transferType;
          itcObject['transferDetails'] = this.transferDetails;
        }
        itcObject['amountFromCash'] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.amountFromCash);
        itcObject['amountFromBank'] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.amountFromBank);
        itcObject['payMode'] = this.payMode;
        this.$root.$firebaseRefs.itcPayment.push(itcObject);

        this.selectedInvoice.map(function (invoiceData) {
          _this6.updateInvoice(invoiceData);
        });
        var expenses = this.expensesINV;
        expenses.map(function (invoice) {
          invoice['ITC_paid'] = true;
          var key = invoice['.key'];
          delete invoice['.key'];
          _this6.$root.$firebaseRefs.invoice.child(key).update(invoice, function () {
            console.info('invoice updated...');
          });
        });

        var assets = this.assetsINV;
        assets.map(function (invoice) {
          invoice['ITC_paid'] = true;
          var key = invoice['.key'];
          delete invoice['.key'];
          _this6.$root.$firebaseRefs.invoice.child(key).update(invoice, function () {
            console.info('invoice updated...');
          });
        });
        this.managePayments();
        // this.selectedInvoices = [];
        // this.selectedFirm = null;
        // this.amountFromCash = 0;
        // this.amountFromBank = 0;
        // this.paymentType = null;
        // this.selectedDate = null;
        // this.transferType = null;
        // this.transferDetails =  {
        //   accountNumber:"",
        //   accountHolderName: "",
        //   bankName: "",
        //   IFSCcode: "",
        //   remark: ""
        // };
        // this.selectedBank = null;
        window.location.reload();
      } else if (this.payMode == 'RCM') {
        var _itcObject = {};
        _itcObject['date'] = new Date(this.selectedDate).getTime();
        _itcObject['firm'] = this.selectedFirm;
        _itcObject['paidAmount'] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.amountFromCash) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.amountFromBank);
        _itcObject['gstType'] = this.currentPaymentGSTType;
        _itcObject['paymentType'] = this.paymentType;
        if (['Bank Account', 'CashAndBank Account'].includes(this.paymentType)) {
          _itcObject['bank'] = this.selectedBank['.key'];
          _itcObject['transferType'] = this.transferType;
          _itcObject['transferDetails'] = this.transferDetails;
        }
        _itcObject['amountFromCash'] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.amountFromCash);
        _itcObject['amountFromBank'] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.amountFromBank);
        _itcObject['payMode'] = this.payMode;
        this.$root.$firebaseRefs.itcPayment.push(_itcObject);
        this.payExpense(this.currentExpense);
        this.managePayments();
        window.location.reload();
      }
      this.dialog = false;
    },
    managePayments: function managePayments() {
      var _this7 = this;

      switch (this.paymentType) {
        case 'Cash':
          {
            if (this.amountFromCash) {
              var firm = this.firms.filter(function (item) {
                return item['.key'] == _this7.selectedFirm;
              })[0];
              if (firm) {
                firm.amount = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(firm.amount) - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.amountFromCash);
                if (firm.amount < 0) {
                  this.insufficientError = 'Insufficient balance.';
                  setTimeout(function () {
                    _this7.insufficientError = null;
                  }, 3000);
                } else {
                  var key = firm['.key'];
                  delete firm['.key'];
                  this.$root.$firebaseRefs.firm.child(key).set(firm);
                  this.getInvoice();
                  this.setData();
                }
              }
            }
            break;
          }
        case 'Bank Account':
          {
            if (this.amountFromBank) {
              var bank = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedBank));
              if (bank) {
                bank.amount = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(bank.amount) - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.amountFromBank);
                if (bank.amount < 0) {
                  this.insufficientError = 'Insufficient balance.';
                  setTimeout(function () {
                    _this7.insufficientError = null;
                  }, 3000);
                } else {
                  var _key = bank['.key'];
                  delete bank['.key'];
                  this.$root.$firebaseRefs.account.child(_key).set(bank);
                  this.getInvoice();
                  this.setData();
                }
              }
            }
            break;
          }
        case 'CashAndBank Account':
          {
            if (this.amountFromCash && this.amountFromBank) {
              var _bank = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedBank));
              if (_bank) {
                _bank.amount = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_bank.amount) - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.amountFromBank);
                if (_bank.amount < 0) {
                  this.insufficientError = 'Insufficient balance.';
                  setTimeout(function () {
                    _this7.insufficientError = null;
                  }, 3000);
                } else {
                  var _key2 = _bank['.key'];
                  delete _bank['.key'];
                  this.$root.$firebaseRefs.account.child(_key2).set(_bank);
                }
              }
              var _firm = this.firms.filter(function (item) {
                return item['.key'] == _this7.selectedFirm;
              })[0];
              if (_firm) {
                _firm.amount = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_firm.amount) - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.amountFromCash);
                if (_firm.amount < 0) {
                  this.insufficientError = 'Insufficient balance.';
                  setTimeout(function () {
                    _this7.insufficientError = null;
                  }, 3000);
                } else {
                  var _key3 = _firm['.key'];
                  delete _firm['.key'];
                  this.$root.$firebaseRefs.firm.child(_key3).set(_firm);
                }
              }
            }
            this.getInvoice();
            this.setData();
            break;
          }
      }
    },
    updateInvoice: function updateInvoice(invoiceData) {
      var _this8 = this;

      var updated_at = new Date().getTime();
      try {
        invoiceData['items'].forEach(function (item, index) {
          switch (_this8.currentPaymentGSTType) {
            case 'IGST':
              {
                invoiceData['items'][index]['IGST_ITC_paid'] = true;
                break;
              }
            case 'CGST':
              {
                invoiceData['items'][index]['CGST_ITC_paid'] = true;
                break;
              }
            case 'SGST':
              {
                invoiceData['items'][index]['SGST_ITC_paid'] = true;
                break;
              }
          }
        });
        invoiceData['updated_at'] = updated_at;
        var key = invoiceData['.key'];
        delete invoiceData['.key'];
        this.$root.$firebaseRefs.invoice.child(key).update(invoiceData, function () {
          console.info('invoice updated...');
        });
      } catch (e) {
        console.info('Error at update Invoice', e);
      }
    },
    openPaymentDialog: function openPaymentDialog(type) {
      this.dialog = true;
      this.currentPaymentGSTType = type;
      this.payMode = 'ITC';
      switch (type) {
        case 'IGST':
          {
            this.payableAmount = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.availableBalance.outputGST.IGST) > __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.availableBalance.inputGST.IGST) ? (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.availableBalance.outputGST.IGST) - (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.availableBalance.inputGST.IGST) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.settleBalance.outputGST.CGST) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.settleBalance.outputGST.SGST))).toFixed(2) : 0;
            break;
          }
        case 'CGST':
          {
            this.payableAmount = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.availableBalance.inputGST.CGST) < __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.availableBalance.outputGST.CGST) - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.settleBalance.outputGST.CGST) ? (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.availableBalance.outputGST.CGST) - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.settleBalance.outputGST.CGST) - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.availableBalance.inputGST.CGST)).toFixed(2) : 0;
            break;
          }
        case 'SGST':
          {
            this.payableAmount = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.availableBalance.inputGST.SGST) < __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.availableBalance.outputGST.SGST) - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.settleBalance.outputGST.SGST) ? (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.availableBalance.outputGST.SGST) - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.settleBalance.outputGST.SGST) - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.availableBalance.inputGST.SGST)).toFixed(2) : 0;
            break;
          }
      }
    },
    openExpensePaymentDialog: function openExpensePaymentDialog(expenseInv) {
      this.dialog = true;
      this.payMode = 'RCM';
      this.currentPaymentGSTType = expenseInv.GST_type;
      this.payableAmount = expenseInv.gstAmount;
      this.currentExpense = expenseInv;
    },
    nextStep: function nextStep(n) {
      if (n === this.steps) {
        this.e1 = 1;
      } else {
        this.e1 = n + 1;
      }
    },
    getInvoice: function getInvoice() {
      var _this9 = this;

      this.invoiceOfFirm = this.invoices.filter(function (item) {
        return item["brand"] === _this9.selectedBrand && item["firm"] === _this9.selectedFirm && item.date >= _this9.finYear.start && item.date <= _this9.finYear.end && item.deleted != true && item['items'] && item['items'].length;
      });
      this.setData();
    },
    resetGSTVals: function resetGSTVals() {
      this.inputGST = {
        IGST: 0,
        CGST: 0,
        SGST: 0
      };
      this.outputGST = {
        IGST: 0,
        CGST: 0,
        SGST: 0
      };
      this.availableBalance = {
        inputGST: {
          IGST: 0,
          CGST: 0,
          SGST: 0
        },
        outputGST: {
          IGST: 0,
          CGST: 0,
          SGST: 0
        }
      }, this.settleBalance = {
        inputGST: {
          IGST: 0,
          CGST: 0,
          SGST: 0
        },
        outputGST: {
          IGST: 0,
          CGST: 0,
          SGST: 0
        }
      };
    },
    setData: function setData() {
      var _this10 = this;

      // if(!this.invoiceOfFirm.length && this.selectedFirm) {
      //   this.getInvoice();
      // }
      this.selectedInvoice = [];
      var toDate = this.toDate ? new Date(this.toDate).getTime() : null;
      var fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
      this.resetGSTVals();
      this.invoiceOfFirm.map(function (invoice) {
        if (!invoice.return && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true)) {
          _this10.selectedInvoice.push(invoice);
          if (invoice.isBuyer) {
            invoice.items.map(function (item) {
              _this10.outputGST.SGST += item.SGST_val && !item.SGST_ITC_paid ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.SGST_val) : 0;
              _this10.outputGST.CGST += item.CGST_val && !item.CGST_ITC_paid ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.CGST_val) : 0;
              _this10.outputGST.IGST += item.IGST_val && !item.IGST_ITC_paid ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.IGST_val) : 0;
            });
          } else {
            invoice.items.map(function (item) {
              _this10.inputGST.SGST += item.SGST_val && !item.SGST_ITC_paid ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.SGST_val) : 0;
              _this10.inputGST.CGST += item.CGST_val && !item.CGST_ITC_paid ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.CGST_val) : 0;
              _this10.inputGST.IGST += item.IGST_val && !item.IGST_ITC_paid ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.IGST_val) : 0;
            });
          }
        }
      });

      this.inputGST.SGST += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.expenseGST.inputGST.SGST);
      this.inputGST.CGST += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.expenseGST.inputGST.CGST);
      this.inputGST.IGST += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.expenseGST.inputGST.IGST);

      this.inputGST.SGST += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.assetsGST.inputGST.SGST);
      this.inputGST.CGST += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.assetsGST.inputGST.CGST);
      this.inputGST.IGST += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.assetsGST.inputGST.IGST);

      this.outputGST.SGST += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.expenseGST.outputGST.SGST);
      this.outputGST.CGST += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.expenseGST.outputGST.CGST);
      this.outputGST.IGST += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.expenseGST.outputGST.IGST);

      // this.$set(this.inputGST, 'SGST', this.inputGST.SGST.toFixed(2));
      // this.$set(this.inputGST, 'CGST', this.inputGST.CGST.toFixed(2));
      // this.$set(this.inputGST, 'IGST', this.inputGST.IGST.toFixed(2));

      // this.$set(this.outputGST, 'SGST', this.outputGST.SGST.toFixed(2));
      // this.$set(this.outputGST, 'CGST', this.outputGST.CGST.toFixed(2));
      // this.$set(this.outputGST, 'IGST', this.outputGST.IGST.toFixed(2));

      // this.$set(this.availableBalance, 'inputGST', this.inputGST);
      // this.$set(this.availableBalance, 'outputGST', this.outputGST);

      this.inputGST.SGST = this.inputGST.SGST.toFixed(2);
      this.inputGST.CGST = this.inputGST.CGST.toFixed(2);
      this.inputGST.IGST = this.inputGST.IGST.toFixed(2);

      this.outputGST.SGST = this.outputGST.SGST.toFixed(2);
      this.outputGST.CGST = this.outputGST.CGST.toFixed(2);
      this.outputGST.IGST = this.outputGST.IGST.toFixed(2);

      this.availableBalance.inputGST = this.inputGST;
      this.availableBalance.outputGST = this.outputGST;
    },
    reset: function reset() {
      this.settleBalance.outputGST.CGST = 0;
      this.settleBalance.outputGST.SGST = 0;
      this.e1 = 1;
    }
  },
  watch: {
    selectedFirm: function selectedFirm(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.getInvoice();
        this.setData();
      }
    },
    toDate: function toDate(newVal, oldVal) {
      if (oldVal !== newVal && this.selectedFirm) {
        this.getInvoice();
        this.setData();
      }
    },
    fromDate: function fromDate(newVal, oldVal) {
      if (oldVal !== newVal && this.selectedFirm) {
        this.getInvoice();
        this.setData();
      }
    }
  }
});

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      viewTransaction: false,
      viewGodawn: false,
      currentGodawn: null,
      currentGodawanTransaction: [],
      currentGodawanProductTransaction: [],
      currentGodawnProducts: [],
      currentProductName: '',
      godawanTransactionHeaders: [{ text: "Date", value: "date", sortable: true, class: "primary--text font-weight-bold" }, { text: "Quantity", value: "quantity", sortable: true, class: "primary--text font-weight-bold" }, { text: "Product", value: "name", sortable: true, class: "primary--text font-weight-bold" }, { text: "Type", value: "type", sortable: true, class: "primary--text font-weight-bold" }]
    };
  },
  created: function created() {
    this.$bindAsObject("productDetail", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("godawns", this.$root.$firebaseRefs.godawn.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("godawnTrans", this.$root.$firebaseRefs.godawnTransaction.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear", "brandFinYear"]), {
    godawnByBrand: function godawnByBrand() {
      var _this = this;

      return this.godawns.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      });
    }
  }),
  methods: {
    openGodawnTransactions: function openGodawnTransactions(godawn) {
      var _this2 = this;

      this.currentGodawn = godawn;
      this.currentGodawanTransaction = this.godawnTrans.filter(function (item) {
        return item['brand'] == _this2.selectedBrand && item['godawn'] == godawn['.key'];
      });
      this.currentGodawanTransaction.map(function (item, index) {
        _this2.currentGodawanTransaction[index]['productName'] = _this2.productDetail[item.product].name;
        _this2.currentGodawanTransaction[index]['type'] = 'Transfer';
        _this2.currentGodawanTransaction[index]['totalQuantity'] = 0;
      });

      // let invoices = this.invoices.filter(item => (item['brand'] == this.selectedBrand && item['godawnBy'] == godawn['.key'] && (item.date >= this.finYear.start) && (item.date <= this.finYear.end)));
      var invoices = this.invoices.filter(function (item) {
        return item['brand'] == _this2.selectedBrand && item.date >= _this2.finYear.start && item.deleted != true && item.date <= _this2.finYear.end;
      });
      invoices.map(function (invoice, index) {
        invoice.items && invoice.items.map(function (item) {
          //  let obj = {}
          //  obj['.key'] = invoice['.key'];
          //  obj['date'] = invoice['date'];
          //  obj['quantity'] = item['quantity'];
          //  obj['productName'] = item['productName'];
          //  obj['totalQuantity'] = 0;
          //  obj['type'] = invoice.isBuyer ? 'Sale' : 'Purchase' ;
          //  this.currentGodawanTransaction.push(obj);

          if (item['godawnBy'] == godawn['.key']) {
            var obj = {};
            obj['.key'] = invoice['.key'];
            obj['date'] = invoice['date'];
            obj['quantity'] = item['quantity'];
            obj['productName'] = item['productName'];
            obj['totalQuantity'] = 0;
            obj['type'] = invoice.isBuyer ? 'Sale' : 'Purchase';
            _this2.currentGodawanTransaction.push(obj);
          }
        });
      });

      var finalResult = [];

      this.currentGodawanTransaction.map(function (item) {
        var index = _.findIndex(finalResult, { productName: item.productName });
        if (index > -1) {
          finalResult[index].totalQuantity += item.type == 'Sale' ? -item['quantity'] : item['quantity'];
        } else {
          item.totalQuantity = item.quantity;
          finalResult.push(item);
        }
      });
      this.currentGodawnProducts = finalResult;
      this.viewGodawn = true;
    },
    openGodawnProductList: function openGodawnProductList(product) {
      this.currentProductName = product.productName;
      this.viewTransaction = true;
      this.currentGodawanProductTransaction = _.filter(this.currentGodawanTransaction, function (p) {
        return p.productName == product.productName;
      });
    },
    renderDate: function renderDate(timeStamp) {
      if (timeStamp) {
        return new Date(timeStamp).toLocaleDateString("en-GB");
      }
      return "--";
    }
  }
});

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      viewReports: false,
      currentGodawn: null,
      reportProducts: [],
      productListHeader: [{ text: "Invoices", value: "action" }, { text: "Name, Description, HSN, GST type, Rate, Unit", value: "Name" }, { text: "Quantity", value: "quantity" }, { text: "Duration quantity", value: "quantity" }, { text: "Amount", value: "quantity" }, { text: "Opening Quantity", value: "quantity" }, { text: "Sale Quantity", value: "quantity" }, { text: "Duration Sale quantity", value: "quantity" }, { text: "Sale Amount", value: "quantity" }, { text: "Purchase Quantity", value: "quantity" }, {
        text: "Duration Purchase quantity",
        value: "quantity"
      }, { text: "Purchase Amount", value: "quantity" }]
    };
  },
  created: function created() {
    this.$bindAsObject("productDetail", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("godawns", this.$root.$firebaseRefs.godawn.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("godawnTrans", this.$root.$firebaseRefs.godawnTransaction.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear", "brandFinYear"]), {
    godawnByBrand: function godawnByBrand() {
      var _this = this;

      return this.godawns.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      });
    }
  }),
  methods: {
    openGodawnReports: function openGodawnReports(godawn) {
      var _this2 = this;

      this.currentGodawn = godawn;
      this.reportProducts = [];
      this.currentGodawanTransaction = this.godawnTrans.filter(function (item) {
        return item['brand'] == _this2.selectedBrand && item['godawn'] == godawn['.key'];
      });
      this.currentGodawanTransaction.map(function (item, index) {
        var productIndex = _this2.reportProducts.findIndex(function (item1) {
          return item1['.key'] == item.product;
        });
        var temp = _this2.productDetail[item.product];
        if (productIndex > -1) {
          _this2.reportProducts[productIndex]['reportDetails'].transfer += item.quantity;
          var amount = item.quantity * __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(temp.sellingPrice);
          _this2.reportProducts[productIndex]['reportDetails'].transferAmount += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(amount);
        } else {
          temp['reportDetails'] = {
            opening: item.quantity,
            openingAmount: item.quantity * __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(temp.sellingPrice),
            purchase: 0,
            purchaseAmount: 0,
            sale: 0,
            saleAmount: 0,
            transfer: 0,
            transferAmount: 0
          };
          temp['.key'] = item.product;
          _this2.reportProducts.push(temp);
        }
      });

      var invoices = this.invoices.filter(function (item) {
        return item['brand'] == _this2.selectedBrand && item.date >= _this2.finYear.start && item.deleted != true && item.date <= _this2.finYear.end;
      });
      invoices.map(function (invoice, index) {
        invoice.items && invoice.items.map(function (item) {
          if (item['godawnBy'] == godawn['.key']) {
            var productIndex = _this2.reportProducts.findIndex(function (item1) {
              return item1['.key'] == item.productId;
            });
            var temp = _this2.productDetail[item.productId];
            if (productIndex > -1) {
              if (invoice.isBuyer) {
                _this2.reportProducts[productIndex]['reportDetails'].sale += item.quantity;
                var amount = item.quantity * __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(temp.sellingPrice);
                _this2.reportProducts[productIndex]['reportDetails'].saleAmount += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(amount);
              } else {
                _this2.reportProducts[productIndex]['reportDetails'].purchase += item.quantity;
                var _amount = item.quantity * __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(temp.purchasingPrice);
                _this2.reportProducts[productIndex]['reportDetails'].purchaseAmount += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(_amount);
              }
            } else {
              temp['reportDetails'] = {
                opening: 0,
                openingAmount: 0,
                purchase: !invoice.isBuyer ? item.quantity : 0,
                purchaseAmount: !invoice.isBuyer ? item.quantity * __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(temp.purchasingPrice) : 0,
                sale: invoice.isBuyer ? item.quantity : 0,
                saleAmount: invoice.isBuyer ? item.quantity * __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(temp.sellingPrice) : 0,
                transfer: 0,
                transferAmount: 0
              };
              temp['.key'] = item.product;
              _this2.reportProducts.push(temp);
            }
          }
        });
      });

      // let finalResult = [];

      //  this.currentGodawanTransaction.map((item)=>{
      //    let index =  _.findIndex(finalResult,{productName : item.productName})
      //    if(index > -1) {
      //      finalResult[index].totalQuantity += (item.type == 'Sale' ? (-item['quantity']) : (item['quantity']))
      //    } else {
      //      item.totalQuantity = item.quantity;
      //      finalResult.push(item)
      //    }
      //  })
      //  this.currentGodawnProducts = finalResult;
      this.viewReports = true;
    }
  }
});

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      viewTransaction: false,
      viewBranch: false,
      currentBranch: null,
      currentBranchTransaction: [],
      currentBranchProductTransaction: [],
      currentBranchProducts: [],
      currentProductName: '',
      branchTransactionHeaders: [{ text: "Date", value: "date", sortable: true, class: "primary--text font-weight-bold" }, { text: "Quantity", value: "quantity", sortable: true, class: "primary--text font-weight-bold" }, { text: "Product", value: "name", sortable: true, class: "primary--text font-weight-bold" }, { text: "Type", value: "type", sortable: true, class: "primary--text font-weight-bold" }]
    };
  },
  created: function created() {
    this.$bindAsObject("productDetail", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("branchs", this.$root.$firebaseRefs.branch.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("branchTrans", this.$root.$firebaseRefs.branchTransaction.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brandFinYear').equalTo(this.brandFinYear));
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear", "brandFinYear"]), {
    branchByBrand: function branchByBrand() {
      var _this = this;

      return this.branchs.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      });
    }
  }),
  methods: {
    openBranchTransactions: function openBranchTransactions(branch) {
      var _this2 = this;

      this.currentBranch = branch;
      this.currentBranchTransaction = this.branchTrans.filter(function (item) {
        return item['brand'] == _this2.selectedBrand && item['branch'] == branch['.key'];
      });
      this.currentBranchTransaction.map(function (item, index) {
        _this2.currentBranchTransaction[index]['productName'] = _this2.productDetail[item.product].name;
        _this2.currentBranchTransaction[index]['type'] = 'Transfer';
        _this2.currentBranchTransaction[index]['totalQuantity'] = 0;
      });

      // let invoices = this.invoices.filter(item => (item['brand'] == this.selectedBrand && item['branchBy'] == branch['.key'] && (item.date >= this.finYear.start) && (item.date <= this.finYear.end)));
      var invoices = this.invoices.filter(function (item) {
        return item['brand'] == _this2.selectedBrand && item.date >= _this2.finYear.start && item.deleted != true && item.date <= _this2.finYear.end;
      });
      invoices.map(function (invoice, index) {
        invoice.items && invoice.items.map(function (item) {
          //  let obj = {}
          //  obj['.key'] = invoice['.key'];
          //  obj['date'] = invoice['date'];
          //  obj['quantity'] = item['quantity'];
          //  obj['productName'] = item['productName'];
          //  obj['totalQuantity'] = 0;
          //  obj['type'] = invoice.isBuyer ? 'Sale' : 'Purchase' ;
          //  this.currentBranchTransaction.push(obj);

          if (item['branchBy'] == branch['.key']) {
            var obj = {};
            obj['.key'] = invoice['.key'];
            obj['date'] = invoice['date'];
            obj['quantity'] = item['quantity'];
            obj['productName'] = item['productName'];
            obj['totalQuantity'] = 0;
            obj['type'] = invoice.isBuyer ? 'Sale' : 'Purchase';
            _this2.currentBranchTransaction.push(obj);
          }
        });
      });

      var finalResult = [];

      this.currentBranchTransaction.map(function (item) {
        var index = _.findIndex(finalResult, { productName: item.productName });
        if (index > -1) {
          finalResult[index].totalQuantity += item.type == 'Sale' ? -item['quantity'] : item['quantity'];
        } else {
          item.totalQuantity = item.quantity;
          finalResult.push(item);
        }
      });
      this.currentBranchProducts = finalResult;
      this.viewBranch = true;
    },
    openBranchProductList: function openBranchProductList(product) {
      this.currentProductName = product.productName;
      this.viewTransaction = true;
      this.currentBranchProductTransaction = _.filter(this.currentBranchTransaction, function (p) {
        return p.productName == product.productName;
      });
    },
    renderDate: function renderDate(timeStamp) {
      if (timeStamp) {
        return new Date(timeStamp).toLocaleDateString("en-GB");
      }
      return "--";
    }
  }
});

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_estimatePdf__ = __webpack_require__(1419);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* createNamespacedHelpers */])("Buyer")["mapGetters"];

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      productsToEstimate: [],
      items: [],
      isEdit: false,
      estimateDialog: false,
      isBuyer: true,
      invoiceEstimate: false,
      selectedEstimate: null,
      selectedBuyer: null,
      selectedFirm: null,
      date: new Date().toISOString().substr(0, 10),
      datepickerEstimate: false,
      statusFilter: 'ALL',
      remark: null,
      estimateHeader: [{ text: "View", value: "quantity" }, { text: "Estimate Date", value: "quantity" }, { text: "Invoice Date", value: "quantity" },
      // { text: "Estimate Number", value: "deposit - ID" },
      { text: "Customer Name", value: "name" }, { text: "Total Amount", value: "name" },
      // { text: "Remaining Estimate", value: "name" }, 
      // { text: "Estimate - ID", value: "deposit - ID" },
      { text: "Remark", value: "remark" }, { text: "Status", value: "edit" }, { text: "Cancel", value: "edit" }, { text: "Edit", value: "edit" }, { text: "Delete", value: "edit" }, { text: "Print", value: "edit" }],
      productInvoiceHeader: [{ text: "Name", value: "Name" }, { text: "Description", value: "Taxable" }, { text: "Quantity", value: "Taxable" }, { text: "Unit", value: "HSN" }, { text: "Rate", value: "rate" }, { text: "Total", value: "total" }]
    };
  },
  created: function created() {
    this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray("buyers", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray("sellers", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray('firms', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray("estimates", this.$root.$firebaseRefs.estimates.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsObject('buyerById', this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsObject('sellerById', this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject('productById', this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("termsAndConditions", this.$root.$firebaseRefs.termsAndConditions.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("bankById", this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", 'finYear']), mapGlobalGetters({ units: "productUnit" }), {
    productListByBrand: function productListByBrand() {
      var _this = this;

      var prod = this.products.filter(function (item) {
        return item["brand"] === _this.selectedBrand && (_this.selectedFirm ? item["firm"] === _this.selectedFirm : false);
        // && (item.openingDate ? (item.openingDate >= this.finYear.start) && (item.openingDate <= this.finYear.end) : true))
      });
      return prod;
    },
    estimatesByBrand: function estimatesByBrand() {
      var _this2 = this;

      return this.estimates.filter(function (item) {
        return item["brand"] === _this2.selectedBrand && (item.date ? item.date >= _this2.finYear.start && item.date <= _this2.finYear.end : true) && (_this2.statusFilter != 'ALL' ? item.status == _this2.statusFilter : true);
      });
    },
    buyersByBrand: function buyersByBrand() {
      var _this3 = this;

      return this.buyers.filter(function (item) {
        return item["brand"] === _this3.selectedBrand;
      });
    },
    sellersByBrand: function sellersByBrand() {
      var _this4 = this;

      return this.sellers.filter(function (item) {
        return item["brand"] === _this4.selectedBrand;
      });
    },
    firmsByBrand: function firmsByBrand() {
      var _this5 = this;

      return this.firms.filter(function (item) {
        return item["brand"] === _this5.selectedBrand;
      }).map(function (item) {
        if (item.defaultFirm) {
          _this5.selectedFirm = item[".key"];
        }
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
    }
  }),
  methods: {
    openProd: function openProd(item) {
      this.selectedEstimate = item;
      this.invoiceEstimate = true;
    },
    getTotal: function getTotal(item) {
      var total = 0;
      item.items.map(function (i) {
        total += __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(i.rate) * __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(i.quantity));
      });
      return total;
    },
    getFirmName: function getFirmName(e) {
      var firm = void 0;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter(function (item) {
          return item['.key'] === e;
        })[0];
      }
      if (firm) return firm.name;
    },
    printEstimate: function printEstimate(invoiceData, isGST) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var firm, customer, termsAndConditions, gstTotal;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                firm = _this6.firms.filter(function (item) {
                  return item['.key'] === invoiceData['firm'];
                })[0];
                customer = invoiceData.isBuyer ? _this6.buyerById[invoiceData.buyerId] : _this6.sellerById[invoiceData.buyerId];

                firm.address = _this6.getAddress(firm);
                customer.address = _this6.getAddress(customer);
                termsAndConditions = _this6.getTermsAndConditions(invoiceData);
                gstTotal = _this6.calculateGSTInvoice(customer, invoiceData, firm);

                if (!isGST) {
                  _context.next = 11;
                  break;
                }

                _context.next = 9;
                return Object(__WEBPACK_IMPORTED_MODULE_5__utils_estimatePdf__["a" /* convertToEstimate */])({
                  invoiceData: invoiceData,
                  firm: firm,
                  customer: customer,
                  terms: termsAndConditions[0],
                  gstTotal: gstTotal
                }).then(function (doc) {
                  pdfMake.createPdf(doc).download();
                });

              case 9:
                _context.next = 13;
                break;

              case 11:
                _context.next = 13;
                return Object(__WEBPACK_IMPORTED_MODULE_5__utils_estimatePdf__["b" /* convertToEstimateWithoutGST */])({
                  invoiceData: invoiceData,
                  firm: firm,
                  customer: customer,
                  terms: termsAndConditions[0],
                  gstTotal: gstTotal
                }).then(function (doc) {
                  pdfMake.createPdf(doc).download();
                });

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this6);
      }))();
    },
    getTermsAndConditions: function getTermsAndConditions(invoiceData) {
      var _this7 = this;

      var termsAndConditions = this.termsAndConditions.filter(function (item) {
        return item["brand"] === _this7.selectedBrand && item["firm"] === invoiceData.firm;
      });
      if (termsAndConditions.length) {
        if (termsAndConditions[0].bank) {
          var banks = [];
          termsAndConditions[0].bank.map(function (bankId) {
            var bank = _this7.bankById[bankId];
            bank.address = _this7.getAddress(bank);
            banks.push(bank);
          });
          termsAndConditions[0].banks = banks;
        } else {
          termsAndConditions[0].banks = [];
        }
      } else {
        termsAndConditions = [{
          termsAndConditions: "",
          banks: []
        }];
      }
      return termsAndConditions;
    },
    getAddress: function getAddress(item) {
      if (!item) {
        return "";
      }
      var address = (item.village ? item.village + " - " : "") + (item.block ? item.block + " - " : "") + (item.tehsil ? item.tehsil + " - " : "") + (item.district ? item.district + " - " : "") + (item.state ? item.state + " - " : "") + (item.country ? item.country + " - " : "");
      address = address.substring(0, address.length - 2);
      return address;
    },
    calculateGSTInvoice: function calculateGSTInvoice(currentUser, invoice, firm) {
      var _this8 = this;

      var SGST_val = 0;
      var CGST_val = 0;
      var IGST_val = 0;
      invoice.items && invoice.items.map(function (item, index) {
        var prod = _this8.products.filter(function (p) {
          return p['.key'] === item['productId'];
        })[0];
        item["taxableGST_rate"] = prod['taxableGST_rate'];
        item.HSN_code = prod["HSN_code"];
        item.basicPrice = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item.rate * item.quantity).toFixed(2);
        item.GSTValue = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item.basicPrice * (parseFloat(item.taxableGST_rate) / 100)).toFixed(2);
        item.totlePrice = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item.GSTValue)).toFixed(2);
        var GST = item["taxableGST_rate"];
        if (!currentUser.state || firm && currentUser.state && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(GST) && firm.state === currentUser.state) {
          item["CGST_val"] = item["GSTValue"] / 2;
          item["CGST"] = GST / 2;
          item["SGST_val"] = item["GSTValue"] / 2;
          item["SGST"] = GST / 2;
          item["IGST"] = 0;
          item["IGST_val"] = 0;
        } else {
          item["IGST"] = GST;
          item["CGST"] = 0;
          item["SGST"] = 0;
          item["IGST_val"] = item["GSTValue"];
          item["CGST_val"] = 0;
          item["SGST_val"] = 0;
        }
        SGST_val += parseFloat(item["SGST_val"]);
        CGST_val += parseFloat(item["CGST_val"]);
        IGST_val += parseFloat(item["IGST_val"]);
      });
      return { SGST_val: SGST_val, CGST_val: CGST_val, IGST_val: IGST_val };
    },
    getCustomerName: function getCustomerName(id) {
      var buyer = this.buyerById[id];
      var seller = this.sellerById[id];
      if (!buyer && !seller) {
        return 'DELETED CUSTOMER';
      }
      return buyer ? buyer.name : seller.name;
    },
    addToBucket: function addToBucket() {
      var _this9 = this;

      var tempIts = this.items;
      this.items = [];
      var buyer = this.isBuyer ? this.buyers.find(function (i) {
        return i['.key'] == _this9.selectedBuyer;
      }) : null;

      this.productsToEstimate.map(function (prod) {
        var selectedProd = tempIts.filter(function (item) {
          return item['productId'] == prod['.key'];
        })[0];
        var temp = {
          productName: prod.name,
          subDescription: prod.subDescription,
          productId: prod['.key'],
          quantity: selectedProd && selectedProd.quantity ? selectedProd.quantity : 1,
          unit: selectedProd && selectedProd.unit ? selectedProd.unit : prod.unit,
          rate: selectedProd && selectedProd.rate ? selectedProd.rate : _this9.isBuyer ? prod["sellingPrice"] || 0 : prod["purchasingPrice"] || 0
        };
        if (buyer && buyer.category && prod.sellingPriceByCategories && prod.sellingPriceByCategories[buyer.category]) {
          temp['rate'] = prod.sellingPriceByCategories[buyer.category];
        }
        _this9.items.push(temp);
      });
    },

    addCustomer: function addCustomer(e) {
      var obj = {
        name: e.target.value,
        brand: this.selectedBrand
      };
      if (this.selectedFirm) {
        obj['state'] = this.selectedFirm;
      }

      if (this.isBuyer) {
        this.$root.$firebaseRefs.buyer.push(obj);
      } else {
        this.$root.$firebaseRefs.seller.push(obj);
      }
    },
    createInvoice: function createInvoice() {
      var _this10 = this;

      var key = this.selectedEstimate['.key'];
      delete this.selectedEstimate['.key'];
      this.$root.$firebaseRefs.estimates.child(key).set(this.selectedEstimate).then(function (snap) {
        _this10.selectedEstimate = null;
        _this10.$router.push({ path: "/estimate-to-invoice/" + key });
        _this10.invoiceEstimate = false;
      });
    },
    cancelEstimate: function cancelEstimate(estimate) {
      var key = estimate['.key'];
      delete estimate['.key'];
      estimate['status'] = 'CANCELLED';
      this.$root.$firebaseRefs.estimates.child(key).set(estimate).then(function (snap) {});
    },
    editEstimate: function editEstimate(estimate) {
      var _this11 = this;

      this.productsToEstimate = [];
      this.estimateDialog = true;
      this.isEdit = true;
      this.items = estimate.items;
      this.firm = estimate.firm;
      this.date = new Date(estimate.date).toISOString().substr(0, 10), this.selectedEstimate = estimate;
      this.isBuyer = estimate.isBuyer;
      this.remark = portfolio.remark;
      if (estimate.isBuyer) {
        this.selectedBuyer = this.buyerById[estimate.buyerId];
      } else {
        this.selectedBuyer = this.sellerById[estimate.buyerId];
      }
      this.items.map(function (item) {
        _this11.productsToEstimate.push(_this11.productById[item.productId]);
        // this.productsToEstimate.push(obj)   
      });
    },
    addEstimate: function addEstimate() {
      var _this12 = this;

      var estimateObj = {
        buyerId: this.selectedBuyer['.key'],
        isBuyer: this.isBuyer,
        remark: this.remark,
        firm: this.selectedFirm,
        brand: this.selectedBrand,
        date: new Date(this.date).getTime(),
        items: this.items
        //   status: 'IN PROGRESS'
        // }
        // this.$root.$firebaseRefs.estimates.push(estimateObj);
      };if (this.isEdit) {
        estimateObj['status'] = this.selectedEstimate['status'];
        estimateObj['buyerId'] = this.selectedEstimate['buyerId'];
        this.$root.$firebaseRefs.estimates.child(this.selectedEstimate['.key']).set(estimateObj).then(function (snap) {
          _this12.isEdit = false;
        });
      } else {
        estimateObj['status'] = 'IN PROGRESS';
        this.$root.$firebaseRefs.estimates.push(estimateObj);
      }
      this.estimateDialog = false;
      this.selectedBuyer = null;
      this.remark = null;
      this.isBuyer = true;
      this.items = [];
      this.productsToEstimate = [];
    },
    deleteEstimate: function deleteEstimate(estimate) {
      if (window.confirm("Do you want to Delete ?")) {
        this.$root.$firebaseRefs.estimates.child(estimate[".key"]).remove();
      }
    }
  }
});

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Buyer")["mapGetters"];
// import { convertToLead, convertToLeadWithoutGST } from "../../utils/leadPdf";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      productsToLead: [],
      items: [],
      isEdit: false,
      leadDialog: false,
      isBuyer: true,
      invoiceLead: false,
      multiFirm: false,
      historyStep: 1,
      selectedLead: null,
      selectedBuyer: null,
      selectedFirm: null,
      leadTime: null,
      soldBy: null,
      availableProductUnit: {},
      date: new Date().toISOString().substr(0, 10),
      datepickerLead: false,
      leadsSetting: null,
      statusFilter: "ALL",
      leadNumber: null,
      leadHistory: false,
      modalMode: null,
      floorName: null,
      tableName: null,
      isCallAdded: false,
      tableList: [],
      leadType: null,
      currentLeadType: ['Social Media', 'Website', 'Magazine', 'News Paper', 'Reference', 'Normal'],
      selectedCustomer: null,
      leadHeader: [{ text: "Action", value: "edit" }, { text: "View", value: "view" }, { text: "Lead Number", value: "leadNumber" }, { text: "Lead Date", value: "date", sortable: true },
      // { text: "Lead Time", value: "time", sortable: true },
      { text: "Customer Name", value: "name" },
      // { text: "Invoice Date", value: "date", sortable: true },
      { text: "Total Amount", value: "name" }, { text: "Lead Type", value: "leadType" }, { text: "Status", value: "status" }]
    };
  },
  created: function created() {
    this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("buyers", this.$root.$firebaseRefs.buyer.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("sellers", this.$root.$firebaseRefs.seller.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("leads", this.$root.$firebaseRefs.leads.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsObject("buyerById", this.$root.$firebaseRefs.buyer.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsObject("sellerById", this.$root.$firebaseRefs.seller.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsObject("productById", this.$root.$firebaseRefs.products.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("termsAndConditions", this.$root.$firebaseRefs.termsAndConditions.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsObject("bankById", this.$root.$firebaseRefs.account.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("firmInfrastructure", this.$root.$firebaseRefs.firmInfrastructure.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("leadSettings", this.$root.$firebaseRefs.leadSetting.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("staffs", this.$root.$firebaseRefs.staff.orderByChild("brand").equalTo(this.selectedBrand)), this.getCurrentSettings();
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear"]), mapGlobalGetters({ units: "productUnit" }), {
    productListByBrand: function productListByBrand() {
      var _this = this;

      var prod = this.products.filter(function (item) {
        return item["brand"] === _this.selectedBrand && (!_this.multiFirm ? _this.selectedFirm ? item["firm"] === _this.selectedFirm : false : true);
      });
      prod.map(function (p, index) {
        var productsWithSimilarCompostion = _this.products.filter(function (item) {
          return item[".key"] == p[".key"] || item["brand"] === _this.selectedBrand && (!!item["composition"] ? _.isEqual(item["composition"], p["composition"]) : false);
        });
        prod[index]["similar"] = productsWithSimilarCompostion;
      });
      return prod;
    },
    staffByBrand: function staffByBrand() {
      var _this2 = this;

      return this.staffs.filter(function (item) {
        return item["brand"] === _this2.selectedBrand && (!_this2.multiFirm ? _this2.selectedFirm ? item["firm"] === _this2.selectedFirm : false : true) && item["staffRole"] === "Salesman";
      }).map(function (item) {
        return {
          text: item["staffName"],
          value: item[".key"]
        };
      });
    },
    leadsByBrand: function leadsByBrand() {
      var _this3 = this;

      return this.leads.filter(function (item) {
        return item["brand"] === _this3.selectedBrand && (_this3.selectedCustomer ? item.buyerId == _this3.selectedCustomer : true) && (_this3.statusFilter != "ALL" ? item.status == _this3.statusFilter : true) && !item.isPortfolio;
      });
    },
    getLeadedCustomers: function getLeadedCustomers() {
      return this.buyersByBrand.map(function (b) {
        return {
          text: b.name,
          value: b[".key"]
        };
      });
    },
    buyersByBrand: function buyersByBrand() {
      var _this4 = this;

      return this.buyers.filter(function (item) {
        return item["brand"] === _this4.selectedBrand;
      });
    },
    sellersByBrand: function sellersByBrand() {
      var _this5 = this;

      return this.sellers.filter(function (item) {
        return item["brand"] === _this5.selectedBrand;
      });
    },
    firmsByBrand: function firmsByBrand() {
      var _this6 = this;

      return this.firms.filter(function (item) {
        return item["brand"] === _this6.selectedBrand;
      }).map(function (item) {
        if (item.defaultFirm) {
          _this6.selectedFirm = item[".key"];
        }
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
    },
    isRestaurantBusiness: function isRestaurantBusiness() {
      var _this7 = this;

      if (this.selectedFirm) {
        var firm = this.firms.find(function (item) {
          return item[".key"] == _this7.selectedFirm;
        });
        if (firm.businessType == "Restaurant") {
          return true;
        }
      }
      return false;
    },
    floorList: function floorList() {
      var _this8 = this;

      if (this.selectedFirm) {
        var firmInfrastructure = this.firmInfrastructure.find(function (item) {
          return item["firm"] == _this8.selectedFirm;
        });
        return firmInfrastructure.floorDetails;
      }
      return [];
    },
    productInvoiceHeader: function productInvoiceHeader() {
      var productInvoiceHeader = [{ text: "Name", value: "Name" }, { text: "Quantity", value: "Taxable" }, { text: "Unit", value: "HSN" }, { text: "Rate", value: "rate" }, { text: "Total", value: "total" }];
      if (this.isRestaurantBusiness) {
        productInvoiceHeader = [{ text: "Call", value: "call" }].concat(productInvoiceHeader);
      }
      return productInvoiceHeader;
    }
  }),
  watch: {
    floorName: {
      handler: function handler(newVal, oldVal) {
        this.getTableList();
      },

      deep: true
    },
    leadSettings: {
      handler: function handler(newVal, oldVal) {
        this.getCurrentSettings();
      },

      deep: true
    }
  },
  methods: {
    getCurrentSettings: function getCurrentSettings() {
      var _this9 = this;

      this.leadsSetting = this.leadSettings.find(function (i) {
        return i.brand == _this9.selectedBrand;
      });
    },

    // async printLead(invoiceData, isGST) {
    //   let firm = this.firms.filter(
    //     (item) => item[".key"] === invoiceData["firm"]
    //   )[0];
    //   let customer = invoiceData.isBuyer
    //     ? this.buyerById[invoiceData.buyerId]
    //     : this.sellerById[invoiceData.buyerId];
    //   firm.address = this.getAddress(firm);
    //   customer.address = this.getAddress(customer);
    //   let termsAndConditions = this.getTermsAndConditions(invoiceData);
    //   let gstTotal = this.calculateGSTInvoice(customer, invoiceData, firm);
    //   if (isGST) {
    //     await convertToLead({
    //       invoiceData: invoiceData,
    //       firm: firm,
    //       customer: customer,
    //       terms: termsAndConditions[0],
    //       gstTotal: gstTotal,
    //     }).then((doc) => {
    //       pdfMake.createPdf(doc).download();
    //     });
    //   } else {
    //     await convertToLeadWithoutGST({
    //       invoiceData: invoiceData,
    //       firm: firm,
    //       customer: customer,
    //       terms: termsAndConditions[0],
    //       gstTotal: gstTotal,
    //     }).then((doc) => {
    //       pdfMake.createPdf(doc).download();
    //     });
    //   }
    // },
    // getTermsAndConditions(invoiceData) {
    //   let termsAndConditions = this.termsAndConditions.filter(
    //     (item) =>
    //       item["brand"] === this.selectedBrand &&
    //       item["firm"] === invoiceData.firm
    //   );
    //   if (termsAndConditions.length) {
    //     if (termsAndConditions[0].bank) {
    //       let banks = [];
    //       termsAndConditions[0].bank.map((bankId) => {
    //         let bank = this.bankById[bankId];
    //         bank.address = this.getAddress(bank);
    //         banks.push(bank);
    //       });
    //       termsAndConditions[0].banks = banks;
    //     } else {
    //       termsAndConditions[0].banks = [];
    //     }
    //   } else {
    //     termsAndConditions = [
    //       {
    //         termsAndConditions: "",
    //         banks: [],
    //       },
    //     ];
    //   }
    //   return termsAndConditions;
    // },
    // getAddress(item) {
    //   if (!item) {
    //     return "";
    //   }
    //   let address =
    //     (item.village ? item.village + " - " : "") +
    //     (item.block ? item.block + " - " : "") +
    //     (item.tehsil ? item.tehsil + " - " : "") +
    //     (item.district ? item.district + " - " : "") +
    //     (item.state ? item.state + " - " : "") +
    //     (item.country ? item.country + " - " : "");
    //   address = address.substring(0, address.length - 2);
    //   return address;
    // },
    calculateGSTInvoice: function calculateGSTInvoice(currentUser, invoice, firm) {
      var _this10 = this;

      var SGST_val = 0;
      var CGST_val = 0;
      var IGST_val = 0;
      invoice.items && invoice.items.map(function (item, index) {
        var prod = _this10.products.filter(function (p) {
          return p[".key"] === item["productId"];
        })[0];
        item["taxableGST_rate"] = prod["taxableGST_rate"];
        item.HSN_code = prod["HSN_code"];
        item.basicPrice = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.rate * item.quantity).toFixed(2);
        item.GSTValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.basicPrice * (parseFloat(item.taxableGST_rate) / 100)).toFixed(2);
        item.totlePrice = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.GSTValue)).toFixed(2);
        var GST = item["taxableGST_rate"];
        if (!currentUser.state || firm && currentUser.state && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(GST) && firm.state === currentUser.state) {
          item["CGST_val"] = item["GSTValue"] / 2;
          item["CGST"] = GST / 2;
          item["SGST_val"] = item["GSTValue"] / 2;
          item["SGST"] = GST / 2;
          item["IGST"] = 0;
          item["IGST_val"] = 0;
        } else {
          item["IGST"] = GST;
          item["CGST"] = 0;
          item["SGST"] = 0;
          item["IGST_val"] = item["GSTValue"];
          item["CGST_val"] = 0;
          item["SGST_val"] = 0;
        }
        SGST_val += parseFloat(item["SGST_val"]);
        CGST_val += parseFloat(item["CGST_val"]);
        IGST_val += parseFloat(item["IGST_val"]);
      });
      return { SGST_val: SGST_val, CGST_val: CGST_val, IGST_val: IGST_val };
    },
    addLeadDialog: function addLeadDialog() {
      var _this11 = this;

      this.leadDialog = true;
      this.productsToLead = [];
      this.items = [{
        productName: null,
        productId: null,
        quantity: 1,
        unit: null,
        rate: 0
      }];
      this.isEdit = false;
      this.invoiceLead = false;
      this.selectedBuyer = null;
      this.accountType = null;
      // this.selectedFirm = null;
      var leads = this.leads.filter(function (i) {
        return i["brand"] === _this11.selectedBrand && i.status == "PENDING";
      });
      this.leadNumber = leads.length + 1;
      this.selectedLead = null;
    },
    openHistory: function openHistory(item) {
      this.selectedLead = item;
      this.leadHistory = true;
      this.historyStep = 1;
      this.modalMode = "history";
    },
    openOrignal: function openOrignal(item) {
      this.selectedLead = item;
      this.leadHistory = true;
      this.historyStep = 1;
      this.modalMode = "orignal";
    },
    openProd: function openProd(item) {
      this.selectedLead = item;
      this.invoiceLead = true;
    },
    getTotal: function getTotal(item) {
      var total = 0;
      item.items.map(function (i) {
        total += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(i.rate) * __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(i.quantity));
      });
      return total;
    },
    getFirmName: function getFirmName(e) {
      var firm = void 0;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter(function (item) {
          return item[".key"] === e;
        })[0];
      }
      if (firm) return firm.name;
    },
    getCustomerName: function getCustomerName(id) {
      var buyer = this.buyerById[id];
      var seller = this.sellerById[id];
      if (!buyer && !seller) {
        return "DELETED CUSTOMER";
      }
      return buyer ? buyer.name : seller.name;
    },
    isShopUserExists: function isShopUserExists(id) {
      var buyers = this.buyers.filter(function (item) {
        return item.shopUserId == id;
      });
      if (!buyers.length) {
        return false;
      }
      return true;
    },
    getShopUserName: function getShopUserName(id) {
      var buyers = this.buyers.filter(function (item) {
        return item.shopUserId == id;
      });
      if (!buyers.length) {
        return "DELETED CUSTOMER";
      }
      return buyers[0].name;
    },
    addToBucket: function addToBucket() {
      var _this12 = this;

      var tempIts = this.items;
      this.items = [];
      this.productsToLead.map(function (prod, index) {
        if (typeof prod == "string") {
          _this12.productsToLead.splice(index, 1);
        }
      });
      this.productsToLead.map(function (prod, index) {
        var selectedProd = tempIts.filter(function (item) {
          return item["productId"] == prod[".key"];
        })[0];
        var itemToAdd = {
          productName: prod.name,
          similar: prod.similar,
          productId: prod[".key"],
          quantity: selectedProd && selectedProd.quantity ? selectedProd.quantity : 1,
          unit: selectedProd && selectedProd.unit ? selectedProd.unit : prod.unit,
          rate: selectedProd && selectedProd.rate ? selectedProd.rate : _this12.isBuyer ? prod["sellingPrice"] || 0 : prod["purchasingPrice"] || 0
        };
        if (_this12.multiFirm) {
          itemToAdd["firm"] = prod.firm;
        }
        _this12.items.push(itemToAdd);
      });
    },
    restructureProductList: function restructureProductList(indexMain) {
      var _this13 = this;

      this.items.map(function (item, index) {
        if (indexMain ? index == indexMain : true) {
          var prod = _this13.products.filter(function (item1) {
            return item1["name"] == item.productName && item1["brand"] === _this13.selectedBrand;
          })[0];

          _this13.items[index]["productName"] = prod.name;
          _this13.items[index]["productId"] = prod[".key"];
          _this13.items[index]["quantity"] = 1;
          _this13.items[index]["unit"] = prod.unit;
          _this13.items[index]["rate"] = _this13.isBuyer ? prod["sellingPrice"] || 0 : prod["purchasingPrice"] || 0;
          if (prod.unitsDeatilsAdded) {
            _this13.availableProductUnit[prod[".key"]] = {
              units: prod.unitsDetails.map(function (prod) {
                return prod.unit;
              })
            };
          } else {
            _this13.availableProductUnit[prod[".key"]] = {
              units: _this13.units
            };
          }
          if (_this13.multiFirm) {
            _this13.items[index]["firm"] = prod.firm;
          }
          if (_this13.isRestaurantBusiness) {
            var call = 0;
            if (_this13.items.length > 1) {
              call = Math.max.apply(Math, _this13.items.map(function (o) {
                return o.call || 0;
              }));
            }
            if (!_this13.isCallAdded) {
              call++;
              _this13.isCallAdded = !_this13.isCallAdded;
            }
            _this13.items[index]["call"] = call;
          }
        }
      });
    },
    getTableList: function getTableList() {
      var _this14 = this;

      this.tableList = this.floorList.find(function (item) {
        return item.name == _this14.floorName;
      }).tables;
    },
    addProd: function addProd() {
      var itemToAdd = {
        productName: null,
        productId: null,
        quantity: 1,
        unit: null,
        rate: 0
      };
      this.items.push(itemToAdd);
    },
    removeProd: function removeProd(index) {
      this.items.splice(index, 1);
    },
    getCurrentFirmState: function getCurrentFirmState() {
      var _this15 = this;

      var firm = this.firms.filter(function (item) {
        return item[".key"] == _this15.selectedFirm;
      })[0];
      return firm["state"];
    },

    addCustomer: function addCustomer(e) {
      var obj = {
        name: e.target.value,
        brand: this.selectedBrand,
        state: this.getCurrentFirmState()
      };
      if (this.isBuyer) {
        this.$root.$firebaseRefs.buyer.push(obj);
      } else {
        this.$root.$firebaseRefs.seller.push(obj);
      }
    },
    addShopUser: function addShopUser(lead) {
      if (confirm("Are you sure you want to create buyer?")) {
        var obj = {
          name: lead.shopLeadUserName,
          shopUserId: lead.shopLeadUserId,
          brand: this.selectedBrand,
          state: this.getCurrentFirmState()
        };
        this.$root.$firebaseRefs.buyer.push(obj);
      }
    },
    createInvoice: function createInvoice() {
      var _this16 = this;

      var key = this.selectedLead[".key"];
      delete this.selectedLead[".key"];

      if (!this.selectedLead.buyerId && this.selectedLead.shopLeadUserId) {
        var buyer = this.buyers.filter(function (item) {
          return item.shopUserId == _this16.selectedLead.shopLeadUserId;
        })[0];
        if (buyer) {
          this.selectedLead["buyerId"] = buyer[".key"];
        } else {
          return;
        }
      }

      this.$root.$firebaseRefs.leads.child(key).set(this.selectedLead).then(function (snap) {
        _this16.selectedLead = null;
        _this16.$router.push({ path: "/lead-to-invoice/" + key });
        _this16.invoiceLead = false;
      });
    },
    cancelLead: function cancelLead(lead) {
      var key = lead[".key"];
      delete lead[".key"];
      lead["status"] = "CANCELLED";
      this.$root.$firebaseRefs.leads.child(key).set(lead).then(function (snap) {});
    },
    editLead: function editLead(lead) {
      var _this17 = this;

      if (lead.multiFirm) {
        this.multiFirm = true;
      }
      if (lead.leadTime) {
        this.leadTime = lead.leadTime;
      }
      if (lead.soldBy) {
        this.soldBy = lead.soldBy;
      }
      this.productsToLead = [];
      this.items = lead.items;
      this.selectedFirm = lead.firm;
      this.date = new Date(lead.date).toISOString().substr(0, 10), this.leadNumber = lead.leadNumber, this.leadType = lead.leadType, this.selectedLead = lead;
      this.isBuyer = lead.isBuyer;
      if (lead.isBuyer) {
        this.selectedBuyer = this.buyerById[lead.buyerId];
      } else {
        this.selectedBuyer = this.sellerById[lead.buyerId];
      }
      if (this.isRestaurantBusiness) {
        this["floorName"] = lead.floorName;
        this["tableName"] = lead.tableName;
      }
      this.items.map(function (item, index) {
        var prod = _this17.products.filter(function (item1) {
          return item1["name"] == item.productName && item1["brand"] === _this17.selectedBrand;
        })[0];

        if (prod.unitsDeatilsAdded) {
          _this17.availableProductUnit[prod[".key"]] = {
            units: prod.unitsDetails.map(function (prod) {
              return prod.unit;
            })
          };
        } else {
          _this17.availableProductUnit[prod[".key"]] = {
            units: _this17.units
          };
        }
      });
      this.leadDialog = true;
      this.isEdit = true;

      // this.items.map((item1,index)=>{
      //   let productsWithSimilarCompostion = this.products.filter((item) => {
      //   return (item['.key'] == item1['productId'] || (item['brand'] === this.selectedBrand && (!!item['composition'] ?
      //     _.isEqual(item['composition'],item1['composition']) : false)
      //     ))
      //   });
      //   this.items[index]['similar'] = productsWithSimilarCompostion;
      //   // this.productsToLead.push(this.productById[item1.productId])
      //   let obj = this.productById[item1.productId];
      //   obj['.key'] = item1.productId;
      //   let sim = this.products.filter((item) => {
      //   return (item['.key'] ==obj['.key'] || (item['brand'] === this.selectedBrand && (!!item['composition'] ?
      //     _.isEqual(item['composition'],obj['composition']) : false)
      //     ))
      //   });
      //   obj['similar'] = sim;
      //   this.productsToLead.push(obj)
      // })
    },
    unitChange: function unitChange(item) {
      var _this18 = this;

      var prod = this.products.find(function (i) {
        return i['.key'] == item['productId'];
      });
      if (prod.unitsDeatilsAdded) {
        prod.unitsDetails.map(function (prod) {
          if (prod['unit'] == item.unit) {
            var rate = _this18.isBuyer ? prod["sellingPrice"] : prod["purchasingPrice"];
            if (rate) {
              item.rate = rate;
            }
          }
        });
      }
    },
    addLead: function addLead() {
      var _this19 = this;

      this.items.map(function (i, index) {
        if (!i.productName) {
          _this19.items.splice(index, 1);
        }
      });
      var leadObj = {
        buyerId: this.selectedBuyer[".key"],
        isBuyer: this.isBuyer,
        firm: this.selectedFirm,
        brand: this.selectedBrand,
        date: new Date(this.date).getTime(),
        leadNumber: this.leadNumber,
        leadType: this.leadType,
        items: this.items
      };
      //   status: 'PENDING'
      // }
      // this.$root.$firebaseRefs.Leads.push(LeadObj);
      if (this.multiFirm) {
        leadObj["multiFirm"] = true;
      }
      if (this.isRestaurantBusiness) {
        leadObj["floorName"] = this.floorName;
        leadObj["tableName"] = this.tableName;
      }
      if (this.leadsSetting && this.leadsSetting.isLeadTime) {
        leadObj['leadTime'] = this.leadTime;
      }
      if (this.leadsSetting && this.leadsSetting.isStaffSelection) {
        leadObj['soldBy'] = this.soldBy;
      }
      if (this.isEdit) {
        leadObj["status"] = this.selectedLead["status"];
        leadObj["buyerId"] = this.selectedLead["buyerId"];
        this.$root.$firebaseRefs.leads.child(this.selectedLead[".key"]).set(leadObj).then(function (snap) {
          _this19.isEdit = false;
        });
      } else {
        leadObj["status"] = "PENDING";
        this.$root.$firebaseRefs.leads.push(leadObj);
      }
      this.isCallAdded = false;
      this.leadDialog = false;
      this.selectedBuyer = null;
      this.isBuyer = true;
      this.items = [];
      this.productsToLead = [];
    },
    deleteLead: function deleteLead(lead) {
      if (window.confirm("Do you want to Delete ?")) {
        this.$root.$firebaseRefs.leads.child(lead[".key"]).remove();
      }
    }
  }
});

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_orderPdf__ = __webpack_require__(1428);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* createNamespacedHelpers */])("Buyer")["mapGetters"];

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      productsToOrder: [],
      items: [],
      isEdit: false,
      orderDialog: false,
      tableDialog: false,
      currentInfra: null,
      isBuyer: true,
      invoiceOrder: false,
      multiFirm: false,
      historyStep: 1,
      selectedOrder: null,
      selectedBuyer: null,
      selectedFirm: null,
      orderTime: null,
      soldBy: null,
      availableProductUnit: {},
      datepickerFrom: null,
      datepickerTo: null,
      dateTo: null,
      dateFrom: null,
      date: new Date().toISOString().substr(0, 10),
      time: new Date().getTime(),
      datepickerOrder: false,
      ordersSetting: null,
      statusFilter: "ALL",
      orderTypeFilter: "All",
      orderNumber: null,
      orderType: null,
      currentOrderType: ["Parcel", "Normal"],
      orderHistory: false,
      modalMode: null,
      floorName: null,
      tableName: null,
      isCallAdded: false,
      tableList: [],
      selectedCustomer: null,
      floorList: [],
      kitchenOrderHeader: [{ text: "Time", value: "edit" }, { text: "Item Name", value: "view" }, { text: "Quantity", value: "orderNumber" }, { text: "Table", value: "date" }, { text: "Floor", value: "date" }],
      kitchenDialog: false,
      orderHeader: [{ text: "Action", value: "edit" }, { text: "View", value: "view" }, { text: "Table", value: "tableName", sortable: true }, { text: "Order Number", value: "orderNumber" }, { text: "Date", value: "date", sortable: true }, { text: "Time", value: "time", sortable: true }, { text: "Name", value: "name" },
      // { text: "Invoice No", value: "invoiceId" },
      { text: "Invoice Date", value: "date", sortable: true }, { text: "Total Amount", value: "name" },
      // { text: "Remaining Order", value: "name" },
      // { text: "Order - ID", value: "deposit - ID" },
      // { text: "Firm", value: "product" },
      { text: "Status", value: "status" }, { text: "Cancel Order", value: "cancelled" }, { text: "Print", value: "print" }]
    };
  },
  created: function created() {
    var start = new Date().setHours(5, 30, 0, 0);
    var end = new Date().setHours(23, 59, 59, 59);
    this.dateFrom = new Date(start).toISOString().substr(0, 10);
    this.dateTo = new Date(end).toISOString().substr(0, 10);
    this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("buyers", this.$root.$firebaseRefs.buyer.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("sellers", this.$root.$firebaseRefs.seller.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("orders", this.$root.$firebaseRefs.orders.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsObject("buyerById", this.$root.$firebaseRefs.buyer.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsObject("sellerById", this.$root.$firebaseRefs.seller.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsObject("productById", this.$root.$firebaseRefs.products.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("termsAndConditions", this.$root.$firebaseRefs.termsAndConditions.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsObject("bankById", this.$root.$firebaseRefs.account.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("firmInfrastructure", this.$root.$firebaseRefs.firmInfrastructure.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("orderSettings", this.$root.$firebaseRefs.orderSetting.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("staffs", this.$root.$firebaseRefs.staff.orderByChild("brand").equalTo(this.selectedBrand)), this.getCurrentSettings();
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear", "roleAndPermission"]), mapGlobalGetters({ units: "productUnit" }), {
    hasOrderRateEditPermission: function hasOrderRateEditPermission() {
      if (this.roleAndPermission && this.roleAndPermission.permissions && this.roleAndPermission.permissions.length && this.roleAndPermission.permissions.indexOf('ORDER_RATE_EDIT') > -1) {
        return true;
      } else {
        return false;
      }
    },
    hasOrderEditPermission: function hasOrderEditPermission() {
      if (this.roleAndPermission && this.roleAndPermission.permissions && this.roleAndPermission.permissions.length && this.roleAndPermission.permissions.indexOf('INDIVIDUAL_ORDER_EDIT') > -1) {
        return true;
      } else {
        return false;
      }
    },
    hasOrderDeletePermission: function hasOrderDeletePermission() {
      if (this.roleAndPermission && this.roleAndPermission.permissions && this.roleAndPermission.permissions.length && this.roleAndPermission.permissions.indexOf('INDIVIDUAL_ORDER_DELETE') > -1) {
        return true;
      } else {
        return false;
      }
    },
    getKetchenItems: function getKetchenItems() {
      var items = [];
      this.filteredOrders.map(function (order) {
        order.items && order.items.map(function (item) {
          var finalItem = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(item));
          finalItem['order'] = order;
          items.push(finalItem);
        });
      });
      return items;
    },
    isTabOccupied: function isTabOccupied() {
      var _this = this;

      var floorIndex = this.floorList.findIndex(function (item) {
        return item.name == _this.floorName;
      });
      if (this.floorList[floorIndex].tables) {
        var tableIndex = this.floorList[floorIndex].tables.findIndex(function (item) {
          return item.name == _this.tableName;
        });
        if (this.floorList[floorIndex].tables[tableIndex]) {
          return this.floorList[floorIndex].tables[tableIndex]["booked"];
        }
      }
      return false;
    },
    productListByBrand: function productListByBrand() {
      var _this2 = this;

      var prod = this.products.filter(function (item) {
        return item["brand"] === _this2.selectedBrand && (!_this2.multiFirm ? _this2.selectedFirm ? item["firm"] === _this2.selectedFirm : false : true);
      });
      prod.map(function (p, index) {
        var productsWithSimilarCompostion = _this2.products.filter(function (item) {
          return item[".key"] == p[".key"] || item["brand"] === _this2.selectedBrand && (!!item["composition"] ? _.isEqual(item["composition"], p["composition"]) : false);
        });
        prod[index]["similar"] = productsWithSimilarCompostion;
      });
      return prod;
    },
    staffByBrand: function staffByBrand() {
      var _this3 = this;

      return this.staffs.filter(function (item) {
        return item["brand"] === _this3.selectedBrand && (!_this3.multiFirm ? _this3.selectedFirm ? item["firm"] === _this3.selectedFirm : false : true) && item["staffRole"] === "Salesman";
      }).map(function (item) {
        return {
          text: item["staffName"],
          value: item[".key"]
        };
      });
    },
    filteredOrders: function filteredOrders() {
      var _this4 = this;

      var dateFrom = new Date(this.dateFrom).setHours(0, 0, 0, 0);
      var dateTo = new Date(this.dateTo).setHours(23, 59, 59, 59);
      return this.orders.filter(function (item) {
        return item["brand"] === _this4.selectedBrand && (_this4.selectedCustomer ? item.buyerId == _this4.selectedCustomer : true) && (_this4.statusFilter != "ALL" ? item.status == _this4.statusFilter : true) && (_this4.orderTypeFilter != "All" ? item.orderType == _this4.orderTypeFilter : true) && (_this4.dateFrom || _this4.dateTo ? item.date >= dateFrom && item.date <= dateTo : true) && !item.isPortfolio;
      });
    },
    getOrderedCustomers: function getOrderedCustomers() {
      return this.buyersByBrand.map(function (b) {
        return {
          text: b.name,
          value: b[".key"]
        };
      });
    },
    buyersByBrand: function buyersByBrand() {
      var _this5 = this;

      return this.buyers.filter(function (item) {
        return item["brand"] === _this5.selectedBrand;
      });
    },
    sellersByBrand: function sellersByBrand() {
      var _this6 = this;

      return this.sellers.filter(function (item) {
        return item["brand"] === _this6.selectedBrand;
      });
    },
    firmsByBrand: function firmsByBrand() {
      var _this7 = this;

      return this.firms.filter(function (item) {
        return item["brand"] === _this7.selectedBrand;
      }).map(function (item) {
        if (item.defaultFirm) {
          _this7.selectedFirm = item[".key"];
        }
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
    },
    isRestaurantBusiness: function isRestaurantBusiness() {
      var _this8 = this;

      if (this.selectedFirm) {
        var firm = this.firms.find(function (item) {
          return item[".key"] == _this8.selectedFirm;
        });
        if (firm.businessType == "Restaurant") {
          return true;
        }
      }
      return false;
    },

    // floorList() {
    //   if (this.selectedFirm) {
    //     let firmInfrastructure = this.firmInfrastructure.find(
    //       (item) => item["firm"] == this.selectedFirm
    //     );
    //     return firmInfrastructure.floorDetails;
    //   }
    //   return [];
    // },
    productInvoiceHeader: function productInvoiceHeader() {
      var productInvoiceHeader = [{ text: "Name", value: "Name" }, { text: "Quantity", value: "Taxable" }, { text: "Unit", value: "HSN" }, { text: "Rate", value: "rate" }, { text: "Total", value: "total" }];
      if (this.isRestaurantBusiness) {
        productInvoiceHeader = [{ text: "Call", value: "call" }].concat(productInvoiceHeader);
      }
      return productInvoiceHeader;
    }
  }),
  watch: {
    floorName: {
      handler: function handler(newVal, oldVal) {
        this.getTableList();
      },

      deep: true
    },
    orderSettings: {
      handler: function handler(newVal, oldVal) {
        this.getCurrentSettings();
      },

      deep: true
    },
    selectedFirm: {
      handler: function handler() {
        this.getFloorList();
      },

      deep: true
    },
    tableName: {
      handler: function handler() {
        // if(!this.selectedOrder && this.tableName) {
        //   this.changeTableStatus(true)
        // }
      },

      deep: true
    }
  },
  methods: {
    viewTable: function viewTable() {
      var _this9 = this;

      this.currentInfra = this.firmInfrastructure.find(function (item) {
        return item["firm"] == _this9.selectedFirm;
      });
      this.currentInfra.floorDetails.map(function (f, i1) {
        f.tables.map(function (t, i2) {
          if (t.orderId) {
            _this9.currentInfra.floorDetails[i1].tables[i2]["order"] = _this9.orders.find(function (o) {
              return o[".key"] == t.orderId;
            });
          }
        });
      });
      this.tableDialog = true;
    },
    getOrders: function getOrders(order) {
      var calls = [];
      order.items && order.items.map(function (i) {
        if (i.call && calls.indexOf(i.call) == -1) {
          calls.push(i.call);
        }
      });
      return calls;
    },
    getFloorList: function getFloorList() {
      var _this10 = this;

      if (this.selectedFirm && this.firmInfrastructure.length) {
        var firmInfrastructure = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(this.firmInfrastructure.find(function (item) {
          return item["firm"] == _this10.selectedFirm;
        })));
        this.floorList = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(firmInfrastructure.floorDetails));
      } else {
        this.floorList = [];
      }
    },
    releaseTable: function releaseTable(floorName, tableName, order) {
      var _this11 = this;

      if (confirm("Are you sure?")) {
        var firmInfrastructure = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(this.firmInfrastructure.find(function (item) {
          return item["firm"] == (order ? order.firm : _this11.selectedFirm);
        })));
        // let floorIndex = firmInfrastructure.floorDetails.findIndex(
        //   (item) => item.name == floorName
        // );
        // let tableIndex = firmInfrastructure.floorDetails[
        //   floorIndex
        // ].tables.findIndex((item) => item.name == tableName);
        // firmInfrastructure.floorDetails[floorIndex].tables[tableIndex][
        //   "booked"
        // ] = false;
        // delete firmInfrastructure.floorDetails[floorIndex].tables[tableIndex][
        //   "orderId"
        // ];
        // delete firmInfrastructure.floorDetails[floorIndex].tables[tableIndex][
        //   "order"
        // ];
        firmInfrastructure.floorDetails.map(function (floor, index) {

          floor.tables.map(function (table, index2) {
            if (floor.name == floorName && table.name == tableName) {
              delete firmInfrastructure.floorDetails[index].tables[index2]["orderId"];
              firmInfrastructure.floorDetails[index].tables[index2]["booked"] = false;
            }
            delete firmInfrastructure.floorDetails[index].tables[index2]["order"];
          });
        });
        var key = firmInfrastructure[".key"];
        delete firmInfrastructure[".key"];
        this.$root.$firebaseRefs.firmInfrastructure.child(key).set(firmInfrastructure).then(function (snap) {
          _this11.viewTable();
          _this11.getFloorList();
        });
      }
    },
    changeTableStatus: function changeTableStatus(book) {
      var _this12 = this;

      var floorIndex = this.floorList.findIndex(function (item) {
        return item.name == _this12.floorName;
      });
      var tableIndex = this.floorList[floorIndex].tables.findIndex(function (item) {
        return item.name == _this12.tableName;
      });
      this.floorList[floorIndex].tables[tableIndex]["booked"] = book;
      if (!book) {
        delete this.floorList[floorIndex].tables[tableIndex]["orderId"];
      }
      this.floorList = [].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(this.floorList));
    },
    saveTableChanges: function saveTableChanges(orderId) {
      var _this13 = this;

      var firmInfrastructure = this.firmInfrastructure.find(function (item) {
        return item["firm"] == _this13.selectedFirm;
      });

      // let floorIndex = this.floorList.findIndex(
      //   (item) => item.name == this.floorName
      // );
      // let tableIndex = this.floorList[floorIndex].tables.findIndex(
      //   (item) => item.name == this.tableName
      // );
      this.floorList.map(function (floor, index) {

        floor.tables.map(function (table, index2) {
          if (floor.name == _this13.floorName && table.name == _this13.tableName) {
            _this13.floorList[index].tables[index2]["orderId"] = orderId;
          }
          delete _this13.floorList[index].tables[index2]["order"];
        });
      });
      //this.floorList[floorIndex].tables[tableIndex]["orderId"] = orderId;

      firmInfrastructure.floorDetails = this.floorList;
      var key = firmInfrastructure[".key"];
      delete firmInfrastructure[".key"];
      this.$root.$firebaseRefs.firmInfrastructure.child(key).set(firmInfrastructure).then(function (snap) {
        if (_this13.tableDialog) {
          _this13.viewTable();
        }
      });
    },
    getCurrentSettings: function getCurrentSettings() {
      var _this14 = this;

      this.ordersSetting = this.orderSettings.find(function (i) {
        return i.brand == _this14.selectedBrand;
      });
    },
    printOrder: function printOrder(invoiceData, isGST, call) {
      var _this15 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var firm, customer, termsAndConditions, gstTotal;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                firm = _this15.firms.filter(function (item) {
                  return item[".key"] === invoiceData["firm"];
                })[0];
                customer = invoiceData.isBuyer ? _this15.buyerById[invoiceData.buyerId] : _this15.sellerById[invoiceData.buyerId];

                firm.address = _this15.getAddress(firm);
                customer.address = _this15.getAddress(customer);
                termsAndConditions = _this15.getTermsAndConditions(invoiceData);
                gstTotal = _this15.calculateGSTInvoice(customer, invoiceData, firm);

                if (!isGST) {
                  _context.next = 11;
                  break;
                }

                _context.next = 9;
                return Object(__WEBPACK_IMPORTED_MODULE_7__utils_orderPdf__["a" /* convertToOrder */])({
                  invoiceData: invoiceData,
                  firm: firm,
                  customer: customer,
                  terms: termsAndConditions[0],
                  gstTotal: gstTotal,
                  call: call
                }).then(function (doc) {
                  pdfMake.createPdf(doc).download();
                });

              case 9:
                _context.next = 13;
                break;

              case 11:
                _context.next = 13;
                return Object(__WEBPACK_IMPORTED_MODULE_7__utils_orderPdf__["b" /* convertToOrderWithoutGST */])({
                  invoiceData: invoiceData,
                  firm: firm,
                  customer: customer,
                  terms: termsAndConditions[0],
                  gstTotal: gstTotal,
                  call: call
                }).then(function (doc) {
                  pdfMake.createPdf(doc).download();
                });

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this15);
      }))();
    },
    getTermsAndConditions: function getTermsAndConditions(invoiceData) {
      var _this16 = this;

      var termsAndConditions = this.termsAndConditions.filter(function (item) {
        return item["brand"] === _this16.selectedBrand && item["firm"] === invoiceData.firm;
      });
      if (termsAndConditions.length) {
        if (termsAndConditions[0].bank) {
          var banks = [];
          termsAndConditions[0].bank.map(function (bankId) {
            var bank = _this16.bankById[bankId];
            bank.address = _this16.getAddress(bank);
            banks.push(bank);
          });
          termsAndConditions[0].banks = banks;
        } else {
          termsAndConditions[0].banks = [];
        }
      } else {
        termsAndConditions = [{
          termsAndConditions: "",
          banks: []
        }];
      }
      return termsAndConditions;
    },
    getAddress: function getAddress(item) {
      if (!item) {
        return "";
      }
      var address = (item.village ? item.village + " - " : "") + (item.block ? item.block + " - " : "") + (item.tehsil ? item.tehsil + " - " : "") + (item.district ? item.district + " - " : "") + (item.state ? item.state + " - " : "") + (item.country ? item.country + " - " : "");
      address = address.substring(0, address.length - 2);
      return address;
    },
    calculateGSTInvoice: function calculateGSTInvoice(currentUser, invoice, firm) {
      var _this17 = this;

      var SGST_val = 0;
      var CGST_val = 0;
      var IGST_val = 0;
      invoice.items && invoice.items.map(function (item, index) {
        var prod = _this17.products.filter(function (p) {
          return p[".key"] === item["productId"];
        })[0];
        item["taxableGST_rate"] = prod["taxableGST_rate"];
        item.HSN_code = prod["HSN_code"];
        item.basicPrice = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.rate * item.quantity).toFixed(2);
        item.GSTValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.basicPrice * (parseFloat(item.taxableGST_rate) / 100)).toFixed(2);
        item.totlePrice = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.GSTValue)).toFixed(2);
        var GST = item["taxableGST_rate"];
        if (!currentUser.state || firm && currentUser.state && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(GST) && firm.state === currentUser.state) {
          item["CGST_val"] = item["GSTValue"] / 2;
          item["CGST"] = GST / 2;
          item["SGST_val"] = item["GSTValue"] / 2;
          item["SGST"] = GST / 2;
          item["IGST"] = 0;
          item["IGST_val"] = 0;
        } else {
          item["IGST"] = GST;
          item["CGST"] = 0;
          item["SGST"] = 0;
          item["IGST_val"] = item["GSTValue"];
          item["CGST_val"] = 0;
          item["SGST_val"] = 0;
        }
        SGST_val += parseFloat(item["SGST_val"]);
        CGST_val += parseFloat(item["CGST_val"]);
        IGST_val += parseFloat(item["IGST_val"]);
      });
      return { SGST_val: SGST_val, CGST_val: CGST_val, IGST_val: IGST_val };
    },
    addOrderDialog: function addOrderDialog(tableName, floorName) {
      var _this18 = this;

      if (tableName && floorName) {
        setTimeout(function () {
          _this18.floorName = floorName;
          _this18.tableName = tableName;
          _this18.orderType = 'Normal';
        }, 500);
      }
      this.orderDialog = true;
      this.productsToOrder = [];
      this.items = [{
        productName: null,
        productId: null,
        quantity: 1,
        unit: null,
        rate: 0,
        time: new Date().getTime()
      }];
      this.time = new Date().getTime();
      this.isEdit = false;
      this.invoiceOrder = false;
      this.selectedBuyer = null;
      // this.selectedFirm = null;
      var orders = this.orders.filter(function (i) {
        return i["brand"] === _this18.selectedBrand;
      });
      this.orderNumber = orders.length + 1;
      this.orderType = null, this.selectedOrder = null;
      this.floorName = null;
      this.tableName = null;
      this.isCallAdded = false;
      this.tableList = [];
      if (this.ordersSetting && this.ordersSetting.isOrderTime) {
        var date = new Date();
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var strTime = hours + ':' + minutes;
        this.orderTime = strTime;
      }
      this.getFloorList();
    },
    openHistory: function openHistory(item) {
      this.selectedOrder = item;
      this.orderHistory = true;
      this.historyStep = 1;
      this.modalMode = "history";
    },
    openOrignal: function openOrignal(item) {
      this.selectedOrder = item;
      this.orderHistory = true;
      this.historyStep = 1;
      this.modalMode = "orignal";
    },
    openProd: function openProd(item) {
      this.selectedOrder = item;
      this.invoiceOrder = true;
    },
    getTotal: function getTotal(item) {
      var total = 0;
      item.items && item.items.map(function (i) {
        total += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(i.rate) * __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(i.quantity));
      });
      return total;
    },
    getFirmName: function getFirmName(e) {
      var firm = void 0;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter(function (item) {
          return item[".key"] === e;
        })[0];
      }
      if (firm) return firm.name;
    },
    getCustomerName: function getCustomerName(id) {
      var buyer = this.buyerById[id];
      var seller = this.sellerById[id];
      if (!buyer && !seller) {
        return "DELETED CUSTOMER";
      }
      return buyer ? buyer.name : seller.name;
    },
    isShopUserExists: function isShopUserExists(id) {
      var buyers = this.buyers.filter(function (item) {
        return item.shopUserId == id;
      });
      if (!buyers.length) {
        return false;
      }
      return true;
    },
    getShopUserName: function getShopUserName(id) {
      var buyers = this.buyers.filter(function (item) {
        return item.shopUserId == id;
      });
      if (!buyers.length) {
        return "DELETED CUSTOMER";
      }
      return buyers[0].name;
    },

    // addToBucket() {
    //   let tempIts = this.items;
    //   this.items = [];
    //   this.productsToOrder.map((prod, index) => {
    //     if (typeof prod == "string") {
    //       this.productsToOrder.splice(index, 1);
    //     }
    //   });
    //   this.productsToOrder.map((prod, index) => {
    //     let selectedProd = tempIts.filter(
    //       (item) => item["productId"] == prod[".key"]
    //     )[0];
    //     let itemToAdd = {
    //       productName: prod.name,
    //       similar: prod.similar,
    //       productId: prod[".key"],
    //       quantity:
    //         selectedProd && selectedProd.quantity ? selectedProd.quantity : 1,
    //       unit:
    //         selectedProd && selectedProd.unit ? selectedProd.unit : prod.unit,
    //       rate:
    //         selectedProd && selectedProd.rate
    //           ? selectedProd.rate
    //           : this.isBuyer
    //           ? prod["sellingPrice"] || 0
    //           : prod["purchasingPrice"] || 0,
    //     };
    //     if (this.multiFirm) {
    //       itemToAdd["firm"] = prod.firm;
    //     }
    //     this.items.push(itemToAdd);
    //   });
    // },
    restructureProductList: function restructureProductList(indexMain) {
      var _this19 = this;

      var buyer = this.selectedBuyer;
      this.items.map(function (item, index) {
        if (indexMain ? index == indexMain : true) {
          var prod = _this19.products.filter(function (item1) {
            return item1["name"] == item.productName && item1["brand"] === _this19.selectedBrand;
          })[0];

          _this19.items[index]["productName"] = prod.name;
          _this19.items[index]["productId"] = prod[".key"];
          _this19.items[index]["quantity"] = 1;
          _this19.items[index]["unit"] = prod.unit;
          _this19.items[index]["rate"] = _this19.isBuyer ? prod["sellingPrice"] || 0 : prod["purchasingPrice"] || 0;
          if (prod.unitsDeatilsAdded) {
            _this19.availableProductUnit[prod[".key"]] = {
              units: prod.unitsDetails.map(function (prod) {
                return prod.unit;
              })
            };
          } else {
            _this19.availableProductUnit[prod[".key"]] = {
              units: _this19.units
            };
          }
          if (buyer && buyer.category && prod.sellingPriceByCategories && prod.sellingPriceByCategories[buyer.category]) {
            _this19.items[index]['rate'] = prod.sellingPriceByCategories[buyer.category];
          }
          if (_this19.multiFirm) {
            _this19.items[index]["firm"] = prod.firm;
          }
          if (_this19.isRestaurantBusiness) {
            var call = 0;
            if (_this19.items.length > 1) {
              call = Math.max.apply(Math, _this19.items.map(function (o) {
                return o.call || 0;
              }));
            }
            if (!_this19.isCallAdded) {
              call++;
              _this19.isCallAdded = !_this19.isCallAdded;
            }
            _this19.items[index]["call"] = call;
          }
        }
      });
    },
    getTableList: function getTableList() {
      var _this20 = this;

      if (this.floorName) {
        var floorList = this.floorList.find(function (item) {
          return item.name == _this20.floorName;
        });
        this.tableList = floorList && floorList.tables ? floorList.tables.filter(function (i) {
          return _this20.selectedOrder && _this20.selectedOrder[".key"] ? true : i.booked != true;
        }) : [];
      }
    },
    addProd: function addProd() {
      var itemToAdd = {
        productName: null,
        productId: null,
        quantity: 1,
        unit: null,
        rate: 0,
        time: new Date().getTime()
      };
      this.items.push(itemToAdd);
    },
    removeProd: function removeProd(index) {
      this.items.splice(index, 1);
    },
    getCurrentFirmState: function getCurrentFirmState() {
      var _this21 = this;

      var firm = this.firms.filter(function (item) {
        return item[".key"] == _this21.selectedFirm;
      })[0];
      return firm["state"];
    },

    addCustomer: function addCustomer(e) {
      var obj = {
        name: e.target.value,
        brand: this.selectedBrand,
        state: this.getCurrentFirmState()
      };
      if (this.isBuyer) {
        this.$root.$firebaseRefs.buyer.push(obj);
      } else {
        this.$root.$firebaseRefs.seller.push(obj);
      }
    },
    addShopUser: function addShopUser(order) {
      if (confirm("Are you sure you want to create buyer?")) {
        var obj = {
          name: order.shopOrderUserName,
          shopUserId: order.shopOrderUserId,
          brand: this.selectedBrand,
          state: this.getCurrentFirmState()
        };
        this.$root.$firebaseRefs.buyer.push(obj);
      }
    },
    createInvoice: function createInvoice() {
      var _this22 = this;

      var key = this.selectedOrder[".key"];
      delete this.selectedOrder[".key"];

      if (!this.selectedOrder.buyerId && this.selectedOrder.shopOrderUserId) {
        var buyer = this.buyers.filter(function (item) {
          return item.shopUserId == _this22.selectedOrder.shopOrderUserId;
        })[0];
        if (buyer) {
          this.selectedOrder["buyerId"] = buyer[".key"];
        } else {
          return;
        }
      }

      this.$root.$firebaseRefs.orders.child(key).set(this.selectedOrder).then(function (snap) {
        _this22.selectedOrder = null;
        _this22.$router.push({ path: "/order-to-invoice/" + key });
        _this22.invoiceOrder = false;
      });
    },
    cancelOrder: function cancelOrder(order) {
      if (window.confirm("Do you want to cancel this order?")) {
        var key = order[".key"];
        delete order[".key"];
        order["status"] = "CANCELLED";
        this.$root.$firebaseRefs.orders.child(key).set(order).then(function (snap) {});
      }
    },
    editOrder: function editOrder(order) {
      var _this23 = this;

      if (order.multiFirm) {
        this.multiFirm = true;
      }
      if (order.orderTime) {
        this.orderTime = order.orderTime;
      }
      if (order.soldBy) {
        this.soldBy = order.soldBy;
      }
      this.productsToOrder = [];
      this.items = order.items;
      this.selectedFirm = order.firm;
      this.date = new Date(order.date).toISOString().substr(0, 10), this.time = new Date(this.time).getTime(), this.orderNumber = order.orderNumber, this.orderType = order.orderType, this.selectedOrder = order;
      this.isBuyer = order.isBuyer;
      if (order.isBuyer) {
        this.selectedBuyer = this.buyerById[order.buyerId];
      } else {
        this.selectedBuyer = this.sellerById[order.buyerId];
      }
      if (this.isRestaurantBusiness && this.orderType === 'Normal') {
        this["floorName"] = order.floorName;
        this["tableName"] = order.tableName;
      }
      this.items.map(function (item, index) {
        var prod = _this23.products.filter(function (item1) {
          return item1["name"] == item.productName && item1["brand"] === _this23.selectedBrand;
        })[0];

        if (prod.unitsDeatilsAdded) {
          _this23.availableProductUnit[prod[".key"]] = {
            units: prod.unitsDetails.map(function (prod) {
              return prod.unit;
            })
          };
        } else {
          _this23.availableProductUnit[prod[".key"]] = {
            units: _this23.units
          };
        }
      });

      this.orderDialog = true;
      this.isEdit = true;

      // this.items.map((item1,index)=>{
      //   let productsWithSimilarCompostion = this.products.filter((item) => {
      //   return (item['.key'] == item1['productId'] || (item['brand'] === this.selectedBrand && (!!item['composition'] ?
      //     _.isEqual(item['composition'],item1['composition']) : false)
      //     ))
      //   });
      //   this.items[index]['similar'] = productsWithSimilarCompostion;
      //   // this.productsToOrder.push(this.productById[item1.productId])
      //   let obj = this.productById[item1.productId];
      //   obj['.key'] = item1.productId;
      //   let sim = this.products.filter((item) => {
      //   return (item['.key'] ==obj['.key'] || (item['brand'] === this.selectedBrand && (!!item['composition'] ?
      //     _.isEqual(item['composition'],obj['composition']) : false)
      //     ))
      //   });
      //   obj['similar'] = sim;
      //   this.productsToOrder.push(obj)
      // })
    },
    unitChange: function unitChange(item) {
      var _this24 = this;

      var prod = this.products.find(function (i) {
        return i[".key"] == item["productId"];
      });
      if (prod.unitsDeatilsAdded) {
        prod.unitsDetails.map(function (prod) {
          if (prod["unit"] == item.unit) {
            var rate = _this24.isBuyer ? prod["sellingPrice"] : prod["purchasingPrice"];
            if (rate) {
              item.rate = rate;
            }
          }
        });
      }
    },
    addOrder: function addOrder() {
      var _this25 = this;

      this.items.map(function (i, index) {
        if (!i.productName) {
          _this25.items.splice(index, 1);
        }
      });
      var orderObj = {
        buyerId: this.selectedBuyer[".key"],
        isBuyer: this.isBuyer,
        firm: this.selectedFirm,
        brand: this.selectedBrand,
        date: new Date(this.date).getTime(),
        time: new Date(this.time).getTime(),
        orderNumber: this.orderNumber,
        orderType: this.orderType,
        items: this.items
      };
      //   status: 'IN PROGRESS'
      // }
      // this.$root.$firebaseRefs.orders.push(orderObj);
      if (this.multiFirm) {
        orderObj["multiFirm"] = true;
      }
      if (this.isRestaurantBusiness) {
        orderObj["floorName"] = this.floorName;
        orderObj["tableName"] = this.tableName;
      }
      if (this.ordersSetting && this.ordersSetting.isOrderTime) {
        orderObj["orderTime"] = this.orderTime;
      }
      if (this.ordersSetting && this.ordersSetting.isStaffSelection) {
        orderObj["soldBy"] = this.soldBy;
      }
      var key = null;
      if (this.isEdit) {
        key = this.selectedOrder[".key"];
        orderObj["status"] = this.selectedOrder["status"];
        orderObj["buyerId"] = this.selectedOrder["buyerId"];
        this.$root.$firebaseRefs.orders.child(this.selectedOrder[".key"]).set(orderObj).then(function (snap) {
          _this25.isEdit = false;
        });
      } else {
        orderObj["status"] = "IN PROGRESS";
        var res = this.$root.$firebaseRefs.orders.push(orderObj);
        key = res.key;
      }
      this.isCallAdded = false;
      this.orderDialog = false;
      this.selectedBuyer = null;
      this.isBuyer = true;
      this.items = [];
      this.productsToOrder = [];
      if (this.isRestaurantBusiness) {
        this.saveTableChanges(key);
        if (this.isEdit && this.tableDialog) {
          this.viewTable();
        }
      }
    },
    deleteOrder: function deleteOrder(order) {
      if (window.confirm("Do you want to Delete ?")) {
        this.$root.$firebaseRefs.orders.child(order[".key"]).remove();
      }
    }
  }
});

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      viewTransaction: false,
      currentStaff: null,
      currentInvoice: null,
      currentPaymentGSTType: null,
      dialog: false,
      payableAmount: 0,
      datepicker: false,
      selectedDate: new Date().toISOString().substr(0, 10),
      paymentType: '',
      selectedBank: null,
      amountFromCash: 0,
      amountFromBank: 0,
      currentStaffInvoices: [],
      staffTransactionHeaders: [{ text: "Date", value: "date", sortable: true }, { text: "Invoice ID", value: "date", sortable: true }, { text: "Customer", value: "date", sortable: true }, { text: "Brokerage Rate", value: "date", sortable: true }, { text: "Brokerage Amount", value: "date", sortable: true }, { text: "Invoice Amount", value: "date", sortable: true }, { text: "Status", value: "date", sortable: true }, { text: "Action", value: "date", sortable: true }, { text: "Firm", value: "date", sortable: true }]
    };
  },
  created: function created() {
    this.$bindAsArray('firms', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray('staff', this.$root.$firebaseRefs.staff.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray('invoice', this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsObject("buyerById", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsObject("sellerById", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("banks", this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand"]), {
    staffByBrand: function staffByBrand() {
      var _this = this;

      return this.staff.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      });
    },
    banksByFirms: function banksByFirms() {
      var _this2 = this;

      return this.banks.filter(function (item) {
        return item["brand"] === _this2.selectedBrand && item["firm"] === _this2.currentInvoice.firm;
      });
    }
  }),
  methods: {
    openPayBrokerage: function openPayBrokerage(inv) {
      this.dialog = true;
      this.currentInvoice = inv;
      this.payableAmount = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount) * __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(inv.brokerageRate) / 100;
      this.paymentType = 'Cash';
    },
    payBrokerage: function payBrokerage() {
      var _this3 = this;

      if (this.paymentType == 'Cash') {
        var firm = this.firms.filter(function (item) {
          return item['.key'] == _this3.currentInvoice.firm;
        })[0];
        if (firm) {
          firm.amount = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(firm.amount) - __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.payableAmount);
          var key = firm['.key'];
          delete firm['.key'];
          this.$root.$firebaseRefs.firm.child(key).set(firm);
          this.updateInvoice(this.currentInvoice);
        }
      } else {
        var bank = this.banks.filter(function (item) {
          return item['.key'] == _this3.selectedBank;
        })[0];
        if (bank) {
          bank.amount = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(bank.amount) - __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.payableAmount);
          var _key = bank['.key'];
          delete bank['.key'];
          this.$root.$firebaseRefs.account.child(_key).set(bank);
          this.updateInvoice(this.currentInvoice);
        }
      }
      this.dialog = false;
    },
    updateInvoice: function updateInvoice(inv) {
      inv['brokeragePaid'] = true;
      inv['brokeragePayDate'] = new Date(this.selectedDate).getTime();
      inv['brokeragePaymentType'] = this.paymentType;
      var key = inv['.key'];
      delete inv['.key'];
      this.$root.$firebaseRefs.invoice.child(key).set(inv);
    },
    getCurrentUserName: function getCurrentUserName(buyerId) {
      var buyer = this.buyerById[buyerId];
      var seller = this.sellerById[buyerId];
      var currentUser = buyer && buyer.state ? buyer : seller && seller.state ? seller : {};
      return currentUser.name;
    },
    openStaffTransactions: function openStaffTransactions(staff) {
      var _this4 = this;

      this.currentStaff = staff;
      this.currentStaffInvoices = this.invoice.filter(function (item) {
        return item['brand'] == _this4.selectedBrand && item['soldBy'] == staff['.key'] && item['brokerageRate'] != undefined;
      });
      this.viewTransaction = true;
    },
    firmbyId: function firmbyId(id) {
      return this.firms.filter(function (item) {
        return item['.key'] == id;
      })[0].name;
    },
    renderDate: function renderDate(timeStamp) {
      if (timeStamp) {
        return new Date(timeStamp).toLocaleDateString("en-GB");
      }
      return "--";
    }
  }
});

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_pdfmake__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_excelExport__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_xlsx__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_xlsx__);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      filterType: 'Custom',
      months: [{
        text: 'January',
        value: 0
      }, {
        text: 'February',
        value: 1
      }, {
        text: 'March',
        value: 2
      }, {
        text: 'April',
        value: 3
      }, {
        text: 'May',
        value: 4
      }, {
        text: 'June',
        value: 5
      }, {
        text: 'July',
        value: 6
      }, {
        text: 'August',
        value: 7
      }, {
        text: 'September',
        value: 8
      }, {
        text: 'October',
        value: 9
      }, {
        text: 'November',
        value: 10
      }, {
        text: 'December',
        value: 11
      }],
      selectedMonth: null,
      selectedQuarter: null,
      quarters: [{
        text: '1 April - May - 30 June',
        value: 1
      }, {
        text: '1 July - Aug - 30 Sept',
        value: 2
      }, {
        text: '1 Oct  - Nov - 31 Dec',
        value: 3
      }, {
        text: '1 Jan  -  March - 31 March',
        value: 4
      }],
      selectedFirm: null,
      toDate: null,
      fromDate: null,
      datepickerFrom: null,
      datepickerTo: null,
      invoiceOfFirm: [],
      invoiceOfFirmGST3: [],
      dialogGSTReports: false,
      outwardSupplies: {},
      gst1_desc: {
        B2B_invoices: {
          voucherCount: 0,
          title: "B2B Invoices",
          description: "4A, 4B, 4C, 6B, 6C",
          totalBaseAmount: 0,
          ICGST: 0,
          CGST: 0,
          SGST: 0,
          CESS: 0,
          totalInvoice: 0,
          invoices: []
        },
        B2C_invoices_big: {
          voucherCount: 0,
          title: "B2C Invoices [Big]",
          description: "5A, 5B",
          totalBaseAmount: 0,
          ICGST: 0,
          CGST: 0,
          SGST: 0,
          CESS: 0,
          totalInvoice: 0,
          invoices: []
        },
        Export_invoices: {
          voucherCount: 0,
          title: "Export Invoices",
          description: "6A",
          totalBaseAmount: 0,
          ICGST: 0,
          CGST: 0,
          SGST: 0,
          CESS: 0,
          totalInvoice: 0,
          invoices: []
        },
        B2C_invoices_small: {
          voucherCount: 0,
          title: "B2C Invoices [small]",
          description: "7",
          totalBaseAmount: 0,
          ICGST: 0,
          CGST: 0,
          SGST: 0,
          CESS: 0,
          totalInvoice: 0,
          invoices: []
        },
        Nillrated_invoices: {
          voucherCount: 0,
          title: "Nill Rated Invoices",
          description: "8A, 8B, 8C, 8D",
          totalBaseAmount: 0,
          ICGST: 0,
          CGST: 0,
          SGST: 0,
          CESS: 0,
          totalInvoice: 0,
          invoices: []
        },
        Credit_Debit_note_reg: {
          voucherCount: 0,
          title: "Credit Note/Debit Note",
          description: "Registered - 9B",
          totalBaseAmount: 0,
          ICGST: 0,
          CGST: 0,
          SGST: 0,
          CESS: 0,
          totalInvoice: 0,
          invoices: []
        },
        Credit_Debit_note_unreg: {
          voucherCount: 0,
          title: "Credit Note/Debit Note",
          description: "Unregistered - 9B",
          totalBaseAmount: 0,
          ICGST: 0,
          CGST: 0,
          SGST: 0,
          CESS: 0,
          totalInvoice: 0,
          invoices: []
        },
        Tax_Liability: {
          voucherCount: 0,
          title: "TAX Liability(Advanced Received)",
          description: "11(A)1-11(A)2",
          totalBaseAmount: 0,
          ICGST: 0,
          CGST: 0,
          SGST: 0,
          CESS: 0,
          totalInvoice: 0,
          invoices: []
        },
        Adjustment_advance: {
          voucherCount: 0,
          title: "Adjustment of Advances",
          description: "11(B)1-11(B)2",
          totalBaseAmount: 0,
          ICGST: 0,
          CGST: 0,
          SGST: 0,
          CESS: 0,
          totalInvoice: 0,
          invoices: []
        },
        HSN_SAC_Summary: {
          voucherCount: 0,
          title: "HSN/SAC Summary",
          description: "12",
          totalBaseAmount: 0,
          ICGST: 0,
          CGST: 0,
          SGST: 0,
          CESS: 0,
          totalInvoice: 0,
          invoices: []
        },
        Document_Summary: {
          voucherCount: 0,
          title: "Document Summary",
          description: "13",
          totalBaseAmount: 0,
          ICGST: 0,
          CGST: 0,
          SGST: 0,
          CESS: 0,
          totalInvoice: 0,
          invoices: []
        },
        Total: {
          voucherCount: 0,
          title: "",
          description: "",
          totalBaseAmount: 0,
          ICGST: 0,
          CGST: 0,
          SGST: 0,
          CESS: 0,
          totalInvoice: 0,
          invoices: []
        }
      },
      selectedGSTCat: {
        voucherCount: 0,
        title: "",
        description: "",
        totalBaseAmount: 0,
        ICGST: 0,
        CGST: 0,
        SGST: 0,
        CESS: 0,
        totalInvoice: 0,
        invoices: []
      }
    };
  },
  created: function created() {
    if (this.finYear) {
      this.fromDate = new Date(this.finYear.start).toISOString().substr(0, 10);
      this.toDate = new Date(this.finYear.end).toISOString().substr(0, 10);
    }
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("buyers", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("sellers", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("buyer", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("seller", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    //this.resetGST3("outwardSupplies");
    //this.getInvoiceGST3();
  },

  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear", "brandFinYear"]), {
    firmsByBrand1: function firmsByBrand1() {
      var _this = this;

      return this.firms.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      });
    },

    // current brands firm list
    firmsByBrand: function firmsByBrand() {
      var _this2 = this;

      // return selected brand firms
      var firmsB = this.firms.filter(function (item) {
        return item['brand'] === _this2.selectedBrand;
      });
      firmsB.map(function (item) {
        if (item.defaultFirm) {
          _this2.selectedFirm = item;
        }
      });
      return firmsB;
    }
  }),
  methods: {
    // Start to Export in XLSX
    downloadJSON: function downloadJSON() {
      var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(this.gst1_desc));
      var dlAnchorElem = document.getElementById('downloadAnchorElem');
      dlAnchorElem.setAttribute("href", dataStr);
      dlAnchorElem.setAttribute("download", "GST1.json");
      dlAnchorElem.click();
    },
    toggle: function toggle(item) {
      item.expand = !item.expand;
    },
    printGST1: function printGST1() {
      var firm = this.selectedFirm;
      firm.address = this.generateAddress(firm);
      var doc = Object(__WEBPACK_IMPORTED_MODULE_7__utils_pdfmake__["m" /* convertToPDFGST_1 */])({
        firm: firm,
        outwardSupplies: this.outwardSupplies,
        gst1: this.gst1_desc
      });
      pdfMake.createPdf(doc).download();
    },
    exportAll: function exportAll() {
      var firm = this.selectedFirm;
      firm.address = this.generateAddress(firm);
      var wb = Object(__WEBPACK_IMPORTED_MODULE_8__utils_excelExport__["b" /* convertToExcelGST_1All */])({
        selectedFirm: firm,
        B2B_invoices: this.gst1_desc.B2B_invoices,
        B2C_invoices_big: this.gst1_desc.B2C_invoices_big,
        B2C_invoices_small: this.gst1_desc.B2C_invoices_small,
        Nillrated_invoices: this.gst1_desc.Nillrated_invoices,
        Export_invoices: this.gst1_desc.Export_invoices,
        Adjustment_advance: this.gst1_desc.Adjustment_advance,
        Tax_Liability: this.gst1_desc.Tax_Liability,
        Credit_Debit_note_reg: this.gst1_desc.Credit_Debit_note_reg,
        Credit_Debit_note_unreg: this.gst1_desc.Credit_Debit_note_unreg,
        HSN_SAC_Summary: this.gst1_desc.HSN_SAC_Summary,
        Document_Summary: this.gst1_desc.Document_Summary
      });
      __WEBPACK_IMPORTED_MODULE_9_xlsx___default.a.writeFile(wb, "GST1_" + new Date().getTime() + ".xlsx"); // name of the file is 'book.xlsx'
    },
    onexport: function onexport() {
      // On Click Excel download button
      // export json to Worksheet of Excel
      // only array possible
      var invoicesHeader = {
        s_no: "S. No",
        location: "Location",
        name: "Customer Name",
        gstin: "GSTIN/UIN",
        invoiceId: "Invoice Number",
        date: "Date",
        basicAmount: "Taxable Value",
        IGST_val: "IGST Amount",
        CGST_val: "CGST Amount",
        SGST_val: "SGST Amount",
        CESS: "CESS Amount",
        totalAmount: "Total Invoices"
      };

      var firmHeader = {
        name: "Name",
        address: "Address",
        mobileNumber: "Mobile",
        panNumber: "PAN Number",
        email: "Email",
        GST_number: "GST Number",
        website: "Website"
      };

      var selectedInvoiceTypeHeader = {
        title: "Description of Invoices",
        voucherCount: "Voucher Count",
        totalBaseAmount: "Total Taxable Value",
        ICGST: "IGST Amount",
        CGST: "CGST Amount",
        SGST: "SGST Amount",
        CESS: "CESS",
        totalInvoice: "Total Invoices"
      };

      var invoiceData = [invoicesHeader].concat(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_toConsumableArray___default()(this.selectedGSTCat.invoices.map(function (invoice, index) {
        return {
          s_no: index + 1,
          location: invoice.buyer.state,
          name: invoice.buyer.name,
          gstin: invoice.buyer.GST_number,
          invoiceId: invoice.invoiceId,
          date: new Date(invoice.date).toLocaleDateString("en-GB"),
          basicAmount: invoice.basicAmount,
          IGST_val: invoice.IGST_val,
          CGST_val: invoice.CGST_val,
          SGST_val: invoice.SGST_val,
          CESS: invoice.CESS,
          totalAmount: invoice.totalAmount
        };
      })));

      var firmData = [firmHeader, {
        name: this.selectedFirm.name,
        address: this.generateAddress(this.selectedFirm),
        mobileNumber: this.selectedFirm.mobileNumber,
        panNumber: this.selectedFirm.panNumber,
        email: this.selectedFirm.email,
        GST_number: this.selectedFirm.GST_number,
        website: this.selectedFirm.website
      }];

      var selectedInvoiceTypeData = [selectedInvoiceTypeHeader, {
        title: this.selectedGSTCat.title,
        voucherCount: this.selectedGSTCat.voucherCount,
        totalBaseAmount: this.selectedGSTCat.totalBaseAmount,
        ICGST: this.selectedGSTCat.ICGST,
        CGST: this.selectedGSTCat.CGST,
        SGST: this.selectedGSTCat.SGST,
        CESS: this.selectedGSTCat.CESS,
        totalInvoice: this.selectedGSTCat.totalInvoice
      }];

      var invoiceWS = __WEBPACK_IMPORTED_MODULE_9_xlsx___default.a.utils.json_to_sheet(invoiceData, {
        skipHeader: true
      });
      var firmWS = __WEBPACK_IMPORTED_MODULE_9_xlsx___default.a.utils.json_to_sheet(firmData, { skipHeader: true });
      var selectedInvoiceTypeWS = __WEBPACK_IMPORTED_MODULE_9_xlsx___default.a.utils.json_to_sheet(selectedInvoiceTypeData, { skipHeader: true });

      // A workbook is the name given to an Excel file
      var wb = __WEBPACK_IMPORTED_MODULE_9_xlsx___default.a.utils.book_new(); // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      __WEBPACK_IMPORTED_MODULE_9_xlsx___default.a.utils.book_append_sheet(wb, invoiceWS, "Invoices");
      __WEBPACK_IMPORTED_MODULE_9_xlsx___default.a.utils.book_append_sheet(wb, selectedInvoiceTypeWS, this.selectedGSTCat.title); // sheetAName is name of Worksheet
      __WEBPACK_IMPORTED_MODULE_9_xlsx___default.a.utils.book_append_sheet(wb, firmWS, "Firm");

      // export Excel file
      __WEBPACK_IMPORTED_MODULE_9_xlsx___default.a.writeFile(wb, "GST1_" + new Date().getTime() + ".xlsx"); // name of the file is 'book.xlsx'
    },

    // End of export of Excel

    // Start of Print and Save in PDF
    printGST1Individual: function printGST1Individual() {
      var doc = Object(__WEBPACK_IMPORTED_MODULE_7__utils_pdfmake__["n" /* convertToPDFGST_1_individual */])({
        firm: this.selectedFirm,
        selectedGSTCat: this.selectedGSTCat
      });
      console.log(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(doc, null, 4));
      pdfMake.createPdf(doc).download();
    },
    openGSTInvoice: function openGSTInvoice(GSTCategory) {
      this.selectedGSTCat = this.gst1_desc[GSTCategory];
      this.selectedGSTCat.invoices.sort(function (a, b) {
        return -(new Date(b.date) - new Date(a.date));
      });
      this.dialogGSTReports = true;
    },
    calculateGSTInvoice: function calculateGSTInvoice(currentUser, invoice) {
      var SGST_val = 0;
      var CGST_val = 0;
      var IGST_val = 0;
      invoice.items && invoice.items.map(function (item, index) {
        if (invoice.gstType == 'SGST|CGST') {
          SGST_val += parseFloat(item["SGST_val"]);
          CGST_val += parseFloat(item["CGST_val"]);
        } else {
          IGST_val += parseFloat(item["IGST_val"]);
        }
      });
      return { SGST_val: SGST_val, CGST_val: CGST_val, IGST_val: IGST_val };
    },
    reset: function reset(obj) {
      var title = this.gst1_desc[obj].title;
      var description = this.gst1_desc[obj].description;
      this.gst1_desc[obj] = {
        voucherCount: 0,
        totalBaseAmount: 0,
        ICGST: 0,
        CGST: 0,
        SGST: 0,
        CESS: 0,
        totalInvoice: 0,
        invoices: [],
        title: title,
        description: description
      };
    },
    resetGST3: function resetGST3(obj) {
      this[obj] = {
        totalBaseAmount: 0,
        IGST: 0,
        CGST: 0,
        SGST: 0,
        CESS: 0,
        totalInvoiceAmount: 0,
        expand: false,
        intraState: {
          totalBaseAmount: 0,
          IGST: 0,
          CGST: 0,
          SGST: 0,
          CESS: 0,
          totalInvoiceAmount: 0,
          taxable: {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0,
            expand: false,
            GST_3: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_5: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_12: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_18: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_28: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            }
          },

          exempted: {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0
          },
          nillrated: {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0
          },
          others: {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0
          }
        },
        interState: {
          totalBaseAmount: 0,
          IGST: 0,
          CGST: 0,
          SGST: 0,
          CESS: 0,
          totalInvoiceAmount: 0,
          taxable: {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0,
            expand: false,
            GST_3: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_5: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_12: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_18: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_28: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            }
          },
          exempted: {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0
          },
          nillrated: {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0
          },
          others: {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0
          }
        }
      };
    },
    getGSTtotal: function getGSTtotal(item) {
      var GSTTotal = 0;
      item && item.items && item.items.map(function (item) {
        GSTTotal += __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
      });
      return GSTTotal;
    },
    getInvoiceGST3: function getInvoiceGST3() {
      var _this3 = this;

      var toDate = this.toDate ? new Date(this.toDate).getTime() : null;
      var fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
      this.invoiceOfFirmGST3 = this.invoices.filter(function (item) {
        return item["brand"] === _this3.selectedBrand && (_this3.selectedFirm ? _this3.selectedFirm[".key"] === item["firm"] : true) && !item.return && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true);
      });
      this.resetGST3("outwardSupplies");
      this.invoiceOfFirmGST3.map(function (invoice) {
        var gst = _this3.getGSTtotal(invoice);
        var buyer = null;
        if (invoice.isBuyer) {
          buyer = _this3.buyer[invoice.buyerId];
        } else {
          buyer = _this3.seller[invoice.buyerId];
        }
        var gstType = _this3.calculateGSTInvoice(buyer, invoice);
        if (invoice.isBuyer) {
          // this.outwardSupplies.totalBaseAmount +=
          //   parseFloat(invoice.totalAmount) - gst;
          // this.outwardSupplies.totalInvoiceAmount += parseFloat(
          //   invoice.totalAmount
          // );
          if (invoice.gstType == 'SGST|CGST') {
            _this3.calculateFromProduct("outwardSupplies", "intraState", invoice, true);
            // this.outwardSupplies.CGST += parseFloat(gstType["CGST_val"]);
            // this.outwardSupplies.SGST += parseFloat(gstType["SGST_val"]);
          } else {
            _this3.calculateFromProduct("outwardSupplies", "interState", invoice, false);
            // this.outwardSupplies.IGST += parseFloat(gstType["IGST_val"]);
          }
        }
      });
    },
    calculateFromProduct: function calculateFromProduct(type, subType, invoice, sameState) {
      var _this4 = this;

      invoice.items && invoice.items.map(function (product) {
        switch (product.GST_type) {
          case "EXEMPT":
            {
              _this4[type][subType]["exempted"].totalBaseAmount += parseFloat(product.basicPrice);
              _this4[type][subType]["exempted"].totalInvoiceAmount += parseFloat(product.totlePrice);
              if (sameState) {
                _this4[type][subType]["exempted"].CGST += parseFloat(product.CGST_val);
                _this4[type][subType]["exempted"].SGST += parseFloat(product.SGST_val);
              } else {
                _this4[type][subType]["exempted"].IGST += parseFloat(product.IGST_val);
              }
              break;
            }
          case "NILL":
            {
              _this4[type][subType]["nillrated"].totalBaseAmount += parseFloat(product.basicPrice);
              _this4[type][subType]["nillrated"].totalInvoiceAmount += parseFloat(product.totlePrice);
              if (sameState) {
                _this4[type][subType]["nillrated"].CGST += parseFloat(product.CGST_val);
                _this4[type][subType]["nillrated"].SGST += parseFloat(product.SGST_val);
              } else {
                _this4[type][subType]["nillrated"].IGST += parseFloat(product.IGST_val);
              }
              break;
            }
          case "TAXABLE":
            {
              _this4[type][subType]["taxable"].totalBaseAmount += parseFloat(product.basicPrice);
              _this4[type][subType]["taxable"].totalInvoiceAmount += parseFloat(product.totlePrice);
              if (sameState) {
                _this4[type][subType]["taxable"].CGST += parseFloat(product.CGST_val);
                _this4[type][subType]["taxable"].SGST += parseFloat(product.SGST_val);
              } else {
                _this4[type][subType]["taxable"].IGST += parseFloat(product.IGST_val);
              }
              switch (product.taxableGST_rate) {
                case 3:
                  {
                    _this4[type][subType]["taxable"]["GST_3"].totalBaseAmount += parseFloat(product.basicPrice);
                    _this4[type][subType]["taxable"]["GST_3"].totalInvoiceAmount += parseFloat(product.totlePrice);
                    if (sameState) {
                      _this4[type][subType]["taxable"]["GST_3"].CGST += parseFloat(product.CGST_val);
                      _this4[type][subType]["taxable"]["GST_3"].SGST += parseFloat(product.SGST_val);
                    } else {
                      _this4[type][subType]["taxable"]["GST_3"].IGST += parseFloat(product.IGST_val);
                    }
                    break;
                  }
                case 5:
                  {
                    _this4[type][subType]["taxable"]["GST_5"].totalBaseAmount += parseFloat(product.basicPrice);
                    _this4[type][subType]["taxable"]["GST_5"].totalInvoiceAmount += parseFloat(product.totlePrice);
                    if (sameState) {
                      _this4[type][subType]["taxable"]["GST_5"].CGST += parseFloat(product.CGST_val);
                      _this4[type][subType]["taxable"]["GST_5"].SGST += parseFloat(product.SGST_val);
                    } else {
                      _this4[type][subType]["taxable"]["GST_5"].IGST += parseFloat(product.IGST_val);
                    }
                    break;
                  }
                case 12:
                  {
                    _this4[type][subType]["taxable"]["GST_12"].totalBaseAmount += parseFloat(product.basicPrice);
                    _this4[type][subType]["taxable"]["GST_12"].totalInvoiceAmount += parseFloat(product.totlePrice);
                    if (sameState) {
                      _this4[type][subType]["taxable"]["GST_12"].CGST += parseFloat(product.CGST_val);
                      _this4[type][subType]["taxable"]["GST_12"].SGST += parseFloat(product.SGST_val);
                    } else {
                      _this4[type][subType]["taxable"]["GST_12"].IGST += parseFloat(product.IGST_val);
                    }
                    break;
                  }
                case 18:
                  {

                    _this4[type][subType]["taxable"]["GST_18"].totalBaseAmount += parseFloat(product.basicPrice);
                    _this4[type][subType]["taxable"]["GST_18"].totalInvoiceAmount += parseFloat(product.totlePrice);
                    if (sameState) {
                      _this4[type][subType]["taxable"]["GST_18"].CGST += parseFloat(product.CGST_val);
                      _this4[type][subType]["taxable"]["GST_18"].SGST += parseFloat(product.SGST_val);
                    } else {
                      _this4[type][subType]["taxable"]["GST_18"].IGST += parseFloat(product.IGST_val);
                    }
                    break;
                  }
                case 28:
                  {
                    _this4[type][subType]["taxable"]["GST_28"].totalBaseAmount += parseFloat(product.basicPrice);
                    _this4[type][subType]["taxable"]["GST_28"].totalInvoiceAmount += parseFloat(product.totlePrice);
                    if (sameState) {
                      _this4[type][subType]["taxable"]["GST_28"].CGST += parseFloat(product.CGST_val);
                      _this4[type][subType]["taxable"]["GST_28"].SGST += parseFloat(product.SGST_val);
                    } else {
                      _this4[type][subType]["taxable"]["GST_28"].IGST += parseFloat(product.IGST_val);
                    }
                    break;
                  }
              }
              break;
            }
          case "OTHER":
            {
              _this4[type][subType]["others"].totalBaseAmount += parseFloat(product.basicPrice);
              _this4[type][subType]["others"].totalInvoiceAmount += parseFloat(product.totlePrice);
              if (sameState) {
                _this4[type][subType]["others"].CGST += parseFloat(product.CGST_val);
                _this4[type][subType]["others"].SGST += parseFloat(product.SGST_val);
              } else {
                _this4[type][subType]["others"].IGST += parseFloat(product.IGST_val);
              }
              break;
            }
        }

        _this4[type][subType].totalBaseAmount += parseFloat(product.basicPrice);
        _this4[type][subType].totalInvoiceAmount += parseFloat(product.totlePrice);

        _this4[type].totalBaseAmount += parseFloat(product.basicPrice);
        _this4[type].totalInvoiceAmount += parseFloat(product.totlePrice);
        if (sameState) {
          _this4[type][subType].CGST += parseFloat(product.CGST_val);
          _this4[type][subType].SGST += parseFloat(product.SGST_val);
          _this4[type].CGST += parseFloat(product.CGST_val);
          _this4[type].SGST += parseFloat(product.SGST_val);
        } else {
          _this4[type][subType].IGST += parseFloat(product.IGST_val);
          _this4[type].IGST += parseFloat(product.IGST_val);
        }
      });
    },
    getInvoice: function getInvoice() {
      var _this5 = this;

      var toDate = this.toDate ? new Date(this.toDate).getTime() : null;
      var fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
      var selectedBuyers = this.buyers.filter(function (item) {
        return item["brand"] === _this5.selectedBrand;
      });
      this.invoiceOfFirm = this.invoices.filter(function (item) {
        return item["brand"] === _this5.selectedBrand && item["firm"] === _this5.selectedFirm[".key"] && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true);
      });
      this.reset("B2B_invoices");
      this.reset("B2C_invoices_big");
      this.reset("Export_invoices");
      this.reset("B2C_invoices_small");
      this.reset("Credit_Debit_note_reg");
      this.reset("Credit_Debit_note_unreg");
      selectedBuyers.map(function (buyer) {
        if (buyer.GST_user === "Yes") {
          var B2BInvoices = _this5.invoiceOfFirm.filter(function (item) {
            return item["buyerId"] === buyer[".key"];
          });
          B2BInvoices.map(function (invoice) {
            var gst = _this5.getGSTtotal(invoice);
            var gstType = _this5.calculateGSTInvoice(buyer, invoice);
            _this5.gst1_desc.B2B_invoices.voucherCount += 1;
            _this5.gst1_desc.B2B_invoices.totalBaseAmount += parseFloat(invoice.totalAmount) - gst;
            _this5.gst1_desc.B2B_invoices.totalInvoice += parseFloat(invoice.totalAmount);
            _this5.gst1_desc.B2B_invoices.ICGST += parseFloat(gstType["IGST_val"]), _this5.gst1_desc.B2B_invoices.CGST += parseFloat(gstType["CGST_val"]), _this5.gst1_desc.B2B_invoices.SGST += parseFloat(gstType["SGST_val"]);
            invoice["buyer"] = buyer;
            invoice["IGST_val"] = gstType["IGST_val"];
            invoice["CGST_val"] = gstType["CGST_val"];
            invoice["SGST_val"] = gstType["SGST_val"];
            invoice["basicAmount"] = parseFloat(invoice.totalAmount) - gst;
            _this5.gst1_desc.B2B_invoices.invoices.push(invoice);
            if (buyer.country != 'India') {
              _this5.gst1_desc.Export_invoices.voucherCount = 1;
              _this5.gst1_desc.Export_invoices.totalBaseAmount = parseFloat(invoice.totalAmount) - gst;
              _this5.gst1_desc.Export_invoices.totalInvoice = parseFloat(invoice.totalAmount);
              _this5.gst1_desc.Export_invoices.ICGST = parseFloat(gstType["IGST_val"]), _this5.gst1_desc.Export_invoices.CGST = parseFloat(gstType["CGST_val"]), _this5.gst1_desc.Export_invoices.SGST = parseFloat(gstType["SGST_val"]);
              _this5.gst1_desc.Export_invoices.invoices.push(invoice);
            }
            if (invoice["return"] === true) {
              _this5.gst1_desc.Credit_Debit_note_reg.voucherCount += 1;
              _this5.gst1_desc.Credit_Debit_note_reg.totalBaseAmount += parseFloat(invoice.totalAmount) - gst;
              _this5.gst1_desc.Credit_Debit_note_reg.totalInvoice += parseFloat(invoice.totalAmount);
              _this5.gst1_desc.Credit_Debit_note_reg.ICGST += parseFloat(gstType["IGST_val"]), _this5.gst1_desc.Credit_Debit_note_reg.CGST += parseFloat(gstType["CGST_val"]), _this5.gst1_desc.Credit_Debit_note_reg.SGST += parseFloat(gstType["SGST_val"]);
              invoice["buyer"] = buyer;
              invoice["IGST_val"] = gstType["IGST_val"];
              invoice["CGST_val"] = gstType["CGST_val"];
              invoice["SGST_val"] = gstType["SGST_val"];
              invoice["basicAmount"] = parseFloat(invoice.totalAmount) - gst;
              _this5.gst1_desc.Credit_Debit_note_reg.invoices.push(invoice);
            }
          });
        } else {
          var B2CInvoicesBig = _this5.invoiceOfFirm.filter(function (item) {
            return item["buyerId"] === buyer[".key"] && item["totalAmount"] >= 150000;
          });
          B2CInvoicesBig.map(function (invoice) {
            var gst = _this5.getGSTtotal(invoice);
            var gstType = _this5.calculateGSTInvoice(buyer, invoice);
            _this5.gst1_desc.B2C_invoices_big.voucherCount += 1;
            _this5.gst1_desc.B2C_invoices_big.totalBaseAmount += parseFloat(invoice.totalAmount) - gst;
            _this5.gst1_desc.B2C_invoices_big.totalInvoice += parseFloat(invoice.totalAmount);
            _this5.gst1_desc.B2C_invoices_big.ICGST += parseFloat(gstType["IGST_val"]), _this5.gst1_desc.B2C_invoices_big.CGST += parseFloat(gstType["CGST_val"]), _this5.gst1_desc.B2C_invoices_big.SGST += parseFloat(gstType["SGST_val"]);
            invoice["buyer"] = buyer;
            invoice["IGST_val"] = gstType["IGST_val"];
            invoice["CGST_val"] = gstType["CGST_val"];
            invoice["SGST_val"] = gstType["SGST_val"];
            invoice["basicAmount"] = parseFloat(invoice.totalAmount) - gst;
            _this5.gst1_desc.B2C_invoices_big.invoices.push(invoice);

            if (invoice["return"] === true) {
              _this5.gst1_desc.Credit_Debit_note_unreg.voucherCount += 1;
              _this5.gst1_desc.Credit_Debit_note_unreg.totalBaseAmount += parseFloat(invoice.totalAmount) - gst;
              _this5.gst1_desc.Credit_Debit_note_unreg.totalInvoice += parseFloat(invoice.totalAmount);
              _this5.gst1_desc.Credit_Debit_note_unreg.ICGST += parseFloat(gstType["IGST_val"]), _this5.gst1_desc.Credit_Debit_note_unreg.CGST += parseFloat(gstType["CGST_val"]), _this5.gst1_desc.Credit_Debit_note_unreg.SGST += parseFloat(gstType["SGST_val"]);
              invoice["buyer"] = buyer;
              invoice["IGST_val"] = gstType["IGST_val"];
              invoice["CGST_val"] = gstType["CGST_val"];
              invoice["SGST_val"] = gstType["SGST_val"];
              invoice["basicAmount"] = parseFloat(invoice.totalAmount) - gst;
              _this5.gst1_desc.Credit_Debit_note_unreg.invoices.push(invoice);
            }
          });
          var B2CInvoicesSmall = _this5.invoiceOfFirm.filter(function (item) {
            return item["buyerId"] === buyer[".key"] && item["totalAmount"] < 150000;
          });
          B2CInvoicesSmall.map(function (invoice) {
            var gst = _this5.getGSTtotal(invoice);
            var gstType = _this5.calculateGSTInvoice(buyer, invoice);
            _this5.gst1_desc.B2C_invoices_small.voucherCount += 1;
            _this5.gst1_desc.B2C_invoices_small.totalBaseAmount += parseFloat(invoice.totalAmount) - gst;
            _this5.gst1_desc.B2C_invoices_small.totalInvoice += parseFloat(invoice.totalAmount);
            _this5.gst1_desc.B2C_invoices_small.ICGST += parseFloat(gstType["IGST_val"]), _this5.gst1_desc.B2C_invoices_small.CGST += parseFloat(gstType["CGST_val"]), _this5.gst1_desc.B2C_invoices_small.SGST += parseFloat(gstType["SGST_val"]);
            invoice["buyer"] = buyer;
            invoice["IGST_val"] = gstType["IGST_val"];
            invoice["CGST_val"] = gstType["CGST_val"];
            invoice["SGST_val"] = gstType["SGST_val"];
            invoice["basicAmount"] = parseFloat(invoice.totalAmount) - gst;
            _this5.gst1_desc.B2C_invoices_small.invoices.push(invoice);

            if (invoice["return"] === true) {
              _this5.gst1_desc.Credit_Debit_note_unreg.voucherCount += 1;
              _this5.gst1_desc.Credit_Debit_note_unreg.totalBaseAmount += parseFloat(invoice.totalAmount) - gst;
              _this5.gst1_desc.Credit_Debit_note_unreg.totalInvoice += parseFloat(invoice.totalAmount);
              _this5.gst1_desc.Credit_Debit_note_unreg.ICGST += parseFloat(gstType["IGST_val"]), _this5.gst1_desc.Credit_Debit_note_unreg.CGST += parseFloat(gstType["CGST_val"]), _this5.gst1_desc.Credit_Debit_note_unreg.SGST += parseFloat(gstType["SGST_val"]);
              invoice["buyer"] = buyer;
              invoice["IGST_val"] = gstType["IGST_val"];
              invoice["CGST_val"] = gstType["CGST_val"];
              invoice["SGST_val"] = gstType["SGST_val"];
              invoice["basicAmount"] = parseFloat(invoice.totalAmount) - gst;
              _this5.gst1_desc.Credit_Debit_note_unreg.invoices.push(invoice);
            }
          });
          _this5.reset("HSN_SAC_Summary");
          var HSN_SAC_Summary = {};
          _this5.invoiceOfFirm.map(function (invoice) {
            invoice.items && invoice.items.map(function (item) {
              if (item.HSN_code && !HSN_SAC_Summary[item.HSN_code]) {
                HSN_SAC_Summary[item.HSN_code] = {
                  HSN_code: item.HSN_code,
                  description: '',
                  UQC: '',
                  quantity: 0,
                  totalAmount: 0,
                  basicAmount: 0,
                  IGST: 0,
                  CGST: 0,
                  SGST: 0,
                  CESS: 0
                };
              }
              if (item.HSN_code) {
                HSN_SAC_Summary[item.HSN_code].quantity += parseInt(item.quantity);
                HSN_SAC_Summary[item.HSN_code].totalAmount += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(item.totlePrice);
                HSN_SAC_Summary[item.HSN_code].basicAmount += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(item.basicPrice);
                HSN_SAC_Summary[item.HSN_code].IGST += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(item.IGST_val);
                HSN_SAC_Summary[item.HSN_code].CGST += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(item.CGST_val);
                HSN_SAC_Summary[item.HSN_code].SGST += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(item.SGST_val);

                _this5.gst1_desc.HSN_SAC_Summary.voucherCount += 1;
                _this5.gst1_desc.HSN_SAC_Summary.totalBaseAmount += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(item.basicPrice);
                _this5.gst1_desc.HSN_SAC_Summary.ICGST += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(item.IGST_val);
                _this5.gst1_desc.HSN_SAC_Summary.CGST += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(item.CGST_val);
                _this5.gst1_desc.HSN_SAC_Summary.SGST += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(item.SGST_val);
                _this5.gst1_desc.HSN_SAC_Summary.totalInvoice += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(item.totlePrice);
              }
            });
          });
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(HSN_SAC_Summary).forEach(function (key) {
            _this5.gst1_desc.HSN_SAC_Summary.invoices.push(HSN_SAC_Summary[key]);
          });
        }
      });
      //this.setData();
    },

    // setData() {
    //   let toDate = this.toDate ? new Date(this.toDate).getTime() : null;
    //   let fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
    //   this.invoiceOfFirm.map(invoice => {});
    // },
    generateAddress: function generateAddress(user) {
      var address = "";
      if (user.block) {
        address = "" + user.block;
      }
      if (user.village) {
        address = "" + (address ? address + " - " : "") + user.village;
      }
      if (user.tehsil) {
        address = "" + (address ? address + " - " : "") + user.tehsil;
      }
      if (user.state) {
        address = "" + (address ? address + " - " : "") + user.state;
      }
      return address;
    },
    formatDate: function formatDate(date) {
      var d = new Date(date),
          month = "" + (d.getMonth() + 1),
          day = "" + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    }
  },
  watch: {
    selectedFirm: function selectedFirm(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.getInvoice();
        this.getInvoiceGST3();
        //this.setData();
      }
    },
    toDate: function toDate(newVal, oldVal) {
      if (oldVal !== newVal && this.selectedFirm) {
        this.getInvoice();
        this.getInvoiceGST3();
        //this.setData();
      }
    },
    fromDate: function fromDate(newVal, oldVal) {
      if (oldVal !== newVal && this.selectedFirm) {
        this.getInvoice();
        this.getInvoiceGST3();
        // this.setData();
      }
    },
    selectedMonth: function selectedMonth(newVal, oldVal) {
      var selectedMonth = newVal;
      var dateFrom = new Date(this.finYear.start);
      var dateTo = new Date(this.finYear.end);
      var fullYear = dateFrom.getFullYear();
      if (selectedMonth < 3) {
        fullYear = dateTo.getFullYear();
      }
      this.fromDate = this.formatDate(new Date(fullYear, selectedMonth, 1).getTime());
      this.toDate = this.formatDate(new Date(fullYear, selectedMonth + 1, 0).getTime());
    },
    selectedQuarter: function selectedQuarter(newVal, oldVal) {
      var selectedQuarter = newVal;
      var selectedMonthFrom = null;
      var selectedMonthTo = null;
      var dateFrom = new Date(this.finYear.start);
      var dateTo = new Date(this.finYear.end);
      var fullYear = dateFrom.getFullYear();
      switch (selectedQuarter) {
        case 1:
          {
            selectedMonthFrom = 3;
            selectedMonthTo = 5;
            break;
          }
        case 2:
          {
            selectedMonthFrom = 6;
            selectedMonthTo = 8;
            break;
          }
        case 3:
          {
            selectedMonthFrom = 9;
            selectedMonthTo = 11;
            break;
          }
        case 4:
          {
            selectedMonthFrom = 0;
            selectedMonthTo = 2;
            fullYear = dateTo.getFullYear();
            break;
          }
      }
      this.fromDate = this.formatDate(new Date(fullYear, selectedMonthFrom, 1).getTime());
      this.toDate = this.formatDate(new Date(fullYear, selectedMonthTo + 1, 0).getTime());
    }
  }
});

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_pdfmake__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_excelExport__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_xlsx__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_xlsx__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      selectedFirm: null,
      toDate: null,
      fromDate: null,
      datepickerFrom: null,
      datepickerTo: null,
      inwardSupplies: {},
      outwardSupplies: {},
      tab2: {
        row_3_1_expand: { expand: false },
        row_4_expand: { expand: false },
        row_5_expand: { expand: false }
      }
    };
  },
  created: function created() {
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("buyer", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("seller", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    this.reset('inwardSupplies');
    this.reset('outwardSupplies');
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand"]), {
    firmsByBrand1: function firmsByBrand1() {
      var _this = this;

      return this.firms.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      });
    },

    // current brands firm list
    firmsByBrand: function firmsByBrand() {
      var _this2 = this;

      // return selected brand firms
      var firmsB = this.firms.filter(function (item) {
        return item['brand'] === _this2.selectedBrand;
      });
      firmsB.map(function (item) {
        if (item.defaultFirm) {
          _this2.selectedFirm = item;
        }
      });
      return firmsB;
    }
  }),
  methods: {
    toggle: function toggle(item) {
      item.expand = !item.expand;
    },
    calculateGSTInvoice: function calculateGSTInvoice(currentUser, invoice) {
      var SGST_val = 0;
      var CGST_val = 0;
      var IGST_val = 0;
      invoice && invoice.items && invoice.items.map(function (item, index) {
        SGST_val += parseFloat(item["SGST_val"]);
        CGST_val += parseFloat(item["CGST_val"]);
        IGST_val += parseFloat(item["IGST_val"]);
      });
      return { SGST_val: SGST_val, CGST_val: CGST_val, IGST_val: IGST_val };
    },
    reset: function reset(obj) {
      this[obj] = {
        totalBaseAmount: 0,
        IGST: 0,
        CGST: 0,
        SGST: 0,
        CESS: 0,
        totalInvoiceAmount: 0,
        expand: false,
        intraState: {
          totalBaseAmount: 0,
          IGST: 0,
          CGST: 0,
          SGST: 0,
          CESS: 0,
          totalInvoiceAmount: 0,
          taxable: {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0,
            expand: false,
            GST_3: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_5: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_12: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_18: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_28: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            }
          },
          exempted: {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0
          },
          nillrated: {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0
          },
          others: {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0
          }
        },
        interState: {
          totalBaseAmount: 0,
          IGST: 0,
          CGST: 0,
          SGST: 0,
          CESS: 0,
          totalInvoiceAmount: 0,
          taxable: {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0,
            expand: false,
            GST_3: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_5: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_12: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_18: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_28: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            }
          },
          exempted: {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0
          },
          nillrated: {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0
          },
          others: {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0
          }
        }
      };
    },
    getGSTtotal: function getGSTtotal(item) {
      var GSTTotal = 0;
      item && item.items && item.items.map(function (item) {
        GSTTotal += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
      });
      return GSTTotal;
    },
    getInvoice: function getInvoice() {
      var _this3 = this;

      var invoiceOfFirm = this.invoices.filter(function (item) {
        return item["brand"] === _this3.selectedBrand && (_this3.selectedFirm ? _this3.selectedFirm[".key"] === item["firm"] : true);
      });
      this.reset('inwardSupplies');
      this.reset('outwardSupplies');
      var toDate = this.toDate ? new Date(this.toDate).getTime() : null;
      var fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
      invoiceOfFirm.map(function (invoice) {
        if (!invoice.return && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true)) {
          var gst = _this3.getGSTtotal(invoice);
          var buyer = null;
          if (invoice.isBuyer) {
            buyer = _this3.buyer[invoice.buyerId];
          } else {
            buyer = _this3.seller[invoice.buyerId];
          }
          var gstType = _this3.calculateGSTInvoice(buyer, invoice);
          if (invoice.isBuyer) {
            _this3.outwardSupplies.totalBaseAmount += parseFloat(invoice.totalAmount) - gst;
            _this3.outwardSupplies.totalInvoiceAmount += parseFloat(invoice.totalAmount);
            _this3.outwardSupplies.IGST += parseFloat(gstType["IGST_val"]);
            _this3.outwardSupplies.CGST += parseFloat(gstType["CGST_val"]);
            _this3.outwardSupplies.SGST += parseFloat(gstType["SGST_val"]);
            if (buyer && _this3.selectedFirm.state == buyer.state) {
              _this3.calculateFromProduct('outwardSupplies', 'intraState', invoice.items, true);
            } else {
              _this3.calculateFromProduct('outwardSupplies', 'interState', invoice.items, false);
            }
          } else {
            _this3.inwardSupplies.totalBaseAmount += parseFloat(invoice.totalAmount) - gst;
            _this3.inwardSupplies.totalInvoiceAmount += parseFloat(invoice.totalAmount);
            _this3.inwardSupplies.IGST += parseFloat(gstType["IGST_val"]);
            _this3.inwardSupplies.CGST += parseFloat(gstType["CGST_val"]);
            _this3.inwardSupplies.SGST += parseFloat(gstType["SGST_val"]);
            if (buyer && _this3.selectedFirm.state == buyer.state) {
              _this3.calculateFromProduct('inwardSupplies', 'intraState', invoice.items, true);
            } else {
              _this3.calculateFromProduct('inwardSupplies', 'interState', invoice.items, false);
            }
          }
        }
      });
    },
    printGST3: function printGST3() {
      var firm = this.selectedFirm;
      firm.address = this.generateAddress(firm);
      var doc = Object(__WEBPACK_IMPORTED_MODULE_3__utils_pdfmake__["o" /* convertToPDFGST_3 */])({
        firm: firm,
        inwardSupplies: this.inwardSupplies,
        outwardSupplies: this.outwardSupplies
      });
      pdfMake.createPdf(doc).download();
    },
    onexport: function onexport() {
      var firm = this.selectedFirm;
      firm.address = this.generateAddress(firm);
      var wb = Object(__WEBPACK_IMPORTED_MODULE_4__utils_excelExport__["c" /* convertToExcelGST_3 */])({ selectedFirm: firm, inwardSupplies: this.inwardSupplies, outwardSupplies: this.outwardSupplies });
      __WEBPACK_IMPORTED_MODULE_5_xlsx___default.a.writeFile(wb, 'GST3_' + new Date().getTime() + '.xlsx'); // name of the file is 'book.xlsx'
    },
    generateAddress: function generateAddress(user) {
      var address = "";
      if (user.block) {
        address = "" + user.block;
      }
      if (user.village) {
        address = "" + (address ? address + ", " : "") + user.village;
      }
      if (user.tehsil) {
        address = "" + (address ? address + ", " : "") + user.tehsil;
      }
      if (user.state) {
        address = "" + (address ? address + ", " : "") + user.state;
      }
      return address;
    },
    calculateFromProduct: function calculateFromProduct(type, subType, products, sameState) {
      var _this4 = this;

      products && products.map(function (product) {
        switch (product.GST_type) {
          case 'EXEMPT':
            {
              _this4[type][subType]['exempted'].totalBaseAmount += parseFloat(product.basicPrice);
              _this4[type][subType]['exempted'].totalInvoiceAmount += parseFloat(product.totlePrice);
              if (sameState) {
                _this4[type][subType]['exempted'].CGST += parseFloat(product.GSTValue / 2);
                _this4[type][subType]['exempted'].SGST += parseFloat(product.GSTValue / 2);
              } else {
                _this4[type][subType]['exempted'].IGST += parseFloat(product.GSTValue);
              }
              break;
            };
          case 'NILL':
            {
              _this4[type][subType]['nillrated'].totalBaseAmount += parseFloat(product.basicPrice);
              _this4[type][subType]['nillrated'].totalInvoiceAmount += parseFloat(product.totlePrice);
              if (sameState) {
                _this4[type][subType]['nillrated'].CGST += parseFloat(product.GSTValue / 2);
                _this4[type][subType]['nillrated'].SGST += parseFloat(product.GSTValue / 2);
              } else {
                _this4[type][subType]['nillrated'].IGST += parseFloat(product.GSTValue);
              }
              break;
            };
          case 'TAXABLE':
            {
              _this4[type][subType]['taxable'].totalBaseAmount += parseFloat(product.basicPrice);
              _this4[type][subType]['taxable'].totalInvoiceAmount += parseFloat(product.totlePrice);
              if (sameState) {
                _this4[type][subType]['taxable'].CGST += parseFloat(product.GSTValue / 2);
                _this4[type][subType]['taxable'].SGST += parseFloat(product.GSTValue / 2);
              } else {
                _this4[type][subType]['taxable'].IGST += parseFloat(product.GSTValue);
              }
              switch (product.taxableGST_rate) {
                case 3:
                  {
                    _this4[type][subType]["taxable"]["GST_3"].totalBaseAmount += parseFloat(product.basicPrice);
                    _this4[type][subType]["taxable"]["GST_3"].totalInvoiceAmount += parseFloat(product.totlePrice);
                    if (sameState) {
                      _this4[type][subType]["taxable"]["GST_3"].CGST += parseFloat(product.GSTValue / 2);
                      _this4[type][subType]["taxable"]["GST_3"].SGST += parseFloat(product.GSTValue / 2);
                    } else {
                      _this4[type][subType]["taxable"]["GST_3"].IGST += parseFloat(product.GSTValue);
                    }
                    break;
                  }
                case 5:
                  {
                    _this4[type][subType]["taxable"]["GST_5"].totalBaseAmount += parseFloat(product.basicPrice);
                    _this4[type][subType]["taxable"]["GST_5"].totalInvoiceAmount += parseFloat(product.totlePrice);
                    if (sameState) {
                      _this4[type][subType]["taxable"]["GST_5"].CGST += parseFloat(product.GSTValue / 2);
                      _this4[type][subType]["taxable"]["GST_5"].SGST += parseFloat(product.GSTValue / 2);
                    } else {
                      _this4[type][subType]["taxable"]["GST_5"].IGST += parseFloat(product.GSTValue);
                    }
                    break;
                  }
                case 12:
                  {
                    _this4[type][subType]["taxable"]["GST_12"].totalBaseAmount += parseFloat(product.basicPrice);
                    _this4[type][subType]["taxable"]["GST_12"].totalInvoiceAmount += parseFloat(product.totlePrice);
                    if (sameState) {
                      _this4[type][subType]["taxable"]["GST_12"].CGST += parseFloat(product.GSTValue / 2);
                      _this4[type][subType]["taxable"]["GST_12"].SGST += parseFloat(product.GSTValue / 2);
                    } else {
                      _this4[type][subType]["taxable"]["GST_12"].IGST += parseFloat(product.GSTValue);
                    }
                    break;
                  }
                case 18:
                  {
                    _this4[type][subType]["taxable"]["GST_18"].totalBaseAmount += parseFloat(product.basicPrice);
                    _this4[type][subType]["taxable"]["GST_18"].totalInvoiceAmount += parseFloat(product.totlePrice);
                    if (sameState) {
                      _this4[type][subType]["taxable"]["GST_18"].CGST += parseFloat(product.GSTValue / 2);
                      _this4[type][subType]["taxable"]["GST_18"].SGST += parseFloat(product.GSTValue / 2);
                    } else {
                      _this4[type][subType]["taxable"]["GST_18"].IGST += parseFloat(product.GSTValue);
                    }
                    break;
                  }
                case 28:
                  {
                    _this4[type][subType]["taxable"]["GST_28"].totalBaseAmount += parseFloat(product.basicPrice);
                    _this4[type][subType]["taxable"]["GST_28"].totalInvoiceAmount += parseFloat(product.totlePrice);
                    if (sameState) {
                      _this4[type][subType]["taxable"]["GST_28"].CGST += parseFloat(product.GSTValue / 2);
                      _this4[type][subType]["taxable"]["GST_28"].SGST += parseFloat(product.GSTValue / 2);
                    } else {
                      _this4[type][subType]["taxable"]["GST_28"].IGST += parseFloat(product.GSTValue);
                    }
                    break;
                  }
              }
              break;
            };
          case 'OTHER':
            {
              _this4[type][subType]['others'].totalBaseAmount += parseFloat(product.basicPrice);
              _this4[type][subType]['others'].totalInvoiceAmount += parseFloat(product.totlePrice);
              if (sameState) {
                _this4[type][subType]['others'].CGST += parseFloat(product.GSTValue / 2);
                _this4[type][subType]['others'].SGST += parseFloat(product.GSTValue / 2);
              } else {
                _this4[type][subType]['others'].IGST += parseFloat(product.GSTValue);
              }
              break;
            };
        }
        _this4[type][subType].totalBaseAmount += parseFloat(product.basicPrice);
        _this4[type][subType].totalInvoiceAmount += parseFloat(product.totlePrice);
        if (sameState) {
          _this4[type][subType].CGST += parseFloat(product.GSTValue / 2);
          _this4[type][subType].SGST += parseFloat(product.GSTValue / 2);
        } else {
          _this4[type][subType].IGST += parseFloat(product.GSTValue);
        }
      });
    }
  },
  watch: {
    selectedFirm: function selectedFirm(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.getInvoice();
        //this.setData();
      }
    },
    toDate: function toDate(newVal, oldVal) {
      if (oldVal !== newVal && this.selectedFirm) {
        this.getInvoice();
        //this.setData();
      }
    },
    fromDate: function fromDate(newVal, oldVal) {
      if (oldVal !== newVal && this.selectedFirm) {
        this.getInvoice();
        // this.setData();
      }
    }
  }
});

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_pdfmake__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_excelExport__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_xlsx__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_xlsx__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      filterType: 'Custom',
      months: [{
        text: 'January',
        value: 0
      }, {
        text: 'February',
        value: 1
      }, {
        text: 'March',
        value: 2
      }, {
        text: 'April',
        value: 3
      }, {
        text: 'May',
        value: 4
      }, {
        text: 'June',
        value: 5
      }, {
        text: 'July',
        value: 6
      }, {
        text: 'August',
        value: 7
      }, {
        text: 'September',
        value: 8
      }, {
        text: 'October',
        value: 9
      }, {
        text: 'November',
        value: 10
      }, {
        text: 'December',
        value: 11
      }],
      selectedMonth: null,
      selectedQuarter: null,
      quarters: [{
        text: '1 April - May - 30 June',
        value: 1
      }, {
        text: '1 July - Aug - 30 Sept',
        value: 2
      }, {
        text: '1 Oct  - Nov - 31 Dec',
        value: 3
      }, {
        text: '1 Jan  -  March - 31 March',
        value: 4
      }],
      selectedFirm: null,
      toDate: null,
      fromDate: null,
      datepickerFrom: null,
      datepickerTo: null,
      inwardSupplies: {},
      outwardSupplies: {},
      tab2: {
        row_3_1_expand: { expand: false },
        row_4_expand: { expand: false },
        row_5_expand: { expand: false }
      }
    };
  },
  created: function created() {
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brandFinYear').equalTo(this.brandFinYear));
    this.$bindAsObject("buyer", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("seller", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    this.reset('inwardSupplies');
    this.reset('outwardSupplies');
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "brandFinYear"]), {
    firmsByBrand1: function firmsByBrand1() {
      var _this = this;

      return this.firms.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      });
    },

    // current brands firm list
    firmsByBrand: function firmsByBrand() {
      var _this2 = this;

      // return selected brand firms
      var firmsB = this.firms.filter(function (item) {
        return item['brand'] === _this2.selectedBrand;
      });
      firmsB.map(function (item) {
        if (item.defaultFirm) {
          _this2.selectedFirm = item;
        }
      });
      return firmsB;
    }
  }),
  methods: {
    toggle: function toggle(item) {
      item.expand = !item.expand;
    },
    calculateGSTInvoice: function calculateGSTInvoice(currentUser, invoice) {
      var SGST_val = 0;
      var CGST_val = 0;
      var IGST_val = 0;
      invoice && invoice.items && invoice.items.map(function (item, index) {
        SGST_val += parseFloat(item["SGST_val"]);
        CGST_val += parseFloat(item["CGST_val"]);
        IGST_val += parseFloat(item["IGST_val"]);
      });
      return { SGST_val: SGST_val, CGST_val: CGST_val, IGST_val: IGST_val };
    },
    reset: function reset(obj) {
      this[obj] = {
        totalBaseAmount: 0,
        IGST: 0,
        CGST: 0,
        SGST: 0,
        CESS: 0,
        totalInvoiceAmount: 0,
        expand: false,
        intraState: {
          totalBaseAmount: 0,
          IGST: 0,
          CGST: 0,
          SGST: 0,
          CESS: 0,
          totalInvoiceAmount: 0,
          taxable: {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0,
            expand: false,
            GST_3: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_5: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_12: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_18: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_28: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            }
          },
          exempted: {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0
          },
          nillrated: {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0
          },
          others: {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0
          }
        },
        interState: {
          totalBaseAmount: 0,
          IGST: 0,
          CGST: 0,
          SGST: 0,
          CESS: 0,
          totalInvoiceAmount: 0,
          taxable: {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0,
            expand: false,
            GST_3: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_5: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_12: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_18: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            },
            GST_28: {
              totalBaseAmount: 0,
              IGST: 0,
              CGST: 0,
              SGST: 0,
              CESS: 0,
              totalInvoiceAmount: 0
            }
          },
          exempted: {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0
          },
          nillrated: {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0
          },
          others: {
            totalBaseAmount: 0,
            IGST: 0,
            CGST: 0,
            SGST: 0,
            CESS: 0,
            totalInvoiceAmount: 0
          }
        }
      };
    },
    getGSTtotal: function getGSTtotal(item) {
      var GSTTotal = 0;
      item && item.items && item.items.map(function (item) {
        GSTTotal += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
      });
      return GSTTotal;
    },
    getInvoice: function getInvoice() {
      var _this3 = this;

      var invoiceOfFirm = this.invoices.filter(function (item) {
        return item["brand"] === _this3.selectedBrand && (_this3.selectedFirm ? _this3.selectedFirm[".key"] === item["firm"] : true);
      });
      this.reset('inwardSupplies');
      this.reset('outwardSupplies');
      var toDate = this.toDate ? new Date(this.toDate).getTime() : null;
      var fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
      invoiceOfFirm.map(function (invoice) {
        if (!invoice.return && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true)) {
          var gst = _this3.getGSTtotal(invoice);
          var buyer = null;
          if (invoice.isBuyer) {
            buyer = _this3.buyer[invoice.buyerId];
          } else {
            buyer = _this3.seller[invoice.buyerId];
          }
          var gstType = _this3.calculateGSTInvoice(buyer, invoice);
          if (invoice.isBuyer) {
            _this3.outwardSupplies.totalBaseAmount += parseFloat(invoice.totalAmount) - gst;
            _this3.outwardSupplies.totalInvoiceAmount += parseFloat(invoice.totalAmount);
            _this3.outwardSupplies.IGST += parseFloat(gstType["IGST_val"]);
            _this3.outwardSupplies.CGST += parseFloat(gstType["CGST_val"]);
            _this3.outwardSupplies.SGST += parseFloat(gstType["SGST_val"]);
            if (buyer && _this3.selectedFirm.state == buyer.state) {
              _this3.calculateFromProduct('outwardSupplies', 'intraState', invoice.items, true);
            } else {
              _this3.calculateFromProduct('outwardSupplies', 'interState', invoice.items, false);
            }
          } else {
            _this3.inwardSupplies.totalBaseAmount += parseFloat(invoice.totalAmount) - gst;
            _this3.inwardSupplies.totalInvoiceAmount += parseFloat(invoice.totalAmount);
            _this3.inwardSupplies.IGST += parseFloat(gstType["IGST_val"]);
            _this3.inwardSupplies.CGST += parseFloat(gstType["CGST_val"]);
            _this3.inwardSupplies.SGST += parseFloat(gstType["SGST_val"]);
            if (buyer && _this3.selectedFirm.state == buyer.state) {
              _this3.calculateFromProduct('inwardSupplies', 'intraState', invoice.items, true);
            } else {
              _this3.calculateFromProduct('inwardSupplies', 'interState', invoice.items, false);
            }
          }
        }
      });
    },
    printGST3: function printGST3() {
      var firm = this.selectedFirm;
      firm.address = this.generateAddress(firm);
      var doc = Object(__WEBPACK_IMPORTED_MODULE_3__utils_pdfmake__["o" /* convertToPDFGST_3 */])({
        firm: firm,
        inwardSupplies: this.inwardSupplies,
        outwardSupplies: this.outwardSupplies
      });
      pdfMake.createPdf(doc).download();
    },
    onexport: function onexport() {
      var firm = this.selectedFirm;
      firm.address = this.generateAddress(firm);
      var wb = Object(__WEBPACK_IMPORTED_MODULE_4__utils_excelExport__["c" /* convertToExcelGST_3 */])({ selectedFirm: firm, inwardSupplies: this.inwardSupplies, outwardSupplies: this.outwardSupplies });
      __WEBPACK_IMPORTED_MODULE_5_xlsx___default.a.writeFile(wb, 'GST3_' + new Date().getTime() + '.xlsx'); // name of the file is 'book.xlsx'
    },
    generateAddress: function generateAddress(user) {
      var address = "";
      if (user.block) {
        address = "" + user.block;
      }
      if (user.village) {
        address = "" + (address ? address + ", " : "") + user.village;
      }
      if (user.tehsil) {
        address = "" + (address ? address + ", " : "") + user.tehsil;
      }
      if (user.state) {
        address = "" + (address ? address + ", " : "") + user.state;
      }
      return address;
    },
    calculateFromProduct: function calculateFromProduct(type, subType, products, sameState) {
      var _this4 = this;

      products && products.map(function (product) {
        switch (product.GST_type) {
          case 'EXEMPT':
            {
              _this4[type][subType]['exempted'].totalBaseAmount += parseFloat(product.basicPrice);
              _this4[type][subType]['exempted'].totalInvoiceAmount += parseFloat(product.totlePrice);
              if (sameState) {
                _this4[type][subType]['exempted'].CGST += parseFloat(product.GSTValue / 2);
                _this4[type][subType]['exempted'].SGST += parseFloat(product.GSTValue / 2);
              } else {
                _this4[type][subType]['exempted'].IGST += parseFloat(product.GSTValue);
              }
              break;
            };
          case 'NILL':
            {
              _this4[type][subType]['nillrated'].totalBaseAmount += parseFloat(product.basicPrice);
              _this4[type][subType]['nillrated'].totalInvoiceAmount += parseFloat(product.totlePrice);
              if (sameState) {
                _this4[type][subType]['nillrated'].CGST += parseFloat(product.GSTValue / 2);
                _this4[type][subType]['nillrated'].SGST += parseFloat(product.GSTValue / 2);
              } else {
                _this4[type][subType]['nillrated'].IGST += parseFloat(product.GSTValue);
              }
              break;
            };
          case 'TAXABLE':
            {
              _this4[type][subType]['taxable'].totalBaseAmount += parseFloat(product.basicPrice);
              _this4[type][subType]['taxable'].totalInvoiceAmount += parseFloat(product.totlePrice);
              if (sameState) {
                _this4[type][subType]['taxable'].CGST += parseFloat(product.GSTValue / 2);
                _this4[type][subType]['taxable'].SGST += parseFloat(product.GSTValue / 2);
              } else {
                _this4[type][subType]['taxable'].IGST += parseFloat(product.GSTValue);
              }
              switch (product.taxableGST_rate) {
                case 3:
                  {
                    _this4[type][subType]["taxable"]["GST_3"].totalBaseAmount += parseFloat(product.basicPrice);
                    _this4[type][subType]["taxable"]["GST_3"].totalInvoiceAmount += parseFloat(product.totlePrice);
                    if (sameState) {
                      _this4[type][subType]["taxable"]["GST_3"].CGST += parseFloat(product.GSTValue / 2);
                      _this4[type][subType]["taxable"]["GST_3"].SGST += parseFloat(product.GSTValue / 2);
                    } else {
                      _this4[type][subType]["taxable"]["GST_3"].IGST += parseFloat(product.GSTValue);
                    }
                    break;
                  }
                case 5:
                  {
                    _this4[type][subType]["taxable"]["GST_5"].totalBaseAmount += parseFloat(product.basicPrice);
                    _this4[type][subType]["taxable"]["GST_5"].totalInvoiceAmount += parseFloat(product.totlePrice);
                    if (sameState) {
                      _this4[type][subType]["taxable"]["GST_5"].CGST += parseFloat(product.GSTValue / 2);
                      _this4[type][subType]["taxable"]["GST_5"].SGST += parseFloat(product.GSTValue / 2);
                    } else {
                      _this4[type][subType]["taxable"]["GST_5"].IGST += parseFloat(product.GSTValue);
                    }
                    break;
                  }
                case 12:
                  {
                    _this4[type][subType]["taxable"]["GST_12"].totalBaseAmount += parseFloat(product.basicPrice);
                    _this4[type][subType]["taxable"]["GST_12"].totalInvoiceAmount += parseFloat(product.totlePrice);
                    if (sameState) {
                      _this4[type][subType]["taxable"]["GST_12"].CGST += parseFloat(product.GSTValue / 2);
                      _this4[type][subType]["taxable"]["GST_12"].SGST += parseFloat(product.GSTValue / 2);
                    } else {
                      _this4[type][subType]["taxable"]["GST_12"].IGST += parseFloat(product.GSTValue);
                    }
                    break;
                  }
                case 18:
                  {
                    _this4[type][subType]["taxable"]["GST_18"].totalBaseAmount += parseFloat(product.basicPrice);
                    _this4[type][subType]["taxable"]["GST_18"].totalInvoiceAmount += parseFloat(product.totlePrice);
                    if (sameState) {
                      _this4[type][subType]["taxable"]["GST_18"].CGST += parseFloat(product.GSTValue / 2);
                      _this4[type][subType]["taxable"]["GST_18"].SGST += parseFloat(product.GSTValue / 2);
                    } else {
                      _this4[type][subType]["taxable"]["GST_18"].IGST += parseFloat(product.GSTValue);
                    }
                    break;
                  }
                case 28:
                  {
                    _this4[type][subType]["taxable"]["GST_28"].totalBaseAmount += parseFloat(product.basicPrice);
                    _this4[type][subType]["taxable"]["GST_28"].totalInvoiceAmount += parseFloat(product.totlePrice);
                    if (sameState) {
                      _this4[type][subType]["taxable"]["GST_28"].CGST += parseFloat(product.GSTValue / 2);
                      _this4[type][subType]["taxable"]["GST_28"].SGST += parseFloat(product.GSTValue / 2);
                    } else {
                      _this4[type][subType]["taxable"]["GST_28"].IGST += parseFloat(product.GSTValue);
                    }
                    break;
                  }
              }
              break;
            };
          case 'OTHER':
            {
              _this4[type][subType]['others'].totalBaseAmount += parseFloat(product.basicPrice);
              _this4[type][subType]['others'].totalInvoiceAmount += parseFloat(product.totlePrice);
              if (sameState) {
                _this4[type][subType]['others'].CGST += parseFloat(product.GSTValue / 2);
                _this4[type][subType]['others'].SGST += parseFloat(product.GSTValue / 2);
              } else {
                _this4[type][subType]['others'].IGST += parseFloat(product.GSTValue);
              }
              break;
            };
        }
        _this4[type][subType].totalBaseAmount += parseFloat(product.basicPrice);
        _this4[type][subType].totalInvoiceAmount += parseFloat(product.totlePrice);
        if (sameState) {
          _this4[type][subType].CGST += parseFloat(product.GSTValue / 2);
          _this4[type][subType].SGST += parseFloat(product.GSTValue / 2);
        } else {
          _this4[type][subType].IGST += parseFloat(product.GSTValue);
        }
      });
    }
  },
  watch: {
    selectedFirm: function selectedFirm(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.getInvoice();
        //this.setData();
      }
    },
    toDate: function toDate(newVal, oldVal) {
      if (oldVal !== newVal && this.selectedFirm) {
        this.getInvoice();
        //this.setData();
      }
    },
    fromDate: function fromDate(newVal, oldVal) {
      if (oldVal !== newVal && this.selectedFirm) {
        this.getInvoice();
        // this.setData();
      }
    }
  }
});

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_pdf_reports_transaction_reports__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_luxon__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__normalInvoice__ = __webpack_require__(1444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__automaticInvoice__ = __webpack_require__(1446);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])("Buyer")["mapGetters"];







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    normalInvoice: __WEBPACK_IMPORTED_MODULE_6__normalInvoice__["a" /* default */],
    automaticInvoice: __WEBPACK_IMPORTED_MODULE_7__automaticInvoice__["a" /* default */]
  },
  data: function data() {
    return {
      headers: [{ text: "Date", value: "date", sortable: false }, { text: "Customer Name", value: "expense", sortable: false }, { text: "Debit", value: "category", sortable: false }, { text: "Credit", value: "underHead", sortable: false }, { text: "Voucher type", value: "totalAmount", sortable: false }, { text: "Payment type", value: "totalAmount", sortable: false },
      // { text: "Transaction type", value: "totalAmount", sortable: false },
      { text: "Status", value: "status", sortable: false }, { text: "Remark", sortable: false }],
      pagination: {
        rowsPerPage: -1 // -1 for All",
      },
      showOptions: false,
      dateFrom: null,
      dateTo: null,
      datepickerFrom: false,
      datepickerTo: false
    };
  },
  created: function created() {
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("sellers", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("buyers", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoiceHistory", this.$root.$firebaseRefs.invoiceHistory.orderByChild('brand').equalTo(this.brand));
    this.$bindAsArray("deposit", this.$root.$firebaseRefs.customerDeposit.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("customerPayments", this.$root.$firebaseRefs.customerPayments.orderByChild('brand').equalTo(this.selectedBrand));
    if (this.finYear) {
      this.dateFrom = this.formatDate(this.finYear.start);
      this.dateTo = this.formatDate(this.finYear.end);
    }
    this.selectedFirm = this.$route.params.firmId;
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear", "brandFinYear"]), {
    invoicesByBrand: function invoicesByBrand() {
      var _this = this;

      var invoiceHistory = this.invoiceHistory.filter(function (item) {
        return item["brand"] === _this.selectedBrand && (
        // this.status.indexOf(item['status']) !== -1 &&
        // (this.datatable ? true : item['isCredited'] === this.isCredited) &&
        _this.selectedFirm ? item["firm"] === _this.selectedFirm : false) && (item['paymentType'] == 'Cash' || 'Bank Account') && item['status'] != 'due' && item.date >= new Date(_this.dateFrom).getTime() && item.deleted != true && item.date <= new Date(_this.dateTo).getTime() && (item["isLatest"] != undefined ? item["isLatest"] == true : true);
      });
      // invoiceHistory.map((item) => {
      //   if (
      //     item.newlyCreated &&
      //     (item.status === "paid" || item.status === "partial")
      //   ) {
      //     let newItem = JSON.parse(JSON.stringify(item));
      //     newItem.date = newItem.date - 1;
      //     newItem.transactionType = "Debit";
      //     newItem.paidAmount = 0;
      //     newItem.status = "due";
      //     newItem.remainingAmount = newItem.totalAmount;
      //     delete newItem["newlyCreated"];
      //     invoiceHistory.push(newItem);
      //   }
      // });
      var invoice = this.invoices.filter(function (item) {
        return item["brand"] === _this.selectedBrand && item.type == "automatic invoice" && item.deleted != true && (_this.selectedFirm ? item["firm"] === _this.selectedFirm : false) && (item['paymentType'] == 'Cash' || 'Bank Account') && item['status'] != 'due' && item.date >= new Date(_this.dateFrom).getTime() && item.date <= new Date(_this.dateTo).getTime() && (item["isLatest"] != undefined ? item["isLatest"] == true : true);
      });

      var customerDeposit = this.deposit.filter(function (item) {
        return item["brand"] === _this.selectedBrand && (_this.selectedFirm ? item["firm"] === _this.selectedFirm : false) && item['status'] != 'due' && item.date >= new Date(_this.dateFrom).getTime() && item.date <= new Date(_this.dateTo).getTime() && (item["type"] === "Advance" || item["type"] === "Opening Balance" || item["type"] === "LoanTaken" || item["type"] === "LoanGiven" || item["type"] === "Security");
      });
      customerDeposit.map(function (deposit) {
        invoice.push(deposit);
        if ((deposit["type"] === "LoanTaken" || deposit["type"] === "LoanGiven") && deposit.status == "paid") {
          var temp = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(deposit));
          temp.status = "due";
          invoice.push(temp);
        }
      });
      var payments = this.customerPayments.filter(function (item) {
        return item["brand"] === _this.selectedBrand && item['paymentType'] != 'Bank Account' && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item["remainingAmount"]) > 0 && (!!_this.selectedFirm ? item["firm"] === _this.selectedFirm : true) && (_this.selectedDate ? new Date(_this.selectedDate).toLocaleDateString() === new Date(item['date']).toLocaleDateString() : false);
      });
      payments.map(function (pay) {
        pay['type'] = 'CustomerPayment';
        invoice.push(pay);
      });
      setTimeout(function () {
        _this.getTotal();
      }, 800);
      invoice = invoice.concat(invoiceHistory);
      invoice.map(function (item, index) {
        if (item.type != 'automatic invoice' && item.closedDate) {
          invoice[index]['date'] = item.closedDate;
        }
      });
      invoice.sort(function (a, b) {
        return a.date > b.date ? 1 : -1;
      });
      invoice.push({
        firm: 'Total'
      });
      return invoice;
    },
    firmsByBrand: function firmsByBrand() {
      var _this2 = this;

      return this.firms.filter(function (item) {
        return item["brand"] === _this2.selectedBrand;
      });
    }
  }),
  methods: {
    buyerById: function buyerById(id) {
      if (this.buyers[id]) {
        return this.buyers[id];
      } else if (this.sellers[id]) {
        return this.sellers[id];
      }
    },
    getTotal: function getTotal() {
      var tableElement = document.querySelector('.transaction-table table');
      if (tableElement) {
        var thead = tableElement.querySelector('thead');
        var tbody = tableElement.querySelector('tbody');
        // Assumes there's only one header row
        var columns = thead.querySelectorAll('tr th');
        var columnNames = [];
        columns.forEach(function (c) {
          return columnNames.push(c.innerText);
        });
        var result = [];
        var bodyRows = tbody.querySelectorAll('tr');
        bodyRows.forEach(function (r) {
          var tds = r.querySelectorAll('td');
          var arr = [];
          tds.forEach(function (td, idx) {
            arr.push(td.innerText);
            if (td.classList.contains("credit-total")) {
              var total = 0;
              result.map(function (a) {
                if (a[0] != 'Total') {
                  var amount = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(0 + a[2].replaceAll(",", ""));
                  total += amount;
                }
              });
              td.querySelector("b").innerHTML = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(total).toFixed(2);
            }
            if (td.classList.contains("debit-total")) {
              var _total = 0;
              result.map(function (a) {
                if (a[0] != 'Total') {
                  var amount = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(0 + a[3].replaceAll(",", ""));
                  _total += amount;
                }
              });
              td.querySelector("b").innerHTML = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(_total).toFixed(2);
            }
          });
          result.push(arr);
        });
        return result;
      }
      // let total = 0;
      //     invoices.map((a)=>{
      //         if(a[0]!='Total') {
      //             let amount  = isCredit ? Number.parseFloat(0+a[2].replaceAll(",","")) : Number.parseFloat(0+a[3].replaceAll(",",""))
      //             total += amount
      //         }

      //     })
      //     return total;
    },
    htmlToArray: function htmlToArray() {
      var tableElement = document.querySelector('.transaction-table table');
      if (tableElement) {
        var thead = tableElement.querySelector('thead');
        var tbody = tableElement.querySelector('tbody');
        // Assumes there's only one header row
        var columns = thead.querySelectorAll('tr th');
        var columnNames = [];
        columns.forEach(function (c) {
          return columnNames.push(c.innerText);
        });
        var result = [];
        var bodyRows = tbody.querySelectorAll('tr');
        bodyRows.forEach(function (r) {
          var tds = r.querySelectorAll('td');
          var arr = [];
          tds.forEach(function (td, idx) {
            arr.push(td.innerText);
          });
          result.push(arr);
        });
        return result;
      }
      return [];
    },
    formatDate: function formatDate(date) {
      var d = new Date(date),
          month = "" + (d.getMonth() + 1),
          day = "" + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    print: function print() {
      var _this3 = this;

      this.pagination.rowsPerPage = -1;
      setTimeout(function () {
        _this3.printInvoices();
      }, 1000);
    },
    printInvoices: function printInvoices() {
      var _this4 = this;

      var htmlToArray = function htmlToArray(tableElement) {
        var thead = tableElement.querySelector("thead");
        var tbody = tableElement.querySelector("tbody");
        // Assumes there's only one header row
        var columns = thead.querySelectorAll("tr th");
        var columnNames = [];
        columns.forEach(function (c) {
          return columnNames.push(c.innerText);
        });
        var result = [];
        var bodyRows = tbody.querySelectorAll("tr");
        bodyRows.forEach(function (r) {
          var tds = r.querySelectorAll("td");
          var arr = [];
          tds.forEach(function (td, idx) {
            arr.push(td.innerText);
          });
          result.push(arr);
        });
        return result;
      };

      var table = document.querySelector(".transaction-table table");
      var invoices = htmlToArray(table);
      var firm = this.firms.filter(function (item) {
        return item[".key"] == _this4.selectedFirm;
      })[0];
      var doc = Object(__WEBPACK_IMPORTED_MODULE_4__utils_pdf_reports_transaction_reports__["b" /* convertToPDFTransactionReportFirm */])({
        invoiceData: invoices,
        firm: this.selectedFirm ? firm.name : "",
        dateFrom: new Date(this.dateFrom).toLocaleDateString("en-GB"),
        dateTo: new Date(this.dateTo).toLocaleDateString("en-GB")
      });
      pdfMake.createPdf(doc).download();
    }
  }
});

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_luxon__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_luxon__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])('Buyer')['mapGetters'];



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        item: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        isCredited: {
            type: Boolean,
            default: true
        },
        firms: {
            type: Array,
            default: []
        },
        sellers: {
            type: Object,
            default: []
        },
        buyers: {
            type: Object,
            default: []
        },
        status: {
            type: Array,
            default: function _default() {
                return ['close'];
            }
        },
        firmAssignment: {
            type: Boolean,
            default: false
        },
        heading: {
            type: String,
            default: ""
        },
        selectedFirm: {
            type: String,
            default: null
        },
        selectedDate: {
            type: String,
            default: function _default() {
                var today = new Date();
                return today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
            }
        }
    },
    data: function data() {
        return {};
    },
    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand']), {
        firmsByBrand: function firmsByBrand() {
            var _this = this;

            return this.firms.filter(function (item) {
                return item['brand'] === _this.selectedBrand;
            });
        }
    }),
    methods: {
        buyerById: function buyerById(id) {
            if (this.buyers[id]) {
                return this.buyers[id];
            } else if (this.sellers[id]) {
                return this.sellers[id];
            } else {
                return {
                    name: '--'
                };
            }
        },
        getCredit: function getCredit(item) {
            if (item.status == 'Cash Opening Balance') {
                return 0;
            }
            if ('Opening Balance' == item.type && item.status == 'paid' || 'Opening Balance' == item.type && item.status == 'partial') {
                return !item.isBuyer ? item['settledAmount'] : 0;
            }
            if (item.type == 'CustomerPayment') {
                if (item.isBuyer) {
                    return 0;
                } else {
                    return item['remainingAmount'];
                }
            } else if (!item.isBuyer && ('Advance' == item.type || 'Security' == item.type)) {
                return item.isUserCreated ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.amount) : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(0);
            }
            if (item.isBuyer) {
                switch (item.status) {
                    case 'due':
                        {
                            return item.totalAmount || item.amount || 0;
                            break;
                        }
                    case 'paid':
                        {
                            return 0;
                            break;
                        }
                    case 'partial':
                        {
                            return 0;
                            break;
                        }
                }
            } else {
                switch (item.status) {
                    case 'due':
                        {
                            return item.settledAmount || 0;
                            break;
                        }
                    case 'paid':
                        {
                            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item['amountFromCash']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item['amountFromBank']));
                            // return Number.parseFloat(item['totalAmount']);
                            break;
                        }
                    case 'partial':
                        {
                            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item['amountFromCash']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item['amountFromBank']));
                            // return Number.parseFloat(item['paidAmount']);
                            break;
                        }
                }
            }
        },
        getDebit: function getDebit(item) {
            if (item.status == 'Cash Opening Balance') {
                return item.openingBalance;
            }
            if ('Opening Balance' == item.type && item.status == 'paid' || 'Opening Balance' == item.type && item.status == 'partial') {
                return item.isBuyer ? item['settledAmount'] : 0;
            }

            if (item.type == 'CustomerPayment') {
                if (!item.isBuyer) {
                    return 0;
                } else {
                    return item['remainingAmount'];
                }
            } else if (item.isBuyer && ('Advance' == item.type || 'Security' == item.type)) {
                return item.isUserCreated ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.amount) : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(0);
            }
            if (item.isBuyer) {
                switch (item.status) {
                    case 'due':
                        {
                            return item.settledAmount || 0;
                            break;
                        }
                    case 'paid':
                        {
                            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item['amountFromCash']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item['amountFromBank']));
                            // return Number.parseFloat(item['totalAmount']);
                            break;
                        }
                    case 'partial':
                        {
                            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item['amountFromCash']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item['amountFromBank']));
                            break;
                        }
                }
            } else {
                switch (item.status) {
                    case 'due':
                        {
                            return item.totalAmount || item.amount || 0;
                            break;
                        }
                    case 'paid':
                        {
                            return 0;
                            break;
                        }
                    case 'partial':
                        {
                            return 0;
                            break;
                        }
                }
            }
        },
        firmNameById: function firmNameById(id) {
            var firm = this.firms.filter(function (item) {
                return item['.key'] == id;
            })[0];
            if (firm) {
                return firm['name'];
            }
        },
        getNumberOfDaysFromStartDate: function getNumberOfDaysFromStartDate(createdAt, closedDate) {
            console.log(createdAt, closedDate);
            var startDate = __WEBPACK_IMPORTED_MODULE_4_luxon__["DateTime"].fromMillis(createdAt);
            if (!closedDate) {
                closedDate = __WEBPACK_IMPORTED_MODULE_4_luxon__["DateTime"].local();
            } else {
                closedDate = __WEBPACK_IMPORTED_MODULE_4_luxon__["DateTime"].fromMillis(closedDate);
            }
            var endDate = closedDate;
            var interval = __WEBPACK_IMPORTED_MODULE_4_luxon__["Interval"].fromDateTimes(startDate, endDate);
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(interval.length('days'));
        },
        getTotalAmount: function getTotalAmount(principal, rate, createdAt) {
            var time = this.getNumberOfDaysFromStartDate(createdAt) / 365;
            rate = rate * 12 / 100;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(principal * (1 + rate * time)).toFixed(2);
        },
        getInterestValue: function getInterestValue(principal, rate, createdAt) {
            return (this.getTotalAmount(principal, rate, createdAt) - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(principal)).toFixed(2);
        },
        getVocherType: function getVocherType(invoice) {
            if (invoice.status == 'Bank Opening Balance') {
                return 'Bank Opening Balance';
            }
            if (invoice.type == 'CustomerPayment') {
                if (invoice.isBuyer) {
                    return "Receipt";
                } else {
                    return "Payment";
                }
            }
            if (invoice.return) {
                if (invoice.isBuyer) {
                    return "Credit Note";
                } else {
                    return "Debit Note";
                }
            }
            if (invoice["type"] == "automatic invoice" && invoice.assetType) {
                return "asset";
            }
            if (invoice["type"] == "automatic invoice" && invoice.expenseType) {
                return "expense";
            }
            if (invoice["type"] == "automatic invoice" && invoice.liabilityType) {
                return "liability";
            }
            if (invoice["type"] == "automatic invoice" && invoice.incomeType) {
                return "income";
            }
            if (invoice["type"] == "automatic invoice" && invoice.staffType) {
                return "Staff";
            }
            if (invoice["type"] == "automatic invoice" && invoice.transactionType === "Transfer") {
                return "Transfer";
            } else if (invoice.transactionType != "Debit" && invoice["type"] === "Advance" ||
            // invoice["type"] === "Opening Balance" ||
            invoice["type"] === "LoanGiven" || invoice["type"] === "LoanTaken" || invoice["type"] === "Security") {
                return invoice["type"];
            } else if (invoice["type"] === "Opening Balance" && !invoice["settledAmount"]) {
                return "Opening Balance";
            } else if (invoice.isBuyer && invoice["type"] === "Opening Balance" && invoice["settledAmount"]) {
                return "Receipt";
            } else if (!invoice.isBuyer && invoice["type"] === "Opening Balance" && invoice["settledAmount"]) {
                return "Payment";
            } else if (invoice.isBuyer && invoice.transactionType === "Debit") {
                return "Sale";
            } else if (invoice.isBuyer && invoice.transactionType === "Credit") {
                return "Receipt";
            } else if (invoice.isBuyer && invoice.transactionType === "Partial Paid") {
                return "Receipt";
            } else if (!invoice.isBuyer && invoice.transactionType === "Debit") {
                return "Purchase";
            } else if (!invoice.isBuyer && invoice.transactionType === "Credit") {
                return "Payment";
            } else if (!invoice.isBuyer && invoice.transactionType === "Partial Paid") {
                return "Payment";
            }
        }
    }
});

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])('Buyer')['mapGetters'];

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        item: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        firms: {
            type: Array,
            default: []
        },
        isCredited: {
            type: Boolean,
            default: true
        }
    },
    data: function data() {
        return {
            expenseById: {},
            liabilityById: {},
            bankAccountById: {},
            incomeById: {},
            staffById: {},
            assetById: {}
        };
    },
    created: function created() {
        this.$bindAsArray('accounts', this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
        this.$bindAsObject('bankAccountById', this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
        this.$bindAsObject('expenseById', this.$root.$firebaseRefs.expenses.orderByChild('brand').equalTo(this.selectedBrand));
        this.$bindAsObject('liabilityById', this.$root.$firebaseRefs.liabilities.orderByChild('brand').equalTo(this.selectedBrand));
        this.$bindAsObject('incomeById', this.$root.$firebaseRefs.incomes.orderByChild('brand').equalTo(this.selectedBrand));
        this.$bindAsObject('assetById', this.$root.$firebaseRefs.assets.orderByChild('brand').equalTo(this.selectedBrand));
        this.$bindAsObject('staffById', this.$root.$firebaseRefs.staff.orderByChild('brand').equalTo(this.selectedBrand));
    },

    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand'])),
    methods: {
        updateInvoice: function updateInvoice(invoiceId, firmId) {
            var updatedInvoice = this.invoicesById[invoiceId];
            updatedInvoice['firm'] = firmId;
            this.$root.$firebaseRefs.invoice.child(invoiceId).set(updatedInvoice);
        },
        firmNameById: function firmNameById(id) {
            var firm = this.firms.filter(function (item) {
                return item['.key'] == id;
            })[0];
            if (firm) {
                return firm['name'];
            }
        },
        expenseNameById: function expenseNameById(id) {
            if (this.expenseById[id]) {
                return this.expenseById[id]['expense'];
            }
        },
        liabilityNameById: function liabilityNameById(id) {
            if (this.liabilityById[id]) {
                return this.liabilityById[id]['liability'];
            }
        },
        bankAccountNameById: function bankAccountNameById(id) {
            if (this.bankAccountById[id]) {
                return this.bankAccountById[id]['bankName'];
            }
        },
        incomeNameById: function incomeNameById(id) {
            if (this.incomeById[id]) {
                return this.incomeById[id]['income'];
            }
        },
        assetNameById: function assetNameById(id) {
            if (this.assetById[id]) {
                return this.assetById[id]['asset'];
            }
        },
        staffNameById: function staffNameById(id) {
            if (this.staffById[id]) {
                return this.staffById[id]['staffName'];
            }
        },
        getNumberOfDaysFromStartDate: function getNumberOfDaysFromStartDate(createdAt, closedDate) {
            console.log(createdAt, closedDate);
            var startDate = DateTime.fromMillis(createdAt);
            if (!closedDate) {
                closedDate = DateTime.local();
            } else {
                closedDate = DateTime.fromMillis(closedDate);
            }
            var endDate = closedDate;
            var interval = Interval.fromDateTimes(startDate, endDate);
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(interval.length('days'));
        },
        getTotalAmount: function getTotalAmount(principal, rate, createdAt) {
            var time = this.getNumberOfDaysFromStartDate(createdAt) / 365;
            rate = rate * 12 / 100;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(principal * (1 + rate * time)).toFixed(2);
        },
        getInterestValue: function getInterestValue(principal, rate, createdAt) {
            return (this.getTotalAmount(principal, rate, createdAt) - __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(principal)).toFixed(2);
        },
        getVocherType: function getVocherType(invoice) {
            if (invoice.return) {
                if (invoice.isBuyer) {
                    return "Credit Note";
                } else {
                    return "Debit Note";
                }
            }
            if (invoice["type"] == "automatic invoice" && invoice.assetType) {
                return "asset";
            }
            if (invoice["type"] == "automatic invoice" && invoice.expenseType) {
                return "expense";
            }
            if (invoice["type"] == "automatic invoice" && invoice.liabilityType) {
                return "liability";
            }
            if (invoice["type"] == "automatic invoice" && invoice.incomeType) {
                return "income";
            }
            if (invoice["type"] == "automatic invoice" && invoice.staffType) {
                return "Staff";
            }
            if (invoice["type"] == "automatic invoice" && invoice.transactionType === "Transfer") {
                return "Transfer";
            } else if (invoice.transactionType != "Debit" && invoice["type"] === "Advance" || invoice["type"] === "Opening Balance" || invoice["type"] === "LoanGiven" || invoice["type"] === "LoanTaken" || invoice["type"] === "Security") {
                return invoice["type"];
            } else if (invoice.isBuyer && invoice.transactionType === "Debit") {
                return "Sale";
            } else if (invoice.isBuyer && invoice.transactionType === "Credit") {
                return "Receipt";
            } else if (invoice.isBuyer && invoice.transactionType === "Partial Paid") {
                return "Receipt";
            } else if (!invoice.isBuyer && invoice.transactionType === "Debit") {
                return "Purchase";
            } else if (!invoice.isBuyer && invoice.transactionType === "Credit") {
                return "Payment";
            } else if (!invoice.isBuyer && invoice.transactionType === "Partial Paid") {
                return "Payment";
            }
        }
    }
});

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_pdf_reports_transaction_reports__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_luxon__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__normalInvoice__ = __webpack_require__(1451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__automaticInvoice__ = __webpack_require__(1453);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])("Buyer")["mapGetters"];







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    normalInvoice: __WEBPACK_IMPORTED_MODULE_6__normalInvoice__["a" /* default */],
    automaticInvoice: __WEBPACK_IMPORTED_MODULE_7__automaticInvoice__["a" /* default */]
  },
  data: function data() {
    return {
      headers: [{ text: "Date", value: "date", sortable: false }, { text: "Customer Name", value: "expense", sortable: false }, { text: "Debit", value: "category", sortable: false }, { text: "Credit", value: "underHead", sortable: false }, { text: "Voucher type", value: "totalAmount", sortable: false }, { text: "Payment type", value: "totalAmount", sortable: false },
      // { text: "Transaction type", value: "totalAmount", sortable: false },
      { text: "Status", value: "status", sortable: false }, { text: "Remark", sortable: false }],
      pagination: {
        rowsPerPage: -1 // -1 for All",
      },
      totalCredit: 0,
      totalDebit: 0,
      showOptions: false,
      dateFrom: null,
      dateTo: null,
      datepickerFrom: false,
      datepickerTo: false
    };
  },
  created: function created() {
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("sellers", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("buyers", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("customerPayments", this.$root.$firebaseRefs.customerPayments.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoiceHistory", this.$root.$firebaseRefs.invoiceHistory.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('bankAccountById', this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("deposit", this.$root.$firebaseRefs.customerDeposit.orderByChild('brand').equalTo(this.selectedBrand));
    if (this.finYear) {
      this.dateFrom = this.formatDate(this.finYear.start);
      this.dateTo = this.formatDate(this.finYear.end);
    }
    this.selectedBank = this.$route.params.bankId;
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear", "brandFinYear"]), {
    invoicesByBrand: function invoicesByBrand() {
      var _this = this;

      var invoiceHistory = this.invoiceHistory.filter(function (item) {
        return item['brand'] === _this.selectedBrand && (
        // this.status.indexOf(item['status']) !== -1 && 
        // (this.datatable ? true : item['isCredited'] === this.isCredited) &&
        _this.selectedBank ? item['bank'] === _this.selectedBank : false) && item['paymentType'] != 'Cash' &&
        // (item['status'] ==='paid'||'partial') &&
        item['status'] != 'due' && item.deleted != true && (
        // ((item.date >= new Date(this.dateFrom).getTime()) && (item.date <= new Date(this.dateTo).getTime()))
        item.closedDate ? item.closedDate >= new Date(_this.dateFrom).getTime() && item.closedDate <= new Date(_this.dateTo).getTime() : item.date >= new Date(_this.dateFrom).getTime() && item.date <= new Date(_this.dateTo).getTime()) && (item['isLatest'] != undefined ? item['isLatest'] == true : true);
      });
      // invoiceHistory.map((item) => {
      //   if (
      //     item.newlyCreated &&
      //     (item.status === "paid" || item.status === "partial")
      //   ) {
      //     let newItem = JSON.parse(JSON.stringify(item));
      //     newItem.date = newItem.date - 1;
      //     newItem.transactionType = "Debit";
      //     newItem.paidAmount = 0;
      //     newItem.status = "due";
      //     newItem.remainingAmount = newItem.totalAmount;
      //     delete newItem["newlyCreated"];
      //     invoiceHistory.push(newItem);
      //   }
      // }
      // );
      var invoice = this.invoices.filter(function (item) {
        return item["brand"] === _this.selectedBrand && item.type == "automatic invoice" && item.deleted != true && (_this.selectedBank ? item['bank'] === _this.selectedBank : false) && item.date >= new Date(_this.dateFrom).getTime() && item.date <= new Date(_this.dateTo).getTime() && (item["isLatest"] != undefined ? item["isLatest"] == true : true);
      });

      var customerDeposit = this.deposit.filter(function (item) {
        return item["brand"] === _this.selectedBrand && (_this.selectedBank ? item['bank'] === _this.selectedBank : false) && item.date >= new Date(_this.dateFrom).getTime() && item.date <= new Date(_this.dateTo).getTime() && (item["type"] === "Advance" || item["type"] === "Opening Balance" || item["type"] === "LoanTaken" || item["type"] === "LoanGiven" || item["type"] === "Security");
      });
      customerDeposit.map(function (deposit) {
        invoice.push(deposit);
        if ((deposit["type"] === "LoanTaken" || deposit["type"] === "LoanGiven") && deposit.status == "paid") {
          var temp = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(deposit));
          temp.status = "due";
          invoice.push(temp);
        }
      });
      var payments = this.customerPayments.filter(function (item) {
        return item["brand"] === _this.selectedBrand && (_this.selectedBank ? item['bank'] === _this.selectedBank : false) && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item["remainingAmount"]) > 0 && (_this.selectedDate ? new Date(_this.selectedDate).toLocaleDateString() === new Date(item['date']).toLocaleDateString() : false);
      });
      payments.map(function (pay) {
        pay['type'] = 'CustomerPayment';
        invoice.push(pay);
      });

      var bankAccountById = this.bankAccountById.filter(function (item) {
        return item['.key'] == _this.selectedBank;
      })[0];
      console.log(bankAccountById);
      if (bankAccountById && bankAccountById.openingBalance) {
        invoice.push({
          status: 'Bank Opening Balance',
          openingBalance: bankAccountById.openingBalance,
          date: bankAccountById.openingDate
        });
      }

      setTimeout(function () {
        _this.getTotal();
      }, 800);
      invoice = invoice.concat(invoiceHistory);

      invoice.map(function (item, index) {
        if (item.type != 'automatic invoice' && item.closedDate) {
          invoice[index]['date'] = item.closedDate;
        }
      });
      // invoice = invoice.concat(invoiceHistory);
      invoice.sort(function (a, b) {
        return a.date > b.date ? 1 : -1;
      });
      invoice.push({
        firm: 'Total'
      });
      return invoice;
    }
  }),
  methods: {
    getTotal: function getTotal() {
      var _this2 = this;

      var tableElement = document.querySelector('.transaction-table table');
      if (tableElement) {
        var thead = tableElement.querySelector('thead');
        var tbody = tableElement.querySelector('tbody');
        // Assumes there's only one header row
        var columns = thead.querySelectorAll('tr th');
        var columnNames = [];
        columns.forEach(function (c) {
          return columnNames.push(c.innerText);
        });
        var result = [];
        var bodyRows = tbody.querySelectorAll('tr');
        bodyRows.forEach(function (r) {
          var tds = r.querySelectorAll('td');
          var arr = [];
          tds.forEach(function (td, idx) {
            arr.push(td.innerText);
            if (td.classList.contains("credit-total")) {
              var total = 0;
              result.map(function (a) {
                if (a[0] != 'Total') {
                  var amount = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(0 + a[2].replaceAll(",", ""));
                  total += amount;
                }
              });
              _this2.totalCredit = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(total);
              td.querySelector("b").innerHTML = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(total).toFixed(2);
            }
            if (td.classList.contains("debit-total")) {
              var _total = 0;
              result.map(function (a) {
                if (a[0] != 'Total') {
                  var amount = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(0 + a[3].replaceAll(",", ""));
                  _total += amount;
                }
              });
              _this2.totalDebit = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(_total);
              td.querySelector("b").innerHTML = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(_total).toFixed(2);
            }
          });
          result.push(arr);
        });
        return result;
      }
      // let total = 0;
      //     invoices.map((a)=>{
      //         if(a[0]!='Total') {
      //             let amount  = isCredit ? Number.parseFloat(0+a[2].replaceAll(",","")) : Number.parseFloat(0+a[3].replaceAll(",",""))
      //             total += amount
      //         }

      //     })
      //     return total;
    },
    htmlToArray: function htmlToArray() {
      var tableElement = document.querySelector('.transaction-table table');
      if (tableElement) {
        var thead = tableElement.querySelector('thead');
        var tbody = tableElement.querySelector('tbody');
        // Assumes there's only one header row
        var columns = thead.querySelectorAll('tr th');
        var columnNames = [];
        columns.forEach(function (c) {
          return columnNames.push(c.innerText);
        });
        var result = [];
        var bodyRows = tbody.querySelectorAll('tr');
        bodyRows.forEach(function (r) {
          var tds = r.querySelectorAll('td');
          var arr = [];
          tds.forEach(function (td, idx) {
            arr.push(td.innerText);
          });
          result.push(arr);
        });
        return result;
      }
      return [];
    },
    buyerById: function buyerById(id) {
      if (this.buyers[id]) {
        return this.buyers[id];
      } else if (this.sellers[id]) {
        return this.sellers[id];
      }
    },
    formatDate: function formatDate(date) {
      var d = new Date(date),
          month = "" + (d.getMonth() + 1),
          day = "" + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    print: function print() {
      var _this3 = this;

      this.pagination.rowsPerPage = -1;
      setTimeout(function () {
        _this3.printInvoices();
      }, 1000);
    },
    printInvoices: function printInvoices() {
      var _this4 = this;

      var htmlToArray = function htmlToArray(tableElement) {
        var thead = tableElement.querySelector("thead");
        var tbody = tableElement.querySelector("tbody");
        // Assumes there's only one header row
        var columns = thead.querySelectorAll("tr th");
        var columnNames = [];
        columns.forEach(function (c) {
          return columnNames.push(c.innerText);
        });
        var result = [];
        var bodyRows = tbody.querySelectorAll("tr");
        bodyRows.forEach(function (r) {
          var tds = r.querySelectorAll("td");
          var arr = [];
          tds.forEach(function (td, idx) {
            arr.push(td.innerText);
          });
          result.push(arr);
        });
        return result;
      };

      var table = document.querySelector(".transaction-table table");
      var invoices = htmlToArray(table);
      var bank = this.bankAccountById.find(function (item) {
        return item['.key'] == _this4.selectedBank;
      });
      var doc = Object(__WEBPACK_IMPORTED_MODULE_4__utils_pdf_reports_transaction_reports__["b" /* convertToPDFTransactionReportFirm */])({
        invoiceData: invoices,
        bank: this.selectedBank ? bank.bankName : '',
        dateFrom: new Date(this.dateFrom).toLocaleDateString("en-GB"),
        dateTo: new Date(this.dateTo).toLocaleDateString("en-GB")
      });
      pdfMake.createPdf(doc).download(bank.bankName + '_Bank_Statement');
    }
  }
});

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_luxon__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_luxon__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])('Buyer')['mapGetters'];



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        item: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        isCredited: {
            type: Boolean,
            default: true
        },
        firms: {
            type: Array,
            default: []
        },
        sellers: {
            type: Object,
            default: []
        },
        buyers: {
            type: Object,
            default: []
        },
        status: {
            type: Array,
            default: function _default() {
                return ['close'];
            }
        },
        firmAssignment: {
            type: Boolean,
            default: false
        },
        heading: {
            type: String,
            default: ""
        },
        selectedFirm: {
            type: String,
            default: null
        },
        selectedDate: {
            type: String,
            default: function _default() {
                var today = new Date();
                return today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
            }
        }
    },
    data: function data() {
        return {};
    },
    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand']), {
        firmsByBrand: function firmsByBrand() {
            var _this = this;

            return this.firms.filter(function (item) {
                return item['brand'] === _this.selectedBrand;
            });
        }
    }),
    methods: {
        buyerById: function buyerById(id) {
            if (this.buyers[id]) {
                return this.buyers[id];
            } else if (this.sellers[id]) {
                return this.sellers[id];
            } else {
                return {
                    name: '--'
                };
            }
        },
        getCredit: function getCredit(item) {
            if (item.status == 'Bank Opening Balance') {
                return 0;
            }
            if ('Opening Balance' == item.type && item.status == 'paid' || 'Opening Balance' == item.type && item.status == 'partial') {
                return !item.isBuyer ? item['settledAmount'] : 0;
            }
            if (item.type == 'CustomerPayment') {
                if (item.isBuyer) {
                    return 0;
                } else {
                    return item['remainingAmount'];
                }
            } else if (!item.isBuyer && ('Advance' == item.type || 'Security' == item.type)) {
                return item.isUserCreated ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.amount) : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(0);
            }
            if (item.isBuyer) {
                switch (item.status) {
                    case 'due':
                        {
                            return item.totalAmount || item.amount || 0;
                            break;
                        }
                    case 'paid':
                        {
                            return 0;
                            break;
                        }
                    case 'partial':
                        {
                            return 0;
                            break;
                        }
                }
            } else {
                switch (item.status) {
                    case 'due':
                        {
                            return item.settledAmount || 0;
                            break;
                        }
                    case 'paid':
                        {
                            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item['amountFromBank']);
                            // return Number.parseFloat(item['totalAmount']);
                            break;
                        }
                    case 'partial':
                        {
                            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item['amountFromBank']);
                            // return Number.parseFloat(item['paidAmount']);
                            break;
                        }
                }
            }
        },
        getDebit: function getDebit(item) {
            if (item.status == 'Bank Opening Balance') {
                return item.openingBalance;
            }
            if ('Opening Balance' == item.type && item.status == 'paid' || 'Opening Balance' == item.type && item.status == 'partial') {
                return item.isBuyer ? item['settledAmount'] : 0;
            }

            if (item.type == 'CustomerPayment') {
                if (!item.isBuyer) {
                    return 0;
                } else {
                    return item['remainingAmount'];
                }
            } else if (item.isBuyer && ('Advance' == item.type || 'Security' == item.type)) {
                return item.isUserCreated ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.amount) : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(0);
            }
            if (item.isBuyer) {
                switch (item.status) {
                    case 'due':
                        {
                            return item.settledAmount || 0;
                            break;
                        }
                    case 'paid':
                        {
                            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item['amountFromBank']);
                            // return Number.parseFloat(item['totalAmount']);
                            break;
                        }
                    case 'partial':
                        {
                            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item['amountFromBank']);
                            break;
                        }
                }
            } else {
                switch (item.status) {
                    case 'due':
                        {
                            return item.totalAmount || item.amount || 0;
                            break;
                        }
                    case 'paid':
                        {
                            return 0;
                            break;
                        }
                    case 'partial':
                        {
                            return 0;
                            break;
                        }
                }
            }
        },
        firmNameById: function firmNameById(id) {
            var firm = this.firms.filter(function (item) {
                return item['.key'] == id;
            })[0];
            if (firm) {
                return firm['name'];
            }
        },
        getNumberOfDaysFromStartDate: function getNumberOfDaysFromStartDate(createdAt, closedDate) {
            console.log(createdAt, closedDate);
            var startDate = __WEBPACK_IMPORTED_MODULE_4_luxon__["DateTime"].fromMillis(createdAt);
            if (!closedDate) {
                closedDate = __WEBPACK_IMPORTED_MODULE_4_luxon__["DateTime"].local();
            } else {
                closedDate = __WEBPACK_IMPORTED_MODULE_4_luxon__["DateTime"].fromMillis(closedDate);
            }
            var endDate = closedDate;
            var interval = __WEBPACK_IMPORTED_MODULE_4_luxon__["Interval"].fromDateTimes(startDate, endDate);
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(interval.length('days'));
        },
        getTotalAmount: function getTotalAmount(principal, rate, createdAt) {
            var time = this.getNumberOfDaysFromStartDate(createdAt) / 365;
            rate = rate * 12 / 100;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(principal * (1 + rate * time)).toFixed(2);
        },
        getInterestValue: function getInterestValue(principal, rate, createdAt) {
            return (this.getTotalAmount(principal, rate, createdAt) - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(principal)).toFixed(2);
        },
        getVocherType: function getVocherType(invoice) {
            if (invoice.status == 'Bank Opening Balance') {
                return 'Bank Opening Balance';
            }
            if (invoice.type == 'CustomerPayment') {
                if (invoice.isBuyer) {
                    return "Receipt";
                } else {
                    return "Payment";
                }
            }
            if (invoice.return) {
                if (invoice.isBuyer) {
                    return "Credit Note";
                } else {
                    return "Debit Note";
                }
            }
            if (invoice["type"] == "automatic invoice" && invoice.assetType) {
                return "asset";
            }
            if (invoice["type"] == "automatic invoice" && invoice.expenseType) {
                return "expense";
            }
            if (invoice["type"] == "automatic invoice" && invoice.liabilityType) {
                return "liability";
            }
            if (invoice["type"] == "automatic invoice" && invoice.incomeType) {
                return "income";
            }
            if (invoice["type"] == "automatic invoice" && invoice.staffType) {
                return "Staff";
            }
            if (invoice["type"] == "automatic invoice" && invoice.transactionType === "Transfer") {
                return "Transfer";
            } else if (invoice.transactionType != "Debit" && invoice["type"] === "Advance" ||
            // invoice["type"] === "Opening Balance" ||
            invoice["type"] === "LoanGiven" || invoice["type"] === "LoanTaken" || invoice["type"] === "Security") {
                return invoice["type"];
            } else if (invoice["type"] === "Opening Balance" && !invoice["settledAmount"]) {
                return "Opening Balance";
            } else if (invoice.isBuyer && invoice["type"] === "Opening Balance" && invoice["settledAmount"]) {
                return "Receipt";
            } else if (!invoice.isBuyer && invoice["type"] === "Opening Balance" && invoice["settledAmount"]) {
                return "Payment";
            } else if (invoice.isBuyer && invoice.transactionType === "Debit") {
                return "Sale";
            } else if (invoice.isBuyer && invoice.transactionType === "Credit") {
                return "Receipt";
            } else if (invoice.isBuyer && invoice.transactionType === "Partial Paid") {
                return "Receipt";
            } else if (!invoice.isBuyer && invoice.transactionType === "Debit") {
                return "Purchase";
            } else if (!invoice.isBuyer && invoice.transactionType === "Credit") {
                return "Payment";
            } else if (!invoice.isBuyer && invoice.transactionType === "Partial Paid") {
                return "Payment";
            }
        }
    }
});

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])('Buyer')['mapGetters'];

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        item: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        firms: {
            type: Array,
            default: []
        },
        isCredited: {
            type: Boolean,
            default: true
        }
    },
    data: function data() {
        return {
            expenseById: {},
            liabilityById: {},
            bankAccountById: {},
            incomeById: {},
            staffById: {},
            assetById: {}
        };
    },
    created: function created() {
        this.$bindAsArray('accounts', this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
        this.$bindAsObject('bankAccountById', this.$root.$firebaseRefs.account);
        this.$bindAsObject('expenseById', this.$root.$firebaseRefs.expenses);
        this.$bindAsObject('liabilityById', this.$root.$firebaseRefs.liabilitys);
        this.$bindAsObject('incomeById', this.$root.$firebaseRefs.incomes);
        this.$bindAsObject('assetById', this.$root.$firebaseRefs.assets);
        this.$bindAsObject('staffById', this.$root.$firebaseRefs.staff);
    },

    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand'])),
    methods: {
        updateInvoice: function updateInvoice(invoiceId, firmId) {
            var updatedInvoice = this.invoicesById[invoiceId];
            updatedInvoice['firm'] = firmId;
            this.$root.$firebaseRefs.invoice.child(invoiceId).set(updatedInvoice);
        },
        firmNameById: function firmNameById(id) {
            var firm = this.firms.filter(function (item) {
                return item['.key'] == id;
            })[0];
            if (firm) {
                return firm['name'];
            }
        },
        expenseNameById: function expenseNameById(id) {
            if (this.expenseById[id]) {
                return this.expenseById[id]['expense'];
            }
        },
        liabilityNameById: function liabilityNameById(id) {
            if (this.liabilityById[id]) {
                return this.liabilityById[id]['liability'];
            }
        },
        bankAccountNameById: function bankAccountNameById(id) {
            if (this.bankAccountById[id]) {
                return this.bankAccountById[id]['bankName'];
            }
        },
        incomeNameById: function incomeNameById(id) {
            if (this.incomeById[id]) {
                return this.incomeById[id]['income'];
            }
        },
        assetNameById: function assetNameById(id) {
            if (this.assetById[id]) {
                return this.assetById[id]['asset'];
            }
        },
        staffNameById: function staffNameById(id) {
            if (this.staffById[id]) {
                return this.staffById[id]['staffName'];
            }
        },
        getNumberOfDaysFromStartDate: function getNumberOfDaysFromStartDate(createdAt, closedDate) {
            console.log(createdAt, closedDate);
            var startDate = DateTime.fromMillis(createdAt);
            if (!closedDate) {
                closedDate = DateTime.local();
            } else {
                closedDate = DateTime.fromMillis(closedDate);
            }
            var endDate = closedDate;
            var interval = Interval.fromDateTimes(startDate, endDate);
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(interval.length('days'));
        },
        getTotalAmount: function getTotalAmount(principal, rate, createdAt) {
            var time = this.getNumberOfDaysFromStartDate(createdAt) / 365;
            rate = rate * 12 / 100;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(principal * (1 + rate * time)).toFixed(2);
        },
        getInterestValue: function getInterestValue(principal, rate, createdAt) {
            return (this.getTotalAmount(principal, rate, createdAt) - __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(principal)).toFixed(2);
        },
        getVocherType: function getVocherType(invoice) {
            if (invoice.return) {
                if (invoice.isBuyer) {
                    return "Credit Note";
                } else {
                    return "Debit Note";
                }
            }
            if (invoice["type"] == "automatic invoice" && invoice.assetType) {
                return "asset";
            }
            if (invoice["type"] == "automatic invoice" && invoice.expenseType) {
                return "expense";
            }
            if (invoice["type"] == "automatic invoice" && invoice.liabilityType) {
                return "liability";
            }
            if (invoice["type"] == "automatic invoice" && invoice.incomeType) {
                return "income";
            }
            if (invoice["type"] == "automatic invoice" && invoice.staffType) {
                return "Staff";
            }
            if (invoice["type"] == "automatic invoice" && invoice.transactionType === "Transfer") {
                return "Transfer";
            } else if (invoice.transactionType != "Debit" && invoice["type"] === "Advance" || invoice["type"] === "Opening Balance" || invoice["type"] === "LoanGiven" || invoice["type"] === "LoanTaken" || invoice["type"] === "Security") {
                return invoice["type"];
            } else if (invoice.isBuyer && invoice.transactionType === "Debit") {
                return "Sale";
            } else if (invoice.isBuyer && invoice.transactionType === "Credit") {
                return "Receipt";
            } else if (invoice.isBuyer && invoice.transactionType === "Partial Paid") {
                return "Receipt";
            } else if (!invoice.isBuyer && invoice.transactionType === "Debit") {
                return "Purchase";
            } else if (!invoice.isBuyer && invoice.transactionType === "Credit") {
                return "Payment";
            } else if (!invoice.isBuyer && invoice.transactionType === "Partial Paid") {
                return "Payment";
            }
        }
    }
});

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_pdf_reports_transaction_reports__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_luxon__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__normalInvoice__ = __webpack_require__(1458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__automaticInvoice__ = __webpack_require__(1460);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])("Buyer")["mapGetters"];







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    normalInvoice: __WEBPACK_IMPORTED_MODULE_6__normalInvoice__["a" /* default */],
    automaticInvoice: __WEBPACK_IMPORTED_MODULE_7__automaticInvoice__["a" /* default */]
  },
  data: function data() {
    return {
      headers: [{ text: "Date", value: "date", sortable: false }, { text: "Customer Name", value: "expense", sortable: true }, { text: "Debit", value: "category", sortable: false }, { text: "Credit", value: "underHead", sortable: false }, { text: "Voucher type", value: "totalAmount", sortable: false }, { text: "Payment type", value: "totalAmount", sortable: false },
      // { text: "Transaction type", value: "totalAmount", sortable: false },
      { text: "Status", value: "status", sortable: false }, { text: "Remark", sortable: false }],
      pagination: {
        rowsPerPage: -1 // -1 for All",
      },
      totalCredit: 0,
      totalDebit: 0,
      showOptions: false,
      dateFrom: null,
      dateTo: null,
      datepickerFrom: false,
      datepickerTo: false
    };
  },
  created: function created() {
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("sellers", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("buyers", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("customerPayments", this.$root.$firebaseRefs.customerPayments.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoiceHistory", this.$root.$firebaseRefs.invoiceHistory.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('firmes', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("deposit", this.$root.$firebaseRefs.customerDeposit.orderByChild('brand').equalTo(this.selectedBrand));
    if (this.finYear) {
      this.dateFrom = this.formatDate(this.finYear.start);
      this.dateTo = this.formatDate(this.finYear.end);
    }
    this.selectedFirm = this.$route.params.firmId;
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear", "brandFinYear"]), {
    invoicesByBrand: function invoicesByBrand() {
      var _this = this;

      var invoiceHistory = this.invoiceHistory.filter(function (item) {
        return item['brand'] === _this.selectedBrand && (
        // this.status.indexOf(item['status']) !== -1 && 
        // (this.datatable ? true : item['isCredited'] === this.isCredited) &&
        _this.selectedFirm ? item['firm'] === _this.selectedFirm : false) && item.deleted != true &&
        // ((item['paymentType'] !== 'Bank Account') || (item['paymentType'] !== 'bank') || (item['paymentType'] !== 'account')) &&
        item['paymentType'] != 'Bank Account' &&
        // (item['status'] ==='paid'||'partial') &&
        item['status'] != 'due' && (
        // ((item.date >= new Date(this.dateFrom).getTime()) && (item.date <= new Date(this.dateTo).getTime()))
        item.closedDate ? item.closedDate >= new Date(_this.dateFrom).getTime() && item.closedDate <= new Date(_this.dateTo).getTime() : item.date >= new Date(_this.dateFrom).getTime() && item.date <= new Date(_this.dateTo).getTime()) && (item['isLatest'] != undefined ? item['isLatest'] == true : true);
      });
      // invoiceHistory.map((item) => {
      //   if (
      //     item.newlyCreated &&
      //     (item.status === "paid" || item.status === "partial")
      //   ) {
      //     let newItem = JSON.parse(JSON.stringify(item));
      //     newItem.date = newItem.date - 1;
      //     newItem.transactionType = "Debit";
      //     newItem.paidAmount = 0;
      //     newItem.status = "due";
      //     newItem.remainingAmount = newItem.totalAmount;
      //     delete newItem["newlyCreated"];
      //     invoiceHistory.push(newItem);
      //   }
      // });
      var invoice = this.invoices.filter(function (item) {
        return item["brand"] === _this.selectedBrand && item.type == "automatic invoice" && item.deleted != true && (item['paymentType'] === 'Cash' || item['paymentType'] === 'cash' || item['paymentType'] === 'bank') && (item.transferCategory == 'C2B' ? item.isCredited == false : true) && (_this.selectedFirm ? item["firm"] === _this.selectedFirm : false) && item.date >= new Date(_this.dateFrom).getTime() && item.date <= new Date(_this.dateTo).getTime() && (item["isLatest"] != undefined ? item["isLatest"] == true : true);
      });

      var customerDeposit = this.deposit.filter(function (item) {
        return item["brand"] === _this.selectedBrand && (_this.selectedFirm ? item["firm"] === _this.selectedFirm : false) &&
        // ((!this.selectedBank) ? (!item['bank'] === this.selectedBank): false) &&
        item['paymentType'] === 'Cash' && item.date >= new Date(_this.dateFrom).getTime() && item.date <= new Date(_this.dateTo).getTime() && (item["type"] === "Advance" || item["type"] === "Opening Balance" || item["type"] === "LoanTaken" || item["type"] === "LoanGiven" || item["type"] === "Security");
      });
      customerDeposit.map(function (deposit) {
        invoice.push(deposit);
        if ((deposit["type"] === "LoanTaken" || deposit["type"] === "LoanGiven") && deposit.status == "paid") {
          var temp = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(deposit));
          temp.status = "due";
          invoice.push(temp);
        }
      });
      var payments = this.customerPayments.filter(function (item) {
        return item["brand"] === _this.selectedBrand && item['paymentType'] != 'Bank Account' && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item["remainingAmount"]) > 0 && (!!_this.selectedFirm ? item["firm"] === _this.selectedFirm : true) && (!_this.selectedBank ? !item['bank'] === _this.selectedBank : false) && (_this.selectedDate ? new Date(_this.selectedDate).toLocaleDateString() === new Date(item['date']).toLocaleDateString() : false);
      });
      payments.map(function (pay) {
        pay['type'] = 'CustomerPayment';
        invoice.push(pay);
      });

      var firmes = this.firmes.filter(function (item) {
        return item['.key'] == _this.selectedFirm;
      })[0];
      console.log(firmes);
      if (firmes && firmes.openingCashAmount) {
        invoice.push({
          status: 'Cash Opening Balance',
          openingCashAmount: firmes.openingCashAmount,
          date: firmes.openingDate
        });
      }

      setTimeout(function () {
        _this.getTotal();
      }, 800);
      invoice = invoice.concat(invoiceHistory);
      invoice.map(function (item, index) {
        if (item.type != 'automatic invoice' && item.closedDate) {
          invoice[index]['date'] = item.closedDate;
        }
      });
      invoice.sort(function (a, b) {
        return a.date > b.date ? 1 : -1;
      });
      invoice.push({
        firm: 'Total'
      });
      return invoice;
    },
    firmsByBrand: function firmsByBrand() {
      var _this2 = this;

      return this.firms.filter(function (item) {
        return item["brand"] === _this2.selectedBrand;
      });
    }
  }),
  methods: {
    buyerById: function buyerById(id) {
      if (this.buyers[id]) {
        return this.buyers[id];
      } else if (this.sellers[id]) {
        return this.sellers[id];
      }
    },
    getTotal: function getTotal() {
      var _this3 = this;

      var tableElement = document.querySelector('.transaction-table table');
      if (tableElement) {
        var thead = tableElement.querySelector('thead');
        var tbody = tableElement.querySelector('tbody');
        // Assumes there's only one header row
        var columns = thead.querySelectorAll('tr th');
        var columnNames = [];
        columns.forEach(function (c) {
          return columnNames.push(c.innerText);
        });
        var result = [];
        var bodyRows = tbody.querySelectorAll('tr');
        bodyRows.forEach(function (r) {
          var tds = r.querySelectorAll('td');
          var arr = [];
          tds.forEach(function (td, idx) {
            arr.push(td.innerText);
            if (td.classList.contains("credit-total")) {
              var total = 0;
              result.map(function (a) {
                if (a[0] != 'Total') {
                  var amount = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(0 + a[2].replaceAll(",", ""));
                  total += amount;
                }
              });
              _this3.totalCredit = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(total);
              td.querySelector("b").innerHTML = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(total).toFixed(2);
            }
            if (td.classList.contains("debit-total")) {
              var _total = 0;
              result.map(function (a) {
                if (a[0] != 'Total') {
                  var amount = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(0 + a[3].replaceAll(",", ""));
                  _total += amount;
                }
              });
              _this3.totalDebit = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(_total);
              td.querySelector("b").innerHTML = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(_total).toFixed(2);
            }
          });
          result.push(arr);
        });
        return result;
      }
      // let total = 0;
      //     invoices.map((a)=>{
      //         if(a[0]!='Total') {
      //             let amount  = isCredit ? Number.parseFloat(0+a[2].replaceAll(",","")) : Number.parseFloat(0+a[3].replaceAll(",",""))
      //             total += amount
      //         }

      //     })
      //     return total;
    },
    htmlToArray: function htmlToArray() {
      var tableElement = document.querySelector('.transaction-table table');
      if (tableElement) {
        var thead = tableElement.querySelector('thead');
        var tbody = tableElement.querySelector('tbody');
        // Assumes there's only one header row
        var columns = thead.querySelectorAll('tr th');
        var columnNames = [];
        columns.forEach(function (c) {
          return columnNames.push(c.innerText);
        });
        var result = [];
        var bodyRows = tbody.querySelectorAll('tr');
        bodyRows.forEach(function (r) {
          var tds = r.querySelectorAll('td');
          var arr = [];
          tds.forEach(function (td, idx) {
            arr.push(td.innerText);
          });
          result.push(arr);
        });
        return result;
      }
      return [];
    },
    formatDate: function formatDate(date) {
      var d = new Date(date),
          month = "" + (d.getMonth() + 1),
          day = "" + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    print: function print() {
      var _this4 = this;

      this.pagination.rowsPerPage = -1;
      setTimeout(function () {
        _this4.printInvoices();
      }, 1000);
    },
    printInvoices: function printInvoices() {
      var _this5 = this;

      var htmlToArray = function htmlToArray(tableElement) {
        var thead = tableElement.querySelector("thead");
        var tbody = tableElement.querySelector("tbody");
        // Assumes there's only one header row
        var columns = thead.querySelectorAll("tr th");
        var columnNames = [];
        columns.forEach(function (c) {
          return columnNames.push(c.innerText);
        });
        var result = [];
        var bodyRows = tbody.querySelectorAll("tr");
        bodyRows.forEach(function (r) {
          var tds = r.querySelectorAll("td");
          var arr = [];
          tds.forEach(function (td, idx) {
            arr.push(td.innerText);
          });
          result.push(arr);
        });
        return result;
      };

      var table = document.querySelector(".transaction-table table");
      var invoices = htmlToArray(table);
      var firm = this.firms.filter(function (item) {
        return item[".key"] == _this5.selectedFirm;
      })[0];
      var doc = Object(__WEBPACK_IMPORTED_MODULE_4__utils_pdf_reports_transaction_reports__["b" /* convertToPDFTransactionReportFirm */])({
        invoiceData: invoices,
        firm: this.selectedFirm ? firm.name : "",
        dateFrom: new Date(this.dateFrom).toLocaleDateString("en-GB"),
        dateTo: new Date(this.dateTo).toLocaleDateString("en-GB")
      });
      pdfMake.createPdf(doc).download(firm.name + '_Cash_Statement');
    }
  }
});

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_luxon__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_luxon__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])('Buyer')['mapGetters'];



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        item: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        isCredited: {
            type: Boolean,
            default: true
        },
        firms: {
            type: Array,
            default: []
        },
        sellers: {
            type: Object,
            default: []
        },
        buyers: {
            type: Object,
            default: []
        },
        status: {
            type: Array,
            default: function _default() {
                return ['close'];
            }
        },
        firmAssignment: {
            type: Boolean,
            default: false
        },
        heading: {
            type: String,
            default: ""
        },
        selectedFirm: {
            type: String,
            default: null
        },
        selectedDate: {
            type: String,
            default: function _default() {
                var today = new Date();
                return today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
            }
        }
    },
    data: function data() {
        return {};
    },
    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand']), {
        firmsByBrand: function firmsByBrand() {
            var _this = this;

            return this.firms.filter(function (item) {
                return item['brand'] === _this.selectedBrand;
            });
        }
    }),
    methods: {
        buyerById: function buyerById(id) {
            if (this.buyers[id]) {
                return this.buyers[id];
            } else if (this.sellers[id]) {
                return this.sellers[id];
            } else {
                return {
                    name: '--'
                };
            }
        },
        getCredit: function getCredit(item) {
            if (item.status == 'Cash Opening Balance') {
                return 0;
            }
            if ('Opening Balance' == item.type && item.status == 'paid' || 'Opening Balance' == item.type && item.status == 'partial') {
                return !item.isBuyer ? item['settledAmount'] : 0;
            }
            if (item.type == 'CustomerPayment') {
                if (item.isBuyer) {
                    return 0;
                } else {
                    return item['remainingAmount'];
                }
            } else if (!item.isBuyer && ('Advance' == item.type || 'Security' == item.type)) {
                return item.isUserCreated ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.amount) : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(0);
            }
            if (item.isBuyer) {
                switch (item.status) {
                    case 'due':
                        {
                            return item.totalAmount || item.amount || 0;
                            break;
                        }
                    case 'paid':
                        {
                            return 0;
                            break;
                        }
                    case 'partial':
                        {
                            return 0;
                            break;
                        }
                }
            } else {
                switch (item.status) {
                    case 'due':
                        {
                            return item.settledAmount || 0;
                            break;
                        }
                    case 'paid':
                        {
                            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item['amountFromCash']);
                            // return Number.parseFloat(item['totalAmount']);
                            break;
                        }
                    case 'partial':
                        {
                            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item['amountFromCash']);
                            // return Number.parseFloat(item['paidAmount']);
                            break;
                        }
                }
            }
        },
        getDebit: function getDebit(item) {
            if (item.status == 'Cash Opening Balance') {
                return item.openingCashAmount;
            }
            if ('Opening Balance' == item.type && item.status == 'paid' || 'Opening Balance' == item.type && item.status == 'partial') {
                return item.isBuyer ? item['settledAmount'] : 0;
            }

            if (item.type == 'CustomerPayment') {
                if (!item.isBuyer) {
                    return 0;
                } else {
                    return item['remainingAmount'];
                }
            } else if (item.isBuyer && ('Advance' == item.type || 'Security' == item.type)) {
                return item.isUserCreated ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.amount) : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(0);
            }
            if (item.isBuyer) {
                switch (item.status) {
                    case 'due':
                        {
                            return item.settledAmount || 0;
                            break;
                        }
                    case 'paid':
                        {
                            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item['amountFromCash']);
                            // return Number.parseFloat(item['totalAmount']);
                            break;
                        }
                    case 'partial':
                        {
                            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item['amountFromCash']);
                            break;
                        }
                }
            } else {
                switch (item.status) {
                    case 'due':
                        {
                            return item.totalAmount || item.amount || 0;
                            break;
                        }
                    case 'paid':
                        {
                            return 0;
                            break;
                        }
                    case 'partial':
                        {
                            return 0;
                            break;
                        }
                }
            }
        },
        firmNameById: function firmNameById(id) {
            var firm = this.firms.filter(function (item) {
                return item['.key'] == id;
            })[0];
            if (firm) {
                return firm['name'];
            }
        },
        getNumberOfDaysFromStartDate: function getNumberOfDaysFromStartDate(createdAt, closedDate) {
            console.log(createdAt, closedDate);
            var startDate = __WEBPACK_IMPORTED_MODULE_4_luxon__["DateTime"].fromMillis(createdAt);
            if (!closedDate) {
                closedDate = __WEBPACK_IMPORTED_MODULE_4_luxon__["DateTime"].local();
            } else {
                closedDate = __WEBPACK_IMPORTED_MODULE_4_luxon__["DateTime"].fromMillis(closedDate);
            }
            var endDate = closedDate;
            var interval = __WEBPACK_IMPORTED_MODULE_4_luxon__["Interval"].fromDateTimes(startDate, endDate);
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(interval.length('days'));
        },
        getTotalAmount: function getTotalAmount(principal, rate, createdAt) {
            var time = this.getNumberOfDaysFromStartDate(createdAt) / 365;
            rate = rate * 12 / 100;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(principal * (1 + rate * time)).toFixed(2);
        },
        getInterestValue: function getInterestValue(principal, rate, createdAt) {
            return (this.getTotalAmount(principal, rate, createdAt) - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(principal)).toFixed(2);
        },
        getVocherType: function getVocherType(invoice) {
            if (invoice.status == 'Cash Opening Balance') {
                return 'Cash Opening Balance';
            }
            if (invoice.type == 'CustomerPayment') {
                if (invoice.isBuyer) {
                    return "Receipt";
                } else {
                    return "Payment";
                }
            }
            if (invoice.return) {
                if (invoice.isBuyer) {
                    return "Credit Note";
                } else {
                    return "Debit Note";
                }
            }
            if (invoice["type"] == "automatic invoice" && invoice.assetType) {
                return "asset";
            }
            if (invoice["type"] == "automatic invoice" && invoice.expenseType) {
                return "expense";
            }
            if (invoice["type"] == "automatic invoice" && invoice.liabilityType) {
                return "liability";
            }
            if (invoice["type"] == "automatic invoice" && invoice.incomeType) {
                return "income";
            }
            if (invoice["type"] == "automatic invoice" && invoice.staffType) {
                return "Staff";
            }
            if (invoice["type"] == "automatic invoice" && invoice.transactionType === "Transfer") {
                return "Transfer";
            } else if (invoice.transactionType != "Debit" && invoice["type"] === "Advance" ||
            // invoice["type"] === "Opening Balance" ||
            invoice["type"] === "LoanGiven" || invoice["type"] === "LoanTaken" || invoice["type"] === "Security") {
                return invoice["type"];
            } else if (invoice["type"] === "Opening Balance" && !invoice["settledAmount"]) {
                return "Opening Balance";
            } else if (invoice.isBuyer && invoice["type"] === "Opening Balance" && invoice["settledAmount"]) {
                return "Receipt";
            } else if (!invoice.isBuyer && invoice["type"] === "Opening Balance" && invoice["settledAmount"]) {
                return "Payment";
            } else if (invoice.isBuyer && invoice.transactionType === "Debit") {
                return "Sale";
            } else if (invoice.isBuyer && invoice.transactionType === "Credit") {
                return "Receipt";
            } else if (invoice.isBuyer && invoice.transactionType === "Partial Paid") {
                return "Receipt";
            } else if (!invoice.isBuyer && invoice.transactionType === "Debit") {
                return "Purchase";
            } else if (!invoice.isBuyer && invoice.transactionType === "Credit") {
                return "Payment";
            } else if (!invoice.isBuyer && invoice.transactionType === "Partial Paid") {
                return "Payment";
            }
        }
    }
});

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])('Buyer')['mapGetters'];

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        item: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        firms: {
            type: Array,
            default: []
        },
        isCredited: {
            type: Boolean,
            default: true
        }
    },
    data: function data() {
        return {
            expenseById: {},
            liabilityById: {},
            bankAccountById: {},
            incomeById: {},
            staffById: {},
            assetById: {}
        };
    },
    created: function created() {
        this.$bindAsArray('accounts', this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
        this.$bindAsObject('bankAccountById', this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
        this.$bindAsObject('expenseById', this.$root.$firebaseRefs.expenses.orderByChild('brand').equalTo(this.selectedBrand));
        this.$bindAsObject('liabilityById', this.$root.$firebaseRefs.liabilities.orderByChild('brand').equalTo(this.selectedBrand));
        this.$bindAsObject('incomeById', this.$root.$firebaseRefs.incomes.orderByChild('brand').equalTo(this.selectedBrand));
        this.$bindAsObject('assetById', this.$root.$firebaseRefs.assets.orderByChild('brand').equalTo(this.selectedBrand));
        this.$bindAsObject('staffById', this.$root.$firebaseRefs.staff.orderByChild('brand').equalTo(this.selectedBrand));
    },

    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand'])),
    methods: {
        updateInvoice: function updateInvoice(invoiceId, firmId) {
            var updatedInvoice = this.invoicesById[invoiceId];
            updatedInvoice['firm'] = firmId;
            this.$root.$firebaseRefs.invoice.child(invoiceId).set(updatedInvoice);
        },
        firmNameById: function firmNameById(id) {
            var firm = this.firms.filter(function (item) {
                return item['.key'] == id;
            })[0];
            if (firm) {
                return firm['name'];
            }
        },
        expenseNameById: function expenseNameById(id) {
            if (this.expenseById[id]) {
                return this.expenseById[id]['expense'];
            }
        },
        liabilityNameById: function liabilityNameById(id) {
            if (this.liabilityById[id]) {
                return this.liabilityById[id]['liability'];
            }
        },
        bankAccountNameById: function bankAccountNameById(id) {
            if (this.bankAccountById[id]) {
                return this.bankAccountById[id]['bankName'];
            }
        },
        incomeNameById: function incomeNameById(id) {
            if (this.incomeById[id]) {
                return this.incomeById[id]['income'];
            }
        },
        assetNameById: function assetNameById(id) {
            if (this.assetById[id]) {
                return this.assetById[id]['asset'];
            }
        },
        staffNameById: function staffNameById(id) {
            if (this.staffById[id]) {
                return this.staffById[id]['staffName'];
            }
        },
        getNumberOfDaysFromStartDate: function getNumberOfDaysFromStartDate(createdAt, closedDate) {
            console.log(createdAt, closedDate);
            var startDate = DateTime.fromMillis(createdAt);
            if (!closedDate) {
                closedDate = DateTime.local();
            } else {
                closedDate = DateTime.fromMillis(closedDate);
            }
            var endDate = closedDate;
            var interval = Interval.fromDateTimes(startDate, endDate);
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(interval.length('days'));
        },
        getTotalAmount: function getTotalAmount(principal, rate, createdAt) {
            var time = this.getNumberOfDaysFromStartDate(createdAt) / 365;
            rate = rate * 12 / 100;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(principal * (1 + rate * time)).toFixed(2);
        },
        getInterestValue: function getInterestValue(principal, rate, createdAt) {
            return (this.getTotalAmount(principal, rate, createdAt) - __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(principal)).toFixed(2);
        },
        getVocherType: function getVocherType(invoice) {
            if (invoice.return) {
                if (invoice.isBuyer) {
                    return "Credit Note";
                } else {
                    return "Debit Note";
                }
            }
            if (invoice["type"] == "automatic invoice" && invoice.assetType) {
                return "asset";
            }
            if (invoice["type"] == "automatic invoice" && invoice.expenseType) {
                return "expense";
            }
            if (invoice["type"] == "automatic invoice" && invoice.liabilityType) {
                return "liability";
            }
            if (invoice["type"] == "automatic invoice" && invoice.incomeType) {
                return "income";
            }
            if (invoice["type"] == "automatic invoice" && invoice.staffType) {
                return "Staff";
            }
            if (invoice["type"] == "automatic invoice" && invoice.transactionType === "Transfer") {
                return "Transfer";
            } else if (invoice.transactionType != "Debit" && invoice["type"] === "Advance" || invoice["type"] === "Opening Balance" || invoice["type"] === "LoanGiven" || invoice["type"] === "LoanTaken" || invoice["type"] === "Security") {
                return invoice["type"];
            } else if (invoice.isBuyer && invoice.transactionType === "Debit") {
                return "Sale";
            } else if (invoice.isBuyer && invoice.transactionType === "Credit") {
                return "Receipt";
            } else if (invoice.isBuyer && invoice.transactionType === "Partial Paid") {
                return "Receipt";
            } else if (!invoice.isBuyer && invoice.transactionType === "Debit") {
                return "Purchase";
            } else if (!invoice.isBuyer && invoice.transactionType === "Credit") {
                return "Payment";
            } else if (!invoice.isBuyer && invoice.transactionType === "Partial Paid") {
                return "Payment";
            }
        }
    }
});

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Buyer")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      invoiceStep: 1,
      invoiceEditDialog: false,
      invoiceClosedDateEditDialog: false,
      currentInvoiceHistory: null,
      isStepper: false,
      invoiceDetails: null,
      invoiceDate: null,
      saveInvoiceHidden: true,
      customerID: '',
      currentUser: {},
      datepicker: null,
      datepicker2: null,
      datepicker3: null,
      invoiceProductListHeader: [{ text: "Name", value: "Name" }, { text: "HSN code", value: "HSN" }, { text: "Taxable rate", value: "Taxable" }, { text: "Unit", value: "Unit" }, { text: "Quantity", value: "quantity" }, { text: "Rate", value: "rate" }],
      invoiceHeader: [
      // { text: "Key", value: "Name" },
      { text: "Date", value: "Name", class: "font-weight-bold primary--text" }, { text: "Edit", value: "Name", class: "font-weight-bold primary--text" }, { text: "Invoice Id", value: "Name", class: "font-weight-bold primary--text" },
      // { text: "Name", value: "HSN" },
      { text: "Firm", value: "Taxable", class: "font-weight-bold primary--text" }, { text: "Total Paid Amount", value: "quantity", class: "font-weight-bold primary--text" }, { text: "Paid Amount", value: "quantity", class: "font-weight-bold primary--text" }, { text: "Remaining Amount", value: "quantity", class: "font-weight-bold primary--text" }, { text: "Total Amount", value: "Unit", class: "font-weight-bold primary--text" }, { text: "Basic Amount", value: "Unit", class: "font-weight-bold primary--text" }, { text: "GST Amount", value: "Unit", class: "font-weight-bold primary--text" }, { text: "Discount", value: "Unit", class: "font-weight-bold primary--text" }, { text: "Duration", value: "Unit", class: "font-weight-bold primary--text" }, { text: "Payment type", value: "quantity", class: "font-weight-bold primary--text" },
      // { text: "Transaction Type", value: "Unit", class:"font-weight-bold primary--text" },
      { text: "Status", value: "Unit", class: "font-weight-bold primary--text" }, { text: "GST type", value: "Unit", class: "font-weight-bold primary--text" }, { text: "Closed Date", value: "Unit", class: "font-weight-bold grey--text" }, { text: "Delete", value: "delete", class: "font-weight-bold grey--text" }]
    };
  },
  mounted: function mounted() {
    this.getCurrentUser();
  },
  created: function created() {
    this.$bindAsArray("invoiceHistory", this.$root.$firebaseRefs.invoiceHistory.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("buyerById", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsObject("sellerById", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("invoiceById", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "brandFinYear"]), mapBuyerGetters(["selectedBuyer"]), {
    invoiceHistoryList: function invoiceHistoryList() {
      var _this = this;

      if (!this.invoiceDetails) {
        this.getInvoiceObj();
      }
      var invoiceHistory = this.invoiceHistory.filter(function (item) {
        return item["parentInvoiceKey"] === _this.$route.params.invoiceId;
      });
      this.customerID = invoiceHistory.length && invoiceHistory[0].buyerId;
      return invoiceHistory;
    }
  }),
  methods: {
    editHistory: function editHistory(history) {
      var copy = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, history);
      if (confirm("Are you sure?")) {
        var key = copy['.key'];
        delete copy['.key'];
        this.$root.$firebaseRefs.invoiceHistory.child(key).set(copy);
      }
    },
    getInvoiceObj: function getInvoiceObj() {
      this.invoiceDetails = this.invoiceById[this.$route.params.invoiceId];
      if (this.invoiceDetails) {
        this.invoiceDate = new Date(this.invoiceDetails.date).toISOString().substr(0, 10);
      }
    },
    editInvoice: function editInvoice(inv) {
      this.invoiceEditDialog = true;
      this.currentInvoiceHistory = inv;
      this.currentInvoiceHistory.date = new Date(inv.date).toISOString().substr(0, 10);
    },
    editInvoiceClosedDate: function editInvoiceClosedDate(inv) {
      this.invoiceClosedDateEditDialog = true;
      this.currentInvoiceHistory = inv;
      this.currentInvoiceHistory.closedDate = new Date(inv.closedDate).toISOString().substr(0, 10);
    },
    saveInvoiceHistory: function saveInvoiceHistory() {
      this.$root.$firebaseRefs.invoiceHistory.child(this.currentInvoiceHistory['.key']).update({
        date: new Date(this.currentInvoiceHistory.date).getTime()
      });
      this.invoiceEditDialog = false;
    },
    saveClosedDateInvoiceHistory: function saveClosedDateInvoiceHistory() {
      this.$root.$firebaseRefs.invoiceHistory.child(this.currentInvoiceHistory['.key']).update({
        closedDate: new Date(this.currentInvoiceHistory.closedDate).getTime()
      });
      this.invoiceClosedDateEditDialog = false;
    },
    saveInvoiceDate: function saveInvoiceDate() {
      this.$root.$firebaseRefs.invoice.child(this.$route.params.invoiceId).update({
        date: new Date(this.invoiceDate).getTime()
      });
      this.saveInvoiceHidden = true;
    },
    editMainInvoiceDate: function editMainInvoiceDate() {
      this.saveInvoiceHidden = false;
    },
    deleteHistory: function deleteHistory(inv) {
      this.currentInvoiceHistory = inv;
      if (window.confirm("Do you want to Delete Invoice History ?")) {
        // this.$root.$firebaseRefs.invoiceHistory.child(invoiceHistory[".key"]).remove();
        this.$root.$firebaseRefs.invoiceHistory.child(this.currentInvoiceHistory['.key']).remove();
        //this.addRemainingBalance();
      }
    },
    getFirmName: function getFirmName(firmId) {
      if (this.firms && this.firms[firmId]) {
        return this.firms[firmId]["name"];
      }
      return "--";
    },
    getCurrentUser: function getCurrentUser() {
      var buyer = this.buyerById[this.selectedBuyer];
      var seller = this.sellerById[this.selectedBuyer];
      this.isUserBuyer = buyer ? true : false;
      this.currentUser = buyer && buyer.state ? buyer : seller && seller.state ? seller : {};
    },
    getCustomerName: function getCustomerName(id) {
      var buyer = this.buyerById[id];
      var seller = this.sellerById[id];
      return buyer ? buyer.name : seller.name;
    },
    getGSTtotal: function getGSTtotal(item) {
      var GSTTotal = 0;
      item && item.items && item.items.map(function (item) {
        GSTTotal += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
      });
      return GSTTotal;
    }
  }
});

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);






var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      payoffType: Boolean,
      selectedFirm: null,
      remainingAmount: 0,
      paymentType: "",
      selectedBank: null,
      payoffAmount: 0,
      ispayDisable: false,
      transferType: 0,
      amountFromCash: 0,
      amountFromBank: 0,
      insufficientError: 0,
      transferTypeDialog: false,
      totalRemainingAmount: 0,
      isBuyer: null,
      datepicker: false,
      selectedDate: new Date().toISOString().substr(0, 10),
      currentUser: null,
      dueAmount: {
        checked: false,
        amount: 0,
        selectedAmount: 0,
        selectedDiscountAmount: 0,
        discountAmount: 0,
        invoices: [],
        expand: true
      },
      advanceDeposit: {
        checked: false,
        amount: 0,
        selectedAmount: 0,
        invoices: [],
        expand: true
      },
      securityDeposit: {
        checked: false,
        amount: 0,
        selectedAmount: 0,
        invoices: [],
        expand: true
      },
      openingBalance: {
        checked: false,
        amount: 0,
        selectedAmount: 0,
        invoices: [],
        expand: true
      },
      transferDetails: {
        accountNumber: "",
        accountHolderName: "",
        bankName: "",
        IFSCcode: "",
        remark: ""
      }
    };
  },
  mounted: function mounted() {
    this.getCurrentUserDetails();
  },
  created: function created() {
    this.$bindAsArray("customerDeposit", this.$root.$firebaseRefs.customerDeposit.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("banks", this.$root.$firebaseRefs.account.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsObject("buyerById", this.$root.$firebaseRefs.buyer.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsObject("sellerById", this.$root.$firebaseRefs.seller.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsObject("firmById", this.$root.$firebaseRefs.firm.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("invoice", this.$root.$firebaseRefs.invoice.orderByChild("brand").equalTo(this.selectedBrand));
    this.getData();
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand"]), {
    firmsByBrand1: function firmsByBrand1() {
      var _this = this;

      return this.firms.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      });
    },

    // current brands firm list
    firmsByBrand: function firmsByBrand() {
      var _this2 = this;

      // return selected brand firms
      var firmsB = this.firms.filter(function (item) {
        return item["brand"] === _this2.selectedBrand;
      });
      firmsB.map(function (item) {
        if (item.defaultFirm) {
          _this2.selectedFirm = item;
        }
      });
      return firmsB;
    },
    banksByFirms: function banksByFirms() {
      var _this3 = this;

      return this.banks.filter(function (item) {
        return item["brand"] === _this3.selectedBrand && item["firm"] === _this3.selectedFirm[".key"];
      });
    }
  }),
  methods: (_methods = {
    toggle: function toggle(item) {
      item.expand = !item.expand;
    },
    getFirmName: function getFirmName(firmId) {
      if (firmId && this.firms) {
        return this.firms.filter(function (item) {
          return item[".key"] === firmId;
        })[0]["name"];
      }
      return "--";
    },
    getData: function getData() {
      this.buyerInvoices();
      this.advanceDepositListByCustomer();
      this.openingBalanceListByCustomer();
      this.securityDepositListByCustomer();
      this.calculateFromChecked();
    },
    payAmount: function payAmount() {
      var _this4 = this;

      this.getCurrentUserDetails();
      var settledInvoiceDetails = [];
      this.dueAmount.invoices.map(function (invoice, index) {
        var pendingAmount = invoice.paidAmount ? parseFloat(invoice.totalAmount) - parseFloat(invoice.paidAmount) : parseFloat(invoice.totalAmount);
        pendingAmount = parseFloat(pendingAmount);
        if (invoice.checked) {
          _this4.dueAmount.invoices[index]["closedDate"] = new Date(_this4.selectedDate).getTime();
          _this4.dueAmount.invoices[index]["status"] = "paid";
          // this.dueAmount.invoices[index]['paidAmount'] = invoice.paidAmount;
          if (_this4.paymentType == "Cash") {
            _this4.dueAmount.invoices[index]["amountFromCash"] = pendingAmount;
          } else if (_this4.paymentType == "Bank Account") {
            _this4.dueAmount.invoices[index]["amountFromBank"] = pendingAmount;
            _this4.dueAmount.invoices[index]["bank"] = _this4.selectedBank[".key"];
            _this4.dueAmount.invoices[index]["transferType"] = _this4.transferType;
            _this4.dueAmount.invoices[index]["transferDetails"] = _this4.transferDetails;
          } else {
            _this4.dueAmount.invoices[index]["amountFromCash"] = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(pendingAmount) / 2;
            _this4.dueAmount.invoices[index]["amountFromBank"] = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(pendingAmount) / 2;
            _this4.dueAmount.invoices[index]["bank"] = _this4.selectedBank[".key"];
            _this4.dueAmount.invoices[index]["transferType"] = _this4.transferType;
            _this4.dueAmount.invoices[index]["transferDetails"] = _this4.transferDetails;
          }
          // this.dueAmount.invoices[index]['amountFromBank'] = invoice.totalAmount;
          _this4.dueAmount.invoices[index]["transactionType"] = "Credit";
          _this4.dueAmount.invoices[index]["paymentType"] = _this4.paymentType;
          _this4.dueAmount.invoices[index]["remainingAmount"] = 0;
          // this.dueAmount.invoices[index]['date'] = new Date(this.selectedDate).getTime();

          var amountToBePaid = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(_this4.dueAmount.invoices[index].amountFromCash) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(_this4.dueAmount.invoices[index].amountFromBank);
          settledInvoiceDetails.push({
            invoiceId: _this4.dueAmount.invoices[index][".key"],
            settledAmount: amountToBePaid,
            status: _this4.dueAmount.invoices[index].status
          });
          _this4.updateInvoice(_this4.dueAmount.invoices[index]);
        }
      });
      if (settledInvoiceDetails.length) {
        var firm = this.firms.find(function (item) {
          return item[".key"] == _this4.selectedFirm[".key"];
        });
        var firmReceiptCount = this.isBuyer ? firm.lastReceiptCount ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int___default()(firm.lastReceiptCount) + 1 : 1 : firm.lastReceiptCountSeller ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int___default()(firm.lastReceiptCountSeller) + 1 : 1;
        var amountToBePaid = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.amountFromCash) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.amountFromBank);
        var receipt = {
          date: new Date(this.selectedDate).getTime(),
          firm: this.selectedFirm[".key"],
          isBuyer: this.isBuyer,
          buyerId: this.$route.params.customerId,
          brand: this.selectedBrand,
          amount: amountToBePaid,
          remainingAmount: 0,
          paymentType: this.paymentType,
          receiptNumber: firmReceiptCount,
          settledInvoiceDetails: settledInvoiceDetails
        };

        if (this.paymentType == "Bank") {
          receipt["transferType"] = this.transferType;
          receipt["transferDetails"] = this.transferDetails;
        }
        // console.log(receipt);
        this.$root.$firebaseRefs.customerPayments.push(receipt);
        if (this.isBuyer) {
          this.$root.$firebaseRefs.firm.child(receipt.firm).update({
            lastReceiptCount: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int___default()(receipt.receiptNumber)
          }, function () {
            //console.info("last receiptNumber updated...");
          });
        } else {
          this.$root.$firebaseRefs.firm.child(receipt.firm).update({
            lastReceiptCountSeller: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int___default()(receipt.receiptNumber)
          }, function () {
            //console.info("last receiptNumber updated...");
          });
        };
      }
      this.managePayments();
      this.settleDeposites();
      // this.addRemainingBalance();
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "getFirmName", function getFirmName(firm) {
    return firm ? this.firmById[firm].name : "";
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "calculateFromChecked", function calculateFromChecked() {
    var _this5 = this;

    this.dueAmount.selectedAmount = 0;
    this.dueAmount.selectedDiscountAmount = 0;
    this.ispayDisable = false;
    this.dueAmount.invoices.map(function (inv) {
      if (inv.checked) {
        _this5.dueAmount.selectedAmount += __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(inv["remainingAmount"]);
        _this5.dueAmount.selectedDiscountAmount += __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(inv["discountAmount"]);
      }
    });
    this.openingBalance.selectedAmount = 0;
    this.openingBalance.invoices.map(function (inv) {
      if (inv.checked) {
        _this5.openingBalance.selectedAmount += __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(inv["amount"]);
        if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(inv.amount) > __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(inv.staticAmount)) {
          _this5.ispayDisable = true;
        }
      }
    });

    this.securityDeposit.selectedAmount = 0;
    this.securityDeposit.invoices.map(function (inv) {
      if (inv.checked) {
        _this5.securityDeposit.selectedAmount += __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(inv["amount"]);
        if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(inv.amount) > __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(inv.staticAmount)) {
          _this5.ispayDisable = true;
        }
      }
    });

    this.advanceDeposit.selectedAmount = 0;
    this.advanceDeposit.invoices.map(function (inv) {
      if (inv.checked) {
        _this5.advanceDeposit.selectedAmount += __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(inv["amount"]);
        if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(inv.amount) > __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(inv.staticAmount)) {
          _this5.ispayDisable = true;
        }
      }
    });

    this.payoffAmount = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.openingBalance.selectedAmount) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.dueAmount.selectedAmount) - (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.advanceDeposit.selectedAmount) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.securityDeposit.selectedAmount) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.dueAmount.selectedDiscountAmount));
    this.totalRemainingAmount = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.openingBalance.amount) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.dueAmount.amount) - (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.advanceDeposit.amount) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.securityDeposit.amount) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.dueAmount.discountAmount));
    this.remainingAmount = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.totalRemainingAmount) - __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.payoffAmount);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "buyerInvoices", function buyerInvoices() {
    var _this6 = this;

    this.dueAmount.invoices = this.invoice.filter(function (item) {
      return item["brand"] === _this6.selectedBrand && item.deleted != true && item["buyerId"] === _this6.$route.params.customerId && (item["status"] === "due" || item["status"] === "partial") && (_this6.selectedFirm ? item["firm"] === _this6.selectedFirm[".key"] : true);
    });
    this.dueAmount.amount = 0;
    this.dueAmount.discountAmount = 0;
    this.dueAmount.invoices.map(function (inv, index) {
      _this6.dueAmount.invoices[index]["checked"] = false;
      _this6.dueAmount.amount += __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(inv.remainingAmount);
      _this6.dueAmount.discountAmount += __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(inv.discountAmount);
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "advanceDepositListByCustomer", function advanceDepositListByCustomer() {
    var _this7 = this;

    this.advanceDeposit.invoices = this.customerDeposit.filter(function (item) {
      return item["brand"] === _this7.selectedBrand && item["buyerId"] === _this7.$route.params.customerId && item["type"] === "Advance" && !!item["isUserCreated"] && parseInt(item["remainingAmount"]) > 0 && (_this7.selectedFirm ? item["firm"] === _this7.selectedFirm[".key"] : true);
    });
    this.advanceDeposit.amount = 0;
    this.advanceDeposit.invoices.map(function (inv, index) {
      _this7.advanceDeposit.amount += __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(inv.amount);
      _this7.advanceDeposit.invoices[index]["checked"] = false;
      _this7.advanceDeposit.invoices[index]["amount"] = inv.remainingAmount;
      _this7.advanceDeposit.invoices[index]["staticAmount"] = inv.remainingAmount;
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "openingBalanceListByCustomer", function openingBalanceListByCustomer() {
    var _this8 = this;

    this.openingBalance.invoices = this.customerDeposit.filter(function (item) {
      return item["brand"] === _this8.selectedBrand && item["buyerId"] === _this8.$route.params.customerId && item["type"] === "Opening Balance" && !!item["isUserCreated"] && parseInt(item["remainingAmount"]) > 0 && (_this8.selectedFirm ? item["firm"] === _this8.selectedFirm[".key"] : true);
    });
    this.openingBalance.amount = 0;
    this.openingBalance.invoices.map(function (inv, index) {
      _this8.openingBalance.amount += __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(inv.amount);
      _this8.openingBalance.invoices[index]["checked"] = false;
      _this8.openingBalance.invoices[index]["amount"] = inv.remainingAmount;
      _this8.openingBalance.invoices[index]["staticAmount"] = inv.remainingAmount;
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "securityDepositListByCustomer", function securityDepositListByCustomer() {
    var _this9 = this;

    this.securityDeposit.invoices = this.customerDeposit.filter(function (item) {
      return item["brand"] === _this9.selectedBrand && item["buyerId"] === _this9.$route.params.customerId && item["type"] === "Security" && !!item["isUserCreated"] && parseInt(item["remainingAmount"]) > 0 && (_this9.selectedFirm ? item["firm"] === _this9.selectedFirm[".key"] : true);
    });
    this.securityDeposit.amount = 0;
    this.securityDeposit.invoices.map(function (inv, index) {
      _this9.securityDeposit.amount += __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(inv.amount);
      _this9.securityDeposit.invoices[index]["checked"] = false;
      _this9.securityDeposit.invoices[index]["amount"] = inv.remainingAmount;
      _this9.securityDeposit.invoices[index]["staticAmount"] = inv.remainingAmount;
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "updateInvoice", function updateInvoice(invoiceData) {
    var _this10 = this;

    console.info(invoiceData);
    var updated_at = new Date().getTime();
    try {
      invoiceData["items"].forEach(function (item, index) {
        item["date"] = invoiceData["date"];
        if (item.id) {
          item["updated_at"] = updated_at;
          _this10.$root.$firebaseRefs.item.child(item["id"]).update(item, function () {
            console.info("item udpated...");
          });
        } else {
          var response = _this10.$root.$firebaseRefs.item.push(item, function () {
            console.info("item pushed...");
          });
          invoiceData["items"][index]["id"] = response["key"];
        }
      });
      invoiceData["updated_at"] = updated_at;
      var key = invoiceData[".key"];
      delete invoiceData[".key"];

      this.$root.$firebaseRefs.invoice.child(key).update(invoiceData, function () {
        console.info("invoice updated...");
        _this10.updateInvoiceDialog = false;
      });
      invoiceData["parentInvoiceKey"] = key;
      delete invoiceData["newlyCreated"];
      this.$root.$firebaseRefs.invoiceHistory.push(invoiceData);
    } catch (e) {
      console.info("Error at update Invoice", e);
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "managePayments", function managePayments() {
    var _this11 = this;

    switch (this.paymentType) {
      case "Cash":
        {
          if (this.amountFromCash) {
            var firm = this.selectedFirm;
            if (firm) {
              firm.amount = this.isBuyer ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(firm.amount) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.amountFromCash) : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(firm.amount) - __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.amountFromCash);
              if (firm.amount < 0) {
                this.insufficientError = "Insufficient balance.";
                setTimeout(function () {
                  _this11.insufficientError = null;
                }, 3000);
              } else {
                var key = firm[".key"];
                delete firm[".key"];
                this.$root.$firebaseRefs.firm.child(key).set(firm);
              }
            }
          }
          break;
        }
      case "Bank Account":
        {
          if (this.amountFromBank) {
            var bank = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.selectedBank));
            if (bank) {
              bank.amount = this.isBuyer ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(bank.amount) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.amountFromBank) : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(bank.amount) - __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.amountFromBank);
              if (bank.amount < 0) {
                this.insufficientError = "Insufficient balance.";
                setTimeout(function () {
                  _this11.insufficientError = null;
                }, 3000);
              } else {
                var _key = bank[".key"];
                delete bank[".key"];
                this.$root.$firebaseRefs.account.child(_key).set(bank);
              }
            }
          }
          break;
        }
      case "CashAndBank Account":
        {
          if (this.amountFromCash && this.amountFromBank) {
            var _bank = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.selectedBank));
            if (_bank) {
              _bank.amount = this.isBuyer ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(_bank.amount) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.amountFromBank) : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(_bank.amount) - __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.amountFromBank);
              if (_bank.amount < 0) {
                this.insufficientError = "Insufficient balance.";
                setTimeout(function () {
                  _this11.insufficientError = null;
                }, 3000);
              } else {
                var _key2 = _bank[".key"];
                delete _bank[".key"];
                this.$root.$firebaseRefs.account.child(_key2).set(_bank);
              }
            }
            var _firm = this.selectedFirm;
            if (_firm) {
              _firm.amount = this.isBuyer ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(_firm.amount) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.amountFromCash) : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(_firm.amount) - __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.amountFromCash);
              if (_firm.amount < 0) {
                this.insufficientError = "Insufficient balance.";
                setTimeout(function () {
                  _this11.insufficientError = null;
                }, 3000);
              } else {
                var _key3 = _firm[".key"];
                delete _firm[".key"];
                this.$root.$firebaseRefs.firm.child(_key3).set(_firm);
              }
            }
          }
          break;
        }
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "getCurrentUserDetails", function getCurrentUserDetails() {
    var buyer = this.buyerById[this.$route.params.customerId];
    var seller = this.sellerById[this.$route.params.customerId];
    this.currentUser = !!buyer ? buyer : seller;
    this.isBuyer = !!buyer ? true : false;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "settleDeposites", function settleDeposites() {
    var _this12 = this;

    this.advanceDeposit.invoices.map(function (invoice, index) {
      if (invoice.checked) {
        _this12.$root.$firebaseRefs.customerDeposit.child(_this12.advanceDeposit.invoices[index][".key"]).update({
          remainingAmount: _this12.advanceDeposit.invoices[index]["remainingAmount"] - _this12.advanceDeposit.invoices[index]["amount"]
        });
        _this12.advanceDeposit.invoices[index]["settledAmount"] = invoice["amount"];
        _this12.advanceDeposit.invoices[index]["amount"] = 0;
        _this12.advanceDeposit.invoices[index]["remainingAmount"] = 0;
        _this12.advanceDeposit.invoices[index]["isUserCreated"] = false;
        _this12.advanceDeposit.invoices[index]["date"] = new Date(_this12.selectedDate).getTime();
        delete _this12.advanceDeposit.invoices[index][".key"];
        _this12.$root.$firebaseRefs.customerDeposit.push(_this12.advanceDeposit.invoices[index]);
      }
    });
    this.securityDeposit.invoices.map(function (invoice, index) {
      if (invoice.checked) {
        _this12.$root.$firebaseRefs.customerDeposit.child(_this12.securityDeposit.invoices[index][".key"]).update({
          remainingAmount: _this12.securityDeposit.invoices[index]["remainingAmount"] - _this12.securityDeposit.invoices[index]["amount"]
        });
        _this12.securityDeposit.invoices[index]["settledAmount"] = invoice["amount"];
        _this12.securityDeposit.invoices[index]["amount"] = 0;
        _this12.securityDeposit.invoices[index]["remainingAmount"] = 0;
        _this12.securityDeposit.invoices[index]["isUserCreated"] = false;
        _this12.securityDeposit.invoices[index]["date"] = new Date(_this12.selectedDate).getTime();
        delete _this12.securityDeposit.invoices[index][".key"];
        _this12.$root.$firebaseRefs.customerDeposit.push(_this12.securityDeposit.invoices[index]);
      }
    });
    this.openingBalance.invoices.map(function (invoice, index) {
      if (invoice.checked) {
        _this12.$root.$firebaseRefs.customerDeposit.child(_this12.openingBalance.invoices[index][".key"]).update({
          remainingAmount: _this12.openingBalance.invoices[index]["remainingAmount"] - _this12.openingBalance.invoices[index]["amount"]
        });
        _this12.openingBalance.invoices[index]["settledAmount"] = invoice["amount"];
        _this12.openingBalance.invoices[index]["amount"] = 0;
        _this12.openingBalance.invoices[index]["remainingAmount"] = 0;
        _this12.openingBalance.invoices[index]["isUserCreated"] = false;
        _this12.openingBalance.invoices[index]["date"] = new Date(_this12.selectedDate).getTime();
        delete _this12.openingBalance.invoices[index][".key"];
        _this12.$root.$firebaseRefs.customerDeposit.push(_this12.openingBalance.invoices[index]);
      }
    });
    setTimeout(function () {
      _this12.$router.push({ path: "/buyers/" + _this12.$route.params.customerId });
    }, 1500);
  }), _methods),
  watch: {
    selectedFirm: {
      handler: function handler(newVal, oldVal) {
        this.getData();
      },

      deep: true
    },
    paymentType: {
      handler: function handler(newVal, oldVal) {
        switch (this.paymentType) {
          case "Cash":
            {
              this.amountFromCash = this.payoffAmount;
              this.amountFromBank = 0;
              break;
            }
          case "Bank Account":
            {
              this.amountFromCash = 0;
              this.amountFromBank = this.payoffAmount;
              break;
            }
          case "CashAndBank Account":
            {
              this.amountFromCash = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.payoffAmount) / 2;
              this.amountFromBank = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.payoffAmount) / 2;
            }
        }
      },

      deep: true
    }
  }
});

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AddItemMed__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AddItemDefault__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AddItemAuto__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AddItemDairy__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__AddItemClothes__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__AddItemJewl__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__AddItemGrain__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ewayBill__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils_pdfmake__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__services_twilio_js__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils___ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Products_addProduct__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_digitsToWords_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Buyers_Buyer_BuyerInfo_vue__ = __webpack_require__(148);










var _watch, _components$data$comp;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];

/* harmony default export */ __webpack_exports__["a"] = (_components$data$comp = {
  components: {
    AddProduct: __WEBPACK_IMPORTED_MODULE_21__Products_addProduct__["a" /* default */],
    AddItemMed: __WEBPACK_IMPORTED_MODULE_10__AddItemMed__["a" /* default */],
    AddItemDefault: __WEBPACK_IMPORTED_MODULE_11__AddItemDefault__["a" /* default */],
    AddItemAuto: __WEBPACK_IMPORTED_MODULE_12__AddItemAuto__["a" /* default */],
    AddItemClothes: __WEBPACK_IMPORTED_MODULE_14__AddItemClothes__["a" /* default */],
    AddItemJewl: __WEBPACK_IMPORTED_MODULE_15__AddItemJewl__["a" /* default */],
    AddItemDairy: __WEBPACK_IMPORTED_MODULE_13__AddItemDairy__["a" /* default */],
    AddItemGrain: __WEBPACK_IMPORTED_MODULE_16__AddItemGrain__["a" /* default */],
    EwayBill: __WEBPACK_IMPORTED_MODULE_17__ewayBill__["a" /* default */],
    BuyerInfo: __WEBPACK_IMPORTED_MODULE_23__Buyers_Buyer_BuyerInfo_vue__["default"]
  },
  data: function data() {
    return {
      buyerDialog: false,
      isSaving: false,
      invoiceImages: [],
      multiFirmData: [],
      multiFirmIndex: 0,
      multiFirmItems: [],
      multiFirmPayment: false,
      branch: null,
      stepperValue: 1,
      addProductDialog: false,
      discountPercentage: 0,
      isDiscountPercentage: false,
      updateLastCount: false,
      lastCountDate: null,
      currentProduct: {
        name: "",
        description: "",
        HSN_code: 0,
        GST_type: "",
        taxableGST_rate: 0,
        unit: "",
        quantity: 0,
        brand: "",
        openingDate: new Date().toISOString().substr(0, 10),
        purchasingPrice: null,
        sellingPrice: null,
        openingBalance: null,
        gstValue: 0,
        basicPrice: 0,
        barcode: "",
        productGroup: null,
        productCategory: null,
        productType: null,
        unitsDetails: [{
          unit: "",
          isLast: true,
          isFirst: true,
          order: 1,
          quantity: 0,
          rate: true
        }],
        unitsDeatilsAdded: false
      },
      selectedProductSet: null,
      lastInvoiceCount: null,
      otpData: {
        otp: null,
        mobile: null,
        dialog: false,
        confirmOtp: null
      },
      dialog: false,
      billingDetailsDialog: false,
      isIncentive: false,
      incentives: [],
      extraCharges: [],
      gstOnExtraChanrges: false,
      extraChargesSample: [{
        name: "Freight Charge",
        amount: 0
      }, {
        name: "Labour Charge",
        amount: 0
      }, {
        name: "Making Charge",
        amount: 0
      }, {
        name: "Other Charge",
        amount: 0
      }, {
        name: "Service Charge",
        amount: 0
      }, {
        name: "TCS",
        amount: 0
      }],
      totalExtraCharges: 0,
      totalExtraChargesGST: 0,
      businessType: null,
      selectedBuyer: null,
      isBuyer: true,
      snackbarSuccess: false,
      isEditItems: false,
      gstInvoice: false,
      duplicateError: null,
      selectedFirmState: null,
      items: [],
      totalTradeDiscount: 0,
      totalSpecialCharge: 0,
      editedIndex: -1,
      editedItem: {
        productName: "",
        productId: "",
        HSN_code: "",
        taxableGST_rate: 0,
        rate: 0,
        unit: "",
        quantity: 1,
        basicPrice: 0,
        GSTValue: 0,
        totlePrice: 0,
        tradeDiscount: 0,
        specialCharge: 0,
        expiryDate: new Date(new Date().setFullYear(new Date().getFullYear() + 100)).toISOString().substr(0, 10),
        manufacturingDate: new Date(new Date().setFullYear(new Date().getFullYear() + 100)).toISOString().substr(0, 10),
        batchNumber: "DEFAULT"
      },
      defaultItem: {
        productName: "",
        productId: "",
        HSN_code: "",
        taxableGST_rate: 0,
        rate: 0,
        unit: "",
        quantity: 1,
        basicPrice: 0,
        GSTValue: 0,
        totlePrice: 0,
        tradeDiscount: 0,
        specialCharge: 0,
        expiryDate: new Date(new Date().setFullYear(new Date().getFullYear() + 100)).toISOString().substr(0, 10),
        manufacturingDate: new Date(new Date().setFullYear(new Date().getFullYear() + 100)).toISOString().substr(0, 10),
        batchNumber: "DEFAULT"
      },
      amountFromCash: 0,
      amountFromBank: 0,
      alertDuration: 0,
      paymentType: "",
      selectedFirm: "",
      selectedBank: "",
      soldBy: "",
      brokerageRate: 0,
      godawnBy: null,
      placeOfSupply: "",
      invoiceDate: new Date().toISOString().substr(0, 10),
      dateFormatted: new Date().toISOString().substr(0, 10),
      datepicker: false,
      totalAmount: 0,
      paidAmount: 0,
      remainingAmount: 0,
      discountAmount: 0,
      roundOffAmount: 0,
      invoiceDraft: {},
      transferType: null,
      transferTypeDialog: false,
      availableBalance: 0,
      firms: [],
      staffs: [],
      // godawns: [],
      banks: [],
      transactionType: "Debit",
      amountFromCashDisabled: true,
      amountFromBankDisabled: true,
      status: "due",
      gstType: null,
      remark: null,
      invoiceIdPrefix: "",
      invoiceIdPostfix: "",
      invoiceId: null,
      snackbar: null,
      snackbarMsg: null,
      GST_Val_total: {
        CGST_val: 0,
        SGST_val: 0,
        IGST_val: 0
      },
      GST_Percentage_total: {
        GST_3: 0,
        GST_5: 0,
        GST_12: 0,
        GST_18: 0,
        GST_28: 0
      },
      roundOff: 2,
      transactionDialog: false,
      expansionVal: false,
      transferDetails: {
        accountNumber: null,
        accountHolderName: null,
        bankName: null,
        IFSCcode: null,
        remark: null
      },
      orderNumber: null,
      applicationNumber: null,
      sanctionDatepicker: null,
      sanctionDate: null,
      orderDatepicker: null,
      orderDate: null,
      billingDetails: {
        name: null,
        mobile: null,
        address: null
      },
      hintText: null
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear", "adminEmail", "roleAndPermission", "brandFinYear"]), mapGlobalGetters({
    gState: "state"
  }), {
    godawnByBrand: function godawnByBrand() {
      var _this = this;

      return this.godawns.filter(function (item) {
        return;
        item["brand"] === _this.selectedBrand;
      }).map(function (item) {
        return {
          text: item["godawnName"],
          value: item[".key"]
        };
      });
    },
    firmSetting: function firmSetting() {
      var _this2 = this;

      if (this.selectedFirm) {
        return this.firmSettings.filter(function (item) {
          return item["firm"] == _this2.selectedFirm;
        })[0];
      }
    },
    branchByBrand: function branchByBrand() {
      var _this3 = this;

      return this.branches.filter(function (item) {
        return item["brand"] === _this3.selectedBrand;
      }).map(function (item) {
        return {
          text: item["branchName"],
          value: item[".key"]
        };
      });
    },
    getHeaders: function getHeaders() {
      if (this.gstInvoice) {
        return [{
          text: "Name",
          sortable: false,
          value: "productName",
          class: "font-weight-bold primary--text"
        }, {
          text: "Unit",
          sortable: false,
          value: "unit",
          class: "font-weight-bold primary--text"
        }, {
          text: "Quantity",
          sortable: false,
          value: "quantity",
          class: "font-weight-bold primary--text"
        }, {
          text: "Rate",
          sortable: false,
          value: "rate",
          class: "font-weight-bold primary--text"
        }, {
          text: "NW",
          sortable: false,
          value: "netWeight",
          class: "font-weight-bold primary--text"
        }, {
          text: "Extra Charge",
          sortable: false,
          value: "specialCharge",
          class: "font-weight-bold primary--text"
        }, {
          text: "Trade %",
          sortable: false,
          value: "tradeDiscount",
          class: "font-weight-bold primary--text"
        }, {
          text: "Taxable Amount",
          sortable: false,
          value: "basicPrice",
          class: "font-weight-bold primary--text"
        }, {
          text: "GST ",
          sortable: false,
          value: "GSTValue",
          class: "font-weight-bold primary--text"
        }, {
          text: "Total Amount",
          sortable: false,
          value: "totlePrice",
          class: "font-weight-bold primary--text"
        }, {
          text: "CGST ",
          sortable: false,
          value: "CGST",
          class: "font-weight-bold primary--text"
        }, {
          text: "SGST ",
          sortable: false,
          value: "SGST",
          class: "font-weight-bold primary--text"
        }, {
          text: "IGST ",
          sortable: false,
          value: "IGST",
          class: "font-weight-bold primary--text"
        }, {
          text: "Action ",
          sortable: false,
          value: "action",
          class: "font-weight-bold primary--text"
        }];
      } else {
        return [{
          text: "Name",
          sortable: false,
          value: "productName",
          class: "font-weight-bold primary--text"
        }, {
          text: "Unit",
          sortable: false,
          value: "unit",
          class: "font-weight-bold primary--text"
        }, {
          text: "Quantity",
          sortable: false,
          value: "quantity",
          class: "font-weight-bold primary--text"
        }, {
          text: "Rate",
          sortable: false,
          value: "rate",
          class: "font-weight-bold primary--text"
        }, {
          text: "Basic Price",
          sortable: false,
          value: "basicPrice",
          class: "font-weight-bold primary--text"
        }, {
          text: "Trade Discount",
          sortable: false,
          value: "totlePrice",
          class: "font-weight-bold primary--text"
        }, {
          text: "Extra Charge",
          sortable: false,
          value: "specialCharge",
          class: "font-weight-bold primary--text"
        }, {
          text: "Total Price",
          sortable: false,
          value: "totlePrice",
          class: "font-weight-bold primary--text"
        }, {
          text: "Action ",
          sortable: false,
          value: "action",
          class: "font-weight-bold primary--text"
        }, { text: "", value: "name", sortable: false }];
      }
    },
    buyersByBrand: function buyersByBrand() {
      var _this4 = this;

      return this.buyers.filter(function (item) {
        return item["brand"] === _this4.selectedBrand;
      });
    },
    sellersByBrand: function sellersByBrand() {
      var _this5 = this;

      return this.sellers.filter(function (item) {
        return item["brand"] === _this5.selectedBrand;
      });
    },
    ProductSetByBrand: function ProductSetByBrand() {
      var _this6 = this;

      return this.productSets.filter(function (item) {
        return item["brand"] === _this6.selectedBrand;
      });
    },
    firmsByBrand: function firmsByBrand() {
      var _this7 = this;

      return this.firms.filter(function (item) {
        return item["brand"] === _this7.selectedBrand;
      }).map(function (item) {
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
    },
    staffByBrand: function staffByBrand() {
      var _this8 = this;

      return this.staffs.filter(function (item) {
        return item["brand"] === _this8.selectedBrand && item["firm"] === _this8.selectedFirm && item["staffRole"] === "Salesman" || "Commission";
      }).map(function (item) {
        return {
          text: item["staffName"],
          value: item[".key"]
        };
      });
    },
    banksByFirms: function banksByFirms() {
      var _this9 = this;

      return this.banks.filter(function (item) {
        return item["brand"] === _this9.selectedBrand && item["firm"] === _this9.selectedFirm;
      }).map(function (item) {
        return {
          account: item,
          text: item["bankName"],
          value: item[".key"]
        };
      });
    },
    totalItems: function totalItems() {
      return this.items.length || 0;
    },
    todaysDate: function todaysDate() {
      var date = new Date();
      return date.getDate() + "\\" + date.getMonth() + "\\" + date.getYear();
    },
    principalValueTotal: function principalValueTotal() {
      var total = this.items.reduce(function (accumulator, currentValue) {
        return accumulator + __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(currentValue.totlePrice);
      }, 0);
      total += __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(this.totalExtraCharges);
      total += __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(this.totalExtraChargesGST);
      total -= __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(this.discountAmount);
      // console.log(total)
      var newtotal = Math.round(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(total));
      //  console.log(newtotal)
      this.roundOffAmount = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(newtotal - total).toFixed(this.roundOff);
      return newtotal;
    },
    getCGSTAmount: function getCGSTAmount() {
      if (this.gstOnExtraChanrges && this.gstType == "SGST|CGST" && this.totalExtraChargesGST) {
        return (__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(this.totalExtraChargesGST) / 2 + __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(this.GST_Val_total.CGST_val)).toFixed(2);
      } else {
        return this.GST_Val_total.CGST_val.toFixed(2);
      }
    },
    getSGSTAmount: function getSGSTAmount() {
      if (this.gstOnExtraChanrges && this.gstType == "SGST|CGST" && this.totalExtraChargesGST) {
        return (__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(this.totalExtraChargesGST) / 2 + __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(this.GST_Val_total.SGST_val)).toFixed(2);
      } else {
        return this.GST_Val_total.SGST_val.toFixed(2);
      }
    },
    getIGSTAmount: function getIGSTAmount() {
      if (this.gstOnExtraChanrges && this.gstType == "IGST" && this.totalExtraChargesGST) {
        return (__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(this.totalExtraChargesGST) + __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(this.GST_Val_total.IGST_val)).toFixed(2);
      } else {
        return this.GST_Val_total.IGST_val.toFixed(2);
      }
    }
  }),
  mounted: function mounted() {
    this.getCurrentUser();
  },
  updated: function updated() {
    this.expansionVal = true;
  },
  created: function created() {
    var _this10 = this;

    if (this.roleAndPermission && this.roleAndPermission.branch) {
      this.branch = this.roleAndPermission.branch;
    }
    this.invoiceDraft = {
      items: this.items,
      amountFromCash: this.amountFromCash || 0,
      amountFromBank: this.amountFromBank || 0,
      brand: this.selectedBrand,
      brandFinYear: this.brandFinYear,
      date: Date.now(),
      transferDetails: this.transferDetails,
      transferType: ["Cash", ""].includes(this.paymentType) ? "0" : this.transferType,
      duration: this.alertDuration, // days
      paymentType: this.paymentType,
      transactionType: this.transactionType,
      isCredited: false,
      firm: this.selectedFirm,
      bank: ["Cash", ""].includes(this.paymentType) ? 0 : this.selectedBank,
      totalAmount: this.principalValueTotal || 0,
      paidAmount: this.paidAmount || 0,
      remainingAmount: this.remainingAmount || 0,
      discountAmount: this.discountAmount || 0,
      roundOffAmount: this.roundOffAmount || 0,
      status: this.status,
      gstType: this.gstType,
      invoiceId: this.invoiceId,
      soldBy: this.soldBy,
      brokerageRate: this.brokerageRate || 0,
      // godawnBy : this.godawnBy,
      placeOfSupply: this.placeOfSupply,
      totalTradeDiscount: this.totalTradeDiscount,
      totalSpecialCharge: this.totalSpecialCharge,
      remark: this.remark,
      applicationNumber: this.applicationNumber,
      sanctionDate: this.sanctionDate,
      orderDate: this.orderDate
    };
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("staffs", this.$root.$firebaseRefs.staff.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("godawns", this.$root.$firebaseRefs.godawn), this.$bindAsArray("banks", this.$root.$firebaseRefs.account.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("buyers", this.$root.$firebaseRefs.buyer.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("sellers", this.$root.$firebaseRefs.seller.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsObject("firmById", this.$root.$firebaseRefs.firm.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsObject("bankById", this.$root.$firebaseRefs.account.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("termsAndConditions", this.$root.$firebaseRefs.termsAndConditions.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("firmSettings", this.$root.$firebaseRefs.firmSettings.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("operatorsList", this.$root.$firebaseRefs.operator);
    // this.$bindAsArray("invoicesOfFirm", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));
    // this.$bindAsArray(
    //   "invoices",
    //   this.$root.$firebaseRefs.invoice
    //     .orderByChild("brandFinYear")
    //     .equalTo(this.brandFinYear)
    // );
    this.$bindAsArray("estimates", this.$root.$firebaseRefs.estimates.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsObject("productById", this.$root.$firebaseRefs.products.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsObject("orderById", this.$root.$firebaseRefs.orders.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsObject("estimateById", this.$root.$firebaseRefs.estimates.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("batch", this.$root.$firebaseRefs.batchTransaction.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("productSets", this.$root.$firebaseRefs.productSets.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("branches", this.$root.$firebaseRefs.branch.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("productUniqueIds", this.$root.$firebaseRefs.productUniqueId.orderByChild("brand").equalTo(this.selectedBrand));
    if (this.$route.params.orderId) {
      this.getProductsFromOrder();
    }
    if (this.$route.params.estimateId) {
      this.getProductsFromEstimate();
    }
    if (this.$route.params.customerId) {
      this.isBuyer = this.$route.params.isBuyer == "true" ? true : false;
      if (this.isBuyer) {
        this.selectedBuyer = this.buyers.filter(function (item) {
          return item[".key"] === _this10.$route.params.customerId;
        })[0];
      } else {
        this.selectedBuyer = this.sellers.filter(function (item) {
          return item[".key"] === _this10.$route.params.customerId;
        })[0];
      }
      this.getCurrentUser();
    }
  },

  watch: (_watch = {
    items: {
      handler: function handler(newVal, oldVal) {
        this.updateAndEmit("totalAmount", this.principalValueTotal);
        this.totalAmount = this.principalValueTotal;
        this.calculateGSTType();
        this.calculateTotal();
        if (this.firmSetting.individualProdBrokerage) {
          this.calculateIndividualBrokerage();
        }
        // this.updateAndEmit('totalCurrentAmount', this.currentValueTotal)
      },

      deep: true
    },
    extraCharges: {
      handler: function handler(newVal, oldVal) {
        var _this11 = this;

        this.totalExtraCharges = 0;
        this.totalExtraChargesGST = 0;
        this.extraCharges.map(function (item, index) {
          if (!!_this11.extraCharges[index].gst) {
            _this11.extraCharges[index].gstAmount = _this11.extraCharges[index].gst * _this11.extraCharges[index].amount / 100;
            _this11.totalExtraChargesGST += __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(_this11.extraCharges[index].gstAmount);
          } else {
            _this11.extraCharges[index].gstAmount = 0;
          }
          _this11.totalExtraCharges += __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item.amount);
        });
        this.totalAmount = this.principalValueTotal;
        this.calculateTotal();
        this.updateAndEmit("extraCharges", this.extraCharges);
        this.updateAndEmit("gstOnExtraChanrges", this.gstOnExtraChanrges);
        this.updateAndEmit("totalAmount", this.principalValueTotal);
        if (this.firmSetting.individualProdBrokerage) {
          this.calculateIndividualBrokerage();
        }
      },

      deep: true
    },
    orderNumber: function orderNumber(newVal, oldVal) {
      if (!!newVal) this.updateAndEmit("orderNumber", newVal);
    },
    discountPercentage: function discountPercentage(newVal) {
      this.discountAmount = newVal * this.totalAmount / 100;
    },
    applicationNumber: function applicationNumber(newVal, oldVal) {
      if (!!newVal) this.updateAndEmit("applicationNumber", newVal);
    },
    sanctionDate: function sanctionDate(newVal, oldVal) {
      if (!!newVal) this.updateAndEmit("sanctionDate", new Date(newVal).getTime());
    },
    orderDate: function orderDate(newVal, oldVal) {
      if (!!newVal) this.updateAndEmit("orderDate", new Date(newVal).getTime());
    },
    isBuyer: function isBuyer(newVal, oldVal) {
      this.updateAndEmit("isBuyer", newVal);
      // this.items = [];
      // this.calculateGSTType();
      if (!this.$route.params.orderId && !this.$route.params.estimateId) {
        this.items = [];
        this.calculateGSTType();
      }
      if (this.$route.params.isBuyer != "false" && !this.$route.params.orderId && !this.$route.params.estimateId) {
        this.selectedBuyer = null;
      }
      if (!newVal) {
        this.invoiceId = null;
        this.invoiceIdPrefix = "";
        this.invoiceIdPostfix = "";
      } else {
        this.firmBasedInvoiceId(true);
      }
      // this.selectedBuyer = null;
    },
    invoiceIdPrefix: function invoiceIdPrefix(newVal, oldVal) {
      // this.invoiceId = newVal + "-" + this.invoiceIdPostfix;
      this.invoiceId = this.invoiceIdPrefix + "-" + parseInt(this.invoiceIdPostfix) == 0 ? 1 : this.invoiceIdPostfix;
      this.updateAndEmit("invoiceId", this.invoiceId);
    },
    invoiceIdPostfix: function invoiceIdPostfix(newVal, oldVal) {
      // this.invoiceId = this.invoiceIdPrefix + "-" + newVal;
      // this.lastInvoiceCount = newVal;
      this.invoiceId = this.invoiceIdPrefix + "-" + parseInt(this.invoiceIdPostfix) == 0 ? 1 : this.invoiceIdPostfix;
      this.lastInvoiceCount = parseInt(this.invoiceIdPostfix) == 0 ? 0 : this.invoiceIdPostfix;
      this.updateAndEmit("invoiceId", this.invoiceId);
    },
    selectedBrand: function selectedBrand(newVal, oldVal) {
      this.updateAndEmit("brand", newVal);
    },
    status: function status(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("status", newVal);
      }
    },

    transferDetails: {
      handler: function handler(newVal, oldVal) {
        if (newVal && this.invoiceDraft.transferDetails) {
          this.invoiceDraft.transferDetails.accountNumber = newVal.accountNumber;
          this.invoiceDraft.transferDetails.accountHolderName = newVal.accountHolderName;
          this.invoiceDraft.transferDetails.bankName = newVal.bankName;
          this.invoiceDraft.transferDetails.IFSCcode = newVal.IFSCcode;
          this.invoiceDraft.transferDetails.remark = newVal.remark;
        }
      },

      deep: true
    },
    gstType: function gstType(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("gstType", newVal);
      }
    },
    placeOfSupply: function placeOfSupply(newVal, oldVal) {
      if (oldVal !== newVal) {
        console.log(newVal);
        this.updateAndEmit("placeOfSupply", newVal);
        this.calculateGSTType();
      }
    },
    soldBy: function soldBy(newVal, oldVal) {
      if (oldVal !== newVal) {
        console.log(newVal);
        this.calculateBrokerage();
        this.updateAndEmit("soldBy", newVal);
      }
    },
    remark: function remark(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("remark", newVal);
      }
    }
  }, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_watch, "applicationNumber", function applicationNumber(newVal, oldVal) {
    if (oldVal !== newVal) {
      this.updateAndEmit("applicationNumber", newVal);
    }
  }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_watch, "sanctionDate", function sanctionDate(newVal, oldVal) {
    if (oldVal !== newVal) {
      this.updateAndEmit("sanctionDate", newVal);
    }
  }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_watch, "businessType", function businessType(newVal, oldVal) {
    // if (oldVal !== newVal) {
    //   this.updateAndEmit("businessType", newVal);
    // }
    this.updateAndEmit("businessType", newVal);
  }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_watch, "brokerageRate", function brokerageRate(newVal, oldVal) {
    if (oldVal !== newVal) {
      this.updateAndEmit("brokerageRate", newVal);
    }
  }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_watch, "transferType", function transferType(newVal, oldVal) {
    if (oldVal !== newVal) {
      this.updateAndEmit("transferType", newVal);
    }
  }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_watch, "selectedBuyer", function selectedBuyer(newVal, oldVal) {
    console.log(newVal);
    if (oldVal !== newVal && !!newVal) {
      this.updateAndEmit("buyerId", newVal[".key"]);
      this.getCurrentUser();
    }
  }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_watch, "alertDuration", function alertDuration(newVal, oldVal) {
    if (oldVal !== newVal) {
      this.updateAndEmit("duration", __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(newVal));
    }
  }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_watch, "paymentType", function paymentType(newVal, oldVal) {
    if (oldVal !== newVal) {
      this.updateAndEmit("paymentType", newVal);
      if (this.selectedFirm != "") this.getFirmAndBankBalance();
      this.calculateTotal();
    }
  }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_watch, "transactionType", function transactionType(newVal, oldVal) {
    if (oldVal !== newVal) {
      this.updateAndEmit("transactionType", newVal);
      this.updateStatus();
      this.calculateTotal();
    }
  }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_watch, "invoiceDate", function invoiceDate(newVal, oldVal) {
    if (oldVal !== newVal) {
      this.updateAndEmit("date", new Date(newVal).getTime());
      this.firmBasedInvoiceId(false);
    }
  }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_watch, "invoiceId", function invoiceId(newVal, oldVal) {
    if (oldVal !== newVal) {
      this.updateAndEmit("invoiceId", newVal);
    }
  }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_watch, "selectedFirm", function selectedFirm(newVal, oldVal) {
    if (oldVal !== newVal) {
      this.updateAndEmit("firm", newVal);
      this.getFirmAndBankBalance();
      this.calculateGSTType();
      this.firmBasedInvoiceId(true);
    }
  }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_watch, "selectedBank", function selectedBank(newVal, oldVal) {
    if (oldVal !== newVal) {
      this.updateAndEmit("bank", newVal);
      if (this.selectedFirm != "") this.getFirmAndBankBalance();
    }
  }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_watch, "amountFromCash", function amountFromCash(newVal, oldVal) {
    if (oldVal !== newVal) {
      this.calculateTotal("amountFromCash");
    }
    this.hintText = this.amountFromCash ? _.startCase(Object(__WEBPACK_IMPORTED_MODULE_22__utils_digitsToWords_js__["a" /* digitsToWords */])(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(this.amountFromCash))) : null;
  }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_watch, "amountFromBank", function amountFromBank(newVal, oldVal) {
    if (oldVal !== newVal) {
      this.calculateTotal("amountFromBank");
    }
    this.hintText = this.amountFromBank ? _.startCase(Object(__WEBPACK_IMPORTED_MODULE_22__utils_digitsToWords_js__["a" /* digitsToWords */])(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(this.amountFromBank))) : null;
  }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_watch, "discountAmount", function discountAmount(newVal, oldVal) {
    if (oldVal !== newVal) {
      this.updateAndEmit("discountAmount", newVal);
      this.calculateTotal();
      this.totalAmount = this.principalValueTotal;
      this.updateAndEmit("totalAmount", this.principalValueTotal);
    }
  }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_watch, "roundOffAmount", function roundOffAmount(newVal, oldVal) {
    if (oldVal !== newVal) {
      this.updateAndEmit("roundOffAmount", newVal);
      //this.calculateTotal();
    }
  }), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_watch, "firmSetting", function firmSetting(newVal, oldVal) {
    if (this.firmSetting && this.firmSetting.transactionType == "Credit") {
      this.transactionType = "Credit";
      this.paymentType = "Cash";
    }
  }), _watch),
  methods: {
    getDateFormatted: function getDateFormatted(date) {
      return new Date(date).toLocaleDateString("en-GB");
    },
    uploadImage: function uploadImage(event) {
      var _this12 = this;

      __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_keys___default()(event.target.files).map(function (key) {

        var fsize = event.target.files[key].size;
        var filesize = Math.round(fsize / 1024);
        if (filesize >= 2048) {
          event.preventDefault();
          alert('File too Big, please select a file less than 2mb');
          return;
        } else {
          _this12.invoiceImages.push(event.target.files[key]);
        }
      });
    },
    clearImage: function clearImage() {
      document.getElementById('invoiceImages').value = '';
      this.invoiceImages = [];
    },
    saveBillingData: function saveBillingData() {
      this.updateAndEmit("billingDetails", this.billingDetails);
      this.billingDetailsDialog = false;
    },
    getFirmName: function getFirmName(firm) {
      return this.firms.filter(function (item) {
        return item[".key"] === firm;
      })[0].name;
    },
    saveProduct: function saveProduct() {
      this.addProductDialog = false;
    },
    addProduct: function addProduct() {
      this.stepperValue = 1;
      this.currentProduct = {
        firm: null,
        name: "",
        description: "",
        HSN_code: 0,
        GST_type: "",
        taxableGST_rate: 0,
        barcode: "",
        productType: null,
        productGroup: null,
        productCategory: null,
        unit: "",
        quantity: 0,
        batchNumber: "",
        openingDate: new Date().toISOString().substr(0, 10),
        brand: "",
        basicPrice: 0,
        gstValue: 0,
        purchasingPrice: null,
        sellingPrice: null,
        openingBalance: null,
        purchasingPricePerProduct: null,
        unitsDetails: [{
          unit: "",
          isLast: true,
          isFirst: true,
          order: 1,
          quantity: 0
        }]
      };
      this.addProductDialog = true;
    },
    transactionDetailsSave: function transactionDetailsSave() {
      this.transactionDialog = false;
      this.calculateTotal();
    },
    focusAddProduct: function focusAddProduct() {
      setTimeout(function () {
        document.querySelector(".add-product-dropdown input").click();
      }, 1000);
    },
    selectProductSet: function selectProductSet() {
      if (this.selectedProductSet) {
        this.addProductFromOrderItems(this.selectedProductSet);
      } else {
        this.items = [];
        this.calculateGSTType();
      }
    },
    changeIncentive: function changeIncentive() {
      if (this.isIncentive) {
        this.incentives.push({
          order: 1,
          percentage: 0
        });
      } else {
        this.incentives = [];
      }
      this.calculateGSTType();
    },
    addIncentive: function addIncentive(event, inc) {
      if (event.which == 13 || event.keyCode == 13) {
        this.incentives.push({
          order: inc.order + 1,
          percentage: 0
        });
        this.calculateGSTType();
      }
    },
    getProductsFromOrder: function getProductsFromOrder() {
      var _this13 = this;

      var order = this.orderById[this.$route.params.orderId];
      if (order.soldBy) {
        this.soldBy = order.soldBy;
      }
      if (order.multiFirm) {
        order.items.map(function (orderItem) {
          var index = _.findIndex(_this13.multiFirmData, { firm: orderItem.firm });
          if (index > -1) {
            _this13.multiFirmData[index].items.push(orderItem);
          } else {
            var data = {
              executed: false,
              firm: orderItem.firm,
              items: [orderItem]
            };
            _this13.multiFirmData.push(data);
          }
        });
        this.getOrderProductInfo();
        this.getMultifirmOrderData();
      } else {
        this.getOrderProductInfo();
        this.addProductFromOrderItems(order);
        this.getCurrentUser();
      }
    },
    getOrderProductInfo: function getOrderProductInfo() {
      var order = this.orderById[this.$route.params.orderId];
      this.orderNumber = order.orderNumber || null;
      // this.date = order.date
      this.orderDate = new Date(order.date).toISOString().substr(0, 10);

      this.isBuyer = order.isBuyer;
      if (this.isBuyer) {
        this.selectedBuyer = this.buyers.filter(function (item) {
          return item[".key"] === order.buyerId;
        })[0];
      } else {
        this.selectedBuyer = this.sellers.filter(function (item) {
          return item[".key"] === order.buyerId;
        })[0];
      }
      var firm = this.firms.filter(function (item) {
        return item[".key"] === order.firm;
      })[0];
      this.selectedFirm = firm[".key"];
      this.selectedFirmState = firm["state"];
    },
    getMultifirmOrderData: function getMultifirmOrderData() {
      var currentFirmData = this.multiFirmData[this.multiFirmIndex];
      var firm = this.firms.filter(function (item) {
        return item[".key"] === currentFirmData.firm;
      })[0];
      this.selectedFirm = firm[".key"];
      this.selectedFirmState = firm["state"];
      this.addProductFromOrderItems(currentFirmData);
      this.getCurrentUser();
    },
    addProductFromOrderItems: function addProductFromOrderItems(order) {
      var _this14 = this;

      order.items.map(function (orderItem) {
        if (!orderItem.completed) {
          var product = _this14.productById[orderItem.productId];
          var itemToAdd = {
            productId: orderItem.productId,
            quantity: orderItem.quantity,
            unit: orderItem.unit,
            taxableGST_rate: product.taxableGST_rate,
            HSN_code: product.HSN_code,
            productName: product.name,
            GST_type: product.GST_type,
            productUnit: product.unit,
            availableQuantity: product.quantity,
            tradeDiscount: 0,
            specialCharge: 0,
            rate: orderItem.rate
          };
          itemToAdd.basicPrice = (__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(itemToAdd.rate * itemToAdd.quantity) - __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(itemToAdd.tradeDiscount) + __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(itemToAdd.specialCharge)).toFixed(2);
          itemToAdd.GSTValue = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(itemToAdd.basicPrice * (parseFloat(itemToAdd.taxableGST_rate) / 100)).toFixed(2);
          itemToAdd.totlePrice = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(itemToAdd.basicPrice) + __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(itemToAdd.GSTValue)).toFixed(2);

          if (order.isPortfolio && _this14.businessType == 'Jwellery') {
            itemToAdd["grossWeight"] = orderItem.grossWeight;
            itemToAdd["purity"] = orderItem.purity;
            itemToAdd.netWeight = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(itemToAdd.grossWeight * itemToAdd.purity / 100).toFixed(2);
            if (_this14.isRoundOff) {
              var basicPrice = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(itemToAdd.rate * itemToAdd.grossWeight * itemToAdd.quantity * (itemToAdd.purity / 100)).toFixed(2);
              itemToAdd.basicPrice = Math.round(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(basicPrice));
              var GSTValue = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(itemToAdd.basicPrice * (parseFloat(itemToAdd.taxableGST_rate) / 100)).toFixed(2);
              itemToAdd.GSTValue = Math.round(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(GSTValue));
              var totlePrice = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(itemToAdd.basicPrice) + __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(itemToAdd.GSTValue)).toFixed(2);
              itemToAdd.totlePrice = Math.round(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(totlePrice));
            } else {
              itemToAdd.basicPrice = (__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(itemToAdd.rate * itemToAdd.grossWeight * itemToAdd.quantity * (itemToAdd.purity / 100)) - __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(itemToAdd.tradeDiscount) + __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(itemToAdd.specialCharge)).toFixed(2);
              itemToAdd.GSTValue = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(itemToAdd.basicPrice * (parseFloat(itemToAdd.taxableGST_rate) / 100)).toFixed(2);
              itemToAdd.totlePrice = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(itemToAdd.basicPrice) + __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(itemToAdd.GSTValue)).toFixed(2);
            }
          }

          var batchArray = _this14.batch.filter(function (item) {
            return item["brand"] === _this14.selectedBrand && item["product"] === orderItem.productId;
          });
          batchArray.sort(function (a, b) {
            return -(new Date(b.expiryDate) - new Date(a.expiryDate));
          });
          if (batchArray.length) {
            itemToAdd.batchNumber = batchArray[0].batchNumber;
            itemToAdd.expiryDate = batchArray[0].expiryDate ? new Date(batchArray[0].expiryDate).toISOString().substr(0, 10) : new Date(new Date().setFullYear(new Date().getFullYear() + 100)).toISOString().substr(0, 10);
            itemToAdd.manufacturingDate = batchArray[0].manufacturingDate ? new Date(batchArray[0].manufacturingDate).toISOString().substr(0, 10) : new Date(new Date().setFullYear(new Date().getFullYear() + 100)).toISOString().substr(0, 10);
          } else {
            itemToAdd.expiryDate = new Date(new Date().setFullYear(new Date().getFullYear() + 100)).toISOString().substr(0, 10);
            itemToAdd.manufacturingDate = new Date(new Date().setFullYear(new Date().getFullYear() + 100)).toISOString().substr(0, 10);
            itemToAdd.batchNumber = "DEFAULT";
          }
          // this.items.push(itemToAdd);
          if (order.isPortfolio) {
            if (orderItem.selected) {
              _this14.items.push(itemToAdd);
            }
          } else {
            _this14.items.push(itemToAdd);
          }
        }
      });
      this.calculateGSTType();
    },
    getProductsFromEstimate: function getProductsFromEstimate() {
      var _this15 = this;

      var estimate = this.estimateById[this.$route.params.estimateId];
      var firm = this.firms.filter(function (item) {
        return item[".key"] === estimate.firm;
      })[0];
      this.selectedFirm = firm[".key"];
      this.selectedFirmState = firm["state"];
      this.isBuyer = estimate.isBuyer;
      if (this.isBuyer) {
        this.selectedBuyer = this.buyers.filter(function (item) {
          return item[".key"] === estimate.buyerId;
        })[0];
      } else {
        this.selectedBuyer = this.sellers.filter(function (item) {
          return item[".key"] === estimate.buyerId;
        })[0];
      }
      estimate.items.map(function (estimateItem) {
        var product = _this15.productById[estimateItem.productId];
        var itemToAdd = {
          productId: estimateItem.productId,
          quantity: estimateItem.quantity,
          unit: estimateItem.unit,
          taxableGST_rate: product.taxableGST_rate,
          HSN_code: product.HSN_code,
          productName: product.name,
          GST_type: product.GST_type,
          productUnit: product.unit,
          availableQuantity: product.quantity,
          tradeDiscount: 0,
          specialCharge: 0,
          rate: estimateItem.rate
        };
        itemToAdd.basicPrice = (__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(itemToAdd.rate * itemToAdd.quantity) - __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(itemToAdd.tradeDiscount) + __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(itemToAdd.specialCharge)).toFixed(2);
        itemToAdd.GSTValue = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(itemToAdd.basicPrice * (parseFloat(itemToAdd.taxableGST_rate) / 100)).toFixed(2);
        itemToAdd.totlePrice = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(itemToAdd.basicPrice) + __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(itemToAdd.GSTValue)).toFixed(2);

        var batchArray = _this15.batch.filter(function (item) {
          return item["brand"] === _this15.selectedBrand && item["product"] === estimateItem.productId;
        });
        batchArray.sort(function (a, b) {
          return -(new Date(b.expiryDate) - new Date(a.expiryDate));
        });
        if (batchArray.length) {
          itemToAdd.batchNumber = batchArray[0].batchNumber;
          itemToAdd.expiryDate = batchArray[0].expiryDate ? new Date(batchArray[0].expiryDate).toISOString().substr(0, 10) : new Date(new Date().setFullYear(new Date().getFullYear() + 100)).toISOString().substr(0, 10);
          itemToAdd.manufacturingDate = batchArray[0].manufacturingDate ? new Date(batchArray[0].manufacturingDate).toISOString().substr(0, 10) : new Date(new Date().setFullYear(new Date().getFullYear() + 100)).toISOString().substr(0, 10);
        } else {
          itemToAdd.expiryDate = new Date(new Date().setFullYear(new Date().getFullYear() + 100)).toISOString().substr(0, 10);
          itemToAdd.manufacturingDate = new Date(new Date().setFullYear(new Date().getFullYear() + 100)).toISOString().substr(0, 10);
          itemToAdd.batchNumber = "DEFAULT";
        }
        _this15.items.push(itemToAdd);
      });
      this.calculateGSTType();
    },
    updateStatus: function updateStatus() {
      switch (this.transactionType) {
        case "Debit":
          {
            this.updateAndEmit("status", "due");
            break;
          }
        case "Partial Paid":
          {
            this.updateAndEmit("status", "partial");
            // if (!this.transactionDialog) this.transactionDialog = true;
            break;
          }
        case "Credit":
          {
            this.updateAndEmit("status", "paid");
            // if (!this.transactionDialog) this.transactionDialog = true;
            break;
          }
      }
    },
    calculateBrokerage: function calculateBrokerage() {
      var _this16 = this;

      var staffObj = this.staffs.filter(function (item) {
        return item[".key"] === _this16.soldBy;
      })[0];
      if (staffObj) {
        this.brokerageRate = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(staffObj.brokerageRate);
        if (!this.firmSetting || !this.firmSetting.individualProdBrokerage) {
          var _staffObj = this.staffs.filter(function (item) {
            return item[".key"] === _this16.soldBy;
          })[0];
          if (_staffObj) {
            this.brokerageRate = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(_staffObj.brokerageRate);
          }
          // console.log(this.brokerageRate);
        }
      }
    },
    calculateIndividualBrokerage: function calculateIndividualBrokerage() {
      var brokerageAmount = 0;
      this.items.map(function (item) {
        brokerageAmount += item.brokerageRate ? __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item.totlePrice) * item.brokerageRate / 100) : 0;
      });
      this.brokerageRate = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(brokerageAmount * 100 / this.totalAmount);
    },
    formatDate: function formatDate() {
      var tomorrow = new Date(this.dateFormatted);
      tomorrow.setDate(tomorrow.getDate() + 1);
      this.invoiceDate = new Date(tomorrow).toISOString().substr(0, 10);
    },
    basicInvoicePrint: function basicInvoicePrint(isVertical, isDownload) {
      var _this17 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var termsAndConditions, firm, customer, productObj, _productObj;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this17.updateAndEmit("totalExtraCharges", _this17.totalExtraCharges);
                if (_this17.gstOnExtraChanrges) {
                  _this17.updateAndEmit("totalExtraChargesGST", _this17.totalExtraChargesGST);
                }
                _this17.updateStatus();
                termsAndConditions = _this17.getTermsAndConditions();

                _this17.calculateGSTType();
                firm = _this17.firmById[_this17.selectedFirm];

                firm.address = _this17.getAddress(firm);
                customer = _this17.selectedBuyer;

                customer.address = _this17.getAddress(customer);
                customer.stateCode = _this17.gState.filter(function (item) {
                  return item.state == customer.state;
                })[0].code;

                if (!isVertical) {
                  _context.next = 22;
                  break;
                }

                if (!_this17.gstInvoice) {
                  _context.next = 16;
                  break;
                }

                _context.next = 14;
                return Object(__WEBPACK_IMPORTED_MODULE_18__utils_pdfmake__["c" /* convertToBasicInvoice */])({
                  invoiceData: _this17.invoiceDraft,
                  firm: firm,
                  customer: customer,
                  gstTotal: _this17.GST_Val_total,
                  terms: termsAndConditions[0]
                }).then(function (doc) {
                  //pdfMake.createPdf(doc).download(this.invoiceId);
                  //doc['info'] = {title : this.invoiceId}
                  //pdfMake.createPdf(doc).print({}, window.frames['printPdf']);
                  if (isDownload) {
                    pdfMake.createPdf(doc).download(_this17.selectedBuyer.name);
                  } else {
                    doc["info"] = { title: _this17.invoiceId };
                    pdfMake.createPdf(doc).print({}, window.frames["printPdf"]);
                  }
                });

              case 14:
                _context.next = 20;
                break;

              case 16:
                productObj = {};

                if (termsAndConditions[0].isMajorUnitDisplay) {
                  _this17.invoiceDraft.items.map(function (item) {
                    productObj[item['productId']] = _this17.productById[item['productId']];
                  });
                }
                _context.next = 20;
                return Object(__WEBPACK_IMPORTED_MODULE_18__utils_pdfmake__["f" /* convertToBasicInvoiceWithoutGST */])({
                  invoiceData: _this17.invoiceDraft,
                  firm: firm,
                  customer: customer,
                  gstTotal: _this17.GST_Val_total,
                  terms: termsAndConditions[0],
                  productObj: productObj
                }).then(function (doc) {
                  // pdfMake.createPdf(doc).download(this.invoiceId);
                  // doc['info'] = {title : this.invoiceId}
                  // pdfMake.createPdf(doc).print({}, window.frames['printPdf']);
                  if (isDownload) {
                    pdfMake.createPdf(doc).download(_this17.selectedBuyer.name);
                  } else {
                    doc["info"] = { title: _this17.invoiceId };
                    pdfMake.createPdf(doc).print({}, window.frames["printPdf"]);
                  }
                });

              case 20:
                _context.next = 31;
                break;

              case 22:
                if (!_this17.gstInvoice) {
                  _context.next = 27;
                  break;
                }

                _context.next = 25;
                return Object(__WEBPACK_IMPORTED_MODULE_18__utils_pdfmake__["e" /* convertToBasicInvoiceHorizontal */])({
                  invoiceData: _this17.invoiceDraft,
                  firm: firm,
                  customer: customer,
                  gstTotal: _this17.GST_Val_total,
                  terms: termsAndConditions[0]
                }).then(function (doc) {
                  // pdfMake.createPdf(doc).download(this.invoiceId);
                  // doc['info'] = {title : this.invoiceId}
                  // pdfMake.createPdf(doc).print({}, window.frames['printPdf']);
                  if (isDownload) {
                    pdfMake.createPdf(doc).download(_this17.selectedBuyer.name);
                  } else {
                    doc["info"] = { title: _this17.invoiceId };
                    pdfMake.createPdf(doc).print({}, window.frames["printPdf"]);
                  }
                });

              case 25:
                _context.next = 31;
                break;

              case 27:
                _productObj = {};

                if (termsAndConditions[0].isMajorUnitDisplay) {
                  _this17.invoiceDraft.items.map(function (item) {
                    _productObj[item['productId']] = _this17.productById[item['productId']];
                  });
                }
                _context.next = 31;
                return Object(__WEBPACK_IMPORTED_MODULE_18__utils_pdfmake__["f" /* convertToBasicInvoiceWithoutGST */])({
                  invoiceData: _this17.invoiceDraft,
                  firm: firm,
                  customer: customer,
                  gstTotal: _this17.GST_Val_total,
                  terms: termsAndConditions[0],
                  productObj: _productObj
                }).then(function (doc) {
                  // pdfMake.createPdf(doc).download(this.invoiceId);
                  // doc['info'] = {title : this.invoiceId}
                  // pdfMake.createPdf(doc).print({}, window.frames['printPdf']);
                  if (isDownload) {
                    pdfMake.createPdf(doc).download(_this17.selectedBuyer.name);
                  } else {
                    doc["info"] = { title: _this17.invoiceId };
                    pdfMake.createPdf(doc).print({}, window.frames["printPdf"]);
                  }
                });

              case 31:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this17);
      }))();
    },


    //Start of New Photo Print Format
    basicShortInvoicePrint: function basicShortInvoicePrint(isVertical, isDownload) {
      var _this18 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var termsAndConditions, firm, customer, productObj, _productObj2;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this18.updateAndEmit("totalExtraCharges", _this18.totalExtraCharges);
                if (_this18.gstOnExtraChanrges) {
                  _this18.updateAndEmit("totalExtraChargesGST", _this18.totalExtraChargesGST);
                }
                _this18.updateStatus();
                termsAndConditions = _this18.getTermsAndConditions();

                _this18.calculateGSTType();
                firm = _this18.firmById[_this18.selectedFirm];

                firm.address = _this18.getAddress(firm);
                customer = _this18.selectedBuyer;

                customer.address = _this18.getAddress(customer);
                customer.stateCode = _this18.gState.filter(function (item) {
                  return item.state == customer.state;
                })[0].code;

                if (!isVertical) {
                  _context2.next = 22;
                  break;
                }

                if (!_this18.gstInvoice) {
                  _context2.next = 16;
                  break;
                }

                _context2.next = 14;
                return Object(__WEBPACK_IMPORTED_MODULE_18__utils_pdfmake__["g" /* convertToBasicShortInvoice */])({
                  invoiceData: _this18.invoiceDraft,
                  firm: firm,
                  customer: customer,
                  gstTotal: _this18.GST_Val_total,
                  terms: termsAndConditions[0]
                }).then(function (doc) {
                  //pdfMake.createPdf(doc).download(this.invoiceId);
                  //doc['info'] = {title : this.invoiceId}
                  //pdfMake.createPdf(doc).print({}, window.frames['printPdf']);
                  if (isDownload) {
                    pdfMake.createPdf(doc).download(_this18.selectedBuyer.name);
                  } else {
                    doc["info"] = { title: _this18.invoiceId };
                    pdfMake.createPdf(doc).print({}, window.frames["printPdf"]);
                  }
                });

              case 14:
                _context2.next = 20;
                break;

              case 16:
                productObj = {};

                if (termsAndConditions[0].isMajorUnitDisplay) {
                  _this18.invoiceDraft.items.map(function (item) {
                    productObj[item['productId']] = _this18.productById[item['productId']];
                  });
                }
                _context2.next = 20;
                return Object(__WEBPACK_IMPORTED_MODULE_18__utils_pdfmake__["i" /* convertToBasicShortInvoiceWithoutGST */])({
                  invoiceData: _this18.invoiceDraft,
                  firm: firm,
                  customer: customer,
                  gstTotal: _this18.GST_Val_total,
                  terms: termsAndConditions[0],
                  productObj: productObj
                }).then(function (doc) {
                  // pdfMake.createPdf(doc).download(this.invoiceId);
                  // doc['info'] = {title : this.invoiceId}
                  // pdfMake.createPdf(doc).print({}, window.frames['printPdf']);
                  if (isDownload) {
                    pdfMake.createPdf(doc).download(_this18.selectedBuyer.name);
                  } else {
                    doc["info"] = { title: _this18.invoiceId };
                    pdfMake.createPdf(doc).print({}, window.frames["printPdf"]);
                  }
                });

              case 20:
                _context2.next = 31;
                break;

              case 22:
                if (!_this18.gstInvoice) {
                  _context2.next = 27;
                  break;
                }

                _context2.next = 25;
                return Object(__WEBPACK_IMPORTED_MODULE_18__utils_pdfmake__["h" /* convertToBasicShortInvoiceHorizontal */])({
                  invoiceData: _this18.invoiceDraft,
                  firm: firm,
                  customer: customer,
                  gstTotal: _this18.GST_Val_total,
                  terms: termsAndConditions[0]
                }).then(function (doc) {
                  // pdfMake.createPdf(doc).download(this.invoiceId);
                  // doc['info'] = {title : this.invoiceId}
                  // pdfMake.createPdf(doc).print({}, window.frames['printPdf']);
                  if (isDownload) {
                    pdfMake.createPdf(doc).download(_this18.selectedBuyer.name);
                  } else {
                    doc["info"] = { title: _this18.invoiceId };
                    pdfMake.createPdf(doc).print({}, window.frames["printPdf"]);
                  }
                });

              case 25:
                _context2.next = 31;
                break;

              case 27:
                _productObj2 = {};

                if (termsAndConditions[0].isMajorUnitDisplay) {
                  _this18.invoiceDraft.items.map(function (item) {
                    _productObj2[item['productId']] = _this18.productById[item['productId']];
                  });
                }
                _context2.next = 31;
                return Object(__WEBPACK_IMPORTED_MODULE_18__utils_pdfmake__["i" /* convertToBasicShortInvoiceWithoutGST */])({
                  invoiceData: _this18.invoiceDraft,
                  firm: firm,
                  customer: customer,
                  gstTotal: _this18.GST_Val_total,
                  terms: termsAndConditions[0],
                  productObj: _productObj2
                }).then(function (doc) {
                  // pdfMake.createPdf(doc).download(this.invoiceId);
                  // doc['info'] = {title : this.invoiceId}
                  // pdfMake.createPdf(doc).print({}, window.frames['printPdf']);
                  if (isDownload) {
                    pdfMake.createPdf(doc).download(_this18.selectedBuyer.name);
                  } else {
                    doc["info"] = { title: _this18.invoiceId };
                    pdfMake.createPdf(doc).print({}, window.frames["printPdf"]);
                  }
                });

              case 31:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this18);
      }))();
    },

    //End of New Photo Print Format

    // Start of New Format For Dairy
    //Start of New Photo Print Format
    basicInvoiceTheme1Print: function basicInvoiceTheme1Print(isVertical, isDownload) {
      var _this19 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var termsAndConditions, firm, customer, productObj, _productObj3;

        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this19.updateAndEmit("totalExtraCharges", _this19.totalExtraCharges);
                if (_this19.gstOnExtraChanrges) {
                  _this19.updateAndEmit("totalExtraChargesGST", _this19.totalExtraChargesGST);
                }
                _this19.updateStatus();
                termsAndConditions = _this19.getTermsAndConditions();

                _this19.calculateGSTType();
                firm = _this19.firmById[_this19.selectedFirm];

                firm.address = _this19.getAddress(firm);
                customer = _this19.selectedBuyer;

                customer.address = _this19.getAddress(customer);
                customer.stateCode = _this19.gState.filter(function (item) {
                  return item.state == customer.state;
                })[0].code;

                if (!isVertical) {
                  _context3.next = 22;
                  break;
                }

                if (!_this19.gstInvoice) {
                  _context3.next = 16;
                  break;
                }

                _context3.next = 14;
                return Object(__WEBPACK_IMPORTED_MODULE_18__utils_pdfmake__["g" /* convertToBasicShortInvoice */])({
                  invoiceData: _this19.invoiceDraft,
                  firm: firm,
                  customer: customer,
                  gstTotal: _this19.GST_Val_total,
                  terms: termsAndConditions[0]
                }).then(function (doc) {
                  //pdfMake.createPdf(doc).download(this.invoiceId);
                  //doc['info'] = {title : this.invoiceId}
                  //pdfMake.createPdf(doc).print({}, window.frames['printPdf']);
                  if (isDownload) {
                    pdfMake.createPdf(doc).download(_this19.selectedBuyer.name);
                  } else {
                    doc["info"] = { title: _this19.invoiceId };
                    pdfMake.createPdf(doc).print({}, window.frames["printPdf"]);
                  }
                });

              case 14:
                _context3.next = 20;
                break;

              case 16:
                productObj = {};

                if (termsAndConditions[0].isMajorUnitDisplay) {
                  _this19.invoiceDraft.items.map(function (item) {
                    productObj[item['productId']] = _this19.productById[item['productId']];
                  });
                }
                _context3.next = 20;
                return Object(__WEBPACK_IMPORTED_MODULE_18__utils_pdfmake__["d" /* convertToBasicInvoiceForDairyWithoutGST */])({
                  invoiceData: _this19.invoiceDraft,
                  firm: firm,
                  customer: customer,
                  gstTotal: _this19.GST_Val_total,
                  terms: termsAndConditions[0],
                  productObj: productObj
                }).then(function (doc) {
                  // pdfMake.createPdf(doc).download(this.invoiceId);
                  // doc['info'] = {title : this.invoiceId}
                  // pdfMake.createPdf(doc).print({}, window.frames['printPdf']);
                  if (isDownload) {
                    pdfMake.createPdf(doc).download(_this19.selectedBuyer.name);
                  } else {
                    doc["info"] = { title: _this19.invoiceId };
                    pdfMake.createPdf(doc).print({}, window.frames["printPdf"]);
                  }
                });

              case 20:
                _context3.next = 31;
                break;

              case 22:
                if (!_this19.gstInvoice) {
                  _context3.next = 27;
                  break;
                }

                _context3.next = 25;
                return Object(__WEBPACK_IMPORTED_MODULE_18__utils_pdfmake__["h" /* convertToBasicShortInvoiceHorizontal */])({
                  invoiceData: _this19.invoiceDraft,
                  firm: firm,
                  customer: customer,
                  gstTotal: _this19.GST_Val_total,
                  terms: termsAndConditions[0]
                }).then(function (doc) {
                  // pdfMake.createPdf(doc).download(this.invoiceId);
                  // doc['info'] = {title : this.invoiceId}
                  // pdfMake.createPdf(doc).print({}, window.frames['printPdf']);
                  if (isDownload) {
                    pdfMake.createPdf(doc).download(_this19.selectedBuyer.name);
                  } else {
                    doc["info"] = { title: _this19.invoiceId };
                    pdfMake.createPdf(doc).print({}, window.frames["printPdf"]);
                  }
                });

              case 25:
                _context3.next = 31;
                break;

              case 27:
                _productObj3 = {};

                if (termsAndConditions[0].isMajorUnitDisplay) {
                  _this19.invoiceDraft.items.map(function (item) {
                    _productObj3[item['productId']] = _this19.productById[item['productId']];
                  });
                }
                _context3.next = 31;
                return Object(__WEBPACK_IMPORTED_MODULE_18__utils_pdfmake__["d" /* convertToBasicInvoiceForDairyWithoutGST */])({
                  invoiceData: _this19.invoiceDraft,
                  firm: firm,
                  customer: customer,
                  gstTotal: _this19.GST_Val_total,
                  terms: termsAndConditions[0],
                  productObj: _productObj3
                }).then(function (doc) {
                  // pdfMake.createPdf(doc).download(this.invoiceId);
                  // doc['info'] = {title : this.invoiceId}
                  // pdfMake.createPdf(doc).print({}, window.frames['printPdf']);
                  if (isDownload) {
                    pdfMake.createPdf(doc).download(_this19.selectedBuyer.name);
                  } else {
                    doc["info"] = { title: _this19.invoiceId };
                    pdfMake.createPdf(doc).print({}, window.frames["printPdf"]);
                  }
                });

              case 31:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this19);
      }))();
    },

    // End of New Format For Dairy

    printInvoice4: function printInvoice4(isSave, isDownload) {
      var _this20 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var termsAndConditions, firm, customer, estimates, previousDue;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this20.updateAndEmit("totalExtraCharges", _this20.totalExtraCharges);
                if (_this20.gstOnExtraChanrges) {
                  _this20.updateAndEmit("totalExtraChargesGST", _this20.totalExtraChargesGST);
                }
                _this20.updateStatus();
                termsAndConditions = _this20.getTermsAndConditions();

                _this20.calculateGSTType();
                firm = _this20.firmById[_this20.selectedFirm];

                firm.address = _this20.getAddress(firm);
                customer = _this20.selectedBuyer;

                customer.address = _this20.getAddress(customer);
                customer.stateCode = _this20.gState.filter(function (item) {
                  return item.state == customer.state;
                })[0].code;
                estimates = [];
                previousDue = [];
                // if (termsAndConditions[0].isPreviousDue) {
                //   previousDue = this.invoices.filter(
                //     (item) =>
                //       item["brand"] == this.selectedBrand &&
                //       item["buyerId"] == this.selectedBuyer[".key"] &&
                //       ["due", "partial"].includes(item["status"]) &&
                //       !item["deleted"] &&
                //       !item["return"]
                //   );
                // }

                if (termsAndConditions[0].isEstimate) {
                  estimates = _this20.estimates.filter(function (item) {
                    return item["brand"] == _this20.selectedBrand && item["buyerId"] == _this20.selectedBuyer[".key"] && ["IN PROGRESS"].includes(item["status"]);
                  });
                }
                _context4.next = 15;
                return Object(__WEBPACK_IMPORTED_MODULE_18__utils_pdfmake__["p" /* convertToSimpleInvoicePrint */])({
                  invoiceData: _this20.invoiceDraft,
                  firm: firm,
                  customer: customer,
                  gstTotal: _this20.GST_Val_total,
                  terms: termsAndConditions[0],
                  previousDue: previousDue,
                  estimates: estimates
                }).then(function (doc) {
                  // pdfMake.createPdf(doc).download(this.invoiceId);
                  // doc['info'] = {title : this.invoiceId}
                  // pdfMake.createPdf(doc).print({}, window.frames['printPdf']);
                  if (isDownload) {
                    pdfMake.createPdf(doc).download(_this20.selectedBuyer.name);
                  } else {
                    doc["info"] = { title: _this20.invoiceId };
                    pdfMake.createPdf(doc).print({}, window.frames["printPdf"]);
                  }
                });

              case 15:
                if (isSave) {
                  _this20.saveInvoice();
                }

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this20);
      }))();
    },
    getTermsAndConditions: function getTermsAndConditions() {
      var _this21 = this;

      var termsAndConditions = this.termsAndConditions.filter(function (item) {
        return item["brand"] === _this21.selectedBrand && item["firm"] === _this21.selectedFirm;
      });
      if (termsAndConditions.length) {
        if (termsAndConditions[0].bank) {
          var banks = [];
          termsAndConditions[0].bank.map(function (bankId) {
            var bank = _this21.bankById[bankId];
            bank.address = _this21.getAddress(bank);
            banks.push(bank);
          });
          termsAndConditions[0].banks = banks;
        } else {
          termsAndConditions[0].banks = [];
        }
      } else {
        termsAndConditions = [{
          termsAndConditions: "",
          banks: []
        }];
      }
      return termsAndConditions;
    },
    getAddress: function getAddress(item) {
      if (!item) {
        return "";
      }
      var address = (item.village ? item.village + ", " : "") + (item.block ? item.block + ", " : "") + (item.tehsil ? item.tehsil + ", " : "") + (item.district ? item.district + ", " : "") + (item.state ? item.state + ", " : "") + (item.country ? item.country + ", " : "");
      address = address.substring(0, address.length - 2);
      return address;
    },
    resetAmounts: function resetAmounts() {
      // this.amountFromCash = 0;
      // this.amountFromBank = 0;
      // this.discountAmount = 0;
      this.transactionDialog = !this.transactionDialog;
    },


    // NEw Development
    getFirmAndBankBalance: function getFirmAndBankBalance() {
      var _this22 = this;

      var selectedFirm = this.firms.filter(function (item) {
        return item["brand"] === _this22.selectedBrand && item[".key"] == _this22.selectedFirm;
      });
      this.businessType = selectedFirm[0].businessType;
      this.updateAndEmit("businessType", this.businessType);
      this.gstInvoice = selectedFirm[0].GST_user && selectedFirm[0].GST_user == "Yes" ? true : false;
      var selectedBank = this.selectedBank ? this.banks.filter(function (item) {
        return item["brand"] === _this22.selectedBrand && item[".key"] == _this22.selectedBank;
      }) : null;
      switch (this.paymentType) {
        case "Cash":
          {
            if (this.selectedFirm) {
              this.availableBalance = selectedFirm.length && (selectedFirm[0]["amount"] ? selectedFirm[0]["amount"] : 0);
            } else {
              this.availableBalance = 0;
            }
            break;
          }
        case "Bank Account":
          {
            if (this.selectedBank) {
              this.availableBalance = selectedBank.length && (selectedBank[0]["amount"] ? selectedBank[0]["amount"] : 0);
            } else {
              this.availableBalance = 0;
            }
            break;
          }
        case "CashAndBank Account":
          {
            if (this.selectedFirm && this.selectedBank) {
              this.availableBalance = selectedFirm.length && selectedBank.length && (selectedBank[0]["amount"] ? selectedBank[0]["amount"] : 0) + (selectedFirm[0]["amount"] ? selectedFirm[0]["amount"] : 0);
            } else {
              this.availableBalance = 0;
            }
            break;
          }
      }
    },
    editItem: function editItem(item, fromDialog) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, item);
      this.isEditItems = true;
      if (!fromDialog) {
        this.dialog = true;
      }
    },
    deleteItem: function deleteItem(item) {
      var index = this.items.indexOf(item);
      confirm("Are you sure you want to delete this item?") && this.items.splice(index, 1);
    },
    close: function close(saveAddItem) {
      var _this23 = this;

      if (!saveAddItem) {
        this.dialog = false;
      } else {
        this.focusAddProduct();
      }
      setTimeout(function () {
        _this23.editedItem = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this23.defaultItem);
        _this23.editedIndex = -1;
      }, 300);
    },
    calculateTotal: function calculateTotal(type) {
      var discountAmount = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(this.discountAmount);
      var amountFromBank = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(this.amountFromBank);
      var amountFromCash = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(this.amountFromCash);
      var totalAmount = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(this.totalAmount);
      switch (this.paymentType) {
        case "Cash":
          {
            this.amountFromBank = 0;
            this.amountFromBankDisabled = true;
            switch (this.transactionType) {
              case "Debit":
                {
                  this.amountFromCashDisabled = true;
                  this.amountFromCash = 0;
                  this.remainingAmount = totalAmount;
                  this.paidAmount = 0;
                  break;
                }
              case "Partial Paid":
                {
                  this.amountFromCashDisabled = false;
                  this.remainingAmount = totalAmount - amountFromCash;
                  this.paidAmount = amountFromCash;
                  break;
                }
              case "Credit":
                {
                  this.amountFromCashDisabled = true;
                  this.amountFromCash = totalAmount;
                  this.remainingAmount = 0;
                  this.paidAmount = totalAmount;
                  break;
                }
            }
            break;
          }
        case "Bank Account":
          {
            this.amountFromCashDisabled = true;
            this.amountFromCash = 0;
            switch (this.transactionType) {
              case "Debit":
                {
                  this.amountFromBankDisabled = true;
                  this.amountFromBank = 0;
                  this.remainingAmount = totalAmount;
                  this.paidAmount = 0;
                  break;
                }
              case "Partial Paid":
                {
                  this.amountFromBankDisabled = false;
                  this.remainingAmount = totalAmount - amountFromBank;
                  this.paidAmount = amountFromBank;
                  break;
                }
              case "Credit":
                {
                  this.amountFromBankDisabled = true;
                  this.amountFromBank = totalAmount;
                  this.remainingAmount = 0;
                  this.paidAmount = totalAmount;
                  break;
                }
            }
            break;
          }
        case "CashAndBank Account":
          {
            this.amountFromCashDisabled = false;
            this.amountFromBankDisabled = false;
            var totalBankAndCash = amountFromCash + amountFromBank;
            switch (this.transactionType) {
              case "Debit":
                {
                  this.remainingAmount = totalAmount;
                  this.paidAmount = 0;
                  this.amountFromBank = 0;
                  this.amountFromCash = 0;
                  break;
                }
              case "Partial Paid":
                {
                  this.paidAmount = totalBankAndCash;
                  this.remainingAmount = totalAmount - this.paidAmount;
                  break;
                }
              case "Credit":
                {
                  this.remainingAmount = 0;
                  this.paidAmount = totalAmount;
                  break;
                }
            }
            break;
          }
        case "":
          {
            this.amountFromCashDisabled = true;
            this.amountFromBankDisabled = true;
            this.amountFromCash = 0;
            this.amountFromBank = 0;
            this.paidAmount = 0;
            this.remainingAmount = totalAmount;
            break;
          }
      }
      this.paidAmount = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(this.paidAmount).toFixed(parseInt(this.roundOff));
      if (type != "amountFromCash") this.amountFromCash = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(this.amountFromCash).toFixed(parseInt(this.roundOff));
      if (type != "amountFromBank") this.amountFromBank = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(this.amountFromBank).toFixed(parseInt(this.roundOff));
      this.remainingAmount = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(this.remainingAmount).toFixed(parseInt(this.roundOff));
      this.updateAndEmit("paidAmount", this.paidAmount);
      this.updateAndEmit("amountFromCash", this.amountFromCash);
      this.updateAndEmit("amountFromBank", this.amountFromBank);
      this.updateAndEmit("remainingAmount", this.remainingAmount);
    },
    save: function save(editedItem, saveAndAdd) {
      var _this24 = this;

      if (this.editedIndex > -1) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.items[this.editedIndex], editedItem);
      } else {
        this.items.push(editedItem);
      }
      this.calculateGSTType();
      setTimeout(function () {
        _this24.editedItem = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this24.defaultItem);
        _this24.editedIndex = -1;
        _this24.isEditItems = false;
      }, 300);
      this.close(saveAndAdd);
    },
    calculateGSTType: function calculateGSTType() {
      var _this25 = this;

      if (this.selectedBuyer) {
        this.GST_Val_total.SGST_val = 0;
        this.GST_Val_total.CGST_val = 0;
        this.GST_Val_total.IGST_val = 0;
        if (this.isIncentive) {
          this.incentives.sort(function (a, b) {
            return new Date(a.order) - new Date(b.order);
          });
        }
        var firm = this.firmById[this.selectedFirm];
        var isCGST = !this.selectedBuyer.state || this.selectedFirm && this.selectedBuyer.state && firm.state === this.placeOfSupply;
        if (isCGST) {
          this.gstType = "SGST|CGST";
          this.updateAndEmit("gstType", "SGST|CGST");
        } else {
          this.gstType = "IGST";
          this.updateAndEmit("gstType", "IGST");
        }
        var isProductRoundOff = this.firmSetting && this.firmSetting.roundOff;
        this.items.map(function (item, index) {
          var GST = item["taxableGST_rate"];

          var itemIncentive = 0;
          _this25.incentives.map(function (inc) {
            if (!!inc.percentage) {
              itemIncentive += (parseFloat(item.basicPrice) - parseFloat(itemIncentive)) * (parseFloat(inc.percentage) / 100);
            }
          });
          item.incentiveAmount = itemIncentive;
          if (isProductRoundOff) {
            var GSTValue = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()((item.basicPrice - itemIncentive) * (parseFloat(item.taxableGST_rate) / 100)).toFixed(2);
            var totlePrice = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item.basicPrice - itemIncentive) + __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item.GSTValue)).toFixed(2);
            item.GSTValue = Math.round(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(GSTValue));
            item.totlePrice = Math.round(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(totlePrice));
          } else {
            item.GSTValue = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()((item.basicPrice - itemIncentive) * (parseFloat(item.taxableGST_rate) / 100)).toFixed(2);
            item.totlePrice = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item.basicPrice - itemIncentive) + __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item.GSTValue)).toFixed(2);
          }
          if (isCGST) {
            item["CGST_val"] = item["GSTValue"] / 2;
            item["CGST"] = GST ? GST / 2 : 0;
            item["SGST_val"] = item["GSTValue"] / 2;
            item["SGST"] = GST ? GST / 2 : 0;
            item["IGST"] = 0;
            item["IGST_val"] = 0;
            _this25.GST_Val_total.SGST_val += __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item["SGST_val"]);
            _this25.GST_Val_total.CGST_val += __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item["CGST_val"]);
            _this25.GST_Val_total.IGST_val += __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item["IGST_val"]);
          } else {
            item["IGST"] = GST;
            item["CGST"] = 0;
            item["SGST"] = 0;
            item["IGST_val"] = item["GSTValue"];
            item["CGST_val"] = 0;
            item["SGST_val"] = 0;
            _this25.GST_Val_total.SGST_val += __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item["SGST_val"]);
            _this25.GST_Val_total.CGST_val += __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item["CGST_val"]);
            _this25.GST_Val_total.IGST_val += __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item["IGST_val"]);
            _this25.totalTradeDiscount += __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item["tradeDiscount"]);
            _this25.totalSpecialCharge += __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(item["specialCharge"]);
          }
          _this25.items[index] = item;
        });
        this.GST_Percentage_total = Object(__WEBPACK_IMPORTED_MODULE_20__utils___["c" /* getGSTPercentageTotal */])(this.items);
        this.updateAndEmit("items", this.items);
        this.updateAndEmit("tradeDiscount", this.totalTradeDiscount);
        this.updateAndEmit("specialCharge", this.totalSpecialCharge);
      }
    },
    updateAndEmit: function updateAndEmit(key, value) {
      this.invoiceDraft[key] = value;
    },
    saveAndPrint: function saveAndPrint(vertical) {
      var _this26 = this;

      this.basicInvoicePrint(vertical, true);
      setTimeout(function () {
        _this26.saveInvoice();
      }, 5000);
    },
    ewayBillSave: function ewayBillSave(ewayBillDetails) {
      this.updateAndEmit("ewayBillDetails", ewayBillDetails);
      // this.ewayBillDialog = false;
      this.saveInvoice();
      document.querySelector(".e-way-bill .v-expansion-panel__header").click();
      document.querySelector(".extra-detail .v-expansion-panel__header").click();
    },
    eWayBillPrint: function eWayBillPrint() {
      this.updateStatus();
      this.updateAndEmit("branch", this.branch);
      this.updateAndEmit("isBuyer", this.isBuyer);
      this.updateAndEmit("transactionType", this.transactionType);
      this.updateAndEmit("buyerId", this.selectedBuyer[".key"]);
      this.updateAndEmit("totalExtraCharges", this.totalExtraCharges);
      if (this.gstOnExtraChanrges) {
        this.updateAndEmit("totalExtraChargesGST", this.totalExtraChargesGST);
        this.updateAndEmit("gstOnExtraChanrges", this.gstOnExtraChanrges);
      }
      this.updateAndEmit("extraCharges", this.extraCharges);

      this.updateAndEmit("incentives", this.incentives);
      this.updateAndEmit("totalAmount", this.principalValueTotal);
      // this.ewayBillDialog = true;
    },
    saveInvoice: function saveInvoice() {
      var _this27 = this;

      this.updateStatus();
      this.updateAndEmit("branch", this.branch);
      this.updateAndEmit("isBuyer", this.isBuyer);
      this.updateAndEmit("transactionType", this.transactionType);
      this.updateAndEmit("buyerId", this.selectedBuyer[".key"]);
      this.updateAndEmit("totalExtraCharges", this.totalExtraCharges);
      if (this.gstOnExtraChanrges) {
        this.updateAndEmit("totalExtraChargesGST", this.totalExtraChargesGST);
        this.updateAndEmit("gstOnExtraChanrges", this.gstOnExtraChanrges);
      }
      this.updateAndEmit("extraCharges", this.extraCharges);
      this.updateAndEmit("incentives", this.incentives);
      this.updateAndEmit("totalAmount", this.principalValueTotal);
      var p = new Ping({ timeout: 3000 });
      p.ping("http://google.com", function (err, data) {
        // Also display error if err is returned.
        if (err) {
          _this27.snackbar = true;
          _this27.snackbarMsg = "It seems like you are offline. Check your Internet Connectivity.";
          console.log("error loading resource");
          data = data + " " + err;
        } else {
          _this27.snackbar = false;
          if (_this27.firmSetting && _this27.firmSetting.verifiedInvoice) {
            var firm = _this27.firms.filter(function (item) {
              return item[".key"] == _this27.selectedFirm;
            })[0];
            if (firm.mobileNumber) {
              _this27.otpData.mobile = firm.mobileNumber;
              _this27.otpData.otp = Math.floor(100000 + Math.random() * 900000);
              var message = "OTP for Invoice of Amount \u20B9" + __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(_this27.totalAmount).toFixed(2) + " under " + (_this27.selectedBuyer.name ? _this27.selectedBuyer.name : "") + " is " + _this27.otpData.otp + ". Please enter otp in portal to continue.";
              _this27.snackbar = true;
              _this27.snackbarMsg = "Sending verification OTP.";
              Object(__WEBPACK_IMPORTED_MODULE_19__services_twilio_js__["a" /* sendSms */])(["+91" + firm.mobileNumber], message).then(function (response) {
                console.log(response);
                _this27.otpData.dialog = true;
              });
            }
          } else {
            _this27.createInvoice(_this27.invoiceDraft);
          }
        }
      });
      document.querySelector(".extra-detail .v-expansion-panel__header").click();
    },
    confirmOTP: function confirmOTP() {
      if (this.otpData.otp == this.otpData.confirmOtp) {
        this.createInvoice(this.invoiceDraft);
        this.otpData.dialog = false;
      }
    },
    getCurrentUser: function getCurrentUser() {
      var _this28 = this;

      this.placeOfSupply = this.selectedBuyer ? this.selectedBuyer.state : null;
      if (!this.selectedFirm) {
        // if(this.selectedBuyer && this.selectedBuyer.defaultFirm) {
        //   this.selectedFirm = this.selectedBuyer.defaultFirm;
        // }
        // else {
        var defaultFirm = this.firms.filter(function (item) {
          return item["brand"] === _this28.selectedBrand && !!item["defaultFirm"];
        })[0];
        this.selectedFirm = defaultFirm[".key"];
        this.selectedFirmState = defaultFirm["state"];
        if (!this.placeOfSupply && this.selectedFirmState) {
          this.placeOfSupply = this.selectedFirmState;
        }
        this.businessType = defaultFirm["businessType"];
        this.updateAndEmit("businessType", this.businessType);
        //}
      }
      this.getFirmAndBankBalance();
      if (!this.invoiceId) {
        this.firmBasedInvoiceId(true);
      }
    },
    firmBasedInvoiceId: function firmBasedInvoiceId(override) {
      var _this29 = this;

      if (this.isBuyer) {
        var firm = this.firms.filter(function (item) {
          return item[".key"] == _this29.selectedFirm;
        })[0];
        var firmInvoiceCount = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(firm.lastInvoiceCount || this.invoices.filter(function (item) {
          return item["brand"] === _this29.selectedBrand && item["firm"] == _this29.selectedFirm && item["isBuyer"] == true;
        }).length);
        var finYear = this.finYear.finYear + "-ACU";
        var count = firmInvoiceCount + 1;
        var firmLastCountDate = firm.lastCountDate;
        if (this.firmSetting) {
          finYear = this.firmSetting.invoiceIdPrefix || this.finYear.finYear + "-ACU";
          if (this.firmSetting.invoiceResetFinYear) {
            firmInvoiceCount = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(firm['invoiceCount_' + this.finYear.finYear] || 0);
            count = firmInvoiceCount + 1;
            firmLastCountDate = firm['invoiceCountDate_' + this.finYear.finYear];
          }
          //count = this.firmSetting.autoCounter ? firmInvoiceCount + 1 : firmInvoiceCount;
        }
        // this.invoiceId = finYear+"-" + (count);
        // this.lastInvoiceCount = count;
        // this.invoiceIdPrefix = finYear;
        // this.invoiceIdPostfix = (count);
        if (override) {
          this.invoiceId = finYear + "-" + count;
          this.lastInvoiceCount = count;
          this.invoiceIdPrefix = finYear;
          this.invoiceIdPostfix = count;
        }
        // if (this.firmSetting.invoiceIdByDate) {
        //   let newCount = this.invoices.filter(
        //     (item) =>
        //       item["brand"] === this.selectedBrand &&
        //       item["firm"] == this.selectedFirm &&
        //       item["isBuyer"] == true &&
        //       item["date"] <= new Date().getTime() &&
        //       item["date"] >= new Date(this.finYear.start).getTime()
        //   ).length;
        //   this.invoiceIdPostfix = newCount;
        // }

        // if (this.firmSetting.invoiceResetFinYear) {
        //   let newCount = this.invoices.filter(
        //     (item) =>
        //       item["brand"] === this.selectedBrand &&
        //       item["isBuyer"] == true &&
        //       item["date"] <= new Date().getTime() &&
        //       item["date"] >= new Date(this.finYear.start).getTime()
        //   ).length;
        //   this.invoiceIdPostfix = newCount;
        // }
        var tempDate = new Date();
        this.lastCountDate = new Date(this.invoiceDate).setHours(tempDate.getHours(), tempDate.getMinutes(), tempDate.getSeconds());
        if (firmLastCountDate && this.lastCountDate > firmLastCountDate) {
          this.updateLastCount = true;
        } else if (!firmLastCountDate) {
          this.updateLastCount = true;
        } else {
          this.updateLastCount = false;
        }
      } else if (override) {
        this.invoiceId = null;
        this.invoiceIdPrefix = "";
        this.invoiceIdPostfix = "";
      }
      this.duplicateCheckInvoiceId();
    },
    duplicateCheckInvoiceId: function duplicateCheckInvoiceId() {
      var _this30 = this;

      this.invoiceId = this.invoiceIdPrefix + "-" + this.invoiceIdPostfix;
      var invoices = this.invoices.filter(function (item) {
        return item["brand"] === _this30.selectedBrand && item["firm"] == _this30.selectedFirm && item["invoiceId"] == _this30.invoiceId;
      });

      if (invoices.length) {
        this.duplicateError = "Invoice with invoiceId " + this.invoiceId + " Already exist.";
        setTimeout(function () {
          _this30.duplicateError = null;
        }, 3000);
      }
    },
    createInvoice: function createInvoice(invoiceData) {
      var _this31 = this;

      this.isSaving = true;
      invoiceData["adminEmail"] = this.adminEmail;
      this.dialog = false;
      invoiceData["items"].forEach(function (item, index) {
        item["date"] = invoiceData["date"];
        if (invoiceData.businessType == "Medical/Pesticides" || !invoiceData.businessType) {
          invoiceData["items"][index]["batchId"] = _this31.addBatchDetails(item, _this31.isBuyer);
        }
        //const response = this.$root.$firebaseRefs.item.push(item);
        //invoiceData["items"][index]["id"] = response["key"];
      });
      var res = this.$root.$firebaseRefs.invoice.push(invoiceData);
      if (res.key) {
        invoiceData["parentInvoiceKey"] = res.key;
        invoiceData["newlyCreated"] = true;
        invoiceData["isLatest"] = true;

        if (invoiceData.bank && !!this.bankById[invoiceData.bank]) {
          invoiceData.accountNumber = this.bankById[invoiceData.bank].accountnumber;
        }
        this.$root.$firebaseRefs.invoiceHistory.push(invoiceData);
        this.saveUniqueIdProducts(invoiceData, res.key);
      }
      this.multiFirmItems = _.concat(this.multiFirmItems, JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.items)));
      if (invoiceData.status != "due") {
        this.createReceipt(invoiceData, res.key);
      }
      this.sendNotification();
      this.manageDrawers(invoiceData, res.key);
      this.manageEstimate();
      this.manageInvoiceCount();
      this.managePayments(invoiceData);
      this.manageProductsQuantity(invoiceData);

      if (this.$route.params.customerId) {
        // this.$router.push({path: `/buyers/${this.$route.params.customerId}` })
        this.$router.push({
          path: "/buyers/" + invoiceData["buyerId"].toString() + "/" + invoiceData["isBuyer"].toString()
        });
      }
      if (this.multiFirmData.length) {
        if (this.multiFirmData.length == this.multiFirmIndex + 1) {
          this.manageOrder();
          this.multiFirmData = [];
          this.multiFirmIndex = 0;
          this.multiFirmPayment = invoiceData["buyerId"];
        } else {
          this.multiFirmIndex++;
          this.getOrderProductInfo();
          this.getMultifirmOrderData();
        }
      } else if (this.$route.params.orderId) {
        this.manageOrder();
      }
    },
    createReceipt: function createReceipt(invoiceData, invoiceKey) {
      var firm = this.firms.find(function (item) {
        return item[".key"] == invoiceData.firm;
      });
      var firmReceiptCount = invoiceData.isBuyer ? firm.lastReceiptCount ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(firm.lastReceiptCount) + 1 : 1 : firm.lastReceiptCountSeller ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(firm.lastReceiptCountSeller) + 1 : 1;
      var amountToBePaid = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash) + __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank);
      var receipt = {
        date: invoiceData.date,
        firm: invoiceData.firm,
        isBuyer: invoiceData.isBuyer,
        buyerId: invoiceData.buyerId,
        brand: invoiceData.brand,
        amount: amountToBePaid,
        remainingAmount: 0,
        receiptNumber: firmReceiptCount,
        paymentType: invoiceData.paymentType,
        settledInvoiceDetails: [{
          invoiceId: invoiceKey,
          settledAmount: amountToBePaid,
          status: invoiceData.status
        }]
      };

      if (invoiceData.paymentType == "Bank") {
        receipt["transferType"] = invoiceData.transferType;
        receipt["transferDetails"] = invoiceData.transferDetails;
      }
      this.$root.$firebaseRefs.customerPayments.push(receipt);
      if (invoiceData.isBuyer) {
        this.$root.$firebaseRefs.firm.child(receipt.firm).update({
          lastReceiptCount: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(receipt.receiptNumber)
        }, function () {
          //console.info("last receiptNumber updated...");
        });
      } else {
        this.$root.$firebaseRefs.firm.child(receipt.firm).update({
          lastReceiptCountSeller: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(receipt.receiptNumber)
        }, function () {
          //console.info("last receiptNumber updated...");
        });
      }
    },
    manageDrawers: function manageDrawers(invoiceData, invoiceKey) {
      var _this32 = this;

      invoiceData.items.map(function (item) {
        if (item.drawerId) {
          var drawerT = {
            brand: _this32.selectedBrand,
            drawer: item.drawerId,
            product: item.productId,
            quantity: item.quantity,
            isBuyer: invoiceData.isBuyer,
            invoiceId: invoiceData.invoiceId,
            invoiceKey: invoiceKey,
            date: invoiceData.date
          };
          _this32.$root.$firebaseRefs.drawerTransaction.push(drawerT);
        }
      });
    },
    saveUniqueIdProducts: function saveUniqueIdProducts(invoiceData, invoiceId) {
      var _this33 = this;

      if (this.businessType == "Jwellery") {
        invoiceData.items.map(function (item) {
          if (item.unqId) {
            if (invoiceData.isBuyer) {
              var uniqueId = _this33.productUniqueIds.find(function (prd) {
                return prd[".key"] == item["unqIdKey"];
              });
              var key = uniqueId[".key"];
              delete uniqueId[".key"];
              uniqueId["invoiceDate"] = invoiceData["date"];
              uniqueId["invoiceId"] = invoiceId;
              uniqueId["sold"] = true;
              _this33.$root.$firebaseRefs.productUniqueId.child(key).update(uniqueId).then(function (data) {}).catch(function (error) {
                console.log(error.code, error.message);
              });
            } else {
              var currentSet = {
                brand: _this33.selectedBrand,
                date: invoiceData["date"],
                grossWeight: item["grossWeight"],
                purity: item["purity"],
                unqId: item["unqId"],
                invoiceDate: invoiceData["date"],
                invoiceId: invoiceId,
                sold: false,
                product: item.productId,
                autoGenerated: true,
                barcode: item["barcode"]
              };
              _this33.$root.$firebaseRefs.productUniqueId.push(currentSet);
            }
          }
        });
      }
    },
    sendNotification: function sendNotification() {
      if (this.selectedBuyer.mobile) {
        var message = "Hi, " + (this.selectedBuyer.name ? this.selectedBuyer.name : "") + " Invoice of Amount \u20B9" + __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(this.totalAmount).toFixed(2) + " has been created. Thank You!";
        Object(__WEBPACK_IMPORTED_MODULE_19__services_twilio_js__["a" /* sendSms */])(["+91" + this.selectedBuyer.mobile], message);
      }
      this.sendWhatsappNotificationToBrandAdmin();
    },
    sendWhatsappNotificationToBrandAdmin: function sendWhatsappNotificationToBrandAdmin() {
      var _this34 = this;

      var message = "Invoice of amount \u20B9" + __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(this.totalAmount).toFixed(2) + " has been created, under " + (this.selectedBuyer.name ? this.selectedBuyer.name : "") + ".";
      var adminUsers = this.operatorsList.filter(function (item) {
        return item["brand"] === _this34.selectedBrand && item["role"] == "admin";
      });
      var mobileNumbers = [];
      adminUsers.map(function (user) {
        if (user.mobile && user.notificationWSAPP) {
          mobileNumbers.push("+91" + user.mobile);
        }
      });
      Object(__WEBPACK_IMPORTED_MODULE_19__services_twilio_js__["b" /* sendWhatsApp */])(mobileNumbers, message);
    },
    getOrderAfterInvoiceGenerate: function getOrderAfterInvoiceGenerate() {
      var _this35 = this;

      var order = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.orderById[this.$route.params.orderId]));
      order.status = "BILLED";
      order.historyItems = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(order.items));
      order.items.map(function (orderItem, index) {
        var currentItem = _.find(_this35.multiFirmItems, function (o) {
          return o["productId"] == orderItem["productId"];
        });
        if (currentItem) {
          order.historyItems[index]["quantity"] = currentItem.quantity;
          if (orderItem.quantity > currentItem.quantity) {
            order.status = "IN PROGRESS";
            order.items[index]["quantity"] = orderItem.quantity - currentItem.quantity;
          } else {
            order.items[index]["completed"] = true;
          }
          if (order.isPortfolio && !orderItem["selected"]) {
            order.status = "IN PROGRESS";
          }
        } else {
          order.status = "IN PROGRESS";
        }
      });
      order.items = order.items.filter(function (item) {
        return !item["completed"] || order.isPortfolio ? !item["selected"] : true;
      });
      if (order.status == "BILLED") {
        return null;
      } else {
        return order;
      }
    },
    manageOrder: function manageOrder() {
      var _this36 = this;

      var orderId = this.$route.params.orderId;
      if (orderId) {
        var orderToBeCreated = this.getOrderAfterInvoiceGenerate(orderId);

        var order = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.orderById[this.$route.params.orderId]));
        delete order[".key"];

        order["invoiceDate"] = new Date(this.invoiceDate).getTime();
        if (order.isPortfolio) {
          var history = {
            date: new Date(this.invoiceDate).getTime(),
            items: orderToBeCreated["items"],
            type: "INVOICE"
          };
          if (!orderToBeCreated) {
            order["status"] = "BILLED";
          } else {
            order["items"] = orderToBeCreated["items"];
          }

          if (order["orderHistory"]) {
            order["orderHistory"].push(history);
          } else {
            order["orderHistory"] = [history];
          }
        } else {
          if (!order["orignalOrder"]) {
            order["orignalOrder"] = order["items"];
          }
          if (orderToBeCreated) {
            order["items"] = orderToBeCreated["items"];
            var _history = {
              date: orderToBeCreated.date,
              items: orderToBeCreated.historyItems
            };
            if (order["orderHistory"]) {
              order["orderHistory"].push(_history);
            } else {
              order["orderHistory"] = [_history];
            }
          } else {
            var _history2 = {
              date: order.date,
              items: order.items
            };
            if (order["orderHistory"]) {
              order["orderHistory"].push(_history2);
            } else {
              order["orderHistory"] = [_history2];
            }
            order["status"] = "BILLED";
          }
        }

        this.$root.$firebaseRefs.orders.child(orderId).set(order).then(function (snap) {
          _this36.$router.push({ path: "/recordOrder" });
        });
      }
    },
    manageEstimate: function manageEstimate() {
      if (this.$route.params.estimateId) {
        var estimate = this.estimateById[this.$route.params.estimateId];
        delete estimate[".key"];
        estimate["status"] = "BILLED";
        estimate["invoiceDate"] = new Date(this.invoiceDate).getTime();
        this.$root.$firebaseRefs.estimates.child(this.$route.params.estimateId).set(estimate).then(function (snap) {});
      }
    },
    manageInvoiceCount: function manageInvoiceCount() {
      if (this.lastInvoiceCount && this.isBuyer && this.updateLastCount) {
        if (this.firmSetting && this.firmSetting.invoiceResetFinYear) {
          var obj = {};
          obj['invoiceCount_' + this.finYear.finYear] = this.lastInvoiceCount;
          obj['invoiceCountDate_' + this.finYear.finYear] = this.lastCountDate;
          this.$root.$firebaseRefs.firm.child(this.selectedFirm).update(obj, function () {
            console.info("last invoice Count updated...");
          });
        } else {
          this.$root.$firebaseRefs.firm.child(this.selectedFirm).update({
            lastInvoiceCount: this.lastInvoiceCount,
            lastCountDate: this.lastCountDate
          }, function () {
            console.info("last invoice Count updated...");
          });
        }
      }
    },
    addBatchDetails: function addBatchDetails(product, isBuyer) {
      var _this37 = this;

      console.log("adding batch details");
      var batchArray = this.batch.filter(function (item) {
        return item["batchNumber"] == product.batchNumber && item["brand"] === _this37.selectedBrand && item["product"] === product.productId;
      });
      var batchId = null;
      if (batchArray.length) {
        // let batchObj = batchArray[0];
        var batchObj = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(batchArray[0]));
        batchObj.quantity = isBuyer ? batchObj.quantity - product.quantity : batchObj.quantity + product.quantity;
        var key = batchObj[".key"];
        delete batchObj[".key"];
        batchId = key;
        this.$root.$firebaseRefs.batchTransaction.child(key).set(batchObj);
      } else {
        var _batchObj = {
          quantity: isBuyer ? -product.quantity : product.quantity,
          // expiryDate : product.expiryDate,
          // manufacturingDate :product.manufacturingDate,
          expiryDate: new Date(product.expiryDate).getTime(),
          manufacturingDate: new Date(product.manufacturingDate).getTime(),
          product: product.productId,
          batchNumber: product.batchNumber,
          brand: this.selectedBrand,
          createdDate: new Date().getTime()
        };
        var response = this.$root.$firebaseRefs.batchTransaction.push(_batchObj);
        batchId = response["key"];
      }
      delete product["expiryDate"];
      delete product["manufacturingDate"];
      delete product["batchNumber"];
      return batchId;
    },
    managePayments: function managePayments(invoiceData) {
      switch (invoiceData.paymentType) {
        case "Cash":
          {
            if (invoiceData.amountFromCash) {
              var firm = this.firmById[invoiceData.firm];
              if (firm && (invoiceData.status == "paid" || invoiceData.status == "partial")) {
                firm.amount = this.isBuyer ? __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(firm.amount) + __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash) : __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(firm.amount) - __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash);
                delete firm[".key"];
                this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(firm);
              }
            }
            break;
          }
        case "Bank Account":
          {
            if (invoiceData.amountFromBank) {
              var bank = this.bankById[invoiceData.bank];
              if (bank && (invoiceData.status == "paid" || invoiceData.status == "partial")) {
                bank.amount = this.isBuyer ? __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(bank.amount) + __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank) : __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(bank.amount) - __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank);
                delete bank[".key"];
                this.$root.$firebaseRefs.account.child(invoiceData.bank).set(bank);
              }
            }
            break;
          }
        case "CashAndBank Account":
          {
            if (invoiceData.amountFromCash && invoiceData.amountFromBank) {
              var _bank = this.bankById[invoiceData.bank];
              if (_bank && (invoiceData.status == "paid" || invoiceData.status == "partial")) {
                _bank.amount = this.isBuyer ? __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(_bank.amount) + __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank) : __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(_bank.amount) - __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank);
                delete _bank[".key"];
                this.$root.$firebaseRefs.account.child(invoiceData.bank).set(_bank);
              }
              var _firm = this.firmById[invoiceData.firm];
              if (_firm && (invoiceData.status == "paid" || invoiceData.status == "partial")) {
                _firm.amount = this.isBuyer ? __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(_firm.amount) + __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash) : __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(_firm.amount) - __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash);
                delete _firm[".key"];
                this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(_firm);
              }
            }
            break;
          }
      }
    },
    manageProductsQuantity: function manageProductsQuantity(invoiceData) {
      var _this38 = this;

      invoiceData.items.map(function (item) {
        var key = item["productId"];
        var product = _this38.productById[key];
        var prodQuantity = product["quantity"];
        var itemQuantity = item["quantity"];
        if (product.unitsDeatilsAdded) {
          var selectedUnitOrder = null;
          var multiplayer = 1;
          product.unitsDetails.map(function (prod) {
            if (prod["unit"] == item["unit"]) {
              selectedUnitOrder = prod["order"];
            }
          });
          product.unitsDetails.map(function (prod) {
            if (prod["order"] > selectedUnitOrder) {
              multiplayer = multiplayer * prod["quantity"];
            }
          });
          itemQuantity = itemQuantity * multiplayer;
        }
        if (_this38.isBuyer) {
          var saleQuantity = product["saleQuantity"] ? product["saleQuantity"] : 0;
          saleQuantity = saleQuantity + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(itemQuantity);
          product["saleQuantity"] = saleQuantity;
          if (!product["updatedSellingDate"] || invoiceData.date > product["updatedSellingDate"]) {
            product["updatedSellingDate"] = invoiceData.date;
          }
        } else {
          var purchaseQuantity = product["purchaseQuantity"] ? product["purchaseQuantity"] : 0;
          purchaseQuantity = purchaseQuantity + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(itemQuantity);
          product["purchaseQuantity"] = purchaseQuantity;
        }
        prodQuantity = _this38.isBuyer ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(prodQuantity) - __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(itemQuantity) : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(prodQuantity) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_int___default()(itemQuantity);
        delete product[".key"];
        product["quantity"] = prodQuantity;
        _this38.$root.$firebaseRefs.products.child(key).set(product);
      });
      this.snackbarSuccess = true;
      this.resetInvoice();
    },
    resetInvoice: function resetInvoice() {
      var _this39 = this;

      this.selectedBuyer = null, this.isBuyer = true, this.isEditItems = false, this.duplicateError = null, this.items = [], this.totalTradeDiscount = 0, this.totalSpecialCharge = 0, this.editedIndex = -1, this.editedItem = {
        productName: "",
        productId: "",
        HSN_code: "",
        taxableGST_rate: 0,
        rate: 0,
        unit: "",
        quantity: 1,
        basicPrice: 0,
        GSTValue: 0,
        totlePrice: 0,
        tradeDiscount: 0,
        specialCharge: 0
      }, this.defaultItem = {
        productName: "",
        productId: "",
        HSN_code: "",
        taxableGST_rate: 0,
        rate: 0,
        unit: "",
        quantity: 0,
        basicPrice: 0,
        GSTValue: 0,
        totlePrice: 0,
        tradeDiscount: 0,
        specialCharge: 0
      }, this.amountFromCash = 0, this.amountFromBank = 0, this.alertDuration = 0, this.paymentType = "",
      // this.selectedFirm= "",
      this.selectedBank = "", this.soldBy = "", this.brokerageRate = 0,
      // this.godawnBy = '',
      this.placeOfSupply = "", this.invoiceDate = new Date().toISOString().substr(0, 10), this.dateFormatted = new Date().toISOString().substr(0, 10), this.datepicker = false, this.totalAmount = 0, this.paidAmount = 0, this.remainingAmount = 0, this.discountAmount = 0, this.roundOffAmount = 0,
      // this.invoiceDraft= {},
      this.transferType = null, this.transferTypeDialog = false, this.availableBalance = 0, this.transactionType = "Debit", this.amountFromCashDisabled = true, this.amountFromBankDisabled = true, this.status = null, this.gstType = null, this.currentUser = null, this.remark = null, this.applicationNumber = null, this.sanctionDate = null, this.invoiceId = null, this.GST_Val_total = {
        CGST_val: 0,
        SGST_val: 0,
        IGST_val: 0
      }, this.GST_Percentage_total = {
        GST_3: 0,
        GST_5: 0,
        GST_12: 0,
        GST_18: 0,
        GST_28: 0
      }, this.roundOff = 2, this.transactionDialog = false, this.expansionVal = false, this.transferDetails = {
        accountNumber: null,
        accountHolderName: null,
        bankName: null,
        IFSCcode: null,
        remark: null
      };
      this.isIncentive = false;
      this.incentives = [];
      this.extraCharges = [];
      this.gstOnExtraChanrges = false;
      this.totalExtraCharges = 0;
      this.totalExtraChargesGST = 0;
      this.invoiceDraft = {
        items: this.items,
        amountFromCash: this.amountFromCash || 0,
        amountFromBank: this.amountFromBank || 0,
        brand: this.selectedBrand,
        brandFinYear: this.brandFinYear,
        date: Date.now(),
        transferDetails: this.transferDetails,
        transferType: ["Cash", ""].includes(this.paymentType) ? "0" : this.transferType,
        duration: this.alertDuration, // days
        paymentType: this.paymentType,
        transactionType: this.transactionType,
        isCredited: false,
        firm: this.selectedFirm,
        bank: ["Cash", ""].includes(this.paymentType) ? 0 : this.selectedBank,
        totalAmount: this.principalValueTotal || 0,
        paidAmount: this.paidAmount || 0,
        remainingAmount: this.remainingAmount || 0,
        discountAmount: this.discountAmount || 0,
        roundOffAmount: this.roundOffAmount || 0,
        status: this.status,
        gstType: this.gstType,
        invoiceId: this.invoiceId,
        soldBy: this.soldBy,
        brokerageRate: this.brokerageRate || 0,
        // godawnBy : this.godawnBy,
        placeOfSupply: this.placeOfSupply,
        totalTradeDiscount: this.totalTradeDiscount,
        totalSpecialCharge: this.totalSpecialCharge,
        remark: this.remark,
        applicationNumber: this.applicationNumber,
        sanctionDate: this.sanctionDate
      };
      this.selectedProductSet = null;
      this.orderNumber = null;
      this.applicationNumber = null;
      this.sanctionDate = null, this.orderDate = null, this.billingDetails = {
        name: null,
        mobile: null,
        address: null
      };
      // this.isIncentive=false;
      // this.incentives=[];
      // this.extraCharges=[];
      // this.totalExtraCharges = 0;
      this.updateAndEmit("date", new Date(this.invoiceDate).getTime());
      this.isSaving = false;
      setTimeout(function () {
        _this39.getCurrentUser();
      }, 1000);
    },

    addCharges: function addCharges(e) {
      var obj = {
        name: e.target.value,
        amount: 0,
        totalAmount: 0
      };
      this.extraChargesSample.push(obj);
    },
    addCustomer: function addCustomer(e) {
      var _this40 = this;

      this.getCurrentUser();
      var obj = {
        name: e.target.value,
        brand: this.selectedBrand
      };
      if (this.selectedFirmState) {
        obj["state"] = this.selectedFirmState;
      }

      if (this.isBuyer) {
        //this.$root.$firebaseRefs.buyer.push(obj);
        var duplicate = this.buyers.filter(function (item) {
          return item["name"] === obj["name"] && item["brand"] == _this40.selectedBrand;
        });
        if (duplicate.length) {
          if (confirm("Buyer with " + obj["name"] + " is Already there. Do you still want to create?")) {
            var res = this.$root.$firebaseRefs.buyer.push(obj);
            this.selectedBuyer = this.buyers.filter(function (item) {
              return item[".key"] === res["key"];
            })[0];
            setTimeout(function () {
              _this40.buyerDialog = true;
            }, 500);
          } else {
            this.selectedBuyer = duplicate[0];
          }
        } else {

          var _res = this.$root.$firebaseRefs.buyer.push(obj);
          this.selectedBuyer = this.buyers.filter(function (item) {
            return item[".key"] === _res["key"];
          })[0];
          setTimeout(function () {
            _this40.buyerDialog = true;
          }, 500);
        }
      } else {
        //this.$root.$firebaseRefs.seller.push(obj);
        var _duplicate = this.sellers.filter(function (item) {
          return item["name"] === obj["name"] && item["brand"] == _this40.selectedBrand;
        });
        if (_duplicate.length) {
          if (confirm("Seller with " + obj["name"] + " is Already there. Do you still want to create?")) {
            var _res2 = this.$root.$firebaseRefs.seller.push(obj);
            this.selectedBuyer = this.sellers.filter(function (item) {
              return item[".key"] === _res2["key"];
            })[0];
            setTimeout(function () {
              _this40.buyerDialog = true;
            }, 500);
          } else {
            this.selectedBuyer = _duplicate[0];
          }
        } else {
          var _res3 = this.$root.$firebaseRefs.seller.push(obj);
          this.selectedBuyer = this.sellers.filter(function (item) {
            return item[".key"] === _res3["key"];
          })[0];
          setTimeout(function () {
            _this40.buyerDialog = true;
          }, 500);
        }
      }
    }
  }
}, __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_components$data$comp, "mounted", function mounted() {
  var self = this;
  this._keyListener = function (e) {
    var key;
    var isShift;
    if (window.event) {
      key = window.event.keyCode;
      isShift = !!window.event.shiftKey; // typecast to boolean
    } else {
      key = ev.which;
      isShift = !!ev.shiftKey;
    }
    if (isShift) {
      switch (key) {
        case 16:
          // ignore shift key
          break;
        default:
          {
            switch (window.event.key) {
              case "N":
                {
                  self.dialog = true;
                  console.log("add new item");
                  break;
                }
              case "A":
                {
                  if (self.dialog) {
                    var btn = document.getElementsByClassName("add-save-btn-add-icons");
                    if (!btn[0].classList.contains("v-btn--disabled")) {
                      document.getElementsByClassName("add-save-btn-add-icons")[0].click();
                    }
                    console.log("save and add");
                  }
                  break;
                }
              case "S":
                {
                  if (self.dialog) {
                    var _btn = document.getElementsByClassName("add-btn-add-icons");
                    if (!_btn[0].classList.contains("v-btn--disabled")) {
                      document.getElementsByClassName("add-btn-add-icons")[0].click();
                    }
                    console.log("save");
                  }
                  break;
                }
              case "C":
                {
                  if (self.dialog) {
                    document.getElementsByClassName("cancel-btn-add-icons")[0].click();
                    console.log("cancel");
                  }
                  break;
                }
              case "W":
                {
                  //document.getElementsByClassName('js-customer-switcher')[0].click()
                  this.isBuyer = !this.isBuyer;
                  setTimeout(function () {
                    document.querySelector(".js-select-buyer input").click();
                  }, 1000);
                  console.log("cancel");
                  break;
                }
              case "P":
                {
                  if (!self.dialog && self.selectedFirm && self.transactionType && self.items.length) {
                    self.saveAndPrint(true);
                    console.log("save and print");
                  }
                  break;
                }
              case "Z":
                {
                  if (!self.dialog && self.selectedFirm && self.transactionType && self.items.length) {
                    self.saveInvoice(true);
                    console.log("save");
                  }
                  break;
                }
              case "H":
                {
                  if (!self.dialog && self.selectedFirm && self.transactionType && self.items.length) {
                    self.basicInvoicePrint(false, true);
                    console.log("horizontal print");
                  }
                  break;
                }
              case "V":
                {
                  if (!self.dialog && self.selectedFirm && self.transactionType && self.items.length) {
                    self.basicInvoicePrint(true, true);
                    console.log("vertical print");
                  }
                  break;
                }
              case "E":
                {
                  if (!self.dialog && self.selectedFirm && self.transactionType && self.items.length) {
                    self.eWayBillPrint();
                    console.log("eway print");
                  }
                  break;
                }
              case "G":
                {
                  this.$router.push({
                    path: "/settings/product-grouping/true/invoice"
                  });
                  break;
                }
              case "T":
                {
                  this.$router.push({
                    path: "/settings/product-set/true/invoice"
                  });
                  break;
                }
                break;
            }
          }
      }
    }
  };
  //document.addEventListener('keydown', this._keyListener.bind(this));
  this._keyListener1 = function (e) {
    if (window.event.keyCode == 73 && window.event.ctrlKey) {
      //ctrl + i
      window.event.preventDefault();
      self.dialog = true;
      console.log("add new item");
    }
    if (window.event.keyCode == 107) {
      // plus(+)
      if (self.dialog) {
        var btn = document.getElementsByClassName("add-save-btn-add-icons");
        if (!btn[0].classList.contains("v-btn--disabled")) {
          window.event.preventDefault();
          document.getElementsByClassName("add-save-btn-add-icons")[0].click();
          console.log("save and add");
        }
      }
    }
    if (window.event.keyCode == 13) {
      //enter
      if (self.dialog) {
        window.event.preventDefault();
        var _btn2 = document.getElementsByClassName("add-btn-add-icons");
        if (!_btn2[0].classList.contains("v-btn--disabled")) {
          document.getElementsByClassName("add-btn-add-icons")[0].click();
        }
        console.log("save");
      }
    }
    if (window.event.keyCode == 27) {
      //escape
      if (self.dialog) {
        window.event.preventDefault();
        document.getElementsByClassName("cancel-btn-add-icons")[0].click();
        console.log("cancel");
      }
    }
    if (window.event.keyCode == 70 && window.event.ctrlKey) {
      //ctrl + f
      this.isBuyer = !this.isBuyer;
      window.event.preventDefault();
      setTimeout(function () {
        document.querySelector(".js-select-buyer input").click();
      }, 1000);
      console.log("switch to purchase/sale");
    }
    if (window.event.keyCode == 80 && window.event.ctrlKey) {
      //ctrl + p
      if (!self.dialog && self.selectedFirm && self.transactionType && self.items.length) {
        window.event.preventDefault();
        self.saveAndPrint(true);
        console.log("Save and Print");
      }
    }
    if (window.event.keyCode == 83 && window.event.ctrlKey) {
      //ctrl + s
      if (!self.dialog && self.selectedFirm && self.transactionType && self.items.length) {
        window.event.preventDefault();
        self.saveInvoice(true);
        console.log("Save Invoice");
      }
    }
    if (window.event.keyCode == 72 && window.event.ctrlKey) {
      //ctrl + h
      if (!self.dialog && self.selectedFirm && self.transactionType && self.items.length) {
        window.event.preventDefault();
        self.basicInvoicePrint(false, true);
        console.log("horizontal print");
      }
    }
    if (window.event.keyCode == 86 && window.event.ctrlKey) {
      //ctrl + v
      if (!self.dialog && self.selectedFirm && self.transactionType && self.items.length) {
        window.event.preventDefault();
        self.basicInvoicePrint(true, true);
        console.log("vertical print");
      }
    }
    if (window.event.keyCode == 69 && window.event.ctrlKey) {
      //ctrl + e
      if (!self.dialog && self.selectedFirm && self.transactionType && self.items.length) {
        window.event.preventDefault();
        self.eWayBillPrint();
        console.log("eway print");
      }
    }
    if (window.event.keyCode == 71 && window.event.ctrlKey) {
      //ctrl + g
      window.event.preventDefault();
      self.$router.push({ path: "/settings/product-grouping/true/invoice" });
    }
    if (window.event.keyCode == 84 && window.event.ctrlKey) {
      //ctrl + t
      window.event.preventDefault();
      self.$router.push({ path: "/settings/product-set/true/invoice" });
    }
  };
  document.addEventListener("keydown", this._keyListener1.bind(this));
}), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_defineProperty___default()(_components$data$comp, "beforeDestroy", function beforeDestroy() {
  document.removeEventListener("keydown", this._keyListener1);
}), _components$data$comp);

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddItemMed_vue__ = __webpack_require__(484);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0627db83_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddItemMed_vue__ = __webpack_require__(1485);
function injectStyle (ssrContext) {
  __webpack_require__(1471)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddItemMed_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0627db83_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddItemMed_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_body_parser__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_body_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_body_parser__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    buyer: Object,
    firmSetting: Object,
    dialog: Boolean,
    selectedFirm: String,
    isEditItems: Boolean,
    gstInvoice: Boolean,
    isBuyer: Boolean,
    allItems: Array,
    // individualProdBrokerage : Boolean,
    invoiceDate: String,
    editedItem: {
      type: Object,
      default: function _default() {
        return {
          productName: "",
          productId: "",
          HSN_code: "",
          taxableGST_rate: 0,
          rate: 0,
          unit: "",
          quantity: 0,
          basicPrice: 0,
          GSTValue: 0,
          totlePrice: 0,
          GST_type: "",
          productUnit: '',
          tradeDiscount: 0,
          expiryDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().substr(0, 10),
          manufacturingDate: new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toISOString().substr(0, 10),
          batchNumber: 'DEFAULT',
          drawer: '',
          drawerId: null,
          brokerageRate: 0
        };
      }
    },
    godawn: String
  },
  data: function data() {
    return {
      productBatches: [],
      productReportDialog: false,
      search: null,
      timeoutSearch: null,
      isTradePercentage: false,
      productsWithSimilarCompostion: [],
      selectedCompositionProd: null,
      compositionDialog: false,
      isComposition: true,
      scannerDialog: false,
      tradeDiscountPercentage: null,
      item: this.editedItem,
      products: [],
      availableProductUnit: this.units,
      selectedProduct: {},
      stepper: 1,
      isOpeningBalance: false,
      isStanderedPrice: false,
      datepicker: false,
      snackbar: false,
      productChanged: false,
      duplicateError: null,
      timeout: 3000,
      datepickerExp: null,
      datepickerMen: null,
      GST_types: [{
        text: "Exempt",
        value: "EXEMPT"
      }, {
        text: "Nil Rated",
        value: "NILL"
      }, {
        text: "Taxable",
        value: "TAXABLE"
      }, {
        text: "Non-GST",
        value: "OTHER"
      }],
      currentProduct: {
        name: "",
        description: "",
        HSN_code: 0,
        GST_type: "",
        taxableGST_rate: 0,
        unit: "",
        quantity: 0,
        brand: "",
        openingDate: new Date().toISOString().substr(0, 10),
        purchasingPrice: null,
        sellingPrice: null,
        openingBalance: null,
        gstValue: 0,
        basicPrice: 0
      }
    };
  },

  components: {
    ProductReports: function ProductReports() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 62));
    }
  },
  watch: {
    "godawn": {
      handler: function handler(newVal, oldVal) {
        if (!this.item.godawnBy) {
          this.item.godawnBy = newVal;
        }
      },

      deep: true
    },
    search: function search(val) {
      if (val.length > 9) {
        this.addProductByBarcode(val);
      }
    },
    editedItem: function editedItem(val) {
      var _this = this;

      this.item = this.editedItem;
      if (this.editedItem.productId) {
        this.selectedProduct = this.products.filter(function (item) {
          return item['.key'] == _this.editedItem.productId;
        })[0];
        this.availableProductUnit = this.units;
      }
    },

    'dialog': {
      handler: function handler(newVal, oldVal) {
        if (this.editedItem.productId) {
          this.getProductBatch();
          if (this.selectedProduct.unitsDeatilsAdded) {
            this.availableProductUnit = this.selectedProduct.unitsDetails.map(function (prod) {
              return prod.unit;
            });
          } else {
            this.availableProductUnit = this.units;
          }
        }
      },

      deep: true
    },
    "item.rate": {
      handler: function handler(newVal, oldVal) {
        this.calculatePrices();
      },

      deep: true
    },
    "item.tradeDiscount": {
      handler: function handler(newVal, oldVal) {
        this.calculatePrices();
      },

      deep: true
    },
    "item.quantity": {
      handler: function handler(newVal, oldVal) {
        this.calculatePrices();
      },

      deep: true
    },
    "item.unit": {
      handler: function handler(newVal, oldVal) {
        this.unitChange(newVal);
      },

      deep: true
    },
    "currentProduct.GST_type": {
      handler: function handler(newVal, oldVal) {
        if (newVal != "TAXABLE") {
          this.currentProduct.taxableGST_rate = 0;
        }
      },

      deep: true
    },
    "currentProduct.basicPrice": {
      handler: function handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.calculateOpeningBalance();
        }
      },

      deep: true
    },
    "currentProduct.gstValue": {
      handler: function handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.calculateOpeningBalance();
        }
      },

      deep: true
    }
  },
  created: function created() {
    this.$bindAsArray("rate", this.$root.$firebaseRefs.rate.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand));
    // this.$bindAsObject(
    //   'buyerById',
    //   this.$root.$firebaseRefs.buyer
    // );
    this.$bindAsArray("batch", this.$root.$firebaseRefs.batchTransaction.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("godawns", this.$root.$firebaseRefs.godawn.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("productDrawers", this.$root.$firebaseRefs.productDrawer.orderByChild("brand").equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear"]), mapGlobalGetters({ units: "productUnit" }), {
    currentProdDrawers: function currentProdDrawers() {
      var _this2 = this;

      if (this.selectedProduct) {
        return this.productDrawers.filter(function (item) {
          return !!item.items.find(function (i) {
            return i.product == _this2.selectedProduct['.key'];
          });
        }).map(function (i) {
          return { text: i.name, value: i['.key'] };
        });
      }
      return [];
    },
    productsByBrand: function productsByBrand() {
      var _this3 = this;

      if (this.rate) {
        return this.products.filter(function (item) {
          return item["brand"] === _this3.selectedBrand && (!_this3.gstInvoice ? item.GST_type != 'TAXABLE' : true) && (!!item.firm && _this3.selectedFirm ? item.firm == _this3.selectedFirm : false) && (item.isActive == undefined ? true : item.isActive);
        }
        // && (item.openingDate ? (item.openingDate >= this.finYear.start) && (item.openingDate <= this.finYear.end) : true))
        );
      }
    },
    offerList: function offerList() {
      var offerItems = [];
      var date = new Date(this.invoiceDate).getTime();
      if (this.selectedProduct && this.selectedProduct.offers) {
        offerItems = this.selectedProduct.offers.filter(function (item) {
          return item.startDate <= date && item.endDate >= date;
        });
      }
      return offerItems;
    },
    godawnByBrand: function godawnByBrand() {
      var _this4 = this;

      return this.godawns.filter(function (item) {
        return item["brand"] === _this4.selectedBrand;
      }).map(function (item) {
        return {
          text: item["godawnName"],
          value: item[".key"]
        };
      });
    },
    getHeaders: function getHeaders() {
      if (this.gstInvoice) {
        return [{ text: "Name", sortable: false, value: "productName", class: "font-weight-bold primary--text" },
        // { text: "Taxable Rate", sortable: false, value: "rate", class: "font-weight-bold primary--text" },
        { text: "Unit", sortable: false, value: "unit", class: "font-weight-bold primary--text" }, { text: "Rate", sortable: false, value: "rate", class: "font-weight-bold primary--text" }, { text: "Quantity", sortable: false, value: "quantity", class: "font-weight-bold primary--text" }, { text: "Basic Price", sortable: false, value: "basicPrice", class: "font-weight-bold primary--text" }, { text: "GST value", sortable: false, value: "GSTValue", class: "font-weight-bold primary--text" }, { text: "Trade Discount", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" }, { text: "Total Price", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" },
        // { text: "CGST ", sortable: false, value: "CGST", class: "font-weight-bold primary--text" },
        // { text: "SGST ", sortable: false, value: "SGST", class: "font-weight-bold primary--text" },
        // { text: "IGST ", sortable: false, value: "IGST", class: "font-weight-bold primary--text" },
        { text: "Action ", sortable: false, value: "action", class: "font-weight-bold primary--text" }, { text: "", value: "name", sortable: false }];
      } else {
        return [{ text: "Name", sortable: false, value: "productName", class: "font-weight-bold primary--text" }, { text: "Rate", sortable: false, value: "rate", class: "font-weight-bold primary--text" }, { text: "Unit", sortable: false, value: "unit", class: "font-weight-bold primary--text" }, { text: "Quantity", sortable: false, value: "quantity", class: "font-weight-bold primary--text" }, { text: "Basic Price", sortable: false, value: "basicPrice", class: "font-weight-bold primary--text" }, { text: "Trade Discount", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" }, { text: "Total Price", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" }, { text: "Action ", sortable: false, value: "action", class: "font-weight-bold primary--text" }, { text: "", value: "name", sortable: false }];
      }
    },
    formTitle: function formTitle() {
      return this.editedIndex === -1 ? "Edit Medicine" : "New Medicine";
    }
  }),

  methods: {
    openProductReport: function openProductReport() {
      this.productReportDialog = true;
    },
    close: function close() {
      this.$emit("closeAddItem", false);
      this.reset();
    },
    editItem: function editItem(item) {
      this.reset();
      this.$emit("editItem", item, true);
    },
    deleteItem: function deleteItem(item) {
      this.reset();
      this.$emit("deleteItem", item);
    },
    productChange: function productChange(val) {
      this.selectedProduct = val;
      this.item.productId = val[".key"];
      this.item.HSN_code = val["HSN_code"];
      this.item.taxableGST_rate = val["taxableGST_rate"];
      this.item.unit = val["unit"];
      // if(this.selectedProduct.unit == this.item.unit) {
      //   this.item.rate = this.isBuyer ? val["sellingPrice"] : val["purchasingPrice"]
      // }
      // if(isBuyer) {
      //   this.getProductBatch();
      // }
      this.getProductBatch();
      // this.productChanged = true; 
      if (this.selectedProduct.unitsDeatilsAdded) {
        this.availableProductUnit = this.selectedProduct.unitsDetails.map(function (prod) {
          return prod.unit;
        });
      } else {
        if (this.selectedProduct.unit == this.item.unit) {
          this.item.rate = this.isBuyer ? val["sellingPrice"] : val["purchasingPrice"];
        }
        if (this.isBuyer && this.buyer.category && this.selectedProduct.sellingPriceByCategories && this.selectedProduct.sellingPriceByCategories[this.buyer.category]) {
          this.item.rate = this.selectedProduct.sellingPriceByCategories[this.buyer.category];
        }
        this.availableProductUnit = this.units;
      }
      this.productChanged = true;
    },
    unitChange: function unitChange(selectedUnit) {
      var _this5 = this;

      if (this.selectedProduct.unitsDeatilsAdded) {
        this.selectedProduct.unitsDetails.map(function (prod) {
          if (prod['unit'] == selectedUnit) {
            var rate = _this5.isBuyer ? prod["sellingPrice"] : prod["purchasingPrice"];
            if (rate) {
              _this5.item.rate = rate;
            }
          }
        });
      }
    },
    calculateTradeDiscount: function calculateTradeDiscount() {
      this.item.tradeDiscount = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.tradeDiscountPercentage * this.item.rate * this.item.quantity / 100).toFixed(2);
    },
    calculatePrices: function calculatePrices() {
      // if(this.isBuyer == null) {
      //     let buyer = this.buyerById[this.buyerId];
      //     this.isBuyer = buyer  ? true : false;
      // }

      if (this.firmSetting && this.firmSetting.isRoundOff) {
        var basicPrice = (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.rate * this.item.quantity) - __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.tradeDiscount)).toFixed(2);
        this.item.basicPrice = Math.round(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(basicPrice));
        var GSTValue = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.basicPrice * (parseFloat(this.item.taxableGST_rate) / 100)).toFixed(2);
        this.item.GSTValue = Math.round(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(GSTValue));
        var totlePrice = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.basicPrice) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.GSTValue)).toFixed(2);
        this.item.totlePrice = Math.round(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(totlePrice));
      } else {
        this.item.basicPrice = (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.rate * this.item.quantity) - __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.tradeDiscount)).toFixed(2);
        this.item.GSTValue = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.basicPrice * (parseFloat(this.item.taxableGST_rate) / 100)).toFixed(2);
        this.item.totlePrice = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.basicPrice) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.GSTValue)).toFixed(2);
      }
    },
    getProductBatch: function getProductBatch() {
      var _this6 = this;

      var batchArray = this.batch.filter(function (item) {
        return item['brand'] === _this6.selectedBrand && item['product'] === _this6.selectedProduct['.key'];
      });
      batchArray.sort(function (a, b) {
        return -(new Date(b.expiryDate) - new Date(a.expiryDate));
      });
      if (batchArray.length) {
        this.item.batchNumber = batchArray[0].batchNumber;
        // this.item.expiryDate = new Date(batchArray[0].expiryDate).toISOString().substr(0, 10);
        // this.item.manufacturingDate = new Date(batchArray[0].manufacturingDate).toISOString().substr(0, 10);
        this.item.expiryDate = batchArray[0].expiryDate ? new Date(batchArray[0].expiryDate).toISOString().substr(0, 10) : new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().substr(0, 10);
        this.item.manufacturingDate = batchArray[0].manufacturingDate ? new Date(batchArray[0].manufacturingDate).toISOString().substr(0, 10) : new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toISOString().substr(0, 10);
      } else {
        batchArray.push({
          batchNumber: 'DEFAULT',
          expiryDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)).getTime(),
          manufacturingDate: new Date(new Date().setFullYear(new Date().getFullYear() - 1)).getTime()
        });
        this.item.expiryDate = new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().substr(0, 10);
        this.item.manufacturingDate = new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toISOString().substr(0, 10);
        this.item.batchNumber = 'DEFAULT';
      }
      if (this.isBuyer && this.selectedProduct.composition && this.isComposition) {
        this.getSimilarCompostionProducts(batchArray[0].expiryDate);
      }
      this.isComposition = !this.isComposition;
      this.productBatches = batchArray;
    },
    getSimilarCompostionProducts: function getSimilarCompostionProducts() {
      var _this7 = this;

      this.productsWithSimilarCompostion = this.products.filter(function (item) {
        return item['brand'] === _this7.selectedBrand && _.isEqual(item['composition'], _this7.selectedProduct['composition']);
      });
      if (this.productsWithSimilarCompostion.length && this.productsWithSimilarCompostion.length > 1) {
        this.selectedCompositionProd = null;
        this.compositionDialog = true;
      }
    },
    addFromCompositionProduct: function addFromCompositionProduct() {
      this.productChange(this.selectedCompositionProd);
      this.item.productName = this.selectedCompositionProd.name;
      this.compositionDialog = false;
    },
    cancelComposition: function cancelComposition() {
      this.compositionDialog = false;
      this.isComposition = !this.isComposition;
    },
    changeBatch: function changeBatch() {
      var _this8 = this;

      var batch = this.productBatches.filter(function (item) {
        return item['batchNumber'] == _this8.item['batchNumber'];
      })[0];
      this.item.expiryDate = batch.expiryDate ? new Date(batch.expiryDate).toISOString().substr(0, 10) : new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().substr(0, 10);
      this.item.manufacturingDate = batch.manufacturingDate ? new Date(batch.manufacturingDate).toISOString().substr(0, 10) : new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toISOString().substr(0, 10);
    },

    // resetDate(){
    //   this.item.expiryDate = new Date().toISOString().substr(0, 10);
    //   this.item.manufacturingDate = new Date().toISOString().substr(0, 10);
    // },
    save: function save(saveAndAdd) {
      var _this9 = this;

      var minQ = 0;
      if (this.offerList.length) {
        this.offerList.map(function (item) {
          if (item.minQuantity <= _this9.item.quantity && minQ < item.offerQuantity) {
            minQ = item.offerQuantity;
          }
        });
      }
      if (this.item.quantity > this.selectedProduct.quantity && this.isBuyer) {
        if (this.firmSetting && this.firmSetting.hideNegetiveStockAlert || confirm("stock can go in negative - do you want to proceed ?")) {
          if (!this.isEditItems || this.isEditItems && this.productChanged) {
            this.item.productName = this.selectedProduct.name;
            this.item.GST_type = this.selectedProduct.GST_type;
            this.item.productUnit = this.selectedProduct.unit;
            this.item.availableQuantity = this.selectedProduct.quantity;
          }
          if (minQ) {
            var clonedItem = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.item);
            clonedItem.quantity = minQ;
            clonedItem.basicPrice = 0;
            clonedItem.rate = 0;
            clonedItem.GSTValue = 0;
            clonedItem.totlePrice = 0;
            this.$emit('saveAddItem', clonedItem, false);
          }
          this.$emit('saveAddItem', this.item, saveAndAdd);
          this.reset();
        }
      } else {
        if (!this.isEditItems || this.isEditItems && this.productChanged) {
          this.item.productName = this.selectedProduct.name;
          this.item.GST_type = this.selectedProduct.GST_type;
          this.item.productUnit = this.selectedProduct.unit;
          this.item.availableQuantity = this.selectedProduct.quantity;
        }
        if (minQ) {
          var _clonedItem = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.item);
          _clonedItem.quantity = minQ;
          _clonedItem.basicPrice = 0;
          _clonedItem.rate = 0;
          _clonedItem.GSTValue = 0;
          _clonedItem.totlePrice = 0;
          this.$emit('saveAddItem', _clonedItem, false);
        }
        this.$emit('saveAddItem', this.item, saveAndAdd);
        this.reset();
      }
    },
    reset: function reset() {
      this.item = {
        productName: "",
        productId: "",
        HSN_code: "",
        taxableGST_rate: 0,
        rate: 0,
        unit: "",
        quantity: 0,
        basicPrice: 0,
        GSTValue: 0,
        GST_type: "",
        productUnit: '',
        totlePrice: 0,
        tradeDiscount: 0,
        drawer: '',
        drawerId: null
      };
      this.tradeDiscountPercentage = null;
      this.isTradePercentage = false;
    },
    calculateOpeningBalance: function calculateOpeningBalance() {
      this.currentProduct.openingBalance = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.currentProduct.basicPrice) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.currentProduct.gstValue);
    },
    scanItem: function scanItem() {
      this.scannerDialog = true;
      this.initQugga();
    },
    initQugga: function initQugga() {
      var selfVue = this;
      $(function () {
        var resultCollector = Quagga.ResultCollector.create({
          capture: true,
          capacity: 20,
          blacklist: [{
            code: "WIWV8ETQZ1", format: "code_93"
          }, {
            code: "EH3C-%GU23RK3", format: "code_93"
          }, {
            code: "O308SIHQOXN5SA/PJ", format: "code_93"
          }, {
            code: "DG7Q$TV8JQ/EN", format: "code_93"
          }, {
            code: "VOFD1DB5A.1F6QU", format: "code_93"
          }, {
            code: "4SO64P4X8 U4YUU1T-", format: "code_93"
          }],
          filter: function filter(codeResult) {
            // only store results which match this constraint
            // e.g.: codeResult
            return true;
          }
        });
        var App = {
          init: function init() {
            var self = this;

            Quagga.init(this.state, function (err) {
              if (err) {
                return self.handleError(err);
              }
              //Quagga.registerResultCollector(resultCollector);
              App.attachListeners();
              App.checkCapabilities();
              Quagga.start();
            });
          },
          handleError: function handleError(err) {
            console.log(err);
          },
          checkCapabilities: function checkCapabilities() {
            var track = Quagga.CameraAccess.getActiveTrack();
            var capabilities = {};
            if (typeof track.getCapabilities === 'function') {
              capabilities = track.getCapabilities();
            }
            this.applySettingsVisibility('zoom', capabilities.zoom);
            this.applySettingsVisibility('torch', capabilities.torch);
          },
          updateOptionsForMediaRange: function updateOptionsForMediaRange(node, range) {
            console.log('updateOptionsForMediaRange', node, range);
            var NUM_STEPS = 6;
            var stepSize = (range.max - range.min) / NUM_STEPS;
            var option;
            var value;
            while (node.firstChild) {
              node.removeChild(node.firstChild);
            }
            for (var i = 0; i <= NUM_STEPS; i++) {
              value = range.min + stepSize * i;
              option = document.createElement('option');
              option.value = value;
              option.innerHTML = value;
              node.appendChild(option);
            }
          },
          applySettingsVisibility: function applySettingsVisibility(setting, capability) {
            // depending on type of capability
            if (typeof capability === 'boolean') {
              var node = document.querySelector('input[name="settings_' + setting + '"]');
              if (node) {
                node.parentNode.style.display = capability ? 'block' : 'none';
              }
              return;
            }
            if (window.MediaSettingsRange && capability instanceof window.MediaSettingsRange) {
              var node = document.querySelector('select[name="settings_' + setting + '"]');
              if (node) {
                this.updateOptionsForMediaRange(node, capability);
                node.parentNode.style.display = 'block';
              }
              return;
            }
          },
          initCameraSelection: function initCameraSelection() {
            var streamLabel = Quagga.CameraAccess.getActiveStreamLabel();

            return Quagga.CameraAccess.enumerateVideoDevices().then(function (devices) {
              function pruneText(text) {
                return text.length > 30 ? text.substr(0, 30) : text;
              }
              var $deviceSelection = document.getElementById("deviceSelection");
              while ($deviceSelection.firstChild) {
                $deviceSelection.removeChild($deviceSelection.firstChild);
              }
              devices.forEach(function (device) {
                var $option = document.createElement("option");
                $option.value = device.deviceId || device.id;
                $option.appendChild(document.createTextNode(pruneText(device.label || device.deviceId || device.id)));
                $option.selected = streamLabel === device.label;
                $deviceSelection.appendChild($option);
              });
            });
          },
          attachListeners: function attachListeners() {
            var self = this;

            self.initCameraSelection();
            $(".controls").on("click", "button.stop", function (e) {
              e.preventDefault();
              Quagga.stop();
              self._printCollectedResults();
            });

            $(".controls .reader-config-group").on("change", "input, select", function (e) {
              e.preventDefault();
              var $target = $(e.target),
                  value = $target.attr("type") === "checkbox" ? $target.prop("checked") : $target.val(),
                  name = $target.attr("name"),
                  state = self._convertNameToState(name);

              console.log("Value of " + state + " changed to " + value);
              self.setState(state, value);
            });
          },
          _printCollectedResults: function _printCollectedResults() {
            var results = resultCollector.getResults(),
                $ul = $("#result_strip ul.collector");

            results.forEach(function (result) {
              var $li = $('<li><div class="thumbnail"><div class="imgWrapper"><img /></div><div class="caption"><h4 class="code"></h4></div></div></li>');

              $li.find("img").attr("src", result.frame);
              $li.find("h4.code").html(result.codeResult.code + " (" + result.codeResult.format + ")");
              $ul.prepend($li);
            });
          },
          _accessByPath: function _accessByPath(obj, path, val) {
            var parts = path.split('.'),
                depth = parts.length,
                setter = typeof val !== "undefined" ? true : false;

            return parts.reduce(function (o, key, i) {
              if (setter && i + 1 === depth) {
                if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(o[key]) === "object" && (typeof val === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(val)) === "object") {
                  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(o[key], val);
                } else {
                  o[key] = val;
                }
              }
              return key in o ? o[key] : {};
            }, obj);
          },
          _convertNameToState: function _convertNameToState(name) {
            return name.replace("_", ".").split("-").reduce(function (result, value) {
              return result + value.charAt(0).toUpperCase() + value.substring(1);
            });
          },
          detachListeners: function detachListeners() {
            $(".controls").off("click", "button.stop");
            $(".controls .reader-config-group").off("change", "input, select");
          },
          applySetting: function applySetting(setting, value) {
            var track = Quagga.CameraAccess.getActiveTrack();
            if (track && typeof track.getCapabilities === 'function') {
              switch (setting) {
                case 'zoom':
                  return track.applyConstraints({ advanced: [{ zoom: parseFloat(value) }] });
                case 'torch':
                  return track.applyConstraints({ advanced: [{ torch: !!value }] });
              }
            }
          },
          setState: function setState(path, value) {
            var self = this;

            if (typeof self._accessByPath(self.inputMapper, path) === "function") {
              value = self._accessByPath(self.inputMapper, path)(value);
            }

            if (path.startsWith('settings.')) {
              var setting = path.substring(9);
              return self.applySetting(setting, value);
            }
            self._accessByPath(self.state, path, value);

            console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.state));
            App.detachListeners();
            Quagga.stop();
            App.init();
          },
          inputMapper: {
            inputStream: {
              constraints: function constraints(value) {
                if (/^(\d+)x(\d+)$/.test(value)) {
                  var values = value.split('x');
                  return {
                    width: { min: parseInt(values[0]) },
                    height: { min: parseInt(values[1]) }
                  };
                }
                return {
                  deviceId: value
                };
              }
            },
            numOfWorkers: function numOfWorkers(value) {
              return parseInt(value);
            },
            decoder: {
              readers: function readers(value) {
                if (value === 'ean_extended') {
                  return [{
                    format: "ean_reader",
                    config: {
                      supplements: ['ean_5_reader', 'ean_2_reader']
                    }
                  }];
                }
                return [{
                  format: value + "_reader",
                  config: {}
                }];
              }
            }
          },
          state: {
            inputStream: {
              type: "LiveStream",
              constraints: {
                width: { min: 640 },
                height: { min: 480 },
                facingMode: "environment",
                aspectRatio: { min: 1, max: 2 }
              }
            },
            locator: {
              patchSize: "medium",
              halfSample: true
            },
            numOfWorkers: 2,
            frequency: 10,
            decoder: {
              readers: [{
                format: "ean_reader",
                config: {}
              }]
            },
            locate: true
          },
          lastResult: null
        };

        App.init();

        Quagga.onProcessed(function (result) {
          var drawingCtx = Quagga.canvas.ctx.overlay,
              drawingCanvas = Quagga.canvas.dom.overlay;

          if (result) {
            if (result.boxes) {
              drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute("width")), parseInt(drawingCanvas.getAttribute("height")));
              result.boxes.filter(function (box) {
                return box !== result.box;
              }).forEach(function (box) {
                Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, { color: "green", lineWidth: 2 });
              });
            }

            if (result.box) {
              Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, { color: "#00F", lineWidth: 2 });
            }

            if (result.codeResult && result.codeResult.code) {
              Quagga.ImageDebug.drawPath(result.line, { x: 'x', y: 'y' }, drawingCtx, { color: 'red', lineWidth: 3 });
            }
          }
        });

        Quagga.onDetected(function (result) {
          var code = result.codeResult.code;
          console.log(code);
          Quagga.stop();
          selfVue.addProductByBarcode(code);
          // if (App.lastResult !== code) {
          //     App.lastResult = code;
          //     var $node = null, canvas = Quagga.canvas.dom.image;

          //     $node = $('<li><div class="thumbnail"><div class="imgWrapper"><img /></div><div class="caption"><h4 class="code"></h4></div></div></li>');
          //     $node.find("img").attr("src", canvas.toDataURL());
          //     $node.find("h4.code").html(code);
          //     $("#result_strip ul.thumbnails").prepend($node);
          // }
        });
      });
    },
    addProductByBarcode: function addProductByBarcode(barcode) {
      var _this10 = this;

      var product = this.productsByBrand.filter(function (item) {
        return item.barcode == barcode;
      })[0];
      var productName = this.productsByBrand.filter(function (item) {
        return item.name == barcode;
      })[0];
      if (product) {
        clearInterval(this.timeoutSearch);
        this.productChange(product);
        this.item.quantity = 1;
        this.item.productName = product.name;
        this.scannerDialog = false;
        this.search = "";
        this.save(true);
      } else if (productName) {
        clearInterval(this.timeoutSearch);
      } else {
        this.timeoutSearch = setTimeout(function () {
          _this10.search = "";
        }, 2000);
      }
    }
  }
});

/***/ }),
/* 485 */,
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    product: Object,
    isBuyer: Boolean,
    buyerId: String
  },
  data: function data() {
    return {
      headers: [{ text: "Date", value: "date", sortable: true }, { text: "Rate", value: "rate", sortable: false }, { text: "Quantity", value: "quantity", sortable: false }, { text: "Fat", value: "fat", sortable: false }, { text: "Basic Price", value: "basicPrice", sortable: false }, { text: "GST", value: "gst", sortable: false }, { text: "Total", value: "closingQuantity", sortable: false }],
      datepickerMenu1: false,
      datepickerMenu2: false,
      startDate: null,
      endDate: null,
      // isBuyer: false,
      selectedProduct: null,
      selectedBuyer: null
    };
  },
  created: function created() {
    var _this = this;

    this.$bindAsArray("invoiceHistory", this.$root.$firebaseRefs.invoiceHistory.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("buyers", this.$root.$firebaseRefs.buyer.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("sellers", this.$root.$firebaseRefs.seller.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild("brand").equalTo(this.selectedBrand)), this.startDate = new Date(this.finYear.start).toISOString().substr(0, 10);
    this.endDate = new Date(this.finYear.end).toISOString().substr(0, 10);
    if (this.product && this.product['.key']) {
      this.selectedProduct = this.product;
    }
    if (this.buyerId) {
      if (this.isBuyer) {
        this.selectedBuyer = this.buyersByBrand.find(function (i) {
          return i['.key'] == _this.buyerId;
        });
      } else {
        this.selectedBuyer = this.sellersByBrand.find(function (i) {
          return i['.key'] == _this.buyerId;
        });
      }
    }
  },

  watch: {
    "product": {
      handler: function handler(newVal) {
        if (this.product && this.product['.key']) {
          this.selectedProduct = this.product;
        }
      },

      deep: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear"]), {
    // headers () {
    //   return this.headers.filter(x=>x.show)
    // },
    buyersByBrand: function buyersByBrand() {
      var _this2 = this;

      return this.buyers.filter(function (item) {
        return item["brand"] === _this2.selectedBrand;
      });
    },
    sellersByBrand: function sellersByBrand() {
      var _this3 = this;

      return this.sellers.filter(function (item) {
        return item["brand"] === _this3.selectedBrand;
      });
    },
    firmsByBrand: function firmsByBrand() {
      var _this4 = this;

      return this.firms.filter(function (item) {
        return item["brand"] === _this4.selectedBrand;
      }).map(function (item) {
        if (item.defaultFirm) {
          _this4.selectedFirm = item[".key"];
        }
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
    },
    isDairyBusiness: function isDairyBusiness() {
      var _this5 = this;

      if (this.selectedFirm) {
        var firm = this.firms.find(function (item) {
          return item[".key"] == _this5.selectedFirm;
        });
        if (firm.businessType == "Dairy") {
          return true;
        }
      }
      return false;
    },
    productsByBrand: function productsByBrand() {
      var _this6 = this;

      return this.products.filter(function (item) {
        return item["brand"] === _this6.selectedBrand && item["firm"] === _this6.selectedFirm;
      });
    },
    productList: function productList() {
      var _this7 = this;

      var products = [];
      if (this.selectedProduct) {
        var fromDate = this.startDate ? new Date(this.startDate).getTime() : null;
        var toDate = this.endDate ? new Date(this.endDate).getTime() : null;
        var invoiceHistory = this.invoiceHistory.filter(function (item) {
          return item["brand"] === _this7.selectedBrand && item.deleted != true && (_this7.selectedBuyer ? item.buyerId == _this7.selectedBuyer[".key"] : true) && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true) && (item["isLatest"] != undefined ? item["isLatest"] == true : true);
        });
        invoiceHistory.map(function (item, index) {
          if (item.newlyCreated && (item.status === "paid" || item.status === "partial")) {
            var newItem = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item));
            newItem.date = newItem.date - 1;
            newItem.transactionType = "Debit";
            newItem.paidAmount = 0;
            newItem.status = "due";
            newItem.remainingAmount = newItem.totalAmount;
            delete newItem["newlyCreated"];
            invoiceHistory.push(newItem);
          }
          if (_this7.isBuyer == item.isBuyer) {
            item.items && item.items.length && item.items.map(function (prod) {
              if (prod["productId"] == _this7.selectedProduct[".key"]) {
                products.push({
                  price: prod.basicPrice,
                  quantity: prod.quantity,
                  fat: prod.fat,
                  rate: prod.rate,
                  date: item.date,
                  totlePrice: prod.totlePrice,
                  gst: prod.GSTValue || 0,
                  isBuyer: item.isBuyer
                });
              }
            });
          }
        });
      }
      return products;
    }
  })
});

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddItemDefault_vue__ = __webpack_require__(488);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7afd7ff2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddItemDefault_vue__ = __webpack_require__(1487);
function injectStyle (ssrContext) {
  __webpack_require__(1486)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddItemDefault_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7afd7ff2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddItemDefault_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_body_parser__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_body_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_body_parser__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isBuyer: Boolean,
    firmSetting: Object,
    buyer: Object,
    selectedFirm: String,
    isEditItems: Boolean,
    gstInvoice: Boolean,
    allItems: Array,
    invoiceDate: String,
    editedItem: {
      type: Object,
      default: function _default() {
        return {
          productName: "",
          productId: "",
          HSN_code: "",
          taxableGST_rate: 0,
          rate: 0,
          unit: "",
          quantity: 0,
          basicPrice: 0,
          GSTValue: 0,
          totlePrice: 0,
          GST_type: "",
          productUnit: '',
          tradeDiscount: 0,
          brokerageRate: 0,
          drawerId: null
        };
      }
    },
    godawn: String
  },
  data: function data() {
    return {
      // isBuyer : null,
      productReportDialog: false,
      search: null,
      timeoutSearch: null,
      isTradePercentage: false,
      scannerDialog: false,
      //individualProdBrokerage : Boolean,
      tradeDiscountPercentage: null,
      item: this.editedItem,
      products: [],
      availableProductUnit: this.units,
      selectedProduct: {},
      stepper: 1,
      isOpeningBalance: false,
      isStanderedPrice: false,
      addProductDialog: false,
      datepicker: false,
      snackbar: false,
      productChanged: false,
      duplicateError: null,
      timeout: 3000,
      GST_types: [{
        text: "Exempt",
        value: "EXEMPT"
      }, {
        text: "Nil Rated",
        value: "NILL"
      }, {
        text: "Taxable",
        value: "TAXABLE"
      }, {
        text: "Non-GST",
        value: "OTHER"
      }],
      currentProduct: {
        name: "",
        description: "",
        HSN_code: 0,
        GST_type: "",
        taxableGST_rate: 0,
        unit: "",
        quantity: 0,
        brand: "",
        openingDate: new Date().toISOString().substr(0, 10),
        purchasingPrice: null,
        sellingPrice: null,
        openingBalance: null,
        gstValue: 0,
        basicPrice: 0
      }
    };
  },

  components: {
    ProductReports: function ProductReports() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 62));
    }
  },
  watch: {
    "godawn": {
      handler: function handler(newVal, oldVal) {
        if (!this.item.godawnBy) {
          this.item.godawnBy = newVal;
        }
      },

      deep: true
    },
    editedItem: function editedItem(val) {
      var _this = this;

      this.item = this.editedItem;
      if (this.editedItem.productId) {
        this.selectedProduct = this.products.filter(function (item) {
          return item['.key'] == _this.editedItem.productId;
        })[0];
        this.availableProductUnit = this.units;
      }
    },
    search: function search(val) {
      if (val.length > 9) {
        this.addProductByBarcode(val);
      }
    },

    "item.rate": {
      handler: function handler(newVal, oldVal) {
        this.calculatePrices();
      },

      deep: true
    },
    "item.tradeDiscount": {
      handler: function handler(newVal, oldVal) {
        this.calculatePrices();
      },

      deep: true
    },
    "item.quantity": {
      handler: function handler(newVal, oldVal) {
        this.calculatePrices();
      },

      deep: true
    },
    "item.unit": {
      handler: function handler(newVal, oldVal) {
        // this.productChange(this.selectedProduct);
        this.unitChange(newVal);
      },

      deep: true
    },
    "currentProduct.GST_type": {
      handler: function handler(newVal, oldVal) {
        if (newVal != "TAXABLE") {
          this.currentProduct.taxableGST_rate = 0;
        }
      },

      deep: true
    },
    "currentProduct.basicPrice": {
      handler: function handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.calculateOpeningBalance();
        }
      },

      deep: true
    },
    "currentProduct.gstValue": {
      handler: function handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.calculateOpeningBalance();
        }
      },

      deep: true
    }
  },
  created: function created() {
    this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand));
    // this.$bindAsObject('buyerById', this.$root.$firebaseRefs.buyer);
    this.$bindAsArray("productDrawers", this.$root.$firebaseRefs.productDrawer.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("godawns", this.$root.$firebaseRefs.godawn.orderByChild('brand').equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear"]), mapGlobalGetters({ units: "productUnit" }), {
    currentProdDrawers: function currentProdDrawers() {
      var _this2 = this;

      if (this.selectedProduct) {
        return this.productDrawers.filter(function (item) {
          return !!item.items.find(function (i) {
            return i.product == _this2.selectedProduct['.key'];
          });
        }).map(function (i) {
          return { text: i.name, value: i['.key'] };
        });
      }
      return [];
    },
    productsByBrand: function productsByBrand() {
      var _this3 = this;

      return this.products.filter(function (item) {
        return item["brand"] === _this3.selectedBrand && (!_this3.gstInvoice ? item.GST_type != 'TAXABLE' : true) && (!!item.firm && _this3.selectedFirm ? item.firm == _this3.selectedFirm : false) && (item.isActive == undefined ? true : item.isActive);
      }
      // && (item.openingDate ? (item.openingDate >= this.finYear.start) && (item.openingDate <= this.finYear.end) : true))
      );
    },
    offerList: function offerList() {
      var offerItems = [];
      var date = new Date(this.invoiceDate).getTime();
      if (this.selectedProduct && this.selectedProduct.offers) {
        offerItems = this.selectedProduct.offers.filter(function (item) {
          return item.startDate <= date && item.endDate >= date;
        });
      }
      return offerItems;
    },
    godawnByBrand: function godawnByBrand() {
      var _this4 = this;

      return this.godawns.filter(function (item) {
        return item["brand"] === _this4.selectedBrand;
      }).map(function (item) {
        return {
          text: item["godawnName"],
          value: item[".key"]
        };
      });
    },
    getHeaders: function getHeaders() {
      if (this.gstInvoice) {
        return [{ text: "Name", sortable: false, value: "productName", class: "font-weight-bold primary--text" },
        // { text: "Taxable Rate", sortable: false, value: "rate", class: "font-weight-bold primary--text" },
        { text: "Unit", sortable: false, value: "unit", class: "font-weight-bold primary--text" }, { text: "Rate", sortable: false, value: "rate", class: "font-weight-bold primary--text" }, { text: "Quantity", sortable: false, value: "quantity", class: "font-weight-bold primary--text" }, { text: "Basic Price", sortable: false, value: "basicPrice", class: "font-weight-bold primary--text" }, { text: "GST value", sortable: false, value: "GSTValue", class: "font-weight-bold primary--text" }, { text: "Trade Discount", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" }, { text: "Total Price", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" },
        // { text: "CGST ", sortable: false, value: "CGST", class: "font-weight-bold primary--text" },
        // { text: "SGST ", sortable: false, value: "SGST", class: "font-weight-bold primary--text" },
        // { text: "IGST ", sortable: false, value: "IGST", class: "font-weight-bold primary--text" },
        { text: "Action ", sortable: false, value: "action", class: "font-weight-bold primary--text" }, { text: "", value: "name", sortable: false }];
      } else {
        return [{ text: "Name", sortable: false, value: "productName", class: "font-weight-bold primary--text" }, { text: "Unit", sortable: false, value: "unit", class: "font-weight-bold primary--text" }, { text: "Quantity", sortable: false, value: "quantity", class: "font-weight-bold primary--text" }, { text: "Rate", sortable: false, value: "rate", class: "font-weight-bold primary--text" }, { text: "Basic Price", sortable: false, value: "basicPrice", class: "font-weight-bold primary--text" }, { text: "Trade Discount", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" }, { text: "Total Price", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" }, { text: "Action ", sortable: false, value: "action", class: "font-weight-bold primary--text" }, { text: "", value: "name", sortable: false }];
      }
    },
    formTitle: function formTitle() {
      return this.editedIndex === -1 ? "Edit Item" : "New Item";
    }
  }),

  methods: {
    openProductReport: function openProductReport() {
      this.productReportDialog = true;
    },
    close: function close() {
      this.$emit("closeAddItem", false);
      this.reset();
    },
    editItem: function editItem(item) {
      this.reset();
      this.$emit("editItem", item, true);
    },
    deleteItem: function deleteItem(item) {
      this.reset();
      this.$emit("deleteItem", item);
    },
    productChange: function productChange(val) {
      this.selectedProduct = val;
      // let buyer = this.buyerById[this.buyerId];
      // let isBuyer = buyer  ? true : false;
      this.item.productId = val[".key"];
      this.item.HSN_code = val["HSN_code"];
      this.item.taxableGST_rate = val["taxableGST_rate"];
      this.item.unit = val["unit"];
      // if(this.selectedProduct.unit == this.item.unit) {
      //   this.item.rate = this.isBuyer ? val["sellingPrice"] : val["purchasingPrice"]
      // }
      this.productChanged = true;
      if (this.selectedProduct.unitsDeatilsAdded) {
        this.availableProductUnit = this.selectedProduct.unitsDetails.map(function (prod) {
          return prod.unit;
        });
      } else {
        if (this.selectedProduct.unit == this.item.unit) {
          this.item.rate = this.isBuyer ? val["sellingPrice"] : val["purchasingPrice"];
        }
        if (this.isBuyer && this.buyer.category && this.selectedProduct.sellingPriceByCategories && this.selectedProduct.sellingPriceByCategories[this.buyer.category]) {
          this.item.rate = this.selectedProduct.sellingPriceByCategories[this.buyer.category];
        }
        this.availableProductUnit = this.units;
      }
      this.productChanged = true;
    },
    unitChange: function unitChange(selectedUnit) {
      var _this5 = this;

      if (this.selectedProduct.unitsDeatilsAdded) {
        this.selectedProduct.unitsDetails.map(function (prod) {
          if (prod['unit'] == selectedUnit) {
            var rate = _this5.isBuyer ? prod["sellingPrice"] : prod["purchasingPrice"];
            if (rate) {
              _this5.item.rate = rate;
            }
          }
        });
      }
    },
    calculateTradeDiscount: function calculateTradeDiscount() {
      this.item.tradeDiscount = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.tradeDiscountPercentage * this.item.rate * this.item.quantity / 100).toFixed(2);
    },
    calculatePrices: function calculatePrices() {
      // if(this.isBuyer == null) {
      //     let buyer = this.buyerById[this.buyerId];
      //     this.isBuyer = buyer  ? true : false;
      // }

      if (this.firmSetting && this.firmSetting.isRoundOff) {
        var basicPrice = (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.rate * this.item.quantity) - __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.tradeDiscount)).toFixed(2);
        this.item.basicPrice = Math.round(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(basicPrice));
        var GSTValue = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.basicPrice * (parseFloat(this.item.taxableGST_rate) / 100)).toFixed(2);
        this.item.GSTValue = Math.round(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(GSTValue));
        var totlePrice = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.basicPrice) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.GSTValue)).toFixed(2);
        this.item.totlePrice = Math.round(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(totlePrice));
      } else {
        this.item.basicPrice = (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.rate * this.item.quantity) - __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.tradeDiscount)).toFixed(2);
        this.item.GSTValue = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.basicPrice * (parseFloat(this.item.taxableGST_rate) / 100)).toFixed(2);
        this.item.totlePrice = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.basicPrice) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.GSTValue)).toFixed(2);
      }
    },
    save: function save(saveAndAdd) {
      var _this6 = this;

      // let buyer = this.buyerById[this.buyerId];
      // let isBuyer = buyer  ? true : false;
      var minQ = 0;
      if (this.offerList.length) {
        this.offerList.map(function (item) {
          if (item.minQuantity <= _this6.item.quantity && minQ < item.offerQuantity) {
            minQ = item.offerQuantity;
          }
        });
      }
      if (this.item.quantity > this.selectedProduct.quantity && this.isBuyer) {
        if (this.firmSetting && this.firmSetting.hideNegetiveStockAlert || confirm("stock can go in negative - do you want to proceed ?")) {
          if (!this.isEditItems || this.isEditItems && this.productChanged) {
            this.item.productName = this.selectedProduct.name;
            this.item.GST_type = this.selectedProduct.GST_type;
            this.item.productUnit = this.selectedProduct.unit;
            this.item.availableQuantity = this.selectedProduct.quantity;
          }
          if (minQ) {
            var clonedItem = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.item);
            clonedItem.quantity = minQ;
            clonedItem.basicPrice = 0;
            clonedItem.rate = 0;
            clonedItem.GSTValue = 0;
            clonedItem.totlePrice = 0;
            this.$emit('saveAddItem', clonedItem, false);
          }
          this.$emit('saveAddItem', this.item, saveAndAdd);
          this.reset();
        }
      } else {
        if (!this.isEditItems || this.isEditItems && this.productChanged) {
          this.item.productName = this.selectedProduct.name;
          this.item.GST_type = this.selectedProduct.GST_type;
          this.item.productUnit = this.selectedProduct.unit;
          this.item.availableQuantity = this.selectedProduct.quantity;
        }
        if (minQ) {
          var _clonedItem = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.item);
          _clonedItem.quantity = minQ;
          _clonedItem.basicPrice = 0;
          _clonedItem.rate = 0;
          _clonedItem.GSTValue = 0;
          _clonedItem.totlePrice = 0;
          this.$emit('saveAddItem', _clonedItem, false);
        }
        this.$emit('saveAddItem', this.item, saveAndAdd);
        this.reset();
      }
    },
    reset: function reset() {
      this.item = {
        productName: "",
        productId: "",
        HSN_code: "",
        taxableGST_rate: 0,
        rate: 0,
        unit: "",
        quantity: 0,
        basicPrice: 0,
        GSTValue: 0,
        GST_type: "",
        productUnit: '',
        totlePrice: 0,
        tradeDiscount: 0,
        drawerId: null
      };
      this.tradeDiscountPercentage = null;
      this.isTradePercentage = false;
    },
    calculateOpeningBalance: function calculateOpeningBalance() {
      this.currentProduct.openingBalance = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.currentProduct.basicPrice) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.currentProduct.gstValue);
    },
    scanItem: function scanItem() {
      this.scannerDialog = true;
      this.initQugga();
    },
    initQugga: function initQugga() {
      var selfVue = this;
      $(function () {
        var resultCollector = Quagga.ResultCollector.create({
          capture: true,
          capacity: 20,
          blacklist: [{
            code: "WIWV8ETQZ1", format: "code_93"
          }, {
            code: "EH3C-%GU23RK3", format: "code_93"
          }, {
            code: "O308SIHQOXN5SA/PJ", format: "code_93"
          }, {
            code: "DG7Q$TV8JQ/EN", format: "code_93"
          }, {
            code: "VOFD1DB5A.1F6QU", format: "code_93"
          }, {
            code: "4SO64P4X8 U4YUU1T-", format: "code_93"
          }],
          filter: function filter(codeResult) {
            // only store results which match this constraint
            // e.g.: codeResult
            return true;
          }
        });
        var App = {
          init: function init() {
            var self = this;

            Quagga.init(this.state, function (err) {
              if (err) {
                return self.handleError(err);
              }
              //Quagga.registerResultCollector(resultCollector);
              App.attachListeners();
              App.checkCapabilities();
              Quagga.start();
            });
          },
          handleError: function handleError(err) {
            console.log(err);
          },
          checkCapabilities: function checkCapabilities() {
            var track = Quagga.CameraAccess.getActiveTrack();
            var capabilities = {};
            if (typeof track.getCapabilities === 'function') {
              capabilities = track.getCapabilities();
            }
            this.applySettingsVisibility('zoom', capabilities.zoom);
            this.applySettingsVisibility('torch', capabilities.torch);
          },
          updateOptionsForMediaRange: function updateOptionsForMediaRange(node, range) {
            console.log('updateOptionsForMediaRange', node, range);
            var NUM_STEPS = 6;
            var stepSize = (range.max - range.min) / NUM_STEPS;
            var option;
            var value;
            while (node.firstChild) {
              node.removeChild(node.firstChild);
            }
            for (var i = 0; i <= NUM_STEPS; i++) {
              value = range.min + stepSize * i;
              option = document.createElement('option');
              option.value = value;
              option.innerHTML = value;
              node.appendChild(option);
            }
          },
          applySettingsVisibility: function applySettingsVisibility(setting, capability) {
            // depending on type of capability
            if (typeof capability === 'boolean') {
              var node = document.querySelector('input[name="settings_' + setting + '"]');
              if (node) {
                node.parentNode.style.display = capability ? 'block' : 'none';
              }
              return;
            }
            if (window.MediaSettingsRange && capability instanceof window.MediaSettingsRange) {
              var node = document.querySelector('select[name="settings_' + setting + '"]');
              if (node) {
                this.updateOptionsForMediaRange(node, capability);
                node.parentNode.style.display = 'block';
              }
              return;
            }
          },
          initCameraSelection: function initCameraSelection() {
            var streamLabel = Quagga.CameraAccess.getActiveStreamLabel();

            return Quagga.CameraAccess.enumerateVideoDevices().then(function (devices) {
              function pruneText(text) {
                return text.length > 30 ? text.substr(0, 30) : text;
              }
              var $deviceSelection = document.getElementById("deviceSelection");
              while ($deviceSelection.firstChild) {
                $deviceSelection.removeChild($deviceSelection.firstChild);
              }
              devices.forEach(function (device) {
                var $option = document.createElement("option");
                $option.value = device.deviceId || device.id;
                $option.appendChild(document.createTextNode(pruneText(device.label || device.deviceId || device.id)));
                $option.selected = streamLabel === device.label;
                $deviceSelection.appendChild($option);
              });
            });
          },
          attachListeners: function attachListeners() {
            var self = this;

            self.initCameraSelection();
            $(".controls").on("click", "button.stop", function (e) {
              e.preventDefault();
              Quagga.stop();
              self._printCollectedResults();
            });

            $(".controls .reader-config-group").on("change", "input, select", function (e) {
              e.preventDefault();
              var $target = $(e.target),
                  value = $target.attr("type") === "checkbox" ? $target.prop("checked") : $target.val(),
                  name = $target.attr("name"),
                  state = self._convertNameToState(name);

              console.log("Value of " + state + " changed to " + value);
              self.setState(state, value);
            });
          },
          _printCollectedResults: function _printCollectedResults() {
            var results = resultCollector.getResults(),
                $ul = $("#result_strip ul.collector");

            results.forEach(function (result) {
              var $li = $('<li><div class="thumbnail"><div class="imgWrapper"><img /></div><div class="caption"><h4 class="code"></h4></div></div></li>');

              $li.find("img").attr("src", result.frame);
              $li.find("h4.code").html(result.codeResult.code + " (" + result.codeResult.format + ")");
              $ul.prepend($li);
            });
          },
          _accessByPath: function _accessByPath(obj, path, val) {
            var parts = path.split('.'),
                depth = parts.length,
                setter = typeof val !== "undefined" ? true : false;

            return parts.reduce(function (o, key, i) {
              if (setter && i + 1 === depth) {
                if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(o[key]) === "object" && (typeof val === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(val)) === "object") {
                  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(o[key], val);
                } else {
                  o[key] = val;
                }
              }
              return key in o ? o[key] : {};
            }, obj);
          },
          _convertNameToState: function _convertNameToState(name) {
            return name.replace("_", ".").split("-").reduce(function (result, value) {
              return result + value.charAt(0).toUpperCase() + value.substring(1);
            });
          },
          detachListeners: function detachListeners() {
            $(".controls").off("click", "button.stop");
            $(".controls .reader-config-group").off("change", "input, select");
          },
          applySetting: function applySetting(setting, value) {
            var track = Quagga.CameraAccess.getActiveTrack();
            if (track && typeof track.getCapabilities === 'function') {
              switch (setting) {
                case 'zoom':
                  return track.applyConstraints({ advanced: [{ zoom: parseFloat(value) }] });
                case 'torch':
                  return track.applyConstraints({ advanced: [{ torch: !!value }] });
              }
            }
          },
          setState: function setState(path, value) {
            var self = this;

            if (typeof self._accessByPath(self.inputMapper, path) === "function") {
              value = self._accessByPath(self.inputMapper, path)(value);
            }

            if (path.startsWith('settings.')) {
              var setting = path.substring(9);
              return self.applySetting(setting, value);
            }
            self._accessByPath(self.state, path, value);

            console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.state));
            App.detachListeners();
            Quagga.stop();
            App.init();
          },
          inputMapper: {
            inputStream: {
              constraints: function constraints(value) {
                if (/^(\d+)x(\d+)$/.test(value)) {
                  var values = value.split('x');
                  return {
                    width: { min: parseInt(values[0]) },
                    height: { min: parseInt(values[1]) }
                  };
                }
                return {
                  deviceId: value
                };
              }
            },
            numOfWorkers: function numOfWorkers(value) {
              return parseInt(value);
            },
            decoder: {
              readers: function readers(value) {
                if (value === 'ean_extended') {
                  return [{
                    format: "ean_reader",
                    config: {
                      supplements: ['ean_5_reader', 'ean_2_reader']
                    }
                  }];
                }
                return [{
                  format: value + "_reader",
                  config: {}
                }];
              }
            }
          },
          state: {
            inputStream: {
              type: "LiveStream",
              constraints: {
                width: { min: 640 },
                height: { min: 480 },
                facingMode: "environment",
                aspectRatio: { min: 1, max: 2 }
              }
            },
            locator: {
              patchSize: "medium",
              halfSample: true
            },
            numOfWorkers: 2,
            frequency: 10,
            decoder: {
              readers: [{
                format: "ean_reader",
                config: {}
              }]
            },
            locate: true
          },
          lastResult: null
        };

        App.init();

        Quagga.onProcessed(function (result) {
          var drawingCtx = Quagga.canvas.ctx.overlay,
              drawingCanvas = Quagga.canvas.dom.overlay;

          if (result) {
            if (result.boxes) {
              drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute("width")), parseInt(drawingCanvas.getAttribute("height")));
              result.boxes.filter(function (box) {
                return box !== result.box;
              }).forEach(function (box) {
                Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, { color: "green", lineWidth: 2 });
              });
            }

            if (result.box) {
              Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, { color: "#00F", lineWidth: 2 });
            }

            if (result.codeResult && result.codeResult.code) {
              Quagga.ImageDebug.drawPath(result.line, { x: 'x', y: 'y' }, drawingCtx, { color: 'red', lineWidth: 3 });
            }
          }
        });

        Quagga.onDetected(function (result) {
          var code = result.codeResult.code;
          console.log(code);
          Quagga.stop();
          selfVue.addProductByBarcode(code);
          // if (App.lastResult !== code) {
          //     App.lastResult = code;
          //     var $node = null, canvas = Quagga.canvas.dom.image;

          //     $node = $('<li><div class="thumbnail"><div class="imgWrapper"><img /></div><div class="caption"><h4 class="code"></h4></div></div></li>');
          //     $node.find("img").attr("src", canvas.toDataURL());
          //     $node.find("h4.code").html(code);
          //     $("#result_strip ul.thumbnails").prepend($node);
          // }
        });
      });
    },
    addProductByBarcode: function addProductByBarcode(barcode) {
      var _this7 = this;

      var product = this.productsByBrand.filter(function (item) {
        return item.barcode == barcode;
      })[0];
      var productName = this.productsByBrand.filter(function (item) {
        return item.name == barcode;
      })[0];
      if (product) {
        clearInterval(this.timeoutSearch);
        this.productChange(product);
        this.item.quantity = 1;
        this.item.productName = product.name;
        this.scannerDialog = false;
        this.search = "";
        this.save(true);
      } else if (productName) {
        clearInterval(this.timeoutSearch);
      } else {
        this.timeoutSearch = setTimeout(function () {
          _this7.search = "";
        }, 2000);
      }
    }
  }
});

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddItemAuto_vue__ = __webpack_require__(490);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4de4d0d4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddItemAuto_vue__ = __webpack_require__(1489);
function injectStyle (ssrContext) {
  __webpack_require__(1488)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddItemAuto_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4de4d0d4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddItemAuto_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_body_parser__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_body_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_body_parser__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isBuyer: Boolean,
    buyer: Object,
    selectedFirm: String,
    isEditItems: Boolean,
    gstInvoice: Boolean,
    firmSetting: Object,
    allItems: Array,
    invoiceDate: String,
    editedItem: {
      type: Object,
      default: function _default() {
        return {
          productName: "",
          productId: "",
          HSN_code: "",
          taxableGST_rate: 0,
          rate: 0,
          unit: "",
          quantity: 0,
          basicPrice: 0,
          GSTValue: 0,
          totlePrice: 0,
          GST_type: "",
          productUnit: '',
          tradeDiscount: 0,
          engineNumber: "",
          chasisNumber: "",
          brokerageRate: 0,
          drawerId: null
        };
      }
    },
    godawn: String
  },
  data: function data() {
    return {
      // isBuyer : null,
      productReportDialog: false,
      search: null,
      timeoutSearch: null,
      isTradePercentage: false,
      scannerDialog: false,
      tradeDiscountPercentage: null,
      item: this.editedItem,
      products: [],
      availableProductUnit: this.units,
      selectedProduct: {},
      stepper: 1,
      isOpeningBalance: false,
      isStanderedPrice: false,
      addProductDialog: false,
      datepicker: false,
      snackbar: false,
      productChanged: false,
      duplicateError: null,
      timeout: 3000,
      GST_types: [{
        text: "Exempt",
        value: "EXEMPT"
      }, {
        text: "Nil Rated",
        value: "NILL"
      }, {
        text: "Taxable",
        value: "TAXABLE"
      }, {
        text: "Non-GST",
        value: "OTHER"
      }],
      currentProduct: {
        name: "",
        description: "",
        HSN_code: 0,
        GST_type: "",
        taxableGST_rate: 0,
        unit: "",
        quantity: 0,
        brand: "",
        openingDate: new Date().toISOString().substr(0, 10),
        purchasingPrice: null,
        sellingPrice: null,
        openingBalance: null,
        gstValue: 0,
        basicPrice: 0
      }
    };
  },

  components: {
    ProductReports: function ProductReports() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 62));
    }
  },
  watch: {
    "godawn": {
      handler: function handler(newVal, oldVal) {
        if (!this.item.godawnBy) {
          this.item.godawnBy = newVal;
        }
      },

      deep: true
    },
    search: function search(val) {
      if (val.length > 9) {
        this.addProductByBarcode(val);
      }
    },
    editedItem: function editedItem(val) {
      var _this = this;

      this.item = this.editedItem;
      if (this.editedItem.productId) {
        this.selectedProduct = this.products.filter(function (item) {
          return item['.key'] == _this.editedItem.productId;
        })[0];
        this.availableProductUnit = this.units;
      }
    },

    "item.rate": {
      handler: function handler(newVal, oldVal) {
        this.calculatePrices();
      },

      deep: true
    },
    "item.tradeDiscount": {
      handler: function handler(newVal, oldVal) {
        this.calculatePrices();
      },

      deep: true
    },
    "item.quantity": {
      handler: function handler(newVal, oldVal) {
        this.calculatePrices();
      },

      deep: true
    },
    "item.unit": {
      handler: function handler(newVal, oldVal) {
        // this.productChange(this.selectedProduct);
        this.unitChange(newVal);
      },

      deep: true
    },
    "currentProduct.GST_type": {
      handler: function handler(newVal, oldVal) {
        if (newVal != "TAXABLE") {
          this.currentProduct.taxableGST_rate = 0;
        }
      },

      deep: true
    },
    "currentProduct.basicPrice": {
      handler: function handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.calculateOpeningBalance();
        }
      },

      deep: true
    },
    "currentProduct.gstValue": {
      handler: function handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.calculateOpeningBalance();
        }
      },

      deep: true
    }
  },
  created: function created() {
    this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand));
    // this.$bindAsObject(
    //   'buyerById',
    //   this.$root.$firebaseRefs.buyer
    // );
    this.$bindAsArray("godawns", this.$root.$firebaseRefs.godawn.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("productDrawers", this.$root.$firebaseRefs.productDrawer.orderByChild("brand").equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear"]), mapGlobalGetters({ units: "productUnit" }), {
    currentProdDrawers: function currentProdDrawers() {
      var _this2 = this;

      if (this.selectedProduct) {
        return this.productDrawers.filter(function (item) {
          return !!item.items.find(function (i) {
            return i.product == _this2.selectedProduct['.key'];
          });
        }).map(function (i) {
          return { text: i.name, value: i['.key'] };
        });
      }
      return [];
    },
    productsByBrand: function productsByBrand() {
      var _this3 = this;

      return this.products.filter(function (item) {
        return item["brand"] === _this3.selectedBrand && (!_this3.gstInvoice ? item.GST_type != 'TAXABLE' : true) && (!!item.firm && _this3.selectedFirm ? item.firm == _this3.selectedFirm : false) && (item.isActive == undefined ? true : item.isActive);
      }
      // && (item.openingDate ? (item.openingDate >= this.finYear.start) && (item.openingDate <= this.finYear.end) : true)
      );
    },
    offerList: function offerList() {
      var offerItems = [];
      var date = new Date(this.invoiceDate).getTime();
      if (this.selectedProduct && this.selectedProduct.offers) {
        offerItems = this.selectedProduct.offers.filter(function (item) {
          return item.startDate <= date && item.endDate >= date;
        });
      }
      return offerItems;
    },
    godawnByBrand: function godawnByBrand() {
      var _this4 = this;

      return this.godawns.filter(function (item) {
        return item["brand"] === _this4.selectedBrand;
      }).map(function (item) {
        return {
          text: item["godawnName"],
          value: item[".key"]
        };
      });
    },
    getHeaders: function getHeaders() {
      if (this.gstInvoice) {
        return [{ text: "Name", sortable: false, value: "productName", class: "font-weight-bold primary--text" },
        // { text: "Taxable Rate", sortable: false, value: "rate", class: "font-weight-bold primary--text" },
        { text: "Unit", sortable: false, value: "unit", class: "font-weight-bold primary--text" }, { text: "Rate", sortable: false, value: "rate", class: "font-weight-bold primary--text" }, { text: "Quantity", sortable: false, value: "quantity", class: "font-weight-bold primary--text" }, { text: "Basic Price", sortable: false, value: "basicPrice", class: "font-weight-bold primary--text" }, { text: "GST value", sortable: false, value: "GSTValue", class: "font-weight-bold primary--text" }, { text: "Trade Discount", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" }, { text: "Total Price", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" },
        // { text: "CGST ", sortable: false, value: "CGST", class: "font-weight-bold primary--text" },
        // { text: "SGST ", sortable: false, value: "SGST", class: "font-weight-bold primary--text" },
        // { text: "IGST ", sortable: false, value: "IGST", class: "font-weight-bold primary--text" },
        { text: "Action ", sortable: false, value: "action", class: "font-weight-bold primary--text" }, { text: "", value: "name", sortable: false }];
      } else {
        return [{ text: "Name", sortable: false, value: "productName", class: "font-weight-bold primary--text" }, { text: "Rate", sortable: false, value: "rate", class: "font-weight-bold primary--text" }, { text: "Unit", sortable: false, value: "unit", class: "font-weight-bold primary--text" }, { text: "Quantity", sortable: false, value: "quantity", class: "font-weight-bold primary--text" }, { text: "Basic Price", sortable: false, value: "basicPrice", class: "font-weight-bold primary--text" }, { text: "Trade Discount", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" }, { text: "Total Price", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" }, { text: "Action ", sortable: false, value: "action", class: "font-weight-bold primary--text" }, { text: "", value: "name", sortable: false }];
      }
    },
    formTitle: function formTitle() {
      return this.editedIndex === -1 ? "Edit Auto Parts" : "New Auto parts";
    }
  }),

  methods: {
    openProductReport: function openProductReport() {
      this.productReportDialog = true;
    },
    close: function close() {
      this.$emit("closeAddItem", false);
      this.reset();
    },
    editItem: function editItem(item) {
      this.reset();
      this.$emit("editItem", item, true);
    },
    deleteItem: function deleteItem(item) {
      this.reset();
      this.$emit("deleteItem", item);
    },
    productChange: function productChange(val) {
      this.selectedProduct = val;
      // let buyer = this.buyerById[this.buyerId];
      // let isBuyer = buyer  ? true : false;
      this.item.productId = val[".key"];
      this.item.HSN_code = val["HSN_code"];
      this.item.taxableGST_rate = val["taxableGST_rate"];
      this.item.unit = val["unit"];
      // if(this.selectedProduct.unit == this.item.unit) {
      //   this.item.rate = this.isBuyer ? val["sellingPrice"] : val["purchasingPrice"]
      // }
      if (this.selectedProduct.unitsDeatilsAdded) {
        this.availableProductUnit = this.selectedProduct.unitsDetails.map(function (prod) {
          return prod.unit;
        });
      } else {
        if (this.selectedProduct.unit == this.item.unit) {
          this.item.rate = this.isBuyer ? val["sellingPrice"] : val["purchasingPrice"];
        }
        if (this.isBuyer && this.buyer.category && this.selectedProduct.sellingPriceByCategories && this.selectedProduct.sellingPriceByCategories[this.buyer.category]) {
          this.item.rate = this.selectedProduct.sellingPriceByCategories[this.buyer.category];
        }
        this.availableProductUnit = this.units;
      }
      this.productChanged = true;
    },
    unitChange: function unitChange(selectedUnit) {
      var _this5 = this;

      if (this.selectedProduct.unitsDeatilsAdded) {
        this.selectedProduct.unitsDetails.map(function (prod) {
          if (prod['unit'] == selectedUnit) {
            var rate = _this5.isBuyer ? prod["sellingPrice"] : prod["purchasingPrice"];
            if (rate) {
              _this5.item.rate = rate;
            }
          }
        });
      }
    },
    calculateTradeDiscount: function calculateTradeDiscount() {
      this.item.tradeDiscount = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.tradeDiscountPercentage * this.item.rate * this.item.quantity / 100).toFixed(2);
    },
    calculatePrices: function calculatePrices() {
      // if(this.isBuyer == null) {
      //     let buyer = this.buyerById[this.buyerId];
      //     this.isBuyer = buyer  ? true : false;
      // }
      if (this.firmSetting && this.firmSetting.isRoundOff) {
        var basicPrice = (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.rate * this.item.quantity) - __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.tradeDiscount)).toFixed(2);
        this.item.basicPrice = Math.round(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(basicPrice));
        var GSTValue = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.basicPrice * (parseFloat(this.item.taxableGST_rate) / 100)).toFixed(2);
        this.item.GSTValue = Math.round(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(GSTValue));
        var totlePrice = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.basicPrice) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.GSTValue)).toFixed(2);
        this.item.totlePrice = Math.round(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(totlePrice));
      } else {
        this.item.basicPrice = (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.rate * this.item.quantity) - __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.tradeDiscount)).toFixed(2);
        this.item.GSTValue = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.basicPrice * (parseFloat(this.item.taxableGST_rate) / 100)).toFixed(2);
        this.item.totlePrice = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.basicPrice) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.GSTValue)).toFixed(2);
      }
    },
    save: function save(saveAndAdd) {
      var _this6 = this;

      // let buyer = this.buyerById[this.buyerId];
      // let isBuyer = buyer  ? true : false;
      // if(!this.isBuyer) {
      //   this.item.expiryDate = new Date(this.item.expiryDate).getTime(),
      //   this.item.manufacturingDate = new Date(this.item.manufacturingDate).getTime()
      // }
      var minQ = 0;
      if (this.offerList.length) {

        this.offerList.map(function (item) {
          if (item.minQuantity <= _this6.item.quantity && minQ < item.offerQuantity) {
            minQ = item.offerQuantity;
          }
        });
      }
      if (this.item.quantity > this.selectedProduct.quantity && this.isBuyer) {
        if (this.firmSetting && this.firmSetting.hideNegetiveStockAlert || confirm("stock can go in negative - do you want to proceed ?")) {
          if (!this.isEditItems || this.isEditItems && this.productChanged) {
            this.item.productName = this.selectedProduct.name;
            this.item.GST_type = this.selectedProduct.GST_type;
            this.item.productUnit = this.selectedProduct.unit;
            this.item.availableQuantity = this.selectedProduct.quantity;
          }
          if (minQ) {
            var clonedItem = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.item);
            clonedItem.quantity = minQ;
            clonedItem.basicPrice = 0;
            clonedItem.rate = 0;
            clonedItem.GSTValue = 0;
            clonedItem.totlePrice = 0;
            this.$emit('saveAddItem', clonedItem, false);
          }
          this.$emit('saveAddItem', this.item, saveAndAdd);
          this.reset();
        }
      } else {
        if (!this.isEditItems || this.isEditItems && this.productChanged) {
          this.item.productName = this.selectedProduct.name;
          this.item.GST_type = this.selectedProduct.GST_type;
          this.item.productUnit = this.selectedProduct.unit;
          this.item.availableQuantity = this.selectedProduct.quantity;
        }
        if (minQ) {
          var _clonedItem = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.item);
          _clonedItem.quantity = minQ;
          _clonedItem.basicPrice = 0;
          _clonedItem.rate = 0;
          _clonedItem.GSTValue = 0;
          _clonedItem.totlePrice = 0;
          this.$emit('saveAddItem', _clonedItem, false);
        }
        this.$emit('saveAddItem', this.item, saveAndAdd);
        this.reset();
      }
    },
    reset: function reset() {
      this.item = {
        productName: "",
        productId: "",
        HSN_code: "",
        taxableGST_rate: 0,
        rate: 0,
        unit: "",
        quantity: 0,
        basicPrice: 0,
        GSTValue: 0,
        GST_type: "",
        productUnit: '',
        totlePrice: 0,
        tradeDiscount: 0,
        engineNumber: "",
        chasisNumber: "",
        drawerId: null
      };
      this.tradeDiscountPercentage = null;
      this.isTradePercentage = false;
    },
    calculateOpeningBalance: function calculateOpeningBalance() {
      this.currentProduct.openingBalance = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.currentProduct.basicPrice) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.currentProduct.gstValue);
    },
    scanItem: function scanItem() {
      this.scannerDialog = true;
      this.initQugga();
    },
    initQugga: function initQugga() {
      var selfVue = this;
      $(function () {
        var resultCollector = Quagga.ResultCollector.create({
          capture: true,
          capacity: 20,
          blacklist: [{
            code: "WIWV8ETQZ1", format: "code_93"
          }, {
            code: "EH3C-%GU23RK3", format: "code_93"
          }, {
            code: "O308SIHQOXN5SA/PJ", format: "code_93"
          }, {
            code: "DG7Q$TV8JQ/EN", format: "code_93"
          }, {
            code: "VOFD1DB5A.1F6QU", format: "code_93"
          }, {
            code: "4SO64P4X8 U4YUU1T-", format: "code_93"
          }],
          filter: function filter(codeResult) {
            // only store results which match this constraint
            // e.g.: codeResult
            return true;
          }
        });
        var App = {
          init: function init() {
            var self = this;

            Quagga.init(this.state, function (err) {
              if (err) {
                return self.handleError(err);
              }
              //Quagga.registerResultCollector(resultCollector);
              App.attachListeners();
              App.checkCapabilities();
              Quagga.start();
            });
          },
          handleError: function handleError(err) {
            console.log(err);
          },
          checkCapabilities: function checkCapabilities() {
            var track = Quagga.CameraAccess.getActiveTrack();
            var capabilities = {};
            if (typeof track.getCapabilities === 'function') {
              capabilities = track.getCapabilities();
            }
            this.applySettingsVisibility('zoom', capabilities.zoom);
            this.applySettingsVisibility('torch', capabilities.torch);
          },
          updateOptionsForMediaRange: function updateOptionsForMediaRange(node, range) {
            console.log('updateOptionsForMediaRange', node, range);
            var NUM_STEPS = 6;
            var stepSize = (range.max - range.min) / NUM_STEPS;
            var option;
            var value;
            while (node.firstChild) {
              node.removeChild(node.firstChild);
            }
            for (var i = 0; i <= NUM_STEPS; i++) {
              value = range.min + stepSize * i;
              option = document.createElement('option');
              option.value = value;
              option.innerHTML = value;
              node.appendChild(option);
            }
          },
          applySettingsVisibility: function applySettingsVisibility(setting, capability) {
            // depending on type of capability
            if (typeof capability === 'boolean') {
              var node = document.querySelector('input[name="settings_' + setting + '"]');
              if (node) {
                node.parentNode.style.display = capability ? 'block' : 'none';
              }
              return;
            }
            if (window.MediaSettingsRange && capability instanceof window.MediaSettingsRange) {
              var node = document.querySelector('select[name="settings_' + setting + '"]');
              if (node) {
                this.updateOptionsForMediaRange(node, capability);
                node.parentNode.style.display = 'block';
              }
              return;
            }
          },
          initCameraSelection: function initCameraSelection() {
            var streamLabel = Quagga.CameraAccess.getActiveStreamLabel();

            return Quagga.CameraAccess.enumerateVideoDevices().then(function (devices) {
              function pruneText(text) {
                return text.length > 30 ? text.substr(0, 30) : text;
              }
              var $deviceSelection = document.getElementById("deviceSelection");
              while ($deviceSelection.firstChild) {
                $deviceSelection.removeChild($deviceSelection.firstChild);
              }
              devices.forEach(function (device) {
                var $option = document.createElement("option");
                $option.value = device.deviceId || device.id;
                $option.appendChild(document.createTextNode(pruneText(device.label || device.deviceId || device.id)));
                $option.selected = streamLabel === device.label;
                $deviceSelection.appendChild($option);
              });
            });
          },
          attachListeners: function attachListeners() {
            var self = this;

            self.initCameraSelection();
            $(".controls").on("click", "button.stop", function (e) {
              e.preventDefault();
              Quagga.stop();
              self._printCollectedResults();
            });

            $(".controls .reader-config-group").on("change", "input, select", function (e) {
              e.preventDefault();
              var $target = $(e.target),
                  value = $target.attr("type") === "checkbox" ? $target.prop("checked") : $target.val(),
                  name = $target.attr("name"),
                  state = self._convertNameToState(name);

              console.log("Value of " + state + " changed to " + value);
              self.setState(state, value);
            });
          },
          _printCollectedResults: function _printCollectedResults() {
            var results = resultCollector.getResults(),
                $ul = $("#result_strip ul.collector");

            results.forEach(function (result) {
              var $li = $('<li><div class="thumbnail"><div class="imgWrapper"><img /></div><div class="caption"><h4 class="code"></h4></div></div></li>');

              $li.find("img").attr("src", result.frame);
              $li.find("h4.code").html(result.codeResult.code + " (" + result.codeResult.format + ")");
              $ul.prepend($li);
            });
          },
          _accessByPath: function _accessByPath(obj, path, val) {
            var parts = path.split('.'),
                depth = parts.length,
                setter = typeof val !== "undefined" ? true : false;

            return parts.reduce(function (o, key, i) {
              if (setter && i + 1 === depth) {
                if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(o[key]) === "object" && (typeof val === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(val)) === "object") {
                  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(o[key], val);
                } else {
                  o[key] = val;
                }
              }
              return key in o ? o[key] : {};
            }, obj);
          },
          _convertNameToState: function _convertNameToState(name) {
            return name.replace("_", ".").split("-").reduce(function (result, value) {
              return result + value.charAt(0).toUpperCase() + value.substring(1);
            });
          },
          detachListeners: function detachListeners() {
            $(".controls").off("click", "button.stop");
            $(".controls .reader-config-group").off("change", "input, select");
          },
          applySetting: function applySetting(setting, value) {
            var track = Quagga.CameraAccess.getActiveTrack();
            if (track && typeof track.getCapabilities === 'function') {
              switch (setting) {
                case 'zoom':
                  return track.applyConstraints({ advanced: [{ zoom: parseFloat(value) }] });
                case 'torch':
                  return track.applyConstraints({ advanced: [{ torch: !!value }] });
              }
            }
          },
          setState: function setState(path, value) {
            var self = this;

            if (typeof self._accessByPath(self.inputMapper, path) === "function") {
              value = self._accessByPath(self.inputMapper, path)(value);
            }

            if (path.startsWith('settings.')) {
              var setting = path.substring(9);
              return self.applySetting(setting, value);
            }
            self._accessByPath(self.state, path, value);

            console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.state));
            App.detachListeners();
            Quagga.stop();
            App.init();
          },
          inputMapper: {
            inputStream: {
              constraints: function constraints(value) {
                if (/^(\d+)x(\d+)$/.test(value)) {
                  var values = value.split('x');
                  return {
                    width: { min: parseInt(values[0]) },
                    height: { min: parseInt(values[1]) }
                  };
                }
                return {
                  deviceId: value
                };
              }
            },
            numOfWorkers: function numOfWorkers(value) {
              return parseInt(value);
            },
            decoder: {
              readers: function readers(value) {
                if (value === 'ean_extended') {
                  return [{
                    format: "ean_reader",
                    config: {
                      supplements: ['ean_5_reader', 'ean_2_reader']
                    }
                  }];
                }
                return [{
                  format: value + "_reader",
                  config: {}
                }];
              }
            }
          },
          state: {
            inputStream: {
              type: "LiveStream",
              constraints: {
                width: { min: 640 },
                height: { min: 480 },
                facingMode: "environment",
                aspectRatio: { min: 1, max: 2 }
              }
            },
            locator: {
              patchSize: "medium",
              halfSample: true
            },
            numOfWorkers: 2,
            frequency: 10,
            decoder: {
              readers: [{
                format: "ean_reader",
                config: {}
              }]
            },
            locate: true
          },
          lastResult: null
        };

        App.init();

        Quagga.onProcessed(function (result) {
          var drawingCtx = Quagga.canvas.ctx.overlay,
              drawingCanvas = Quagga.canvas.dom.overlay;

          if (result) {
            if (result.boxes) {
              drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute("width")), parseInt(drawingCanvas.getAttribute("height")));
              result.boxes.filter(function (box) {
                return box !== result.box;
              }).forEach(function (box) {
                Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, { color: "green", lineWidth: 2 });
              });
            }

            if (result.box) {
              Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, { color: "#00F", lineWidth: 2 });
            }

            if (result.codeResult && result.codeResult.code) {
              Quagga.ImageDebug.drawPath(result.line, { x: 'x', y: 'y' }, drawingCtx, { color: 'red', lineWidth: 3 });
            }
          }
        });

        Quagga.onDetected(function (result) {
          var code = result.codeResult.code;
          console.log(code);
          Quagga.stop();
          selfVue.addProductByBarcode(code);
          // if (App.lastResult !== code) {
          //     App.lastResult = code;
          //     var $node = null, canvas = Quagga.canvas.dom.image;

          //     $node = $('<li><div class="thumbnail"><div class="imgWrapper"><img /></div><div class="caption"><h4 class="code"></h4></div></div></li>');
          //     $node.find("img").attr("src", canvas.toDataURL());
          //     $node.find("h4.code").html(code);
          //     $("#result_strip ul.thumbnails").prepend($node);
          // }
        });
      });
    },
    addProductByBarcode: function addProductByBarcode(barcode) {
      var _this7 = this;

      var product = this.productsByBrand.filter(function (item) {
        return item.barcode == barcode;
      })[0];
      var productName = this.productsByBrand.filter(function (item) {
        return item.name == barcode;
      })[0];
      if (product) {
        clearInterval(this.timeoutSearch);
        this.productChange(product);
        this.item.quantity = 1;
        this.item.productName = product.name;
        this.scannerDialog = false;
        this.search = "";
        this.save(true);
      } else if (productName) {
        clearInterval(this.timeoutSearch);
      } else {
        this.timeoutSearch = setTimeout(function () {
          _this7.search = "";
        }, 2000);
      }
    }
  }
});

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddItemDairy_vue__ = __webpack_require__(492);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e44e916_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddItemDairy_vue__ = __webpack_require__(1491);
function injectStyle (ssrContext) {
  __webpack_require__(1490)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddItemDairy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e44e916_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddItemDairy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_body_parser__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_body_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_body_parser__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isBuyer: Boolean,
    buyer: Object,
    selectedFirm: String,
    isEditItems: Boolean,
    gstInvoice: Boolean,
    firmSetting: Object,
    allItems: Array,
    invoiceDate: String,
    editedItem: {
      type: Object,
      default: function _default() {
        return {
          productName: "",
          productId: "",
          HSN_code: "",
          taxableGST_rate: 0,
          rate: 0,
          unit: "",
          quantity: 0,
          fat: 0,
          basicPrice: 0,
          GSTValue: 0,
          totlePrice: 0,
          GST_type: "",
          productUnit: '',
          tradeDiscount: 0,
          clr: "",
          snf: "",
          brokerageRate: 0,
          drawerId: null
        };
      }
    },
    godawn: String
  },
  data: function data() {
    return {
      // isBuyer : null,
      productReportDialog: false,
      search: null,
      timeoutSearch: null,
      isTradePercentage: false,
      scannerDialog: false,
      tradeDiscountPercentage: null,
      item: this.editedItem,
      products: [],
      availableProductUnit: this.units,
      selectedProduct: {},
      stepper: 1,
      isOpeningBalance: false,
      isStanderedPrice: false,
      addProductDialog: false,
      datepicker: false,
      snackbar: false,
      productChanged: false,
      duplicateError: null,
      timeout: 3000,
      GST_types: [{
        text: "Exempt",
        value: "EXEMPT"
      }, {
        text: "Nil Rated",
        value: "NILL"
      }, {
        text: "Taxable",
        value: "TAXABLE"
      }, {
        text: "Non-GST",
        value: "OTHER"
      }],
      currentProduct: {
        name: "",
        description: "",
        HSN_code: 0,
        GST_type: "",
        taxableGST_rate: 0,
        unit: "",
        quantity: 0,
        fat: 0,
        brand: "",
        openingDate: new Date().toISOString().substr(0, 10),
        purchasingPrice: null,
        sellingPrice: null,
        openingBalance: null,
        gstValue: 0,
        basicPrice: 0
      }
    };
  },

  components: {
    ProductReports: function ProductReports() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 62));
    }
  },
  watch: {
    "godawn": {
      handler: function handler(newVal, oldVal) {
        if (!this.item.godawnBy) {
          this.item.godawnBy = newVal;
        }
      },

      deep: true
    },
    search: function search(val) {
      if (val.length > 9) {
        this.addProductByBarcode(val);
      }
    },
    editedItem: function editedItem(val) {
      var _this = this;

      this.item = this.editedItem;
      if (this.editedItem.productId) {
        this.selectedProduct = this.products.filter(function (item) {
          return item['.key'] == _this.editedItem.productId;
        })[0];
        this.availableProductUnit = this.units;
      }
    },

    "item.rate": {
      handler: function handler(newVal, oldVal) {
        this.calculatePrices();
      },

      deep: true
    },
    "item.tradeDiscount": {
      handler: function handler(newVal, oldVal) {
        this.calculatePrices();
      },

      deep: true
    },
    "item.quantity": {
      handler: function handler(newVal, oldVal) {
        this.calculatePrices();
      },

      deep: true
    },
    "item.fat": {
      handler: function handler(newVal, oldVal) {
        this.calculatePrices();
      },

      deep: true
    },
    "item.unit": {
      handler: function handler(newVal, oldVal) {
        // this.productChange(this.selectedProduct);
        this.unitChange(newVal);
      },

      deep: true
    },
    "currentProduct.GST_type": {
      handler: function handler(newVal, oldVal) {
        if (newVal != "TAXABLE") {
          this.currentProduct.taxableGST_rate = 0;
        }
      },

      deep: true
    },
    "currentProduct.basicPrice": {
      handler: function handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.calculateOpeningBalance();
        }
      },

      deep: true
    },
    // "currentProduct.snf": {
    //   handler(newVal, oldVal) {
    //     if (newVal != oldVal) {
    //       this.calculatePrices();
    //     }
    //   },
    //   deep: true
    // },
    "currentProduct.gstValue": {
      handler: function handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.calculateOpeningBalance();
        }
      },

      deep: true
    }
  },
  created: function created() {
    this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand));
    // this.$bindAsObject(
    //   'buyerById',
    //   this.$root.$firebaseRefs.buyer
    // );
    this.$bindAsArray("godawns", this.$root.$firebaseRefs.godawn.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("productDrawers", this.$root.$firebaseRefs.productDrawer.orderByChild("brand").equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear"]), mapGlobalGetters({ units: "productUnit" }), {
    currentProdDrawers: function currentProdDrawers() {
      var _this2 = this;

      if (this.selectedProduct) {
        return this.productDrawers.filter(function (item) {
          return !!item.items.find(function (i) {
            return i.product == _this2.selectedProduct['.key'];
          });
        }).map(function (i) {
          return { text: i.name, value: i['.key'] };
        });
      }
      return [];
    },
    productsByBrand: function productsByBrand() {
      var _this3 = this;

      return this.products.filter(function (item) {
        return item["brand"] === _this3.selectedBrand && (!_this3.gstInvoice ? item.GST_type != 'TAXABLE' : true) && (!!item.firm && _this3.selectedFirm ? item.firm == _this3.selectedFirm : false) && (item.isActive == undefined ? true : item.isActive);
      }
      // && (item.openingDate ? (item.openingDate >= this.finYear.start) && (item.openingDate <= this.finYear.end) : true)
      );
    },
    offerList: function offerList() {
      var offerItems = [];
      var date = new Date(this.invoiceDate).getTime();
      if (this.selectedProduct && this.selectedProduct.offers) {
        offerItems = this.selectedProduct.offers.filter(function (item) {
          return item.startDate <= date && item.endDate >= date;
        });
      }
      return offerItems;
    },
    godawnByBrand: function godawnByBrand() {
      var _this4 = this;

      return this.godawns.filter(function (item) {
        return item["brand"] === _this4.selectedBrand;
      }).map(function (item) {
        return {
          text: item["godawnName"],
          value: item[".key"]
        };
      });
    },
    getHeaders: function getHeaders() {
      if (this.gstInvoice) {
        return [{ text: "Name", sortable: false, value: "productName", class: "font-weight-bold primary--text" },
        // { text: "Taxable Rate", sortable: false, value: "rate", class: "font-weight-bold primary--text" },
        { text: "Unit", sortable: false, value: "unit", class: "font-weight-bold primary--text" }, { text: "Quantity", sortable: false, value: "quantity", class: "font-weight-bold primary--text" }, { text: "Fat", sortable: false, value: "fat", class: "font-weight-bold primary--text" }, { text: "Rate", sortable: false, value: "rate", class: "font-weight-bold primary--text" }, { text: "Basic Price", sortable: false, value: "basicPrice", class: "font-weight-bold primary--text" }, { text: "GST value", sortable: false, value: "GSTValue", class: "font-weight-bold primary--text" }, { text: "Trade Discount", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" }, { text: "Total Price", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" },
        // { text: "CGST ", sortable: false, value: "CGST", class: "font-weight-bold primary--text" },
        // { text: "SGST ", sortable: false, value: "SGST", class: "font-weight-bold primary--text" },
        // { text: "IGST ", sortable: false, value: "IGST", class: "font-weight-bold primary--text" },
        { text: "Action ", sortable: false, value: "action", class: "font-weight-bold primary--text" }, { text: "", value: "name", sortable: false }];
      } else {
        return [{ text: "Name", sortable: false, value: "productName", class: "font-weight-bold primary--text" }, { text: "Unit", sortable: false, value: "unit", class: "font-weight-bold primary--text" }, { text: "Quantity", sortable: false, value: "quantity", class: "font-weight-bold primary--text" }, { text: "Fat", sortable: false, value: "fat", class: "font-weight-bold primary--text" }, { text: "Rate", sortable: false, value: "rate", class: "font-weight-bold primary--text" }, { text: "Basic Price", sortable: false, value: "basicPrice", class: "font-weight-bold primary--text" }, { text: "Trade Discount", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" }, { text: "Total Price", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" }, { text: "Action ", sortable: false, value: "action", class: "font-weight-bold primary--text" }, { text: "", value: "name", sortable: false }];
      }
    },
    formTitle: function formTitle() {
      return this.editedIndex === -1 ? "Edit Items" : "New Items";
    }
  }),

  methods: {
    openProductReport: function openProductReport() {
      this.productReportDialog = true;
    },
    close: function close() {
      this.$emit("closeAddItem", false);
      this.reset();
    },
    editItem: function editItem(item) {
      this.reset();
      this.$emit("editItem", item, true);
    },
    deleteItem: function deleteItem(item) {
      this.reset();
      this.$emit("deleteItem", item);
    },
    productChange: function productChange(val) {
      this.selectedProduct = val;
      // let buyer = this.buyerById[this.buyerId];
      // let isBuyer = buyer  ? true : false;
      this.item.productId = val[".key"];
      this.item.HSN_code = val["HSN_code"];
      this.item.taxableGST_rate = val["taxableGST_rate"];
      this.item.unit = val["unit"];
      // if(this.selectedProduct.unit == this.item.unit) {
      //   this.item.rate = this.isBuyer ? val["sellingPrice"] : val["purchasingPrice"]
      // }
      if (this.selectedProduct.unitsDeatilsAdded) {
        this.availableProductUnit = this.selectedProduct.unitsDetails.map(function (prod) {
          return prod.unit;
        });
      } else {
        if (this.selectedProduct.unit == this.item.unit) {
          this.item.rate = this.isBuyer ? val["sellingPrice"] : val["purchasingPrice"];
        }
        if (this.isBuyer && this.buyer.category && this.selectedProduct.sellingPriceByCategories && this.selectedProduct.sellingPriceByCategories[this.buyer.category]) {
          this.item.rate = this.selectedProduct.sellingPriceByCategories[this.buyer.category];
        }
        this.availableProductUnit = this.units;
      }
      this.productChanged = true;
    },
    unitChange: function unitChange(selectedUnit) {
      var _this5 = this;

      if (this.selectedProduct.unitsDeatilsAdded) {
        this.selectedProduct.unitsDetails.map(function (prod) {
          if (prod['unit'] == selectedUnit) {
            var rate = _this5.isBuyer ? prod["sellingPrice"] : prod["purchasingPrice"];
            if (rate) {
              _this5.item.rate = rate;
            }
          }
        });
      }
    },
    calculateTradeDiscount: function calculateTradeDiscount() {
      this.item.tradeDiscount = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.tradeDiscountPercentage * this.item.rate * this.item.quantity / 100).toFixed(2);
    },
    calculatePrices: function calculatePrices() {
      // if(this.isBuyer == null) {
      //     let buyer = this.buyerById[this.buyerId];
      //     this.isBuyer = buyer  ? true : false;
      // }
      if (this.firmSetting && this.firmSetting.isRoundOff) {
        // let snf = (Number.parseFloat(
        // this.item.rate * this.item.quantity * this.item.fat) - Number.parseFloat(this.item.tradeDiscount)).toFixed(2);
        // this.item.snf = Math.round(Number.parseFloat(snf));

        var basicPrice = (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.rate * this.item.quantity * this.item.fat) - __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.tradeDiscount)).toFixed(2);
        this.item.basicPrice = Math.round(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(basicPrice));

        var GSTValue = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.basicPrice * (parseFloat(this.item.taxableGST_rate) / 100)).toFixed(2);
        this.item.GSTValue = Math.round(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(GSTValue));
        var totlePrice = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.basicPrice) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.GSTValue)).toFixed(2);
        this.item.totlePrice = Math.round(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(totlePrice));
      } else {
        // this.item.snf = (Number.parseFloat(
        // this.item.rate * this.item.quantity * this.item.fat) - Number.parseFloat(this.item.tradeDiscount)).toFixed(2);

        this.item.basicPrice = (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.rate * this.item.quantity * this.item.fat) - __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.tradeDiscount)).toFixed(2);
        this.item.GSTValue = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.basicPrice * (parseFloat(this.item.taxableGST_rate) / 100)).toFixed(2);
        this.item.totlePrice = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.basicPrice) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.GSTValue)).toFixed(2);
      }
    },
    save: function save(saveAndAdd) {
      var _this6 = this;

      // let buyer = this.buyerById[this.buyerId];
      // let isBuyer = buyer  ? true : false;
      // if(!this.isBuyer) {
      //   this.item.expiryDate = new Date(this.item.expiryDate).getTime(),
      //   this.item.manufacturingDate = new Date(this.item.manufacturingDate).getTime()
      // }
      var minQ = 0;
      if (this.offerList.length) {

        this.offerList.map(function (item) {
          if (item.minQuantity <= _this6.item.quantity && minQ < item.offerQuantity) {
            minQ = item.offerQuantity;
          }
        });
      }
      if (this.item.quantity > this.selectedProduct.quantity && this.isBuyer) {
        if (this.firmSetting && this.firmSetting.hideNegetiveStockAlert || confirm("stock can go in negative - do you want to proceed ?")) {
          if (!this.isEditItems || this.isEditItems && this.productChanged) {
            this.item.productName = this.selectedProduct.name;
            this.item.GST_type = this.selectedProduct.GST_type;
            this.item.productUnit = this.selectedProduct.unit;
            this.item.availableQuantity = this.selectedProduct.quantity;
          }
          if (minQ) {
            var clonedItem = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.item);
            clonedItem.quantity = minQ;
            clonedItem.basicPrice = 0;
            clonedItem.rate = 0;
            clonedItem.GSTValue = 0;
            clonedItem.totlePrice = 0;
            this.$emit('saveAddItem', clonedItem, false);
          }
          this.$emit('saveAddItem', this.item, saveAndAdd);
          this.reset();
        }
      } else {
        if (!this.isEditItems || this.isEditItems && this.productChanged) {
          this.item.productName = this.selectedProduct.name;
          this.item.GST_type = this.selectedProduct.GST_type;
          this.item.productUnit = this.selectedProduct.unit;
          this.item.availableQuantity = this.selectedProduct.quantity;
        }
        if (minQ) {
          var _clonedItem = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.item);
          _clonedItem.quantity = minQ;
          _clonedItem.basicPrice = 0;
          _clonedItem.rate = 0;
          _clonedItem.GSTValue = 0;
          _clonedItem.totlePrice = 0;
          this.$emit('saveAddItem', _clonedItem, false);
        }
        this.$emit('saveAddItem', this.item, saveAndAdd);
        this.reset();
      }
    },
    reset: function reset() {
      this.item = {
        productName: "",
        productId: "",
        HSN_code: "",
        taxableGST_rate: 0,
        rate: 0,
        unit: "",
        quantity: 0,
        fat: 0,
        basicPrice: 0,
        GSTValue: 0,
        GST_type: "",
        productUnit: '',
        totlePrice: 0,
        tradeDiscount: 0,
        clr: "",
        snf: "",
        drawerId: null
      };
      this.tradeDiscountPercentage = null;
      this.isTradePercentage = false;
    },
    calculateOpeningBalance: function calculateOpeningBalance() {
      this.currentProduct.openingBalance = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.currentProduct.basicPrice) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.currentProduct.gstValue);
    },
    scanItem: function scanItem() {
      this.scannerDialog = true;
      this.initQugga();
    },
    initQugga: function initQugga() {
      var selfVue = this;
      $(function () {
        var resultCollector = Quagga.ResultCollector.create({
          capture: true,
          capacity: 20,
          blacklist: [{
            code: "WIWV8ETQZ1", format: "code_93"
          }, {
            code: "EH3C-%GU23RK3", format: "code_93"
          }, {
            code: "O308SIHQOXN5SA/PJ", format: "code_93"
          }, {
            code: "DG7Q$TV8JQ/EN", format: "code_93"
          }, {
            code: "VOFD1DB5A.1F6QU", format: "code_93"
          }, {
            code: "4SO64P4X8 U4YUU1T-", format: "code_93"
          }],
          filter: function filter(codeResult) {
            // only store results which match this constraint
            // e.g.: codeResult
            return true;
          }
        });
        var App = {
          init: function init() {
            var self = this;

            Quagga.init(this.state, function (err) {
              if (err) {
                return self.handleError(err);
              }
              //Quagga.registerResultCollector(resultCollector);
              App.attachListeners();
              App.checkCapabilities();
              Quagga.start();
            });
          },
          handleError: function handleError(err) {
            console.log(err);
          },
          checkCapabilities: function checkCapabilities() {
            var track = Quagga.CameraAccess.getActiveTrack();
            var capabilities = {};
            if (typeof track.getCapabilities === 'function') {
              capabilities = track.getCapabilities();
            }
            this.applySettingsVisibility('zoom', capabilities.zoom);
            this.applySettingsVisibility('torch', capabilities.torch);
          },
          updateOptionsForMediaRange: function updateOptionsForMediaRange(node, range) {
            console.log('updateOptionsForMediaRange', node, range);
            var NUM_STEPS = 6;
            var stepSize = (range.max - range.min) / NUM_STEPS;
            var option;
            var value;
            while (node.firstChild) {
              node.removeChild(node.firstChild);
            }
            for (var i = 0; i <= NUM_STEPS; i++) {
              value = range.min + stepSize * i;
              option = document.createElement('option');
              option.value = value;
              option.innerHTML = value;
              node.appendChild(option);
            }
          },
          applySettingsVisibility: function applySettingsVisibility(setting, capability) {
            // depending on type of capability
            if (typeof capability === 'boolean') {
              var node = document.querySelector('input[name="settings_' + setting + '"]');
              if (node) {
                node.parentNode.style.display = capability ? 'block' : 'none';
              }
              return;
            }
            if (window.MediaSettingsRange && capability instanceof window.MediaSettingsRange) {
              var node = document.querySelector('select[name="settings_' + setting + '"]');
              if (node) {
                this.updateOptionsForMediaRange(node, capability);
                node.parentNode.style.display = 'block';
              }
              return;
            }
          },
          initCameraSelection: function initCameraSelection() {
            var streamLabel = Quagga.CameraAccess.getActiveStreamLabel();

            return Quagga.CameraAccess.enumerateVideoDevices().then(function (devices) {
              function pruneText(text) {
                return text.length > 30 ? text.substr(0, 30) : text;
              }
              var $deviceSelection = document.getElementById("deviceSelection");
              while ($deviceSelection.firstChild) {
                $deviceSelection.removeChild($deviceSelection.firstChild);
              }
              devices.forEach(function (device) {
                var $option = document.createElement("option");
                $option.value = device.deviceId || device.id;
                $option.appendChild(document.createTextNode(pruneText(device.label || device.deviceId || device.id)));
                $option.selected = streamLabel === device.label;
                $deviceSelection.appendChild($option);
              });
            });
          },
          attachListeners: function attachListeners() {
            var self = this;

            self.initCameraSelection();
            $(".controls").on("click", "button.stop", function (e) {
              e.preventDefault();
              Quagga.stop();
              self._printCollectedResults();
            });

            $(".controls .reader-config-group").on("change", "input, select", function (e) {
              e.preventDefault();
              var $target = $(e.target),
                  value = $target.attr("type") === "checkbox" ? $target.prop("checked") : $target.val(),
                  name = $target.attr("name"),
                  state = self._convertNameToState(name);

              console.log("Value of " + state + " changed to " + value);
              self.setState(state, value);
            });
          },
          _printCollectedResults: function _printCollectedResults() {
            var results = resultCollector.getResults(),
                $ul = $("#result_strip ul.collector");

            results.forEach(function (result) {
              var $li = $('<li><div class="thumbnail"><div class="imgWrapper"><img /></div><div class="caption"><h4 class="code"></h4></div></div></li>');

              $li.find("img").attr("src", result.frame);
              $li.find("h4.code").html(result.codeResult.code + " (" + result.codeResult.format + ")");
              $ul.prepend($li);
            });
          },
          _accessByPath: function _accessByPath(obj, path, val) {
            var parts = path.split('.'),
                depth = parts.length,
                setter = typeof val !== "undefined" ? true : false;

            return parts.reduce(function (o, key, i) {
              if (setter && i + 1 === depth) {
                if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(o[key]) === "object" && (typeof val === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(val)) === "object") {
                  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(o[key], val);
                } else {
                  o[key] = val;
                }
              }
              return key in o ? o[key] : {};
            }, obj);
          },
          _convertNameToState: function _convertNameToState(name) {
            return name.replace("_", ".").split("-").reduce(function (result, value) {
              return result + value.charAt(0).toUpperCase() + value.substring(1);
            });
          },
          detachListeners: function detachListeners() {
            $(".controls").off("click", "button.stop");
            $(".controls .reader-config-group").off("change", "input, select");
          },
          applySetting: function applySetting(setting, value) {
            var track = Quagga.CameraAccess.getActiveTrack();
            if (track && typeof track.getCapabilities === 'function') {
              switch (setting) {
                case 'zoom':
                  return track.applyConstraints({ advanced: [{ zoom: parseFloat(value) }] });
                case 'torch':
                  return track.applyConstraints({ advanced: [{ torch: !!value }] });
              }
            }
          },
          setState: function setState(path, value) {
            var self = this;

            if (typeof self._accessByPath(self.inputMapper, path) === "function") {
              value = self._accessByPath(self.inputMapper, path)(value);
            }

            if (path.startsWith('settings.')) {
              var setting = path.substring(9);
              return self.applySetting(setting, value);
            }
            self._accessByPath(self.state, path, value);

            console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.state));
            App.detachListeners();
            Quagga.stop();
            App.init();
          },
          inputMapper: {
            inputStream: {
              constraints: function constraints(value) {
                if (/^(\d+)x(\d+)$/.test(value)) {
                  var values = value.split('x');
                  return {
                    width: { min: parseInt(values[0]) },
                    height: { min: parseInt(values[1]) }
                  };
                }
                return {
                  deviceId: value
                };
              }
            },
            numOfWorkers: function numOfWorkers(value) {
              return parseInt(value);
            },
            decoder: {
              readers: function readers(value) {
                if (value === 'ean_extended') {
                  return [{
                    format: "ean_reader",
                    config: {
                      supplements: ['ean_5_reader', 'ean_2_reader']
                    }
                  }];
                }
                return [{
                  format: value + "_reader",
                  config: {}
                }];
              }
            }
          },
          state: {
            inputStream: {
              type: "LiveStream",
              constraints: {
                width: { min: 640 },
                height: { min: 480 },
                facingMode: "environment",
                aspectRatio: { min: 1, max: 2 }
              }
            },
            locator: {
              patchSize: "medium",
              halfSample: true
            },
            numOfWorkers: 2,
            frequency: 10,
            decoder: {
              readers: [{
                format: "ean_reader",
                config: {}
              }]
            },
            locate: true
          },
          lastResult: null
        };

        App.init();

        Quagga.onProcessed(function (result) {
          var drawingCtx = Quagga.canvas.ctx.overlay,
              drawingCanvas = Quagga.canvas.dom.overlay;

          if (result) {
            if (result.boxes) {
              drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute("width")), parseInt(drawingCanvas.getAttribute("height")));
              result.boxes.filter(function (box) {
                return box !== result.box;
              }).forEach(function (box) {
                Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, { color: "green", lineWidth: 2 });
              });
            }

            if (result.box) {
              Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, { color: "#00F", lineWidth: 2 });
            }

            if (result.codeResult && result.codeResult.code) {
              Quagga.ImageDebug.drawPath(result.line, { x: 'x', y: 'y' }, drawingCtx, { color: 'red', lineWidth: 3 });
            }
          }
        });

        Quagga.onDetected(function (result) {
          var code = result.codeResult.code;
          console.log(code);
          Quagga.stop();
          selfVue.addProductByBarcode(code);
          // if (App.lastResult !== code) {
          //     App.lastResult = code;
          //     var $node = null, canvas = Quagga.canvas.dom.image;

          //     $node = $('<li><div class="thumbnail"><div class="imgWrapper"><img /></div><div class="caption"><h4 class="code"></h4></div></div></li>');
          //     $node.find("img").attr("src", canvas.toDataURL());
          //     $node.find("h4.code").html(code);
          //     $("#result_strip ul.thumbnails").prepend($node);
          // }
        });
      });
    },
    addProductByBarcode: function addProductByBarcode(barcode) {
      var _this7 = this;

      var product = this.productsByBrand.filter(function (item) {
        return item.barcode == barcode;
      })[0];
      var productName = this.productsByBrand.filter(function (item) {
        return item.name == barcode;
      })[0];
      if (product) {
        clearInterval(this.timeoutSearch);
        this.productChange(product);
        this.item.quantity = 1;
        this.item.productName = product.name;
        this.scannerDialog = false;
        this.search = "";
        this.save(true);
      } else if (productName) {
        clearInterval(this.timeoutSearch);
      } else {
        this.timeoutSearch = setTimeout(function () {
          _this7.search = "";
        }, 2000);
      }
    }
  }
});

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddItemClothes_vue__ = __webpack_require__(494);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_632702f4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddItemClothes_vue__ = __webpack_require__(1493);
function injectStyle (ssrContext) {
  __webpack_require__(1492)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddItemClothes_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_632702f4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddItemClothes_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_body_parser__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_body_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_body_parser__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isBuyer: Boolean,
    firmSetting: Object,
    buyer: Object,
    selectedFirm: String,
    isEditItems: Boolean,
    gstInvoice: Boolean,
    allItems: Array,
    invoiceDate: String,
    editedItem: {
      type: Object,
      default: function _default() {
        return {
          productName: "",
          productId: "",
          HSN_code: "",
          taxableGST_rate: 0,
          rate: 0,
          unit: "",
          quantity: 0,
          basicPrice: 0,
          GSTValue: 0,
          totlePrice: 0,
          GST_type: "",
          productUnit: '',
          tradeDiscount: 0,
          productBrandName: "",
          color: "",
          size: "",
          brokerageRate: 0,
          drawerId: null
        };
      }
    },
    godawn: String
  },
  data: function data() {
    return {
      // isBuyer : null,
      productReportDialog: false,
      search: null,
      timeoutSearch: null,
      isTradePercentage: false,
      scannerDialog: false,
      //individualProdBrokerage : Boolean,
      tradeDiscountPercentage: null,
      item: this.editedItem,
      products: [],
      availableProductUnit: this.units,
      selectedProduct: {},
      stepper: 1,
      isOpeningBalance: false,
      isStanderedPrice: false,
      datepicker: false,
      snackbar: false,
      productChanged: false,
      duplicateError: null,
      timeout: 3000,
      GST_types: [{
        text: "Exempt",
        value: "EXEMPT"
      }, {
        text: "Nil Rated",
        value: "NILL"
      }, {
        text: "Taxable",
        value: "TAXABLE"
      }, {
        text: "Non-GST",
        value: "OTHER"
      }],
      currentProduct: {
        name: "",
        description: "",
        HSN_code: 0,
        GST_type: "",
        taxableGST_rate: 0,
        unit: "",
        quantity: 0,
        brand: "",
        openingDate: new Date().toISOString().substr(0, 10),
        purchasingPrice: null,
        sellingPrice: null,
        openingBalance: null,
        gstValue: 0,
        basicPrice: 0
      }
    };
  },

  components: {
    ProductReports: function ProductReports() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 62));
    }
  },
  watch: {
    "godawn": {
      handler: function handler(newVal, oldVal) {
        if (!this.item.godawnBy) {
          this.item.godawnBy = newVal;
        }
      },

      deep: true
    },
    search: function search(val) {
      if (val.length > 9) {
        this.addProductByBarcode(val);
      }
    },
    editedItem: function editedItem(val) {
      var _this = this;

      this.item = this.editedItem;
      if (this.editedItem.productId) {
        this.selectedProduct = this.products.filter(function (item) {
          return item['.key'] == _this.editedItem.productId;
        })[0];
        this.availableProductUnit = this.units;
      }
    },

    "item.rate": {
      handler: function handler(newVal, oldVal) {
        this.calculatePrices();
      },

      deep: true
    },
    "item.tradeDiscount": {
      handler: function handler(newVal, oldVal) {
        this.calculatePrices();
      },

      deep: true
    },
    "item.quantity": {
      handler: function handler(newVal, oldVal) {
        this.calculatePrices();
      },

      deep: true
    },
    "item.unit": {
      handler: function handler(newVal, oldVal) {
        // this.productChange(this.selectedProduct);
        this.unitChange(newVal);
      },

      deep: true
    },
    "currentProduct.GST_type": {
      handler: function handler(newVal, oldVal) {
        if (newVal != "TAXABLE") {
          this.currentProduct.taxableGST_rate = 0;
        }
      },

      deep: true
    },
    "currentProduct.basicPrice": {
      handler: function handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.calculateOpeningBalance();
        }
      },

      deep: true
    },
    "currentProduct.gstValue": {
      handler: function handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.calculateOpeningBalance();
        }
      },

      deep: true
    }
  },
  created: function created() {
    this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand));
    // this.$bindAsObject(
    //   'buyerById',
    //   this.$root.$firebaseRefs.buyer
    // );
    this.$bindAsArray("productDrawers", this.$root.$firebaseRefs.productDrawer.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("godawns", this.$root.$firebaseRefs.godawn.orderByChild('brand').equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear"]), mapGlobalGetters({ units: "productUnit" }), {
    currentProdDrawers: function currentProdDrawers() {
      var _this2 = this;

      if (this.selectedProduct) {
        return this.productDrawers.filter(function (item) {
          return !!item.items.find(function (i) {
            return i.product == _this2.selectedProduct['.key'];
          });
        }).map(function (i) {
          return { text: i.name, value: i['.key'] };
        });
      }
      return [];
    },
    productsByBrand: function productsByBrand() {
      var _this3 = this;

      return this.products.filter(function (item) {
        return item["brand"] === _this3.selectedBrand && (!_this3.gstInvoice ? item.GST_type != 'TAXABLE' : true) && (!!item.firm && _this3.selectedFirm ? item.firm == _this3.selectedFirm : false) && (item.isActive == undefined ? true : item.isActive);
      }
      // &&(item.openingDate ? (item.openingDate >= this.finYear.start) && (item.openingDate <= this.finYear.end) : true))
      );
    },
    offerList: function offerList() {
      var offerItems = [];
      var date = new Date(this.invoiceDate).getTime();
      if (this.selectedProduct && this.selectedProduct.offers) {
        offerItems = this.selectedProduct.offers.filter(function (item) {
          return item.startDate <= date && item.endDate >= date;
        });
      }
      return offerItems;
    },
    godawnByBrand: function godawnByBrand() {
      var _this4 = this;

      return this.godawns.filter(function (item) {
        return item["brand"] === _this4.selectedBrand;
      }).map(function (item) {
        return {
          text: item["godawnName"],
          value: item[".key"]
        };
      });
    },
    getHeaders: function getHeaders() {
      if (this.gstInvoice) {
        return [{ text: "Name", sortable: false, value: "productName", class: "font-weight-bold primary--text" },
        // { text: "Taxable Rate", sortable: false, value: "rate", class: "font-weight-bold primary--text" },
        { text: "Unit", sortable: false, value: "unit", class: "font-weight-bold primary--text" }, { text: "Rate", sortable: false, value: "rate", class: "font-weight-bold primary--text" }, { text: "Quantity", sortable: false, value: "quantity", class: "font-weight-bold primary--text" }, { text: "Basic Price", sortable: false, value: "basicPrice", class: "font-weight-bold primary--text" }, { text: "GST value", sortable: false, value: "GSTValue", class: "font-weight-bold primary--text" }, { text: "Trade Discount", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" }, { text: "Total Price", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" },
        // { text: "CGST ", sortable: false, value: "CGST", class: "font-weight-bold primary--text" },
        // { text: "SGST ", sortable: false, value: "SGST", class: "font-weight-bold primary--text" },
        // { text: "IGST ", sortable: false, value: "IGST", class: "font-weight-bold primary--text" },
        { text: "Action ", sortable: false, value: "action", class: "font-weight-bold primary--text" }, { text: "", value: "name", sortable: false }];
      } else {
        return [{ text: "Name", sortable: false, value: "productName", class: "font-weight-bold primary--text" }, { text: "Rate", sortable: false, value: "rate", class: "font-weight-bold primary--text" }, { text: "Unit", sortable: false, value: "unit", class: "font-weight-bold primary--text" }, { text: "Quantity", sortable: false, value: "quantity", class: "font-weight-bold primary--text" }, { text: "Basic Price", sortable: false, value: "basicPrice", class: "font-weight-bold primary--text" }, { text: "Trade Discount", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" }, { text: "Total Price", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" }, { text: "Action ", sortable: false, value: "action", class: "font-weight-bold primary--text" }, { text: "", value: "name", sortable: false }];
      }
    },
    formTitle: function formTitle() {
      return this.editedIndex === -1 ? "Edit clothe Item" : "New clothe Item";
    }
  }),

  methods: {
    openProductReport: function openProductReport() {
      this.productReportDialog = true;
    },
    close: function close() {
      this.$emit("closeAddItem", false);
      this.reset();
    },
    editItem: function editItem(item) {
      this.reset();
      this.$emit("editItem", item, true);
    },
    deleteItem: function deleteItem(item) {
      this.reset();
      this.$emit("deleteItem", item);
    },
    productChange: function productChange(val) {
      this.selectedProduct = val;
      // let buyer = this.buyerById[this.buyerId];
      // let isBuyer = buyer  ? true : false;
      this.item.productId = val[".key"];
      this.item.HSN_code = val["HSN_code"];
      this.item.taxableGST_rate = val["taxableGST_rate"];
      this.item.unit = val["unit"];
      // if(this.selectedProduct.unit == this.item.unit) {
      //   this.item.rate = this.isBuyer ? val["sellingPrice"] : val["purchasingPrice"]
      // }
      this.productChanged = true;
      if (this.selectedProduct.unitsDeatilsAdded) {
        this.availableProductUnit = this.selectedProduct.unitsDetails.map(function (prod) {
          return prod.unit;
        });
      } else {
        if (this.selectedProduct.unit == this.item.unit) {
          this.item.rate = this.isBuyer ? val["sellingPrice"] : val["purchasingPrice"];
        }
        if (this.isBuyer && this.buyer.category && this.selectedProduct.sellingPriceByCategories && this.selectedProduct.sellingPriceByCategories[this.buyer.category]) {
          this.item.rate = this.selectedProduct.sellingPriceByCategories[this.buyer.category];
        }
        this.availableProductUnit = this.units;
      }
      this.productChanged = true;
    },
    unitChange: function unitChange(selectedUnit) {
      var _this5 = this;

      if (this.selectedProduct.unitsDeatilsAdded) {
        this.selectedProduct.unitsDetails.map(function (prod) {
          if (prod['unit'] == selectedUnit) {
            var rate = _this5.isBuyer ? prod["sellingPrice"] : prod["purchasingPrice"];
            if (rate) {
              _this5.item.rate = rate;
            }
          }
        });
      }
    },
    calculateTradeDiscount: function calculateTradeDiscount() {
      this.item.tradeDiscount = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.tradeDiscountPercentage * this.item.rate * this.item.quantity / 100).toFixed(2);
    },
    calculatePrices: function calculatePrices() {
      // if(this.isBuyer == null) {
      //     let buyer = this.buyerById[this.buyerId];
      //     this.isBuyer = buyer  ? true : false;
      // }

      if (this.firmSetting && this.firmSetting.isRoundOff) {
        var basicPrice = (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.rate * this.item.quantity) - __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.tradeDiscount)).toFixed(2);
        this.item.basicPrice = Math.round(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(basicPrice));
        var GSTValue = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.basicPrice * (parseFloat(this.item.taxableGST_rate) / 100)).toFixed(2);
        this.item.GSTValue = Math.round(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(GSTValue));
        var totlePrice = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.basicPrice) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.GSTValue)).toFixed(2);
        this.item.totlePrice = Math.round(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(totlePrice));
      } else {
        this.item.basicPrice = (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.rate * this.item.quantity) - __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.tradeDiscount)).toFixed(2);
        this.item.GSTValue = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.basicPrice * (parseFloat(this.item.taxableGST_rate) / 100)).toFixed(2);
        this.item.totlePrice = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.basicPrice) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.GSTValue)).toFixed(2);
      }
    },
    save: function save(saveAndAdd) {
      var _this6 = this;

      // let buyer = this.buyerById[this.buyerId];
      // let isBuyer = buyer  ? true : false;
      // if(!this.isBuyer) {
      //   this.item.expiryDate = new Date(this.item.expiryDate).getTime(),
      //   this.item.manufacturingDate = new Date(this.item.manufacturingDate).getTime()
      // }
      var minQ = 0;
      if (this.offerList.length) {

        this.offerList.map(function (item) {
          if (item.minQuantity <= _this6.item.quantity && minQ < item.offerQuantity) {
            minQ = item.offerQuantity;
          }
        });
      }
      if (this.item.quantity > this.selectedProduct.quantity && this.isBuyer) {
        if (this.firmSetting && this.firmSetting.hideNegetiveStockAlert || confirm("stock can go in negative - do you want to proceed ?")) {
          if (!this.isEditItems || this.isEditItems && this.productChanged) {
            this.item.productName = this.selectedProduct.name;
            this.item.GST_type = this.selectedProduct.GST_type;
            this.item.productUnit = this.selectedProduct.unit;
            this.item.availableQuantity = this.selectedProduct.quantity;
          }
          if (minQ) {
            var clonedItem = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.item);
            clonedItem.quantity = minQ;
            clonedItem.basicPrice = 0;
            clonedItem.rate = 0;
            clonedItem.GSTValue = 0;
            clonedItem.totlePrice = 0;
            this.$emit('saveAddItem', clonedItem, false);
          }
          this.$emit('saveAddItem', this.item, saveAndAdd);
          this.reset();
        }
      } else {
        if (!this.isEditItems || this.isEditItems && this.productChanged) {
          this.item.productName = this.selectedProduct.name;
          this.item.GST_type = this.selectedProduct.GST_type;
          this.item.productUnit = this.selectedProduct.unit;
          this.item.availableQuantity = this.selectedProduct.quantity;
        }
        if (minQ) {
          var _clonedItem = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.item);
          _clonedItem.quantity = minQ;
          _clonedItem.basicPrice = 0;
          _clonedItem.rate = 0;
          _clonedItem.GSTValue = 0;
          _clonedItem.totlePrice = 0;
          this.$emit('saveAddItem', _clonedItem, false);
        }
        this.$emit('saveAddItem', this.item, saveAndAdd);
        this.reset();
      }
    },
    reset: function reset() {
      this.item = {
        productName: "",
        productId: "",
        HSN_code: "",
        taxableGST_rate: 0,
        rate: 0,
        unit: "",
        quantity: 0,
        basicPrice: 0,
        GSTValue: 0,
        GST_type: "",
        productUnit: '',
        totlePrice: 0,
        tradeDiscount: 0,
        productBrandName: "",
        color: "",
        size: "",
        drawerId: null
      };
      this.tradeDiscountPercentage = null;
      this.isTradePercentage = false;
    },
    calculateOpeningBalance: function calculateOpeningBalance() {
      this.currentProduct.openingBalance = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.currentProduct.basicPrice) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.currentProduct.gstValue);
    },
    scanItem: function scanItem() {
      this.scannerDialog = true;
      this.initQugga();
    },
    initQugga: function initQugga() {
      var selfVue = this;
      $(function () {
        var resultCollector = Quagga.ResultCollector.create({
          capture: true,
          capacity: 20,
          blacklist: [{
            code: "WIWV8ETQZ1", format: "code_93"
          }, {
            code: "EH3C-%GU23RK3", format: "code_93"
          }, {
            code: "O308SIHQOXN5SA/PJ", format: "code_93"
          }, {
            code: "DG7Q$TV8JQ/EN", format: "code_93"
          }, {
            code: "VOFD1DB5A.1F6QU", format: "code_93"
          }, {
            code: "4SO64P4X8 U4YUU1T-", format: "code_93"
          }],
          filter: function filter(codeResult) {
            // only store results which match this constraint
            // e.g.: codeResult
            return true;
          }
        });
        var App = {
          init: function init() {
            var self = this;

            Quagga.init(this.state, function (err) {
              if (err) {
                return self.handleError(err);
              }
              //Quagga.registerResultCollector(resultCollector);
              App.attachListeners();
              App.checkCapabilities();
              Quagga.start();
            });
          },
          handleError: function handleError(err) {
            console.log(err);
          },
          checkCapabilities: function checkCapabilities() {
            var track = Quagga.CameraAccess.getActiveTrack();
            var capabilities = {};
            if (typeof track.getCapabilities === 'function') {
              capabilities = track.getCapabilities();
            }
            this.applySettingsVisibility('zoom', capabilities.zoom);
            this.applySettingsVisibility('torch', capabilities.torch);
          },
          updateOptionsForMediaRange: function updateOptionsForMediaRange(node, range) {
            console.log('updateOptionsForMediaRange', node, range);
            var NUM_STEPS = 6;
            var stepSize = (range.max - range.min) / NUM_STEPS;
            var option;
            var value;
            while (node.firstChild) {
              node.removeChild(node.firstChild);
            }
            for (var i = 0; i <= NUM_STEPS; i++) {
              value = range.min + stepSize * i;
              option = document.createElement('option');
              option.value = value;
              option.innerHTML = value;
              node.appendChild(option);
            }
          },
          applySettingsVisibility: function applySettingsVisibility(setting, capability) {
            // depending on type of capability
            if (typeof capability === 'boolean') {
              var node = document.querySelector('input[name="settings_' + setting + '"]');
              if (node) {
                node.parentNode.style.display = capability ? 'block' : 'none';
              }
              return;
            }
            if (window.MediaSettingsRange && capability instanceof window.MediaSettingsRange) {
              var node = document.querySelector('select[name="settings_' + setting + '"]');
              if (node) {
                this.updateOptionsForMediaRange(node, capability);
                node.parentNode.style.display = 'block';
              }
              return;
            }
          },
          initCameraSelection: function initCameraSelection() {
            var streamLabel = Quagga.CameraAccess.getActiveStreamLabel();

            return Quagga.CameraAccess.enumerateVideoDevices().then(function (devices) {
              function pruneText(text) {
                return text.length > 30 ? text.substr(0, 30) : text;
              }
              var $deviceSelection = document.getElementById("deviceSelection");
              while ($deviceSelection.firstChild) {
                $deviceSelection.removeChild($deviceSelection.firstChild);
              }
              devices.forEach(function (device) {
                var $option = document.createElement("option");
                $option.value = device.deviceId || device.id;
                $option.appendChild(document.createTextNode(pruneText(device.label || device.deviceId || device.id)));
                $option.selected = streamLabel === device.label;
                $deviceSelection.appendChild($option);
              });
            });
          },
          attachListeners: function attachListeners() {
            var self = this;

            self.initCameraSelection();
            $(".controls").on("click", "button.stop", function (e) {
              e.preventDefault();
              Quagga.stop();
              self._printCollectedResults();
            });

            $(".controls .reader-config-group").on("change", "input, select", function (e) {
              e.preventDefault();
              var $target = $(e.target),
                  value = $target.attr("type") === "checkbox" ? $target.prop("checked") : $target.val(),
                  name = $target.attr("name"),
                  state = self._convertNameToState(name);

              console.log("Value of " + state + " changed to " + value);
              self.setState(state, value);
            });
          },
          _printCollectedResults: function _printCollectedResults() {
            var results = resultCollector.getResults(),
                $ul = $("#result_strip ul.collector");

            results.forEach(function (result) {
              var $li = $('<li><div class="thumbnail"><div class="imgWrapper"><img /></div><div class="caption"><h4 class="code"></h4></div></div></li>');

              $li.find("img").attr("src", result.frame);
              $li.find("h4.code").html(result.codeResult.code + " (" + result.codeResult.format + ")");
              $ul.prepend($li);
            });
          },
          _accessByPath: function _accessByPath(obj, path, val) {
            var parts = path.split('.'),
                depth = parts.length,
                setter = typeof val !== "undefined" ? true : false;

            return parts.reduce(function (o, key, i) {
              if (setter && i + 1 === depth) {
                if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(o[key]) === "object" && (typeof val === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(val)) === "object") {
                  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(o[key], val);
                } else {
                  o[key] = val;
                }
              }
              return key in o ? o[key] : {};
            }, obj);
          },
          _convertNameToState: function _convertNameToState(name) {
            return name.replace("_", ".").split("-").reduce(function (result, value) {
              return result + value.charAt(0).toUpperCase() + value.substring(1);
            });
          },
          detachListeners: function detachListeners() {
            $(".controls").off("click", "button.stop");
            $(".controls .reader-config-group").off("change", "input, select");
          },
          applySetting: function applySetting(setting, value) {
            var track = Quagga.CameraAccess.getActiveTrack();
            if (track && typeof track.getCapabilities === 'function') {
              switch (setting) {
                case 'zoom':
                  return track.applyConstraints({ advanced: [{ zoom: parseFloat(value) }] });
                case 'torch':
                  return track.applyConstraints({ advanced: [{ torch: !!value }] });
              }
            }
          },
          setState: function setState(path, value) {
            var self = this;

            if (typeof self._accessByPath(self.inputMapper, path) === "function") {
              value = self._accessByPath(self.inputMapper, path)(value);
            }

            if (path.startsWith('settings.')) {
              var setting = path.substring(9);
              return self.applySetting(setting, value);
            }
            self._accessByPath(self.state, path, value);

            console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.state));
            App.detachListeners();
            Quagga.stop();
            App.init();
          },
          inputMapper: {
            inputStream: {
              constraints: function constraints(value) {
                if (/^(\d+)x(\d+)$/.test(value)) {
                  var values = value.split('x');
                  return {
                    width: { min: parseInt(values[0]) },
                    height: { min: parseInt(values[1]) }
                  };
                }
                return {
                  deviceId: value
                };
              }
            },
            numOfWorkers: function numOfWorkers(value) {
              return parseInt(value);
            },
            decoder: {
              readers: function readers(value) {
                if (value === 'ean_extended') {
                  return [{
                    format: "ean_reader",
                    config: {
                      supplements: ['ean_5_reader', 'ean_2_reader']
                    }
                  }];
                }
                return [{
                  format: value + "_reader",
                  config: {}
                }];
              }
            }
          },
          state: {
            inputStream: {
              type: "LiveStream",
              constraints: {
                width: { min: 640 },
                height: { min: 480 },
                facingMode: "environment",
                aspectRatio: { min: 1, max: 2 }
              }
            },
            locator: {
              patchSize: "medium",
              halfSample: true
            },
            numOfWorkers: 2,
            frequency: 10,
            decoder: {
              readers: [{
                format: "ean_reader",
                config: {}
              }]
            },
            locate: true
          },
          lastResult: null
        };

        App.init();

        Quagga.onProcessed(function (result) {
          var drawingCtx = Quagga.canvas.ctx.overlay,
              drawingCanvas = Quagga.canvas.dom.overlay;

          if (result) {
            if (result.boxes) {
              drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute("width")), parseInt(drawingCanvas.getAttribute("height")));
              result.boxes.filter(function (box) {
                return box !== result.box;
              }).forEach(function (box) {
                Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, { color: "green", lineWidth: 2 });
              });
            }

            if (result.box) {
              Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, { color: "#00F", lineWidth: 2 });
            }

            if (result.codeResult && result.codeResult.code) {
              Quagga.ImageDebug.drawPath(result.line, { x: 'x', y: 'y' }, drawingCtx, { color: 'red', lineWidth: 3 });
            }
          }
        });

        Quagga.onDetected(function (result) {
          var code = result.codeResult.code;
          console.log(code);
          Quagga.stop();
          selfVue.addProductByBarcode(code);
          // if (App.lastResult !== code) {
          //     App.lastResult = code;
          //     var $node = null, canvas = Quagga.canvas.dom.image;

          //     $node = $('<li><div class="thumbnail"><div class="imgWrapper"><img /></div><div class="caption"><h4 class="code"></h4></div></div></li>');
          //     $node.find("img").attr("src", canvas.toDataURL());
          //     $node.find("h4.code").html(code);
          //     $("#result_strip ul.thumbnails").prepend($node);
          // }
        });
      });
    },
    addProductByBarcode: function addProductByBarcode(barcode) {
      var _this7 = this;

      var product = this.productsByBrand.filter(function (item) {
        return item.barcode == barcode;
      })[0];
      var productName = this.productsByBrand.filter(function (item) {
        return item.name == barcode;
      })[0];
      if (product) {
        clearInterval(this.timeoutSearch);
        this.productChange(product);
        this.item.quantity = 1;
        this.item.productName = product.name;
        this.scannerDialog = false;
        this.search = "";
        this.save(true);
      } else if (productName) {
        clearInterval(this.timeoutSearch);
      } else {
        this.timeoutSearch = setTimeout(function () {
          _this7.search = "";
        }, 2000);
      }
    }
  }
});

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddItemJewl_vue__ = __webpack_require__(496);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aeaf8f2c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddItemJewl_vue__ = __webpack_require__(1495);
function injectStyle (ssrContext) {
  __webpack_require__(1494)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddItemJewl_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aeaf8f2c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddItemJewl_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_barcodePrint__ = __webpack_require__(241);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isBuyer: Boolean,
    firmSetting: Object,
    buyer: Object,
    selectedFirm: String,
    isEditItems: Boolean,
    gstInvoice: Boolean,
    allItems: Array,
    invoiceDate: String,
    editedItem: {
      type: Object,
      default: function _default() {
        return {
          productName: "",
          productId: "",
          HSN_code: "",
          taxableGST_rate: 0,
          rate: 0,
          unit: "",
          quantity: 1,
          basicPrice: 0,
          GSTValue: 0,
          totlePrice: 0,
          GST_type: "",
          productUnit: '',
          tradeDiscount: 0,
          specialCharge: 0,
          purity: 100,
          purityRemark: '18K/75',
          lessStone: 0,
          netWeight: 0,
          unqId: null,
          unqIdKey: null,
          // tunch : '',
          brokerageRate: 0,
          drawerId: null
        };
      }
    },
    godawn: String
  },
  data: function data() {
    return {
      // isBuyer : null,
      productReportDialog: false,
      search: null,
      timeoutSearch: null,
      isTradePercentage: false,
      isSpecialChargePercentage: true,
      scannerDialog: false,
      //individualProdBrokerage : Boolean,
      tradeDiscountPercentage: null,
      specialChargePercentage: null,
      item: this.editedItem,
      products: [],
      availableProductUnit: this.units,
      selectedProduct: {},
      stepper: 1,
      isOpeningBalance: false,
      isStanderedPrice: false,
      addProductDialog: false,
      datepicker: false,
      snackbar: false,
      productChanged: false,
      duplicateError: null,
      timeout: 3000,
      uniqueId: null,
      GST_types: [{
        text: "Exempt",
        value: "EXEMPT"
      }, {
        text: "Nil Rated",
        value: "NILL"
      }, {
        text: "Taxable",
        value: "TAXABLE"
      }, {
        text: "Non-GST",
        value: "OTHER"
      }],
      currentProduct: {
        name: "",
        description: "",
        HSN_code: 0,
        GST_type: "",
        taxableGST_rate: 0,
        unit: "",
        quantity: 0,
        brand: "",
        openingDate: new Date().toISOString().substr(0, 10),
        purchasingPrice: null,
        sellingPrice: null,
        openingBalance: null,
        gstValue: 0,
        basicPrice: 0
      },
      availableProductUniqueIds: [],
      scanningBarcodeForUniqueId: false
    };
  },

  components: {
    ProductReports: function ProductReports() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 62));
    }
  },
  watch: {
    "godawn": {
      handler: function handler(newVal, oldVal) {
        if (!this.item.godawnBy) {
          this.item.godawnBy = newVal;
        }
      },

      deep: true
    },
    search: function search(val) {
      if (val.length > 9) {
        this.addProductByBarcode(val);
      }
    },

    "item.barcode": {
      handler: function handler(newVal, oldVal) {
        if (this.selectedProduct && newVal.length > 9) {
          if (this.isBuyer) {
            this.addUniqueIdByBarcode(newVal);
          }
        }
        JsBarcode("#barcode", this.item.barcode);
      },

      deep: true
    },
    editedItem: function editedItem(val) {
      var _this = this;

      this.item = this.editedItem;
      if (this.editedItem.productId) {
        this.selectedProduct = this.products.filter(function (item) {
          return item['.key'] == _this.editedItem.productId;
        })[0];
        this.availableProductUnit = this.units;
      }
    },

    "item.productId": {
      handler: function handler(newVal, oldVal) {
        if (!this.item.purity) {
          this.item.purity = 100;
          this.item.purityRemark = '18K/75';
        }
        this.item.lessStone = 0;
      },

      deep: true
    },
    "item.rate": {
      handler: function handler(newVal, oldVal) {
        this.calculatePrices();
      },

      deep: true
    },
    "item.tradeDiscount": {
      handler: function handler(newVal, oldVal) {
        this.calculatePrices();
      },

      deep: true
    },
    "item.specialCharge": {
      handler: function handler(newVal, oldVal) {
        this.calculatePrices();
      },

      deep: true
    },
    "item.quantity": {
      handler: function handler(newVal, oldVal) {
        this.calculatePrices();
      },

      deep: true
    },
    // "item.purityRemark": {
    //   handler(newVal, oldVal) {
    //     this.calculatePrices();
    //   },
    //   deep: true
    // },
    "item.grossWeight": {
      handler: function handler(newVal, oldVal) {
        this.calculatePrices();
      },

      deep: true
    },
    "item.purity": {
      handler: function handler(newVal, oldVal) {
        this.calculatePrices();
      },

      deep: true
    },
    "item.lessStone": {
      handler: function handler(newVal, oldVal) {
        this.calculatePrices();
      },

      deep: true
    },
    "item.unit": {
      handler: function handler(newVal, oldVal) {
        // this.productChange(this.selectedProduct);
        this.unitChange(newVal);
      },

      deep: true
    },
    "currentProduct.GST_type": {
      handler: function handler(newVal, oldVal) {
        if (newVal != "TAXABLE") {
          this.currentProduct.taxableGST_rate = 0;
        }
      },

      deep: true
    },
    "currentProduct.basicPrice": {
      handler: function handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.calculateOpeningBalance();
        }
      },

      deep: true
    },
    "currentProduct.gstValue": {
      handler: function handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.calculateOpeningBalance();
        }
      },

      deep: true
    }
  },
  created: function created() {
    // this.item.purity = 100;
    // this.item.lessStone = 0;
    // this.$bindAsObject(
    //   'buyerById',
    //   this.$root.$firebaseRefs.buyer
    // );
    this.$bindAsArray("productUniqueIds", this.$root.$firebaseRefs.productUniqueId.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("productDrawers", this.$root.$firebaseRefs.productDrawer.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("godawns", this.$root.$firebaseRefs.godawn.orderByChild('brand').equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear"]), mapGlobalGetters({ units: "productUnit" }), {
    productsByBrand: function productsByBrand() {
      var _this2 = this;

      return this.products.filter(function (item) {
        return item["brand"] === _this2.selectedBrand && (!_this2.gstInvoice ? item.GST_type != 'TAXABLE' : true) && (!!item.firm && _this2.selectedFirm ? item.firm == _this2.selectedFirm : false) && (item.isActive == undefined ? true : item.isActive);
      }
      // && (item.openingDate ? (item.openingDate >= this.finYear.start) && (item.openingDate <= this.finYear.end) : true))
      );
    },
    currentProdDrawers: function currentProdDrawers() {
      var _this3 = this;

      if (this.selectedProduct) {
        return this.productDrawers.filter(function (item) {
          return !!item.items.find(function (i) {
            return i.product == _this3.selectedProduct['.key'];
          });
        }).map(function (i) {
          return { text: i.name, value: i['.key'] };
        });
      }
      return [];
    },
    offerList: function offerList() {
      var offerItems = [];
      var date = new Date(this.invoiceDate).getTime();
      if (this.selectedProduct && this.selectedProduct.offers) {
        offerItems = this.selectedProduct.offers.filter(function (item) {
          return item.startDate <= date && item.endDate >= date;
        });
      }
      return offerItems;
    },
    godawnByBrand: function godawnByBrand() {
      var _this4 = this;

      return this.godawns.filter(function (item) {
        return item["brand"] === _this4.selectedBrand;
      }).map(function (item) {
        return {
          text: item["godawnName"],
          value: item[".key"]
        };
      });
    },
    getHeaders: function getHeaders() {
      if (this.gstInvoice) {
        return [{ text: "Name", sortable: false, value: "productName", class: "font-weight-bold primary--text" },
        // { text: "Taxable Rate", sortable: false, value: "rate", class: "font-weight-bold primary--text" },
        { text: "Unit", sortable: false, value: "unit", class: "font-weight-bold primary--text" }, { text: "Rate", sortable: false, value: "rate", class: "font-weight-bold primary--text" }, { text: "Quantity", sortable: false, value: "quantity", class: "font-weight-bold primary--text" }, { text: "Basic Price", sortable: false, value: "basicPrice", class: "font-weight-bold primary--text" }, { text: "GST value", sortable: false, value: "GSTValue", class: "font-weight-bold primary--text" }, { text: "Trade Discount", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" }, { text: "Special Charge", sortable: false, value: "specialCharge", class: "font-weight-bold primary--text" }, { text: "Total Price", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" },
        // { text: "CGST ", sortable: false, value: "CGST", class: "font-weight-bold primary--text" },
        // { text: "SGST ", sortable: false, value: "SGST", class: "font-weight-bold primary--text" },
        // { text: "IGST ", sortable: false, value: "IGST", class: "font-weight-bold primary--text" },
        { text: "Action ", sortable: false, value: "action", class: "font-weight-bold primary--text" }, { text: "", value: "name", sortable: false }];
      } else {
        return [{ text: "Name", sortable: false, value: "productName", class: "font-weight-bold primary--text" }, { text: "Rate", sortable: false, value: "rate", class: "font-weight-bold primary--text" }, { text: "Unit", sortable: false, value: "unit", class: "font-weight-bold primary--text" }, { text: "Quantity", sortable: false, value: "quantity", class: "font-weight-bold primary--text" }, { text: "Basic Price", sortable: false, value: "basicPrice", class: "font-weight-bold primary--text" }, { text: "Trade Discount", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" }, { text: "Special Charge", sortable: false, value: "specialCharge", class: "font-weight-bold primary--text" }, { text: "Total Price", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" }, { text: "Action ", sortable: false, value: "action", class: "font-weight-bold primary--text" }, { text: "", value: "name", sortable: false }];
      }
    },
    formTitle: function formTitle() {
      return this.editedIndex === -1 ? "Edit Jewellery item" : "New Jewellery item";
    }
  }),

  methods: {
    openProductReport: function openProductReport() {
      this.productReportDialog = true;
    },
    close: function close() {
      this.$emit("closeAddItem", false);
      this.reset();
    },
    printBarcode: function printBarcode() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_8__utils_barcodePrint__["a" /* barcodePrintPDF */])({});

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this5);
      }))();
    },
    generateBarcode: function generateBarcode() {
      this.item.barcode = new Date().getTime() + "";
      this.item = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, this.item);
    },
    setUniqueId: function setUniqueId() {
      this.item.unqId = this.uniqueId['unqId'];
      this.item.purity = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.uniqueId['purity']);
      this.item.lessStone = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.uniqueId['lessStone']);
      this.item.grossWeight = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.uniqueId['grossWeight']);
      this.item.unqIdKey = this.uniqueId['.key'];
      this.calculatePrices();
    },
    editItem: function editItem(item) {
      this.reset();
      this.$emit("editItem", item, true);
    },
    deleteItem: function deleteItem(item) {
      this.reset();
      this.$emit("deleteItem", item);
    },
    productChange: function productChange(val) {
      this.selectedProduct = val;
      // let buyer = this.buyerById[this.buyerId];
      // let isBuyer = buyer  ? true : false;
      this.item.productId = val[".key"];
      this.item.HSN_code = val["HSN_code"];
      this.item.taxableGST_rate = val["taxableGST_rate"];
      this.item.unit = val["unit"];
      // if(this.selectedProduct.unit == this.item.unit) {
      //   this.item.rate = this.isBuyer ? val["sellingPrice"] : val["purchasingPrice"]
      // }
      this.productChanged = true;
      if (this.selectedProduct.unitsDeatilsAdded) {
        this.availableProductUnit = this.selectedProduct.unitsDetails.map(function (prod) {
          return prod.unit;
        });
      } else {
        if (this.selectedProduct.unit == this.item.unit) {
          this.item.rate = this.isBuyer ? val["sellingPrice"] : val["purchasingPrice"];
        }
        if (this.isBuyer && this.buyer.category && this.selectedProduct.sellingPriceByCategories && this.selectedProduct.sellingPriceByCategories[this.buyer.category]) {
          this.item.rate = this.selectedProduct.sellingPriceByCategories[this.buyer.category];
        }
        this.availableProductUnit = this.units;
      }
      if (val.isSpecialChargePercentage && val.specialChargePercentage) {
        this.specialChargePercentage = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(val.specialChargePercentage);
        this.isSpecialChargePercentage = true;
        this.calculateSpecialCharge();
      } else if (val.specialCharge) {
        this.item.specialCharge = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(val.specialCharge);
      }
      this.productChanged = true;
      this.availableProductUniqueIds = this.productUniqueIds.filter(function (item) {
        return item['product'] == val[".key"] && !item['sold'];
      });
      setTimeout(function () {
        document.querySelector(".barcode-selector input").click();
      }, 1000);
      this.scanningBarcodeForUniqueId = true;
    },
    unitChange: function unitChange(selectedUnit) {
      var _this6 = this;

      if (this.selectedProduct.unitsDeatilsAdded) {
        this.selectedProduct.unitsDetails.map(function (prod) {
          if (prod['unit'] == selectedUnit) {
            var rate = _this6.isBuyer ? prod["sellingPrice"] : prod["purchasingPrice"];
            if (rate) {
              _this6.item.rate = rate;
            }
          }
        });
      }
    },
    calculateTradeDiscount: function calculateTradeDiscount() {
      this.item.tradeDiscount = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.tradeDiscountPercentage * __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.rate) * this.item.quantity / 100).toFixed(2);
    },
    calculateSpecialCharge: function calculateSpecialCharge() {
      //this.item.specialCharge = Number.parseFloat((this.specialChargePercentage * Number.parseFloat(this.item.rate) * this.item.quantity * this.item.netWeight)/100).toFixed(2);
      if (this.isSpecialChargePercentage) {
        this.item.specialCharge = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.specialChargePercentage * __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.rate) * this.item.quantity * this.item.netWeight / 100).toFixed(2);
      }
    },
    calculatePrices: function calculatePrices() {
      // if(this.isBuyer == null) {
      //     let buyer = this.buyerById[this.buyerId];
      //     this.isBuyer = buyer  ? true : false;
      // }
      this.item.netWeight = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.grossWeight * this.item.purity / 100) - __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.lessStone)).toFixed(3);
      if (this.firmSetting && this.firmSetting.isRoundOff) {
        console.log("round");
        var basicPrice = (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.rate * this.item.netWeight * this.item.quantity * (this.item.purity / 100)) - __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.tradeDiscount) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.specialCharge)).toFixed(2);
        this.item.basicPrice = Math.round(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(basicPrice));
        var GSTValue = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.basicPrice * (parseFloat(this.item.taxableGST_rate) / 100)).toFixed(2);
        this.item.GSTValue = Math.round(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(GSTValue));
        var totlePrice = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.basicPrice) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.GSTValue)).toFixed(2);
        this.item.totlePrice = Math.round(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(totlePrice));
      } else {
        this.item.basicPrice = (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.rate * this.item.netWeight * this.item.quantity * (this.item.purity / 100)) - __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.tradeDiscount) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.specialCharge)).toFixed(2);
        this.item.GSTValue = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.basicPrice * (parseFloat(this.item.taxableGST_rate) / 100)).toFixed(2);
        this.item.totlePrice = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.basicPrice) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.GSTValue)).toFixed(2);
      }
      this.calculateSpecialCharge();
      this.calculateTradeDiscount();
    },
    save: function save(saveAndAdd) {
      var _this7 = this;

      // let buyer = this.buyerById[this.buyerId];
      // let isBuyer = buyer  ? true : false;
      // if(!this.isBuyer) {
      //   this.item.expiryDate = new Date(this.item.expiryDate).getTime(),
      //   this.item.manufacturingDate = new Date(this.item.manufacturingDate).getTime()
      // }
      var minQ = 0;
      if (this.offerList.length) {

        this.offerList.map(function (item) {
          if (item.minQuantity <= _this7.item.quantity && minQ < item.offerQuantity) {
            minQ = item.offerQuantity;
          }
        });
      }
      if (this.item.quantity > this.selectedProduct.quantity && this.isBuyer) {
        if (this.firmSetting && this.firmSetting.hideNegetiveStockAlert || confirm("stock can go in negative - do you want to proceed ?")) {
          if (!this.isEditItems || this.isEditItems && this.productChanged) {
            this.item.productName = this.selectedProduct.name;
            this.item.GST_type = this.selectedProduct.GST_type;
            this.item.productUnit = this.selectedProduct.unit;
            this.item.availableQuantity = this.selectedProduct.quantity;
          }
          if (minQ) {
            var clonedItem = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, this.item);
            clonedItem.quantity = minQ;
            clonedItem.basicPrice = 0;
            clonedItem.rate = 0;
            clonedItem.GSTValue = 0;
            clonedItem.totlePrice = 0;
            this.$emit('saveAddItem', clonedItem, false);
          }
          this.$emit('saveAddItem', this.item, saveAndAdd);
          this.reset();
        }
      } else {
        if (!this.isEditItems || this.isEditItems && this.productChanged) {
          this.item.productName = this.selectedProduct.name;
          this.item.GST_type = this.selectedProduct.GST_type;
          this.item.productUnit = this.selectedProduct.unit;
          this.item.availableQuantity = this.selectedProduct.quantity;
        }
        if (minQ) {
          var _clonedItem = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, this.item);
          _clonedItem.quantity = minQ;
          _clonedItem.basicPrice = 0;
          _clonedItem.rate = 0;
          _clonedItem.GSTValue = 0;
          _clonedItem.totlePrice = 0;
          this.$emit('saveAddItem', _clonedItem, false);
        }
        this.$emit('saveAddItem', this.item, saveAndAdd);
        this.reset();
      }
    },
    reset: function reset() {
      this.item = {
        productName: "",
        productId: "",
        HSN_code: "",
        taxableGST_rate: 0,
        rate: 0,
        unit: "",
        quantity: 0,
        basicPrice: 0,
        GSTValue: 0,
        GST_type: "",
        productUnit: '',
        totlePrice: 0,
        tradeDiscount: 0,
        specialCharge: 0,
        grossWeight: 0,
        purity: 100,
        purityRemark: '18K/75',
        netWeight: 0,
        lessStone: 0,
        drawerId: null
        // tunch : ''
      };
      this.tradeDiscountPercentage = null;
      this.isTradePercentage = false;
      this.specialChargePercentage = null;
      this.isSpecialChargePercentage = false;
    },
    calculateOpeningBalance: function calculateOpeningBalance() {
      this.currentProduct.openingBalance = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.currentProduct.basicPrice) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.currentProduct.gstValue);
    },
    scanItem: function scanItem() {
      this.scannerDialog = true;
      this.initQugga();
    },
    initQugga: function initQugga() {
      var selfVue = this;
      $(function () {
        var resultCollector = Quagga.ResultCollector.create({
          capture: true,
          capacity: 20,
          blacklist: [{
            code: "WIWV8ETQZ1", format: "code_93"
          }, {
            code: "EH3C-%GU23RK3", format: "code_93"
          }, {
            code: "O308SIHQOXN5SA/PJ", format: "code_93"
          }, {
            code: "DG7Q$TV8JQ/EN", format: "code_93"
          }, {
            code: "VOFD1DB5A.1F6QU", format: "code_93"
          }, {
            code: "4SO64P4X8 U4YUU1T-", format: "code_93"
          }],
          filter: function filter(codeResult) {
            // only store results which match this constraint
            // e.g.: codeResult
            return true;
          }
        });
        var App = {
          init: function init() {
            var self = this;

            Quagga.init(this.state, function (err) {
              if (err) {
                return self.handleError(err);
              }
              //Quagga.registerResultCollector(resultCollector);
              App.attachListeners();
              App.checkCapabilities();
              Quagga.start();
            });
          },
          handleError: function handleError(err) {
            console.log(err);
          },
          checkCapabilities: function checkCapabilities() {
            var track = Quagga.CameraAccess.getActiveTrack();
            var capabilities = {};
            if (typeof track.getCapabilities === 'function') {
              capabilities = track.getCapabilities();
            }
            this.applySettingsVisibility('zoom', capabilities.zoom);
            this.applySettingsVisibility('torch', capabilities.torch);
          },
          updateOptionsForMediaRange: function updateOptionsForMediaRange(node, range) {
            console.log('updateOptionsForMediaRange', node, range);
            var NUM_STEPS = 6;
            var stepSize = (range.max - range.min) / NUM_STEPS;
            var option;
            var value;
            while (node.firstChild) {
              node.removeChild(node.firstChild);
            }
            for (var i = 0; i <= NUM_STEPS; i++) {
              value = range.min + stepSize * i;
              option = document.createElement('option');
              option.value = value;
              option.innerHTML = value;
              node.appendChild(option);
            }
          },
          applySettingsVisibility: function applySettingsVisibility(setting, capability) {
            // depending on type of capability
            if (typeof capability === 'boolean') {
              var node = document.querySelector('input[name="settings_' + setting + '"]');
              if (node) {
                node.parentNode.style.display = capability ? 'block' : 'none';
              }
              return;
            }
            if (window.MediaSettingsRange && capability instanceof window.MediaSettingsRange) {
              var node = document.querySelector('select[name="settings_' + setting + '"]');
              if (node) {
                this.updateOptionsForMediaRange(node, capability);
                node.parentNode.style.display = 'block';
              }
              return;
            }
          },
          initCameraSelection: function initCameraSelection() {
            var streamLabel = Quagga.CameraAccess.getActiveStreamLabel();

            return Quagga.CameraAccess.enumerateVideoDevices().then(function (devices) {
              function pruneText(text) {
                return text.length > 30 ? text.substr(0, 30) : text;
              }
              var $deviceSelection = document.getElementById("deviceSelection");
              while ($deviceSelection.firstChild) {
                $deviceSelection.removeChild($deviceSelection.firstChild);
              }
              devices.forEach(function (device) {
                var $option = document.createElement("option");
                $option.value = device.deviceId || device.id;
                $option.appendChild(document.createTextNode(pruneText(device.label || device.deviceId || device.id)));
                $option.selected = streamLabel === device.label;
                $deviceSelection.appendChild($option);
              });
            });
          },
          attachListeners: function attachListeners() {
            var self = this;

            self.initCameraSelection();
            $(".controls").on("click", "button.stop", function (e) {
              e.preventDefault();
              Quagga.stop();
              self._printCollectedResults();
            });

            $(".controls .reader-config-group").on("change", "input, select", function (e) {
              e.preventDefault();
              var $target = $(e.target),
                  value = $target.attr("type") === "checkbox" ? $target.prop("checked") : $target.val(),
                  name = $target.attr("name"),
                  state = self._convertNameToState(name);

              console.log("Value of " + state + " changed to " + value);
              self.setState(state, value);
            });
          },
          _printCollectedResults: function _printCollectedResults() {
            var results = resultCollector.getResults(),
                $ul = $("#result_strip ul.collector");

            results.forEach(function (result) {
              var $li = $('<li><div class="thumbnail"><div class="imgWrapper"><img /></div><div class="caption"><h4 class="code"></h4></div></div></li>');

              $li.find("img").attr("src", result.frame);
              $li.find("h4.code").html(result.codeResult.code + " (" + result.codeResult.format + ")");
              $ul.prepend($li);
            });
          },
          _accessByPath: function _accessByPath(obj, path, val) {
            var parts = path.split('.'),
                depth = parts.length,
                setter = typeof val !== "undefined" ? true : false;

            return parts.reduce(function (o, key, i) {
              if (setter && i + 1 === depth) {
                if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(o[key]) === "object" && (typeof val === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(val)) === "object") {
                  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(o[key], val);
                } else {
                  o[key] = val;
                }
              }
              return key in o ? o[key] : {};
            }, obj);
          },
          _convertNameToState: function _convertNameToState(name) {
            return name.replace("_", ".").split("-").reduce(function (result, value) {
              return result + value.charAt(0).toUpperCase() + value.substring(1);
            });
          },
          detachListeners: function detachListeners() {
            $(".controls").off("click", "button.stop");
            $(".controls .reader-config-group").off("change", "input, select");
          },
          applySetting: function applySetting(setting, value) {
            var track = Quagga.CameraAccess.getActiveTrack();
            if (track && typeof track.getCapabilities === 'function') {
              switch (setting) {
                case 'zoom':
                  return track.applyConstraints({ advanced: [{ zoom: parseFloat(value) }] });
                case 'torch':
                  return track.applyConstraints({ advanced: [{ torch: !!value }] });
              }
            }
          },
          setState: function setState(path, value) {
            var self = this;

            if (typeof self._accessByPath(self.inputMapper, path) === "function") {
              value = self._accessByPath(self.inputMapper, path)(value);
            }

            if (path.startsWith('settings.')) {
              var setting = path.substring(9);
              return self.applySetting(setting, value);
            }
            self._accessByPath(self.state, path, value);

            console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.state));
            App.detachListeners();
            Quagga.stop();
            App.init();
          },
          inputMapper: {
            inputStream: {
              constraints: function constraints(value) {
                if (/^(\d+)x(\d+)$/.test(value)) {
                  var values = value.split('x');
                  return {
                    width: { min: parseInt(values[0]) },
                    height: { min: parseInt(values[1]) }
                  };
                }
                return {
                  deviceId: value
                };
              }
            },
            numOfWorkers: function numOfWorkers(value) {
              return parseInt(value);
            },
            decoder: {
              readers: function readers(value) {
                if (value === 'ean_extended') {
                  return [{
                    format: "ean_reader",
                    config: {
                      supplements: ['ean_5_reader', 'ean_2_reader']
                    }
                  }];
                }
                return [{
                  format: value + "_reader",
                  config: {}
                }];
              }
            }
          },
          state: {
            inputStream: {
              type: "LiveStream",
              constraints: {
                width: { min: 640 },
                height: { min: 480 },
                facingMode: "environment",
                aspectRatio: { min: 1, max: 2 }
              }
            },
            locator: {
              patchSize: "medium",
              halfSample: true
            },
            numOfWorkers: 2,
            frequency: 10,
            decoder: {
              readers: [{
                format: "ean_reader",
                config: {}
              }]
            },
            locate: true
          },
          lastResult: null
        };

        App.init();

        Quagga.onProcessed(function (result) {
          var drawingCtx = Quagga.canvas.ctx.overlay,
              drawingCanvas = Quagga.canvas.dom.overlay;

          if (result) {
            if (result.boxes) {
              drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute("width")), parseInt(drawingCanvas.getAttribute("height")));
              result.boxes.filter(function (box) {
                return box !== result.box;
              }).forEach(function (box) {
                Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, { color: "green", lineWidth: 2 });
              });
            }

            if (result.box) {
              Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, { color: "#00F", lineWidth: 2 });
            }

            if (result.codeResult && result.codeResult.code) {
              Quagga.ImageDebug.drawPath(result.line, { x: 'x', y: 'y' }, drawingCtx, { color: 'red', lineWidth: 3 });
            }
          }
        });

        Quagga.onDetected(function (result) {
          var code = result.codeResult.code;
          console.log(code);
          Quagga.stop();
          selfVue.addProductByBarcode(code);
          // if (App.lastResult !== code) {
          //     App.lastResult = code;
          //     var $node = null, canvas = Quagga.canvas.dom.image;

          //     $node = $('<li><div class="thumbnail"><div class="imgWrapper"><img /></div><div class="caption"><h4 class="code"></h4></div></div></li>');
          //     $node.find("img").attr("src", canvas.toDataURL());
          //     $node.find("h4.code").html(code);
          //     $("#result_strip ul.thumbnails").prepend($node);
          // }
        });
      });
    },
    addProductByBarcode: function addProductByBarcode(barcode) {
      var _this8 = this;

      var product = this.productsByBrand.filter(function (item) {
        return item.barcode == barcode;
      })[0];
      var productName = this.productsByBrand.filter(function (item) {
        return item.name == barcode;
      })[0];
      if (product) {
        clearInterval(this.timeoutSearch);
        this.productChange(product);
        this.item.quantity = 1;
        this.item.productName = product.name;
        this.scannerDialog = false;
        this.search = "";
        // this.save(true)
      } else if (productName) {
        clearInterval(this.timeoutSearch);
      } else {
        this.timeoutSearch = setTimeout(function () {
          _this8.search = "";
        }, 2000);
      }
    },
    addUniqueIdByBarcode: function addUniqueIdByBarcode(barcode) {
      var _this9 = this;

      var uniqId = this.availableProductUniqueIds.find(function (item) {
        return item.barcode == barcode;
      });
      if (uniqId) {
        this.uniqueId = uniqId;
      }
      setTimeout(function () {
        _this9.scanningBarcodeForUniqueId = false;
      }, 1000);
    }
  }
});

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddItemGrain_vue__ = __webpack_require__(498);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d23b71a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddItemGrain_vue__ = __webpack_require__(1497);
function injectStyle (ssrContext) {
  __webpack_require__(1496)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddItemGrain_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d23b71a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddItemGrain_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_body_parser__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_body_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_body_parser__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    isBuyer: Boolean,
    firmSetting: Object,
    buyer: Object,
    selectedFirm: String,
    isEditItems: Boolean,
    gstInvoice: Boolean,
    allItems: Array,
    invoiceDate: String,
    editedItem: {
      type: Object,
      default: function _default() {
        return {
          productName: "",
          productId: "",
          HSN_code: "",
          taxableGST_rate: 0,
          rate: 0,
          unit: "",
          quantity: 1,
          basicPrice: 0,
          GSTValue: 0,
          totlePrice: 0,
          GST_type: "",
          productUnit: '',
          tradeDiscount: 0,
          specialCharge: 0,
          purity: 100,
          netWeight: 0,
          // tunch : '',
          brokerageRate: 0,
          drawerId: null
        };
      }
    },
    godawn: String
  },
  data: function data() {
    return {
      // isBuyer : null,
      productReportDialog: false,
      search: null,
      timeoutSearch: null,
      isTradePercentage: false,
      isSpecialChargePercentage: false,
      scannerDialog: false,
      // individualProdBrokerage : Boolean,
      tradeDiscountPercentage: null,
      specialChargePercentage: null,
      item: this.editedItem,
      products: [],
      availableProductUnit: this.units,
      selectedProduct: {},
      stepper: 1,
      isOpeningBalance: false,
      isStanderedPrice: false,
      addProductDialog: false,
      datepicker: false,
      snackbar: false,
      productChanged: false,
      duplicateError: null,
      timeout: 3000,
      GST_types: [{
        text: "Exempt",
        value: "EXEMPT"
      }, {
        text: "Nil Rated",
        value: "NILL"
      }, {
        text: "Taxable",
        value: "TAXABLE"
      }, {
        text: "Non-GST",
        value: "OTHER"
      }],
      currentProduct: {
        name: "",
        description: "",
        HSN_code: 0,
        GST_type: "",
        taxableGST_rate: 0,
        unit: "",
        quantity: 0,
        brand: "",
        openingDate: new Date().toISOString().substr(0, 10),
        purchasingPrice: null,
        sellingPrice: null,
        openingBalance: null,
        gstValue: 0,
        basicPrice: 0
      }
    };
  },

  components: {
    ProductReports: function ProductReports() {
      return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 62));
    }
  },
  watch: {
    "godawn": {
      handler: function handler(newVal, oldVal) {
        if (!this.item.godawnBy) {
          this.item.godawnBy = newVal;
        }
      },

      deep: true
    },
    "item.productId": {
      handler: function handler(newVal, oldVal) {
        this.item.purity = 100;
      },

      deep: true
    },
    search: function search(val) {
      if (val.length > 9) {
        this.addProductByBarcode(val);
      }
    },
    editedItem: function editedItem(val) {
      var _this = this;

      this.item = this.editedItem;
      if (this.editedItem.productId) {
        this.selectedProduct = this.products.filter(function (item) {
          return item['.key'] == _this.editedItem.productId;
        })[0];
        this.availableProductUnit = this.units;
      }
    },

    "item.rate": {
      handler: function handler(newVal, oldVal) {
        this.calculatePrices();
      },

      deep: true
    },
    "item.tradeDiscount": {
      handler: function handler(newVal, oldVal) {
        this.calculatePrices();
      },

      deep: true
    },
    "item.specialCharge": {
      handler: function handler(newVal, oldVal) {
        this.calculatePrices();
      },

      deep: true
    },
    "item.quantity": {
      handler: function handler(newVal, oldVal) {
        this.calculatePrices();
      },

      deep: true
    },
    "item.grossWeight": {
      handler: function handler(newVal, oldVal) {
        this.calculatePrices();
      },

      deep: true
    },
    "item.purity": {
      handler: function handler(newVal, oldVal) {
        this.calculatePrices();
      },

      deep: true
    },
    "item.unit": {
      handler: function handler(newVal, oldVal) {
        // this.productChange(this.selectedProduct);
        this.unitChange(newVal);
      },

      deep: true
    },
    "currentProduct.GST_type": {
      handler: function handler(newVal, oldVal) {
        if (newVal != "TAXABLE") {
          this.currentProduct.taxableGST_rate = 0;
        }
      },

      deep: true
    },
    "currentProduct.basicPrice": {
      handler: function handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.calculateOpeningBalance();
        }
      },

      deep: true
    },
    "currentProduct.gstValue": {
      handler: function handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.calculateOpeningBalance();
        }
      },

      deep: true
    }
  },
  created: function created() {
    //this.item.purity = 100;
    this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand));
    // this.$bindAsObject(
    //   'buyerById',
    //   this.$root.$firebaseRefs.buyer
    // );
    this.$bindAsArray("godawns", this.$root.$firebaseRefs.godawn.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("productDrawers", this.$root.$firebaseRefs.productDrawer.orderByChild("brand").equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear"]), mapGlobalGetters({ units: "productUnit" }), {
    currentProdDrawers: function currentProdDrawers() {
      var _this2 = this;

      if (this.selectedProduct) {
        return this.productDrawers.filter(function (item) {
          return !!item.items.find(function (i) {
            return i.product == _this2.selectedProduct['.key'];
          });
        }).map(function (i) {
          return { text: i.name, value: i['.key'] };
        });
      }
      return [];
    },
    productsByBrand: function productsByBrand() {
      var _this3 = this;

      return this.products.filter(function (item) {
        return item["brand"] === _this3.selectedBrand && (!_this3.gstInvoice ? item.GST_type != 'TAXABLE' : true) && (!!item.firm && _this3.selectedFirm ? item.firm == _this3.selectedFirm : false) && (item.isActive == undefined ? true : item.isActive);
      }
      // && (item.openingDate ? (item.openingDate >= this.finYear.start) && (item.openingDate <= this.finYear.end) : true))
      );
    },
    offerList: function offerList() {
      var offerItems = [];
      var date = new Date(this.invoiceDate).getTime();
      if (this.selectedProduct && this.selectedProduct.offers) {
        offerItems = this.selectedProduct.offers.filter(function (item) {
          return item.startDate <= date && item.endDate >= date;
        });
      }
      return offerItems;
    },
    godawnByBrand: function godawnByBrand() {
      var _this4 = this;

      return this.godawns.filter(function (item) {
        return item["brand"] === _this4.selectedBrand;
      }).map(function (item) {
        return {
          text: item["godawnName"],
          value: item[".key"]
        };
      });
    },
    getHeaders: function getHeaders() {
      if (this.gstInvoice) {
        return [{ text: "Name", sortable: false, value: "productName", class: "font-weight-bold primary--text" },
        // { text: "Taxable Rate", sortable: false, value: "rate", class: "font-weight-bold primary--text" },
        { text: "Unit", sortable: false, value: "unit", class: "font-weight-bold primary--text" }, { text: "Rate", sortable: false, value: "rate", class: "font-weight-bold primary--text" }, { text: "Quantity", sortable: false, value: "quantity", class: "font-weight-bold primary--text" }, { text: "Basic Price", sortable: false, value: "basicPrice", class: "font-weight-bold primary--text" }, { text: "GST value", sortable: false, value: "GSTValue", class: "font-weight-bold primary--text" }, { text: "Special Charge", sortable: false, value: "specialCharge", class: "font-weight-bold primary--text" }, { text: "Trade Discount", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" }, { text: "Total Price", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" },
        // { text: "CGST ", sortable: false, value: "CGST", class: "font-weight-bold primary--text" },
        // { text: "SGST ", sortable: false, value: "SGST", class: "font-weight-bold primary--text" },
        // { text: "IGST ", sortable: false, value: "IGST", class: "font-weight-bold primary--text" },
        { text: "Action ", sortable: false, value: "action", class: "font-weight-bold primary--text" }, { text: "", value: "name", sortable: false }];
      } else {
        return [{ text: "Name", sortable: false, value: "productName", class: "font-weight-bold primary--text" }, { text: "Rate", sortable: false, value: "rate", class: "font-weight-bold primary--text" }, { text: "Unit", sortable: false, value: "unit", class: "font-weight-bold primary--text" }, { text: "Quantity", sortable: false, value: "quantity", class: "font-weight-bold primary--text" }, { text: "Basic Price", sortable: false, value: "basicPrice", class: "font-weight-bold primary--text" }, { text: "Special Charge", sortable: false, value: "specialCharge", class: "font-weight-bold primary--text" }, { text: "Trade Discount", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" }, { text: "Total Price", sortable: false, value: "totlePrice", class: "font-weight-bold primary--text" }, { text: "Action ", sortable: false, value: "action", class: "font-weight-bold primary--text" }, { text: "", value: "name", sortable: false }];
      }
    },
    formTitle: function formTitle() {
      return this.editedIndex === -1 ? "Edit Grain item" : "New Grain item";
    }
  }),

  methods: {
    openProductReport: function openProductReport() {
      this.productReportDialog = true;
    },
    close: function close() {
      this.$emit("closeAddItem", false);
      this.reset();
    },
    editItem: function editItem(item) {
      this.reset();
      this.$emit("editItem", item, true);
    },
    deleteItem: function deleteItem(item) {
      this.reset();
      this.$emit("deleteItem", item);
    },
    productChange: function productChange(val) {
      this.selectedProduct = val;
      // let buyer = this.buyerById[this.buyerId];
      // let isBuyer = buyer  ? true : false;
      this.item.productId = val[".key"];
      this.item.HSN_code = val["HSN_code"];
      this.item.taxableGST_rate = val["taxableGST_rate"];
      this.item.unit = val["unit"];
      // if(this.selectedProduct.unit == this.item.unit) {
      //   this.item.rate = this.isBuyer ? val["sellingPrice"] : val["purchasingPrice"]
      // }
      this.productChanged = true;
      if (this.selectedProduct.unitsDeatilsAdded) {
        this.availableProductUnit = this.selectedProduct.unitsDetails.map(function (prod) {
          return prod.unit;
        });
      } else {
        if (this.selectedProduct.unit == this.item.unit) {
          this.item.rate = this.isBuyer ? val["sellingPrice"] : val["purchasingPrice"];
        }
        if (this.isBuyer && this.buyer.category && this.selectedProduct.sellingPriceByCategories && this.selectedProduct.sellingPriceByCategories[this.buyer.category]) {
          this.item.rate = this.selectedProduct.sellingPriceByCategories[this.buyer.category];
        }
        this.availableProductUnit = this.units;
      }
      if (val.isSpecialChargePercentage && val.specialChargePercentage) {
        this.specialChargePercentage = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(val.specialChargePercentage);
        this.isSpecialChargePercentage = true;
        this.calculateSpecialCharge();
      } else if (val.specialCharge) {
        this.item.specialCharge = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(val.specialCharge);
      }
      this.productChanged = true;
    },
    unitChange: function unitChange(selectedUnit) {
      var _this5 = this;

      if (this.selectedProduct.unitsDeatilsAdded) {
        this.selectedProduct.unitsDetails.map(function (prod) {
          if (prod['unit'] == selectedUnit) {
            var rate = _this5.isBuyer ? prod["sellingPrice"] : prod["purchasingPrice"];
            if (rate) {
              _this5.item.rate = rate;
            }
          }
        });
      }
    },
    calculateTradeDiscount: function calculateTradeDiscount() {
      this.item.tradeDiscount = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.tradeDiscountPercentage * this.item.rate * this.item.quantity / 100).toFixed(2);
    },
    calculateSpecialCharge: function calculateSpecialCharge() {
      if (this.isSpecialChargePercentage) {
        this.item.specialCharge = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.specialChargePercentage * this.item.rate * this.item.quantity * this.item.netWeight / 100).toFixed(2);
      }
    },
    calculatePrices: function calculatePrices() {
      // if(this.isBuyer == null) {
      //     let buyer = this.buyerById[this.buyerId];
      //     this.isBuyer = buyer  ? true : false;
      // }
      // this.item.netWeight = ((this.item.quantity  * this.item.purity )/100)
      // this.item.netWeight = Number.parseFloat((this.item.quantity  * this.item.purity )/100).toFixed(2) 
      this.item.netWeight = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.grossWeight * this.item.purity) / 100).toFixed(3);
      if (this.firmSetting && this.firmSetting.isRoundOff) {
        console.log("round");
        var basicPrice = (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.rate * this.item.netWeight) - __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.tradeDiscount) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.specialCharge)).toFixed(2);
        this.item.basicPrice = Math.round(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(basicPrice));
        var GSTValue = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.basicPrice * (parseFloat(this.item.taxableGST_rate) / 100)).toFixed(2);
        this.item.GSTValue = Math.round(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(GSTValue));
        var totlePrice = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.basicPrice) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.GSTValue)).toFixed(2);
        this.item.totlePrice = Math.round(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(totlePrice));
      } else {
        this.item.basicPrice = (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.rate * this.item.netWeight) - __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.tradeDiscount) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.specialCharge)).toFixed(2);
        this.item.GSTValue = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.basicPrice * (parseFloat(this.item.taxableGST_rate) / 100)).toFixed(2);
        this.item.totlePrice = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.basicPrice) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.item.GSTValue)).toFixed(2);
      }
      this.calculateSpecialCharge();
      this.calculateTradeDiscount();
    },
    save: function save(saveAndAdd) {
      var _this6 = this;

      // let buyer = this.buyerById[this.buyerId];
      // let isBuyer = buyer  ? true : false;
      // if(!this.isBuyer) {
      //   this.item.expiryDate = new Date(this.item.expiryDate).getTime(),
      //   this.item.manufacturingDate = new Date(this.item.manufacturingDate).getTime()
      // }
      var minQ = 0;
      if (this.offerList.length) {

        this.offerList.map(function (item) {
          if (item.minQuantity <= _this6.item.quantity && minQ < item.offerQuantity) {
            minQ = item.offerQuantity;
          }
        });
      }
      if (this.item.quantity > this.selectedProduct.quantity && this.isBuyer) {
        if (this.firmSetting && this.firmSetting.hideNegetiveStockAlert || confirm("stock can go in negative - do you want to proceed ?")) {
          if (!this.isEditItems || this.isEditItems && this.productChanged) {
            this.item.productName = this.selectedProduct.name;
            this.item.GST_type = this.selectedProduct.GST_type;
            this.item.productUnit = this.selectedProduct.unit;
            this.item.availableQuantity = this.selectedProduct.quantity;
          }
          if (minQ) {
            var clonedItem = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.item);
            clonedItem.quantity = minQ;
            clonedItem.basicPrice = 0;
            clonedItem.rate = 0;
            clonedItem.GSTValue = 0;
            clonedItem.totlePrice = 0;
            this.$emit('saveAddItem', clonedItem, false);
          }
          this.$emit('saveAddItem', this.item, saveAndAdd);
          this.reset();
        }
      } else {
        if (!this.isEditItems || this.isEditItems && this.productChanged) {
          this.item.productName = this.selectedProduct.name;
          this.item.GST_type = this.selectedProduct.GST_type;
          this.item.productUnit = this.selectedProduct.unit;
          this.item.availableQuantity = this.selectedProduct.quantity;
        }
        if (minQ) {
          var _clonedItem = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, this.item);
          _clonedItem.quantity = minQ;
          _clonedItem.basicPrice = 0;
          _clonedItem.rate = 0;
          _clonedItem.GSTValue = 0;
          _clonedItem.totlePrice = 0;
          this.$emit('saveAddItem', _clonedItem, false);
        }
        this.$emit('saveAddItem', this.item, saveAndAdd);
        this.reset();
      }
    },
    reset: function reset() {
      this.item = {
        productName: "",
        productId: "",
        HSN_code: "",
        taxableGST_rate: 0,
        rate: 0,
        unit: "",
        quantity: 0,
        basicPrice: 0,
        GSTValue: 0,
        GST_type: "",
        productUnit: '',
        totlePrice: 0,
        tradeDiscount: 0,
        grossWeight: 0,
        purity: 100,
        netWeight: 0,
        specialCharge: 0,
        //tunch : '',
        drawerId: null
      };
      this.tradeDiscountPercentage = null;
      this.isTradePercentage = false;
      this.specialChargePercentage = null;
      this.isSpecialChargePercentage = false;
    },
    calculateOpeningBalance: function calculateOpeningBalance() {
      this.currentProduct.openingBalance = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.currentProduct.basicPrice) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(this.currentProduct.gstValue);
    },
    scanItem: function scanItem() {
      this.scannerDialog = true;
      this.initQugga();
    },
    initQugga: function initQugga() {
      var selfVue = this;
      $(function () {
        var resultCollector = Quagga.ResultCollector.create({
          capture: true,
          capacity: 20,
          blacklist: [{
            code: "WIWV8ETQZ1", format: "code_93"
          }, {
            code: "EH3C-%GU23RK3", format: "code_93"
          }, {
            code: "O308SIHQOXN5SA/PJ", format: "code_93"
          }, {
            code: "DG7Q$TV8JQ/EN", format: "code_93"
          }, {
            code: "VOFD1DB5A.1F6QU", format: "code_93"
          }, {
            code: "4SO64P4X8 U4YUU1T-", format: "code_93"
          }],
          filter: function filter(codeResult) {
            // only store results which match this constraint
            // e.g.: codeResult
            return true;
          }
        });
        var App = {
          init: function init() {
            var self = this;

            Quagga.init(this.state, function (err) {
              if (err) {
                return self.handleError(err);
              }
              //Quagga.registerResultCollector(resultCollector);
              App.attachListeners();
              App.checkCapabilities();
              Quagga.start();
            });
          },
          handleError: function handleError(err) {
            console.log(err);
          },
          checkCapabilities: function checkCapabilities() {
            var track = Quagga.CameraAccess.getActiveTrack();
            var capabilities = {};
            if (typeof track.getCapabilities === 'function') {
              capabilities = track.getCapabilities();
            }
            this.applySettingsVisibility('zoom', capabilities.zoom);
            this.applySettingsVisibility('torch', capabilities.torch);
          },
          updateOptionsForMediaRange: function updateOptionsForMediaRange(node, range) {
            console.log('updateOptionsForMediaRange', node, range);
            var NUM_STEPS = 6;
            var stepSize = (range.max - range.min) / NUM_STEPS;
            var option;
            var value;
            while (node.firstChild) {
              node.removeChild(node.firstChild);
            }
            for (var i = 0; i <= NUM_STEPS; i++) {
              value = range.min + stepSize * i;
              option = document.createElement('option');
              option.value = value;
              option.innerHTML = value;
              node.appendChild(option);
            }
          },
          applySettingsVisibility: function applySettingsVisibility(setting, capability) {
            // depending on type of capability
            if (typeof capability === 'boolean') {
              var node = document.querySelector('input[name="settings_' + setting + '"]');
              if (node) {
                node.parentNode.style.display = capability ? 'block' : 'none';
              }
              return;
            }
            if (window.MediaSettingsRange && capability instanceof window.MediaSettingsRange) {
              var node = document.querySelector('select[name="settings_' + setting + '"]');
              if (node) {
                this.updateOptionsForMediaRange(node, capability);
                node.parentNode.style.display = 'block';
              }
              return;
            }
          },
          initCameraSelection: function initCameraSelection() {
            var streamLabel = Quagga.CameraAccess.getActiveStreamLabel();

            return Quagga.CameraAccess.enumerateVideoDevices().then(function (devices) {
              function pruneText(text) {
                return text.length > 30 ? text.substr(0, 30) : text;
              }
              var $deviceSelection = document.getElementById("deviceSelection");
              while ($deviceSelection.firstChild) {
                $deviceSelection.removeChild($deviceSelection.firstChild);
              }
              devices.forEach(function (device) {
                var $option = document.createElement("option");
                $option.value = device.deviceId || device.id;
                $option.appendChild(document.createTextNode(pruneText(device.label || device.deviceId || device.id)));
                $option.selected = streamLabel === device.label;
                $deviceSelection.appendChild($option);
              });
            });
          },
          attachListeners: function attachListeners() {
            var self = this;

            self.initCameraSelection();
            $(".controls").on("click", "button.stop", function (e) {
              e.preventDefault();
              Quagga.stop();
              self._printCollectedResults();
            });

            $(".controls .reader-config-group").on("change", "input, select", function (e) {
              e.preventDefault();
              var $target = $(e.target),
                  value = $target.attr("type") === "checkbox" ? $target.prop("checked") : $target.val(),
                  name = $target.attr("name"),
                  state = self._convertNameToState(name);

              console.log("Value of " + state + " changed to " + value);
              self.setState(state, value);
            });
          },
          _printCollectedResults: function _printCollectedResults() {
            var results = resultCollector.getResults(),
                $ul = $("#result_strip ul.collector");

            results.forEach(function (result) {
              var $li = $('<li><div class="thumbnail"><div class="imgWrapper"><img /></div><div class="caption"><h4 class="code"></h4></div></div></li>');

              $li.find("img").attr("src", result.frame);
              $li.find("h4.code").html(result.codeResult.code + " (" + result.codeResult.format + ")");
              $ul.prepend($li);
            });
          },
          _accessByPath: function _accessByPath(obj, path, val) {
            var parts = path.split('.'),
                depth = parts.length,
                setter = typeof val !== "undefined" ? true : false;

            return parts.reduce(function (o, key, i) {
              if (setter && i + 1 === depth) {
                if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(o[key]) === "object" && (typeof val === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(val)) === "object") {
                  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(o[key], val);
                } else {
                  o[key] = val;
                }
              }
              return key in o ? o[key] : {};
            }, obj);
          },
          _convertNameToState: function _convertNameToState(name) {
            return name.replace("_", ".").split("-").reduce(function (result, value) {
              return result + value.charAt(0).toUpperCase() + value.substring(1);
            });
          },
          detachListeners: function detachListeners() {
            $(".controls").off("click", "button.stop");
            $(".controls .reader-config-group").off("change", "input, select");
          },
          applySetting: function applySetting(setting, value) {
            var track = Quagga.CameraAccess.getActiveTrack();
            if (track && typeof track.getCapabilities === 'function') {
              switch (setting) {
                case 'zoom':
                  return track.applyConstraints({ advanced: [{ zoom: parseFloat(value) }] });
                case 'torch':
                  return track.applyConstraints({ advanced: [{ torch: !!value }] });
              }
            }
          },
          setState: function setState(path, value) {
            var self = this;

            if (typeof self._accessByPath(self.inputMapper, path) === "function") {
              value = self._accessByPath(self.inputMapper, path)(value);
            }

            if (path.startsWith('settings.')) {
              var setting = path.substring(9);
              return self.applySetting(setting, value);
            }
            self._accessByPath(self.state, path, value);

            console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(self.state));
            App.detachListeners();
            Quagga.stop();
            App.init();
          },
          inputMapper: {
            inputStream: {
              constraints: function constraints(value) {
                if (/^(\d+)x(\d+)$/.test(value)) {
                  var values = value.split('x');
                  return {
                    width: { min: parseInt(values[0]) },
                    height: { min: parseInt(values[1]) }
                  };
                }
                return {
                  deviceId: value
                };
              }
            },
            numOfWorkers: function numOfWorkers(value) {
              return parseInt(value);
            },
            decoder: {
              readers: function readers(value) {
                if (value === 'ean_extended') {
                  return [{
                    format: "ean_reader",
                    config: {
                      supplements: ['ean_5_reader', 'ean_2_reader']
                    }
                  }];
                }
                return [{
                  format: value + "_reader",
                  config: {}
                }];
              }
            }
          },
          state: {
            inputStream: {
              type: "LiveStream",
              constraints: {
                width: { min: 640 },
                height: { min: 480 },
                facingMode: "environment",
                aspectRatio: { min: 1, max: 2 }
              }
            },
            locator: {
              patchSize: "medium",
              halfSample: true
            },
            numOfWorkers: 2,
            frequency: 10,
            decoder: {
              readers: [{
                format: "ean_reader",
                config: {}
              }]
            },
            locate: true
          },
          lastResult: null
        };

        App.init();

        Quagga.onProcessed(function (result) {
          var drawingCtx = Quagga.canvas.ctx.overlay,
              drawingCanvas = Quagga.canvas.dom.overlay;

          if (result) {
            if (result.boxes) {
              drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute("width")), parseInt(drawingCanvas.getAttribute("height")));
              result.boxes.filter(function (box) {
                return box !== result.box;
              }).forEach(function (box) {
                Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, { color: "green", lineWidth: 2 });
              });
            }

            if (result.box) {
              Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, { color: "#00F", lineWidth: 2 });
            }

            if (result.codeResult && result.codeResult.code) {
              Quagga.ImageDebug.drawPath(result.line, { x: 'x', y: 'y' }, drawingCtx, { color: 'red', lineWidth: 3 });
            }
          }
        });

        Quagga.onDetected(function (result) {
          var code = result.codeResult.code;
          console.log(code);
          Quagga.stop();
          selfVue.addProductByBarcode(code);
          // if (App.lastResult !== code) {
          //     App.lastResult = code;
          //     var $node = null, canvas = Quagga.canvas.dom.image;

          //     $node = $('<li><div class="thumbnail"><div class="imgWrapper"><img /></div><div class="caption"><h4 class="code"></h4></div></div></li>');
          //     $node.find("img").attr("src", canvas.toDataURL());
          //     $node.find("h4.code").html(code);
          //     $("#result_strip ul.thumbnails").prepend($node);
          // }
        });
      });
    },
    addProductByBarcode: function addProductByBarcode(barcode) {
      var _this7 = this;

      var product = this.productsByBrand.filter(function (item) {
        return item.barcode == barcode;
      })[0];
      var productName = this.productsByBrand.filter(function (item) {
        return item.name == barcode;
      })[0];
      if (product) {
        clearInterval(this.timeoutSearch);
        this.productChange(product);
        this.item.quantity = 1;
        this.item.productName = product.name;
        this.scannerDialog = false;
        this.search = "";
        this.save(true);
      } else if (productName) {
        clearInterval(this.timeoutSearch);
      } else {
        this.timeoutSearch = setTimeout(function () {
          _this7.search = "";
        }, 2000);
      }
    }
  }
});

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ewayBill_vue__ = __webpack_require__(500);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_070171f9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ewayBill_vue__ = __webpack_require__(1499);
function injectStyle (ssrContext) {
  __webpack_require__(1498)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ewayBill_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_070171f9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ewayBill_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_pdfmake__ = __webpack_require__(31);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  props: ["invoiceData", "bank", "firm", "selectedBuyer", "termsAndConditions", "gstTotal", 'isBuyer', 'ewayBillDetails'],
  data: function data() {
    return {
      customer: null,
      Itemheaders: [{ text: "Product Name", sortable: false, value: "productName" }, { text: "HSN code", sortable: false, value: "HSN_code" }, { text: "GST", sortable: false, value: "taxableGST_rate" }, { text: "Rate", sortable: false, value: "rate" }, { text: "Unit", sortable: false, value: "unit" }, { text: "Quantity", sortable: false, value: "quantity" }, { text: "Basic Price", sortable: false, value: "basicPrice" }, { text: "GST value", sortable: false, value: "GSTValue" }, { text: "Total Price", sortable: false, value: "totlePrice" }, { text: "CGST value ( %)", sortable: false, value: "CGST" }, { text: "SGST value ( %)", sortable: false, value: "SGST" }, { text: "IGST value ( %)", sortable: false, value: "IGST" }],
      transportationDetails: {
        vehicleNo: null,
        goodsReceiptNumber: null,
        otherTransportationMode: null,
        transporterName: null,
        driverName: null,
        driverNumber: null,
        supplyDate: null
      },
      mobile: {
        value: "",
        rules: [function (v) {
          return (/^$/.test(v) || /^(\+91|\+91\-|0)?[789]\d{9}$/.test(v) || "Mobile number is wrong"
          );
        }]
      },
      consignee: null,
      datepickerBillDate: false,
      datepickerBillDate1: false,
      datepickerBillDate2: false,
      datepickerValidUntil: false,
      datepickerValidUntil1: false,
      datepickerDocumentDate: false,
      datepickerDepartureDate: false,
      tab: null,
      ebillDetails: {
        billNo: null,
        billDate: null,
        generatedBy: null,
        validFrom: null,
        validUntil: null,
        GSTofSupplier: null,
        GSTofReceipient: null,
        placeOfDispatch: null, //add
        placeOfDelivery: null, //add
        documentNo: null,
        documentDate: null,
        valueOfGoods: null,
        reasonOfTransportation: null,
        transportationDetails: {
          mode: null,
          vehicleNo: null,
          from: null, //ad
          to: null, // add
          departureDate: null,
          enteredBy: null,
          CEWBno: null,
          remark: null,
          goodsReceiptNumber: null,
          otherTransportationMode: null,
          transporterName: null
        }
      },
      address: {
        village: null,
        block: null,
        tehsil: null,
        district: null,
        state: null,
        field1: null,
        field2: null,
        fullAddress: null
      },
      addressDialog: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, mapGlobalGetters({
    gVillage: "village",
    gBlock: "block",
    gTehsil: "tehsil",
    gDistrict: "district",
    gState: "state",
    gCountry: "country"
  })),
  methods: {
    setSateCode: function setSateCode(user) {
      var states = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.gState));
      user.stateCode = states.filter(function (item) {
        return item.state == user.state;
      })[0].code;
    },
    createEwayBill: function createEwayBill() {
      alert("Work In Progress");
    },
    getAddress: function getAddress(item) {
      var address = (item.village ? item.village + ", " : "") + (item.block ? item.block + ", " : "") + (item.tehsil ? item.tehsil + ", " : "") + (item.district ? item.district + ", " : "") + (item.state ? item.state + ", " : "") + (item.country ? item.country + ", " : "");
      address = address.substring(0, address.length - 2);
      return address;
    },
    setAddress: function setAddress() {
      if (this.address.field1 && this.address.field2) {
        this.ebillDetails[this.address.field1][this.address.field2] = this.address.fullAddress;
      } else if (this.address.field1) {
        this.ebillDetails[this.address.field1] = this.address.fullAddress;
      }
      this.addressDialog = false;
    },
    resetAddress: function resetAddress() {
      this.address = {
        village: null,
        block: null,
        tehsil: null,
        district: null,
        state: null,
        field1: null,
        field2: null,
        fullAddress: null
      };
    },
    checkUser: function checkUser() {
      var _this = this;

      var states = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.gState));
      this.customer = this.selectedBuyer;
      this.customer.address = this.getAddress(this.selectedBuyer);
      this.customer.stateCode = states.filter(function (item) {
        return item.state == _this.customer.state;
      })[0].code;
      this.consignee = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.customer));
      this.firm.address = this.getAddress(this.firm);
      this.firm.stateCode = states.filter(function (item) {
        return item.state == _this.firm.state;
      })[0].code;
      this.getEbillDetails();
    },
    addressDialogOpen: function addressDialogOpen(field1, field2) {
      this.address.field1 = field1;
      this.address.field2 = field2;
      this.addressDialog = true;
    },
    getEbillDetails: function getEbillDetails() {
      this.ebillDetails.generatedBy = this.firm && this.firm.name + " - " + this.firm.GST_number;
      this.ebillDetails.validFrom = this.invoiceData && this.invoiceData.date;
      this.ebillDetails.GSTofSupplier = this.firm && this.firm.GST_number;
      this.ebillDetails.GSTofReceipient = this.customer && this.customer.GST_number;
      this.ebillDetails.valueOfGoods = this.invoiceData && this.invoiceData.totalAmount;
      this.ebillDetails.transportationDetails.enteredBy = this.firm && this.firm.GST_number;
      this.ebillDetails.billDate = new Date(this.invoiceData.date).toISOString().substr(0, 10);
      if (this.ewayBillDetails) {
        this.ebillDetails = this.ewayBillDetails.ebillDetails;
        this.transportationDetails = this.ewayBillDetails.transportationDetails;
        this.consignee.name = this.ewayBillDetails.consignee.name;
        this.consignee.propName = this.ewayBillDetails.consignee.propName;
        this.consignee.GST_number = this.ewayBillDetails.consignee.GST_number;
        this.consignee.localAddress = this.ewayBillDetails.consignee.localAddress;
        this.consignee.address = this.ewayBillDetails.consignee.address;
        this.consignee.state = this.ewayBillDetails.consignee.state;
        this.consignee.stateCode = this.ewayBillDetails.consignee.stateCode;
        this.consignee.email = this.ewayBillDetails.consignee.email;
      }
    },
    getEwayBillDetails: function getEwayBillDetails() {
      var ewayBillDetails = {
        ebillDetails: this.ebillDetails,
        transportationDetails: this.transportationDetails
      };
      ewayBillDetails['consignee'] = {
        name: this.consignee.name,
        propName: this.consignee.propName || '',
        GST_number: this.consignee.GST_number,
        address: this.consignee.address,
        localAddress: this.consignee.localAddress,
        mobile: this.consignee.mobile || '',
        state: this.consignee.state || '',
        stateCode: this.consignee.stateCode || '',
        email: this.consignee.email || ''
      };
      return ewayBillDetails;
    },
    printInvoice: function printInvoice() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_6__utils_pdfmake__["j" /* convertToEwayBillType1 */])({
                  invoiceData: _this2.invoiceData,
                  bank: _this2.bank,
                  firm: _this2.firm,
                  customer: _this2.customer,
                  ebillDetails: _this2.ebillDetails,
                  consignee: _this2.consignee,
                  transportationDetails: _this2.transportationDetails,
                  terms: _this2.termsAndConditions[0],
                  gstTotal: _this2.gstTotal
                }).then(function (doc) {
                  //pdfMake.createPdf(doc).download(this.invoiceData.invoiceId);
                  doc['info'] = { title: _this2.invoiceId };
                  pdfMake.createPdf(doc).print({}, window.frames['printPdf']);
                  _this2.saveAndReset();
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    printInvoice2: function printInvoice2() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_6__utils_pdfmake__["k" /* convertToEwayBillType2 */])({
                  invoiceData: _this3.invoiceData,
                  bank: _this3.bank,
                  firm: _this3.firm,
                  customer: _this3.customer,
                  ebillDetails: _this3.ebillDetails,
                  consignee: _this3.consignee,
                  transportationDetails: _this3.transportationDetails,
                  terms: _this3.termsAndConditions[0],
                  gstTotal: _this3.gstTotal
                }).then(function (doc) {
                  //pdfMake.createPdf(doc).download(this.invoiceData.invoiceId);
                  doc['info'] = { title: _this3.invoiceId };
                  pdfMake.createPdf(doc).print({}, window.frames['printPdf']);
                  _this3.saveAndReset();
                });

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },
    printInvoice3: function printInvoice3(isSave, isDownload) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_6__utils_pdfmake__["l" /* convertToEwayBillType3 */])({
                  invoiceData: _this4.invoiceData,
                  bank: _this4.bank,
                  firm: _this4.firm,
                  customer: _this4.customer,
                  ebillDetails: _this4.ebillDetails,
                  consignee: _this4.consignee,
                  transportationDetails: _this4.transportationDetails,
                  terms: _this4.termsAndConditions[0],
                  gstTotal: _this4.gstTotal
                }).then(function (doc) {
                  if (isDownload) {
                    pdfMake.createPdf(doc).download(_this4.invoiceData.invoiceId);
                  } else {
                    doc['info'] = { title: _this4.invoiceData.invoiceId };
                    pdfMake.createPdf(doc).print({}, window.frames['printPdf']);
                  }
                });

              case 2:
                if (isSave) {
                  _this4.saveInvoice();
                }

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    saveAndReset: function saveAndReset() {
      var _this5 = this;

      var ewayData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.getEwayBillDetails());
      this.$emit("ewayBillSave", ewayData);
      setTimeout(function () {
        _this5.resetData();
      }, 2500);
    },
    resetData: function resetData() {
      this.customer = {
        name: "",
        propName: "",
        GST_number: "",
        address: "",
        localAddress: '',
        mobile: "",
        state: "",
        stateCode: "",
        email: ""
      };
      this.transportationDetails = {
        vehicleNo: null,
        goodsReceiptNumber: null,
        transporterName: null,
        driverName: null,
        driverNumber: null,
        supplyDate: null,
        otherTransportationMode: null
      };
      this.mobile.value = null;
      this.consignee = {
        name: "",
        propName: "",
        GST_number: "",
        address: "",
        localAddress: "",
        mobile: "",
        state: "",
        stateCode: "",
        email: ""
      };
      this.ebillDetails = {
        billNo: null,
        billDate: null,
        generatedBy: null,
        validFrom: null,
        validUntil: null,
        GSTofSupplier: null,
        GSTofReceipient: null,
        placeOfDispatch: null, //add
        placeOfDelivery: null, //add
        documentNo: null,
        documentDate: null,
        valueOfGoods: null,
        reasonOfTransportation: null,
        transportationDetails: {
          mode: null,
          vehicleNo: null,
          from: null, //ad
          to: null, // add
          departureDate: null,
          enteredBy: null,
          CEWBno: null,
          remark: null,
          goodsReceiptNumber: null,
          transporterName: null,
          otherTransportationMode: null
        }
      };
      this.address = {
        village: null,
        block: null,
        tehsil: null,
        district: null,
        state: null,
        field1: null,
        field2: null,
        fullAddress: null
      };
    },
    printInvoice4: function printInvoice4() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return Object(__WEBPACK_IMPORTED_MODULE_6__utils_pdfmake__["p" /* convertToSimpleInvoicePrint */])({
                  invoiceData: _this6.invoiceData,
                  bank: _this6.bank,
                  firm: _this6.firm,
                  customer: _this6.customer,
                  ebillDetails: _this6.ebillDetails,
                  consignee: _this6.consignee,
                  transportationDetails: _this6.transportationDetails,
                  terms: _this6.termsAndConditions[0],
                  gstTotal: _this6.gstTotal
                }).then(function (doc) {
                  // pdfMake.createPdf(doc).download(this.invoiceData.invoiceId);
                  doc['info'] = { title: _this6.invoiceId };
                  pdfMake.createPdf(doc).print({}, window.frames['printPdf']);
                  _this6.saveAndReset();
                });

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this6);
      }))();
    },
    saveInvoice: function saveInvoice() {
      this.saveAndReset();
    }
  },
  watch: {
    // firm(newVal, oldVal) {
    //   if (newVal) {
    //     this.firm.address = this.getAddress(this.firm);
    //   }
    // },
    selectedBuyer: function selectedBuyer(newVal, oldVal) {
      this.checkUser();
    },

    "address.village": function addressVillage(newVal, oldVal) {
      this.address.fullAddress = this.getAddress(this.address);
    },
    "address.block": function addressBlock(newVal, oldVal) {
      this.address.fullAddress = this.getAddress(this.address);
    },
    "address.tehsil": function addressTehsil(newVal, oldVal) {
      this.address.fullAddress = this.getAddress(this.address);
    },
    "address.district": function addressDistrict(newVal, oldVal) {
      this.address.fullAddress = this.getAddress(this.address);
    },
    "address.state": function addressState(newVal, oldVal) {
      this.address.fullAddress = this.getAddress(this.address);
    },
    "invoiceData.totalAmount": {
      handler: function handler(newVal, oldVal) {
        this.getEbillDetails();
      },

      deep: true
    },
    "invoiceData.firm": {
      handler: function handler(newVal, oldVal) {
        this.getEbillDetails();
      },

      deep: true
    }
  },
  created: function created() {
    this.checkUser();
  }
});

/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_int__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AddItemMed__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AddItemAuto__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AddItemDefault__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AddItemClothes__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AddItemJewl__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__AddItemDairy__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__AddItemGrain__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ewayBill__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_pdfmake__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__services_twilio_js__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils___ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Products_addProduct__ = __webpack_require__(240);









var _components$data$comp;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];

/* harmony default export */ __webpack_exports__["a"] = (_components$data$comp = {
  components: {
    AddProduct: __WEBPACK_IMPORTED_MODULE_20__Products_addProduct__["a" /* default */],
    AddItemMed: __WEBPACK_IMPORTED_MODULE_9__AddItemMed__["a" /* default */],
    AddItemDefault: __WEBPACK_IMPORTED_MODULE_11__AddItemDefault__["a" /* default */],
    AddItemAuto: __WEBPACK_IMPORTED_MODULE_10__AddItemAuto__["a" /* default */],
    AddItemClothes: __WEBPACK_IMPORTED_MODULE_12__AddItemClothes__["a" /* default */],
    AddItemJewl: __WEBPACK_IMPORTED_MODULE_13__AddItemJewl__["a" /* default */],
    AddItemDairy: __WEBPACK_IMPORTED_MODULE_14__AddItemDairy__["a" /* default */],
    AddItemGrain: __WEBPACK_IMPORTED_MODULE_15__AddItemGrain__["a" /* default */],
    EwayBill: __WEBPACK_IMPORTED_MODULE_16__ewayBill__["a" /* default */]
  },
  data: function data() {
    return {
      addProductDialog: false,
      stepperValue: null,
      invoiceDraftPrevious: null,
      currentProduct: {
        name: "",
        description: "",
        HSN_code: 0,
        GST_type: "",
        taxableGST_rate: 0,
        unit: "",
        quantity: 0,
        brand: "",
        openingDate: new Date().toISOString().substr(0, 10),
        purchasingPrice: null,
        sellingPrice: null,
        openingBalance: null,
        gstValue: 0,
        basicPrice: 0,
        barcode: "",
        productGroup: null,
        productCategory: null,
        productType: null,
        unitsDetails: [{
          unit: '',
          isLast: true,
          isFirst: true,
          order: 1,
          quantity: 0,
          rate: true
        }],
        unitsDeatilsAdded: false
      },
      selectedProductSet: null,
      otpData: {
        otp: null,
        mobile: null,
        dialog: false,
        confirmOtp: null
      },
      isPaymentDone: null,
      dialog: false,
      isIncentive: false,
      //ewayBillDialog: false,
      billingDetailsDialog: false,
      incentives: [],
      extraCharges: [],
      extraChargesSample: [{
        name: 'Freight Charge',
        amount: 0
      }, {
        name: 'Labour Charge',
        amount: 0
      }, {
        name: 'Making Charge',
        amount: 0
      }, {
        name: 'Other Charge',
        amount: 0
      }, {
        name: 'Service Charge',
        amount: 0
      }, {
        name: 'TCS',
        amount: 0
      }],
      totalExtraCharges: 0,
      businessType: null,
      selectedBuyer: null,
      isBuyer: true,
      snackbarSuccess: false,
      isEditItems: false,
      gstInvoice: false,
      duplicateError: null,
      selectedFirmState: null,
      items: [],
      totalTradeDiscount: 0,
      totalSpecialCharge: 0,
      editedIndex: -1,
      editedItem: {
        productName: "",
        productId: "",
        HSN_code: "",
        taxableGST_rate: 0,
        rate: 0,
        unit: "",
        quantity: 1,
        basicPrice: 0,
        GSTValue: 0,
        totlePrice: 0,
        tradeDiscount: 0,
        specialCharge: 0,
        expiryDate: new Date(new Date().setFullYear(new Date().getFullYear() + 100)).toISOString().substr(0, 10),
        manufacturingDate: new Date(new Date().setFullYear(new Date().getFullYear() + 100)).toISOString().substr(0, 10),
        batchNumber: "DEFAULT"
      },
      defaultItem: {
        productName: "",
        productId: "",
        HSN_code: "",
        taxableGST_rate: 0,
        rate: 0,
        unit: "",
        quantity: 1,
        basicPrice: 0,
        GSTValue: 0,
        totlePrice: 0,
        tradeDiscount: 0,
        specialCharge: 0,
        expiryDate: new Date(new Date().setFullYear(new Date().getFullYear() + 100)).toISOString().substr(0, 10),
        manufacturingDate: new Date(new Date().setFullYear(new Date().getFullYear() + 100)).toISOString().substr(0, 10),
        batchNumber: "DEFAULT"
      },
      amountFromCash: 0,
      amountFromBank: 0,
      alertDuration: 0,
      paymentType: "",
      selectedFirm: "",
      selectedBank: "",
      soldBy: "",
      brokerageRate: 0,
      // godawnBy : '',
      placeOfSupply: "",
      invoiceDate: new Date().toISOString().substr(0, 10),
      dateFormatted: new Date().toISOString().substr(0, 10),
      datepicker: false,
      totalAmount: 0,
      paidAmount: 0,
      remainingAmount: 0,
      discountAmount: 0,
      roundOffAmount: 0,
      invoiceDraft: {},
      transferType: null,
      transferTypeDialog: false,
      availableBalance: 0,
      firms: [],
      staffs: [],
      // godawns: [],
      banks: [],
      transactionType: "Debit",
      amountFromCashDisabled: true,
      amountFromBankDisabled: true,
      status: null,
      gstType: null,
      remark: null,
      invoiceId: null,
      snackbar: null,
      snackbarMsg: null,
      GST_Val_total: {
        CGST_val: 0,
        SGST_val: 0,
        IGST_val: 0
      },
      GST_Percentage_total: {
        GST_0: 0,
        GST_5: 0,
        GST_12: 0,
        GST_18: 0,
        GST_28: 0
      },
      roundOff: 2,
      transactionDialog: false,
      expansionVal: false,
      transferDetails: {
        accountNumber: null,
        accountHolderName: null,
        bankName: null,
        IFSCcode: null,
        remark: null
      },
      orderNumber: null,
      applicationNumber: null,
      sanctionDatepicker: null,
      sanctionDate: null,
      orderDatepicker: null,
      orderDate: null,
      billingDetails: {
        name: null,
        mobile: null,
        address: null
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear", "adminEmail", "brandFinYear"]), mapGlobalGetters({
    gState: "state"
  }), {
    firmSetting: function firmSetting() {
      var _this = this;

      if (this.selectedFirm) {
        return this.firmSettings.filter(function (item) {
          return item['firm'] == _this.selectedFirm;
        })[0];
      }
    },
    getHeaders: function getHeaders() {
      if (this.gstInvoice) {
        return [{
          text: "Name",
          sortable: false,
          value: "productName",
          class: "font-weight-bold primary--text"
        }, {
          text: "Rate",
          sortable: false,
          value: "rate",
          class: "font-weight-bold primary--text"
        }, {
          text: "Unit",
          sortable: false,
          value: "unit",
          class: "font-weight-bold primary--text"
        }, {
          text: "Quantity",
          sortable: false,
          value: "quantity",
          class: "font-weight-bold primary--text"
        }, {
          text: "Basic Price",
          sortable: false,
          value: "basicPrice",
          class: "font-weight-bold primary--text"
        }, {
          text: "GST value",
          sortable: false,
          value: "GSTValue",
          class: "font-weight-bold primary--text"
        }, {
          text: "Trade Discount",
          sortable: false,
          value: "totlePrice",
          class: "font-weight-bold primary--text"
        }, {
          text: "Special Charge",
          sortable: false,
          value: "specialCharge",
          class: "font-weight-bold primary--text"
        }, {
          text: "Total Price",
          sortable: false,
          value: "totlePrice",
          class: "font-weight-bold primary--text"
        }, {
          text: "CGST ",
          sortable: false,
          value: "CGST",
          class: "font-weight-bold primary--text"
        }, {
          text: "SGST ",
          sortable: false,
          value: "SGST",
          class: "font-weight-bold primary--text"
        }, {
          text: "IGST ",
          sortable: false,
          value: "IGST",
          class: "font-weight-bold primary--text"
        }, {
          text: "Action ",
          sortable: false,
          value: "action",
          class: "font-weight-bold primary--text"
        }, { text: "", value: "name", sortable: false }];
      } else {
        return [{
          text: "Name",
          sortable: false,
          value: "productName",
          class: "font-weight-bold primary--text"
        }, {
          text: "Rate",
          sortable: false,
          value: "rate",
          class: "font-weight-bold primary--text"
        }, {
          text: "Unit",
          sortable: false,
          value: "unit",
          class: "font-weight-bold primary--text"
        }, {
          text: "Quantity",
          sortable: false,
          value: "quantity",
          class: "font-weight-bold primary--text"
        }, {
          text: "Basic Price",
          sortable: false,
          value: "basicPrice",
          class: "font-weight-bold primary--text"
        }, {
          text: "Trade Discount",
          sortable: false,
          value: "totlePrice",
          class: "font-weight-bold primary--text"
        }, {
          text: "Special Charge",
          sortable: false,
          value: "specialCharge",
          class: "font-weight-bold primary--text"
        }, {
          text: "Total Price",
          sortable: false,
          value: "totlePrice",
          class: "font-weight-bold primary--text"
        }, {
          text: "Action ",
          sortable: false,
          value: "action",
          class: "font-weight-bold primary--text"
        }, { text: "", value: "name", sortable: false }];
      }
    },
    buyersByBrand: function buyersByBrand() {
      var _this2 = this;

      return this.buyers.filter(function (item) {
        return item["brand"] === _this2.selectedBrand;
      });
    },
    sellersByBrand: function sellersByBrand() {
      var _this3 = this;

      return this.sellers.filter(function (item) {
        return item["brand"] === _this3.selectedBrand;
      });
    },
    ProductSetByBrand: function ProductSetByBrand() {
      var _this4 = this;

      return this.productSets.filter(function (item) {
        return item["brand"] === _this4.selectedBrand;
      });
    },
    firmsByBrand: function firmsByBrand() {
      var _this5 = this;

      return this.firms.filter(function (item) {
        return item["brand"] === _this5.selectedBrand;
      }).map(function (item) {
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
    },
    staffByBrand: function staffByBrand() {
      var _this6 = this;

      return this.staffs.filter(function (item) {
        return item["brand"] === _this6.selectedBrand && item["firm"] === _this6.selectedFirm;
      }).map(function (item) {
        return {
          text: item["staffName"],
          value: item[".key"]
        };
      });
    },

    // godawnByBrand() {
    //   return this.godawns
    //     .filter(item => {
    //       return (
    //         item["brand"] === this.selectedBrand
    //       );
    //     })
    //     .map(item => {
    //       return {
    //         text: item["godawnName"],
    //         value: item[".key"]
    //       };
    //     });
    // },
    banksByFirms: function banksByFirms() {
      var _this7 = this;

      return this.banks.filter(function (item) {
        return item["brand"] === _this7.selectedBrand && item["firm"] === _this7.selectedFirm;
      }).map(function (item) {
        return {
          text: item["bankName"],
          value: item[".key"]
        };
      });
    },
    totalItems: function totalItems() {
      return this.items.length || 0;
    },
    todaysDate: function todaysDate() {
      var date = new Date();
      return date.getDate() + "\\" + date.getMonth() + "\\" + date.getYear();
    },
    principalValueTotal: function principalValueTotal() {
      var total = this.items.reduce(function (accumulator, currentValue) {
        return accumulator + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(currentValue.totlePrice);
      }, 0);
      total += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.totalExtraCharges);
      total -= __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.discountAmount);
      // console.log(total)
      var newtotal = Math.round(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(total));
      //  console.log(newtotal)
      this.roundOffAmount = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(newtotal - total).toFixed(this.roundOff);
      return newtotal;
    }
  }),
  mounted: function mounted() {
    this.getCurrentUser();
  },
  updated: function updated() {
    this.expansionVal = true;
  },
  created: function created() {
    this.invoiceDraft = {
      items: this.items,
      amountFromCash: this.amountFromCash || 0,
      amountFromBank: this.amountFromBank || 0,
      brand: this.selectedBrand,
      date: Date.now(),
      transferDetails: this.transferDetails,
      transferType: ["Cash", ""].includes(this.paymentType) ? "0" : this.transferType,
      duration: this.alertDuration, // days
      paymentType: this.paymentType,
      transactionType: this.transactionType,
      isCredited: false,
      firm: this.selectedFirm,
      bank: ["Cash", ""].includes(this.paymentType) ? 0 : this.selectedBank,
      totalAmount: this.principalValueTotal || 0,
      paidAmount: this.paidAmount || 0,
      remainingAmount: this.remainingAmount || 0,
      discountAmount: this.discountAmount || 0,
      roundOffAmount: this.roundOffAmount || 0,
      status: this.status,
      gstType: this.gstType,
      invoiceId: this.invoiceId,
      soldBy: this.soldBy,
      brokerageRate: this.brokerageRate,
      // godawnBy : this.godawnBy,
      placeOfSupply: this.placeOfSupply,
      totalTradeDiscount: this.totalTradeDiscount,
      totalSpecialCharge: this.totalSpecialCharge,
      remark: this.remark,
      orderNumber: this.orderNumber,
      applicationNumber: this.applicationNumber,
      sanctionDatepicker: this.sanctionDatepicker,
      sanctionDate: this.sanctionDate,
      orderDatepicker: this.orderDatepicker,
      orderDate: this.orderDate
    };
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray("staffs", this.$root.$firebaseRefs.staff.orderByChild('brand').equalTo(this.selectedBrand)),
    // this.$bindAsArray("godawns", this.$root.$firebaseRefs.godawn),
    this.$bindAsArray("banks", this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray("buyers", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray("sellers", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("firmById", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("bankById", this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("termsAndConditions", this.$root.$firebaseRefs.termsAndConditions.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("productById", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("orderById", this.$root.$firebaseRefs.orders.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("estimateById", this.$root.$firebaseRefs.estimates.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("batch", this.$root.$firebaseRefs.batchTransaction.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("productSets", this.$root.$firebaseRefs.productSets.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('invoiceHistories', this.$root.$firebaseRefs.invoiceHistory.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("firmSettings", this.$root.$firebaseRefs.firmSettings.orderByChild('brand').equalTo(this.selectedBrand));
    if (this.$route.params.invoiceId) {
      this.getCurrentInvoice();
    }
  },

  watch: {
    items: {
      handler: function handler(newVal, oldVal) {
        this.updateAndEmit("totalAmount", this.principalValueTotal);
        this.totalAmount = this.principalValueTotal;
        this.calculateGSTType();
        this.calculateTotal();
        // this.updateAndEmit('totalCurrentAmount', this.currentValueTotal)
      },

      deep: true
    },
    extraCharges: {
      handler: function handler(newVal, oldVal) {
        var _this8 = this;

        this.totalExtraCharges = 0;
        this.extraCharges.map(function (item) {
          _this8.totalExtraCharges += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.amount);
        });
        this.totalAmount = this.principalValueTotal;
        this.calculateTotal();
        this.updateAndEmit("extraCharges", this.extraCharges);
        this.updateAndEmit("totalAmount", this.principalValueTotal);
      },

      deep: true
    },
    orderNumber: function orderNumber(newVal, oldVal) {
      if (!!newVal) this.updateAndEmit("orderNumber", newVal);
    },
    applicationNumber: function applicationNumber(newVal, oldVal) {
      if (!!newVal) this.updateAndEmit("applicationNumber", newVal);
    },
    sanctionDate: function sanctionDate(newVal, oldVal) {
      if (!!newVal) this.updateAndEmit("sanctionDate", new Date(newVal).getTime());
    },
    orderDate: function orderDate(newVal, oldVal) {
      if (!!newVal) this.updateAndEmit("orderDate", new Date(newVal).getTime());
    },
    isBuyer: function isBuyer(newVal, oldVal) {
      this.updateAndEmit("isBuyer", newVal);
    },
    selectedBrand: function selectedBrand(newVal, oldVal) {
      this.updateAndEmit("brand", newVal);
    },
    status: function status(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("status", newVal);
      }
    },

    transferDetails: {
      handler: function handler(newVal, oldVal) {
        if (newVal && this.invoiceDraft.transferDetails) {
          this.invoiceDraft.transferDetails.accountNumber = newVal.accountNumber;
          this.invoiceDraft.transferDetails.accountHolderName = newVal.accountHolderName;
          this.invoiceDraft.transferDetails.bankName = newVal.bankName;
          this.invoiceDraft.transferDetails.IFSCcode = newVal.IFSCcode;
          this.invoiceDraft.transferDetails.remark = newVal.remark;
        }
      },

      deep: true
    },
    gstType: function gstType(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("gstType", newVal);
      }
    },
    placeOfSupply: function placeOfSupply(newVal, oldVal) {
      if (oldVal !== newVal) {
        console.log(newVal);
        this.updateAndEmit("placeOfSupply", newVal);
        this.calculateGSTType();
      }
    },
    soldBy: function soldBy(newVal, oldVal) {
      if (oldVal !== newVal) {
        console.log(newVal);
        this.calculateBrokerage();
        this.updateAndEmit("soldBy", newVal);
      }
    },
    remark: function remark(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("remark", newVal);
      }
    },
    businessType: function businessType(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("businessType", newVal);
      }
    },
    brokerageRate: function brokerageRate(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("brokerageRate", newVal);
      }
    },

    // godawnBy(newVal, oldVal) {
    //   if (oldVal !== newVal) {
    //     this.updateAndEmit("godawnBy", newVal);
    //   }
    // },
    transferType: function transferType(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("transferType", newVal);
      }
    },
    selectedBuyer: function selectedBuyer(newVal, oldVal) {
      if (oldVal !== newVal && !!newVal) {
        this.updateAndEmit("buyerId", newVal[".key"]);
        this.getCurrentUser();
      }
    },
    alertDuration: function alertDuration(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("duration", __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_int___default()(newVal));
      }
    },
    paymentType: function paymentType(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("paymentType", newVal);
        if (this.selectedFirm != "") this.getFirmAndBankBalance();
        this.calculateTotal();
      }
    },
    transactionType: function transactionType(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("transactionType", newVal);
        this.updateStatus();
        this.calculateTotal();
      }
    },
    invoiceDate: function invoiceDate(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("date", new Date(newVal).getTime());
      }
    },
    invoiceId: function invoiceId(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("invoiceId", newVal);
      }
    },
    selectedFirm: function selectedFirm(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("firm", newVal);
        this.getFirmAndBankBalance();
        this.calculateGSTType();
      }
    },
    selectedBank: function selectedBank(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("bank", newVal);
        if (this.selectedFirm != "") this.getFirmAndBankBalance();
      }
    },
    amountFromCash: function amountFromCash(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.calculateTotal("amountFromCash");
      }
    },
    amountFromBank: function amountFromBank(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.calculateTotal("amountFromBank");
      }
    },
    discountAmount: function discountAmount(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("discountAmount", newVal);
        this.calculateTotal();
        this.totalAmount = this.principalValueTotal;
        this.updateAndEmit("totalAmount", this.principalValueTotal);
      }
    },
    roundOffAmount: function roundOffAmount(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.updateAndEmit("roundOffAmount", newVal);
        //this.calculateTotal();
      }
    }
  },
  methods: {
    saveBillingData: function saveBillingData() {
      this.updateAndEmit("billingDetails", this.billingDetails);
      this.billingDetailsDialog = false;
    },
    saveProduct: function saveProduct() {
      this.addProductDialog = false;
    },
    addProduct: function addProduct() {
      this.stepperValue = 1;
      this.currentProduct = {
        firm: null,
        name: "",
        description: "",
        HSN_code: 0,
        GST_type: "",
        taxableGST_rate: 0,
        barcode: "",
        productType: null,
        productGroup: null,
        productCategory: null,
        unit: "",
        quantity: 0,
        batchNumber: "",
        openingDate: new Date().toISOString().substr(0, 10),
        brand: "",
        basicPrice: 0,
        gstValue: 0,
        purchasingPrice: null,
        sellingPrice: null,
        openingBalance: null,
        purchasingPricePerProduct: null,
        unitsDetails: [{
          unit: '',
          isLast: true,
          isFirst: true,
          order: 1,
          quantity: 0
        }]
      };
      this.addProductDialog = true;
    },
    getCurrentInvoice: function getCurrentInvoice() {
      var _this9 = this;

      this.invoiceDraft = this.invoices.filter(function (item) {
        return item['.key'] === _this9.$route.params.invoiceId;
      })[0];
      if (this.invoiceDraft.buyerId) {
        this.invoiceDraftPrevious = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(this.invoiceDraft));
      }
      this.buyerId = this.invoiceDraft.buyerId;
      this.isPaymentDone = this.invoiceDraft.status != 'due' ? true : false;
      this.isBuyer = this.invoiceDraft.isBuyer;
      this.items = this.invoiceDraft.items;
      this.totalTradeDiscount = this.invoiceDraft.totalTradeDiscount;
      this.amountFromCash = this.invoiceDraft.amountFromCash;
      this.amountFromBank = this.invoiceDraft.amountFromBank;
      this.alertDuration = this.invoiceDraft.duration;
      this.paymentType = this.invoiceDraft.paymentType;
      this.selectedBank = this.invoiceDraft.bank;
      this.soldBy = this.invoiceDraft.soldBy;
      this.brokerageRate = this.invoiceDraft.brokerageRate;
      // this.godawnBy = '',
      this.placeOfSupply = this.invoiceDraft.placeOfSupply;
      this.invoiceDate = new Date(this.invoiceDraft.date).toISOString().substr(0, 10);
      this.dateFormatted = new Date(this.invoiceDraft.date).toISOString().substr(0, 10);
      this.totalAmount = this.invoiceDraft.totalAmount;
      this.paidAmount = this.invoiceDraft.paidAmount || 0;
      this.remainingAmount = this.invoiceDraft.remainingAmount || 0;
      this.discountAmount = this.invoiceDraft.discountAmount || 0;
      this.roundOffAmount = this.invoiceDraft.roundOffAmount || 0;
      // this.invoiceDraft= {},
      this.transferType = this.invoiceDraft.transferType;
      this.availableBalance = this.invoiceDraft.availableBalance;
      this.transactionType = this.invoiceDraft.transactionType;
      this.status = this.invoiceDraft.status;
      this.gstType = this.invoiceDraft.gstType;
      this.remark = this.invoiceDraft.remark || "";
      this.invoiceId = this.invoiceDraft.invoiceId;
      this.roundOff = this.invoiceDraft.roundOff;
      this.orderNumber = this.invoiceDraft.orderNumber;
      this.orderDate = this.invoiceDraft.orderDate;
      this.orderDatepicker = this.invoiceDraft.orderDatepicker;
      this.sanctionDate = this.invoiceDraft.sanctionDate;
      this.sanctionDatepicker = this.invoiceDraft.sanctionDatepicker;
      this.applicationNumber = this.invoiceDraft.applicationNumber;
      if (this.invoiceDraft.billingDetails) {
        this.billingDetails.name = this.invoiceDraft.billingDetails.name || null;
        this.billingDetails.address = this.invoiceDraft.billingDetails.address || null;
        this.billingDetails.mobile = this.invoiceDraft.billingDetails.mobile || null;
      }
      if (!this.invoiceDraft.transferDetails) {
        this.transferDetails = {
          accountNumber: null,
          accountHolderName: null,
          bankName: null,
          IFSCcode: null,
          remark: null
        };
      } else {
        if (this.transferDetails.accountNumber) {
          this.transferDetails['accountNumber'] = this.invoiceDraft.transferDetails['accountNumber'];
        }
        if (this.transferDetails.accountHolderName) {
          this.transferDetails['accountHolderName'] = this.invoiceDraft.transferDetails['accountHolderName'];
        }
        if (this.transferDetails.bankName) {
          this.transferDetails['bankName'] = this.invoiceDraft.transferDetails['bankName'];
        }
        if (this.transferDetails.IFSCcode) {
          this.transferDetails['IFSCcode'] = this.invoiceDraft.transferDetails['IFSCcode'];
        }
        if (this.transferDetails.remark) {
          this.transferDetails['remark'] = this.invoiceDraft.transferDetails['remark'];
        }
      }

      this.isIncentive = !!this.invoiceDraft.incentives && !!this.invoiceDraft.incentives.length;
      this.incentives = this.invoiceDraft.incentives || [];
      this.extraCharges = this.invoiceDraft.extraCharges || [];
      this.totalExtraCharges = this.invoiceDraft.totalExtraCharges;
      if (this.isBuyer) {
        this.selectedBuyer = this.buyers.filter(function (item) {
          return item[".key"] === _this9.buyerId;
        })[0];
      } else {
        this.selectedBuyer = this.sellers.filter(function (item) {
          return item[".key"] === _this9.buyerId;
        })[0];
      }
      var firm = this.firms.filter(function (item) {
        return item[".key"] === _this9.invoiceDraft.firm;
      })[0];
      this.selectedFirm = firm[".key"];
      this.selectedFirmState = firm["state"];
    },
    focusAddProduct: function focusAddProduct() {
      setTimeout(function () {
        document.querySelector('.add-product-dropdown input').click();
      }, 500);
    },
    selectProductSet: function selectProductSet() {
      if (this.selectedProductSet) {
        this.addProductFromOrderItems(this.selectedProductSet);
      } else {
        this.items = [];
        this.calculateGSTType();
      }
    },
    changeIncentive: function changeIncentive() {
      if (this.isIncentive) {
        this.incentives.push({
          order: 1,
          percentage: 0
        });
      } else {
        this.incentives = [];
      }
      this.calculateGSTType();
    },
    addIncentive: function addIncentive(event, inc) {
      if (event.which == 13 || event.keyCode == 13) {
        this.incentives.push({
          order: inc.order + 1,
          percentage: 0
        });
        this.calculateGSTType();
      }
    },
    getProductsFromOrder: function getProductsFromOrder() {
      var order = this.orderById[this.$route.params.orderId];
      var firm = this.firms.filter(function (item) {
        return item[".key"] === order.firm;
      })[0];
      this.selectedFirm = firm[".key"];
      this.selectedFirmState = firm["state"];
      this.isBuyer = order.isBuyer;
      if (this.isBuyer) {
        this.selectedBuyer = this.buyers.filter(function (item) {
          return item[".key"] === order.buyerId;
        })[0];
      } else {
        this.selectedBuyer = this.sellers.filter(function (item) {
          return item[".key"] === order.buyerId;
        })[0];
      }
      this.addProductFromOrderItems(order);
    },
    addProductFromOrderItems: function addProductFromOrderItems(order) {
      var _this10 = this;

      order.items.map(function (orderItem) {
        var product = _this10.productById[orderItem.productId];
        var itemToAdd = {
          productId: orderItem.productId,
          quantity: orderItem.quantity,
          unit: orderItem.unit,
          taxableGST_rate: product.taxableGST_rate,
          HSN_code: product.HSN_code,
          productName: product.name,
          GST_type: product.GST_type,
          productUnit: product.unit,
          availableQuantity: product.quantity,
          tradeDiscount: 0,
          specialCharge: 0,
          rate: orderItem.rate
        };
        itemToAdd.basicPrice = (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(itemToAdd.rate * itemToAdd.quantity) - __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(itemToAdd.tradeDiscount) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(itemToAdd.specialCharge)).toFixed(2);
        itemToAdd.GSTValue = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(itemToAdd.basicPrice * (parseFloat(itemToAdd.taxableGST_rate) / 100)).toFixed(2);
        itemToAdd.totlePrice = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(itemToAdd.basicPrice) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(itemToAdd.GSTValue)).toFixed(2);

        var batchArray = _this10.batch.filter(function (item) {
          return item["brand"] === _this10.selectedBrand && item["product"] === orderItem.productId;
        });
        batchArray.sort(function (a, b) {
          return -(new Date(b.expiryDate) - new Date(a.expiryDate));
        });
        if (batchArray.length) {
          itemToAdd.batchNumber = batchArray[0].batchNumber;
          itemToAdd.expiryDate = batchArray[0].expiryDate ? new Date(batchArray[0].expiryDate).toISOString().substr(0, 10) : new Date(new Date().setFullYear(new Date().getFullYear() + 100)).toISOString().substr(0, 10);
          itemToAdd.manufacturingDate = batchArray[0].manufacturingDate ? new Date(batchArray[0].manufacturingDate).toISOString().substr(0, 10) : new Date(new Date().setFullYear(new Date().getFullYear() + 100)).toISOString().substr(0, 10);
        } else {
          itemToAdd.expiryDate = new Date(new Date().setFullYear(new Date().getFullYear() + 100)).toISOString().substr(0, 10);
          itemToAdd.manufacturingDate = new Date(new Date().setFullYear(new Date().getFullYear() + 100)).toISOString().substr(0, 10);
          itemToAdd.batchNumber = "DEFAULT";
        }
        _this10.items.push(itemToAdd);
      });
      this.calculateGSTType();
    },
    getProductsFromEstimate: function getProductsFromEstimate() {
      var _this11 = this;

      var estimate = this.estimateById[this.$route.params.estimateId];
      var firm = this.firms.filter(function (item) {
        return item[".key"] === estimate.firm;
      })[0];
      this.selectedFirm = firm[".key"];
      this.selectedFirmState = firm["state"];
      this.isBuyer = estimate.isBuyer;
      if (this.isBuyer) {
        this.selectedBuyer = this.buyers.filter(function (item) {
          return item[".key"] === estimate.buyerId;
        })[0];
      } else {
        this.selectedBuyer = this.sellers.filter(function (item) {
          return item[".key"] === estimate.buyerId;
        })[0];
      }
      estimate.items.map(function (estimateItem) {
        var product = _this11.productById[estimateItem.productId];
        var itemToAdd = {
          productId: estimateItem.productId,
          quantity: estimateItem.quantity,
          unit: estimateItem.unit,
          taxableGST_rate: product.taxableGST_rate,
          HSN_code: product.HSN_code,
          productName: product.name,
          GST_type: product.GST_type,
          productUnit: product.unit,
          availableQuantity: product.quantity,
          tradeDiscount: 0,
          specialCharge: 0,
          rate: estimateItem.rate
        };
        itemToAdd.basicPrice = (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(itemToAdd.rate * itemToAdd.quantity) - __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(itemToAdd.tradeDiscount) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(itemToAdd.specialCharge)).toFixed(2);
        itemToAdd.GSTValue = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(itemToAdd.basicPrice * (parseFloat(itemToAdd.taxableGST_rate) / 100)).toFixed(2);
        itemToAdd.totlePrice = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(itemToAdd.basicPrice) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(itemToAdd.GSTValue)).toFixed(2);

        var batchArray = _this11.batch.filter(function (item) {
          return item["brand"] === _this11.selectedBrand && item["product"] === estimateItem.productId;
        });
        batchArray.sort(function (a, b) {
          return -(new Date(b.expiryDate) - new Date(a.expiryDate));
        });
        if (batchArray.length) {
          itemToAdd.batchNumber = batchArray[0].batchNumber;
          itemToAdd.expiryDate = batchArray[0].expiryDate ? new Date(batchArray[0].expiryDate).toISOString().substr(0, 10) : new Date(new Date().setFullYear(new Date().getFullYear() + 100)).toISOString().substr(0, 10);
          itemToAdd.manufacturingDate = batchArray[0].manufacturingDate ? new Date(batchArray[0].manufacturingDate).toISOString().substr(0, 10) : new Date(new Date().setFullYear(new Date().getFullYear() + 100)).toISOString().substr(0, 10);
        } else {
          itemToAdd.expiryDate = new Date(new Date().setFullYear(new Date().getFullYear() + 100)).toISOString().substr(0, 10);
          itemToAdd.manufacturingDate = new Date(new Date().setFullYear(new Date().getFullYear() + 100)).toISOString().substr(0, 10);
          itemToAdd.batchNumber = "DEFAULT";
        }
        _this11.items.push(itemToAdd);
      });
      this.calculateGSTType();
    },
    updateStatus: function updateStatus() {
      switch (this.transactionType) {
        case "Debit":
          {
            this.updateAndEmit("status", "due");
            break;
          }
        case "Partial Paid":
          {
            this.updateAndEmit("status", "partial");
            // if (!this.transactionDialog) this.transactionDialog = true;
            break;
          }
        case "Credit":
          {
            this.updateAndEmit("status", "paid");
            // if (!this.transactionDialog) this.transactionDialog = true;
            break;
          }
      }
    },
    calculateBrokerage: function calculateBrokerage() {
      var _this12 = this;

      var staffObj = this.staffs.filter(function (item) {
        return item[".key"] === _this12.soldBy;
      })[0];
      if (staffObj) {
        this.brokerageRate = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(staffObj.brokerageRate);
        console.log(this.brokerageRate);
      }
    },
    formatDate: function formatDate() {
      var tomorrow = new Date(this.dateFormatted);
      tomorrow.setDate(tomorrow.getDate() + 1);
      this.invoiceDate = new Date(tomorrow).toISOString().substr(0, 10);
    },
    basicInvoicePrint: function basicInvoicePrint(isVertical) {
      var _this13 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var termsAndConditions, firm, customer;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this13.updateAndEmit("totalExtraCharges", _this13.totalExtraCharges);
                _this13.updateStatus();
                termsAndConditions = _this13.getTermsAndConditions();

                _this13.calculateGSTType();
                firm = _this13.firmById[_this13.selectedFirm];

                firm.address = _this13.getAddress(firm);
                customer = _this13.selectedBuyer;

                customer.address = _this13.getAddress(customer);

                if (!isVertical) {
                  _context.next = 18;
                  break;
                }

                if (!_this13.gstInvoice) {
                  _context.next = 14;
                  break;
                }

                _context.next = 12;
                return Object(__WEBPACK_IMPORTED_MODULE_17__utils_pdfmake__["c" /* convertToBasicInvoice */])({
                  invoiceData: _this13.invoiceDraft,
                  firm: firm,
                  customer: customer,
                  gstTotal: _this13.GST_Val_total,
                  terms: termsAndConditions[0]
                }).then(function (doc) {
                  pdfMake.createPdf(doc).download();
                });

              case 12:
                _context.next = 16;
                break;

              case 14:
                _context.next = 16;
                return Object(__WEBPACK_IMPORTED_MODULE_17__utils_pdfmake__["f" /* convertToBasicInvoiceWithoutGST */])({
                  invoiceData: _this13.invoiceDraft,
                  firm: firm,
                  customer: customer,
                  gstTotal: _this13.GST_Val_total,
                  terms: termsAndConditions[0]
                }).then(function (doc) {
                  pdfMake.createPdf(doc).download();
                });

              case 16:
                _context.next = 25;
                break;

              case 18:
                if (!_this13.gstInvoice) {
                  _context.next = 23;
                  break;
                }

                _context.next = 21;
                return Object(__WEBPACK_IMPORTED_MODULE_17__utils_pdfmake__["e" /* convertToBasicInvoiceHorizontal */])({
                  invoiceData: _this13.invoiceDraft,
                  firm: firm,
                  customer: customer,
                  gstTotal: _this13.GST_Val_total,
                  terms: termsAndConditions[0]
                }).then(function (doc) {
                  pdfMake.createPdf(doc).download();
                });

              case 21:
                _context.next = 25;
                break;

              case 23:
                _context.next = 25;
                return Object(__WEBPACK_IMPORTED_MODULE_17__utils_pdfmake__["f" /* convertToBasicInvoiceWithoutGST */])({
                  invoiceData: _this13.invoiceDraft,
                  firm: firm,
                  customer: customer,
                  gstTotal: _this13.GST_Val_total,
                  terms: termsAndConditions[0]
                }).then(function (doc) {
                  pdfMake.createPdf(doc).download();
                });

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this13);
      }))();
    },
    printInvoice4: function printInvoice4(isSave) {
      var _this14 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var termsAndConditions, firm, customer;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this14.updateAndEmit("totalExtraCharges", _this14.totalExtraCharges);
                _this14.updateStatus();
                termsAndConditions = _this14.getTermsAndConditions();

                _this14.calculateGSTType();
                firm = _this14.firmById[_this14.selectedFirm];

                firm.address = _this14.getAddress(firm);
                customer = _this14.selectedBuyer;

                customer.address = _this14.getAddress(customer);
                _context2.next = 10;
                return Object(__WEBPACK_IMPORTED_MODULE_17__utils_pdfmake__["p" /* convertToSimpleInvoicePrint */])({
                  invoiceData: _this14.invoiceDraft,
                  firm: firm,
                  customer: customer,
                  gstTotal: _this14.GST_Val_total,
                  terms: termsAndConditions[0]
                }).then(function (doc) {
                  // pdfMake.createPdf(doc).download(this.invoiceId);
                  doc['info'] = { title: _this14.invoiceId };
                  pdfMake.createPdf(doc).print({}, window.frames['printPdf']);
                });

              case 10:
                if (isSave) {
                  _this14.saveInvoice();
                }

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this14);
      }))();
    },
    getTermsAndConditions: function getTermsAndConditions() {
      var _this15 = this;

      var termsAndConditions = this.termsAndConditions.filter(function (item) {
        return item["brand"] === _this15.selectedBrand && item["firm"] === _this15.selectedFirm;
      });
      if (termsAndConditions.length) {
        if (termsAndConditions[0].bank) {
          var banks = [];
          termsAndConditions[0].bank.map(function (bankId) {
            var bank = _this15.bankById[bankId];
            bank.address = _this15.getAddress(bank);
            banks.push(bank);
          });
          termsAndConditions[0].banks = banks;
        } else {
          termsAndConditions[0].banks = [];
        }
      } else {
        termsAndConditions = [{
          termsAndConditions: "",
          banks: []
        }];
      }
      return termsAndConditions;
    },
    getAddress: function getAddress(item) {
      if (!item) {
        return "";
      }
      var address = (item.village ? item.village + ", " : "") + (item.block ? item.block + ", " : "") + (item.tehsil ? item.tehsil + ", " : "") + (item.district ? item.district + ", " : "") + (item.state ? item.state + ", " : "") + (item.country ? item.country + ", " : "");
      address = address.substring(0, address.length - 2);
      return address;
    },
    resetAmounts: function resetAmounts() {
      this.amountFromCash = 0;
      this.amountFromBank = 0;
      this.discountAmount = 0;
    },


    // NEw Development
    getFirmAndBankBalance: function getFirmAndBankBalance() {
      var _this16 = this;

      var selectedFirm = this.firms.filter(function (item) {
        return item["brand"] === _this16.selectedBrand && item[".key"] == _this16.selectedFirm;
      });
      this.businessType = selectedFirm[0].businessType;
      this.gstInvoice = selectedFirm[0].GST_user && selectedFirm[0].GST_user == "Yes" ? true : false;
      var selectedBank = this.selectedBank ? this.banks.filter(function (item) {
        return item["brand"] === _this16.selectedBrand && item[".key"] == _this16.selectedBank;
      }) : null;
      switch (this.paymentType) {
        case "Cash":
          {
            if (this.selectedFirm) {
              this.availableBalance = selectedFirm.length && (selectedFirm[0]["amount"] ? selectedFirm[0]["amount"] : 0);
            } else {
              this.availableBalance = 0;
            }
            break;
          }
        case "Bank Account":
          {
            if (this.selectedBank) {
              this.availableBalance = selectedBank.length && (selectedBank[0]["amount"] ? selectedBank[0]["amount"] : 0);
            } else {
              this.availableBalance = 0;
            }
            break;
          }
        case "CashAndBank Account":
          {
            if (this.selectedFirm && this.selectedBank) {
              this.availableBalance = selectedFirm.length && selectedBank.length && (selectedBank[0]["amount"] ? selectedBank[0]["amount"] : 0) + (selectedFirm[0]["amount"] ? selectedFirm[0]["amount"] : 0);
            } else {
              this.availableBalance = 0;
            }
            break;
          }
      }
    },
    editItem: function editItem(item, fromDialog) {
      this.editedIndex = this.items.indexOf(item);
      this.editedItem = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, item);
      this.isEditItems = true;
      if (!fromDialog) {
        this.dialog = true;
      }
    },
    deleteItem: function deleteItem(item) {
      var index = this.items.indexOf(item);
      confirm("Are you sure you want to delete this item?") && this.items.splice(index, 1);
    },
    close: function close(saveAddItem) {
      var _this17 = this;

      if (!saveAddItem) {
        this.dialog = false;
      } else {
        this.focusAddProduct();
      }
      setTimeout(function () {
        _this17.editedItem = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this17.defaultItem);
        _this17.editedIndex = -1;
      }, 300);
    },
    calculateTotal: function calculateTotal(type) {
      var discountAmount = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.discountAmount);
      var amountFromBank = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.amountFromBank);
      var amountFromCash = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.amountFromCash);
      var totalAmount = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.totalAmount);
      switch (this.paymentType) {
        case "Cash":
          {
            this.amountFromBank = 0;
            this.amountFromBankDisabled = true;
            switch (this.transactionType) {
              case "Debit":
                {
                  this.amountFromCashDisabled = true;
                  this.amountFromCash = totalAmount;
                  this.remainingAmount = totalAmount;
                  this.paidAmount = 0;
                  break;
                }
              case "Partial Paid":
                {
                  this.amountFromCashDisabled = false;
                  this.remainingAmount = totalAmount - amountFromCash;
                  this.paidAmount = amountFromCash;
                  break;
                }
              case "Credit":
                {
                  this.amountFromCashDisabled = true;
                  this.amountFromCash = totalAmount;
                  this.remainingAmount = 0;
                  this.paidAmount = totalAmount;
                  break;
                }
            }
            break;
          }
        case "Bank Account":
          {
            this.amountFromCashDisabled = true;
            this.amountFromCash = 0;
            switch (this.transactionType) {
              case "Debit":
                {
                  this.amountFromBankDisabled = true;
                  this.amountFromBank = totalAmount;
                  this.remainingAmount = totalAmount;
                  this.paidAmount = 0;
                  break;
                }
              case "Partial Paid":
                {
                  this.amountFromBankDisabled = false;
                  this.remainingAmount = totalAmount - amountFromBank;
                  this.paidAmount = amountFromBank;
                  break;
                }
              case "Credit":
                {
                  this.amountFromBankDisabled = true;
                  this.amountFromBank = totalAmount;
                  this.remainingAmount = 0;
                  this.paidAmount = totalAmount;
                  break;
                }
            }
            break;
          }
        case "CashAndBank Account":
          {
            this.amountFromCashDisabled = false;
            this.amountFromBankDisabled = false;
            var totalBankAndCash = amountFromCash + amountFromBank;
            switch (this.transactionType) {
              case "Debit":
                {
                  this.remainingAmount = totalAmount;
                  this.paidAmount = 0;
                  break;
                }
              case "Partial Paid":
                {
                  this.paidAmount = totalBankAndCash;
                  this.remainingAmount = totalAmount - paidAmount;
                  break;
                }
              case "Credit":
                {
                  this.remainingAmount = 0;
                  this.paidAmount = totalAmount;
                  break;
                }
            }
            break;
          }
        case "":
          {
            this.amountFromCashDisabled = true;
            this.amountFromBankDisabled = true;
            this.amountFromCash = 0;
            this.amountFromBank = 0;
            this.paidAmount = 0;
            this.remainingAmount = totalAmount;
            break;
          }
      }
      this.paidAmount = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.paidAmount).toFixed(parseInt(this.roundOff));
      if (type != "amountFromCash") this.amountFromCash = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.amountFromCash).toFixed(parseInt(this.roundOff));
      if (type != "amountFromBank") this.amountFromBank = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.amountFromBank).toFixed(parseInt(this.roundOff));
      this.remainingAmount = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.remainingAmount).toFixed(parseInt(this.roundOff));
      this.updateAndEmit("paidAmount", this.paidAmount);
      this.updateAndEmit("amountFromCash", this.amountFromCash);
      this.updateAndEmit("amountFromBank", this.amountFromBank);
      this.updateAndEmit("remainingAmount", this.remainingAmount);
    },
    save: function save(editedItem, saveAndAdd) {
      var _this18 = this;

      if (this.editedIndex > -1) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.items[this.editedIndex], editedItem);
      } else {
        this.items.push(editedItem);
      }
      this.calculateGSTType();
      setTimeout(function () {
        _this18.editedItem = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this18.defaultItem);
        _this18.editedIndex = -1;
        _this18.isEditItems = false;
      }, 300);
      this.close(saveAndAdd);
    },
    calculateGSTType: function calculateGSTType() {
      var _this19 = this;

      if (this.selectedBuyer) {
        this.GST_Val_total.SGST_val = 0;
        this.GST_Val_total.CGST_val = 0;
        this.GST_Val_total.IGST_val = 0;
        if (this.isIncentive) {
          this.incentives.sort(function (a, b) {
            return new Date(a.order) - new Date(b.order);
          });
        }
        var isProductRoundOff = this.firmSetting && this.firmSetting.roundOff;
        this.items.map(function (item, index) {
          var GST = item["taxableGST_rate"];
          var firm = _this19.firmById[_this19.selectedFirm];
          var itemIncentive = 0;
          _this19.incentives.map(function (inc) {
            if (!!inc.percentage) {
              itemIncentive += (parseFloat(item.basicPrice) - parseFloat(itemIncentive)) * (parseFloat(inc.percentage) / 100);
            }
          });
          item.incentiveAmount = itemIncentive;
          if (isProductRoundOff) {
            var GSTValue = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()((item.basicPrice - itemIncentive) * (parseFloat(item.taxableGST_rate) / 100)).toFixed(2);
            var totlePrice = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.basicPrice - itemIncentive) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.GSTValue)).toFixed(2);
            item.GSTValue = Math.round(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(GSTValue));
            item.totlePrice = Math.round(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(totlePrice));
          } else {
            item.GSTValue = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()((item.basicPrice - itemIncentive) * (parseFloat(item.taxableGST_rate) / 100)).toFixed(2);
            item.totlePrice = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.basicPrice - itemIncentive) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.GSTValue)).toFixed(2);
          }
          if (!_this19.selectedBuyer.state || _this19.selectedFirm && _this19.selectedBuyer.state && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(GST) && firm.state === _this19.placeOfSupply) {
            item["CGST_val"] = item["GSTValue"] / 2;
            item["CGST"] = GST / 2;
            item["SGST_val"] = item["GSTValue"] / 2;
            item["SGST"] = GST / 2;
            item["IGST"] = 0;
            item["IGST_val"] = 0;
            _this19.GST_Val_total.SGST_val += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item["SGST_val"]);
            _this19.GST_Val_total.CGST_val += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item["CGST_val"]);
            _this19.GST_Val_total.IGST_val += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item["IGST_val"]);
            _this19.updateAndEmit("gstType", "SGST|CGST");
          } else {
            item["IGST"] = GST;
            item["CGST"] = 0;
            item["SGST"] = 0;
            item["IGST_val"] = item["GSTValue"];
            item["CGST_val"] = 0;
            item["SGST_val"] = 0;
            _this19.GST_Val_total.SGST_val += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item["SGST_val"]);
            _this19.GST_Val_total.CGST_val += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item["CGST_val"]);
            _this19.GST_Val_total.IGST_val += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item["IGST_val"]);
            _this19.updateAndEmit("gstType", "IGST");
            _this19.totalTradeDiscount += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item["tradeDiscount"]);
            _this19.totalSpecialCharge += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item["specialCharge"]);
          }
          _this19.items[index] = item;
        });
        this.GST_Percentage_total = Object(__WEBPACK_IMPORTED_MODULE_19__utils___["c" /* getGSTPercentageTotal */])(this.items);
        this.updateAndEmit("items", this.items);
        this.updateAndEmit("tradeDiscount", this.totalTradeDiscount);
        this.updateAndEmit("specialCharge", this.totalSpecialCharge);
      }
    },
    updateAndEmit: function updateAndEmit(key, value) {
      this.invoiceDraft[key] = value;
    },
    saveAndPrint: function saveAndPrint(vertical) {
      this.basicInvoicePrint(vertical);
      this.saveInvoice();
    },
    ewayBillSave: function ewayBillSave(ewayBillDetails) {
      this.updateAndEmit("ewayBillDetails", ewayBillDetails);
      // this.ewayBillDialog = false;
      this.saveInvoice();
    },
    eWayBillPrint: function eWayBillPrint() {
      this.updateStatus();
      this.updateAndEmit("isBuyer", this.isBuyer);
      this.updateAndEmit("transactionType", this.transactionType);
      this.updateAndEmit("buyerId", this.selectedBuyer[".key"]);
      this.updateAndEmit("totalExtraCharges", this.totalExtraCharges);
      this.updateAndEmit("extraCharges", this.extraCharges);
      this.updateAndEmit("incentives", this.incentives);
      this.updateAndEmit("totalAmount", this.principalValueTotal);
      // this.ewayBillDialog = true;
    },
    saveInvoice: function saveInvoice() {
      var _this20 = this;

      this.updateStatus();
      this.updateAndEmit("isBuyer", this.isBuyer);
      this.updateAndEmit("transactionType", this.transactionType);
      this.updateAndEmit("buyerId", this.selectedBuyer[".key"]);
      this.updateAndEmit("totalExtraCharges", this.totalExtraCharges);
      this.updateAndEmit("extraCharges", this.extraCharges);
      this.updateAndEmit("incentives", this.incentives);
      this.updateAndEmit("totalAmount", this.principalValueTotal);
      //this.updateInvoice(this.invoiceDraft);
      var p = new Ping({ timeout: 3000 });
      p.ping("http://google.com", function (err, data) {
        // Also display error if err is returned.
        if (err) {
          _this20.snackbar = true;
          _this20.snackbarMsg = 'It seems like you are offline. Check your Internet Connectivity.';
          console.log("error loading resource");
          data = data + " " + err;
        } else {
          _this20.snackbar = false;
          if (_this20.firmSetting && _this20.firmSetting.verifiedInvoice) {
            var firm = _this20.firms.filter(function (item) {
              return item['.key'] == _this20.selectedFirm;
            })[0];
            if (firm.mobileNumber) {
              _this20.otpData.mobile = firm.mobileNumber;
              _this20.otpData.otp = Math.floor(100000 + Math.random() * 900000);
              var message = "OTP for Invoice of Amount \u20B9" + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_this20.totalAmount).toFixed(2) + " under " + (_this20.selectedBuyer.name ? _this20.selectedBuyer.name : '') + " is " + _this20.otpData.otp + ". Please enter otp in portal to continue.";
              _this20.snackbar = true;
              _this20.snackbarMsg = 'Sending verification OTP.';
              Object(__WEBPACK_IMPORTED_MODULE_18__services_twilio_js__["a" /* sendSms */])(["+91" + firm.mobileNumber], message).then(function (response) {
                console.log(response);
                _this20.otpData.dialog = true;
              });
            }
          } else {
            _this20.updateInvoice(_this20.invoiceDraft);
          }
        }
      });
    },
    confirmOTP: function confirmOTP() {
      if (this.otpData.otp == this.otpData.confirmOtp) {
        this.updateInvoice(this.invoiceDraft);
        this.otpData.dialog = false;
      }
    },
    getCurrentUser: function getCurrentUser() {
      var _this21 = this;

      this.placeOfSupply = this.selectedBuyer ? this.selectedBuyer.state : null;
      if (!this.selectedFirm) {
        // if(this.selectedBuyer && this.selectedBuyer.defaultFirm) {
        //   this.selectedFirm = this.selectedBuyer.defaultFirm;
        // }
        // else {
        var defaultFirm = this.firms.filter(function (item) {
          return item["brand"] === _this21.selectedBrand && !!item["defaultFirm"];
        })[0];
        this.selectedFirm = defaultFirm[".key"];
        this.selectedFirmState = defaultFirm["state"];
        if (!this.placeOfSupply && this.selectedFirmState) {
          this.placeOfSupply = this.selectedFirmState;
        }
        this.businessType = defaultFirm["businessType"];
        //}
      }
      this.getFirmAndBankBalance();
    },
    updateInvoice: function updateInvoice(invoiceData) {
      var _this22 = this;

      console.log('Update Invoice Called');
      this.manageBeforePayments(invoiceData['.key']);
      if (invoiceData.transferDetails) {}
      // this.dialog = false
      console.info(invoiceData);
      var updated_at = new Date().getTime();
      // debugger
      try {
        //   invoiceData['items'].forEach((item, index) => {
        //   item['date'] = invoiceData['date']
        //   if(item.id) {
        //     item['updated_at'] = updated_at;
        //     this.$root.$firebaseRefs.item.child(item['id']).update(item, () => {
        //       console.info('item updated...')
        //     })
        //   } else {
        //     const response = this.$root.$firebaseRefs.item.push(item, () => {
        //       console.info('item pushed...')
        //     })
        //     invoiceData['items'][index]['id'] = response['key']
        //   }
        // })
        invoiceData['updated_at'] = updated_at;
        var key = invoiceData['.key'];
        delete invoiceData['.key'];

        this.$root.$firebaseRefs.invoice.child(key).update(invoiceData, function () {
          console.info('invoice updated...');
          _this22.managePayments(invoiceData);
        });
        invoiceData['parentInvoiceKey'] = key;

        var histories = this.invoiceHistories.filter(function (item) {
          return item['brand'] == _this22.selectedBrand && item['parentInvoiceKey'] == key;
        });
        // if(this.isPaymentDone) {
        //   histories.map((h)=>{
        //     this.$root.$firebaseRefs.buyer.invoiceHistory(h['.key']).remove();
        //   })
        //   invoiceData["newlyCreated"] = true;
        //   invoiceData["isLatest"] = true;
        //   this.$root.$firebaseRefs.invoiceHistory.push(invoiceData);
        // } else {
        histories.map(function (h) {
          if (h.isLatest == true || h.isLatest == false) {
            invoiceData['isLatest'] = h.isLatest;
          } else {
            delete invoiceData['isLatest'];
          }

          if (h.newlyCreated == true || h.newlyCreated == false) {
            invoiceData['newlyCreated'] = h.newlyCreated;
          } else {
            delete invoiceData['newlyCreated'];
          }
          var key = h['.key'];
          _this22.$root.$firebaseRefs.invoiceHistory.child(key).update(invoiceData, function () {});
        });
        //}
      } catch (e) {
        console.info('Error at update Invoice', e);
      }
      //this.$router.push({path: `/buyers/${this.selectedBuyer['.key']}` })
    },
    sendNotification: function sendNotification() {
      if (this.selectedBuyer.mobile) {
        var message = "Hi, " + (this.selectedBuyer.name ? this.selectedBuyer.name : '') + " Invoice of Amount \u20B9" + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.totalAmount).toFixed(2) + " has been created. Thank You!";
        Object(__WEBPACK_IMPORTED_MODULE_18__services_twilio_js__["a" /* sendSms */])(["+91" + this.selectedBuyer.mobile], message);
      }
      this.sendWhatsappNotificationToBrandAdmin();
    },
    sendWhatsappNotificationToBrandAdmin: function sendWhatsappNotificationToBrandAdmin() {
      var _this23 = this;

      var message = "Invoice of amount \u20B9" + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.totalAmount).toFixed(2) + " has been created, under " + (this.selectedBuyer.name ? this.selectedBuyer.name : '') + ".";
      var adminUsers = this.operatorsList.filter(function (item) {
        return item["brand"] === _this23.selectedBrand && item["role"] == 'admin';
      });
      var mobileNumbers = [];
      adminUsers.map(function (user) {
        if (user.mobile && user.notificationWSAPP) {
          mobileNumbers.push("+91" + user.mobile);
        }
      });
      Object(__WEBPACK_IMPORTED_MODULE_18__services_twilio_js__["b" /* sendWhatsApp */])(mobileNumbers, message);
    },
    managePayments: function managePayments(invoiceData) {
      //let beforeUpdateInvoice = this.invoices.filter(item => item['.key'] === invoiceData['.key'])[0];
      switch (invoiceData.paymentType) {
        case 'Cash':
          {
            if (invoiceData.amountFromCash) {
              var firm = this.firms.filter(function (item) {
                return item['.key'] == invoiceData.firm;
              })[0];
              if (firm && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                firm.amount = this.isBuyer ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(firm.amount) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash) : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(firm.amount) - __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash);
                delete firm['.key'];
                this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(firm);
              }
            }
            break;
          }
        case 'Bank Account':
          {
            if (invoiceData.amountFromBank) {
              var bank = this.banks.filter(function (item) {
                return item['.key'] == invoiceData.bank;
              })[0];
              if (bank && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                bank.amount = this.isBuyer ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(bank.amount) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank) : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(bank.amount) - __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank);
                delete bank['.key'];
                this.$root.$firebaseRefs.account.child(invoiceData.bank).set(bank);
              }
            }
            break;
          }
        case 'CashAndBank Account':
          {
            if (invoiceData.amountFromCash && invoiceData.amountFromBank) {
              var _bank = this.banks.filter(function (item) {
                return item['.key'] == invoiceData.bank;
              })[0];
              if (_bank && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                _bank.amount = this.isBuyer ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_bank.amount) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank) : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_bank.amount) - __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank);
                delete _bank['.key'];
                this.$root.$firebaseRefs.account.child(invoiceData.bank).set(_bank);
              }
              var _firm = this.firms.filter(function (item) {
                return item['.key'] == invoiceData.firm;
              })[0];
              if (_firm && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                _firm.amount = this.isBuyer ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_firm.amount) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash) : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_firm.amount) - __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash);
                delete _firm['.key'];
                this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(_firm);
              }
            }
            break;
          }
      }
      this.manageProductsQuantity(invoiceData);
    },
    manageProductsQuantity: function manageProductsQuantity(invoiceData) {
      var _this24 = this;

      invoiceData.items.map(function (item) {
        var key = item['productId'];
        var product = _this24.productById[key];
        if (_this24.isBuyer) {
          var saleQuantity = product['saleQuantity'] ? product['saleQuantity'] : 0;
          saleQuantity = saleQuantity + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_int___default()(item.quantity);
          product['saleQuantity'] = saleQuantity;
        } else {
          var purchaseQuantity = product['purchaseQuantity'] ? product['purchaseQuantity'] : 0;
          purchaseQuantity = purchaseQuantity + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_int___default()(item.quantity);
          product['purchaseQuantity'] = purchaseQuantity;
        }
        var prodQuantity = product['quantity'];
        prodQuantity = _this24.isBuyer ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_int___default()(prodQuantity) - __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_int___default()(item.quantity) : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_int___default()(prodQuantity) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_int___default()(item.quantity);
        delete product['.key'];
        product['quantity'] = prodQuantity;
        _this24.$root.$firebaseRefs.products.child(key).set(product);
      });
      this.snackbarSuccess = true;
      this.resetInvoice();
    },
    manageBeforePayments: function manageBeforePayments(key) {
      var invoiceData = this.invoiceDraftPrevious;
      switch (invoiceData.paymentType) {
        case 'Cash':
          {
            if (invoiceData.amountFromCash) {
              var firm = this.firms.filter(function (item) {
                return item['.key'] == invoiceData.firm;
              })[0];
              if (firm && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                firm.amount = this.isBuyer ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(firm.amount) - __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash) : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(firm.amount) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash);
                delete firm['.key'];
                this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(firm);
              }
            }
            break;
          }
        case 'Bank Account':
          {
            if (invoiceData.amountFromBank) {
              var bank = this.banks.filter(function (item) {
                return item['.key'] == invoiceData.bank;
              })[0];
              if (bank && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                bank.amount = this.isBuyer ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(bank.amount) - __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank) : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(bank.amount) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank);
                delete bank['.key'];
                this.$root.$firebaseRefs.account.child(invoiceData.bank).set(bank);
              }
            }
            break;
          }
        case 'CashAndBank Account':
          {
            if (invoiceData.amountFromCash && invoiceData.amountFromBank) {
              var _bank2 = this.banks.filter(function (item) {
                return item['.key'] == invoiceData.bank;
              })[0];
              if (_bank2 && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                _bank2.amount = this.isBuyer ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_bank2.amount) - __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank) : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_bank2.amount) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank);
                delete _bank2['.key'];
                this.$root.$firebaseRefs.account.child(invoiceData.bank).set(_bank2);
              }
              var _firm2 = this.firms.filter(function (item) {
                return item['.key'] == invoiceData.firm;
              })[0];
              if (_firm2 && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                _firm2.amount = this.isBuyer ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_firm2.amount) - __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash) : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_firm2.amount) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash);
                delete _firm2['.key'];
                this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(_firm2);
              }
            }
            break;
          }
      }
      this.manageBeforeProductsQuantity(invoiceData);
    },
    manageBeforeProductsQuantity: function manageBeforeProductsQuantity(invoiceData) {
      var _this25 = this;

      invoiceData.items.map(function (item) {
        var key = item['productId'];
        var product = _this25.productById[key];
        if (_this25.isBuyer) {
          var saleQuantity = product['saleQuantity'] ? product['saleQuantity'] : 0;
          saleQuantity = saleQuantity - __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_int___default()(item.quantity);
          product['saleQuantity'] = saleQuantity;
        } else {
          var purchaseQuantity = product['purchaseQuantity'] ? product['purchaseQuantity'] : 0;
          purchaseQuantity = purchaseQuantity - __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_int___default()(item.quantity);
          product['purchaseQuantity'] = purchaseQuantity;
        }
        var prodQuantity = product['quantity'];
        prodQuantity = _this25.isBuyer ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_int___default()(prodQuantity) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_int___default()(item.quantity) : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_int___default()(prodQuantity) - __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_int___default()(item.quantity);
        delete product['.key'];
        product['quantity'] = prodQuantity;
        _this25.$root.$firebaseRefs.products.child(key).set(product);
      });
    },
    addBatchDetails: function addBatchDetails(product, isBuyer) {
      var _this26 = this;

      console.log("adding batch details");
      console.log(product);
      var batchArray = this.batch.filter(function (item) {
        return item["batchNumber"] == product.batchNumber && item["brand"] === _this26.selectedBrand && item["product"] === product.productId;
      });
      if (batchArray.length) {
        // let batchObj = batchArray[0];
        var batchObj = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(batchArray[0]));
        batchObj.quantity = isBuyer ? batchObj.quantity - product.quantity : batchObj.quantity + product.quantity;
        var key = batchObj[".key"];
        delete batchObj[".key"];
        this.$root.$firebaseRefs.batchTransaction.child(key).set(batchObj);
      } else {
        var _batchObj = {
          quantity: isBuyer ? -product.quantity : product.quantity,
          // expiryDate : product.expiryDate,
          // manufacturingDate :product.manufacturingDate,
          expiryDate: new Date(product.expiryDate).getTime(),
          manufacturingDate: new Date(product.manufacturingDate).getTime(),
          product: product.productId,
          batchNumber: product.batchNumber,
          brand: this.selectedBrand,
          createdDate: new Date().getTime()
        };
        this.$root.$firebaseRefs.batchTransaction.push(_batchObj);
      }
      delete product["expiryDate"];
      delete product["manufacturingDate"];
      delete product["batchNumber"];
    },
    resetInvoice: function resetInvoice() {
      var _this27 = this;

      this.$router.push({ path: "/buyers/" + this.selectedBuyer['.key'] })(this.selectedBuyer = null), this.isBuyer = true, this.isEditItems = false, this.duplicateError = null, this.items = [], this.totalTradeDiscount = 0, this.totalSpecialCharge = 0, this.editedIndex = -1, this.editedItem = {
        productName: "",
        productId: "",
        HSN_code: "",
        taxableGST_rate: 0,
        rate: 0,
        unit: "",
        quantity: 0,
        basicPrice: 0,
        GSTValue: 0,
        totlePrice: 0,
        tradeDiscount: 0,
        specialCharge: 0
      }, this.defaultItem = {
        productName: "",
        productId: "",
        HSN_code: "",
        taxableGST_rate: 0,
        rate: 0,
        unit: "",
        quantity: 0,
        basicPrice: 0,
        GSTValue: 0,
        totlePrice: 0,
        tradeDiscount: 0,
        specialCharge: 0
      }, this.amountFromCash = 0, this.amountFromBank = 0, this.alertDuration = 0, this.paymentType = "",
      // this.selectedFirm= "",
      this.selectedBank = "", this.soldBy = "", this.brokerageRate = 0,
      // this.godawnBy = '',
      this.placeOfSupply = "", this.invoiceDate = new Date().toISOString().substr(0, 10), this.dateFormatted = new Date().toISOString().substr(0, 10), this.datepicker = false, this.totalAmount = 0, this.paidAmount = 0, this.remainingAmount = 0, this.discountAmount = 0, this.roundOffAmount = 0,
      // this.invoiceDraft= {},
      this.transferType = null, this.transferTypeDialog = false, this.availableBalance = 0, this.transactionType = "Debit", this.amountFromCashDisabled = true, this.amountFromBankDisabled = true, this.status = null, this.gstType = null, this.currentUser = null, this.remark = null, this.invoiceId = null, this.GST_Val_total = {
        CGST_val: 0,
        SGST_val: 0,
        IGST_val: 0
      }, this.GST_Percentage_total = {
        GST_0: 0,
        GST_5: 0,
        GST_12: 0,
        GST_18: 0,
        GST_28: 0
      }, this.roundOff = 2, this.transactionDialog = false, this.expansionVal = false, this.transferDetails = {
        accountNumber: null,
        accountHolderName: null,
        bankName: null,
        IFSCcode: null,
        remark: null
      };
      this.isIncentive = false;
      this.incentives = [];
      this.extraCharges = [];
      this.totalExtraCharges = 0;
      this.invoiceDraft = {
        items: this.items,
        amountFromCash: this.amountFromCash || 0,
        amountFromBank: this.amountFromBank || 0,
        brand: this.selectedBrand,
        date: Date.now(),
        transferDetails: this.transferDetails,
        transferType: ["Cash", ""].includes(this.paymentType) ? "0" : this.transferType,
        duration: this.alertDuration, // days
        paymentType: this.paymentType,
        transactionType: this.transactionType,
        isCredited: false,
        firm: this.selectedFirm,
        bank: ["Cash", ""].includes(this.paymentType) ? 0 : this.selectedBank,
        totalAmount: this.principalValueTotal || 0,
        paidAmount: this.paidAmount || 0,
        remainingAmount: this.remainingAmount || 0,
        discountAmount: this.discountAmount || 0,
        roundOffAmount: this.roundOffAmount || 0,
        status: this.status,
        gstType: this.gstType,
        invoiceId: this.invoiceId,
        soldBy: this.soldBy,
        brokerageRate: this.brokerageRate,
        // godawnBy : this.godawnBy,
        placeOfSupply: this.placeOfSupply,
        totalTradeDiscount: this.totalTradeDiscount,
        totalSpecialCharge: this.totalSpecialCharge,
        remark: this.remark
      };
      this.selectedProductSet = null;

      this.updateAndEmit("date", new Date(this.invoiceDate).getTime());
      setTimeout(function () {
        _this27.getCurrentUser();
      }, 1000);
    },

    addCharges: function addCharges(e) {
      var obj = {
        name: e.target.value,
        amount: 0
      };
      this.extraChargesSample.push(obj);
    },
    addCustomer: function addCustomer(e) {
      this.getCurrentUser();
      var obj = {
        name: e.target.value,
        brand: this.selectedBrand
      };
      if (this.selectedFirmState) {
        obj["state"] = this.selectedFirmState;
      }

      if (this.isBuyer) {
        this.$root.$firebaseRefs.buyer.push(obj);
      } else {
        this.$root.$firebaseRefs.seller.push(obj);
      }
    }
  }
}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$data$comp, "mounted", function mounted() {
  var self = this;
  this._keyListener = function (e) {
    var key;
    var isShift;
    if (window.event) {
      key = window.event.keyCode;
      isShift = !!window.event.shiftKey; // typecast to boolean
    } else {
      key = ev.which;
      isShift = !!ev.shiftKey;
    }
    if (isShift) {
      switch (key) {
        case 16:
          // ignore shift key
          break;
        default:
          {
            switch (window.event.key) {
              case 'N':
                {
                  self.dialog = true;
                  console.log('add new item');
                  break;
                }
              case 'A':
                {
                  if (self.dialog) {
                    var btn = document.getElementsByClassName('add-save-btn-add-icons');
                    if (!btn[0].classList.contains('v-btn--disabled')) {
                      document.getElementsByClassName('add-save-btn-add-icons')[0].click();
                    }
                    console.log('save and add');
                  }
                  break;
                }
              case 'S':
                {
                  if (self.dialog) {
                    var _btn = document.getElementsByClassName('add-btn-add-icons');
                    if (!_btn[0].classList.contains('v-btn--disabled')) {
                      document.getElementsByClassName('add-btn-add-icons')[0].click();
                    }
                    console.log('save');
                  }
                  break;
                }
              case 'C':
                {
                  if (self.dialog) {
                    document.getElementsByClassName('cancel-btn-add-icons')[0].click();
                    console.log('cancel');
                  }
                  break;
                }
              case 'W':
                {
                  //document.getElementsByClassName('js-customer-switcher')[0].click()
                  this.isBuyer = !this.isBuyer;
                  setTimeout(function () {
                    document.querySelector('.js-select-buyer input').click();
                  }, 1000);
                  console.log('cancel');
                  break;
                }
              case 'P':
                {
                  if (!self.dialog && self.selectedFirm && self.transactionType && self.items.length) {
                    self.saveAndPrint(true);
                    console.log('save and print');
                  }
                  break;
                }
              case 'Z':
                {
                  if (!self.dialog && self.selectedFirm && self.transactionType && self.items.length) {
                    self.saveInvoice(true);
                    console.log('save');
                  }
                  break;
                }
              case 'H':
                {
                  if (!self.dialog && self.selectedFirm && self.transactionType && self.items.length) {
                    self.basicInvoicePrint(false);
                    console.log('horizontal print');
                  }
                  break;
                }
              case 'V':
                {
                  if (!self.dialog && self.selectedFirm && self.transactionType && self.items.length) {
                    self.basicInvoicePrint(true);
                    console.log('vertical print');
                  }
                  break;
                }
              case 'E':
                {
                  if (!self.dialog && self.selectedFirm && self.transactionType && self.items.length) {
                    self.eWayBillPrint();
                    console.log('eway print');
                  }
                  break;
                }
              case 'G':
                {
                  this.$router.push({ path: "/settings/product-grouping/true/invoice" });
                  break;
                }
              case 'T':
                {
                  this.$router.push({ path: "/settings/product-set/true/invoice" });
                  break;
                }
                break;
            }
          }
      }
    };
  };
  //document.addEventListener('keydown', this._keyListener.bind(this));
  this._keyListener1 = function (e) {
    if (window.event.keyCode == 73 && window.event.ctrlKey) {
      //ctrl + i
      window.event.preventDefault();
      self.dialog = true;
      console.log('add new item');
    }
    if (window.event.keyCode == 32) {
      // space 
      if (self.dialog) {
        var btn = document.getElementsByClassName('add-save-btn-add-icons');
        if (!btn[0].classList.contains('v-btn--disabled')) {
          window.event.preventDefault();
          document.getElementsByClassName('add-save-btn-add-icons')[0].click();
          console.log('save and add');
        }
      }
    }
    if (window.event.keyCode == 13) {
      //enter
      if (self.dialog) {
        window.event.preventDefault();
        var _btn2 = document.getElementsByClassName('add-btn-add-icons');
        if (!_btn2[0].classList.contains('v-btn--disabled')) {
          document.getElementsByClassName('add-btn-add-icons')[0].click();
        }
        console.log('save');
      }
    }
    if (window.event.keyCode == 27) {
      //escape
      if (self.dialog) {
        window.event.preventDefault();
        document.getElementsByClassName('cancel-btn-add-icons')[0].click();
        console.log('cancel');
      }
    }
    if (window.event.keyCode == 70 && window.event.ctrlKey) {
      //ctrl + f
      this.isBuyer = !this.isBuyer;
      window.event.preventDefault();
      setTimeout(function () {
        document.querySelector('.js-select-buyer input').click();
      }, 1000);
      console.log('switch to purchase/sale');
    }
    if (window.event.keyCode == 80 && window.event.ctrlKey) {
      //ctrl + p
      if (!self.dialog && self.selectedFirm && self.transactionType && self.items.length) {
        window.event.preventDefault();
        self.saveAndPrint(true);
        console.log('Save and Print');
      }
    }
    if (window.event.keyCode == 83 && window.event.ctrlKey) {
      //ctrl + s
      if (!self.dialog && self.selectedFirm && self.transactionType && self.items.length) {
        window.event.preventDefault();
        self.saveInvoice(true);
        console.log('Save Invoice');
      }
    }
    if (window.event.keyCode == 72 && window.event.ctrlKey) {
      //ctrl + h
      if (!self.dialog && self.selectedFirm && self.transactionType && self.items.length) {
        window.event.preventDefault();
        self.basicInvoicePrint(false);
        console.log('horizontal print');
      }
    }
    if (window.event.keyCode == 86 && window.event.ctrlKey) {
      //ctrl + v
      if (!self.dialog && self.selectedFirm && self.transactionType && self.items.length) {
        window.event.preventDefault();
        self.basicInvoicePrint(true);
        console.log('vertical print');
      }
    }
    if (window.event.keyCode == 69 && window.event.ctrlKey) {
      //ctrl + e
      if (!self.dialog && self.selectedFirm && self.transactionType && self.items.length) {
        window.event.preventDefault();
        self.eWayBillPrint();
        console.log('eway print');
      }
    }
    if (window.event.keyCode == 71 && window.event.ctrlKey) {
      //ctrl + g
      window.event.preventDefault();
      self.$router.push({ path: "/settings/product-grouping/true/invoice" });
    }
    if (window.event.keyCode == 84 && window.event.ctrlKey) {
      //ctrl + t
      window.event.preventDefault();
      self.$router.push({ path: "/settings/product-set/true/invoice" });
    }
  };
  document.addEventListener('keydown', this._keyListener1.bind(this));
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_components$data$comp, "beforeDestroy", function beforeDestroy() {
  document.removeEventListener('keydown', this._keyListener1);
}), _components$data$comp);

/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__invoiceList_vue__ = __webpack_require__(1506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_pdf_reports_dailyProductReport_js__ = __webpack_require__(1517);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];

// import { setTimeout } from "timers";


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    InvoiceList: __WEBPACK_IMPORTED_MODULE_3__invoiceList_vue__["a" /* default */]
  },
  data: function data() {
    return {
      headers: [{ text: "Invoice ID", value: "expense", sortable: true }, { text: "Firm", value: "firm", sortable: true }, { text: "Customer Name", value: "name", sortable: true }, { text: "Product Name", value: "category", sortable: true }, { text: "Opening Quantity", value: "availableQuantity", sortable: false }, { text: "Purchase Quantity", value: "quantity", sortable: false }, { text: "Sale Quantity", value: "quantity", sortable: false }, { text: "Amount", value: "quantity", sortable: false }, { text: "Closing Quantity", value: "closingQuantity", sortable: false }],
      groupHeaders: [{ text: "Group Name", value: "category", sortable: true }, { text: "Opening Quantity", value: "availableQuantity", sortable: false }, { text: "Purchase Quantity", value: "quantity", sortable: false }, { text: "Purchase Amount", value: "quantity", sortable: false }, { text: "Sale Quantity", value: "quantity", sortable: false }, { text: "Sale Amount", value: "quantity", sortable: false }, { text: "Closing Quantity", value: "closingQuantity", sortable: false }],
      isProductGroupView: false,
      color: null,
      expand: true,
      isProductView: false,
      unqProdHeader: [{ text: "Product Name", value: "category", sortable: true }, { text: "Sale Quantity", value: "quantity", sortable: false }, { text: "Sale Amount", value: "quantity", sortable: false }],
      timeout: 3000,
      datepickerMenu: false,
      snackbarSuccessText: null,
      snackbarText: null,
      snackbar: false,
      snackbarSuccess: false,
      date: null,
      print: false,
      stripPrint: false,
      selectedFirm: null,
      voucherTypeFilter: [],
      filterFlag: null,
      combineProduct: false
    };
  },
  created: function created() {
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsObject("sellers", this.$root.$firebaseRefs.seller.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsObject("buyers", this.$root.$firebaseRefs.buyer.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("productGroups", this.$root.$firebaseRefs.productGroup.orderByChild("brand").equalTo(this.selectedBrand));
    var today = new Date();
    this.date = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
    this.salaryInvoiceDate = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
    this.transferInvoiceDate = today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "brandFinYear"]), {
    firmsByBrand: function firmsByBrand() {
      var _this = this;

      return this.firms.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      }).map(function (item) {
        if (item.defaultFirm) {
          _this.selectedFirm = item[".key"];
        }
        return {
          firm: item,
          text: item["name"],
          value: item[".key"]
        };
      });
    },
    productsTransaction: function productsTransaction() {
      var _this2 = this;

      var productList = [];
      var inv = this.invoices.filter(function (item) {
        return item["brand"] === _this2.selectedBrand && (_this2.selectedFirm ? item["firm"] === _this2.selectedFirm : true) && item.deleted != true && (_this2.date ? new Date(_this2.date).toLocaleDateString() === new Date(item["date"]).toLocaleDateString() : false);
      });
      inv.map(function (invoice, index) {
        if (invoice.items) {
          invoice.items.map(function (item, index) {
            item["firm"] = invoice["firm"];
            item["buyerId"] = invoice["buyerId"];
            item["isBuyer"] = invoice["isBuyer"];
            item["date"] = invoice["date"];
            item["invoiceId"] = invoice["invoiceId"];
            productList.push(item);
          });
        }
      });
      return productList;
    },
    groupsTransaction: function groupsTransaction() {
      var _this3 = this;

      var groupList = [];
      var inv = this.invoices.filter(function (item) {
        return item["brand"] === _this3.selectedBrand && (_this3.selectedFirm ? item["firm"] === _this3.selectedFirm : true) && item.deleted != true && (_this3.date ? new Date(_this3.date).toLocaleDateString() === new Date(item["date"]).toLocaleDateString() : false);
      });
      var total = {
        name: "Total",
        id: null,
        availableQuantity: 0,
        sellingQuantity: 0,
        purchaseQuantity: 0,
        closingQuantity: 0,
        saleAmount: 0,
        purchaseAmount: 0
      };
      inv.map(function (invoice) {
        if (invoice.items) {
          invoice.items.map(function (item) {
            var product = _this3.products.find(function (item1) {
              return item1[".key"] == item["productId"];
            });
            var group = null;
            item["firm"] = invoice["firm"];
            item["buyerId"] = invoice["buyerId"];
            item["isBuyer"] = invoice["isBuyer"];
            item["date"] = invoice["date"];
            item["invoiceId"] = invoice["invoiceId"];
            item["saleQuantity"] = invoice["isBuyer"] ? item.quantity : 0;
            item["purchaseQuantity"] = !invoice["isBuyer"] ? item.quantity : 0;
            item["saleAmount"] = invoice.isBuyer ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) : 0;
            item["purchaseAmount"] = !invoice.isBuyer ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) : 0;
            if (product && product["productGroup"]) {
              group = _this3.productGroups.find(function (item1) {
                return item1[".key"] == product["productGroup"];
              });
              if (group) {
                group = {
                  name: group.name,
                  id: group[".key"],
                  availableQuantity: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.availableQuantity) || 0,
                  sellingQuantity: invoice.isBuyer ? item.quantity : 0,
                  purchaseQuantity: !invoice.isBuyer ? item.quantity : 0,
                  closingQuantity: invoice.isBuyer ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.availableQuantity) - __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.quantity)) : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.availableQuantity) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.quantity)),
                  majorUnit: product.majorUnit,
                  majorUnitQuantity: product.majorUnitQuantity,
                  sameMajorUnit: true,
                  saleAmount: invoice.isBuyer ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) : 0,
                  purchaseAmount: !invoice.isBuyer ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) : 0
                };
              }
            }
            if (!group) {
              group = {
                name: "Non Group",
                id: null,
                availableQuantity: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.availableQuantity) || 0,
                sellingQuantity: invoice.isBuyer ? item.quantity : 0,
                purchaseQuantity: !invoice.isBuyer ? item.quantity : 0,
                closingQuantity: invoice.isBuyer ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.availableQuantity) - __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.quantity)) : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.availableQuantity) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.quantity)),
                saleAmount: invoice.isBuyer ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) : 0,
                purchaseAmount: !invoice.isBuyer ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) : 0
              };
            }
            var index = groupList.findIndex(function (x) {
              return x.id === group.id;
            });
            if (index > -1) {
              if (groupList[index].sameMajorUnit && groupList[index].majorUnit != group.majorUnit) {
                groupList[index].sameMajorUnit = false;
              }
              groupList[index]["availableQuantity"] += group["availableQuantity"];
              groupList[index]["sellingQuantity"] += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(group["sellingQuantity"]);
              groupList[index]["purchaseQuantity"] += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(group["purchaseQuantity"]);
              groupList[index]["closingQuantity"] += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(group["closingQuantity"]);
              groupList[index]["saleAmount"] += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(invoice.isBuyer ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(group["saleAmount"]) : 0);
              groupList[index]["purchaseAmount"] += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(!invoice.isBuyer ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(group["purchaseAmount"]) : 0);
              groupList[index]["products"].push(item);
              var ind = groupList[index]["unqProducts"].findIndex(function (i) {
                return i.productId == item.productId;
              });
              if (ind > -1) {
                groupList[index]["unqProducts"][ind]["saleQuantity"] += item["saleQuantity"];
                groupList[index]["unqProducts"][ind]["saleAmount"] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(invoice.isBuyer ? groupList[index]["unqProducts"][ind]["saleAmount"] || 0 : 0) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(invoice.isBuyer ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) : 0));
                groupList[index]["unqProducts"][ind]["purchaseQuantity"] += item["purchaseQuantity"];
              } else {
                groupList[index]["unqProducts"].push(item);
              }
              if (item.productName == 'SOYA 1/2 LTR') {
                debugger;
              }
              total['availableQuantity'] += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(group['availableQuantity']);
              total['sellingQuantity'] += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(group['sellingQuantity']);
              total['purchaseQuantity'] += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(group['purchaseQuantity']);
              total['closingQuantity'] += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(group['closingQuantity']);
              total['saleAmount'] += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(invoice.isBuyer ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(group["saleAmount"]) : 0);
              total['purchaseAmount'] += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(!invoice.isBuyer ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(group["purchaseAmount"]) : 0);
            } else {
              group['products'] = [item];
              group['unqProducts'] = [item];
              groupList.push(group);
              total['availableQuantity'] += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(group['availableQuantity']);
              total['sellingQuantity'] += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(group['sellingQuantity']);
              total['purchaseQuantity'] += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(group['purchaseQuantity']);
              total['closingQuantity'] += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(group['closingQuantity']);
              total['saleAmount'] += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(group['saleAmount']);
              total['purchaseAmount'] += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(group['purchaseAmount']);
            }
          });
        }
      });
      groupList.push(total);
      return groupList;
    }
  }),
  methods: {
    productReportPrint: function productReportPrint() {
      var htmlToArray = function htmlToArray(tableElement) {
        var thead = tableElement.querySelector("thead");
        var tbody = tableElement.querySelector("tbody");
        // Assumes there's only one header row
        var columns = thead.querySelectorAll("tr th");
        var columnNames = [];
        columns.forEach(function (c) {
          return columnNames.push(c.innerText);
        });
        var result = [];
        var bodyRows = tbody.querySelectorAll("tr");
        bodyRows.forEach(function (r) {
          var tds = r.querySelectorAll("td");
          var arr = [];
          tds.forEach(function (td, idx) {
            arr.push(td.innerText);
          });
          result.push(arr);
        });
        return result;
      };
      var table = document.querySelector(".prod-reports");
      var invoices = htmlToArray(table);
      var doc = Object(__WEBPACK_IMPORTED_MODULE_4__utils_pdf_reports_dailyProductReport_js__["b" /* dailyProductReport */])({
        invoiceData: invoices,
        firm: this.selectedFirm ? this.selectedFirm.name : "",
        date: this.date ? new Date(this.date).toLocaleDateString("en-GB") : ""
      });
      pdfMake.createPdf(doc).download("product-report");
    },
    productGroupReportPrint: function productGroupReportPrint(isDetailed) {
      var _this4 = this;

      if (isDetailed) {
        $(".not-expand.product-group-row").click();
      }
      var htmlToArray = function htmlToArray(tableElement) {
        var thead = tableElement.querySelector("thead");
        var tbody = tableElement.querySelector("tbody");
        // Assumes there's only one header row
        var columns = thead.querySelectorAll("tr th");
        var columnNames = [];
        columns.forEach(function (c) {
          return columnNames.push(c.innerText);
        });
        var result = [];
        var bodyRows = tbody.querySelectorAll("tr");
        bodyRows.forEach(function (r) {
          var tds = r.querySelectorAll("td");
          var arr = [];
          tds.forEach(function (td, idx) {
            arr.push(td.innerText);
          });
          result.push(arr);
        });
        return result;
      };
      setTimeout(function () {
        var table = document.querySelector(".prod-grp-reports");
        var invoices = htmlToArray(table);
        var doc = Object(__WEBPACK_IMPORTED_MODULE_4__utils_pdf_reports_dailyProductReport_js__["a" /* dailyProductGroupReport */])({
          invoiceData: invoices,
          firm: _this4.selectedFirm ? _this4.selectedFirm.name : "",
          date: _this4.date ? new Date(_this4.date).toLocaleDateString("en-GB") : "",
          isDetailed: isDetailed
        });
        pdfMake.createPdf(doc).download("product-report");
        $(".product-group-row").click();
      }, 1500);
    },
    getMajorQuantity: function getMajorQuantity(quantity, productId) {
      var product = this.products.find(function (item) {
        return item[".key"] == productId;
      });
      if (product && product.majorUnit) {
        var text = "(" + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(quantity / (product.majorUnitQuantity || 1)).toFixed(2) + " " + product.majorUnit + ")";
        return text;
      }
      return "";
    },
    getMajorQuantityGroup: function getMajorQuantityGroup(sameMajorUnit, quantity, majorUnitQuantity, majorUnit) {
      if (sameMajorUnit && majorUnitQuantity && majorUnit) {
        var text = "(" + quantity / majorUnitQuantity + " " + majorUnit + ")";
        return text;
      }
      return "";
    },
    printInv: function printInv() {
      var _this5 = this;

      this.print = true;
      setTimeout(function () {
        _this5.print = false;
      }, 100);
    },
    printStripInv: function printStripInv() {
      var _this6 = this;

      this.stripPrint = true;
      setTimeout(function () {
        _this6.stripPrint = false;
      }, 100);
    },
    notify: function notify(message, isSuccess) {
      if (isSuccess) {
        this.snackbarSuccess = true;
        this.snackbarSuccessText = message;
      } else {
        this.snackbar = true;
        this.snackbarText = message;
      }
    },
    closeDialog: function closeDialog() {
      this.dialog12 = false;
    },
    buyerById: function buyerById(id) {
      if (this.buyers[id]) {
        return this.buyers[id].name;
      } else if (this.sellers[id]) {
        return this.sellers[id].name;
      } else {
        return "--DELETED--";
      }
    },
    firmNameById: function firmNameById(id) {
      return this.firms.filter(function (item) {
        return item[".key"] == id;
      })[0].name;
    }
  },
  watch: {}
});

/***/ }),
/* 503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_pdf_reports_transaction_reports__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_pdf_reports_transaction_stripReports__ = __webpack_require__(1509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_luxon__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_luxon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__normalInvoice__ = __webpack_require__(1510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__automaticInvoice__ = __webpack_require__(1513);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])('Buyer')['mapGetters'];








/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        normalInvoice: __WEBPACK_IMPORTED_MODULE_7__normalInvoice__["a" /* default */],
        automaticInvoice: __WEBPACK_IMPORTED_MODULE_8__automaticInvoice__["a" /* default */]
    },
    props: {
        isCredited: {
            type: Boolean,
            default: true
        },
        voucherTypeFilter: {
            type: Array,
            default: []
        },
        invoices: {
            type: Array,
            default: []
        },
        firms: {
            type: Array,
            default: []
        },
        sellers: {
            type: Object,
            default: []
        },
        buyers: {
            type: Object,
            default: []
        },
        status: {
            type: Array,
            default: function _default() {
                return ['Paid'];
            }
        },
        print: {
            type: Boolean,
            default: false
        },
        stripPrint: {
            type: Boolean,
            default: false
        },
        firmAssignment: {
            type: Boolean,
            default: false
        },
        heading: {
            type: String,
            default: ""
        },
        selectedFirm: {
            type: String,
            default: null
        },
        selectedDate: {
            type: String,
            default: function _default() {
                var today = new Date();
                return today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
            }
        }
    },
    data: function data() {
        return {
            headers: [
            // { text: "Invoice ID", value: "expense", sortable: true },
            { text: "Firm", value: "expense", sortable: true }, { text: "Particulars", value: "name", sortable: true }, { text: "Debit", value: "category", sortable: true }, { text: "Credit", value: "underHead", sortable: false }, { text: "Voucher type", value: "totalAmount", sortable: false }, { text: "Payment type", value: "totalAmount", sortable: false },
            // { text: "Transaction type", value: "totalAmount", sortable: false },
            { text: "Status", value: "status", sortable: true }, { text: "Remark", sortable: false }]
        };
    },
    watch: {
        print: function print(newVal, oldVal) {
            if (newVal) {
                this.printInvoices();
            }
        },
        stripPrint: function stripPrint(newVal, oldVal) {
            if (newVal) {
                this.stripPrintInvoices();
            }
        }
    },
    created: function created() {
        this.$bindAsArray('invoiceHistory', this.$root.$firebaseRefs.invoiceHistory.orderByChild('brand').equalTo(this.selectedBrand));
        this.$bindAsArray("customerPayments", this.$root.$firebaseRefs.customerPayments.orderByChild('brand').equalTo(this.selectedBrand));
        this.$bindAsArray("deposit", this.$root.$firebaseRefs.customerDeposit.orderByChild('brand').equalTo(this.selectedBrand));
    },

    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand', 'brandFinYear']), {
        invoicesByBrand: function invoicesByBrand() {
            var _this = this;

            var invoiceHistory = this.invoiceHistory.filter(function (item) {
                return item['brand'] === _this.selectedBrand &&
                // this.status.indexOf(item['status']) !== -1 && 
                // (this.datatable ? true : item['isCredited'] === this.isCredited) &&
                item.deleted != true && (_this.selectedFirm ? item['firm'] === _this.selectedFirm : true) && (
                // ((this.selectedDate) ? (new Date(this.selectedDate).toLocaleDateString() === new Date(item['date']).toLocaleDateString()): false)
                item.closedDate ? _this.selectedDate ? new Date(_this.selectedDate).toLocaleDateString() === new Date(item['closedDate']).toLocaleDateString() : false : _this.selectedDate ? new Date(_this.selectedDate).toLocaleDateString() === new Date(item['date']).toLocaleDateString() : false) && (item['isLatest'] != undefined ? item['isLatest'] == true : true);
            });
            invoiceHistory.map(function (item, index) {
                invoiceHistory[index]['buyerName'] = _this.buyerById(item.buyerId);
                if (item.newlyCreated && (item.status === "paid" || item.status === "partial")) {
                    var newItem = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(item));
                    newItem.date = newItem.date - 1;
                    newItem.transactionType = "Debit";
                    newItem.paidAmount = 0;
                    newItem.status = 'due';
                    newItem.remainingAmount = newItem.totalAmount;
                    delete newItem['newlyCreated'];
                    invoiceHistory.push(newItem);
                }
            });
            var invoice = this.invoices.filter(function (item) {
                return item['brand'] === _this.selectedBrand && item.deleted != true && item.type == "automatic invoice" && (_this.selectedFirm ? item['firm'] === _this.selectedFirm : true) && (_this.selectedDate ? new Date(_this.selectedDate).toLocaleDateString() === new Date(item['date']).toLocaleDateString() : false) && (item['isLatest'] != undefined ? item['isLatest'] == true : true);
            });

            var customerDeposit = this.deposit.filter(function (item) {
                return item["brand"] === _this.selectedBrand && (_this.selectedFirm ? item['firm'] === _this.selectedFirm : true) && (_this.selectedDate ? new Date(_this.selectedDate).toLocaleDateString() === new Date(item['date']).toLocaleDateString() : false) && (item["type"] === "Advance" || item["type"] === "Opening Balance" || item["type"] === "LoanTaken" || item["type"] === "LoanGiven" || item["type"] === "Security");
            });
            customerDeposit.map(function (deposit) {
                if (deposit.buyerId) {
                    deposit['buyerName'] = _this.buyerById(deposit.buyerId);
                }
                invoice.push(deposit);
                // if((deposit["type"] === "LoanTaken" || deposit["type"] === "LoanGiven") && deposit.status =="paid") {
                // let temp = JSON.parse(JSON.stringify(deposit))
                // temp.status = 'due';
                // invoice.push(temp);
                // }
            });
            var payments = this.customerPayments.filter(function (item) {
                return item["brand"] === _this.selectedBrand && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item["remainingAmount"]) > 0 && (!!_this.selectedFirm ? item["firm"] === _this.selectedFirm : true) && (_this.selectedDate ? new Date(_this.selectedDate).toLocaleDateString() === new Date(item['date']).toLocaleDateString() : false);
            });
            payments.map(function (pay) {
                if (pay.buyerId) {
                    pay['buyerName'] = _this.buyerById(pay.buyerId);
                }
                pay['type'] = 'CustomerPayment';
                invoice.push(pay);
            });
            setTimeout(function () {
                _this.getTotal();
            }, 800);
            invoice = invoice.concat(invoiceHistory);
            invoice.map(function (item, index) {
                invoice[index]['voucherType'] = _this.getVocherType(item);
            });
            if (this.voucherTypeFilter.length) {
                invoice = invoice.filter(function (it) {
                    return _this.voucherTypeFilter.indexOf(it['voucherType']) > -1;
                });
            }
            invoice.sort(function (a, b) {
                return a.buyerName > b.buyerName ? 1 : -1;
            });
            invoice.push({
                firm: 'Total'
            });
            return invoice;
        },
        firmsByBrand: function firmsByBrand() {
            var _this2 = this;

            return this.firms.filter(function (item) {
                return item['brand'] === _this2.selectedBrand;
            });
        }
    }),
    methods: {
        buyerById: function buyerById(id) {
            if (this.buyers[id]) {
                return this.buyers[id].name;
            } else if (this.sellers[id]) {
                return this.sellers[id].name;
            } else {
                return "--DELETED--";
            }
        },
        getTotal: function getTotal(isCredit) {
            var tableElement = document.querySelector('.transaction-table table');
            if (tableElement) {
                var thead = tableElement.querySelector('thead');
                var tbody = tableElement.querySelector('tbody');
                // Assumes there's only one header row
                var columns = thead.querySelectorAll('tr th');
                var columnNames = [];
                columns.forEach(function (c) {
                    return columnNames.push(c.innerText);
                });
                var result = [];
                var bodyRows = tbody.querySelectorAll('tr');
                bodyRows.forEach(function (r) {
                    var tds = r.querySelectorAll('td');
                    var arr = [];
                    tds.forEach(function (td, idx) {
                        arr.push(td.innerText);
                        if (td.classList.contains("credit-total")) {
                            var _total = 0;
                            result.map(function (a) {
                                if (a[0] != 'Total') {
                                    var amount = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(0 + a[2].replaceAll(",", ""));
                                    _total += amount;
                                }
                            });
                            td.querySelector("b").innerHTML = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(_total.toFixed(2)).toLocaleString('en-IN');
                        }
                        if (td.classList.contains("debit-total")) {
                            var _total2 = 0;
                            result.map(function (a) {
                                if (a[0] != 'Total') {
                                    var amount = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(0 + a[3].replaceAll(",", ""));
                                    _total2 += amount;
                                }
                            });
                            td.querySelector("b").innerHTML = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(_total2.toFixed(2)).toLocaleString('en-IN');
                        }
                    });
                    result.push(arr);
                });
                return result;
            }
            var total = 0;
            invoices.map(function (a) {
                if (a[0] != 'Total') {
                    var amount = isCredit ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(0 + a[2].replaceAll(",", "")) : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(0 + a[3].replaceAll(",", ""));
                    total += amount;
                }
            });
            return total;
        },
        htmlToArray: function htmlToArray() {
            var tableElement = document.querySelector('.transaction-table table');
            if (tableElement) {
                var thead = tableElement.querySelector('thead');
                var tbody = tableElement.querySelector('tbody');
                // Assumes there's only one header row
                var columns = thead.querySelectorAll('tr th');
                var columnNames = [];
                columns.forEach(function (c) {
                    return columnNames.push(c.innerText);
                });
                var result = [];
                var bodyRows = tbody.querySelectorAll('tr');
                bodyRows.forEach(function (r) {
                    var tds = r.querySelectorAll('td');
                    var arr = [];
                    tds.forEach(function (td, idx) {
                        arr.push(td.innerText);
                    });
                    result.push(arr);
                });
                return result;
            }
            return [];
        },
        printInvoices: function printInvoices() {
            var _this3 = this;

            var invoices = this.htmlToArray();
            var firm = this.firms.filter(function (item) {
                return item['.key'] == _this3.selectedFirm;
            })[0];
            var doc = Object(__WEBPACK_IMPORTED_MODULE_4__utils_pdf_reports_transaction_reports__["a" /* convertToPDFTransactionReport */])({
                invoiceData: invoices,
                firm: this.selectedFirm ? firm.name : '',
                date: this.selectedDate ? new Date(this.selectedDate).toLocaleDateString('en-GB') : ''
            });
            pdfMake.createPdf(doc).download('Daybook_' + new Date(this.selectedDate).toLocaleDateString('en-GB'));
        },
        stripPrintInvoices: function stripPrintInvoices() {
            var _this4 = this;

            var invoices = this.htmlToArray();
            var firm = this.firms.filter(function (item) {
                return item['.key'] == _this4.selectedFirm;
            })[0];
            var doc = Object(__WEBPACK_IMPORTED_MODULE_5__utils_pdf_reports_transaction_stripReports__["a" /* convertToPDFTransactionStripReport */])({
                invoiceData: invoices,
                firm: this.selectedFirm ? firm.name : '',
                date: this.selectedDate ? new Date(this.selectedDate).toLocaleDateString('en-GB') : ''
            });
            pdfMake.createPdf(doc).download('Daybook_' + new Date(this.selectedDate).toLocaleDateString('en-GB'));
        },
        getVocherType: function getVocherType(invoice) {
            if (invoice.type == 'CustomerPayment') {
                if (invoice.isBuyer) {
                    return "Receipt";
                } else {
                    return "Payment";
                }
            }
            if (invoice.return) {
                if (invoice.isBuyer) {
                    return "Credit Note";
                } else {
                    return "Debit Note";
                }
            }
            if (invoice["type"] == "automatic invoice" && invoice.assetType) {
                return "Asset";
            }
            if (invoice["type"] == "automatic invoice" && invoice.expenseType) {
                return "Expense";
            }
            if (invoice["type"] == "automatic invoice" && invoice.liabilityType) {
                return "Liability";
            }
            if (invoice["type"] == "automatic invoice" && invoice.incomeType) {
                return "Income";
            }
            if (invoice["type"] == "automatic invoice" && invoice.staffType) {
                return "Staff";
            }
            if (invoice["type"] == "automatic invoice" && invoice.transactionType === "Transfer") {
                return "Transfer";
            } else if (invoice.transactionType != "Debit" && invoice["type"] === "Advance" ||
            // invoice["type"] === "Opening Balance" ||
            invoice["type"] === "LoanGiven" || invoice["type"] === "LoanTaken" || invoice["type"] === "Security") {
                return invoice["type"];
            } else if (invoice["type"] === "Opening Balance" && !invoice["settledAmount"]) {
                return "Opening Balance";
            } else if (invoice.isBuyer && invoice["type"] === "Opening Balance" && invoice["settledAmount"]) {
                return "Receipt";
            } else if (!invoice.isBuyer && invoice["type"] === "Opening Balance" && invoice["settledAmount"]) {
                return "Payment";
            } else if (invoice.isBuyer && invoice.transactionType === "Debit") {
                return "Sale";
            } else if (invoice.isBuyer && invoice.transactionType === "Credit") {
                return "Receipt";
            } else if (invoice.isBuyer && invoice.transactionType === "Partial Paid") {
                return "Receipt";
            } else if (!invoice.isBuyer && invoice.transactionType === "Debit") {
                return "Purchase";
            } else if (!invoice.isBuyer && invoice.transactionType === "Credit") {
                return "Payment";
            } else if (!invoice.isBuyer && invoice.transactionType === "Partial Paid") {
                return "Payment";
            }
        }
    }
});

/***/ }),
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_luxon__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_luxon__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])('Buyer')['mapGetters'];



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        item: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        isCredited: {
            type: Boolean,
            default: true
        },
        firms: {
            type: Array,
            default: []
        },
        sellers: {
            type: Object,
            default: []
        },
        buyers: {
            type: Object,
            default: []
        },
        status: {
            type: Array,
            default: function _default() {
                return ['close'];
            }
        },
        firmAssignment: {
            type: Boolean,
            default: false
        },
        heading: {
            type: String,
            default: ""
        },
        selectedFirm: {
            type: String,
            default: null
        },
        selectedDate: {
            type: String,
            default: function _default() {
                var today = new Date();
                return today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
            }
        }
    },
    data: function data() {
        return {};
    },
    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand']), {
        firmsByBrand: function firmsByBrand() {
            var _this = this;

            return this.firms.filter(function (item) {
                return item['brand'] === _this.selectedBrand;
            });
        }
    }),
    methods: {
        buyerById: function buyerById(id) {
            if (this.buyers[id]) {
                return this.buyers[id];
            } else if (this.sellers[id]) {
                return this.sellers[id];
            }
        },
        getCredit: function getCredit(item) {
            if ('Opening Balance' == item.type && item.status == 'paid' || 'Opening Balance' == item.type && item.status == 'partial') {
                return !item.isBuyer ? item['settledAmount'] : 0;
            }
            if ('LoanGiven' == item.type) {
                if (item.loanTransaction) {
                    return 0;
                } else {
                    return item.amount;
                }
            }
            if ('LoanTaken' == item.type) {
                if (item.loanTransaction) {
                    return item.amount;
                } else {
                    return 0;
                }
            }
            if (item.type == 'CustomerPayment') {
                if (item.isBuyer) {
                    return 0;
                } else {
                    return item['remainingAmount'];
                }
            } else if ('Advance' == item.type || 'Security' == item.type) {
                return item.isUserCreated ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(0) : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.settledAmount);
            }
            if (item.isBuyer) {
                switch (item.status) {
                    case 'due':
                        {
                            return item.totalAmount || item.amount || 0;
                            break;
                        }
                    case 'paid':
                        {
                            return 0;
                            break;
                        }
                    case 'partial':
                        {
                            return 0;
                            break;
                        }
                }
            } else {
                switch (item.status) {
                    case 'due':
                        {
                            return item.settledAmount || 0;
                            break;
                        }
                    case 'paid':
                        {
                            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item['amountFromBank']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item['amountFromCash']);
                            // return Number.parseFloat(item['totalAmount']);
                            break;
                        }
                    case 'partial':
                        {
                            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item['amountFromBank']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item['amountFromCash']);
                            // return Number.parseFloat(item['paidAmount']);
                            break;
                        }
                }
            }
        },
        getDebit: function getDebit(item) {
            if ('Opening Balance' == item.type && item.status == 'paid' || 'Opening Balance' == item.type && item.status == 'partial') {
                return item.isBuyer ? item['settledAmount'] : 0;
            }
            if ('LoanGiven' == item.type) {
                if (item.loanTransaction) {
                    return item.amount;
                } else {
                    return 0;
                }
            }
            if ('LoanTaken' == item.type) {
                if (item.loanTransaction) {
                    return 0;
                } else {
                    return item.amount;
                }
            }
            if (item.type == 'CustomerPayment') {
                if (!item.isBuyer) {
                    return 0;
                } else {
                    return item['remainingAmount'];
                }
            } else if ('Advance' == item.type || 'Security' == item.type) {
                return item.isUserCreated ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.amount) : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(0);
            }
            if (item.isBuyer) {
                switch (item.status) {
                    case 'due':
                        {
                            return item.settledAmount || 0;
                            break;
                        }
                    case 'paid':
                        {
                            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item['amountFromBank']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item['amountFromCash']);
                            // return Number.parseFloat(item['totalAmount']);
                            break;
                        }
                    case 'partial':
                        {
                            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item['amountFromBank']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item['amountFromCash']);
                            break;
                        }
                }
            } else {
                switch (item.status) {
                    case 'due':
                        {
                            return item.totalAmount || item.amount || 0;
                            break;
                        }
                    case 'paid':
                        {
                            return 0;
                            break;
                        }
                    case 'partial':
                        {
                            return 0;
                            break;
                        }
                }
            }
        },
        firmNameById: function firmNameById(id) {
            var firm = this.firms.filter(function (item) {
                return item['.key'] == id;
            })[0];
            if (firm) {
                return firm['name'];
            }
        },
        getNumberOfDaysFromStartDate: function getNumberOfDaysFromStartDate(createdAt, closedDate) {
            console.log(createdAt, closedDate);
            var startDate = __WEBPACK_IMPORTED_MODULE_4_luxon__["DateTime"].fromMillis(createdAt);
            if (!closedDate) {
                closedDate = __WEBPACK_IMPORTED_MODULE_4_luxon__["DateTime"].local();
            } else {
                closedDate = __WEBPACK_IMPORTED_MODULE_4_luxon__["DateTime"].fromMillis(closedDate);
            }
            var endDate = closedDate;
            var interval = __WEBPACK_IMPORTED_MODULE_4_luxon__["Interval"].fromDateTimes(startDate, endDate);
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(interval.length('days'));
        },
        getTotalAmount: function getTotalAmount(principal, rate, createdAt) {
            var time = this.getNumberOfDaysFromStartDate(createdAt) / 365;
            rate = rate * 12 / 100;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(principal * (1 + rate * time)).toFixed(2);
        },
        getInterestValue: function getInterestValue(principal, rate, createdAt) {
            return (this.getTotalAmount(principal, rate, createdAt) - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(principal)).toFixed(2);
        }
    }
});

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])('Buyer')['mapGetters'];

/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        item: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        firms: {
            type: Array,
            default: []
        },
        isCredited: {
            type: Boolean,
            default: true
        }
    },
    data: function data() {
        return {
            expenseById: {},
            liabilityById: {},
            bankAccountById: {},
            incomeById: {},
            staffById: {},
            assetById: {}
        };
    },
    created: function created() {
        this.$bindAsArray('accounts', this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
        this.$bindAsObject('bankAccountById', this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
        this.$bindAsObject('expenseById', this.$root.$firebaseRefs.expenses.orderByChild('brand').equalTo(this.selectedBrand));
        this.$bindAsObject('liabilityById', this.$root.$firebaseRefs.liabilities.orderByChild('brand').equalTo(this.selectedBrand));
        this.$bindAsObject('incomeById', this.$root.$firebaseRefs.incomes.orderByChild('brand').equalTo(this.selectedBrand));
        this.$bindAsObject('assetById', this.$root.$firebaseRefs.assets.orderByChild('brand').equalTo(this.selectedBrand));
        this.$bindAsObject('staffById', this.$root.$firebaseRefs.staff.orderByChild('brand').equalTo(this.selectedBrand));
    },

    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand'])),
    methods: {
        updateInvoice: function updateInvoice(invoiceId, firmId) {
            var updatedInvoice = this.invoicesById[invoiceId];
            updatedInvoice['firm'] = firmId;
            this.$root.$firebaseRefs.invoice.child(invoiceId).set(updatedInvoice);
        },
        firmNameById: function firmNameById(id) {
            var firm = this.firms.filter(function (item) {
                return item['.key'] == id;
            })[0];
            if (firm) {
                return firm['name'];
            }
        },
        expenseNameById: function expenseNameById(id) {
            if (this.expenseById[id]) {
                return this.expenseById[id]['expense'];
            }
        },
        liabilityNameById: function liabilityNameById(id) {
            if (this.liabilityById[id]) {
                return this.liabilityById[id]['liability'];
            }
        },
        bankAccountNameById: function bankAccountNameById(id) {
            if (this.bankAccountById[id]) {
                return this.bankAccountById[id]['bankName'];
            }
        },
        incomeNameById: function incomeNameById(id) {
            if (this.incomeById[id]) {
                return this.incomeById[id]['income'];
            }
        },
        assetNameById: function assetNameById(id) {
            if (this.assetById[id]) {
                return this.assetById[id]['asset'];
            }
        },
        staffNameById: function staffNameById(id) {
            if (this.staffById[id]) {
                return this.staffById[id]['staffName'];
            }
        },
        getNumberOfDaysFromStartDate: function getNumberOfDaysFromStartDate(createdAt, closedDate) {
            console.log(createdAt, closedDate);
            var startDate = DateTime.fromMillis(createdAt);
            if (!closedDate) {
                closedDate = DateTime.local();
            } else {
                closedDate = DateTime.fromMillis(closedDate);
            }
            var endDate = closedDate;
            var interval = Interval.fromDateTimes(startDate, endDate);
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(interval.length('days'));
        },
        getTotalAmount: function getTotalAmount(principal, rate, createdAt) {
            var time = this.getNumberOfDaysFromStartDate(createdAt) / 365;
            rate = rate * 12 / 100;
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(principal * (1 + rate * time)).toFixed(2);
        },
        getInterestValue: function getInterestValue(principal, rate, createdAt) {
            return (this.getTotalAmount(principal, rate, createdAt) - __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(principal)).toFixed(2);
        }
    }
});

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_int__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_pdf_reports_dashboard_reports__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils___ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__StatementView__ = __webpack_require__(1521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__normalView__ = __webpack_require__(1523);






var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* createNamespacedHelpers */])("Buyer")["mapGetters"];





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    StatementView: __WEBPACK_IMPORTED_MODULE_8__StatementView__["a" /* default */],
    NormalView: __WEBPACK_IMPORTED_MODULE_9__normalView__["a" /* default */]
  },
  data: function data() {
    return {
      headers: [{ text: "Date", value: "date", sortable: true }, { text: "Customer Name", value: "expense", sortable: true }, { text: "Debit", value: "category", sortable: true }, { text: "Credit", value: "underHead", sortable: false }, { text: "Voucher type", value: "totalAmount", sortable: false }, { text: "Payment type", value: "totalAmount", sortable: false }, { text: "Status", value: "status", sortable: true }, { text: "Remark", sortable: false }],
      invoiceHeader: [
      // { text: "Invoice - Key", value: "Name" },
      { text: "Date", value: "date", sortable: true }, { text: "Action", value: "action" }, { text: "Buyer Name", value: "Father Name" }, { text: "Invoice No", value: "invoiceId", sortable: true }, { text: "Total Amount", value: "totalCurrentAmount" }, { text: "Basic Amount", value: "basic amount" }, { text: "GST", value: "GST" }, { text: "Extra Charges", value: "Extra Charges" }, { text: "Discount", value: "discount" }, { text: "Paid Amount", value: "Tehsil" }, { text: "Due Amount", value: "District" }, { text: "Payment Type", value: "Identity Number" }, { text: "Status", value: "Mobile" },
      // { text: "Transaction Type", sortable: true, value: "paymentType" },
      { text: "GST Type", sortable: true, value: "gstType" }, { text: "IGST Value", sortable: true, value: "gstType" }, { text: "SGST Value", sortable: true, value: "gstType" }, { text: "CGST Value", sortable: true, value: "gstType" }, { text: "GST (3%)", sortable: true, value: "gstType" }, { text: "GST (5%)", sortable: true, value: "gstType" }, { text: "GST (12%)", sortable: true, value: "gstType" }, { text: "GST (18%)", sortable: true, value: "gstType" }, { text: "GST (28%)", sortable: true, value: "gstType" }, { text: "Duration (in Days)", value: "abs" }, { text: "Admin email", sortable: true, value: "gstType" }, { text: "Firm Name", value: "firmName" }, { text: "Branch Name", value: "branch" }, { text: "Voucher type", value: "totalAmount", sortable: false }],
      invoiceProductListHeader: [{ text: "Name", value: "Name", class: "font-weight-bold primary--text" }, { text: "HSN code", value: "HSN", class: "font-weight-bold primary--text" }, { text: "Taxable rate", value: "Taxable", class: "font-weight-bold primary--text" }, { text: "Unit", value: "Unit", class: "font-weight-bold primary--text" }, { text: "Quantity", value: "quantity", class: "font-weight-bold primary--text" }, { text: "Rate", value: "rate", class: "font-weight-bold primary--text" }],
      pagination: {
        rowsPerPage: 10 // -1 for All",
      },
      businessType: null,
      isStatementView: false,
      statmentData: [],
      normalData: [],
      isSale: null,
      dateFrom: null,
      dateTo: null,
      datepickerFrom: false,
      selectedFirm: null,
      selectedBranch: null,
      datepickerTo: false,
      dialog11: false,
      selectedInvoice: null
    };
  },
  created: function created() {
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("branchs", this.$root.$firebaseRefs.branch.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("sellers", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("buyers", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoiceHistory", this.$root.$firebaseRefs.invoiceHistory.orderByChild('brand').equalTo(this.selectedBrand));
    if (this.$route.params.month && this.$route.params.date) {
      var date = parseInt(this.$route.params.date);
      var dateF = 1;
      var dateT = 0;
      if (date > 0) {
        dateF = date;
        dateT = date;
      }
      var selectedMonth = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_int___default()(this.$route.params.month);
      var dateFrom = new Date(this.finYear.start);
      var dateTo = new Date(this.finYear.end);
      var fullYear = dateFrom.getFullYear();
      if (selectedMonth < 3) {
        fullYear = dateTo.getFullYear();
      }
      this.dateFrom = this.formatDate(new Date(fullYear, selectedMonth, dateF).getTime());
      this.dateTo = this.formatDate(new Date(fullYear, dateT == 0 ? selectedMonth + 1 : selectedMonth, dateT).getTime());
    } else if (this.finYear) {
      this.dateFrom = this.formatDate(this.finYear.start);
      this.dateTo = this.formatDate(this.finYear.end);
    }
    if (window.location.pathname.split('/')[1] == 'sale-register') {
      this.isSale = true;
    } else {
      this.isSale = false;
    }
    this.invoicesByBrand();
    this.invoicesByBrandNormal();
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear", "brandFinYear"]), {
    firmsByBrand: function firmsByBrand() {
      var _this = this;

      return this.firms.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      }).map(function (item) {
        if (item.defaultFirm) {
          _this.selectedFirm = item['.key'];
        }
        return {
          text: item["name"],
          value: item[".key"]
        };
      });;
    },
    branchsByBrand: function branchsByBrand() {
      var _this2 = this;

      return this.branchs.filter(function (item) {
        return item["brand"] === _this2.selectedBrand && item["firm"] === _this2.selectedFirm;
      }).map(function (item) {
        return {
          text: item["branchName"],
          value: item[".key"]
        };
      });
    }
  }),
  watch: {
    "selectedFirm": {
      handler: function handler(newVal, oldVal) {
        this.setBussinessType();
        console.log(newVal);
        this.invoicesByBrand();
        this.invoicesByBrandNormal();
      },

      deep: true
    },
    "selectedBranch": {
      handler: function handler(newVal, oldVal) {
        console.log(newVal);
        this.invoicesByBrand();
        this.invoicesByBrandNormal();
      },

      deep: true
    },
    "dateTo": {
      handler: function handler(newVal, oldVal) {
        this.invoicesByBrand();
        this.invoicesByBrandNormal();
      }
    },
    "dateFrom": {
      handler: function handler(newVal, oldVal) {
        this.invoicesByBrand();
        this.invoicesByBrandNormal();
      }
    }
  },
  methods: (_methods = {
    invoicesByBrand: function invoicesByBrand() {
      var _this3 = this;

      var toDate = this.dateTo ? new Date(this.dateTo).setUTCHours(23, 59, 59, 999) : null;
      var fromDate = this.dateFrom ? new Date(this.dateFrom).setUTCHours(0, 0, 0, 0) : null;
      var invoiceHistory = this.invoices.filter(function (item) {
        return item["brand"] === _this3.selectedBrand && (_this3.selectedFirm ? item["firm"] === _this3.selectedFirm : true) && (_this3.selectedBranch ? item["branch"] === _this3.selectedBranch : true) && (_this3.isSale ? item.isBuyer == true : item.isBuyer == false) && item.deleted != true && !item.isCarryForwarded && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true);
      });
      invoiceHistory.map(function (inv, index) {
        if (inv["items"] && inv["items"].length) invoiceHistory[index]['GST_Percentage_total'] = Object(__WEBPACK_IMPORTED_MODULE_7__utils___["c" /* getGSTPercentageTotal */])(inv["items"]);
        invoiceHistory[index]['voucherType'] = _this3.getVocherType(inv);
      });
      this.statmentData = invoiceHistory;
    },
    invoicesByBrandNormal: function invoicesByBrandNormal() {
      var _this4 = this;

      var toDate = this.dateTo ? new Date(this.dateTo).setUTCHours(23, 59, 59, 999) : null;
      var fromDate = this.dateFrom ? new Date(this.dateFrom).setUTCHours(0, 0, 0, 0) : null;
      var total = {
        name: 'total',
        key: 'total',
        totalAmount: 0,
        basicAmount: 0,
        gstTotal: 0,
        GST_3: 0,
        GST_5: 0,
        GST_12: 0,
        GST_18: 0,
        GST_28: 0,
        totalExtraCharges: 0,
        roundOffAmount: 0,
        discountAmount: 0,
        paidAmount: 0,
        remainingAmount: 0
      };
      var invoiceHistory = this.invoices.filter(function (item) {
        return item["brand"] === _this4.selectedBrand && (_this4.selectedFirm ? item["firm"] === _this4.selectedFirm : true) && (_this4.selectedBranch ? item["branch"] === _this4.selectedBranch : true) && (_this4.isSale ? item.isBuyer == true : item.isBuyer == false) && item.deleted != true && !item.isCarryForwarded && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true);
      });
      invoiceHistory.map(function (inv, index) {
        if (inv["items"] && inv["items"].length) invoiceHistory[index]['GST_Percentage_total'] = Object(__WEBPACK_IMPORTED_MODULE_7__utils___["c" /* getGSTPercentageTotal */])(inv["items"]);
        var gst = _this4.getGSTtotal(inv);
        total.paidAmount += parseFloat(inv.paidAmount);
        total.remainingAmount += parseFloat(inv.remainingAmount);
        total.totalAmount += parseFloat(inv.totalAmount);
        // total.basicAmount += parseFloat(inv.totalAmount) - gst;
        total.basicAmount += parseFloat(inv.totalAmount) - (inv.totalExtraCharges || 0) - (inv.roundOffAmount || 0) - gst || 0;
        total.discountAmount += parseFloat(inv.discountAmount);
        total.totalExtraCharges += parseFloat(inv.totalExtraCharges);
        total.roundOffAmount += parseFloat(inv.roundOffAmount);
        total.gstTotal += gst;
        total.GST_3 += parseFloat(inv.GST_Percentage_total.GST_3);
        total.GST_5 += parseFloat(inv.GST_Percentage_total.GST_5);
        total.GST_12 += parseFloat(inv.GST_Percentage_total.GST_12);
        total.GST_18 += parseFloat(inv.GST_Percentage_total.GST_18);
        total.GST_28 += parseFloat(inv.GST_Percentage_total.GST_28);
      });
      invoiceHistory.push(total);
      this.normalData = invoiceHistory;
    },
    getGSTtotal: function getGSTtotal(item) {
      var GSTTotal = 0;
      item && item.items && item.items.map(function (item) {
        GSTTotal += __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
      });
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(GSTTotal);
    },
    buyerById: function buyerById(id) {
      if (this.buyers[id]) {
        return this.buyers[id];
      } else if (this.sellers[id]) {
        return this.sellers[id];
      }
    },
    openItems: function openItems(inv) {
      this.selectedInvoice = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(inv));
      var total = {
        productName: "Total",
        HSN_code: "",
        taxableGST_rate: "",
        productUnit: "",
        quantity: 0,
        rate: "",
        netWeight: 0
      };
      this.selectedInvoice.items.map(function (item) {
        total.quantity += parseInt(item.quantity);
        // total.rate += Number.parseFloat(item.rate)
        total.netWeight += __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item.netWeight);
      });
      total.netWeight = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(total.netWeight).toFixed(3);
      this.selectedInvoice.items.push(total);
      this.dialog11 = true;
    },
    setBussinessType: function setBussinessType() {
      var _this5 = this;

      this.businessType = this.firms.find(function (item) {
        return item[".key"] == _this5.selectedFirm;
      }).businessType;
      if (this.businessType == 'Jwellery' && this.invoiceProductListHeader[this.invoiceProductListHeader.length - 1].text != "Net Weight") {
        this.invoiceProductListHeader.push({ text: "Net Weight", value: "weight", class: "font-weight-bold primary--text" });
      }

      if (this.businessType != 'Jwellery' && this.invoiceProductListHeader[this.invoiceProductListHeader.length - 1].text == "Net Weight") {
        this.invoiceProductListHeader.pop();
      }
    },
    formatDate: function formatDate(date) {
      var d = new Date(date),
          month = "" + (d.getMonth() + 1),
          day = "" + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "getGSTtotal", function getGSTtotal(item) {
    var GSTTotal = 0;
    item && item.items && item.items.map(function (item) {
      GSTTotal += __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
    });
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_float___default()(GSTTotal);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "getFirmName", function getFirmName(id) {
    var firm = this.firms.filter(function (item) {
      return item[".key"] == id;
    })[0];
    if (firm) {
      return firm["name"];
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "print", function print() {
    if (!this.isStatementView) {
      this.isSale ? this.printSaleReport() : this.printPurchaseReport();
    } else {}
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "getVocherType", function getVocherType(invoice) {
    if (invoice.return) {
      if (invoice.isBuyer) {
        return "Credit Note";
      } else {
        return "Debit Note";
      }
    }
    // if (invoice.isBuyer && invoice.transactionType === "Debit") {
    //     return "Sale";
    // } 
    // else if (invoice.isBuyer && invoice.transactionType === "Credit") {
    //     return "Receipt";
    // }
    // else if (invoice.isBuyer && invoice.transactionType === "Partial Paid") {
    //     return "Receipt";
    // }
    // else if (!invoice.isBuyer && invoice.transactionType === "Debit") {
    //     return "Purchase";
    // }
    // else if (!invoice.isBuyer && invoice.transactionType === "Credit") {
    //     return "Payment";
    // }
    // else if (!invoice.isBuyer && invoice.transactionType === "Partial Paid") {
    //     return "Payment";
    // }
    if (invoice.isBuyer) {
      return "Sale";
    } else {
      return "Purchase";
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "printPurchaseReport", function printPurchaseReport() {
    var _this6 = this;

    var purchaseInvoice = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.normalData));
    purchaseInvoice = purchaseInvoice.filter(function (item) {
      return item['name'] != 'total';
    });
    purchaseInvoice.map(function (item, index) {
      purchaseInvoice[index]["firmName"] = _this6.getFirmName(item.firm);
      purchaseInvoice[index]["buyerName"] = _this6.buyerById(item.buyerId).name;
      purchaseInvoice[index]["GST_TOTAL"] = _this6.getGSTtotal(item);
      purchaseInvoice[index]["BASIC_AMOUNT"] = item.totalAmount - purchaseInvoice[index]["GST_TOTAL"] || 0;
      purchaseInvoice[index]["IGST"] = item.gstType == 'IGST' ? purchaseInvoice[index]["GST_TOTAL"] : 0;
      purchaseInvoice[index]["CGST"] = item.gstType == 'SGST|CGST' ? purchaseInvoice[index]["GST_TOTAL"] / 2 : 0;
      purchaseInvoice[index]["SGST"] = item.gstType == 'SGST|CGST' ? purchaseInvoice[index]["GST_TOTAL"] / 2 : 0;
      purchaseInvoice[index]["GST_3"] = item.GST_Percentage_total ? item['GST_Percentage_total']['GST_3'] : '';
      purchaseInvoice[index]["GST_5"] = item.GST_Percentage_total ? item['GST_Percentage_total']['GST_5'] : '';
      purchaseInvoice[index]["GST_12"] = item.GST_Percentage_total ? item['GST_Percentage_total']['GST_12'] : '';
      purchaseInvoice[index]["GST_18"] = item.GST_Percentage_total ? item['GST_Percentage_total']['GST_18'] : '';
      purchaseInvoice[index]["GST_28"] = item.GST_Percentage_total ? item['GST_Percentage_total']['GST_28'] : '';
    });
    var totalRow = document.querySelectorAll(".totalRow .totalField");
    purchaseInvoice.push({
      firmName: 'Total',
      buyerName: '',
      GST_TOTAL: totalRow[2].innerText.replaceAll(",", ""),
      BASIC_AMOUNT: totalRow[1].innerText.replaceAll(",", ""),
      discountAmount: totalRow[4].innerText.replaceAll(",", ""),
      IGST: 0,
      CGST: 0,
      SGST: 0,
      GST_3: totalRow[7].innerText.replaceAll(",", ""),
      GST_5: totalRow[8].innerText.replaceAll(",", ""),
      GST_12: totalRow[9].innerText.replaceAll(",", ""),
      GST_18: totalRow[10].innerText.replaceAll(",", ""),
      GST_28: totalRow[11].innerText.replaceAll(",", ""),
      totalAmount: totalRow[0].innerText.replaceAll(",", "")

    });
    var doc = Object(__WEBPACK_IMPORTED_MODULE_6__utils_pdf_reports_dashboard_reports__["a" /* convertToPDFReport */])({
      type: 'Purchase Register',
      invoiceData: purchaseInvoice,
      firm: this.selectedFirm ? this.getFirmName(this.selectedFirm) : null,
      fromDate: this.dateFrom ? new Date(this.dateFrom).toLocaleDateString('en-GB') : null,
      toDate: this.dateTo ? new Date(this.dateTo).toLocaleDateString('en-GB') : null
    });
    pdfMake.createPdf(doc).download('Purchase Register_' + new Date(this.dateFrom).toLocaleDateString('en-GB') + 'to' + new Date(this.dateTo).toLocaleDateString('en-GB'));
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "printSaleReport", function printSaleReport() {
    var _this7 = this;

    var saleInvoices = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.normalData));
    saleInvoices = saleInvoices.filter(function (item) {
      return item['name'] != 'total';
    });
    saleInvoices.map(function (item, index) {
      saleInvoices[index]["firmName"] = _this7.getFirmName(item.firm);
      saleInvoices[index]["buyerName"] = _this7.buyerById(item.buyerId).name;
      saleInvoices[index]["GST_TOTAL"] = _this7.getGSTtotal(item);
      saleInvoices[index]["BASIC_AMOUNT"] = item.totalAmount - saleInvoices[index]["GST_TOTAL"] || 0;
      saleInvoices[index]["IGST"] = item.gstType == 'IGST' ? saleInvoices[index]["GST_TOTAL"] : 0;
      saleInvoices[index]["CGST"] = item.gstType == 'SGST|CGST' ? saleInvoices[index]["GST_TOTAL"] / 2 : 0;
      saleInvoices[index]["SGST"] = item.gstType == 'SGST|CGST' ? saleInvoices[index]["GST_TOTAL"] / 2 : 0;
      saleInvoices[index]["GST_3"] = item.GST_Percentage_total ? item['GST_Percentage_total']['GST_3'] : '';
      saleInvoices[index]["GST_5"] = item.GST_Percentage_total ? item['GST_Percentage_total']['GST_5'] : '';
      saleInvoices[index]["GST_12"] = item.GST_Percentage_total ? item['GST_Percentage_total']['GST_12'] : '';
      saleInvoices[index]["GST_18"] = item.GST_Percentage_total ? item['GST_Percentage_total']['GST_18'] : '';
      saleInvoices[index]["GST_28"] = item.GST_Percentage_total ? item['GST_Percentage_total']['GST_28'] : '';
    });
    var totalRow = document.querySelectorAll(".totalRow .totalField");
    saleInvoices.push({
      firmName: 'Total',
      buyerName: '',
      GST_TOTAL: totalRow[2].innerText.replaceAll(",", ""),
      BASIC_AMOUNT: totalRow[1].innerText.replaceAll(",", ""),
      discountAmount: totalRow[4].innerText.replaceAll(",", ""),
      IGST: 0,
      CGST: 0,
      SGST: 0,
      GST_3: totalRow[7].innerText.replaceAll(",", ""),
      GST_5: totalRow[8].innerText.replaceAll(",", ""),
      GST_12: totalRow[9].innerText.replaceAll(",", ""),
      GST_18: totalRow[10].innerText.replaceAll(",", ""),
      GST_28: totalRow[11].innerText.replaceAll(",", ""),
      totalAmount: totalRow[0].innerText.replaceAll(",", "")

    });
    var doc = Object(__WEBPACK_IMPORTED_MODULE_6__utils_pdf_reports_dashboard_reports__["a" /* convertToPDFReport */])({
      type: 'Sale Register',
      invoiceData: saleInvoices,
      firm: this.selectedFirm ? this.getFirmName(this.selectedFirm) : null,
      fromDate: this.dateFrom ? new Date(this.dateFrom).toLocaleDateString('en-GB') : null,
      toDate: this.dateTo ? new Date(this.dateTo).toLocaleDateString('en-GB') : null
    });
    pdfMake.createPdf(doc).download('Sale Register_' + new Date(this.dateFrom).toLocaleDateString('en-GB') + 'to' + new Date(this.dateTo).toLocaleDateString('en-GB'));
  }), _methods)
});

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_luxon__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_luxon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_luxon__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])('Buyer')['mapGetters'];



/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        item: {
            type: Object,
            default: function _default() {
                return {};
            }
        },
        isCredited: {
            type: Boolean,
            default: true
        },
        firms: {
            type: Array,
            default: []
        },
        sellers: {
            type: Object,
            default: []
        },
        buyers: {
            type: Object,
            default: []
        },
        status: {
            type: Array,
            default: function _default() {
                return ['close'];
            }
        },
        firmAssignment: {
            type: Boolean,
            default: false
        },
        heading: {
            type: String,
            default: ""
        },
        selectedFirm: {
            type: String,
            default: null
        },
        selectedDate: {
            type: String,
            default: function _default() {
                var today = new Date();
                return today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
            }
        }
    },
    data: function data() {
        return {};
    },
    computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand']), {
        firmsByBrand: function firmsByBrand() {
            var _this = this;

            return this.firms.filter(function (item) {
                return item['brand'] === _this.selectedBrand;
            });
        }
    }),
    methods: {
        buyerById: function buyerById(id) {
            if (this.buyers[id]) {
                return this.buyers[id];
            } else if (this.sellers[id]) {
                return this.sellers[id];
            } else {
                return {
                    name: '--'
                };
            }
        },
        getCredit: function getCredit(item) {
            if (item.isBuyer) {
                switch (item.status) {
                    case 'due':
                        {
                            return item.totalAmount || item.amount || 0;
                            break;
                        }
                    case 'paid':
                        {
                            return 0;
                            break;
                        }
                    case 'partial':
                        {
                            return 0;
                            break;
                        }
                }
            } else {
                switch (item.status) {
                    case 'due':
                        {
                            return item.settledAmount || 0;
                            break;
                        }
                    case 'paid':
                        {
                            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item['amountFromBank']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item['amountFromCash']);
                            break;
                        }
                    case 'partial':
                        {
                            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item['amountFromBank']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item['amountFromCash']);
                            break;
                        }
                }
            }
        },
        getDebit: function getDebit(item) {
            if (item.isBuyer) {
                switch (item.status) {
                    case 'due':
                        {
                            return item.settledAmount || 0;
                            break;
                        }
                    case 'paid':
                        {
                            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item['amountFromBank']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item['amountFromCash']);
                            break;
                        }
                    case 'partial':
                        {
                            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item['amountFromBank']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item['amountFromCash']);
                            break;
                        }
                }
            } else {
                switch (item.status) {
                    case 'due':
                        {
                            return item.totalAmount || item.amount || 0;
                            break;
                        }
                    case 'paid':
                        {
                            return 0;
                            break;
                        }
                    case 'partial':
                        {
                            return 0;
                            break;
                        }
                }
            }
        },
        firmNameById: function firmNameById(id) {
            var firm = this.firms.filter(function (item) {
                return item['.key'] == id;
            })[0];
            if (firm) {
                return firm['name'];
            }
        },
        getNumberOfDaysFromStartDate: function getNumberOfDaysFromStartDate(createdAt, closedDate) {
            console.log(createdAt, closedDate);
            var startDate = __WEBPACK_IMPORTED_MODULE_4_luxon__["DateTime"].fromMillis(createdAt);
            if (!closedDate) {
                closedDate = __WEBPACK_IMPORTED_MODULE_4_luxon__["DateTime"].local();
            } else {
                closedDate = __WEBPACK_IMPORTED_MODULE_4_luxon__["DateTime"].fromMillis(closedDate);
            }
            var endDate = closedDate;
            var interval = __WEBPACK_IMPORTED_MODULE_4_luxon__["Interval"].fromDateTimes(startDate, endDate);
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(interval.length('days'));
        },
        getTotalAmount: function getTotalAmount(principal, rate, createdAt) {
            var time = this.getNumberOfDaysFromStartDate(createdAt) / 365;
            rate = rate * 12 / 100;
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(principal * (1 + rate * time)).toFixed(2);
        },
        getInterestValue: function getInterestValue(principal, rate, createdAt) {
            return (this.getTotalAmount(principal, rate, createdAt) - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(principal)).toFixed(2);
        },
        getVocherType: function getVocherType(invoice) {
            if (invoice.return) {
                if (invoice.isBuyer) {
                    return "Credit Note";
                } else {
                    return "Debit Note";
                }
            }
            // if (invoice.isBuyer && invoice.transactionType === "Debit") {
            //     return "Sale";
            // } 
            // else if (invoice.isBuyer && invoice.transactionType === "Credit") {
            //     return "Receipt";
            // }
            // else if (invoice.isBuyer && invoice.transactionType === "Partial Paid") {
            //     return "Receipt";
            // }
            // else if (!invoice.isBuyer && invoice.transactionType === "Debit") {
            //     return "Purchase";
            // }
            // else if (!invoice.isBuyer && invoice.transactionType === "Credit") {
            //     return "Payment";
            // }
            // else if (!invoice.isBuyer && invoice.transactionType === "Partial Paid") {
            //     return "Payment";
            // }
            if (invoice.isBuyer) {
                return "Sale";
            } else {
                return "Purchase";
            }
        }
    }
});

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_pdfmake__ = __webpack_require__(31);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    item: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    amount: 0.00,
    isCredited: {
      type: Boolean,
      default: true
    },
    firms: {
      type: Array,
      default: []
    },
    // branchs: {
    //   type: Array,
    //   default: [],
    // },
    sellers: {
      type: Object,
      default: []
    },
    buyers: {
      type: Object,
      default: []
    },
    status: {
      type: Array,
      default: function _default() {
        return ["close"];
      }
    },
    firmAssignment: {
      type: Boolean,
      default: false
    },
    heading: {
      type: String,
      default: ""
    },
    selectedFirm: {
      type: String,
      default: null
    },
    selectedDate: {
      type: String,
      default: function _default() {
        var today = new Date();
        return today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
      }
    }
  },
  data: function data() {
    return {};
  },
  created: function created() {
    this.$bindAsArray("termsAndConditions", this.$root.$firebaseRefs.termsAndConditions.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("accounts", this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("branchs", this.$root.$firebaseRefs.branch.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("productById", this.$root.$firebaseRefs.products.orderByChild("brand").equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand"]), {
    firmsByBrand: function firmsByBrand() {
      var _this = this;

      return this.firms.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      });
    }
  }),
  methods: {
    openProd: function openProd(invoice) {
      this.$emit('openItems', invoice);
    },
    buyerById: function buyerById(id) {
      if (this.buyers[id]) {
        return this.buyers[id];
      } else if (this.sellers[id]) {
        return this.sellers[id];
      } else {
        return {
          name: "--"
        };
      }
    },
    printBasicInvoice: function printBasicInvoice(selectedInvoice) {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var termsAndConditions, banks, firm, customer, gstInvoice, gstTotal, productObj, doc;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                termsAndConditions = _this2.getTermsAndConditions(selectedInvoice);

                if (termsAndConditions.length) {
                  if (termsAndConditions[0].bank) {
                    banks = [];

                    termsAndConditions[0].bank.map(function (bankId) {
                      var bank = _this2.accounts.filter(function (item) {
                        return item[".key"] == bankId;
                      })[0];

                      bank.address = _this2.getAddress(bank);
                      banks.push(bank);
                    });
                    termsAndConditions[0].banks = banks;
                  } else {
                    termsAndConditions[0].banks = [];
                  }
                } else {
                  termsAndConditions = [{
                    termsAndConditions: "",
                    banks: []
                  }];
                }
                firm = _this2.firms.filter(function (item) {
                  return item[".key"] == selectedInvoice.firm;
                })[0];

                firm.address = _this2.getAddress(firm);
                customer = _this2.buyerById(selectedInvoice.buyerId);

                customer.address = _this2.getAddress(customer);
                // selectedInvoice['date'] = selectedInvoice['dateOfInvoice'];
                gstInvoice = firm.GST_user && firm.GST_user == "Yes" ? true : false;
                gstTotal = _this2.calculateGSTInvoice(customer, selectedInvoice);
                productObj = {};

                if (!gstInvoice && termsAndConditions[0].isMajorUnitDisplay) {
                  selectedInvoice.items.map(function (item) {
                    productObj[item['productId']] = _this2.productById[item['productId']];
                  });
                }

                if (!gstInvoice) {
                  _context.next = 16;
                  break;
                }

                _context.next = 13;
                return Object(__WEBPACK_IMPORTED_MODULE_5__utils_pdfmake__["c" /* convertToBasicInvoice */])({
                  invoiceData: selectedInvoice,
                  firm: firm,
                  customer: customer,
                  gstTotal: gstTotal,
                  terms: termsAndConditions[0]
                });

              case 13:
                _context.t0 = _context.sent;
                _context.next = 19;
                break;

              case 16:
                _context.next = 18;
                return Object(__WEBPACK_IMPORTED_MODULE_5__utils_pdfmake__["f" /* convertToBasicInvoiceWithoutGST */])({
                  invoiceData: selectedInvoice,
                  firm: firm,
                  customer: customer,
                  gstTotal: gstTotal,
                  terms: termsAndConditions[0],
                  productObj: productObj
                });

              case 18:
                _context.t0 = _context.sent;

              case 19:
                doc = _context.t0;

                pdfMake.createPdf(doc).download(_this2.buyerById(selectedInvoice.buyerId).name);

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },


    // Start simple Print
    // async printInvoice4(selectedInvoice){
    //   let termsAndConditions = this.getTermsAndConditions(selectedInvoice);
    //   if(termsAndConditions.length) {
    //     if(termsAndConditions[0].bank) {
    //     let banks = [];
    //     termsAndConditions[0].bank.map((bankId) =>{
    //       let bank = this.banks.filter(item => item['.key'] == bankId)[0]

    //       bank.address = this.getAddress(bank);
    //       banks.push(bank);
    //     })
    //     termsAndConditions[0].banks = banks;
    //   } else {
    //       termsAndConditions[0].banks = [];
    //     } 
    //   } else {
    //     termsAndConditions = [{
    //       termsAndConditions : "",
    //       banks: []
    //     }]
    //   }
    //     let firm = this.firms.filter(item => item['.key'] == selectedInvoice.firmID)[0]
    //     firm.address = this.getAddress(firm);
    //     this.getCurrentUserDetails();
    //     let customer = this.currentUser;
    //     customer.address = this.getAddress(customer);
    //     selectedInvoice['date'] = selectedInvoice['dateOfInvoice'];
    //     let gstTotal = this.calculateGSTInvoice(customer,selectedInvoice);
    //      await convertToSimpleInvoicePrint({
    //         invoiceData:selectedInvoice,
    //         firm: firm,
    //         customer : customer,
    //         gstTotal : gstTotal,
    //         terms : termsAndConditions[0]
    //       }).then((doc) => {
    //         pdfMake.createPdf(doc).download(this.buyerById(selectedInvoice.buyerId).name);
    //       });
    // },
    // End simple Print

    // Simple Print
    printInvoice4: function printInvoice4(selectedInvoice) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var termsAndConditions, banks, firm, customer, gstTotal;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                termsAndConditions = _this3.getTermsAndConditions(selectedInvoice);

                if (termsAndConditions.length) {
                  if (termsAndConditions[0].bank) {
                    banks = [];

                    termsAndConditions[0].bank.map(function (bankId) {
                      var bank = _this3.accounts.filter(function (item) {
                        return item[".key"] == bankId;
                      })[0];

                      bank.address = _this3.getAddress(bank);
                      banks.push(bank);
                    });
                    termsAndConditions[0].banks = banks;
                  } else {
                    termsAndConditions[0].banks = [];
                  }
                } else {
                  termsAndConditions = [{
                    termsAndConditions: "",
                    banks: []
                  }];
                }
                firm = _this3.firms.filter(function (item) {
                  return item[".key"] == selectedInvoice.firm;
                })[0];

                firm.address = _this3.getAddress(firm);
                customer = _this3.buyerById(selectedInvoice.buyerId);

                customer.address = _this3.getAddress(customer);
                gstTotal = _this3.calculateGSTInvoice(customer, selectedInvoice);
                _context2.next = 9;
                return Object(__WEBPACK_IMPORTED_MODULE_5__utils_pdfmake__["p" /* convertToSimpleInvoicePrint */])({
                  invoiceData: selectedInvoice,
                  firm: firm,
                  customer: customer,
                  gstTotal: gstTotal,
                  terms: termsAndConditions[0],
                  previousDue: [],
                  estimates: []
                }).then(function (doc) {
                  pdfMake.createPdf(doc).download(_this3.buyerById(selectedInvoice.buyerId).name);
                });

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    },


    // End of Simple Print

    // Temp of Dairy Invoice
    printDairyInvoice: function printDairyInvoice(selectedInvoice) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var termsAndConditions, banks, firm, customer, gstInvoice, gstTotal, productObj, doc;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                termsAndConditions = _this4.getTermsAndConditions(selectedInvoice);

                if (termsAndConditions.length) {
                  if (termsAndConditions[0].bank) {
                    banks = [];

                    termsAndConditions[0].bank.map(function (bankId) {
                      var bank = _this4.accounts.filter(function (item) {
                        return item[".key"] == bankId;
                      })[0];

                      bank.address = _this4.getAddress(bank);
                      banks.push(bank);
                    });
                    termsAndConditions[0].banks = banks;
                  } else {
                    termsAndConditions[0].banks = [];
                  }
                } else {
                  termsAndConditions = [{
                    termsAndConditions: "",
                    banks: []
                  }];
                }
                firm = _this4.firms.filter(function (item) {
                  return item[".key"] == selectedInvoice.firm;
                })[0];

                firm.address = _this4.getAddress(firm);
                customer = _this4.buyerById(selectedInvoice.buyerId);

                customer.address = _this4.getAddress(customer);
                // selectedInvoice['date'] = selectedInvoice['dateOfInvoice'];
                gstInvoice = firm.GST_user && firm.GST_user == "Yes" ? true : false;
                gstTotal = _this4.calculateGSTInvoice(customer, selectedInvoice);
                productObj = {};

                if (!gstInvoice && termsAndConditions[0].isMajorUnitDisplay) {
                  selectedInvoice.items.map(function (item) {
                    productObj[item['productId']] = _this4.productById[item['productId']];
                  });
                }

                if (!gstInvoice) {
                  _context3.next = 16;
                  break;
                }

                _context3.next = 13;
                return Object(__WEBPACK_IMPORTED_MODULE_5__utils_pdfmake__["c" /* convertToBasicInvoice */])({
                  invoiceData: selectedInvoice,
                  firm: firm,
                  customer: customer,
                  gstTotal: gstTotal,
                  terms: termsAndConditions[0]
                });

              case 13:
                _context3.t0 = _context3.sent;
                _context3.next = 19;
                break;

              case 16:
                _context3.next = 18;
                return Object(__WEBPACK_IMPORTED_MODULE_5__utils_pdfmake__["d" /* convertToBasicInvoiceForDairyWithoutGST */])({
                  invoiceData: selectedInvoice,
                  firm: firm,
                  customer: customer,
                  gstTotal: gstTotal,
                  terms: termsAndConditions[0],
                  productObj: productObj
                });

              case 18:
                _context3.t0 = _context3.sent;

              case 19:
                doc = _context3.t0;

                pdfMake.createPdf(doc).download(_this4.buyerById(selectedInvoice.buyerId).name);

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },

    // Temp  of Dairy Invoice

    // Start of Dairy Invoice
    // async printDairyInvoice(selectedInvoice) {
    //   let termsAndConditions = this.getTermsAndConditions(selectedInvoice);
    //   if (termsAndConditions.length) {
    //     if (termsAndConditions[0].bank) {
    //       let banks = [];
    //       termsAndConditions[0].bank.map((bankId) => {
    //         let bank = this.banks.filter((item) => item[".key"] == bankId)[0];

    //         bank.address = this.getAddress(bank);
    //         banks.push(bank);
    //       });
    //       termsAndConditions[0].banks = banks;
    //     } else {
    //       termsAndConditions[0].banks = [];
    //     }
    //   } else {
    //     termsAndConditions = [
    //       {
    //         termsAndConditions: "",
    //         banks: [],
    //       },
    //     ];
    //   }
    //   let firm = this.firms.filter(
    //     (item) => item[".key"] == selectedInvoice.firmID
    //   )[0];
    //   firm.address = this.getAddress(firm);
    //   this.getCurrentUserDetails();
    //   let customer = this.currentUser;
    //   customer.address = this.getAddress(customer);
    //   customer.stateCode = this.gState.filter(
    //     (item) => item.state == customer.state
    //   )[0].code;
    //   selectedInvoice["date"] = selectedInvoice["dateOfInvoice"];
    //   let gstInvoice = firm.GST_user && firm.GST_user == "Yes" ? true : false;
    //   let gstTotal = this.calculateGSTInvoice(customer, selectedInvoice);
    //   let productObj = {};
    //   if(!gstInvoice && termsAndConditions[0].isMajorUnitDisplay) {
    //     selectedInvoice.items.map((item)=>{
    //       productObj[item['productId']] =  this.productById[item['productId']];
    //     })
    //   }
    //   let doc = gstInvoice
    //     ? await convertToBasicInvoice({
    //         invoiceData: selectedInvoice,
    //         firm: firm,
    //         customer: customer,
    //         gstTotal: gstTotal,
    //         terms: termsAndConditions[0],
    //         balance : this.getBalance,
    //       })
    //     : await convertToBasicInvoiceForDairyWithoutGST({
    //         invoiceData: selectedInvoice,
    //         firm: firm,
    //         customer: customer,
    //         gstTotal: gstTotal,
    //         terms: termsAndConditions[0],
    //         balance : this.getBalance,
    //         productObj : productObj
    //       });
    //   pdfMake.createPdf(doc).download(this.currentUser.name);
    // },
    // End of Dairy Invoice


    printHorizontalInvoice: function printHorizontalInvoice(selectedInvoice) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var termsAndConditions, banks, firm, customer, gstTotal;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                termsAndConditions = _this5.getTermsAndConditions(selectedInvoice);

                if (termsAndConditions.length) {
                  if (termsAndConditions[0].bank) {
                    banks = [];

                    termsAndConditions[0].bank.map(function (bankId) {
                      var bank = _this5.accounts.filter(function (item) {
                        return item[".key"] == bankId;
                      })[0];

                      bank.address = _this5.getAddress(bank);
                      banks.push(bank);
                    });
                    termsAndConditions[0].banks = banks;
                  } else {
                    termsAndConditions[0].banks = [];
                  }
                } else {
                  termsAndConditions = [{
                    termsAndConditions: "",
                    banks: []
                  }];
                }
                firm = _this5.firms.filter(function (item) {
                  return item[".key"] == selectedInvoice.firm;
                })[0];

                firm.address = _this5.getAddress(firm);
                customer = _this5.buyerById(selectedInvoice.buyerId);

                customer.address = _this5.getAddress(customer);
                gstTotal = _this5.calculateGSTInvoice(customer, selectedInvoice);
                _context4.next = 9;
                return Object(__WEBPACK_IMPORTED_MODULE_5__utils_pdfmake__["e" /* convertToBasicInvoiceHorizontal */])({
                  invoiceData: selectedInvoice,
                  firm: firm,
                  customer: customer,
                  gstTotal: gstTotal,
                  terms: termsAndConditions[0]
                }).then(function (doc) {
                  pdfMake.createPdf(doc).download(_this5.buyerById(selectedInvoice.buyerId).name);
                });

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    printEwayType1: function printEwayType1(selectedInvoice) {
      var _this6 = this;

      var termsAndConditions = this.getTermsAndConditions(selectedInvoice);
      if (termsAndConditions.length) {
        if (termsAndConditions[0].bank) {
          var banks = [];
          termsAndConditions[0].bank.map(function (bankId) {
            var bank = _this6.accounts.filter(function (item) {
              return item[".key"] == bankId;
            })[0];

            bank.address = _this6.getAddress(bank);
            banks.push(bank);
          });
          termsAndConditions[0].banks = banks;
        } else {
          termsAndConditions[0].banks = [];
        }
      } else {
        termsAndConditions = [{
          termsAndConditions: "",
          banks: []
        }];
      }
      var firm = this.firms.filter(function (item) {
        return item[".key"] == selectedInvoice.firm;
      })[0];
      firm.address = this.getAddress(firm);
      var customer = this.buyerById(selectedInvoice.buyerId);
      customer.address = this.getAddress(customer);
      var gstTotal = this.calculateGSTInvoice(customer, selectedInvoice);
      var doc = Object(__WEBPACK_IMPORTED_MODULE_5__utils_pdfmake__["j" /* convertToEwayBillType1 */])({
        invoiceData: selectedInvoice,
        firm: firm,
        customer: customer,
        gstTotal: gstTotal,
        terms: termsAndConditions[0],
        ebillDetails: selectedInvoice.ewayBillDetails.ebillDetails,
        consignee: selectedInvoice.ewayBillDetails.consignee,
        transportationDetails: selectedInvoice.ewayBillDetails.transportationDetails
      });
      pdfMake.createPdf(doc).download(this.buyerById(selectedInvoice.buyerId).name);
    },
    printEwayType2: function printEwayType2(selectedInvoice) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var termsAndConditions, banks, firm, customer, gstTotal;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                termsAndConditions = _this7.getTermsAndConditions(selectedInvoice);

                if (termsAndConditions.length) {
                  if (termsAndConditions[0].bank) {
                    banks = [];

                    termsAndConditions[0].bank.map(function (bankId) {
                      var bank = _this7.accounts.filter(function (item) {
                        return item[".key"] == bankId;
                      })[0];

                      bank.address = _this7.getAddress(bank);
                      banks.push(bank);
                    });
                    termsAndConditions[0].banks = banks;
                  } else {
                    termsAndConditions[0].banks = [];
                  }
                } else {
                  termsAndConditions = [{
                    termsAndConditions: "",
                    banks: []
                  }];
                }
                firm = _this7.firms.filter(function (item) {
                  return item[".key"] == selectedInvoice.firm;
                })[0];

                firm.address = _this7.getAddress(firm);
                customer = _this7.buyerById(selectedInvoice.buyerId);

                customer.address = _this7.getAddress(customer);
                gstTotal = _this7.calculateGSTInvoice(customer, selectedInvoice);
                _context5.next = 9;
                return Object(__WEBPACK_IMPORTED_MODULE_5__utils_pdfmake__["k" /* convertToEwayBillType2 */])({
                  invoiceData: selectedInvoice,
                  firm: firm,
                  customer: customer,
                  gstTotal: gstTotal,
                  terms: termsAndConditions[0],
                  ebillDetails: selectedInvoice.ewayBillDetails.ebillDetails,
                  consignee: selectedInvoice.ewayBillDetails.consignee,
                  transportationDetails: selectedInvoice.ewayBillDetails.transportationDetails
                }).then(function (doc) {
                  pdfMake.createPdf(doc).download(_this7.buyerById(selectedInvoice.buyerId).name);
                });

              case 9:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this7);
      }))();
    },
    printEwayType3: function printEwayType3(selectedInvoice) {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var termsAndConditions, banks, firm, customer, gstTotal;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                termsAndConditions = _this8.getTermsAndConditions(selectedInvoice);

                if (termsAndConditions.length) {
                  if (termsAndConditions[0].bank) {
                    banks = [];

                    termsAndConditions[0].bank.map(function (bankId) {
                      var bank = _this8.accounts.filter(function (item) {
                        return item[".key"] == bankId;
                      })[0];

                      bank.address = _this8.getAddress(bank);
                      banks.push(bank);
                    });
                    termsAndConditions[0].banks = banks;
                  } else {
                    termsAndConditions[0].banks = [];
                  }
                } else {
                  termsAndConditions = [{
                    termsAndConditions: "",
                    banks: []
                  }];
                }
                firm = _this8.firms.filter(function (item) {
                  return item[".key"] == selectedInvoice.firm;
                })[0];

                firm.address = _this8.getAddress(firm);
                customer = _this8.buyerById(selectedInvoice.buyerId);

                customer.address = _this8.getAddress(customer);
                gstTotal = _this8.calculateGSTInvoice(customer, selectedInvoice);
                _context6.next = 9;
                return Object(__WEBPACK_IMPORTED_MODULE_5__utils_pdfmake__["l" /* convertToEwayBillType3 */])({
                  invoiceData: selectedInvoice,
                  firm: firm,
                  customer: customer,
                  gstTotal: gstTotal,
                  terms: termsAndConditions[0],
                  ebillDetails: selectedInvoice.ewayBillDetails.ebillDetails,
                  consignee: selectedInvoice.ewayBillDetails.consignee,
                  transportationDetails: selectedInvoice.ewayBillDetails.transportationDetails
                }).then(function (doc) {
                  pdfMake.createPdf(doc).download(_this8.buyerById(selectedInvoice.buyerId).name);
                });

              case 9:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, _this8);
      }))();
    },
    getTermsAndConditions: function getTermsAndConditions(selectedInvoice) {
      var _this9 = this;

      return this.termsAndConditions.filter(function (item) {
        return item["brand"] === _this9.selectedBrand && item["firm"] === selectedInvoice.firm;
      });
    },
    getAddress: function getAddress(item) {
      var address = (item.village ? item.village + ", " : "") + (item.block ? item.block + ", " : "") + (item.tehsil ? item.tehsil + ", " : "") + (item.district ? item.district + ", " : "") + (item.state ? item.state + ", " : "") + (item.country ? item.country + ", " : "");
      address = address.substring(0, address.length - 2);
      return address;
    },
    getGSTtotal: function getGSTtotal(item) {
      var GSTTotal = 0;
      item && item.items && item.items.map(function (item) {
        GSTTotal += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
      });
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(GSTTotal);
    },
    calculateGSTInvoice: function calculateGSTInvoice(currentUser, invoice) {
      var SGST_val = 0;
      var CGST_val = 0;
      var IGST_val = 0;
      invoice.items && invoice.items.map(function (item, index) {
        SGST_val += parseFloat(item["SGST_val"]);
        CGST_val += parseFloat(item["CGST_val"]);
        IGST_val += parseFloat(item["IGST_val"]);
      });
      return { SGST_val: SGST_val, CGST_val: CGST_val, IGST_val: IGST_val };
    },
    firmNameById: function firmNameById(id) {
      var firm = this.firms.filter(function (item) {
        return item[".key"] == id;
      })[0];
      if (firm) {
        return firm["name"];
      }
    },
    branchNameById: function branchNameById(id) {
      var branch = this.branchs.filter(function (item) {
        return item[".key"] == id;
      })[0];
      if (branch) {
        return branch["branchName"];
      }
    },
    renderDate: function renderDate(timeStamp) {
      if (timeStamp) {
        return new Date(timeStamp).toLocaleDateString("en-GB");
      }
      return "--";
    }
  }
});

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_PaymentReceipt__ = __webpack_require__(1529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_digitsToWords_js__ = __webpack_require__(35);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* createNamespacedHelpers */])("Buyer")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      addDipositDialog: false,
      defaultFirm: null,
      currentPayment: {},
      isSaving: false,
      snackbar: false,
      successText: '',
      hintText: null,
      selectedInvoices: [],
      currentUser: {},
      balance: 0,
      datepicker: null,
      transferType: null,
      transferTypeDialog: false,
      paymentHeader: [
      // { text: "ID", value: "payment - ID" },
      { text: "Amount", value: "quantity" }, { text: "Remaining Amount", value: "quantity" }, { text: "Date", value: "date", sortable: true }, { text: "Edit", value: "edit" }, { text: "Delete", value: "delete" }, { text: "Print", value: "print" }],
      isBuyer: true,
      transferDetails: {
        accountNumber: "",
        accountHolderName: "",
        bankName: "",
        IFSCcode: "",
        remark: ""
      },
      password: null,
      passwordDialog: false,
      currentPasswordReference: null,
      currentPasswordMethod: null,
      isValidSave: false,
      currentUserId: null
    };
  },
  mounted: function mounted() {
    this.getCurrentUser();
    this.getBalance();
  },
  created: function created() {
    this.$bindAsArray("customerPayments", this.$root.$firebaseRefs.customerPayments.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray('buyers', this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray('sellers', this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('invoice', this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("banks", this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsObject("productById", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('invoiceHistories', this.$root.$firebaseRefs.invoiceHistory.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("customerDeposit", this.$root.$firebaseRefs.customerDeposit.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("termsAndConditions", this.$root.$firebaseRefs.termsAndConditions.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("bankById", this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("firmSettings", this.$root.$firebaseRefs.firmSettings.orderByChild("brand").equalTo(this.selectedBrand));
  },

  watch: {
    "currentUserId": {
      handler: function handler(newVal) {
        if (newVal) {
          if (this.isBuyer) {
            this.currentUser = this.buyers.find(function (item) {
              return item['.key'] == newVal;
            });
          } else {
            this.currentUser = this.sellers.find(function (item) {
              return item['.key'] == newVal;
            });
          }
          this.getBalance();
        }
      }
    },
    "currentPayment.amount": {
      handler: function handler() {
        this.hintText = this.currentPayment.amount ? _.startCase(Object(__WEBPACK_IMPORTED_MODULE_9__utils_digitsToWords_js__["a" /* digitsToWords */])(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.currentPayment.amount))) : null;
      },

      deep: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", 'finYear']), {
    paymentListByBrand: function paymentListByBrand() {
      var _this = this;

      return this.customerPayments.filter(function (item) {
        return item["brand"] === _this.selectedBrand && item.buyerId == _this.currentUser['.key'] && item.date >= _this.finYear.start && item.date <= _this.finYear.end;
      });
    },
    firmsByBrand: function firmsByBrand() {
      var _this2 = this;

      return this.firms.filter(function (item) {
        return item["brand"] === _this2.selectedBrand;
      }).map(function (item) {
        if (item.defaultFirm) {
          _this2.defaultFirm = item['.key'];
        }
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
    },
    banksByFirms: function banksByFirms() {
      var _this3 = this;

      return this.banks.filter(function (item) {
        return item["brand"] === _this3.selectedBrand && item["firm"] === _this3.currentPayment['firm'];
      }).map(function (item) {
        return {
          account: item,
          text: item["bankName"],
          value: item[".key"]
        };
      });
    },
    customerListByBrand: function customerListByBrand() {
      var _this4 = this;

      if (this.isBuyer) {
        return this.buyers.filter(function (item) {
          return item["brand"] === _this4.selectedBrand;
        }).map(function (item) {
          return {
            name: item.name + " | " + (item['localAddress'] || ""),
            value: item['.key']
          };
        });
      } else {
        return this.sellers.filter(function (item) {
          return item["brand"] === _this4.selectedBrand;
        }).map(function (item) {
          return {
            name: item.name,
            value: item['.key']
          };
        });
      }
    }
  }),
  methods: {
    //  getBalance(){
    //   let remainingAmount = 0;
    //   this.invoice.filter(
    //     item =>
    //       (item["brand"] === this.selectedBrand &&
    //       (item.deleted != true) &&
    //       (item.buyerId == this.currentUser['.key']) &&
    //       (item["status"] === "due" || item["status"] === "partial"))
    //   ).map((item)=>{
    //       remainingAmount += item.totalAmount ? Number.parseFloat(item.totalAmount) : 0;
    //       remainingAmount -= item.paidAmount ? Number.parseFloat(item.paidAmount) : 0;
    //   });
    //   this.balance = ((remainingAmount ? Number.parseFloat(remainingAmount) : 0) + this.getDepositeAmount())
    // },
    getBalance: function getBalance() {
      var _this5 = this;

      var filteredInvoice = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], this.invoiceHistories.filter(function (item) {
        return item["brand"] === _this5.selectedBrand && item["buyerId"] === _this5.currentUser['.key'] && !item["deleted"] && (item['returnStatus'] ? item['returnStatus'] == 'remaining' && item['status'] == 'paid' : true) && (item['isLatest'] != undefined ? item['isLatest'] == true : true);
      }));
      var payments = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], this.customerPayments.filter(function (item) {
        return item["brand"] === _this5.selectedBrand && item["buyerId"] === _this5.currentUser['.key'] && __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item["remainingAmount"]) > 0;
      }));
      var customerDeposit = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], this.customerDeposit.filter(function (item) {
        return item["brand"] === _this5.selectedBrand && item["buyerId"] === _this5.currentUser['.key'] && (item["type"] === "Advance" || item["type"] === "Opening Balance" || item["type"] === "LoanTaken" || item["type"] === "LoanGiven" || item["type"] === "Security");
      }));

      filteredInvoice.map(function (item, index) {
        //if(item.newlyCreated && (item.status === "paid" || item.status === "partial")) {
        if (item.newlyCreated && (item.status === "paid" || item.status === "partial")) {
          var newItem = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(item));
          newItem.date = newItem.date - 1;
          newItem.transactionType = "Debit";
          newItem.paidAmount = 0;
          newItem.status = 'due';
          newItem.remainingAmount = newItem.totalAmount;
          delete newItem['newlyCreated'];
          filteredInvoice.push(newItem);
        }
        if (item.closedDate) {
          filteredInvoice[index].date = item.closedDate;
        }
      });

      customerDeposit.map(function (deposit, index) {
        filteredInvoice.push(deposit);
        if ((deposit["type"] === "LoanTaken" || deposit["type"] === "LoanGiven") && deposit.status == "paid" && !deposit.loanTransaction) {
          customerDeposit[index].status = 'due';
        }
      });

      payments.map(function (pay) {
        pay['type'] = 'CustomerPayment';
        filteredInvoice.push(pay);
      });
      filteredInvoice.sort(function (a, b) {
        return -(new Date(b.date) - new Date(a.date));
      });

      filteredInvoice.map(function (item, index) {

        filteredInvoice[index]["debit"] = _this5.getDebit(filteredInvoice[index]);
        filteredInvoice[index]["credit"] = _this5.getCredit(filteredInvoice[index]);
        if (item.isBuyer) {
          var temp = filteredInvoice[index]["credit"];
          filteredInvoice[index]["credit"] = filteredInvoice[index]["debit"];
          filteredInvoice[index]["debit"] = temp;
        }
        filteredInvoice[index]["RunningBal"] = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(filteredInvoice[index]["debit"] || 0) - __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(filteredInvoice[index]["credit"] || 0) + (index == 0 ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(filteredInvoice[index - 1]["RunningBal"]));
      });
      // this.balance = filteredInvoice[filteredInvoice.length-1]["RunningBal"]
      this.balance = filteredInvoice && filteredInvoice.length ? filteredInvoice[filteredInvoice.length - 1]["RunningBal"] : 0;
    },
    getDebit: function getDebit(item) {
      if (item.type == 'CustomerPayment') {
        if (!item.isBuyer) {
          return 0;
        } else {
          return item['remainingAmount'];
        }
      } else if (['LoanTaken', 'LoanGiven', 'Opening Balance', 'Advance', 'Security'].includes(item.type)) {
        switch (item.type) {
          case 'LoanTaken':
            {
              if (item.loanTransaction) {
                return 0;
              } else {
                return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.amount);
              }
              break;
            }
          case 'LoanGiven':
            {
              if (item.loanTransaction) {
                if (item.loanPaymentType == 'interest') {
                  return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.paidInterest);
                } else {
                  return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.paidAmount);
                }
              } else {
                return 0;
              }
              break;
            }
          case 'Opening Balance':
            {
              // if(item.status == 'due') {
              //   return item.isUserCreated ? Number.parseFloat(0) : Number.parseFloat(item.amount);
              // } else if((item.status == 'paid' || item.status == 'partial' )) {
              //   return item.isUserCreated ? Number.parseFloat(0) : Number.parseFloat(item.settledAmount);
              // } 
              // else {
              //   return 0 ;
              // }
              // return item.isUserCreated ? Number.parseFloat(item.amount) : Number.parseFloat(0);
              return item.isUserCreated ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(0) : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.settledAmount);
              break;
            }
          case 'Advance':
            {
              return item.isUserCreated ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.amount) : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(0);
              break;
            }
          case 'Security':
            {
              return item.isUserCreated ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.amount) : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(0);
              break;
            }
        }
      } else {
        switch (item.status) {
          case 'due':
            {
              return 0;
              break;
            }
          case 'paid':
            {
              // return (Number.parseFloat(item['totalAmount']));
              return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item['amountFromBank']) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item['amountFromCash']);
              break;
            }
          case 'partial':
            {
              return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item['amountFromBank']) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item['amountFromCash']);
              break;
            }
        }
      }
    },
    getCredit: function getCredit(item) {
      if (item.type == 'CustomerPayment') {
        if (item.isBuyer) {
          return 0;
        } else {
          return item['remainingAmount'];
        }
      } else if (['LoanTaken', 'LoanGiven', 'Opening Balance', 'Advance', 'Security'].includes(item.type)) {
        switch (item.type) {
          case 'LoanTaken':
            {
              if (item.loanTransaction) {
                if (item.loanPaymentType == 'interest') {
                  return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.paidInterest);
                } else {
                  return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.paidAmount);
                }
              } else {
                return 0;
              }
              break;
            }
          case 'LoanGiven':
            {
              if (item.loanTransaction) {
                return 0;
              } else {
                return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.amount);
              }
              break;
            }
          case 'Opening Balance':
            {
              return item.isUserCreated ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.amount) : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(0);
              break;
            }
          case 'Advance':
            {
              return item.isUserCreated ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(0) : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.settledAmount);
              break;
            }
          case 'Security':
            {
              return item.isUserCreated ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(0) : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.settledAmount);
              break;
            }
        }
      } else {
        switch (item.status) {
          case 'due':
            {
              return item.totalAmount;
              break;
            }
          case 'paid':
            {
              return 0;
              break;
            }
          case 'partial':
            {
              return 0;
              break;
            }
        }
      }
    },
    getUserInvoices: function getUserInvoices() {
      var _this6 = this;

      this.selectedInvoices = [];
      var dueInvoices = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], this.invoice.filter(function (item) {
        return item["brand"] === _this6.selectedBrand && item.deleted != true && (_this6.currentPayment.firm && !_this6.currentPayment.multiFirm ? item.firm == _this6.currentPayment.firm : true) && item.buyerId == _this6.currentUser['.key'] && (item["status"] === "due" || item["status"] === "partial");
      }));
      var amountToBePaid = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.currentPayment.amount);
      var openingBalance = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], this.customerDeposit.filter(function (item) {
        return item["brand"] === _this6.selectedBrand && item.buyerId == _this6.currentUser['.key'] && item["type"] === "Opening Balance" && !!item["isUserCreated"] && parseInt(item["remainingAmount"]) > 0 && (_this6.currentPayment.firm && !_this6.currentPayment.multiFirm ? item.firm == _this6.currentPayment.firm : true);
      }));
      openingBalance.map(function (invoice) {
        if (invoice['.key']) {
          if (amountToBePaid >= __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoice.remainingAmount)) {
            amountToBePaid = amountToBePaid - __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoice.remainingAmount);
            _this6.selectedInvoices.push({
              invoiceId: invoice['.key'],
              settledAmount: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoice.remainingAmount),
              status: 'paid',
              invoiceType: "Opening Balance",
              invoice: invoice
            });
          } else if (amountToBePaid > 0) {
            _this6.selectedInvoices.push({
              invoiceId: invoice['.key'],
              settledAmount: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(amountToBePaid),
              status: 'partial',
              invoiceType: "Opening Balance",
              invoice: invoice
            });
            amountToBePaid = 0;
          }
        }
      });
      dueInvoices.map(function (invoice) {
        if (invoice['.key']) {
          if (amountToBePaid >= __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoice.remainingAmount)) {
            amountToBePaid = amountToBePaid - __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoice.remainingAmount);
            _this6.selectedInvoices.push({
              invoiceId: invoice['.key'],
              settledAmount: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoice.remainingAmount),
              status: 'paid',
              invoice: invoice
            });
          } else if (amountToBePaid > 0) {
            _this6.selectedInvoices.push({
              invoiceId: invoice['.key'],
              settledAmount: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(amountToBePaid),
              status: 'partial',
              invoice: invoice
            });
            amountToBePaid = 0;
          }
        }
      });
      this.currentPayment.remainingAmount = amountToBePaid;
      this.paySelectedInvoice();
    },
    paySelectedInvoice: function paySelectedInvoice() {
      var _this7 = this;

      this.isSaving = true;
      var closedDate = new Date(this.currentPayment.date);
      var todayDate = new Date();
      var selectedDate = new Date(closedDate.getFullYear(), closedDate.getMonth(), closedDate.getDate(), todayDate.getHours(), todayDate.getMinutes(), todayDate.getSeconds());
      this.selectedInvoices.map(function (item, index) {
        if (item.invoiceType == 'Opening Balance') {
          var invoiceToUpdate = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, item.invoice);
          _this7.$root.$firebaseRefs.customerDeposit.child(invoiceToUpdate['.key']).update({
            remainingAmount: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceToUpdate['remainingAmount']) - __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.settledAmount)
          });
          invoiceToUpdate['settledAmount'] = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.settledAmount);
          invoiceToUpdate['amount'] = 0;
          invoiceToUpdate['status'] = item.status;
          invoiceToUpdate['paymentType'] = _this7.currentPayment.paymentType;
          invoiceToUpdate['remainingAmount'] = 0;
          invoiceToUpdate['isUserCreated'] = false;
          invoiceToUpdate['date'] = new Date(selectedDate).getTime();

          if (_this7.currentPayment.paymentType == 'Cash') {} else {
            invoiceToUpdate['bank'] = _this7.currentPayment.bank;
            invoiceToUpdate['transferType'] = _this7.transferType;
            invoiceToUpdate['transferDetails'] = _this7.transferDetails;
          }
          delete invoiceToUpdate['.key'];
          var newdeposite = _this7.$root.$firebaseRefs.customerDeposit.push(invoiceToUpdate);
          switch (invoiceToUpdate.paymentType) {
            case 'Cash':
              {
                if (invoiceToUpdate.settledAmount) {
                  var firm = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this7.firms.filter(function (item) {
                    return item['.key'] == invoiceToUpdate.firm;
                  })[0]);
                  if (firm && (invoiceToUpdate.status == 'paid' || invoiceToUpdate.status == 'partial')) {
                    firm.amount = invoiceToUpdate.isBuyer ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(firm.amount) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceToUpdate.settledAmount) : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(firm.amount) - __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceToUpdate.settledAmount);
                    delete firm['.key'];
                    _this7.$root.$firebaseRefs.firm.child(invoiceToUpdate.firm).set(firm);
                  }
                }
                break;
              }
            case 'Bank Account':
              {
                if (invoiceToUpdate.settledAmount) {
                  var bank = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this7.banks.filter(function (item) {
                    return item['.key'] == invoiceToUpdate.bank;
                  })[0]);
                  if (bank && (invoiceToUpdate.status == 'paid' || invoiceToUpdate.status == 'partial')) {
                    bank.amount = invoiceToUpdate.isBuyer ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(bank.amount) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceToUpdate.settledAmount) : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(bank.amount) - __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceToUpdate.settledAmount);
                    delete bank['.key'];
                    _this7.$root.$firebaseRefs.account.child(invoiceToUpdate.bank).set(bank);
                  }
                }
                break;
              }
          }
          _this7.selectedInvoices[index]['newInvoice'] = newdeposite['key'];
        } else {
          var _invoiceToUpdate = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, item.invoice);
          _invoiceToUpdate['closedDate'] = new Date(selectedDate).getTime();
          _invoiceToUpdate['status'] = item.status;
          if (_this7.currentPayment.paymentType == 'Cash') {
            _invoiceToUpdate['amountFromCash'] = _invoiceToUpdate['amountFromCash'] ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_invoiceToUpdate['amountFromCash']) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.settledAmount) : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.settledAmount);
            // invoiceToUpdate['remainingAmount'] = Number.parseFloat(invoiceToUpdate['totalAmount']) -Number.parseFloat(invoiceToUpdate['amountFromCash']);
            _invoiceToUpdate['remainingAmount'] = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_invoiceToUpdate['totalAmount']) - (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_invoiceToUpdate['amountFromCash']) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_invoiceToUpdate['amountFromBank']));
          } else {
            _invoiceToUpdate['amountFromBank'] = _invoiceToUpdate['amountFromBank'] ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_invoiceToUpdate['amountFromBank']) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.settledAmount) : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.settledAmount);
            // invoiceToUpdate['remainingAmount'] = Number.parseFloat(invoiceToUpdate['totalAmount']) -Number.parseFloat(invoiceToUpdate['amountFromBank']);
            _invoiceToUpdate['remainingAmount'] = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_invoiceToUpdate['totalAmount']) - (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_invoiceToUpdate['amountFromCash']) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_invoiceToUpdate['amountFromBank']));
            _invoiceToUpdate['bank'] = _this7.currentPayment.bank;
            _invoiceToUpdate['transferType'] = _this7.transferType;
            _invoiceToUpdate['transferDetails'] = _this7.transferDetails;
          }
          _invoiceToUpdate['transactionType'] = "Credit";
          _invoiceToUpdate['paymentType'] = _this7.currentPayment.paymentType;
          // invoiceToUpdate['date'] = new Date(this.currentPayment.date).getTime();
          _invoiceToUpdate['paidAmount'] = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_invoiceToUpdate.amountFromCash ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_invoiceToUpdate.amountFromCash) : 0) + (_invoiceToUpdate.amountFromBank ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_invoiceToUpdate.amountFromBank) : 0);

          _this7.selectedInvoices[index]['oldInvoiceHistoryId'] = _this7.updateInvoice(_invoiceToUpdate, item.settledAmount);
        }
        delete _this7.selectedInvoices[index]['invoice'];
      });
      this.currentPayment['settledInvoiceDetails'] = this.selectedInvoices;
      if (!!this.currentPayment['.key']) {
        this.updatePayment();
      } else {
        this.savePayment();
      }
    },
    updateInvoice: function updateInvoice(invoiceData, settledAmount) {
      var _this8 = this;

      console.log('Update Invoice Called');
      var latestInvKey = null;
      // this.dialog = false
      console.info(invoiceData);
      var updated_at = new Date().getTime();
      try {
        invoiceData['items'].forEach(function (item, index) {
          item['date'] = invoiceData['date'];
          if (item.id) {
            item['updated_at'] = updated_at;
            _this8.$root.$firebaseRefs.item.child(item['id']).update(item, function () {
              console.info('item udpated...');
            });
          } else {
            var response = _this8.$root.$firebaseRefs.item.push(item, function () {
              console.info('item pushed...');
            });
            invoiceData['items'][index]['id'] = response['key'];
          }
        });
        invoiceData['updated_at'] = updated_at;
        var key = invoiceData['.key'];
        delete invoiceData['.key'];

        this.$root.$firebaseRefs.invoice.child(key).update(invoiceData, function () {
          console.info('invoice updated...');
          if (_this8.dialog) _this8.dialog = false;
          _this8.managePayments(invoiceData);
        });
        invoiceData['parentInvoiceKey'] = key;
        delete invoiceData['newlyCreated'];
        var letestInv = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.invoiceHistories.filter(function (item) {
          return item['brand'] == _this8.selectedBrand && item['isLatest'] == true && item['parentInvoiceKey'] == key;
        })[0]);
        latestInvKey = letestInv['.key'];
        delete letestInv['.key'];
        delete letestInv['isLatest'];
        this.$root.$firebaseRefs.invoiceHistory.child(latestInvKey).set(letestInv, function () {});
        invoiceData['isLatest'] = true;
        if (invoiceData.paymentType == 'Cash') {
          invoiceData['amountFromCash'] = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(settledAmount);
          invoiceData['amountFromBank'] = 0;
        } else {
          invoiceData['amountFromBank'] = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(settledAmount);
          invoiceData['amountFromCash'] = 0;
        }
        this.$root.$firebaseRefs.invoiceHistory.push(invoiceData);
      } catch (e) {
        console.info('Error at update Invoice', e);
      }
      return latestInvKey;
    },
    saveUpdatedPayment: function saveUpdatedPayment() {
      this.undoInvoicePayment(this.currentPayment, true);
      this.getUserInvoices();
    },
    undoInvoicePayment: function undoInvoicePayment(payment, manageBeforePayments) {
      var _this9 = this;

      payment.settledInvoiceDetails && payment.settledInvoiceDetails.map(function (inv) {
        if (inv.invoiceType == 'Opening Balance') {
          var oldInvoiceData = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this9.customerDeposit.filter(function (item) {
            return item['.key'] == inv['invoiceId'];
          })[0]);
          _this9.$root.$firebaseRefs.customerDeposit.child(inv['newInvoice']).remove();
          _this9.$root.$firebaseRefs.customerDeposit.child(inv['invoiceId']).update({
            remainingAmount: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(oldInvoiceData['remainingAmount']) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.settledAmount)
          });
        } else {
          console.log(_this9.invoice);
          var invoiceData = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this9.invoice.filter(function (item) {
            return item['.key'] == inv['invoiceId'];
          })[0]);
          if (manageBeforePayments) {
            _this9.manageBeforePayments(invoiceData);
          }
          var _oldInvoiceData = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this9.invoiceHistories.filter(function (item) {
            return item['.key'] == inv['oldInvoiceHistoryId'];
          })[0]);
          var letestInv = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this9.invoiceHistories.filter(function (item) {
            return item['brand'] == _this9.selectedBrand && item['isLatest'] == true && item['parentInvoiceKey'] == inv['invoiceId'];
          })[0]);
          _this9.$root.$firebaseRefs.invoiceHistory.child(letestInv['.key']).remove();
          if (_oldInvoiceData['closedDate']) {
            invoiceData['closedDate'] = _oldInvoiceData['closedDate'];
          } else {
            delete invoiceData['closedDate'];
          }
          if (_oldInvoiceData['paymentType']) {
            invoiceData['paymentType'] = _oldInvoiceData['paymentType'];
          } else {
            delete invoiceData['paymentType'];
          }
          if (!!__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_oldInvoiceData['amountFromCash'])) {
            invoiceData['amountFromCash'] = _oldInvoiceData['amountFromCash'];
          } else {
            invoiceData['amountFromCash'] = 0;
          }
          if (!!__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_oldInvoiceData['amountFromBank'])) {
            invoiceData['amountFromBank'] = _oldInvoiceData['amountFromBank'];
          } else {
            invoiceData['amountFromBank'] = 0;
          }
          if (_oldInvoiceData['bank']) {
            invoiceData['bank'] = _oldInvoiceData['bank'];
          } else {
            delete invoiceData['bank'];
          }
          if (_oldInvoiceData['transferType']) {
            invoiceData['transferType'] = _oldInvoiceData['transferType'];
          } else {
            delete invoiceData['transferType'];
          }

          if (_oldInvoiceData['transferDetails']) {
            invoiceData['transferDetails'] = _oldInvoiceData['transferDetails'];
          } else {
            delete invoiceData['transferDetails'];
          }
          invoiceData['status'] = _oldInvoiceData.status;
          invoiceData['remainingAmount'] = _oldInvoiceData.remainingAmount;
          invoiceData['date'] = _oldInvoiceData.date;
          invoiceData['paidAmount'] = _oldInvoiceData.paidAmount;
          delete invoiceData['.key'];
          _this9.$root.$firebaseRefs.invoice.child(inv['invoiceId']).update(invoiceData, function () {
            // this.manageBeforePayments(invoiceData);
          });
          // oldInvoiceData['isLatest'] = true;
          // delete oldInvoiceData['.key']
          _this9.$root.$firebaseRefs.invoiceHistory.child(inv['oldInvoiceHistoryId']).update({ isLatest: true }, function () {});
        }
      });
    },
    manageBeforePayments: function manageBeforePayments(invoiceData) {
      switch (invoiceData.paymentType) {
        case 'Cash':
          {
            if (invoiceData.amountFromCash) {
              var firm = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.firms.filter(function (item) {
                return item['.key'] == invoiceData.firm;
              })[0]);
              if (firm && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                firm.amount = invoiceData.isBuyer ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(firm.amount) - __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash) : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(firm.amount) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash);
                delete firm['.key'];
                this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(firm);
              }
            }
            break;
          }
        case 'Bank Account':
          {
            if (invoiceData.amountFromBank) {
              var bank = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.banks.filter(function (item) {
                return item['.key'] == invoiceData.bank;
              })[0]);
              if (bank && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                bank.amount = invoiceData.isBuyer ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(bank.amount) - __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank) : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(bank.amount) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank);
                delete bank['.key'];
                this.$root.$firebaseRefs.account.child(invoiceData.bank).set(bank);
              }
            }
            break;
          }
        case 'CashAndBank Account':
          {
            if (invoiceData.amountFromCash && invoiceData.amountFromBank) {
              var _bank = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.banks.filter(function (item) {
                return item['.key'] == invoiceData.bank;
              })[0]);
              if (_bank && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                _bank.amount = invoiceData.isBuyer ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_bank.amount) - __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank) : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_bank.amount) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank);
                delete _bank['.key'];
                this.$root.$firebaseRefs.account.child(invoiceData.bank).set(_bank);
              }
              var _firm = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.firms.filter(function (item) {
                return item['.key'] == invoiceData.firm;
              })[0]);
              if (_firm && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                _firm.amount = invoiceData.isBuyer ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_firm.amount) - __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash) : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_firm.amount) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash);
                delete _firm['.key'];
                this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(_firm);
              }
            }
            break;
          }
      }
    },
    managePayments: function managePayments(invoiceData) {
      switch (invoiceData.paymentType) {
        case 'Cash':
          {
            if (invoiceData.amountFromCash) {
              var firm = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.firms.filter(function (item) {
                return item['.key'] == invoiceData.firm;
              })[0]);
              if (firm && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                firm.amount = invoiceData.isBuyer ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(firm.amount) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash) : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(firm.amount) - __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash);
                delete firm['.key'];
                this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(firm);
              }
            }
            break;
          }
        case 'Bank Account':
          {
            if (invoiceData.amountFromBank) {
              var bank = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.banks.filter(function (item) {
                return item['.key'] == invoiceData.bank;
              })[0]);
              if (bank && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                bank.amount = invoiceData.isBuyer ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(bank.amount) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank) : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(bank.amount) - __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank);
                delete bank['.key'];
                this.$root.$firebaseRefs.account.child(invoiceData.bank).set(bank);
              }
            }
            break;
          }
        case 'CashAndBank Account':
          {
            if (invoiceData.amountFromCash && invoiceData.amountFromBank) {
              var _bank2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.banks.filter(function (item) {
                return item['.key'] == invoiceData.bank;
              })[0]);
              if (_bank2 && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                _bank2.amount = invoiceData.isBuyer ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_bank2.amount) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank) : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_bank2.amount) - __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank);
                delete _bank2['.key'];
                this.$root.$firebaseRefs.account.child(invoiceData.bank).set(_bank2);
              }
              var _firm2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.firms.filter(function (item) {
                return item['.key'] == invoiceData.firm;
              })[0]);
              if (_firm2 && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                _firm2.amount = invoiceData.isBuyer ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_firm2.amount) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash) : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_firm2.amount) - __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash);
                delete _firm2['.key'];
                this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(_firm2);
              }
            }
            break;
          }
      }
    },
    manageDeletes: function manageDeletes(invoiceData) {
      switch (invoiceData.paymentType) {
        case 'Cash':
          {
            if (invoiceData.amount) {
              var firm = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.firms.filter(function (item) {
                return item['.key'] == invoiceData.firm;
              })[0]);
              if (firm) {
                firm.amount = invoiceData.isBuyer ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(firm.amount) - __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceData.amount) : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(firm.amount) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceData.amount);
                delete firm['.key'];
                this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(firm);
              }
            }
            break;
          }
        case 'Bank Account':
          {
            if (invoiceData.amount) {
              var bank = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, this.banks.filter(function (item) {
                return item['.key'] == invoiceData.bank;
              })[0]);
              if (bank) {
                bank.amount = invoiceData.isBuyer ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(bank.amount) - __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceData.amount) : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(bank.amount) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(invoiceData.amount);
                delete bank['.key'];
                this.$root.$firebaseRefs.account.child(invoiceData.bank).set(bank);
              }
            }
            break;
          }
      }
    },
    checkValidity: function checkValidity() {
      if (!this.currentPayment.firm) {
        this.isValidSave = false;
      } else {
        this.isValidSave = true;
      }
      if (!this.currentPayment.paymentType) {
        this.isValidSave = false;
      } else {
        if (this.currentPayment.paymentType == 'Cash') {
          if (!this.currentPayment.amount) {
            this.isValidSave = false;
          } else {
            this.isValidSave = true;
          }
        } else {
          if (!this.currentPayment.bank) {
            this.isValidSave = false;
          } else {
            if (!this.currentPayment.amount) {
              this.isValidSave = false;
            } else {
              this.isValidSave = true;
            }
          }
        }
      }
    },
    savePayment: function savePayment() {
      var closedDate = new Date(this.currentPayment.date);
      var todayDate = new Date();
      var selectedDate = new Date(closedDate.getFullYear(), closedDate.getMonth(), closedDate.getDate(), todayDate.getHours(), todayDate.getMinutes(), todayDate.getSeconds());
      this.currentPayment.date = new Date(selectedDate).getTime();
      this.currentPayment['isBuyer'] = this.isBuyer;
      this.currentPayment['buyerId'] = this.currentUser['.key'];
      if (this.currentPayment.paymentType == 'Bank') {
        this.currentPayment['transferType'] = this.transferType;
        this.currentPayment['transferDetails'] = this.transferDetails;
      }
      this.$root.$firebaseRefs.customerPayments.push(this.currentPayment);
      //this.addRemainingBalance();
      this.successText = this.currentPayment.settledInvoiceDetails.length + " invoice(s) has been updated.";
      this.addDipositDialog = false;
      this.snackbar = true;
      this.getBalance();
      this.isSaving = false;
      this.saveReceiptNumber(this.currentPayment);
    },
    updatePayment: function updatePayment() {
      var closedDate = new Date(this.currentPayment.date);
      var todayDate = new Date();
      var selectedDate = new Date(closedDate.getFullYear(), closedDate.getMonth(), closedDate.getDate(), todayDate.getHours(), todayDate.getMinutes(), todayDate.getSeconds());
      this.currentPayment.date = new Date(selectedDate).getTime();
      var paymentId = this.currentPayment['.key'];
      delete this.currentPayment['.key'];
      this.$root.$firebaseRefs.customerPayments.child(paymentId).update(this.currentPayment, function () {});
      //this.addRemainingBalance();
      this.successText = this.currentPayment.settledInvoiceDetails.length + " invoice(s) has been updated.";
      this.addDipositDialog = false;
      this.snackbar = true;
      this.getBalance();
      this.isSaving = false;
    },
    getCurrentUser: function getCurrentUser() {
      var _this10 = this;

      if (this.$route.params.customerId != 'null') {
        var buyer = this.buyers.filter(function (item) {
          return item['.key'] == _this10.$route.params.customerId;
        })[0];
        var seller = this.sellers.filter(function (item) {
          return item['.key'] == _this10.$route.params.customerId;
        })[0];
        this.isBuyer = buyer ? true : false;
        this.currentUserId = this.$route.params.customerId;
      }
    },
    saveReceiptNumber: function saveReceiptNumber() {
      if (!this.currentPayment.multiFirm) {
        if (this.isBuyer) {
          this.$root.$firebaseRefs.firm.child(this.currentPayment.firm).update({
            lastReceiptCount: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int___default()(this.currentPayment.receiptNumber)
          }, function () {
            //console.info("last receiptNumber updated...");
          });
        } else {
          this.$root.$firebaseRefs.firm.child(this.currentPayment.firm).update({
            lastReceiptCountSeller: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int___default()(this.currentPayment.receiptNumber)
          }, function () {
            //console.info("last receiptNumber updated...");
          });
        }
      }
    },
    addDiposit: function addDiposit() {

      this.currentPayment = {
        amount: 0,
        buyerId: this.currentUser['.key'],
        brand: this.selectedBrand,
        paymentType: 'Cash',
        firm: this.defaultFirm || null,
        bank: null,
        date: new Date().toISOString().substr(0, 10),
        receiptNumber: 1
      };
      this.setReceiptNumber();
      this.addDipositDialog = true;
    },
    setReceiptNumber: function setReceiptNumber() {
      var _this11 = this;

      var firm = this.firms.find(function (item) {
        return item['.key'] == _this11.currentPayment.firm;
      });
      var firmReceiptCount = this.isBuyer ? firm.lastReceiptCount ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int___default()(firm.lastReceiptCount) + 1 : 1 : firm.lastReceiptCountSeller ? __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int___default()(firm.lastReceiptCountSeller) + 1 : 1;
      var firmSettings = this.firmSettings.find(function (i) {
        return i['firm'] == _this11.currentPayment.firm;
      });
      if (firmSettings && firmSettings.receiptNumberFinReset) {
        var newCount = this.customerPayments.filter(function (item) {
          return item["brand"] === _this11.selectedBrand && item["date"] <= new Date().getTime() && item["date"] >= new Date(_this11.finYear.start).getTime();
        }).length;
        firmReceiptCount = newCount;
      }
      // let firmReceiptCount = Number.parseInt(this.customerPayments.filter(
      // item => (item["brand"] === this.selectedBrand &&
      //     (item["firm"] == this.currentPayment.firm) &&
      //     (item.date >= this.finYear.start) && (item.date <= this.finYear.end))
      // ).length || 1);
      this.currentPayment.receiptNumber = firmReceiptCount;
    },
    editPayment: function editPayment(payment) {
      this.currentPayment = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, payment);
      this.currentPayment.date = new Date(this.currentPayment.date).toISOString().substr(0, 10);
      this.addDipositDialog = true;
    },
    deleteFromDialog: function deleteFromDialog() {
      this[this.currentPasswordMethod](this.currentPasswordReference);
    },
    deletePayment: function deletePayment(payment) {
      var firmSettings = this.firmSettings.find(function (i) {
        return i['firm'] == payment.firm;
      });
      var hasPassword = firmSettings && firmSettings.deleteWithPassword && !!firmSettings.deleteInvoicePassword;
      if (!payment.multiFirm && hasPassword && this.password != firmSettings.deleteInvoicePassword && this.passwordDialog) {
        alert("Incorrect Password");
        this.passwordDialog = false;
        this.password = null;
      } else if (!payment.multiFirm && hasPassword && !this.passwordDialog) {
        this.passwordDialog = true;
        this.password = null;
        this.currentPasswordReference = payment;
        this.currentPasswordMethod = "deletePayment";
      } else if (window.confirm("Do you want to Delete ?")) {
        this.passwordDialog = false;
        this.password = null;
        this.currentPayment = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, payment);
        this.undoInvoicePayment(this.currentPayment, false);
        this.manageDeletes(this.currentPayment);
        this.$root.$firebaseRefs.customerPayments.child(payment[".key"]).remove();
        //this.addRemainingBalance();
      }
    },
    printPayment: function printPayment(item) {
      var _this12 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var termsAndConditions;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // console.log(item)
                termsAndConditions = _this12.getTermsAndConditions(item);

                if (item.multiFirm) {
                  _context.next = 4;
                  break;
                }

                _context.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_8__utils_PaymentReceipt__["a" /* paymentReceiptPDF */])({
                  firm: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, _this12.firms.filter(function (item1) {
                    return item1['.key'] == item.firm;
                  })[0]),
                  customer: _this12.currentUser,
                  terms: termsAndConditions[0],
                  payment: item
                }).then(function (doc) {
                  pdfMake.createPdf(doc).download(_this12.currentUser.name + "_Receipt");
                });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this12);
      }))();
    },
    getTermsAndConditions: function getTermsAndConditions(invoiceData) {
      var _this13 = this;

      var termsAndConditions = this.termsAndConditions.filter(function (item) {
        return item["brand"] === _this13.selectedBrand && item["firm"] === invoiceData.firm;
      });
      if (termsAndConditions.length) {
        if (termsAndConditions[0].bank) {
          var banks = [];
          termsAndConditions[0].bank.map(function (bankId) {
            var bank = _this13.bankById[bankId];
            bank.address = _this13.getAddress(bank);
            banks.push(bank);
          });
          termsAndConditions[0].banks = banks;
        } else {
          termsAndConditions[0].banks = [];
        }
      } else {
        termsAndConditions = [{
          termsAndConditions: "",
          banks: []
        }];
      }
      return termsAndConditions;
    },
    getAddress: function getAddress(item) {
      if (!item) {
        return "";
      }
      var address = (item.village ? item.village + " - " : "") + (item.block ? item.block + " - " : "") + (item.tehsil ? item.tehsil + " - " : "") + (item.district ? item.district + " - " : "") + (item.state ? item.state + " - " : "") + (item.country ? item.country + " - " : "");
      address = address.substring(0, address.length - 2);
      return address;
    }
  }
});

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Buyer")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      productsToPortfolio: [],
      items: [],
      selectAll: false,
      isEdit: false,
      portfolioDialog: false,
      isBuyer: true,
      selectedCustomer: null,
      invoicePortfolio: false,
      multiFirm: false,
      historyStep: 1,
      selectedPortfolio: null,
      selectedBuyer: null,
      selectedFirm: null,
      date: new Date().toISOString().substr(0, 10),
      datepickerPortfolio: false,
      statusFilter: "ALL",
      portfolioNumber: null,
      portfolioHistory: false,
      modalMode: null,
      floorName: null,
      tableName: null,
      datepicker1: {},
      isCallAdded: false,
      tableList: [],
      portfolioHeader: [{ text: "Action", value: "edit" }, { text: "View", value: "view" }, { text: "Serial Number", value: "portfolioNumber" }, { text: "Portfolio Date", value: "date", sortable: true }, { text: "Invoice Date", value: "date", sortable: true }, { text: "Customer Name", value: "name" }, { text: "Status", value: "edit" }]
    };
  },
  created: function created() {
    this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("buyers", this.$root.$firebaseRefs.buyer.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("sellers", this.$root.$firebaseRefs.seller.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("portfolios", this.$root.$firebaseRefs.portfolio.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsObject("buyerById", this.$root.$firebaseRefs.buyer.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsObject("sellerById", this.$root.$firebaseRefs.seller.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsObject("productById", this.$root.$firebaseRefs.products.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("termsAndConditions", this.$root.$firebaseRefs.termsAndConditions.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsObject("bankById", this.$root.$firebaseRefs.account.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("firmInfrastructure", this.$root.$firebaseRefs.firmInfrastructure.orderByChild("brand").equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear"]), mapGlobalGetters({ units: "productUnit" }), {
    productListByBrand: function productListByBrand() {
      var _this = this;

      var prod = this.products.filter(function (item) {
        return item["brand"] === _this.selectedBrand && (!_this.multiFirm ? _this.selectedFirm ? item["firm"] === _this.selectedFirm : false : true);
      });
      prod.map(function (p, index) {
        var productsWithSimilarCompostion = _this.products.filter(function (item) {
          return item[".key"] == p[".key"] || item["brand"] === _this.selectedBrand && (!!item["composition"] ? _.isEqual(item["composition"], p["composition"]) : false);
        });
        prod[index]["similar"] = productsWithSimilarCompostion;
      });
      return prod;
    },
    portfoliosByBrand: function portfoliosByBrand() {
      var _this2 = this;

      return this.portfolios.filter(function (item) {
        return item["brand"] === _this2.selectedBrand && (_this2.selectedCustomer ? item.buyerId == _this2.selectedCustomer : true) && (_this2.statusFilter != "ALL" ? item.status == _this2.statusFilter : true) && item.isPortfolio;
      });
    },
    getPortfolioCustomers: function getPortfolioCustomers() {
      return this.buyersByBrand.map(function (b) {
        return {
          text: b.name,
          value: b[".key"]
        };
      });
    },
    buyersByBrand: function buyersByBrand() {
      var _this3 = this;

      return this.buyers.filter(function (item) {
        return item["brand"] === _this3.selectedBrand;
      });
    },
    sellersByBrand: function sellersByBrand() {
      var _this4 = this;

      return this.sellers.filter(function (item) {
        return item["brand"] === _this4.selectedBrand;
      });
    },
    firmsByBrand: function firmsByBrand() {
      var _this5 = this;

      return this.firms.filter(function (item) {
        return item["brand"] === _this5.selectedBrand;
      }).map(function (item) {
        if (item.defaultFirm) {
          _this5.selectedFirm = item[".key"];
        }
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
    },
    isRestaurantBusiness: function isRestaurantBusiness() {
      var _this6 = this;

      if (this.selectedFirm) {
        var firm = this.firms.find(function (item) {
          return item[".key"] == _this6.selectedFirm;
        });
        if (firm.businessType == "Restaurant") {
          return true;
        }
      }
      return false;
    },
    isJewlBusiness: function isJewlBusiness() {
      var _this7 = this;

      if (this.selectedFirm) {
        var firm = this.firms.find(function (item) {
          return item[".key"] == _this7.selectedFirm;
        });
        if (firm.businessType == "Jwellery") {
          return true;
        }
      }
      return false;
    },
    floorList: function floorList() {
      var _this8 = this;

      if (this.selectedFirm) {
        var firmInfrastructure = this.firmInfrastructure.find(function (item) {
          return item["firm"] == _this8.selectedFirm;
        });
        return firmInfrastructure.floorDetails;
      }
      return [];
    },
    productInvoiceHeader: function productInvoiceHeader() {
      var productInvoiceHeader = null;
      if (this.isJewlBusiness) {
        productInvoiceHeader = [{ text: "Name", value: "Name" }, { text: "Quantity", value: "Taxable" }, { text: "Purity", value: "Taxable" }, { text: "Gross Weight", value: "Taxable" }, { text: "Date", value: "Taxable" },
        //   { text: "Unit", value: "HSN" },
        { text: "Rate", value: "rate" }, { text: "Fetch Latest Rate", value: "total" }];
      } else {
        productInvoiceHeader = [{ text: "Name", value: "Name" }, { text: "Quantity", value: "Taxable" }, { text: "Date", value: "Taxable" },
        //   { text: "Unit", value: "HSN" },
        { text: "Rate", value: "rate" }, { text: "Fetch Latest Rate", value: "total" }];
      }
      return productInvoiceHeader;
    },
    productHeaderCreateInvoice: function productHeaderCreateInvoice() {
      var productInvoiceHeader = null;
      if (this.isJewlBusiness) {
        productInvoiceHeader = [{ text: "Select", value: "Name" }, { text: "Name", value: "Name" }, { text: "Quantity", value: "Taxable" }, { text: "Purity", value: "Taxable" }, { text: "Gross Weight", value: "Taxable" }, { text: "Date", value: "Taxable" },
        //   { text: "Unit", value: "HSN" },
        { text: "Rate", value: "rate" }, { text: "Fetch Latest Rate", value: "total" }];
      } else {
        productInvoiceHeader = [{ text: "Select", value: "Name" }, { text: "Name", value: "Name" }, { text: "Quantity", value: "Taxable" }, { text: "Date", value: "Taxable" },
        //   { text: "Unit", value: "HSN" },
        { text: "Rate", value: "rate" }, { text: "Fetch Latest Rate", value: "total" }];
      }
      return productInvoiceHeader;
    }
  }),
  watch: {
    floorName: {
      handler: function handler(newVal, oldVal) {
        this.getTableList();
      },

      deep: true
    },
    date: {
      handler: function handler(newVal, oldVal) {
        this.items[0].date = new Date(newVal).toISOString().substr(0, 10);
      },

      deep: true
    },
    selectAll: {
      handler: function handler(newVal, oldVal) {
        var _this9 = this;

        this.selectedPortfolio.items.map(function (i, index) {
          _this9.selectedPortfolio.items[index]['selected'] = _this9.selectAll;
        });
      },

      deep: true
    }
  },
  methods: {
    fetchLatestRate: function fetchLatestRate(item) {
      var prod = this.products.find(function (item1) {
        return item1[".key"] == item.productId;
      });
      item.rate = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(prod && prod.sellingPrice || 0);
    },
    getTermsAndConditions: function getTermsAndConditions(invoiceData) {
      var _this10 = this;

      var termsAndConditions = this.termsAndConditions.filter(function (item) {
        return item["brand"] === _this10.selectedBrand && item["firm"] === invoiceData.firm;
      });
      if (termsAndConditions.length) {
        if (termsAndConditions[0].bank) {
          var banks = [];
          termsAndConditions[0].bank.map(function (bankId) {
            var bank = _this10.bankById[bankId];
            bank.address = _this10.getAddress(bank);
            banks.push(bank);
          });
          termsAndConditions[0].banks = banks;
        } else {
          termsAndConditions[0].banks = [];
        }
      } else {
        termsAndConditions = [{
          termsAndConditions: "",
          banks: []
        }];
      }
      return termsAndConditions;
    },
    getAddress: function getAddress(item) {
      if (!item) {
        return "";
      }
      var address = (item.village ? item.village + " - " : "") + (item.block ? item.block + " - " : "") + (item.tehsil ? item.tehsil + " - " : "") + (item.district ? item.district + " - " : "") + (item.state ? item.state + " - " : "") + (item.country ? item.country + " - " : "");
      address = address.substring(0, address.length - 2);
      return address;
    },
    calculateGSTInvoice: function calculateGSTInvoice(currentUser, invoice, firm) {
      var _this11 = this;

      var SGST_val = 0;
      var CGST_val = 0;
      var IGST_val = 0;
      invoice.items && invoice.items.map(function (item, index) {
        var prod = _this11.products.filter(function (p) {
          return p[".key"] === item["productId"];
        })[0];
        item["taxableGST_rate"] = prod["taxableGST_rate"];
        item.HSN_code = prod["HSN_code"];
        item.basicPrice = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.rate * item.quantity).toFixed(2);
        item.GSTValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.basicPrice * (parseFloat(item.taxableGST_rate) / 100)).toFixed(2);
        item.totlePrice = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.GSTValue)).toFixed(2);
        var GST = item["taxableGST_rate"];
        if (!currentUser.state || firm && currentUser.state && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(GST) && firm.state === currentUser.state) {
          item["CGST_val"] = item["GSTValue"] / 2;
          item["CGST"] = GST / 2;
          item["SGST_val"] = item["GSTValue"] / 2;
          item["SGST"] = GST / 2;
          item["IGST"] = 0;
          item["IGST_val"] = 0;
        } else {
          item["IGST"] = GST;
          item["CGST"] = 0;
          item["SGST"] = 0;
          item["IGST_val"] = item["GSTValue"];
          item["CGST_val"] = 0;
          item["SGST_val"] = 0;
        }
        SGST_val += parseFloat(item["SGST_val"]);
        CGST_val += parseFloat(item["CGST_val"]);
        IGST_val += parseFloat(item["IGST_val"]);
      });
      return { SGST_val: SGST_val, CGST_val: CGST_val, IGST_val: IGST_val };
    },
    addPortfolioDialog: function addPortfolioDialog() {
      this.portfolioDialog = true;
      this.productsToPortfolio = [];
      this.items = [{
        productName: null,
        productId: null,
        quantity: 1,
        unit: null,
        rate: 0,
        grossWeight: 0,
        purity: 100,
        isReturn: false,
        date: new Date().toISOString().substr(0, 10)
      }];
      this.isEdit = false;
      this.invoicePortfolio = false;
      this.selectedBuyer = null;
      // this.selectedFirm = null;
      this.portfolioNumber = null;
      this.selectedPortfolio = null;
    },
    combinePortfolio: function combinePortfolio() {
      var _this12 = this;

      if (confirm("Are you sure you want to combine selected Items?")) {
        var groupId = 1;
        var selectStatus = false;
        this.items.map(function (it, index) {
          if (!it.isReturn) {
            groupId++;
            selectStatus = it.selected;
          }
          _this12.items[index]["groupId"] = groupId;
          _this12.items[index]["selected"] = selectStatus;
        });
        var combinedItems = this.items.filter(function (i1) {
          return !i1.isReturn && i1.selected;
        });
        var unselectedItems = this.items.filter(function (i1) {
          return !i1.selected;
        });

        this.items.filter(function (i2) {
          return i2.isReturn;
        }).map(function (item) {
          var index = _.findIndex(combinedItems, function (ci) {
            return ci.productId == item.productId && ci.groupId == item.groupId && item.selected;
          });
          if (index > -1) {
            combinedItems[index].grossWeight += item.isReturn ? -item.grossWeight : item.grossWeight;
            // combinedItems[index].quantity += item.isReturn
            //   ? -item.quantity
            //   : item.quantity;
          }
        });
        var history = {
          date: this.selectedPortfolio.date,
          items: this.items
        };
        if (this.selectedPortfolio.portfolioHistory) {
          this.selectedPortfolio.portfolioHistory.push(history);
        } else {
          this.selectedPortfolio.portfolioHistory = [history];
        }
        this.items = combinedItems.concat(unselectedItems);
        this.items.map(function (it, index) {
          delete _this12.items[index].groupId;
          delete _this12.items[index].selected;
        });
      }
    },
    openHistory: function openHistory(item) {
      this.selectedPortfolio = item;
      this.portfolioHistory = true;
      this.historyStep = 1;
      this.modalMode = "history";
    },
    openOrignal: function openOrignal(item) {
      this.selectedPortfolio = item;
      this.portfolioHistory = true;
      this.historyStep = 1;
      this.modalMode = "orignal";
    },
    openProd: function openProd(item) {
      this.selectedPortfolio = item;
      this.invoicePortfolio = true;
    },
    getTotal: function getTotal(item) {
      var total = 0;
      item.items.map(function (i) {
        total += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(i.rate) * __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(i.quantity));
      });
      return total;
    },
    getFirmName: function getFirmName(e) {
      var firm = void 0;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter(function (item) {
          return item[".key"] === e;
        })[0];
      }
      if (firm) return firm.name;
    },
    getCustomerName: function getCustomerName(id) {
      var buyer = this.buyerById[id];
      var seller = this.sellerById[id];
      if (!buyer && !seller) {
        return "DELETED CUSTOMER";
      }
      return buyer ? buyer.name : seller.name;
    },
    isShopUserExists: function isShopUserExists(id) {
      var buyers = this.buyers.filter(function (item) {
        return item.shopUserId == id;
      });
      if (!buyers.length) {
        return false;
      }
      return true;
    },
    getShopUserName: function getShopUserName(id) {
      var buyers = this.buyers.filter(function (item) {
        return item.shopUserId == id;
      });
      if (!buyers.length) {
        return "DELETED CUSTOMER";
      }
      return buyers[0].name;
    },

    // addToBucket() {
    //   let tempIts = this.items;
    //   this.items = [];
    //   this.productsToPortfolio.map((prod, index) => {
    //     if (typeof prod == "string") {
    //       this.productsToPortfolio.splice(index, 1);
    //     }
    //   });
    //   this.productsToPortfolio.map((prod, index) => {
    //     let selectedProd = tempIts.filter(
    //       (item) => item["productId"] == prod[".key"]
    //     )[0];
    //     let itemToAdd = {
    //       productName: prod.name,
    //       similar: prod.similar,
    //       productId: prod[".key"],
    //       quantity:
    //         selectedProd && selectedProd.quantity ? selectedProd.quantity : 1,
    //       unit:
    //         selectedProd && selectedProd.unit ? selectedProd.unit : prod.unit,
    //       rate:
    //         selectedProd && selectedProd.rate
    //           ? selectedProd.rate
    //           : this.isBuyer
    //           ? prod["sellingPrice"] || 0
    //           : prod["purchasingPrice"] || 0,
    //       grossWeight: 0,
    //       purity: 100,
    //       isReturn: false,
    //       date: new Date().toISOString().substr(0, 10),
    //     };
    //     if (this.multiFirm) {
    //       itemToAdd["firm"] = prod.firm;
    //     }
    //     this.items.push(itemToAdd);
    //   });
    // },
    restructureProductList: function restructureProductList(indexMain) {
      var _this13 = this;

      var buyer = this.selectedBuyer;
      this.items.map(function (item, index) {
        if (indexMain ? index == indexMain : true) {
          var prod = _this13.products.filter(function (item1) {
            return item1["name"] == item.productName && item1["brand"] === _this13.selectedBrand;
          })[0];
          _this13.items[index]["productName"] = prod.name;
          _this13.items[index]["productId"] = prod[".key"];
          _this13.items[index]["quantity"] = 1;
          _this13.items[index]["unit"] = prod.unit;
          _this13.items[index]["rate"] = _this13.isBuyer ? prod["sellingPrice"] || 0 : prod["purchasingPrice"] || 0;
          if (_this13.multiFirm) {
            _this13.items[index]["firm"] = prod.firm;
          }
          if (buyer && buyer.category && prod.sellingPriceByCategories && prod.sellingPriceByCategories[buyer.category]) {
            _this13.items[index]['rate'] = prod.sellingPriceByCategories[buyer.category];
          }
          if (_this13.isRestaurantBusiness) {
            var call = 0;
            if (_this13.items.length > 1) {
              call = Math.max.apply(Math, _this13.items.map(function (o) {
                return o.call || 0;
              }));
            }
            if (!_this13.isCallAdded) {
              call++;
              _this13.isCallAdded = !_this13.isCallAdded;
            }
            _this13.items[index]["call"] = call;
          }
        }
      });
    },
    getTableList: function getTableList() {
      var _this14 = this;

      this.tableList = this.floorList.find(function (item) {
        return item.name == _this14.floorName;
      }).tables;
    },
    addProd: function addProd(product, index) {
      var itemToAdd = null;
      if (product) {
        itemToAdd = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, product);
        itemToAdd.isReturn = true;
        itemToAdd.date = new Date().toISOString().substr(0, 10);
        this.items.splice(index + 1, 0, itemToAdd);
      } else {
        itemToAdd = {
          productName: null,
          productId: null,
          quantity: 1,
          unit: null,
          rate: 0,
          grossWeight: 0,
          purity: 100,
          isReturn: false,
          date: new Date(this.date).toISOString().substr(0, 10)
        };
        this.items.push(itemToAdd);
      }
    },
    removeProd: function removeProd(index) {
      this.items.splice(index, 1);
    },
    getCurrentFirmState: function getCurrentFirmState() {
      var _this15 = this;

      var firm = this.firms.filter(function (item) {
        return item[".key"] == _this15.selectedFirm;
      })[0];
      return firm["state"];
    },

    addCustomer: function addCustomer(e) {
      var obj = {
        name: e.target.value,
        brand: this.selectedBrand,
        state: this.getCurrentFirmState()
      };
      if (this.isBuyer) {
        this.$root.$firebaseRefs.buyer.push(obj);
      } else {
        this.$root.$firebaseRefs.seller.push(obj);
      }
    },
    addShopUser: function addShopUser(portfolio) {
      if (confirm("Are you sure you want to create buyer?")) {
        var obj = {
          name: portfolio.shopPortfolioUserName,
          shopUserId: portfolio.shopPortfolioUserId,
          brand: this.selectedBrand,
          state: this.getCurrentFirmState()
        };
        this.$root.$firebaseRefs.buyer.push(obj);
      }
    },
    createInvoice: function createInvoice() {
      var _this16 = this;

      var key = this.selectedPortfolio[".key"];
      delete this.selectedPortfolio[".key"];

      if (!this.selectedPortfolio.buyerId && this.selectedPortfolio.shopPortfolioUserId) {
        var buyer = this.buyers.filter(function (item) {
          return item.shopUserId == _this16.selectedPortfolio.shopPortfolioUserId;
        })[0];
        if (buyer) {
          this.selectedPortfolio["buyerId"] = buyer[".key"];
        } else {
          return;
        }
      }

      this.$root.$firebaseRefs.portfolio.child(key).set(this.selectedPortfolio).then(function (snap) {
        _this16.selectedPortfolio = null;
        _this16.$router.push({ path: "/portfolio-to-invoice/" + key });
        _this16.invoicePortfolio = false;
      });
    },
    cancelPortfolio: function cancelPortfolio(portfolio) {
      var key = portfolio[".key"];
      delete portfolio[".key"];
      portfolio["status"] = "CANCELLED";
      this.$root.$firebaseRefs.portfolio.child(key).set(portfolio).then(function (snap) {});
    },
    editPortfolio: function editPortfolio(portfolio) {
      var _this17 = this;

      if (portfolio.multiFirm) {
        this.multiFirm = true;
      }
      this.productsToPortfolio = [];
      this.portfolioDialog = true;
      this.isEdit = true;
      this.items = portfolio.items;
      this.items.map(function (i, index) {
        _this17.items[index]["date"] = new Date(i.date).toISOString().substr(0, 10);
      });
      this.selectedFirm = portfolio.firm;
      this.date = new Date(portfolio.date).toISOString().substr(0, 10), this.portfolioNumber = portfolio.portfolioNumber, this.selectedPortfolio = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, portfolio);
      this.isBuyer = portfolio.isBuyer;
      if (portfolio.isBuyer) {
        this.selectedBuyer = this.buyerById[portfolio.buyerId];
      } else {
        this.selectedBuyer = this.sellerById[portfolio.buyerId];
      }
      if (this.isRestaurantBusiness) {
        this["floorName"] = portfolio.floorName;
        this["tableName"] = portfolio.tableName;
      }
    },
    addPortfolio: function addPortfolio() {
      var _this18 = this;

      this.items.map(function (i, index) {
        if (!i.productName) {
          _this18.items.splice(index, 1);
        } else {
          _this18.items[index]["date"] = new Date(i.date).getTime();
        }
      });
      var portfolioObj = {
        buyerId: this.selectedBuyer[".key"],
        isBuyer: this.isBuyer,
        firm: this.selectedFirm,
        brand: this.selectedBrand,
        date: new Date(this.date).getTime(),
        portfolioNumber: this.portfolioNumber,
        items: this.items,
        isPortfolio: true
      };
      //   status: 'IN PROGRESS'
      // }
      // this.$root.$firebaseRefs.portfolio.push(portfolioObj);
      if (this.multiFirm) {
        portfolioObj["multiFirm"] = true;
      }
      if (this.isRestaurantBusiness) {
        portfolioObj["floorName"] = this.floorName;
        portfolioObj["tableName"] = this.tableName;
      }
      var history = {
        date: new Date(this.date).getTime(),
        items: this.items
      };
      if (this.isEdit) {
        if (this.selectedPortfolio.portfolioHistory) {
          portfolioObj["portfolioHistory"] = this.selectedPortfolio.portfolioHistory;
          portfolioObj["portfolioHistory"].push(history);
        } else {
          portfolioObj["portfolioHistory"] = [history];
        }
        portfolioObj["status"] = this.selectedPortfolio["status"];
        portfolioObj["buyerId"] = this.selectedPortfolio["buyerId"];
        this.$root.$firebaseRefs.portfolio.child(this.selectedPortfolio[".key"]).set(portfolioObj).then(function (snap) {
          _this18.isEdit = false;
        });
      } else {
        portfolioObj["status"] = "IN PROGRESS";
        portfolioObj["portfolioHistory"] = [history];
        this.$root.$firebaseRefs.portfolio.push(portfolioObj);
      }
      this.isCallAdded = false;
      this.portfolioDialog = false;
      this.selectedBuyer = null;
      this.isBuyer = true;
      this.items = [];
      this.productsToPortfolio = [];
    },
    deletePortfolio: function deletePortfolio(portfolio) {
      if (window.confirm("Do you want to Delete ?")) {
        this.$root.$firebaseRefs.portfolio.child(portfolio[".key"]).remove();
      }
    }
  }
});

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_pdf_reports_receipt_register_report__ = __webpack_require__(1537);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      headers: [{ text: "Firm", value: "date", sortable: true }, { text: "Date", value: "date", sortable: true }, { text: "Customer Name", value: "expense", sortable: true }, { text: "Receipt Number", value: "receiptNumber", sortable: true }, { text: "Amount", value: "category", sortable: true }, { text: "Payment type", value: "totalAmount", sortable: false }],
      pagination: {
        rowsPerPage: 10 // -1 for All",
      },
      businessType: null,
      isStatementView: false,
      statmentData: [],
      normalData: [],
      dateFrom: null,
      dateTo: null,
      datepickerFrom: false,
      selectedFirm: null,
      selectedBranch: null,
      datepickerTo: false,
      dialog11: false,
      selectedInvoice: null
    };
  },
  created: function created() {
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsObject("sellers", this.$root.$firebaseRefs.seller.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsObject("buyers", this.$root.$firebaseRefs.buyer.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("customerPayments", this.$root.$firebaseRefs.customerPayments.orderByChild("brand").equalTo(this.selectedBrand));
    if (this.$route.params.month && this.$route.params.date) {
      var date = parseInt(this.$route.params.date);
      var dateF = 1;
      var dateT = 0;
      if (date > 0) {
        dateF = date;
        dateT = date;
      }
      var selectedMonth = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(this.$route.params.month);
      var dateFrom = new Date(this.finYear.start);
      var dateTo = new Date(this.finYear.end);
      var fullYear = dateFrom.getFullYear();
      if (selectedMonth < 3) {
        fullYear = dateTo.getFullYear();
      }
      this.dateFrom = this.formatDate(new Date(fullYear, selectedMonth, dateF).getTime());
      this.dateTo = this.formatDate(new Date(fullYear, dateT == 0 ? selectedMonth + 1 : selectedMonth, dateT).getTime());
    } else if (this.finYear) {
      this.dateFrom = this.formatDate(this.finYear.start);
      this.dateTo = this.formatDate(this.finYear.end);
    }
    this.invoicesByBrandNormal();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear"]), {
    firmsByBrand: function firmsByBrand() {
      var _this = this;

      return this.firms.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      }).map(function (item) {
        if (item.defaultFirm) {
          _this.selectedFirm = item[".key"];
        }
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
    }
  }),
  watch: {
    selectedFirm: {
      handler: function handler(newVal, oldVal) {
        this.invoicesByBrandNormal();
      },

      deep: true
    },
    selectedBranch: {
      handler: function handler(newVal, oldVal) {
        console.log(newVal);
        this.invoicesByBrandNormal();
      },

      deep: true
    },
    dateTo: {
      handler: function handler(newVal, oldVal) {
        this.invoicesByBrandNormal();
      }
    },
    dateFrom: {
      handler: function handler(newVal, oldVal) {
        this.invoicesByBrandNormal();
      }
    }
  },
  methods: {
    print: function print() {
      var doc = Object(__WEBPACK_IMPORTED_MODULE_3__utils_pdf_reports_receipt_register_report__["a" /* convertToPDFReport */])({
        invoiceData: this.normalData,
        firm: this.selectedFirm ? this.getFirmName(this.selectedFirm) : null,
        fromDate: this.dateFrom ? new Date(this.dateFrom).toLocaleDateString('en-GB') : null,
        toDate: this.dateTo ? new Date(this.dateTo).toLocaleDateString('en-GB') : null
      });
      pdfMake.createPdf(doc).download('Receipt Register_' + new Date(this.dateFrom).toLocaleDateString('en-GB') + 'to' + new Date(this.dateTo).toLocaleDateString('en-GB'));
    },
    invoicesByBrandNormal: function invoicesByBrandNormal() {
      var _this2 = this;

      var toDate = this.dateTo ? new Date(this.dateTo).setUTCHours(23, 59, 59, 999) : null;
      var fromDate = this.dateFrom ? new Date(this.dateFrom).setUTCHours(0, 0, 0, 0) : null;

      var invoiceHistory = this.customerPayments.filter(function (item) {
        return item["brand"] === _this2.selectedBrand && (_this2.selectedFirm ? item["firm"] === _this2.selectedFirm : true) && (_this2.isBuyer ? item.isBuyer == false : item.isBuyer == true) && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true);
      });
      invoiceHistory.map(function (item, index) {
        invoiceHistory[index]['firmName'] = _this2.getFirmName(item.firm);
        invoiceHistory[index]['buyerName'] = _this2.buyerById(item.buyerId)["name"];
      });
      this.normalData = invoiceHistory;
    },
    buyerById: function buyerById(id) {
      if (this.buyers[id]) {
        return this.buyers[id];
      } else if (this.sellers[id]) {
        return this.sellers[id];
      }
    },
    formatDate: function formatDate(date) {
      var d = new Date(date),
          month = "" + (d.getMonth() + 1),
          day = "" + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    getFirmName: function getFirmName(id) {
      var firm = this.firms.filter(function (item) {
        return item[".key"] == id;
      })[0];
      if (firm) {
        return firm["name"];
      }
    }
  }
});

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_pdf_reports_payment_register_report__ = __webpack_require__(1541);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      headers: [{ text: "Firm", value: "date", sortable: true }, { text: "Date", value: "date", sortable: true }, { text: "Customer Name", value: "expense", sortable: true }, { text: "Payment Number", value: "receiptNumber", sortable: true }, { text: "Amount", value: "category", sortable: true }, { text: "Payment type", value: "totalAmount", sortable: false }],
      pagination: {
        rowsPerPage: 10 // -1 for All",
      },
      businessType: null,
      isStatementView: false,
      statmentData: [],
      normalData: [],
      dateFrom: null,
      dateTo: null,
      datepickerFrom: false,
      selectedFirm: null,
      selectedBranch: null,
      datepickerTo: false,
      dialog11: false,
      selectedInvoice: null
    };
  },
  created: function created() {
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsObject("sellers", this.$root.$firebaseRefs.seller.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsObject("buyers", this.$root.$firebaseRefs.buyer.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("customerPayments", this.$root.$firebaseRefs.customerPayments.orderByChild("brand").equalTo(this.selectedBrand));
    if (this.$route.params.month && this.$route.params.date) {
      var date = parseInt(this.$route.params.date);
      var dateF = 1;
      var dateT = 0;
      if (date > 0) {
        dateF = date;
        dateT = date;
      }
      var selectedMonth = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(this.$route.params.month);
      var dateFrom = new Date(this.finYear.start);
      var dateTo = new Date(this.finYear.end);
      var fullYear = dateFrom.getFullYear();
      if (selectedMonth < 3) {
        fullYear = dateTo.getFullYear();
      }
      this.dateFrom = this.formatDate(new Date(fullYear, selectedMonth, dateF).getTime());
      this.dateTo = this.formatDate(new Date(fullYear, dateT == 0 ? selectedMonth + 1 : selectedMonth, dateT).getTime());
    } else if (this.finYear) {
      this.dateFrom = this.formatDate(this.finYear.start);
      this.dateTo = this.formatDate(this.finYear.end);
    }
    this.invoicesByBrandNormal();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear"]), {
    firmsByBrand: function firmsByBrand() {
      var _this = this;

      return this.firms.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      }).map(function (item) {
        if (item.defaultFirm) {
          _this.selectedFirm = item[".key"];
        }
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
    }
  }),
  watch: {
    selectedFirm: {
      handler: function handler(newVal, oldVal) {
        this.invoicesByBrandNormal();
      },

      deep: true
    },
    selectedBranch: {
      handler: function handler(newVal, oldVal) {
        console.log(newVal);
        this.invoicesByBrandNormal();
      },

      deep: true
    },
    dateTo: {
      handler: function handler(newVal, oldVal) {
        this.invoicesByBrandNormal();
      }
    },
    dateFrom: {
      handler: function handler(newVal, oldVal) {
        this.invoicesByBrandNormal();
      }
    }
  },
  methods: {
    print: function print() {
      var doc = Object(__WEBPACK_IMPORTED_MODULE_3__utils_pdf_reports_payment_register_report__["a" /* convertToPDFReport */])({
        invoiceData: this.normalData,
        firm: this.selectedFirm ? this.getFirmName(this.selectedFirm) : null,
        fromDate: this.dateFrom ? new Date(this.dateFrom).toLocaleDateString('en-GB') : null,
        toDate: this.dateTo ? new Date(this.dateTo).toLocaleDateString('en-GB') : null
      });
      pdfMake.createPdf(doc).download('Payment Register_' + new Date(this.dateFrom).toLocaleDateString('en-GB') + 'to' + new Date(this.dateTo).toLocaleDateString('en-GB'));
    },
    invoicesByBrandNormal: function invoicesByBrandNormal() {
      var _this2 = this;

      var toDate = this.dateTo ? new Date(this.dateTo).setUTCHours(23, 59, 59, 999) : null;
      var fromDate = this.dateFrom ? new Date(this.dateFrom).setUTCHours(0, 0, 0, 0) : null;

      var invoiceHistory = this.customerPayments.filter(function (item) {
        return item["brand"] === _this2.selectedBrand && (_this2.selectedFirm ? item["firm"] === _this2.selectedFirm : true) && (_this2.isBuyer ? item.isBuyer == true : item.isBuyer == false) && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true);
      });
      invoiceHistory.map(function (item, index) {
        invoiceHistory[index]['firmName'] = _this2.getFirmName(item.firm);
        invoiceHistory[index]['buyerName'] = _this2.buyerById(item.buyerId)["name"];
      });
      this.normalData = invoiceHistory;
    },
    buyerById: function buyerById(id) {
      if (this.buyers[id]) {
        return this.buyers[id];
      } else if (this.sellers[id]) {
        return this.sellers[id];
      }
    },
    formatDate: function formatDate(date) {
      var d = new Date(date),
          month = "" + (d.getMonth() + 1),
          day = "" + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    getFirmName: function getFirmName(id) {
      var firm = this.firms.filter(function (item) {
        return item[".key"] == id;
      })[0];
      if (firm) {
        return firm["name"];
      }
    }
  }
});

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_digitsToWords_js__ = __webpack_require__(35);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Buyer")["mapGetters"];

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      productsToReceiptCollection: [],
      items: [],
      selectAll: false,
      isEdit: false,
      receiptCollectionDialog: false,
      isBuyer: true,
      selectedCustomer: null,
      invoiceReceiptCollection: false,
      multiFirm: false,
      historyStep: 1,
      selectedReceiptCollection: null,
      selectedBuyer: null,
      selectedFirm: null,
      date: new Date().toISOString().substr(0, 10),
      datepickerReceiptCollection: false,
      statusFilter: "ALL",
      receiptCollectionNumber: null,
      soldBy: null,
      orderHistory: false,
      modalMode: null,
      floorName: null,
      tableName: null,
      datepicker1: {},
      isCallAdded: false,
      tableList: [],
      hintText: null,
      receiptCollectionHeader: [
      // { text: "Key", value: ".key" },  
      { text: "Action", value: "edit" }, { text: "View", value: "view" }, { text: "Receipt Collection Number", value: "receiptCollectionNumber" }, { text: "Receipt Collection Date", value: "date", sortable: true },
      // { text: "Invoice Date", value: "date", sortable: true },
      { text: "Staff Name", value: "name" }, { text: "Status", value: "edit" }]
    };
  },
  created: function created() {
    this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("buyers", this.$root.$firebaseRefs.buyer.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("sellers", this.$root.$firebaseRefs.seller.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("receiptCollections", this.$root.$firebaseRefs.receiptCollections.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsObject("buyerById", this.$root.$firebaseRefs.buyer.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsObject("sellerById", this.$root.$firebaseRefs.seller.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsObject("productById", this.$root.$firebaseRefs.products.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("termsAndConditions", this.$root.$firebaseRefs.termsAndConditions.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsObject("bankById", this.$root.$firebaseRefs.account.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("firmInfrastructure", this.$root.$firebaseRefs.firmInfrastructure.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("staffs", this.$root.$firebaseRefs.staff.orderByChild("brand").equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear"]), mapGlobalGetters({ units: "productUnit" }), {
    productListByBrand: function productListByBrand() {
      var _this = this;

      var prod = this.products.filter(function (item) {
        return item["brand"] === _this.selectedBrand && (!_this.multiFirm ? _this.selectedFirm ? item["firm"] === _this.selectedFirm : false : true);
      });
      prod.map(function (p, index) {
        var productsWithSimilarCompostion = _this.products.filter(function (item) {
          return item[".key"] == p[".key"] || item["brand"] === _this.selectedBrand && (!!item["composition"] ? _.isEqual(item["composition"], p["composition"]) : false);
        });
        prod[index]["similar"] = productsWithSimilarCompostion;
      });
      return prod;
    },
    receiptCollectionsByBrand: function receiptCollectionsByBrand() {
      var _this2 = this;

      return this.receiptCollections.filter(function (item) {
        return item["brand"] === _this2.selectedBrand && (_this2.selectedCustomer ? item.buyerId == _this2.selectedCustomer : true) && (_this2.statusFilter != "ALL" ? item.status == _this2.statusFilter : true) && item.isReceiptCollection;
      });
    },
    getReceiptCollectionCustomers: function getReceiptCollectionCustomers() {
      return this.staffByBrand.map(function (b) {
        return {
          text: b.name,
          value: b[".key"]
        };
      });
    },
    buyersByBrand: function buyersByBrand() {
      var _this3 = this;

      return this.buyers.filter(function (item) {
        return item["brand"] === _this3.selectedBrand;
      });
    },
    sellersByBrand: function sellersByBrand() {
      var _this4 = this;

      return this.sellers.filter(function (item) {
        return item["brand"] === _this4.selectedBrand;
      });
    },
    firmsByBrand: function firmsByBrand() {
      var _this5 = this;

      return this.firms.filter(function (item) {
        return item["brand"] === _this5.selectedBrand;
      }).map(function (item) {
        if (item.defaultFirm) {
          _this5.selectedFirm = item[".key"];
        }
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
    },
    staffByBrand: function staffByBrand() {
      var _this6 = this;

      return this.staffs.filter(function (item) {
        return item["brand"] === _this6.selectedBrand && (!_this6.multiFirm ? _this6.selectedFirm ? item["firm"] === _this6.selectedFirm : false : true) && item["staffRole"] === "Salesman";
      }).map(function (item) {
        return {
          text: item["staffName"],
          value: item[".key"]
        };
      });
    },
    isRestaurantBusiness: function isRestaurantBusiness() {
      var _this7 = this;

      if (this.selectedFirm) {
        var firm = this.firms.find(function (item) {
          return item[".key"] == _this7.selectedFirm;
        });
        if (firm.businessType == "Restaurant") {
          return true;
        }
      }
      return false;
    },
    isJewlBusiness: function isJewlBusiness() {
      var _this8 = this;

      if (this.selectedFirm) {
        var firm = this.firms.find(function (item) {
          return item[".key"] == _this8.selectedFirm;
        });
        if (firm.businessType == "Jwellery") {
          return true;
        }
      }
      return false;
    },
    floorList: function floorList() {
      var _this9 = this;

      if (this.selectedFirm) {
        var firmInfrastructure = this.firmInfrastructure.find(function (item) {
          return item["firm"] == _this9.selectedFirm;
        });
        return firmInfrastructure.floorDetails;
      }
      return [];
    },
    productInvoiceHeader: function productInvoiceHeader() {
      var productInvoiceHeader = null;
      if (this.isJewlBusiness) {
        productInvoiceHeader = [{ text: "Name", value: "Name" }, { text: "Quantity", value: "Taxable" }, { text: "Purity", value: "Taxable" }, { text: "Gross Weight", value: "Taxable" }, { text: "Date", value: "Taxable" },
        //   { text: "Unit", value: "HSN" },
        { text: "Rate", value: "rate" }, { text: "Fetch Latest Rate", value: "total" }];
      } else {
        productInvoiceHeader = [{ text: "Name", value: "Name" }, { text: "Quantity", value: "Taxable" }, { text: "Date", value: "Taxable" },
        //   { text: "Unit", value: "HSN" },
        { text: "Rate", value: "rate" }, { text: "Fetch Latest Rate", value: "total" }];
      }
      return productInvoiceHeader;
    },
    productHeaderCreateInvoice: function productHeaderCreateInvoice() {
      var productInvoiceHeader = null;
      if (this.isJewlBusiness) {
        productInvoiceHeader = [{ text: "Select", value: "Name" }, { text: "Name", value: "Name" }, { text: "Quantity", value: "Taxable" }, { text: "Purity", value: "Taxable" }, { text: "Gross Weight", value: "Taxable" }, { text: "Date", value: "Taxable" },
        //   { text: "Unit", value: "HSN" },
        { text: "Rate", value: "rate" }, { text: "Fetch Latest Rate", value: "total" }];
      } else {
        productInvoiceHeader = [{ text: "Select", value: "Name" }, { text: "Name", value: "Name" }, { text: "Quantity", value: "Taxable" }, { text: "Date", value: "Taxable" },
        //   { text: "Unit", value: "HSN" },
        { text: "Rate", value: "rate" }, { text: "Fetch Latest Rate", value: "total" }];
      }
      return productInvoiceHeader;
    }
  }),
  watch: {
    floorName: {
      handler: function handler(newVal, oldVal) {
        this.getTableList();
      },

      deep: true
    },
    date: {
      handler: function handler(newVal, oldVal) {
        this.items[0].date = new Date(newVal).toISOString().substr(0, 10);
      },

      deep: true
    },
    selectAll: {
      handler: function handler(newVal, oldVal) {
        var _this10 = this;

        this.selectedReceiptCollection.items.map(function (i, index) {
          _this10.selectedReceiptCollection.items[index]['selected'] = _this10.selectAll;
        });
      },

      deep: true
    },
    "item.amount": {
      handler: function handler() {
        this.hintText = this.item.amount ? _.startCase(Object(__WEBPACK_IMPORTED_MODULE_3__utils_digitsToWords_js__["a" /* digitsToWords */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.item.amount))) : null;
      },

      deep: true
    }
  },
  methods: {
    fetchLatestRate: function fetchLatestRate(item) {
      var prod = this.products.find(function (item1) {
        return item1[".key"] == item.productId;
      });
      item.rate = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(prod && prod.sellingPrice || 0);
    },
    getTermsAndConditions: function getTermsAndConditions(invoiceData) {
      var _this11 = this;

      var termsAndConditions = this.termsAndConditions.filter(function (item) {
        return item["brand"] === _this11.selectedBrand && item["firm"] === invoiceData.firm;
      });
      if (termsAndConditions.length) {
        if (termsAndConditions[0].bank) {
          var banks = [];
          termsAndConditions[0].bank.map(function (bankId) {
            var bank = _this11.bankById[bankId];
            bank.address = _this11.getAddress(bank);
            banks.push(bank);
          });
          termsAndConditions[0].banks = banks;
        } else {
          termsAndConditions[0].banks = [];
        }
      } else {
        termsAndConditions = [{
          termsAndConditions: "",
          banks: []
        }];
      }
      return termsAndConditions;
    },
    getAddress: function getAddress(item) {
      if (!item) {
        return "";
      }
      var address = (item.village ? item.village + " - " : "") + (item.block ? item.block + " - " : "") + (item.tehsil ? item.tehsil + " - " : "") + (item.district ? item.district + " - " : "") + (item.state ? item.state + " - " : "") + (item.country ? item.country + " - " : "");
      address = address.substring(0, address.length - 2);
      return address;
    },
    calculateGSTInvoice: function calculateGSTInvoice(currentUser, invoice, firm) {
      var _this12 = this;

      var SGST_val = 0;
      var CGST_val = 0;
      var IGST_val = 0;
      invoice.items && invoice.items.map(function (item, index) {
        var prod = _this12.products.filter(function (p) {
          return p[".key"] === item["productId"];
        })[0];
        item["taxableGST_rate"] = prod["taxableGST_rate"];
        item.HSN_code = prod["HSN_code"];
        item.basicPrice = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.rate * item.quantity).toFixed(2);
        item.GSTValue = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.basicPrice * (parseFloat(item.taxableGST_rate) / 100)).toFixed(2);
        item.totlePrice = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.GSTValue)).toFixed(2);
        var GST = item["taxableGST_rate"];
        if (!currentUser.state || firm && currentUser.state && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(GST) && firm.state === currentUser.state) {
          item["CGST_val"] = item["GSTValue"] / 2;
          item["CGST"] = GST / 2;
          item["SGST_val"] = item["GSTValue"] / 2;
          item["SGST"] = GST / 2;
          item["IGST"] = 0;
          item["IGST_val"] = 0;
        } else {
          item["IGST"] = GST;
          item["CGST"] = 0;
          item["SGST"] = 0;
          item["IGST_val"] = item["GSTValue"];
          item["CGST_val"] = 0;
          item["SGST_val"] = 0;
        }
        SGST_val += parseFloat(item["SGST_val"]);
        CGST_val += parseFloat(item["CGST_val"]);
        IGST_val += parseFloat(item["IGST_val"]);
      });
      return { SGST_val: SGST_val, CGST_val: CGST_val, IGST_val: IGST_val };
    },
    addReceiptCollectionDialog: function addReceiptCollectionDialog() {
      this.receiptCollectionDialog = true;
      this.productsToReceiptCollection = [];
      this.items = [{
        productName: null,
        productId: null,
        quantity: 1,
        unit: null,
        rate: 0,
        grossWeight: 0,
        purity: 100,
        isReturn: false,
        date: new Date().toISOString().substr(0, 10)
      }];
      this.isEdit = false;
      this.invoiceReceiptCollection = false;
      this.selectedBuyer = null;
      // this.selectedFirm = null;
      this.receiptCollectionNumber = null;
      this.selectedReceiptCollection = null;
    },
    combineReceiptCollection: function combineReceiptCollection() {
      var _this13 = this;

      if (confirm("Are you sure you want to combine selected Items?")) {
        var groupId = 1;
        var selectStatus = false;
        this.items.map(function (it, index) {
          if (!it.isReturn) {
            groupId++;
            selectStatus = it.selected;
          }
          _this13.items[index]["groupId"] = groupId;
          _this13.items[index]["selected"] = selectStatus;
        });
        var combinedItems = this.items.filter(function (i1) {
          return !i1.isReturn && i1.selected;
        });
        var unselectedItems = this.items.filter(function (i1) {
          return !i1.selected;
        });

        this.items.filter(function (i2) {
          return i2.isReturn;
        }).map(function (item) {
          var index = _.findIndex(combinedItems, function (ci) {
            return ci.productId == item.productId && ci.groupId == item.groupId && item.selected;
          });
          if (index > -1) {
            combinedItems[index].grossWeight += item.isReturn ? -item.grossWeight : item.grossWeight;
            // combinedItems[index].quantity += item.isReturn
            //   ? -item.quantity
            //   : item.quantity;
          }
        });
        var history = {
          date: this.selectedReceiptCollection.date,
          items: this.items
        };
        if (this.selectedReceiptCollection.orderHistory) {
          this.selectedReceiptCollection.orderHistory.push(history);
        } else {
          this.selectedReceiptCollection.orderHistory = [history];
        }
        this.items = combinedItems.concat(unselectedItems);
        this.items.map(function (it, index) {
          delete _this13.items[index].groupId;
          delete _this13.items[index].selected;
        });
      }
    },
    openHistory: function openHistory(item) {
      this.selectedReceiptCollection = item;
      this.orderHistory = true;
      this.historyStep = 1;
      this.modalMode = "history";
    },
    openOrignal: function openOrignal(item) {
      this.selectedReceiptCollection = item;
      this.orderHistory = true;
      this.historyStep = 1;
      this.modalMode = "orignal";
    },
    openProd: function openProd(item) {
      this.selectedReceiptCollection = item;
      this.invoiceReceiptCollection = true;
    },
    getTotal: function getTotal(item) {
      var total = 0;
      item.items.map(function (i) {
        total += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(i.rate) * __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(i.quantity));
      });
      return total;
    },
    getFirmName: function getFirmName(e) {
      var firm = void 0;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter(function (item) {
          return item[".key"] === e;
        })[0];
      }
      if (firm) return firm.name;
    },
    getCustomerName: function getCustomerName(id) {
      var buyer = this.buyerById[id];
      var seller = this.sellerById[id];
      if (!buyer && !seller) {
        return "DELETED CUSTOMER";
      }
      return buyer ? buyer.name : seller.name;
    },
    isShopUserExists: function isShopUserExists(id) {
      var buyers = this.buyers.filter(function (item) {
        return item.shopUserId == id;
      });
      if (!buyers.length) {
        return false;
      }
      return true;
    },
    getShopUserName: function getShopUserName(id) {
      var buyers = this.buyers.filter(function (item) {
        return item.shopUserId == id;
      });
      if (!buyers.length) {
        return "DELETED CUSTOMER";
      }
      return buyers[0].name;
    },
    addToBucket: function addToBucket() {
      var _this14 = this;

      var tempIts = this.items;
      this.items = [];
      this.productsToReceiptCollection.map(function (prod, index) {
        if (typeof prod == "string") {
          _this14.productsToReceiptCollection.splice(index, 1);
        }
      });
      this.productsToReceiptCollection.map(function (prod, index) {
        var selectedProd = tempIts.filter(function (item) {
          return item["productId"] == prod[".key"];
        })[0];
        var itemToAdd = {
          productName: prod.name,
          similar: prod.similar,
          productId: prod[".key"],
          quantity: selectedProd && selectedProd.quantity ? selectedProd.quantity : 1,
          unit: selectedProd && selectedProd.unit ? selectedProd.unit : prod.unit,
          rate: selectedProd && selectedProd.rate ? selectedProd.rate : _this14.isBuyer ? prod["sellingPrice"] || 0 : prod["purchasingPrice"] || 0,
          grossWeight: 0,
          purity: 100,
          isReturn: false,
          date: new Date().toISOString().substr(0, 10)
        };
        if (_this14.multiFirm) {
          itemToAdd["firm"] = prod.firm;
        }
        _this14.items.push(itemToAdd);
      });
    },
    restructureProductList: function restructureProductList(indexMain) {
      var _this15 = this;

      this.items.map(function (item, index) {
        if (indexMain ? index == indexMain : true) {
          var prod = _this15.products.filter(function (item1) {
            return item1["name"] == item.productName && item1["brand"] === _this15.selectedBrand;
          })[0];
          _this15.items[index]["productName"] = prod.name;
          _this15.items[index]["productId"] = prod[".key"];
          _this15.items[index]["quantity"] = 1;
          _this15.items[index]["unit"] = prod.unit;
          _this15.items[index]["rate"] = _this15.isBuyer ? prod["sellingPrice"] || 0 : prod["purchasingPrice"] || 0;
          if (_this15.multiFirm) {
            _this15.items[index]["firm"] = prod.firm;
          }
          if (_this15.isRestaurantBusiness) {
            var call = 0;
            if (_this15.items.length > 1) {
              call = Math.max.apply(Math, _this15.items.map(function (o) {
                return o.call || 0;
              }));
            }
            if (!_this15.isCallAdded) {
              call++;
              _this15.isCallAdded = !_this15.isCallAdded;
            }
            _this15.items[index]["call"] = call;
          }
        }
      });
    },
    getTableList: function getTableList() {
      var _this16 = this;

      this.tableList = this.floorList.find(function (item) {
        return item.name == _this16.floorName;
      }).tables;
    },
    addProd: function addProd(product, index) {
      var itemToAdd = null;
      if (product) {
        itemToAdd = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, product);
        itemToAdd.isReturn = true;
        itemToAdd.date = new Date().toISOString().substr(0, 10);
        this.items.splice(index + 1, 0, itemToAdd);
      } else {
        itemToAdd = {
          productName: null,
          productId: null,
          quantity: 1,
          unit: null,
          rate: 0,
          grossWeight: 0,
          purity: 100,
          isReturn: false,
          date: new Date(this.date).toISOString().substr(0, 10)
        };
        this.items.push(itemToAdd);
      }
    },
    removeProd: function removeProd(index) {
      this.items.splice(index, 1);
    },
    getCurrentFirmState: function getCurrentFirmState() {
      var _this17 = this;

      var firm = this.firms.filter(function (item) {
        return item[".key"] == _this17.selectedFirm;
      })[0];
      return firm["state"];
    },

    addCustomer: function addCustomer(e) {
      var obj = {
        name: e.target.value,
        brand: this.selectedBrand,
        state: this.getCurrentFirmState()
      };
      if (this.isBuyer) {
        this.$root.$firebaseRefs.buyer.push(obj);
      } else {
        this.$root.$firebaseRefs.seller.push(obj);
      }
    },
    addShopUser: function addShopUser(receiptCollection) {
      if (confirm("Are you sure you want to create buyer?")) {
        var obj = {
          name: receiptCollection.shopReceiptCollectionUserName,
          shopUserId: receiptCollection.shopReceiptCollectionUserId,
          brand: this.selectedBrand,
          state: this.getCurrentFirmState()
        };
        this.$root.$firebaseRefs.buyer.push(obj);
      }
    },
    createInvoice: function createInvoice() {
      var _this18 = this;

      var key = this.selectedReceiptCollection[".key"];
      delete this.selectedReceiptCollection[".key"];

      if (!this.selectedReceiptCollection.buyerId && this.selectedReceiptCollection.shopReceiptCollectionUserId) {
        var buyer = this.buyers.filter(function (item) {
          return item.shopUserId == _this18.selectedReceiptCollection.shopReceiptCollectionUserId;
        })[0];
        if (buyer) {
          this.selectedReceiptCollection["buyerId"] = buyer[".key"];
        } else {
          return;
        }
      }

      this.$root.$firebaseRefs.receiptCollections.child(key).set(this.selectedReceiptCollection).then(function (snap) {
        _this18.selectedReceiptCollection = null;
        _this18.$router.push({ path: "/ReceiptCollection-to-invoice/" + key });
        _this18.invoiceReceiptCollection = false;
      });
    },
    cancelReceiptCollection: function cancelReceiptCollection(receiptCollection) {
      var key = receiptCollection[".key"];
      delete receiptCollection[".key"];
      receiptCollection["status"] = "CANCELLED";
      this.$root.$firebaseRefs.receiptCollections.child(key).set(receiptCollection).then(function (snap) {});
    },
    editReceiptCollection: function editReceiptCollection(receiptCollection) {
      var _this19 = this;

      if (receiptCollection.multiFirm) {
        this.multiFirm = true;
      }

      this.soldBy = receiptCollection.soldBy;
      this.productsToReceiptCollection = [];
      this.receiptCollectionDialog = true;
      this.isEdit = true;
      this.items = receiptCollection.items;
      this.items.map(function (i, index) {
        _this19.items[index]["date"] = new Date(i.date).toISOString().substr(0, 10);
      });
      this.selectedFirm = receiptCollection.firm;
      this.date = new Date(receiptCollection.date).toISOString().substr(0, 10), this.receiptCollectionNumber = receiptCollection.receiptCollectionNumber, this.selectedReceiptCollection = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, receiptCollection);
      this.isBuyer = receiptCollection.isBuyer;
      if (receiptCollection.isBuyer) {
        this.selectedBuyer = this.buyerById[receiptCollection.buyerId];
      } else {
        this.selectedBuyer = this.sellerById[receiptCollection.buyerId];
      }
      if (this.isRestaurantBusiness) {
        this["floorName"] = receiptCollection.floorName;
        this["tableName"] = receiptCollection.tableName;
      }
    },
    addReceiptCollection: function addReceiptCollection() {
      var _this20 = this;

      this.items.map(function (i, index) {
        if (!i.productName) {
          _this20.items.splice(index, 1);
        } else {
          _this20.items[index]["date"] = new Date(i.date).getTime();
        }
      });
      var receiptCollectionObj = {
        buyerId: this.selectedBuyer[".key"],
        isBuyer: this.isBuyer,
        firm: this.selectedFirm,
        brand: this.selectedBrand,
        date: new Date(this.date).getTime(),
        receiptCollectionNumber: this.receiptCollectionNumber,
        items: this.items,
        isReceiptCollection: true,
        soldBy: this.soldBy
      };
      //   status: 'PENDING'
      // }
      // this.$root.$firebaseRefs.receiptCollections.push(receiptCollectionObj);
      if (this.multiFirm) {
        receiptCollectionObj["multiFirm"] = true;
      }
      if (this.isRestaurantBusiness) {
        receiptCollectionObj["floorName"] = this.floorName;
        receiptCollectionObj["tableName"] = this.tableName;
      }
      var history = {
        date: new Date(this.date).getTime(),
        items: this.items
      };
      if (this.isEdit) {
        if (this.selectedReceiptCollection.orderHistory) {
          receiptCollectionObj["orderHistory"] = this.selectedReceiptCollection.orderHistory;
          receiptCollectionObj["orderHistory"].push(history);
        } else {
          receiptCollectionObj["orderHistory"] = [history];
        }
        receiptCollectionObj["status"] = this.selectedReceiptCollection["status"];
        receiptCollectionObj["buyerId"] = this.selectedReceiptCollection["buyerId"];
        this.$root.$firebaseRefs.receiptCollections.child(this.selectedReceiptCollection[".key"]).set(receiptCollectionObj).then(function (snap) {
          _this20.isEdit = false;
        });
      } else {
        receiptCollectionObj["status"] = "PENDING";
        receiptCollectionObj["orderHistory"] = [history];
        this.$root.$firebaseRefs.receiptCollections.push(receiptCollectionObj);
      }
      this.isCallAdded = false;
      this.receiptCollectionDialog = false;
      this.selectedBuyer = null;
      this.isBuyer = true;
      this.items = [];
      this.productsToReceiptCollection = [];
    },
    deleteReceiptCollection: function deleteReceiptCollection(receiptCollection) {
      if (window.confirm("Do you want to Delete ?")) {
        this.$root.$firebaseRefs.receiptCollections.child(receiptCollection[".key"]).remove();
      }
    }
  }
});

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      links: ['About Us', 'Products', 'Contact', 'Login/SignUp']
    };
  }
});

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_util__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Staff',
  data: function data() {
    return {
      // getStaffAccount: [],
      dialog: false,
      dialogEdit: false,
      items: null,
      currentFirm: "",
      currentStaffRole: ['Normal A/C', 'Accountant', 'Commission', 'Director', 'Manager', 'Supervisor', 'Operator', 'Salesman', 'Trader', 'Helper', 'Personal', 'Not to disclose'],
      staffName: null,
      brokerageRate: 0,
      staffRole: null,
      staffNameEdit: null,
      staffRoleEdit: null,
      firms: [],
      openingBalanceEdit: 0,
      openingBalance: 0,
      initialamount: 0,
      snackbarSuccessText: null,
      snackbarText: null,
      snackbar: false,
      snackbarSuccess: false,
      currentFirmEdit: null,
      itemsEdit: null
    };
  },
  created: function created() {
    this.$bindAsArray('firms', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('account', this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('staff', this.$root.$firebaseRefs.staff.orderByChild('brand').equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand']), {
    getStaffAccount: function getStaffAccount() {
      var _this = this;

      if (this.selectedBrand) {
        return this.staff.filter(function (item) {
          return item['brand'] === _this.selectedBrand && item['firm'] != '';
        });
      }
    },
    staffCount: function staffCount() {
      return this.getStaffAccount.length || 0;
    }
  }),
  methods: {
    firmbyId: function firmbyId(id) {
      return this.firms.filter(function (item) {
        return item['.key'] == id;
      })[0].name;
    },
    addNewStaffAccount: function addNewStaffAccount() {
      var data = {
        brand: this.selectedBrand,
        firm: this.currentFirm,
        staffName: this.staffName,
        brokerageRate: this.brokerageRate,
        openingBalance: this.openingBalance,
        amount: this.initialamount,
        staffRole: this.staffRole
      };
      if (data.firm == null || data.firm == "") {
        this.snackbar = true;
        this.snackbarText = 'Please Select Firm';
        return false;
      } else if (data.staffName == null || data.staffName == "") {
        this.snackbar = true;
        this.snackbarText = 'Enter Account Holder Name';
        return false;
      } else if (data.staffRole == null || data.staffRole == "") {
        this.snackbar = true;
        this.snackbarText = 'Please Select Account Role';
        return false;
      }

      this.$root.$firebaseRefs.staff.push(data);
      // this.addInvoice();
      this.dialog = false;
      this.currentFirm = "";
      this.staffName = "";
      this.brokerageRate = 0;
      this.openingBalance = 0;
      this.amount = 0;
      this.staffRole = "";
    },
    editStaffAccount: function editStaffAccount(key) {
      var _this2 = this;

      this.dialogEdit = true;
      console.log(key);
      var firms = this.firms.filter(function (item) {
        return item['brand'] === _this2.selectedBrand;
      });
      var totalitem = [];
      firms.forEach(function (arrayItem) {
        totalitem.push({
          id: arrayItem['.key'],
          name: arrayItem.name
        });
      });
      this.itemsEdit = totalitem;

      this.dialogEdit = true;
      this.currentFirmEdit = key.firm;
      this.staffNameEdit = key.staffName;
      this.brokerageRate = key.brokerageRate;
      this.staffRoleEdit = key.staffRole;
      this.staffOpeningBalanceEdit = key.openingBalance;
      this.updateKey = key['.key'];
    },
    updateNewStaffAccount: function updateNewStaffAccount() {
      var data = {
        brand: this.selectedBrand,
        firm: this.currentFirmEdit,
        staffName: this.staffNameEdit,
        brokerageRate: this.brokerageRate,
        staffRole: this.staffRoleEdit,
        openingBalance: Number(this.openingBalanceEdit)
      };
      this.$root.$firebaseRefs.staff.child(this.updateKey).update({
        brand: this.selectedBrand,
        firm: this.currentFirmEdit,
        staffName: this.staffNameEdit,
        brokerageRate: this.brokerageRate,
        staffRole: this.staffRoleEdit,
        openingBalance: Number(this.openingBalanceEdit)
      });
      // this.addInvoice();
      this.currentFirmEdit = "";
      this.bankNameEdit = "";
      this.staffNameEdit = "";
      this.brokerageRate = 0;
      this.staffRoleEdit = "";
      this.openingBalanceEdit = 0;
      this.cancelDialogEdit();
    },
    deleteStaffAccount: function deleteStaffAccount(key) {
      confirm('Are you sure you want to delete this Account') && this.$root.$firebaseRefs.staff.child(key).remove();
    },
    cancelDialog: function cancelDialog() {
      this.dialog = false;
    },
    cancelDialogEdit: function cancelDialogEdit() {
      this.dialogEdit = false;
    },
    getFirms: function getFirms() {
      var _this3 = this;

      this.dialog = true;
      var firms = this.firms.filter(function (item) {
        return item['brand'] === _this3.selectedBrand;
      });
      var totalitem = [];
      firms.forEach(function (arrayItem) {
        totalitem.push({
          id: arrayItem['.key'],
          name: arrayItem.name
        });
      });
      this.items = totalitem;
      this.itemsEdit = totalitem;
    },
    getStaffAccount: function getStaffAccount() {
      var _this4 = this;

      this.dialog = true;
      var staff = this.staff.filter(function (item) {
        return item['brand'] === _this4.selectedBrand;
      });
      var totalitem = [];
      staff.forEach(function (arrayItem) {
        totalitem.push({
          id: arrayItem['.key'],
          name: arrayItem.name
        });
      });
      this.items = totalitem;
    }
  }
});

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_firebase__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];

var logoPath = 'print-images/';
var signaturePath = 'signature-images/';
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      addTermsDialog: false,
      currentTerms: {
        firm: null,
        termsAndConditions: "",
        bank: [],
        brand: null
      },
      printLogoImage: null,
      signatureImage: null,
      uploadValue: 0,
      termsList: [],
      termsListHeader: [
      // { text: "Print- ID", value: "Term - ID" },
      { text: "Firm", value: "Name" }, { text: "Banks", value: "Description" }, { text: "Terms and Conditions", value: "Description" }, { text: "Edit", value: "edit" }, { text: "Delete", value: "delete" }]
    };
  },
  created: function created() {
    this.$bindAsArray("termsAndConditions", this.$root.$firebaseRefs.termsAndConditions.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("banks", this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand"]), {
    firmsByBrand: function firmsByBrand() {
      var _this = this;

      var alreadyExistsSettingsFirm = this.termsListByBrand;
      return this.firms.filter(function (item) {
        return item["brand"] === _this.selectedBrand && !_.find(alreadyExistsSettingsFirm, function (o) {
          return o['firm'] == item['.key'];
        });
      }).map(function (item) {
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
    },
    banksByFirms: function banksByFirms() {
      var _this2 = this;

      return this.banks.filter(function (item) {
        return item["brand"] === _this2.selectedBrand && (_this2.currentTerms.firm ? item['firm'] === _this2.currentTerms.firm : false);
      }).map(function (item) {
        return {
          text: item["bankName"] + " | " + item["accountnumber"],
          value: item[".key"]
        };
      });
    },
    termsListByBrand: function termsListByBrand() {
      var _this3 = this;

      return this.termsAndConditions.filter(function (item) {
        return item["brand"] === _this3.selectedBrand;
      });
    }
  }),
  methods: {
    saveTerms: function saveTerms() {
      if (this.printLogoImage || this.signatureImage) {
        this.uploadAndSave(true);
      } else {
        this.$root.$firebaseRefs.termsAndConditions.push(this.currentTerms);
        this.addTermsDialog = false;
      }
    },
    deleteImage: function deleteImage(name, filePath) {
      var storagePath = __WEBPACK_IMPORTED_MODULE_6_firebase___default.a.storage().ref();
      storagePath.child(filePath + ("" + name)).delete();
    },
    uploadAndSave: function uploadAndSave(isSave) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this4.printLogoImage && _this4.currentTerms.printLogo) {
                  _this4.deleteImage(_this4.currentTerms.logoFileName, logoPath);
                }
                if (_this4.signatureImage && _this4.currentTerms.signature) {
                  _this4.deleteImage(_this4.currentTerms.signatureFileName, signaturePath);
                }

                if (!_this4.printLogoImage) {
                  _context.next = 5;
                  break;
                }

                _context.next = 5;
                return _this4.upload(_this4.printLogoImage, logoPath, ['printLogo', 'logoFileName']).then(function () {
                  _this4.printLogoImage = null;
                });

              case 5:
                if (!_this4.signatureImage) {
                  _context.next = 8;
                  break;
                }

                _context.next = 8;
                return _this4.upload(_this4.signatureImage, signaturePath, ['signature', 'signatureFileName']).then(function () {
                  _this4.signatureImage = null;
                });

              case 8:
                if (isSave) {
                  _this4.saveTerms();
                } else {
                  _this4.updateTerms();
                }

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this4);
      }))();
    },
    upload: function upload(image, filePath, fields) {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        var fileName = new Date().getTime() + "_" + image.name;
        var storageRef = __WEBPACK_IMPORTED_MODULE_6_firebase___default.a.storage().ref(filePath + ("" + fileName)).put(image);
        storageRef.on("state_changed", function (snapshot) {
          _this5.uploadValue = snapshot.bytesTransferred / snapshot.totalBytes * 100;
        }, function (error) {
          console.log(error.message);
        }, function () {
          _this5.uploadValue = 100;
          storageRef.snapshot.ref.getDownloadURL().then(function (url) {
            _this5.uploadValue = 0;
            _this5.currentTerms[fields[0]] = url;
            _this5.currentTerms[fields[1]] = fileName;
            resolve();
          });
        });
      });
    },
    uploadChangeLogo: function uploadChangeLogo(event) {
      this.printLogoImage = event.target.files[0];
    },
    uploadChangeSignature: function uploadChangeSignature(event) {
      this.signatureImage = event.target.files[0];
    },
    addTerm: function addTerm() {
      this.currentTerms = {
        firm: null,
        bank: [],
        termsAndConditions: '',
        brand: this.selectedBrand
      };
      this.addTermsDialog = true;
    },
    getFirmName: function getFirmName(e) {
      var firm = void 0;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter(function (item) {
          return item['.key'] === e;
        })[0];
      }
      if (firm) return firm.name;
    },
    getBankName: function getBankName(e) {
      var bank = this.banks.filter(function (item) {
        return item['.key'] === e;
      })[0];
      if (bank) return bank.bankName + " | " + bank["accountnumber"];
    },
    updateTerms: function updateTerms() {
      if (this.printLogoImage || this.signatureImage) {
        this.uploadAndSave(false);
      } else {
        var key = this.currentTerms[".key"];
        delete this.currentTerms[".key"];
        this.$root.$firebaseRefs.termsAndConditions.child(key).set(this.currentTerms);
        this.currentTerms = {
          firm: null,
          bank: [],
          termsAndConditions: '',
          brand: this.selectedBrand,
          greetingMessage: ""
        };
        this.addTermsDialog = false;
      }
    },
    editTerm: function editTerm(term) {
      this.currentTerms = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(term));
      this.addTermsDialog = true;
    },
    deleteTerm: function deleteTerm(term) {
      if (window.confirm("Do you want to Delete " + term.name + "?")) {
        if (term.printLogo) {
          this.deleteImage(term.logoFileName, logoPath);
        }
        if (term.signature) {
          this.deleteImage(term.signatureFileName, signaturePath);
        }
        this.$root.$firebaseRefs.termsAndConditions.child(term[".key"]).remove();
      }
    }
  }
});

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Firms',
  data: function data() {
    var _this = this;

    return {
      businessType: null,
      dialogEdit: false,
      dialog: false,
      addNewFirmValid: false,
      firmName: null,
      firmProprietor: null,
      firmLiveAddress: null,
      firmLiveAddressEdit: null,
      firmRegNumber: null,
      panNumber: null,
      GST_user: null,
      website: null,
      timeout: 3000,
      snackbar: false,
      zipCode: null,
      datepicker1: false,
      datepicker2: false,
      text: null,
      amount: {
        value: 0
      },
      openingCashAmount: {
        value: 0
      },
      switch1: false,
      switch2: false,
      firmMobileNumber: {
        value: null,
        rules: [function (v) {
          return !!v || 'Mobile is required';
        }, function (v) {
          return (/^(\+91|\+91\-|0)?[6789]\d{9}$/.test(v) || 'Mobile number is wrong'
          );
        }]
      },
      firms: [],
      GST_Type: {
        value: null
      },
      firmNameEdit: null,
      firmProprietorEdit: null,
      firmRegNumberEdit: null,
      firmMobileNumberEdit: {
        value: null,
        rules: [function (v) {
          return !!v || 'Mobile is required';
        }, function (v) {
          return (/^(\+91|\+91\-|0)?[6789]\d{9}$/.test(v) || 'Mobile number is wrong'
          );
        }]
      },
      amountEdit: {
        value: 0
        // rules:[
        //   v => !!v || 'Amount is Required',
        //   v => v>0 || 'Amount cannot be negative'
        // ]
      },
      openingCashAmountEdit: {
        value: 0
        // rules:[
        //   v => !!v || 'Amount is Required',
        //   v => v>0 || 'Amount cannot be negative'
        // ]
      },
      GST_number: {
        value: '',
        rules: [function (v) {
          var obj = _this.gState.find(function (o) {
            return o.state === _this.state.value;
          });
          var reg = /^$/;
          if (obj && obj.code) {
            reg = new RegExp("^([" + obj.code + "]){2}[A-Z]{5}\\d{4}[A-Z]{1}[A-Z\\d]{1}[Z]{1}[A-Z\\d]{1}");
          }
          return v == undefined || /^$/.test(v) || reg.test(v) || "GST number must be Valid";
        }]
      },
      PAN_Rules: [function (v) {
        var obj = _this.gState.find(function (o) {
          return o.state === _this.state.value;
        });
        var reg = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
        return v == undefined || /^$/.test(v) || reg.test(v) || "PAN number must be Valid";
      }],
      email: {
        value: ''
        //  rules: [
        //   v =>  /^$/.test(v) || /.+@.+/.test(v) || 'E-mail must be valid'
        // ],
      },
      switch1Edit: false,
      switch2Edit: false,
      firmOpeningBalance: null,
      firmOpeningDate: new Date().toISOString().substr(0, 10),
      firmOpeningBalanceEdit: null,
      firmOpeningDateEdit: null,
      firmOpeningStock: null,
      firmOpeningStockEdit: null,
      updateKey: null,
      village: {
        value: ''
      },
      block: {
        value: ''
      },
      tehsil: {
        value: ''
      },
      district: {
        value: ''
      },
      state: {
        value: ''
      },
      country: {
        value: ''
      }
    };
  },
  created: function created() {
    this.$bindAsArray('firms', this.$root.$firebaseRefs.firm);
    this.$bindAsArray("operator", this.$root.$firebaseRefs.operator);
    var today = new Date();
    this.date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    this.firmOpeningDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    this.firmOpeningDateEdit = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand']), mapGlobalGetters({
    gVillage: 'village',
    gBlock: 'block',
    gTehsil: 'tehsil',
    gDistrict: 'district',
    gState: 'state',
    gCountry: 'country',
    gGST_Type: 'GST_Type'
  }), {
    getFirms: function getFirms() {
      var _this2 = this;

      if (this.firms && this.selectedBrand) {
        return this.firms.filter(function (item) {
          return item['brand'] === _this2.selectedBrand;
        });
      }
    },
    firmCount: function firmCount() {
      return this.getFirms.length || 0;
    }
  }),
  methods: {
    setLocationBasedOnZipCode: function setLocationBasedOnZipCode() {
      var _this3 = this;

      var reg = /^[1-9][0-9]{5}$/;
      console.log(this.zipCode);
      if (this.zipCode && reg.test(this.zipCode)) {
        console.log("change");
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://api.postalpincode.in/pincode/' + this.zipCode).then(function (response) {
          var data = response.data[0].PostOffice[0];
          _this3.gCountry.push(data.Country);
          _this3.gState.push(data.State);
          _this3.gDistrict.push(data.District);
          _this3.gTehsil.push(data.Block);
          setTimeout(function () {
            _this3.country.value = data.Country;
            _this3.state.value = data.State;
            _this3.district.value = data.District;
            _this3.tehsil.value = data.Block;
          }, 100);
        });
      }
    },
    addNewFirm: function addNewFirm() {
      if (this.firmName && this.selectedBrand) {
        var data = {
          brand: this.selectedBrand,
          name: this.firmName,
          proprietor: this.firmProprietor,
          liveAddress: this.firmLiveAddress,
          registrationNumber: this.firmRegNumber,
          mobileNumber: Number(this.firmMobileNumber.value),
          openingBalance: Number(this.firmOpeningBalance),
          openingStock: Number(this.firmOpeningStock),
          openingDate: new Date(this.firmOpeningDate).getTime(),
          amount: Number(this.amount.value),
          openingCashAmount: Number(this.openingCashAmount.value),
          amountAtCreation: Number(this.amount.value),
          village: this.village.value,
          block: this.block.value,
          tehsil: this.tehsil.value,
          district: this.district.value,
          state: this.state.value,
          country: this.country.value,
          website: this.website,
          panNumber: this.panNumber,
          email: this.email.value,
          GST_user: this.GST_user,
          GST_number: this.GST_number.value,
          GST_Type: this.GST_Type.value,
          zipCode: this.zipCode,
          businessType: this.businessType
        };
        if (this.switch1) {
          if (this.amount) {
            data['amount'] = Number(this.amount.value);
            this.$root.$firebaseRefs.firm.push(data);
            // this.addInvoice();
            this.firmName = null;
            this.firmProprietor = null;
            this.firmLiveAddress = null;
            this.firmRegNumber = null;
            this.firmMobileNumber.value = null;
            this.firmOpeningBalance = null;
            this.firmOpeningStock = null;
            this.firmOpeningDate = null;
            this.switch1 = false;
            this.switch2 = false;
            this.amount.value = 0;
            this.openingCashAmount.value = 0;
            this.dialog = false;
            this.village.value = null;
            this.block.value = null;
            this.tehsil.value = null;
            this.district.value = null;
            this.state.value = null;
            this.country.value = null;
            this.email.value = null;
            this.website = null;
            this.GST_user = null;
            this.GST_number.value = null;
            this.panNumber = null;
            this.GST_Type.value = null;
            this.zipCode = null;
            this.businessType = null;
          } else {
            this.snackbar = true;
            this.text = "Please fill the amount";
          }
        } else {
          this.$root.$firebaseRefs.firm.push(data);
          this.dialog = false;
          this.firmName = null;
          this.firmProprietor = null;
          this.firmRegNumber = null;
          this.firmMobileNumber.value = null;
          this.firmOpeningBalance = null;
          this.firmOpeningStock = null;
          this.firmOpeningDate = null;
          this.switch1 = false;
          this.switch2 = false;
          this.amount.value = 0;
          this.openingCashAmount.value = 0;
          this.village.value = null;
          this.block.value = null;
          this.tehsil.value = null;
          this.district.value = null;
          this.state.value = null;
          this.country.value = null;
          this.email.value = null;
          this.website = null;
          this.GST_user = null;
          this.GST_number.value = null;
          this.panNumber = null;
          this.zipCode = null;
          this.GST_Type.value = null;
          this.businessType = null;
        }
      }
    },


    //Start of Bydefault fetchinng values
    // getAndSetDefaultValues() {
    //   let operatorArr = this.operator.filter(
    //     item => item["brand"] === this.selectedBrand
    //   );
    //   let operator = operatorArr[0];
    //   if(operator){
    //     if(!this.village.value && operator.village){
    //     this.village.value = operator.village;
    //     }
    //     if(!this.block.value && operator.block){
    //       this.block.value = operator.block;
    //     }
    //     if(!this.tehsil.value && operator.tehsil){
    //       this.tehsil.value = operator.tehsil;
    //     }
    //     if(!this.district.value && operator.district){
    //       this.district.value = operator.district;
    //     }
    //     if(!this.state.value && operator.state){
    //       this.state.value = operator.state;
    //     }
    //     if(!this.country.value && operator.country){
    //       this.country.value = operator.country;
    //     }
    //     if(!this.email.value && operator.email){
    //       this.email.value = operator.email;
    //     }
    //   }
    // },
    // End of Bydefault Fetching Values


    // addInvoice(){
    //   let invoiceData = {
    //       brand: this.selectedBrand,
    //       type:'automatic invoice',
    //       paymentType:'cash',
    //       subtype:'deposit',
    //       isCredited:true,
    //       totalAmount:Number(this.amount.value),
    //       date:Date.now()
    //   }
    //   this.$root.$firebaseRefs.invoice.push(invoiceData);
    // },
    deletefirm: function deletefirm(key) {
      this.$root.$firebaseRefs.firm.child(key).remove();
    },
    cancelDialog: function cancelDialog() {
      this.dialog = false;
      this.firmName = null;
      this.firmProprietor = null;
      this.firmLiveAddress = null;
      this.firmRegNumber = null;
      this.firmMobileNumber.value = null;
      this.firmOpeningBalance = null;
      this.firmOpeningStock = null;
      this.firmOpeningDate = null;
      this.amount = 0;
      this.openingCashAmount = 0;
      this.switch1 = false;
      this.switch2 = false;
      this.village.value = null;
      this.block.value = null;
      this.tehsil.value = null;
      this.district.value = null;
      this.state.value = null;
      this.country.value = null;
      this.email.value = null;
      this.zipCode = null;
      this.website = null;
      this.GST_user = null;
      this.GST_number.value = null;
      this.panNumber = null;
      this.GST_Type.value = null;
      this.businessType = null;
    },
    cancelDialogEdit: function cancelDialogEdit() {
      this.dialogEdit = false;
      this.firmNameEdit = null;
      this.firmProprietorEdit = null;
      this.firmLiveAddressEdit = null;
      this.firmRegNumberEdit = null;
      this.firmMobileNumberEdit.value = null;
      this.firmOpeningBalanceEdit = null;
      this.firmOpeningStockEdit = null;
      this.firmOpeningDateEdit = null;
      this.amountEdit.value = 0;
      this.openingCashAmountEdit.value = 0;
      this.switch1Edit = false;
      this.switch2Edit = false;
      this.village.value = null;
      this.block.value = null;
      this.tehsil.value = null;
      this.district.value = null;
      this.state.value = null;
      this.country.value = null;
      this.email.value = null;
      this.website = null;
      this.GST_user = null;
      this.GST_number.value = null;
      this.panNumber = null;
      this.zipCode = null;
      this.GST_Type.value = null;
      this.businessType = null;
    },
    editFirm: function editFirm(key) {
      this.dialogEdit = true;
      console.log(key);
      this.firmNameEdit = key.name;
      this.firmProprietorEdit = key.proprietor;
      this.firmLiveAddressEdit = key.liveAddress;
      this.firmRegNumberEdit = key.registrationNumber ? key.registrationNumber : null;
      this.firmMobileNumberEdit.value = key.mobileNumber;
      this.firmOpeningBalanceEdit = isNaN(key.openingBalance) ? 0 : key.openingBalance;
      this.firmOpeningStockEdit = isNaN(key.openingStock) ? 0 : key.openingStock;
      this.firmOpeningDateEdit = key.openingDate ? new Date(key.openingDate).toISOString().substr(0, 10) : null, this.village.value = key.village;
      this.block.value = key.block;
      this.tehsil.value = key.tehsil;
      this.district.value = key.district;
      this.state.value = key.state;
      this.country.value = key.country;
      this.email.value = key.email;
      this.website = key.website;
      this.GST_user = key.GST_user;
      this.GST_number.value = key.GST_number;
      this.panNumber = key.panNumber;
      this.updateKey = key['.key'];
      this.GST_Type.value = key.GST_Type;
      this.zipCode = key.zipCode;
      this.businessType = key.businessType;
      if (key.amount > 0) {
        this.switch1Edit = true;
        this.amountEdit.value = isNaN(key.amount) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(key.amount);
      } else {
        this.switch1Edit = false;
      };
      if (key.openingCashAmountEdit > 0) {
        this.switch2Edit = true;
        this.openingCashAmountEdit.value = isNaN(key.openingCashAmountEdit) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(key.openingCashAmountEdit);
      } else {
        this.switch2Edit = false;
      }
    },
    updateFirm: function updateFirm() {
      if (this.firmNameEdit && this.selectedBrand) {
        var data = {
          brand: this.selectedBrand,
          name: this.firmNameEdit,
          proprietor: this.firmProprietorEdit,
          liveAddress: this.firmLiveAddressEdit,
          registrationNumber: this.firmRegNumberEdit ? this.firmRegNumberEdit : null,
          mobileNumber: Number(this.firmMobileNumberEdit.value),
          openingBalance: Number(this.firmOpeningBalanceEdit),
          openingStock: Number(this.firmOpeningStockEdit),
          openingDate: new Date(this.firmOpeningDateEdit).toISOString().substr(0, 10),
          amount: Number(this.amountEdit.value),
          openingCashAmount: Number(this.openingCashAmountEdit.value),
          zipCode: this.zipCode,
          village: this.village.value,
          block: this.block.value,
          tehsil: this.tehsil.value,
          district: this.district.value,
          state: this.state.value,
          country: this.country.value,
          website: this.website,
          panNumber: this.panNumber,
          email: this.email.value,
          GST_user: this.GST_user,
          GST_number: this.GST_number.value,
          GST_Type: this.GST_Type.value,
          businessType: this.businessType
        };
        if (this.switch1Edit || this.switch2Edit) {
          if (this.amountEdit || this.openingCashAmountEdit) {
            data['amount'] = Number(this.amountEdit.value) || Number(this.openingCashAmountEdit.value);
            var updatedData = {
              brand: this.selectedBrand,
              name: this.firmNameEdit,
              proprietor: this.firmProprietorEdit,
              liveAddress: this.firmLiveAddressEdit,
              registrationNumber: this.firmRegNumberEdit ? this.firmRegNumberEdit : null,
              mobileNumber: Number(this.firmMobileNumberEdit.value),
              openingBalance: Number(this.firmOpeningBalanceEdit),
              openingStock: Number(this.firmOpeningStockEdit),
              openingDate: new Date(this.firmOpeningDateEdit).toISOString().substr(0, 10),
              amount: Number(this.amountEdit.value),
              openingCashAmount: Number(this.openingCashAmountEdit.value),
              zipCode: this.zipCode
            };

            if (this.village.value) updatedData['village'] = this.village.value;

            if (this.block.value) updatedData['block'] = this.block.value;

            if (this.tehsil.value) updatedData['tehsil'] = this.tehsil.value;

            if (this.district.value) updatedData['district'] = this.district.value;

            if (this.state.value) updatedData['state'] = this.state.value;

            if (this.country.value) updatedData['country'] = this.country.value;

            if (this.email.value) updatedData['email'] = this.email.value;

            if (this.GST_number.value) updatedData['GST_number'] = this.GST_number.value;

            if (this.panNumber) updatedData['panNumber'] = this.panNumber;

            if (this.website) updatedData['website'] = this.website;

            if (this.GST_user) updatedData['GST_user'] = this.GST_user;

            if (this.GST_Type.value) updatedData['GST_Type'] = this.GST_Type.value;

            if (this.businessType) updatedData['businessType'] = this.businessType;

            this.$root.$firebaseRefs.firm.child(this.updateKey).update(updatedData);
            this.firmNameEdit = null;
            this.firmProprietorEdit = null;
            this.firmLiveAddressEdit = null;
            this.firmRegNumberEdit = null;
            this.firmMobileNumberEdit.value = null;
            this.firmOpeningBalanceEdit = null;
            this.firmOpeningStockEdit = null;
            this.firmOpeningDateEdit = null;
            this.switch1Edit = false;
            this.switch2Edit = false;
            this.amountEdit.value = 0;
            this.openingCashAmountEdit.value = 0;
            this.zipCode = null;
            this.dialogEdit = false;
            this.switch1Edit = false;
            this.village.value = null;
            this.block.value = null;
            this.tehsil.value = null;
            this.district.value = null;
            this.state.value = null;
            this.country.value = null;
            this.email.value = null;
            this.website = null;
            this.GST_user = null;
            this.GST_number.value = null;
            this.panNumber = null;
            this.GST_Type.value = null;
            this.businessType = null;
          } else {
            this.snackbar = true;
            this.text = "Please fill the amount";
          }
        } else {
          var _updatedData = {
            brand: this.selectedBrand,
            name: this.firmNameEdit,
            proprietor: this.firmProprietorEdit,
            liveAddress: this.firmLiveAddressEdit,
            registrationNumber: this.firmRegNumberEdit,
            mobileNumber: Number(this.firmMobileNumberEdit.value),
            openingBalance: Number(this.firmOpeningBalanceEdit),
            openingStock: Number(this.firmOpeningStockEdit),
            openingDate: new Date(this.firmOpeningDateEdit).getTime(),
            amount: Number(this.amountEdit.value),
            openingCashAmount: Number(this.openingCashAmountEdit.value),
            zipCode: this.zipCode
          };

          if (this.village.value) _updatedData['village'] = this.village.value;

          if (this.block.value) _updatedData['block'] = this.block.value;

          if (this.tehsil.value) _updatedData['tehsil'] = this.tehsil.value;

          if (this.district.value) _updatedData['district'] = this.district.value;

          if (this.state.value) _updatedData['state'] = this.state.value;

          if (this.country.value) _updatedData['country'] = this.country.value;

          if (this.email.value) _updatedData['email'] = this.email.value;

          if (this.GST_number.value) _updatedData['GST_number'] = this.GST_number.value;

          if (this.panNumber) _updatedData['panNumber'] = this.panNumber;

          if (this.website) _updatedData['website'] = this.website;

          if (this.GST_user) _updatedData['GST_user'] = this.GST_user;

          if (this.GST_Type.value) _updatedData['GST_Type'] = this.GST_Type.value;

          if (this.businessType) _updatedData['businessType'] = this.businessType;

          this.$root.$firebaseRefs.firm.child(this.updateKey).update(_updatedData);
          this.firmNameEdit = null;
          this.firmProprietorEdit = null;
          this.firmLiveAddressEdit = null;
          this.firmRegNumberEdit = null;
          this.firmMobileNumberEdit.value = null;
          this.firmOpeningBalanceEdit = null;
          this.firmOpeningStockEdit = null;
          this.firmOpeningDateEdit = null;
          this.switch1Edit = false;
          this.amountEdit.value = 0;
          this.switch2Edit = false;
          this.openingCashAmountEdit.value = 0;
          this.zipCode = null;
          this.dialogEdit = false;
          this.village.value = null;
          this.block.value = null;
          this.tehsil.value = null;
          this.district.value = null;
          this.state.value = null;
          this.country.value = null;
          this.email.value = null;
          this.website = null;
          this.GST_user = null;
          this.GST_number.value = null;
          this.panNumber = null;
          this.GST_Type.value = null;
          this.businessType = null;
        }
      }
    }
  },
  watch: {
    selectedBrand: function selectedBrand() {
      // this.getAndSetDefaultValues();
    }
  }
});

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Account',
  data: function data() {
    var _ref;

    return _ref = {
      datepicker2: false,
      datepicker1: false,
      requiredRule: [function (v) {
        return !!v || 'Field is Required';
      }],
      addNewAccountValid: false,
      dialog: false,
      dialogEdit: false,
      items: null,
      itemsEdit: null,
      bankName: null,
      accountType: null,
      accountCategory: null,
      currentFirmEdit: null,
      bankNameEdit: null,
      accountCategoryEdit: null,
      accountTypeEdit: null,
      accountHolderNameEdit: null,
      accountnumberEdit: null,
      ifsccodeEdit: null,
      accountLocationEdit: null,
      initialamountEdit: null,
      openingBalanceEdit: null,
      updateKey: null,
      accholderdisabled: false,
      accholderdisabledEdit: false,
      currentFirm: null,
      currentAccountCategory: ['Firm A/C', 'Prop A/C', 'Normal A/C'],
      currentBankName: ['Allahabad Bank', 'Andhra Bank', 'Axis Bank', 'Bandhan Bank', 'Bank of India', 'Bank Of Baroda', 'Bank Of Maharastra', 'Canara Bank', 'Central Bank Of India', 'Corporation Bank', 'Dena Bank', 'DCB bank', 'Google Pay', 'HDFC bank', 'ICICI Bank', 'Indian Overseas Bank', 'India Post', 'Kotak Mahindra Bank', 'Oriental Bank Of Commerce', 'Paytm', 'Phone Pe', 'Punjab National Bank', 'Punjab and Sind Bank', 'State Bank Of India', 'UCO Bank', 'Union Bank Of India', 'Vijaya Bank', 'Yes Bank'],
      currentAccountType: ['Current A/C', 'Cumulative A/C', 'Demat A/C', 'Fixed Deposit A/C', 'Loan A/C', 'NRI A/C', 'Post-Office A/C', 'Overdraft A/C', 'Saving A/C'],
      IFSC_Rules: [function (v) {
        // let reg = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
        var reg = /^([a-zA-Z]){4}([0]){1}([a-zA-Z0-9]){6}?$/;
        return v == undefined || /^$/.test(v) || reg.test(v) || "IFSC must be Valid";
      }],
      ifsccode: null,
      accountLocation: null,
      accountHolderName: null,
      accountnumber: null,
      firms: [],
      initialamount: 0,
      openingBalance: null,
      openingDate: null
    }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'openingBalanceEdit', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'openingDateEdit', null), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'village', {
      value: ''
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'block', {
      value: ''
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'tehsil', {
      value: ''
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'district', {
      value: ''
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'state', {
      value: ''
    }), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_ref, 'country', {
      value: ''
    }), _ref;
  },
  created: function created() {
    this.$bindAsArray('firms', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('account', this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("operator", this.$root.$firebaseRefs.operator.orderByChild('brand').equalTo(this.selectedBrand));
    var today = new Date();
    this.date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    this.openingDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    this.openingDateEdit = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    if (this.$route.params.isNew) {
      // this.dialog = true; 
      this.getFirms();
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand', 'brandFinYear']), {
    getAccount: function getAccount() {
      var _this = this;

      if (this.selectedBrand) {
        return this.account.filter(function (item) {
          return item['brand'] === _this.selectedBrand;
        });
      }
    },
    accountCount: function accountCount() {
      return this.getAccount.length || 0;
    }
  }, mapGlobalGetters({
    gVillage: 'village',
    gBlock: 'block',
    gTehsil: 'tehsil',
    gDistrict: 'district',
    gState: 'state',
    gCountry: 'country'
  })),
  methods: {
    capitalize: function capitalize(s) {
      s = s.toLowerCase();
      if (typeof s !== 'string') return '';
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
    getBankDetailsFromIFSC: function getBankDetailsFromIFSC(isEdit) {
      var _this2 = this;

      var ifsc = isEdit ? this.ifsccodeEdit : this.ifsccode;
      var reg = /^([a-zA-Z]){4}([0]){1}([a-zA-Z0-9]){6}?$/;
      console.log(ifsc);
      if (ifsc && reg.test(ifsc)) {
        console.log("change");
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('https://ifsc.razorpay.com/' + ifsc).then(function (response) {
          _this2.gState.push(_this2.capitalize(response.data.STATE));
          _this2.gDistrict.push(_this2.capitalize(response.data.DISTRICT));
          _this2.gTehsil.push(_this2.capitalize(response.data.CITY));
          setTimeout(function () {
            _this2.country.value = 'India';
            _this2.district.value = _this2.capitalize(response.data.DISTRICT);
            _this2.state.value = _this2.capitalize(response.data.STATE);
            _this2.tehsil.value = _this2.capitalize(response.data.CITY);
          }, 100);
          if (isEdit) {
            _this2.accountLocationEdit = response.data.BRANCH + " " + response.data.ADDRESS;
          } else {
            _this2.accountLocation = response.data.BRANCH + " " + response.data.ADDRESS;
          }
        });
      }
    },
    firmbyId: function firmbyId(id) {
      return this.firms.filter(function (item) {
        return item['.key'] == id;
      })[0].name;
    },
    propbyId: function propbyId(id) {
      return this.firms.filter(function (item) {
        return item['.key'] == id;
      })[0].proprietor;
    },
    addNewAccount: function addNewAccount() {
      var _this3 = this;

      if (!this.$refs.addAccount.validate()) {
        return console.info('not valid....');
      }
      var data = {
        brand: this.selectedBrand,
        brandFinYear: this.brandFinYear,
        firm: this.currentFirm,
        bankName: this.bankName,
        accountCategory: this.accountCategory,
        accountHolderName: this.accountHolderName,
        accountnumber: this.accountnumber,
        ifsccode: this.ifsccode,
        accountLocation: this.accountLocation,
        accountType: this.accountType,
        amount: Number(this.initialamount),
        openingBalance: Number(this.openingBalance),
        village: this.village.value || '',
        block: this.block.value || '',
        tehsil: this.tehsil.value,
        district: this.district.value,
        state: this.state.value,
        country: this.country.value
      };
      this.$root.$firebaseRefs.account.push(data, function () {
        _this3.clearForm();
        _this3.cancelDialog();
      });
    },
    clearForm: function clearForm() {
      this.dialog = false;
      this.currentFirm = "";
      this.bankName = "";
      this.accountCategory = "";
      this.ifsccode = null;
      this.accountHolderName = null;
      this.accountType = "";
      this.accountLocation = null;
      this.accountnumber = "";
      this.amount = 0;
      this.openingBalance = 0;
      this.initialamount = 0;
      this.village.value = null;
      this.block.value = null;
      this.tehsil.value = null;
      this.district.value = null;
      this.state.value = null;
      this.country.value = null;
    },
    updateNewAccount: function updateNewAccount() {
      if (!this.$refs.editAccount.validate()) {
        return console.info('not valid....');
      }
      var data = {
        brand: this.selectedBrand,
        firm: this.currentFirmEdit,
        bankName: this.bankNameEdit,
        accountCategory: this.accountCategoryEdit,
        accountHolderName: this.accountHolderNameEdit,
        accountnumber: this.accountnumberEdit,
        ifsccode: this.ifsccodeEdit,
        accountLocation: this.accountLocationEdit,
        accountType: this.accountTypeEdit,
        amount: Number(this.initialamountEdit),
        openingBalance: this.openingBalanceEdit,
        openingDate: new Date(this.openingDateEdit).getTime()
      };
      this.$root.$firebaseRefs.account.child(this.updateKey).update({
        brand: this.selectedBrand,
        firm: this.currentFirmEdit,
        bankName: this.bankNameEdit,
        accountCategory: this.accountCategoryEdit,
        accountHolderName: this.accountHolderNameEdit,
        accountnumber: this.accountnumberEdit,
        ifsccode: this.ifsccodeEdit,
        accountLocation: this.accountLocationEdit,
        accountType: this.accountTypeEdit,
        amount: Number(this.initialamountEdit),
        openingBalance: this.openingBalanceEdit,
        village: this.village.value || "",
        block: this.block.value || "",
        tehsil: this.tehsil.value || "",
        district: this.district.value,
        state: this.state.value,
        country: this.country.value,
        openingDate: new Date(this.openingDateEdit).getTime()
      });
      // this.addInvoice();
      this.currentFirmEdit = "";
      this.bankNameEdit = "";
      this.accountCategoryEdit = "";
      this.ifsccodeEdit = null;
      this.accountHolderNameEdit = null;
      this.accountTypeEdit = "";
      this.accountLocationEdit = null;
      this.accountnumberEdit = 0;
      this.initialamountEdit = 0;
      this.openingBalanceEdit = null;
      this.openingDateEdit = null;
      this.village.value = null;
      this.block.value = null;
      this.tehsil.value = null;
      this.district.value = null;
      this.state.value = null;
      this.country.value = null;
      this.cancelDialog();
    },
    addInvoice: function addInvoice() {
      var invoiceData = {
        brand: this.selectedBrand,
        brandFinYear: this.brandFinYear,
        type: 'automatic invoice',
        firm: this.currentFirm,
        paymentType: 'bank',
        accountHolderName: this.accountHolderName,
        accountNumber: this.accountnumber,
        isCredited: true,
        totalAmount: Number(this.initialamount),
        openingBalance: Number(this.openingBalance),
        openingDate: Number(this.openingDate),
        date: Date.now()
      };
      this.$root.$firebaseRefs.invoice.push(invoiceData);
    },
    deleteAccount: function deleteAccount(key) {
      confirm('Are you sure you want to delete this Bank Account') && this.$root.$firebaseRefs.account.child(key).remove();
    },
    cancelDialog: function cancelDialog() {
      this.dialog = false;
      if (this.$refs.addAccount) {
        this.$refs.addAccount.reset();
      }
      this.dialogEdit = false;
      if (this.$refs.editAccount) {
        this.$refs.editAccount.reset();
      }
    },
    getFirms: function getFirms() {
      var _this4 = this;

      this.dialog = true;
      var firms = this.firms.filter(function (item) {
        return item['brand'] === _this4.selectedBrand;
      });
      var totalitem = [];
      firms.forEach(function (arrayItem) {
        totalitem.push({
          id: arrayItem['.key'],
          name: arrayItem.name
        });
      });
      this.items = totalitem;
      this.itemsEdit = totalitem;
    },
    getAccount: function getAccount() {
      var _this5 = this;

      this.dialog = true;
      var account = this.account.filter(function (item) {
        return item['brand'] === _this5.selectedBrand;
      });
      var totalitem = [];
      account.forEach(function (arrayItem) {
        totalitem.push({
          id: arrayItem['.key'],
          name: arrayItem.name
        });
      });
      this.items = totalitem;
    },
    editAccount: function editAccount(key) {
      var _this6 = this;

      this.dialogEdit = true;
      console.log(key);
      var firms = this.firms.filter(function (item) {
        return item['brand'] === _this6.selectedBrand;
      });
      var totalitem = [];
      firms.forEach(function (arrayItem) {
        totalitem.push({
          id: arrayItem['.key'],
          name: arrayItem.name
        });
      });
      this.itemsEdit = totalitem;

      this.currentFirmEdit = key.firm;
      this.bankNameEdit = key.bankName;
      this.accountCategoryEdit = key.accountCategory;
      this.accountTypeEdit = key.accountType;
      this.accountHolderNameEdit = key.accountHolderName;
      this.accountnumberEdit = key.accountnumber;
      this.ifsccodeEdit = key.ifsccode;
      this.accountLocationEdit = key.accountLocation;
      this.initialamountEdit = key.amount;
      this.openingBalanceEdit = key.openingBalance;
      this.village.value = key.village;
      this.block.value = key.block;
      this.tehsil.value = key.tehsil;
      this.district.value = key.district;
      this.state.value = key.state;
      this.country.value = key.country;
      this.openingDateEdit = key.openingDate ? new Date(key.openingDate).toISOString().substr(0, 10) : null, this.updateKey = key['.key'];
    },
    categoryChange: function categoryChange() {
      var self = this;
      setTimeout(function () {
        if (self.accountCategory == "Firm A/C" && self.currentFirm) {
          self.accountHolderName = self.firmbyId(self.currentFirm);
          self.accholderdisabled = true;
        } else if (self.accountCategory == "Prop A/C" && self.currentFirm) {
          self.accountHolderName = self.propbyId(self.currentFirm);
          self.accholderdisabled = true;
        } else {
          self.accountHolderName = "";
          self.accholderdisabled = false;
        }
      }, 1000);
    },
    firmChange: function firmChange() {
      var self = this;
      setTimeout(function () {
        if (self.accountCategory == "Firm A/C" && self.currentFirm) {
          self.accountHolderName = self.firmbyId(self.currentFirm);
          self.accholderdisabled = true;
        } else if (self.accountCategory == "Prop A/C" && self.currentFirm) {
          self.accountHolderName = self.propbyId(self.currentFirm);
          self.accholderdisabled = true;
        } else {
          self.accountHolderName = "";
          self.accholderdisabled = false;
        }
      }, 1000);
    },
    categoryChangeEdit: function categoryChangeEdit() {
      var self = this;
      setTimeout(function () {
        if (self.accountCategoryEdit == "Firm A/C" && self.currentFirmEdit) {
          self.accountHolderNameEdit = self.firmbyId(self.currentFirmEdit);
          self.accholderdisabledEdit = true;
        } else if (self.accountCategoryEdit == "Prop A/C" && self.currentFirmEdit) {
          self.accountHolderNameEdit = self.propbyId(self.currentFirmEdit);
          self.accholderdisabledEdit = true;
        } else {
          self.accountHolderNameEdit = "";
          self.accholderdisabledEdit = false;
        }
      }, 1000);
    },
    firmChangeEdit: function firmChangeEdit() {
      var self = this;
      setTimeout(function () {
        if (self.accountCategoryEdit == "Firm A/C" && self.currentFirmEdit) {
          self.accountHolderNameEdit = self.firmbyId(self.currentFirmEdit);
          self.accholderdisabledEdit = true;
        } else if (self.accountCategoryEdit == "Prop A/C" && self.currentFirmEdit) {
          self.accountHolderNameEdit = self.propbyId(self.currentFirmEdit);
          self.accholderdisabledEdit = true;
        } else {
          self.accountHolderNameEdit = "";
          self.accholderdisabledEdit = false;
        }
      }, 1000);
    }
  }
});

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_util__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Asset',
  data: function data() {
    return {
      dialog: false,
      items: null,
      bankName: null,
      assetType: null,
      assetCategory: null,
      currentFirm: {
        id: '',
        name: ''
      },
      currentAssetCategory: ['Deposit & Securities', 'Fixed Assets', 'Stocks/SIPS'],
      currentBankName: ['Allahabad Bank', 'Andhra Bank', 'Axis Bank', 'Bandhan Bank', 'Bank of India', 'Bank Of Baroda', 'Bank Of Maharastra', 'Canara Bank', 'Central Bank Of India', 'Corporation Bank', 'Dena Bank', 'DCB bank', 'HDFC bank', 'ICICI Bank', 'Indian Overseas Bank', 'Kotak Mahindra Bank', 'Oriental Bank Of Commerce', 'Punjab National Bank', 'Punjab and Sind Bank', 'State Bank Of India', 'UCO Bank', 'Union Bank Of India', 'Vijaya Bank', 'Yes Bank'],
      currentAssetType: ['Normal', 'Depriciating'],
      assetName: null,
      firms: [],
      initialamount: 0,
      openingBalance: 0,
      ifsccode: null,
      accountLocation: null,
      accountnumber: 0
    };
  },
  created: function created() {
    this.$bindAsArray('firms', this.$root.$firebaseRefs.firm);
    this.$bindAsArray('asset', this.$root.$firebaseRefs.asset);
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand']), {
    getAssetAccount: function getAssetAccount() {
      var _this = this;

      if (this.selectedBrand) {
        return this.asset.filter(function (item) {
          return item['brand'] === _this.selectedBrand;
        });
      }
    },
    assetCount: function assetCount() {
      return this.getAssetAccount.length || 0;
    }
  }),
  methods: {
    firmbyId: function firmbyId(id) {
      return this.firms.filter(function (item) {
        return item['.key'] == id;
      })[0].name;
    },
    addNewAssetAccount: function addNewAssetAccount() {
      var data = {
        brand: this.selectedBrand,
        firm: this.currentFirm,
        // bankName:this.bankName,
        assetCategory: this.assetCategory,
        assetName: this.assetName,
        accountnumber: Number(this.accountnumber),
        // ifsccode:this.ifsccode,
        // accountLocation:this.accountLocation,
        assetType: this.assetType,
        amount: Number(this.initialamount),
        openingBalance: Number(this.openingBalance)
      };
      this.$root.$firebaseRefs.asset.push(data);
      this.addInvoice();
      this.dialog = false;
      this.currentFirm = "";
      this.assetCategory = "";
      this.assetName = null;
      this.assetType = "";
      this.amount = 0;
      this.openingBalance = 0;
      // this.bankName="";
      // this.ifsccode=null;
      // this.accountLocation=null;
      this.accountnumber = 0;
    },
    addInvoice: function addInvoice() {
      var invoiceData = {
        brand: this.selectedBrand,
        type: 'automatic invoice',
        firm: this.currentFirm,
        paymentType: 'bank',
        accountNumber: Number(this.accountnumber),
        isCredited: true,
        totalAmount: Number(this.initialamount),
        openingBalance: Number(this.openingBalance),
        date: Date.now()
      };
      this.$root.$firebaseRefs.invoice.push(invoiceData);
    },
    deleteAssetAccount: function deleteAssetAccount(key) {
      confirm('Are you sure you want to delete this Bank Account') && this.$root.$firebaseRefs.asset.child(key).remove();
    },
    cancelDialog: function cancelDialog() {
      this.dialog = false;
    },
    getFirms: function getFirms() {
      var _this2 = this;

      this.dialog = true;
      var firms = this.firms.filter(function (item) {
        return item['brand'] === _this2.selectedBrand;
      });
      var totalitem = [];
      firms.forEach(function (arrayItem) {
        totalitem.push({
          id: arrayItem['.key'],
          name: arrayItem.name
        });
      });
      this.items = totalitem;
    },
    getAssetAccount: function getAssetAccount() {
      var _this3 = this;

      this.dialog = true;
      var asset = this.asset.filter(function (item) {
        return item['brand'] === _this3.selectedBrand;
      });
      var totalitem = [];
      asset.forEach(function (arrayItem) {
        totalitem.push({
          id: arrayItem['.key'],
          name: arrayItem.name
        });
      });
      this.items = totalitem;
    }
  }
});

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_util__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Loan',
  data: function data() {
    return {
      dialog: false,
      items: null,
      // bankName:null,
      // accountType:null,
      loanCategory: null,
      currentFirm: {
        id: '',
        name: ''
      },
      currentLoanCategory: ['Secure Loan', 'Unsecure Loan'],
      //   currentBankName:[
      //     'Allahabad Bank',
      //     'Andhra Bank',
      //     'Axis Bank',
      //     'Bandhan Bank',
      //     'Bank of India',
      //     'Bank Of Baroda',
      //     'Bank Of Maharastra',
      //     'Canara Bank',
      //     'Central Bank Of India',
      //     'Corporation Bank',
      //     'Dena Bank',
      //     'DCB bank',
      //     'HDFC bank',
      //     'ICICI Bank',
      //     'Indian Overseas Bank',
      //     'Kotak Mahindra Bank',
      //     'Oriental Bank Of Commerce',
      //     'Punjab National Bank',
      //     'Punjab and Sind Bank',
      //     'State Bank Of India',
      //     'UCO Bank',
      //     'Union Bank Of India',
      //     'Vijaya Bank',
      //     'Yes Bank',
      //   ],
      //   currentAccountType:[
      //     'S/A',
      //     'C/A',
      //     'O/D'
      //   ],
      //   ifsccode:null,
      //   accountLocation:null,
      accountHolderName: null,
      accountnumber: 0,
      firms: [],
      openingBalance: 0,
      initialamount: 0
    };
  },
  created: function created() {
    this.$bindAsArray('firms', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('account', this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('loan', this.$root.$firebaseRefs.loan.orderByChild('brand').equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand']), {
    getLoanAccount: function getLoanAccount() {
      var _this = this;

      if (this.selectedBrand) {
        return this.loan.filter(function (item) {
          return item['brand'] === _this.selectedBrand;
        });
      }
    },
    loanCount: function loanCount() {
      return this.getLoanAccount.length || 0;
    }
  }),
  methods: {
    firmbyId: function firmbyId(id) {
      return this.firms.filter(function (item) {
        return item['.key'] == id;
      })[0].name;
    },
    addNewLoanAccount: function addNewLoanAccount() {
      var data = {
        brand: this.selectedBrand,
        firm: this.currentFirm,
        accountHolderName: this.accountHolderName,
        // openingBalance:Number(this.openingBalance),
        amount: Number(this.initialamount),
        loanCategory: this.loanCategory,
        accountnumber: this.accountnumber
        //   bankName:this.bankName,
        //   ifsccode:this.ifsccode,
        //   accountLocation:this.accountLocation,
        //   accountType:this.accountType,
      };
      this.$root.$firebaseRefs.loan.push(data);
      // this.addInvoice();
      this.dialog = false;
      this.currentFirm = "";
      this.accountHolderName = null;
      // this.openingBalance=0;
      this.amount = 0;
      this.accountnumber = 0;
      this.loanCategory = "";
      // this.bankName="";
      // this.ifsccode=null;
      // this.accountType="";
      // this.accountLocation=null;
    },
    addInvoice: function addInvoice() {
      var invoiceData = {
        brand: this.selectedBrand,
        type: 'automatic invoice',
        firm: this.currentFirm,
        paymentType: 'bank',
        accountNumber: this.accountnumber,
        accountHolderName: this.accountHolderName,
        // openingBalance:Number(this.openingBalance),
        isCredited: true,
        totalAmount: Number(this.initialamount),
        date: Date.now()
      };
      this.$root.$firebaseRefs.invoice.push(invoiceData);
    },
    deleteLoanAccount: function deleteLoanAccount(key) {
      confirm('Are you sure you want to delete this Bank Account') && this.$root.$firebaseRefs.loan.child(key).remove();
    },
    cancelDialog: function cancelDialog() {
      this.dialog = false;
    },
    getFirms: function getFirms() {
      var _this2 = this;

      this.dialog = true;
      var firms = this.firms.filter(function (item) {
        return item['brand'] === _this2.selectedBrand;
      });
      var totalitem = [];
      firms.forEach(function (arrayItem) {
        totalitem.push({
          id: arrayItem['.key'],
          name: arrayItem.name
        });
      });
      this.items = totalitem;
    },
    getLoanAccount: function getLoanAccount() {
      var _this3 = this;

      this.dialog = true;
      var loan = this.loan.filter(function (item) {
        return item['brand'] === _this3.selectedBrand;
      });
      var totalitem = [];
      loan.forEach(function (arrayItem) {
        totalitem.push({
          id: arrayItem['.key'],
          name: arrayItem.name
        });
      });
      this.items = totalitem;
    }
  }
});

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_util__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Loanadvances',
  data: function data() {
    return {
      dialog: false,
      items: null,
      //   bankName:null,
      //   accountType:null,
      //   accountCategory:null,
      //   currentFirm:{
      //       id:'',
      //       name:''
      //   },
      //   currentAccountCategory: [
      //     'Firm A/C',
      //     'Prop A/C',
      //     'Normal A/C',        
      //   ],
      //   currentBankName:[
      //     'Allahabad Bank',
      //     'Andhra Bank',
      //     'Axis Bank',
      //     'Bandhan Bank',
      //     'Bank of India',
      //     'Bank Of Baroda',
      //     'Bank Of Maharastra',
      //     'Canara Bank',
      //     'Central Bank Of India',
      //     'Corporation Bank',
      //     'Dena Bank',
      //     'DCB bank',
      //     'HDFC bank',
      //     'ICICI Bank',
      //     'Indian Overseas Bank',
      //     'Kotak Mahindra Bank',
      //     'Oriental Bank Of Commerce',
      //     'Punjab National Bank',
      //     'Punjab and Sind Bank',
      //     'State Bank Of India',
      //     'UCO Bank',
      //     'Union Bank Of India',
      //     'Vijaya Bank',
      //     'Yes Bank',
      //   ],
      //   currentAccountType:[
      //     'S/A',
      //     'C/A',
      //     'O/D'
      //   ],
      //   ifsccode:null,
      //   accountLocation:null,
      accountHolderName: null,
      //   accountnumber:0,
      firms: [],
      openingBalance: 0,
      initialamount: 0
    };
  },
  created: function created() {
    this.$bindAsArray('firms', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('account', this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('loanadvances', this.$root.$firebaseRefs.loanadvances.orderByChild('brand').equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand']), {
    getLoanAdvancesAccount: function getLoanAdvancesAccount() {
      var _this = this;

      if (this.selectedBrand) {
        return this.loanadvances.filter(function (item) {
          return item['brand'] === _this.selectedBrand;
        });
      }
    },
    loanadvancesCount: function loanadvancesCount() {
      return this.getLoanAdvancesAccount.length || 0;
    }
  }),
  methods: {
    firmbyId: function firmbyId(id) {
      return this.firms.filter(function (item) {
        return item['.key'] == id;
      })[0].name;
    },
    addNewLoanAdvancesAccount: function addNewLoanAdvancesAccount() {
      var data = {
        brand: this.selectedBrand,
        firm: this.currentFirm,
        accountHolderName: this.accountHolderName,
        openingBalance: this.openingBalance,
        amount: this.initialamount
        //   bankName:this.bankName,
        //   accountCategory:this.accountCategory,
        //   accountnumber:this.accountnumber,
        //   ifsccode:this.ifsccode,
        //   accountLocation:this.accountLocation,
        //   accountType:this.accountType,
      };
      this.$root.$firebaseRefs.loanadvances.push(data);
      // this.addInvoice();
      this.dialog = false;
      this.currentFirm = "";
      this.accountHolderName = null;
      this.openingBalance = 0;
      this.amount = 0;
      // this.bankName="";
      // this.accountCategory="";
      // this.ifsccode=null;
      // this.accountType="";
      // this.accountLocation=null;
      // this.accountnumber=0;
    },

    // addInvoice(){
    //   let invoiceData = {
    //       brand: this.selectedBrand,
    //       type:'automatic invoice',
    //       firm:this.currentFirm,
    //       paymentType:'bank',
    //       accountNumber:this.accountnumber,
    //       isCredited:true,
    //       totalAmount:Number(this.initialamount),
    //       date:Date.now()
    //   }
    //   this.$root.$firebaseRefs.invoice.push(invoiceData);
    // },
    deleteLoanAccount: function deleteLoanAccount(key) {
      confirm('Are you sure you want to delete this Loan&Advances Account') && this.$root.$firebaseRefs.loanadvances.child(key).remove();
    },
    cancelDialog: function cancelDialog() {
      this.dialog = false;
    },
    getFirms: function getFirms() {
      var _this2 = this;

      this.dialog = true;
      var firms = this.firms.filter(function (item) {
        return item['brand'] === _this2.selectedBrand;
      });
      var totalitem = [];
      firms.forEach(function (arrayItem) {
        totalitem.push({
          id: arrayItem['.key'],
          name: arrayItem.name
        });
      });
      this.items = totalitem;
    },
    getLoanAdvancesAccount: function getLoanAdvancesAccount() {
      var _this3 = this;

      this.dialog = true;
      var loanadvances = this.loanadvances.filter(function (item) {
        return item['brand'] === _this3.selectedBrand;
      });
      var totalitem = [];
      loanadvances.forEach(function (arrayItem) {
        totalitem.push({
          id: arrayItem['.key'],
          name: arrayItem.name
        });
      });
      this.items = totalitem;
    }
  }
});

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_util__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Godawn',
  data: function data() {
    return {
      dialog: false,
      dialogEdit: false,
      items: null,
      currentFirm: "",
      godawnName: null,
      godawnAddress: null,
      godawnPincode: null,
      godawnNameEdit: null,
      godawnAddressEdit: null,
      godawnPincodeEdit: null,
      snackbarSuccessText: null,
      snackbarText: null,
      snackbar: false,
      snackbarSuccess: false,
      itemsEdit: null
    };
  },
  created: function created() {
    this.$bindAsArray('firms', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('account', this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('godawn', this.$root.$firebaseRefs.godawn.orderByChild('brand').equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand']), {
    getGodawnAccount: function getGodawnAccount() {
      var _this = this;

      if (this.selectedBrand) {
        return this.godawn.filter(function (item) {
          return item['brand'] === _this.selectedBrand && item['firm'] != '';
        });
      }
    },
    godawnCount: function godawnCount() {
      return this.getGodawnAccount.length || 0;
    }
  }),
  methods: {
    firmbyId: function firmbyId(id) {
      return this.firms.filter(function (item) {
        return item['.key'] == id;
      })[0].name;
    },
    addNewGodawnAccount: function addNewGodawnAccount() {
      var data = {
        brand: this.selectedBrand,
        godawnName: this.godawnName,
        godawnAddress: this.godawnAddress,
        godawnPincode: this.godawnPincode
      };

      if (data.godawnName == null || data.godawnName == "") {
        this.snackbar = true;
        this.snackbarText = 'Enter Godawn Name';
        return false;
      }

      this.$root.$firebaseRefs.godawn.push(data);
      // this.addInvoice();
      this.dialog = false;
      this.godawnName = null;
      this.godawnAddress = null;
      this.godawnPincode = null;
    },
    editGodawnAccount: function editGodawnAccount(key) {
      var _this2 = this;

      this.dialogEdit = true;
      console.log(key);
      var firms = this.firms.filter(function (item) {
        return item['brand'] === _this2.selectedBrand;
      });
      var totalitem = [];
      firms.forEach(function (arrayItem) {
        totalitem.push({
          id: arrayItem['.key'],
          name: arrayItem.name
        });
      });
      this.itemsEdit = totalitem;

      this.dialogEdit = true;
      this.godawnNameEdit = key.godawnName;
      this.godawnAddressEdit = key.godawnAddress;
      this.godawnPincodeEdit = key.godawnPincode;
      this.updateKey = key['.key'];
    },
    updateNewGodawnAccount: function updateNewGodawnAccount() {
      var data = {
        brand: this.selectedBrand,
        godawnName: this.godawnNameEdit,
        godawnAddress: this.godawnAddressEdit,
        godawnPincode: this.godawnPincodeEdit
      };
      this.$root.$firebaseRefs.godawn.child(this.updateKey).update({
        brand: this.selectedBrand,
        godawnName: this.godawnNameEdit,
        godawnAddress: this.godawnAddressEdit,
        godawnPincode: this.godawnPincodeEdit
      });
      // this.addInvoice();
      this.godawnNameEdit = "";
      this.godawnAddressEdit = "";
      this.godawnPincodeEdit = "";
      this.cancelDialogEdit();
    },
    deleteGodawnAccount: function deleteGodawnAccount(key) {
      confirm('Are you sure you want to delete this Godawn Account') && this.$root.$firebaseRefs.godawn.child(key).remove();
    },
    cancelDialog: function cancelDialog() {
      this.dialog = false;
    },
    cancelDialogEdit: function cancelDialogEdit() {
      this.dialogEdit = false;
    },
    getFirms: function getFirms() {
      var _this3 = this;

      this.dialog = true;
      var firms = this.firms.filter(function (item) {
        return item['brand'] === _this3.selectedBrand;
      });
      var totalitem = [];
      firms.forEach(function (arrayItem) {
        totalitem.push({
          id: arrayItem['.key'],
          name: arrayItem.name
        });
      });
      this.items = totalitem;
      this.itemsEdit = totalitem;
    },
    getGodawnAccount: function getGodawnAccount() {
      var _this4 = this;

      this.dialog = true;
      var godawn = this.godawn.filter(function (item) {
        return item['brand'] === _this4.selectedBrand;
      });
      var totalitem = [];
      godawn.forEach(function (arrayItem) {
        totalitem.push({
          id: arrayItem['.key'],
          name: arrayItem.name
        });
      });
      this.items = totalitem;
    }
  }
});

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBuyer: true,
      search: null,
      defaultFirm: null,
      compositionSuggestions: [],
      suggestionAdded: false,
      transferDialog: false,
      viewBatchDialog: false,
      batchDialog: false,
      damageDialog: false,
      stepper: 1,
      isBankDetails: false,
      isProfessionalDetails: false,
      isSalaryDetails: false,
      isDocumentAvailable: false,
      addHrDialog: false,
      hrToTansfer: null,
      hrToBatch: null,
      hrToDamage: null,
      datepickerTransfer: false,
      datepickerBatch: false,
      todatepickerBatch: false,
      datepickerDamage: false,
      currentGodawn: null,
      transferQuantity: 0,
      batchQuantity: 0,
      damageQuantity: 0,
      batchNumber: "",
      brand: {},
      datepicker: false,
      datepicker1: false,
      duplicateError: null,
      currentHr: {
        name: "",
        fatherName: "",
        motherName: "",
        guardianName: "",
        age: 0,
        gender: "",
        description: "",
        currentAddressDescription: "",
        currentPermanentDescription: "",
        currentWorkShift: "",
        currentAccountType: "",
        currentBankName: "",
        currentEmployeeQualification: "",
        currentContractType: "",
        employerName: "",
        StaffId: 0,
        Designation: "",
        staffDesignationCategory: "",
        unit: "",
        quantity: 0,
        brand: "",
        dateOfJoining: new Date().toISOString().substr(0, 10),
        dateOfBirth: new Date().toISOString().substr(0, 10),
        purchasingPrice: null,
        sellingPrice: null,
        openingBalance: null,
        gstValue: 0,
        basicPrice: 0,
        barcode: "",
        basicSalary: 0,
        netSalary: 0,
        generalConveyance: 0,
        specialConveyance: 0,
        medicalConveyance: 0,
        casualLeave: 0,
        epfAmount: 0,
        esiAmount: 0,
        tdsAmount: 0,
        professionalTaxAmount: 0,

        bankName: "",
        accountNumber: "",
        accountType: "",
        accountHolderName: "",
        accountLocation: "",
        ifsccode: "",

        hrGroup: null,

        mobile: {
          value: "",
          rules: [function (v) {
            if (!v) {
              return true;
            } else {
              return (/^$/.test(v) || /^(\+91|\+91\-|0)?[6789]\d{9}$/.test(v) || "Mobile number is wrong"
              );
            }
          }]
        },

        email: {
          value: "",
          rules: [function (v) {
            if (!v) {
              return true;
            } else {
              return (/^$/.test(v) || /.@./.test(v) || "E-mail must be valid"
              );
            }
          }]
        },

        unitsDetails: [{
          unit: '',
          isLast: true,
          isFirst: true,
          order: 1,
          quantity: 0,
          rate: true
        }],
        unitsDeatilsAdded: false
      },
      timeout: 3000,
      snackbar: false,
      hrList: [],
      hrPreviousList: [],
      hrListHeader: [{ text: "Name - Description", value: "Name" }, { text: "Age", value: "age" }, { text: "Role", value: "quantity" }, { text: "Department", value: "quantity" }, { text: "Designation", value: "quantity" }, { text: "Basic Salary", value: "quantity" }, { text: "Net Salary", value: "quantity" }, { text: "EPF Amount", value: "quantity" }, { text: "ESI Amount", value: "transfer" }, { text: "TDS Amount", value: "transfer" }, { text: "Pro Tax Amount", value: "edit" }, { text: "HRA Amount", value: "delete" }, { text: "General Con", value: "transfer" }, { text: "Special Con", value: "quantity" }, { text: "Medical Con", value: "quantity" }, { text: "Bank Name", value: "transfer" }, { text: "Account Holder Name", value: "edit" }, { text: "Account Number", value: "delete" }, { text: "Account Type", value: "transfer" }, { text: "Account Location", value: "quantity" }, { text: "IFSC Code", value: "quantity" }, { text: "Mobile No", value: "quantity" }, { text: "Email", value: "quantity" }, { text: "Address", value: "quantity" }, { text: "Transfer", value: "transfer" }, { text: "Batch", value: "transfer" }, { text: "Edit", value: "edit" }, { text: "Delete", value: "delete" }, { text: "Action", value: "transfer" }],
      hrListHeaderByBatch: [{ text: "Batch", value: "batch" }, { text: "Manufacturing Date", value: "manuDate" }, { text: "Expiry Date", value: "expiryDate" }, { text: "Quantity", value: "quantity" }],
      Designations: [{
        text: "Accountant",
        value: "Accountant"
      }, {
        text: "Conductor",
        value: "Conductor"
      }, {
        text: "DataEntry Operator",
        value: "DataEntryOperator"
      }, {
        text: "Driver",
        value: "Driver"
      }, {
        text: "Librarian",
        value: "Librarian"
      }, {
        text: "Warden",
        value: "Warden"
      }, {
        text: "Manager",
        value: "Manager"
      }, {
        text: "Peon",
        value: "Peon"
      }, {
        text: "Staff",
        value: "Staff"
      }, {
        text: "Supervisor",
        value: "Supervisor"
      }, {
        text: "Teacher",
        value: "Teacher"
      }],
      age: {
        value: ""
      },
      workExperience: {
        value: ""
      },
      gender: {
        value: ""
      },
      marital: {
        value: ""
      },
      identityType: {
        value: ""
      },
      identityNumber: {
        value: ""
      },
      mobile: {
        value: "",
        rules: [function (v) {
          if (!v) {
            return true;
          } else {
            return (/^$/.test(v) || /^(\+91|\+91\-|0)?[6789]\d{9}$/.test(v) || "Mobile number is wrong"
            );
          }
        }]
      },
      email: {
        value: "",
        rules: [function (v) {
          if (!v) {
            return true;
          } else {
            return (/^$/.test(v) || /.@./.test(v) || "E-mail must be valid"
            );
          }
        }]
      },
      bachList: [],
      batchSelectedHr: null,
      bankName: null,
      accountType: null,
      accholderdisabled: false,
      contractType: null,
      workShift: null,
      employeeQualification: null,
      accountCategory: null,
      currentBankName: ['Allahabad Bank', 'Andhra Bank', 'Axis Bank', 'Bandhan Bank', 'Bank of India', 'Bank Of Baroda', 'Bank Of Maharastra', 'Canara Bank', 'Central Bank Of India', 'Corporation Bank', 'Dena Bank', 'DCB bank', 'Google Pay', 'HDFC bank', 'ICICI Bank', 'Indian Overseas Bank', 'Kotak Mahindra Bank', 'Oriental Bank Of Commerce', 'Paytm', 'Phone Pe', 'Punjab National Bank', 'Punjab and Sind Bank', 'State Bank Of India', 'UCO Bank', 'Union Bank Of India', 'Vijaya Bank', 'Yes Bank'],
      currentAccountType: ['Saving A/C', 'Current A/C', 'Overdraft A/C', 'Loan A/C'],
      currentContractType: ['Permanent', 'Contractual', 'Temporary', 'Extra'],
      currentWorkShift: ['Day', 'Afternoon', 'Evening', 'Night'],
      currentEmployeeQualification: ['Option 1', 'Option 2', 'Option 3'],
      IFSC_Rules: [function (v) {
        // let reg = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
        var reg = /^([a-zA-Z]){4}([0]){1}([a-zA-Z0-9]){6}?$/;
        return v == undefined || /^$/.test(v) || reg.test(v) || "IFSC must be Valid";
      }],
      ifsccode: null,
      accountLocation: null,
      accountHolderName: null,
      accountnumber: null,
      epfnumber: null,
      basicSalary: null
    };
  },
  created: function created() {
    this.$bindAsArray("hrList", this.$root.$firebaseRefs.hrs.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("hrPreviousList", this.$root.$firebaseRefs.hrs.orderByChild('brand').equalTo(this.selectedBrand));
    // this.$bindAsObject('brands',this.$root.$firebaseRefs.brand.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsArray("godawns", this.$root.$firebaseRefs.godawn.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("godawnTrans", this.$root.$firebaseRefs.godawnTransaction.orderByChild('brand').equalTo(this.selectedBrand));
    // this.$bindAsArray('hrGroups', this.$root.$firebaseRefs.hrGroup)
    this.$bindAsArray("batch", this.$root.$firebaseRefs.batchTransaction.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("damage", this.$root.$firebaseRefs.damageTransaction.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    if (this.$route.params.isNew) {
      this.addHr();
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear", "roleAndPermission"]), mapGlobalGetters({ units: "hrUnit" }), mapGlobalGetters({
    gIdentityType: "identityType",
    gVillage: "village",
    gBlock: "block",
    gTehsil: "tehsil",
    gDistrict: "district",
    gState: "state",
    gCountry: "country",
    gGender: "gender",
    gMarital: "marital"
  }), {
    firmsByBrand: function firmsByBrand() {
      var _this = this;

      var firmsB = this.firms.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      }).map(function (item) {
        if (item.defaultFirm) {
          _this.defaultFirm = item[".key"];
          _this.currentHr.businessType = item["businessType"];
        }
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
      return firmsB;
    },
    hasHrAddPermission: function hasHrAddPermission() {
      if (this.roleAndPermission && this.roleAndPermission.permissions && this.roleAndPermission.permissions.length && this.roleAndPermission.permissions.indexOf('PRODUCT_ADD') > -1) {
        return true;
      } else {
        return false;
      }
    },
    hasHrEditPermission: function hasHrEditPermission() {
      if (this.roleAndPermission && this.roleAndPermission.permissions && this.roleAndPermission.permissions.length && this.roleAndPermission.permissions.indexOf('PRODUCT_EDIT') > -1) {
        return true;
      } else {
        return false;
      }
    },
    hasHrDeletePermission: function hasHrDeletePermission() {
      if (this.roleAndPermission && this.roleAndPermission.permissions && this.roleAndPermission.permissions.length && this.roleAndPermission.permissions.indexOf('PRODUCT_DELETE') > -1) {
        return true;
      } else {
        return false;
      }
    },
    hasHrTransferPermission: function hasHrTransferPermission() {
      if (this.roleAndPermission && this.roleAndPermission.permissions && this.roleAndPermission.permissions.length && this.roleAndPermission.permissions.indexOf('PRODUCT_TRANSFER') > -1) {
        return true;
      } else {
        return false;
      }
    },
    identityNumeberError: function identityNumeberError() {
      if (this.identityNumber.value) {
        var error = null;
        switch (this.identityType.value) {
          case "Voter ID":
            // 3 alpha, 7 digit 
            error = /^([a-zA-Z]){3}([0-9]){7}?$/g.test(this.identityNumber.value) ? null : 'Enter valid Voter ID';
            break;
          case "Adhaar ID":
            // 16 or 12 digit number 
            error = /^(\d{16}|\d{12})$/g.test(Number(this.identityNumber.value)) ? null : 'Enter valid Adhaar ID';
            break;
          case "Driving License":
            // 2 alpha, 2 digit, 4 digit, 7 digit  
            error = /^([a-zA-Z]{2})(\d{2})(\d{4})(\d{7})$/g.test(this.identityNumber.value) ? null : 'Enter valid Driving License';
            break;
          case "Pan Card":
            // 5 alpha, 4 digit, 1 alpha 
            error = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}$/g.test(this.identityNumber.value) ? null : 'Enter valid PAN Card';
            break;
          case "Samagra Id":
            // 9 digit number  
            error = /^(\d{9})$/g.test(Number(this.identityNumber.value)) ? null : 'Enter valid Samagra ID';
            break;
          default:
            error = 'Select Identity type';
            break;
        }
        return error;
      }
    },
    hrListByBrand: function hrListByBrand() {
      var _this2 = this;

      var prod = this.hrList.filter(function (item) {
        return item["brand"] === _this2.selectedBrand
        // && (item.dateOfJoining ? (item.dateOfJoining >= this.finYear.start) && (item.dateOfJoining <= this.finYear.end) : true) 
        && (!!_this2.search ? !!item["name"].toLowerCase().includes(_this2.search.toLowerCase()) : true);
      });
      if (!this.suggestionAdded) {
        this.compositionSuggestions = [];
      }
      prod.map(function (p) {
        if (!_this2.suggestionAdded) {
          if (p.composition && _this2.compositionSuggestions.indexOf(p.composition) == -1) {
            _this2.compositionSuggestions.push(p.composition);
          }
        }
        if (p.unitsDeatilsAdded) {
          p['openingQuantityTitle'] = _this2.getFilteredQuantity(p, p['openingQuantity']);
          p['purchaseQuantityTitle'] = _this2.getFilteredQuantity(p, p['purchaseQuantity']);
          p['saleQuantityTitle'] = _this2.getFilteredQuantity(p, p['saleQuantity']);
          p['closingQuantityTitle'] = _this2.getFilteredQuantity(p, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(p['openingQuantity']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(p['purchaseQuantity']) - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(p['saleQuantity']));
        }
      });
      return prod;
    }
  }),
  methods: {
    capitalize: function capitalize(s) {
      s = s.toLowerCase();
      if (typeof s !== 'string') return '';
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
    getBankDetailsFromIFSC: function getBankDetailsFromIFSC(isEdit) {
      var _this3 = this;

      var ifsc = isEdit ? this.ifsccodeEdit : this.ifsccode;
      var reg = /^([a-zA-Z]){4}([0]){1}([a-zA-Z0-9]){6}?$/;
      console.log(ifsc);
      if (ifsc && reg.test(ifsc)) {
        console.log("change");
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('https://ifsc.razorpay.com/' + ifsc).then(function (response) {
          _this3.gState.push(_this3.capitalize(response.data.STATE));
          _this3.gDistrict.push(_this3.capitalize(response.data.DISTRICT));
          _this3.gTehsil.push(_this3.capitalize(response.data.CITY));
          setTimeout(function () {
            _this3.country.value = 'India';
            _this3.district.value = _this3.capitalize(response.data.DISTRICT);
            _this3.state.value = _this3.capitalize(response.data.STATE);
            _this3.tehsil.value = _this3.capitalize(response.data.CITY);
          }, 100);
          if (isEdit) {
            _this3.accountLocationEdit = response.data.BRANCH + " " + response.data.ADDRESS;
          } else {
            _this3.accountLocation = response.data.BRANCH + " " + response.data.ADDRESS;
          }
        });
      }
    },
    duplicateCheck: function duplicateCheck() {
      var _this4 = this;

      var duplicateCheck = this.hrList.filter(function (item) {
        return item["brand"] === _this4.selectedBrand && item['name'] == _this4.currentHr.name;
      });
      if (duplicateCheck.length) {
        this.duplicateError = 'Hr with name ' + this.currentHr.name + ' Already exist.';
        setTimeout(function () {
          _this4.duplicateError = null;
        }, 3000);
      }
    },
    saveHr: function saveHr() {
      var _this5 = this;

      if (this.currentHr.unitsDeatilsAdded) {
        this.currentHr.unit = this.getLastUnit;
      } else {
        delete this.currentHr['unitsDetails'];
      }
      var duplicateCheck = this.hrList.filter(function (item) {
        return item["brand"] === _this5.selectedBrand && item['name'] == _this5.currentHr.name;
      });
      console.log(duplicateCheck);
      if (duplicateCheck.length) {
        this.duplicateError = 'Hr with name ' + this.currentHr.name + ' Already exist.';
        setTimeout(function () {
          _this5.duplicateError = null;
        }, 3000);
      } else {
        this.currentHr["brand"] = this.selectedBrand;

        this.currentHr["name"] = this.currentHr.name;
        this.currentHr["fatherName"] = this.currentHr.fatherName;
        this.currentHr["motherName"] = this.currentHr.motherName;
        this.currentHr["guardianName"] = this.currentHr.guardianName;

        this.currentHr["employerName"] = this.currentHr.employerName;

        this.currentHr["age"] = this.currentHr.age;
        this.currentHr["gender"] = this.currentHr.gender;
        this.currentHr["mobile"] = this.currentHr.mobile;
        this.currentHr["email"] = this.currentHr.email;

        this.currentHr["bankName"] = this.currentHr.bankName;
        this.currentHr["accountType"] = this.currentHr.accountType;
        this.currentHr["accountNumber"] = this.currentHr.accountNumber;
        this.currentHr["accountHolderName"] = this.currentHr.accountHolderName;
        // this.currentHr["accountLocation"] = this.currentHr.accountLocation;
        // this.currentHr["ifsccode"] = this.currentHr.ifsccode;

        this.currentHr["StaffId"] = this.currentHr.StaffId;
        this.currentHr["staffDesignationCategory"] = this.currentHr.staffDesignationCategory;
        this.currentHr.purchaseQuantity = 0;
        this.currentHr.saleQuantity = 0;
        this.currentHr.openingQuantity = this.currentHr.quantity;
        this.currentHr.dateOfJoining = new Date(this.currentHr.dateOfJoining).getTime();
        this.currentHr.dateOfBirth = new Date(this.currentHr.dateOfBirth).getTime();
        delete this.currentHr['openingQuantityTitle'];
        delete this.currentHr['purchaseQuantityTitle'];
        delete this.currentHr['saleQuantityTitle'];
        delete this.currentHr['closingQuantityTitle'];
        this.$root.$firebaseRefs.hrs.push(this.currentHr);
        this.addHrDialog = false;
        this.snackbar = true;
      }
    },
    keymonitor: function keymonitor(event) {
      this.search = event.target.value;
    },
    addHr: function addHr() {
      this.stepper = 1;
      this.currentHr = {
        firm: this.defaultFirm,
        name: "",
        fatherName: "",
        motherName: "",
        guardianName: "",
        employerName: "",
        age: 0,
        gender: "",
        marital: "",
        description: "",
        currentAddressDescription: "",
        currentAccountType: "",
        currentBankName: "",
        currentContractType: "",
        currentWorkShift: "",
        currentEmployeeQualification: "",
        currentPermanentDescription: "",
        StaffId: 0,
        Designation: "",
        staffDesignationCategory: "",
        barcode: "",
        hrGroup: null,
        unit: "",
        quantity: 0,
        batchNumber: "",
        dateOfJoining: new Date().toISOString().substr(0, 10),
        dateOfBirth: new Date().toISOString().substr(0, 10),
        brand: "",
        basicPrice: 0,
        gstValue: 0,
        purchasingPrice: null,
        sellingPrice: null,
        openingBalance: null,
        purchasingPricePerHr: null,
        basicSalary: 0,
        netSalary: 0,
        generalConveyance: 0,
        medicalConveyance: 0,
        specialConveyance: 0,
        casualLeave: 0,
        epfAmount: 0,
        esiAmount: 0,
        tdsAmunt: 0,
        professionalTaxAmount: 0,
        unitsDetails: [{
          unit: '',
          isLast: true,
          isFirst: true,
          order: 1,
          quantity: 0
        }]
      };
      this.addHrDialog = true;
    },
    updateHr: function updateHr() {
      if (this.currentHr.unitsDeatilsAdded) {
        this.currentHr.unit = this.getLastUnit;
      } else {
        delete this.currentHr['unitsDetails'];
      }
      var key = this.currentHr[".key"];
      delete this.currentHr[".key"];
      this.currentHr.dateOfJoining = new Date(this.currentHr.dateOfJoining).getTime();
      this.currentHr.dateOfBirth = new Date(this.currentHr.dateOfBirth).getTime();
      this.currentHr.openingQuantity = this.currentHr.quantity;

      this.currentHr["name"] = this.currentHr.name;
      this.currentHr["fatherName"] = this.currentHr.fatherName;
      this.currentHr["motherName"] = this.currentHr.motherName;
      this.currentHr["guardianName"] = this.currentHr.guardianName;

      this.currentHr["employerName"] = this.currentHr.employerName;

      this.currentHr["age"] = this.currentHr.age;
      this.currentHr["gender"] = this.currentHr.gender;
      this.currentHr["StaffId"] = this.currentHr.StaffId;
      this.currentHr["marital"] = this.currentHr.marital;
      this.currentHr["mobile"] = this.currentHr.mobile;
      this.currentHr["email"] = this.currentHr.email;

      this.currentHr["bankName"] = this.currentHr.bankName;
      this.currentHr["accountType"] = this.currentHr.accountType;
      this.currentHr["accountNumber"] = this.currentHr.accountNumber;
      this.currentHr["accountHolderName"] = this.currentHr.accountHolderName;
      this.currentHr["accountLocation"] = this.currentHr.accountLocation;
      this.currentHr["ifsccode"] = this.currentHr.ifsccode;

      this.currentHr.quantity = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.currentHr.openingQuantity) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.currentHr.purchaseQuantity) - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.currentHr.saleQuantity);
      delete this.currentHr['openingQuantityTitle'];
      delete this.currentHr['purchaseQuantityTitle'];
      delete this.currentHr['saleQuantityTitle'];
      delete this.currentHr['closingQuantityTitle'];
      this.$root.$firebaseRefs.hrs.child(key).set(this.currentHr);
      this.currentHr = {
        name: "",
        fatherName: "",
        motherName: "",
        guardianName: "",
        employerName: "",
        age: "",
        gender: "",
        description: "",
        currentAddressDescription: "",
        currentPermanentDescription: "",
        currentAccountType: "",
        currentContractType: "",
        contractType: "",
        currentWorkShift: "",
        workShift: "",
        employeeQualification: "",
        currentEmployeeQualification: "",
        currentBankName: "",
        StaffId: 0,
        Designation: "",
        staffDesignationCategory: 0,
        barcode: "",
        quantity: 0,
        unit: "",
        dateOfJoining: new Date().toISOString().substr(0, 10),
        brand: "",
        basicPrice: 0,
        gstValue: 0,
        purchasingPrice: null,
        sellingPrice: null,
        openingBalance: null,
        basicSalary: 0,
        netSalary: 0,
        generalConveyance: 0,
        medicalConveyance: 0,
        specialConveyance: 0,
        casualLeave: 0,
        epfAmount: 0,
        esiAmount: 0,
        tdsAmunt: 0,
        professionalTaxAmount: 0
      };
      this.addHrDialog = false;
      this.snackbar = true;
    },
    editHr: function editHr(hr) {
      this.currentHr = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(hr));
      this.currentHr.dateOfJoining = this.currentHr.dateOfJoining ? new Date(this.currentHr.dateOfJoining).toISOString().substr(0, 10) : new Date().toISOString().substr(0, 10);
      this.currentHr.quantity = this.currentHr.openingQuantity;

      this.currentHr.name = this.currentHr.name;
      this.currentHr.fatherName = this.currentHr.fatherName;
      this.currentHr.motherName = this.currentHr.motherName;
      this.currentHr.guardianName = this.currentHr.guardianName;

      this.currentHr.employerName = this.currentHr.employerName;

      this.currentHr.age = this.currentHr.age;
      this.currentHr.gender = this.currentHr.gender;
      this.currentHr.mobile = this.currentHr.mobile;
      this.currentHr.email = this.currentHr.email;
      this.currentHr.marital = this.currentHr.marital;
      this.currentHr.StaffId = this.currentHr.StaffId;
      this.currentHr.name = this.currentHr.name;
      this.currentHr.basicSalary = this.currentHr.basicSalary;
      this.currentHr.netSalary = this.currentHr.netSalary;
      this.currentHr.generalConveyance = this.currentHr.generalConveyance;
      this.currentHr.specialConveyance = this.currentHr.specialConveyance;
      this.currentHr.medicalConveyance = this.currentHr.medicalConveyance;
      this.currentHr.epfAmount = this.currentHr.epfAmount;
      this.currentHr.esiAmount = this.currentHr.esiAmount;
      this.currentHr.professionalTaxAmount = this.currentHr.professionalTaxAmount;
      this.currentHr.tdsAmunt = this.currentHr.tdsAmunt;
      this.currentHr.casualLeave = this.currentHr.casualLeave;
      this.currentHr.bankName = this.currentHr.bankName;
      this.currentHr.accountType = this.currentHr.accountType;
      this.currentHr.accountNumber = this.currentHr.accountNumber;
      this.currentHr.accountHolderName = this.currentHr.accountHolderName;
      // this.currentHr.accountLocation = this.currentHr.accountLocation;
      // this.currentHr.ifsccode = this.currentHr.ifsccode;
      this.addHrDialog = true;
      if (!this.currentHr.unitsDeatilsAdded) {
        this.currentHr.unitsDetails = [{
          unit: '',
          isLast: true,
          isFirst: true,
          order: 1,
          quantity: 0
        }];
      }
    },
    deleteHr: function deleteHr(hr) {
      if (window.confirm("Do you want to Delete " + hr.name + "?")) {
        this.$root.$firebaseRefs.hrs.child(hr[".key"]).remove();
      }
    }
  },
  watch: {
    "currentHr.Designation": {
      handler: function handler(newVal, oldVal) {
        if (newVal != "Teacher") {
          this.currentHr.staffDesignationCategory = 0;
        }
      },

      deep: true
    }
    //  "currentHr.basicPrice": {
    //   handler(newVal, oldVal) {
    //     if (newVal != oldVal) {
    //       this.calculateOpeningBalance();
    //     }
    //   },
    //   deep: true
    // },
    // "currentHr.firm": {
    //   handler(newVal, oldVal) {
    //     if (newVal != oldVal) {
    //       this.getBusinessType();
    //     }
    //   },
    //   deep: true
    // },
    // "currentHr.gstValue": {
    //   handler(newVal, oldVal) {
    //     if (newVal != oldVal) {
    //       this.calculateOpeningBalance();
    //     }
    //   },
    //   deep: true
    // }
  }
});

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      items1: ['All', 'Teacher', 'Peon', 'Manager', 'Accountant', 'Operator', 'Driver', 'Conductor', 'IT Department', 'Admin'],
      items2: ['January', 'Februry', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      isBuyer: true,
      search: null,
      defaultFirm: null,
      compositionSuggestions: [],
      suggestionAdded: false,
      transferDialog: false,
      viewBatchDialog: false,
      batchDialog: false,
      damageDialog: false,
      stepper: 1,
      isBankDetails: false,
      isProfessionalDetails: false,
      isSalaryDetails: false,
      isDocumentAvailable: false,
      addHrDialog: false,
      hrToTansfer: null,
      hrToBatch: null,
      hrToDamage: null,
      datepickerTransfer: false,
      datepickerBatch: false,
      todatepickerBatch: false,
      datepickerDamage: false,
      currentGodawn: null,
      transferQuantity: 0,
      batchQuantity: 0,
      damageQuantity: 0,
      batchNumber: "",
      brand: {},
      datepicker: false,
      datepicker1: false,
      duplicateError: null,
      //   transferDate : new Date().toISOString().substr(0, 10),
      //   manufacuturingDate : new Date().toISOString().substr(0, 10),
      //   expiryDate : new Date().toISOString().substr(0, 10),
      //   damageDate : new Date().toISOString().substr(0, 10),
      currentHr: {
        name: "",
        age: 0,
        gender: "",
        description: "",
        currentAddressDescription: "",
        currentPermanentDescription: "",
        currentWorkShift: "",
        currentAccountType: "",
        currentBankName: "",
        currentEmployeeQualification: "",
        currentContractType: "",
        StaffId: 0,
        Designation: "",
        staffDesignationCategory: "",
        unit: "",
        quantity: 0,
        brand: "",
        dateOfJoining: new Date().toISOString().substr(0, 10),
        dateOfBirth: new Date().toISOString().substr(0, 10),
        purchasingPrice: null,
        sellingPrice: null,
        openingBalance: null,
        gstValue: 0,
        basicPrice: 0,
        barcode: "",
        basicSalary: 0,
        netSalary: 0,
        generalConveyance: 0,
        specialConveyance: 0,
        medicalConveyance: 0,
        casualLeave: 0,
        epfAmount: 0,
        esiAmount: 0,
        tdsAmount: 0,
        professionalTaxAmount: 0,

        bankName: "",
        accountNumber: "",
        accountType: "",
        accountHolderName: "",
        accountLocation: "",
        ifsccode: "",

        hrGroup: null,

        mobile: {
          value: "",
          rules: [function (v) {
            if (!v) {
              return true;
            } else {
              return (/^$/.test(v) || /^(\+91|\+91\-|0)?[6789]\d{9}$/.test(v) || "Mobile number is wrong"
              );
            }
          }]
        },

        email: {
          value: "",
          rules: [function (v) {
            if (!v) {
              return true;
            } else {
              return (/^$/.test(v) || /.@./.test(v) || "E-mail must be valid"
              );
            }
          }]
        },

        unitsDetails: [{
          unit: '',
          isLast: true,
          isFirst: true,
          order: 1,
          quantity: 0,
          rate: true
        }],
        unitsDeatilsAdded: false
      },
      timeout: 3000,
      snackbar: false,
      hrList: [],
      hrListHeader: [{ text: "Name - Description", value: "Name" }, { text: "Age", value: "age" }, { text: "Role", value: "quantity" }, { text: "Department", value: "quantity" }, { text: "Designation", value: "quantity" }, { text: "Basic Salary", value: "quantity" }, { text: "Net Salary", value: "quantity" }, { text: "EPF Amount", value: "quantity" }, { text: "ESI Amount", value: "transfer" }, { text: "TDS Amount", value: "transfer" }, { text: "Pro Tax Amount", value: "edit" }, { text: "HRA Amount", value: "delete" }, { text: "General Con", value: "transfer" }, { text: "Special Con", value: "quantity" }, { text: "Medical Con", value: "quantity" }, { text: "Bank Name", value: "transfer" }, { text: "Account Holder Name", value: "edit" }, { text: "Account Number", value: "delete" }, { text: "Account Type", value: "transfer" }, { text: "Account Location", value: "quantity" }, { text: "IFSC Code", value: "quantity" }, { text: "Mobile No", value: "quantity" }, { text: "Email", value: "quantity" }, { text: "Address", value: "quantity" }, { text: "Transfer", value: "transfer" }, { text: "Batch", value: "transfer" }, { text: "Edit", value: "edit" }, { text: "Delete", value: "delete" }, { text: "Action", value: "transfer" }],
      hrListHeaderByBatch: [{ text: "Batch", value: "batch" }, { text: "Manufacturing Date", value: "manuDate" }, { text: "Expiry Date", value: "expiryDate" }, { text: "Quantity", value: "quantity" }],
      Designations: [{
        text: "Accountant",
        value: "Accountant"
      }, {
        text: "Conductor",
        value: "Conductor"
      }, {
        text: "DataEntry Operator",
        value: "DataEntryOperator"
      }, {
        text: "Driver",
        value: "Driver"
      }, {
        text: "Manager",
        value: "Manager"
      }, {
        text: "Peon",
        value: "Peon"
      }, {
        text: "Staff",
        value: "Staff"
      }, {
        text: "Supervisor",
        value: "Supervisor"
      }, {
        text: "Teacher",
        value: "Teacher"
      }],
      age: {
        value: ""
      },
      workExperience: {
        value: ""
      },
      gender: {
        value: ""
      },
      marital: {
        value: ""
      },
      identityType: {
        value: ""
      },
      identityNumber: {
        value: ""
      },
      mobile: {
        value: "",
        rules: [function (v) {
          if (!v) {
            return true;
          } else {
            return (/^$/.test(v) || /^(\+91|\+91\-|0)?[6789]\d{9}$/.test(v) || "Mobile number is wrong"
            );
          }
        }]
      },
      email: {
        value: "",
        rules: [function (v) {
          if (!v) {
            return true;
          } else {
            return (/^$/.test(v) || /.@./.test(v) || "E-mail must be valid"
            );
          }
        }]
      },
      bachList: [],
      batchSelectedHr: null,
      bankName: null,
      accountType: null,
      accholderdisabled: false,
      contractType: null,
      workShift: null,
      employeeQualification: null,
      accountCategory: null,
      currentBankName: ['Allahabad Bank', 'Andhra Bank', 'Axis Bank', 'Bandhan Bank', 'Bank of India', 'Bank Of Baroda', 'Bank Of Maharastra', 'Canara Bank', 'Central Bank Of India', 'Corporation Bank', 'Dena Bank', 'DCB bank', 'Google Pay', 'HDFC bank', 'ICICI Bank', 'Indian Overseas Bank', 'Kotak Mahindra Bank', 'Oriental Bank Of Commerce', 'Paytm', 'Phone Pe', 'Punjab National Bank', 'Punjab and Sind Bank', 'State Bank Of India', 'UCO Bank', 'Union Bank Of India', 'Vijaya Bank', 'Yes Bank'],
      currentAccountType: ['Saving A/C', 'Current A/C', 'Overdraft A/C', 'Loan A/C'],
      currentContractType: ['Permanent', 'Contractual', 'Temporary', 'Extra'],
      currentWorkShift: ['Day', 'Afternoon', 'Evening', 'Night'],
      currentEmployeeQualification: ['Option 1', 'Option 2', 'Option 3'],
      IFSC_Rules: [function (v) {
        // let reg = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
        var reg = /^([a-zA-Z]){4}([0]){1}([a-zA-Z0-9]){6}?$/;
        return v == undefined || /^$/.test(v) || reg.test(v) || "IFSC must be Valid";
      }],
      ifsccode: null,
      accountLocation: null,
      accountHolderName: null,
      accountnumber: null,
      epfnumber: null,
      basicSalary: null
    };
  },
  created: function created() {
    this.$bindAsArray("hrList", this.$root.$firebaseRefs.hrs.orderByChild('brand').equalTo(this.selectedBrand));
    // this.$bindAsObject('brands',this.$root.$firebaseRefs.brand.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsArray("godawns", this.$root.$firebaseRefs.godawn.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("godawnTrans", this.$root.$firebaseRefs.godawnTransaction.orderByChild('brand').equalTo(this.selectedBrand));
    // this.$bindAsArray('hrGroups', this.$root.$firebaseRefs.hrGroup)
    this.$bindAsArray("batch", this.$root.$firebaseRefs.batchTransaction.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("damage", this.$root.$firebaseRefs.damageTransaction.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    if (this.$route.params.isNew) {
      this.addHr();
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear", "roleAndPermission"]), mapGlobalGetters({ units: "hrUnit" }), mapGlobalGetters({
    gIdentityType: "identityType",
    gVillage: "village",
    gBlock: "block",
    gTehsil: "tehsil",
    gDistrict: "district",
    gState: "state",
    gCountry: "country",
    gGender: "gender",
    gMarital: "marital"
  }), {
    firmsByBrand: function firmsByBrand() {
      var _this = this;

      var firmsB = this.firms.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      }).map(function (item) {
        if (item.defaultFirm) {
          _this.defaultFirm = item[".key"];
          _this.currentHr.businessType = item["businessType"];
        }
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
      return firmsB;
    },
    hasHrAddPermission: function hasHrAddPermission() {
      if (this.roleAndPermission && this.roleAndPermission.permissions && this.roleAndPermission.permissions.length && this.roleAndPermission.permissions.indexOf('PRODUCT_ADD') > -1) {
        return true;
      } else {
        return false;
      }
    },
    hasHrEditPermission: function hasHrEditPermission() {
      if (this.roleAndPermission && this.roleAndPermission.permissions && this.roleAndPermission.permissions.length && this.roleAndPermission.permissions.indexOf('PRODUCT_EDIT') > -1) {
        return true;
      } else {
        return false;
      }
    },
    hasHrDeletePermission: function hasHrDeletePermission() {
      if (this.roleAndPermission && this.roleAndPermission.permissions && this.roleAndPermission.permissions.length && this.roleAndPermission.permissions.indexOf('PRODUCT_DELETE') > -1) {
        return true;
      } else {
        return false;
      }
    },
    hasHrTransferPermission: function hasHrTransferPermission() {
      if (this.roleAndPermission && this.roleAndPermission.permissions && this.roleAndPermission.permissions.length && this.roleAndPermission.permissions.indexOf('PRODUCT_TRANSFER') > -1) {
        return true;
      } else {
        return false;
      }
    },
    identityNumeberError: function identityNumeberError() {
      if (this.identityNumber.value) {
        var error = null;
        switch (this.identityType.value) {
          case "Voter ID":
            // 3 alpha, 7 digit 
            error = /^([a-zA-Z]){3}([0-9]){7}?$/g.test(this.identityNumber.value) ? null : 'Enter valid Voter ID';
            break;
          case "Adhaar ID":
            // 16 or 12 digit number 
            error = /^(\d{16}|\d{12})$/g.test(Number(this.identityNumber.value)) ? null : 'Enter valid Adhaar ID';
            break;
          case "Driving License":
            // 2 alpha, 2 digit, 4 digit, 7 digit  
            error = /^([a-zA-Z]{2})(\d{2})(\d{4})(\d{7})$/g.test(this.identityNumber.value) ? null : 'Enter valid Driving License';
            break;
          case "Pan Card":
            // 5 alpha, 4 digit, 1 alpha 
            error = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}$/g.test(this.identityNumber.value) ? null : 'Enter valid PAN Card';
            break;
          case "Samagra Id":
            // 9 digit number  
            error = /^(\d{9})$/g.test(Number(this.identityNumber.value)) ? null : 'Enter valid Samagra ID';
            break;
          default:
            error = 'Select Identity type';
            break;
        }
        return error;
      }
    },
    hrListByBrand: function hrListByBrand() {
      var _this2 = this;

      var prod = this.hrList.filter(function (item) {
        return item["brand"] === _this2.selectedBrand
        // && (item.dateOfJoining ? (item.dateOfJoining >= this.finYear.start) && (item.dateOfJoining <= this.finYear.end) : true) 
        && (!!_this2.search ? !!item["name"].toLowerCase().includes(_this2.search.toLowerCase()) : true);
      });
      if (!this.suggestionAdded) {
        this.compositionSuggestions = [];
      }
      prod.map(function (p) {
        if (!_this2.suggestionAdded) {
          if (p.composition && _this2.compositionSuggestions.indexOf(p.composition) == -1) {
            _this2.compositionSuggestions.push(p.composition);
          }
        }
        if (p.unitsDeatilsAdded) {
          p['openingQuantityTitle'] = _this2.getFilteredQuantity(p, p['openingQuantity']);
          p['purchaseQuantityTitle'] = _this2.getFilteredQuantity(p, p['purchaseQuantity']);
          p['saleQuantityTitle'] = _this2.getFilteredQuantity(p, p['saleQuantity']);
          p['closingQuantityTitle'] = _this2.getFilteredQuantity(p, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(p['openingQuantity']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(p['purchaseQuantity']) - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(p['saleQuantity']));
        }
      });
      return prod;
    }
  }),
  methods: {
    // addComposition(e){
    //   this.suggestionAdded = true;
    //   this.compositionSuggestions.push(e.target.value)
    // },
    //  getBusinessType(){
    //   let firm = this.firms.filter((item) => item[".key"] === this.currentHr['firm'])[0];
    //   this.currentHr.businessType = firm['businessType'];
    // },
    //   getFilteredQuantity(hr,qty){
    //   let quantity = qty;
    //   let string = "";
    //       hr.unitsDetails.sort(function(a,b){
    //         return (new Date(b.order) - new Date(a.order));
    //       });
    //       for (var i = 0; i < hr.unitsDetails.length; i++) {
    //          if(quantity > Number.parseFloat(hr.unitsDetails[i].quantity) && i+1 <hr.unitsDetails.length) {
    //           let temp  = Number.parseFloat(quantity)/Number.parseFloat(hr.unitsDetails[i].quantity);
    //             string = (("("+((temp).toString().split(".")[1] ? (temp).toString().split(".")[1] : 0) + " "+hr.unitsDetails[i].unit+") ")+ string);
    //             quantity = Number.parseInt((temp).toString().split(".")[0])
    //           } else {
    //             string = (("("+quantity + " "+hr.unitsDetails[i].unit+") ")+ string);
    //             break;
    //           }
    //       }
    //       console.log(string)
    //     return string;
    // },
    // addUnitData(data){
    //   delete data['isLast']
    //   this.currentHr.unitsDetails.push({
    //     unit:'',
    //     order : data.order+1,
    //     quantity : 0,
    //     isLast : true,
    //   })
    // },
    // removeUnitData(){
    //   this.currentHr.unitsDetails.pop();
    //   this.currentHr.unitsDetails[this.currentHr.unitsDetails.length-1]['isLast'] = true;
    // },
    // transferToGodawn(){
    //   let transferObj = {
    //     quantity : Number.parseFloat(this.transferQuantity),
    //     date : new Date(this.transferDate).getTime(),
    //     hr : this.hrToTansfer['.key'],
    //     godawn : this.currentGodawn['.key'],
    //     brand : this.selectedBrand
    //   }
    //   this.$root.$firebaseRefs.godawnTransaction.push(transferObj);
    //   let key = this.hrToTansfer[".key"];
    //   delete this.hrToTansfer[".key"];

    //   this.transferDialog = false;
    //   this.transferQuantity = 0;
    //   this.currentGodawn = null;
    //   this.hrToTansfer = null;
    //   this.transferDate =  new Date().toISOString().substr(0, 10);
    // },
    // transferToDamage(){
    //   let damageObj = {
    //     quantity : Number.parseFloat(this.damageQuantity),
    //     date : new Date(this.damageDate).getTime(),
    //     hr : this.hrToDamage['.key'],
    //     brand : this.selectedBrand
    //   }
    //   this.$root.$firebaseRefs.damageTransaction.push(damageObj);
    //   let key = this.hrToDamage[".key"];
    //   delete this.hrToDamage[".key"];
    //   this.hrToDamage['quantity'] = this.hrToDamage['quantity'] - damageObj.quantity;
    //   this.$root.$firebaseRefs.hrs.child(key).set(this.hrToDamage);

    //   this.damageDialog = false;
    //   this.damageQuantity = 0;
    //   this.hrToDamage = null;
    //   this.damageDate =  new Date().toISOString().substr(0, 10);
    // },
    // addToBatch(){
    //   let batchObj = {
    //     quantity : Number.parseFloat(this.batchQuantity),
    //     manufacturingDate : new Date(this.manufacuturingDate).getTime(),
    //     expiryDate : new Date(this.expiryDate).getTime(),
    //     hr : this.hrToBatch['.key'],
    //     batchNumber: this.batchNumber,
    //     brand : this.selectedBrand
    //   }
    //   this.$root.$firebaseRefs.batchTransaction.push(batchObj);
    //   let key = this.hrToBatch[".key"];
    //   delete this.hrToBatch[".key"];

    //   this.batchDialog = false;
    //   this.batchQuantity = 0;
    //   this.batchNumber ="";

    //   this.hrToBatch = null;
    //   this.manufacuturingDate =  new Date().toISOString().substr(0, 10);
    //   this.expiryDate =  new Date().toISOString().substr(0, 10);
    // },
    // openTansferDialog(hr){
    //   this.hrToTansfer = hr;
    //   this.transferDialog = true;
    // },
    // openBatchDialog(hr){
    //   this.hrToBatch = hr;
    //   this.batchDialog = true;
    // },
    // viewHrByBatch(hr){
    //   this.batchSelectedHr = hr;
    //   this.viewBatchDialog = true;
    //   this.bachList = this.batch.filter(item => item["brand"] === this.selectedBrand
    //     && item['hr'] == hr['.key'])
    // },
    // openDamageDialog(hr){
    //   this.hrToDamage = hr;
    //   this.damageDialog = true;
    // },
    capitalize: function capitalize(s) {
      s = s.toLowerCase();
      if (typeof s !== 'string') return '';
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
    getBankDetailsFromIFSC: function getBankDetailsFromIFSC(isEdit) {
      var _this3 = this;

      var ifsc = isEdit ? this.ifsccodeEdit : this.ifsccode;
      var reg = /^([a-zA-Z]){4}([0]){1}([a-zA-Z0-9]){6}?$/;
      console.log(ifsc);
      if (ifsc && reg.test(ifsc)) {
        console.log("change");
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('https://ifsc.razorpay.com/' + ifsc).then(function (response) {
          _this3.gState.push(_this3.capitalize(response.data.STATE));
          _this3.gDistrict.push(_this3.capitalize(response.data.DISTRICT));
          _this3.gTehsil.push(_this3.capitalize(response.data.CITY));
          setTimeout(function () {
            _this3.country.value = 'India';
            _this3.district.value = _this3.capitalize(response.data.DISTRICT);
            _this3.state.value = _this3.capitalize(response.data.STATE);
            _this3.tehsil.value = _this3.capitalize(response.data.CITY);
          }, 100);
          if (isEdit) {
            _this3.accountLocationEdit = response.data.BRANCH + " " + response.data.ADDRESS;
          } else {
            _this3.accountLocation = response.data.BRANCH + " " + response.data.ADDRESS;
          }
        });
      }
    },
    duplicateCheck: function duplicateCheck() {
      var _this4 = this;

      var duplicateCheck = this.hrList.filter(function (item) {
        return item["brand"] === _this4.selectedBrand && item['name'] == _this4.currentHr.name;
      });
      if (duplicateCheck.length) {
        this.duplicateError = 'Hr with name ' + this.currentHr.name + ' Already exist.';
        setTimeout(function () {
          _this4.duplicateError = null;
        }, 3000);
      }
    },
    saveHr: function saveHr() {
      var _this5 = this;

      if (this.currentHr.unitsDeatilsAdded) {
        this.currentHr.unit = this.getLastUnit;
      } else {
        delete this.currentHr['unitsDetails'];
      }
      var duplicateCheck = this.hrList.filter(function (item) {
        return item["brand"] === _this5.selectedBrand && item['name'] == _this5.currentHr.name;
      });
      console.log(duplicateCheck);
      if (duplicateCheck.length) {
        this.duplicateError = 'Hr with name ' + this.currentHr.name + ' Already exist.';
        setTimeout(function () {
          _this5.duplicateError = null;
        }, 3000);
      } else {
        this.currentHr["brand"] = this.selectedBrand;
        this.currentHr["age"] = this.currentHr.age;
        this.currentHr["gender"] = this.currentHr.gender;
        this.currentHr["mobile"] = this.currentHr.mobile;
        this.currentHr["email"] = this.currentHr.email;

        this.currentHr["bankName"] = this.currentHr.bankName;
        this.currentHr["accountType"] = this.currentHr.accountType;
        this.currentHr["accountNumber"] = this.currentHr.accountNumber;
        this.currentHr["accountHolderName"] = this.currentHr.accountHolderName;
        // this.currentHr["accountLocation"] = this.currentHr.accountLocation;
        // this.currentHr["ifsccode"] = this.currentHr.ifsccode;

        this.currentHr["StaffId"] = this.currentHr.StaffId;
        this.currentHr["staffDesignationCategory"] = this.currentHr.staffDesignationCategory;
        this.currentHr.purchaseQuantity = 0;
        this.currentHr.saleQuantity = 0;
        this.currentHr.openingQuantity = this.currentHr.quantity;
        this.currentHr.dateOfJoining = new Date(this.currentHr.dateOfJoining).getTime();
        this.currentHr.dateOfBirth = new Date(this.currentHr.dateOfBirth).getTime();
        delete this.currentHr['openingQuantityTitle'];
        delete this.currentHr['purchaseQuantityTitle'];
        delete this.currentHr['saleQuantityTitle'];
        delete this.currentHr['closingQuantityTitle'];
        this.$root.$firebaseRefs.hrs.push(this.currentHr);
        this.addHrDialog = false;
        this.snackbar = true;
      }
    },
    keymonitor: function keymonitor(event) {
      this.search = event.target.value;
    },
    addHr: function addHr() {
      this.stepper = 1;
      this.currentHr = {
        firm: this.defaultFirm,
        name: "",
        age: 0,
        gender: "",
        marital: "",
        description: "",
        currentAddressDescription: "",
        currentAccountType: "",
        currentBankName: "",
        currentContractType: "",
        currentWorkShift: "",
        currentEmployeeQualification: "",
        currentPermanentDescription: "",
        StaffId: 0,
        Designation: "",
        staffDesignationCategory: "",
        barcode: "",
        hrGroup: null,
        unit: "",
        quantity: 0,
        batchNumber: "",
        dateOfJoining: new Date().toISOString().substr(0, 10),
        dateOfBirth: new Date().toISOString().substr(0, 10),
        brand: "",
        basicPrice: 0,
        gstValue: 0,
        purchasingPrice: null,
        sellingPrice: null,
        openingBalance: null,
        purchasingPricePerHr: null,
        basicSalary: 0,
        netSalary: 0,
        generalConveyance: 0,
        medicalConveyance: 0,
        specialConveyance: 0,
        casualLeave: 0,
        epfAmount: 0,
        esiAmount: 0,
        tdsAmunt: 0,
        professionalTaxAmount: 0,
        unitsDetails: [{
          unit: '',
          isLast: true,
          isFirst: true,
          order: 1,
          quantity: 0
        }]
      };
      this.addHrDialog = true;
    },
    updateHr: function updateHr() {
      if (this.currentHr.unitsDeatilsAdded) {
        this.currentHr.unit = this.getLastUnit;
      } else {
        delete this.currentHr['unitsDetails'];
      }
      var key = this.currentHr[".key"];
      delete this.currentHr[".key"];
      this.currentHr.dateOfJoining = new Date(this.currentHr.dateOfJoining).getTime();
      this.currentHr.dateOfBirth = new Date(this.currentHr.dateOfBirth).getTime();
      this.currentHr.openingQuantity = this.currentHr.quantity;
      this.currentHr["age"] = this.currentHr.age;
      this.currentHr["gender"] = this.currentHr.gender;
      this.currentHr["StaffId"] = this.currentHr.StaffId;
      this.currentHr["marital"] = this.currentHr.marital;
      this.currentHr["mobile"] = this.currentHr.mobile;
      this.currentHr["email"] = this.currentHr.email;

      this.currentHr["bankName"] = this.currentHr.bankName;
      this.currentHr["accountType"] = this.currentHr.accountType;
      this.currentHr["accountNumber"] = this.currentHr.accountNumber;
      this.currentHr["accountHolderName"] = this.currentHr.accountHolderName;
      this.currentHr["accountLocation"] = this.currentHr.accountLocation;
      this.currentHr["ifsccode"] = this.currentHr.ifsccode;

      this.currentHr.quantity = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.currentHr.openingQuantity) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.currentHr.purchaseQuantity) - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.currentHr.saleQuantity);
      delete this.currentHr['openingQuantityTitle'];
      delete this.currentHr['purchaseQuantityTitle'];
      delete this.currentHr['saleQuantityTitle'];
      delete this.currentHr['closingQuantityTitle'];
      this.$root.$firebaseRefs.hrs.child(key).set(this.currentHr);
      this.currentHr = {
        name: "",
        age: "",
        gender: "",
        description: "",
        currentAddressDescription: "",
        currentPermanentDescription: "",
        currentAccountType: "",
        currentContractType: "",
        contractType: "",
        currentWorkShift: "",
        workShift: "",
        employeeQualification: "",
        currentEmployeeQualification: "",
        currentBankName: "",
        StaffId: 0,
        Designation: "",
        staffDesignationCategory: 0,
        barcode: "",
        quantity: 0,
        unit: "",
        dateOfJoining: new Date().toISOString().substr(0, 10),
        brand: "",
        basicPrice: 0,
        gstValue: 0,
        purchasingPrice: null,
        sellingPrice: null,
        openingBalance: null,
        basicSalary: 0,
        netSalary: 0,
        generalConveyance: 0,
        medicalConveyance: 0,
        specialConveyance: 0,
        casualLeave: 0,
        epfAmount: 0,
        esiAmount: 0,
        tdsAmunt: 0,
        professionalTaxAmount: 0
      };
      this.addHrDialog = false;
      this.snackbar = true;
    },
    editHr: function editHr(hr) {
      this.currentHr = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(hr));
      this.currentHr.dateOfJoining = this.currentHr.dateOfJoining ? new Date(this.currentHr.dateOfJoining).toISOString().substr(0, 10) : new Date().toISOString().substr(0, 10);
      this.currentHr.quantity = this.currentHr.openingQuantity;
      this.currentHr.age = this.currentHr.age;
      this.currentHr.gender = this.currentHr.gender;
      this.currentHr.mobile = this.currentHr.mobile;
      this.currentHr.email = this.currentHr.email;
      this.currentHr.marital = this.currentHr.marital;
      this.currentHr.StaffId = this.currentHr.StaffId;
      this.currentHr.name = this.currentHr.name;
      this.currentHr.basicSalary = this.currentHr.basicSalary;
      this.currentHr.netSalary = this.currentHr.netSalary;
      this.currentHr.generalConveyance = this.currentHr.generalConveyance;
      this.currentHr.specialConveyance = this.currentHr.specialConveyance;
      this.currentHr.medicalConveyance = this.currentHr.medicalConveyance;
      this.currentHr.epfAmount = this.currentHr.epfAmount;
      this.currentHr.esiAmount = this.currentHr.esiAmount;
      this.currentHr.professionalTaxAmount = this.currentHr.professionalTaxAmount;
      this.currentHr.tdsAmunt = this.currentHr.tdsAmunt;
      this.currentHr.casualLeave = this.currentHr.casualLeave;
      this.currentHr.bankName = this.currentHr.bankName;
      this.currentHr.accountType = this.currentHr.accountType;
      this.currentHr.accountNumber = this.currentHr.accountNumber;
      this.currentHr.accountHolderName = this.currentHr.accountHolderName;
      // this.currentHr.accountLocation = this.currentHr.accountLocation;
      // this.currentHr.ifsccode = this.currentHr.ifsccode;
      this.addHrDialog = true;
      if (!this.currentHr.unitsDeatilsAdded) {
        this.currentHr.unitsDetails = [{
          unit: '',
          isLast: true,
          isFirst: true,
          order: 1,
          quantity: 0
        }];
      }
    },
    deleteHr: function deleteHr(hr) {
      if (window.confirm("Do you want to Delete " + hr.name + "?")) {
        this.$root.$firebaseRefs.hrs.child(hr[".key"]).remove();
      }
    }
  },
  watch: {
    "currentHr.Designation": {
      handler: function handler(newVal, oldVal) {
        if (newVal != "Teacher") {
          this.currentHr.staffDesignationCategory = 0;
        }
      },

      deep: true
    }
    //  "currentHr.basicPrice": {
    //   handler(newVal, oldVal) {
    //     if (newVal != oldVal) {
    //       this.calculateOpeningBalance();
    //     }
    //   },
    //   deep: true
    // },
    // "currentHr.firm": {
    //   handler(newVal, oldVal) {
    //     if (newVal != oldVal) {
    //       this.getBusinessType();
    //     }
    //   },
    //   deep: true
    // },
    // "currentHr.gstValue": {
    //   handler(newVal, oldVal) {
    //     if (newVal != oldVal) {
    //       this.calculateOpeningBalance();
    //     }
    //   },
    //   deep: true
    // }
  }
});

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])("Buyer")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      productsToLetterHead: [],
      items: [],
      isEdit: false,
      letterHeadDialog: false,
      isBuyer: true,
      invoiceLetterHead: false,
      historyStep: 1,
      selectedLetterHead: null,
      selectedBuyer: null,
      selectedFirm: null,
      date: new Date().toISOString().substr(0, 10),
      datepickerLetterHead: false,
      statusFilter: 'ALL',
      letterHeadNumber: null,
      letterHeadHistory: false,
      letterHeadContent: null,
      modalMode: null,
      letterHeadHeader: [{ text: "View", value: "view" },
      // { text: "History", value: "history" },
      // { text: "Orignal LetterHead", value: "originalLetterHead" },
      { text: "Letter Head Number", value: "letterHeadNumber" }, { text: "Letter Head Date", value: "date", sortable: true },
      // { text: "Invoice No", value: "invoiceId" },
      // { text: "Invoice Date", value: "date", sortable: true},
      { text: "Customer Name", value: "name" },
      // { text: "Total Amount", value: "name" }, 
      // { text: "Status", value: "edit" },
      { text: "Print", value: "edit" }, { text: "Edit", value: "edit" }, { text: "Delete", value: "edit" }],
      productInvoiceHeader: [{ text: "Name", value: "Name" }, { text: "Quantity", value: "Taxable" }, { text: "Unit", value: "HSN" }, { text: "Rate", value: "rate" }, { text: "Total", value: "total" }]
    };
  },
  created: function created() {
    this.$bindAsArray("buyers", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray("sellers", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray('firms', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray("letterHeads", this.$root.$firebaseRefs.letterHeads.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsObject('buyerById', this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsObject('sellerById', this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", 'finYear']), mapGlobalGetters({ units: "productUnit" }), {
    letterHeadsByBrand: function letterHeadsByBrand() {
      var _this = this;

      return this.letterHeads.filter(function (item) {
        return item["brand"] === _this.selectedBrand && (_this.statusFilter != 'ALL' ? item.status == _this.statusFilter : true);
      });
    },
    buyersByBrand: function buyersByBrand() {
      var _this2 = this;

      return this.buyers.filter(function (item) {
        return item["brand"] === _this2.selectedBrand;
      });
    },
    sellersByBrand: function sellersByBrand() {
      var _this3 = this;

      return this.sellers.filter(function (item) {
        return item["brand"] === _this3.selectedBrand;
      });
    },
    firmsByBrand: function firmsByBrand() {
      var _this4 = this;

      return this.firms.filter(function (item) {
        return item["brand"] === _this4.selectedBrand;
      }).map(function (item) {
        if (item.defaultFirm) {
          _this4.selectedFirm = item[".key"];
        }
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
    }
  }),
  methods: {
    openProd: function openProd(item) {
      this.selectedLetterHead = item;
      this.invoiceLetterHead = true;
    },
    getFirmName: function getFirmName(e) {
      var firm = void 0;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter(function (item) {
          return item['.key'] === e;
        })[0];
      }
      if (firm) return firm.name;
    },
    getCustomerName: function getCustomerName(id) {
      var buyer = this.buyerById[id];
      var seller = this.sellerById[id];
      if (!buyer && !seller) {
        return 'DELETED CUSTOMER';
      }
      return buyer ? buyer.name : seller.name;
    },

    addCustomer: function addCustomer(e) {
      var obj = {
        name: e.target.value,
        brand: this.selectedBrand
      };
      if (this.selectedFirm) {
        obj['state'] = this.selectedFirm;
      }

      if (this.isBuyer) {
        this.$root.$firebaseRefs.buyer.push(obj);
      } else {
        this.$root.$firebaseRefs.seller.push(obj);
      }
    },
    createInvoice: function createInvoice() {
      var _this5 = this;

      var key = this.selectedLetterHead['.key'];
      delete this.selectedLetterHead['.key'];
      this.$root.$firebaseRefs.letterHeads.child(key).set(this.selectedLetterHead).then(function (snap) {
        _this5.selectedLetterHead = null;
        _this5.$router.push({ path: "/letterHead-to-invoice/" + key });
        _this5.invoiceLetterHead = false;
      });
    },
    cancelLetterHead: function cancelLetterHead(letterHead) {
      var key = letterHead['.key'];
      delete letterHead['.key'];
      letterHead['status'] = 'CANCELLED';
      this.$root.$firebaseRefs.letterHeads.child(key).set(letterHead).then(function (snap) {});
    },
    editLetterHead: function editLetterHead(letterHead) {
      this.productsToLetterHead = [];
      this.letterHeadDialog = true;
      this.isEdit = true;
      this.firm = letterHead.firm;
      this.date = new Date(letterHead.date).toISOString().substr(0, 10), this.letterHeadNumber = letterHead.letterHeadNumber, this.letterHeadContent = letterHead.letterHeadContent;
      this.selectedLetterHead = letterHead;
      this.isBuyer = letterHead.isBuyer;
      if (letterHead.isBuyer) {
        this.selectedBuyer = this.buyerById[letterHead.buyerId];
      } else {
        this.selectedBuyer = this.sellerById[letterHead.buyerId];
      }
    },
    addLetterHead: function addLetterHead() {
      var _this6 = this;

      var letterHeadObj = {
        buyerId: this.selectedBuyer['.key'],
        isBuyer: this.isBuyer,
        firm: this.selectedFirm,
        brand: this.selectedBrand,
        date: new Date(this.date).getTime(),
        letterHeadNumber: this.letterHeadNumber,
        letterHeadContent: this.letterHeadContent,
        items: this.items
      };
      if (this.isEdit) {
        letterHeadObj['status'] = this.selectedLetterHead['status'];
        letterHeadObj['buyerId'] = this.selectedLetterHead['buyerId'];
        this.$root.$firebaseRefs.letterHeads.child(this.selectedLetterHead['.key']).set(letterHeadObj).then(function (snap) {
          _this6.isEdit = false;
        });
      } else {
        letterHeadObj['status'] = 'IN PROGRESS';
        this.$root.$firebaseRefs.letterHeads.push(letterHeadObj);
      }
      this.letterHeadDialog = false;
      this.selectedBuyer = null;
      this.isBuyer = true;
      this.items = [];
    },
    deleteLetterHead: function deleteLetterHead(letterHead) {
      if (window.confirm("Do you want to Delete ?")) {
        this.$root.$firebaseRefs.letterHeads.child(letterHead[".key"]).remove();
      }
    }
  }
});

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])("Buyer")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      productsToTodo: [],
      items: [],
      isEdit: false,
      todoDialog: false,
      isBuyer: true,
      invoiceTodo: false,
      historyStep: 1,
      selectedTodo: null,
      selectedBuyer: null,
      selectedFirm: null,
      date: new Date().toISOString().substr(0, 10),
      datepickerTodo: false,
      statusFilter: 'ALL',
      todoNumber: null,
      todoHistory: false,
      todoContent: null,
      modalMode: null,
      todoHeader: [{ text: "Date", value: "date" }, { text: "Purpose", value: "todoNumber" }, { text: "Content", value: "date", sortable: true }, { text: "Edit", value: "edit" }, { text: "Delete", value: "edit" }],
      productInvoiceHeader: [{ text: "Name", value: "Name" }, { text: "Quantity", value: "Taxable" }, { text: "Unit", value: "HSN" }, { text: "Rate", value: "rate" }, { text: "Total", value: "total" }]
    };
  },
  created: function created() {
    this.$bindAsArray("buyers", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray("sellers", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray('firms', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray("todos", this.$root.$firebaseRefs.todos.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsObject('buyerById', this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsObject('sellerById', this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", 'finYear']), mapGlobalGetters({ units: "productUnit" }), {
    todosByBrand: function todosByBrand() {
      var _this = this;

      return this.todos.filter(function (item) {
        return item["brand"] === _this.selectedBrand && (_this.statusFilter != 'ALL' ? item.status == _this.statusFilter : true);
      });
    },
    buyersByBrand: function buyersByBrand() {
      var _this2 = this;

      return this.buyers.filter(function (item) {
        return item["brand"] === _this2.selectedBrand;
      });
    },
    sellersByBrand: function sellersByBrand() {
      var _this3 = this;

      return this.sellers.filter(function (item) {
        return item["brand"] === _this3.selectedBrand;
      });
    },
    firmsByBrand: function firmsByBrand() {
      var _this4 = this;

      return this.firms.filter(function (item) {
        return item["brand"] === _this4.selectedBrand;
      }).map(function (item) {
        if (item.defaultFirm) {
          _this4.selectedFirm = item[".key"];
        }
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
    }
  }),
  methods: {
    openProd: function openProd(item) {
      this.selectedTodo = item;
      this.invoiceTodo = true;
    },
    getFirmName: function getFirmName(e) {
      var firm = void 0;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter(function (item) {
          return item['.key'] === e;
        })[0];
      }
      if (firm) return firm.name;
    },
    getCustomerName: function getCustomerName(id) {
      var buyer = this.buyerById[id];
      var seller = this.sellerById[id];
      if (!buyer && !seller) {
        return 'DELETED CUSTOMER';
      }
      return buyer ? buyer.name : seller.name;
    },

    addCustomer: function addCustomer(e) {
      var obj = {
        name: e.target.value,
        brand: this.selectedBrand
      };
      if (this.selectedFirm) {
        obj['state'] = this.selectedFirm;
      }

      if (this.isBuyer) {
        this.$root.$firebaseRefs.buyer.push(obj);
      } else {
        this.$root.$firebaseRefs.seller.push(obj);
      }
    },
    createInvoice: function createInvoice() {
      var _this5 = this;

      var key = this.selectedTodo['.key'];
      delete this.selectedTodo['.key'];
      this.$root.$firebaseRefs.todos.child(key).set(this.selectedTodo).then(function (snap) {
        _this5.selectedTodo = null;
        _this5.$router.push({ path: "/todo-to-invoice/" + key });
        _this5.invoiceTodo = false;
      });
    },
    cancelTodo: function cancelTodo(todo) {
      var key = todo['.key'];
      delete todo['.key'];
      todo['status'] = 'CANCELLED';
      this.$root.$firebaseRefs.todos.child(key).set(todo).then(function (snap) {});
    },
    editTodo: function editTodo(todo) {
      this.productsToTodo = [];
      this.todoDialog = true;
      this.isEdit = true;
      this.firm = todo.firm;
      this.date = new Date(todo.date).toISOString().substr(0, 10), this.todoNumber = todo.todoNumber, this.todoContent = todo.todoContent;
      this.selectedTodo = todo;
      this.isBuyer = todo.isBuyer;
      if (todo.isBuyer) {
        this.selectedBuyer = this.buyerById[todo.buyerId];
      } else {
        this.selectedBuyer = this.sellerById[todo.buyerId];
      }
    },
    addTodo: function addTodo() {
      var _this6 = this;

      var todoObj = {
        // buyerId : this.selectedBuyer['.key'],
        // isBuyer: this.isBuyer,
        firm: this.selectedFirm,
        brand: this.selectedBrand,
        date: new Date(this.date).getTime(),
        todoNumber: this.todoNumber,
        todoContent: this.todoContent,
        items: this.items
      };
      if (this.isEdit) {
        todoObj['status'] = this.selectedTodo['status'];
        // todoObj['buyerId'] = this.selectedTodo['buyerId']; 
        this.$root.$firebaseRefs.todos.child(this.selectedTodo['.key']).set(todoObj).then(function (snap) {
          _this6.isEdit = false;
        });
      } else {
        todoObj['status'] = 'IN PROGRESS';
        this.$root.$firebaseRefs.todos.push(todoObj);
      }
      this.todoDialog = false;
      this.selectedBuyer = null;
      this.isBuyer = true;
      this.items = [];
    },
    deleteTodo: function deleteTodo(todo) {
      if (window.confirm("Do you want to Delete ?")) {
        this.$root.$firebaseRefs.todos.child(todo[".key"]).remove();
      }
    }
  }
});

/***/ }),
/* 527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      items1: ['All', 'Teacher', 'Peon', 'Manager', 'Accountant', 'Operator', 'Driver', 'Conductor', 'IT Department', 'Admin'],
      items2: ['January', 'Februry', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      isBuyer: true,
      search: null,
      defaultFirm: null,
      compositionSuggestions: [],
      suggestionAdded: false,
      transferDialog: false,
      viewBatchDialog: false,
      batchDialog: false,
      damageDialog: false,
      stepper: 1,
      isBankDetails: false,
      isProfessionalDetails: false,
      isSalaryDetails: false,
      isDocumentAvailable: false,
      addHrDialog: false,
      hrToTansfer: null,
      hrToBatch: null,
      hrToDamage: null,
      datepickerTransfer: false,
      datepickerBatch: false,
      todatepickerBatch: false,
      datepickerDamage: false,
      currentGodawn: null,
      transferQuantity: 0,
      batchQuantity: 0,
      damageQuantity: 0,
      batchNumber: "",
      brand: {},
      datepicker: false,
      datepicker1: false,
      duplicateError: null,
      //   transferDate : new Date().toISOString().substr(0, 10),
      //   manufacuturingDate : new Date().toISOString().substr(0, 10),
      //   expiryDate : new Date().toISOString().substr(0, 10),
      //   damageDate : new Date().toISOString().substr(0, 10),
      currentHr: {
        name: "",
        age: 0,
        gender: "",
        description: "",
        currentAddressDescription: "",
        currentPermanentDescription: "",
        currentWorkShift: "",
        currentAccountType: "",
        currentBankName: "",
        currentEmployeeQualification: "",
        currentContractType: "",
        StaffId: 0,
        Designation: "",
        staffDesignationCategory: "",
        unit: "",
        quantity: 0,
        brand: "",
        dateOfJoining: new Date().toISOString().substr(0, 10),
        dateOfBirth: new Date().toISOString().substr(0, 10),
        purchasingPrice: null,
        sellingPrice: null,
        openingBalance: null,
        gstValue: 0,
        basicPrice: 0,
        barcode: "",
        basicSalary: 0,
        netSalary: 0,
        generalConveyance: 0,
        specialConveyance: 0,
        medicalConveyance: 0,
        casualLeave: 0,
        epfAmount: 0,
        esiAmount: 0,
        tdsAmount: 0,
        professionalTaxAmount: 0,

        bankName: "",
        accountNumber: "",
        accountType: "",
        accountHolderName: "",
        accountLocation: "",
        ifsccode: "",

        hrGroup: null,

        mobile: {
          value: "",
          rules: [function (v) {
            if (!v) {
              return true;
            } else {
              return (/^$/.test(v) || /^(\+91|\+91\-|0)?[6789]\d{9}$/.test(v) || "Mobile number is wrong"
              );
            }
          }]
        },

        email: {
          value: "",
          rules: [function (v) {
            if (!v) {
              return true;
            } else {
              return (/^$/.test(v) || /.@./.test(v) || "E-mail must be valid"
              );
            }
          }]
        },

        unitsDetails: [{
          unit: '',
          isLast: true,
          isFirst: true,
          order: 1,
          quantity: 0,
          rate: true
        }],
        unitsDeatilsAdded: false
      },
      timeout: 3000,
      snackbar: false,
      hrList: [],
      hrListHeader: [{ text: "Name - Description", value: "Name" }, { text: "Age", value: "age" }, { text: "Role", value: "quantity" }, { text: "Department", value: "quantity" }, { text: "Designation", value: "quantity" }, { text: "Basic Salary", value: "quantity" }, { text: "Net Salary", value: "quantity" }, { text: "EPF Amount", value: "quantity" }, { text: "ESI Amount", value: "transfer" }, { text: "TDS Amount", value: "transfer" }, { text: "Pro Tax Amount", value: "edit" }, { text: "HRA Amount", value: "delete" }, { text: "General Con", value: "transfer" }, { text: "Special Con", value: "quantity" }, { text: "Medical Con", value: "quantity" }, { text: "Bank Name", value: "transfer" }, { text: "Account Holder Name", value: "edit" }, { text: "Account Number", value: "delete" }, { text: "Account Type", value: "transfer" }, { text: "Account Location", value: "quantity" }, { text: "IFSC Code", value: "quantity" }, { text: "Mobile No", value: "quantity" }, { text: "Email", value: "quantity" }, { text: "Address", value: "quantity" }, { text: "Transfer", value: "transfer" }, { text: "Batch", value: "transfer" }, { text: "Edit", value: "edit" }, { text: "Delete", value: "delete" }, { text: "Action", value: "transfer" }],
      hrListHeaderByBatch: [{ text: "Batch", value: "batch" }, { text: "Manufacturing Date", value: "manuDate" }, { text: "Expiry Date", value: "expiryDate" }, { text: "Quantity", value: "quantity" }],
      Designations: [{
        text: "Accountant",
        value: "Accountant"
      }, {
        text: "Conductor",
        value: "Conductor"
      }, {
        text: "DataEntry Operator",
        value: "DataEntryOperator"
      }, {
        text: "Driver",
        value: "Driver"
      }, {
        text: "Manager",
        value: "Manager"
      }, {
        text: "Peon",
        value: "Peon"
      }, {
        text: "Staff",
        value: "Staff"
      }, {
        text: "Supervisor",
        value: "Supervisor"
      }, {
        text: "Teacher",
        value: "Teacher"
      }],
      age: {
        value: ""
      },
      workExperience: {
        value: ""
      },
      gender: {
        value: ""
      },
      marital: {
        value: ""
      },
      identityType: {
        value: ""
      },
      identityNumber: {
        value: ""
      },
      mobile: {
        value: "",
        rules: [function (v) {
          if (!v) {
            return true;
          } else {
            return (/^$/.test(v) || /^(\+91|\+91\-|0)?[6789]\d{9}$/.test(v) || "Mobile number is wrong"
            );
          }
        }]
      },
      email: {
        value: "",
        rules: [function (v) {
          if (!v) {
            return true;
          } else {
            return (/^$/.test(v) || /.@./.test(v) || "E-mail must be valid"
            );
          }
        }]
      },
      bachList: [],
      batchSelectedHr: null,
      bankName: null,
      accountType: null,
      accholderdisabled: false,
      contractType: null,
      workShift: null,
      employeeQualification: null,
      accountCategory: null,
      currentBankName: ['Allahabad Bank', 'Andhra Bank', 'Axis Bank', 'Bandhan Bank', 'Bank of India', 'Bank Of Baroda', 'Bank Of Maharastra', 'Canara Bank', 'Central Bank Of India', 'Corporation Bank', 'Dena Bank', 'DCB bank', 'Google Pay', 'HDFC bank', 'ICICI Bank', 'Indian Overseas Bank', 'Kotak Mahindra Bank', 'Oriental Bank Of Commerce', 'Paytm', 'Phone Pe', 'Punjab National Bank', 'Punjab and Sind Bank', 'State Bank Of India', 'UCO Bank', 'Union Bank Of India', 'Vijaya Bank', 'Yes Bank'],
      currentAccountType: ['Saving A/C', 'Current A/C', 'Overdraft A/C', 'Loan A/C'],
      currentContractType: ['Permanent', 'Contractual', 'Temporary', 'Extra'],
      currentWorkShift: ['Day', 'Afternoon', 'Evening', 'Night'],
      currentEmployeeQualification: ['Option 1', 'Option 2', 'Option 3'],
      IFSC_Rules: [function (v) {
        // let reg = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
        var reg = /^([a-zA-Z]){4}([0]){1}([a-zA-Z0-9]){6}?$/;
        return v == undefined || /^$/.test(v) || reg.test(v) || "IFSC must be Valid";
      }],
      ifsccode: null,
      accountLocation: null,
      accountHolderName: null,
      accountnumber: null,
      epfnumber: null,
      basicSalary: null
    };
  },
  created: function created() {
    this.$bindAsArray("hrList", this.$root.$firebaseRefs.hrs.orderByChild('brand').equalTo(this.selectedBrand));
    // this.$bindAsObject('brands',this.$root.$firebaseRefs.brand.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsArray("godawns", this.$root.$firebaseRefs.godawn.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("godawnTrans", this.$root.$firebaseRefs.godawnTransaction.orderByChild('brand').equalTo(this.selectedBrand));
    // this.$bindAsArray('hrGroups', this.$root.$firebaseRefs.hrGroup)
    this.$bindAsArray("batch", this.$root.$firebaseRefs.batchTransaction.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("damage", this.$root.$firebaseRefs.damageTransaction.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    if (this.$route.params.isNew) {
      this.addHr();
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear", "roleAndPermission"]), mapGlobalGetters({ units: "hrUnit" }), mapGlobalGetters({
    gIdentityType: "identityType",
    gVillage: "village",
    gBlock: "block",
    gTehsil: "tehsil",
    gDistrict: "district",
    gState: "state",
    gCountry: "country",
    gGender: "gender",
    gMarital: "marital"
  }), {
    firmsByBrand: function firmsByBrand() {
      var _this = this;

      var firmsB = this.firms.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      }).map(function (item) {
        if (item.defaultFirm) {
          _this.defaultFirm = item[".key"];
          _this.currentHr.businessType = item["businessType"];
        }
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
      return firmsB;
    },
    hasHrAddPermission: function hasHrAddPermission() {
      if (this.roleAndPermission && this.roleAndPermission.permissions && this.roleAndPermission.permissions.length && this.roleAndPermission.permissions.indexOf('PRODUCT_ADD') > -1) {
        return true;
      } else {
        return false;
      }
    },
    hasHrEditPermission: function hasHrEditPermission() {
      if (this.roleAndPermission && this.roleAndPermission.permissions && this.roleAndPermission.permissions.length && this.roleAndPermission.permissions.indexOf('PRODUCT_EDIT') > -1) {
        return true;
      } else {
        return false;
      }
    },
    hasHrDeletePermission: function hasHrDeletePermission() {
      if (this.roleAndPermission && this.roleAndPermission.permissions && this.roleAndPermission.permissions.length && this.roleAndPermission.permissions.indexOf('PRODUCT_DELETE') > -1) {
        return true;
      } else {
        return false;
      }
    },
    hasHrTransferPermission: function hasHrTransferPermission() {
      if (this.roleAndPermission && this.roleAndPermission.permissions && this.roleAndPermission.permissions.length && this.roleAndPermission.permissions.indexOf('PRODUCT_TRANSFER') > -1) {
        return true;
      } else {
        return false;
      }
    },
    identityNumeberError: function identityNumeberError() {
      if (this.identityNumber.value) {
        var error = null;
        switch (this.identityType.value) {
          case "Voter ID":
            // 3 alpha, 7 digit 
            error = /^([a-zA-Z]){3}([0-9]){7}?$/g.test(this.identityNumber.value) ? null : 'Enter valid Voter ID';
            break;
          case "Adhaar ID":
            // 16 or 12 digit number 
            error = /^(\d{16}|\d{12})$/g.test(Number(this.identityNumber.value)) ? null : 'Enter valid Adhaar ID';
            break;
          case "Driving License":
            // 2 alpha, 2 digit, 4 digit, 7 digit  
            error = /^([a-zA-Z]{2})(\d{2})(\d{4})(\d{7})$/g.test(this.identityNumber.value) ? null : 'Enter valid Driving License';
            break;
          case "Pan Card":
            // 5 alpha, 4 digit, 1 alpha 
            error = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}$/g.test(this.identityNumber.value) ? null : 'Enter valid PAN Card';
            break;
          case "Samagra Id":
            // 9 digit number  
            error = /^(\d{9})$/g.test(Number(this.identityNumber.value)) ? null : 'Enter valid Samagra ID';
            break;
          default:
            error = 'Select Identity type';
            break;
        }
        return error;
      }
    },
    hrListByBrand: function hrListByBrand() {
      var _this2 = this;

      var prod = this.hrList.filter(function (item) {
        return item["brand"] === _this2.selectedBrand
        // && (item.dateOfJoining ? (item.dateOfJoining >= this.finYear.start) && (item.dateOfJoining <= this.finYear.end) : true) 
        && (!!_this2.search ? !!item["name"].toLowerCase().includes(_this2.search.toLowerCase()) : true);
      });
      if (!this.suggestionAdded) {
        this.compositionSuggestions = [];
      }
      prod.map(function (p) {
        if (!_this2.suggestionAdded) {
          if (p.composition && _this2.compositionSuggestions.indexOf(p.composition) == -1) {
            _this2.compositionSuggestions.push(p.composition);
          }
        }
        if (p.unitsDeatilsAdded) {
          p['openingQuantityTitle'] = _this2.getFilteredQuantity(p, p['openingQuantity']);
          p['purchaseQuantityTitle'] = _this2.getFilteredQuantity(p, p['purchaseQuantity']);
          p['saleQuantityTitle'] = _this2.getFilteredQuantity(p, p['saleQuantity']);
          p['closingQuantityTitle'] = _this2.getFilteredQuantity(p, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(p['openingQuantity']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(p['purchaseQuantity']) - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(p['saleQuantity']));
        }
      });
      return prod;
    }
  }),
  methods: {
    // addComposition(e){
    //   this.suggestionAdded = true;
    //   this.compositionSuggestions.push(e.target.value)
    // },
    //  getBusinessType(){
    //   let firm = this.firms.filter((item) => item[".key"] === this.currentHr['firm'])[0];
    //   this.currentHr.businessType = firm['businessType'];
    // },
    //   getFilteredQuantity(hr,qty){
    //   let quantity = qty;
    //   let string = "";
    //       hr.unitsDetails.sort(function(a,b){
    //         return (new Date(b.order) - new Date(a.order));
    //       });
    //       for (var i = 0; i < hr.unitsDetails.length; i++) {
    //          if(quantity > Number.parseFloat(hr.unitsDetails[i].quantity) && i+1 <hr.unitsDetails.length) {
    //           let temp  = Number.parseFloat(quantity)/Number.parseFloat(hr.unitsDetails[i].quantity);
    //             string = (("("+((temp).toString().split(".")[1] ? (temp).toString().split(".")[1] : 0) + " "+hr.unitsDetails[i].unit+") ")+ string);
    //             quantity = Number.parseInt((temp).toString().split(".")[0])
    //           } else {
    //             string = (("("+quantity + " "+hr.unitsDetails[i].unit+") ")+ string);
    //             break;
    //           }
    //       }
    //       console.log(string)
    //     return string;
    // },
    // addUnitData(data){
    //   delete data['isLast']
    //   this.currentHr.unitsDetails.push({
    //     unit:'',
    //     order : data.order+1,
    //     quantity : 0,
    //     isLast : true,
    //   })
    // },
    // removeUnitData(){
    //   this.currentHr.unitsDetails.pop();
    //   this.currentHr.unitsDetails[this.currentHr.unitsDetails.length-1]['isLast'] = true;
    // },
    // transferToGodawn(){
    //   let transferObj = {
    //     quantity : Number.parseFloat(this.transferQuantity),
    //     date : new Date(this.transferDate).getTime(),
    //     hr : this.hrToTansfer['.key'],
    //     godawn : this.currentGodawn['.key'],
    //     brand : this.selectedBrand
    //   }
    //   this.$root.$firebaseRefs.godawnTransaction.push(transferObj);
    //   let key = this.hrToTansfer[".key"];
    //   delete this.hrToTansfer[".key"];

    //   this.transferDialog = false;
    //   this.transferQuantity = 0;
    //   this.currentGodawn = null;
    //   this.hrToTansfer = null;
    //   this.transferDate =  new Date().toISOString().substr(0, 10);
    // },
    // transferToDamage(){
    //   let damageObj = {
    //     quantity : Number.parseFloat(this.damageQuantity),
    //     date : new Date(this.damageDate).getTime(),
    //     hr : this.hrToDamage['.key'],
    //     brand : this.selectedBrand
    //   }
    //   this.$root.$firebaseRefs.damageTransaction.push(damageObj);
    //   let key = this.hrToDamage[".key"];
    //   delete this.hrToDamage[".key"];
    //   this.hrToDamage['quantity'] = this.hrToDamage['quantity'] - damageObj.quantity;
    //   this.$root.$firebaseRefs.hrs.child(key).set(this.hrToDamage);

    //   this.damageDialog = false;
    //   this.damageQuantity = 0;
    //   this.hrToDamage = null;
    //   this.damageDate =  new Date().toISOString().substr(0, 10);
    // },
    // addToBatch(){
    //   let batchObj = {
    //     quantity : Number.parseFloat(this.batchQuantity),
    //     manufacturingDate : new Date(this.manufacuturingDate).getTime(),
    //     expiryDate : new Date(this.expiryDate).getTime(),
    //     hr : this.hrToBatch['.key'],
    //     batchNumber: this.batchNumber,
    //     brand : this.selectedBrand
    //   }
    //   this.$root.$firebaseRefs.batchTransaction.push(batchObj);
    //   let key = this.hrToBatch[".key"];
    //   delete this.hrToBatch[".key"];

    //   this.batchDialog = false;
    //   this.batchQuantity = 0;
    //   this.batchNumber ="";

    //   this.hrToBatch = null;
    //   this.manufacuturingDate =  new Date().toISOString().substr(0, 10);
    //   this.expiryDate =  new Date().toISOString().substr(0, 10);
    // },
    // openTansferDialog(hr){
    //   this.hrToTansfer = hr;
    //   this.transferDialog = true;
    // },
    // openBatchDialog(hr){
    //   this.hrToBatch = hr;
    //   this.batchDialog = true;
    // },
    // viewHrByBatch(hr){
    //   this.batchSelectedHr = hr;
    //   this.viewBatchDialog = true;
    //   this.bachList = this.batch.filter(item => item["brand"] === this.selectedBrand
    //     && item['hr'] == hr['.key'])
    // },
    // openDamageDialog(hr){
    //   this.hrToDamage = hr;
    //   this.damageDialog = true;
    // },
    capitalize: function capitalize(s) {
      s = s.toLowerCase();
      if (typeof s !== 'string') return '';
      return s.charAt(0).toUpperCase() + s.slice(1);
    },
    getBankDetailsFromIFSC: function getBankDetailsFromIFSC(isEdit) {
      var _this3 = this;

      var ifsc = isEdit ? this.ifsccodeEdit : this.ifsccode;
      var reg = /^([a-zA-Z]){4}([0]){1}([a-zA-Z0-9]){6}?$/;
      console.log(ifsc);
      if (ifsc && reg.test(ifsc)) {
        console.log("change");
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get('https://ifsc.razorpay.com/' + ifsc).then(function (response) {
          _this3.gState.push(_this3.capitalize(response.data.STATE));
          _this3.gDistrict.push(_this3.capitalize(response.data.DISTRICT));
          _this3.gTehsil.push(_this3.capitalize(response.data.CITY));
          setTimeout(function () {
            _this3.country.value = 'India';
            _this3.district.value = _this3.capitalize(response.data.DISTRICT);
            _this3.state.value = _this3.capitalize(response.data.STATE);
            _this3.tehsil.value = _this3.capitalize(response.data.CITY);
          }, 100);
          if (isEdit) {
            _this3.accountLocationEdit = response.data.BRANCH + " " + response.data.ADDRESS;
          } else {
            _this3.accountLocation = response.data.BRANCH + " " + response.data.ADDRESS;
          }
        });
      }
    },
    duplicateCheck: function duplicateCheck() {
      var _this4 = this;

      var duplicateCheck = this.hrList.filter(function (item) {
        return item["brand"] === _this4.selectedBrand && item['name'] == _this4.currentHr.name;
      });
      if (duplicateCheck.length) {
        this.duplicateError = 'Hr with name ' + this.currentHr.name + ' Already exist.';
        setTimeout(function () {
          _this4.duplicateError = null;
        }, 3000);
      }
    },
    saveHr: function saveHr() {
      var _this5 = this;

      if (this.currentHr.unitsDeatilsAdded) {
        this.currentHr.unit = this.getLastUnit;
      } else {
        delete this.currentHr['unitsDetails'];
      }
      var duplicateCheck = this.hrList.filter(function (item) {
        return item["brand"] === _this5.selectedBrand && item['name'] == _this5.currentHr.name;
      });
      console.log(duplicateCheck);
      if (duplicateCheck.length) {
        this.duplicateError = 'Hr with name ' + this.currentHr.name + ' Already exist.';
        setTimeout(function () {
          _this5.duplicateError = null;
        }, 3000);
      } else {
        this.currentHr["brand"] = this.selectedBrand;
        this.currentHr["age"] = this.currentHr.age;
        this.currentHr["gender"] = this.currentHr.gender;
        this.currentHr["mobile"] = this.currentHr.mobile;
        this.currentHr["email"] = this.currentHr.email;

        this.currentHr["bankName"] = this.currentHr.bankName;
        this.currentHr["accountType"] = this.currentHr.accountType;
        this.currentHr["accountNumber"] = this.currentHr.accountNumber;
        this.currentHr["accountHolderName"] = this.currentHr.accountHolderName;
        // this.currentHr["accountLocation"] = this.currentHr.accountLocation;
        // this.currentHr["ifsccode"] = this.currentHr.ifsccode;

        this.currentHr["StaffId"] = this.currentHr.StaffId;
        this.currentHr["staffDesignationCategory"] = this.currentHr.staffDesignationCategory;
        this.currentHr.purchaseQuantity = 0;
        this.currentHr.saleQuantity = 0;
        this.currentHr.openingQuantity = this.currentHr.quantity;
        this.currentHr.dateOfJoining = new Date(this.currentHr.dateOfJoining).getTime();
        this.currentHr.dateOfBirth = new Date(this.currentHr.dateOfBirth).getTime();
        delete this.currentHr['openingQuantityTitle'];
        delete this.currentHr['purchaseQuantityTitle'];
        delete this.currentHr['saleQuantityTitle'];
        delete this.currentHr['closingQuantityTitle'];
        this.$root.$firebaseRefs.hrs.push(this.currentHr);
        this.addHrDialog = false;
        this.snackbar = true;
      }
    },
    keymonitor: function keymonitor(event) {
      this.search = event.target.value;
    },
    addHr: function addHr() {
      this.stepper = 1;
      this.currentHr = {
        firm: this.defaultFirm,
        name: "",
        age: 0,
        gender: "",
        marital: "",
        description: "",
        currentAddressDescription: "",
        currentAccountType: "",
        currentBankName: "",
        currentContractType: "",
        currentWorkShift: "",
        currentEmployeeQualification: "",
        currentPermanentDescription: "",
        StaffId: 0,
        Designation: "",
        staffDesignationCategory: "",
        barcode: "",
        hrGroup: null,
        unit: "",
        quantity: 0,
        batchNumber: "",
        dateOfJoining: new Date().toISOString().substr(0, 10),
        dateOfBirth: new Date().toISOString().substr(0, 10),
        brand: "",
        basicPrice: 0,
        gstValue: 0,
        purchasingPrice: null,
        sellingPrice: null,
        openingBalance: null,
        purchasingPricePerHr: null,
        basicSalary: 0,
        netSalary: 0,
        generalConveyance: 0,
        medicalConveyance: 0,
        specialConveyance: 0,
        casualLeave: 0,
        epfAmount: 0,
        esiAmount: 0,
        tdsAmunt: 0,
        professionalTaxAmount: 0,
        unitsDetails: [{
          unit: '',
          isLast: true,
          isFirst: true,
          order: 1,
          quantity: 0
        }]
      };
      this.addHrDialog = true;
    },
    updateHr: function updateHr() {
      if (this.currentHr.unitsDeatilsAdded) {
        this.currentHr.unit = this.getLastUnit;
      } else {
        delete this.currentHr['unitsDetails'];
      }
      var key = this.currentHr[".key"];
      delete this.currentHr[".key"];
      this.currentHr.dateOfJoining = new Date(this.currentHr.dateOfJoining).getTime();
      this.currentHr.dateOfBirth = new Date(this.currentHr.dateOfBirth).getTime();
      this.currentHr.openingQuantity = this.currentHr.quantity;
      this.currentHr["age"] = this.currentHr.age;
      this.currentHr["gender"] = this.currentHr.gender;
      this.currentHr["StaffId"] = this.currentHr.StaffId;
      this.currentHr["marital"] = this.currentHr.marital;
      this.currentHr["mobile"] = this.currentHr.mobile;
      this.currentHr["email"] = this.currentHr.email;

      this.currentHr["bankName"] = this.currentHr.bankName;
      this.currentHr["accountType"] = this.currentHr.accountType;
      this.currentHr["accountNumber"] = this.currentHr.accountNumber;
      this.currentHr["accountHolderName"] = this.currentHr.accountHolderName;
      this.currentHr["accountLocation"] = this.currentHr.accountLocation;
      this.currentHr["ifsccode"] = this.currentHr.ifsccode;

      this.currentHr.quantity = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.currentHr.openingQuantity) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.currentHr.purchaseQuantity) - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.currentHr.saleQuantity);
      delete this.currentHr['openingQuantityTitle'];
      delete this.currentHr['purchaseQuantityTitle'];
      delete this.currentHr['saleQuantityTitle'];
      delete this.currentHr['closingQuantityTitle'];
      this.$root.$firebaseRefs.hrs.child(key).set(this.currentHr);
      this.currentHr = {
        name: "",
        age: "",
        gender: "",
        description: "",
        currentAddressDescription: "",
        currentPermanentDescription: "",
        currentAccountType: "",
        currentContractType: "",
        contractType: "",
        currentWorkShift: "",
        workShift: "",
        employeeQualification: "",
        currentEmployeeQualification: "",
        currentBankName: "",
        StaffId: 0,
        Designation: "",
        staffDesignationCategory: 0,
        barcode: "",
        quantity: 0,
        unit: "",
        dateOfJoining: new Date().toISOString().substr(0, 10),
        brand: "",
        basicPrice: 0,
        gstValue: 0,
        purchasingPrice: null,
        sellingPrice: null,
        openingBalance: null,
        basicSalary: 0,
        netSalary: 0,
        generalConveyance: 0,
        medicalConveyance: 0,
        specialConveyance: 0,
        casualLeave: 0,
        epfAmount: 0,
        esiAmount: 0,
        tdsAmunt: 0,
        professionalTaxAmount: 0
      };
      this.addHrDialog = false;
      this.snackbar = true;
    },
    editHr: function editHr(hr) {
      this.currentHr = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(hr));
      this.currentHr.dateOfJoining = this.currentHr.dateOfJoining ? new Date(this.currentHr.dateOfJoining).toISOString().substr(0, 10) : new Date().toISOString().substr(0, 10);
      this.currentHr.quantity = this.currentHr.openingQuantity;
      this.currentHr.age = this.currentHr.age;
      this.currentHr.gender = this.currentHr.gender;
      this.currentHr.mobile = this.currentHr.mobile;
      this.currentHr.email = this.currentHr.email;
      this.currentHr.marital = this.currentHr.marital;
      this.currentHr.StaffId = this.currentHr.StaffId;
      this.currentHr.name = this.currentHr.name;
      this.currentHr.basicSalary = this.currentHr.basicSalary;
      this.currentHr.netSalary = this.currentHr.netSalary;
      this.currentHr.generalConveyance = this.currentHr.generalConveyance;
      this.currentHr.specialConveyance = this.currentHr.specialConveyance;
      this.currentHr.medicalConveyance = this.currentHr.medicalConveyance;
      this.currentHr.epfAmount = this.currentHr.epfAmount;
      this.currentHr.esiAmount = this.currentHr.esiAmount;
      this.currentHr.professionalTaxAmount = this.currentHr.professionalTaxAmount;
      this.currentHr.tdsAmunt = this.currentHr.tdsAmunt;
      this.currentHr.casualLeave = this.currentHr.casualLeave;
      this.currentHr.bankName = this.currentHr.bankName;
      this.currentHr.accountType = this.currentHr.accountType;
      this.currentHr.accountNumber = this.currentHr.accountNumber;
      this.currentHr.accountHolderName = this.currentHr.accountHolderName;
      // this.currentHr.accountLocation = this.currentHr.accountLocation;
      // this.currentHr.ifsccode = this.currentHr.ifsccode;
      this.addHrDialog = true;
      if (!this.currentHr.unitsDeatilsAdded) {
        this.currentHr.unitsDetails = [{
          unit: '',
          isLast: true,
          isFirst: true,
          order: 1,
          quantity: 0
        }];
      }
    },
    deleteHr: function deleteHr(hr) {
      if (window.confirm("Do you want to Delete " + hr.name + "?")) {
        this.$root.$firebaseRefs.hrs.child(hr[".key"]).remove();
      }
    }
  },
  watch: {
    "currentHr.Designation": {
      handler: function handler(newVal, oldVal) {
        if (newVal != "Teacher") {
          this.currentHr.staffDesignationCategory = 0;
        }
      },

      deep: true
    }
    //  "currentHr.basicPrice": {
    //   handler(newVal, oldVal) {
    //     if (newVal != oldVal) {
    //       this.calculateOpeningBalance();
    //     }
    //   },
    //   deep: true
    // },
    // "currentHr.firm": {
    //   handler(newVal, oldVal) {
    //     if (newVal != oldVal) {
    //       this.getBusinessType();
    //     }
    //   },
    //   deep: true
    // },
    // "currentHr.gstValue": {
    //   handler(newVal, oldVal) {
    //     if (newVal != oldVal) {
    //       this.calculateOpeningBalance();
    //     }
    //   },
    //   deep: true
    // }
  }
});

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_firebase_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    var _ref;

    return _ref = {
      message: null,
      snackbar: false,
      timeout: 5000,
      dialog: null,
      permissionDialog: false,
      mobileRules: [function (v) {
        return (/^$/.test(v) || /^(\+91|\+91\-|0)?[6789]\d{9}$/.test(v) || "Mobile number is wrong"
        );
      }],
      emailRules: [function (v) {
        return !!v || "E-mail is required";
      }, function (v) {
        return (/.+@.+/.test(v) || "E-mail must be valid"
        );
      }],
      currentUser: null,
      permissionsObj: {
        PRODUCT_VIEW: false,
        PRODUCT_ADD: false,
        PRODUCT_EDIT: false,
        PRODUCT_DELETE: false,
        PRODUCT_TRANSFER: false,
        INVOICE_EDIT: false,
        INVOICE_DELETE: false,
        INVOICE_TRANSFER: false,
        BRAND_SETTINGS: false,
        BRAND_RECORDS: false,
        BRAND_REPORTS: false,
        AMOUNT_TRANSFER: false,
        BRAND_PRODUCTS: false,
        BRAND_DASHBOARD: false,
        BRAND_BUYER: false,
        BRAND_TRANSACTION: false,
        SALE_RATE_VIEW_EDIT: false,
        PURCHASE_RATE_VIEW_EDIT: false,
        ORDER_RATE_EDIT: false,
        INDIVIDUAL_ORDER_EDIT: false,
        INDIVIDUAL_ORDER_DELETE: false
      },
      email: ""
    }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "emailRules", [function (v) {
      return !!v || "E-mail is required";
    }, function (v) {
      return (/.+@.+/.test(v) || "E-mail must be valid"
      );
    }]), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "password", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "rePassword", ""), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "passwordRules", [function (v) {
      return !!v || "Password is required";
    }, function (v) {
      return v && v.length >= 8 || "Password must be Greater or equal to than 8 characters";
    }]), _ref;
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand"]), mapGlobalGetters({
    gVillage: "village",
    gBlock: "block",
    gTehsil: "tehsil",
    gDistrict: "district",
    gState: "state",
    gCountry: "country"
  }), {
    getAdmins: function getAdmins() {
      var _this = this;

      if (this.selectedBrand) {
        var a = this.operatorsList.filter(function (item) {
          return item["brand"] === _this.selectedBrand;
        });
        return a;
      }
    },
    branchByBrand: function branchByBrand() {
      var _this2 = this;

      return this.branches.filter(function (item) {
        return item["brand"] === _this2.selectedBrand;
      }).map(function (item) {
        return {
          text: item["branchName"],
          value: item[".key"]
        };
      });
    }
  }),
  watch: {},
  created: function created() {
    this.$bindAsObject("brands", this.$root.$firebaseRefs.brand);
    this.$bindAsObject("operators", this.$root.$firebaseRefs.operator);
    this.$bindAsArray("operatorsList", this.$root.$firebaseRefs.operator);
    this.$bindAsArray('branches', this.$root.$firebaseRefs.branch.orderByChild('brand').equalTo(this.selectedBrand));
  },
  destroyed: function destroyed() {
    // this.$unbind('brands')
    // this.$unbind('operators')
  },

  methods: {
    setLocationBasedOnZipCode: function setLocationBasedOnZipCode() {
      var _this3 = this;

      var reg = /^[1-9][0-9]{5}$/;
      console.log(this.currentUser.zipCode);
      if (this.currentUser.zipCode && reg.test(this.currentUser.zipCode)) {
        console.log("change");
        __WEBPACK_IMPORTED_MODULE_5_axios___default.a.get("https://api.postalpincode.in/pincode/" + this.currentUser.zipCode).then(function (response) {
          var data = response.data[0].PostOffice[0];
          _this3.gCountry.push(data.Country);
          _this3.gState.push(data.State);
          _this3.gDistrict.push(data.District);
          _this3.gTehsil.push(data.Block);
          setTimeout(function () {
            _this3.currentUser.country = data.Country;
            _this3.currentUser.district = data.District;
            _this3.currentUser.state = data.State;
            _this3.currentUser.tehsil = data.Block;
          }, 100);
        });
      }
    },
    openPermissionDialog: function openPermissionDialog(user) {
      this.currentUser = user;
      this.permissionDialog = true;
      this.getPermissionObject();
    },
    toggleUserActive: function toggleUserActive(user, event) {
      if (confirm("Are you sure you want to " + (!user.isActive ? "Deactive user?" : "Activate user?"))) {
        var key = user[".key"];
        delete user[".key"];
        this.$root.$firebaseRefs.operator.child(key).update(user, function () {
          console.info("item udpated...");
        });
      } else {
        event.preventDefault();
      }
    },
    isVerified: function isVerified() {
      if (this.password !== this.rePassword) {
        this.message = "Password didn't match";
        return false;
      }
      if (!this.password || !this.email) {
        this.message = "Wrong Input";
        return false;
      }
      return true;
    },
    signUp: function signUp() {
      var _this4 = this;

      if (!this.isVerified()) {
        this.snackbar = true;
        return;
      }
      __WEBPACK_IMPORTED_MODULE_4__services_firebase_js__["a" /* cfirebase */].auth().createUserWithEmailAndPassword(this.email, this.password).then(function (data) {
        _this4.message = "User Added Successful";
        _this4.snackbar = true;

        var brandKey = _this4.selectedBrand;
        _this4.addNewUser(data.user.uid, brandKey);
        _this4.dialog = false;
        _this4.sendEmailVerification();
      }).catch(function (error) {
        _this4.message = error.message;
        _this4.snackbar = true;
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;

        console.log(errorCode, errorMessage);
      });
    },
    addNewUser: function addNewUser(uid, brandKey) {
      this.$root.$firebaseRefs.operator.push({
        uid: uid,
        brand: brandKey,
        role: "admin",
        email: this.email,
        isActive: true
      });
    },
    getPermissionArray: function getPermissionArray() {
      var _this5 = this;

      var permissionArr = [];
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.permissionsObj).forEach(function (key) {
        if (_this5.permissionsObj[key]) {
          permissionArr.push(key);
        }
      });
      return permissionArr;
    },
    getPermissionObject: function getPermissionObject() {
      var _this6 = this;

      if (this.currentUser.permission) {
        this.currentUser.permission.map(function (item) {
          _this6.permissionsObj[item] = true;
        });
      }
    },
    sendEmailVerification: function sendEmailVerification() {
      __WEBPACK_IMPORTED_MODULE_4__services_firebase_js__["a" /* cfirebase */].auth().currentUser.sendEmailVerification();
    },
    savePermission: function savePermission() {
      var key = this.currentUser[".key"];
      delete this.currentUser[".key"];
      this.currentUser["permission"] = this.getPermissionArray();
      this.$root.$firebaseRefs.operator.child(key).update(this.currentUser, function () {
        console.info("item udpated...");
      });
      this.currentUser = null;
      this.permissionDialog = false;
    }
  }
});

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_firebase_js__ = __webpack_require__(37);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      message: null,
      snackbar: false,
      timeout: 5000,
      dialog: null,
      name: '',
      isEdit: false,
      currentGroup: {
        name: null,
        weight: null,
        quantity: null,
        brand: this.selectedBrand,
        openingBalance: null
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand']), {
    getGroups: function getGroups() {
      var _this = this;

      if (this.selectedBrand) {
        return this.productGroups.filter(function (item) {
          return item['brand'] === _this.selectedBrand;
        });
      }
    }
  }),
  watch: {},
  created: function created() {
    this.$bindAsArray('productGroups', this.$root.$firebaseRefs.productGroup.orderByChild('brand').equalTo(this.selectedBrand));
    if (this.$route.params.isNew) {
      this.dialog = true;
    }
  },
  destroyed: function destroyed() {},

  methods: {
    editGroup: function editGroup(item) {
      this.isEdit = true;
      this.dialog = true;
      this.currentGroup = item;
    },
    editGroupSave: function editGroupSave() {
      var _this2 = this;

      var key = this.currentGroup['.key'];
      delete this.currentGroup['.key'];
      this.$root.$firebaseRefs.productGroup.child(key).update(this.currentGroup).then(function (data) {
        _this2.message = 'Group Edited Successful';
        _this2.snackbar = true;
        _this2.dialog = false;
        _this2.isEdit = false;
        _this2.currentGroup = {
          name: null,
          brand: _this2.selectedBrand
        };
      }).catch(function (error) {
        _this2.message = error.message;
        _this2.snackbar = true;
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;

        console.log(errorCode, errorMessage);
      });
    },
    addNewGroup: function addNewGroup() {
      var _this3 = this;

      this.currentGroup.brand = this.selectedBrand;
      this.$root.$firebaseRefs.productGroup.push(this.currentGroup).then(function (data) {
        if (_this3.$route.params.redirect) {
          _this3.$router.push({ path: "/quick-invoice" });
        } else {
          _this3.message = 'Group Added Successful';
          _this3.snackbar = true;
          _this3.dialog = false;
        }
      }).catch(function (error) {
        _this3.message = error.message;
        _this3.snackbar = true;
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;

        console.log(errorCode, errorMessage);
      });
    }
  }
});

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_firebase_js__ = __webpack_require__(37);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      message: null,
      snackbar: false,
      timeout: 5000,
      dialog: null,
      name: '',
      isEdit: false,
      currentCategory: {
        name: null,
        brand: this.selectedBrand
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand']), {
    getCategories: function getCategories() {
      var _this = this;

      if (this.selectedBrand) {
        return this.productCategories.filter(function (item) {
          return item['brand'] === _this.selectedBrand;
        });
      }
    }
  }),
  watch: {},
  created: function created() {
    this.$bindAsArray('productCategories', this.$root.$firebaseRefs.productCategory.orderByChild('brand').equalTo(this.selectedBrand));
    if (this.$route.params.isNew) {
      this.dialog = true;
    }
  },
  destroyed: function destroyed() {},

  methods: {
    editCategory: function editCategory(item) {
      this.isEdit = true;
      this.dialog = true;
      this.currentCategory = item;
    },
    editCategorySave: function editCategorySave() {
      var _this2 = this;

      var key = this.currentCategory['.key'];
      delete this.currentCategory['.key'];
      this.$root.$firebaseRefs.productCategory.child(key).update(this.currentCategory).then(function (data) {
        _this2.message = 'Category Edited Successful';
        _this2.snackbar = true;
        _this2.dialog = false;
        _this2.isEdit = false;
        _this2.currentCategory = {
          name: null,
          brand: _this2.selectedBrand
        };
      }).catch(function (error) {
        _this2.message = error.message;
        _this2.snackbar = true;
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;

        console.log(errorCode, errorMessage);
      });
    },
    addNewCategory: function addNewCategory() {
      var _this3 = this;

      this.currentCategory.brand = this.selectedBrand;
      this.$root.$firebaseRefs.productCategory.push(this.currentCategory).then(function (data) {
        if (_this3.$route.params.redirect) {
          _this3.$router.push({ path: "/quick-invoice" });
        } else {
          _this3.message = 'Category Added Successful';
          _this3.snackbar = true;
          _this3.dialog = false;
        }
      }).catch(function (error) {
        _this3.message = error.message;
        _this3.snackbar = true;
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;

        console.log(errorCode, errorMessage);
      });
    }
  }
});

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_firebase_js__ = __webpack_require__(37);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      message: null,
      snackbar: false,
      timeout: 5000,
      dialog: null,
      name: '',
      isEdit: false,
      currentCategory: {
        name: null,
        brand: this.selectedBrand
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand']), {
    getCategories: function getCategories() {
      var _this = this;

      if (this.selectedBrand) {
        return this.productCategories.filter(function (item) {
          return item['brand'] === _this.selectedBrand;
        });
      }
    }
  }),
  watch: {},
  created: function created() {
    this.$bindAsArray('productCategories', this.$root.$firebaseRefs.productRateCategory.orderByChild('brand').equalTo(this.selectedBrand));
    if (this.$route.params.isNew) {
      this.dialog = true;
    }
  },
  destroyed: function destroyed() {},

  methods: {
    editCategory: function editCategory(item) {
      this.isEdit = true;
      this.dialog = true;
      this.currentCategory = item;
    },
    editCategorySave: function editCategorySave() {
      var _this2 = this;

      var key = this.currentCategory['.key'];
      delete this.currentCategory['.key'];
      this.$root.$firebaseRefs.productRateCategory.child(key).update(this.currentCategory).then(function (data) {
        _this2.message = 'Category Edited Successful';
        _this2.snackbar = true;
        _this2.dialog = false;
        _this2.isEdit = false;
        _this2.currentCategory = {
          name: null,
          brand: _this2.selectedBrand
        };
      }).catch(function (error) {
        _this2.message = error.message;
        _this2.snackbar = true;
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;

        console.log(errorCode, errorMessage);
      });
    },
    addNewCategory: function addNewCategory() {
      var _this3 = this;

      this.currentCategory.brand = this.selectedBrand;
      this.$root.$firebaseRefs.productRateCategory.push(this.currentCategory).then(function (data) {
        if (_this3.$route.params.redirect) {
          _this3.$router.push({ path: "/quick-invoice" });
        } else {
          _this3.message = 'Category Added Successful';
          _this3.snackbar = true;
          _this3.dialog = false;
        }
      }).catch(function (error) {
        _this3.message = error.message;
        _this3.snackbar = true;
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;

        console.log(errorCode, errorMessage);
      });
    }
  }
});

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Buyer")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      productsToProductSet: [],
      productSetName: null,
      items: [],
      productSetDialog: false,
      selectedProductSet: null,
      viewProductSetDialog: false,
      productSetHeader: [{ text: "View", value: "quantity" }, { text: "Product Set Name", value: "deposit - ID" }, { text: "Total Amount", value: "name" }, { text: "Edit", value: "edit" }, { text: "Delete", value: "edit" }],
      productInvoiceHeader: [{ text: "Name", value: "Name" }, { text: "Quantity", value: "Taxable" }, { text: "unit", value: "HSN" }, { text: "Rate", value: "rate" }, { text: "Fetch", value: "fetch" }]

    };
  },
  created: function created() {
    this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray("productSets", this.$root.$firebaseRefs.productSets.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsObject('productById', this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand));
    if (this.$route.params.isNew) {
      this.productSetDialog = true;
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", 'finYear']), mapGlobalGetters({ units: "productUnit" }), {
    productListByBrand: function productListByBrand() {
      var _this = this;

      return this.products.filter(function (item) {
        return item["brand"] === _this.selectedBrand && (item.openingDate ? item.openingDate >= _this.finYear.start && item.openingDate <= _this.finYear.end : true);
      });
    },
    productSetsByBrand: function productSetsByBrand() {
      var _this2 = this;

      return this.productSets.filter(function (item) {
        return item["brand"] === _this2.selectedBrand && (item.date ? item.date >= _this2.finYear.start && item.date <= _this2.finYear.end : true);
      });
    }
  }),
  methods: {
    openProd: function openProd(item) {
      this.selectedProductSet = item;
      this.viewProductSetDialog = true;
    },
    getTotal: function getTotal(item) {
      var total = 0;
      item.items.map(function (i) {
        total += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(i.rate) * __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(i.quantity));
      });
      return total;
    },
    fetchLatestRate: function fetchLatestRate(item) {
      var prod = this.products.find(function (item1) {
        return item1[".key"] == item.productId;
      });
      item.rate = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(prod && prod.sellingPrice || 0);
    },
    fetchLatestRateBulk: function fetchLatestRateBulk() {
      var _this3 = this;

      this.selectedProductSet.items.map(function (item) {
        return _this3.fetchLatestRate(item);
      });
    },
    addToBucket: function addToBucket() {
      var _this4 = this;

      this.items = [];
      this.productsToProductSet.map(function (prod) {
        _this4.items.push({
          productName: prod.name,
          productId: prod['.key'],
          quantity: 1,
          unit: prod.unit,
          rate: _this4.isBuyer ? prod["sellingPrice"] || 0 : prod["purchasingPrice"] || 0
        });
      });
    },
    addProductSet: function addProductSet() {
      var productSetObj = {
        brand: this.selectedBrand,
        items: this.items,
        name: this.productSetName
      };
      this.$root.$firebaseRefs.productSets.push(productSetObj);
      if (this.$route.params.redirect) {
        this.$router.push({ path: "/quick-invoice" });
      } else {
        this.productSetDialog = false;
        this.selectedBuyer = null;
        this.productSetName = null;
        this.items = [];
        this.productsToProductSet = [];
      }
    },
    deleteProductSet: function deleteProductSet(productSet) {
      if (window.confirm("Do you want to Delete ?")) {
        this.$root.$firebaseRefs.productSets.child(productSet[".key"]).remove();
      }
    },
    editProductSet: function editProductSet(set) {
      var _this5 = this;

      this.selectedProductSet = set;
      this.productSetName = this.selectedProductSet.name;
      this.items = this.selectedProductSet.items;
      this.productSetDialog = true;
      this.productsToProductSet = [];
      this.items.map(function (item) {
        var prod = _this5.products.find(function (prod) {
          return prod['.key'] == item['productId'];
        });
        prod && _this5.productsToProductSet.push(prod);
      });
    },
    updateProductSet: function updateProductSet() {
      this.selectedProductSet['items'] = this.items;
      this.selectedProductSet['name'] = this.productSetName;
      this.saveUpdatedSet();
    },
    saveUpdatedSet: function saveUpdatedSet() {
      var _this6 = this;

      var key = this.selectedProductSet[".key"];
      delete this.selectedProductSet[".key"];
      this.$root.$firebaseRefs.productSets.child(key).update(this.selectedProductSet, function () {
        _this6.selectedProductSet = null;
        _this6.productSetDialog = false;
        _this6.viewProductSetDialog = false;
      });
    }
  }
});

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_firebase_js__ = __webpack_require__(37);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      message: null,
      snackbar: false,
      timeout: 5000,
      dialog: null,
      name: '',
      isEdit: false,
      currentType: {
        name: null,
        brand: this.selectedBrand
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand']), {
    getTypes: function getTypes() {
      var _this = this;

      if (this.selectedBrand) {
        return this.productTypes.filter(function (item) {
          return item['brand'] === _this.selectedBrand;
        });
      }
    }
  }),
  watch: {},
  created: function created() {
    this.$bindAsArray('productTypes', this.$root.$firebaseRefs.productType.orderByChild('brand').equalTo(this.selectedBrand));
    if (this.$route.params.isNew) {
      this.dialog = true;
    }
  },
  destroyed: function destroyed() {},

  methods: {
    editType: function editType(item) {
      this.isEdit = true;
      this.dialog = true;
      this.currentType = item;
    },
    editTypeSave: function editTypeSave() {
      var _this2 = this;

      var key = this.currentType['.key'];
      delete this.currentType['.key'];
      this.$root.$firebaseRefs.productType.child(key).update(this.currentType).then(function (data) {
        _this2.message = 'Type Edited Successful';
        _this2.snackbar = true;
        _this2.dialog = false;
        _this2.isEdit = false;
        _this2.currentType = {
          name: null,
          brand: _this2.selectedBrand
        };
      }).catch(function (error) {
        _this2.message = error.message;
        _this2.snackbar = true;
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;

        console.log(errorCode, errorMessage);
      });
    },
    addNewType: function addNewType() {
      var _this3 = this;

      this.currentType.brand = this.selectedBrand;
      this.$root.$firebaseRefs.productType.push(this.currentType).then(function (data) {
        if (_this3.$route.params.redirect) {
          _this3.$router.push({ path: "/quick-invoice" });
        } else {
          _this3.message = 'Type Added Successful';
          _this3.snackbar = true;
          _this3.dialog = false;
        }
      }).catch(function (error) {
        _this3.message = error.message;
        _this3.snackbar = true;
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;

        console.log(errorCode, errorMessage);
      });
    }
  }
});

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_barcodePrint__ = __webpack_require__(241);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])("Buyer")["mapGetters"];

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      datePicker: null,
      productSetDialog: false,
      currentSet: null,
      productSetHeader: [{ text: "UniqueId", value: "deposit - ID" }, { text: "Barcode", value: "barcode" }, { text: "Net Weight", value: "name" }, { text: "Purity", value: "purity" }, { text: "less", value: "lessStone" }, { text: "Sold", value: "name" }, { text: "Edit", value: "edit" }, { text: "Print Barcode", value: "edit" }, { text: "Delete", value: "edit" }]
    };
  },
  created: function created() {
    this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("productUniqueIds", this.$root.$firebaseRefs.productUniqueId.orderByChild("brand").equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear"]), mapGlobalGetters({ units: "productUnit" }), {
    productListByBrand: function productListByBrand() {
      var _this = this;

      return this.products.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      }).map(function (p) {
        return { title: p.name, value: p[".key"] };
      });
    },
    productSetsByBrand: function productSetsByBrand() {
      var _this2 = this;

      return this.productSets.filter(function (item) {
        return item["brand"] === _this2.selectedBrand && (item.date ? item.date >= _this2.finYear.start && item.date <= _this2.finYear.end : true);
      });
    }
  }),
  watch: {
    "currentSet.barcode": {
      handler: function handler(newVal, oldVal) {
        JsBarcode("#barcode", this.currentSet.barcode);
      },

      deep: true
    }
  },
  methods: {
    save: function save() {
      this.currentSet.date = new Date(this.currentSet.date).getTime();
      this.$root.$firebaseRefs.productUniqueId.push(this.currentSet);
      this.productSetDialog = false;
    },
    generateBarcode: function generateBarcode(barcode) {
      if (barcode == null) {
        this.currentSet.barcode = new Date().getTime() + "";
      }
    },
    printBarcode: function printBarcode(item) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                JsBarcode("#barcode", item.barcode);
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_4__utils_barcodePrint__["a" /* barcodePrintPDF */])({
                  productName: _this3.productListByBrand.find(function (i) {
                    return i['value'] == item.product;
                  }).title,
                  grossWeight: item.grossWeight,
                  purity: item.purity,
                  lessStone: item.lessStone
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    addProductSet: function addProductSet() {
      this.currentSet = {
        brand: this.selectedBrand,
        date: new Date().toISOString().substr(0, 10),
        grossWeight: 0,
        purity: 0,
        lessStone: 0,
        unqId: null,
        sold: false,
        product: null,
        barcode: ""
      };
      this.productSetDialog = true;
    },
    edit: function edit(productSet) {
      this.currentSet = productSet;
      this.currentSet.date = new Date(this.currentSet.date).toISOString().substr(0, 10);
      this.productSetDialog = true;
    },
    update: function update() {
      var _this4 = this;

      this.currentSet.date = new Date(this.currentSet.date).getTime();
      var key = this.currentSet[".key"];
      delete this.currentSet[".key"];
      this.$root.$firebaseRefs.productUniqueId.child(key).update(this.currentSet).then(function (data) {
        _this4.currentSet = null;
        _this4.productSetDialog = false;
      }).catch(function (error) {
        console.log(error.code, error.message);
      });
    },
    deleteProductSet: function deleteProductSet(productSet) {
      if (window.confirm("Do you want to Delete ?")) {
        this.$root.$firebaseRefs.productUniqueId.child(productSet[".key"]).remove();
      }
    }
  }
});

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])("Buyer")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      productOfferDialog: false,
      productOffersHeader: [{ text: "Product", value: "deposit - ID" }, { text: "Edit", value: "edit" }],
      selectedProduct: {
        offers: []
      },
      datepicker1: [],
      datepicker2: []
    };
  },
  created: function created() {
    this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild("brand").equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear"]), mapGlobalGetters({ units: "productUnit" }), {
    productListByBrand: function productListByBrand() {
      var _this = this;

      return this.products.filter(function (item) {
        return item["brand"] === _this.selectedBrand && (item.openingDate ? item.openingDate >= _this.finYear.start && item.openingDate <= _this.finYear.end : true);
      });
    }
  }),
  methods: {
    updateProduct: function updateProduct() {
      var _this2 = this;

      this.selectedProduct.offers.map(function (item, index) {
        _this2.selectedProduct.offers[index].startDate = new Date(item.startDate).getTime(), _this2.selectedProduct.offers[index].endDate = new Date(item.endDate).getTime();
      });
      var key = this.selectedProduct[".key"];
      delete this.selectedProduct[".key"];
      this.$root.$firebaseRefs.products.child(key).set(this.selectedProduct).then(function (snap) {
        _this2.productOfferDialog = false;
        _this2.selectedProduct = {
          offers: []
        };
      });
    },
    editProduct: function editProduct(item) {
      var _this3 = this;

      this.selectedProduct = item;
      if (!this.selectedProduct.offers) {
        this.selectedProduct.offers = [];
      } else {
        this.selectedProduct.offers.map(function (item, index) {
          _this3.selectedProduct.offers[index].startDate = new Date(item.startDate).toISOString().substr(0, 10);
          _this3.selectedProduct.offers[index].endDate = new Date(item.endDate).toISOString().substr(0, 10);
        });
      }
      this.productOfferDialog = true;
    },
    addProd: function addProd() {
      this.selectedProduct.offers.push({
        minQuantity: 1,
        offerQuantity: 1,
        startDate: new Date().toISOString().substr(0, 10),
        endDate: new Date().toISOString().substr(0, 10)
      });
      this.selectedProduct = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.selectedProduct);
    },
    removeProd: function removeProd(index) {
      this.selectedProduct.offers.splice(index, 1);
    }
  }
});

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Buyer")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      datePicker: null,
      menufDialog: false,
      currentMenuf: null,
      manufHeader: [{ text: "Old Product Name", value: "deposit - ID" }, { text: "New Product Name", value: "deposit - ID" }, { text: "Customer Name", value: "deposit - ID" }, { text: "Date", value: "name" }, { text: "Edit", value: "edit" }, { text: "Delete", value: "delete" }]
    };
  },
  created: function created() {
    this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("productMenufs", this.$root.$firebaseRefs.productReplaceTransaction.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("buyers", this.$root.$firebaseRefs.buyer.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("sellers", this.$root.$firebaseRefs.seller.orderByChild("brand").equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear"]), mapGlobalGetters({ units: "productUnit" }), {
    productsByBrand: function productsByBrand() {
      var _this = this;

      return this.products.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      }).map(function (item) {
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
    },
    productMenufsList: function productMenufsList() {
      return this.productMenufs;
    },
    buyersByBrand: function buyersByBrand() {
      var _this2 = this;

      return this.buyers.filter(function (item) {
        return item["brand"] === _this2.selectedBrand;
      }).map(function (item) {
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
    },
    sellersByBrand: function sellersByBrand() {
      var _this3 = this;

      return this.sellers.filter(function (item) {
        return item["brand"] === _this3.selectedBrand;
      }).map(function (item) {
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
    }
  }),
  methods: {
    save: function save() {
      this.convert("save");
    },
    getCustomerName: function getCustomerName(id) {
      var buyer = this.buyersByBrand.find(function (i) {
        return i["value"] == id;
      });
      var seller = this.sellersByBrand.find(function (i) {
        return i["value"] == id;
      });
      if (!buyer && !seller) {
        return "DELETED CUSTOMER";
      }
      return buyer ? buyer.text : seller.text;
    },
    saveFinal: function saveFinal() {
      this.currentMenuf.date = new Date(this.currentMenuf.date).getTime();
      this.$root.$firebaseRefs.productReplaceTransaction.push(this.currentMenuf);
      this.menufDialog = false;
    },
    addDamage: function addDamage() {
      this.currentMenuf = {
        brand: this.selectedBrand,
        date: new Date().toISOString().substr(0, 10),
        productId: null,
        quantity: 1,
        buyerId: null,
        isBuyer: true
      };
      this.menufDialog = true;
    },
    edit: function edit(productSet) {
      this.currentMenuf = productSet;
      this.currentMenuf.date = new Date(this.currentMenuf.date).toISOString().substr(0, 10);
      this.menufDialog = true;
    },
    update: function update() {
      this.convertBack("update");
    },
    updateFinal: function updateFinal() {
      var _this4 = this;

      this.currentMenuf.date = new Date(this.currentMenuf.date).getTime();
      var key = this.currentMenuf[".key"];
      delete this.currentMenuf[".key"];
      this.$root.$firebaseRefs.productReplaceTransaction.child(key).update(this.currentMenuf).then(function (data) {
        _this4.currentMenuf = null;
        _this4.menufDialog = false;
      }).catch(function (error) {
        console.log(error.code, error.message);
      });
    },
    deleteMenuf: function deleteMenuf(productSet) {
      if (window.confirm("Do you want to Delete ?")) {
        this.currentMenuf = productSet;
        this.convertBack("delete");
      }
    },
    getProductName: function getProductName(key) {
      return this.products.find(function (item) {
        return item[".key"] == key;
      }).name;
    },
    deletefinal: function deletefinal() {
      this.$root.$firebaseRefs.productReplaceTransaction.child(this.currentMenuf[".key"]).remove();
    },
    convert: function convert(action) {
      var _this5 = this;

      var prod = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.products.find(function (item) {
        return item[".key"] == _this5.currentMenuf.productId;
      }));
      var newprod = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.products.find(function (item) {
        return item[".key"] == _this5.currentMenuf.newProductId;
      }));
      if (prod) {
        var purchaseQuantity = prod["purchaseQuantity"] ? prod["purchaseQuantity"] : 0;
        purchaseQuantity = purchaseQuantity - __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(this.currentMenuf.quantity);
        var prodQuantity = prod["quantity"];
        prodQuantity = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(prodQuantity) - __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(this.currentMenuf.quantity);
        var key = prod[".key"];
        delete prod[".key"];
        prod["quantity"] = prodQuantity;
        this.$root.$firebaseRefs.products.child(key).set(prod);
      }

      if (newprod) {
        var _purchaseQuantity = newprod["purchaseQuantity"] ? newprod["purchaseQuantity"] : 0;
        _purchaseQuantity = _purchaseQuantity + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(this.currentMenuf.newProductQuantity);
        var _prodQuantity = newprod["quantity"];
        _prodQuantity = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(_prodQuantity) - __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(this.currentMenuf.newProductQuantity);
        var _key = newprod[".key"];
        delete newprod[".key"];
        newprod["quantity"] = _prodQuantity;
        this.$root.$firebaseRefs.products.child(_key).set(newprod);
      }

      this.performAction(action, true);
    },
    convertBack: function convertBack(action) {
      var _this6 = this;

      var prod = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.products.find(function (item) {
        return item[".key"] == _this6.currentMenuf.productId;
      }));

      var newprod = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.products.find(function (item) {
        return item[".key"] == _this6.currentMenuf.newProductId;
      }));
      if (prod) {
        var purchaseQuantity = prod["purchaseQuantity"] ? prod["purchaseQuantity"] : 0;
        purchaseQuantity = purchaseQuantity + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(this.currentMenuf.quantity);
        var prodQuantity = prod["quantity"];
        prodQuantity = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(prodQuantity) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(this.currentMenuf.quantity);
        var key = prod[".key"];
        delete prod[".key"];
        prod["quantity"] = prodQuantity;
        this.$root.$firebaseRefs.products.child(key).set(prod);
      }

      if (newprod) {
        var _purchaseQuantity2 = newprod["purchaseQuantity"] ? newprod["purchaseQuantity"] : 0;
        _purchaseQuantity2 = _purchaseQuantity2 - __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(this.currentMenuf.newProductQuantity);
        var _prodQuantity2 = newprod["quantity"];
        _prodQuantity2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(_prodQuantity2) - __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(this.currentMenuf.newProductQuantity);
        var _key2 = newprod[".key"];
        delete newprod[".key"];
        newprod["quantity"] = _prodQuantity2;
        this.$root.$firebaseRefs.products.child(_key2).set(newprod);
      }

      this.performAction(action, false);
    },
    performAction: function performAction(action, isUpdateDone) {
      switch (action) {
        case "save":
          {
            this.saveFinal();
            break;
          }
        case "update":
          {
            if (isUpdateDone) {
              this.updateFinal();
            } else {
              this.convert(action);
            }
            break;
          }
        case "delete":
          {
            this.deletefinal();
            break;
          }
      }
    }
  }
});

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])("Buyer")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      productDrawerDialog: false,
      currentDrawer: null,
      datePicker: false,
      productViewDialog: false,
      productTransactionDialog: false,
      isAddEditMode: false,
      transactions: [],
      productDrawerHeader: [{ text: "View", value: "deposit - ID" }, { text: "Drawer Name", value: "deposit - ID" }, { text: "Edit", value: "edit" }],
      currentEntry: null,
      productTransactionHeader: [{ text: "Date", value: "deposit - ID" }, { text: "Invoice Id", value: "deposit - ID" }, { text: "Quantity", value: "deposit - ID" }, { text: "Edit", value: "edit" }]
    };
  },
  created: function created() {
    this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("productDrawers", this.$root.$firebaseRefs.productDrawer.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("drawerTransactions", this.$root.$firebaseRefs.drawerTransaction.orderByChild("brand").equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear"]), mapGlobalGetters({ units: "productUnit" }), {
    productListByBrand: function productListByBrand() {
      var _this = this;

      return this.products.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      }).map(function (item) {
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
    },
    productDrawersByBrand: function productDrawersByBrand() {
      var _this2 = this;

      return this.productDrawers.filter(function (item) {
        return item["brand"] === _this2.selectedBrand;
      });
    }
  }),
  methods: {
    addDrawer: function addDrawer() {
      this.currentDrawer = {
        name: null,
        items: [{
          product: null
        }],
        brand: this.selectedBrand
      };
      this.productDrawerDialog = true;
    },
    save: function save() {
      this.$root.$firebaseRefs.productDrawer.push(this.currentDrawer);
      this.productDrawerDialog = false;
    },
    saveTrnasaction: function saveTrnasaction() {
      var _this3 = this;

      this.currentEntry.date = new Date(this.currentEntry.date).getTime();
      this.$root.$firebaseRefs.drawerTransaction.push(this.currentEntry);
      this.isAddEditMode = false;
      this.currentEntry = false;
      this.transactions = this.drawerTransactions.filter(function (item) {
        return item["brand"] === _this3.selectedBrand && item["product"] == _this3.currentProductId && item.drawer == _this3.currentDrawer[".key"];
      });
    },
    viewDrawer: function viewDrawer(set) {
      this.currentDrawer = set;
      this.productViewDialog = true;
    },
    addEntry: function addEntry() {
      this.isAddEditMode = true;
      this.currentEntry = {
        brand: this.selectedBrand,
        quantity: 1,
        date: new Date().toISOString().substr(0, 10),
        product: this.currentProductId,
        drawer: this.currentDrawer[".key"]
      };
    },
    editProductDrawer: function editProductDrawer(set) {
      this.currentDrawer = set;
      this.productDrawerDialog = true;
    },
    editEntry: function editEntry(set) {
      this.currentEntry = set;
      this.currentEntry.date = new Date(this.currentEntry.date).toISOString().substr(0, 10), this.isAddEditMode = true;
    },
    viewTransactions: function viewTransactions(productId) {
      var _this4 = this;

      this.currentProductId = productId;
      this.productTransactionDialog = true;
      this.transactions = this.drawerTransactions.filter(function (item) {
        return item["brand"] === _this4.selectedBrand && item["product"] == _this4.currentProductId && item.drawer == _this4.currentDrawer[".key"];
      });
    },
    addProd: function addProd() {
      var itemToAdd = {
        product: null
      };
      this.currentDrawer.items.push(itemToAdd);
    },
    removeProd: function removeProd(index) {
      this.currentDrawer.items.splice(index, 1);
    },
    updateProductDrawer: function updateProductDrawer() {
      var _this5 = this;

      var key = this.currentDrawer[".key"];
      delete this.currentDrawer[".key"];
      this.$root.$firebaseRefs.productDrawer.child(key).update(this.currentDrawer, function () {
        _this5.currentDrawer = null;
        _this5.productDrawerDialog = false;
      });
    },
    udpateTransaction: function udpateTransaction() {
      var _this6 = this;

      var key = this.currentEntry[".key"];
      delete this.currentEntry[".key"];
      this.currentEntry.date = new Date(this.currentEntry.date).getTime();
      this.$root.$firebaseRefs.drawerTransaction.child(key).update(this.currentEntry, function () {
        _this6.currentEntry = null;
        _this6.isAddEditMode = false;
        _this6.transactions = _this6.drawerTransactions.filter(function (item) {
          return item["brand"] === _this6.selectedBrand && item["product"] == _this6.currentProductId && item.drawer == _this6.currentDrawer[".key"];
        });
      });
    }
  }
});

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_firebase_js__ = __webpack_require__(37);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      message: null,
      snackbar: false,
      snackbarSuccessText: ''
    };
  },


  watch: {},
  created: function created() {
    this.$bindAsArray('buyer', this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('seller', this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('invoice', this.$root.$firebaseRefs.invoice.orderByChild('brandFinYear').equalTo(this.brandFinYear));
    // this.$bindAsArray(
    //   'item',
    //   this.$root.$firebaseRefs.item.orderByChild('brand').equalTo(this.selectedBrand)
    // )
    this.$bindAsArray('firm', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('account', this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('loan', this.$root.$firebaseRefs.loan.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('staffs', this.$root.$firebaseRefs.staffs.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('staff', this.$root.$firebaseRefs.staff.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('expenses', this.$root.$firebaseRefs.expenses.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('liabilities', this.$root.$firebaseRefs.liabilities.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('incomes', this.$root.$firebaseRefs.incomes.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('customerDeposit', this.$root.$firebaseRefs.customerDeposit.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('products', this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('invoiceHistory', this.$root.$firebaseRefs.invoiceHistory.orderByChild('brandFinYear').equalTo(this.brandFinYear));
    this.$bindAsArray('salarys', this.$root.$firebaseRefs.salarys.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('termsAndConditions', this.$root.$firebaseRefs.termsAndConditions.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('provisionExpense', this.$root.$firebaseRefs.provisionExpense.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('provisionLiability', this.$root.$firebaseRefs.provisionLiability.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('provisionIncome', this.$root.$firebaseRefs.provisionIncome.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('itcPayment', this.$root.$firebaseRefs.itcPayment.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('godawn', this.$root.$firebaseRefs.godawn.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('godawnTransaction', this.$root.$firebaseRefs.godawnTransaction.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('closingDetails', this.$root.$firebaseRefs.closingDetails.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('productGroup', this.$root.$firebaseRefs.productGroup.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('batchTransaction', this.$root.$firebaseRefs.batchTransaction.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('damageTransaction', this.$root.$firebaseRefs.damageTransaction.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('orders', this.$root.$firebaseRefs.orders.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('firmSettings', this.$root.$firebaseRefs.firmSettings.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('hrs', this.$root.$firebaseRefs.hrs.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('productType', this.$root.$firebaseRefs.productType.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('estimates', this.$root.$firebaseRefs.estimates.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('productSets', this.$root.$firebaseRefs.productSets.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('customerPayments', this.$root.$firebaseRefs.customerPayments.orderByChild('brand').equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand', 'brandFinYear'])),
  destroyed: function destroyed() {},

  methods: {
    uploadFile: function uploadFile() {
      document.getElementById('importDataFile').click();
    },
    deleteIndividualDataSet: function deleteIndividualDataSet(table) {
      // if(this.selectedBrand && confirm('Are you sure you want to delete data of ' + table+ '?')) {
      //   let data = this[table].filter(item=> item['brand'] == this.selectedBrand);
      //   data.map((item)=>{
      //     let key = item['.key'];
      //     this.$root.$firebaseRefs[table].child(key).remove();
      //   })
      //   this.snackbar = true;
      //   this.snackbarSuccessText = "Data is successfully Deleted for " + table + ".";
      // }
    },
    loadImportedFile: function loadImportedFile(ev) {
      var _this = this;

      var file = ev.target.files[0];
      var fr = new FileReader();
      fr.onload = function (e) {
        var result = JSON.parse(e.target.result);
        var formatted = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(result, null, 2);
        if (confirm("Are you sure you want to import all data?")) {
          _this.importAllData(formatted);
        }
      };
      fr.readAsText(file);
    },
    importAllData: function importAllData(data) {
      var _this2 = this;

      var dataDetails = data['dataDetails'];
      delete data['dataDetails'];
      if (!!this.selectedBrand && dataDetails.brand == this.selectedBrand) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data).forEach(function (table) {
          data[table].map(function (item) {
            var key = item['.key'];
            delete item['.key'];
            _this2.$root.$firebaseRefs[table].child(key).update(item);
          });
        });
        this.snackbar = true;
        this.snackbarSuccessText = "Data is successfully imported.";
      }
    },
    removeAllData: function removeAllData() {
      var _this3 = this;

      var data = this.getCurrentBrandData();
      if (confirm("Are you sure you want to remove all data?")) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(data).forEach(function (table) {
          data[table].map(function (item) {
            var key = item['.key'];
            _this3.$root.$firebaseRefs[table].child(key).remove();
          });
        });
        this.snackbar = true;
        this.snackbarSuccessText = "Data is successfully Deleted.";
      }
    },
    getCurrentBrandData: function getCurrentBrandData() {
      var _this4 = this;

      if (!!this.selectedBrand) {
        var data = {};
        data['buyer'] = this.buyer.filter(function (item) {
          return item['brand'] == _this4.selectedBrand;
        });
        data['seller'] = this.seller.filter(function (item) {
          return item['brand'] == _this4.selectedBrand;
        });
        data['invoice'] = this.invoice.filter(function (item) {
          return item['brand'] == _this4.selectedBrand;
        });
        data['item'] = this.item.filter(function (item) {
          return item['brand'] == _this4.selectedBrand;
        });
        data['firm'] = this.firm.filter(function (item) {
          return item['brand'] == _this4.selectedBrand;
        });
        data['account'] = this.account.filter(function (item) {
          return item['brand'] == _this4.selectedBrand;
        });
        data['loan'] = this.loan.filter(function (item) {
          return item['brand'] == _this4.selectedBrand;
        });
        data['staffs'] = this.staffs.filter(function (item) {
          return item['brand'] == _this4.selectedBrand;
        });
        data['staff'] = this.staff.filter(function (item) {
          return item['brand'] == _this4.selectedBrand;
        });
        data['expenses'] = this.expenses.filter(function (item) {
          return item['brand'] == _this4.selectedBrand;
        });
        data['liabilities'] = this.liabilities.filter(function (item) {
          return item['brand'] == _this4.selectedBrand;
        });
        data['incomes'] = this.incomes.filter(function (item) {
          return item['brand'] == _this4.selectedBrand;
        });
        data['customerDeposit'] = this.customerDeposit.filter(function (item) {
          return item['brand'] == _this4.selectedBrand;
        });
        data['products'] = this.products.filter(function (item) {
          return item['brand'] == _this4.selectedBrand;
        });
        data['invoiceHistory'] = this.invoiceHistory.filter(function (item) {
          return item['brand'] == _this4.selectedBrand;
        });
        data['salarys'] = this.salarys.filter(function (item) {
          return item['brand'] == _this4.selectedBrand;
        });
        data['termsAndConditions'] = this.termsAndConditions.filter(function (item) {
          return item['brand'] == _this4.selectedBrand;
        });
        data['provisionExpense'] = this.provisionExpense.filter(function (item) {
          return item['brand'] == _this4.selectedBrand;
        });
        data['provisionLiability'] = this.provisionLiability.filter(function (item) {
          return item['brand'] == _this4.selectedBrand;
        });
        data['provisionIncome'] = this.provisionIncome.filter(function (item) {
          return item['brand'] == _this4.selectedBrand;
        });
        data['itcPayment'] = this.itcPayment.filter(function (item) {
          return item['brand'] == _this4.selectedBrand;
        });
        data['godawn'] = this.godawn.filter(function (item) {
          return item['brand'] == _this4.selectedBrand;
        });
        data['godawnTransaction'] = this.godawnTransaction.filter(function (item) {
          return item['brand'] == _this4.selectedBrand;
        });
        data['closingDetails'] = this.closingDetails.filter(function (item) {
          return item['brand'] == _this4.selectedBrand;
        });
        data['productGroup'] = this.productGroup.filter(function (item) {
          return item['brand'] == _this4.selectedBrand;
        });
        data['batchTransaction'] = this.batchTransaction.filter(function (item) {
          return item['brand'] == _this4.selectedBrand;
        });
        data['damageTransaction'] = this.damageTransaction.filter(function (item) {
          return item['brand'] == _this4.selectedBrand;
        });
        data['orders'] = this.orders.filter(function (item) {
          return item['brand'] == _this4.selectedBrand;
        });
        data['firmSettings'] = this.firmSettings.filter(function (item) {
          return item['brand'] == _this4.selectedBrand;
        });
        data['hrs'] = this.hrs.filter(function (item) {
          return item['brand'] == _this4.selectedBrand;
        });
        data['productType'] = this.productType.filter(function (item) {
          return item['brand'] == _this4.selectedBrand;
        });
        data['estimates'] = this.estimates.filter(function (item) {
          return item['brand'] == _this4.selectedBrand;
        });
        data['productSets'] = this.productSets.filter(function (item) {
          return item['brand'] == _this4.selectedBrand;
        });
        data['customerPayments'] = this.customerPayments.filter(function (item) {
          return item['brand'] == _this4.selectedBrand;
        });
        return data;
      }
    },
    exportAllData: function exportAllData() {
      var data = this.getCurrentBrandData();
      data['dataDetails'] = {
        brand: this.selectedBrand,
        date: new Date().getTime()
      };
      this.exportToJsonFile(data);
    },
    exportToJsonFile: function exportToJsonFile(jsonData) {
      var dataStr = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(jsonData, null, 4);
      var dataUri = 'data:application/json;charset=utf-8,' + encodeURIComponent(dataStr);
      var exportFileDefaultName = 'data_' + new Date().toISOString().substr(0, 10) + '.json';
      var linkElement = document.createElement('a');
      linkElement.setAttribute('href', dataUri);
      linkElement.setAttribute('download', exportFileDefaultName);
      linkElement.click();
    }
  }
});

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      addSettingsDialog: false,
      currentSettings: {
        firm: null,
        invoiceIdPrefix: "",
        roundOff: false,
        verifiedInvoice: false,
        autoCounter: false,
        stockReportView: "APP",
        ewayBill: false,
        brand: null,
        invoiceIdByDate: false,
        deleteWithPassword: false,
        deleteInvoicePassword: null
      },
      settingsListHeader: [
      // { text: "Print- ID", value: "Term - ID" },
      { text: "Firm", value: "Name" }, { text: "invoiceId Prefix", value: "Description" }, { text: "Invoice Round off", value: "Description" }, { text: "Edit", value: "edit" }, { text: "Delete", value: "delete" }]
    };
  },
  created: function created() {
    this.$bindAsArray("firmSettings", this.$root.$firebaseRefs.firmSettings.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild("brand").equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "stockReportTypes"]), {
    firmsByBrand: function firmsByBrand() {
      var _this = this;

      var alreadyExistsSettingsFirm = this.settingsListByBrand;
      return this.firms.filter(function (item) {
        return item["brand"] === _this.selectedBrand && !_.find(alreadyExistsSettingsFirm, function (o) {
          return o["firm"] == item[".key"];
        });
      }).map(function (item) {
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
    },
    settingsListByBrand: function settingsListByBrand() {
      var _this2 = this;

      return this.firmSettings.filter(function (item) {
        return item["brand"] === _this2.selectedBrand;
      });
    }
  }),
  methods: {
    saveSettings: function saveSettings() {
      this.$root.$firebaseRefs.firmSettings.push(this.currentSettings);
      this.addSettingsDialog = false;
    },
    addSettings: function addSettings() {
      this.currentSettings = {
        firm: null,
        brand: this.selectedBrand,
        invoiceIdPrefix: "",
        roundOff: false,
        verifiedInvoice: false,
        autoCounter: false,
        stockReportView: "APP",
        ewayBill: false,
        invoiceIdByDate: false,
        deleteWithPassword: false,
        deleteInvoicePassword: null
      };
      this.addSettingsDialog = true;
    },
    getFirmName: function getFirmName(e) {
      var firm = void 0;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter(function (item) {
          return item[".key"] === e;
        })[0];
      }
      if (firm) return firm.name;
    },
    editSetting: function editSetting(term) {
      this.currentSettings = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(term));
      this.addSettingsDialog = true;
    },
    deleteSetting: function deleteSetting(term) {
      if (window.confirm("Do you want to Delete " + term.name + "?")) {
        this.$root.$firebaseRefs.firmSettings.child(term[".key"]).remove();
      }
    },
    updateSettings: function updateSettings() {
      var _this3 = this;

      var settingsToUpdate = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.currentSettings));
      delete settingsToUpdate[".key"];
      this.$root.$firebaseRefs.firmSettings.child(this.currentSettings[".key"]).update(settingsToUpdate, function () {
        _this3.currentSettings = {
          firm: null,
          brand: _this3.selectedBrand,
          invoiceIdPrefix: "",
          roundOff: false,
          verifiedInvoice: false,
          stockReportView: "APP",
          autoCounter: false,
          ewayBill: false,
          invoiceIdByDate: false,
          deleteWithPassword: false,
          deleteInvoicePassword: null
        };
        _this3.addSettingsDialog = false;
      });
    }
  }
});

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Branch',
  data: function data() {
    return {
      dialog: false,
      dialogEdit: false,
      items: null,
      currentFirm: "",
      branchName: null,
      branchAddress: null,
      branchPincode: 0,
      branchNameEdit: null,
      branchAddressEdit: null,
      branchPincodeEdit: null,
      firms: [],
      snackbarSuccessText: null,
      snackbarText: null,
      snackbar: false,
      snackbarSuccess: false,
      currentFirmEdit: null,
      itemsEdit: null,
      branchMobileNumber: {
        value: null,
        rules: [function (v) {
          return !!v || 'Mobile is required';
        }, function (v) {
          return (/^(\+91|\+91\-|0)?[6789]\d{9}$/.test(v) || 'Mobile number is wrong'
          );
        }]
      },
      branchMobileNumberEdit: {
        value: null,
        rules: [function (v) {
          return !!v || 'Mobile is required';
        }, function (v) {
          return (/^(\+91|\+91\-|0)?[6789]\d{9}$/.test(v) || 'Mobile number is wrong'
          );
        }]
      },
      branchEmail: {
        value: '',
        rules: [function (v) {
          return (/^$/.test(v) || /.+@.+/.test(v) || 'E-mail must be valid'
          );
        }]
      },
      branchEmailEdit: {
        value: '',
        rules: [function (v) {
          return (/^$/.test(v) || /.+@.+/.test(v) || 'E-mail must be valid'
          );
        }]
      }
    };
  },
  created: function created() {
    this.$bindAsArray('firms', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('account', this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('branch', this.$root.$firebaseRefs.branch.orderByChild('brand').equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand']), {
    getBranchAccount: function getBranchAccount() {
      var _this = this;

      if (this.selectedBrand) {
        return this.branch.filter(function (item) {
          return item['brand'] === _this.selectedBrand && item['firm'] != '';
        });
      }
    },
    branchCount: function branchCount() {
      return this.getBranchAccount.length || 0;
    }
  }),
  methods: {
    firmbyId: function firmbyId(id) {
      return this.firms.filter(function (item) {
        return item['.key'] == id;
      })[0].name;
    },
    addNewBranchAccount: function addNewBranchAccount() {
      var data = {
        brand: this.selectedBrand,
        firm: this.currentFirm,
        branchName: this.branchName,
        branchAddress: this.branchAddress,
        branchPincode: this.branchPincode,
        branchEmail: this.branchEmail.value,
        branchMobileNumber: this.branchMobileNumber.value
      };
      if (data.firm == null || data.firm == "") {
        this.snackbar = true;
        this.snackbarText = 'Please Select Firm';
        return false;
      } else if (data.branchName == null || data.branchName == "") {
        this.snackbar = true;
        this.snackbarText = 'Enter Branch Name';
        return false;
      }
      this.$root.$firebaseRefs.branch.push(data);
      this.dialog = false;
      this.currentFirm = "";
      this.branchName = "";
      this.branchAddress = "";
      this.branchPincode = 0;
      this.branchMobileNumber.value = 0;
      this.branchEmail.value = "";
    },
    editBranchAccount: function editBranchAccount(key) {
      var _this2 = this;

      this.dialogEdit = true;
      console.log(key);
      var firms = this.firms.filter(function (item) {
        return item['brand'] === _this2.selectedBrand;
      });
      var totalitem = [];
      firms.forEach(function (arrayItem) {
        totalitem.push({
          id: arrayItem['.key'],
          name: arrayItem.name
        });
      });
      this.itemsEdit = totalitem;
      this.dialogEdit = true;
      this.currentFirmEdit = key.firm;
      this.branchNameEdit = key.branchName;
      this.branchPincodeEdit = key.branchPincode;
      this.branchAddressEdit = key.branchAddress;
      this.branchMobileNumberEdit.value = key.branchMobileNumber;
      this.branchEmailEdit.value = key.branchEmail;
      this.updateKey = key['.key'];
    },
    updateNewBranchAccount: function updateNewBranchAccount() {
      var data = {
        brand: this.selectedBrand,
        firm: this.currentFirmEdit,
        branchName: this.branchNameEdit,
        branchAddress: this.branchAddressEdit,
        branchPincode: this.branchPincodeEdit,
        branchEmail: this.branchEmailEdit.value,
        branchMobileNumber: this.branchMobileNumberEdit.value
      };
      this.$root.$firebaseRefs.branch.child(this.updateKey).update({
        brand: this.selectedBrand,
        firm: this.currentFirmEdit,
        branchName: this.branchNameEdit,
        branchAddress: this.branchAddressEdit,
        branchPincode: this.branchPincodeEdit,
        branchEmail: this.branchEmailEdit.value,
        branchMobileNumber: this.branchMobileNumberEdit.value
      });
      this.currentFirmEdit = "";
      this.branchNameEdit = "";
      this.branchAddressEdit = "", this.branchPincodeEdit = "", this.branchEmailEdit.value = "", this.branchMobileNumberEdit.value = "";
      this.cancelDialogEdit();
    },
    deleteBranchAccount: function deleteBranchAccount(key) {
      confirm('Are you sure you want to delete this Branch Account') && this.$root.$firebaseRefs.branch.child(key).remove();
    },
    cancelDialog: function cancelDialog() {
      this.dialog = false;
    },
    cancelDialogEdit: function cancelDialogEdit() {
      this.dialogEdit = false;
    },
    getFirms: function getFirms() {
      var _this3 = this;

      this.dialog = true;
      var firms = this.firms.filter(function (item) {
        return item['brand'] === _this3.selectedBrand;
      });
      var totalitem = [];
      firms.forEach(function (arrayItem) {
        totalitem.push({
          id: arrayItem['.key'],
          name: arrayItem.name
        });
      });
      this.items = totalitem;
      this.itemsEdit = totalitem;
    },
    getBranchAccount: function getBranchAccount() {
      var _this4 = this;

      this.dialog = true;
      var branch = this.branch.filter(function (item) {
        return item['brand'] === _this4.selectedBrand;
      });
      var totalitem = [];
      branch.forEach(function (arrayItem) {
        totalitem.push({
          id: arrayItem['.key'],
          name: arrayItem.name
        });
      });
      this.items = totalitem;
    }
  }
});

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      transferDialog: false,
      currentTransfer: {},
      transferdatepicker: null,
      snackbarSuccessText: null,
      snackbarText: null,
      snackbar: false,
      snackbarSuccess: false,
      termsList: [],
      transferHeader: [
      // { text: "Print- ID", value: "Term - ID" },
      { text: "Firm", value: "Name" }, { text: "Date", value: "Name" }, { text: "Transfer Category", value: "Description" }, { text: "Amount", value: "Description" }, { text: "Edit", value: "edit" }, { text: "Delete", value: "delete" }]
    };
  },
  created: function created() {
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("banks", this.$root.$firebaseRefs.account.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("transactions", this.$root.$firebaseRefs.transaction.orderByChild("brand").equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "brandFinYear"]), {
    firmsByBrand: function firmsByBrand() {
      var _this = this;

      return this.firms.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      }).map(function (item) {
        return {
          firm: item,
          text: item["name"],
          value: item[".key"]
        };
      });
    },
    banksByFirms: function banksByFirms() {
      var _this2 = this;

      return this.banks.filter(function (item) {
        return item["brand"] === _this2.selectedBrand && item["firm"] == _this2.currentTransfer.firm;
      }).map(function (item) {
        return {
          account: item,
          text: item["accountnumber"],
          value: item[".key"]
        };
      });
    },
    transferListByBrand: function transferListByBrand() {
      var _this3 = this;

      return this.transactions.filter(function (item) {
        return item["brand"] === _this3.selectedBrand;
      });
    }
  }),
  methods: {
    saveTerms: function saveTerms() {
      console.log(this.currentTransfer);
      this.transferAmount(false, false);

      this.transferDialog = false;
    },
    checkForSameAccount: function checkForSameAccount() {
      if (this.currentTransfer.bankFrom != null && this.currentTransfer.bankTo != null) {
        if (this.currentTransfer.bankFrom == this.currentTransfer.bankTo) {
          this.snackbar = true;
          this.snackbarText = "Both Accounts cannot be same";
          return false;
        } else {
          return true;
        }
      }
    },
    transferAmount: function transferAmount(reverse, isDelete) {
      switch (this.currentTransfer.transferCategory) {
        case "B2B":
          {
            this.bankToBank(reverse, isDelete);
            break;
          }
        case "C2B":
          {
            reverse ? this.bankToCash(reverse, isDelete) : this.cashToBank(reverse);
            break;
          }
        case "B2C":
          {
            reverse ? this.cashToBank(reverse, isDelete) : this.bankToCash(reverse);
            break;
          }
      }
    },
    addTerm: function addTerm() {
      this.currentTransfer = {
        firm: null,
        bankFrom: null,
        bankTo: null,
        amount: 0,
        paymentType: "cash",
        date: new Date().toISOString().substr(0, 10),
        transferCategory: "B2B",
        brand: this.selectedBrand,
        remark: ""
      };
      this.transferDialog = true;
    },
    addInvoice: function addInvoice() {
      if (this.currentTransfer[".key"]) {
        this.$root.$firebaseRefs.invoice.child(this.currentTransfer["creditInvoiceId"]).remove();
        this.$root.$firebaseRefs.invoice.child(this.currentTransfer["debitInvoiceId"]).remove();
      }
      var invoiceDataCredit = {
        brand: this.selectedBrand,
        brandFinYear: this.brandFinYear,
        type: "automatic invoice",
        transactionType: "Transfer",
        firm: this.currentTransfer.firm,
        paymentType: "bank",
        isCredited: true,
        totalAmount: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.currentTransfer.amount),
        date: new Date(this.currentTransfer.date).getTime(),
        transferCategory: this.currentTransfer.transferCategory
      };
      var invoiceDataDebit = {
        brand: this.selectedBrand,
        brandFinYear: this.brandFinYear,
        type: "automatic invoice",
        transactionType: "Transfer",
        firm: this.currentTransfer.firm,
        paymentType: "bank",
        isCredited: false,
        totalAmount: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.currentTransfer.amount),
        date: new Date(this.currentTransfer.date).getTime(),
        transferCategory: this.currentTransfer.transferCategory
      };

      if (this.currentTransfer.transferCategory == "B2B") {
        invoiceDataCredit["transferType"] = this.currentTransfer.bankTransferType;
        invoiceDataCredit["bank"] = this.currentTransfer.bankTo;
        invoiceDataDebit["transferType"] = this.currentTransfer.bankTransferType;
        invoiceDataDebit["bank"] = this.currentTransfer.bankFrom;
        invoiceDataCredit["remark"] = this.currentTransfer.remark;
        invoiceDataDebit["remark"] = this.currentTransfer.remark;
      } else if (this.currentTransfer.transferCategory == "B2C") {
        invoiceDataCredit["depositVia"] = this.currentTransfer.depositVia;
        invoiceDataCredit["remark"] = this.currentTransfer.remark;
        invoiceDataDebit["bank"] = this.currentTransfer.bankFrom;

        invoiceDataDebit["depositVia"] = this.currentTransfer.depositVia;
        invoiceDataDebit["remark"] = this.currentTransfer.remark;
      } else if (this.currentTransfer.transferCategory == "C2B") {
        invoiceDataCredit["depositVia"] = this.currentTransfer.depositVia;
        invoiceDataCredit["remark"] = this.currentTransfer.remark;
        invoiceDataCredit["bank"] = this.currentTransfer.bankTo;

        invoiceDataDebit["depositVia"] = this.currentTransfer.depositVia;
        invoiceDataDebit["remark"] = this.currentTransfer.remark;
      }
      var res1 = this.$root.$firebaseRefs.invoice.push(invoiceDataCredit);
      var res2 = this.$root.$firebaseRefs.invoice.push(invoiceDataDebit);
      this.currentTransfer["creditInvoiceId"] = res1["key"];
      this.currentTransfer["debitInvoiceId"] = res2["key"];
      this.currentTransfer["date"] = new Date(this.currentTransfer.date).getTime();
      if (this.currentTransfer[".key"]) {
        var key = this.currentTransfer[".key"];
        delete this.currentTransfer[".key"];
        this.$root.$firebaseRefs.transaction.child(key).set(this.currentTransfer);
      } else {
        this.$root.$firebaseRefs.transaction.push(this.currentTransfer);
      }
    },
    bankToBank: function bankToBank(reverse, isDelete) {
      var self = this;
      var result = this.checkForSameAccount();
      var bankFrom = reverse ? this.currentTransfer.bankTo : this.currentTransfer.bankFrom;
      var bankTo = reverse ? this.currentTransfer.bankFrom : this.currentTransfer.bankTo;
      if (result) {
        if (this.currentTransfer.amount == null) {
          this.snackbar = true;
          this.snackbarText = "Amount cannot be empty";
        } else {
          this.$root.$firebaseRefs.account.child(bankFrom).once("value").then(function (snap) {
            if (Number(snap.val().amount) >= Number(self.currentTransfer.amount)) {
              self.$root.$firebaseRefs.account.child(bankFrom).update({
                amount: Number(snap.val().amount) - Number(self.currentTransfer.amount)
              });
              self.$root.$firebaseRefs.account.child(bankTo).once("value").then(function (snap) {
                self.$root.$firebaseRefs.account.child(bankTo).update({
                  amount: Number(snap.val().amount) + Number(self.currentTransfer.amount)
                });
              });
              setTimeout(function () {
                if (!reverse) {
                  self.addInvoice();
                }
                if (isDelete) {
                  self.$root.$firebaseRefs.invoice.child(self.currentTransfer["creditInvoiceId"]).remove();
                  self.$root.$firebaseRefs.invoice.child(self.currentTransfer["debitInvoiceId"]).remove();
                  self.$root.$firebaseRefs.transaction.child(self.currentTransfer[".key"]).remove();
                }
                if (reverse && !isDelete) {
                  this.transferAmount(false, false);
                }
              }, 1000);
            } else {
              self.snackbar = true;
              self.snackbarText = "Insufficient Balance";
            }
          });
        }
      } else {
        this.snackbar = true;
        this.snackbarText = "Both Accounts cannot be same";
      }
    },
    bankToCash: function bankToCash(reverse, isDelete) {
      var self = this;
      if (this.currentTransfer.amount == null) {
        this.snackbar = true;
        this.snackbarText = "Amount cannot be empty";
      } else {
        var bankFrom = reverse ? this.currentTransfer.bankTo : this.currentTransfer.bankFrom;
        this.$root.$firebaseRefs.account.child(bankFrom).once("value").then(function (snap) {
          if (Number(snap.val().amount) >= Number(self.currentTransfer.amount)) {
            self.$root.$firebaseRefs.account.child(bankFrom).update({
              amount: Number(snap.val().amount) - Number(self.currentTransfer.amount)
            });
            self.$root.$firebaseRefs.firm.child(self.currentTransfer.firm).once("value").then(function (snap) {
              self.$root.$firebaseRefs.firm.child(self.currentTransfer.firm).update({
                amount: Number(snap.val().amount) + Number(self.currentTransfer.amount)
              });
            });
            setTimeout(function () {
              if (!reverse) {
                self.addInvoice();
              }
              if (isDelete) {
                self.$root.$firebaseRefs.invoice.child(self.currentTransfer["creditInvoiceId"]).remove();
                self.$root.$firebaseRefs.invoice.child(self.currentTransfer["debitInvoiceId"]).remove();
                self.$root.$firebaseRefs.transaction.child(self.currentTransfer[".key"]).remove();
              }
              if (reverse && !isDelete) {
                this.transferAmount(false, false);
              }
            }, 1000);
          } else {
            self.snackbar = true;
            self.snackbarText = "Insufficient Balance";
          }
        });
      }
    },
    cashToBank: function cashToBank(reverse, isDelete) {
      var self = this;
      if (this.currentTransfer.amount == null) {
        this.snackbar = true;
        this.snackbarText = "Amount cannot be empty";
      } else {
        var bankTo = reverse ? this.currentTransfer.bankFrom : this.currentTransfer.bankTo;
        this.$root.$firebaseRefs.firm.child(this.currentTransfer.firm).once("value").then(function (snap) {
          if (Number(snap.val().amount) >= Number(self.currentTransfer.amount)) {
            self.$root.$firebaseRefs.firm.child(self.currentTransfer.firm).update({
              amount: Number(snap.val().amount) - Number(self.currentTransfer.amount)
            });

            self.$root.$firebaseRefs.account.child(bankTo).once("value").then(function (snap) {
              self.$root.$firebaseRefs.account.child(bankTo).update({
                amount: Number(snap.val().amount) + Number(self.currentTransfer.amount)
              });
            });
            setTimeout(function () {
              if (!reverse) {
                self.addInvoice();
              }
              if (isDelete) {
                self.$root.$firebaseRefs.invoice.child(self.currentTransfer["creditInvoiceId"]).remove();
                self.$root.$firebaseRefs.invoice.child(self.currentTransfer["debitInvoiceId"]).remove();
                self.$root.$firebaseRefs.transaction.child(self.currentTransfer[".key"]).remove();
              }
              if (reverse && !isDelete) {
                this.transferAmount(false, false);
              }
            }, 1000);
          } else {
            self.snackbar = true;
            self.snackbarText = "Insufficient Balance";
          }
        });
      }
    },
    getFirmName: function getFirmName(e) {
      var firm = void 0;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter(function (item) {
          return item[".key"] === e;
        })[0];
      }
      if (firm) return firm.name;
    },
    getBankName: function getBankName(e) {
      var bank = this.banks.filter(function (item) {
        return item[".key"] === e;
      })[0];
      if (bank) return bank.bankName + " | " + bank["accountnumber"];
    },
    updateTransfer: function updateTransfer() {
      this.transferAmount(true, false);
      this.transferDialog = false;
    },
    editTransfer: function editTransfer(term) {
      this.currentTransfer = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(term));
      this.currentTransfer["date"] = new Date(this.currentTransfer["date"]).toISOString().substr(0, 10), this.transferDialog = true;
    },
    deleteTerm: function deleteTerm(term) {
      if (window.confirm("Do you want to Delete ?")) {
        this.currentTransfer = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(term));
        this.transferAmount(true, true);
      }
    }
  }
});

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(1613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_firebase__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_firebase__);









//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_9_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];

var logoPath = "shop-images/";
var productsImagesPath = "shop-images/products/";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      brandLogo: null,
      uploadValue: 0,
      snackbar: false,
      productImages: {},
      currentSettings: {
        firm: null,
        logo: null,
        logoFileName: null,
        active: false,
        name: null,
        items: [{
          productName: null,
          productId: null,
          unit: null,
          rate: 0,
          MRPRate: 0,
          image: {
            fileName: null,
            filePath: null,
            uploadDate: null,
            documentName: null
          }
        }]
      }
    };
  },
  created: function created() {
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("shopSettings", this.$root.$firebaseRefs.shopSettings.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild("brand").equalTo(this.selectedBrand)), this.getCurrentSettings();
  },

  watch: {
    shopSettings: {
      handler: function handler(value) {
        this.getCurrentSettings();
      },

      deep: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand"]), mapGlobalGetters({ units: "productUnit" }), {
    firmsByBrand: function firmsByBrand() {
      return this.firms.map(function (item) {
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
    },
    productsByFirm: function productsByFirm() {
      var _this = this;

      return this.products.filter(function (p) {
        return p.firm == _this.currentSettings.firm;
      });
    }
  }),
  methods: {
    restructureProductList: function restructureProductList(indexMain) {
      var _this2 = this;

      this.currentSettings.items.map(function (item, index) {
        if (indexMain ? index == indexMain : true) {
          var prod = _this2.products.filter(function (item1) {
            return item1["name"] == item["productName"];
          })[0];
          _this2.currentSettings.items[index]["productName"] = prod.name;
          _this2.currentSettings.items[index]["productId"] = prod[".key"];
          _this2.currentSettings.items[index]["unit"] = prod.unit;
          _this2.currentSettings.items[index]["rate"] = _this2.isBuyer ? prod["sellingPrice"] || 0 : prod["purchasingPrice"] || 0;
          _this2.currentSettings.items[index]['MRPRate'] = prod.MRPRate || _this2.currentSettings.items[index]["rate"];
        }
      });
      this.currentSettings = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, this.currentSettings);
    },
    getProd: function getProd(productId) {
      return this.productsByFirm.find(function (item) {
        return item['.key'] == productId;
      });
    },
    addAllProds: function addAllProds() {
      var _this3 = this;

      this.currentSettings.items = [];
      var products = this.productsByFirm;
      products.map(function (item) {
        var itemToAdd = {
          productId: item['.key'],
          orignal: true,
          image: {
            fileName: null,
            filePath: null,
            uploadDate: null,
            documentName: null
          }
        };
        _this3.currentSettings.items.push(itemToAdd);
      });
      this.currentSettings.items = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()([], this.currentSettings.items);
    },
    addProd: function addProd() {
      var itemToAdd = {
        productName: null,
        productId: null,
        unit: null,
        rate: 0,
        MRPRate: 0,
        orignal: false,
        image: {
          fileName: null,
          filePath: null,
          uploadDate: null,
          documentName: null
        }
      };
      this.currentSettings.items.push(itemToAdd);
      this.currentSettings.items = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()([], this.currentSettings.items);
    },
    removeProd: function removeProd(index) {
      this.currentSettings.items.splice(index, 1);
      this.currentSettings.items = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()([], this.currentSettings.items);
    },
    deleteImage: function deleteImage(name, filePath) {
      var storagePath = __WEBPACK_IMPORTED_MODULE_10_firebase___default.a.storage().ref();
      storagePath.child(filePath + ("" + name)).delete();
    },
    uploadAndSave: function uploadAndSave() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var path, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref, _ref2, key, value, _loop, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _ref3, _ref4, _key, _value;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_keys___default()(_this4.productImages).length) {
                  _context2.next = 50;
                  break;
                }

                path = productsImagesPath;
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 5;

                for (_iterator = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(_this4.productImages)); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  _ref = _step.value;
                  _ref2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref, 2);
                  key = _ref2[0];
                  value = _ref2[1];

                  if (value && _this4.currentSettings.items[key].image.filePath) {
                    _this4.deleteImage(_this4.currentSettings.items[key].image.fileName, path);
                  }
                }
                _context2.next = 13;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](5);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 13:
                _context2.prev = 13;
                _context2.prev = 14;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 16:
                _context2.prev = 16;

                if (!_didIteratorError) {
                  _context2.next = 19;
                  break;
                }

                throw _iteratorError;

              case 19:
                return _context2.finish(16);

              case 20:
                return _context2.finish(13);

              case 21:
                _loop = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _loop(_key, _value) {
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _loop$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!_value) {
                            _context.next = 3;
                            break;
                          }

                          _context.next = 3;
                          return _this4.upload(_value, path, _key, true).then(function () {
                            delete _this4.productImages[_key];
                          });

                        case 3:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _loop, _this4);
                });
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context2.prev = 25;
                _iterator2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(_this4.productImages));

              case 27:
                if (_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done) {
                  _context2.next = 36;
                  break;
                }

                _ref3 = _step2.value;
                _ref4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);
                _key = _ref4[0];
                _value = _ref4[1];
                return _context2.delegateYield(_loop(_key, _value), "t1", 33);

              case 33:
                _iteratorNormalCompletion2 = true;
                _context2.next = 27;
                break;

              case 36:
                _context2.next = 42;
                break;

              case 38:
                _context2.prev = 38;
                _context2.t2 = _context2["catch"](25);
                _didIteratorError2 = true;
                _iteratorError2 = _context2.t2;

              case 42:
                _context2.prev = 42;
                _context2.prev = 43;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 45:
                _context2.prev = 45;

                if (!_didIteratorError2) {
                  _context2.next = 48;
                  break;
                }

                throw _iteratorError2;

              case 48:
                return _context2.finish(45);

              case 49:
                return _context2.finish(42);

              case 50:
                if (_this4.brandLogo && _this4.currentSettings.logo) {
                  _this4.deleteImage(_this4.currentSettings.logoFileName, logoPath);
                }

                if (!_this4.brandLogo) {
                  _context2.next = 54;
                  break;
                }

                _context2.next = 54;
                return _this4.upload(_this4.brandLogo, logoPath, ["logo", "logoFileName"], false).then(function () {
                  _this4.brandLogo = null;
                });

              case 54:
                _this4.update();

              case 55:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee, _this4, [[5, 9, 13, 21], [14,, 16, 20], [25, 38, 42, 50], [43,, 45, 49]]);
      }))();
    },
    uploadChangeProduct: function uploadChangeProduct(event, doc, index) {
      this.productImages[index] = event.target.files[0];
      this.currentSettings.items[index].image.documentName = this.productImages[index].name;
      this.currentSettings = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_assign___default()({}, this.currentSettings);
    },
    upload: function upload(image, filePath, fields, isProductImage) {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        var fileName = new Date().getTime() + "_" + image.name;
        var storageRef = __WEBPACK_IMPORTED_MODULE_10_firebase___default.a.storage().ref(filePath + ("" + fileName)).put(image);
        storageRef.on("state_changed", function (snapshot) {
          _this5.uploadValue = snapshot.bytesTransferred / snapshot.totalBytes * 100;
        }, function (error) {
          console.log(error.message);
        }, function () {
          _this5.uploadValue = 100;
          storageRef.snapshot.ref.getDownloadURL().then(function (url) {
            _this5.uploadValue = 0;
            if (isProductImage) {
              _this5.currentSettings.items[fields].image.filePath = url;
              _this5.currentSettings.items[fields].image.fileName = fileName;
              _this5.currentSettings.items[fields].image.uploadDate = new Date().getTime();
            } else {
              _this5.currentSettings[fields[0]] = url;
              _this5.currentSettings[fields[1]] = fileName;
            }

            resolve();
          });
        });
      });
    },
    downloadURI: function downloadURI(uri, name) {
      var link = document.createElement("a");
      link.download = name;
      link.href = uri;
      link.target = "_blank";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    uploadChangeLogo: function uploadChangeLogo(event) {
      this.brandLogo = event.target.files[0];
    },
    update: function update() {
      var _this6 = this;

      if (this.currentSettings[".key"]) {
        var key = this.currentSettings[".key"];
        delete this.currentSettings[".key"];
        this.$root.$firebaseRefs.shopSettings.child(key).set(this.currentSettings).then(function () {
          _this6.currentSettings[".key"] = key;
          _this6.snackbar = true;
        });
      } else {
        this.currentSettings.brand = this.selectedBrand;
        var res = this.$root.$firebaseRefs.shopSettings.push(this.currentSettings);
        this.currentSettings[".key"] = res["key"];
        this.snackbar = true;
      }
    },
    getCurrentSettings: function getCurrentSettings() {
      var _this7 = this;

      console.log(this.shopSettings);
      if (this.shopSettings.length) {
        this.currentSettings = this.shopSettings[0];
        if (!this.currentSettings.items || !this.currentSettings.items.length) {
          this.addAllProds();
        } else {
          this.currentSettings.items.map(function (p, index) {
            if (!p.image) {
              _this7.currentSettings.items[index]['image'] = {
                fileName: null,
                filePath: null,
                uploadDate: null,
                documentName: null
              };
            }
          });
        }
      }
    }
  }
});

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_firebase__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      addSettingsDialog: false,
      currentSettings: {
        firm: null,
        brand: null,
        floorDetails: [{
          name: "",
          tables: [{
            name: "",
            capacity: 10
          }]
        }]
      },
      settingsListHeader: [
      // { text: "Print- ID", value: "Term - ID" },
      { text: "Firm", value: "Name" }, { text: "Edit", value: "edit" }, { text: "Delete", value: "delete" }]
    };
  },
  created: function created() {
    this.$bindAsArray("firmInfrastructure", this.$root.$firebaseRefs.firmInfrastructure.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild("brand").equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "stockReportTypes"]), {
    firmsByBrand: function firmsByBrand() {
      var _this = this;

      var alreadyExistsSettingsFirm = this.settingsListByBrand;
      return this.firms.filter(function (item) {
        return item["brand"] === _this.selectedBrand && !_.find(alreadyExistsSettingsFirm, function (o) {
          return o["firm"] == item[".key"];
        });
      }).map(function (item) {
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
    },
    settingsListByBrand: function settingsListByBrand() {
      var _this2 = this;

      return this.firmInfrastructure.filter(function (item) {
        return item["brand"] === _this2.selectedBrand;
      });
    }
  }),
  methods: {
    saveSettings: function saveSettings() {
      this.$root.$firebaseRefs.firmInfrastructure.push(this.currentSettings);
      this.addSettingsDialog = false;
    },
    addSettings: function addSettings() {
      this.currentSettings = {
        firm: null,
        brand: this.selectedBrand,
        floorDetails: [{
          name: "",
          tables: [{
            name: "",
            capacity: 10
          }]
        }]
      };
      this.addSettingsDialog = true;
    },
    getFirmName: function getFirmName(e) {
      var firm = void 0;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter(function (item) {
          return item[".key"] === e;
        })[0];
      }
      if (firm) return firm.name;
    },
    editSetting: function editSetting(term) {
      this.currentSettings = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(term));
      this.addSettingsDialog = true;
    },
    addTables: function addTables(index, index1) {
      this.currentSettings.floorDetails[index].tables.push({
        name: "",
        capacity: 10
      });
    },
    removeTables: function removeTables(index, index1) {
      this.currentSettings.floorDetails[index].tables.splice(index1, 1);
    },
    addFloor: function addFloor(index) {
      this.currentSettings.floorDetails.push({
        name: "",
        tables: [{
          name: "",
          capacity: 10
        }]
      });
    },
    removeFloor: function removeFloor(index) {
      this.currentSettings.floorDetails.splice(index, 1);
    },
    deleteSetting: function deleteSetting(term) {
      if (window.confirm("Do you want to Delete " + term.name + "?")) {
        this.$root.$firebaseRefs.firmInfrastructure.child(term[".key"]).remove();
      }
    },
    updateSettings: function updateSettings() {
      var _this3 = this;

      var settingsToUpdate = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.currentSettings));
      delete settingsToUpdate[".key"];
      this.$root.$firebaseRefs.firmInfrastructure.child(this.currentSettings[".key"]).update(settingsToUpdate, function () {
        _this3.currentSettings = {
          firm: null,
          brand: _this3.selectedBrand,
          floorDetails: [{
            name: "",
            tables: [{
              name: "",
              capacity: 10
            }]
          }]
        };
        _this3.addSettingsDialog = false;
      });
    }
  }
});

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      productsHeader: [{ text: "Product", value: "Name" }, { text: "Quantity", value: "Name" }],
      transferType: "P2G",
      selectedGodownFrom: null,
      selectedGodownTo: null,
      datepickerTransfer: false,
      snackbar: false,
      transferDate: new Date().toISOString().substr(0, 10)
    };
  },
  created: function created() {
    this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("godawns", this.$root.$firebaseRefs.godawn.orderByChild("brand").equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand"])),
  methods: {
    transfer: function transfer() {
      var _this = this;

      var productToTransfer = this.products.filter(function (item) {
        return item["transferQuantity"] != undefined && parseInt(item["transferQuantity"]) > 0;
      });
      productToTransfer.map(function (item, index) {
        var transferObj = {
          quantity: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item.transferQuantity),
          date: new Date(_this.transferDate).getTime(),
          product: item[".key"],
          godawn: _this.selectedGodownFrom[".key"],
          brand: _this.selectedBrand
        };

        if (_this.transferType == "G2G") {
          transferObj["godawn"] = _this.selectedGodownTo[".key"];
          transferObj["godawnFrom"] = _this.selectedGodownFrom[".key"];
        }
        _this.$root.$firebaseRefs.godawnTransaction.push(transferObj);
        if (index == productToTransfer.length - 1) {
          _this.snackbar = true;
          _this.products.map(function (item, index) {
            _this.products[index]['transferQuantity'] = 0;
          });
        }
      });
    }
  }
});

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_xlsx__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_xlsx__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      currentFirm: null,
      mobileRules: /^(\+91|\+91\-|0)?[6789]\d{9}$/,
      emailRules: /.@./,
      progressBar: false,
      bufferValue: 0,
      progressVal: 0,
      snackbar: false
    };
  },
  created: function created() {
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
  },

  watch: {},
  firestore: {},
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand"]), {
    firmsByBrand: function firmsByBrand() {
      var _this = this;

      return this.firms.filter(function (item) {
        return item['brand'] === _this.selectedBrand;
      });
    }
  }),
  methods: {
    downloadFile: function downloadFile() {
      document.getElementById("xlsxfile").click();
    },
    addProductData: function addProductData(data) {
      var product = {
        brand: this.selectedBrand,
        firm: this.currentFirm['.key'],
        name: data['Product Name']
      };

      if (data['Active']) {
        product.isActive = data['Active'] == "YES";
      }

      if (data['Product Description']) {
        product.description = data['Product Description'];
      }

      if (data['Product Barcode']) {
        product.barcode = data['Product Barcode'];
      }

      if (data['Alert Quantity']) {
        product.alertQuantity = this.getNumber(data['Alert Quantity'], true);
      }

      if (data['GST type']) {
        product.GST_type = data['GST type'];
      }

      product.taxableGST_rate = data['Taxable GST rate'] ? this.getNumber(data['Taxable GST rate'], false) : 0;

      product.HSN_code = this.getNumber(data['HSN code'], true) || 0;

      if (data['Unit']) {
        product.unit = data['Unit'];
      }

      if (data['Opening Date']) {
        var date = this.getFormattedDate(data['Opening Date']);
        if (this.isValidDate(date)) {
          product["openingDate"] = date.getTime();
        }
      }

      if (data['Opening Quantity']) {
        product.quantity = this.getNumber(data['Opening Quantity'], true);
        product.purchaseQuantity = 0;
        product.saleQuantity = 0;
        product.openingQuantity = product.quantity;
      }

      if (data['Opening Amount']) {
        product.openingBalance = this.getNumber(data['Opening Amount'], false);
      }

      if (data['Purchasing Price [Excluding GST]']) {
        product.purchasingPrice = this.getNumber(data['Purchasing Price [Excluding GST]'], false);
      }

      if (data['Selling Price [Excluding GST]']) {
        product.sellingPrice = this.getNumber(data['Selling Price [Excluding GST]'], false);
      }

      if (data['MRP [Including GST]']) {
        product.MRPRate = this.getNumber(data['MRP [Including GST]'], false);
      }
      this.$root.$firebaseRefs.products.push(product);
    },
    getFormattedDate: function getFormattedDate(date) {
      if (date.indexOf("/") > 0) {
        return new Date(date.split("/")[1] + "/" + date.split("/")[0] + "/" + date.split("/")[2]);
      } else if (date.indexOf("-") > 0) {
        return new Date(date.split("-")[1] + "/" + date.split("-")[0] + "/" + date.split("-")[2]);
      }
    },
    getNumber: function getNumber(a, isInt) {
      var temp = isInt ? parseInt(a) : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(a);
      return isNaN(temp) ? 0 : temp;
    },
    isValidDate: function isValidDate(d) {
      if (Object.prototype.toString.call(d) === "[object Date]") {
        // it is a date
        if (isNaN(d.getTime())) {
          // d.valueOf() could also work
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    dataImport: function dataImport(e) {
      var _this2 = this;

      var files = e.target.files,
          f = files[0];
      var reader = new FileReader();
      reader.onload = function (e) {
        var data = new Uint8Array(e.target.result);
        var workbook = __WEBPACK_IMPORTED_MODULE_4_xlsx___default.a.read(data, { type: "array" });

        if (workbook.Sheets.auth.H1.h == "4ACvPW6LwZrucLtVOoBL") {
          if (confirm("Are you sure you want to import this data?")) {
            var productWorksheet = workbook.Sheets['Products'];
            var productData = __WEBPACK_IMPORTED_MODULE_4_xlsx___default.a.utils.sheet_to_json(productWorksheet, { raw: false });
            productData.map(function (product) {
              if (product['Product Name']) {
                _this2.addProductData(product);
                console.log(product);
              }
            });
            _this2.snackbar = true;
          }
        } else {
          alert("Please upload valid file from template.");
        }
      };
      reader.readAsArrayBuffer(f);
    }
  }
});

/***/ }),
/* 546 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { createNamespacedHelpers } from "vuex";
// import _ from "lodash";
// import XLSX from 'xlsx';
// const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
// export default {
//   data() {
//     return {
//       currentFirm: null,
//       mobileRules: /^(\+91|\+91\-|0)?[6789]\d{9}$/,
//       emailRules: /.@./,
//       progressBar : false,
//       bufferValue : 0,
//       progressVal : 0,
//       snackbar : false
//     };
//   },
//   created() {
//     this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand))
//   },
//   watch: {
//   },
//   firestore: {},
//   computed: {
//     ...mapGlobalGetters(["selectedBrand"]),
//     firmsByBrand () {
//             return this.firms.filter((item) => 
//                 item['brand'] === this.selectedBrand
//             )
//     }
//   },
//   methods: {
//     downloadFile() {
//       document.getElementById("xlsxfile").click();
//     },
//     addProductData(data){
//       let product = {
//         brand: this.selectedBrand,
//         firm : this.currentFirm['.key'],
//         name : data['Product Name']
//       };

//       if(data['Active']) {
//         product.isActive = data['Active'] == "YES";
//       }

//       if(data['Product Description']) {
//         product.description = data['Product Description'];
//       }

//       if(data['Product Barcode']) {
//         product.barcode = data['Product Barcode'];
//       }

//       if(data['Alert Quantity']) {
//         product.alertQuantity = this.getNumber(data['Alert Quantity']);
//       }

//       if(data['GST type']) {
//         product.GST_type = data['GST type'];
//       }

//       if(data['Taxable GST rate']) {
//         product.taxableGST_rate = this.getNumber(data['Taxable GST rate']);
//       }

//       if(data['HSN code']) {
//         product.HSN_code = data['HSN code'];
//       }

//       if(data['Unit']) {
//         product.unit = data['Unit'];
//       }

//       if(data['Opening Date']) {
//         product.openingDate = this.getFormattedDate(data['Opening Date']).getTime();
//       }

//       if(data['Opening Quantity']) {
//         product.quantity = this.getNumber(data['Opening Quantity']);
//       }

//       if(data['Opening Amount']) {
//         product.openingBalance = this.getNumber(data['Opening Amount']);
//       }

//       if(data['Purchasing Price [Excluding GST]']) {
//         product.purchasingPrice = this.getNumber(data['Purchasing Price [Excluding GST]']);
//       }

//       if(data['Selling Price [Excluding GST]']) {
//         product.sellingPrice = this.getNumber(data['Selling Price [Excluding GST]']);
//       }

//       if(data['MRP [Including GST]']) {
//         product.MRPRate = this.getNumber(data['MRP [Including GST]']);
//       }
//       this.$root.$firebaseRefs.products.push(product);
//     },
//     getFormattedDate(date) {
//       if(date.indexOf("/") > 0) {
//           return new Date(
//             date.split("/")[0] + "/" + date.split("/")[1] + "/" + date.split("/")[2]
//           );
//       } else if(date.indexOf("-") > 0) {
//         return new Date(
//             date.split("-")[0] + "/" + date.split("-")[1] + "/" + date.split("-")[2]
//           );
//       }

//     },
//     getNumber(a){
//       let temp = Number.parseFloat(a);
//       return isNaN(temp) ? 0 : temp;
//     },
//     isValidDate(d) {
//       if (Object.prototype.toString.call(d) === "[object Date]") {
//         // it is a date
//         if (isNaN(d.getTime())) {
//           // d.valueOf() could also work
//           return false;
//         } else {
//           return true;
//         }
//       } else {
//         return false;
//       }
//     },
//     dataImport(e) {
//       var files = e.target.files,
//         f = files[0];
//       var reader = new FileReader();
//       reader.onload =  (e)=> {
//         var data = new Uint8Array(e.target.result);
//         var workbook = XLSX.read(data, { type: "array" });

//         if (workbook.Sheets.auth.H1.h == "4ACvPW6LwZrucLtVOoBL") {
//           if (confirm("Are you sure you want to import this data?")) {
//             let productWorksheet = workbook.Sheets['Products'];
//              let productData = XLSX.utils.sheet_to_json(productWorksheet, { raw: false });
//             productData.map((product) => {
//                 if(product['Product Name']) {
//                     this.addProductData(product);
//                 }
//             });
//             this.snackbar = true;
//           }
//         } else {
//           alert("Please upload valid file from template.");
//         }
//       };
//       reader.readAsArrayBuffer(f);
//     },
//   },
// };

/***/ }),
/* 547 */
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { createNamespacedHelpers } from "vuex";
// import _ from "lodash";
// import XLSX from 'xlsx';
// const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
// export default {
//   data() {
//     return {
//       currentFirm: null,
//       mobileRules: /^(\+91|\+91\-|0)?[6789]\d{9}$/,
//       emailRules: /.@./,
//       progressBar : false,
//       bufferValue : 0,
//       progressVal : 0,
//       snackbar : false
//     };
//   },
//   created() {
//     this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand))
//   },
//   watch: {
//   },
//   firestore: {},
//   computed: {
//     ...mapGlobalGetters(["selectedBrand"]),
//     firmsByBrand () {
//             return this.firms.filter((item) => 
//                 item['brand'] === this.selectedBrand
//             )
//     }
//   },
//   methods: {
//     downloadFile() {
//       document.getElementById("xlsxfile").click();
//     },
//     addProductData(data){
//       let product = {
//         brand: this.selectedBrand,
//         firm : this.currentFirm['.key'],
//         name : data['Product Name']
//       };

//       if(data['Active']) {
//         product.isActive = data['Active'] == "YES";
//       }

//       if(data['Product Description']) {
//         product.description = data['Product Description'];
//       }

//       if(data['Product Barcode']) {
//         product.barcode = data['Product Barcode'];
//       }

//       if(data['Alert Quantity']) {
//         product.alertQuantity = this.getNumber(data['Alert Quantity']);
//       }

//       if(data['GST type']) {
//         product.GST_type = data['GST type'];
//       }

//       if(data['Taxable GST rate']) {
//         product.taxableGST_rate = this.getNumber(data['Taxable GST rate']);
//       }

//       if(data['HSN code']) {
//         product.HSN_code = data['HSN code'];
//       }

//       if(data['Unit']) {
//         product.unit = data['Unit'];
//       }

//       if(data['Opening Date']) {
//         product.openingDate = this.getFormattedDate(data['Opening Date']).getTime();
//       }

//       if(data['Opening Quantity']) {
//         product.quantity = this.getNumber(data['Opening Quantity']);
//       }

//       if(data['Opening Amount']) {
//         product.openingBalance = this.getNumber(data['Opening Amount']);
//       }

//       if(data['Purchasing Price [Excluding GST]']) {
//         product.purchasingPrice = this.getNumber(data['Purchasing Price [Excluding GST]']);
//       }

//       if(data['Selling Price [Excluding GST]']) {
//         product.sellingPrice = this.getNumber(data['Selling Price [Excluding GST]']);
//       }

//       if(data['MRP [Including GST]']) {
//         product.MRPRate = this.getNumber(data['MRP [Including GST]']);
//       }
//       this.$root.$firebaseRefs.products.push(product);
//     },
//     getFormattedDate(date) {
//       if(date.indexOf("/") > 0) {
//           return new Date(
//             date.split("/")[0] + "/" + date.split("/")[1] + "/" + date.split("/")[2]
//           );
//       } else if(date.indexOf("-") > 0) {
//         return new Date(
//             date.split("-")[0] + "/" + date.split("-")[1] + "/" + date.split("-")[2]
//           );
//       }

//     },
//     getNumber(a){
//       let temp = Number.parseFloat(a);
//       return isNaN(temp) ? 0 : temp;
//     },
//     isValidDate(d) {
//       if (Object.prototype.toString.call(d) === "[object Date]") {
//         // it is a date
//         if (isNaN(d.getTime())) {
//           // d.valueOf() could also work
//           return false;
//         } else {
//           return true;
//         }
//       } else {
//         return false;
//       }
//     },
//     dataImport(e) {
//       var files = e.target.files,
//         f = files[0];
//       var reader = new FileReader();
//       reader.onload =  (e)=> {
//         var data = new Uint8Array(e.target.result);
//         var workbook = XLSX.read(data, { type: "array" });

//         if (workbook.Sheets.auth.H1.h == "4ACvPW6LwZrucLtVOoBL") {
//           if (confirm("Are you sure you want to import this data?")) {
//             let productWorksheet = workbook.Sheets['Products'];
//              let productData = XLSX.utils.sheet_to_json(productWorksheet, { raw: false });
//             productData.map((product) => {
//                 if(product['Product Name']) {
//                     this.addProductData(product);
//                 }
//             });
//             this.snackbar = true;
//           }
//         } else {
//           alert("Please upload valid file from template.");
//         }
//       };
//       reader.readAsArrayBuffer(f);
//     },
//   },
// };

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Buyer")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      datePicker: null,
      menufDialog: false,
      currentMenuf: null,
      manufHeader: [{ text: "Product Name", value: "deposit - ID" }, { text: "Date", value: "name" }, { text: "Delete", value: "edit" }]
    };
  },
  created: function created() {
    this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("productMenufs", this.$root.$firebaseRefs.productManufactureTransaction.orderByChild("brand").equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear"]), mapGlobalGetters({ units: "productUnit" }), {
    productsByBrand: function productsByBrand() {
      var _this = this;

      return this.products.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      }).map(function (item) {
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
    },
    productMenufsList: function productMenufsList() {
      return this.productMenufs;
    }
  }),
  methods: {
    save: function save() {
      this.convert("save");
    },
    saveFinal: function saveFinal() {
      this.currentMenuf.date = new Date(this.currentMenuf.date).getTime();
      this.$root.$firebaseRefs.productManufactureTransaction.push(this.currentMenuf);
      this.menufDialog = false;
    },
    addMenufacturing: function addMenufacturing() {
      this.currentMenuf = {
        brand: this.selectedBrand,
        date: new Date().toISOString().substr(0, 10),
        productId: null,
        quantity: 1,
        rawMaterials: [{
          productId: null,
          quantity: 1
        }]
      };
      this.menufDialog = true;
    },
    addProd: function addProd() {
      var itemToAdd = {
        productId: null,
        quantity: 1
      };
      this.currentMenuf.rawMaterials.push(itemToAdd);
    },
    removeProd: function removeProd(index) {
      this.currentMenuf.rawMaterials.splice(index, 1);
    },
    edit: function edit(productSet) {
      this.currentMenuf = productSet;
      this.currentMenuf.date = new Date(this.currentMenuf.date).toISOString().substr(0, 10);
      this.menufDialog = true;
    },
    update: function update() {
      this.convertBack("update");
    },
    updateFinal: function updateFinal() {
      var _this2 = this;

      this.currentMenuf.date = new Date(this.currentMenuf.date).getTime();
      var key = this.currentMenuf[".key"];
      delete this.currentMenuf[".key"];
      this.$root.$firebaseRefs.productManufactureTransaction.child(key).update(this.currentMenuf).then(function (data) {
        _this2.currentMenuf = null;
        _this2.menufDialog = false;
      }).catch(function (error) {
        console.log(error.code, error.message);
      });
    },
    deleteMenuf: function deleteMenuf(productSet) {
      if (window.confirm("Do you want to Delete ?")) {
        this.currentMenuf = productSet;
        this.convertBack("delete");
      }
    },
    getProductName: function getProductName(key) {
      return this.products.find(function (item) {
        return item[".key"] == key;
      }).name;
    },
    deletefinal: function deletefinal() {
      this.$root.$firebaseRefs.productManufactureTransaction.child(this.currentMenuf[".key"]).remove();
    },
    convert: function convert(action) {
      var _this3 = this;

      var total = this.currentMenuf.rawMaterials.length;
      this.currentMenuf.rawMaterials.map(function (raw, index) {
        var prod = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this3.products.find(function (item) {
          return item[".key"] == raw.productId;
        }));
        if (prod) {
          var saleQuantity = prod["saleQuantity"] ? prod["saleQuantity"] : 0;
          saleQuantity = saleQuantity + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(raw.quantity);
          var prodQuantity = prod["quantity"];
          prodQuantity = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(prodQuantity) - __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(raw.quantity);
          var key = prod[".key"];
          delete prod[".key"];
          prod["quantity"] = prodQuantity;
          _this3.$root.$firebaseRefs.products.child(key).set(prod);
          if (index == total - 1) {
            var _prod = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this3.products.find(function (item) {
              return item[".key"] == _this3.currentMenuf.productId;
            }));
            if (_prod) {
              var purchaseQuantity = _prod["purchaseQuantity"] ? _prod["purchaseQuantity"] : 0;
              purchaseQuantity = purchaseQuantity + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(_this3.currentMenuf.quantity);
              var _prodQuantity = _prod["quantity"];
              _prodQuantity = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(_prodQuantity) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(_this3.currentMenuf.quantity);
              var _key = _prod[".key"];
              delete _prod[".key"];
              _prod["quantity"] = _prodQuantity;
              _this3.$root.$firebaseRefs.products.child(_key).set(_prod);
              _this3.performAction(action, true);
            }
          }
        }
      });
    },
    convertBack: function convertBack(action) {
      var _this4 = this;

      var total = this.currentMenuf.rawMaterials.length;
      this.currentMenuf.rawMaterials.map(function (raw, index) {
        var prod = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this4.products.find(function (item) {
          return item[".key"] == raw.productId;
        }));
        if (prod) {
          var purchaseQuantity = prod["purchaseQuantity"] ? prod["purchaseQuantity"] : 0;
          purchaseQuantity = purchaseQuantity + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(raw.quantity);
          var prodQuantity = prod["quantity"];
          prodQuantity = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(prodQuantity) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(raw.quantity);
          var key = prod[".key"];
          delete prod[".key"];
          prod["quantity"] = prodQuantity;

          _this4.$root.$firebaseRefs.products.child(key).set(prod);
          if (index == total - 1) {
            var _prod2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this4.products.find(function (item) {
              return item[".key"] == _this4.currentMenuf.productId;
            }));
            if (_prod2) {
              var saleQuantity = _prod2["saleQuantity"] ? _prod2["saleQuantity"] : 0;
              saleQuantity = saleQuantity + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(_this4.currentMenuf.quantity);
              var _prodQuantity2 = _prod2["quantity"];
              _prodQuantity2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(_prodQuantity2) - __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(_this4.currentMenuf.quantity);
              var _key2 = _prod2[".key"];
              delete _prod2[".key"];
              _prod2["quantity"] = _prodQuantity2;
              _this4.$root.$firebaseRefs.products.child(_key2).set(_prod2);
              _this4.performAction(action, false);
            }
          }
        }
      });
    },
    performAction: function performAction(action, isUpdateDone) {
      switch (action) {
        case "save":
          {
            this.saveFinal();
            break;
          }
        case "update":
          {
            if (isUpdateDone) {
              this.updateFinal();
            } else {
              this.convert(action);
            }
            break;
          }
        case "delete":
          {
            this.deletefinal();
            break;
          }
      }
    }
  }
});

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Buyer")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      datePicker: null,
      menufDialog: false,
      currentMenuf: null,
      manufHeader: [{ text: "Product Name", value: "deposit - ID" }, { text: "Date", value: "name" }, { text: "Edit", value: "edit" }, { text: "Delete", value: "delete" }]
    };
  },
  created: function created() {
    this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("productMenufs", this.$root.$firebaseRefs.productDamageTransaction.orderByChild("brand").equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear"]), mapGlobalGetters({ units: "productUnit" }), {
    productsByBrand: function productsByBrand() {
      var _this = this;

      return this.products.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      }).map(function (item) {
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
    },
    productMenufsList: function productMenufsList() {
      return this.productMenufs;
    }
  }),
  methods: {
    save: function save() {
      this.convert("save");
    },
    saveFinal: function saveFinal() {
      this.currentMenuf.date = new Date(this.currentMenuf.date).getTime();
      this.$root.$firebaseRefs.productDamageTransaction.push(this.currentMenuf);
      this.menufDialog = false;
    },
    addDamage: function addDamage() {
      this.currentMenuf = {
        brand: this.selectedBrand,
        date: new Date().toISOString().substr(0, 10),
        productId: null,
        quantity: 1
      };
      this.menufDialog = true;
    },
    edit: function edit(productSet) {
      this.currentMenuf = productSet;
      this.currentMenuf.date = new Date(this.currentMenuf.date).toISOString().substr(0, 10);
      this.menufDialog = true;
    },
    update: function update() {
      this.convertBack("update");
    },
    updateFinal: function updateFinal() {
      var _this2 = this;

      this.currentMenuf.date = new Date(this.currentMenuf.date).getTime();
      var key = this.currentMenuf[".key"];
      delete this.currentMenuf[".key"];
      this.$root.$firebaseRefs.productDamageTransaction.child(key).update(this.currentMenuf).then(function (data) {
        _this2.currentMenuf = null;
        _this2.menufDialog = false;
      }).catch(function (error) {
        console.log(error.code, error.message);
      });
    },
    deleteMenuf: function deleteMenuf(productSet) {
      if (window.confirm("Do you want to Delete ?")) {
        this.currentMenuf = productSet;
        this.convertBack("delete");
      }
    },
    getProductName: function getProductName(key) {
      return this.products.find(function (item) {
        return item[".key"] == key;
      }).name;
    },
    deletefinal: function deletefinal() {
      this.$root.$firebaseRefs.productDamageTransaction.child(this.currentMenuf[".key"]).remove();
    },
    convert: function convert(action) {
      var _this3 = this;

      var prod = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.products.find(function (item) {
        return item[".key"] == _this3.currentMenuf.productId;
      }));
      if (prod) {
        var purchaseQuantity = prod["purchaseQuantity"] ? prod["purchaseQuantity"] : 0;
        purchaseQuantity = purchaseQuantity - __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(this.currentMenuf.quantity);
        var prodQuantity = prod["quantity"];
        prodQuantity = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(prodQuantity) - __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(this.currentMenuf.quantity);
        var key = prod[".key"];
        delete prod[".key"];
        prod["quantity"] = prodQuantity;
        this.$root.$firebaseRefs.products.child(key).set(prod);
        this.performAction(action, true);
      }
    },
    convertBack: function convertBack(action) {
      var _this4 = this;

      var prod = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.products.find(function (item) {
        return item[".key"] == _this4.currentMenuf.productId;
      }));
      if (prod) {
        var purchaseQuantity = prod["purchaseQuantity"] ? prod["purchaseQuantity"] : 0;
        purchaseQuantity = purchaseQuantity + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(this.currentMenuf.quantity);
        var prodQuantity = prod["quantity"];
        prodQuantity = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(prodQuantity) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(this.currentMenuf.quantity);
        var key = prod[".key"];
        delete prod[".key"];
        prod["quantity"] = prodQuantity;
        this.$root.$firebaseRefs.products.child(key).set(prod);
        this.performAction(action, false);
      }
    },
    performAction: function performAction(action, isUpdateDone) {
      switch (action) {
        case "save":
          {
            this.saveFinal();
            break;
          }
        case "update":
          {
            if (isUpdateDone) {
              this.updateFinal();
            } else {
              this.convert(action);
            }
            break;
          }
        case "delete":
          {
            this.deletefinal();
            break;
          }
      }
    }
  }
});

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
var mapBuyerGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])("Buyer")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      datePicker: null,
      menufDialog: false,
      currentMenuf: null,
      manufHeader: [{ text: "Product Name", value: "deposit - ID" }, { text: "Customer Name", value: "deposit - ID" }, { text: "Date", value: "name" }, { text: "Status", value: "name" }, { text: "Edit", value: "edit" }, { text: "Delete", value: "delete" }]
    };
  },
  created: function created() {
    this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("productMenufs", this.$root.$firebaseRefs.productRepair.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("buyers", this.$root.$firebaseRefs.buyer.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("sellers", this.$root.$firebaseRefs.seller.orderByChild("brand").equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear"]), mapGlobalGetters({ units: "productUnit" }), {
    productsByBrand: function productsByBrand() {
      var _this = this;

      return this.products.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      }).map(function (item) {
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
    },
    productMenufsList: function productMenufsList() {
      return this.productMenufs;
    },
    buyersByBrand: function buyersByBrand() {
      var _this2 = this;

      return this.buyers.filter(function (item) {
        return item["brand"] === _this2.selectedBrand;
      }).map(function (item) {
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
    },
    sellersByBrand: function sellersByBrand() {
      var _this3 = this;

      return this.sellers.filter(function (item) {
        return item["brand"] === _this3.selectedBrand;
      }).map(function (item) {
        return {
          text: item["name"],
          value: item[".key"]
        };
      });
    }
  }),
  methods: {
    saveFinal: function saveFinal() {
      this.currentMenuf.date = new Date(this.currentMenuf.date).getTime();
      this.$root.$firebaseRefs.productRepair.push(this.currentMenuf);
      this.menufDialog = false;
    },
    getCustomerName: function getCustomerName(id) {
      var buyer = this.buyersByBrand.find(function (i) {
        return i["value"] == id;
      });
      var seller = this.sellersByBrand.find(function (i) {
        return i["value"] == id;
      });
      if (!buyer && !seller) {
        return "DELETED CUSTOMER";
      }
      return buyer ? buyer.text : seller.text;
    },
    addDamage: function addDamage() {
      this.currentMenuf = {
        brand: this.selectedBrand,
        date: new Date().toISOString().substr(0, 10),
        productId: null,
        quantity: 1,
        status: "Pending",
        remark: "",
        buyerId: null,
        isBuyer: true
      };
      this.menufDialog = true;
    },
    edit: function edit(productSet) {
      this.currentMenuf = productSet;
      this.currentMenuf.date = new Date(this.currentMenuf.date).toISOString().substr(0, 10);
      this.menufDialog = true;
    },
    updateFinal: function updateFinal() {
      var _this4 = this;

      this.currentMenuf.date = new Date(this.currentMenuf.date).getTime();
      var key = this.currentMenuf[".key"];
      delete this.currentMenuf[".key"];
      this.$root.$firebaseRefs.productRepair.child(key).update(this.currentMenuf).then(function (data) {
        _this4.currentMenuf = null;
        _this4.menufDialog = false;
      }).catch(function (error) {
        console.log(error.code, error.message);
      });
    },
    deleteMenuf: function deleteMenuf(productSet) {
      if (window.confirm("Do you want to Delete ?")) {
        this.currentMenuf = productSet;
        this.convertBack("delete");
      }
    },
    getProductName: function getProductName(key) {
      return this.products.find(function (item) {
        return item[".key"] == key;
      }).name;
    },
    deletefinal: function deletefinal(item) {
      if (confirm("Are You sure?")) {
        this.$root.$firebaseRefs.productRepair.child(item[".key"]).remove();
      }
    }
  }
});

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      brandLogo: null,
      snackbar: false,
      currentSettings: {
        isOrderTime: false,
        isStaffSelection: false
      }
    };
  },
  created: function created() {
    this.$bindAsArray("orderSettings", this.$root.$firebaseRefs.orderSetting.orderByChild("brand").equalTo(this.selectedBrand));
    this.getCurrentSettings();
  },

  watch: {
    orderSettings: {
      handler: function handler(value) {
        this.getCurrentSettings();
      },

      deep: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand"])),
  methods: {
    update: function update() {
      var _this = this;

      if (this.currentSettings[".key"]) {
        var key = this.currentSettings[".key"];
        delete this.currentSettings[".key"];
        this.$root.$firebaseRefs.orderSetting.child(key).set(this.currentSettings).then(function () {
          _this.currentSettings[".key"] = key;
          _this.snackbar = true;
        });
      } else {
        this.currentSettings.brand = this.selectedBrand;
        var res = this.$root.$firebaseRefs.orderSetting.push(this.currentSettings);
        this.currentSettings[".key"] = res["key"];
        this.snackbar = true;
      }
    },
    getCurrentSettings: function getCurrentSettings() {
      if (this.orderSettings.length) {
        this.currentSettings = this.orderSettings[0];
      }
    }
  }
});

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      brandLogo: null,
      snackbar: false,
      currentSettings: {
        isLeadTime: false,
        isStaffSelection: false
      }
    };
  },
  created: function created() {
    this.$bindAsArray("leadSettings", this.$root.$firebaseRefs.leadSetting.orderByChild("brand").equalTo(this.selectedBrand));
    this.getCurrentSettings();
  },

  watch: {
    leadSettings: {
      handler: function handler(value) {
        this.getCurrentSettings();
      },

      deep: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand"])),
  methods: {
    update: function update() {
      var _this = this;

      if (this.currentSettings[".key"]) {
        var key = this.currentSettings[".key"];
        delete this.currentSettings[".key"];
        this.$root.$firebaseRefs.leadSetting.child(key).set(this.currentSettings).then(function () {
          _this.currentSettings[".key"] = key;
          _this.snackbar = true;
        });
      } else {
        this.currentSettings.brand = this.selectedBrand;
        var res = this.$root.$firebaseRefs.leadSetting.push(this.currentSettings);
        this.currentSettings[".key"] = res["key"];
        this.snackbar = true;
      }
    },
    getCurrentSettings: function getCurrentSettings() {
      if (this.leadSettings.length) {
        this.currentSettings = this.leadSettings[0];
      }
    }
  }
});

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__buyer__ = __webpack_require__(1641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__global__ = __webpack_require__(1646);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
  modules: {
    Global: __WEBPACK_IMPORTED_MODULE_3__global__["a" /* default */],
    Buyer: __WEBPACK_IMPORTED_MODULE_2__buyer__["a" /* default */]
  }
}));

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_SELECTED_CUSTOMER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_CUSTOMER; });
var SET_SELECTED_CUSTOMER = 'SET_SELECTED_CUSTOMER';
var SET_CUSTOMER = 'SET_CUSTOMER';

/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_BRANDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_SELECTED_BRAND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_ADMIN_EMAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_FIN_YEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_ROLE_AND_PERMISSIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_BRAND_FIN_YEAR; });
var SET_BRANDS = 'SET_BRANDS';
var SET_SELECTED_BRAND = 'SET_SELECTED_BRAND';
var SET_ADMIN_EMAIL = 'SET_ADMIN_EMAIL';
var SET_FIN_YEAR = 'SET_FIN_YEAR';
var SET_ROLE_AND_PERMISSIONS = 'SET_ROLE_AND_PERMISSIONS';
var SET_BRAND_FIN_YEAR = 'SET_BRAND_FIN_YEAR';

/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__expandCard__ = __webpack_require__(36);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ExpandCard: __WEBPACK_IMPORTED_MODULE_4__expandCard__["a" /* default */]
  },
  watch: {
    selectedFirm: function selectedFirm(nval, oval) {
      if (oval !== nval) {
        this.getData();
      }
    }
  },
  created: function created() {
    this.$bindAsArray('invoices', this.$root.$firebaseRefs.invoice.orderByChild('brandFinYear').equalTo(this.brandFinYear));
    this.$bindAsArray('expenses', this.$root.$firebaseRefs.expenses.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('liabilities', this.$root.$firebaseRefs.liabilities.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('assets', this.$root.$firebaseRefs.assets.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('firms', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('accounts', this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('buyers', this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('sellers', this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("customerDeposit", this.$root.$firebaseRefs.customerDeposit.orderByChild('brand').equalTo(this.selectedBrand));
    this.getData();
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand', 'brandFinYear']), {
    selectedFirmDetail: function selectedFirmDetail() {
      var _this = this;

      if (!this.selectedFirm) {
        return null;
      }
      return this.firms.find(function (item) {
        return item['.key'] === _this.selectedFirm;
      });
    },
    ITCData: function ITCData() {
      var _this2 = this;

      var inputGST = {
        IGST: 0,
        CGST: 0,
        SGST: 0
      };
      var outputGST = {
        IGST: 0,
        CGST: 0,
        SGST: 0
      };
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var filteredInvoices = this.invoices.filter(function (item) {
        return item["brand"] === _this2.selectedBrand && item['items'] && item['items'].length && (_this2.selectedFirm ? item["firm"] == _this2.selectedFirm : true) && (_this2.selectedfromDate ? item.date >= fromDate : true) && (_this2.selectedtoDate ? item.date <= toDate : true);
      });
      filteredInvoices.map(function (invoice) {
        if (invoice.isBuyer) {
          invoice.items.map(function (item) {
            outputGST.SGST += item.SGST_val && !item.SGST_ITC_paid ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.SGST_val) : 0;
            outputGST.CGST += item.CGST_val && !item.CGST_ITC_paid ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.CGST_val) : 0;
            outputGST.IGST += item.IGST_val && !item.IGST_ITC_paid ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.IGST_val) : 0;
          });
        } else {
          invoice.items.map(function (item) {
            inputGST.SGST += item.SGST_val && !item.SGST_ITC_paid ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.SGST_val) : 0;
            inputGST.CGST += item.CGST_val && !item.CGST_ITC_paid ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.CGST_val) : 0;
            inputGST.IGST += item.IGST_val && !item.IGST_ITC_paid ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.IGST_val) : 0;
          });
        }
      });

      var returnOBJ = {
        liabilities: {
          SGST: 0,
          CGST: 0,
          IGST: 0
        },
        assets: {
          SGST: 0,
          CGST: 0,
          IGST: 0
        }

        //IGST
      };if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(outputGST.IGST) < __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inputGST.IGST)) {
        returnOBJ.assets.IGST = (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inputGST.IGST) - (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(outputGST.IGST) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(outputGST.CGST) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(outputGST.SGST))).toFixed(2);
      } else {
        returnOBJ.assets.IGST = 0;
      }

      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(outputGST.IGST) > __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inputGST.IGST)) {
        returnOBJ.liabilities.IGST = (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(outputGST.IGST) - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inputGST.IGST)).toFixed(2);
      } else {
        returnOBJ.liabilities.IGST = 0;
      }

      //CGST
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inputGST.CGST) > __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(outputGST.CGST)) {
        returnOBJ.assets.CGST = (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inputGST.CGST) - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(outputGST.CGST)).toFixed(2);
      } else {
        returnOBJ.assets.CGST = 0;
      }

      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inputGST.CGST) < __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(outputGST.CGST)) {
        returnOBJ.liabilities.CGST = (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(outputGST.CGST) - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inputGST.CGST)).toFixed(2);
      } else {
        returnOBJ.liabilities.CGST = 0;
      }

      //SGST
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inputGST.SGST) > __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(outputGST.SGST)) {
        returnOBJ.assets.SGST = (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inputGST.SGST) - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(outputGST.SGST)).toFixed(2);
      } else {
        returnOBJ.assets.SGST = 0;
      }

      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inputGST.SGST) < __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(outputGST.SGST)) {
        returnOBJ.liabilities.SGST = (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(outputGST.SGST) - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inputGST.SGST)).toFixed(2);
      } else {
        returnOBJ.liabilities.SGST = 0;
      }
      return returnOBJ;
    },
    accountByBrand: function accountByBrand() {
      var _this3 = this;

      var accounts = this.accounts.filter(function (account) {
        return account.brand === _this3.selectedBrand;
      });
      if (this.selectedFirm) {
        return accounts.filter(function (account) {
          return account.firm === _this3.selectedFirm;
        });
      }
      return accounts;
    },

    // creditorByBrand() {
    //   if(this.creditors) {
    //     return this.creditors.filter(creditor => creditor['brand'] === this.selectedBrand)
    //   }
    //   return [];
    // },
    // customerByBrand() {
    //   if(this.customers) {
    //     return this.customers.filter(customer => customer['brand'] === this.selectedBrand)
    //   }
    //   return [];
    // },
    // list creditor by Id for diff for invoice
    creditorsById: function creditorsById() {
      return this.creditorByBrand.map(function (item) {
        return item['.key'];
      });
    },

    // list customer by Id for diff for invoice 
    customersById: function customersById() {
      return this.customerByBrand.map(function (item) {
        return item['.key'];
      });
    },

    // current brands firm list
    firmsByBrand: function firmsByBrand() {
      var _this4 = this;

      // return selected brand firms
      return this.firms.filter(function (item) {
        return item['brand'] === _this4.selectedBrand;
      }).map(function (item) {
        return { text: item['name'], value: item['.key'], item: item };
      });
    },

    // all invoice for brand and firms
    invoiceByBrandAndFirm: function invoiceByBrandAndFirm() {
      var _this5 = this;

      if (!this.invoices) {
        return [];
      };
      var filter = this.invoices.filter(function (item) {
        return item['brand'] === _this5.selectedBrand;
      });
      if (this.selectedFirm) {
        filter = filter.filter(function (item) {
          return item.firm === _this5.selectedFirm;
        });
      }
      if (this.filterInvoiceFrom) {
        var from = new Date(this.filterInvoiceFrom).setHours(0, 0, 0, 0);
        filter = filter.filter(function (item) {
          return item.date >= from;
        });
      }
      if (this.filterInvoiceTo) {
        var to = new Date(this.filterInvoiceTo).setHours(23, 29, 59, 999);
        filter = filter.filter(function (item) {
          return item.date <= to;
        });
      }
      return filter;
    },

    // all invoice which are credited
    creditedInvoice: function creditedInvoice() {
      return this.invoiceByBrandAndFirm.filter(function (invoice) {
        return invoice.isCredited;
      });
    },

    // all invoice which are debited
    debitedInvoice: function debitedInvoice() {
      return this.invoiceByBrandAndFirm.filter(function (invoice) {
        return !invoice.isCredited;
      });
    },

    // expense list type by brand
    expenseByBrand: function expenseByBrand() {
      var _this6 = this;

      if (!this.expenses) {
        return [];
      };
      // return expense with underhead 
      return this.expenses.filter(function (item) {
        return item['brand'] === _this6.selectedBrand;
      }).map(function (item) {
        return item['.key'];
      });
    },
    liabilityByBrand: function liabilityByBrand() {
      var _this7 = this;

      if (!this.liabilities) {
        return [];
      };
      // return expense with underhead 
      return this.liabilities.filter(function (item) {
        return item['brand'] === _this7.selectedBrand;
      }).map(function (item) {
        return item['.key'];
      });
    },

    // expense for which expense type is for brands
    invoiceByExpense: function invoiceByExpense() {
      var _this8 = this;

      return this.invoiceByBrandAndFirm.filter(function (invoice) {
        if (invoice.expenseType) {
          return _this8.expenseByBrand.includes(invoice.expenseType);
        }
        return false;
      });
    },
    invoiceByLiability: function invoiceByLiability() {
      var _this9 = this;

      return this.invoiceByBrandAndFirm.filter(function (invoice) {
        if (invoice.liabilityType) {
          return _this9.liabilityByBrand.includes(invoice.liabilityType);
        }
        return false;
      });
    },

    // total amount for expense by current brand
    invoiceByExpenseTotal: function invoiceByExpenseTotal() {
      return this.invoiceByExpense.reduce(function (total, item) {
        return total + item.totalAmount;
      }, 0);
    },

    // total amount for liability by current brand
    invoiceByLiabilityTotal: function invoiceByLiabilityTotal() {
      return this.invoiceByLiability.reduce(function (total, item) {
        return total + item.totalAmount;
      }, 0);
    },

    // total Profit income from invoice by brand and firms
    invoiceTotalIncome: function invoiceTotalIncome() {
      return this.invoiceByBrandAndFirm.reduce(function (total, item) {
        // calculate total Income for expense
        return total + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item['profit'] || 0);
      }, 0);
    },

    // for liabilities
    //  closing balance from net propA/C by firms
    propCapitalAC: function propCapitalAC() {
      if (!this.selectedFirm) {
        return 0;
      }
      return this.selectedFirmDetail.openingBalance;
    },

    // all invoice for brand with status "open"
    openInvoices: function openInvoices() {
      return this.invoiceByBrandAndFirm.filter(function (item) {
        return item.status === 'open';
      });
    },

    // all invoice by creditors
    openInvoiceByCreditor: function openInvoiceByCreditor() {
      var invoice = [];
      for (var i = 0; i !== this.openInvoices.length; i++) {
        // diff invoice by customeId to creditor
        if (this.creditorsById.includes(this.openInvoices[i].customerId)) {
          invoice.push(this.openInvoices[i]);
        }
      }
      return invoice;
    },

    // all invoice by customer (debtors)
    openInvoiceByCustomer: function openInvoiceByCustomer() {
      var invoice = [];
      for (var i = 0; i !== this.openInvoices.length; i++) {
        // diff invoice by customeId to customer
        if (this.customersById.includes(this.openInvoices[i].customerId)) {
          invoice.push(this.openInvoices[i]);
        }
      }
      return invoice;
    },

    // creditor invoice where item type is gold/silver
    openInvoiceByCreditorSundry: function openInvoiceByCreditorSundry() {
      return this.openInvoiceByCreditor.filter(function (invoice) {
        if (invoice.items && invoice.items[0]) {
          return invoice.items[0].type === 'Gold' || invoice.items[0].type === 'Silver';
        }
        return false;
      });
    },

    // creditor invoice where item type is "without item"
    openInvoiceByCreditorUnsecured: function openInvoiceByCreditorUnsecured() {
      return this.openInvoiceByCreditor.filter(function (invoice) {
        if (invoice.items && invoice.items[0]) {
          return invoice.items[0].type === "Without item";
        }
        return false;
      });
    },


    // creditor invoice where item type is gold/silver
    openInvoiceByCustomerSundry: function openInvoiceByCustomerSundry() {
      return this.openInvoiceByCustomer.filter(function (invoice) {
        if (invoice.items && invoice.items[0]) {
          return invoice.items[0].type === 'Gold' || invoice.items[0].type === 'Silver';
        }
        return false;
      });
    },

    // creditor invoice where item type is "without item"
    openInvoiceByCustomerLoanNAdvances: function openInvoiceByCustomerLoanNAdvances() {
      return this.openInvoiceByCustomer.filter(function (invoice) {
        if (invoice.items && invoice.items[0]) {
          return invoice.items[0].type === "Without item";
        }
        return false;
      });
    },

    // Sundry Creditor total: Transaction with item taken by Creditor
    sundryCreditors: function sundryCreditors() {
      return this.openInvoiceByCreditorSundry.reduce(function (total, item) {
        return total + item.totalAmount;
      }, 0);
    },
    sundryCreditorsList: function sundryCreditorsList() {
      var creditor = {};
      var calculated = [];
      try {
        this.openInvoiceByCreditorSundry.forEach(function (invoice) {
          if (creditor[invoice.customerId]) {
            creditor[invoice.customerId].push(invoice);
          } else {
            creditor[invoice.customerId] = [invoice];
          }
        });
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(creditor).forEach(function (customer) {
          var list = creditor[customer] || [];
          calculated.push({
            type: 'creditor',
            invoices: creditor[customer],
            id: customer,
            amount: list.reduce(function (total, item) {
              return total + item.totalAmount;
            }, 0)
          });
        });
      } catch (e) {
        console.info(e);
        return calculated;
      }
      return calculated;
    },

    // Creditors Unsecured Loans Total: landing money without item by Creditor
    unsecuredLoans: function unsecuredLoans() {
      return this.openInvoiceByCreditorUnsecured.reduce(function (total, item) {
        return total + item.totalAmount;
      }, 0);
    },
    unsecuredLoansList: function unsecuredLoansList() {
      var customers = {};
      var customerList = [];
      try {
        this.openInvoiceByCreditorUnsecured.forEach(function (invoice) {
          if (customers[invoice.customerId]) {
            customers[invoice.customerId].push(invoice);
          } else {
            customers[invoice.customerId] = [invoice];
          }
        });
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(customers).forEach(function (items) {
          var list = customers[items] || [];
          customerList.push({
            type: 'creditor',
            invoices: customers[items],
            id: items,
            amount: list.reduce(function (total, item) {
              return total + item.totalAmount;
            }, 0)
          });
        });
      } catch (e) {
        console.info(e);
      }
      return customerList;
    },

    // Debtors Total: Transaction with item taken by Customer(debtors)
    sundryDebtors: function sundryDebtors() {
      return this.openInvoiceByCustomerSundry.reduce(function (total, item) {
        return total + item.totalAmount;
      }, 0);
    },
    sundryDebtorsList: function sundryDebtorsList() {
      var customers = {};
      var customerList = [];
      try {
        this.openInvoiceByCustomerSundry.forEach(function (invoice) {
          if (customers[invoice.customerId]) {
            customers[invoice.customerId].push(invoice);
          } else {
            customers[invoice.customerId] = [invoice];
          }
        });
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(customers).forEach(function (items) {
          var list = customers[items] || [];
          customerList.push({
            type: 'customer',
            invoices: customers[items],
            id: items,
            amount: list.reduce(function (total, item) {
              return total + item.totalAmount;
            }, 0)
          });
        });
      } catch (e) {
        console.info(e);
      }
      return customerList;
    },

    // landing money without by Customer (debtors)
    loansAndAdvances: function loansAndAdvances() {
      return this.openInvoiceByCustomerLoanNAdvances.reduce(function (total, item) {
        return total + item.totalAmount;
      }, 0);
    },
    loansAndAdvancesList: function loansAndAdvancesList() {
      var customers = {};
      var customerList = [];
      try {
        this.openInvoiceByCustomerLoanNAdvances.forEach(function (invoice) {
          if (customers[invoice.customerId]) {
            customers[invoice.customerId].push(invoice);
          } else {
            customers[invoice.customerId] = [invoice];
          }
        });
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(customers).forEach(function (items) {
          var list = customers[items] || [];
          customerList.push({
            type: 'customer',
            invoices: customers[items],
            id: items,
            amount: list.reduce(function (total, item) {
              return total + item.totalAmount;
            }, 0)
          });
        });
      } catch (e) {
        console.info(e);
      }
      return customerList;
    },

    // bank with list
    securedLoansBankList: function securedLoansBankList() {
      return this.accountByBrand.filter(function (bank) {
        return bank.accountType === 'Loan A/C' || bank.accountType === 'Overdraft A/C';
      });
    },

    // Total of amount of secured loans bank
    securedLoansBankListTotal: function securedLoansBankListTotal() {
      return this.securedLoansBankList.reduce(function (total, bank) {
        return total + bank.amount;
      }, 0);
    },

    // secured account bank list
    savingsCurrentBankList: function savingsCurrentBankList() {
      return this.accountByBrand.filter(function (bank) {
        return bank.accountType === 'Saving A/C' || bank.accountType === 'Current A/C';
      });
    },

    // total of amount of saving/current bank account
    savingsCurrentBankListTotal: function savingsCurrentBankListTotal() {
      return this.savingsCurrentBankList.reduce(function (total, bank) {
        return total + bank.amount;
      }, 0);
    },

    // cash in hand: firms available cash
    cashInHand: function cashInHand() {
      var _this10 = this;

      if (this.selectedFirm) {
        var firm = this.firmsByBrand.find(function (firm) {
          return firm.value === _this10.selectedFirm;
        });
        return firm.item.amount;
      }
      return this.firmsByBrand.reduce(function (balance, firm) {
        return balance = balance + firm.item.amount;
      }, 0);
    },
    totalAssetAmount: function totalAssetAmount() {
      var _this11 = this;

      return this.getAssetAccount.reduce(function (total, item) {
        return item.details.totalAmount + item.details.openingBalance - ((item.details.totalAmount + item.details.openingBalance) * ((_this11.isDepriciation ? item.details.depriciation : 0) / 100) || 0) + total;
      }, 0);
    },
    totalInvestmentAmount: function totalInvestmentAmount() {
      return this.getInvestmentAccount.reduce(function (total, item) {
        return item.details.totalAmount + item.details.openingBalance + total;
      }, 0);
    },
    assetByBrand: function assetByBrand() {
      var _this12 = this;

      if (!this.assets) {
        return [];
      };
      // return asset with underhead 
      return this.assets.filter(function (item) {
        return item['brand'] === _this12.selectedBrand && item.type != 'investments';
      });
    },
    assetAsInvestmentByBrand: function assetAsInvestmentByBrand() {
      var _this13 = this;

      if (!this.assets) {
        return [];
      };
      // return asset with underhead 
      return this.assets.filter(function (item) {
        return item['brand'] === _this13.selectedBrand && item.type === 'investments';
      });
    },
    invoiceByBrand: function invoiceByBrand() {
      var _this14 = this;

      if (!this.invoices) {
        return [];
      };
      var filter = this.invoices.filter(function (item) {
        return item['brand'] === _this14.selectedBrand;
      });
      if (this.selectedFirm) {
        filter = filter.filter(function (item) {
          return item.firm === _this14.selectedFirm;
        });
      }
      if (this.filterInvoiceFrom) {
        var from = new Date(this.filterInvoiceFrom).setHours(0, 0, 0, 0);
        filter = filter.filter(function (item) {
          return item.date >= from;
        });
      }
      if (this.filterInvoiceTo) {
        var to = new Date(this.filterInvoiceTo).setHours(23, 29, 59, 999);
        filter = filter.filter(function (item) {
          return item.date <= to;
        });
      }
      return filter;
    },
    getAssetAccount: function getAssetAccount() {
      var _this15 = this;

      var mainGroup = []; // { details: {} && invoices: []}
      try {
        this.assetByBrand.forEach(function (details) {
          var invoices = _this15.invoiceByBrand.filter(function (invoice) {
            if (_this15.selectedFirm) {
              // return invoice of selected firmId
              return invoice.assetType === details['.key'] && invoice.firm === _this15.selectedFirm;
            }
            // return all matched key invoices
            return invoice.assetType === details['.key'];
          });
          details.totalAmount = invoices.reduce(function (total, item) {
            return total + item.totalAmount;
          }, 0);
          details.openingBalance = invoices.reduce(function (total, item) {
            return total + item.openingBalance;
          }, 0);
          if (details.totalAmount) {
            mainGroup.push({
              details: details,
              invoices: invoices
            });
          } else if (details.openingBalance) {
            mainGroup.push({
              details: details,
              invoices: invoices
            });
          }
        });
        return mainGroup;
      } catch (e) {
        console.info(e);
        return [];
      }
    },
    getInvestmentAccount: function getInvestmentAccount() {
      var _this16 = this;

      var mainGroup = []; // { details: {} && invoices: []}
      try {
        this.assetAsInvestmentByBrand.forEach(function (details) {
          var invoices = _this16.invoiceByBrand.filter(function (invoice) {
            if (_this16.selectedFirm) {
              // return invoice of selected firmId
              return invoice.assetType === details['.key'] && invoice.firm === _this16.selectedFirm;
            }
            // return all matched key invoices
            return invoice.assetType === details['.key'];
          });
          details.totalAmount = invoices.reduce(function (total, item) {
            return total + item.totalAmount;
          }, 0);
          details.openingBalance = invoices.reduce(function (total, item) {
            return total + item.openingBalance;
          }, 0);
          if (details.totalAmount) {
            mainGroup.push({
              details: details,
              invoices: invoices
            });
          } else if (details.openingBalance) {
            mainGroup.push({
              details: details,
              invoices: invoices
            });
          }
        });
        return mainGroup;
      } catch (e) {
        console.info(e);
        return [];
      }
    }
  }),
  data: function data() {
    return {
      isDepriciation: true,
      selectedFirm: null,
      filterInvoiceFrom: null,
      filterInvoiceTo: null,
      fromdatepicker: false,
      todatepicker: false,
      searchInput: null,
      totalSundryCreditors: 0,
      totalSundryDebitors: 0,
      totalLoan: 0,
      totalLoanAndAdvances: 0,
      buyerList: [],
      sellerList: [],
      expensesWPro: [],
      expenseTotal: 0
    };
  },
  methods: {
    getName: function getName(key, property, name) {
      var dd = this[property].find(function (item) {
        return item['.key'] === key;
      });
      if (dd) {
        return dd[name] || key;
      }
      return key;
    },
    getData: function getData() {
      this.usersByBrand();
      this.expenseWithProvision();
      this.liabilityWithProvision();
    },
    expenseWithProvision: function expenseWithProvision() {
      var _this17 = this;

      this.expenseTotal = 0;
      var expenses = this.expenses.filter(function (expense) {
        return expense.brand === _this17.selectedBrand;
      });
      expenses = expenses.filter(function (expense) {
        return !!expense['.key'];
      });
      expenses.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = 'confirm';
        var invoices = _this17.invoices.filter(function (invoice) {
          return invoice.brand === _this17.selectedBrand && invoice["expenseType"] === ex['.key'];
        });
        console.log(invoices);
        invoices.map(function (inv) {
          openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
          totalAmount += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          if (paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        expenses[index].paymentTypeStatus = paymentTypeStatus;
        expenses[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        expenses[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        if (expenses[index].paymentTypeStatus == 'yet to confirm') {
          console.log(totalAmount);
          _this17.expenseTotal = isNaN(totalAmount) ? _this17.expenseTotal : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this17.expenseTotal) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(totalAmount);
        }
      });
      this.expenseTotal = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.expenseTotal);
      this.expensesWPro = expenses;
    },

    // Liability With Provision
    liabilityWithProvision: function liabilityWithProvision() {
      var _this18 = this;

      this.liabilityTotal = 0;
      var liabilities = this.liabilities.filter(function (liability) {
        return liability.brand === _this18.selectedBrand;
      });
      liabilities = liabilities.filter(function (liability) {
        return !!liability['.key'];
      });
      liabilities.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = 'confirm';
        var invoices = _this18.invoices.filter(function (invoice) {
          return invoice.brand === _this18.selectedBrand && invoice["liabilityType"] === ex['.key'];
        });
        console.log(invoices);
        invoices.map(function (inv) {
          openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
          totalAmount += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          if (paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        liabilities[index].paymentTypeStatus = paymentTypeStatus;
        liabilities[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        liabilities[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        if (liabilities[index].paymentTypeStatus == 'yet to confirm') {
          console.log(totalAmount);
          _this18.liabilityTotal = isNaN(totalAmount) ? _this18.liabilityTotal : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this18.liabilityTotal) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(totalAmount);
        }
      });
      this.liabilityTotal = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.liabilityTotal);
      this.liabilitiesWPro = liabilities;
    },
    usersByBrand: function usersByBrand() {
      var _this19 = this;

      if (this.sellers) {
        this.totalLoan = 0;
        this.totalLoanAndAdvances = 0;
        this.totalSundryCreditors = 0;
        this.sellerList = this.sellers.filter(function (customer) {
          return customer['brand'] === _this19.selectedBrand;
        });
        this.sellerList.map(function (seller, index) {
          _this19.sellerList[index]['totalDiscount'] = 0;
          _this19.sellerList[index]['totalDueAmount'] = 0;
          _this19.sellerList[index]['totalAdvance'] = 0;
          _this19.sellerList[index]['totalSecurity'] = 0;
          _this19.sellerList[index]['totalOpeningBal'] = 0;
          _this19.sellerList[index]['totalLoanGiven'] = 0;
          _this19.sellerList[index]['totalLoanTaken'] = 0;
          var invoices = _this19.invoices.filter(function (item) {
            return item["brand"] === _this19.selectedBrand && item["buyerId"] === seller['.key'] && (item["status"] === "due" || item["status"] === "partial") && (_this19.selectedFirm ? item["firm"] === _this19.selectedFirm : true);
          });
          invoices.map(function (inv) {
            _this19.sellerList[index]['totalDueAmount'] += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv.remainingAmount);
            _this19.sellerList[index]['totalDiscount'] += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv.discountAmount);
          });

          var advanceInv = _this19.customerDeposit.filter(function (item) {
            return item["brand"] === _this19.selectedBrand && item["buyerId"] === seller['.key'] && item["type"] === "Advance" && !!item["isUserCreated"] && parseInt(item["remainingAmount"]) > 0 && (_this19.selectedFirm ? item["firm"] === _this19.selectedFirm : true);
          });
          advanceInv.map(function (inv) {
            _this19.sellerList[index]['totalAdvance'] = inv.remainingAmount;
          });

          var securityInv = _this19.customerDeposit.filter(function (item) {
            return item["brand"] === _this19.selectedBrand && item["buyerId"] === seller['.key'] && item["type"] === "Security" && !!item["isUserCreated"] && parseInt(item["remainingAmount"]) > 0 && (_this19.selectedFirm ? item["firm"] === _this19.selectedFirm : true);
          });
          securityInv.map(function (inv) {
            _this19.sellerList[index]['totalSecurity'] = inv.remainingAmount;
          });

          var openingInv = _this19.customerDeposit.filter(function (item) {
            return item["brand"] === _this19.selectedBrand && item["buyerId"] === seller['.key'] && item["type"] === "Opening Balance" && !!item["isUserCreated"] && parseInt(item["remainingAmount"]) > 0 && (_this19.selectedFirm ? item["firm"] === _this19.selectedFirm : true);
          });
          openingInv.map(function (inv) {
            _this19.sellerList[index]['totalOpeningBal'] = inv.remainingAmount;
          });

          var loanInv = _this19.customerDeposit.filter(function (item) {
            return item["brand"] === _this19.selectedBrand && item["buyerId"] === seller['.key'] && item["type"] === "Loan Given" && (_this19.selectedFirm ? item["firm"] === _this19.selectedFirm : true);
          });
          loanInv.map(function (inv) {
            _this19.sellerList[index]['totalLoanGiven'] += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv.amount);
          });

          var loanInvTkn = _this19.customerDeposit.filter(function (item) {
            return item["brand"] === _this19.selectedBrand && item["buyerId"] === seller['.key'] && item["type"] === "Loan Taken" && (_this19.selectedFirm ? item["firm"] === _this19.selectedFirm : true);
          });
          loanInvTkn.map(function (inv) {
            _this19.sellerList[index]['totalLoanTaken'] += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv.amount);
          });

          _this19.totalLoan += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this19.sellerList[index]['totalLoanGiven']);
          _this19.totalLoanAndAdvances += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this19.sellerList[index]['totalLoanTaken']);
          _this19.sellerList[index]['totalRemainingAmount'] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this19.sellerList[index]['totalOpeningBal']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this19.sellerList[index]['totalDueAmount']) - (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this19.sellerList[index]['totalAdvance']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this19.sellerList[index]['totalSecurity']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this19.sellerList[index]['totalDiscount']));
          _this19.totalSundryCreditors += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this19.sellerList[index]['totalRemainingAmount']);
        });
      }

      if (this.buyers) {
        this.totalSundryDebitors = 0;
        this.buyerList = this.buyers.filter(function (customer) {
          return customer['brand'] === _this19.selectedBrand;
        });
        this.buyerList.map(function (seller, index) {
          _this19.buyerList[index]['totalDiscount'] = 0;
          _this19.buyerList[index]['totalDueAmount'] = 0;
          _this19.buyerList[index]['totalAdvance'] = 0;
          _this19.buyerList[index]['totalSecurity'] = 0;
          _this19.buyerList[index]['totalOpeningBal'] = 0;
          _this19.buyerList[index]['totalLoanTaken'] = 0;
          _this19.buyerList[index]['totalLoanGiven'] = 0;
          _this19.buyerList[index]['totalRemainingAmount'] = 0;
          var invoices = _this19.invoices.filter(function (item) {
            return item["brand"] === _this19.selectedBrand && item["buyerId"] === seller['.key'] && (item["status"] === "due" || item["status"] === "partial") && (_this19.selectedFirm ? item["firm"] === _this19.selectedFirm : true);
          });
          invoices.map(function (inv) {
            console.log(_this19.buyerList[index]['totalDueAmount']);
            _this19.buyerList[index]['totalDueAmount'] += inv.remainingAmount ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv.remainingAmount) : 0;
            _this19.buyerList[index]['totalDiscount'] += inv.discountAmount ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv.discountAmount) : 0;
          });

          var advanceInv = _this19.customerDeposit.filter(function (item) {
            return item["brand"] === _this19.selectedBrand && item["buyerId"] === seller['.key'] && item["type"] === "Advance" && !!item["isUserCreated"] && parseInt(item["remainingAmount"]) > 0 && (_this19.selectedFirm ? item["firm"] === _this19.selectedFirm : true);
          });
          advanceInv.map(function (inv) {
            _this19.buyerList[index]['totalAdvance'] = inv.remainingAmount;
          });

          var securityInv = _this19.customerDeposit.filter(function (item) {
            return item["brand"] === _this19.selectedBrand && item["buyerId"] === seller['.key'] && item["type"] === "Security" && !!item["isUserCreated"] && parseInt(item["remainingAmount"]) > 0 && (_this19.selectedFirm ? item["firm"] === _this19.selectedFirm : true);
          });
          securityInv.map(function (inv) {
            _this19.buyerList[index]['totalSecurity'] = inv.remainingAmount;
          });

          var openingInv = _this19.customerDeposit.filter(function (item) {
            return item["brand"] === _this19.selectedBrand && item["buyerId"] === seller['.key'] && item["type"] === "Opening Balance" && !!item["isUserCreated"] && parseInt(item["remainingAmount"]) > 0 && (_this19.selectedFirm ? item["firm"] === _this19.selectedFirm : true);
          });
          openingInv.map(function (inv) {
            _this19.buyerList[index]['totalOpeningBal'] = inv.remainingAmount;
          });

          var loanInv = _this19.customerDeposit.filter(function (item) {
            return item["brand"] === _this19.selectedBrand && item["buyerId"] === seller['.key'] && item["type"] === "Loan Taken" && (_this19.selectedFirm ? item["firm"] === _this19.selectedFirm : true);
          });
          loanInv.map(function (inv) {
            _this19.buyerList[index]['totalLoanTaken'] += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv.amount);
          });

          var loanInvGV = _this19.customerDeposit.filter(function (item) {
            return item["brand"] === _this19.selectedBrand && item["buyerId"] === seller['.key'] && item["type"] === "Loan Given" && (_this19.selectedFirm ? item["firm"] === _this19.selectedFirm : true);
          });
          loanInvGV.map(function (inv) {
            _this19.buyerList[index]['totalLoanGiven'] += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv.amount);
          });

          _this19.totalLoanAndAdvances += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this19.buyerList[index]['totalLoanTaken']);
          _this19.totalLoan += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this19.buyerList[index]['totalLoanGiven']);
          _this19.buyerList[index]['totalRemainingAmount'] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this19.buyerList[index]['totalOpeningBal']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this19.buyerList[index]['totalDueAmount']) - (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this19.buyerList[index]['totalAdvance']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this19.buyerList[index]['totalSecurity']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this19.buyerList[index]['totalDiscount']));
          _this19.totalSundryDebitors += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this19.buyerList[index]['totalRemainingAmount']);
        });
      }
    }
  }
});

/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'ExpandCard',
    props: {
        onlyTitle: {
            type: Boolean,
            default: false
        },
        value: {
            type: [String, Number],
            default: function _default() {
                return 0;
            }
        },
        hasItems: {
            type: Boolean,
            default: false
        },
        containerClass: {
            type: String,
            default: function _default() {
                return '';
            }
        }
    },
    methods: {
        handleClick: function handleClick(e) {
            e.stopPropagation();
            // e.preventDefault();
            console.info('lol');
        }
    }
});

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_int__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_pdf_reports_information_reports__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__expandCard__ = __webpack_require__(1659);








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ExpandCard: __WEBPACK_IMPORTED_MODULE_10__expandCard__["a" /* default */]
  },
  watch: {
    selectedFirm: function selectedFirm(nval, oval) {
      if (oval !== nval) {
        this.getData();
      }
    }
  },
  created: function created() {
    this.$bindAsArray('invoices', this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('expenses', this.$root.$firebaseRefs.expenses.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('incomes', this.$root.$firebaseRefs.incomes.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('liabilities', this.$root.$firebaseRefs.liabilities.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('assets', this.$root.$firebaseRefs.assets.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('firms', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('accounts', this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('buyers', this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('sellers', this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("customerDeposit", this.$root.$firebaseRefs.customerDeposit.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('salarys', this.$root.$firebaseRefs.salarys.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('staff', this.$root.$firebaseRefs.staff.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("productList", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("firmSettings", this.$root.$firebaseRefs.firmSettings.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("productGroups", this.$root.$firebaseRefs.productGroup.orderByChild("brand").equalTo(this.selectedBrand));
    this.getData();
  },

  computed: __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand', 'finYear', "brandFinYear"]), {
    firmStockReportType: function firmStockReportType() {
      var _this = this;

      var val = 'APP';
      if (this.selectedFirm) {
        var dfirmSetting = this.firmSettings.filter(function (item) {
          return item['firm'] == _this.selectedFirm['.key'];
        })[0];
        if (dfirmSetting && dfirmSetting.stockReportView) {
          val = dfirmSetting.stockReportView;
        }
      }
      return val;
    },
    selectedFirmDetail: function selectedFirmDetail() {
      var _this2 = this;

      if (!this.selectedFirm) {
        return null;
      }
      return this.firms.find(function (item) {
        return item['.key'] === _this2.selectedFirm['.key'];
      });
    },
    filteredProduct: function filteredProduct() {
      var _this3 = this;

      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var products = this.productList.filter(function (item) {
        return item['brand'] === _this3.selectedBrand && (_this3.selectedFirm ? item['firm'] === _this3.selectedFirm['.key'] : true);
      });
      var total = {
        quantity: 0,
        durationQuantity: 0,
        durationAmount: 0,
        saleQuantity: 0,
        durationQtySale: 0,
        durationAmountSale: 0,
        purchaseQuantity: 0,
        durationQtyPurchase: 0,
        durationAmountPurchase: 0,
        openingQuantity: 0,
        openingBalance: 0
      };
      products.map(function (p, index) {
        p["durationQuantity"] = undefined;
        p["durationAmount"] = 0;
        p["durationQtySale"] = 0;
        p["durationQtyPurchase"] = 0;
        p["durationAmountSale"] = 0;
        p["durationAmountPurchase"] = 0;
        p["stockReportData"] = {
          saleDetails: [],
          purchaseDetails: [],
          lastSalePrice: 0,
          lastPurchasePrice: 0
        };
        var prodG = {
          weight: 0,
          openingBalance: 0
        };
        if (_this3.isJwelleryBussiness) {
          if (p.productGroup) {
            prodG = _this3.productGroups.find(function (item) {
              return item[".key"] == p.productGroup;
            });
          }
          products[index]["openingQuantity"] = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prodG && prodG.weigh ? prodG.weight : 0);
          products[index]["openingBalance"] = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prodG && prodG.openingBalance ? prodG.openingBalance : 0);
        } else {
          products[index]["openingQuantity"] = 0;
          products[index]["openingBalance"] = 0;
        }
        if (p.openingBalance && p.openingQuantity) {
          p["stockReportData"]['purchaseDetails'].push({
            // quantity : Number.parseFloat(p.openingQuantity),
            // rate : Number.parseInt(p.openingBalance),
            quantity: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_int___default()(p.openingQuantity),
            rate: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(p.openingBalance) / __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_int___default()(p.openingQuantity),
            date: p.openingDate
          });
          p["stockReportData"]['lastPurchasePrice'] = p.openingBalance;
        }
        total.openingQuantity += parseInt(p["openingQuantity"] ? p["openingQuantity"] : 0);
        total.openingBalance += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(p["openingBalance"] ? p["openingBalance"] : 0);
      });
      var productGroup = products.reduce(function (r, a) {
        r[a[".key"]] = r[a[".key"]] || [];
        r[a[".key"]].push(a);
        return r;
      }, __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_create___default()(null));
      var latestSaleDate = new Date('01-01-1000').getTime();
      var latestPurchaseDate = new Date('01-01-1000').getTime();
      var filteredInvoices = this.invoices.filter(function (item) {
        return item.type != "automatic invoice" && item.items && item.items.length && item.date >= _this3.finYear.start && item.deleted != true && item.date <= _this3.finYear.end && (_this3.selectedFirm ? item['firm'] === _this3.selectedFirm['.key'] : true) && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true);
      });
      this.selectProdList = [];
      filteredInvoices.map(function (invoice) {
        var invoiceMonth = new Date(invoice.date).getMonth();
        var isBuyer = invoice.isBuyer;
        invoice.items && invoice.items.map(function (item) {
          if (productGroup[item["productId"]]) {
            if (productGroup[item["productId"]][0].durationQuantity != undefined) {
              var durationQuantity = parseInt(productGroup[item["productId"]][0]["durationQuantity"]);
              durationQuantity += !!isBuyer ? -parseInt(item.quantity) : parseInt(item.quantity);
              total.durationQuantity += durationQuantity;
              productGroup[item["productId"]][0]["durationQuantity"] = durationQuantity;
            } else {
              productGroup[item["productId"]][0]["durationQuantity"] = productGroup[item["productId"]][0].openingQuantity ? productGroup[item["productId"]][0].openingQuantity : 0;
              total.durationQuantity += parseInt(productGroup[item["productId"]][0]["durationQuantity"]);
            }
            var rate = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.rate);
            if (isBuyer) {
              if (invoice.date > latestSaleDate) {
                latestSaleDate = invoice.date;
                productGroup[item["productId"]][0]['stockReportData']['lastSalePrice'] = rate;
              }
              productGroup[item["productId"]][0]['stockReportData']['saleDetails'].push({
                quantity: item.quantity,
                rate: rate,
                date: invoice.date
              });
            } else {
              if (invoice.date > latestPurchaseDate) {
                latestPurchaseDate = invoice.date;
                productGroup[item["productId"]][0]['stockReportData']['lastPurchasePrice'] = rate;
              }
              productGroup[item["productId"]][0]['stockReportData']['purchaseDetails'].push({
                quantity: item.quantity,
                rate: rate,
                date: invoice.date
              });
            }
            productGroup[item["productId"]][0]["durationAmount"] += !!isBuyer ? -__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.GSTValue) : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
            total.durationAmount += productGroup[item["productId"]][0]["durationAmount"];
            if (!!isBuyer) {
              productGroup[item["productId"]][0]["durationQtySale"] += parseInt(item.quantity);
              total.durationQtySale += parseInt(item.quantity);
              productGroup[item["productId"]][0]["durationAmountSale"] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
              total.durationAmountSale += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
            } else {
              productGroup[item["productId"]][0]["durationQtyPurchase"] += parseInt(item.quantity);
              total.durationQtyPurchase += parseInt(item.quantity);
              productGroup[item["productId"]][0]["durationAmountPurchase"] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
              total.durationAmountPurchase += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
            }
            item['date'] = invoice.date;
            item['invoice'] = invoice;
            item['isBuyer'] = invoice['isBuyer'];
            item['openingBalance'] = productGroup[item["productId"]][0]['openingBalance'];
            item['openingQuantity'] = productGroup[item["productId"]][0]['openingQuantity'];
            if (!(productGroup[item["productId"]][0]['productList'] && productGroup[item["productId"]][0]['productList'].length)) productGroup[item["productId"]][0]['productList'] = [];

            productGroup[item["productId"]][0]['productList'].push(item);
          }
        });
      });
      // productGroup['total'] = [{
      //   name : 'Total',
      //   ".key" : 'total',
      //   quantity : total.quantity,
      //   durationQuantity : total.durationQuantity,
      //   durationAmount : total.durationAmount,
      //   saleQuantity : total.saleQuantity,
      //   durationQtySale : total.durationQtySale,
      //   durationAmountSale : total.durationAmountSale,
      //   purchaseQuantity : total.purchaseQuantity,
      //   durationQtyPurchase : total.durationQtyPurchase,
      //   durationAmountPurchase : total.durationAmountPurchase,
      //   openingQuantity : total.openingQuantity,
      //   openingBalance : total.openingBalance
      // }];
      var results = [];
      this.closingStock = 0;
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(productGroup).length && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(productGroup).map(function (key, index) {
        productGroup[key][".key"] = key;
        results.push(productGroup[key][0]);
        // productGroup[key][0]['closingAmount'] = this.getClosingAmount(productGroup[key][0]);
        var temp = _this3.getClosingAmount(productGroup[key][0]);
        productGroup[key][0]['closingAmount'] = isNaN(temp) ? 0 : temp;
        _this3.closingStock += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(productGroup[key][0]['closingAmount']);
      });

      return results;
    },
    filteredGroups: function filteredGroups() {
      var products = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()([], this.filteredProduct);
      //let total = products.pop();
      var groups = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.productGroups));
      groups.push({
        name: "Non group Products",
        ".key": "Nongroup",
        quantity: 0,
        durationQuantity: 0,
        durationAmount: 0,
        saleQuantity: 0,
        durationQtySale: 0,
        durationAmountSale: 0,
        purchaseQuantity: 0,
        durationQtyPurchase: 0,
        durationAmountPurchase: 0,
        openingQuantity: 0,
        openingBalance: 0,
        closingAmount: 0,
        closingQuantity: 0
      });
      groups.map(function (item, index) {
        groups[index]["productList"] = [];
        groups[index]["quantity"] = 0;
        groups[index]["durationQuantity"] = 0;
        groups[index]["durationAmount"] = 0;
        groups[index]["saleQuantity"] = 0;
        groups[index]["durationQtySale"] = 0;
        groups[index]["durationAmountSale"] = 0;
        groups[index]["purchaseQuantity"] = 0;
        groups[index]["durationQtyPurchase"] = 0;
        groups[index]["durationAmountPurchase"] = 0;
        groups[index]['openingQuantity'] = item.weight;
        groups[index]['openingBalance'] = item.openingBalance;

        groups[index]["closingAmount"] = 0;
        groups[index]["closingQuantity"] = 0;
      });
      groups.map(function (item, index) {
        products.map(function (prod) {
          if (prod.productGroup && prod.productGroup == item[".key"]) {
            groups[index]["productList"] = groups[index]["productList"].concat(prod.productList);
            groups[index]["quantity"] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod["quantity"]);
            groups[index]["durationQuantity"] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod["durationQuantity"]);
            groups[index]["durationAmount"] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod["durationAmount"]);
            groups[index]["saleQuantity"] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod["saleQuantity"]);
            groups[index]["durationQtySale"] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod["durationQtySale"]);
            groups[index]["durationAmountSale"] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod["durationAmountSale"]);
            groups[index]["purchaseQuantity"] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod["purchaseQuantity"]);
            groups[index]["durationQtyPurchase"] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod["durationQtyPurchase"]);
            groups[index]["durationAmountPurchase"] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod["durationAmountPurchase"]);
            // groups[index]["openingQuantity"] += Number.parseFloat(
            //   prod["openingQuantity"]
            // );
            // groups[index]["openingBalance"] += Number.parseFloat(
            //   prod["openingBalance"]
            // );
            groups[index]["closingAmount"] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod["closingAmount"]);
            groups[index]["closingQuantity"] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod["closingQuantity"]);
          } else if (!prod.productGroup && item[".key"] == "Nongroup") {
            groups[index]["productList"] = groups[index]["productList"].concat(prod.productList);
            groups[index]["quantity"] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod["quantity"]);
            groups[index]["durationQuantity"] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod["durationQuantity"]);
            groups[index]["durationAmount"] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod["durationAmount"]);
            groups[index]["saleQuantity"] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod["saleQuantity"]);
            groups[index]["durationQtySale"] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod["durationQtySale"]);
            groups[index]["durationAmountSale"] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod["durationAmountSale"]);
            groups[index]["purchaseQuantity"] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod["purchaseQuantity"]);
            groups[index]["durationQtyPurchase"] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod["durationQtyPurchase"]);
            groups[index]["durationAmountPurchase"] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod["durationAmountPurchase"]);
            groups[index]["openingQuantity"] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod["openingQuantity"]);
            groups[index]["openingBalance"] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod["openingBalance"]);
            groups[index]["closingAmount"] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod["closingAmount"]);
            groups[index]["closingQuantity"] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod["closingQuantity"]);
          }
        });
      });
      //groups.push(total);
      groups.map(function (prod, index) {
        groups[index]["closingAmount"] = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod["openingBalance"]) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod["durationAmountPurchase"]) - __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod["durationAmountSale"]);
        groups[index]["closingQuantity"] = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod["openingQuantity"]) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod["durationQtyPurchase"]) - __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod["durationQtySale"]);
      });

      var closingAmount = 0;
      var openingBalance = 0;
      groups.map(function (prod, index) {
        groups[index]['quantity'] = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod['quantity']).toFixed(3);
        groups[index]['durationQuantity'] = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod['durationQuantity']).toFixed(3);
        groups[index]['durationAmount'] = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod['durationAmount']).toFixed(3);
        groups[index]['saleQuantity'] = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod['saleQuantity']).toFixed(3);
        groups[index]['durationQtySale'] = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod['durationQtySale']).toFixed(3);
        groups[index]['durationAmountSale'] = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod['durationAmountSale']).toFixed(3);
        groups[index]['purchaseQuantity'] = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod['purchaseQuantity']).toFixed(3);
        groups[index]['durationQtyPurchase'] = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod['durationQtyPurchase']).toFixed(3);
        groups[index]['durationAmountPurchase'] = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod['durationAmountPurchase']).toFixed(3);
        groups[index]['openingQuantity'] = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod['openingQuantity']).toFixed(3);
        groups[index]['openingBalance'] = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod['openingBalance']).toFixed(3);
        groups[index]['closingAmount'] = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod['closingAmount']).toFixed(3);
        groups[index]['closingQuantity'] = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod['closingQuantity']).toFixed(3);
        closingAmount += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod['closingAmount']);
        openingBalance += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(prod['openingBalance']);
      });
      this.closingStockWeight = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(closingAmount).toFixed(3);
      this.totalOpeningStockWeight = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(3);

      return groups;
    },
    ITCData: function ITCData() {
      var _this4 = this;

      var inputGST = {
        IGST: 0,
        CGST: 0,
        SGST: 0
      };
      var outputGST = {
        IGST: 0,
        CGST: 0,
        SGST: 0
      };
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var filteredInvoices = this.invoices.filter(function (item) {
        return item["brand"] === _this4.selectedBrand && item.date >= _this4.finYear.start && item.date <= _this4.finYear.end && item['items'] && item['items'].length && (_this4.selectedFirm ? item["firm"] == _this4.selectedFirm['.key'] : true) && (_this4.selectedfromDate ? item.date >= fromDate : true) && item.deleted != true && (_this4.selectedtoDate ? item.date <= toDate : true);
      });
      filteredInvoices.map(function (invoice) {
        if (invoice.isBuyer) {
          invoice.items && invoice.items.map(function (item) {
            outputGST.SGST += item.SGST_val ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.SGST_val) : 0;
            outputGST.CGST += item.CGST_val ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.CGST_val) : 0;
            outputGST.IGST += item.IGST_val ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.IGST_val) : 0;
          });
        } else {
          invoice.items && invoice.items.map(function (item) {
            inputGST.SGST += item.SGST_val ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.SGST_val) : 0;
            inputGST.CGST += item.CGST_val ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.CGST_val) : 0;
            inputGST.IGST += item.IGST_val ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item.IGST_val) : 0;
          });
        }
      });

      var returnOBJ = {
        liabilities: {
          SGST: 0,
          CGST: 0,
          IGST: 0
        },
        assets: {
          SGST: 0,
          CGST: 0,
          IGST: 0
        }

        //IGST
      };if (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(outputGST.IGST) < __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inputGST.IGST)) {
        returnOBJ.assets.IGST = (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inputGST.IGST) - (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(outputGST.IGST) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(outputGST.CGST) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(outputGST.SGST))).toFixed(2);
      } else {
        returnOBJ.assets.IGST = 0;
      }

      if (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(outputGST.IGST) > __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inputGST.IGST)) {
        returnOBJ.liabilities.IGST = (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(outputGST.IGST) - __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inputGST.IGST)).toFixed(2);
      } else {
        returnOBJ.liabilities.IGST = 0;
      }

      //CGST
      if (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inputGST.CGST) > __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(outputGST.CGST)) {
        returnOBJ.assets.CGST = (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inputGST.CGST) - __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(outputGST.CGST)).toFixed(2);
      } else {
        returnOBJ.assets.CGST = 0;
      }

      if (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inputGST.CGST) < __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(outputGST.CGST)) {
        returnOBJ.liabilities.CGST = (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(outputGST.CGST) - __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inputGST.CGST)).toFixed(2);
      } else {
        returnOBJ.liabilities.CGST = 0;
      }

      //SGST
      if (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inputGST.SGST) > __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(outputGST.SGST)) {
        returnOBJ.assets.SGST = (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inputGST.SGST) - __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(outputGST.SGST)).toFixed(2);
      } else {
        returnOBJ.assets.SGST = 0;
      }

      if (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inputGST.SGST) < __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(outputGST.SGST)) {
        returnOBJ.liabilities.SGST = (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(outputGST.SGST) - __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inputGST.SGST)).toFixed(2);
      } else {
        returnOBJ.liabilities.SGST = 0;
      }
      return returnOBJ;
    },
    accountByBrand: function accountByBrand() {
      var _this5 = this;

      var accounts = this.accounts.filter(function (account) {
        return account.brand === _this5.selectedBrand;
      });
      if (this.selectedFirm) {
        return accounts.filter(function (account) {
          return account.firm === _this5.selectedFirm['.key'];
        });
      }
      return accounts;
    },

    // creditorByBrand() {
    //   if(this.creditors) {
    //     return this.creditors.filter(creditor => creditor['brand'] === this.selectedBrand)
    //   }
    //   return [];
    // },
    // customerByBrand() {
    //   if(this.customers) {
    //     return this.customers.filter(customer => customer['brand'] === this.selectedBrand)
    //   }
    //   return [];
    // },
    // list creditor by Id for diff for invoice
    creditorsById: function creditorsById() {
      return this.creditorByBrand.map(function (item) {
        return item['.key'];
      });
    },

    // list customer by Id for diff for invoice 
    customersById: function customersById() {
      return this.customerByBrand.map(function (item) {
        return item['.key'];
      });
    },

    // current brands firm list
    firmsByBrand: function firmsByBrand() {
      var _this6 = this;

      // return selected brand firms
      return this.firms.filter(function (item) {
        return item['brand'] === _this6.selectedBrand;
      }).map(function (item) {
        if (item.defaultFirm) {
          _this6.selectedFirm = item;
          _this6.isJwelleryBussiness = item.businessType == "Jwellery";
        }
        return item;
      });
    },

    // all invoice for brand and firms
    invoiceByBrandAndFirm: function invoiceByBrandAndFirm() {
      var _this7 = this;

      if (!this.invoices) {
        return [];
      };
      var filter = this.invoices.filter(function (item) {
        return item['brand'] === _this7.selectedBrand && item.date >= _this7.finYear.start && item.deleted != true && item.date <= _this7.finYear.end;
      });
      if (this.selectedFirm) {
        filter = filter.filter(function (item) {
          return item.firm === _this7.selectedFirm['.key'];
        });
      }
      if (this.filterInvoiceFrom) {
        var from = new Date(this.filterInvoiceFrom).setHours(0, 0, 0, 0);
        filter = filter.filter(function (item) {
          return item.date >= from;
        });
      }
      if (this.filterInvoiceTo) {
        var to = new Date(this.filterInvoiceTo).setHours(23, 29, 59, 999);
        filter = filter.filter(function (item) {
          return item.date <= to;
        });
      }
      return filter;
    },

    // all invoice which are credited
    creditedInvoice: function creditedInvoice() {
      return this.invoiceByBrandAndFirm.filter(function (invoice) {
        return invoice.isCredited;
      });
    },

    // all invoice which are debited
    debitedInvoice: function debitedInvoice() {
      return this.invoiceByBrandAndFirm.filter(function (invoice) {
        return !invoice.isCredited;
      });
    },

    // expense list type by brand
    expenseByBrand: function expenseByBrand() {
      var _this8 = this;

      if (!this.expenses) {
        return [];
      };
      // return expense with underhead 
      return this.expenses.filter(function (item) {
        return item['brand'] === _this8.selectedBrand;
      }).map(function (item) {
        return item['.key'];
      });
    },
    liabilityByBrand: function liabilityByBrand() {
      var _this9 = this;

      if (!this.liabilities) {
        return [];
      };
      // return expense with underhead 
      return this.liabilities.filter(function (item) {
        return item['brand'] === _this9.selectedBrand;
      }).map(function (item) {
        return item['.key'];
      });
    },

    // expense for which expense type is for brands
    invoiceByExpense: function invoiceByExpense() {
      var _this10 = this;

      return this.invoiceByBrandAndFirm.filter(function (invoice) {
        if (invoice.expenseType) {
          return _this10.expenseByBrand.includes(invoice.expenseType);
        }
        return false;
      });
    },
    invoiceByLiability: function invoiceByLiability() {
      var _this11 = this;

      return this.invoiceByBrandAndFirm.filter(function (invoice) {
        if (invoice.liabilityType) {
          return _this11.liabilityByBrand.includes(invoice.liabilityType);
        }
        return false;
      });
    },

    // total amount for expense by current brand
    invoiceByExpenseTotal: function invoiceByExpenseTotal() {
      return this.invoiceByExpense.reduce(function (total, item) {
        return total + item.totalAmount;
      }, 0);
    },

    // total amount for liability by current brand
    invoiceByLiabilityTotal: function invoiceByLiabilityTotal() {
      return this.invoiceByLiability.reduce(function (total, item) {
        return total + item.totalAmount;
      }, 0);
    },

    // total Profit income from invoice by brand and firms
    invoiceTotalIncome: function invoiceTotalIncome() {
      return this.invoiceByBrandAndFirm.reduce(function (total, item) {
        // calculate total Income for expense
        return total + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(item['profit'] || 0);
      }, 0);
    },

    // for liabilities
    //  closing balance from net propA/C by firms
    propCapitalAC: function propCapitalAC() {
      if (!this.selectedFirm) {
        return 0;
      }
      return this.selectedFirmDetail.openingBalance;
    },


    // Start of liability from Transaction Tab
    groupLiabilities: function groupLiabilities() {
      var _this12 = this;

      this.liabilityTotal = 0;
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var liabilities = this.liabilities.filter(function (liability) {
        return liability.brand === _this12.selectedBrand && liability.category === "non-current" && liability.underHead === "Long-term Borrowing";
      });
      liabilities = liabilities.filter(function (liability) {
        return !!liability['.key'];
      });
      liabilities.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = 'confirm';
        var invoices = _this12.invoices.filter(function (invoice) {
          return invoice.brand === _this12.selectedBrand && invoice.date >= _this12.finYear.start && invoice.date <= _this12.finYear.end && invoice["liabilityType"] === ex['.key'] && (_this12.selectedFirm ? invoice['firm'] === _this12.selectedFirm['.key'] : true) && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true);
        });
        invoices.map(function (inv) {
          openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
          totalAmount += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          if (paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        liabilities[index]['invoices'] = invoices;
        liabilities[index].paymentTypeStatus = paymentTypeStatus;
        liabilities[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        liabilities[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        _this12.liabilityTotal += (isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(openingBalance)) + (isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(totalAmount));
      });
      this.liabilityTotal = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.liabilityTotal).toFixed(2);
      return liabilities;
    },

    // End of liability From Transaction Tab

    // Start of Short-term liability from Transaction Tab
    groupLiabilitiesShortTerm: function groupLiabilitiesShortTerm() {
      var _this13 = this;

      this.shortTermLiabilityTotal = 0;
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var liabilities = this.liabilities.filter(function (liability) {
        return liability.brand === _this13.selectedBrand && liability.category === "current" && liability.underHead === "Short-Term Borrowing";
      });
      liabilities = liabilities.filter(function (liability) {
        return !!liability['.key'];
      });
      liabilities.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = 'confirm';
        var invoices = _this13.invoices.filter(function (invoice) {
          return invoice.brand === _this13.selectedBrand && invoice.date >= _this13.finYear.start && invoice.date <= _this13.finYear.end && invoice["liabilityType"] === ex['.key'] && (_this13.selectedFirm ? invoice['firm'] === _this13.selectedFirm['.key'] : true) && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true);
        });
        invoices.map(function (inv) {
          openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
          totalAmount += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          if (paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        liabilities[index]['invoices'] = invoices;
        liabilities[index].paymentTypeStatus = paymentTypeStatus;
        liabilities[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        liabilities[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        _this13.shortTermLiabilityTotal += (isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(openingBalance)) + (isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(totalAmount));
      });
      this.shortTermLiabilityTotal = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.shortTermLiabilityTotal).toFixed(2);
      return liabilities;
    },

    // End of liability From Transaction Tab


    // all invoice for brand with status "open"
    openInvoices: function openInvoices() {
      return this.invoiceByBrandAndFirm.filter(function (item) {
        return item.status === 'open';
      });
    },

    // all invoice by creditors
    openInvoiceByCreditor: function openInvoiceByCreditor() {
      var invoice = [];
      for (var i = 0; i !== this.openInvoices.length; i++) {
        // diff invoice by customeId to creditor
        if (this.creditorsById.includes(this.openInvoices[i].customerId)) {
          invoice.push(this.openInvoices[i]);
        }
      }
      return invoice;
    },

    // all invoice by customer (debtors)
    openInvoiceByCustomer: function openInvoiceByCustomer() {
      var invoice = [];
      for (var i = 0; i !== this.openInvoices.length; i++) {
        // diff invoice by customeId to customer
        if (this.customersById.includes(this.openInvoices[i].customerId)) {
          invoice.push(this.openInvoices[i]);
        }
      }
      return invoice;
    },

    // creditor invoice where item type is gold/silver
    openInvoiceByCreditorSundry: function openInvoiceByCreditorSundry() {
      return this.openInvoiceByCreditor.filter(function (invoice) {
        if (invoice.items && invoice.items[0]) {
          return invoice.items[0].type === 'Gold' || invoice.items[0].type === 'Silver';
        }
        return false;
      });
    },

    // creditor invoice where item type is "without item"
    openInvoiceByCreditorUnsecured: function openInvoiceByCreditorUnsecured() {
      return this.openInvoiceByCreditor.filter(function (invoice) {
        if (invoice.items && invoice.items[0]) {
          return invoice.items[0].type === "Without item";
        }
        return false;
      });
    },


    // creditor invoice where item type is gold/silver
    openInvoiceByCustomerSundry: function openInvoiceByCustomerSundry() {
      return this.openInvoiceByCustomer.filter(function (invoice) {
        if (invoice.items && invoice.items[0]) {
          return invoice.items[0].type === 'Gold' || invoice.items[0].type === 'Silver';
        }
        return false;
      });
    },

    // creditor invoice where item type is "without item"
    openInvoiceByCustomerLoanNAdvances: function openInvoiceByCustomerLoanNAdvances() {
      return this.openInvoiceByCustomer.filter(function (invoice) {
        if (invoice.items && invoice.items[0]) {
          return invoice.items[0].type === "Without item";
        }
        return false;
      });
    },

    // Sundry Creditor total: Transaction with item taken by Creditor
    sundryCreditors: function sundryCreditors() {
      return this.openInvoiceByCreditorSundry.reduce(function (total, item) {
        return total + item.totalAmount;
      }, 0);
    },
    sundryCreditorsList: function sundryCreditorsList() {
      var creditor = {};
      var calculated = [];
      try {
        this.openInvoiceByCreditorSundry.forEach(function (invoice) {
          if (creditor[invoice.customerId]) {
            creditor[invoice.customerId].push(invoice);
          } else {
            creditor[invoice.customerId] = [invoice];
          }
        });
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(creditor).forEach(function (customer) {
          var list = creditor[customer] || [];
          calculated.push({
            type: 'creditor',
            invoices: creditor[customer],
            id: customer,
            amount: list.reduce(function (total, item) {
              return total + item.totalAmount;
            }, 0)
          });
        });
      } catch (e) {
        // console.info(e)
        return calculated;
      }
      return calculated;
    },

    // Creditors Unsecured Loans Total: landing money without item by Creditor
    unsecuredLoans: function unsecuredLoans() {
      return this.openInvoiceByCreditorUnsecured.reduce(function (total, item) {
        return total + item.totalAmount;
      }, 0);
    },
    unsecuredLoansList: function unsecuredLoansList() {
      var customers = {};
      var customerList = [];
      try {
        this.openInvoiceByCreditorUnsecured.forEach(function (invoice) {
          if (customers[invoice.customerId]) {
            customers[invoice.customerId].push(invoice);
          } else {
            customers[invoice.customerId] = [invoice];
          }
        });
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(customers).forEach(function (items) {
          var list = customers[items] || [];
          customerList.push({
            type: 'creditor',
            invoices: customers[items],
            id: items,
            amount: list.reduce(function (total, item) {
              return total + item.totalAmount;
            }, 0)
          });
        });
      } catch (e) {
        // console.info(e)
      }
      return customerList;
    },

    // Debtors Total: Transaction with item taken by Customer(debtors)
    sundryDebtors: function sundryDebtors() {
      return this.openInvoiceByCustomerSundry.reduce(function (total, item) {
        return total + item.totalAmount;
      }, 0);
    },
    sundryDebtorsList: function sundryDebtorsList() {
      var customers = {};
      var customerList = [];
      try {
        this.openInvoiceByCustomerSundry.forEach(function (invoice) {
          if (customers[invoice.customerId]) {
            customers[invoice.customerId].push(invoice);
          } else {
            customers[invoice.customerId] = [invoice];
          }
        });
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(customers).forEach(function (items) {
          var list = customers[items] || [];
          customerList.push({
            type: 'customer',
            invoices: customers[items],
            id: items,
            amount: list.reduce(function (total, item) {
              return total + item.totalAmount;
            }, 0)
          });
        });
      } catch (e) {
        // console.info(e)
      }
      return customerList;
    },

    // landing money without by Customer (debtors)
    loansAndAdvances: function loansAndAdvances() {
      return this.openInvoiceByCustomerLoanNAdvances.reduce(function (total, item) {
        return total + item.totalAmount;
      }, 0);
    },
    loansAndAdvancesList: function loansAndAdvancesList() {
      var customers = {};
      var customerList = [];
      try {
        this.openInvoiceByCustomerLoanNAdvances.forEach(function (invoice) {
          if (customers[invoice.customerId]) {
            customers[invoice.customerId].push(invoice);
          } else {
            customers[invoice.customerId] = [invoice];
          }
        });
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(customers).forEach(function (items) {
          var list = customers[items] || [];
          customerList.push({
            type: 'customer',
            invoices: customers[items],
            id: items,
            amount: list.reduce(function (total, item) {
              return total + item.totalAmount;
            }, 0)
          });
        });
      } catch (e) {
        // console.info(e)
      }
      return customerList;
    },

    // bank with list
    securedLoansBankList: function securedLoansBankList() {
      return this.accountByBrand.filter(function (bank) {
        return bank.accountType === 'Loan A/C' || bank.accountType === 'Overdraft A/C';
      });
    },

    // Total of amount of secured loans bank
    securedLoansBankListTotal: function securedLoansBankListTotal() {
      return this.securedLoansBankList.reduce(function (total, bank) {
        return total + bank.amount;
      }, 0);
    },

    // secured account bank list
    savingsCurrentBankList: function savingsCurrentBankList() {
      return this.accountByBrand.filter(function (bank) {
        return bank.accountType === 'Saving A/C' || bank.accountType === 'Current A/C';
      });
      // && (bank.openingDate ? ((bank.openingDate >= new Date(this.finYear.start).getTime()) && (bank.openingDate <= new Date(this.finYear.end).getTime())) : false ))
    },

    // total of amount of saving/current bank account
    savingsCurrentBankListTotal: function savingsCurrentBankListTotal() {
      // return this.savingsCurrentBankList.reduce((total, bank) => total + bank.amount, 0);
      var amount = 0;
      this.savingsCurrentBankList.map(function (bank) {
        // let openingDate = new Date(bank.openingDate).getTime();
        amount += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(bank.amount);
      });
      return amount;
    },

    // cash in hand: firms available cash
    cashInHand: function cashInHand() {
      if (this.selectedFirm) {
        // return firm.item.amount
        // let openingDate = new Date(this.selectedFirm.openingDate).getTime();
        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.selectedFirm.amount);
      }
      return this.firmsByBrand.reduce(function (balance, firm) {
        // let openingDate = new Date(this.selectedFirm.openingDate).getTime();
        var amount = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(firm.amount);
        return balance = balance + amount;
        // return balance = balance + firm.item.amount
      }, 0);
    },
    totalAssetAmount: function totalAssetAmount() {
      var _this14 = this;

      return this.getAssetAccount.reduce(function (total, item) {
        // return (item.details.totalAmount + item.details.openingBalance) - ((item.details.totalAmount + item.details.openingBalance) * ((item.details.depriciation) /100) || 0)  + total
        return item.details.totalAmount + item.details.openingBalance - ((item.details.totalAmount + item.details.openingBalance) * ((_this14.isDepriciation ? item.details.depriciation : 0) / 100) || 0) + total;
      }, 0);
    },
    totalInvestmentAmount: function totalInvestmentAmount() {
      return this.getInvestmentAccount.reduce(function (total, item) {
        return item.details.totalAmount + item.details.openingBalance + total;
      }, 0);
    },
    totalIntangibleAssetAmount: function totalIntangibleAssetAmount() {
      var _this15 = this;

      return this.getIntangibleAssetAccount.reduce(function (total, item) {
        // return (item.details.totalAmount + item.details.openingBalance) - ((item.details.totalAmount + item.details.openingBalance) * ((item.details.depriciation) /100) || 0)  + total
        return item.details.totalAmount + item.details.openingBalance - ((item.details.totalAmount + item.details.openingBalance) * ((_this15.isDepriciation ? item.details.depriciation : 0) / 100) || 0) + total;
      }, 0);
    },

    // totalIntangibleAssetAmount() {
    //   return this.getIntangibleAssetAccount.reduce((total, item) => {
    //     return item.details.totalAmount + item.details.openingBalance  + total
    //   }, 0)
    // },
    assetAsFixedByBrand: function assetAsFixedByBrand() {
      var _this16 = this;

      if (!this.assets) {
        return [];
      };
      // return asset with underhead 
      return this.assets.filter(function (item) {
        return item['brand'] === _this16.selectedBrand && item.type != 'investments' && item['brand'] === _this16.selectedBrand && item.type != 'intangibleAssets';
      });
    },
    assetAsInvestmentByBrand: function assetAsInvestmentByBrand() {
      var _this17 = this;

      if (!this.assets) {
        return [];
      };
      // return asset with underhead 
      return this.assets.filter(function (item) {
        return item['brand'] === _this17.selectedBrand && item.type === 'investments';
      });
    },
    assetAsIntangibleByBrand: function assetAsIntangibleByBrand() {
      var _this18 = this;

      if (!this.assets) {
        return [];
      };
      // return asset with underhead 
      return this.assets.filter(function (item) {
        return item['brand'] === _this18.selectedBrand && item.type === 'intangibleAssets';
      });
    },
    invoiceByBrand: function invoiceByBrand() {
      var _this19 = this;

      if (!this.invoices) {
        return [];
      };
      var filter = this.invoices.filter(function (item) {
        return item['brand'] === _this19.selectedBrand && item.deleted != true && item.date >= _this19.finYear.start && item.date <= _this19.finYear.end;
      });
      if (this.selectedFirm) {
        filter = filter.filter(function (item) {
          return item.firm === _this19.selectedFirm['.key'];
        });
      }
      if (this.filterInvoiceFrom) {
        var from = new Date(this.filterInvoiceFrom).setHours(0, 0, 0, 0);
        filter = filter.filter(function (item) {
          return item.date >= from;
        });
      }
      if (this.filterInvoiceTo) {
        var to = new Date(this.filterInvoiceTo).setHours(23, 29, 59, 999);
        filter = filter.filter(function (item) {
          return item.date <= to;
        });
      }
      return filter;
    },
    getAssetAccount: function getAssetAccount() {
      var _this20 = this;

      var mainGroup = []; // { details: {} && invoices: []}
      try {
        this.assetAsFixedByBrand.forEach(function (details) {
          var invoices = _this20.invoiceByBrand.filter(function (invoice) {
            if (_this20.selectedFirm) {
              // return invoice of selected firmId
              return invoice.assetType === details['.key'] && invoice.firm === _this20.selectedFirm['.key'];
            }
            // return all matched key invoices
            return invoice.assetType === details['.key'];
          });
          details.totalAmount = invoices.reduce(function (total, item) {
            return total + item.totalAmount;
          }, 0);
          details.openingBalance = invoices.reduce(function (total, item) {
            return total + item.openingBalance;
          }, 0);
          if (details.totalAmount) {
            mainGroup.push({
              details: details,
              invoices: invoices
            });
          } else if (details.openingBalance) {
            mainGroup.push({
              details: details,
              invoices: invoices
            });
          }
        });
        return mainGroup;
      } catch (e) {
        // console.info(e)
        return [];
      }
    },
    getInvestmentAccount: function getInvestmentAccount() {
      var _this21 = this;

      var mainGroup = []; // { details: {} && invoices: []}
      try {
        this.assetAsInvestmentByBrand.forEach(function (details) {
          var invoices = _this21.invoiceByBrand.filter(function (invoice) {
            if (_this21.selectedFirm) {
              // return invoice of selected firmId
              return invoice.assetType === details['.key'] && invoice.firm === _this21.selectedFirm['.key'];
            }
            // return all matched key invoices
            return invoice.assetType === details['.key'];
          });
          details.totalAmount = invoices.reduce(function (total, item) {
            return total + item.totalAmount;
          }, 0);
          details.openingBalance = invoices.reduce(function (total, item) {
            return total + item.openingBalance;
          }, 0);
          if (details.totalAmount) {
            mainGroup.push({
              details: details,
              invoices: invoices
            });
          } else if (details.openingBalance) {
            mainGroup.push({
              details: details,
              invoices: invoices
            });
          }
        });
        return mainGroup;
      } catch (e) {
        // console.info(e)
        return [];
      }
    },


    // Intangible assets 
    getIntangibleAssetAccount: function getIntangibleAssetAccount() {
      var _this22 = this;

      var mainGroup = []; // { details: {} && invoices: []}
      try {
        this.assetAsIntangibleByBrand.forEach(function (details) {
          var invoices = _this22.invoiceByBrand.filter(function (invoice) {
            if (_this22.selectedFirm) {
              // return invoice of selected firmId
              return invoice.assetType === details['.key'] && invoice.firm === _this22.selectedFirm['.key'];
            }
            // return all matched key invoices
            return invoice.assetType === details['.key'];
          });
          details.totalAmount = invoices.reduce(function (total, item) {
            return total + item.totalAmount;
          }, 0);
          details.openingBalance = invoices.reduce(function (total, item) {
            return total + item.openingBalance;
          }, 0);
          if (details.totalAmount) {
            mainGroup.push({
              details: details,
              invoices: invoices
            });
          } else if (details.openingBalance) {
            mainGroup.push({
              details: details,
              invoices: invoices
            });
          }
        });
        return mainGroup;
      } catch (e) {
        // console.info(e)
        return [];
      }
    },


    // group Expenses of Prop Capital
    groupExpensesOfPropCapital: function groupExpensesOfPropCapital() {
      var _this23 = this;

      this.propexpenseTotal = 0;
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var expenses = this.expenses.filter(function (expense) {
        return expense.brand === _this23.selectedBrand && expense.underHead === 'Prop Capital A/C' && expense.category === "Indirect";
      });
      expenses = expenses.filter(function (expense) {
        return !!expense['.key'];
      });
      expenses.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = 'confirm';
        var invoices = _this23.invoices.filter(function (invoice) {
          return invoice.brand === _this23.selectedBrand && invoice["expenseType"] === ex['.key'] && (_this23.selectedFirm ? invoice['firm'] === _this23.selectedFirm['.key'] : true) && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true) && invoice.date >= _this23.finYear.start && invoice.date <= _this23.finYear.end;
        });
        invoices.map(function (inv) {
          openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
          totalAmount += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          if (paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        expenses[index]['invoices'] = invoices;
        expenses[index].paymentTypeStatus = paymentTypeStatus;
        expenses[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        expenses[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        _this23.propexpenseTotal += (isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(openingBalance)) + (isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(totalAmount));
      });
      this.propexpenseTotal = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.propexpenseTotal).toFixed(2);
      return expenses;
    },


    // Group Incomes Of Prop Capital
    groupIncomesOfPropCapital: function groupIncomesOfPropCapital() {
      var _this24 = this;

      this.propincomeTotal = 0;
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var incomes = this.incomes.filter(function (income) {
        return income.brand === _this24.selectedBrand && income.underHead === 'Prop Capital A/C' && income.category === "Indirect";
      });
      incomes = incomes.filter(function (income) {
        return !!income['.key'];
      });
      incomes.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = 'confirm';
        var invoices = _this24.invoices.filter(function (invoice) {
          return invoice.brand === _this24.selectedBrand && invoice["incomeType"] === ex['.key'] && (_this24.selectedFirm ? invoice['firm'] === _this24.selectedFirm['.key'] : true) && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true) && invoice.date >= _this24.finYear.start && invoice.date <= _this24.finYear.end;
        });
        invoices.map(function (inv) {
          openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
          totalAmount += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          if (paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        incomes[index]['invoices'] = invoices;
        incomes[index].paymentTypeStatus = paymentTypeStatus;
        incomes[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        incomes[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        _this24.propincomeTotal += (isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(openingBalance)) + (isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(totalAmount));
      });
      this.propincomeTotal = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.propincomeTotal).toFixed(2);
      return incomes;
    },


    // Start Functionality of Dep Assets in Profit and Loss A/C
    plassetByBrand: function plassetByBrand() {
      var _this25 = this;

      if (this.assets) {
        this.pltotalAsset = 0;
        var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
        var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
        // let selectedAssets = this.assets.filter(asset => {
        //   return asset.brand === this.selectedBrand && (this.selectedFirmDetail ? this['firm']  === this.selectedFirmDetail['.key'] : true)  && asset['category'] != 'personal' && asset['depriciation']    
        // });
        var selectedAssets = this.assets.filter(function (asset) {
          return asset.brand === _this25.selectedBrand && asset['category'] != 'personal' && asset['depriciation'];
        });
        selectedAssets.map(function (ast, index) {
          var firmAsset = _this25.invoices.filter(function (item) {
            return item['assetType'] === ast['.key'] && item['brand'] === _this25.selectedBrand && item.date >= _this25.finYear.start && item.date <= _this25.finYear.end && (_this25.selectedFirmDetail ? item['firm'] === _this25.selectedFirmDetail['.key'] : true) && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true);
          });
          var openingBalance = 0;
          var totalAmount = 0;
          firmAsset.map(function (inv) {
            openingBalance += inv.openingBalance ? parseInt(inv.openingBalance) : 0;
            totalAmount += inv.totalAmount ? parseInt(inv.totalAmount) : 0;
          });
          selectedAssets[index]['openingBalance'] = openingBalance;
          selectedAssets[index]['totalAmount'] = totalAmount;
          selectedAssets[index]['depAmount'] = _this25.getDepAmount(ast, ast.type);
          if (ast.category === 'b&p') {
            selectedAssets[index]['depAmount'] = selectedAssets[index]['depAmount'] / 2;
          }
          _this25.pltotalAsset += selectedAssets[index]['depAmount'];
        });
        return selectedAssets;
      }
      return [];
    },

    // End functionality of Dep Assets in Profit and Loss A/C


    // Start Functionality of Dep Assets in Prop Capital A/C 
    propassetByBrand: function propassetByBrand() {
      var _this26 = this;

      if (this.assets) {
        this.proptotalAsset = 0;
        var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
        var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
        // let selectedAssets = this.assets.filter(asset => {
        //   return asset.brand === this.selectedBrand && (this.selectedFirmDetail ? this['firm']  === this.selectedFirmDetail['.key'] : true)  && asset['category'] != 'business' && asset['depriciation']    
        // });
        var selectedAssets = this.assets.filter(function (asset) {
          return asset.brand === _this26.selectedBrand && asset['category'] != 'business' && asset['depriciation'];
        });
        selectedAssets.map(function (ast, index) {
          var firmAsset = _this26.invoices.filter(function (item) {
            return item['assetType'] === ast['.key'] && item['brand'] === _this26.selectedBrand && item.date >= _this26.finYear.start && item.date <= _this26.finYear.end && (_this26.selectedFirmDetail ? item['firm'] === _this26.selectedFirmDetail['.key'] : true) && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true);
          });
          var openingBalance = 0;
          var totalAmount = 0;
          firmAsset.map(function (inv) {
            openingBalance += inv.openingBalance ? parseInt(inv.openingBalance) : 0;
            totalAmount += inv.totalAmount ? parseInt(inv.totalAmount) : 0;
          });
          selectedAssets[index]['openingBalance'] = openingBalance;
          selectedAssets[index]['totalAmount'] = totalAmount;
          selectedAssets[index]['depAmount'] = _this26.getDepAmount(ast, ast.type);
          if (ast.category === 'b&p') {
            selectedAssets[index]['depAmount'] = selectedAssets[index]['depAmount'] / 2;
          }
          _this26.proptotalAsset += selectedAssets[index]['depAmount'];
        });
        return selectedAssets;
      }
      return [];
    },

    // End functionality of Dep Assets in Profit and Loss A/C

    // Group Expenses of Trading Account
    groupExpensesOfTradingAccount: function groupExpensesOfTradingAccount() {
      var _this27 = this;

      this.tradingexpenseTotal = 0;
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var expenses = this.expenses.filter(function (expense) {
        return expense.brand === _this27.selectedBrand && expense.category === "Direct";
      });
      expenses = expenses.filter(function (expense) {
        return !!expense['.key'];
      });
      expenses.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = 'confirm';
        var invoices = _this27.invoices.filter(function (invoice) {
          return invoice.brand === _this27.selectedBrand && invoice["expenseType"] === ex['.key'] && (_this27.selectedFirm ? invoice['firm'] === _this27.selectedFirm['.key'] : true) && invoice.date >= _this27.finYear.start && invoice.date <= _this27.finYear.end && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true);
        });
        invoices.map(function (inv) {
          openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
          totalAmount += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          if (paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        expenses[index]['invoices'] = invoices;
        expenses[index].paymentTypeStatus = paymentTypeStatus;
        expenses[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        expenses[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        _this27.tradingexpenseTotal += (isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(openingBalance)) + (isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(totalAmount));
      });
      this.tradingexpenseTotal = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.tradingexpenseTotal).toFixed(2);
      return expenses;
    },


    // Group Income of Trading account
    groupIncomesOfTradingAccount: function groupIncomesOfTradingAccount() {
      var _this28 = this;

      this.tradingincomeTotal = 0;
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var incomes = this.incomes.filter(function (income) {
        return income.brand === _this28.selectedBrand && income.category === "Direct";
      });
      incomes = incomes.filter(function (income) {
        return !!income['.key'];
      });
      incomes.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = 'confirm';
        var invoices = _this28.invoices.filter(function (invoice) {
          return invoice.brand === _this28.selectedBrand && invoice["incomeType"] === ex['.key'] && (_this28.selectedFirm ? invoice['firm'] === _this28.selectedFirm['.key'] : true) && invoice.date >= _this28.finYear.start && invoice.date <= _this28.finYear.end && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true);
        });
        invoices.map(function (inv) {
          openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
          totalAmount += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          if (paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        incomes[index]['invoices'] = invoices;
        incomes[index].paymentTypeStatus = paymentTypeStatus;
        incomes[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        incomes[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        _this28.tradingincomeTotal += (isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(openingBalance)) + (isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(totalAmount));
      });
      this.tradingincomeTotal = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.tradingincomeTotal).toFixed(2);
      return incomes;
    },


    // Group Incomes of Profit and Loss
    groupIncomesOfPl: function groupIncomesOfPl() {
      var _this29 = this;

      this.pandlincomeTotal = 0;
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var incomes = this.incomes.filter(function (income) {
        return income.brand === _this29.selectedBrand && income.underHead === 'Profit and Loss' && income.category === "Indirect";
      });
      incomes = incomes.filter(function (income) {
        return !!income['.key'];
      });
      incomes.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = 'confirm';
        var invoices = _this29.invoices.filter(function (invoice) {
          return invoice.brand === _this29.selectedBrand && invoice["incomeType"] === ex['.key'] && (_this29.selectedFirm ? invoice['firm'] === _this29.selectedFirm['.key'] : true) && invoice.date >= _this29.finYear.start && invoice.date <= _this29.finYear.end && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true);
        });
        invoices.map(function (inv) {
          openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
          totalAmount += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          if (paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        incomes[index]['invoices'] = invoices;
        incomes[index].paymentTypeStatus = paymentTypeStatus;
        incomes[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        incomes[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        _this29.pandlincomeTotal += (isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(openingBalance)) + (isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(totalAmount));
      });
      this.pandlincomeTotal = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.pandlincomeTotal).toFixed(2);
      return incomes;
    },


    // Group Expense of Profit and Loss
    groupExpensesOfPandL: function groupExpensesOfPandL() {
      var _this30 = this;

      this.pandlexpenseTotal = 0;
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var expenses = this.expenses.filter(function (expense) {
        return expense.brand === _this30.selectedBrand && expense.underHead === 'Profit and Loss' && expense.category === "Indirect";
      });
      expenses = expenses.filter(function (expense) {
        return !!expense['.key'];
      });
      expenses.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = 'confirm';
        var invoices = _this30.invoices.filter(function (invoice) {
          return invoice.brand === _this30.selectedBrand && invoice["expenseType"] === ex['.key'] && (_this30.selectedFirm ? invoice['firm'] === _this30.selectedFirm['.key'] : true) && invoice.date >= _this30.finYear.start && invoice.date <= _this30.finYear.end && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true);
        });
        invoices.map(function (inv) {
          openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
          totalAmount += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          if (paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        expenses[index]['invoices'] = invoices;
        expenses[index].paymentTypeStatus = paymentTypeStatus;
        expenses[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        expenses[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        _this30.pandlexpenseTotal += (isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(openingBalance)) + (isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(totalAmount));
      });
      this.pandlexpenseTotal = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.pandlexpenseTotal).toFixed(2);
      return expenses;
    },


    // staff account in profit and loss  
    getStaffAccount: function getStaffAccount() {
      var _this31 = this;

      this.totalSalary = 0;
      if (this.selectedBrand) {
        var staffList = this.staff.filter(function (item) {
          return item['brand'] === _this31.selectedBrand && (_this31.selectedFirm ? item['firm'] === _this31.selectedFirm['.key'] : true);
        });
        var result = staffList.map(function (e) {
          var salaryList = _.filter(_this31.salarys, { 'staffId': e['.key'] });
          e.salaryList = salaryList;
          var creditTotal = _.sumBy(salaryList, function (s) {
            if (s.isCredited) return s.amount;
          });

          e.creditTotal = creditTotal ? creditTotal : 0;

          var debitTotal = _.sumBy(salaryList, function (s) {
            if (!s.isCredited) return s.amount;
          });

          e.debitTotal = debitTotal ? debitTotal : 0;

          _this31.totalSalary = _this31.totalSalary + (parseInt(e.creditTotal) - parseInt(e.debitTotal));
          return e;
        });
        // console.log(result,null,4)
        return result;
      }
    },


    // Sale record from Trading account
    sales: function sales() {
      var _this32 = this;

      var totalSale = 0;
      var buyers = this.buyers.filter(function (item) {
        return item["brand"] === _this32.selectedBrand;
      });
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      buyers.map(function (buyer) {
        var sales = _this32.invoices.filter(function (item) {
          return item['brand'] === _this32.selectedBrand && item.date >= _this32.finYear.start && item.date <= _this32.finYear.end && item['buyerId'] == buyer['.key'] && (_this32.selectedFirm ? item['firm'] === _this32.selectedFirm['.key'] : true) && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true);
        });
        sales.map(function (inv) {
          totalSale += inv.totalAmount ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount) : 0;
        });
      });
      totalSale = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(totalSale).toFixed(2);
      return totalSale;
    },


    // Purchase record from Trading account
    purchase: function purchase() {
      var _this33 = this;

      var totalPurchase = 0;
      var sellers = this.sellers.filter(function (item) {
        return item["brand"] === _this33.selectedBrand;
      });
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      sellers.map(function (buyer) {
        var purchase = _this33.invoices.filter(function (item) {
          return item['brand'] === _this33.selectedBrand && item.date >= _this33.finYear.start && item.date <= _this33.finYear.end && item['buyerId'] == buyer['.key'] && item.deleted != true && (_this33.selectedFirm ? item['firm'] === _this33.selectedFirm['.key'] : true) && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true);
        });
        purchase.map(function (inv) {
          totalPurchase += inv.totalAmount ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount) : 0;
        });
      });
      totalPurchase = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(totalPurchase).toFixed(2);
      return totalPurchase;
    },


    // Closing Stock fethced from "Prop Capital Account"
    closingBalance: function closingBalance() {
      var propclosing = (this.selectedFirmDetail ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.selectedFirmDetail.openingBalance) || 0 : 0) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.propincomeTotal) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.netProfit) - (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.proptotalAsset) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.propexpenseTotal));
      propclosing = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(propclosing).toFixed(2);
      return propclosing;
    },


    // Closing Stock fethced from "Trading Account "
    // closingStock(){
    //   let closingstock =  (((this.selectedFirmDetail ? (Number.parseFloat(this.selectedFirmDetail.openingStock) || 0) : 0) + 
    //   Number.parseFloat(this.purchase || 0 | amount)) - (
    //   Number.parseFloat(this.sales || 0 | amount)));
    //   closingstock = Number.parseFloat(closingstock).toFixed(2)
    //   return closingstock;
    // },


    // Gross profit fethced from "Trading Account "
    // grossProfit(){
    //   let profit = (( Number.parseFloat(this.sales) + Number.parseFloat(this.tradingincomeTotal) + Number.parseFloat((this.isJwelleryBussiness
    //             ? this.closingStockWeight
    //             : this.closingStock)))
    //   - ((this.selectedFirmDetail ? (Number.parseFloat(this.selectedFirmDetail.openingStock) || 0) : 0) + 
    //     Number.parseFloat(this.purchase) +  Number.parseFloat(this.tradingexpenseTotal))
    //   ); 
    //   profit = Number.parseFloat(profit).toFixed(2);
    //   return profit;
    // },
    grossProfit: function grossProfit() {
      var profit = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.sales) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.incomeTotal) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.isJwelleryBussiness ? this.closingStock : this.closingStockWeight) - ((this.selectedFirm ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.selectedFirm.openingStock) || 0 : 0) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.isJwelleryBussiness ? this.totalOpeningStockWeight : this.totalOpeningStock) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.purchase) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.expenseTotal));
      profit = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(profit).toFixed(2);
      return profit;
    },


    // net profit fethced from " Profit and Loss A/C "
    netProfit: function netProfit() {
      var netprofit = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.pandlincomeTotal) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.grossProfit) - (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.pandlexpenseTotal) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.totalSalary) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.pltotalAsset));
      netprofit = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(netprofit).toFixed(2);
      return netprofit;
    },
    expenseWithProvision: function expenseWithProvision() {
      var _this34 = this;

      this.expenseProvisionTotal = 0;
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var expenses = this.expenses.filter(function (expense) {
        return expense.brand === _this34.selectedBrand && expense.paymentTypeStatus === 'yet to confirm';
      });
      expenses = expenses.filter(function (expense) {
        return !!expense['.key'];
      });
      expenses.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = 'confirm';
        // let invoices = this.invoices.filter(invoice => invoice.brand === this.selectedBrand &&  invoice["expenseType"] === ex['.key'])
        var invoices = _this34.invoices.filter(function (invoice) {
          return invoice.brand === _this34.selectedBrand && invoice["expenseType"] === ex['.key'] && (_this34.selectedFirm ? invoice['firm'] === _this34.selectedFirm['.key'] : true) && invoice.date >= _this34.finYear.start && invoice.date <= _this34.finYear.end && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true);
        });
        // console.log(invoices)
        invoices.map(function (inv) {
          if (inv.paymentTypeStatus == 'yet to confirm') {
            openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
            totalAmount += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          }
          if (paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        expenses[index].paymentTypeStatus = paymentTypeStatus;
        expenses[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        expenses[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        if (expenses[index].paymentTypeStatus == 'yet to confirm') {
          // console.log(totalAmount)
          //this.expenseProvisionTotal = isNaN(totalAmount) ? this.expenseProvisionTotal : Number.parseFloat(this.expenseProvisionTotal) + Number.parseFloat(totalAmount);
          _this34.expenseProvisionTotal += (isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(openingBalance)) + (isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(totalAmount));
        }
      });
      this.expenseProvisionTotal = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.expenseProvisionTotal);
      return expenses;
    }
  }),
  data: function data() {
    var _ref;

    return _ref = {
      isDepriciation: true,
      expenseTotal: 0,
      pandlexpenseTotal: 0,
      propexpenseTotal: 0,
      incomeTotal: 0,
      tradingexpenseTotal: 0,
      tradingincomeTotal: 0,
      pandlincomeTotal: 0,
      propincomeTotal: 0,
      proptotalAsset: 0,
      pltotalAsset: 0,
      selectedFirm: null,
      filterInvoiceFrom: null,
      filterInvoiceTo: null,
      fromdatepicker: false,
      todatepicker: false,
      searchInput: null,
      totalSundryCreditors: 0,
      totalSundryDebitors: 0,
      totalLoan: 0,
      totalSalary: 0,
      totalLoanAndAdvances: 0,
      expenseProvisionTotal: 0,
      buyerList: [],
      sellerList: [],
      incomesWPro: []
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'searchInput', null), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'selectedStaff', {}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'salaryListHeaders', [{ text: 'Date', value: 'date', sortable: true }, { text: 'Credit/Debit', value: 'amount', sortable: false }]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'sale', {
      total: 0,
      list: [],
      expand: false
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'closingStock', 0), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'isJwelleryBussiness', false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, 'closingStockWeight', 0), _ref;
  },
  methods: {
    getClosingAmount: function getClosingAmount(item) {
      var closingQty = parseInt(item['openingQuantity'] ? item['openingQuantity'] : 0) + parseInt(item['durationQtyPurchase'] ? item['durationQtyPurchase'] : 0) - parseInt(item['durationQtySale'] ? item['durationQtySale'] : 0);
      switch (this.firmStockReportType) {

        case 'APP':
          {
            var amount = 0;
            if (item.stockReportData) {
              var avgPurchasePrice = item.stockReportData.purchaseDetails.reduce(function (a, b) {
                return a + (b['rate'] || 0);
              }, 0) / item.stockReportData.purchaseDetails.length;
              amount = avgPurchasePrice * closingQty;
            }
            return amount;
          }
        case 'LPP':
          {
            var _amount = 0;
            if (item.stockReportData) {
              _amount = item.stockReportData.lastPurchasePrice * closingQty;
            }
            return _amount;
          }
        case 'LSP':
          {
            var _amount2 = 0;
            if (item.stockReportData) {
              _amount2 = item.stockReportData.lastSalePrice * closingQty;
            }
            return _amount2;
          }
        case 'ASP':
          {
            var _amount3 = 0;
            if (item.stockReportData) {
              var avgSalePrice = item.stockReportData.saleDetails.reduce(function (a, b) {
                return a + (b['rate'] || 0);
              }, 0) / item.stockReportData.saleDetails.length;
              _amount3 = avgSalePrice * closingQty;
            }
            return _amount3;
          }
        case 'FIFO':
          {
            var _amount4 = 0;
            if (item.stockReportData) {
              var allTransaction = item.stockReportData.purchaseDetails.sort(function (a, b) {
                return -(new Date(b.date) - new Date(a.date));
              });

              var qntTemp = closingQty;
              allTransaction.map(function (t) {
                if (qntTemp > t.quantity) {
                  _amount4 += t.quantity * t.rate;
                  qntTemp = qntTemp - t.quantity;
                } else if (qntTemp > 0) {
                  _amount4 += t.quantity - qntTemp * t.rate;
                  qntTemp = 0;
                }
              });
            }
            return _amount4;
          }
        case 'LIFO':
          {
            var _amount5 = 0;
            if (item.stockReportData) {
              var _allTransaction = item.stockReportData.purchaseDetails.sort(function (a, b) {
                return new Date(b.date) - new Date(a.date);
              });
              var _qntTemp = closingQty;
              _allTransaction.map(function (t) {
                if (_qntTemp > t.quantity) {
                  _amount5 += t.quantity * t.rate;
                  _qntTemp = _qntTemp - t.quantity;
                } else if (_qntTemp > 0) {
                  _amount5 += t.quantity - _qntTemp * t.rate;
                  _qntTemp = 0;
                }
              });
            }
            return _amount5;
          }
      }
    },
    print: function print() {
      var data = [];
      $(".print-field").each(function (index) {
        data.push($(this).text());
      });
      var doc = Object(__WEBPACK_IMPORTED_MODULE_9__utils_pdf_reports_information_reports__["b" /* convertToPDFBalanceSheet */])({ data: data });
      pdfMake.createPdf(doc).download();
    },
    getName: function getName(key, property, name) {
      var dd = this[property].find(function (item) {
        return item['.key'] === key;
      });
      if (dd) {
        return dd[name] || key;
      }
      return key;
    },

    // getFirmName(e){
    //   let firm;
    //     if (this.firms && this.selectedBrand) {
    //       firm =this.firms.filter(item => item['.key'] === e)[0]
    //     }
    //     if(firm)
    //     return firm.name
    // },
    getDepAmount: function getDepAmount(asset, type) {
      var depriciation = null;
      if (asset.isVerified && asset.depriciation) {
        var totalAmount = this.getTotalAmount(asset);
        depriciation = Number(totalAmount * asset.depriciation / 100);
        return depriciation;
      }
      return 0;
    },
    getTotalAmount: function getTotalAmount(asset) {
      if (asset.isVerified) {
        return Number(asset.openingBalance || 0) + Number(asset.totalAdditionAmount) - Number(asset.totalDeletionAmount);
      }
      return Number(asset.totalAdditionAmount) - Number(asset.totalDeletionAmount);
    },
    getData: function getData() {
      // this.sellersByBrand();
      // this.BuyersByBrand();
      this.usersByBrand();
      // this.expenseWithProvision();
      this.incomeWithProvision();
      this.liabilityWithProvision();
    },


    // Income with Provision 
    incomeWithProvision: function incomeWithProvision() {
      var _this35 = this;

      this.incomeProvisionTotal = 0;
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var incomes = this.incomes.filter(function (income) {
        return income.brand === _this35.selectedBrand && income.paymentTypeStatus === 'yet to confirm';
      });
      incomes = incomes.filter(function (income) {
        return !!income['.key'];
      });
      incomes.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = 'confirm';
        // let invoices = this.invoices.filter(invoice => invoice.brand === this.selectedBrand &&  invoice["incomeType"] === ex['.key'])
        var invoices = _this35.invoices.filter(function (invoice) {
          return invoice.brand === _this35.selectedBrand && invoice["incomeType"] === ex['.key'] && (_this35.selectedFirm ? invoice['firm'] === _this35.selectedFirm['.key'] : true) && invoice.date >= _this35.finYear.start && invoice.date <= _this35.finYear.end && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true);
        });
        // console.log(invoices)
        invoices.map(function (inv) {
          if (inv.paymentTypeStatus == 'yet to confirm') {
            openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
            totalAmount += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          }
          if (paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        incomes[index].paymentTypeStatus = paymentTypeStatus;
        incomes[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        incomes[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        if (incomes[index].paymentTypeStatus == 'yet to confirm') {
          // console.log(totalAmount)
          //this.incomeProvisionTotal = isNaN(totalAmount) ? this.incomeProvisionTotal : Number.parseFloat(this.incomeProvisionTotal) + Number.parseFloat(totalAmount);
          _this35.incomeProvisionTotal += (isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(openingBalance)) + (isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(totalAmount));
        }
      });
      this.incomeProvisionTotal = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.incomeProvisionTotal);
      this.incomesWPro = incomes;
    },


    // Liability With Provision
    liabilityWithProvision: function liabilityWithProvision() {
      var _this36 = this;

      this.liabilityTotalWPro = 0;
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var liabilities = this.liabilities.filter(function (liability) {
        return liability.brand === _this36.selectedBrand;
      });
      liabilities = liabilities.filter(function (liability) {
        return !!liability['.key'];
      });
      liabilities.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = 'confirm';
        // let invoices = this.invoices.filter(invoice => invoice.brand === this.selectedBrand && invoice["liabilityType"] === ex['.key']
        // )
        var invoices = _this36.invoices.filter(function (invoice) {
          return invoice.brand === _this36.selectedBrand && invoice["liabilityType"] === ex['.key'] && (_this36.selectedFirm ? invoice['firm'] === _this36.selectedFirm['.key'] : true) && invoice.date >= _this36.finYear.start && invoice.date <= _this36.finYear.end && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true);
        });
        // console.log(invoices)
        invoices.map(function (inv) {
          openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
          totalAmount += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          if (paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        liabilities[index].paymentTypeStatus = paymentTypeStatus;
        liabilities[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        liabilities[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        if (liabilities[index].paymentTypeStatus == 'yet to confirm') {
          // console.log(totalAmount)
          //this.liabilityTotalWPro = isNaN(totalAmount) ? this.liabilityTotalWPro : Number.parseFloat(this.liabilityTotalWPro) + Number.parseFloat(totalAmount);
          _this36.liabilityTotalWPro += (isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(openingBalance)) + (isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(totalAmount));
        }
      });
      this.liabilityTotalWPro = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(this.liabilityTotalWPro);
      this.liabilitiesWPro = liabilities;
    },

    // BuyersByBrand() {
    //   if(this.buyers) {
    //     this.totalSundryDebitors = 0;
    //     this.totalLoanAndAdvances = 0;
    //     this.buyerList = this.buyers.filter(customer => customer['brand'] === this.selectedBrand);
    //     this.buyerList.map((seller,index)=>{
    //         this.buyerList[index]['totalDiscount'] = 0;
    //         this.buyerList[index]['totalDueAmount'] = 0;
    //         this.buyerList[index]['totalAdvance'] = 0;
    //         this.buyerList[index]['totalSecurity'] = 0;
    //         this.buyerList[index]['totalOpeningBal'] = 0;
    //         this.buyerList[index]['totalLoan'] = 0;
    //         this.buyerList[index]['totalRemainingAmount'] = 0;
    usersByBrand: function usersByBrand() {
      var _this37 = this;

      if (this.sellers) {
        this.totalLoan = 0;
        this.totalLoanAndAdvances = 0;
        this.totalSundryCreditors = 0;
        this.sellerList = this.sellers.filter(function (customer) {
          return customer['brand'] === _this37.selectedBrand;
        });
        this.sellerList.map(function (seller, index) {
          _this37.sellerList[index]['totalDiscount'] = 0;
          _this37.sellerList[index]['totalDueAmount'] = 0;
          _this37.sellerList[index]['totalAdvance'] = 0;
          _this37.sellerList[index]['totalSecurity'] = 0;
          _this37.sellerList[index]['totalOpeningBal'] = 0;
          _this37.sellerList[index]['totalLoanGiven'] = 0;
          _this37.sellerList[index]['totalLoanTaken'] = 0;
          var invoices = _this37.invoices.filter(function (item) {
            return item["brand"] === _this37.selectedBrand && item["buyerId"] === seller['.key'] && item.deleted != true
            // && (item.date >= this.finYear.start) 
            // && (item.date <= this.finYear.end) 
            && (item["status"] === "due" || item["status"] === "partial") && (_this37.selectedFirm ? item["firm"] === _this37.selectedFirm['.key'] : true);
          });
          invoices.map(function (inv) {
            //console.log(this.buyerList[index]['totalDueAmount'])
            //this.buyerList[index]['totalDueAmount'] += inv.remainingAmount ? Number.parseFloat(inv.remainingAmount) : 0;
            // this.buyerList[index]['totalDiscount'] += inv.discountAmount ? Number.parseFloat(inv.discountAmount) : 0;
            _this37.sellerList[index]['totalDueAmount'] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.remainingAmount);
            _this37.sellerList[index]['totalDiscount'] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.discountAmount);
          });

          var advanceInv = _this37.customerDeposit.filter(function (item) {
            return item["brand"] === _this37.selectedBrand && item["buyerId"] === seller['.key'] && item["type"] === "Advance" && item.date >= _this37.finYear.start && item.date <= _this37.finYear.end && !!item["isUserCreated"] && parseInt(item["remainingAmount"]) > 0 && (_this37.selectedFirm ? item["firm"] === _this37.selectedFirm['.key'] : true);
          });
          advanceInv.map(function (inv) {
            _this37.sellerList[index]['totalAdvance'] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.remainingAmount);
          });

          var securityInv = _this37.customerDeposit.filter(function (item) {
            return item["brand"] === _this37.selectedBrand && item["buyerId"] === seller['.key'] && item["type"] === "Security" && item.date >= _this37.finYear.start && item.date <= _this37.finYear.end && !!item["isUserCreated"] && parseInt(item["remainingAmount"]) > 0 && (_this37.selectedFirm ? item["firm"] === _this37.selectedFirm['.key'] : true);
          });
          securityInv.map(function (inv) {
            _this37.sellerList[index]['totalSecurity'] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.remainingAmount);
          });

          var openingInv = _this37.customerDeposit.filter(function (item) {
            return item["brand"] === _this37.selectedBrand && item["buyerId"] === seller['.key'] && item["type"] === "Opening Balance" && item.date >= _this37.finYear.start && item.date <= _this37.finYear.end && !!item["isUserCreated"] && parseInt(item["remainingAmount"]) > 0 && (_this37.selectedFirm ? item["firm"] === _this37.selectedFirm['.key'] : true);
          });
          openingInv.map(function (inv) {
            _this37.sellerList[index]['totalOpeningBal'] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.remainingAmount);
          });

          var loanInv = _this37.customerDeposit.filter(function (item) {
            return item["brand"] === _this37.selectedBrand && item["buyerId"] === seller['.key'] && item.date >= _this37.finYear.start && item.date <= _this37.finYear.end && item["type"] === "LoanGiven" && item["status"] != "paid" && (_this37.selectedFirm ? item["firm"] === _this37.selectedFirm['.key'] : true);
          });
          loanInv.map(function (inv) {
            // this.sellerList[index]['totalLoanGiven'] = inv.amount;
            _this37.sellerList[index]['totalLoanGiven'] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.amount);
          });
          var loanInvTkn = _this37.customerDeposit.filter(function (item) {
            return item["brand"] === _this37.selectedBrand && item["buyerId"] === seller['.key'] && item["type"] === "LoanTaken" && item.date >= _this37.finYear.start && item.date <= _this37.finYear.end && item["status"] != "paid" && (_this37.selectedFirm ? item["firm"] === _this37.selectedFirm['.key'] : true);
          });
          loanInvTkn.map(function (inv) {
            //this.sellerList[index]['totalLoanTaken'] = inv.amount;
            _this37.sellerList[index]['totalLoanTaken'] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.amount);
          });
          _this37.totalLoan += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_this37.sellerList[index]['totalLoanTaken']);
          _this37.totalLoanAndAdvances += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_this37.sellerList[index]['totalLoanGiven']);
          _this37.sellerList[index]['totalRemainingAmount'] = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_this37.sellerList[index]['totalOpeningBal']) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_this37.sellerList[index]['totalDueAmount']) - (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_this37.sellerList[index]['totalAdvance']) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_this37.sellerList[index]['totalSecurity']) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_this37.sellerList[index]['totalDiscount']));
          _this37.totalSundryCreditors += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_this37.sellerList[index]['totalRemainingAmount']);
        });
      }
      // },
      // sellersByBrand() {
      //   if(this.sellers) {
      //     this.totalLoan = 0;
      //     this.totalSundryCreditors = 0;
      //     this.sellerList = this.sellers.filter(customer => customer['brand'] === this.selectedBrand);
      //     this.sellerList.map((seller,index)=>{
      //         this.sellerList[index]['totalDiscount'] = 0;
      //         this.sellerList[index]['totalDueAmount'] = 0;
      //         this.sellerList[index]['totalAdvance'] = 0;
      //         this.sellerList[index]['totalSecurity'] = 0;
      //         this.sellerList[index]['totalOpeningBal'] = 0;
      //         this.sellerList[index]['totalLoan'] = 0;
      if (this.buyers) {
        this.totalSundryDebitors = 0;
        // this.totalLoan = 0;
        // this.totalLoanAndAdvances = 0;
        this.buyerList = this.buyers.filter(function (customer) {
          return customer['brand'] === _this37.selectedBrand;
        });
        this.buyerList.map(function (seller, index) {
          _this37.buyerList[index]['totalDiscount'] = 0;
          _this37.buyerList[index]['totalDueAmount'] = 0;
          _this37.buyerList[index]['totalAdvance'] = 0;
          _this37.buyerList[index]['totalSecurity'] = 0;
          _this37.buyerList[index]['totalOpeningBal'] = 0;
          _this37.buyerList[index]['totalLoanTaken'] = 0;
          _this37.buyerList[index]['totalLoanGiven'] = 0;
          _this37.buyerList[index]['totalRemainingAmount'] = 0;
          var invoices = _this37.invoices.filter(function (item) {
            return item["brand"] === _this37.selectedBrand && item["buyerId"] === seller['.key']
            // && (item.date >= this.finYear.start) 
            // && (item.date <= this.finYear.end) 
            && item.deleted != true && (item["status"] === "due" || item["status"] === "partial") && (_this37.selectedFirm ? item["firm"] === _this37.selectedFirm['.key'] : true);
          });

          invoices.map(function (inv) {
            // this.buyerList[index]['totalDueAmount'] += Number.parseFloat(inv.remainingAmount);
            // this.buyerList[index]['totalDiscount'] += Number.parseFloat(inv.discountAmount);
            // console.log(this.buyerList[index]['totalDueAmount'])
            _this37.buyerList[index]['totalDueAmount'] += inv.remainingAmount ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.remainingAmount) : 0;
            _this37.buyerList[index]['totalDiscount'] += inv.discountAmount ? __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.discountAmount) : 0;
          });

          var advanceInv = _this37.customerDeposit.filter(function (item) {
            return item["brand"] === _this37.selectedBrand && item["buyerId"] === seller['.key'] && item["type"] === "Advance" && item.date >= _this37.finYear.start && item.date <= _this37.finYear.end && !!item["isUserCreated"] && parseInt(item["remainingAmount"]) > 0 && (_this37.selectedFirm ? item["firm"] === _this37.selectedFirm['.key'] : true);
          });
          advanceInv.map(function (inv) {
            _this37.buyerList[index]['totalAdvance'] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.remainingAmount);
          });

          var securityInv = _this37.customerDeposit.filter(function (item) {
            return item["brand"] === _this37.selectedBrand && item["buyerId"] === seller['.key'] && item["type"] === "Security" && item.date >= _this37.finYear.start && item.date <= _this37.finYear.end && !!item["isUserCreated"] && parseInt(item["remainingAmount"]) > 0 && (_this37.selectedFirm ? item["firm"] === _this37.selectedFirm['.key'] : true);
          });
          securityInv.map(function (inv) {
            _this37.buyerList[index]['totalSecurity'] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.remainingAmount);
          });

          var openingInv = _this37.customerDeposit.filter(function (item) {
            return item["brand"] === _this37.selectedBrand && item["buyerId"] === seller['.key'] && item["type"] === "Opening Balance" && item.date >= _this37.finYear.start && item.date <= _this37.finYear.end && !!item["isUserCreated"] && parseInt(item["remainingAmount"]) > 0 && (_this37.selectedFirm ? item["firm"] === _this37.selectedFirm['.key'] : true);
          });
          openingInv.map(function (inv) {
            _this37.buyerList[index]['totalOpeningBal'] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.remainingAmount);
          });

          var loanInv = _this37.customerDeposit.filter(function (item) {
            return item["brand"] === _this37.selectedBrand && item["buyerId"] === seller['.key'] && item["type"] === "LoanTaken" && item.date >= _this37.finYear.start && item.date <= _this37.finYear.end && item["status"] != "paid" && (_this37.selectedFirm ? item["firm"] === _this37.selectedFirm['.key'] : true);
          });
          loanInv.map(function (inv) {
            // this.buyerList[index]['totalLoanTaken'] = inv.amount;
            _this37.buyerList[index]['totalLoanTaken'] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.amount);
          });

          var loanInvGV = _this37.customerDeposit.filter(function (item) {
            return item["brand"] === _this37.selectedBrand && item["buyerId"] === seller['.key'] && item["type"] === "LoanGiven" && item.date >= _this37.finYear.start && item.date <= _this37.finYear.end && item["status"] != "paid" && (_this37.selectedFirm ? item["firm"] === _this37.selectedFirm['.key'] : true);
          });
          loanInvGV.map(function (inv) {
            // this.buyerList[index]['totalLoanGiven'] = inv.amount;
            _this37.buyerList[index]['totalLoanGiven'] += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(inv.amount);
          });

          _this37.totalLoan += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_this37.buyerList[index]['totalLoanTaken']);
          _this37.totalLoanAndAdvances += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_this37.buyerList[index]['totalLoanGiven']);
          _this37.buyerList[index]['totalRemainingAmount'] = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_this37.buyerList[index]['totalOpeningBal']) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_this37.buyerList[index]['totalDueAmount']) - (__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_this37.buyerList[index]['totalAdvance']) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_this37.buyerList[index]['totalSecurity']) + __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_this37.buyerList[index]['totalDiscount']));
          _this37.totalSundryDebitors += __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_number_parse_float___default()(_this37.buyerList[index]['totalRemainingAmount']);
        });
      }
    }
  }
});

/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'ExpandCard',
    props: {
        onlyTitle: {
            type: Boolean,
            default: false
        },
        value: {
            type: [String, Number],
            default: function _default() {
                return 0;
            }
        },
        hasItems: {
            type: Boolean,
            default: false
        },
        containerClass: {
            type: String,
            default: function _default() {
                return '';
            }
        }
    },
    methods: {
        handleClick: function handleClick(e) {
            e.stopPropagation();
            // e.preventDefault();
            console.info('lol');
        }
    }
});

/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Balancesheet_expandCard__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_pdf_reports_information_reports__ = __webpack_require__(46);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ExpandCard: __WEBPACK_IMPORTED_MODULE_8__Balancesheet_expandCard__["a" /* default */]
  },
  data: function data() {
    return {
      tradingAccount: [{
        expense: true
      }, {
        expense: false
      }],
      isJwelleryBussiness: false,
      expenseTotal: 0,
      closingStockWeight: 0,
      totalOpeningStockWeight: 0,
      incomeTotal: 0,
      selectedFirm: null,
      filterInvoiceFrom: null,
      filterInvoiceTo: null,
      fromdatepicker: false,
      todatepicker: false,
      editClosingStock: false,
      currentClosingDetails: null,
      brandClosingStockAmount: 0,
      sale: {
        total: 0,
        list: [],
        expand: false
      },
      totalOpeningStock: 0,
      closingStock: 0
    };
  },
  created: function created() {
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("expenses", this.$root.$firebaseRefs.expenses.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("buyers", this.$root.$firebaseRefs.buyer.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("sellers", this.$root.$firebaseRefs.seller.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("incomes", this.$root.$firebaseRefs.incomes.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("salarys", this.$root.$firebaseRefs.salarys.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("closingDet", this.$root.$firebaseRefs.closingDetails.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("productList", this.$root.$firebaseRefs.products.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("firmSettings", this.$root.$firebaseRefs.firmSettings.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("productGroups", this.$root.$firebaseRefs.productGroup.orderByChild("brand").equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear", "brandFinYear"]), {
    firmStockReportType: function firmStockReportType() {
      var _this = this;

      var val = "APP";
      if (this.selectedFirm[".key"]) {
        var dfirmSetting = this.firmSettings.filter(function (item) {
          return item["firm"] == _this.selectedFirm[".key"];
        })[0];
        if (dfirmSetting && dfirmSetting.stockReportView) {
          val = dfirmSetting.stockReportView;
        }
      }
      return val;
    },
    sales: function sales() {
      var _this2 = this;

      var totalSale = 0;
      var buyers = this.buyers.filter(function (item) {
        return item["brand"] === _this2.selectedBrand;
      });
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      buyers.map(function (buyer) {
        var sales = _this2.invoices.filter(function (item) {
          return item["brand"] === _this2.selectedBrand && item.deleted != true && item.date >= _this2.finYear.start && item.date <= _this2.finYear.end && item["buyerId"] == buyer[".key"] && (_this2.selectedFirm ? item["firm"] === _this2.selectedFirm[".key"] : true) && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true);
        });
        sales.map(function (inv) {
          // totalSale += inv.totalAmount ? Number.parseFloat(inv.totalAmount) : 0;
          // totalSale += (isNaN(totalAmount) ? 0 :Number.parseFloat(totalAmount)) - (isNaN(GSTValue) ? 0 :  Number.parseFloat(GSTValue));
          var gst = _this2.getGSTtotal(inv);
          totalSale += parseFloat(inv.totalAmount || 0) - gst;
        });
      });
      totalSale = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(totalSale).toFixed(2);
      return totalSale;
    },
    purchase: function purchase() {
      var _this3 = this;

      var totalPurchase = 0;
      var sellers = this.sellers.filter(function (item) {
        return item["brand"] === _this3.selectedBrand;
      });
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      sellers.map(function (buyer) {
        var purchase = _this3.invoices.filter(function (item) {
          return item["brand"] === _this3.selectedBrand && item.date >= _this3.finYear.start && item.date <= _this3.finYear.end && item.deleted != true && item["buyerId"] == buyer[".key"] && (_this3.selectedFirm ? item["firm"] === _this3.selectedFirm[".key"] : true) && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true);
        });
        purchase.map(function (inv) {
          var gst = _this3.getGSTtotal(inv);
          //totalPurchase += (parseFloat(inv.totalAmount || 0) - gst);
          totalPurchase += parseFloat(inv.totalAmount) - (inv.totalExtraCharges || 0) - (inv.roundOffAmount || 0) - gst || 0;
        });
      });
      totalPurchase = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(totalPurchase).toFixed(2);
      return totalPurchase;
    },

    // current brands firm list
    firmsByBrand: function firmsByBrand() {
      var _this4 = this;

      // return selected brand firms
      var firmsB = this.firms.filter(function (item) {
        return item["brand"] === _this4.selectedBrand;
      });
      firmsB.map(function (item) {
        if (item.defaultFirm) {
          _this4.selectedFirm = item;
          _this4.isJwelleryBussiness = item.businessType == "Jwellery";
        }
      });
      return firmsB;
    },
    groupExpenses: function groupExpenses() {
      var _this5 = this;

      this.expenseTotal = 0;
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var expenses = this.expenses.filter(function (expense) {
        return expense.brand === _this5.selectedBrand && expense.underHead === 'Profit and Loss' && expense.category === "Direct";
      });
      expenses = expenses.filter(function (expense) {
        return !!expense[".key"];
      });
      expenses.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = "confirm";
        var invoices = _this5.invoices.filter(function (invoice) {
          return invoice.brand === _this5.selectedBrand && invoice.date >= _this5.finYear.start && invoice.date <= _this5.finYear.end && invoice["expenseType"] === ex[".key"] && (_this5.selectedFirm ? invoice["firm"] === _this5.selectedFirm[".key"] : true) && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true);
        });
        invoices.map(function (inv) {
          openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
          totalAmount += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          if (paymentTypeStatus == "confirm") {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        expenses[index]["invoices"] = invoices;
        expenses[index].paymentTypeStatus = paymentTypeStatus;
        expenses[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        expenses[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        _this5.expenseTotal += (isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(openingBalance)) + (isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(totalAmount));
      });
      this.expenseTotal = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.expenseTotal).toFixed(2);
      return expenses;
    },
    groupIncomes: function groupIncomes() {
      var _this6 = this;

      this.incomeTotal = 0;
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var incomes = this.incomes.filter(function (income) {
        return income.brand === _this6.selectedBrand && income.category === "Direct";
      });
      incomes = incomes.filter(function (income) {
        return !!income[".key"];
      });
      incomes.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = "confirm";
        var invoices = _this6.invoices.filter(function (invoice) {
          return invoice.brand === _this6.selectedBrand && invoice.date >= _this6.finYear.start && invoice.date <= _this6.finYear.end && invoice["incomeType"] === ex[".key"] && (_this6.selectedFirm ? invoice["firm"] === _this6.selectedFirm[".key"] : true) && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true);
        });
        invoices.map(function (inv) {
          if (inv.paymentTypeStatus == "confirm") {
            openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
            totalAmount += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          }
          if (paymentTypeStatus == "yet to confirm") {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        incomes[index]["invoices"] = invoices;
        incomes[index].paymentTypeStatus = paymentTypeStatus;
        incomes[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        incomes[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        _this6.incomeTotal += (isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(openingBalance)) + (isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(totalAmount));
      });
      this.incomeTotal = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.incomeTotal).toFixed(2);
      return incomes;
    },

    // groupIncomes(){
    //      const mainGroup = [] // { details: {} && invoices: []}
    //   try {
    //     this.incomesByBrand.forEach(details => {
    //       const invoices = this.invoiceByBrand.filter(invoice => {
    //         return invoice.incomeType === details['.key'];
    //       })
    //       details.totalAmount = invoices.reduce((total, item) => {
    //         return total + item.totalAmount
    //       }, 0)
    //       details.openingBalance = invoices.reduce((total, item) => {
    //         return total + item.openingBalance
    //       }, 0)
    //       if(details.totalAmount) {
    //         mainGroup.push({
    //           details,
    //           invoices
    //         })
    //       }
    //       else if(details.openingBalance) {
    //         mainGroup.push({
    //           details,
    //           invoices
    //         })
    //       }
    //     })
    //     return mainGroup
    //   } catch(e) {
    //     console.info(e)
    //     return []
    //   }
    // },
    totalIncomesAmount: function totalIncomesAmount() {
      return this.groupIncomes.reduce(function (total, item) {
        return item.details.totalAmount + total;
      }, 0);
    },
    incomesByBrand: function incomesByBrand() {
      var _this7 = this;

      var income = this.incomes.filter(function (income) {
        return income.brand === _this7.selectedBrand && income.underHead === "Profit and Loss";
      });
      return income;
    },
    incomeInvoices: function incomeInvoices() {
      return this.invoiceByBrand.filter(function (invoice) {
        return !!invoice.incomeType;
      });
    },
    totalIncomeAmount: function totalIncomeAmount() {
      return this.creditedInvoiceByBrand.reduce(function (total, item) {
        // calculate total Income for expense
        return total + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item["profit"] || 0);
      }, 0);
    },
    creditedInvoiceByBrand: function creditedInvoiceByBrand() {
      var _this8 = this;

      return this.invoiceByBrand.filter(function (invoice) {
        if (_this8.selectedFirm) {
          return invoice.firm === _this8.selectedFirm[".key"] && invoice.isCredited;
        }
        return invoice.isCredited;
      });
    },
    totalIncomesOpeningBalance: function totalIncomesOpeningBalance() {
      return this.groupIncomes.reduce(function (total, item) {
        return (isNaN(item.details.openingBalance) ? 0 : item.details.openingBalance) + (isNaN(total) ? 0 : total);
      }, 0);
    },
    invoiceByBrand: function invoiceByBrand() {
      var _this9 = this;

      if (!this.invoices) {
        return [];
      }
      var filter = this.invoices.filter(function (item) {
        return item["brand"] === _this9.selectedBrand && invoice.deleted != true && invoice.date >= _this9.finYear.start && invoice.date <= _this9.finYear.end;
      });
      if (this.selectedFirm) {
        filter = filter.filter(function (item) {
          return item.firm === _this9.selectedFirm[".key"];
        });
      }
      if (this.filterInvoiceFrom) {
        var from = new Date(this.filterInvoiceFrom).setHours(0, 0, 0, 0);
        filter = filter.filter(function (item) {
          return item.date >= from;
        });
      }
      if (this.filterInvoiceTo) {
        var to = new Date(this.filterInvoiceTo).setHours(23, 29, 59, 999);
        filter = filter.filter(function (item) {
          return item.date <= to;
        });
      }
      return filter;
    },
    closingStockFiltered: function closingStockFiltered() {
      var closingstock = (this.selectedFirm ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.selectedFirm.openingStock) || 0 : 0) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.purchase || 0 | amount) - __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.sales || 0 | amount);
      closingstock = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(closingstock).toFixed(2);
      return closingstock;
    },

    // closingStock(){
    //   let closingstock = Number.parseFloat(this.closingStockFiltered);
    //   this.brandClosingStockAmount = closingstock;
    //   this.currentClosingDetails = this.closingDet.filter(det => det.brand === this.selectedBrand)[0];
    //   if(this.currentClosingDetails && this.currentClosingDetails.closingAmount) {
    //     closingstock += Number.parseFloat(this.currentClosingDetails.closingAmount);
    //   }
    //   return closingstock;
    // },
    grossProfit: function grossProfit() {
      var profit = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.sales) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.incomeTotal) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.isJwelleryBussiness ? this.closingStockWeight : this.closingStock) - ((this.selectedFirm ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.selectedFirm.openingStock) || 0 : 0) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.isJwelleryBussiness ? this.totalOpeningStockWeight : this.totalOpeningStock) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.purchase) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.expenseTotal));
      profit = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(profit).toFixed(2);
      return profit;
    },
    filteredGroups: function filteredGroups() {
      var products = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()([], this.filteredProduct);
      //let total = products.pop();
      var groups = JSON.parse(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(this.productGroups));
      groups.push({
        name: "Non group Products",
        ".key": "Nongroup",
        quantity: 0,
        durationQuantity: 0,
        durationAmount: 0,
        saleQuantity: 0,
        durationQtySale: 0,
        durationAmountSale: 0,
        purchaseQuantity: 0,
        durationQtyPurchase: 0,
        durationAmountPurchase: 0,
        openingQuantity: 0,
        openingBalance: 0,
        closingAmount: 0,
        closingQuantity: 0
      });
      groups.map(function (item, index) {
        groups[index]["productList"] = [];
        groups[index]["quantity"] = 0;
        groups[index]["durationQuantity"] = 0;
        groups[index]["durationAmount"] = 0;
        groups[index]["saleQuantity"] = 0;
        groups[index]["durationQtySale"] = 0;
        groups[index]["durationAmountSale"] = 0;
        groups[index]["purchaseQuantity"] = 0;
        groups[index]["durationQtyPurchase"] = 0;
        groups[index]["durationAmountPurchase"] = 0;
        groups[index]['openingQuantity'] = item.weight;
        groups[index]['openingBalance'] = item.openingBalance;

        groups[index]["closingAmount"] = 0;
        groups[index]["closingQuantity"] = 0;
      });
      groups.map(function (item, index) {
        products.map(function (prod) {
          if (prod.productGroup && prod.productGroup == item[".key"]) {
            groups[index]["productList"] = groups[index]["productList"].concat(prod.productList);
            groups[index]["quantity"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["quantity"]);
            groups[index]["durationQuantity"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationQuantity"]);
            groups[index]["durationAmount"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationAmount"]);
            groups[index]["saleQuantity"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["saleQuantity"]);
            groups[index]["durationQtySale"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationQtySale"]);
            groups[index]["durationAmountSale"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationAmountSale"]);
            groups[index]["purchaseQuantity"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["purchaseQuantity"]);
            groups[index]["durationQtyPurchase"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationQtyPurchase"]);
            groups[index]["durationAmountPurchase"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationAmountPurchase"]);
            // groups[index]["openingQuantity"] += Number.parseFloat(
            //   prod["openingQuantity"]
            // );
            // groups[index]["openingBalance"] += Number.parseFloat(
            //   prod["openingBalance"]
            // );
            groups[index]["closingAmount"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["closingAmount"]);
            groups[index]["closingQuantity"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["closingQuantity"]);
          } else if (!prod.productGroup && item[".key"] == "Nongroup") {
            groups[index]["productList"] = groups[index]["productList"].concat(prod.productList);
            groups[index]["quantity"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["quantity"]);
            groups[index]["durationQuantity"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationQuantity"]);
            groups[index]["durationAmount"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationAmount"]);
            groups[index]["saleQuantity"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["saleQuantity"]);
            groups[index]["durationQtySale"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationQtySale"]);
            groups[index]["durationAmountSale"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationAmountSale"]);
            groups[index]["purchaseQuantity"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["purchaseQuantity"]);
            groups[index]["durationQtyPurchase"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationQtyPurchase"]);
            groups[index]["durationAmountPurchase"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationAmountPurchase"]);
            groups[index]["openingQuantity"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["openingQuantity"]);
            groups[index]["openingBalance"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["openingBalance"]);
            groups[index]["closingAmount"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["closingAmount"]);
            groups[index]["closingQuantity"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["closingQuantity"]);
          }
        });
      });
      //groups.push(total);
      groups.map(function (prod, index) {
        groups[index]["closingAmount"] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["openingBalance"]) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationAmountPurchase"]) - __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationAmountSale"]);
        groups[index]["closingQuantity"] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["openingQuantity"]) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationQtyPurchase"]) - __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationQtySale"]);
      });

      var closingAmount = 0;
      var openingBalance = 0;
      groups.map(function (prod, index) {
        groups[index]['quantity'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['quantity']).toFixed(3);
        groups[index]['durationQuantity'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['durationQuantity']).toFixed(3);
        groups[index]['durationAmount'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['durationAmount']).toFixed(3);
        groups[index]['saleQuantity'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['saleQuantity']).toFixed(3);
        groups[index]['durationQtySale'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['durationQtySale']).toFixed(3);
        groups[index]['durationAmountSale'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['durationAmountSale']).toFixed(3);
        groups[index]['purchaseQuantity'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['purchaseQuantity']).toFixed(3);
        groups[index]['durationQtyPurchase'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['durationQtyPurchase']).toFixed(3);
        groups[index]['durationAmountPurchase'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['durationAmountPurchase']).toFixed(3);
        groups[index]['openingQuantity'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['openingQuantity']).toFixed(3);
        groups[index]['openingBalance'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['openingBalance']).toFixed(3);
        groups[index]['closingAmount'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['closingAmount']).toFixed(3);
        groups[index]['closingQuantity'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['closingQuantity']).toFixed(3);
        closingAmount += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['closingAmount']);
        openingBalance += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['openingBalance']);
      });
      this.closingStockWeight = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(closingAmount).toFixed(3);
      this.totalOpeningStockWeight = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(3);

      return groups;
    },
    filteredProduct: function filteredProduct() {
      var _this10 = this;

      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var products = this.productList.filter(function (item) {
        return item["brand"] === _this10.selectedBrand && (_this10.selectedFirm ? item["firm"] === _this10.selectedFirm[".key"] : true);
      });
      var total = {
        quantity: 0,
        durationQuantity: 0,
        durationAmount: 0,
        saleQuantity: 0,
        durationQtySale: 0,
        durationAmountSale: 0,
        purchaseQuantity: 0,
        durationQtyPurchase: 0,
        durationAmountPurchase: 0,
        openingQuantity: 0,
        openingBalance: 0
      };
      products.map(function (p, index) {
        p["durationQuantity"] = undefined;
        p["durationAmount"] = 0;
        p["durationQtySale"] = 0;
        p["durationQtyPurchase"] = 0;
        p["durationAmountSale"] = 0;
        p["durationAmountPurchase"] = 0;
        p["stockReportData"] = {
          saleDetails: [],
          purchaseDetails: [],
          lastSalePrice: 0,
          lastPurchasePrice: 0
        };
        var prodG = {
          weight: 0,
          openingBalance: 0
        };
        if (_this10.isJwelleryBussiness) {
          if (p.productGroup) {
            prodG = _this10.productGroups.find(function (item) {
              return item[".key"] == p.productGroup;
            });
          }
          products[index]["openingQuantity"] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prodG && prodG.weigh ? prodG.weight : 0);
          products[index]["openingBalance"] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prodG && prodG.openingBalance ? prodG.openingBalance : 0);
        } else {
          products[index]["openingQuantity"] = 0;
          products[index]["openingBalance"] = 0;
        }
        if (p.openingBalance && p.openingQuantity) {
          p["stockReportData"]["purchaseDetails"].push({
            // quantity : Number.parseFloat(p.openingQuantity),
            // rate : Number.parseInt(p.openingBalance),
            quantity: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int___default()(p.openingQuantity),
            rate: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(p.openingBalance) / __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int___default()(p.openingQuantity),
            date: p.openingDate
          });
          p["stockReportData"]["lastPurchasePrice"] = p.openingBalance;
        }
        total.openingQuantity += parseInt(p["openingQuantity"] ? p["openingQuantity"] : 0);
        total.openingBalance += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(p["openingBalance"] ? p["openingBalance"] : 0);
      });
      var productGroup = products.reduce(function (r, a) {
        r[a[".key"]] = r[a[".key"]] || [];
        r[a[".key"]].push(a);
        return r;
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_create___default()(null));
      var latestSaleDate = new Date("01-01-1000").getTime();
      var latestPurchaseDate = new Date("01-01-1000").getTime();
      var filteredInvoices = this.invoices.filter(function (item) {
        return item.type != "automatic invoice" && item.items && item.items.length && item.date >= _this10.finYear.start && item.deleted != true && item.date <= _this10.finYear.end && (_this10.selectedFirm ? item["firm"] === _this10.selectedFirm[".key"] : true) && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true);
      });
      this.selectProdList = [];
      filteredInvoices.map(function (invoice) {
        var invoiceMonth = new Date(invoice.date).getMonth();
        var isBuyer = invoice.isBuyer;
        invoice.items && invoice.items.map(function (item) {
          if (productGroup[item["productId"]]) {
            if (productGroup[item["productId"]][0].durationQuantity != undefined) {
              var durationQuantity = parseInt(productGroup[item["productId"]][0]["durationQuantity"]);
              durationQuantity += !!isBuyer ? -parseInt(_this10.isJwelleryBussiness ? item.netWeight : item.quantity) : parseInt(_this10.isJwelleryBussiness ? item.netWeight : item.quantity);
              total.durationQuantity += durationQuantity;
              productGroup[item["productId"]][0]["durationQuantity"] = durationQuantity;
            } else {
              productGroup[item["productId"]][0]["durationQuantity"] = productGroup[item["productId"]][0].openingQuantity ? productGroup[item["productId"]][0].openingQuantity : 0;
              total.durationQuantity += parseInt(productGroup[item["productId"]][0]["durationQuantity"]);
            }
            var rate = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.rate);
            if (isBuyer) {
              if (invoice.date > latestSaleDate) {
                latestSaleDate = invoice.date;
                productGroup[item["productId"]][0]["stockReportData"]["lastSalePrice"] = rate;
              }
              productGroup[item["productId"]][0]["stockReportData"]["saleDetails"].push({
                quantity: _this10.isJwelleryBussiness ? item.netWeight : item.quantity,
                rate: rate,
                date: invoice.date
              });
            } else {
              if (invoice.date > latestPurchaseDate) {
                latestPurchaseDate = invoice.date;
                productGroup[item["productId"]][0]["stockReportData"]["lastPurchasePrice"] = rate;
              }
              productGroup[item["productId"]][0]["stockReportData"]["purchaseDetails"].push({
                quantity: _this10.isJwelleryBussiness ? item.netWeight : item.quantity,
                rate: rate,
                date: invoice.date
              });
            }

            productGroup[item["productId"]][0]["durationAmount"] += !!isBuyer ? -__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.GSTValue) : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
            total.durationAmount += productGroup[item["productId"]][0]["durationAmount"];
            if (!!isBuyer) {
              productGroup[item["productId"]][0]["durationQtySale"] += _this10.isJwelleryBussiness ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.netWeight) : parseInt(item.quantity);
              total.durationQtySale += _this10.isJwelleryBussiness ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.netWeight) : parseInt(item.quantity);
              productGroup[item["productId"]][0]["durationAmountSale"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
              total.durationAmountSale += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
            } else {
              productGroup[item["productId"]][0]["durationQtyPurchase"] += _this10.isJwelleryBussiness ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.netWeight) : parseInt(item.quantity);
              total.durationQtyPurchase += _this10.isJwelleryBussiness ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.netWeight) : parseInt(item.quantity);
              productGroup[item["productId"]][0]["durationAmountPurchase"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
              total.durationAmountPurchase += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
            }
            item["date"] = invoice.date;
            item["invoice"] = invoice;
            item["isBuyer"] = invoice["isBuyer"];
            item["openingBalance"] = productGroup[item["productId"]][0]["openingBalance"];
            item["openingQuantity"] = productGroup[item["productId"]][0]["openingQuantity"];
            if (!(productGroup[item["productId"]][0]["productList"] && productGroup[item["productId"]][0]["productList"].length)) productGroup[item["productId"]][0]["productList"] = [];

            productGroup[item["productId"]][0]["productList"].push(item);
          }
        });
      });
      // productGroup['total'] = [{
      //   name : 'Total',
      //   ".key" : 'total',
      //   quantity : total.quantity,
      //   durationQuantity : total.durationQuantity,
      //   durationAmount : total.durationAmount,
      //   saleQuantity : total.saleQuantity,
      //   durationQtySale : total.durationQtySale,
      //   durationAmountSale : total.durationAmountSale,
      //   purchaseQuantity : total.purchaseQuantity,
      //   durationQtyPurchase : total.durationQtyPurchase,
      //   durationAmountPurchase : total.durationAmountPurchase,
      //   openingQuantity : total.openingQuantity,
      //   openingBalance : total.openingBalance
      // }];
      this.totalOpeningStock = total.openingBalance;
      var results = [];
      this.closingStock = 0;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(productGroup).length && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(productGroup).map(function (key, index) {
        productGroup[key][".key"] = key;
        results.push(productGroup[key][0]);
        // productGroup[key][0]['closingAmount'] = this.getClosingAmount(productGroup[key][0]);
        var temp = _this10.getClosingAmount(productGroup[key][0]);
        productGroup[key][0]["closingAmount"] = isNaN(temp) ? 0 : temp;
        _this10.closingStock += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(productGroup[key][0]["closingAmount"]);
      });
      console.log(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(results.length, null, 4));
      return results;
    }
  }),
  methods: {
    getGSTtotal: function getGSTtotal(item) {
      var GSTTotal = 0;
      item && item.items && item.items.map(function (item) {
        GSTTotal += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
      });
      return GSTTotal;
    },
    getClosingAmount: function getClosingAmount(item) {
      var closingQty = parseInt(item["openingQuantity"] ? item["openingQuantity"] : 0) + parseInt(item["durationQtyPurchase"] ? item["durationQtyPurchase"] : 0) - parseInt(item["durationQtySale"] ? item["durationQtySale"] : 0);
      switch (this.firmStockReportType) {
        case "APP":
          {
            var _amount = 0;
            if (item.stockReportData) {
              var avgPurchasePrice = item.stockReportData.purchaseDetails.reduce(function (a, b) {
                return a + (b["rate"] || 0);
              }, 0) / item.stockReportData.purchaseDetails.length;
              _amount = avgPurchasePrice * closingQty;
            }
            return _amount;
          }
        case "LPP":
          {
            var _amount2 = 0;
            if (item.stockReportData) {
              _amount2 = item.stockReportData.lastPurchasePrice * closingQty;
            }
            return _amount2;
          }
        case "LSP":
          {
            var _amount3 = 0;
            if (item.stockReportData) {
              _amount3 = item.stockReportData.lastSalePrice * closingQty;
            }
            return _amount3;
          }
        case "ASP":
          {
            var _amount4 = 0;
            if (item.stockReportData) {
              var avgSalePrice = item.stockReportData.saleDetails.reduce(function (a, b) {
                return a + (b["rate"] || 0);
              }, 0) / item.stockReportData.saleDetails.length;
              _amount4 = avgSalePrice * closingQty;
            }
            return _amount4;
          }
        case "FIFO":
          {
            var _amount5 = 0;
            if (item.stockReportData) {
              var allTransaction = item.stockReportData.purchaseDetails.sort(function (a, b) {
                return -(new Date(b.date) - new Date(a.date));
              });

              var qntTemp = closingQty;
              allTransaction.map(function (t) {
                if (qntTemp > t.quantity) {
                  _amount5 += t.quantity * t.rate;
                  qntTemp = qntTemp - t.quantity;
                } else if (qntTemp > 0) {
                  _amount5 += t.quantity - qntTemp * t.rate;
                  qntTemp = 0;
                }
              });
            }
            return _amount5;
          }
        case "LIFO":
          {
            var _amount6 = 0;
            if (item.stockReportData) {
              var _allTransaction = item.stockReportData.purchaseDetails.sort(function (a, b) {
                return new Date(b.date) - new Date(a.date);
              });
              var _qntTemp = closingQty;
              _allTransaction.map(function (t) {
                if (_qntTemp > t.quantity) {
                  _amount6 += t.quantity * t.rate;
                  _qntTemp = _qntTemp - t.quantity;
                } else if (_qntTemp > 0) {
                  _amount6 += t.quantity - _qntTemp * t.rate;
                  _qntTemp = 0;
                }
              });
            }
            return _amount6;
          }
      }
    },
    print: function print() {
      var data = [];
      $(".print-field").each(function (index) {
        data.push($(this).text());
      });
      var doc = Object(__WEBPACK_IMPORTED_MODULE_9__utils_pdf_reports_information_reports__["e" /* convertToPDFTradingAccount */])({ data: data });
      pdfMake.createPdf(doc).download();
    },
    saveClosingStock: function saveClosingStock() {
      this.editClosingStock = false;
      var calculatedClosingAmount = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.brandClosingStockAmount) - __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.closingStockFiltered);
      if (this.currentClosingDetails) {
        var key = this.currentClosingDetails[".key"];
        delete this.currentClosingDetails[".key"];
        this.currentClosingDetails.closingAmount = calculatedClosingAmount;
        this.$root.$firebaseRefs.closingDetails.child(key).set(this.currentClosingDetails);
      } else {
        var obj = {
          brand: this.selectedBrand,
          closingAmount: calculatedClosingAmount
        };
        this.$root.$firebaseRefs.closingDetails.push(obj);
      }
    }
  }
});

/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Balancesheet_expandCard__ = __webpack_require__(36);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ExpandCard: __WEBPACK_IMPORTED_MODULE_3__Balancesheet_expandCard__["a" /* default */]
  },
  data: function data() {
    return {
      pandlAccount: [{
        expense: true
      }, {
        expense: false
      }],
      expenseTotal: 0,
      pandlexpenseTotal: 0,
      incomeTotal: 0,
      pandlincomeTotal: 0,
      selectedFirm: null,
      filterInvoiceFrom: null,
      filterInvoiceTo: null,
      fromdatepicker: false,
      todatepicker: false,
      totalSalary: 0,
      totalAsset: 0,
      searchInput: null,
      selectedStaff: {},
      salaryListHeaders: [{ text: 'Date', value: 'date', sortable: true }, { text: 'Credit/Debit', value: 'amount', sortable: false }],
      sale: {
        total: 0,
        list: [],
        expand: false
      }
    };
  },
  created: function created() {
    this.$bindAsArray('invoices', this.$root.$firebaseRefs.invoice.orderByChild('brandFinYear').equalTo(this.brandFinYear));
    this.$bindAsArray('expenses', this.$root.$firebaseRefs.expenses.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('firms', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("buyers", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("sellers", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('incomes', this.$root.$firebaseRefs.incomes.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('salarys', this.$root.$firebaseRefs.salarys.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('staff', this.$root.$firebaseRefs.staff.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('assets', this.$root.$firebaseRefs.assets.orderByChild('brand').equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand', 'brandFinYear']), {
    sales: function sales() {
      var _this = this;

      var totalSale = 0;
      var buyers = this.buyers.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      });
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      buyers.map(function (buyer) {
        var sales = _this.invoices.filter(function (item) {
          return item['brand'] === _this.selectedBrand && item['buyerId'] == buyer['.key'] && (_this.selectedFirm ? item['firm'] === _this.selectedFirm['.key'] : true) && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true);
        });
        sales.map(function (inv) {
          totalSale += inv.totalAmount ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount) : 0;
        });
      });
      totalSale = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(totalSale).toFixed(2);
      return totalSale;
    },
    purchase: function purchase() {
      var _this2 = this;

      var totalPurchase = 0;
      var sellers = this.sellers.filter(function (item) {
        return item["brand"] === _this2.selectedBrand;
      });
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      sellers.map(function (buyer) {
        var purchase = _this2.invoices.filter(function (item) {
          return item['brand'] === _this2.selectedBrand && item['buyerId'] == buyer['.key'] && (_this2.selectedFirm ? item['firm'] === _this2.selectedFirm['.key'] : true) && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true);
        });
        purchase.map(function (inv) {
          totalPurchase += inv.totalAmount ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount) : 0;
        });
      });
      totalPurchase = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(totalPurchase).toFixed(2);
      return totalPurchase;
    },

    // current brands firm list
    firmsByBrand: function firmsByBrand() {
      var _this3 = this;

      // return selected brand firms
      return this.firms.filter(function (item) {
        return item['brand'] === _this3.selectedBrand;
      });
    },
    groupExpensesOfTradingAccount: function groupExpensesOfTradingAccount() {
      var _this4 = this;

      this.expenseTotal = 0;
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var expenses = this.expenses.filter(function (expense) {
        return expense.brand === _this4.selectedBrand;
      });
      expenses = expenses.filter(function (expense) {
        return !!expense['.key'];
      });
      expenses.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = 'confirm';
        var invoices = _this4.invoices.filter(function (invoice) {
          return invoice.brand === _this4.selectedBrand && invoice["expenseType"] === ex['.key'] && (_this4.selectedFirm ? invoice['firm'] === _this4.selectedFirm['.key'] : true) && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true);
        });
        invoices.map(function (inv) {
          openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
          totalAmount += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          if (paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        expenses[index]['invoices'] = invoices;
        expenses[index].paymentTypeStatus = paymentTypeStatus;
        expenses[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        expenses[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        _this4.expenseTotal += (isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(openingBalance)) + (isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(totalAmount));
      });
      this.expenseTotal = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.expenseTotal).toFixed(2);
      return expenses;
    },
    groupIncomesOfTradingAccount: function groupIncomesOfTradingAccount() {
      var _this5 = this;

      this.incomeTotal = 0;
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var incomes = this.incomes.filter(function (income) {
        return income.brand === _this5.selectedBrand;
      });
      incomes = incomes.filter(function (income) {
        return !!income['.key'];
      });
      incomes.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = 'confirm';
        var invoices = _this5.invoices.filter(function (invoice) {
          return invoice.brand === _this5.selectedBrand && invoice["incomeType"] === ex['.key'] && (_this5.selectedFirm ? invoice['firm'] === _this5.selectedFirm['.key'] : true) && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true);
        });
        invoices.map(function (inv) {
          openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
          totalAmount += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          if (paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        incomes[index]['invoices'] = invoices;
        incomes[index].paymentTypeStatus = paymentTypeStatus;
        incomes[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        incomes[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        _this5.incomeTotal += (isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(openingBalance)) + (isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(totalAmount));
      });
      this.incomeTotal = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.incomeTotal).toFixed(2);
      return incomes;
    },
    groupExpensesOfPandL: function groupExpensesOfPandL() {
      var _this6 = this;

      this.pandlexpenseTotal = 0;
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var expenses = this.expenses.filter(function (expense) {
        return expense.brand === _this6.selectedBrand && expense.underHead === 'Profit and Loss';
      });
      expenses = expenses.filter(function (expense) {
        return !!expense['.key'];
      });
      expenses.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = 'confirm';
        var invoices = _this6.invoices.filter(function (invoice) {
          return invoice.brand === _this6.selectedBrand && invoice["expenseType"] === ex['.key'] && (_this6.selectedFirm ? invoice['firm'] === _this6.selectedFirm['.key'] : true) && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true);
        });
        invoices.map(function (inv) {
          openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
          totalAmount += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          if (paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        expenses[index]['invoices'] = invoices;
        expenses[index].paymentTypeStatus = paymentTypeStatus;
        expenses[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        expenses[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        _this6.pandlexpenseTotal += (isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(openingBalance)) + (isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(totalAmount));
      });
      this.pandlexpenseTotal = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.pandlexpenseTotal).toFixed(2);
      return expenses;
    },
    getStaffAccount: function getStaffAccount() {
      var _this7 = this;

      this.totalSalary = 0;
      if (this.selectedBrand) {
        var staffList = this.staff.filter(function (item) {
          return item['brand'] === _this7.selectedBrand && (_this7.selectedFirm ? item['firm'] === _this7.selectedFirm['.key'] : true);
        });
        var result = staffList.map(function (e) {
          var salaryList = _.filter(_this7.salarys, { 'staffId': e['.key'] });
          e.salaryList = salaryList;
          var creditTotal = _.sumBy(salaryList, function (s) {
            if (s.isCredited) return s.amount;
          });

          e.creditTotal = creditTotal ? creditTotal : 0;

          var debitTotal = _.sumBy(salaryList, function (s) {
            if (!s.isCredited) return s.amount;
          });

          e.debitTotal = debitTotal ? debitTotal : 0;

          _this7.totalSalary = _this7.totalSalary + (parseInt(e.creditTotal) - parseInt(e.debitTotal));
          return e;
        });
        console.log(result, null, 4);
        return result;
      }
    },
    assetByBrand: function assetByBrand() {
      var _this8 = this;

      if (this.assets) {
        this.totalAsset = 0;
        var selectedAssets = this.assets.filter(function (asset) {
          return asset.brand === _this8.selectedBrand && asset['category'] != 'personal' && asset['depriciation'];
        });
        selectedAssets.map(function (ast, index) {
          var firmAsset = _this8.invoices.filter(function (item) {
            return item['assetType'] === ast['.key'] && item['brand'] === _this8.selectedBrand && (_this8.selectedFirm ? ast.firm === _this8.selectedFirm['.key'] : true);
          });
          var openingBalance = 0;
          firmAsset.map(function (inv) {
            openingBalance += inv.openingBalance ? parseInt(inv.openingBalance) : 0;
          });
          selectedAssets[index]['openingBalance'] = openingBalance;
          selectedAssets[index]['depAmount'] = _this8.getDepAmount(ast, ast.type);
          if (ast.category === 'b&p') {
            selectedAssets[index]['depAmount'] = selectedAssets[index]['depAmount'] / 2;
          }
          _this8.totalAsset += selectedAssets[index]['depAmount'];
        });
        return selectedAssets;
      }
      return [];
    },
    groupIncomes: function groupIncomes() {
      var _this9 = this;

      this.pandlincomeTotal = 0;
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var incomes = this.incomes.filter(function (income) {
        return income.brand === _this9.selectedBrand && income.underHead === 'Profit and Loss';
      });
      incomes = incomes.filter(function (income) {
        return !!income['.key'];
      });
      incomes.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = 'confirm';
        var invoices = _this9.invoices.filter(function (invoice) {
          return invoice.brand === _this9.selectedBrand && invoice["incomeType"] === ex['.key'] && (_this9.selectedFirm ? invoice['firm'] === _this9.selectedFirm['.key'] : true) && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true);
        });
        invoices.map(function (inv) {
          openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
          totalAmount += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          if (paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        incomes[index]['invoices'] = invoices;
        incomes[index].paymentTypeStatus = paymentTypeStatus;
        incomes[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        incomes[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        _this9.pandlincomeTotal += (isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(openingBalance)) + (isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(totalAmount));
      });
      this.pandlincomeTotal = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.pandlincomeTotal).toFixed(2);
      return incomes;
    },

    // groupIncomes(){
    //      const mainGroup = [] // { details: {} && invoices: []}
    //   try {
    //     this.incomesByBrand.forEach(details => {
    //       const invoices = this.invoiceByBrand.filter(invoice => {
    //         return invoice.incomeType === details['.key'];
    //       })
    //       details.totalAmount = invoices.reduce((total, item) => {
    //         return total + item.totalAmount  
    //       }, 0)
    //       details.openingBalance = invoices.reduce((total, item) => {
    //         return total + item.openingBalance  
    //       }, 0)
    //       if(details.totalAmount) {
    //         mainGroup.push({
    //           details,
    //           invoices
    //         }) 
    //       }
    //       else if(details.openingBalance) {
    //         mainGroup.push({
    //           details,
    //           invoices
    //         }) 
    //       }
    //     })
    //     return mainGroup
    //   } catch(e) {
    //     console.info(e)
    //     return []
    //   }
    // },
    totalIncomesAmount: function totalIncomesAmount() {
      return this.groupIncomes.reduce(function (total, item) {
        return item.details.totalAmount + total;
      }, 0);
    },
    incomesByBrand: function incomesByBrand() {
      var _this10 = this;

      var income = this.incomes.filter(function (income) {
        return income.brand === _this10.selectedBrand && income.underHead === 'Profit and Loss';
      });
      return income;
    },
    incomeInvoices: function incomeInvoices() {
      return this.invoiceByBrand.filter(function (invoice) {
        return !!invoice.incomeType;
      });
    },
    totalIncomeAmount: function totalIncomeAmount() {
      return this.creditedInvoiceByBrand.reduce(function (total, item) {
        // calculate total Income for expense
        return total + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item['profit'] || 0);
      }, 0);
    },
    creditedInvoiceByBrand: function creditedInvoiceByBrand() {
      var _this11 = this;

      return this.invoiceByBrand.filter(function (invoice) {
        if (_this11.selectedFirm) {
          return invoice.firm === _this11.selectedFirm['.key'] && invoice.isCredited;
        }
        return invoice.isCredited;
      });
    },
    totalIncomesOpeningBalance: function totalIncomesOpeningBalance() {
      return this.groupIncomes.reduce(function (total, item) {
        return (isNaN(item.details.openingBalance) ? 0 : item.details.openingBalance) + (isNaN(total) ? 0 : total);
      }, 0);
    },
    invoiceByBrand: function invoiceByBrand() {
      var _this12 = this;

      if (!this.invoices) {
        return [];
      };
      var filter = this.invoices.filter(function (item) {
        return item['brand'] === _this12.selectedBrand;
      });
      if (this.selectedFirm) {
        filter = filter.filter(function (item) {
          return item.firm === _this12.selectedFirm['.key'];
        });
      }
      if (this.filterInvoiceFrom) {
        var from = new Date(this.filterInvoiceFrom).setHours(0, 0, 0, 0);
        filter = filter.filter(function (item) {
          return item.date >= from;
        });
      }
      if (this.filterInvoiceTo) {
        var to = new Date(this.filterInvoiceTo).setHours(23, 29, 59, 999);
        filter = filter.filter(function (item) {
          return item.date <= to;
        });
      }
      return filter;
    },
    closingStock: function closingStock() {
      var closingstock = (this.selectedFirm ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.selectedFirm.openingStock) || 0 : 0) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.purchase || 0 | amount) - __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.sales || 0 | amount);
      closingstock = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(closingstock).toFixed(2);
      return closingstock;
    },
    grossProfit: function grossProfit() {
      var profit = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.sales) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.incomeTotal) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.closingStock) - ((this.selectedFirm ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.selectedFirm.openingStock) || 0 : 0) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.purchase) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.expenseTotal));
      profit = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(profit).toFixed(2);
      return profit;
    },
    netProfit: function netProfit() {
      var netprofit = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.pandlincomeTotal) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.grossProfit) - (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.totalSalary) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.totalAsset) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.pandlexpenseTotal));
      netprofit = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(netprofit).toFixed(2);
      return netprofit;
    },
    grossProfit1: function grossProfit1() {
      var profit = (this.selectedFirm ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.selectedFirm.openingStock) || 0 : 0) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.purchase) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.expenseTotal) - (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.sales) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.incomeTotal) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.closingStock));
      profit = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(profit).toFixed(2);
      return profit;
    },
    grossLoss1: function grossLoss1() {
      var loss = (this.selectedFirm ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.selectedFirm.openingStock) || 0 : 0) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.purchase) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.expenseTotal) - (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.sales) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.incomeTotal) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.closingStock));
      loss = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(loss).toFixed(2);
      return loss;
    }
  }),
  methods: {
    getFirmName: function getFirmName(e) {
      var firm = void 0;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter(function (item) {
          return item['.key'] === e;
        })[0];
      }
      if (firm) return firm.name;
    },
    getDepAmount: function getDepAmount(asset, type) {
      var depriciation = null;
      if (asset.isVerified && asset.depriciation) {
        var totalAmount = this.getTotalAmount(asset);
        depriciation = Number(totalAmount * asset.depriciation / 100);
        return depriciation;
      }
      return 0;
    },
    getTotalAmount: function getTotalAmount(asset) {
      if (asset.isVerified) {
        return Number(asset.openingBalance || 0) + Number(asset.totalAdditionAmount) - Number(asset.totalDeletionAmount);
      }
      return Number(asset.totalAdditionAmount) - Number(asset.totalDeletionAmount);
    }
  }
});

/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_int__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Balancesheet_expandCard__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_pdf_reports_information_reports__ = __webpack_require__(46);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ExpandCard: __WEBPACK_IMPORTED_MODULE_8__Balancesheet_expandCard__["a" /* default */]
  },
  data: function data() {
    return {
      pandlAccount: [{
        expense: true
      }, {
        expense: false
      }],
      isJwelleryBussiness: false,
      expenseTotal: 0,
      pandlexpenseTotal: 0,
      incomeTotal: 0,
      pandlincomeTotal: 0,
      selectedFirm: null,
      filterInvoiceFrom: null,
      filterInvoiceTo: null,
      fromdatepicker: false,
      todatepicker: false,
      totalSalary: 0,
      totalAsset: 0,
      searchInput: null,
      selectedStaff: {},
      salaryListHeaders: [{ text: 'Date', value: 'date', sortable: true }, { text: 'Credit/Debit', value: 'amount', sortable: false }],
      sale: {
        total: 0,
        list: [],
        expand: false
      }
    };
  },
  created: function created() {
    this.$bindAsArray('invoices', this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('expenses', this.$root.$firebaseRefs.expenses.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('firms', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("buyers", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("sellers", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('incomes', this.$root.$firebaseRefs.incomes.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('salarys', this.$root.$firebaseRefs.salarys.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('staff', this.$root.$firebaseRefs.staff.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('assets', this.$root.$firebaseRefs.assets.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("productList", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("firmSettings", this.$root.$firebaseRefs.firmSettings.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("productGroups", this.$root.$firebaseRefs.productGroup.orderByChild("brand").equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand', 'finYear', "brandFinYear"]), {
    firmStockReportType: function firmStockReportType() {
      var _this = this;

      var val = 'APP';
      if (this.selectedFirm['.key']) {
        var dfirmSetting = this.firmSettings.filter(function (item) {
          return item['firm'] == _this.selectedFirm['.key'];
        })[0];
        if (dfirmSetting && dfirmSetting.stockReportView) {
          val = dfirmSetting.stockReportView;
        }
      }
      return val;
    },
    sales: function sales() {
      var _this2 = this;

      var totalSale = 0;
      var buyers = this.buyers.filter(function (item) {
        return item["brand"] === _this2.selectedBrand;
      });
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      buyers.map(function (buyer) {
        var sales = _this2.invoices.filter(function (item) {
          return item['brand'] === _this2.selectedBrand && item['buyerId'] == buyer['.key'] && item.date >= _this2.finYear.start && item.date <= _this2.finYear.end && item.deleted != true && (_this2.selectedFirm ? item['firm'] === _this2.selectedFirm['.key'] : true) && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true);
        });
        sales.map(function (inv) {
          totalSale += inv.totalAmount ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount) : 0;
        });
      });
      totalSale = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(totalSale).toFixed(2);
      return totalSale;
    },
    purchase: function purchase() {
      var _this3 = this;

      var totalPurchase = 0;
      var sellers = this.sellers.filter(function (item) {
        return item["brand"] === _this3.selectedBrand;
      });
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      sellers.map(function (buyer) {
        var purchase = _this3.invoices.filter(function (item) {
          return item['brand'] === _this3.selectedBrand && item.date >= _this3.finYear.start && item.date <= _this3.finYear.end && item.deleted != true && item['buyerId'] == buyer['.key'] && (_this3.selectedFirm ? item['firm'] === _this3.selectedFirm['.key'] : true) && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true);
        });
        purchase.map(function (inv) {
          totalPurchase += inv.totalAmount ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount) : 0;
        });
      });
      totalPurchase = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(totalPurchase).toFixed(2);
      return totalPurchase;
    },

    // current brands firm list
    firmsByBrand1: function firmsByBrand1() {
      var _this4 = this;

      // return selected brand firms
      return this.firms.filter(function (item) {
        return item['brand'] === _this4.selectedBrand;
      });
    },
    firmsByBrand: function firmsByBrand() {
      var _this5 = this;

      // return selected brand firms
      var firmsB = this.firms.filter(function (item) {
        return item['brand'] === _this5.selectedBrand;
      });
      firmsB.map(function (item) {
        if (item.defaultFirm) {
          _this5.selectedFirm = item;
          _this5.isJwelleryBussiness = item.businessType == "Jwellery";
        }
      });
      return firmsB;
    },
    groupExpensesOfTradingAccount: function groupExpensesOfTradingAccount() {
      var _this6 = this;

      this.expenseTotal = 0;
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var expenses = this.expenses.filter(function (expense) {
        return expense.brand === _this6.selectedBrand && expense.underHead === 'Profit and Loss' && expense.category === "Direct";
      });
      expenses = expenses.filter(function (expense) {
        return !!expense['.key'];
      });
      expenses.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = 'confirm';
        var invoices = _this6.invoices.filter(function (invoice) {
          return invoice.brand === _this6.selectedBrand && invoice["expenseType"] === ex['.key'] && invoice.date >= _this6.finYear.start && invoice.date <= _this6.finYear.end && invoice.deleted != true && (_this6.selectedFirm ? invoice['firm'] === _this6.selectedFirm['.key'] : true) && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true);
        });
        invoices.map(function (inv) {
          openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
          totalAmount += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          if (paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        expenses[index]['invoices'] = invoices;
        expenses[index].paymentTypeStatus = paymentTypeStatus;
        expenses[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        expenses[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        _this6.expenseTotal += (isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(openingBalance)) + (isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(totalAmount));
      });
      this.expenseTotal = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.expenseTotal).toFixed(2);
      return expenses;
    },
    groupIncomesOfTradingAccount: function groupIncomesOfTradingAccount() {
      var _this7 = this;

      this.incomeTotal = 0;
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var incomes = this.incomes.filter(function (income) {
        return income.brand === _this7.selectedBrand && income.underHead === 'Profit and Loss' && income.category === "Direct";
      });
      incomes = incomes.filter(function (income) {
        return !!income['.key'];
      });
      incomes.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = 'confirm';
        var invoices = _this7.invoices.filter(function (invoice) {
          return invoice.brand === _this7.selectedBrand && invoice["incomeType"] === ex['.key'] && invoice.date >= _this7.finYear.start && invoice.date <= _this7.finYear.end && invoice.deleted != true && (_this7.selectedFirm ? invoice['firm'] === _this7.selectedFirm['.key'] : true) && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true);
        });
        invoices.map(function (inv) {
          openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
          totalAmount += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          if (paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        incomes[index]['invoices'] = invoices;
        incomes[index].paymentTypeStatus = paymentTypeStatus;
        incomes[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        incomes[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        _this7.incomeTotal += (isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(openingBalance)) + (isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(totalAmount));
      });
      this.incomeTotal = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.incomeTotal).toFixed(2);
      return incomes;
    },
    groupExpensesOfPandL: function groupExpensesOfPandL() {
      var _this8 = this;

      this.pandlexpenseTotal = 0;
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var expenses = this.expenses.filter(function (expense) {
        return expense.brand === _this8.selectedBrand && expense.underHead === 'Profit and Loss' && expense.category === 'Indirect';
      });
      expenses = expenses.filter(function (expense) {
        return !!expense['.key'];
      });
      expenses.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = 'confirm';
        var invoices = _this8.invoices.filter(function (invoice) {
          return invoice.brand === _this8.selectedBrand && invoice["expenseType"] === ex['.key'] && invoice.date >= _this8.finYear.start && invoice.date <= _this8.finYear.end && invoice.deleted != true && (_this8.selectedFirm ? invoice['firm'] === _this8.selectedFirm['.key'] : true) && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true);
        });
        invoices.map(function (inv) {
          openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
          totalAmount += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          if (paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        expenses[index]['invoices'] = invoices;
        expenses[index].paymentTypeStatus = paymentTypeStatus;
        expenses[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        expenses[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        _this8.pandlexpenseTotal += (isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(openingBalance)) + (isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(totalAmount));
      });
      this.pandlexpenseTotal = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.pandlexpenseTotal).toFixed(2);
      return expenses;
    },
    getStaffAccount: function getStaffAccount() {
      var _this9 = this;

      this.totalSalary = 0;
      if (this.selectedBrand) {
        var staffList = this.staff.filter(function (item) {
          return item['brand'] === _this9.selectedBrand && (_this9.selectedFirm ? item['firm'] === _this9.selectedFirm['.key'] : true);
        });
        var result = staffList.map(function (e) {
          var salaryList = _.filter(_this9.salarys, { 'staffId': e['.key'] });
          e.salaryList = salaryList;
          var creditTotal = _.sumBy(salaryList, function (s) {
            if (s.isCredited) return s.amount;
          });

          e.creditTotal = creditTotal ? creditTotal : 0;

          var debitTotal = _.sumBy(salaryList, function (s) {
            if (!s.isCredited) return s.amount;
          });

          e.debitTotal = debitTotal ? debitTotal : 0;

          _this9.totalSalary = _this9.totalSalary + (parseInt(e.creditTotal) - parseInt(e.debitTotal));
          return e;
        });
        return result;
      }
    },
    assetByBrand: function assetByBrand() {
      var _this10 = this;

      if (this.assets) {
        this.totalAsset = 0;
        var selectedAssets = this.assets.filter(function (asset) {
          return asset.brand === _this10.selectedBrand && asset['category'] != 'personal' && asset['depriciation'];
        });
        selectedAssets.map(function (ast, index) {
          var firmAsset = _this10.invoices.filter(function (item) {
            return item['assetType'] === ast['.key'] && item['brand'] === _this10.selectedBrand && item.date >= _this10.finYear.start && item.date <= _this10.finYear.end && (_this10.selectedFirm ? item['firm'] == _this10.selectedFirm['.key'] : true);
          });
          console.log(firmAsset);
          var openingBalance = 0;
          var totalAmount = 0;
          firmAsset.map(function (inv) {
            openingBalance += inv.openingBalance ? parseInt(inv.openingBalance) : 0;
            totalAmount += inv.totalAmount ? parseInt(inv.totalAmount) : 0;
          });
          selectedAssets[index]['openingBalance'] = openingBalance;
          selectedAssets[index]['totalAmount'] = totalAmount;
          selectedAssets[index]['depAmount'] = _this10.getDepAmount(ast, ast.type);
          if (ast.category === 'b&p') {
            selectedAssets[index]['depAmount'] = selectedAssets[index]['depAmount'] / 2;
          }
          _this10.totalAsset += selectedAssets[index]['depAmount'];
        });
        return selectedAssets;
      }
      return [];
    },
    groupIncomes: function groupIncomes() {
      var _this11 = this;

      this.pandlincomeTotal = 0;
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var incomes = this.incomes.filter(function (income) {
        return income.brand === _this11.selectedBrand && income.underHead === 'Profit and Loss' && income.category === "Indirect";
      });
      incomes = incomes.filter(function (income) {
        return !!income['.key'];
      });
      incomes.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = 'confirm';
        var invoices = _this11.invoices.filter(function (invoice) {
          return invoice.brand === _this11.selectedBrand && invoice["incomeType"] === ex['.key'] && (_this11.selectedFirm ? invoice['firm'] === _this11.selectedFirm['.key'] : true) && invoice.date >= _this11.finYear.start && invoice.date <= _this11.finYear.end && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true);
        });
        invoices.map(function (inv) {
          openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
          totalAmount += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          if (paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        incomes[index]['invoices'] = invoices;
        incomes[index].paymentTypeStatus = paymentTypeStatus;
        incomes[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        incomes[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        _this11.pandlincomeTotal += (isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(openingBalance)) + (isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(totalAmount));
      });
      this.pandlincomeTotal = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.pandlincomeTotal).toFixed(2);
      return incomes;
    },

    // groupIncomes(){
    //      const mainGroup = [] // { details: {} && invoices: []}
    //   try {
    //     this.incomesByBrand.forEach(details => {
    //       const invoices = this.invoiceByBrand.filter(invoice => {
    //         return invoice.incomeType === details['.key'];
    //       })
    //       details.totalAmount = invoices.reduce((total, item) => {
    //         return total + item.totalAmount  
    //       }, 0)
    //       details.openingBalance = invoices.reduce((total, item) => {
    //         return total + item.openingBalance  
    //       }, 0)
    //       if(details.totalAmount) {
    //         mainGroup.push({
    //           details,
    //           invoices
    //         }) 
    //       }
    //       else if(details.openingBalance) {
    //         mainGroup.push({
    //           details,
    //           invoices
    //         }) 
    //       }
    //     })
    //     return mainGroup
    //   } catch(e) {
    //     console.info(e)
    //     return []
    //   }
    // },
    totalIncomesAmount: function totalIncomesAmount() {
      return this.groupIncomes.reduce(function (total, item) {
        return item.details.totalAmount + total;
      }, 0);
    },
    incomesByBrand: function incomesByBrand() {
      var _this12 = this;

      var income = this.incomes.filter(function (income) {
        return income.brand === _this12.selectedBrand && income.underHead === 'Profit and Loss';
      });
      return income;
    },
    incomeInvoices: function incomeInvoices() {
      return this.invoiceByBrand.filter(function (invoice) {
        return !!invoice.incomeType;
      });
    },
    totalIncomeAmount: function totalIncomeAmount() {
      return this.creditedInvoiceByBrand.reduce(function (total, item) {
        // calculate total Income for expense
        return total + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item['profit'] || 0);
      }, 0);
    },
    creditedInvoiceByBrand: function creditedInvoiceByBrand() {
      var _this13 = this;

      return this.invoiceByBrand.filter(function (invoice) {
        if (_this13.selectedFirm) {
          return invoice.firm === _this13.selectedFirm['.key'] && invoice.isCredited;
        }
        return invoice.isCredited;
      });
    },
    totalIncomesOpeningBalance: function totalIncomesOpeningBalance() {
      return this.groupIncomes.reduce(function (total, item) {
        return (isNaN(item.details.openingBalance) ? 0 : item.details.openingBalance) + (isNaN(total) ? 0 : total);
      }, 0);
    },
    invoiceByBrand: function invoiceByBrand() {
      var _this14 = this;

      if (!this.invoices) {
        return [];
      };
      var filter = this.invoices.filter(function (item) {
        return item['brand'] === _this14.selectedBrand && item.deleted != true && item.date >= _this14.finYear.start && item.date <= _this14.finYear.end;
      });
      if (this.selectedFirm) {
        filter = filter.filter(function (item) {
          return item.firm === _this14.selectedFirm['.key'];
        });
      }
      if (this.filterInvoiceFrom) {
        var from = new Date(this.filterInvoiceFrom).setHours(0, 0, 0, 0);
        filter = filter.filter(function (item) {
          return item.date >= from;
        });
      }
      if (this.filterInvoiceTo) {
        var to = new Date(this.filterInvoiceTo).setHours(23, 29, 59, 999);
        filter = filter.filter(function (item) {
          return item.date <= to;
        });
      }
      return filter;
    },
    closingStock: function closingStock() {
      var _this15 = this;

      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var products = this.productList.filter(function (item) {
        return item['brand'] === _this15.selectedBrand && (_this15.selectedFirm ? item['firm'] === _this15.selectedFirm['.key'] : true);
      });
      var total = {
        quantity: 0,
        durationQuantity: 0,
        durationAmount: 0,
        saleQuantity: 0,
        durationQtySale: 0,
        durationAmountSale: 0,
        purchaseQuantity: 0,
        durationQtyPurchase: 0,
        durationAmountPurchase: 0,
        openingQuantity: 0,
        openingBalance: 0
      };
      products.map(function (p, index) {
        p["durationQuantity"] = undefined;
        p["durationAmount"] = 0;
        p["durationQtySale"] = 0;
        p["durationQtyPurchase"] = 0;
        p["durationAmountSale"] = 0;
        p["durationAmountPurchase"] = 0;
        p["stockReportData"] = {
          saleDetails: [],
          purchaseDetails: [],
          lastSalePrice: 0,
          lastPurchasePrice: 0
        };
        var prodG = {
          weight: 0,
          openingBalance: 0
        };
        if (_this15.isJwelleryBussiness) {
          if (p.productGroup) {
            prodG = _this15.productGroups.find(function (item) {
              return item[".key"] == p.productGroup;
            });
          }
          products[index]["openingQuantity"] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prodG && prodG.weigh ? prodG.weight : 0);
          products[index]["openingBalance"] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prodG && prodG.openingBalance ? prodG.openingBalance : 0);
        } else {
          products[index]["openingQuantity"] = 0;
          products[index]["openingBalance"] = 0;
        }
        if (p.openingBalance && p.openingQuantity) {
          p["stockReportData"]['purchaseDetails'].push({
            // quantity : Number.parseFloat(p.openingQuantity),
            // rate : Number.parseInt(p.openingBalance),
            quantity: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_int___default()(p.openingQuantity),
            rate: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(p.openingBalance) / __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_int___default()(p.openingQuantity),
            date: p.openingDate
          });
          p["stockReportData"]['lastPurchasePrice'] = p.openingBalance;
        }
        total.openingQuantity += parseInt(p["openingQuantity"] ? p["openingQuantity"] : 0);
        total.openingBalance += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(p["openingBalance"] ? p["openingBalance"] : 0);
      });
      var productGroup = products.reduce(function (r, a) {
        r[a[".key"]] = r[a[".key"]] || [];
        r[a[".key"]].push(a);
        return r;
      }, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(null));
      var latestSaleDate = new Date('01-01-1000').getTime();
      var latestPurchaseDate = new Date('01-01-1000').getTime();
      var filteredInvoices = this.invoices.filter(function (item) {
        return item.type != "automatic invoice" && item.items && item.items.length && item.date >= _this15.finYear.start && item.deleted != true && item.date <= _this15.finYear.end && (_this15.selectedFirm ? item['firm'] === _this15.selectedFirm['.key'] : true) && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true);
      });
      this.selectProdList = [];
      filteredInvoices.map(function (invoice) {
        var isBuyer = invoice.isBuyer;
        invoice.items && invoice.items.map(function (item) {
          if (productGroup[item["productId"]]) {
            if (productGroup[item["productId"]][0].durationQuantity != undefined) {
              var durationQuantity = parseInt(productGroup[item["productId"]][0]["durationQuantity"]);
              durationQuantity += !!isBuyer ? -parseInt(item.quantity) : parseInt(item.quantity);
              total.durationQuantity += durationQuantity;
              productGroup[item["productId"]][0]["durationQuantity"] = durationQuantity;
            } else {
              productGroup[item["productId"]][0]["durationQuantity"] = productGroup[item["productId"]][0].openingQuantity ? productGroup[item["productId"]][0].openingQuantity : 0;
              total.durationQuantity += parseInt(productGroup[item["productId"]][0]["durationQuantity"]);
            }
            var rate = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.rate);
            if (isBuyer) {
              if (invoice.date > latestSaleDate) {
                latestSaleDate = invoice.date;
                productGroup[item["productId"]][0]['stockReportData']['lastSalePrice'] = rate;
              }
              productGroup[item["productId"]][0]['stockReportData']['saleDetails'].push({
                quantity: item.quantity,
                rate: rate,
                date: invoice.date
              });
            } else {
              if (invoice.date > latestPurchaseDate) {
                latestPurchaseDate = invoice.date;
                productGroup[item["productId"]][0]['stockReportData']['lastPurchasePrice'] = rate;
              }
              productGroup[item["productId"]][0]['stockReportData']['purchaseDetails'].push({
                quantity: item.quantity,
                rate: rate,
                date: invoice.date
              });
            }

            productGroup[item["productId"]][0]["durationAmount"] += !!isBuyer ? -__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.GSTValue) : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
            total.durationAmount += productGroup[item["productId"]][0]["durationAmount"];
            if (!!isBuyer) {
              productGroup[item["productId"]][0]["durationQtySale"] += parseInt(item.quantity);
              total.durationQtySale += parseInt(item.quantity);
              productGroup[item["productId"]][0]["durationAmountSale"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
              total.durationAmountSale += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
            } else {
              productGroup[item["productId"]][0]["durationQtyPurchase"] += parseInt(item.quantity);
              total.durationQtyPurchase += parseInt(item.quantity);
              productGroup[item["productId"]][0]["durationAmountPurchase"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
              total.durationAmountPurchase += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
            }
            item['date'] = invoice.date;
            item['invoice'] = invoice;
            item['isBuyer'] = invoice['isBuyer'];
            item['openingBalance'] = productGroup[item["productId"]][0]['openingBalance'];
            item['openingQuantity'] = productGroup[item["productId"]][0]['openingQuantity'];
            if (!(productGroup[item["productId"]][0]['productList'] && productGroup[item["productId"]][0]['productList'].length)) productGroup[item["productId"]][0]['productList'] = [];

            productGroup[item["productId"]][0]['productList'].push(item);
          }
        });
      });

      this.totalOpeningStock = total.openingBalance;
      var results = [];
      var closingStock = 0;
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(productGroup).length && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(productGroup).map(function (key, index) {
        productGroup[key][".key"] = key;
        results.push(productGroup[key][0]);
        // productGroup[key][0]['closingAmount'] = this.getClosingAmount(productGroup[key][0]);
        var temp = _this15.getClosingAmount(productGroup[key][0]);
        productGroup[key][0]['closingAmount'] = isNaN(temp) ? 0 : temp;
        closingStock += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(productGroup[key][0]['closingAmount']);
      });
      console.log(closingStock);
      if (this.isJwelleryBussiness) {
        var _products = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], results);
        var groups = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.productGroups));
        groups.push({
          name: "Non group Products",
          ".key": "Nongroup",
          quantity: 0,
          durationQuantity: 0,
          durationAmount: 0,
          saleQuantity: 0,
          durationQtySale: 0,
          durationAmountSale: 0,
          purchaseQuantity: 0,
          durationQtyPurchase: 0,
          durationAmountPurchase: 0,
          openingQuantity: 0,
          openingBalance: 0,
          closingAmount: 0,
          closingQuantity: 0
        });
        groups.map(function (item, index) {
          groups[index]["productList"] = [];
          groups[index]["quantity"] = 0;
          groups[index]["durationQuantity"] = 0;
          groups[index]["durationAmount"] = 0;
          groups[index]["saleQuantity"] = 0;
          groups[index]["durationQtySale"] = 0;
          groups[index]["durationAmountSale"] = 0;
          groups[index]["purchaseQuantity"] = 0;
          groups[index]["durationQtyPurchase"] = 0;
          groups[index]["durationAmountPurchase"] = 0;
          groups[index]['openingQuantity'] = item.weight;
          groups[index]['openingBalance'] = item.openingBalance;

          groups[index]["closingAmount"] = 0;
          groups[index]["closingQuantity"] = 0;
        });
        groups.map(function (item, index) {
          _products.map(function (prod) {
            if (prod.productGroup && prod.productGroup == item[".key"]) {
              groups[index]["productList"] = groups[index]["productList"].concat(prod.productList);
              groups[index]["quantity"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["quantity"]);
              groups[index]["durationQuantity"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationQuantity"]);
              groups[index]["durationAmount"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationAmount"]);
              groups[index]["saleQuantity"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["saleQuantity"]);
              groups[index]["durationQtySale"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationQtySale"]);
              groups[index]["durationAmountSale"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationAmountSale"]);
              groups[index]["purchaseQuantity"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["purchaseQuantity"]);
              groups[index]["durationQtyPurchase"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationQtyPurchase"]);
              groups[index]["durationAmountPurchase"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationAmountPurchase"]);
              // groups[index]["openingQuantity"] += Number.parseFloat(
              //   prod["openingQuantity"]
              // );
              // groups[index]["openingBalance"] += Number.parseFloat(
              //   prod["openingBalance"]
              // );
              groups[index]["closingAmount"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["closingAmount"]);
              groups[index]["closingQuantity"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["closingQuantity"]);
            } else if (!prod.productGroup && item[".key"] == "Nongroup") {
              groups[index]["productList"] = groups[index]["productList"].concat(prod.productList);
              groups[index]["quantity"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["quantity"]);
              groups[index]["durationQuantity"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationQuantity"]);
              groups[index]["durationAmount"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationAmount"]);
              groups[index]["saleQuantity"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["saleQuantity"]);
              groups[index]["durationQtySale"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationQtySale"]);
              groups[index]["durationAmountSale"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationAmountSale"]);
              groups[index]["purchaseQuantity"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["purchaseQuantity"]);
              groups[index]["durationQtyPurchase"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationQtyPurchase"]);
              groups[index]["durationAmountPurchase"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationAmountPurchase"]);
              groups[index]["openingQuantity"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["openingQuantity"]);
              groups[index]["openingBalance"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["openingBalance"]);
              groups[index]["closingAmount"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["closingAmount"]);
              groups[index]["closingQuantity"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["closingQuantity"]);
            }
          });
        });
        //groups.push(total);
        groups.map(function (prod, index) {
          groups[index]["closingAmount"] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["openingBalance"]) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationAmountPurchase"]) - __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationAmountSale"]);
          groups[index]["closingQuantity"] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["openingQuantity"]) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationQtyPurchase"]) - __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationQtySale"]);
        });

        closingStock = 0;
        var openingBalance = 0;
        groups.map(function (prod, index) {
          groups[index]['quantity'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['quantity']).toFixed(3);
          groups[index]['durationQuantity'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['durationQuantity']).toFixed(3);
          groups[index]['durationAmount'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['durationAmount']).toFixed(3);
          groups[index]['saleQuantity'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['saleQuantity']).toFixed(3);
          groups[index]['durationQtySale'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['durationQtySale']).toFixed(3);
          groups[index]['durationAmountSale'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['durationAmountSale']).toFixed(3);
          groups[index]['purchaseQuantity'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['purchaseQuantity']).toFixed(3);
          groups[index]['durationQtyPurchase'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['durationQtyPurchase']).toFixed(3);
          groups[index]['durationAmountPurchase'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['durationAmountPurchase']).toFixed(3);
          groups[index]['openingQuantity'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['openingQuantity']).toFixed(3);
          groups[index]['openingBalance'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['openingBalance']).toFixed(3);
          groups[index]['closingAmount'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['closingAmount']).toFixed(3);
          groups[index]['closingQuantity'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['closingQuantity']).toFixed(3);
          closingStock += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['closingAmount']);
          openingBalance += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['openingBalance']);
        });
        closingStock = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(closingStock).toFixed(3);
        this.totalOpeningStockWeight = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(3);
      }
      console.log(closingStock);
      return closingStock;
    },

    // grossProfit(){
    //   let profit = (
    //     ( Number.parseFloat(this.sales) + 
    //     Number.parseFloat(this.incomeTotal) + 
    //     Number.parseFloat(this.closingStock))
    //   - ((this.selectedFirm ? (Number.parseFloat(this.selectedFirm.openingStock) || 0) : 0) + 
    //     Number.parseFloat(this.purchase) +  
    //     Number.parseFloat(this.expenseTotal))
    //   ); 
    //   profit = Number.parseFloat(profit).toFixed(2);
    //   return profit;
    // },
    grossProfit: function grossProfit() {
      var profit = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.sales) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.incomeTotal) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.isJwelleryBussiness ? this.closingStock : this.closingStock) - ((this.selectedFirm ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.selectedFirm.openingStock) || 0 : 0) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.isJwelleryBussiness ? this.totalOpeningStockWeight : this.totalOpeningStock) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.purchase) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.expenseTotal));
      profit = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(profit).toFixed(2);
      return profit;
    },
    netProfit: function netProfit() {
      var netprofit = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.pandlincomeTotal) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.grossProfit) - (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.totalSalary) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.totalAsset) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.pandlexpenseTotal));
      netprofit = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(netprofit).toFixed(2);
      return netprofit;
    }
  }),
  watch: {
    selectedFirm: {
      handler: function handler(newVal, oldVal) {
        if (newVal != oldVal) {
          this.assetByBrand;
        }
      },

      deep: true
    }
  },
  methods: {
    getClosingAmount: function getClosingAmount(item) {
      var closingQty = parseInt(item['openingQuantity'] ? item['openingQuantity'] : 0) + parseInt(item['durationQtyPurchase'] ? item['durationQtyPurchase'] : 0) - parseInt(item['durationQtySale'] ? item['durationQtySale'] : 0);
      switch (this.firmStockReportType) {

        case 'APP':
          {
            var amount = 0;
            if (item.stockReportData) {
              var avgPurchasePrice = item.stockReportData.purchaseDetails.reduce(function (a, b) {
                return a + (b['rate'] || 0);
              }, 0) / item.stockReportData.purchaseDetails.length;
              amount = avgPurchasePrice * closingQty;
            }
            return amount;
          }
        case 'LPP':
          {
            var _amount = 0;
            if (item.stockReportData) {
              _amount = item.stockReportData.lastPurchasePrice * closingQty;
            }
            return _amount;
          }
        case 'LSP':
          {
            var _amount2 = 0;
            if (item.stockReportData) {
              _amount2 = item.stockReportData.lastSalePrice * closingQty;
            }
            return _amount2;
          }
        case 'ASP':
          {
            var _amount3 = 0;
            if (item.stockReportData) {
              var avgSalePrice = item.stockReportData.saleDetails.reduce(function (a, b) {
                return a + (b['rate'] || 0);
              }, 0) / item.stockReportData.saleDetails.length;
              _amount3 = avgSalePrice * closingQty;
            }
            return _amount3;
          }
        case 'FIFO':
          {
            var _amount4 = 0;
            if (item.stockReportData) {
              var allTransaction = item.stockReportData.purchaseDetails.sort(function (a, b) {
                return -(new Date(b.date) - new Date(a.date));
              });

              var qntTemp = closingQty;
              allTransaction.map(function (t) {
                if (qntTemp > t.quantity) {
                  _amount4 += t.quantity * t.rate;
                  qntTemp = qntTemp - t.quantity;
                } else if (qntTemp > 0) {
                  _amount4 += t.quantity - qntTemp * t.rate;
                  qntTemp = 0;
                }
              });
            }
            return _amount4;
          }
        case 'LIFO':
          {
            var _amount5 = 0;
            if (item.stockReportData) {
              var _allTransaction = item.stockReportData.purchaseDetails.sort(function (a, b) {
                return new Date(b.date) - new Date(a.date);
              });
              var _qntTemp = closingQty;
              _allTransaction.map(function (t) {
                if (_qntTemp > t.quantity) {
                  _amount5 += t.quantity * t.rate;
                  _qntTemp = _qntTemp - t.quantity;
                } else if (_qntTemp > 0) {
                  _amount5 += t.quantity - _qntTemp * t.rate;
                  _qntTemp = 0;
                }
              });
            }
            return _amount5;
          }
      }
    },
    print: function print() {
      var data = [];
      $(".print-field").each(function (index) {
        data.push($(this).text());
      });
      var doc = Object(__WEBPACK_IMPORTED_MODULE_9__utils_pdf_reports_information_reports__["c" /* convertToPDFProfitAndLoss */])({ data: data });
      pdfMake.createPdf(doc).download();
    },
    getFirmName: function getFirmName(e) {
      var firm = void 0;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter(function (item) {
          return item['.key'] === e;
        })[0];
      }
      if (firm) return firm.name;
    },
    getDepAmount: function getDepAmount(asset, type) {
      var depriciation = null;
      if (asset.isVerified && asset.depriciation) {
        var totalAmount = this.getTotalAmount(asset);
        depriciation = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(totalAmount * asset.depriciation / 100);
        return depriciation;
      }
      return 0;
    },
    getTotalAmount: function getTotalAmount(asset) {
      if (asset.isVerified) {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(asset.openingBalance || 0) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(asset.totalAdditionAmount) - __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(asset.totalDeletionAmount);
      }
      return Number(asset.totalAdditionAmount) - Number(asset.totalDeletionAmount);
    }
  }
});

/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Balancesheet_expandCard__ = __webpack_require__(36);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ExpandCard: __WEBPACK_IMPORTED_MODULE_3__Balancesheet_expandCard__["a" /* default */]
  },
  data: function data() {
    return {
      propAccount: [{
        expense: true
      }, {
        expense: false
      }],
      expenseTotal: 0,
      pandlexpenseTotal: 0,
      propexpenseTotal: 0,
      incomeTotal: 0,
      pandlincomeTotal: 0,
      propincomeTotal: 0,
      selectedFirm: null,
      filterInvoiceFrom: null,
      filterInvoiceTo: null,
      fromdatepicker: false,
      todatepicker: false,
      totalSalary: 0,
      totalAsset: 0,
      proptotalAsset: 0,
      searchInput: null,
      selectedStaff: {},
      salaryListHeaders: [{ text: 'Date', value: 'date', sortable: true }, { text: 'Credit/Debit', value: 'amount', sortable: false }],
      sale: {
        total: 0,
        list: [],
        expand: false
      }
    };
  },
  created: function created() {
    this.$bindAsArray('invoices', this.$root.$firebaseRefs.invoice.orderByChild('brandFinYear').equalTo(this.brandFinYear));
    this.$bindAsArray('expenses', this.$root.$firebaseRefs.expenses);
    this.$bindAsArray('firms', this.$root.$firebaseRefs.firm);
    this.$bindAsArray("buyers", this.$root.$firebaseRefs.buyer);
    this.$bindAsArray("sellers", this.$root.$firebaseRefs.seller);
    this.$bindAsArray('incomes', this.$root.$firebaseRefs.incomes);
    this.$bindAsArray('salarys', this.$root.$firebaseRefs.salarys);
    this.$bindAsArray('staff', this.$root.$firebaseRefs.staff);
    this.$bindAsArray('assets', this.$root.$firebaseRefs.assets);
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand', 'brandFinYear']), {
    //   selectedFirmDetail() {
    //     if(!this.selectedFirm) { return null }
    //     return this.firms.find(item => item['.key'] === this.selectedFirm)
    //   },
    sales: function sales() {
      var _this = this;

      var totalSale = 0;
      var buyers = this.buyers.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      });
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      buyers.map(function (buyer) {
        var sales = _this.invoices.filter(function (item) {
          return item['brand'] === _this.selectedBrand && item['buyerId'] == buyer['.key'] && (_this.selectedFirm ? item['firm'] === _this.selectedFirm['.key'] : true) && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true);
        });
        sales.map(function (inv) {
          totalSale += inv.totalAmount ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount) : 0;
        });
      });
      totalSale = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(totalSale).toFixed(2);
      return totalSale;
    },
    purchase: function purchase() {
      var _this2 = this;

      var totalPurchase = 0;
      var sellers = this.sellers.filter(function (item) {
        return item["brand"] === _this2.selectedBrand;
      });
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      sellers.map(function (buyer) {
        var purchase = _this2.invoices.filter(function (item) {
          return item['brand'] === _this2.selectedBrand && item['buyerId'] == buyer['.key'] && (_this2.selectedFirm ? item['firm'] === _this2.selectedFirm['.key'] : true) && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true);
        });
        purchase.map(function (inv) {
          totalPurchase += inv.totalAmount ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount) : 0;
        });
      });
      totalPurchase = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(totalPurchase).toFixed(2);
      return totalPurchase;
    },

    // current brands firm list
    firmsByBrand: function firmsByBrand() {
      var _this3 = this;

      // return selected brand firms
      return this.firms.filter(function (item) {
        return item['brand'] === _this3.selectedBrand;
      });
    },
    groupExpensesOfTradingAccount: function groupExpensesOfTradingAccount() {
      var _this4 = this;

      this.expenseTotal = 0;
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var expenses = this.expenses.filter(function (expense) {
        return expense.brand === _this4.selectedBrand;
      });
      expenses = expenses.filter(function (expense) {
        return !!expense['.key'];
      });
      expenses.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = 'confirm';
        var invoices = _this4.invoices.filter(function (invoice) {
          return invoice.brand === _this4.selectedBrand && invoice["expenseType"] === ex['.key'] && (_this4.selectedFirm ? invoice['firm'] === _this4.selectedFirm['.key'] : true) && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true);
        });
        invoices.map(function (inv) {
          openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
          totalAmount += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          if (paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        expenses[index]['invoices'] = invoices;
        expenses[index].paymentTypeStatus = paymentTypeStatus;
        expenses[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        expenses[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        _this4.expenseTotal += (isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(openingBalance)) + (isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(totalAmount));
      });
      this.expenseTotal = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.expenseTotal).toFixed(2);
      return expenses;
    },
    groupIncomesOfTradingAccount: function groupIncomesOfTradingAccount() {
      var _this5 = this;

      this.incomeTotal = 0;
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var incomes = this.incomes.filter(function (income) {
        return income.brand === _this5.selectedBrand;
      });
      incomes = incomes.filter(function (income) {
        return !!income['.key'];
      });
      incomes.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = 'confirm';
        var invoices = _this5.invoices.filter(function (invoice) {
          return invoice.brand === _this5.selectedBrand && invoice["incomeType"] === ex['.key'] && (_this5.selectedFirm ? invoice['firm'] === _this5.selectedFirm['.key'] : true) && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true);
        });
        invoices.map(function (inv) {
          openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
          totalAmount += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          if (paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        incomes[index]['invoices'] = invoices;
        incomes[index].paymentTypeStatus = paymentTypeStatus;
        incomes[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        incomes[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        _this5.incomeTotal += (isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(openingBalance)) + (isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(totalAmount));
      });
      this.incomeTotal = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.incomeTotal).toFixed(2);
      return incomes;
    },
    groupExpensesOfPandL: function groupExpensesOfPandL() {
      var _this6 = this;

      this.pandlexpenseTotal = 0;
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var expenses = this.expenses.filter(function (expense) {
        return expense.brand === _this6.selectedBrand && expense.underHead === 'Profit and Loss';
      });
      expenses = expenses.filter(function (expense) {
        return !!expense['.key'];
      });
      expenses.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = 'confirm';
        var invoices = _this6.invoices.filter(function (invoice) {
          return invoice.brand === _this6.selectedBrand && invoice["expenseType"] === ex['.key'] && (_this6.selectedFirm ? invoice['firm'] === _this6.selectedFirm['.key'] : true) && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true);
        });
        invoices.map(function (inv) {
          openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
          totalAmount += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          if (paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        expenses[index]['invoices'] = invoices;
        expenses[index].paymentTypeStatus = paymentTypeStatus;
        expenses[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        expenses[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        _this6.pandlexpenseTotal += (isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(openingBalance)) + (isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(totalAmount));
      });
      this.pandlexpenseTotal = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.pandlexpenseTotal).toFixed(2);
      return expenses;
    },
    getStaffAccount: function getStaffAccount() {
      var _this7 = this;

      this.totalSalary = 0;
      if (this.selectedBrand) {
        var staffList = this.staff.filter(function (item) {
          return item['brand'] === _this7.selectedBrand && (_this7.selectedFirm ? item['firm'] === _this7.selectedFirm['.key'] : true);
        });
        var result = staffList.map(function (e) {
          var salaryList = _.filter(_this7.salarys, { 'staffId': e['.key'] });
          e.salaryList = salaryList;
          var creditTotal = _.sumBy(salaryList, function (s) {
            if (s.isCredited) return s.amount;
          });

          e.creditTotal = creditTotal ? creditTotal : 0;

          var debitTotal = _.sumBy(salaryList, function (s) {
            if (!s.isCredited) return s.amount;
          });

          e.debitTotal = debitTotal ? debitTotal : 0;

          _this7.totalSalary = _this7.totalSalary + (parseInt(e.creditTotal) - parseInt(e.debitTotal));
          return e;
        });
        console.log(result, null, 4);
        return result;
      }
    },
    assetByBrand: function assetByBrand() {
      var _this8 = this;

      if (this.assets) {
        this.totalAsset = 0;
        var selectedAssets = this.assets.filter(function (asset) {
          return asset.brand === _this8.selectedBrand && asset['category'] != 'personal' && asset['depriciation'];
        });
        selectedAssets.map(function (ast, index) {
          var firmAsset = _this8.invoices.filter(function (item) {
            return item['assetType'] === ast['.key'] && item['brand'] === _this8.selectedBrand && (_this8.selectedFirm ? ast.firm === _this8.selectedFirm['.key'] : true);
          });
          var openingBalance = 0;
          firmAsset.map(function (inv) {
            openingBalance += inv.openingBalance ? parseInt(inv.openingBalance) : 0;
          });
          selectedAssets[index]['openingBalance'] = openingBalance;
          selectedAssets[index]['depAmount'] = _this8.getDepAmount(ast, ast.type);
          if (ast.category === 'b&p') {
            selectedAssets[index]['depAmount'] = selectedAssets[index]['depAmount'] / 2;
          }
          _this8.totalAsset += selectedAssets[index]['depAmount'];
        });
        return selectedAssets;
      }
      return [];
    },
    propassetByBrand: function propassetByBrand() {
      var _this9 = this;

      if (this.assets) {
        this.proptotalAsset = 0;
        var selectedAssets = this.assets.filter(function (asset) {
          return asset.brand === _this9.selectedBrand && asset['category'] != 'business' && asset['depriciation'];
        });
        selectedAssets.map(function (ast, index) {
          var firmAsset = _this9.invoices.filter(function (item) {
            return item['assetType'] === ast['.key'] && item['brand'] === _this9.selectedBrand && (_this9.selectedFirm ? ast['firm'] === _this9.selectedFirm : true);
          });
          var openingBalance = 0;
          firmAsset.map(function (inv) {
            openingBalance += inv.openingBalance ? parseInt(inv.openingBalance) : 0;
          });
          selectedAssets[index]['openingBalance'] = openingBalance;
          selectedAssets[index]['depAmount'] = _this9.getDepAmount(ast, ast.type);
          if (ast.category === 'b&p') {
            selectedAssets[index]['depAmount'] = selectedAssets[index]['depAmount'] / 2;
          }
          _this9.proptotalAsset += selectedAssets[index]['depAmount'];
        });
        return selectedAssets;
      }
      return [];
    },
    groupIncomes: function groupIncomes() {
      var _this10 = this;

      this.pandlincomeTotal = 0;
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var incomes = this.incomes.filter(function (income) {
        return income.brand === _this10.selectedBrand && income.underHead === 'Profit and Loss';
      });
      incomes = incomes.filter(function (income) {
        return !!income['.key'];
      });
      incomes.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = 'confirm';
        var invoices = _this10.invoices.filter(function (invoice) {
          return invoice.brand === _this10.selectedBrand && invoice["incomeType"] === ex['.key'] && (_this10.selectedFirm ? invoice['firm'] === _this10.selectedFirm['.key'] : true) && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true);
        });
        invoices.map(function (inv) {
          openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
          totalAmount += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          if (paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        incomes[index]['invoices'] = invoices;
        incomes[index].paymentTypeStatus = paymentTypeStatus;
        incomes[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        incomes[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        _this10.pandlincomeTotal += (isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(openingBalance)) + (isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(totalAmount));
      });
      this.pandlincomeTotal = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.pandlincomeTotal).toFixed(2);
      return incomes;
    },
    groupExpensesOfPropCapital: function groupExpensesOfPropCapital() {
      var _this11 = this;

      this.propexpenseTotal = 0;
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var expenses = this.expenses.filter(function (expense) {
        return expense.brand === _this11.selectedBrand && expense.underHead === 'Prop Capital A/C';
      });
      expenses = expenses.filter(function (expense) {
        return !!expense['.key'];
      });
      expenses.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = 'confirm';
        var invoices = _this11.invoices.filter(function (invoice) {
          return invoice.brand === _this11.selectedBrand && invoice["expenseType"] === ex['.key'] && (_this11.selectedFirm ? invoice['firm'] === _this11.selectedFirm['.key'] : true) && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true);
        });
        invoices.map(function (inv) {
          openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
          totalAmount += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          if (paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        expenses[index]['invoices'] = invoices;
        expenses[index].paymentTypeStatus = paymentTypeStatus;
        expenses[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        expenses[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        _this11.propexpenseTotal += (isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(openingBalance)) + (isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(totalAmount));
      });
      this.propexpenseTotal = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.propexpenseTotal).toFixed(2);
      return expenses;
    },
    groupIncomesOfPropCapital: function groupIncomesOfPropCapital() {
      var _this12 = this;

      this.propincomeTotal = 0;
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var incomes = this.incomes.filter(function (income) {
        return income.brand === _this12.selectedBrand && income.underHead === 'Prop Capital A/C';
      });
      incomes = incomes.filter(function (income) {
        return !!income['.key'];
      });
      incomes.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = 'confirm';
        var invoices = _this12.invoices.filter(function (invoice) {
          return invoice.brand === _this12.selectedBrand && invoice["incomeType"] === ex['.key'] && (_this12.selectedFirm ? invoice['firm'] === _this12.selectedFirm['.key'] : true) && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true);
        });
        invoices.map(function (inv) {
          openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
          totalAmount += __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          if (paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        incomes[index]['invoices'] = invoices;
        incomes[index].paymentTypeStatus = paymentTypeStatus;
        incomes[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        incomes[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        _this12.propincomeTotal += (isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(openingBalance)) + (isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(totalAmount));
      });
      this.propincomeTotal = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.propincomeTotal).toFixed(2);
      return incomes;
    },

    // groupIncomes(){
    //      const mainGroup = [] // { details: {} && invoices: []}
    //   try {
    //     this.incomesByBrand.forEach(details => {
    //       const invoices = this.invoiceByBrand.filter(invoice => {
    //         return invoice.incomeType === details['.key'];
    //       })
    //       details.totalAmount = invoices.reduce((total, item) => {
    //         return total + item.totalAmount  
    //       }, 0)
    //       details.openingBalance = invoices.reduce((total, item) => {
    //         return total + item.openingBalance  
    //       }, 0)
    //       if(details.totalAmount) {
    //         mainGroup.push({
    //           details,
    //           invoices
    //         }) 
    //       }
    //       else if(details.openingBalance) {
    //         mainGroup.push({
    //           details,
    //           invoices
    //         }) 
    //       }
    //     })
    //     return mainGroup
    //   } catch(e) {
    //     console.info(e)
    //     return []
    //   }
    // },
    totalIncomesAmount: function totalIncomesAmount() {
      return this.groupIncomes.reduce(function (total, item) {
        return item.details.totalAmount + total;
      }, 0);
    },
    incomesByBrand: function incomesByBrand() {
      var _this13 = this;

      var income = this.incomes.filter(function (income) {
        return income.brand === _this13.selectedBrand && income.underHead === 'Profit and Loss';
      });
      return income;
    },
    incomeInvoices: function incomeInvoices() {
      return this.invoiceByBrand.filter(function (invoice) {
        return !!invoice.incomeType;
      });
    },
    totalIncomeAmount: function totalIncomeAmount() {
      return this.creditedInvoiceByBrand.reduce(function (total, item) {
        // calculate total Income for expense
        return total + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item['profit'] || 0);
      }, 0);
    },
    creditedInvoiceByBrand: function creditedInvoiceByBrand() {
      var _this14 = this;

      return this.invoiceByBrand.filter(function (invoice) {
        if (_this14.selectedFirm) {
          return invoice.firm === _this14.selectedFirm['.key'] && invoice.isCredited;
        }
        return invoice.isCredited;
      });
    },
    totalIncomesOpeningBalance: function totalIncomesOpeningBalance() {
      return this.groupIncomes.reduce(function (total, item) {
        return (isNaN(item.details.openingBalance) ? 0 : item.details.openingBalance) + (isNaN(total) ? 0 : total);
      }, 0);
    },
    invoiceByBrand: function invoiceByBrand() {
      var _this15 = this;

      if (!this.invoices) {
        return [];
      };
      var filter = this.invoices.filter(function (item) {
        return item['brand'] === _this15.selectedBrand;
      });
      if (this.selectedFirm) {
        filter = filter.filter(function (item) {
          return item.firm === _this15.selectedFirm['.key'];
        });
      }
      if (this.filterInvoiceFrom) {
        var from = new Date(this.filterInvoiceFrom).setHours(0, 0, 0, 0);
        filter = filter.filter(function (item) {
          return item.date >= from;
        });
      }
      if (this.filterInvoiceTo) {
        var to = new Date(this.filterInvoiceTo).setHours(23, 29, 59, 999);
        filter = filter.filter(function (item) {
          return item.date <= to;
        });
      }
      return filter;
    },
    closingStock: function closingStock() {
      var closingstock = (this.selectedFirm ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.selectedFirm.openingStock) || 0 : 0) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.purchase || 0 | amount) - __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.sales || 0 | amount);
      closingstock = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(closingstock).toFixed(2);
      return closingstock;
    },
    closingBalance: function closingBalance() {
      var propclosing = (this.selectedFirm ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.selectedFirm.openingBalance) || 0 : 0) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.propincomeTotal) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.netProfit) - (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.proptotalAsset) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.propexpenseTotal));
      propclosing = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(propclosing).toFixed(2);
      return propclosing;
    },
    propAllTotal: function propAllTotal() {
      var propclosing = (this.selectedFirm ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.selectedFirm.openingBalance) || 0 : 0) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.propincomeTotal);
      propclosing = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(propclosing).toFixed(2);
      return propclosing;
    },
    grossProfit: function grossProfit() {
      var profit = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.sales) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.incomeTotal) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.closingStock) - ((this.selectedFirm ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.selectedFirm.openingStock) || 0 : 0) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.purchase) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.expenseTotal));
      profit = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(profit).toFixed(2);
      return profit;
    },
    netProfit: function netProfit() {
      var netprofit = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.pandlincomeTotal) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.grossProfit) - (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.totalSalary) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.totalAsset) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(this.pandlexpenseTotal));
      netprofit = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(netprofit).toFixed(2);
      return netprofit;
    }
  }),
  methods: {
    getFirmName: function getFirmName(e) {
      var firm = void 0;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter(function (item) {
          return item['.key'] === e;
        })[0];
      }
      if (firm) return firm.name;
    },
    getDepAmount: function getDepAmount(asset, type) {
      var depriciation = null;
      if (asset.isVerified && asset.depriciation) {
        var totalAmount = this.getTotalAmount(asset);
        depriciation = Number(totalAmount * asset.depriciation / 100);
        return depriciation;
      }
      return 0;
    },
    getTotalAmount: function getTotalAmount(asset) {
      if (asset.isVerified) {
        return Number(asset.openingBalance || 0) + Number(asset.totalAdditionAmount) - Number(asset.totalDeletionAmount);
      }
      return Number(asset.totalAdditionAmount) - Number(asset.totalDeletionAmount);
    }
  }
});

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_int__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Balancesheet_expandCard__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_pdf_reports_information_reports__ = __webpack_require__(46);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ExpandCard: __WEBPACK_IMPORTED_MODULE_8__Balancesheet_expandCard__["a" /* default */]
  },
  data: function data() {
    return {
      propAccount: [{
        expense: true
      }, {
        expense: false
      }],
      expenseTotal: 0,
      pandlexpenseTotal: 0,
      propexpenseTotal: 0,
      incomeTotal: 0,
      pandlincomeTotal: 0,
      propincomeTotal: 0,
      selectedFirm: null,
      filterInvoiceFrom: null,
      filterInvoiceTo: null,
      fromdatepicker: false,
      todatepicker: false,
      totalSalary: 0,
      pltotalAsset: 0,
      proptotalAsset: 0,
      searchInput: null,
      selectedStaff: {},
      salaryListHeaders: [{ text: 'Date', value: 'date', sortable: true }, { text: 'Credit/Debit', value: 'amount', sortable: false }],
      sale: {
        total: 0,
        list: [],
        expand: false
      },
      isJwelleryBussiness: false
    };
  },
  created: function created() {
    this.$bindAsArray('invoices', this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('expenses', this.$root.$firebaseRefs.expenses.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('firms', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("buyers", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("sellers", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('incomes', this.$root.$firebaseRefs.incomes.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('salarys', this.$root.$firebaseRefs.salarys.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('staff', this.$root.$firebaseRefs.staff.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('assets', this.$root.$firebaseRefs.assets.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("productList", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("firmSettings", this.$root.$firebaseRefs.firmSettings.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("productGroups", this.$root.$firebaseRefs.productGroup.orderByChild("brand").equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand', 'finYear', 'brandFinYear']), {
    //   selectedFirmDetail() {
    //     if(!this.selectedFirm) { return null }
    //     return this.firms.find(item => item['.key'] === this.selectedFirm)
    //   },
    sales: function sales() {
      var _this = this;

      var totalSale = 0;
      var buyers = this.buyers.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      });
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      buyers.map(function (buyer) {
        var sales = _this.invoices.filter(function (item) {
          return item['brand'] === _this.selectedBrand && item.date >= _this.finYear.start && item.date <= _this.finYear.end && item.deleted != true && item['buyerId'] == buyer['.key'] && (_this.selectedFirm ? item['firm'] === _this.selectedFirm['.key'] : true) && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true);
        });
        sales.map(function (inv) {
          totalSale += inv.totalAmount ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount) : 0;
        });
      });
      totalSale = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(totalSale).toFixed(2);
      return totalSale;
    },
    purchase: function purchase() {
      var _this2 = this;

      var totalPurchase = 0;
      var sellers = this.sellers.filter(function (item) {
        return item["brand"] === _this2.selectedBrand;
      });
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      sellers.map(function (buyer) {
        var purchase = _this2.invoices.filter(function (item) {
          return item['brand'] === _this2.selectedBrand && item.date >= _this2.finYear.start && item.date <= _this2.finYear.end && item.deleted != true && item['buyerId'] == buyer['.key'] && (_this2.selectedFirm ? item['firm'] === _this2.selectedFirm['.key'] : true) && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true);
        });
        purchase.map(function (inv) {
          totalPurchase += inv.totalAmount ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount) : 0;
        });
      });
      totalPurchase = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(totalPurchase).toFixed(2);
      return totalPurchase;
    },

    // current brands firm list
    firmsByBrand1: function firmsByBrand1() {
      var _this3 = this;

      // return selected brand firms
      return this.firms.filter(function (item) {
        return item['brand'] === _this3.selectedBrand;
      });
    },
    firmsByBrand: function firmsByBrand() {
      var _this4 = this;

      // return selected brand firms
      var firmsB = this.firms.filter(function (item) {
        return item['brand'] === _this4.selectedBrand;
      });
      firmsB.map(function (item) {
        if (item.defaultFirm) {
          _this4.selectedFirm = item;
          _this4.isJwelleryBussiness = item.businessType == "Jwellery";
        }
      });
      return firmsB;
    },
    groupExpensesOfTradingAccount: function groupExpensesOfTradingAccount() {
      var _this5 = this;

      this.expenseTotal = 0;
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var expenses = this.expenses.filter(function (expense) {
        return expense.brand === _this5.selectedBrand && expense.category === "Direct";
      });
      expenses = expenses.filter(function (expense) {
        return !!expense['.key'];
      });
      expenses.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = 'confirm';
        var invoices = _this5.invoices.filter(function (invoice) {
          return invoice.brand === _this5.selectedBrand && invoice["expenseType"] === ex['.key'] && (_this5.selectedFirm ? invoice['firm'] === _this5.selectedFirm['.key'] : true) && invoice.date >= _this5.finYear.start && invoice.date <= _this5.finYear.end && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true);
        });
        invoices.map(function (inv) {
          openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
          totalAmount += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          if (paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        expenses[index]['invoices'] = invoices;
        expenses[index].paymentTypeStatus = paymentTypeStatus;
        expenses[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        expenses[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        _this5.expenseTotal += (isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(openingBalance)) + (isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(totalAmount));
      });
      this.expenseTotal = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.expenseTotal).toFixed(2);
      return expenses;
    },

    // New Code 09/09/20
    groupExpensesOfCategory: function groupExpensesOfCategory() {
      var _this6 = this;

      var catAmount = 0;
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var expenses = this.expenses.filter(function (expense) {
        return expense.brand === _this6.selectedBrand;
      });
      expenses = expenses.filter(function (expense) {
        return !!expense['.key'];
      });
      expenses.map(function (ex, index) {
        var invoices = _this6.invoices.filter(function (invoice) {
          return invoice.brand === _this6.selectedBrand && invoice["expenseType"] === ex['.key'] && (_this6.selectedFirm ? invoice['firm'] === _this6.selectedFirm['.key'] : true) && invoice.date >= _this6.finYear.start && invoice.date <= _this6.finYear.end && invoice.paymentType == 'capital' && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true);
        });
        console.log(invoices);
        invoices.map(function (inv) {
          catAmount += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
        });
      });
      return catAmount;
    },

    // End of New Code 09/09/20

    groupIncomesOfTradingAccount: function groupIncomesOfTradingAccount() {
      var _this7 = this;

      this.incomeTotal = 0;
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var incomes = this.incomes.filter(function (income) {
        return income.brand === _this7.selectedBrand && income.category === "Direct";
      });
      incomes = incomes.filter(function (income) {
        return !!income['.key'];
      });
      incomes.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = 'confirm';
        var invoices = _this7.invoices.filter(function (invoice) {
          return invoice.brand === _this7.selectedBrand && invoice["incomeType"] === ex['.key'] && (_this7.selectedFirm ? invoice['firm'] === _this7.selectedFirm['.key'] : true) && invoice.date >= _this7.finYear.start && invoice.date <= _this7.finYear.end && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true);
        });
        invoices.map(function (inv) {
          openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
          totalAmount += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          if (paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        incomes[index]['invoices'] = invoices;
        incomes[index].paymentTypeStatus = paymentTypeStatus;
        incomes[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        incomes[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        _this7.incomeTotal += (isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(openingBalance)) + (isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(totalAmount));
      });
      this.incomeTotal = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.incomeTotal).toFixed(2);
      return incomes;
    },
    groupExpensesOfPandL: function groupExpensesOfPandL() {
      var _this8 = this;

      this.pandlexpenseTotal = 0;
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var expenses = this.expenses.filter(function (expense) {
        return expense.brand === _this8.selectedBrand && expense.underHead === 'Profit and Loss' && expense.category === "Indirect";
      });
      expenses = expenses.filter(function (expense) {
        return !!expense['.key'];
      });
      expenses.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = 'confirm';
        var invoices = _this8.invoices.filter(function (invoice) {
          return invoice.brand === _this8.selectedBrand && invoice["expenseType"] === ex['.key'] && (_this8.selectedFirm ? invoice['firm'] === _this8.selectedFirm['.key'] : true) && invoice.date >= _this8.finYear.start && invoice.date <= _this8.finYear.end && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true);
        });
        invoices.map(function (inv) {
          openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
          totalAmount += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          if (paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        expenses[index]['invoices'] = invoices;
        expenses[index].paymentTypeStatus = paymentTypeStatus;
        expenses[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        expenses[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        _this8.pandlexpenseTotal += (isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(openingBalance)) + (isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(totalAmount));
      });
      this.pandlexpenseTotal = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.pandlexpenseTotal).toFixed(2);
      return expenses;
    },
    getStaffAccount: function getStaffAccount() {
      var _this9 = this;

      this.totalSalary = 0;
      if (this.selectedBrand) {
        var staffList = this.staff.filter(function (item) {
          return item['brand'] === _this9.selectedBrand && (_this9.selectedFirm ? item['firm'] === _this9.selectedFirm['.key'] : true);
        });
        var result = staffList.map(function (e) {
          var salaryList = _.filter(_this9.salarys, { 'staffId': e['.key'] });
          e.salaryList = salaryList;
          var creditTotal = _.sumBy(salaryList, function (s) {
            if (s.isCredited) return s.amount;
          });

          e.creditTotal = creditTotal ? creditTotal : 0;

          var debitTotal = _.sumBy(salaryList, function (s) {
            if (!s.isCredited) return s.amount;
          });

          e.debitTotal = debitTotal ? debitTotal : 0;

          _this9.totalSalary = _this9.totalSalary + (parseInt(e.creditTotal) - parseInt(e.debitTotal));
          return e;
        });
        console.log(result, null, 4);
        return result;
      }
    },
    plassetByBrand: function plassetByBrand() {
      var _this10 = this;

      if (this.assets) {
        this.pltotalAsset = 0;
        // let selectedAssets = this.assets.filter(asset => {
        //   return asset.brand === this.selectedBrand && (this.selectedFirm ? this['firm']  === this.selectedFirm['.key'] : true)  && asset['category'] != 'personal' && asset['depriciation']    
        // });
        var selectedAssets = this.assets.filter(function (asset) {
          return asset.brand === _this10.selectedBrand && asset['category'] != 'personal' && asset['depriciation'];
        });
        selectedAssets.map(function (ast, index) {
          var firmAsset = _this10.invoices.filter(function (item) {
            return item['assetType'] === ast['.key'] && item['brand'] === _this10.selectedBrand && item.date >= _this10.finYear.start && item.date <= _this10.finYear.end && (_this10.selectedFirm ? item['firm'] === _this10.selectedFirm['.key'] : true);
          });
          var openingBalance = 0;
          var totalAmount = 0;
          firmAsset.map(function (inv) {
            openingBalance += inv.openingBalance ? parseInt(inv.openingBalance) : 0;
            totalAmount += inv.totalAmount ? parseInt(inv.totalAmount) : 0;
          });
          console.log(firmAsset);
          selectedAssets[index]['openingBalance'] = openingBalance;
          selectedAssets[index]['totalAmount'] = totalAmount;
          selectedAssets[index]['depAmount'] = _this10.getDepAmount(ast, ast.type);
          if (ast.category === 'b&p') {
            selectedAssets[index]['depAmount'] = selectedAssets[index]['depAmount'] / 2;
          }
          _this10.pltotalAsset += selectedAssets[index]['depAmount'];
        });
        return selectedAssets;
      }
      return [];
    },
    propassetByBrand: function propassetByBrand() {
      var _this11 = this;

      if (this.assets) {
        this.proptotalAsset = 0;
        var selectedAssets = this.assets.filter(function (asset) {
          return asset.brand === _this11.selectedBrand && asset['category'] != 'business' && asset['depriciation'];
        });
        selectedAssets.map(function (ast, index) {
          var firmAsset = _this11.invoices.filter(function (item) {
            return item['assetType'] === ast['.key'] && item.date >= _this11.finYear.start && item.date <= _this11.finYear.end && item['brand'] === _this11.selectedBrand && (_this11.selectedFirm ? item.firm === _this11.selectedFirm['.key'] : true);
          });
          var openingBalance = 0;
          var totalAmount = 0;
          firmAsset.map(function (inv) {
            openingBalance += inv.openingBalance ? parseInt(inv.openingBalance) : 0;
            totalAmount += inv.totalAmount ? parseInt(inv.totalAmount) : 0;
          });
          console.log(firmAsset);
          selectedAssets[index]['openingBalance'] = openingBalance;
          selectedAssets[index]['totalAmount'] = totalAmount;
          selectedAssets[index]['depAmount'] = _this11.getDepAmount(ast, ast.type);
          if (ast.category === 'b&p') {
            selectedAssets[index]['depAmount'] = selectedAssets[index]['depAmount'] / 2;
          }
          _this11.proptotalAsset += selectedAssets[index]['depAmount'];
        });
        return selectedAssets;
      }
      return [];
    },
    groupIncomes: function groupIncomes() {
      var _this12 = this;

      this.pandlincomeTotal = 0;
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var incomes = this.incomes.filter(function (income) {
        return income.brand === _this12.selectedBrand && income.underHead === 'Profit and Loss' && income.category === "Indirect";
      });
      incomes = incomes.filter(function (income) {
        return !!income['.key'];
      });
      incomes.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = 'confirm';
        var invoices = _this12.invoices.filter(function (invoice) {
          return invoice.brand === _this12.selectedBrand && invoice["incomeType"] === ex['.key'] && (_this12.selectedFirm ? invoice['firm'] === _this12.selectedFirm['.key'] : true) && (fromDate ? invoice.date >= fromDate : true) && invoice.date >= _this12.finYear.start && invoice.date <= _this12.finYear.end && (toDate ? invoice.date <= toDate : true);
        });
        invoices.map(function (inv) {
          openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
          totalAmount += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          if (paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        incomes[index]['invoices'] = invoices;
        incomes[index].paymentTypeStatus = paymentTypeStatus;
        incomes[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        incomes[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        _this12.pandlincomeTotal += (isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(openingBalance)) + (isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(totalAmount));
      });
      this.pandlincomeTotal = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.pandlincomeTotal).toFixed(2);
      return incomes;
    },
    groupExpensesOfPropCapital: function groupExpensesOfPropCapital() {
      var _this13 = this;

      this.propexpenseTotal = 0;
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var expenses = this.expenses.filter(function (expense) {
        return expense.brand === _this13.selectedBrand && expense.underHead === 'Prop Capital A/C' && expense.category === "Indirect";
      });
      expenses = expenses.filter(function (expense) {
        return !!expense['.key'];
      });
      expenses.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = 'confirm';
        var invoices = _this13.invoices.filter(function (invoice) {
          return invoice.brand === _this13.selectedBrand && invoice["expenseType"] === ex['.key'] && (_this13.selectedFirm ? invoice['firm'] === _this13.selectedFirm['.key'] : true) && invoice.date >= _this13.finYear.start && invoice.date <= _this13.finYear.end && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true);
        });
        invoices.map(function (inv) {
          openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
          totalAmount += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          if (paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        expenses[index]['invoices'] = invoices;
        expenses[index].paymentTypeStatus = paymentTypeStatus;
        expenses[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        expenses[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        _this13.propexpenseTotal += (isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(openingBalance)) + (isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(totalAmount));
      });
      this.propexpenseTotal = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.propexpenseTotal).toFixed(2);
      return expenses;
    },
    groupIncomesOfPropCapital: function groupIncomesOfPropCapital() {
      var _this14 = this;

      this.propincomeTotal = 0;
      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var incomes = this.incomes.filter(function (income) {
        return income.brand === _this14.selectedBrand && income.underHead === 'Prop Capital A/C' && income.category === "Indirect";
      });
      incomes = incomes.filter(function (income) {
        return !!income['.key'];
      });
      incomes.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = 'confirm';
        var invoices = _this14.invoices.filter(function (invoice) {
          return invoice.brand === _this14.selectedBrand && invoice["incomeType"] === ex['.key'] && (_this14.selectedFirm ? invoice['firm'] === _this14.selectedFirm['.key'] : true) && invoice.date >= _this14.finYear.start && invoice.date <= _this14.finYear.end && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true);
        });
        invoices.map(function (inv) {
          openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
          totalAmount += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          if (paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        incomes[index]['invoices'] = invoices;
        incomes[index].paymentTypeStatus = paymentTypeStatus;
        incomes[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        incomes[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        _this14.propincomeTotal += (isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(openingBalance)) + (isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(totalAmount));
      });
      this.propincomeTotal = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.propincomeTotal).toFixed(2);
      return incomes;
    },
    totalIncomesAmount: function totalIncomesAmount() {
      return this.groupIncomes.reduce(function (total, item) {
        return item.details.totalAmount + total;
      }, 0);
    },
    incomesByBrand: function incomesByBrand() {
      var _this15 = this;

      var income = this.incomes.filter(function (income) {
        return income.brand === _this15.selectedBrand && income.underHead === 'Profit and Loss';
      });
      return income;
    },
    incomeInvoices: function incomeInvoices() {
      return this.invoiceByBrand.filter(function (invoice) {
        return !!invoice.incomeType;
      });
    },
    totalIncomeAmount: function totalIncomeAmount() {
      return this.creditedInvoiceByBrand.reduce(function (total, item) {
        // calculate total Income for expense
        return total + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item['profit'] || 0);
      }, 0);
    },
    creditedInvoiceByBrand: function creditedInvoiceByBrand() {
      var _this16 = this;

      return this.invoiceByBrand.filter(function (invoice) {
        if (_this16.selectedFirm) {
          return invoice.firm === _this16.selectedFirm['.key'] && invoice.isCredited;
        }
        return invoice.isCredited;
      });
    },
    totalIncomesOpeningBalance: function totalIncomesOpeningBalance() {
      return this.groupIncomes.reduce(function (total, item) {
        return (isNaN(item.details.openingBalance) ? 0 : item.details.openingBalance) + (isNaN(total) ? 0 : total);
      }, 0);
    },
    invoiceByBrand: function invoiceByBrand() {
      var _this17 = this;

      if (!this.invoices) {
        return [];
      };
      var filter = this.invoices.filter(function (item) {
        return item['brand'] === _this17.selectedBrand && item.deleted != true && item.date >= _this17.finYear.start && item.date <= _this17.finYear.end;
      });
      if (this.selectedFirm) {
        filter = filter.filter(function (item) {
          return item.firm === _this17.selectedFirm['.key'];
        });
      }
      if (this.filterInvoiceFrom) {
        var from = new Date(this.filterInvoiceFrom).setHours(0, 0, 0, 0);
        filter = filter.filter(function (item) {
          return item.date >= from;
        });
      }
      if (this.filterInvoiceTo) {
        var to = new Date(this.filterInvoiceTo).setHours(23, 29, 59, 999);
        filter = filter.filter(function (item) {
          return item.date <= to;
        });
      }
      return filter;
    },
    firmStockReportType: function firmStockReportType() {
      var _this18 = this;

      var val = 'APP';
      if (this.selectedFirm['.key']) {
        var dfirmSetting = this.firmSettings.filter(function (item) {
          return item['firm'] == _this18.selectedFirm['.key'];
        })[0];
        if (dfirmSetting && dfirmSetting.stockReportView) {
          val = dfirmSetting.stockReportView;
        }
      }
      return val;
    },
    closingStock: function closingStock() {
      var _this19 = this;

      var toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      var fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      var products = this.productList.filter(function (item) {
        return item['brand'] === _this19.selectedBrand && (_this19.selectedFirm ? item['firm'] === _this19.selectedFirm['.key'] : true);
      });
      var total = {
        quantity: 0,
        durationQuantity: 0,
        durationAmount: 0,
        saleQuantity: 0,
        durationQtySale: 0,
        durationAmountSale: 0,
        purchaseQuantity: 0,
        durationQtyPurchase: 0,
        durationAmountPurchase: 0,
        openingQuantity: 0,
        openingBalance: 0
      };
      products.map(function (p, index) {
        p["durationQuantity"] = undefined;
        p["durationAmount"] = 0;
        p["durationQtySale"] = 0;
        p["durationQtyPurchase"] = 0;
        p["durationAmountSale"] = 0;
        p["durationAmountPurchase"] = 0;
        p["stockReportData"] = {
          saleDetails: [],
          purchaseDetails: [],
          lastSalePrice: 0,
          lastPurchasePrice: 0
        };
        var prodG = {
          weight: 0,
          openingBalance: 0
        };
        if (_this19.isJwelleryBussiness) {
          if (p.productGroup) {
            prodG = _this19.productGroups.find(function (item) {
              return item[".key"] == p.productGroup;
            });
          }
          products[index]["openingQuantity"] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prodG && prodG.weigh ? prodG.weight : 0);
          products[index]["openingBalance"] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prodG && prodG.openingBalance ? prodG.openingBalance : 0);
        } else {
          products[index]["openingQuantity"] = 0;
          products[index]["openingBalance"] = 0;
        }
        if (p.openingBalance && p.openingQuantity) {
          p["stockReportData"]['purchaseDetails'].push({
            // quantity : Number.parseFloat(p.openingQuantity),
            // rate : Number.parseInt(p.openingBalance),
            quantity: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_int___default()(p.openingQuantity),
            rate: __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(p.openingBalance) / __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_number_parse_int___default()(p.openingQuantity),
            date: p.openingDate
          });
          p["stockReportData"]['lastPurchasePrice'] = p.openingBalance;
        }
        total.openingQuantity += parseInt(p["openingQuantity"] ? p["openingQuantity"] : 0);
        total.openingBalance += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(p["openingBalance"] ? p["openingBalance"] : 0);
      });
      var productGroup = products.reduce(function (r, a) {
        r[a[".key"]] = r[a[".key"]] || [];
        r[a[".key"]].push(a);
        return r;
      }, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_create___default()(null));
      var latestSaleDate = new Date('01-01-1000').getTime();
      var latestPurchaseDate = new Date('01-01-1000').getTime();
      var filteredInvoices = this.invoices.filter(function (item) {
        return item.type != "automatic invoice" && item.items && item.items.length && item.date >= _this19.finYear.start && item.deleted != true && item.date <= _this19.finYear.end && (_this19.selectedFirm ? item['firm'] === _this19.selectedFirm['.key'] : true) && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true);
      });
      this.selectProdList = [];
      filteredInvoices.map(function (invoice) {
        var isBuyer = invoice.isBuyer;
        invoice.items && invoice.items.map(function (item) {
          if (productGroup[item["productId"]]) {
            if (productGroup[item["productId"]][0].durationQuantity != undefined) {
              var durationQuantity = parseInt(productGroup[item["productId"]][0]["durationQuantity"]);
              durationQuantity += !!isBuyer ? -parseInt(item.quantity) : parseInt(item.quantity);
              total.durationQuantity += durationQuantity;
              productGroup[item["productId"]][0]["durationQuantity"] = durationQuantity;
            } else {
              productGroup[item["productId"]][0]["durationQuantity"] = productGroup[item["productId"]][0].openingQuantity ? productGroup[item["productId"]][0].openingQuantity : 0;
              total.durationQuantity += parseInt(productGroup[item["productId"]][0]["durationQuantity"]);
            }
            var rate = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.rate);
            if (isBuyer) {
              if (invoice.date > latestSaleDate) {
                latestSaleDate = invoice.date;
                productGroup[item["productId"]][0]['stockReportData']['lastSalePrice'] = rate;
              }
              productGroup[item["productId"]][0]['stockReportData']['saleDetails'].push({
                quantity: item.quantity,
                rate: rate,
                date: invoice.date
              });
            } else {
              if (invoice.date > latestPurchaseDate) {
                latestPurchaseDate = invoice.date;
                productGroup[item["productId"]][0]['stockReportData']['lastPurchasePrice'] = rate;
              }
              productGroup[item["productId"]][0]['stockReportData']['purchaseDetails'].push({
                quantity: item.quantity,
                rate: rate,
                date: invoice.date
              });
            }

            productGroup[item["productId"]][0]["durationAmount"] += !!isBuyer ? -__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.GSTValue) : __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
            total.durationAmount += productGroup[item["productId"]][0]["durationAmount"];
            if (!!isBuyer) {
              productGroup[item["productId"]][0]["durationQtySale"] += parseInt(item.quantity);
              total.durationQtySale += parseInt(item.quantity);
              productGroup[item["productId"]][0]["durationAmountSale"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
              total.durationAmountSale += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
            } else {
              productGroup[item["productId"]][0]["durationQtyPurchase"] += parseInt(item.quantity);
              total.durationQtyPurchase += parseInt(item.quantity);
              productGroup[item["productId"]][0]["durationAmountPurchase"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
              total.durationAmountPurchase += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.basicPrice) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
            }
            item['date'] = invoice.date;
            item['invoice'] = invoice;
            item['isBuyer'] = invoice['isBuyer'];
            item['openingBalance'] = productGroup[item["productId"]][0]['openingBalance'];
            item['openingQuantity'] = productGroup[item["productId"]][0]['openingQuantity'];
            if (!(productGroup[item["productId"]][0]['productList'] && productGroup[item["productId"]][0]['productList'].length)) productGroup[item["productId"]][0]['productList'] = [];

            productGroup[item["productId"]][0]['productList'].push(item);
          }
        });
      });

      this.totalOpeningStock = total.openingBalance;
      var results = [];
      var closingStock = 0;
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(productGroup).length && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(productGroup).map(function (key, index) {
        productGroup[key][".key"] = key;
        results.push(productGroup[key][0]);
        // productGroup[key][0]['closingAmount'] = this.getClosingAmount(productGroup[key][0]);
        var temp = _this19.getClosingAmount(productGroup[key][0]);
        productGroup[key][0]['closingAmount'] = isNaN(temp) ? 0 : temp;
        closingStock += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(productGroup[key][0]['closingAmount']);
      });
      if (this.isJwelleryBussiness) {
        var _products = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()([], results);
        var groups = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.productGroups));
        groups.push({
          name: "Non group Products",
          ".key": "Nongroup",
          quantity: 0,
          durationQuantity: 0,
          durationAmount: 0,
          saleQuantity: 0,
          durationQtySale: 0,
          durationAmountSale: 0,
          purchaseQuantity: 0,
          durationQtyPurchase: 0,
          durationAmountPurchase: 0,
          openingQuantity: 0,
          openingBalance: 0,
          closingAmount: 0,
          closingQuantity: 0
        });
        groups.map(function (item, index) {
          groups[index]["productList"] = [];
          groups[index]["quantity"] = 0;
          groups[index]["durationQuantity"] = 0;
          groups[index]["durationAmount"] = 0;
          groups[index]["saleQuantity"] = 0;
          groups[index]["durationQtySale"] = 0;
          groups[index]["durationAmountSale"] = 0;
          groups[index]["purchaseQuantity"] = 0;
          groups[index]["durationQtyPurchase"] = 0;
          groups[index]["durationAmountPurchase"] = 0;
          groups[index]['openingQuantity'] = item.weight;
          groups[index]['openingBalance'] = item.openingBalance;

          groups[index]["closingAmount"] = 0;
          groups[index]["closingQuantity"] = 0;
        });
        groups.map(function (item, index) {
          _products.map(function (prod) {
            if (prod.productGroup && prod.productGroup == item[".key"]) {
              groups[index]["productList"] = groups[index]["productList"].concat(prod.productList);
              groups[index]["quantity"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["quantity"]);
              groups[index]["durationQuantity"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationQuantity"]);
              groups[index]["durationAmount"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationAmount"]);
              groups[index]["saleQuantity"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["saleQuantity"]);
              groups[index]["durationQtySale"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationQtySale"]);
              groups[index]["durationAmountSale"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationAmountSale"]);
              groups[index]["purchaseQuantity"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["purchaseQuantity"]);
              groups[index]["durationQtyPurchase"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationQtyPurchase"]);
              groups[index]["durationAmountPurchase"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationAmountPurchase"]);
              // groups[index]["openingQuantity"] += Number.parseFloat(
              //   prod["openingQuantity"]
              // );
              // groups[index]["openingBalance"] += Number.parseFloat(
              //   prod["openingBalance"]
              // );
              groups[index]["closingAmount"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["closingAmount"]);
              groups[index]["closingQuantity"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["closingQuantity"]);
            } else if (!prod.productGroup && item[".key"] == "Nongroup") {
              groups[index]["productList"] = groups[index]["productList"].concat(prod.productList);
              groups[index]["quantity"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["quantity"]);
              groups[index]["durationQuantity"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationQuantity"]);
              groups[index]["durationAmount"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationAmount"]);
              groups[index]["saleQuantity"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["saleQuantity"]);
              groups[index]["durationQtySale"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationQtySale"]);
              groups[index]["durationAmountSale"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationAmountSale"]);
              groups[index]["purchaseQuantity"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["purchaseQuantity"]);
              groups[index]["durationQtyPurchase"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationQtyPurchase"]);
              groups[index]["durationAmountPurchase"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationAmountPurchase"]);
              groups[index]["openingQuantity"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["openingQuantity"]);
              groups[index]["openingBalance"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["openingBalance"]);
              groups[index]["closingAmount"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["closingAmount"]);
              groups[index]["closingQuantity"] += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["closingQuantity"]);
            }
          });
        });
        //groups.push(total);
        groups.map(function (prod, index) {
          groups[index]["closingAmount"] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["openingBalance"]) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationAmountPurchase"]) - __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationAmountSale"]);
          groups[index]["closingQuantity"] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["openingQuantity"]) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationQtyPurchase"]) - __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod["durationQtySale"]);
        });

        closingStock = 0;
        var openingBalance = 0;
        groups.map(function (prod, index) {
          groups[index]['quantity'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['quantity']).toFixed(3);
          groups[index]['durationQuantity'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['durationQuantity']).toFixed(3);
          groups[index]['durationAmount'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['durationAmount']).toFixed(3);
          groups[index]['saleQuantity'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['saleQuantity']).toFixed(3);
          groups[index]['durationQtySale'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['durationQtySale']).toFixed(3);
          groups[index]['durationAmountSale'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['durationAmountSale']).toFixed(3);
          groups[index]['purchaseQuantity'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['purchaseQuantity']).toFixed(3);
          groups[index]['durationQtyPurchase'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['durationQtyPurchase']).toFixed(3);
          groups[index]['durationAmountPurchase'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['durationAmountPurchase']).toFixed(3);
          groups[index]['openingQuantity'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['openingQuantity']).toFixed(3);
          groups[index]['openingBalance'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['openingBalance']).toFixed(3);
          groups[index]['closingAmount'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['closingAmount']).toFixed(3);
          groups[index]['closingQuantity'] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['closingQuantity']).toFixed(3);
          closingStock += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['closingAmount']);
          openingBalance += __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(prod['openingBalance']);
        });
        closingStock = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(closingStock).toFixed(3);
        this.totalOpeningStockWeight = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(3);
      }
      return closingStock;
    },
    closingBalance: function closingBalance() {
      var propclosing = (this.selectedFirm ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.selectedFirm.openingBalance) || 0 : 0) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.propincomeTotal) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.netProfit) - (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(62571.11) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.propexpenseTotal));
      propclosing = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(propclosing).toFixed(2);
      return propclosing;
    },

    // closingBalance() {
    //   let propclosing = ((this.selectedFirm ? (Number.parseFloat(this.selectedFirm.openingBalance) || 0) : 0) + Number.parseFloat(this.propincomeTotal) + Number.parseFloat(this.netProfit)  - (Number.parseFloat(this.proptotalAsset) + Number.parseFloat(this.propexpenseTotal)))
    //   propclosing -= Number.parseFloat(this.groupExpensesOfCategory);
    //   console.log(this.groupExpensesOfCategory)
    //   propclosing = Number.parseFloat(propclosing).toFixed(2);
    //   return propclosing;
    // },
    propAllTotal: function propAllTotal() {
      var propclosing = (this.selectedFirm ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.selectedFirm.openingBalance) || 0 : 0) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.propincomeTotal);
      propclosing = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(propclosing).toFixed(2);
      return propclosing;
    },

    // grossProfit(){
    //   let profit = (( Number.parseFloat(this.sales) + Number.parseFloat(this.incomeTotal) + Number.parseFloat(this.closingStock))
    //   - ((this.selectedFirm ? (Number.parseFloat(this.selectedFirm.openingStock) || 0) : 0) + 
    //     Number.parseFloat(this.purchase) +  Number.parseFloat(this.expenseTotal))
    //   ); 
    //   profit = Number.parseFloat(profit).toFixed(2);
    //   return profit;
    // },
    grossProfit: function grossProfit() {
      var profit = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.sales) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.incomeTotal) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.isJwelleryBussiness ? this.closingStock : this.closingStock) - ((this.selectedFirm ? __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.selectedFirm.openingStock) || 0 : 0) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.isJwelleryBussiness ? this.totalOpeningStockWeight : this.totalOpeningStock) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.purchase) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.expenseTotal));
      profit = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(profit).toFixed(2);
      return profit;
    },
    netProfit: function netProfit() {
      var netprofit = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.pandlincomeTotal) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.grossProfit) - (__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.totalSalary) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.pltotalAsset) + __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(this.pandlexpenseTotal));
      netprofit = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_number_parse_float___default()(netprofit).toFixed(2);
      return netprofit;
    }
  }),
  methods: {
    getClosingAmount: function getClosingAmount(item) {
      var closingQty = parseInt(item['openingQuantity'] ? item['openingQuantity'] : 0) + parseInt(item['durationQtyPurchase'] ? item['durationQtyPurchase'] : 0) - parseInt(item['durationQtySale'] ? item['durationQtySale'] : 0);
      switch (this.firmStockReportType) {

        case 'APP':
          {
            var amount = 0;
            if (item.stockReportData) {
              var avgPurchasePrice = item.stockReportData.purchaseDetails.reduce(function (a, b) {
                return a + (b['rate'] || 0);
              }, 0) / item.stockReportData.purchaseDetails.length;
              amount = avgPurchasePrice * closingQty;
            }
            return amount;
          }
        case 'LPP':
          {
            var _amount = 0;
            if (item.stockReportData) {
              _amount = item.stockReportData.lastPurchasePrice * closingQty;
            }
            return _amount;
          }
        case 'LSP':
          {
            var _amount2 = 0;
            if (item.stockReportData) {
              _amount2 = item.stockReportData.lastSalePrice * closingQty;
            }
            return _amount2;
          }
        case 'ASP':
          {
            var _amount3 = 0;
            if (item.stockReportData) {
              var avgSalePrice = item.stockReportData.saleDetails.reduce(function (a, b) {
                return a + (b['rate'] || 0);
              }, 0) / item.stockReportData.saleDetails.length;
              _amount3 = avgSalePrice * closingQty;
            }
            return _amount3;
          }
        case 'FIFO':
          {
            var _amount4 = 0;
            if (item.stockReportData) {
              var allTransaction = item.stockReportData.purchaseDetails.sort(function (a, b) {
                return -(new Date(b.date) - new Date(a.date));
              });

              var qntTemp = closingQty;
              allTransaction.map(function (t) {
                if (qntTemp > t.quantity) {
                  _amount4 += t.quantity * t.rate;
                  qntTemp = qntTemp - t.quantity;
                } else if (qntTemp > 0) {
                  _amount4 += t.quantity - qntTemp * t.rate;
                  qntTemp = 0;
                }
              });
            }
            return _amount4;
          }
        case 'LIFO':
          {
            var _amount5 = 0;
            if (item.stockReportData) {
              var _allTransaction = item.stockReportData.purchaseDetails.sort(function (a, b) {
                return new Date(b.date) - new Date(a.date);
              });
              var _qntTemp = closingQty;
              _allTransaction.map(function (t) {
                if (_qntTemp > t.quantity) {
                  _amount5 += t.quantity * t.rate;
                  _qntTemp = _qntTemp - t.quantity;
                } else if (_qntTemp > 0) {
                  _amount5 += t.quantity - _qntTemp * t.rate;
                  _qntTemp = 0;
                }
              });
            }
            return _amount5;
          }
      }
    },
    print: function print() {
      var data = [];
      $(".print-field").each(function (index) {
        data.push($(this).text());
      });
      var doc = Object(__WEBPACK_IMPORTED_MODULE_9__utils_pdf_reports_information_reports__["d" /* convertToPDFProprietor */])({ data: data });
      pdfMake.createPdf(doc).download();
    },
    getFirmName: function getFirmName(e) {
      var firm = void 0;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter(function (item) {
          return item['.key'] === e;
        })[0];
      }
      if (firm) return firm.name;
    },
    getDepAmount: function getDepAmount(asset, type) {
      var depriciation = null;
      if (asset.isVerified && asset.depriciation) {
        var totalAmount = this.getTotalAmount(asset);
        depriciation = Number(totalAmount * asset.depriciation / 100);
        return depriciation;
      }
      return 0;
    },
    getTotalAmount: function getTotalAmount(asset) {
      if (asset.isVerified) {
        return Number(asset.openingBalance || 0) + Number(asset.totalAdditionAmount) - Number(asset.totalDeletionAmount);
      }
      return Number(asset.totalAdditionAmount) - Number(asset.totalDeletionAmount);
    }
  }
});

/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3__ = __webpack_require__(189);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'items',
    data: function data() {
        return {
            firms: [],
            items: [],
            selectFirm: null
        };
    },
    created: function created() {
        this.$bindAsArray('items', this.$root.$firebaseRefs.item);
        this.$bindAsArray('firms', this.$root.$firebaseRefs.firm);
    },

    computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand']), {
        getFirms: function getFirms() {
            var _this = this;

            if (this.firms && this.selectedBrand) {
                return this.firms.filter(function (item) {
                    return item['brand'] === _this.selectedBrand;
                }).map(function (item) {
                    return { text: item.name, value: item['.key'] };
                });
            }
        },
        processedItems: function processedItems() {
            var _this2 = this;

            if (this.items.length) {
                var filteredItems = this.items.filter(function (item) {
                    return item['brand'] === _this2.selectedBrand && item['status'] !== 'closed';
                }).filter(function (_ref) {
                    var firm = _ref.firm;
                    return _this2.selectFirm ? _this2.selectFirm == firm : true;
                });
                var data = __WEBPACK_IMPORTED_MODULE_3_d3__["a" /* nest */]().key(function (d) {
                    return d.type;
                }).key(function (d) {
                    return d.subType;
                }).rollup(function (v) {
                    return __WEBPACK_IMPORTED_MODULE_3_d3__["b" /* sum */](v, function (d) {
                        return d.quantity;
                    });
                }).entries(filteredItems);

                data = data.filter(function (_ref2) {
                    var key = _ref2.key;
                    return key && key.trim() != "";
                }).map(function (_ref3) {
                    var key = _ref3.key,
                        values = _ref3.values;
                    return {
                        name: key, values: values.filter(function (_ref4) {
                            var key = _ref4.key;
                            return key && key.trim() != "";
                        })
                        // .map(({key, value}) => ({[key]: value}))
                    };
                });
                // console.log('med', JSON.stringify(data));
                // data = data.map(({name, values})=> {
                //     let result = {
                //         name
                //     }
                //     values.forEach(value => {
                //         result = {...result, ...value}
                //     })
                //     return result
                // })
                console.log('final', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));

                return data;
            }
            return [];
        }
    })
});

/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];

/* harmony default export */ __webpack_exports__["a"] = ({
  // name: 'Firms',
  data: function data() {
    return {
      headers: [
      // { text: 'Buyer Name', sortable: false, value: 'buyerName' },
      // { text: 'Father Name', sortable: false, value: 'propName' },
      // { text: 'Buyer ID', sortable: false, value: 'buyerId' },
      // { text: 'Village', sortable: false, value: 'village' },
      // { text: 'Block', sortable: false, value: 'block' },
      // { text: 'Tehsil', sortable: false, value: 'tehsil' },
      // { text: 'District', sortable: false, value: 'district' },
      { text: 'Date', sortable: false, value: 'date' }, { text: 'Invoice Id', sortable: false, value: 'key' },
      // { text: 'Item Type', sortable: false, value: 'itemType' },
      // { text: 'Item SubType', sortable: false, value: 'itemSubType' },        
      // { text: 'Closed Date', sortable: false, value: 'closedDate' },
      { text: 'Firm', sortable: false, value: 'firmName' },
      // { text: 'Payment Type', sortable: false, value: 'paymentType' },
      { text: 'Rate %', sortable: false, value: 'rate' },
      // { text: 'Days Left', sortable: true, value: 'daysLeft' },
      { text: 'Principal Value', sortable: false, value: 'totalAmount' },
      // { text: 'Duration (in Days)', sortable: false, value: 'duration' },
      { text: 'Interest Value', sortable: false, value: 'interestValue' }, { text: 'Total Value', sortable: false, value: 'totalValue' }],
      firms: {},
      buyerById: {}
    };
  }
});

/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils___ = __webpack_require__(47);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AlertSheet',
  data: function data() {
    return {
      headers: [{ text: 'Date', sortable: true, value: 'date' }, { text: 'Buyer Name', sortable: true, value: 'buyerName' }, { text: 'Invoice Id', sortable: false, value: 'invoiceId' }, { text: 'Total Amount', sortable: false, value: 'totalAmount' },
      // { text: 'Item Type', sortable: false, value: 'itemType' },
      // { text: 'Item SubType', sortable: false, value: 'itemSubType' },
      // { text: 'Closed Date', sortable: false, value: 'closedDate' },
      // { text: 'Rate %', sortable: false, value: 'rate' },
      // { text: 'Interest Value', sortable: false, value: 'interestValue' },
      // { text: 'Total Value', sortable: false, value: 'totalValue' },
      { text: 'Days Left', sortable: true, value: 'daysLeft' }, { text: 'Alloted Days', sortable: false, value: 'duration' },
      // { text: 'Payment Type', sortable: false, value: 'paymentType' },
      // { text: 'Status', sortable: false, value: 'status' },
      { text: 'Mobile', sortable: false, value: 'mobile' }, { text: 'CareOf Name', sortable: false, value: 'propName' },
      // { text: 'Buyer ID', sortable: false, value: 'buyerId' },
      // { text: 'Village', sortable: false, value: 'village' },
      // { text: 'Block', sortable: false, value: 'block' },
      { text: 'Tehsil', sortable: false, value: 'tehsil' }, { text: 'District', sortable: false, value: 'district' }, { text: 'Firm', sortable: false, value: 'firmName' }],
      firms: {},
      buyerById: {},
      sellerById: {},
      invoices: [],
      selectedFirm: null,
      filterInvoiceFrom: null,
      filterInvoiceTo: null,
      fromdatepicker: false,
      todatepicker: false
    };
  },
  created: function created() {
    this.$bindAsArray('invoices', this.$root.$firebaseRefs.invoice.orderByChild('brandFinYear').equalTo(this.brandFinYear));
    this.$bindAsObject('buyerById', this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject('sellerById', this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject('firms', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('firmList', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand', 'finYear', 'brandFinYear']), {
    // firmsByBrand1() {
    //   return this.firmList
    //   .filter(item => item["brand"] === this.selectedBrand)  
    // },

    // current brands firm list
    firmsByBrand: function firmsByBrand() {
      var _this = this;

      // return selected brand firms
      var firmsB = this.firmList.filter(function (item) {
        return item['brand'] === _this.selectedBrand;
      });
      firmsB.map(function (item) {
        if (item.defaultFirm) {
          _this.selectedFirm = item;
        }
      });
      return firmsB;
    },
    filteredAlerts: function filteredAlerts() {
      var _this2 = this;

      if (!this.invoices) {
        return [];
      }
      var alertItems = [];

      this.invoices.forEach(function (item) {
        if (item.brand !== _this2.selectedBrand && (_this2.selectedFirm ? item['firm'] !== _this2.selectedFirm['.key'] : true)) {
          return null;
        }
        // if(!(item.date >= this.finYear.start) || !(item.date <= this.finYear.end)) {
        //    return null
        // }
        if (item.status === 'paid' || !item.duration) {
          return null;
        }

        // calculate value details
        var dt1 = new Date(item.date);
        var dt2 = new Date();
        var daysSpent = Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24));

        if (item.date) {
          item.date = dt1.toLocaleDateString('en-GB');
        }
        item.closedDate = item.closedDate ? new Date(item.closedDate).toLocaleDateString('en-GB') : null;
        var daysLeft = item.duration - daysSpent;

        // remove invoices which has daysLeft less than 0
        // if(daysLeft) {
        //   return null;
        // }
        if (daysLeft <= -2000 || daysLeft >= 2000) {
          return null;
        }
        // Set Item as AlertList 
        item.daysLeft = daysLeft;
        item.daysSpent = daysSpent;
        // item.paymentType = paymentType
        if (daysLeft && item.rate) {
          var rate = item['rate'] * 12 / 100;
          var time = daysSpent / 365;
          var principal = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item['totalAmount']);
          var amount = Object(__WEBPACK_IMPORTED_MODULE_3__utils___["a" /* amountCompound */])(principal, rate, time);
          var interest = Object(__WEBPACK_IMPORTED_MODULE_3__utils___["b" /* compoundInterest */])(principal, rate, time);
          item['interestValue'] = interest.toFixed(2);
          item['totalValue'] = amount.toFixed(2);
        }

        // set buyer info
        var buyer = _this2.buyerById[item.buyerId] || _this2.sellerById[item.buyerId] || {};
        if (buyer) {
          item.buyerName = buyer.name;
          item.propName = buyer.propName;
          item.village = buyer.village;
          item.block = buyer.block;
          item.tehsil = buyer.tehsil;
          item.district = buyer.district;
          item.mobile = buyer.mobile;
        }
        // get items from items array
        if (item.items) {
          item.type = item.items[0].type;
          item.subType = item.items[0].subType;
        }

        if (item.firm) {
          var firm = _this2.firms[item.firm];
          item.firmName = firm && firm.name;
        }
        alertItems.push(item);
      });
      return alertItems;
    }
  }),
  methods: {
    getFirmName: function getFirmName(e) {
      var firm = void 0;
      if (this.firms && this.selectedBrand) {
        firm = this.firmList.filter(function (item) {
          return item[".key"] === e;
        })[0];
      }
      if (firm) return firm.name;
    },
    renderDate: function renderDate(timeStamp) {
      if (timeStamp) {
        return new Date(timeStamp).toLocaleDateString("en-GB");
      }
      return "--";
    }
  }
});

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      headers: [{ text: 'Buyer Name', sortable: false, value: 'buyerName' }, { text: 'Father Name', sortable: false, value: 'propName' }, { text: 'Buyer ID', sortable: false, value: 'buyerId' }, { text: 'Village', sortable: false, value: 'village' }, { text: 'Block', sortable: false, value: 'block' }, { text: 'Tehsil', sortable: false, value: 'tehsil' }, { text: 'District', sortable: false, value: 'district' }, { text: 'Mobile No', sortable: false, value: 'mobileNo' }],
      firms: {},
      buyerById: {}
    };
  }
});

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils___ = __webpack_require__(47);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'UnpickupSheet',
  data: function data() {
    return {
      headers: [{ text: 'Date', sortable: true, value: 'date' }, { text: 'Buyer Name', sortable: true, value: 'buyerName' }, { text: 'Invoice Id', sortable: false, value: 'invoiceID' }, { text: 'Total Value', sortable: false, value: 'totalValue' }, { text: 'Duration (in Days)', sortable: false, value: 'duration' }, { text: 'Status', sortable: false, value: 'status' }, { text: 'Mobile', sortable: false, value: 'mobile' }, { text: 'Prop Name', sortable: false, value: 'propName' },
      // { text: 'Village', sortable: false, value: 'village' },
      // { text: 'Block', sortable: false, value: 'block' },
      { text: 'Tehsil', sortable: false, value: 'tehsil' }, { text: 'District', sortable: false, value: 'district' }, { text: 'Firm', sortable: false, value: 'firmName' }],
      firms: {},
      buyerById: {},
      sellerById: {},
      invoices: [],
      selectedFirm: null,
      filterInvoiceFrom: null,
      filterInvoiceTo: null,
      fromdatepicker: false,
      todatepicker: false
    };
  },
  created: function created() {
    this.$bindAsArray('invoices', this.$root.$firebaseRefs.invoice.orderByChild('brandFinYear').equalTo(this.brandFinYear));
    this.$bindAsObject('buyerById', this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject('sellerById', this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject('firms', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('firmList', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand']), {
    firmsByBrand: function firmsByBrand() {
      var _this = this;

      return this.firmList.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      });
    },
    unpickItems: function unpickItems() {
      var _this2 = this;

      if (!this.invoices) {
        return [];
      }
      var alertItems = [];

      this.invoices.forEach(function (item) {
        if (item.brand !== _this2.selectedBrand) {
          return null;
        }

        // show only unpicked items
        if (!item.isUnpicked) {
          return null;
        }

        // calculate value details
        var dt1 = new Date(item.date);
        var dt2 = new Date();
        var daysSpent = Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24));

        if (item.date) {
          item.date = dt1.toLocaleDateString('en-GB');
        }
        item.closedDate = item.closedDate ? new Date(item.closedDate).toLocaleDateString('en-GB') : null;
        var daysLeft = item.duration - daysSpent;

        // Set Item as AlertList 
        item.daysLeft = daysLeft;
        item.daysSpent = daysSpent;
        // item.paymentType = paymentType
        if (daysSpent && item.rate) {
          var rate = item['rate'] * 12 / 100;
          var time = daysSpent / 365;
          var principal = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(item['totalAmount']);
          var amount = Object(__WEBPACK_IMPORTED_MODULE_3__utils___["a" /* amountCompound */])(principal, rate, time);
          var interest = Object(__WEBPACK_IMPORTED_MODULE_3__utils___["b" /* compoundInterest */])(principal, rate, time);
          item['interestValue'] = interest.toFixed(2);
          item['totalValue'] = amount.toFixed(2);
        }

        // set buyer info
        var buyer = _this2.buyerById[item.buyerId] || _this2.sellerById[item.buyerId] || {};
        item.buyerName = buyer.name;
        item.propName = buyer.propName;
        item.village = buyer.village;
        item.block = buyer.block;
        item.tehsil = buyer.tehsil;
        item.district = buyer.district;
        item.mobile = buyer.mobile;

        // get items from items array
        if (item.items) {
          item.type = item.items[0].type;
          item.subType = item.items[0].subType;
        }

        if (item.firm) {
          var firm = _this2.firms[item.firm];
          item.firmName = firm && firm.name;
        }

        alertItems.push(item);
      });
      return alertItems;
    }
  })
});

/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      items: [{
        name: 'Firm 1',
        expaccount: 100000,
        assetaccount: 5000000,
        otherincomeaccount: 150000,
        itemaccount: 519,
        intaccount: 1500000,
        custaccount: 789
      }, {
        name: 'Firm 2',
        expaccount: 100000,
        assetaccount: 5000000,
        otherincomeaccount: 150000,
        itemaccount: 519,
        intaccount: 1500000,
        custaccount: 789
      }, {
        name: 'Firm 3',
        expaccount: 100000,
        assetaccount: 5000000,
        otherincomeaccount: 150000,
        itemaccount: 519,
        intaccount: 1500000,
        custaccount: 789
      }, {
        name: 'Firm 4',
        expaccount: 100000,
        assetaccount: 5000000,
        otherincomeaccount: 150000,
        itemaccount: 519,
        intaccount: 1500000,
        custaccount: 789
      }]
    };
  }
});

/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      headers: [{ text: 'Date', sortable: false, value: 'date' }, { text: 'TransactionID', sortable: false, value: 'transactionID' }, { text: 'TransactionType', sortable: false, value: 'transactionType' }, { text: 'Debit', sortable: false, value: 'debited' }, { text: 'Credit', sortable: false, value: 'credited' }, { text: 'Balance', sortable: false, value: 'balance' }, { text: 'Description', sortable: false, value: 'description' }, { text: 'Remark', sortable: false, value: 'remark' }],
      desserts: [{
        date: '15-04-2019',
        transactionType: '',
        transactionID: '',
        debited: '',
        credited: 400000,
        balance: 400000,
        description: 'opening balance',
        remark: '2019 opening'
      }, {
        date: '23-05-2019',
        transactionType: 'NEFT',
        transactionID: '#$1$5&87#7',
        debited: 276000,
        credited: '',
        balance: 124000,
        description: 'neft to vicky',
        remark: 'chq-02'
      }, {
        date: '08-06-2019',
        transactionType: 'IMPS',
        transactionID: '#$56$&87#7',
        debited: '',
        credited: 246000,
        balance: 370000,
        description: 'Anshul Malpani',
        remark: '7896541235'
      }, {
        date: '28-07-2019',
        transactionType: 'NEFT',
        transactionID: '#$235&87#7',
        debited: 170000,
        credited: '',
        balance: 200000,
        description: 'cash',
        remark: 'Deepak'
      }, {
        date: '28-08-2019',
        transactionType: 'CASH',
        transactionID: '',
        debited: '',
        credited: 150000,
        balance: 350000,
        description: 'cash deposit by sonu',
        remark: 'Cash'
      }],
      firms: {},
      buyerById: {}
    };
  }
});

/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Balancesheet_expandCard__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_pdf_reports_information_reports__ = __webpack_require__(46);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ExpandCard: __WEBPACK_IMPORTED_MODULE_4__Balancesheet_expandCard__["a" /* default */]
  },
  data: function data() {
    return {
      cashBook: [{
        expense: true
      }, {
        expense: false
      }],
      firmClosingAmount: 0,
      datepicker: null,
      selectedDate: new Date().toISOString().substr(0, 10),
      selectedFirm: null,
      firmCashSale: 0,
      firmReceipt: 0,
      firmPayment: 0,
      firmExpense: 0,
      expenses: {
        total: 0,
        invoice: []
      },
      cashSale: {
        total: 0,
        invoice: []
      },
      receipts: {
        total: 0,
        invoice: []
      },
      payments: {
        total: 0,
        invoice: []
      }
    };
  },
  created: function created() {
    this.$bindAsArray('invoiceHistory', this.$root.$firebaseRefs.invoiceHistory.orderByChild('brandFinYear').equalTo(this.brandFinYear));
    this.$bindAsArray('invoice', this.$root.$firebaseRefs.invoice.orderByChild('brandFinYear').equalTo(this.brandFinYear));
    this.$bindAsObject('expense', this.$root.$firebaseRefs.expenses.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('firm', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject('buyerById', this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject('sellerById', this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("deposit", this.$root.$firebaseRefs.customerDeposit.orderByChild('brand').equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand', 'finYear']), {
    firmsByBrand: function firmsByBrand() {
      var _this = this;

      // return selected brand firms
      var firms = this.firm.filter(function (item) {
        return item['brand'] === _this.selectedBrand;
      });
      firms.map(function (item) {
        if (item.defaultFirm) {
          _this.selectedFirm = item;
        }
      });
      return firms;
    },
    getClosingAmount: function getClosingAmount() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.firmClosingAmount) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.firmCashSale) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.firmReceipt) - (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.firmExpense) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.firmPayment));
    },
    getClosingAmountOfDay: function getClosingAmountOfDay() {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.getClosingAmount) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.cashSale.total) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.receipts.total) - (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.expenses.total) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.payments.total));
    }
  }),
  watch: {
    selectedDate: function selectedDate(nval, oval) {
      if (oval !== nval) {
        this.getData();
      }
    },

    selectedFirm: {
      handler: function handler(newVal, oldVal) {
        this.firmClosingAmount = newVal.openingCashAmount || 0;
        this.getData();
      },

      deep: true
    },
    selectedBrand: function selectedBrand(nval, oval) {
      if (oval !== nval) {
        this.getData();
      }
    }
  },
  methods: {
    print: function print() {
      var data = [];
      $(".print-field").each(function (index) {
        data.push($(this).text());
      });
      var doc = Object(__WEBPACK_IMPORTED_MODULE_5__utils_pdf_reports_information_reports__["a" /* convertToCashBook */])({ data: data });
      pdfMake.createPdf(doc).download();
    },
    resetData: function resetData() {
      this.cashSale = {
        total: 0,
        invoice: []
      };
      this.receipts = {
        total: 0,
        invoice: []
      };
      this.payments = {
        total: 0,
        invoice: []
      };
      this.expenses = {
        total: 0,
        invoice: []
      };
      this.firmCashSale = 0;
      this.firmReceipt = 0;
      this.firmPayment = 0;
      this.firmExpense = 0;
    },
    getCustomerName: function getCustomerName(buyerId, isBuyer) {
      if (isBuyer) {
        var buyer = this.buyerById[buyerId];
        return buyer ? buyer.name : "";
      } else {
        var seller = this.sellerById[buyerId];
        return seller ? seller.name : "";
      }
    },
    isDateEqual: function isDateEqual(dt1, dt2) {
      var date1 = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(dt1));
      var date2 = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(dt2));
      var dateA = new Date(date1).setHours(0, 0, 0, 0);
      var dateB = new Date(date2).setHours(0, 0, 0, 0);
      return dateA == dateB;
    },
    expenseNameById: function expenseNameById(id) {
      if (this.expense[id]) {
        return this.expense[id]['expense'];
      }
    },
    getData: function getData() {
      var _this2 = this;

      this.resetData();
      var self = this;
      var selectedDateString = new Date(this.selectedDate).getTime();
      var invoiceHistory = this.invoiceHistory.filter(function (item) {
        return item['brand'] === _this2.selectedBrand && (_this2.selectedFirm ? item['firm'] === _this2.selectedFirm['.key'] : true) && item.date >= _this2.finYear.start && item.date <= _this2.finYear.end && item.deleted != true && (_this2.selectedFirm ? item['date'] >= new Date(_this2.selectedFirm['openingDate']).getTime() : false) && (item.status == 'partial' || item.status == 'paid');
      });
      var expenseInvoice = this.invoice.filter(function (item) {
        return item['brand'] === _this2.selectedBrand && (_this2.selectedFirm ? item['firm'] === _this2.selectedFirm['.key'] : true) && item.date >= _this2.finYear.start && item.date <= _this2.finYear.end && (_this2.selectedFirm ? item['date'] >= new Date(_this2.selectedFirm['openingDate']).getTime() : false) && item.type == 'automatic invoice' && item.expenseType && item.expenseType.length;
      });
      var customerDeposit = this.deposit.filter(function (item) {
        return item["brand"] === _this2.selectedBrand && (_this2.selectedFirm ? item['firm'] === _this2.selectedFirm['.key'] : true) && item.date >= _this2.finYear.start && item.date <= _this2.finYear.end && (_this2.selectedFirm ? item['date'] >= new Date(_this2.selectedFirm['openingDate']).getTime() : false) && item.settledAmount != undefined && item.isBuyer != undefined && (item["type"] === "Advance" || item["type"] === "Opening Balance" || item["type"] === "LoanTaken" || item["type"] === "LoanGiven" || item["type"] === "Security");
      });

      customerDeposit.map(function (invoice) {
        if (invoice.isBuyer) {
          if (invoice.date < selectedDateString) {
            self.firmReceipt += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(isNaN(invoice.settledAmount) ? 0 : invoice.settledAmount);
          }
          if (self.isDateEqual(invoice.date, selectedDateString)) {
            self.receipts.invoice.push({
              userName: self.getCustomerName(invoice.buyerId, invoice.isBuyer),
              amount: invoice.settledAmount
            });
            self.receipts.total += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(invoice.settledAmount);
          }
        } else {
          if (invoice.date < selectedDateString) {
            self.firmPayment += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(isNaN(invoice.settledAmount) ? 0 : invoice.settledAmount);
          }
          if (self.isDateEqual(invoice.date, selectedDateString)) {
            self.payments.invoice.push({
              userName: self.getCustomerName(invoice.buyerId, invoice.isBuyer),
              amount: invoice.settledAmount
            });
            self.payments.total += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(invoice.settledAmount);
          }
        }
      });
      expenseInvoice.map(function (invoice) {
        if (invoice.date < selectedDateString) {
          self.firmExpense += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(isNaN(invoice.totalAmount) ? 0 : invoice.totalAmount);
        }
        if (_this2.isDateEqual(invoice.date, selectedDateString)) {
          _this2.expenses.invoice.push({
            name: _this2.expenseNameById(invoice.expenseType),
            amount: invoice.totalAmount
          });
          self.expenses.total += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(invoice.totalAmount);
        }
      });
      invoiceHistory = _.groupBy(invoiceHistory, 'parentInvoiceKey');
      _.each(invoiceHistory, function (value, key, obj) {
        if (obj[key].length > 1) {
          var invoicesSorted = obj[key].sort(function (a, b) {
            return -(new Date(b.date) - new Date(a.date));
          });

          var diffTime = new Date(invoicesSorted[invoicesSorted.length - 1].date).getTime() - new Date(invoicesSorted[0].date).getTime();
          var diffDays = diffTime / (1000 * 3600 * 24);
          if (diffDays >= 1) {
            invoicesSorted.map(function (inv) {
              if (inv.isBuyer) {
                if (inv.date < selectedDateString) {
                  self.firmReceipt += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv['amountFromBank']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv['amountFromCash']);
                }
                if (_this2.isDateEqual(inv.date, selectedDateString)) {
                  self.receipts.invoice.push({
                    userName: self.getCustomerName(inv.buyerId, inv.isBuyer),
                    amount: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv['amountFromBank']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv['amountFromCash'])
                  });
                  self.receipts.total += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv['amountFromBank']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv['amountFromCash']);
                }
              } else {
                if (inv.date < selectedDateString) {
                  self.firmPayment += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv['amountFromBank']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv['amountFromCash']);
                }
                if (_this2.isDateEqual(inv.date, selectedDateString)) {
                  self.payments.invoice.push({
                    userName: self.getCustomerName(inv.buyerId, inv.isBuyer),
                    amount: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv['amountFromBank']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv['amountFromCash'])
                  });
                  self.payments.total += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv['amountFromBank']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv['amountFromCash']);
                }
              }
            });
          } else {
            invoicesSorted.map(function (inv) {
              if (inv.isBuyer) {
                if (inv.date < selectedDateString) {
                  self.firmCashSale += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv['amountFromBank']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv['amountFromCash']);
                }
                if (_this2.isDateEqual(inv.date, selectedDateString)) {
                  self.cashSale.invoice.push({
                    userName: self.getCustomerName(inv.buyerId, inv.isBuyer),
                    amount: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv['amountFromBank']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv['amountFromCash'])
                  });
                  self.cashSale.total += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv['amountFromBank']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv['amountFromCash']);
                }
              } else {
                if (_this2.isDateEqual(inv.date, selectedDateString)) {
                  if (inv.date < selectedDateString) {
                    self.firmPayment += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv['amountFromBank']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv['amountFromCash']);
                  }
                  self.payments.invoice.push({
                    userName: self.getCustomerName(inv.buyerId, inv.isBuyer),
                    amount: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv['amountFromBank']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv['amountFromCash'])
                  });
                  self.payments.total += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv['amountFromBank']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv['amountFromCash']);
                }
              }
            });
          }
        } else {
          if (obj[key][0].isBuyer) {
            if (obj[key][0].date < selectedDateString) {
              self.firmCashSale += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(obj[key][0]['amountFromBank']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(obj[key][0]['amountFromCash']);
            }
            if (_this2.isDateEqual(obj[key][0].date, selectedDateString)) {
              self.cashSale.invoice.push({
                userName: self.getCustomerName(obj[key][0].buyerId, obj[key][0].isBuyer),
                amount: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(obj[key][0]['amountFromBank']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(obj[key][0]['amountFromCash'])
              });
              self.cashSale.total += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(obj[key][0]['amountFromBank']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(obj[key][0]['amountFromCash']);
            }
          } else {
            if (obj[key][0].date < selectedDateString) {
              self.firmPayment += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(obj[key][0]['amountFromBank']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(obj[key][0]['amountFromCash']);
            }
            if (_this2.isDateEqual(obj[key][0].date, selectedDateString)) {
              self.payments.invoice.push({
                userName: self.getCustomerName(obj[key][0].buyerId, obj[key][0].isBuyer),
                amount: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(obj[key][0]['amountFromBank']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(obj[key][0]['amountFromCash'])
              });
              self.payments.total += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(obj[key][0]['amountFromBank']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(obj[key][0]['amountFromCash']);
            }
          }
        }
      });
    }
  }
});

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_pdfmake__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_excelExport__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_xlsx__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_xlsx__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      selectedFirm: null,
      selectedAccount: null,
      toDate: null,
      fromDate: null,
      datepickerFrom: null,
      datepickerTo: null,
      totalBuyer: null,
      totalSeller: null,
      buyerInvoices: [],
      sellerInvoices: []
    };
  },
  created: function created() {
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.brand));
    this.getInvoice();
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "brandFinYear"]), {
    firmsByBrand1: function firmsByBrand1() {
      var _this = this;

      return this.firms.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      });
    },

    // current brands firm list
    firmsByBrand: function firmsByBrand() {
      var _this2 = this;

      // return selected brand firms
      var firmsB = this.firms.filter(function (item) {
        return item['brand'] === _this2.selectedBrand;
      });
      firmsB.map(function (item) {
        if (item.defaultFirm) {
          _this2.selectedFirm = item;
        }
      });
      return firmsB;
    }
  }),
  methods: {
    toggle: function toggle(item) {
      item.expand = !item.expand;
    },

    // renderDate(timeStamp) {
    //   if (timeStamp) {
    //     return new Date(timeStamp).toLocaleDateString("en-GB");
    //   }
    //   return "--";
    // },
    getInvoice: function getInvoice() {
      var _this3 = this;

      var invoiceOfFirm = this.invoices.filter(function (item) {
        return item["brand"] === _this3.selectedBrand && (_this3.selectedFirm ? _this3.selectedFirm[".key"] === item["firm"] : true);
      });
      var buyerInvoices = [];
      var sellerInvoices = [];
      var totalBuyer = {
        val_3: 0,
        val_5: 0,
        val_12: 0,
        val_18: 0,
        val_28: 0
      };
      var totalSeller = {
        val_3: 0,
        val_5: 0,
        val_12: 0,
        val_18: 0,
        val_28: 0
      };
      var toDate = this.toDate ? new Date(this.toDate).getTime() : null;
      var fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
      invoiceOfFirm.map(function (invoice) {
        if (!invoice.return && (fromDate ? invoice.date >= fromDate : true) && (toDate ? invoice.date <= toDate : true) && (_this3.selectedAccount && (_this3.selectedAccount === "CGST Accounts" || _this3.selectedAccount === "SGST Accounts" || _this3.selectedAccount === "CGST+SGST Accounts") ? invoice.gstType === "SGST|CGST" : true) && (_this3.selectedAccount && _this3.selectedAccount === "IGST Accounts" ? invoice.gstType === "IGST" : true)) {
          invoice.items && invoice.items.map(function (item) {
            switch (item.taxableGST_rate) {

              case 3:
                {
                  if (invoice.isBuyer) {
                    buyerInvoices.push({
                      val_3: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.GSTValue),
                      date: invoice.date
                    });
                    totalBuyer.val_3 += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
                  } else {
                    sellerInvoices.push({
                      val_3: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.GSTValue),
                      date: invoice.date
                    });
                    totalSeller.val_3 += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
                  }
                  break;
                }
              case 5:
                {
                  if (invoice.isBuyer) {
                    buyerInvoices.push({
                      val_5: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.GSTValue),
                      date: invoice.date
                    });
                    totalBuyer.val_5 += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
                  } else {
                    sellerInvoices.push({
                      val_5: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.GSTValue),
                      date: invoice.date
                    });
                    totalSeller.val_5 += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
                  }
                  break;
                }
              case 12:
                {
                  if (invoice.isBuyer) {
                    buyerInvoices.push({
                      val_12: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.GSTValue),
                      date: invoice.date
                    });
                    totalBuyer.val_12 += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
                  } else {
                    sellerInvoices.push({
                      val_12: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.GSTValue),
                      date: invoice.date
                    });
                    totalSeller.val_12 += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
                  }
                  break;
                }
              case 18:
                {
                  if (invoice.isBuyer) {
                    buyerInvoices.push({
                      val_18: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.GSTValue),
                      date: invoice.date
                    });
                    totalBuyer.val_18 += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
                  } else {
                    sellerInvoices.push({
                      val_18: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.GSTValue),
                      date: invoice.date
                    });
                    totalSeller.val_18 += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
                  }
                  break;
                }
              case 28:
                {
                  if (invoice.isBuyer) {
                    buyerInvoices.push({
                      val_28: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.GSTValue),
                      date: invoice.date
                    });
                    totalBuyer.val_28 += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
                  } else {
                    sellerInvoices.push({
                      val_28: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.GSTValue),
                      date: invoice.date
                    });
                    totalSeller.val_28 += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
                  }
                  break;
                }
              default:
                {
                  console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item, null, 4));
                  break;
                }
            }
          });
          // console.log("ss")
          _this3.totalBuyer = totalBuyer;
          _this3.totalSeller = totalSeller;
          _this3.sellerInvoices = sellerInvoices;
          _this3.buyerInvoices = buyerInvoices;
        }
      });
    },
    printGST3: function printGST3() {
      var firm = this.selectedFirm;
      firm.address = this.generateAddress(firm);
      var doc = Object(__WEBPACK_IMPORTED_MODULE_4__utils_pdfmake__["o" /* convertToPDFGST_3 */])({
        firm: firm,
        inwardSupplies: this.inwardSupplies,
        outwardSupplies: this.outwardSupplies
      });
      pdfMake.createPdf(doc).download();
    },
    onexport: function onexport() {
      var firm = this.selectedFirm;
      firm.address = this.generateAddress(firm);
      var wb = Object(__WEBPACK_IMPORTED_MODULE_5__utils_excelExport__["c" /* convertToExcelGST_3 */])({
        selectedFirm: firm,
        inwardSupplies: this.inwardSupplies,
        outwardSupplies: this.outwardSupplies
      });
      __WEBPACK_IMPORTED_MODULE_6_xlsx___default.a.writeFile(wb, "GST3_" + new Date().getTime() + ".xlsx"); // name of the file is 'book.xlsx'
    },
    generateAddress: function generateAddress(user) {
      var address = "";
      if (user.block) {
        address = "" + user.block;
      }
      if (user.village) {
        address = "" + (address ? address + ", " : "") + user.village;
      }
      if (user.tehsil) {
        address = "" + (address ? address + ", " : "") + user.tehsil;
      }
      if (user.state) {
        address = "" + (address ? address + ", " : "") + user.state;
      }
      return address;
    }
  },
  watch: {
    selectedFirm: function selectedFirm(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.getInvoice();
        //this.setData();
      }
    },
    toDate: function toDate(newVal, oldVal) {
      if (oldVal !== newVal) {

        this.getInvoice();
        //this.setData();
      }
    },
    fromDate: function fromDate(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.getInvoice();
        // this.setData();
      }
    },
    selectedAccount: function selectedAccount(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.getInvoice();
        // this.setData();
      }
    }
  }
});

/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      invoiceHeader: [{ text: "Date", value: "date", sortable: true },
      // { text: "Invoice Key", value: "key" },
      { text: "Invoice ID", value: "Block" }, { text: "Customer Name", value: "Village" }, { text: "Debit", value: "Block" }, { text: "Credit", value: "Block" }, { text: "Payment Type", value: "paymentType" }, { text: "Firm", value: "firm" }],
      selectedFirm: null,
      filterInvoiceFrom: null,
      filterInvoiceTo: null,
      fromdatepicker: false,
      todatepicker: false
    };
  },
  created: function created() {
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("firm", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsObject("buyerById", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsObject("sellerById", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear", "brandFinYear"]), {
    firmsByBrand1: function firmsByBrand1() {
      var _this = this;

      return this.firms.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      });
    },


    // current brands firm list
    firmsByBrand: function firmsByBrand() {
      var _this2 = this;

      // return selected brand firms
      var firmsB = this.firms.filter(function (item) {
        return item['brand'] === _this2.selectedBrand;
      });
      firmsB.map(function (item) {
        if (item.defaultFirm) {
          _this2.selectedFirm = item;
        }
      });
      return firmsB;
    },
    getInvoice: function getInvoice() {
      var _this3 = this;

      var toDate = this.toDate ? new Date(this.toDate).getTime() : null;
      var fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
      var invoices = this.invoices.filter(function (item) {
        return item["brand"] === _this3.selectedBrand && (_this3.selectedFirm ? item['firm'] === _this3.selectedFirm['.key'] : true) && !item["return"] && item['discountAmount'] && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true) && item.deleted != true && item.date >= _this3.finYear.start && item.date <= _this3.finYear.end;
      });
      var credit = 0;
      var debit = 0;
      invoices.map(function (invoice, index) {
        if (invoice.isBuyer) {
          invoices[index]["debit"] = invoice.discountAmount ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(invoice.discountAmount) : 0;
          debit += invoices[index]["debit"];
        } else {
          invoices[index]["credit"] = invoice.discountAmount ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(invoice.discountAmount) : 0;
          credit += invoices[index]["credit"];
        }
      });

      invoices.sort(function (a, b) {
        return -(new Date(b.date) - new Date(a.date));
      });
      invoices.push({
        type: "total",
        debit: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(debit).toFixed(2),
        credit: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(credit).toFixed(2)
      });
      console.log(invoices);
      return invoices;
    }
  }),
  methods: {
    getCurrentUserName: function getCurrentUserName(buyerId) {
      var buyer = this.buyerById[buyerId];
      var seller = this.sellerById[buyerId];
      var currentUser = buyer && buyer.state ? buyer : seller && seller.state ? seller : {};
      return currentUser.name;
    },

    // getFirmName(firmId) {
    //   if (this.firm && this.firm[firmId]) {
    //     return this.firm[firmId]["name"];
    //   }
    //   return "--";
    // },
    getFirmName: function getFirmName(e) {
      var firm = void 0;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter(function (item) {
          return item[".key"] === e;
        })[0];
      }
      if (firm) return firm.name;
    },
    renderDate: function renderDate(timeStamp) {
      if (timeStamp) {
        return new Date(timeStamp).toLocaleDateString("en-GB");
      }
      return "--";
    }
  },
  watch: {}
});

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      invoiceHeader: [{ text: "Date", value: "date", sortable: true },
      // { text: "Invoice Key", value: "key" },
      // { text: "Invoice ID", value: "invoiceId" },
      { text: "Customer Name", value: "name" }, { text: "PrincipalAmount", value: "principalAmount" }, { text: "Debit", value: "InterestAmount" }, { text: "Credit", value: "InterestAmount" }, { text: "TotalAmount", value: "TotalAmount" }, { text: "Payment Type", value: "paymentType" }, { text: "Firm", value: "firmName" }],
      selectedFirm: null,
      filterInvoiceFrom: null,
      filterInvoiceTo: null,
      fromdatepicker: false,
      todatepicker: false
    };
  },
  created: function created() {
    this.$bindAsObject("firm", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsObject("buyerById", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsObject("sellerById", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray("customerDeposits", this.$root.$firebaseRefs.customerDeposit.orderByChild('brand').equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear", "brandFinYear"]), {
    firmsByBrand1: function firmsByBrand1() {
      var _this = this;

      return this.firms.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      });
    },

    // current brands firm list
    firmsByBrand: function firmsByBrand() {
      var _this2 = this;

      // return selected brand firms
      var firmsB = this.firms.filter(function (item) {
        return item['brand'] === _this2.selectedBrand;
      });
      firmsB.map(function (item) {
        if (item.defaultFirm) {
          _this2.selectedFirm = item;
        }
      });
      return firmsB;
    },
    getInvoice: function getInvoice() {
      var _this3 = this;

      var toDate = this.toDate ? new Date(this.toDate).getTime() : null;
      var fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
      var invoices = this.customerDeposits.filter(function (item) {
        // return ((this.selectedFirm ? item['firm'] === this.selectedFirm['.key'] : true) &&
        return item["brand"] === _this3.selectedBrand && (_this3.selectedFirm ? item['firm'] === _this3.selectedFirm['.key'] : true) && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true) && item.deleted != true && item.date >= _this3.finYear.start && item.date <= _this3.finYear.end && (item["status"] == 'paid' || item["status"] == 'partial') && (item["type"] === "LoanGiven" || item["type"] === "LoanTaken" || item["type"] === "Opening Balance" && (item["parentType"] == 'LoanTaken' || item["parentType"] == 'LoanGiven'));
      });
      return invoices;
    }
  }),
  methods: {
    dayDiff: function dayDiff(dt1, dt2) {
      return Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24));
    },
    getInterest: function getInterest(loan) {
      var dayDiff = this.dayDiff(new Date(loan.interestDate), new Date());
      return this.calculateInterest(loan.amount, loan.interest, dayDiff);
    },
    calculateInterest: function calculateInterest(P, R, N) {
      var interestRate = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(P) * __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(R) / 3000 * N;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(interestRate).toFixed(2);
    },
    getCurrentUserName: function getCurrentUserName(buyerId) {
      var buyer = this.buyerById[buyerId];
      var seller = this.sellerById[buyerId];
      var currentUser = buyer && buyer.state ? buyer : seller && seller.state ? seller : {};
      return currentUser.name;
    },

    // getFirmName1(firmId) {
    //   if (this.firm && this.firm[firmId]) {
    //     return this.firm[firmId]["name"];
    //   }
    //   return "--";
    // },
    getFirmName: function getFirmName(e) {
      var firm = void 0;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter(function (item) {
          return item[".key"] === e;
        })[0];
      }
      if (firm) return firm.name;
    },
    renderDate: function renderDate(timeStamp) {
      if (timeStamp) {
        return new Date(timeStamp).toLocaleDateString("en-GB");
      }
      return "--";
    }
  },
  watch: {}
});

/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    bankByBrand: { type: Array }
  },
  data: function data() {
    return {
      selectedFirm: null,
      toDate: null,
      detailedView: false,
      fromDate: null,
      datepickerFrom: false,
      datepickerTo: false,
      selectedfromDate: null,
      selectedtoDate: null,
      totalSundryCreditors: 0,
      totalSundryDebitors: 0,
      totalSundryDebitorsOpening: 0,
      totalLoan: 0,
      totalLoanAndAdvances: 0,
      buyerList: [],
      sellerList: [],
      expensesWPro: [],
      expenseTotal: 0,
      totalUnsecuredLoanOpening: 0,
      provisionOpeningBal: 0,
      liabilityOpeningBalanace: 0,
      loanObj: {
        expand: false,
        securedLoanObj: {
          expand: false
        },
        unsecuredLoanObj: {
          expand: false
        }
      },
      loanAdvancesObj: {
        expand: false,
        unsecuredLoanAdvancesObj: {
          expand: false
        }
        // securedLoanObj : {
        //   expand : false
        // },
      },
      liabilitiesObj: {
        expand: false,
        sundryCreditorsObj: {
          expand: false
        },
        provisionObj: {
          expand: false
        },
        liabilitiesObj: {
          expand: false
        },
        gstObj: {
          expand: false
        }
      },
      fixedAssetsObj: {
        expand: false
      },
      intangibleAssetsObj: {
        expand: false
      },
      firmObj: {
        total: 0,
        list: [],
        expand: false
      },
      cashInHand: {
        total: 0,
        totalOpeningBal: 0,
        list: [],
        expand: false
      },
      debtors: {
        total: 0,
        list: [],
        expand: false
      },
      creditors: {
        total: 0,
        list: [],
        expand: false
      },
      bankObj: {
        total: 0,
        list: [],
        expand: false
      },
      saleReturn: {
        total: 0,
        list: [],
        expand: false
      },
      purchaseReturn: {
        total: 0,
        list: [],
        expand: false
      },
      expensesObj: {
        total: 0,
        totalOpeningBal: 0,
        list: [],
        direct: {
          expand: false,
          total: 0,
          totalOpeningBal: 0
        },
        indirect: {
          expand: false,
          total: 0,
          totalOpeningBal: 0
        }
      },
      incomes: {
        total: 0,
        totalOpeningBal: 0,
        list: [],
        direct: {
          expand: false,
          totalOpeningBal: 0,
          total: 0
        },
        indirect: {
          expand: false,
          totalOpeningBal: 0,
          total: 0
        }
      },
      assetsObj: {
        total: 0,
        list: [],
        expand: false
      },
      discount: {
        total: 0,
        list: [],
        expand: false
      },
      sale: {
        total: 0,
        list: [],
        expand: false
      },
      purchase: {
        total: 0,
        list: [],
        expand: false
      },
      investmentsObj: {
        expand: false
      },
      currentAssetsObj: {
        expand: false,
        sundryDebtorsObj: {
          expand: false
        },
        cashInHandObj: {
          expand: false
        },
        bankAccountsObj: {
          expand: false
        },
        gstReceivableObj: {
          expand: false
        }
      }

    };
  },
  created: function created() {
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("buyers", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("sellers", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("expenses", this.$root.$firebaseRefs.expenses.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("incomesList", this.$root.$firebaseRefs.incomes.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("assets", this.$root.$firebaseRefs.assets.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('liabilities', this.$root.$firebaseRefs.liabilities.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("customerDeposit", this.$root.$firebaseRefs.customerDeposit.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('accounts', this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
    this.getData();
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear"]), {
    // firmsByBrand() {
    //   return this.firms.filter(item => item["brand"] === this.selectedBrand);
    // },

    // current brands firm list
    firmsByBrand: function firmsByBrand() {
      var _this = this;

      // return selected brand firms
      var firmsB = this.firms.filter(function (item) {
        return item['brand'] === _this.selectedBrand;
      });
      firmsB.map(function (item) {
        if (item.defaultFirm) {
          _this.selectedFirm = item;
        }
      });
      return firmsB;
    },

    // firmsByBrand () {
    // 	let list = this.firms.filter((item) =>
    // 		item['brand'] === this.selectedBrand
    //   )
    //   .map(item => {
    // 		return {
    // 			text: item['name'],
    //       value: item['.key']
    // 		}
    //   });
    //   if(list.length > 0){
    //     this.updateAndEmit('firms', list[0].value)
    //   }
    //   return list;
    // },

    totalDebit: function totalDebit() {
      return ((this.bankObj.total ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.bankObj.total) : 0) + (this.expensesObj.total ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.expensesObj.total) : 0) + (this.assetsObj.total ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.assetsObj.total) : 0) + (
      //  (this.debtors.total ? Number.parseFloat(this.debtors.total) : 0) + 
      this.purchase.total ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.purchase.total) : 0) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.totalAssetAmount) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.totalInvestmentAmount) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.totalIntangibleAmount) + (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.totalSundryDebitors) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.savingsCurrentBankListTotal) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.cashInHand.total) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.ITCData.assets.IGST) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.ITCData.assets.SGST) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.ITCData.assets.CGST)) + (this.saleReturn.total ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.saleReturn.total) : 0)).toFixed(2);
    },
    totalCredit: function totalCredit() {
      return ((this.firmObj.total ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.firmObj.total) : 0) + (this.sale.total ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.sale.total) : 0) + (this.purchaseReturn.total ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.purchaseReturn.total) : 0) + (this.incomes.total ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.incomes.total) : 0) +
      // (this.creditors.total ? Number.parseFloat(this.creditors.total):0 )+
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.securedLoansBankListTotal + this.totalLoan) + (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.liabilityTotal) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.totalSundryCreditors) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.expenseTotal) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.ITCData.liabilities.IGST) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.ITCData.liabilities.SGST) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.ITCData.liabilities.CGST)) + (this.discount.total ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.discount.total) : 0)).toFixed(2);
    },
    totalOpening: function totalOpening() {
      return (this.firmObj.total ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.firmObj.total) : 0) + (this.securedLoansBankListTotalOpening ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.securedLoansBankListTotalOpening) : 0) + (this.totalUnsecuredLoanOpening ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.totalUnsecuredLoanOpening) : 0) + (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.totalUnsecuredLoanOpening) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.provisionOpeningBal) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.liabilityOpeningBalanace)) + (this.totalUnsecuredLoanOpening ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.totalUnsecuredLoanOpening) : 0) + (this.totalAssetOpening ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.totalAssetOpening) : 0) + (this.totalIntangibleOpening ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.totalIntangibleOpening) : 0) + (this.totalInvestmentOpening ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.totalInvestmentOpening) : 0) + (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.totalSundryDebitorsOpening) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.cashInHand.totalOpeningBal) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.savingsCurrentBankListTotalOpening)) + (this.expensesObj.totalOpeningBal ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.expensesObj.totalOpeningBal) : 0) + (this.incomes.totalOpeningBal ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.incomes.totalOpeningBal) : 0);
    },
    totalClosing: function totalClosing() {
      return this.getClosingBalance(this.totalOpening, this.totalDebit, this.totalCredit);
    },
    ITCData: function ITCData() {
      var _this2 = this;

      var inputGST = {
        IGST: 0,
        CGST: 0,
        SGST: 0
      };
      var outputGST = {
        IGST: 0,
        CGST: 0,
        SGST: 0
      };
      var toDate = this.toDate ? new Date(this.toDate).getTime() : null;
      var fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
      var filteredInvoices = this.invoices.filter(function (item) {
        return item["brand"] === _this2.selectedBrand && item['items'] && item['items'].length && item.date >= _this2.finYear.start && item.date <= _this2.finYear.end && item.deleted != true && (_this2.selectedFirm ? item["firm"] == _this2.selectedFirm['.key'] : true) && (_this2.selectedfromDate ? item.date >= fromDate : true) && (_this2.selectedtoDate ? item.date <= toDate : true);
      });
      filteredInvoices.map(function (invoice) {
        if (invoice.isBuyer) {
          invoice.items.map(function (item) {
            outputGST.SGST += item.SGST_val && !item.SGST_ITC_paid ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.SGST_val) : 0;
            outputGST.CGST += item.CGST_val && !item.CGST_ITC_paid ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.CGST_val) : 0;
            outputGST.IGST += item.IGST_val && !item.IGST_ITC_paid ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.IGST_val) : 0;
          });
        } else {
          invoice.items.map(function (item) {
            inputGST.SGST += item.SGST_val && !item.SGST_ITC_paid ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.SGST_val) : 0;
            inputGST.CGST += item.CGST_val && !item.CGST_ITC_paid ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.CGST_val) : 0;
            inputGST.IGST += item.IGST_val && !item.IGST_ITC_paid ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.IGST_val) : 0;
          });
        }
      });

      var returnOBJ = {
        liabilities: {
          SGST: 0,
          CGST: 0,
          IGST: 0
        },
        assets: {
          SGST: 0,
          CGST: 0,
          IGST: 0
        }

        //IGST
      };if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(outputGST.IGST) < __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inputGST.IGST)) {
        returnOBJ.assets.IGST = (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inputGST.IGST) - (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(outputGST.IGST) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(outputGST.CGST) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(outputGST.SGST))).toFixed(2);
      } else {
        returnOBJ.assets.IGST = 0;
      }

      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(outputGST.IGST) > __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inputGST.IGST)) {
        returnOBJ.liabilities.IGST = (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(outputGST.IGST) - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inputGST.IGST)).toFixed(2);
      } else {
        returnOBJ.liabilities.IGST = 0;
      }

      //CGST
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inputGST.CGST) > __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(outputGST.CGST)) {
        returnOBJ.assets.CGST = (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inputGST.CGST) - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(outputGST.CGST)).toFixed(2);
      } else {
        returnOBJ.assets.CGST = 0;
      }

      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inputGST.CGST) < __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(outputGST.CGST)) {
        returnOBJ.liabilities.CGST = (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(outputGST.CGST) - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inputGST.CGST)).toFixed(2);
      } else {
        returnOBJ.liabilities.CGST = 0;
      }

      //SGST
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inputGST.SGST) > __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(outputGST.SGST)) {
        returnOBJ.assets.SGST = (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inputGST.SGST) - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(outputGST.SGST)).toFixed(2);
      } else {
        returnOBJ.assets.SGST = 0;
      }

      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inputGST.SGST) < __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(outputGST.SGST)) {
        returnOBJ.liabilities.SGST = (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(outputGST.SGST) - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inputGST.SGST)).toFixed(2);
      } else {
        returnOBJ.liabilities.SGST = 0;
      }
      return returnOBJ;
    },
    accountByBrand: function accountByBrand() {
      var _this3 = this;

      var accounts = this.accounts.filter(function (account) {
        return account.brand === _this3.selectedBrand;
      });
      if (this.selectedFirm) {
        return accounts.filter(function (account) {
          return account.firm === _this3.selectedFirm['.key'];
        });
      }
      return accounts;
    },
    creditorsById: function creditorsById() {
      return this.creditorByBrand.map(function (item) {
        return item['.key'];
      });
    },

    // list customer by Id for diff for invoice 
    customersById: function customersById() {
      return this.customerByBrand.map(function (item) {
        return item['.key'];
      });
    },
    invoiceByBrandAndFirm: function invoiceByBrandAndFirm() {
      var _this4 = this;

      if (!this.invoices) {
        return [];
      };
      var filter = this.invoices.filter(function (item) {
        return item['brand'] === _this4.selectedBrand && item.deleted != true && item.date >= _this4.finYear.start && item.date <= _this4.finYear.end;
      });
      if (this.selectedFirm) {
        filter = filter.filter(function (item) {
          return item.firm === _this4.selectedFirm['.key'];
        });
      }
      if (this.fromDate) {
        var from = new Date(this.fromDate).setHours(0, 0, 0, 0);
        filter = filter.filter(function (item) {
          return item.date >= from;
        });
      }
      if (this.toDate) {
        var to = new Date(this.toDate).setHours(23, 29, 59, 999);
        filter = filter.filter(function (item) {
          return item.date <= to;
        });
      }
      return filter;
    },

    // all invoice which are credited
    creditedInvoice: function creditedInvoice() {
      return this.invoiceByBrandAndFirm.filter(function (invoice) {
        return invoice.isCredited;
      });
    },

    // all invoice which are debited
    debitedInvoice: function debitedInvoice() {
      return this.invoiceByBrandAndFirm.filter(function (invoice) {
        return !invoice.isCredited;
      });
    },

    // expense list type by brand
    expenseByBrand: function expenseByBrand() {
      var _this5 = this;

      if (!this.expenses) {
        return [];
      };
      // return expense with underhead 
      return this.expenses.filter(function (item) {
        return item['brand'] === _this5.selectedBrand;
      }).map(function (item) {
        return item['.key'];
      });
    },
    liabilityByBrand: function liabilityByBrand() {
      var _this6 = this;

      if (!this.liabilities) {
        return [];
      };
      // return expense with underhead 
      return this.liabilities.filter(function (item) {
        return item['brand'] === _this6.selectedBrand;
      }).map(function (item) {
        return item['.key'];
      });
    },

    // expense for which expense type is for brands
    invoiceByExpense: function invoiceByExpense() {
      var _this7 = this;

      return this.invoiceByBrandAndFirm.filter(function (invoice) {
        if (invoice.expenseType) {
          return _this7.expenseByBrand.includes(invoice.expenseType);
        }
        return false;
      });
    },
    invoiceByLiability: function invoiceByLiability() {
      var _this8 = this;

      return this.invoiceByBrandAndFirm.filter(function (invoice) {
        if (invoice.liabilityType) {
          return _this8.liabilityByBrand.includes(invoice.liabilityType);
        }
        return false;
      });
    },

    // total amount for expense by current brand
    invoiceByExpenseTotal: function invoiceByExpenseTotal() {
      return this.invoiceByExpense.reduce(function (total, item) {
        return total + item.totalAmount;
      }, 0);
    },

    // total amount for liability by current brand
    invoiceByLiabilityTotal: function invoiceByLiabilityTotal() {
      return this.invoiceByLiability.reduce(function (total, item) {
        return total + item.totalAmount;
      }, 0);
    },

    // total Profit income from invoice by brand and firms
    invoiceTotalIncome: function invoiceTotalIncome() {
      return this.invoiceByBrandAndFirm.reduce(function (total, item) {
        // calculate total Income for expense
        return total + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item['profit'] || 0);
      }, 0);
    },

    // for liabilities
    //  closing balance from net propA/C by firms
    propCapitalAC: function propCapitalAC() {
      if (!this.selectedFirm) {
        return 0;
      }
      return this.selectedFirm.openingBalance;
    },

    // all invoice for brand with status "open"
    openInvoices: function openInvoices() {
      return this.invoiceByBrandAndFirm.filter(function (item) {
        return item.status === 'open';
      });
    },

    // all invoice by creditors
    openInvoiceByCreditor: function openInvoiceByCreditor() {
      var invoice = [];
      for (var i = 0; i !== this.openInvoices.length; i++) {
        // diff invoice by customeId to creditor
        if (this.creditorsById.includes(this.openInvoices[i].customerId)) {
          invoice.push(this.openInvoices[i]);
        }
      }
      return invoice;
    },

    // all invoice by customer (debtors)
    openInvoiceByCustomer: function openInvoiceByCustomer() {
      var invoice = [];
      for (var i = 0; i !== this.openInvoices.length; i++) {
        // diff invoice by customeId to customer
        if (this.customersById.includes(this.openInvoices[i].customerId)) {
          invoice.push(this.openInvoices[i]);
        }
      }
      return invoice;
    },

    // creditor invoice where item type is gold/silver
    openInvoiceByCreditorSundry: function openInvoiceByCreditorSundry() {
      return this.openInvoiceByCreditor.filter(function (invoice) {
        if (invoice.items && invoice.items[0]) {
          return invoice.items[0].type === 'Gold' || invoice.items[0].type === 'Silver';
        }
        return false;
      });
    },

    // creditor invoice where item type is "without item"
    openInvoiceByCreditorUnsecured: function openInvoiceByCreditorUnsecured() {
      return this.openInvoiceByCreditor.filter(function (invoice) {
        if (invoice.items && invoice.items[0]) {
          return invoice.items[0].type === "Without item";
        }
        return false;
      });
    },


    // creditor invoice where item type is gold/silver
    openInvoiceByCustomerSundry: function openInvoiceByCustomerSundry() {
      return this.openInvoiceByCustomer.filter(function (invoice) {
        if (invoice.items && invoice.items[0]) {
          return invoice.items[0].type === 'Gold' || invoice.items[0].type === 'Silver';
        }
        return false;
      });
    },

    // creditor invoice where item type is "without item"
    openInvoiceByCustomerLoanNAdvances: function openInvoiceByCustomerLoanNAdvances() {
      return this.openInvoiceByCustomer.filter(function (invoice) {
        if (invoice.items && invoice.items[0]) {
          return invoice.items[0].type === "Without item";
        }
        return false;
      });
    },

    // Sundry Creditor total: Transaction with item taken by Creditor
    sundryCreditors: function sundryCreditors() {
      return this.openInvoiceByCreditorSundry.reduce(function (total, item) {
        return total + item.totalAmount;
      }, 0);
    },
    sundryCreditorsList: function sundryCreditorsList() {
      var creditor = {};
      var calculated = [];
      try {
        this.openInvoiceByCreditorSundry.forEach(function (invoice) {
          if (creditor[invoice.customerId]) {
            creditor[invoice.customerId].push(invoice);
          } else {
            creditor[invoice.customerId] = [invoice];
          }
        });
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(creditor).forEach(function (customer) {
          var list = creditor[customer] || [];
          calculated.push({
            type: 'creditor',
            invoices: creditor[customer],
            id: customer,
            amount: list.reduce(function (total, item) {
              return total + item.totalAmount;
            }, 0)
          });
        });
      } catch (e) {
        console.info(e);
        return calculated;
      }
      return calculated;
    },

    // Creditors Unsecured Loans Total: landing money without item by Creditor
    unsecuredLoans: function unsecuredLoans() {
      return this.openInvoiceByCreditorUnsecured.reduce(function (total, item) {
        return total + item.totalAmount;
      }, 0);
    },
    unsecuredLoansList: function unsecuredLoansList() {
      var customers = {};
      var customerList = [];
      try {
        this.openInvoiceByCreditorUnsecured.forEach(function (invoice) {
          if (customers[invoice.customerId]) {
            customers[invoice.customerId].push(invoice);
          } else {
            customers[invoice.customerId] = [invoice];
          }
        });
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(customers).forEach(function (items) {
          var list = customers[items] || [];
          customerList.push({
            type: 'creditor',
            invoices: customers[items],
            id: items,
            amount: list.reduce(function (total, item) {
              return total + item.totalAmount;
            }, 0)
          });
        });
      } catch (e) {
        console.info(e);
      }
      return customerList;
    },

    // Debtors Total: Transaction with item taken by Customer(debtors)
    sundryDebtors: function sundryDebtors() {
      return this.openInvoiceByCustomerSundry.reduce(function (total, item) {
        return total + item.totalAmount;
      }, 0);
    },
    sundryDebtorsList: function sundryDebtorsList() {
      var customers = {};
      var customerList = [];
      try {
        this.openInvoiceByCustomerSundry.forEach(function (invoice) {
          if (customers[invoice.customerId]) {
            customers[invoice.customerId].push(invoice);
          } else {
            customers[invoice.customerId] = [invoice];
          }
        });
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(customers).forEach(function (items) {
          var list = customers[items] || [];
          customerList.push({
            type: 'customer',
            invoices: customers[items],
            id: items,
            amount: list.reduce(function (total, item) {
              return total + item.totalAmount;
            }, 0)
          });
        });
      } catch (e) {
        console.info(e);
      }
      return customerList;
    },

    // landing money without by Customer (debtors)
    loansAndAdvances: function loansAndAdvances() {
      return this.openInvoiceByCustomerLoanNAdvances.reduce(function (total, item) {
        return total + item.totalAmount;
      }, 0);
    },
    loansAndAdvancesList: function loansAndAdvancesList() {
      var customers = {};
      var customerList = [];
      try {
        this.openInvoiceByCustomerLoanNAdvances.forEach(function (invoice) {
          if (customers[invoice.customerId]) {
            customers[invoice.customerId].push(invoice);
          } else {
            customers[invoice.customerId] = [invoice];
          }
        });
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(customers).forEach(function (items) {
          var list = customers[items] || [];
          customerList.push({
            type: 'customer',
            invoices: customers[items],
            id: items,
            amount: list.reduce(function (total, item) {
              return total + item.totalAmount;
            }, 0)
          });
        });
      } catch (e) {
        console.info(e);
      }
      return customerList;
    },

    // bank with list
    securedLoansBankList: function securedLoansBankList() {
      return this.accountByBrand.filter(function (bank) {
        return bank.accountType === 'Loan A/C' || bank.accountType === 'Overdraft A/C';
      });
    },

    // Total of amount of secured loans bank
    securedLoansBankListTotal: function securedLoansBankListTotal() {
      return this.securedLoansBankList.reduce(function (total, bank) {
        return total + bank.amount;
      }, 0);
    },
    securedLoansBankListTotalOpening: function securedLoansBankListTotalOpening() {
      return this.securedLoansBankList.reduce(function (openingBalance, bank) {
        return openingBalance + bank.openingBalance;
      }, 0);
    },

    // secured account bank list
    savingsCurrentBankList: function savingsCurrentBankList() {
      return this.accountByBrand.filter(function (bank) {
        return bank.accountType === 'Saving A/C' || bank.accountType === 'Current A/C';
      });
    },

    // total of amount of saving/current bank account
    savingsCurrentBankListTotal: function savingsCurrentBankListTotal() {
      return this.savingsCurrentBankList.reduce(function (total, bank) {
        return total + bank.amount;
      }, 0);
    },
    savingsCurrentBankListTotalOpening: function savingsCurrentBankListTotalOpening() {
      return this.savingsCurrentBankList.reduce(function (total, bank) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(total) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(bank.openingBalance);
      }, 0);
    },

    // cash in hand: firms available cash
    // cashInHand() {
    //   if(this.selectedFirm) {
    //     const firm = this.firmsByBrand.find(firm => firm.value === this.selectedFirm);
    //     return firm.item.amount
    //   }
    //   return this.firmsByBrand.reduce((balance, firm) => {
    //     return balance = balance + firm.item.amount
    //   }, 0)
    // },
    totalAssetAmount: function totalAssetAmount() {
      return this.getAssetAccount.reduce(function (total, item) {
        return item.details.totalAmount + item.details.openingBalance - ((item.details.totalAmount + item.details.openingBalance) * (item.details.depriciation / 100) || 0) + total;
      }, 0);
    },
    totalAssetOpening: function totalAssetOpening() {
      return this.getAssetAccount.reduce(function (total, item) {
        return (item.details.openingBalance || 0) + total;
      }, 0);
    },
    totalIntangibleAmount: function totalIntangibleAmount() {
      return this.getIntangibleAccount.reduce(function (total, item) {
        return item.details.totalAmount + item.details.openingBalance - ((item.details.totalAmount + item.details.openingBalance) * (item.details.depriciation / 100) || 0) + total;
      }, 0);
    },
    totalIntangibleOpening: function totalIntangibleOpening() {
      return this.getIntangibleAccount.reduce(function (total, item) {
        return (item.details.openingBalance || 0) + total;
      }, 0);
    },
    totalInvestmentAmount: function totalInvestmentAmount() {
      return this.getInvestmentAccount.reduce(function (total, item) {
        return item.details.totalAmount + item.details.openingBalance + total;
      }, 0);
    },
    totalInvestmentOpening: function totalInvestmentOpening() {
      return this.getInvestmentAccount.reduce(function (total, item) {
        return item.details.openingBalance + total;
      }, 0);
    },
    assetByBrand: function assetByBrand() {
      var _this9 = this;

      if (!this.assets) {
        return [];
      };
      // return asset with underhead 
      return this.assets.filter(function (item) {
        return item['brand'] === _this9.selectedBrand && item.type != 'investments' && 'intangibleAssets';
      });
    },
    assetAsIntangibleByBrand: function assetAsIntangibleByBrand() {
      var _this10 = this;

      if (!this.assets) {
        return [];
      };
      // return asset with underhead 
      return this.assets.filter(function (item) {
        return item['brand'] === _this10.selectedBrand && item.type === 'intangibleAssets';
      });
    },
    assetAsInvestmentByBrand: function assetAsInvestmentByBrand() {
      var _this11 = this;

      if (!this.assets) {
        return [];
      };
      // return asset with underhead 
      return this.assets.filter(function (item) {
        return item['brand'] === _this11.selectedBrand && item.type === 'investments';
      });
    },
    invoiceByBrand: function invoiceByBrand() {
      var _this12 = this;

      if (!this.invoices) {
        return [];
      };
      var filter = this.invoices.filter(function (item) {
        return item['brand'] === _this12.selectedBrand && item.date >= _this12.finYear.start && item.deleted != true && item.date <= _this12.finYear.end;
      });
      if (this.selectedFirm) {
        filter = filter.filter(function (item) {
          return item.firm === _this12.selectedFirm['.key'];
        });
      }
      if (this.fromDate) {
        var from = new Date(this.fromDate).setHours(0, 0, 0, 0);
        filter = filter.filter(function (item) {
          return item.date >= from;
        });
      }
      if (this.toDate) {
        var to = new Date(this.toDate).setHours(23, 29, 59, 999);
        filter = filter.filter(function (item) {
          return item.date <= to;
        });
      }
      return filter;
    },
    getAssetAccount: function getAssetAccount() {
      var _this13 = this;

      var mainGroup = []; // { details: {} && invoices: []}
      try {
        this.assetByBrand.forEach(function (details) {
          var invoices = _this13.invoiceByBrand.filter(function (invoice) {
            if (_this13.selectedFirm) {
              // return invoice of selected firmId
              return invoice.assetType === details['.key'] && invoice.firm === _this13.selectedFirm['.key'];
            }
            // return all matched key invoices
            return invoice.assetType === details['.key'];
          });
          details.totalAmount = invoices.reduce(function (total, item) {
            return total + item.totalAmount;
          }, 0);
          details.openingBalance = invoices.reduce(function (total, item) {
            return total + item.openingBalance;
          }, 0);
          if (details.totalAmount) {
            mainGroup.push({
              details: details,
              invoices: invoices,
              expand: false
            });
          } else if (details.openingBalance) {
            mainGroup.push({
              details: details,
              invoices: invoices,
              expand: false
            });
          }
        });
        return mainGroup;
      } catch (e) {
        console.info(e);
        return [];
      }
    },


    // Intangible Assets
    getIntangibleAccount: function getIntangibleAccount() {
      var _this14 = this;

      var mainGroup = []; // { details: {} && invoices: []}
      try {
        this.assetAsIntangibleByBrand.forEach(function (details) {
          var invoices = _this14.invoiceByBrand.filter(function (invoice) {
            if (_this14.selectedFirm) {
              // return invoice of selected firmId
              return invoice.assetType === details['.key'] && invoice.firm === _this14.selectedFirm['.key'];
            }
            // return all matched key invoices
            return invoice.assetType === details['.key'];
          });
          details.totalAmount = invoices.reduce(function (total, item) {
            return total + item.totalAmount;
          }, 0);
          details.openingBalance = invoices.reduce(function (total, item) {
            return total + item.openingBalance;
          }, 0);
          if (details.totalAmount) {
            mainGroup.push({
              details: details,
              invoices: invoices,
              expand: false
            });
          } else if (details.openingBalance) {
            mainGroup.push({
              details: details,
              invoices: invoices,
              expand: false
            });
          }
        });
        return mainGroup;
      } catch (e) {
        console.info(e);
        return [];
      }
    },

    // Investment Assets
    getInvestmentAccount: function getInvestmentAccount() {
      var _this15 = this;

      var mainGroup = []; // { details: {} && invoices: []}
      try {
        this.assetAsInvestmentByBrand.forEach(function (details) {
          var invoices = _this15.invoiceByBrand.filter(function (invoice) {
            if (_this15.selectedFirm) {
              // return invoice of selected firmId
              return invoice.assetType === details['.key'] && invoice.firm === _this15.selectedFirm['.key'];
            }
            // return all matched key invoices
            return invoice.assetType === details['.key'];
          });
          details.totalAmount = invoices.reduce(function (total, item) {
            return total + item.totalAmount;
          }, 0);
          details.openingBalance = invoices.reduce(function (total, item) {
            return total + item.openingBalance;
          }, 0);
          if (details.totalAmount) {
            mainGroup.push({
              details: details,
              invoices: invoices
            });
          } else if (details.openingBalance) {
            mainGroup.push({
              details: details,
              invoices: invoices
            });
          }
        });
        return mainGroup;
      } catch (e) {
        console.info(e);
        return [];
      }
    }
  }),
  methods: {
    toggle: function toggle(item) {
      item.expand = !item.expand;
    },
    getClosingBalance: function getClosingBalance(opening, debit, credit) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(opening) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(debit) - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(credit);
    },
    getData: function getData() {
      this.propCapital();
      this.getDebtors();
      this.getCreditors();
      this.getBanks();
      this.getSaleReturn();
      this.getPurchaseReturn();
      this.getExpenses();
      this.getIncomes();
      this.getAssets();
      this.usersByBrand();
      this.expenseWithProvision();
      this.liabilityWithProvision();
    },
    getFilteredData: function getFilteredData() {
      this.getData();
    },
    propCapital: function propCapital() {
      var _this16 = this;

      this.firmObj = {
        total: 0,
        list: [],
        expand: false
      };
      this.cashInHand = {
        total: 0,
        totalOpeningBal: 0,
        list: [],
        expand: false
      };
      this.firmObj.list = this.firms.filter(function (item) {
        return item["brand"] === _this16.selectedBrand && (_this16.selectedFirm ? item[".key"] == _this16.selectedFirm['.key'] : true);
      });
      this.cashInHand.list = this.firmObj.list;
      this.firmObj.list.map(function (firm) {
        _this16.firmObj.total += firm.openingBalance ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(firm.openingBalance) : 0;
        _this16.cashInHand.total += firm.amount ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(firm.amount) : 0;
        _this16.cashInHand.totalOpeningBal += firm.openingStock ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(firm.openingStock) : 0;
      });
      this.firmObj.total = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.firmObj.total).toFixed(2);
      this.cashInHand.total = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.cashInHand.total).toFixed(2);
      this.cashInHand.totalOpeningBal = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.cashInHand.totalOpeningBal).toFixed(2);
    },
    getDebtors: function getDebtors() {
      var _this17 = this;

      this.debtors = {
        total: 0,
        list: [],
        expand: false
      };
      this.sale = {
        total: 0,
        list: [],
        expand: false
      };
      this.debtors.list = this.buyers.filter(function (item) {
        return item["brand"] === _this17.selectedBrand;
      });
      this.sale.list = this.debtors.list;
      this.debtors.list.map(function (buyer, index) {
        var invoices = _this17.invoices.filter(function (item) {
          return item["brand"] === _this17.selectedBrand && item['buyerId'] === buyer['.key'] && (_this17.selectedFirm ? item["firm"] == _this17.selectedFirm['.key'] : true) && item.date >= _this17.finYear.start && item.date <= _this17.finYear.end && item.deleted != true && (_this17.selectedfromDate ? item.date >= _this17.selectedfromDate : true) && (_this17.selectedtoDate ? item.date <= _this17.selectedtoDat : true);
        });
        var remainingAmountTotal = 0;
        var total = 0;
        invoices.map(function (invoice) {
          _this17.debtors.total += invoice.remainingAmount ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(invoice.remainingAmount) : 0;
          _this17.sale.total += invoice.totalAmount ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(invoice.totalAmount) : 0;
          remainingAmountTotal += invoice.remainingAmount ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(invoice.remainingAmount) : 0;
          total += invoice.totalAmount ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(invoice.totalAmount) : 0;
        });
        _this17.debtors.list[index]['remainingAmount'] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(remainingAmountTotal).toFixed(2);
        _this17.sale.list[index]['totalAmount'] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(total).toFixed(2);
      });
      this.debtors.total = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.debtors.total).toFixed(2);
      this.sale.total = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.sale.total).toFixed(2);
    },
    getCreditors: function getCreditors() {
      var _this18 = this;

      this.creditors = {
        total: 0,
        list: [],
        expand: false
      };
      this.discount = {
        total: 0,
        list: [],
        expand: false
      };
      this.purchase = {
        total: 0,
        list: [],
        expand: false
      };
      this.creditors.list = this.sellers.filter(function (item) {
        return item["brand"] === _this18.selectedBrand;
      });
      this.discount.list = this.creditors.list;
      this.purchase.list = this.creditors.list;
      this.creditors.list.map(function (buyer, index) {
        var invoices = _this18.invoices.filter(function (item) {
          return item["brand"] === _this18.selectedBrand && item['buyerId'] === buyer['.key'] && (_this18.selectedFirm ? item["firm"] == _this18.selectedFirm['.key'] : true) && item.date >= _this18.finYear.start && item.date <= _this18.finYear.end && (_this18.selectedfromDate ? item.date >= _this18.selectedfromDate : true) && (_this18.selectedtoDate ? item.date <= _this18.selectedtoDat : true);
        });
        var remainingAmountTotal = 0;
        var discount = 0;
        var total = 0;
        invoices.map(function (invoice) {
          _this18.creditors.total += invoice.remainingAmount ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(invoice.remainingAmount) : 0;
          remainingAmountTotal += invoice.remainingAmount ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(invoice.remainingAmount) : 0;
          discount += invoice.discountAmount ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(invoice.discountAmount) : 0;
          _this18.discount.total += invoice.discountAmount ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(invoice.discountAmount) : 0;
          total += invoice.totalAmount ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(invoice.totalAmount) : 0;
          _this18.purchase.total += invoice.totalAmount ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(invoice.totalAmount) : 0;
        });
        _this18.discount.list[index]['discountAmount'] = discount ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(discount).toFixed(2) : 0;
        _this18.creditors.list[index]['remainingAmount'] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(remainingAmountTotal).toFixed(2);
        _this18.purchase.list[index]['totalAmount'] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(total).toFixed(2);
      });
      this.creditors.total = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.creditors.total).toFixed(2);
      this.discount.total = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.discount.total).toFixed(2);
      this.purchase.total = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.purchase.total).toFixed(2);
    },
    getBanks: function getBanks() {
      var _this19 = this;

      this.bankObj = {
        total: 0,
        list: [],
        expand: false
      };
      this.bankObj.list = this.bankByBrand.filter(function (item) {
        return _this19.selectedFirm ? item["firm"] == _this19.selectedFirm['.key'] : true;
      });

      this.bankObj.list.map(function (bank) {
        _this19.bankObj.total += bank.amount ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(bank.amount) : 0;
      });
      this.bankObj.total = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.bankObj.total).toFixed(2);
    },
    getSaleReturn: function getSaleReturn() {
      var _this20 = this;

      this.saleReturn = {
        total: 0,
        list: [],
        expand: false
      };
      this.saleReturn.list = this.invoices.filter(function (item) {
        return item["brand"] === _this20.selectedBrand && item['return'] && item['isBuyer'] == true && item['parentInvoice'] && (_this20.selectedFirm ? item["firm"] == _this20.selectedFirm['.key'] : true) && item.date >= _this20.finYear.start && item.date <= _this20.finYear.end && (_this20.selectedfromDate ? item.date >= _this20.selectedfromDate : true) && (_this20.selectedtoDate ? item.date <= _this20.selectedtoDat : true);
      });
      this.saleReturn.list.map(function (inv) {
        var parentInvoice = _this20.invoices.filter(function (item) {
          return item['.key'] == inv.parentInvoice;
        })[0];
        inv.remainingAmount = parentInvoice.remainingAmount - inv.remainingAmount;
        _this20.saleReturn.total += inv.remainingAmount;
      });
      this.saleReturn.total = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.saleReturn.total).toFixed(2);
    },
    getPurchaseReturn: function getPurchaseReturn() {
      var _this21 = this;

      this.purchaseReturn = {
        total: 0,
        list: [],
        expand: false
      };
      this.purchaseReturn.list = this.invoices.filter(function (item) {
        return item["brand"] === _this21.selectedBrand && item['return'] && item['isBuyer'] == false && item['parentInvoice'] && (_this21.selectedFirm ? item["firm"] == _this21.selectedFirm['.key'] : true) && item.deleted != true && item.date >= _this21.finYear.start && item.date <= _this21.finYear.end && (_this21.selectedfromDate ? item.date >= _this21.selectedfromDate : true) && (_this21.selectedtoDate ? item.date <= _this21.selectedtoDat : true);
      });
      this.purchaseReturn.list.map(function (inv) {
        var parentInvoice = _this21.invoices.filter(function (item) {
          return item['.key'] == inv.parentInvoice;
        })[0];
        inv.remainingAmount = parentInvoice.remainingAmount - inv.remainingAmount;
        _this21.purchaseReturn.total += inv.remainingAmount;
      });
      this.purchaseReturn.total = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.purchaseReturn.total).toFixed(2);
    },
    getExpenses: function getExpenses() {
      var _this22 = this;

      this.expensesObj = {
        total: 0,
        totalOpeningBal: 0,
        list: [],
        direct: {
          expand: false,
          total: 0,
          totalOpeningBal: 0
        },
        indirect: {
          expand: false,
          total: 0,
          totalOpeningBal: 0
        }

      };
      this.expensesObj.list = this.expenses.filter(function (expense) {
        return expense.brand === _this22.selectedBrand;
      });
      this.expensesObj.list.map(function (ex, index) {
        var invoices = _this22.invoices.filter(function (invoice) {
          return invoice.brand === _this22.selectedBrand && invoice["expenseType"] === ex['.key'] && (_this22.selectedFirm ? invoice["firm"] == _this22.selectedFirm['.key'] : true) && invoice.date >= _this22.finYear.start && invoice.date <= _this22.finYear.end && (_this22.selectedfromDate ? invoice.date >= _this22.selectedfromDate : true) && (_this22.selectedtoDate ? invoice.date <= _this22.selectedtoDat : true);
        });
        var invoiceOpening = 0;
        invoices.map(function (inv, index) {
          _this22.expensesObj.list[index]['category'] = ex.category;
          invoiceOpening += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : inv.totalAmount ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount) : 0;
        });
        _this22.expensesObj.list[index]['openingBalance'] = invoiceOpening ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(invoiceOpening).toFixed(2) : 0;
        _this22.expensesObj.total += invoiceOpening ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(invoiceOpening) : 0;
        _this22.expensesObj.totalOpeningBal += invoiceOpening ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(invoiceOpening) : 0;
        if (ex.category == "Direct") {
          _this22.expensesObj.direct.total += invoiceOpening ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(invoiceOpening) : 0;
          _this22.expensesObj.direct.totalOpeningBal += invoiceOpening ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(invoiceOpening) : 0;
        } else {
          _this22.expensesObj.indirect.total += invoiceOpening ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(invoiceOpening) : 0;
          _this22.expensesObj.direct.totalOpeningBal += invoiceOpening ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(invoiceOpening) : 0;
        }
      });
      this.expensesObj.total = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.expensesObj.total).toFixed(2);
      this.expensesObj.direct.total = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.expensesObj.direct.total).toFixed(2);
      this.expensesObj.indirect.total = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.expensesObj.indirect.total).toFixed(2);

      this.expensesObj.totalOpeningBal = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.expensesObj.totalOpeningBal).toFixed(2);
      this.expensesObj.direct.totalOpeningBal = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.expensesObj.direct.totalOpeningBal).toFixed(2);
      this.expensesObj.indirect.totalOpeningBal = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.expensesObj.indirect.totalOpeningBal).toFixed(2);
    },
    getIncomes: function getIncomes() {
      var _this23 = this;

      this.incomes = {
        total: 0,
        totalOpeningBal: 0,
        list: [],
        direct: {
          expand: false,
          total: 0,
          totalOpeningBal: 0
        },
        indirect: {
          expand: false,
          total: 0,
          totalOpeningBal: 0
        }
      };
      this.incomes.list = this.incomesList.filter(function (income) {
        return income.brand === _this23.selectedBrand;
      });
      this.incomes.list.map(function (ex, index) {
        var invoices = _this23.invoices.filter(function (invoice) {
          return invoice.brand === _this23.selectedBrand && invoice["incomeType"] === ex['.key'] && (_this23.selectedFirm ? invoice["firm"] == _this23.selectedFirm['.key'] : true) && invoice.date >= _this23.finYear.start && invoice.date <= _this23.finYear.end && (_this23.selectedfromDate ? invoice.date >= _this23.selectedfromDate : true) && (_this23.selectedtoDate ? invoice.date <= _this23.selectedtoDat : true);
        });
        var invoiceOpening = 0;
        invoices.map(function (inv) {
          _this23.incomes.list[index]['category'] = ex.category;
          invoiceOpening += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : inv.totalAmount ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount) : 0;
        });
        _this23.incomes.list[index]['openingBalance'] = invoiceOpening ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(invoiceOpening).toFixed(2) : 0;
        _this23.incomes.total += invoiceOpening ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(invoiceOpening) : 0;
        _this23.incomes.totalOpeningBal += invoiceOpening ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(invoiceOpening) : 0;
        if (ex.category == "Direct") {
          _this23.incomes.direct.total += invoiceOpening ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(invoiceOpening) : 0;
          _this23.incomes.direct.totalOpeningBal += invoiceOpening ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(invoiceOpening) : 0;
        } else {
          _this23.incomes.indirect.total += invoiceOpening ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(invoiceOpening) : 0;
          _this23.incomes.indirect.totalOpeningBal += invoiceOpening ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(invoiceOpening) : 0;
        }
      });
      this.incomes.total = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.incomes.total).toFixed(2);
      this.incomes.direct.total = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.incomes.direct.total).toFixed(2);
      this.incomes.indirect.total = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.incomes.indirect.total).toFixed(2);

      this.incomes.totalOpeningBal = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.incomes.total).toFixed(2);
      this.incomes.direct.totalOpeningBal = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.incomes.direct.total).toFixed(2);
      this.incomes.indirect.totalOpeningBal = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.incomes.indirect.total).toFixed(2);
    },
    getAssets: function getAssets() {
      var _this24 = this;

      this.assetsObj = {
        total: 0,
        list: [],
        expand: false
      };
      this.assetsObj.list = this.assets.filter(function (asset) {
        return asset.brand === _this24.selectedBrand;
      });
      this.assetsObj.list.map(function (ex, index) {
        var invoices = _this24.invoices.filter(function (invoice) {
          return invoice.brand === _this24.selectedBrand && invoice["assetType"] === ex['.key'] && (_this24.selectedFirm ? invoice["firm"] == _this24.selectedFirm['.key'] : true) && invoice.date >= _this24.finYear.start && invoice.date <= _this24.finYear.end && (_this24.selectedfromDate ? invoice.date >= _this24.selectedfromDate : true) && (_this24.selectedtoDate ? invoice.date <= _this24.selectedtoDat : true);
        });
        var invoiceOpening = 0;
        invoices.map(function (inv) {
          invoiceOpening += (inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0) + (inv.totalAmount ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount) : 0);
        });
        _this24.assetsObj.list[index]['openingBalance'] = invoiceOpening ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(invoiceOpening).toFixed(2) : 0;
        _this24.assetsObj.total += invoiceOpening ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(invoiceOpening) : 0;
      });
      this.assetsObj.total = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.assetsObj.total).toFixed(2);
    },
    expenseWithProvision: function expenseWithProvision() {
      var _this25 = this;

      this.expenseTotal = 0;
      this.provisionOpeningBal = 0;
      var expenses = this.expenses.filter(function (expense) {
        return expense.brand === _this25.selectedBrand;
      });
      expenses = expenses.filter(function (expense) {
        return !!expense['.key'];
      });
      expenses.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = 'confirm';
        var invoices = _this25.invoices.filter(function (invoice) {
          return invoice.brand === _this25.selectedBrand && invoice["expenseType"] === ex['.key'] && invoice.date >= _this25.finYear.start && invoice.date <= _this25.finYear.end;
        });
        console.log(invoices);
        invoices.map(function (inv) {
          openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
          totalAmount += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          if (paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        expenses[index].paymentTypeStatus = paymentTypeStatus;
        expenses[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        expenses[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        _this25.provisionOpeningBal = isNaN(openingBalance) ? _this25.provisionOpeningBal : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this25.provisionOpeningBal) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(openingBalance);
        if (expenses[index].paymentTypeStatus == 'yet to confirm') {
          console.log(totalAmount);
          _this25.expenseTotal = isNaN(totalAmount) ? _this25.expenseTotal : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this25.expenseTotal) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(totalAmount);
        }
      });
      this.provisionOpeningBal = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.provisionOpeningBal);
      this.expenseTotal = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.expenseTotal);
      this.expensesWPro = expenses;
    },

    // Liability With Provision
    liabilityWithProvision: function liabilityWithProvision() {
      var _this26 = this;

      this.liabilityTotal = 0;
      this.liabilityOpeningBalanace = 0;
      var liabilities = this.liabilities.filter(function (liability) {
        return liability.brand === _this26.selectedBrand;
      });
      liabilities = liabilities.filter(function (liability) {
        return !!liability['.key'];
      });
      liabilities.map(function (ex, index) {
        var openingBalance = 0;
        var totalAmount = 0;
        var paymentTypeStatus = 'confirm';
        var invoices = _this26.invoices.filter(function (invoice) {
          return invoice.brand === _this26.selectedBrand && invoice["liabilityType"] === ex['.key'] && invoice.date >= _this26.finYear.start && invoice.date <= _this26.finYear.end;
        });
        console.log(invoices);
        invoices.map(function (inv) {
          openingBalance += inv.openingBalance ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv.openingBalance) : 0;
          totalAmount += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv.totalAmount);
          if (paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
          }
        });
        liabilities[index].paymentTypeStatus = paymentTypeStatus;
        liabilities[index].totalAmount = isNaN(totalAmount) ? 0 : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(totalAmount).toFixed(2);
        liabilities[index].openingBalance = isNaN(openingBalance) ? 0 : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(openingBalance).toFixed(2);
        _this26.liabilityOpeningBalanace = isNaN(openingBalance) ? _this26.liabilityOpeningBalanace : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this26.liabilityOpeningBalanace) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(openingBalance);
        if (liabilities[index].paymentTypeStatus == 'yet to confirm') {
          console.log(totalAmount);
          _this26.liabilityTotal = isNaN(totalAmount) ? _this26.liabilityTotal : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this26.liabilityTotal) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(totalAmount);
        }
      });
      this.liabilityTotal = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(this.liabilityTotal);
      this.liabilitiesWPro = liabilities;
    },
    usersByBrand: function usersByBrand() {
      var _this27 = this;

      if (this.sellers) {
        this.totalLoan = 0;
        this.totalUnsecuredLoanOpening = 0;
        this.totalLoanAndAdvances = 0;
        this.totalSundryCreditors = 0;
        this.sellerList = this.sellers.filter(function (customer) {
          return customer['brand'] === _this27.selectedBrand;
        });
        this.sellerList.map(function (seller, index) {
          _this27.sellerList[index]['totalDiscount'] = 0;
          _this27.sellerList[index]['totalDueAmount'] = 0;
          _this27.sellerList[index]['totalAdvance'] = 0;
          _this27.sellerList[index]['totalSecurity'] = 0;
          _this27.sellerList[index]['totalOpeningBal'] = 0;
          _this27.sellerList[index]['totalLoanGiven'] = 0;
          _this27.sellerList[index]['totalLoanTaken'] = 0;
          var invoices = _this27.invoices.filter(function (item) {
            return item["brand"] === _this27.selectedBrand && item["buyerId"] === seller['.key'] && item.deleted != true && item.date >= _this27.finYear.start && item.date <= _this27.finYear.end && (item["status"] === "due" || item["status"] === "partial") && (_this27.selectedFirm ? item["firm"] === _this27.selectedFirm['.key'] : true);
          });
          invoices.map(function (inv) {
            _this27.sellerList[index]['totalDueAmount'] += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv.remainingAmount);
            _this27.sellerList[index]['totalDiscount'] += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv.discountAmount);
          });

          var advanceInv = _this27.customerDeposit.filter(function (item) {
            return item["brand"] === _this27.selectedBrand && item.date >= _this27.finYear.start && item.date <= _this27.finYear.end && item["buyerId"] === seller['.key'] && item["type"] === "Advance" && !!item["isUserCreated"] && parseInt(item["remainingAmount"]) > 0 && (_this27.selectedFirm ? item["firm"] === _this27.selectedFirm['.key'] : true);
          });
          advanceInv.map(function (inv) {
            _this27.sellerList[index]['totalAdvance'] = inv.remainingAmount;
          });

          var securityInv = _this27.customerDeposit.filter(function (item) {
            return item["brand"] === _this27.selectedBrand && item["buyerId"] === seller['.key'] && item.date >= _this27.finYear.start && item.date <= _this27.finYear.end && item["type"] === "Security" && !!item["isUserCreated"] && parseInt(item["remainingAmount"]) > 0 && (_this27.selectedFirm ? item["firm"] === _this27.selectedFirm['.key'] : true);
          });
          securityInv.map(function (inv) {
            _this27.sellerList[index]['totalSecurity'] = inv.remainingAmount;
          });

          var openingInv = _this27.customerDeposit.filter(function (item) {
            return item["brand"] === _this27.selectedBrand && item["buyerId"] === seller['.key'] && item.date >= _this27.finYear.start && item.date <= _this27.finYear.end && item["type"] === "Opening Balance" && !!item["isUserCreated"] && parseInt(item["remainingAmount"]) > 0 && (_this27.selectedFirm ? item["firm"] === _this27.selectedFirm['.key'] : true);
          });
          openingInv.map(function (inv) {
            _this27.sellerList[index]['totalOpeningBal'] = inv.remainingAmount;
          });

          var loanInv = _this27.customerDeposit.filter(function (item) {
            return item["brand"] === _this27.selectedBrand && item["buyerId"] === seller['.key'] && item.date >= _this27.finYear.start && item.date <= _this27.finYear.end && item["type"] === "LoanGiven" && (_this27.selectedFirm ? item["firm"] === _this27.selectedFirm['.key'] : true);
          });
          loanInv.map(function (inv) {
            _this27.sellerList[index]['totalLoanGiven'] += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv.amount);
          });

          var loanInvTkn = _this27.customerDeposit.filter(function (item) {
            return item["brand"] === _this27.selectedBrand && item["buyerId"] === seller['.key'] && item.date >= _this27.finYear.start && item.date <= _this27.finYear.end && item["type"] === "LoanTaken" && (_this27.selectedFirm ? item["firm"] === _this27.selectedFirm['.key'] : true);
          });
          loanInvTkn.map(function (inv) {
            _this27.sellerList[index]['totalLoanTaken'] += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv.amount);
          });

          _this27.totalLoan += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this27.sellerList[index]['totalLoanGiven']);
          _this27.totalUnsecuredLoanOpening += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this27.sellerList[index]['totalOpeningBal']);
          _this27.totalLoanAndAdvances += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this27.sellerList[index]['totalLoanTaken']);
          _this27.sellerList[index]['totalRemainingAmount'] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this27.sellerList[index]['totalOpeningBal']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this27.sellerList[index]['totalDueAmount']) - (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this27.sellerList[index]['totalAdvance']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this27.sellerList[index]['totalSecurity']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this27.sellerList[index]['totalDiscount']));
          _this27.totalSundryCreditors += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this27.sellerList[index]['totalRemainingAmount']);
        });
      }

      if (this.buyers) {
        this.totalSundryDebitors = 0;
        this.totalSundryDebitorsOpening = 0;
        this.buyerList = this.buyers.filter(function (customer) {
          return customer['brand'] === _this27.selectedBrand;
        });
        this.buyerList.map(function (seller, index) {
          _this27.buyerList[index]['totalDiscount'] = 0;
          _this27.buyerList[index]['totalDueAmount'] = 0;
          _this27.buyerList[index]['totalAdvance'] = 0;
          _this27.buyerList[index]['totalSecurity'] = 0;
          _this27.buyerList[index]['totalOpeningBal'] = 0;
          _this27.buyerList[index]['totalLoanTaken'] = 0;
          _this27.buyerList[index]['totalLoanGiven'] = 0;
          _this27.buyerList[index]['totalRemainingAmount'] = 0;
          var invoices = _this27.invoices.filter(function (item) {
            return item["brand"] === _this27.selectedBrand && item["buyerId"] === seller['.key'] && item.deleted != true && item.date >= _this27.finYear.start && item.date <= _this27.finYear.end && (item["status"] === "due" || item["status"] === "partial") && (_this27.selectedFirm ? item["firm"] === _this27.selectedFirm['.key'] : true);
          });
          invoices.map(function (inv) {
            console.log(_this27.buyerList[index]['totalDueAmount']);
            _this27.buyerList[index]['totalDueAmount'] += inv.remainingAmount ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv.remainingAmount) : 0;
            _this27.buyerList[index]['totalDiscount'] += inv.discountAmount ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv.discountAmount) : 0;
          });

          var advanceInv = _this27.customerDeposit.filter(function (item) {
            return item["brand"] === _this27.selectedBrand && item["buyerId"] === seller['.key'] && item["type"] === "Advance" && item.date >= _this27.finYear.start && item.date <= _this27.finYear.end && !!item["isUserCreated"] && parseInt(item["remainingAmount"]) > 0 && (_this27.selectedFirm ? item["firm"] === _this27.selectedFirm['.key'] : true);
          });
          advanceInv.map(function (inv) {
            _this27.buyerList[index]['totalAdvance'] = inv.remainingAmount;
          });

          var securityInv = _this27.customerDeposit.filter(function (item) {
            return item["brand"] === _this27.selectedBrand && item["buyerId"] === seller['.key'] && item["type"] === "Security" && item.date >= _this27.finYear.start && item.date <= _this27.finYear.end && !!item["isUserCreated"] && parseInt(item["remainingAmount"]) > 0 && (_this27.selectedFirm ? item["firm"] === _this27.selectedFirm['.key'] : true);
          });
          securityInv.map(function (inv) {
            _this27.buyerList[index]['totalSecurity'] = inv.remainingAmount;
          });

          var openingInv = _this27.customerDeposit.filter(function (item) {
            return item["brand"] === _this27.selectedBrand && item["buyerId"] === seller['.key'] && item["type"] === "Opening Balance" && item.date >= _this27.finYear.start && item.date <= _this27.finYear.end && !!item["isUserCreated"] && parseInt(item["remainingAmount"]) > 0 && (_this27.selectedFirm ? item["firm"] === _this27.selectedFirm['.key'] : true);
          });
          openingInv.map(function (inv) {
            _this27.buyerList[index]['totalOpeningBal'] = inv.remainingAmount;
          });

          var loanInv = _this27.customerDeposit.filter(function (item) {
            return item["brand"] === _this27.selectedBrand && item["buyerId"] === seller['.key'] && item["type"] === "LoanTaken" && item.date >= _this27.finYear.start && item.date <= _this27.finYear.end && s(_this27.selectedFirm ? item["firm"] === _this27.selectedFirm['.key'] : true);
          });
          loanInv.map(function (inv) {
            _this27.buyerList[index]['totalLoanTaken'] += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv.amount);
          });

          var loanInvGV = _this27.customerDeposit.filter(function (item) {
            return item["brand"] === _this27.selectedBrand && item["buyerId"] === seller['.key'] && item["type"] === "LoanGiven" && item.date >= _this27.finYear.start && item.date <= _this27.finYear.end && (_this27.selectedFirm ? item["firm"] === _this27.selectedFirm['.key'] : true);
          });
          loanInvGV.map(function (inv) {
            _this27.buyerList[index]['totalLoanGiven'] += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(inv.amount);
          });

          _this27.totalLoanAndAdvances += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this27.buyerList[index]['totalLoanTaken']);
          _this27.totalLoan += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this27.buyerList[index]['totalLoanGiven']);
          _this27.buyerList[index]['totalRemainingAmount'] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this27.buyerList[index]['totalOpeningBal']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this27.buyerList[index]['totalDueAmount']) - (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this27.buyerList[index]['totalAdvance']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this27.buyerList[index]['totalSecurity']) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this27.buyerList[index]['totalDiscount']));
          _this27.totalSundryDebitors += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this27.buyerList[index]['totalRemainingAmount']);
          _this27.totalSundryDebitorsOpening += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(_this27.buyerList[index]['totalOpeningBal']);
        });
      }
    },
    generateAddress: function generateAddress(user) {
      var address = "";
      if (user.block) {
        address = "" + user.block;
      }
      if (user.village) {
        address = "" + (address ? address + ", " : "") + user.village;
      }
      if (user.tehsil) {
        address = "" + (address ? address + ", " : "") + user.tehsil;
      }
      if (user.state) {
        address = "" + (address ? address + ", " : "") + user.state;
      }
      return address;
    }
  },
  watch: {
    selectedFirm: function selectedFirm(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.getFilteredData();
      }
    },
    toDate: function toDate(newVal, oldVal) {
      if (oldVal !== newVal) {
        var selectedtoDate = this.toDate ? new Date(this.toDate).getTime() : null;
        this.getFilteredData();
      }
    },
    fromDate: function fromDate(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.selectedfromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
        this.getFilteredData();
      }
    },
    selectedBrand: function selectedBrand(newVal, oldVal) {
      if (oldVal !== newVal) {
        this.getData();
      }
    }
  }
});

/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_pdf_reports_collectionBookReport_js__ = __webpack_require__(1709);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      buyerHeader: [{ text: "Buyer Name", value: "name", sortable: true }, { text: "Remaining Amount", value: "invoiceId", sortable: true }, { text: "Mobile No.", value: "name" },
      // { text: "Village", value: "village" },
      // { text: "Block", value: "block" },
      { text: "Address", value: "localAddress" }, { text: "Tehsil", value: "tehsil" }, { text: "District", value: "district" }, { text: "State", value: "state" }, { text: "Receipt", value: "name" }],
      selectedAddress: null,
      selectedBlock: null,
      selectedDistrict: null,
      selectedState: null,
      dayDiff: null,
      selectedTehsil: null,
      selectedVillage: null,
      selectedBuyer: null,
      buyers: [],
      expand: false
    };
  },
  created: function created() {
    this.$bindAsArray("buyers", this.$root.$firebaseRefs.buyer.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("customerDeposit", this.$root.$firebaseRefs.customerDeposit.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("customerPayments", this.$root.$firebaseRefs.customerPayments.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("invoiceHistories", this.$root.$firebaseRefs.invoiceHistory.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("customerDeposit", this.$root.$firebaseRefs.customerDeposit.orderByChild("brand").equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear"]), {
    getBuyerBlocks: function getBuyerBlocks() {
      var _this = this;

      return this.buyers.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      }).map(function (item) {
        if (!!item.block) return {
          text: item["block"],
          value: item["block"]
        };
      });
    },
    getBuyerVillage: function getBuyerVillage() {
      var _this2 = this;

      return this.buyers.filter(function (item) {
        return item["brand"] === _this2.selectedBrand;
      }).map(function (item) {
        if (!!item.village) return {
          text: item["village"],
          value: item["village"]
        };
      });
    },
    getBuyerAddress: function getBuyerAddress() {
      var _this3 = this;

      return this.buyers.filter(function (item) {
        return item["brand"] === _this3.selectedBrand;
      }).map(function (item) {
        if (!!item.localAddress) return {
          text: item["localAddress"],
          value: item["localAddress"]
        };
      });
    },
    getBuyerTehsil: function getBuyerTehsil() {
      var _this4 = this;

      return this.buyers.filter(function (item) {
        return item["brand"] === _this4.selectedBrand;
      }).map(function (item) {
        if (!!item.tehsil) return {
          text: item["tehsil"],
          value: item["tehsil"]
        };
      });
    },
    getBuyerDistrict: function getBuyerDistrict() {
      var _this5 = this;

      return this.buyers.filter(function (item) {
        return item["brand"] === _this5.selectedBrand;
      }).map(function (item) {
        if (!!item.district) return {
          text: item["district"],
          value: item["district"]
        };
      });
    },
    getBuyerStates: function getBuyerStates() {
      var _this6 = this;

      return this.buyers.filter(function (item) {
        return item["brand"] === _this6.selectedBrand;
      }).map(function (item) {
        if (!!item.state) return {
          text: item["state"],
          value: item["state"]
        };
      });
    },
    getBuyerName: function getBuyerName() {
      var _this7 = this;

      return this.buyers.filter(function (item) {
        return item["brand"] === _this7.selectedBrand;
      }).map(function (item) {
        if (!!item.name) return {
          text: item["name"],
          value: item["name"]
        };
      });
    },
    getBuyers: function getBuyers() {
      var _this8 = this;

      var total = 0;
      var buyers = this.buyers.filter(function (item) {
        return item["brand"] === _this8.selectedBrand && (_this8.selectedBuyer ? item["name"] == _this8.selectedBuyer : true) && (_this8.selectedAddress ? item["localAddress"] == _this8.selectedAddress : true) && (_this8.selectedBlock ? item["block"] == _this8.selectedBlock : true) && (_this8.selectedDistrict ? item["district"] == _this8.selectedDistrict : true) && (_this8.selectedVillage ? item["village"] == _this8.selectedVillage : true) && (_this8.selectedState ? item["state"] == _this8.selectedState : true) && (_this8.selectedTehsil ? item["tehsil"] == _this8.selectedTehsil : true);
      });
      buyers.map(function (buyer, bIndex) {
        var temp = _this8.getRemainingBalanceAmount(buyer);
        buyers[bIndex]["remainingBalance"] = temp.amount;
        buyers[bIndex]["invoices"] = temp.invoices;
        // buyers[bIndex]["remainingBalance"] = 0;
        // let invoices = this.invoices.filter((item) => {
        //   return (
        //     item["brand"] === this.selectedBrand &&
        //     item["status"] != "paid" &&
        //     item.date >= this.finYear.start &&
        //     (item.deleted != true) &&
        //     item.date <= this.finYear.end &&
        //     item.buyerId == buyer['.key']
        //   );
        // });
        // invoices.map((invoice, Iindex) => {
        //   buyers[bIndex]["remainingBalance"] += invoice.remainingAmount ? Number.parseFloat(
        //     invoice.remainingAmount
        //   ) : 0;
        // });
        // buyers[bIndex]["remainingBalance"] +=  buyer.remainingAmountFromDeposite?  Number.parseFloat(
        //   buyer.remainingAmountFromDeposite
        // ) : 0;
        //   buyers[bIndex]["remainingBalance"] =  Number.parseFloat(buyers[bIndex]["remainingBalance"]).toFixed(2)
        total += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(buyers[bIndex]["remainingBalance"]);
      });
      buyers = buyers.filter(function (item) {
        return !!item.remainingBalance;
      });
      buyers.push({
        isTotal: true,
        total: total
      });
      return buyers;
    }
  }),
  methods: {
    printReport: function printReport() {
      var doc = Object(__WEBPACK_IMPORTED_MODULE_4__utils_pdf_reports_collectionBookReport_js__["a" /* collectionBookReport */])({
        buyers: this.getBuyers
      });
      pdfMake.createPdf(doc).download();
    },
    keymonitor: function keymonitor(event) {
      this.search = event.target.value;
    },
    getRemainingBalanceAmount: function getRemainingBalanceAmount(buyer) {
      var _this9 = this;

      var filteredInvoice = this.invoiceHistories.filter(function (item) {
        return item["brand"] === _this9.selectedBrand && item["buyerId"] === buyer[".key"] && !item["deleted"] && (item["returnStatus"] ? item["returnStatus"] == "remaining" && item["status"] == "paid" : true) && (item["isLatest"] != undefined ? item["isLatest"] == true : true);
      });
      var payments = this.customerPayments.filter(function (item) {
        return item["brand"] === _this9.selectedBrand && item["buyerId"] === buyer[".key"] && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item["remainingAmount"]) > 0;
      });

      var customerDeposit = this.customerDeposit.filter(function (item) {
        return item["brand"] === _this9.selectedBrand && item["buyerId"] === buyer[".key"] && (item["type"] === "Advance" || item["type"] === "Opening Balance" || item["type"] === "LoanTaken" || item["type"] === "LoanGiven" || item["type"] === "Security");
      });

      filteredInvoice.map(function (item, index) {
        //if(item.newlyCreated && (item.status === "paid" || item.status === "partial")) {
        if (item.newlyCreated && (item.status === "paid" || item.status === "partial")) {
          var newItem = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item));
          newItem.date = newItem.date - 1;
          newItem.transactionType = "Debit";
          newItem.paidAmount = 0;
          newItem.status = "due";
          newItem.remainingAmount = newItem.totalAmount;
          delete newItem["newlyCreated"];
          filteredInvoice.push(newItem);
        }
        if (item.closedDate) {
          filteredInvoice[index].date = item.closedDate;
        }
      });

      customerDeposit.map(function (deposit, index) {
        filteredInvoice.push(deposit);
        if ((deposit["type"] === "LoanTaken" || deposit["type"] === "LoanGiven") && deposit.status == "paid" && !deposit.loanTransaction) {
          customerDeposit[index].status = "due";
        }
      });

      payments.map(function (pay) {
        pay["type"] = "CustomerPayment";
        filteredInvoice.push(pay);
      });
      if (this.dayDiff) {
        var date = new Date();

        filteredInvoice = filteredInvoice.filter(function (i) {
          if (i.date) {
            var diffTime = Math.abs(date - i.date);
            var diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            return diffDays >= _this9.dayDiff;
          }
          return false;
        });
      }
      filteredInvoice.sort(function (a, b) {
        return -(new Date(b.date) - new Date(a.date));
      });

      var invoices = [];
      filteredInvoice.map(function (item, index) {
        filteredInvoice[index]["debit"] = _this9.getDebit(filteredInvoice[index]);
        filteredInvoice[index]["credit"] = _this9.getCredit(filteredInvoice[index]);
        if (item.isBuyer) {
          var temp = filteredInvoice[index]["credit"];
          filteredInvoice[index]["credit"] = filteredInvoice[index]["debit"];
          filteredInvoice[index]["debit"] = temp;
        }
        filteredInvoice[index]["RunningBal"] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(filteredInvoice[index]["debit"] || 0) - __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(filteredInvoice[index]["credit"] || 0) + (index == 0 ? 0 : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(filteredInvoice[index - 1]["RunningBal"]));
        invoices.push(item);
      });
      return filteredInvoice.length ? {
        amount: filteredInvoice[filteredInvoice.length - 1]["RunningBal"],
        invoices: invoices
      } : {
        amount: 0,
        invoices: []
      };
    },
    getDebit: function getDebit(item) {
      if (item.type == "CustomerPayment") {
        if (!item.isBuyer) {
          return 0;
        } else {
          return item["remainingAmount"];
        }
      } else if (["LoanTaken", "LoanGiven", "Opening Balance", "Advance", "Security"].includes(item.type)) {
        switch (item.type) {
          case "LoanTaken":
            {
              if (item.loanTransaction) {
                return 0;
              } else {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.amount);
              }
              break;
            }
          case "LoanGiven":
            {
              if (item.loanTransaction) {
                if (item.loanPaymentType == "interest") {
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.paidInterest);
                } else {
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.paidAmount);
                }
              } else {
                return 0;
              }
              break;
            }
          case "Opening Balance":
            {
              return item.isUserCreated ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(0) : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.settledAmount);
              break;
            }
          case "Advance":
            {
              return item.isUserCreated ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.amount) : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(0);
              break;
            }
          case "Security":
            {
              return item.isUserCreated ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.amount) : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(0);
              break;
            }
        }
      } else {
        switch (item.status) {
          case "due":
            {
              return 0;
              break;
            }
          case "paid":
            {
              // return (Number.parseFloat(item['totalAmount']));
              return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item["amountFromBank"]) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item["amountFromCash"]);
              break;
            }
          case "partial":
            {
              return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item["amountFromBank"]) + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item["amountFromCash"]);
              break;
            }
        }
      }
    },
    getCredit: function getCredit(item) {
      if (item.type == "CustomerPayment") {
        if (item.isBuyer) {
          return 0;
        } else {
          return item["remainingAmount"];
        }
      } else if (["LoanTaken", "LoanGiven", "Opening Balance", "Advance", "Security"].includes(item.type)) {
        switch (item.type) {
          case "LoanTaken":
            {
              if (item.loanTransaction) {
                if (item.loanPaymentType == "interest") {
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.paidInterest);
                } else {
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.paidAmount);
                }
              } else {
                return 0;
              }
              break;
            }
          case "LoanGiven":
            {
              if (item.loanTransaction) {
                return 0;
              } else {
                return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.amount);
              }
              break;
            }
          case "Opening Balance":
            {
              return item.isUserCreated ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.amount) : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(0);
              break;
            }
          case "Advance":
            {
              return item.isUserCreated ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(0) : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.settledAmount);
              break;
            }
          case "Security":
            {
              return item.isUserCreated ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(0) : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.settledAmount);
              break;
            }
        }
      } else {
        switch (item.status) {
          case "due":
            {
              return item.totalAmount;
              break;
            }
          case "paid":
            {
              return 0;
              break;
            }
          case "partial":
            {
              return 0;
              break;
            }
        }
      }
    }
  }
});

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Balancesheet_expandCard__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_pdf_reports_information_reports__ = __webpack_require__(46);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    ExpandCard: __WEBPACK_IMPORTED_MODULE_1__Balancesheet_expandCard__["a" /* default */]
  },
  data: function data() {
    return {
      helpBook: [{
        expense: true
      }, {
        expense: false
      }]
    };
  },
  created: function created() {},

  computed: {},
  watch: {},
  methods: {}
});

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      invoiceHeader: [{ text: "Date", value: "date", sortable: true },
      // { text: "Invoice Key", value: "key" },
      { text: "Invoice ID", value: "invoiceId" }, { text: "Customer Name", value: "name" }, { text: "TotalAmount", value: "TotalAmount" }, { text: "Status", value: "status" }, { text: "Restore", value: "restore" }, { text: "Delete", value: "delete" }, { text: "Firm", value: "firmName" }],
      selectedFirm: null,
      filterInvoiceFrom: null,
      filterInvoiceTo: null,
      fromdatepicker: false,
      todatepicker: false
    };
  },
  created: function created() {
    this.$bindAsObject("firm", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray("account", this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsObject("buyerById", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsObject("sellerById", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray('invoices', this.$root.$firebaseRefs.invoice.orderByChild('brandFinYear').equalTo(this.brandFinYear));
    this.$bindAsArray('invoiceHistories', this.$root.$firebaseRefs.invoiceHistory).orderByChild('brandFinYear').equalTo(this.brandFinYear);
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear", "brandFinYear"]), {
    firmsByBrand1: function firmsByBrand1() {
      var _this = this;

      return this.firms.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      });
    },

    // current brands firm list
    firmsByBrand: function firmsByBrand() {
      var _this2 = this;

      // return selected brand firms
      var firmsB = this.firms.filter(function (item) {
        return item['brand'] === _this2.selectedBrand;
      });
      firmsB.map(function (item) {
        if (item.defaultFirm) {
          _this2.selectedFirm = item;
        }
      });
      return firmsB;
    },
    getInvoice: function getInvoice() {
      var _this3 = this;

      var toDate = this.toDate ? new Date(this.toDate).getTime() : null;
      var fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
      var invoices = this.invoices.filter(function (item) {
        // return ((this.selectedFirm ? item['firm'] === this.selectedFirm['.key'] : true) &&
        return item["brand"] === _this3.selectedBrand && (_this3.selectedFirm ? item['firm'] === _this3.selectedFirm['.key'] : true) && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true) && item.date >= _this3.finYear.start && item.date <= _this3.finYear.end && item.deleted == true;
      });
      return invoices;
    }
  }),
  methods: {
    dayDiff: function dayDiff(dt1, dt2) {
      return Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24));
    },
    restoreInvoice: function restoreInvoice(selectedInvoice) {
      var _this4 = this;

      if (confirm('Are you sure you want to restore this invoice?')) {
        this.$root.$firebaseRefs.invoice.child(selectedInvoice['.key']).update({
          deleted: false
        }, function () {
          console.info('Invoice Restored...');
        });

        var invoiceHistory = this.invoiceHistories.filter(function (item) {
          return item['brand'] == _this4.selectedBrand && item['parentInvoiceKey'] == selectedInvoice['.key'];
        });
        invoiceHistory.map(function (invoice) {
          _this4.$root.$firebaseRefs.invoiceHistory.child(invoice['.key']).update({
            deleted: false
          }, function () {
            console.info('Invoice History Restored...');
            _this4.managePayments(selectedInvoice, false);
          });
        });
      }
    },
    deleteInvoice: function deleteInvoice(selectedInvoice) {
      var _this5 = this;

      if (confirm('Are you sure you want to delete this invoice?')) {
        if (selectedInvoice.isBuyer) {
          var firmInvoiceCount = this.invoices.filter(function (item) {
            return item["brand"] === _this5.selectedBrand && item["firm"] == selectedInvoice.firm && item["isBuyer"] == true;
          }).length;
          this.$root.$firebaseRefs.firm.child(selectedInvoice.firm).update({
            lastInvoiceCount: firmInvoiceCount
          }, function () {
            console.info('last invoice Count updated...');
          });
        }
        var invoiceHistory = this.invoiceHistories.filter(function (item) {
          return item['brand'] == _this5.selectedBrand && item['parentInvoiceKey'] == selectedInvoice['.key'];
        });
        invoiceHistory.map(function (invoice) {
          _this5.$root.$firebaseRefs.invoiceHistory.child(invoice['.key']).remove();
        });
        this.$root.$firebaseRefs.invoice.child(selectedInvoice['.key']).remove();
        this.managePayments(selectedInvoice, true);
      }
    },
    getCurrentUserName: function getCurrentUserName(buyerId) {
      var buyer = this.buyerById[buyerId];
      var seller = this.sellerById[buyerId];
      var currentUser = buyer && buyer.state ? buyer : seller && seller.state ? seller : {};
      return currentUser.name;
    },

    // getFirmName1(firmId) {
    //   if (this.firm && this.firm[firmId]) {
    //     return this.firm[firmId]["name"];
    //   }
    //   return "--";
    // },
    getFirmName: function getFirmName(e) {
      var firm = void 0;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter(function (item) {
          return item[".key"] === e;
        })[0];
      }
      if (firm) return firm.name;
    },
    renderDate: function renderDate(timeStamp) {
      if (timeStamp) {
        return new Date(timeStamp).toLocaleDateString("en-GB");
      }
      return "--";
    },
    managePayments: function managePayments(invoiceData, isDelete) {
      var isAddition = invoiceData.isBuyer;
      isAddition = isDelete ? !isAddition : isAddition;
      switch (invoiceData.paymentType) {
        case 'Cash':
          {
            if (invoiceData.amountFromCash) {
              var firm = this.firms.filter(function (item) {
                return item['.key'] == invoiceData.firm;
              })[0];
              if (firm && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                firm.amount = isAddition ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(firm.amount) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash) : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(firm.amount) - __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash);
                delete firm['.key'];
                this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(firm);
              }
            }
            break;
          }
        case 'Bank Account':
          {
            if (invoiceData.amountFromBank) {
              var bank = this.banks.filter(function (item) {
                return item['.key'] == invoiceData.bank;
              })[0];
              if (bank && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                bank.amount = isAddition ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(bank.amount) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank) : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(bank.amount) - __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank);
                delete bank['.key'];
                this.$root.$firebaseRefs.account.child(invoiceData.bank).set(bank);
              }
            }
            break;
          }
        case 'CashAndBank Account':
          {
            if (invoiceData.amountFromCash && invoiceData.amountFromBank) {
              var _bank = this.banks.filter(function (item) {
                return item['.key'] == invoiceData.bank;
              })[0];
              if (_bank && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                _bank.amount = isAddition ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(_bank.amount) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank) : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(_bank.amount) - __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromBank);
                delete _bank['.key'];
                this.$root.$firebaseRefs.account.child(invoiceData.bank).set(_bank);
              }
              var _firm = this.firms.filter(function (item) {
                return item['.key'] == invoiceData.firm;
              })[0];
              if (_firm && (invoiceData.status == 'paid' || invoiceData.status == 'partial')) {
                _firm.amount = isAddition ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(_firm.amount) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash) : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(_firm.amount) - __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(invoiceData.amountFromCash);
                delete _firm['.key'];
                this.$root.$firebaseRefs.firm.child(invoiceData.firm).set(_firm);
              }
            }
            break;
          }
      }
    }
  },
  watch: {}
});

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      invoiceHeader: [{ text: "Date", value: "date", sortable: true },
      // { text: "Invoice Key", value: "key" },
      { text: "Invoice ID", value: "Block" }, { text: "Customer Name", value: "Village" }, { text: "Charges", value: "Block" }, { text: "Debit", value: "Block" }, { text: "Credit", value: "Block" }, { text: "Firm", value: "firm" }],
      selectedFirm: null,
      fromDate: null,
      toDate: null,
      fromdatepicker: false,
      todatepicker: false,
      chargeList: [],
      selectedCharge: null
    };
  },
  created: function created() {
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brandFinYear').equalTo(this.brandFinYear));
    this.$bindAsObject("firm", this.$root.$firebaseRefs.firm), this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsObject("buyerById", this.$root.$firebaseRefs.buyer), this.$bindAsObject("sellerById", this.$root.$firebaseRefs.seller);
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear", "brandFinYear"]), {
    firmsByBrand1: function firmsByBrand1() {
      var _this = this;

      return this.firms.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      });
    },


    // current brands firm list
    firmsByBrand: function firmsByBrand() {
      var _this2 = this;

      // return selected brand firms
      var firmsB = this.firms.filter(function (item) {
        return item['brand'] === _this2.selectedBrand;
      });
      firmsB.map(function (item) {
        if (item.defaultFirm) {
          _this2.selectedFirm = item;
        }
      });
      return firmsB;
    },
    getInvoice: function getInvoice() {
      var _this3 = this;

      var chargesNames = [];
      var totalDebit = 0;
      var totalCredit = 0;
      var toDate = this.toDate ? new Date(this.toDate).getTime() : null;
      var fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
      var invoices = this.invoices.filter(function (item) {
        return item["brand"] === _this3.selectedBrand && (_this3.selectedFirm ? item['firm'] === _this3.selectedFirm['.key'] : true) && !item["return"] && item['extraCharges'] && item['extraCharges'].length && (_this3.selectedCharge ? item['extraCharges'].some(function (el) {
          return el.name == _this3.selectedCharge;
        }) : true) && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true) && item.deleted != true && item.date >= _this3.finYear.start && item.date <= _this3.finYear.end;
      });
      var invoiceToPass = [];
      invoices.map(function (invoice, index1) {
        invoice.extraCharges.map(function (item, index2) {
          chargesNames.push(item.name);
          if (!!parseInt(item.amount) && (!_this3.selectedCharge || _this3.selectedCharge == item.name)) {
            // totalAmount += Number.parseFloat(item.amount)
            if (invoice.isBuyer) {
              totalCredit += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.amount);
            } else {
              totalDebit += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(item.amount);
            }
            var inv = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(invoice));
            inv['ext'] = item;
            invoiceToPass.push(inv);
          }
        });
      });

      invoiceToPass.sort(function (a, b) {
        return -(new Date(b.date) - new Date(a.date));
      });
      invoiceToPass.push({
        isTotal: true,
        totalDebit: totalDebit,
        totalCredit: totalCredit
      });
      this.chargeList = _.uniq(chargesNames);
      return invoiceToPass;
    }
  }),
  methods: {
    getCurrentUserName: function getCurrentUserName(buyerId) {
      var buyer = this.buyerById[buyerId];
      var seller = this.sellerById[buyerId];
      var currentUser = buyer && buyer.state ? buyer : seller && seller.state ? seller : {};
      return currentUser.name;
    },

    // getFirmName(firmId) {
    //   if (this.firm && this.firm[firmId]) {
    //     return this.firm[firmId]["name"];
    //   }
    //   return "--";
    // },
    getFirmName: function getFirmName(e) {
      var firm = void 0;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter(function (item) {
          return item[".key"] === e;
        })[0];
      }
      if (firm) return firm.name;
    },
    renderDate: function renderDate(timeStamp) {
      if (timeStamp) {
        return new Date(timeStamp).toLocaleDateString("en-GB");
      }
      return "--";
    }
  },
  watch: {}
});

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(1);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      invoiceHeader: [{ text: "Date", value: "date", sortable: true },
      // { text: "Invoice Key", value: "key" },
      { text: "Invoice ID", value: "Block" }, { text: "Customer Name", value: "Village" }, { text: "Percentage", value: "Block" }, { text: "Payment Type", value: "paymentType" }, { text: "Firm", value: "firm" }],
      selectedFirm: null,
      filterInvoiceFrom: null,
      filterInvoiceTo: null,
      fromdatepicker: false,
      todatepicker: false
    };
  },
  created: function created() {
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brandFinYear').equalTo(this.brandFinYear));
    this.$bindAsObject("firm", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsObject("buyerById", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand)), this.$bindAsObject("sellerById", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear", "brandFinYear"]), {
    firmsByBrand1: function firmsByBrand1() {
      var _this = this;

      return this.firms.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      });
    },


    // current brands firm list
    firmsByBrand: function firmsByBrand() {
      var _this2 = this;

      // return selected brand firms
      var firmsB = this.firms.filter(function (item) {
        return item['brand'] === _this2.selectedBrand;
      });
      firmsB.map(function (item) {
        if (item.defaultFirm) {
          _this2.selectedFirm = item;
        }
      });
      return firmsB;
    },
    getInvoice: function getInvoice() {
      var _this3 = this;

      var toDate = this.toDate ? new Date(this.toDate).getTime() : null;
      var fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;
      var invoices = this.invoices.filter(function (item) {
        return item["brand"] === _this3.selectedBrand && (_this3.selectedFirm ? item['firm'] === _this3.selectedFirm['.key'] : true) && !item["return"] && item['incentives'] && item['incentives'].length && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true) && item.deleted != true && item.date >= _this3.finYear.start && item.date <= _this3.finYear.end;
      });
      invoices.map(function (invoice, index1) {
        invoice.incentives.map(function (item, index2) {
          if (index2 == 0) {
            invoices[index1]['inc'] = item;
          } else if (!!parseInt(item.percentage)) {
            var inv = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(invoice));
            inv['inc'] = item;
            invoices.push(inv);
          }
        });
      });

      invoices.sort(function (a, b) {
        return -(new Date(b.date) - new Date(a.date));
      });
      return invoices;
    }
  }),
  methods: {
    getCurrentUserName: function getCurrentUserName(buyerId) {
      var buyer = this.buyerById[buyerId];
      var seller = this.sellerById[buyerId];
      var currentUser = buyer && buyer.state ? buyer : seller && seller.state ? seller : {};
      return currentUser.name;
    },

    // getFirmName(firmId) {
    //   if (this.firm && this.firm[firmId]) {
    //     return this.firm[firmId]["name"];
    //   }
    //   return "--";
    // },
    getFirmName: function getFirmName(e) {
      var firm = void 0;
      if (this.firms && this.selectedBrand) {
        firm = this.firms.filter(function (item) {
          return item[".key"] === e;
        })[0];
      }
      if (firm) return firm.name;
    },
    renderDate: function renderDate(timeStamp) {
      if (timeStamp) {
        return new Date(timeStamp).toLocaleDateString("en-GB");
      }
      return "--";
    }
  },
  watch: {}
});

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_twilio_js__ = __webpack_require__(244);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      buyerHeader: [{ text: "Select", value: "name" }, { text: "Buyer Name", value: "name", sortable: true }, { text: "Mobile No.", value: "name" }, { text: "Type", value: "name" }],
      selectedBlock: null,
      selectedDistrict: null,
      selectedState: null,
      selectedTehsil: null,
      selectedVillage: null,
      selectedBuyer: null,
      buyersList: [],
      selectAll: true,
      dialog: false,
      smsText: ''
    };
  },
  created: function created() {
    this.$bindAsArray("buyers", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("sellers", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear"]), {
    getBuyers: function getBuyers() {
      var _this = this;

      var buyers = this.buyers.filter(function (item) {
        return item["brand"] === _this.selectedBrand && !!item["mobile"];
      });
      buyers.map(function (b, index) {
        buyers[index]['prefix'] = 'Buyer';
        buyers[index]['selected'] = true;
      });
      var sellers = this.sellers.filter(function (item) {
        return item["brand"] === _this.selectedBrand && !!item["mobile"];
      });
      sellers.map(function (b, index) {
        sellers[index]['prefix'] = 'Seller';
        sellers[index]['selected'] = true;
      });
      this.buyersList = buyers.concat(sellers);
      return this.buyersList;
    }
  }),
  methods: {
    toggleSelect: function toggleSelect() {
      var _this2 = this;

      this.buyersList.map(function (b, index) {
        _this2.buyersList[index]['selected'] = !_this2.buyersList[index]['selected'];
      });
    },
    sendSMS: function sendSMS() {
      var recp = [];
      this.buyersList.map(function (b) {
        if (b.selected) {
          recp.push("+91" + b.mobile);
        }
      });
      console.log(recp);
      Object(__WEBPACK_IMPORTED_MODULE_2__services_twilio_js__["a" /* sendSms */])(["+91" + this.selectedBuyer.mobile], message);
      console.log(this.smsText);
    }
  }
});

/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Balancesheet_expandCard__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_pdf_reports_information_reports__ = __webpack_require__(46);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      rowsPerPageItems: [4, 8, 12],
      search: '',
      pagination: {
        rowsPerPage: 4
      },
      items: [{
        name: 'Frozen Yogurt',
        calories: 159,
        fat: 6.0,
        carbs: 24,
        protein: 4.0,
        sodium: 87,
        calcium: '14%',
        iron: '1%'
      }, {
        name: 'Ice cream sandwich',
        calories: 237,
        fat: 9.0,
        carbs: 37,
        protein: 4.3,
        sodium: 129,
        calcium: '8%',
        iron: '1%'
      }, {
        name: 'Eclair',
        calories: 262,
        fat: 16.0,
        carbs: 23,
        protein: 6.0,
        sodium: 337,
        calcium: '6%',
        iron: '7%'
      }, {
        name: 'Cupcake',
        calories: 305,
        fat: 3.7,
        carbs: 67,
        protein: 4.3,
        sodium: 413,
        calcium: '3%',
        iron: '8%'
      }, {
        name: 'Gingerbread',
        calories: 356,
        fat: 16.0,
        carbs: 49,
        protein: 3.9,
        sodium: 327,
        calcium: '7%',
        iron: '16%'
      }, {
        name: 'Jelly bean',
        calories: 375,
        fat: 0.0,
        carbs: 94,
        protein: 0.0,
        sodium: 50,
        calcium: '0%',
        iron: '0%'
      }, {
        name: 'Lollipop',
        calories: 392,
        fat: 0.2,
        carbs: 98,
        protein: 0,
        sodium: 38,
        calcium: '0%',
        iron: '2%'
      }, {
        name: 'Honeycomb',
        calories: 408,
        fat: 3.2,
        carbs: 87,
        protein: 6.5,
        sodium: 562,
        calcium: '0%',
        iron: '45%'
      }, {
        name: 'Donut',
        calories: 452,
        fat: 25.0,
        carbs: 51,
        protein: 4.9,
        sodium: 326,
        calcium: '2%',
        iron: '22%'
      }, {
        name: 'KitKat',
        calories: 518,
        fat: 26.0,
        carbs: 65,
        protein: 7,
        sodium: 54,
        calcium: '12%',
        iron: '6%'
      }]
    };
  },
  created: function created() {
    this.$bindAsArray('firm', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand', 'finYear']), {
    firmsByBrand: function firmsByBrand() {
      var _this = this;

      // return selected brand firms
      var firms = this.firm.filter(function (item) {
        return item['brand'] === _this.selectedBrand;
      });
      firms.map(function (item) {
        if (item.defaultFirm) {
          _this.selectedFirm = item;
        }
      });
      return firms;
    }
  })
});

/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Balancesheet_expandCard__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_pdf_reports_information_reports__ = __webpack_require__(46);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      rowsPerPageItems: [4, 8, 12],
      search: '',
      pagination: {
        rowsPerPage: 4
      },
      items: [{
        name: 'Frozen Yogurt',
        calories: 159,
        fat: 6.0,
        carbs: 24,
        protein: 4.0,
        sodium: 87,
        calcium: '14%',
        iron: '1%'
      }, {
        name: 'Ice cream sandwich',
        calories: 237,
        fat: 9.0,
        carbs: 37,
        protein: 4.3,
        sodium: 129,
        calcium: '8%',
        iron: '1%'
      }, {
        name: 'Eclair',
        calories: 262,
        fat: 16.0,
        carbs: 23,
        protein: 6.0,
        sodium: 337,
        calcium: '6%',
        iron: '7%'
      }, {
        name: 'Cupcake',
        calories: 305,
        fat: 3.7,
        carbs: 67,
        protein: 4.3,
        sodium: 413,
        calcium: '3%',
        iron: '8%'
      }, {
        name: 'Gingerbread',
        calories: 356,
        fat: 16.0,
        carbs: 49,
        protein: 3.9,
        sodium: 327,
        calcium: '7%',
        iron: '16%'
      }, {
        name: 'Jelly bean',
        calories: 375,
        fat: 0.0,
        carbs: 94,
        protein: 0.0,
        sodium: 50,
        calcium: '0%',
        iron: '0%'
      }, {
        name: 'Lollipop',
        calories: 392,
        fat: 0.2,
        carbs: 98,
        protein: 0,
        sodium: 38,
        calcium: '0%',
        iron: '2%'
      }, {
        name: 'Honeycomb',
        calories: 408,
        fat: 3.2,
        carbs: 87,
        protein: 6.5,
        sodium: 562,
        calcium: '0%',
        iron: '45%'
      }, {
        name: 'Donut',
        calories: 452,
        fat: 25.0,
        carbs: 51,
        protein: 4.9,
        sodium: 326,
        calcium: '2%',
        iron: '22%'
      }, {
        name: 'KitKat',
        calories: 518,
        fat: 26.0,
        carbs: 65,
        protein: 7,
        sodium: 54,
        calcium: '12%',
        iron: '6%'
      }]
    };
  },
  created: function created() {
    this.$bindAsArray('firm', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand', 'finYear']), {
    firmsByBrand: function firmsByBrand() {
      var _this = this;

      // return selected brand firms
      var firms = this.firm.filter(function (item) {
        return item['brand'] === _this.selectedBrand;
      });
      firms.map(function (item) {
        if (item.defaultFirm) {
          _this.selectedFirm = item;
        }
      });
      return firms;
    }
  })
});

/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Balancesheet_expandCard__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_pdf_reports_information_reports__ = __webpack_require__(46);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      rowsPerPageItems: [4, 8, 12],
      search: '',
      pagination: {
        rowsPerPage: 4
      },
      items: [{
        name: 'Frozen Yogurt',
        calories: 159,
        fat: 6.0,
        carbs: 24,
        protein: 4.0,
        sodium: 87,
        calcium: '14%',
        iron: '1%'
      }, {
        name: 'Ice cream sandwich',
        calories: 237,
        fat: 9.0,
        carbs: 37,
        protein: 4.3,
        sodium: 129,
        calcium: '8%',
        iron: '1%'
      }, {
        name: 'Eclair',
        calories: 262,
        fat: 16.0,
        carbs: 23,
        protein: 6.0,
        sodium: 337,
        calcium: '6%',
        iron: '7%'
      }, {
        name: 'Cupcake',
        calories: 305,
        fat: 3.7,
        carbs: 67,
        protein: 4.3,
        sodium: 413,
        calcium: '3%',
        iron: '8%'
      }, {
        name: 'Gingerbread',
        calories: 356,
        fat: 16.0,
        carbs: 49,
        protein: 3.9,
        sodium: 327,
        calcium: '7%',
        iron: '16%'
      }, {
        name: 'Jelly bean',
        calories: 375,
        fat: 0.0,
        carbs: 94,
        protein: 0.0,
        sodium: 50,
        calcium: '0%',
        iron: '0%'
      }, {
        name: 'Lollipop',
        calories: 392,
        fat: 0.2,
        carbs: 98,
        protein: 0,
        sodium: 38,
        calcium: '0%',
        iron: '2%'
      }, {
        name: 'Honeycomb',
        calories: 408,
        fat: 3.2,
        carbs: 87,
        protein: 6.5,
        sodium: 562,
        calcium: '0%',
        iron: '45%'
      }, {
        name: 'Donut',
        calories: 452,
        fat: 25.0,
        carbs: 51,
        protein: 4.9,
        sodium: 326,
        calcium: '2%',
        iron: '22%'
      }, {
        name: 'KitKat',
        calories: 518,
        fat: 26.0,
        carbs: 65,
        protein: 7,
        sodium: 54,
        calcium: '12%',
        iron: '6%'
      }]
    };
  },
  created: function created() {
    this.$bindAsArray('firm', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand', 'finYear']), {
    firmsByBrand: function firmsByBrand() {
      var _this = this;

      // return selected brand firms
      var firms = this.firm.filter(function (item) {
        return item['brand'] === _this.selectedBrand;
      });
      firms.map(function (item) {
        if (item.defaultFirm) {
          _this.selectedFirm = item;
        }
      });
      return firms;
    }
  })
});

/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Balancesheet_expandCard__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_pdf_reports_information_reports__ = __webpack_require__(46);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])('Global')['mapGetters'];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      rowsPerPageItems: [4, 8, 12],
      search: '',
      pagination: {
        rowsPerPage: 4
      },
      items: [{
        name: 'Frozen Yogurt',
        calories: 159,
        fat: 6.0,
        carbs: 24,
        protein: 4.0,
        sodium: 87,
        calcium: '14%',
        iron: '1%'
      }, {
        name: 'Ice cream sandwich',
        calories: 237,
        fat: 9.0,
        carbs: 37,
        protein: 4.3,
        sodium: 129,
        calcium: '8%',
        iron: '1%'
      }, {
        name: 'Eclair',
        calories: 262,
        fat: 16.0,
        carbs: 23,
        protein: 6.0,
        sodium: 337,
        calcium: '6%',
        iron: '7%'
      }, {
        name: 'Cupcake',
        calories: 305,
        fat: 3.7,
        carbs: 67,
        protein: 4.3,
        sodium: 413,
        calcium: '3%',
        iron: '8%'
      }, {
        name: 'Gingerbread',
        calories: 356,
        fat: 16.0,
        carbs: 49,
        protein: 3.9,
        sodium: 327,
        calcium: '7%',
        iron: '16%'
      }, {
        name: 'Jelly bean',
        calories: 375,
        fat: 0.0,
        carbs: 94,
        protein: 0.0,
        sodium: 50,
        calcium: '0%',
        iron: '0%'
      }, {
        name: 'Lollipop',
        calories: 392,
        fat: 0.2,
        carbs: 98,
        protein: 0,
        sodium: 38,
        calcium: '0%',
        iron: '2%'
      }, {
        name: 'Honeycomb',
        calories: 408,
        fat: 3.2,
        carbs: 87,
        protein: 6.5,
        sodium: 562,
        calcium: '0%',
        iron: '45%'
      }, {
        name: 'Donut',
        calories: 452,
        fat: 25.0,
        carbs: 51,
        protein: 4.9,
        sodium: 326,
        calcium: '2%',
        iron: '22%'
      }, {
        name: 'KitKat',
        calories: 518,
        fat: 26.0,
        carbs: 65,
        protein: 7,
        sodium: 54,
        calcium: '12%',
        iron: '6%'
      }]
    };
  },
  created: function created() {
    this.$bindAsArray('firm', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(['selectedBrand', 'finYear']), {
    firmsByBrand: function firmsByBrand() {
      var _this = this;

      // return selected brand firms
      var firms = this.firm.filter(function (item) {
        return item['brand'] === _this.selectedBrand;
      });
      firms.map(function (item) {
        if (item.defaultFirm) {
          _this.selectedFirm = item;
        }
      });
      return firms;
    }
  })
});

/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_pdfmake_js__ = __webpack_require__(31);






var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      invoiceHeader: [{ text: "Print", value: "action" }, { text: "Date", value: "date", sortable: true },
      // { text: "Invoice - Key", value: "Name" },
      { text: "Buyer Name", value: "Father Name" }, { text: "Invoice No", value: "invoiceId", sortable: true }, { text: "Total Amount", value: "totalCurrentAmount" }, { text: "Basic Amount", value: "basic amount" }, { text: "GST", value: "GST" }, { text: "Extra Charges", value: "Extra Charges" }, { text: "Discount", value: "discount" }, { text: "Paid Amount", value: "Tehsil" }, { text: "Due Amount", value: "District" }, { text: "Duration (in Days)", value: "abs" }, { text: "Payment Type", value: "Identity Number" }, { text: "Status", value: "Mobile" },
      // { text: "Transaction Type", sortable: true, value: "paymentType" },
      { text: "GST Type", sortable: true, value: "gstType" }, { text: "IGST Value", sortable: true, value: "gstType" }, { text: "SGST Value", sortable: true, value: "gstType" }, { text: "CGST Value", sortable: true, value: "gstType" }, { text: "GST (3%)", sortable: true, value: "gstType" }, { text: "GST (5%)", sortable: true, value: "gstType" }, { text: "GST (12%)", sortable: true, value: "gstType" }, { text: "GST (18%)", sortable: true, value: "gstType" }, { text: "GST (28%)", sortable: true, value: "gstType" }, { text: "Admin email", sortable: true, value: "gstType" }, { text: "Firm Name", value: "Village" }, { text: "Voucher type", value: "totalAmount", sortable: false }],
      invoiceProductListHeader: [{ text: "Name", value: "Name", class: "font-weight-bold primary--text" }, { text: "HSN code", value: "HSN", class: "font-weight-bold primary--text" }, { text: "Taxable rate", value: "Taxable", class: "font-weight-bold primary--text" }, { text: "Unit", value: "Unit", class: "font-weight-bold primary--text" }, { text: "Quantity", value: "quantity", class: "font-weight-bold primary--text" }, { text: "Rate", value: "rate", class: "font-weight-bold primary--text" }],
      pagination: {
        rowsPerPage: 10 // -1 for All",
      },
      normalData: [],
      dateFrom: null,
      dateTo: null,
      datepickerFrom: false,
      selectedFirm: null,
      datepickerTo: false,
      printBuffer: [],
      printBufferFinalLength: 0
    };
  },
  created: function created() {
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brandFinYear').equalTo(this.brandFinYear));
    this.$bindAsObject("sellers", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("buyers", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoiceHistory", this.$root.$firebaseRefs.invoiceHistory.orderByChild('brandFinYear').equalTo(this.brandFinYear));
    this.$bindAsArray("termsAndConditions", this.$root.$firebaseRefs.termsAndConditions.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("accounts", this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("productById", this.$root.$firebaseRefs.products.orderByChild("brand").equalTo(this.selectedBrand));
    if (this.finYear) {
      this.dateFrom = this.formatDate(this.finYear.start);
      this.dateTo = this.formatDate(this.finYear.end);
    }
    this.invoicesByBrandNormal();
  },

  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear", "brandFinYear"]), mapGlobalGetters({
    gState: "state"
  }), {
    firmsByBrand: function firmsByBrand() {
      var _this = this;

      return this.firms.filter(function (item) {
        return item["brand"] === _this.selectedBrand;
      }).map(function (item) {
        if (item.defaultFirm) {
          _this.selectedFirm = item['.key'];
        }
        return {
          text: item["name"],
          value: item[".key"]
        };
      });;
    }
  }),
  watch: {
    "selectedFirm": {
      handler: function handler(newVal, oldVal) {
        this.invoicesByBrandNormal();
      },

      deep: true
    },
    "dateTo": {
      handler: function handler(newVal, oldVal) {
        this.invoicesByBrandNormal();
      }
    },
    "dateFrom": {
      handler: function handler(newVal, oldVal) {
        this.invoicesByBrandNormal();
      }
    }
  },
  methods: (_methods = {
    convertToSinglePrint: function convertToSinglePrint() {
      var temp = this.printBuffer[0];
      this.printBuffer.map(function (item, index) {
        if (index != 0) {
          temp.content.push({ text: '', pageBreak: 'after' });
          temp.content = temp.content.concat(item.content);
        }
      });
      console.log(this.printBuffer);
      pdfMake.createPdf(temp).download('Acuify_file');
    },
    invoicesByBrandNormal: function invoicesByBrandNormal() {
      var _this2 = this;

      var toDate = this.dateTo ? new Date(this.dateTo).getTime() : null;
      var fromDate = this.dateFrom ? new Date(this.dateFrom).getTime() : null;
      var invoiceHistory = this.invoices.filter(function (item) {
        return item["brand"] === _this2.selectedBrand && (_this2.selectedFirm ? item["firm"] === _this2.selectedFirm : true) && item.deleted != true && (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true);
      });
      this.normalData = invoiceHistory;
    },
    buyerById: function buyerById(id) {
      if (this.buyers[id]) {
        return this.buyers[id];
      } else if (this.sellers[id]) {
        return this.sellers[id];
      }
    },
    formatDate: function formatDate(date) {
      var d = new Date(date),
          month = "" + (d.getMonth() + 1),
          day = "" + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    getGSTtotal: function getGSTtotal(item) {
      var GSTTotal = 0;
      item && item.items && item.items.map(function (item) {
        GSTTotal += __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
      });
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(GSTTotal);
    },
    getFirmName: function getFirmName(id) {
      var firm = this.firms.filter(function (item) {
        return item[".key"] == id;
      })[0];
      if (firm) {
        return firm["name"];
      }
    },
    print: function print(type) {
      var _this3 = this;

      this.printBuffer = [];
      this.printBufferFinalLength = this.normalData.filter(function (item) {
        return item.selectedForPrint;
      }).length;
      this.normalData.map(function (invoice) {
        if (invoice.selectedForPrint) {
          _this3[type](invoice);
        }
      });
    },
    getVocherType: function getVocherType(invoice) {
      if (invoice.return) {
        if (invoice.isBuyer) {
          return "Credit Note";
        } else {
          return "Debit Note";
        }
      }
      // if (invoice.isBuyer && invoice.transactionType === "Debit") {
      //     return "Sale";
      // } 
      // else if (invoice.isBuyer && invoice.transactionType === "Credit") {
      //     return "Receipt";
      // }
      // else if (invoice.isBuyer && invoice.transactionType === "Partial Paid") {
      //     return "Receipt";
      // }
      // else if (!invoice.isBuyer && invoice.transactionType === "Debit") {
      //     return "Purchase";
      // }
      // else if (!invoice.isBuyer && invoice.transactionType === "Credit") {
      //     return "Payment";
      // }
      // else if (!invoice.isBuyer && invoice.transactionType === "Partial Paid") {
      //     return "Payment";
      // }
      if (invoice.isBuyer) {
        return "Sale";
      } else {
        return "Purchase";
      }
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "buyerById", function buyerById(id) {
    if (this.buyers[id]) {
      return this.buyers[id];
    } else if (this.sellers[id]) {
      return this.sellers[id];
    } else {
      return {
        name: "--"
      };
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "printBasicInvoice", function printBasicInvoice(selectedInvoice) {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
      var termsAndConditions, banks, firm, customer, gstInvoice, gstTotal, productObj, doc;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              termsAndConditions = _this4.getTermsAndConditions(selectedInvoice);

              if (termsAndConditions.length) {
                if (termsAndConditions[0].bank) {
                  banks = [];

                  termsAndConditions[0].bank.map(function (bankId) {
                    var bank = _this4.accounts.filter(function (item) {
                      return item[".key"] == bankId;
                    })[0];

                    bank.address = _this4.getAddress(bank);
                    banks.push(bank);
                  });
                  termsAndConditions[0].banks = banks;
                } else {
                  termsAndConditions[0].banks = [];
                }
              } else {
                termsAndConditions = [{
                  termsAndConditions: "",
                  banks: []
                }];
              }
              firm = _this4.firms.filter(function (item) {
                return item[".key"] == selectedInvoice.firm;
              })[0];

              firm.address = _this4.getAddress(firm);
              customer = _this4.buyerById(selectedInvoice.buyerId);

              customer.address = _this4.getAddress(customer);
              customer.stateCode = _this4.gState.filter(function (item) {
                return item.state == customer.state;
              })[0].code;
              // selectedInvoice['date'] = selectedInvoice['dateOfInvoice'];
              gstInvoice = firm.GST_user && firm.GST_user == "Yes" ? true : false;
              gstTotal = _this4.calculateGSTInvoice(customer, selectedInvoice);
              productObj = {};

              if (!gstInvoice && termsAndConditions[0].isMajorUnitDisplay) {
                selectedInvoice.items.map(function (item) {
                  productObj[item['productId']] = _this4.productById[item['productId']];
                });
              }

              if (!gstInvoice) {
                _context.next = 17;
                break;
              }

              _context.next = 14;
              return Object(__WEBPACK_IMPORTED_MODULE_6__utils_pdfmake_js__["c" /* convertToBasicInvoice */])({
                invoiceData: selectedInvoice,
                firm: firm,
                customer: customer,
                gstTotal: gstTotal,
                terms: termsAndConditions[0]
              });

            case 14:
              _context.t0 = _context.sent;
              _context.next = 20;
              break;

            case 17:
              _context.next = 19;
              return Object(__WEBPACK_IMPORTED_MODULE_6__utils_pdfmake_js__["f" /* convertToBasicInvoiceWithoutGST */])({
                invoiceData: selectedInvoice,
                firm: firm,
                customer: customer,
                gstTotal: gstTotal,
                terms: termsAndConditions[0],
                productObj: productObj
              });

            case 19:
              _context.t0 = _context.sent;

            case 20:
              doc = _context.t0;

              _this4.printBuffer.push(doc);
              if (_this4.printBufferFinalLength == _this4.printBuffer.length) {
                _this4.convertToSinglePrint();
              }

            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this4);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "printHorizontalInvoice", function printHorizontalInvoice(selectedInvoice) {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var termsAndConditions, banks, firm, customer, gstTotal;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              termsAndConditions = _this5.getTermsAndConditions(selectedInvoice);

              if (termsAndConditions.length) {
                if (termsAndConditions[0].bank) {
                  banks = [];

                  termsAndConditions[0].bank.map(function (bankId) {
                    var bank = _this5.accounts.filter(function (item) {
                      return item[".key"] == bankId;
                    })[0];

                    bank.address = _this5.getAddress(bank);
                    banks.push(bank);
                  });
                  termsAndConditions[0].banks = banks;
                } else {
                  termsAndConditions[0].banks = [];
                }
              } else {
                termsAndConditions = [{
                  termsAndConditions: "",
                  banks: []
                }];
              }
              firm = _this5.firms.filter(function (item) {
                return item[".key"] == selectedInvoice.firm;
              })[0];

              firm.address = _this5.getAddress(firm);
              customer = _this5.buyerById(selectedInvoice.buyerId);

              customer.stateCode = _this5.gState.filter(function (item) {
                return item.state == customer.state;
              })[0].code;
              customer.address = _this5.getAddress(customer);
              gstTotal = _this5.calculateGSTInvoice(customer, selectedInvoice);
              _context2.next = 10;
              return Object(__WEBPACK_IMPORTED_MODULE_6__utils_pdfmake_js__["e" /* convertToBasicInvoiceHorizontal */])({
                invoiceData: selectedInvoice,
                firm: firm,
                customer: customer,
                gstTotal: gstTotal,
                terms: termsAndConditions[0]
              }).then(function (doc) {
                _this5.printBuffer.push(doc);
                if (_this5.printBufferFinalLength == _this5.printBuffer.length) {
                  _this5.convertToSinglePrint();
                }
              });

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this5);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "printInvoice4", function printInvoice4(selectedInvoice) {
    var _this6 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var termsAndConditions, banks, firm, customer, gstTotal;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              termsAndConditions = _this6.getTermsAndConditions(selectedInvoice);

              if (termsAndConditions.length) {
                if (termsAndConditions[0].bank) {
                  banks = [];

                  termsAndConditions[0].bank.map(function (bankId) {
                    var bank = _this6.accounts.filter(function (item) {
                      return item[".key"] == bankId;
                    })[0];

                    bank.address = _this6.getAddress(bank);
                    banks.push(bank);
                  });
                  termsAndConditions[0].banks = banks;
                } else {
                  termsAndConditions[0].banks = [];
                }
              } else {
                termsAndConditions = [{
                  termsAndConditions: "",
                  banks: []
                }];
              }
              firm = _this6.firms.filter(function (item) {
                return item[".key"] == selectedInvoice.firm;
              })[0];

              firm.address = _this6.getAddress(firm);
              customer = _this6.buyerById(selectedInvoice.buyerId);

              customer.stateCode = _this6.gState.filter(function (item) {
                return item.state == customer.state;
              })[0].code;
              customer.address = _this6.getAddress(customer);
              gstTotal = _this6.calculateGSTInvoice(customer, selectedInvoice);
              _context3.next = 10;
              return Object(__WEBPACK_IMPORTED_MODULE_6__utils_pdfmake_js__["p" /* convertToSimpleInvoicePrint */])({
                invoiceData: selectedInvoice,
                firm: firm,
                customer: customer,
                gstTotal: gstTotal,
                terms: termsAndConditions[0],
                previousDue: [],
                estimates: []
              }).then(function (doc) {
                _this6.printBuffer.push(doc);
                if (_this6.printBufferFinalLength == _this6.printBuffer.length) {
                  _this6.convertToSinglePrint();
                }
              });

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this6);
    }))();
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "getTermsAndConditions", function getTermsAndConditions(selectedInvoice) {
    var _this7 = this;

    return this.termsAndConditions.filter(function (item) {
      return item["brand"] === _this7.selectedBrand && item["firm"] === selectedInvoice.firm;
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "getAddress", function getAddress(item) {
    var address = (item.village ? item.village + " - " : "") + (item.block ? item.block + " - " : "") + (item.tehsil ? item.tehsil + " - " : "") + (item.district ? item.district + " - " : "") + (item.state ? item.state + " - " : "") + (item.country ? item.country + " - " : "");
    address = address.substring(0, address.length - 2);
    return address;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "getGSTtotal", function getGSTtotal(item) {
    var GSTTotal = 0;
    item && item.items && item.items.map(function (item) {
      GSTTotal += __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(item.GSTValue);
    });
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(GSTTotal);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "calculateGSTInvoice", function calculateGSTInvoice(currentUser, invoice) {
    var SGST_val = 0;
    var CGST_val = 0;
    var IGST_val = 0;
    invoice.items && invoice.items.map(function (item, index) {
      SGST_val += parseFloat(item["SGST_val"]);
      CGST_val += parseFloat(item["CGST_val"]);
      IGST_val += parseFloat(item["IGST_val"]);
    });
    return { SGST_val: SGST_val, CGST_val: CGST_val, IGST_val: IGST_val };
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "firmNameById", function firmNameById(id) {
    var firm = this.firms.filter(function (item) {
      return item[".key"] == id;
    })[0];
    if (firm) {
      return firm["name"];
    }
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "renderDate", function renderDate(timeStamp) {
    if (timeStamp) {
      return new Date(timeStamp).toLocaleDateString("en-GB");
    }
    return "--";
  }), _methods)
});

/***/ }),
/* 589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      headers: [{ text: "Products", value: "action" }, { text: "Quantity", value: "quantity" }]
    };
  },
  created: function created() {
    this.$bindAsArray("orders", this.$root.$firebaseRefs.orders.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild("brand").equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear"]), {
    getFilteredProducts: function getFilteredProducts() {
      var _this = this;

      var products = this.products.filter(function (item) {
        return item.brand == _this.selectedBrand;
      });

      this.orders.filter(function (order) {
        return order.brand == _this.selectedBrand && order.status == "IN PROGRESS" && order.isBuyer == true;
      }).map(function (item) {
        item.items.map(function (orderItem) {
          if (!orderItem.completed) {
            var index = products.findIndex(function (r) {
              return r[".key"] == orderItem.productId;
            });
            if (index && index > -1) {
              if (products[index].orderQuantity == undefined) {
                products[index].orderQuantity = 0;
              }
              products[index].orderQuantity += orderItem.quantity;
            }
          }
        });
      });
      return products.filter(function (p) {
        return !!p['orderQuantity'];
      });
    }
  }),
  methods: {}
});

/***/ }),
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      headers: [{ text: "Products", value: "action" }, { text: "Quantity", value: "quantity" }]
    };
  },
  created: function created() {
    this.$bindAsArray("leads", this.$root.$firebaseRefs.leads.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild("brand").equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear"]), {
    getFilteredProducts: function getFilteredProducts() {
      var _this = this;

      var products = this.products.filter(function (item) {
        return item.brand == _this.selectedBrand;
      });

      this.leads.filter(function (lead) {
        return lead.brand == _this.selectedBrand && lead.status == "PENDING" && lead.isBuyer == true;
      }).map(function (item) {
        item.items.map(function (leadItem) {
          if (!leadItem.completed) {
            var index = products.findIndex(function (r) {
              return r[".key"] == leadItem.productId;
            });
            if (index && index > -1) {
              if (products[index].leadQuantity == undefined) {
                products[index].leadQuantity = 0;
              }
              products[index].leadQuantity += leadItem.quantity;
            }
          }
        });
      });
      return products.filter(function (p) {
        return !!p['leadQuantity'];
      });
    }
  }),
  methods: {}
});

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      headers: [{ text: "Products", value: "action" }, { text: "Quantity", value: "quantity" }]
    };
  },
  created: function created() {
    this.$bindAsArray("estimates", this.$root.$firebaseRefs.estimates.orderByChild("brand").equalTo(this.selectedBrand)), this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild("brand").equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear"]), {
    getFilteredProducts: function getFilteredProducts() {
      var _this = this;

      var products = this.products.filter(function (item) {
        return item.brand == _this.selectedBrand;
      });

      this.estimates.filter(function (estimate) {
        return estimate.brand == _this.selectedBrand && estimate.status == "IN PROGRESS" && estimate.isBuyer == true;
      }).map(function (item) {
        item.items.map(function (estimateItem) {
          if (!estimateItem.completed) {
            var index = products.findIndex(function (r) {
              return r[".key"] == estimateItem.productId;
            });
            if (index && index > -1) {
              if (products[index].estimateQuantity == undefined) {
                products[index].estimateQuantity = 0;
              }
              products[index].estimateQuantity += estimateItem.quantity;
            }
          }
        });
      });
      return products.filter(function (p) {
        return !!p['estimateQuantity'];
      });
    }
  }),
  methods: {}
});

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var mapGlobalGetters = Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* createNamespacedHelpers */])("Global")["mapGetters"];
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      batchReportHeader: [{ text: "View", value: "batch" }, { text: "Batch", value: "batch" }, { text: "Manufacturing Date", value: "manuDate" }, { text: "Expiry Date", value: "expiryDate" }, { text: "Quantity", value: "quantity" }],
      headers: [{ text: "Products", value: "action" }, { text: "Date", value: "date", sortable: true }, { text: "Buyer Name", value: "Father Name" }, { text: "Invoice ID", value: "Block" }, { text: "Total Amount", value: "totalCurrentAmount" }, { text: "Basic Amount", value: "basic" }, { text: "GST", value: "GST" }, { text: "Discount", value: "totalCurrentAmount" }, { text: "Paid Amount", value: "Tehsil" }, { text: "Due Amount", value: "District" }, { text: "Duration (in Days)", value: "abs" }, { text: "Days Left", sortable: true, value: "daysLeft" }, { text: "Payment Type", value: "Identity Number" }, { text: "Status", value: "Mobile" }, { text: "GST type", value: "gst type" }, { text: "Mobile", value: "mobile" }, { text: "Tehsil", value: "tehsil" }, { text: "District", value: "district" }, { text: "State", value: "state" }, { text: "Firm Name", value: "Village" }],
      invoiceProductListHeader: [{ text: "Product Name", value: "productName" }, { text: "HSN code", value: "HSN" }, { text: "Product rate", value: "rate" }, { text: "GST %", value: "GST Rate" }, { text: "Unit", value: "Unit" }, { text: "Quantity", value: "quantity" }],
      filteredInvoices: [],
      viewBatchDialog: false,
      selectedInvoice: {
        items: []
      },
      dialog: false,
      toDate: null,
      fromDate: null,
      datepickerFrom: null,
      datepickerTo: null
    };
  },
  created: function created() {
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild("brandFinYear").equalTo(this.brandFinYear));
    this.$bindAsArray("batches", this.$root.$firebaseRefs.batchTransaction.orderByChild("brand").equalTo(this.selectedBrand));
    this.$bindAsArray("products", this.$root.$firebaseRefs.products.orderByChild("brand").equalTo(this.selectedBrand));
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalGetters(["selectedBrand", "finYear", "brandFinYear"]), {
    getFilteredBatches: function getFilteredBatches() {
      var _this = this;

      var results = [];
      results.push({
        batchNumber: "No Batch Assigned",
        quantity: 0,
        invoices: []
      });
      var filteredInvoices = this.invoices.filter(function (item) {
        return item["brand"] === _this.selectedBrand && item.deleted != true;
      });
      this.batches.map(function (it) {
        results.push({
          batchNumber: it.batchNumber,
          quantity: it.openingQuantity || 0,
          invoices: [],
          manufacturingDate: it.manufacturingDate,
          expiryDate: it.expiryDate,
          id: it['.key']
        });
      });
      filteredInvoices.forEach(function (element) {
        element.items && element.items.map(function (item) {
          if (!item.batchId) {
            var index = results.findIndex(function (r) {
              return r.batchNumber == "No Batch Assigned";
            });
            results[index].quantity += element.isBuyer ? -item.quantity : item.quantity;

            results[index].invoices.push(element);
          } else {
            var _index = results.findIndex(function (r) {
              return r["id"] == item.batchId;
            });
            if (_index && _index > -1) {
              results[_index].quantity += element.isBuyer ? -item.quantity : item.quantity;
              results[_index].invoices.push(element);
            }
          }
        });
      });
      return results.filter(function (item) {
        return (_this.fromDate ? item.expiryDate >= new Date(_this.toDate).getTime() : true) && (_this.toDate ? item.expiryDate <= new Date(_this.toDate).getTime() : true);
      });
    }
  }),
  methods: {
    getProductName: function getProductName(key) {
      return this.products.find(function (item) {
        return item[".key"] == key;
      }).name;
    },
    openInvoice: function openInvoice(item) {
      this.filteredInvoices = item.invoices;
      this.viewBatchDialog = true;
    },
    openProd: function openProd(invoice) {
      this.selectedInvoice = invoice;
      this.dialog = true;
    }
  }
});

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuefire__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_es5_components_transitions__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_es5_components_transitions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetify_es5_components_transitions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_VApp__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_VApp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_VApp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VAutocomplete__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VAutocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VAutocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VBtn__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VCard__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VCheckbox__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VCheckbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VCheckbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VChip__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VChip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VChip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VDataIterator__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VDataIterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VDataIterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VDataTable__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VDataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VDataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VDatePicker__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VDatePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VDatePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_VDialog__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_VDialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_VDialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VDivider__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VDivider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VDivider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VExpansionPanel__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VExpansionPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VExpansionPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VFooter__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VFooter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VFooter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VForm__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VGrid__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VGrid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VGrid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VIcon__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VIcon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VIcon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_VImg__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_VImg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_VImg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vuetify_es5_components_VList__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vuetify_es5_components_VList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vuetify_es5_components_VList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vuetify_es5_components_VMenu__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vuetify_es5_components_VMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_vuetify_es5_components_VMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vuetify_es5_components_VNavigationDrawer__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vuetify_es5_components_VNavigationDrawer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_vuetify_es5_components_VNavigationDrawer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vuetify_es5_components_VRadioGroup__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vuetify_es5_components_VRadioGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_vuetify_es5_components_VRadioGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vuetify_es5_components_VSelect__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vuetify_es5_components_VSelect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_vuetify_es5_components_VSelect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vuetify_es5_components_VSlider__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vuetify_es5_components_VSlider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_vuetify_es5_components_VSlider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vuetify_es5_components_VSnackbar__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vuetify_es5_components_VSnackbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_vuetify_es5_components_VSnackbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vuetify_es5_components_VStepper__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vuetify_es5_components_VStepper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_vuetify_es5_components_VStepper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vuetify_es5_components_VProgressLinear__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vuetify_es5_components_VProgressLinear___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_vuetify_es5_components_VProgressLinear__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vuetify_es5_components_VSubheader__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vuetify_es5_components_VSubheader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_vuetify_es5_components_VSubheader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_vuetify_es5_components_VTabs__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_vuetify_es5_components_VTabs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_vuetify_es5_components_VTabs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_vuetify_es5_components_VTextField__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_vuetify_es5_components_VTextField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_vuetify_es5_components_VTextField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_vuetify_es5_components_VToolbar__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_vuetify_es5_components_VToolbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_vuetify_es5_components_VToolbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_vuetify_es5_components_VTooltip__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_vuetify_es5_components_VTooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_vuetify_es5_components_VTooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_vuetify_es5_components_VTextarea__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_vuetify_es5_components_VTextarea___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_vuetify_es5_components_VTextarea__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_vuetify_es5_components_VSwitch__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_vuetify_es5_components_VSwitch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_vuetify_es5_components_VSwitch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_vuetify_es5_components_VCombobox__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_vuetify_es5_components_VCombobox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_vuetify_es5_components_VCombobox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_vuetify_es5_components_VTimePicker__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_vuetify_es5_components_VTimePicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_vuetify_es5_components_VTimePicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_vuex__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__node_modules_vuetify_src_stylus_app_styl__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__node_modules_vuetify_src_stylus_app_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__node_modules_vuetify_src_stylus_app_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__App__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__router__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__store__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__i18n__ = __webpack_require__(185);


// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


// import VueResource from 'vue-resource'















































var mapGlobalActions = Object(__WEBPACK_IMPORTED_MODULE_41_vuex__["a" /* createNamespacedHelpers */])("Global")["mapActions"];

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuetify___default.a, {
  components: {
    VApp: __WEBPACK_IMPORTED_MODULE_6_vuetify_es5_components_VApp___default.a,
    VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_25_vuetify_es5_components_VNavigationDrawer___default.a,
    VFooter: __WEBPACK_IMPORTED_MODULE_18_vuetify_es5_components_VFooter___default.a,
    VList: __WEBPACK_IMPORTED_MODULE_23_vuetify_es5_components_VList___default.a,
    VBtn: __WEBPACK_IMPORTED_MODULE_8_vuetify_es5_components_VBtn___default.a,
    VIcon: __WEBPACK_IMPORTED_MODULE_21_vuetify_es5_components_VIcon___default.a,
    VGrid: __WEBPACK_IMPORTED_MODULE_20_vuetify_es5_components_VGrid___default.a,
    VToolbar: __WEBPACK_IMPORTED_MODULE_35_vuetify_es5_components_VToolbar___default.a,
    VTabs: __WEBPACK_IMPORTED_MODULE_33_vuetify_es5_components_VTabs___default.a,
    VCard: __WEBPACK_IMPORTED_MODULE_9_vuetify_es5_components_VCard___default.a,
    VImg: __WEBPACK_IMPORTED_MODULE_22_vuetify_es5_components_VImg___default.a,
    VDivider: __WEBPACK_IMPORTED_MODULE_16_vuetify_es5_components_VDivider___default.a,
    VSubheader: __WEBPACK_IMPORTED_MODULE_32_vuetify_es5_components_VSubheader___default.a,
    VForm: __WEBPACK_IMPORTED_MODULE_19_vuetify_es5_components_VForm___default.a,
    VTextField: __WEBPACK_IMPORTED_MODULE_34_vuetify_es5_components_VTextField___default.a,
    VChip: __WEBPACK_IMPORTED_MODULE_11_vuetify_es5_components_VChip___default.a,
    VSelect: __WEBPACK_IMPORTED_MODULE_27_vuetify_es5_components_VSelect___default.a,
    VMenu: __WEBPACK_IMPORTED_MODULE_24_vuetify_es5_components_VMenu___default.a,
    VDialog: __WEBPACK_IMPORTED_MODULE_15_vuetify_es5_components_VDialog___default.a,
    VTooltip: __WEBPACK_IMPORTED_MODULE_36_vuetify_es5_components_VTooltip___default.a,
    VStepper: __WEBPACK_IMPORTED_MODULE_30_vuetify_es5_components_VStepper___default.a,
    VDataTable: __WEBPACK_IMPORTED_MODULE_13_vuetify_es5_components_VDataTable___default.a,
    VSnackbar: __WEBPACK_IMPORTED_MODULE_29_vuetify_es5_components_VSnackbar___default.a,
    VDataIterator: __WEBPACK_IMPORTED_MODULE_12_vuetify_es5_components_VDataIterator___default.a,
    VCheckbox: __WEBPACK_IMPORTED_MODULE_10_vuetify_es5_components_VCheckbox___default.a,
    VExpansionPanel: __WEBPACK_IMPORTED_MODULE_17_vuetify_es5_components_VExpansionPanel___default.a,
    VAutocomplete: __WEBPACK_IMPORTED_MODULE_7_vuetify_es5_components_VAutocomplete___default.a,
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_31_vuetify_es5_components_VProgressLinear___default.a,
    VSlider: __WEBPACK_IMPORTED_MODULE_28_vuetify_es5_components_VSlider___default.a,
    VDatePicker: __WEBPACK_IMPORTED_MODULE_14_vuetify_es5_components_VDatePicker___default.a,
    VRadioGroup: __WEBPACK_IMPORTED_MODULE_26_vuetify_es5_components_VRadioGroup___default.a,
    VTextarea: __WEBPACK_IMPORTED_MODULE_37_vuetify_es5_components_VTextarea___default.a,
    transitions: __WEBPACK_IMPORTED_MODULE_5_vuetify_es5_components_transitions___default.a,
    VSwitch: __WEBPACK_IMPORTED_MODULE_38_vuetify_es5_components_VSwitch___default.a,
    VCombobox: __WEBPACK_IMPORTED_MODULE_39_vuetify_es5_components_VCombobox___default.a,
    VTimePicker: __WEBPACK_IMPORTED_MODULE_40_vuetify_es5_components_VTimePicker___default.a
  },
  theme: {
    primary: '#15155D',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#B71C1C',
    info: '#2196F3',
    success: '#1B5E20',
    warning: '#F9A825'
  }
});

// import Vuetify from 'vuetify'
// import 'vuetify/dist/vuetify.min.css'

// Vue.use(Vuetify)

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_41_vuex__["b" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuefire___default.a);
// Vue.use(VueResource)

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('list', function (val) {
  if (!val) return '';
  if (!!val.join) return val.join(', ');
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('capitalize', function (val) {
  if (!val) return '';
  return val.toUpperCase();
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('invoiceTransactionType', function (invoice) {
  var invoiceTypes = {
    asset: 'Asset',
    deposit: 'Deposit',
    expense: 'Expense',
    income: 'Income',
    liability: 'Liability',
    normal: 'Normal',
    salary: 'Salary',
    transfer: 'Transfer',
    withdrawl: 'With Drawl',
    staff: 'Staff'
  };

  if (invoice.transactionType && invoiceTypes[invoice.transactionType]) {
    return invoice.transactionType;
  }
  if (invoice.type === 'automatic invoice') {
    if (invoice.assetType) return invoiceTypes.asset;
    if (invoice.expenseType) return invoiceTypes.expense;
    if (invoice.incomeType) return invoiceTypes.income;
    if (invoice.liablityType) return invoiceTypes.liability;
  }
  return invoiceTypes.normal;
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('localeAmount', function (value) {
  if (!!value) return value.toLocaleString();
  return 0;
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('amount', function (value) {
  var n = Number(value);
  if (n === 'NaN') {
    return 0.00;
  } else if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(n)) {
    return n.toLocaleString('en-IN') + '.00';
  } else if (n !== 'NaN') {
    if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(Number(n.toFixed(2)))) {
      return Number(n.toFixed(2)).toLocaleString('en-IN') + '.00';
    }
    return Number(n.toFixed(2)).toLocaleString('en-IN');
  } else {
    return n.toLocaleString('en-IN') + '.00';
  }
});

var total = 12;
var reduceLoader = function reduceLoader() {
  total -= 1;
  if (total === 0) {
    var loader = document.getElementsByClassName('app-loader');
    if (loader && loader.length) {
      loader[0].remove();
    } else {
      console.info('something went wrong...');
    }
  }
};
var brand = window.localStorage.getItem('brand');
var brandFinYear = window.localStorage.getItem('brandFinYear');

if (!brand) {
  brand = "-";
}
if (!brandFinYear) {
  brandFinYear = '-';
}
//console.log("------------("+brandFinYear)
//console.log("------------("+brand)

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
  el: '#app',
  firebase: {
    buyer: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('buyer').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    seller: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('seller').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    invoice: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('invoice').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    item: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('item').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    brand: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('brand'),
      readyCallback: reduceLoader
    },
    firm: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('firm').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    firmSettings: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('firmSettings').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    operator: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('operator').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    account: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('account').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    loan: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('loan').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    // loanadvances: { 
    //   source:firebase.database.ref('loanadvances'), 
    //   readyCallback: reduceLoader,
    // },
    staffs: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('staffs').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    staff: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('staff').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    assets: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('assets').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    expenses: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('expenses').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    liabilities: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('liabilities').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    incomes: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('incomes').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    rate: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('rate').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    customerDeposit: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('customerDeposit').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    products: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('products').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    hrs: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('hrs').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    invoiceHistory: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('invoiceHistory').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    salarys: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('salarys').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    liabilitys: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('liabilitys').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    termsAndConditions: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('termsAndConditions').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    provisionExpense: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('provisionExpense').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    provisionLiability: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('provisionLiability').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    provisionIncome: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('provisionIncome').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    itcPayment: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('itcPayment').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    godawn: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('godawn').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    godawnTransaction: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('godawnTrans').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    closingDetails: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('closingDetails').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    productGroup: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('productGroup').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    productCategory: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('productCategory').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    productType: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('productType').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    batchTransaction: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('batchTransaction').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    damageTransaction: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('damageTransaction').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    orders: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('orders').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    leads: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('leads').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    letterHeads: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('letterHeads').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    todos: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('todos').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    estimates: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('estimates').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    productSets: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('productSets').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    customerPayments: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('customerPayments').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    brandPermission: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('brandPermission').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    branch: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('branch').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    branchTransaction: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('branchTrans').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    transaction: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('transaction').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    shopSettings: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('shopSettings').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    productUniqueId: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('productUniqueId').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    firmInfrastructure: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('firmInfrastructure').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    portfolio: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('portfolio').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    productManufactureTransaction: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('productManufactureTransaction').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    productDamageTransaction: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('productDamageTransaction').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    productReplaceTransaction: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('productReplaceTransaction').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    productRepair: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('productRepair').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    productDrawer: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('productDrawer').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    drawerTransaction: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('drawerTransaction').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    orderSetting: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('orderSetting').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    leadSetting: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('leadSetting').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    receiptCollections: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('receiptCollections').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    },
    productRateCategory: {
      source: __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].database.ref('productRateCategory').orderByChild('brand').equalTo(brand),
      readyCallback: reduceLoader
    }
  },
  router: __WEBPACK_IMPORTED_MODULE_44__router__["a" /* default */],
  i18n: __WEBPACK_IMPORTED_MODULE_47__i18n__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_46__store__["a" /* default */],

  components: { App: __WEBPACK_IMPORTED_MODULE_43__App__["a" /* default */] },
  template: '<App/>',
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, mapGlobalActions(["SET_SELECTED_BRAND", "SET_BRAND_FIN_YEAR"])),
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_45__services_firebase_js__["b" /* default */].firebase.auth().onAuthStateChanged(function (user) {
      if (user) {
        // this.$router.push('/')
        // console.log('user', user)
        var _brandFinYear = window.localStorage.getItem('brandFinYear');
        if (!_brandFinYear) {
          var finYear = null;
          var date = new Date();
          var year = date.getFullYear();
          var month = date.getMonth();
          var qter = Math.floor((month + 3) / 3);
          if (qter == 1) {
            finYear = parseInt(year) - 1 + "-" + year.toString().slice(-2);
          } else {
            finYear = year + "-" + (parseInt(year) + 1).toString().slice(-2);
          }
          _brandFinYear = user.displayName + "_" + finYear;
        }
        _this.SET_BRAND_FIN_YEAR(_brandFinYear);
        _this.SET_SELECTED_BRAND(user.displayName);
        window.localStorage.setItem('brand', user.displayName);
        window.localStorage.setItem('brandFinYear', _brandFinYear);
        window.localStorage.setItem('user', user.uid);
      } else {
        window.localStorage.removeItem('user');
        window.localStorage.removeItem('brand');
        window.localStorage.removeItem('brandFinYear');
        // this.$router.push('/login')
      }
    });
  }
});

/***/ }),
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 616 */,
/* 617 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 618 */,
/* 619 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 620 */,
/* 621 */,
/* 622 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 631 */,
/* 632 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 633 */,
/* 634 */,
/* 635 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 636 */,
/* 637 */,
/* 638 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 639 */,
/* 640 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 641 */,
/* 642 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 650 */,
/* 651 */,
/* 652 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 657 */,
/* 658 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 659 */,
/* 660 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 666 */,
/* 667 */,
/* 668 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 669 */,
/* 670 */,
/* 671 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 676 */,
/* 677 */,
/* 678 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 683 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 690 */,
/* 691 */,
/* 692 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 693 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 694 */,
/* 695 */,
/* 696 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 697 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 698 */,
/* 699 */,
/* 700 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 705 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 706 */,
/* 707 */,
/* 708 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 713 */,
/* 714 */,
/* 715 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 726 */,
/* 727 */,
/* 728 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 729 */,
/* 730 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 731 */,
/* 732 */,
/* 733 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 734 */,
/* 735 */,
/* 736 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 737 */,
/* 738 */,
/* 739 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 745 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 759 */,
/* 760 */,
/* 761 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 771 */,
/* 772 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 773 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 774 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(286);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4eca78c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(777);
function injectStyle (ssrContext) {
  __webpack_require__(776)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4eca78c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 776 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home_index_vue__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Login___ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SignUp___ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_ForgotPassword___ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_PublicPages_PrivacyPolicy_vue__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18n__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__home__ = __webpack_require__(859);









// import { cfirebase } from '../services/firebase.js'



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = [{
  path: '/',
  name: 'Home',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Home_index_vue__["a" /* default */],
  children: __WEBPACK_IMPORTED_MODULE_8__home__["a" /* default */],
  redirect: 'Dashboard',
  meta: { requiresAuth: true }
}, {
  path: '/login',
  name: 'Login',
  component: __WEBPACK_IMPORTED_MODULE_3__components_Login___["a" /* default */]
}, {
  path: '/signup',
  name: 'SignUp',
  component: __WEBPACK_IMPORTED_MODULE_4__components_SignUp___["a" /* default */]
}, {
  path: '/forgot-password',
  name: 'ForgotPassword',
  component: __WEBPACK_IMPORTED_MODULE_5__components_ForgotPassword___["a" /* default */]
}, {
  path: '*',
  redirect: '/'
}, {
  path: '/privacy-policy',
  name: 'PrivacyPolicy',
  component: __WEBPACK_IMPORTED_MODULE_6__components_PublicPages_PrivacyPolicy_vue__["a" /* default */]
}];

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: routes
});

router.beforeEach(function (to, from, next) {
  // const uid = window.localStorage.getItem('user')
  // let user = cfirebase.auth().currentUser
  var user = window.localStorage.getItem('user');
  var brand = window.localStorage.getItem('brand');
  var locale = window.localStorage.getItem("locale");
  if (locale) {
    __WEBPACK_IMPORTED_MODULE_7__i18n__["a" /* default */].locale = locale;
  }
  if (to.name == 'Login' || to.name == 'SignUp') {
    var loader = document.getElementsByClassName('app-loader');
    // loader[0].remove();
    if (loader && loader.length) {
      // loader[0].remove();
      setTimeout(function () {
        loader[0].remove();
      }, 7000);
    }
  }
  if (to.meta.requiresAuth) {
    if (user && brand) {
      next();
    } else {
      next({ name: 'Login' });
    }
  } else {
    if (user && brand) {
      next('/');
    } else {
      next();
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 779 */,
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(287);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1db9ea1e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(827);
function injectStyle (ssrContext) {
  __webpack_require__(781)
  __webpack_require__(782)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1db9ea1e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1db9ea1e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 781 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 782 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// PRODUCTS
var PERMISSIONS_obj = ['PRODUCT_VIEW', 'PRODUCT_ADD', 'PRODUCT_EDIT', 'PRODUCT_DELETE', 'PRODUCT_TRANSFER', 'INVOICE_EDIT', 'INVOICE_DELETE', 'INVOICE_TRANSFER', 'BRAND_SETTINGS', 'BRAND_REPORTS', 'BRAND_RECORDS', 'BRAND_DASHBOARD', 'BRAND_BUYER', 'BRAND_TRANSACTIONS', 'PURCHASE_RATE_VIEW_EDIT', 'SALE_RATE_VIEW_EDIT', 'CHANGE_FIN_YEAR', 'CHANGE_DEFAULT_FIRM', 'AMOUNT_TRANSFER', 'BRAND_PRODUCTS', 'ORDER_RATE_EDIT', 'INDIVIDUAL_ORDER_EDIT', 'INDIVIDUAL_ORDER_DELETE'];
/* harmony default export */ __webpack_exports__["a"] = ({
    PERMISSIONS: PERMISSIONS_obj
});

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RateCard_vue__ = __webpack_require__(289);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2dae63c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RateCard_vue__ = __webpack_require__(811);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RateCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d2dae63c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RateCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ratesReportPDF; });

// playground requires you to assign document definition to a variable called dd
var ratesReportPDF = function ratesReportPDF(_ref) {
	var products = _ref.products;

	var dd = {
		content: [{ text: 'Rate Card\n', style: "topHeader1" }, {
			table: {
				body: [[{ text: 'Product Name', style: "gstHeader" }, { text: 'Description', style: "gstHeader" }, { text: 'HSN', style: "gstHeader" }, { text: 'Rate', style: "gstHeader" }]]
			}
		}],
		styles: {
			gstHeader: {
				fontSize: 12,
				bold: true,
				alignment: 'center'
			},
			data: {
				fontSize: 9,
				alignment: 'center'
			},
			topHeader1: {
				fontSize: 14,
				alignment: 'center',
				bold: true,
				fillColor: '#15155d'
			}
		}
	};

	products.map(function (product) {
		dd.content[1].table.body.push([{ text: product.name || '-', style: "data" }, { text: product.description || '-', style: "data" }, { text: product.HSN_code || '-', style: "data" }, { text: product.sellingPrice || '-', style: "data" }]);
	});

	return dd;
};

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',[_vm._v("Update Rate")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{staticStyle:{"margin-top":"10px"},attrs:{"prepend-inner-icon":"search","solo":"","outlined":"","clearable":"","label":"Search Product"},nativeOn:{"keyup":function($event){return _vm.keymonitor($event)}}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.printReport()}}},[_c('v-icon',[_vm._v("print")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.close($event)}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('v-select',{attrs:{"item-text":"name","return-object":"","items":_vm.productGroups,"clearable":"","label":"Product Group Filter"},model:{value:(_vm.selectedProductGroup),callback:function ($$v) {_vm.selectedProductGroup=$$v},expression:"selectedProductGroup"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[(_vm.hasPurchasePermission && _vm.selectedProductGroup)?_c('v-edit-dialog',{attrs:{"return-value":_vm.bulkPurchaseRate,"large":"","lazy":"","persistent":""},on:{"update:returnValue":function($event){_vm.bulkPurchaseRate=$event},"update:return-value":function($event){_vm.bulkPurchaseRate=$event},"save":function($event){return _vm.saveBulkRate(true)},"cancel":_vm.cancelRateSave,"open":_vm.openRateSave,"close":_vm.closeRateSave}},[_c('div',[_c('h3',[_vm._v("Update Purchase Rate")])]),_vm._v(" "),_c('template',{slot:"input"},[_c('div',{staticClass:"mt-3 title"},[_vm._v("Bulk Update Purchase Rate")])]),_vm._v(" "),_c('template',{slot:"input"},[_c('v-text-field',{attrs:{"rules":[_vm.onlyNumbers],"label":"Edit","single-line":"","counter":"","autofocus":"","align":""},model:{value:(_vm.bulkPurchaseRate),callback:function ($$v) {_vm.bulkPurchaseRate=$$v},expression:"bulkPurchaseRate"}})],1)],2):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[(_vm.hasSalePermission && _vm.selectedProductGroup)?_c('v-edit-dialog',{attrs:{"return-value":_vm.bulkSellingRate,"large":"","lazy":"","persistent":""},on:{"update:returnValue":function($event){_vm.bulkSellingRate=$event},"update:return-value":function($event){_vm.bulkSellingRate=$event},"save":function($event){return _vm.saveBulkRate(false)},"cancel":_vm.cancelRateSave,"open":_vm.openRateSave,"close":_vm.closeRateSave}},[_c('div',[_c('h3',[_vm._v("Update Selling Rate")])]),_vm._v(" "),_c('template',{slot:"input"},[_c('div',{staticClass:"mt-3 title"},[_vm._v("Bulk Update Selling Rate")])]),_vm._v(" "),_c('template',{slot:"input"},[_c('v-text-field',{attrs:{"rules":[_vm.onlyNumbers],"label":"Edit","single-line":"","counter":"","autofocus":"","align":""},model:{value:(_vm.bulkSellingRate),callback:function ($$v) {_vm.bulkSellingRate=$$v},expression:"bulkSellingRate"}})],1)],2):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[(_vm.selectedProductGroup)?_c('v-edit-dialog',{attrs:{"return-value":_vm.bulkHSN,"large":"","lazy":"","persistent":""},on:{"update:returnValue":function($event){_vm.bulkHSN=$event},"update:return-value":function($event){_vm.bulkHSN=$event},"save":function($event){return _vm.saveBulkHSN(false)},"cancel":_vm.cancelRateSave,"open":_vm.openRateSave,"close":_vm.closeRateSave}},[_c('div',[_c('h3',[_vm._v("Bulk Update HSN code")])]),_vm._v(" "),_c('template',{slot:"input"},[_c('div',{staticClass:"mt-3 title"},[_vm._v("Bulk Update HSN code")])]),_vm._v(" "),_c('template',{slot:"input"},[_c('v-text-field',{attrs:{"rules":[_vm.onlyNumbers],"label":"Edit","single-line":"","counter":"","autofocus":"","align":""},model:{value:(_vm.bulkHSN),callback:function ($$v) {_vm.bulkHSN=$$v},expression:"bulkHSN"}})],1)],2):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[(_vm.selectedProductGroup)?_c('v-edit-dialog',{attrs:{"return-value":_vm.bulkSpecialChargePercentage,"large":"","lazy":"","persistent":""},on:{"update:returnValue":function($event){_vm.bulkSpecialChargePercentage=$event},"update:return-value":function($event){_vm.bulkSpecialChargePercentage=$event},"save":function($event){return _vm.saveBulkSpecialChargePercentage(false)},"cancel":_vm.cancelRateSave,"open":_vm.openRateSave,"close":_vm.closeRateSave}},[_c('div',[_c('h3',[_vm._v("Bulk Update Special Charge")])]),_vm._v(" "),_c('template',{slot:"input"},[_c('div',{staticClass:"mt-3 title"},[_vm._v("Bulk Update Special Charge")])]),_vm._v(" "),_c('template',{slot:"input"},[_c('v-text-field',{attrs:{"rules":[_vm.onlyNumbers],"label":"Edit","single-line":"","counter":"","autofocus":"","align":""},model:{value:(_vm.bulkSpecialChargePercentage),callback:function ($$v) {_vm.bulkSpecialChargePercentage=$$v},expression:"bulkSpecialChargePercentage"}})],1)],2):_vm._e()],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.productsByBrand,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('h3',{staticClass:"primary--text"},[_vm._v(_vm._s(props.item.name))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[(_vm.hasPurchasePermission)?_c('v-edit-dialog',{attrs:{"return-value":props.item.purchasingPrice,"large":"","lazy":"","persistent":""},on:{"update:returnValue":function($event){return _vm.$set(props.item, "purchasingPrice", $event)},"update:return-value":function($event){return _vm.$set(props.item, "purchasingPrice", $event)},"save":function($event){return _vm.savePurchaseRate(props.item)},"cancel":_vm.cancelRateSave,"open":_vm.openRateSave,"close":_vm.closeRateSave}},[_c('div',[_c('h3',[_vm._v(_vm._s(props.item.purchasingPrice))])]),_vm._v(" "),_c('template',{slot:"input"},[_c('div',{staticClass:"mt-3 title"},[_vm._v("Update Purchase Rate")])]),_vm._v(" "),_c('template',{slot:"input"},[_c('v-text-field',{attrs:{"rules":[_vm.onlyNumbers],"label":"Edit","single-line":"","counter":"","autofocus":"","align":""},model:{value:(props.item.purchasingPrice),callback:function ($$v) {_vm.$set(props.item, "purchasingPrice", $$v)},expression:"props.item.purchasingPrice"}})],1)],2):_vm._e()],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[(_vm.hasSalePermission)?_c('v-edit-dialog',{attrs:{"return-value":props.item.sellingPrice,"large":"","lazy":"","persistent":""},on:{"update:returnValue":function($event){return _vm.$set(props.item, "sellingPrice", $event)},"update:return-value":function($event){return _vm.$set(props.item, "sellingPrice", $event)},"save":function($event){return _vm.saveSellingRate(props.item)},"cancel":_vm.cancelRateSave,"open":_vm.openRateSave,"close":_vm.closeRateSave}},[_c('div',[_c('h3',[_vm._v(_vm._s(props.item.sellingPrice))])]),_vm._v(" "),_c('template',{slot:"input"},[_c('div',{staticClass:"mt-3 title"},[_vm._v("Update Selling Rate")])]),_vm._v(" "),_c('template',{slot:"input"},[_c('v-text-field',{attrs:{"rules":[_vm.onlyNumbers],"label":"Edit","single-line":"","counter":"","autofocus":"","align":""},model:{value:(props.item.sellingPrice),callback:function ($$v) {_vm.$set(props.item, "sellingPrice", $$v)},expression:"props.item.sellingPrice"}})],1)],2):_vm._e()],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('v-edit-dialog',{attrs:{"return-value":props.item.HSN_code,"large":"","lazy":"","persistent":""},on:{"update:returnValue":function($event){return _vm.$set(props.item, "HSN_code", $event)},"update:return-value":function($event){return _vm.$set(props.item, "HSN_code", $event)},"save":function($event){return _vm.saveHSN(props.item)},"cancel":_vm.cancelRateSave,"open":_vm.openRateSave,"close":_vm.closeRateSave}},[_c('div',[_c('h3',[_vm._v(_vm._s(props.item.HSN_code))])]),_vm._v(" "),_c('template',{slot:"input"},[_c('div',{staticClass:"mt-3 title"},[_vm._v("Update HSN")])]),_vm._v(" "),_c('template',{slot:"input"},[_c('v-text-field',{attrs:{"rules":[_vm.onlyNumbers],"label":"Edit","single-line":"","counter":"","autofocus":"","align":""},model:{value:(props.item.HSN_code),callback:function ($$v) {_vm.$set(props.item, "HSN_code", $$v)},expression:"props.item.HSN_code"}})],1)],2)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_c('v-edit-dialog',{attrs:{"return-value":props.item.specialChargePercentage,"large":"","lazy":"","persistent":""},on:{"update:returnValue":function($event){return _vm.$set(props.item, "specialChargePercentage", $event)},"update:return-value":function($event){return _vm.$set(props.item, "specialChargePercentage", $event)},"save":function($event){return _vm.saveSpecialChargePercentage(props.item)},"cancel":_vm.cancelRateSave,"open":_vm.openRateSave,"close":_vm.closeRateSave}},[_c('div',[_c('h3',[_vm._v(_vm._s(props.item.specialChargePercentage))])]),_vm._v(" "),_c('template',{slot:"input"},[_c('div',{staticClass:"mt-3 title"},[_vm._v("Update Special Charge")])]),_vm._v(" "),_c('template',{slot:"input"},[_c('v-text-field',{attrs:{"rules":[_vm.onlyNumbers],"label":"Edit","single-line":"","counter":"","autofocus":"","align":""},model:{value:(props.item.specialChargePercentage),callback:function ($$v) {_vm.$set(props.item, "specialChargePercentage", $$v)},expression:"props.item.specialChargePercentage"}})],1)],2)],1),_vm._v(" "),_c('td',[_c('h3',[_vm._v(_vm._s(props.item.unit))])])]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AlertSidebar_vue__ = __webpack_require__(290);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c2c4caa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AlertSidebar_vue__ = __webpack_require__(824);
function injectStyle (ssrContext) {
  __webpack_require__(813)
  __webpack_require__(814)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c2c4caa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AlertSidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c2c4caa_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AlertSidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 813 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 814 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-expansion-panel',[(!_vm.alertMode)?_vm._l((_vm.filteredAlerts),function(item){return _c('v-expansion-panel-content',{key:item['.key'],class:item.daysLeft < 0 ? 'went' : 'coming',attrs:{"expand-icon":""}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('b',[_vm._v(_vm._s(item.buyerName))]),_c('br'),_vm._v(" "),(item.mobile)?_c('b',[_vm._v("Contact: "+_vm._s(item.mobile))]):_vm._e(),_c('br'),_vm._v("\r\n        "+_vm._s(_vm.generateAddress(item))+" \r\n      ")]),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('div',[_c('b',[_vm._v("Deposite Amount :")]),_vm._v(" "+_vm._s(item.paidAmount || null)),_c('br'),_vm._v(" "),_c('b',[_vm._v("Remaining Amount :")]),_vm._v(" "+_vm._s(item.remainingAmount || null)),_c('br'),_vm._v(" "),_c('b',[_vm._v("Total Amount :")]),_vm._v(" "+_vm._s(item.totalAmount || null)),_c('br'),_vm._v(" "),_c('b',[_vm._v("Basic Amount :")]),_vm._v(" "+_vm._s(item.totalAmount -  _vm.getGSTtotal(item)|| null)),_c('br'),_vm._v(" "),_c('b',[_vm._v("Discount Amount :")]),_vm._v(" "+_vm._s(item.discountAmount || null)),_c('br'),_vm._v(" "),_c('b',[_vm._v("GST Amount :")]),_vm._v(" "+_vm._s(_vm.getGSTtotal(item) || null)),_c('br'),_vm._v(" "),_c('b',[_vm._v("Transaction type :")]),_vm._v(" "+_vm._s(item.transactionType || null)),_c('br')])]),_vm._v(" "),_c('v-card-actions',{staticStyle:{"padding":"0 16px 16px 16px"}},[_c('v-btn',{attrs:{"small":"","color":"primary white--text"},on:{"click":function($event){_vm.dialogOpen=true; _vm.dialogDetail=item;}}},[_vm._v("View Details")])],1)],1)],1)}):_vm._l((_vm.filteredProducts),function(item){return _c('v-expansion-panel-content',{key:item['.key'],attrs:{"expand-icon":""}},[((item['alertQuantity'] ? item['closingQty'] <= item['alertQuantity']:item['closingQty'] <= 5))?[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('b',[_vm._v(_vm._s(item.name))]),_c('br')]),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('div',[_c('b',{staticClass:"font-weight-light"},[_vm._v("Quantity :")]),_vm._v(" "+_vm._s(item.closingQty || null)),_c('br')])])],1)]:_vm._e()],2)})],2),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.dialogOpen),callback:function ($$v) {_vm.dialogOpen=$$v},expression:"dialogOpen"}},[(_vm.dialogDetail)?_c('v-card',[_c('v-card-title',[_c('b',[_vm._v("Invoice Full Detail")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',[_c('b',[_vm._v("\r\n            Days "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.dialogDetail.daysLeft < 0 ? 'Went' : 'Left')}}),_vm._v("\r\n            : "+_vm._s(Math.abs(_vm.dialogDetail.daysLeft))+"\r\n          ")])]),_vm._v(" "),_c('v-card-text',[_c('b',[_vm._v("Name")]),_vm._v(" "+_vm._s(_vm.dialogDetail.buyerName)),_c('br'),_vm._v(" "),_c('b',[_vm._v("Prop Name :")]),_vm._v(" "+_vm._s(_vm.dialogDetail.propName)),_c('br'),_vm._v(" "),_c('b',[_vm._v("buyer Id :")]),_vm._v(" "+_vm._s(_vm.dialogDetail.buyerId)),_c('br'),_vm._v(" "),_c('b',[_vm._v("Village :")]),_vm._v(" "+_vm._s(_vm.dialogDetail.village)),_c('br'),_vm._v(" "),_c('b',[_vm._v("Block :")]),_vm._v(" "+_vm._s(_vm.dialogDetail.block)),_c('br'),_vm._v(" "),_c('b',[_vm._v("Tehsil :")]),_vm._v(" "+_vm._s(_vm.dialogDetail.tehsil)),_c('br'),_vm._v(" "),_c('b',[_vm._v("District :")]),_vm._v(" "+_vm._s(_vm.dialogDetail.district)),_c('br'),_vm._v(" "),_c('b',[_vm._v("Date :")]),_vm._v(" "+_vm._s(_vm.dialogDetail.date)),_c('br'),_vm._v(" "),_c('b',[_vm._v("Id :")]),_vm._v(" "+_vm._s(_vm.dialogDetail['.key'])),_c('br'),_vm._v(" "),_c('b',[_vm._v("Invoice ID :")]),_vm._v(" "+_vm._s(_vm.dialogDetail['invoiceId'])),_c('br'),_vm._v(" "),_c('b',[_vm._v("Firm Name :")]),_vm._v(" "+_vm._s(_vm.dialogDetail.firmName)),_c('br'),_vm._v(" "),_c('b',[_vm._v("Payment Type :")]),_vm._v(" "+_vm._s(_vm.dialogDetail.paymentType)),_c('br'),_vm._v(" "),_c('b',[_vm._v("Duration :")]),_vm._v(" "+_vm._s(_vm.dialogDetail.duration)+" days"),_c('br'),_vm._v(" "),_c('b',[_vm._v("Status :")]),_vm._v(" "+_vm._s(_vm.dialogDetail.status)),_c('br'),_vm._v(" "),_c('b',[_vm._v("Contact :")]),_vm._v(" "+_vm._s(_vm.dialogDetail.mobile)),_c('br'),_c('br'),_vm._v(" "),_c('b',[_vm._v("Deposite Amount :")]),_vm._v(" "+_vm._s(_vm.dialogDetail.paidAmount || null)),_c('br'),_vm._v(" "),_c('b',[_vm._v("Remaining Amount :")]),_vm._v(" "+_vm._s(_vm.dialogDetail.remainingAmount || null)),_c('br'),_vm._v(" "),_c('b',[_vm._v("Total Amount :")]),_vm._v(" "+_vm._s(_vm.dialogDetail.totalAmount || null)),_c('br'),_vm._v(" "),_c('b',[_vm._v("Basic Amount :")]),_vm._v(" "+_vm._s(_vm.dialogDetail.totalAmount -  _vm.getGSTtotal(_vm.dialogDetail)|| null)),_c('br'),_vm._v(" "),_c('b',[_vm._v("Discount Amount :")]),_vm._v(" "+_vm._s(_vm.dialogDetail.discountAmount || null)),_c('br'),_vm._v(" "),_c('b',[_vm._v("GST Amount :")]),_vm._v(" "+_vm._s(_vm.getGSTtotal(_vm.dialogDetail) || null)),_c('br')])],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary white--text","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogOpen=false}}},[_vm._v("Close")])],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnderMaintenance_vue__ = __webpack_require__(293);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d708ae6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnderMaintenance_vue__ = __webpack_require__(826);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UnderMaintenance_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d708ae6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UnderMaintenance_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","text-xs-center":"","fluid":""}},[_c('h3',{staticStyle:{"text-align":"center"}},[_c('v-icon',{staticClass:"primary--text",staticStyle:{"margin-top":"10%","font-size":"128px"},attrs:{"dark":"","left":""}},[_vm._v("warning")])],1),_vm._v(" "),_c('h2',{staticStyle:{"text-align":"center"}},[_vm._v("We’ll be back soon!")]),_vm._v(" "),_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v("\n    Sorry for the inconvenience. We’re performing some maintenance at the moment.\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-navigation-drawer',{attrs:{"absolute":"","persistent":"","mini-variant":_vm.miniVariant,"clipped":_vm.clipped,"enable-resize-watcher":"","fixed":"","app":"","expand-on-hover":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',[_vm._l((_vm.items),function(item,i){return [((item.title == 'Settings' ? _vm.hasSettingsPermission : true) 
          && (item.title == 'Dashboard' ? _vm.hasDashboardPermission : true)
          && (item.title == 'Buyers' ? _vm.hasBuyerPermission : true)
          && (item.title == 'Record' ? _vm.hasRecordsPermission : true)
          && (item.title == 'Reports' ? _vm.hasReportsPermission : true)
          && (item.title == 'Transactions' ? _vm.hasTransactionPermission : true))?_c('v-list-tile',{key:i,attrs:{"value":"true"},on:{"click":function($event){return _vm.switchRoute(item.link)}}},[_c('v-list-tile-action',[_c('div',{staticClass:"dashboard-item"},[_c('v-icon',{domProps:{"innerHTML":_vm._s(item.icon)}}),_vm._v(" "),_c('span',{staticClass:"dashboard-item-title"},[_vm._v(_vm._s(_vm.$t(item.title)))])],1)]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"textContent":_vm._s(item.title)}})],1)],1):_vm._e()]})],2)],1),_vm._v(" "),_c('v-toolbar',{staticClass:"primary white--text",attrs:{"app":"","clipped-left":_vm.clipped}},[_c('v-toolbar-side-icon',{staticClass:"primary white--text",on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t(_vm.title)))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.$route.path!='/transfer' && _vm.hasTransferPermission)?_c('router-link',{attrs:{"to":"/transfer"}},[_c('v-btn',{staticStyle:{"margin":"0px 15px"},attrs:{"flat":"","icon":"","color":"white"}},[_c('div',{staticClass:"dashboard-item",staticStyle:{"padding":"0px 20px 0px 20px"}},[_c('v-icon',[_vm._v("mdi-autorenew")]),_vm._v(" "),_c('span',{staticClass:"dashboard-item-title",staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.$t("Transfer")))])],1)])],1):_vm._e(),_vm._v(" "),_c('img',{staticStyle:{"display":"none"},attrs:{"id":"pdfimgToExport","src":__webpack_require__(828)}}),_vm._v(" "),_c('img',{staticStyle:{"display":"none"},attrs:{"id":"pdfimgToExportHorizontal","src":__webpack_require__(129)}}),_vm._v(" "),(_vm.hasRatesPermission)?_c('v-btn',{staticStyle:{"margin":"0px 15px"},attrs:{"flat":"","icon":"","color":"white"},on:{"click":function($event){_vm.dialog = true}}},[_c('div',{staticClass:"dashboard-item",staticStyle:{"padding":"0px 10px 0px 10px"}},[_c('v-icon',[_vm._v("text_snippet")]),_vm._v(" "),_c('span',{staticClass:"dashboard-item-title",staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.$t("Rates")))])],1)]):_vm._e(),_vm._v(" "),(_vm.$route.path!='/products' && _vm.hasProductsPermission)?_c('router-link',{attrs:{"to":"/products"}},[_c('v-btn',{staticStyle:{"margin":"0px 15px"},attrs:{"flat":"","icon":"","color":"white"}},[_c('div',{staticClass:"dashboard-item",staticStyle:{"padding":"0px 20px 0px 20px"}},[_c('v-icon',[_vm._v("shopping_basket")]),_vm._v(" "),_c('span',{staticClass:"dashboard-item-title",staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.$t("Products")))])],1)])],1):_vm._e(),_vm._v(" "),_c('v-btn',{staticStyle:{"margin":"0px 15px"},attrs:{"flat":"","icon":"","color":"white"},on:{"click":function($event){return _vm.toggleAlertList()}}},[_c('div',{staticClass:"dashboard-item",staticStyle:{"padding":"0px 20px 0px 20px"}},[_c('v-icon',[_vm._v("alarm_on")]),_vm._v(" "),_c('span',{staticClass:"dashboard-item-title",staticStyle:{"color":"white"}},[_vm._v(_vm._s(_vm.$t("Alerts")))])],1)]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-width":200,"offset-x":"","max-width":400},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
          var on = ref.on;
          var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"color":"indigo","fab":"","dark":""}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"large":""}},[_vm._v("mdi-account-circle")])],1)]}}]),model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_vm._v(" "),_c('v-card',[_c('v-card-title',{staticClass:"indigo white--text",attrs:{"primary":"","title":""}},[_c('span',{staticClass:"headline"},[_vm._v("Manage")])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',{staticClass:"dashboard-item",staticStyle:{"padding":"0px 0px","text-align":"center","width":"100%"}},[_c('v-icon',{staticStyle:{"font-size":"110px"},attrs:{"color":"indigo"}},[_vm._v("account_box")]),_vm._v(" "),_c('div',[_c('h3',{staticClass:"primary--text font-weight-bold headline",staticStyle:{"margin-top":"-10px"}},[_vm._v(" "+_vm._s(_vm.getSelectedBrandName)+" ")]),_vm._v(" "),_c('h4',{staticClass:"primary--text font-weight-light subheading"},[_vm._v(" "+_vm._s(_vm.adminEmail)+" ")])])],1)]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.getFinList,"label":"Financial Year","disabled":!_vm.hasFinChangePermission},on:{"change":function($event){return _vm.setFinYear()}},model:{value:(_vm.currentFinancialYear),callback:function ($$v) {_vm.currentFinancialYear=$$v},expression:"currentFinancialYear"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-select',{staticClass:"black-text font-weight-bold",attrs:{"items":_vm.langs,"menu-props":"auto","item-text":"text","item-value":"value","label":"Select Language"},on:{"change":function($event){return _vm.changeLocale()}},model:{value:(_vm.$i18n.locale),callback:function ($$v) {_vm.$set(_vm.$i18n, "locale", $$v)},expression:"$i18n.locale"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.firmsByBrand,"label":"Select Firm","item-text":"text","item-value":"value","disabled":!_vm.hasFirmChangePermission,"clearable":""},on:{"change":function($event){return _vm.setDefaultFirm(_vm.selectedDefaultFirm)}},model:{value:(_vm.selectedDefaultFirm),callback:function ($$v) {_vm.selectedDefaultFirm=$$v},expression:"selectedDefaultFirm"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"indigo white--text",attrs:{"primary":"","title":"","flat":"flat"},on:{"click":_vm.signOut}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("exit_to_app")]),_vm._v("Logout\n              ")],1),_vm._v(" "),_c('v-spacer')],1)],1)],1)],1)],1),_vm._v(" "),_c('v-navigation-drawer',{attrs:{"persistent":"","clipped":_vm.clipped,"right":"","temporary":"","enable-resize-watcher":"","fixed":"","app":""},model:{value:(_vm.alertListOpen),callback:function ($$v) {_vm.alertListOpen=$$v},expression:"alertListOpen"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary-title":""}},[_c('h3',{attrs:{"color":"primary"}}),_vm._v(" "),_c('v-switch',{staticClass:"custom-alert",attrs:{"label":("" + (_vm.alertMode ? 'Product Alert' : 'Customer Alert'))},model:{value:(_vm.alertMode),callback:function ($$v) {_vm.alertMode=$$v},expression:"alertMode"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"outline":"","dark":"","small":""},on:{"click":function($event){_vm.alertListOpen = false}}},[_c('v-icon',[_vm._v("close")])],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('alert-side-bar',{attrs:{"alertMode":_vm.alertMode}})],1),_vm._v(" "),_c('v-content',[_c('router-view')],1),_vm._v(" "),(_vm.dialog)?[_c('v-dialog',{attrs:{"hide-overlay":"","transition":"dialog-bottom-transition","scrollable":"","persistent":"","width":"700"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('rate-card',{attrs:{"brand":_vm.brand},on:{"close":function($event){_vm.dialog = false}}})],1)]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/perfectLogo.5d8c8ba.png";

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(294);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13398f3c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(830);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13398f3c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-flex',[_c('v-card-actions',{staticStyle:{"margin-bottom":"-20px"}},[_c('v-spacer'),_vm._v(" "),_c('v-avatar',{attrs:{"color":"grey lighten-4"}},[_c('img',{staticStyle:{"height":"10%","width":"220px"},attrs:{"src":__webpack_require__(129),"alt":"avatar"}})]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-actions',{staticStyle:{"margin-top":"-20px"}},[_c('v-spacer'),_vm._v(" "),_c('h3',{staticClass:"primary--text font-weight-light text-muted"},[_vm._v(" All in One Business Platform")]),_vm._v(" "),_c('v-spacer')],1)],1),_vm._v(" "),_c('v-card',[_c('v-card-title',{staticClass:"primary white--text headline",attrs:{"primary-title":""}},[_vm._v("\n          LogIn\n        ")]),_vm._v(" "),_c('v-card-text',[_c('v-form',{model:{value:(_vm.isValid),callback:function ($$v) {_vm.isValid=$$v},expression:"isValid"}},[_c('v-text-field',{attrs:{"prepend-icon":"person","name":"email","label":"Email","id":"email","type":"email","rules":_vm.emailRules,"required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"prepend-icon":"lock","name":"password","label":"Password","id":"password","append-icon":_vm.show1 ? 'mdi-eye-off' : 'mdi-eye',"type":_vm.show1 ? 'text' : 'password',"rules":_vm.passwordRules,"required":""},on:{"click:append":function($event){_vm.show1 = !_vm.show1}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text",attrs:{"round":"","large":"","primary-title":"","disabled":!_vm.isValid,"type":"submit"},on:{"click":_vm.signIn}},[_vm._v("\n            Sign In "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_done")])],1),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"href":"/privacy-policy","text":""}},[_vm._v("\n          Privacy Policy\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"primary--text",attrs:{"small":"","outline":"","href":"/forgot-password"}},[_vm._v("Forgot password?")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.timeout,"top":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n  "+_vm._s(_vm.message)+"\n")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(295);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7437c437_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(849);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7437c437_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-flex',[_c('v-card-actions',{staticStyle:{"margin-bottom":"-20px"}},[_c('v-spacer'),_vm._v(" "),_c('v-avatar',{attrs:{"color":"grey lighten-4"}},[_c('img',{staticStyle:{"height":"10%","width":"220px"},attrs:{"src":__webpack_require__(129),"alt":"avatar"}})]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-actions',{staticStyle:{"margin-top":"-20px"}},[_c('v-spacer'),_vm._v(" "),_c('h3',{staticClass:"primary--text font-weight-light text-muted"},[_vm._v("  All in One Business Platform ")]),_vm._v(" "),_c('v-spacer')],1)],1),_vm._v(" "),_c('v-card',[_c('v-card-title',{staticClass:"primary white--text headline",attrs:{"primary-title":""}},[_vm._v("\n        Create an Account\n      ")]),_vm._v(" "),_c('v-form',{model:{value:(_vm.isValid),callback:function ($$v) {_vm.isValid=$$v},expression:"isValid"}},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"prepend-icon":"account_balance","name":"brand","label":"Brand","id":"brand","type":"text","counter":50,"rules":_vm.nameRules,"required":""},model:{value:(_vm.brand),callback:function ($$v) {_vm.brand=$$v},expression:"brand"}}),_vm._v(" "),_c('v-text-field',{attrs:{"prepend-icon":"person","name":"email","label":"Email","id":"email","type":"email","rules":_vm.emailRules,"required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"prepend-icon":"lock","name":"password","label":"Password","id":"password","type":"password","rules":_vm.passwordRules,"required":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('v-text-field',{attrs:{"prepend-icon":"lock","name":"confirmPassword","label":"Confirm Password","id":"confirmPassword","type":"password","rules":_vm.passwordRules,"required":""},model:{value:(_vm.rePassword),callback:function ($$v) {_vm.rePassword=$$v},expression:"rePassword"}}),_vm._v(" "),(_vm.rePassword)?_c('v-text-field',{ref:"zipCode",attrs:{"prepend-icon":"location_city","type":"number","label":"ZipCode"},on:{"change":function($event){return _vm.setLocationBasedOnZipCode()}},model:{value:(_vm.zipCode),callback:function ($$v) {_vm.zipCode=$$v},expression:"zipCode"}}):_vm._e(),_vm._v(" "),(_vm.zipCode)?_c('v-text-field',{ref:"mobile",attrs:{"prepend-icon":"dialpad","type":"number","rules":_vm.mobile.rules,"label":"Mobile"},model:{value:(_vm.mobile.value),callback:function ($$v) {_vm.$set(_vm.mobile, "value", $$v)},expression:"mobile.value"}}):_vm._e(),_vm._v(" "),(_vm.zipCode)?_c('v-select',{attrs:{"required":"","items":_vm.gCountry,"label":"Country"},model:{value:(_vm.country.value),callback:function ($$v) {_vm.$set(_vm.country, "value", $$v)},expression:"country.value"}}):_vm._e(),_vm._v(" "),(_vm.country.value)?_c('v-select',{attrs:{"required":"","items":_vm.gState,"item-text":"state","label":"State"},model:{value:(_vm.state.value),callback:function ($$v) {_vm.$set(_vm.state, "value", $$v)},expression:"state.value"}}):_vm._e(),_vm._v(" "),(_vm.state.value)?_c('v-select',{attrs:{"required":"","items":_vm.gDistrict,"label":"District"},model:{value:(_vm.district.value),callback:function ($$v) {_vm.$set(_vm.district, "value", $$v)},expression:"district.value"}}):_vm._e(),_vm._v(" "),(_vm.district.value)?_c('v-select',{attrs:{"required":"","disabled":_vm.isDisabled('tehsil'),"items":_vm.gTehsil,"label":"Tehsil"},model:{value:(_vm.tehsil.value),callback:function ($$v) {_vm.$set(_vm.tehsil, "value", $$v)},expression:"tehsil.value"}}):_vm._e(),_vm._v(" "),(_vm.tehsil.value)?_c('v-select',{attrs:{"required":"","disabled":_vm.isDisabled('block'),"items":_vm.gBlock,"label":"Block"},model:{value:(_vm.block.value),callback:function ($$v) {_vm.$set(_vm.block, "value", $$v)},expression:"block.value"}}):_vm._e(),_vm._v(" "),(_vm.block.value)?_c('v-select',{attrs:{"required":"","disabled":_vm.isDisabled('village'),"items":_vm.gVillage,"label":"Village"},model:{value:(_vm.village.value),callback:function ($$v) {_vm.$set(_vm.village, "value", $$v)},expression:"village.value"}}):_vm._e()],1),_vm._v(" "),(_vm.rePassword)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-radio-group',{model:{value:(_vm.planDetails),callback:function ($$v) {_vm.planDetails=$$v},expression:"planDetails"}},_vm._l((_vm.brandPackageTypes),function(pack){return _c('v-radio',{key:pack,attrs:{"label":(pack + " PLAN"),"value":pack}})}),1)],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('h3',[_vm._v(" Already a Member ")]),_vm._v("\n             \n          "),_c('v-btn',{staticClass:"blue-grey white--text",attrs:{"round":"","large":"","href":"/login","type":"submit"}},[_vm._v("\n            Go To Login  \n            "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_upload")])],1),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"href":"/privacy-policy","text":""}},[_vm._v("\n            Privacy Policy\n          ")]),_vm._v(" "),_c('v-spacer')],1)],1)],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.timeout,"top":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n  "+_vm._s(_vm.message)+"\n")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(301);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60275d4c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(851);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60275d4c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-flex',[_c('v-card-actions',{staticStyle:{"margin-bottom":"-20px"}},[_c('v-spacer'),_vm._v(" "),_c('v-avatar',{attrs:{"color":"grey lighten-4"}},[_c('img',{staticStyle:{"height":"10%","width":"220px"},attrs:{"src":__webpack_require__(129),"alt":"avatar"}})]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-actions',{staticStyle:{"margin-top":"-20px"}},[_c('v-spacer'),_vm._v(" "),_c('h3',{staticClass:"primary--text font-weight-light text-muted"},[_vm._v(" All in One Business Platform")]),_vm._v(" "),_c('v-spacer')],1)],1),_vm._v(" "),_c('v-card',[_c('v-card-title',{staticClass:"primary white--text headline",attrs:{"primary-title":""}},[_vm._v("\n          Forgot password\n        ")]),_vm._v(" "),_c('v-card-text',[_c('form',[_c('span',[_vm._v("Please enter your email to reset password.")]),_vm._v(" "),_c('v-text-field',{attrs:{"prepend-icon":"person","name":"email","label":"Email","id":"email","type":"email","rules":_vm.emailRules,"required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),(_vm.resetSuccess)?[_c('span',{staticClass:"green--text"},[_vm._v("Password Reset link has been sent to "+_vm._s(_vm.email)+" Please check your inbox.")])]:_vm._e()],2)]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text",attrs:{"round":"","primary-title":""},on:{"click":_vm.sendVerificationLink}},[_vm._v("\n          Send Verification link \n        ")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"grey white--text",attrs:{"round":"","href":"/login","type":"submit"}},[_vm._v("Go To Login")]),_vm._v(" "),_c('v-spacer')],1)],1)],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.timeout,"top":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n  "+_vm._s(_vm.message)+"\n")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__ = __webpack_require__(302);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67fa3f32_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__ = __webpack_require__(854);
function injectStyle (ssrContext) {
  __webpack_require__(853)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67fa3f32"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PrivacyPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_67fa3f32_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrivacyPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 853 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"font-family":"'Roboto'","padding":"50 px 20%"},attrs:{"grid-list-md":"","text-xs-center":"","fluid":""}},[_c('strong',[_vm._v("Privacy Policy")]),_vm._v(" "),_c('p',[_vm._v("\n    PARV Technology & Services built the Acuify app as a Commercial app.\n    This SERVICE is provided by PARV Technology & Services and is intended\n    for use as is.\n  ")]),_vm._v(" "),_c('p',[_vm._v("\n    This page is used to inform visitors regarding our policies with the\n    collection, use, and disclosure of Personal Information if anyone decided\n    to use our Service.\n  ")]),_vm._v(" "),_c('p',[_vm._v("\n    If you choose to use our Service, then you agree to the collection and use\n    of information in relation to this policy. The Personal Information that\n    we collect is used for providing and improving the Service. We will not\n    use or share your information with anyone except as described in this\n    Privacy Policy.\n  ")]),_vm._v(" "),_c('p',[_vm._v("\n    The terms used in this Privacy Policy have the same meanings as in our\n    Terms and Conditions, which is accessible at Acuify unless otherwise\n    defined in this Privacy Policy.\n  ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Information Collection and Use")])]),_vm._v(" "),_c('p',[_vm._v("\n    For a better experience, while using our Service, we may require you to\n    provide us with certain personally identifiable information. The\n    information that we request will be retained by us and used as described\n    in this privacy policy.\n  ")]),_vm._v(" "),_c('div',[_c('p',[_vm._v("\n      The app does use third party services that may collect information used\n      to identify you.\n    ")]),_vm._v(" "),_c('p',[_vm._v("\n      Link to privacy policy of third party service providers used by the app\n    ")]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"https://www.google.com/policies/privacy/","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Google Play Services")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://firebase.google.com/policies/analytics","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Google Analytics for Firebase")])])])]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Log Data")])]),_vm._v(" "),_c('p',[_vm._v("\n    We want to inform you that whenever you use our Service, in a case of an\n    error in the app we collect data and information (through third party\n    products) on your phone called Log Data. This Log Data may include\n    information such as your device Internet Protocol (“IP”) address, device\n    name, operating system version, the configuration of the app when\n    utilizing our Service, the time and date of your use of the Service, and\n    other statistics.\n  ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Cookies")])]),_vm._v(" "),_c('p',[_vm._v("\n    Cookies are files with a small amount of data that are commonly used as\n    anonymous unique identifiers. These are sent to your browser from the\n    websites that you visit and are stored on your device's internal memory.\n  ")]),_vm._v(" "),_c('p',[_vm._v("\n    This Service does not use these “cookies” explicitly. However, the app may\n    use third party code and libraries that use “cookies” to collect\n    information and improve their services. You have the option to either\n    accept or refuse these cookies and know when a cookie is being sent to\n    your device. If you choose to refuse our cookies, you may not be able to\n    use some portions of this Service.\n  ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Service Providers")])]),_vm._v(" "),_c('p',[_vm._v("\n    We may employ third-party companies and individuals due to the following\n    reasons:\n  ")]),_vm._v(" "),_c('ul',[_c('li',[_vm._v("To facilitate our Service;")]),_vm._v(" "),_c('li',[_vm._v("To provide the Service on our behalf;")]),_vm._v(" "),_c('li',[_vm._v("To perform Service-related services; or")]),_vm._v(" "),_c('li',[_vm._v("To assist us in analyzing how our Service is used.")])]),_vm._v(" "),_c('p',[_vm._v("\n    We want to inform users of this Service that these third parties have\n    access to your Personal Information. The reason is to perform the tasks\n    assigned to them on our behalf. However, they are obligated not to\n    disclose or use the information for any other purpose.\n  ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Security")])]),_vm._v(" "),_c('p',[_vm._v("\n    We value your trust in providing us your Personal Information, thus we are\n    striving to use commercially acceptable means of protecting it. But\n    remember that no method of transmission over the internet, or method of\n    electronic storage is 100% secure and reliable, and we cannot guarantee\n    its absolute security.\n  ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Links to Other Sites")])]),_vm._v(" "),_c('p',[_vm._v("\n    This Service may contain links to other sites. If you click on a\n    third-party link, you will be directed to that site. Note that these\n    external sites are not operated by us. Therefore, we strongly advise you\n    to review the Privacy Policy of these websites. We have no control over\n    and assume no responsibility for the content, privacy policies, or\n    practices of any third-party sites or services.\n  ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Children’s Privacy")])]),_vm._v(" "),_c('p',[_vm._v("\n    These Services do not address anyone under the age of 13. We do not\n    knowingly collect personally identifiable information from children under\n    13 years of age. In the case we discover that a child under 13 has\n    provided us with personal information, we immediately delete this from our\n    servers. If you are a parent or guardian and you are aware that your child\n    has provided us with personal information, please contact us so that we\n    will be able to do necessary actions.\n  ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Changes to This Privacy Policy")])]),_vm._v(" "),_c('p',[_vm._v("\n    We may update our Privacy Policy from time to time. Thus, you are advised\n    to review this page periodically for any changes. We will notify you of\n    any changes by posting the new Privacy Policy on this page.\n  ")]),_vm._v(" "),_c('p',[_vm._v("This policy is effective as of 2021-11-19")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("Contact Us")])]),_vm._v(" "),_c('p',[_vm._v("\n    If you have any questions or suggestions about our Privacy Policy, do not\n    hesitate to contact us at technologyparv@gmail.com.\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 855 */,
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en.json": 857,
	"./hi.json": 858
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 856;

/***/ }),
/* 857 */
/***/ (function(module, exports) {

module.exports = {"Customer":"Customer","Sales":"Sales","Buyer":"Buyer","Seller":"Seller","Amount":"Amount","Invoices":"Invoices","Purchase":"Purchase","Stock":"Stock","Quantity":"Quantity","Trade":"Trade","Volume":"Volume","Product":"Product","Show Filter":"Show Filter","Sale":"Sale","April":"April","May":"May","June":"June","July":"July","August":"August","September":"September","October":"October","November":"November","Dedember":"Dedember","January":"January","February":"February","March":"March","Top Selling Products":"Top Selling Products","Top Billing Customer":"Top Billing Customer","All":"All","Customers":"Customers","Suppliers":"Suppliers","Person Name":"Person Name","Total Amount":"Total Amount","Paid Amount":"Paid Amount","Remaining Amount":"Remaining Amount","Product Name":"Product Name","Units":"Units","Sold duration":"Sold duration","Days":"Days","Invoicing":"Invoicing","Receipt/Payments":"Receipt/Payments","Estimate/Challans":"Estimate/Challans","Manage Portfolio":"Manage Portfolio","Manage Orders":"Manage Orders","Manage Leads":"Manage Leads","Firms":"Firms","Bank Accounts":"Bank Accounts","Cash Book":"Cash Book","Day Book":"Day Book","Product Report":"Product Report","Financial Reports":"Financial Reports","View Balance Sheet":"View Balance Sheet","View Trading Account":"View Trading Account","View Profit and Loss Account":"View Profit and Loss Account","View Prop Capital Account":"View Prop Capital Account","View Trail Balance":"View Trail Balance","GST Reports":"GST Reports","Other Accounts":"Other Accounts","GSTR-1":"GSTR-1","GSTR-3B":"GSTR-3B","GST Accounts":"GST Accounts","Expense Accounts":"Expense Accounts","Income Account":"Income Account","Salary Accounts":"Salary Accounts","Credit Note":"Credit Note","Debit Note":"Debit Note","Acuify":"Acuify","Transfer":"Transfer","Rates":"Rates","Products":"Products","Alerts":"Alerts","Manage":"Manage","Financial Year":"Financial Year","Select Firm":"Select Firm","Logout":"Logout","Dashboard":"Dashboard","Buyers":"Buyers","Record":"Record","Transactions":"Transactions","Settings":"Settings","Reports":"Reports","Godown Reports":"Godown Reports","Godowns":"Godowns","Date":"Date","From":"From","To":"To","Transfer Category":"Transfer Category","Edit":"Edit","Delete":"Delete","New Transfer":"New Transfer","From Bank Account -To- Bank Account":"From Bank Account -To- Bank Account","From Bank Account -To- Cash Account":"From Bank Account -To- Cash Account","From Cash Account -To- Bank Account":"From Cash Account -To- Bank Account","From Account":"From Account","To Account":"To Account","Remark":"Remark","Cancel":"Cancel","Save":"Save","Update Rate":"Update Rate","Search Product":"Search Product","Product Group Filter":"Product Group Filter","Purchase Rate":"Purchase Rate","Selling Rate":"Selling Rate","Unit":"Unit","Update Purchase Rate":"Update Purchase Rate","Update Selling Rate":"Update Selling Rate","Description":"Description","Branch":"Branch","Btch":"Btch","Damage":"Damage","New Product":"New Product","Only Active Product":"Only Active Product","Active":"Active","Inactive":"Inactive","Select Group":"Select Group","Product Description":"Product Description","Product Barcode":"Product Barcode","Set Alert Quantity":"Set Alert Quantity","Select GST type":"Select GST type","Taxable GST rate":"Taxable GST rate","HSN code":"HSN code","Select unit":"Select unit","No Items":"No Items","FIRMS":"FIRMS","EXPENSE ACCOUNTS":"Expense Accounts","Statement":"Statement","INCOME ACCOUNTS":"Income Accounts","ASSET ACCOUNTS":"Asset Accounts","SALARY ACCOUNTS":"Salary Accounts","Expense Details":"Expense Details","Income Details":"Income Details","Asset Details":"Asset Details"}

/***/ }),
/* 858 */
/***/ (function(module, exports) {

module.exports = {"Customer":"ग्राहक ","Sales":"विक्रय ","Buyer":"खरीददार ","Seller":"विक्रेता ","Amount":"राशि ","Invoices":"बिल ","Purchase":"क्रय ","Stock":"स्टाक ","Quantity":"मात्रा ","Trade":"व्यापार ","Volume":"आयतन ","Product":"उत्पाद ","Show Filter":"फ़िल्टर दिखाएँ ","Sale":"बिक्री ","April":"अप्रैल ","May":"मई ","June":"जून ","July":"जुलाई ","August":"अगस्त ","September":"सितम्बर ","October":"अक्टूबर ","November":"नवम्बर ","Dedember":"समर्पित ","January":"जनवरी ","February":"फरवरी ","March":"मार्च ","Top Selling Products":"शीर्ष बिक्री उत्पाद ","Top Billing Customer":"शीर्ष बिलिंग ग्राहक ","All":"सभी ","Customers":"ग्राहक ","Suppliers":"आपूर्तिकार ","Person Name":"व्यक्ति नाम ","Total Amount":"कुल राशि ","Paid Amount":"जमा राशि ","Remaining Amount":"शेष राशि ","Product Name":"उत्पाद नाम ","Units":"इकाइयाँ ","Sold duration":"बेची गई अवधि ","Days":"दिन ","Invoicing":"बिल ","Receipt/Payments":"प्राप्ति/भुगतान ","Estimate/Challans":"अनुमान/चालान ","Manage Portfolio":"पोर्टफोलियो प्रबंधन","Manage Orders":"आदेश प्रबंधन","Manage Leads":"नेतृत्व प्रबंधन","Firms":"व्यवसाय संघ","Bank Accounts":"बैंक खाता","Cash Book":"कैश पुस्तक","Day Book":"दैनिक पुस्तक ","Product Report":"उत्पाद विवरण","Financial Reports":"वित्तीय विवरण","View Balance Sheet":"बैलेंस शीट देखें ","View Trading Account":"ट्रेडिंग खाता देखें ","View Profit and Loss Account":"लाभ व हानि खाता देखें ","View Prop Capital Account":"प्रोप. कैपिटल खाता देखें ","View Trail Balance":"पुछल्ला संतुलन देखें ","GST Reports":"जीएसटी विवरण","Other Accounts":"अन्य खाता ","GSTR-1":"जीएसटी-1 ","GSTR-3B":"जीएसटी-3बी ","GST Accounts":"जीएसटी खाता ","Expense Accounts":"व्यय खाता ","Income Account":"आय खाता ","Salary Accounts":"वेतन खाता ","Credit Note":"क्रेडिट नोट ","Debit Note":"डेबिट नोट ","Acuify":"एक्यूफाई","Transfer":"अंतरण ","Rates":"दर ","Products":"उत्पाद ","Alerts":"चेतावनी ","Manage":"प्रबंधित करें ","Financial Year":"वित्तीय वर्ष ","Select Firm":"फर्म का चयन करें ","Logout":"लॉगआउट ","Dashboard":"डैशबोर्ड ","Buyers":"क्रेताओं ","Record":"रेकॉर्ड ","Transactions":"लेन देन ","Settings":"विन्यास ","Reports":"विवरण","ITC":"आईटीसी","Godown Reports":"गोदाम विवरण","Godowns":"गोदाम","Date":"तिथि ","From":"से ","To":"के लिए ","Transfer Category":"स्थानांतरण श्रेणी ","Edit":"संपादित करें ","Delete":"मिटाएँ ","New Transfer":"नया अंतरण ","From Bank Account -To- Bank Account":"बैंक खाते से लेकर बैंक खाते मे ","From Bank Account -To- Cash Account":"बैंक खाते-से-रोकड़ खाते मे ","From Cash Account -To- Bank Account":"नकद खाते से बैंक खाते मे ","From Account":"खाता से ","To Account":"खाता मे","Remark":"टिप्पणी ","Cancel":"रद्द करें ","Save":"सहेजें ","Update Rate":"नवीनतम दर ","Search Product":"खोज उत्पाद ","Product Group Filter":"उत्पाद समूह फ़िल्टर ","Purchase Rate":"क्रय दर ","Selling Rate":"विक्रय दर ","Unit":"इकाई ","Update Purchase Rate":"खरीद दर नवीनतम करें ","Update Selling Rate":"बिक्री दर नवीनतम करें ","Description":"वर्णन ","Branch":"शाखा ","Btch":"Btch ","Damage":"क्षति ","New Product":"नया उत्पाद ","Only Active Product":"केवल सक्रिय उत्पाद ","Active":"सक्रिय ","Inactive":"निष्क्रिय ","Select Group":"समूह चुनें ","Product Description":"उत्पाद विवरण ","Product Barcode":"उत्पाद बारकोड ","Set Alert Quantity":"चेतावनी मात्रा सेट करें ","Select GST type":"जीएसटी प्रकार चुनें ","Taxable GST rate":"कर योग्य जीएसटी दर ","HSN code":"एचएसएन कोड ","Select unit":"इकाई चुनें ","No Items":"कोई मद नहीं ","FIRMS":"फर्में ","EXPENSE ACCOUNTS":"व्यय खाता ","Statement":"कथन ","INCOME ACCOUNTS":"आय खाता ","ASSET ACCOUNTS":"सम्पत्तियाँ खाता ","SALARY ACCOUNTS":"वेतन खाता ","Expense Details":"व्यय विवरण ","Income Details":"आय विवरण ","Asset Details":"सम्पत्तियाँ विवरण"}

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Dashboard___ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Buyers___ = __webpack_require__(1233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Buyers_CustomerDeposit_customerDeposite_vue__ = __webpack_require__(1338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Settings___ = __webpack_require__(1343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Reports___ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Reports_MonthlyReports__ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Items___ = __webpack_require__(1363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_InvoiceManagement___ = __webpack_require__(1365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Informations__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Products_product_vue__ = __webpack_require__(1396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Transactions_transfer_vue__ = __webpack_require__(1400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_IST_index_vue__ = __webpack_require__(1402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Godawn_godawn_vue__ = __webpack_require__(1405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_GodownReports_GodownReports_vue__ = __webpack_require__(1408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Offshoot_offshoot_vue__ = __webpack_require__(1411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_RecordDelivery_recordDelivery_vue__ = __webpack_require__(1414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_RecordDispatch_recordDispatch_vue__ = __webpack_require__(1416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_RecordEstimate_recordEstimate_vue__ = __webpack_require__(1418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_RecordLead_RecordLead_vue__ = __webpack_require__(1421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_RecordOrder_recordOrder_vue__ = __webpack_require__(1425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Staffs_staff_vue__ = __webpack_require__(1430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Buyers_Buyer_BuyerStatements__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_GSTReports_gst1__ = __webpack_require__(1433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_GSTReports_gst3__ = __webpack_require__(1436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_GSTReports_gstMonthly__ = __webpack_require__(1439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Firms_invoiceList_vue__ = __webpack_require__(1442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_BankStatements_invoiceList_vue__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_CashStatements_invoiceList_vue__ = __webpack_require__(1456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_Buyers_InvoiceHistory___ = __webpack_require__(1463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Buyers_RemainingBalance_RemainingBalance_vue__ = __webpack_require__(1466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_Quick_Invoice_quickInvoice_vue__ = __webpack_require__(1469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_Quick_Invoice_invoiceUpdate_vue__ = __webpack_require__(1501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_DailyTransactions_index_vue__ = __webpack_require__(1504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_SalePurchaseStatements_invoiceList_vue__ = __webpack_require__(1519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_Buyers_CustomerPayments_customerPayments_vue__ = __webpack_require__(1526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_ProductReports_ProductReports_vue__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_PortfolioManagement_PortfolioManagement_vue__ = __webpack_require__(1531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_ReceiptRegister_receiptList_vue__ = __webpack_require__(1535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_PaymentRegister_paymentList_vue__ = __webpack_require__(1539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_ReceiptCollection_ReceiptCollection_vue__ = __webpack_require__(1543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_LandingPage_homePage_vue__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__buyers___ = __webpack_require__(1549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__settings___ = __webpack_require__(1550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__reports___ = __webpack_require__(1638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_PermissionDenied_PermissionDenied_vue__ = __webpack_require__(1639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__store__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__informations___ = __webpack_require__(1651);


// import CustomerDeposit from '@/components/Buyers/CustomerDeposit/'




















































// import Items from './items/'

// import InvoiceRoutes from './invoices/'

/* harmony default export */ __webpack_exports__["a"] = ([{
  path: '/dashboard',
  name: 'Dashboard',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Dashboard___["a" /* default */],
  meta: { requiresAuth: true },
  beforeEnter: function beforeEnter(to, from, next) {
    var rolesAndPermissions = __WEBPACK_IMPORTED_MODULE_45__store__["a" /* default */].getters['Global/roleAndPermission'];
    if (rolesAndPermissions && rolesAndPermissions.permissions && rolesAndPermissions.permissions.length && rolesAndPermissions.permissions.indexOf('BRAND_DASHBOARD') > -1) {
      next();
    } else {
      next('/permission-denied');
    }
  }
}, {
  path: '/reports',
  name: 'Reports',
  component: __WEBPACK_IMPORTED_MODULE_4__components_Reports___["a" /* default */],
  children: __WEBPACK_IMPORTED_MODULE_43__reports___["a" /* default */],
  meta: { requiresAuth: true },
  beforeEnter: function beforeEnter(to, from, next) {
    var rolesAndPermissions = __WEBPACK_IMPORTED_MODULE_45__store__["a" /* default */].getters['Global/roleAndPermission'];
    if (rolesAndPermissions && rolesAndPermissions.permissions && rolesAndPermissions.permissions.length && rolesAndPermissions.permissions.indexOf('BRAND_RECORDS') > -1) {
      next();
    } else {
      next('/permission-denied');
    }
  }
}, {
  path: '/reports/:reportType',
  name: 'ReportsWithType',
  component: __WEBPACK_IMPORTED_MODULE_4__components_Reports___["a" /* default */],
  children: __WEBPACK_IMPORTED_MODULE_43__reports___["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/invoicemanagement',
  name: 'InvoiceManagement',
  component: __WEBPACK_IMPORTED_MODULE_7__components_InvoiceManagement___["a" /* default */],
  // children: InvoiceRoutes,
  meta: { requiresAuth: true },
  beforeEnter: function beforeEnter(to, from, next) {
    var rolesAndPermissions = __WEBPACK_IMPORTED_MODULE_45__store__["a" /* default */].getters['Global/roleAndPermission'];
    if (rolesAndPermissions && rolesAndPermissions.permissions && rolesAndPermissions.permissions.length && rolesAndPermissions.permissions.indexOf('BRAND_TRANSACTIONS') > -1) {
      next();
    } else {
      next('/permission-denied');
    }
  }
}, {
  path: '/invoicemanagement/:type',
  name: 'InvoiceManagementWithType',
  component: __WEBPACK_IMPORTED_MODULE_7__components_InvoiceManagement___["a" /* default */],
  // children: InvoiceRoutes,
  meta: { requiresAuth: true }
}, {
  path: '/buyers',
  name: 'Buyers',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Buyers___["a" /* default */],
  children: __WEBPACK_IMPORTED_MODULE_41__buyers___["a" /* default */],
  meta: { requiresAuth: true },
  beforeEnter: function beforeEnter(to, from, next) {
    var rolesAndPermissions = __WEBPACK_IMPORTED_MODULE_45__store__["a" /* default */].getters['Global/roleAndPermission'];
    if (rolesAndPermissions && rolesAndPermissions.permissions && rolesAndPermissions.permissions.length && rolesAndPermissions.permissions.indexOf('BRAND_BUYER') > -1) {
      next();
    } else {
      next('/permission-denied');
    }
  }
}, {
  path: '/settings',
  name: 'Settings',
  component: __WEBPACK_IMPORTED_MODULE_3__components_Settings___["a" /* default */],
  children: __WEBPACK_IMPORTED_MODULE_42__settings___["a" /* default */],
  meta: { requiresAuth: true },
  beforeEnter: function beforeEnter(to, from, next) {
    var rolesAndPermissions = __WEBPACK_IMPORTED_MODULE_45__store__["a" /* default */].getters['Global/roleAndPermission'];
    if (rolesAndPermissions && rolesAndPermissions.permissions && rolesAndPermissions.permissions.length && rolesAndPermissions.permissions.indexOf('BRAND_SETTINGS') > -1) {
      next();
    } else {
      next('/permission-denied');
    }
  }
}, {
  path: '/items',
  name: 'Items',
  component: __WEBPACK_IMPORTED_MODULE_6__components_Items___["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/informations',
  name: 'Informations',
  component: __WEBPACK_IMPORTED_MODULE_8__components_Informations__["a" /* default */],
  children: __WEBPACK_IMPORTED_MODULE_46__informations___["a" /* default */],
  meta: { requiresAuth: true },
  beforeEnter: function beforeEnter(to, from, next) {
    var rolesAndPermissions = __WEBPACK_IMPORTED_MODULE_45__store__["a" /* default */].getters['Global/roleAndPermission'];
    if (rolesAndPermissions && rolesAndPermissions.permissions && rolesAndPermissions.permissions.length && rolesAndPermissions.permissions.indexOf('BRAND_REPORTS') > -1) {
      next();
    } else {
      next('/permission-denied');
    }
  }
}, {
  path: '/products',
  name: 'Products',
  component: __WEBPACK_IMPORTED_MODULE_9__components_Products_product_vue__["a" /* default */],
  meta: { requiresAuth: true },
  beforeEnter: function beforeEnter(to, from, next) {
    var rolesAndPermissions = __WEBPACK_IMPORTED_MODULE_45__store__["a" /* default */].getters['Global/roleAndPermission'];
    if (rolesAndPermissions && rolesAndPermissions.permissions && rolesAndPermissions.permissions.length && rolesAndPermissions.permissions.indexOf('BRAND_PRODUCTS') > -1) {
      next();
    } else {
      next('/permission-denied');
    }
  }
}, {
  path: '/transfer',
  name: 'Transactions',
  component: __WEBPACK_IMPORTED_MODULE_10__components_Transactions_transfer_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/products/:isNew',
  name: 'ProductsWithNew',
  component: __WEBPACK_IMPORTED_MODULE_9__components_Products_product_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/products/:isNew/:redirect',
  name: 'ProductsWithRedirect',
  component: __WEBPACK_IMPORTED_MODULE_9__components_Products_product_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/customer-deposit/:customerId',
  name: 'CustomerDeposit',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Buyers_CustomerDeposit_customerDeposite_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/customer-payments/:customerId',
  name: 'CustomerPayments',
  component: __WEBPACK_IMPORTED_MODULE_34__components_Buyers_CustomerPayments_customerPayments_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/montly-stock-reports',
  name: 'MonthlyStockReports',
  component: __WEBPACK_IMPORTED_MODULE_5__components_Reports_MonthlyReports__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/ist',
  name: 'IST',
  component: __WEBPACK_IMPORTED_MODULE_11__components_IST_index_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/invoice-history/:invoiceId',
  name: 'InvoiceHistory',
  component: __WEBPACK_IMPORTED_MODULE_28__components_Buyers_InvoiceHistory___["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/invoice-statements/:customerId',
  name: 'InvoiceStatements',
  component: __WEBPACK_IMPORTED_MODULE_21__components_Buyers_Buyer_BuyerStatements__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/gst1-reports',
  name: 'GST1Reports',
  component: __WEBPACK_IMPORTED_MODULE_22__components_GSTReports_gst1__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/gst3-reports',
  name: 'GST3Reports',
  component: __WEBPACK_IMPORTED_MODULE_23__components_GSTReports_gst3__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/gst-monthly',
  name: 'GSTMonthly',
  component: __WEBPACK_IMPORTED_MODULE_24__components_GSTReports_gstMonthly__["a" /* default */],
  meta: { requiresAuth: true }
},
// {
//   path: '/firm-statements/:firmId',
//   name: 'FirmStatements',
//   component: FirmStatements,
//   meta: {requiresAuth: true}
// }, 
{
  path: '/remaining-balance/:customerId',
  name: 'RemainingBalance',
  component: __WEBPACK_IMPORTED_MODULE_29__components_Buyers_RemainingBalance_RemainingBalance_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/godawn',
  name: 'Godawns',
  component: __WEBPACK_IMPORTED_MODULE_12__components_Godawn_godawn_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/godown-reports',
  name: 'GodownReports',
  component: __WEBPACK_IMPORTED_MODULE_13__components_GodownReports_GodownReports_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/offshoot',
  name: 'Offshoots',
  component: __WEBPACK_IMPORTED_MODULE_14__components_Offshoot_offshoot_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/staffs',
  name: 'Staffs',
  component: __WEBPACK_IMPORTED_MODULE_20__components_Staffs_staff_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/lead-record',
  name: 'RecordLead',
  component: __WEBPACK_IMPORTED_MODULE_18__components_RecordLead_RecordLead_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/recordOrder',
  name: 'RecordOrder',
  component: __WEBPACK_IMPORTED_MODULE_19__components_RecordOrder_recordOrder_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/recordEstimate',
  name: 'RecordEstimate',
  component: __WEBPACK_IMPORTED_MODULE_17__components_RecordEstimate_recordEstimate_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/dispatch-register',
  name: 'RecordDispatch',
  component: __WEBPACK_IMPORTED_MODULE_16__components_RecordDispatch_recordDispatch_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/delivery-register',
  name: 'RecordDelivery',
  component: __WEBPACK_IMPORTED_MODULE_15__components_RecordDelivery_recordDelivery_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/quick-invoice',
  name: 'QuickInvoice',
  component: __WEBPACK_IMPORTED_MODULE_30__components_Quick_Invoice_quickInvoice_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/order-to-invoice/:orderId',
  name: 'QuickInvoice',
  component: __WEBPACK_IMPORTED_MODULE_30__components_Quick_Invoice_quickInvoice_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/portfolio-to-invoice/:orderId',
  name: 'QuickInvoice',
  component: __WEBPACK_IMPORTED_MODULE_30__components_Quick_Invoice_quickInvoice_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/invoice-create/:customerId/:isBuyer',
  name: 'QuickInvoice',
  component: __WEBPACK_IMPORTED_MODULE_30__components_Quick_Invoice_quickInvoice_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/estimate-to-invoice/:estimateId',
  name: 'QuickInvoice',
  component: __WEBPACK_IMPORTED_MODULE_30__components_Quick_Invoice_quickInvoice_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/update-invoice/:invoiceId',
  name: 'InvoiceUpdate',
  component: __WEBPACK_IMPORTED_MODULE_31__components_Quick_Invoice_invoiceUpdate_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'daily-transaction-book',
  name: 'DailyTransactionBook',
  component: __WEBPACK_IMPORTED_MODULE_32__components_DailyTransactions_index_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/landingPage',
  name: 'LandingPage',
  component: __WEBPACK_IMPORTED_MODULE_40__components_LandingPage_homePage_vue__["a" /* default */],
  children: __WEBPACK_IMPORTED_MODULE_43__reports___["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/firm-statements/:firmId',
  name: 'FirmStatements',
  component: __WEBPACK_IMPORTED_MODULE_25__components_Firms_invoiceList_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/bank-statements/:bankId',
  name: 'BankStatements',
  component: __WEBPACK_IMPORTED_MODULE_26__components_BankStatements_invoiceList_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/cash-statements',
  name: 'CashStatements',
  component: __WEBPACK_IMPORTED_MODULE_27__components_CashStatements_invoiceList_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/sale-register/:month/:date',
  name: 'SalePurchaseStatements',
  component: __WEBPACK_IMPORTED_MODULE_33__components_SalePurchaseStatements_invoiceList_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/purchase-register/:month/:date',
  name: 'SalePurchaseStatements',
  component: __WEBPACK_IMPORTED_MODULE_33__components_SalePurchaseStatements_invoiceList_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/product-report',
  name: 'ProductReports',
  component: __WEBPACK_IMPORTED_MODULE_35__components_ProductReports_ProductReports_vue__["default"],
  meta: { requiresAuth: true }
}, {
  path: '/sale-register',
  name: 'SalePurchaseStatements',
  component: __WEBPACK_IMPORTED_MODULE_33__components_SalePurchaseStatements_invoiceList_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/purchase-register',
  name: 'SalePurchaseStatements',
  component: __WEBPACK_IMPORTED_MODULE_33__components_SalePurchaseStatements_invoiceList_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/portfolio-management',
  name: 'PortfolioManagement',
  component: __WEBPACK_IMPORTED_MODULE_36__components_PortfolioManagement_PortfolioManagement_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  name: 'PermissionDenied',
  path: '/permission-denied',
  component: __WEBPACK_IMPORTED_MODULE_44__components_PermissionDenied_PermissionDenied_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/receipt-register',
  name: 'ReceiptRegister',
  component: __WEBPACK_IMPORTED_MODULE_37__components_ReceiptRegister_receiptList_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/payment-register',
  name: 'PaymentRegister',
  component: __WEBPACK_IMPORTED_MODULE_38__components_PaymentRegister_paymentList_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/receipt-collection',
  name: 'ReceiptCollection',
  component: __WEBPACK_IMPORTED_MODULE_39__components_ReceiptCollection_ReceiptCollection_vue__["a" /* default */],
  meta: { requiresAuth: true }
}]);

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(303);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a2aec9a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1232);
function injectStyle (ssrContext) {
  __webpack_require__(861)
  __webpack_require__(862)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a2aec9a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a2aec9a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 861 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 862 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */,
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */,
/* 953 */,
/* 954 */,
/* 955 */,
/* 956 */,
/* 957 */,
/* 958 */,
/* 959 */,
/* 960 */,
/* 961 */,
/* 962 */,
/* 963 */,
/* 964 */,
/* 965 */,
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */,
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */,
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */,
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */,
/* 1142 */,
/* 1143 */,
/* 1144 */,
/* 1145 */,
/* 1146 */,
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */,
/* 1156 */,
/* 1157 */,
/* 1158 */,
/* 1159 */,
/* 1160 */,
/* 1161 */,
/* 1162 */,
/* 1163 */,
/* 1164 */,
/* 1165 */,
/* 1166 */,
/* 1167 */,
/* 1168 */,
/* 1169 */,
/* 1170 */,
/* 1171 */,
/* 1172 */,
/* 1173 */,
/* 1174 */,
/* 1175 */,
/* 1176 */,
/* 1177 */,
/* 1178 */,
/* 1179 */,
/* 1180 */,
/* 1181 */,
/* 1182 */,
/* 1183 */,
/* 1184 */,
/* 1185 */,
/* 1186 */,
/* 1187 */,
/* 1188 */,
/* 1189 */,
/* 1190 */,
/* 1191 */,
/* 1192 */,
/* 1193 */,
/* 1194 */,
/* 1195 */,
/* 1196 */,
/* 1197 */,
/* 1198 */,
/* 1199 */,
/* 1200 */,
/* 1201 */,
/* 1202 */,
/* 1203 */,
/* 1204 */,
/* 1205 */,
/* 1206 */,
/* 1207 */,
/* 1208 */,
/* 1209 */,
/* 1210 */,
/* 1211 */,
/* 1212 */,
/* 1213 */,
/* 1214 */,
/* 1215 */,
/* 1216 */,
/* 1217 */,
/* 1218 */,
/* 1219 */,
/* 1220 */,
/* 1221 */,
/* 1222 */,
/* 1223 */,
/* 1224 */,
/* 1225 */,
/* 1226 */,
/* 1227 */,
/* 1228 */,
/* 1229 */,
/* 1230 */,
/* 1231 */,
/* 1232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"one-dashboard",attrs:{"grid-list-md":"","text-xs-center":"","fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md2":"","lg2":""}},[_vm._l((_vm.cards1),function(card,i){return [_c('v-card',{key:i,staticStyle:{"font-size":"12px","margin-bottom":"8px","font-weight":"bolder"}},[_c('v-card-title',{staticClass:"primary white--text subheading"},[_c('h3',{staticClass:"font-weight-light"},[_vm._v(_vm._s(_vm.$t(card.title)))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('a',{on:{"click":function($event){$event.stopPropagation();return _vm.openFirstDialog(card.title)}}},[_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("remove_red_eye")])],1)],1),_vm._v(" "),(('amount' in card) || ('value' in card))?[_c('v-card-text',{staticClass:"text"},[_c('v-card-actions',{staticClass:"primary--text font-weight-bold"},[_vm._v("\n                "+_vm._s(_vm.$t("Invoices"))+"\n                "),_c('v-spacer'),_vm._v(" "),('amount' in card)?_c('span',[_vm._v(_vm._s(_vm.$t("Amount")))]):_c('span',[_vm._v(_vm._s(card.value))])],1),_vm._v(" "),('amount' in card)?_c('v-card-actions',{staticClass:"primary--text font-weight-bold",staticStyle:{"margin-top":"-7px"}},[_vm._v("\n                "+_vm._s(card.value)+"\n                "),_c('v-spacer'),_vm._v(" "),('amount' in card)?_c('span',[_vm._v(_vm._s(_vm._f("amount")(card.amount || 0))+" ")]):_vm._e()],1):_vm._e()],1)]:_vm._e(),_vm._v(" "),(('sellerCount' in card) || ('buyerCount' in card))?_c('v-card-text',{staticClass:"text"},[_c('v-card-actions',{staticClass:"primary--text font-weight-bold"},[_vm._v("\n              "+_vm._s(_vm.$t("Buyer"))+"\n              "),_c('v-spacer'),_vm._v(_vm._s(_vm.$t("Seller"))+"\n            ")],1),_vm._v(" "),_c('v-card-actions',{staticClass:"primary--text font-weight-bold",staticStyle:{"margin-top":"-9px"}},[_c('span',[_vm._v(_vm._s(card.buyerCount))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',[_vm._v(_vm._s(card.sellerCount))])],1)],1):_vm._e(),_vm._v(" "),(('measure' in card) || ('aggregate' in card))?_c('v-card-text',{staticClass:"text"},[_c('v-card-actions',{staticClass:"primary--text font-weight-bold"},[_vm._v("\n              "+_vm._s(_vm.$t("Quantity"))+"\n              "),_c('v-spacer'),_vm._v(_vm._s(_vm.$t("Amount"))+"\n            ")],1),_vm._v(" "),_c('v-card-actions',{staticClass:"primary--text font-weight-bold"},[_c('span',[_vm._v(_vm._s(card.measure))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("amount")(card.aggregate || 0))+" ")])],1)],1):_vm._e()],2)]})],2),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md8":""}},[_c('v-layout',{staticStyle:{"display":"none"},attrs:{"row":"","wrap":"","id":"dashboard-filters"}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-select',{staticClass:"select-firm-dashboard",attrs:{"dense":"","items":_vm.firmsByBrand,"label":_vm.$t('Select Firm'),"clearable":""},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-menu',{staticClass:"ist-datepicker-dashboard",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px","clearable":""},model:{value:(_vm.datepickerFrom),callback:function ($$v) {_vm.datepickerFrom=$$v},expression:"datepickerFrom"}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.$t('From Date'),"prepend-icon":"event","readonly":"","clearable":""},slot:"activator",model:{value:(_vm.fromDate),callback:function ($$v) {_vm.fromDate=$$v},expression:"fromDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerFrom = false}},model:{value:(_vm.fromDate),callback:function ($$v) {_vm.fromDate=$$v},expression:"fromDate"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-menu',{staticClass:"ist-datepicker-dashboard",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px","clearable":""},model:{value:(_vm.datepickerTo),callback:function ($$v) {_vm.datepickerTo=$$v},expression:"datepickerTo"}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.$t('To Date'),"prepend-icon":"event","readonly":"","clearable":""},slot:"activator",model:{value:(_vm.toDate),callback:function ($$v) {_vm.toDate=$$v},expression:"toDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerTo = false}},model:{value:(_vm.toDate),callback:function ($$v) {_vm.toDate=$$v},expression:"toDate"}})],1)],1)],1),_vm._v(" "),_c('v-tabs',{attrs:{"color":"primary","dark":"","icons":""},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tabs-slider',{attrs:{"color":"yellow"}}),_vm._v(" "),_c('v-tab',{key:'tab-1',attrs:{"href":"#tab-1"}},[_vm._v("\n          "+_vm._s(_vm.$t("Trade"))+"\n          "),_c('v-icon',[_vm._v("swap_vert")])],1),_vm._v(" "),_c('v-tab',{key:'tab-2',attrs:{"href":"#tab-2"}},[_vm._v("\n          "+_vm._s(_vm.$t("Volume"))+"\n          "),_c('v-icon',[_vm._v("swap_horiz")])],1),_vm._v(" "),_c('v-tab',{key:'tab-3',attrs:{"href":"#tab-3"}},[_vm._v("\n          "+_vm._s(_vm.$t("Product"))+"\n          "),_c('v-icon',[_vm._v("category")])],1),_vm._v(" "),_c('v-tab',{key:'tab-4',attrs:{"href":"#tab-4"}},[_vm._v("\n          "+_vm._s(_vm.$t("Daily"))+"\n          "),_c('v-icon',[_vm._v("category")])],1),_vm._v(" "),_c('v-switch',{staticClass:"filter-switch",attrs:{"color":"white","label":_vm.$t(("" + (_vm.isFilter ? 'Hide Filter' : 'Show Filter')))},model:{value:(_vm.isFilter),callback:function ($$v) {_vm.isFilter=$$v},expression:"isFilter"}}),_vm._v(" "),_c('v-tabs-items',[_c('v-tab-item',{key:'tab1',attrs:{"value":'tab-1'}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('apexchart',{attrs:{"type":"bar","height":"550","options":_vm.tradeOptions,"series":_vm.tradeData}})],1)],1)],1),_vm._v(" "),_c('v-tab-item',{key:'tab2',attrs:{"value":'tab-2'}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('apexchart',{attrs:{"type":"bar","height":"550","options":_vm.volumeOptions,"series":_vm.volumeData}})],1)],1)],1),_vm._v(" "),_c('v-tab-item',{key:'tab4',attrs:{"value":'tab-4'}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('apexchart',{attrs:{"type":"bar","height":"550","options":_vm.volumeOptionsDaily,"series":_vm.volumeDataDaily}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"cursor":"pointer"},attrs:{"xs12":"","sm12":"","md2":"","lg2":""}},[_c('v-card',{staticClass:"sec3-card"},[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":"/quick-invoice"}},[_c('v-card-text',{staticClass:"pa-2"},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("note_alt")]),_vm._v("  "+_vm._s(_vm.$t("Invoicing"))+"\n          ")],1)],1)],1),_vm._v(" "),_c('v-card',{staticClass:"sec3-card"},[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":"/customer-payments/null"}},[_c('v-card-text',{staticClass:"pa-2"},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("currency_rupee")]),_vm._v("  "+_vm._s(_vm.$t("Receipt/Payments"))+"\n          ")],1)],1)],1),_vm._v(" "),_c('v-card',{staticClass:"sec3-card"},[(_vm.$route.path!='/recordEstimate')?_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":"/recordEstimate"}},[_c('v-card-text',{staticClass:"pa-2"},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("list_alt ")]),_vm._v("  "+_vm._s(_vm.$t("Estimate/Challans"))+"\n          ")],1)],1):_vm._e()],1),_vm._v(" "),_c('v-card',{staticClass:"sec3-card"},[(_vm.$route.path!='/recordOrder')?_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":"/recordOrder"}},[_c('v-card-text',{staticClass:"pa-2"},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v(" content_paste ")]),_vm._v("  "+_vm._s(_vm.$t("Manage Orders"))+"\n          ")],1)],1):_vm._e()],1),_vm._v(" "),_c('v-card',{staticClass:"sec3-card"},[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":"/portfolio-management"}},[_c('v-card-text',{staticClass:"pa-2"},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("fact_check")]),_vm._v("  "+_vm._s(_vm.$t("Manage Portfolio"))+"\n          ")],1)],1)],1),_vm._v(" "),_c('v-card',{staticClass:"sec3-card",on:{"click":function($event){_vm.Sec3DetailsDialog=true; _vm.Sec3Type='firm'}}},[_c('v-card-text',{staticClass:"pa-2"},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("menu_book")]),_vm._v("  "+_vm._s(_vm.$t("Firms"))+"\n        ")],1)],1),_vm._v(" "),_c('v-card',{staticClass:"sec3-card",on:{"click":function($event){_vm.Sec3DetailsDialog=true; _vm.Sec3Type='bank'}}},[_c('v-card-text',{staticClass:"pa-2"},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("account_box")]),_vm._v("  "+_vm._s(_vm.$t("Bank Accounts"))+" \n        ")],1)],1),_vm._v(" "),_c('v-card',{staticClass:"sec3-card",on:{"click":function($event){_vm.Sec3DetailsDialog=true; _vm.Sec3Type='cash'}}},[_c('v-card-text',{staticClass:"pa-2"},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("assignment")]),_vm._v("  "+_vm._s(_vm.$t("Cash Book"))+"\n        ")],1)],1),_vm._v(" "),_c('v-card',{staticClass:"sec3-card"},[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":"/daily-transaction-book"}},[_c('v-card-text',{staticClass:"pa-2"},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("analytics")]),_vm._v("  "+_vm._s(_vm.$t("Day Book"))+"\n          ")],1)],1)],1),_vm._v(" "),_c('v-card',{staticClass:"sec3-card",on:{"click":function($event){_vm.bookExpansion = !_vm.bookExpansion}}},[_c('v-card-text',{staticClass:"pa-2"},[(!_vm.bookExpansion)?_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.bookExpansion)?_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("expand_less")]):_vm._e(),_vm._v("  "+_vm._s(_vm.$t("Financial Reports"))+"\n        ")],1)],1),_vm._v(" "),(_vm.bookExpansion)?[_c('v-card',{staticClass:"sec3-card"},[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":{ name: 'Bsheet'}}},[_c('v-card-text',{staticClass:"pa-2",staticStyle:{"font-size":"12px"}},[_c('b',{staticClass:"font-weight-light"},[_vm._v(" "+_vm._s(_vm.$t("View Balance Sheet")))])])],1)],1),_vm._v(" "),_c('v-card',{staticClass:"sec3-card"},[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":{ name: 'Tradingaccount'}}},[_c('v-card-text',{staticClass:"pa-2",staticStyle:{"font-size":"12px"}},[_c('b',{staticClass:"font-weight-light"},[_vm._v(" "+_vm._s(_vm.$t("View Trading Account")))])])],1)],1),_vm._v(" "),_c('v-card',{staticClass:"sec3-card"},[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":{ name: 'Profitandloss'}}},[_c('v-card-text',{staticClass:"pa-2",staticStyle:{"font-size":"12px"}},[_c('b',{staticClass:"font-weight-light"},[_vm._v(" "+_vm._s(_vm.$t("View Profit and Loss Account")))])])],1)],1),_vm._v(" "),_c('v-card',{staticClass:"sec3-card"},[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":{ name: 'Proprietor'}}},[_c('v-card-text',{staticClass:"pa-2",staticStyle:{"font-size":"12px"}},[_c('b',{staticClass:"font-weight-light"},[_vm._v(" "+_vm._s(_vm.$t("View Prop Capital Account")))])])],1)],1),_vm._v(" "),_c('v-card',{staticClass:"sec3-card"},[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":{ name: 'TrailBalanceAccounts'}}},[_c('v-card-text',{staticClass:"pa-2",staticStyle:{"font-size":"12px"}},[_c('b',{staticClass:"font-weight-light"},[_vm._v(" "+_vm._s(_vm.$t("View Trail Balance")))])])],1)],1)]:_vm._e(),_vm._v(" "),_c('v-card',{staticClass:"sec3-card",on:{"click":function($event){_vm.gstrExpansion = !_vm.gstrExpansion}}},[_c('v-card-text',{staticClass:"pa-2"},[(!_vm.gstrExpansion)?_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.gstrExpansion)?_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("expand_less")]):_vm._e(),_vm._v("  "+_vm._s(_vm.$t("GST Reports"))+"\n        ")],1)],1),_vm._v(" "),(_vm.gstrExpansion)?[_c('v-card',{staticClass:"sec3-card"},[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":{ name: 'GST1Reports'}}},[_c('v-card-text',{staticClass:"pa-2",staticStyle:{"font-size":"12px"}},[_c('a',{staticClass:"font-weight-light"},[_vm._v(" "+_vm._s(_vm.$t("GSTR-1")))])])],1)],1),_vm._v(" "),_c('v-card',{staticClass:"sec3-card"},[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":{ name: 'GST3Reports'}}},[_c('v-card-text',{staticClass:"pa-2",staticStyle:{"font-size":"12px"}},[_c('a',{staticClass:"font-weight-light"},[_vm._v(" "+_vm._s(_vm.$t("GSTR-3B")))])])],1)],1),_vm._v(" "),_c('v-card',{staticClass:"sec3-card"},[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":{ name: 'GSTAccounts'}}},[_c('v-card-text',{staticClass:"pa-2",staticStyle:{"font-size":"12px"}},[_c('a',{staticClass:"font-weight-light"},[_vm._v(" "+_vm._s(_vm.$t("GST Accounts")))])])],1)],1)]:_vm._e(),_vm._v(" "),_c('v-card',{staticClass:"sec3-card",on:{"click":function($event){_vm.otherAcctExpansion = !_vm.otherAcctExpansion}}},[_c('v-card-text',{staticClass:"pa-2"},[(!_vm.otherAcctExpansion)?_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.otherAcctExpansion)?_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("expand_less")]):_vm._e(),_vm._v("  "+_vm._s(_vm.$t("Other Accounts"))+"\n        ")],1)],1),_vm._v(" "),(_vm.otherAcctExpansion)?[_c('v-card',{staticClass:"sec3-card"},[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":"/product-report"}},[_c('v-card-text',{staticClass:"pa-2 font-weight-light",staticStyle:{"font-size":"12px"}},[_vm._v("\n              "+_vm._s(_vm.$t("Product Report"))+"\n            ")])],1)],1),_vm._v(" "),_c('v-card',{staticClass:"sec3-card"},[_c('v-card-text',{staticClass:"pa-2 font-weight-light",staticStyle:{"font-size":"13px"},on:{"click":function($event){_vm.Sec3DetailsDialog=true; _vm.Sec3Type='expense'}}},[_vm._v(" "+_vm._s(_vm.$t("Expense Accounts")))])],1),_vm._v(" "),_c('v-card',{staticClass:"sec3-card"},[_c('v-card-text',{staticClass:"pa-2 font-weight-light",staticStyle:{"font-size":"13px"},on:{"click":function($event){_vm.Sec3DetailsDialog=true; _vm.Sec3Type='income'}}},[_vm._v(" "+_vm._s(_vm.$t("INCOME ACCOUNTS")))])],1),_vm._v(" "),_c('v-card',{staticClass:"sec3-card"},[_c('v-card-text',{staticClass:"pa-2 font-weight-light",staticStyle:{"font-size":"13px"},on:{"click":function($event){_vm.Sec3DetailsDialog=true; _vm.Sec3Type='asset'}}},[_vm._v(" "+_vm._s(_vm.$t("ASSET ACCOUNTS")))])],1),_vm._v(" "),_c('v-card',{staticClass:"sec3-card"},[_c('v-card-text',{staticClass:"pa-2 font-weight-light",staticStyle:{"font-size":"13px"},on:{"click":function($event){_vm.Sec3DetailsDialog=true; _vm.Sec3Type='salary'}}},[_vm._v(" "+_vm._s(_vm.$t("Salary Accounts")))])],1),_vm._v(" "),_c('v-card',{staticClass:"sec3-card",on:{"click":function($event){$event.stopPropagation();return _vm.openFirstDialog('Credit Note')}}},[_c('v-card-text',{staticClass:"pa-2 font-weight-light",staticStyle:{"font-size":"13px"}},[_vm._v("\n            "+_vm._s(_vm.$t("Credit Note"))+"\n          ")])],1),_vm._v(" "),_c('v-card',{staticClass:"sec3-card",on:{"click":function($event){$event.stopPropagation();return _vm.openFirstDialog('Debit Note')}}},[_c('v-card-text',{staticClass:"pa-2 font-weight-light",staticStyle:{"font-size":"13px"}},[_vm._v("\n            "+_vm._s(_vm.$t("Debit Note"))+"\n          ")])],1),_vm._v(" "),_c('v-card',{staticClass:"sec3-card"},[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":{ name: 'IST'}}},[_c('v-card-text',{staticClass:"pa-2 font-weight-light",staticStyle:{"font-size":"13px"}},[_vm._v("\n              "+_vm._s(_vm.$t("ITC"))+"\n            ")])],1)],1)]:_vm._e(),_vm._v(" "),_c('v-card',{staticClass:"sec3-card"},[(_vm.$route.path!='/godawn')?_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":"/godawn"}},[_c('v-card-text',{staticClass:"pa-2"},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v(" store ")]),_vm._v("  "+_vm._s(_vm.$t("Godowns"))+"\n          ")],1)],1):_vm._e()],1)],2),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md6":""}},[_c('v-card',[_c('v-card-text',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',{staticClass:"title font-weight-light"},[_vm._v(" "+_vm._s(_vm.$t('Top Selling Products')))])],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.getTranslatedHeaders(_vm.topProdHead),"items":_vm.getTopProducts},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_c('b',{staticClass:"font-weight-bold primary--text"},[_vm._v(_vm._s(props.item['name']))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('b',[_vm._v(_vm._s(props.item['unit']))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('b',[_vm._v(_vm._s(props.item['saleQuantity']))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[(props.item['updatedSellingDate'])?_c('b',[_vm._v(_vm._s(_vm.dayDiff(props.item['updatedSellingDate'])))]):_vm._e()])]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v(_vm._s(_vm.$t("No Items")))])],2)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md6":""}},[_c('v-card',[_c('v-card-text',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',{staticClass:"title font-weight-light"},[_vm._v(" "+_vm._s(_vm.$t("Top Billing Customer")))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-select',{attrs:{"clearable":"","items":['Customers','Suppliers','All'],"label":"Filter"},model:{value:(_vm.topCustomerFilter),callback:function ($$v) {_vm.topCustomerFilter=$$v},expression:"topCustomerFilter"}})],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.getTranslatedHeaders(_vm.topCustHead),"items":_vm.topCustomers},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_c('b',[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":'/buyers/' + props.item['.key']}},[_vm._v("\n                  "+_vm._s(props.item['name'])+"\n                  ")])],1)]),_vm._v(" "),_c('td',{staticClass:"text-xs-left success--text"},[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item['totalAmount'] || 0)))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left primary--text"},[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item['paidAmount'] || 0)))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left error--text"},[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item['remainingAmount'] || 0)))])])]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v(_vm._s(_vm.$t("No Items")))])],2)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.Sec3DetailsDialog),callback:function ($$v) {_vm.Sec3DetailsDialog=$$v},expression:"Sec3DetailsDialog"}},[(_vm.Sec3Type =='firm')?_c('v-card',{staticClass:"one-dashboard"},[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":"","title":""}},[_c('h2',[_vm._v("FIRMS")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.Sec3DetailsDialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.getFirmSorted),function(firm){return _c('v-flex',{key:firm['.key'],staticStyle:{"padding":"15px"},attrs:{"xs12":"","md3":"","sm3":""}},[_c('v-card',{staticClass:"icon-card"},[_c('v-icon',{staticStyle:{"padding":"12px 18px"}},[_vm._v("table_chart")])],1),_vm._v(" "),_c('v-card',{key:firm['.key']+'F',staticClass:"sec1-card"},[_c('v-card-title',{staticClass:"subheading font-weight-bold",staticStyle:{"font-size":"20px"},attrs:{"primary-title":""}},[_c('v-spacer'),_vm._v("\n                    "+_vm._s(firm.name)+"\n                  ")],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":{ name: 'FirmStatements', params: {firmId: firm['.key']}}}},[_c('v-btn',{staticClass:"primary--text font-weight-bold",attrs:{"outline":""}},[_c('v-icon',{staticStyle:{"text-decoration":"none"},attrs:{"left":""}},[_vm._v(" remove_red_eye ")]),_vm._v("  \n                          Statement\n                        ")],1)],1),_vm._v(" "),_c('v-spacer')],1)],1)],1)}),1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.Sec3Type =='cash')?_c('v-card',{staticClass:"one-dashboard"},[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":"","title":""}},[_c('h2',[_vm._v("CASH ACCOUNTS")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.Sec3DetailsDialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.getFirmSorted),function(firm){return _c('v-flex',{key:firm['.key'],staticStyle:{"padding":"15px"},attrs:{"xs12":"","md3":"","sm3":""}},[_c('v-card',{staticClass:"icon-card"},[_c('v-icon',{staticStyle:{"padding":"12px 18px"}},[_vm._v("table_chart")])],1),_vm._v(" "),_c('v-card',{key:firm['.key']+'F',staticClass:"sec1-card"},[_c('v-card-title',{staticClass:"subheading font-weight-bold",staticStyle:{"font-size":"30px"},attrs:{"primary-title":""}},[_c('v-spacer'),_vm._v("\n                    "+_vm._s(firm.name)+"\n                  ")],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":{ name: 'CashStatements', params: {firmId: firm['.key']}}}},[_c('v-btn',{staticClass:"primary--text font-weight-bold",attrs:{"outline":""}},[_c('v-icon',{staticClass:"primary--text",attrs:{"left":""}},[_vm._v("\n                          remove_red_eye\n                        ")]),_vm._v("\n                        Statement\n                      ")],1)],1),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.firmDialog),callback:function ($$v) {_vm.firmDialog=$$v},expression:"firmDialog"}},[_c('v-card',[_vm._l((_vm.getFirmSorted),function(firm){return _c('v-flex',{key:firm['.key']},[(firm.name && firm.name==_vm.currentFirm)?[_c('v-card',{staticClass:"primary white--text",attrs:{"primary":"","title":""}},[_c('v-card-title',{attrs:{"primary-title":"","row":"","wrap":""}},[_c('b',{staticClass:"title font-weight-light"},[_vm._v("Cash Book")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('b',{staticClass:"title font-weight-light"},[_vm._v(" "+_vm._s(firm.name))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('b',{staticClass:"title font-weight-light"},[_vm._v(" "+_vm._s(firm.proprietor))]),_vm._v(" "),_c('v-spacer'),_vm._v("\n                                  Available Cash Balance:-\n                                  "),_c('b',{staticClass:"title font-weight-light"},[_vm._v(" "+_vm._s((firm.amount).toFixed(2)))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.firmDialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1)],1)]:_vm._e()],2)}),_vm._v(" "),_c('v-card-text',[_c('v-layout',{staticStyle:{"padding":"10px 50px 5px 21px"},attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-menu',{staticClass:"ist-datepicker-dashboard",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px","clearable":""},model:{value:(_vm.datepickerFrom3),callback:function ($$v) {_vm.datepickerFrom3=$$v},expression:"datepickerFrom3"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"From Date","prepend-icon":"event","readonly":"","clearable":""},slot:"activator",model:{value:(_vm.fromDate),callback:function ($$v) {_vm.fromDate=$$v},expression:"fromDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerFrom3 = false}},model:{value:(_vm.fromDate),callback:function ($$v) {_vm.fromDate=$$v},expression:"fromDate"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-menu',{staticClass:"ist-datepicker-dashboard",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px","clearable":""},model:{value:(_vm.datepickerTo3),callback:function ($$v) {_vm.datepickerTo3=$$v},expression:"datepickerTo3"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"To Date","prepend-icon":"event","readonly":"","clearable":""},slot:"activator",model:{value:(_vm.toDate),callback:function ($$v) {_vm.toDate=$$v},expression:"toDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerTo3 = false}},model:{value:(_vm.toDate),callback:function ($$v) {_vm.toDate=$$v},expression:"toDate"}})],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.getTranslatedHeaders(_vm.firmHeader),"items":_vm.getCashInvoices},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"primary--text font-weight-bold",domProps:{"innerHTML":_vm._s(_vm.renderDate(props.item.date))}}),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getFirmName(props.item.firm)))]),_vm._v(" "),_c('td',[_c('b',{staticClass:"primary--text font-weight-bold"},[_vm._v(_vm._s(_vm.getCurrentUserName(props.item.buyerId)))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item['.key']))]),_vm._v(" "),(!props.item.isCredited && props.item.buyerId)?[_c('td'),_vm._v(" "),_c('td',[_c('h3',{staticClass:"green--text text--darken-4"},[_vm._v(_vm._s(_vm._f("amount")((Number.parseFloat(props.item.amountFromBank) + Number.parseFloat(props.item.amountFromCash)) || 0))+" ")])])]:_vm._e(),_vm._v(" "),(props.item.isCredited && props.item.buyerId)?[_c('td',[_c('h3',{staticClass:"red--text text--darken-4"},[_vm._v(_vm._s(_vm._f("amount")((Number.parseFloat(props.item.amountFromBank) + Number.parseFloat(props.item.amountFromCash)) || 0))+" ")])]),_vm._v(" "),_c('td')]:_vm._e(),_vm._v(" "),(!props.item.isCredited && !props.item.buyerId)?[_c('td',[_c('h3',{staticClass:"red--text text--darken-4"},[_vm._v(" "+_vm._s(_vm._f("amount")(Number.parseFloat(props.item.totalAmount) - Number.parseFloat(props.item.discountAmount || 0 ) || 0)))])]),_vm._v(" "),_c('td')]:_vm._e(),_vm._v(" "),(props.item.isCredited && !props.item.buyerId)?[_c('td'),_vm._v(" "),_c('td',[_c('h3',{staticClass:"green--text text--darken-4"},[_vm._v(" "+_vm._s(_vm._f("amount")(Number.parseFloat(props.item.totalAmount) - Number.parseFloat(props.item.discountAmount || 0) || 0)))])])]:_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.paymentType))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.status))]),_vm._v(" "),_c('td',[_c('b',{staticClass:"primary--text font-weight-bold"},[_vm._v(_vm._s(_vm.getVocherType(props.item)))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.remark))])]}}],null,true)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],2)],1)],1)],1)}),1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.Sec3Type =='bank')?_c('v-card',{staticClass:"one-dashboard"},[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":"","title":""}},[_c('h2',[_vm._v(_vm._s(_vm.$t("BANK ACCOUNTS")))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.Sec3DetailsDialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.getSortedBankAccounts),function(account){return _c('v-flex',{key:account['.key'],staticStyle:{"padding":"15px"},attrs:{"xs12":"","md3":"","sm3":""}},[_c('v-card',{staticClass:"icon-card"},[_c('v-icon',{staticStyle:{"padding":"12px 18px"}},[_vm._v("account_balance_wallet")])],1),_vm._v(" "),_c('v-card',{key:account['.key']+'B',staticClass:"sec1-card"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('v-spacer'),_vm._v(" "),_c('div',[_c('h3',{staticClass:"title font-weight-bold"},[_vm._v(_vm._s(account.bankName)+" ")]),_vm._v(" "),_c('h5',{staticClass:"font-weight-light"},[_vm._v(_vm._s(account.accountnumber)+" - "+_vm._s(_vm.getFirmName(account.firm))+" ")])])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":{ name: 'BankStatements', params: {bankId: account['.key']}}}},[_c('v-btn',{staticClass:"primary--text font-weight-bold",attrs:{"outline":""}},[_c('v-icon',{staticClass:"primary--text",attrs:{"left":""}},[_vm._v("\n                          remove_red_eye\n                        ")]),_vm._v(" "+_vm._s(_vm.$t("Statement"))+"\n                      ")],1)],1),_vm._v(" "),_c('v-spacer')],1)],1)],1)}),1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.Sec3Type =='expense')?_c('v-card',{staticClass:"one-dashboard"},[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":"","title":""}},[_c('h3',[_vm._v(_vm._s(_vm.$t("EXPENSE ACCOUNTS")))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.Sec3DetailsDialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.getExpenses),function(expense){return _c('v-flex',{key:expense['.key'],staticStyle:{"padding":"15px"},attrs:{"xs12":"","md3":"","sm3":""}},[_c('v-card',{staticClass:"icon-card"},[_c('v-icon',{staticStyle:{"padding":"12px 18px"}},[_vm._v("account_balance_wallet")])],1),_vm._v(" "),_c('v-card',{key:expense['.key']+'E',staticClass:"sec1-card"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"title font-weight-bold"},[_vm._v(_vm._s(expense.expense))])],1),_vm._v(" "),[_c('v-card-text',{staticClass:"text"})],_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"outline":""},on:{"click":function($event){_vm.openDialog (expense['.key'])}}},[_c('v-icon',{staticClass:"primary--text",attrs:{"left":""}},[_vm._v("remove_red_eye")]),_vm._v("\n                      "+_vm._s(_vm.$t("Statement"))+"\n                    ")],1),_vm._v(" "),_c('v-spacer')],1)],2)],1)}),1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.Sec3Type =='income')?_c('v-card',{staticClass:"one-dashboard"},[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":"","title":""}},[_c('h3',[_vm._v(_vm._s(_vm.$t("INCOME ACCOUNTS")))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.Sec3DetailsDialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.getIncomes),function(income){return _c('v-flex',{key:income['.key'],staticStyle:{"padding":"15px"},attrs:{"xs12":"","md3":"","sm3":""}},[_c('v-card',{staticClass:"icon-card"},[_c('v-icon',{staticStyle:{"padding":"12px 18px"}},[_vm._v("account_balance_wallet")])],1),_vm._v(" "),_c('v-card',{key:income['.key']+'I',staticClass:"sec1-card"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"title font-weight-bold"},[_vm._v(_vm._s(income.income))])],1),_vm._v(" "),[_c('v-card-text',{staticClass:"text"})],_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"outline":""},on:{"click":function($event){_vm.openDialog1 (income['.key'])}}},[_c('v-icon',{staticClass:"primary--text",attrs:{"left":""}},[_vm._v("remove_red_eye")]),_vm._v("\n                      "+_vm._s(_vm.$t("Statement"))+"\n                    ")],1),_vm._v(" "),_c('v-spacer')],1)],2)],1)}),1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.Sec3Type =='asset')?_c('v-card',{staticClass:"one-dashboard"},[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":"","title":""}},[_c('h3',[_vm._v(_vm._s(_vm.$t("ASSET ACCOUNTS")))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.Sec3DetailsDialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.getAssets),function(asset){return _c('v-flex',{key:asset['.key'],staticStyle:{"padding":"15px"},attrs:{"xs12":"","md3":"","sm3":""}},[_c('v-card',{staticClass:"icon-card"},[_c('v-icon',{staticStyle:{"padding":"12px 18px"}},[_vm._v("account_balance_wallet")])],1),_vm._v(" "),_c('v-card',{key:asset['.key']+'A',staticClass:"sec1-card"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"title font-weight-bold"},[_vm._v(_vm._s(asset.asset))])],1),_vm._v(" "),[_c('v-card-text',{staticClass:"text"})],_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"outline":""},on:{"click":function($event){_vm.openDialog7 (asset['.key'])}}},[_c('v-icon',{staticClass:"primary--text",attrs:{"left":""}},[_vm._v("remove_red_eye")]),_vm._v("\n                      "+_vm._s(_vm.$t("Statement"))+"\n                    ")],1),_vm._v(" "),_c('v-spacer')],1)],2)],1)}),1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.Sec3Type =='salary')?_c('v-card',{staticClass:"one-dashboard"},[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":"","title":""}},[_c('h3',[_vm._v(_vm._s(_vm.$t("SALARY ACCOUNTS")))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.Sec3DetailsDialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.getStaffs),function(staff){return _c('v-flex',{key:staff['.key'],staticStyle:{"padding":"15px"},attrs:{"xs12":"","md3":"","sm3":""}},[_c('v-card',{staticClass:"icon-card"},[_c('v-icon',{staticStyle:{"padding":"12px 18px"}},[_vm._v("account_balance_wallet")])],1),_vm._v(" "),_c('v-card',{key:staff['.key']+'St',staticClass:"sec1-card"},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"title"},[_vm._v(_vm._s(staff.staffName))])],1),_vm._v(" "),[_c('v-card-text',{staticClass:"text"})],_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"outline":""},on:{"click":function($event){_vm.openDialog6 (staff['.key'])}}},[_c('v-icon',{staticClass:"primary--text",attrs:{"left":""}},[_vm._v("remove_red_eye")]),_vm._v("\n                      "+_vm._s(_vm.$t("Statement"))+"\n                    ")],1),_vm._v(" "),_c('v-spacer')],1)],2)],1)}),1)],1)],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.accountDialog),callback:function ($$v) {_vm.accountDialog=$$v},expression:"accountDialog"}},[_c('v-card',[_vm._l((_vm.getSortedBankAccounts),function(account){return _c('v-flex',{key:account['.key'],attrs:{"xs12":"","sm12":"","md12":""}},[(account.accountnumber && account.accountnumber==_vm.currentAccountNumber)?[_c('v-card',{staticClass:"primary white--text",attrs:{"primary":"","title":""}},[_c('v-card-title',{staticClass:"title font-weight-light",attrs:{"primary-title":"","row":""}},[_vm._v("\n              "+_vm._s(_vm.getFirmName(account.firm))+"\n              "),_c('v-spacer'),_vm._v("\n              "+_vm._s(account.bankName)+"\n              "),_c('v-spacer'),_vm._v("\n              "+_vm._s(account.accountHolderName)+"\n              "),_c('v-spacer'),_vm._v("\n              "+_vm._s(account.accountType)+"\n              "),_c('v-spacer'),_vm._v("Available Balance :   ₹\n              "),_c('b',[_vm._v(_vm._s(_vm._f("amount")(account.amount))+"/-")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.accountDialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1)],1),_vm._v(" "),_c('v-layout',{staticStyle:{"padding":"10px 50px 5px 21px"},attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-menu',{staticClass:"ist-datepicker-dashboard",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px","clearable":""},model:{value:(_vm.datepickerFrom4),callback:function ($$v) {_vm.datepickerFrom4=$$v},expression:"datepickerFrom4"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"From Date","prepend-icon":"event","readonly":"","clearable":""},slot:"activator",model:{value:(_vm.fromDate),callback:function ($$v) {_vm.fromDate=$$v},expression:"fromDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerFrom4 = false}},model:{value:(_vm.fromDate),callback:function ($$v) {_vm.fromDate=$$v},expression:"fromDate"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-menu',{staticClass:"ist-datepicker-dashboard",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px","clearable":""},model:{value:(_vm.datepickerTo4),callback:function ($$v) {_vm.datepickerTo4=$$v},expression:"datepickerTo4"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"To Date","prepend-icon":"event","readonly":"","clearable":""},slot:"activator",model:{value:(_vm.toDate),callback:function ($$v) {_vm.toDate=$$v},expression:"toDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerTo4 = false}},model:{value:(_vm.toDate),callback:function ($$v) {_vm.toDate=$$v},expression:"toDate"}})],1)],1)],1)]:_vm._e()],2)}),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.getTranslatedHeaders(_vm.bankHeader),"items":_vm.getBankInvoices},scopedSlots:_vm._u([{key:"items",fn:function(props){return (props.item.bank && props.item.bank==_vm.currentAccountKey)?[_c('td',{staticClass:"primary--text font-weight-bold",domProps:{"innerHTML":_vm._s(_vm.renderDate(props.item.date))}}),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getFirmName(props.item.firm)))]),_vm._v(" "),(props.item.accountType)?[(props.item.accountType  == 'Overdraft A/C' || props.item.accountType  == 'Loan A/C' )?[_c('td',[_c('h3',{staticClass:"error--text text--darken-4"},[_vm._v(" "+_vm._s(props.item.totalAmount))])]),_vm._v(" "),_c('td')]:[_c('td'),_vm._v(" "),_c('td',[_c('h3',{staticClass:"success--text text--darken-4"},[_vm._v(" "+_vm._s(props.item.totalAmount))])])]]:[(!props.item.isCredited)?[_c('td',[_c('h3',{staticClass:"green--text text--darken-4"},[_vm._v(" "+_vm._s(props.item.totalAmount))])]),_vm._v(" "),_c('td')]:_vm._e(),_vm._v(" "),(props.item.isCredited)?[_c('td'),_vm._v(" "),_c('td',[_c('h3',{staticClass:"red--text text--darken-4"},[_vm._v(" "+_vm._s(props.item.totalAmount))])])]:_vm._e()],_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.paymentType))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.remark))])]:undefined}}],null,true)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],2)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[(_vm.currentTitle == 'Profit')?[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("RECEIVED PAYMENT DETAILS")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-autocomplete',{staticClass:"mx-3",attrs:{"items":_vm.firmsByBrand,"search-input":_vm.searchInput,"cache-items":"","flat":"","hide-no-data":"","hide-details":"","label":"Select Firm","clearable":""},on:{"update:searchInput":function($event){_vm.searchInput=$event},"update:search-input":function($event){_vm.searchInput=$event}},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.profitHeader,"items":_vm.getInvoices,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return (props.item.profit && props.item.isCredited)?[_c('td',[_c('b',[_vm._v(_vm._s(new Date(props.item.closedDate).toLocaleDateString('en-GB')))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['.key']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.getFirmName(props.item.firm)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.rate)+" %")])]),_vm._v(" "),_c('td',[_c('h3',{staticClass:"error--text text--darken-4"},[_c('b',[_vm._v(_vm._s(props.item.principalValue))])])]),_vm._v(" "),_c('td',[_c('h3',{staticClass:"primary--text text--darken-4"},[_c('b',[_vm._v(_vm._s(props.item.profit))])])]),_vm._v(" "),_c('td',[_c('h3',{staticClass:"success--text text--darken-4"},[_c('b',[_vm._v(_vm._s(props.item.totalAmount))])])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.paymentType))])])]:undefined}}],null,true)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)]:_vm._e(),_vm._v(" "),(_vm.currentTitle == 'Sales')?[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-flex',{attrs:{"xs12":"","md2":"","sm2":""}},[_c('h3',{staticClass:"title font-weight-bold"},[_vm._v("\n          Sales Register\n        ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.printSaleReport()}}},[_c('v-icon',[_vm._v("print")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-toolbar',[_c('v-flex',{attrs:{"xs12":"","md3":"","sm3":""}},[_c('v-select',{staticClass:"select-firm-dashboard",attrs:{"dense":"","items":_vm.firmsByBrand,"label":"Select Firm","clearable":""},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":"","sm3":""}},[_c('v-menu',{staticClass:"ist-datepicker-dashboard",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px","clearable":""},model:{value:(_vm.datepickerFrom5),callback:function ($$v) {_vm.datepickerFrom5=$$v},expression:"datepickerFrom5"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"From Date","prepend-icon":"event","readonly":"","clearable":""},slot:"activator",model:{value:(_vm.fromDate),callback:function ($$v) {_vm.fromDate=$$v},expression:"fromDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerFrom5 = false}},model:{value:(_vm.fromDate),callback:function ($$v) {_vm.fromDate=$$v},expression:"fromDate"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":"","sm3":""}},[_c('v-menu',{staticClass:"ist-datepicker-dashboard",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px","clearable":""},model:{value:(_vm.datepickerTo5),callback:function ($$v) {_vm.datepickerTo5=$$v},expression:"datepickerTo5"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"To Date","prepend-icon":"event","readonly":"","clearable":""},slot:"activator",model:{value:(_vm.toDate),callback:function ($$v) {_vm.toDate=$$v},expression:"toDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerTo5 = false}},model:{value:(_vm.toDate),callback:function ($$v) {_vm.toDate=$$v},expression:"toDate"}})],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.invoiceHeader,"items":_vm.getSaleInvoices},scopedSlots:_vm._u([{key:"items",fn:function(props){return [(props.item.totalColumn_buyer)?[_c('td',[_c('b',[_c('h3',[_vm._v("Total")])])]),_vm._v(" "),_c('td',[_c('b',[_c('h3')])]),_vm._v(" "),_c('td',[_c('b',[_c('h3')])]),_vm._v(" "),_c('td',[_c('b',[_c('h3')])]),_vm._v(" "),_c('td',[_c('b',[_c('h3')])]),_vm._v(" "),_c('td',[_c('b',[_c('h4',{staticClass:"success--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item['totalAmount'] || 0)))])])]),_vm._v(" "),_c('td',[_c('b',[_c('h4',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item['basicAmount'] || 0)))])])]),_vm._v(" "),_c('td',[_c('b',[_c('h4',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item['gstTotal']|| 0)))])])]),_vm._v(" "),_c('td',[_c('b',[_c('h4',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item['discountAmount'] || 0)))])])]),_vm._v(" "),_c('td',[_c('b',[_c('h4',{staticClass:"primary--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item['paidAmount'] || 0)))])])]),_vm._v(" "),_c('td',[_c('b',[_c('h4',{staticClass:"error--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item['remainingAmount'] || 0)))])])]),_vm._v(" "),_c('td',[_c('b',[_c('h3')])]),_vm._v(" "),_c('td',[_c('b',[_c('h3')])]),_vm._v(" "),_c('td',[_c('b',[_c('h3')])]),_vm._v(" "),_c('td',[_c('b',[_c('h4')])]),_vm._v(" "),_c('td',[_c('b',[_c('h4')])]),_vm._v(" "),_c('td',[_c('b',[_c('h4')])]),_vm._v(" "),_c('td',[_c('b',[_c('h4')])]),_vm._v(" "),_c('td',[_c('b',[_c('h4')])]),_vm._v(" "),_c('td',[_c('b',[_c('h4',{staticClass:"primary--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item['GST_3']|| 0)))])])]),_vm._v(" "),_c('td',[_c('b',[_c('h4',{staticClass:"primary--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item['GST_5']|| 0)))])])]),_vm._v(" "),_c('td',[_c('b',[_c('h4',{staticClass:"primary--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item['GST_12']|| 0)))])])]),_vm._v(" "),_c('td',[_c('b',[_c('h4',{staticClass:"primary--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item['GST_18']|| 0)))])])]),_vm._v(" "),_c('td',[_c('b',[_c('h4',{staticClass:"primary--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item['GST_28']|| 0)))])])]),_vm._v(" "),_c('td')]:[_c('td',{staticClass:"primary--text font-weight-bold",domProps:{"innerHTML":_vm._s(_vm.renderDate(props.item.date))}}),_vm._v(" "),_c('td',[_c('v-menu',{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({},on),[_vm._v("more_vert")])]}}],null,true)},[_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.openProd(props.item)}}},[_c('v-list-tile-title',{staticClass:"font-weight-bold primary--text"},[_c('v-icon',{staticClass:"primary--text"},[_vm._v("\n                          remove_red_eye\n                        ")]),_vm._v("\n                        View \n                      ")],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.printBasicInvoice(props.item)}}},[_c('v-list-tile-title',{staticClass:"font-weight-bold primary--text"},[_c('v-icon',{staticClass:"primary--text"},[_vm._v("\n                          picture_as_pdf\n                        ")]),_vm._v("\n                        Print\n                      ")],1)],1),_vm._v(" "),_c('v-list-tile',[_c('router-link',{attrs:{"to":{ name: 'InvoiceUpdate', params: {invoiceId: props.item['.key']}}}},[_c('v-list-tile-title',{staticClass:"font-weight-bold primary--text"},[_c('v-icon',{staticClass:"primary--text"},[_vm._v("\n                          edit\n                        ")]),_vm._v("\n                        Edit\n                      ")],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.buyerId  &&  _vm.buyerById[props.item.buyerId]  ? _vm.buyerById[props.item.buyerId].name : ''))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['invoiceId']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"success--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item['totalAmount'] || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")((props.item['totalAmount'] - _vm.getGSTtotal(props.item)) || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(_vm.getGSTtotal(props.item) || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item['discountAmount'] || 0)))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"primary--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item['paidAmount'] || 0)))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"error--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item['remainingAmount'] || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['duration']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['paymentType']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['status']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['gstType']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")((props.item['gstType'] == 'IGST' ?  _vm.getGSTtotal(props.item) || 0 : 0))))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")((props.item['gstType'] == 'SGST|CGST' ?  _vm.getGSTtotal(props.item)/2 || 0 : 0))))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")((props.item['gstType'] == 'SGST|CGST' ?  _vm.getGSTtotal(props.item)/2 || 0 : 0))))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_3'] : '' || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_5'] : '' || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_12'] : ''|| 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_18'] : ''|| 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_28'] : ''|| 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['adminEmail'] ? props.item['adminEmail']: ''))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.getFirmName(props.item.firm)))])])]]}}],null,false,828232617)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2),_vm._v(" "),(_vm.selectedInvoice && _vm.selectedInvoice['.key'])?_c('v-dialog',{attrs:{"persistent":"","width":"1000"},model:{value:(_vm.dialog11),callback:function ($$v) {_vm.dialog11=$$v},expression:"dialog11"}},[_c('v-card',[_c('v-card-title',{staticClass:"title grey lighten-2",attrs:{"primary-title":""}},[_vm._v("\n                  "),_c('b',[_vm._v(_vm._s(_vm.selectedInvoice.buyerId ? _vm.buyerById[_vm.selectedInvoice.buyerId].name : '')+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.dialog11 = false}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("clear")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('b',[_vm._v("Name :-")]),_vm._v(" "),_vm._v("\n                      "+_vm._s(_vm.selectedInvoice.buyerId ? _vm.buyerById[_vm.selectedInvoice.buyerId].name : '')+"\n                    "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Firm :-")]),_vm._v("\n                    "+_vm._s(_vm.getFirmName(_vm.selectedInvoice.firm))+"\n                    "),_c('br'),_vm._v(" "),_c('b',[_vm._v("invoiceId :-")]),_vm._v("\n                    "+_vm._s(_vm.selectedInvoice['invoiceId'])+"\n                    "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Duration (in Days) :-")]),_vm._v("\n                    "+_vm._s(_vm.selectedInvoice['duration'])+"\n                    "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Payment Type :-")]),_vm._v("\n                    "+_vm._s(_vm.selectedInvoice['paymentType'])+"\n                    "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Status :-")]),_vm._v("\n                    "+_vm._s(_vm.selectedInvoice['status'])+"\n                    "),_c('br')]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('b',{staticClass:"success--text font-weight-bold"},[_vm._v("Total Amount:")]),_vm._v("\n                     "+_vm._s(_vm.selectedInvoice['totalAmount'])+"\n                    "),_c('br'),_vm._v(" "),_c('b',{staticClass:"primary--text font-weight-bold"},[_vm._v("Basic Amount:")]),_vm._v("\n                     "+_vm._s(_vm.selectedInvoice['totalAmount'] - _vm.getGSTtotal(_vm.selectedInvoice))+"\n                    "),_c('br'),_vm._v(" "),_c('b',{staticClass:"primary--text font-weight-bold"},[_vm._v("Total GST: ")]),_vm._v("\n                     "+_vm._s(_vm.getGSTtotal(_vm.selectedInvoice))+"\n                    "),_c('br'),_vm._v(" "),_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v("Deposite Amount:")]),_vm._v("\n                     "+_vm._s(_vm.selectedInvoice['paidAmount'])+"\n                    "),_c('br'),_vm._v(" "),_c('b',{staticClass:"red--text font-weight-bold"},[_vm._v("Remaining Amount:")]),_vm._v("\n                     "+_vm._s(_vm.selectedInvoice['remainingAmount'])+"\n                    "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Discount:")]),_vm._v("\n                     "+_vm._s(_vm.selectedInvoice['discountAmount'])+"\n                    "),_c('br')]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('b',[_vm._v("GST Type: ")]),_vm._v("\n                    "+_vm._s(_vm.selectedInvoice['gstType'])+"\n                    "),_c('br'),_vm._v(" "),_c('b',[_vm._v("GST (3%): ")]),_vm._v("\n                     "+_vm._s(_vm.selectedInvoice['GST_Percentage_total']['GST_3'])+"\n                    "),_c('br'),_vm._v(" "),_c('b',[_vm._v("GST (5%): ")]),_vm._v("\n                     "+_vm._s(_vm.selectedInvoice['GST_Percentage_total']['GST_5'])+"\n                    "),_c('br'),_vm._v(" "),_c('b',[_vm._v("GST (12%): ")]),_vm._v("\n                     "+_vm._s(_vm.selectedInvoice['GST_Percentage_total']['GST_12'])+"\n                    "),_c('br'),_vm._v(" "),_c('b',[_vm._v("GST (18%):")]),_vm._v("\n                     "+_vm._s(_vm.selectedInvoice['GST_Percentage_total']['GST_18'])+"\n                    "),_c('br'),_vm._v(" "),_c('b',[_vm._v("GST (28%): ")]),_vm._v("\n                     "+_vm._s(_vm.selectedInvoice['GST_Percentage_total']['GST_28'])+"\n                    "),_c('br')])],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.invoiceProductListHeader,"items":_vm.selectedInvoice.items},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',[_vm._v(_vm._s(props.item['productName']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['HSN_code']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.taxableGST_rate))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['productUnit']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['quantity']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.rate))])])]}}],null,false,3643818972)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.dialog11 = false}}},[_vm._v("Close")])],1)],1)],1):_vm._e()],1)]:_vm._e(),_vm._v(" "),(_vm.currentTitle == 'Credit Note')?[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Credit Note Register")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.invoiceHeader,"items":_vm.getCreditNoteInvoices},scopedSlots:_vm._u([{key:"headerCell",fn:function(ref){
var header = ref.header;
return [_c('span',{staticClass:"subheading font-weight-light text-success text--darken-3",domProps:{"textContent":_vm._s(header.text)}})]}},{key:"items",fn:function(props){return [(props.item.totalColum_credit)?[_c('td',[_c('b',[_vm._v("Total")])]),_vm._v(" "),_c('td',[_c('b')]),_vm._v(" "),_c('td',[_c('b')]),_vm._v(" "),_c('td',[_c('b')]),_vm._v(" "),_c('td',[_c('b')]),_vm._v(" "),_c('td',[_c('b',[_vm._v(" "+_vm._s(props.item['totalAmount']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(" "+_vm._s(props.item['basicAmount']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(" "+_vm._s(props.item['gstTotal'].toFixed(2)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(" "+_vm._s(props.item['discountAmount']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(" "+_vm._s(props.item['paidAmount']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(" "+_vm._s(props.item['remainingAmount']))])]),_vm._v(" "),_c('td',[_c('b')]),_vm._v(" "),_c('td',[_c('b')]),_vm._v(" "),_c('td',[_c('b')]),_vm._v(" "),_c('td',[_c('b')]),_vm._v(" "),_c('td',[_c('b')]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['GST_3'].toFixed(2)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['GST_5'].toFixed(2)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['GST_12'].toFixed(2)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['GST_18'].toFixed(2)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['GST_28'].toFixed(2)))])]),_vm._v(" "),_c('td')]:[_c('td',{staticClass:"primary--text font-weight-bold",domProps:{"innerHTML":_vm._s(_vm.renderDate(props.item.date))}}),_vm._v(" "),_c('td',[_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.openProd(props.item)}}},[_vm._v("remove_red_eye")])],1),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.buyerId ? _vm.buyerById[props.item.buyerId].name : ''))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['invoiceId']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(" "+_vm._s(props.item['paidAmount']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(" "+_vm._s(props.item['remainingAmount']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(" "+_vm._s(props.item['totalAmount']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(" "+_vm._s(props.item['totalAmount'] - _vm.getGSTtotal(props.item)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(" "+_vm._s(_vm.getGSTtotal(props.item)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(" "+_vm._s(props.item['discountAmount']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['duration']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['paymentType']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['status']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['transactionType']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['gstType']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")((props.item['gstType'] == 'IGST' ?  _vm.getGSTtotal(props.item) || 0 : 0))))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")((props.item['gstType'] != 'IGST' ?  _vm.getGSTtotal(props.item)/2 || 0 : 0))))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")((props.item['gstType'] != 'IGST' ?  _vm.getGSTtotal(props.item)/2 || 0 : 0))))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_3'] : ''))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_5'] : ''))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_12'] : ''))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_18'] : ''))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_28'] : ''))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['adminEmail'] ? props.item['adminEmail']: ''))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.getFirmName(props.item.firm)))])])]]}}],null,false,4033449526)},[_vm._v(" "),_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)]:_vm._e(),_vm._v(" "),(_vm.currentTitle == 'Debit Note')?[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Debit Note Register")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.invoiceHeader,"items":_vm.getDebitNoteInvoices},scopedSlots:_vm._u([{key:"items",fn:function(props){return [(props.item.totalColum_debit)?[_c('td',[_c('b',[_c('h2',[_vm._v("Total")])])]),_vm._v(" "),_c('td',[_c('b',[_c('h2')])]),_vm._v(" "),_c('td',[_c('b',[_c('h2')])]),_vm._v(" "),_c('td',[_c('b',[_c('h2')])]),_vm._v(" "),_c('td',[_c('b',[_c('h2')])]),_vm._v(" "),_c('td',[_c('b',[_c('h2')])]),_vm._v(" "),_c('td',[_c('b',[_vm._v("\n                     "+_vm._s(props.item['totalAmount'])+" \n                  ")])]),_vm._v(" "),_c('td',[_c('b',[_vm._v("\n                     "+_vm._s(props.item['basicAmount'])+"\n                  ")])]),_vm._v(" "),_c('td',[_c('b',[_c('h2',[_vm._v(" "+_vm._s(props.item['gstTotal'].toFixed(2)))])])]),_vm._v(" "),_c('td',[_c('b',[_c('h2',[_vm._v(" "+_vm._s(props.item['discountAmount']))])])]),_vm._v(" "),_c('td',[_c('b',[_vm._v("\n                     "+_vm._s(props.item['paidAmount'])+"  \n                  ")])]),_vm._v(" "),_c('td',[_c('b',[_vm._v("\n                     "+_vm._s(props.item['remainingAmount'])+" \n                  ")])]),_vm._v(" "),_c('td',[_c('b')]),_vm._v(" "),_c('td',[_c('b')]),_vm._v(" "),_c('td',[_c('b')]),_vm._v(" "),_c('td',[_c('b')]),_vm._v(" "),_c('td',[_c('b')]),_vm._v(" "),_c('td',[_c('b')]),_vm._v(" "),_c('td',[_c('b')]),_vm._v(" "),_c('td',[_c('b')]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['GST_3'].toFixed(2)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['GST_5'].toFixed(2)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['GST_12'].toFixed(2)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['GST_18'].toFixed(2)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['GST_28'].toFixed(2)))])])]:[_c('td',{staticClass:"primary--text font-weight-bold",domProps:{"innerHTML":_vm._s(_vm.renderDate(props.item.date))}}),_vm._v(" "),_c('td',[_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.openProd(props.item)}}},[_vm._v("remove_red_eye")])],1),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.buyerId ? _vm.sellerById[props.item.buyerId].name : ''))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['invoiceId']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(" "+_vm._s(props.item['totalAmount']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(" "+_vm._s(props.item['totalAmount'] - _vm.getGSTtotal(props.item)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(" "+_vm._s(_vm.getGSTtotal(props.item)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(" "+_vm._s(props.item['discountAmount']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(" "+_vm._s(props.item['paidAmount']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(" "+_vm._s(props.item['remainingAmount']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['duration']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['paymentType']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['status']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['transactionType']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['gstType']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")((props.item['gstType'] == 'IGST' ?  _vm.getGSTtotal(props.item) || 0 : 0))))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")((props.item['gstType'] != 'IGST' ?  _vm.getGSTtotal(props.item)/2 || 0 : 0))))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")((props.item['gstType'] != 'IGST' ?  _vm.getGSTtotal(props.item)/2 || 0 : 0))))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_3'] : ''))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_5'] : ''))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_12'] : ''))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_18'] : ''))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_28'] : ''))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.getFirmName(props.item.firm)))])])]]}}],null,false,691789940)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)]:_vm._e(),_vm._v(" "),(_vm.currentTitle == 'Purchase')?[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-flex',{attrs:{"xs12":"","md2":"","sm2":""}},[_c('h3',{staticClass:"title font-weight-bold"},[_vm._v("\n            Purchase Register\n          ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.printPurchaseReport()}}},[_c('v-icon',[_vm._v("print")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-toolbar',[_c('v-flex',{attrs:{"xs12":"","md3":"","sm3":""}},[_c('v-select',{staticClass:"select-firm-dashboard",attrs:{"dense":"","items":_vm.firmsByBrand,"label":"Select Firm","clearable":""},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":"","sm3":""}},[_c('v-menu',{staticClass:"ist-datepicker-dashboard",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px","clearable":""},model:{value:(_vm.datepickerFrom6),callback:function ($$v) {_vm.datepickerFrom6=$$v},expression:"datepickerFrom6"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"From Date","prepend-icon":"event","readonly":"","clearable":""},slot:"activator",model:{value:(_vm.fromDate),callback:function ($$v) {_vm.fromDate=$$v},expression:"fromDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerFrom6 = false}},model:{value:(_vm.fromDate),callback:function ($$v) {_vm.fromDate=$$v},expression:"fromDate"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":"","sm3":""}},[_c('v-menu',{staticClass:"ist-datepicker-dashboard",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px","clearable":""},model:{value:(_vm.datepickerTo6),callback:function ($$v) {_vm.datepickerTo6=$$v},expression:"datepickerTo6"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"To Date","prepend-icon":"event","readonly":"","clearable":""},slot:"activator",model:{value:(_vm.toDate),callback:function ($$v) {_vm.toDate=$$v},expression:"toDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerTo6 = false}},model:{value:(_vm.toDate),callback:function ($$v) {_vm.toDate=$$v},expression:"toDate"}})],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.invoiceHeader,"items":_vm.getPurchaseInvoices},scopedSlots:_vm._u([{key:"items",fn:function(props){return [(props.item.totalColum_seller)?[_c('td',[_c('b',[_vm._v("Total")])]),_vm._v(" "),_c('td',[_c('b')]),_vm._v(" "),_c('td',[_c('b')]),_vm._v(" "),_c('td',[_c('b')]),_vm._v(" "),_c('td',[_c('b')]),_vm._v(" "),_c('td',[_c('b',{staticClass:"success--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item['totalAmount']|| 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item['basicAmount']|| 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item['gstTotal'] || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item['discountAmount']|| 0)))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"primary--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item['paidAmount'] || 0)))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"error--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item['remainingAmount']|| 0)))])]),_vm._v(" "),_c('td',[_c('b')]),_vm._v(" "),_c('td',[_c('b')]),_vm._v(" "),_c('td',[_c('b')]),_vm._v(" "),_c('td',[_c('b')]),_vm._v(" "),_c('td',[_c('b')]),_vm._v(" "),_c('td',[_c('b')]),_vm._v(" "),_c('td',[_c('b')]),_vm._v(" "),_c('td',[_c('b')]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item['GST_3'] || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item['GST_5'] || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item['GST_12'] || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item['GST_18'] || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item['GST_28'] || 0)))])]),_vm._v(" "),_c('td')]:[_c('td',{staticClass:"primary--text font-weight-bold",domProps:{"innerHTML":_vm._s(_vm.renderDate(props.item.date))}}),_vm._v(" "),_c('td',[_c('v-menu',{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({},on),[_vm._v("more_vert")])]}}],null,true)},[_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.openProd(props.item)}}},[_c('v-list-tile-title',{staticClass:"font-weight-bold primary--text"},[_c('v-icon',{staticClass:"primary--text"},[_vm._v("\n                          remove_red_eye\n                        ")]),_vm._v("\n                        View\n                      ")],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.printBasicInvoice(props.item)}}},[_c('v-list-tile-title',{staticClass:"font-weight-bold primary--text"},[_c('v-icon',{staticClass:"primary--text"},[_vm._v("\n                          picture_as_pdf\n                        ")]),_vm._v("\n                        Print")],1)],1),_vm._v(" "),_c('v-list-tile',[_c('router-link',{attrs:{"to":{ name: 'InvoiceUpdate', params: {invoiceId: props.item['.key']}}}},[_c('v-list-tile-title',{staticClass:"font-weight-bold primary--text"},[_c('v-icon',{staticClass:"primary--text"},[_vm._v("\n                          edit\n                        ")]),_vm._v("\n                        Edit\n                      ")],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.buyerId ? _vm.sellerById[props.item.buyerId].name : ''))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['invoiceId']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"success--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item['totalAmount'] || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['totalAmount'] - _vm.getGSTtotal(props.item)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.getGSTtotal(props.item)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['discountAmount']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"primary--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item['paidAmount'] || 0)))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"error--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item['remainingAmount'] || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['duration']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['paymentType']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['status']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['gstType']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")((props.item['gstType'] == 'IGST' ?  _vm.getGSTtotal(props.item) || 0 : 0))))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")((props.item['gstType'] != 'IGST' ?  _vm.getGSTtotal(props.item)/2 || 0 : 0))))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")((props.item['gstType'] != 'IGST' ?  _vm.getGSTtotal(props.item)/2 || 0 : 0))))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_3'] : ''))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_5'] : ''))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_12'] : ''))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_18'] : ''))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['GST_Percentage_total'] ? props.item['GST_Percentage_total']['GST_28'] : ''))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['adminEmail'] ? props.item['adminEmail']: ''))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.getFirmName(props.item.firm)))])])]]}}],null,false,981145859)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2),_vm._v(" "),(_vm.selectedInvoice && _vm.selectedInvoice['.key'])?_c('v-dialog',{attrs:{"persistent":"","width":"1000"},model:{value:(_vm.dialog11),callback:function ($$v) {_vm.dialog11=$$v},expression:"dialog11"}},[_c('v-card',[_c('v-card-title',{staticClass:"title grey lighten-2",attrs:{"primary-title":""}},[_vm._v("\n                "+_vm._s(_vm.selectedInvoice.buyerId ? _vm.sellerById[_vm.selectedInvoice.buyerId].name : '')+"\n                "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.dialog11 = false}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("clear")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('b',[_vm._v("Name: ")]),_vm._v("\n                    "+_vm._s(_vm.selectedInvoice.buyerId ? _vm.sellerById[_vm.selectedInvoice.buyerId].name : '')+"\n                    "),_vm._v(" "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Firm: ")]),_vm._v("\n                    "+_vm._s(_vm.getFirmName(_vm.selectedInvoice.firm))+"\n                    "),_c('br'),_vm._v(" "),_c('b',[_vm._v("invoiceId: ")]),_vm._v("\n                    "+_vm._s(_vm.selectedInvoice['invoiceId'])+"\n                    "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Payment Type: ")]),_vm._v("\n                    "+_vm._s(_vm.selectedInvoice['paymentType'])+"\n                    "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Status: ")]),_vm._v("\n                    "+_vm._s(_vm.selectedInvoice['status'])+"\n                    "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Duration (in Days): ")]),_vm._v("\n                    "+_vm._s(_vm.selectedInvoice['duration'])+"\n                    "),_c('br')]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('b',{staticClass:"font-weight-bold green--text"},[_vm._v("Total Amount: ")]),_vm._v("\n                     "+_vm._s(_vm.selectedInvoice['totalAmount'])+"\n                    "),_c('br'),_vm._v(" "),_c('b',{staticClass:"font-weight-bold primary--text"},[_vm._v("Basic Amount: ")]),_vm._v("\n                     "+_vm._s(_vm.selectedInvoice['totalAmount'] - _vm.getGSTtotal(_vm.selectedInvoice))+"\n                    "),_c('br'),_vm._v(" "),_c('b',{staticClass:"font-weight-bold primary--text"},[_vm._v("GST: ")]),_vm._v("\n                     "+_vm._s(_vm.getGSTtotal(_vm.selectedInvoice))+"\n                    "),_c('br'),_vm._v(" "),_c('b',{staticClass:"font-weight-bold success--text"},[_vm._v("Deposit Amount: ")]),_vm._v("\n                     "+_vm._s(_vm.selectedInvoice['paidAmount'])+"\n                    "),_c('br'),_vm._v(" "),_c('b',{staticClass:"font-weight-bold red--text"},[_vm._v("Remaining Amount: ")]),_vm._v("\n                     "+_vm._s(_vm.selectedInvoice['remainingAmount'])+"\n                    "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Discount: ")]),_vm._v("\n                     "+_vm._s(_vm.selectedInvoice['discountAmount'])+"\n                    "),_c('br')]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('b',[_vm._v("GST Type: ")]),_vm._v("\n                    "+_vm._s(_vm.selectedInvoice['gstType'])+"\n                    "),_c('br'),_vm._v(" "),_c('b',[_vm._v("GST (0%): ")]),_vm._v("\n                     "+_vm._s(_vm.selectedInvoice['GST_Percentage_total']['GST_3'])+"\n                    "),_c('br'),_vm._v(" "),_c('b',[_vm._v("GST (5%): ")]),_vm._v("\n                     "+_vm._s(_vm.selectedInvoice['GST_Percentage_total']['GST_5'])+"\n                    "),_c('br'),_vm._v(" "),_c('b',[_vm._v("GST (12%): ")]),_vm._v("\n                     "+_vm._s(_vm.selectedInvoice['GST_Percentage_total']['GST_12'])+"\n                    "),_c('br'),_vm._v(" "),_c('b',[_vm._v("GST (18%): ")]),_vm._v("\n                     "+_vm._s(_vm.selectedInvoice['GST_Percentage_total']['GST_18'])+"\n                    "),_c('br'),_vm._v(" "),_c('b',[_vm._v("GST (28%): ")]),_vm._v("\n                     "+_vm._s(_vm.selectedInvoice['GST_Percentage_total']['GST_28'])+"\n                    "),_c('br')])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.invoiceProductListHeader,"items":_vm.selectedInvoice.items},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',[_vm._v(_vm._s(props.item['productName']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['HSN_code']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.taxableGST_rate))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['productUnit']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['quantity']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.rate))])])]}}],null,false,3643818972)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.dialog11 = false}}},[_vm._v("Close")])],1)],1)],1):_vm._e()],1)]:_vm._e(),_vm._v(" "),(_vm.currentTitle == 'Customer')?[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',[_vm._v("CUSTOMER INFORMATION")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{staticStyle:{"margin-top":"10px"},attrs:{"prepend-inner-icon":"search","solo":"","outlined":"","clearable":"","label":"Search Customer"},nativeOn:{"keyup":function($event){return _vm.keymonitorCustomer($event)}}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.buyerHeader,"items":_vm.itemList,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return (props.item.name || props.item.propName)?[_c('td',[_c('b',[_vm._v(_vm._s(props.item['.key']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"primary--text"},[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":{ name: 'BuyersInfo', params : {buyerId : props.item['.key']}}}},[_vm._v("\n                    "+_vm._s(props.item.name)+"\n                  ")])],1)]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.propName))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.localAddress))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.tehsil))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.district))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"primary--text"},[_vm._v(_vm._s(props.item.mobile))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.identityType))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.identityNumber))])])]:undefined}}],null,true)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)]:_vm._e()],2)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.expenseDialog),callback:function ($$v) {_vm.expenseDialog=$$v},expression:"expenseDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":"","title":""}},[_c('h2',[_vm._v(_vm._s(_vm.$t("Expense Details")))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.expenseDialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.expenseHeader,"items":_vm.getExpenseInvoices},scopedSlots:_vm._u([{key:"items",fn:function(props){return (props.item.expenseType == _vm.currentExpense)?[_c('td',{staticClass:"primary--text font-weight-bold",domProps:{"innerHTML":_vm._s(_vm.renderDate(props.item.date))}}),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item['.key']))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getFirmName(props.item.firm)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.paymentType))]),_vm._v(" "),_c('td',{staticClass:"red--text text--darken-4"},[_vm._v(_vm._s(props.item.totalAmount)+"/-")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.remark))])]:undefined}}],null,true)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.incomeDialog),callback:function ($$v) {_vm.incomeDialog=$$v},expression:"incomeDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":"","title":""}},[_c('h2',[_vm._v("Income Details")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.incomeDialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.incomeAccHeader,"items":_vm.getIncomeInvoices},scopedSlots:_vm._u([{key:"items",fn:function(props){return (props.item.incomeType == _vm.currentIncome)?[_c('td',{staticClass:"primary--text font-weight-bold",domProps:{"innerHTML":_vm._s(_vm.renderDate(props.item.date))}}),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item['.key']))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getFirmName(props.item.firm)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.paymentType))]),_vm._v(" "),_c('td',{staticClass:"green--text text--darken-4"},[_vm._v(_vm._s(props.item.totalAmount)+"/-")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.remark))])]:undefined}}],null,true)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.staffDialog),callback:function ($$v) {_vm.staffDialog=$$v},expression:"staffDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":"","title":""}},[_c('h2',[_vm._v("Staff Details")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.staffDialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.salaryHeader,"items":_vm.getStaffInvoices},scopedSlots:_vm._u([{key:"items",fn:function(props){return (props.item.staffkey == _vm.currentStaff)?[_c('td',{staticClass:"primary--text font-weight-bold",domProps:{"innerHTML":_vm._s(_vm.renderDate(props.item.date))}}),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item['.key']))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getFirmName(props.item.firm)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.paymentType))]),_vm._v(" "),(['advance','salary','commission'].includes(props.item.salaryType))?_c('td',{staticClass:"red--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item.totalAmount || 0))+"/-")]):_c('td'),_vm._v(" "),(['return'].includes(props.item.salaryType))?_c('td',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item.totalAmount || 0))+"/-")]):_c('td'),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.remark))])]:undefined}}],null,true)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.assetDialog),callback:function ($$v) {_vm.assetDialog=$$v},expression:"assetDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":"","title":""}},[_c('h2',[_vm._v("Asset Details")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.assetDialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.assetHeader,"items":_vm.getAssetInvoices},scopedSlots:_vm._u([{key:"items",fn:function(props){return (props.item.assetType == _vm.currentAsset)?[_c('td',{staticClass:"primary--text font-weight-bold",domProps:{"innerHTML":_vm._s(_vm.renderDate(props.item.date))}}),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item['.key']))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getFirmName(props.item.firm)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.paymentType))]),_vm._v(" "),_c('td',{staticClass:"success--text text--darken-4"},[_vm._v(_vm._s(props.item.totalAmount)+"/-")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.remark))])]:undefined}}],null,true)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(404);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0af935b2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1337);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0af935b2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(405);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80b16a20_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1333);
function injectStyle (ssrContext) {
  __webpack_require__(1235)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_80b16a20_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1235 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1236 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{ref:"form"},[_c('v-expansion-panel',{attrs:{"id":"buyerInfo"}},[_c('v-expansion-panel-content',{attrs:{"value":_vm.expansion},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('div',[_c('v-card-title',{staticClass:"primary white--text"},[(_vm.newBuyer)?_c('h3',{attrs:{"color":"primary"}},[_vm._v("ADD USER INFORMATION")]):_c('h3',{attrs:{"color":"primary"}},[_vm._v("PERSONAL INFORMATION - "),_c('b',[_vm._v(_vm._s(_vm.name.value))])])])],1)]},proxy:true}])},[_vm._v(" "),_c('v-form',{ref:"buyerform",attrs:{"lazy-validation":""},model:{value:(_vm.userInfoIsValid),callback:function ($$v) {_vm.userInfoIsValid=$$v},expression:"userInfoIsValid"}},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{ref:"name",attrs:{"counter":"100","maxlength":"100","rules":_vm.name.rules,"label":"Name","required":""},model:{value:(_vm.name.value),callback:function ($$v) {_vm.$set(_vm.name, "value", $$v)},expression:"name.value"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{ref:"propName",attrs:{"counter":"100","maxlength":"100","rules":_vm.propName.rules,"label":"Proprietor's Name","required":""},model:{value:(_vm.propName.value),callback:function ($$v) {_vm.$set(_vm.propName, "value", $$v)},expression:"propName.value"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-text-field',{ref:"age",attrs:{"type":"number","rules":_vm.age.rules,"label":"Age","maxlength":"3"},model:{value:(_vm.age.value),callback:function ($$v) {_vm.$set(_vm.age, "value", $$v)},expression:"age.value"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-select',{attrs:{"items":_vm.gGender,"label":"Gender"},model:{value:(_vm.gender.value),callback:function ($$v) {_vm.$set(_vm.gender, "value", $$v)},expression:"gender.value"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.gIdentityType,"clearable":"","label":"Identity Type"},model:{value:(_vm.identityType.value),callback:function ($$v) {_vm.$set(_vm.identityType, "value", $$v)},expression:"identityType.value"}})],1),_vm._v(" "),(_vm.identityType.value)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{ref:"identityNumber",attrs:{"error-messages":_vm.identityNumeberError,"rules":_vm.identityNumber.rules,"label":"Identity Number"},model:{value:(_vm.identityNumber.value),callback:function ($$v) {_vm.$set(_vm.identityNumber, "value", $$v)},expression:"identityNumber.value"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{ref:"mobile",attrs:{"type":"number","rules":_vm.mobile.rules,"label":"Mobile"},model:{value:(_vm.mobile.value),callback:function ($$v) {_vm.$set(_vm.mobile, "value", $$v)},expression:"mobile.value"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{ref:"email",attrs:{"type":"email","rules":_vm.email.rules,"label":"Email"},model:{value:(_vm.email.value),callback:function ($$v) {_vm.$set(_vm.email, "value", $$v)},expression:"email.value"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{ref:"zipCode",attrs:{"type":"number","label":"ZipCode"},on:{"change":function($event){return _vm.setLocationBasedOnZipCode()}},model:{value:(_vm.zipCode),callback:function ($$v) {_vm.zipCode=$$v},expression:"zipCode"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-combobox',{ref:"localAddress",attrs:{"autocomplete":"false","counter":"100","maxlength":"100","items":_vm.addressSuggestions,"rules":_vm.localAddress.rules,"label":"Address","required":""},model:{value:(_vm.localAddress.value),callback:function ($$v) {_vm.$set(_vm.localAddress, "value", $$v)},expression:"localAddress.value"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"clearable":"","items":_vm.gTehsil,"label":"Tehsil"},model:{value:(_vm.tehsil.value),callback:function ($$v) {_vm.$set(_vm.tehsil, "value", $$v)},expression:"tehsil.value"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-select',{attrs:{"clearable":"","items":_vm.gDistrict,"label":"District"},model:{value:(_vm.district.value),callback:function ($$v) {_vm.$set(_vm.district, "value", $$v)},expression:"district.value"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-select',{attrs:{"clearable":"","items":_vm.gState,"item-text":"state","label":"State"},model:{value:(_vm.state.value),callback:function ($$v) {_vm.$set(_vm.state, "value", $$v)},expression:"state.value"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-select',{attrs:{"clearable":"","items":_vm.gCountry,"label":"Country"},model:{value:(_vm.country.value),callback:function ($$v) {_vm.$set(_vm.country, "value", $$v)},expression:"country.value"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[(_vm.state.value)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-select',{attrs:{"items":['Yes','No'],"label":"GST User"},model:{value:(_vm.GST_user.value),callback:function ($$v) {_vm.$set(_vm.GST_user, "value", $$v)},expression:"GST_user.value"}})],1):_vm._e(),_vm._v(" "),(_vm.GST_user.value === 'Yes')?_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"type":"text","disabled":_vm.GST_user.value != 'Yes',"rules":_vm.GST_number.rules,"label":"GST number"},model:{value:(_vm.GST_number.value),callback:function ($$v) {_vm.$set(_vm.GST_number, "value", $$v)},expression:"GST_number.value"}})],1):_vm._e(),_vm._v(" "),(_vm.GST_user.value === 'Yes')?_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-select',{attrs:{"items":_vm.gFirmType,"label":"Firm Type"},model:{value:(_vm.firm_type.value),callback:function ($$v) {_vm.$set(_vm.firm_type, "value", $$v)},expression:"firm_type.value"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-select',{attrs:{"items":_vm.gPurchaseType,"label":this.isBuyer ? 'Sale Type' : 'Purchase Type'},model:{value:(_vm.purchaseType.value),callback:function ($$v) {_vm.$set(_vm.purchaseType, "value", $$v)},expression:"purchaseType.value"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-select',{attrs:{"items":_vm.filteredProductRateCategories,"label":"User Category"},model:{value:(_vm.category),callback:function ($$v) {_vm.category=$$v},expression:"category"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"grey white--text",attrs:{"flat":""},on:{"click":_vm.clear}},[_vm._v("\n              Reset\n            ")]),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text",attrs:{"flat":"","disabled":!_vm.userInfoIsValid},on:{"click":_vm.submit}},[_vm._v(_vm._s(_vm.isCreateOrUpdate)+"\n            ")])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BuyerItems_vue__ = __webpack_require__(407);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba0c3dec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuyerItems_vue__ = __webpack_require__(1240);
function injectStyle (ssrContext) {
  __webpack_require__(1239)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ba0c3dec"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BuyerItems_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba0c3dec_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuyerItems_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"height":"100%"}},[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":""}},[_c('h3',{attrs:{"color":"primary"}},[_vm._v("ACTIONS")])]),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[_c('v-btn',{staticClass:"primary--text font-weight-bold",attrs:{"outline":"","disabled":!_vm.isBuyerSelected},on:{"click":_vm.openInvoice}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("\n        add\n      ")]),_vm._v(" "),_c('h3',[_vm._v("New Invoice")])],1),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":{ name: 'InvoiceStatements', params: {customerId: _vm.selectedBuyer}}}},[_c('v-btn',{staticClass:"primary--text font-weight-bold",attrs:{"outline":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("\n          visibility\n        ")]),_vm._v(" "),_c('h3',[_vm._v(" Statements ")])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[(_vm.isBuyerSelected)?_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":{ 
        name: 'CustomerDeposit',
        params: {
          customerId: _vm.selectedBuyer
          }
        }}},[_c('v-btn',{staticClass:"primary--text font-weight-bold",attrs:{"outline":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("\n            account_balance_wallet\n          ")]),_vm._v(" "),_c('h3',[_vm._v(" Add Options ")])],1)],1):_vm._e()],1),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[(_vm.isBuyerSelected)?_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":{ 
        name: 'CustomerPayments',
        params: {
          customerId: _vm.selectedBuyer
          }
        }}},[_c('v-btn',{staticClass:"primary--text font-weight-bold",staticStyle:{"text-decoration":"none"},attrs:{"outline":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("\n            receipt_long\n          ")]),_vm._v(" "),_c('h3',[_vm._v(" "+_vm._s(_vm.isBuyer ? 'New Receipt' : 'New Payment')+" ")])],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BuyerInvoiceExpansion_vue__ = __webpack_require__(408);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a784bb4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuyerInvoiceExpansion_vue__ = __webpack_require__(1332);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BuyerInvoiceExpansion_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a784bb4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuyerInvoiceExpansion_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BuyerInvoices_vue__ = __webpack_require__(409);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36cdf07d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuyerInvoices_vue__ = __webpack_require__(1247);
function injectStyle (ssrContext) {
  __webpack_require__(1243)
  __webpack_require__(1244)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36cdf07d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BuyerInvoices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36cdf07d_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuyerInvoices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1243 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1244 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-card',{attrs:{"v-if":_vm.invoiceDataAvailable}},[_c('v-card-title',{staticClass:"primary white--text headline",attrs:{"primary-title":""}},[_c('h3',{staticClass:"strong white--text font-weight-light headline"},[_c('b',[_vm._v(_vm._s(this.currentUser.name))])]),_vm._v(" "),_c('h5',{staticClass:"subheading font-weight-light white--text"},[_vm._v("\n              "+_vm._s(this.currentUser.GST_number || "-")+"\n          ")])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('div',{staticClass:"text-sm-left subheading font-weight-light"},[_vm._v("\n                Invoice Id:\n                "),_c('b',{staticClass:"font-weight-bold"},[_vm._v("#"+_vm._s(_vm.selectedInvoiceId))])]),_vm._v(" "),_c('div',{staticClass:"text-sm-left subheading font-weight-light"},[_vm._v("\n                Invoice No:\n                "),_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.invoiceData["invoiceId"]))])]),_vm._v(" "),_c('div',{staticClass:"text-sm-left subheading font-weight-light"},[_vm._v("\n                Billed on:\n                "),_c('b',{staticClass:"font-weight-bold"},[_vm._v("\n                  "+_vm._s(new Date(_vm.invoiceData["date"]).toLocaleDateString("en-GB"))+"\n                ")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('div',{staticClass:"text-sm-left subheading font-weight-light"},[_vm._v("\n                Total Amount:\n                "),_c('b',{staticClass:"success--text font-weight-bold"},[_vm._v("\n                  "+_vm._s(_vm._f("amount")(Number.parseFloat(_vm.invoiceData["totalAmount"]) ||
                    0)))])]),_vm._v(" "),_c('div',{staticClass:"text-sm-left subheading font-weight-light"},[_vm._v("\n                Paid Amount:\n                "),_c('b',{staticClass:"warning--text font-weight-bold"},[_vm._v("\n                  "+_vm._s(_vm._f("amount")(_vm.invoiceData["paidAmount"] || 0)))])]),_vm._v(" "),_c('div',{staticClass:"text-sm-left subheading font-weight-light"},[_vm._v("\n                Due Amount:\n                "),_c('b',{staticClass:"error--text font-weight-bold"},[_vm._v("\n                  "+_vm._s(_vm._f("amount")(_vm.invoiceData["remainingAmount"] || 0))+"\n                ")])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker),callback:function ($$v) {_vm.datepicker=$$v},expression:"datepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Closing Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.closedDate),callback:function ($$v) {_vm.closedDate=$$v},expression:"closedDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepicker = false}},model:{value:(_vm.closedDate),callback:function ($$v) {_vm.closedDate=$$v},expression:"closedDate"}})],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.invoiceData.items,"hide-actions":"","item-key":"index"},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.productName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.unit))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.rate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.basicPrice))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.GSTValue))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.totlePrice))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.CGST_val)+" ("+_vm._s(props.item.CGST)+" %)")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.SGST_val)+" ("+_vm._s(props.item.SGST)+" %)")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.IGST_val)+" ("+_vm._s(props.item.IGST)+" %)")])]}}])}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.firmsByBrand,"label":"Select Firm","readonly":""},model:{value:(_vm.invoiceData.firm),callback:function ($$v) {_vm.$set(_vm.invoiceData, "firm", $$v)},expression:"invoiceData.firm"}}),_vm._v(" "),(_vm.invoiceData.transactionType)?_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.transactionDialog = true}}},[_vm._v("Transaction Details")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-select',{attrs:{"dense":"","items":[
                  {
                    text: 'Partial Paid',
                    value: 'Partial Paid',
                  },
                  {
                    text: 'Full Paid',
                    value: 'Credit',
                  } ],"label":"Select Transaction type"},on:{"input":function($event){_vm.transactionDialog = true}},model:{value:(_vm.invoiceData.transactionType),callback:function ($$v) {_vm.$set(_vm.invoiceData, "transactionType", $$v)},expression:"invoiceData.transactionType"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('div',{},[_vm._v("\n                Amount Deposited:\n                "),_c('br'),_vm._v(" "),(_vm.nowDepositedIsDirty)?_c('b',[_vm._v(_vm._s((
                    Number.parseFloat(_vm.invoiceData["amountFromBank"]) +
                    Number.parseFloat(_vm.invoiceData["amountFromCash"])
                  ).toFixed(_vm.roundOff)))]):_vm._e(),_vm._v(" "),(!_vm.nowDepositedIsDirty)?_c('b',[_vm._v("0")]):_vm._e()])]),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('div',{},[_vm._v("\n                Amount Remaining:\n                "),_c('br'),_vm._v(" "),(_vm.nowDepositedIsDirty)?_c('b',[_vm._v(_vm._s(Number.parseFloat(_vm.invoiceData["amountToBePaid"])))]):_vm._e(),_vm._v(" "),(!_vm.nowDepositedIsDirty)?_c('b',[_vm._v(_vm._s(_vm.invoiceData["remainingAmount"]))]):_vm._e()]),_vm._v(" "),(_vm.invoiceData.transactionType)?_c('v-btn',{staticClass:"primary white--text",attrs:{"large":"","flat":""},nativeOn:{"click":function($event){return _vm.updateInvoice($event)}}},[_vm._v("Update Payment\n              ")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"1000px"},model:{value:(_vm.transactionDialog),callback:function ($$v) {_vm.transactionDialog=$$v},expression:"transactionDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Payment Details\n                ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.transactionDialog = false}}},[_c('v-icon',[_vm._v("mdi-close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Total Amount","readonly":"","value":_vm.invoiceData.totalAmount,"prefix":""}}),_vm._v(" "),_c('v-text-field',{attrs:{"readonly":"","value":_vm.invoiceData['remainingAmount'],"type":"number","label":"Due Amount"}}),_vm._v(" "),_c('v-text-field',{attrs:{"readonly":"","value":_vm.invoiceData['paidAmount'],"type":"number","label":"Previously Paid Amount"}}),_vm._v(" "),_c('v-text-field',{attrs:{"type":"number","label":"Discount "},model:{value:(_vm.invoiceData.discountAmount),callback:function ($$v) {_vm.$set(_vm.invoiceData, "discountAmount", $$v)},expression:"invoiceData.discountAmount"}}),_vm._v(" "),_c('v-text-field',{attrs:{"type":"number","label":"Additional Discount "},model:{value:(_vm.additionalDiscount),callback:function ($$v) {_vm.additionalDiscount=$$v},expression:"additionalDiscount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-select',{attrs:{"dense":"","items":[
                        {
                          text: 'Cash',
                          value: 'Cash',
                        },
                        {
                          text: 'Bank Account',
                          value: 'Bank Account',
                        },
                        {
                          text: 'Cash & Bank Account',
                          value: 'CashAndBank Account',
                        } ],"label":"Select Payment Type"},on:{"change":function($event){return _vm.resetAmounts()}},model:{value:(_vm.invoiceData.paymentType),callback:function ($$v) {_vm.$set(_vm.invoiceData, "paymentType", $$v)},expression:"invoiceData.paymentType"}}),_vm._v(" "),(
                        _vm.invoiceData.paymentType != 'Cash' &&
                        _vm.invoiceData.paymentType != ''
                      )?_c('v-select',{attrs:{"dense":"","items":_vm.banksByFirms,"label":"Select Bank","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                        "+_vm._s(data.item.account.accountnumber)+"\n                        "+_vm._s(data.item.account.bankName
                            ? " | " + data.item.account.bankName
                            : "")+"\n                      ")]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(
                              ((data.item.account.accountnumber) + "\n                                    " + (data.item.account.bankName
                                        ? ' | ' + data.item.account.bankName
                                        : '') + "\n                                    " + (data.item.account.accountType
                                        ? ' | ' +
                                          data.item.account.accountType
                                        : '') + "\n                                    | ₹: " + ((
                                      data.item.account.amount || 0
                                    ).toLocaleString()))
                            )}})],1)]}}],null,false,1706857889),model:{value:(_vm.invoiceData.bank),callback:function ($$v) {_vm.$set(_vm.invoiceData, "bank", $$v)},expression:"invoiceData.bank"}}):_vm._e(),_vm._v(" "),(
                        _vm.invoiceData.paymentType != 'Cash' &&
                        _vm.invoiceData.paymentType != ''
                      )?_c('v-select',{attrs:{"dense":"","items":[
                        {
                          text: 'Cheque',
                          value: 'Cheque',
                        },
                        {
                          text: 'NEFT',
                          value: 'NEFT',
                        },
                        {
                          text: 'RTGS',
                          value: 'RTGS',
                        },
                        {
                          text: 'IMPS',
                          value: 'IMPS',
                        } ],"label":"Select Transfer type"},on:{"input":function($event){_vm.transferTypeDialog = true}},model:{value:(_vm.invoiceData.transferType),callback:function ($$v) {_vm.$set(_vm.invoiceData, "transferType", $$v)},expression:"invoiceData.transferType"}}):_vm._e(),_vm._v(" "),_c('v-text-field',{attrs:{"type":"number","label":"Remaining Amount ","readonly":"","value":_vm.invoiceData.amountToBePaid,"prefix":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"x1":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-text-field',{attrs:{"type":"number","disabled":_vm.amountFromCashDisabled,"hint":_vm.hintText,"label":"Amount from Cash"},model:{value:(_vm.invoiceData.amountFromCash),callback:function ($$v) {_vm.$set(_vm.invoiceData, "amountFromCash", $$v)},expression:"invoiceData.amountFromCash"}}),_vm._v(" "),_c('v-text-field',{attrs:{"type":"number","hint":_vm.hintText,"disabled":_vm.amountFromBankDisabled,"label":"Amount from Bank"},model:{value:(_vm.invoiceData.amountFromBank),callback:function ($$v) {_vm.$set(_vm.invoiceData, "amountFromBank", $$v)},expression:"invoiceData.amountFromBank"}}),_vm._v(" "),(
                        _vm.invoiceData.status == 'paid'
                          ? Number.parseFloat(_vm.invoiceData.amountToBePaid) != 0
                          : false
                      )?_c('b',{staticClass:"red--text font-weight-bold"},[_vm._v("In Full payment, Paid Amount should be equal to\n                      Remaining Amount")]):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","disabled":!_vm.invoiceData.paymentType ||
                  (_vm.invoiceData.status == 'paid'
                    ? Number.parseFloat(_vm.invoiceData.amountToBePaid) != 0
                    : false),"flat":""},nativeOn:{"click":function($event){_vm.transactionDialog = false}}},[_vm._v("Confirm")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.transferTypeDialog),callback:function ($$v) {_vm.transferTypeDialog=$$v},expression:"transferTypeDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("\n                Transfer Information\n                "),_c('b',[_vm._v(_vm._s(_vm.transferTypeDialog.transferType))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.transferTypeDialog = false}}},[_c('v-icon',[_vm._v("mdi-close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","label":"A/C Number"},model:{value:(_vm.transferDetails.accountNumber),callback:function ($$v) {_vm.$set(_vm.transferDetails, "accountNumber", $$v)},expression:"transferDetails.accountNumber"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"text","label":"A/C Holder Name"},model:{value:(_vm.transferDetails.accountHolderName),callback:function ($$v) {_vm.$set(_vm.transferDetails, "accountHolderName", $$v)},expression:"transferDetails.accountHolderName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"text","label":"Bank Name"},model:{value:(_vm.transferDetails.bankName),callback:function ($$v) {_vm.$set(_vm.transferDetails, "bankName", $$v)},expression:"transferDetails.bankName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"text","label":"IFSC Code"},model:{value:(_vm.transferDetails.IFSCcode),callback:function ($$v) {_vm.$set(_vm.transferDetails, "IFSCcode", $$v)},expression:"transferDetails.IFSCcode"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"text","label":"Remark"},model:{value:(_vm.transferDetails.remark),callback:function ($$v) {_vm.$set(_vm.transferDetails, "remark", $$v)},expression:"transferDetails.remark"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.transferTypeDialog = false}}},[_vm._v("Ok")])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"height":"100%"}},[_c('v-card-title',{staticClass:"primary--text",attrs:{"primary":""}},[_c('h3',{attrs:{"color":"primary"}},[_vm._v("DUE INVOICES")])]),_vm._v(" "),_c('v-list',{attrs:{"one-line":""}},[_c('v-divider'),_vm._v(" "),_vm._l((_vm.invoiceList),function(item,index){return [_c('v-list-tile',{key:index,staticClass:"due-inv-list",attrs:{"avatar":""}},[_c('v-list-tile-avatar',[_c('i',{staticClass:"material-icons"},[_c('b',[_vm._v("₹")])])]),_vm._v(" "),_c('v-list-tile-content',[(!item.isCredited)?_c('v-list-tile-title',[_c('h3',[_c('b',{staticClass:"red--text font-weight-bold"},[_vm._v("\n                        "+_vm._s(_vm._f("amount")(Number.parseFloat(Number.parseFloat(item.totalAmount || 0 | _vm.amount) - Number.parseFloat(item.paidAmount || 0 | _vm.amount)) || 0))+"\n                      ")]),_vm._v(" "),_c('b',{staticClass:"Font-weight-light"},[_vm._v("\n                        ("+_vm._s(_vm._f("amount")(Number.parseFloat(Number.parseFloat(item.totalAmount || 0 | _vm.amount)) || 0))+" ~ "+_vm._s(_vm._f("amount")(Number.parseFloat(Number.parseFloat(item.paidAmount || 0 | _vm.amount)) || 0))+")\n                      ")])])]):_vm._e(),_vm._v(" "),(item.isCredited)?_c('v-list-tile-title',[_c('h3',[_c('b',{staticClass:"red--text font-weight-bold"},[_vm._v("\n                        "+_vm._s(_vm._f("amount")(Number.parseFloat(Number.parseFloat(item.totalAmount || 0 | _vm.amount) - Number.parseFloat(item.paidAmount || 0 | _vm.amount)) || 0))+"\n                      ")]),_vm._v(" "),_c('b',{staticClass:"Font-weight-light"},[_vm._v("\n                        ("+_vm._s(_vm._f("amount")(Number.parseFloat(Number.parseFloat(item.totalAmount || 0 | _vm.amount)) || 0))+" ~ "+_vm._s(_vm._f("amount")(Number.parseFloat(Number.parseFloat(item.paidAmount || 0 | _vm.amount)) || 0))+")\n                      ")])])]):_vm._e(),_vm._v(" "),_c('v-list-tile-sub-title',[_c('h4',{staticClass:"primary--text font-weight-light"},[_vm._v(" "+_vm._s(item['date'])+" ")])])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-data-table',{staticClass:"elevation",attrs:{"items":_vm.invoiceList,"hide-actions":"","row":"","wrap":""}}),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition","scrollable":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Invoice Detail")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('invoice-payment',{attrs:{"isBuyer":_vm.isBuyer,"selectedInvoiceId":_vm.selectedInvoiceId},on:{"close":function($event){_vm.dialog = false},"updateInvoice":_vm.updateInvoice}}),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)],1)],1),_vm._v(" "),_c('v-divider',{key:index+'divider'})]})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BuyerTransactions_vue__ = __webpack_require__(412);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53ff784e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuyerTransactions_vue__ = __webpack_require__(1327);
function injectStyle (ssrContext) {
  __webpack_require__(1249)
  __webpack_require__(1250)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-53ff784e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BuyerTransactions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53ff784e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuyerTransactions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1249 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1250 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(413);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79f77056_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1325);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79f77056_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceScreen_vue__ = __webpack_require__(414);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61119be5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceScreen_vue__ = __webpack_require__(1324);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceScreen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61119be5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceScreen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdateItem_vue__ = __webpack_require__(415);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17c3b309_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateItem_vue__ = __webpack_require__(1323);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UpdateItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17c3b309_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UpdateItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1254 */,
/* 1255 */,
/* 1256 */,
/* 1257 */
/***/ (function(module, exports) {

module.exports = {"100":"Continue","101":"Switching Protocols","102":"Processing","103":"Early Hints","200":"OK","201":"Created","202":"Accepted","203":"Non-Authoritative Information","204":"No Content","205":"Reset Content","206":"Partial Content","207":"Multi-Status","208":"Already Reported","226":"IM Used","300":"Multiple Choices","301":"Moved Permanently","302":"Found","303":"See Other","304":"Not Modified","305":"Use Proxy","306":"(Unused)","307":"Temporary Redirect","308":"Permanent Redirect","400":"Bad Request","401":"Unauthorized","402":"Payment Required","403":"Forbidden","404":"Not Found","405":"Method Not Allowed","406":"Not Acceptable","407":"Proxy Authentication Required","408":"Request Timeout","409":"Conflict","410":"Gone","411":"Length Required","412":"Precondition Failed","413":"Payload Too Large","414":"URI Too Long","415":"Unsupported Media Type","416":"Range Not Satisfiable","417":"Expectation Failed","418":"I'm a teapot","421":"Misdirected Request","422":"Unprocessable Entity","423":"Locked","424":"Failed Dependency","425":"Unordered Collection","426":"Upgrade Required","428":"Precondition Required","429":"Too Many Requests","431":"Request Header Fields Too Large","451":"Unavailable For Legal Reasons","500":"Internal Server Error","501":"Not Implemented","502":"Bad Gateway","503":"Service Unavailable","504":"Gateway Timeout","505":"HTTP Version Not Supported","506":"Variant Also Negotiates","507":"Insufficient Storage","508":"Loop Detected","509":"Bandwidth Limit Exceeded","510":"Not Extended","511":"Network Authentication Required"}

/***/ }),
/* 1258 */,
/* 1259 */,
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */,
/* 1264 */,
/* 1265 */,
/* 1266 */,
/* 1267 */,
/* 1268 */,
/* 1269 */,
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */,
/* 1274 */,
/* 1275 */,
/* 1276 */
/***/ (function(module, exports) {

module.exports = [["0","\u0000",128],["a1","｡",62],["8140","　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈",9,"＋－±×"],["8180","÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇◆□■△▲▽▼※〒→←↑↓〓"],["81b8","∈∋⊆⊇⊂⊃∪∩"],["81c8","∧∨￢⇒⇔∀∃"],["81da","∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬"],["81f0","Å‰♯♭♪†‡¶"],["81fc","◯"],["824f","０",9],["8260","Ａ",25],["8281","ａ",25],["829f","ぁ",82],["8340","ァ",62],["8380","ム",22],["839f","Α",16,"Σ",6],["83bf","α",16,"σ",6],["8440","А",5,"ЁЖ",25],["8470","а",5,"ёж",7],["8480","о",17],["849f","─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂"],["8740","①",19,"Ⅰ",9],["875f","㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡"],["877e","㍻"],["8780","〝〟№㏍℡㊤",4,"㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪"],["889f","亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭"],["8940","院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円"],["8980","園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改"],["8a40","魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫"],["8a80","橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄"],["8b40","機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救"],["8b80","朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈"],["8c40","掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨"],["8c80","劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向"],["8d40","后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降"],["8d80","項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷"],["8e40","察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止"],["8e80","死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周"],["8f40","宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳"],["8f80","準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾"],["9040","拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨"],["9080","逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線"],["9140","繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻"],["9180","操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只"],["9240","叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄"],["9280","逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓"],["9340","邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬"],["9380","凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入"],["9440","如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅"],["9480","楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美"],["9540","鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷"],["9580","斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋"],["9640","法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆"],["9680","摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒"],["9740","諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲"],["9780","沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯"],["9840","蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕"],["989f","弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲"],["9940","僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭"],["9980","凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨"],["9a40","咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸"],["9a80","噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩"],["9b40","奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀"],["9b80","它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏"],["9c40","廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠"],["9c80","怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛"],["9d40","戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫"],["9d80","捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼"],["9e40","曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎"],["9e80","梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣"],["9f40","檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯"],["9f80","麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌"],["e040","漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝"],["e080","烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱"],["e140","瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿"],["e180","痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬"],["e240","磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰"],["e280","窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆"],["e340","紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷"],["e380","縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋"],["e440","隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤"],["e480","艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈"],["e540","蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬"],["e580","蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞"],["e640","襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧"],["e680","諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊"],["e740","蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜"],["e780","轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮"],["e840","錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙"],["e880","閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰"],["e940","顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃"],["e980","騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈"],["ea40","鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯"],["ea80","黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠堯槇遙瑤凜熙"],["ed40","纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏"],["ed80","塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱"],["ee40","犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙"],["ee80","蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑"],["eeef","ⅰ",9,"￢￤＇＂"],["f040","",62],["f080","",124],["f140","",62],["f180","",124],["f240","",62],["f280","",124],["f340","",62],["f380","",124],["f440","",62],["f480","",124],["f540","",62],["f580","",124],["f640","",62],["f680","",124],["f740","",62],["f780","",124],["f840","",62],["f880","",124],["f940",""],["fa40","ⅰ",9,"Ⅰ",9,"￢￤＇＂㈱№℡∵纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊"],["fa80","兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯"],["fb40","涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神"],["fb80","祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙"],["fc40","髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑"]]

/***/ }),
/* 1277 */
/***/ (function(module, exports) {

module.exports = [["0","\u0000",127],["8ea1","｡",62],["a1a1","　、。，．・：；？！゛゜´｀¨＾￣＿ヽヾゝゞ〃仝々〆〇ー―‐／＼～∥｜…‥‘’“”（）〔〕［］｛｝〈",9,"＋－±×÷＝≠＜＞≦≧∞∴♂♀°′″℃￥＄￠￡％＃＆＊＠§☆★○●◎◇"],["a2a1","◆□■△▲▽▼※〒→←↑↓〓"],["a2ba","∈∋⊆⊇⊂⊃∪∩"],["a2ca","∧∨￢⇒⇔∀∃"],["a2dc","∠⊥⌒∂∇≡≒≪≫√∽∝∵∫∬"],["a2f2","Å‰♯♭♪†‡¶"],["a2fe","◯"],["a3b0","０",9],["a3c1","Ａ",25],["a3e1","ａ",25],["a4a1","ぁ",82],["a5a1","ァ",85],["a6a1","Α",16,"Σ",6],["a6c1","α",16,"σ",6],["a7a1","А",5,"ЁЖ",25],["a7d1","а",5,"ёж",25],["a8a1","─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂"],["ada1","①",19,"Ⅰ",9],["adc0","㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻㎜㎝㎞㎎㎏㏄㎡"],["addf","㍻〝〟№㏍℡㊤",4,"㈱㈲㈹㍾㍽㍼≒≡∫∮∑√⊥∠∟⊿∵∩∪"],["b0a1","亜唖娃阿哀愛挨姶逢葵茜穐悪握渥旭葦芦鯵梓圧斡扱宛姐虻飴絢綾鮎或粟袷安庵按暗案闇鞍杏以伊位依偉囲夷委威尉惟意慰易椅為畏異移維緯胃萎衣謂違遺医井亥域育郁磯一壱溢逸稲茨芋鰯允印咽員因姻引飲淫胤蔭"],["b1a1","院陰隠韻吋右宇烏羽迂雨卯鵜窺丑碓臼渦嘘唄欝蔚鰻姥厩浦瓜閏噂云運雲荏餌叡営嬰影映曳栄永泳洩瑛盈穎頴英衛詠鋭液疫益駅悦謁越閲榎厭円園堰奄宴延怨掩援沿演炎焔煙燕猿縁艶苑薗遠鉛鴛塩於汚甥凹央奥往応"],["b2a1","押旺横欧殴王翁襖鴬鴎黄岡沖荻億屋憶臆桶牡乙俺卸恩温穏音下化仮何伽価佳加可嘉夏嫁家寡科暇果架歌河火珂禍禾稼箇花苛茄荷華菓蝦課嘩貨迦過霞蚊俄峨我牙画臥芽蛾賀雅餓駕介会解回塊壊廻快怪悔恢懐戒拐改"],["b3a1","魁晦械海灰界皆絵芥蟹開階貝凱劾外咳害崖慨概涯碍蓋街該鎧骸浬馨蛙垣柿蛎鈎劃嚇各廓拡撹格核殻獲確穫覚角赫較郭閣隔革学岳楽額顎掛笠樫橿梶鰍潟割喝恰括活渇滑葛褐轄且鰹叶椛樺鞄株兜竃蒲釜鎌噛鴨栢茅萱"],["b4a1","粥刈苅瓦乾侃冠寒刊勘勧巻喚堪姦完官寛干幹患感慣憾換敢柑桓棺款歓汗漢澗潅環甘監看竿管簡緩缶翰肝艦莞観諌貫還鑑間閑関陥韓館舘丸含岸巌玩癌眼岩翫贋雁頑顔願企伎危喜器基奇嬉寄岐希幾忌揮机旗既期棋棄"],["b5a1","機帰毅気汽畿祈季稀紀徽規記貴起軌輝飢騎鬼亀偽儀妓宜戯技擬欺犠疑祇義蟻誼議掬菊鞠吉吃喫桔橘詰砧杵黍却客脚虐逆丘久仇休及吸宮弓急救朽求汲泣灸球究窮笈級糾給旧牛去居巨拒拠挙渠虚許距鋸漁禦魚亨享京"],["b6a1","供侠僑兇競共凶協匡卿叫喬境峡強彊怯恐恭挟教橋況狂狭矯胸脅興蕎郷鏡響饗驚仰凝尭暁業局曲極玉桐粁僅勤均巾錦斤欣欽琴禁禽筋緊芹菌衿襟謹近金吟銀九倶句区狗玖矩苦躯駆駈駒具愚虞喰空偶寓遇隅串櫛釧屑屈"],["b7a1","掘窟沓靴轡窪熊隈粂栗繰桑鍬勲君薫訓群軍郡卦袈祁係傾刑兄啓圭珪型契形径恵慶慧憩掲携敬景桂渓畦稽系経継繋罫茎荊蛍計詣警軽頚鶏芸迎鯨劇戟撃激隙桁傑欠決潔穴結血訣月件倹倦健兼券剣喧圏堅嫌建憲懸拳捲"],["b8a1","検権牽犬献研硯絹県肩見謙賢軒遣鍵険顕験鹸元原厳幻弦減源玄現絃舷言諺限乎個古呼固姑孤己庫弧戸故枯湖狐糊袴股胡菰虎誇跨鈷雇顧鼓五互伍午呉吾娯後御悟梧檎瑚碁語誤護醐乞鯉交佼侯候倖光公功効勾厚口向"],["b9a1","后喉坑垢好孔孝宏工巧巷幸広庚康弘恒慌抗拘控攻昂晃更杭校梗構江洪浩港溝甲皇硬稿糠紅紘絞綱耕考肯肱腔膏航荒行衡講貢購郊酵鉱砿鋼閤降項香高鴻剛劫号合壕拷濠豪轟麹克刻告国穀酷鵠黒獄漉腰甑忽惚骨狛込"],["baa1","此頃今困坤墾婚恨懇昏昆根梱混痕紺艮魂些佐叉唆嵯左差査沙瑳砂詐鎖裟坐座挫債催再最哉塞妻宰彩才採栽歳済災采犀砕砦祭斎細菜裁載際剤在材罪財冴坂阪堺榊肴咲崎埼碕鷺作削咋搾昨朔柵窄策索錯桜鮭笹匙冊刷"],["bba1","察拶撮擦札殺薩雑皐鯖捌錆鮫皿晒三傘参山惨撒散桟燦珊産算纂蚕讃賛酸餐斬暫残仕仔伺使刺司史嗣四士始姉姿子屍市師志思指支孜斯施旨枝止死氏獅祉私糸紙紫肢脂至視詞詩試誌諮資賜雌飼歯事似侍児字寺慈持時"],["bca1","次滋治爾璽痔磁示而耳自蒔辞汐鹿式識鴫竺軸宍雫七叱執失嫉室悉湿漆疾質実蔀篠偲柴芝屡蕊縞舎写射捨赦斜煮社紗者謝車遮蛇邪借勺尺杓灼爵酌釈錫若寂弱惹主取守手朱殊狩珠種腫趣酒首儒受呪寿授樹綬需囚収周"],["bda1","宗就州修愁拾洲秀秋終繍習臭舟蒐衆襲讐蹴輯週酋酬集醜什住充十従戎柔汁渋獣縦重銃叔夙宿淑祝縮粛塾熟出術述俊峻春瞬竣舜駿准循旬楯殉淳準潤盾純巡遵醇順処初所暑曙渚庶緒署書薯藷諸助叙女序徐恕鋤除傷償"],["bea1","勝匠升召哨商唱嘗奨妾娼宵将小少尚庄床廠彰承抄招掌捷昇昌昭晶松梢樟樵沼消渉湘焼焦照症省硝礁祥称章笑粧紹肖菖蒋蕉衝裳訟証詔詳象賞醤鉦鍾鐘障鞘上丈丞乗冗剰城場壌嬢常情擾条杖浄状畳穣蒸譲醸錠嘱埴飾"],["bfa1","拭植殖燭織職色触食蝕辱尻伸信侵唇娠寝審心慎振新晋森榛浸深申疹真神秦紳臣芯薪親診身辛進針震人仁刃塵壬尋甚尽腎訊迅陣靭笥諏須酢図厨逗吹垂帥推水炊睡粋翠衰遂酔錐錘随瑞髄崇嵩数枢趨雛据杉椙菅頗雀裾"],["c0a1","澄摺寸世瀬畝是凄制勢姓征性成政整星晴棲栖正清牲生盛精聖声製西誠誓請逝醒青静斉税脆隻席惜戚斥昔析石積籍績脊責赤跡蹟碩切拙接摂折設窃節説雪絶舌蝉仙先千占宣専尖川戦扇撰栓栴泉浅洗染潜煎煽旋穿箭線"],["c1a1","繊羨腺舛船薦詮賎践選遷銭銑閃鮮前善漸然全禅繕膳糎噌塑岨措曾曽楚狙疏疎礎祖租粗素組蘇訴阻遡鼠僧創双叢倉喪壮奏爽宋層匝惣想捜掃挿掻操早曹巣槍槽漕燥争痩相窓糟総綜聡草荘葬蒼藻装走送遭鎗霜騒像増憎"],["c2a1","臓蔵贈造促側則即息捉束測足速俗属賊族続卒袖其揃存孫尊損村遜他多太汰詑唾堕妥惰打柁舵楕陀駄騨体堆対耐岱帯待怠態戴替泰滞胎腿苔袋貸退逮隊黛鯛代台大第醍題鷹滝瀧卓啄宅托択拓沢濯琢託鐸濁諾茸凧蛸只"],["c3a1","叩但達辰奪脱巽竪辿棚谷狸鱈樽誰丹単嘆坦担探旦歎淡湛炭短端箪綻耽胆蛋誕鍛団壇弾断暖檀段男談値知地弛恥智池痴稚置致蜘遅馳築畜竹筑蓄逐秩窒茶嫡着中仲宙忠抽昼柱注虫衷註酎鋳駐樗瀦猪苧著貯丁兆凋喋寵"],["c4a1","帖帳庁弔張彫徴懲挑暢朝潮牒町眺聴脹腸蝶調諜超跳銚長頂鳥勅捗直朕沈珍賃鎮陳津墜椎槌追鎚痛通塚栂掴槻佃漬柘辻蔦綴鍔椿潰坪壷嬬紬爪吊釣鶴亭低停偵剃貞呈堤定帝底庭廷弟悌抵挺提梯汀碇禎程締艇訂諦蹄逓"],["c5a1","邸鄭釘鼎泥摘擢敵滴的笛適鏑溺哲徹撤轍迭鉄典填天展店添纏甜貼転顛点伝殿澱田電兎吐堵塗妬屠徒斗杜渡登菟賭途都鍍砥砺努度土奴怒倒党冬凍刀唐塔塘套宕島嶋悼投搭東桃梼棟盗淘湯涛灯燈当痘祷等答筒糖統到"],["c6a1","董蕩藤討謄豆踏逃透鐙陶頭騰闘働動同堂導憧撞洞瞳童胴萄道銅峠鴇匿得徳涜特督禿篤毒独読栃橡凸突椴届鳶苫寅酉瀞噸屯惇敦沌豚遁頓呑曇鈍奈那内乍凪薙謎灘捺鍋楢馴縄畷南楠軟難汝二尼弐迩匂賑肉虹廿日乳入"],["c7a1","如尿韮任妊忍認濡禰祢寧葱猫熱年念捻撚燃粘乃廼之埜嚢悩濃納能脳膿農覗蚤巴把播覇杷波派琶破婆罵芭馬俳廃拝排敗杯盃牌背肺輩配倍培媒梅楳煤狽買売賠陪這蝿秤矧萩伯剥博拍柏泊白箔粕舶薄迫曝漠爆縛莫駁麦"],["c8a1","函箱硲箸肇筈櫨幡肌畑畠八鉢溌発醗髪伐罰抜筏閥鳩噺塙蛤隼伴判半反叛帆搬斑板氾汎版犯班畔繁般藩販範釆煩頒飯挽晩番盤磐蕃蛮匪卑否妃庇彼悲扉批披斐比泌疲皮碑秘緋罷肥被誹費避非飛樋簸備尾微枇毘琵眉美"],["c9a1","鼻柊稗匹疋髭彦膝菱肘弼必畢筆逼桧姫媛紐百謬俵彪標氷漂瓢票表評豹廟描病秒苗錨鋲蒜蛭鰭品彬斌浜瀕貧賓頻敏瓶不付埠夫婦富冨布府怖扶敷斧普浮父符腐膚芙譜負賦赴阜附侮撫武舞葡蕪部封楓風葺蕗伏副復幅服"],["caa1","福腹複覆淵弗払沸仏物鮒分吻噴墳憤扮焚奮粉糞紛雰文聞丙併兵塀幣平弊柄並蔽閉陛米頁僻壁癖碧別瞥蔑箆偏変片篇編辺返遍便勉娩弁鞭保舗鋪圃捕歩甫補輔穂募墓慕戊暮母簿菩倣俸包呆報奉宝峰峯崩庖抱捧放方朋"],["cba1","法泡烹砲縫胞芳萌蓬蜂褒訪豊邦鋒飽鳳鵬乏亡傍剖坊妨帽忘忙房暴望某棒冒紡肪膨謀貌貿鉾防吠頬北僕卜墨撲朴牧睦穆釦勃没殆堀幌奔本翻凡盆摩磨魔麻埋妹昧枚毎哩槙幕膜枕鮪柾鱒桝亦俣又抹末沫迄侭繭麿万慢満"],["cca1","漫蔓味未魅巳箕岬密蜜湊蓑稔脈妙粍民眠務夢無牟矛霧鵡椋婿娘冥名命明盟迷銘鳴姪牝滅免棉綿緬面麺摸模茂妄孟毛猛盲網耗蒙儲木黙目杢勿餅尤戻籾貰問悶紋門匁也冶夜爺耶野弥矢厄役約薬訳躍靖柳薮鑓愉愈油癒"],["cda1","諭輸唯佑優勇友宥幽悠憂揖有柚湧涌猶猷由祐裕誘遊邑郵雄融夕予余与誉輿預傭幼妖容庸揚揺擁曜楊様洋溶熔用窯羊耀葉蓉要謡踊遥陽養慾抑欲沃浴翌翼淀羅螺裸来莱頼雷洛絡落酪乱卵嵐欄濫藍蘭覧利吏履李梨理璃"],["cea1","痢裏裡里離陸律率立葎掠略劉流溜琉留硫粒隆竜龍侶慮旅虜了亮僚両凌寮料梁涼猟療瞭稜糧良諒遼量陵領力緑倫厘林淋燐琳臨輪隣鱗麟瑠塁涙累類令伶例冷励嶺怜玲礼苓鈴隷零霊麗齢暦歴列劣烈裂廉恋憐漣煉簾練聯"],["cfa1","蓮連錬呂魯櫓炉賂路露労婁廊弄朗楼榔浪漏牢狼篭老聾蝋郎六麓禄肋録論倭和話歪賄脇惑枠鷲亙亘鰐詫藁蕨椀湾碗腕"],["d0a1","弌丐丕个丱丶丼丿乂乖乘亂亅豫亊舒弍于亞亟亠亢亰亳亶从仍仄仆仂仗仞仭仟价伉佚估佛佝佗佇佶侈侏侘佻佩佰侑佯來侖儘俔俟俎俘俛俑俚俐俤俥倚倨倔倪倥倅伜俶倡倩倬俾俯們倆偃假會偕偐偈做偖偬偸傀傚傅傴傲"],["d1a1","僉僊傳僂僖僞僥僭僣僮價僵儉儁儂儖儕儔儚儡儺儷儼儻儿兀兒兌兔兢竸兩兪兮冀冂囘册冉冏冑冓冕冖冤冦冢冩冪冫决冱冲冰况冽凅凉凛几處凩凭凰凵凾刄刋刔刎刧刪刮刳刹剏剄剋剌剞剔剪剴剩剳剿剽劍劔劒剱劈劑辨"],["d2a1","辧劬劭劼劵勁勍勗勞勣勦飭勠勳勵勸勹匆匈甸匍匐匏匕匚匣匯匱匳匸區卆卅丗卉卍凖卞卩卮夘卻卷厂厖厠厦厥厮厰厶參簒雙叟曼燮叮叨叭叺吁吽呀听吭吼吮吶吩吝呎咏呵咎呟呱呷呰咒呻咀呶咄咐咆哇咢咸咥咬哄哈咨"],["d3a1","咫哂咤咾咼哘哥哦唏唔哽哮哭哺哢唹啀啣啌售啜啅啖啗唸唳啝喙喀咯喊喟啻啾喘喞單啼喃喩喇喨嗚嗅嗟嗄嗜嗤嗔嘔嗷嘖嗾嗽嘛嗹噎噐營嘴嘶嘲嘸噫噤嘯噬噪嚆嚀嚊嚠嚔嚏嚥嚮嚶嚴囂嚼囁囃囀囈囎囑囓囗囮囹圀囿圄圉"],["d4a1","圈國圍圓團圖嗇圜圦圷圸坎圻址坏坩埀垈坡坿垉垓垠垳垤垪垰埃埆埔埒埓堊埖埣堋堙堝塲堡塢塋塰毀塒堽塹墅墹墟墫墺壞墻墸墮壅壓壑壗壙壘壥壜壤壟壯壺壹壻壼壽夂夊夐夛梦夥夬夭夲夸夾竒奕奐奎奚奘奢奠奧奬奩"],["d5a1","奸妁妝佞侫妣妲姆姨姜妍姙姚娥娟娑娜娉娚婀婬婉娵娶婢婪媚媼媾嫋嫂媽嫣嫗嫦嫩嫖嫺嫻嬌嬋嬖嬲嫐嬪嬶嬾孃孅孀孑孕孚孛孥孩孰孳孵學斈孺宀它宦宸寃寇寉寔寐寤實寢寞寥寫寰寶寳尅將專對尓尠尢尨尸尹屁屆屎屓"],["d6a1","屐屏孱屬屮乢屶屹岌岑岔妛岫岻岶岼岷峅岾峇峙峩峽峺峭嶌峪崋崕崗嵜崟崛崑崔崢崚崙崘嵌嵒嵎嵋嵬嵳嵶嶇嶄嶂嶢嶝嶬嶮嶽嶐嶷嶼巉巍巓巒巖巛巫已巵帋帚帙帑帛帶帷幄幃幀幎幗幔幟幢幤幇幵并幺麼广庠廁廂廈廐廏"],["d7a1","廖廣廝廚廛廢廡廨廩廬廱廳廰廴廸廾弃弉彝彜弋弑弖弩弭弸彁彈彌彎弯彑彖彗彙彡彭彳彷徃徂彿徊很徑徇從徙徘徠徨徭徼忖忻忤忸忱忝悳忿怡恠怙怐怩怎怱怛怕怫怦怏怺恚恁恪恷恟恊恆恍恣恃恤恂恬恫恙悁悍惧悃悚"],["d8a1","悄悛悖悗悒悧悋惡悸惠惓悴忰悽惆悵惘慍愕愆惶惷愀惴惺愃愡惻惱愍愎慇愾愨愧慊愿愼愬愴愽慂慄慳慷慘慙慚慫慴慯慥慱慟慝慓慵憙憖憇憬憔憚憊憑憫憮懌懊應懷懈懃懆憺懋罹懍懦懣懶懺懴懿懽懼懾戀戈戉戍戌戔戛"],["d9a1","戞戡截戮戰戲戳扁扎扞扣扛扠扨扼抂抉找抒抓抖拔抃抔拗拑抻拏拿拆擔拈拜拌拊拂拇抛拉挌拮拱挧挂挈拯拵捐挾捍搜捏掖掎掀掫捶掣掏掉掟掵捫捩掾揩揀揆揣揉插揶揄搖搴搆搓搦搶攝搗搨搏摧摯摶摎攪撕撓撥撩撈撼"],["daa1","據擒擅擇撻擘擂擱擧舉擠擡抬擣擯攬擶擴擲擺攀擽攘攜攅攤攣攫攴攵攷收攸畋效敖敕敍敘敞敝敲數斂斃變斛斟斫斷旃旆旁旄旌旒旛旙无旡旱杲昊昃旻杳昵昶昴昜晏晄晉晁晞晝晤晧晨晟晢晰暃暈暎暉暄暘暝曁暹曉暾暼"],["dba1","曄暸曖曚曠昿曦曩曰曵曷朏朖朞朦朧霸朮朿朶杁朸朷杆杞杠杙杣杤枉杰枩杼杪枌枋枦枡枅枷柯枴柬枳柩枸柤柞柝柢柮枹柎柆柧檜栞框栩桀桍栲桎梳栫桙档桷桿梟梏梭梔條梛梃檮梹桴梵梠梺椏梍桾椁棊椈棘椢椦棡椌棍"],["dca1","棔棧棕椶椒椄棗棣椥棹棠棯椨椪椚椣椡棆楹楷楜楸楫楔楾楮椹楴椽楙椰楡楞楝榁楪榲榮槐榿槁槓榾槎寨槊槝榻槃榧樮榑榠榜榕榴槞槨樂樛槿權槹槲槧樅榱樞槭樔槫樊樒櫁樣樓橄樌橲樶橸橇橢橙橦橈樸樢檐檍檠檄檢檣"],["dda1","檗蘗檻櫃櫂檸檳檬櫞櫑櫟檪櫚櫪櫻欅蘖櫺欒欖鬱欟欸欷盜欹飮歇歃歉歐歙歔歛歟歡歸歹歿殀殄殃殍殘殕殞殤殪殫殯殲殱殳殷殼毆毋毓毟毬毫毳毯麾氈氓气氛氤氣汞汕汢汪沂沍沚沁沛汾汨汳沒沐泄泱泓沽泗泅泝沮沱沾"],["dea1","沺泛泯泙泪洟衍洶洫洽洸洙洵洳洒洌浣涓浤浚浹浙涎涕濤涅淹渕渊涵淇淦涸淆淬淞淌淨淒淅淺淙淤淕淪淮渭湮渮渙湲湟渾渣湫渫湶湍渟湃渺湎渤滿渝游溂溪溘滉溷滓溽溯滄溲滔滕溏溥滂溟潁漑灌滬滸滾漿滲漱滯漲滌"],["dfa1","漾漓滷澆潺潸澁澀潯潛濳潭澂潼潘澎澑濂潦澳澣澡澤澹濆澪濟濕濬濔濘濱濮濛瀉瀋濺瀑瀁瀏濾瀛瀚潴瀝瀘瀟瀰瀾瀲灑灣炙炒炯烱炬炸炳炮烟烋烝烙焉烽焜焙煥煕熈煦煢煌煖煬熏燻熄熕熨熬燗熹熾燒燉燔燎燠燬燧燵燼"],["e0a1","燹燿爍爐爛爨爭爬爰爲爻爼爿牀牆牋牘牴牾犂犁犇犒犖犢犧犹犲狃狆狄狎狒狢狠狡狹狷倏猗猊猜猖猝猴猯猩猥猾獎獏默獗獪獨獰獸獵獻獺珈玳珎玻珀珥珮珞璢琅瑯琥珸琲琺瑕琿瑟瑙瑁瑜瑩瑰瑣瑪瑶瑾璋璞璧瓊瓏瓔珱"],["e1a1","瓠瓣瓧瓩瓮瓲瓰瓱瓸瓷甄甃甅甌甎甍甕甓甞甦甬甼畄畍畊畉畛畆畚畩畤畧畫畭畸當疆疇畴疊疉疂疔疚疝疥疣痂疳痃疵疽疸疼疱痍痊痒痙痣痞痾痿痼瘁痰痺痲痳瘋瘍瘉瘟瘧瘠瘡瘢瘤瘴瘰瘻癇癈癆癜癘癡癢癨癩癪癧癬癰"],["e2a1","癲癶癸發皀皃皈皋皎皖皓皙皚皰皴皸皹皺盂盍盖盒盞盡盥盧盪蘯盻眈眇眄眩眤眞眥眦眛眷眸睇睚睨睫睛睥睿睾睹瞎瞋瞑瞠瞞瞰瞶瞹瞿瞼瞽瞻矇矍矗矚矜矣矮矼砌砒礦砠礪硅碎硴碆硼碚碌碣碵碪碯磑磆磋磔碾碼磅磊磬"],["e3a1","磧磚磽磴礇礒礑礙礬礫祀祠祗祟祚祕祓祺祿禊禝禧齋禪禮禳禹禺秉秕秧秬秡秣稈稍稘稙稠稟禀稱稻稾稷穃穗穉穡穢穩龝穰穹穽窈窗窕窘窖窩竈窰窶竅竄窿邃竇竊竍竏竕竓站竚竝竡竢竦竭竰笂笏笊笆笳笘笙笞笵笨笶筐"],["e4a1","筺笄筍笋筌筅筵筥筴筧筰筱筬筮箝箘箟箍箜箚箋箒箏筝箙篋篁篌篏箴篆篝篩簑簔篦篥籠簀簇簓篳篷簗簍篶簣簧簪簟簷簫簽籌籃籔籏籀籐籘籟籤籖籥籬籵粃粐粤粭粢粫粡粨粳粲粱粮粹粽糀糅糂糘糒糜糢鬻糯糲糴糶糺紆"],["e5a1","紂紜紕紊絅絋紮紲紿紵絆絳絖絎絲絨絮絏絣經綉絛綏絽綛綺綮綣綵緇綽綫總綢綯緜綸綟綰緘緝緤緞緻緲緡縅縊縣縡縒縱縟縉縋縢繆繦縻縵縹繃縷縲縺繧繝繖繞繙繚繹繪繩繼繻纃緕繽辮繿纈纉續纒纐纓纔纖纎纛纜缸缺"],["e6a1","罅罌罍罎罐网罕罔罘罟罠罨罩罧罸羂羆羃羈羇羌羔羞羝羚羣羯羲羹羮羶羸譱翅翆翊翕翔翡翦翩翳翹飜耆耄耋耒耘耙耜耡耨耿耻聊聆聒聘聚聟聢聨聳聲聰聶聹聽聿肄肆肅肛肓肚肭冐肬胛胥胙胝胄胚胖脉胯胱脛脩脣脯腋"],["e7a1","隋腆脾腓腑胼腱腮腥腦腴膃膈膊膀膂膠膕膤膣腟膓膩膰膵膾膸膽臀臂膺臉臍臑臙臘臈臚臟臠臧臺臻臾舁舂舅與舊舍舐舖舩舫舸舳艀艙艘艝艚艟艤艢艨艪艫舮艱艷艸艾芍芒芫芟芻芬苡苣苟苒苴苳苺莓范苻苹苞茆苜茉苙"],["e8a1","茵茴茖茲茱荀茹荐荅茯茫茗茘莅莚莪莟莢莖茣莎莇莊荼莵荳荵莠莉莨菴萓菫菎菽萃菘萋菁菷萇菠菲萍萢萠莽萸蔆菻葭萪萼蕚蒄葷葫蒭葮蒂葩葆萬葯葹萵蓊葢蒹蒿蒟蓙蓍蒻蓚蓐蓁蓆蓖蒡蔡蓿蓴蔗蔘蔬蔟蔕蔔蓼蕀蕣蕘蕈"],["e9a1","蕁蘂蕋蕕薀薤薈薑薊薨蕭薔薛藪薇薜蕷蕾薐藉薺藏薹藐藕藝藥藜藹蘊蘓蘋藾藺蘆蘢蘚蘰蘿虍乕虔號虧虱蚓蚣蚩蚪蚋蚌蚶蚯蛄蛆蚰蛉蠣蚫蛔蛞蛩蛬蛟蛛蛯蜒蜆蜈蜀蜃蛻蜑蜉蜍蛹蜊蜴蜿蜷蜻蜥蜩蜚蝠蝟蝸蝌蝎蝴蝗蝨蝮蝙"],["eaa1","蝓蝣蝪蠅螢螟螂螯蟋螽蟀蟐雖螫蟄螳蟇蟆螻蟯蟲蟠蠏蠍蟾蟶蟷蠎蟒蠑蠖蠕蠢蠡蠱蠶蠹蠧蠻衄衂衒衙衞衢衫袁衾袞衵衽袵衲袂袗袒袮袙袢袍袤袰袿袱裃裄裔裘裙裝裹褂裼裴裨裲褄褌褊褓襃褞褥褪褫襁襄褻褶褸襌褝襠襞"],["eba1","襦襤襭襪襯襴襷襾覃覈覊覓覘覡覩覦覬覯覲覺覽覿觀觚觜觝觧觴觸訃訖訐訌訛訝訥訶詁詛詒詆詈詼詭詬詢誅誂誄誨誡誑誥誦誚誣諄諍諂諚諫諳諧諤諱謔諠諢諷諞諛謌謇謚諡謖謐謗謠謳鞫謦謫謾謨譁譌譏譎證譖譛譚譫"],["eca1","譟譬譯譴譽讀讌讎讒讓讖讙讚谺豁谿豈豌豎豐豕豢豬豸豺貂貉貅貊貍貎貔豼貘戝貭貪貽貲貳貮貶賈賁賤賣賚賽賺賻贄贅贊贇贏贍贐齎贓賍贔贖赧赭赱赳趁趙跂趾趺跏跚跖跌跛跋跪跫跟跣跼踈踉跿踝踞踐踟蹂踵踰踴蹊"],["eda1","蹇蹉蹌蹐蹈蹙蹤蹠踪蹣蹕蹶蹲蹼躁躇躅躄躋躊躓躑躔躙躪躡躬躰軆躱躾軅軈軋軛軣軼軻軫軾輊輅輕輒輙輓輜輟輛輌輦輳輻輹轅轂輾轌轉轆轎轗轜轢轣轤辜辟辣辭辯辷迚迥迢迪迯邇迴逅迹迺逑逕逡逍逞逖逋逧逶逵逹迸"],["eea1","遏遐遑遒逎遉逾遖遘遞遨遯遶隨遲邂遽邁邀邊邉邏邨邯邱邵郢郤扈郛鄂鄒鄙鄲鄰酊酖酘酣酥酩酳酲醋醉醂醢醫醯醪醵醴醺釀釁釉釋釐釖釟釡釛釼釵釶鈞釿鈔鈬鈕鈑鉞鉗鉅鉉鉤鉈銕鈿鉋鉐銜銖銓銛鉚鋏銹銷鋩錏鋺鍄錮"],["efa1","錙錢錚錣錺錵錻鍜鍠鍼鍮鍖鎰鎬鎭鎔鎹鏖鏗鏨鏥鏘鏃鏝鏐鏈鏤鐚鐔鐓鐃鐇鐐鐶鐫鐵鐡鐺鑁鑒鑄鑛鑠鑢鑞鑪鈩鑰鑵鑷鑽鑚鑼鑾钁鑿閂閇閊閔閖閘閙閠閨閧閭閼閻閹閾闊濶闃闍闌闕闔闖關闡闥闢阡阨阮阯陂陌陏陋陷陜陞"],["f0a1","陝陟陦陲陬隍隘隕隗險隧隱隲隰隴隶隸隹雎雋雉雍襍雜霍雕雹霄霆霈霓霎霑霏霖霙霤霪霰霹霽霾靄靆靈靂靉靜靠靤靦靨勒靫靱靹鞅靼鞁靺鞆鞋鞏鞐鞜鞨鞦鞣鞳鞴韃韆韈韋韜韭齏韲竟韶韵頏頌頸頤頡頷頽顆顏顋顫顯顰"],["f1a1","顱顴顳颪颯颱颶飄飃飆飩飫餃餉餒餔餘餡餝餞餤餠餬餮餽餾饂饉饅饐饋饑饒饌饕馗馘馥馭馮馼駟駛駝駘駑駭駮駱駲駻駸騁騏騅駢騙騫騷驅驂驀驃騾驕驍驛驗驟驢驥驤驩驫驪骭骰骼髀髏髑髓體髞髟髢髣髦髯髫髮髴髱髷"],["f2a1","髻鬆鬘鬚鬟鬢鬣鬥鬧鬨鬩鬪鬮鬯鬲魄魃魏魍魎魑魘魴鮓鮃鮑鮖鮗鮟鮠鮨鮴鯀鯊鮹鯆鯏鯑鯒鯣鯢鯤鯔鯡鰺鯲鯱鯰鰕鰔鰉鰓鰌鰆鰈鰒鰊鰄鰮鰛鰥鰤鰡鰰鱇鰲鱆鰾鱚鱠鱧鱶鱸鳧鳬鳰鴉鴈鳫鴃鴆鴪鴦鶯鴣鴟鵄鴕鴒鵁鴿鴾鵆鵈"],["f3a1","鵝鵞鵤鵑鵐鵙鵲鶉鶇鶫鵯鵺鶚鶤鶩鶲鷄鷁鶻鶸鶺鷆鷏鷂鷙鷓鷸鷦鷭鷯鷽鸚鸛鸞鹵鹹鹽麁麈麋麌麒麕麑麝麥麩麸麪麭靡黌黎黏黐黔黜點黝黠黥黨黯黴黶黷黹黻黼黽鼇鼈皷鼕鼡鼬鼾齊齒齔齣齟齠齡齦齧齬齪齷齲齶龕龜龠"],["f4a1","堯槇遙瑤凜熙"],["f9a1","纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勀勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏塚增墲夋奓奛奝奣妤妺孖寀甯寘寬尞岦岺峵崧嵓﨑嵂嵭嶸嶹巐弡弴彧德"],["faa1","忞恝悅悊惞惕愠惲愑愷愰憘戓抦揵摠撝擎敎昀昕昻昉昮昞昤晥晗晙晴晳暙暠暲暿曺朎朗杦枻桒柀栁桄棏﨓楨﨔榘槢樰橫橆橳橾櫢櫤毖氿汜沆汯泚洄涇浯涖涬淏淸淲淼渹湜渧渼溿澈澵濵瀅瀇瀨炅炫焏焄煜煆煇凞燁燾犱"],["fba1","犾猤猪獷玽珉珖珣珒琇珵琦琪琩琮瑢璉璟甁畯皂皜皞皛皦益睆劯砡硎硤硺礰礼神祥禔福禛竑竧靖竫箞精絈絜綷綠緖繒罇羡羽茁荢荿菇菶葈蒴蕓蕙蕫﨟薰蘒﨡蠇裵訒訷詹誧誾諟諸諶譓譿賰賴贒赶﨣軏﨤逸遧郞都鄕鄧釚"],["fca1","釗釞釭釮釤釥鈆鈐鈊鈺鉀鈼鉎鉙鉑鈹鉧銧鉷鉸鋧鋗鋙鋐﨧鋕鋠鋓錥錡鋻﨨錞鋿錝錂鍰鍗鎤鏆鏞鏸鐱鑅鑈閒隆﨩隝隯霳霻靃靍靏靑靕顗顥飯飼餧館馞驎髙髜魵魲鮏鮱鮻鰀鵰鵫鶴鸙黑"],["fcf1","ⅰ",9,"￢￤＇＂"],["8fa2af","˘ˇ¸˙˝¯˛˚～΄΅"],["8fa2c2","¡¦¿"],["8fa2eb","ºª©®™¤№"],["8fa6e1","ΆΈΉΊΪ"],["8fa6e7","Ό"],["8fa6e9","ΎΫ"],["8fa6ec","Ώ"],["8fa6f1","άέήίϊΐόςύϋΰώ"],["8fa7c2","Ђ",10,"ЎЏ"],["8fa7f2","ђ",10,"ўџ"],["8fa9a1","ÆĐ"],["8fa9a4","Ħ"],["8fa9a6","Ĳ"],["8fa9a8","ŁĿ"],["8fa9ab","ŊØŒ"],["8fa9af","ŦÞ"],["8fa9c1","æđðħıĳĸłŀŉŋøœßŧþ"],["8faaa1","ÁÀÄÂĂǍĀĄÅÃĆĈČÇĊĎÉÈËÊĚĖĒĘ"],["8faaba","ĜĞĢĠĤÍÌÏÎǏİĪĮĨĴĶĹĽĻŃŇŅÑÓÒÖÔǑŐŌÕŔŘŖŚŜŠŞŤŢÚÙÜÛŬǓŰŪŲŮŨǗǛǙǕŴÝŸŶŹŽŻ"],["8faba1","áàäâăǎāąåãćĉčçċďéèëêěėēęǵĝğ"],["8fabbd","ġĥíìïîǐ"],["8fabc5","īįĩĵķĺľļńňņñóòöôǒőōõŕřŗśŝšşťţúùüûŭǔűūųůũǘǜǚǖŵýÿŷźžż"],["8fb0a1","丂丄丅丌丒丟丣两丨丫丮丯丰丵乀乁乄乇乑乚乜乣乨乩乴乵乹乿亍亖亗亝亯亹仃仐仚仛仠仡仢仨仯仱仳仵份仾仿伀伂伃伈伋伌伒伕伖众伙伮伱你伳伵伷伹伻伾佀佂佈佉佋佌佒佔佖佘佟佣佪佬佮佱佷佸佹佺佽佾侁侂侄"],["8fb1a1","侅侉侊侌侎侐侒侓侔侗侙侚侞侟侲侷侹侻侼侽侾俀俁俅俆俈俉俋俌俍俏俒俜俠俢俰俲俼俽俿倀倁倄倇倊倌倎倐倓倗倘倛倜倝倞倢倧倮倰倲倳倵偀偁偂偅偆偊偌偎偑偒偓偗偙偟偠偢偣偦偧偪偭偰偱倻傁傃傄傆傊傎傏傐"],["8fb2a1","傒傓傔傖傛傜傞",4,"傪傯傰傹傺傽僀僃僄僇僌僎僐僓僔僘僜僝僟僢僤僦僨僩僯僱僶僺僾儃儆儇儈儋儌儍儎僲儐儗儙儛儜儝儞儣儧儨儬儭儯儱儳儴儵儸儹兂兊兏兓兕兗兘兟兤兦兾冃冄冋冎冘冝冡冣冭冸冺冼冾冿凂"],["8fb3a1","凈减凑凒凓凕凘凞凢凥凮凲凳凴凷刁刂刅划刓刕刖刘刢刨刱刲刵刼剅剉剕剗剘剚剜剟剠剡剦剮剷剸剹劀劂劅劊劌劓劕劖劗劘劚劜劤劥劦劧劯劰劶劷劸劺劻劽勀勄勆勈勌勏勑勔勖勛勜勡勥勨勩勪勬勰勱勴勶勷匀匃匊匋"],["8fb4a1","匌匑匓匘匛匜匞匟匥匧匨匩匫匬匭匰匲匵匼匽匾卂卌卋卙卛卡卣卥卬卭卲卹卾厃厇厈厎厓厔厙厝厡厤厪厫厯厲厴厵厷厸厺厽叀叅叏叒叓叕叚叝叞叠另叧叵吂吓吚吡吧吨吪启吱吴吵呃呄呇呍呏呞呢呤呦呧呩呫呭呮呴呿"],["8fb5a1","咁咃咅咈咉咍咑咕咖咜咟咡咦咧咩咪咭咮咱咷咹咺咻咿哆哊响哎哠哪哬哯哶哼哾哿唀唁唅唈唉唌唍唎唕唪唫唲唵唶唻唼唽啁啇啉啊啍啐啑啘啚啛啞啠啡啤啦啿喁喂喆喈喎喏喑喒喓喔喗喣喤喭喲喿嗁嗃嗆嗉嗋嗌嗎嗑嗒"],["8fb6a1","嗓嗗嗘嗛嗞嗢嗩嗶嗿嘅嘈嘊嘍",5,"嘙嘬嘰嘳嘵嘷嘹嘻嘼嘽嘿噀噁噃噄噆噉噋噍噏噔噞噠噡噢噣噦噩噭噯噱噲噵嚄嚅嚈嚋嚌嚕嚙嚚嚝嚞嚟嚦嚧嚨嚩嚫嚬嚭嚱嚳嚷嚾囅囉囊囋囏囐囌囍囙囜囝囟囡囤",4,"囱囫园"],["8fb7a1","囶囷圁圂圇圊圌圑圕圚圛圝圠圢圣圤圥圩圪圬圮圯圳圴圽圾圿坅坆坌坍坒坢坥坧坨坫坭",4,"坳坴坵坷坹坺坻坼坾垁垃垌垔垗垙垚垜垝垞垟垡垕垧垨垩垬垸垽埇埈埌埏埕埝埞埤埦埧埩埭埰埵埶埸埽埾埿堃堄堈堉埡"],["8fb8a1","堌堍堛堞堟堠堦堧堭堲堹堿塉塌塍塏塐塕塟塡塤塧塨塸塼塿墀墁墇墈墉墊墌墍墏墐墔墖墝墠墡墢墦墩墱墲壄墼壂壈壍壎壐壒壔壖壚壝壡壢壩壳夅夆夋夌夒夓夔虁夝夡夣夤夨夯夰夳夵夶夿奃奆奒奓奙奛奝奞奟奡奣奫奭"],["8fb9a1","奯奲奵奶她奻奼妋妌妎妒妕妗妟妤妧妭妮妯妰妳妷妺妼姁姃姄姈姊姍姒姝姞姟姣姤姧姮姯姱姲姴姷娀娄娌娍娎娒娓娞娣娤娧娨娪娭娰婄婅婇婈婌婐婕婞婣婥婧婭婷婺婻婾媋媐媓媖媙媜媞媟媠媢媧媬媱媲媳媵媸媺媻媿"],["8fbaa1","嫄嫆嫈嫏嫚嫜嫠嫥嫪嫮嫵嫶嫽嬀嬁嬈嬗嬴嬙嬛嬝嬡嬥嬭嬸孁孋孌孒孖孞孨孮孯孼孽孾孿宁宄宆宊宎宐宑宓宔宖宨宩宬宭宯宱宲宷宺宼寀寁寍寏寖",4,"寠寯寱寴寽尌尗尞尟尣尦尩尫尬尮尰尲尵尶屙屚屜屢屣屧屨屩"],["8fbba1","屭屰屴屵屺屻屼屽岇岈岊岏岒岝岟岠岢岣岦岪岲岴岵岺峉峋峒峝峗峮峱峲峴崁崆崍崒崫崣崤崦崧崱崴崹崽崿嵂嵃嵆嵈嵕嵑嵙嵊嵟嵠嵡嵢嵤嵪嵭嵰嵹嵺嵾嵿嶁嶃嶈嶊嶒嶓嶔嶕嶙嶛嶟嶠嶧嶫嶰嶴嶸嶹巃巇巋巐巎巘巙巠巤"],["8fbca1","巩巸巹帀帇帍帒帔帕帘帟帠帮帨帲帵帾幋幐幉幑幖幘幛幜幞幨幪",4,"幰庀庋庎庢庤庥庨庪庬庱庳庽庾庿廆廌廋廎廑廒廔廕廜廞廥廫异弆弇弈弎弙弜弝弡弢弣弤弨弫弬弮弰弴弶弻弽弿彀彄彅彇彍彐彔彘彛彠彣彤彧"],["8fbda1","彯彲彴彵彸彺彽彾徉徍徏徖徜徝徢徧徫徤徬徯徰徱徸忄忇忈忉忋忐",4,"忞忡忢忨忩忪忬忭忮忯忲忳忶忺忼怇怊怍怓怔怗怘怚怟怤怭怳怵恀恇恈恉恌恑恔恖恗恝恡恧恱恾恿悂悆悈悊悎悑悓悕悘悝悞悢悤悥您悰悱悷"],["8fbea1","悻悾惂惄惈惉惊惋惎惏惔惕惙惛惝惞惢惥惲惵惸惼惽愂愇愊愌愐",4,"愖愗愙愜愞愢愪愫愰愱愵愶愷愹慁慅慆慉慞慠慬慲慸慻慼慿憀憁憃憄憋憍憒憓憗憘憜憝憟憠憥憨憪憭憸憹憼懀懁懂懎懏懕懜懝懞懟懡懢懧懩懥"],["8fbfa1","懬懭懯戁戃戄戇戓戕戜戠戢戣戧戩戫戹戽扂扃扄扆扌扐扑扒扔扖扚扜扤扭扯扳扺扽抍抎抏抐抦抨抳抶抷抺抾抿拄拎拕拖拚拪拲拴拼拽挃挄挊挋挍挐挓挖挘挩挪挭挵挶挹挼捁捂捃捄捆捊捋捎捒捓捔捘捛捥捦捬捭捱捴捵"],["8fc0a1","捸捼捽捿掂掄掇掊掐掔掕掙掚掞掤掦掭掮掯掽揁揅揈揎揑揓揔揕揜揠揥揪揬揲揳揵揸揹搉搊搐搒搔搘搞搠搢搤搥搩搪搯搰搵搽搿摋摏摑摒摓摔摚摛摜摝摟摠摡摣摭摳摴摻摽撅撇撏撐撑撘撙撛撝撟撡撣撦撨撬撳撽撾撿"],["8fc1a1","擄擉擊擋擌擎擐擑擕擗擤擥擩擪擭擰擵擷擻擿攁攄攈攉攊攏攓攔攖攙攛攞攟攢攦攩攮攱攺攼攽敃敇敉敐敒敔敟敠敧敫敺敽斁斅斊斒斕斘斝斠斣斦斮斲斳斴斿旂旈旉旎旐旔旖旘旟旰旲旴旵旹旾旿昀昄昈昉昍昑昒昕昖昝"],["8fc2a1","昞昡昢昣昤昦昩昪昫昬昮昰昱昳昹昷晀晅晆晊晌晑晎晗晘晙晛晜晠晡曻晪晫晬晾晳晵晿晷晸晹晻暀晼暋暌暍暐暒暙暚暛暜暟暠暤暭暱暲暵暻暿曀曂曃曈曌曎曏曔曛曟曨曫曬曮曺朅朇朎朓朙朜朠朢朳朾杅杇杈杌杔杕杝"],["8fc3a1","杦杬杮杴杶杻极构枎枏枑枓枖枘枙枛枰枱枲枵枻枼枽柹柀柂柃柅柈柉柒柗柙柜柡柦柰柲柶柷桒栔栙栝栟栨栧栬栭栯栰栱栳栻栿桄桅桊桌桕桗桘桛桫桮",4,"桵桹桺桻桼梂梄梆梈梖梘梚梜梡梣梥梩梪梮梲梻棅棈棌棏"],["8fc4a1","棐棑棓棖棙棜棝棥棨棪棫棬棭棰棱棵棶棻棼棽椆椉椊椐椑椓椖椗椱椳椵椸椻楂楅楉楎楗楛楣楤楥楦楨楩楬楰楱楲楺楻楿榀榍榒榖榘榡榥榦榨榫榭榯榷榸榺榼槅槈槑槖槗槢槥槮槯槱槳槵槾樀樁樃樏樑樕樚樝樠樤樨樰樲"],["8fc5a1","樴樷樻樾樿橅橆橉橊橎橐橑橒橕橖橛橤橧橪橱橳橾檁檃檆檇檉檋檑檛檝檞檟檥檫檯檰檱檴檽檾檿櫆櫉櫈櫌櫐櫔櫕櫖櫜櫝櫤櫧櫬櫰櫱櫲櫼櫽欂欃欆欇欉欏欐欑欗欛欞欤欨欫欬欯欵欶欻欿歆歊歍歒歖歘歝歠歧歫歮歰歵歽"],["8fc6a1","歾殂殅殗殛殟殠殢殣殨殩殬殭殮殰殸殹殽殾毃毄毉毌毖毚毡毣毦毧毮毱毷毹毿氂氄氅氉氍氎氐氒氙氟氦氧氨氬氮氳氵氶氺氻氿汊汋汍汏汒汔汙汛汜汫汭汯汴汶汸汹汻沅沆沇沉沔沕沗沘沜沟沰沲沴泂泆泍泏泐泑泒泔泖"],["8fc7a1","泚泜泠泧泩泫泬泮泲泴洄洇洊洎洏洑洓洚洦洧洨汧洮洯洱洹洼洿浗浞浟浡浥浧浯浰浼涂涇涑涒涔涖涗涘涪涬涴涷涹涽涿淄淈淊淎淏淖淛淝淟淠淢淥淩淯淰淴淶淼渀渄渞渢渧渲渶渹渻渼湄湅湈湉湋湏湑湒湓湔湗湜湝湞"],["8fc8a1","湢湣湨湳湻湽溍溓溙溠溧溭溮溱溳溻溿滀滁滃滇滈滊滍滎滏滫滭滮滹滻滽漄漈漊漌漍漖漘漚漛漦漩漪漯漰漳漶漻漼漭潏潑潒潓潗潙潚潝潞潡潢潨潬潽潾澃澇澈澋澌澍澐澒澓澔澖澚澟澠澥澦澧澨澮澯澰澵澶澼濅濇濈濊"],["8fc9a1","濚濞濨濩濰濵濹濼濽瀀瀅瀆瀇瀍瀗瀠瀣瀯瀴瀷瀹瀼灃灄灈灉灊灋灔灕灝灞灎灤灥灬灮灵灶灾炁炅炆炔",4,"炛炤炫炰炱炴炷烊烑烓烔烕烖烘烜烤烺焃",4,"焋焌焏焞焠焫焭焯焰焱焸煁煅煆煇煊煋煐煒煗煚煜煞煠"],["8fcaa1","煨煹熀熅熇熌熒熚熛熠熢熯熰熲熳熺熿燀燁燄燋燌燓燖燙燚燜燸燾爀爇爈爉爓爗爚爝爟爤爫爯爴爸爹牁牂牃牅牎牏牐牓牕牖牚牜牞牠牣牨牫牮牯牱牷牸牻牼牿犄犉犍犎犓犛犨犭犮犱犴犾狁狇狉狌狕狖狘狟狥狳狴狺狻"],["8fcba1","狾猂猄猅猇猋猍猒猓猘猙猞猢猤猧猨猬猱猲猵猺猻猽獃獍獐獒獖獘獝獞獟獠獦獧獩獫獬獮獯獱獷獹獼玀玁玃玅玆玎玐玓玕玗玘玜玞玟玠玢玥玦玪玫玭玵玷玹玼玽玿珅珆珉珋珌珏珒珓珖珙珝珡珣珦珧珩珴珵珷珹珺珻珽"],["8fcca1","珿琀琁琄琇琊琑琚琛琤琦琨",9,"琹瑀瑃瑄瑆瑇瑋瑍瑑瑒瑗瑝瑢瑦瑧瑨瑫瑭瑮瑱瑲璀璁璅璆璇璉璏璐璑璒璘璙璚璜璟璠璡璣璦璨璩璪璫璮璯璱璲璵璹璻璿瓈瓉瓌瓐瓓瓘瓚瓛瓞瓟瓤瓨瓪瓫瓯瓴瓺瓻瓼瓿甆"],["8fcda1","甒甖甗甠甡甤甧甩甪甯甶甹甽甾甿畀畃畇畈畎畐畒畗畞畟畡畯畱畹",5,"疁疅疐疒疓疕疙疜疢疤疴疺疿痀痁痄痆痌痎痏痗痜痟痠痡痤痧痬痮痯痱痹瘀瘂瘃瘄瘇瘈瘊瘌瘏瘒瘓瘕瘖瘙瘛瘜瘝瘞瘣瘥瘦瘩瘭瘲瘳瘵瘸瘹"],["8fcea1","瘺瘼癊癀癁癃癄癅癉癋癕癙癟癤癥癭癮癯癱癴皁皅皌皍皕皛皜皝皟皠皢",6,"皪皭皽盁盅盉盋盌盎盔盙盠盦盨盬盰盱盶盹盼眀眆眊眎眒眔眕眗眙眚眜眢眨眭眮眯眴眵眶眹眽眾睂睅睆睊睍睎睏睒睖睗睜睞睟睠睢"],["8fcfa1","睤睧睪睬睰睲睳睴睺睽瞀瞄瞌瞍瞔瞕瞖瞚瞟瞢瞧瞪瞮瞯瞱瞵瞾矃矉矑矒矕矙矞矟矠矤矦矪矬矰矱矴矸矻砅砆砉砍砎砑砝砡砢砣砭砮砰砵砷硃硄硇硈硌硎硒硜硞硠硡硣硤硨硪确硺硾碊碏碔碘碡碝碞碟碤碨碬碭碰碱碲碳"],["8fd0a1","碻碽碿磇磈磉磌磎磒磓磕磖磤磛磟磠磡磦磪磲磳礀磶磷磺磻磿礆礌礐礚礜礞礟礠礥礧礩礭礱礴礵礻礽礿祄祅祆祊祋祏祑祔祘祛祜祧祩祫祲祹祻祼祾禋禌禑禓禔禕禖禘禛禜禡禨禩禫禯禱禴禸离秂秄秇秈秊秏秔秖秚秝秞"],["8fd1a1","秠秢秥秪秫秭秱秸秼稂稃稇稉稊稌稑稕稛稞稡稧稫稭稯稰稴稵稸稹稺穄穅穇穈穌穕穖穙穜穝穟穠穥穧穪穭穵穸穾窀窂窅窆窊窋窐窑窔窞窠窣窬窳窵窹窻窼竆竉竌竎竑竛竨竩竫竬竱竴竻竽竾笇笔笟笣笧笩笪笫笭笮笯笰"],["8fd2a1","笱笴笽笿筀筁筇筎筕筠筤筦筩筪筭筯筲筳筷箄箉箎箐箑箖箛箞箠箥箬箯箰箲箵箶箺箻箼箽篂篅篈篊篔篖篗篙篚篛篨篪篲篴篵篸篹篺篼篾簁簂簃簄簆簉簋簌簎簏簙簛簠簥簦簨簬簱簳簴簶簹簺籆籊籕籑籒籓籙",5],["8fd3a1","籡籣籧籩籭籮籰籲籹籼籽粆粇粏粔粞粠粦粰粶粷粺粻粼粿糄糇糈糉糍糏糓糔糕糗糙糚糝糦糩糫糵紃紇紈紉紏紑紒紓紖紝紞紣紦紪紭紱紼紽紾絀絁絇絈絍絑絓絗絙絚絜絝絥絧絪絰絸絺絻絿綁綂綃綅綆綈綋綌綍綑綖綗綝"],["8fd4a1","綞綦綧綪綳綶綷綹緂",4,"緌緍緎緗緙縀緢緥緦緪緫緭緱緵緶緹緺縈縐縑縕縗縜縝縠縧縨縬縭縯縳縶縿繄繅繇繎繐繒繘繟繡繢繥繫繮繯繳繸繾纁纆纇纊纍纑纕纘纚纝纞缼缻缽缾缿罃罄罇罏罒罓罛罜罝罡罣罤罥罦罭"],["8fd5a1","罱罽罾罿羀羋羍羏羐羑羖羗羜羡羢羦羪羭羴羼羿翀翃翈翎翏翛翟翣翥翨翬翮翯翲翺翽翾翿耇耈耊耍耎耏耑耓耔耖耝耞耟耠耤耦耬耮耰耴耵耷耹耺耼耾聀聄聠聤聦聭聱聵肁肈肎肜肞肦肧肫肸肹胈胍胏胒胔胕胗胘胠胭胮"],["8fd6a1","胰胲胳胶胹胺胾脃脋脖脗脘脜脞脠脤脧脬脰脵脺脼腅腇腊腌腒腗腠腡腧腨腩腭腯腷膁膐膄膅膆膋膎膖膘膛膞膢膮膲膴膻臋臃臅臊臎臏臕臗臛臝臞臡臤臫臬臰臱臲臵臶臸臹臽臿舀舃舏舓舔舙舚舝舡舢舨舲舴舺艃艄艅艆"],["8fd7a1","艋艎艏艑艖艜艠艣艧艭艴艻艽艿芀芁芃芄芇芉芊芎芑芔芖芘芚芛芠芡芣芤芧芨芩芪芮芰芲芴芷芺芼芾芿苆苐苕苚苠苢苤苨苪苭苯苶苷苽苾茀茁茇茈茊茋荔茛茝茞茟茡茢茬茭茮茰茳茷茺茼茽荂荃荄荇荍荎荑荕荖荗荰荸"],["8fd8a1","荽荿莀莂莄莆莍莒莔莕莘莙莛莜莝莦莧莩莬莾莿菀菇菉菏菐菑菔菝荓菨菪菶菸菹菼萁萆萊萏萑萕萙莭萯萹葅葇葈葊葍葏葑葒葖葘葙葚葜葠葤葥葧葪葰葳葴葶葸葼葽蒁蒅蒒蒓蒕蒞蒦蒨蒩蒪蒯蒱蒴蒺蒽蒾蓀蓂蓇蓈蓌蓏蓓"],["8fd9a1","蓜蓧蓪蓯蓰蓱蓲蓷蔲蓺蓻蓽蔂蔃蔇蔌蔎蔐蔜蔞蔢蔣蔤蔥蔧蔪蔫蔯蔳蔴蔶蔿蕆蕏",4,"蕖蕙蕜",6,"蕤蕫蕯蕹蕺蕻蕽蕿薁薅薆薉薋薌薏薓薘薝薟薠薢薥薧薴薶薷薸薼薽薾薿藂藇藊藋藎薭藘藚藟藠藦藨藭藳藶藼"],["8fdaa1","藿蘀蘄蘅蘍蘎蘐蘑蘒蘘蘙蘛蘞蘡蘧蘩蘶蘸蘺蘼蘽虀虂虆虒虓虖虗虘虙虝虠",4,"虩虬虯虵虶虷虺蚍蚑蚖蚘蚚蚜蚡蚦蚧蚨蚭蚱蚳蚴蚵蚷蚸蚹蚿蛀蛁蛃蛅蛑蛒蛕蛗蛚蛜蛠蛣蛥蛧蚈蛺蛼蛽蜄蜅蜇蜋蜎蜏蜐蜓蜔蜙蜞蜟蜡蜣"],["8fdba1","蜨蜮蜯蜱蜲蜹蜺蜼蜽蜾蝀蝃蝅蝍蝘蝝蝡蝤蝥蝯蝱蝲蝻螃",6,"螋螌螐螓螕螗螘螙螞螠螣螧螬螭螮螱螵螾螿蟁蟈蟉蟊蟎蟕蟖蟙蟚蟜蟟蟢蟣蟤蟪蟫蟭蟱蟳蟸蟺蟿蠁蠃蠆蠉蠊蠋蠐蠙蠒蠓蠔蠘蠚蠛蠜蠞蠟蠨蠭蠮蠰蠲蠵"],["8fdca1","蠺蠼衁衃衅衈衉衊衋衎衑衕衖衘衚衜衟衠衤衩衱衹衻袀袘袚袛袜袟袠袨袪袺袽袾裀裊",4,"裑裒裓裛裞裧裯裰裱裵裷褁褆褍褎褏褕褖褘褙褚褜褠褦褧褨褰褱褲褵褹褺褾襀襂襅襆襉襏襒襗襚襛襜襡襢襣襫襮襰襳襵襺"],["8fdda1","襻襼襽覉覍覐覔覕覛覜覟覠覥覰覴覵覶覷覼觔",4,"觥觩觫觭觱觳觶觹觽觿訄訅訇訏訑訒訔訕訞訠訢訤訦訫訬訯訵訷訽訾詀詃詅詇詉詍詎詓詖詗詘詜詝詡詥詧詵詶詷詹詺詻詾詿誀誃誆誋誏誐誒誖誗誙誟誧誩誮誯誳"],["8fdea1","誶誷誻誾諃諆諈諉諊諑諓諔諕諗諝諟諬諰諴諵諶諼諿謅謆謋謑謜謞謟謊謭謰謷謼譂",4,"譈譒譓譔譙譍譞譣譭譶譸譹譼譾讁讄讅讋讍讏讔讕讜讞讟谸谹谽谾豅豇豉豋豏豑豓豔豗豘豛豝豙豣豤豦豨豩豭豳豵豶豻豾貆"],["8fdfa1","貇貋貐貒貓貙貛貜貤貹貺賅賆賉賋賏賖賕賙賝賡賨賬賯賰賲賵賷賸賾賿贁贃贉贒贗贛赥赩赬赮赿趂趄趈趍趐趑趕趞趟趠趦趫趬趯趲趵趷趹趻跀跅跆跇跈跊跎跑跔跕跗跙跤跥跧跬跰趼跱跲跴跽踁踄踅踆踋踑踔踖踠踡踢"],["8fe0a1","踣踦踧踱踳踶踷踸踹踽蹀蹁蹋蹍蹎蹏蹔蹛蹜蹝蹞蹡蹢蹩蹬蹭蹯蹰蹱蹹蹺蹻躂躃躉躐躒躕躚躛躝躞躢躧躩躭躮躳躵躺躻軀軁軃軄軇軏軑軔軜軨軮軰軱軷軹軺軭輀輂輇輈輏輐輖輗輘輞輠輡輣輥輧輨輬輭輮輴輵輶輷輺轀轁"],["8fe1a1","轃轇轏轑",4,"轘轝轞轥辝辠辡辤辥辦辵辶辸达迀迁迆迊迋迍运迒迓迕迠迣迤迨迮迱迵迶迻迾适逄逈逌逘逛逨逩逯逪逬逭逳逴逷逿遃遄遌遛遝遢遦遧遬遰遴遹邅邈邋邌邎邐邕邗邘邙邛邠邡邢邥邰邲邳邴邶邽郌邾郃"],["8fe2a1","郄郅郇郈郕郗郘郙郜郝郟郥郒郶郫郯郰郴郾郿鄀鄄鄅鄆鄈鄍鄐鄔鄖鄗鄘鄚鄜鄞鄠鄥鄢鄣鄧鄩鄮鄯鄱鄴鄶鄷鄹鄺鄼鄽酃酇酈酏酓酗酙酚酛酡酤酧酭酴酹酺酻醁醃醅醆醊醎醑醓醔醕醘醞醡醦醨醬醭醮醰醱醲醳醶醻醼醽醿"],["8fe3a1","釂釃釅釓釔釗釙釚釞釤釥釩釪釬",5,"釷釹釻釽鈀鈁鈄鈅鈆鈇鈉鈊鈌鈐鈒鈓鈖鈘鈜鈝鈣鈤鈥鈦鈨鈮鈯鈰鈳鈵鈶鈸鈹鈺鈼鈾鉀鉂鉃鉆鉇鉊鉍鉎鉏鉑鉘鉙鉜鉝鉠鉡鉥鉧鉨鉩鉮鉯鉰鉵",4,"鉻鉼鉽鉿銈銉銊銍銎銒銗"],["8fe4a1","銙銟銠銤銥銧銨銫銯銲銶銸銺銻銼銽銿",4,"鋅鋆鋇鋈鋋鋌鋍鋎鋐鋓鋕鋗鋘鋙鋜鋝鋟鋠鋡鋣鋥鋧鋨鋬鋮鋰鋹鋻鋿錀錂錈錍錑錔錕錜錝錞錟錡錤錥錧錩錪錳錴錶錷鍇鍈鍉鍐鍑鍒鍕鍗鍘鍚鍞鍤鍥鍧鍩鍪鍭鍯鍰鍱鍳鍴鍶"],["8fe5a1","鍺鍽鍿鎀鎁鎂鎈鎊鎋鎍鎏鎒鎕鎘鎛鎞鎡鎣鎤鎦鎨鎫鎴鎵鎶鎺鎩鏁鏄鏅鏆鏇鏉",4,"鏓鏙鏜鏞鏟鏢鏦鏧鏹鏷鏸鏺鏻鏽鐁鐂鐄鐈鐉鐍鐎鐏鐕鐖鐗鐟鐮鐯鐱鐲鐳鐴鐻鐿鐽鑃鑅鑈鑊鑌鑕鑙鑜鑟鑡鑣鑨鑫鑭鑮鑯鑱鑲钄钃镸镹"],["8fe6a1","镾閄閈閌閍閎閝閞閟閡閦閩閫閬閴閶閺閽閿闆闈闉闋闐闑闒闓闙闚闝闞闟闠闤闦阝阞阢阤阥阦阬阱阳阷阸阹阺阼阽陁陒陔陖陗陘陡陮陴陻陼陾陿隁隂隃隄隉隑隖隚隝隟隤隥隦隩隮隯隳隺雊雒嶲雘雚雝雞雟雩雯雱雺霂"],["8fe7a1","霃霅霉霚霛霝霡霢霣霨霱霳靁靃靊靎靏靕靗靘靚靛靣靧靪靮靳靶靷靸靻靽靿鞀鞉鞕鞖鞗鞙鞚鞞鞟鞢鞬鞮鞱鞲鞵鞶鞸鞹鞺鞼鞾鞿韁韄韅韇韉韊韌韍韎韐韑韔韗韘韙韝韞韠韛韡韤韯韱韴韷韸韺頇頊頙頍頎頔頖頜頞頠頣頦"],["8fe8a1","頫頮頯頰頲頳頵頥頾顄顇顊顑顒顓顖顗顙顚顢顣顥顦顪顬颫颭颮颰颴颷颸颺颻颿飂飅飈飌飡飣飥飦飧飪飳飶餂餇餈餑餕餖餗餚餛餜餟餢餦餧餫餱",4,"餹餺餻餼饀饁饆饇饈饍饎饔饘饙饛饜饞饟饠馛馝馟馦馰馱馲馵"],["8fe9a1","馹馺馽馿駃駉駓駔駙駚駜駞駧駪駫駬駰駴駵駹駽駾騂騃騄騋騌騐騑騖騞騠騢騣騤騧騭騮騳騵騶騸驇驁驄驊驋驌驎驑驔驖驝骪骬骮骯骲骴骵骶骹骻骾骿髁髃髆髈髎髐髒髕髖髗髛髜髠髤髥髧髩髬髲髳髵髹髺髽髿",4],["8feaa1","鬄鬅鬈鬉鬋鬌鬍鬎鬐鬒鬖鬙鬛鬜鬠鬦鬫鬭鬳鬴鬵鬷鬹鬺鬽魈魋魌魕魖魗魛魞魡魣魥魦魨魪",4,"魳魵魷魸魹魿鮀鮄鮅鮆鮇鮉鮊鮋鮍鮏鮐鮔鮚鮝鮞鮦鮧鮩鮬鮰鮱鮲鮷鮸鮻鮼鮾鮿鯁鯇鯈鯎鯐鯗鯘鯝鯟鯥鯧鯪鯫鯯鯳鯷鯸"],["8feba1","鯹鯺鯽鯿鰀鰂鰋鰏鰑鰖鰘鰙鰚鰜鰞鰢鰣鰦",4,"鰱鰵鰶鰷鰽鱁鱃鱄鱅鱉鱊鱎鱏鱐鱓鱔鱖鱘鱛鱝鱞鱟鱣鱩鱪鱜鱫鱨鱮鱰鱲鱵鱷鱻鳦鳲鳷鳹鴋鴂鴑鴗鴘鴜鴝鴞鴯鴰鴲鴳鴴鴺鴼鵅鴽鵂鵃鵇鵊鵓鵔鵟鵣鵢鵥鵩鵪鵫鵰鵶鵷鵻"],["8feca1","鵼鵾鶃鶄鶆鶊鶍鶎鶒鶓鶕鶖鶗鶘鶡鶪鶬鶮鶱鶵鶹鶼鶿鷃鷇鷉鷊鷔鷕鷖鷗鷚鷞鷟鷠鷥鷧鷩鷫鷮鷰鷳鷴鷾鸊鸂鸇鸎鸐鸑鸒鸕鸖鸙鸜鸝鹺鹻鹼麀麂麃麄麅麇麎麏麖麘麛麞麤麨麬麮麯麰麳麴麵黆黈黋黕黟黤黧黬黭黮黰黱黲黵"],["8feda1","黸黿鼂鼃鼉鼏鼐鼑鼒鼔鼖鼗鼙鼚鼛鼟鼢鼦鼪鼫鼯鼱鼲鼴鼷鼹鼺鼼鼽鼿齁齃",4,"齓齕齖齗齘齚齝齞齨齩齭",4,"齳齵齺齽龏龐龑龒龔龖龗龞龡龢龣龥"]]

/***/ }),
/* 1278 */
/***/ (function(module, exports) {

module.exports = {"uChars":[128,165,169,178,184,216,226,235,238,244,248,251,253,258,276,284,300,325,329,334,364,463,465,467,469,471,473,475,477,506,594,610,712,716,730,930,938,962,970,1026,1104,1106,8209,8215,8218,8222,8231,8241,8244,8246,8252,8365,8452,8454,8458,8471,8482,8556,8570,8596,8602,8713,8720,8722,8726,8731,8737,8740,8742,8748,8751,8760,8766,8777,8781,8787,8802,8808,8816,8854,8858,8870,8896,8979,9322,9372,9548,9588,9616,9622,9634,9652,9662,9672,9676,9680,9702,9735,9738,9793,9795,11906,11909,11913,11917,11928,11944,11947,11951,11956,11960,11964,11979,12284,12292,12312,12319,12330,12351,12436,12447,12535,12543,12586,12842,12850,12964,13200,13215,13218,13253,13263,13267,13270,13384,13428,13727,13839,13851,14617,14703,14801,14816,14964,15183,15471,15585,16471,16736,17208,17325,17330,17374,17623,17997,18018,18212,18218,18301,18318,18760,18811,18814,18820,18823,18844,18848,18872,19576,19620,19738,19887,40870,59244,59336,59367,59413,59417,59423,59431,59437,59443,59452,59460,59478,59493,63789,63866,63894,63976,63986,64016,64018,64021,64025,64034,64037,64042,65074,65093,65107,65112,65127,65132,65375,65510,65536],"gbChars":[0,36,38,45,50,81,89,95,96,100,103,104,105,109,126,133,148,172,175,179,208,306,307,308,309,310,311,312,313,341,428,443,544,545,558,741,742,749,750,805,819,820,7922,7924,7925,7927,7934,7943,7944,7945,7950,8062,8148,8149,8152,8164,8174,8236,8240,8262,8264,8374,8380,8381,8384,8388,8390,8392,8393,8394,8396,8401,8406,8416,8419,8424,8437,8439,8445,8482,8485,8496,8521,8603,8936,8946,9046,9050,9063,9066,9076,9092,9100,9108,9111,9113,9131,9162,9164,9218,9219,11329,11331,11334,11336,11346,11361,11363,11366,11370,11372,11375,11389,11682,11686,11687,11692,11694,11714,11716,11723,11725,11730,11736,11982,11989,12102,12336,12348,12350,12384,12393,12395,12397,12510,12553,12851,12962,12973,13738,13823,13919,13933,14080,14298,14585,14698,15583,15847,16318,16434,16438,16481,16729,17102,17122,17315,17320,17402,17418,17859,17909,17911,17915,17916,17936,17939,17961,18664,18703,18814,18962,19043,33469,33470,33471,33484,33485,33490,33497,33501,33505,33513,33520,33536,33550,37845,37921,37948,38029,38038,38064,38065,38066,38069,38075,38076,38078,39108,39109,39113,39114,39115,39116,39265,39394,189000]}

/***/ }),
/* 1279 */
/***/ (function(module, exports) {

module.exports = [["0","\u0000",127],["8141","갂갃갅갆갋",4,"갘갞갟갡갢갣갥",6,"갮갲갳갴"],["8161","갵갶갷갺갻갽갾갿걁",9,"걌걎",5,"걕"],["8181","걖걗걙걚걛걝",18,"걲걳걵걶걹걻",4,"겂겇겈겍겎겏겑겒겓겕",6,"겞겢",5,"겫겭겮겱",6,"겺겾겿곀곂곃곅곆곇곉곊곋곍",7,"곖곘",7,"곢곣곥곦곩곫곭곮곲곴곷",4,"곾곿괁괂괃괅괇",4,"괎괐괒괓"],["8241","괔괕괖괗괙괚괛괝괞괟괡",7,"괪괫괮",5],["8261","괶괷괹괺괻괽",6,"굆굈굊",5,"굑굒굓굕굖굗"],["8281","굙",7,"굢굤",7,"굮굯굱굲굷굸굹굺굾궀궃",4,"궊궋궍궎궏궑",10,"궞",5,"궥",17,"궸",7,"귂귃귅귆귇귉",6,"귒귔",7,"귝귞귟귡귢귣귥",18],["8341","귺귻귽귾긂",5,"긊긌긎",5,"긕",7],["8361","긝",18,"긲긳긵긶긹긻긼"],["8381","긽긾긿깂깄깇깈깉깋깏깑깒깓깕깗",4,"깞깢깣깤깦깧깪깫깭깮깯깱",6,"깺깾",5,"꺆",5,"꺍",46,"꺿껁껂껃껅",6,"껎껒",5,"껚껛껝",8],["8441","껦껧껩껪껬껮",5,"껵껶껷껹껺껻껽",8],["8461","꼆꼉꼊꼋꼌꼎꼏꼑",18],["8481","꼤",7,"꼮꼯꼱꼳꼵",6,"꼾꽀꽄꽅꽆꽇꽊",5,"꽑",10,"꽞",5,"꽦",18,"꽺",5,"꾁꾂꾃꾅꾆꾇꾉",6,"꾒꾓꾔꾖",5,"꾝",26,"꾺꾻꾽꾾"],["8541","꾿꿁",5,"꿊꿌꿏",4,"꿕",6,"꿝",4],["8561","꿢",5,"꿪",5,"꿲꿳꿵꿶꿷꿹",6,"뀂뀃"],["8581","뀅",6,"뀍뀎뀏뀑뀒뀓뀕",6,"뀞",9,"뀩",26,"끆끇끉끋끍끏끐끑끒끖끘끚끛끜끞",29,"끾끿낁낂낃낅",6,"낎낐낒",5,"낛낝낞낣낤"],["8641","낥낦낧낪낰낲낶낷낹낺낻낽",6,"냆냊",5,"냒"],["8661","냓냕냖냗냙",6,"냡냢냣냤냦",10],["8681","냱",22,"넊넍넎넏넑넔넕넖넗넚넞",4,"넦넧넩넪넫넭",6,"넶넺",5,"녂녃녅녆녇녉",6,"녒녓녖녗녙녚녛녝녞녟녡",22,"녺녻녽녾녿놁놃",4,"놊놌놎놏놐놑놕놖놗놙놚놛놝"],["8741","놞",9,"놩",15],["8761","놹",18,"뇍뇎뇏뇑뇒뇓뇕"],["8781","뇖",5,"뇞뇠",7,"뇪뇫뇭뇮뇯뇱",7,"뇺뇼뇾",5,"눆눇눉눊눍",6,"눖눘눚",5,"눡",18,"눵",6,"눽",26,"뉙뉚뉛뉝뉞뉟뉡",6,"뉪",4],["8841","뉯",4,"뉶",5,"뉽",6,"늆늇늈늊",4],["8861","늏늒늓늕늖늗늛",4,"늢늤늧늨늩늫늭늮늯늱늲늳늵늶늷"],["8881","늸",15,"닊닋닍닎닏닑닓",4,"닚닜닞닟닠닡닣닧닩닪닰닱닲닶닼닽닾댂댃댅댆댇댉",6,"댒댖",5,"댝",54,"덗덙덚덝덠덡덢덣"],["8941","덦덨덪덬덭덯덲덳덵덶덷덹",6,"뎂뎆",5,"뎍"],["8961","뎎뎏뎑뎒뎓뎕",10,"뎢",5,"뎩뎪뎫뎭"],["8981","뎮",21,"돆돇돉돊돍돏돑돒돓돖돘돚돜돞돟돡돢돣돥돦돧돩",18,"돽",18,"됑",6,"됙됚됛됝됞됟됡",6,"됪됬",7,"됵",15],["8a41","둅",10,"둒둓둕둖둗둙",6,"둢둤둦"],["8a61","둧",4,"둭",18,"뒁뒂"],["8a81","뒃",4,"뒉",19,"뒞",5,"뒥뒦뒧뒩뒪뒫뒭",7,"뒶뒸뒺",5,"듁듂듃듅듆듇듉",6,"듑듒듓듔듖",5,"듞듟듡듢듥듧",4,"듮듰듲",5,"듹",26,"딖딗딙딚딝"],["8b41","딞",5,"딦딫",4,"딲딳딵딶딷딹",6,"땂땆"],["8b61","땇땈땉땊땎땏땑땒땓땕",6,"땞땢",8],["8b81","땫",52,"떢떣떥떦떧떩떬떭떮떯떲떶",4,"떾떿뗁뗂뗃뗅",6,"뗎뗒",5,"뗙",18,"뗭",18],["8c41","똀",15,"똒똓똕똖똗똙",4],["8c61","똞",6,"똦",5,"똭",6,"똵",5],["8c81","똻",12,"뙉",26,"뙥뙦뙧뙩",50,"뚞뚟뚡뚢뚣뚥",5,"뚭뚮뚯뚰뚲",16],["8d41","뛃",16,"뛕",8],["8d61","뛞",17,"뛱뛲뛳뛵뛶뛷뛹뛺"],["8d81","뛻",4,"뜂뜃뜄뜆",33,"뜪뜫뜭뜮뜱",6,"뜺뜼",7,"띅띆띇띉띊띋띍",6,"띖",9,"띡띢띣띥띦띧띩",6,"띲띴띶",5,"띾띿랁랂랃랅",6,"랎랓랔랕랚랛랝랞"],["8e41","랟랡",6,"랪랮",5,"랶랷랹",8],["8e61","럂",4,"럈럊",19],["8e81","럞",13,"럮럯럱럲럳럵",6,"럾렂",4,"렊렋렍렎렏렑",6,"렚렜렞",5,"렦렧렩렪렫렭",6,"렶렺",5,"롁롂롃롅",11,"롒롔",7,"롞롟롡롢롣롥",6,"롮롰롲",5,"롹롺롻롽",7],["8f41","뢅",7,"뢎",17],["8f61","뢠",7,"뢩",6,"뢱뢲뢳뢵뢶뢷뢹",4],["8f81","뢾뢿룂룄룆",5,"룍룎룏룑룒룓룕",7,"룞룠룢",5,"룪룫룭룮룯룱",6,"룺룼룾",5,"뤅",18,"뤙",6,"뤡",26,"뤾뤿륁륂륃륅",6,"륍륎륐륒",5],["9041","륚륛륝륞륟륡",6,"륪륬륮",5,"륶륷륹륺륻륽"],["9061","륾",5,"릆릈릋릌릏",15],["9081","릟",12,"릮릯릱릲릳릵",6,"릾맀맂",5,"맊맋맍맓",4,"맚맜맟맠맢맦맧맩맪맫맭",6,"맶맻",4,"먂",5,"먉",11,"먖",33,"먺먻먽먾먿멁멃멄멅멆"],["9141","멇멊멌멏멐멑멒멖멗멙멚멛멝",6,"멦멪",5],["9161","멲멳멵멶멷멹",9,"몆몈몉몊몋몍",5],["9181","몓",20,"몪몭몮몯몱몳",4,"몺몼몾",5,"뫅뫆뫇뫉",14,"뫚",33,"뫽뫾뫿묁묂묃묅",7,"묎묐묒",5,"묙묚묛묝묞묟묡",6],["9241","묨묪묬",7,"묷묹묺묿",4,"뭆뭈뭊뭋뭌뭎뭑뭒"],["9261","뭓뭕뭖뭗뭙",7,"뭢뭤",7,"뭭",4],["9281","뭲",21,"뮉뮊뮋뮍뮎뮏뮑",18,"뮥뮦뮧뮩뮪뮫뮭",6,"뮵뮶뮸",7,"믁믂믃믅믆믇믉",6,"믑믒믔",35,"믺믻믽믾밁"],["9341","밃",4,"밊밎밐밒밓밙밚밠밡밢밣밦밨밪밫밬밮밯밲밳밵"],["9361","밶밷밹",6,"뱂뱆뱇뱈뱊뱋뱎뱏뱑",8],["9381","뱚뱛뱜뱞",37,"벆벇벉벊벍벏",4,"벖벘벛",4,"벢벣벥벦벩",6,"벲벶",5,"벾벿볁볂볃볅",7,"볎볒볓볔볖볗볙볚볛볝",22,"볷볹볺볻볽"],["9441","볾",5,"봆봈봊",5,"봑봒봓봕",8],["9461","봞",5,"봥",6,"봭",12],["9481","봺",5,"뵁",6,"뵊뵋뵍뵎뵏뵑",6,"뵚",9,"뵥뵦뵧뵩",22,"붂붃붅붆붋",4,"붒붔붖붗붘붛붝",6,"붥",10,"붱",6,"붹",24],["9541","뷒뷓뷖뷗뷙뷚뷛뷝",11,"뷪",5,"뷱"],["9561","뷲뷳뷵뷶뷷뷹",6,"븁븂븄븆",5,"븎븏븑븒븓"],["9581","븕",6,"븞븠",35,"빆빇빉빊빋빍빏",4,"빖빘빜빝빞빟빢빣빥빦빧빩빫",4,"빲빶",4,"빾빿뺁뺂뺃뺅",6,"뺎뺒",5,"뺚",13,"뺩",14],["9641","뺸",23,"뻒뻓"],["9661","뻕뻖뻙",6,"뻡뻢뻦",5,"뻭",8],["9681","뻶",10,"뼂",5,"뼊",13,"뼚뼞",33,"뽂뽃뽅뽆뽇뽉",6,"뽒뽓뽔뽖",44],["9741","뾃",16,"뾕",8],["9761","뾞",17,"뾱",7],["9781","뾹",11,"뿆",5,"뿎뿏뿑뿒뿓뿕",6,"뿝뿞뿠뿢",89,"쀽쀾쀿"],["9841","쁀",16,"쁒",5,"쁙쁚쁛"],["9861","쁝쁞쁟쁡",6,"쁪",15],["9881","쁺",21,"삒삓삕삖삗삙",6,"삢삤삦",5,"삮삱삲삷",4,"삾샂샃샄샆샇샊샋샍샎샏샑",6,"샚샞",5,"샦샧샩샪샫샭",6,"샶샸샺",5,"섁섂섃섅섆섇섉",6,"섑섒섓섔섖",5,"섡섢섥섨섩섪섫섮"],["9941","섲섳섴섵섷섺섻섽섾섿셁",6,"셊셎",5,"셖셗"],["9961","셙셚셛셝",6,"셦셪",5,"셱셲셳셵셶셷셹셺셻"],["9981","셼",8,"솆",5,"솏솑솒솓솕솗",4,"솞솠솢솣솤솦솧솪솫솭솮솯솱",11,"솾",5,"쇅쇆쇇쇉쇊쇋쇍",6,"쇕쇖쇙",6,"쇡쇢쇣쇥쇦쇧쇩",6,"쇲쇴",7,"쇾쇿숁숂숃숅",6,"숎숐숒",5,"숚숛숝숞숡숢숣"],["9a41","숤숥숦숧숪숬숮숰숳숵",16],["9a61","쉆쉇쉉",6,"쉒쉓쉕쉖쉗쉙",6,"쉡쉢쉣쉤쉦"],["9a81","쉧",4,"쉮쉯쉱쉲쉳쉵",6,"쉾슀슂",5,"슊",5,"슑",6,"슙슚슜슞",5,"슦슧슩슪슫슮",5,"슶슸슺",33,"싞싟싡싢싥",5,"싮싰싲싳싴싵싷싺싽싾싿쌁",6,"쌊쌋쌎쌏"],["9b41","쌐쌑쌒쌖쌗쌙쌚쌛쌝",6,"쌦쌧쌪",8],["9b61","쌳",17,"썆",7],["9b81","썎",25,"썪썫썭썮썯썱썳",4,"썺썻썾",5,"쎅쎆쎇쎉쎊쎋쎍",50,"쏁",22,"쏚"],["9c41","쏛쏝쏞쏡쏣",4,"쏪쏫쏬쏮",5,"쏶쏷쏹",5],["9c61","쏿",8,"쐉",6,"쐑",9],["9c81","쐛",8,"쐥",6,"쐭쐮쐯쐱쐲쐳쐵",6,"쐾",9,"쑉",26,"쑦쑧쑩쑪쑫쑭",6,"쑶쑷쑸쑺",5,"쒁",18,"쒕",6,"쒝",12],["9d41","쒪",13,"쒹쒺쒻쒽",8],["9d61","쓆",25],["9d81","쓠",8,"쓪",5,"쓲쓳쓵쓶쓷쓹쓻쓼쓽쓾씂",9,"씍씎씏씑씒씓씕",6,"씝",10,"씪씫씭씮씯씱",6,"씺씼씾",5,"앆앇앋앏앐앑앒앖앚앛앜앟앢앣앥앦앧앩",6,"앲앶",5,"앾앿얁얂얃얅얆얈얉얊얋얎얐얒얓얔"],["9e41","얖얙얚얛얝얞얟얡",7,"얪",9,"얶"],["9e61","얷얺얿",4,"엋엍엏엒엓엕엖엗엙",6,"엢엤엦엧"],["9e81","엨엩엪엫엯엱엲엳엵엸엹엺엻옂옃옄옉옊옋옍옎옏옑",6,"옚옝",6,"옦옧옩옪옫옯옱옲옶옸옺옼옽옾옿왂왃왅왆왇왉",6,"왒왖",5,"왞왟왡",10,"왭왮왰왲",5,"왺왻왽왾왿욁",6,"욊욌욎",5,"욖욗욙욚욛욝",6,"욦"],["9f41","욨욪",5,"욲욳욵욶욷욻",4,"웂웄웆",5,"웎"],["9f61","웏웑웒웓웕",6,"웞웟웢",5,"웪웫웭웮웯웱웲"],["9f81","웳",4,"웺웻웼웾",5,"윆윇윉윊윋윍",6,"윖윘윚",5,"윢윣윥윦윧윩",6,"윲윴윶윸윹윺윻윾윿읁읂읃읅",4,"읋읎읐읙읚읛읝읞읟읡",6,"읩읪읬",7,"읶읷읹읺읻읿잀잁잂잆잋잌잍잏잒잓잕잙잛",4,"잢잧",4,"잮잯잱잲잳잵잶잷"],["a041","잸잹잺잻잾쟂",5,"쟊쟋쟍쟏쟑",6,"쟙쟚쟛쟜"],["a061","쟞",5,"쟥쟦쟧쟩쟪쟫쟭",13],["a081","쟻",4,"젂젃젅젆젇젉젋",4,"젒젔젗",4,"젞젟젡젢젣젥",6,"젮젰젲",5,"젹젺젻젽젾젿졁",6,"졊졋졎",5,"졕",26,"졲졳졵졶졷졹졻",4,"좂좄좈좉좊좎",5,"좕",7,"좞좠좢좣좤"],["a141","좥좦좧좩",18,"좾좿죀죁"],["a161","죂죃죅죆죇죉죊죋죍",6,"죖죘죚",5,"죢죣죥"],["a181","죦",14,"죶",5,"죾죿줁줂줃줇",4,"줎　、。·‥…¨〃­―∥＼∼‘’“”〔〕〈",9,"±×÷≠≤≥∞∴°′″℃Å￠￡￥♂♀∠⊥⌒∂∇≡≒§※☆★○●◎◇◆□■△▲▽▼→←↑↓↔〓≪≫√∽∝∵∫∬∈∋⊆⊇⊂⊃∪∩∧∨￢"],["a241","줐줒",5,"줙",18],["a261","줭",6,"줵",18],["a281","쥈",7,"쥒쥓쥕쥖쥗쥙",6,"쥢쥤",7,"쥭쥮쥯⇒⇔∀∃´～ˇ˘˝˚˙¸˛¡¿ː∮∑∏¤℉‰◁◀▷▶♤♠♡♥♧♣⊙◈▣◐◑▒▤▥▨▧▦▩♨☏☎☜☞¶†‡↕↗↙↖↘♭♩♪♬㉿㈜№㏇™㏂㏘℡€®"],["a341","쥱쥲쥳쥵",6,"쥽",10,"즊즋즍즎즏"],["a361","즑",6,"즚즜즞",16],["a381","즯",16,"짂짃짅짆짉짋",4,"짒짔짗짘짛！",58,"￦］",32,"￣"],["a441","짞짟짡짣짥짦짨짩짪짫짮짲",5,"짺짻짽짾짿쨁쨂쨃쨄"],["a461","쨅쨆쨇쨊쨎",5,"쨕쨖쨗쨙",12],["a481","쨦쨧쨨쨪",28,"ㄱ",93],["a541","쩇",4,"쩎쩏쩑쩒쩓쩕",6,"쩞쩢",5,"쩩쩪"],["a561","쩫",17,"쩾",5,"쪅쪆"],["a581","쪇",16,"쪙",14,"ⅰ",9],["a5b0","Ⅰ",9],["a5c1","Α",16,"Σ",6],["a5e1","α",16,"σ",6],["a641","쪨",19,"쪾쪿쫁쫂쫃쫅"],["a661","쫆",5,"쫎쫐쫒쫔쫕쫖쫗쫚",5,"쫡",6],["a681","쫨쫩쫪쫫쫭",6,"쫵",18,"쬉쬊─│┌┐┘└├┬┤┴┼━┃┏┓┛┗┣┳┫┻╋┠┯┨┷┿┝┰┥┸╂┒┑┚┙┖┕┎┍┞┟┡┢┦┧┩┪┭┮┱┲┵┶┹┺┽┾╀╁╃",7],["a741","쬋",4,"쬑쬒쬓쬕쬖쬗쬙",6,"쬢",7],["a761","쬪",22,"쭂쭃쭄"],["a781","쭅쭆쭇쭊쭋쭍쭎쭏쭑",6,"쭚쭛쭜쭞",5,"쭥",7,"㎕㎖㎗ℓ㎘㏄㎣㎤㎥㎦㎙",9,"㏊㎍㎎㎏㏏㎈㎉㏈㎧㎨㎰",9,"㎀",4,"㎺",5,"㎐",4,"Ω㏀㏁㎊㎋㎌㏖㏅㎭㎮㎯㏛㎩㎪㎫㎬㏝㏐㏓㏃㏉㏜㏆"],["a841","쭭",10,"쭺",14],["a861","쮉",18,"쮝",6],["a881","쮤",19,"쮹",11,"ÆÐªĦ"],["a8a6","Ĳ"],["a8a8","ĿŁØŒºÞŦŊ"],["a8b1","㉠",27,"ⓐ",25,"①",14,"½⅓⅔¼¾⅛⅜⅝⅞"],["a941","쯅",14,"쯕",10],["a961","쯠쯡쯢쯣쯥쯦쯨쯪",18],["a981","쯽",14,"찎찏찑찒찓찕",6,"찞찟찠찣찤æđðħıĳĸŀłøœßþŧŋŉ㈀",27,"⒜",25,"⑴",14,"¹²³⁴ⁿ₁₂₃₄"],["aa41","찥찦찪찫찭찯찱",6,"찺찿",4,"챆챇챉챊챋챍챎"],["aa61","챏",4,"챖챚",5,"챡챢챣챥챧챩",6,"챱챲"],["aa81","챳챴챶",29,"ぁ",82],["ab41","첔첕첖첗첚첛첝첞첟첡",6,"첪첮",5,"첶첷첹"],["ab61","첺첻첽",6,"쳆쳈쳊",5,"쳑쳒쳓쳕",5],["ab81","쳛",8,"쳥",6,"쳭쳮쳯쳱",12,"ァ",85],["ac41","쳾쳿촀촂",5,"촊촋촍촎촏촑",6,"촚촜촞촟촠"],["ac61","촡촢촣촥촦촧촩촪촫촭",11,"촺",4],["ac81","촿",28,"쵝쵞쵟А",5,"ЁЖ",25],["acd1","а",5,"ёж",25],["ad41","쵡쵢쵣쵥",6,"쵮쵰쵲",5,"쵹",7],["ad61","춁",6,"춉",10,"춖춗춙춚춛춝춞춟"],["ad81","춠춡춢춣춦춨춪",5,"춱",18,"췅"],["ae41","췆",5,"췍췎췏췑",16],["ae61","췢",5,"췩췪췫췭췮췯췱",6,"췺췼췾",4],["ae81","츃츅츆츇츉츊츋츍",6,"츕츖츗츘츚",5,"츢츣츥츦츧츩츪츫"],["af41","츬츭츮츯츲츴츶",19],["af61","칊",13,"칚칛칝칞칢",5,"칪칬"],["af81","칮",5,"칶칷칹칺칻칽",6,"캆캈캊",5,"캒캓캕캖캗캙"],["b041","캚",5,"캢캦",5,"캮",12],["b061","캻",5,"컂",19],["b081","컖",13,"컦컧컩컪컭",6,"컶컺",5,"가각간갇갈갉갊감",7,"같",4,"갠갤갬갭갯갰갱갸갹갼걀걋걍걔걘걜거걱건걷걸걺검겁것겄겅겆겉겊겋게겐겔겜겝겟겠겡겨격겪견겯결겸겹겻겼경곁계곈곌곕곗고곡곤곧골곪곬곯곰곱곳공곶과곽관괄괆"],["b141","켂켃켅켆켇켉",6,"켒켔켖",5,"켝켞켟켡켢켣"],["b161","켥",6,"켮켲",5,"켹",11],["b181","콅",14,"콖콗콙콚콛콝",6,"콦콨콪콫콬괌괍괏광괘괜괠괩괬괭괴괵괸괼굄굅굇굉교굔굘굡굣구국군굳굴굵굶굻굼굽굿궁궂궈궉권궐궜궝궤궷귀귁귄귈귐귑귓규균귤그극근귿글긁금급긋긍긔기긱긴긷길긺김깁깃깅깆깊까깍깎깐깔깖깜깝깟깠깡깥깨깩깬깰깸"],["b241","콭콮콯콲콳콵콶콷콹",6,"쾁쾂쾃쾄쾆",5,"쾍"],["b261","쾎",18,"쾢",5,"쾩"],["b281","쾪",5,"쾱",18,"쿅",6,"깹깻깼깽꺄꺅꺌꺼꺽꺾껀껄껌껍껏껐껑께껙껜껨껫껭껴껸껼꼇꼈꼍꼐꼬꼭꼰꼲꼴꼼꼽꼿꽁꽂꽃꽈꽉꽐꽜꽝꽤꽥꽹꾀꾄꾈꾐꾑꾕꾜꾸꾹꾼꿀꿇꿈꿉꿋꿍꿎꿔꿜꿨꿩꿰꿱꿴꿸뀀뀁뀄뀌뀐뀔뀜뀝뀨끄끅끈끊끌끎끓끔끕끗끙"],["b341","쿌",19,"쿢쿣쿥쿦쿧쿩"],["b361","쿪",5,"쿲쿴쿶",5,"쿽쿾쿿퀁퀂퀃퀅",5],["b381","퀋",5,"퀒",5,"퀙",19,"끝끼끽낀낄낌낍낏낑나낙낚난낟날낡낢남납낫",4,"낱낳내낵낸낼냄냅냇냈냉냐냑냔냘냠냥너넉넋넌널넒넓넘넙넛넜넝넣네넥넨넬넴넵넷넸넹녀녁년녈념녑녔녕녘녜녠노녹논놀놂놈놉놋농높놓놔놘놜놨뇌뇐뇔뇜뇝"],["b441","퀮",5,"퀶퀷퀹퀺퀻퀽",6,"큆큈큊",5],["b461","큑큒큓큕큖큗큙",6,"큡",10,"큮큯"],["b481","큱큲큳큵",6,"큾큿킀킂",18,"뇟뇨뇩뇬뇰뇹뇻뇽누눅눈눋눌눔눕눗눙눠눴눼뉘뉜뉠뉨뉩뉴뉵뉼늄늅늉느늑는늘늙늚늠늡늣능늦늪늬늰늴니닉닌닐닒님닙닛닝닢다닥닦단닫",4,"닳담답닷",4,"닿대댁댄댈댐댑댓댔댕댜더덕덖던덛덜덞덟덤덥"],["b541","킕",14,"킦킧킩킪킫킭",5],["b561","킳킶킸킺",5,"탂탃탅탆탇탊",5,"탒탖",4],["b581","탛탞탟탡탢탣탥",6,"탮탲",5,"탹",11,"덧덩덫덮데덱덴델뎀뎁뎃뎄뎅뎌뎐뎔뎠뎡뎨뎬도독돈돋돌돎돐돔돕돗동돛돝돠돤돨돼됐되된될됨됩됫됴두둑둔둘둠둡둣둥둬뒀뒈뒝뒤뒨뒬뒵뒷뒹듀듄듈듐듕드득든듣들듦듬듭듯등듸디딕딘딛딜딤딥딧딨딩딪따딱딴딸"],["b641","턅",7,"턎",17],["b661","턠",15,"턲턳턵턶턷턹턻턼턽턾"],["b681","턿텂텆",5,"텎텏텑텒텓텕",6,"텞텠텢",5,"텩텪텫텭땀땁땃땄땅땋때땍땐땔땜땝땟땠땡떠떡떤떨떪떫떰떱떳떴떵떻떼떽뗀뗄뗌뗍뗏뗐뗑뗘뗬또똑똔똘똥똬똴뙈뙤뙨뚜뚝뚠뚤뚫뚬뚱뛔뛰뛴뛸뜀뜁뜅뜨뜩뜬뜯뜰뜸뜹뜻띄띈띌띔띕띠띤띨띰띱띳띵라락란랄람랍랏랐랑랒랖랗"],["b741","텮",13,"텽",6,"톅톆톇톉톊"],["b761","톋",20,"톢톣톥톦톧"],["b781","톩",6,"톲톴톶톷톸톹톻톽톾톿퇁",14,"래랙랜랠램랩랫랬랭랴략랸럇량러럭런럴럼럽럿렀렁렇레렉렌렐렘렙렛렝려력련렬렴렵렷렸령례롄롑롓로록론롤롬롭롯롱롸롼뢍뢨뢰뢴뢸룀룁룃룅료룐룔룝룟룡루룩룬룰룸룹룻룽뤄뤘뤠뤼뤽륀륄륌륏륑류륙륜률륨륩"],["b841","퇐",7,"퇙",17],["b861","퇫",8,"퇵퇶퇷퇹",13],["b881","툈툊",5,"툑",24,"륫륭르륵른를름릅릇릉릊릍릎리릭린릴림립릿링마막만많",4,"맘맙맛망맞맡맣매맥맨맬맴맵맷맸맹맺먀먁먈먕머먹먼멀멂멈멉멋멍멎멓메멕멘멜멤멥멧멨멩며멱면멸몃몄명몇몌모목몫몬몰몲몸몹못몽뫄뫈뫘뫙뫼"],["b941","툪툫툮툯툱툲툳툵",6,"툾퉀퉂",5,"퉉퉊퉋퉌"],["b961","퉍",14,"퉝",6,"퉥퉦퉧퉨"],["b981","퉩",22,"튂튃튅튆튇튉튊튋튌묀묄묍묏묑묘묜묠묩묫무묵묶문묻물묽묾뭄뭅뭇뭉뭍뭏뭐뭔뭘뭡뭣뭬뮈뮌뮐뮤뮨뮬뮴뮷므믄믈믐믓미믹민믿밀밂밈밉밋밌밍및밑바",4,"받",4,"밤밥밧방밭배백밴밸뱀뱁뱃뱄뱅뱉뱌뱍뱐뱝버벅번벋벌벎범법벗"],["ba41","튍튎튏튒튓튔튖",5,"튝튞튟튡튢튣튥",6,"튭"],["ba61","튮튯튰튲",5,"튺튻튽튾틁틃",4,"틊틌",5],["ba81","틒틓틕틖틗틙틚틛틝",6,"틦",9,"틲틳틵틶틷틹틺벙벚베벡벤벧벨벰벱벳벴벵벼벽변별볍볏볐병볕볘볜보복볶본볼봄봅봇봉봐봔봤봬뵀뵈뵉뵌뵐뵘뵙뵤뵨부북분붇불붉붊붐붑붓붕붙붚붜붤붰붸뷔뷕뷘뷜뷩뷰뷴뷸븀븃븅브븍븐블븜븝븟비빅빈빌빎빔빕빗빙빚빛빠빡빤"],["bb41","틻",4,"팂팄팆",5,"팏팑팒팓팕팗",4,"팞팢팣"],["bb61","팤팦팧팪팫팭팮팯팱",6,"팺팾",5,"퍆퍇퍈퍉"],["bb81","퍊",31,"빨빪빰빱빳빴빵빻빼빽뺀뺄뺌뺍뺏뺐뺑뺘뺙뺨뻐뻑뻔뻗뻘뻠뻣뻤뻥뻬뼁뼈뼉뼘뼙뼛뼜뼝뽀뽁뽄뽈뽐뽑뽕뾔뾰뿅뿌뿍뿐뿔뿜뿟뿡쀼쁑쁘쁜쁠쁨쁩삐삑삔삘삠삡삣삥사삭삯산삳살삵삶삼삽삿샀상샅새색샌샐샘샙샛샜생샤"],["bc41","퍪",17,"퍾퍿펁펂펃펅펆펇"],["bc61","펈펉펊펋펎펒",5,"펚펛펝펞펟펡",6,"펪펬펮"],["bc81","펯",4,"펵펶펷펹펺펻펽",6,"폆폇폊",5,"폑",5,"샥샨샬샴샵샷샹섀섄섈섐섕서",4,"섣설섦섧섬섭섯섰성섶세섹센셀셈셉셋셌셍셔셕션셜셤셥셧셨셩셰셴셸솅소속솎손솔솖솜솝솟송솥솨솩솬솰솽쇄쇈쇌쇔쇗쇘쇠쇤쇨쇰쇱쇳쇼쇽숀숄숌숍숏숑수숙순숟술숨숩숫숭"],["bd41","폗폙",7,"폢폤",7,"폮폯폱폲폳폵폶폷"],["bd61","폸폹폺폻폾퐀퐂",5,"퐉",13],["bd81","퐗",5,"퐞",25,"숯숱숲숴쉈쉐쉑쉔쉘쉠쉥쉬쉭쉰쉴쉼쉽쉿슁슈슉슐슘슛슝스슥슨슬슭슴습슷승시식신싣실싫심십싯싱싶싸싹싻싼쌀쌈쌉쌌쌍쌓쌔쌕쌘쌜쌤쌥쌨쌩썅써썩썬썰썲썸썹썼썽쎄쎈쎌쏀쏘쏙쏜쏟쏠쏢쏨쏩쏭쏴쏵쏸쐈쐐쐤쐬쐰"],["be41","퐸",7,"푁푂푃푅",14],["be61","푔",7,"푝푞푟푡푢푣푥",7,"푮푰푱푲"],["be81","푳",4,"푺푻푽푾풁풃",4,"풊풌풎",5,"풕",8,"쐴쐼쐽쑈쑤쑥쑨쑬쑴쑵쑹쒀쒔쒜쒸쒼쓩쓰쓱쓴쓸쓺쓿씀씁씌씐씔씜씨씩씬씰씸씹씻씽아악안앉않알앍앎앓암압앗았앙앝앞애액앤앨앰앱앳앴앵야약얀얄얇얌얍얏양얕얗얘얜얠얩어억언얹얻얼얽얾엄",6,"엌엎"],["bf41","풞",10,"풪",14],["bf61","풹",18,"퓍퓎퓏퓑퓒퓓퓕"],["bf81","퓖",5,"퓝퓞퓠",7,"퓩퓪퓫퓭퓮퓯퓱",6,"퓹퓺퓼에엑엔엘엠엡엣엥여역엮연열엶엷염",5,"옅옆옇예옌옐옘옙옛옜오옥온올옭옮옰옳옴옵옷옹옻와왁완왈왐왑왓왔왕왜왝왠왬왯왱외왹왼욀욈욉욋욍요욕욘욜욤욥욧용우욱운울욹욺움웁웃웅워웍원월웜웝웠웡웨"],["c041","퓾",5,"픅픆픇픉픊픋픍",6,"픖픘",5],["c061","픞",25],["c081","픸픹픺픻픾픿핁핂핃핅",6,"핎핐핒",5,"핚핛핝핞핟핡핢핣웩웬웰웸웹웽위윅윈윌윔윕윗윙유육윤율윰윱윳융윷으윽은을읊음읍읏응",7,"읜읠읨읫이익인일읽읾잃임입잇있잉잊잎자작잔잖잗잘잚잠잡잣잤장잦재잭잰잴잼잽잿쟀쟁쟈쟉쟌쟎쟐쟘쟝쟤쟨쟬저적전절젊"],["c141","핤핦핧핪핬핮",5,"핶핷핹핺핻핽",6,"햆햊햋"],["c161","햌햍햎햏햑",19,"햦햧"],["c181","햨",31,"점접젓정젖제젝젠젤젬젭젯젱져젼졀졈졉졌졍졔조족존졸졺좀좁좃종좆좇좋좌좍좔좝좟좡좨좼좽죄죈죌죔죕죗죙죠죡죤죵주죽준줄줅줆줌줍줏중줘줬줴쥐쥑쥔쥘쥠쥡쥣쥬쥰쥴쥼즈즉즌즐즘즙즛증지직진짇질짊짐집짓"],["c241","헊헋헍헎헏헑헓",4,"헚헜헞",5,"헦헧헩헪헫헭헮"],["c261","헯",4,"헶헸헺",5,"혂혃혅혆혇혉",6,"혒"],["c281","혖",5,"혝혞혟혡혢혣혥",7,"혮",9,"혺혻징짖짙짚짜짝짠짢짤짧짬짭짯짰짱째짹짼쨀쨈쨉쨋쨌쨍쨔쨘쨩쩌쩍쩐쩔쩜쩝쩟쩠쩡쩨쩽쪄쪘쪼쪽쫀쫄쫌쫍쫏쫑쫓쫘쫙쫠쫬쫴쬈쬐쬔쬘쬠쬡쭁쭈쭉쭌쭐쭘쭙쭝쭤쭸쭹쮜쮸쯔쯤쯧쯩찌찍찐찔찜찝찡찢찧차착찬찮찰참찹찻"],["c341","혽혾혿홁홂홃홄홆홇홊홌홎홏홐홒홓홖홗홙홚홛홝",4],["c361","홢",4,"홨홪",5,"홲홳홵",11],["c381","횁횂횄횆",5,"횎횏횑횒횓횕",7,"횞횠횢",5,"횩횪찼창찾채책챈챌챔챕챗챘챙챠챤챦챨챰챵처척천철첨첩첫첬청체첵첸첼쳄쳅쳇쳉쳐쳔쳤쳬쳰촁초촉촌촐촘촙촛총촤촨촬촹최쵠쵤쵬쵭쵯쵱쵸춈추축춘출춤춥춧충춰췄췌췐취췬췰췸췹췻췽츄츈츌츔츙츠측츤츨츰츱츳층"],["c441","횫횭횮횯횱",7,"횺횼",7,"훆훇훉훊훋"],["c461","훍훎훏훐훒훓훕훖훘훚",5,"훡훢훣훥훦훧훩",4],["c481","훮훯훱훲훳훴훶",5,"훾훿휁휂휃휅",11,"휒휓휔치칙친칟칠칡침칩칫칭카칵칸칼캄캅캇캉캐캑캔캘캠캡캣캤캥캬캭컁커컥컨컫컬컴컵컷컸컹케켁켄켈켐켑켓켕켜켠켤켬켭켯켰켱켸코콕콘콜콤콥콧콩콰콱콴콸쾀쾅쾌쾡쾨쾰쿄쿠쿡쿤쿨쿰쿱쿳쿵쿼퀀퀄퀑퀘퀭퀴퀵퀸퀼"],["c541","휕휖휗휚휛휝휞휟휡",6,"휪휬휮",5,"휶휷휹"],["c561","휺휻휽",6,"흅흆흈흊",5,"흒흓흕흚",4],["c581","흟흢흤흦흧흨흪흫흭흮흯흱흲흳흵",6,"흾흿힀힂",5,"힊힋큄큅큇큉큐큔큘큠크큭큰클큼큽킁키킥킨킬킴킵킷킹타탁탄탈탉탐탑탓탔탕태택탠탤탬탭탯탰탱탸턍터턱턴털턺텀텁텃텄텅테텍텐텔템텝텟텡텨텬텼톄톈토톡톤톨톰톱톳통톺톼퇀퇘퇴퇸툇툉툐투툭툰툴툼툽툿퉁퉈퉜"],["c641","힍힎힏힑",6,"힚힜힞",5],["c6a1","퉤튀튁튄튈튐튑튕튜튠튤튬튱트특튼튿틀틂틈틉틋틔틘틜틤틥티틱틴틸팀팁팃팅파팍팎판팔팖팜팝팟팠팡팥패팩팬팰팸팹팻팼팽퍄퍅퍼퍽펀펄펌펍펏펐펑페펙펜펠펨펩펫펭펴편펼폄폅폈평폐폘폡폣포폭폰폴폼폽폿퐁"],["c7a1","퐈퐝푀푄표푠푤푭푯푸푹푼푿풀풂품풉풋풍풔풩퓌퓐퓔퓜퓟퓨퓬퓰퓸퓻퓽프픈플픔픕픗피픽핀필핌핍핏핑하학한할핥함합핫항해핵핸핼햄햅햇했행햐향허헉헌헐헒험헙헛헝헤헥헨헬헴헵헷헹혀혁현혈혐협혓혔형혜혠"],["c8a1","혤혭호혹혼홀홅홈홉홋홍홑화확환활홧황홰홱홴횃횅회획횐횔횝횟횡효횬횰횹횻후훅훈훌훑훔훗훙훠훤훨훰훵훼훽휀휄휑휘휙휜휠휨휩휫휭휴휵휸휼흄흇흉흐흑흔흖흗흘흙흠흡흣흥흩희흰흴흼흽힁히힉힌힐힘힙힛힝"],["caa1","伽佳假價加可呵哥嘉嫁家暇架枷柯歌珂痂稼苛茄街袈訶賈跏軻迦駕刻却各恪慤殼珏脚覺角閣侃刊墾奸姦干幹懇揀杆柬桿澗癎看磵稈竿簡肝艮艱諫間乫喝曷渴碣竭葛褐蝎鞨勘坎堪嵌感憾戡敢柑橄減甘疳監瞰紺邯鑑鑒龕"],["cba1","匣岬甲胛鉀閘剛堈姜岡崗康强彊慷江畺疆糠絳綱羌腔舡薑襁講鋼降鱇介价個凱塏愷愾慨改槪漑疥皆盖箇芥蓋豈鎧開喀客坑更粳羹醵倨去居巨拒据據擧渠炬祛距踞車遽鉅鋸乾件健巾建愆楗腱虔蹇鍵騫乞傑杰桀儉劍劒檢"],["cca1","瞼鈐黔劫怯迲偈憩揭擊格檄激膈覡隔堅牽犬甄絹繭肩見譴遣鵑抉決潔結缺訣兼慊箝謙鉗鎌京俓倞傾儆勁勍卿坰境庚徑慶憬擎敬景暻更梗涇炅烱璟璥瓊痙硬磬竟競絅經耕耿脛莖警輕逕鏡頃頸驚鯨係啓堺契季屆悸戒桂械"],["cda1","棨溪界癸磎稽系繫繼計誡谿階鷄古叩告呱固姑孤尻庫拷攷故敲暠枯槁沽痼皐睾稿羔考股膏苦苽菰藁蠱袴誥賈辜錮雇顧高鼓哭斛曲梏穀谷鵠困坤崑昆梱棍滾琨袞鯤汨滑骨供公共功孔工恐恭拱控攻珙空蚣貢鞏串寡戈果瓜"],["cea1","科菓誇課跨過鍋顆廓槨藿郭串冠官寬慣棺款灌琯瓘管罐菅觀貫關館刮恝括适侊光匡壙廣曠洸炚狂珖筐胱鑛卦掛罫乖傀塊壞怪愧拐槐魁宏紘肱轟交僑咬喬嬌嶠巧攪敎校橋狡皎矯絞翹膠蕎蛟較轎郊餃驕鮫丘久九仇俱具勾"],["cfa1","區口句咎嘔坵垢寇嶇廐懼拘救枸柩構歐毆毬求溝灸狗玖球瞿矩究絿耉臼舅舊苟衢謳購軀逑邱鉤銶駒驅鳩鷗龜國局菊鞠鞫麴君窘群裙軍郡堀屈掘窟宮弓穹窮芎躬倦券勸卷圈拳捲權淃眷厥獗蕨蹶闕机櫃潰詭軌饋句晷歸貴"],["d0a1","鬼龜叫圭奎揆槻珪硅窺竅糾葵規赳逵閨勻均畇筠菌鈞龜橘克剋劇戟棘極隙僅劤勤懃斤根槿瑾筋芹菫覲謹近饉契今妗擒昑檎琴禁禽芩衾衿襟金錦伋及急扱汲級給亘兢矜肯企伎其冀嗜器圻基埼夔奇妓寄岐崎己幾忌技旗旣"],["d1a1","朞期杞棋棄機欺氣汽沂淇玘琦琪璂璣畸畿碁磯祁祇祈祺箕紀綺羈耆耭肌記譏豈起錡錤飢饑騎騏驥麒緊佶吉拮桔金喫儺喇奈娜懦懶拏拿癩",5,"那樂",4,"諾酪駱亂卵暖欄煖爛蘭難鸞捏捺南嵐枏楠湳濫男藍襤拉"],["d2a1","納臘蠟衲囊娘廊",4,"乃來內奈柰耐冷女年撚秊念恬拈捻寧寗努勞奴弩怒擄櫓爐瑙盧",5,"駑魯",10,"濃籠聾膿農惱牢磊腦賂雷尿壘",7,"嫩訥杻紐勒",5,"能菱陵尼泥匿溺多茶"],["d3a1","丹亶但單團壇彖斷旦檀段湍短端簞緞蛋袒鄲鍛撻澾獺疸達啖坍憺擔曇淡湛潭澹痰聃膽蕁覃談譚錟沓畓答踏遝唐堂塘幢戇撞棠當糖螳黨代垈坮大對岱帶待戴擡玳臺袋貸隊黛宅德悳倒刀到圖堵塗導屠島嶋度徒悼挑掉搗桃"],["d4a1","棹櫂淘渡滔濤燾盜睹禱稻萄覩賭跳蹈逃途道都鍍陶韜毒瀆牘犢獨督禿篤纛讀墩惇敦旽暾沌焞燉豚頓乭突仝冬凍動同憧東桐棟洞潼疼瞳童胴董銅兜斗杜枓痘竇荳讀豆逗頭屯臀芚遁遯鈍得嶝橙燈登等藤謄鄧騰喇懶拏癩羅"],["d5a1","蘿螺裸邏樂洛烙珞絡落諾酪駱丹亂卵欄欒瀾爛蘭鸞剌辣嵐擥攬欖濫籃纜藍襤覽拉臘蠟廊朗浪狼琅瑯螂郞來崍徠萊冷掠略亮倆兩凉梁樑粮粱糧良諒輛量侶儷勵呂廬慮戾旅櫚濾礪藜蠣閭驢驪麗黎力曆歷瀝礫轢靂憐戀攣漣"],["d6a1","煉璉練聯蓮輦連鍊冽列劣洌烈裂廉斂殮濂簾獵令伶囹寧岺嶺怜玲笭羚翎聆逞鈴零靈領齡例澧禮醴隷勞怒撈擄櫓潞瀘爐盧老蘆虜路輅露魯鷺鹵碌祿綠菉錄鹿麓論壟弄朧瀧瓏籠聾儡瀨牢磊賂賚賴雷了僚寮廖料燎療瞭聊蓼"],["d7a1","遼鬧龍壘婁屢樓淚漏瘻累縷蔞褸鏤陋劉旒柳榴流溜瀏琉瑠留瘤硫謬類六戮陸侖倫崙淪綸輪律慄栗率隆勒肋凜凌楞稜綾菱陵俚利厘吏唎履悧李梨浬犁狸理璃異痢籬罹羸莉裏裡里釐離鯉吝潾燐璘藺躪隣鱗麟林淋琳臨霖砬"],["d8a1","立笠粒摩瑪痲碼磨馬魔麻寞幕漠膜莫邈万卍娩巒彎慢挽晩曼滿漫灣瞞萬蔓蠻輓饅鰻唜抹末沫茉襪靺亡妄忘忙望網罔芒茫莽輞邙埋妹媒寐昧枚梅每煤罵買賣邁魅脈貊陌驀麥孟氓猛盲盟萌冪覓免冕勉棉沔眄眠綿緬面麵滅"],["d9a1","蔑冥名命明暝椧溟皿瞑茗蓂螟酩銘鳴袂侮冒募姆帽慕摸摹暮某模母毛牟牡瑁眸矛耗芼茅謀謨貌木沐牧目睦穆鶩歿沒夢朦蒙卯墓妙廟描昴杳渺猫竗苗錨務巫憮懋戊拇撫无楙武毋無珷畝繆舞茂蕪誣貿霧鵡墨默們刎吻問文"],["daa1","汶紊紋聞蚊門雯勿沕物味媚尾嵋彌微未梶楣渼湄眉米美薇謎迷靡黴岷悶愍憫敏旻旼民泯玟珉緡閔密蜜謐剝博拍搏撲朴樸泊珀璞箔粕縛膊舶薄迫雹駁伴半反叛拌搬攀斑槃泮潘班畔瘢盤盼磐磻礬絆般蟠返頒飯勃拔撥渤潑"],["dba1","發跋醱鉢髮魃倣傍坊妨尨幇彷房放方旁昉枋榜滂磅紡肪膀舫芳蒡蚌訪謗邦防龐倍俳北培徘拜排杯湃焙盃背胚裴裵褙賠輩配陪伯佰帛柏栢白百魄幡樊煩燔番磻繁蕃藩飜伐筏罰閥凡帆梵氾汎泛犯範范法琺僻劈壁擘檗璧癖"],["dca1","碧蘗闢霹便卞弁變辨辯邊別瞥鱉鼈丙倂兵屛幷昞昺柄棅炳甁病秉竝輧餠騈保堡報寶普步洑湺潽珤甫菩補褓譜輔伏僕匐卜宓復服福腹茯蔔複覆輹輻馥鰒本乶俸奉封峯峰捧棒烽熢琫縫蓬蜂逢鋒鳳不付俯傅剖副否咐埠夫婦"],["dda1","孚孵富府復扶敷斧浮溥父符簿缶腐腑膚艀芙莩訃負賦賻赴趺部釜阜附駙鳧北分吩噴墳奔奮忿憤扮昐汾焚盆粉糞紛芬賁雰不佛弗彿拂崩朋棚硼繃鵬丕備匕匪卑妃婢庇悲憊扉批斐枇榧比毖毗毘沸泌琵痺砒碑秕秘粃緋翡肥"],["dea1","脾臂菲蜚裨誹譬費鄙非飛鼻嚬嬪彬斌檳殯浜濱瀕牝玭貧賓頻憑氷聘騁乍事些仕伺似使俟僿史司唆嗣四士奢娑寫寺射巳師徙思捨斜斯柶査梭死沙泗渣瀉獅砂社祀祠私篩紗絲肆舍莎蓑蛇裟詐詞謝賜赦辭邪飼駟麝削數朔索"],["dfa1","傘刪山散汕珊産疝算蒜酸霰乷撒殺煞薩三參杉森渗芟蔘衫揷澁鈒颯上傷像償商喪嘗孀尙峠常床庠廂想桑橡湘爽牀狀相祥箱翔裳觴詳象賞霜塞璽賽嗇塞穡索色牲生甥省笙墅壻嶼序庶徐恕抒捿敍暑曙書栖棲犀瑞筮絮緖署"],["e0a1","胥舒薯西誓逝鋤黍鼠夕奭席惜昔晳析汐淅潟石碩蓆釋錫仙僊先善嬋宣扇敾旋渲煽琁瑄璇璿癬禪線繕羨腺膳船蘚蟬詵跣選銑鐥饍鮮卨屑楔泄洩渫舌薛褻設說雪齧剡暹殲纖蟾贍閃陝攝涉燮葉城姓宬性惺成星晟猩珹盛省筬"],["e1a1","聖聲腥誠醒世勢歲洗稅笹細說貰召嘯塑宵小少巢所掃搔昭梳沼消溯瀟炤燒甦疏疎瘙笑篠簫素紹蔬蕭蘇訴逍遡邵銷韶騷俗屬束涑粟續謖贖速孫巽損蓀遜飡率宋悚松淞訟誦送頌刷殺灑碎鎖衰釗修受嗽囚垂壽嫂守岫峀帥愁"],["e2a1","戍手授搜收數樹殊水洙漱燧狩獸琇璲瘦睡秀穗竪粹綏綬繡羞脩茱蒐蓚藪袖誰讐輸遂邃酬銖銹隋隧隨雖需須首髓鬚叔塾夙孰宿淑潚熟琡璹肅菽巡徇循恂旬栒楯橓殉洵淳珣盾瞬筍純脣舜荀蓴蕣詢諄醇錞順馴戌術述鉥崇崧"],["e3a1","嵩瑟膝蝨濕拾習褶襲丞乘僧勝升承昇繩蠅陞侍匙嘶始媤尸屎屍市弑恃施是時枾柴猜矢示翅蒔蓍視試詩諡豕豺埴寔式息拭植殖湜熄篒蝕識軾食飾伸侁信呻娠宸愼新晨燼申神紳腎臣莘薪藎蜃訊身辛辰迅失室實悉審尋心沁"],["e4a1","沈深瀋甚芯諶什十拾雙氏亞俄兒啞娥峨我牙芽莪蛾衙訝阿雅餓鴉鵝堊岳嶽幄惡愕握樂渥鄂鍔顎鰐齷安岸按晏案眼雁鞍顔鮟斡謁軋閼唵岩巖庵暗癌菴闇壓押狎鴨仰央怏昻殃秧鴦厓哀埃崖愛曖涯碍艾隘靄厄扼掖液縊腋額"],["e5a1","櫻罌鶯鸚也倻冶夜惹揶椰爺耶若野弱掠略約若葯蒻藥躍亮佯兩凉壤孃恙揚攘敭暘梁楊樣洋瀁煬痒瘍禳穰糧羊良襄諒讓釀陽量養圄御於漁瘀禦語馭魚齬億憶抑檍臆偃堰彦焉言諺孼蘖俺儼嚴奄掩淹嶪業円予余勵呂女如廬"],["e6a1","旅歟汝濾璵礖礪與艅茹輿轝閭餘驪麗黎亦力域役易曆歷疫繹譯轢逆驛嚥堧姸娟宴年延憐戀捐挻撚椽沇沿涎涓淵演漣烟然煙煉燃燕璉硏硯秊筵緣練縯聯衍軟輦蓮連鉛鍊鳶列劣咽悅涅烈熱裂說閱厭廉念捻染殮炎焰琰艶苒"],["e7a1","簾閻髥鹽曄獵燁葉令囹塋寧嶺嶸影怜映暎楹榮永泳渶潁濚瀛瀯煐營獰玲瑛瑩瓔盈穎纓羚聆英詠迎鈴鍈零霙靈領乂倪例刈叡曳汭濊猊睿穢芮藝蘂禮裔詣譽豫醴銳隸霓預五伍俉傲午吾吳嗚塢墺奧娛寤悟惡懊敖旿晤梧汚澳"],["e8a1","烏熬獒筽蜈誤鰲鼇屋沃獄玉鈺溫瑥瘟穩縕蘊兀壅擁瓮甕癰翁邕雍饔渦瓦窩窪臥蛙蝸訛婉完宛梡椀浣玩琓琬碗緩翫脘腕莞豌阮頑曰往旺枉汪王倭娃歪矮外嵬巍猥畏了僚僥凹堯夭妖姚寥寮尿嶢拗搖撓擾料曜樂橈燎燿瑤療"],["e9a1","窈窯繇繞耀腰蓼蟯要謠遙遼邀饒慾欲浴縟褥辱俑傭冗勇埇墉容庸慂榕涌湧溶熔瑢用甬聳茸蓉踊鎔鏞龍于佑偶優又友右宇寓尤愚憂旴牛玗瑀盂祐禑禹紆羽芋藕虞迂遇郵釪隅雨雩勖彧旭昱栯煜稶郁頊云暈橒殞澐熉耘芸蕓"],["eaa1","運隕雲韻蔚鬱亐熊雄元原員圓園垣媛嫄寃怨愿援沅洹湲源爰猿瑗苑袁轅遠阮院願鴛月越鉞位偉僞危圍委威尉慰暐渭爲瑋緯胃萎葦蔿蝟衛褘謂違韋魏乳侑儒兪劉唯喩孺宥幼幽庾悠惟愈愉揄攸有杻柔柚柳楡楢油洧流游溜"],["eba1","濡猶猷琉瑜由留癒硫紐維臾萸裕誘諛諭踰蹂遊逾遺酉釉鍮類六堉戮毓肉育陸倫允奫尹崙淪潤玧胤贇輪鈗閏律慄栗率聿戎瀜絨融隆垠恩慇殷誾銀隱乙吟淫蔭陰音飮揖泣邑凝應膺鷹依倚儀宜意懿擬椅毅疑矣義艤薏蟻衣誼"],["eca1","議醫二以伊利吏夷姨履已弛彛怡易李梨泥爾珥理異痍痢移罹而耳肄苡荑裏裡貽貳邇里離飴餌匿溺瀷益翊翌翼謚人仁刃印吝咽因姻寅引忍湮燐璘絪茵藺蚓認隣靭靷鱗麟一佚佾壹日溢逸鎰馹任壬妊姙恁林淋稔臨荏賃入卄"],["eda1","立笠粒仍剩孕芿仔刺咨姉姿子字孜恣慈滋炙煮玆瓷疵磁紫者自茨蔗藉諮資雌作勺嚼斫昨灼炸爵綽芍酌雀鵲孱棧殘潺盞岑暫潛箴簪蠶雜丈仗匠場墻壯奬將帳庄張掌暲杖樟檣欌漿牆狀獐璋章粧腸臟臧莊葬蔣薔藏裝贓醬長"],["eea1","障再哉在宰才材栽梓渽滓災縡裁財載齋齎爭箏諍錚佇低儲咀姐底抵杵楮樗沮渚狙猪疽箸紵苧菹著藷詛貯躇這邸雎齟勣吊嫡寂摘敵滴狄炙的積笛籍績翟荻謫賊赤跡蹟迪迹適鏑佃佺傳全典前剪塡塼奠專展廛悛戰栓殿氈澱"],["efa1","煎琠田甸畑癲筌箋箭篆纏詮輾轉鈿銓錢鐫電顚顫餞切截折浙癤竊節絶占岾店漸点粘霑鮎點接摺蝶丁井亭停偵呈姃定幀庭廷征情挺政整旌晶晸柾楨檉正汀淀淨渟湞瀞炡玎珽町睛碇禎程穽精綎艇訂諪貞鄭酊釘鉦鋌錠霆靖"],["f0a1","靜頂鼎制劑啼堤帝弟悌提梯濟祭第臍薺製諸蹄醍除際霽題齊俎兆凋助嘲弔彫措操早晁曺曹朝條棗槽漕潮照燥爪璪眺祖祚租稠窕粗糟組繰肇藻蚤詔調趙躁造遭釣阻雕鳥族簇足鏃存尊卒拙猝倧宗從悰慫棕淙琮種終綜縱腫"],["f1a1","踪踵鍾鐘佐坐左座挫罪主住侏做姝胄呪周嗾奏宙州廚晝朱柱株注洲湊澍炷珠疇籌紂紬綢舟蛛註誅走躊輳週酎酒鑄駐竹粥俊儁准埈寯峻晙樽浚準濬焌畯竣蠢逡遵雋駿茁中仲衆重卽櫛楫汁葺增憎曾拯烝甑症繒蒸證贈之只"],["f2a1","咫地址志持指摯支旨智枝枳止池沚漬知砥祉祗紙肢脂至芝芷蜘誌識贄趾遲直稙稷織職唇嗔塵振搢晉晋桭榛殄津溱珍瑨璡畛疹盡眞瞋秦縉縝臻蔯袗診賑軫辰進鎭陣陳震侄叱姪嫉帙桎瓆疾秩窒膣蛭質跌迭斟朕什執潗緝輯"],["f3a1","鏶集徵懲澄且侘借叉嗟嵯差次此磋箚茶蹉車遮捉搾着窄錯鑿齪撰澯燦璨瓚竄簒纂粲纘讚贊鑽餐饌刹察擦札紮僭參塹慘慙懺斬站讒讖倉倡創唱娼廠彰愴敞昌昶暢槍滄漲猖瘡窓脹艙菖蒼債埰寀寨彩採砦綵菜蔡采釵冊柵策"],["f4a1","責凄妻悽處倜刺剔尺慽戚拓擲斥滌瘠脊蹠陟隻仟千喘天川擅泉淺玔穿舛薦賤踐遷釧闡阡韆凸哲喆徹撤澈綴輟轍鐵僉尖沾添甛瞻簽籤詹諂堞妾帖捷牒疊睫諜貼輒廳晴淸聽菁請靑鯖切剃替涕滯締諦逮遞體初剿哨憔抄招梢"],["f5a1","椒楚樵炒焦硝礁礎秒稍肖艸苕草蕉貂超酢醋醮促囑燭矗蜀觸寸忖村邨叢塚寵悤憁摠總聰蔥銃撮催崔最墜抽推椎楸樞湫皺秋芻萩諏趨追鄒酋醜錐錘鎚雛騶鰍丑畜祝竺筑築縮蓄蹙蹴軸逐春椿瑃出朮黜充忠沖蟲衝衷悴膵萃"],["f6a1","贅取吹嘴娶就炊翠聚脆臭趣醉驟鷲側仄厠惻測層侈値嗤峙幟恥梔治淄熾痔痴癡稚穉緇緻置致蚩輜雉馳齒則勅飭親七柒漆侵寢枕沈浸琛砧針鍼蟄秤稱快他咤唾墮妥惰打拖朶楕舵陀馱駝倬卓啄坼度托拓擢晫柝濁濯琢琸託"],["f7a1","鐸呑嘆坦彈憚歎灘炭綻誕奪脫探眈耽貪塔搭榻宕帑湯糖蕩兌台太怠態殆汰泰笞胎苔跆邰颱宅擇澤撑攄兎吐土討慟桶洞痛筒統通堆槌腿褪退頹偸套妬投透鬪慝特闖坡婆巴把播擺杷波派爬琶破罷芭跛頗判坂板版瓣販辦鈑"],["f8a1","阪八叭捌佩唄悖敗沛浿牌狽稗覇貝彭澎烹膨愎便偏扁片篇編翩遍鞭騙貶坪平枰萍評吠嬖幣廢弊斃肺蔽閉陛佈包匍匏咆哺圃布怖抛抱捕暴泡浦疱砲胞脯苞葡蒲袍褒逋鋪飽鮑幅暴曝瀑爆輻俵剽彪慓杓標漂瓢票表豹飇飄驃"],["f9a1","品稟楓諷豊風馮彼披疲皮被避陂匹弼必泌珌畢疋筆苾馝乏逼下何厦夏廈昰河瑕荷蝦賀遐霞鰕壑學虐謔鶴寒恨悍旱汗漢澣瀚罕翰閑閒限韓割轄函含咸啣喊檻涵緘艦銜陷鹹合哈盒蛤閤闔陜亢伉姮嫦巷恒抗杭桁沆港缸肛航"],["faa1","行降項亥偕咳垓奚孩害懈楷海瀣蟹解該諧邂駭骸劾核倖幸杏荇行享向嚮珦鄕響餉饗香噓墟虛許憲櫶獻軒歇險驗奕爀赫革俔峴弦懸晛泫炫玄玹現眩睍絃絢縣舷衒見賢鉉顯孑穴血頁嫌俠協夾峽挾浹狹脅脇莢鋏頰亨兄刑型"],["fba1","形泂滎瀅灐炯熒珩瑩荊螢衡逈邢鎣馨兮彗惠慧暳蕙蹊醯鞋乎互呼壕壺好岵弧戶扈昊晧毫浩淏湖滸澔濠濩灝狐琥瑚瓠皓祜糊縞胡芦葫蒿虎號蝴護豪鎬頀顥惑或酷婚昏混渾琿魂忽惚笏哄弘汞泓洪烘紅虹訌鴻化和嬅樺火畵"],["fca1","禍禾花華話譁貨靴廓擴攫確碻穫丸喚奐宦幻患換歡晥桓渙煥環紈還驩鰥活滑猾豁闊凰幌徨恍惶愰慌晃晄榥況湟滉潢煌璜皇篁簧荒蝗遑隍黃匯回廻徊恢悔懷晦會檜淮澮灰獪繪膾茴蛔誨賄劃獲宖橫鐄哮嚆孝效斅曉梟涍淆"],["fda1","爻肴酵驍侯候厚后吼喉嗅帿後朽煦珝逅勛勳塤壎焄熏燻薰訓暈薨喧暄煊萱卉喙毁彙徽揮暉煇諱輝麾休携烋畦虧恤譎鷸兇凶匈洶胸黑昕欣炘痕吃屹紇訖欠欽歆吸恰洽翕興僖凞喜噫囍姬嬉希憙憘戱晞曦熙熹熺犧禧稀羲詰"]]

/***/ }),
/* 1280 */
/***/ (function(module, exports) {

module.exports = [["8740","䏰䰲䘃䖦䕸𧉧䵷䖳𧲱䳢𧳅㮕䜶䝄䱇䱀𤊿𣘗𧍒𦺋𧃒䱗𪍑䝏䗚䲅𧱬䴇䪤䚡𦬣爥𥩔𡩣𣸆𣽡晍囻"],["8767","綕夝𨮹㷴霴𧯯寛𡵞媤㘥𩺰嫑宷峼杮薓𩥅瑡璝㡵𡵓𣚞𦀡㻬"],["87a1","𥣞㫵竼龗𤅡𨤍𣇪𠪊𣉞䌊蒄龖鐯䤰蘓墖靊鈘秐稲晠権袝瑌篅枂稬剏遆㓦珄𥶹瓆鿇垳䤯呌䄱𣚎堘穲𧭥讏䚮𦺈䆁𥶙箮𢒼鿈𢓁𢓉𢓌鿉蔄𣖻䂴鿊䓡𪷿拁灮鿋"],["8840","㇀",4,"𠄌㇅𠃑𠃍㇆㇇𠃋𡿨㇈𠃊㇉㇊㇋㇌𠄎㇍㇎ĀÁǍÀĒÉĚÈŌÓǑÒ࿿Ê̄Ế࿿Ê̌ỀÊāáǎàɑēéěèīíǐìōóǒòūúǔùǖǘǚ"],["88a1","ǜü࿿ê̄ế࿿ê̌ềêɡ⏚⏛"],["8940","𪎩𡅅"],["8943","攊"],["8946","丽滝鵎釟"],["894c","𧜵撑会伨侨兖兴农凤务动医华发变团声处备夲头学实実岚庆总斉柾栄桥济炼电纤纬纺织经统缆缷艺苏药视设询车轧轮"],["89a1","琑糼緍楆竉刧"],["89ab","醌碸酞肼"],["89b0","贋胶𠧧"],["89b5","肟黇䳍鷉鸌䰾𩷶𧀎鸊𪄳㗁"],["89c1","溚舾甙"],["89c5","䤑马骏龙禇𨑬𡷊𠗐𢫦两亁亀亇亿仫伷㑌侽㹈倃傈㑽㒓㒥円夅凛凼刅争剹劐匧㗇厩㕑厰㕓参吣㕭㕲㚁咓咣咴咹哐哯唘唣唨㖘唿㖥㖿嗗㗅"],["8a40","𧶄唥"],["8a43","𠱂𠴕𥄫喐𢳆㧬𠍁蹆𤶸𩓥䁓𨂾睺𢰸㨴䟕𨅝𦧲𤷪擝𠵼𠾴𠳕𡃴撍蹾𠺖𠰋𠽤𢲩𨉖𤓓"],["8a64","𠵆𩩍𨃩䟴𤺧𢳂骲㩧𩗴㿭㔆𥋇𩟔𧣈𢵄鵮頕"],["8a76","䏙𦂥撴哣𢵌𢯊𡁷㧻𡁯"],["8aa1","𦛚𦜖𧦠擪𥁒𠱃蹨𢆡𨭌𠜱"],["8aac","䠋𠆩㿺塳𢶍"],["8ab2","𤗈𠓼𦂗𠽌𠶖啹䂻䎺"],["8abb","䪴𢩦𡂝膪飵𠶜捹㧾𢝵跀嚡摼㹃"],["8ac9","𪘁𠸉𢫏𢳉"],["8ace","𡃈𣧂㦒㨆𨊛㕸𥹉𢃇噒𠼱𢲲𩜠㒼氽𤸻"],["8adf","𧕴𢺋𢈈𪙛𨳍𠹺𠰴𦠜羓𡃏𢠃𢤹㗻𥇣𠺌𠾍𠺪㾓𠼰𠵇𡅏𠹌"],["8af6","𠺫𠮩𠵈𡃀𡄽㿹𢚖搲𠾭"],["8b40","𣏴𧘹𢯎𠵾𠵿𢱑𢱕㨘𠺘𡃇𠼮𪘲𦭐𨳒𨶙𨳊閪哌苄喹"],["8b55","𩻃鰦骶𧝞𢷮煀腭胬尜𦕲脴㞗卟𨂽醶𠻺𠸏𠹷𠻻㗝𤷫㘉𠳖嚯𢞵𡃉𠸐𠹸𡁸𡅈𨈇𡑕𠹹𤹐𢶤婔𡀝𡀞𡃵𡃶垜𠸑"],["8ba1","𧚔𨋍𠾵𠹻𥅾㜃𠾶𡆀𥋘𪊽𤧚𡠺𤅷𨉼墙剨㘚𥜽箲孨䠀䬬鼧䧧鰟鮍𥭴𣄽嗻㗲嚉丨夂𡯁屮靑𠂆乛亻㔾尣彑忄㣺扌攵歺氵氺灬爫丬犭𤣩罒礻糹罓𦉪㓁"],["8bde","𦍋耂肀𦘒𦥑卝衤见𧢲讠贝钅镸长门𨸏韦页风飞饣𩠐鱼鸟黄歯龜丷𠂇阝户钢"],["8c40","倻淾𩱳龦㷉袏𤅎灷峵䬠𥇍㕙𥴰愢𨨲辧釶熑朙玺𣊁𪄇㲋𡦀䬐磤琂冮𨜏䀉橣𪊺䈣蘏𠩯稪𩥇𨫪靕灍匤𢁾鏴盙𨧣龧矝亣俰傼丯众龨吴綋墒壐𡶶庒庙忂𢜒斋"],["8ca1","𣏹椙橃𣱣泿"],["8ca7","爀𤔅玌㻛𤨓嬕璹讃𥲤𥚕窓篬糃繬苸薗龩袐龪躹龫迏蕟駠鈡龬𨶹𡐿䁱䊢娚"],["8cc9","顨杫䉶圽"],["8cce","藖𤥻芿𧄍䲁𦵴嵻𦬕𦾾龭龮宖龯曧繛湗秊㶈䓃𣉖𢞖䎚䔶"],["8ce6","峕𣬚諹屸㴒𣕑嵸龲煗䕘𤃬𡸣䱷㥸㑊𠆤𦱁諌侴𠈹妿腬顖𩣺弻"],["8d40","𠮟"],["8d42","𢇁𨥭䄂䚻𩁹㼇龳𪆵䃸㟖䛷𦱆䅼𨚲𧏿䕭㣔𥒚䕡䔛䶉䱻䵶䗪㿈𤬏㙡䓞䒽䇭崾嵈嵖㷼㠏嶤嶹㠠㠸幂庽弥徃㤈㤔㤿㥍惗愽峥㦉憷憹懏㦸戬抐拥挘㧸嚱"],["8da1","㨃揢揻搇摚㩋擀崕嘡龟㪗斆㪽旿晓㫲暒㬢朖㭂枤栀㭘桊梄㭲㭱㭻椉楃牜楤榟榅㮼槖㯝橥橴橱檂㯬檙㯲檫檵櫔櫶殁毁毪汵沪㳋洂洆洦涁㳯涤涱渕渘温溆𨧀溻滢滚齿滨滩漤漴㵆𣽁澁澾㵪㵵熷岙㶊瀬㶑灐灔灯灿炉𠌥䏁㗱𠻘"],["8e40","𣻗垾𦻓焾𥟠㙎榢𨯩孴穉𥣡𩓙穥穽𥦬窻窰竂竃燑𦒍䇊竚竝竪䇯咲𥰁笋筕笩𥌎𥳾箢筯莜𥮴𦱿篐萡箒箸𥴠㶭𥱥蒒篺簆簵𥳁籄粃𤢂粦晽𤕸糉糇糦籴糳糵糎"],["8ea1","繧䔝𦹄絝𦻖璍綉綫焵綳緒𤁗𦀩緤㴓緵𡟹緥𨍭縝𦄡𦅚繮纒䌫鑬縧罀罁罇礶𦋐駡羗𦍑羣𡙡𠁨䕜𣝦䔃𨌺翺𦒉者耈耝耨耯𪂇𦳃耻耼聡𢜔䦉𦘦𣷣𦛨朥肧𨩈脇脚墰𢛶汿𦒘𤾸擧𡒊舘𡡞橓𤩥𤪕䑺舩𠬍𦩒𣵾俹𡓽蓢荢𦬊𤦧𣔰𡝳𣷸芪椛芳䇛"],["8f40","蕋苐茚𠸖𡞴㛁𣅽𣕚艻苢茘𣺋𦶣𦬅𦮗𣗎㶿茝嗬莅䔋𦶥莬菁菓㑾𦻔橗蕚㒖𦹂𢻯葘𥯤葱㷓䓤檧葊𣲵祘蒨𦮖𦹷𦹃蓞萏莑䒠蒓蓤𥲑䉀𥳀䕃蔴嫲𦺙䔧蕳䔖枿蘖"],["8fa1","𨘥𨘻藁𧂈蘂𡖂𧃍䕫䕪蘨㙈𡢢号𧎚虾蝱𪃸蟮𢰧螱蟚蠏噡虬桖䘏衅衆𧗠𣶹𧗤衞袜䙛袴袵揁装睷𧜏覇覊覦覩覧覼𨨥觧𧤤𧪽誜瞓釾誐𧩙竩𧬺𣾏䜓𧬸煼謌謟𥐰𥕥謿譌譍誩𤩺讐讛誯𡛟䘕衏貛𧵔𧶏貫㜥𧵓賖𧶘𧶽贒贃𡤐賛灜贑𤳉㻐起"],["9040","趩𨀂𡀔𤦊㭼𨆼𧄌竧躭躶軃鋔輙輭𨍥𨐒辥錃𪊟𠩐辳䤪𨧞𨔽𣶻廸𣉢迹𪀔𨚼𨔁𢌥㦀𦻗逷𨔼𧪾遡𨕬𨘋邨𨜓郄𨛦邮都酧㫰醩釄粬𨤳𡺉鈎沟鉁鉢𥖹銹𨫆𣲛𨬌𥗛"],["90a1","𠴱錬鍫𨫡𨯫炏嫃𨫢𨫥䥥鉄𨯬𨰹𨯿鍳鑛躼閅閦鐦閠濶䊹𢙺𨛘𡉼𣸮䧟氜陻隖䅬隣𦻕懚隶磵𨫠隽双䦡𦲸𠉴𦐐𩂯𩃥𤫑𡤕𣌊霱虂霶䨏䔽䖅𤫩灵孁霛靜𩇕靗孊𩇫靟鐥僐𣂷𣂼鞉鞟鞱鞾韀韒韠𥑬韮琜𩐳響韵𩐝𧥺䫑頴頳顋顦㬎𧅵㵑𠘰𤅜"],["9140","𥜆飊颷飈飇䫿𦴧𡛓喰飡飦飬鍸餹𤨩䭲𩡗𩤅駵騌騻騐驘𥜥㛄𩂱𩯕髠髢𩬅髴䰎鬔鬭𨘀倴鬴𦦨㣃𣁽魐魀𩴾婅𡡣鮎𤉋鰂鯿鰌𩹨鷔𩾷𪆒𪆫𪃡𪄣𪇟鵾鶃𪄴鸎梈"],["91a1","鷄𢅛𪆓𪈠𡤻𪈳鴹𪂹𪊴麐麕麞麢䴴麪麯𤍤黁㭠㧥㴝伲㞾𨰫鼂鼈䮖鐤𦶢鼗鼖鼹嚟嚊齅馸𩂋韲葿齢齩竜龎爖䮾𤥵𤦻煷𤧸𤍈𤩑玞𨯚𡣺禟𨥾𨸶鍩鏳𨩄鋬鎁鏋𨥬𤒹爗㻫睲穃烐𤑳𤏸煾𡟯炣𡢾𣖙㻇𡢅𥐯𡟸㜢𡛻𡠹㛡𡝴𡣑𥽋㜣𡛀坛𤨥𡏾𡊨"],["9240","𡏆𡒶蔃𣚦蔃葕𤦔𧅥𣸱𥕜𣻻𧁒䓴𣛮𩦝𦼦柹㜳㰕㷧塬𡤢栐䁗𣜿𤃡𤂋𤄏𦰡哋嚞𦚱嚒𠿟𠮨𠸍鏆𨬓鎜仸儫㠙𤐶亼𠑥𠍿佋侊𥙑婨𠆫𠏋㦙𠌊𠐔㐵伩𠋀𨺳𠉵諚𠈌亘"],["92a1","働儍侢伃𤨎𣺊佂倮偬傁俌俥偘僼兙兛兝兞湶𣖕𣸹𣺿浲𡢄𣺉冨凃𠗠䓝𠒣𠒒𠒑赺𨪜𠜎剙劤𠡳勡鍮䙺熌𤎌𠰠𤦬𡃤槑𠸝瑹㻞璙琔瑖玘䮎𤪼𤂍叐㖄爏𤃉喴𠍅响𠯆圝鉝雴鍦埝垍坿㘾壋媙𨩆𡛺𡝯𡜐娬妸銏婾嫏娒𥥆𡧳𡡡𤊕㛵洅瑃娡𥺃"],["9340","媁𨯗𠐓鏠璌𡌃焅䥲鐈𨧻鎽㞠尞岞幞幈𡦖𡥼𣫮廍孏𡤃𡤄㜁𡢠㛝𡛾㛓脪𨩇𡶺𣑲𨦨弌弎𡤧𡞫婫𡜻孄蘔𧗽衠恾𢡠𢘫忛㺸𢖯𢖾𩂈𦽳懀𠀾𠁆𢘛憙憘恵𢲛𢴇𤛔𩅍"],["93a1","摱𤙥𢭪㨩𢬢𣑐𩣪𢹸挷𪑛撶挱揑𤧣𢵧护𢲡搻敫楲㯴𣂎𣊭𤦉𣊫唍𣋠𡣙𩐿曎𣊉𣆳㫠䆐𥖄𨬢𥖏𡛼𥕛𥐥磮𣄃𡠪𣈴㑤𣈏𣆂𤋉暎𦴤晫䮓昰𧡰𡷫晣𣋒𣋡昞𥡲㣑𣠺𣞼㮙𣞢𣏾瓐㮖枏𤘪梶栞㯄檾㡣𣟕𤒇樳橒櫉欅𡤒攑梘橌㯗橺歗𣿀𣲚鎠鋲𨯪𨫋"],["9440","銉𨀞𨧜鑧涥漋𤧬浧𣽿㶏渄𤀼娽渊塇洤硂焻𤌚𤉶烱牐犇犔𤞏𤜥兹𤪤𠗫瑺𣻸𣙟𤩊𤤗𥿡㼆㺱𤫟𨰣𣼵悧㻳瓌琼鎇琷䒟𦷪䕑疃㽣𤳙𤴆㽘畕癳𪗆㬙瑨𨫌𤦫𤦎㫻"],["94a1","㷍𤩎㻿𤧅𤣳釺圲鍂𨫣𡡤僟𥈡𥇧睸𣈲眎眏睻𤚗𣞁㩞𤣰琸璛㺿𤪺𤫇䃈𤪖𦆮錇𥖁砞碍碈磒珐祙𧝁𥛣䄎禛蒖禥樭𣻺稺秴䅮𡛦䄲鈵秱𠵌𤦌𠊙𣶺𡝮㖗啫㕰㚪𠇔𠰍竢婙𢛵𥪯𥪜娍𠉛磰娪𥯆竾䇹籝籭䈑𥮳𥺼𥺦糍𤧹𡞰粎籼粮檲緜縇緓罎𦉡"],["9540","𦅜𧭈綗𥺂䉪𦭵𠤖柖𠁎𣗏埄𦐒𦏸𤥢翝笧𠠬𥫩𥵃笌𥸎駦虅驣樜𣐿㧢𤧷𦖭騟𦖠蒀𧄧𦳑䓪脷䐂胆脉腂𦞴飃𦩂艢艥𦩑葓𦶧蘐𧈛媆䅿𡡀嬫𡢡嫤𡣘蚠蜨𣶏蠭𧐢娂"],["95a1","衮佅袇袿裦襥襍𥚃襔𧞅𧞄𨯵𨯙𨮜𨧹㺭蒣䛵䛏㟲訽訜𩑈彍鈫𤊄旔焩烄𡡅鵭貟賩𧷜妚矃姰䍮㛔踪躧𤰉輰轊䋴汘澻𢌡䢛潹溋𡟚鯩㚵𤤯邻邗啱䤆醻鐄𨩋䁢𨫼鐧𨰝𨰻蓥訫閙閧閗閖𨴴瑅㻂𤣿𤩂𤏪㻧𣈥随𨻧𨹦𨹥㻌𤧭𤩸𣿮琒瑫㻼靁𩂰"],["9640","桇䨝𩂓𥟟靝鍨𨦉𨰦𨬯𦎾銺嬑譩䤼珹𤈛鞛靱餸𠼦巁𨯅𤪲頟𩓚鋶𩗗釥䓀𨭐𤩧𨭤飜𨩅㼀鈪䤥萔餻饍𧬆㷽馛䭯馪驜𨭥𥣈檏騡嫾騯𩣱䮐𩥈馼䮽䮗鍽塲𡌂堢𤦸"],["96a1","𡓨硄𢜟𣶸棅㵽鑘㤧慐𢞁𢥫愇鱏鱓鱻鰵鰐魿鯏𩸭鮟𪇵𪃾鴡䲮𤄄鸘䲰鴌𪆴𪃭𪃳𩤯鶥蒽𦸒𦿟𦮂藼䔳𦶤𦺄𦷰萠藮𦸀𣟗𦁤秢𣖜𣙀䤭𤧞㵢鏛銾鍈𠊿碹鉷鑍俤㑀遤𥕝砽硔碶硋𡝗𣇉𤥁㚚佲濚濙瀞瀞吔𤆵垻壳垊鴖埗焴㒯𤆬燫𦱀𤾗嬨𡞵𨩉"],["9740","愌嫎娋䊼𤒈㜬䭻𨧼鎻鎸𡣖𠼝葲𦳀𡐓𤋺𢰦𤏁妔𣶷𦝁綨𦅛𦂤𤦹𤦋𨧺鋥珢㻩璴𨭣𡢟㻡𤪳櫘珳珻㻖𤨾𤪔𡟙𤩦𠎧𡐤𤧥瑈𤤖炥𤥶銄珦鍟𠓾錱𨫎𨨖鎆𨯧𥗕䤵𨪂煫"],["97a1","𤥃𠳿嚤𠘚𠯫𠲸唂秄𡟺緾𡛂𤩐𡡒䔮鐁㜊𨫀𤦭妰𡢿𡢃𧒄媡㛢𣵛㚰鉟婹𨪁𡡢鍴㳍𠪴䪖㦊僴㵩㵌𡎜煵䋻𨈘渏𩃤䓫浗𧹏灧沯㳖𣿭𣸭渂漌㵯𠏵畑㚼㓈䚀㻚䡱姄鉮䤾轁𨰜𦯀堒埈㛖𡑒烾𤍢𤩱𢿣𡊰𢎽梹楧𡎘𣓥𧯴𣛟𨪃𣟖𣏺𤲟樚𣚭𦲷萾䓟䓎"],["9840","𦴦𦵑𦲂𦿞漗𧄉茽𡜺菭𦲀𧁓𡟛妉媂𡞳婡婱𡤅𤇼㜭姯𡜼㛇熎鎐暚𤊥婮娫𤊓樫𣻹𧜶𤑛𤋊焝𤉙𨧡侰𦴨峂𤓎𧹍𤎽樌𤉖𡌄炦焳𤏩㶥泟勇𤩏繥姫崯㷳彜𤩝𡟟綤萦"],["98a1","咅𣫺𣌀𠈔坾𠣕𠘙㿥𡾞𪊶瀃𩅛嵰玏糓𨩙𩐠俈翧狍猐𧫴猸猹𥛶獁獈㺩𧬘遬燵𤣲珡臶㻊県㻑沢国琙琞琟㻢㻰㻴㻺瓓㼎㽓畂畭畲疍㽼痈痜㿀癍㿗癴㿜発𤽜熈嘣覀塩䀝睃䀹条䁅㗛瞘䁪䁯属瞾矋売砘点砜䂨砹硇硑硦葈𥔵礳栃礲䄃"],["9940","䄉禑禙辻稆込䅧窑䆲窼艹䇄竏竛䇏両筢筬筻簒簛䉠䉺类粜䊌粸䊔糭输烀𠳏総緔緐緽羮羴犟䎗耠耥笹耮耱联㷌垴炠肷胩䏭脌猪脎脒畠脔䐁㬹腖腙腚"],["99a1","䐓堺腼膄䐥膓䐭膥埯臁臤艔䒏芦艶苊苘苿䒰荗险榊萅烵葤惣蒈䔄蒾蓡蓸蔐蔸蕒䔻蕯蕰藠䕷虲蚒蚲蛯际螋䘆䘗袮裿褤襇覑𧥧訩訸誔誴豑賔賲贜䞘塟跃䟭仮踺嗘坔蹱嗵躰䠷軎転軤軭軲辷迁迊迌逳駄䢭飠鈓䤞鈨鉘鉫銱銮銿"],["9a40","鋣鋫鋳鋴鋽鍃鎄鎭䥅䥑麿鐗匁鐝鐭鐾䥪鑔鑹锭関䦧间阳䧥枠䨤靀䨵鞲韂噔䫤惨颹䬙飱塄餎餙冴餜餷饂饝饢䭰駅䮝騼鬏窃魩鮁鯝鯱鯴䱭鰠㝯𡯂鵉鰺"],["9aa1","黾噐鶓鶽鷀鷼银辶鹻麬麱麽黆铜黢黱黸竈齄𠂔𠊷𠎠椚铃妬𠓗塀铁㞹𠗕𠘕𠙶𡚺块煳𠫂𠫍𠮿呪吆𠯋咞𠯻𠰻𠱓𠱥𠱼惧𠲍噺𠲵𠳝𠳭𠵯𠶲𠷈楕鰯螥𠸄𠸎𠻗𠾐𠼭𠹳尠𠾼帋𡁜𡁏𡁶朞𡁻𡂈𡂖㙇𡂿𡃓𡄯𡄻卤蒭𡋣𡍵𡌶讁𡕷𡘙𡟃𡟇乸炻𡠭𡥪"],["9b40","𡨭𡩅𡰪𡱰𡲬𡻈拃𡻕𡼕熘桕𢁅槩㛈𢉼𢏗𢏺𢜪𢡱𢥏苽𢥧𢦓𢫕覥𢫨辠𢬎鞸𢬿顇骽𢱌"],["9b62","𢲈𢲷𥯨𢴈𢴒𢶷𢶕𢹂𢽴𢿌𣀳𣁦𣌟𣏞徱晈暿𧩹𣕧𣗳爁𤦺矗𣘚𣜖纇𠍆墵朎"],["9ba1","椘𣪧𧙗𥿢𣸑𣺹𧗾𢂚䣐䪸𤄙𨪚𤋮𤌍𤀻𤌴𤎖𤩅𠗊凒𠘑妟𡺨㮾𣳿𤐄𤓖垈𤙴㦛𤜯𨗨𩧉㝢𢇃譞𨭎駖𤠒𤣻𤨕爉𤫀𠱸奥𤺥𤾆𠝹軚𥀬劏圿煱𥊙𥐙𣽊𤪧喼𥑆𥑮𦭒釔㑳𥔿𧘲𥕞䜘𥕢𥕦𥟇𤤿𥡝偦㓻𣏌惞𥤃䝼𨥈𥪮𥮉𥰆𡶐垡煑澶𦄂𧰒遖𦆲𤾚譢𦐂𦑊"],["9c40","嵛𦯷輶𦒄𡤜諪𤧶𦒈𣿯𦔒䯀𦖿𦚵𢜛鑥𥟡憕娧晉侻嚹𤔡𦛼乪𤤴陖涏𦲽㘘襷𦞙𦡮𦐑𦡞營𦣇筂𩃀𠨑𦤦鄄𦤹穅鷰𦧺騦𦨭㙟𦑩𠀡禃𦨴𦭛崬𣔙菏𦮝䛐𦲤画补𦶮墶"],["9ca1","㜜𢖍𧁋𧇍㱔𧊀𧊅銁𢅺𧊋錰𧋦𤧐氹钟𧑐𠻸蠧裵𢤦𨑳𡞱溸𤨪𡠠㦤㚹尐秣䔿暶𩲭𩢤襃𧟌𧡘囖䃟𡘊㦡𣜯𨃨𡏅熭荦𧧝𩆨婧䲷𧂯𨦫𧧽𧨊𧬋𧵦𤅺筃祾𨀉澵𪋟樃𨌘厢𦸇鎿栶靝𨅯𨀣𦦵𡏭𣈯𨁈嶅𨰰𨂃圕頣𨥉嶫𤦈斾槕叒𤪥𣾁㰑朶𨂐𨃴𨄮𡾡𨅏"],["9d40","𨆉𨆯𨈚𨌆𨌯𨎊㗊𨑨𨚪䣺揦𨥖砈鉕𨦸䏲𨧧䏟𨧨𨭆𨯔姸𨰉輋𨿅𩃬筑𩄐𩄼㷷𩅞𤫊运犏嚋𩓧𩗩𩖰𩖸𩜲𩣑𩥉𩥪𩧃𩨨𩬎𩵚𩶛纟𩻸𩼣䲤镇𪊓熢𪋿䶑递𪗋䶜𠲜达嗁"],["9da1","辺𢒰边𤪓䔉繿潖檱仪㓤𨬬𧢝㜺躀𡟵𨀤𨭬𨮙𧨾𦚯㷫𧙕𣲷𥘵𥥖亚𥺁𦉘嚿𠹭踎孭𣺈𤲞揞拐𡟶𡡻攰嘭𥱊吚𥌑㷆𩶘䱽嘢嘞罉𥻘奵𣵀蝰东𠿪𠵉𣚺脗鵞贘瘻鱅癎瞹鍅吲腈苷嘥脲萘肽嗪祢噃吖𠺝㗎嘅嗱曱𨋢㘭甴嗰喺咗啲𠱁𠲖廐𥅈𠹶𢱢"],["9e40","𠺢麫絚嗞𡁵抝靭咔賍燶酶揼掹揾啩𢭃鱲𢺳冚㓟𠶧冧呍唞唓癦踭𦢊疱肶蠄螆裇膶萜𡃁䓬猄𤜆宐茋𦢓噻𢛴𧴯𤆣𧵳𦻐𧊶酰𡇙鈈𣳼𪚩𠺬𠻹牦𡲢䝎𤿂𧿹𠿫䃺"],["9ea1","鱝攟𢶠䣳𤟠𩵼𠿬𠸊恢𧖣𠿭"],["9ead","𦁈𡆇熣纎鵐业丄㕷嬍沲卧㚬㧜卽㚥𤘘墚𤭮舭呋垪𥪕𠥹"],["9ec5","㩒𢑥獴𩺬䴉鯭𣳾𩼰䱛𤾩𩖞𩿞葜𣶶𧊲𦞳𣜠挮紥𣻷𣸬㨪逈勌㹴㙺䗩𠒎癀嫰𠺶硺𧼮墧䂿噼鮋嵴癔𪐴麅䳡痹㟻愙𣃚𤏲"],["9ef5","噝𡊩垧𤥣𩸆刴𧂮㖭汊鵼"],["9f40","籖鬹埞𡝬屓擓𩓐𦌵𧅤蚭𠴨𦴢𤫢𠵱"],["9f4f","凾𡼏嶎霃𡷑麁遌笟鬂峑箣扨挵髿篏鬪籾鬮籂粆鰕篼鬉鼗鰛𤤾齚啳寃俽麘俲剠㸆勑坧偖妷帒韈鶫轜呩鞴饀鞺匬愰"],["9fa1","椬叚鰊鴂䰻陁榀傦畆𡝭駚剳"],["9fae","酙隁酜"],["9fb2","酑𨺗捿𦴣櫊嘑醎畺抅𠏼獏籰𥰡𣳽"],["9fc1","𤤙盖鮝个𠳔莾衂"],["9fc9","届槀僭坺刟巵从氱𠇲伹咜哚劚趂㗾弌㗳"],["9fdb","歒酼龥鮗頮颴骺麨麄煺笔"],["9fe7","毺蠘罸"],["9feb","嘠𪙊蹷齓"],["9ff0","跔蹏鸜踁抂𨍽踨蹵竓𤩷稾磘泪詧瘇"],["a040","𨩚鼦泎蟖痃𪊲硓咢贌狢獱謭猂瓱賫𤪻蘯徺袠䒷"],["a055","𡠻𦸅"],["a058","詾𢔛"],["a05b","惽癧髗鵄鍮鮏蟵"],["a063","蠏賷猬霡鮰㗖犲䰇籑饊𦅙慙䰄麖慽"],["a073","坟慯抦戹拎㩜懢厪𣏵捤栂㗒"],["a0a1","嵗𨯂迚𨸹"],["a0a6","僙𡵆礆匲阸𠼻䁥"],["a0ae","矾"],["a0b0","糂𥼚糚稭聦聣絍甅瓲覔舚朌聢𧒆聛瓰脃眤覉𦟌畓𦻑螩蟎臈螌詉貭譃眫瓸蓚㘵榲趦"],["a0d4","覩瑨涹蟁𤀑瓧㷛煶悤憜㳑煢恷"],["a0e2","罱𨬭牐惩䭾删㰘𣳇𥻗𧙖𥔱𡥄𡋾𩤃𦷜𧂭峁𦆭𨨏𣙷𠃮𦡆𤼎䕢嬟𦍌齐麦𦉫"],["a3c0","␀",31,"␡"],["c6a1","①",9,"⑴",9,"ⅰ",9,"丶丿亅亠冂冖冫勹匸卩厶夊宀巛⼳广廴彐彡攴无疒癶辵隶¨ˆヽヾゝゞ〃仝々〆〇ー［］✽ぁ",23],["c740","す",58,"ァアィイ"],["c7a1","ゥ",81,"А",5,"ЁЖ",4],["c840","Л",26,"ёж",25,"⇧↸↹㇏𠃌乚𠂊刂䒑"],["c8a1","龰冈龱𧘇"],["c8cd","￢￤＇＂㈱№℡゛゜⺀⺄⺆⺇⺈⺊⺌⺍⺕⺜⺝⺥⺧⺪⺬⺮⺶⺼⺾⻆⻊⻌⻍⻏⻖⻗⻞⻣"],["c8f5","ʃɐɛɔɵœøŋʊɪ"],["f9fe","￭"],["fa40","𠕇鋛𠗟𣿅蕌䊵珯况㙉𤥂𨧤鍄𡧛苮𣳈砼杄拟𤤳𨦪𠊠𦮳𡌅侫𢓭倈𦴩𧪄𣘀𤪱𢔓倩𠍾徤𠎀𠍇滛𠐟偽儁㑺儎顬㝃萖𤦤𠒇兠𣎴兪𠯿𢃼𠋥𢔰𠖎𣈳𡦃宂蝽𠖳𣲙冲冸"],["faa1","鴴凉减凑㳜凓𤪦决凢卂凭菍椾𣜭彻刋刦刼劵剗劔効勅簕蕂勠蘍𦬓包𨫞啉滙𣾀𠥔𣿬匳卄𠯢泋𡜦栛珕恊㺪㣌𡛨燝䒢卭却𨚫卾卿𡖖𡘓矦厓𨪛厠厫厮玧𥝲㽙玜叁叅汉义埾叙㪫𠮏叠𣿫𢶣叶𠱷吓灹唫晗浛呭𦭓𠵴啝咏咤䞦𡜍𠻝㶴𠵍"],["fb40","𨦼𢚘啇䳭启琗喆喩嘅𡣗𤀺䕒𤐵暳𡂴嘷曍𣊊暤暭噍噏磱囱鞇叾圀囯园𨭦㘣𡉏坆𤆥汮炋坂㚱𦱾埦𡐖堃𡑔𤍣堦𤯵塜墪㕡壠壜𡈼壻寿坃𪅐𤉸鏓㖡够梦㛃湙"],["fba1","𡘾娤啓𡚒蔅姉𠵎𦲁𦴪𡟜姙𡟻𡞲𦶦浱𡠨𡛕姹𦹅媫婣㛦𤦩婷㜈媖瑥嫓𦾡𢕔㶅𡤑㜲𡚸広勐孶斈孼𧨎䀄䡝𠈄寕慠𡨴𥧌𠖥寳宝䴐尅𡭄尓珎尔𡲥𦬨屉䣝岅峩峯嶋𡷹𡸷崐崘嵆𡺤岺巗苼㠭𤤁𢁉𢅳芇㠶㯂帮檊幵幺𤒼𠳓厦亷廐厨𡝱帉廴𨒂"],["fc40","廹廻㢠廼栾鐛弍𠇁弢㫞䢮𡌺强𦢈𢏐彘𢑱彣鞽𦹮彲鍀𨨶徧嶶㵟𥉐𡽪𧃸𢙨釖𠊞𨨩怱暅𡡷㥣㷇㘹垐𢞴祱㹀悞悤悳𤦂𤦏𧩓璤僡媠慤萤慂慈𦻒憁凴𠙖憇宪𣾷"],["fca1","𢡟懓𨮝𩥝懐㤲𢦀𢣁怣慜攞掋𠄘担𡝰拕𢸍捬𤧟㨗搸揸𡎎𡟼撐澊𢸶頔𤂌𥜝擡擥鑻㩦携㩗敍漖𤨨𤨣斅敭敟𣁾斵𤥀䬷旑䃘𡠩无旣忟𣐀昘𣇷𣇸晄𣆤𣆥晋𠹵晧𥇦晳晴𡸽𣈱𨗴𣇈𥌓矅𢣷馤朂𤎜𤨡㬫槺𣟂杞杧杢𤇍𩃭柗䓩栢湐鈼栁𣏦𦶠桝"],["fd40","𣑯槡樋𨫟楳棃𣗍椁椀㴲㨁𣘼㮀枬楡𨩊䋼椶榘㮡𠏉荣傐槹𣙙𢄪橅𣜃檝㯳枱櫈𩆜㰍欝𠤣惞欵歴𢟍溵𣫛𠎵𡥘㝀吡𣭚毡𣻼毜氷𢒋𤣱𦭑汚舦汹𣶼䓅𣶽𤆤𤤌𤤀"],["fda1","𣳉㛥㳫𠴲鮃𣇹𢒑羏样𦴥𦶡𦷫涖浜湼漄𤥿𤂅𦹲蔳𦽴凇沜渝萮𨬡港𣸯瑓𣾂秌湏媑𣁋濸㜍澝𣸰滺𡒗𤀽䕕鏰潄潜㵎潴𩅰㴻澟𤅄濓𤂑𤅕𤀹𣿰𣾴𤄿凟𤅖𤅗𤅀𦇝灋灾炧炁烌烕烖烟䄄㷨熴熖𤉷焫煅媈煊煮岜𤍥煏鍢𤋁焬𤑚𤨧𤨢熺𨯨炽爎"],["fe40","鑂爕夑鑃爤鍁𥘅爮牀𤥴梽牕牗㹕𣁄栍漽犂猪猫𤠣𨠫䣭𨠄猨献珏玪𠰺𦨮珉瑉𤇢𡛧𤨤昣㛅𤦷𤦍𤧻珷琕椃𤨦琹𠗃㻗瑜𢢭瑠𨺲瑇珤瑶莹瑬㜰瑴鏱樬璂䥓𤪌"],["fea1","𤅟𤩹𨮏孆𨰃𡢞瓈𡦈甎瓩甞𨻙𡩋寗𨺬鎅畍畊畧畮𤾂㼄𤴓疎瑝疞疴瘂瘬癑癏癯癶𦏵皐臯㟸𦤑𦤎皡皥皷盌𦾟葢𥂝𥅽𡸜眞眦着撯𥈠睘𣊬瞯𨥤𨥨𡛁矴砉𡍶𤨒棊碯磇磓隥礮𥗠磗礴碱𧘌辸袄𨬫𦂃𢘜禆褀椂禀𥡗禝𧬹礼禩渪𧄦㺨秆𩄍秔"]]

/***/ }),
/* 1281 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1282 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1283 */,
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1289 */,
/* 1290 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1291 */,
/* 1292 */,
/* 1293 */,
/* 1294 */,
/* 1295 */,
/* 1296 */,
/* 1297 */,
/* 1298 */,
/* 1299 */,
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */,
/* 1304 */,
/* 1305 */,
/* 1306 */,
/* 1307 */,
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */
/***/ (function(module, exports) {

module.exports = {"application/1d-interleaved-parityfec":{"source":"iana"},"application/3gpdash-qoe-report+xml":{"source":"iana","compressible":true},"application/3gpp-ims+xml":{"source":"iana","compressible":true},"application/a2l":{"source":"iana"},"application/activemessage":{"source":"iana"},"application/activity+json":{"source":"iana","compressible":true},"application/alto-costmap+json":{"source":"iana","compressible":true},"application/alto-costmapfilter+json":{"source":"iana","compressible":true},"application/alto-directory+json":{"source":"iana","compressible":true},"application/alto-endpointcost+json":{"source":"iana","compressible":true},"application/alto-endpointcostparams+json":{"source":"iana","compressible":true},"application/alto-endpointprop+json":{"source":"iana","compressible":true},"application/alto-endpointpropparams+json":{"source":"iana","compressible":true},"application/alto-error+json":{"source":"iana","compressible":true},"application/alto-networkmap+json":{"source":"iana","compressible":true},"application/alto-networkmapfilter+json":{"source":"iana","compressible":true},"application/aml":{"source":"iana"},"application/andrew-inset":{"source":"iana","extensions":["ez"]},"application/applefile":{"source":"iana"},"application/applixware":{"source":"apache","extensions":["aw"]},"application/atf":{"source":"iana"},"application/atfx":{"source":"iana"},"application/atom+xml":{"source":"iana","compressible":true,"extensions":["atom"]},"application/atomcat+xml":{"source":"iana","compressible":true,"extensions":["atomcat"]},"application/atomdeleted+xml":{"source":"iana","compressible":true},"application/atomicmail":{"source":"iana"},"application/atomsvc+xml":{"source":"iana","compressible":true,"extensions":["atomsvc"]},"application/atsc-dwd+xml":{"source":"iana","compressible":true},"application/atsc-held+xml":{"source":"iana","compressible":true},"application/atsc-rsat+xml":{"source":"iana","compressible":true},"application/atxml":{"source":"iana"},"application/auth-policy+xml":{"source":"iana","compressible":true},"application/bacnet-xdd+zip":{"source":"iana","compressible":false},"application/batch-smtp":{"source":"iana"},"application/bdoc":{"compressible":false,"extensions":["bdoc"]},"application/beep+xml":{"source":"iana","compressible":true},"application/calendar+json":{"source":"iana","compressible":true},"application/calendar+xml":{"source":"iana","compressible":true},"application/call-completion":{"source":"iana"},"application/cals-1840":{"source":"iana"},"application/cbor":{"source":"iana"},"application/cccex":{"source":"iana"},"application/ccmp+xml":{"source":"iana","compressible":true},"application/ccxml+xml":{"source":"iana","compressible":true,"extensions":["ccxml"]},"application/cdfx+xml":{"source":"iana","compressible":true},"application/cdmi-capability":{"source":"iana","extensions":["cdmia"]},"application/cdmi-container":{"source":"iana","extensions":["cdmic"]},"application/cdmi-domain":{"source":"iana","extensions":["cdmid"]},"application/cdmi-object":{"source":"iana","extensions":["cdmio"]},"application/cdmi-queue":{"source":"iana","extensions":["cdmiq"]},"application/cdni":{"source":"iana"},"application/cea":{"source":"iana"},"application/cea-2018+xml":{"source":"iana","compressible":true},"application/cellml+xml":{"source":"iana","compressible":true},"application/cfw":{"source":"iana"},"application/clue_info+xml":{"source":"iana","compressible":true},"application/cms":{"source":"iana"},"application/cnrp+xml":{"source":"iana","compressible":true},"application/coap-group+json":{"source":"iana","compressible":true},"application/coap-payload":{"source":"iana"},"application/commonground":{"source":"iana"},"application/conference-info+xml":{"source":"iana","compressible":true},"application/cose":{"source":"iana"},"application/cose-key":{"source":"iana"},"application/cose-key-set":{"source":"iana"},"application/cpl+xml":{"source":"iana","compressible":true},"application/csrattrs":{"source":"iana"},"application/csta+xml":{"source":"iana","compressible":true},"application/cstadata+xml":{"source":"iana","compressible":true},"application/csvm+json":{"source":"iana","compressible":true},"application/cu-seeme":{"source":"apache","extensions":["cu"]},"application/cwt":{"source":"iana"},"application/cybercash":{"source":"iana"},"application/dart":{"compressible":true},"application/dash+xml":{"source":"iana","compressible":true,"extensions":["mpd"]},"application/dashdelta":{"source":"iana"},"application/davmount+xml":{"source":"iana","compressible":true,"extensions":["davmount"]},"application/dca-rft":{"source":"iana"},"application/dcd":{"source":"iana"},"application/dec-dx":{"source":"iana"},"application/dialog-info+xml":{"source":"iana","compressible":true},"application/dicom":{"source":"iana"},"application/dicom+json":{"source":"iana","compressible":true},"application/dicom+xml":{"source":"iana","compressible":true},"application/dii":{"source":"iana"},"application/dit":{"source":"iana"},"application/dns":{"source":"iana"},"application/dns+json":{"source":"iana","compressible":true},"application/dns-message":{"source":"iana"},"application/docbook+xml":{"source":"apache","compressible":true,"extensions":["dbk"]},"application/dskpp+xml":{"source":"iana","compressible":true},"application/dssc+der":{"source":"iana","extensions":["dssc"]},"application/dssc+xml":{"source":"iana","compressible":true,"extensions":["xdssc"]},"application/dvcs":{"source":"iana"},"application/ecmascript":{"source":"iana","compressible":true,"extensions":["ecma","es"]},"application/edi-consent":{"source":"iana"},"application/edi-x12":{"source":"iana","compressible":false},"application/edifact":{"source":"iana","compressible":false},"application/efi":{"source":"iana"},"application/emergencycalldata.comment+xml":{"source":"iana","compressible":true},"application/emergencycalldata.control+xml":{"source":"iana","compressible":true},"application/emergencycalldata.deviceinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.ecall.msd":{"source":"iana"},"application/emergencycalldata.providerinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.serviceinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.subscriberinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.veds+xml":{"source":"iana","compressible":true},"application/emma+xml":{"source":"iana","compressible":true,"extensions":["emma"]},"application/emotionml+xml":{"source":"iana","compressible":true},"application/encaprtp":{"source":"iana"},"application/epp+xml":{"source":"iana","compressible":true},"application/epub+zip":{"source":"iana","compressible":false,"extensions":["epub"]},"application/eshop":{"source":"iana"},"application/exi":{"source":"iana","extensions":["exi"]},"application/expect-ct-report+json":{"source":"iana","compressible":true},"application/fastinfoset":{"source":"iana"},"application/fastsoap":{"source":"iana"},"application/fdt+xml":{"source":"iana","compressible":true},"application/fhir+json":{"source":"iana","compressible":true},"application/fhir+xml":{"source":"iana","compressible":true},"application/fido.trusted-apps+json":{"compressible":true},"application/fits":{"source":"iana"},"application/flexfec":{"source":"iana"},"application/font-sfnt":{"source":"iana"},"application/font-tdpfr":{"source":"iana","extensions":["pfr"]},"application/font-woff":{"source":"iana","compressible":false},"application/framework-attributes+xml":{"source":"iana","compressible":true},"application/geo+json":{"source":"iana","compressible":true,"extensions":["geojson"]},"application/geo+json-seq":{"source":"iana"},"application/geopackage+sqlite3":{"source":"iana"},"application/geoxacml+xml":{"source":"iana","compressible":true},"application/gltf-buffer":{"source":"iana"},"application/gml+xml":{"source":"iana","compressible":true,"extensions":["gml"]},"application/gpx+xml":{"source":"apache","compressible":true,"extensions":["gpx"]},"application/gxf":{"source":"apache","extensions":["gxf"]},"application/gzip":{"source":"iana","compressible":false,"extensions":["gz"]},"application/h224":{"source":"iana"},"application/held+xml":{"source":"iana","compressible":true},"application/hjson":{"extensions":["hjson"]},"application/http":{"source":"iana"},"application/hyperstudio":{"source":"iana","extensions":["stk"]},"application/ibe-key-request+xml":{"source":"iana","compressible":true},"application/ibe-pkg-reply+xml":{"source":"iana","compressible":true},"application/ibe-pp-data":{"source":"iana"},"application/iges":{"source":"iana"},"application/im-iscomposing+xml":{"source":"iana","compressible":true},"application/index":{"source":"iana"},"application/index.cmd":{"source":"iana"},"application/index.obj":{"source":"iana"},"application/index.response":{"source":"iana"},"application/index.vnd":{"source":"iana"},"application/inkml+xml":{"source":"iana","compressible":true,"extensions":["ink","inkml"]},"application/iotp":{"source":"iana"},"application/ipfix":{"source":"iana","extensions":["ipfix"]},"application/ipp":{"source":"iana"},"application/isup":{"source":"iana"},"application/its+xml":{"source":"iana","compressible":true},"application/java-archive":{"source":"apache","compressible":false,"extensions":["jar","war","ear"]},"application/java-serialized-object":{"source":"apache","compressible":false,"extensions":["ser"]},"application/java-vm":{"source":"apache","compressible":false,"extensions":["class"]},"application/javascript":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["js","mjs"]},"application/jf2feed+json":{"source":"iana","compressible":true},"application/jose":{"source":"iana"},"application/jose+json":{"source":"iana","compressible":true},"application/jrd+json":{"source":"iana","compressible":true},"application/json":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["json","map"]},"application/json-patch+json":{"source":"iana","compressible":true},"application/json-seq":{"source":"iana"},"application/json5":{"extensions":["json5"]},"application/jsonml+json":{"source":"apache","compressible":true,"extensions":["jsonml"]},"application/jwk+json":{"source":"iana","compressible":true},"application/jwk-set+json":{"source":"iana","compressible":true},"application/jwt":{"source":"iana"},"application/kpml-request+xml":{"source":"iana","compressible":true},"application/kpml-response+xml":{"source":"iana","compressible":true},"application/ld+json":{"source":"iana","compressible":true,"extensions":["jsonld"]},"application/lgr+xml":{"source":"iana","compressible":true},"application/link-format":{"source":"iana"},"application/load-control+xml":{"source":"iana","compressible":true},"application/lost+xml":{"source":"iana","compressible":true,"extensions":["lostxml"]},"application/lostsync+xml":{"source":"iana","compressible":true},"application/lxf":{"source":"iana"},"application/mac-binhex40":{"source":"iana","extensions":["hqx"]},"application/mac-compactpro":{"source":"apache","extensions":["cpt"]},"application/macwriteii":{"source":"iana"},"application/mads+xml":{"source":"iana","compressible":true,"extensions":["mads"]},"application/manifest+json":{"charset":"UTF-8","compressible":true,"extensions":["webmanifest"]},"application/marc":{"source":"iana","extensions":["mrc"]},"application/marcxml+xml":{"source":"iana","compressible":true,"extensions":["mrcx"]},"application/mathematica":{"source":"iana","extensions":["ma","nb","mb"]},"application/mathml+xml":{"source":"iana","compressible":true,"extensions":["mathml"]},"application/mathml-content+xml":{"source":"iana","compressible":true},"application/mathml-presentation+xml":{"source":"iana","compressible":true},"application/mbms-associated-procedure-description+xml":{"source":"iana","compressible":true},"application/mbms-deregister+xml":{"source":"iana","compressible":true},"application/mbms-envelope+xml":{"source":"iana","compressible":true},"application/mbms-msk+xml":{"source":"iana","compressible":true},"application/mbms-msk-response+xml":{"source":"iana","compressible":true},"application/mbms-protection-description+xml":{"source":"iana","compressible":true},"application/mbms-reception-report+xml":{"source":"iana","compressible":true},"application/mbms-register+xml":{"source":"iana","compressible":true},"application/mbms-register-response+xml":{"source":"iana","compressible":true},"application/mbms-schedule+xml":{"source":"iana","compressible":true},"application/mbms-user-service-description+xml":{"source":"iana","compressible":true},"application/mbox":{"source":"iana","extensions":["mbox"]},"application/media-policy-dataset+xml":{"source":"iana","compressible":true},"application/media_control+xml":{"source":"iana","compressible":true},"application/mediaservercontrol+xml":{"source":"iana","compressible":true,"extensions":["mscml"]},"application/merge-patch+json":{"source":"iana","compressible":true},"application/metalink+xml":{"source":"apache","compressible":true,"extensions":["metalink"]},"application/metalink4+xml":{"source":"iana","compressible":true,"extensions":["meta4"]},"application/mets+xml":{"source":"iana","compressible":true,"extensions":["mets"]},"application/mf4":{"source":"iana"},"application/mikey":{"source":"iana"},"application/mipc":{"source":"iana"},"application/mmt-aei+xml":{"source":"iana","compressible":true},"application/mmt-usd+xml":{"source":"iana","compressible":true},"application/mods+xml":{"source":"iana","compressible":true,"extensions":["mods"]},"application/moss-keys":{"source":"iana"},"application/moss-signature":{"source":"iana"},"application/mosskey-data":{"source":"iana"},"application/mosskey-request":{"source":"iana"},"application/mp21":{"source":"iana","extensions":["m21","mp21"]},"application/mp4":{"source":"iana","extensions":["mp4s","m4p"]},"application/mpeg4-generic":{"source":"iana"},"application/mpeg4-iod":{"source":"iana"},"application/mpeg4-iod-xmt":{"source":"iana"},"application/mrb-consumer+xml":{"source":"iana","compressible":true},"application/mrb-publish+xml":{"source":"iana","compressible":true},"application/msc-ivr+xml":{"source":"iana","compressible":true},"application/msc-mixer+xml":{"source":"iana","compressible":true},"application/msword":{"source":"iana","compressible":false,"extensions":["doc","dot"]},"application/mud+json":{"source":"iana","compressible":true},"application/mxf":{"source":"iana","extensions":["mxf"]},"application/n-quads":{"source":"iana","extensions":["nq"]},"application/n-triples":{"source":"iana","extensions":["nt"]},"application/nasdata":{"source":"iana"},"application/news-checkgroups":{"source":"iana"},"application/news-groupinfo":{"source":"iana"},"application/news-transmission":{"source":"iana"},"application/nlsml+xml":{"source":"iana","compressible":true},"application/node":{"source":"iana"},"application/nss":{"source":"iana"},"application/ocsp-request":{"source":"iana"},"application/ocsp-response":{"source":"iana"},"application/octet-stream":{"source":"iana","compressible":false,"extensions":["bin","dms","lrf","mar","so","dist","distz","pkg","bpk","dump","elc","deploy","exe","dll","deb","dmg","iso","img","msi","msp","msm","buffer"]},"application/oda":{"source":"iana","extensions":["oda"]},"application/odm+xml":{"source":"iana","compressible":true},"application/odx":{"source":"iana"},"application/oebps-package+xml":{"source":"iana","compressible":true,"extensions":["opf"]},"application/ogg":{"source":"iana","compressible":false,"extensions":["ogx"]},"application/omdoc+xml":{"source":"apache","compressible":true,"extensions":["omdoc"]},"application/onenote":{"source":"apache","extensions":["onetoc","onetoc2","onetmp","onepkg"]},"application/oscore":{"source":"iana"},"application/oxps":{"source":"iana","extensions":["oxps"]},"application/p2p-overlay+xml":{"source":"iana","compressible":true},"application/parityfec":{"source":"iana"},"application/passport":{"source":"iana"},"application/patch-ops-error+xml":{"source":"iana","compressible":true,"extensions":["xer"]},"application/pdf":{"source":"iana","compressible":false,"extensions":["pdf"]},"application/pdx":{"source":"iana"},"application/pem-certificate-chain":{"source":"iana"},"application/pgp-encrypted":{"source":"iana","compressible":false,"extensions":["pgp"]},"application/pgp-keys":{"source":"iana"},"application/pgp-signature":{"source":"iana","extensions":["asc","sig"]},"application/pics-rules":{"source":"apache","extensions":["prf"]},"application/pidf+xml":{"source":"iana","compressible":true},"application/pidf-diff+xml":{"source":"iana","compressible":true},"application/pkcs10":{"source":"iana","extensions":["p10"]},"application/pkcs12":{"source":"iana"},"application/pkcs7-mime":{"source":"iana","extensions":["p7m","p7c"]},"application/pkcs7-signature":{"source":"iana","extensions":["p7s"]},"application/pkcs8":{"source":"iana","extensions":["p8"]},"application/pkcs8-encrypted":{"source":"iana"},"application/pkix-attr-cert":{"source":"iana","extensions":["ac"]},"application/pkix-cert":{"source":"iana","extensions":["cer"]},"application/pkix-crl":{"source":"iana","extensions":["crl"]},"application/pkix-pkipath":{"source":"iana","extensions":["pkipath"]},"application/pkixcmp":{"source":"iana","extensions":["pki"]},"application/pls+xml":{"source":"iana","compressible":true,"extensions":["pls"]},"application/poc-settings+xml":{"source":"iana","compressible":true},"application/postscript":{"source":"iana","compressible":true,"extensions":["ai","eps","ps"]},"application/ppsp-tracker+json":{"source":"iana","compressible":true},"application/problem+json":{"source":"iana","compressible":true},"application/problem+xml":{"source":"iana","compressible":true},"application/provenance+xml":{"source":"iana","compressible":true},"application/prs.alvestrand.titrax-sheet":{"source":"iana"},"application/prs.cww":{"source":"iana","extensions":["cww"]},"application/prs.hpub+zip":{"source":"iana","compressible":false},"application/prs.nprend":{"source":"iana"},"application/prs.plucker":{"source":"iana"},"application/prs.rdf-xml-crypt":{"source":"iana"},"application/prs.xsf+xml":{"source":"iana","compressible":true},"application/pskc+xml":{"source":"iana","compressible":true,"extensions":["pskcxml"]},"application/qsig":{"source":"iana"},"application/raml+yaml":{"compressible":true,"extensions":["raml"]},"application/raptorfec":{"source":"iana"},"application/rdap+json":{"source":"iana","compressible":true},"application/rdf+xml":{"source":"iana","compressible":true,"extensions":["rdf","owl"]},"application/reginfo+xml":{"source":"iana","compressible":true,"extensions":["rif"]},"application/relax-ng-compact-syntax":{"source":"iana","extensions":["rnc"]},"application/remote-printing":{"source":"iana"},"application/reputon+json":{"source":"iana","compressible":true},"application/resource-lists+xml":{"source":"iana","compressible":true,"extensions":["rl"]},"application/resource-lists-diff+xml":{"source":"iana","compressible":true,"extensions":["rld"]},"application/rfc+xml":{"source":"iana","compressible":true},"application/riscos":{"source":"iana"},"application/rlmi+xml":{"source":"iana","compressible":true},"application/rls-services+xml":{"source":"iana","compressible":true,"extensions":["rs"]},"application/route-apd+xml":{"source":"iana","compressible":true},"application/route-s-tsid+xml":{"source":"iana","compressible":true},"application/route-usd+xml":{"source":"iana","compressible":true},"application/rpki-ghostbusters":{"source":"iana","extensions":["gbr"]},"application/rpki-manifest":{"source":"iana","extensions":["mft"]},"application/rpki-publication":{"source":"iana"},"application/rpki-roa":{"source":"iana","extensions":["roa"]},"application/rpki-updown":{"source":"iana"},"application/rsd+xml":{"source":"apache","compressible":true,"extensions":["rsd"]},"application/rss+xml":{"source":"apache","compressible":true,"extensions":["rss"]},"application/rtf":{"source":"iana","compressible":true,"extensions":["rtf"]},"application/rtploopback":{"source":"iana"},"application/rtx":{"source":"iana"},"application/samlassertion+xml":{"source":"iana","compressible":true},"application/samlmetadata+xml":{"source":"iana","compressible":true},"application/sbml+xml":{"source":"iana","compressible":true,"extensions":["sbml"]},"application/scaip+xml":{"source":"iana","compressible":true},"application/scim+json":{"source":"iana","compressible":true},"application/scvp-cv-request":{"source":"iana","extensions":["scq"]},"application/scvp-cv-response":{"source":"iana","extensions":["scs"]},"application/scvp-vp-request":{"source":"iana","extensions":["spq"]},"application/scvp-vp-response":{"source":"iana","extensions":["spp"]},"application/sdp":{"source":"iana","extensions":["sdp"]},"application/secevent+jwt":{"source":"iana"},"application/senml+cbor":{"source":"iana"},"application/senml+json":{"source":"iana","compressible":true},"application/senml+xml":{"source":"iana","compressible":true},"application/senml-exi":{"source":"iana"},"application/sensml+cbor":{"source":"iana"},"application/sensml+json":{"source":"iana","compressible":true},"application/sensml+xml":{"source":"iana","compressible":true},"application/sensml-exi":{"source":"iana"},"application/sep+xml":{"source":"iana","compressible":true},"application/sep-exi":{"source":"iana"},"application/session-info":{"source":"iana"},"application/set-payment":{"source":"iana"},"application/set-payment-initiation":{"source":"iana","extensions":["setpay"]},"application/set-registration":{"source":"iana"},"application/set-registration-initiation":{"source":"iana","extensions":["setreg"]},"application/sgml":{"source":"iana"},"application/sgml-open-catalog":{"source":"iana"},"application/shf+xml":{"source":"iana","compressible":true,"extensions":["shf"]},"application/sieve":{"source":"iana","extensions":["siv","sieve"]},"application/simple-filter+xml":{"source":"iana","compressible":true},"application/simple-message-summary":{"source":"iana"},"application/simplesymbolcontainer":{"source":"iana"},"application/sipc":{"source":"iana"},"application/slate":{"source":"iana"},"application/smil":{"source":"iana"},"application/smil+xml":{"source":"iana","compressible":true,"extensions":["smi","smil"]},"application/smpte336m":{"source":"iana"},"application/soap+fastinfoset":{"source":"iana"},"application/soap+xml":{"source":"iana","compressible":true},"application/sparql-query":{"source":"iana","extensions":["rq"]},"application/sparql-results+xml":{"source":"iana","compressible":true,"extensions":["srx"]},"application/spirits-event+xml":{"source":"iana","compressible":true},"application/sql":{"source":"iana"},"application/srgs":{"source":"iana","extensions":["gram"]},"application/srgs+xml":{"source":"iana","compressible":true,"extensions":["grxml"]},"application/sru+xml":{"source":"iana","compressible":true,"extensions":["sru"]},"application/ssdl+xml":{"source":"apache","compressible":true,"extensions":["ssdl"]},"application/ssml+xml":{"source":"iana","compressible":true,"extensions":["ssml"]},"application/stix+json":{"source":"iana","compressible":true},"application/swid+xml":{"source":"iana","compressible":true},"application/tamp-apex-update":{"source":"iana"},"application/tamp-apex-update-confirm":{"source":"iana"},"application/tamp-community-update":{"source":"iana"},"application/tamp-community-update-confirm":{"source":"iana"},"application/tamp-error":{"source":"iana"},"application/tamp-sequence-adjust":{"source":"iana"},"application/tamp-sequence-adjust-confirm":{"source":"iana"},"application/tamp-status-query":{"source":"iana"},"application/tamp-status-response":{"source":"iana"},"application/tamp-update":{"source":"iana"},"application/tamp-update-confirm":{"source":"iana"},"application/tar":{"compressible":true},"application/taxii+json":{"source":"iana","compressible":true},"application/tei+xml":{"source":"iana","compressible":true,"extensions":["tei","teicorpus"]},"application/tetra_isi":{"source":"iana"},"application/thraud+xml":{"source":"iana","compressible":true,"extensions":["tfi"]},"application/timestamp-query":{"source":"iana"},"application/timestamp-reply":{"source":"iana"},"application/timestamped-data":{"source":"iana","extensions":["tsd"]},"application/tlsrpt+gzip":{"source":"iana"},"application/tlsrpt+json":{"source":"iana","compressible":true},"application/tnauthlist":{"source":"iana"},"application/toml":{"compressible":true,"extensions":["toml"]},"application/trickle-ice-sdpfrag":{"source":"iana"},"application/trig":{"source":"iana"},"application/ttml+xml":{"source":"iana","compressible":true},"application/tve-trigger":{"source":"iana"},"application/tzif":{"source":"iana"},"application/tzif-leap":{"source":"iana"},"application/ulpfec":{"source":"iana"},"application/urc-grpsheet+xml":{"source":"iana","compressible":true},"application/urc-ressheet+xml":{"source":"iana","compressible":true},"application/urc-targetdesc+xml":{"source":"iana","compressible":true},"application/urc-uisocketdesc+xml":{"source":"iana","compressible":true},"application/vcard+json":{"source":"iana","compressible":true},"application/vcard+xml":{"source":"iana","compressible":true},"application/vemmi":{"source":"iana"},"application/vividence.scriptfile":{"source":"apache"},"application/vnd.1000minds.decision-model+xml":{"source":"iana","compressible":true},"application/vnd.3gpp-prose+xml":{"source":"iana","compressible":true},"application/vnd.3gpp-prose-pc3ch+xml":{"source":"iana","compressible":true},"application/vnd.3gpp-v2x-local-service-information":{"source":"iana"},"application/vnd.3gpp.access-transfer-events+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.bsf+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.gmop+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mc-signalling-ear":{"source":"iana"},"application/vnd.3gpp.mcdata-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-payload":{"source":"iana"},"application/vnd.3gpp.mcdata-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-signalling":{"source":"iana"},"application/vnd.3gpp.mcdata-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-floor-request+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-location-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-mbms-usage-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-signed+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-ue-init-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-affiliation-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-location-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-mbms-usage-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-transmission-request+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mid-call+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.pic-bw-large":{"source":"iana","extensions":["plb"]},"application/vnd.3gpp.pic-bw-small":{"source":"iana","extensions":["psb"]},"application/vnd.3gpp.pic-bw-var":{"source":"iana","extensions":["pvb"]},"application/vnd.3gpp.sms":{"source":"iana"},"application/vnd.3gpp.sms+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.srvcc-ext+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.srvcc-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.state-and-event-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.ussd+xml":{"source":"iana","compressible":true},"application/vnd.3gpp2.bcmcsinfo+xml":{"source":"iana","compressible":true},"application/vnd.3gpp2.sms":{"source":"iana"},"application/vnd.3gpp2.tcap":{"source":"iana","extensions":["tcap"]},"application/vnd.3lightssoftware.imagescal":{"source":"iana"},"application/vnd.3m.post-it-notes":{"source":"iana","extensions":["pwn"]},"application/vnd.accpac.simply.aso":{"source":"iana","extensions":["aso"]},"application/vnd.accpac.simply.imp":{"source":"iana","extensions":["imp"]},"application/vnd.acucobol":{"source":"iana","extensions":["acu"]},"application/vnd.acucorp":{"source":"iana","extensions":["atc","acutc"]},"application/vnd.adobe.air-application-installer-package+zip":{"source":"apache","compressible":false,"extensions":["air"]},"application/vnd.adobe.flash.movie":{"source":"iana"},"application/vnd.adobe.formscentral.fcdt":{"source":"iana","extensions":["fcdt"]},"application/vnd.adobe.fxp":{"source":"iana","extensions":["fxp","fxpl"]},"application/vnd.adobe.partial-upload":{"source":"iana"},"application/vnd.adobe.xdp+xml":{"source":"iana","compressible":true,"extensions":["xdp"]},"application/vnd.adobe.xfdf":{"source":"iana","extensions":["xfdf"]},"application/vnd.aether.imp":{"source":"iana"},"application/vnd.afpc.afplinedata":{"source":"iana"},"application/vnd.afpc.modca":{"source":"iana"},"application/vnd.ah-barcode":{"source":"iana"},"application/vnd.ahead.space":{"source":"iana","extensions":["ahead"]},"application/vnd.airzip.filesecure.azf":{"source":"iana","extensions":["azf"]},"application/vnd.airzip.filesecure.azs":{"source":"iana","extensions":["azs"]},"application/vnd.amadeus+json":{"source":"iana","compressible":true},"application/vnd.amazon.ebook":{"source":"apache","extensions":["azw"]},"application/vnd.amazon.mobi8-ebook":{"source":"iana"},"application/vnd.americandynamics.acc":{"source":"iana","extensions":["acc"]},"application/vnd.amiga.ami":{"source":"iana","extensions":["ami"]},"application/vnd.amundsen.maze+xml":{"source":"iana","compressible":true},"application/vnd.android.ota":{"source":"iana"},"application/vnd.android.package-archive":{"source":"apache","compressible":false,"extensions":["apk"]},"application/vnd.anki":{"source":"iana"},"application/vnd.anser-web-certificate-issue-initiation":{"source":"iana","extensions":["cii"]},"application/vnd.anser-web-funds-transfer-initiation":{"source":"apache","extensions":["fti"]},"application/vnd.antix.game-component":{"source":"iana","extensions":["atx"]},"application/vnd.apache.thrift.binary":{"source":"iana"},"application/vnd.apache.thrift.compact":{"source":"iana"},"application/vnd.apache.thrift.json":{"source":"iana"},"application/vnd.api+json":{"source":"iana","compressible":true},"application/vnd.apothekende.reservation+json":{"source":"iana","compressible":true},"application/vnd.apple.installer+xml":{"source":"iana","compressible":true,"extensions":["mpkg"]},"application/vnd.apple.keynote":{"source":"iana","extensions":["keynote"]},"application/vnd.apple.mpegurl":{"source":"iana","extensions":["m3u8"]},"application/vnd.apple.numbers":{"source":"iana","extensions":["numbers"]},"application/vnd.apple.pages":{"source":"iana","extensions":["pages"]},"application/vnd.apple.pkpass":{"compressible":false,"extensions":["pkpass"]},"application/vnd.arastra.swi":{"source":"iana"},"application/vnd.aristanetworks.swi":{"source":"iana","extensions":["swi"]},"application/vnd.artisan+json":{"source":"iana","compressible":true},"application/vnd.artsquare":{"source":"iana"},"application/vnd.astraea-software.iota":{"source":"iana","extensions":["iota"]},"application/vnd.audiograph":{"source":"iana","extensions":["aep"]},"application/vnd.autopackage":{"source":"iana"},"application/vnd.avalon+json":{"source":"iana","compressible":true},"application/vnd.avistar+xml":{"source":"iana","compressible":true},"application/vnd.balsamiq.bmml+xml":{"source":"iana","compressible":true},"application/vnd.balsamiq.bmpr":{"source":"iana"},"application/vnd.banana-accounting":{"source":"iana"},"application/vnd.bbf.usp.error":{"source":"iana"},"application/vnd.bbf.usp.msg":{"source":"iana"},"application/vnd.bbf.usp.msg+json":{"source":"iana","compressible":true},"application/vnd.bekitzur-stech+json":{"source":"iana","compressible":true},"application/vnd.bint.med-content":{"source":"iana"},"application/vnd.biopax.rdf+xml":{"source":"iana","compressible":true},"application/vnd.blink-idb-value-wrapper":{"source":"iana"},"application/vnd.blueice.multipass":{"source":"iana","extensions":["mpm"]},"application/vnd.bluetooth.ep.oob":{"source":"iana"},"application/vnd.bluetooth.le.oob":{"source":"iana"},"application/vnd.bmi":{"source":"iana","extensions":["bmi"]},"application/vnd.bpf":{"source":"iana"},"application/vnd.bpf3":{"source":"iana"},"application/vnd.businessobjects":{"source":"iana","extensions":["rep"]},"application/vnd.byu.uapi+json":{"source":"iana","compressible":true},"application/vnd.cab-jscript":{"source":"iana"},"application/vnd.canon-cpdl":{"source":"iana"},"application/vnd.canon-lips":{"source":"iana"},"application/vnd.capasystems-pg+json":{"source":"iana","compressible":true},"application/vnd.cendio.thinlinc.clientconf":{"source":"iana"},"application/vnd.century-systems.tcp_stream":{"source":"iana"},"application/vnd.chemdraw+xml":{"source":"iana","compressible":true,"extensions":["cdxml"]},"application/vnd.chess-pgn":{"source":"iana"},"application/vnd.chipnuts.karaoke-mmd":{"source":"iana","extensions":["mmd"]},"application/vnd.ciedi":{"source":"iana"},"application/vnd.cinderella":{"source":"iana","extensions":["cdy"]},"application/vnd.cirpack.isdn-ext":{"source":"iana"},"application/vnd.citationstyles.style+xml":{"source":"iana","compressible":true,"extensions":["csl"]},"application/vnd.claymore":{"source":"iana","extensions":["cla"]},"application/vnd.cloanto.rp9":{"source":"iana","extensions":["rp9"]},"application/vnd.clonk.c4group":{"source":"iana","extensions":["c4g","c4d","c4f","c4p","c4u"]},"application/vnd.cluetrust.cartomobile-config":{"source":"iana","extensions":["c11amc"]},"application/vnd.cluetrust.cartomobile-config-pkg":{"source":"iana","extensions":["c11amz"]},"application/vnd.coffeescript":{"source":"iana"},"application/vnd.collabio.xodocuments.document":{"source":"iana"},"application/vnd.collabio.xodocuments.document-template":{"source":"iana"},"application/vnd.collabio.xodocuments.presentation":{"source":"iana"},"application/vnd.collabio.xodocuments.presentation-template":{"source":"iana"},"application/vnd.collabio.xodocuments.spreadsheet":{"source":"iana"},"application/vnd.collabio.xodocuments.spreadsheet-template":{"source":"iana"},"application/vnd.collection+json":{"source":"iana","compressible":true},"application/vnd.collection.doc+json":{"source":"iana","compressible":true},"application/vnd.collection.next+json":{"source":"iana","compressible":true},"application/vnd.comicbook+zip":{"source":"iana","compressible":false},"application/vnd.comicbook-rar":{"source":"iana"},"application/vnd.commerce-battelle":{"source":"iana"},"application/vnd.commonspace":{"source":"iana","extensions":["csp"]},"application/vnd.contact.cmsg":{"source":"iana","extensions":["cdbcmsg"]},"application/vnd.coreos.ignition+json":{"source":"iana","compressible":true},"application/vnd.cosmocaller":{"source":"iana","extensions":["cmc"]},"application/vnd.crick.clicker":{"source":"iana","extensions":["clkx"]},"application/vnd.crick.clicker.keyboard":{"source":"iana","extensions":["clkk"]},"application/vnd.crick.clicker.palette":{"source":"iana","extensions":["clkp"]},"application/vnd.crick.clicker.template":{"source":"iana","extensions":["clkt"]},"application/vnd.crick.clicker.wordbank":{"source":"iana","extensions":["clkw"]},"application/vnd.criticaltools.wbs+xml":{"source":"iana","compressible":true,"extensions":["wbs"]},"application/vnd.cryptii.pipe+json":{"source":"iana","compressible":true},"application/vnd.crypto-shade-file":{"source":"iana"},"application/vnd.ctc-posml":{"source":"iana","extensions":["pml"]},"application/vnd.ctct.ws+xml":{"source":"iana","compressible":true},"application/vnd.cups-pdf":{"source":"iana"},"application/vnd.cups-postscript":{"source":"iana"},"application/vnd.cups-ppd":{"source":"iana","extensions":["ppd"]},"application/vnd.cups-raster":{"source":"iana"},"application/vnd.cups-raw":{"source":"iana"},"application/vnd.curl":{"source":"iana"},"application/vnd.curl.car":{"source":"apache","extensions":["car"]},"application/vnd.curl.pcurl":{"source":"apache","extensions":["pcurl"]},"application/vnd.cyan.dean.root+xml":{"source":"iana","compressible":true},"application/vnd.cybank":{"source":"iana"},"application/vnd.d2l.coursepackage1p0+zip":{"source":"iana","compressible":false},"application/vnd.dart":{"source":"iana","compressible":true,"extensions":["dart"]},"application/vnd.data-vision.rdz":{"source":"iana","extensions":["rdz"]},"application/vnd.datapackage+json":{"source":"iana","compressible":true},"application/vnd.dataresource+json":{"source":"iana","compressible":true},"application/vnd.debian.binary-package":{"source":"iana"},"application/vnd.dece.data":{"source":"iana","extensions":["uvf","uvvf","uvd","uvvd"]},"application/vnd.dece.ttml+xml":{"source":"iana","compressible":true,"extensions":["uvt","uvvt"]},"application/vnd.dece.unspecified":{"source":"iana","extensions":["uvx","uvvx"]},"application/vnd.dece.zip":{"source":"iana","extensions":["uvz","uvvz"]},"application/vnd.denovo.fcselayout-link":{"source":"iana","extensions":["fe_launch"]},"application/vnd.desmume.movie":{"source":"iana"},"application/vnd.dir-bi.plate-dl-nosuffix":{"source":"iana"},"application/vnd.dm.delegation+xml":{"source":"iana","compressible":true},"application/vnd.dna":{"source":"iana","extensions":["dna"]},"application/vnd.document+json":{"source":"iana","compressible":true},"application/vnd.dolby.mlp":{"source":"apache","extensions":["mlp"]},"application/vnd.dolby.mobile.1":{"source":"iana"},"application/vnd.dolby.mobile.2":{"source":"iana"},"application/vnd.doremir.scorecloud-binary-document":{"source":"iana"},"application/vnd.dpgraph":{"source":"iana","extensions":["dpg"]},"application/vnd.dreamfactory":{"source":"iana","extensions":["dfac"]},"application/vnd.drive+json":{"source":"iana","compressible":true},"application/vnd.ds-keypoint":{"source":"apache","extensions":["kpxx"]},"application/vnd.dtg.local":{"source":"iana"},"application/vnd.dtg.local.flash":{"source":"iana"},"application/vnd.dtg.local.html":{"source":"iana"},"application/vnd.dvb.ait":{"source":"iana","extensions":["ait"]},"application/vnd.dvb.dvbj":{"source":"iana"},"application/vnd.dvb.esgcontainer":{"source":"iana"},"application/vnd.dvb.ipdcdftnotifaccess":{"source":"iana"},"application/vnd.dvb.ipdcesgaccess":{"source":"iana"},"application/vnd.dvb.ipdcesgaccess2":{"source":"iana"},"application/vnd.dvb.ipdcesgpdd":{"source":"iana"},"application/vnd.dvb.ipdcroaming":{"source":"iana"},"application/vnd.dvb.iptv.alfec-base":{"source":"iana"},"application/vnd.dvb.iptv.alfec-enhancement":{"source":"iana"},"application/vnd.dvb.notif-aggregate-root+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-container+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-generic+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-msglist+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-registration-request+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-registration-response+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-init+xml":{"source":"iana","compressible":true},"application/vnd.dvb.pfr":{"source":"iana"},"application/vnd.dvb.service":{"source":"iana","extensions":["svc"]},"application/vnd.dxr":{"source":"iana"},"application/vnd.dynageo":{"source":"iana","extensions":["geo"]},"application/vnd.dzr":{"source":"iana"},"application/vnd.easykaraoke.cdgdownload":{"source":"iana"},"application/vnd.ecdis-update":{"source":"iana"},"application/vnd.ecip.rlp":{"source":"iana"},"application/vnd.ecowin.chart":{"source":"iana","extensions":["mag"]},"application/vnd.ecowin.filerequest":{"source":"iana"},"application/vnd.ecowin.fileupdate":{"source":"iana"},"application/vnd.ecowin.series":{"source":"iana"},"application/vnd.ecowin.seriesrequest":{"source":"iana"},"application/vnd.ecowin.seriesupdate":{"source":"iana"},"application/vnd.efi.img":{"source":"iana"},"application/vnd.efi.iso":{"source":"iana"},"application/vnd.emclient.accessrequest+xml":{"source":"iana","compressible":true},"application/vnd.enliven":{"source":"iana","extensions":["nml"]},"application/vnd.enphase.envoy":{"source":"iana"},"application/vnd.eprints.data+xml":{"source":"iana","compressible":true},"application/vnd.epson.esf":{"source":"iana","extensions":["esf"]},"application/vnd.epson.msf":{"source":"iana","extensions":["msf"]},"application/vnd.epson.quickanime":{"source":"iana","extensions":["qam"]},"application/vnd.epson.salt":{"source":"iana","extensions":["slt"]},"application/vnd.epson.ssf":{"source":"iana","extensions":["ssf"]},"application/vnd.ericsson.quickcall":{"source":"iana"},"application/vnd.espass-espass+zip":{"source":"iana","compressible":false},"application/vnd.eszigno3+xml":{"source":"iana","compressible":true,"extensions":["es3","et3"]},"application/vnd.etsi.aoc+xml":{"source":"iana","compressible":true},"application/vnd.etsi.asic-e+zip":{"source":"iana","compressible":false},"application/vnd.etsi.asic-s+zip":{"source":"iana","compressible":false},"application/vnd.etsi.cug+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvcommand+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvdiscovery+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvprofile+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-bc+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-cod+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-npvr+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvservice+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsync+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvueprofile+xml":{"source":"iana","compressible":true},"application/vnd.etsi.mcid+xml":{"source":"iana","compressible":true},"application/vnd.etsi.mheg5":{"source":"iana"},"application/vnd.etsi.overload-control-policy-dataset+xml":{"source":"iana","compressible":true},"application/vnd.etsi.pstn+xml":{"source":"iana","compressible":true},"application/vnd.etsi.sci+xml":{"source":"iana","compressible":true},"application/vnd.etsi.simservs+xml":{"source":"iana","compressible":true},"application/vnd.etsi.timestamp-token":{"source":"iana"},"application/vnd.etsi.tsl+xml":{"source":"iana","compressible":true},"application/vnd.etsi.tsl.der":{"source":"iana"},"application/vnd.eudora.data":{"source":"iana"},"application/vnd.evolv.ecig.profile":{"source":"iana"},"application/vnd.evolv.ecig.settings":{"source":"iana"},"application/vnd.evolv.ecig.theme":{"source":"iana"},"application/vnd.exstream-empower+zip":{"source":"iana","compressible":false},"application/vnd.exstream-package":{"source":"iana"},"application/vnd.ezpix-album":{"source":"iana","extensions":["ez2"]},"application/vnd.ezpix-package":{"source":"iana","extensions":["ez3"]},"application/vnd.f-secure.mobile":{"source":"iana"},"application/vnd.fastcopy-disk-image":{"source":"iana"},"application/vnd.fdf":{"source":"iana","extensions":["fdf"]},"application/vnd.fdsn.mseed":{"source":"iana","extensions":["mseed"]},"application/vnd.fdsn.seed":{"source":"iana","extensions":["seed","dataless"]},"application/vnd.ffsns":{"source":"iana"},"application/vnd.ficlab.flb+zip":{"source":"iana","compressible":false},"application/vnd.filmit.zfc":{"source":"iana"},"application/vnd.fints":{"source":"iana"},"application/vnd.firemonkeys.cloudcell":{"source":"iana"},"application/vnd.flographit":{"source":"iana","extensions":["gph"]},"application/vnd.fluxtime.clip":{"source":"iana","extensions":["ftc"]},"application/vnd.font-fontforge-sfd":{"source":"iana"},"application/vnd.framemaker":{"source":"iana","extensions":["fm","frame","maker","book"]},"application/vnd.frogans.fnc":{"source":"iana","extensions":["fnc"]},"application/vnd.frogans.ltf":{"source":"iana","extensions":["ltf"]},"application/vnd.fsc.weblaunch":{"source":"iana","extensions":["fsc"]},"application/vnd.fujitsu.oasys":{"source":"iana","extensions":["oas"]},"application/vnd.fujitsu.oasys2":{"source":"iana","extensions":["oa2"]},"application/vnd.fujitsu.oasys3":{"source":"iana","extensions":["oa3"]},"application/vnd.fujitsu.oasysgp":{"source":"iana","extensions":["fg5"]},"application/vnd.fujitsu.oasysprs":{"source":"iana","extensions":["bh2"]},"application/vnd.fujixerox.art-ex":{"source":"iana"},"application/vnd.fujixerox.art4":{"source":"iana"},"application/vnd.fujixerox.ddd":{"source":"iana","extensions":["ddd"]},"application/vnd.fujixerox.docuworks":{"source":"iana","extensions":["xdw"]},"application/vnd.fujixerox.docuworks.binder":{"source":"iana","extensions":["xbd"]},"application/vnd.fujixerox.docuworks.container":{"source":"iana"},"application/vnd.fujixerox.hbpl":{"source":"iana"},"application/vnd.fut-misnet":{"source":"iana"},"application/vnd.futoin+cbor":{"source":"iana"},"application/vnd.futoin+json":{"source":"iana","compressible":true},"application/vnd.fuzzysheet":{"source":"iana","extensions":["fzs"]},"application/vnd.genomatix.tuxedo":{"source":"iana","extensions":["txd"]},"application/vnd.geo+json":{"source":"iana","compressible":true},"application/vnd.geocube+xml":{"source":"iana","compressible":true},"application/vnd.geogebra.file":{"source":"iana","extensions":["ggb"]},"application/vnd.geogebra.tool":{"source":"iana","extensions":["ggt"]},"application/vnd.geometry-explorer":{"source":"iana","extensions":["gex","gre"]},"application/vnd.geonext":{"source":"iana","extensions":["gxt"]},"application/vnd.geoplan":{"source":"iana","extensions":["g2w"]},"application/vnd.geospace":{"source":"iana","extensions":["g3w"]},"application/vnd.gerber":{"source":"iana"},"application/vnd.globalplatform.card-content-mgt":{"source":"iana"},"application/vnd.globalplatform.card-content-mgt-response":{"source":"iana"},"application/vnd.gmx":{"source":"iana","extensions":["gmx"]},"application/vnd.google-apps.document":{"compressible":false,"extensions":["gdoc"]},"application/vnd.google-apps.presentation":{"compressible":false,"extensions":["gslides"]},"application/vnd.google-apps.spreadsheet":{"compressible":false,"extensions":["gsheet"]},"application/vnd.google-earth.kml+xml":{"source":"iana","compressible":true,"extensions":["kml"]},"application/vnd.google-earth.kmz":{"source":"iana","compressible":false,"extensions":["kmz"]},"application/vnd.gov.sk.e-form+xml":{"source":"iana","compressible":true},"application/vnd.gov.sk.e-form+zip":{"source":"iana","compressible":false},"application/vnd.gov.sk.xmldatacontainer+xml":{"source":"iana","compressible":true},"application/vnd.grafeq":{"source":"iana","extensions":["gqf","gqs"]},"application/vnd.gridmp":{"source":"iana"},"application/vnd.groove-account":{"source":"iana","extensions":["gac"]},"application/vnd.groove-help":{"source":"iana","extensions":["ghf"]},"application/vnd.groove-identity-message":{"source":"iana","extensions":["gim"]},"application/vnd.groove-injector":{"source":"iana","extensions":["grv"]},"application/vnd.groove-tool-message":{"source":"iana","extensions":["gtm"]},"application/vnd.groove-tool-template":{"source":"iana","extensions":["tpl"]},"application/vnd.groove-vcard":{"source":"iana","extensions":["vcg"]},"application/vnd.hal+json":{"source":"iana","compressible":true},"application/vnd.hal+xml":{"source":"iana","compressible":true,"extensions":["hal"]},"application/vnd.handheld-entertainment+xml":{"source":"iana","compressible":true,"extensions":["zmm"]},"application/vnd.hbci":{"source":"iana","extensions":["hbci"]},"application/vnd.hc+json":{"source":"iana","compressible":true},"application/vnd.hcl-bireports":{"source":"iana"},"application/vnd.hdt":{"source":"iana"},"application/vnd.heroku+json":{"source":"iana","compressible":true},"application/vnd.hhe.lesson-player":{"source":"iana","extensions":["les"]},"application/vnd.hp-hpgl":{"source":"iana","extensions":["hpgl"]},"application/vnd.hp-hpid":{"source":"iana","extensions":["hpid"]},"application/vnd.hp-hps":{"source":"iana","extensions":["hps"]},"application/vnd.hp-jlyt":{"source":"iana","extensions":["jlt"]},"application/vnd.hp-pcl":{"source":"iana","extensions":["pcl"]},"application/vnd.hp-pclxl":{"source":"iana","extensions":["pclxl"]},"application/vnd.httphone":{"source":"iana"},"application/vnd.hydrostatix.sof-data":{"source":"iana","extensions":["sfd-hdstx"]},"application/vnd.hyper+json":{"source":"iana","compressible":true},"application/vnd.hyper-item+json":{"source":"iana","compressible":true},"application/vnd.hyperdrive+json":{"source":"iana","compressible":true},"application/vnd.hzn-3d-crossword":{"source":"iana"},"application/vnd.ibm.afplinedata":{"source":"iana"},"application/vnd.ibm.electronic-media":{"source":"iana"},"application/vnd.ibm.minipay":{"source":"iana","extensions":["mpy"]},"application/vnd.ibm.modcap":{"source":"iana","extensions":["afp","listafp","list3820"]},"application/vnd.ibm.rights-management":{"source":"iana","extensions":["irm"]},"application/vnd.ibm.secure-container":{"source":"iana","extensions":["sc"]},"application/vnd.iccprofile":{"source":"iana","extensions":["icc","icm"]},"application/vnd.ieee.1905":{"source":"iana"},"application/vnd.igloader":{"source":"iana","extensions":["igl"]},"application/vnd.imagemeter.folder+zip":{"source":"iana","compressible":false},"application/vnd.imagemeter.image+zip":{"source":"iana","compressible":false},"application/vnd.immervision-ivp":{"source":"iana","extensions":["ivp"]},"application/vnd.immervision-ivu":{"source":"iana","extensions":["ivu"]},"application/vnd.ims.imsccv1p1":{"source":"iana"},"application/vnd.ims.imsccv1p2":{"source":"iana"},"application/vnd.ims.imsccv1p3":{"source":"iana"},"application/vnd.ims.lis.v2.result+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolconsumerprofile+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolproxy+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolproxy.id+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolsettings+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolsettings.simple+json":{"source":"iana","compressible":true},"application/vnd.informedcontrol.rms+xml":{"source":"iana","compressible":true},"application/vnd.informix-visionary":{"source":"iana"},"application/vnd.infotech.project":{"source":"iana"},"application/vnd.infotech.project+xml":{"source":"iana","compressible":true},"application/vnd.innopath.wamp.notification":{"source":"iana"},"application/vnd.insors.igm":{"source":"iana","extensions":["igm"]},"application/vnd.intercon.formnet":{"source":"iana","extensions":["xpw","xpx"]},"application/vnd.intergeo":{"source":"iana","extensions":["i2g"]},"application/vnd.intertrust.digibox":{"source":"iana"},"application/vnd.intertrust.nncp":{"source":"iana"},"application/vnd.intu.qbo":{"source":"iana","extensions":["qbo"]},"application/vnd.intu.qfx":{"source":"iana","extensions":["qfx"]},"application/vnd.iptc.g2.catalogitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.conceptitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.knowledgeitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.newsitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.newsmessage+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.packageitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.planningitem+xml":{"source":"iana","compressible":true},"application/vnd.ipunplugged.rcprofile":{"source":"iana","extensions":["rcprofile"]},"application/vnd.irepository.package+xml":{"source":"iana","compressible":true,"extensions":["irp"]},"application/vnd.is-xpr":{"source":"iana","extensions":["xpr"]},"application/vnd.isac.fcs":{"source":"iana","extensions":["fcs"]},"application/vnd.iso11783-10+zip":{"source":"iana","compressible":false},"application/vnd.jam":{"source":"iana","extensions":["jam"]},"application/vnd.japannet-directory-service":{"source":"iana"},"application/vnd.japannet-jpnstore-wakeup":{"source":"iana"},"application/vnd.japannet-payment-wakeup":{"source":"iana"},"application/vnd.japannet-registration":{"source":"iana"},"application/vnd.japannet-registration-wakeup":{"source":"iana"},"application/vnd.japannet-setstore-wakeup":{"source":"iana"},"application/vnd.japannet-verification":{"source":"iana"},"application/vnd.japannet-verification-wakeup":{"source":"iana"},"application/vnd.jcp.javame.midlet-rms":{"source":"iana","extensions":["rms"]},"application/vnd.jisp":{"source":"iana","extensions":["jisp"]},"application/vnd.joost.joda-archive":{"source":"iana","extensions":["joda"]},"application/vnd.jsk.isdn-ngn":{"source":"iana"},"application/vnd.kahootz":{"source":"iana","extensions":["ktz","ktr"]},"application/vnd.kde.karbon":{"source":"iana","extensions":["karbon"]},"application/vnd.kde.kchart":{"source":"iana","extensions":["chrt"]},"application/vnd.kde.kformula":{"source":"iana","extensions":["kfo"]},"application/vnd.kde.kivio":{"source":"iana","extensions":["flw"]},"application/vnd.kde.kontour":{"source":"iana","extensions":["kon"]},"application/vnd.kde.kpresenter":{"source":"iana","extensions":["kpr","kpt"]},"application/vnd.kde.kspread":{"source":"iana","extensions":["ksp"]},"application/vnd.kde.kword":{"source":"iana","extensions":["kwd","kwt"]},"application/vnd.kenameaapp":{"source":"iana","extensions":["htke"]},"application/vnd.kidspiration":{"source":"iana","extensions":["kia"]},"application/vnd.kinar":{"source":"iana","extensions":["kne","knp"]},"application/vnd.koan":{"source":"iana","extensions":["skp","skd","skt","skm"]},"application/vnd.kodak-descriptor":{"source":"iana","extensions":["sse"]},"application/vnd.las":{"source":"iana"},"application/vnd.las.las+json":{"source":"iana","compressible":true},"application/vnd.las.las+xml":{"source":"iana","compressible":true,"extensions":["lasxml"]},"application/vnd.laszip":{"source":"iana"},"application/vnd.leap+json":{"source":"iana","compressible":true},"application/vnd.liberty-request+xml":{"source":"iana","compressible":true},"application/vnd.llamagraphics.life-balance.desktop":{"source":"iana","extensions":["lbd"]},"application/vnd.llamagraphics.life-balance.exchange+xml":{"source":"iana","compressible":true,"extensions":["lbe"]},"application/vnd.logipipe.circuit+zip":{"source":"iana","compressible":false},"application/vnd.loom":{"source":"iana"},"application/vnd.lotus-1-2-3":{"source":"iana","extensions":["123"]},"application/vnd.lotus-approach":{"source":"iana","extensions":["apr"]},"application/vnd.lotus-freelance":{"source":"iana","extensions":["pre"]},"application/vnd.lotus-notes":{"source":"iana","extensions":["nsf"]},"application/vnd.lotus-organizer":{"source":"iana","extensions":["org"]},"application/vnd.lotus-screencam":{"source":"iana","extensions":["scm"]},"application/vnd.lotus-wordpro":{"source":"iana","extensions":["lwp"]},"application/vnd.macports.portpkg":{"source":"iana","extensions":["portpkg"]},"application/vnd.mapbox-vector-tile":{"source":"iana"},"application/vnd.marlin.drm.actiontoken+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.conftoken+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.license+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.mdcf":{"source":"iana"},"application/vnd.mason+json":{"source":"iana","compressible":true},"application/vnd.maxmind.maxmind-db":{"source":"iana"},"application/vnd.mcd":{"source":"iana","extensions":["mcd"]},"application/vnd.medcalcdata":{"source":"iana","extensions":["mc1"]},"application/vnd.mediastation.cdkey":{"source":"iana","extensions":["cdkey"]},"application/vnd.meridian-slingshot":{"source":"iana"},"application/vnd.mfer":{"source":"iana","extensions":["mwf"]},"application/vnd.mfmp":{"source":"iana","extensions":["mfm"]},"application/vnd.micro+json":{"source":"iana","compressible":true},"application/vnd.micrografx.flo":{"source":"iana","extensions":["flo"]},"application/vnd.micrografx.igx":{"source":"iana","extensions":["igx"]},"application/vnd.microsoft.portable-executable":{"source":"iana"},"application/vnd.microsoft.windows.thumbnail-cache":{"source":"iana"},"application/vnd.miele+json":{"source":"iana","compressible":true},"application/vnd.mif":{"source":"iana","extensions":["mif"]},"application/vnd.minisoft-hp3000-save":{"source":"iana"},"application/vnd.mitsubishi.misty-guard.trustweb":{"source":"iana"},"application/vnd.mobius.daf":{"source":"iana","extensions":["daf"]},"application/vnd.mobius.dis":{"source":"iana","extensions":["dis"]},"application/vnd.mobius.mbk":{"source":"iana","extensions":["mbk"]},"application/vnd.mobius.mqy":{"source":"iana","extensions":["mqy"]},"application/vnd.mobius.msl":{"source":"iana","extensions":["msl"]},"application/vnd.mobius.plc":{"source":"iana","extensions":["plc"]},"application/vnd.mobius.txf":{"source":"iana","extensions":["txf"]},"application/vnd.mophun.application":{"source":"iana","extensions":["mpn"]},"application/vnd.mophun.certificate":{"source":"iana","extensions":["mpc"]},"application/vnd.motorola.flexsuite":{"source":"iana"},"application/vnd.motorola.flexsuite.adsi":{"source":"iana"},"application/vnd.motorola.flexsuite.fis":{"source":"iana"},"application/vnd.motorola.flexsuite.gotap":{"source":"iana"},"application/vnd.motorola.flexsuite.kmr":{"source":"iana"},"application/vnd.motorola.flexsuite.ttc":{"source":"iana"},"application/vnd.motorola.flexsuite.wem":{"source":"iana"},"application/vnd.motorola.iprm":{"source":"iana"},"application/vnd.mozilla.xul+xml":{"source":"iana","compressible":true,"extensions":["xul"]},"application/vnd.ms-3mfdocument":{"source":"iana"},"application/vnd.ms-artgalry":{"source":"iana","extensions":["cil"]},"application/vnd.ms-asf":{"source":"iana"},"application/vnd.ms-cab-compressed":{"source":"iana","extensions":["cab"]},"application/vnd.ms-color.iccprofile":{"source":"apache"},"application/vnd.ms-excel":{"source":"iana","compressible":false,"extensions":["xls","xlm","xla","xlc","xlt","xlw"]},"application/vnd.ms-excel.addin.macroenabled.12":{"source":"iana","extensions":["xlam"]},"application/vnd.ms-excel.sheet.binary.macroenabled.12":{"source":"iana","extensions":["xlsb"]},"application/vnd.ms-excel.sheet.macroenabled.12":{"source":"iana","extensions":["xlsm"]},"application/vnd.ms-excel.template.macroenabled.12":{"source":"iana","extensions":["xltm"]},"application/vnd.ms-fontobject":{"source":"iana","compressible":true,"extensions":["eot"]},"application/vnd.ms-htmlhelp":{"source":"iana","extensions":["chm"]},"application/vnd.ms-ims":{"source":"iana","extensions":["ims"]},"application/vnd.ms-lrm":{"source":"iana","extensions":["lrm"]},"application/vnd.ms-office.activex+xml":{"source":"iana","compressible":true},"application/vnd.ms-officetheme":{"source":"iana","extensions":["thmx"]},"application/vnd.ms-opentype":{"source":"apache","compressible":true},"application/vnd.ms-outlook":{"compressible":false,"extensions":["msg"]},"application/vnd.ms-package.obfuscated-opentype":{"source":"apache"},"application/vnd.ms-pki.seccat":{"source":"apache","extensions":["cat"]},"application/vnd.ms-pki.stl":{"source":"apache","extensions":["stl"]},"application/vnd.ms-playready.initiator+xml":{"source":"iana","compressible":true},"application/vnd.ms-powerpoint":{"source":"iana","compressible":false,"extensions":["ppt","pps","pot"]},"application/vnd.ms-powerpoint.addin.macroenabled.12":{"source":"iana","extensions":["ppam"]},"application/vnd.ms-powerpoint.presentation.macroenabled.12":{"source":"iana","extensions":["pptm"]},"application/vnd.ms-powerpoint.slide.macroenabled.12":{"source":"iana","extensions":["sldm"]},"application/vnd.ms-powerpoint.slideshow.macroenabled.12":{"source":"iana","extensions":["ppsm"]},"application/vnd.ms-powerpoint.template.macroenabled.12":{"source":"iana","extensions":["potm"]},"application/vnd.ms-printdevicecapabilities+xml":{"source":"iana","compressible":true},"application/vnd.ms-printing.printticket+xml":{"source":"apache","compressible":true},"application/vnd.ms-printschematicket+xml":{"source":"iana","compressible":true},"application/vnd.ms-project":{"source":"iana","extensions":["mpp","mpt"]},"application/vnd.ms-tnef":{"source":"iana"},"application/vnd.ms-windows.devicepairing":{"source":"iana"},"application/vnd.ms-windows.nwprinting.oob":{"source":"iana"},"application/vnd.ms-windows.printerpairing":{"source":"iana"},"application/vnd.ms-windows.wsd.oob":{"source":"iana"},"application/vnd.ms-wmdrm.lic-chlg-req":{"source":"iana"},"application/vnd.ms-wmdrm.lic-resp":{"source":"iana"},"application/vnd.ms-wmdrm.meter-chlg-req":{"source":"iana"},"application/vnd.ms-wmdrm.meter-resp":{"source":"iana"},"application/vnd.ms-word.document.macroenabled.12":{"source":"iana","extensions":["docm"]},"application/vnd.ms-word.template.macroenabled.12":{"source":"iana","extensions":["dotm"]},"application/vnd.ms-works":{"source":"iana","extensions":["wps","wks","wcm","wdb"]},"application/vnd.ms-wpl":{"source":"iana","extensions":["wpl"]},"application/vnd.ms-xpsdocument":{"source":"iana","compressible":false,"extensions":["xps"]},"application/vnd.msa-disk-image":{"source":"iana"},"application/vnd.mseq":{"source":"iana","extensions":["mseq"]},"application/vnd.msign":{"source":"iana"},"application/vnd.multiad.creator":{"source":"iana"},"application/vnd.multiad.creator.cif":{"source":"iana"},"application/vnd.music-niff":{"source":"iana"},"application/vnd.musician":{"source":"iana","extensions":["mus"]},"application/vnd.muvee.style":{"source":"iana","extensions":["msty"]},"application/vnd.mynfc":{"source":"iana","extensions":["taglet"]},"application/vnd.ncd.control":{"source":"iana"},"application/vnd.ncd.reference":{"source":"iana"},"application/vnd.nearst.inv+json":{"source":"iana","compressible":true},"application/vnd.nervana":{"source":"iana"},"application/vnd.netfpx":{"source":"iana"},"application/vnd.neurolanguage.nlu":{"source":"iana","extensions":["nlu"]},"application/vnd.nimn":{"source":"iana"},"application/vnd.nintendo.nitro.rom":{"source":"iana"},"application/vnd.nintendo.snes.rom":{"source":"iana"},"application/vnd.nitf":{"source":"iana","extensions":["ntf","nitf"]},"application/vnd.noblenet-directory":{"source":"iana","extensions":["nnd"]},"application/vnd.noblenet-sealer":{"source":"iana","extensions":["nns"]},"application/vnd.noblenet-web":{"source":"iana","extensions":["nnw"]},"application/vnd.nokia.catalogs":{"source":"iana"},"application/vnd.nokia.conml+wbxml":{"source":"iana"},"application/vnd.nokia.conml+xml":{"source":"iana","compressible":true},"application/vnd.nokia.iptv.config+xml":{"source":"iana","compressible":true},"application/vnd.nokia.isds-radio-presets":{"source":"iana"},"application/vnd.nokia.landmark+wbxml":{"source":"iana"},"application/vnd.nokia.landmark+xml":{"source":"iana","compressible":true},"application/vnd.nokia.landmarkcollection+xml":{"source":"iana","compressible":true},"application/vnd.nokia.n-gage.ac+xml":{"source":"iana","compressible":true},"application/vnd.nokia.n-gage.data":{"source":"iana","extensions":["ngdat"]},"application/vnd.nokia.n-gage.symbian.install":{"source":"iana","extensions":["n-gage"]},"application/vnd.nokia.ncd":{"source":"iana"},"application/vnd.nokia.pcd+wbxml":{"source":"iana"},"application/vnd.nokia.pcd+xml":{"source":"iana","compressible":true},"application/vnd.nokia.radio-preset":{"source":"iana","extensions":["rpst"]},"application/vnd.nokia.radio-presets":{"source":"iana","extensions":["rpss"]},"application/vnd.novadigm.edm":{"source":"iana","extensions":["edm"]},"application/vnd.novadigm.edx":{"source":"iana","extensions":["edx"]},"application/vnd.novadigm.ext":{"source":"iana","extensions":["ext"]},"application/vnd.ntt-local.content-share":{"source":"iana"},"application/vnd.ntt-local.file-transfer":{"source":"iana"},"application/vnd.ntt-local.ogw_remote-access":{"source":"iana"},"application/vnd.ntt-local.sip-ta_remote":{"source":"iana"},"application/vnd.ntt-local.sip-ta_tcp_stream":{"source":"iana"},"application/vnd.oasis.opendocument.chart":{"source":"iana","extensions":["odc"]},"application/vnd.oasis.opendocument.chart-template":{"source":"iana","extensions":["otc"]},"application/vnd.oasis.opendocument.database":{"source":"iana","extensions":["odb"]},"application/vnd.oasis.opendocument.formula":{"source":"iana","extensions":["odf"]},"application/vnd.oasis.opendocument.formula-template":{"source":"iana","extensions":["odft"]},"application/vnd.oasis.opendocument.graphics":{"source":"iana","compressible":false,"extensions":["odg"]},"application/vnd.oasis.opendocument.graphics-template":{"source":"iana","extensions":["otg"]},"application/vnd.oasis.opendocument.image":{"source":"iana","extensions":["odi"]},"application/vnd.oasis.opendocument.image-template":{"source":"iana","extensions":["oti"]},"application/vnd.oasis.opendocument.presentation":{"source":"iana","compressible":false,"extensions":["odp"]},"application/vnd.oasis.opendocument.presentation-template":{"source":"iana","extensions":["otp"]},"application/vnd.oasis.opendocument.spreadsheet":{"source":"iana","compressible":false,"extensions":["ods"]},"application/vnd.oasis.opendocument.spreadsheet-template":{"source":"iana","extensions":["ots"]},"application/vnd.oasis.opendocument.text":{"source":"iana","compressible":false,"extensions":["odt"]},"application/vnd.oasis.opendocument.text-master":{"source":"iana","extensions":["odm"]},"application/vnd.oasis.opendocument.text-template":{"source":"iana","extensions":["ott"]},"application/vnd.oasis.opendocument.text-web":{"source":"iana","extensions":["oth"]},"application/vnd.obn":{"source":"iana"},"application/vnd.ocf+cbor":{"source":"iana"},"application/vnd.oftn.l10n+json":{"source":"iana","compressible":true},"application/vnd.oipf.contentaccessdownload+xml":{"source":"iana","compressible":true},"application/vnd.oipf.contentaccessstreaming+xml":{"source":"iana","compressible":true},"application/vnd.oipf.cspg-hexbinary":{"source":"iana"},"application/vnd.oipf.dae.svg+xml":{"source":"iana","compressible":true},"application/vnd.oipf.dae.xhtml+xml":{"source":"iana","compressible":true},"application/vnd.oipf.mippvcontrolmessage+xml":{"source":"iana","compressible":true},"application/vnd.oipf.pae.gem":{"source":"iana"},"application/vnd.oipf.spdiscovery+xml":{"source":"iana","compressible":true},"application/vnd.oipf.spdlist+xml":{"source":"iana","compressible":true},"application/vnd.oipf.ueprofile+xml":{"source":"iana","compressible":true},"application/vnd.oipf.userprofile+xml":{"source":"iana","compressible":true},"application/vnd.olpc-sugar":{"source":"iana","extensions":["xo"]},"application/vnd.oma-scws-config":{"source":"iana"},"application/vnd.oma-scws-http-request":{"source":"iana"},"application/vnd.oma-scws-http-response":{"source":"iana"},"application/vnd.oma.bcast.associated-procedure-parameter+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.drm-trigger+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.imd+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.ltkm":{"source":"iana"},"application/vnd.oma.bcast.notification+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.provisioningtrigger":{"source":"iana"},"application/vnd.oma.bcast.sgboot":{"source":"iana"},"application/vnd.oma.bcast.sgdd+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.sgdu":{"source":"iana"},"application/vnd.oma.bcast.simple-symbol-container":{"source":"iana"},"application/vnd.oma.bcast.smartcard-trigger+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.sprov+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.stkm":{"source":"iana"},"application/vnd.oma.cab-address-book+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-feature-handler+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-pcc+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-subs-invite+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-user-prefs+xml":{"source":"iana","compressible":true},"application/vnd.oma.dcd":{"source":"iana"},"application/vnd.oma.dcdc":{"source":"iana"},"application/vnd.oma.dd2+xml":{"source":"iana","compressible":true,"extensions":["dd2"]},"application/vnd.oma.drm.risd+xml":{"source":"iana","compressible":true},"application/vnd.oma.group-usage-list+xml":{"source":"iana","compressible":true},"application/vnd.oma.lwm2m+json":{"source":"iana","compressible":true},"application/vnd.oma.lwm2m+tlv":{"source":"iana"},"application/vnd.oma.pal+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.detailed-progress-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.final-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.groups+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.invocation-descriptor+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.optimized-progress-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.push":{"source":"iana"},"application/vnd.oma.scidm.messages+xml":{"source":"iana","compressible":true},"application/vnd.oma.xcap-directory+xml":{"source":"iana","compressible":true},"application/vnd.omads-email+xml":{"source":"iana","compressible":true},"application/vnd.omads-file+xml":{"source":"iana","compressible":true},"application/vnd.omads-folder+xml":{"source":"iana","compressible":true},"application/vnd.omaloc-supl-init":{"source":"iana"},"application/vnd.onepager":{"source":"iana"},"application/vnd.onepagertamp":{"source":"iana"},"application/vnd.onepagertamx":{"source":"iana"},"application/vnd.onepagertat":{"source":"iana"},"application/vnd.onepagertatp":{"source":"iana"},"application/vnd.onepagertatx":{"source":"iana"},"application/vnd.openblox.game+xml":{"source":"iana","compressible":true},"application/vnd.openblox.game-binary":{"source":"iana"},"application/vnd.openeye.oeb":{"source":"iana"},"application/vnd.openofficeorg.extension":{"source":"apache","extensions":["oxt"]},"application/vnd.openstreetmap.data+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.custom-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.customxmlproperties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawing+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.chart+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramcolors+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramdata+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramlayout+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramstyle+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.extended-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.commentauthors+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.handoutmaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.notesmaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.notesslide+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.presentation":{"source":"iana","compressible":false,"extensions":["pptx"]},"application/vnd.openxmlformats-officedocument.presentationml.presentation.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.presprops+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slide":{"source":"iana","extensions":["sldx"]},"application/vnd.openxmlformats-officedocument.presentationml.slide+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slidelayout+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slidemaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slideshow":{"source":"iana","extensions":["ppsx"]},"application/vnd.openxmlformats-officedocument.presentationml.slideshow.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slideupdateinfo+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.tablestyles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.tags+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.template":{"source":"iana","extensions":["potx"]},"application/vnd.openxmlformats-officedocument.presentationml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.viewprops+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.calcchain+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.externallink+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcachedefinition+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcacherecords+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivottable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.querytable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionheaders+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionlog+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedstrings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":{"source":"iana","compressible":false,"extensions":["xlsx"]},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetmetadata+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.tablesinglecells+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.template":{"source":"iana","extensions":["xltx"]},"application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.usernames+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.volatiledependencies+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.theme+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.themeoverride+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.vmldrawing":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.document":{"source":"iana","compressible":false,"extensions":["docx"]},"application/vnd.openxmlformats-officedocument.wordprocessingml.document.glossary+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.endnotes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.fonttable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.footer+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.footnotes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.numbering+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.settings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.styles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.template":{"source":"iana","extensions":["dotx"]},"application/vnd.openxmlformats-officedocument.wordprocessingml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.websettings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.core-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.digital-signature-xmlsignature+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.relationships+xml":{"source":"iana","compressible":true},"application/vnd.oracle.resource+json":{"source":"iana","compressible":true},"application/vnd.orange.indata":{"source":"iana"},"application/vnd.osa.netdeploy":{"source":"iana"},"application/vnd.osgeo.mapguide.package":{"source":"iana","extensions":["mgp"]},"application/vnd.osgi.bundle":{"source":"iana"},"application/vnd.osgi.dp":{"source":"iana","extensions":["dp"]},"application/vnd.osgi.subsystem":{"source":"iana","extensions":["esa"]},"application/vnd.otps.ct-kip+xml":{"source":"iana","compressible":true},"application/vnd.oxli.countgraph":{"source":"iana"},"application/vnd.pagerduty+json":{"source":"iana","compressible":true},"application/vnd.palm":{"source":"iana","extensions":["pdb","pqa","oprc"]},"application/vnd.panoply":{"source":"iana"},"application/vnd.paos.xml":{"source":"iana"},"application/vnd.patentdive":{"source":"iana"},"application/vnd.patientecommsdoc":{"source":"iana"},"application/vnd.pawaafile":{"source":"iana","extensions":["paw"]},"application/vnd.pcos":{"source":"iana"},"application/vnd.pg.format":{"source":"iana","extensions":["str"]},"application/vnd.pg.osasli":{"source":"iana","extensions":["ei6"]},"application/vnd.piaccess.application-licence":{"source":"iana"},"application/vnd.picsel":{"source":"iana","extensions":["efif"]},"application/vnd.pmi.widget":{"source":"iana","extensions":["wg"]},"application/vnd.poc.group-advertisement+xml":{"source":"iana","compressible":true},"application/vnd.pocketlearn":{"source":"iana","extensions":["plf"]},"application/vnd.powerbuilder6":{"source":"iana","extensions":["pbd"]},"application/vnd.powerbuilder6-s":{"source":"iana"},"application/vnd.powerbuilder7":{"source":"iana"},"application/vnd.powerbuilder7-s":{"source":"iana"},"application/vnd.powerbuilder75":{"source":"iana"},"application/vnd.powerbuilder75-s":{"source":"iana"},"application/vnd.preminet":{"source":"iana"},"application/vnd.previewsystems.box":{"source":"iana","extensions":["box"]},"application/vnd.proteus.magazine":{"source":"iana","extensions":["mgz"]},"application/vnd.psfs":{"source":"iana"},"application/vnd.publishare-delta-tree":{"source":"iana","extensions":["qps"]},"application/vnd.pvi.ptid1":{"source":"iana","extensions":["ptid"]},"application/vnd.pwg-multiplexed":{"source":"iana"},"application/vnd.pwg-xhtml-print+xml":{"source":"iana","compressible":true},"application/vnd.qualcomm.brew-app-res":{"source":"iana"},"application/vnd.quarantainenet":{"source":"iana"},"application/vnd.quark.quarkxpress":{"source":"iana","extensions":["qxd","qxt","qwd","qwt","qxl","qxb"]},"application/vnd.quobject-quoxdocument":{"source":"iana"},"application/vnd.radisys.moml+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-conf+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-conn+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-dialog+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-stream+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-conf+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-base+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-fax-detect+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-fax-sendrecv+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-group+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-speech+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-transform+xml":{"source":"iana","compressible":true},"application/vnd.rainstor.data":{"source":"iana"},"application/vnd.rapid":{"source":"iana"},"application/vnd.rar":{"source":"iana"},"application/vnd.realvnc.bed":{"source":"iana","extensions":["bed"]},"application/vnd.recordare.musicxml":{"source":"iana","extensions":["mxl"]},"application/vnd.recordare.musicxml+xml":{"source":"iana","compressible":true,"extensions":["musicxml"]},"application/vnd.renlearn.rlprint":{"source":"iana"},"application/vnd.restful+json":{"source":"iana","compressible":true},"application/vnd.rig.cryptonote":{"source":"iana","extensions":["cryptonote"]},"application/vnd.rim.cod":{"source":"apache","extensions":["cod"]},"application/vnd.rn-realmedia":{"source":"apache","extensions":["rm"]},"application/vnd.rn-realmedia-vbr":{"source":"apache","extensions":["rmvb"]},"application/vnd.route66.link66+xml":{"source":"iana","compressible":true,"extensions":["link66"]},"application/vnd.rs-274x":{"source":"iana"},"application/vnd.ruckus.download":{"source":"iana"},"application/vnd.s3sms":{"source":"iana"},"application/vnd.sailingtracker.track":{"source":"iana","extensions":["st"]},"application/vnd.sbm.cid":{"source":"iana"},"application/vnd.sbm.mid2":{"source":"iana"},"application/vnd.scribus":{"source":"iana"},"application/vnd.sealed.3df":{"source":"iana"},"application/vnd.sealed.csf":{"source":"iana"},"application/vnd.sealed.doc":{"source":"iana"},"application/vnd.sealed.eml":{"source":"iana"},"application/vnd.sealed.mht":{"source":"iana"},"application/vnd.sealed.net":{"source":"iana"},"application/vnd.sealed.ppt":{"source":"iana"},"application/vnd.sealed.tiff":{"source":"iana"},"application/vnd.sealed.xls":{"source":"iana"},"application/vnd.sealedmedia.softseal.html":{"source":"iana"},"application/vnd.sealedmedia.softseal.pdf":{"source":"iana"},"application/vnd.seemail":{"source":"iana","extensions":["see"]},"application/vnd.sema":{"source":"iana","extensions":["sema"]},"application/vnd.semd":{"source":"iana","extensions":["semd"]},"application/vnd.semf":{"source":"iana","extensions":["semf"]},"application/vnd.shade-save-file":{"source":"iana"},"application/vnd.shana.informed.formdata":{"source":"iana","extensions":["ifm"]},"application/vnd.shana.informed.formtemplate":{"source":"iana","extensions":["itp"]},"application/vnd.shana.informed.interchange":{"source":"iana","extensions":["iif"]},"application/vnd.shana.informed.package":{"source":"iana","extensions":["ipk"]},"application/vnd.shootproof+json":{"source":"iana","compressible":true},"application/vnd.shopkick+json":{"source":"iana","compressible":true},"application/vnd.sigrok.session":{"source":"iana"},"application/vnd.simtech-mindmapper":{"source":"iana","extensions":["twd","twds"]},"application/vnd.siren+json":{"source":"iana","compressible":true},"application/vnd.smaf":{"source":"iana","extensions":["mmf"]},"application/vnd.smart.notebook":{"source":"iana"},"application/vnd.smart.teacher":{"source":"iana","extensions":["teacher"]},"application/vnd.software602.filler.form+xml":{"source":"iana","compressible":true},"application/vnd.software602.filler.form-xml-zip":{"source":"iana"},"application/vnd.solent.sdkm+xml":{"source":"iana","compressible":true,"extensions":["sdkm","sdkd"]},"application/vnd.spotfire.dxp":{"source":"iana","extensions":["dxp"]},"application/vnd.spotfire.sfs":{"source":"iana","extensions":["sfs"]},"application/vnd.sqlite3":{"source":"iana"},"application/vnd.sss-cod":{"source":"iana"},"application/vnd.sss-dtf":{"source":"iana"},"application/vnd.sss-ntf":{"source":"iana"},"application/vnd.stardivision.calc":{"source":"apache","extensions":["sdc"]},"application/vnd.stardivision.draw":{"source":"apache","extensions":["sda"]},"application/vnd.stardivision.impress":{"source":"apache","extensions":["sdd"]},"application/vnd.stardivision.math":{"source":"apache","extensions":["smf"]},"application/vnd.stardivision.writer":{"source":"apache","extensions":["sdw","vor"]},"application/vnd.stardivision.writer-global":{"source":"apache","extensions":["sgl"]},"application/vnd.stepmania.package":{"source":"iana","extensions":["smzip"]},"application/vnd.stepmania.stepchart":{"source":"iana","extensions":["sm"]},"application/vnd.street-stream":{"source":"iana"},"application/vnd.sun.wadl+xml":{"source":"iana","compressible":true,"extensions":["wadl"]},"application/vnd.sun.xml.calc":{"source":"apache","extensions":["sxc"]},"application/vnd.sun.xml.calc.template":{"source":"apache","extensions":["stc"]},"application/vnd.sun.xml.draw":{"source":"apache","extensions":["sxd"]},"application/vnd.sun.xml.draw.template":{"source":"apache","extensions":["std"]},"application/vnd.sun.xml.impress":{"source":"apache","extensions":["sxi"]},"application/vnd.sun.xml.impress.template":{"source":"apache","extensions":["sti"]},"application/vnd.sun.xml.math":{"source":"apache","extensions":["sxm"]},"application/vnd.sun.xml.writer":{"source":"apache","extensions":["sxw"]},"application/vnd.sun.xml.writer.global":{"source":"apache","extensions":["sxg"]},"application/vnd.sun.xml.writer.template":{"source":"apache","extensions":["stw"]},"application/vnd.sus-calendar":{"source":"iana","extensions":["sus","susp"]},"application/vnd.svd":{"source":"iana","extensions":["svd"]},"application/vnd.swiftview-ics":{"source":"iana"},"application/vnd.symbian.install":{"source":"apache","extensions":["sis","sisx"]},"application/vnd.syncml+xml":{"source":"iana","compressible":true,"extensions":["xsm"]},"application/vnd.syncml.dm+wbxml":{"source":"iana","extensions":["bdm"]},"application/vnd.syncml.dm+xml":{"source":"iana","compressible":true,"extensions":["xdm"]},"application/vnd.syncml.dm.notification":{"source":"iana"},"application/vnd.syncml.dmddf+wbxml":{"source":"iana"},"application/vnd.syncml.dmddf+xml":{"source":"iana","compressible":true},"application/vnd.syncml.dmtnds+wbxml":{"source":"iana"},"application/vnd.syncml.dmtnds+xml":{"source":"iana","compressible":true},"application/vnd.syncml.ds.notification":{"source":"iana"},"application/vnd.tableschema+json":{"source":"iana","compressible":true},"application/vnd.tao.intent-module-archive":{"source":"iana","extensions":["tao"]},"application/vnd.tcpdump.pcap":{"source":"iana","extensions":["pcap","cap","dmp"]},"application/vnd.think-cell.ppttc+json":{"source":"iana","compressible":true},"application/vnd.tmd.mediaflex.api+xml":{"source":"iana","compressible":true},"application/vnd.tml":{"source":"iana"},"application/vnd.tmobile-livetv":{"source":"iana","extensions":["tmo"]},"application/vnd.tri.onesource":{"source":"iana"},"application/vnd.trid.tpt":{"source":"iana","extensions":["tpt"]},"application/vnd.triscape.mxs":{"source":"iana","extensions":["mxs"]},"application/vnd.trueapp":{"source":"iana","extensions":["tra"]},"application/vnd.truedoc":{"source":"iana"},"application/vnd.ubisoft.webplayer":{"source":"iana"},"application/vnd.ufdl":{"source":"iana","extensions":["ufd","ufdl"]},"application/vnd.uiq.theme":{"source":"iana","extensions":["utz"]},"application/vnd.umajin":{"source":"iana","extensions":["umj"]},"application/vnd.unity":{"source":"iana","extensions":["unityweb"]},"application/vnd.uoml+xml":{"source":"iana","compressible":true,"extensions":["uoml"]},"application/vnd.uplanet.alert":{"source":"iana"},"application/vnd.uplanet.alert-wbxml":{"source":"iana"},"application/vnd.uplanet.bearer-choice":{"source":"iana"},"application/vnd.uplanet.bearer-choice-wbxml":{"source":"iana"},"application/vnd.uplanet.cacheop":{"source":"iana"},"application/vnd.uplanet.cacheop-wbxml":{"source":"iana"},"application/vnd.uplanet.channel":{"source":"iana"},"application/vnd.uplanet.channel-wbxml":{"source":"iana"},"application/vnd.uplanet.list":{"source":"iana"},"application/vnd.uplanet.list-wbxml":{"source":"iana"},"application/vnd.uplanet.listcmd":{"source":"iana"},"application/vnd.uplanet.listcmd-wbxml":{"source":"iana"},"application/vnd.uplanet.signal":{"source":"iana"},"application/vnd.uri-map":{"source":"iana"},"application/vnd.valve.source.material":{"source":"iana"},"application/vnd.vcx":{"source":"iana","extensions":["vcx"]},"application/vnd.vd-study":{"source":"iana"},"application/vnd.vectorworks":{"source":"iana"},"application/vnd.vel+json":{"source":"iana","compressible":true},"application/vnd.verimatrix.vcas":{"source":"iana"},"application/vnd.veryant.thin":{"source":"iana"},"application/vnd.ves.encrypted":{"source":"iana"},"application/vnd.vidsoft.vidconference":{"source":"iana"},"application/vnd.visio":{"source":"iana","extensions":["vsd","vst","vss","vsw"]},"application/vnd.visionary":{"source":"iana","extensions":["vis"]},"application/vnd.vividence.scriptfile":{"source":"iana"},"application/vnd.vsf":{"source":"iana","extensions":["vsf"]},"application/vnd.wap.sic":{"source":"iana"},"application/vnd.wap.slc":{"source":"iana"},"application/vnd.wap.wbxml":{"source":"iana","extensions":["wbxml"]},"application/vnd.wap.wmlc":{"source":"iana","extensions":["wmlc"]},"application/vnd.wap.wmlscriptc":{"source":"iana","extensions":["wmlsc"]},"application/vnd.webturbo":{"source":"iana","extensions":["wtb"]},"application/vnd.wfa.p2p":{"source":"iana"},"application/vnd.wfa.wsc":{"source":"iana"},"application/vnd.windows.devicepairing":{"source":"iana"},"application/vnd.wmc":{"source":"iana"},"application/vnd.wmf.bootstrap":{"source":"iana"},"application/vnd.wolfram.mathematica":{"source":"iana"},"application/vnd.wolfram.mathematica.package":{"source":"iana"},"application/vnd.wolfram.player":{"source":"iana","extensions":["nbp"]},"application/vnd.wordperfect":{"source":"iana","extensions":["wpd"]},"application/vnd.wqd":{"source":"iana","extensions":["wqd"]},"application/vnd.wrq-hp3000-labelled":{"source":"iana"},"application/vnd.wt.stf":{"source":"iana","extensions":["stf"]},"application/vnd.wv.csp+wbxml":{"source":"iana"},"application/vnd.wv.csp+xml":{"source":"iana","compressible":true},"application/vnd.wv.ssp+xml":{"source":"iana","compressible":true},"application/vnd.xacml+json":{"source":"iana","compressible":true},"application/vnd.xara":{"source":"iana","extensions":["xar"]},"application/vnd.xfdl":{"source":"iana","extensions":["xfdl"]},"application/vnd.xfdl.webform":{"source":"iana"},"application/vnd.xmi+xml":{"source":"iana","compressible":true},"application/vnd.xmpie.cpkg":{"source":"iana"},"application/vnd.xmpie.dpkg":{"source":"iana"},"application/vnd.xmpie.plan":{"source":"iana"},"application/vnd.xmpie.ppkg":{"source":"iana"},"application/vnd.xmpie.xlim":{"source":"iana"},"application/vnd.yamaha.hv-dic":{"source":"iana","extensions":["hvd"]},"application/vnd.yamaha.hv-script":{"source":"iana","extensions":["hvs"]},"application/vnd.yamaha.hv-voice":{"source":"iana","extensions":["hvp"]},"application/vnd.yamaha.openscoreformat":{"source":"iana","extensions":["osf"]},"application/vnd.yamaha.openscoreformat.osfpvg+xml":{"source":"iana","compressible":true,"extensions":["osfpvg"]},"application/vnd.yamaha.remote-setup":{"source":"iana"},"application/vnd.yamaha.smaf-audio":{"source":"iana","extensions":["saf"]},"application/vnd.yamaha.smaf-phrase":{"source":"iana","extensions":["spf"]},"application/vnd.yamaha.through-ngn":{"source":"iana"},"application/vnd.yamaha.tunnel-udpencap":{"source":"iana"},"application/vnd.yaoweme":{"source":"iana"},"application/vnd.yellowriver-custom-menu":{"source":"iana","extensions":["cmp"]},"application/vnd.youtube.yt":{"source":"iana"},"application/vnd.zul":{"source":"iana","extensions":["zir","zirz"]},"application/vnd.zzazz.deck+xml":{"source":"iana","compressible":true,"extensions":["zaz"]},"application/voicexml+xml":{"source":"iana","compressible":true,"extensions":["vxml"]},"application/voucher-cms+json":{"source":"iana","compressible":true},"application/vq-rtcpxr":{"source":"iana"},"application/wasm":{"compressible":true,"extensions":["wasm"]},"application/watcherinfo+xml":{"source":"iana","compressible":true},"application/webpush-options+json":{"source":"iana","compressible":true},"application/whoispp-query":{"source":"iana"},"application/whoispp-response":{"source":"iana"},"application/widget":{"source":"iana","extensions":["wgt"]},"application/winhlp":{"source":"apache","extensions":["hlp"]},"application/wita":{"source":"iana"},"application/wordperfect5.1":{"source":"iana"},"application/wsdl+xml":{"source":"iana","compressible":true,"extensions":["wsdl"]},"application/wspolicy+xml":{"source":"iana","compressible":true,"extensions":["wspolicy"]},"application/x-7z-compressed":{"source":"apache","compressible":false,"extensions":["7z"]},"application/x-abiword":{"source":"apache","extensions":["abw"]},"application/x-ace-compressed":{"source":"apache","extensions":["ace"]},"application/x-amf":{"source":"apache"},"application/x-apple-diskimage":{"source":"apache","extensions":["dmg"]},"application/x-arj":{"compressible":false,"extensions":["arj"]},"application/x-authorware-bin":{"source":"apache","extensions":["aab","x32","u32","vox"]},"application/x-authorware-map":{"source":"apache","extensions":["aam"]},"application/x-authorware-seg":{"source":"apache","extensions":["aas"]},"application/x-bcpio":{"source":"apache","extensions":["bcpio"]},"application/x-bdoc":{"compressible":false,"extensions":["bdoc"]},"application/x-bittorrent":{"source":"apache","extensions":["torrent"]},"application/x-blorb":{"source":"apache","extensions":["blb","blorb"]},"application/x-bzip":{"source":"apache","compressible":false,"extensions":["bz"]},"application/x-bzip2":{"source":"apache","compressible":false,"extensions":["bz2","boz"]},"application/x-cbr":{"source":"apache","extensions":["cbr","cba","cbt","cbz","cb7"]},"application/x-cdlink":{"source":"apache","extensions":["vcd"]},"application/x-cfs-compressed":{"source":"apache","extensions":["cfs"]},"application/x-chat":{"source":"apache","extensions":["chat"]},"application/x-chess-pgn":{"source":"apache","extensions":["pgn"]},"application/x-chrome-extension":{"extensions":["crx"]},"application/x-cocoa":{"source":"nginx","extensions":["cco"]},"application/x-compress":{"source":"apache"},"application/x-conference":{"source":"apache","extensions":["nsc"]},"application/x-cpio":{"source":"apache","extensions":["cpio"]},"application/x-csh":{"source":"apache","extensions":["csh"]},"application/x-deb":{"compressible":false},"application/x-debian-package":{"source":"apache","extensions":["deb","udeb"]},"application/x-dgc-compressed":{"source":"apache","extensions":["dgc"]},"application/x-director":{"source":"apache","extensions":["dir","dcr","dxr","cst","cct","cxt","w3d","fgd","swa"]},"application/x-doom":{"source":"apache","extensions":["wad"]},"application/x-dtbncx+xml":{"source":"apache","compressible":true,"extensions":["ncx"]},"application/x-dtbook+xml":{"source":"apache","compressible":true,"extensions":["dtb"]},"application/x-dtbresource+xml":{"source":"apache","compressible":true,"extensions":["res"]},"application/x-dvi":{"source":"apache","compressible":false,"extensions":["dvi"]},"application/x-envoy":{"source":"apache","extensions":["evy"]},"application/x-eva":{"source":"apache","extensions":["eva"]},"application/x-font-bdf":{"source":"apache","extensions":["bdf"]},"application/x-font-dos":{"source":"apache"},"application/x-font-framemaker":{"source":"apache"},"application/x-font-ghostscript":{"source":"apache","extensions":["gsf"]},"application/x-font-libgrx":{"source":"apache"},"application/x-font-linux-psf":{"source":"apache","extensions":["psf"]},"application/x-font-pcf":{"source":"apache","extensions":["pcf"]},"application/x-font-snf":{"source":"apache","extensions":["snf"]},"application/x-font-speedo":{"source":"apache"},"application/x-font-sunos-news":{"source":"apache"},"application/x-font-type1":{"source":"apache","extensions":["pfa","pfb","pfm","afm"]},"application/x-font-vfont":{"source":"apache"},"application/x-freearc":{"source":"apache","extensions":["arc"]},"application/x-futuresplash":{"source":"apache","extensions":["spl"]},"application/x-gca-compressed":{"source":"apache","extensions":["gca"]},"application/x-glulx":{"source":"apache","extensions":["ulx"]},"application/x-gnumeric":{"source":"apache","extensions":["gnumeric"]},"application/x-gramps-xml":{"source":"apache","extensions":["gramps"]},"application/x-gtar":{"source":"apache","extensions":["gtar"]},"application/x-gzip":{"source":"apache"},"application/x-hdf":{"source":"apache","extensions":["hdf"]},"application/x-httpd-php":{"compressible":true,"extensions":["php"]},"application/x-install-instructions":{"source":"apache","extensions":["install"]},"application/x-iso9660-image":{"source":"apache","extensions":["iso"]},"application/x-java-archive-diff":{"source":"nginx","extensions":["jardiff"]},"application/x-java-jnlp-file":{"source":"apache","compressible":false,"extensions":["jnlp"]},"application/x-javascript":{"compressible":true},"application/x-latex":{"source":"apache","compressible":false,"extensions":["latex"]},"application/x-lua-bytecode":{"extensions":["luac"]},"application/x-lzh-compressed":{"source":"apache","extensions":["lzh","lha"]},"application/x-makeself":{"source":"nginx","extensions":["run"]},"application/x-mie":{"source":"apache","extensions":["mie"]},"application/x-mobipocket-ebook":{"source":"apache","extensions":["prc","mobi"]},"application/x-mpegurl":{"compressible":false},"application/x-ms-application":{"source":"apache","extensions":["application"]},"application/x-ms-shortcut":{"source":"apache","extensions":["lnk"]},"application/x-ms-wmd":{"source":"apache","extensions":["wmd"]},"application/x-ms-wmz":{"source":"apache","extensions":["wmz"]},"application/x-ms-xbap":{"source":"apache","extensions":["xbap"]},"application/x-msaccess":{"source":"apache","extensions":["mdb"]},"application/x-msbinder":{"source":"apache","extensions":["obd"]},"application/x-mscardfile":{"source":"apache","extensions":["crd"]},"application/x-msclip":{"source":"apache","extensions":["clp"]},"application/x-msdos-program":{"extensions":["exe"]},"application/x-msdownload":{"source":"apache","extensions":["exe","dll","com","bat","msi"]},"application/x-msmediaview":{"source":"apache","extensions":["mvb","m13","m14"]},"application/x-msmetafile":{"source":"apache","extensions":["wmf","wmz","emf","emz"]},"application/x-msmoney":{"source":"apache","extensions":["mny"]},"application/x-mspublisher":{"source":"apache","extensions":["pub"]},"application/x-msschedule":{"source":"apache","extensions":["scd"]},"application/x-msterminal":{"source":"apache","extensions":["trm"]},"application/x-mswrite":{"source":"apache","extensions":["wri"]},"application/x-netcdf":{"source":"apache","extensions":["nc","cdf"]},"application/x-ns-proxy-autoconfig":{"compressible":true,"extensions":["pac"]},"application/x-nzb":{"source":"apache","extensions":["nzb"]},"application/x-perl":{"source":"nginx","extensions":["pl","pm"]},"application/x-pilot":{"source":"nginx","extensions":["prc","pdb"]},"application/x-pkcs12":{"source":"apache","compressible":false,"extensions":["p12","pfx"]},"application/x-pkcs7-certificates":{"source":"apache","extensions":["p7b","spc"]},"application/x-pkcs7-certreqresp":{"source":"apache","extensions":["p7r"]},"application/x-rar-compressed":{"source":"apache","compressible":false,"extensions":["rar"]},"application/x-redhat-package-manager":{"source":"nginx","extensions":["rpm"]},"application/x-research-info-systems":{"source":"apache","extensions":["ris"]},"application/x-sea":{"source":"nginx","extensions":["sea"]},"application/x-sh":{"source":"apache","compressible":true,"extensions":["sh"]},"application/x-shar":{"source":"apache","extensions":["shar"]},"application/x-shockwave-flash":{"source":"apache","compressible":false,"extensions":["swf"]},"application/x-silverlight-app":{"source":"apache","extensions":["xap"]},"application/x-sql":{"source":"apache","extensions":["sql"]},"application/x-stuffit":{"source":"apache","compressible":false,"extensions":["sit"]},"application/x-stuffitx":{"source":"apache","extensions":["sitx"]},"application/x-subrip":{"source":"apache","extensions":["srt"]},"application/x-sv4cpio":{"source":"apache","extensions":["sv4cpio"]},"application/x-sv4crc":{"source":"apache","extensions":["sv4crc"]},"application/x-t3vm-image":{"source":"apache","extensions":["t3"]},"application/x-tads":{"source":"apache","extensions":["gam"]},"application/x-tar":{"source":"apache","compressible":true,"extensions":["tar"]},"application/x-tcl":{"source":"apache","extensions":["tcl","tk"]},"application/x-tex":{"source":"apache","extensions":["tex"]},"application/x-tex-tfm":{"source":"apache","extensions":["tfm"]},"application/x-texinfo":{"source":"apache","extensions":["texinfo","texi"]},"application/x-tgif":{"source":"apache","extensions":["obj"]},"application/x-ustar":{"source":"apache","extensions":["ustar"]},"application/x-virtualbox-hdd":{"compressible":true,"extensions":["hdd"]},"application/x-virtualbox-ova":{"compressible":true,"extensions":["ova"]},"application/x-virtualbox-ovf":{"compressible":true,"extensions":["ovf"]},"application/x-virtualbox-vbox":{"compressible":true,"extensions":["vbox"]},"application/x-virtualbox-vbox-extpack":{"compressible":false,"extensions":["vbox-extpack"]},"application/x-virtualbox-vdi":{"compressible":true,"extensions":["vdi"]},"application/x-virtualbox-vhd":{"compressible":true,"extensions":["vhd"]},"application/x-virtualbox-vmdk":{"compressible":true,"extensions":["vmdk"]},"application/x-wais-source":{"source":"apache","extensions":["src"]},"application/x-web-app-manifest+json":{"compressible":true,"extensions":["webapp"]},"application/x-www-form-urlencoded":{"source":"iana","compressible":true},"application/x-x509-ca-cert":{"source":"apache","extensions":["der","crt","pem"]},"application/x-xfig":{"source":"apache","extensions":["fig"]},"application/x-xliff+xml":{"source":"apache","compressible":true,"extensions":["xlf"]},"application/x-xpinstall":{"source":"apache","compressible":false,"extensions":["xpi"]},"application/x-xz":{"source":"apache","extensions":["xz"]},"application/x-zmachine":{"source":"apache","extensions":["z1","z2","z3","z4","z5","z6","z7","z8"]},"application/x400-bp":{"source":"iana"},"application/xacml+xml":{"source":"iana","compressible":true},"application/xaml+xml":{"source":"apache","compressible":true,"extensions":["xaml"]},"application/xcap-att+xml":{"source":"iana","compressible":true},"application/xcap-caps+xml":{"source":"iana","compressible":true},"application/xcap-diff+xml":{"source":"iana","compressible":true,"extensions":["xdf"]},"application/xcap-el+xml":{"source":"iana","compressible":true},"application/xcap-error+xml":{"source":"iana","compressible":true},"application/xcap-ns+xml":{"source":"iana","compressible":true},"application/xcon-conference-info+xml":{"source":"iana","compressible":true},"application/xcon-conference-info-diff+xml":{"source":"iana","compressible":true},"application/xenc+xml":{"source":"iana","compressible":true,"extensions":["xenc"]},"application/xhtml+xml":{"source":"iana","compressible":true,"extensions":["xhtml","xht"]},"application/xhtml-voice+xml":{"source":"apache","compressible":true},"application/xliff+xml":{"source":"iana","compressible":true},"application/xml":{"source":"iana","compressible":true,"extensions":["xml","xsl","xsd","rng"]},"application/xml-dtd":{"source":"iana","compressible":true,"extensions":["dtd"]},"application/xml-external-parsed-entity":{"source":"iana"},"application/xml-patch+xml":{"source":"iana","compressible":true},"application/xmpp+xml":{"source":"iana","compressible":true},"application/xop+xml":{"source":"iana","compressible":true,"extensions":["xop"]},"application/xproc+xml":{"source":"apache","compressible":true,"extensions":["xpl"]},"application/xslt+xml":{"source":"iana","compressible":true,"extensions":["xslt"]},"application/xspf+xml":{"source":"apache","compressible":true,"extensions":["xspf"]},"application/xv+xml":{"source":"iana","compressible":true,"extensions":["mxml","xhvml","xvml","xvm"]},"application/yang":{"source":"iana","extensions":["yang"]},"application/yang-data+json":{"source":"iana","compressible":true},"application/yang-data+xml":{"source":"iana","compressible":true},"application/yang-patch+json":{"source":"iana","compressible":true},"application/yang-patch+xml":{"source":"iana","compressible":true},"application/yin+xml":{"source":"iana","compressible":true,"extensions":["yin"]},"application/zip":{"source":"iana","compressible":false,"extensions":["zip"]},"application/zlib":{"source":"iana"},"application/zstd":{"source":"iana"},"audio/1d-interleaved-parityfec":{"source":"iana"},"audio/32kadpcm":{"source":"iana"},"audio/3gpp":{"source":"iana","compressible":false,"extensions":["3gpp"]},"audio/3gpp2":{"source":"iana"},"audio/aac":{"source":"iana"},"audio/ac3":{"source":"iana"},"audio/adpcm":{"source":"apache","extensions":["adp"]},"audio/amr":{"source":"iana"},"audio/amr-wb":{"source":"iana"},"audio/amr-wb+":{"source":"iana"},"audio/aptx":{"source":"iana"},"audio/asc":{"source":"iana"},"audio/atrac-advanced-lossless":{"source":"iana"},"audio/atrac-x":{"source":"iana"},"audio/atrac3":{"source":"iana"},"audio/basic":{"source":"iana","compressible":false,"extensions":["au","snd"]},"audio/bv16":{"source":"iana"},"audio/bv32":{"source":"iana"},"audio/clearmode":{"source":"iana"},"audio/cn":{"source":"iana"},"audio/dat12":{"source":"iana"},"audio/dls":{"source":"iana"},"audio/dsr-es201108":{"source":"iana"},"audio/dsr-es202050":{"source":"iana"},"audio/dsr-es202211":{"source":"iana"},"audio/dsr-es202212":{"source":"iana"},"audio/dv":{"source":"iana"},"audio/dvi4":{"source":"iana"},"audio/eac3":{"source":"iana"},"audio/encaprtp":{"source":"iana"},"audio/evrc":{"source":"iana"},"audio/evrc-qcp":{"source":"iana"},"audio/evrc0":{"source":"iana"},"audio/evrc1":{"source":"iana"},"audio/evrcb":{"source":"iana"},"audio/evrcb0":{"source":"iana"},"audio/evrcb1":{"source":"iana"},"audio/evrcnw":{"source":"iana"},"audio/evrcnw0":{"source":"iana"},"audio/evrcnw1":{"source":"iana"},"audio/evrcwb":{"source":"iana"},"audio/evrcwb0":{"source":"iana"},"audio/evrcwb1":{"source":"iana"},"audio/evs":{"source":"iana"},"audio/flexfec":{"source":"iana"},"audio/fwdred":{"source":"iana"},"audio/g711-0":{"source":"iana"},"audio/g719":{"source":"iana"},"audio/g722":{"source":"iana"},"audio/g7221":{"source":"iana"},"audio/g723":{"source":"iana"},"audio/g726-16":{"source":"iana"},"audio/g726-24":{"source":"iana"},"audio/g726-32":{"source":"iana"},"audio/g726-40":{"source":"iana"},"audio/g728":{"source":"iana"},"audio/g729":{"source":"iana"},"audio/g7291":{"source":"iana"},"audio/g729d":{"source":"iana"},"audio/g729e":{"source":"iana"},"audio/gsm":{"source":"iana"},"audio/gsm-efr":{"source":"iana"},"audio/gsm-hr-08":{"source":"iana"},"audio/ilbc":{"source":"iana"},"audio/ip-mr_v2.5":{"source":"iana"},"audio/isac":{"source":"apache"},"audio/l16":{"source":"iana"},"audio/l20":{"source":"iana"},"audio/l24":{"source":"iana","compressible":false},"audio/l8":{"source":"iana"},"audio/lpc":{"source":"iana"},"audio/melp":{"source":"iana"},"audio/melp1200":{"source":"iana"},"audio/melp2400":{"source":"iana"},"audio/melp600":{"source":"iana"},"audio/midi":{"source":"apache","extensions":["mid","midi","kar","rmi"]},"audio/mobile-xmf":{"source":"iana"},"audio/mp3":{"compressible":false,"extensions":["mp3"]},"audio/mp4":{"source":"iana","compressible":false,"extensions":["m4a","mp4a"]},"audio/mp4a-latm":{"source":"iana"},"audio/mpa":{"source":"iana"},"audio/mpa-robust":{"source":"iana"},"audio/mpeg":{"source":"iana","compressible":false,"extensions":["mpga","mp2","mp2a","mp3","m2a","m3a"]},"audio/mpeg4-generic":{"source":"iana"},"audio/musepack":{"source":"apache"},"audio/ogg":{"source":"iana","compressible":false,"extensions":["oga","ogg","spx"]},"audio/opus":{"source":"iana"},"audio/parityfec":{"source":"iana"},"audio/pcma":{"source":"iana"},"audio/pcma-wb":{"source":"iana"},"audio/pcmu":{"source":"iana"},"audio/pcmu-wb":{"source":"iana"},"audio/prs.sid":{"source":"iana"},"audio/qcelp":{"source":"iana"},"audio/raptorfec":{"source":"iana"},"audio/red":{"source":"iana"},"audio/rtp-enc-aescm128":{"source":"iana"},"audio/rtp-midi":{"source":"iana"},"audio/rtploopback":{"source":"iana"},"audio/rtx":{"source":"iana"},"audio/s3m":{"source":"apache","extensions":["s3m"]},"audio/silk":{"source":"apache","extensions":["sil"]},"audio/smv":{"source":"iana"},"audio/smv-qcp":{"source":"iana"},"audio/smv0":{"source":"iana"},"audio/sp-midi":{"source":"iana"},"audio/speex":{"source":"iana"},"audio/t140c":{"source":"iana"},"audio/t38":{"source":"iana"},"audio/telephone-event":{"source":"iana"},"audio/tetra_acelp":{"source":"iana"},"audio/tone":{"source":"iana"},"audio/uemclip":{"source":"iana"},"audio/ulpfec":{"source":"iana"},"audio/usac":{"source":"iana"},"audio/vdvi":{"source":"iana"},"audio/vmr-wb":{"source":"iana"},"audio/vnd.3gpp.iufp":{"source":"iana"},"audio/vnd.4sb":{"source":"iana"},"audio/vnd.audiokoz":{"source":"iana"},"audio/vnd.celp":{"source":"iana"},"audio/vnd.cisco.nse":{"source":"iana"},"audio/vnd.cmles.radio-events":{"source":"iana"},"audio/vnd.cns.anp1":{"source":"iana"},"audio/vnd.cns.inf1":{"source":"iana"},"audio/vnd.dece.audio":{"source":"iana","extensions":["uva","uvva"]},"audio/vnd.digital-winds":{"source":"iana","extensions":["eol"]},"audio/vnd.dlna.adts":{"source":"iana"},"audio/vnd.dolby.heaac.1":{"source":"iana"},"audio/vnd.dolby.heaac.2":{"source":"iana"},"audio/vnd.dolby.mlp":{"source":"iana"},"audio/vnd.dolby.mps":{"source":"iana"},"audio/vnd.dolby.pl2":{"source":"iana"},"audio/vnd.dolby.pl2x":{"source":"iana"},"audio/vnd.dolby.pl2z":{"source":"iana"},"audio/vnd.dolby.pulse.1":{"source":"iana"},"audio/vnd.dra":{"source":"iana","extensions":["dra"]},"audio/vnd.dts":{"source":"iana","extensions":["dts"]},"audio/vnd.dts.hd":{"source":"iana","extensions":["dtshd"]},"audio/vnd.dts.uhd":{"source":"iana"},"audio/vnd.dvb.file":{"source":"iana"},"audio/vnd.everad.plj":{"source":"iana"},"audio/vnd.hns.audio":{"source":"iana"},"audio/vnd.lucent.voice":{"source":"iana","extensions":["lvp"]},"audio/vnd.ms-playready.media.pya":{"source":"iana","extensions":["pya"]},"audio/vnd.nokia.mobile-xmf":{"source":"iana"},"audio/vnd.nortel.vbk":{"source":"iana"},"audio/vnd.nuera.ecelp4800":{"source":"iana","extensions":["ecelp4800"]},"audio/vnd.nuera.ecelp7470":{"source":"iana","extensions":["ecelp7470"]},"audio/vnd.nuera.ecelp9600":{"source":"iana","extensions":["ecelp9600"]},"audio/vnd.octel.sbc":{"source":"iana"},"audio/vnd.presonus.multitrack":{"source":"iana"},"audio/vnd.qcelp":{"source":"iana"},"audio/vnd.rhetorex.32kadpcm":{"source":"iana"},"audio/vnd.rip":{"source":"iana","extensions":["rip"]},"audio/vnd.rn-realaudio":{"compressible":false},"audio/vnd.sealedmedia.softseal.mpeg":{"source":"iana"},"audio/vnd.vmx.cvsd":{"source":"iana"},"audio/vnd.wave":{"compressible":false},"audio/vorbis":{"source":"iana","compressible":false},"audio/vorbis-config":{"source":"iana"},"audio/wav":{"compressible":false,"extensions":["wav"]},"audio/wave":{"compressible":false,"extensions":["wav"]},"audio/webm":{"source":"apache","compressible":false,"extensions":["weba"]},"audio/x-aac":{"source":"apache","compressible":false,"extensions":["aac"]},"audio/x-aiff":{"source":"apache","extensions":["aif","aiff","aifc"]},"audio/x-caf":{"source":"apache","compressible":false,"extensions":["caf"]},"audio/x-flac":{"source":"apache","extensions":["flac"]},"audio/x-m4a":{"source":"nginx","extensions":["m4a"]},"audio/x-matroska":{"source":"apache","extensions":["mka"]},"audio/x-mpegurl":{"source":"apache","extensions":["m3u"]},"audio/x-ms-wax":{"source":"apache","extensions":["wax"]},"audio/x-ms-wma":{"source":"apache","extensions":["wma"]},"audio/x-pn-realaudio":{"source":"apache","extensions":["ram","ra"]},"audio/x-pn-realaudio-plugin":{"source":"apache","extensions":["rmp"]},"audio/x-realaudio":{"source":"nginx","extensions":["ra"]},"audio/x-tta":{"source":"apache"},"audio/x-wav":{"source":"apache","extensions":["wav"]},"audio/xm":{"source":"apache","extensions":["xm"]},"chemical/x-cdx":{"source":"apache","extensions":["cdx"]},"chemical/x-cif":{"source":"apache","extensions":["cif"]},"chemical/x-cmdf":{"source":"apache","extensions":["cmdf"]},"chemical/x-cml":{"source":"apache","extensions":["cml"]},"chemical/x-csml":{"source":"apache","extensions":["csml"]},"chemical/x-pdb":{"source":"apache"},"chemical/x-xyz":{"source":"apache","extensions":["xyz"]},"font/collection":{"source":"iana","extensions":["ttc"]},"font/otf":{"source":"iana","compressible":true,"extensions":["otf"]},"font/sfnt":{"source":"iana"},"font/ttf":{"source":"iana","compressible":true,"extensions":["ttf"]},"font/woff":{"source":"iana","extensions":["woff"]},"font/woff2":{"source":"iana","extensions":["woff2"]},"image/aces":{"source":"iana","extensions":["exr"]},"image/apng":{"compressible":false,"extensions":["apng"]},"image/avci":{"source":"iana"},"image/avcs":{"source":"iana"},"image/bmp":{"source":"iana","compressible":true,"extensions":["bmp"]},"image/cgm":{"source":"iana","extensions":["cgm"]},"image/dicom-rle":{"source":"iana","extensions":["drle"]},"image/emf":{"source":"iana","extensions":["emf"]},"image/fits":{"source":"iana","extensions":["fits"]},"image/g3fax":{"source":"iana","extensions":["g3"]},"image/gif":{"source":"iana","compressible":false,"extensions":["gif"]},"image/heic":{"source":"iana","extensions":["heic"]},"image/heic-sequence":{"source":"iana","extensions":["heics"]},"image/heif":{"source":"iana","extensions":["heif"]},"image/heif-sequence":{"source":"iana","extensions":["heifs"]},"image/hej2k":{"source":"iana","extensions":["hej2"]},"image/hsj2":{"source":"iana","extensions":["hsj2"]},"image/ief":{"source":"iana","extensions":["ief"]},"image/jls":{"source":"iana","extensions":["jls"]},"image/jp2":{"source":"iana","compressible":false,"extensions":["jp2","jpg2"]},"image/jpeg":{"source":"iana","compressible":false,"extensions":["jpeg","jpg","jpe"]},"image/jph":{"source":"iana","extensions":["jph"]},"image/jphc":{"source":"iana","extensions":["jhc"]},"image/jpm":{"source":"iana","compressible":false,"extensions":["jpm"]},"image/jpx":{"source":"iana","compressible":false,"extensions":["jpx","jpf"]},"image/jxr":{"source":"iana","extensions":["jxr"]},"image/jxra":{"source":"iana","extensions":["jxra"]},"image/jxrs":{"source":"iana","extensions":["jxrs"]},"image/jxs":{"source":"iana","extensions":["jxs"]},"image/jxsc":{"source":"iana","extensions":["jxsc"]},"image/jxsi":{"source":"iana","extensions":["jxsi"]},"image/jxss":{"source":"iana","extensions":["jxss"]},"image/ktx":{"source":"iana","extensions":["ktx"]},"image/naplps":{"source":"iana"},"image/pjpeg":{"compressible":false},"image/png":{"source":"iana","compressible":false,"extensions":["png"]},"image/prs.btif":{"source":"iana","extensions":["btif"]},"image/prs.pti":{"source":"iana","extensions":["pti"]},"image/pwg-raster":{"source":"iana"},"image/sgi":{"source":"apache","extensions":["sgi"]},"image/svg+xml":{"source":"iana","compressible":true,"extensions":["svg","svgz"]},"image/t38":{"source":"iana","extensions":["t38"]},"image/tiff":{"source":"iana","compressible":false,"extensions":["tif","tiff"]},"image/tiff-fx":{"source":"iana","extensions":["tfx"]},"image/vnd.adobe.photoshop":{"source":"iana","compressible":true,"extensions":["psd"]},"image/vnd.airzip.accelerator.azv":{"source":"iana","extensions":["azv"]},"image/vnd.cns.inf2":{"source":"iana"},"image/vnd.dece.graphic":{"source":"iana","extensions":["uvi","uvvi","uvg","uvvg"]},"image/vnd.djvu":{"source":"iana","extensions":["djvu","djv"]},"image/vnd.dvb.subtitle":{"source":"iana","extensions":["sub"]},"image/vnd.dwg":{"source":"iana","extensions":["dwg"]},"image/vnd.dxf":{"source":"iana","extensions":["dxf"]},"image/vnd.fastbidsheet":{"source":"iana","extensions":["fbs"]},"image/vnd.fpx":{"source":"iana","extensions":["fpx"]},"image/vnd.fst":{"source":"iana","extensions":["fst"]},"image/vnd.fujixerox.edmics-mmr":{"source":"iana","extensions":["mmr"]},"image/vnd.fujixerox.edmics-rlc":{"source":"iana","extensions":["rlc"]},"image/vnd.globalgraphics.pgb":{"source":"iana"},"image/vnd.microsoft.icon":{"source":"iana","extensions":["ico"]},"image/vnd.mix":{"source":"iana"},"image/vnd.mozilla.apng":{"source":"iana"},"image/vnd.ms-dds":{"extensions":["dds"]},"image/vnd.ms-modi":{"source":"iana","extensions":["mdi"]},"image/vnd.ms-photo":{"source":"apache","extensions":["wdp"]},"image/vnd.net-fpx":{"source":"iana","extensions":["npx"]},"image/vnd.radiance":{"source":"iana"},"image/vnd.sealed.png":{"source":"iana"},"image/vnd.sealedmedia.softseal.gif":{"source":"iana"},"image/vnd.sealedmedia.softseal.jpg":{"source":"iana"},"image/vnd.svf":{"source":"iana"},"image/vnd.tencent.tap":{"source":"iana","extensions":["tap"]},"image/vnd.valve.source.texture":{"source":"iana","extensions":["vtf"]},"image/vnd.wap.wbmp":{"source":"iana","extensions":["wbmp"]},"image/vnd.xiff":{"source":"iana","extensions":["xif"]},"image/vnd.zbrush.pcx":{"source":"iana","extensions":["pcx"]},"image/webp":{"source":"apache","extensions":["webp"]},"image/wmf":{"source":"iana","extensions":["wmf"]},"image/x-3ds":{"source":"apache","extensions":["3ds"]},"image/x-cmu-raster":{"source":"apache","extensions":["ras"]},"image/x-cmx":{"source":"apache","extensions":["cmx"]},"image/x-freehand":{"source":"apache","extensions":["fh","fhc","fh4","fh5","fh7"]},"image/x-icon":{"source":"apache","compressible":true,"extensions":["ico"]},"image/x-jng":{"source":"nginx","extensions":["jng"]},"image/x-mrsid-image":{"source":"apache","extensions":["sid"]},"image/x-ms-bmp":{"source":"nginx","compressible":true,"extensions":["bmp"]},"image/x-pcx":{"source":"apache","extensions":["pcx"]},"image/x-pict":{"source":"apache","extensions":["pic","pct"]},"image/x-portable-anymap":{"source":"apache","extensions":["pnm"]},"image/x-portable-bitmap":{"source":"apache","extensions":["pbm"]},"image/x-portable-graymap":{"source":"apache","extensions":["pgm"]},"image/x-portable-pixmap":{"source":"apache","extensions":["ppm"]},"image/x-rgb":{"source":"apache","extensions":["rgb"]},"image/x-tga":{"source":"apache","extensions":["tga"]},"image/x-xbitmap":{"source":"apache","extensions":["xbm"]},"image/x-xcf":{"compressible":false},"image/x-xpixmap":{"source":"apache","extensions":["xpm"]},"image/x-xwindowdump":{"source":"apache","extensions":["xwd"]},"message/cpim":{"source":"iana"},"message/delivery-status":{"source":"iana"},"message/disposition-notification":{"source":"iana","extensions":["disposition-notification"]},"message/external-body":{"source":"iana"},"message/feedback-report":{"source":"iana"},"message/global":{"source":"iana","extensions":["u8msg"]},"message/global-delivery-status":{"source":"iana","extensions":["u8dsn"]},"message/global-disposition-notification":{"source":"iana","extensions":["u8mdn"]},"message/global-headers":{"source":"iana","extensions":["u8hdr"]},"message/http":{"source":"iana","compressible":false},"message/imdn+xml":{"source":"iana","compressible":true},"message/news":{"source":"iana"},"message/partial":{"source":"iana","compressible":false},"message/rfc822":{"source":"iana","compressible":true,"extensions":["eml","mime"]},"message/s-http":{"source":"iana"},"message/sip":{"source":"iana"},"message/sipfrag":{"source":"iana"},"message/tracking-status":{"source":"iana"},"message/vnd.si.simp":{"source":"iana"},"message/vnd.wfa.wsc":{"source":"iana","extensions":["wsc"]},"model/3mf":{"source":"iana","extensions":["3mf"]},"model/gltf+json":{"source":"iana","compressible":true,"extensions":["gltf"]},"model/gltf-binary":{"source":"iana","compressible":true,"extensions":["glb"]},"model/iges":{"source":"iana","compressible":false,"extensions":["igs","iges"]},"model/mesh":{"source":"iana","compressible":false,"extensions":["msh","mesh","silo"]},"model/stl":{"source":"iana","extensions":["stl"]},"model/vnd.collada+xml":{"source":"iana","compressible":true,"extensions":["dae"]},"model/vnd.dwf":{"source":"iana","extensions":["dwf"]},"model/vnd.flatland.3dml":{"source":"iana"},"model/vnd.gdl":{"source":"iana","extensions":["gdl"]},"model/vnd.gs-gdl":{"source":"apache"},"model/vnd.gs.gdl":{"source":"iana"},"model/vnd.gtw":{"source":"iana","extensions":["gtw"]},"model/vnd.moml+xml":{"source":"iana","compressible":true},"model/vnd.mts":{"source":"iana","extensions":["mts"]},"model/vnd.opengex":{"source":"iana","extensions":["ogex"]},"model/vnd.parasolid.transmit.binary":{"source":"iana","extensions":["x_b"]},"model/vnd.parasolid.transmit.text":{"source":"iana","extensions":["x_t"]},"model/vnd.rosette.annotated-data-model":{"source":"iana"},"model/vnd.usdz+zip":{"source":"iana","compressible":false,"extensions":["usdz"]},"model/vnd.valve.source.compiled-map":{"source":"iana","extensions":["bsp"]},"model/vnd.vtu":{"source":"iana","extensions":["vtu"]},"model/vrml":{"source":"iana","compressible":false,"extensions":["wrl","vrml"]},"model/x3d+binary":{"source":"apache","compressible":false,"extensions":["x3db","x3dbz"]},"model/x3d+fastinfoset":{"source":"iana","extensions":["x3db"]},"model/x3d+vrml":{"source":"apache","compressible":false,"extensions":["x3dv","x3dvz"]},"model/x3d+xml":{"source":"iana","compressible":true,"extensions":["x3d","x3dz"]},"model/x3d-vrml":{"source":"iana","extensions":["x3dv"]},"multipart/alternative":{"source":"iana","compressible":false},"multipart/appledouble":{"source":"iana"},"multipart/byteranges":{"source":"iana"},"multipart/digest":{"source":"iana"},"multipart/encrypted":{"source":"iana","compressible":false},"multipart/form-data":{"source":"iana","compressible":false},"multipart/header-set":{"source":"iana"},"multipart/mixed":{"source":"iana"},"multipart/multilingual":{"source":"iana"},"multipart/parallel":{"source":"iana"},"multipart/related":{"source":"iana","compressible":false},"multipart/report":{"source":"iana"},"multipart/signed":{"source":"iana","compressible":false},"multipart/vnd.bint.med-plus":{"source":"iana"},"multipart/voice-message":{"source":"iana"},"multipart/x-mixed-replace":{"source":"iana"},"text/1d-interleaved-parityfec":{"source":"iana"},"text/cache-manifest":{"source":"iana","compressible":true,"extensions":["appcache","manifest"]},"text/calendar":{"source":"iana","extensions":["ics","ifb"]},"text/calender":{"compressible":true},"text/cmd":{"compressible":true},"text/coffeescript":{"extensions":["coffee","litcoffee"]},"text/css":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["css"]},"text/csv":{"source":"iana","compressible":true,"extensions":["csv"]},"text/csv-schema":{"source":"iana"},"text/directory":{"source":"iana"},"text/dns":{"source":"iana"},"text/ecmascript":{"source":"iana"},"text/encaprtp":{"source":"iana"},"text/enriched":{"source":"iana"},"text/flexfec":{"source":"iana"},"text/fwdred":{"source":"iana"},"text/grammar-ref-list":{"source":"iana"},"text/html":{"source":"iana","compressible":true,"extensions":["html","htm","shtml"]},"text/jade":{"extensions":["jade"]},"text/javascript":{"source":"iana","compressible":true},"text/jcr-cnd":{"source":"iana"},"text/jsx":{"compressible":true,"extensions":["jsx"]},"text/less":{"compressible":true,"extensions":["less"]},"text/markdown":{"source":"iana","compressible":true,"extensions":["markdown","md"]},"text/mathml":{"source":"nginx","extensions":["mml"]},"text/mdx":{"compressible":true,"extensions":["mdx"]},"text/mizar":{"source":"iana"},"text/n3":{"source":"iana","compressible":true,"extensions":["n3"]},"text/parameters":{"source":"iana"},"text/parityfec":{"source":"iana"},"text/plain":{"source":"iana","compressible":true,"extensions":["txt","text","conf","def","list","log","in","ini"]},"text/provenance-notation":{"source":"iana"},"text/prs.fallenstein.rst":{"source":"iana"},"text/prs.lines.tag":{"source":"iana","extensions":["dsc"]},"text/prs.prop.logic":{"source":"iana"},"text/raptorfec":{"source":"iana"},"text/red":{"source":"iana"},"text/rfc822-headers":{"source":"iana"},"text/richtext":{"source":"iana","compressible":true,"extensions":["rtx"]},"text/rtf":{"source":"iana","compressible":true,"extensions":["rtf"]},"text/rtp-enc-aescm128":{"source":"iana"},"text/rtploopback":{"source":"iana"},"text/rtx":{"source":"iana"},"text/sgml":{"source":"iana","extensions":["sgml","sgm"]},"text/shex":{"extensions":["shex"]},"text/slim":{"extensions":["slim","slm"]},"text/strings":{"source":"iana"},"text/stylus":{"extensions":["stylus","styl"]},"text/t140":{"source":"iana"},"text/tab-separated-values":{"source":"iana","compressible":true,"extensions":["tsv"]},"text/troff":{"source":"iana","extensions":["t","tr","roff","man","me","ms"]},"text/turtle":{"source":"iana","charset":"UTF-8","extensions":["ttl"]},"text/ulpfec":{"source":"iana"},"text/uri-list":{"source":"iana","compressible":true,"extensions":["uri","uris","urls"]},"text/vcard":{"source":"iana","compressible":true,"extensions":["vcard"]},"text/vnd.a":{"source":"iana"},"text/vnd.abc":{"source":"iana"},"text/vnd.ascii-art":{"source":"iana"},"text/vnd.curl":{"source":"iana","extensions":["curl"]},"text/vnd.curl.dcurl":{"source":"apache","extensions":["dcurl"]},"text/vnd.curl.mcurl":{"source":"apache","extensions":["mcurl"]},"text/vnd.curl.scurl":{"source":"apache","extensions":["scurl"]},"text/vnd.debian.copyright":{"source":"iana"},"text/vnd.dmclientscript":{"source":"iana"},"text/vnd.dvb.subtitle":{"source":"iana","extensions":["sub"]},"text/vnd.esmertec.theme-descriptor":{"source":"iana"},"text/vnd.ficlab.flt":{"source":"iana"},"text/vnd.fly":{"source":"iana","extensions":["fly"]},"text/vnd.fmi.flexstor":{"source":"iana","extensions":["flx"]},"text/vnd.gml":{"source":"iana"},"text/vnd.graphviz":{"source":"iana","extensions":["gv"]},"text/vnd.hgl":{"source":"iana"},"text/vnd.in3d.3dml":{"source":"iana","extensions":["3dml"]},"text/vnd.in3d.spot":{"source":"iana","extensions":["spot"]},"text/vnd.iptc.newsml":{"source":"iana"},"text/vnd.iptc.nitf":{"source":"iana"},"text/vnd.latex-z":{"source":"iana"},"text/vnd.motorola.reflex":{"source":"iana"},"text/vnd.ms-mediapackage":{"source":"iana"},"text/vnd.net2phone.commcenter.command":{"source":"iana"},"text/vnd.radisys.msml-basic-layout":{"source":"iana"},"text/vnd.senx.warpscript":{"source":"iana"},"text/vnd.si.uricatalogue":{"source":"iana"},"text/vnd.sosi":{"source":"iana"},"text/vnd.sun.j2me.app-descriptor":{"source":"iana","extensions":["jad"]},"text/vnd.trolltech.linguist":{"source":"iana"},"text/vnd.wap.si":{"source":"iana"},"text/vnd.wap.sl":{"source":"iana"},"text/vnd.wap.wml":{"source":"iana","extensions":["wml"]},"text/vnd.wap.wmlscript":{"source":"iana","extensions":["wmls"]},"text/vtt":{"charset":"UTF-8","compressible":true,"extensions":["vtt"]},"text/x-asm":{"source":"apache","extensions":["s","asm"]},"text/x-c":{"source":"apache","extensions":["c","cc","cxx","cpp","h","hh","dic"]},"text/x-component":{"source":"nginx","extensions":["htc"]},"text/x-fortran":{"source":"apache","extensions":["f","for","f77","f90"]},"text/x-gwt-rpc":{"compressible":true},"text/x-handlebars-template":{"extensions":["hbs"]},"text/x-java-source":{"source":"apache","extensions":["java"]},"text/x-jquery-tmpl":{"compressible":true},"text/x-lua":{"extensions":["lua"]},"text/x-markdown":{"compressible":true,"extensions":["mkd"]},"text/x-nfo":{"source":"apache","extensions":["nfo"]},"text/x-opml":{"source":"apache","extensions":["opml"]},"text/x-org":{"compressible":true,"extensions":["org"]},"text/x-pascal":{"source":"apache","extensions":["p","pas"]},"text/x-processing":{"compressible":true,"extensions":["pde"]},"text/x-sass":{"extensions":["sass"]},"text/x-scss":{"extensions":["scss"]},"text/x-setext":{"source":"apache","extensions":["etx"]},"text/x-sfv":{"source":"apache","extensions":["sfv"]},"text/x-suse-ymp":{"compressible":true,"extensions":["ymp"]},"text/x-uuencode":{"source":"apache","extensions":["uu"]},"text/x-vcalendar":{"source":"apache","extensions":["vcs"]},"text/x-vcard":{"source":"apache","extensions":["vcf"]},"text/xml":{"source":"iana","compressible":true,"extensions":["xml"]},"text/xml-external-parsed-entity":{"source":"iana"},"text/yaml":{"extensions":["yaml","yml"]},"video/1d-interleaved-parityfec":{"source":"iana"},"video/3gpp":{"source":"iana","extensions":["3gp","3gpp"]},"video/3gpp-tt":{"source":"iana"},"video/3gpp2":{"source":"iana","extensions":["3g2"]},"video/bmpeg":{"source":"iana"},"video/bt656":{"source":"iana"},"video/celb":{"source":"iana"},"video/dv":{"source":"iana"},"video/encaprtp":{"source":"iana"},"video/flexfec":{"source":"iana"},"video/h261":{"source":"iana","extensions":["h261"]},"video/h263":{"source":"iana","extensions":["h263"]},"video/h263-1998":{"source":"iana"},"video/h263-2000":{"source":"iana"},"video/h264":{"source":"iana","extensions":["h264"]},"video/h264-rcdo":{"source":"iana"},"video/h264-svc":{"source":"iana"},"video/h265":{"source":"iana"},"video/iso.segment":{"source":"iana"},"video/jpeg":{"source":"iana","extensions":["jpgv"]},"video/jpeg2000":{"source":"iana"},"video/jpm":{"source":"apache","extensions":["jpm","jpgm"]},"video/mj2":{"source":"iana","extensions":["mj2","mjp2"]},"video/mp1s":{"source":"iana"},"video/mp2p":{"source":"iana"},"video/mp2t":{"source":"iana","extensions":["ts"]},"video/mp4":{"source":"iana","compressible":false,"extensions":["mp4","mp4v","mpg4"]},"video/mp4v-es":{"source":"iana"},"video/mpeg":{"source":"iana","compressible":false,"extensions":["mpeg","mpg","mpe","m1v","m2v"]},"video/mpeg4-generic":{"source":"iana"},"video/mpv":{"source":"iana"},"video/nv":{"source":"iana"},"video/ogg":{"source":"iana","compressible":false,"extensions":["ogv"]},"video/parityfec":{"source":"iana"},"video/pointer":{"source":"iana"},"video/quicktime":{"source":"iana","compressible":false,"extensions":["qt","mov"]},"video/raptorfec":{"source":"iana"},"video/raw":{"source":"iana"},"video/rtp-enc-aescm128":{"source":"iana"},"video/rtploopback":{"source":"iana"},"video/rtx":{"source":"iana"},"video/smpte291":{"source":"iana"},"video/smpte292m":{"source":"iana"},"video/ulpfec":{"source":"iana"},"video/vc1":{"source":"iana"},"video/vc2":{"source":"iana"},"video/vnd.cctv":{"source":"iana"},"video/vnd.dece.hd":{"source":"iana","extensions":["uvh","uvvh"]},"video/vnd.dece.mobile":{"source":"iana","extensions":["uvm","uvvm"]},"video/vnd.dece.mp4":{"source":"iana"},"video/vnd.dece.pd":{"source":"iana","extensions":["uvp","uvvp"]},"video/vnd.dece.sd":{"source":"iana","extensions":["uvs","uvvs"]},"video/vnd.dece.video":{"source":"iana","extensions":["uvv","uvvv"]},"video/vnd.directv.mpeg":{"source":"iana"},"video/vnd.directv.mpeg-tts":{"source":"iana"},"video/vnd.dlna.mpeg-tts":{"source":"iana"},"video/vnd.dvb.file":{"source":"iana","extensions":["dvb"]},"video/vnd.fvt":{"source":"iana","extensions":["fvt"]},"video/vnd.hns.video":{"source":"iana"},"video/vnd.iptvforum.1dparityfec-1010":{"source":"iana"},"video/vnd.iptvforum.1dparityfec-2005":{"source":"iana"},"video/vnd.iptvforum.2dparityfec-1010":{"source":"iana"},"video/vnd.iptvforum.2dparityfec-2005":{"source":"iana"},"video/vnd.iptvforum.ttsavc":{"source":"iana"},"video/vnd.iptvforum.ttsmpeg2":{"source":"iana"},"video/vnd.motorola.video":{"source":"iana"},"video/vnd.motorola.videop":{"source":"iana"},"video/vnd.mpegurl":{"source":"iana","extensions":["mxu","m4u"]},"video/vnd.ms-playready.media.pyv":{"source":"iana","extensions":["pyv"]},"video/vnd.nokia.interleaved-multimedia":{"source":"iana"},"video/vnd.nokia.mp4vr":{"source":"iana"},"video/vnd.nokia.videovoip":{"source":"iana"},"video/vnd.objectvideo":{"source":"iana"},"video/vnd.radgamettools.bink":{"source":"iana"},"video/vnd.radgamettools.smacker":{"source":"iana"},"video/vnd.sealed.mpeg1":{"source":"iana"},"video/vnd.sealed.mpeg4":{"source":"iana"},"video/vnd.sealed.swf":{"source":"iana"},"video/vnd.sealedmedia.softseal.mov":{"source":"iana"},"video/vnd.uvvu.mp4":{"source":"iana","extensions":["uvu","uvvu"]},"video/vnd.vivo":{"source":"iana","extensions":["viv"]},"video/vnd.youtube.yt":{"source":"iana"},"video/vp8":{"source":"iana"},"video/webm":{"source":"apache","compressible":false,"extensions":["webm"]},"video/x-f4v":{"source":"apache","extensions":["f4v"]},"video/x-fli":{"source":"apache","extensions":["fli"]},"video/x-flv":{"source":"apache","compressible":false,"extensions":["flv"]},"video/x-m4v":{"source":"apache","extensions":["m4v"]},"video/x-matroska":{"source":"apache","compressible":false,"extensions":["mkv","mk3d","mks"]},"video/x-mng":{"source":"apache","extensions":["mng"]},"video/x-ms-asf":{"source":"apache","extensions":["asf","asx"]},"video/x-ms-vob":{"source":"apache","extensions":["vob"]},"video/x-ms-wm":{"source":"apache","extensions":["wm"]},"video/x-ms-wmv":{"source":"apache","compressible":false,"extensions":["wmv"]},"video/x-ms-wmx":{"source":"apache","extensions":["wmx"]},"video/x-ms-wvx":{"source":"apache","extensions":["wvx"]},"video/x-msvideo":{"source":"apache","extensions":["avi"]},"video/x-sgi-movie":{"source":"apache","extensions":["movie"]},"video/x-smv":{"source":"apache","extensions":["smv"]},"x-conference/x-cooltalk":{"source":"apache","extensions":["ice"]},"x-shader/x-fragment":{"compressible":true},"x-shader/x-vertex":{"compressible":true}}

/***/ }),
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formTitle))])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"disabled":"","label":"Product Name"},model:{value:(_vm.item.productName),callback:function ($$v) {_vm.$set(_vm.item, "productName", $$v)},expression:"item.productName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"disabled":"","label":"Unit"},model:{value:(_vm.item.unit),callback:function ($$v) {_vm.$set(_vm.item, "unit", $$v)},expression:"item.unit"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Quantity"},model:{value:(_vm.item.quantity),callback:function ($$v) {_vm.$set(_vm.item, "quantity", _vm._n($$v))},expression:"item.quantity"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"type":"number","disabled":"","label":"Product Rate"},model:{value:(_vm.item.rate),callback:function ($$v) {_vm.$set(_vm.item, "rate", _vm._n($$v))},expression:"item.rate"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"type":"text","disabled":"","label":"HSN Code"},model:{value:(_vm.item.HSN_code),callback:function ($$v) {_vm.$set(_vm.item, "HSN_code", _vm._n($$v))},expression:"item.HSN_code"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"type":"number","disabled":"","suffix":"%","label":"GST"},model:{value:(_vm.item.taxableGST_rate),callback:function ($$v) {_vm.$set(_vm.item, "taxableGST_rate", _vm._n($$v))},expression:"item.taxableGST_rate"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"type":"number","disabled":"","label":"Basic Price"},model:{value:(_vm.item.basicPrice),callback:function ($$v) {_vm.$set(_vm.item, "basicPrice", _vm._n($$v))},expression:"item.basicPrice"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"type":"number","disabled":"","label":"GST Value"},model:{value:(_vm.item.GSTValue),callback:function ($$v) {_vm.$set(_vm.item, "GSTValue", _vm._n($$v))},expression:"item.GSTValue"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"type":"number","disabled":"","label":"Total Price"},model:{value:(_vm.item.totlePrice),callback:function ($$v) {_vm.$set(_vm.item, "totlePrice", _vm._n($$v))},expression:"item.totlePrice"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md8":""}},[_c('v-textarea',{attrs:{"label":"Remark"},model:{value:(_vm.item.returnRemark),callback:function ($$v) {_vm.$set(_vm.item, "returnRemark", $$v)},expression:"item.returnRemark"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v("Save")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"prefix":"#","label":"Alert (in Days)","disabled":""},model:{value:(_vm.alertDuration),callback:function ($$v) {_vm.alertDuration=$$v},expression:"alertDuration"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"prefix":"#","label":"Invoice Id","disabled":""},model:{value:(_vm.invoiceId),callback:function ($$v) {_vm.invoiceId=$$v},expression:"invoiceId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","disabled":"","min-width":"290px"},model:{value:(_vm.datepicker2),callback:function ($$v) {_vm.datepicker2=$$v},expression:"datepicker2"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Invoice Date","prepend-icon":"event","readonly":"","disabled":""},slot:"activator",model:{value:(_vm.prevInvoiceDate),callback:function ($$v) {_vm.prevInvoiceDate=$$v},expression:"prevInvoiceDate"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"disabled":""},on:{"input":function($event){_vm.datepicker2 = false}},model:{value:(_vm.prevInvoiceDate),callback:function ($$v) {_vm.prevInvoiceDate=$$v},expression:"prevInvoiceDate"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"prefix":"#","label":_vm.isBuyer? 'Credit Note Number' : 'Debit Note Number'},model:{value:(_vm.noteNumber),callback:function ($$v) {_vm.noteNumber=$$v},expression:"noteNumber"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker),callback:function ($$v) {_vm.datepicker=$$v},expression:"datepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.invoiceDate),callback:function ($$v) {_vm.invoiceDate=$$v},expression:"invoiceDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepicker = false}},model:{value:(_vm.invoiceDate),callback:function ($$v) {_vm.invoiceDate=$$v},expression:"invoiceDate"}})],1)],1)],1)],1),_vm._v(" "),_c('v-tabs',{attrs:{"background-color":"deep-purple accent-4","centered":"","dark":"","icons-and-text":""},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tabs-slider'),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-1"}},[_vm._v("\n      Return Invoice\n      "),_c('v-icon',[_vm._v("mdi-tumblr-reblog")])],1),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-2"}},[_vm._v("\n      New Invoice\n      "),_c('v-icon',[_vm._v("mdi-refresh")])],1)],1),_vm._v(" "),_c('v-tabs-items',{model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab-item',{key:'tab-1-key',attrs:{"value":'tab-1'}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.items,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"justify-center layout px-0"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.productName))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.HSN_code))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.taxableGST_rate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.rate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.unit))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.basicPrice))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.GSTValue))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.totlePrice))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.CGST_val)+" ₹ ("+_vm._s(props.item.CGST)+" %)")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.SGST_val)+" ₹ ("+_vm._s(props.item.SGST)+" %)")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.IGST_val)+" ₹ ("+_vm._s(props.item.IGST)+" %)")])]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('v-text-field',{attrs:{"label":"Total Item","disabled":"","value":_vm.totalItems}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-select',{attrs:{"dense":"","readonly":_vm.isSummary,"items":[{
            text: 'Cash',
            value: 'Cash'
          }, {
            text: 'Bank Account',
            value: 'Bank Account'
          }, {
            text: 'Cash & Bank Account',
            value: 'CashAndBank Account'
          }],"label":"Select Payment Type","disabled":""},on:{"change":function($event){return _vm.resetAmounts()}},model:{value:(_vm.paymentType),callback:function ($$v) {_vm.paymentType=$$v},expression:"paymentType"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.firmsByBrand,"label":"Select Firm","disabled":""},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.banksByFirms,"label":"Select Bank","disabled":""},model:{value:(_vm.selectedBank),callback:function ($$v) {_vm.selectedBank=$$v},expression:"selectedBank"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Available Balance (in ₹)","disabled":"","value":_vm.availableBalance}})],1),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('v-text-field',{attrs:{"disabled":"","value":Number.parseFloat(_vm.GST_Val_total.SGST_val) + Number.parseFloat(_vm.GST_Val_total.CGST_val) + Number.parseFloat(_vm.GST_Val_total.IGST_val),"type":"number","label":"Total GST"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-text-field',{attrs:{"disabled":"","value":_vm.GST_Val_total.SGST_val,"type":"number","label":"Total SGST"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-text-field',{attrs:{"disabled":"","value":_vm.GST_Val_total.CGST_val,"type":"number","label":"Total CGST"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-text-field',{attrs:{"disabled":"","value":_vm.GST_Val_total.IGST_val,"type":"number","label":"Total IGST"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"disabled":"","value":_vm.GST_Percentage_total.GST_0,"type":"number","label":"Total GST(0%)"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"disabled":"","value":_vm.GST_Percentage_total.GST_5,"type":"number","label":"Total GST(5%)"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"disabled":"","value":_vm.GST_Percentage_total.GST_12,"type":"number","label":"Total GST(12%)"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"disabled":"","value":_vm.GST_Percentage_total.GST_18,"type":"number","label":"Total GST(18%)"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"disabled":"","value":_vm.GST_Percentage_total.GST_28,"type":"number","label":"Total GST(28%)"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"disabled":"","value":(Number.parseFloat(_vm.totalAmount) - (Number.parseFloat(_vm.GST_Val_total.SGST_val) + Number.parseFloat(_vm.GST_Val_total.CGST_val) + Number.parseFloat(_vm.GST_Val_total.IGST_val))),"type":"number","label":"Basic Amount (in ₹)"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-select',{attrs:{"dense":"","disabled":"","items":[{
            text: 'Debit',
            value: 'Debit'
          }, {
            text: 'Partial Paid',
            value: 'Partial Paid'
          }, {
            text: 'Credit',
            value: 'Credit'
          }],"label":"Select Transaction type"},on:{"change":function($event){return _vm.resetAmounts()}},model:{value:(_vm.transactionType),callback:function ($$v) {_vm.transactionType=$$v},expression:"transactionType"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"type":"number","disabled":"","label":"Discount (in ₹)"},model:{value:(_vm.discountAmount),callback:function ($$v) {_vm.discountAmount=$$v},expression:"discountAmount"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"type":"number","disabled":"","label":"Amount from Cash"},model:{value:(_vm.amountFromCash),callback:function ($$v) {_vm.amountFromCash=$$v},expression:"amountFromCash"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"readonly":_vm.isSummary,"type":"number","disabled":"","label":"Amount from Bank"},model:{value:(_vm.amountFromBank),callback:function ($$v) {_vm.amountFromBank=$$v},expression:"amountFromBank"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Paid Amount (in ₹)","disabled":"","prefix":""},model:{value:(_vm.paidAmount),callback:function ($$v) {_vm.paidAmount=$$v},expression:"paidAmount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Remaining Amount (in ₹)","disabled":"","prefix":""},model:{value:(_vm.remainingAmount),callback:function ($$v) {_vm.remainingAmount=$$v},expression:"remainingAmount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Total Amount (in ₹)","disabled":"","value":_vm.totalAmount,"prefix":""}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',{key:'tab-2-key',attrs:{"value":'tab-2'}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.returnItems,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"justify-center layout px-0"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":""},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":""},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.productName))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.HSN_code))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.taxableGST_rate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.rate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.unit))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.basicPrice))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.GSTValue))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.totlePrice))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.CGST_val)+" ₹ ("+_vm._s(props.item.CGST)+" %)")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.SGST_val)+" ₹ ("+_vm._s(props.item.SGST)+" %)")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.IGST_val)+" ₹ ("+_vm._s(props.item.IGST)+" %)")])]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('v-text-field',{attrs:{"label":"Total Item","disabled":"","value":_vm.totalItemsRetuen}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-select',{attrs:{"dense":"","items":[{
                  text: 'Cash',
                  value: 'Cash'
                }, {
                  text: 'Bank Account',
                  value: 'Bank Account'
                }, {
                  text: 'Cash & Bank Account',
                  value: 'CashAndBank Account'
                }],"label":"Select Payment Type","disabled":""},on:{"change":function($event){return _vm.resetAmounts()}},model:{value:(_vm.paymentType),callback:function ($$v) {_vm.paymentType=$$v},expression:"paymentType"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.firmsByBrand,"label":"Select Firm","disabled":""},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.banksByFirms,"label":"Select Bank","disabled":""},model:{value:(_vm.selectedBank),callback:function ($$v) {_vm.selectedBank=$$v},expression:"selectedBank"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Available Balance (in ₹)","disabled":"","value":_vm.availableBalance}})],1),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('v-text-field',{attrs:{"disabled":"","value":Number.parseFloat(_vm.R_GST_Val_total.SGST_val) + Number.parseFloat(_vm.R_GST_Val_total.CGST_val) + Number.parseFloat(_vm.R_GST_Val_total.IGST_val),"type":"number","label":"Total GST"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-text-field',{attrs:{"disabled":"","value":_vm.R_GST_Val_total.SGST_val,"type":"number","label":"Total SGST"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-text-field',{attrs:{"disabled":"","value":_vm.R_GST_Val_total.CGST_val,"type":"number","label":"Total CGST"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-text-field',{attrs:{"disabled":"","value":_vm.R_GST_Val_total.IGST_val,"type":"number","label":"Total IGST"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"disabled":"","value":_vm.R_GST_Percentage_total.GST_0,"type":"number","label":"Total GST(0%)"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"disabled":"","value":_vm.R_GST_Percentage_total.GST_5,"type":"number","label":"Total GST(5%)"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"disabled":"","value":_vm.R_GST_Percentage_total.GST_12,"type":"number","label":"Total GST(12%)"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"disabled":"","value":_vm.R_GST_Percentage_total.GST_18,"type":"number","label":"Total GST(18%)"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"disabled":"","value":_vm.R_GST_Percentage_total.GST_28,"type":"number","label":"Total GST(28%)"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"disabled":"","value":(Number.parseFloat(_vm.totalAmountReturn) - (Number.parseFloat(_vm.R_GST_Val_total.SGST_val) + Number.parseFloat(_vm.R_GST_Val_total.CGST_val) + Number.parseFloat(_vm.R_GST_Val_total.IGST_val))),"type":"number","label":"Basic Amount (in ₹)"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-select',{attrs:{"dense":"","disabled":"","items":[{
            text: 'Debit',
            value: 'Debit'
          }, {
            text: 'Partial Paid',
            value: 'Partial Paid'
          }, {
            text: 'Credit',
            value: 'Credit'
          }],"label":"Select Transaction type"},on:{"change":function($event){return _vm.resetAmounts()}},model:{value:(_vm.transactionType),callback:function ($$v) {_vm.transactionType=$$v},expression:"transactionType"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"type":"number","disabled":"","label":"Discount (in ₹)"},model:{value:(_vm.discountAmount),callback:function ($$v) {_vm.discountAmount=$$v},expression:"discountAmount"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"type":"number","disabled":"","label":"Amount from Cash"},model:{value:(_vm.amountFromCashReturn),callback:function ($$v) {_vm.amountFromCashReturn=$$v},expression:"amountFromCashReturn"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"readonly":_vm.isSummary,"type":"number","disabled":"","label":"Amount from Bank"},model:{value:(_vm.amountFromBankReturn),callback:function ($$v) {_vm.amountFromBankReturn=$$v},expression:"amountFromBankReturn"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Paid Amount (in ₹)","disabled":"","prefix":""},model:{value:(_vm.paidAmountReturn),callback:function ($$v) {_vm.paidAmountReturn=$$v},expression:"paidAmountReturn"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Remaining Amount (in ₹)","disabled":"","prefix":""},model:{value:(_vm.remainingAmountReturn),callback:function ($$v) {_vm.remainingAmountReturn=$$v},expression:"remainingAmountReturn"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Total Amount (in ₹)","disabled":"","value":_vm.totalAmountReturn,"prefix":""}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-dialog',{attrs:{"max-width":"800px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('add-item',{attrs:{"editedItem":_vm.editedItem,"buyerId":_vm.buyerId},on:{"closeAddItem":_vm.close,"saveAddItem":_vm.save}})],1),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},nativeOn:{"click":function($event){return _vm.saveInvoice()}}},[_vm._v("Update Invoice")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('invoice-screen',{attrs:{"firms":_vm.firms,"banks":_vm.banks,"buyers":_vm.buyers,"sellers":_vm.sellers,"buyerId":_vm.buyerId,"invoiceData":_vm.invoiceData,"returnInvoiceData":_vm.returnInvoiceData},on:{"updateInvoiceReturnData":_vm.updateInvoiceReturnData,"updateInvoiceData":_vm.updateInvoiceData,"close":_vm.close}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1326 */,
/* 1327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.returnedInvoices ? !!_vm.invoiceList.length : true)?_c('v-card',{attrs:{"height":"100%"}},[_c('v-card-title',{staticClass:"primary white--text"},[_c('h3',{attrs:{"color":"primary"}},[_vm._v(_vm._s(_vm.header))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(
        _vm.selectedBuyer &&
        _vm.header == 'TRANSACTION OPEN' &&
        _vm.invoiceList.length == 0 &&
        !_vm.getBalance
      )?_c('v-btn',{staticClass:"primary--text",attrs:{"id":"delete-user-btn","outlined":""},on:{"click":function($event){return _vm.deleteUser()}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" delete ")]),_vm._v(" "),_c('b',[_vm._v("Delete Account")])],1):_vm._e(),_vm._v(" "),(_vm.selectedBuyer && _vm.header == 'TRANSACTION OPEN')?_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":{
        name: 'RemainingBalance',
        params: {
          customerId: _vm.selectedBuyer,
        },
      }}},[_c('v-btn',{attrs:{"outlined":""}},[_c('b',{staticClass:"primary--text"},[_vm._v("Balance:")]),_vm._v(" "),_c('b',{staticClass:"primary--text font-weight-bolder"},[_vm._v("\n           "+_vm._s(_vm._f("amount")(_vm.getBalance))+"\n        ")])])],1):_vm._e()],1),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.invoiceList,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{class:[
            props.item.isUnpicked ? 'isUnpicked' : '',
            Number.parseFloat(props.item.totalAmount) <
              Number.parseFloat(props.item.absoluteValue) &&
            (_vm.status === 'due' || _vm.status === 'partial')
              ? 'absoluteMore'
              : '' ]},[_c('td',{staticClass:"justify-center layout px-0"},[_c('v-menu',{attrs:{"bottom":"","right":"","offset-y":"","close-on-content-click":false}},[_c('v-btn',{staticClass:"mx-0",attrs:{"slot":"activator","icon":"","dark":""},slot:"activator"},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',[(
                    (_vm.hasInvoiceEditPermission &&
                      props.item.status == 'due') ||
                    'partial' ||
                    'paid'
                  )?_c('v-list-tile',{attrs:{"disabled":!_vm.hasInvoiceEditPermission},on:{"click":function($event){return _vm.editInvoiceModalOpen(props.item)}}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Edit")])],1):_vm._e(),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.returnInvoiceModalOpen(props.item)}}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("assignment_return")])],1),_vm._v(" "),(_vm.isBuyer)?_c('v-list-tile-title',[_vm._v("Credit note")]):_c('v-list-tile-title',[_vm._v("Debit note")])],1),_vm._v(" "),(_vm.status.includes('due') || _vm.status.includes('partial'))?_c('v-list-tile',{on:{"click":function($event){return _vm.openInvoice(props.item)}}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("local_parking")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Pay")])],1):_vm._e(),_vm._v(" "),(_vm.status.includes('due') || _vm.status.includes('partial'))?_c('v-list-tile',{on:{"click":function($event){return _vm.toggleUnpick(props.item['.key'], props.item.isUnpicked)}}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v(_vm._s(props.item.isUnpicked
                        ? "schedule"
                        : "cancel_schedule_send"))])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(props.item.isUnpicked ? "Pick" : "Unpick"))])],1):_vm._e(),_vm._v(" "),_c('v-list-tile',{attrs:{"disabled":!_vm.hasInvoiceTransferPermission},on:{"click":function($event){return _vm.transferInvoice(props.item)}}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("send")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Transfer To")])],1),_vm._v(" "),_c('v-list-tile',{attrs:{"disabled":!_vm.hasInvoiceDeletePermission},on:{"click":function($event){return _vm.deleteInvoice(props.item)}}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("delete")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Delete Invoice")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.openHistory(props.item['.key'])}}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("history")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("History")])],1),_vm._v(" "),_c('v-list-group',{attrs:{"prepend-icon":'picture_as_pdf',"no-action":""},scopedSlots:_vm._u([{key:"activator",fn:function(){return [_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Invoice Download")])],1)],1)]},proxy:true}],null,true)},[_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.printBasicInvoice(props.item)}}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("panorama_vertical")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Basic Print")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.printInvoice4(props.item)}}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("panorama_wide_angle")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v(" Simple Print ")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.printDairyInvoice(props.item)}}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("panorama_vertical")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Theme1 Print")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.printHorizontalInvoice(props.item)}}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("panorama_horizontal")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Detailed Print")])],1),_vm._v(" "),(props.item.ewayBillDetails)?_c('v-list-tile',{on:{"click":function($event){return _vm.printEwayType3(props.item)}}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("aspect_ratio")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Exclusive Print")])],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('h3',[_vm._v("\n              "+_vm._s(new Date(props.item.date).toLocaleDateString("en-GB"))+"\n            ")])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('h3',[_vm._v(_vm._s(props.item.invoiceId || null))])]),_vm._v(" "),_c('td',{staticClass:"nowrap"},[_c('h3',{staticClass:"text-xs-left primary--text"},[_vm._v("\n              "+_vm._s(_vm._f("amount")(Number.parseFloat(props.item.totalAmount || 0 | _vm.amount) ||
                0))+"\n            ")])]),_vm._v(" "),_c('td',{staticClass:"nowrap"},[_c('h3',{staticClass:"text-xs-left"},[_vm._v("\n              "+_vm._s(_vm._f("amount")(props.item.totalAmount -
                  (props.item.roundOffAmount || 0 | _vm.amount) -
                  _vm.getGSTtotal(props.item) +
                  Number.parseFloat(props.item.discountAmount) +
                  Number.parseFloat(
                    props.item.gstOnExtraChanrges
                      ? 0
                      : -Number.parseFloat(props.item.totalExtraCharges)
                  ) || 0))+"\n            ")])]),_vm._v(" "),_c('td',{staticClass:"nowrap"},[_c('h3',[_vm._v(_vm._s(_vm._f("amount")(_vm.getGSTtotal(props.item) || 0)))])]),_vm._v(" "),_c('td',{staticClass:"nowrap"},[_c('h3',{staticClass:"text-xs-left success--text"},[_vm._v("\n              "+_vm._s(_vm._f("amount")(props.item.paidAmount || 0))+"\n            ")])]),_vm._v(" "),_c('td',{staticClass:"nowrap"},[_c('h3',{staticClass:"text-xs-left error--text"},[_vm._v("\n              "+_vm._s(_vm._f("amount")(props.item.remainingAmount || 0))+"\n            ")])]),_vm._v(" "),_c('td',{staticClass:"nowrap"},[_c('h3',[_vm._v(_vm._s(_vm._f("amount")(props.item.totalExtraCharges || 0)))])]),_vm._v(" "),_c('td',{staticClass:"nowrap"},[_c('h3',[_vm._v(_vm._s(_vm._f("amount")(props.item.discountAmount || 0)))])]),_vm._v(" "),_c('td',{staticClass:"nowrap"},[_c('h3',{staticClass:"text-xs-left primary--text"},[_vm._v("\n              "+_vm._s(_vm._f("amount")(props.item.roundOffAmount || 0))+"\n            ")])]),_vm._v(" "),_c('td',{staticClass:"nowrap"},[_c('h3',[_vm._v(_vm._s(props.item.daysSpent))])]),_vm._v(" "),_c('td',{staticClass:"nowrap"},[_c('h3',[_vm._v(_vm._s(props.item.daysLeft))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('h3',[_vm._v(_vm._s(props.item.status))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('h3',[_vm._v(_vm._s(props.item.paymentType))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('h3',[_vm._v(_vm._s(props.item.firm || "--"))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('h3',[_vm._v(_vm._s(props.item.gstType))])]),_vm._v(" "),_c('td',{staticClass:"nowrap"},[_vm._v(_vm._s(props.item.placeOfSupply))]),_vm._v(" "),_c('td',{staticClass:"nowrap"},[_vm._v(_vm._s(_vm.getStaffName(props.item.soldBy)))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('h3',[_vm._v(_vm._s(props.item.parentUserName))])]),_vm._v(" "),(_vm.header == 'TRANSACTION CLOSE' || _vm.returnedInvoices)?_c('td',{staticClass:"text-xs-left nowrap"},[_c('h3',[_vm._v("\n              "+_vm._s(props.item.closedDate
                  ? new Date(props.item.closedDate).toLocaleDateString(
                      "en-GB"
                    )
                  : "")+"\n            ")])]):_vm._e(),_vm._v(" "),(_vm.header == 'TRANSACTION CLOSE' || _vm.returnedInvoices)?_c('td',{staticClass:"text-xs-left nowrap"},[_c('h3',[_vm._v("\n              "+_vm._s(props.item.parentInvoiceDate
                  ? new Date(props.item.parentInvoiceDate).toLocaleDateString(
                      "en-GB"
                    )
                  : "")+"\n            ")])]):_vm._e(),_vm._v(" "),(_vm.header == 'TRANSACTION CLOSE' || _vm.returnedInvoices)?_c('td',{staticClass:"text-xs-left nowrap"},[_c('h3',[_vm._v(_vm._s(props.item.noteNumber))])]):_vm._e()])]}}],null,false,1109457361)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v(" No Items ")])],2)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition","scrollable":"","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{staticStyle:{"height":"fit-content"},attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Invoice Payment")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('invoice-payment',{attrs:{"invoices":_vm.invoices,"firms":_vm.firms,"banks":_vm.banks,"buyers":_vm.buyers,"sellers":_vm.sellers,"isBuyer":_vm.isBuyer,"selectedInvoiceId":_vm.selectedInvoiceId},on:{"close":function($event){_vm.dialog = false},"updateInvoice":_vm.updateInvoice}}),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition","scrollable":"","persistent":""},model:{value:(_vm.transferInvoiceDialog),callback:function ($$v) {_vm.transferInvoiceDialog=$$v},expression:"transferInvoiceDialog"}},[_c('v-card',{staticStyle:{"height":"fit-content"},attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Transfer Invoice to Other Customer")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.transferInvoiceDialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-tabs',{attrs:{"color":"primary","dark":"","centered":""},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_c('v-tab',[_vm._v("Select Buyer")]),_vm._v(" "),_c('v-tab',[_vm._v("Create Buyer")]),_vm._v(" "),_c('v-tab-item',[(_vm.transferTo.length > 0)?_c('v-form',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"md12":""}}),_vm._v(" "),_c('v-flex',{attrs:{"md6":"","xs12":""}},[_c('v-subheader',[_vm._v("Select Buyer*")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-autocomplete',{attrs:{"dense":"","required":"","items":_vm.transferTo,"item-text":"name","return-object":"","label":"Select Buyer*","rules":_vm.buyerSelectRequied},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                      "+_vm._s(data.item.name)+"\n                    ")]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(((data.item.name) + ", " + (data.item.mobile)))}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s(_vm.generateAddress(data.item))}})],1)]}}],null,false,176990856),model:{value:(_vm.transferInvoiceUser),callback:function ($$v) {_vm.transferInvoiceUser=$$v},expression:"transferInvoiceUser"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',[_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.transferInvoiceToUser}},[_vm._v("Transfer")])],1)],1)],1):_c('v-layout',[_c('v-flex',[_c('v-subheader',[_vm._v("Please create a buyer to transfer invoice...")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.active = 1}}},[_vm._v("Create buyer")])],1)],1)],1),_vm._v(" "),_c('v-tab-item',[_c('buyer-info',{attrs:{"firms":_vm.firms,"isBuyer":true,"buyers":_vm.buyers,"sellers":_vm.sellers},on:{"onCreate":_vm.transferInvoiceToUserJustCreated}})],1)],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition","scrollable":"","persistent":""},model:{value:(_vm.updateInvoiceDialog),callback:function ($$v) {_vm.updateInvoiceDialog=$$v},expression:"updateInvoiceDialog"}},[(_vm.updateInvoiceDetail)?_c('v-card',{staticStyle:{"height":"fit-content"},attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Update an Invoice")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.updateInvoiceDialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition","scrollable":"","persistent":""},model:{value:(_vm.returnInvoiceDialog),callback:function ($$v) {_vm.returnInvoiceDialog=$$v},expression:"returnInvoiceDialog"}},[(_vm.returnInvoiceDetail)?_c('v-card',{staticStyle:{"height":"fit-content"},attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[(_vm.isBuyer)?_c('v-toolbar-title',[_vm._v("Credit Note")]):_c('v-toolbar-title',[_vm._v("Debit Note")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.returnInvoiceDialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('invoice-return',{attrs:{"invoiceDetail":_vm.returnInvoiceDetail,"buyerId":_vm.selectedBuyer,"isBuyer":_vm.isBuyer,"firms":_vm.firms,"banks":_vm.banks,"buyers":_vm.buyers,"sellers":_vm.sellers},on:{"close":function($event){_vm.returnInvoiceDialog = false},"returnInvoice":_vm.returnInvoice}}),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"800","persistent":""},model:{value:(_vm.passwordDialog),callback:function ($$v) {_vm.passwordDialog=$$v},expression:"passwordDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline primary--text",attrs:{"primary-title":""}},[_vm._v("\n          Enter the password\n          "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"primary",attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.passwordDialog = false}}},[_c('v-icon',[_vm._v("mdi-close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"type":"password","label":"Password","autocomplete":"false"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.deleteFromDialog()}}},[_vm._v("Delete")])],1)],1)],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1328 */,
/* 1329 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1330 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_vm._v(" "),_c('v-card',{attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[(_vm.$route.params.customerId)?_c('router-link',{attrs:{"to":{ name: 'BuyersInfo', params: { buyerId:_vm.$route.params.customerId }}}},[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("keyboard_backspace")])],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('h3',{staticClass:"font-weight-light headline"},[_vm._v("\n            Statements\n          ")]),_vm._v(" "),_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(this.currentUser.name))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-select',{staticClass:"select-firm",attrs:{"dense":"","item-text":"name","return-object":"","items":_vm.firmsByBrand,"label":"Select Firm","clearable":""},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-menu',{staticClass:"ist-datepicker",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerFrom),callback:function ($$v) {_vm.datepickerFrom=$$v},expression:"datepickerFrom"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"From Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.fromDate),callback:function ($$v) {_vm.fromDate=$$v},expression:"fromDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerFrom = false}},model:{value:(_vm.fromDate),callback:function ($$v) {_vm.fromDate=$$v},expression:"fromDate"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-menu',{staticClass:"ist-datepicker",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerTo),callback:function ($$v) {_vm.datepickerTo=$$v},expression:"datepickerTo"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"To Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.toDate),callback:function ($$v) {_vm.toDate=$$v},expression:"toDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerTo = false}},model:{value:(_vm.toDate),callback:function ($$v) {_vm.toDate=$$v},expression:"toDate"}})],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-select',{attrs:{"dense":"","multiple":"","items":[
              'Receipt',
              'Payment',
              'Credit Note',
              'Debit Note',
              'Asset',
              'Expense',
              'Liability',
              'Income',
              'Staff',
              'Transfer',
              'Advance',
              'LoanGiven',
              'LoanTaken',
              'Security',
              'Opening Balance',
              'Sale',
              'Purchase'
              ],"label":"Filter Voucher Type","clearable":""},model:{value:(_vm.voucherTypeFilter),callback:function ($$v) {_vm.voucherTypeFilter=$$v},expression:"voucherTypeFilter"}})],1),_vm._v(" "),_c('v-btn',{attrs:{"outline":""}},[_c('v-icon',{staticClass:"primary white--text",on:{"click":function($event){return _vm.print()}}},[_vm._v("\n              print\n             ")])],1),_vm._v(" "),_c('v-btn',{attrs:{"outline":""}},[_c('v-icon',{staticClass:"primary white--text",on:{"click":function($event){return _vm.printDetailed()}}},[_vm._v("\n              save_alt\n             ")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('h3',[_vm._v("Previous Running Balance : "+_vm._s(_vm.prevRunningBal))]),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.invoiceHeader,"items":_vm.invoiceList},scopedSlots:_vm._u([{key:"items",fn:function(props){return [('isBuyer' in props.item || 'type' in props.item)?[_c('td',[(props.item['type']!='CustomerPayment')?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.openProd(props.item)}}},[_vm._v("remove_red_eye")]):_vm._e()],1),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(new Date(props.item.closedDate ? props.item.closedDate : props.item.date).toLocaleDateString('en-GB')))])]),_vm._v(" "),_c('td',[(props.item['type']!='CustomerPayment')?_c('b',[_vm._v(_vm._s(props.item['invoiceId']))]):_vm._e()]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item['debit'] || 0)))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"red--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item['credit'] || 0)))])]),_vm._v(" "),_c('td',[(_vm.isUserBuyer)?_c('b',{staticClass:"primary--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item['RunningBal'])))]):_c('b',{staticClass:"primary--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item['RunningBal'])))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['paymentType']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.getVocherType(props.item)))])])]:_vm._e()]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")]),_vm._v(" "),_c('template',{slot:"footer"},[_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('b',[_vm._v("Total")])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(_vm.total['debit'] || 0)))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"red--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(_vm.total['credit'] || 0)))])]),_vm._v(" "),_c('td',[(_vm.isUserBuyer)?_c('b',{staticClass:"primary--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(_vm.total['RunningBal'])))]):_c('b',{staticClass:"primary--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")((_vm.total['RunningBal']))))])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')])])],2)],1),_vm._v(" "),(_vm.selectedInvoice && _vm.selectedInvoice['.key'])?_c('v-dialog',{attrs:{"width":"800"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline grey lighten-2",attrs:{"primary-title":""}},[_vm._v("\n          "+_vm._s(_vm.selectedInvoice.customer ? _vm.selectedInvoice.customer.name : '')+"\n        ")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('b',[_vm._v("Name :-")]),_vm._v("\n              "+_vm._s(_vm.selectedInvoice.customer ? _vm.selectedInvoice.customer.name : '')+"\n              "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Firm :-")]),_vm._v("\n              "+_vm._s(_vm.getFirmName(_vm.selectedInvoice.firm))+"\n              "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Invoice Number :-")]),_vm._v("\n              "+_vm._s(_vm.selectedInvoice['invoiceId'])+"\n              "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Payment Type :-")]),_vm._v("\n              "+_vm._s(_vm.selectedInvoice['paymentType'])+"\n              "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Status :-")]),_vm._v("\n              "+_vm._s(_vm.selectedInvoice['status'])+"\n              "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Duration (in Days) :-")]),_vm._v("\n              "+_vm._s(_vm.selectedInvoice['duration'])+"\n              "),_c('br')]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('b',{staticClass:"font-weight-bold green--text"},[_vm._v("Total Amount :-")]),_vm._v(" "),_c('b',{staticClass:"font-weight-bold green--text"},[_vm._v("₹."+_vm._s(_vm.selectedInvoice['totalAmount']))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Basic Amount :-")]),_vm._v(" "),_c('b',{staticClass:"font-weight-bold blue--text"},[_vm._v("₹. "+_vm._s(_vm.selectedInvoice['totalAmount'] - _vm.getGSTtotal(_vm.selectedInvoice)))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b',[_vm._v("GST :-")]),_vm._v("\n              ₹. "+_vm._s(_vm.getGSTtotal(_vm.selectedInvoice))+"\n              "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Discount :-")]),_vm._v("\n              ₹. "+_vm._s(_vm.selectedInvoice['discountAmount'])+"\n              "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Paid Amount :-")]),_vm._v("\n              ₹. "),_c('b',{staticClass:"font-weight-bold primary--text"},[_vm._v(_vm._s(_vm.selectedInvoice['paidAmount']))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b',{staticClass:"font-weight-bold red--text"},[_vm._v("Remaining Amount :-")]),_vm._v(" "),_c('b',{staticClass:"font-weight-bold red--text"},[_vm._v("₹."+_vm._s(_vm.selectedInvoice['remainingAmount']))]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('b',[_vm._v("GST Type :-")]),_vm._v("\n              "+_vm._s(_vm.selectedInvoice['gstType'])+"\n              "),_c('br'),_vm._v(" "),_c('b',[_vm._v("GST (0%) :-")]),_vm._v("\n              ₹. "+_vm._s(_vm.selectedInvoice['GST_Percentage_total']['GST_3'])+"\n              "),_c('br'),_vm._v(" "),_c('b',[_vm._v("GST (5%) :-")]),_vm._v("\n              ₹. "+_vm._s(_vm.selectedInvoice['GST_Percentage_total']['GST_5'])+"\n              "),_c('br'),_vm._v(" "),_c('b',[_vm._v("GST (12%) :-")]),_vm._v("\n              ₹. "+_vm._s(_vm.selectedInvoice['GST_Percentage_total']['GST_12'])+"\n              "),_c('br'),_vm._v(" "),_c('b',[_vm._v("GST (18%) :-")]),_vm._v("\n              ₹. "+_vm._s(_vm.selectedInvoice['GST_Percentage_total']['GST_18'])+"\n              "),_c('br'),_vm._v(" "),_c('b',[_vm._v("GST (28%) :-")]),_vm._v("\n              ₹. "+_vm._s(_vm.selectedInvoice['GST_Percentage_total']['GST_28'])+"\n              "),_c('br')])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.invoiceProductListHeader,"items":_vm.selectedInvoice.items},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',[_vm._v(_vm._s(props.item['productName']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['HSN_code']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.taxableGST_rate))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['productUnit']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['quantity']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['fat']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['rate']))])])]}}],null,false,2211788395)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("Close")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"flex":"1 1 auto"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectedBuyer)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('buyer-invoices',{attrs:{"isBuyer":_vm.isBuyer,"invoices":_vm.invoices}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('buyer-transactions',{attrs:{"buyers":_vm.buyers,"sellers":_vm.sellers,"invoices":_vm.invoices,"isBuyer":_vm.isBuyer,"header":"TRANSACTION OPEN","status":['due','partial']}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('buyer-transactions',{attrs:{"buyers":_vm.buyers,"sellers":_vm.sellers,"invoices":_vm.invoices,"isBuyer":_vm.isBuyer,"header":"TRANSACTION CLOSE","status":['paid']}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('buyer-transactions',{attrs:{"buyers":_vm.buyers,"sellers":_vm.sellers,"invoices":_vm.invoices,"isBuyer":_vm.isBuyer,"header":_vm.isBuyer ? 'CREDIT NOTE' : 'DEBIT NOTE',"status":['due','partial','paid'],"returnedInvoices":true}})],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.selectedBuyer)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('buyer-info',{attrs:{"firms":_vm.firms,"buyers":_vm.buyers,"sellers":_vm.sellers,"productRateCategories":_vm.productRateCategories,"isBuyer":_vm.isBuyer}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('buyer-items',{attrs:{"isBuyer":_vm.isBuyer}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.transactionView = !_vm.transactionView}}},[_vm._v("\n                   "+_vm._s(_vm.transactionView ? "Hide Transaction" : "Show Transaction")+"\n      ")]),_vm._v(" "),(_vm.transactionView)?_c('buyer-invoice-expansion',{attrs:{"buyers":_vm.buyers,"sellers":_vm.sellers,"isBuyer":_vm.isBuyer}}):_vm._e()],1)],1):_c('v-card',{attrs:{"height":"100%","flat":"","color":"grey lighten-5"}},[_c('v-card-text',[_c('p',{staticClass:"text-md-center title "},[_vm._v("\n            "+_vm._s(_vm.emptyText)+"\n        ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(433);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b38a68d8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1336);
function injectStyle (ssrContext) {
  __webpack_require__(1335)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b38a68d8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b38a68d8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1335 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',{attrs:{"grow":""},model:{value:(_vm.selectedTab),callback:function ($$v) {_vm.selectedTab=$$v},expression:"selectedTab"}},[_vm._l((_vm.tabs),function(tab){return _c('v-tab',{key:tab,attrs:{"ripple":""},on:{"click":function($event){return _vm.changeTabs(tab == 'Customer' ? 0 : 1)}}},[_c('h3',[_vm._v(_vm._s(tab))])])}),_vm._v(" "),_vm._l((_vm.tabs),function(tab){return _c('v-tab-item',{key:tab},[_c('v-card',{attrs:{"height":"100%"}},[_c('v-flex',[_c('v-card',[_c('v-text-field',{staticClass:"white primary--text",attrs:{"autofocus":true,"solo":"","label":"Search Candidate","prepend-inner-icon":"search","clearable":"","flat":"","hide-details":"","hide-no-data":"","single-line":""},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onEnterBuyer()}},model:{value:(_vm.searchtext),callback:function ($$v) {_vm.searchtext=$$v},expression:"searchtext"}})],1)],1),_vm._v(" "),_c('div',{staticStyle:{"max-height":"600px","overflow-y":"scroll"}},[_c('v-list',{attrs:{"two-line":""}},[_c('router-link',{attrs:{"tag":"v-subheader","to":{ 
                name: 'BuyersInfo',
                params: {
                  buyerId: '-1'
                }
              }}},[_c('v-btn',{staticClass:"primary--text subheading font-weight-bold",staticStyle:{"text-align":"center"}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("\n                add\n              ")]),_vm._v("\n               "+_vm._s(_vm.addText)+"\n            ")],1)],1),_vm._v(" "),_vm._l((_vm.getCandidate),function(item,index){return [_c('v-divider',{key:index}),_vm._v(" "),_c('router-link',{key:item['.key'],attrs:{"tag":"v-list-tile","to":{ 
                name: 'BuyersInfo',
                params: {
                  buyerId: item['.key']
                }
              },"avatar":""}},[_c('v-list-tile-avatar',[_c('i',{staticClass:"material-icons"},[_vm._v("\n                    person\n                  ")])]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"primary--text font-weight-bold"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(item.localAddress)+" , "+_vm._s(item.tehsil)+" , "+_vm._s(item.district))])],1)],1)]})],2)],1)],1)],1)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"sm3":"","md3":""}},[_c('buyer-list',{on:{"tabSelected":_vm.tabSelected}})],1),_vm._v(" "),_c('v-flex',{attrs:{"sm9":"","md9":""}},[_c('buyer',{attrs:{"isBuyer":_vm.isBuyer}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customerDeposite_vue__ = __webpack_require__(434);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30981d89_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customerDeposite_vue__ = __webpack_require__(1342);
function injectStyle (ssrContext) {
  __webpack_require__(1339)
  __webpack_require__(1340)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-30981d89"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customerDeposite_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30981d89_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customerDeposite_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1339 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1340 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loanReceiptPDF; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__digitsToWords_js__ = __webpack_require__(35);





var _this = this;

// Start - Payment Receipt

var getBase64ImageFromURL = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(url) {
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						return _context.abrupt("return", new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
							var img = new Image();
							img.setAttribute("crossOrigin", "anonymous");

							img.onload = function () {
								var canvas = document.createElement("canvas");
								canvas.width = img.width;
								canvas.height = img.height;

								var ctx = canvas.getContext("2d");
								ctx.drawImage(img, 0, 0);

								var dataURL = canvas.toDataURL("image/png");

								resolve(dataURL);
							};

							img.onerror = function (error) {
								reject(error);
							};

							img.src = url;
						}));

					case 1:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, _this);
	}));

	return function getBase64ImageFromURL(_x) {
		return _ref.apply(this, arguments);
	};
}();

var loanReceiptPDF = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(metaData) {
		var pdfDoc, logoData, imgToExport, canvas, base64;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						pdfDoc = {
							content: [{
								table: {
									widths: ['50%', '50%'],
									body: [[{
										image: 'sampleImage.jpg',
										width: 100,
										height: 80
									}, {
										text: [{ text: 'Firm Name\n', style: 'topFirmAuthority1' }, { text: 'Live Address\n', style: 'topFirmHeader' }, { text: 'Address\n', style: 'topFirmHeader' }, { text: 'GSTIN\n', style: 'topFirmHeader' }, { text: 'MOBILE\n', style: 'topFirmHeader' }, { text: 'EMAIL\n', style: 'topFirmHeader' }]
									}]]

								},
								layout: {
									hLineWidth: function hLineWidth(i, node) {
										return i === 0 || i === node.table.body.length ? 2 : 0;
									},
									vLineWidth: function vLineWidth(i, node) {
										return i === 0 || i === node.table.widths.length ? 2 : 0;
									},
									hLineColor: function hLineColor(i, node) {
										return i === 0 || i === node.table.body.length ? 'black' : 'white';
									},
									vLineColor: function vLineColor(i, node) {
										return i === 0 || i === node.table.widths.length ? 'black' : 'white';
									}
								}
							}, {
								table: {
									widths: ['100%'],
									body: [[{
										text: [{ text: 'LOAN\n', style: "borderTitle" }]
									}]]
								}
							}, {
								table: {
									widths: ['100%'],
									body: [[{
										text: [{ text: 'RECEIPT NO                        :       ', bold: true, style: 'invoiceDetails' }, { text: '123\n', style: 'invoiceDetailsBlue' }, { text: 'DATE                                     :      ', bold: true, style: 'invoiceDetails' }, { text: '12/12/12 \n', style: 'invoiceDetailsBlue' }, { text: 'NAME                                   :      ', bold: true, style: 'invoiceDetails' }, { text: '1600  \n', style: 'invoiceDetailsBlue' }, { text: 'ADDRESS                             :      ', bold: true, style: 'invoiceDetails' }, { text: '7788996655\n', style: 'invoiceDetailsBlue' }, { text: 'AMOUNT (IN NUMBERS)  :      ', bold: true, style: "invoiceDetails" }, { text: '1679905\n', style: "invoiceDetailsBlue" }, { text: 'AMOUNT (IN WORDS)       :      ', bold: true, style: "invoiceDetails" }, { text: '23\n', style: "invoiceDetailsBlue" }, { text: 'PAYMENT TYPE                  :      ', bold: true, style: "invoiceDetails" }, { text: '23\n', style: "invoiceDetailsBlue" }]
									}]]
								}
							},
							//{text:'\n'},   
							{
								table: {
									widths: ['30%', '40%', '30%'],
									body: [[{
										text: [{ text: '\n', style: '' }, { text: '', style: 'invoiceDetails1' }]
									}, {
										text: [{ text: '\n', style: 'transpotationDel' }, { text: '', style: 'invoiceDetails1' }]
									}, {
										text: [{ text: '' }, { text: 'Firm Name  ', bold: true, alignment: 'center', style: 'topFirmAuthority' }, { text: '\n\n\n\n' }, { text: 'AUTHORITY SIGNATURE  ', bold: true, alignment: 'center', style: 'topFirmAuthority' }, { text: '\n' }]

									}]]

								},
								layout: {
									hLineWidth: function hLineWidth(i, node) {
										return i === 0 || i === node.table.body.length ? 2 : 0;
									},
									vLineWidth: function vLineWidth(i, node) {
										return i === 0 || i === node.table.widths.length ? 2 : 0;
									},
									hLineColor: function hLineColor(i, node) {
										return i === 0 || i === node.table.body.length ? 'black' : 'white';
									},
									vLineColor: function vLineColor(i, node) {
										return i === 0 || i === node.table.widths.length ? 'black' : 'white';
									}
								}
							}, {
								table: {
									widths: ['*'],
									body: [[{ text: 'Thank you! Stay at home. Be safe. Wear Mask', style: 'thankyouMsg' }]]
								}
							}],
							styles: {
								header: {
									fontSize: 15,
									bold: true,
									alignment: 'center',
									color: '#160091'
								},
								productHeader: {
									fontSize: 10,
									bold: true,
									alignment: 'center',
									color: '#160091'
								},
								transpotationDel: {
									fontSize: 9,
									bold: true,
									alignment: 'center',
									color: '#160091'
								},
								gstHeader: {
									fontSize: 8,
									color: '#160091',
									alignment: 'center'
								},
								gstHeader1: {
									fontSize: 10,
									color: '#160091',
									bold: true,
									alignment: 'center'
								},
								product: {
									fontSize: 9,
									alignment: 'center'
								},
								subproduct: {
									fontSize: 9,
									alignment: 'center'
								},
								product1: {
									fontSize: 7,
									alignment: 'center'
								},
								total: {
									fontSize: 10,
									alignment: 'center',
									bold: true
								},
								total1: {
									fontSize: 7,
									alignment: 'center'
								},
								topHeader: {
									color: '#160091',
									fontSize: 11,
									alignment: 'center',
									bold: true
								},
								topCustomerHeader: {
									color: '#160091',
									fontSize: 11,
									alignment: 'left',
									bold: true
								},

								topFirmAuthority: {
									color: '#160091',
									fontSize: 9,
									bold: true
								},
								topFirmAuthority1: {
									color: '#160091',
									fontSize: 12,
									bold: true
								},
								topFirmHeader: {
									fontSize: 10,
									bold: true
								},
								invoiceDetails: {
									fontSize: 10,
									bold: true
								},
								invoiceDetailsBlue: {
									fontSize: 10,
									bold: true,
									color: '#160091'
								},
								invoiceDetailsBlueConsignee: {
									fontSize: 11,
									bold: true,
									color: '#160091'
								},
								invoiceDetails1: {
									fontSize: 9,
									bold: true
								},
								totalAmountHeader: {
									color: '#160091',
									fontSize: 10,
									bold: true
								},
								invoiceStatusDetails: {
									color: '#FF0000',
									fontSize: 10,
									bold: true
								},
								thankyouMsg: {
									color: '#160091',
									fontSize: 12,
									bold: true,
									alignment: 'center'
								},
								borderTitle: {
									color: '#160091',
									fontSize: 11,
									alignment: 'center',
									bold: true
								}
							}

							//Firm Details 
						};
						pdfDoc.content[0].table.body[0][1].text[0].text = (metaData.firm.name ? metaData.firm.name.toUpperCase() : '') + "\n";
						pdfDoc.content[0].table.body[0][1].text[1].text = (metaData.firm.GST_number ? metaData.firm.GST_number : '') + "\n";
						pdfDoc.content[0].table.body[0][1].text[2].text = (metaData.firm.liveAddress ? metaData.firm.liveAddress : '') + "\n";
						pdfDoc.content[0].table.body[0][1].text[3].text = (metaData.firm.address ? metaData.firm.address : '') + "\n";
						pdfDoc.content[0].table.body[0][1].text[4].text = (metaData.firm.mobileNumber ? metaData.firm.mobileNumber : '') + "\n";
						pdfDoc.content[0].table.body[0][1].text[5].text = (metaData.firm.email ? metaData.firm.email : '') + "\n";

						//Customer and payment details

						pdfDoc.content[2].table.body[0][0].text[1].text = "" + "\n";
						pdfDoc.content[2].table.body[0][0].text[3].text = new Date(metaData.payment.date).toLocaleDateString('en-GB').toString() + "\n";
						pdfDoc.content[2].table.body[0][0].text[5].text = (metaData.customer.name ? metaData.customer.name.toUpperCase() : '') + "\n";
						pdfDoc.content[2].table.body[0][0].text[7].text = (metaData.customer.localAddress ? metaData.customer.localAddress.toUpperCase() : '') + "\n";
						pdfDoc.content[2].table.body[0][0].text[9].text = (metaData.payment.amount ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(metaData.payment.amount).toFixed(2) : '') + "\n";
						pdfDoc.content[2].table.body[0][0].text[11].text = (metaData.payment.amount ? _.startCase(Object(__WEBPACK_IMPORTED_MODULE_4__digitsToWords_js__["a" /* digitsToWords */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(metaData.payment.amount))) : '') + "\n";
						pdfDoc.content[2].table.body[0][0].text[13].text = (metaData.payment.paymentType ? metaData.payment.paymentType.toUpperCase() : '') + "\n";

						//authority
						pdfDoc.content[3].table.body[0][2].text[1].text = metaData.firm.name ? metaData.firm.name.toUpperCase() : '';

						// Logo 

						if (!metaData.terms.printLogo) {
							_context2.next = 29;
							break;
						}

						_context2.prev = 16;
						_context2.next = 19;
						return getBase64ImageFromURL(metaData.terms.printLogo);

					case 19:
						logoData = _context2.sent;

						pdfDoc.content[0].table.body[0][0].image = logoData;
						return _context2.abrupt("return", pdfDoc);

					case 24:
						_context2.prev = 24;
						_context2.t0 = _context2["catch"](16);

						console.log(_context2.t0);

					case 27:
						_context2.next = 36;
						break;

					case 29:
						imgToExport = document.getElementById('pdfimgToExport');
						canvas = document.createElement('canvas');

						canvas.width = imgToExport.width;
						canvas.height = imgToExport.height;
						canvas.getContext('2d').drawImage(imgToExport, 0, 0);
						base64 = canvas.toDataURL('image/png');

						pdfDoc.content[0].table.body[0][0].image = base64;

					case 36:
						return _context2.abrupt("return", pdfDoc);

					case 37:
					case "end":
						return _context2.stop();
				}
			}
		}, _callee2, _this, [[16, 24]]);
	}));

	return function loanReceiptPDF(_x2) {
		return _ref2.apply(this, arguments);
	};
}();

/***/ }),
/* 1342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('br'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text",attrs:{"card":""}},[(_vm.$route.params.customerId)?_c('router-link',{attrs:{"to":{
            name: 'BuyersInfo',
            params: { buyerId: _vm.$route.params.customerId },
          }}},[_c('v-btn',{attrs:{"outlined":"primary"},on:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',{staticClass:"primary--text"},[_vm._v("keyboard_backspace")])],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('h3',{staticClass:"strong white--text font-weight-light headline"},[_vm._v("\n            "+_vm._s(this.currentUser.name)+"\n          ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.$route.params.customerId)?_c('router-link',{attrs:{"to":{
            name: 'BuyersInfo',
            params: { buyerId: _vm.$route.params.customerId },
          }}},[_c('v-btn',{attrs:{"outlined":""},on:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',{staticClass:"primary--text"},[_vm._v("close")])],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"text-xs-center"},[_vm._v("Advance Deposit")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{staticClass:"primary--text",attrs:{"outlined":""},on:{"click":function($event){return _vm.addDiposit('Advance')}}},[_c('v-icon',[_vm._v("add")]),_vm._v("\n              ADVANCED DEPOSIT\n          ")],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.AdvancedDepositeHeader,"items":_vm.advanceDepositListByCustomer,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',[_vm._v(_vm._s(new Date(props.item.date).toLocaleDateString("en-GB")))])]),_vm._v(" "),_c('td',[(props.item['isUserCreated'])?_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item["amount"] || 0)))]):_c('b')]),_vm._v(" "),_c('td',[(!props.item['isUserCreated'])?_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item["settledAmount"] || 0)))]):_c('b')]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["paymentType"]))])]),_vm._v(" "),(props.item['isUserCreated'])?_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editDeposite(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1)],1):_vm._e(),_vm._v(" "),(props.item['isUserCreated'])?_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteDeposit(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1):_vm._e(),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["remark"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.getFirmName(props.item["firm"])))])])]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"text-xs-center"},[_vm._v("Security Deposit")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{staticClass:"primary--text",attrs:{"outlined":""},on:{"click":function($event){return _vm.addDiposit('Security')}}},[_c('v-icon',[_vm._v("add")]),_vm._v("\n              SECURITY DEPOSIT\n          ")],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.SecurityDepositeHeader,"items":_vm.securityDepositListByCustomer,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',[_vm._v(_vm._s(new Date(props.item.date).toLocaleDateString("en-GB")))])]),_vm._v(" "),_c('td',[(props.item['isUserCreated'])?_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item["amount"] || 0)))]):_c('b')]),_vm._v(" "),_c('td',[(!props.item['isUserCreated'])?_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item["settledAmount"] || 0)))]):_c('b')]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["mortgage"]))])]),_vm._v(" "),_c('td',[(props.item['isUserCreated'])?_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editDeposite(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1):_vm._e()],1),_vm._v(" "),_c('td',[(props.item['isUserCreated'])?_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteDeposit(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1):_vm._e()],1),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.getFirmName(props.item["firm"])))])])]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"text-xs-center"},[_vm._v(_vm._s(_vm.isBuyer ? "Note Order" : "Place Order"))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{staticClass:"primary--text",attrs:{"outlined":""},on:{"click":function($event){_vm.isBuyer ? _vm.addDiposit('Send Order') : _vm.addDiposit('Place Order')}}},[_c('v-icon',[_vm._v("add")]),_vm._v("\n              NEW "+_vm._s(_vm.isBuyer ? "Order" : "Order")+"\n          ")],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.orderHeader,"items":_vm.isBuyer ? _vm.sendOrderListByCustomer : _vm.placeOrderListByCustomer,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',[_vm._v(_vm._s(props.item[".key"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["quantity"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["product"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(new Date(props.item.date).toLocaleDateString("en-GB")))])]),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editDeposite(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteDeposit(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"text-xs-center"},[_vm._v("Opening Balance")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{staticClass:"primary--text",attrs:{"outlined":""},on:{"click":function($event){return _vm.addDiposit('Opening Balance')}}},[_c('v-icon',[_vm._v("add")]),_vm._v("\n              OPENING BALANCE\n          ")],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.OpeningBalanceHeader,"items":_vm.openingBalanceListByCustomer,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',[_vm._v(_vm._s(new Date(props.item.date).toLocaleDateString("en-GB")))])]),_vm._v(" "),_c('td',[(props.item['isUserCreated'])?_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item["amount"] || 0)))]):_c('b')]),_vm._v(" "),_c('td',[(!props.item['isUserCreated'])?_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item["settledAmount"] || 0)))]):_c('b')]),_vm._v(" "),_c('td',[(props.item.interest)?_c('b',[_vm._v(_vm._s(props.item["interest"]))]):_vm._e()]),_vm._v(" "),_c('td',[(props.item.interest)?_c('b',[_vm._v(_vm._s(_vm.getInterest(props.item) > 0 ? _vm.getInterest(props.item) : 0))]):_vm._e()]),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editDeposite(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteDeposit(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.getFirmName(props.item["firm"])))])])]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"text-xs-center"},[_vm._v("Loan Given")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{staticClass:"primary--text",attrs:{"outlined":""},on:{"click":function($event){return _vm.addDiposit('LoanGiven')}}},[_c('v-icon',[_vm._v("add")]),_vm._v("\n              NEW LOAN\n          ")],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.LoanGivenHeader,"items":_vm.givenLoanListByCustomer,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [(!props.item.loanTransaction)?[_c('tr',[_c('td',[_c('v-btn',{staticClass:"primary--text",attrs:{"disabled":props.item.status == 'paid',"outlined":""},on:{"click":function($event){return _vm.addDiposit('LoanTaken', props.item)}}},[_vm._v("\n                  PAY\n                ")])],1),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(new Date(props.item.date).toLocaleDateString("en-GB")))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item["amount"] || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["interest"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.getInterest(props.item) > 0 ? _vm.getInterest(props.item) : 0))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.getDuration(props.item)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["paidAmount"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["paidInterest"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["paymentType"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["status"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["remark"]))])]),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.printLoanReceipt(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("print")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"disabled":props.item.status == 'paid',"icon":""},on:{"click":function($event){return _vm.editDeposite(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"disabled":props.item.status == 'paid',"icon":""},on:{"click":function($event){return _vm.deleteDeposit(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(new Date(props.item.interestDate).toLocaleDateString(
                    "en-GB"
                  )))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["transferType"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.getFirmName(props.item["firm"])))])])]),_vm._v(" "),_vm._l((props.item.transactions),function(loan){return [(loan['.key'])?_c('tr',{key:loan['.key'] + 'roww',staticClass:"loan-transactions"},[_c('td',{key:loan['.key'] + 'key'}),_vm._v(" "),_c('td',{key:loan['.key'] + 'date'},[_c('b',[_vm._v(_vm._s(new Date(loan.date).toLocaleDateString("en-GB")))])]),_vm._v(" "),_c('td',{key:loan['.key'] + 'a'}),_vm._v(" "),_c('td',{key:loan['.key'] + 'int'}),_vm._v(" "),_c('td',{key:loan['.key'] + 'getint'}),_vm._v(" "),_c('td',{key:loan['.key'] + 'dur'}),_vm._v(" "),_c('td',{key:loan['.key'] + 'paidAmount'},[_c('b',[_vm._v(_vm._s(loan["paidAmount"]))])]),_vm._v(" "),_c('td',{key:loan['.key'] + 'paidInterest'},[_c('b',[_vm._v(_vm._s(loan["paidInterest"]))])]),_vm._v(" "),_c('td',{key:loan['.key'] + 'paytype'},[_c('b',[_vm._v(_vm._s(loan["paymentType"]))])]),_vm._v(" "),_c('td',{key:loan['.key'] + 'PT'},[_c('b',[_vm._v(_vm._s(loan["loanPaymentType"]))])]),_vm._v(" "),_c('td',{key:loan['.key'] + 'firm'}),_vm._v(" "),_c('td',{key:loan['.key'] + 'interest'}),_vm._v(" "),_c('td',{key:loan['.key'] + 'edit'}),_vm._v(" "),_c('td',{key:loan['.key'] + 'delete'}),_vm._v(" "),_c('td',{key:loan['.key'] + 'trans'}),_vm._v(" "),_c('td',{key:loan['.key'] + 'pay'})]):_vm._e()]})]:_vm._e()]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"text-xs-center"},[_vm._v("Loan Taken")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{staticClass:"primary--text",attrs:{"outlined":""},on:{"click":function($event){return _vm.addDiposit('LoanTaken')}}},[_c('v-icon',[_vm._v("add")]),_vm._v("\n              NEW LOAN\n          ")],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.LoanTakenHeader,"items":_vm.takenLoanListByCustomer,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [(!props.item.loanTransaction)?[_c('tr',[_c('td',[_c('v-btn',{staticClass:"primary--text",attrs:{"disabled":props.item.status == 'paid',"outlined":""},on:{"click":function($event){return _vm.addDiposit('LoanTaken', props.item)}}},[_vm._v("\n                  PAY\n                ")])],1),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(new Date(props.item.date).toLocaleDateString("en-GB")))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(new Date(props.item.interestDate).toLocaleDateString(
                    "en-GB"
                  )))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item["amount"] || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["interest"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.getInterest(props.item) > 0 ? _vm.getInterest(props.item) : 0))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.getDuration(props.item)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["paidAmount"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["paidInterest"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["paymentType"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["transferType"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["status"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["remark"]))])]),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editDeposite(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteDeposit(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.getFirmName(props.item["firm"])))])])]),_vm._v(" "),_vm._l((props.item.transactions),function(loan){return [(loan['.key'])?_c('tr',{key:loan['.key'] + 'roww',staticClass:"loan-transactions"},[_c('td',{key:loan['.key'] + 'k'},[_c('b',[_vm._v(_vm._s(loan[".key"]))])]),_vm._v(" "),_c('td',{key:loan['.key'] + 'a'}),_vm._v(" "),_c('td',{key:loan['.key'] + 'paytype'},[_c('b',[_vm._v(_vm._s(loan["paymentType"]))])]),_vm._v(" "),_c('td',{key:loan['.key'] + 'trans'}),_vm._v(" "),_c('td',{key:loan['.key'] + 'int'}),_vm._v(" "),_c('td',{key:loan['.key'] + 'getint'}),_vm._v(" "),_c('td',{key:loan['.key'] + 'dur'}),_vm._v(" "),_c('td',{key:loan['.key'] + 'paidAmount'},[_c('b',[_vm._v(_vm._s(loan["paidAmount"]))])]),_vm._v(" "),_c('td',{key:loan['.key'] + 'paidInterest'},[_c('b',[_vm._v(_vm._s(loan["paidInterest"]))])]),_vm._v(" "),_c('td',{key:loan['.key'] + 'firm'}),_vm._v(" "),_c('td',{key:loan['.key'] + 'date'},[_c('b',[_vm._v(_vm._s(new Date(loan.date).toLocaleDateString("en-GB")))])]),_vm._v(" "),_c('td',{key:loan['.key'] + 'interest'}),_vm._v(" "),_c('td',{key:loan['.key'] + 'PT'},[_c('b',[_vm._v(_vm._s(loan["loanPaymentType"]))])]),_vm._v(" "),_c('td',{key:loan['.key'] + 'edit'}),_vm._v(" "),_c('td',{key:loan['.key'] + 'delete'}),_vm._v(" "),_c('td',{key:loan['.key'] + 'pay'})]):_vm._e()]})]:_vm._e()]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"700px"},model:{value:(_vm.addDipositDialog),callback:function ($$v) {_vm.addDipositDialog=$$v},expression:"addDipositDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.addDipositDialog = false}}},[_c('v-icon',[_vm._v("mdi-close")])],1),_vm._v(" "),_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.currentDeposite.type)+" Deposit Details")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(
            !_vm.loanPayment &&
            (_vm.currentDeposite.type == 'Advance' ||
              _vm.currentDeposite.type == 'LoanGiven' ||
              _vm.currentDeposite.type == 'LoanTaken' ||
              _vm.currentDeposite.type == 'Security')
          )?_c('v-switch',{staticClass:"customer-deposite",staticStyle:{"margin-top":"13px"},attrs:{"label":("Enter as opening Balance: " + (_vm.isOpeningBalance ? 'Yes' : 'No'))},on:{"change":function($event){return _vm.openingBalanceSwitcherChange()}},model:{value:(_vm.isOpeningBalance),callback:function ($$v) {_vm.isOpeningBalance=$$v},expression:"isOpeningBalance"}}):_vm._e()],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[(
                (_vm.currentDeposite.type == 'LoanTaken' ||
                  _vm.currentDeposite.type == 'LoanGiven' ||
                  _vm.currentDeposite.type == 'Opening Balance') &&
                _vm.loanPayment
              )?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-radio-group',{key:'deposite-amount-total',attrs:{"row":""},on:{"change":function($event){return _vm.calculateAmounts()}},model:{value:(_vm.loanPaymentType),callback:function ($$v) {_vm.loanPaymentType=$$v},expression:"loanPaymentType"}},[_c('v-radio',{attrs:{"label":"Pay Custom","value":"custom"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Pay Interest","value":"interest"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Pay Full","value":"full"}})],1)],1):_vm._e(),_vm._v(" "),(
                _vm.currentDeposite.type != 'Send Order' &&
                _vm.currentDeposite.type != 'Place Order'
              )?_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.firmsByBrand,"label":"Select Firm","readonly":_vm.isSummary},model:{value:(_vm.currentDeposite.firm),callback:function ($$v) {_vm.$set(_vm.currentDeposite, "firm", $$v)},expression:"currentDeposite.firm"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"date-container",attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker),callback:function ($$v) {_vm.datepicker=$$v},expression:"datepicker"}},[_c('v-text-field',{staticClass:"deposite-date",attrs:{"slot":"activator","label":"Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.currentDeposite.date),callback:function ($$v) {_vm.$set(_vm.currentDeposite, "date", $$v)},expression:"currentDeposite.date"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepicker = false}},model:{value:(_vm.currentDeposite.date),callback:function ($$v) {_vm.$set(_vm.currentDeposite, "date", $$v)},expression:"currentDeposite.date"}})],1)],1),_vm._v(" "),(_vm.currentDeposite.type == 'Security')?_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"text","label":"Mortgage"},model:{value:(_vm.currentDeposite.mortgage),callback:function ($$v) {_vm.$set(_vm.currentDeposite, "mortgage", $$v)},expression:"currentDeposite.mortgage"}})],1):_vm._e(),_vm._v(" "),(
                _vm.currentDeposite.type == 'Advance' ||
                _vm.currentDeposite.type == 'LoanGiven' ||
                _vm.currentDeposite.type == 'LoanTaken' ||
                (_vm.currentDeposite.type == 'Opening Balance' && _vm.loanPayment)
              )?_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-select',{attrs:{"dense":"","items":[
                  {
                    text: 'Cash',
                    value: 'Cash',
                  },
                  {
                    text: 'Bank Account',
                    value: 'Bank Account',
                  },
                  {
                    text: 'Cash & Bank Account',
                    value: 'CashAndBank Account',
                  } ],"label":"Select Payment Type"},model:{value:(_vm.currentDeposite.paymentType),callback:function ($$v) {_vm.$set(_vm.currentDeposite, "paymentType", $$v)},expression:"currentDeposite.paymentType"}})],1):_vm._e(),_vm._v(" "),(
                _vm.currentDeposite.type == 'LoanTaken' ||
                _vm.currentDeposite.type == 'LoanGiven' ||
                (_vm.currentDeposite.type == 'Opening Balance' &&
                  _vm.previousType != 'Advance' &&
                  _vm.previousType != 'Security')
              )?_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Interest Rate","disabled":_vm.loanPayment},model:{value:(_vm.currentDeposite.interest),callback:function ($$v) {_vm.$set(_vm.currentDeposite, "interest", $$v)},expression:"currentDeposite.interest"}})],1):_vm._e(),_vm._v(" "),(
                !_vm.loanPayment &&
                (_vm.currentDeposite.type == 'Security' ||
                  _vm.currentDeposite.type == 'Advance' ||
                  _vm.currentDeposite.type == 'Opening Balance' ||
                  _vm.currentDeposite.type == 'LoanTaken' ||
                  _vm.currentDeposite.type == 'LoanGiven')
              )?_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","label":_vm.loanPayment ? 'Principal Amount' : 'Amount',"hint":_vm.hintText,"disabled":_vm.loanPayment},model:{value:(_vm.currentDeposite.amount),callback:function ($$v) {_vm.$set(_vm.currentDeposite, "amount", $$v)},expression:"currentDeposite.amount"}})],1):_vm._e(),_vm._v(" "),_c('v-textarea',{attrs:{"background-color":"grey darken-1","color":"black","type":"text","label":"Remark","disabled":_vm.loanPayment},model:{value:(_vm.currentDeposite.remark),callback:function ($$v) {_vm.$set(_vm.currentDeposite, "remark", $$v)},expression:"currentDeposite.remark"}}),_vm._v(" "),(
                _vm.currentDeposite.type == 'Send Order' ||
                _vm.currentDeposite.type == 'Place Order'
              )?_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Quantity"},model:{value:(_vm.currentDeposite.quantity),callback:function ($$v) {_vm.$set(_vm.currentDeposite, "quantity", $$v)},expression:"currentDeposite.quantity"}})],1):_vm._e(),_vm._v(" "),(
                (_vm.currentDeposite.type == 'LoanTaken' ||
                  _vm.currentDeposite.type == 'LoanGiven') &&
                _vm.loanPayment
              )?_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"type":"number","value":_vm.currentDeposite.interestAmount,"label":"Interest Amount","hint":_vm.hintText,"disabled":_vm.loanPayment}})],1):_vm._e(),_vm._v(" "),(
                (_vm.currentDeposite.type == 'LoanTaken' ||
                  _vm.currentDeposite.type == 'LoanGiven') &&
                _vm.loanPayment
              )?_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"type":"number","value":_vm.currentDeposite.roundOffAmount,"label":"Round Off","disabled":_vm.loanPayment}})],1):_vm._e(),_vm._v(" "),(
                (_vm.currentDeposite.type == 'LoanTaken' ||
                  _vm.currentDeposite.type == 'LoanGiven') &&
                _vm.loanPayment
              )?_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"type":"number","value":Number.parseFloat(_vm.currentDeposite.interestAmount) +
                  Number.parseFloat(_vm.currentDeposite.amount) +
                  Number.parseFloat(_vm.currentDeposite.roundOffAmount) -
                  Number.parseFloat(_vm.currentDeposite.paidAmount),"label":"Total Amount","hint":_vm.hintText,"disabled":_vm.loanPayment}})],1):_vm._e(),_vm._v(" "),(
                _vm.currentDeposite.type == 'Send Order' ||
                _vm.currentDeposite.type == 'Place Order'
              )?_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-select',{attrs:{"items":_vm.productsByBrand,"item-text":"name","label":"Product"},model:{value:(_vm.currentDeposite.product),callback:function ($$v) {_vm.$set(_vm.currentDeposite, "product", $$v)},expression:"currentDeposite.product"}})],1):_vm._e(),_vm._v(" "),(_vm.loanPayment || _vm.currentDeposite.type == 'Advance' || _vm.currentDeposite.type == 'LoanTaken' || _vm.currentDeposite.type == 'LoanGiven')?_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[(
                  ['Bank Account', 'CashAndBank Account'].includes(
                    _vm.currentDeposite.paymentType
                  )
                )?_c('v-select',{attrs:{"dense":"","items":_vm.banksByFirms,"label":"Select Bank","flat":"","clearable":"","item-text":"bankName","return-object":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                "+_vm._s(data.item.account.accountnumber)+"\n                "+_vm._s(data.item.account.bankName ? ' | '+ data.item.account.bankName : '')+"\n              ")]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(((data.item.account.accountnumber) + "\n                          " + (data.item.account.bankName ? ' | '+data.item.account.bankName : '') + "\n                          " + (data.item.account.accountType ? ' | '+data.item.account.accountType : ''))
                      )}})],1)]}}],null,false,113989768),model:{value:(_vm.currentDeposite.bank),callback:function ($$v) {_vm.$set(_vm.currentDeposite, "bank", $$v)},expression:"currentDeposite.bank"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(
                (_vm.currentDeposite.type == 'LoanGiven' ||
                  _vm.currentDeposite.type == 'LoanTaken' ||
                   _vm.currentDeposite.type == 'Advance' || 
                  _vm.currentDeposite.type == 'Opening Balance') &&
                _vm.currentDeposite.paymentType != 'Cash' &&
                _vm.currentDeposite.paymentType != ''
              )?_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-select',{attrs:{"dense":"","items":[
                  {
                    text: 'Cheque',
                    value: 'Cheque',
                  },
                  {
                    text: 'NEFT',
                    value: 'NEFT',
                  },
                  {
                    text: 'RTGS',
                    value: 'RTGS',
                  },
                  {
                    text: 'IMPS',
                    value: 'IMPS',
                  } ],"label":"Select Transfer type"},model:{value:(_vm.currentDeposite.transferType),callback:function ($$v) {_vm.$set(_vm.currentDeposite, "transferType", $$v)},expression:"currentDeposite.transferType"}})],1):_vm._e(),_vm._v(" "),(_vm.loanPayment || _vm.currentDeposite.type == 'Advance')?_c('v-flex',{staticStyle:{"padding-top":"14px"},attrs:{"xs6":"","sm6":"","md6":""}},[(
                  ['Cash', 'CashAndBank Account'].includes(
                    _vm.currentDeposite.paymentType
                  )
                )?_c('v-text-field',{key:'cus-depo-amt-cash',attrs:{"type":"number","label":"Amount from Cash","hint":_vm.hintText},model:{value:(_vm.currentDeposite.amountFromCash),callback:function ($$v) {_vm.$set(_vm.currentDeposite, "amountFromCash", $$v)},expression:"currentDeposite.amountFromCash"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.loanPayment || _vm.currentDeposite.type == 'Advance')?_c('v-flex',{staticStyle:{"padding-top":"14px"},attrs:{"xs6":"","sm6":"","md6":""}},[(
                  ['Bank Account', 'CashAndBank Account'].includes(
                    _vm.currentDeposite.paymentType
                  )
                )?_c('v-text-field',{key:'cus-depo-amt-bank',attrs:{"type":"number","hint":_vm.hintText,"label":"Amount from Bank"},model:{value:(_vm.currentDeposite.amountFromBank),callback:function ($$v) {_vm.$set(_vm.currentDeposite, "amountFromBank", $$v)},expression:"currentDeposite.amountFromBank"}}):_vm._e()],1):_vm._e()],1)],1)],1),_vm._v(" "),(!_vm.loanPayment)?_c('v-card-actions',[(_vm.previousType)?_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){return _vm.backToPrevious()}}},[_vm._v("Back")]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!_vm.currentDeposite['.key'])?_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":_vm.saveDiposit}},[_vm._v("Save")]):_vm._e(),_vm._v(" "),(!!_vm.currentDeposite['.key'])?_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":_vm.updateDeposit}},[_vm._v("Update")]):_vm._e()],1):_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text",attrs:{"flat":""},on:{"click":function($event){return _vm.payLoan()}}},[_vm._v("Pay")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"800","persistent":""},model:{value:(_vm.passwordDialog),callback:function ($$v) {_vm.passwordDialog=$$v},expression:"passwordDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline primary--text",attrs:{"primary-title":""}},[_vm._v("\n          Enter the password\n          "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"primary",attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.passwordDialog = false}}},[_c('v-icon',[_vm._v("mdi-close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"type":"password","label":"Password","autocomplete":"false"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.deleteFromDialog()}}},[_vm._v("Delete")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(435);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f7c2a66_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1347);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f7c2a66_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__(436);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2092ebc4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(1346);
function injectStyle (ssrContext) {
  __webpack_require__(1345)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2092ebc4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2092ebc4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1345 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-card',{attrs:{"height":"100%"}},[_c('v-list',[_vm._l((_vm.items),function(item,index){return [(item.header)?_c('v-subheader',{key:item.header,staticClass:"primary title white--text",attrs:{"primary-title":""},domProps:{"innerHTML":_vm._s(item.header)}}):(item.divider)?_c('v-divider',{key:index,attrs:{"inset":item.inset}}):(!item.isMultiple)?[_c('router-link',{key:item['.key'],attrs:{"tag":"v-list-tile","to":{ 
              name: item.link
            },"avatar":""}},[_c('v-list-tile-avatar',[_c('i',{staticClass:"material-icons primary--text"},[_vm._v("\n                  "+_vm._s(item.icon)+"\n                ")])]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"primary--text font-weight-bold",domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"primary--text font-weight-light",domProps:{"innerHTML":_vm._s(item.subtitle)}})],1)],1)]:(item.isMultiple)?[_c('v-list-group',{key:item.title,attrs:{"value":false},scopedSlots:_vm._u([{key:"activator",fn:function(){return [_c('v-list-tile-avatar',{style:(item.style)},[_c('i',{staticClass:"material-icons primary--text",staticStyle:{"padding-left":"25px"}},[_vm._v("\n                  "+_vm._s(item.icon)+"\n                ")])]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"subheading primary--text font-weight-bold",domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"primary--text font-weight-light",domProps:{"innerHTML":_vm._s(item.subtitle)}})],1)]},proxy:true}],null,true)},[_vm._v(" "),_vm._l((item.children),function(item1,index1){return [(item1.divider)?_c('v-divider',{key:index1,attrs:{"inset":item.inset}}):_c('router-link',{key:item1['.key'],staticStyle:{"padding-left":"35px"},attrs:{"tag":"v-list-tile","to":{ 
                  name: item1.link
                },"avatar":""}},[_c('v-list-tile-avatar',[_c('i',{staticClass:"material-icons primary--text"},[_vm._v("\n                  "+_vm._s(item1.icon)+"\n                ")])]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"primary--text font-weight-bold",domProps:{"innerHTML":_vm._s(item1.title)}}),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"primary--text font-weight-light",domProps:{"innerHTML":_vm._s(item1.subtitle)}})],1)],1)]})],2)]:_vm._e()]})],2)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-xs":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"sm3":"","md3":""}},[_c('sidebar')],1),_vm._v(" "),_c('v-flex',{attrs:{"sm9":"","md9":""}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(437);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_584e4481_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1360);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_584e4481_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Filters_vue__ = __webpack_require__(438);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2ab45c6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Filters_vue__ = __webpack_require__(1350);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Filters_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2ab45c6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Filters_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary-title":""}},[_c('h3',{attrs:{"color":"primary"}},[_vm._v("FILTERS")])]),_vm._v(" "),_c('v-card-text',[_c('v-expansion-panel',_vm._l((_vm.filters),function(item,i){return _c('v-expansion-panel-content',{key:i+'fil'},[(item.reportType.includes(_vm.reportType))?_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('b',{staticClass:"primary--text font-weight-bold"},[_vm._v(_vm._s(item.name))])]):_vm._e(),_vm._v(" "),_c('v-card',[(item.type=='select' && item.reportType.includes(_vm.reportType))?_c('v-card-text',[_c('v-select',{attrs:{"items":item.options,"label":item.placeholder},model:{value:(item.model),callback:function ($$v) {_vm.$set(item, "model", $$v)},expression:"item.model"}})],1):(item.type=='search' && item.reportType.includes(_vm.reportType))?_c('v-card-text',[_c('v-autocomplete',{staticClass:"mx-3",attrs:{"items":item.options,"search-input":item.input,"flat":"","hide-no-data":"","hide-details":"","label":item.placeholder,"solo-inverted":"","clearable":""},on:{"update:searchInput":function($event){return _vm.$set(item, "input", $event)},"update:search-input":function($event){return _vm.$set(item, "input", $event)}},model:{value:(item.model),callback:function ($$v) {_vm.$set(item, "model", $$v)},expression:"item.model"}})],1):(item.type=='number-range' && item.reportType.includes(_vm.reportType))?_c('v-card-text',[_c('v-slider',{attrs:{"thumb-label":"","label":item.label,"min":item.min,"max":item.max,"range":""},model:{value:(item.model),callback:function ($$v) {_vm.$set(item, "model", $$v)},expression:"item.model"}})],1):(item.type=='date-range' && item.reportType.includes(_vm.reportType))?_c('v-card-text',[_c('v-menu',{ref:"menu",refInFor:true,attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":item.start,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},on:{"update:returnValue":function($event){return _vm.$set(item, "start", $event)},"update:return-value":function($event){return _vm.$set(item, "start", $event)}},model:{value:(item.menu),callback:function ($$v) {_vm.$set(item, "menu", $$v)},expression:"item.menu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Pick a Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(item.model),callback:function ($$v) {_vm.$set(item, "model", $$v)},expression:"item.model"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":""},on:{"input":function($event){item.menu = false}},model:{value:(item.model),callback:function ($$v) {_vm.$set(item, "model", $$v)},expression:"item.model"}})],1)],1):_vm._e()],1)],1)}),1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text",attrs:{"large":"","round":"","primary":"","title":"","color":"white"},nativeOn:{"click":function($event){return _vm.clearFilter()}}},[_vm._v("\n      Clear Filter\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GridView_vue__ = __webpack_require__(439);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10515182_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GridView_vue__ = __webpack_require__(1359);
function injectStyle (ssrContext) {
  __webpack_require__(1352)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GridView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10515182_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GridView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1352 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return convertToPDFStockReport; });

// playground requires you to assign document definition to a variable called dd
var convertToPDFStockReport = function convertToPDFStockReport(_ref) {
    var invoiceData = _ref.invoiceData,
        firm = _ref.firm,
        fromDate = _ref.fromDate,
        toDate = _ref.toDate;

    var dd = {
        pageOrientation: 'landscape',
        content: [{ text: 'STOCK BOOK\n\n', style: "gstDataBold" }, {
            table: {
                widths: ['*'],
                body: [[{
                    text: []
                }], [{ text: '', style: "gstDataBold1" }]]
            }
        }, {
            table: {

                body: [[{ text: 'S.No', style: "gstHeader", rowSpan: 2 }, { text: 'Product Description', style: "gstHeader", rowSpan: 2 }, { text: 'Opening', style: "gstHeader", colSpan: 2, rowSpan: 1 }, { text: '', style: "gstHeader", rowSpan: 2 }, { text: 'Purchase', style: "gstHeader", colSpan: 2, rowSpan: 1 }, { text: '', style: "gstHeader", rowSpan: 2 }, { text: 'Sales', style: "gstHeader", colSpan: 2, rowSpan: 1 }, { text: '', style: "gstHeader", rowSpan: 2 }, { text: 'Closing', style: "gstHeader", colSpan: 2, rowSpan: 1 }, { text: '', style: "gstHeader", rowSpan: 2 }], [{ text: 'S.No', style: "gstHeader" }, { text: 'Name - Description \n', style: "gstHeader1" }, { text: 'Quantity', style: "gstHeader" }, { text: 'Amount', style: "gstHeader" }, { text: 'Quantity', style: "gstHeader" }, { text: 'Amount', style: "gstHeader" }, { text: 'Quantity', style: "gstHeader" }, { text: 'Amount', style: "gstHeader" }, { text: 'Quantity', style: "gstHeader" }, { text: 'Amount', style: "gstHeader" }]]
            }

        }],
        styles: {
            gstHeader: {
                fontSize: 11,
                bold: true,
                alignment: 'center',
                color: '#160091'
            },
            gstHeader1: {
                fontSize: 11,
                bold: true,
                alignment: 'left',
                color: '#160091'
            },
            gstData: {
                fontSize: 9,
                bold: false,
                alignment: 'center'
            },
            gstDataBold: {
                fontSize: 14,
                bold: true,
                alignment: 'center',
                color: '#160091'
            },
            gstDataBold1: {
                fontSize: 14,
                bold: true,
                alignment: 'center',
                color: '#160091',
                fillColor: '#15155d'
            },
            gstDataAlert: {
                fontSize: 9,
                bold: true,
                alignment: 'center',
                color: '#B71C1C'
            },
            gstDataInfo: {
                fontSize: 9,
                bold: true,
                alignment: 'center',
                color: '#0D47A1'
            },
            gstDataSuccess: {
                fontSize: 9,
                bold: true,
                alignment: 'center',
                color: '#1B5E20'
            },
            gstDataPrimary: {
                fontSize: 9,
                bold: true,
                alignment: 'center',
                color: '#160091'
            }
        }
    };
    if (firm) {
        dd.content[1].table.body[0][0].text.push({ text: '   Firm : ' + firm, bold: true });
    }
    if (fromDate) {
        dd.content[1].table.body[0][0].text.push({ text: '   From Date : ' + fromDate, bold: true });
    }
    if (toDate) {
        dd.content[1].table.body[0][0].text.push({ text: '   To Date : ' + toDate, bold: true });
    }
    // if (liveAddress) {
    //     dd.content[1].table.body[1][0].text[3].text = liveAddress
    // }
    invoiceData.map(function (invoice) {
        var Opening = invoice[3].split('\n');
        var Purchase = invoice[4].split('\n');
        var Sales = invoice[5].split('\n');
        var Closing = invoice[6].split('\n');
        dd.content[2].table.body.push([{ text: invoice[0], style: "gstData" }, { text: invoice[2], style: "gstHeader1" }, { text: Opening[0], style: "gstDataInfo" }, { text: Opening[1], style: "gstData" }, { text: Purchase[0], style: "gstDataPrimary" }, { text: Purchase[1], style: "gstData" }, { text: Sales[0], style: "gstDataSuccess" }, { text: Sales[1], style: "gstData" }, { text: Closing[0], style: "gstDataAlert" }, { text: Closing[1], style: "gstData" }]);
    });

    return dd;
};

/***/ }),
/* 1359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialogStockReports),callback:function ($$v) {_vm.dialogStockReports=$$v},expression:"dialogStockReports"}},[_c('v-card',[[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',[_vm._v("\n              STOCK REPORTS\n            ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{staticClass:"product-report-search",attrs:{"solo":"","outlined":"","autofocus":true,"clearable":"","label":"Search Product"},nativeOn:{"keyup":function($event){return _vm.keymonitor($event)}}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',{staticClass:"white--text",on:{"click":function($event){return _vm.printStockReports()}}},[_vm._v("print")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialogStockReports = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),(Object.keys(_vm.filters).length)?_c('div',{staticStyle:{"padding":"15px 20px 0px 20px"}},[_vm._v("\n            Active Filters:\n            "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.date.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("From Date : "+_vm._s(new Date(_vm.filters.date.model).toLocaleDateString('en-GB')))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.tillDate.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("Till Date : "+_vm._s(new Date(_vm.filters.tillDate.model).toLocaleDateString('en-GB')))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.month.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("Month : "+_vm._s(_vm.filters.month.model+1))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.duration.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("Duration : "+_vm._s(_vm.filters.duration.model))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.firms.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("Firm : "+_vm._s(_vm.getFirmName(_vm.filters.firms.model)))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.gstType.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("GST Type : "+_vm._s(_vm.filters.gstType.model))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.paymentType.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("Payment Type : "+_vm._s(_vm.filters.paymentType.model))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.status && _vm.filters.status.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("Status : "+_vm._s(_vm.filters.status.model))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.invoiceNumber.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("Invoice Number : "+_vm._s(_vm.filters.invoiceNumber.model))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.buyerName.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("Buyer Name : "+_vm._s(_vm.filters.buyerName.model))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.gstPercentage.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("GST Percentage : "+_vm._s(_vm.filters.gstPercentage.model))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.gstCategory.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("GST Category : "+_vm._s(_vm.filters.gstCategory.model))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.isActive.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("Product Status : "+_vm._s(_vm.filters.isActive.model))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.hsnCode.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("HSN : "+_vm._s(_vm.filters.hsnCode.model))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.unit.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("UNIT : "+_vm._s(_vm.filters.unit.model))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.quantity.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("Quantity : "+_vm._s(_vm.filters.quantity.model))]):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_c('v-card-text',[(_vm.reportType == 'stock')?_c('v-data-table',{staticClass:"elevation-1 dashboardHead  stocks-reports",attrs:{"headers":_vm.productListHeader,"items":_vm.filters.stockReportType.model == 'quantity' ? _vm.filteredProduct : _vm.filteredProductByWeight,"hide-actions":""},scopedSlots:_vm._u([{key:"headers",fn:function(props){return [_c('tr',[_c('th',[_vm._v("Sr\n    ")]),_vm._v(" "),_c('th',[_vm._v("Action")]),_vm._v(" "),_c('th',[_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v("NAME - Description")])]),_vm._v(" "),_c('th',[_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v("Opening Stock")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(_vm.filters.stockReportType.model == 'quantity' ? 'Quantity' : 'Weight'))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_vm._v("Amount")])]),_vm._v(" "),_c('th',[_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v("Purchase Stock")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(_vm.filters.stockReportType.model == 'quantity' ? 'Quantity' : 'Weight'))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_vm._v("Amount")])]),_vm._v(" "),_c('th',[_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v("Sales Stock")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(_vm.filters.stockReportType.model == 'quantity' ? 'Quantity' : 'Weight'))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_vm._v("Amount")])]),_vm._v(" "),_c('th',[_c('v-select',{staticStyle:{"margin-bottom":"-35px"},attrs:{"items":_vm.stockReportTypes,"label":"Closing Stock"},model:{value:(_vm.selectedClosingStockType),callback:function ($$v) {_vm.selectedClosingStockType=$$v},expression:"selectedClosingStockType"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"float":"left"}},[_vm._v("Quantity")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_vm._v("Amount")])],1)])]}},{key:"items",fn:function(props){return [_c('tr',[_c('td',{staticStyle:{"text-align":"center"}},[(props.item['name'] != 'Total')?_c('b',[_vm._v(_vm._s(props.index + 1))]):_vm._e()]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[(props.item['name'] != 'Total')?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.openProdItems(props.item)}}},[_vm._v("remove_red_eye")]):_vm._e()],1),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['name']))])]),_c('td',[_c('span',{staticStyle:{"float":"left"}},[_c('b',{staticClass:"font-weight-bold info--text",attrs:{"title":props.item['openingQuantityTitle']}},[_vm._v(_vm._s(props.item['openingQuantity']))])]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item['openingBalance'] || 0)))])])]),_vm._v(" "),_c('td',[_c('span',{staticStyle:{"float":"left"}},[_c('b',{staticClass:"font-weight-bold primary--text",attrs:{"title":props.item['purchaseQuantityTitle']}},[_vm._v(_vm._s(props.item['durationQtyPurchase']))])]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_c('b',[_vm._v(" "+_vm._s(_vm._f("amount")(props.item['durationAmountPurchase'] || 0)))])])]),_vm._v(" "),_c('td',[_c('span',{staticStyle:{"float":"left"}},[_c('b',{staticClass:"font-weight-bold green--text",attrs:{"title":props.item['saleQuantityTitle']}},[_vm._v(_vm._s(props.item['durationQtySale']))])]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_c('b',[_vm._v(" "+_vm._s(_vm._f("amount")(props.item['durationAmountSale'] || 0)))])])]),_vm._v(" "),_c('td',[_c('span',{staticStyle:{"float":"left"}},[_c('b',{staticClass:"font-weight-bold red--text",attrs:{"title":props.item['closingQuantityTitle']}},[_vm._v(_vm._s(props.item['closingQuantity']))])]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_c('b',[_vm._v(" "+_vm._s(_vm._f("amount")(props.item['closingAmount']|| 0)))])])])])]}}],null,false,3077968365)},[_vm._v(" "),_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2):_vm._e(),_vm._v(" "),(_vm.reportType == 'productGroup')?_c('v-data-table',{staticClass:"elevation-1 dashboardHead  stocks-reports",attrs:{"headers":_vm.productListHeader,"items":_vm.filteredGroups,"hide-actions":""},scopedSlots:_vm._u([{key:"headers",fn:function(props){return [_c('tr',[_c('th',[_vm._v("Sr\n    ")]),_vm._v(" "),_c('th',[_vm._v("Action")]),_vm._v(" "),_c('th',[_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v("NAME - Description")])]),_vm._v(" "),_c('th',[_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v("Opening Stock")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(_vm.filters.stockReportType.model == 'quantity' ? 'Quantity' : 'Weight'))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_vm._v("Amount")])]),_vm._v(" "),_c('th',[_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v("Purchase Stock")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(_vm.filters.stockReportType.model == 'quantity' ? 'Quantity' : 'Weight'))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_vm._v("Amount")])]),_vm._v(" "),_c('th',[_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v("Sales Stock")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(_vm.filters.stockReportType.model == 'quantity' ? 'Quantity' : 'Weight'))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_vm._v("Amount")])]),_vm._v(" "),_c('th',[_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v("Closing Stock")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"float":"left"}},[_vm._v("Quantity")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_vm._v("Amount")])])])]}},{key:"items",fn:function(props){return [_c('tr',[_c('td',{staticStyle:{"text-align":"center"}},[(props.item['name'] != 'Total')?_c('b',[_vm._v(_vm._s(props.index + 1))]):_vm._e()]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"center"}},[(props.item['name'] != 'Total')?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.openProdItems(props.item)}}},[_vm._v("remove_red_eye")]):_vm._e()],1),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['name']))])]),_c('td',[_c('span',{staticStyle:{"float":"left"}},[_c('b',{staticClass:"font-weight-bold info--text",attrs:{"title":props.item['openingQuantityTitle']}},[_vm._v(_vm._s(props.item['openingQuantity']))])]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item['openingBalance'] || 0)))])])]),_vm._v(" "),_c('td',[_c('span',{staticStyle:{"float":"left"}},[_c('b',{staticClass:"font-weight-bold primary--text",attrs:{"title":props.item['purchaseQuantityTitle']}},[_vm._v(_vm._s(props.item['durationQtyPurchase']))])]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_c('b',[_vm._v(" "+_vm._s(_vm._f("amount")(props.item['durationAmountPurchase'] || 0)))])])]),_vm._v(" "),_c('td',[_c('span',{staticStyle:{"float":"left"}},[_c('b',{staticClass:"font-weight-bold green--text",attrs:{"title":props.item['saleQuantityTitle']}},[_vm._v(_vm._s(props.item['durationQtySale']))])]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_c('b',[_vm._v(" "+_vm._s(_vm._f("amount")(props.item['durationAmountSale'] || 0)))])])]),_vm._v(" "),_c('td',[_c('span',{staticStyle:{"float":"left"}},[_c('b',{staticClass:"font-weight-bold red--text",attrs:{"title":props.item['closingQuantityTitle']}},[_vm._v(_vm._s(props.item['closingQuantity']))])]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_c('b',[_vm._v(" "+_vm._s(_vm._f("amount")(props.item['closingAmount']|| 0)))])])])])]}}],null,false,1607048276)},[_vm._v(" "),_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2):_vm._e()],1)]],2)],1),_vm._v(" "),(_vm.reportType == 'stock')?_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.productListHeader,"items":_vm.filters.stockReportType.model == 'quantity' ? _vm.filteredProduct : _vm.filteredProductByWeight,"hide-actions":""},scopedSlots:_vm._u([{key:"headers",fn:function(props){return [_c('tr',[_c('th',[_c('v-btn',{staticClass:"full-screen-view",attrs:{"flat":"","icon":""},on:{"click":function($event){_vm.dialogStockReports = true}}},[_c('v-icon',[_vm._v("menu")])],1)],1),_vm._v(" "),_c('th',[_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v("Name - Description")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("HSN-GST-RATE-UNIT")])]),_vm._v(" "),_c('th',[_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v("Opening Stock")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(_vm.filters.stockReportType.model == 'quantity' ? 'Quantity' : 'Weight'))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_vm._v("Amount")])]),_vm._v(" "),_c('th',[_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v("Purchase Stock")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(_vm.filters.stockReportType.model == 'quantity' ? 'Quantity' : 'Weight'))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_vm._v("Amount")])]),_vm._v(" "),_c('th',[_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v("Sales Stock")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(_vm.filters.stockReportType.model == 'quantity' ? 'Quantity' : 'Weight'))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_vm._v("Amount")])]),_vm._v(" "),_c('th',[_c('v-select',{staticStyle:{"margin-bottom":"-35px"},attrs:{"items":_vm.stockReportTypes,"label":"Closing Stock"},model:{value:(_vm.selectedClosingStockType),callback:function ($$v) {_vm.selectedClosingStockType=$$v},expression:"selectedClosingStockType"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(_vm.filters.stockReportType.model == 'quantity' ? 'Quantity' : 'Weight'))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_vm._v("Amount")])],1)])]}},{key:"items",fn:function(props){return [_c('td',{staticStyle:{"text-align":"center"}},[(props.item['name'] != 'Total')?_c('b',[_vm._v(_vm._s(props.index + 1))]):_vm._e()]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['name']))]),_vm._v(" "),(props.item['description'])?[_c('br'),_vm._v("Desc : "+_vm._s(props.item['description'])+"\n        ")]:_vm._e(),_vm._v(" "),(props.item['HSN_code'])?[_c('br'),_vm._v("HSN : "+_vm._s(props.item['HSN_code'])+"\n        ")]:_vm._e(),_vm._v(" "),(props.item['GST_type'])?[_vm._v("\n          GST Category : "+_vm._s(props.item['GST_type'])+"\n        ")]:_vm._e(),_vm._v(" "),(props.item['taxableGST_rate'])?[_c('br'),_vm._v("\n          Rate : "+_vm._s(props.item['taxableGST_rate'])+"\n        ")]:_vm._e(),_vm._v(" "),(props.item['unit'])?[_vm._v("\n          Unit : "+_vm._s(props.item['unit'])+"\n        ")]:_vm._e()],2),_vm._v(" "),_c('td',[_c('span',{staticStyle:{"float":"left"}},[_c('b',{staticClass:"font-weight-bold info--text",attrs:{"title":props.item['openingQuantityTitle']}},[_vm._v(_vm._s(props.item['openingQuantity']))])]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item['openingBalance'] || 0)))])])]),_vm._v(" "),_c('td',[_c('span',{staticStyle:{"float":"left"}},[_c('b',{staticClass:"font-weight-bold primary--text",attrs:{"title":props.item['purchaseQuantityTitle']}},[_vm._v(_vm._s(props.item['durationQtyPurchase']))])]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_c('b',[_vm._v(" "+_vm._s(_vm._f("amount")(props.item['durationAmountPurchase'] || 0)))])])]),_vm._v(" "),_c('td',[_c('span',{staticStyle:{"float":"left"}},[_c('b',{staticClass:"font-weight-bold green--text",attrs:{"title":props.item['saleQuantityTitle']}},[_vm._v(_vm._s(props.item['durationQtySale']))])]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_c('b',[_vm._v(" "+_vm._s(_vm._f("amount")(props.item['durationAmountSale'] || 0)))])])]),_vm._v(" "),_c('td',[_c('span',{staticStyle:{"float":"left"}},[_c('b',{staticClass:"font-weight-bold red--text",attrs:{"title":props.item['closingQuantityTitle']}},[_vm._v(_vm._s(props.item['closingQuantity']))])]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item['closingAmount']|| 0)))])])])]}}],null,false,1082032996)},[_vm._v(" "),_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2):_vm._e(),_vm._v(" "),(_vm.reportType == 'productGroup')?_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.productListHeader,"items":_vm.filteredGroups,"hide-actions":""},scopedSlots:_vm._u([{key:"headers",fn:function(props){return [_c('tr',[_c('th',[_c('v-btn',{staticClass:"full-screen-view",attrs:{"flat":"","icon":""},on:{"click":function($event){_vm.dialogStockReports = true}}},[_c('v-icon',[_vm._v("menu")])],1)],1),_vm._v(" "),_c('th',[_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v("Name - Description")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("HSN-GST-RATE-UNIT")])]),_vm._v(" "),_c('th',[_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v("Opening Stock")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(_vm.filters.stockReportType.model == 'quantity' ? 'Quantity' : 'Weight'))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_vm._v("Amount")])]),_vm._v(" "),_c('th',[_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v("Purchase Stock")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(_vm.filters.stockReportType.model == 'quantity' ? 'Quantity' : 'Weight'))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_vm._v("Amount")])]),_vm._v(" "),_c('th',[_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v("Sales Stock")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(_vm.filters.stockReportType.model == 'quantity' ? 'Quantity' : 'Weight'))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_vm._v("Amount")])]),_vm._v(" "),_c('th',[_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v("Closing Stock")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(_vm.filters.stockReportType.model == 'quantity' ? 'Quantity' : 'Weight'))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_vm._v("Amount")])])])]}},{key:"items",fn:function(props){return [_c('td',{staticStyle:{"text-align":"center"}},[(props.item['name'] != 'Total')?_c('b',[_vm._v(_vm._s(props.index + 1))]):_vm._e()]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['name']))])]),_vm._v(" "),_c('td',[_c('span',{staticStyle:{"float":"left"}},[_c('b',{staticClass:"font-weight-bold info--text",attrs:{"title":props.item['openingQuantityTitle']}},[_vm._v(_vm._s(props.item['openingQuantity']))])]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item['openingBalance'] || 0)))])])]),_vm._v(" "),_c('td',[_c('span',{staticStyle:{"float":"left"}},[_c('b',{staticClass:"font-weight-bold primary--text",attrs:{"title":props.item['purchaseQuantityTitle']}},[_vm._v(_vm._s(props.item['durationQtyPurchase']))])]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_c('b',[_vm._v(" "+_vm._s(_vm._f("amount")(props.item['durationAmountPurchase'] || 0)))])])]),_vm._v(" "),_c('td',[_c('span',{staticStyle:{"float":"left"}},[_c('b',{staticClass:"font-weight-bold green--text",attrs:{"title":props.item['saleQuantityTitle']}},[_vm._v(_vm._s(props.item['durationQtySale']))])]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_c('b',[_vm._v(" "+_vm._s(_vm._f("amount")(props.item['durationAmountSale'] || 0)))])])]),_vm._v(" "),_c('td',[_c('span',{staticStyle:{"float":"left"}},[_c('b',{staticClass:"font-weight-bold red--text",attrs:{"title":props.item['closingQuantityTitle']}},[_vm._v(_vm._s(props.item['closingQuantity']))])]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item['closingAmount']|| 0)))])])])]}}],null,false,2753599260)},[_vm._v(" "),_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2):_vm._e(),_vm._v(" "),(['sale','purchase'].indexOf(_vm.reportType) > -1)?_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.filteredInvoices},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left nowrap"},[_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.openProd(props.item)}}},[_vm._v("remove_red_eye")])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(new Date(props.item.date).toLocaleDateString('en-GB') || '-'))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.buyerName || '-'))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('b',[_vm._v(_vm._s(props.item.invoiceId || '-'))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',{staticClass:"font-weight-bold success--text"},[_vm._v(_vm._s(_vm._f("amount")(props.item.totalAmount || 0)))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(props.item.totalAmount) - Number.parseFloat(props.item.GSTTotal) || 0)))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item.GSTTotal || 0)))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item.discountAmount || 0)))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('b',{staticClass:"font-weight-bold primary--text"},[_vm._v(_vm._s(_vm._f("amount")(props.item.paidAmount || 0)))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('b',{staticClass:"font-weight-bold error--text"},[_vm._v(_vm._s(_vm._f("amount")(props.item.remainingAmount || 0)))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.duration || '-'))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.daysLeft || '-'))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.paymentType || '-'))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.status || '-'))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.gstType || '-'))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.mobile || '-'))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.tehsil || '-'))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.district || '-'))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.state || '-'))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.firmName || '-'))])])]}}],null,false,4132519059)}):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":""},model:{value:(_vm.prodListDialog),callback:function ($$v) {_vm.prodListDialog=$$v},expression:"prodListDialog"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[(_vm.selectedProduct)?_c('v-toolbar-title',[_c('b',[_vm._v(_vm._s(_vm.selectedProduct['name']))]),_vm._v("        \n              "),(_vm.selectedProduct['description'])?[_vm._v("\n                Desc : "+_vm._s(_vm.selectedProduct['description'])+"       \n              ")]:_vm._e(),_vm._v(" "),(_vm.selectedProduct['HSN_code'])?[_vm._v("\n                HSN : "+_vm._s(_vm.selectedProduct['HSN_code'])+"        \n              ")]:_vm._e(),_vm._v(" "),(_vm.selectedProduct['GST_type'])?[_vm._v("\n                GST Category : "+_vm._s(_vm.selectedProduct['GST_type'])+"        \n              ")]:_vm._e(),_vm._v(" "),(_vm.selectedProduct['taxableGST_rate'])?[_vm._v("\n                Rate : "+_vm._s(_vm.selectedProduct['taxableGST_rate'])+"        \n              ")]:_vm._e(),_vm._v(" "),(_vm.selectedProduct['unit'])?[_vm._v("\n                Unit : "+_vm._s(_vm.selectedProduct['unit'])+" \n              ")]:_vm._e()],2):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.prodListDialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),(Object.keys(_vm.filters).length)?_c('div',{staticStyle:{"padding":"15px 20px 0px 20px"}},[_vm._v("\n          Active Filters:\n          "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.date.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("From Date : "+_vm._s(new Date(_vm.filters.date.model).toLocaleDateString('en-GB')))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.tillDate.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("Till Date : "+_vm._s(new Date(_vm.filters.tillDate.model).toLocaleDateString('en-GB')))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.month.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("Month : "+_vm._s(_vm.filters.month.model+1))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.duration.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("Duration : "+_vm._s(_vm.filters.duration.model))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.firms.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("Firm : "+_vm._s(_vm.filters.firms.model))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.gstType.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("GST Type : "+_vm._s(_vm.filters.gstType.model))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.paymentType.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("Payment Type : "+_vm._s(_vm.filters.paymentType.model))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.status && _vm.filters.status.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("Status : "+_vm._s(_vm.filters.status.model))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.invoiceNumber.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("Invoice Number : "+_vm._s(_vm.filters.invoiceNumber.model))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.buyerName.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("Buyer Name : "+_vm._s(_vm.filters.buyerName.model))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.gstPercentage.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("GST Percentage : "+_vm._s(_vm.filters.gstPercentage.model))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.isActive.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("Product Status : "+_vm._s(_vm.filters.isActive.model))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.gstCategory.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("GST Category : "+_vm._s(_vm.filters.gstCategory.model))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.hsnCode.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("HSN : "+_vm._s(_vm.filters.hsnCode.model))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.unit.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("UNIT : "+_vm._s(_vm.filters.unit.model))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.quantity.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("Quantity : "+_vm._s(_vm.filters.quantity.model))]):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.productItemListHeader,"items":_vm.selectProdList},scopedSlots:_vm._u([{key:"headers",fn:function(props){return [_c('tr',[_c('th',[_vm._v("Invoice")]),_vm._v(" "),_c('th',[_vm._v("Date")]),_vm._v(" "),_c('th',[_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v("Opening Stock")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(_vm.filters.stockReportType.model == 'quantity' ? 'Quantity' : 'Weight'))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_vm._v("Amount")])]),_vm._v(" "),_c('th',[_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v("Purchase ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(_vm.filters.stockReportType.model == 'quantity' ? 'Quantity' : 'Weight'))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_vm._v("Amount")])]),_vm._v(" "),_c('th',[_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v("Sale ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(_vm.filters.stockReportType.model == 'quantity' ? 'Quantity' : 'Weight'))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_vm._v("Amount")])]),_vm._v(" "),_c('th',[_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v("Closing stock")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"float":"left"}},[_vm._v(_vm._s(_vm.filters.stockReportType.model == 'quantity' ? 'Quantity' : 'Weight'))]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_vm._v("Amount")])])])]}},{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left nowrap"},[(props.item['date'] != 'Total' && props.item['type'] != 'menufacture' && props.item['type'] != 'damage' && props.item['type'] != 'replace')?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.openProdInvoice(props.item)}}},[_vm._v("remove_red_eye")]):_vm._e(),_vm._v(" "),(props.item['type'] == 'menufacture')?_c('b',[_vm._v("MANUFACTURED")]):_vm._e(),_vm._v(" "),(props.item['type'] == 'damage')?_c('b',[_vm._v("DAMAGED")]):_vm._e(),_vm._v(" "),(props.item['type'] == 'replace')?_c('b',[_vm._v("REPLACED")]):_vm._e()],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[(props.item['date'] != 'Total')?_c('b',[_vm._v(_vm._s(new Date(props.item.date).toLocaleDateString('en-GB') || '-'))]):_c('b',[_vm._v(_vm._s(props.item['date']))])]),_vm._v(" "),_c('td',[_c('span',{staticStyle:{"float":"left"}},[_c('b',{staticClass:"font-weight-bold info--text"},[_vm._v(_vm._s(props.item['openingQuantity']))])]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item['openingBalance'] || 0)))])])]),_vm._v(" "),_c('td',[_c('span',{staticStyle:{"float":"left"}},[_c('b',{staticClass:"font-weight-bold green--text"},[_vm._v(_vm._s(props.item['quantityPurchase']))])]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_c('b',[_vm._v(" "+_vm._s(_vm._f("amount")(props.item['balancePurchase'] || 0)))])])]),_vm._v(" "),_c('td',[_c('span',{staticStyle:{"float":"left"}},[_c('b',{staticClass:"font-weight-bold primary--text"},[_vm._v(_vm._s(props.item['quantitySale']))])]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_c('b',[_vm._v(" "+_vm._s(_vm._f("amount")(props.item['balanceSale'] || 0)))])])]),_vm._v(" "),_c('td',[_c('span',{staticStyle:{"float":"left"}},[_c('b',{staticClass:"font-weight-bold red--text"},[_vm._v(_vm._s(props.item['quantityClosing']))])]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_c('b',[_vm._v(" "+_vm._s(_vm._f("amount")(props.item['balanceCloseing'] || 0)))])])])]}}])},[_vm._v(" "),_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"800","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline primary--text",attrs:{"primary-title":""}},[_vm._v("\n          Product List\n          "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("mdi-close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.invoiceProductListHeader,"items":_vm.selectedInvoice.items},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',[_vm._v(_vm._s(props.item['productName']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['HSN_code']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['rate']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.taxableGST_rate))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['productUnit']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['quantity']))])])]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("Close")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialogInvoice),callback:function ($$v) {_vm.dialogInvoice=$$v},expression:"dialogInvoice"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("\n              Invoices List\n            ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialogInvoice = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),(Object.keys(_vm.filters).length)?_c('div',{staticStyle:{"padding":"15px 20px 0px 20px"}},[_vm._v("\n          Active Filters:\n          "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.date.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("From Date : "+_vm._s(new Date(_vm.filters.date.model).toLocaleDateString('en-GB')))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.tillDate.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("Till Date : "+_vm._s(new Date(_vm.filters.tillDate.model).toLocaleDateString('en-GB')))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.month.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("Month : "+_vm._s(_vm.filters.month.model+1))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.duration.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("Duration : "+_vm._s(_vm.filters.duration.model))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.firms.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("Firm : "+_vm._s(_vm.filters.firms.model))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.gstType.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("GST Type : "+_vm._s(_vm.filters.gstType.model))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.paymentType.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("Payment Type : "+_vm._s(_vm.filters.paymentType.model))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.status && _vm.filters.status.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("Status : "+_vm._s(_vm.filters.status.model))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.invoiceNumber.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("Invoice Number : "+_vm._s(_vm.filters.invoiceNumber.model))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.buyerName.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("Buyer Name : "+_vm._s(_vm.filters.buyerName.model))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.gstPercentage.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("GST Percentage : "+_vm._s(_vm.filters.gstPercentage.model))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.isActive.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("Product Status : "+_vm._s(_vm.filters.isActive.model))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.gstCategory.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("GST Category : "+_vm._s(_vm.filters.gstCategory.model))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.hsnCode.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("HSN : "+_vm._s(_vm.filters.hsnCode.model))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.unit.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("UNIT : "+_vm._s(_vm.filters.unit.model))]):_vm._e()],1),_vm._v(" "),_c('v-row',{attrs:{"justify":"center","align":"center"}},[(_vm.filters.quantity.model)?_c('v-chip',{attrs:{"ripple":false}},[_vm._v("Quantity : "+_vm._s(_vm.filters.quantity.model))]):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.selectedProdInvoices},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left nowrap"},[_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.openProd(props.item)}}},[_vm._v("remove_red_eye")])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap primary--text font-weight-bold",domProps:{"innerHTML":_vm._s(_vm.renderDate(props.item.date))}}),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(_vm.getCustomerName(props.item.buyerId)|| '-'))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('b',[_vm._v(_vm._s(props.item.invoiceId || '-'))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item.totalAmount || 0)))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(props.item.totalAmount) - Number.parseFloat(props.item.GSTTotal) || 0)))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(props.item.GSTTotal) || 0)))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item.discountAmount || 0)))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('b',[_vm._v(_vm._s(props.item.paidAmount || '-'))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('b',[_vm._v(_vm._s(props.item.remainingAmount || '-'))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.duration || '-'))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.daysLeft || '-'))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.paymentType || '-'))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.status|| '-'))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.gstType || '-'))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.mobile || '-'))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.tehsil || '-'))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.district || '-'))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.state || '-'))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.firmName || '-'))])])]}}])})],1),_vm._v(" "),_c('v-divider')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('filters',{attrs:{"reportType":_vm.reportType,"units":_vm.productUnit,"selectedBrand":_vm.selectedBrand},on:{"resetTabs":_vm.resetTabs,"update":_vm.updateFilters}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs9":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary-title":""}},[_c('h3',{attrs:{"color":"primary"}},[_vm._v("RECORDS")])]),_vm._v(" "),_c('v-card-text',[_c('v-tabs',{attrs:{"background-color":"transparent","color":"basil","fixed-tabs":"","grow":""},model:{value:(_vm.reportTab),callback:function ($$v) {_vm.reportTab=$$v},expression:"reportTab"}},_vm._l((['Sale Report','Purchase Report','Stock Report','Product Group Report']),function(item){return _c('v-tab',{key:item},[_vm._v(_vm._s(item)+"\n                ")])}),1),_vm._v(" "),_c('v-tabs-items',[_c('v-tab-item',[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('grid-view',{attrs:{"filters":_vm.filters,"reportType":_vm.reportType,"selectedClosingStockType":_vm.getDefaultStockReportType}})],1)],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(442);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41440011_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1362);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41440011_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary-title":""}},[_c('h3',{attrs:{"color":"primary"}},[_vm._v("Monthly Reports")])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-expansion-panel',_vm._l((_vm.filters),function(item,i){return _c('v-expansion-panel-content',{key:i+'monF'},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('v-card',[(item.type=='select')?_c('v-card-text',[_c('v-select',{attrs:{"items":item.options,"label":item.placeholder},model:{value:(item.model),callback:function ($$v) {_vm.$set(item, "model", $$v)},expression:"item.model"}})],1):(item.type=='search')?_c('v-card-text',[_c('v-autocomplete',{staticClass:"mx-3",attrs:{"items":item.options,"search-input":item.input,"flat":"","hide-no-data":"","hide-details":"","label":item.placeholder,"solo-inverted":"","clearable":""},on:{"update:searchInput":function($event){return _vm.$set(item, "input", $event)},"update:search-input":function($event){return _vm.$set(item, "input", $event)}},model:{value:(item.model),callback:function ($$v) {_vm.$set(item, "model", $$v)},expression:"item.model"}})],1):(item.type=='number-range')?_c('v-card-text',[_c('v-slider',{attrs:{"thumb-label":"","label":item.label,"min":item.min,"max":item.max,"range":""},model:{value:(item.model),callback:function ($$v) {_vm.$set(item, "model", $$v)},expression:"item.model"}})],1):(item.type=='date-range')?_c('v-card-text',[_c('v-menu',{ref:"menu",refInFor:true,attrs:{"close-on-content-click":false,"nudge-right":40,"return-value":item.start,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},on:{"update:returnValue":function($event){return _vm.$set(item, "start", $event)},"update:return-value":function($event){return _vm.$set(item, "start", $event)}},model:{value:(item.menu),callback:function ($$v) {_vm.$set(item, "menu", $$v)},expression:"item.menu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Pick a Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(item.model),callback:function ($$v) {_vm.$set(item, "model", $$v)},expression:"item.model"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":"","scrollable":""},on:{"input":function($event){item.menu = false}},model:{value:(item.model),callback:function ($$v) {_vm.$set(item, "model", $$v)},expression:"item.model"}})],1)],1):_vm._e()],1)],1)}),1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md9":""}},[_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.productListHeader,"items":_vm.filteredProduct},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',[_vm._v(_vm._s(props.item['.key']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['name']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['description']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['HSN_code']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['GST_type']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.taxableGST_rate))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['unit']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['quantity']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['openingQuantity']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['monthlyQuantity']))])])]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(443);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69c04d97_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1364);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69c04d97_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","align":"center"}},[_c('v-flex',{staticClass:"d-flex",attrs:{"cols":"24","sm":"24"}},[_c('v-data-iterator',{attrs:{"items":_vm.processedItems,"content-tag":"v-layout","hide-actions":""},scopedSlots:_vm._u([{key:"item",fn:function(props){return [_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('h2',[_vm._v(_vm._s(props.item.name))])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((props.item.values),function(item){return _c('v-list-tile',{key:item.key},[_c('v-list-tile-content',[_c('h2',[_vm._v(_vm._s(item.key)+":")])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_c('h2',[_vm._v(_vm._s(item.value))])])],1)}),1)],1)],1)]}}])})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(444);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5019cc24_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1390);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5019cc24_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expense_vue__ = __webpack_require__(445);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fe0d54d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_expense_vue__ = __webpack_require__(1370);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expense_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3fe0d54d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_expense_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expenseTable_vue__ = __webpack_require__(446);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_381dacc6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_expenseTable_vue__ = __webpack_require__(1369);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expenseTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_381dacc6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_expenseTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return expenseOverallReport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);




var _this = this;

var expenseOverallReport = function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
        var firm = _ref2.firm,
            list = _ref2.list;
        var pdfDoc, total, taxable;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        pdfDoc = {
                            // pageOrientation: 'landscape',
                            content: [{
                                table: {
                                    widths: ['30%', '70%'],
                                    body: [[{
                                        text: 'EXPENSE OVERALL REPORT ', style: 'schoolColorHeader2'
                                    }, {
                                        text: [{ text: '          ', bold: true, style: 'schoolColorHeader' }, { text: '\n', style: 'schoolColorHeader' }]
                                    }]]

                                },
                                layout: {
                                    hLineWidth: function hLineWidth(i, node) {
                                        return i === 0 || i === node.table.body.length ? 2 : 0;
                                    },
                                    vLineWidth: function vLineWidth(i, node) {
                                        return i === 0 || i === node.table.widths.length ? 2 : 0;
                                    },
                                    hLineColor: function hLineColor(i, node) {
                                        return i === 0 || i === node.table.body.length ? 'black' : 'white';
                                    },
                                    vLineColor: function vLineColor(i, node) {
                                        return i === 0 || i === node.table.widths.length ? 'black' : 'white';
                                    }
                                }
                            }, {
                                table: {
                                    headerRows: 1,
                                    widths: ['10%', "*", '20%', '20%'],
                                    body: [[{ text: 'S.No.', style: "schoolColorHeader1" }, { text: 'Particulars', style: "schoolColorHeader1" }, { text: 'Taxable', style: "schoolColorHeader1" }, { text: 'Total', style: "schoolColorHeader1" }]]
                                }
                            }, {
                                table: {
                                    widths: ['33%', '34%', '33%'],
                                    body: [[{
                                        text: [{ text: '\n\n\n\n' }, { text: 'OFFICE INCHARGE ', bold: true, alignment: 'center', style: 'colorHeader' }, { text: '\n' }]
                                    }, {
                                        text: [{ text: '\n\n\n\n' }, { text: 'AUTHORITY SIGNATURE  ', bold: true, alignment: 'center', style: 'colorHeader' }, { text: '\n' }]
                                    }, {
                                        text: [{ text: '\n\n\n\n' }, { text: 'PRINCIPAL SIGNATURE  ', bold: true, alignment: 'center', style: 'colorHeader' }, { text: '\n' }]
                                    }]]

                                },
                                layout: {
                                    hLineWidth: function hLineWidth(i, node) {
                                        return i === 0 || i === node.table.body.length ? 2 : 0;
                                    },
                                    vLineWidth: function vLineWidth(i, node) {
                                        return i === 0 || i === node.table.widths.length ? 2 : 0;
                                    },
                                    hLineColor: function hLineColor(i, node) {
                                        return i === 0 || i === node.table.body.length ? 'black' : 'white';
                                    },
                                    vLineColor: function vLineColor(i, node) {
                                        return i === 0 || i === node.table.widths.length ? 'black' : 'white';
                                    }
                                }
                            }],
                            styles: {
                                feeHeader: {
                                    fontSize: 10,
                                    alignment: 'center'
                                },
                                feeTableHeader: {
                                    fontSize: 10,
                                    alignment: 'center',
                                    fillColor: '#1A237E',
                                    color: '#ffffff',
                                    bold: true
                                },
                                feeDescriptiveHeader: {
                                    fontSize: 10,
                                    alignment: 'left',
                                    bold: true
                                },
                                feeDescriptiveHeader1: {
                                    fontSize: 10,
                                    alignment: 'center',
                                    bold: true
                                },
                                topHeader: {
                                    color: '#ffffff',
                                    fontSize: 11,
                                    alignment: 'left',
                                    bold: true,
                                    fillColor: '#1A237E'
                                },
                                thankyouHeader: {
                                    color: '#ffffff',
                                    fontSize: 11,
                                    alignment: 'center',
                                    bold: true,
                                    fillColor: '#1A237E'
                                },
                                upcomingFeeHeader: {
                                    color: '#ffffff',
                                    fontSize: 11,
                                    alignment: 'left',
                                    bold: true,
                                    fillColor: '#1A237E'
                                },
                                colorHeader: {
                                    color: '#1A237E',
                                    fontSize: 12,
                                    bold: true
                                },
                                schoolColorHeader: {
                                    color: '#1A237E',
                                    fontSize: 14,
                                    bold: true,
                                    alignment: 'right'
                                },
                                schoolColorHeader1: {
                                    color: '#1A237E',
                                    fontSize: 9,
                                    bold: true,
                                    alignment: 'center'
                                },
                                schoolColorHeader2: {
                                    color: '#1A237E',
                                    fontSize: 14,
                                    bold: true,
                                    alignment: 'left'
                                },
                                studentDetails: {
                                    fontSize: 9,
                                    bold: true
                                },
                                studentDetailsRight: {
                                    fontSize: 9,
                                    bold: true
                                },
                                studentIncreaseFontDetails: {
                                    fontSize: 12,
                                    bold: true
                                },
                                studentIncreaseFontAmountDetails: {
                                    fontSize: 12,
                                    bold: true,
                                    color: '#1A237E'
                                },
                                studentBlankDetails: {
                                    fontSize: 20,
                                    bold: true,
                                    color: '#ffffff'
                                },
                                schoolDetails: {
                                    fontSize: 10,
                                    bold: true,
                                    alignment: 'right'
                                },
                                thankyouMsg: {
                                    color: '#1A237E',
                                    fontSize: 12,
                                    bold: true,
                                    alignment: 'center'
                                }
                            }

                            //school details

                        };
                        if (firm) {
                            pdfDoc.content[0].table.body[0][1].text[1].text = 'BMJ'.toUpperCase() + '\n';
                            // pdfDoc.content[0].table.body[0][1].text[3].text = (school.address || '') + '\n';
                            // pdfDoc.content[0].table.body[0][1].text[5].text = (school.boardAffiliationNumber || '') + '\n';
                            // pdfDoc.content[0].table.body[0][1].text[7].text = (school.schoolCode || '') + '\n';
                            // pdfDoc.content[0].table.body[0][1].text[9].text = (school.mobile || '') + '\n';
                        }

                        // pdfDoc.content[0].table.body[0][0].text += `[${selectedExpense}]`


                        total = 0;
                        taxable = 0;

                        list.map(function (pro, index) {
                            total += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(pro.totalAmount);
                            taxable += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(pro.taxableAmount);
                            var temp = [{ text: index + 1, style: 'studentDetails' },
                            // { text:  new Date(pro.date).toLocaleDateString("en-GB"), style: 'studentDetails' },
                            { text: pro.expense, style: 'studentDetailsRight' }, { text: pro.taxableAmount, style: 'studentDetails' }, { text: pro.totalAmount, style: 'studentDetails' }];

                            pdfDoc.content[1].table.body.push(temp);
                        });
                        pdfDoc.content[1].table.body.push([{ text: " ", style: "studentDetails" }, { text: "Total", style: "studentDetails" }, { text: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(taxable).toFixed(2), style: "studentDetailsRight" }, { text: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(total).toFixed(2), style: "studentDetailsRight" }]);
                        return _context.abrupt('return', pdfDoc);

                    case 7:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this);
    }));

    return function expenseOverallReport(_x) {
        return _ref.apply(this, arguments);
    };
}();

/***/ }),
/* 1369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"mt-4",nativeOn:{"click":function($event){return _vm.printOverallExpense($event)}}},[_c('v-icon',[_vm._v("print")])],1),_vm._v(" "),_c('v-switch',{staticClass:"mb-2",attrs:{"inset":"","label":"Major Expenses"},model:{value:(_vm.hideZero),callback:function ($$v) {_vm.hideZero=$$v},expression:"hideZero"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 black--text font-weight-bold",attrs:{"items":_vm.list,"headers":_vm.headers},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',{staticClass:"primary--text font-weight-bolder"},[_vm._v(_vm._s(props.item.expense)+" ")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.category))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.underHead))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(props.item.openingBalance)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.taxableAmount ? props.item.taxableAmount : 0))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(props.item.totalAmount)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(((props.item.openingBalance ? Number.parseFloat(props.item.openingBalance) : 0 ) + (props.item.totalAmount ? Number.parseFloat(props.item.totalAmount) : 0)))))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.paymentTypeStatus))]),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"primary--text",attrs:{"icon":"","round":""},on:{"click":function($event){return _vm.openExpenseDialog(props.item)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n          remove_red_eye\n        ")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"primary--text",attrs:{"icon":"","round":""},on:{"click":function($event){return _vm.openExpenseEdit(props.item)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v(" \n          edit \n        ")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No expenses to Show")])],2),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.selectedExpense))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 black--text font-weight-bold",attrs:{"items":_vm.selectedExpenses,"headers":_vm.expenseHeader},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.getFirmName(props.item.firm))+"  - "+_vm._s(props.item.taxableGST_rate)+" - "+_vm._s(props.item.GST_type)+" ")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(new Date(props.item.date).toLocaleDateString('en-GB')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(props.item.openingBalance || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(props.item.taxableAmount || 0)))]),_vm._v(" "),_c('td',[_c('b',{staticClass:"error--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item.totalAmount || 0)))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.getTotalAmount(props.item)|| 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(((props.item.openingBalance ?  props.item.totalAmount : 0 ) + (props.item.totalAmount ? props.item.totalAmount : 0) ) || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.paymentType))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.remark))]),_vm._v(" "),_c('td',[( props.item.paymentTypeStatus == 'yet to confirm')?_c('v-btn',{on:{"click":function($event){return _vm.openExpenseInvoiceEdit(props.item,true)}}},[_vm._v(_vm._s(props.item.paymentTypeStatus))]):_c('b',[_vm._v(_vm._s(props.item.paymentTypeStatus))])],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"primary--text",attrs:{"icon":""},on:{"click":function($event){return _vm.openExpenseInvoiceEdit(props.item,false)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n              edit\n            ")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"red--text",attrs:{"icon":""},on:{"click":function($event){return _vm.openExpenseInvoiceDelete(props.item)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n              delete\n            ")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("no record found")])],2)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialogEdit),callback:function ($$v) {_vm.dialogEdit=$$v},expression:"dialogEdit"}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[(_vm.selectedExpense)?_c('v-toolbar-title',[_vm._v(_vm._s(_vm.selectedExpense.expense))]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogEdit = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),(_vm.selectedExpense)?_c('v-card',{attrs:{"tile":""}},[_c('v-card-text',[_c('v-text-field',{attrs:{"label":"Name"},model:{value:(_vm.selectedExpense.expense),callback:function ($$v) {_vm.$set(_vm.selectedExpense, "expense", $$v)},expression:"selectedExpense.expense"}}),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.categotyList,"label":"Expense Category"},model:{value:(_vm.selectedExpense.category),callback:function ($$v) {_vm.$set(_vm.selectedExpense, "category", $$v)},expression:"selectedExpense.category"}}),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.underHeadList,"label":"UnderHead"},model:{value:(_vm.selectedExpense.underHead),callback:function ($$v) {_vm.$set(_vm.selectedExpense, "underHead", $$v)},expression:"selectedExpense.underHead"}}),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.saveExpense()}}},[_vm._v("Save")])],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialogEditInvoice),callback:function ($$v) {_vm.dialogEditInvoice=$$v},expression:"dialogEditInvoice"}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[(_vm.isConfirm)?_c('v-toolbar-title',[_vm._v("Confirm Expense")]):_c('v-toolbar-title',[_vm._v("Edit Expense")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogEditInvoice = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),(_vm.selectedExpenseInvoice)?_c('v-card',{attrs:{"tile":""}},[_c('v-card-text',[_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.selectedExpenseInvoice.paymentType),callback:function ($$v) {_vm.$set(_vm.selectedExpenseInvoice, "paymentType", $$v)},expression:"selectedExpenseInvoice.paymentType"}},[_c('v-radio',{attrs:{"label":"From Cash","value":"cash"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"From Bank Account","value":"account"}})],1),_vm._v(" "),_c('v-menu',{attrs:{"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker),callback:function ($$v) {_vm.datepicker=$$v},expression:"datepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.selectedExpenseInvoice.date),callback:function ($$v) {_vm.$set(_vm.selectedExpenseInvoice, "date", $$v)},expression:"selectedExpenseInvoice.date"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepicker = false}},model:{value:(_vm.selectedExpenseInvoice.date),callback:function ($$v) {_vm.$set(_vm.selectedExpenseInvoice, "date", $$v)},expression:"selectedExpenseInvoice.date"}})],1),_vm._v(" "),_c('v-select',{staticClass:"select-firm",attrs:{"items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.selectedExpenseInvoice.firm),callback:function ($$v) {_vm.$set(_vm.selectedExpenseInvoice, "firm", $$v)},expression:"selectedExpenseInvoice.firm"}}),_vm._v(" "),(_vm.selectedExpenseInvoice.paymentType == 'account')?_c('v-select',{attrs:{"items":_vm.banksByFirm,"label":"From Account","disabled":!_vm.selectedExpenseInvoice.firm,"required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                  "+_vm._s(data.item.accountnumber)+_vm._s(data.item.bankName ? ' | '+data.item.bankName : '')+"\n              ")]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(((data.item.accountnumber) + "\n                          " + (data.item.bankName ? ' | '+data.item.bankName : '') + "\n                          " + (data.item.accountType ? ' | '+data.item.accountType : ''))
                      )}})],1)]}}],null,false,855933585),model:{value:(_vm.selectAccountFromExpense),callback:function ($$v) {_vm.selectAccountFromExpense=$$v},expression:"selectAccountFromExpense"}}):_vm._e(),_vm._v(" "),_c('v-text-field',{attrs:{"type":"number","label":"Opening Balance"},model:{value:(_vm.selectedExpenseInvoice.openingBalance),callback:function ($$v) {_vm.$set(_vm.selectedExpenseInvoice, "openingBalance", $$v)},expression:"selectedExpenseInvoice.openingBalance"}}),_vm._v(" "),(_vm.isConfirm)?_c('v-text-field',{attrs:{"value":_vm.selectedExpense,"label":"Expense","disabled":true}}):_vm._e(),_vm._v(" "),_c('v-text-field',{attrs:{"type":"number","label":"Amount"},model:{value:(_vm.selectedExpenseInvoice.totalAmount),callback:function ($$v) {_vm.$set(_vm.selectedExpenseInvoice, "totalAmount", $$v)},expression:"selectedExpenseInvoice.totalAmount"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Remark"},model:{value:(_vm.selectedExpenseInvoice.remark),callback:function ($$v) {_vm.$set(_vm.selectedExpenseInvoice, "remark", $$v)},expression:"selectedExpenseInvoice.remark"}}),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.saveExpenseInvoice()}}},[(_vm.isConfirm)?_c('span',[_vm._v("Confirm")]):_c('span',[_vm._v("Save")])])],1)],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-5",attrs:{"flat":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker),callback:function ($$v) {_vm.datepicker=$$v},expression:"datepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.expenseInvoiceDate),callback:function ($$v) {_vm.expenseInvoiceDate=$$v},expression:"expenseInvoiceDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepicker = false}},model:{value:(_vm.expenseInvoiceDate),callback:function ($$v) {_vm.expenseInvoiceDate=$$v},expression:"expenseInvoiceDate"}})],1),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.firmsByBrand,"label":"From Firm","item-value":"value","required":""},model:{value:(_vm.selectedFirmFromExpense),callback:function ($$v) {_vm.selectedFirmFromExpense=$$v},expression:"selectedFirmFromExpense"}}),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.expenseByBrand,"label":"Select or add Expense","autocomplete":""},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addExpense($event)}},model:{value:(_vm.selectExpense),callback:function ($$v) {_vm.selectExpense=$$v},expression:"selectExpense"}}),_vm._v(" "),(_vm.addError)?_c('span',{staticClass:"error--text"},[_vm._v(_vm._s(_vm.addError))]):_vm._e(),_vm._v(" "),(_vm.selectExpense)?_c('v-select',{attrs:{"disabled":!!_vm.selectedExpenseType.category,"items":_vm.categotyList,"label":"Select Expense Category"},model:{value:(_vm.expenseCategory),callback:function ($$v) {_vm.expenseCategory=$$v},expression:"expenseCategory"}}):_vm._e(),_vm._v(" "),(_vm.selectExpense && _vm.expenseCategory)?_c('v-select',{attrs:{"disabled":!!_vm.selectedExpenseType.underHead,"items":_vm.underHeadList,"label":"Select UnderHead"},model:{value:(_vm.expenseUnderHead),callback:function ($$v) {_vm.expenseUnderHead=$$v},expression:"expenseUnderHead"}}):_vm._e(),_vm._v(" "),((_vm.selectExpense && _vm.selectedFirm && _vm.selectedFirm.firm['GST_user'] != 'No') && (!_vm.firmExpense.length || !(_vm.firmExpense.length && _vm.firmExpense[0] && _vm.firmExpense[0].isGSTApplicable != false)))?_c('div',[_c('b',{staticClass:"subheading primary--text font-weight-bold"},[_vm._v(" IS GST Applicable Over this Expense? ")])]):_vm._e(),_vm._v(" "),((_vm.selectExpense && _vm.selectedFirm && _vm.selectedFirm.firm['GST_user'] != 'No') && (!_vm.firmExpense.length || !(_vm.firmExpense.length && _vm.firmExpense[0] && _vm.firmExpense[0].isGSTApplicable != false)))?_c('v-radio-group',{attrs:{"row":"","disabled":!!(_vm.firmExpense.length && _vm.firmExpense[0] && _vm.selectExpense)},model:{value:(_vm.isGSTApplicable),callback:function ($$v) {_vm.isGSTApplicable=$$v},expression:"isGSTApplicable"}},[_c('v-radio',{attrs:{"label":"Yes","value":true}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"No","value":false}})],1):_vm._e(),_vm._v(" "),(_vm.isGSTApplicable && _vm.selectExpense)?_c('v-select',{attrs:{"dense":"","items":[3,5,12,18,28],"disabled":!!(_vm.firmExpense.length && _vm.firmExpense[0] && _vm.taxableGST_rate),"label":"Taxable GST rate"},model:{value:(_vm.taxableGST_rate),callback:function ($$v) {_vm.taxableGST_rate=$$v},expression:"taxableGST_rate"}}):_vm._e(),_vm._v(" "),(_vm.isGSTApplicable && _vm.selectExpense)?_c('v-select',{attrs:{"dense":"","items":_vm.GST_types_list,"disabled":!!(_vm.firmExpense.length && _vm.firmExpense[0] && _vm.GST_type),"label":"Select GST type"},model:{value:(_vm.GST_type),callback:function ($$v) {_vm.GST_type=$$v},expression:"GST_type"}}):_vm._e(),_vm._v(" "),(_vm.isGSTApplicable && _vm.selectExpense)?_c('div',[_c('b',{staticClass:"subheading primary--text font-weight-bold"},[_vm._v("Does RCM Applicable ? ")])]):_vm._e(),_vm._v(" "),(_vm.isGSTApplicable && _vm.selectExpense)?_c('v-radio-group',{attrs:{"row":"","disabled":!!(_vm.firmExpense.length && _vm.firmExpense[0] && _vm.isRCMApplicable != null)},model:{value:(_vm.isRCMApplicable),callback:function ($$v) {_vm.isRCMApplicable=$$v},expression:"isRCMApplicable"}},[_c('v-radio',{attrs:{"label":"Yes","value":true}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"No","value":false}})],1):_vm._e(),_vm._v(" "),(_vm.selectExpense && _vm.expenseCategory && _vm.expenseUnderHead && (!_vm.firmExpense.length) && !_vm.selectedFirmOpeningBalance)?_c('div',[_c('b',{staticClass:"subheading primary--text font-weight-bold"},[_vm._v(" Is Opening Balance Available For ")])]):_vm._e(),_vm._v(" "),(_vm.selectExpense && _vm.expenseCategory && _vm.expenseUnderHead && (!_vm.firmExpense.length))?_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.isOpeningBalance),callback:function ($$v) {_vm.isOpeningBalance=$$v},expression:"isOpeningBalance"}},[_c('v-radio',{attrs:{"label":"Yes","value":true}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"No","value":false}})],1):_vm._e(),_vm._v(" "),((_vm.selectExpense && _vm.expenseCategory && _vm.expenseUnderHead && _vm.isOpeningBalance && !_vm.firmExpense.length) && !_vm.selectedFirmOpeningBalance)?_c('v-text-field',{attrs:{"type":"number","label":"Opening Balance"},model:{value:(_vm.expenseOpeningBalance),callback:function ($$v) {_vm.expenseOpeningBalance=$$v},expression:"expenseOpeningBalance"}}):_vm._e(),_vm._v(" "),(_vm.selectExpense && _vm.expenseCategory  && _vm.expenseOpeningBalance && _vm.isOpeningBalance)?_c('b',{staticClass:"subheading primary--text font-weight-bold"},[_vm._v(" Payment Type ")]):_vm._e(),_vm._v(" "),(_vm.selectExpense && _vm.expenseCategory  && _vm.expenseOpeningBalance && _vm.isOpeningBalance)?_c('v-radio-group',{attrs:{"mandatory":false,"row":""},model:{value:(_vm.expenseVia),callback:function ($$v) {_vm.expenseVia=$$v},expression:"expenseVia"}},[_c('v-radio',{attrs:{"label":"From Provision","value":"provision"}})],1):_vm._e(),_vm._v(" "),(_vm.selectExpense && _vm.isGSTApplicable && !_vm.isOpeningBalance && _vm.isRCMApplicable !=null)?_c('v-text-field',{attrs:{"label":"Taxable Value","type":"number"},on:{"keyup":function($event){_vm.expenseAmount = (Number.parseFloat(_vm.taxableAmount) + Number.parseFloat((_vm.taxableAmount*_vm.taxableGST_rate)/100))}},model:{value:(_vm.taxableAmount),callback:function ($$v) {_vm.taxableAmount=$$v},expression:"taxableAmount"}}):_vm._e(),_vm._v(" "),(_vm.selectExpense && _vm.isGSTApplicable && !_vm.isOpeningBalance  && _vm.isRCMApplicable !=null)?_c('v-text-field',{attrs:{"label":"GST Value","value":((_vm.taxableAmount*_vm.taxableGST_rate)/100),"disabled":true}}):_vm._e(),_vm._v(" "),(_vm.selectExpense && _vm.expenseCategory && _vm.expenseUnderHead && !_vm.isOpeningBalance)?_c('v-text-field',{attrs:{"label":"Amount","hint":_vm.hintText,"required":""},model:{value:(_vm.expenseAmount),callback:function ($$v) {_vm.expenseAmount=$$v},expression:"expenseAmount"}}):_vm._e(),_vm._v(" "),(_vm.selectExpense && _vm.expenseCategory && _vm.expenseUnderHead && _vm.expenseAmount && !_vm.isOpeningBalance)?_c('b',{staticClass:"subheading primary--text font-weight-bold"},[_vm._v(" Payment Type ")]):_vm._e(),_vm._v(" "),(_vm.selectExpense && _vm.expenseCategory && _vm.expenseUnderHead && _vm.expenseAmount && !_vm.isOpeningBalance)?_c('v-radio-group',{attrs:{"mandatory":false,"row":""},model:{value:(_vm.expenseVia),callback:function ($$v) {_vm.expenseVia=$$v},expression:"expenseVia"}},[_c('v-radio',{attrs:{"label":"From Cash","value":"cash"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"From Bank Account","value":"account"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"From Provision","value":"provision"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"From Capital","value":"capital"}})],1):_vm._e(),_vm._v(" "),(_vm.expenseVia == 'account')?_c('v-select',{attrs:{"items":_vm.banksByFirm,"label":"From Account","disabled":!_vm.selectedFirmFromExpense,"required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                "+_vm._s(data.item.account.accountnumber)+_vm._s(data.item.account.bankName ? ' | '+data.item.account.bankName : '')+"\n            ")]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(((data.item.account.accountnumber) + "\n                        " + (data.item.account.bankName ? ' | '+data.item.account.bankName : '') + "\n                        " + (data.item.account.accountType ? ' | '+data.item.account.accountType : '') + "\n                        | ₹: " + ((data.item.account.amount || 0).toLocaleString()))
                    )}})],1)]}}],null,false,49996952),model:{value:(_vm.selectAccountFromExpense),callback:function ($$v) {_vm.selectAccountFromExpense=$$v},expression:"selectAccountFromExpense"}}):_vm._e(),_vm._v(" "),(_vm.selectExpense  && _vm.expenseCategory && _vm.expenseUnderHead && (_vm.expenseAmount || _vm.expenseOpeningBalance))?_c('v-text-field',{attrs:{"label":"Remark","disabled":!!_vm.selectedExpenseType.expenseRemark},model:{value:(_vm.expenseRemark),callback:function ($$v) {_vm.expenseRemark=$$v},expression:"expenseRemark"}}):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.expenseAmountClick}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("money_off")]),_vm._v("   Save\n        ")],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("cancel")]),_vm._v("   Cancel \n        ")],1),_vm._v(" "),_c('v-btn',{staticClass:"primary--text font-weight-bold",attrs:{"round":"","outline":""},on:{"click":function($event){_vm.openExpenseTable = true}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v(" remove_red_eye ")]),_vm._v(" \n                 Expense Table \n        ")],1),_vm._v(" "),_c('v-btn',{staticClass:"primary--text font-weight-bold",attrs:{"round":"","outline":""},on:{"click":function($event){_vm.openProvisionTable = true}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v(" remove_red_eye ")]),_vm._v(" \n                 Provision Table \n        ")],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullScreen":"","transition":"dialog-bottom-transition"},model:{value:(_vm.openExpenseTable),callback:function ($$v) {_vm.openExpenseTable=$$v},expression:"openExpenseTable"}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Expense Details")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.openExpenseTable = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card',[_c('Expense-table-info',{attrs:{"accountsByBrand":_vm.accountsByBrand,"firmsByBrand":_vm.firmsByBrand}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullScreen":"","transition":"dialog-bottom-transition"},model:{value:(_vm.openProvisionTable),callback:function ($$v) {_vm.openProvisionTable=$$v},expression:"openProvisionTable"}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{staticClass:"select-firm",attrs:{"items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.selectedFirmProvisionFilter),callback:function ($$v) {_vm.selectedFirmProvisionFilter=$$v},expression:"selectedFirmProvisionFilter"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('h3',[_c('p',{staticStyle:{"text-align":"center"}},[_c('v-toolbar-title',[_vm._v("Provision Details")])],1)])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.openProvisionTable = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card',[_c('v-data-table',{staticClass:"elevation",attrs:{"items":_vm.provisionByBrand,"headers":_vm.provisionHeader},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item['.key']))]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.getFirmName(props.item.firm)))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(new Date(props.item.date).toLocaleDateString('en-GB')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(props.item.openingBalance || 0)))]),_vm._v(" "),(!props.item['isCredited'])?_c('td',[_c('b',{staticClass:"success--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item.credit || 0)))])]):_c('td'),_vm._v(" "),(props.item['isCredited'])?_c('td',[_c('b',{staticClass:"error--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item.debit || 0)))])]):_c('td'),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item.RunningBal || 0)))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(((props.item.openingBalance ?  props.item.totalAmount : 0 ) + (props.item.totalAmount ? props.item.totalAmount : 0) ) || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.paymentType))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.remark))]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.paymentTypeStatus || "yet to confirm/confirm"))])])]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("no record found")])],2)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_income_vue__ = __webpack_require__(447);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e14b9e6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_income_vue__ = __webpack_require__(1375);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_income_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e14b9e6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_income_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_incomeTable_vue__ = __webpack_require__(448);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c50511e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_incomeTable_vue__ = __webpack_require__(1374);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_incomeTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c50511e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_incomeTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return incomeOverallReport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);




var _this = this;

var incomeOverallReport = function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
        var firm = _ref2.firm,
            list = _ref2.list;
        var pdfDoc, total, taxable;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        pdfDoc = {
                            // pageOrientation: 'landscape',
                            content: [{
                                table: {
                                    widths: ['30%', '70%'],
                                    body: [[{
                                        text: 'INCOME OVERALL REPORT ', style: 'schoolColorHeader2'
                                    }, {
                                        text: [{ text: '          ', bold: true, style: 'schoolColorHeader' }, { text: '\n', style: 'schoolColorHeader' }]
                                    }]]

                                },
                                layout: {
                                    hLineWidth: function hLineWidth(i, node) {
                                        return i === 0 || i === node.table.body.length ? 2 : 0;
                                    },
                                    vLineWidth: function vLineWidth(i, node) {
                                        return i === 0 || i === node.table.widths.length ? 2 : 0;
                                    },
                                    hLineColor: function hLineColor(i, node) {
                                        return i === 0 || i === node.table.body.length ? 'black' : 'white';
                                    },
                                    vLineColor: function vLineColor(i, node) {
                                        return i === 0 || i === node.table.widths.length ? 'black' : 'white';
                                    }
                                }
                            }, {
                                table: {
                                    headerRows: 1,
                                    widths: ['10%', "*", '20%', '20%'],
                                    body: [[{ text: 'S.No.', style: "schoolColorHeader1" }, { text: 'Particulars', style: "schoolColorHeader1" }, { text: 'Taxable', style: "schoolColorHeader1" }, { text: 'Total', style: "schoolColorHeader1" }]]
                                }
                            }, {
                                table: {
                                    widths: ['33%', '34%', '33%'],
                                    body: [[{
                                        text: [{ text: '\n\n\n\n' }, { text: 'OFFICE INCHARGE ', bold: true, alignment: 'center', style: 'colorHeader' }, { text: '\n' }]
                                    }, {
                                        text: [{ text: '\n\n\n\n' }, { text: 'AUTHORITY SIGNATURE  ', bold: true, alignment: 'center', style: 'colorHeader' }, { text: '\n' }]
                                    }, {
                                        text: [{ text: '\n\n\n\n' }, { text: 'PRINCIPAL SIGNATURE  ', bold: true, alignment: 'center', style: 'colorHeader' }, { text: '\n' }]
                                    }]]

                                },
                                layout: {
                                    hLineWidth: function hLineWidth(i, node) {
                                        return i === 0 || i === node.table.body.length ? 2 : 0;
                                    },
                                    vLineWidth: function vLineWidth(i, node) {
                                        return i === 0 || i === node.table.widths.length ? 2 : 0;
                                    },
                                    hLineColor: function hLineColor(i, node) {
                                        return i === 0 || i === node.table.body.length ? 'black' : 'white';
                                    },
                                    vLineColor: function vLineColor(i, node) {
                                        return i === 0 || i === node.table.widths.length ? 'black' : 'white';
                                    }
                                }
                            }],
                            styles: {
                                feeHeader: {
                                    fontSize: 10,
                                    alignment: 'center'
                                },
                                feeTableHeader: {
                                    fontSize: 10,
                                    alignment: 'center',
                                    fillColor: '#1A237E',
                                    color: '#ffffff',
                                    bold: true
                                },
                                feeDescriptiveHeader: {
                                    fontSize: 10,
                                    alignment: 'left',
                                    bold: true
                                },
                                feeDescriptiveHeader1: {
                                    fontSize: 10,
                                    alignment: 'center',
                                    bold: true
                                },
                                topHeader: {
                                    color: '#ffffff',
                                    fontSize: 11,
                                    alignment: 'left',
                                    bold: true,
                                    fillColor: '#1A237E'
                                },
                                thankyouHeader: {
                                    color: '#ffffff',
                                    fontSize: 11,
                                    alignment: 'center',
                                    bold: true,
                                    fillColor: '#1A237E'
                                },
                                upcomingFeeHeader: {
                                    color: '#ffffff',
                                    fontSize: 11,
                                    alignment: 'left',
                                    bold: true,
                                    fillColor: '#1A237E'
                                },
                                colorHeader: {
                                    color: '#1A237E',
                                    fontSize: 12,
                                    bold: true
                                },
                                schoolColorHeader: {
                                    color: '#1A237E',
                                    fontSize: 14,
                                    bold: true,
                                    alignment: 'right'
                                },
                                schoolColorHeader1: {
                                    color: '#1A237E',
                                    fontSize: 9,
                                    bold: true,
                                    alignment: 'center'
                                },
                                schoolColorHeader2: {
                                    color: '#1A237E',
                                    fontSize: 14,
                                    bold: true,
                                    alignment: 'left'
                                },
                                studentDetails: {
                                    fontSize: 9,
                                    bold: true
                                },
                                studentDetailsRight: {
                                    fontSize: 9,
                                    bold: true
                                },
                                studentIncreaseFontDetails: {
                                    fontSize: 12,
                                    bold: true
                                },
                                studentIncreaseFontAmountDetails: {
                                    fontSize: 12,
                                    bold: true,
                                    color: '#1A237E'
                                },
                                studentBlankDetails: {
                                    fontSize: 20,
                                    bold: true,
                                    color: '#ffffff'
                                },
                                schoolDetails: {
                                    fontSize: 10,
                                    bold: true,
                                    alignment: 'right'
                                },
                                thankyouMsg: {
                                    color: '#1A237E',
                                    fontSize: 12,
                                    bold: true,
                                    alignment: 'center'
                                }
                            }

                            //school details

                        };
                        if (firm) {
                            pdfDoc.content[0].table.body[0][1].text[1].text = 'BMJ'.toUpperCase() + '\n';
                            // pdfDoc.content[0].table.body[0][1].text[3].text = (school.address || '') + '\n';
                            // pdfDoc.content[0].table.body[0][1].text[5].text = (school.boardAffiliationNumber || '') + '\n';
                            // pdfDoc.content[0].table.body[0][1].text[7].text = (school.schoolCode || '') + '\n';
                            // pdfDoc.content[0].table.body[0][1].text[9].text = (school.mobile || '') + '\n';
                        }

                        // pdfDoc.content[0].table.body[0][0].text += `[${selectedIncome}]`


                        total = 0;
                        taxable = 0;

                        list.map(function (pro, index) {
                            total += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(pro.totalAmount);
                            taxable += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(pro.taxableAmount);
                            var temp = [{ text: index + 1, style: 'studentDetails' },
                            // { text:  new Date(pro.date).toLocaleDateString("en-GB"), style: 'studentDetails' },
                            { text: pro.income, style: 'studentDetailsRight' }, { text: pro.taxableAmount || 0, style: 'studentDetails' }, { text: pro.totalAmount || 0, style: 'studentDetails' }];

                            pdfDoc.content[1].table.body.push(temp);
                        });
                        pdfDoc.content[1].table.body.push([{ text: " ", style: "studentDetails" }, { text: "Total", style: "studentDetails" }, { text: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(taxable).toFixed(2), style: "studentDetailsRight" }, { text: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(total).toFixed(2), style: "studentDetailsRight" }]);
                        return _context.abrupt('return', pdfDoc);

                    case 7:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this);
    }));

    return function incomeOverallReport(_x) {
        return _ref.apply(this, arguments);
    };
}();

/***/ }),
/* 1374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"mt-4",nativeOn:{"click":function($event){return _vm.printOverallIncome($event)}}},[_c('v-icon',[_vm._v("print")])],1),_vm._v(" "),_c('v-switch',{staticClass:"mb-2",attrs:{"inset":"","label":"Major Incomes"},model:{value:(_vm.hideZero),callback:function ($$v) {_vm.hideZero=$$v},expression:"hideZero"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 black--text font-weight-bold",attrs:{"items":_vm.list,"headers":_vm.headers},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',{staticClass:"primary--text font-weight-bolder"},[_vm._v(_vm._s(props.item.income))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.category))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.underHead))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(props.item.openingBalance)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(props.item.totalAmount)))]),_vm._v(" "),_c('td',[_c('b',{staticClass:"primary--text font-weight-bolder"},[_vm._v(" "+_vm._s(_vm._f("amount")(((props.item.openingBalance ? Number.parseFloat(props.item.openingBalance) : 0 ) + (props.item.totalAmount ? Number.parseFloat(props.item.totalAmount) : 0)))))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.paymentTypeStatus))]),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"primary--text",attrs:{"icon":"","round":""},on:{"click":function($event){return _vm.openIncomeDialog(props.item)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n          remove_red_eye\n        ")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"primary--text",attrs:{"icon":"","round":""},on:{"click":function($event){return _vm.openIncomeEdit(props.item)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v(" \n          edit \n        ")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Incomes to Show")])],2),_vm._v(" "),_c('v-dialog',{attrs:{"transition":"dialog-bottom-transition"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.selectedIncome))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 black--text font-weight-bold",attrs:{"items":_vm.selectedIncomes,"headers":_vm.incomeHeader},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',{staticClass:"primary--text font-weight-bold"},[_vm._v(_vm._s(_vm.getFirmName(props.item.firm)))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(new Date(props.item.date).toLocaleDateString('en-GB')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(props.item.openingBalance || 0)))]),_vm._v(" "),_c('td',[_c('b',{staticClass:"success--text font-weight-bolder"},[_vm._v(_vm._s(_vm._f("amount")(props.item.totalAmount || 0)))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"primary--text font-weight-bolder"},[_vm._v("\n            "+_vm._s(_vm._f("amount")((Number.parseFloat(props.item.openingBalance ?  props.item.openingBalance : 0 ) + (props.item.totalAmount ? props.item.totalAmount : 0) ) || 0))+"\n          ")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.paymentType))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.remark))]),_vm._v(" "),_c('td',[( props.item.paymentTypeStatus == 'yet to confirm')?_c('v-btn',{on:{"click":function($event){return _vm.openIncomeInvoiceEdit(props.item,true)}}},[_vm._v(_vm._s(props.item.paymentTypeStatus))]):_c('b',[_vm._v(_vm._s(props.item.paymentTypeStatus))])],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"primary--text",attrs:{"icon":""},on:{"click":function($event){return _vm.openIncomeInvoiceEdit(props.item,false)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n              edit\n            ")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"red--text",attrs:{"icon":""},on:{"click":function($event){return _vm.openIncomeInvoiceDelete(props.item)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n              delete\n            ")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("no record found")])],2)],1),_vm._v(" "),_c('v-dialog',{attrs:{"transition":"dialog-bottom-transition"},model:{value:(_vm.dialogEdit),callback:function ($$v) {_vm.dialogEdit=$$v},expression:"dialogEdit"}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[(_vm.selectedIncome)?_c('v-toolbar-title',[_vm._v(_vm._s(_vm.selectedIncome.income))]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogEdit = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),(_vm.selectedIncome)?_c('v-card',{attrs:{"tile":""}},[_c('v-card-text',[_c('v-text-field',{attrs:{"label":"Name"},model:{value:(_vm.selectedIncome.income),callback:function ($$v) {_vm.$set(_vm.selectedIncome, "income", $$v)},expression:"selectedIncome.income"}}),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.categotyList,"label":"income Category"},model:{value:(_vm.selectedIncome.category),callback:function ($$v) {_vm.$set(_vm.selectedIncome, "category", $$v)},expression:"selectedIncome.category"}}),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.underHeadList,"label":"UnderHead"},model:{value:(_vm.selectedIncome.underHead),callback:function ($$v) {_vm.$set(_vm.selectedIncome, "underHead", $$v)},expression:"selectedIncome.underHead"}}),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.saveIncome()}}},[_vm._v("Save")])],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"transition":"dialog-bottom-transition"},model:{value:(_vm.dialogEditInvoice),callback:function ($$v) {_vm.dialogEditInvoice=$$v},expression:"dialogEditInvoice"}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[(_vm.isConfirm)?_c('v-toolbar-title',[_vm._v("Confirm Income")]):_c('v-toolbar-title',[_vm._v("Edit Income")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogEditInvoice = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),(_vm.selectedIncomeInvoice)?_c('v-card',{attrs:{"tile":""}},[_c('v-card-text',[_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.selectedIncomeInvoice.paymentType),callback:function ($$v) {_vm.$set(_vm.selectedIncomeInvoice, "paymentType", $$v)},expression:"selectedIncomeInvoice.paymentType"}},[_c('v-radio',{attrs:{"label":"From Cash","value":"cash"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"From Bank Account","value":"account"}})],1),_vm._v(" "),_c('v-menu',{attrs:{"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker),callback:function ($$v) {_vm.datepicker=$$v},expression:"datepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.selectedIncomeInvoice.date),callback:function ($$v) {_vm.$set(_vm.selectedIncomeInvoice, "date", $$v)},expression:"selectedIncomeInvoice.date"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepicker = false}},model:{value:(_vm.selectedIncomeInvoice.date),callback:function ($$v) {_vm.$set(_vm.selectedIncomeInvoice, "date", $$v)},expression:"selectedIncomeInvoice.date"}})],1),_vm._v(" "),_c('v-select',{staticClass:"select-firm",attrs:{"items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.selectedIncomeInvoice.firm),callback:function ($$v) {_vm.$set(_vm.selectedIncomeInvoice, "firm", $$v)},expression:"selectedIncomeInvoice.firm"}}),_vm._v(" "),(_vm.selectedIncomeInvoice.paymentType == 'account')?_c('v-select',{attrs:{"items":_vm.banksByFirm,"label":"From Account","disabled":!_vm.selectedIncomeInvoice.firm,"required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                  "+_vm._s(data.item.accountnumber)+_vm._s(data.item.bankName ? ' | '+data.item.bankName : '')+"\n              ")]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(((data.item.accountnumber) + "\n                          " + (data.item.bankName ? ' | '+data.item.bankName : '') + "\n                          " + (data.item.accountType ? ' | '+data.item.accountType : ''))
                      )}})],1)]}}],null,false,855933585),model:{value:(_vm.selectAccountFromIncome),callback:function ($$v) {_vm.selectAccountFromIncome=$$v},expression:"selectAccountFromIncome"}}):_vm._e(),_vm._v(" "),_c('v-text-field',{attrs:{"type":"number","label":"Opening Balance"},model:{value:(_vm.selectedIncomeInvoice.openingBalance),callback:function ($$v) {_vm.$set(_vm.selectedIncomeInvoice, "openingBalance", $$v)},expression:"selectedIncomeInvoice.openingBalance"}}),_vm._v(" "),(_vm.isConfirm)?_c('v-text-field',{attrs:{"value":_vm.selectedIncome,"label":"Income","disabled":true}}):_vm._e(),_vm._v(" "),_c('v-text-field',{attrs:{"type":"number","label":"Amount"},model:{value:(_vm.selectedIncomeInvoice.totalAmount),callback:function ($$v) {_vm.$set(_vm.selectedIncomeInvoice, "totalAmount", $$v)},expression:"selectedIncomeInvoice.totalAmount"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Remark"},model:{value:(_vm.selectedIncomeInvoice.remark),callback:function ($$v) {_vm.$set(_vm.selectedIncomeInvoice, "remark", $$v)},expression:"selectedIncomeInvoice.remark"}}),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.saveIncomeInvoice()}}},[(_vm.isConfirm)?_c('span',[_vm._v("Confirm")]):_c('span',[_vm._v("Save")])])],1)],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-5",attrs:{"flat":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker),callback:function ($$v) {_vm.datepicker=$$v},expression:"datepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.incomeInvoiceDate),callback:function ($$v) {_vm.incomeInvoiceDate=$$v},expression:"incomeInvoiceDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepicker = false}},model:{value:(_vm.incomeInvoiceDate),callback:function ($$v) {_vm.incomeInvoiceDate=$$v},expression:"incomeInvoiceDate"}})],1),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.firmsByBrand,"label":"From Firm","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n            "+_vm._s(data.item.text)+"\n        ")]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(("" + (data.item.firm.name) + (data.item.firm.proprietor ? ' | '+data.item.firm.proprietor : '') + " | ₹: " + ((data.item.firm.amount || 0).toLocaleString())))}})],1)]}}]),model:{value:(_vm.selectedFirmFromIncome),callback:function ($$v) {_vm.selectedFirmFromIncome=$$v},expression:"selectedFirmFromIncome"}}),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.incomeByBrand,"label":"Select or add Income","autocomplete":""},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addIncome($event)}},model:{value:(_vm.selectIncome),callback:function ($$v) {_vm.selectIncome=$$v},expression:"selectIncome"}}),_vm._v(" "),(_vm.addError)?_c('span',{staticClass:"error--text"},[_vm._v(_vm._s(_vm.addError))]):_vm._e(),_vm._v(" "),(_vm.selectIncome)?_c('v-select',{attrs:{"disabled":!!_vm.selectedIncomeType.category,"items":_vm.categotyList,"label":"Select Income Category"},model:{value:(_vm.incomeCategory),callback:function ($$v) {_vm.incomeCategory=$$v},expression:"incomeCategory"}}):_vm._e(),_vm._v(" "),(_vm.selectIncome && _vm.incomeCategory)?_c('v-select',{attrs:{"disabled":!!_vm.selectedIncomeType.underHead,"items":_vm.underHeadList,"label":"Select Income UnderHead"},model:{value:(_vm.incomeUnderHead),callback:function ($$v) {_vm.incomeUnderHead=$$v},expression:"incomeUnderHead"}}):_vm._e(),_vm._v(" "),(_vm.selectIncome && _vm.incomeCategory && _vm.incomeUnderHead && (!_vm.firmIncame.length) && !_vm.selectedFirmOpeningBalance)?_c('div',[_c('b',{staticClass:"subheading primary--text font-weight-bold"},[_vm._v(" is Opening Balance Available For \n            ")])]):_vm._e(),_vm._v(" "),(_vm.selectIncome && _vm.incomeCategory && _vm.incomeUnderHead && (!_vm.firmIncame.length))?_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.isOpeningBalance),callback:function ($$v) {_vm.isOpeningBalance=$$v},expression:"isOpeningBalance"}},[_c('v-radio',{attrs:{"label":"New","value":true},scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('div',[_c('strong',{staticClass:"success--text"},[_vm._v(" Yes ")])])]},proxy:true}],null,false,60981060)}),_vm._v(" "),_c('v-radio',{attrs:{"label":"old","value":false},scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('div',[_c('strong',{staticClass:"primary--text"},[_vm._v(" No ")])])]},proxy:true}],null,false,2122471461)})],1):_vm._e(),_vm._v(" "),((_vm.selectIncome && _vm.incomeCategory && _vm.incomeUnderHead && _vm.isOpeningBalance && !_vm.firmIncame.length) && !_vm.selectedFirmOpeningBalance)?_c('v-text-field',{attrs:{"type":"number","label":"Opening Balance"},model:{value:(_vm.incomeOpeningBalance),callback:function ($$v) {_vm.incomeOpeningBalance=$$v},expression:"incomeOpeningBalance"}}):_vm._e(),_vm._v(" "),(_vm.selectIncome && _vm.incomeCategory  && _vm.incomeOpeningBalance && _vm.isOpeningBalance)?_c('b',{staticClass:"subheading primary--text font-weight-bold"},[_vm._v(" Payment Type ")]):_vm._e(),_vm._v(" "),(_vm.selectIncome && _vm.incomeCategory  && _vm.incomeOpeningBalance && _vm.isOpeningBalance)?_c('v-radio-group',{attrs:{"mandatory":false,"row":""},model:{value:(_vm.incomeVia),callback:function ($$v) {_vm.incomeVia=$$v},expression:"incomeVia"}},[_c('v-radio',{attrs:{"label":"From Provision","value":"provision"}})],1):_vm._e(),_vm._v(" "),(_vm.selectIncome && _vm.incomeCategory && _vm.incomeUnderHead && !_vm.isOpeningBalance)?_c('v-text-field',{attrs:{"label":"Amount","hint":_vm.hintText,"required":""},model:{value:(_vm.incomeAmount),callback:function ($$v) {_vm.incomeAmount=$$v},expression:"incomeAmount"}}):_vm._e(),_vm._v(" "),(_vm.selectIncome && _vm.incomeCategory && _vm.incomeUnderHead && _vm.incomeAmount && !_vm.isOpeningBalance)?_c('b',{staticClass:"primary--text font-weight-bold"},[_vm._v(" Payment Type ")]):_vm._e(),_vm._v(" "),(_vm.selectIncome && _vm.incomeCategory && _vm.incomeUnderHead && _vm.incomeAmount && !_vm.isOpeningBalance)?_c('v-radio-group',{attrs:{"mandatory":false,"row":""},model:{value:(_vm.incomeVia),callback:function ($$v) {_vm.incomeVia=$$v},expression:"incomeVia"}},[_c('v-radio',{attrs:{"label":"To Cash","value":"cash"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"To Bank Account","value":"account"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"To Provision","value":"provision"}})],1):_vm._e(),_vm._v(" "),(_vm.incomeVia == 'account')?_c('v-select',{attrs:{"items":_vm.banksByFirm,"label":"From Bank Account","disabled":!_vm.selectedFirmFromIncome,"required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                "+_vm._s(data.item.account.accountnumber)+_vm._s(data.item.account.bankName ? ' | '+data.item.account.bankName : '')+"\n            ")]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(((data.item.account.accountnumber) + "\n                        " + (data.item.account.bankName ? ' | '+data.item.account.bankName : '') + "\n                        " + (data.item.account.accountType ? ' | '+data.item.account.accountType : '') + "\n                        | ₹: " + ((data.item.account.amount || 0).toLocaleString()))
                    )}})],1)]}}],null,false,49996952),model:{value:(_vm.selectAccountFromIncome),callback:function ($$v) {_vm.selectAccountFromIncome=$$v},expression:"selectAccountFromIncome"}}):_vm._e(),_vm._v(" "),(_vm.selectIncome && _vm.incomeCategory && _vm.incomeUnderHead && _vm.incomeOpeningBalance || _vm.incomeAmount)?_c('v-text-field',{attrs:{"label":"Remark","disabled":_vm.selectedIncomeType.incomeRemark},model:{value:(_vm.incomeRemark),callback:function ($$v) {_vm.incomeRemark=$$v},expression:"incomeRemark"}}):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.incomeAmountClick}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("money_off")]),_vm._v("   Save\n        ")],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("cancel")]),_vm._v("   Cancel \n        ")],1),_vm._v(" "),_c('v-btn',{staticClass:"primary--text font-weight-bold",attrs:{"round":"","outline":""},on:{"click":function($event){_vm.openIncomeTable = true}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v(" remove_red_eye ")]),_vm._v(" \n                 Income Table \n        ")],1),_vm._v(" "),_c('v-btn',{staticClass:"primary--text font-weight-bold",attrs:{"round":"","outline":""},on:{"click":function($event){_vm.openProvisionTable = true}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v(" remove_red_eye ")]),_vm._v(" \n                 Provision Table \n        ")],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullScreen":"","transition":"dialog-bottom-transition"},model:{value:(_vm.openIncomeTable),callback:function ($$v) {_vm.openIncomeTable=$$v},expression:"openIncomeTable"}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Income Details")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.openIncomeTable = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card',[_c('income-table-info',{attrs:{"accountsByBrand":_vm.accountsByBrand,"firmsByBrand":_vm.firmsByBrand}})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullScreen":"","transition":"dialog-bottom-transition"},model:{value:(_vm.openProvisionTable),callback:function ($$v) {_vm.openProvisionTable=$$v},expression:"openProvisionTable"}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{staticClass:"select-firm",attrs:{"items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.selectedFirmProvisionFilter),callback:function ($$v) {_vm.selectedFirmProvisionFilter=$$v},expression:"selectedFirmProvisionFilter"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('h3',[_c('p',{staticStyle:{"text-align":"center"}},[_c('v-toolbar-title',[_vm._v("Provision Details")])],1)])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.openProvisionTable = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card',[_c('v-data-table',{staticClass:"elevation",attrs:{"items":_vm.provisionByBrand,"headers":_vm.provisionHeader},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item['.key']))]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.getFirmName(props.item.firm)))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(new Date(props.item.date).toLocaleDateString('en-GB')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(props.item.openingBalance || 0)))]),_vm._v(" "),(!props.item['isCredited'])?_c('td',[_c('b',{staticClass:"success--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item.credit || 0)))])]):_c('td'),_vm._v(" "),(props.item['isCredited'])?_c('td',[_c('b',{staticClass:"error--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item.debit || 0)))])]):_c('td'),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item.RunningBal || 0)))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(((props.item.openingBalance ?  props.item.totalAmount : 0 ) + (props.item.totalAmount ? props.item.totalAmount : 0) ) || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.paymentType))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.remark))]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.paymentTypeStatus || "yet to confirm/confirm"))])])]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("no record found")])],2)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_asset_vue__ = __webpack_require__(449);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79f61cb8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_asset_vue__ = __webpack_require__(1380);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_asset_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79f61cb8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_asset_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_assetTable_vue__ = __webpack_require__(450);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cf07882_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_assetTable_vue__ = __webpack_require__(1379);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_assetTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cf07882_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_assetTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return assetOverallReport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);




var _this = this;

var assetOverallReport = function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
        var firm = _ref2.firm,
            list = _ref2.list;
        var pdfDoc, total, addition, deletion, opening, taxable, closingTotal, depreciationTotal;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        pdfDoc = {
                            // pageOrientation: 'landscape',
                            content: [{
                                table: {
                                    widths: ['30%', '70%'],
                                    body: [[{
                                        text: 'ASSET OVERALL REPORT ', style: 'schoolColorHeader2'
                                    }, {
                                        text: [{ text: '          ', bold: true, style: 'schoolColorHeader' }, { text: '\n', style: 'schoolColorHeader' }]
                                    }]]

                                },
                                layout: {
                                    hLineWidth: function hLineWidth(i, node) {
                                        return i === 0 || i === node.table.body.length ? 2 : 0;
                                    },
                                    vLineWidth: function vLineWidth(i, node) {
                                        return i === 0 || i === node.table.widths.length ? 2 : 0;
                                    },
                                    hLineColor: function hLineColor(i, node) {
                                        return i === 0 || i === node.table.body.length ? 'black' : 'white';
                                    },
                                    vLineColor: function vLineColor(i, node) {
                                        return i === 0 || i === node.table.widths.length ? 'black' : 'white';
                                    }
                                }
                            }, {
                                table: {
                                    headerRows: 1,
                                    // widths: ['10%', "*", '10%', '10%', '10%', '10%', '10%'],
                                    widths: ['10%', "*", '15%', '15%', '15%', '15%'],
                                    body: [[{ text: 'S.No.', style: "schoolColorHeader1" }, { text: 'Particulars', style: "schoolColorHeader1" }, { text: 'Opening', style: "schoolColorHeader1" },
                                    // { text: 'Taxable', style: "schoolColorHeader1" },
                                    { text: 'Addition', style: "schoolColorHeader1" },
                                    // { text: 'Total', style: "schoolColorHeader1" },
                                    { text: 'Depriciation', style: "schoolColorHeader1" }, { text: 'Closing', style: "schoolColorHeader1" }]]
                                }
                            }, {
                                table: {
                                    widths: ['33%', '34%', '33%'],
                                    body: [[{
                                        text: [{ text: '\n\n\n\n' }, { text: 'OFFICE INCHARGE ', bold: true, alignment: 'center', style: 'colorHeader' }, { text: '\n' }]
                                    }, {
                                        text: [{ text: '\n\n\n\n' }, { text: 'AUTHORITY SIGNATURE  ', bold: true, alignment: 'center', style: 'colorHeader' }, { text: '\n' }]
                                    }, {
                                        text: [{ text: '\n\n\n\n' }, { text: 'PRINCIPAL SIGNATURE  ', bold: true, alignment: 'center', style: 'colorHeader' }, { text: '\n' }]
                                    }]]

                                },
                                layout: {
                                    hLineWidth: function hLineWidth(i, node) {
                                        return i === 0 || i === node.table.body.length ? 2 : 0;
                                    },
                                    vLineWidth: function vLineWidth(i, node) {
                                        return i === 0 || i === node.table.widths.length ? 2 : 0;
                                    },
                                    hLineColor: function hLineColor(i, node) {
                                        return i === 0 || i === node.table.body.length ? 'black' : 'white';
                                    },
                                    vLineColor: function vLineColor(i, node) {
                                        return i === 0 || i === node.table.widths.length ? 'black' : 'white';
                                    }
                                }
                            }],
                            styles: {
                                feeHeader: {
                                    fontSize: 10,
                                    alignment: 'center'
                                },
                                feeTableHeader: {
                                    fontSize: 10,
                                    alignment: 'center',
                                    fillColor: '#1A237E',
                                    color: '#ffffff',
                                    bold: true
                                },
                                feeDescriptiveHeader: {
                                    fontSize: 10,
                                    alignment: 'left',
                                    bold: true
                                },
                                feeDescriptiveHeader1: {
                                    fontSize: 10,
                                    alignment: 'center',
                                    bold: true
                                },
                                topHeader: {
                                    color: '#ffffff',
                                    fontSize: 11,
                                    alignment: 'left',
                                    bold: true,
                                    fillColor: '#1A237E'
                                },
                                thankyouHeader: {
                                    color: '#ffffff',
                                    fontSize: 11,
                                    alignment: 'center',
                                    bold: true,
                                    fillColor: '#1A237E'
                                },
                                upcomingFeeHeader: {
                                    color: '#ffffff',
                                    fontSize: 11,
                                    alignment: 'left',
                                    bold: true,
                                    fillColor: '#1A237E'
                                },
                                colorHeader: {
                                    color: '#1A237E',
                                    fontSize: 12,
                                    bold: true
                                },
                                schoolColorHeader: {
                                    color: '#1A237E',
                                    fontSize: 14,
                                    bold: true,
                                    alignment: 'right'
                                },
                                schoolColorHeader1: {
                                    color: '#1A237E',
                                    fontSize: 9,
                                    bold: true,
                                    alignment: 'center'
                                },
                                schoolColorHeader2: {
                                    color: '#1A237E',
                                    fontSize: 14,
                                    bold: true,
                                    alignment: 'left'
                                },
                                studentDetails: {
                                    fontSize: 9,
                                    bold: true
                                },
                                studentDetailsRight: {
                                    fontSize: 9,
                                    bold: true
                                }
                            }

                            //school details

                        };
                        if (firm) {
                            pdfDoc.content[0].table.body[0][1].text[1].text = 'BMJ'.toUpperCase() + '\n';
                        }

                        total = 0;
                        addition = 0;
                        deletion = 0;
                        opening = 0;
                        taxable = 0;
                        closingTotal = 0;
                        depreciationTotal = 0;


                        list.map(function (pro, index) {
                            total += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(pro.totalAmount);
                            taxable += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(pro.taxableAmount);
                            addition += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(pro.totalAdditionAmount);
                            // deletion += Number.parseFloat(pro.deletionAmount);
                            opening += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(pro.openingBalance);

                            var openingBalance = parseFloat(pro.openingBalance || 0);
                            var totalAdditionAmount = parseFloat(pro.totalAdditionAmount);
                            var totalAmount = parseFloat(pro.totalAmount || 0);
                            var depriciationRate = parseFloat(pro.depriciation || 0); // % value
                            var isVerified = pro.isVerified;

                            var depriciation = 0;
                            if (isVerified && depriciationRate) {
                                depriciation = (totalAdditionAmount || 0) * depriciationRate / 100;
                            }
                            depreciationTotal += depriciation;

                            var closing = (openingBalance + totalAdditionAmount - depriciation).toFixed(2);
                            closingTotal += __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(closing);

                            var temp = [{ text: index + 1, style: 'studentDetails' }, { text: pro.asset, style: 'studentDetailsRight' }, { text: openingBalance.toFixed(2), style: 'studentDetails' }, { text: totalAdditionAmount || 0, style: 'studentDetails' }, { text: depriciation.toFixed(2), style: 'studentDetails' }, { text: closing, style: 'studentDetails' }];

                            pdfDoc.content[1].table.body.push(temp);
                        });
                        pdfDoc.content[1].table.body.push([{ text: " ", style: "studentDetails" }, { text: "Total", style: "studentDetails" }, { text: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(opening).toFixed(2), style: "studentDetailsRight" }, { text: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(addition).toFixed(2), style: "studentDetailsRight" }, { text: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(depreciationTotal).toFixed(2), style: "studentDetails" }, { text: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_float___default()(closingTotal).toFixed(2), style: "studentDetailsRight" }]);
                        return _context.abrupt('return', pdfDoc);

                    case 12:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this);
    }));

    return function assetOverallReport(_x) {
        return _ref.apply(this, arguments);
    };
}();

/***/ }),
/* 1379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"mt-4",nativeOn:{"click":function($event){return _vm.printOverallAsset($event)}}},[_c('v-icon',[_vm._v("print")])],1),_vm._v(" "),_c('v-switch',{staticClass:"mb-2",attrs:{"inset":"","label":"Major Assets"},model:{value:(_vm.hideZero),callback:function ($$v) {_vm.hideZero=$$v},expression:"hideZero"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-data-table',{staticClass:"elevation",attrs:{"items":_vm.list,"headers":_vm.headers},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.asset))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.type))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.category))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.depriciation ? ((props.item.depriciation) + "%") : '--'))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(props.item.openingBalance || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(props.item.totalAdditionAmount)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(props.item.totalDeletionAmount)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.getTotalAmount(props.item))))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.getDepAmount(props.item, props.item.category))))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingWdv(props.item))))]),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"primary white--text",attrs:{"icon":""},on:{"click":function($event){return _vm.openAssetDialog(props.item)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v(" \n            remove_red_eye \n          ")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"primary white--text",attrs:{"icon":""},on:{"click":function($event){return _vm.openAssetEdit(props.item)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v(" \n            edit \n          ")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Assets to Show")])],2),_vm._v(" "),_c('v-dialog',{attrs:{"transition":"dialog-bottom-transition"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.selectedAsset))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation",attrs:{"items":_vm.selectedAssets,"headers":_vm.assetHeader},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"primary--text font-weight-bold",domProps:{"innerHTML":_vm._s(_vm.renderDate(props.item.date))}}),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.getFirmName(props.item.firm))+"  - "+_vm._s(props.item.taxableGST_rate)+" - "+_vm._s(props.item.GST_type)+" ")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(props.item.openingBalance || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(props.item.taxableAmount || 0)))]),_vm._v(" "),(!props.item.isCredited)?[_c('td',{staticClass:"red--text text--darken-4",attrs:{"h3":""}},[_vm._v("\n            "+_vm._s(_vm._f("amount")(props.item.totalAmount || 0))+"\n          ")]),_vm._v(" "),_c('td')]:_vm._e(),_vm._v(" "),(props.item.isCredited)?[_c('td'),_vm._v(" "),_c('td',{staticClass:"green--text text--darken-4",attrs:{"h3":""}},[_vm._v("\n            "+_vm._s(_vm._f("amount")(props.item.totalAmount || 0))+"\n          ")])]:_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.paymentType))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.remark))]),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"primary--text",attrs:{"icon":""},on:{"click":function($event){return _vm.openAssetInvoiceEdit(props.item,false)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("\n              edit\n            ")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("no record found")])],2)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialogEdit),callback:function ($$v) {_vm.dialogEdit=$$v},expression:"dialogEdit"}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[(_vm.selectedAsset)?_c('v-toolbar-title',[_vm._v(_vm._s(_vm.selectedAsset.asset))]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogEdit = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),(_vm.selectedAsset)?_c('v-card',{attrs:{"tile":""}},[_c('v-card-text',[_c('v-text-field',{attrs:{"label":"Name"},model:{value:(_vm.selectedAsset.asset),callback:function ($$v) {_vm.$set(_vm.selectedAsset, "asset", $$v)},expression:"selectedAsset.asset"}}),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.assetCategoryList,"label":"Asset Category","required":""},model:{value:(_vm.asset.category),callback:function ($$v) {_vm.$set(_vm.asset, "category", $$v)},expression:"asset.category"}}),_vm._v(" "),(_vm.asset.category)?_c('v-select',{attrs:{"items":_vm.assetTypeList,"label":"Asset Type","required":""},model:{value:(_vm.asset.type),callback:function ($$v) {_vm.$set(_vm.asset, "type", $$v)},expression:"asset.type"}}):_vm._e(),_vm._v(" "),(_vm.asset.type && _vm.allowDepriciation)?_c('v-select',{attrs:{"label":"Allocate Depriciation % ?","items":_vm.depriciationList},model:{value:(_vm.asset.depriciation),callback:function ($$v) {_vm.$set(_vm.asset, "depriciation", $$v)},expression:"asset.depriciation"}}):_vm._e(),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.saveAsset()}}},[_vm._v("Save")])],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialogEditInvoice),callback:function ($$v) {_vm.dialogEditInvoice=$$v},expression:"dialogEditInvoice"}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[(_vm.isConfirm)?_c('v-toolbar-title',[_vm._v("Confirm asset")]):_c('v-toolbar-title',[_vm._v("Edit asset")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogEditInvoice = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),(_vm.selectedAssetInvoice)?_c('v-card',{attrs:{"tile":""}},[_c('v-card-text',[_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.selectedAssetInvoice.paymentType),callback:function ($$v) {_vm.$set(_vm.selectedAssetInvoice, "paymentType", $$v)},expression:"selectedAssetInvoice.paymentType"}},[_c('v-radio',{attrs:{"label":"From Cash","value":"cash"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"From Bank Account","value":"account"}})],1),_vm._v(" "),_c('v-menu',{attrs:{"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker),callback:function ($$v) {_vm.datepicker=$$v},expression:"datepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.selectedAssetInvoice.date),callback:function ($$v) {_vm.$set(_vm.selectedAssetInvoice, "date", $$v)},expression:"selectedAssetInvoice.date"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepicker = false}},model:{value:(_vm.selectedAssetInvoice.date),callback:function ($$v) {_vm.$set(_vm.selectedAssetInvoice, "date", $$v)},expression:"selectedAssetInvoice.date"}})],1),_vm._v(" "),_c('v-select',{staticClass:"select-firm",attrs:{"items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.selectedAssetInvoice.firm),callback:function ($$v) {_vm.$set(_vm.selectedAssetInvoice, "firm", $$v)},expression:"selectedAssetInvoice.firm"}}),_vm._v(" "),(_vm.selectedAssetInvoice.paymentType == 'account')?_c('v-select',{attrs:{"items":_vm.banksByFirm,"label":"From Account","disabled":!_vm.selectedAssetInvoice.firm,"required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n            "+_vm._s(data.item.accountnumber)+_vm._s(data.item.bankName ? ' | '+data.item.bankName : '')+"\n          ")]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(((data.item.accountnumber) + "\n                " + (data.item.bankName ? ' | '+data.item.bankName : '') + "\n                " + (data.item.accountType ? ' | '+data.item.accountType : ''))
              )}})],1)]}}],null,false,1180326929),model:{value:(_vm.selectAccountFromasset),callback:function ($$v) {_vm.selectAccountFromasset=$$v},expression:"selectAccountFromasset"}}):_vm._e(),_vm._v(" "),_c('v-text-field',{attrs:{"type":"number","label":"Opening Balance"},model:{value:(_vm.selectedAssetInvoice.openingBalance),callback:function ($$v) {_vm.$set(_vm.selectedAssetInvoice, "openingBalance", $$v)},expression:"selectedAssetInvoice.openingBalance"}}),_vm._v(" "),(_vm.isConfirm)?_c('v-text-field',{attrs:{"value":_vm.selectedAsset,"label":"asset","disabled":true}}):_vm._e(),_vm._v(" "),_c('v-text-field',{attrs:{"type":"number","label":"Amount"},model:{value:(_vm.selectedAssetInvoice.totalAmount),callback:function ($$v) {_vm.$set(_vm.selectedAssetInvoice, "totalAmount", $$v)},expression:"selectedAssetInvoice.totalAmount"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Remark"},model:{value:(_vm.selectedAssetInvoice.remark),callback:function ($$v) {_vm.$set(_vm.selectedAssetInvoice, "remark", $$v)},expression:"selectedAssetInvoice.remark"}}),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.saveAssetInvoice()}}},[(_vm.isConfirm)?_c('span',[_vm._v("Confirm")]):_c('span',[_vm._v("Save")])])],1)],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-5",attrs:{"flat":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.assetdatepicker),callback:function ($$v) {_vm.assetdatepicker=$$v},expression:"assetdatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.assetInvoiceDate),callback:function ($$v) {_vm.assetInvoiceDate=$$v},expression:"assetInvoiceDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.assetdatepicker = false}},model:{value:(_vm.assetInvoiceDate),callback:function ($$v) {_vm.assetInvoiceDate=$$v},expression:"assetInvoiceDate"}})],1),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.firmsByBrand,"label":"To Firm","return-object":"","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n          "+_vm._s(data.item.text)+"\n      ")]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(("" + (data.item.firm.name) + (data.item.firm.proprietor ? ' | '+data.item.firm.proprietor : '') + " | ₹: " + ((data.item.firm.amount || 0).toLocaleString())))}})],1)]}}]),model:{value:(_vm.selectedFirmFromAsset),callback:function ($$v) {_vm.selectedFirmFromAsset=$$v},expression:"selectedFirmFromAsset"}}),_vm._v(" "),_c('v-autocomplete',{attrs:{"items":_vm.assetByBrand,"label":"Select or add Asset"},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addAsset($event)}},model:{value:(_vm.selectAsset),callback:function ($$v) {_vm.selectAsset=$$v},expression:"selectAsset"}}),_vm._v(" "),(_vm.addError)?_c('span',{staticClass:"error--text"},[_vm._v(_vm._s(_vm.addError))]):_vm._e(),_vm._v(" "),(_vm.selectedAssetDetail)?[_c('v-select',{attrs:{"disabled":_vm.assetEditDisabled,"items":_vm.assetCategoryList,"label":"Asset Category","required":""},model:{value:(_vm.asset.category),callback:function ($$v) {_vm.$set(_vm.asset, "category", $$v)},expression:"asset.category"}}),_vm._v(" "),(_vm.asset.category)?_c('v-select',{attrs:{"disabled":_vm.assetEditDisabled,"items":_vm.assetTypeList,"label":"Asset Type","required":""},model:{value:(_vm.asset.type),callback:function ($$v) {_vm.$set(_vm.asset, "type", $$v)},expression:"asset.type"}}):_vm._e(),_vm._v(" "),(_vm.asset.type && _vm.allowDepriciation)?_c('v-select',{attrs:{"disabled":_vm.assetEditDisabled,"label":"Allocate Depriciation % ?","items":_vm.depriciationList},model:{value:(_vm.asset.depriciation),callback:function ($$v) {_vm.$set(_vm.asset, "depriciation", $$v)},expression:"asset.depriciation"}}):_vm._e(),_vm._v(" "),(_vm.selectAsset)?_c('div',[_c('b',{staticClass:"subheading primary--text font-weight-bold"},[_vm._v(" IS GST Applicable Over this Asset? ")])]):_vm._e(),_vm._v(" "),(_vm.selectAsset)?_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.isGSTApplicable),callback:function ($$v) {_vm.isGSTApplicable=$$v},expression:"isGSTApplicable"}},[_c('v-radio',{attrs:{"label":"Yes","value":true}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"No","value":false}})],1):_vm._e(),_vm._v(" "),(_vm.isGSTApplicable && _vm.selectAsset)?_c('v-select',{attrs:{"dense":"","items":[0,5,12,18,28],"label":"Taxable GST rate"},model:{value:(_vm.taxableGST_rate),callback:function ($$v) {_vm.taxableGST_rate=$$v},expression:"taxableGST_rate"}}):_vm._e(),_vm._v(" "),(_vm.isGSTApplicable && _vm.selectAsset)?_c('v-select',{attrs:{"dense":"","items":_vm.GST_types_list,"label":"Select GST type"},model:{value:(_vm.GST_type),callback:function ($$v) {_vm.GST_type=$$v},expression:"GST_type"}}):_vm._e(),_vm._v(" "),(_vm.asset.type)?_c('v-radio-group',{attrs:{"disabled":_vm.assetEditDisabled && !!_vm.selectedFirmOpeningBalance,"label":"Asset Age"},model:{value:(_vm.asset.age),callback:function ($$v) {_vm.$set(_vm.asset, "age", $$v)},expression:"asset.age"}},[_c('v-radio',{attrs:{"label":"New","value":true},scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('div',[_c('strong',{staticClass:"success--text"},[_vm._v("\n                      NEW\n                  ")]),_vm._v(" "),_c('b',{staticClass:"font-weight-light"},[_vm._v("Recently Purchased")])])]},proxy:true}],null,false,834778520)}),_vm._v(" "),_c('v-radio',{attrs:{"label":"old","value":false},scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('div',[_c('strong',{staticClass:"primary--text"},[_vm._v("\n                      OLD\n                  ")]),_vm._v(" "),_c('b',{staticClass:"font-weight-light"},[_vm._v("Already Have")])])]},proxy:true}],null,false,3572417953)})],1):_vm._e(),_vm._v(" "),(_vm.asset.age === true)?[(_vm.selectAsset && _vm.isGSTApplicable && !_vm.isOpeningBalance)?_c('v-text-field',{attrs:{"label":"Taxable Value","type":"number"},on:{"keyup":function($event){_vm.$set(_vm.asset, 'totalAmount', (Number.parseFloat(_vm.taxableAmount) + Number.parseFloat((_vm.taxableAmount*_vm.taxableGST_rate)/100)));}},model:{value:(_vm.taxableAmount),callback:function ($$v) {_vm.taxableAmount=$$v},expression:"taxableAmount"}}):_vm._e(),_vm._v(" "),(_vm.selectAsset && _vm.isGSTApplicable && !_vm.isOpeningBalance)?_c('v-text-field',{attrs:{"label":"GST Value","value":((_vm.taxableAmount*_vm.taxableGST_rate)/100),"disabled":true}}):_vm._e(),_vm._v(" "),(_vm.asset.type && _vm.asset.age)?_c('v-text-field',{attrs:{"disabled":_vm.assetEditDisabled && !!_vm.selectedFirmOpeningBalance,"label":"Total Amount of Asset","type":"number","hint":_vm.hintText},model:{value:(_vm.asset.totalAmount),callback:function ($$v) {_vm.$set(_vm.asset, "totalAmount", $$v)},expression:"asset.totalAmount"}}):_vm._e(),_vm._v(" "),(_vm.asset.type && _vm.asset.age)?_c('v-select',{attrs:{"disabled":_vm.assetEditDisabled && !!_vm.selectedFirmOpeningBalance,"label":"Asset Purchase Type","items":_vm.assetPurchaseType},on:{"change":function($event){delete _vm.asset.paymentType}},model:{value:(_vm.asset.purchaseType),callback:function ($$v) {_vm.$set(_vm.asset, "purchaseType", $$v)},expression:"asset.purchaseType"}}):_vm._e(),_vm._v(" "),(_vm.asset.purchaseType && _vm.asset.purchaseType === 'downpayment')?[_c('v-select',{attrs:{"dense":"","disabled":_vm.assetEditDisabled && !!_vm.selectedFirmOpeningBalance,"label":"Select Payment Type","items":_vm.paymentOptions},model:{value:(_vm.asset.paymentType),callback:function ($$v) {_vm.$set(_vm.asset, "paymentType", $$v)},expression:"asset.paymentType"}}),_vm._v(" "),(_vm.asset.paymentType === 'CashAndBank Account')?_c('v-text-field',{attrs:{"disabled":_vm.assetEditDisabled && !!_vm.selectedFirmOpeningBalance,"type":"number","label":"Amount to Pay From Cash","hint":_vm.hintText,"error-messages":(Number(_vm.asset.amountFromCash) + Number(_vm.asset.amountFromBank)) != Number(_vm.asset.totalAmount) && _vm.asset.paymentType == 'CashAndBank Account' ? ['Sum of Cash amount and bank amount should be equal to Total Amount'] : []},model:{value:(_vm.asset.amountFromCash),callback:function ($$v) {_vm.$set(_vm.asset, "amountFromCash", $$v)},expression:"asset.amountFromCash"}}):_vm._e(),_vm._v(" "),(_vm.asset.paymentType === 'CashAndBank Account')?_c('v-text-field',{attrs:{"disabled":_vm.assetEditDisabled && !!_vm.selectedFirmOpeningBalance,"type":"number","label":"Amount to Pay From Bank","hint":_vm.hintText,"error-messages":(Number(_vm.asset.amountFromCash) + Number(_vm.asset.amountFromBank)) != Number(_vm.asset.totalAmount) && _vm.asset.paymentType == 'CashAndBank Account' ? ['Sum of Cash amount and bank amount should be equal to Total Amount'] : []},model:{value:(_vm.asset.amountFromBank),callback:function ($$v) {_vm.$set(_vm.asset, "amountFromBank", $$v)},expression:"asset.amountFromBank"}}):_vm._e(),_vm._v(" "),(_vm.asset.paymentType && _vm.asset.paymentType !== 'Cash')?_c('v-select',{attrs:{"items":_vm.otherAccountByBrand,"label":"Account to pay from bank","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                  "+_vm._s(data.item.text)+"\n              ")]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(((data.item.text) + "\n                          " + (data.item.account.bankName ? ' | '+data.item.account.bankName : '') + "\n                          " + (data.item.account.accountType ? ' | '+data.item.account.accountType : '') + "\n                          | ₹: " + ((data.item.account.amount || 0).toLocaleString()))
                      )}})],1)]}}],null,false,344035788),model:{value:(_vm.selectAccountFromAsset),callback:function ($$v) {_vm.selectAccountFromAsset=$$v},expression:"selectAccountFromAsset"}}):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.asset.purchaseType && _vm.asset.purchaseType === 'partial')?[_c('v-text-field',{attrs:{"disabled":_vm.assetEditDisabled && !!_vm.selectedFirmOpeningBalance,"type":"number","label":"Downpayment Amount","hint":_vm.downPaymentHintText,"error-messages":Number(_vm.asset.totalAmount) != Number(_vm.asset.downPaymentAmount) + Number(_vm.asset.installmentAmount) ? ['Downpayment, Installlment Amount total should be equal to Total Amount'] : []},model:{value:(_vm.asset.downPaymentAmount),callback:function ($$v) {_vm.$set(_vm.asset, "downPaymentAmount", $$v)},expression:"asset.downPaymentAmount"}}),_vm._v(" "),_c('v-select',{attrs:{"disabled":_vm.assetEditDisabled && !!_vm.selectedFirmOpeningBalance,"dense":"","label":"Select Payment Type","items":_vm.paymentOptions},model:{value:(_vm.asset.paymentType),callback:function ($$v) {_vm.$set(_vm.asset, "paymentType", $$v)},expression:"asset.paymentType"}}),_vm._v(" "),(_vm.asset.paymentType === 'CashAndBank Account')?_c('v-text-field',{attrs:{"disabled":_vm.assetEditDisabled && !!_vm.selectedFirmOpeningBalance,"type":"number","hint":_vm.hintText,"label":"Amount to Pay From Cash","error-messages":(Number(_vm.asset.amountFromCash) + Number(_vm.asset.amountFromBank)) != Number(_vm.asset.downPaymentAmount) && _vm.asset.paymentType == 'CashAndBank Account' ? ['Sum of Cash amount and bank amount should be equal to Downpayment Amount'] : []},model:{value:(_vm.asset.amountFromCash),callback:function ($$v) {_vm.$set(_vm.asset, "amountFromCash", $$v)},expression:"asset.amountFromCash"}}):_vm._e(),_vm._v(" "),(_vm.asset.paymentType ==='CashAndBank Account')?_c('v-text-field',{attrs:{"disabled":_vm.assetEditDisabled && !!_vm.selectedFirmOpeningBalance,"type":"number","label":"Amount to Pay From Bank","hint":_vm.hintText,"error-messages":(Number(_vm.asset.amountFromCash) + Number(_vm.asset.amountFromBank)) != Number(_vm.asset.downPaymentAmount) && _vm.asset.paymentType == 'CashAndBank Account' ? ['Sum of Cash amount and bank amount should be equal to Downpayment Amount'] : []},model:{value:(_vm.asset.amountFromBank),callback:function ($$v) {_vm.$set(_vm.asset, "amountFromBank", $$v)},expression:"asset.amountFromBank"}}):_vm._e(),_vm._v(" "),(_vm.asset.paymentType && _vm.asset.paymentType !== 'Cash')?_c('v-select',{attrs:{"items":_vm.otherAccountByBrand,"label":"Account to Pay From Bank","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                  "+_vm._s(data.item.text)+"\n              ")]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(((data.item.text) + "\n                          " + (data.item.account.bankName ? ' | '+data.item.account.bankName : '') + "\n                          " + (data.item.account.accountType ? ' | '+data.item.account.accountType : '') + "\n                          | ₹: " + ((data.item.account.amount || 0).toLocaleString()))
                      )}})],1)]}}],null,false,344035788),model:{value:(_vm.selectAccountFromAsset),callback:function ($$v) {_vm.selectAccountFromAsset=$$v},expression:"selectAccountFromAsset"}}):_vm._e(),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":_vm.assetEditDisabled && !!_vm.selectedFirmOpeningBalance,"label":"Installment Amount","type":"number","hint":_vm.installmentHintText,"error-messages":Number(_vm.asset.totalAmount) != Number(_vm.asset.downPaymentAmount) + Number(_vm.asset.installmentAmount) ? ['Downpayment, Installlment Amount total should be equal to Total Amount'] : []},model:{value:(_vm.asset.installmentAmount),callback:function ($$v) {_vm.$set(_vm.asset, "installmentAmount", $$v)},expression:"asset.installmentAmount"}}),_vm._v(" "),(_vm.loanAccountByBrand.length == 0 || _vm.loanAccountByBrand)?_c('v-btn',{attrs:{"outline":"","color":"primary"},on:{"click":_vm.getFirms}},[_c('v-icon',[_vm._v("\n                  add\n              ")]),_vm._v(" \n                New Loan Account [Bank]\n          ")],1):_vm._e(),_vm._v(" "),_c('v-select',{attrs:{"disabled":_vm.assetEditDisabled && !!_vm.selectedFirmOpeningBalance,"items":_vm.loanAccountByBrand,"label":"Loan Account for installment","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                  "+_vm._s(data.item.text)+"\n              ")]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(((data.item.text) + "\n                          " + (data.item.account.bankName ? ' | '+data.item.account.bankName : '') + "\n                          " + (data.item.account.accountType ? ' | '+data.item.account.accountType : '') + "\n                          | ₹: " + ((data.item.account.amount || 0).toLocaleString()))
                      )}})],1)]}}],null,false,344035788),model:{value:(_vm.asset.loanAccount),callback:function ($$v) {_vm.$set(_vm.asset, "loanAccount", $$v)},expression:"asset.loanAccount"}})]:_vm._e(),_vm._v(" "),(_vm.asset.purchaseType && _vm.asset.purchaseType === 'installment')?[(_vm.loanAccountByBrand.length == 0)?_c('v-btn',{attrs:{"outline":"","color":"primary"},on:{"click":_vm.getFirms}},[_c('v-icon',[_vm._v("\n                  add\n              ")]),_vm._v(" \n                New Loan Account [Bank]\n          ")],1):_vm._e(),_vm._v(" "),_c('v-select',{attrs:{"disabled":_vm.assetEditDisabled && !!_vm.selectedFirmOpeningBalance,"items":_vm.loanAccountByBrand,"label":"Loan Account for installment","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                  "+_vm._s(data.item.text)+"\n              ")]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(((data.item.text) + "\n                          " + (data.item.account.bankName ? ' | '+data.item.account.bankName : '') + "\n                          " + (data.item.account.accountType ? ' | '+data.item.account.accountType : '') + "\n                          | ₹: " + ((data.item.account.amount || 0).toLocaleString()))
                      )}})],1)]}}],null,false,344035788),model:{value:(_vm.asset.loanAccount),callback:function ($$v) {_vm.$set(_vm.asset, "loanAccount", $$v)},expression:"asset.loanAccount"}})]:_vm._e()]:_vm._e(),_vm._v(" "),(_vm.asset.age === false)?[_c('v-text-field',{attrs:{"disabled":_vm.asset.disableOpeningBalance && !!_vm.selectedFirmOpeningBalance,"type":"number","label":"Opening Balance of Asset","hint":_vm.hintText},model:{value:(_vm.asset.openingBalance),callback:function ($$v) {_vm.$set(_vm.asset, "openingBalance", $$v)},expression:"asset.openingBalance"}}),_vm._v(" "),(_vm.selectAsset)?_c('v-select',{attrs:{"label":"Select Operation Type","items":_vm.getOperationOptions},model:{value:(_vm.addition),callback:function ($$v) {_vm.addition=$$v},expression:"addition"}}):_vm._e(),_vm._v(" "),(_vm.selectAsset && _vm.addition === 'addition')?_c('v-text-field',{attrs:{"type":"number","label":"Addition Amount","hint":_vm.hintText},model:{value:(_vm.additionAmount),callback:function ($$v) {_vm.additionAmount=$$v},expression:"additionAmount"}}):_vm._e(),_vm._v(" "),(_vm.selectAsset && _vm.addition === 'deletion')?_c('v-text-field',{attrs:{"type":"number","label":"Deletion Amount","hint":_vm.hintText},model:{value:(_vm.deletionAmount),callback:function ($$v) {_vm.deletionAmount=$$v},expression:"deletionAmount"}}):_vm._e(),_vm._v(" "),(_vm.additionAmount || _vm.deletionAmount)?_c('v-select',{attrs:{"dense":"","label":"Select Payment Type","items":_vm.paymentOptions},model:{value:(_vm.operationPaymentType),callback:function ($$v) {_vm.operationPaymentType=$$v},expression:"operationPaymentType"}}):_vm._e(),_vm._v(" "),(_vm.operationPaymentType === 'CashAndBank Account')?_c('v-text-field',{attrs:{"type":"number","label":"Operation Amount to Pay From Cash","error-messages":(Number(_vm.operationAmountFromCash) + Number(_vm.operationAmountFromBank)) != Number(_vm.addition === 'addition' ? _vm.additionAmount : _vm.deletionAmount) && _vm.operationPaymentType == 'CashAndBank Account' ? ['Sum of Cash amount and bank amount should be equal to Asset Amount'] : []},model:{value:(_vm.operationAmountFromCash),callback:function ($$v) {_vm.operationAmountFromCash=$$v},expression:"operationAmountFromCash"}}):_vm._e(),_vm._v(" "),(_vm.operationPaymentType === 'CashAndBank Account')?_c('v-text-field',{attrs:{"type":"number","label":"Operation Amount to Pay From Bank","hint":_vm.hintText,"error-messages":(Number(_vm.operationAmountFromCash) + Number(_vm.operationAmountFromBank)) != Number(_vm.addition === 'addition' ? _vm.additionAmount : _vm.deletionAmount) && _vm.operationPaymentType == 'CashAndBank Account' ? ['Sum of Cash amount and bank amount should be equal to Asset Amount'] : []},model:{value:(_vm.operationAmountFromBank),callback:function ($$v) {_vm.operationAmountFromBank=$$v},expression:"operationAmountFromBank"}}):_vm._e(),_vm._v(" "),(_vm.operationPaymentType && _vm.operationPaymentType !== 'Cash')?_c('v-select',{attrs:{"items":_vm.otherAccountByBrand,"label":"Bank Account to Pay operation amount from Bank","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n              "+_vm._s(data.item.text)+"\n          ")]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(((data.item.text) + "\n                      " + (data.item.account.bankName ? ' | '+data.item.account.bankName : '') + "\n                      " + (data.item.account.accountType ? ' | '+data.item.account.accountType : '') + "\n                      | ₹: " + ((data.item.account.amount || 0).toLocaleString()))
                  )}})],1)]}}],null,false,145483212),model:{value:(_vm.operationAccountForTransaction),callback:function ($$v) {_vm.operationAccountForTransaction=$$v},expression:"operationAccountForTransaction"}}):_vm._e()]:_vm._e(),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Remark"},model:{value:(_vm.assetRemark),callback:function ($$v) {_vm.assetRemark=$$v},expression:"assetRemark"}})]:_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.assetAmountClick}},[_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("money_off")]),_vm._v("Save\n  ")],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("cancel")]),_vm._v("Cancel\n  ")],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.openAssetTable = true}}},[_vm._v("\n    View Asset Table\n  ")]),_vm._v(" "),_c('v-dialog',{attrs:{"fullScreen":"","transition":"dialog-bottom-transition"},model:{value:(_vm.openAssetTable),callback:function ($$v) {_vm.openAssetTable=$$v},expression:"openAssetTable"}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Asset Table")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.openAssetTable = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card',[_c('asset-table-info')],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"400"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-form',{ref:"addAccount",attrs:{"lazy-validation":""},model:{value:(_vm.addNewAccountValid),callback:function ($$v) {_vm.addNewAccountValid=$$v},expression:"addNewAccountValid"}},[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":"","title":""}},[_c('span',{staticClass:"headline"},[_vm._v("Add New Bank Account")])]),_vm._v(" "),_c('v-card-text',[_c('v-select',{attrs:{"items":_vm.firmsByBrand,"label":"Select Firms"},model:{value:(_vm.currentFirm),callback:function ($$v) {_vm.currentFirm=$$v},expression:"currentFirm"}}),_vm._v(" "),_c('v-select',{attrs:{"item-text":"name","item-value":"id","items":_vm.currentBankName,"rules":_vm.requiredRule,"label":"Choose Bank"},model:{value:(_vm.bankNameForLoan),callback:function ($$v) {_vm.bankNameForLoan=$$v},expression:"bankNameForLoan"}}),_vm._v(" "),_c('v-select',{attrs:{"item-text":"name","item-value":"id","items":_vm.currentAccountCategoryForLoan,"rules":_vm.requiredRule,"label":"Choose account category"},on:{"change":_vm.categoryChange},model:{value:(_vm.accountCategoryForLoan),callback:function ($$v) {_vm.accountCategoryForLoan=$$v},expression:"accountCategoryForLoan"}}),_vm._v(" "),_c('v-select',{attrs:{"item-text":"name","item-value":"id","items":_vm.currentAccountType,"rules":_vm.requiredRule,"label":"Choose Account Type"},model:{value:(_vm.accountTypeForLoan),callback:function ($$v) {_vm.accountTypeForLoan=$$v},expression:"accountTypeForLoan"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Account Holder Name","rules":_vm.requiredRule,"disabled":_vm.accholderdisabled},model:{value:(_vm.accountHolderName),callback:function ($$v) {_vm.accountHolderName=$$v},expression:"accountHolderName"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Account Number","rules":_vm.requiredRule},model:{value:(_vm.accountnumberForLoan),callback:function ($$v) {_vm.accountnumberForLoan=$$v},expression:"accountnumberForLoan"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"IFSC code","rules":_vm.IFSC_Rules},model:{value:(_vm.ifsccode),callback:function ($$v) {_vm.ifsccode=$$v},expression:"ifsccode"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Location","rules":_vm.requiredRule},model:{value:(_vm.accountLocation),callback:function ($$v) {_vm.accountLocation=$$v},expression:"accountLocation"}}),_vm._v(" "),_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker1),callback:function ($$v) {_vm.datepicker1=$$v},expression:"datepicker1"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Opening Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.accountOpeningDate),callback:function ($$v) {_vm.accountOpeningDate=$$v},expression:"accountOpeningDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepicker1 = false}},model:{value:(_vm.accountOpeningDate),callback:function ($$v) {_vm.accountOpeningDate=$$v},expression:"accountOpeningDate"}})],1),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Amount"},model:{value:(_vm.initialamount),callback:function ($$v) {_vm.initialamount=_vm._n($$v)},expression:"initialamount"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"warning white--text",attrs:{"primary":"","title":"","flat":"flat"},on:{"click":_vm.cancelDialog}},[_vm._v("\n          Cancel\n        ")]),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text",attrs:{"primary":"","title":"","flat":"flat"},on:{"click":_vm.addNewAccount}},[_vm._v("\n          Save\n        ")])],1)],1)],1)],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_salary_vue__ = __webpack_require__(451);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23635c06_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_salary_vue__ = __webpack_require__(1384);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_salary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23635c06_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_salary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_salaryTable_vue__ = __webpack_require__(452);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ca4b37f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_salaryTable_vue__ = __webpack_require__(1383);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_salaryTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ca4b37f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_salaryTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{staticClass:"elevation",attrs:{"items":_vm.getStaffAccount,"headers":_vm.headers},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.staffName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.staffRole))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.firmbyId(props.item.firm)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(props.item.creditTotal)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(props.item.debitTotal)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")((props.item.creditTotal - props.item.debitTotal))))]),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"primary white--text",on:{"click":function($event){return _vm.openSalaryDialog(props.item)}}},[_vm._v("\n          View\n        ")])],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v(" No Staff to Show ")])],2),_vm._v(" "),_c('v-dialog',{attrs:{"transition":"dialog-bottom-transition"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.selectedStaffName))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation",attrs:{"items":_vm.selectedSalaryList,"headers":_vm.salaryListHeaders},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.isOpening ? "" : new Date(props.item.date).toLocaleDateString("en-GB")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.isOpening ? "" : _vm.getFirmName(props.item.firm)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.transactionType))]),_vm._v(" "),(props.item.isCredited)?[_c('td',[_c('h3',{staticClass:"success--text text--darken-4"},[_vm._v("\n              "+_vm._s(_vm._f("amount")(props.item.amount))+"\n            ")])]),_vm._v(" "),_c('td')]:_vm._e(),_vm._v(" "),(!props.item.isCredited)?[_c('td'),_vm._v(" "),_c('td',[_c('h3',{staticClass:"error--text text--darken-4"},[_vm._v("\n              "+_vm._s(_vm._f("amount")(props.item.amount))+"\n            ")])])]:_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.isOpening ? "" : props.item.paymentType))]),_vm._v(" "),_c('td',[(props.item.invoiceIdCash || props.item.invoiceIdBank)?_c('v-btn',{staticClass:"primary--text",attrs:{"icon":""},on:{"click":function($event){return _vm.openAssetInvoiceEdit(props.item)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v(" edit ")])],1):_vm._e()],1),_vm._v(" "),_c('td',[(props.item.invoiceIdCash || props.item.invoiceIdBank)?_c('v-btn',{staticClass:"primary--text",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteSalary(props.item)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v(" delete ")])],1):_vm._e()],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v(" no record found ")])],2)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialogEditInvoice),callback:function ($$v) {_vm.dialogEditInvoice=$$v},expression:"dialogEditInvoice"}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Edit Salary")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogEditInvoice = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card',{attrs:{"tile":""}},[_c('v-card-text',[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.assetdatepicker),callback:function ($$v) {_vm.assetdatepicker=$$v},expression:"assetdatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.salaryInvoiceDate),callback:function ($$v) {_vm.salaryInvoiceDate=$$v},expression:"salaryInvoiceDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.assetdatepicker = false}},model:{value:(_vm.salaryInvoiceDate),callback:function ($$v) {_vm.salaryInvoiceDate=$$v},expression:"salaryInvoiceDate"}})],1),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.firmsByBrand,"label":"Select Firm","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n            "+_vm._s(data.item.text)+"\n          ")]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(
                  ("" + (data.item.firm.name) + (data.item.firm.proprietor
                      ? ' | ' + data.item.firm.proprietor
                      : '') + " | ₹: " + ((data.item.firm.amount || 0).toLocaleString()))
                )}})],1)]}}]),model:{value:(_vm.selectedFirmFromAsset),callback:function ($$v) {_vm.selectedFirmFromAsset=$$v},expression:"selectedFirmFromAsset"}}),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.staffByBrand,"label":"Select Staff Account"},model:{value:(_vm.selectStaff),callback:function ($$v) {_vm.selectStaff=$$v},expression:"selectStaff"}}),_vm._v(" "),(_vm.selectedFirmFromAsset && _vm.selectStaff)?_c('v-select',{attrs:{"label":"Select transaction type","items":_vm.getTransactionTypeOptions},model:{value:(_vm.addition),callback:function ($$v) {_vm.addition=$$v},expression:"addition"}}):_vm._e(),_vm._v(" "),(_vm.selectedFirmFromAsset && _vm.selectStaff && _vm.addition)?_c('v-text-field',{attrs:{"type":"number","label":"Amount"},model:{value:(_vm.additionAmount),callback:function ($$v) {_vm.additionAmount=$$v},expression:"additionAmount"}}):_vm._e(),_vm._v(" "),(_vm.additionAmount)?_c('v-select',{attrs:{"dense":"","label":"Select Transaction Payment Type","items":_vm.paymentOptions},model:{value:(_vm.operationPaymentType),callback:function ($$v) {_vm.operationPaymentType=$$v},expression:"operationPaymentType"}}):_vm._e(),_vm._v(" "),(_vm.operationPaymentType === 'CashAndBank Account')?_c('v-text-field',{attrs:{"type":"number","label":"Transactionn Amount to Pay From Cash","error-messages":Number(_vm.operationAmountFromCash) +
              Number(_vm.operationAmountFromBank) !=
              Number(_vm.additionAmount) &&
            _vm.operationPaymentType == 'CashAndBank Account'
              ? [
                  'Sum of Cash amount and bank amount should be equal to Asset Amount' ]
              : []},model:{value:(_vm.operationAmountFromCash),callback:function ($$v) {_vm.operationAmountFromCash=$$v},expression:"operationAmountFromCash"}}):_vm._e(),_vm._v(" "),(_vm.operationPaymentType === 'CashAndBank Account')?_c('v-text-field',{attrs:{"type":"number","label":"Transactionn Amount to Pay From Bank","error-messages":Number(_vm.operationAmountFromCash) +
              Number(_vm.operationAmountFromBank) !=
              Number(_vm.additionAmount) &&
            _vm.operationPaymentType == 'CashAndBank Account'
              ? [
                  'Sum of Cash amount and bank amount should be equal to Asset Amount' ]
              : []},model:{value:(_vm.operationAmountFromBank),callback:function ($$v) {_vm.operationAmountFromBank=$$v},expression:"operationAmountFromBank"}}):_vm._e(),_vm._v(" "),(_vm.operationPaymentType && _vm.operationPaymentType !== 'Cash')?_c('v-select',{attrs:{"items":_vm.otherAccountByBrand,"label":"Bank Account to Pay operation amount from Bank","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n            "+_vm._s(data.item.text)+"\n          ")]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(
                  ((data.item.text) + "\n                          " + (data.item.account.bankName
                              ? ' | ' + data.item.account.bankName
                              : '') + "\n                          " + (data.item.account.accountType
                              ? ' | ' + data.item.account.accountType
                              : '') + "\n                          | ₹: " + ((
                            data.item.account.amount || 0
                          ).toLocaleString()))
                )}})],1)]}}],null,false,1819667846),model:{value:(_vm.operationAccountForTransaction),callback:function ($$v) {_vm.operationAccountForTransaction=$$v},expression:"operationAccountForTransaction"}}):_vm._e(),_vm._v(" "),(_vm.additionAmount && _vm.operationPaymentType)?_c('v-text-field',{attrs:{"label":"Remark"},model:{value:(_vm.staffRemark),callback:function ($$v) {_vm.staffRemark=$$v},expression:"staffRemark"}}):_vm._e(),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.salaryAmountClick}},[_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("money_off")]),_vm._v("Save\n          ")],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.dialogEditInvoice = false}}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("cancel")]),_vm._v("Cancel\n          ")],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-5",attrs:{"flat":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.assetdatepicker),callback:function ($$v) {_vm.assetdatepicker=$$v},expression:"assetdatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.salaryInvoiceDate),callback:function ($$v) {_vm.salaryInvoiceDate=$$v},expression:"salaryInvoiceDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.assetdatepicker = false}},model:{value:(_vm.salaryInvoiceDate),callback:function ($$v) {_vm.salaryInvoiceDate=$$v},expression:"salaryInvoiceDate"}})],1),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.firmsByBrand,"label":"Select Firm","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n          "+_vm._s(data.item.text)+"\n      ")]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(("" + (data.item.firm.name) + (data.item.firm.proprietor ? ' | '+data.item.firm.proprietor : '') + " | ₹: " + ((data.item.firm.amount || 0).toLocaleString())))}})],1)]}}]),model:{value:(_vm.selectedFirmFromAsset),callback:function ($$v) {_vm.selectedFirmFromAsset=$$v},expression:"selectedFirmFromAsset"}}),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.staffByBrand,"label":"Select Staff Account"},model:{value:(_vm.selectStaff),callback:function ($$v) {_vm.selectStaff=$$v},expression:"selectStaff"}}),_vm._v(" "),( _vm.selectedFirmFromAsset && _vm.selectStaff)?_c('v-select',{attrs:{"label":"Select transaction type","items":_vm.getTransactionTypeOptions},model:{value:(_vm.addition),callback:function ($$v) {_vm.addition=$$v},expression:"addition"}}):_vm._e(),_vm._v(" "),( _vm.selectedFirmFromAsset && _vm.selectStaff && _vm.addition)?_c('v-text-field',{attrs:{"type":"number","label":"Amount"},model:{value:(_vm.additionAmount),callback:function ($$v) {_vm.additionAmount=$$v},expression:"additionAmount"}}):_vm._e(),_vm._v(" "),(_vm.additionAmount)?_c('v-select',{attrs:{"dense":"","label":"Select Transaction Payment Type","items":_vm.paymentOptions},model:{value:(_vm.operationPaymentType),callback:function ($$v) {_vm.operationPaymentType=$$v},expression:"operationPaymentType"}}):_vm._e(),_vm._v(" "),(_vm.operationPaymentType === 'CashAndBank Account')?_c('v-text-field',{attrs:{"type":"number","label":"Transactionn Amount to Pay From Cash","error-messages":(Number(_vm.operationAmountFromCash) + Number(_vm.operationAmountFromBank)) != Number(_vm.additionAmount) && _vm.operationPaymentType == 'CashAndBank Account' ? ['Sum of Cash amount and bank amount should be equal to Asset Amount'] : []},model:{value:(_vm.operationAmountFromCash),callback:function ($$v) {_vm.operationAmountFromCash=$$v},expression:"operationAmountFromCash"}}):_vm._e(),_vm._v(" "),(_vm.operationPaymentType === 'CashAndBank Account')?_c('v-text-field',{attrs:{"type":"number","label":"Transactionn Amount to Pay From Bank","error-messages":(Number(_vm.operationAmountFromCash) + Number(_vm.operationAmountFromBank)) != Number(_vm.additionAmount) && _vm.operationPaymentType == 'CashAndBank Account' ? ['Sum of Cash amount and bank amount should be equal to Asset Amount'] : []},model:{value:(_vm.operationAmountFromBank),callback:function ($$v) {_vm.operationAmountFromBank=$$v},expression:"operationAmountFromBank"}}):_vm._e(),_vm._v(" "),(_vm.operationPaymentType && _vm.operationPaymentType !== 'Cash')?_c('v-select',{attrs:{"items":_vm.otherAccountByBrand,"label":"Bank Account to Pay operation amount from Bank","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                  "+_vm._s(data.item.text)+"\n              ")]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(((data.item.text) + "\n                          " + (data.item.account.bankName ? ' | '+data.item.account.bankName : '') + "\n                          " + (data.item.account.accountType ? ' | '+data.item.account.accountType : '') + "\n                          | ₹: " + ((data.item.account.amount || 0).toLocaleString()))
                      )}})],1)]}}],null,false,344035788),model:{value:(_vm.operationAccountForTransaction),callback:function ($$v) {_vm.operationAccountForTransaction=$$v},expression:"operationAccountForTransaction"}}):_vm._e(),_vm._v(" "),(_vm.additionAmount && _vm.operationPaymentType)?_c('v-text-field',{attrs:{"label":"Remark"},model:{value:(_vm.staffRemark),callback:function ($$v) {_vm.staffRemark=$$v},expression:"staffRemark"}}):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.salaryAmountClick}},[_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("money_off")]),_vm._v("Save\n  ")],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("cancel")]),_vm._v("Cancel\n  ")],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.openSalaryTable = true}}},[_vm._v("\n    View Salary Detail\n  ")]),_vm._v(" "),_c('v-dialog',{attrs:{"fullScreen":"","transition":"dialog-bottom-transition"},model:{value:(_vm.openSalaryTable),callback:function ($$v) {_vm.openSalaryTable=$$v},expression:"openSalaryTable"}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Salary Details")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.openSalaryTable = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card',[_c('salary-table-info',{attrs:{"accountsByBrand":_vm.accountsByBrand,"firmsByBrand":_vm.firmsByBrand,"staffAccount":_vm.staffAccount,"paymentOptions":_vm.paymentOptions},on:{"notify":_vm.notify}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_liability_vue__ = __webpack_require__(453);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21acb056_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_liability_vue__ = __webpack_require__(1389);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_liability_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21acb056_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_liability_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_liabilityTable_vue__ = __webpack_require__(454);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_596c3de6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_liabilityTable_vue__ = __webpack_require__(1388);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_liabilityTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_596c3de6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_liabilityTable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return liabilityOverallReport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);



var _this = this;

var liabilityOverallReport = function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2) {
        var firm = _ref2.firm,
            list = _ref2.list;
        var pdfDoc, runningBalance, debitTotal, creditTotal;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        pdfDoc = {
                            // pageOrientation: 'landscape',
                            content: [{
                                table: {
                                    widths: ['30%', '70%'],
                                    body: [[{
                                        text: 'COMMON REPORT ', style: 'schoolColorHeader2'
                                    }, {
                                        text: [{ text: '          ', bold: true, style: 'schoolColorHeader' }, { text: '\n', style: 'schoolColorHeader' }]
                                    }]]

                                },
                                layout: {
                                    hLineWidth: function hLineWidth(i, node) {
                                        return i === 0 || i === node.table.body.length ? 2 : 0;
                                    },
                                    vLineWidth: function vLineWidth(i, node) {
                                        return i === 0 || i === node.table.widths.length ? 2 : 0;
                                    },
                                    hLineColor: function hLineColor(i, node) {
                                        return i === 0 || i === node.table.body.length ? 'black' : 'white';
                                    },
                                    vLineColor: function vLineColor(i, node) {
                                        return i === 0 || i === node.table.widths.length ? 'black' : 'white';
                                    }
                                }
                            }, {
                                table: {
                                    headerRows: 1,
                                    widths: ['10%', "*", '15%', '15%', '15%', '15%'],
                                    body: [[{ text: 'S.No.', style: "schoolColorHeader1" }, { text: 'Staff', style: "schoolColorHeader1" }, { text: 'Debit (₹)', style: "schoolColorHeader1" }, { text: 'Credit (₹)', style: "schoolColorHeader1" }, { text: 'Running Balance (₹)', style: "schoolColorHeader1" }, { text: 'Remark', style: "schoolColorHeader1" }]]
                                }
                            }, {
                                table: {
                                    widths: ['33%', '34%', '33%'],
                                    body: [[{
                                        text: [{ text: '\n\n\n\n' }, { text: 'OFFICE INCHARGE ', bold: true, alignment: 'center', style: 'colorHeader' }, { text: '\n' }]
                                    }, {
                                        text: [{ text: '\n\n\n\n' }, { text: 'AUTHORITY SIGNATURE  ', bold: true, alignment: 'center', style: 'colorHeader' }, { text: '\n' }]
                                    }, {
                                        text: [{ text: '\n\n\n\n' }, { text: 'PRINCIPAL SIGNATURE  ', bold: true, alignment: 'center', style: 'colorHeader' }, { text: '\n' }]
                                    }]]

                                },
                                layout: {
                                    hLineWidth: function hLineWidth(i, node) {
                                        return i === 0 || i === node.table.body.length ? 2 : 0;
                                    },
                                    vLineWidth: function vLineWidth(i, node) {
                                        return i === 0 || i === node.table.widths.length ? 2 : 0;
                                    },
                                    hLineColor: function hLineColor(i, node) {
                                        return i === 0 || i === node.table.body.length ? 'black' : 'white';
                                    },
                                    vLineColor: function vLineColor(i, node) {
                                        return i === 0 || i === node.table.widths.length ? 'black' : 'white';
                                    }
                                }
                            }],
                            styles: {
                                feeHeader: {
                                    fontSize: 10,
                                    alignment: 'center'
                                },
                                feeTableHeader: {
                                    fontSize: 10,
                                    alignment: 'center',
                                    fillColor: '#1A237E',
                                    color: '#ffffff',
                                    bold: true
                                },
                                feeDescriptiveHeader: {
                                    fontSize: 10,
                                    alignment: 'left',
                                    bold: true
                                },
                                feeDescriptiveHeader1: {
                                    fontSize: 10,
                                    alignment: 'center',
                                    bold: true
                                },
                                topHeader: {
                                    color: '#ffffff',
                                    fontSize: 11,
                                    alignment: 'left',
                                    bold: true,
                                    fillColor: '#1A237E'
                                },
                                thankyouHeader: {
                                    color: '#ffffff',
                                    fontSize: 11,
                                    alignment: 'center',
                                    bold: true,
                                    fillColor: '#1A237E'
                                },
                                upcomingFeeHeader: {
                                    color: '#ffffff',
                                    fontSize: 11,
                                    alignment: 'left',
                                    bold: true,
                                    fillColor: '#1A237E'
                                },
                                colorHeader: {
                                    color: '#1A237E',
                                    fontSize: 12,
                                    bold: true
                                },
                                schoolColorHeader: {
                                    color: '#1A237E',
                                    fontSize: 14,
                                    bold: true,
                                    alignment: 'right'
                                },
                                schoolColorHeader1: {
                                    color: '#1A237E',
                                    fontSize: 9,
                                    bold: true,
                                    alignment: 'center'
                                },
                                schoolColorHeader2: {
                                    color: '#1A237E',
                                    fontSize: 14,
                                    bold: true,
                                    alignment: 'left'
                                },
                                studentDetails: {
                                    fontSize: 9,
                                    bold: true
                                },
                                studentDetailsRight: {
                                    fontSize: 9,
                                    bold: true
                                },
                                studentIncreaseFontDetails: {
                                    fontSize: 12,
                                    bold: true
                                },
                                studentIncreaseFontAmountDetails: {
                                    fontSize: 12,
                                    bold: true,
                                    color: '#1A237E'
                                },
                                studentBlankDetails: {
                                    fontSize: 20,
                                    bold: true,
                                    color: '#ffffff'
                                },
                                schoolDetails: {
                                    fontSize: 10,
                                    bold: true,
                                    alignment: 'right'
                                },
                                thankyouMsg: {
                                    color: '#1A237E',
                                    fontSize: 12,
                                    bold: true,
                                    alignment: 'center'
                                }
                            }

                            //school details

                        };
                        if (firm) {
                            pdfDoc.content[0].table.body[0][1].text[1].text = 'BMJ'.toUpperCase() + '\n';
                            // pdfDoc.content[0].table.body[0][1].text[3].text = (school.address || '') + '\n';
                            // pdfDoc.content[0].table.body[0][1].text[5].text = (school.boardAffiliationNumber || '') + '\n';
                            // pdfDoc.content[0].table.body[0][1].text[7].text = (school.schoolCode || '') + '\n';
                            // pdfDoc.content[0].table.body[0][1].text[9].text = (school.mobile || '') + '\n';
                        }

                        // pdfDoc.content[0].table.body[0][0].text += `[${selectedExpense}]`


                        runningBalance = 0;
                        debitTotal = 0;
                        creditTotal = 0;


                        list.forEach(function (pro, index) {
                            var isDebit = pro.type === 'liability';
                            var debit = isDebit ? Number(pro.amount) : 0;
                            var credit = !isDebit ? Number(pro.amount) : 0;

                            // Update totals
                            debitTotal += debit;
                            creditTotal += credit;

                            // Update running balance
                            runningBalance += debit - credit;

                            pdfDoc.content[1].table.body.push([{ text: index + 1, style: 'studentDetails' }, { text: pro.staffName || '', style: 'studentDetails' }, { text: debit ? debit.toFixed(2) : '500000.25', style: 'studentDetails' }, { text: credit ? credit.toFixed(2) : '500000.25', style: 'studentDetails' }, { text: '500000.25', style: 'studentDetails' }, { text: pro.remark || '', style: 'studentDetails' }]);
                        });

                        pdfDoc.content[1].table.body.push([{ text: '', style: 'studentDetails' }, { text: 'Total', style: 'studentDetailsRight' }, { text: '500000.25', style: 'studentDetails' }, { text: '500000.25', style: 'studentDetails' }, { text: '500000.25', style: 'studentDetails' }, { text: '', style: 'studentDetails' }]);
                        return _context.abrupt('return', pdfDoc);

                    case 8:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this);
    }));

    return function liabilityOverallReport(_x) {
        return _ref.apply(this, arguments);
    };
}();

/***/ }),
/* 1388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"mt-4",nativeOn:{"click":function($event){return _vm.printOverallLiability($event)}}},[_c('v-icon',[_vm._v("print")])],1),_vm._v(" "),_c('v-switch',{staticClass:"mb-2",attrs:{"inset":"","label":"Major Expenses"},model:{value:(_vm.hideZero),callback:function ($$v) {_vm.hideZero=$$v},expression:"hideZero"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-data-table',{staticClass:"elevation",attrs:{"items":_vm.getStaffAccount,"headers":_vm.headers},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.staffName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.staffRole))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.firmbyId(props.item.firm)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(props.item.creditTotal)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(props.item.debitTotal)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")((props.item.creditTotal - props.item.debitTotal))))]),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"primary white--text",on:{"click":function($event){return _vm.openLiabilityDialog(props.item)}}},[_vm._v("\n          View\n        ")])],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v(" No Staff to Show ")])],2),_vm._v(" "),_c('v-dialog',{attrs:{"transition":"dialog-bottom-transition"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.selectedStaffName))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation",attrs:{"items":_vm.selectedLiabilityList,"headers":_vm.liabilityListHeaders},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.isOpening ? "" : new Date(props.item.date).toLocaleDateString("en-GB")))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.isOpening ? "" : _vm.getFirmName(props.item.firm)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.transactionType))]),_vm._v(" "),(props.item.isCredited)?[_c('td',[_c('h3',{staticClass:"success--text text--darken-4"},[_vm._v("\n              "+_vm._s(_vm._f("amount")(props.item.amount))+"\n            ")])]),_vm._v(" "),_c('td')]:_vm._e(),_vm._v(" "),(!props.item.isCredited)?[_c('td'),_vm._v(" "),_c('td',[_c('h3',{staticClass:"error--text text--darken-4"},[_vm._v("\n              "+_vm._s(_vm._f("amount")(props.item.amount))+"\n            ")])])]:_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.isOpening ? "" : props.item.paymentType))]),_vm._v(" "),_c('td',[(props.item.invoiceIdCash || props.item.invoiceIdBank)?_c('v-btn',{staticClass:"primary--text",attrs:{"icon":""},on:{"click":function($event){return _vm.openAssetInvoiceEdit(props.item)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v(" edit ")])],1):_vm._e()],1),_vm._v(" "),_c('td',[(props.item.invoiceIdCash || props.item.invoiceIdBank)?_c('v-btn',{staticClass:"primary--text",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteLiability(props.item)}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v(" delete ")])],1):_vm._e()],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v(" no record found ")])],2)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialogEditInvoice),callback:function ($$v) {_vm.dialogEditInvoice=$$v},expression:"dialogEditInvoice"}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Edit Liability")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogEditInvoice = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card',{attrs:{"tile":""}},[_c('v-card-text',[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.assetdatepicker),callback:function ($$v) {_vm.assetdatepicker=$$v},expression:"assetdatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.liabilityInvoiceDate),callback:function ($$v) {_vm.liabilityInvoiceDate=$$v},expression:"liabilityInvoiceDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.assetdatepicker = false}},model:{value:(_vm.liabilityInvoiceDate),callback:function ($$v) {_vm.liabilityInvoiceDate=$$v},expression:"liabilityInvoiceDate"}})],1),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.firmsByBrand,"label":"Select Firm","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n            "+_vm._s(data.item.text)+"\n          ")]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(
                  ("" + (data.item.firm.name) + (data.item.firm.proprietor
                      ? ' | ' + data.item.firm.proprietor
                      : '') + " | ₹: " + ((data.item.firm.amount || 0).toLocaleString()))
                )}})],1)]}}]),model:{value:(_vm.selectedFirmFromAsset),callback:function ($$v) {_vm.selectedFirmFromAsset=$$v},expression:"selectedFirmFromAsset"}}),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.staffByBrand,"label":"Select Staff Account"},model:{value:(_vm.selectStaff),callback:function ($$v) {_vm.selectStaff=$$v},expression:"selectStaff"}}),_vm._v(" "),(_vm.selectedFirmFromAsset && _vm.selectStaff)?_c('v-select',{attrs:{"label":"Select transaction type","items":_vm.getTransactionTypeOptions},model:{value:(_vm.addition),callback:function ($$v) {_vm.addition=$$v},expression:"addition"}}):_vm._e(),_vm._v(" "),(_vm.selectedFirmFromAsset && _vm.selectStaff && _vm.addition)?_c('v-text-field',{attrs:{"type":"number","label":"Amount"},model:{value:(_vm.additionAmount),callback:function ($$v) {_vm.additionAmount=$$v},expression:"additionAmount"}}):_vm._e(),_vm._v(" "),(_vm.additionAmount)?_c('v-select',{attrs:{"dense":"","label":"Select Transaction Payment Type","items":_vm.paymentOptions},model:{value:(_vm.operationPaymentType),callback:function ($$v) {_vm.operationPaymentType=$$v},expression:"operationPaymentType"}}):_vm._e(),_vm._v(" "),(_vm.operationPaymentType === 'CashAndBank Account')?_c('v-text-field',{attrs:{"type":"number","label":"Transactionn Amount to Pay From Cash","error-messages":Number(_vm.operationAmountFromCash) +
              Number(_vm.operationAmountFromBank) !=
              Number(_vm.additionAmount) &&
            _vm.operationPaymentType == 'CashAndBank Account'
              ? [
                  'Sum of Cash amount and bank amount should be equal to Asset Amount' ]
              : []},model:{value:(_vm.operationAmountFromCash),callback:function ($$v) {_vm.operationAmountFromCash=$$v},expression:"operationAmountFromCash"}}):_vm._e(),_vm._v(" "),(_vm.operationPaymentType === 'CashAndBank Account')?_c('v-text-field',{attrs:{"type":"number","label":"Transactionn Amount to Pay From Bank","error-messages":Number(_vm.operationAmountFromCash) +
              Number(_vm.operationAmountFromBank) !=
              Number(_vm.additionAmount) &&
            _vm.operationPaymentType == 'CashAndBank Account'
              ? [
                  'Sum of Cash amount and bank amount should be equal to Asset Amount' ]
              : []},model:{value:(_vm.operationAmountFromBank),callback:function ($$v) {_vm.operationAmountFromBank=$$v},expression:"operationAmountFromBank"}}):_vm._e(),_vm._v(" "),(_vm.operationPaymentType && _vm.operationPaymentType !== 'Cash')?_c('v-select',{attrs:{"items":_vm.otherAccountByBrand,"label":"Bank Account to Pay operation amount from Bank","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n            "+_vm._s(data.item.text)+"\n          ")]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(
                  ((data.item.text) + "\n                          " + (data.item.account.bankName
                              ? ' | ' + data.item.account.bankName
                              : '') + "\n                          " + (data.item.account.accountType
                              ? ' | ' + data.item.account.accountType
                              : '') + "\n                          | ₹: " + ((
                            data.item.account.amount || 0
                          ).toLocaleString()))
                )}})],1)]}}],null,false,1819667846),model:{value:(_vm.operationAccountForTransaction),callback:function ($$v) {_vm.operationAccountForTransaction=$$v},expression:"operationAccountForTransaction"}}):_vm._e(),_vm._v(" "),(_vm.additionAmount && _vm.operationPaymentType)?_c('v-text-field',{attrs:{"label":"Remark"},model:{value:(_vm.staffRemark),callback:function ($$v) {_vm.staffRemark=$$v},expression:"staffRemark"}}):_vm._e(),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.liabilityAmountClick}},[_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("money_off")]),_vm._v("Save\n          ")],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.dialogEditInvoice = false}}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("cancel")]),_vm._v("Cancel\n          ")],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-5",attrs:{"flat":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.assetdatepicker),callback:function ($$v) {_vm.assetdatepicker=$$v},expression:"assetdatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.liabilityInvoiceDate),callback:function ($$v) {_vm.liabilityInvoiceDate=$$v},expression:"liabilityInvoiceDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.assetdatepicker = false}},model:{value:(_vm.liabilityInvoiceDate),callback:function ($$v) {_vm.liabilityInvoiceDate=$$v},expression:"liabilityInvoiceDate"}})],1),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.firmsByBrand,"label":"Select Firm","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n          "+_vm._s(data.item.text)+"\n      ")]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(("" + (data.item.firm.name) + (data.item.firm.proprietor ? ' | '+data.item.firm.proprietor : '') + " | ₹: " + ((data.item.firm.amount || 0).toLocaleString())))}})],1)]}}]),model:{value:(_vm.selectedFirmFromAsset),callback:function ($$v) {_vm.selectedFirmFromAsset=$$v},expression:"selectedFirmFromAsset"}}),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.staffByBrand,"label":"Select Staff Account"},model:{value:(_vm.selectStaff),callback:function ($$v) {_vm.selectStaff=$$v},expression:"selectStaff"}}),_vm._v(" "),( _vm.selectedFirmFromAsset && _vm.selectStaff)?_c('v-select',{attrs:{"label":"Select transaction type","items":_vm.getTransactionTypeOptions},model:{value:(_vm.addition),callback:function ($$v) {_vm.addition=$$v},expression:"addition"}}):_vm._e(),_vm._v(" "),( _vm.selectedFirmFromAsset && _vm.selectStaff && _vm.addition)?_c('v-text-field',{attrs:{"type":"number","label":"Amount"},model:{value:(_vm.additionAmount),callback:function ($$v) {_vm.additionAmount=$$v},expression:"additionAmount"}}):_vm._e(),_vm._v(" "),(_vm.additionAmount)?_c('v-select',{attrs:{"dense":"","label":"Select Transaction Payment Type","items":_vm.paymentOptions},model:{value:(_vm.operationPaymentType),callback:function ($$v) {_vm.operationPaymentType=$$v},expression:"operationPaymentType"}}):_vm._e(),_vm._v(" "),(_vm.operationPaymentType === 'CashAndBank Account')?_c('v-text-field',{attrs:{"type":"number","label":"Transactionn Amount to Pay From Cash","error-messages":(Number(_vm.operationAmountFromCash) + Number(_vm.operationAmountFromBank)) != Number(_vm.additionAmount) && _vm.operationPaymentType == 'CashAndBank Account' ? ['Sum of Cash amount and bank amount should be equal to Asset Amount'] : []},model:{value:(_vm.operationAmountFromCash),callback:function ($$v) {_vm.operationAmountFromCash=$$v},expression:"operationAmountFromCash"}}):_vm._e(),_vm._v(" "),(_vm.operationPaymentType === 'CashAndBank Account')?_c('v-text-field',{attrs:{"type":"number","label":"Transactionn Amount to Pay From Bank","error-messages":(Number(_vm.operationAmountFromCash) + Number(_vm.operationAmountFromBank)) != Number(_vm.additionAmount) && _vm.operationPaymentType == 'CashAndBank Account' ? ['Sum of Cash amount and bank amount should be equal to Asset Amount'] : []},model:{value:(_vm.operationAmountFromBank),callback:function ($$v) {_vm.operationAmountFromBank=$$v},expression:"operationAmountFromBank"}}):_vm._e(),_vm._v(" "),(_vm.operationPaymentType && _vm.operationPaymentType !== 'Cash')?_c('v-select',{attrs:{"items":_vm.otherAccountByBrand,"label":"Bank Account to Pay operation amount from Bank","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                  "+_vm._s(data.item.text)+"\n              ")]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(((data.item.text) + "\n                          " + (data.item.account.bankName ? ' | '+data.item.account.bankName : '') + "\n                          " + (data.item.account.accountType ? ' | '+data.item.account.accountType : '') + "\n                          | ₹: " + ((data.item.account.amount || 0).toLocaleString()))
                      )}})],1)]}}],null,false,344035788),model:{value:(_vm.operationAccountForTransaction),callback:function ($$v) {_vm.operationAccountForTransaction=$$v},expression:"operationAccountForTransaction"}}):_vm._e(),_vm._v(" "),(_vm.additionAmount && _vm.operationPaymentType)?_c('v-text-field',{attrs:{"label":"Remark"},model:{value:(_vm.staffRemark),callback:function ($$v) {_vm.staffRemark=$$v},expression:"staffRemark"}}):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.liabilityAmountClick}},[_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("money_off")]),_vm._v("Save\n  ")],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("cancel")]),_vm._v("Cancel\n  ")],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.openLiabilityTable = true}}},[_vm._v("\n    View Details\n  ")]),_vm._v(" "),_c('v-dialog',{attrs:{"fullScreen":"","transition":"dialog-bottom-transition"},model:{value:(_vm.openLiabilityTable),callback:function ($$v) {_vm.openLiabilityTable=$$v},expression:"openLiabilityTable"}},[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Liability Details")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.openLiabilityTable = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card',[_c('liability-table-info',{attrs:{"accountsByBrand":_vm.accountsByBrand,"firmsByBrand":_vm.firmsByBrand,"staffAccount":_vm.staffAccount,"paymentOptions":_vm.paymentOptions},on:{"notify":_vm.notify}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-sm":""}},[_c('v-card',[_c('v-tabs',{attrs:{"centered":"","color":"primary","dark":"","icons-and-text":"","fixed-tabs":"","scrollable":"","slider-color":""}},[_c('v-tabs-slider',{attrs:{"color":"yellow"}}),_vm._v(" "),_c('v-tab',{key:2,on:{"click":function($event){_vm.transfer = false; _vm.deposit=false; _vm.expense=true; _vm.withdrawl=false; _vm.income=false; _vm.asset=false; _vm.staff=false; _vm.liability=false;}}},[_vm._v("\n            Expense\n            "),_c('v-icon',[_vm._v("money_off")])],1),_vm._v(" "),_c('v-tab',{key:3,on:{"click":function($event){_vm.transfer = false; _vm.deposit=false; _vm.expense=false; _vm.withdrawl=false; _vm.income=true; _vm.asset=false; _vm.staff=false; _vm.liability=false;}}},[_vm._v("\n            Income\n            "),_c('v-icon',[_vm._v("money_off")])],1),_vm._v(" "),_c('v-tab',{key:4,on:{"click":function($event){_vm.transfer = false; _vm.deposit=false; _vm.expense=false; _vm.withdrawl=false; _vm.income=false; _vm.asset=true; _vm.staff=false; _vm.liability=false;}}},[_vm._v("\n            Asset\n            "),_c('v-icon',[_vm._v("money_off")])],1),_vm._v(" "),_c('v-tab',{key:5,on:{"click":function($event){_vm.transfer = false; _vm.deposit=false; _vm.expense=false; _vm.withdrawl=false; _vm.income=false; _vm.asset=false; _vm.staff=true; _vm.liability=false;}}},[_vm._v("\n            Salary\n            "),_c('v-icon',[_vm._v("money_off")])],1),_vm._v(" "),_c('v-tab',{key:6,on:{"click":function($event){_vm.transfer = false; _vm.deposit=false; _vm.expense=false; _vm.withdrawl=false; _vm.income=false; _vm.asset=false; _vm.staff=false; _vm.liability=true;}}},[_vm._v("\n            Common\n            "),_c('v-icon',[_vm._v("money_off")])],1),_vm._v(" "),_c('v-tab-item',{key:2},[(_vm.expense)?_c('expense-tab',{attrs:{"selectedBrand":_vm.selectedBrand || [],"firmsByBrand":_vm.firmsByBrand || [],"accountsByBrand":_vm.accountsByBrand || []},on:{"notify":_vm.notify,"closeDialog":_vm.closeDialog}}):_vm._e()],1),_vm._v(" "),_c('v-tab-item',{key:3},[(_vm.income)?_c('income-tab',{attrs:{"selectedBrand":_vm.selectedBrand || [],"firmsByBrand":_vm.firmsByBrand || [],"accountsByBrand":_vm.accountsByBrand || []},on:{"notify":_vm.notify,"closeDialog":_vm.closeDialog}}):_vm._e()],1),_vm._v(" "),_c('v-tab-item',{key:4},[(_vm.asset)?_c('asset-tab',{attrs:{"selectedBrand":_vm.selectedBrand || [],"firmsByBrand":_vm.firmsByBrand || [],"accountsByBrand":_vm.accountsByBrand || [],"assetByBrand":_vm.assetByBrand || []},on:{"notify":_vm.notify,"closeDialog":_vm.closeDialog}}):_vm._e()],1),_vm._v(" "),_c('v-tab-item',{key:5},[(_vm.staff)?_c('salary-tab',{attrs:{"selectedBrand":_vm.selectedBrand || [],"firmsByBrand":_vm.firmsByBrand || [],"accountsByBrand":_vm.accountsByBrand || [],"assetByBrand":_vm.assetByBrand || [],"staffAccount":_vm.getStaff || []},on:{"notify":_vm.notify,"closeDialog":_vm.closeDialog}}):_vm._e()],1),_vm._v(" "),_c('v-tab-item',{key:6},[(_vm.liability)?_c('liability-tab',{attrs:{"selectedBrand":_vm.selectedBrand || [],"firmsByBrand":_vm.firmsByBrand || [],"accountsByBrand":_vm.accountsByBrand || [],"assetByBrand":_vm.assetByBrand || [],"staffAccount":_vm.getStaff || []},on:{"notify":_vm.notify,"closeDialog":_vm.closeDialog}}):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"top":"","color":"error","timeout":3000},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n "+_vm._s(_vm.snackbarText)+"\n  ")]),_vm._v(" "),_c('v-snackbar',{attrs:{"top":"","color":"success","timeout":3000},model:{value:(_vm.snackbarSuccess),callback:function ($$v) {_vm.snackbarSuccess=$$v},expression:"snackbarSuccess"}},[_vm._v("\n "+_vm._s(_vm.snackbarSuccessText)+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(455);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bde5f9a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1395);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1bde5f9a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__(456);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_339fb2a8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(1394);
function injectStyle (ssrContext) {
  __webpack_require__(1393)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-339fb2a8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_339fb2a8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1393 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-card',{attrs:{"height":"100%"}},[_c('v-list',[_vm._l((_vm.items),function(item,index){return [(item.header)?_c('v-subheader',{key:item.header,staticClass:"primary title white--text",attrs:{"primary-title":""},domProps:{"innerHTML":_vm._s(item.header)}}):(item.divider)?_c('v-divider',{key:index,attrs:{"inset":item.inset}}):(!item.isMultiple)?[_c('router-link',{key:item['.key'],attrs:{"tag":"v-list-tile","to":{ 
              name: item.link
            },"avatar":""}},[_c('v-list-tile-avatar',[_c('i',{staticClass:"material-icons primary--text"},[_vm._v("\n                  "+_vm._s(item.icon)+"\n                ")])]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"primary--text font-weight-bold",domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"primary--text font-weight-light",domProps:{"innerHTML":_vm._s(item.subtitle)}})],1)],1)]:(item.isMultiple)?[_c('v-list-group',{key:item.title,attrs:{"value":false},scopedSlots:_vm._u([{key:"activator",fn:function(){return [_c('v-list-tile-avatar',{style:(item.style)},[_c('i',{staticClass:"material-icons primary--text",staticStyle:{"padding-left":"25px"}},[_vm._v("\n                  "+_vm._s(item.icon)+"\n                ")])]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"subheading primary--text font-weight-bold",domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"primary--text font-weight-light",domProps:{"innerHTML":_vm._s(item.subtitle)}})],1)]},proxy:true}],null,true)},[_vm._v(" "),_vm._l((item.children),function(item1,index1){return [(item1.divider)?_c('v-divider',{key:index1,attrs:{"inset":item.inset}}):_c('router-link',{key:item1['.key'],staticStyle:{"padding-left":"35px"},attrs:{"tag":"v-list-tile","to":{ 
                  name: item1.link
                },"avatar":""}},[_c('v-list-tile-avatar',[_c('i',{staticClass:"material-icons primary--text"},[_vm._v("\n                  "+_vm._s(item1.icon)+"\n                ")])]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"primary--text font-weight-bold",domProps:{"innerHTML":_vm._s(item1.title)}}),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"primary--text font-weight-light",domProps:{"innerHTML":_vm._s(item1.subtitle)}})],1)],1)]})],2)]:_vm._e()]})],2)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-xs":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"sm3":"","md3":""}},[_c('sidebar')],1),_vm._v(" "),_c('v-flex',{attrs:{"sm9":"","md9":""}},[_c('router-view',{attrs:{"bankByBrand":_vm.bankByBrand}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_product_vue__ = __webpack_require__(457);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_608d64c5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_product_vue__ = __webpack_require__(1399);
function injectStyle (ssrContext) {
  __webpack_require__(1397)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_product_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_608d64c5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_product_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1397 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticStyle:{"padding":"0","height":"100%"},attrs:{"fluid":""}},[_c('v-card',{staticStyle:{"height":"100%"}},[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Product Summary")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){return _vm.close()}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[(_vm.currentProd != null)?_c('v-stepper',{attrs:{"vertical":""},model:{value:(_vm.stepValue),callback:function ($$v) {_vm.stepValue=$$v},expression:"stepValue"}},[_c('v-stepper-step',{attrs:{"complete":_vm.stepValue > 1,"step":"1"}},[_vm._v("Step : 1 "),_c('h3',{staticClass:"error--text text--darken-4"},[_vm._v(_vm._s(_vm.duplicateError))])]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-card',{staticClass:"mb-12",staticStyle:{"height":"100%"}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-combobox',{attrs:{"items":_vm.productListByBrand,"return-object":false,"item-text":"name","item-value":"name","label":"Product Name","placeholder":"Enter Product name"},on:{"change":function($event){return _vm.duplicateCheck()}},model:{value:(_vm.currentProd.name),callback:function ($$v) {_vm.$set(_vm.currentProd, "name", $$v)},expression:"currentProd.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-switch',{attrs:{"label":_vm.currentProd.isActive ? 'Active' : 'Inactive'},model:{value:(_vm.currentProd.isActive),callback:function ($$v) {_vm.$set(_vm.currentProd, "isActive", $$v)},expression:"currentProd.isActive"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.productGroupListByBrand,"label":"Select Group","item-text":"text","item-value":"value"},model:{value:(_vm.currentProd.productGroup),callback:function ($$v) {_vm.$set(_vm.currentProd, "productGroup", $$v)},expression:"currentProd.productGroup"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.firmsByBrand,"label":"Select Firm","item-text":"text","item-value":"value"},model:{value:(_vm.currentProd.firm),callback:function ($$v) {_vm.$set(_vm.currentProd, "firm", $$v)},expression:"currentProd.firm"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Product Weight"},model:{value:(_vm.currentProd.weight),callback:function ($$v) {_vm.$set(_vm.currentProd, "weight", $$v)},expression:"currentProd.weight"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"type":"text","label":"Product Description"},model:{value:(_vm.currentProd.description),callback:function ($$v) {_vm.$set(_vm.currentProd, "description", $$v)},expression:"currentProd.description"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.productTypeListByBrand,"label":"Select Type","item-text":"text","item-value":"value"},model:{value:(_vm.currentProd.productType),callback:function ($$v) {_vm.$set(_vm.currentProd, "productType", $$v)},expression:"currentProd.productType"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.productCategoryListByBrand,"label":"Select Category","item-text":"text","item-value":"value"},model:{value:(_vm.currentProd.productCategory),callback:function ($$v) {_vm.$set(_vm.currentProd, "productCategory", $$v)},expression:"currentProd.productCategory"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"type":"text","label":"Product Barcode"},model:{value:(_vm.currentProd.barcode),callback:function ($$v) {_vm.$set(_vm.currentProd, "barcode", $$v)},expression:"currentProd.barcode"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.generateBarcode(null)}}},[_vm._v("Generate New Barcode")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.printBarcode()}}},[_vm._v("Print Barcode")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.currentProd.barcode)?_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_vm._v("\n                      Barcode Image\n                      "),_c('br'),_vm._v(" "),_c('svg',{attrs:{"id":"barcode"}})]):_vm._e(),_vm._v(" "),(_vm.currentProd.businessType == 'Medical/Pesticides')?_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-autocomplete',{attrs:{"items":_vm.compositionSuggestions,"label":"Select or Add Composition","multiple":"","clearable":""},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addComposition($event)}},model:{value:(_vm.currentProd.composition),callback:function ($$v) {_vm.$set(_vm.currentProd, "composition", $$v)},expression:"currentProd.composition"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Set Alert Quantity"},model:{value:(_vm.currentProd.alertQuantity),callback:function ($$v) {_vm.$set(_vm.currentProd, "alertQuantity", $$v)},expression:"currentProd.alertQuantity"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.GST_types,"label":"Select GST type"},model:{value:(_vm.currentProd.GST_type),callback:function ($$v) {_vm.$set(_vm.currentProd, "GST_type", $$v)},expression:"currentProd.GST_type"}})],1),_vm._v(" "),(_vm.currentProd.GST_type === 'TAXABLE')?_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"type":"number","dense":"","items":[3,5,12,18,28],"disabled":_vm.currentProd.GST_type != 'TAXABLE',"label":"Taxable GST rate"},model:{value:(_vm.currentProd.taxableGST_rate),callback:function ($$v) {_vm.$set(_vm.currentProd, "taxableGST_rate", $$v)},expression:"currentProd.taxableGST_rate"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"type":"number","label":"HSN code"},model:{value:(_vm.currentProd.HSN_code),callback:function ($$v) {_vm.$set(_vm.currentProd, "HSN_code", $$v)},expression:"currentProd.HSN_code"}})],1),_vm._v(" "),(!_vm.currentProd.unitsDeatilsAdded)?_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.units,"label":"Select unit"},model:{value:(_vm.currentProd.unit),callback:function ($$v) {_vm.$set(_vm.currentProd, "unit", $$v)},expression:"currentProd.unit"}})],1):_vm._e(),_vm._v(" "),(!_vm.currentProd.unitsDeatilsAdded)?_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.units,"label":"Select Major Unit"},model:{value:(_vm.currentProd.majorUnit),callback:function ($$v) {_vm.$set(_vm.currentProd, "majorUnit", $$v)},expression:"currentProd.majorUnit"}})],1):_vm._e(),_vm._v(" "),(!_vm.currentProd.unitsDeatilsAdded)?_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Major Unit Quantity"},model:{value:(_vm.currentProd.majorUnitQuantity),callback:function ($$v) {_vm.$set(_vm.currentProd, "majorUnitQuantity", $$v)},expression:"currentProd.majorUnitQuantity"}})],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-select',{attrs:{"dense":"","items":[
                            {
                              text: 'Yes',
                              value: true
                            },
                            {
                              text: 'No',
                              value: false
                            } ],"label":"Do you have Multiple units Of Product?"},model:{value:(_vm.currentProd.unitsDeatilsAdded),callback:function ($$v) {_vm.$set(_vm.currentProd, "unitsDeatilsAdded", $$v)},expression:"currentProd.unitsDeatilsAdded"}})],1)],1),_vm._v(" "),(_vm.currentProd.unitsDeatilsAdded)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-layout',{attrs:{"wrap":""}},[_vm._l((_vm.currentProd.unitsDetails),function(unitDetail){return [_c('v-flex',{key:unitDetail.order + 'flex1',attrs:{"xs2":""}},[_c('v-select',{key:unitDetail.order + 'unit',attrs:{"dense":"","items":_vm.units,"label":'Select unit ( ' + unitDetail.order + '.)'},model:{value:(unitDetail.unit),callback:function ($$v) {_vm.$set(unitDetail, "unit", $$v)},expression:"unitDetail.unit"}})],1),_vm._v(" "),_c('v-flex',{key:unitDetail.order + 'flex3',attrs:{"xs2":""}},[(unitDetail.unit)?_c('v-text-field',{key:unitDetail.order + 'rateP',attrs:{"type":"number","label":'Purchasing Rate of 1 '+ unitDetail.unit},model:{value:(unitDetail.purchasingPrice),callback:function ($$v) {_vm.$set(unitDetail, "purchasingPrice", $$v)},expression:"unitDetail.purchasingPrice"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{key:unitDetail.order + 'flex6',attrs:{"xs2":""}},[(unitDetail.unit)?_c('v-text-field',{key:unitDetail.order + 'rateS',attrs:{"type":"number","label":'Selling Rate of 1 '+ unitDetail.unit},model:{value:(unitDetail.sellingPrice),callback:function ($$v) {_vm.$set(unitDetail, "sellingPrice", $$v)},expression:"unitDetail.sellingPrice"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{key:unitDetail.order + 'flex2',attrs:{"xs2":""}},[(!unitDetail.isFirst)?_c('v-text-field',{key:unitDetail.order + 'quantity',attrs:{"type":"number","label":'Quantity'},model:{value:(unitDetail.quantity),callback:function ($$v) {_vm.$set(unitDetail, "quantity", $$v)},expression:"unitDetail.quantity"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{key:unitDetail.order + 'flex4',attrs:{"xs2":""}},[(unitDetail.isLast && unitDetail.unit)?_c('v-btn',{key:unitDetail.order + 'add',staticClass:"primary white--text",attrs:{"flat":""},on:{"click":function($event){return _vm.addUnitData(unitDetail)}}},[_vm._v("Add next unit \n                              "),_c('v-icon',[_vm._v("add")])],1):_vm._e()],1),_vm._v(" "),_c('v-flex',{key:unitDetail.order + 'flex5',attrs:{"xs2":""}},[(unitDetail.isLast && !unitDetail.isFirst)?_c('v-btn',{key:unitDetail.order + 'close',staticClass:"primary white--text",on:{"click":function($event){return _vm.removeUnitData(unitDetail)}}},[_vm._v("Remove\n                              "),_c('v-icon',[_vm._v("close")])],1):_vm._e()],1)]})],2)],1):_vm._e(),_vm._v(" "),(_vm.currentProd.businessType == 'Jwellery')?_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-switch',{attrs:{"label":("Labour Charge: " + (_vm.currentProd.isSpecialChargePercentage ? '%' : '₹'))},model:{value:(_vm.currentProd.isSpecialChargePercentage),callback:function ($$v) {_vm.$set(_vm.currentProd, "isSpecialChargePercentage", $$v)},expression:"currentProd.isSpecialChargePercentage"}})],1):_vm._e(),_vm._v(" "),(_vm.currentProd.isSpecialChargePercentage)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"disabled":!_vm.currentProd.isSpecialChargePercentage,"type":"number","suffix":"%","label":"Labour Charge in %"},on:{"keyup":function($event){return _vm.calculateSpecialCharge()}},model:{value:(_vm.currentProd.specialChargePercentage),callback:function ($$v) {_vm.$set(_vm.currentProd, "specialChargePercentage", _vm._n($$v))},expression:"currentProd.specialChargePercentage"}})],1):_vm._e(),_vm._v(" "),(_vm.currentProd.isSpecialChargePercentage)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"type":"number","suffix":"₹","disabled":_vm.currentProd.isSpecialChargePercentage,"label":"Labour Charge in ₹"},model:{value:(_vm.currentProd.specialCharge),callback:function ($$v) {_vm.$set(_vm.currentProd, "specialCharge", _vm._n($$v))},expression:"currentProd.specialCharge"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.stepValue = 2}}},[_vm._v("Next")])],1)],1)],1),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.stepValue > 2,"step":"2"}},[_vm._v("Step : 2")]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-card',{staticClass:"mb-12",staticStyle:{"height":"100%"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-select',{attrs:{"dense":"","items":[
                        {
                          text: 'Yes',
                          value: true
                        },
                        {
                          text: 'No',
                          value: false
                        } ],"label":"Do you have Opening Balance Of Product?"},model:{value:(_vm.isOpeningBalance),callback:function ($$v) {_vm.isOpeningBalance=$$v},expression:"isOpeningBalance"}})],1)],1),_vm._v(" "),(_vm.isOpeningBalance)?_c('v-layout',{attrs:{"wrap":""}},[(_vm.isOpeningBalance)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker),callback:function ($$v) {_vm.datepicker=$$v},expression:"datepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.currentProd.openingDate),callback:function ($$v) {_vm.$set(_vm.currentProd, "openingDate", $$v)},expression:"currentProd.openingDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepicker = false}},model:{value:(_vm.currentProd.openingDate),callback:function ($$v) {_vm.$set(_vm.currentProd, "openingDate", $$v)},expression:"currentProd.openingDate"}})],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","label": true ? this.getLastUnit : this.currentProd.unit+')'},model:{value:(_vm.currentProd.quantity),callback:function ($$v) {_vm.$set(_vm.currentProd, "quantity", $$v)},expression:"currentProd.quantity"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Opening Amount"},model:{value:(_vm.currentProd.openingBalance),callback:function ($$v) {_vm.$set(_vm.currentProd, "openingBalance", $$v)},expression:"currentProd.openingBalance"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-text-field',{attrs:{"disabled":true,"type":"number","value":(Number.parseFloat((_vm.currentProd.openingBalance * 100) / (_vm.currentProd.taxableGST_rate + 100))).toFixed(2),"label":"Basic Value"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-text-field',{attrs:{"disabled":true,"type":"number","value":(Number.parseFloat ((_vm.currentProd.openingBalance || 0) - ((_vm.currentProd.openingBalance * 100) / (_vm.currentProd.taxableGST_rate + 100)))).toFixed(2),"label":"GST Value"}})],1),_vm._v(" "),_vm._l((_vm.productRateCategories),function(cat){return [_c('v-flex',{key:cat['.key'] + 'a',attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"disabled":true,"value":cat.name,"label":"Category"}})],1),_vm._v(" "),_c('v-flex',{key:cat['.key'] + 'b',attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Selling Price"},model:{value:(_vm.currentProd.sellingPriceByCategories[cat['.key']]),callback:function ($$v) {_vm.$set(_vm.currentProd.sellingPriceByCategories, cat['.key'], $$v)},expression:"currentProd.sellingPriceByCategories[cat['.key']]"}})],1)]})],2):_vm._e()],1),_vm._v(" "),_c('v-card-text',[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.stepValue = 3}}},[_vm._v("Next")]),_vm._v(" "),_c('v-btn',{attrs:{"text":""},on:{"click":function($event){_vm.stepValue = 1}}},[_vm._v("Back")])],1)],1)],1),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.stepValue > 3,"step":"3"}},[_vm._v("Step : 3")]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"3"}},[_c('v-card',{staticClass:"mb-12",staticStyle:{"height":"100%"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-select',{attrs:{"dense":"","items":[
                        {
                          text: 'Yes',
                          value: true
                        },
                        {
                          text: 'No',
                          value: false
                        } ],"label":"Do you want to add Standard Price of the Product?"},model:{value:(_vm.isStanderedPrice),callback:function ($$v) {_vm.isStanderedPrice=$$v},expression:"isStanderedPrice"}})],1),_vm._v(" "),(_vm.isStanderedPrice)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-select',{attrs:{"dense":"","disabled":true,"items":_vm.units,"label":"Selected unit","value":this.currentProd.unitsDeatilsAdded ? this.getLastUnit : this.currentProd.unit}})],1):_vm._e(),_vm._v(" "),(_vm.isStanderedPrice)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-select',{attrs:{"dense":"","items":[3,5,12,18,28],"disabled":true,"label":"Taxable GST rate"},model:{value:(_vm.currentProd.taxableGST_rate),callback:function ($$v) {_vm.$set(_vm.currentProd, "taxableGST_rate", $$v)},expression:"currentProd.taxableGST_rate"}})],1):_vm._e(),_vm._v(" "),(_vm.isStanderedPrice && _vm.currentProd.taxableGST_rate)?_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-switch',{attrs:{"label":_vm.addIncPrice ? 'Mention Price Including GST' : 'Mention Price Excluding GST'},model:{value:(_vm.addIncPrice),callback:function ($$v) {_vm.addIncPrice=$$v},expression:"addIncPrice"}})],1):_vm._e()],1),_vm._v(" "),(_vm.isStanderedPrice)?_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","disabled":_vm.addIncPrice,"label":"Purchasing Price [Excluding GST]"},model:{value:(_vm.currentProd.purchasingPrice),callback:function ($$v) {_vm.$set(_vm.currentProd, "purchasingPrice", $$v)},expression:"currentProd.purchasingPrice"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","disabled":!_vm.addIncPrice,"label":"Purchasing Price [Including GST]"},model:{value:(_vm.purchasingPriceInc),callback:function ($$v) {_vm.purchasingPriceInc=$$v},expression:"purchasingPriceInc"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","disabled":_vm.addIncPrice,"label":"Selling Price [Excluding GST]"},model:{value:(_vm.currentProd.sellingPrice),callback:function ($$v) {_vm.$set(_vm.currentProd, "sellingPrice", $$v)},expression:"currentProd.sellingPrice"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","disabled":!_vm.addIncPrice,"label":"Selling Price [Including GST]"},model:{value:(_vm.sellingPriceInc),callback:function ($$v) {_vm.sellingPriceInc=$$v},expression:"sellingPriceInc"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"type":"number","label":"MRP [Including GST]"},model:{value:(_vm.currentProd.MRPRate),callback:function ($$v) {_vm.$set(_vm.currentProd, "MRPRate", $$v)},expression:"currentProd.MRPRate"}})],1),_vm._v(" "),_c('v-spacer')],1):_vm._e()],1),_vm._v(" "),_c('v-card-text',[_c('v-btn',{attrs:{"text":""},on:{"click":function($event){_vm.stepValue = 2}}},[_vm._v("Back")]),_vm._v(" "),(!_vm.currentProd['.key'])?_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.saveProduct(false)}}},[_vm._v("Save")]):_vm._e(),_vm._v(" "),(!_vm.currentProd['.key'])?_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.saveProduct(true)}}},[_vm._v("Save & add")]):_vm._e(),_vm._v(" "),(!!_vm.currentProd['.key'])?_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.updateProduct}},[_vm._v("Update")]):_vm._e()],1)],1)],1)],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('router-link',{attrs:{"to":"/Dashboard"}},[_c('v-btn',{attrs:{"icon":"","dark":""}},[_c('v-icon',[_vm._v("keyboard_backspace")])],1)],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("PRODUCTS")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"prepend-inner-icon":"search","solo":"","outlined":"","clearable":"","autofocus":true,"label":"Search Product"},nativeOn:{"keyup":function($event){return _vm.keymonitor($event)}}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-switch',{staticClass:"white-switch",attrs:{"color":"white","label":_vm.showOnlyActiveProd ? 'Active Products' : 'All Products'},model:{value:(_vm.showOnlyActiveProd),callback:function ($$v) {_vm.showOnlyActiveProd=$$v},expression:"showOnlyActiveProd"}}),_vm._v(" "),_c('v-select',{staticClass:"white-select",attrs:{"items":_vm.productGroupListByBrand,"label":"Group","item-text":"text","item-value":"value","color":"white","clearable":""},model:{value:(_vm.selectedGroup),callback:function ($$v) {_vm.selectedGroup=$$v},expression:"selectedGroup"}}),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{staticClass:"white--text",attrs:{"outline":"","disabled":!_vm.hasProductAddPermission},on:{"click":_vm.addProduct}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("add")]),_vm._v("\n              NEW PRODUCT\n          ")],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.productListHeader,"items":_vm.productListByBrand,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',[_vm._v(_vm._s(props.item['name']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-light"},[_vm._v(_vm._s(props.item['description']))]),_vm._v(" \n              -\n            "),_c('b',{staticClass:"font-weight-light"},[_vm._v(_vm._s(props.item['HSN_code']))]),_vm._v("\n              -\n            "),_c('b',{staticClass:"font-weight-light"},[_vm._v(_vm._s(props.item['GST_type']))]),_vm._v("\n              -\n            "),_c('b',{staticClass:"font-weight-light"},[_vm._v(_vm._s(props.item.taxableGST_rate))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['unit']))])]),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"disabled":!_vm.hasProductTransferPermission,"icon":""},on:{"click":function($event){return _vm.openTansferDialog(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("double_arrow")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.openBranchDialog(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("store")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.openBatchDialog(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("add")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.viewProductByBatch(props.item)}}},[_c('v-icon',{attrs:{"color":"blue"}},[_vm._v("remove_red_eye")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"disabled":!_vm.hasProductEditPermission,"icon":""},on:{"click":function($event){return _vm.editProduct(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"disabled":!_vm.hasProductDeletePermission,"icon":""},on:{"click":function($event){return _vm.deleteProduct(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.openDamageDialog(props.item)}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("warning")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","fullscreen":"","hide-overlay":""},model:{value:(_vm.addProductDialog),callback:function ($$v) {_vm.addProductDialog=$$v},expression:"addProductDialog"}},[(_vm.addProductDialog)?_c('add-product',{attrs:{"currentProduct":_vm.currentProduct,"stepperValue":_vm.stepperValue},on:{"updateProduct":function($event){return _vm.updateProduct()},"saveProduct":_vm.saveProduct,"close":function($event){_vm.addProductDialog = false}}}):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"1000px"},model:{value:(_vm.transferDialog),callback:function ($$v) {_vm.transferDialog=$$v},expression:"transferDialog"}},[_c('v-card',{attrs:{"persistent":""}},[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Shift/Transfer Items")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-combobox',{attrs:{"items":_vm.productListByBrand,"return-object":true,"item-text":"name","label":"Product"},model:{value:(_vm.productToTansfer),callback:function ($$v) {_vm.productToTansfer=$$v},expression:"productToTansfer"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerTransfer),callback:function ($$v) {_vm.datepickerTransfer=$$v},expression:"datepickerTransfer"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.transferDate),callback:function ($$v) {_vm.transferDate=$$v},expression:"transferDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerTransfer = false}},model:{value:(_vm.transferDate),callback:function ($$v) {_vm.transferDate=$$v},expression:"transferDate"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-combobox',{attrs:{"items":_vm.godawnByBrand,"return-object":true,"item-text":"godawnName","label":"Select Godawn"},model:{value:(_vm.currentGodawn),callback:function ($$v) {_vm.currentGodawn=$$v},expression:"currentGodawn"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Quantity"},model:{value:(_vm.transferQuantity),callback:function ($$v) {_vm.transferQuantity=$$v},expression:"transferQuantity"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){_vm.transferDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){return _vm.transferToGodawn()}}},[_vm._v("Move")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"1000px"},model:{value:(_vm.branchDialog),callback:function ($$v) {_vm.branchDialog=$$v},expression:"branchDialog"}},[_c('v-card',{attrs:{"persistent":""}},[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Branch - Transfer ")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-combobox',{attrs:{"items":_vm.productListByBrand,"return-object":true,"item-text":"name","label":"Product"},model:{value:(_vm.productToBranch),callback:function ($$v) {_vm.productToBranch=$$v},expression:"productToBranch"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerTransfer),callback:function ($$v) {_vm.datepickerTransfer=$$v},expression:"datepickerTransfer"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.branchDate),callback:function ($$v) {_vm.branchDate=$$v},expression:"branchDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerBranch = false}},model:{value:(_vm.branchDate),callback:function ($$v) {_vm.branchDate=$$v},expression:"branchDate"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-combobox',{attrs:{"items":_vm.branchByBrand,"return-object":true,"item-text":"branchName","label":"Select Branch"},model:{value:(_vm.currentBranch),callback:function ($$v) {_vm.currentBranch=$$v},expression:"currentBranch"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Quantity"},model:{value:(_vm.branchQuantity),callback:function ($$v) {_vm.branchQuantity=$$v},expression:"branchQuantity"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){_vm.branchDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){return _vm.transferToBranch()}}},[_vm._v("Move")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"1000px"},model:{value:(_vm.batchDialog),callback:function ($$v) {_vm.batchDialog=$$v},expression:"batchDialog"}},[_c('v-card',{attrs:{"persistent":""}},[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Add Batch Details")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}},[_c('v-combobox',{attrs:{"items":_vm.productListByBrand,"return-object":true,"item-text":"name","label":"Product"},model:{value:(_vm.productToBatch),callback:function ($$v) {_vm.productToBatch=$$v},expression:"productToBatch"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}},[_c('v-text-field',{attrs:{"type":"text","label":"BatchNumber"},model:{value:(_vm.batchNumber),callback:function ($$v) {_vm.batchNumber=$$v},expression:"batchNumber"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerBatch),callback:function ($$v) {_vm.datepickerBatch=$$v},expression:"datepickerBatch"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"ManuFacturing Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.manufacuturingDate),callback:function ($$v) {_vm.manufacuturingDate=$$v},expression:"manufacuturingDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerBatch = false}},model:{value:(_vm.manufacuturingDate),callback:function ($$v) {_vm.manufacuturingDate=$$v},expression:"manufacuturingDate"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.todatepickerBatch),callback:function ($$v) {_vm.todatepickerBatch=$$v},expression:"todatepickerBatch"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Expiry Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.expiryDate),callback:function ($$v) {_vm.expiryDate=$$v},expression:"expiryDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.todatepickerBatch = false}},model:{value:(_vm.expiryDate),callback:function ($$v) {_vm.expiryDate=$$v},expression:"expiryDate"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-text-field',{attrs:{"type":"number","label":"ProductQuantity"},model:{value:(_vm.batchQuantity),callback:function ($$v) {_vm.batchQuantity=$$v},expression:"batchQuantity"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){_vm.batchDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){return _vm.addToBatch()}}},[_vm._v("Save")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.viewBatchDialog),callback:function ($$v) {_vm.viewBatchDialog=$$v},expression:"viewBatchDialog"}},[(_vm.batchSelectedProduct)?_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.viewBatchDialog = false}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Batch Details of \n            "),_c('b',[_vm._v(_vm._s(_vm.batchSelectedProduct['name']))]),_vm._v("\n              -\n            "),_c('b',{staticClass:"font-weight-light"},[_vm._v("HSN: "+_vm._s(_vm.batchSelectedProduct['HSN_code']))]),_vm._v("\n              -\n            "),_c('b',{staticClass:"font-weight-light"},[_vm._v("GST type: "+_vm._s(_vm.batchSelectedProduct['GST_type']))]),_vm._v("\n              -\n            "),_c('b',{staticClass:"font-weight-light"},[_vm._v("GST Rate: "+_vm._s(_vm.batchSelectedProduct.taxableGST_rate))]),_vm._v("\n              -\n            "),_c('b',{staticClass:"font-weight-light"},[_vm._v("UNI : "+_vm._s(_vm.batchSelectedProduct.unit))])]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.productListHeaderByBatch,"items":_vm.bachList,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',[_vm._v(_vm._s(props.item['batchNumber']))])]),_vm._v(" "),_c('td',[(props.item['manufacturingDate'])?_c('b',[_vm._v(_vm._s(new Date(props.item['manufacturingDate']).toISOString().substr(0, 10)))]):_vm._e()]),_vm._v(" "),_c('td',[(props.item['expiryDate'])?_c('b',[_vm._v(_vm._s(new Date(props.item['expiryDate']).toISOString().substr(0, 10)))]):_vm._e()]),_vm._v(" "),_c('td',[_c('b',{staticClass:"info--text font-weight-bold"},[_vm._v(_vm._s(props.item['quantity']))])])]}}],null,false,1942437694)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"1000px"},model:{value:(_vm.damageDialog),callback:function ($$v) {_vm.damageDialog=$$v},expression:"damageDialog"}},[_c('v-card',{attrs:{"persistent":""}},[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("DamageList")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-combobox',{attrs:{"items":_vm.productListByBrand,"return-object":true,"item-text":"name","label":"Product"},model:{value:(_vm.productToDamage),callback:function ($$v) {_vm.productToDamage=$$v},expression:"productToDamage"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerDamage),callback:function ($$v) {_vm.datepickerDamage=$$v},expression:"datepickerDamage"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.damageDate),callback:function ($$v) {_vm.damageDate=$$v},expression:"damageDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerDamage = false}},model:{value:(_vm.damageDate),callback:function ($$v) {_vm.damageDate=$$v},expression:"damageDate"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Damage Quantity"},model:{value:(_vm.damageQuantity),callback:function ($$v) {_vm.damageQuantity=$$v},expression:"damageQuantity"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){_vm.damageDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){return _vm.transferToDamage()}}},[_vm._v("Save")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"800","persistent":""},model:{value:(_vm.passwordDialog),callback:function ($$v) {_vm.passwordDialog=$$v},expression:"passwordDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline primary--text",attrs:{"primary-title":""}},[_vm._v("\n          Enter the password\n          "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"primary",attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.passwordDialog = false}}},[_c('v-icon',[_vm._v("mdi-close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"type":"password","label":"Password","autocomplete":"false"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.deleteFromDialog()}}},[_vm._v("Delete")])],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.timeout,"top":"","color":"primary"},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    Thank You so Much \n    "),_vm._v("\n      To make you serve Better.\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_transfer_vue__ = __webpack_require__(459);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16d84ff8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_transfer_vue__ = __webpack_require__(1401);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_transfer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16d84ff8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_transfer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"headline text-xs-center"},[_vm._v("\n          Transfer \n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{staticClass:"white--text",attrs:{"outline":"","large":""},on:{"click":_vm.addTerm}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v(" add ")]),_vm._v("\n            NEW TRANSFER\n          ")],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.transferHeader,"items":_vm.transferListByBrand,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',[_vm._v(_vm._s(new Date(props.item.date).toLocaleDateString("en-GB")))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.getBankName(props.item["bankFrom"]) || "Cash")+"   ")])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.getBankName(props.item["bankTo"]) || "Cash"))])]),_vm._v(" "),_c('td',[(props.item.transferCategory == 'B2B')?_c('b',[_vm._v("Bank Account -To- Bank Account")]):(props.item.transferCategory == 'B2C')?_c('b',[_vm._v("Bank Account -To- Cash Account")]):(props.item.transferCategory == 'C2B')?_c('b',[_vm._v("Cash Account -To- Bank Account")]):_vm._e()]),_vm._v(" "),_c('td',[_c('b',{staticClass:"primary--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item["amount"] || 0)))])]),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editTransfer(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteTerm(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.getFirmName(props.item.firm)))])])]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","persistent":""},model:{value:(_vm.transferDialog),callback:function ($$v) {_vm.transferDialog=$$v},expression:"transferDialog"}},[(_vm.currentTransfer)?_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Transfer")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.transferDialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-radio-group',{attrs:{"mandatory":false,"disabled":_vm.currentTransfer['.key'],"row":""},model:{value:(_vm.currentTransfer.transferCategory),callback:function ($$v) {_vm.$set(_vm.currentTransfer, "transferCategory", $$v)},expression:"currentTransfer.transferCategory"}},[_c('v-radio',{staticClass:"font-weight-bold",attrs:{"label":"From Bank Account -To- Bank Account","value":"B2B"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"From Bank Account -To- Cash Account","value":"B2C"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"From Cash Account -To- Bank Account","value":"C2B"}})],1),_vm._v(" "),_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.transferdatepicker),callback:function ($$v) {_vm.transferdatepicker=$$v},expression:"transferdatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.currentTransfer.date),callback:function ($$v) {_vm.$set(_vm.currentTransfer, "date", $$v)},expression:"currentTransfer.date"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.transferdatepicker = false}},model:{value:(_vm.currentTransfer.date),callback:function ($$v) {_vm.$set(_vm.currentTransfer, "date", $$v)},expression:"currentTransfer.date"}})],1),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.firmsByBrand,"label":"Select Firm","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n            "+_vm._s(data.item.text)+"\n          ")]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(
                  ("" + (data.item.firm.name) + (data.item.firm.proprietor
                      ? ' | ' + data.item.firm.proprietor
                      : '') + " | ₹: " + ((data.item.firm.amount || 0).toLocaleString()))
                )}})],1)]}}],null,false,3601820041),model:{value:(_vm.currentTransfer.firm),callback:function ($$v) {_vm.$set(_vm.currentTransfer, "firm", $$v)},expression:"currentTransfer.firm"}}),_vm._v(" "),(
            _vm.currentTransfer.firm &&
            (_vm.currentTransfer.transferCategory == 'B2C' ||
              _vm.currentTransfer.transferCategory == 'B2B')
          )?_c('v-autocomplete',{attrs:{"items":_vm.banksByFirms,"flat":"","hide-no-data":"","hide-details":"","label":"From Account","clearable":""},on:{"change":_vm.checkForSameAccount},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n            "+_vm._s(((data.item.text) + "\n                          " + (data.item.account.bankName
                              ? " | " + data.item.account.bankName
                              : "") + "\n                          " + (data.item.account.accountType
                              ? " | " + data.item.account.accountType
                              : "") + "\n                          | ₹: " + ((
                            data.item.account.amount || 0
                          ).toLocaleString())))+"\n          ")]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(
                  ((data.item.text) + "\n                          " + (data.item.account.bankName
                              ? ' | ' + data.item.account.bankName
                              : '') + "\n                          " + (data.item.account.accountType
                              ? ' | ' + data.item.account.accountType
                              : '') + "\n                          | ₹: " + ((
                            data.item.account.amount || 0
                          ).toLocaleString()))
                )}})],1)]}}],null,false,3692651341),model:{value:(_vm.currentTransfer.bankFrom),callback:function ($$v) {_vm.$set(_vm.currentTransfer, "bankFrom", $$v)},expression:"currentTransfer.bankFrom"}}):_vm._e(),_vm._v(" "),(
            _vm.currentTransfer.firm &&
            (_vm.currentTransfer.transferCategory == 'C2B' ||
              _vm.currentTransfer.transferCategory == 'B2B')
          )?_c('v-autocomplete',{attrs:{"items":_vm.banksByFirms,"flat":"","hide-no-data":"","hide-details":"","label":"To Account","clearable":""},on:{"change":_vm.checkForSameAccount},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n            "+_vm._s(((data.item.text) + "\n                          " + (data.item.account.bankName
                              ? " | " + data.item.account.bankName
                              : "") + "\n                          " + (data.item.account.accountType
                              ? " | " + data.item.account.accountType
                              : "") + "\n                          | ₹: " + ((
                            data.item.account.amount || 0
                          ).toLocaleString())))+"\n          ")]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(
                  ((data.item.text) + "\n                          " + (data.item.account.bankName
                              ? ' | ' + data.item.account.bankName
                              : '') + "\n                          " + (data.item.account.accountType
                              ? ' | ' + data.item.account.accountType
                              : '') + "\n                          | ₹: " + ((
                            data.item.account.amount || 0
                          ).toLocaleString()))
                )}})],1)]}}],null,false,3692651341),model:{value:(_vm.currentTransfer.bankTo),callback:function ($$v) {_vm.$set(_vm.currentTransfer, "bankTo", $$v)},expression:"currentTransfer.bankTo"}}):_vm._e(),_vm._v(" "),(_vm.currentTransfer.firm)?_c('v-text-field',{attrs:{"label":"Amount","hint":_vm.hintText},model:{value:(_vm.currentTransfer.amount),callback:function ($$v) {_vm.$set(_vm.currentTransfer, "amount", $$v)},expression:"currentTransfer.amount"}}):_vm._e(),_vm._v(" "),(
            _vm.currentTransfer.amount &&
            _vm.currentTransfer.transferCategory == 'C2B'
          )?_c('v-select',{attrs:{"items":[
            {
              text: 'Atm Deposit',
              value: 'Atm Deposit',
            },
            {
              text: 'Cash Counter',
              value: 'Cash Counter',
            } ],"label":"Deposit Via","required":""},model:{value:(_vm.currentTransfer.depositVia),callback:function ($$v) {_vm.$set(_vm.currentTransfer, "depositVia", $$v)},expression:"currentTransfer.depositVia"}}):_vm._e(),_vm._v(" "),(
            _vm.currentTransfer.amount &&
            _vm.currentTransfer.transferCategory == 'B2C'
          )?_c('v-select',{attrs:{"items":[
            {
              text: 'Atm Withdrawn',
              value: 'Atm',
            },
            {
              text: 'Cash Counter',
              value: 'Cash Counter',
            } ],"label":"withdrawn Via","required":""},model:{value:(_vm.currentTransfer.depositVia),callback:function ($$v) {_vm.$set(_vm.currentTransfer, "depositVia", $$v)},expression:"currentTransfer.depositVia"}}):_vm._e(),_vm._v(" "),(
            _vm.currentTransfer.amount &&
            _vm.currentTransfer.transferCategory == 'B2B'
          )?_c('v-select',{attrs:{"dense":"","items":[
            {
              text: 'Cheque',
              value: 'Cheque',
            },
            {
              text: 'NEFT',
              value: 'NEFT',
            },
            {
              text: 'RTGS',
              value: 'RTGS',
            },
            {
              text: 'IMPS',
              value: 'IMPS',
            } ],"label":"Select Transfer type"},model:{value:(_vm.currentTransfer.bankTransferType),callback:function ($$v) {_vm.$set(_vm.currentTransfer, "bankTransferType", $$v)},expression:"currentTransfer.bankTransferType"}}):_vm._e(),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Remark"},model:{value:(_vm.currentTransfer.remark),callback:function ($$v) {_vm.$set(_vm.currentTransfer, "remark", $$v)},expression:"currentTransfer.remark"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{staticClass:"grey white-text",attrs:{"outlined":"","large":""},on:{"click":function($event){_vm.transferDialog = false}}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("cancel")]),_vm._v("Cancel\n        ")],1),_vm._v(" "),(!_vm.currentTransfer['.key'])?_c('v-btn',{staticClass:"primary white-text",attrs:{"outlined":"","large":""},on:{"click":_vm.saveTerms}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("swap_horiz")]),_vm._v("Save\n        ")],1):_c('v-btn',{staticClass:"primary white-text",attrs:{"outlined":"","large":""},on:{"click":_vm.updateTransfer}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("swap_horiz")]),_vm._v("Update\n        ")],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"800","persistent":""},model:{value:(_vm.passwordDialog),callback:function ($$v) {_vm.passwordDialog=$$v},expression:"passwordDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline primary--text",attrs:{"primary-title":""}},[_vm._v("\n          Enter the password\n          "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"primary",attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.passwordDialog = false}}},[_c('v-icon',[_vm._v("mdi-close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"type":"password","label":"Password","autocomplete":"false"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.deleteFromDialog()}}},[_vm._v("Delete")])],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"top":"","color":"error","timeout":3000},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.snackbarText)+"\n  ")]),_vm._v(" "),_c('v-snackbar',{attrs:{"top":"","color":"success","timeout":3000},model:{value:(_vm.snackbarSuccess),callback:function ($$v) {_vm.snackbarSuccess=$$v},expression:"snackbarSuccess"}},[_vm._v("\n    "+_vm._s(_vm.snackbarSuccessText)+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(460);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4e3023e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1404);
function injectStyle (ssrContext) {
  __webpack_require__(1403)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4e3023e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1403 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md1":""}},[_c('router-link',{attrs:{"to":"/Dashboard"}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("close")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md1":""}},[_c('h2',[_vm._v("\n            ITC\n          ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-select',{staticClass:"select-firm",attrs:{"dense":"","items":_vm.firmsByBrand,"label":"Select Firm","clearable":""},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-menu',{staticClass:"ist-datepicker",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px","clearable":""},model:{value:(_vm.datepickerFrom),callback:function ($$v) {_vm.datepickerFrom=$$v},expression:"datepickerFrom"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"From Date","prepend-icon":"event","readonly":"","clearable":""},slot:"activator",model:{value:(_vm.fromDate),callback:function ($$v) {_vm.fromDate=$$v},expression:"fromDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerFrom = false}},model:{value:(_vm.fromDate),callback:function ($$v) {_vm.fromDate=$$v},expression:"fromDate"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-menu',{staticClass:"ist-datepicker",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px","clearable":""},model:{value:(_vm.datepickerTo),callback:function ($$v) {_vm.datepickerTo=$$v},expression:"datepickerTo"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"To Date","prepend-icon":"event","readonly":"","clearable":""},slot:"activator",model:{value:(_vm.toDate),callback:function ($$v) {_vm.toDate=$$v},expression:"toDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerTo = false}},model:{value:(_vm.toDate),callback:function ($$v) {_vm.toDate=$$v},expression:"toDate"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":""}},[_c('h3',{staticStyle:{"text-align":"center"},attrs:{"color":"primary"}},[_vm._v("Input GST")])]),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"label":"INPUT IGST (in ₹)","value":Number.parseFloat(_vm.inputGST.IGST),"readonly":"","prefix":""}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-text-field',{attrs:{"label":"INPUT CGST (in ₹)","value":Number.parseFloat(_vm.inputGST.CGST),"readonly":"","prefix":""}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-text-field',{attrs:{"label":"INPUT SGST (in ₹)","value":Number.parseFloat(_vm.inputGST.SGST),"readonly":"","prefix":""}})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":""}},[_c('h3',{staticStyle:{"text-align":"center"},attrs:{"color":"primary"}},[_vm._v("Output GST")])]),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"label":"OUTPUT IGST (in ₹)","value":Number.parseFloat(_vm.outputGST.IGST),"readonly":"","prefix":""}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-text-field',{attrs:{"label":"OUTPUT CGST (in ₹)","value":Number.parseFloat(_vm.outputGST.CGST),"readonly":"","prefix":""}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-text-field',{attrs:{"label":"OUTPUT SGST (in ₹)","value":Number.parseFloat(_vm.outputGST.SGST),"readonly":"","prefix":""}})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":""}},[_c('h3',{staticStyle:{"text-align":"center"},attrs:{"color":"primary"}},[_vm._v("RCM")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-switch',{staticClass:"paid-rtc",attrs:{"disabled":!_vm.selectedFirm,"label":("" + (_vm.isPaidVisible ? 'Click to View Unpaid Expenses' : 'Click to View Paid Expenses'))},model:{value:(_vm.isPaidVisible),callback:function ($$v) {_vm.isPaidVisible=$$v},expression:"isPaidVisible"}})],1),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation",attrs:{"items":_vm.expensesINV,"headers":_vm.expenseHeader},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('v-btn',{staticClass:"primary--text",attrs:{"disabled":_vm.isPaidVisible,"outlined":""},on:{"click":function($event){return _vm.openExpensePaymentDialog(props.item)}}},[_vm._v("\n                "+_vm._s(_vm.isPaidVisible ? 'PAID' : 'PAY')+"\n              ")])],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item['expense']))]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.getFirmName(props.item.firm)))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(new Date(props.item.date).toLocaleDateString('en-GB')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(props.item.gstAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.GST_type))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(props.item.openingBalance || 0)))]),_vm._v(" "),_c('td',[_c('b',{staticClass:"error--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item.totalAmount || 0)))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(((props.item.openingBalance ?  props.item.totalAmount : 0 ) + (props.item.totalAmount ? props.item.totalAmount : 0) ) || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.paymentType))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.remark))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item['.key']))])]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("no record found")])],2)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":""}},[_c('h3',{staticStyle:{"text-align":"center"},attrs:{"color":"primary"}},[_vm._v("IGST")])]),_vm._v(" "),_c('v-card-text',{class:{disabledCard: _vm.e1 != 1}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding-right":"6px","text-align":"end"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('h3',[_vm._v("Available Balance")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-top":"14px"},attrs:{"xs12":"","sm3":"","md3":""}},[_c('h4',[_vm._v("Input IGST")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs12":"","sm9":"","md9":""}},[_c('v-text-field',{staticStyle:{"padding":"0 4px 0 4px"},attrs:{"value":_vm.availableBalance.inputGST.IGST,"readonly":"","disabled":_vm.e1 != 1,"type":"number"}}),_vm._v(" "),_c('v-text-field',{staticClass:"primary--text",staticStyle:{"padding":"0 4px 0 4px"},attrs:{"value":_vm.availableBalance.inputGST.IGST,"readonly":"","type":"number","disabled":_vm.e1 != 1}})],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-top":"14px"},attrs:{"xs12":"","sm3":"","md3":""}},[_c('h4',[_vm._v("Output IGST")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs12":"","sm9":"","md9":""}},[_c('v-text-field',{staticStyle:{"padding":"0 4px 0 4px"},attrs:{"readonly":"","value":_vm.availableBalance.outputGST.IGST,"disabled":_vm.e1 != 1,"type":"number"}}),_vm._v(" "),_c('v-text-field',{staticStyle:{"padding":"0 4px 0 4px"},attrs:{"readonly":"","value":_vm.availableBalance.outputGST.IGST,"disabled":_vm.e1 != 1,"type":"number"}})],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-top":"14px"},attrs:{"xs12":"","sm3":"","md3":""}},[_c('h4',[_vm._v("Output CGST")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs12":"","sm9":"","md9":""}},[_c('v-text-field',{staticStyle:{"padding":"0 4px 0 4px"},attrs:{"rules":_vm.settleOutputCGST,"disabled":_vm.isOpDisabled() || _vm.e1 != 1,"type":"number"},model:{value:(_vm.settleBalance.outputGST.CGST),callback:function ($$v) {_vm.$set(_vm.settleBalance.outputGST, "CGST", $$v)},expression:"settleBalance.outputGST.CGST"}}),_vm._v(" "),_c('v-text-field',{staticStyle:{"padding":"0 4px 0 4px"},attrs:{"value":_vm.availableBalance.outputGST.CGST,"disabled":_vm.e1 != 1,"readonly":"","type":"number"}})],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-top":"14px"},attrs:{"xs12":"","sm3":"","md3":""}},[_c('h4',[_vm._v("Output SGST")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs12":"","sm9":"","md9":""}},[_c('v-text-field',{staticStyle:{"padding":"0 4px 0 4px"},attrs:{"disabled":_vm.isOpDisabled() || _vm.e1 != 1,"rules":_vm.settleOutputSGST,"type":"number"},model:{value:(_vm.settleBalance.outputGST.SGST),callback:function ($$v) {_vm.$set(_vm.settleBalance.outputGST, "SGST", $$v)},expression:"settleBalance.outputGST.SGST"}}),_vm._v(" "),_c('v-text-field',{staticStyle:{"padding":"0 4px 0 4px"},attrs:{"value":_vm.availableBalance.outputGST.SGST,"disabled":_vm.e1 != 1,"readonly":"","type":"number"}})],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","value":(Number.parseFloat(_vm.availableBalance.outputGST.IGST) < Number.parseFloat(_vm.availableBalance.inputGST.IGST) ? 
                    (Number.parseFloat(_vm.availableBalance.inputGST.IGST) - (Number.parseFloat(_vm.availableBalance.outputGST.IGST) + Number.parseFloat(_vm.settleBalance.outputGST.CGST) + Number.parseFloat(_vm.settleBalance.outputGST.SGST))).toFixed(2) : 0),"disabled":_vm.e1 != 1,"label":"Net Receiveable","readonly":"","prefix":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","disabled":_vm.e1 != 1,"value":(Number.parseFloat(_vm.availableBalance.outputGST.IGST) > Number.parseFloat(_vm.availableBalance.inputGST.IGST) ? 
                  (Number.parseFloat(_vm.availableBalance.outputGST.IGST) - (Number.parseFloat(_vm.availableBalance.inputGST.IGST) + Number.parseFloat(_vm.settleBalance.outputGST.CGST) + Number.parseFloat(_vm.settleBalance.outputGST.SGST))).toFixed(2) : 0),"label":"Net Payable","readonly":"","prefix":""}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-btn',{attrs:{"small":"","disabled":_vm.e1 != 1},on:{"click":_vm.reset}},[_vm._v("Reset")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-btn',{attrs:{"small":"","disabled":(_vm.e1 != 1) || (Number.parseFloat(_vm.availableBalance.outputGST.IGST) < Number.parseFloat(_vm.availableBalance.inputGST.IGST)),"color":"success"},on:{"click":function($event){return _vm.openPaymentDialog('IGST')}}},[_vm._v("Pay Now")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-btn',{attrs:{"small":"","disabled":_vm.e1 != 1,"color":"warning"},on:{"click":function($event){return _vm.nextStep(1)}}},[_vm._v("Pay Later")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":""}},[_c('h3',{staticStyle:{"text-align":"center"},attrs:{"color":"primary"}},[_vm._v("CGST")])]),_vm._v(" "),_c('v-card-text',{class:{disabledCard: _vm.e1 != 2}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding-right":"6px","text-align":"end"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('h3',[_vm._v("Available Balance")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-top":"14px"},attrs:{"xs12":"","sm3":"","md3":""}},[_c('h4',[_vm._v("Input CGST")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs12":"","sm9":"","md9":""}},[_c('v-text-field',{staticStyle:{"padding":"0 4px 0 4px"},attrs:{"value":_vm.availableBalance.inputGST.CGST,"readonly":"","type":"number","disabled":_vm.e1 != 2}}),_vm._v(" "),_c('v-text-field',{staticStyle:{"padding":"0 4px 0 4px"},attrs:{"value":_vm.availableBalance.inputGST.CGST,"readonly":"","type":"number","disabled":_vm.e1 != 2}})],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-top":"14px"},attrs:{"xs12":"","sm3":"","md3":""}},[_c('h4',[_vm._v("Output CGST")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs12":"","sm9":"","md9":""}},[_c('v-text-field',{staticStyle:{"padding":"0 4px 0 4px"},attrs:{"disabled":_vm.e1 != 2,"type":"number"}}),_vm._v(" "),_c('v-text-field',{staticStyle:{"padding":"0 4px 0 4px"},attrs:{"value":(_vm.availableBalance.outputGST.CGST - _vm.settleBalance.outputGST.CGST).toFixed(2),"readonly":"","disabled":_vm.e1 != 2,"type":"number"}})],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-top":"14px"},attrs:{"xs12":"","sm3":"","md3":""}},[_c('h4',[_vm._v("Adjusted Input IGST")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs12":"","sm9":"","md9":""}},[_c('v-text-field',{staticStyle:{"padding":"0 4px 0 4px"},attrs:{"value":Number.parseFloat(_vm.availableBalance.inputGST.IGST)  >= Number.parseFloat(_vm.availableBalance.outputGST.IGST)  ?
                   (Number.parseFloat(_vm.availableBalance.inputGST.IGST) - (Number.parseFloat(_vm.availableBalance.outputGST.IGST) + Number.parseFloat(_vm.settleBalance.outputGST.CGST) + Number.parseFloat(_vm.settleBalance.outputGST.SGST))).toFixed(2) : 0,"disabled":_vm.e1 != 2,"readonly":"","type":"number"}}),_vm._v(" "),_c('v-text-field',{staticStyle:{"padding":"0 4px 0 4px"},attrs:{"value":Number.parseFloat(_vm.availableBalance.inputGST.IGST)  >= Number.parseFloat(_vm.availableBalance.outputGST.IGST)  ?
                   (Number.parseFloat(_vm.availableBalance.inputGST.IGST) - (Number.parseFloat(_vm.availableBalance.outputGST.IGST) + Number.parseFloat(_vm.settleBalance.outputGST.CGST) + Number.parseFloat(_vm.settleBalance.outputGST.SGST))).toFixed(2) : 0,"disabled":_vm.e1 != 2,"readonly":"","type":"number"}})],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","disabled":_vm.e1 != 2,"value":(Number.parseFloat(_vm.availableBalance.inputGST.CGST) > (Number.parseFloat(_vm.availableBalance.outputGST.CGST) - Number.parseFloat(_vm.settleBalance.outputGST.CGST)) ? 
                    (Number.parseFloat(_vm.availableBalance.inputGST.CGST) - (Number.parseFloat(_vm.availableBalance.outputGST.CGST) - Number.parseFloat(_vm.settleBalance.outputGST.CGST))).toFixed(2) : 0),"label":"Net Receiveable","readonly":"","prefix":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","value":(Number.parseFloat(_vm.availableBalance.inputGST.CGST) < (Number.parseFloat(_vm.availableBalance.outputGST.CGST) - Number.parseFloat(_vm.settleBalance.outputGST.CGST)) ? 
                    ((Number.parseFloat(_vm.availableBalance.outputGST.CGST) - Number.parseFloat(_vm.settleBalance.outputGST.CGST)) - Number.parseFloat(_vm.availableBalance.inputGST.CGST)).toFixed(2) : 0),"disabled":_vm.e1 != 2,"label":"Net Payable","readonly":"","prefix":""}})],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-btn',{attrs:{"small":"","disabled":_vm.e1 != 2},on:{"click":_vm.reset}},[_vm._v("Reset")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-btn',{attrs:{"small":"","color":"success","disabled":(_vm.e1 != 2) || (Number.parseFloat(_vm.availableBalance.inputGST.CGST) > (Number.parseFloat(_vm.availableBalance.outputGST.CGST) - Number.parseFloat(_vm.settleBalance.outputGST.CGST)))},on:{"click":function($event){return _vm.openPaymentDialog('CGST')}}},[_vm._v("Pay Now")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-btn',{attrs:{"small":"","color":"warning","disabled":_vm.e1 != 2},on:{"click":function($event){return _vm.nextStep(2)}}},[_vm._v("Pay Later")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":""}},[_c('h3',{staticStyle:{"text-align":"center"},attrs:{"color":"primary"}},[_vm._v("SGST")])]),_vm._v(" "),_c('v-card-text',{class:{disabledCard: _vm.e1 != 3}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding-right":"6px","text-align":"end"},attrs:{"xs12":"","sm12":"","md12":""}},[_c('h3',[_vm._v("Available Balance")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-top":"14px"},attrs:{"xs12":"","sm3":"","md3":""}},[_c('h4',[_vm._v("Input SGST")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs12":"","sm9":"","md9":""}},[_c('v-text-field',{staticStyle:{"padding":"0 4px 0 4px"},attrs:{"value":_vm.availableBalance.inputGST.SGST,"readonly":"","disabled":_vm.e1 != 3,"type":"number"}}),_vm._v(" "),_c('v-text-field',{staticStyle:{"padding":"0 4px 0 4px"},attrs:{"value":_vm.availableBalance.inputGST.SGST,"readonly":"","disabled":_vm.e1 != 3,"type":"number"}})],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-top":"14px"},attrs:{"xs12":"","sm3":"","md3":""}},[_c('h4',[_vm._v("Output SGST")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs12":"","sm9":"","md9":""}},[_c('v-text-field',{staticStyle:{"padding":"0 4px 0 4px"},attrs:{"disabled":_vm.e1 != 3,"type":"number"}}),_vm._v(" "),_c('v-text-field',{staticStyle:{"padding":"0 4px 0 4px"},attrs:{"value":(_vm.availableBalance.outputGST.SGST - _vm.settleBalance.outputGST.SGST).toFixed(2),"readonly":"","disabled":_vm.e1 != 3,"type":"number"}})],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-top":"14px"},attrs:{"xs12":"","sm3":"","md3":""}},[_c('h4',[_vm._v("Adjusted Input IGST")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs12":"","sm9":"","md9":""}},[_c('v-text-field',{staticStyle:{"padding":"0 4px 0 4px"},attrs:{"readonly":"","value":Number.parseFloat(_vm.availableBalance.inputGST.IGST)  >= Number.parseFloat(_vm.availableBalance.outputGST.IGST)  ?
                   (Number.parseFloat(_vm.availableBalance.inputGST.IGST) - (Number.parseFloat(_vm.availableBalance.outputGST.IGST) + Number.parseFloat(_vm.settleBalance.outputGST.CGST) + Number.parseFloat(_vm.settleBalance.outputGST.SGST))).toFixed(2) : 0,"disabled":_vm.e1 != 3,"type":"number"}}),_vm._v(" "),_c('v-text-field',{staticStyle:{"padding":"0 4px 0 4px"},attrs:{"value":Number.parseFloat(_vm.availableBalance.inputGST.IGST)  >= Number.parseFloat(_vm.availableBalance.outputGST.IGST)  ?
                   (Number.parseFloat(_vm.availableBalance.inputGST.IGST) - (Number.parseFloat(_vm.availableBalance.outputGST.IGST) + Number.parseFloat(_vm.settleBalance.outputGST.CGST) + Number.parseFloat(_vm.settleBalance.outputGST.SGST))).toFixed(2) : 0,"readonly":"","disabled":_vm.e1 != 3,"type":"number"}})],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","md6":"","sm6":""}},[_c('v-text-field',{attrs:{"type":"number","disabled":_vm.e1 != 3,"value":(Number.parseFloat(_vm.availableBalance.inputGST.SGST) > (Number.parseFloat(_vm.availableBalance.outputGST.SGST) - Number.parseFloat(_vm.settleBalance.outputGST.SGST)) ? 
                    (Number.parseFloat(_vm.availableBalance.inputGST.SGST) - (Number.parseFloat(_vm.availableBalance.outputGST.SGST) - Number.parseFloat(_vm.settleBalance.outputGST.SGST))).toFixed(2) : 0),"label":"Net Receiveable","readonly":"","prefix":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":"","sm6":""}},[_c('v-text-field',{attrs:{"type":"number","value":(Number.parseFloat(_vm.availableBalance.inputGST.SGST) < (Number.parseFloat(_vm.availableBalance.outputGST.SGST) - Number.parseFloat(_vm.settleBalance.outputGST.SGST)) ? 
                    ((Number.parseFloat(_vm.availableBalance.outputGST.SGST) - Number.parseFloat(_vm.settleBalance.outputGST.SGST)) - Number.parseFloat(_vm.availableBalance.inputGST.SGST)).toFixed(2) : 0),"disabled":_vm.e1 != 3,"label":"Net Payable","readonly":"","prefix":""}})],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-btn',{attrs:{"small":"","disabled":_vm.e1 != 3},on:{"click":_vm.reset}},[_vm._v("Reset")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-btn',{attrs:{"small":"","disabled":(_vm.e1 != 3 ) || (Number.parseFloat(_vm.availableBalance.inputGST.SGST) > (Number.parseFloat(_vm.availableBalance.outputGST.SGST) - Number.parseFloat(_vm.settleBalance.outputGST.SGST))),"color":"success"},on:{"click":function($event){return _vm.openPaymentDialog('SGST')}}},[_vm._v("Pay Now")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-btn',{attrs:{"small":"","disabled":_vm.e1 != 3,"color":"warning"},on:{"click":function($event){return _vm.nextStep(3)}}},[_vm._v("Pay Later")])],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"1000px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{attrs:{"persistent":""}},[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Payment for "+_vm._s(_vm.currentPaymentGSTType))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h4',[(_vm.insufficientError)?_c('b',{staticClass:"text-error"},[_vm._v("Insufficient amount.")]):_vm._e()])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"type":"number","value":_vm.payableAmount,"disabled":"","label":"Net Payable","readonly":"","prefix":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker),callback:function ($$v) {_vm.datepicker=$$v},expression:"datepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.selectedDate),callback:function ($$v) {_vm.selectedDate=$$v},expression:"selectedDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepicker = false}},model:{value:(_vm.selectedDate),callback:function ($$v) {_vm.selectedDate=$$v},expression:"selectedDate"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","m3":""}},[_c('v-select',{attrs:{"dense":"","items":[{
                                text: 'Cash',
                                value: 'Cash'
                              }, {
                                text: 'Bank Account',
                                value: 'Bank Account'
                              }, {
                                text: 'Cash & Bank Account',
                                value: 'CashAndBank Account'
                              }],"label":"Select Payment Type"},model:{value:(_vm.paymentType),callback:function ($$v) {_vm.paymentType=$$v},expression:"paymentType"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[(['Cash','CashAndBank Account'].includes(_vm.paymentType))?_c('v-text-field',{attrs:{"type":"number","label":"Amount from Cash","value":_vm.payableAmount},model:{value:(_vm.amountFromCash),callback:function ($$v) {_vm.amountFromCash=$$v},expression:"amountFromCash"}}):_vm._e(),_vm._v(" "),(['Cash','CashAndBank Account'].includes(_vm.paymentType) && !((Number.parseFloat(_vm.amountFromBank) + Number.parseFloat(_vm.amountFromCash)) == Number.parseFloat(_vm.payableAmount )))?_c('b',{staticClass:"text-error"},[_vm._v("Total should be equal to Payoff amount")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[(['Bank Account','CashAndBank Account'].includes(_vm.paymentType))?_c('v-select',{attrs:{"dense":"","items":_vm.banksByFirms,"label":"Select Bank","flat":"","clearable":"","item-text":"bankName","return-object":"","disabled":_vm.paymentType == 'Cash' || _vm.paymentType == ''},model:{value:(_vm.selectedBank),callback:function ($$v) {_vm.selectedBank=$$v},expression:"selectedBank"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[(['Bank Account','CashAndBank Account'].includes(_vm.paymentType))?_c('v-text-field',{attrs:{"type":"number","label":"Amount from Bank","value":_vm.payableAmount},model:{value:(_vm.amountFromBank),callback:function ($$v) {_vm.amountFromBank=$$v},expression:"amountFromBank"}}):_vm._e(),_vm._v(" "),(['Bank Account','CashAndBank Account'].includes(_vm.paymentType) && !((Number.parseFloat(_vm.amountFromBank) + Number.parseFloat(_vm.amountFromCash)) == Number.parseFloat(_vm.payableAmount )))?_c('b',{staticClass:"text-error"},[_vm._v("Total should be equal to Payoff amount")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[(['Bank Account','CashAndBank Account'].includes(_vm.paymentType))?_c('v-select',{attrs:{"dense":"","disabled":_vm.paymentType == 'Cash' || _vm.paymentType == '',"items":[{
                        text: 'Cheque',
                        value: 'Cheque'
                      }, {
                        text: 'NEFT',
                        value: 'NEFT'
                      }, {
                        text: 'RTGS',
                        value: 'RTGS'
                      }, {
                        text: 'IMPS',
                        value: 'IMPS'
                      }],"label":"Select Transfer type"},on:{"input":function($event){_vm.transferTypeDialog = true}},model:{value:(_vm.transferType),callback:function ($$v) {_vm.transferType=$$v},expression:"transferType"}}):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){return _vm.payITC()}}},[_vm._v("Pay")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.transferTypeDialog),callback:function ($$v) {_vm.transferTypeDialog=$$v},expression:"transferTypeDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("\n          Transfer Information\n          "),_c('b',[_vm._v(_vm._s(_vm.transferType))])])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","label":"A/C Number"},model:{value:(_vm.transferDetails.accountNumber),callback:function ($$v) {_vm.$set(_vm.transferDetails, "accountNumber", $$v)},expression:"transferDetails.accountNumber"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"text","label":"A/C Holder Name"},model:{value:(_vm.transferDetails.accountHolderName),callback:function ($$v) {_vm.$set(_vm.transferDetails, "accountHolderName", $$v)},expression:"transferDetails.accountHolderName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"text","label":"Bank Name"},model:{value:(_vm.transferDetails.bankName),callback:function ($$v) {_vm.$set(_vm.transferDetails, "bankName", $$v)},expression:"transferDetails.bankName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"text","label":"IFSC Code"},model:{value:(_vm.transferDetails.IFSCcode),callback:function ($$v) {_vm.$set(_vm.transferDetails, "IFSCcode", $$v)},expression:"transferDetails.IFSCcode"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"text","label":"Remark"},model:{value:(_vm.transferDetails.remark),callback:function ($$v) {_vm.$set(_vm.transferDetails, "remark", $$v)},expression:"transferDetails.remark"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.transferTypeDialog = false}}},[_vm._v("Ok")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_godawn_vue__ = __webpack_require__(461);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2936dd0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_godawn_vue__ = __webpack_require__(1407);
function injectStyle (ssrContext) {
  __webpack_require__(1406)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a2936dd0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_godawn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2936dd0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_godawn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1406 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"godawn-details",attrs:{"fluid":"","grid-list-md":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('router-link',{attrs:{"to":"/Dashboard"}},[_c('v-btn',{attrs:{"icon":"","dark":""}},[_c('v-icon',[_vm._v("keyboard_backspace")])],1)],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("STORE LIST")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.godawnByBrand),function(godawn){return _c('v-flex',{key:godawn['.key'],staticStyle:{"padding":"15px"},attrs:{"xs12":"","md3":"","sm3":""}},[_c('v-card',{staticClass:"icon-card"},[_c('v-icon',{staticStyle:{"padding":"18px 18px"}},[_vm._v("business")])],1),_vm._v(" "),_c('v-card',{key:godawn['.key']+'G',staticClass:"sec1-card"},[_c('v-card-title',{staticClass:"headline",attrs:{"primary-title":""}},[_c('v-spacer'),_vm._v("\n                    "+_vm._s(godawn.godawnName)+"\n                  ")],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('b',{staticClass:"subheading primary--text font-weight-light"},[_vm._v(_vm._s(godawn.godawnAddress))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('span',[_vm._v(_vm._s(godawn.godawnPincode))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text",attrs:{"outline":""},on:{"click":function($event){return _vm.openGodawnTransactions(godawn)}}},[_c('v-icon',{staticClass:"primary--text",attrs:{"left":""}},[_vm._v("remove_red_eye")]),_vm._v(" "),_c('a',{staticClass:"primary--text font-weight-light"},[_vm._v("View")])],1),_vm._v(" "),_c('v-spacer')],1)],1)],1)}),1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":""},model:{value:(_vm.viewTransaction),callback:function ($$v) {_vm.viewTransaction=$$v},expression:"viewTransaction"}},[(_vm.currentGodawn)?_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.currentProductName)+" - Transactions")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.viewTransaction = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation",attrs:{"items":_vm.currentGodawanProductTransaction,"headers":_vm.godawanTransactionHeaders},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"primary--text font-weight-bold",domProps:{"innerHTML":_vm._s(_vm.renderDate(props.item.date))}}),_vm._v(" "),_c('td',{staticClass:"red--text font-weight-bold"},[_vm._v(_vm._s(props.item.quantity))]),_vm._v(" "),_c('td',{staticClass:"primary--text font-weight-bold"},[_vm._v(_vm._s(props.item.productName))]),_vm._v(" "),_c('td',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item.type))])]}}],null,false,2699931606)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("no record found")])],2)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":""},model:{value:(_vm.viewGodawn),callback:function ($$v) {_vm.viewGodawn=$$v},expression:"viewGodawn"}},[(_vm.currentGodawn)?_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.currentGodawn.godawnName)+" - Transactions")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.viewGodawn = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{staticClass:"godawn-details"},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.currentGodawnProducts),function(product){return _c('v-flex',{key:product['productName']+'a',staticStyle:{"padding":"15px"},attrs:{"xs12":"","md3":"","sm3":""}},[_c('v-card',{staticClass:"icon-card"},[_c('v-icon',{staticStyle:{"padding":"18px 18px"}},[_vm._v("shopping_basket")])],1),_vm._v(" "),_c('v-card',{key:product['productName']+'G',staticClass:"sec1-card"},[_c('v-card-title',{staticClass:"headline",attrs:{"primary-title":""}},[_c('v-spacer'),_vm._v("\n                    "+_vm._s(product.productName)+"\n                  ")],1),_vm._v(" "),(product.totalQuantity <= 0)?_c('v-card-actions',{staticClass:"title font-weight-bold"},[_c('v-spacer'),_vm._v(" "),_c('span',[_vm._v("Quantity:   \n                      "),_c('b',{staticClass:"font-weight-bold title red--text"},[_vm._v("\n                        "+_vm._s(product.totalQuantity)+"\n                      ")])]),_vm._v(" "),_c('v-spacer')],1):_vm._e(),_vm._v(" "),(product.totalQuantity > 0)?_c('v-card-actions',{staticClass:"title font-weight-bold"},[_c('v-spacer'),_vm._v(" "),_c('span',[_vm._v("Quantity:   \n                      "),_c('b',{staticClass:"font-weight-bold title green--text"},[_vm._v("\n                        "+_vm._s(product.totalQuantity)+"\n                      ")])]),_vm._v(" "),_c('v-spacer')],1):_vm._e(),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text",attrs:{"outline":""},on:{"click":function($event){return _vm.openGodawnProductList(product)}}},[_c('v-icon',{staticClass:"primary--text",attrs:{"left":""}},[_vm._v("remove_red_eye")]),_vm._v(" "),_c('a',{staticClass:"primary--text font-weight-light"},[_vm._v("View")])],1),_vm._v(" "),_c('v-spacer')],1)],1)],1)}),1)],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GodownReports_vue__ = __webpack_require__(462);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84841c62_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GodownReports_vue__ = __webpack_require__(1410);
function injectStyle (ssrContext) {
  __webpack_require__(1409)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-84841c62"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GodownReports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_84841c62_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GodownReports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1409 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"godawn-details",attrs:{"fluid":"","grid-list-md":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('router-link',{attrs:{"to":"/Dashboard"}},[_c('v-btn',{attrs:{"icon":"","dark":""}},[_c('v-icon',[_vm._v("keyboard_backspace")])],1)],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("STORE INVENTORY")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.godawnByBrand),function(godawn){return _c('v-flex',{key:godawn['.key'],staticStyle:{"padding":"15px"},attrs:{"xs12":"","md3":"","sm3":""}},[_c('v-card',{staticClass:"icon-card"},[_c('v-icon',{staticStyle:{"padding":"18px 18px"}},[_vm._v("business")])],1),_vm._v(" "),_c('v-card',{key:godawn['.key']+'G',staticClass:"sec1-card"},[_c('v-card-title',{staticClass:"headline",attrs:{"primary-title":""}},[_c('v-spacer'),_vm._v("\n                      "+_vm._s(godawn.godawnName)+"\n                    ")],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('b',{staticClass:"subheading primary--text font-weight-light"},[_vm._v(_vm._s(godawn.godawnAddress))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('span',[_vm._v(_vm._s(godawn.godawnPincode))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text",attrs:{"outline":""},on:{"click":function($event){return _vm.openGodawnReports(godawn)}}},[_c('v-icon',{staticClass:"primary--text",attrs:{"left":""}},[_vm._v("remove_red_eye")]),_vm._v(" "),_c('a',{staticClass:"primary--text font-weight-light"},[_vm._v("View")])],1),_vm._v(" "),_c('v-spacer')],1)],1)],1)}),1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":""},model:{value:(_vm.viewReports),callback:function ($$v) {_vm.viewReports=$$v},expression:"viewReports"}},[(_vm.currentGodawn)?_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.currentGodawn.godawnName)+" - Reports")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.viewReports = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1 dashboardHead  stocks-reports",attrs:{"headers":_vm.productListHeader,"items":_vm.reportProducts,"hide-actions":""},scopedSlots:_vm._u([{key:"headers",fn:function(props){return [_c('tr',[_c('th',[_vm._v("Sr\n    ")]),_vm._v(" "),_c('th',[_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v("NAME - Description")])]),_vm._v(" "),_c('th',[_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v("Opening Stock")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"float":"left"}},[_vm._v("Quantity")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_vm._v("Amount")])]),_vm._v(" "),_c('th',[_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v("Purchase Stock")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"float":"left"}},[_vm._v("Quantity")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_vm._v("Amount")])]),_vm._v(" "),_c('th',[_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v("Sales Stock")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"float":"left"}},[_vm._v("Quantity")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_vm._v("Amount")])]),_vm._v(" "),_c('th',[_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v("Transfer")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"float":"left"}},[_vm._v("Quantity")]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_vm._v("Amount")])])])]}},{key:"items",fn:function(props){return [_c('tr',[_c('td',{staticStyle:{"text-align":"center"}},[(props.item['name'] != 'Total')?_c('b',[_vm._v(_vm._s(props.index + 1))]):_vm._e()]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['name']))])]),_c('td',[_c('span',{staticStyle:{"float":"left"}},[_c('b',{staticClass:"font-weight-bold info--text"},[_vm._v(_vm._s(props.item['reportDetails'].opening))])]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item['reportDetails'].openingAmount || 0)))])])]),_vm._v(" "),_c('td',[_c('span',{staticStyle:{"float":"left"}},[_c('b',{staticClass:"font-weight-bold primary--text"},[_vm._v(_vm._s(props.item['reportDetails'].purchase))])]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_c('b',[_vm._v(" "+_vm._s(_vm._f("amount")(props.item['reportDetails'].purchaseAmount || 0)))])])]),_vm._v(" "),_c('td',[_c('span',{staticStyle:{"float":"left"}},[_c('b',{staticClass:"font-weight-bold green--text"},[_vm._v(_vm._s(props.item['reportDetails'].sale))])]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_c('b',[_vm._v(" "+_vm._s(_vm._f("amount")(props.item['reportDetails'].saleAmount || 0)))])])]),_vm._v(" "),_c('td',[_c('span',{staticStyle:{"float":"left"}},[_c('b',{staticClass:"font-weight-bold red--text"},[_vm._v(_vm._s(props.item['reportDetails'].transfer))])]),_vm._v(" "),_c('span',{staticStyle:{"float":"right"}},[_c('b',[_vm._v(" "+_vm._s(_vm._f("amount")(props.item['reportDetails'].transferAmount || 0)))])])])])]}}],null,false,3588234300)},[_vm._v(" "),_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_offshoot_vue__ = __webpack_require__(463);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70f13f12_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_offshoot_vue__ = __webpack_require__(1413);
function injectStyle (ssrContext) {
  __webpack_require__(1412)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-70f13f12"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_offshoot_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70f13f12_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_offshoot_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1412 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"branch-details",attrs:{"fluid":"","grid-list-md":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('router-link',{attrs:{"to":"/Dashboard"}},[_c('v-btn',{attrs:{"icon":"","dark":""}},[_c('v-icon',[_vm._v("keyboard_backspace")])],1)],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("BRANCH")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.branchByBrand),function(branch){return _c('v-flex',{key:branch['.key'],staticStyle:{"padding":"15px"},attrs:{"xs12":"","md3":"","sm3":""}},[_c('v-card',{staticClass:"icon-card"},[_c('v-icon',{staticStyle:{"padding":"18px 18px"}},[_vm._v("business")])],1),_vm._v(" "),_c('v-card',{key:branch['.key']+'G',staticClass:"sec1-card"},[_c('v-card-title',{staticClass:"headline",attrs:{"primary-title":""}},[_c('v-spacer'),_vm._v(" "),_c('div',[_vm._v("                        \n                      "+_vm._s(branch.branchName)+"\n                      "),_c('h6',{staticClass:"font-weight-light"},[_vm._v(_vm._s(branch.branchAddress))])])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('b',{staticClass:"subheading primary--text font-weight-light"},[_vm._v(_vm._s(branch.branchEmail))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('span',[_vm._v(_vm._s(branch.branchMobileNumber))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text",attrs:{"outline":""},on:{"click":function($event){return _vm.openBranchTransactions(branch)}}},[_c('v-icon',{staticClass:"primary--text",attrs:{"left":""}},[_vm._v("remove_red_eye")]),_vm._v(" "),_c('a',{staticClass:"primary--text font-weight-light"},[_vm._v("View")])],1),_vm._v(" "),_c('v-spacer')],1)],1)],1)}),1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":""},model:{value:(_vm.viewTransaction),callback:function ($$v) {_vm.viewTransaction=$$v},expression:"viewTransaction"}},[(_vm.currentBranch)?_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.currentProductName)+" - Transactions")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.viewTransaction = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation",attrs:{"items":_vm.currentBranchProductTransaction,"headers":_vm.branchTransactionHeaders},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"primary--text font-weight-bold",domProps:{"innerHTML":_vm._s(_vm.renderDate(props.item.date))}}),_vm._v(" "),_c('td',{staticClass:"red--text font-weight-bold"},[_vm._v(_vm._s(props.item.quantity))]),_vm._v(" "),_c('td',{staticClass:"primary--text font-weight-bold"},[_vm._v(_vm._s(props.item.productName))]),_vm._v(" "),_c('td',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item.type))])]}}],null,false,2699931606)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("no record found")])],2)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":""},model:{value:(_vm.viewBranch),callback:function ($$v) {_vm.viewBranch=$$v},expression:"viewBranch"}},[(_vm.currentBranch)?_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.currentBranch.branchName)+" - Transactions")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.viewBranch = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',{staticClass:"branch-details"},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.currentBranchProducts),function(product){return _c('v-flex',{key:product['productName']+'a',staticStyle:{"padding":"15px"},attrs:{"xs12":"","md3":"","sm3":""}},[_c('v-card',{staticClass:"icon-card"},[_c('v-icon',{staticStyle:{"padding":"18px 18px"}},[_vm._v("shopping_basket")])],1),_vm._v(" "),_c('v-card',{key:product['productName']+'G',staticClass:"sec1-card"},[_c('v-card-title',{staticClass:"headline",attrs:{"primary-title":""}},[_c('v-spacer'),_vm._v("\n                    "+_vm._s(product.productName)+"\n                  ")],1),_vm._v(" "),(product.totalQuantity <= 0)?_c('v-card-actions',{staticClass:"title font-weight-bold"},[_c('v-spacer'),_vm._v(" "),_c('span',[_vm._v("Quantity:   \n                      "),_c('b',{staticClass:"font-weight-bold title red--text"},[_vm._v("\n                        "+_vm._s(product.totalQuantity)+"\n                      ")])]),_vm._v(" "),_c('v-spacer')],1):_vm._e(),_vm._v(" "),(product.totalQuantity > 0)?_c('v-card-actions',{staticClass:"title font-weight-bold"},[_c('v-spacer'),_vm._v(" "),_c('span',[_vm._v("Quantity:   \n                      "),_c('b',{staticClass:"font-weight-bold title green--text"},[_vm._v("\n                        "+_vm._s(product.totalQuantity)+"\n                      ")])]),_vm._v(" "),_c('v-spacer')],1):_vm._e(),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text",attrs:{"outline":""},on:{"click":function($event){return _vm.openBranchProductList(product)}}},[_c('v-icon',{staticClass:"primary--text",attrs:{"left":""}},[_vm._v("remove_red_eye")]),_vm._v(" "),_c('a',{staticClass:"primary--text font-weight-light"},[_vm._v("View")])],1),_vm._v(" "),_c('v-spacer')],1)],1)],1)}),1)],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f0c8072_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_recordDelivery_vue__ = __webpack_require__(1415);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f0c8072_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_recordDelivery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_vm._v("\n    Hello, Welcome to Delivery Register\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6eea8641_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_recordDispatch_vue__ = __webpack_require__(1417);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6eea8641_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_recordDispatch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_vm._v("\n    Hello, Welcome to Dispatch Register\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_recordEstimate_vue__ = __webpack_require__(464);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c84e2a5a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_recordEstimate_vue__ = __webpack_require__(1420);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_recordEstimate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c84e2a5a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_recordEstimate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export convertToPDFProducts */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return convertToEstimate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return convertToEstimateWithoutGST; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float__);





var _this = this;

// playground requires you to assign document definition to a variable called dd
// playground requires you to assign document definition to a variable called dd
var convertToPDFProducts = function convertToPDFProducts(items, isGST) {
	var productList = [];
	var totalObj = {
		quantity: 0,
		basicPrice: 0,
		totlePrice: 0
	};
	items.map(function (item, index) {
		var product = [];
		product.push({ text: index + 1, style: "product" });
		product.push({ text: item.productName + (item.subDescription ? "( " + item.subDescription + " )" : ""), style: "product1" });
		product.push({ text: item.HSN_code, style: "product" });
		product.push({ text: item.quantity, style: "product" });
		product.push({ text: item.unit, style: "product" });
		product.push({ text: '₹ ' + item.rate, style: "product" });
		product.push({ text: '₹ ' + item.basicPrice, style: "product" });
		totalObj.quantity += item.quantity;
		totalObj.basicPrice += __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(item.basicPrice);
		if (isGST) {
			product.push({ text: '₹ ' + item.totlePrice, style: "product" });
			totalObj.totlePrice += __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(item.totlePrice);
		}
		productList.push(product);
	});

	if (isGST) {
		productList.push([{ text: '', style: "product" }, { text: 'Total', style: "total" }, { text: '', style: "product" }, { text: totalObj.quantity, style: "total" }, { text: '', style: "product" }, { text: '', style: "product" }, { text: totalObj.basicPrice.toFixed(2), style: "total" }, { text: totalObj.totlePrice.toFixed(2), style: "total" }]);
	} else {
		productList.push([{ text: '', style: "product" }, { text: 'Total', style: "total" }, { text: '', style: "product" }, { text: totalObj.quantity, style: "total" }, { text: '', style: "product" }, { text: '', style: "product" }, { text: totalObj.basicPrice.toFixed(2), style: "total" }]);
	}
	return productList;
};

var getBase64ImageFromURL = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(url) {
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						return _context.abrupt("return", new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
							var img = new Image();
							img.setAttribute("crossOrigin", "anonymous");

							img.onload = function () {
								var canvas = document.createElement("canvas");
								canvas.width = img.width;
								canvas.height = img.height;

								var ctx = canvas.getContext("2d");
								ctx.drawImage(img, 0, 0);

								var dataURL = canvas.toDataURL("image/png");

								resolve(dataURL);
							};

							img.onerror = function (error) {
								reject(error);
							};

							img.src = url;
						}));

					case 1:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, _this);
	}));

	return function getBase64ImageFromURL(_x) {
		return _ref.apply(this, arguments);
	};
}();

var convertToEstimate = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(metaData) {
		var pdfDoc, productList, productLength, logoData, imgToExport, canvas, base64, temp;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						pdfDoc = {
							content: [{
								table: {
									widths: ['40%', '60%'],
									body: [[{
										image: 'sampleImage.jpg',
										width: 120,
										height: 80
									}, {
										text: [{ text: 'Firm Name\n', style: 'FirmHeader' }, { text: 'GST\n' }, { text: 'Local Address\n' }, { text: 'Address\n' }, { text: 'MOBILE\n' }, { text: 'EMAIL\n' }]
									}]]

								},
								layout: {
									hLineWidth: function hLineWidth(i, node) {
										return i === 0 || i === node.table.body.length ? 2 : 1;
									},
									vLineWidth: function vLineWidth(i, node) {
										return i === 0 || i === node.table.widths.length ? 2 : 1;
									},
									hLineColor: function hLineColor(i, node) {
										return i === 0 || i === node.table.body.length ? 'black' : 'white';
									},
									vLineColor: function vLineColor(i, node) {
										return i === 0 || i === node.table.widths.length ? 'black' : 'white';
									}
								}
							}, {
								table: {
									widths: ['50%', '*'],
									body: [[{ text: 'ESTIMATE TO', style: "topHeader" }, { text: 'ESTIMATE DETAILS', style: "topHeader" }], [{
										text: [{ text: ' ', bold: true }, { text: 'Customer Name\n' }, { text: ' ', bold: true }, { text: 'Care of Name\n' }, { text: ' ', bold: true }, { text: 'GST Number\n' }, { text: ' ', bold: true }, { text: 'Address \n' }, { text: ' ', bold: true }, { text: 'Mobile \n' }, { text: ' ', bold: true }, { text: '1679905\n' }, { text: ' ', bold: true }, { text: 'State Code\n' }]
									}, {
										text: [{ text: 'Date: ', bold: true }, { text: '12/12/90 \n' }, { text: 'Remark: ', bold: true }, { text: '\n' }]
									}]]
								}
							}, {
								table: {
									widths: ['7%', '28%', '10%', '5%', '10%', '10%', '15%', '15%'],
									body: [[{ text: 'S.NO', style: "productHeader", rowSpan: 2 }, { text: 'PARTICULARS', style: "productHeader", rowSpan: 2 }, { text: 'HSN/SAC', style: "productHeader", rowSpan: 2 }, { text: 'QTY', style: "productHeader", rowSpan: 2 }, { text: 'UNIT', style: "productHeader", rowSpan: 2 }, { text: 'RATE', style: "productHeader", rowSpan: 2 }, { text: 'TAXABLE AMOUNT', style: "productHeader", rowSpan: 2 }, { text: 'TOTAL AMOUNT', style: "productHeader", rowSpan: 2 }], [{ text: 'S.NO', style: "productHeader" }, { text: 'PARTICULARS', style: "productHeader" }, { text: 'HSN/SAC', style: "productHeader" }, { text: 'QTY', style: "productHeader" }, { text: 'UNITS', style: "productHeader" }, { text: 'RATE', style: "productHeader" }, { text: 'TAXABLE AMOUNT', style: "productHeader" }, { text: 'TOTAL AMOUNT', style: "productHeader" }]]
								}
							}, {
								table: {
									widths: ['71.50%', '*'],
									body: [[{}, {
										text: [{ text: 'Taxable Amount:     ', bold: true, style: 'TaxableHeader' }, { text: '12122\n', style: 'TaxableHeader' }, { text: 'CGST Amount:        ', bold: true, style: 'TaxableHeader' }, { text: '12122\n', style: 'TaxableHeader' }, { text: 'SGST Amount:        ', bold: true, style: 'TaxableHeader' }, { text: '12122\n', style: 'TaxableHeader' }, { text: 'IGST Amount:         ', bold: true, style: 'TaxableHeader' }, { text: '12122\n', style: 'TaxableHeader' }, { text: 'Total Amount:         ', bold: true, style: 'TotalHeader' }, { text: '12122\n', style: 'TotalHeader' }]

									}]]

								},
								style: 'tab2'

							}, {
								table: {
									widths: ['30%', '40%', '30%'],
									body: [[{
										text: [{ text: 'PAYMENT DETAILS\n', style: 'transpotationDel' }, { text: '', style: 'invoiceDetails' }]
									}, {
										text: [{ text: 'TERMS AND CONDITIONS\n', style: 'transpotationDel' }, { text: '', style: 'invoiceDetails' }]
									},

									//    {
									//    text:
									[{ text: '' }, { text: 'Firm Name  ', bold: true, alignment: 'center', color: 'primary' }, { text: '\n\n\n' }, { text: 'AUTHORIY SIGNATURE', bold: true, alignment: 'center', color: 'primary' }, { text: '\n' }]

									//    },
									]]

								},
								layout: {
									hLineWidth: function hLineWidth(i, node) {
										return i === 0 || i === node.table.body.length ? 2 : 1;
									},
									vLineWidth: function vLineWidth(i, node) {
										return i === 0 || i === node.table.widths.length ? 2 : 1;
									},
									hLineColor: function hLineColor(i, node) {
										return i === 0 || i === node.table.body.length ? 'black' : 'white';
									},
									vLineColor: function vLineColor(i, node) {
										return i === 0 || i === node.table.widths.length ? 'black' : 'white';
									}
								}
							}, {
								table: {
									widths: ['*'],
									body: [[{ text: 'Thank you \n', style: 'emptyHeader2' }]]

								},
								layout: 'noBorders',
								style: 'tab2'
							}],
							styles: {
								header: {
									fontSize: 14,
									bold: true,
									alignment: 'center'
								},
								emptyHeader2: {
									color: 'white',
									fillColor: '#15155d',
									alignment: 'center',
									bold: true,
									fontSize: 14
								},
								productHeader: {
									fontSize: 11,
									bold: true,
									alignment: 'center',
									color: '#160091'
								},
								transpotationDel: {
									bold: true,
									alignment: 'center',
									color: '#160091'
								},
								gstHeader: {
									fontSize: 9,
									color: '#160091',
									bold: true,
									alignment: 'center'
								},
								TaxableHeader: {
									fontSize: 10,
									bold: true
								},
								TotalHeader: {
									fontSize: 10,
									bold: true,
									color: '#160091'
								},
								FirmHeader: {
									fontSize: 12,
									color: '#160091',
									bold: true
								},
								product: {
									fontSize: 9,
									alignment: 'center'
								},
								product1: {
									fontSize: 9,
									alignment: 'left'
								},
								total: {
									fontSize: 10,
									alignment: 'center',
									bold: true
								},
								topHeader: {
									color: '#160091',
									fontSize: 13,
									alignment: 'center',
									bold: true
								},
								invoiceDetails: {
									fontSize: 9
								}
							}
							//Firm Details 
						};
						pdfDoc.content[0].table.body[0][1].text[0].text = (metaData.firm.name ? metaData.firm.name.toUpperCase() : '') + "\n";
						pdfDoc.content[0].table.body[0][1].text[1].text = (metaData.firm.GST_number ? metaData.firm.GST_number : '') + "\n";
						pdfDoc.content[0].table.body[0][1].text[2].text = (metaData.firm.liveAddress ? metaData.firm.liveAddress : '') + "\n";
						pdfDoc.content[0].table.body[0][1].text[3].text = (metaData.firm.address ? metaData.firm.address : '') + "\n";
						pdfDoc.content[0].table.body[0][1].text[4].text = (metaData.firm.mobileNumber ? metaData.firm.mobileNumber : '') + "\n";
						// pdfDoc.content[0].table.body[0][1].text[7].text = (metaData.firm.panNumber ? metaData.firm.panNumber : '') + "\n";
						pdfDoc.content[0].table.body[0][1].text[5].text = (metaData.firm.email ? metaData.firm.email : '') + "\n";
						// pdfDoc.content[0].table.body[0][1].text[2].text = (metaData.firm.GST_number ? metaData.firm.GST_number : '') + "\n";
						// pdfDoc.content[0].table.body[0][1].text[13].text = (metaData.firm.website ? metaData.firm.website : '') + "\n";

						//Invoice Details
						pdfDoc.content[1].table.body[1][1].text[1].text = new Date(metaData.invoiceData.date).toLocaleDateString('en-GB').toString() + "\n";
						pdfDoc.content[1].table.body[1][1].text[3].text = (metaData.invoiceData.remark ? metaData.invoiceData.remark : '') + "\n";
						//Receipient Details

						pdfDoc.content[1].table.body[1][0].text[1].text = (metaData.customer.name ? metaData.customer.name.toUpperCase() : '') + "\n";
						pdfDoc.content[1].table.body[1][0].text[3].text = (metaData.customer.GST_number ? metaData.customer.GST_number : '') + "\n";
						pdfDoc.content[1].table.body[1][0].text[5].text = (metaData.customer.propName ? metaData.customer.propName.toUpperCase() : '') + "\n";
						pdfDoc.content[1].table.body[1][0].text[7].text = (metaData.customer.localAddress ? metaData.customer.localAddress : '') + "\n";
						pdfDoc.content[1].table.body[1][0].text[9].text = (metaData.customer.address ? metaData.customer.address : '') + "\n";
						pdfDoc.content[1].table.body[1][0].text[11].text = (metaData.customer.mobile ? metaData.customer.mobile : '') + "\n";
						pdfDoc.content[1].table.body[1][0].text[13].text = (metaData.customer.stateCode ? metaData.customer.stateCode : '') + "\n";

						//Products
						productList = convertToPDFProducts(metaData.invoiceData.items, true);

						productList.map(function (item) {
							pdfDoc.content[2].table.body.push(item);
						});

						//Bank Account Details
						if (metaData.terms.banks.length) {
							metaData.terms.banks.map(function (bankDetails) {
								pdfDoc.content[4].table.body[0][0].text.push({ text: bankDetails.bankName + " ( " + bankDetails.ifsccode + " )\n", style: 'invoiceDetails' });
								pdfDoc.content[4].table.body[0][0].text.push({ text: "A/C: " + bankDetails.accountnumber + "\n", style: 'invoiceDetails' });
								pdfDoc.content[4].table.body[0][0].text.push({ text: bankDetails.address + "\n", style: 'invoiceDetails' });
							});
						}

						//Terms and cond
						pdfDoc.content[4].table.body[0][1].text[1].text = metaData.terms.termsAndConditions;

						productLength = pdfDoc.content[2].table.body.length - 1;

						//gst details
						// pdfDoc.content[5].table.body[0][1].text[1].text = (metaData.invoiceData.totalAmount ? Number.parseFloat(metaData.invoiceData.totalAmount).toFixed(2) - Number.parseFloat(metaData.gstTotal.CGST_val + metaData.gstTotal.SGST_val + metaData.gstTotal.IGST_val).toFixed(2) : '0') + "\n";

						pdfDoc.content[3].table.body[0][1].text[1].text = pdfDoc.content[2].table.body[productLength][6].text + "\n";
						pdfDoc.content[3].table.body[0][1].text[3].text = (metaData.gstTotal.CGST_val ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.CGST_val).toFixed(2) : '0') + "\n";
						pdfDoc.content[3].table.body[0][1].text[5].text = (metaData.gstTotal.SGST_val ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.SGST_val).toFixed(2) : '0') + "\n";
						pdfDoc.content[3].table.body[0][1].text[7].text = (metaData.gstTotal.IGST_val ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.IGST_val).toFixed(2) : '0') + "\n";
						pdfDoc.content[3].table.body[0][1].text[9].text = pdfDoc.content[2].table.body[productLength][7].text + "\n";

						// pdfDoc.content[6].table.body[0][1].text[17].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";

						//authority
						pdfDoc.content[4].table.body[0][2][1].text = metaData.firm.name ? metaData.firm.name.toUpperCase() : '';

						if (!metaData.terms.printLogo) {
							_context2.next = 41;
							break;
						}

						_context2.prev = 28;
						_context2.next = 31;
						return getBase64ImageFromURL(metaData.terms.printLogo);

					case 31:
						logoData = _context2.sent;

						pdfDoc.content[0].table.body[0][0].image = logoData;
						return _context2.abrupt("return", pdfDoc);

					case 36:
						_context2.prev = 36;
						_context2.t0 = _context2["catch"](28);

						console.log(_context2.t0);

					case 39:
						_context2.next = 48;
						break;

					case 41:
						imgToExport = document.getElementById('pdfimgToExport');
						canvas = document.createElement('canvas');

						canvas.width = imgToExport.width;
						canvas.height = imgToExport.height;
						canvas.getContext('2d').drawImage(imgToExport, 0, 0);
						base64 = canvas.toDataURL('image/png');

						pdfDoc.content[0].table.body[0][0].image = base64;

					case 48:
						if (!metaData.terms.signature) {
							_context2.next = 57;
							break;
						}

						temp = { columns: [] };
						_context2.t1 = temp.columns;
						_context2.next = 53;
						return getBase64ImageFromURL(metaData.terms.signature);

					case 53:
						_context2.t2 = _context2.sent;
						_context2.t3 = {
							image: _context2.t2,
							width: 150,
							alignment: 'right'
						};

						_context2.t1.push.call(_context2.t1, _context2.t3);

						pdfDoc.content[4].table.body[0][2][2] = temp.columns[0];

					case 57:
						pdfDoc.content[5].table.body[0][0].text = metaData.terms.greetingMessage || "Thank You for choosing us!";
						return _context2.abrupt("return", pdfDoc);

					case 59:
					case "end":
						return _context2.stop();
				}
			}
		}, _callee2, _this, [[28, 36]]);
	}));

	return function convertToEstimate(_x2) {
		return _ref2.apply(this, arguments);
	};
}();

var convertToEstimateWithoutGST = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(metaData) {
		var pdfDoc, productList, productLength, logoData, imgToExport, canvas, base64;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						pdfDoc = {
							content: [{
								table: {
									widths: ['50%', '50%'],
									body: [[{
										image: 'sampleImage.jpg',
										width: 120,
										height: 80
									}, {
										text: [{ text: 'Firm Name\n', style: 'FirmHeader' }, { text: 'LocalAddress\n' }, { text: 'Address\n' }, { text: 'MOBILE\n' }, { text: 'EMAIL\n' }]
									}]]

								},
								layout: {
									hLineWidth: function hLineWidth(i, node) {
										return i === 0 || i === node.table.body.length ? 2 : 1;
									},
									vLineWidth: function vLineWidth(i, node) {
										return i === 0 || i === node.table.widths.length ? 2 : 1;
									},
									hLineColor: function hLineColor(i, node) {
										return i === 0 || i === node.table.body.length ? 'black' : 'white';
									},
									vLineColor: function vLineColor(i, node) {
										return i === 0 || i === node.table.widths.length ? 'black' : 'white';
									}
								}
							}, {
								table: {
									widths: ['50%', '*'],
									body: [[{ text: 'ESTIMATE TO', style: "topHeader" }, { text: 'ESTIMATE DETAILS', style: "topHeader" }], [{
										text: [{ text: ' ', bold: true }, { text: 'Customer Name\n' }, { text: ' ', bold: true }, { text: 'Care of Name\n' }, { text: ' ', bold: true }, { text: 'GST Number\n' }, { text: ' ', bold: true }, { text: 'Address \n' }, { text: ' ', bold: true }, { text: 'Mobile \n' }]
									}, {
										text: [{ text: 'Date: ', bold: true }, { text: '12/12/90 \n' }]
									}]]
								}
							}, {
								table: {
									widths: ['7%', '28%', '10%', '5%', '15%', '15%', '20%'],
									body: [[{ text: 'S.No', style: "productHeader", rowSpan: 2 }, { text: 'Product Name', style: "productHeader", rowSpan: 2 }, { text: 'HSN code', style: "productHeader", rowSpan: 2 }, { text: 'Qty', style: "productHeader", rowSpan: 2 }, { text: 'Units', style: "productHeader", rowSpan: 2 }, { text: 'Rate', style: "productHeader", rowSpan: 2 }, { text: 'Total Amount', style: "productHeader", rowSpan: 2 }], [{ text: 'S.No', style: "productHeader" }, { text: 'Product Description', style: "productHeader" }, { text: 'HSN code', style: "productHeader" }, { text: 'Qty', style: "productHeader" }, { text: 'Units', style: "productHeader" }, { text: 'Rate', style: "productHeader" }, { text: 'Total Amount', style: "productHeader" }]]
								}
							}, {
								table: {
									widths: ['71.50%', '*'],
									body: [[{}, {
										text: [{ text: 'Total Amount:         ', bold: true, style: 'TotalHeader' }, { text: '12122\n', style: 'TotalHeader' }]

									}]]

								},
								style: 'tab2'

							}, {
								table: {
									widths: ['30%', '40%', '30%'],
									body: [[{
										text: [{ text: 'PAYMENT DETAILS\n', style: 'transpotationDel' }, { text: '', style: 'invoiceDetails' }]
									}, {
										text: [{ text: 'TERMS AND CONDITIONS\n', style: 'transpotationDel' }, { text: '', style: 'invoiceDetails' }]
									}, {
										text: [{ text: '' }, { text: 'Firm Name  ', bold: true, alignment: 'center', color: 'primary' }, { text: '\n\n\n' }, { text: 'AUTHORIY SIGNATURE', bold: true, alignment: 'center', color: 'primary' }, { text: '\n' }]

									}]]

								},
								layout: {
									hLineWidth: function hLineWidth(i, node) {
										return i === 0 || i === node.table.body.length ? 2 : 1;
									},
									vLineWidth: function vLineWidth(i, node) {
										return i === 0 || i === node.table.widths.length ? 2 : 1;
									},
									hLineColor: function hLineColor(i, node) {
										return i === 0 || i === node.table.body.length ? 'black' : 'white';
									},
									vLineColor: function vLineColor(i, node) {
										return i === 0 || i === node.table.widths.length ? 'black' : 'white';
									}
								}
							}],
							styles: {
								header: {
									fontSize: 14,
									bold: true,
									alignment: 'center'
								},
								productHeader: {
									fontSize: 11,
									bold: true,
									alignment: 'center',
									color: '#160091'
								},
								transpotationDel: {
									bold: true,
									alignment: 'center',
									color: '#160091'
								},
								gstHeader: {
									fontSize: 9,
									color: '#160091',
									bold: true,
									alignment: 'center'
								},
								TaxableHeader: {
									fontSize: 10,
									bold: true
								},
								TotalHeader: {
									fontSize: 10,
									bold: true,
									color: '#160091'
								},
								FirmHeader: {
									fontSize: 12,
									color: '#160091',
									bold: true
								},
								product: {
									fontSize: 9,
									alignment: 'center'
								},
								total: {
									fontSize: 10,
									alignment: 'center',
									bold: true
								},
								topHeader: {
									color: '#160091',
									fontSize: 13,
									alignment: 'center',
									bold: true
								},
								invoiceDetails: {
									fontSize: 9
								}
							}
							//Firm Details 
						};
						pdfDoc.content[0].table.body[0][1].text[0].text = (metaData.firm.name ? metaData.firm.name.toUpperCase() : '') + "\n";
						pdfDoc.content[0].table.body[0][1].text[1].text = (metaData.firm.liveAddress ? metaData.firm.liveAddress : '') + "\n";
						pdfDoc.content[0].table.body[0][1].text[2].text = (metaData.firm.address ? metaData.firm.address : '') + "\n";
						pdfDoc.content[0].table.body[0][1].text[3].text = (metaData.firm.mobileNumber ? metaData.firm.mobileNumber : '') + "\n";
						// pdfDoc.content[0].table.body[0][1].text[7].text = (metaData.firm.panNumber ? metaData.firm.panNumber : '') + "\n";
						// pdfDoc.content[0].table.body[0][1].text[2].text = (metaData.firm.GST_number ? metaData.firm.GST_number : '') + "\n";
						pdfDoc.content[0].table.body[0][1].text[4].text = (metaData.firm.email ? metaData.firm.email : '') + "\n";

						// pdfDoc.content[0].table.body[0][1].text[13].text = (metaData.firm.website ? metaData.firm.website : '') + "\n";

						//Invoice Details
						pdfDoc.content[1].table.body[1][1].text[1].text = new Date(metaData.invoiceData.date).toLocaleDateString('en-GB').toString() + "\n";

						//Receipient Details

						pdfDoc.content[1].table.body[1][0].text[1].text = (metaData.customer.name ? metaData.customer.name : '') + "\n";
						pdfDoc.content[1].table.body[1][0].text[3].text = (metaData.customer.propName ? metaData.customer.propName : '') + "\n";
						pdfDoc.content[1].table.body[1][0].text[5].text = (metaData.customer.localAddress ? metaData.customer.localAddress : '') + "\n";
						pdfDoc.content[1].table.body[1][0].text[7].text = (metaData.customer.address ? metaData.customer.address : '') + "\n";
						pdfDoc.content[1].table.body[1][0].text[9].text = (metaData.customer.mobile ? metaData.customer.mobile : '') + "\n";
						// pdfDoc.content[1].table.body[1][0].text[9].text = (metaData.customer.GST_number ? metaData.customer.GST_number : '') + "\n";
						// pdfDoc.content[1].table.body[1][0].text[11].text = (metaData.customer.stateCode ? metaData.customer.stateCode : '') + "\n";


						//Products
						productList = convertToPDFProducts(metaData.invoiceData.items, false);

						productList.map(function (item) {
							pdfDoc.content[2].table.body.push(item);
						});

						//Bank Account Details
						if (metaData.terms.banks.length) {
							metaData.terms.banks.map(function (bankDetails) {
								pdfDoc.content[4].table.body[0][0].text.push({ text: bankDetails.bankName + " ( " + bankDetails.ifsccode + " )\n", style: 'invoiceDetails' });
								pdfDoc.content[4].table.body[0][0].text.push({ text: "A/C: " + bankDetails.accountnumber + "\n", style: 'invoiceDetails' });
								pdfDoc.content[4].table.body[0][0].text.push({ text: bankDetails.address + "\n", style: 'invoiceDetails' });
							});
						}

						//Terms and cond
						pdfDoc.content[4].table.body[0][1].text[1].text = metaData.terms.termsAndConditions;

						productLength = pdfDoc.content[2].table.body.length - 1;

						//gst details

						pdfDoc.content[3].table.body[0][1].text[1].text = pdfDoc.content[2].table.body[productLength][6].text + "\n";

						// pdfDoc.content[6].table.body[0][1].text[17].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";

						//authority
						pdfDoc.content[4].table.body[0][2].text[1].text = metaData.firm.name ? metaData.firm.name.toUpperCase() : '';

						if (!metaData.terms.printLogo) {
							_context3.next = 33;
							break;
						}

						_context3.prev = 20;
						_context3.next = 23;
						return getBase64ImageFromURL(metaData.terms.printLogo);

					case 23:
						logoData = _context3.sent;

						pdfDoc.content[0].table.body[0][0].image = logoData;
						return _context3.abrupt("return", pdfDoc);

					case 28:
						_context3.prev = 28;
						_context3.t0 = _context3["catch"](20);

						console.log(_context3.t0);

					case 31:
						_context3.next = 40;
						break;

					case 33:
						imgToExport = document.getElementById('pdfimgToExport');
						canvas = document.createElement('canvas');

						canvas.width = imgToExport.width;
						canvas.height = imgToExport.height;
						canvas.getContext('2d').drawImage(imgToExport, 0, 0);
						base64 = canvas.toDataURL('image/png');

						pdfDoc.content[0].table.body[0][0].image = base64;

					case 40:
						return _context3.abrupt("return", pdfDoc);

					case 41:
					case "end":
						return _context3.stop();
				}
			}
		}, _callee3, _this, [[20, 28]]);
	}));

	return function convertToEstimateWithoutGST(_x3) {
		return _ref3.apply(this, arguments);
	};
}();

/***/ }),
/* 1420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"text-xs-center"},[_vm._v("\n            Manage Estimate\n          ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-select',{attrs:{"solo":"","clearable":"","items":['IN PROGRESS','CANCELLED','BILLED','ALL'],"label":"Filter"},model:{value:(_vm.statusFilter),callback:function ($$v) {_vm.statusFilter=$$v},expression:"statusFilter"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"outlined":""},on:{"click":function($event){_vm.estimateDialog = true}}},[_c('v-icon',{attrs:{"left":"","color":"teal"}},[_vm._v("add")]),_vm._v("\n            New Estimate\n          ")],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.estimateHeader,"items":_vm.estimatesByBrand,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('v-icon',{attrs:{"disabled":props.item['status']=='CANCELLED' || props.item['status']=='BILLED' || _vm.getCustomerName(props.item.buyerId) == 'DELETED CUSTOMER',"color":"primary"},on:{"click":function($event){return _vm.openProd(props.item)}}},[_vm._v("remove_red_eye")])],1),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(new Date(props.item.date).toLocaleDateString('en-GB')))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['invoiceDate'] ? new Date(props.item.invoiceDate).toLocaleDateString('en-GB'): ''))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.getCustomerName(props.item.buyerId)))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold red--text"},[_vm._v(_vm._s(_vm._f("amount")(_vm.getTotal(props.item) || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['remark']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['status']))])]),_vm._v(" "),(props.item['status']!='CANCELLED')?_c('td',[(props.item['status'] == 'IN PROGRESS')?_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.cancelEstimate(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("cancel")])],1):_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.dispatchEstimate(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("commute")])],1)],1):_c('td'),_vm._v(" "),_c('td',[(props.item['status'] == 'IN PROGRESS')?_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editEstimate(props.item)}}},[_c('v-icon',{attrs:{"color":"green"}},[_vm._v("edit")])],1):_vm._e()],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteEstimate(props.item)}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("delete")])],1)],1),_vm._v(" "),_c('td',[_c('v-menu',{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"mx-0",attrs:{"icon":""}},on),[_c('v-icon',{attrs:{"color":"blue"}},[_vm._v("print")])],1)]}}],null,true)},[_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.printEstimate(props.item,true)}}},[_c('v-list-tile-title',[_vm._v("\n                        Taxable Print\n                      ")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.printEstimate(props.item,false)}}},[_c('v-list-tile-title',[_vm._v("\n                        Simple Print\n                      ")])],1)],1)],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"1000px"},model:{value:(_vm.estimateDialog),callback:function ($$v) {_vm.estimateDialog=$$v},expression:"estimateDialog"}},[_c('v-card',{attrs:{"persistent":""}},[_c('v-card-title',{staticClass:"primary white--text"},[(_vm.isEdit)?_c('span',{staticClass:"headline"},[_vm._v("Edit Estimate")]):_c('span',{staticClass:"headline"},[_vm._v("Create Estimate")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-switch',{attrs:{"disabled":_vm.isEdit,"label":("" + (_vm.isBuyer ? 'Sale Estimate' : 'Purchase Estimate'))},model:{value:(_vm.isBuyer),callback:function ($$v) {_vm.isBuyer=$$v},expression:"isBuyer"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-select',{attrs:{"items":_vm.isBuyer ? _vm.buyersByBrand : _vm.sellersByBrand,"label":_vm.isBuyer ? 'Select or add Buyer' : 'Select or add Seller',"autocomplete":"","disabled":_vm.isEdit,"item-text":"name","return-object":""},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addCustomer($event)}},model:{value:(_vm.selectedBuyer),callback:function ($$v) {_vm.selectedBuyer=$$v},expression:"selectedBuyer"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerEstimate),callback:function ($$v) {_vm.datepickerEstimate=$$v},expression:"datepickerEstimate"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerEstimate = false}},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-text-field',{attrs:{"prefix":"#","label":"Remark","placeholder":"Enter Remark","required":""},model:{value:(_vm.remark),callback:function ($$v) {_vm.remark=$$v},expression:"remark"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-combobox',{attrs:{"items":_vm.productListByBrand,"return-object":true,"item-text":"name","label":"Product","multiple":""},on:{"change":function($event){return _vm.addToBucket()}},model:{value:(_vm.productsToEstimate),callback:function ($$v) {_vm.productsToEstimate=$$v},expression:"productsToEstimate"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"wrap":""}},[_vm._l((_vm.items),function(item){return [_c('v-flex',{key:item.productId,attrs:{"xs3":"","sm3":"","md3":""}},[_vm._v("\n                    "+_vm._s(item.productName)+"\n                  ")]),_vm._v(" "),_c('v-flex',{key:item.productName,attrs:{"xs3":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"type":"text","label":"Sub Description"},model:{value:(item.subDescription),callback:function ($$v) {_vm.$set(item, "subDescription", $$v)},expression:"item.subDescription"}})],1),_vm._v(" "),_c('v-flex',{key:item.productName,attrs:{"xs3":"","sm1":"","md1":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Quantity"},model:{value:(item.quantity),callback:function ($$v) {_vm.$set(item, "quantity", _vm._n($$v))},expression:"item.quantity"}})],1),_vm._v(" "),_c('v-flex',{key:item.unit,attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-select',{attrs:{"dense":"","item-text":"text","item-value":"value","items":_vm.units,"label":"Select unit"},model:{value:(item.unit),callback:function ($$v) {_vm.$set(item, "unit", $$v)},expression:"item.unit"}})],1),_vm._v(" "),_c('v-flex',{key:item.productName+'RATE',attrs:{"xs2":"","sm2":"","md2":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Rate"},model:{value:(item.rate),callback:function ($$v) {_vm.$set(item, "rate", _vm._n($$v))},expression:"item.rate"}})],1),_vm._v(" "),_c('v-flex',{key:item.productName+'total',attrs:{"xs2":"","sm2":"","md2":""}},[_c('v-text-field',{attrs:{"type":"number","value":(item.rate ? Number.parseFloat(item.rate) : 0 ) * (item.rate ? Number.parseFloat(item.quantity) : 0 ),"disabled":true,"label":"Total"}})],1)]})],2)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){_vm.estimateDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","disabled":!_vm.items.length || !_vm.selectedBuyer || !_vm.selectedFirm,"flat":""},on:{"click":function($event){return _vm.addEstimate()}}},[_vm._v(_vm._s(_vm.isEdit ? 'Save' : 'Create'))])],1)],1)],1),_vm._v(" "),(_vm.selectedEstimate && _vm.selectedEstimate['.key'])?_c('v-dialog',{attrs:{"width":"800"},model:{value:(_vm.invoiceEstimate),callback:function ($$v) {_vm.invoiceEstimate=$$v},expression:"invoiceEstimate"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline grey lighten-2",attrs:{"primary-title":""}},[_vm._v("Estimate details:- \n          ")]),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.productInvoiceHeader,"items":_vm.selectedEstimate.items},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',[_vm._v(_vm._s(props.item['productName'])+" - "+_vm._s(props.item['subDescription']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['quantity']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.unit))])]),_vm._v(" "),_c('td',[_c('b',[_c('v-text-field',{attrs:{"type":"number","label":"Product Rate"},model:{value:(props.item.rate),callback:function ($$v) {_vm.$set(props.item, "rate", _vm._n($$v))},expression:"props.item.rate"}})],1)]),_vm._v(" "),_c('td',[_c('v-text-field',{attrs:{"type":"number","value":(props.item.rate ? Number.parseFloat(props.item.rate) : 0 ) * (props.item.rate ? Number.parseFloat(props.item.quantity) : 0 ),"disabled":true,"label":"Total"}})],1)]}}],null,false,684340396)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.invoiceEstimate = false}}},[_vm._v("Back")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.createInvoice()}}},[_vm._v("Create Invoice ")])],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecordLead_vue__ = __webpack_require__(465);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bee0d7d6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecordLead_vue__ = __webpack_require__(1424);
function injectStyle (ssrContext) {
  __webpack_require__(1422)
  __webpack_require__(1423)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-bee0d7d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RecordLead_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bee0d7d6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RecordLead_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1422 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1423 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"text-xs-center"},[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":{ name: 'Dashboard'}}},[_c('b',{staticClass:"title primary white--text"},[_vm._v("\n              Manage Lead\n            ")])])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-select',{attrs:{"solo":"","clearable":"","items":_vm.getLeadedCustomers,"label":"Buyers"},model:{value:(_vm.selectedCustomer),callback:function ($$v) {_vm.selectedCustomer=$$v},expression:"selectedCustomer"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-select',{attrs:{"solo":"","clearable":"","items":['PENDING', 'CANCELLED', 'CONFIRMED', 'ALL'],"label":"Filter"},model:{value:(_vm.statusFilter),callback:function ($$v) {_vm.statusFilter=$$v},expression:"statusFilter"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":'informations/product-lead-report/'}},[_c('v-btn',{attrs:{"outlined":""}},[_c('v-icon',{staticClass:"primary--text",attrs:{"left":""}},[_vm._v("mdi-alert-box")]),_vm._v(" Lead Product\n            ")],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"outlined":""},on:{"click":function($event){return _vm.addLeadDialog()}}},[_c('v-icon',{attrs:{"left":"","color":"teal"}},[_vm._v("add")]),_vm._v(" New Lead\n        ")],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.leadHeader,"items":_vm.leadsByBrand,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('v-menu',{attrs:{"bottom":"","right":"","offset-y":"","close-on-content-click":false}},[_c('v-btn',{staticClass:"mx-0",attrs:{"slot":"activator","icon":"","dark":""},slot:"activator"},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',[_c('v-list-group',{attrs:{"prepend-icon":'picture_as_pdf',"no-action":""},scopedSlots:_vm._u([{key:"activator",fn:function(){return [_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Actions")])],1)],1)]},proxy:true}],null,true)},[_vm._v(" "),(props.item['leadHistory'])?_c('v-list-tile',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.openHistory(props.item)}}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("history")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Processed Lead")])],1):_vm._e(),_vm._v(" "),(props.item['orignalLead'])?_c('v-list-tile',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.openOrignal(props.item)}}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("trip_origin")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v(" Original Lead ")])],1):_vm._e(),_vm._v(" "),(props.item['status'] == 'PENDING')?_c('v-list-tile',{on:{"click":function($event){return _vm.editLead(props.item)}}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Edit Lead")])],1):_vm._e(),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.deleteLead(props.item)}}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("delete")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Delete Lead")])],1)],1)],1)],1)],1),_vm._v(" "),_c('td',[_c('v-icon',{attrs:{"disabled":props.item['status'] == 'CANCELLED' ||
                props.item['status'] == 'CONFIRMED' ||
                (_vm.getCustomerName(props.item.buyerId) == 'DELETED CUSTOMER'
                  ? _vm.isShopUserExists(props.item.shopLeadUserId)
                    ? false
                    : true
                  : false),"color":"primary"},on:{"click":function($event){return _vm.openProd(props.item)}}},[_vm._v("remove_red_eye")])],1),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["leadNumber"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(new Date(props.item.date).toLocaleDateString("en-GB"))+" ")])]),_vm._v(" "),_c('td',[(props.item.buyerId)?_c('b',[_vm._v(_vm._s(_vm.getCustomerName(props.item.buyerId)))]):(_vm.isShopUserExists(props.item.shopLeadUserId))?_c('b',[_vm._v(_vm._s(_vm.getShopUserName(props.item.shopLeadUserId)))]):_c('b',[_c('v-btn',{on:{"click":function($event){return _vm.addShopUser(props.item)}}},[_vm._v(_vm._s(props.item.shopLeadUserName))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_vm._v("New Customer. Click To Create Buyer.")])],1)]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold red--text"},[_vm._v(_vm._s(_vm._f("amount")(_vm.getTotal(props.item) || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["leadType"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["status"]))])])]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"1000px"},model:{value:(_vm.leadDialog),callback:function ($$v) {_vm.leadDialog=$$v},expression:"leadDialog"}},[_c('v-card',{attrs:{"persistent":""}},[_c('v-card-title',{staticClass:"primary white--text"},[(_vm.isEdit)?_c('span',{staticClass:"headline"},[_vm._v("Edit Lead")]):_c('span',{staticClass:"headline"},[_vm._v("Create Lead")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-switch',{attrs:{"disabled":_vm.isEdit,"label":("" + (_vm.isBuyer ? 'Sale Lead' : 'Purchase Lead'))},model:{value:(_vm.isBuyer),callback:function ($$v) {_vm.isBuyer=$$v},expression:"isBuyer"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-switch',{attrs:{"disabled":_vm.isEdit,"label":"Multi-firm"},on:{"change":function($event){return _vm.restructureProductList()}},model:{value:(_vm.multiFirm),callback:function ($$v) {_vm.multiFirm=$$v},expression:"multiFirm"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-select',{attrs:{"dense":"","disabled":_vm.multiFirm,"items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-select',{attrs:{"items":_vm.isBuyer ? _vm.buyersByBrand : _vm.sellersByBrand,"label":_vm.isBuyer ? 'Select or add Buyer' : 'Select or add Seller',"autocomplete":"","disabled":_vm.isEdit,"item-text":"name","return-object":""},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addCustomer($event)}},model:{value:(_vm.selectedBuyer),callback:function ($$v) {_vm.selectedBuyer=$$v},expression:"selectedBuyer"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"item-text":"name","item-value":"id","items":_vm.currentLeadType,"label":"Choose Lead Type"},model:{value:(_vm.leadType),callback:function ($$v) {_vm.leadType=$$v},expression:"leadType"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerLead),callback:function ($$v) {_vm.datepickerLead=$$v},expression:"datepickerLead"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Lead Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerLead = false}},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm1":"","md1":""}},[_c('v-text-field',{attrs:{"prefix":"#","label":"Lead Number","placeholder":"Enter Lead Number","required":""},model:{value:(_vm.leadNumber),callback:function ($$v) {_vm.leadNumber=$$v},expression:"leadNumber"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.leadsSetting && _vm.leadsSetting.isLeadTime)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-time-picker',{attrs:{"label":"Lead Time"},model:{value:(_vm.leadTime),callback:function ($$v) {_vm.leadTime=$$v},expression:"leadTime"}})],1):_vm._e(),_vm._v(" "),(_vm.leadsSetting && _vm.leadsSetting.isStaffSelection)?_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.staffByBrand,"label":"Sold By"},model:{value:(_vm.soldBy),callback:function ($$v) {_vm.soldBy=$$v},expression:"soldBy"}})],1):_vm._e(),_vm._v(" "),(_vm.isRestaurantBusiness && !_vm.multiFirm)?_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.floorList,"label":"Select Floor","item-text":"name","item-value":"name"},on:{"change":function($event){return _vm.getTableList()}},model:{value:(_vm.floorName),callback:function ($$v) {_vm.floorName=$$v},expression:"floorName"}})],1):_vm._e(),_vm._v(" "),(_vm.tableList.length)?_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.tableList,"label":"Select Table","return-object":"","item-text":"name","item-value":"name"},model:{value:(_vm.tableName),callback:function ($$v) {_vm.tableName=$$v},expression:"tableName"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"wrap":""}},[_vm._l((_vm.items),function(item,index){return [_c('v-flex',{key:index + item.productId,staticStyle:{"display":"inline-flex"},attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-select',{staticStyle:{"width":"90%"},attrs:{"dense":"","autocomplete":"","item-text":"name","item-value":'name',"items":_vm.productListByBrand,"label":"Product Name"},on:{"change":function($event){return _vm.restructureProductList(index)}},model:{value:(item.productName),callback:function ($$v) {_vm.$set(item, "productName", $$v)},expression:"item.productName"}}),_vm._v(" "),(_vm.isRestaurantBusiness)?_c('v-text-field',{staticStyle:{"width":"10%"},attrs:{"disabled":"","type":"number","label":"Call"},model:{value:(item.call),callback:function ($$v) {_vm.$set(item, "call", $$v)},expression:"item.call"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{key:index + item.productName,attrs:{"xs1":"","sm1":"","md1":""}},[(item.productName)?_c('v-text-field',{attrs:{"type":"number","label":"Quantity"},model:{value:(item.quantity),callback:function ($$v) {_vm.$set(item, "quantity", _vm._n($$v))},expression:"item.quantity"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{key:index + item.unit,attrs:{"xs2":"","sm2":"","md2":""}},[(item.productName)?_c('v-select',{attrs:{"dense":"","item-text":"text","item-value":"value","items":_vm.availableProductUnit[item.productId].units,"label":"Select unit"},on:{"change":function($event){return _vm.unitChange(item)}},model:{value:(item.unit),callback:function ($$v) {_vm.$set(item, "unit", $$v)},expression:"item.unit"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{key:index + item.productName + 'RATE',attrs:{"xs2":"","sm2":"","md2":""}},[(item.productName)?_c('v-text-field',{attrs:{"type":"number","label":"Rate"},model:{value:(item.rate),callback:function ($$v) {_vm.$set(item, "rate", _vm._n($$v))},expression:"item.rate"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{key:index + item.productName + 'total',attrs:{"xs2":"","sm2":"","md2":""}},[(item.productName)?_c('v-text-field',{attrs:{"type":"number","value":Number.parseFloat((item.rate ? Number.parseFloat(item.rate) : 0) *
                        (item.rate ? Number.parseFloat(item.quantity) : 0)).toFixed(2),"disabled":true,"label":"Total"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{key:index + item.productName + 'add',attrs:{"xs1":"","sm1":"","md1":""}},[(index == _vm.items.length - 1 && item.productName)?_c('v-btn',{attrs:{"icon":"","color":"primary"},on:{"click":function($event){return _vm.addProd()}}},[_c('v-icon',[_vm._v("add_circle")])],1):(item.productName)?_c('v-btn',{attrs:{"icon":"","color":"primary"},on:{"click":function($event){return _vm.removeProd(index)}}},[_c('v-icon',[_vm._v("cancel")])],1):_vm._e()],1)]})],2)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){_vm.leadDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","disabled":!_vm.items.length ||
            !_vm.selectedBuyer ||
            !_vm.items[0].productId ||
            (_vm.multiFirm ? false : !_vm.selectedFirm),"flat":""},on:{"click":function($event){return _vm.addLead()}}},[_vm._v(_vm._s(_vm.isEdit ? "Save" : "Create"))])],1)],1)],1),_vm._v(" "),(_vm.selectedLead && _vm.selectedLead['.key'])?_c('v-dialog',{attrs:{"width":"800"},model:{value:(_vm.invoiceLead),callback:function ($$v) {_vm.invoiceLead=$$v},expression:"invoiceLead"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline grey lighten-2",attrs:{"primary-title":""}},[_vm._v("Lead details:-\n        ")]),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.productInvoiceHeader,"items":_vm.selectedLead.items},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{class:props.item.completed ? 'green-bg' : ''},[(_vm.isRestaurantBusiness)?_c('td',[_c('b',[_vm._v(_vm._s(props.item["call"]))])]):_vm._e(),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["productName"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["quantity"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.unit))])]),_vm._v(" "),_c('td',[_c('b',[_c('v-text-field',{attrs:{"type":"number","label":"Product Rate"},model:{value:(props.item.rate),callback:function ($$v) {_vm.$set(props.item, "rate", _vm._n($$v))},expression:"props.item.rate"}})],1)]),_vm._v(" "),_c('td',[_c('v-text-field',{attrs:{"type":"number","value":(props.item.rate
                      ? Number.parseFloat(props.item.rate)
                      : 0) *
                    (props.item.rate
                      ? Number.parseFloat(props.item.quantity)
                      : 0),"disabled":true,"label":"Total"}})],1)])]}}],null,false,2870010424)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.invoiceLead = false}}},[_vm._v("Back")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.createInvoice()}}},[_vm._v("Create Order\n        ")])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.selectedLead && _vm.selectedLead['.key'])?_c('v-dialog',{attrs:{"width":"800"},model:{value:(_vm.leadHistory),callback:function ($$v) {_vm.leadHistory=$$v},expression:"leadHistory"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline grey lighten-2",attrs:{"primary-title":""}},[_vm._v(_vm._s(_vm.modalMode == "history"
            ? "Proceesed Lead History:-"
            : "Orignal Lead:- ")+"\n        ")]),_vm._v(" "),_c('v-card-text',[(_vm.modalMode == 'orignal')?[_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.productInvoiceHeader,"items":_vm.selectedLead.orignalLead},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{class:props.item.completed ? 'green-bg' : ''},[(_vm.isRestaurantBusiness)?_c('td',[_c('b',[_vm._v(_vm._s(props.item["call"]))])]):_vm._e(),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["productName"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["quantity"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.unit))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.rate))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s((props.item.rate
                      ? Number.parseFloat(props.item.rate)
                      : 0) *
                    (props.item.rate
                      ? Number.parseFloat(props.item.quantity)
                      : 0)))])])])]}}],null,false,2185673059)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)]:[_c('v-stepper',{attrs:{"vertical":""},model:{value:(_vm.historyStep),callback:function ($$v) {_vm.historyStep=$$v},expression:"historyStep"}},[_vm._l((_vm.selectedLead.leadHistory),function(item,index){return [_c('v-stepper-step',{key:item['.key'],attrs:{"step":index + 1}},[_c('v-link',{on:{"click":function($event){_vm.historyStep = index + 1}}},[_vm._v(_vm._s(new Date(item["date"]).toLocaleDateString("en-GB")))])],1),_vm._v(" "),_c('v-stepper-content',{key:index,attrs:{"step":index + 1}},[_c('v-card',{staticClass:"mb-12 invoice-stepper"},[_c('v-layout',{staticStyle:{"padding":"30px"},attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('h2',{staticStyle:{"text-decoration":"underline","text-align":"center"}},[_vm._v("\n                        Product List\n                      ")]),_vm._v(" "),[_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.productInvoiceHeader,"items":item.items},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{class:props.item.completed ? 'green-bg' : ''},[(_vm.isRestaurantBusiness)?_c('td',[_c('b',[_vm._v(_vm._s(props.item["call"]))])]):_vm._e(),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["productName"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["quantity"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.unit))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.rate))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s((props.item.rate
                                    ? Number.parseFloat(props.item.rate)
                                    : 0) *
                                  (props.item.rate
                                    ? Number.parseFloat(props.item.quantity)
                                    : 0)))])])])]}}],null,true)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)]],2)],1)],1)],1)]})],2)]],2),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.leadHistory = false}}},[_vm._v("Back")])],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_recordOrder_vue__ = __webpack_require__(466);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2643af8a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_recordOrder_vue__ = __webpack_require__(1429);
function injectStyle (ssrContext) {
  __webpack_require__(1426)
  __webpack_require__(1427)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2643af8a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_recordOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2643af8a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_recordOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1426 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1427 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export convertToPDFProducts */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return convertToOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return convertToOrderWithoutGST; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float__);





var _this = this;

// playground requires you to assign document definition to a variable called dd
// playground requires you to assign document definition to a variable called dd
var convertToPDFProducts = function convertToPDFProducts(items, isGST) {
	var productList = [];
	var totalObj = {
		quantity: 0,
		basicPrice: 0,
		totlePrice: 0
	};
	items.map(function (item, index) {
		var product = [];
		product.push({ text: index + 1, style: "product1" });
		product.push({ text: item.productName + (item.subDescription ? "( " + item.subDescription + " )" : ""), style: "product1" });
		// if(isGST) {
		// product.push({ text: item.HSN_code, style: "product1" });
		// }
		product.push({ text: item.quantity, style: "productRight" });
		product.push({ text: item.unit, style: "product1" });
		product.push({ text: '₹ ' + item.rate, style: "productRight" });

		product.push({ text: '₹ ' + item.basicPrice, style: "productRight" });
		totalObj.quantity += item.quantity;
		totalObj.basicPrice += __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(item.basicPrice);
		if (isGST) {
			product.push({ text: '₹ ' + item.totlePrice, style: "productRight" });
			totalObj.totlePrice += __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(item.totlePrice);
		}
		productList.push(product);
	});

	if (isGST) {
		productList.push([{ text: '', style: "product" }, { text: 'Total', style: "productTotalLeft" },
		// { text: '', style: "product" },
		{ text: totalObj.quantity, style: "productTotalRight" }, { text: '', style: "product" }, { text: '', style: "product" }, { text: totalObj.basicPrice.toFixed(2), style: "productTotalRight" }, { text: totalObj.totlePrice.toFixed(2), style: "productTotalRight" }]);
	} else {
		productList.push([{ text: '', style: "product" }, { text: 'Total', style: "productTotalLeft" },
		// { text: '', style: "product" },
		{ text: totalObj.quantity, style: "productTotalRight" }, { text: '', style: "product" }, { text: '', style: "product" }, { text: totalObj.basicPrice.toFixed(2), style: "productTotalRight" }]);
	}
	return productList;
};

var getBase64ImageFromURL = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(url) {
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						return _context.abrupt("return", new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
							var img = new Image();
							img.setAttribute("crossOrigin", "anonymous");

							img.onload = function () {
								var canvas = document.createElement("canvas");
								canvas.width = img.width;
								canvas.height = img.height;

								var ctx = canvas.getContext("2d");
								ctx.drawImage(img, 0, 0);

								var dataURL = canvas.toDataURL("image/png");

								resolve(dataURL);
							};

							img.onerror = function (error) {
								reject(error);
							};

							img.src = url;
						}));

					case 1:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, _this);
	}));

	return function getBase64ImageFromURL(_x) {
		return _ref.apply(this, arguments);
	};
}();

var convertToOrder = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(metaData) {
		var pdfDoc, productList, productLength, logoData, imgToExport, canvas, base64;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						pdfDoc = {
							content: [{
								table: {
									widths: ['40%', '60%'],
									body: [[{
										image: 'sampleImage.jpg',
										width: 120,
										height: 80
									}, {
										text: [{ text: 'Firm Name\n', style: 'FirmHeader' }, { text: 'GSTIN\n' }, { text: 'Local Address\n' }, { text: 'Address\n' }, { text: 'MOBILE\n' }, { text: 'EMAIL\n' }]
									}]]

								},
								layout: {
									hLineWidth: function hLineWidth(i, node) {
										return i === 0 || i === node.table.body.length ? 2 : 1;
									},
									vLineWidth: function vLineWidth(i, node) {
										return i === 0 || i === node.table.widths.length ? 2 : 1;
									},
									hLineColor: function hLineColor(i, node) {
										return i === 0 || i === node.table.body.length ? 'black' : 'white';
									},
									vLineColor: function vLineColor(i, node) {
										return i === 0 || i === node.table.widths.length ? 'black' : 'white';
									}
								}
							}, {
								table: {
									widths: ['42.80%', '*'],
									body: [[{ text: 'ORDER TO', style: "topHeader" }, { text: 'ORDER DETAILS', style: "topHeader" }], [{
										text: [{ text: ' ', bold: true }, { text: 'Google\n' }, { text: ' ', bold: true }, { text: '7788996655\n' },
										// { text: ' ', bold: true },
										// { text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n' },
										{ text: ' ', bold: true }, { text: '7788996655\n' }]
									}, {
										text: [{ text: 'Date: ', bold: true }, { text: '12/12/90 \n' }, { text: 'Order: ', bold: true }, { text: '12/12/90 \n' }, { text: 'Location: ', bold: true }, { text: '12/12/90 \n' }]
									}]]
								}
							}, {
								table: {
									widths: ['5%', '40%', '5%', '10%', '10%', '15%', '15%'],
									body: [[{ text: 'S.N', style: "productHeader", rowSpan: 2 }, { text: 'PARTICULARS', style: "productHeader", rowSpan: 2 },
									// { text: 'HSN/SAC', style: "productHeader", rowSpan: 2 },
									{ text: 'QTY', style: "productHeader", rowSpan: 2 }, { text: 'UNIT', style: "productHeader", rowSpan: 2 }, { text: 'RATE', style: "productHeader", rowSpan: 2 }, { text: 'TAXABLE AMOUNT', style: "productHeader", rowSpan: 2 }, { text: 'TOTAL AMOUNT', style: "productHeader", rowSpan: 2 }], [{ text: 'S.N', style: "productHeader" }, { text: 'PARTICULARS', style: "productHeader" },
									// { text: 'HSN/SAC', style: "productHeader" },
									{ text: 'QTY', style: "productHeader" }, { text: 'UNIT', style: "productHeader" }, { text: 'RATE', style: "productHeader" }, { text: 'TAXABLE AMOUNT', style: "productHeader" }, { text: 'TOTAL AMOUNT', style: "productHeader" }]]
								}
							}, {
								table: {
									widths: ['60%', '*'],
									body: [[{}, {
										text: [{ text: 'TAXABLE AMOUNT   :       ', bold: true, style: 'TaxableHeader' }, { text: '12122\n', style: 'TaxableHeaderRightAlign' }, { text: 'CGST AMOUNT          :       ', bold: true, style: 'TaxableHeader' }, { text: '12122\n', style: 'TaxableHeaderRightAlign' }, { text: 'SGST AMOUNT          :       ', bold: true, style: 'TaxableHeader' }, { text: '12122\n', style: 'TaxableHeaderRightAlign' }, { text: 'IGST AMOUNT           :        ', bold: true, style: 'TaxableHeader' }, { text: '12122\n', style: 'TaxableHeaderRightAlign' }, { text: 'TOTAL AMOUNT        :       ', bold: true, style: 'TaxableHeaderTotal' }, { text: '12122\n', style: 'TaxableHeaderTotalRightAlign' }]

									}]]

								},
								style: 'tab2'

							}, {
								table: {
									widths: ['30%', '40%', '30%'],
									body: [[{
										text: [{ text: 'PAYMENT DETAILS\n', style: 'transpotationDel' }, { text: '', style: 'invoiceDetails' }]
									}, {
										text: [{ text: 'TERMS AND CONDITIONS\n', style: 'transpotationDel' }, { text: '', style: 'invoiceDetails' }]
									}, {
										text: [{ text: '' }, { text: 'Firm Name  ', bold: true, style: 'transpotationDel' }, { text: '\n\n\n\n' }, { text: 'AUTHORITY SIGNATURE', bold: true, style: 'transpotationDel' }, { text: '\n' }]

									}]]

								},
								layout: {
									hLineWidth: function hLineWidth(i, node) {
										return i === 0 || i === node.table.body.length ? 2 : 1;
									},
									vLineWidth: function vLineWidth(i, node) {
										return i === 0 || i === node.table.widths.length ? 2 : 1;
									},
									hLineColor: function hLineColor(i, node) {
										return i === 0 || i === node.table.body.length ? 'black' : 'white';
									},
									vLineColor: function vLineColor(i, node) {
										return i === 0 || i === node.table.widths.length ? 'black' : 'white';
									}
								}
							}, {
								table: {
									widths: ['*'],
									body: [[{ text: 'Thank you for giving us your valuable time ! Visit Again', style: 'thankyouMsg' }]]
								}
							}],
							footer: {
								columns: [{ text: 'Powered By ACUIFY', alignment: 'right', color: '#160091' }],
								margin: [10, 10]
							},
							styles: {
								header: {
									fontSize: 14,
									bold: true,
									alignment: 'center'
								},
								thankyouMsg: {
									fontSize: 12,
									alignment: 'center',
									bold: true,
									color: '#160091'
								},
								productHeader: {
									fontSize: 11,
									bold: true,
									alignment: 'center',
									color: '#160091'
								},
								transpotationDel: {
									fontSize: 11,
									bold: true,
									alignment: 'center',
									color: '#160091'
								},
								gstHeader: {
									fontSize: 9,
									color: '#160091',
									bold: true,
									alignment: 'center'
								},
								TaxableHeader: {
									fontSize: 12,
									bold: true
								},
								TaxableHeaderRightAlign: {
									fontSize: 12,
									bold: true,
									alignment: 'right'
								},
								TaxableHeaderTotal: {
									fontSize: 12,
									bold: true
								},
								TaxableHeaderTotalRightAlign: {
									fontSize: 12,
									color: '#160091',
									bold: true,
									alignment: 'right'
								},
								TotalHeader: {
									fontSize: 10,
									bold: true,
									color: '#160091'
								},
								FirmHeader: {
									fontSize: 12,
									color: '#160091',
									bold: true
								},
								product: {
									fontSize: 9,
									alignment: 'center'
								},
								product1: {
									fontSize: 10,
									alignment: 'left'
								},
								productRight: {
									fontSize: 10,
									alignment: 'right'
								},
								productTotalLeft: {
									fontSize: 12,
									alignment: 'left',
									bold: true,
									color: '#160091'
								},
								productTotalRight: {
									fontSize: 12,
									alignment: 'right',
									bold: true,
									color: '#160091'
								},
								total: {
									fontSize: 10,
									alignment: 'center',
									bold: true
								},
								topHeader: {
									color: '#160091',
									fontSize: 13,
									alignment: 'center',
									bold: true
								},
								invoiceDetails: {
									fontSize: 9
								}
							}
							//Firm Details 
						};
						pdfDoc.content[0].table.body[0][1].text[0].text = (metaData.firm.name ? metaData.firm.name.toUpperCase() : '') + "\n";
						pdfDoc.content[0].table.body[0][1].text[1].text = (metaData.firm.GST_number ? metaData.firm.GST_number : '') + "\n";
						pdfDoc.content[0].table.body[0][1].text[2].text = (metaData.firm.liveAddress ? metaData.firm.liveAddress : '') + "\n";
						pdfDoc.content[0].table.body[0][1].text[3].text = (metaData.firm.address ? metaData.firm.address : '') + "\n";
						pdfDoc.content[0].table.body[0][1].text[4].text = (metaData.firm.mobileNumber ? metaData.firm.mobileNumber : '') + "\n";
						// pdfDoc.content[0].table.body[0][1].text[7].text = (metaData.firm.panNumber ? metaData.firm.panNumber : '') + "\n";
						pdfDoc.content[0].table.body[0][1].text[5].text = (metaData.firm.email ? metaData.firm.email : '') + "\n";
						// pdfDoc.content[0].table.body[0][1].text[2].text = (metaData.firm.GST_number ? metaData.firm.GST_number : '') + "\n";
						// pdfDoc.content[0].table.body[0][1].text[13].text = (metaData.firm.website ? metaData.firm.website : '') + "\n";

						//Invoice Details
						// pdfDoc.content[1].table.body[1][1].text[1].text = new Date(metaData.invoiceData.date).toLocaleString() + "\n";
						pdfDoc.content[1].table.body[1][1].text[1].text = new Date(metaData.invoiceData.date).toLocaleDateString('en-GB') + '  -  ' + new Date(metaData.invoiceData.time).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }) + "\n";
						pdfDoc.content[1].table.body[1][1].text[3].text = metaData.invoiceData.orderNumber + "\n";
						pdfDoc.content[1].table.body[1][1].text[5].text = metaData.invoiceData.floorName + '-' + metaData.invoiceData.tableName + "\n";

						//Receipient Details

						pdfDoc.content[1].table.body[1][0].text[1].text = (metaData.customer.name ? metaData.customer.name.toUpperCase() : '') + "\n";
						pdfDoc.content[1].table.body[1][0].text[3].text = (metaData.customer.localAddress ? metaData.customer.localAddress : '') + "\n";
						// pdfDoc.content[1].table.body[1][0].text[5].text = (metaData.customer.address ? metaData.customer.address : '') + "\n";
						pdfDoc.content[1].table.body[1][0].text[5].text = (metaData.customer.mobile ? metaData.customer.mobile : '') + "\n";
						// pdfDoc.content[1].table.body[1][0].text[9].text = (metaData.customer.GST_number ? metaData.customer.GST_number : '') + "\n";
						// pdfDoc.content[1].table.body[1][0].text[11].text = (metaData.customer.stateCode ? metaData.customer.stateCode : '') + "\n";


						//Products
						productList = convertToPDFProducts(metaData.invoiceData.items, true);

						productList.map(function (item) {
							pdfDoc.content[2].table.body.push(item);
						});

						//Bank Account Details
						if (metaData.terms.banks.length) {
							metaData.terms.banks.map(function (bankDetails) {
								pdfDoc.content[4].table.body[0][0].text.push({ text: bankDetails.bankName + " ( " + bankDetails.ifsccode + " )\n", style: 'invoiceDetails' });
								pdfDoc.content[4].table.body[0][0].text.push({ text: "A/C: " + bankDetails.accountnumber + "\n", style: 'invoiceDetails' });
								pdfDoc.content[4].table.body[0][0].text.push({ text: bankDetails.address + "\n", style: 'invoiceDetails' });
							});
						}

						//Terms and cond
						pdfDoc.content[4].table.body[0][1].text[1].text = metaData.terms.termsAndConditions;

						productLength = pdfDoc.content[2].table.body.length - 1;

						//gst details
						// pdfDoc.content[5].table.body[0][1].text[1].text = (metaData.invoiceData.totalAmount ? Number.parseFloat(metaData.invoiceData.totalAmount).toFixed(2) - Number.parseFloat(metaData.gstTotal.CGST_val + metaData.gstTotal.SGST_val + metaData.gstTotal.IGST_val).toFixed(2) : '0') + "\n";

						pdfDoc.content[3].table.body[0][1].text[1].text = pdfDoc.content[2].table.body[productLength][5].text + "\n";
						pdfDoc.content[3].table.body[0][1].text[3].text = (metaData.gstTotal.CGST_val ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.CGST_val).toFixed(2) : '0') + "\n";
						pdfDoc.content[3].table.body[0][1].text[5].text = (metaData.gstTotal.SGST_val ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.SGST_val).toFixed(2) : '0') + "\n";
						pdfDoc.content[3].table.body[0][1].text[7].text = (metaData.gstTotal.IGST_val ? __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_number_parse_float___default()(metaData.gstTotal.IGST_val).toFixed(2) : '0') + "\n";
						pdfDoc.content[3].table.body[0][1].text[9].text = pdfDoc.content[2].table.body[productLength][6].text + "\n";

						// pdfDoc.content[6].table.body[0][1].text[17].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";

						//authority
						pdfDoc.content[4].table.body[0][2].text[1].text = metaData.firm.name ? metaData.firm.name.toUpperCase() : '';

						if (!metaData.terms.printLogo) {
							_context2.next = 38;
							break;
						}

						_context2.prev = 25;
						_context2.next = 28;
						return getBase64ImageFromURL(metaData.terms.printLogo);

					case 28:
						logoData = _context2.sent;

						pdfDoc.content[0].table.body[0][0].image = logoData;
						return _context2.abrupt("return", pdfDoc);

					case 33:
						_context2.prev = 33;
						_context2.t0 = _context2["catch"](25);

						console.log(_context2.t0);

					case 36:
						_context2.next = 45;
						break;

					case 38:
						imgToExport = document.getElementById('pdfimgToExport');
						canvas = document.createElement('canvas');

						canvas.width = imgToExport.width;
						canvas.height = imgToExport.height;
						canvas.getContext('2d').drawImage(imgToExport, 0, 0);
						base64 = canvas.toDataURL('image/png');

						pdfDoc.content[0].table.body[0][0].image = base64;

					case 45:
						return _context2.abrupt("return", pdfDoc);

					case 46:
					case "end":
						return _context2.stop();
				}
			}
		}, _callee2, _this, [[25, 33]]);
	}));

	return function convertToOrder(_x2) {
		return _ref2.apply(this, arguments);
	};
}();

var convertToOrderWithoutGST = function () {
	var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(metaData) {
		var pdfDoc, productList, productLength, logoData, imgToExport, canvas, base64;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						pdfDoc = {
							content: [{
								table: {
									widths: ['40%', '60%'],
									body: [[{
										image: 'sampleImage.jpg',
										width: 120,
										height: 80
									}, {
										text: [{ text: 'Firm Name\n', style: 'FirmHeader' }, { text: 'LocalAddress\n' }, { text: 'Address\n' }, { text: 'MOBILE\n' }, { text: 'EMAIL\n' }]
									}]]

								},
								layout: {
									hLineWidth: function hLineWidth(i, node) {
										return i === 0 || i === node.table.body.length ? 2 : 1;
									},
									vLineWidth: function vLineWidth(i, node) {
										return i === 0 || i === node.table.widths.length ? 2 : 1;
									},
									hLineColor: function hLineColor(i, node) {
										return i === 0 || i === node.table.body.length ? 'black' : 'white';
									},
									vLineColor: function vLineColor(i, node) {
										return i === 0 || i === node.table.widths.length ? 'black' : 'white';
									}
								}
							}, {
								table: {
									widths: ['40%', '*'],
									body: [[{ text: 'ORDER FROM', style: "topHeader" }, { text: 'ORDER DETAILS', style: "topHeader" }], [{
										text: [{ text: ' ', bold: true }, { text: 'Google\n' }, { text: ' ', bold: true },
										// { text: '7788996655\n' },
										// { text: ' ', bold: true },
										{ text: '1600 Amphitheatre Parkway in Mountain View, California, United States, near San Jose. \n' }, { text: ' ', bold: true }, { text: '7788996655\n' }]
									}, {
										text: [{ text: 'Date: ', bold: true }, { text: '12/12/90 \n' }, { text: 'Order: ', bold: true }, { text: '12/12/90 \n' }, { text: 'Location: ', bold: true }, { text: '12/12/90 \n' }]
									}]]
								}
							}, {
								table: {
									widths: ['7%', '34%', '9%', '15%', '15%', '20%'],
									body: [[{ text: 'S.No', style: "productHeader", rowSpan: 2 }, { text: 'Product Name', style: "productHeader", rowSpan: 2 },
									// { text: 'HSN code', style: "productHeader", rowSpan: 2 },
									{ text: 'Quantity', style: "productHeader", rowSpan: 2 }, { text: 'Units', style: "productHeader", rowSpan: 2 }, { text: 'Rate', style: "productHeader", rowSpan: 2 }, { text: 'Total Amount', style: "productHeader", rowSpan: 2 }], [{ text: 'S.No', style: "productHeader" }, { text: 'Product Description', style: "productHeader" },
									// { text: 'HSN code', style: "productHeader" },
									{ text: 'Qty', style: "productHeader" }, { text: 'Units', style: "productHeader" }, { text: 'Rate', style: "productHeader" }, { text: 'Total Amount', style: "productHeader" }]]
								}
							}, {
								table: {
									widths: ['65.80%', '*'],
									body: [[{}, {
										text: [{ text: 'Payable Amount:         ', bold: true, style: 'TotalHeader' }, { text: '12122\n', style: 'TotalHeader' }]

									}]]

								},
								style: 'tab2'

							}, {
								table: {
									widths: ['30%', '40%', '30%'],
									body: [[{
										text: [{ text: 'PAYMENT DETAILS\n', style: 'transpotationDel' }, { text: '', style: 'invoiceDetails' }]
									}, {
										text: [{ text: 'TERMS AND CONDITIONS\n', style: 'transpotationDel' }, { text: '', style: 'invoiceDetails' }]
									}, {
										text: [{ text: '' }, { text: 'Firm Name  ', bold: true, alignment: 'center', color: 'primary' }, { text: '\n\n\n' }, { text: 'AUTHORITY SIGNATURE', bold: true, alignment: 'center', color: 'primary' }, { text: '\n' }]

									}]]

								},
								layout: {
									hLineWidth: function hLineWidth(i, node) {
										return i === 0 || i === node.table.body.length ? 1 : 1;
									},
									vLineWidth: function vLineWidth(i, node) {
										return i === 0 || i === node.table.widths.length ? 1 : 1;
									},
									hLineColor: function hLineColor(i, node) {
										return i === 0 || i === node.table.body.length ? 'black' : 'white';
									},
									vLineColor: function vLineColor(i, node) {
										return i === 0 || i === node.table.widths.length ? 'black' : 'white';
									}
								}
							}, {
								table: {
									widths: ['*'],
									body: [[{ text: 'Thank you for giving us your valuable time ! Visit Again', style: 'thankyouMsg' }]]
								}
							}],
							footer: {
								columns: [{ text: 'Powered By ACUIFY', alignment: 'right', color: '#160091' }],
								margin: [10, 10]
							},
							styles: {
								header: {
									fontSize: 14,
									bold: true,
									alignment: 'center'
								},
								productHeader: {
									fontSize: 11,
									bold: true,
									alignment: 'center',
									color: '#160091'
								},
								transpotationDel: {
									bold: true,
									alignment: 'center',
									color: '#160091'
								},
								gstHeader: {
									fontSize: 9,
									color: '#160091',
									bold: true,
									alignment: 'center'
								},
								TaxableHeader: {
									fontSize: 10,
									bold: true
								},
								TotalHeader: {
									fontSize: 12,
									bold: true,
									color: '#160091'
								},
								FirmHeader: {
									fontSize: 16,
									color: '#160091',
									bold: true
								},
								thankyouMsg: {
									fontSize: 12,
									alignment: 'center',
									bold: true,
									color: '#160091'
								},
								product: {
									fontSize: 9,
									alignment: 'center'
								},
								product1: {
									fontSize: 10,
									alignment: 'left'
								},
								productRight: {
									fontSize: 10,
									alignment: 'right'
								},
								productTotalRight: {
									fontSize: 12,
									alignment: 'right',
									bold: true,
									color: '#160091'
								},
								productTotalLeft: {
									fontSize: 12,
									alignment: 'left',
									bold: true,
									color: '#160091'
								},
								total: {
									fontSize: 10,
									alignment: 'center',
									bold: true
								},
								topHeader: {
									color: '#160091',
									fontSize: 13,
									alignment: 'center',
									bold: true
								},
								invoiceDetails: {
									fontSize: 9
								}
							}
							//Firm Details 
						};
						pdfDoc.content[0].table.body[0][1].text[0].text = (metaData.firm.name ? metaData.firm.name.toUpperCase() : '') + "\n";
						pdfDoc.content[0].table.body[0][1].text[1].text = (metaData.firm.liveAddress ? metaData.firm.liveAddress : '') + "\n";
						pdfDoc.content[0].table.body[0][1].text[2].text = (metaData.firm.address ? metaData.firm.address : '') + "\n";
						pdfDoc.content[0].table.body[0][1].text[3].text = (metaData.firm.mobileNumber ? metaData.firm.mobileNumber : '') + "\n";
						// pdfDoc.content[0].table.body[0][1].text[7].text = (metaData.firm.panNumber ? metaData.firm.panNumber : '') + "\n";
						// pdfDoc.content[0].table.body[0][1].text[2].text = (metaData.firm.GST_number ? metaData.firm.GST_number : '') + "\n";
						pdfDoc.content[0].table.body[0][1].text[4].text = (metaData.firm.email ? metaData.firm.email : '') + "\n";

						// pdfDoc.content[0].table.body[0][1].text[13].text = (metaData.firm.website ? metaData.firm.website : '') + "\n";

						//Invoice Details
						pdfDoc.content[1].table.body[1][1].text[1].text = new Date(metaData.invoiceData.date).toLocaleDateString('en-GB') + '  -  ' + new Date(metaData.invoiceData.time).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true }) + "\n";
						pdfDoc.content[1].table.body[1][1].text[3].text = metaData.invoiceData.orderNumber + "\n";
						pdfDoc.content[1].table.body[1][1].text[5].text = metaData.invoiceData.floorName + '-' + metaData.invoiceData.tableName + "\n";
						//Receipient Details

						pdfDoc.content[1].table.body[1][0].text[1].text = (metaData.customer.name ? metaData.customer.name : '') + "\n";
						pdfDoc.content[1].table.body[1][0].text[3].text = (metaData.customer.localAddress ? metaData.customer.localAddress : '') + "\n";
						// pdfDoc.content[1].table.body[1][0].text[5].text = (metaData.customer.address ? metaData.customer.address : '') + "\n";
						pdfDoc.content[1].table.body[1][0].text[5].text = (metaData.customer.mobile ? metaData.customer.mobile : '') + "\n";
						// pdfDoc.content[1].table.body[1][0].text[9].text = (metaData.customer.GST_number ? metaData.customer.GST_number : '') + "\n";
						// pdfDoc.content[1].table.body[1][0].text[11].text = (metaData.customer.stateCode ? metaData.customer.stateCode : '') + "\n";


						//Products
						productList = null;

						if (metaData.call) {
							productList = convertToPDFProducts(metaData.invoiceData.items.filter(function (i) {
								return i.call == metaData.call;
							}), false);
						} else {
							productList = convertToPDFProducts(metaData.invoiceData.items, false);
						}
						productList.map(function (item) {
							pdfDoc.content[2].table.body.push(item);
						});

						//Bank Account Details
						if (metaData.terms.banks.length) {
							metaData.terms.banks.map(function (bankDetails) {
								pdfDoc.content[4].table.body[0][0].text.push({ text: bankDetails.bankName + " ( " + bankDetails.ifsccode + " )\n", style: 'invoiceDetails' });
								pdfDoc.content[4].table.body[0][0].text.push({ text: "A/C: " + bankDetails.accountnumber + "\n", style: 'invoiceDetails' });
								pdfDoc.content[4].table.body[0][0].text.push({ text: bankDetails.address + "\n", style: 'invoiceDetails' });
							});
						}

						//Terms and cond
						pdfDoc.content[4].table.body[0][1].text[1].text = metaData.terms.termsAndConditions;

						productLength = pdfDoc.content[2].table.body.length - 1;

						//gst details

						pdfDoc.content[3].table.body[0][1].text[1].text = pdfDoc.content[2].table.body[productLength][5].text + "\n";

						// pdfDoc.content[6].table.body[0][1].text[17].text = (metaData.invoiceData.paymentType ? metaData.invoiceData.paymentType : '') + "\n";

						//authority
						pdfDoc.content[4].table.body[0][2].text[1].text = metaData.firm.name ? metaData.firm.name.toUpperCase() : '';

						if (!metaData.terms.printLogo) {
							_context3.next = 34;
							break;
						}

						_context3.prev = 21;
						_context3.next = 24;
						return getBase64ImageFromURL(metaData.terms.printLogo);

					case 24:
						logoData = _context3.sent;

						pdfDoc.content[0].table.body[0][0].image = logoData;
						return _context3.abrupt("return", pdfDoc);

					case 29:
						_context3.prev = 29;
						_context3.t0 = _context3["catch"](21);

						console.log(_context3.t0);

					case 32:
						_context3.next = 41;
						break;

					case 34:
						imgToExport = document.getElementById('pdfimgToExport');
						canvas = document.createElement('canvas');

						canvas.width = imgToExport.width;
						canvas.height = imgToExport.height;
						canvas.getContext('2d').drawImage(imgToExport, 0, 0);
						base64 = canvas.toDataURL('image/png');

						pdfDoc.content[0].table.body[0][0].image = base64;

					case 41:
						return _context3.abrupt("return", pdfDoc);

					case 42:
					case "end":
						return _context3.stop();
				}
			}
		}, _callee3, _this, [[21, 29]]);
	}));

	return function convertToOrderWithoutGST(_x3) {
		return _ref3.apply(this, arguments);
	};
}();

/***/ }),
/* 1429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":"","text-xs-center":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"text-xs-center"},[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":{ name: 'Dashboard' }}},[_c('b',{staticClass:"title primary white--text"},[_vm._v(" Manage Order ")])])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-select',{attrs:{"solo":"","clearable":"","items":_vm.getOrderedCustomers,"label":"Buyers"},model:{value:(_vm.selectedCustomer),callback:function ($$v) {_vm.selectedCustomer=$$v},expression:"selectedCustomer"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-select',{attrs:{"solo":"","clearable":"","items":['IN PROGRESS', 'CANCELLED', 'BILLED', 'ALL'],"label":"Filter"},model:{value:(_vm.statusFilter),callback:function ($$v) {_vm.statusFilter=$$v},expression:"statusFilter"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{staticClass:"white-datepicker",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerFrom),callback:function ($$v) {_vm.datepickerFrom=$$v},expression:"datepickerFrom"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"From Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.dateFrom),callback:function ($$v) {_vm.dateFrom=$$v},expression:"dateFrom"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerFrom = false}},model:{value:(_vm.dateFrom),callback:function ($$v) {_vm.dateFrom=$$v},expression:"dateFrom"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{staticClass:"white-datepicker",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerTo),callback:function ($$v) {_vm.datepickerTo=$$v},expression:"datepickerTo"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"To Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.dateTo),callback:function ($$v) {_vm.dateTo=$$v},expression:"dateTo"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerTo = false}},model:{value:(_vm.dateTo),callback:function ($$v) {_vm.dateTo=$$v},expression:"dateTo"}})],1),_vm._v(" "),_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":'informations/product-order-report/'}},[(!_vm.isRestaurantBusiness)?_c('v-btn',{attrs:{"outlined":""}},[_c('v-icon',{staticClass:"primary--text",attrs:{"left":""}},[_vm._v("mdi-alert-box")]),_vm._v(" Order\n            Product\n          ")],1):_vm._e()],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.isRestaurantBusiness)?_c('v-btn',{attrs:{"outlined":""},on:{"click":function($event){return _vm.viewTable()}}},[_c('v-icon',{attrs:{"left":"","color":"primary"}},[_vm._v("remove_red_eye")]),_vm._v(" View Tables\n        ")],1):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"outlined":""},on:{"click":function($event){return _vm.addOrderDialog()}}},[_c('v-icon',{attrs:{"left":"","color":"primary"}},[_vm._v("add")]),_vm._v(" New Order\n        ")],1)],1),_vm._v(" "),(_vm.isRestaurantBusiness)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}},[_c('v-btn',{attrs:{"outlined":""},on:{"click":function($event){_vm.kitchenDialog = true}}},[_c('v-icon',{attrs:{"left":"","color":"primary"}},[_vm._v("fastfood")]),_vm._v(" Kitchen Screen\n                  ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}},[_c('v-select',{attrs:{"solo":"","clearable":"","items":['Normal', 'Parcel', 'All'],"label":"Type"},model:{value:(_vm.orderTypeFilter),callback:function ($$v) {_vm.orderTypeFilter=$$v},expression:"orderTypeFilter"}})],1)],1):_vm._e(),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.orderHeader,"items":_vm.filteredOrders,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('v-menu',{attrs:{"bottom":"","right":"","offset-y":"","close-on-content-click":false}},[_c('v-btn',{staticClass:"mx-0",attrs:{"slot":"activator","icon":"","dark":""},slot:"activator"},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',[_c('v-list-group',{attrs:{"prepend-icon":'picture_as_pdf',"no-action":""},scopedSlots:_vm._u([{key:"activator",fn:function(){return [_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Actions")])],1)],1)]},proxy:true}],null,true)},[_vm._v(" "),(props.item['orderHistory'])?_c('v-list-tile',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.openHistory(props.item)}}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("history")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Processed Order")])],1):_vm._e(),_vm._v(" "),(props.item['orignalOrder'])?_c('v-list-tile',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.openOrignal(props.item)}}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("trip_origin")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v(" Original Order ")])],1):_vm._e(),_vm._v(" "),(props.item['status'] == 'IN PROGRESS' && _vm.hasOrderEditPermission)?_c('v-list-tile',{on:{"click":function($event){return _vm.editOrder(props.item)}}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Add/Edit Order")])],1):_vm._e(),_vm._v(" "),(props.item['status'] == 'IN PROGRESS'  && _vm.hasOrderDeletePermission)?_c('v-list-tile',{on:{"click":function($event){return _vm.deleteOrder(props.item)}}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("delete")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Delete Order")])],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('td',[_c('v-icon',{attrs:{"disabled":props.item['status'] == 'CANCELLED' ||
                props.item['status'] == 'BILLED' ||
                (_vm.getCustomerName(props.item.buyerId) == 'DELETED CUSTOMER'
                  ? _vm.isShopUserExists(props.item.shopOrderUserId)
                    ? false
                    : true
                  : false),"color":"primary"},on:{"click":function($event){return _vm.openProd(props.item)}}},[_vm._v("remove_red_eye")])],1),_vm._v(" "),_c('td',[_c('b',[_vm._v("\n              "+_vm._s(props.item["tableName"])+"\n            ")])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["orderNumber"])+" -\n              "+_vm._s(props.item["orderType"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(new Date(props.item.date).toLocaleDateString("en-GB") || '-'))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(new Date(props.item.time).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })))])]),_vm._v(" "),_c('td',[(props.item.buyerId)?_c('b',[_vm._v(_vm._s(_vm.getCustomerName(props.item.buyerId)))]):(_vm.isShopUserExists(props.item.shopOrderUserId))?_c('b',[_vm._v(_vm._s(_vm.getShopUserName(props.item.shopOrderUserId)))]):_c('b',[_c('v-btn',{on:{"click":function($event){return _vm.addShopUser(props.item)}}},[_vm._v(_vm._s(props.item.shopOrderUserName))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_vm._v("New Customer. Click To Create Buyer.")])],1)]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["invoiceDate"]
                ? new Date(props.item.invoiceDate).toLocaleDateString("en-GB")
                : ""))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold red--text"},[_vm._v(_vm._s(_vm._f("amount")(_vm.getTotal(props.item) || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["status"]))])]),_vm._v(" "),(props.item['status'] != 'CANCELLED')?_c('td',[(props.item['status'] == 'IN PROGRESS')?_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.cancelOrder(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("cancel")])],1):_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.dispatrchOrder(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("commute")])],1)],1):_c('td'),_vm._v(" "),_c('td',[_c('v-menu',{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"mx-0",attrs:{"icon":""}},on),[_c('v-icon',{attrs:{"color":"blue"}},[_vm._v("print")])],1)]}}],null,true)},[_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.printOrder(props.item, true)}}},[_c('v-list-tile-title',[_vm._v(" Taxable Print ")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.printOrder(props.item, false)}}},[_c('v-list-tile-title',[_vm._v(" Simple Print ")])],1),_vm._v(" "),_vm._l((_vm.getOrders(props.item)),function(i){return _c('v-list-tile',{key:i},[_c('v-list-tile',{on:{"click":function($event){return _vm.printOrder(props.item, false, i)}}},[_c('v-list-tile-title',[_vm._v("Call- "+_vm._s(i)+" ")])],1)],1)})],2)],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","persistent":""},model:{value:(_vm.orderDialog),callback:function ($$v) {_vm.orderDialog=$$v},expression:"orderDialog"}},[_c('v-card',{attrs:{"persistent":""}},[_c('v-card-title',{staticClass:"primary white--text"},[(_vm.isEdit)?_c('span',{staticClass:"headline"},[_vm._v("Edit Order")]):_c('span',{staticClass:"headline"},[_vm._v("Create Order")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-switch',{attrs:{"disabled":_vm.isEdit,"label":("" + (_vm.isBuyer ? 'Sale Order' : 'Purchase Order'))},model:{value:(_vm.isBuyer),callback:function ($$v) {_vm.isBuyer=$$v},expression:"isBuyer"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-switch',{attrs:{"disabled":_vm.isEdit,"label":"Multi-firm"},on:{"change":function($event){return _vm.restructureProductList()}},model:{value:(_vm.multiFirm),callback:function ($$v) {_vm.multiFirm=$$v},expression:"multiFirm"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-select',{attrs:{"dense":"","disabled":_vm.multiFirm,"items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-select',{attrs:{"items":_vm.isBuyer ? _vm.buyersByBrand : _vm.sellersByBrand,"label":_vm.isBuyer ? 'Select or add Customer' : 'Select or add Seller',"autocomplete":"","disabled":_vm.isEdit,"item-text":"name","return-object":""},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addCustomer($event)}},model:{value:(_vm.selectedBuyer),callback:function ($$v) {_vm.selectedBuyer=$$v},expression:"selectedBuyer"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerOrder),callback:function ($$v) {_vm.datepickerOrder=$$v},expression:"datepickerOrder"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Order Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerOrder = false}},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm1":"","md1":""}},[_c('v-text-field',{attrs:{"prefix":"#","label":"Order Number","placeholder":"Enter Order Number","required":""},model:{value:(_vm.orderNumber),callback:function ($$v) {_vm.orderNumber=$$v},expression:"orderNumber"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-select',{attrs:{"item-text":"name","item-value":"id","items":_vm.currentOrderType,"label":"Choose Order Type"},model:{value:(_vm.orderType),callback:function ($$v) {_vm.orderType=$$v},expression:"orderType"}})],1),_vm._v(" "),(_vm.ordersSetting && _vm.ordersSetting.isOrderTime)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-time-picker',{attrs:{"label":"Order Time"},model:{value:(_vm.orderTime),callback:function ($$v) {_vm.orderTime=$$v},expression:"orderTime"}})],1):_vm._e(),_vm._v(" "),(_vm.ordersSetting && _vm.ordersSetting.isStaffSelection)?_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[(_vm.orderType==='Normal')?_c('v-select',{attrs:{"dense":"","items":_vm.staffByBrand,"label":"Sold By"},model:{value:(_vm.soldBy),callback:function ($$v) {_vm.soldBy=$$v},expression:"soldBy"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.isRestaurantBusiness && !_vm.multiFirm)?_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[(_vm.orderType==='Normal')?_c('v-select',{attrs:{"dense":"","items":_vm.floorList,"label":"Select Floor","item-text":"name","item-value":"name"},on:{"change":function($event){_vm.getTableList();
                  _vm.getFloorList();}},model:{value:(_vm.floorName),callback:function ($$v) {_vm.floorName=$$v},expression:"floorName"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.tableList.length)?_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.tableList,"label":"Select Table","item-text":"name","item-value":"name"},model:{value:(_vm.tableName),callback:function ($$v) {_vm.tableName=$$v},expression:"tableName"}})],1):_vm._e(),_vm._v(" "),(_vm.tableName && _vm.floorName)?_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[(!_vm.isTabOccupied)?_c('v-btn',{attrs:{"color":"green darken-4","flat":""},on:{"click":function($event){return _vm.changeTableStatus(true)}}},[_vm._v("Book Table")]):_c('v-btn',{attrs:{"color":"red darken-4","flat":""},on:{"click":function($event){return _vm.changeTableStatus(false)}}},[_vm._v("Release Table")])],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"wrap":""}},[_vm._l((_vm.items),function(item,index){return [_c('v-flex',{key:index + item.productId,staticStyle:{"display":"inline-flex"},attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-select',{staticStyle:{"width":"90%"},attrs:{"dense":"","autocomplete":"","item-text":"name","item-value":'name',"items":_vm.productListByBrand,"label":"Product Name"},on:{"change":function($event){return _vm.restructureProductList(index)}},model:{value:(item.productName),callback:function ($$v) {_vm.$set(item, "productName", $$v)},expression:"item.productName"}}),_vm._v(" "),(_vm.isRestaurantBusiness)?_c('v-text-field',{staticStyle:{"width":"10%"},attrs:{"disabled":"","type":"number","label":"Call"},model:{value:(item.call),callback:function ($$v) {_vm.$set(item, "call", $$v)},expression:"item.call"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{key:index + item.productName,attrs:{"xs1":"","sm1":"","md1":""}},[(item.productName)?_c('v-text-field',{attrs:{"type":"number","label":"Quantity"},model:{value:(item.quantity),callback:function ($$v) {_vm.$set(item, "quantity", _vm._n($$v))},expression:"item.quantity"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{key:index + item.unit,attrs:{"xs2":"","sm2":"","md2":""}},[(item.productName)?_c('v-select',{attrs:{"dense":"","item-text":"text","item-value":"value","items":_vm.availableProductUnit[item.productId].units,"label":"Select unit"},on:{"change":function($event){return _vm.unitChange(item)}},model:{value:(item.unit),callback:function ($$v) {_vm.$set(item, "unit", $$v)},expression:"item.unit"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{key:index + item.productName + 'RATE',attrs:{"xs2":"","sm2":"","md2":""}},[(item.productName)?_c('v-text-field',{attrs:{"type":"number","disabled":!_vm.hasOrderRateEditPermission,"label":"Rate"},model:{value:(item.rate),callback:function ($$v) {_vm.$set(item, "rate", _vm._n($$v))},expression:"item.rate"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{key:index + item.productName + 'total',attrs:{"xs2":"","sm2":"","md2":""}},[(item.productName)?_c('v-text-field',{attrs:{"type":"number","value":Number.parseFloat(
                          (item.rate ? Number.parseFloat(item.rate) : 0) *
                            (item.rate ? Number.parseFloat(item.quantity) : 0)
                        ).toFixed(2),"disabled":true,"label":"Total"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{key:index + item.productName + 'add',attrs:{"xs1":"","sm1":"","md1":""}},[(item.productName)?_c('v-btn',{attrs:{"icon":"","color":"primary"},on:{"click":function($event){return _vm.removeProd(index)}}},[_c('v-icon',[_vm._v("cancel")])],1):_vm._e(),_vm._v(" "),(index == _vm.items.length - 1 && item.productName)?_c('v-btn',{attrs:{"icon":"","color":"primary"},on:{"click":function($event){return _vm.addProd()}}},[_c('v-icon',[_vm._v("add_circle")])],1):_vm._e()],1)]})],2)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){_vm.orderDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","disabled":!_vm.items.length ||
            !_vm.selectedBuyer ||
            !_vm.items[0].productId ||
            (_vm.multiFirm ? false : !_vm.selectedFirm),"flat":""},on:{"click":function($event){return _vm.addOrder()}}},[_vm._v(_vm._s(_vm.isEdit ? "Save" : "Create"))])],1)],1)],1),_vm._v(" "),(_vm.selectedOrder && _vm.selectedOrder['.key'])?_c('v-dialog',{attrs:{"width":"800"},model:{value:(_vm.invoiceOrder),callback:function ($$v) {_vm.invoiceOrder=$$v},expression:"invoiceOrder"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline grey lighten-2",attrs:{"primary-title":""}},[_vm._v("Order details:-\n        ")]),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.productInvoiceHeader,"items":_vm.selectedOrder.items},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{class:props.item.completed ? 'green-bg' : ''},[(_vm.isRestaurantBusiness)?_c('td',[_c('b',[_vm._v(_vm._s(props.item["call"]))])]):_vm._e(),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["productName"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["quantity"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.unit))])]),_vm._v(" "),_c('td',[_c('b',[_c('v-text-field',{attrs:{"type":"number","disabled":!_vm.hasOrderRateEditPermission,"label":"Product Rate"},model:{value:(props.item.rate),callback:function ($$v) {_vm.$set(props.item, "rate", _vm._n($$v))},expression:"props.item.rate"}})],1)]),_vm._v(" "),_c('td',[_c('v-text-field',{attrs:{"type":"number","value":(props.item.rate
                      ? Number.parseFloat(props.item.rate)
                      : 0) *
                    (props.item.rate
                      ? Number.parseFloat(props.item.quantity)
                      : 0),"disabled":true,"label":"Total"}})],1)])]}}],null,false,3770887966)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.invoiceOrder = false}}},[_vm._v("Back")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.createInvoice()}}},[_vm._v("Create Invoice\n        ")])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.selectedOrder && _vm.selectedOrder['.key'])?_c('v-dialog',{attrs:{"width":"800"},model:{value:(_vm.orderHistory),callback:function ($$v) {_vm.orderHistory=$$v},expression:"orderHistory"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline grey lighten-2",attrs:{"primary-title":""}},[_vm._v(_vm._s(_vm.modalMode == "history"
            ? "Proceesed Order History:-"
            : "Orignal Order:- ")+"\n        ")]),_vm._v(" "),_c('v-card-text',[(_vm.modalMode == 'orignal')?[_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.productInvoiceHeader,"items":_vm.selectedOrder.orignalOrder},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{class:props.item.completed ? 'green-bg' : ''},[(_vm.isRestaurantBusiness)?_c('td',[_c('b',[_vm._v(_vm._s(props.item["call"]))])]):_vm._e(),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["productName"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["quantity"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.unit))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.rate))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s((props.item.rate
                      ? Number.parseFloat(props.item.rate)
                      : 0) *
                    (props.item.rate
                      ? Number.parseFloat(props.item.quantity)
                      : 0)))])])])]}}],null,false,2185673059)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)]:[_c('v-stepper',{attrs:{"vertical":""},model:{value:(_vm.historyStep),callback:function ($$v) {_vm.historyStep=$$v},expression:"historyStep"}},[_vm._l((_vm.selectedOrder.orderHistory),function(item,index){return [_c('v-stepper-step',{key:item['.key'],attrs:{"step":index + 1}},[_c('v-link',{on:{"click":function($event){_vm.historyStep = index + 1}}},[_vm._v(_vm._s(new Date(item["date"]).toLocaleDateString("en-GB")))])],1),_vm._v(" "),_c('v-stepper-content',{key:index + 'a' + item['.key'],attrs:{"step":index + 1}},[_c('v-card',{staticClass:"mb-12 invoice-stepper"},[_c('v-layout',{staticStyle:{"padding":"30px"},attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('h2',{staticStyle:{"text-decoration":"underline","text-align":"center"}},[_vm._v("\n                        Product List\n                      ")]),_vm._v(" "),[_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.productInvoiceHeader,"items":item.items},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{class:props.item.completed ? 'green-bg' : ''},[(_vm.isRestaurantBusiness)?_c('td',[_c('b',[_vm._v(_vm._s(props.item["call"]))])]):_vm._e(),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["productName"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["quantity"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.unit))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.rate))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s((props.item.rate
                                    ? Number.parseFloat(props.item.rate)
                                    : 0) *
                                  (props.item.rate
                                    ? Number.parseFloat(props.item.quantity)
                                    : 0)))])])])]}}],null,true)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)]],2)],1)],1)],1)]})],2)]],2),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.orderHistory = false}}},[_vm._v("Back")])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.currentInfra)?_c('v-dialog',{attrs:{"fullscreen":"","persistent":""},model:{value:(_vm.tableDialog),callback:function ($$v) {_vm.tableDialog=$$v},expression:"tableDialog"}},[_c('v-card',[_c('v-card-text',[_c('v-tabs',{attrs:{"color":"primary","dark":"","centered":""},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},[_vm._l((_vm.currentInfra.floorDetails),function(floor){return [_c('v-tab',{key:floor.name + 't'},[_vm._v(_vm._s(floor.name))]),_vm._v(" "),_c('v-tab-item',{key:floor.name + 'it'},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((floor.tables),function(table){return _c('v-flex',{key:table.name,attrs:{"xs12":"","sm2":""}},[_c('v-card',{class:table.booked ? 'lightgreen-bg' : '',staticStyle:{"padding":"0 10px"},attrs:{"height":"200px"}},[_c('v-card-title',{staticClass:"title white lighten-4",attrs:{"height":"200px","primary-title":""}},[_vm._v(_vm._s(table.name)+"\n                    ")]),_vm._v(" "),_c('v-card-text',[_c('h2',{staticClass:"primary--text font-weight-bold",staticStyle:{"text-align":"center","font-size":"18px"}},[_vm._v("\n                        "+_vm._s(table.booked ? "RESERVED" : "OPEN")+"\n                      ")]),_vm._v(" "),(table.booked && table.order)?_c('h4',{staticStyle:{"text-align":"center","font-size":"12px"}},[_vm._v("\n                        "+_vm._s(_vm.staffByBrand.find(
                            function (i) { return i["value"] == table.order.soldBy; }
                          ).text)+"\n                      ")]):_vm._e()]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-card-actions',[_c('v-list-item',{staticClass:"grow"},[_c('v-layout',{staticStyle:{"margin-top":"-20px"},attrs:{"align-center":"","justify-end":""}},[(table.booked && table.order)?_c('v-icon',{staticClass:"mr-3 primary--text",on:{"click":function($event){return _vm.editOrder(table.order)}}},[_vm._v("\n                            add\n                          ")]):_vm._e(),_vm._v(" "),(!table.booked)?_c('v-icon',{staticClass:"mr-3 primary--text",on:{"click":function($event){return _vm.addOrderDialog(table.name,floor.name)}}},[_vm._v("\n                            book\n                          ")]):_vm._e(),_vm._v(" "),(table.booked && table.order)?_c('v-menu',{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                          var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"mx-0",attrs:{"icon":""}},on),[_c('v-icon',{staticClass:"mr-3 primary--text"},[_vm._v("mdi-receipt")])],1)]}}],null,true)},[_vm._v(" "),_c('v-list',_vm._l((_vm.getOrders(table.order)),function(i){return _c('v-list-tile',{key:i},[_c('v-list-tile',{on:{"click":function($event){return _vm.printOrder(table.order, false, i)}}},[_c('v-list-tile-title',[_vm._v("Call- "+_vm._s(i)+"\n                                  ")])],1)],1)}),1)],1):_vm._e(),_vm._v(" "),(table.booked)?_c('v-icon',{staticClass:"mr-3 primary--text",on:{"click":function($event){return _vm.releaseTable(
                                floor.name,
                                table.name,
                                table.order
                              )}}},[_vm._v("\n                            lock_open\n                          ")]):_vm._e(),_vm._v(" "),(table.booked && table.order)?_c('v-menu',{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                              var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"mx-0",attrs:{"icon":""}},on),[_c('v-icon',{staticClass:"mr-3 primary--text"},[_vm._v("picture_as_pdf")])],1)]}}],null,true)},[_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.printOrder(table.order, true)}}},[_c('v-list-tile-title',[_vm._v("\n                                  Taxable Print\n                                ")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.printOrder(table.order, false)}}},[_c('v-list-tile-title',[_vm._v("\n                                  Simple Print\n                                ")])],1)],1)],1):_vm._e()],1)],1)],1)],1)],1)}),1)],1)]})],2)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.tableDialog = false}}},[_vm._v("Back")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","persistent":""},model:{value:(_vm.kitchenDialog),callback:function ($$v) {_vm.kitchenDialog=$$v},expression:"kitchenDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline grey lighten-2",attrs:{"primary-title":""}},[_vm._v("Order Details\n      ")]),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.kitchenOrderHeader,"items":_vm.getKetchenItems},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',[_c('td',[(props.item.time)?_c('b',[_vm._v(_vm._s(new Date(props.item["time"]).toLocaleTimeString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })))]):_vm._e()]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["productName"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["quantity"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.order.tableName))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.order.floorName))])])])]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.kitchenDialog = false}}},[_vm._v("Back")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_staff_vue__ = __webpack_require__(467);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33cb2d09_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_staff_vue__ = __webpack_require__(1432);
function injectStyle (ssrContext) {
  __webpack_require__(1431)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-33cb2d09"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_staff_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33cb2d09_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_staff_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1431 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"godawn-details",attrs:{"fluid":"","grid-list-md":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('router-link',{attrs:{"to":"/Dashboard"}},[_c('v-btn',{attrs:{"icon":"","dark":""}},[_c('v-icon',[_vm._v("keyboard_backspace")])],1)],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Sales Team")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.staffByBrand),function(staff){return _c('v-flex',{key:staff['.key'],staticStyle:{"padding":"15px"},attrs:{"xs12":"","md3":"","sm3":""}},[_c('v-card',{staticClass:"icon-card"},[_c('v-icon',{staticStyle:{"padding":"18px 18px"}},[_vm._v("business")])],1),_vm._v(" "),_c('v-card',{key:staff['.key']+'G',staticClass:"sec1-card"},[_c('v-card-title',{staticClass:"headline",attrs:{"primary-title":""}},[_c('v-spacer'),_vm._v("\n                    "+_vm._s(staff.staffName)+"\n                  ")],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('b',{staticClass:"subheading primary--text font-weight-light"},[_vm._v(_vm._s(_vm.firmbyId(staff.firm)))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v("\n                    Opening Balance : "),_c('span',[_vm._v(_vm._s(staff.openingBalance))]),_vm._v(" "),_c('v-spacer'),_vm._v("\n                    Rate : "),_c('span',[_vm._v(_vm._s(staff.brokerageRate))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text",attrs:{"outline":""},on:{"click":function($event){return _vm.openStaffTransactions(staff)}}},[_c('v-icon',{staticClass:"primary--text",attrs:{"left":""}},[_vm._v("remove_red_eye")]),_vm._v(" "),_c('a',{staticClass:"primary--text font-weight-light"},[_vm._v("View Transactions")])],1)],1)],1)}),1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":""},model:{value:(_vm.viewTransaction),callback:function ($$v) {_vm.viewTransaction=$$v},expression:"viewTransaction"}},[(_vm.currentStaff)?_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.currentStaff.staffName)+" - Transactions")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.viewTransaction = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation",attrs:{"items":_vm.currentStaffInvoices,"headers":_vm.staffTransactionHeaders},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"primary--text font-weight-bold",domProps:{"innerHTML":_vm._s(_vm.renderDate(props.item.date))}}),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.invoiceId))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getCurrentUserName(props.item.buyerId)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.brokerageRate))]),_vm._v(" "),_c('td',{staticClass:"primary--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(((props.item.totalAmount * props.item.brokerageRate)/100))))]),_vm._v(" "),_c('td',{staticClass:"red--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item.totalAmount)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.status))]),_vm._v(" "),(!props.item.brokeragePaid)?_c('td',[_c('v-btn',{staticClass:"primary--text",attrs:{"outlined":""},on:{"click":function($event){return _vm.openPayBrokerage(props.item)}}},[_vm._v("\n          PAY\n        ")])],1):_c('td',{domProps:{"innerHTML":_vm._s('Paid on ' + _vm.renderDate(props.item.brokeragePayDate))}}),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.firmbyId(props.item.firm)))])]}}],null,false,4002685309)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("no record found")])],2)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"1000px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{attrs:{"persistent":""}},[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Payment for "+_vm._s(_vm.currentPaymentGSTType))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"type":"number","disabled":"","label":"Net Payable","readonly":"","prefix":""},model:{value:(_vm.payableAmount),callback:function ($$v) {_vm.payableAmount=$$v},expression:"payableAmount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker),callback:function ($$v) {_vm.datepicker=$$v},expression:"datepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.selectedDate),callback:function ($$v) {_vm.selectedDate=$$v},expression:"selectedDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepicker = false}},model:{value:(_vm.selectedDate),callback:function ($$v) {_vm.selectedDate=$$v},expression:"selectedDate"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","m3":""}},[_c('v-select',{attrs:{"dense":"","items":[{
                                text: 'Cash',
                                value: 'Cash'
                              }, {
                                text: 'Bank Account',
                                value: 'Bank Account'
                              }],"label":"Select Payment Type"},model:{value:(_vm.paymentType),callback:function ($$v) {_vm.paymentType=$$v},expression:"paymentType"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[(['Bank Account','CashAndBank Account'].includes(_vm.paymentType))?_c('v-select',{attrs:{"dense":"","items":_vm.banksByFirms,"label":"Select Bank","flat":"","clearable":"","item-text":"bankName","return-object":"","disabled":_vm.paymentType == 'Cash' || _vm.paymentType == ''},model:{value:(_vm.selectedBank),callback:function ($$v) {_vm.selectedBank=$$v},expression:"selectedBank"}}):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"grey white--text",attrs:{"flat":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text",attrs:{"flat":""},on:{"click":function($event){return _vm.payBrokerage()}}},[_vm._v("Pay")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gst1_vue__ = __webpack_require__(468);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8be91f54_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gst1_vue__ = __webpack_require__(1435);
function injectStyle (ssrContext) {
  __webpack_require__(1434)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gst1_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8be91f54_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gst1_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1434 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md1":""}},[_c('router-link',{attrs:{"to":"/Dashboard"}},[_c('v-btn',{attrs:{"icon":"","dark":""}},[_c('v-icon',[_vm._v("keyboard_backspace")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md1":""}},[_c('h2',[_vm._v("\n            GSTR-1\n          ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md1":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-select',{staticClass:"select-firm",attrs:{"dense":"","flat":"","clearable":"","item-text":"name","return-object":"","items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-select',{staticClass:"select-firm",attrs:{"dense":"","flat":"","items":['Monthly','Quarterly','Custom'],"label":"Filter type"},model:{value:(_vm.filterType),callback:function ($$v) {_vm.filterType=$$v},expression:"filterType"}})],1),_vm._v(" "),(_vm.filterType == 'Quarterly')?_c('v-flex',{attrs:{"xs12":"","sm3":"","md4":""}},[_c('v-select',{staticClass:"select-firm",attrs:{"dense":"","flat":"","items":_vm.quarters,"label":"Select Quarter"},model:{value:(_vm.selectedQuarter),callback:function ($$v) {_vm.selectedQuarter=$$v},expression:"selectedQuarter"}})],1):_vm._e(),_vm._v(" "),(_vm.filterType == 'Monthly')?_c('v-flex',{attrs:{"xs12":"","sm3":"","md4":""}},[_c('v-select',{staticClass:"select-firm",attrs:{"dense":"","flat":"","items":_vm.months,"label":"Select Month"},model:{value:(_vm.selectedMonth),callback:function ($$v) {_vm.selectedMonth=$$v},expression:"selectedMonth"}})],1):_vm._e(),_vm._v(" "),(_vm.filterType == 'Custom')?_c('v-flex',{attrs:{"xs12":"","sm3":"","md2":""}},[_c('v-menu',{staticClass:"ist-datepicker",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerFrom),callback:function ($$v) {_vm.datepickerFrom=$$v},expression:"datepickerFrom"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"From Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.fromDate),callback:function ($$v) {_vm.fromDate=$$v},expression:"fromDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerFrom = false}},model:{value:(_vm.fromDate),callback:function ($$v) {_vm.fromDate=$$v},expression:"fromDate"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.filterType == 'Custom')?_c('v-flex',{attrs:{"xs12":"","sm3":"","md2":""}},[_c('v-menu',{staticClass:"ist-datepicker",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerTo),callback:function ($$v) {_vm.datepickerTo=$$v},expression:"datepickerTo"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"To Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.toDate),callback:function ($$v) {_vm.toDate=$$v},expression:"toDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerTo = false}},model:{value:(_vm.toDate),callback:function ($$v) {_vm.toDate=$$v},expression:"toDate"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[(_vm.selectedFirm)?[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v(" perm_identity ")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.selectedFirm.name))]),_vm._v(" -\n                  "),_c('b',[_vm._v(_vm._s(_vm.selectedFirm.GST_number))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-icon',{attrs:{"color":"primary"}},[_vm._v(" location_city ")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.generateAddress(_vm.selectedFirm)))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-icon',{attrs:{"color":"primary"}},[_vm._v(" phone ")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.selectedFirm.mobileNumber))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-icon',{attrs:{"color":"primary"}},[_vm._v(" email ")]),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.selectedFirm.email))])]:_vm._e()],2),_vm._v(" "),_c('v-flex',{staticStyle:{"overflow-x":"auto"},attrs:{"xs12":"","sm8":"","md8":""}},[_c('table',{staticClass:"fl-table"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Expand")]),_vm._v(" "),_c('th',[_vm._v("Description")]),_vm._v(" "),_c('th',[_vm._v("Total Taxable Value")]),_vm._v(" "),_c('th',{attrs:{"colspan":"4"}},[_vm._v("TAX/GST Amounts")]),_vm._v(" "),_c('th',[_vm._v("Total Invoices")])]),_vm._v(" "),_c('tr',[_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v("IGST A.")]),_vm._v(" "),_c('th',[_vm._v("CGST A.")]),_vm._v(" "),_c('th',[_vm._v("SGST A.")]),_vm._v(" "),_c('th',[_vm._v("CESS")]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[(!_vm.outwardSupplies.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.outwardSupplies)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.outwardSupplies.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.outwardSupplies)}}},[_vm._v("expand_less")]):_vm._e()],1),_vm._v(" "),_c('td',[_c('h2',[_vm._v("OUTWARD SUPPLIES")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.totalInvoiceAmount || 0)))])]),_vm._v(" "),(_vm.outwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h2',{staticClass:"primary--text"},[_c('b',[_vm._v("(A). Intra state")])])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.outwardSupplies.expand)?_c('tr',[_c('td',[(!_vm.outwardSupplies.intraState.taxable.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.outwardSupplies.intraState.taxable)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.outwardSupplies.intraState.taxable.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.outwardSupplies.intraState.taxable)}}},[_vm._v("expand_less")]):_vm._e()],1),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(i). Taxable")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.outwardSupplies.intraState.taxable.expand)?[_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (3%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_3.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_3.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_3.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_3.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_3.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_3.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (5%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_5.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_5.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_5.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_5.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_5.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_5.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (12%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_12.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_12.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_12.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_12.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_12.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_12.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (18%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_18.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_18.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_18.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_18.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_18.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_18.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (28%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_28.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_28.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_28.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_28.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_28.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_28.totalInvoiceAmount || 0)))])])]:_vm._e(),_vm._v(" "),(_vm.outwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(ii). Exempted")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.exempted.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.exempted.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.exempted.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.exempted.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.exempted.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.exempted.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.outwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(iii). Nill Rated")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.nillrated.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.nillrated.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.nillrated.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.nillrated.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.nillrated.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.nillrated.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.outwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(iv). Others")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.others.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.others.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.others.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.others.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.others.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.others.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.outwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h2',{staticClass:"primary--text"},[_c('b',[_vm._v("(B). Inter state")])])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.outwardSupplies.expand)?_c('tr',[_c('td',[(!_vm.outwardSupplies.interState.taxable.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.outwardSupplies.interState.taxable)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.outwardSupplies.interState.taxable.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.outwardSupplies.interState.taxable)}}},[_vm._v("expand_less")]):_vm._e()],1),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(i). Taxable")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.outwardSupplies.interState.taxable.expand)?[_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (3%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_3.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_3.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_3.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_3.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_3.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_3.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (5%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_5.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_5.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_5.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_5.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_5.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_5.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (12%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_12.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_12.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_12.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_12.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_12.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_12.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (18%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_18.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_18.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_18.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_18.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_18.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_18.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (28%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_28.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_28.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_28.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_28.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_28.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_28.totalInvoiceAmount || 0)))])])]:_vm._e(),_vm._v(" "),(_vm.outwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(ii). Exempted")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.exempted.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.exempted.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.exempted.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.exempted.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.exempted.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.exempted.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.outwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(iii). Nill Rated")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.nillrated.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.nillrated.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.nillrated.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.nillrated.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.nillrated.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.nillrated.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.outwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(iv). Others")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.others.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.others.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.others.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.others.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.others.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.others.totalInvoiceAmount || 0)))])]):_vm._e()],2)])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"primary white--text",attrs:{"round":"","flat":"","type":"button"},on:{"click":function($event){return _vm.exportAll()}}},[_vm._v("\n              Excel\n              "),_c('v-icon',{attrs:{"dark":""}},[_vm._v(" save_alt ")])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text",attrs:{"round":"","flat":"","type":"button"},on:{"click":function($event){return _vm.printGST1()}}},[_vm._v("\n              Print\n              "),_c('v-icon',{attrs:{"dark":""}},[_vm._v(" print ")])],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text",attrs:{"round":"","flat":"","type":"button"},on:{"click":function($event){return _vm.downloadJSON()}}},[_vm._v("\n              JSON\n              "),_c('v-icon',{attrs:{"dark":""}},[_vm._v(" save_alt ")])],1),_vm._v(" "),_c('a',{staticStyle:{"display":"none"},attrs:{"id":"downloadAnchorElem"}})],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"overflow-x":"auto"},attrs:{"xs12":""}},[_c('table',{staticClass:"fl-table"},[_c('thead',[_c('tr',[_c('th',[_vm._v("S. No")]),_vm._v(" "),_c('th',[_vm._v("Description of Invoices")]),_vm._v(" "),_c('th',[_vm._v("Voucher Count")]),_vm._v(" "),_c('th',[_vm._v("Total Taxable Value")]),_vm._v(" "),_c('th',{attrs:{"colspan":"4"}},[_vm._v("TAX/GST Amounts")]),_vm._v(" "),_c('th',[_vm._v("Total Invoices")]),_vm._v(" "),_c('th',[_vm._v("View")])]),_vm._v(" "),_c('tr',[_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v("IGST A.")]),_vm._v(" "),_c('th',[_vm._v("CGST A.")]),_vm._v(" "),_c('th',[_vm._v("SGST A.")]),_vm._v(" "),_c('th',[_vm._v("CESS")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("1")]),_vm._v(" "),_c('td',[_c('h2',[_vm._v(_vm._s(_vm.gst1_desc.B2B_invoices.title))]),_vm._v("\n                  "+_vm._s(_vm.gst1_desc.B2B_invoices.description)+"\n                ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.gst1_desc.B2B_invoices.voucherCount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.B2B_invoices.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.B2B_invoices.ICGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.B2B_invoices.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.B2B_invoices.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.B2B_invoices.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.B2B_invoices.totalInvoice || 0)))]),_vm._v(" "),_c('td',[_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.openGSTInvoice('B2B_invoices')}}},[_vm._v("remove_red_eye")])],1)]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("2")]),_vm._v(" "),_c('td',[_c('h2',[_vm._v(_vm._s(_vm.gst1_desc.B2C_invoices_big.title))]),_vm._v("\n                   "+_vm._s(_vm.gst1_desc.B2C_invoices_big.description)+"\n                ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.gst1_desc.B2C_invoices_big.voucherCount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.B2C_invoices_big.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.B2C_invoices_big.ICGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.B2C_invoices_big.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.B2C_invoices_big.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.B2C_invoices_big.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.B2C_invoices_big.totalInvoice || 0)))]),_vm._v(" "),_c('td',[_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.openGSTInvoice('B2C_invoices_big')}}},[_vm._v("remove_red_eye\n                  ")])],1)]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("3")]),_vm._v(" "),_c('td',[_c('h2',[_vm._v(_vm._s(_vm.gst1_desc.Export_invoices.title))]),_vm._v("\n                   "+_vm._s(_vm.gst1_desc.Export_invoices.description)+"\n                ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.gst1_desc.Export_invoices.voucherCount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.Export_invoices.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.Export_invoices.ICGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.Export_invoices.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.Export_invoices.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.Export_invoices.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.Export_invoices.totalInvoice || 0)))]),_vm._v(" "),_c('td',[_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.openGSTInvoice('Export_invoices')}}},[_vm._v("remove_red_eye\n                  ")])],1)]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("4")]),_vm._v(" "),_c('td',[_c('h2',[_vm._v(_vm._s(_vm.gst1_desc.B2C_invoices_small.title))]),_vm._v("\n                  "+_vm._s(_vm.gst1_desc.B2C_invoices_small.description)+"\n                ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.gst1_desc.B2C_invoices_small.voucherCount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.B2C_invoices_small.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.B2C_invoices_small.ICGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.B2C_invoices_small.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.B2C_invoices_small.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.B2C_invoices_small.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.B2C_invoices_small.totalInvoice || 0)))]),_vm._v(" "),_c('td',[_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.openGSTInvoice('B2C_invoices_small')}}},[_vm._v("remove_red_eye")])],1)]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("5")]),_vm._v(" "),_c('td',[_c('h2',[_vm._v(_vm._s(_vm.gst1_desc.Nillrated_invoices.title))]),_vm._v("\n                  "+_vm._s(_vm.gst1_desc.Nillrated_invoices.description)+"\n                ")]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("6")]),_vm._v(" "),_c('td',[_c('h2',[_vm._v(_vm._s(_vm.gst1_desc.Credit_Debit_note_reg.title))]),_vm._v("\n                  "+_vm._s(_vm.gst1_desc.Credit_Debit_note_reg.description)+"\n                ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.gst1_desc.Credit_Debit_note_reg.voucherCount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.Credit_Debit_note_reg.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.Credit_Debit_note_reg.ICGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.Credit_Debit_note_reg.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.Credit_Debit_note_reg.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.Credit_Debit_note_reg.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.Credit_Debit_note_reg.totalInvoice || 0)))]),_vm._v(" "),_c('td',[_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.openGSTInvoice('Credit_Debit_note_reg')}}},[_vm._v("remove_red_eye")])],1)]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("7")]),_vm._v(" "),_c('td',[_c('h2',[_vm._v(_vm._s(_vm.gst1_desc.Credit_Debit_note_unreg.title))]),_vm._v("\n                  "+_vm._s(_vm.gst1_desc.Credit_Debit_note_unreg.description)+"\n                ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.gst1_desc.Credit_Debit_note_unreg.voucherCount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.Credit_Debit_note_unreg.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.Credit_Debit_note_unreg.ICGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.Credit_Debit_note_unreg.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.Credit_Debit_note_unreg.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.Credit_Debit_note_unreg.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.Credit_Debit_note_unreg.totalInvoice || 0)))]),_vm._v(" "),_c('td',[_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.openGSTInvoice('Credit_Debit_note_unreg')}}},[_vm._v("remove_red_eye")])],1)]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("8")]),_vm._v(" "),_c('td',[_c('h2',[_vm._v(_vm._s(_vm.gst1_desc.Tax_Liability.title))]),_vm._v("\n                  "+_vm._s(_vm.gst1_desc.Tax_Liability.description)+"\n                ")]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("9")]),_vm._v(" "),_c('td',[_c('h2',[_vm._v(_vm._s(_vm.gst1_desc.Adjustment_advance.title))]),_vm._v("\n                  "+_vm._s(_vm.gst1_desc.Adjustment_advance.description)+"\n                ")]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("10")]),_vm._v(" "),_c('td',[_c('h2',[_vm._v(_vm._s(_vm.gst1_desc.HSN_SAC_Summary.title))]),_vm._v("\n                  "+_vm._s(_vm.gst1_desc.HSN_SAC_Summary.description)+"\n                ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.gst1_desc.HSN_SAC_Summary.voucherCount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.HSN_SAC_Summary.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.HSN_SAC_Summary.ICGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.HSN_SAC_Summary.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.HSN_SAC_Summary.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.HSN_SAC_Summary.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.gst1_desc.HSN_SAC_Summary.totalInvoice || 0)))]),_vm._v(" "),_c('td',[_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.openGSTInvoice('HSN_SAC_Summary')}}},[_vm._v("remove_red_eye")])],1)]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("11")]),_vm._v(" "),_c('td',[_c('h2',[_vm._v(_vm._s(_vm.gst1_desc.Document_Summary.title))]),_vm._v("\n                  "+_vm._s(_vm.gst1_desc.Document_Summary.description)+"\n                ")]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h2',[_vm._v("Total")])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')])])])])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.dialogGSTReports),callback:function ($$v) {_vm.dialogGSTReports=$$v},expression:"dialogGSTReports"}},[_c('v-card',[[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-toolbar-title'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('h2',{staticStyle:{"text-align":"center"}},[_vm._v("GSTR-1")]),_vm._v(" "),_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v(_vm._s(_vm.selectedGSTCat.title)+" - "+_vm._s(_vm.selectedGSTCat.description))])]),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialogGSTReports = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[(_vm.selectedFirm)?_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_vm._v("\n                Firm name :\n                "),_c('b',[_vm._v(_vm._s(_vm.selectedFirm.name))]),_vm._v(" "),_c('br'),_vm._v("Address :\n                "),_c('b',[_vm._v(_vm._s(_vm.generateAddress(_vm.selectedFirm)))]),_vm._v(" "),_c('br'),_vm._v("\n                GSTIN :\n                "),_c('b',[_vm._v(_vm._s(_vm.selectedFirm.GST_number))]),_vm._v(" "),_c('br'),_vm._v("Mobile :\n                "),_c('b',[_vm._v(_vm._s(_vm.selectedFirm.mobileNumber))]),_vm._v(" "),_c('br'),_vm._v("Email :\n                "),_c('b',[_vm._v(_vm._s(_vm.selectedFirm.email))])]):_vm._e(),_vm._v(" "),(_vm.selectedGSTCat)?_c('v-flex',{staticStyle:{"overflow-x":"auto"},attrs:{"xs12":"","sm8":"","md8":""}},[_c('table',{staticClass:"fl-table"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Description of Invoices")]),_vm._v(" "),_c('th',[_vm._v("Voucher Count")]),_vm._v(" "),_c('th',[_vm._v("Total Taxable Value")]),_vm._v(" "),_c('th',{attrs:{"colspan":"4"}},[_vm._v("TAX/GST Amounts")]),_vm._v(" "),_c('th',[_vm._v("Total Invoices")])]),_vm._v(" "),_c('tr',[_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v("IGST A.")]),_vm._v(" "),_c('th',[_vm._v("CGST A.")]),_vm._v(" "),_c('th',[_vm._v("SGST A.")]),_vm._v(" "),_c('th',[_vm._v("CESS")]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_c('h2',[_vm._v(_vm._s(_vm.selectedGSTCat.title))]),_vm._v("\n                        "+_vm._s(_vm.selectedGSTCat.description)+"\n                      ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.selectedGSTCat.voucherCount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.selectedGSTCat.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.selectedGSTCat.ICGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.selectedGSTCat.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.selectedGSTCat.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.selectedGSTCat.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.selectedGSTCat.totalInvoice || 0)))])])])])]):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){return _vm.printGST1Individual()}}},[_vm._v("Print")]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","type":"button"},on:{"click":function($event){return _vm.onexport()}}},[_vm._v("Excel")])],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"overflow-x":"auto"},attrs:{"xs12":""}},[(_vm.selectedGSTCat && _vm.selectedGSTCat.invoices.length)?_c('table',{staticClass:"fl-table"},[(_vm.selectedGSTCat.title == 'HSN/SAC Summary')?[_c('thead',[_c('tr',[_c('th',[_vm._v("S. No")]),_vm._v(" "),_c('th',[_vm._v("\n                      HSN\n                    ")]),_vm._v(" "),_c('th',[_vm._v("\n                      Description\n                    ")]),_vm._v(" "),_c('th',[_vm._v("UQC")]),_vm._v(" "),_c('th',[_vm._v("Total Quantity")]),_vm._v(" "),_c('th',[_vm._v("Total Value")]),_vm._v(" "),_c('th',[_vm._v("Total Taxable Value")]),_vm._v(" "),_c('th',{attrs:{"colspan":"4"}},[_vm._v("TAX Amounts")])]),_vm._v(" "),_c('tr',[_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v("IGST A.")]),_vm._v(" "),_c('th',[_vm._v("CGST A.")]),_vm._v(" "),_c('th',[_vm._v("SGST A.")]),_vm._v(" "),_c('th',[_vm._v("CESS")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.selectedGSTCat.invoices),function(invoice,index){return _c('tr',{key:("invoice1-" + index)},[_c('td',[_vm._v(_vm._s(index+1))]),_vm._v(" "),_c('td',[_c('h2',[_vm._v(_vm._s(invoice.HSN_code))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(invoice.description))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(invoice.UQC))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(invoice.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(invoice.totalAmount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(invoice.basicAmount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(invoice.IGST))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(invoice.CGST))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(invoice.SGST))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(invoice.CESS))])])}),0)]:[_c('thead',[_c('tr',[_c('th',[_vm._v("S. No")]),_vm._v(" "),_c('th',[_vm._v("\n                      Customer Name\n                      "),_c('br'),_vm._v("GSTIN/UIN\n                      "),_c('br'),_vm._v("Location\n                    ")]),_vm._v(" "),_c('th',[_vm._v("Invoice Number")]),_vm._v(" "),_c('th',[_vm._v("Date")]),_vm._v(" "),_c('th',[_vm._v("Taxable Value")]),_vm._v(" "),_c('th',{attrs:{"colspan":"4"}},[_vm._v("TAX Amounts")]),_vm._v(" "),_c('th',[_vm._v("Invoice Amount")]),_vm._v(" "),_c('th',[_vm._v("Action")])]),_vm._v(" "),_c('tr',[_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v("IGST A.")]),_vm._v(" "),_c('th',[_vm._v("CGST A.")]),_vm._v(" "),_c('th',[_vm._v("SGST A.")]),_vm._v(" "),_c('th',[_vm._v("CESS")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',_vm._l((_vm.selectedGSTCat.invoices),function(invoice,index){return _c('tr',{key:("invoice-" + index)},[_c('td',[_vm._v(_vm._s(index+1))]),_vm._v(" "),_c('td',[_c('h2',[_vm._v(_vm._s(invoice.buyer.name))]),_vm._v("\n                      "+_vm._s(invoice.buyer.GST_number)+"\n                      "),_c('br'),_vm._v("\n                      "+_vm._s(invoice.buyer.state)+"\n                    ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(invoice.invoiceId))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(new Date(invoice.date).toLocaleDateString('en-GB')))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(invoice.basicAmount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(invoice.IGST_val))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(invoice.CGST_val))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(invoice.SGST_val))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(invoice.CESS))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(invoice.totalAmount))]),_vm._v(" "),_c('td')])}),0)]],2):_vm._e()])],1)],1)]],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gst3_vue__ = __webpack_require__(469);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8169591a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gst3_vue__ = __webpack_require__(1438);
function injectStyle (ssrContext) {
  __webpack_require__(1437)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gst3_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8169591a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gst3_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1437 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md1":""}},[_c('router-link',{attrs:{"to":"/Dashboard"}},[_c('v-btn',{attrs:{"icon":"","dark":""}},[_c('v-icon',[_vm._v("keyboard_backspace")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md1":""}},[_c('h2',[_vm._v("\n            GSTR-3\n          ")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md1":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-select',{staticClass:"select-firm",attrs:{"dense":"","flat":"","clearable":"","item-text":"name","return-object":"","items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md1":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md2":""}},[_c('v-menu',{staticClass:"ist-datepicker",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerFrom),callback:function ($$v) {_vm.datepickerFrom=$$v},expression:"datepickerFrom"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"From Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.fromDate),callback:function ($$v) {_vm.fromDate=$$v},expression:"fromDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerFrom = false}},model:{value:(_vm.fromDate),callback:function ($$v) {_vm.fromDate=$$v},expression:"fromDate"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md1":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md2":""}},[_c('v-menu',{staticClass:"ist-datepicker",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerTo),callback:function ($$v) {_vm.datepickerTo=$$v},expression:"datepickerTo"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"To Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.toDate),callback:function ($$v) {_vm.toDate=$$v},expression:"toDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerTo = false}},model:{value:(_vm.toDate),callback:function ($$v) {_vm.toDate=$$v},expression:"toDate"}})],1)],1)],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[(_vm.selectedFirm)?[_vm._v("\n                Firm name :\n                "),_c('b',[_vm._v(_vm._s(_vm.selectedFirm.name))]),_vm._v(" "),_c('br'),_vm._v("Address :\n                "),_c('b',[_vm._v(_vm._s(_vm.generateAddress(_vm.selectedFirm)))]),_vm._v(" "),_c('br'),_vm._v("\n                GSTIN :\n                "),_c('b',[_vm._v(_vm._s(_vm.selectedFirm.GST_number))]),_vm._v(" "),_c('br'),_vm._v("Mobile :\n                "),_c('b',[_vm._v(_vm._s(_vm.selectedFirm.mobileNumber))]),_vm._v(" "),_c('br'),_vm._v("Email :\n                "),_c('b',[_vm._v(_vm._s(_vm.selectedFirm.email))]),_vm._v(" "),_c('br')]:_vm._e()],2),_vm._v(" "),_c('v-flex',{staticStyle:{"overflow-x":"auto"},attrs:{"xs12":"","sm8":"","md8":""}},[_c('table',{staticClass:"fl-table"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Expand")]),_vm._v(" "),_c('th',[_vm._v("Description")]),_vm._v(" "),_c('th',[_vm._v("Total Taxable Value")]),_vm._v(" "),_c('th',{attrs:{"colspan":"4"}},[_vm._v("TAX/GST Amounts")]),_vm._v(" "),_c('th',[_vm._v("Total Invoices")])]),_vm._v(" "),_c('tr',[_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v("IGST A.")]),_vm._v(" "),_c('th',[_vm._v("CGST A.")]),_vm._v(" "),_c('th',[_vm._v("SGST A.")]),_vm._v(" "),_c('th',[_vm._v("CESS")]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[(!_vm.outwardSupplies.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.outwardSupplies)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.outwardSupplies.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.outwardSupplies)}}},[_vm._v("expand_less")]):_vm._e()],1),_vm._v(" "),_c('td',[_c('h2',[_vm._v("OUTWARD SUPPLIES")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.totalInvoiceAmount || 0)))])]),_vm._v(" "),(_vm.outwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h2',{staticClass:"primary--text"},[_c('b',[_vm._v("(A). Intra state ")])])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.outwardSupplies.expand)?_c('tr',[_c('td',[(!_vm.outwardSupplies.intraState.taxable.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.outwardSupplies.intraState.taxable)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.outwardSupplies.intraState.taxable.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.outwardSupplies.intraState.taxable)}}},[_vm._v("expand_less")]):_vm._e()],1),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(i). Taxable")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.outwardSupplies.intraState.taxable.expand)?[_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (3%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_3.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_3.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_3.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_3.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_3.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_3.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (5%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_5.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_5.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_5.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_5.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_5.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_5.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (12%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_12.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_12.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_12.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_12.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_12.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_12.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (18%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_18.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_18.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_18.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_18.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_18.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_18.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (28%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_28.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_28.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_28.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_28.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_28.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_28.totalInvoiceAmount || 0)))])])]:_vm._e(),_vm._v(" "),(_vm.outwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(ii). Exempted")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.exempted.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.exempted.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.exempted.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.exempted.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.exempted.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.exempted.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.outwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(iii). Nill Rated")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.nillrated.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.nillrated.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.nillrated.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.nillrated.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.nillrated.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.nillrated.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.outwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(iv). Others")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.others.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.others.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.others.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.others.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.others.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.others.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.outwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h2',{staticClass:"primary--text"},[_c('b',[_vm._v(" (B). Inter state ")])])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.outwardSupplies.expand)?_c('tr',[_c('td',[(!_vm.outwardSupplies.interState.taxable.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.outwardSupplies.interState.taxable)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.outwardSupplies.interState.taxable.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.outwardSupplies.interState.taxable)}}},[_vm._v("expand_less")]):_vm._e()],1),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(i). Taxable")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.outwardSupplies.interState.taxable.expand)?[_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (3%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_3.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_3.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_3.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_3.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_3.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_3.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (5%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_5.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_5.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_5.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_5.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_5.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_5.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (12%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_12.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_12.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_12.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_12.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_12.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_12.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (18%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_18.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_18.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_18.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_18.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_18.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_18.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (28%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_28.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_28.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_28.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_28.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_28.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_28.totalInvoiceAmount || 0)))])])]:_vm._e(),_vm._v(" "),(_vm.outwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(ii). Exempted")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.exempted.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.exempted.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.exempted.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.exempted.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.exempted.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.exempted.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.outwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(iii). Nill Rated")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.nillrated.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.nillrated.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.nillrated.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.nillrated.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.nillrated.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.nillrated.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.outwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(iv). Others")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.others.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.others.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.others.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.others.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.others.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.others.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.inwardSupplies && _vm.inwardSupplies.hasOwnProperty('expand'))?[_c('tr',[_c('td',[(!_vm.inwardSupplies.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.inwardSupplies)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.inwardSupplies.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.inwardSupplies)}}},[_vm._v("expand_less")]):_vm._e()],1),_vm._v(" "),_c('td',[_c('h2',[_vm._v("INWARD SUPPLIES")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.totalInvoiceAmount || 0)))])]),_vm._v(" "),(_vm.inwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h3',[_vm._v("(A). Intra state")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.inwardSupplies.expand)?_c('tr',[_c('td',[(!_vm.inwardSupplies.intraState.taxable.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.inwardSupplies.intraState.taxable)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.inwardSupplies.intraState.taxable.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.inwardSupplies.intraState.taxable)}}},[_vm._v("expand_less")]):_vm._e()],1),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(i). Taxable")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.inwardSupplies.intraState.taxable.expand)?[_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (3%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_3.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_3.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_3.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_3.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_3.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_3.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (5%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_5.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_5.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_5.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_5.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_5.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_5.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (12%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_12.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_12.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_12.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_12.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_12.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_12.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (18%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_18.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_18.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_18.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_18.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_18.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_18.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (28%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_28.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_28.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_28.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_28.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_28.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_28.totalInvoiceAmount || 0)))])])]:_vm._e(),_vm._v(" "),(_vm.inwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(ii). Exempted")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.exempted.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.exempted.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.exempted.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.exempted.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.exempted.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.exempted.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.inwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(iii). Nill Rated")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.nillrated.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.nillrated.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.nillrated.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.nillrated.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.nillrated.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.nillrated.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.inwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(iv). Others")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.others.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.others.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.others.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.others.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.others.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.others.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.inwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h3',[_vm._v("(A). Inter state")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.inwardSupplies.expand)?_c('tr',[_c('td',[(!_vm.inwardSupplies.interState.taxable.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.inwardSupplies.interState.taxable)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.inwardSupplies.interState.taxable.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.inwardSupplies.interState.taxable)}}},[_vm._v("expand_less")]):_vm._e()],1),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(i). Taxable")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.inwardSupplies.interState.taxable.expand)?[_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (3%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_3.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_3.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_3.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_3.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_3.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_3.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (5%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_5.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_5.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_5.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_5.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_5.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_5.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (12%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_12.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_12.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_12.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_12.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_12.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_12.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (18%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_18.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_18.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_18.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_18.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_18.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_18.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (28%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_28.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_28.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_28.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_28.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_28.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_28.totalInvoiceAmount || 0)))])])]:_vm._e(),_vm._v(" "),(_vm.inwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(ii). Exempted")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.exempted.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.exempted.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.exempted.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.exempted.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.exempted.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.exempted.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.inwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(iii). Nill Rated")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.nillrated.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.nillrated.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.nillrated.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.nillrated.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.nillrated.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.nillrated.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.inwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(iv). Others")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.others.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.others.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.others.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.others.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.others.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.others.totalInvoiceAmount || 0)))])]):_vm._e()]:_vm._e()],2)])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm1":"","md1":""}},[_c('br'),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text",attrs:{"round":"","flat":"","type":"button"},on:{"click":function($event){return _vm.onexport()}}},[_vm._v("\n                Excel\n                  "),_c('v-icon',{attrs:{"dark":""}},[_vm._v(" save_alt ")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text",attrs:{"round":"","flat":"","type":"button"},on:{"click":function($event){return _vm.printGST3()}}},[_vm._v("\n                Print\n              "),_c('v-icon',{attrs:{"dark":""}},[_vm._v(" print ")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"overflow-x":"auto"},attrs:{"xs12":""}},[_c('table',{staticClass:"fl-table"},[_c('thead',[_c('tr',[_c('th',[_vm._v("S. No")]),_vm._v(" "),_c('th',[_vm._v("Expand")]),_vm._v(" "),_c('th',[_vm._v("Description")]),_vm._v(" "),_c('th',[_vm._v("Place of Supply")]),_vm._v(" "),_c('th',[_vm._v("Total Taxable Value")]),_vm._v(" "),_c('th',{attrs:{"colspan":"4"}},[_vm._v("TAX/GST Amounts")]),_vm._v(" "),_c('th',[_vm._v("Total Invoices")])]),_vm._v(" "),_c('tr',[_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v("IGST A.")]),_vm._v(" "),_c('th',[_vm._v("CGST A.")]),_vm._v(" "),_c('th',[_vm._v("SGST A.")]),_vm._v(" "),_c('th',[_vm._v("CESS")]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("3.1")]),_vm._v(" "),_c('td',[(!_vm.tab2.row_3_1_expand.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.tab2.row_3_1_expand)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.tab2.row_3_1_expand.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.tab2.row_3_1_expand)}}},[_vm._v("expand_less")]):_vm._e()],1),_vm._v(" "),_c('td',[_c('h2',[_vm._v("OUTWARD Supplies & INWARD SUPPLIES liable to reverse charge")])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.totalInvoiceAmount || 0)))])]),_vm._v(" "),(_vm.tab2.row_3_1_expand.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('h3',[_vm._v("(A). Outward Taxable Supplies")]),_vm._v("Taxable\n                ")]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.totalBaseAmount + _vm.outwardSupplies.intraState.taxable.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.IGST + _vm.outwardSupplies.intraState.taxable.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.CGST + _vm.outwardSupplies.intraState.taxable.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.SGST + _vm.outwardSupplies.intraState.taxable.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.CESS + _vm.outwardSupplies.intraState.taxable.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.totalInvoiceAmount + _vm.outwardSupplies.intraState.taxable.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.tab2.row_3_1_expand.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('h3',[_vm._v("(B). Outward Taxable Supplies")]),_vm._v("Zero Rated\n                ")]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.nillrated.totalBaseAmount + _vm.outwardSupplies.intraState.nillrated.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.nillrated.IGST + _vm.outwardSupplies.intraState.nillrated.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.nillrated.CGST + _vm.outwardSupplies.intraState.nillrated.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.nillrated.SGST + _vm.outwardSupplies.intraState.nillrated.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.nillrated.CESS + _vm.outwardSupplies.intraState.nillrated.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.nillrated.totalInvoiceAmount + _vm.outwardSupplies.intraState.nillrated.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.tab2.row_3_1_expand.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('h3',[_vm._v("(C). Outward Taxable Supplies")]),_vm._v("Nill Rated or Exempt\n                ")]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.exempted.totalBaseAmount + _vm.outwardSupplies.intraState.exempted.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.exempted.IGST + _vm.outwardSupplies.intraState.exempted.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.exempted.CGST + _vm.outwardSupplies.intraState.exempted.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.exempted.SGST + _vm.outwardSupplies.intraState.exempted.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.exempted.CESS + _vm.outwardSupplies.intraState.exempted.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.exempted.totalInvoiceAmount + _vm.outwardSupplies.intraState.exempted.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.tab2.row_3_1_expand.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('h3',[_vm._v("(D). Inward Taxable Supplies")]),_vm._v("Liable To Reverse Charge\n                ")]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")])]):_vm._e(),_vm._v(" "),(_vm.tab2.row_3_1_expand.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('h3',[_vm._v("(E). NON-GST Outward Supplies")])]),_vm._v(" "),_c('td',[_vm._v("-")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.others.totalBaseAmount + _vm.outwardSupplies.intraState.others.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.others.IGST + _vm.outwardSupplies.intraState.others.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.others.CGST + _vm.outwardSupplies.intraState.others.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.others.SGST + _vm.outwardSupplies.intraState.others.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.others.CESS + _vm.outwardSupplies.intraState.others.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.others.totalInvoiceAmount + _vm.outwardSupplies.intraState.others.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_vm._v("3.2")]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('h2',[_vm._v("INTER-STATE Supplies Made To Understand Composition Taxable Persons...")])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("4")]),_vm._v(" "),_c('td',[(!_vm.tab2.row_4_expand.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.tab2.row_4_expand)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.tab2.row_4_expand.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.tab2.row_4_expand)}}},[_vm._v("expand_less")]):_vm._e()],1),_vm._v(" "),_c('td',[_c('h2',[_vm._v("ELIGIABLE ITC")])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")])]),_vm._v(" "),(_vm.tab2.row_4_expand.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('h3',[_vm._v("(A). ITC Available [Full/Part]")])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")])]):_vm._e(),_vm._v(" "),(_vm.tab2.row_4_expand.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(i). Imports of Goods")])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")])]):_vm._e(),_vm._v(" "),(_vm.tab2.row_4_expand.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(ii). Imports of Services")])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")])]):_vm._e(),_vm._v(" "),(_vm.tab2.row_4_expand.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(iii). Inward Supplies Liable")]),_vm._v(" "),_c('h4',[_vm._v("To reverse charges")])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")])]):_vm._e(),_vm._v(" "),(_vm.tab2.row_4_expand.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(iv). Inward Supplies From ISD")])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")])]):_vm._e(),_vm._v(" "),(_vm.tab2.row_4_expand.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(v). All Other ITC")])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.tab2.row_4_expand.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('h3',[_vm._v("(B). ITC Reserved")])]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")])]):_vm._e(),_vm._v(" "),(_vm.tab2.row_4_expand.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(i). As per Rules 42 & 43")]),_vm._v(" "),_c('h4',[_vm._v("of cost")])]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")])]):_vm._e(),_vm._v(" "),(_vm.tab2.row_4_expand.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(ii). Others")])]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")])]):_vm._e(),_vm._v(" "),(_vm.tab2.row_4_expand.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('h3',[_vm._v("(C). Net ITC Available")]),_vm._v(" "),_c('h3',[_vm._v("(A) - (B)")])]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")])]):_vm._e(),_vm._v(" "),(_vm.tab2.row_4_expand.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('h3',[_vm._v("(D). InEligible ITC")])]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")])]):_vm._e(),_vm._v(" "),(_vm.tab2.row_4_expand.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(i). As per Section 17(s)")])]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")])]):_vm._e(),_vm._v(" "),(_vm.tab2.row_4_expand.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(ii). Others")])]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")])]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_vm._v("5")]),_vm._v(" "),_c('td',[(!_vm.tab2.row_5_expand.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.tab2.row_5_expand)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.tab2.row_5_expand.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.tab2.row_5_expand)}}},[_vm._v("expand_less")]):_vm._e()],1),_vm._v(" "),_c('td',[_c('h2',[_vm._v("Values Of Exempted Nill rated & NON-GST Inward Supplies")])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")])]),_vm._v(" "),(_vm.tab2.row_5_expand.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('h3',[_vm._v("(A). From Supplier Under")]),_vm._v(" "),_c('h3',[_vm._v("Composition Scheme, Exempt")]),_vm._v(" "),_c('h3',[_vm._v("& Nillrated Supplies")])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")])]):_vm._e(),_vm._v(" "),(_vm.tab2.row_5_expand.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('h3',[_vm._v("(B). Non-GST Supplies")])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")]),_vm._v(" "),_c('td',[_vm._v("0")])]):_vm._e()])])])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gstMonthly_vue__ = __webpack_require__(470);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6463e181_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gstMonthly_vue__ = __webpack_require__(1441);
function injectStyle (ssrContext) {
  __webpack_require__(1440)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gstMonthly_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6463e181_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gstMonthly_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1440 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('h2',[_c('router-link',{attrs:{"to":"/informations"}},[_c('v-btn',{attrs:{"icon":"","dark":""}},[_c('v-icon',[_vm._v("keyboard_backspace")])],1)],1),_vm._v(" \n          GSTR    \n          ")],1)]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-select',{staticClass:"select-firm",attrs:{"dense":"","flat":"","clearable":"","item-text":"name","return-object":"","items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-select',{staticClass:"select-firm",attrs:{"dense":"","clearable":"","flat":"","items":['Monthly','Quarterly','Custom'],"label":"Filter type"},model:{value:(_vm.filterType),callback:function ($$v) {_vm.filterType=$$v},expression:"filterType"}})],1),_vm._v(" "),(_vm.filterType == 'Quarterly')?_c('v-flex',{attrs:{"xs12":"","sm3":"","md4":""}},[_c('v-select',{staticClass:"select-firm",attrs:{"clearable":"","dense":"","flat":"","items":_vm.quarters,"label":"Select Quarter"},model:{value:(_vm.selectedQuarter),callback:function ($$v) {_vm.selectedQuarter=$$v},expression:"selectedQuarter"}})],1):_vm._e(),_vm._v(" "),(_vm.filterType == 'Monthly')?_c('v-flex',{attrs:{"xs12":"","sm3":"","md4":""}},[_c('v-select',{staticClass:"select-firm",attrs:{"dense":"","clearable":"","flat":"","items":_vm.months,"label":"Select Month"},model:{value:(_vm.selectedMonth),callback:function ($$v) {_vm.selectedMonth=$$v},expression:"selectedMonth"}})],1):_vm._e(),_vm._v(" "),(_vm.filterType == 'Custom')?_c('v-flex',{attrs:{"xs12":"","sm3":"","md2":""}},[_c('v-menu',{staticClass:"ist-datepicker",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerFrom),callback:function ($$v) {_vm.datepickerFrom=$$v},expression:"datepickerFrom"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"From Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.fromDate),callback:function ($$v) {_vm.fromDate=$$v},expression:"fromDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerFrom = false}},model:{value:(_vm.fromDate),callback:function ($$v) {_vm.fromDate=$$v},expression:"fromDate"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.filterType == 'Custom')?_c('v-flex',{attrs:{"xs12":"","sm3":"","md2":""}},[_c('v-menu',{staticClass:"ist-datepicker",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerTo),callback:function ($$v) {_vm.datepickerTo=$$v},expression:"datepickerTo"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"To Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.toDate),callback:function ($$v) {_vm.toDate=$$v},expression:"toDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerTo = false}},model:{value:(_vm.toDate),callback:function ($$v) {_vm.toDate=$$v},expression:"toDate"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[(_vm.selectedFirm)?[_vm._v("\n                Firm name :\n                "),_c('b',[_vm._v(_vm._s(_vm.selectedFirm.name))]),_vm._v(" "),_c('br'),_vm._v("Address :\n                "),_c('b',[_vm._v(_vm._s(_vm.generateAddress(_vm.selectedFirm)))]),_vm._v(" "),_c('br'),_vm._v("\n                GSTIN :\n                "),_c('b',[_vm._v(_vm._s(_vm.selectedFirm.GST_number))]),_vm._v(" "),_c('br'),_vm._v("Mobile :\n                "),_c('b',[_vm._v(_vm._s(_vm.selectedFirm.mobileNumber))]),_vm._v(" "),_c('br'),_vm._v("Email :\n                "),_c('b',[_vm._v(_vm._s(_vm.selectedFirm.email))]),_vm._v(" "),_c('br'),_vm._v("Status :\n                "),_vm._v(" "),_c('br')]:_vm._e()],2),_vm._v(" "),_c('v-flex',{staticStyle:{"overflow-x":"auto"},attrs:{"xs12":"","sm9":"","md9":""}},[_c('table',{staticClass:"fl-table"},[_c('thead',[_c('tr',[_c('th',[_vm._v("EXPAND")]),_vm._v(" "),_c('th',[_vm._v("PARTICULARS")]),_vm._v(" "),_c('th',[_vm._v("TOTAL TAXABLE AMOUNT")]),_vm._v(" "),_c('th',{attrs:{"colspan":"4"}},[_vm._v("TOTAL TAX AMOUNT")]),_vm._v(" "),_c('th',[_vm._v("TOTAL AMOUNT")])]),_vm._v(" "),_c('tr',[_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v("IGST A.")]),_vm._v(" "),_c('th',[_vm._v("CGST A.")]),_vm._v(" "),_c('th',[_vm._v("SGST A.")]),_vm._v(" "),_c('th',[_vm._v("CESS")]),_vm._v(" "),_c('th')])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[(!_vm.outwardSupplies.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.outwardSupplies)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.outwardSupplies.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.outwardSupplies)}}},[_vm._v("expand_less")]):_vm._e()],1),_vm._v(" "),_c('td',[_c('h2',[_vm._v("OUTWARD SUPPLIES")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.totalInvoiceAmount || 0)))])]),_vm._v(" "),(_vm.outwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h2',{staticClass:"primary--text"},[_c('b',[_vm._v("(A). Intra state ")])])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.outwardSupplies.expand)?_c('tr',[_c('td',[(!_vm.outwardSupplies.intraState.taxable.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.outwardSupplies.intraState.taxable)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.outwardSupplies.intraState.taxable.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.outwardSupplies.intraState.taxable)}}},[_vm._v("expand_less")]):_vm._e()],1),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(i). Taxable")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.outwardSupplies.intraState.taxable.expand)?[_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (3%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_3.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_3.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_3.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_3.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_3.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_3.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (5%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_5.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_5.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_5.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_5.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_5.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_5.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (12%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_12.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_12.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_12.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_12.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_12.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_12.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (18%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_18.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_18.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_18.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_18.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_18.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_18.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (28%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_28.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_28.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_28.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_28.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_28.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.taxable.GST_28.totalInvoiceAmount || 0)))])])]:_vm._e(),_vm._v(" "),(_vm.outwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(ii). Exempted")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.exempted.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.exempted.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.exempted.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.exempted.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.exempted.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.exempted.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.outwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(iii). Nill Rated")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.nillrated.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.nillrated.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.nillrated.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.nillrated.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.nillrated.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.nillrated.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.outwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(iv). Others")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.others.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.others.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.others.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.others.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.others.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.intraState.others.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.outwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h2',{staticClass:"primary--text"},[_c('b',[_vm._v(" (B). Inter state ")])])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.outwardSupplies.expand)?_c('tr',[_c('td',[(!_vm.outwardSupplies.interState.taxable.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.outwardSupplies.interState.taxable)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.outwardSupplies.interState.taxable.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.outwardSupplies.interState.taxable)}}},[_vm._v("expand_less")]):_vm._e()],1),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(i). Taxable")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.outwardSupplies.interState.taxable.expand)?[_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (3%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_3.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_3.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_3.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_3.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_3.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_3.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (5%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_5.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_5.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_5.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_5.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_5.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_5.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (12%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_12.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_12.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_12.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_12.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_12.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_12.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (18%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_18.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_18.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_18.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_18.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_18.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_18.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (28%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_28.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_28.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_28.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_28.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_28.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.taxable.GST_28.totalInvoiceAmount || 0)))])])]:_vm._e(),_vm._v(" "),(_vm.outwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(ii). Exempted")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.exempted.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.exempted.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.exempted.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.exempted.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.exempted.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.exempted.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.outwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(iii). Nill Rated")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.nillrated.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.nillrated.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.nillrated.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.nillrated.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.nillrated.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.nillrated.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.outwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(iv). Others")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.others.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.others.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.others.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.others.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.others.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.outwardSupplies.interState.others.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.inwardSupplies && _vm.inwardSupplies.hasOwnProperty('expand'))?[_c('tr',[_c('td',[(!_vm.inwardSupplies.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.inwardSupplies)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.inwardSupplies.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.inwardSupplies)}}},[_vm._v("expand_less")]):_vm._e()],1),_vm._v(" "),_c('td',[_c('h2',[_vm._v("INWARD SUPPLIES")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.totalInvoiceAmount || 0)))])]),_vm._v(" "),(_vm.inwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h3',[_vm._v("(A). Intra state")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.inwardSupplies.expand)?_c('tr',[_c('td',[(!_vm.inwardSupplies.intraState.taxable.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.inwardSupplies.intraState.taxable)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.inwardSupplies.intraState.taxable.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.inwardSupplies.intraState.taxable)}}},[_vm._v("expand_less")]):_vm._e()],1),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(i). Taxable")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.inwardSupplies.intraState.taxable.expand)?[_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (3%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_3.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_3.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_3.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_3.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_3.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_3.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (5%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_5.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_5.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_5.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_5.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_5.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_5.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (12%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_12.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_12.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_12.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_12.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_12.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_12.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (18%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_18.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_18.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_18.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_18.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_18.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_18.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (28%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_28.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_28.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_28.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_28.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_28.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.taxable.GST_28.totalInvoiceAmount || 0)))])])]:_vm._e(),_vm._v(" "),(_vm.inwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(ii). Exempted")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.exempted.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.exempted.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.exempted.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.exempted.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.exempted.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.exempted.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.inwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(iii). Nill Rated")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.nillrated.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.nillrated.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.nillrated.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.nillrated.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.nillrated.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.nillrated.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.inwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(iv). Others")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.others.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.others.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.others.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.others.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.others.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.intraState.others.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.inwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h3',[_vm._v("(A). Inter state")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.inwardSupplies.expand)?_c('tr',[_c('td',[(!_vm.inwardSupplies.interState.taxable.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.inwardSupplies.interState.taxable)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.inwardSupplies.interState.taxable.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.inwardSupplies.interState.taxable)}}},[_vm._v("expand_less")]):_vm._e()],1),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(i). Taxable")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.inwardSupplies.interState.taxable.expand)?[_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (3%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_3.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_3.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_3.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_3.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_3.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_3.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (5%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_5.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_5.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_5.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_5.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_5.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_5.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (12%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_12.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_12.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_12.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_12.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_12.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_12.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (18%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_18.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_18.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_18.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_18.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_18.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_18.totalInvoiceAmount || 0)))])]),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("GST (28%)")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_28.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_28.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_28.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_28.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_28.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.taxable.GST_28.totalInvoiceAmount || 0)))])])]:_vm._e(),_vm._v(" "),(_vm.inwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(ii). Exempted")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.exempted.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.exempted.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.exempted.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.exempted.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.exempted.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.exempted.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.inwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(iii). Nill Rated")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.nillrated.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.nillrated.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.nillrated.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.nillrated.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.nillrated.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.nillrated.totalInvoiceAmount || 0)))])]):_vm._e(),_vm._v(" "),(_vm.inwardSupplies.expand)?_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v("(iv). Others")])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.others.totalBaseAmount || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.others.IGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.others.CGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.others.SGST || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.others.CESS || 0)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm._f("amount")(_vm.inwardSupplies.interState.others.totalInvoiceAmount || 0)))])]):_vm._e()]:_vm._e()],2)])])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoiceList_vue__ = __webpack_require__(471);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdcf6ae4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoiceList_vue__ = __webpack_require__(1448);
function injectStyle (ssrContext) {
  __webpack_require__(1443)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoiceList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bdcf6ae4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoiceList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1443 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_normalInvoice_vue__ = __webpack_require__(472);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4e678b8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_normalInvoice_vue__ = __webpack_require__(1445);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_normalInvoice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e4e678b8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_normalInvoice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(new Date(_vm.item.closedDate ? _vm.item.closedDate : _vm.item.date).toLocaleDateString('en-IN')))])]),_vm._v(" "),_c('td',[(_vm.item.buyerId)?_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.buyerById(_vm.item.buyerId)['name'])+" ")]):_vm._e()]),_vm._v(" "),[_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.getCredit(_vm.item) || 0))+" ")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"red--text font-weight-bold"},[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.getDebit(_vm.item)|| 0))+" ")])])],_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.getVocherType(_vm.item))+" ")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.item.paymentType))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.item.status))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.item.remark)+" ")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_automaticInvoice_vue__ = __webpack_require__(473);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13e80fb4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_automaticInvoice_vue__ = __webpack_require__(1447);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_automaticInvoice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13e80fb4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_automaticInvoice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(new Date(_vm.item.date).toLocaleDateString("en-GB"))+" ")])]),_vm._v(" "),_c('td'),_vm._v(" "),(!_vm.item.isCredited)?_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v("  "+_vm._s(_vm._f("amount")(_vm.item.totalAmount || 0))+" ")])]):_vm._e(),_vm._v(" "),(!_vm.item.isCredited)?_c('td'):_vm._e(),_vm._v(" "),(_vm.item.isCredited)?_c('td'):_vm._e(),_vm._v(" "),(_vm.item.isCredited)?_c('td',[_c('b',{staticClass:"red--text font-weight-bold"},[_vm._v("  "+_vm._s(_vm._f("amount")(_vm.item.totalAmount || 0))+" ")])]):_vm._e(),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.getVocherType(_vm.item))+" ")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.item.paymentType))])]),_vm._v(" "),_c('td',[(_vm.item.accountNumber)?_c('b',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.item.transferType || _vm.item.transactionType)+" ")]):_vm._e()]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.item.remark)+" ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"invoiceList"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-toolbar',{staticClass:"primary white--text",staticStyle:{"margin-top":"10px"}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-switch',{staticClass:"white-switch",attrs:{"color":"white","label":("" + (_vm.showOptions ? 'Hide Options' : 'Show Options'))},model:{value:(_vm.showOptions),callback:function ($$v) {_vm.showOptions=$$v},expression:"showOptions"}})],1),_vm._v(" "),(_vm.showOptions)?[_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-menu',{staticClass:"white-datepicker",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerFrom),callback:function ($$v) {_vm.datepickerFrom=$$v},expression:"datepickerFrom"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"From Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.dateFrom),callback:function ($$v) {_vm.dateFrom=$$v},expression:"dateFrom"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerFrom = false}},model:{value:(_vm.dateFrom),callback:function ($$v) {_vm.dateFrom=$$v},expression:"dateFrom"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-menu',{staticClass:"white-datepicker",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerTo),callback:function ($$v) {_vm.datepickerTo=$$v},expression:"datepickerTo"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"To Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.dateTo),callback:function ($$v) {_vm.dateTo=$$v},expression:"dateTo"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerTo = false}},model:{value:(_vm.dateTo),callback:function ($$v) {_vm.dateTo=$$v},expression:"dateTo"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('router-link',{attrs:{"to":"/Dashboard"}},[_c('v-btn',{staticClass:"primary white--text",staticStyle:{"float":"right"},attrs:{"icon":"","dark":""}},[_c('v-icon',[_vm._v("close")])],1)],1)],1)]:[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('h3',{staticClass:"title text-xs-center"},[_vm._v("CASH & BANK TRANSACTIONS")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('router-link',{attrs:{"to":"/Dashboard"}},[_c('v-btn',{staticClass:"primary white--text",staticStyle:{"float":"right"},attrs:{"icon":"","dark":""}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text",staticStyle:{"float":"right"},attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.print()}}},[_c('v-icon',[_vm._v("picture_as_pdf")])],1)],1)]],2)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation transaction-table",attrs:{"items":_vm.invoicesByBrand,"pagination":_vm.pagination,"headers":_vm.headers},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [(props.item.type == "automatic invoice" && props.item.firm != "Total")?_c('automatic-invoice',{attrs:{"item":props.item,"firms":_vm.firms}}):_vm._e(),_vm._v(" "),(props.item.type != "automatic invoice" && props.item.firm != "Total")?_c('normal-invoice',{attrs:{"item":props.item,"firms":_vm.firms,"buyers":_vm.buyers,"sellers":_vm.sellers}}):_vm._e(),_vm._v(" "),(props.item.firm == "Total")?_c('tr',[_c('td',[_c('b',{staticClass:"font-weight-bold primary--text"},[_vm._v("Total")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"})]),_vm._v(" "),[_c('td',{staticClass:"credit-total"},[_c('b',{staticClass:"green--text font-weight-bold "},[_vm._v(" "+_vm._s(_vm._f("amount")(props.item.credit || 0))+" ")])]),_vm._v(" "),_c('td',{staticClass:"debit-total"},[_c('b',{staticClass:"red--text font-weight-bold "},[_vm._v(" "+_vm._s(_vm._f("amount")(props.item.debit || 0))+" ")])])],_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"})]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"})]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"})]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"})])],2):_vm._e()]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No data to Show")])],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoiceList_vue__ = __webpack_require__(474);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e272376_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoiceList_vue__ = __webpack_require__(1455);
function injectStyle (ssrContext) {
  __webpack_require__(1450)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoiceList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9e272376_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoiceList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1450 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_normalInvoice_vue__ = __webpack_require__(475);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e154f82_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_normalInvoice_vue__ = __webpack_require__(1452);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_normalInvoice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e154f82_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_normalInvoice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(new Date(_vm.item.closedDate ? _vm.item.closedDate : _vm.item.date).toLocaleDateString('en-IN')))])]),_vm._v(" "),_c('td',[(_vm.item.buyerId)?_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.buyerById(_vm.item.buyerId)['name'])+" ")]):_vm._e()]),_vm._v(" "),[_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.getCredit(_vm.item) || 0))+" ")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"red--text font-weight-bold"},[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.getDebit(_vm.item)|| 0))+" ")])])],_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.getVocherType(_vm.item))+" ")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.item.paymentType))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.item.status))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.item.remark)+" ")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_automaticInvoice_vue__ = __webpack_require__(476);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2311a02_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_automaticInvoice_vue__ = __webpack_require__(1454);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_automaticInvoice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2311a02_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_automaticInvoice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(new Date(_vm.item.date).toLocaleDateString("en-IN"))+" ")])]),_vm._v(" "),_c('td',[(_vm.item.accountNumber)?[_c('b',{staticClass:"font-weight-bold"},[_vm._v("\n            "+_vm._s(_vm.bankAccountNameById(_vm.item.bank))+" - "+_vm._s(_vm.item.accountNumber)+"\n        ")])]:_vm._e(),_vm._v(" "),(_vm.item.expenseType)?[_c('b',{staticClass:"font-weight-bold"},[_vm._v("\n            "+_vm._s(_vm.expenseNameById(_vm.item.expenseType) || 'Not Assigned')+" \n        ")])]:_vm._e(),_vm._v(" "),(_vm.item.incomeType)?[_c('b',{staticClass:"font-weight-bold"},[_vm._v("\n            "+_vm._s(_vm.incomeNameById(_vm.item.incomeType) || 'Not Assigned')+" \n        ")])]:_vm._e(),_vm._v(" "),(_vm.item.assetType)?[_c('b',{staticClass:"font-weight-bold"},[_vm._v("\n            "+_vm._s(_vm.assetNameById(_vm.item.assetType) || 'Not Assigned')+" \n        ")])]:_vm._e(),_vm._v(" "),(_vm.item.staffType)?[_c('b',{staticClass:"font-weight-bold"},[_vm._v("\n            "+_vm._s(_vm.staffNameById(_vm.item.staffkey) || 'Not Assigned')+" \n        ")])]:_vm._e()],2),_vm._v(" "),(!_vm.item.isCredited)?_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v("  "+_vm._s(_vm._f("amount")(_vm.item.totalAmount || 0))+" ")])]):_vm._e(),_vm._v(" "),(!_vm.item.isCredited)?_c('td'):_vm._e(),_vm._v(" "),(_vm.item.isCredited)?_c('td'):_vm._e(),_vm._v(" "),(_vm.item.isCredited)?_c('td',[_c('b',{staticClass:"red--text font-weight-bold"},[_vm._v("  "+_vm._s(_vm._f("amount")(_vm.item.totalAmount || 0))+" ")])]):_vm._e(),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.getVocherType(_vm.item))+" ")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.item.paymentType))])]),_vm._v(" "),_c('td',[(_vm.item.accountNumber)?_c('b',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.item.transferType || _vm.item.transactionType)+" ")]):_vm._e()]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.item.remark)+" ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"invoiceList"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-toolbar',{staticClass:"primary white--text",staticStyle:{"margin-top":"10px"}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-switch',{staticClass:"white-switch",attrs:{"color":"white","label":("" + (_vm.showOptions ? 'Hide Options' : 'Show Options'))},model:{value:(_vm.showOptions),callback:function ($$v) {_vm.showOptions=$$v},expression:"showOptions"}})],1),_vm._v(" "),(_vm.showOptions)?[_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-menu',{staticClass:"white-datepicker",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerFrom),callback:function ($$v) {_vm.datepickerFrom=$$v},expression:"datepickerFrom"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"From Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.dateFrom),callback:function ($$v) {_vm.dateFrom=$$v},expression:"dateFrom"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerFrom = false}},model:{value:(_vm.dateFrom),callback:function ($$v) {_vm.dateFrom=$$v},expression:"dateFrom"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-menu',{staticClass:"white-datepicker",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerTo),callback:function ($$v) {_vm.datepickerTo=$$v},expression:"datepickerTo"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"To Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.dateTo),callback:function ($$v) {_vm.dateTo=$$v},expression:"dateTo"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerTo = false}},model:{value:(_vm.dateTo),callback:function ($$v) {_vm.dateTo=$$v},expression:"dateTo"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('router-link',{attrs:{"to":"/Dashboard"}},[_c('v-btn',{staticClass:"primary white--text",staticStyle:{"float":"right"},attrs:{"icon":"","dark":""}},[_c('v-icon',[_vm._v("close")])],1)],1)],1)]:[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('h3',{staticClass:"title text-xs-center "},[_vm._v("BANK TRANSACTIONS")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('h3',{staticClass:"title text-xs-center "},[_vm._v("Balance : ₹ "+_vm._s(Number.parseFloat(_vm.totalDebit - _vm.totalCredit).toFixed(2)))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('router-link',{attrs:{"to":"/Dashboard"}},[_c('v-btn',{staticClass:"primary white--text",staticStyle:{"float":"right"},attrs:{"icon":"","dark":""}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text",staticStyle:{"float":"right"},attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.print()}}},[_c('v-icon',[_vm._v("picture_as_pdf")])],1)],1)]],2)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation transaction-table",attrs:{"items":_vm.invoicesByBrand,"pagination":_vm.pagination,"headers":_vm.headers},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [(props.item.type == "automatic invoice" && props.item.firm != "Total")?_c('automatic-invoice',{attrs:{"item":props.item,"firms":_vm.firms}}):_vm._e(),_vm._v(" "),(props.item.type != "automatic invoice" && props.item.firm != "Total")?_c('normal-invoice',{attrs:{"item":props.item,"firms":_vm.firms,"buyers":_vm.buyers,"sellers":_vm.sellers}}):_vm._e(),_vm._v(" "),(props.item.firm == "Total")?_c('tr',[_c('td',[_c('b',{staticClass:"font-weight-bold primary--text"},[_vm._v("Total")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"})]),_vm._v(" "),[_c('td',{staticClass:"credit-total"},[_c('b',{staticClass:"green--text font-weight-bold "},[_vm._v(" "+_vm._s(_vm._f("amount")(props.item.credit || 0))+" ")])]),_vm._v(" "),_c('td',{staticClass:"debit-total"},[_c('b',{staticClass:"red--text font-weight-bold "},[_vm._v(" "+_vm._s(_vm._f("amount")(props.item.debit || 0))+" ")])])],_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"})]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"})]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"})]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"})])],2):_vm._e()]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No rows to Show")])],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoiceList_vue__ = __webpack_require__(477);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_612b6c72_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoiceList_vue__ = __webpack_require__(1462);
function injectStyle (ssrContext) {
  __webpack_require__(1457)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoiceList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_612b6c72_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoiceList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1457 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_normalInvoice_vue__ = __webpack_require__(478);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_001b7164_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_normalInvoice_vue__ = __webpack_require__(1459);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_normalInvoice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_001b7164_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_normalInvoice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(new Date(_vm.item.date).toLocaleDateString('en-IN')))])]),_vm._v(" "),_c('td',[(_vm.item.buyerId)?_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.buyerById(_vm.item.buyerId)['name'])+" ")]):_vm._e()]),_vm._v(" "),[_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.getCredit(_vm.item) || 0))+" ")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"red--text font-weight-bold"},[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.getDebit(_vm.item)|| 0))+" ")])])],_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.getVocherType(_vm.item))+" ")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.item.paymentType))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.item.status))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.item.remark)+" ")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_automaticInvoice_vue__ = __webpack_require__(479);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8009026a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_automaticInvoice_vue__ = __webpack_require__(1461);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_automaticInvoice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8009026a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_automaticInvoice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(new Date(_vm.item.date).toLocaleDateString("en-IN"))+" ")])]),_vm._v(" "),_c('td',[(_vm.item.accountNumber)?[_c('b',{staticClass:"font-weight-bold"},[_vm._v("\n            "+_vm._s(_vm.bankAccountNameById(_vm.item.bank))+" - "+_vm._s(_vm.item.accountNumber)+"\n        ")])]:_vm._e(),_vm._v(" "),(_vm.item.expenseType)?[_c('b',{staticClass:"font-weight-bold"},[_vm._v("\n            "+_vm._s(_vm.expenseNameById(_vm.item.expenseType) || 'Not Assigned')+" \n        ")])]:_vm._e(),_vm._v(" "),(_vm.item.incomeType)?[_c('b',{staticClass:"font-weight-bold"},[_vm._v("\n            "+_vm._s(_vm.incomeNameById(_vm.item.incomeType) || 'Not Assigned')+" \n        ")])]:_vm._e(),_vm._v(" "),(_vm.item.assetType)?[_c('b',{staticClass:"font-weight-bold"},[_vm._v("\n            "+_vm._s(_vm.assetNameById(_vm.item.assetType) || 'Not Assigned')+" \n        ")])]:_vm._e(),_vm._v(" "),(_vm.item.staffType)?[_c('b',{staticClass:"font-weight-bold"},[_vm._v("\n            "+_vm._s(_vm.staffNameById(_vm.item.staffkey) || 'Not Assigned')+" \n        ")])]:_vm._e()],2),_vm._v(" "),(!_vm.item.isCredited)?_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v("  "+_vm._s(_vm._f("amount")(_vm.item.totalAmount || 0))+" ")])]):_vm._e(),_vm._v(" "),(!_vm.item.isCredited)?_c('td'):_vm._e(),_vm._v(" "),(_vm.item.isCredited)?_c('td'):_vm._e(),_vm._v(" "),(_vm.item.isCredited)?_c('td',[_c('b',{staticClass:"red--text font-weight-bold"},[_vm._v("  "+_vm._s(_vm._f("amount")(_vm.item.totalAmount || 0))+" ")])]):_vm._e(),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.getVocherType(_vm.item))+" ")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.item.paymentType))])]),_vm._v(" "),_c('td',[(_vm.item.accountNumber)?_c('b',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.item.transferType || _vm.item.transactionType)+" ")]):_vm._e()]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.item.remark)+" ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"invoiceList"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-toolbar',{staticClass:"primary white--text",staticStyle:{"margin-top":"10px"}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-switch',{staticClass:"white-switch",attrs:{"color":"white","label":("" + (_vm.showOptions ? 'Hide Options' : 'Show Options'))},model:{value:(_vm.showOptions),callback:function ($$v) {_vm.showOptions=$$v},expression:"showOptions"}})],1),_vm._v(" "),(_vm.showOptions)?[_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-menu',{staticClass:"white-datepicker",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerFrom),callback:function ($$v) {_vm.datepickerFrom=$$v},expression:"datepickerFrom"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"From Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.dateFrom),callback:function ($$v) {_vm.dateFrom=$$v},expression:"dateFrom"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerFrom = false}},model:{value:(_vm.dateFrom),callback:function ($$v) {_vm.dateFrom=$$v},expression:"dateFrom"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-menu',{staticClass:"white-datepicker",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerTo),callback:function ($$v) {_vm.datepickerTo=$$v},expression:"datepickerTo"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"To Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.dateTo),callback:function ($$v) {_vm.dateTo=$$v},expression:"dateTo"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerTo = false}},model:{value:(_vm.dateTo),callback:function ($$v) {_vm.dateTo=$$v},expression:"dateTo"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('router-link',{attrs:{"to":"/Dashboard"}},[_c('v-btn',{staticClass:"primary white--text",staticStyle:{"float":"right"},attrs:{"icon":"","dark":""}},[_c('v-icon',[_vm._v("close")])],1)],1)],1)]:[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('h3',{staticClass:"title text-xs-center"},[_vm._v("CASH TRANSACTIONS")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('h3',{staticClass:"title text-xs-center "},[_vm._v("Balance : ₹ "+_vm._s(Number.parseFloat(_vm.totalDebit - _vm.totalCredit).toFixed(2)))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('router-link',{attrs:{"to":"/Dashboard"}},[_c('v-btn',{staticClass:"primary white--text",staticStyle:{"float":"right"},attrs:{"icon":"","dark":""}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text",staticStyle:{"float":"right"},attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.print()}}},[_c('v-icon',[_vm._v("picture_as_pdf")])],1)],1)]],2)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation transaction-table",attrs:{"items":_vm.invoicesByBrand,"pagination":_vm.pagination,"headers":_vm.headers},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [(props.item.type == "automatic invoice" && props.item.firm != "Total")?_c('automatic-invoice',{attrs:{"item":props.item,"firms":_vm.firms}}):_vm._e(),_vm._v(" "),(props.item.type != "automatic invoice" && props.item.firm != "Total")?_c('normal-invoice',{attrs:{"item":props.item,"firms":_vm.firms,"buyers":_vm.buyers,"sellers":_vm.sellers}}):_vm._e(),_vm._v(" "),(props.item.firm == "Total")?_c('tr',[_c('td',[_c('b',{staticClass:"font-weight-bold primary--text"},[_vm._v("Total")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"})]),_vm._v(" "),[_c('td',{staticClass:"credit-total"},[_c('b',{staticClass:"green--text font-weight-bold "},[_vm._v(" "+_vm._s(_vm._f("amount")(props.item.credit || 0))+" ")])]),_vm._v(" "),_c('td',{staticClass:"debit-total"},[_c('b',{staticClass:"red--text font-weight-bold "},[_vm._v(" "+_vm._s(_vm._f("amount")(props.item.debit || 0))+" ")])])],_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"})]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"})]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"})]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"})])],2):_vm._e()]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No rows to Show")])],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(480);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3301a1cf_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1465);
function injectStyle (ssrContext) {
  __webpack_require__(1464)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3301a1cf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3301a1cf_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1464 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[(_vm.customerID)?_c('router-link',{attrs:{"to":{ name: 'BuyersInfo', params: { buyerId:_vm.customerID }}}},[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("keyboard_backspace")])],1)],1):_vm._e(),_vm._v(" "),_c('v-toolbar-title',{staticClass:"text-xs-center"},[_vm._v("Invoice History")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',{staticClass:"strong white--text font-weight-light headline"},[_vm._v("\n          "+_vm._s(this.currentUser.name)+"\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.customerID)?_c('router-link',{attrs:{"to":{ name: 'BuyersInfo', params: { buyerId: _vm.customerID }}}},[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1):_vm._e()],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}},[_c('v-switch',{attrs:{"label":("" + (_vm.isStepper ? 'Stepper View' : 'Data Table View'))},model:{value:(_vm.isStepper),callback:function ($$v) {_vm.isStepper=$$v},expression:"isStepper"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker),callback:function ($$v) {_vm.datepicker=$$v},expression:"datepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Latest Invoice Date","prepend-icon":"event","readonly":""},on:{"change":function($event){return _vm.editMainInvoiceDate()}},slot:"activator",model:{value:(_vm.invoiceDate),callback:function ($$v) {_vm.invoiceDate=$$v},expression:"invoiceDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"change":function($event){return _vm.editMainInvoiceDate()},"input":function($event){_vm.datepicker = false}},model:{value:(_vm.invoiceDate),callback:function ($$v) {_vm.invoiceDate=$$v},expression:"invoiceDate"}})],1)],1),_vm._v(" "),(!_vm.saveInvoiceHidden)?_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}},[_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.saveInvoiceDate()}}},[_vm._v("Save ")])],1):_vm._e()],1),_vm._v(" "),(_vm.isStepper)?_c('v-stepper',{attrs:{"vertical":""},model:{value:(_vm.invoiceStep),callback:function ($$v) {_vm.invoiceStep=$$v},expression:"invoiceStep"}},[_vm._l((_vm.invoiceHistoryList),function(item,index){return [_c('v-stepper-step',{key:item['.key'],attrs:{"step":index +1}},[_c('v-link',{on:{"click":function($event){_vm.invoiceStep = index + 1}}},[_vm._v("\n                "+_vm._s(item['invoiceId']))]),_vm._v(" "),_c('small',[_c('b',[_vm._v(_vm._s(new Date(item['date']).toLocaleDateString('en-GB')))])])],1),_vm._v(" "),_c('v-stepper-content',{key:index,attrs:{"step":index +1}},[_c('v-card',{staticClass:"mb-12 invoice-stepper"},[_c('v-layout',{staticStyle:{"padding":"30px"},attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_vm._v("\n                    Date:\n                    "),_c('b',[_vm._v(_vm._s(new Date(item.date).toLocaleDateString('en-GB')))]),_vm._v(" "),_c('br'),_vm._v("Name:\n                    "),_vm._v(" "),_c('b',[_vm._v(_vm._s(_vm.getCustomerName(item.buyerId) || ''))]),_vm._v(" "),_c('br'),_vm._v("Firm:\n                    "),_c('b',[_vm._v(_vm._s(_vm.getFirmName(item.firm)))]),_vm._v(" "),_c('br'),_vm._v("Duration:\n                    "),_c('b',[_vm._v(_vm._s(item['duration']))]),_vm._v(" "),_c('br'),_vm._v("Payment Type:\n                    "),_c('b',[_vm._v(_vm._s(item['paymentType']))]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_vm._v("\n                    Invoice Number :\n                    "),_c('b',[_vm._v(_vm._s(item['invoiceId']))]),_vm._v(" "),_c('br'),_vm._v("Total Paid Amount :\n                    "),_c('b',[_vm._v(" "+_vm._s(item['paidAmount']))]),_vm._v(" "),_c('br'),_vm._v("Paid Amount :\n                    "),(item['transactionType']!='Debit')?_c('b',[_vm._v(" "+_vm._s(_vm._f("amount")((parseFloat(item['amountFromBank']) + parseFloat(item['amountFromCash'])) || 0)))]):_c('b',[_vm._v(" 0")]),_vm._v(" "),_c('br'),_vm._v("Remaining Amount :\n                    "),_c('b',[_vm._v(" "+_vm._s(_vm._f("amount")(item['remainingAmount'] || 0)))]),_vm._v(" "),_c('br'),_vm._v("Status :\n                    "),_c('b',[_vm._v(_vm._s(item['status']))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_vm._v("\n                    Total Amount :\n                    "),_c('b',[_vm._v(" "+_vm._s(_vm._f("amount")(item['totalAmount'] || 0)))]),_vm._v(" "),_c('br'),_vm._v("Basic Amount :\n                    "),_c('b',[_vm._v(" "+_vm._s(_vm._f("amount")((item['totalAmount'] - _vm.getGSTtotal(item)) || 0)))]),_vm._v(" "),_c('br'),_vm._v("Discount :\n                    "),_c('b',[_vm._v(" "+_vm._s(_vm._f("amount")(item['discountAmount'] || 0)))]),_vm._v(" "),_c('br'),_vm._v("GST :\n                    "),_c('b',[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.getGSTtotal(item) || 0)))]),_vm._v(" "),_c('br'),_vm._v("GST type :\n                    "),_c('b',[_vm._v(_vm._s(item['gstType']))]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('h2',{staticStyle:{"text-decoration":"underline","text-align":"center"}},[_vm._v("Product List")]),_vm._v(" "),[_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.invoiceProductListHeader,"items":item.items},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',[_vm._v(_vm._s(props.item['productName']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['HSN_code']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.taxableGST_rate))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['productUnit']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['quantity']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['rate']))])])]}}],null,true)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)]],2)],1)],1)],1)]})],2):_vm._e(),_vm._v(" "),(!_vm.isStepper)?_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.invoiceHeader,"items":_vm.invoiceHistoryList},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',[_vm._v(_vm._s(new Date(props.item.date).toLocaleDateString('en-GB')))])]),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""}},[_c('v-icon',{attrs:{"color":"teal"},on:{"click":function($event){return _vm.editInvoice(props.item)}}},[_vm._v("edit")])],1)],1),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.invoiceId))]),_vm._v(" "),(props.item.isLatest != undefined)?[_c('v-switch',{attrs:{"label":("" + (props.item['isLatest'] ? 'isLatest : true' : 'isLatest : false'))},model:{value:(props.item['isLatest']),callback:function ($$v) {_vm.$set(props.item, 'isLatest', $$v)},expression:"props.item['isLatest']"}}),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",on:{"click":function($event){return _vm.editHistory(props.item)}}},[_vm._v("\n                    save\n                  ")])]:_vm._e()],2),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.getFirmName(props.item.firm)))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold green--text"},[_vm._v(_vm._s(_vm._f("amount")(props.item.paidAmount || 0)))])]),_vm._v(" "),_c('td',[(props.item['transactionType']!='Debit')?_c('b',[_vm._v(" "+_vm._s(_vm._f("amount")(parseFloat((props.item['amountFromBank']) + parseFloat(props.item['amountFromCash'])) || 0)))]):_c('b',[_vm._v(" 0")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold red--text"},[_vm._v(_vm._s(_vm._f("amount")(props.item.remainingAmount || 0)))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold primary--text"},[_vm._v(_vm._s(_vm._f("amount")(props.item.totalAmount || 0)))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold primary--text"},[_vm._v(_vm._s(_vm._f("amount")((props.item.totalAmount - _vm.getGSTtotal(props.item)) || 0)))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold primary--text"},[_vm._v(_vm._s(_vm._f("amount")(_vm.getGSTtotal(props.item) || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item.discountAmount || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.duration))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.paymentType))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.status))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.gstType))])]),_vm._v(" "),_c('td',[(props.item.closedDate)?_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""}},[_c('v-icon',{attrs:{"color":"teal"},on:{"click":function($event){return _vm.editInvoiceClosedDate(props.item)}}},[_vm._v("edit")])],1):_vm._e()],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteHistory(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}],null,false,1924082985)}):_vm._e()],1)],1),_vm._v(" "),(_vm.currentInvoiceHistory && _vm.currentInvoiceHistory['.key'])?_c('v-dialog',{attrs:{"width":"800"},model:{value:(_vm.invoiceEditDialog),callback:function ($$v) {_vm.invoiceEditDialog=$$v},expression:"invoiceEditDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline grey lighten-2",attrs:{"primary-title":""}},[_vm._v("Change Date: - "+_vm._s(_vm.currentInvoiceHistory['invoiceId']))]),_vm._v(" "),_c('v-card-text',[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker2),callback:function ($$v) {_vm.datepicker2=$$v},expression:"datepicker2"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Invoice Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.currentInvoiceHistory.date),callback:function ($$v) {_vm.$set(_vm.currentInvoiceHistory, "date", $$v)},expression:"currentInvoiceHistory.date"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepicker2 = false}},model:{value:(_vm.currentInvoiceHistory.date),callback:function ($$v) {_vm.$set(_vm.currentInvoiceHistory, "date", $$v)},expression:"currentInvoiceHistory.date"}})],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.invoiceEditDialog = false}}},[_vm._v("Back")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.saveInvoiceHistory()}}},[_vm._v("Save ")])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.currentInvoiceHistory && _vm.currentInvoiceHistory['.key'])?_c('v-dialog',{attrs:{"width":"800"},model:{value:(_vm.invoiceClosedDateEditDialog),callback:function ($$v) {_vm.invoiceClosedDateEditDialog=$$v},expression:"invoiceClosedDateEditDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline grey lighten-2",attrs:{"primary-title":""}},[_vm._v("Change Closed Date: - "+_vm._s(_vm.currentInvoiceHistory['invoiceId']))]),_vm._v(" "),_c('v-card-text',[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker3),callback:function ($$v) {_vm.datepicker3=$$v},expression:"datepicker3"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Closed Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.currentInvoiceHistory.closedDate),callback:function ($$v) {_vm.$set(_vm.currentInvoiceHistory, "closedDate", $$v)},expression:"currentInvoiceHistory.closedDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepicker3 = false}},model:{value:(_vm.currentInvoiceHistory.closedDate),callback:function ($$v) {_vm.$set(_vm.currentInvoiceHistory, "closedDate", $$v)},expression:"currentInvoiceHistory.closedDate"}})],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.invoiceClosedDateEditDialog = false}}},[_vm._v("Back")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.saveClosedDateInvoiceHistory()}}},[_vm._v("Save ")])],1)],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemainingBalance_vue__ = __webpack_require__(481);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_413ba5d6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemainingBalance_vue__ = __webpack_require__(1468);
function injectStyle (ssrContext) {
  __webpack_require__(1467)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RemainingBalance_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_413ba5d6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RemainingBalance_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1467 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticStyle:{"padding-bottom":"0px"},attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[(_vm.$route.params.customerId)?_c('router-link',{attrs:{"to":{
              name: 'BuyersInfo',
              params: { buyerId: _vm.$route.params.customerId },
            }}},[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("keyboard_backspace")])],1)],1):_vm._e(),_vm._v(" "),_c('v-toolbar-title',{staticClass:"text-xs-center"},[_vm._v("Payment")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h2',{staticClass:"title white--text text--darken-4"},[_vm._v("\n            "+_vm._s(this.currentUser.name)+"\n          ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-select',{staticClass:"select-firm",attrs:{"dense":"","flat":"","clearable":"","item-text":"name","return-object":"","items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.$route.params.customerId)?_c('router-link',{attrs:{"to":{
              name: 'BuyersInfo',
              params: { buyerId: _vm.$route.params.customerId },
            }}},[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-container',{attrs:{"fluid":"","grid-list-md":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('table',{staticClass:"fl-table"},[_c('thead',[_c('tr',[_c('th',[_vm._v("Expand")]),_vm._v(" "),_c('th',[_vm._v("Category Amount")]),_vm._v(" "),_c('th',[_vm._v("Date")]),_vm._v(" "),_c('th',[_vm._v("Firm")]),_vm._v(" "),_c('th',[_vm._v("Invoice Id")]),_vm._v(" "),_c('th',[_vm._v("Remaining Amount")]),_vm._v(" "),_c('th',[_vm._v("Amount Selected")]),_vm._v(" "),_c('th',[_vm._v("Discount Amount")])])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[(!_vm.openingBalance.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.openingBalance)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.openingBalance.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.openingBalance)}}},[_vm._v("expand_less")]):_vm._e()],1),_vm._v(" "),_c('td',[_c('h2',[_vm._v("OPENING BALANCE")])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('v-text-field',{staticStyle:{"padding":"0 4px 0 4px"},attrs:{"value":_vm.openingBalance.amount,"readonly":"","type":"number"}})],1),_vm._v(" "),_c('td',[_c('v-text-field',{staticStyle:{"padding":"0 4px 0 4px"},attrs:{"value":_vm.openingBalance.selectedAmount,"readonly":"","type":"number"}})],1),_vm._v(" "),_c('td')]),_vm._v(" "),(_vm.openingBalance.expand)?_vm._l((_vm.openingBalance.invoices),function(op,index){return _c('tr',{key:("op-" + index)},[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v("\n                      "+_vm._s(new Date(op.date).toLocaleDateString("en-GB"))+"\n                    ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getFirmName(op.firm)))]),_vm._v(" "),_c('td',[_c('v-checkbox',{staticClass:"mx-2",staticStyle:{"margin":"0px","font-size":"10px"},attrs:{"label":op['.key']},on:{"change":function($event){return _vm.calculateFromChecked()}},model:{value:(op.checked),callback:function ($$v) {_vm.$set(op, "checked", $$v)},expression:"op.checked"}})],1),_vm._v(" "),_c('td',[_c('v-text-field',{staticStyle:{"padding":"0 4px 0 4px"},attrs:{"type":"number"},on:{"keyup":function($event){return _vm.calculateFromChecked()}},model:{value:(op.amount),callback:function ($$v) {_vm.$set(op, "amount", $$v)},expression:"op.amount"}}),_vm._v(" "),(
                          Number.parseFloat(op.amount) >
                          Number.parseFloat(op.staticAmount)
                        )?_c('b',{staticClass:"red--text font-weight-bold"},[_vm._v("Should be equal or less then "+_vm._s(op.staticAmount))]):_c('b',[_vm._v(" of "+_vm._s(op.staticAmount))])],1),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')])}):_vm._e(),_vm._v(" "),_c('tr',[_c('td',[(!_vm.dueAmount.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.dueAmount)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.dueAmount.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.dueAmount)}}},[_vm._v("expand_less")]):_vm._e()],1),_vm._v(" "),_c('td',[_c('h2',[_vm._v("DUE INVOICES")])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('v-text-field',{staticStyle:{"padding":"0 4px 0 4px"},attrs:{"value":_vm.dueAmount.amount,"readonly":"","type":"number"}})],1),_vm._v(" "),_c('td',[_c('v-text-field',{staticStyle:{"padding":"0 4px 0 4px"},attrs:{"value":_vm.dueAmount.selectedAmount,"readonly":"","type":"number"}})],1),_vm._v(" "),_c('td',[_c('v-text-field',{staticStyle:{"padding":"0 4px 0 4px"},attrs:{"value":_vm.dueAmount.discountAmount,"readonly":"","type":"number"}})],1)]),_vm._v(" "),(_vm.dueAmount.expand)?_vm._l((_vm.dueAmount.invoices),function(invoice,index){return _c('tr',{key:("invoice-" + index)},[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v("\n                      "+_vm._s(new Date(invoice.date).toLocaleDateString("en-GB"))+"\n                    ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getFirmName(invoice.firm)))]),_vm._v(" "),_c('td',[_c('v-checkbox',{staticClass:"mx-2",staticStyle:{"margin":"0px","font-size":"10px"},attrs:{"label":invoice['invoiceId'] + ' '},on:{"change":function($event){return _vm.calculateFromChecked()}},model:{value:(invoice.checked),callback:function ($$v) {_vm.$set(invoice, "checked", $$v)},expression:"invoice.checked"}})],1),_vm._v(" "),_c('td',[_c('span',{staticStyle:{"display":"flex"}},[_c('v-text-field',{staticClass:"error--text font-weight-light",staticStyle:{"padding":"0 4px 0 4px"},attrs:{"value":invoice.remainingAmount,"readonly":"","color":"red lighten-1","type":"number"}}),_vm._v(" "),_c('h2',{staticClass:"primary--text font-weight-bold align-start",staticStyle:{"text-align":"left"}},[_vm._v("[ "+_vm._s(invoice.totalAmount)+"   ")]),_vm._v(" "),_c('h2',[_vm._v(" - ")]),_vm._v("   "),_c('h2',{staticClass:"success--text font-weight-bold align-end",staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(invoice.paidAmount)+" ]")])],1)]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('v-text-field',{staticStyle:{"padding":"0 4px 0 4px"},attrs:{"type":"number"},on:{"keyup":function($event){return _vm.calculateFromChecked()}},model:{value:(invoice.discountAmount),callback:function ($$v) {_vm.$set(invoice, "discountAmount", $$v)},expression:"invoice.discountAmount"}})],1)])}):_vm._e(),_vm._v(" "),_c('tr',[_c('td',[(!_vm.advanceDeposit.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.advanceDeposit)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.advanceDeposit.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.advanceDeposit)}}},[_vm._v("expand_less")]):_vm._e()],1),_vm._v(" "),_c('td',[_c('h2',[_vm._v("ADVANCE DEPOSIT")])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('v-text-field',{staticStyle:{"padding":"0 4px 0 4px"},attrs:{"value":_vm.advanceDeposit.amount,"readonly":"","type":"number"}})],1),_vm._v(" "),_c('td',[_c('v-text-field',{staticStyle:{"padding":"0 4px 0 4px"},attrs:{"value":_vm.advanceDeposit.selectedAmount,"readonly":"","type":"number"}})],1),_vm._v(" "),_c('td')]),_vm._v(" "),(_vm.advanceDeposit.expand)?_vm._l((_vm.advanceDeposit.invoices),function(adDepo,index){return _c('tr',{key:("adDepo-" + index)},[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v("\n                      "+_vm._s(new Date(adDepo.date).toLocaleDateString("en-GB"))+"\n                    ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getFirmName(adDepo.firm)))]),_vm._v(" "),_c('td',[_c('v-checkbox',{staticClass:"mx-2",staticStyle:{"margin":"0px","font-size":"10px"},attrs:{"label":adDepo['.key']},on:{"change":function($event){return _vm.calculateFromChecked()}},model:{value:(adDepo.checked),callback:function ($$v) {_vm.$set(adDepo, "checked", $$v)},expression:"adDepo.checked"}})],1),_vm._v(" "),_c('td',[_c('v-text-field',{staticStyle:{"padding":"0 4px 0 4px"},attrs:{"type":"number"},on:{"keyup":function($event){return _vm.calculateFromChecked()}},model:{value:(adDepo.amount),callback:function ($$v) {_vm.$set(adDepo, "amount", $$v)},expression:"adDepo.amount"}}),_vm._v(" "),(
                          Number.parseFloat(adDepo.amount) >
                          Number.parseFloat(adDepo.staticAmount)
                        )?_c('b',{staticClass:"red--text font-weight-bold"},[_vm._v("Should be equal or less then\n                        "+_vm._s(adDepo.staticAmount))]):_c('b',[_vm._v(" of "+_vm._s(adDepo.staticAmount))])],1),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')])}):_vm._e(),_vm._v(" "),_c('tr',[_c('td',[(!_vm.securityDeposit.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.securityDeposit)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.securityDeposit.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.securityDeposit)}}},[_vm._v("expand_less")]):_vm._e()],1),_vm._v(" "),_c('td',[_c('h2',[_vm._v("SECURITY DEPOSIT")])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('v-text-field',{staticStyle:{"padding":"0 4px 0 4px"},attrs:{"value":_vm.securityDeposit.amount,"readonly":"","type":"number"}})],1),_vm._v(" "),_c('td',[_c('v-text-field',{staticStyle:{"padding":"0 4px 0 4px"},attrs:{"value":_vm.securityDeposit.selectedAmount,"readonly":"","type":"number"}})],1),_vm._v(" "),_c('td')]),_vm._v(" "),(_vm.securityDeposit.expand)?_vm._l((_vm.securityDeposit.invoices),function(sec,index){return _c('tr',{key:("sec-" + index)},[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_vm._v("\n                      "+_vm._s(new Date(sec.date).toLocaleDateString("en-GB"))+"\n                    ")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.getFirmName(sec.firm)))]),_vm._v(" "),_c('td',[_c('v-checkbox',{staticClass:"mx-2",staticStyle:{"margin":"0px","font-size":"10px"},attrs:{"label":sec['.key']},on:{"change":function($event){return _vm.calculateFromChecked()}},model:{value:(sec.checked),callback:function ($$v) {_vm.$set(sec, "checked", $$v)},expression:"sec.checked"}})],1),_vm._v(" "),_c('td',[_c('v-text-field',{staticStyle:{"padding":"0 4px 0 4px"},attrs:{"type":"number"},on:{"keyup":function($event){return _vm.calculateFromChecked()}},model:{value:(sec.amount),callback:function ($$v) {_vm.$set(sec, "amount", $$v)},expression:"sec.amount"}}),_vm._v(" "),(
                          Number.parseFloat(sec.amount) >
                          Number.parseFloat(sec.staticAmount)
                        )?_c('b',{staticClass:"red--text font-weight-bold"},[_vm._v("Should be equal or less then\n                        "+_vm._s(sec.staticAmount))]):_c('b',[_vm._v(" of "+_vm._s(sec.staticAmount))])],1),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')])}):_vm._e()],2)])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","s12":"","md12":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('div',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding-top":"14px"},attrs:{"xs2":"","sm2":"","md2":""}},[_c('h4',[_vm._v("Remaining Balance")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs2":"","sm2":"","md2":""}},[_c('v-text-field',{staticStyle:{"padding":"0 4px 0 4px"},attrs:{"value":_vm.totalRemainingAmount,"readonly":"","type":"number"}})],1)],1)],1),_vm._v(" "),_c('div',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding-top":"14px"},attrs:{"xs2":"","sm2":"","md2":""}},[_c('h4',[_vm._v("Payoff Amount")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs2":"","sm2":"","md2":""}},[_c('v-text-field',{staticStyle:{"padding":"0 4px 0 4px"},attrs:{"value":_vm.payoffAmount,"readonly":"","type":"number"}})],1)],1)],1),_vm._v(" "),_c('div',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding-top":"14px"},attrs:{"xs2":"","sm2":"","md2":""}},[_c('h4',[_vm._v("Remaining Amount")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs2":"","sm2":"","md2":""}},[_c('v-text-field',{staticStyle:{"padding":"0 4px 0 4px"},attrs:{"value":_vm.remainingAmount,"readonly":"","type":"number"}})],1)],1),_vm._v(" "),_c('h4',[(_vm.insufficientError)?_c('b',{staticClass:"red--text font-weight-bold"},[_vm._v("Insufficient amount.")]):_vm._e()]),_vm._v(" "),(_vm.selectedFirm)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding-top":"14px"},attrs:{"xs2":"","sm2":"","md2":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker),callback:function ($$v) {_vm.datepicker=$$v},expression:"datepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.selectedDate),callback:function ($$v) {_vm.selectedDate=$$v},expression:"selectedDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepicker = false}},model:{value:(_vm.selectedDate),callback:function ($$v) {_vm.selectedDate=$$v},expression:"selectedDate"}})],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-top":"14px"},attrs:{"xs2":"","sm2":"","md2":""}},[_c('v-select',{attrs:{"dense":"","items":[
                      {
                        text: 'Cash',
                        value: 'Cash',
                      },
                      {
                        text: 'Bank Account',
                        value: 'Bank Account',
                      },
                      {
                        text: 'Cash & Bank Account',
                        value: 'CashAndBank Account',
                      } ],"label":"Select Payment Type"},model:{value:(_vm.paymentType),callback:function ($$v) {_vm.paymentType=$$v},expression:"paymentType"}})],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-top":"14px"},attrs:{"xs2":"","sm2":"","md2":""}},[(
                      ['Cash', 'CashAndBank Account'].includes(_vm.paymentType)
                    )?_c('v-text-field',{attrs:{"type":"number","label":"Amount from Cash"},model:{value:(_vm.amountFromCash),callback:function ($$v) {_vm.amountFromCash=$$v},expression:"amountFromCash"}}):_vm._e(),_vm._v(" "),(
                      ['Cash', 'CashAndBank Account'].includes(_vm.paymentType) &&
                      !(
                        Number.parseFloat(_vm.amountFromBank) +
                          Number.parseFloat(_vm.amountFromCash) ==
                        Number.parseFloat(_vm.payoffAmount)
                      )
                    )?_c('b',{staticClass:"text-error"},[_vm._v("Total should be equal to Payoff amount")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-top":"14px"},attrs:{"xs2":"","sm2":"","md2":""}},[(
                      ['Bank Account', 'CashAndBank Account'].includes(
                        _vm.paymentType
                      )
                    )?_c('v-text-field',{attrs:{"type":"number","label":"Amount from Bank"},model:{value:(_vm.amountFromBank),callback:function ($$v) {_vm.amountFromBank=$$v},expression:"amountFromBank"}}):_vm._e(),_vm._v(" "),(
                      ['Bank Account', 'CashAndBank Account'].includes(
                        _vm.paymentType
                      ) &&
                      !(
                        Number.parseFloat(_vm.amountFromBank) +
                          Number.parseFloat(_vm.amountFromCash) ==
                        Number.parseFloat(_vm.payoffAmount)
                      )
                    )?_c('b',{staticClass:"text-error"},[_vm._v("Total should be equal to Payoff amount")]):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-top":"14px"},attrs:{"xs2":"","sm2":"","md2":""}},[(
                      ['Bank Account', 'CashAndBank Account'].includes(
                        _vm.paymentType
                      )
                    )?_c('v-select',{attrs:{"dense":"","items":_vm.banksByFirms,"label":"Select Bank","flat":"","clearable":"","item-text":"bankName","return-object":"","disabled":_vm.paymentType == 'Cash' || _vm.paymentType == ''},model:{value:(_vm.selectedBank),callback:function ($$v) {_vm.selectedBank=$$v},expression:"selectedBank"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-top":"14px"},attrs:{"xs2":"","sm2":"","md2":""}},[(
                      ['Bank Account', 'CashAndBank Account'].includes(
                        _vm.paymentType
                      )
                    )?_c('v-select',{attrs:{"dense":"","disabled":_vm.paymentType == 'Cash' || _vm.paymentType == '',"items":[
                      {
                        text: 'Cheque',
                        value: 'Cheque',
                      },
                      {
                        text: 'NEFT',
                        value: 'NEFT',
                      },
                      {
                        text: 'RTGS',
                        value: 'RTGS',
                      },
                      {
                        text: 'IMPS',
                        value: 'IMPS',
                      } ],"label":"Select Transfer type"},on:{"input":function($event){_vm.transferTypeDialog = true}},model:{value:(_vm.transferType),callback:function ($$v) {_vm.transferType=$$v},expression:"transferType"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding-top":"14px"},attrs:{"xs2":"","sm2":"","md2":""}},[_c('v-btn',{staticClass:"primary white--text",attrs:{"disabled":_vm.ispayDisable ||
                      !(
                        Number.parseFloat(_vm.amountFromBank) +
                          Number.parseFloat(_vm.amountFromCash) ==
                        Number.parseFloat(_vm.payoffAmount)
                      )},nativeOn:{"click":function($event){return _vm.payAmount()}}},[_vm._v("Pay Amount")])],1)],1):_vm._e()],1)])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.transferTypeDialog),callback:function ($$v) {_vm.transferTypeDialog=$$v},expression:"transferTypeDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("\n            Transfer Information\n            "),_c('b',[_vm._v(_vm._s(_vm.transferType))])])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","label":"A/C Number"},model:{value:(_vm.transferDetails.accountNumber),callback:function ($$v) {_vm.$set(_vm.transferDetails, "accountNumber", $$v)},expression:"transferDetails.accountNumber"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"text","label":"A/C Holder Name"},model:{value:(_vm.transferDetails.accountHolderName),callback:function ($$v) {_vm.$set(_vm.transferDetails, "accountHolderName", $$v)},expression:"transferDetails.accountHolderName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"text","label":"Bank Name"},model:{value:(_vm.transferDetails.bankName),callback:function ($$v) {_vm.$set(_vm.transferDetails, "bankName", $$v)},expression:"transferDetails.bankName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"text","label":"IFSC Code"},model:{value:(_vm.transferDetails.IFSCcode),callback:function ($$v) {_vm.$set(_vm.transferDetails, "IFSCcode", $$v)},expression:"transferDetails.IFSCcode"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"text","label":"Remark"},model:{value:(_vm.transferDetails.remark),callback:function ($$v) {_vm.$set(_vm.transferDetails, "remark", $$v)},expression:"transferDetails.remark"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.transferTypeDialog = false}}},[_vm._v("Ok")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quickInvoice_vue__ = __webpack_require__(482);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a8e71ff_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quickInvoice_vue__ = __webpack_require__(1500);
function injectStyle (ssrContext) {
  __webpack_require__(1470)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_quickInvoice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a8e71ff_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_quickInvoice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1470 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1471 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-sm":""}},[_c('v-layout',{attrs:{"justify-end":"","row":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.productsByBrand,"label":"Select Product","item-text":"name","return-object":"","clearable":""},model:{value:(_vm.selectedProduct),callback:function ($$v) {_vm.selectedProduct=$$v},expression:"selectedProduct"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.isBuyer ? _vm.buyersByBrand : _vm.sellersByBrand,"label":_vm.isBuyer ? 'Select Buyer' : 'Select Seller',"autocomplete":"","item-text":"name","clearable":"","return-object":""},model:{value:(_vm.selectedBuyer),callback:function ($$v) {_vm.selectedBuyer=$$v},expression:"selectedBuyer"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-switch',{staticClass:"js-customer-switcher",attrs:{"label":("" + (_vm.isBuyer ? 'Sale' : 'Purchase'))},on:{"change":function($event){_vm.selectedBuyer = null}},model:{value:(_vm.isBuyer),callback:function ($$v) {_vm.isBuyer=$$v},expression:"isBuyer"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerMenu1),callback:function ($$v) {_vm.datepickerMenu1=$$v},expression:"datepickerMenu1"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Start Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerMenu1 = false}},model:{value:(_vm.startDate),callback:function ($$v) {_vm.startDate=$$v},expression:"startDate"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerMenu2),callback:function ($$v) {_vm.datepickerMenu2=$$v},expression:"datepickerMenu2"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"End Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.endDate),callback:function ($$v) {_vm.endDate=$$v},expression:"endDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerMenu2 = false}},model:{value:(_vm.endDate),callback:function ($$v) {_vm.endDate=$$v},expression:"endDate"}})],1)],1),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-data-table',{staticClass:"elevation transaction-table",attrs:{"items":_vm.productList,"hide-actions":"","headers":_vm.headers},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',[_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v("\n                  "+_vm._s(new Date(props.item.date).toLocaleDateString('en-GB'))+"\n                ")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(props.item.rate))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(props.item.quantity))])]),_vm._v(" "),(_vm.isDairyBusiness)?_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(props.item.fat || ''))])]):_vm._e(),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(props.item.price))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(props.item.gst))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(props.item.totlePrice))])])])]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No rows to Show")])],2)],1)],1)]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cotainer',[_c('v-card',{attrs:{"persistent":""}},[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formTitle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"outline":""},on:{"click":function($event){return _vm.$emit('addProduct')}}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("add")]),_vm._v("\r\n              NEW PRODUCT\r\n          ")],1),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"outline":""},on:{"click":function($event){return _vm.scanItem()}}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("qr_code_scanner")]),_vm._v("\r\n            SCAN\r\n        ")],1),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"outline":""},on:{"click":function($event){return _vm.openProductReport()}}},[_vm._v("\r\n            SUGGESTIONS\r\n        ")])],1),_vm._v(" "),_c('p',{staticStyle:{"font-size":"11px","font-style":"italic","color":"green","padding":"10px"}},[_vm._v("\r\n               **["),_c('b',[_vm._v("Escape")]),_vm._v(" for Cancel],["),_c('b',[_vm._v("Enter")]),_vm._v(" for SAVE] & ["),_c('b',[_vm._v("Plus(+)")]),_vm._v(" for SAVE & ADD].\r\n              ")]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticStyle:{"margin-top":"-35px"},attrs:{"xs11":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.getHeaders,"items":_vm.allItems,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.productName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.unit))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.rate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.basicPrice))]),_vm._v(" "),(_vm.gstInvoice)?_c('td',[_vm._v(_vm._s(props.item.GSTValue))]):_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.tradeDiscount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.totlePrice))]),_vm._v(" "),_c('td',{staticClass:"justify-center layout px-0"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"-60px"},attrs:{"xs1":""}},[_c('v-btn',{staticClass:"cancel-btn-add-icons",attrs:{"color":"blue darken-1"},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancel")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text add-btn-add-icons",attrs:{"disabled":!(_vm.item.productName && _vm.item.quantity && _vm.item.rate)},nativeOn:{"click":function($event){return _vm.save(false)}}},[_vm._v("Save")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{staticClass:"add-save-btn-add-icons",attrs:{"color":"success white--text","disabled":!(_vm.item.productName && _vm.item.quantity && _vm.item.rate)},nativeOn:{"click":function($event){return _vm.save(true)}}},[_vm._v("Save&Add")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-select',{staticClass:"add-product-dropdown",attrs:{"items":_vm.productsByBrand,"item-text":"name","return-object":"","autocomplete":"","label":"Products"},on:{"change":_vm.productChange},model:{value:(_vm.item.productName),callback:function ($$v) {_vm.$set(_vm.item, "productName", $$v)},expression:"item.productName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-select',{attrs:{"items":_vm.availableProductUnit,"label":"Unit"},model:{value:(_vm.item.unit),callback:function ($$v) {_vm.$set(_vm.item, "unit", $$v)},expression:"item.unit"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[(_vm.item.productName)?_c('v-text-field',{attrs:{"type":"number","label":"Quantity"},model:{value:(_vm.item.quantity),callback:function ($$v) {_vm.$set(_vm.item, "quantity", _vm._n($$v))},expression:"item.quantity"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[(_vm.item.productName)?_c('v-text-field',{attrs:{"type":"number","label":"Product Rate"},model:{value:(_vm.item.rate),callback:function ($$v) {_vm.$set(_vm.item, "rate", _vm._n($$v))},expression:"item.rate"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-text-field',{attrs:{"type":"number","disabled":"","label":"Basic Price"},model:{value:(_vm.item.basicPrice),callback:function ($$v) {_vm.$set(_vm.item, "basicPrice", _vm._n($$v))},expression:"item.basicPrice"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-text-field',{attrs:{"type":"number","disabled":"","label":"GST Value"},model:{value:(_vm.item.GSTValue),callback:function ($$v) {_vm.$set(_vm.item, "GSTValue", _vm._n($$v))},expression:"item.GSTValue"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-text-field',{attrs:{"type":"number","disabled":"","label":"Total Price"},model:{value:(_vm.item.totlePrice),callback:function ($$v) {_vm.$set(_vm.item, "totlePrice", _vm._n($$v))},expression:"item.totlePrice"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate && _vm.isBuyer)?_c('v-select',{attrs:{"item-text":"batchNumber","item-value":"batchNumber","items":_vm.productBatches,"return-object":false,"label":"Batch number"},on:{"change":function($event){return _vm.changeBatch()}},model:{value:(_vm.item.batchNumber),callback:function ($$v) {_vm.$set(_vm.item, "batchNumber", $$v)},expression:"item.batchNumber"}}):(_vm.item.productName && _vm.item.quantity && _vm.item.rate && !_vm.isBuyer)?_c('v-combobox',{attrs:{"item-text":"batchNumber","item-value":"batchNumber","items":_vm.productBatches,"return-object":false,"label":"Batch number"},on:{"change":function($event){return _vm.changeBatch()}},model:{value:(_vm.item.batchNumber),callback:function ($$v) {_vm.$set(_vm.item, "batchNumber", $$v)},expression:"item.batchNumber"}}):_vm._e()],1),_vm._v(" "),(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px","disabled":_vm.isBuyer},model:{value:(_vm.datepickerExp),callback:function ($$v) {_vm.datepickerExp=$$v},expression:"datepickerExp"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Expiry date","prepend-icon":"event","disabled":_vm.isBuyer,"readonly":""},slot:"activator",model:{value:(_vm.item.expiryDate),callback:function ($$v) {_vm.$set(_vm.item, "expiryDate", $$v)},expression:"item.expiryDate"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"disabled":_vm.isBuyer},on:{"input":function($event){_vm.datepickerExp = false}},model:{value:(_vm.item.expiryDate),callback:function ($$v) {_vm.$set(_vm.item, "expiryDate", $$v)},expression:"item.expiryDate"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":"","disabled":_vm.isBuyer}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px","disabled":_vm.isBuyer},model:{value:(_vm.datepickerMen),callback:function ($$v) {_vm.datepickerMen=$$v},expression:"datepickerMen"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Manufacturing date","prepend-icon":"event","disabled":_vm.isBuyer,"readonly":""},slot:"activator",model:{value:(_vm.item.manufacturingDate),callback:function ($$v) {_vm.$set(_vm.item, "manufacturingDate", $$v)},expression:"item.manufacturingDate"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"disabled":_vm.isBuyer},on:{"input":function($event){_vm.datepickerMen = false}},model:{value:(_vm.item.manufacturingDate),callback:function ($$v) {_vm.$set(_vm.item, "manufacturingDate", $$v)},expression:"item.manufacturingDate"}})],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-switch',{attrs:{"label":("Trade Discount in: " + (_vm.isTradePercentage ? '%' : '₹'))},model:{value:(_vm.isTradePercentage),callback:function ($$v) {_vm.isTradePercentage=$$v},expression:"isTradePercentage"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate && _vm.isTradePercentage)?_c('v-text-field',{attrs:{"type":"number","suffix":"%","label":"Trade Discount"},on:{"keyup":function($event){return _vm.calculateTradeDiscount()}},model:{value:(_vm.tradeDiscountPercentage),callback:function ($$v) {_vm.tradeDiscountPercentage=_vm._n($$v)},expression:"tradeDiscountPercentage"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-text-field',{attrs:{"type":"number","suffix":"₹","disabled":_vm.isTradePercentage,"label":"Trade Discount"},model:{value:(_vm.item.tradeDiscount),callback:function ($$v) {_vm.$set(_vm.item, "tradeDiscount", _vm._n($$v))},expression:"item.tradeDiscount"}}):_vm._e()],1),_vm._v(" "),(_vm.firmSetting && _vm.firmSetting.individualProdBrokerage)?_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"type":"Number","label":"Brokerage Rate (in %)"},model:{value:(_vm.item.brokerageRate),callback:function ($$v) {_vm.$set(_vm.item, "brokerageRate", $$v)},expression:"item.brokerageRate"}})],1):_vm._e(),_vm._v(" "),(_vm.firmSetting && _vm.firmSetting.individualProdBrokerage)?_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Brokerage Amount (in ₹)","disabled":"","value":Number.parseFloat(
                  (Number.parseFloat(_vm.item.totlePrice) *
                    _vm.item.brokerageRate) /
                    100
                ).toFixed(2)}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-select',{attrs:{"dense":"","items":_vm.godawnByBrand,"label":"Via Godawn"},model:{value:(_vm.item.godawnBy),callback:function ($$v) {_vm.$set(_vm.item, "godawnBy", $$v)},expression:"item.godawnBy"}}):_vm._e()],1),_vm._v(" "),(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName)?_c('v-select',{attrs:{"items":_vm.currentProdDrawers,"item-text":'text',"item-value":'value',"label":"Select Drawer"},model:{value:(_vm.item.drawerId),callback:function ($$v) {_vm.$set(_vm.item, "drawerId", $$v)},expression:"item.drawerId"}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"sub-desc",attrs:{"xs12":"","sm3":"","md3":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-textarea',{attrs:{"background-color":"grey darken-1","color":"black","box":"","label":"Description"},model:{value:(_vm.item.subDescription),callback:function ($$v) {_vm.$set(_vm.item, "subDescription", $$v)},expression:"item.subDescription"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},_vm._l((_vm.offerList),function(offer,index){return _c('div',{key:index},[_c('h3',{staticClass:"red--text font-weight-bold"},[_vm._v("Offer : Buy "+_vm._s(offer.minQuantity)+" Get "+_vm._s(offer.offerQuantity)+" Free!")])])}),0)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"800px"},model:{value:(_vm.scannerDialog),callback:function ($$v) {_vm.scannerDialog=$$v},expression:"scannerDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Scan Barcode of Product")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('section',{staticClass:"container",attrs:{"id":"container"}},[_c('label',[_c('span',[_vm._v("Camera")]),_vm._v(" "),_c('select',{attrs:{"name":"input-stream_constraints","id":"deviceSelection"}})]),_vm._v(" "),_c('div',{staticClass:"viewport",attrs:{"id":"interactive"}})])])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.scannerDialog = false}}},[_vm._v("Cancel")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"800px"},model:{value:(_vm.compositionDialog),callback:function ($$v) {_vm.compositionDialog=$$v},expression:"compositionDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Replace "+_vm._s(this.selectedProduct.name)+" with Similar composition Products")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-radio-group',{model:{value:(_vm.selectedCompositionProd),callback:function ($$v) {_vm.selectedCompositionProd=$$v},expression:"selectedCompositionProd"}},_vm._l((_vm.productsWithSimilarCompostion),function(prod){return _c('v-radio',{key:prod['.key'],attrs:{"label":("" + (prod['name'])),"value":prod}})}),1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){return _vm.cancelComposition()}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){return _vm.addFromCompositionProduct()}}},[_vm._v("Save")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"1000px"},model:{value:(_vm.productReportDialog),callback:function ($$v) {_vm.productReportDialog=$$v},expression:"productReportDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Product Report")])]),_vm._v(" "),_c('v-card-text',[_c('product-reports',{attrs:{"product":_vm.selectedProduct,"isBuyer":_vm.isBuyer,"buyerId":_vm.buyer['.key']}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.productReportDialog = false}}},[_vm._v("Cancel")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1486 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cotainer',[_c('v-card',{attrs:{"persistent":""}},[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formTitle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"outline":""},on:{"click":function($event){return _vm.$emit('addProduct')}}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("add")]),_vm._v("\r\n            NEW PRODUCT\r\n        ")],1),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"outline":""},on:{"click":function($event){return _vm.scanItem()}}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("qr_code_scanner")]),_vm._v("\r\n          SCAN\r\n      ")],1),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"outline":""},on:{"click":function($event){return _vm.openProductReport()}}},[_vm._v("\r\n        SUGGESTIONS\r\n      ")])],1),_vm._v(" "),_c('p',{staticStyle:{"font-size":"11px","font-style":"italic","color":"green","padding":"10px"}},[_vm._v("\r\n      **["),_c('b',[_vm._v("Escape")]),_vm._v(" for Cancel],["),_c('b',[_vm._v("Enter")]),_vm._v(" for SAVE] & ["),_c('b',[_vm._v("Plus(+)")]),_vm._v(" for SAVE & ADD].\r\n    ")]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticStyle:{"margin-top":"-35px"},attrs:{"xs11":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.getHeaders,"items":_vm.allItems,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.productName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.unit))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.rate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.basicPrice))]),_vm._v(" "),(_vm.gstInvoice)?_c('td',[_vm._v(_vm._s(props.item.GSTValue))]):_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.tradeDiscount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.totlePrice))]),_vm._v(" "),_c('td',{staticClass:"justify-center layout px-0"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"-60px"},attrs:{"xs1":""}},[_c('v-btn',{staticClass:"cancel-btn-add-icons",attrs:{"color":"blue darken-1"},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancel")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text add-btn-add-icons",attrs:{"disabled":!(_vm.item.productName && _vm.item.quantity && _vm.item.rate)},nativeOn:{"click":function($event){return _vm.save(false)}}},[_vm._v("Save")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{staticClass:"add-save-btn-add-icons",attrs:{"color":"success white--text","disabled":!(_vm.item.productName && _vm.item.quantity && _vm.item.rate)},nativeOn:{"click":function($event){return _vm.save(true)}}},[_vm._v("Save&Add")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-select',{staticClass:"add-product-dropdown",attrs:{"items":_vm.productsByBrand,"item-text":"name","return-object":"","autocomplete":"","search-input":_vm.search,"label":"Products"},on:{"change":_vm.productChange,"update:searchInput":function($event){_vm.search=$event},"update:search-input":function($event){_vm.search=$event}},model:{value:(_vm.item.productName),callback:function ($$v) {_vm.$set(_vm.item, "productName", $$v)},expression:"item.productName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[(_vm.item.productName)?_c('v-text-field',{attrs:{"type":"number","label":"Quantity"},model:{value:(_vm.item.quantity),callback:function ($$v) {_vm.$set(_vm.item, "quantity", _vm._n($$v))},expression:"item.quantity"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-select',{attrs:{"items":_vm.availableProductUnit,"label":"Unit"},model:{value:(_vm.item.unit),callback:function ($$v) {_vm.$set(_vm.item, "unit", $$v)},expression:"item.unit"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[(_vm.item.productName)?_c('v-text-field',{attrs:{"type":"number","label":"Product Rate"},model:{value:(_vm.item.rate),callback:function ($$v) {_vm.$set(_vm.item, "rate", _vm._n($$v))},expression:"item.rate"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-text-field',{attrs:{"type":"number","disabled":"","label":"Basic Price"},model:{value:(_vm.item.basicPrice),callback:function ($$v) {_vm.$set(_vm.item, "basicPrice", _vm._n($$v))},expression:"item.basicPrice"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-text-field',{attrs:{"type":"number","disabled":"","label":"GST Value"},model:{value:(_vm.item.GSTValue),callback:function ($$v) {_vm.$set(_vm.item, "GSTValue", _vm._n($$v))},expression:"item.GSTValue"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-text-field',{attrs:{"type":"number","disabled":"","label":"Total Price"},model:{value:(_vm.item.totlePrice),callback:function ($$v) {_vm.$set(_vm.item, "totlePrice", _vm._n($$v))},expression:"item.totlePrice"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-switch',{attrs:{"label":("Trade Discount in: " + (_vm.isTradePercentage ? '%' : '₹'))},model:{value:(_vm.isTradePercentage),callback:function ($$v) {_vm.isTradePercentage=$$v},expression:"isTradePercentage"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate && _vm.isTradePercentage)?_c('v-text-field',{attrs:{"type":"number","suffix":"%","label":"Trade Discount"},on:{"keyup":function($event){return _vm.calculateTradeDiscount()}},model:{value:(_vm.tradeDiscountPercentage),callback:function ($$v) {_vm.tradeDiscountPercentage=_vm._n($$v)},expression:"tradeDiscountPercentage"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-text-field',{attrs:{"type":"number","suffix":"₹","disabled":_vm.isTradePercentage,"label":"Trade Discount"},model:{value:(_vm.item.tradeDiscount),callback:function ($$v) {_vm.$set(_vm.item, "tradeDiscount", _vm._n($$v))},expression:"item.tradeDiscount"}}):_vm._e()],1),_vm._v(" "),(_vm.firmSetting && _vm.firmSetting.individualProdBrokerage)?_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"type":"Number","label":"Brokerage Rate (in %)"},model:{value:(_vm.item.brokerageRate),callback:function ($$v) {_vm.$set(_vm.item, "brokerageRate", $$v)},expression:"item.brokerageRate"}})],1):_vm._e(),_vm._v(" "),(_vm.firmSetting && _vm.firmSetting.individualProdBrokerage)?_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Brokerage Amount (in ₹)","disabled":"","value":Number.parseFloat(
                  (Number.parseFloat(_vm.item.totlePrice) *
                    _vm.item.brokerageRate) /
                    100
                ).toFixed(2)}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-select',{attrs:{"dense":"","items":_vm.godawnByBrand,"label":"Via Godawn"},model:{value:(_vm.item.godawnBy),callback:function ($$v) {_vm.$set(_vm.item, "godawnBy", $$v)},expression:"item.godawnBy"}}):_vm._e()],1),_vm._v(" "),(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName)?_c('v-select',{attrs:{"items":_vm.currentProdDrawers,"item-text":'text',"item-value":'value',"label":"Select Drawer"},model:{value:(_vm.item.drawerId),callback:function ($$v) {_vm.$set(_vm.item, "drawerId", $$v)},expression:"item.drawerId"}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"sub-desc",attrs:{"xs12":"","sm3":"","md3":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-textarea',{attrs:{"background-color":"grey darken-1","color":"black","box":"","label":"Description"},model:{value:(_vm.item.subDescription),callback:function ($$v) {_vm.$set(_vm.item, "subDescription", $$v)},expression:"item.subDescription"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},_vm._l((_vm.offerList),function(offer,index){return _c('div',{key:index},[_c('h3',{staticClass:"red--text font-weight-bold"},[_vm._v("Offer : Buy "+_vm._s(offer.minQuantity)+" Get "+_vm._s(offer.offerQuantity)+" Free!")])])}),0)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"800px"},model:{value:(_vm.scannerDialog),callback:function ($$v) {_vm.scannerDialog=$$v},expression:"scannerDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Scan")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('section',{staticClass:"container",attrs:{"id":"container"}},[_c('label',[_c('span',[_vm._v("Camera")]),_vm._v(" "),_c('select',{attrs:{"name":"input-stream_constraints","id":"deviceSelection"}})]),_vm._v(" "),_c('div',{staticClass:"viewport",attrs:{"id":"interactive"}})])])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.scannerDialog = false}}},[_vm._v("Cancel")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"1000px"},model:{value:(_vm.productReportDialog),callback:function ($$v) {_vm.productReportDialog=$$v},expression:"productReportDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Product Report")])]),_vm._v(" "),_c('v-card-text',[_c('product-reports',{attrs:{"product":_vm.selectedProduct,"isBuyer":_vm.isBuyer,"buyerId":_vm.buyer['.key']}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.productReportDialog = false}}},[_vm._v("Cancel")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1488 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cotainer',[_c('v-card',{attrs:{"persistent":""}},[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formTitle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"outline":""},on:{"click":function($event){return _vm.$emit('addProduct')}}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("add")]),_vm._v("\r\n              NEW PRODUCT\r\n          ")],1),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"outline":""},on:{"click":function($event){return _vm.scanItem()}}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("qr_code_scanner")]),_vm._v("\r\n            SCAN\r\n        ")],1),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"outline":""},on:{"click":function($event){return _vm.openProductReport()}}},[_vm._v("\r\n            SUGGESTIONS\r\n        ")])],1),_vm._v(" "),_c('p',{staticStyle:{"font-size":"11px","font-style":"italic","color":"green","padding":"10px"}},[_vm._v("\r\n      **["),_c('b',[_vm._v("Escape")]),_vm._v(" for Cancel],["),_c('b',[_vm._v("Enter")]),_vm._v(" for SAVE] & ["),_c('b',[_vm._v("Plus(+)")]),_vm._v(" for SAVE & ADD].\r\n    ")]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticStyle:{"margin-top":"-35px"},attrs:{"xs11":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.getHeaders,"items":_vm.allItems,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.productName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.unit))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.rate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.basicPrice))]),_vm._v(" "),(_vm.gstInvoice)?_c('td',[_vm._v(_vm._s(props.item.GSTValue))]):_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.tradeDiscount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.totlePrice))]),_vm._v(" "),_c('td',{staticClass:"justify-center layout px-0"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"-60px"},attrs:{"xs1":""}},[_c('v-btn',{staticClass:"cancel-btn-add-icons",attrs:{"color":"blue darken-1"},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancel")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text add-btn-add-icons",attrs:{"disabled":!(_vm.item.productName && _vm.item.quantity && _vm.item.rate)},nativeOn:{"click":function($event){return _vm.save(false)}}},[_vm._v("Save")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{staticClass:"add-save-btn-add-icons",attrs:{"color":"success white--text ","disabled":!(_vm.item.productName && _vm.item.quantity && _vm.item.rate)},nativeOn:{"click":function($event){return _vm.save(true)}}},[_vm._v("Save&Add")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-select',{staticClass:"add-product-dropdown",attrs:{"items":_vm.productsByBrand,"item-text":"name","return-object":"","autocomplete":"","search-input":_vm.search,"label":"Products"},on:{"change":_vm.productChange,"update:searchInput":function($event){_vm.search=$event},"update:search-input":function($event){_vm.search=$event}},model:{value:(_vm.item.productName),callback:function ($$v) {_vm.$set(_vm.item, "productName", $$v)},expression:"item.productName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-select',{attrs:{"items":_vm.availableProductUnit,"label":"Unit"},model:{value:(_vm.item.unit),callback:function ($$v) {_vm.$set(_vm.item, "unit", $$v)},expression:"item.unit"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[(_vm.item.productName)?_c('v-text-field',{attrs:{"type":"number","label":"Quantity"},model:{value:(_vm.item.quantity),callback:function ($$v) {_vm.$set(_vm.item, "quantity", _vm._n($$v))},expression:"item.quantity"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[(_vm.item.productName)?_c('v-text-field',{attrs:{"type":"number","label":"Product Rate"},model:{value:(_vm.item.rate),callback:function ($$v) {_vm.$set(_vm.item, "rate", _vm._n($$v))},expression:"item.rate"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-text-field',{attrs:{"type":"number","disabled":"","label":"Basic Price"},model:{value:(_vm.item.basicPrice),callback:function ($$v) {_vm.$set(_vm.item, "basicPrice", _vm._n($$v))},expression:"item.basicPrice"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-text-field',{attrs:{"type":"number","disabled":"","label":"GST Value"},model:{value:(_vm.item.GSTValue),callback:function ($$v) {_vm.$set(_vm.item, "GSTValue", _vm._n($$v))},expression:"item.GSTValue"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-text-field',{attrs:{"type":"number","disabled":"","label":"Total Price"},model:{value:(_vm.item.totlePrice),callback:function ($$v) {_vm.$set(_vm.item, "totlePrice", _vm._n($$v))},expression:"item.totlePrice"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}}),_vm._v(" "),(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"type":"text","label":"Engine Number"},model:{value:(_vm.item.engineNumber),callback:function ($$v) {_vm.$set(_vm.item, "engineNumber", $$v)},expression:"item.engineNumber"}})],1):_vm._e(),_vm._v(" "),(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"type":"text","label":"Chasis Number"},model:{value:(_vm.item.chasisNumber),callback:function ($$v) {_vm.$set(_vm.item, "chasisNumber", $$v)},expression:"item.chasisNumber"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-switch',{attrs:{"label":("Trade Discount in: " + (_vm.isTradePercentage ? '%' : '₹'))},model:{value:(_vm.isTradePercentage),callback:function ($$v) {_vm.isTradePercentage=$$v},expression:"isTradePercentage"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate && _vm.isTradePercentage)?_c('v-text-field',{attrs:{"type":"number","suffix":"%","label":"Trade Discount"},on:{"keyup":function($event){return _vm.calculateTradeDiscount()}},model:{value:(_vm.tradeDiscountPercentage),callback:function ($$v) {_vm.tradeDiscountPercentage=_vm._n($$v)},expression:"tradeDiscountPercentage"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-text-field',{attrs:{"type":"number","suffix":"₹","disabled":_vm.isTradePercentage,"label":"Trade Discount"},model:{value:(_vm.item.tradeDiscount),callback:function ($$v) {_vm.$set(_vm.item, "tradeDiscount", _vm._n($$v))},expression:"item.tradeDiscount"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-select',{attrs:{"dense":"","items":_vm.godawnByBrand,"label":"Via Godawn"},model:{value:(_vm.item.godawnBy),callback:function ($$v) {_vm.$set(_vm.item, "godawnBy", $$v)},expression:"item.godawnBy"}}):_vm._e()],1),_vm._v(" "),(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName)?_c('v-select',{attrs:{"items":_vm.currentProdDrawers,"item-text":'text',"item-value":'value',"label":"Select Drawer"},model:{value:(_vm.item.drawerId),callback:function ($$v) {_vm.$set(_vm.item, "drawerId", $$v)},expression:"item.drawerId"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.firmSetting && _vm.firmSetting.individualProdBrokerage)?_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"type":"Number","label":"Brokerage Rate (in %)"},model:{value:(_vm.item.brokerageRate),callback:function ($$v) {_vm.$set(_vm.item, "brokerageRate", $$v)},expression:"item.brokerageRate"}})],1):_vm._e(),_vm._v(" "),(_vm.firmSetting && _vm.firmSetting.individualProdBrokerage)?_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Brokerage Amount (in ₹)","disabled":"","value":Number.parseFloat(
                  (Number.parseFloat(_vm.item.totlePrice) *
                    _vm.item.brokerageRate) /
                    100
                ).toFixed(2)}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"sub-desc",attrs:{"xs12":"","sm3":"","md3":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-textarea',{attrs:{"background-color":"grey darken-1","color":"black","box":"","label":"Description"},model:{value:(_vm.item.subDescription),callback:function ($$v) {_vm.$set(_vm.item, "subDescription", $$v)},expression:"item.subDescription"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},_vm._l((_vm.offerList),function(offer,index){return _c('div',{key:index},[_c('h3',{staticClass:"red--text font-weight-bold"},[_vm._v("Offer : Buy "+_vm._s(offer.minQuantity)+" Get "+_vm._s(offer.offerQuantity)+" Free!")])])}),0)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"800px"},model:{value:(_vm.scannerDialog),callback:function ($$v) {_vm.scannerDialog=$$v},expression:"scannerDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Scan Barcode of Product")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('section',{staticClass:"container",attrs:{"id":"container"}},[_c('label',[_c('span',[_vm._v("Camera")]),_vm._v(" "),_c('select',{attrs:{"name":"input-stream_constraints","id":"deviceSelection"}})]),_vm._v(" "),_c('div',{staticClass:"viewport",attrs:{"id":"interactive"}})])])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.scannerDialog = false}}},[_vm._v("Cancel")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"1000px"},model:{value:(_vm.productReportDialog),callback:function ($$v) {_vm.productReportDialog=$$v},expression:"productReportDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Product Report")])]),_vm._v(" "),_c('v-card-text',[_c('product-reports',{attrs:{"product":_vm.selectedProduct,"isBuyer":_vm.isBuyer,"buyerId":_vm.buyer['.key']}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.productReportDialog = false}}},[_vm._v("Cancel")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1490 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cotainer',[_c('v-card',{attrs:{"persistent":""}},[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formTitle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"outline":""},on:{"click":function($event){return _vm.$emit('addProduct')}}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("add")]),_vm._v("\r\n              NEW PRODUCT\r\n          ")],1),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"outline":""},on:{"click":function($event){return _vm.scanItem()}}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("qr_code_scanner")]),_vm._v("\r\n            SCAN\r\n        ")],1),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"outline":""},on:{"click":function($event){return _vm.openProductReport()}}},[_vm._v("\r\n            SUGGESTIONS\r\n        ")])],1),_vm._v(" "),_c('p',{staticStyle:{"font-size":"11px","font-style":"italic","color":"green","padding":"10px"}},[_vm._v("\r\n      **["),_c('b',[_vm._v("Escape")]),_vm._v(" for Cancel],["),_c('b',[_vm._v("Enter")]),_vm._v(" for SAVE] & ["),_c('b',[_vm._v("Plus(+)")]),_vm._v(" for SAVE & ADD].\r\n    ")]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticStyle:{"margin-top":"-35px"},attrs:{"xs11":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.getHeaders,"items":_vm.allItems,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.productName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.unit))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.fat))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.rate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.basicPrice))]),_vm._v(" "),(_vm.gstInvoice)?_c('td',[_vm._v(_vm._s(props.item.GSTValue))]):_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.tradeDiscount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.totlePrice))]),_vm._v(" "),_c('td',{staticClass:"justify-center layout px-0"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"-60px"},attrs:{"xs1":""}},[_c('v-btn',{staticClass:"cancel-btn-add-icons",attrs:{"color":"blue darken-1"},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancel")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text add-btn-add-icons",attrs:{"disabled":!(_vm.item.productName && _vm.item.quantity && _vm.item.rate)},nativeOn:{"click":function($event){return _vm.save(false)}}},[_vm._v("Save")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{staticClass:"add-save-btn-add-icons",attrs:{"color":"success white--text ","disabled":!(_vm.item.productName && _vm.item.quantity && _vm.item.rate)},nativeOn:{"click":function($event){return _vm.save(true)}}},[_vm._v("Save&Add")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-select',{staticClass:"add-product-dropdown",attrs:{"items":_vm.productsByBrand,"item-text":"name","return-object":"","autocomplete":"","search-input":_vm.search,"label":"Products"},on:{"change":_vm.productChange,"update:searchInput":function($event){_vm.search=$event},"update:search-input":function($event){_vm.search=$event}},model:{value:(_vm.item.productName),callback:function ($$v) {_vm.$set(_vm.item, "productName", $$v)},expression:"item.productName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-select',{attrs:{"items":_vm.availableProductUnit,"label":"Unit"},model:{value:(_vm.item.unit),callback:function ($$v) {_vm.$set(_vm.item, "unit", $$v)},expression:"item.unit"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md1":""}},[(_vm.item.productName)?_c('v-text-field',{attrs:{"type":"number","label":"Quantity"},model:{value:(_vm.item.quantity),callback:function ($$v) {_vm.$set(_vm.item, "quantity", _vm._n($$v))},expression:"item.quantity"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md1":""}},[(_vm.item.productName)?_c('v-text-field',{attrs:{"type":"number","label":"Fat"},model:{value:(_vm.item.fat),callback:function ($$v) {_vm.$set(_vm.item, "fat", _vm._n($$v))},expression:"item.fat"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[(_vm.item.productName)?_c('v-text-field',{attrs:{"type":"number","label":"Product Rate"},model:{value:(_vm.item.rate),callback:function ($$v) {_vm.$set(_vm.item, "rate", _vm._n($$v))},expression:"item.rate"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.fat && _vm.item.rate)?_c('v-text-field',{attrs:{"type":"number","disabled":"","label":"Basic Price"},model:{value:(_vm.item.basicPrice),callback:function ($$v) {_vm.$set(_vm.item, "basicPrice", _vm._n($$v))},expression:"item.basicPrice"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-text-field',{attrs:{"type":"number","disabled":"","label":"GST Value"},model:{value:(_vm.item.GSTValue),callback:function ($$v) {_vm.$set(_vm.item, "GSTValue", _vm._n($$v))},expression:"item.GSTValue"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-text-field',{attrs:{"type":"number","disabled":"","label":"Total Price"},model:{value:(_vm.item.totlePrice),callback:function ($$v) {_vm.$set(_vm.item, "totlePrice", _vm._n($$v))},expression:"item.totlePrice"}}):_vm._e()],1),_vm._v(" "),(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-text-field',{attrs:{"type":"number","label":"CLR"},model:{value:(_vm.item.clr),callback:function ($$v) {_vm.$set(_vm.item, "clr", $$v)},expression:"item.clr"}})],1):_vm._e(),_vm._v(" "),(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md1":""}},[_c('v-text-field',{attrs:{"type":"number","label":"SNF"},model:{value:(_vm.item.snf),callback:function ($$v) {_vm.$set(_vm.item, "snf", $$v)},expression:"item.snf"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-switch',{attrs:{"label":("Trade Discount in: " + (_vm.isTradePercentage ? '%' : '₹'))},model:{value:(_vm.isTradePercentage),callback:function ($$v) {_vm.isTradePercentage=$$v},expression:"isTradePercentage"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate && _vm.isTradePercentage)?_c('v-text-field',{attrs:{"type":"number","suffix":"%","label":"Trade Discount"},on:{"keyup":function($event){return _vm.calculateTradeDiscount()}},model:{value:(_vm.tradeDiscountPercentage),callback:function ($$v) {_vm.tradeDiscountPercentage=_vm._n($$v)},expression:"tradeDiscountPercentage"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-text-field',{attrs:{"type":"number","suffix":"₹","disabled":_vm.isTradePercentage,"label":"Trade Discount"},model:{value:(_vm.item.tradeDiscount),callback:function ($$v) {_vm.$set(_vm.item, "tradeDiscount", _vm._n($$v))},expression:"item.tradeDiscount"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-select',{attrs:{"dense":"","items":_vm.godawnByBrand,"label":"Via Godawn"},model:{value:(_vm.item.godawnBy),callback:function ($$v) {_vm.$set(_vm.item, "godawnBy", $$v)},expression:"item.godawnBy"}}):_vm._e()],1),_vm._v(" "),(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName)?_c('v-select',{attrs:{"items":_vm.currentProdDrawers,"item-text":'text',"item-value":'value',"label":"Select Drawer"},model:{value:(_vm.item.drawerId),callback:function ($$v) {_vm.$set(_vm.item, "drawerId", $$v)},expression:"item.drawerId"}}):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.firmSetting && _vm.firmSetting.individualProdBrokerage)?_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"type":"Number","label":"Brokerage Rate (in %)"},model:{value:(_vm.item.brokerageRate),callback:function ($$v) {_vm.$set(_vm.item, "brokerageRate", $$v)},expression:"item.brokerageRate"}})],1):_vm._e(),_vm._v(" "),(_vm.firmSetting && _vm.firmSetting.individualProdBrokerage)?_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Brokerage Amount (in ₹)","disabled":"","value":Number.parseFloat(
                  (Number.parseFloat(_vm.item.totlePrice) *
                    _vm.item.brokerageRate) /
                    100
                ).toFixed(2)}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"sub-desc",attrs:{"xs12":"","sm3":"","md3":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-textarea',{attrs:{"background-color":"grey darken-1","color":"black","box":"","label":"Description"},model:{value:(_vm.item.subDescription),callback:function ($$v) {_vm.$set(_vm.item, "subDescription", $$v)},expression:"item.subDescription"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},_vm._l((_vm.offerList),function(offer,index){return _c('div',{key:index},[_c('h3',{staticClass:"red--text font-weight-bold"},[_vm._v("Offer : Buy "+_vm._s(offer.minQuantity)+" Get "+_vm._s(offer.offerQuantity)+" Free!")])])}),0)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"800px"},model:{value:(_vm.scannerDialog),callback:function ($$v) {_vm.scannerDialog=$$v},expression:"scannerDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Scan Barcode of Product")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('section',{staticClass:"container",attrs:{"id":"container"}},[_c('label',[_c('span',[_vm._v("Camera")]),_vm._v(" "),_c('select',{attrs:{"name":"input-stream_constraints","id":"deviceSelection"}})]),_vm._v(" "),_c('div',{staticClass:"viewport",attrs:{"id":"interactive"}})])])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.scannerDialog = false}}},[_vm._v("Cancel")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"1000px"},model:{value:(_vm.productReportDialog),callback:function ($$v) {_vm.productReportDialog=$$v},expression:"productReportDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Product Report")])]),_vm._v(" "),_c('v-card-text',[_c('product-reports',{attrs:{"product":_vm.selectedProduct,"isBuyer":_vm.isBuyer,"buyerId":_vm.buyer['.key']}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.productReportDialog = false}}},[_vm._v("Cancel")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1492 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cotainer',[_c('v-card',{attrs:{"persistent":""}},[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formTitle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"outline":""},on:{"click":function($event){return _vm.$emit('addProduct')}}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("add")]),_vm._v("\r\n            NEW PRODUCT\r\n        ")],1),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"outline":""},on:{"click":function($event){return _vm.scanItem()}}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("qr_code_scanner")]),_vm._v("\r\n          SCAN\r\n      ")],1),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"outline":""},on:{"click":function($event){return _vm.openProductReport()}}},[_vm._v("\r\n          SUGGESTIONS\r\n      ")])],1),_vm._v(" "),_c('p',{staticStyle:{"font-size":"11px","font-style":"italic","color":"green","padding":"10px"}},[_vm._v("\r\n      **["),_c('b',[_vm._v("Escape")]),_vm._v(" for Cancel],["),_c('b',[_vm._v("Enter")]),_vm._v(" for SAVE] & ["),_c('b',[_vm._v("Plus(+)")]),_vm._v(" for SAVE & ADD].\r\n    ")]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticStyle:{"margin-top":"-35px"},attrs:{"xs11":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.getHeaders,"items":_vm.allItems,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.productName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.unit))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.rate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.basicPrice))]),_vm._v(" "),(_vm.gstInvoice)?_c('td',[_vm._v(_vm._s(props.item.GSTValue))]):_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.tradeDiscount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.totlePrice))]),_vm._v(" "),_c('td',{staticClass:"justify-center layout px-0"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"-60px"},attrs:{"xs1":""}},[_c('v-btn',{staticClass:"cancel-btn-add-icons",attrs:{"color":"blue darken-1"},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancel")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text add-btn-add-icons",attrs:{"disabled":!(_vm.item.productName && _vm.item.quantity && _vm.item.rate)},nativeOn:{"click":function($event){return _vm.save(false)}}},[_vm._v("Save")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{staticClass:"add-save-btn-add-icons",attrs:{"color":"success white--text","disabled":!(_vm.item.productName && _vm.item.quantity && _vm.item.rate)},nativeOn:{"click":function($event){return _vm.save(true)}}},[_vm._v("Save&Add")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-select',{staticClass:"add-product-dropdown",attrs:{"items":_vm.productsByBrand,"item-text":"name","return-object":"","autocomplete":"","label":"Products"},on:{"change":_vm.productChange},model:{value:(_vm.item.productName),callback:function ($$v) {_vm.$set(_vm.item, "productName", $$v)},expression:"item.productName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-select',{attrs:{"items":_vm.availableProductUnit,"label":"Unit"},model:{value:(_vm.item.unit),callback:function ($$v) {_vm.$set(_vm.item, "unit", $$v)},expression:"item.unit"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[(_vm.item.productName)?_c('v-text-field',{attrs:{"type":"number","label":"Quantity"},model:{value:(_vm.item.quantity),callback:function ($$v) {_vm.$set(_vm.item, "quantity", _vm._n($$v))},expression:"item.quantity"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[(_vm.item.productName)?_c('v-text-field',{attrs:{"type":"number","label":"Product Rate"},model:{value:(_vm.item.rate),callback:function ($$v) {_vm.$set(_vm.item, "rate", _vm._n($$v))},expression:"item.rate"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-text-field',{attrs:{"type":"number","disabled":"","label":"Basic Price"},model:{value:(_vm.item.basicPrice),callback:function ($$v) {_vm.$set(_vm.item, "basicPrice", _vm._n($$v))},expression:"item.basicPrice"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-text-field',{attrs:{"type":"number","disabled":"","label":"GST Value"},model:{value:(_vm.item.GSTValue),callback:function ($$v) {_vm.$set(_vm.item, "GSTValue", _vm._n($$v))},expression:"item.GSTValue"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-text-field',{attrs:{"type":"number","disabled":"","label":"Total Price"},model:{value:(_vm.item.totlePrice),callback:function ($$v) {_vm.$set(_vm.item, "totlePrice", _vm._n($$v))},expression:"item.totlePrice"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}}),_vm._v(" "),(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"type":"text","label":"Brand"},model:{value:(_vm.item.productBrandName),callback:function ($$v) {_vm.$set(_vm.item, "productBrandName", $$v)},expression:"item.productBrandName"}})],1):_vm._e(),_vm._v(" "),(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"type":"text","label":"Color"},model:{value:(_vm.item.color),callback:function ($$v) {_vm.$set(_vm.item, "color", $$v)},expression:"item.color"}})],1):_vm._e(),_vm._v(" "),(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"type":"text","label":"Size"},model:{value:(_vm.item.size),callback:function ($$v) {_vm.$set(_vm.item, "size", $$v)},expression:"item.size"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-switch',{attrs:{"label":("Trade Discount in: " + (_vm.isTradePercentage ? '%' : '₹'))},model:{value:(_vm.isTradePercentage),callback:function ($$v) {_vm.isTradePercentage=$$v},expression:"isTradePercentage"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate && _vm.isTradePercentage)?_c('v-text-field',{attrs:{"type":"number","suffix":"%","label":"Trade Discount"},on:{"keyup":function($event){return _vm.calculateTradeDiscount()}},model:{value:(_vm.tradeDiscountPercentage),callback:function ($$v) {_vm.tradeDiscountPercentage=_vm._n($$v)},expression:"tradeDiscountPercentage"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-text-field',{attrs:{"type":"number","suffix":"₹","disabled":_vm.isTradePercentage,"label":"Trade Discount"},model:{value:(_vm.item.tradeDiscount),callback:function ($$v) {_vm.$set(_vm.item, "tradeDiscount", _vm._n($$v))},expression:"item.tradeDiscount"}}):_vm._e()],1),_vm._v(" "),(_vm.firmSetting && _vm.firmSetting.individualProdBrokerage)?_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"type":"Number","label":"Brokerage Rate (in %)"},model:{value:(_vm.item.brokerageRate),callback:function ($$v) {_vm.$set(_vm.item, "brokerageRate", $$v)},expression:"item.brokerageRate"}})],1):_vm._e(),_vm._v(" "),(_vm.firmSetting && _vm.firmSetting.individualProdBrokerage)?_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Brokerage Amount (in ₹)","disabled":"","value":Number.parseFloat(
                  (Number.parseFloat(_vm.item.totlePrice) *
                    _vm.item.brokerageRate) /
                    100
                ).toFixed(2)}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-select',{attrs:{"dense":"","items":_vm.godawnByBrand,"label":"Via Godawn"},model:{value:(_vm.item.godawnBy),callback:function ($$v) {_vm.$set(_vm.item, "godawnBy", $$v)},expression:"item.godawnBy"}}):_vm._e()],1),_vm._v(" "),(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName)?_c('v-select',{attrs:{"items":_vm.currentProdDrawers,"item-text":'text',"item-value":'value',"label":"Select Drawer"},model:{value:(_vm.item.drawerId),callback:function ($$v) {_vm.$set(_vm.item, "drawerId", $$v)},expression:"item.drawerId"}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"sub-desc",attrs:{"xs12":"","sm3":"","md3":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-textarea',{attrs:{"background-color":"grey darken-1","color":"black","box":"","label":"Description"},model:{value:(_vm.item.subDescription),callback:function ($$v) {_vm.$set(_vm.item, "subDescription", $$v)},expression:"item.subDescription"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},_vm._l((_vm.offerList),function(offer,index){return _c('div',{key:index},[_c('h3',{staticClass:"red--text font-weight-bold"},[_vm._v("Offer : Buy "+_vm._s(offer.minQuantity)+" Get "+_vm._s(offer.offerQuantity)+" Free!")])])}),0)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"800px"},model:{value:(_vm.scannerDialog),callback:function ($$v) {_vm.scannerDialog=$$v},expression:"scannerDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Scan Barcode of Product")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('section',{staticClass:"container",attrs:{"id":"container"}},[_c('label',[_c('span',[_vm._v("Camera")]),_vm._v(" "),_c('select',{attrs:{"name":"input-stream_constraints","id":"deviceSelection"}})]),_vm._v(" "),_c('div',{staticClass:"viewport",attrs:{"id":"interactive"}})])])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.scannerDialog = false}}},[_vm._v("Cancel")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"1000px"},model:{value:(_vm.productReportDialog),callback:function ($$v) {_vm.productReportDialog=$$v},expression:"productReportDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Product Report")])]),_vm._v(" "),_c('v-card-text',[_c('product-reports',{attrs:{"product":_vm.selectedProduct,"isBuyer":_vm.isBuyer,"buyerId":_vm.buyer['.key']}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.productReportDialog = false}}},[_vm._v("Cancel")])],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.timeout,"top":"","color":"primary"},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\r\n    Product is added.\r\n    ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1494 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cotainer',[_c('v-card',{attrs:{"persistent":""}},[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formTitle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"outline":""},on:{"click":function($event){return _vm.$emit('addProduct')}}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("add")]),_vm._v("\r\n              NEW PRODUCT\r\n          ")],1),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"outline":""},on:{"click":function($event){return _vm.scanItem()}}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("qr_code_scanner")]),_vm._v("\r\n          SCAN\r\n      ")],1),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"outline":""},on:{"click":function($event){return _vm.openProductReport()}}},[_vm._v("\r\n            SUGGESTIONS\r\n        ")])],1),_vm._v(" "),_c('p',{staticStyle:{"font-size":"11px","font-style":"italic","color":"green","padding":"10px"}},[_vm._v("\r\n      **["),_c('b',[_vm._v("Escape")]),_vm._v(" for Cancel],["),_c('b',[_vm._v("Enter")]),_vm._v(" for SAVE] & ["),_c('b',[_vm._v("Plus(+)")]),_vm._v(" for SAVE & ADD].\r\n    ")]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticStyle:{"margin-top":"-35px"},attrs:{"xs11":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.getHeaders,"items":_vm.allItems,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.productName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.unit))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.rate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.basicPrice))]),_vm._v(" "),(_vm.gstInvoice)?_c('td',[_vm._v(_vm._s(props.item.GSTValue))]):_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.tradeDiscount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.specialCharge))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.totlePrice))]),_vm._v(" "),_c('td',{staticClass:"justify-center layout px-0"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"-60px"},attrs:{"xs1":""}},[_c('v-btn',{staticClass:"cancel-btn-add-icons",attrs:{"color":"blue darken-1"},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancel")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text add-btn-add-icons",attrs:{"disabled":(!(_vm.item.productName && _vm.item.quantity && _vm.item.rate && _vm.item.grossWeight))},nativeOn:{"click":function($event){return _vm.save(false)}}},[_vm._v("Save")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{staticClass:"add-save-btn-add-icons",attrs:{"color":"success white--text","disabled":(!(_vm.item.productName && _vm.item.quantity && _vm.item.rate && _vm.item.grossWeight))},nativeOn:{"click":function($event){return _vm.save(true)}}},[_vm._v("Save&Add")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-select',{staticClass:"add-product-dropdown",attrs:{"items":_vm.productsByBrand,"item-text":"name","return-object":"","autocomplete":"","label":"Products"},on:{"change":_vm.productChange},model:{value:(_vm.item.productName),callback:function ($$v) {_vm.$set(_vm.item, "productName", $$v)},expression:"item.productName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[(_vm.isBuyer)?_c('v-select',{attrs:{"items":_vm.availableProductUniqueIds,"item-text":"unqId","return-object":true,"label":"Unique ID (HUID | RFID)"},on:{"change":function($event){return _vm.setUniqueId()}},model:{value:(_vm.uniqueId),callback:function ($$v) {_vm.uniqueId=$$v},expression:"uniqueId"}}):_c('v-text-field',{attrs:{"type":"text","label":"Unique ID (HUID | RFID)"},model:{value:(_vm.item.unqId),callback:function ($$v) {_vm.$set(_vm.item, "unqId", $$v)},expression:"item.unqId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-text-field',{staticClass:"barcode-selector",attrs:{"type":"text","label":"Barcode"},model:{value:(_vm.item.barcode),callback:function ($$v) {_vm.$set(_vm.item, "barcode", $$v)},expression:"item.barcode"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md1":""}},[_c('v-select',{attrs:{"items":_vm.availableProductUnit,"label":"Unit"},model:{value:(_vm.item.unit),callback:function ($$v) {_vm.$set(_vm.item, "unit", $$v)},expression:"item.unit"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md1":""}},[(_vm.item.productName)?_c('v-text-field',{attrs:{"type":"number","label":"Quantity"},model:{value:(_vm.item.quantity),callback:function ($$v) {_vm.$set(_vm.item, "quantity", _vm._n($$v))},expression:"item.quantity"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[(_vm.item.productName)?_c('v-text-field',{attrs:{"type":"number","label":"Product Rate"},model:{value:(_vm.item.rate),callback:function ($$v) {_vm.$set(_vm.item, "rate", _vm._n($$v))},expression:"item.rate"}}):_vm._e()],1),_vm._v(" "),(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Gross Weight","suffix":_vm.item.unit},model:{value:(_vm.item.grossWeight),callback:function ($$v) {_vm.$set(_vm.item, "grossWeight", _vm._n($$v))},expression:"item.grossWeight"}})],1):_vm._e(),_vm._v(" "),(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Purity","suffix":"%"},model:{value:(_vm.item.purity),callback:function ($$v) {_vm.$set(_vm.item, "purity", $$v)},expression:"item.purity"}})],1):_vm._e(),_vm._v(" "),(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Less"},on:{"keyup":_vm.calculatePrices},model:{value:(_vm.item.lessStone),callback:function ($$v) {_vm.$set(_vm.item, "lessStone", $$v)},expression:"item.lessStone"}})],1):_vm._e(),_vm._v(" "),(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"type":"number","disabled":"","label":"Net Weight","suffix":"Gram"},model:{value:(_vm.item.netWeight),callback:function ($$v) {_vm.$set(_vm.item, "netWeight", _vm._n($$v))},expression:"item.netWeight"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-text-field',{attrs:{"type":"number","disabled":"","label":"Basic Price"},model:{value:(_vm.item.basicPrice),callback:function ($$v) {_vm.$set(_vm.item, "basicPrice", _vm._n($$v))},expression:"item.basicPrice"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-text-field',{attrs:{"type":"number","disabled":"","label":"GST Value"},model:{value:(_vm.item.GSTValue),callback:function ($$v) {_vm.$set(_vm.item, "GSTValue", _vm._n($$v))},expression:"item.GSTValue"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-text-field',{attrs:{"type":"number","disabled":"","label":"Total Price"},model:{value:(_vm.item.totlePrice),callback:function ($$v) {_vm.$set(_vm.item, "totlePrice", _vm._n($$v))},expression:"item.totlePrice"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-switch',{attrs:{"label":("Trade Discount in: " + (_vm.isTradePercentage ? '%' : '₹'))},model:{value:(_vm.isTradePercentage),callback:function ($$v) {_vm.isTradePercentage=$$v},expression:"isTradePercentage"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate && _vm.isTradePercentage)?_c('v-text-field',{attrs:{"type":"number","suffix":"%","label":"Trade Discount in %"},on:{"keyup":function($event){return _vm.calculateTradeDiscount()}},model:{value:(_vm.tradeDiscountPercentage),callback:function ($$v) {_vm.tradeDiscountPercentage=_vm._n($$v)},expression:"tradeDiscountPercentage"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-text-field',{attrs:{"type":"number","suffix":"₹","disabled":_vm.isTradePercentage,"label":"Trade Discount in ₹"},model:{value:(_vm.item.tradeDiscount),callback:function ($$v) {_vm.$set(_vm.item, "tradeDiscount", _vm._n($$v))},expression:"item.tradeDiscount"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-switch',{attrs:{"label":("Labour Charge: " + (_vm.isSpecialChargePercentage ? '%' : '₹'))},model:{value:(_vm.isSpecialChargePercentage),callback:function ($$v) {_vm.isSpecialChargePercentage=$$v},expression:"isSpecialChargePercentage"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate && _vm.isSpecialChargePercentage)?_c('v-text-field',{attrs:{"type":"number","suffix":"%","label":"Labour Charge in %"},on:{"keyup":function($event){return _vm.calculateSpecialCharge()}},model:{value:(_vm.specialChargePercentage),callback:function ($$v) {_vm.specialChargePercentage=_vm._n($$v)},expression:"specialChargePercentage"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-text-field',{attrs:{"type":"number","suffix":"₹","disabled":_vm.isSpecialChargePercentage,"label":"Labour Charge in ₹"},model:{value:(_vm.item.specialCharge),callback:function ($$v) {_vm.$set(_vm.item, "specialCharge", _vm._n($$v))},expression:"item.specialCharge"}}):_vm._e()],1),_vm._v(" "),(_vm.firmSetting && _vm.firmSetting.individualProdBrokerage)?_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"type":"Number","label":"Brokerage Rate (in %)"},model:{value:(_vm.item.brokerageRate),callback:function ($$v) {_vm.$set(_vm.item, "brokerageRate", $$v)},expression:"item.brokerageRate"}})],1):_vm._e(),_vm._v(" "),(_vm.firmSetting && _vm.firmSetting.individualProdBrokerage)?_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Brokerage Amount (in ₹)","disabled":"","value":Number.parseFloat(
                  (Number.parseFloat(_vm.item.totlePrice) *
                    _vm.item.brokerageRate) /
                    100
                ).toFixed(2)}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-select',{attrs:{"dense":"","items":_vm.godawnByBrand,"label":"Via Store"},model:{value:(_vm.item.godawnBy),callback:function ($$v) {_vm.$set(_vm.item, "godawnBy", $$v)},expression:"item.godawnBy"}}):_vm._e()],1),_vm._v(" "),(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName)?_c('v-select',{attrs:{"items":_vm.currentProdDrawers,"item-text":'text',"item-value":'value',"label":"Select Drawer"},model:{value:(_vm.item.drawerId),callback:function ($$v) {_vm.$set(_vm.item, "drawerId", $$v)},expression:"item.drawerId"}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"sub-desc",attrs:{"xs12":"","sm3":"","md3":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-textarea',{attrs:{"background-color":"grey darken-1","color":"black","box":"","label":"Description"},model:{value:(_vm.item.subDescription),callback:function ($$v) {_vm.$set(_vm.item, "subDescription", $$v)},expression:"item.subDescription"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"sub-desc",attrs:{"xs12":"","sm3":"","md3":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-textarea',{attrs:{"background-color":"grey darken-1","color":"black","box":"","label":"Purity Remark"},model:{value:(_vm.item.purityRemark),callback:function ($$v) {_vm.$set(_vm.item, "purityRemark", $$v)},expression:"item.purityRemark"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.generateBarcode()}}},[_vm._v("Generate New Barcode")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.printBarcode()}}},[_vm._v("Print Barcode")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_vm._v("\r\n            Barcode Image\r\n            "),_c('br'),_vm._v(" "),_c('svg',{attrs:{"id":"barcode"}})]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},_vm._l((_vm.offerList),function(offer,index){return _c('div',{key:index},[_c('h3',{staticClass:"red--text font-weight-bold"},[_vm._v("Offer : Buy "+_vm._s(offer.minQuantity)+" Get "+_vm._s(offer.offerQuantity)+" Free!")])])}),0)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"800px"},model:{value:(_vm.scannerDialog),callback:function ($$v) {_vm.scannerDialog=$$v},expression:"scannerDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Scan Barcode of Product")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('section',{staticClass:"container",attrs:{"id":"container"}},[_c('label',[_c('span',[_vm._v("Camera")]),_vm._v(" "),_c('select',{attrs:{"name":"input-stream_constraints","id":"deviceSelection"}})]),_vm._v(" "),_c('div',{staticClass:"viewport",attrs:{"id":"interactive"}})])])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.scannerDialog = false}}},[_vm._v("Cancel")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"1000px"},model:{value:(_vm.productReportDialog),callback:function ($$v) {_vm.productReportDialog=$$v},expression:"productReportDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Product Report")])]),_vm._v(" "),_c('v-card-text',[_c('product-reports',{attrs:{"product":_vm.selectedProduct,"isBuyer":_vm.isBuyer,"buyerId":_vm.buyer['.key']}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.productReportDialog = false}}},[_vm._v("Cancel")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1496 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cotainer',[_c('v-card',{attrs:{"persistent":""}},[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.formTitle))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"outline":""},on:{"click":function($event){return _vm.$emit('addProduct')}}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("add")]),_vm._v("\r\n              NEW PRODUCT\r\n          ")],1),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"outline":""},on:{"click":function($event){return _vm.scanItem()}}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("qr_code_scanner")]),_vm._v("\r\n          SCAN\r\n      ")],1),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"outline":""},on:{"click":function($event){return _vm.openProductReport()}}},[_vm._v("\r\n            SUGGESTIONS\r\n        ")])],1),_vm._v(" "),_c('p',{staticStyle:{"font-size":"11px","font-style":"italic","color":"green","padding":"10px"}},[_vm._v("\r\n      **["),_c('b',[_vm._v("Escape")]),_vm._v(" for Cancel],["),_c('b',[_vm._v("Enter")]),_vm._v(" for SAVE] & ["),_c('b',[_vm._v("Plus(+)")]),_vm._v(" for SAVE & ADD].\r\n    ")]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{staticStyle:{"margin-top":"-35px"},attrs:{"xs11":""}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.getHeaders,"items":_vm.allItems,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.productName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.unit))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.rate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.basicPrice))]),_vm._v(" "),(_vm.gstInvoice)?_c('td',[_vm._v(_vm._s(props.item.GSTValue))]):_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.specialCharge))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.tradeDiscount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.totlePrice))]),_vm._v(" "),_c('td',{staticClass:"justify-center layout px-0"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"-60px"},attrs:{"xs1":""}},[_c('v-btn',{staticClass:"cancel-btn-add-icons",attrs:{"color":"blue darken-1"},nativeOn:{"click":function($event){return _vm.close($event)}}},[_vm._v("Cancel")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text add-btn-add-icons",attrs:{"disabled":!(_vm.item.productName && _vm.item.quantity && _vm.item.rate)},nativeOn:{"click":function($event){return _vm.save(false)}}},[_vm._v("Save")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{staticClass:"add-save-btn-add-icons",attrs:{"color":"success white--text","disabled":!(_vm.item.productName && _vm.item.quantity && _vm.item.rate)},nativeOn:{"click":function($event){return _vm.save(true)}}},[_vm._v("Save&Add")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-select',{staticClass:"add-product-dropdown",attrs:{"items":_vm.productsByBrand,"item-text":"name","return-object":"","autocomplete":"","label":"Products"},on:{"change":_vm.productChange},model:{value:(_vm.item.productName),callback:function ($$v) {_vm.$set(_vm.item, "productName", $$v)},expression:"item.productName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-select',{attrs:{"items":_vm.availableProductUnit,"label":"Unit"},model:{value:(_vm.item.unit),callback:function ($$v) {_vm.$set(_vm.item, "unit", $$v)},expression:"item.unit"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[(_vm.item.productName)?_c('v-text-field',{attrs:{"type":"number","label":"Quantity"},model:{value:(_vm.item.quantity),callback:function ($$v) {_vm.$set(_vm.item, "quantity", _vm._n($$v))},expression:"item.quantity"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[(_vm.item.productName)?_c('v-text-field',{attrs:{"type":"number","label":"Product Rate"},model:{value:(_vm.item.rate),callback:function ($$v) {_vm.$set(_vm.item, "rate", _vm._n($$v))},expression:"item.rate"}}):_vm._e()],1),_vm._v(" "),(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Gross Weight","suffix":_vm.item.unit},model:{value:(_vm.item.grossWeight),callback:function ($$v) {_vm.$set(_vm.item, "grossWeight", _vm._n($$v))},expression:"item.grossWeight"}})],1):_vm._e(),_vm._v(" "),(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-flex',{attrs:{"xs12":"","sm1":"","md1":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Purity","suffix":"%"},model:{value:(_vm.item.purity),callback:function ($$v) {_vm.$set(_vm.item, "purity", $$v)},expression:"item.purity"}})],1):_vm._e(),_vm._v(" "),(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-text-field',{attrs:{"type":"number","disabled":"","label":"Net Weight","suffix":_vm.item.unit},model:{value:(_vm.item.netWeight),callback:function ($$v) {_vm.$set(_vm.item, "netWeight", _vm._n($$v))},expression:"item.netWeight"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-text-field',{attrs:{"type":"number","disabled":"","label":"Basic Price"},model:{value:(_vm.item.basicPrice),callback:function ($$v) {_vm.$set(_vm.item, "basicPrice", _vm._n($$v))},expression:"item.basicPrice"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-text-field',{attrs:{"type":"number","disabled":"","label":"GST Value"},model:{value:(_vm.item.GSTValue),callback:function ($$v) {_vm.$set(_vm.item, "GSTValue", _vm._n($$v))},expression:"item.GSTValue"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-text-field',{attrs:{"type":"number","disabled":"","label":"Total Price"},model:{value:(_vm.item.totlePrice),callback:function ($$v) {_vm.$set(_vm.item, "totlePrice", _vm._n($$v))},expression:"item.totlePrice"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-switch',{attrs:{"label":("Trade Discount in: " + (_vm.isTradePercentage ? '%' : '₹'))},model:{value:(_vm.isTradePercentage),callback:function ($$v) {_vm.isTradePercentage=$$v},expression:"isTradePercentage"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate && _vm.isTradePercentage)?_c('v-text-field',{attrs:{"type":"number","suffix":"%","label":"Trade Discount"},on:{"keyup":function($event){return _vm.calculateTradeDiscount()}},model:{value:(_vm.tradeDiscountPercentage),callback:function ($$v) {_vm.tradeDiscountPercentage=_vm._n($$v)},expression:"tradeDiscountPercentage"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-text-field',{attrs:{"type":"number","suffix":"₹","disabled":_vm.isTradePercentage,"label":"Trade Discount"},model:{value:(_vm.item.tradeDiscount),callback:function ($$v) {_vm.$set(_vm.item, "tradeDiscount", _vm._n($$v))},expression:"item.tradeDiscount"}}):_vm._e()],1),_vm._v(" "),(_vm.firmSetting && _vm.firmSetting.individualProdBrokerage)?_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"type":"Number","label":"Brokerage Rate (in %)"},model:{value:(_vm.item.brokerageRate),callback:function ($$v) {_vm.$set(_vm.item, "brokerageRate", $$v)},expression:"item.brokerageRate"}})],1):_vm._e(),_vm._v(" "),(_vm.firmSetting && _vm.firmSetting.individualProdBrokerage)?_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Brokerage Amount (in ₹)","disabled":"","value":Number.parseFloat(
                  (Number.parseFloat(_vm.item.totlePrice) *
                    _vm.item.brokerageRate) /
                    100
                ).toFixed(2)}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-switch',{attrs:{"label":("Labour Charge: " + (_vm.isSpecialChargePercentage ? '%' : '₹'))},model:{value:(_vm.isSpecialChargePercentage),callback:function ($$v) {_vm.isSpecialChargePercentage=$$v},expression:"isSpecialChargePercentage"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate && _vm.isSpecialChargePercentage)?_c('v-text-field',{attrs:{"type":"number","suffix":"%","label":"Labour Charge in %"},on:{"keyup":function($event){return _vm.calculateSpecialCharge()}},model:{value:(_vm.specialChargePercentage),callback:function ($$v) {_vm.specialChargePercentage=_vm._n($$v)},expression:"specialChargePercentage"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-text-field',{attrs:{"type":"number","suffix":"₹","disabled":_vm.isSpecialChargePercentage,"label":"Labour Charge in ₹"},model:{value:(_vm.item.specialCharge),callback:function ($$v) {_vm.$set(_vm.item, "specialCharge", _vm._n($$v))},expression:"item.specialCharge"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-select',{attrs:{"dense":"","items":_vm.godawnByBrand,"label":"Via Godawn"},model:{value:(_vm.item.godawnBy),callback:function ($$v) {_vm.$set(_vm.item, "godawnBy", $$v)},expression:"item.godawnBy"}}):_vm._e()],1),_vm._v(" "),(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[(_vm.item.productName)?_c('v-select',{attrs:{"items":_vm.currentProdDrawers,"item-text":'text',"item-value":'value',"label":"Select Drawer"},model:{value:(_vm.item.drawerId),callback:function ($$v) {_vm.$set(_vm.item, "drawerId", $$v)},expression:"item.drawerId"}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"sub-desc",attrs:{"xs12":"","sm3":"","md3":""}},[(_vm.item.productName && _vm.item.quantity && _vm.item.rate)?_c('v-textarea',{attrs:{"background-color":"grey darken-1","color":"black","box":"","label":"Description"},model:{value:(_vm.item.subDescription),callback:function ($$v) {_vm.$set(_vm.item, "subDescription", $$v)},expression:"item.subDescription"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},_vm._l((_vm.offerList),function(offer,index){return _c('div',{key:index},[_c('h3',{staticClass:"red--text font-weight-bold"},[_vm._v("Offer : Buy "+_vm._s(offer.minQuantity)+" Get "+_vm._s(offer.offerQuantity)+" Free!")])])}),0)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"800px"},model:{value:(_vm.scannerDialog),callback:function ($$v) {_vm.scannerDialog=$$v},expression:"scannerDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Scan Barcode of Product")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('section',{staticClass:"container",attrs:{"id":"container"}},[_c('label',[_c('span',[_vm._v("Camera")]),_vm._v(" "),_c('select',{attrs:{"name":"input-stream_constraints","id":"deviceSelection"}})]),_vm._v(" "),_c('div',{staticClass:"viewport",attrs:{"id":"interactive"}})])])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.scannerDialog = false}}},[_vm._v("Cancel")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"1000px"},model:{value:(_vm.productReportDialog),callback:function ($$v) {_vm.productReportDialog=$$v},expression:"productReportDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Product Report")])]),_vm._v(" "),_c('v-card-text',[_c('product-reports',{attrs:{"product":_vm.selectedProduct,"isBuyer":_vm.isBuyer,"buyerId":_vm.buyer['.key']}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.productReportDialog = false}}},[_vm._v("Cancel")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1498 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticStyle:{"background-color":"#f1f1f1"},attrs:{"flat":""}},[_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"prefix":"#","label":"Alert (in Days)","readonly":""},model:{value:(_vm.invoiceData.duration),callback:function ($$v) {_vm.$set(_vm.invoiceData, "duration", $$v)},expression:"invoiceData.duration"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"prefix":"#","label":"Invoice Id","readonly":""},model:{value:(_vm.invoiceData.invoiceId),callback:function ($$v) {_vm.$set(_vm.invoiceData, "invoiceId", $$v)},expression:"invoiceData.invoiceId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","offset-xs6":""}},[_c('v-text-field',{attrs:{"label":"Invoice Date","readonly":"","value":new Date(_vm.invoiceData.date).toISOString().substr(0, 10)}})],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.Itemheaders,"items":_vm.invoiceData.items,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.productName))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.HSN_code))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.taxableGST_rate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.rate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.unit))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.basicPrice))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.GSTValue))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.totlePrice))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.CGST_val)+" ₹ ("+_vm._s(props.item.CGST)+" %)")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.SGST_val)+" ₹ ("+_vm._s(props.item.SGST)+" %)")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.IGST_val)+" ₹ ("+_vm._s(props.item.IGST)+" %)")])]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1),_vm._v(" "),_c('v-tabs',{attrs:{"centered":"","icons-and-text":"","background-color":"primary"},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab',{attrs:{"href":"#tab-1"}},[_vm._v("TRANSPORT DETAILS")])],1),_vm._v(" "),_c('v-tabs-items',{model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab-item',{attrs:{"value":'tab-1'}},[_c('v-layout',{staticStyle:{"margin":"20px"},attrs:{"row":"","wrap":""}},[(_vm.customer)?_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"xs12":"","s6":"","md4":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":""}},[_c('h3',{attrs:{"color":"primary"}},[_vm._v("CUSTOMER DETAILS")])]),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"disabled":"","label":"Firm Name"},model:{value:(_vm.customer.name),callback:function ($$v) {_vm.$set(_vm.customer, "name", $$v)},expression:"customer.name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":"","label":"Proprietor Name"},model:{value:(_vm.customer.propName),callback:function ($$v) {_vm.$set(_vm.customer, "propName", $$v)},expression:"customer.propName"}}),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":"","label":"GST Number"},model:{value:(_vm.customer.GST_number),callback:function ($$v) {_vm.$set(_vm.customer, "GST_number", $$v)},expression:"customer.GST_number"}}),_vm._v(" "),_c('v-textarea',{attrs:{"background-color":"grey darken-1","color":"black","disabled":"","box":"","label":"Address"},model:{value:(_vm.customer.localAddress),callback:function ($$v) {_vm.$set(_vm.customer, "localAddress", $$v)},expression:"customer.localAddress"}}),_vm._v(" "),_c('v-textarea',{attrs:{"background-color":"grey darken-1","color":"black","disabled":"","box":"","label":"Place"},model:{value:(_vm.customer.address),callback:function ($$v) {_vm.$set(_vm.customer, "address", $$v)},expression:"customer.address"}}),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":"","label":"Mobile Number"},model:{value:(_vm.customer.mobile),callback:function ($$v) {_vm.$set(_vm.customer, "mobile", $$v)},expression:"customer.mobile"}}),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":"","label":"State"},model:{value:(_vm.customer.state),callback:function ($$v) {_vm.$set(_vm.customer, "state", $$v)},expression:"customer.state"}}),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":"","label":"State Code"},model:{value:(_vm.customer.stateCode),callback:function ($$v) {_vm.$set(_vm.customer, "stateCode", $$v)},expression:"customer.stateCode"}}),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":"","label":"Email"},model:{value:(_vm.customer.email),callback:function ($$v) {_vm.$set(_vm.customer, "email", $$v)},expression:"customer.email"}})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.consignee)?_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"xs12":"","s6":"","md4":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":""}},[_c('h3',{attrs:{"color":"primary"}},[_vm._v("CONSIGNEE DETAILS")])]),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"label":"Firm Name"},model:{value:(_vm.consignee.name),callback:function ($$v) {_vm.$set(_vm.consignee, "name", $$v)},expression:"consignee.name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Proprietor Name"},model:{value:(_vm.consignee.propName),callback:function ($$v) {_vm.$set(_vm.consignee, "propName", $$v)},expression:"consignee.propName"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"GST Number"},model:{value:(_vm.consignee.GST_number),callback:function ($$v) {_vm.$set(_vm.consignee, "GST_number", $$v)},expression:"consignee.GST_number"}}),_vm._v(" "),_c('v-textarea',{attrs:{"background-color":"grey darken-1","color":"black","box":"","label":"Address"},model:{value:(_vm.consignee.localAddress),callback:function ($$v) {_vm.$set(_vm.consignee, "localAddress", $$v)},expression:"consignee.localAddress"}}),_vm._v(" "),_c('v-textarea',{attrs:{"background-color":"grey darken-1","color":"black","box":"","label":"Place"},model:{value:(_vm.consignee.address),callback:function ($$v) {_vm.$set(_vm.consignee, "address", $$v)},expression:"consignee.address"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Mobile Number","rules":_vm.mobile.rules},model:{value:(_vm.consignee.mobile),callback:function ($$v) {_vm.$set(_vm.consignee, "mobile", $$v)},expression:"consignee.mobile"}}),_vm._v(" "),_c('v-select',{attrs:{"clearable":"","items":_vm.gState,"item-text":"state","label":"State"},on:{"change":function($event){return _vm.setSateCode(_vm.consignee)}},model:{value:(_vm.consignee.state),callback:function ($$v) {_vm.$set(_vm.consignee, "state", $$v)},expression:"consignee.state"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"State Code"},model:{value:(_vm.consignee.stateCode),callback:function ($$v) {_vm.$set(_vm.consignee, "stateCode", $$v)},expression:"consignee.stateCode"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Email"},model:{value:(_vm.consignee.email),callback:function ($$v) {_vm.$set(_vm.consignee, "email", $$v)},expression:"consignee.email"}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"xs12":"","s6":"","md4":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":""}},[_c('h3',{attrs:{"color":"primary"}},[_vm._v("TRANSPORTATION DETAILS")])]),_vm._v(" "),_c('v-card-text',[_c('v-select',{attrs:{"items":['Air','Ship','Rail','Road', 'Other'],"label":"Mode of Transport"},model:{value:(_vm.ebillDetails.transportationDetails.mode),callback:function ($$v) {_vm.$set(_vm.ebillDetails.transportationDetails, "mode", $$v)},expression:"ebillDetails.transportationDetails.mode"}}),_vm._v(" "),(_vm.ebillDetails.transportationDetails.mode==='Other')?_c('v-text-field',{attrs:{"label":"Enter Transport Mode"},model:{value:(_vm.transportationDetails.otherTransportationMode),callback:function ($$v) {_vm.$set(_vm.transportationDetails, "otherTransportationMode", $$v)},expression:"transportationDetails.otherTransportationMode"}}):_vm._e(),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Transporter Name"},model:{value:(_vm.transportationDetails.transporterName),callback:function ($$v) {_vm.$set(_vm.transportationDetails, "transporterName", $$v)},expression:"transportationDetails.transporterName"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Goods Receipt Number"},model:{value:(_vm.transportationDetails.goodsReceiptNumber),callback:function ($$v) {_vm.$set(_vm.transportationDetails, "goodsReceiptNumber", $$v)},expression:"transportationDetails.goodsReceiptNumber"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Vehicle Number"},model:{value:(_vm.transportationDetails.vehicleNo),callback:function ($$v) {_vm.$set(_vm.transportationDetails, "vehicleNo", $$v)},expression:"transportationDetails.vehicleNo"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Driver Name"},model:{value:(_vm.transportationDetails.driverName),callback:function ($$v) {_vm.$set(_vm.transportationDetails, "driverName", $$v)},expression:"transportationDetails.driverName"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Driver Mobile Number","rules":_vm.mobile.rules},model:{value:(_vm.transportationDetails.driverNumber),callback:function ($$v) {_vm.$set(_vm.transportationDetails, "driverNumber", $$v)},expression:"transportationDetails.driverNumber"}}),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":"","label":"GSTIN of Supplier"},model:{value:(_vm.ebillDetails.GSTofSupplier),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "GSTofSupplier", $$v)},expression:"ebillDetails.GSTofSupplier"}}),_vm._v(" "),_c('v-textarea',{attrs:{"background-color":"grey darken-1","color":"black","box":"","label":"Place Of Dispatch","readonly":""},model:{value:(_vm.firm.address),callback:function ($$v) {_vm.$set(_vm.firm, "address", $$v)},expression:"firm.address"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"GSTIN of Receipient/Consignee"},model:{value:(_vm.ebillDetails.GSTofReceipient),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "GSTofReceipient", $$v)},expression:"ebillDetails.GSTofReceipient"}}),_vm._v(" "),_c('v-textarea',{attrs:{"background-color":"grey darken-1","color":"black","box":"","label":"Place Of Delivery","readonly":""},model:{value:(_vm.consignee.address),callback:function ($$v) {_vm.$set(_vm.consignee, "address", $$v)},expression:"consignee.address"}})],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"xs12":""}},[_c('v-menu',{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"primary white--text",attrs:{"flat":"","large":""},on:{"click":function($event){return _vm.createEwayBill()}}},on),[_vm._v("\n                  Create E-way Bill\n                ")]),_vm._v(" "),_c('v-btn',_vm._g({staticClass:"primary white--text",attrs:{"flat":"","large":""},on:{"click":function($event){return _vm.printInvoice3(false,false)}}},on),[_vm._v("\n                  Print Preview\n                ")]),_vm._v(" "),_c('v-btn',_vm._g({staticClass:"primary white--text",attrs:{"flat":"","outlined":"","large":""},on:{"click":function($event){return _vm.printInvoice3(true,true)}}},on),[_vm._v("\n                  Save and Download\n                ")]),_vm._v(" "),_c('v-btn',_vm._g({staticClass:"primary white--text",attrs:{"flat":"","large":""},on:{"click":function($event){return _vm.saveInvoice()}}},on),[_vm._v("\n                  Save Invoice\n                ")])]}}])})],1)],1)],1),_vm._v(" "),_c('v-tab-item',{attrs:{"value":'tab-2'}},[_c('v-layout',{staticStyle:{"margin":"20px"},attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"xs12":"","s6":"","md4":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":""}},[_c('h3',{attrs:{"color":"primary"}},[_vm._v("E-WAY DETAILS")])]),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"label":"E-Way Bill no"},model:{value:(_vm.ebillDetails.billNo),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "billNo", $$v)},expression:"ebillDetails.billNo"}}),_vm._v(" "),_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerBillDate2),callback:function ($$v) {_vm.datepickerBillDate2=$$v},expression:"datepickerBillDate2"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"E-way Bill Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.ebillDetails.billDate),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "billDate", $$v)},expression:"ebillDetails.billDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerBillDate2 = false}},model:{value:(_vm.ebillDetails.billDate),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "billDate", $$v)},expression:"ebillDetails.billDate"}})],1),_vm._v(" "),_c('v-text-field',{attrs:{"disabled":"","label":"Generated By"},model:{value:(_vm.ebillDetails.generatedBy),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "generatedBy", $$v)},expression:"ebillDetails.generatedBy"}}),_vm._v(" "),_c('v-text-field',{attrs:{"slot":"activator","label":"Valid From","prepend-icon":"event","value":new Date(_vm.invoiceData.date).toISOString().substr(0, 10),"disabled":""},slot:"activator"}),_vm._v(" "),_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerValidUntil),callback:function ($$v) {_vm.datepickerValidUntil=$$v},expression:"datepickerValidUntil"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Valid Untill","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.ebillDetails.validUntil),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "validUntil", $$v)},expression:"ebillDetails.validUntil"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerValidUntil = false}},model:{value:(_vm.ebillDetails.validUntil),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "validUntil", $$v)},expression:"ebillDetails.validUntil"}})],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"xs12":"","s6":"","md4":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":""}},[_c('h3',{attrs:{"color":"primary"}},[_vm._v("PART - A")])]),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"disabled":"","label":"GSTIN of Supplier"},model:{value:(_vm.ebillDetails.GSTofSupplier),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "GSTofSupplier", $$v)},expression:"ebillDetails.GSTofSupplier"}}),_vm._v(" "),_c('v-textarea',{attrs:{"background-color":"grey darken-1","color":"black","box":"","label":"Place Of Dispatch","readonly":""},model:{value:(_vm.firm.address),callback:function ($$v) {_vm.$set(_vm.firm, "address", $$v)},expression:"firm.address"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"GSTIN of Receipient/Consignee"},model:{value:(_vm.ebillDetails.GSTofReceipient),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "GSTofReceipient", $$v)},expression:"ebillDetails.GSTofReceipient"}}),_vm._v(" "),_c('v-textarea',{attrs:{"background-color":"grey darken-1","color":"black","box":"","label":"Place Of Delivery","readonly":""},model:{value:(_vm.consignee.address),callback:function ($$v) {_vm.$set(_vm.consignee, "address", $$v)},expression:"consignee.address"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Document No"},model:{value:(_vm.ebillDetails.documentNo),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "documentNo", $$v)},expression:"ebillDetails.documentNo"}}),_vm._v(" "),_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerDocumentDate),callback:function ($$v) {_vm.datepickerDocumentDate=$$v},expression:"datepickerDocumentDate"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Document Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.ebillDetails.documentDate),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "documentDate", $$v)},expression:"ebillDetails.documentDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerDocumentDate = false}},model:{value:(_vm.ebillDetails.documentDate),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "documentDate", $$v)},expression:"ebillDetails.documentDate"}})],1),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Value Of Goods"},model:{value:(_vm.ebillDetails.valueOfGoods),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "valueOfGoods", $$v)},expression:"ebillDetails.valueOfGoods"}}),_vm._v(" "),_c('v-textarea',{attrs:{"background-color":"grey darken-1","color":"black","box":"","label":"Reason Of Transportation"},model:{value:(_vm.ebillDetails.reasonOfTransportation),callback:function ($$v) {_vm.$set(_vm.ebillDetails, "reasonOfTransportation", $$v)},expression:"ebillDetails.reasonOfTransportation"}})],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"xs12":"","s6":"","md4":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":""}},[_c('h3',{attrs:{"color":"primary"}},[_vm._v("PART - B")])]),_vm._v(" "),_c('v-card-text',[_c('v-select',{attrs:{"readonly":"","items":['Air','Ship','Rail','Road', 'Other'],"label":"Mode of Transport"},model:{value:(_vm.ebillDetails.transportationDetails.mode),callback:function ($$v) {_vm.$set(_vm.ebillDetails.transportationDetails, "mode", $$v)},expression:"ebillDetails.transportationDetails.mode"}}),_vm._v(" "),(_vm.ebillDetails.transportationDetails.mode==='Other')?_c('v-text-field',{attrs:{"label":"Enter Transport Mode"},model:{value:(_vm.transportationDetails.otherTransportationMode),callback:function ($$v) {_vm.$set(_vm.transportationDetails, "otherTransportationMode", $$v)},expression:"transportationDetails.otherTransportationMode"}}):_vm._e(),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Transporter Name","readonly":""},model:{value:(_vm.transportationDetails.transporterName),callback:function ($$v) {_vm.$set(_vm.transportationDetails, "transporterName", $$v)},expression:"transportationDetails.transporterName"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Goods Receipt Number","readonly":""},model:{value:(_vm.transportationDetails.goodsReceiptNumber),callback:function ($$v) {_vm.$set(_vm.transportationDetails, "goodsReceiptNumber", $$v)},expression:"transportationDetails.goodsReceiptNumber"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Vehicle Number","readonly":""},model:{value:(_vm.transportationDetails.vehicleNo),callback:function ($$v) {_vm.$set(_vm.transportationDetails, "vehicleNo", $$v)},expression:"transportationDetails.vehicleNo"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Driver Name","readonly":""},model:{value:(_vm.transportationDetails.driverName),callback:function ($$v) {_vm.$set(_vm.transportationDetails, "driverName", $$v)},expression:"transportationDetails.driverName"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Driver Mobile Number","readonly":"","rules":_vm.mobile.rules},model:{value:(_vm.transportationDetails.driverNumber),callback:function ($$v) {_vm.$set(_vm.transportationDetails, "driverNumber", $$v)},expression:"transportationDetails.driverNumber"}}),_vm._v(" "),_c('v-textarea',{attrs:{"background-color":"grey darken-1","color":"black","box":"","label":"From Address","readonly":""},model:{value:(_vm.firm.address),callback:function ($$v) {_vm.$set(_vm.firm, "address", $$v)},expression:"firm.address"}}),_vm._v(" "),_c('v-textarea',{attrs:{"background-color":"grey darken-1","color":"black","box":"","label":"To Address","readonly":""},on:{"click":function($event){return _vm.addressDialogOpen('transportationDetails','to')}},model:{value:(_vm.consignee.address),callback:function ($$v) {_vm.$set(_vm.consignee, "address", $$v)},expression:"consignee.address"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Entered By"},model:{value:(_vm.ebillDetails.transportationDetails.enteredBy),callback:function ($$v) {_vm.$set(_vm.ebillDetails.transportationDetails, "enteredBy", $$v)},expression:"ebillDetails.transportationDetails.enteredBy"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"CEWB Number"},model:{value:(_vm.ebillDetails.transportationDetails.CEWBno),callback:function ($$v) {_vm.$set(_vm.ebillDetails.transportationDetails, "CEWBno", $$v)},expression:"ebillDetails.transportationDetails.CEWBno"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"800px"},model:{value:(_vm.addressDialog),callback:function ($$v) {_vm.addressDialog=$$v},expression:"addressDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Select Address")])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-select',{attrs:{"items":_vm.gVillage,"label":"Village"},model:{value:(_vm.address.village),callback:function ($$v) {_vm.$set(_vm.address, "village", $$v)},expression:"address.village"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-select',{attrs:{"items":_vm.gBlock,"label":"Block"},model:{value:(_vm.address.block),callback:function ($$v) {_vm.$set(_vm.address, "block", $$v)},expression:"address.block"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-select',{attrs:{"items":_vm.gTehsil,"label":"Tehsil"},model:{value:(_vm.address.tehsil),callback:function ($$v) {_vm.$set(_vm.address, "tehsil", $$v)},expression:"address.tehsil"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-select',{attrs:{"items":_vm.gDistrict,"label":"District"},model:{value:(_vm.address.district),callback:function ($$v) {_vm.$set(_vm.address, "district", $$v)},expression:"address.district"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-select',{attrs:{"items":_vm.gState,"item-text":"state","label":"State"},model:{value:(_vm.address.state),callback:function ($$v) {_vm.$set(_vm.address, "state", $$v)},expression:"address.state"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Full Address"},model:{value:(_vm.address.fullAddress),callback:function ($$v) {_vm.$set(_vm.address, "fullAddress", $$v)},expression:"address.fullAddress"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.addressDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){return _vm.setAddress($event)}}},[_vm._v("Save")])],1)],1)],1),_vm._v(" "),_c('iframe',{attrs:{"id":"printPdf","name":"printPdf"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-card',{attrs:{"flat":""}},[_c('p',{staticStyle:{"font-size":"11px","font-style":"italic","color":"green","margin":"0px","padding":"10px"}},[_vm._v("\n              **"),_c('b',[_vm._v("Select Customer")]),_vm._v(" and press "),_c('b',[_vm._v("[ Ctrl + f ")]),_vm._v(" to Switch\n              ] "),_c('b',[_vm._v("[ Ctrl + i ")]),_vm._v(" to add New Items ] "),_c('b',[_vm._v(" [Ctrl + p")]),_vm._v(" to\n              Save and Print Invoice.] & "),_c('b',[_vm._v("[Ctrl + s")]),_vm._v(" to Save Invoice.]\n            ")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{staticStyle:{"margin-top":"-30px"},attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-switch',{staticClass:"js-customer-switcher",attrs:{"disabled":!!(_vm.$route.params.orderId || _vm.$route.params.estimateId),"label":("" + (_vm.isBuyer ? 'Sale Invoice' : 'Purchase Invoice'))},model:{value:(_vm.isBuyer),callback:function ($$v) {_vm.isBuyer=$$v},expression:"isBuyer"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{staticClass:"js-select-buyer",attrs:{"items":_vm.isBuyer ? _vm.buyersByBrand : _vm.sellersByBrand,"disabled":!!(_vm.$route.params.orderId || _vm.$route.params.estimateId),"label":_vm.isBuyer ? 'Select or add Buyer' : 'Select or add Seller',"autocomplete":"","item-text":"name","return-object":"","autofocus":true},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addCustomer($event)}},model:{value:(_vm.selectedBuyer),callback:function ($$v) {_vm.selectedBuyer=$$v},expression:"selectedBuyer"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(
                    _vm.firmSetting &&
                    (_vm.firmSetting.autoCounter || _vm.firmSetting.invoiceIdByDate)
                  )?_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-text-field',{attrs:{"prefix":"#","suffix":_vm.invoiceIdPostfix,"label":"Invoice Number","placeholder":"Invoice Number"},on:{"change":function($event){return _vm.duplicateCheckInvoiceId()}},model:{value:(_vm.invoiceIdPrefix),callback:function ($$v) {_vm.invoiceIdPrefix=$$v},expression:"invoiceIdPrefix"}})],1):[_c('v-flex',{attrs:{"xs6":"","sm1":"","md1":""}},[_c('v-text-field',{attrs:{"prefix":"#","label":"Invoice Prefix","placeholder":"Prefix"},on:{"change":function($event){return _vm.duplicateCheckInvoiceId()}},model:{value:(_vm.invoiceIdPrefix),callback:function ($$v) {_vm.invoiceIdPrefix=$$v},expression:"invoiceIdPrefix"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm1":"","md1":""}},[_c('v-text-field',{attrs:{"prefix":"-","label":"Invoice Number","placeholder":"Invoice Number"},on:{"change":function($event){return _vm.duplicateCheckInvoiceId()}},model:{value:(_vm.invoiceIdPostfix),callback:function ($$v) {_vm.invoiceIdPostfix=$$v},expression:"invoiceIdPostfix"}})],1)],_vm._v(" "),_c('h3',{staticClass:"error--text text--darken-4"},[_vm._v("\n                  "+_vm._s(_vm.duplicateError)+"\n                ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker),callback:function ($$v) {_vm.datepicker=$$v},expression:"datepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","value":_vm.getDateFormatted(_vm.invoiceDate),"label":"Date","prepend-icon":"event","readonly":""},slot:"activator"}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepicker = false}},model:{value:(_vm.invoiceDate),callback:function ($$v) {_vm.invoiceDate=$$v},expression:"invoiceDate"}})],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm1":"","md1":""}},[(_vm.firmSetting && _vm.firmSetting.alert)?_c('v-text-field',{attrs:{"prefix":"#","label":"Alert (in Days)"},model:{value:(_vm.alertDuration),callback:function ($$v) {_vm.alertDuration=$$v},expression:"alertDuration"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"primary white--text",attrs:{"icon":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',[_vm._v("\n                      mdi-close\n                    ")])],1)],1)],2)],1),_vm._v(" "),(
                !(
                  new Date(_vm.invoiceDate).getTime() >= _vm.finYear.start &&
                  new Date(_vm.invoiceDate).getTime() <= _vm.finYear.end
                )
              )?_c('h3',{staticClass:"error--text text--darken-4"},[_vm._v("\n              This invoice is not in current financial year.\n            ")]):_vm._e(),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.getHeaders,"items":_vm.items,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.productName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.unit))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.rate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.netWeight))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.tradeDiscount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.specialCharge))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.basicPrice))]),_vm._v(" "),(_vm.gstInvoice)?_c('td',[_vm._v(_vm._s(props.item.GSTValue))]):_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.totlePrice))]),_vm._v(" "),(_vm.gstInvoice)?_c('td',[_vm._v("\n                  "+_vm._s(props.item.CGST_val)+" ₹ ("+_vm._s(props.item.CGST)+" %)\n                ")]):_vm._e(),_vm._v(" "),(_vm.gstInvoice)?_c('td',[_vm._v("\n                  "+_vm._s(props.item.SGST_val)+" ₹ ("+_vm._s(props.item.SGST)+" %)\n                ")]):_vm._e(),_vm._v(" "),(_vm.gstInvoice)?_c('td',[_vm._v("\n                  "+_vm._s(props.item.IGST_val)+" ₹ ("+_vm._s(props.item.IGST)+" %)\n                ")]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"justify-center layout px-0"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item, false)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2),_vm._v(" "),(_vm.selectedBuyer && _vm.selectedFirm)?_c('v-card-actions',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('v-dialog',{attrs:{"persistent":"","width":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[(_vm.businessType == 'Jwellery')?[_c('v-btn',{staticClass:"primary white--text",staticStyle:{"margin-top":"10px"},attrs:{"slot":"activator","flat":""},on:{"click":function($event){return _vm.focusAddProduct()}},slot:"activator"},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("add")]),_vm._v("\n                        New Item\n                      ")],1),_vm._v(" "),_c('add-item-jewl',{attrs:{"editedItem":_vm.editedItem,"buyer":_vm.selectedBuyer  || null,"allItems":_vm.items,"isEditItems":_vm.isEditItems,"gstInvoice":_vm.gstInvoice,"selectedFirm":_vm.selectedFirm,"isBuyer":_vm.isBuyer,"firmSetting":_vm.firmSetting,"invoiceDate":_vm.invoiceDate,"godawn":_vm.godawnBy},on:{"closeAddItem":_vm.close,"saveAddItem":_vm.save,"editItem":_vm.editItem,"deleteItem":_vm.deleteItem,"addProduct":_vm.addProduct}})]:(_vm.businessType == 'Grain')?[_c('v-btn',{staticClass:"primary white--text",staticStyle:{"margin-top":"10px"},attrs:{"slot":"activator","flat":""},on:{"click":function($event){return _vm.focusAddProduct()}},slot:"activator"},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("add")]),_vm._v("\n                        New Item\n                      ")],1),_vm._v(" "),_c('add-item-grain',{attrs:{"editedItem":_vm.editedItem,"buyer":_vm.selectedBuyer  || null,"allItems":_vm.items,"isEditItems":_vm.isEditItems,"gstInvoice":_vm.gstInvoice,"selectedFirm":_vm.selectedFirm,"isBuyer":_vm.isBuyer,"firmSetting":_vm.firmSetting,"invoiceDate":_vm.invoiceDate,"godawn":_vm.godawnBy},on:{"closeAddItem":_vm.close,"saveAddItem":_vm.save,"editItem":_vm.editItem,"deleteItem":_vm.deleteItem,"addProduct":_vm.addProduct}})]:(_vm.businessType == 'Default')?[_c('v-btn',{staticClass:"primary white--text",staticStyle:{"margin-top":"10px"},attrs:{"slot":"activator","flat":""},on:{"click":function($event){return _vm.focusAddProduct()}},slot:"activator"},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("add")]),_vm._v("\n                        New Item\n                      ")],1),_vm._v(" "),_c('add-item-default',{attrs:{"editedItem":_vm.editedItem,"buyer":_vm.selectedBuyer  || null,"allItems":_vm.items,"isEditItems":_vm.isEditItems,"gstInvoice":_vm.gstInvoice,"selectedFirm":_vm.selectedFirm,"isBuyer":_vm.isBuyer,"firmSetting":_vm.firmSetting,"invoiceDate":_vm.invoiceDate,"godawn":_vm.godawnBy},on:{"closeAddItem":_vm.close,"saveAddItem":_vm.save,"editItem":_vm.editItem,"deleteItem":_vm.deleteItem,"addProduct":_vm.addProduct}})]:(_vm.businessType == 'Clothes')?[_c('v-btn',{staticClass:"primary white--text",staticStyle:{"margin-top":"10px"},attrs:{"slot":"activator","flat":""},on:{"click":function($event){return _vm.focusAddProduct()}},slot:"activator"},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("add")]),_vm._v("\n                        New Item\n                      ")],1),_vm._v(" "),_c('add-item-clothes',{attrs:{"editedItem":_vm.editedItem,"buyer":_vm.selectedBuyer  || null,"allItems":_vm.items,"isEditItems":_vm.isEditItems,"gstInvoice":_vm.gstInvoice,"selectedFirm":_vm.selectedFirm,"isBuyer":_vm.isBuyer,"firmSetting":_vm.firmSetting,"invoiceDate":_vm.invoiceDate,"godawn":_vm.godawnBy},on:{"closeAddItem":_vm.close,"saveAddItem":_vm.save,"editItem":_vm.editItem,"deleteItem":_vm.deleteItem,"addProduct":_vm.addProduct}})]:(_vm.businessType == 'Dairy')?[_c('v-btn',{staticClass:"primary white--text",staticStyle:{"margin-top":"10px"},attrs:{"slot":"activator","flat":""},on:{"click":function($event){return _vm.focusAddProduct()}},slot:"activator"},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("add")]),_vm._v("\n                        New Item\n                      ")],1),_vm._v(" "),_c('add-item-dairy',{attrs:{"editedItem":_vm.editedItem,"buyer":_vm.selectedBuyer  || null,"allItems":_vm.items,"isEditItems":_vm.isEditItems,"gstInvoice":_vm.gstInvoice,"selectedFirm":_vm.selectedFirm,"isBuyer":_vm.isBuyer,"firmSetting":_vm.firmSetting,"invoiceDate":_vm.invoiceDate,"godawn":_vm.godawnBy},on:{"closeAddItem":_vm.close,"saveAddItem":_vm.save,"editItem":_vm.editItem,"deleteItem":_vm.deleteItem,"addProduct":_vm.addProduct}})]:(
                        _vm.businessType == 'Automobile/Agriculture/Spare Parts'
                      )?[_c('v-btn',{staticClass:"primary white--text",staticStyle:{"margin-top":"10px"},attrs:{"slot":"activator","flat":""},on:{"click":function($event){return _vm.focusAddProduct()}},slot:"activator"},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("add")]),_vm._v("\n                        New Item\n                      ")],1),_vm._v(" "),_c('add-item-auto',{attrs:{"editedItem":_vm.editedItem,"buyer":_vm.selectedBuyer  || null,"allItems":_vm.items,"isEditItems":_vm.isEditItems,"gstInvoice":_vm.gstInvoice,"selectedFirm":_vm.selectedFirm,"isBuyer":_vm.isBuyer,"firmSetting":_vm.firmSetting,"invoiceDate":_vm.invoiceDate,"godawn":_vm.godawnBy},on:{"closeAddItem":_vm.close,"saveAddItem":_vm.save,"editItem":_vm.editItem,"deleteItem":_vm.deleteItem,"addProduct":_vm.addProduct}})]:[_c('v-btn',{staticClass:"primary white--text",staticStyle:{"margin-top":"10px"},attrs:{"slot":"activator","flat":""},on:{"click":function($event){return _vm.focusAddProduct()}},slot:"activator"},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("add")]),_vm._v("\n                        New Item\n                      ")],1),_vm._v(" "),_c('add-item-med',{attrs:{"editedItem":_vm.editedItem,"buyer":_vm.selectedBuyer  || null,"allItems":_vm.items,"isEditItems":_vm.isEditItems,"gstInvoice":_vm.gstInvoice,"selectedFirm":_vm.selectedFirm,"isBuyer":_vm.isBuyer,"firmSetting":_vm.firmSetting,"invoiceDate":_vm.invoiceDate,"godawn":_vm.godawnBy},on:{"closeAddItem":_vm.close,"saveAddItem":_vm.save,"editItem":_vm.editItem,"deleteItem":_vm.deleteItem,"addProduct":_vm.addProduct}})]],2)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{staticClass:"warning white--text",staticStyle:{"margin-top":"10px"},attrs:{"flat":""},on:{"click":function($event){_vm.billingDetailsDialog = true}}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v(" add ")]),_vm._v("\n                    Mailing Info\n                  ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-select',{attrs:{"solo":"","label":'Select Product Set',"item-text":"name","items":_vm.ProductSetByBrand,"return-object":"","clearable":""},on:{"change":_vm.selectProductSet},model:{value:(_vm.selectedProductSet),callback:function ($$v) {_vm.selectedProductSet=$$v},expression:"selectedProductSet"}})],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.selectedFirm && _vm.transactionType && _vm.items.length)?_c('v-card-actions',[_c('v-menu',{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                      var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"ma-1 primary white--text",staticStyle:{"font-size":"15px"},attrs:{"flat":"","large":"","outlined":"","disabled":_vm.isSaving}},on),[_vm._v("\n                      Print Preview\n                    ")])]}}],null,false,3382288138)},[_vm._v(" "),_c('v-list',[(_vm.firmSetting && _vm.firmSetting.supportedPrintFormats && _vm.firmSetting.supportedPrintFormats.length ? _vm.firmSetting.supportedPrintFormats.indexOf('simple') > -1 : true)?_c('v-list-tile',{on:{"click":function($event){return _vm.printInvoice4(false, false)}}},[_c('v-list-tile-title',[_vm._v(" Simple Print ")])],1):_vm._e(),_vm._v(" "),(_vm.firmSetting && _vm.firmSetting.supportedPrintFormats && _vm.firmSetting.supportedPrintFormats.length ? _vm.firmSetting.supportedPrintFormats.indexOf('basic') > -1 : true)?_c('v-list-tile',{on:{"click":function($event){return _vm.basicInvoicePrint(true, false)}}},[_c('v-list-tile-title',[_vm._v(" Basic Print ")])],1):_vm._e(),_vm._v(" "),(_vm.firmSetting && _vm.firmSetting.supportedPrintFormats && _vm.firmSetting.supportedPrintFormats.length ? _vm.firmSetting.supportedPrintFormats.indexOf('detailed') > -1 : true)?_c('v-list-tile',{on:{"click":function($event){return _vm.basicInvoicePrint(false, false)}}},[_c('v-list-tile-title',[_vm._v(" Detailed Print ")])],1):_vm._e(),_vm._v(" "),(_vm.firmSetting && _vm.firmSetting.supportedPrintFormats && _vm.firmSetting.supportedPrintFormats.length ? _vm.firmSetting.supportedPrintFormats.indexOf('trail') > -1 : true)?_c('v-list-tile',{on:{"click":function($event){return _vm.basicShortInvoicePrint(false, false)}}},[_c('v-list-tile-title',[_vm._v(" Short Print ")])],1):_vm._e(),_vm._v(" "),(_vm.firmSetting && _vm.firmSetting.supportedPrintFormats && _vm.firmSetting.supportedPrintFormats.length ? _vm.firmSetting.supportedPrintFormats.indexOf('theme1') > -1 : true)?_c('v-list-tile',{on:{"click":function($event){return _vm.basicInvoiceTheme1Print(false, false)}}},[_c('v-list-tile-title',[_vm._v(" Theme Print ")])],1):_vm._e()],1)],1),_vm._v(" "),_c('v-menu',{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                      var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"ma-1 primary white--text",attrs:{"flat":"","large":"","outlined":"","disabled":_vm.isSaving}},on),[_vm._v("\n                      Save & Print\n                    ")])]}}],null,false,2047130517)},[_vm._v(" "),_c('v-list',[(_vm.firmSetting && _vm.firmSetting.supportedPrintFormats && _vm.firmSetting.supportedPrintFormats.length ? _vm.firmSetting.supportedPrintFormats.indexOf('simple') > -1 : true)?_c('v-list-tile',{on:{"click":function($event){return _vm.printInvoice4(true, true)}}},[_c('v-list-tile-title',[_vm._v(" Simple Print ")])],1):_vm._e(),_vm._v(" "),(_vm.firmSetting && _vm.firmSetting.supportedPrintFormats && _vm.firmSetting.supportedPrintFormats.length ? _vm.firmSetting.supportedPrintFormats.indexOf('basic') > -1 : true)?_c('v-list-tile',{on:{"click":function($event){return _vm.saveAndPrint(true, true)}}},[_c('v-list-tile-title',[_vm._v("Basic Print")])],1):_vm._e(),_vm._v(" "),(_vm.firmSetting && _vm.firmSetting.supportedPrintFormats && _vm.firmSetting.supportedPrintFormats.length ? _vm.firmSetting.supportedPrintFormats.indexOf('detailed') > -1 : true)?_c('v-list-tile',{on:{"click":function($event){return _vm.saveAndPrint(false, true)}}},[_c('v-list-tile-title',[_vm._v("Detailed Print")])],1):_vm._e(),_vm._v(" "),(_vm.firmSetting && _vm.firmSetting.supportedPrintFormats && _vm.firmSetting.supportedPrintFormats.length ? _vm.firmSetting.supportedPrintFormats.indexOf('trail') > -1 : true)?_c('v-list-tile',{on:{"click":function($event){return _vm.basicShortInvoicePrint(true, true)}}},[_c('v-list-tile-title',[_vm._v("Short Print")])],1):_vm._e(),_vm._v(" "),(_vm.firmSetting && _vm.firmSetting.supportedPrintFormats && _vm.firmSetting.supportedPrintFormats.length ? _vm.firmSetting.supportedPrintFormats.indexOf('theme1') > -1 : true)?_c('v-list-tile',{on:{"click":function($event){return _vm.basicInvoiceTheme1Print(true, true)}}},[_c('v-list-tile-title',[_vm._v("Theme1 Print")])],1):_vm._e()],1)],1),_vm._v(" "),_c('v-btn',{staticClass:"ma-1 primary white--text",attrs:{"flat":"","large":"","outlined":"","disabled":_vm.isSaving},nativeOn:{"click":function($event){return _vm.saveInvoice()}}},[_vm._v("Save Invoice\n                ")])],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_vm._l((_vm.multiFirmData),function(item){return [_c('v-chip',{key:item.firm,attrs:{"color":item.firm == _vm.selectedFirm ? 'green' : '',"text-color":item.firm == _vm.selectedFirm ? 'white' : ''}},[_vm._v(_vm._s(_vm.getFirmName(item.firm)))])]}),_vm._v(" "),_c('router-link',{attrs:{"to":{
                    name: 'CustomerPayments',
                    params: { customerId: _vm.multiFirmPayment },
                  }}},[(_vm.multiFirmPayment)?_c('v-btn',{staticClass:"primary white--text",attrs:{"flat":""}},[_vm._v("Pay Invoice\n                  ")]):_vm._e()],1)],2)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.transactionDialog),callback:function ($$v) {_vm.transactionDialog=$$v},expression:"transactionDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Payment Details ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.transactionDialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Total Amount (in ₹)","readonly":"","value":_vm.totalAmount,"prefix":""}}),_vm._v(" "),_c('v-select',{attrs:{"dense":"","items":[
                            {
                              text: 'Cash',
                              value: 'Cash',
                            },
                            {
                              text: 'Bank Account',
                              value: 'Bank Account',
                            },
                            {
                              text: 'Cash & Bank Account',
                              value: 'CashAndBank Account',
                            } ],"label":"Select Payment Type"},model:{value:(_vm.paymentType),callback:function ($$v) {_vm.paymentType=$$v},expression:"paymentType"}}),_vm._v(" "),(
                            ['Bank Account', 'CashAndBank Account'].includes(
                              _vm.paymentType
                            )
                          )?_c('v-select',{attrs:{"dense":"","items":_vm.banksByFirms,"label":"Select Bank","disabled":_vm.paymentType == 'Cash' || _vm.paymentType == ''},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                            "+_vm._s(data.item.account.accountnumber)+"\n                            "+_vm._s(data.item.account.bankName ? ' | '+ data.item.account.bankName : '')+"\n                        ")]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(((data.item.account.accountnumber) + "\n                                    " + (data.item.account.bankName ? ' | '+data.item.account.bankName : '') + "\n                                    " + (data.item.account.accountType ? ' | '+data.item.account.accountType : '') + "\n                                    | ₹: " + ((data.item.account.amount || 0).toLocaleString()))
                                )}})],1)]}}],null,false,2292747233),model:{value:(_vm.selectedBank),callback:function ($$v) {_vm.selectedBank=$$v},expression:"selectedBank"}}):_vm._e(),_vm._v(" "),(
                            ['Bank Account', 'CashAndBank Account'].includes(
                              _vm.paymentType
                            )
                          )?_c('v-select',{attrs:{"dense":"","disabled":_vm.paymentType == 'Cash' || _vm.paymentType == '',"items":[
                            {
                              text: 'Cheque',
                              value: 'Cheque',
                            },
                            {
                              text: 'NEFT',
                              value: 'NEFT',
                            },
                            {
                              text: 'RTGS',
                              value: 'RTGS',
                            },
                            {
                              text: 'IMPS',
                              value: 'IMPS',
                            } ],"label":"Select Transfer type"},on:{"input":function($event){_vm.transferTypeDialog = true}},model:{value:(_vm.transferType),callback:function ($$v) {_vm.transferType=$$v},expression:"transferType"}}):_vm._e(),_vm._v(" "),(
                            ['Cash', 'CashAndBank Account'].includes(
                              _vm.paymentType
                            )
                          )?_c('v-text-field',{attrs:{"type":"number","disabled":_vm.amountFromCashDisabled,"label":"Amount from Cash","hint":_vm.hintText},model:{value:(_vm.amountFromCash),callback:function ($$v) {_vm.amountFromCash=$$v},expression:"amountFromCash"}}):_vm._e(),_vm._v(" "),(
                            ['Bank Account', 'CashAndBank Account'].includes(
                              _vm.paymentType
                            )
                          )?_c('v-text-field',{attrs:{"type":"number","disabled":_vm.amountFromBankDisabled,"label":"Amount from Bank","hint":_vm.hintText},model:{value:(_vm.amountFromBank),callback:function ($$v) {_vm.amountFromBank=$$v},expression:"amountFromBank"}}):_vm._e(),_vm._v(" "),(_vm.remainingAmount > 0)?_c('v-text-field',{attrs:{"type":"number","label":"Remaining Amount (in ₹)","readonly":"","prefix":""},model:{value:(_vm.remainingAmount),callback:function ($$v) {_vm.remainingAmount=$$v},expression:"remainingAmount"}}):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","disabled":!_vm.paymentType ||
                      (_vm.paymentType == 'CashAndBank Account' &&
                      _vm.status == 'paid'
                        ? Number.parseFloat(_vm.amountFromCash) +
                            Number.parseFloat(_vm.amountFromBank) !=
                          Number.parseFloat(_vm.totalAmount)
                        : false),"flat":""},nativeOn:{"click":function($event){return _vm.transactionDetailsSave()}}},[_vm._v("Confirm")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.transferTypeDialog),callback:function ($$v) {_vm.transferTypeDialog=$$v},expression:"transferTypeDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("\n                    Transfer Information\n                    "),_c('b',[_vm._v(_vm._s(_vm.transferType))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.transferTypeDialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","label":"A/C Number"},model:{value:(_vm.transferDetails.accountNumber),callback:function ($$v) {_vm.$set(_vm.transferDetails, "accountNumber", $$v)},expression:"transferDetails.accountNumber"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"text","label":"A/C Holder Name"},model:{value:(_vm.transferDetails.accountHolderName),callback:function ($$v) {_vm.$set(_vm.transferDetails, "accountHolderName", $$v)},expression:"transferDetails.accountHolderName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"text","label":"Bank Name"},model:{value:(_vm.transferDetails.bankName),callback:function ($$v) {_vm.$set(_vm.transferDetails, "bankName", $$v)},expression:"transferDetails.bankName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"text","label":"IFSC Code"},model:{value:(_vm.transferDetails.IFSCcode),callback:function ($$v) {_vm.$set(_vm.transferDetails, "IFSCcode", $$v)},expression:"transferDetails.IFSCcode"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"text","label":"Remark"},model:{value:(_vm.transferDetails.remark),callback:function ($$v) {_vm.$set(_vm.transferDetails, "remark", $$v)},expression:"transferDetails.remark"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.transferTypeDialog = false}}},[_vm._v("Ok")])],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"dense":"","flat":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","s12":"","md8":""}},[_c('v-expansion-panel',{staticClass:"invoiceExpansion"},[_c('v-expansion-panel-content',{attrs:{"value":_vm.expansionVal},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('v-card-title',[_c('h3',{staticClass:"\n                              title\n                              font-weight-light\n                              primary\n                              white--text\n                            "},[_vm._v("\n                            Basic Details\n                          ")])])]},proxy:true}])},[_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm2":"","md1":""}},[_c('v-text-field',{attrs:{"label":"Total Item","readonly":"","value":_vm.totalItems}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs5":""}},[_c('v-select',{attrs:{"dense":"","readonly":"","items":_vm.firmsByBrand,"label":"Select Firm","disabled":!!_vm.multiFirmData.length},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-select',{attrs:{"dense":"","disabled":!_vm.items.length,"items":[
                                  {
                                    text: 'Due',
                                    value: 'Debit',
                                  },
                                  {
                                    text: 'Partial Paid',
                                    value: 'Partial Paid',
                                  },
                                  {
                                    text: 'Full Paid',
                                    value: 'Credit',
                                  } ],"label":"Select Transaction type"},on:{"change":function($event){return _vm.resetAmounts()}},model:{value:(_vm.transactionType),callback:function ($$v) {_vm.transactionType=$$v},expression:"transactionType"}})],1),_vm._v(" "),(_vm.transactionType != 'Debit')?[_c('v-flex',{attrs:{"xs3":""}},[_c('v-select',{attrs:{"dense":"","items":[
                                    {
                                      text: 'Cash',
                                      value: 'Cash',
                                    },
                                    {
                                      text: 'Bank Account',
                                      value: 'Bank Account',
                                    },
                                    {
                                      text: 'Cash & Bank Account',
                                      value: 'CashAndBank Account',
                                    } ],"label":"Select Payment Type"},model:{value:(_vm.paymentType),callback:function ($$v) {_vm.paymentType=$$v},expression:"paymentType"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[(
                                    [
                                      'Bank Account',
                                      'CashAndBank Account' ].includes(_vm.paymentType)
                                  )?_c('v-select',{attrs:{"dense":"","items":_vm.banksByFirms,"label":"Select Bank","disabled":_vm.paymentType == 'Cash' || _vm.paymentType == ''},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                                    "+_vm._s(data.item.account.accountnumber)+"\n                                    "+_vm._s(data.item.account.bankName ? ' | '+ data.item.account.bankName : '')+"\n                                ")]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(((data.item.account.accountnumber) + "\n                                            " + (data.item.account.bankName ? ' | '+data.item.account.bankName : '') + "\n                                            " + (data.item.account.accountType ? ' | '+data.item.account.accountType : '') + "\n                                            | ₹: " + ((data.item.account.amount || 0).toLocaleString()))
                                        )}})],1)]}}],null,false,1595645921),model:{value:(_vm.selectedBank),callback:function ($$v) {_vm.selectedBank=$$v},expression:"selectedBank"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[(
                                    [
                                      'Bank Account',
                                      'CashAndBank Account' ].includes(_vm.paymentType)
                                  )?_c('v-select',{attrs:{"dense":"","disabled":_vm.paymentType == 'Cash' || _vm.paymentType == '',"items":[
                                    {
                                      text: 'Cheque',
                                      value: 'Cheque',
                                    },
                                    {
                                      text: 'NEFT',
                                      value: 'NEFT',
                                    },
                                    {
                                      text: 'RTGS',
                                      value: 'RTGS',
                                    },
                                    {
                                      text: 'IMPS',
                                      value: 'IMPS',
                                    } ],"label":"Select Transfer type"},on:{"input":function($event){_vm.transferTypeDialog = true}},model:{value:(_vm.transferType),callback:function ($$v) {_vm.transferType=$$v},expression:"transferType"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[(
                                    ['Cash', 'CashAndBank Account'].includes(
                                      _vm.paymentType
                                    )
                                  )?_c('v-text-field',{attrs:{"hint":_vm.hintText,"type":"number","disabled":_vm.amountFromCashDisabled,"label":"Amount from Cash"},model:{value:(_vm.amountFromCash),callback:function ($$v) {_vm.amountFromCash=$$v},expression:"amountFromCash"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[(
                                    [
                                      'Bank Account',
                                      'CashAndBank Account' ].includes(_vm.paymentType)
                                  )?_c('v-text-field',{attrs:{"type":"number","hint":_vm.hintText,"disabled":_vm.amountFromBankDisabled,"label":"Amount from Bank"},model:{value:(_vm.amountFromBank),callback:function ($$v) {_vm.amountFromBank=$$v},expression:"amountFromBank"}}):_vm._e()],1)]:_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-select',{attrs:{"disabled":!!(
                                    _vm.roleAndPermission &&
                                    !!_vm.roleAndPermission.branch
                                  ),"item-text":"text","item-value":"value","items":_vm.branchByBrand,"label":"Select Branch"},model:{value:(_vm.branch),callback:function ($$v) {_vm.branch=$$v},expression:"branch"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.godawnByBrand,"label":"Via Godawn"},model:{value:(_vm.godawnBy),callback:function ($$v) {_vm.godawnBy=$$v},expression:"godawnBy"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[(!_vm.isDiscountPercentage)?_c('span',{staticClass:"percentage-button",on:{"click":function($event){_vm.isDiscountPercentage = true}}},[_vm._v("\n                                %\n                              ")]):_c('span',{staticClass:"percentage-button",on:{"click":function($event){_vm.isDiscountPercentage = false}}},[_vm._v("\n                                ₹\n                              ")]),_vm._v(" "),(!_vm.isDiscountPercentage)?_c('v-text-field',{attrs:{"type":"number","label":"Discount (in ₹)"},model:{value:(_vm.discountAmount),callback:function ($$v) {_vm.discountAmount=$$v},expression:"discountAmount"}}):_c('v-text-field',{attrs:{"type":"number","label":"Discount (in %)"},model:{value:(_vm.discountPercentage),callback:function ($$v) {_vm.discountPercentage=$$v},expression:"discountPercentage"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Round Off (in ₹)"},model:{value:(_vm.roundOffAmount),callback:function ($$v) {_vm.roundOffAmount=$$v},expression:"roundOffAmount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.staffByBrand,"label":"Sold By"},model:{value:(_vm.soldBy),callback:function ($$v) {_vm.soldBy=$$v},expression:"soldBy"}})],1),_vm._v(" "),(_vm.soldBy)?_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"type":"Number","label":"Brokerage Rate (in %)"},model:{value:(_vm.brokerageRate),callback:function ($$v) {_vm.brokerageRate=$$v},expression:"brokerageRate"}})],1):_vm._e(),_vm._v(" "),(_vm.soldBy)?_c('v-flex',{attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Brokerage Amount (in ₹)","disabled":"","value":Number.parseFloat(
                                    (Number.parseFloat(_vm.totalAmount) *
                                      _vm.brokerageRate) /
                                      100
                                  ).toFixed(2)}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.gState,"label":"Place of Supply","item-text":"state"},model:{value:(_vm.placeOfSupply),callback:function ($$v) {_vm.placeOfSupply=$$v},expression:"placeOfSupply"}})],1),_vm._v(" "),(
                              _vm.firmSetting &&
                              (_vm.firmSetting.invoiceImage)
                            )?_c('v-flex',{attrs:{"xs4":""}},[_c('label',{staticClass:"title mat-raised-button",attrs:{"for":"invoiceImages"}},[_c('span',{staticStyle:{"font-weight":"bold","color":"rgb(39, 39, 176)","font-size":"14px","margin":"20px","display":"inline-block"}},[_vm._v(_vm._s(_vm.invoiceImages.length ? _vm.invoiceImages.map(function (i){ return i.name; }) : 'Select Images(Max-3)'))])]),_vm._v(" "),(_vm.invoiceImages.length)?_c('v-btn',{staticClass:"primary--text font-weight-bold",attrs:{"outline":"","flat":""},on:{"click":function($event){return _vm.clearImage()}}},[_vm._v("Clear")]):_vm._e(),_vm._v(" "),_c('input',{staticStyle:{"visibility":"hidden"},attrs:{"id":"invoiceImages","multiple":"","accept":".png,.jpg","type":"file"},on:{"change":function($event){return _vm.uploadImage($event)}}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-textarea',{attrs:{"background-color":"grey darken-1","color":"black","box":"","label":"Delivery Terms"},model:{value:(_vm.remark),callback:function ($$v) {_vm.remark=$$v},expression:"remark"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"label":"Incentive"},on:{"change":function($event){return _vm.changeIncentive()}},model:{value:(_vm.isIncentive),callback:function ($$v) {_vm.isIncentive=$$v},expression:"isIncentive"}}),_vm._v(" "),(_vm.isIncentive)?_c('p',{staticStyle:{"font-size":"11px","font-style":"italic","color":"green","margin":"0px"}},[_vm._v("\n                                **Press ENTER to add more incentive.\n                              ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.incentives),function(inc){return [(_vm.isIncentive)?_c('v-text-field',{key:inc.order + 'per',attrs:{"type":"number","prefix":"%","label":'Incentive ' + inc.order + '.'},on:{"keydown":function($event){return _vm.addIncentive($event, inc)}},model:{value:(inc.percentage),callback:function ($$v) {_vm.$set(inc, "percentage", $$v)},expression:"inc.percentage"}}):_vm._e()]})],2),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"label":"Is GST applicable on Extra Charges?"},model:{value:(_vm.gstOnExtraChanrges),callback:function ($$v) {_vm.gstOnExtraChanrges=$$v},expression:"gstOnExtraChanrges"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-autocomplete',{attrs:{"items":_vm.extraChargesSample,"label":"Extra Charges","item-text":"name","return-object":true,"multiple":""},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addCharges($event)}},model:{value:(_vm.extraCharges),callback:function ($$v) {_vm.extraCharges=$$v},expression:"extraCharges"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_vm._l((_vm.extraCharges),function(ext,index){return [_c('v-flex',{key:'name' + index,attrs:{"xs2":""}},[_c('v-text-field',{attrs:{"type":"text","label":"Charge Name"},model:{value:(ext.name),callback:function ($$v) {_vm.$set(ext, "name", $$v)},expression:"ext.name"}})],1),_vm._v(" "),(_vm.gstOnExtraChanrges)?_c('v-flex',{key:'gst1' + index,attrs:{"xs2":""}},[_c('v-select',{key:'gst' + index,attrs:{"type":"number","dense":"","items":[3, 5, 12, 18, 28],"label":"GST"},model:{value:(ext.gst),callback:function ($$v) {_vm.$set(ext, "gst", $$v)},expression:"ext.gst"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{key:'amt1' + index,attrs:{"xs2":""}},[_c('v-text-field',{key:'amt' + index,attrs:{"type":"number","label":"Taxable Amount"},model:{value:(ext.amount),callback:function ($$v) {_vm.$set(ext, "amount", $$v)},expression:"ext.amount"}})],1),_vm._v(" "),(_vm.gstOnExtraChanrges)?_c('v-flex',{key:'gstamt1' + index,attrs:{"xs2":""}},[_c('v-text-field',{key:'gstamt' + index,attrs:{"type":"number","disabled":"","label":"GST Amount"},model:{value:(ext.gstAmount),callback:function ($$v) {_vm.$set(ext, "gstAmount", $$v)},expression:"ext.gstAmount"}})],1):_vm._e(),_vm._v(" "),(_vm.gstOnExtraChanrges)?_c('v-flex',{key:'total1' + index,attrs:{"xs2":""}},[_c('v-text-field',{key:'total' + index,attrs:{"disabled":"","type":"number","value":Number.parseFloat(ext.amount) +
                                        Number.parseFloat(ext.gstAmount),"label":"Total Amount"}})],1):_vm._e()]})],2)],1)],2)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","s12":"","md4":""}},[_c('v-expansion-panel',{staticClass:"invoiceExpansion"},[_c('v-expansion-panel-content',{attrs:{"value":_vm.expansionVal},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('div',[_c('v-card-title',[_c('h3',{staticClass:"\n                                title\n                                font-weight-light\n                                primary\n                                white--text\n                              "},[_vm._v("\n                              Invoice Details\n                            ")])])],1)]},proxy:true}])},[_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"margin-top":"1px"},attrs:{"xs12":"","sm6":"","md6":""}},[_c('h3',{staticClass:"primary--text"},[_vm._v("Taxable Amount")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{staticStyle:{"margin-top":"-20px"},attrs:{"readonly":"","value":(
                                    Number.parseFloat(_vm.totalAmount) +
                                    Number.parseFloat(_vm.discountAmount) +
                                    (_vm.gstOnExtraChanrges
                                      ? 0
                                      : -Number.parseFloat(
                                          _vm.totalExtraCharges
                                        )) -
                                    Number.parseFloat(_vm.roundOffAmount) -
                                    (Number.parseFloat(_vm.getCGSTAmount) +
                                      Number.parseFloat(_vm.getSGSTAmount) +
                                      Number.parseFloat(_vm.getIGSTAmount))
                                  ).toFixed(2),"type":"number"}})],1),_vm._v(" "),(_vm.gstInvoice)?_c('v-flex',{staticStyle:{"margin-top":"-5px"},attrs:{"xs12":"","sm6":"","md6":""}},[_c('h3',{staticClass:"primary--text"},[_vm._v("CGST Amount")])]):_vm._e(),_vm._v(" "),(_vm.gstInvoice)?_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs12":"","s6":"","md6":""}},[_c('v-text-field',{staticStyle:{"margin-top":"-20px"},attrs:{"readonly":"","value":_vm.getCGSTAmount,"type":"number"}})],1):_vm._e(),_vm._v(" "),(_vm.gstInvoice)?_c('v-flex',{staticStyle:{"margin-top":"-5px"},attrs:{"xs12":"","sm6":"","md6":""}},[_c('h3',{staticClass:"primary--text"},[_vm._v("SGST Amount")])]):_vm._e(),_vm._v(" "),(_vm.gstInvoice)?_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs12":"","s6":"","md6":""}},[_c('v-text-field',{staticStyle:{"margin-top":"-20px"},attrs:{"readonly":"","value":_vm.getSGSTAmount,"type":"number"}})],1):_vm._e(),_vm._v(" "),(_vm.gstInvoice)?_c('v-flex',{staticStyle:{"margin-top":"-5px"},attrs:{"xs12":"","sm6":"","md6":""}},[_c('h3',{staticClass:"primary--text"},[_vm._v("IGST Amount")])]):_vm._e(),_vm._v(" "),(_vm.gstInvoice)?_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs12":"","s6":"","md6":""}},[_c('v-text-field',{staticStyle:{"margin-top":"-20px"},attrs:{"readonly":"","value":_vm.getIGSTAmount,"type":"number"}})],1):_vm._e(),_vm._v(" "),(!_vm.gstOnExtraChanrges)?[_vm._l((_vm.extraCharges),function(ext,index){return [_c('v-flex',{key:'extraname' + index,staticStyle:{"margin-top":"-5px"},attrs:{"xs12":"","sm6":"","md6":""}},[_c('h3',{staticClass:"primary--text"},[_vm._v("\n                                    "+_vm._s(ext.name)+"\n                                  ")])]),_vm._v(" "),_c('v-flex',{key:'extraamount' + index,staticStyle:{"display":"inline-flex"},attrs:{"xs12":"","s6":"","md6":""}},[_c('v-text-field',{staticStyle:{"margin-top":"-20px"},attrs:{"readonly":"","type":"number"},model:{value:(ext.amount),callback:function ($$v) {_vm.$set(ext, "amount", $$v)},expression:"ext.amount"}})],1)]})]:_vm._e(),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"-5px"},attrs:{"xs12":"","sm6":"","md6":""}},[_c('h3',{staticClass:"primary--text"},[_vm._v("Discount")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs12":"","s6":"","md6":""}},[_c('v-text-field',{staticStyle:{"margin-top":"-20px"},attrs:{"readonly":"","type":"number"},model:{value:(_vm.discountAmount),callback:function ($$v) {_vm.discountAmount=$$v},expression:"discountAmount"}})],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"-5px"},attrs:{"xs12":"","sm6":"","md6":""}},[_c('h3',{staticClass:"primary--text"},[_vm._v("Round Off")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs12":"","s6":"","md6":""}},[_c('v-text-field',{staticStyle:{"margin-top":"-20px"},attrs:{"readonly":"","type":"number"},model:{value:(_vm.roundOffAmount),callback:function ($$v) {_vm.roundOffAmount=$$v},expression:"roundOffAmount"}})],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"-5px"},attrs:{"xs12":"","sm6":"","md6":""}},[_c('h3',{staticClass:"primary--text"},[_vm._v("Invoice Amount")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs12":"","s6":"","md6":""}},[_c('v-text-field',{staticStyle:{"margin-top":"-20px"},attrs:{"type":"number","readonly":"","value":Number.parseFloat(_vm.totalAmount).toFixed(2)}})],1)],2)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","s12":"","md12":""}},[_c('v-expansion-panel',{staticClass:"invoiceExpansion"},[_c('v-expansion-panel-content',{staticClass:"extra-detail",scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('v-card-title',[_c('h3',{staticClass:"\n                              title\n                              font-weight-light\n                              primary\n                              white--text\n                            "},[_vm._v("\n                            Extra Details\n                          ")])])]},proxy:true}])},[_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","s12":"","md4":""}},[_c('v-text-field',{attrs:{"type":"text","label":"Order Number","prefix":""},model:{value:(_vm.orderNumber),callback:function ($$v) {_vm.orderNumber=$$v},expression:"orderNumber"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.orderDatepicker),callback:function ($$v) {_vm.orderDatepicker=$$v},expression:"orderDatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Order Date","readonly":""},slot:"activator",model:{value:(_vm.orderDate),callback:function ($$v) {_vm.orderDate=$$v},expression:"orderDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.orderDatepicker = false}},model:{value:(_vm.orderDate),callback:function ($$v) {_vm.orderDate=$$v},expression:"orderDate"}})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.sanctionDatepicker),callback:function ($$v) {_vm.sanctionDatepicker=$$v},expression:"sanctionDatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Sanction Date","readonly":""},slot:"activator",model:{value:(_vm.sanctionDate),callback:function ($$v) {_vm.sanctionDate=$$v},expression:"sanctionDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.sanctionDatepicker = false}},model:{value:(_vm.sanctionDate),callback:function ($$v) {_vm.sanctionDate=$$v},expression:"sanctionDate"}})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-text-field',{attrs:{"type":"text","label":"Application Number","prefix":""},model:{value:(_vm.applicationNumber),callback:function ($$v) {_vm.applicationNumber=$$v},expression:"applicationNumber"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{staticClass:"primary--text font-weight-bold",attrs:{"outline":"","flat":""},nativeOn:{"click":function($event){_vm.transactionDialog = true}}},[_vm._v("View Transaction Summary\n                              ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[(_vm.gstInvoice)?_c('v-text-field',{attrs:{"readonly":"","value":_vm.GST_Percentage_total.GST_3,"type":"number","label":"Total GST(3%)"}}):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.gstInvoice)?_c('v-text-field',{attrs:{"readonly":"","value":_vm.GST_Percentage_total.GST_5,"type":"number","label":"Total GST(5%)"}}):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.gstInvoice)?_c('v-text-field',{attrs:{"readonly":"","value":_vm.GST_Percentage_total.GST_12,"type":"number","label":"Total GST(12%)"}}):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.gstInvoice)?_c('v-text-field',{attrs:{"readonly":"","value":_vm.GST_Percentage_total.GST_18,"type":"number","label":"Total GST(18%)"}}):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.gstInvoice)?_c('v-text-field',{attrs:{"readonly":"","value":_vm.GST_Percentage_total.GST_28,"type":"number","label":"Total GST(28%)"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-select',{attrs:{"dense":"","readonly":"","items":[
                                  {
                                    text: 'Cash',
                                    value: 'Cash',
                                  },
                                  {
                                    text: 'Bank Account',
                                    value: 'Bank Account',
                                  },
                                  {
                                    text: 'Cash & Bank Account',
                                    value: 'CashAndBank Account',
                                  } ],"label":"Select Payment Type"},on:{"change":function($event){return _vm.resetAmounts()}},model:{value:(_vm.paymentType),callback:function ($$v) {_vm.paymentType=$$v},expression:"paymentType"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-text-field',{attrs:{"readonly":"","type":"number","disabled":_vm.amountFromCashDisabled,"label":"Amount from Cash"},model:{value:(_vm.amountFromCash),callback:function ($$v) {_vm.amountFromCash=$$v},expression:"amountFromCash"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-text-field',{attrs:{"readonly":"","type":"number","disabled":_vm.amountFromBankDisabled,"label":"Amount from Bank"},model:{value:(_vm.amountFromBank),callback:function ($$v) {_vm.amountFromBank=$$v},expression:"amountFromBank"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-text-field',{attrs:{"type":"number","label":"Paid Amount (in ₹)","readonly":"","prefix":""},model:{value:(_vm.paidAmount),callback:function ($$v) {_vm.paidAmount=$$v},expression:"paidAmount"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-text-field',{attrs:{"type":"number","label":"Remaining Amount (in ₹)","readonly":"","prefix":""},model:{value:(_vm.remainingAmount),callback:function ($$v) {_vm.remainingAmount=$$v},expression:"remainingAmount"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-select',{attrs:{"readonly":"","dense":"","items":[
                                  {
                                    text: 'Due',
                                    value: 'Debit',
                                  },
                                  {
                                    text: 'Partial Paid',
                                    value: 'Partial Paid',
                                  },
                                  {
                                    text: 'Full Paid',
                                    value: 'Credit',
                                  } ],"label":"Select Transaction type"},on:{"change":function($event){return _vm.resetAmounts()}},model:{value:(_vm.transactionType),callback:function ($$v) {_vm.transactionType=$$v},expression:"transactionType"}})],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),(this.firmSetting && this.firmSetting.ewayBill)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","s12":"","md12":""}},[_c('v-expansion-panel',{staticClass:"invoiceExpansion"},[_c('v-expansion-panel-content',{staticClass:"e-way-bill",scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('v-card-title',[_c('h3',{staticClass:"\n                              title\n                              font-weight-light\n                              primary\n                              white--text\n                            "},[_vm._v("\n                            Transport Details\n                          ")])])]},proxy:true}],null,false,1450844085)},[_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('eway-bill',{attrs:{"invoiceData":_vm.invoiceDraft,"bank":_vm.bankById[_vm.selectedBank],"firm":_vm.firmById[_vm.selectedFirm],"selectedBuyer":_vm.selectedBuyer,"isBuyer":_vm.isBuyer,"ewayBillDetails":_vm.invoiceDraft.ewayBillDetails,"termsAndConditions":_vm.getTermsAndConditions(),"gstTotal":_vm.GST_Val_total},on:{"ewayBillSave":_vm.ewayBillSave}})],1)],1)],1)],1)],1)],1):_vm._e()],1)],1)],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"top":"","color":"success","timeout":3000},model:{value:(_vm.snackbarSuccess),callback:function ($$v) {_vm.snackbarSuccess=$$v},expression:"snackbarSuccess"}},[_vm._v("\n      New invoice Created!\n    ")])],1),_vm._v(" "),_c('v-snackbar',{scopedSlots:_vm._u([{key:"action",fn:function(ref){
                                var attrs = ref.attrs;
return [_c('v-btn',_vm._b({attrs:{"color":"red","text":""},on:{"click":function($event){_vm.snackbar = false}}},'v-btn',attrs,false),[_vm._v("\n        Close\n      ")])]}}]),model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.snackbarMsg)+"\n    ")]),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"500"},model:{value:(_vm.otpData.dialog),callback:function ($$v) {_vm.$set(_vm.otpData, "dialog", $$v)},expression:"otpData.dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Please enter OTP that has been sent to mobile\n          "+_vm._s(_vm.otpData.mobile)+" to save invoice.")])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"type":"number","label":"OTP"},model:{value:(_vm.otpData.confirmOtp),callback:function ($$v) {_vm.$set(_vm.otpData, "confirmOtp", $$v)},expression:"otpData.confirmOtp"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text",attrs:{"primary":"","title":"","flat":"flat"},on:{"click":_vm.confirmOTP}},[_vm._v("\n          Confirm\n        ")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"800"},model:{value:(_vm.buyerDialog),callback:function ($$v) {_vm.buyerDialog=$$v},expression:"buyerDialog"}},[_c('v-card',[_c('v-toolbar',{attrs:{"card":"","dark":"","color":"primary"}},[_c('v-toolbar-title',[_vm._v("Update User")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.buyerDialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),(_vm.selectedBuyer)?_c('v-card-text',[_c('buyer-info',{attrs:{"firms":_vm.firms,"buyers":_vm.buyers,"sellers":_vm.sellers,"isBuyer":_vm.isBuyer,"buyerIdProvided":_vm.selectedBuyer['.key']}})],1):_vm._e(),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.buyerDialog = false}}},[_vm._v("Close")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":""},model:{value:(_vm.addProductDialog),callback:function ($$v) {_vm.addProductDialog=$$v},expression:"addProductDialog"}},[_c('add-product',{attrs:{"currentProduct":_vm.currentProduct,"stepperValue":_vm.stepperValue},on:{"saveProduct":function($event){return _vm.saveProduct()},"close":function($event){_vm.addProductDialog = false}}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.billingDetailsDialog),callback:function ($$v) {_vm.billingDetailsDialog=$$v},expression:"billingDetailsDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Mailing Information ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.billingDetailsDialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Billing Name"},model:{value:(_vm.billingDetails.name),callback:function ($$v) {_vm.$set(_vm.billingDetails, "name", $$v)},expression:"billingDetails.name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Mobile"},model:{value:(_vm.billingDetails.mobile),callback:function ($$v) {_vm.$set(_vm.billingDetails, "mobile", $$v)},expression:"billingDetails.mobile"}}),_vm._v(" "),_c('v-textarea',{attrs:{"box":"","label":"Address"},model:{value:(_vm.billingDetails.address),callback:function ($$v) {_vm.$set(_vm.billingDetails, "address", $$v)},expression:"billingDetails.address"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){return _vm.saveBillingData()}}},[_vm._v("Confirm")])],1)],1)],1),_vm._v(" "),_c('iframe',{attrs:{"id":"printPdf","name":"printPdf"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoiceUpdate_vue__ = __webpack_require__(501);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_137896a2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoiceUpdate_vue__ = __webpack_require__(1503);
function injectStyle (ssrContext) {
  __webpack_require__(1502)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoiceUpdate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_137896a2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoiceUpdate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1502 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-card',{attrs:{"flat":""}},[_c('p',{staticStyle:{"font-size":"11px","font-style":"italic","color":"green","margin":"0px"}},[_vm._v("\n              **"),_c('b',[_vm._v("Select Customer")]),_vm._v(" and press "),_c('b',[_vm._v("[ Ctrl + f ")]),_vm._v(" to Switch ] "),_c('b',[_vm._v("[ Ctrl + i ")]),_vm._v(" to add New Items ] "),_c('b',[_vm._v(" [Ctrl + p")]),_vm._v(" to Save and Print Invoice.] & "),_c('b',[_vm._v("[Ctrl + s")]),_vm._v(" to Save Invoice.]\n            ")]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{staticStyle:{"margin-top":"-30px"},attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-switch',{attrs:{"disabled":"","label":("" + (_vm.isBuyer ? 'Sale Invoice' : 'Purchase Invoice'))},model:{value:(_vm.isBuyer),callback:function ($$v) {_vm.isBuyer=$$v},expression:"isBuyer"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.isBuyer ? _vm.buyersByBrand : _vm.sellersByBrand,"label":_vm.isBuyer ? 'Select or add Buyer' : 'Select or add Seller',"disabled":"","autocomplete":"","item-text":"name","return-object":""},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addCustomer($event)}},model:{value:(_vm.selectedBuyer),callback:function ($$v) {_vm.selectedBuyer=$$v},expression:"selectedBuyer"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-text-field',{attrs:{"prefix":"#","label":"Invoice Number","placeholder":"Invoice Number"},model:{value:(_vm.invoiceId),callback:function ($$v) {_vm.invoiceId=$$v},expression:"invoiceId"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker),callback:function ($$v) {_vm.datepicker=$$v},expression:"datepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.invoiceDate),callback:function ($$v) {_vm.invoiceDate=$$v},expression:"invoiceDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepicker = false}},model:{value:(_vm.invoiceDate),callback:function ($$v) {_vm.invoiceDate=$$v},expression:"invoiceDate"}})],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm1":"","md1":""}},[_c('v-text-field',{attrs:{"prefix":"#","label":"Alert (in Days)"},model:{value:(_vm.alertDuration),callback:function ($$v) {_vm.alertDuration=$$v},expression:"alertDuration"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"12px","text-decoration":"none"},attrs:{"xs12":"","sm1":"","md1":""}},[_c('v-btn',{staticClass:"primary white--text",attrs:{"icon":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',[_vm._v("\n                      mdi-close\n                    ")])],1)],1)],1)],1),_vm._v(" "),(
                !(
                  new Date(_vm.invoiceDate).getTime() >= _vm.finYear.start &&
                  new Date(_vm.invoiceDate).getTime() <= _vm.finYear.end
                )
              )?_c('h3',{staticClass:"error--text text--darken-4"},[_vm._v("\n              This invoice is not in current financial year.\n            ")]):_vm._e(),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.getHeaders,"items":_vm.items,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.productName))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.rate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.unit))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.quantity))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.basicPrice))]),_vm._v(" "),(_vm.gstInvoice)?_c('td',[_vm._v(_vm._s(props.item.GSTValue))]):_vm._e(),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.tradeDiscount))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.specialCharge))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.totlePrice))]),_vm._v(" "),(_vm.gstInvoice)?_c('td',[_vm._v("\n                  "+_vm._s(props.item.CGST_val)+" ₹ ("+_vm._s(props.item.CGST)+" %)\n                ")]):_vm._e(),_vm._v(" "),(_vm.gstInvoice)?_c('td',[_vm._v("\n                  "+_vm._s(props.item.SGST_val)+" ₹ ("+_vm._s(props.item.SGST)+" %)\n                ")]):_vm._e(),_vm._v(" "),(_vm.gstInvoice)?_c('td',[_vm._v("\n                  "+_vm._s(props.item.IGST_val)+" ₹ ("+_vm._s(props.item.IGST)+" %)\n                ")]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"justify-center layout px-0"},[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editItem(props.item, false)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteItem(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2),_vm._v(" "),(_vm.selectedBuyer && _vm.selectedFirm)?_c('v-card-actions',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"1200px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[(_vm.businessType == 'Jwellery')?[_c('v-btn',{staticClass:"primary white--text",attrs:{"slot":"activator","flat":""},on:{"click":function($event){return _vm.focusAddProduct()}},slot:"activator"},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("add")]),_vm._v("\n                        New Item\n                      ")],1),_vm._v(" "),_c('add-item-jewl',{attrs:{"editedItem":_vm.editedItem,"buyer":_vm.selectedBuyer  || null,"allItems":_vm.items,"isEditItems":_vm.isEditItems,"gstInvoice":_vm.gstInvoice,"selectedFirm":_vm.selectedFirm,"isBuyer":_vm.isBuyer,"isRoundOff":_vm.firmSetting && _vm.firmSetting.roundOff},on:{"closeAddItem":_vm.close,"saveAddItem":_vm.save,"editItem":_vm.editItem,"deleteItem":_vm.deleteItem,"addProduct":_vm.addProduct}})]:(_vm.businessType == 'Grain')?[_c('v-btn',{staticClass:"primary white--text",attrs:{"slot":"activator","flat":""},on:{"click":function($event){return _vm.focusAddProduct()}},slot:"activator"},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("add")]),_vm._v("\n                        New Item\n                      ")],1),_vm._v(" "),_c('add-item-grain',{attrs:{"editedItem":_vm.editedItem,"buyer":_vm.selectedBuyer  || null,"allItems":_vm.items,"isEditItems":_vm.isEditItems,"gstInvoice":_vm.gstInvoice,"selectedFirm":_vm.selectedFirm,"isBuyer":_vm.isBuyer,"isRoundOff":_vm.firmSetting && _vm.firmSetting.roundOff},on:{"closeAddItem":_vm.close,"saveAddItem":_vm.save,"editItem":_vm.editItem,"deleteItem":_vm.deleteItem,"addProduct":_vm.addProduct}})]:(_vm.businessType == 'Clothes')?[_c('v-btn',{staticClass:"primary white--text",attrs:{"slot":"activator","flat":""},slot:"activator"},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("add")]),_vm._v("\n                        New Item\n                      ")],1),_vm._v(" "),_c('add-item-clothes',{attrs:{"editedItem":_vm.editedItem,"buyer":_vm.selectedBuyer  || null,"allItems":_vm.items,"isEditItems":_vm.isEditItems,"gstInvoice":_vm.gstInvoice,"selectedFirm":_vm.selectedFirm,"isBuyer":_vm.isBuyer,"isRoundOff":_vm.firmSetting && _vm.firmSetting.roundOff},on:{"closeAddItem":_vm.close,"saveAddItem":_vm.save,"editItem":_vm.editItem,"deleteItem":_vm.deleteItem,"addProduct":_vm.addProduct}})]:(_vm.businessType == 'Dairy')?[_c('v-btn',{staticClass:"primary white--text",staticStyle:{"margin-top":"10px"},attrs:{"slot":"activator","flat":""},on:{"click":function($event){return _vm.focusAddProduct()}},slot:"activator"},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("add")]),_vm._v("\n                        New Item\n                      ")],1),_vm._v(" "),_c('add-item-dairy',{attrs:{"editedItem":_vm.editedItem,"buyer":_vm.selectedBuyer  || null,"allItems":_vm.items,"isEditItems":_vm.isEditItems,"gstInvoice":_vm.gstInvoice,"selectedFirm":_vm.selectedFirm,"isBuyer":_vm.isBuyer,"firmSetting":_vm.firmSetting,"invoiceDate":_vm.invoiceDate,"godawn":_vm.godawnBy},on:{"closeAddItem":_vm.close,"saveAddItem":_vm.save,"editItem":_vm.editItem,"deleteItem":_vm.deleteItem,"addProduct":_vm.addProduct}})]:(_vm.businessType == 'Default')?[_c('v-btn',{staticClass:"primary white--text",staticStyle:{"margin-top":"10px"},attrs:{"slot":"activator","flat":""},on:{"click":function($event){return _vm.focusAddProduct()}},slot:"activator"},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("add")]),_vm._v("\n                        New Item\n                      ")],1),_vm._v(" "),_c('add-item-default',{attrs:{"editedItem":_vm.editedItem,"buyer":_vm.selectedBuyer  || null,"allItems":_vm.items,"isEditItems":_vm.isEditItems,"gstInvoice":_vm.gstInvoice,"selectedFirm":_vm.selectedFirm,"isBuyer":_vm.isBuyer,"isRoundOff":_vm.firmSetting && _vm.firmSetting.roundOff},on:{"closeAddItem":_vm.close,"saveAddItem":_vm.save,"editItem":_vm.editItem,"deleteItem":_vm.deleteItem,"addProduct":_vm.addProduct}})]:(_vm.businessType == 'Automobile/Agriculture/Spare Parts')?[_c('v-btn',{staticClass:"primary white--text",attrs:{"slot":"activator","flat":""},slot:"activator"},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("add")]),_vm._v("\n                        New Item\n                      ")],1),_vm._v(" "),_c('add-item-auto',{attrs:{"editedItem":_vm.editedItem,"buyer":_vm.selectedBuyer  || null,"allItems":_vm.items,"isEditItems":_vm.isEditItems,"gstInvoice":_vm.gstInvoice,"selectedFirm":_vm.selectedFirm,"isBuyer":_vm.isBuyer,"isRoundOff":_vm.firmSetting && _vm.firmSetting.roundOff},on:{"closeAddItem":_vm.close,"saveAddItem":_vm.save,"editItem":_vm.editItem,"deleteItem":_vm.deleteItem,"addProduct":_vm.addProduct}})]:[_c('v-btn',{staticClass:"primary white--text",attrs:{"slot":"activator","flat":""},slot:"activator"},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("add")]),_vm._v("\n                        New Item\n                      ")],1),_vm._v(" "),_c('add-item-med',{attrs:{"editedItem":_vm.editedItem,"buyer":_vm.selectedBuyer  || null,"dialog":_vm.dialog,"allItems":_vm.items,"isEditItems":_vm.isEditItems,"gstInvoice":_vm.gstInvoice,"selectedFirm":_vm.selectedFirm,"isBuyer":_vm.isBuyer,"isRoundOff":_vm.firmSetting && _vm.firmSetting.roundOff},on:{"closeAddItem":_vm.close,"saveAddItem":_vm.save,"editItem":_vm.editItem,"deleteItem":_vm.deleteItem,"addProduct":_vm.addProduct}})]],2)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-btn',{staticClass:"warning white--text",staticStyle:{"margin-top":"10px"},attrs:{"flat":""},on:{"click":function($event){_vm.billingDetailsDialog = true}}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("\n                      add\n                    ")]),_vm._v("\n                      Mailing Info\n                    ")],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-select',{attrs:{"label":'Select Product Set',"item-text":"name","clearable":"","items":_vm.ProductSetByBrand,"return-object":""},on:{"change":_vm.selectProductSet},model:{value:(_vm.selectedProductSet),callback:function ($$v) {_vm.selectedProductSet=$$v},expression:"selectedProductSet"}})],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.selectedFirm && _vm.transactionType && _vm.items.length)?_c('v-card-actions',[_c('v-menu',{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
              var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"warning white--text",attrs:{"flat":""}},on),[_vm._v("\n                      Print Preview\n                    ")])]}}],null,false,4083265775)},[_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.printInvoice4(false)}}},[_c('v-list-tile-title',[_vm._v("Simple Print")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.basicInvoicePrint(true)}}},[_c('v-list-tile-title',[_vm._v("Basic Print")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.basicInvoicePrint(false)}}},[_c('v-list-tile-title',[_vm._v("Detailed Print")])],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
              var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"primary white--text",attrs:{"flat":""}},on),[_vm._v("\n                      Save & Print\n                    ")])]}}],null,false,3743709348)},[_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.printInvoice4(true)}}},[_c('v-list-tile-title',[_vm._v("Simple Print")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.saveAndPrint(true)}}},[_c('v-list-tile-title',[_vm._v("Basic Print")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.saveAndPrint(false)}}},[_c('v-list-tile-title',[_vm._v("Detail Print")])],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"success white--text",attrs:{"flat":""},nativeOn:{"click":function($event){return _vm.saveInvoice()}}},[_vm._v("Save Invoice")])],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.transactionDialog),callback:function ($$v) {_vm.transactionDialog=$$v},expression:"transactionDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("\n                    Payment Details: \n                  ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.transactionDialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Total Amount (in ₹)","readonly":"","value":_vm.totalAmount,"prefix":""}}),_vm._v(" "),_c('v-select',{attrs:{"dense":"","items":[
                            {
                              text: 'Cash',
                              value: 'Cash',
                            },
                            {
                              text: 'Bank Account',
                              value: 'Bank Account',
                            },
                            {
                              text: 'Cash & Bank Account',
                              value: 'CashAndBank Account',
                            } ],"label":"Select Payment Type"},on:{"change":function($event){return _vm.resetAmounts()}},model:{value:(_vm.paymentType),callback:function ($$v) {_vm.paymentType=$$v},expression:"paymentType"}}),_vm._v(" "),(
                            ['Bank Account', 'CashAndBank Account'].includes(
                              _vm.paymentType
                            )
                          )?_c('v-select',{attrs:{"dense":"","items":_vm.banksByFirms,"label":"Select Bank","disabled":_vm.paymentType == 'Cash' || _vm.paymentType == ''},model:{value:(_vm.selectedBank),callback:function ($$v) {_vm.selectedBank=$$v},expression:"selectedBank"}}):_vm._e(),_vm._v(" "),(
                            ['Bank Account', 'CashAndBank Account'].includes(
                              _vm.paymentType
                            )
                          )?_c('v-select',{attrs:{"dense":"","disabled":_vm.paymentType == 'Cash' || _vm.paymentType == '',"items":[
                            {
                              text: 'Cheque',
                              value: 'Cheque',
                            },
                            {
                              text: 'NEFT',
                              value: 'NEFT',
                            },
                            {
                              text: 'RTGS',
                              value: 'RTGS',
                            },
                            {
                              text: 'IMPS',
                              value: 'IMPS',
                            } ],"label":"Select Transfer type"},on:{"input":function($event){_vm.transferTypeDialog = true}},model:{value:(_vm.transferType),callback:function ($$v) {_vm.transferType=$$v},expression:"transferType"}}):_vm._e(),_vm._v(" "),(!['Bank Account'].includes(_vm.paymentType))?_c('v-text-field',{attrs:{"type":"number","disabled":_vm.amountFromCashDisabled,"label":"Amount from Cash"},model:{value:(_vm.amountFromCash),callback:function ($$v) {_vm.amountFromCash=$$v},expression:"amountFromCash"}}):_vm._e(),_vm._v(" "),(
                            ['Bank Account', 'CashAndBank Account'].includes(
                              _vm.paymentType
                            )
                          )?_c('v-text-field',{attrs:{"type":"number","disabled":_vm.amountFromBankDisabled,"label":"Amount from Bank"},model:{value:(_vm.amountFromBank),callback:function ($$v) {_vm.amountFromBank=$$v},expression:"amountFromBank"}}):_vm._e(),_vm._v(" "),(_vm.remainingAmount > 0)?_c('v-text-field',{attrs:{"type":"number","label":"Remaining Amount (in ₹)","readonly":"","prefix":""},model:{value:(_vm.remainingAmount),callback:function ($$v) {_vm.remainingAmount=$$v},expression:"remainingAmount"}}):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","disabled":!_vm.paymentType,"flat":""},nativeOn:{"click":function($event){_vm.transactionDialog = false}}},[_vm._v("Confirm")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.transferTypeDialog),callback:function ($$v) {_vm.transferTypeDialog=$$v},expression:"transferTypeDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("\n                    Transfer Information\n                    "),_c('b',[_vm._v(_vm._s(_vm.transferType))])])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","label":"A/C Number"},model:{value:(_vm.transferDetails.accountNumber),callback:function ($$v) {_vm.$set(_vm.transferDetails, "accountNumber", $$v)},expression:"transferDetails.accountNumber"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"text","label":"A/C Holder Name"},model:{value:(_vm.transferDetails.accountHolderName),callback:function ($$v) {_vm.$set(_vm.transferDetails, "accountHolderName", $$v)},expression:"transferDetails.accountHolderName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"text","label":"Bank Name"},model:{value:(_vm.transferDetails.bankName),callback:function ($$v) {_vm.$set(_vm.transferDetails, "bankName", $$v)},expression:"transferDetails.bankName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"text","label":"IFSC Code"},model:{value:(_vm.transferDetails.IFSCcode),callback:function ($$v) {_vm.$set(_vm.transferDetails, "IFSCcode", $$v)},expression:"transferDetails.IFSCcode"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"text","label":"Remark"},model:{value:(_vm.transferDetails.remark),callback:function ($$v) {_vm.$set(_vm.transferDetails, "remark", $$v)},expression:"transferDetails.remark"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){_vm.transferTypeDialog = false}}},[_vm._v("Ok")])],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"dense":"","flat":"","row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","s12":"","md8":""}},[_c('v-expansion-panel',{staticClass:"invoiceExpansion"},[_c('v-expansion-panel-content',{attrs:{"value":_vm.expansionVal},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('v-card-title',[_c('h3',{staticClass:"title font-weight-light primary white--text"},[_vm._v("\n                            Basic Details\n                          ")])])]},proxy:true}])},[_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"label":"Total Item","readonly":"","value":_vm.totalItems}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-select',{attrs:{"dense":"","disabled":!_vm.items.length,"items":[
                                  {
                                    text: 'Due',
                                    value: 'Debit',
                                  },
                                  {
                                    text: 'Partial Paid',
                                    value: 'Partial Paid',
                                  },
                                  {
                                    text: 'Full Paid',
                                    value: 'Credit',
                                  } ],"label":"Select Transaction type"},on:{"change":function($event){return _vm.resetAmounts()}},model:{value:(_vm.transactionType),callback:function ($$v) {_vm.transactionType=$$v},expression:"transactionType"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Discount (in ₹)"},model:{value:(_vm.discountAmount),callback:function ($$v) {_vm.discountAmount=$$v},expression:"discountAmount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Round Off (in ₹)"},model:{value:(_vm.roundOffAmount),callback:function ($$v) {_vm.roundOffAmount=$$v},expression:"roundOffAmount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.staffByBrand,"label":"Sold By"},model:{value:(_vm.soldBy),callback:function ($$v) {_vm.soldBy=$$v},expression:"soldBy"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"type":"Number","label":"Brokerage Rate (in %)"},model:{value:(_vm.brokerageRate),callback:function ($$v) {_vm.brokerageRate=$$v},expression:"brokerageRate"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Brokerage Amount (in ₹)","disabled":"","value":Number.parseFloat(
                                    (Number.parseFloat(_vm.totalAmount) *
                                      _vm.brokerageRate) /
                                      100
                                  ).toFixed(2)}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.gState,"label":"Place of Supply","item-text":"state"},model:{value:(_vm.placeOfSupply),callback:function ($$v) {_vm.placeOfSupply=$$v},expression:"placeOfSupply"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-textarea',{attrs:{"background-color":"grey darken-1","color":"black","box":"","label":"Delivery Terms"},model:{value:(_vm.remark),callback:function ($$v) {_vm.remark=$$v},expression:"remark"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-switch',{attrs:{"label":"Incentive"},on:{"change":function($event){return _vm.changeIncentive()}},model:{value:(_vm.isIncentive),callback:function ($$v) {_vm.isIncentive=$$v},expression:"isIncentive"}}),_vm._v(" "),(_vm.isIncentive)?_c('p',{staticStyle:{"font-size":"11px","font-style":"italic","color":"green","margin":"0px"}},[_vm._v("\n                                **Press enter to add more incentive.\n                              ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.incentives),function(inc){return [(_vm.isIncentive)?_c('v-text-field',{key:inc.order+'per',attrs:{"type":"number","prefix":"%","label":'Incentive ' +inc.order+'.'},on:{"keydown":function($event){return _vm.addIncentive($event,inc)}},model:{value:(inc.percentage),callback:function ($$v) {_vm.$set(inc, "percentage", $$v)},expression:"inc.percentage"}}):_vm._e()]})],2),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md4":""}},[_c('v-autocomplete',{attrs:{"items":_vm.extraChargesSample,"label":"Extra Charges","item-text":"name","return-object":true,"multiple":""},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addCharges($event)}},model:{value:(_vm.extraCharges),callback:function ($$v) {_vm.extraCharges=$$v},expression:"extraCharges"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"wrap":""}},[_vm._l((_vm.extraCharges),function(ext,index){return [_c('v-flex',{key:'name'+index,attrs:{"xs6":""}},[_c('v-text-field',{attrs:{"type":"text","label":"Charge Name"},model:{value:(ext.name),callback:function ($$v) {_vm.$set(ext, "name", $$v)},expression:"ext.name"}})],1),_vm._v(" "),_c('v-flex',{key:'amount'+index,attrs:{"xs6":""}},[_c('v-text-field',{key:'amt'+index,attrs:{"type":"number","label":"Amount"},model:{value:(ext.amount),callback:function ($$v) {_vm.$set(ext, "amount", $$v)},expression:"ext.amount"}})],1)]})],2)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","s12":"","md4":""}},[_c('v-expansion-panel',{staticClass:"invoiceExpansion"},[_c('v-expansion-panel-content',{attrs:{"value":_vm.expansionVal},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('div',[_c('v-card-title',[_c('h3',{staticClass:"title font-weight-light primary white--text"},[_vm._v("\n                              Invoice Details\n                            ")])])],1)]},proxy:true}])},[_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticStyle:{"margin-top":"1px"},attrs:{"xs12":"","sm6":"","md6":""}},[_c('h3',{staticClass:"primary--text"},[_vm._v("Taxable Amount")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{staticStyle:{"margin-top":"-20px"},attrs:{"readonly":"","value":(
                                    Number.parseFloat(_vm.totalAmount) +
                                    Number.parseFloat(_vm.discountAmount) -
                                    Number.parseFloat(_vm.totalExtraCharges) -
                                    Number.parseFloat(_vm.roundOffAmount) -
                                    (Number.parseFloat(
                                      _vm.GST_Val_total.SGST_val
                                    ) +
                                      Number.parseFloat(
                                        _vm.GST_Val_total.CGST_val
                                      ) +
                                      Number.parseFloat(
                                        _vm.GST_Val_total.IGST_val
                                      ))
                                  ).toFixed(2),"type":"number"}})],1),_vm._v(" "),(_vm.gstInvoice)?_c('v-flex',{staticStyle:{"margin-top":"-5px"},attrs:{"xs12":"","sm6":"","md6":""}},[_c('h3',{staticClass:"primary--text"},[_vm._v("CGST Amount")])]):_vm._e(),_vm._v(" "),(_vm.gstInvoice)?_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs12":"","s6":"","md6":""}},[_c('v-text-field',{staticStyle:{"margin-top":"-20px"},attrs:{"readonly":"","value":_vm.GST_Val_total.CGST_val.toFixed(2),"type":"number"}})],1):_vm._e(),_vm._v(" "),(_vm.gstInvoice)?_c('v-flex',{staticStyle:{"margin-top":"-5px"},attrs:{"xs12":"","sm6":"","md6":""}},[_c('h3',{staticClass:"primary--text"},[_vm._v("SGST Amount")])]):_vm._e(),_vm._v(" "),(_vm.gstInvoice)?_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs12":"","s6":"","md6":""}},[_c('v-text-field',{staticStyle:{"margin-top":"-20px"},attrs:{"readonly":"","value":_vm.GST_Val_total.SGST_val.toFixed(2),"type":"number"}})],1):_vm._e(),_vm._v(" "),(_vm.gstInvoice)?_c('v-flex',{staticStyle:{"margin-top":"-5px"},attrs:{"xs12":"","sm6":"","md6":""}},[_c('h3',{staticClass:"primary--text"},[_vm._v("IGST Amount")])]):_vm._e(),_vm._v(" "),(_vm.gstInvoice)?_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs12":"","s6":"","md6":""}},[_c('v-text-field',{staticStyle:{"margin-top":"-20px"},attrs:{"readonly":"","value":_vm.GST_Val_total.IGST_val.toFixed(2),"type":"number"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"-5px"},attrs:{"xs12":"","sm6":"","md6":""}},[_c('h3',{staticClass:"primary--text"},[_vm._v("Discount")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs12":"","s6":"","md6":""}},[_c('v-text-field',{staticStyle:{"margin-top":"-20px"},attrs:{"readonly":"","type":"number"},model:{value:(_vm.discountAmount),callback:function ($$v) {_vm.discountAmount=$$v},expression:"discountAmount"}})],1),_vm._v(" "),_vm._l((_vm.extraCharges),function(ext,index){return [_c('v-flex',{key:'extraname'+index,staticStyle:{"margin-top":"-5px"},attrs:{"xs12":"","sm6":"","md6":""}},[_c('h3',{staticClass:"primary--text"},[_vm._v(_vm._s(ext.name))])]),_vm._v(" "),_c('v-flex',{key:'extraamount'+index,staticStyle:{"display":"inline-flex"},attrs:{"xs12":"","s6":"","md6":""}},[_c('v-text-field',{staticStyle:{"margin-top":"-20px"},attrs:{"readonly":"","type":"number"},model:{value:(ext.amount),callback:function ($$v) {_vm.$set(ext, "amount", $$v)},expression:"ext.amount"}})],1)]}),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"-5px"},attrs:{"xs12":"","sm6":"","md6":""}},[_c('h3',{staticClass:"primary--text"},[_vm._v("Round Off")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs12":"","s6":"","md6":""}},[_c('v-text-field',{staticStyle:{"margin-top":"-20px"},attrs:{"readonly":"","type":"number"},model:{value:(_vm.roundOffAmount),callback:function ($$v) {_vm.roundOffAmount=$$v},expression:"roundOffAmount"}})],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"-5px"},attrs:{"xs12":"","sm6":"","md6":""}},[_c('h3',{staticClass:"primary--text"},[_vm._v("Invoice Amount")])]),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs12":"","s6":"","md6":""}},[_c('v-text-field',{staticStyle:{"margin-top":"-20px"},attrs:{"type":"number","readonly":"","value":(
                                    Number.parseFloat(_vm.totalAmount)
                                  ).toFixed(2)}})],1)],2)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","s12":"","md12":""}},[_c('v-expansion-panel',{staticClass:"invoiceExpansion"},[_c('v-expansion-panel-content',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('v-card-title',[_c('h3',{staticClass:"title font-weight-light primary white--text"},[_vm._v("\n                              Extra Details\n                            ")])])]},proxy:true}])},[_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","s12":"","md4":""}},[_c('v-text-field',{attrs:{"type":"text","label":"Order Number","prefix":""},model:{value:(_vm.orderNumber),callback:function ($$v) {_vm.orderNumber=$$v},expression:"orderNumber"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.orderDatepicker),callback:function ($$v) {_vm.orderDatepicker=$$v},expression:"orderDatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Order Date","readonly":""},slot:"activator",model:{value:(_vm.orderDate),callback:function ($$v) {_vm.orderDate=$$v},expression:"orderDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.orderDatepicker = false}},model:{value:(_vm.orderDate),callback:function ($$v) {_vm.orderDate=$$v},expression:"orderDate"}})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.sanctionDatepicker),callback:function ($$v) {_vm.sanctionDatepicker=$$v},expression:"sanctionDatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Sanction Date","readonly":""},slot:"activator",model:{value:(_vm.sanctionDate),callback:function ($$v) {_vm.sanctionDate=$$v},expression:"sanctionDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.sanctionDatepicker = false}},model:{value:(_vm.sanctionDate),callback:function ($$v) {_vm.sanctionDate=$$v},expression:"sanctionDate"}})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-text-field',{attrs:{"type":"text","label":"Application Number","prefix":""},model:{value:(_vm.applicationNumber),callback:function ($$v) {_vm.applicationNumber=$$v},expression:"applicationNumber"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-btn',{staticClass:"primary--text font-weight-bold",attrs:{"outline":"","flat":""},nativeOn:{"click":function($event){_vm.transactionDialog = true}}},[_vm._v("View Transaction Summary\n                          ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[(_vm.gstInvoice)?_c('v-text-field',{attrs:{"readonly":"","value":_vm.GST_Percentage_total.GST_3,"type":"number","label":"Total GST(3%)"}}):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.gstInvoice)?_c('v-text-field',{attrs:{"readonly":"","value":_vm.GST_Percentage_total.GST_5,"type":"number","label":"Total GST(5%)"}}):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.gstInvoice)?_c('v-text-field',{attrs:{"readonly":"","value":_vm.GST_Percentage_total.GST_12,"type":"number","label":"Total GST(12%)"}}):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.gstInvoice)?_c('v-text-field',{attrs:{"readonly":"","value":_vm.GST_Percentage_total.GST_18,"type":"number","label":"Total GST(18%)"}}):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.gstInvoice)?_c('v-text-field',{attrs:{"readonly":"","value":_vm.GST_Percentage_total.GST_28,"type":"number","label":"Total GST(28%)"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-select',{attrs:{"dense":"","readonly":"","items":[
                                  {
                                    text: 'Cash',
                                    value: 'Cash',
                                  },
                                  {
                                    text: 'Bank Account',
                                    value: 'Bank Account',
                                  },
                                  {
                                    text: 'Cash & Bank Account',
                                    value: 'CashAndBank Account',
                                  } ],"label":"Select Payment Type"},on:{"change":function($event){return _vm.resetAmounts()}},model:{value:(_vm.paymentType),callback:function ($$v) {_vm.paymentType=$$v},expression:"paymentType"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-text-field',{attrs:{"readonly":"","type":"number","disabled":_vm.amountFromCashDisabled,"label":"Amount from Cash"},model:{value:(_vm.amountFromCash),callback:function ($$v) {_vm.amountFromCash=$$v},expression:"amountFromCash"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-text-field',{attrs:{"readonly":"","type":"number","disabled":_vm.amountFromBankDisabled,"label":"Amount from Bank"},model:{value:(_vm.amountFromBank),callback:function ($$v) {_vm.amountFromBank=$$v},expression:"amountFromBank"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-text-field',{attrs:{"type":"number","label":"Paid Amount (in ₹)","readonly":"","prefix":""},model:{value:(_vm.paidAmount),callback:function ($$v) {_vm.paidAmount=$$v},expression:"paidAmount"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-text-field',{attrs:{"type":"number","label":"Remaining Amount (in ₹)","readonly":"","prefix":""},model:{value:(_vm.remainingAmount),callback:function ($$v) {_vm.remainingAmount=$$v},expression:"remainingAmount"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-select',{attrs:{"readonly":"","dense":"","items":[
                                  {
                                    text: 'Due',
                                    value: 'Debit',
                                  },
                                  {
                                    text: 'Partial Paid',
                                    value: 'Partial Paid',
                                  },
                                  {
                                    text: 'Full Paid',
                                    value: 'Credit',
                                  } ],"label":"Select Transaction type"},on:{"change":function($event){return _vm.resetAmounts()}},model:{value:(_vm.transactionType),callback:function ($$v) {_vm.transactionType=$$v},expression:"transactionType"}})],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),(this.firmSetting && this.firmSetting.ewayBill)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","s12":"","md12":""}},[_c('v-expansion-panel',{staticClass:"invoiceExpansion"},[_c('v-expansion-panel-content',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('v-card-title',[_c('h3',{staticClass:"title font-weight-light primary white--text"},[_vm._v("\n                            Transport Details\n                          ")])])]},proxy:true}],null,false,2044737383)},[_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('eway-bill',{attrs:{"invoiceData":_vm.invoiceDraft,"bank":_vm.bankById[_vm.selectedBank],"firm":_vm.firmById[_vm.selectedFirm],"selectedBuyer":_vm.selectedBuyer,"isBuyer":_vm.isBuyer,"ewayBillDetails":_vm.invoiceDraft.ewayBillDetails,"termsAndConditions":_vm.getTermsAndConditions(),"gstTotal":_vm.GST_Val_total},on:{"ewayBillSave":_vm.ewayBillSave}})],1)],1)],1)],1)],1)],1):_vm._e()],1)],1)],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"top":"","color":"success","timeout":3000},model:{value:(_vm.snackbarSuccess),callback:function ($$v) {_vm.snackbarSuccess=$$v},expression:"snackbarSuccess"}},[_vm._v("\n      Invoice updated successfully!\n    ")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"400"},model:{value:(_vm.otpData.dialog),callback:function ($$v) {_vm.$set(_vm.otpData, "dialog", $$v)},expression:"otpData.dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":"","title":""}},[_c('span',{staticClass:"headline"},[_vm._v("Please enter OTP that has been sent to mobile "+_vm._s(_vm.otpData.mobile)+" to create invoice.")])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"type":"number","label":"OTP"},model:{value:(_vm.otpData.confirmOtp),callback:function ($$v) {_vm.$set(_vm.otpData, "confirmOtp", $$v)},expression:"otpData.confirmOtp"}})],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text",attrs:{"primary":"","title":"","flat":"flat"},on:{"click":_vm.confirmOTP}},[_vm._v("\n           Confirm\n         ")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":""},model:{value:(_vm.addProductDialog),callback:function ($$v) {_vm.addProductDialog=$$v},expression:"addProductDialog"}},[_c('add-product',{attrs:{"currentProduct":_vm.currentProduct,"stepperValue":_vm.stepperValue},on:{"saveProduct":function($event){return _vm.saveProduct()},"close":function($event){_vm.addProductDialog = false}}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.billingDetailsDialog),callback:function ($$v) {_vm.billingDetailsDialog=$$v},expression:"billingDetailsDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Billing Details\n          ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.billingDetailsDialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":"Billing Name"},model:{value:(_vm.billingDetails.name),callback:function ($$v) {_vm.$set(_vm.billingDetails, "name", $$v)},expression:"billingDetails.name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Mobile"},model:{value:(_vm.billingDetails.mobile),callback:function ($$v) {_vm.$set(_vm.billingDetails, "mobile", $$v)},expression:"billingDetails.mobile"}}),_vm._v(" "),_c('v-textarea',{attrs:{"box":"","label":"Address"},model:{value:(_vm.billingDetails.address),callback:function ($$v) {_vm.$set(_vm.billingDetails, "address", $$v)},expression:"billingDetails.address"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},nativeOn:{"click":function($event){return _vm.saveBillingData()}}},[_vm._v("Confirm")])],1)],1)],1),_vm._v(" "),_c('v-snackbar',{scopedSlots:_vm._u([{key:"action",fn:function(ref){
                                var attrs = ref.attrs;
return [_c('v-btn',_vm._b({attrs:{"color":"red","text":""},on:{"click":function($event){_vm.snackbar = false}}},'v-btn',attrs,false),[_vm._v("\n        Close\n      ")])]}}]),model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.snackbarMsg)+"\n    ")]),_vm._v(" "),_c('iframe',{attrs:{"id":"printPdf","name":"printPdf"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(502);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d3d4c4f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1518);
function injectStyle (ssrContext) {
  __webpack_require__(1505)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d3d4c4f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1505 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoiceList_vue__ = __webpack_require__(503);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b46e094_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoiceList_vue__ = __webpack_require__(1516);
function injectStyle (ssrContext) {
  __webpack_require__(1507)
  __webpack_require__(1508)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoiceList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b46e094_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoiceList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1507 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1508 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return convertToPDFTransactionStripReport; });
/* unused harmony export convertToPDFTransactionReportFirm */

// playground requires you to assign document definition to a variable called dd
var convertToPDFTransactionStripReport = function convertToPDFTransactionStripReport(_ref) {
	var invoiceData = _ref.invoiceData,
	    firm = _ref.firm,
	    date = _ref.date;

	var dd = {
		content: [{ text: 'DAY BOOK\n', style: "topHeader1" }, {
			table: {
				widths: ['*'],
				body: [[{ text: 'DAYBOOK', style: "topHeader2" }], [{
					text: [{ text: 'Firm Name:-    ', bold: true }, { text: 'Google\n' }, { text: 'Date:-               ', bold: true }, { text: '12/12/12\n' }]
				}]]
			}
		}, {
			table: {
				body: [[{ text: 'STATEMENTS', style: "topHeader", colSpan: 7, decoration: 'underline' },
				// { text: '', style: "header" },
				{ text: '', style: "header" }, { text: '', style: "header" }, { text: '', style: "header" }, { text: '', style: "header" }, { text: '', style: "header" }, { text: '', style: "header" }], [
				// { text: 'Firm', style: "gstHeader" },
				{ text: 'Particulars', style: "gstHeader" }, { text: 'Debit', style: "gstHeader" }, { text: 'Credit', style: "gstHeader" }, { text: 'Voucher', style: "gstHeader" }, { text: 'Payment', style: "gstHeader" }, { text: 'Status', style: "gstHeader" }, { text: 'Remark', style: "gstHeader" }]]
			}
		}],
		styles: {
			header: {
				fontSize: 13,
				bold: true,
				alignment: 'center'
			},
			gstHeader: {
				fontSize: 14,
				bold: true,
				alignment: 'center'
			},
			data: {
				fontSize: 9,
				alignment: 'center'
			},
			topHeader: {
				color: 'white',
				fontSize: 12,
				alignment: 'center',
				bold: true,
				fillColor: '#15155d'
			},
			topHeader1: {
				color: 'white',
				fontSize: 1,
				alignment: 'center',
				bold: true,
				fillColor: '#15155d'
			},
			topHeader2: {
				color: 'white',
				fontSize: 14,
				alignment: 'center',
				bold: true,
				fillColor: '#15155d'
			},
			gstData1: {
				fontSize: 9,
				alignment: 'center',
				color: '#15155d',
				bold: true
			},
			gstData2: {
				fontSize: 9,
				alignment: 'center',
				color: '#B71C1C',
				bold: true
			},
			gstData3: {
				fontSize: 9,
				alignment: 'center',
				color: '#43A047',
				bold: true
			},
			gstData22: {
				fontSize: 9,
				alignment: 'center',
				color: '#B71C1C',
				bold: true,
				fillColor: '#d8d8d8'
			},
			gstData32: {
				fontSize: 9,
				alignment: 'center',
				color: '#43A047',
				bold: true,
				fillColor: '#d8d8d8'
			},
			data2: {
				fontSize: 9,
				alignment: 'center',
				fillColor: '#d8d8d8'
			},
			bigger: {
				fontSize: 18,
				bold: true,
				alignment: 'center',
				decoration: 'underline',
				decorationStyle: 'solid',
				decorationColor: 'black'
			}
		}
	};

	if (firm) {
		dd.content[1].table.body[1][0].text[1].text = firm + "\n";
	}
	if (date) {
		dd.content[1].table.body[1][0].text[3].text = date;
	}

	invoiceData.map(function (invoice, index) {
		dd.content[2].table.body.push([
		// { text: invoice[0], style: (index%2 == 0 ? "data" : "data2") },
		{ text: invoice[1], style: index % 2 == 0 ? "data" : "data2" }, { text: invoice[2], style: index % 2 == 0 ? "gstData3" : "gstData32" }, { text: invoice[3], style: index % 2 == 0 ? "gstData2" : "gstData22" }, { text: invoice[4], style: index % 2 == 0 ? "data" : "data2" }, { text: invoice[5], style: index % 2 == 0 ? "data" : "data2" }, { text: invoice[6], style: index % 2 == 0 ? "data" : "data2" }, { text: invoice[7], style: index % 2 == 0 ? "data" : "data2" }]);
	});
	return dd;
};

// playground requires you to assign document definition to a variable called dd
var convertToPDFTransactionReportFirm = function convertToPDFTransactionReportFirm(_ref2) {
	var invoiceData = _ref2.invoiceData,
	    firm = _ref2.firm,
	    dateFrom = _ref2.dateFrom,
	    dateTo = _ref2.dateTo,
	    bank = _ref2.bank;

	var dd = {
		content: [{
			table: {
				widths: ['50%', '*'],
				body: [[{
					image: '',
					width: 160,
					height: 35
				}, {
					text: [{
						text: [{ text: 'Firm Name:    ', bold: true }, { text: 'Google\n' }, { text: 'From Date:     ', bold: true }, { text: '12/12/12\n' }, { text: 'To Date:          ', bold: true }, { text: '12/12/12\n' }]
					}]

				}]]
			},

			style: "topTab"
		}, {
			table: {
				body: [[{ text: 'STATEMENTS', style: "topHeader", colSpan: 8, decoration: 'underline' }, { text: '', style: "header" }, { text: '', style: "header" }, { text: '', style: "header" }, { text: '', style: "header" }, { text: '', style: "header" }, { text: '', style: "header" }, { text: '', style: "header" }], [{ text: 'Date', style: "gstHeader" }, { text: 'Particulars', style: "gstHeader" }, { text: 'Debit', style: "gstHeader" }, { text: 'Credit', style: "gstHeader" }, { text: 'Voucher Type', style: "gstHeader" }, { text: 'Payment Type', style: "gstHeader" }, { text: 'Status', style: "gstHeader" }, { text: 'Remark', style: "gstHeader" }]]
			}
		}],
		styles: {
			header: {
				fontSize: 13,
				bold: true,
				alignment: 'center'
			},
			gstHeader: {
				fontSize: 14,
				bold: true,
				alignment: 'center'
			},
			data: {
				fontSize: 9,
				alignment: 'center'
			},
			topHeader: {
				color: 'white',
				fontSize: 12,
				alignment: 'center',
				bold: true,
				fillColor: '#15155d'
			},
			gstData1: {
				fontSize: 9,
				alignment: 'center',
				color: '#15155d',
				bold: true
			},
			gstData2: {
				fontSize: 9,
				alignment: 'center',
				color: '#B71C1C',
				bold: true
			},
			gstData3: {
				fontSize: 9,
				alignment: 'center',
				color: '#43A047',
				bold: true
			}
		}
	};

	if (firm) {
		dd.content[0].table.body[0][1].text[0].text[1].text = firm.toUpperCase() + "\n";
	}

	if (bank) {
		dd.content[0].table.body[0][1].text[0].text[0].text = "Bank Name:   ";
		dd.content[0].table.body[0][1].text[0].text[1].text = bank.toUpperCase() + "\n";
	}

	if (dateFrom) {
		dd.content[0].table.body[0][1].text[0].text[3].text = dateFrom + "\n";
	}
	if (dateTo) {
		dd.content[0].table.body[0][1].text[0].text[5].text = dateTo;
	}

	invoiceData.map(function (invoice) {
		dd.content[1].table.body.push([
		// { text: invoice[0], style: "data" },
		{ text: invoice[1], style: "data" }, { text: invoice[2], style: "gstData3" }, { text: invoice[3], style: "gstData2" }, { text: invoice[4], style: "data" }, { text: invoice[5], style: "data" }, { text: invoice[6], style: "data" }, { text: invoice[7], style: "data" }]);
	});
	var imgToExport = document.getElementById('pdfimgToExportHorizontal');
	var canvas = document.createElement('canvas');
	canvas.width = imgToExport.width;
	canvas.height = imgToExport.height;
	canvas.getContext('2d').drawImage(imgToExport, 0, 0);
	var base64 = canvas.toDataURL('image/png');
	dd.content[0].table.body[0][0].image = base64;
	return dd;
};

/***/ }),
/* 1510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_normalInvoice_vue__ = __webpack_require__(504);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ccb1867e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_normalInvoice_vue__ = __webpack_require__(1512);
function injectStyle (ssrContext) {
  __webpack_require__(1511)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_normalInvoice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ccb1867e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_normalInvoice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1511 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.firmNameById(_vm.item.firm) || 'Not Assigned')+" ")])]),_vm._v(" "),_c('td',[(_vm.item.buyerId)?_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.item.buyerName)+" ")]):_vm._e()]),_vm._v(" "),[_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.getCredit(_vm.item) || 0))+" ")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"red--text font-weight-bold"},[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.getDebit(_vm.item)|| 0))+" ")])])],_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.item.voucherType)+" ")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.item.paymentType))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.item.status))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.item.remark)+" ")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_automaticInvoice_vue__ = __webpack_require__(505);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e9d00ef_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_automaticInvoice_vue__ = __webpack_require__(1515);
function injectStyle (ssrContext) {
  __webpack_require__(1514)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_automaticInvoice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e9d00ef_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_automaticInvoice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.firmNameById(_vm.item.firm) || 'Not Assigned')+" ")])]),_vm._v(" "),_c('td',[(_vm.item.bank)?[_c('b',{staticClass:"font-weight-bold"},[_vm._v("\n            "+_vm._s(_vm.bankAccountNameById(_vm.item.bank))+" \n            ")])]:_vm._e(),_vm._v(" "),(_vm.item.expenseType)?[_c('b',{staticClass:"font-weight-bold"},[_vm._v("\n            "+_vm._s(_vm.expenseNameById(_vm.item.expenseType) || 'Not Assigned')+" \n        ")])]:_vm._e(),_vm._v(" "),(_vm.item.incomeType)?[_c('b',{staticClass:"font-weight-bold"},[_vm._v("\n            "+_vm._s(_vm.incomeNameById(_vm.item.incomeType) || 'Not Assigned')+" \n        ")])]:_vm._e(),_vm._v(" "),(_vm.item.assetType)?[_c('b',{staticClass:"font-weight-bold"},[_vm._v("\n            "+_vm._s(_vm.assetNameById(_vm.item.assetType) || 'Not Assigned')+" \n        ")])]:_vm._e(),_vm._v(" "),(_vm.item.staffType)?[_c('b',{staticClass:"font-weight-bold"},[_vm._v("\n            "+_vm._s(_vm.staffNameById(_vm.item.staffkey) || 'Not Assigned')+" \n        ")])]:_vm._e()],2),_vm._v(" "),(!_vm.item.isCredited)?_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v("  "+_vm._s(_vm._f("amount")(_vm.item.totalAmount || 0))+" ")])]):_vm._e(),_vm._v(" "),(!_vm.item.isCredited)?_c('td'):_vm._e(),_vm._v(" "),(_vm.item.isCredited)?_c('td'):_vm._e(),_vm._v(" "),(_vm.item.isCredited)?_c('td',[_c('b',{staticClass:"red--text font-weight-bold"},[_vm._v("  "+_vm._s(_vm._f("amount")(_vm.item.totalAmount || 0))+" ")])]):_vm._e(),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.item.voucherType)+" ")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.item.paymentType))])]),_vm._v(" "),_c('td',[(_vm.item.accountNumber)?_c('b',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.item.transferType || _vm.item.transactionType)+" ")]):_vm._e()]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.item.remark)+" ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"invoiceList"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"primary white--text text-xs-center body-2"},[_c('v-card-text',[_c('h3',[_vm._v(_vm._s(_vm.heading))])])],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation transaction-table strip-table",attrs:{"items":_vm.invoicesByBrand,"hide-actions":"","headers":_vm.headers},scopedSlots:_vm._u([{key:"items",fn:function(props){return [(props.item.type == "automatic invoice" && props.item.firm != "Total")?_c('automatic-invoice',{attrs:{"item":props.item,"firms":_vm.firms}}):_vm._e(),_vm._v(" "),(props.item.type != "automatic invoice" && props.item.firm != "Total")?_c('normal-invoice',{attrs:{"item":props.item,"firms":_vm.firms,"buyers":_vm.buyers,"sellers":_vm.sellers}}):_vm._e(),_vm._v(" "),(props.item.firm == "Total")?_c('tr',[_c('td',[_c('b',{staticClass:"font-weight-bold primary--text"},[_vm._v("Total")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"})]),_vm._v(" "),[_c('td',{staticClass:"credit-total"},[_c('b',{staticClass:"green--text font-weight-bold "},[_vm._v(" "+_vm._s(_vm._f("amount")(props.item.credit || 0))+" ")])]),_vm._v(" "),_c('td',{staticClass:"debit-total"},[_c('b',{staticClass:"red--text font-weight-bold "},[_vm._v(" "+_vm._s(_vm._f("amount")(props.item.debit || 0))+" ")])])],_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"})]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"})]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"})]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"})])],2):_vm._e()]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No rows to Show")])],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return dailyProductReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dailyProductGroupReport; });

// playground requires you to assign document definition to a variable called dd
var dailyProductReport = function dailyProductReport(_ref) {
    var invoiceData = _ref.invoiceData,
        firm = _ref.firm,
        date = _ref.date;

    var dd = {
        pageOrientation: 'landscape',
        content: [{ text: 'Daily Product Book\n\n', style: "gstDataBold" }, {
            table: {
                widths: ['*'],
                body: [[{
                    text: []
                }], [{ text: '', style: "gstDataBold1" }]]
            }
        }, {
            table: {

                body: [[{ text: 'Invoice ID', style: "gstHeader" }, { text: 'Firm', style: "gstHeader1" }, { text: 'Customer Name', style: "gstHeader" }, { text: 'Product Name', style: "gstHeader" }, { text: 'Opening Quantity', style: "gstHeader" }, { text: 'Purchase Quantity', style: "gstHeader" }, { text: 'Sale Quantity', style: "gstHeader" }, { text: 'Amount', style: "gstHeader" }, { text: 'Closing Quantity', style: "gstHeader" }]]
            }

        }],
        styles: {
            gstHeader: {
                fontSize: 11,
                bold: true,
                alignment: 'center',
                color: '#160091'
            },
            gstHeader1: {
                fontSize: 11,
                bold: true,
                alignment: 'left',
                color: '#160091'
            },
            gstData: {
                fontSize: 9,
                bold: false,
                alignment: 'center'
            },
            gstDataBold: {
                fontSize: 14,
                bold: true,
                alignment: 'center',
                color: '#160091'
            },
            gstDataBold1: {
                fontSize: 14,
                bold: true,
                alignment: 'center',
                color: '#160091',
                fillColor: '#15155d'
            },
            gstDataAlert: {
                fontSize: 9,
                bold: true,
                alignment: 'center',
                color: '#B71C1C'
            },
            gstDataInfo: {
                fontSize: 9,
                bold: true,
                alignment: 'center',
                color: '#0D47A1'
            },
            gstDataSuccess: {
                fontSize: 9,
                bold: true,
                alignment: 'center',
                color: '#1B5E20'
            },
            gstDataPrimary: {
                fontSize: 9,
                bold: true,
                alignment: 'center',
                color: '#160091'
            }
        }
    };
    dd.content[1].table.body[0][0].text.push({ text: '   Firm : ' + (firm || ""), bold: true });
    if (date) {
        dd.content[1].table.body[0][0].text.push({ text: '   Date : ' + date, bold: true });
    }
    invoiceData.map(function (invoice) {
        dd.content[2].table.body.push([{ text: invoice[0], style: "gstData" }, { text: invoice[1], style: "gstData" }, { text: invoice[2], style: "gstData" }, { text: invoice[3], style: "gstData" }, { text: invoice[4], style: "gstData" }, { text: invoice[5], style: "gstData" }, { text: invoice[6], style: "gstData" }, { text: invoice[7], style: "gstData" }, { text: invoice[8], style: "gstData" }]);
    });

    return dd;
};

var dailyProductGroupReport = function dailyProductGroupReport(_ref2) {
    var invoiceData = _ref2.invoiceData,
        firm = _ref2.firm,
        date = _ref2.date,
        isDetailed = _ref2.isDetailed;

    var dd = {
        pageOrientation: 'landscape',
        content: [{ text: 'Daily Product-Group Book\n\n', style: "gstDataBold" }, {
            table: {
                widths: ['*'],
                body: [[{
                    text: []
                }], [{ text: '', style: "gstDataBold1" }]]
            }
        }, {
            table: {

                body: [[{ text: 'Group Name', style: "gstHeader" }, { text: 'Opening Quantity', style: "gstHeader1" }, { text: 'Purchase Quantity', style: "gstHeader" }, { text: 'Purchase Amount', style: "gstHeader" }, { text: 'Sale Quantity', style: "gstHeader" }, { text: 'Sale Amount', style: "gstHeader" }, { text: 'Closing Quantity', style: "gstHeader" }]]
            }

        }],
        styles: {
            gstHeader: {
                fontSize: 11,
                bold: true,
                alignment: 'center',
                color: '#160091'
            },
            gstCombineHeader: {
                fontSize: 9,
                alignment: 'center',
                color: '#160091'
            },
            gstHeader1: {
                fontSize: 11,
                bold: true,
                alignment: 'left',
                color: '#160091'
            },
            gstData: {
                fontSize: 9,
                bold: false,
                alignment: 'center'
            },
            gstCombinedData: {
                fontSize: 11,
                bold: true,
                alignment: 'center',
                fillColor: '#15155d',
                color: '#FFFFFF'
            },
            gstDataBold: {
                fontSize: 14,
                bold: true,
                alignment: 'center',
                color: '#160091'
            },
            gstDataBold1: {
                fontSize: 14,
                bold: true,
                alignment: 'center',
                color: '#160091',
                fillColor: '#15155d'
            },
            gstDataAlert: {
                fontSize: 9,
                bold: true,
                alignment: 'center',
                color: '#B71C1C'
            },
            gstDataInfo: {
                fontSize: 9,
                bold: true,
                alignment: 'center',
                color: '#0D47A1'
            },
            gstDataSuccess: {
                fontSize: 9,
                bold: true,
                alignment: 'center',
                color: '#1B5E20'
            },
            gstDataPrimary: {
                fontSize: 9,
                bold: true,
                alignment: 'center',
                color: '#160091'
            }
        }
    };
    dd.content[1].table.body[0][0].text.push({ text: '   Firm : ' + (firm || ""), bold: true });
    if (date) {
        dd.content[1].table.body[0][0].text.push({ text: '   Date : ' + date, bold: true });
    }
    var count = 0;
    invoiceData.map(function (invoice) {
        if (invoice[0] && !invoice[0].includes("Combined Product") && invoice[0] != "") {
            if (invoice.length == '7') {
                count = 0;
                dd.content[2].table.body.push([{ text: invoice[0], style: "gstCombinedData" }, { text: invoice[1], style: "gstCombinedData" }, { text: invoice[2], style: "gstCombinedData" }, { text: invoice[3], style: "gstCombinedData" }, { text: invoice[4], style: "gstCombinedData" }, { text: invoice[5], style: "gstCombinedData" }, { text: invoice[6], style: "gstCombinedData" }]);
            } else if (invoice.length == '9' && isDetailed) {
                count++;
                if (count == 1) {
                    dd.content[2].table.body.push([{ table: {

                            body: [[{ text: 'Invoice Id', style: "gstHeader" }, { text: 'Firm', style: "gstHeader1" }, { text: 'Customer Name', style: "gstHeader" }, { text: 'Product Name', style: "gstHeader" }, { text: 'Opening QTY', style: "gstHeader" }, { text: 'Purchase QTY', style: "gstHeader" }, { text: 'Sale QTY', style: "gstHeader" }, { text: 'Amount', style: "gstHeader" }, { text: 'Closing QTY', style: "gstHeader" }], [{ text: invoice[0], style: "gstData" }, { text: invoice[1], style: "gstData" }, { text: invoice[2], style: "gstData" }, { text: invoice[3], style: "gstData" }, { text: invoice[4], style: "gstData" }, { text: invoice[5], style: "gstData" }, { text: invoice[6], style: "gstData" }, { text: invoice[7], style: "gstData" }, { text: invoice[8], style: "gstData" }]]
                        }, style: "gstData", colSpan: 7 }]);
                } else {
                    dd.content[2].table.body[dd.content[2].table.body.length - 1][0].table.body.push([{ text: invoice[0], style: "gstData" }, { text: invoice[1], style: "gstData" }, { text: invoice[2], style: "gstData" }, { text: invoice[3], style: "gstData" }, { text: invoice[4], style: "gstData" }, { text: invoice[5], style: "gstData" }, { text: invoice[6], style: "gstData" }, { text: invoice[7], style: "gstData" }, { text: invoice[8], style: "gstData" }]);
                }
            } else if (isDetailed) {
                count++;
                if (count == 1) {
                    dd.content[2].table.body.push([{ table: {

                            body: [[{ text: 'Product Name', style: "gstCombineHeader" }, { text: 'Sale Quantity', style: "gstCombineHeader" }, { text: 'Sale Amount', style: "gstCombineHeader" }], [{ text: invoice[0], style: "gstData" }, { text: invoice[1], style: "gstData" }, { text: invoice[2], style: "gstData" }]]
                        }, style: "gstData", colSpan: 7 }]);
                } else {
                    dd.content[2].table.body[dd.content[2].table.body.length - 1][0].table.body.push([{ text: invoice[0], style: "gstData" }, { text: invoice[1], style: "gstData" }, { text: invoice[2], style: "gstData" }]);
                }
            }
        }
    });

    return dd;
};

/***/ }),
/* 1518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-sm":""}},[_c('v-layout',{attrs:{"justify-end":"","row":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.firmsByBrand,"label":"Select Firm","clearable":""},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerMenu),callback:function ($$v) {_vm.datepickerMenu=$$v},expression:"datepickerMenu"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.menu2 = false}},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-select',{attrs:{"dense":"","multiple":"","items":[
        'Receipt',
        'Payment',
        'Credit Note',
        'Debit Note',
        'Asset',
        'Expense',
        'Liability',
        'Income',
        'Staff',
        'Transfer',
        'Advance',
        'LoanGiven',
        'LoanTaken',
        'Security',
        'Opening Balance',
        'Sale',
        'Purchase'
        ],"label":"Filter Voucher Type","clearable":""},model:{value:(_vm.voucherTypeFilter),callback:function ($$v) {_vm.voucherTypeFilter=$$v},expression:"voucherTypeFilter"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm1":"","md1":""}},[_c('v-switch',{attrs:{"label":("" + (!_vm.isProductView ? 'Product' : 'Invoice'))},model:{value:(_vm.isProductView),callback:function ($$v) {_vm.isProductView=$$v},expression:"isProductView"}})],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"10px"},attrs:{"xs12":"","sm1":"","md1":""}},[(!_vm.isProductView)?_c('v-btn',{staticClass:"primary white--text",on:{"click":function($event){return _vm.printInv()}}},[_vm._v("\n        Print\n      ")]):_vm._e(),_vm._v(" "),(!_vm.isProductView)?_c('v-btn',{staticClass:"primary white--text",on:{"click":function($event){return _vm.printStripInv()}}},[_vm._v("\n        Strip Print\n      ")]):_vm._e(),_vm._v(" "),(_vm.isProductView && _vm.isProductGroupView)?_c('v-btn',{staticClass:"primary white--text",on:{"click":function($event){return _vm.productGroupReportPrint(false)}}},[_vm._v("\n        Print (Simple)\n      ")]):_vm._e(),_vm._v(" "),(_vm.isProductView && _vm.isProductGroupView)?_c('v-btn',{staticClass:"primary white--text",on:{"click":function($event){return _vm.productGroupReportPrint(true)}}},[_vm._v("\n        Print (Detailed)\n      ")]):_vm._e(),_vm._v(" "),(_vm.isProductView && !_vm.isProductGroupView)?_c('v-btn',{staticClass:"primary white--text",on:{"click":function($event){return _vm.productReportPrint()}}},[_vm._v("\n        Print\n      ")]):_vm._e()],1),_vm._v(" "),(_vm.isProductView)?_c('v-flex',{attrs:{"xs12":"","sm1":"","md1":""}},[_c('v-switch',{attrs:{"label":("" + (!_vm.isProductGroupView ? 'Product Group' : 'Products'))},model:{value:(_vm.isProductGroupView),callback:function ($$v) {_vm.isProductGroupView=$$v},expression:"isProductGroupView"}})],1):_vm._e()],1),_vm._v(" "),(!_vm.isProductView)?[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('invoice-list',{attrs:{"firmAssignment":true,"heading":"DAYBOOK","selectedFirm":_vm.selectedFirm,"selectedDate":_vm.date,"print":_vm.print,"stripPrint":_vm.stripPrint,"invoices":_vm.invoices,"firms":_vm.firms,"buyers":_vm.buyers,"sellers":_vm.sellers,"voucherTypeFilter":_vm.voucherTypeFilter}})],1)],1)]:[_c('v-layout',{attrs:{"row":"","wrap":""}},[(!_vm.isProductGroupView)?_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-card',{staticClass:"primary white--text text-xs-center body-2"},[_c('v-card-text',[_c('h3',[_vm._v("Product Transactions")])])],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation prod-reports strip-table",attrs:{"items":_vm.productsTransaction,"headers":_vm.headers,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(props.item["invoiceId"]))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.firmNameById(props.item.firm) || "Not Assigned")+"\n              ")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.buyerById(props.item.buyerId) || "Not Assigned")+"\n              ")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(props.item.productName)+" ")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(props.item.availableQuantity)+"\n                "+_vm._s(_vm.getMajorQuantity(
                    props.item.availableQuantity,
                    props.item.productId
                  )))])]),_vm._v(" "),(!props.item.isBuyer)?[_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(props.item.quantity)+"\n                  "+_vm._s(_vm.getMajorQuantity(
                      props.item.quantity,
                      props.item.productId
                    )))])]),_vm._v(" "),_c('td')]:[_c('td'),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(props.item.quantity)+"\n                  "+_vm._s(_vm.getMajorQuantity(
                      props.item.quantity,
                      props.item.productId
                    )))])])],_vm._v(" "),_c('td',[(props.item.isBuyer)?_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(props.item.basicPrice)+" ")]):_vm._e()]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(props.item.isBuyer
                    ? Number.parseFloat(
                        Number.parseFloat(props.item.availableQuantity) -
                          Number.parseFloat(props.item.quantity)
                      )
                    : Number.parseFloat(
                        Number.parseFloat(props.item.availableQuantity) +
                          Number.parseFloat(props.item.quantity)
                      ))+"\n              ")])])]}}],null,false,3252731115)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v(" No rows to Show ")])],2)],1):_c('v-flex',{attrs:{"xs12":"","sm12":""}},[_c('v-card',{staticClass:"primary white--text text-xs-center body-2"},[_c('v-card-text',[_c('h3',[_vm._v("Product Group Transactions")])])],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation prod-grp-reports strip-table",attrs:{"items":_vm.groupsTransaction,"headers":_vm.groupHeaders,"expand":true,"item-key":"name","hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{class:(props.item.name != 'Total' ? (!props.expanded ? 'not-expand product-group-row' : 'product-group-row') : ''),on:{"click":function($event){props.expanded = !props.expanded;}}},[_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(props.item.name)+" ")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(props.item.availableQuantity)+"\n                "+_vm._s(_vm.getMajorQuantityGroup(
                    props.item.sameMajorUnit,
                    props.item.availableQuantity,
                    props.item.majorUnitQuantity,
                    props.item.majorUnit
                  )))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold primary--text"},[_vm._v(_vm._s(props.item.purchaseQuantity)+"\n                "+_vm._s(_vm.getMajorQuantityGroup(
                    props.item.sameMajorUnit,
                    props.item.purchaseQuantity,
                    props.item.majorUnitQuantity,
                    props.item.majorUnit
                  )))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold success--text"},[_vm._v(_vm._s(Number.parseFloat(props.item.purchaseAmount).toFixed(2))+" ")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(props.item.sellingQuantity)+"\n                "+_vm._s(_vm.getMajorQuantityGroup(
                    props.item.sameMajorUnit,
                    props.item.sellingQuantity,
                    props.item.majorUnitQuantity,
                    props.item.majorUnit
                  )))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(Number.parseFloat(props.item.saleAmount).toFixed(2))+" ")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(props.item.closingQuantity)+"\n                "+_vm._s(_vm.getMajorQuantityGroup(
                    props.item.sameMajorUnit,
                    props.item.closingQuantity,
                    props.item.majorUnitQuantity,
                    props.item.majorUnit
                  )))])])])]}},{key:"expand",fn:function(props){return [(props.item.name != 'Total')?_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-switch',{attrs:{"label":("Combined Product : " + (_vm.combineProduct ? 'YES' : 'NO'))},model:{value:(_vm.combineProduct),callback:function ($$v) {_vm.combineProduct=$$v},expression:"combineProduct"}})],1),_vm._v(" "),(!_vm.combineProduct)?_c('v-data-table',{staticClass:"elevation prod-reports strip-table",attrs:{"items":props.item.products,"headers":_vm.headers,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(props.item["invoiceId"]))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.firmNameById(props.item.firm) || "Not Assigned")+"\n                    ")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.buyerById(props.item.buyerId) || "Not Assigned")+"\n                    ")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(props.item.productName)+" ")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(props.item.availableQuantity)+"\n                      "+_vm._s(_vm.getMajorQuantity(
                          props.item.availableQuantity,
                          props.item.productId
                        )))])]),_vm._v(" "),(!props.item.isBuyer)?[_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(props.item.quantity)+"\n                        "+_vm._s(_vm.getMajorQuantity(
                            props.item.quantity,
                            props.item.productId
                          )))])]),_vm._v(" "),_c('td')]:[_c('td'),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(props.item.quantity)+"\n                        "+_vm._s(_vm.getMajorQuantity(
                            props.item.quantity,
                            props.item.productId
                          )))])])],_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(props.item.basicPrice)+" ")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(props.item.isBuyer
                          ? Number.parseFloat(
                              Number.parseFloat(props.item.availableQuantity) -
                                Number.parseFloat(props.item.quantity)
                            )
                          : Number.parseFloat(
                              Number.parseFloat(props.item.availableQuantity) +
                                Number.parseFloat(props.item.quantity)
                            ))+"\n                    ")])])]}}],null,true)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v(" No rows to Show ")])],2):_c('v-data-table',{staticClass:"elevation prod-reports strip-table",attrs:{"items":props.item.unqProducts,"hide-actions":"","headers":_vm.unqProdHeader},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(props.item.productName)+" ")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v("\n                      "+_vm._s(props.item.saleQuantity)+"\n                      "+_vm._s(_vm.getMajorQuantity(
                          props.item.saleQuantity,
                          props.item.productId
                        )))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(props.item.saleAmount)+"\n                    ")])])]}}],null,true)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v(" No rows to Show ")])],2)],1):_vm._e()]}}])},[_vm._v(" "),_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v(" No rows to Show ")])],2)],1)],1)],_vm._v(" "),_c('v-snackbar',{attrs:{"top":"","color":"error","timeout":3000},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.snackbarText)+"\n  ")]),_vm._v(" "),_c('v-snackbar',{attrs:{"top":"","color":"success","timeout":3000},model:{value:(_vm.snackbarSuccess),callback:function ($$v) {_vm.snackbarSuccess=$$v},expression:"snackbarSuccess"}},[_vm._v("\n    "+_vm._s(_vm.snackbarSuccessText)+"\n  ")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoiceList_vue__ = __webpack_require__(506);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f3831bc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoiceList_vue__ = __webpack_require__(1525);
function injectStyle (ssrContext) {
  __webpack_require__(1520)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invoiceList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f3831bc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_invoiceList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1520 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatementView_vue__ = __webpack_require__(507);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ab5d747_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatementView_vue__ = __webpack_require__(1522);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatementView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6ab5d747_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatementView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(new Date(_vm.item.date).toLocaleDateString("en-IN")))])]),_vm._v(" "),_c('td',[(_vm.item.buyerId)?_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.buyerById(_vm.item.buyerId)['name'])+" ")]):_vm._e()]),_vm._v(" "),[_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.getCredit(_vm.item) || 0))+" ")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"red--text font-weight-bold"},[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.getDebit(_vm.item)|| 0))+" ")])])],_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.getVocherType(_vm.item))+" ")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.item.paymentType))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.item.status))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.item.remark)+" ")])])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_normalView_vue__ = __webpack_require__(508);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43883150_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_normalView_vue__ = __webpack_require__(1524);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_normalView_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43883150_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_normalView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item.name == 'total')?_c('tr',{staticClass:"totalRow"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('td',[_c('b',[_c('h4',{staticClass:"success--text font-weight-bold totalField"},[_vm._v("\n        "+_vm._s(_vm._f("amount")(_vm.item["totalAmount"] || 0))+"\n      ")])])]),_vm._v(" "),_c('td',[_c('b',[_c('h4',{staticClass:"font-weight-bold totalField"},[_vm._v("\n        "+_vm._s(_vm._f("amount")(_vm.item["basicAmount"] || 0))+"\n      ")])])]),_vm._v(" "),_c('td',[_c('b',[_c('h4',{staticClass:"font-weight-bold totalField"},[_vm._v(_vm._s(_vm._f("amount")(_vm.item["gstTotal"] || 0)))])])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"totalField"},[_vm._v(_vm._s(_vm._f("amount")(_vm.item.totalExtraCharges || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_c('h4',{staticClass:"font-weight-bold totalField"},[_vm._v("\n        "+_vm._s(_vm._f("amount")(_vm.item["discountAmount"] || 0))+"\n      ")])])]),_vm._v(" "),_c('td',[_c('b',[_c('h4',{staticClass:"primary--text font-weight-bold totalField"},[_vm._v("\n        "+_vm._s(_vm._f("amount")(_vm.item["paidAmount"] || 0))+"\n      ")])])]),_vm._v(" "),_c('td',[_c('b',[_c('h4',{staticClass:"error--text font-weight-bold totalField"},[_vm._v("\n        "+_vm._s(_vm._f("amount")(_vm.item["remainingAmount"] || 0))+"\n      ")])])]),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_c('td',[_c('b',[_c('h4',{staticClass:"primary--text font-weight-bold totalField"},[_vm._v("\n        "+_vm._s(_vm._f("amount")(_vm.item["GST_3"] || 0))+"\n      ")])])]),_vm._v(" "),_c('td',[_c('b',[_c('h4',{staticClass:"primary--text font-weight-bold totalField"},[_vm._v("\n        "+_vm._s(_vm._f("amount")(_vm.item["GST_5"] || 0))+"\n      ")])])]),_vm._v(" "),_c('td',[_c('b',[_c('h4',{staticClass:"primary--text font-weight-bold totalField"},[_vm._v("\n        "+_vm._s(_vm._f("amount")(_vm.item["GST_12"] || 0))+"\n      ")])])]),_vm._v(" "),_c('td',[_c('b',[_c('h4',{staticClass:"primary--text font-weight-bold totalField"},[_vm._v("\n        "+_vm._s(_vm._f("amount")(_vm.item["GST_18"] || 0))+"\n      ")])])]),_vm._v(" "),_c('td',[_c('b',[_c('h4',{staticClass:"primary--text font-weight-bold totalField"},[_vm._v("\n        "+_vm._s(_vm._f("amount")(_vm.item["GST_28"] || 0))+"\n      ")])])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')]):_c('tr',[_c('td',{staticClass:"primary--text font-weight-bold",domProps:{"innerHTML":_vm._s(_vm.renderDate(_vm.item.date))}}),_vm._v(" "),_c('td',[_c('v-menu',{attrs:{"offset-y":"","close-on-content-click":false},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({},on),[_vm._v("more_vert")])]}}])},[_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.openProd(_vm.item)}}},[_c('v-list-tile-title',{staticClass:"font-weight-bold primary--text"},[_c('v-icon',{staticClass:"primary--text"},[_vm._v("\n              remove_red_eye\n            ")]),_vm._v("\n            View\n          ")],1)],1),_vm._v(" "),_c('v-list-group',{attrs:{"no-action":""},scopedSlots:_vm._u([{key:"activator",fn:function(){return [_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',{staticClass:"font-weight-bold primary--text"},[_c('v-icon',{staticClass:"primary--text"},[_vm._v("\n                    remove_red_eye\n                  ")]),_vm._v("\n                  Print\n                ")],1)],1)],1)]},proxy:true}])},[_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.printBasicInvoice(_vm.item)}}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("panorama_vertical")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Basic Print")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.printInvoice4(_vm.item)}}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("panorama_wide_angle")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("\n                Simple Print\n              ")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.printHorizontalInvoice(_vm.item)}}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("panorama_horizontal")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Detailed Print")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.printDairyInvoice(_vm.item)}}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("mdi-receipt")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Theme1 Print")])],1),_vm._v(" "),(_vm.item.ewayBillDetails)?_c('v-list-tile',{on:{"click":function($event){return _vm.printEwayType3(_vm.item)}}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("aspect_ratio")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Exclusive Print")])],1):_vm._e()],1),_vm._v(" "),_c('v-list-tile',[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":{
              name: 'InvoiceUpdate',
              params: { invoiceId: _vm.item['.key'] },
            }}},[_c('v-list-tile-title',{staticClass:"font-weight-bold primary--text"},[_c('v-icon',{staticClass:"primary--text"},[_vm._v("\n                edit\n              ")]),_vm._v("\n              Edit\n            ")],1)],1)],1),_vm._v(" "),_c('v-list-tile',[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":'/invoice-statements/' + _vm.item.buyerId}},[_c('v-list-tile-title',{staticClass:"font-weight-bold primary--text"},[_c('v-icon',{staticClass:"primary--text"},[_vm._v("\n                fact_check\n              ")]),_vm._v("\n              Statement\n            ")],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('td',[_c('b',[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":'/buyers/' + _vm.item.buyerId}},[_vm._v("\n      "+_vm._s(_vm.buyerById(_vm.item.buyerId).name)+"\n      ")])],1)]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.item["invoiceId"]))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"success--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(_vm.item["totalAmount"] || 0)))])]),_vm._v(" "),_c('td',{staticClass:"nowrap"},[_c('b',{staticClass:"text-xs-left "},[_vm._v(" "+_vm._s(_vm._f("amount")(((_vm.item.totalAmount - (_vm.item.totalExtraCharges || 0 ) - (_vm.item.roundOffAmount || 0 )) - _vm.getGSTtotal(_vm.item)) || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(_vm.getGSTtotal(_vm.item) || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(_vm.item.totalExtraCharges || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(_vm.item["discountAmount"] || 0)))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"primary--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(_vm.item["paidAmount"] || 0)))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"error--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(_vm.item["remainingAmount"] || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.item["paymentType"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.item["status"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.item["gstType"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")((_vm.item["gstType"] == "IGST" ? _vm.getGSTtotal(_vm.item) || 0 : 0))))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")((_vm.item["gstType"] == "SGST|CGST" ? _vm.getGSTtotal(_vm.item) / 2 || 0 : 0))))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")((_vm.item["gstType"] == "SGST|CGST" ? _vm.getGSTtotal(_vm.item) / 2 || 0 : 0))))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(_vm.item["GST_Percentage_total"]
        ? _vm.item["GST_Percentage_total"]["GST_3"]
        : "" || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(_vm.item["GST_Percentage_total"]
        ? _vm.item["GST_Percentage_total"]["GST_5"]
        : "" || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(_vm.item["GST_Percentage_total"]
        ? _vm.item["GST_Percentage_total"]["GST_12"]
        : "" || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(_vm.item["GST_Percentage_total"]
        ? _vm.item["GST_Percentage_total"]["GST_18"]
        : "" || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(_vm.item["GST_Percentage_total"]
        ? _vm.item["GST_Percentage_total"]["GST_28"]
        : "" || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.item["duration"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.item["adminEmail"] ? _vm.item["adminEmail"] : ""))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.firmNameById(_vm.item.firm)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.branchNameById(_vm.item.branch)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.item.voucherType))])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('b',[_c('h3',[_vm._v("Total")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('b',[_c('h3')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('b',[_c('h3')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('b',[_c('h3')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('b',[_c('h3')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('b',[_c('h3')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('b',[_c('h3')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('b',[_c('h4')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('b',[_c('h4',{staticClass:"font-weight-bold totalField"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('b',[_c('h4',{staticClass:"font-weight-bold totalField"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('b',[_c('h4',{staticClass:"font-weight-bold totalField"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"invoiceList"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-toolbar',{staticClass:"primary white--text",staticStyle:{"margin-top":"10px"}},[_c('v-flex',{attrs:{"xs12":"","md1":"","sm1":""}},[_c('h3',{staticClass:"title font-weight-light"},[_vm._v(_vm._s(_vm.isSale ?'Sales Register' : 'Purchase Register'))])]),_vm._v(" "),[_c('v-flex',{attrs:{"xs12":"","md2":"","sm2":""}},[_c('v-select',{staticClass:"select-firm",attrs:{"dense":"","items":_vm.firmsByBrand,"label":"Select Firm","clearable":""},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-select',{staticClass:"select-firm",attrs:{"dense":"","items":_vm.branchsByBrand,"label":"Select branch","clearable":""},model:{value:(_vm.selectedBranch),callback:function ($$v) {_vm.selectedBranch=$$v},expression:"selectedBranch"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-menu',{staticClass:"white-datepicker",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerFrom),callback:function ($$v) {_vm.datepickerFrom=$$v},expression:"datepickerFrom"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"From Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.dateFrom),callback:function ($$v) {_vm.dateFrom=$$v},expression:"dateFrom"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerFrom = false}},model:{value:(_vm.dateFrom),callback:function ($$v) {_vm.dateFrom=$$v},expression:"dateFrom"}})],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-menu',{staticClass:"white-datepicker",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerTo),callback:function ($$v) {_vm.datepickerTo=$$v},expression:"datepickerTo"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"To Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.dateTo),callback:function ($$v) {_vm.dateTo=$$v},expression:"dateTo"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerTo = false}},model:{value:(_vm.dateTo),callback:function ($$v) {_vm.dateTo=$$v},expression:"dateTo"}})],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md1":"","sm1":""}},[_c('v-switch',{staticClass:"white-switch subheading font-weight-bold",attrs:{"color":"white","label":("" + (_vm.isStatementView ? 'View' : 'View'))},model:{value:(_vm.isStatementView),callback:function ($$v) {_vm.isStatementView=$$v},expression:"isStatementView"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md1":"","sm1":""}},[_c('router-link',{attrs:{"to":"/Dashboard"}},[_c('v-btn',{staticStyle:{"float":"right"},attrs:{"icon":"","dark":""}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-btn',{staticStyle:{"float":"left"},attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.print()}}},[_c('v-icon',{staticClass:"primary white--text"},[_vm._v("\n                picture_as_pdf\n              ")])],1)],1)]],2)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation transaction-table",attrs:{"items":_vm.isStatementView ? _vm.statmentData : _vm.normalData,"pagination":_vm.pagination,"headers":_vm.isStatementView ? _vm.headers : _vm.invoiceHeader},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [(_vm.isStatementView)?_c('statement-view',{attrs:{"item":props.item,"firms":_vm.firms,"buyers":_vm.buyers,"sellers":_vm.sellers}}):_c('normal-view',{attrs:{"item":props.item,"firms":_vm.firms,"buyers":_vm.buyers,"sellers":_vm.sellers},on:{"openItems":_vm.openItems}})]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No rows to Show")])],2)],1),_vm._v(" "),(_vm.selectedInvoice && _vm.selectedInvoice['.key'])?_c('v-dialog',{attrs:{"persistent":"","width":"1000"},model:{value:(_vm.dialog11),callback:function ($$v) {_vm.dialog11=$$v},expression:"dialog11"}},[_c('v-card',[_c('v-card-title',{staticClass:"title grey lighten-2"},[_vm._v("\n                  "),_c('b',[_vm._v(_vm._s(_vm.buyerById(_vm.selectedInvoice.buyerId).name)+" ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialog11 = false}}},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("clear")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('b',[_vm._v("Name :-")]),_vm._v(" "),_vm._v("\n                      "+_vm._s(_vm.buyerById(_vm.selectedInvoice.buyerId).name)+"\n                    "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Firm :-")]),_vm._v("\n                    "+_vm._s(_vm.getFirmName(_vm.selectedInvoice.firm))+"\n                    "),_c('br'),_vm._v(" "),_c('b',[_vm._v("invoiceId :-")]),_vm._v("\n                    "+_vm._s(_vm.selectedInvoice['invoiceId'])+"\n                    "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Duration (in Days) :-")]),_vm._v("\n                    "+_vm._s(_vm.selectedInvoice['duration'])+"\n                    "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Payment Type :-")]),_vm._v("\n                    "+_vm._s(_vm.selectedInvoice['paymentType'])+"\n                    "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Status :-")]),_vm._v("\n                    "+_vm._s(_vm.selectedInvoice['status'])+"\n                    "),_c('br')]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('b',{staticClass:"success--text font-weight-bold"},[_vm._v("Total Amount:")]),_vm._v("\n                     "+_vm._s(_vm.selectedInvoice['totalAmount'])+"\n                    "),_c('br'),_vm._v(" "),_c('b',{staticClass:"primary--text font-weight-bold"},[_vm._v("Basic Amount:")]),_vm._v("\n                     "+_vm._s(_vm.selectedInvoice['totalAmount'] - _vm.getGSTtotal(_vm.selectedInvoice))+"\n                    "),_c('br'),_vm._v(" "),_c('b',{staticClass:"primary--text font-weight-bold"},[_vm._v("Total GST: ")]),_vm._v("\n                     "+_vm._s(_vm.getGSTtotal(_vm.selectedInvoice))+"\n                    "),_c('br'),_vm._v(" "),_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v("Paid Amount:")]),_vm._v("\n                     "+_vm._s(_vm.selectedInvoice['paidAmount'])+"\n                    "),_c('br'),_vm._v(" "),_c('b',{staticClass:"red--text font-weight-bold"},[_vm._v("Due Amount:")]),_vm._v("\n                     "+_vm._s(_vm.selectedInvoice['remainingAmount'])+"\n                    "),_c('br'),_vm._v(" "),_c('b',[_vm._v("Discount:")]),_vm._v("\n                     "+_vm._s(_vm.selectedInvoice['discountAmount'])+"\n                    "),_c('br')]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('b',[_vm._v("GST Type: ")]),_vm._v("\n                    "+_vm._s(_vm.selectedInvoice['gstType'])+"\n                    "),_c('br'),_vm._v(" "),_c('b',[_vm._v("GST (3%): ")]),_vm._v("\n                     "+_vm._s(_vm.selectedInvoice['GST_Percentage_total']['GST_3'])+"\n                    "),_c('br'),_vm._v(" "),_c('b',[_vm._v("GST (5%): ")]),_vm._v("\n                     "+_vm._s(_vm.selectedInvoice['GST_Percentage_total']['GST_5'])+"\n                    "),_c('br'),_vm._v(" "),_c('b',[_vm._v("GST (12%): ")]),_vm._v("\n                     "+_vm._s(_vm.selectedInvoice['GST_Percentage_total']['GST_12'])+"\n                    "),_c('br'),_vm._v(" "),_c('b',[_vm._v("GST (18%):")]),_vm._v("\n                     "+_vm._s(_vm.selectedInvoice['GST_Percentage_total']['GST_18'])+"\n                    "),_c('br'),_vm._v(" "),_c('b',[_vm._v("GST (28%): ")]),_vm._v("\n                     "+_vm._s(_vm.selectedInvoice['GST_Percentage_total']['GST_28'])+"\n                    "),_c('br')])],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.invoiceProductListHeader,"items":_vm.selectedInvoice.items},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',[_vm._v(_vm._s(props.item['productName']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['HSN_code']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.taxableGST_rate))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['productUnit']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['quantity']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.rate))])]),_vm._v(" "),(_vm.businessType == 'Jwellery')?_c('td',[_c('b',[_vm._v(_vm._s(Number.parseFloat(props.item.netWeight).toFixed(3)))])]):_vm._e()]}}],null,false,3812208200)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.dialog11 = false}}},[_vm._v("Close")])],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customerPayments_vue__ = __webpack_require__(509);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4adb7bb0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customerPayments_vue__ = __webpack_require__(1530);
function injectStyle (ssrContext) {
  __webpack_require__(1527)
  __webpack_require__(1528)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_customerPayments_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4adb7bb0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_customerPayments_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1527 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1528 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return paymentReceiptPDF; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__digitsToWords_js__ = __webpack_require__(35);





var _this = this;

// Start - Payment Receipt

var getBase64ImageFromURL = function () {
	var _ref = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee(url) {
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						return _context.abrupt("return", new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
							var img = new Image();
							img.setAttribute("crossOrigin", "anonymous");

							img.onload = function () {
								var canvas = document.createElement("canvas");
								canvas.width = img.width;
								canvas.height = img.height;

								var ctx = canvas.getContext("2d");
								ctx.drawImage(img, 0, 0);

								var dataURL = canvas.toDataURL("image/png");

								resolve(dataURL);
							};

							img.onerror = function (error) {
								reject(error);
							};

							img.src = url;
						}));

					case 1:
					case "end":
						return _context.stop();
				}
			}
		}, _callee, _this);
	}));

	return function getBase64ImageFromURL(_x) {
		return _ref.apply(this, arguments);
	};
}();

var paymentReceiptPDF = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(metaData) {
		var pdfDoc, logoData, imgToExport, canvas, base64;
		return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						pdfDoc = {
							content: [{
								table: {
									widths: ['50%', '50%'],
									body: [[{
										image: 'sampleImage.jpg',
										width: 100,
										height: 80
									}, {
										text: [{ text: 'Firm Name\n', style: 'topFirmAuthority1' }, { text: 'Live Address\n', style: 'topFirmHeader' }, { text: 'Address\n', style: 'topFirmHeader' }, { text: 'GSTIN\n', style: 'topFirmHeader' }, { text: 'MOBILE\n', style: 'topFirmHeader' }, { text: 'EMAIL\n', style: 'topFirmHeader' }]
									}]]

								},
								layout: {
									hLineWidth: function hLineWidth(i, node) {
										return i === 0 || i === node.table.body.length ? 2 : 0;
									},
									vLineWidth: function vLineWidth(i, node) {
										return i === 0 || i === node.table.widths.length ? 2 : 0;
									},
									hLineColor: function hLineColor(i, node) {
										return i === 0 || i === node.table.body.length ? 'black' : 'white';
									},
									vLineColor: function vLineColor(i, node) {
										return i === 0 || i === node.table.widths.length ? 'black' : 'white';
									}
								}
							}, {
								table: {
									widths: ['100%'],
									body: [[{
										text: [{ text: 'CASH RECEIPT\n', style: "borderTitle" }]
									}]]
								}
							}, {
								table: {
									widths: ['100%'],
									body: [[{
										text: [{ text: 'RECEIPT NO                        :       ', bold: true, style: 'invoiceDetails' }, { text: '123\n', style: 'invoiceDetailsBlue' }, { text: 'DATE                                     :      ', bold: true, style: 'invoiceDetails' }, { text: '12/12/12 \n', style: 'invoiceDetailsBlue' }, { text: 'NAME                                   :      ', bold: true, style: 'invoiceDetails' }, { text: '1600  \n', style: 'invoiceDetailsBlue' }, { text: 'ADDRESS                             :      ', bold: true, style: 'invoiceDetails' }, { text: '7788996655\n', style: 'invoiceDetailsBlue' }, { text: 'AMOUNT (IN NUMBERS)  :      ', bold: true, style: "invoiceDetails" }, { text: '1679905\n', style: "invoiceDetailsBlue" }, { text: 'AMOUNT (IN WORDS)       :      ', bold: true, style: "invoiceDetails" }, { text: '23\n', style: "invoiceDetailsBlue" }, { text: 'PAYMENT TYPE                  :      ', bold: true, style: "invoiceDetails" }, { text: '23\n', style: "invoiceDetailsBlue" }]
									}]]
								}
							},
							//{text:'\n'},   
							{
								table: {
									widths: ['30%', '40%', '30%'],
									body: [[{
										text: [{ text: '\n', style: '' }, { text: '', style: 'invoiceDetails1' }]
									}, {
										text: [{ text: '\n', style: 'transpotationDel' }, { text: '', style: 'invoiceDetails1' }]
									}, {
										text: [{ text: '' }, { text: 'Firm Name  ', bold: true, alignment: 'center', style: 'topFirmAuthority' }, { text: '\n\n\n\n' }, { text: 'AUTHORITY SIGNATURE  ', bold: true, alignment: 'center', style: 'topFirmAuthority' }, { text: '\n' }]

									}]]

								},
								layout: {
									hLineWidth: function hLineWidth(i, node) {
										return i === 0 || i === node.table.body.length ? 2 : 0;
									},
									vLineWidth: function vLineWidth(i, node) {
										return i === 0 || i === node.table.widths.length ? 2 : 0;
									},
									hLineColor: function hLineColor(i, node) {
										return i === 0 || i === node.table.body.length ? 'black' : 'white';
									},
									vLineColor: function vLineColor(i, node) {
										return i === 0 || i === node.table.widths.length ? 'black' : 'white';
									}
								}
							}, {
								table: {
									widths: ['*'],
									body: [[{ text: 'Thank you! Stay at home. Be safe. Wear Mask', style: 'thankyouMsg' }]]
								}
							}],
							styles: {
								header: {
									fontSize: 15,
									bold: true,
									alignment: 'center',
									color: '#160091'
								},
								productHeader: {
									fontSize: 10,
									bold: true,
									alignment: 'center',
									color: '#160091'
								},
								transpotationDel: {
									fontSize: 9,
									bold: true,
									alignment: 'center',
									color: '#160091'
								},
								gstHeader: {
									fontSize: 8,
									color: '#160091',
									alignment: 'center'
								},
								gstHeader1: {
									fontSize: 10,
									color: '#160091',
									bold: true,
									alignment: 'center'
								},
								product: {
									fontSize: 9,
									alignment: 'center'
								},
								subproduct: {
									fontSize: 9,
									alignment: 'center'
								},
								product1: {
									fontSize: 7,
									alignment: 'center'
								},
								total: {
									fontSize: 10,
									alignment: 'center',
									bold: true
								},
								total1: {
									fontSize: 7,
									alignment: 'center'
								},
								topHeader: {
									color: '#160091',
									fontSize: 11,
									alignment: 'center',
									bold: true
								},
								topCustomerHeader: {
									color: '#160091',
									fontSize: 11,
									alignment: 'left',
									bold: true
								},

								topFirmAuthority: {
									color: '#160091',
									fontSize: 9,
									bold: true
								},
								topFirmAuthority1: {
									color: '#160091',
									fontSize: 12,
									bold: true
								},
								topFirmHeader: {
									fontSize: 10,
									bold: true
								},
								invoiceDetails: {
									fontSize: 10,
									bold: true
								},
								invoiceDetailsBlue: {
									fontSize: 10,
									bold: true,
									color: '#160091'
								},
								invoiceDetailsBlueConsignee: {
									fontSize: 11,
									bold: true,
									color: '#160091'
								},
								invoiceDetails1: {
									fontSize: 9,
									bold: true
								},
								totalAmountHeader: {
									color: '#160091',
									fontSize: 10,
									bold: true
								},
								invoiceStatusDetails: {
									color: '#FF0000',
									fontSize: 10,
									bold: true
								},
								thankyouMsg: {
									color: '#160091',
									fontSize: 12,
									bold: true,
									alignment: 'center'
								},
								borderTitle: {
									color: '#160091',
									fontSize: 11,
									alignment: 'center',
									bold: true
								}
							}

							//Firm Details 
						};
						pdfDoc.content[0].table.body[0][1].text[0].text = (metaData.firm.name ? metaData.firm.name.toUpperCase() : '') + "\n";
						pdfDoc.content[0].table.body[0][1].text[1].text = (metaData.firm.GST_number ? metaData.firm.GST_number : '') + "\n";
						pdfDoc.content[0].table.body[0][1].text[2].text = (metaData.firm.liveAddress ? metaData.firm.liveAddress : '') + "\n";
						pdfDoc.content[0].table.body[0][1].text[3].text = (metaData.firm.address ? metaData.firm.address : '') + "\n";
						pdfDoc.content[0].table.body[0][1].text[4].text = (metaData.firm.mobileNumber ? metaData.firm.mobileNumber : '') + "\n";
						pdfDoc.content[0].table.body[0][1].text[5].text = (metaData.firm.email ? metaData.firm.email : '') + "\n";

						//Customer and payment details

						pdfDoc.content[2].table.body[0][0].text[1].text = "" + "\n";
						pdfDoc.content[2].table.body[0][0].text[3].text = new Date(metaData.payment.date).toLocaleDateString('en-GB').toString() + "\n";
						pdfDoc.content[2].table.body[0][0].text[5].text = (metaData.customer.name ? metaData.customer.name.toUpperCase() : '') + "\n";
						pdfDoc.content[2].table.body[0][0].text[7].text = (metaData.customer.localAddress ? metaData.customer.localAddress.toUpperCase() : '') + "\n";
						pdfDoc.content[2].table.body[0][0].text[9].text = (metaData.payment.amount ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(metaData.payment.amount).toFixed(2) : '') + "\n";
						pdfDoc.content[2].table.body[0][0].text[11].text = (metaData.payment.amount ? _.startCase(Object(__WEBPACK_IMPORTED_MODULE_4__digitsToWords_js__["a" /* digitsToWords */])(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(metaData.payment.amount))) : '') + "\n";
						pdfDoc.content[2].table.body[0][0].text[13].text = (metaData.payment.paymentType ? metaData.payment.paymentType.toUpperCase() : '') + "\n";

						//authority
						pdfDoc.content[3].table.body[0][2].text[1].text = metaData.firm.name ? metaData.firm.name.toUpperCase() : '';

						// Logo 

						if (!metaData.terms.printLogo) {
							_context2.next = 29;
							break;
						}

						_context2.prev = 16;
						_context2.next = 19;
						return getBase64ImageFromURL(metaData.terms.printLogo);

					case 19:
						logoData = _context2.sent;

						pdfDoc.content[0].table.body[0][0].image = logoData;
						return _context2.abrupt("return", pdfDoc);

					case 24:
						_context2.prev = 24;
						_context2.t0 = _context2["catch"](16);

						console.log(_context2.t0);

					case 27:
						_context2.next = 36;
						break;

					case 29:
						imgToExport = document.getElementById('pdfimgToExport');
						canvas = document.createElement('canvas');

						canvas.width = imgToExport.width;
						canvas.height = imgToExport.height;
						canvas.getContext('2d').drawImage(imgToExport, 0, 0);
						base64 = canvas.toDataURL('image/png');

						pdfDoc.content[0].table.body[0][0].image = base64;

					case 36:
						return _context2.abrupt("return", pdfDoc);

					case 37:
					case "end":
						return _context2.stop();
				}
			}
		}, _callee2, _this, [[16, 24]]);
	}));

	return function paymentReceiptPDF(_x2) {
		return _ref2.apply(this, arguments);
	};
}();

/***/ }),
/* 1530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-flex',{attrs:{"xs12":"","sm1":"","md1":""}},[(_vm.$route.params.customerId !='null')?_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":'/buyers/'+_vm.$route.params.customerId+'/'+_vm.isBuyer}},[_c('b',{staticClass:"headline primary white--text"},[_vm._v("\n              "+_vm._s(_vm.isBuyer? 'Receipt' : 'Payment')+"\n            ")])]):_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":{ name: 'Dashboard'}}},[_c('b',{staticClass:"headline primary white--text"},[_vm._v("\n              "+_vm._s(_vm.isBuyer? 'Receipt' : 'Payment')+"\n            ")])])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-top":"12px","text-decoration":"none"},attrs:{"xs12":"","sm1":"","md1":""}},[_c('v-switch',{staticClass:"customer-switch",attrs:{"disabled":_vm.$route.params.customerId  !='null',"label":("" + (_vm.isBuyer ? 'Customer List' : 'Supplier List'))},model:{value:(_vm.isBuyer),callback:function ($$v) {_vm.isBuyer=$$v},expression:"isBuyer"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{staticClass:"customer-pay-select-firm",attrs:{"solo":"","dense":"","disabled":_vm.$route.params.customerId !='null',"items":_vm.customerListByBrand,"label":"Search Name","item-text":"name","item-value":"value","autocomplete":"","autofocus":true},model:{value:(_vm.currentUserId),callback:function ($$v) {_vm.currentUserId=$$v},expression:"currentUserId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm1":"","md1":""}},[(_vm.currentUser['.key'])?_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":{
                name: 'RemainingBalance',
                params: {
                  customerId: _vm.currentUser['.key'],
                },
              }}},[_c('v-btn',{staticClass:"primary--text",attrs:{"outlined":""}},[_vm._v("\n              Balance: "),_c('b',{staticClass:"font-weight-bolder"},[_vm._v(_vm._s(_vm._f("amount")(_vm.balance))+" ")])])],1):_vm._e()],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.currentUser['localAddress'])?_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_vm._v("\n             Address: "+_vm._s(_vm.currentUser['localAddress'])+"\n        ")]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[(_vm.$route.params.customerId !='null' || _vm.currentUser['.key'])?_c('v-btn',{staticClass:"primary--text",attrs:{"outlined":""},on:{"click":function($event){return _vm.addDiposit()}}},[_c('v-icon',[_vm._v("add")]),_vm._v("\n             \n              "+_vm._s(_vm.isBuyer? 'New Receipt' : 'New Payment')+"\n          ")],1):_vm._e()],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.paymentHeader,"items":_vm.paymentListByBrand,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item['amount'] || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item['remainingAmount'] || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(new Date(props.item.date).toLocaleDateString('en-GB')))])]),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":_vm.isSaving},on:{"click":function($event){return _vm.editPayment(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":_vm.isSaving},on:{"click":function($event){return _vm.deletePayment(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.printPayment(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("print")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"700px"},model:{value:(_vm.addDipositDialog),callback:function ($$v) {_vm.addDipositDialog=$$v},expression:"addDipositDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"title font-weight-light"},[_vm._v(_vm._s(_vm.isBuyer? 'Receipt' : 'Payment')+" Details")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-switch',{attrs:{"disabled":_vm.currentPayment['.key'],"label":"Multi-firm"},model:{value:(_vm.currentPayment.multiFirm),callback:function ($$v) {_vm.$set(_vm.currentPayment, "multiFirm", $$v)},expression:"currentPayment.multiFirm"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.addDipositDialog = false}}},[_c('v-icon',[_vm._v("mdi-close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"type":"number","readonly":"","label":"Receipt Number"},model:{value:(_vm.currentPayment.receiptNumber),callback:function ($$v) {_vm.$set(_vm.currentPayment, "receiptNumber", $$v)},expression:"currentPayment.receiptNumber"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"date-container",attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker),callback:function ($$v) {_vm.datepicker=$$v},expression:"datepicker"}},[_c('v-text-field',{staticClass:"payment-date",attrs:{"slot":"activator","label":"Date","readonly":""},slot:"activator",model:{value:(_vm.currentPayment.date),callback:function ($$v) {_vm.$set(_vm.currentPayment, "date", $$v)},expression:"currentPayment.date"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepicker = false}},model:{value:(_vm.currentPayment.date),callback:function ($$v) {_vm.$set(_vm.currentPayment, "date", $$v)},expression:"currentPayment.date"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm5":"","md5":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.firmsByBrand,"label":"Select Firm","disabled":_vm.currentPayment.multiFirm},on:{"change":function($event){_vm.checkValidity() && _vm.setReceiptNumber()}},model:{value:(_vm.currentPayment.firm),callback:function ($$v) {_vm.$set(_vm.currentPayment, "firm", $$v)},expression:"currentPayment.firm"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-select',{attrs:{"dense":"","items":[{
                            text: 'Cash',
                            value: 'Cash'
                          }, {
                            text: 'Bank Account',
                            value: 'Bank Account'
                          }],"label":"Select Payment Type"},on:{"change":function($event){return _vm.checkValidity()}},model:{value:(_vm.currentPayment.paymentType),callback:function ($$v) {_vm.$set(_vm.currentPayment, "paymentType", $$v)},expression:"currentPayment.paymentType"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[(['Cash'].includes(_vm.currentPayment.paymentType))?_c('v-text-field',{attrs:{"type":"number","label":"Amount from Cash","hint":_vm.hintText},on:{"keyup":function($event){return _vm.checkValidity()}},model:{value:(_vm.currentPayment.amount),callback:function ($$v) {_vm.$set(_vm.currentPayment, "amount", $$v)},expression:"currentPayment.amount"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[(['Bank Account'].includes(_vm.currentPayment.paymentType))?_c('v-select',{attrs:{"dense":"","items":_vm.banksByFirms,"label":"Select Bank","disabled":_vm.currentPayment.paymentType == 'Cash' || _vm.currentPayment.paymentType == '',"required":""},on:{"change":function($event){return _vm.checkValidity()}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n                        "+_vm._s(data.item.account.accountnumber)+"\n                        "+_vm._s(data.item.account.bankName ? ' | '+ data.item.account.bankName : '')+"\n                    ")]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(((data.item.account.accountnumber) + "\n                                " + (data.item.account.bankName ? ' | '+data.item.account.bankName : '') + "\n                                " + (data.item.account.accountType ? ' | '+data.item.account.accountType : '') + "\n                                | ₹: " + ((data.item.account.amount || 0).toLocaleString()))
                            )}})],1)]}}],null,false,3864183265),model:{value:(_vm.currentPayment.bank),callback:function ($$v) {_vm.$set(_vm.currentPayment, "bank", $$v)},expression:"currentPayment.bank"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[(['Bank Account'].includes(_vm.currentPayment.paymentType))?_c('v-text-field',{attrs:{"type":"number","label":"Amount from Bank","hint":_vm.hintText},on:{"keyup":function($event){return _vm.checkValidity()}},model:{value:(_vm.currentPayment.amount),callback:function ($$v) {_vm.$set(_vm.currentPayment, "amount", $$v)},expression:"currentPayment.amount"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[(['Bank Account'].includes(_vm.currentPayment.paymentType))?_c('v-select',{attrs:{"dense":"","disabled":_vm.currentPayment.paymentType == 'Cash' || _vm.currentPayment.paymentType == '',"items":[{
                        text: 'Cheque',
                        value: 'Cheque'
                      }, {
                        text: 'NEFT',
                        value: 'NEFT'
                      }, {
                        text: 'RTGS',
                        value: 'RTGS'
                      }, {
                        text: 'IMPS',
                        value: 'IMPS'
                      }, {
                        text: 'UPI',
                        value: 'UPI'
                      }],"label":"Select Transfer type"},on:{"change":function($event){return _vm.checkValidity()},"input":function($event){_vm.transferTypeDialog = true}},model:{value:(_vm.transferType),callback:function ($$v) {_vm.transferType=$$v},expression:"transferType"}}):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"blue darken-1","flat":"","disabled":_vm.isSaving},on:{"click":function($event){_vm.addDipositDialog = false}}},[_vm._v("Back")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!_vm.currentPayment['.key'])?_c('v-btn',{attrs:{"color":"blue darken-1","disabled":!_vm.isValidSave || _vm.isSaving,"flat":""},on:{"click":_vm.getUserInvoices}},[_vm._v("Save")]):_vm._e(),_vm._v(" "),(!!_vm.currentPayment['.key'])?_c('v-btn',{attrs:{"color":"blue darken-1","disabled":!_vm.isValidSave  || _vm.isSaving,"flat":""},on:{"click":_vm.saveUpdatedPayment}},[_vm._v("Update")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.transferTypeDialog),callback:function ($$v) {_vm.transferTypeDialog=$$v},expression:"transferTypeDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("\n          Transfer Information\n          "),_c('b',[_vm._v(_vm._s(_vm.transferType))])])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","label":"A/C Number"},model:{value:(_vm.transferDetails.accountNumber),callback:function ($$v) {_vm.$set(_vm.transferDetails, "accountNumber", $$v)},expression:"transferDetails.accountNumber"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"text","label":"A/C Holder Name"},model:{value:(_vm.transferDetails.accountHolderName),callback:function ($$v) {_vm.$set(_vm.transferDetails, "accountHolderName", $$v)},expression:"transferDetails.accountHolderName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"text","label":"Bank Name"},model:{value:(_vm.transferDetails.bankName),callback:function ($$v) {_vm.$set(_vm.transferDetails, "bankName", $$v)},expression:"transferDetails.bankName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"text","label":"IFSC Code"},model:{value:(_vm.transferDetails.IFSCcode),callback:function ($$v) {_vm.$set(_vm.transferDetails, "IFSCcode", $$v)},expression:"transferDetails.IFSCcode"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"text","label":"Remark"},model:{value:(_vm.transferDetails.remark),callback:function ($$v) {_vm.$set(_vm.transferDetails, "remark", $$v)},expression:"transferDetails.remark"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.transferTypeDialog = false}}},[_vm._v("Ok")])],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":3000,"top":"","color":"success"},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.successText)+"\n  ")]),_vm._v(" "),_c('v-dialog',{attrs:{"width":"800","persistent":""},model:{value:(_vm.passwordDialog),callback:function ($$v) {_vm.passwordDialog=$$v},expression:"passwordDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline primary--text",attrs:{"primary-title":""}},[_vm._v("\n        Enter the password\n        "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"primary",attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.passwordDialog = false}}},[_c('v-icon',[_vm._v("mdi-close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"type":"password","label":"Password","autocomplete":"false"},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.deleteFromDialog()}}},[_vm._v("Delete")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PortfolioManagement_vue__ = __webpack_require__(510);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_172f4b83_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PortfolioManagement_vue__ = __webpack_require__(1534);
function injectStyle (ssrContext) {
  __webpack_require__(1532)
  __webpack_require__(1533)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-172f4b83"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PortfolioManagement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_172f4b83_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PortfolioManagement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1532 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1533 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"text-xs-center"},[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":{ name: 'Dashboard'}}},[_c('b',{staticClass:"title primary white--text"},[_vm._v("\n              Manage Portfolio\n            ")])])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-select',{attrs:{"solo":"","clearable":"","items":_vm.getPortfolioCustomers,"label":"Buyers"},model:{value:(_vm.selectedCustomer),callback:function ($$v) {_vm.selectedCustomer=$$v},expression:"selectedCustomer"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-select',{attrs:{"solo":"","clearable":"","items":['IN PROGRESS', 'CANCELLED', 'BILLED', 'ALL'],"label":"Filter"},model:{value:(_vm.statusFilter),callback:function ($$v) {_vm.statusFilter=$$v},expression:"statusFilter"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"outlined":""},on:{"click":function($event){return _vm.addPortfolioDialog()}}},[_c('v-icon',{attrs:{"left":"","color":"teal"}},[_vm._v("add")]),_vm._v(" New Portfolio\n        ")],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.portfolioHeader,"items":_vm.portfoliosByBrand,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('v-menu',{attrs:{"bottom":"","right":"","offset-y":"","close-on-content-click":false}},[_c('v-btn',{staticClass:"mx-0",attrs:{"slot":"activator","icon":"","dark":""},slot:"activator"},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',[_c('v-list-group',{attrs:{"prepend-icon":'picture_as_pdf',"no-action":""},scopedSlots:_vm._u([{key:"activator",fn:function(){return [_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Actions")])],1)],1)]},proxy:true}],null,true)},[_vm._v(" "),(props.item['portfolioHistory'])?_c('v-list-tile',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.openHistory(props.item)}}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("history")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Portfolio History")])],1):_vm._e(),_vm._v(" "),(props.item['status'] == 'IN PROGRESS')?_c('v-list-tile',{on:{"click":function($event){return _vm.editPortfolio(props.item)}}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Edit Portfolio")])],1):_vm._e(),_vm._v(" "),(props.item['status'] == 'IN PROGRESS')?_c('v-list-tile',{on:{"click":function($event){return _vm.editPortfolio(props.item)}}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Return Items")])],1):_vm._e(),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.deletePortfolio(props.item)}}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("delete")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Delete Portfolio")])],1)],1)],1)],1)],1),_vm._v(" "),_c('td',[_c('v-icon',{attrs:{"disabled":props.item['status'] == 'CANCELLED' ||
                props.item['status'] == 'BILLED' ||
                (_vm.getCustomerName(props.item.buyerId) == 'DELETED CUSTOMER'
                  ? _vm.isShopUserExists(props.item.shopPortfolioUserId)
                    ? false
                    : true
                  : false),"color":"primary"},on:{"click":function($event){return _vm.openProd(props.item)}}},[_vm._v("remove_red_eye")])],1),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["portfolioNumber"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(new Date(props.item.date).toLocaleDateString("en-GB")))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["invoiceDate"]
                ? new Date(props.item.invoiceDate).toLocaleDateString("en-GB")
                : ""))])]),_vm._v(" "),_c('td',[(props.item.buyerId)?_c('b',[_vm._v(_vm._s(_vm.getCustomerName(props.item.buyerId)))]):(_vm.isShopUserExists(props.item.shopPortfolioUserId))?_c('b',[_vm._v(_vm._s(_vm.getShopUserName(props.item.shopPortfolioUserId)))]):_c('b',[_c('v-btn',{on:{"click":function($event){return _vm.addShopUser(props.item)}}},[_vm._v(_vm._s(props.item.shopPortfolioUserName))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_vm._v("New Customer. Click To Create Buyer.")])],1)]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["status"]))])])]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","fullscreen":""},model:{value:(_vm.portfolioDialog),callback:function ($$v) {_vm.portfolioDialog=$$v},expression:"portfolioDialog"}},[_c('v-card',{attrs:{"persistent":""}},[_c('v-card-title',{staticClass:"primary white--text"},[(_vm.isEdit)?_c('span',{staticClass:"headline"},[_vm._v("Edit Portfolio")]):_c('span',{staticClass:"headline"},[_vm._v("Create Portfolio")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"large":"","icon":"","flat":""},on:{"click":function($event){_vm.portfolioDialog = false}}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"disabled":_vm.isEdit,"label":("" + (_vm.isBuyer ? 'Sale Portfolio' : 'Purchase Portfolio'))},model:{value:(_vm.isBuyer),callback:function ($$v) {_vm.isBuyer=$$v},expression:"isBuyer"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"disabled":_vm.isEdit,"label":"Multi-firm"},on:{"change":function($event){return _vm.restructureProductList()}},model:{value:(_vm.multiFirm),callback:function ($$v) {_vm.multiFirm=$$v},expression:"multiFirm"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-select',{attrs:{"dense":"","disabled":_vm.multiFirm,"items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-select',{attrs:{"items":_vm.isBuyer ? _vm.buyersByBrand : _vm.sellersByBrand,"label":_vm.isBuyer ? 'Select or add Buyer' : 'Select or add Seller',"autocomplete":"","disabled":_vm.isEdit,"item-text":"name","return-object":""},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addCustomer($event)}},model:{value:(_vm.selectedBuyer),callback:function ($$v) {_vm.selectedBuyer=$$v},expression:"selectedBuyer"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerPortfolio),callback:function ($$v) {_vm.datepickerPortfolio=$$v},expression:"datepickerPortfolio"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Portfolio Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerPortfolio = false}},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-text-field',{attrs:{"prefix":"#","label":"Serial Number","placeholder":"Enter Serial Number","required":""},model:{value:(_vm.portfolioNumber),callback:function ($$v) {_vm.portfolioNumber=$$v},expression:"portfolioNumber"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},_vm._l((_vm.items),function(item,index){return _c('v-layout',{key:index + item.productId,style:(item.isReturn
                    ? 'background: #f7c4c4;'
                    : 'background: #c5f7c4;'),attrs:{"wrap":""}},[_c('v-flex',{staticStyle:{"padding-left":"20px"},attrs:{"xs1":"","sm1":"","md1":""}},[(!item.isReturn)?_c('v-checkbox',{attrs:{"color":"indigo","hide-details":""},model:{value:(item.selected),callback:function ($$v) {_vm.$set(item, "selected", $$v)},expression:"item.selected"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs2":"","sm2":"","md2":""}},[_c('v-select',{attrs:{"dense":"","autocomplete":"","item-text":"name","item-value":'name',"items":_vm.productListByBrand,"label":"Product Name"},on:{"change":function($event){return _vm.restructureProductList(index)}},model:{value:(item.productName),callback:function ($$v) {_vm.$set(item, "productName", $$v)},expression:"item.productName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[(item.productName)?_c('v-text-field',{attrs:{"type":"number","label":"Quantity"},model:{value:(item.quantity),callback:function ($$v) {_vm.$set(item, "quantity", _vm._n($$v))},expression:"item.quantity"}}):_vm._e()],1),_vm._v(" "),(_vm.isJewlBusiness)?_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[(item.productName)?_c('v-text-field',{attrs:{"type":"number","label":"Purity"},model:{value:(item.purity),callback:function ($$v) {_vm.$set(item, "purity", _vm._n($$v))},expression:"item.purity"}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}},[(item.productName)?_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker1[index]),callback:function ($$v) {_vm.$set(_vm.datepicker1, index, $$v)},expression:"datepicker1[index]"}},[(item.productName)?_c('v-text-field',{attrs:{"slot":"activator","label":item.isReturn ? 'Return Date' : 'Sell Date',"prepend-icon":"event","readonly":""},slot:"activator",model:{value:(item.date),callback:function ($$v) {_vm.$set(item, "date", $$v)},expression:"item.date"}}):_vm._e(),_vm._v(" "),(item.productName)?_c('v-date-picker',{on:{"input":function($event){_vm.datepicker1[index] = false}},model:{value:(item.date),callback:function ($$v) {_vm.$set(item, "date", $$v)},expression:"item.date"}}):_vm._e()],1):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[(item.productName)?_c('v-text-field',{attrs:{"type":"number","label":"Rate"},model:{value:(item.rate),callback:function ($$v) {_vm.$set(item, "rate", _vm._n($$v))},expression:"item.rate"}}):_vm._e()],1),_vm._v(" "),(_vm.isJewlBusiness)?_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[(item.productName)?_c('v-text-field',{attrs:{"type":"number","label":"Gross Weight"},model:{value:(item.grossWeight),callback:function ($$v) {_vm.$set(item, "grossWeight", _vm._n($$v))},expression:"item.grossWeight"}}):_vm._e()],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}},[(index == _vm.items.length - 1 && item.productName)?_c('v-btn',{attrs:{"icon":"","color":"primary"},on:{"click":function($event){return _vm.addProd()}}},[_c('v-icon',[_vm._v("add_circle")])],1):_vm._e(),_vm._v(" "),(item.productName)?_c('v-btn',{attrs:{"icon":"","color":"primary"},on:{"click":function($event){return _vm.removeProd(index)}}},[_c('v-icon',[_vm._v("cancel")])],1):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs1":"","sm1":"","md1":""}},[(item.productName && !item.isReturn)?_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){return _vm.addProd(item, index)}}},[_vm._v("\n                    Return\n                  ")]):_vm._e()],1)],1)}),1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"blue darken-1"},on:{"click":function($event){return _vm.combinePortfolio()}}},[_vm._v("Combine Selected Items")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){_vm.portfolioDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","disabled":!_vm.items.length ||
            !_vm.selectedBuyer ||
            !_vm.items[0].productId ||
            (_vm.multiFirm ? false : !_vm.selectedFirm),"flat":""},on:{"click":function($event){return _vm.addPortfolio()}}},[_vm._v(_vm._s(_vm.isEdit ? "Save" : "Create"))])],1)],1)],1),_vm._v(" "),(_vm.selectedPortfolio && _vm.selectedPortfolio['.key'])?_c('v-dialog',{attrs:{"width":"1200"},model:{value:(_vm.invoicePortfolio),callback:function ($$v) {_vm.invoicePortfolio=$$v},expression:"invoicePortfolio"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline grey lighten-2",attrs:{"primary-title":""}},[_vm._v("Portfolio details:-\n        ")]),_vm._v(" "),_c('v-card-text',[_c('v-checkbox',{attrs:{"color":"indigo","label":"Select All"},model:{value:(_vm.selectAll),callback:function ($$v) {_vm.selectAll=$$v},expression:"selectAll"}}),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.productHeaderCreateInvoice,"items":_vm.selectedPortfolio.items},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{style:(props.item.isReturn
                  ? 'background: #f7c4c4;'
                  : 'background: #c5f7c4;')},[_c('td',[_c('v-checkbox',{attrs:{"color":"indigo","hide-details":""},model:{value:(props.item.selected),callback:function ($$v) {_vm.$set(props.item, "selected", $$v)},expression:"props.item.selected"}})],1),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["productName"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["quantity"]))])]),_vm._v(" "),(_vm.isJewlBusiness)?_c('td',[_c('b',[_c('v-text-field',{attrs:{"type":"number","label":"Purity"},model:{value:(props.item.purity),callback:function ($$v) {_vm.$set(props.item, "purity", _vm._n($$v))},expression:"props.item.purity"}})],1)]):_vm._e(),_vm._v(" "),(_vm.isJewlBusiness)?_c('td',[_c('b',[_vm._v(_vm._s(props.item.grossWeight))])]):_vm._e(),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(new Date(props.item.date).toISOString().substr(0, 10)))])]),_vm._v(" "),_c('td',[_c('b',[_c('v-text-field',{attrs:{"type":"number","label":"Product Rate"},model:{value:(props.item.rate),callback:function ($$v) {_vm.$set(props.item, "rate", _vm._n($$v))},expression:"props.item.rate"}})],1)]),_vm._v(" "),_c('td',[_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.fetchLatestRate(props.item)}}},[_vm._v("Fetch Rate")])],1)])]}}],null,false,429330559)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.invoicePortfolio = false}}},[_vm._v("Back")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.createInvoice()}}},[_vm._v("Create Invoice\n        ")])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.selectedPortfolio && _vm.selectedPortfolio['.key'])?_c('v-dialog',{attrs:{"width":"1200"},model:{value:(_vm.portfolioHistory),callback:function ($$v) {_vm.portfolioHistory=$$v},expression:"portfolioHistory"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline grey lighten-2",attrs:{"primary-title":""}},[_vm._v("Portfolio History:-\n        ")]),_vm._v(" "),_c('v-card-text',[[_c('v-stepper',{attrs:{"vertical":""},model:{value:(_vm.historyStep),callback:function ($$v) {_vm.historyStep=$$v},expression:"historyStep"}},[_vm._l((_vm.selectedPortfolio.portfolioHistory),function(item,index){return [_c('v-stepper-step',{key:item['.key'],attrs:{"step":index + 1}},[_c('v-link',{on:{"click":function($event){_vm.historyStep = index + 1}}},[_vm._v(_vm._s(new Date(item["date"]).toLocaleDateString("en-GB") +
                  (item["type"] == "INVOICE" ? "  -  Invoice created" : "")))])],1),_vm._v(" "),_c('v-stepper-content',{key:index,attrs:{"step":index + 1}},[_c('v-card',{staticClass:"mb-12 invoice-stepper"},[_c('v-layout',{staticStyle:{"padding":"30px"},attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('h2',{staticStyle:{"text-decoration":"underline","text-align":"center"}},[_vm._v("\n                        Product List\n                      ")]),_vm._v(" "),[_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.productInvoiceHeader,"items":item.items},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{style:(props.item.isReturn
                                  ? 'background: #f7c4c4;'
                                  : 'background: #c5f7c4;')},[_c('td',[_c('b',[_vm._v(_vm._s(props.item["productName"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["quantity"]))])]),_vm._v(" "),(_vm.isJewlBusiness)?_c('td',[_c('b',[_vm._v(_vm._s(props.item["purity"]))])]):_vm._e(),_vm._v(" "),(_vm.isJewlBusiness)?_c('td',[_c('b',[_vm._v(_vm._s(props.item.grossWeight))])]):_vm._e(),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(new Date(props.item.date)
                                    .toISOString()
                                    .substr(0, 10)))])]),_vm._v(" "),_c('td',[_c('b',[_c('v-text-field',{attrs:{"type":"number","label":"Product Rate"},model:{value:(props.item.rate),callback:function ($$v) {_vm.$set(props.item, "rate", _vm._n($$v))},expression:"props.item.rate"}})],1)]),_vm._v(" "),_c('td',[_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.fetchLatestRate(props.item)}}},[_vm._v("Fetch Rate")])],1)])]}}],null,true)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)]],2)],1)],1)],1)]})],2)]],2),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.portfolioHistory = false}}},[_vm._v("Back")])],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_receiptList_vue__ = __webpack_require__(511);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a912f23_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_receiptList_vue__ = __webpack_require__(1538);
function injectStyle (ssrContext) {
  __webpack_require__(1536)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_receiptList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a912f23_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_receiptList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1536 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return convertToPDFReport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);


// playground requires you to assign document definition to a variable called dd
var convertToPDFReport = function convertToPDFReport(_ref) {
    var invoiceData = _ref.invoiceData,
        firm = _ref.firm,
        fromDate = _ref.fromDate,
        toDate = _ref.toDate;

    var dd = {
        //pageOrientation: 'landscape',
        content: [{
            table: {
                widths: ['20%', '40%', '20%', '20%'],
                body: [[{ text: '', style: "reportHeader1" }, { text: 'FIRM NOT SELECTED\n', style: "reportHeader" }, { text: 'From:NOT SELECTED\n', style: "reportHeader" }, { text: 'To:  NOT SELECTED\n', style: "reportHeader" }]]
            }

        }, { text: '\n', style: '' }, {
            table: {
                widths: ['20%', '20%', '20%', '20%', '20%'],
                body: [[

                // { text: 'Firm', style: "gstHeader" },
                { text: 'Date', style: "gstHeader" }, { text: 'Customer Name', style: "gstHeader" }, { text: 'Receipt Number', style: "gstHeader" }, { text: 'Amount', style: "gstHeader" }, { text: 'Payment type', style: "gstHeader" }]]
            }

        }],
        styles: {
            gstHeader: {
                fontSize: 9,
                bold: true,
                alignment: 'center'
            },
            gstHeaderBuyer1: {
                fontSize: 6,
                bold: true,
                alignment: 'center',
                color: '#160091'
            },
            gstHeaderTotal1: {
                fontSize: 6,
                bold: true,
                alignment: 'center',
                color: '#160091'
            },
            gstHeaderBasic1: {
                fontSize: 10,
                bold: true,
                alignment: 'center'
            },
            gstHeaderBuyer: {
                fontSize: 8,
                bold: true,
                alignment: 'left',
                color: '#160091'
            },
            gstHeaderTotal: {
                fontSize: 8,
                bold: true,
                alignment: 'right',
                color: '#160091'
            },
            gstHeaderBasic: {
                fontSize: 10,
                bold: true,
                alignment: 'right'
            },
            gstData: {
                fontSize: 9,
                bold: true,
                alignment: 'center'
            },
            gstHeaderInvoice: {
                fontSize: 7,
                bold: true,
                alignment: 'left'
            },
            reportHeader: {
                fontSize: 12,
                bold: true,
                alignment: 'center'
            },
            reportHeader1: {
                fontSize: 14,
                bold: true,
                alignment: 'left',
                color: "#160091"
            }
        }

    };

    dd.content[0].table.body[0][0].text = "Receipt Register";
    if (firm) {
        dd.content[0].table.body[0][1].text = '' + firm + '\n';
    }
    if (fromDate) {
        dd.content[0].table.body[0][2].text = 'From ' + fromDate + '\n';
    }
    if (toDate) {
        dd.content[0].table.body[0][3].text = 'To ' + toDate + '\n';
    }

    invoiceData.map(function (invoice) {
        dd.content[2].table.body.push([

        // { text: invoice.firmName, style: "gstData" },
        { text: new Date(invoice.date).toLocaleDateString("en-IN"), style: "gstData" }, { text: invoice.buyerName, style: "gstData" }, { text: invoice.receiptNumber, style: "gstData" }, { text: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(invoice.amount).toFixed(2), style: "gstHeaderBasic" }, { text: invoice.paymentType, style: "gstData" }]);
    });
    return dd;
};

/***/ }),
/* 1538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"invoiceList"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-toolbar',{staticClass:"primary white--text",staticStyle:{"margin-top":"10px"}},[_c('v-flex',{attrs:{"xs12":"","md1":"","sm1":""}},[_c('h3',{staticClass:"title font-weight-light"},[_vm._v("Receipt Register")])]),_vm._v(" "),[_c('v-flex',{attrs:{"xs12":"","md2":"","sm2":""}},[_c('v-select',{staticClass:"select-firm",attrs:{"dense":"","items":_vm.firmsByBrand,"label":"Select Firm","clearable":""},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-menu',{staticClass:"white-datepicker",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerFrom),callback:function ($$v) {_vm.datepickerFrom=$$v},expression:"datepickerFrom"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"From Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.dateFrom),callback:function ($$v) {_vm.dateFrom=$$v},expression:"dateFrom"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerFrom = false}},model:{value:(_vm.dateFrom),callback:function ($$v) {_vm.dateFrom=$$v},expression:"dateFrom"}})],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-menu',{staticClass:"white-datepicker",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerTo),callback:function ($$v) {_vm.datepickerTo=$$v},expression:"datepickerTo"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"To Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.dateTo),callback:function ($$v) {_vm.dateTo=$$v},expression:"dateTo"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerTo = false}},model:{value:(_vm.dateTo),callback:function ($$v) {_vm.dateTo=$$v},expression:"dateTo"}})],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md1":"","sm1":""}},[_c('v-btn',{staticStyle:{"float":"left"},attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.print()}}},[_c('v-icon',{staticClass:"primary white--text"},[_vm._v("\n                picture_as_pdf\n              ")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('router-link',{attrs:{"to":"/Dashboard"}},[_c('v-btn',{staticStyle:{"float":"right"},attrs:{"icon":"","dark":""}},[_c('v-icon',[_vm._v("close")])],1)],1)],1)]],2)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation transaction-table",attrs:{"items":_vm.normalData,"pagination":_vm.pagination,"headers":_vm.headers},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',[_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(props.item.firmName))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(new Date(props.item.date).toLocaleDateString("en-IN")))])]),_vm._v(" "),_c('td',[(props.item.buyerId)?_c('b',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(props.item.buyerName)+"\n            ")]):_vm._e()]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v("\n              "+_vm._s(props.item.receiptNumber || '')+"\n            ")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v("\n              "+_vm._s(_vm._f("amount")(props.item.amount || 0))+"\n            ")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(props.item.paymentType))])])])]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No rows to Show")])],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_paymentList_vue__ = __webpack_require__(512);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c8fd406_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_paymentList_vue__ = __webpack_require__(1542);
function injectStyle (ssrContext) {
  __webpack_require__(1540)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_paymentList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c8fd406_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_paymentList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1540 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return convertToPDFReport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);


// playground requires you to assign document definition to a variable called dd
var convertToPDFReport = function convertToPDFReport(_ref) {
    var invoiceData = _ref.invoiceData,
        firm = _ref.firm,
        fromDate = _ref.fromDate,
        toDate = _ref.toDate;

    var dd = {
        //pageOrientation: 'landscape',
        content: [{
            table: {
                widths: ['20%', '40%', '20%', '20%'],
                body: [[{ text: '', style: "reportHeader1" }, { text: 'FIRM NOT SELECTED\n', style: "reportHeader" }, { text: 'From:NOT SELECTED\n', style: "reportHeader" }, { text: 'To:  NOT SELECTED\n', style: "reportHeader" }]]
            }

        }, { text: '\n', style: '' }, {
            table: {
                widths: ['20%', '20%', '20%', '20%', '20%'],
                body: [[

                // { text: 'Firm', style: "gstHeader" },
                { text: 'Date', style: "gstHeader" }, { text: 'Customer Name', style: "gstHeader" }, { text: 'Payment Number', style: "gstHeader" }, { text: 'Amount', style: "gstHeader" }, { text: 'Payment type', style: "gstHeader" }]]
            }

        }],
        styles: {
            gstHeader: {
                fontSize: 9,
                bold: true,
                alignment: 'center'
            },
            gstHeaderBuyer1: {
                fontSize: 6,
                bold: true,
                alignment: 'center',
                color: '#160091'
            },
            gstHeaderTotal1: {
                fontSize: 6,
                bold: true,
                alignment: 'center',
                color: '#160091'
            },
            gstHeaderBasic1: {
                fontSize: 10,
                bold: true,
                alignment: 'center'
            },
            gstHeaderBuyer: {
                fontSize: 8,
                bold: true,
                alignment: 'left',
                color: '#160091'
            },
            gstHeaderTotal: {
                fontSize: 8,
                bold: true,
                alignment: 'right',
                color: '#160091'
            },
            gstHeaderBasic: {
                fontSize: 10,
                bold: true,
                alignment: 'right'
            },
            gstData: {
                fontSize: 9,
                bold: true,
                alignment: 'center'
            },
            gstHeaderInvoice: {
                fontSize: 7,
                bold: true,
                alignment: 'left'
            },
            reportHeader: {
                fontSize: 12,
                bold: true,
                alignment: 'center'
            },
            reportHeader1: {
                fontSize: 14,
                bold: true,
                alignment: 'left',
                color: "#160091"
            }
        }

    };

    dd.content[0].table.body[0][0].text = "Payment Register";
    if (firm) {
        dd.content[0].table.body[0][1].text = '' + firm + '\n';
    }
    if (fromDate) {
        dd.content[0].table.body[0][2].text = 'From ' + fromDate + '\n';
    }
    if (toDate) {
        dd.content[0].table.body[0][3].text = 'To ' + toDate + '\n';
    }

    invoiceData.map(function (invoice) {
        dd.content[2].table.body.push([

        // { text: invoice.firmName, style: "gstData" },
        { text: new Date(invoice.date).toLocaleDateString("en-IN"), style: "gstData" }, { text: invoice.buyerName, style: "gstData" }, { text: invoice.receiptNumber, style: "gstData" }, { text: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(invoice.amount).toFixed(2), style: "gstHeaderBasic" }, { text: invoice.paymentType, style: "gstData" }]);
    });
    return dd;
};

/***/ }),
/* 1542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"invoiceList"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-toolbar',{staticClass:"primary white--text",staticStyle:{"margin-top":"10px"}},[_c('v-flex',{attrs:{"xs12":"","md1":"","sm1":""}},[_c('h3',{staticClass:"title font-weight-light"},[_vm._v("Payment Register")])]),_vm._v(" "),[_c('v-flex',{attrs:{"xs12":"","md2":"","sm2":""}},[_c('v-select',{staticClass:"select-firm",attrs:{"dense":"","items":_vm.firmsByBrand,"label":"Select Firm","clearable":""},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-menu',{staticClass:"white-datepicker",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerFrom),callback:function ($$v) {_vm.datepickerFrom=$$v},expression:"datepickerFrom"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"From Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.dateFrom),callback:function ($$v) {_vm.dateFrom=$$v},expression:"dateFrom"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerFrom = false}},model:{value:(_vm.dateFrom),callback:function ($$v) {_vm.dateFrom=$$v},expression:"dateFrom"}})],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-menu',{staticClass:"white-datepicker",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerTo),callback:function ($$v) {_vm.datepickerTo=$$v},expression:"datepickerTo"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"To Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.dateTo),callback:function ($$v) {_vm.dateTo=$$v},expression:"dateTo"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerTo = false}},model:{value:(_vm.dateTo),callback:function ($$v) {_vm.dateTo=$$v},expression:"dateTo"}})],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md1":"","sm1":""}},[_c('v-btn',{staticStyle:{"float":"left"},attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.print()}}},[_c('v-icon',{staticClass:"primary white--text"},[_vm._v("\n                picture_as_pdf\n              ")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('router-link',{attrs:{"to":"/Dashboard"}},[_c('v-btn',{staticStyle:{"float":"right"},attrs:{"icon":"","dark":""}},[_c('v-icon',[_vm._v("close")])],1)],1)],1)]],2)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation transaction-table",attrs:{"items":_vm.normalData,"pagination":_vm.pagination,"headers":_vm.headers},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',[_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(props.item.firmName))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(new Date(props.item.date).toLocaleDateString("en-IN")))])]),_vm._v(" "),_c('td',[(props.item.buyerId)?_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(props.item.buyerName)+"\n            ")]):_vm._e()]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v("\n              "+_vm._s(props.item.receiptNumber || '')+"\n            ")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"red--text font-weight-bold"},[_vm._v("\n              "+_vm._s(_vm._f("amount")(props.item.amount || 0))+"\n            ")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(props.item.paymentType))])])])]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No rows to Show")])],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReceiptCollection_vue__ = __webpack_require__(513);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68d7c5ed_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReceiptCollection_vue__ = __webpack_require__(1546);
function injectStyle (ssrContext) {
  __webpack_require__(1544)
  __webpack_require__(1545)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-68d7c5ed"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReceiptCollection_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68d7c5ed_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReceiptCollection_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1544 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1545 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"text-xs-center"},[_vm._v("\n          Receipt Collection\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-select',{attrs:{"solo":"","clearable":"","items":_vm.getReceiptCollectionCustomers,"label":"Buyers","item-text":"name","return-object":""},model:{value:(_vm.selectedCustomer),callback:function ($$v) {_vm.selectedCustomer=$$v},expression:"selectedCustomer"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-select',{attrs:{"solo":"","clearable":"","items":['PENDING', 'CONFIRMED', 'ALL'],"label":"Filter"},model:{value:(_vm.statusFilter),callback:function ($$v) {_vm.statusFilter=$$v},expression:"statusFilter"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"outlined":""},on:{"click":function($event){return _vm.addReceiptCollectionDialog()}}},[_c('v-icon',{attrs:{"left":"","color":"teal"}},[_vm._v("add")]),_vm._v(" New Receipt Collection\n        ")],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.receiptCollectionHeader,"items":_vm.receiptCollectionsByBrand,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('v-menu',{attrs:{"bottom":"","right":"","offset-y":"","close-on-content-click":false}},[_c('v-btn',{staticClass:"mx-0",attrs:{"slot":"activator","icon":"","dark":""},slot:"activator"},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',[_c('v-list-group',{attrs:{"prepend-icon":'picture_as_pdf',"no-action":""},scopedSlots:_vm._u([{key:"activator",fn:function(){return [_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Actions")])],1)],1)]},proxy:true}],null,true)},[_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item[".key"]))])]),_vm._v(" "),(props.item['orderHistory'])?_c('v-list-tile',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.openHistory(props.item)}}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("history")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Receipt Collection History")])],1):_vm._e(),_vm._v(" "),(props.item['status'] == 'PENDING')?_c('v-list-tile',{on:{"click":function($event){return _vm.editReceiptCollection(props.item)}}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Edit Receipt Collection")])],1):_vm._e(),_vm._v(" "),(props.item['status'] == 'PENDING')?_c('v-list-tile',{on:{"click":function($event){return _vm.editReceiptCollection(props.item)}}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Return Items")])],1):_vm._e(),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.deleteReceiptCollection(props.item)}}},[_c('v-list-tile-avatar',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("delete")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Delete Receipt Collection")])],1)],1)],1)],1)],1),_vm._v(" "),_c('td',[_c('v-icon',{attrs:{"disabled":props.item['status'] == 'CONFIRMED' ||
                (_vm.getCustomerName(props.item.buyerId) == 'DELETED CUSTOMER'
                  ? _vm.isShopUserExists(props.item.shopReceiptCollectionUserId)
                    ? false
                    : true
                  : false),"color":"primary"},on:{"click":function($event){return _vm.openProd(props.item)}}},[_vm._v("remove_red_eye")])],1),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["ReceiptCollectionNumber"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(new Date(props.item.date).toLocaleDateString("en-GB")))])]),_vm._v(" "),_c('td',[(props.item.buyerId)?_c('b',[_vm._v(_vm._s(_vm.getCustomerName(props.item.buyerId)))]):(_vm.isShopUserExists(props.item.shopReceiptCollectionUserId))?_c('b',[_vm._v(_vm._s(_vm.getShopUserName(props.item.shopReceiptCollectionUserId)))]):_c('b',[_c('v-btn',{on:{"click":function($event){return _vm.addShopUser(props.item)}}},[_vm._v(_vm._s(props.item.shopReceiptCollectionUserName))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',[_vm._v("New Customer. Click To Create Buyer.")])],1)]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["status"]))])])]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","fullscreen":""},model:{value:(_vm.receiptCollectionDialog),callback:function ($$v) {_vm.receiptCollectionDialog=$$v},expression:"receiptCollectionDialog"}},[_c('v-card',{attrs:{"persistent":""}},[_c('v-card-title',{staticClass:"primary white--text"},[(_vm.isEdit)?_c('span',{staticClass:"headline"},[_vm._v("Edit Receipt Collection")]):_c('span',{staticClass:"headline"},[_vm._v("Create Receipt Collection")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"large":"","icon":"","flat":""},on:{"click":function($event){_vm.receiptCollectionDialog = false}}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-switch',{attrs:{"disabled":_vm.isEdit,"label":("" + (_vm.isBuyer ? 'Sale Receipt Collection' : 'Purchase Receipt Collection'))},model:{value:(_vm.isBuyer),callback:function ($$v) {_vm.isBuyer=$$v},expression:"isBuyer"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-switch',{attrs:{"disabled":_vm.isEdit,"label":"Multi-firm"},on:{"change":function($event){return _vm.restructureProductList()}},model:{value:(_vm.multiFirm),callback:function ($$v) {_vm.multiFirm=$$v},expression:"multiFirm"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-select',{attrs:{"dense":"","disabled":_vm.multiFirm,"items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.staffByBrand,"label":"Collection By"},model:{value:(_vm.soldBy),callback:function ($$v) {_vm.soldBy=$$v},expression:"soldBy"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerReceiptCollection),callback:function ($$v) {_vm.datepickerReceiptCollection=$$v},expression:"datepickerReceiptCollection"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Receipt Collection Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerReceiptCollection = false}},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"prefix":"#","label":"receipt Collection","placeholder":"Enter Receipt Collection Number","required":""},model:{value:(_vm.receiptCollectionNumber),callback:function ($$v) {_vm.receiptCollectionNumber=$$v},expression:"receiptCollectionNumber"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},_vm._l((_vm.items),function(item,index){return _c('v-layout',{key:index + item.productId,style:(item.isReturn
                    ? 'background: #f7c4c4;'
                    : 'background: #c5f7c4;'),attrs:{"wrap":""}},[_c('v-flex',{staticStyle:{"padding-left":"20px"},attrs:{"xs1":"","sm1":"","md1":""}},[(!item.isReturn)?_c('v-checkbox',{attrs:{"color":"indigo","hide-details":""},model:{value:(item.selected),callback:function ($$v) {_vm.$set(item, "selected", $$v)},expression:"item.selected"}}):_vm._e()],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-select',{attrs:{"items":_vm.isBuyer ? _vm.buyersByBrand : _vm.sellersByBrand,"label":_vm.isBuyer ? 'Select or add Buyer' : 'Select or add Seller',"autocomplete":"","disabled":_vm.isEdit,"item-text":"name","return-object":""},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addCustomer($event)}},model:{value:(_vm.selectedBuyer),callback:function ($$v) {_vm.selectedBuyer=$$v},expression:"selectedBuyer"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[(_vm.selectedBuyer)?_c('v-text-field',{attrs:{"type":"number","hint":_vm.hintText,"label":"Enter Amount"},model:{value:(item.amount),callback:function ($$v) {_vm.$set(item, "amount", $$v)},expression:"item.amount"}}):_vm._e()],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[(index == _vm.items.length - 1 && _vm.selectedBuyer)?_c('v-btn',{attrs:{"icon":"","color":"primary"},on:{"click":function($event){return _vm.addProd()}}},[_c('v-icon',[_vm._v("add_circle")])],1):_vm._e(),_vm._v(" "),(_vm.selectedBuyer)?_c('v-btn',{attrs:{"icon":"","color":"primary"},on:{"click":function($event){return _vm.removeProd(index)}}},[_c('v-icon',[_vm._v("cancel")])],1):_vm._e()],1)],1)}),1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"blue darken-1"},on:{"click":function($event){return _vm.combineReceiptCollection()}}},[_vm._v("COMBINE RECEIPT COLLECTIONS")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){_vm.receiptCollectionDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","disabled":!_vm.items.length ||
            !_vm.selectedBuyer ||
            (_vm.multiFirm ? false : !_vm.selectedFirm),"flat":""},on:{"click":function($event){return _vm.addReceiptCollection()}}},[_vm._v(_vm._s(_vm.isEdit ? "Save" : "Create"))])],1)],1)],1),_vm._v(" "),(_vm.selectedReceiptCollection && _vm.selectedReceiptCollection['.key'])?_c('v-dialog',{attrs:{"width":"1200"},model:{value:(_vm.invoiceReceiptCollection),callback:function ($$v) {_vm.invoiceReceiptCollection=$$v},expression:"invoiceReceiptCollection"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline grey lighten-2",attrs:{"primary-title":""}},[_vm._v("Receipt Collection details:-\n        ")]),_vm._v(" "),_c('v-card-text',[_c('v-checkbox',{attrs:{"color":"indigo","label":"Select All"},model:{value:(_vm.selectAll),callback:function ($$v) {_vm.selectAll=$$v},expression:"selectAll"}}),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.productHeaderCreateInvoice,"items":_vm.selectedReceiptCollection.items},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{style:(props.item.isReturn
                  ? 'background: #f7c4c4;'
                  : 'background: #c5f7c4;')},[_c('td',[_c('v-checkbox',{attrs:{"color":"indigo","hide-details":""},model:{value:(props.item.selected),callback:function ($$v) {_vm.$set(props.item, "selected", $$v)},expression:"props.item.selected"}})],1),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["productName"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["quantity"]))])]),_vm._v(" "),(_vm.isJewlBusiness)?_c('td',[_c('b',[_c('v-text-field',{attrs:{"type":"number","label":"Purity"},model:{value:(props.item.purity),callback:function ($$v) {_vm.$set(props.item, "purity", _vm._n($$v))},expression:"props.item.purity"}})],1)]):_vm._e(),_vm._v(" "),(_vm.isJewlBusiness)?_c('td',[_c('b',[_vm._v(_vm._s(props.item.grossWeight))])]):_vm._e(),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(new Date(props.item.date).toISOString().substr(0, 10)))])]),_vm._v(" "),_c('td',[_c('b',[_c('v-text-field',{attrs:{"type":"number","label":"Product Rate"},model:{value:(props.item.rate),callback:function ($$v) {_vm.$set(props.item, "rate", _vm._n($$v))},expression:"props.item.rate"}})],1)]),_vm._v(" "),_c('td',[_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.fetchLatestRate(props.item)}}},[_vm._v("Fetch Rate")])],1)])]}}],null,false,429330559)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.invoiceReceiptCollection = false}}},[_vm._v("Back")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.createInvoice()}}},[_vm._v("Create Invoice\n        ")])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.selectedReceiptCollection && _vm.selectedReceiptCollection['.key'])?_c('v-dialog',{attrs:{"width":"1200"},model:{value:(_vm.orderHistory),callback:function ($$v) {_vm.orderHistory=$$v},expression:"orderHistory"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline grey lighten-2",attrs:{"primary-title":""}},[_vm._v("Receipt Collection History:-\n        ")]),_vm._v(" "),_c('v-card-text',[[_c('v-stepper',{attrs:{"vertical":""},model:{value:(_vm.historyStep),callback:function ($$v) {_vm.historyStep=$$v},expression:"historyStep"}},[_vm._l((_vm.selectedReceiptCollection.orderHistory),function(item,index){return [_c('v-stepper-step',{key:item['.key'],attrs:{"step":index + 1}},[_c('v-link',{on:{"click":function($event){_vm.historyStep = index + 1}}},[_vm._v(_vm._s(new Date(item["date"]).toLocaleDateString("en-GB") +
                  (item["type"] == "INVOICE" ? "  -  Invoice created" : "")))])],1),_vm._v(" "),_c('v-stepper-content',{key:index,attrs:{"step":index + 1}},[_c('v-card',{staticClass:"mb-12 invoice-stepper"},[_c('v-layout',{staticStyle:{"padding":"30px"},attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('h2',{staticStyle:{"text-decoration":"underline","text-align":"center"}},[_vm._v("\n                        Product List\n                      ")]),_vm._v(" "),[_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.productInvoiceHeader,"items":item.items},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',{style:(props.item.isReturn
                                  ? 'background: #f7c4c4;'
                                  : 'background: #c5f7c4;')},[_c('td',[_c('b',[_vm._v(_vm._s(props.item["productName"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["quantity"]))])]),_vm._v(" "),(_vm.isJewlBusiness)?_c('td',[_c('b',[_vm._v(_vm._s(props.item["purity"]))])]):_vm._e(),_vm._v(" "),(_vm.isJewlBusiness)?_c('td',[_c('b',[_vm._v(_vm._s(props.item.grossWeight))])]):_vm._e(),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(new Date(props.item.date)
                                    .toISOString()
                                    .substr(0, 10)))])]),_vm._v(" "),_c('td',[_c('b',[_c('v-text-field',{attrs:{"type":"number","label":"Product Rate"},model:{value:(props.item.rate),callback:function ($$v) {_vm.$set(props.item, "rate", _vm._n($$v))},expression:"props.item.rate"}})],1)]),_vm._v(" "),_c('td',[_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.fetchLatestRate(props.item)}}},[_vm._v("Fetch Rate")])],1)])]}}],null,true)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)]],2)],1)],1)],1)]})],2)]],2),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.orderHistory = false}}},[_vm._v("Back")])],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_homePage_vue__ = __webpack_require__(514);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_602865f2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_homePage_vue__ = __webpack_require__(1548);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_homePage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_602865f2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_homePage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticStyle:{"margin-top":"15px"},attrs:{"id":"inspire"}},[_c('v-app-bar',{attrs:{"app":"","color":"white","flat":""}},[_c('v-avatar',{attrs:{"color":_vm.$vuetify.breakpoint.smAndDown ? 'grey darken-1' : 'transparent',"size":"32"}}),_vm._v(" "),_c('v-tabs',{staticClass:"primary white--text"},_vm._l((_vm.links),function(link){return _c('v-tab',{key:link},[_vm._v("\n        "+_vm._s(link)+"\n      ")])}),1),_vm._v(" "),_c('v-tabs',{staticClass:"primary white--text",attrs:{"centered":""}},_vm._l((_vm.links),function(link){return _c('v-tab',{key:link},[_vm._v("\n        "+_vm._s(link)+"\n      ")])}),1),_vm._v(" "),_c('v-tabs',{staticClass:"primary white--text",attrs:{"end":""}},_vm._l((_vm.links),function(link){return _c('v-tab',{key:link},[_vm._v("\n        "+_vm._s(link)+"\n      ")])}),1),_vm._v(" "),_c('v-avatar',{staticClass:"hidden-sm-and-down",attrs:{"color":"grey darken-1 shrink","size":"32"}})],1),_vm._v(" "),_c('v-main',{staticClass:"grey lighten-3"},[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"2"}},[_c('v-sheet',{attrs:{"rounded":"lg","min-height":"268"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"8"}},[_c('v-sheet',{attrs:{"min-height":"70vh","rounded":"lg"}})],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"12","sm":"2"}},[_c('v-sheet',{attrs:{"rounded":"lg","min-height":"268"}})],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var BuyersInfo = function BuyersInfo() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 148));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  name: 'BuyersInfo',
  path: ':buyerId',
  component: BuyersInfo,
  meta: { requiresAuth: true }
}, {
  name: 'BuyersInfo',
  path: ':buyerId/:isBuyer',
  component: BuyersInfo,
  meta: { requiresAuth: true }
}]);

/***/ }),
/* 1550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Settings_Staff_index_vue__ = __webpack_require__(1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_Print_printSettings_vue__ = __webpack_require__(1553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Settings_Firms_index_vue__ = __webpack_require__(1555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Settings_Account_index_vue__ = __webpack_require__(1557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Settings_Asset_index_vue__ = __webpack_require__(1559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Settings_Loan_index_vue__ = __webpack_require__(1561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Settings_Loanadvances_index_vue__ = __webpack_require__(1563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Settings_Godawn_index_vue__ = __webpack_require__(1565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Settings_HumanResource_index_vue__ = __webpack_require__(1567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Settings_StaffAttendance_staffAttendance_vue__ = __webpack_require__(1570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Settings_LetterHead_LetterHead_vue__ = __webpack_require__(1573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Settings_Todo_todo_vue__ = __webpack_require__(1577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Settings_Payroll_payroll_vue__ = __webpack_require__(1581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Settings_AdminAccounts_index_vue__ = __webpack_require__(1584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Settings_ProductGroup_productGroup_vue__ = __webpack_require__(1586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Settings_ProductCategory_productCategory_vue__ = __webpack_require__(1588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Settings_ProductRateCategory_productRateCategory_vue__ = __webpack_require__(1590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_Settings_ProductSet_productSet_vue__ = __webpack_require__(1592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Settings_ProductType_ProductType_vue__ = __webpack_require__(1594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Settings_ProductUniqueId_ProductUniqueId_vue__ = __webpack_require__(1596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Settings_ProductOffers_ProductOffers_vue__ = __webpack_require__(1598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Settings_ProductReplacement_ProductReplacement_vue__ = __webpack_require__(1600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Settings_productDrawer_productDrawer_vue__ = __webpack_require__(1602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Settings_DataManagement_dataManagement_vue__ = __webpack_require__(1604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Settings_FirmSettings_FirmSettings_vue__ = __webpack_require__(1606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Settings_Branch_Branch_vue__ = __webpack_require__(1608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Settings_Transactions_Transfer_vue__ = __webpack_require__(1610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Settings_ShopSettings_ShopSettings_vue__ = __webpack_require__(1612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_Settings_Infrastructure_Infrastructure_vue__ = __webpack_require__(1618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Settings_Godawn_BulkTransfer_vue__ = __webpack_require__(1620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_Settings_DataManagement_ImportFromExcel_vue__ = __webpack_require__(1622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_Settings_DataManagement_ImportCustomerFromExcel_vue__ = __webpack_require__(1624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_Settings_DataManagement_ImportSupplierFromExcel_vue__ = __webpack_require__(1626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_Settings_ProductManufacturing_ProductManufacturing_vue__ = __webpack_require__(1628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_Settings_ProductDamage_ProductDamage_vue__ = __webpack_require__(1630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_Settings_ProductRepair_ProductRepair_vue__ = __webpack_require__(1632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_Settings_OrderSettings_OrderSettings_vue__ = __webpack_require__(1634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_Settings_LeadSettings_LeadSettings_vue__ = __webpack_require__(1636);








































/* harmony default export */ __webpack_exports__["a"] = ([{
  path: 'staff',
  name: 'Staff',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Settings_Staff_index_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'print',
  name: 'Print',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Settings_Print_printSettings_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'firms',
  name: 'Firms',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Settings_Firms_index_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'firm-settings',
  name: 'FirmSettings',
  component: __WEBPACK_IMPORTED_MODULE_24__components_Settings_FirmSettings_FirmSettings_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'firms/:isNew',
  name: 'FirmsNew',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Settings_Firms_index_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'account',
  name: 'Account',
  component: __WEBPACK_IMPORTED_MODULE_3__components_Settings_Account_index_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'account/:isNew',
  name: 'AccountNew',
  component: __WEBPACK_IMPORTED_MODULE_3__components_Settings_Account_index_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'asset',
  name: 'Asset',
  component: __WEBPACK_IMPORTED_MODULE_4__components_Settings_Asset_index_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'loan',
  name: 'Loan',
  component: __WEBPACK_IMPORTED_MODULE_5__components_Settings_Loan_index_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'loanadvances',
  name: 'Loanadvances',
  component: __WEBPACK_IMPORTED_MODULE_6__components_Settings_Loanadvances_index_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'godawn',
  name: 'Godawn',
  component: __WEBPACK_IMPORTED_MODULE_7__components_Settings_Godawn_index_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'godawn-bulk-transfer',
  name: 'GodawnBulkTransfer',
  component: __WEBPACK_IMPORTED_MODULE_29__components_Settings_Godawn_BulkTransfer_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'humanResource',
  name: 'HumanResource',
  component: __WEBPACK_IMPORTED_MODULE_8__components_Settings_HumanResource_index_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'staffAttendance',
  name: 'StaffAttendance',
  component: __WEBPACK_IMPORTED_MODULE_9__components_Settings_StaffAttendance_staffAttendance_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'LetterHead',
  name: 'LetterHead',
  component: __WEBPACK_IMPORTED_MODULE_10__components_Settings_LetterHead_LetterHead_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'todo',
  name: 'Todo',
  component: __WEBPACK_IMPORTED_MODULE_11__components_Settings_Todo_todo_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'payroll',
  name: 'Payroll',
  component: __WEBPACK_IMPORTED_MODULE_12__components_Settings_Payroll_payroll_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'admin-accounts',
  name: 'AdminAccounts',
  component: __WEBPACK_IMPORTED_MODULE_13__components_Settings_AdminAccounts_index_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'data-management',
  name: 'DataManagement',
  component: __WEBPACK_IMPORTED_MODULE_23__components_Settings_DataManagement_dataManagement_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'product-grouping',
  name: 'ProductGroup',
  component: __WEBPACK_IMPORTED_MODULE_14__components_Settings_ProductGroup_productGroup_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'product-set',
  name: 'ProductSet',
  component: __WEBPACK_IMPORTED_MODULE_17__components_Settings_ProductSet_productSet_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'product-type',
  name: 'ProductType',
  component: __WEBPACK_IMPORTED_MODULE_18__components_Settings_ProductType_ProductType_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'product-category',
  name: 'ProductCategory',
  component: __WEBPACK_IMPORTED_MODULE_15__components_Settings_ProductCategory_productCategory_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'rate-category',
  name: 'ProductRateCategory',
  component: __WEBPACK_IMPORTED_MODULE_16__components_Settings_ProductRateCategory_productRateCategory_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'product-grouping/:isNew/:redirect',
  name: 'ProductGroupWithRedirect',
  component: __WEBPACK_IMPORTED_MODULE_14__components_Settings_ProductGroup_productGroup_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'product-set/:isNew/:redirect',
  name: 'ProductSetWithRedirect',
  component: __WEBPACK_IMPORTED_MODULE_17__components_Settings_ProductSet_productSet_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'product-category/:isNew/:redirect',
  name: 'ProductCategoryWithRedirect',
  component: __WEBPACK_IMPORTED_MODULE_15__components_Settings_ProductCategory_productCategory_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'product-type/:isNew/:redirect',
  name: 'ProductTypeWithRedirect',
  component: __WEBPACK_IMPORTED_MODULE_18__components_Settings_ProductType_ProductType_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'product-offers',
  name: 'ProductOffers',
  component: __WEBPACK_IMPORTED_MODULE_20__components_Settings_ProductOffers_ProductOffers_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'product-unique-id',
  name: 'ProductUniqueId',
  component: __WEBPACK_IMPORTED_MODULE_19__components_Settings_ProductUniqueId_ProductUniqueId_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'Branch',
  name: 'Branch',
  component: __WEBPACK_IMPORTED_MODULE_25__components_Settings_Branch_Branch_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'transfer',
  name: 'Transfer',
  component: __WEBPACK_IMPORTED_MODULE_26__components_Settings_Transactions_Transfer_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'shop-settings',
  name: 'ShopSettings',
  component: __WEBPACK_IMPORTED_MODULE_27__components_Settings_ShopSettings_ShopSettings_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'infrastructure',
  name: 'Infrastructure',
  component: __WEBPACK_IMPORTED_MODULE_28__components_Settings_Infrastructure_Infrastructure_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'data-import',
  name: 'ImportFromExcel',
  component: __WEBPACK_IMPORTED_MODULE_30__components_Settings_DataManagement_ImportFromExcel_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'customer-import',
  name: 'ImportCustomerFromExcel',
  component: __WEBPACK_IMPORTED_MODULE_31__components_Settings_DataManagement_ImportCustomerFromExcel_vue__["default"],
  meta: { requiresAuth: true }
}, {
  path: 'supplier-import',
  name: 'ImportSupplierFromExcel',
  component: __WEBPACK_IMPORTED_MODULE_32__components_Settings_DataManagement_ImportSupplierFromExcel_vue__["default"],
  meta: { requiresAuth: true }
}, {
  path: 'product-manufacturing',
  name: 'ProductManufacturing',
  component: __WEBPACK_IMPORTED_MODULE_33__components_Settings_ProductManufacturing_ProductManufacturing_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'product-damage',
  name: 'ProductDamage',
  component: __WEBPACK_IMPORTED_MODULE_34__components_Settings_ProductDamage_ProductDamage_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'product-replacement',
  name: 'ProductReplacement',
  component: __WEBPACK_IMPORTED_MODULE_21__components_Settings_ProductReplacement_ProductReplacement_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'product-repair',
  name: 'ProductRepair',
  component: __WEBPACK_IMPORTED_MODULE_35__components_Settings_ProductRepair_ProductRepair_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'product-drawer',
  name: 'productDrawer',
  component: __WEBPACK_IMPORTED_MODULE_22__components_Settings_productDrawer_productDrawer_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'order-settings',
  name: 'OrderSettings',
  component: __WEBPACK_IMPORTED_MODULE_36__components_Settings_OrderSettings_OrderSettings_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'lead-settings',
  name: 'LeadSettings',
  component: __WEBPACK_IMPORTED_MODULE_37__components_Settings_LeadSettings_LeadSettings_vue__["a" /* default */],
  meta: { requiresAuth: true }
}]);

/***/ }),
/* 1551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(515);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37d3fbaa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1552);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37d3fbaa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","offset-sm":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"headline text-xs-center"},[_vm._v("\n           Common Team Management \n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{attrs:{"outlined":""},on:{"click":_vm.getFirms}},[_c('v-icon',{attrs:{"left":"","color":"teal"}},[_vm._v(" add ")]),_vm._v(" \n            New Account  \n          ")],1)],1)],1),_vm._v(" "),_c('v-card',[_vm._l((_vm.getStaffAccount),function(item,index){return [_c('v-divider',{key:item['.key']}),_vm._v(" "),_c('v-card',{key:index},[_c('v-card-title',{staticClass:"body-1 primary--text font-weight-light",attrs:{"col":""}},[_c('v-flex',{attrs:{"xs11":""}},[_vm._v(" \n                  Firm:    "),_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.firmbyId(item.firm)))]),_vm._v(" "),_c('v-spacer'),_vm._v("\n                  Account Name:   "),_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(item.staffName))]),_vm._v(" "),_c('v-spacer'),_vm._v("\n                  Account Role:   "),_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(item.staffRole))]),_vm._v(" "),_c('v-spacer'),_vm._v("\n                  Opening Balance:   "),_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(item.openingBalance))])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('v-btn',{staticClass:"primary white--text",attrs:{"flat":"","icon":""},on:{"click":function($event){return _vm.editStaffAccount(item)}}},[_c('v-icon',{attrs:{"color":"grey white--text"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text",attrs:{"flat":"","icon":""},on:{"click":function($event){return _vm.deleteStaffAccount(item['.key'])}}},[_c('v-icon',[_vm._v("delete")])],1)],1)],1)],1)]})],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"400"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":"","title":""}},[_c('span',{staticClass:"headline"},[_vm._v("Add New Account Account")])]),_vm._v(" "),_c('v-card-text',[_c('v-select',{attrs:{"item-text":"name","item-value":"id","items":_vm.items,"label":"Select Firms"},model:{value:(_vm.currentFirm),callback:function ($$v) {_vm.currentFirm=$$v},expression:"currentFirm"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Account Holder Name"},model:{value:(_vm.staffName),callback:function ($$v) {_vm.staffName=$$v},expression:"staffName"}}),_vm._v(" "),_c('v-select',{attrs:{"item-text":"name","item-value":"id","items":_vm.currentStaffRole,"label":"Choose Account Role"},model:{value:(_vm.staffRole),callback:function ($$v) {_vm.staffRole=$$v},expression:"staffRole"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Opening Balance"},model:{value:(_vm.openingBalance),callback:function ($$v) {_vm.openingBalance=$$v},expression:"openingBalance"}}),_vm._v(" "),(_vm.staffRole === 'Commission')?_c('v-text-field',{attrs:{"type":"Number","label":"Brokerage Rate"},model:{value:(_vm.brokerageRate),callback:function ($$v) {_vm.brokerageRate=$$v},expression:"brokerageRate"}}):_vm._e()],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":_vm.cancelDialog}},[_vm._v("\n          Cancel\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":_vm.addNewStaffAccount}},[_vm._v("\n          Save\n        ")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"400"},model:{value:(_vm.dialogEdit),callback:function ($$v) {_vm.dialogEdit=$$v},expression:"dialogEdit"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":"","title":""}},[_c('span',{staticClass:"headline"},[_vm._v("Edit Account Account")])]),_vm._v(" "),_c('v-card-text',[_c('v-select',{attrs:{"item-text":"name","item-value":"id","items":_vm.itemsEdit,"label":"Select Firm"},model:{value:(_vm.currentFirmEdit),callback:function ($$v) {_vm.currentFirmEdit=$$v},expression:"currentFirmEdit"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Account Holder Name"},model:{value:(_vm.staffNameEdit),callback:function ($$v) {_vm.staffNameEdit=$$v},expression:"staffNameEdit"}}),_vm._v(" "),_c('v-select',{attrs:{"item-text":"name","item-value":"id","items":_vm.currentStaffRole,"label":"Choose Account Role"},model:{value:(_vm.staffRoleEdit),callback:function ($$v) {_vm.staffRoleEdit=$$v},expression:"staffRoleEdit"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Opening Balance"},model:{value:(_vm.openingBalanceEdit),callback:function ($$v) {_vm.openingBalanceEdit=$$v},expression:"openingBalanceEdit"}}),_vm._v(" "),(_vm.staffRoleEdit === 'Commission')?_c('v-text-field',{attrs:{"type":"Number","label":"Commission Rate"},model:{value:(_vm.brokerageRate),callback:function ($$v) {_vm.brokerageRate=$$v},expression:"brokerageRate"}}):_vm._e()],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":_vm.cancelDialogEdit}},[_vm._v("\n          Cancel\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":_vm.updateNewStaffAccount}},[_vm._v("\n          Update\n        ")])],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"top":"","color":"error","timeout":3000},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n "+_vm._s(_vm.snackbarText)+"\n  ")]),_vm._v(" "),_c('v-snackbar',{attrs:{"top":"","color":"success","timeout":3000},model:{value:(_vm.snackbarSuccess),callback:function ($$v) {_vm.snackbarSuccess=$$v},expression:"snackbarSuccess"}},[_vm._v("\n "+_vm._s(_vm.snackbarSuccessText)+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_printSettings_vue__ = __webpack_require__(516);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6aa12758_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_printSettings_vue__ = __webpack_require__(1554);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_printSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6aa12758_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_printSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"headline text-xs-center"},[_vm._v("\n              Print Management\n            ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{attrs:{"outlined":"","large":""},on:{"click":_vm.addTerm}},[_c('v-icon',{attrs:{"left":"","color":"teal"}},[_vm._v("\n                add\n                ")]),_vm._v(" \n                NEW PRINT \n              ")],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.termsListHeader,"items":_vm.termsListByBrand,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',[_vm._v(_vm._s(_vm.getFirmName(props.item.firm)))])]),_vm._v(" "),_c('td',[_vm._l((props.item.bank),function(cbank){return [_c('v-chip',{key:cbank,staticClass:"ma-2",staticStyle:{"color":"white"},attrs:{"color":"primary"}},[_vm._v("\n                    "+_vm._s(_vm.getBankName(cbank))+"\n                  ")])]})],2),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['termsAndConditions']))])]),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editTerm(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteTerm(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"1000px"},model:{value:(_vm.addTermsDialog),callback:function ($$v) {_vm.addTermsDialog=$$v},expression:"addTermsDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Terms and Conditions")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.addTermsDialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[(!_vm.currentTerms['.key'])?_c('v-select',{attrs:{"dense":"","items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.currentTerms.firm),callback:function ($$v) {_vm.$set(_vm.currentTerms, "firm", $$v)},expression:"currentTerms.firm"}}):_c('v-text-field',{attrs:{"dense":"","value":_vm.getFirmName(_vm.currentTerms.firm),"disabled":true,"label":"Select Firm"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.banksByFirms,"multiple":true,"label":"Select Bank"},model:{value:(_vm.currentTerms.bank),callback:function ($$v) {_vm.$set(_vm.currentTerms, "bank", $$v)},expression:"currentTerms.bank"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"label":("" + ('Display Trade Discount in PDF: '+ (_vm.currentTerms.isTradeDiscount ? 'YES': 'NO')))},model:{value:(_vm.currentTerms.isTradeDiscount),callback:function ($$v) {_vm.$set(_vm.currentTerms, "isTradeDiscount", $$v)},expression:"currentTerms.isTradeDiscount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"label":("" + ('Display Purity in PDF: '+ (_vm.currentTerms.isPurity ? 'YES': 'NO')))},model:{value:(_vm.currentTerms.isPurity),callback:function ($$v) {_vm.$set(_vm.currentTerms, "isPurity", $$v)},expression:"currentTerms.isPurity"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"label":("" + ('Display Purity Msg in PDF: '+ (_vm.currentTerms.purityRemark ? 'YES': 'NO')))},model:{value:(_vm.currentTerms.purityRemark),callback:function ($$v) {_vm.$set(_vm.currentTerms, "purityRemark", $$v)},expression:"currentTerms.purityRemark"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"label":("" + ('Display Special Charge in PDF: '+ (_vm.currentTerms.isSpecialCharge ? 'YES': 'NO')))},model:{value:(_vm.currentTerms.isSpecialCharge),callback:function ($$v) {_vm.$set(_vm.currentTerms, "isSpecialCharge", $$v)},expression:"currentTerms.isSpecialCharge"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"label":("" + ('Display Gross Weight in PDF: '+ (_vm.currentTerms.isGrossWeight ? 'YES': 'NO')))},model:{value:(_vm.currentTerms.isGrossWeight),callback:function ($$v) {_vm.$set(_vm.currentTerms, "isGrossWeight", $$v)},expression:"currentTerms.isGrossWeight"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"label":("" + ('Display Net Weight in PDF: '+ (_vm.currentTerms.isNetWeight ? 'YES': 'NO')))},model:{value:(_vm.currentTerms.isNetWeight),callback:function ($$v) {_vm.$set(_vm.currentTerms, "isNetWeight", $$v)},expression:"currentTerms.isNetWeight"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"label":("" + ('Display Less(Stone) in PDF: '+ (_vm.currentTerms.isLessStone ? 'YES': 'NO')))},model:{value:(_vm.currentTerms.isLessStone),callback:function ($$v) {_vm.$set(_vm.currentTerms, "isLessStone", $$v)},expression:"currentTerms.isLessStone"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"label":("" + ('Display Fat in PDF: '+ (_vm.currentTerms.fat ? 'YES': 'NO')))},model:{value:(_vm.currentTerms.fat),callback:function ($$v) {_vm.$set(_vm.currentTerms, "fat", $$v)},expression:"currentTerms.fat"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"label":("" + ('Disable GST Grouping in PDF: '+ (_vm.currentTerms.isGSTGroupingDisabled ? 'YES': 'NO')))},model:{value:(_vm.currentTerms.isGSTGroupingDisabled),callback:function ($$v) {_vm.$set(_vm.currentTerms, "isGSTGroupingDisabled", $$v)},expression:"currentTerms.isGSTGroupingDisabled"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"label":("" + ('Display Total Amount: '+ (_vm.currentTerms.isTotalAmount ? 'YES': 'NO')))},model:{value:(_vm.currentTerms.isTotalAmount),callback:function ($$v) {_vm.$set(_vm.currentTerms, "isTotalAmount", $$v)},expression:"currentTerms.isTotalAmount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"label":("" + ('Display Previous Due invoices: '+ (_vm.currentTerms.isPreviousDue ? 'YES': 'NO')))},model:{value:(_vm.currentTerms.isPreviousDue),callback:function ($$v) {_vm.$set(_vm.currentTerms, "isPreviousDue", $$v)},expression:"currentTerms.isPreviousDue"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"label":("" + ('Display Estimates: '+ (_vm.currentTerms.isEstimate ? 'YES': 'NO')))},model:{value:(_vm.currentTerms.isEstimate),callback:function ($$v) {_vm.$set(_vm.currentTerms, "isEstimate", $$v)},expression:"currentTerms.isEstimate"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"label":("" + ('Display Previous , Current and Total Balance: '+ (_vm.currentTerms.isPreviousCurrentTotalBalance ? 'YES': 'NO')))},model:{value:(_vm.currentTerms.isPreviousCurrentTotalBalance),callback:function ($$v) {_vm.$set(_vm.currentTerms, "isPreviousCurrentTotalBalance", $$v)},expression:"currentTerms.isPreviousCurrentTotalBalance"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"label":("" + ('Display Major Unit Details : '+ (_vm.currentTerms.isMajorUnitDisplay ? 'YES': 'NO')))},model:{value:(_vm.currentTerms.isMajorUnitDisplay),callback:function ($$v) {_vm.$set(_vm.currentTerms, "isMajorUnitDisplay", $$v)},expression:"currentTerms.isMajorUnitDisplay"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"label":("" + ('Display Blank Header in PDF : '+ (_vm.currentTerms.isBlankHeader ? 'YES': 'NO')))},model:{value:(_vm.currentTerms.isBlankHeader),callback:function ($$v) {_vm.$set(_vm.currentTerms, "isBlankHeader", $$v)},expression:"currentTerms.isBlankHeader"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"label":("" + ('Display Payment Type in PDF : '+ (_vm.currentTerms.isPaymentType ? 'YES': 'NO')))},model:{value:(_vm.currentTerms.isPaymentType),callback:function ($$v) {_vm.$set(_vm.currentTerms, "isPaymentType", $$v)},expression:"currentTerms.isPaymentType"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-textarea',{attrs:{"background-color":"grey darken-1","color":"black","name":"input-7-1","box":"","label":"Terms and Conditions"},model:{value:(_vm.currentTerms.termsAndConditions),callback:function ($$v) {_vm.$set(_vm.currentTerms, "termsAndConditions", $$v)},expression:"currentTerms.termsAndConditions"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-textarea',{attrs:{"background-color":"grey darken-1","color":"black","name":"input-7-1","max":"20","box":"","label":"Greeting Message"},model:{value:(_vm.currentTerms.greetingMessage),callback:function ($$v) {_vm.$set(_vm.currentTerms, "greetingMessage", $$v)},expression:"currentTerms.greetingMessage"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('span',[_c('label',{staticClass:"title mat-raised-button",attrs:{"for":"filesLogo"}},[_c('span',{staticStyle:{"font-weight":"bold","color":"#2727b0"}},[_vm._v(_vm._s(_vm.currentTerms.printLogo ? 'Change Logo Image' : 'Upload Logo Image'))])]),_vm._v(" "),_c('input',{staticStyle:{"visibility":"hidden"},attrs:{"id":"filesLogo","accept":".png,.jpg","type":"file"},on:{"change":function($event){return _vm.uploadChangeLogo($event)}}})]),_vm._v(" "),(_vm.printLogoImage)?_c('span',[_vm._v(_vm._s(_vm.printLogoImage.name))]):_vm._e(),_vm._v(" "),(_vm.uploadValue!=0)?_c('span',[_vm._v(_vm._s(_vm.uploadValue)+"%")]):_vm._e()]),_vm._v(" "),(_vm.currentTerms.printLogo)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('img',{staticStyle:{"object-fit":"cover"},attrs:{"src":_vm.currentTerms.printLogo,"height":"250px","width":"250px"}})]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('span',[_c('label',{staticClass:"title mat-raised-button",attrs:{"for":"filesSig"}},[_c('span',{staticStyle:{"font-weight":"bold","color":"#2727b0"}},[_vm._v(_vm._s(_vm.currentTerms.signature ? 'Change Signature Image' : 'Upload Signature Image'))])]),_vm._v(" "),_c('input',{staticStyle:{"visibility":"hidden"},attrs:{"id":"filesSig","accept":".png,.jpg","type":"file"},on:{"change":function($event){return _vm.uploadChangeSignature($event)}}})]),_vm._v(" "),(_vm.signatureImage)?_c('span',[_vm._v(_vm._s(_vm.signatureImage.name))]):_vm._e(),_vm._v(" "),(_vm.uploadValue!=0)?_c('span',[_vm._v(_vm._s(_vm.uploadValue)+"%")]):_vm._e()]),_vm._v(" "),(_vm.currentTerms.signature)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('img',{staticStyle:{"object-fit":"cover"},attrs:{"src":_vm.currentTerms.signature,"height":"100px","width":"250px"}})]):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(!_vm.currentTerms['.key'])?_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":_vm.saveTerms}},[_vm._v("Save")]):_vm._e(),_vm._v(" "),(!!_vm.currentTerms['.key'])?_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":_vm.updateTerms}},[_vm._v("Update")]):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(517);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_769a45ca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1556);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_769a45ca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","offset-sm":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"headline text-xs-center"},[_vm._v("\n            Firms Management\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{attrs:{"outlined":"","large":""},on:{"click":function($event){$event.stopPropagation();_vm.dialog = true}}},[_c('v-icon',{attrs:{"left":"","color":"teal"}},[_vm._v("\n              add\n            ")]),_vm._v("\n            NEW FIRM\n          ")],1)],1)],1),_vm._v(" "),_c('v-card',[_vm._l((_vm.getFirms),function(item,index){return [_c('v-divider',{key:item['.key']}),_vm._v(" "),_c('v-card',{key:index},[_c('v-card-title',{staticClass:"body-1 primary--text font-weight-light",attrs:{"col":""}},[_c('v-flex',{attrs:{"xs5":""}},[_vm._v("\n                Firm Name:   "),_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('v-spacer'),_vm._v("\n                Proprietor Name:   "),_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(item.proprietor))]),_vm._v(" "),_c('v-spacer'),_vm._v("\n                Mobile Number:   "),_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(item.mobileNumber))]),_vm._v(" "),_c('v-spacer'),_vm._v("\n                Address:   "),_c('b',{staticClass:"font-weight-bold"},[_vm._v("\n                  "+_vm._s(item.liveAddress)+" "),_c('br'),_vm._v("\n                  "+_vm._s(item.tehsil || '-')+" - "+_vm._s(item.district || '-')+" - "+_vm._s(item.state || '-'))]),_vm._v(" "),_c('v-spacer'),_vm._v("\n                Email:   "),_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(item.email || '-'))])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs5":""}},[_vm._v("\n                GST Number:   "),_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(item.GST_number))]),_vm._v(" "),_c('v-spacer'),_vm._v("\n                Pan Number:   "),_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(item.panNumber))]),_vm._v(" "),_c('v-spacer'),_vm._v("\n                Opening Balance of Capital A/C:   "),_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(item.openingBalance || 0)))]),_vm._v(" "),_c('v-spacer'),_vm._v("\n                Opening Balance of Stock:   "),_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(item.openingStock || 0)))]),_vm._v(" "),_c('v-spacer'),_vm._v("\n                Opening Balance Cash A/C:   "),_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(item.openingCashAmount || 0)))]),_vm._v(" "),_c('v-spacer'),_vm._v("\n                Cash In Hand:   "),_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(item.amount || 0)))])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('v-btn',{staticClass:"primary white--text",attrs:{"flat":"","icon":""},on:{"click":function($event){return _vm.editFirm(item)}}},[_c('v-icon',{staticClass:"white--text",attrs:{"primary":"","title":""}},[_vm._v("edit")])],1)],1)],1)],1)]})],2)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.timeout},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")]),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"900"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":"","title":""}},[_c('span',{staticClass:"headline"},[_vm._v("Add New Firm")])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Firm Name"},model:{value:(_vm.firmName),callback:function ($$v) {_vm.firmName=$$v},expression:"firmName"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Proprietor Name"},model:{value:(_vm.firmProprietor),callback:function ($$v) {_vm.firmProprietor=$$v},expression:"firmProprietor"}}),_vm._v(" "),_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker1),callback:function ($$v) {_vm.datepicker1=$$v},expression:"datepicker1"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Opening Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.firmOpeningDate),callback:function ($$v) {_vm.firmOpeningDate=$$v},expression:"firmOpeningDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepicker1 = false}},model:{value:(_vm.firmOpeningDate),callback:function ($$v) {_vm.firmOpeningDate=$$v},expression:"firmOpeningDate"}})],1),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Opening Balance of Capital A/C"},model:{value:(_vm.firmOpeningBalance),callback:function ($$v) {_vm.firmOpeningBalance=$$v},expression:"firmOpeningBalance"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Opening Stock Balance"},model:{value:(_vm.firmOpeningStock),callback:function ($$v) {_vm.firmOpeningStock=$$v},expression:"firmOpeningStock"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Opening Balance of Cash Account"},model:{value:(_vm.switch2),callback:function ($$v) {_vm.switch2=$$v},expression:"switch2"}}),_vm._v(" "),(_vm.switch2)?_c('v-text-field',{ref:"openingCashAmount",attrs:{"label":"Enter opening Balance of Cash Account","rules":_vm.openingCashAmount.rules},model:{value:(_vm.openingCashAmount.value),callback:function ($$v) {_vm.$set(_vm.openingCashAmount, "value", $$v)},expression:"openingCashAmount.value"}}):_vm._e(),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Cash Account"},model:{value:(_vm.switch1),callback:function ($$v) {_vm.switch1=$$v},expression:"switch1"}}),_vm._v(" "),(_vm.switch1)?_c('v-text-field',{ref:"amount",attrs:{"label":"Enter amount","rules":_vm.amount.rules},model:{value:(_vm.amount.value),callback:function ($$v) {_vm.$set(_vm.amount, "value", $$v)},expression:"amount.value"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Mobile Number","rules":_vm.firmMobileNumber.rules},model:{value:(_vm.firmMobileNumber.value),callback:function ($$v) {_vm.$set(_vm.firmMobileNumber, "value", $$v)},expression:"firmMobileNumber.value"}}),_vm._v(" "),_c('v-text-field',{ref:"zipCode",attrs:{"type":"number","label":"ZipCode"},on:{"change":function($event){return _vm.setLocationBasedOnZipCode()}},model:{value:(_vm.zipCode),callback:function ($$v) {_vm.zipCode=$$v},expression:"zipCode"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Address"},model:{value:(_vm.firmLiveAddress),callback:function ($$v) {_vm.firmLiveAddress=$$v},expression:"firmLiveAddress"}}),_vm._v(" "),(_vm.zipCode)?_c('v-select',{attrs:{"items":_vm.gCountry,"label":"Country"},model:{value:(_vm.country.value),callback:function ($$v) {_vm.$set(_vm.country, "value", $$v)},expression:"country.value"}}):_vm._e(),_vm._v(" "),(_vm.country.value)?_c('v-select',{attrs:{"items":_vm.gState,"item-text":"state","label":"State"},model:{value:(_vm.state.value),callback:function ($$v) {_vm.$set(_vm.state, "value", $$v)},expression:"state.value"}}):_vm._e(),_vm._v(" "),(_vm.state.value)?_c('v-select',{attrs:{"items":_vm.gDistrict,"label":"District"},model:{value:(_vm.district.value),callback:function ($$v) {_vm.$set(_vm.district, "value", $$v)},expression:"district.value"}}):_vm._e(),_vm._v(" "),(_vm.district.value)?_c('v-select',{attrs:{"items":_vm.gTehsil,"label":"Tehsil","clearable":""},model:{value:(_vm.tehsil.value),callback:function ($$v) {_vm.$set(_vm.tehsil, "value", $$v)},expression:"tehsil.value"}}):_vm._e(),_vm._v(" "),(_vm.tehsil.value)?_c('v-select',{attrs:{"items":_vm.gBlock,"label":"Block","clearable":""},model:{value:(_vm.block.value),callback:function ($$v) {_vm.$set(_vm.block, "value", $$v)},expression:"block.value"}}):_vm._e(),_vm._v(" "),(_vm.block.value)?_c('v-select',{attrs:{"items":_vm.gVillage,"label":"Village","clearable":""},model:{value:(_vm.village.value),callback:function ($$v) {_vm.$set(_vm.village, "value", $$v)},expression:"village.value"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"items":['Yes','No'],"label":"GST User"},model:{value:(_vm.GST_user),callback:function ($$v) {_vm.GST_user=$$v},expression:"GST_user"}}),_vm._v(" "),(_vm.GST_user === 'Yes')?_c('v-text-field',{attrs:{"type":"text","disabled":_vm.GST_user != 'Yes',"rules":_vm.GST_number.rules,"label":"GST number"},model:{value:(_vm.GST_number.value),callback:function ($$v) {_vm.$set(_vm.GST_number, "value", $$v)},expression:"GST_number.value"}}):_vm._e(),_vm._v(" "),(_vm.GST_user === 'Yes')?_c('v-select',{attrs:{"disabled":_vm.GST_user != 'Yes',"items":_vm.gGST_Type,"label":"GST Scheme"},model:{value:(_vm.GST_Type.value),callback:function ($$v) {_vm.$set(_vm.GST_Type, "value", $$v)},expression:"GST_Type.value"}}):_vm._e(),_vm._v(" "),(_vm.GST_user === 'No' )?_c('v-text-field',{attrs:{"label":"Registration(TIN) Number "},model:{value:(_vm.firmRegNumber),callback:function ($$v) {_vm.firmRegNumber=$$v},expression:"firmRegNumber"}}):_vm._e(),_vm._v(" "),_c('v-text-field',{attrs:{"label":"PAN Number","rules":_vm.PAN_Rules},model:{value:(_vm.panNumber),callback:function ($$v) {_vm.panNumber=$$v},expression:"panNumber"}}),_vm._v(" "),_c('v-text-field',{ref:"email",attrs:{"type":"email","rules":_vm.email.rules,"label":"Email"},model:{value:(_vm.email.value),callback:function ($$v) {_vm.$set(_vm.email, "value", $$v)},expression:"email.value"}}),_vm._v(" "),_c('v-text-field',{ref:"website",attrs:{"label":"Website"},model:{value:(_vm.website),callback:function ($$v) {_vm.website=$$v},expression:"website"}}),_vm._v(" "),_c('v-select',{attrs:{"items":['Automobile/Agriculture/Spare Parts', 'Clothes', 'Default', 'Dairy', 'Jwellery', 'Medical/Pesticides', 'Grain', 'Restaurant'],"label":"Business Type","placeholder":"Select Business Type"},model:{value:(_vm.businessType),callback:function ($$v) {_vm.businessType=$$v},expression:"businessType"}}),_vm._v(" "),_c('p',{staticStyle:{"color":"red","font-style":"italic","font-size":"12px"}},[_vm._v(" Note: This field can't be edited in future.")])],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"warning white--text",attrs:{"primary":"","title":"","flat":"flat"},on:{"click":_vm.cancelDialog}},[_vm._v("\n          Cancel\n        ")]),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text",attrs:{"primary":"","title":"","flat":"flat"},on:{"click":_vm.addNewFirm}},[_vm._v("\n          Save\n        ")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"900"},model:{value:(_vm.dialogEdit),callback:function ($$v) {_vm.dialogEdit=$$v},expression:"dialogEdit"}},[_c('v-card',[_c('v-form',{ref:"editAccount",attrs:{"lazy-validation":""},model:{value:(_vm.addNewFirmValid),callback:function ($$v) {_vm.addNewFirmValid=$$v},expression:"addNewFirmValid"}},[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":"","title":""}},[_c('span',{staticClass:"headline"},[_vm._v("Edit Firm")])]),_vm._v(" "),_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Firm Name"},model:{value:(_vm.firmNameEdit),callback:function ($$v) {_vm.firmNameEdit=$$v},expression:"firmNameEdit"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Proprietor Name"},model:{value:(_vm.firmProprietorEdit),callback:function ($$v) {_vm.firmProprietorEdit=$$v},expression:"firmProprietorEdit"}}),_vm._v(" "),_c('v-menu',{attrs:{"close-on-content-click":false,"v":"","model":"datepicker  ","nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Opening Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.firmOpeningDateEdit),callback:function ($$v) {_vm.firmOpeningDateEdit=$$v},expression:"firmOpeningDateEdit"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepicker2 = false}},model:{value:(_vm.firmOpeningDateEdit),callback:function ($$v) {_vm.firmOpeningDateEdit=$$v},expression:"firmOpeningDateEdit"}})],1),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Edit Opening Balance of Capital Account"},model:{value:(_vm.firmOpeningBalanceEdit),callback:function ($$v) {_vm.firmOpeningBalanceEdit=$$v},expression:"firmOpeningBalanceEdit"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Edit Opening Stock Balance"},model:{value:(_vm.firmOpeningStockEdit),callback:function ($$v) {_vm.firmOpeningStockEdit=$$v},expression:"firmOpeningStockEdit"}}),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Edit Opening Balance of Cash Account"},model:{value:(_vm.switch2Edit),callback:function ($$v) {_vm.switch2Edit=$$v},expression:"switch2Edit"}}),_vm._v(" "),(_vm.switch2Edit)?_c('v-text-field',{ref:"openingCashAmountEdit",attrs:{"label":"Enter Opening Balance","rules":_vm.openingCashAmountEdit.rules},model:{value:(_vm.openingCashAmountEdit.value),callback:function ($$v) {_vm.$set(_vm.openingCashAmountEdit, "value", $$v)},expression:"openingCashAmountEdit.value"}}):_vm._e(),_vm._v(" "),_c('v-checkbox',{attrs:{"label":"Edit Cash Account Balance"},model:{value:(_vm.switch1Edit),callback:function ($$v) {_vm.switch1Edit=$$v},expression:"switch1Edit"}}),_vm._v(" "),(_vm.switch1Edit)?_c('v-text-field',{ref:"amount",attrs:{"label":"Enter amount","rules":_vm.amountEdit.rules},model:{value:(_vm.amountEdit.value),callback:function ($$v) {_vm.$set(_vm.amountEdit, "value", $$v)},expression:"amountEdit.value"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Mobile Number","rules":_vm.firmMobileNumberEdit.rules},model:{value:(_vm.firmMobileNumberEdit.value),callback:function ($$v) {_vm.$set(_vm.firmMobileNumberEdit, "value", $$v)},expression:"firmMobileNumberEdit.value"}}),_vm._v(" "),_c('v-text-field',{ref:"zipCode",attrs:{"type":"number","label":"ZipCode"},on:{"change":function($event){return _vm.setLocationBasedOnZipCode()}},model:{value:(_vm.zipCode),callback:function ($$v) {_vm.zipCode=$$v},expression:"zipCode"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Address"},model:{value:(_vm.firmLiveAddressEdit),callback:function ($$v) {_vm.firmLiveAddressEdit=$$v},expression:"firmLiveAddressEdit"}}),_vm._v(" "),(_vm.zipCode)?_c('v-select',{attrs:{"items":_vm.gCountry,"label":"Country"},model:{value:(_vm.country.value),callback:function ($$v) {_vm.$set(_vm.country, "value", $$v)},expression:"country.value"}}):_vm._e(),_vm._v(" "),(_vm.country.value)?_c('v-select',{attrs:{"items":_vm.gState,"item-text":"state","label":"State"},model:{value:(_vm.state.value),callback:function ($$v) {_vm.$set(_vm.state, "value", $$v)},expression:"state.value"}}):_vm._e(),_vm._v(" "),(_vm.state.value)?_c('v-select',{attrs:{"items":_vm.gDistrict,"label":"District"},model:{value:(_vm.district.value),callback:function ($$v) {_vm.$set(_vm.district, "value", $$v)},expression:"district.value"}}):_vm._e(),_vm._v(" "),(_vm.district.value)?_c('v-select',{attrs:{"items":_vm.gTehsil,"clearable":"","label":"Tehsil"},model:{value:(_vm.tehsil.value),callback:function ($$v) {_vm.$set(_vm.tehsil, "value", $$v)},expression:"tehsil.value"}}):_vm._e(),_vm._v(" "),(_vm.tehsil.value)?_c('v-select',{attrs:{"items":_vm.gBlock,"label":"Block","clearable":""},model:{value:(_vm.block.value),callback:function ($$v) {_vm.$set(_vm.block, "value", $$v)},expression:"block.value"}}):_vm._e(),_vm._v(" "),(_vm.block.value)?_c('v-select',{attrs:{"items":_vm.gVillage,"label":"Village","clearable":""},model:{value:(_vm.village.value),callback:function ($$v) {_vm.$set(_vm.village, "value", $$v)},expression:"village.value"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"items":['Yes','No'],"label":"GST User"},model:{value:(_vm.GST_user),callback:function ($$v) {_vm.GST_user=$$v},expression:"GST_user"}}),_vm._v(" "),(_vm.GST_user === 'Yes')?_c('v-text-field',{attrs:{"type":"text","disabled":_vm.GST_user != 'Yes',"rules":_vm.GST_number.rules,"label":"GST number"},model:{value:(_vm.GST_number.value),callback:function ($$v) {_vm.$set(_vm.GST_number, "value", $$v)},expression:"GST_number.value"}}):_vm._e(),_vm._v(" "),(_vm.GST_user === 'Yes')?_c('v-select',{attrs:{"disabled":_vm.GST_user != 'Yes',"items":_vm.gGST_Type,"label":"GST Type"},model:{value:(_vm.GST_Type.value),callback:function ($$v) {_vm.$set(_vm.GST_Type, "value", $$v)},expression:"GST_Type.value"}}):_vm._e(),_vm._v(" "),(_vm.GST_user === 'No')?_c('v-text-field',{attrs:{"label":"Registration Number"},model:{value:(_vm.firmRegNumberEdit),callback:function ($$v) {_vm.firmRegNumberEdit=$$v},expression:"firmRegNumberEdit"}}):_vm._e(),_vm._v(" "),_c('v-text-field',{attrs:{"label":"PAN Number","rules":_vm.PAN_Rules},model:{value:(_vm.panNumber),callback:function ($$v) {_vm.panNumber=$$v},expression:"panNumber"}}),_vm._v(" "),_c('v-text-field',{ref:"email",attrs:{"type":"email","rules":_vm.email.rules,"label":"Email"},model:{value:(_vm.email.value),callback:function ($$v) {_vm.$set(_vm.email, "value", $$v)},expression:"email.value"}}),_vm._v(" "),_c('v-text-field',{ref:"website",attrs:{"label":"Website"},model:{value:(_vm.website),callback:function ($$v) {_vm.website=$$v},expression:"website"}}),_vm._v(" "),_c('v-select',{attrs:{"disabled":!!_vm.businessType,"items":['Automobile/Agricluture/Spare Parts', 'Clothes', 'Default', 'Dairy', 'Jwellery', 'Medical/Pesticides', 'Grain'],"label":"Business Type"},model:{value:(_vm.businessType),callback:function ($$v) {_vm.businessType=$$v},expression:"businessType"}}),_vm._v(" "),(!_vm.businessType)?_c('p',{staticStyle:{"color":"red","font-style":"italic","font-size":"12px"}},[_vm._v(" Note: This field can't be edited in future.")]):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"warning white--text",attrs:{"primary":"","title":"","flat":"flat"},on:{"click":_vm.cancelDialogEdit}},[_vm._v("\n          Cancel\n        ")]),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text",attrs:{"primary":"","title":"","flat":"flat"},on:{"click":_vm.updateFirm}},[_vm._v("\n          Update\n        ")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(518);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_492fe79e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1558);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_492fe79e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","offset-sm":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"headline text-xs-center"},[_vm._v("\n              Bank Account Management\n          ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{attrs:{"outlined":"","large":""},on:{"click":_vm.getFirms}},[_c('v-icon',{attrs:{"left":"","color":"teal"}},[_vm._v("\n                  add\n                  ")]),_vm._v("\n                  NEW BANK ACCOUNT  \n              ")],1)],1)],1),_vm._v(" "),_c('v-card',[_vm._l((_vm.getAccount),function(item,index){return [_c('v-divider',{key:item['.key']}),_vm._v(" "),_c('v-card',{key:index},[_c('v-card-title',{staticClass:"body-1 primary--text font-weight-light",attrs:{"col":""}},[_c('v-flex',{attrs:{"xs5":""}},[_vm._v("\n                    Firm :- "),_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.firmbyId(item.firm)))]),_vm._v(" "),_c('v-spacer'),_vm._v(" \n                    Bank Name :- "),_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(item.bankName))]),_vm._v(" "),_c('v-spacer'),_vm._v(" \n                    A/C Category :- "),_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(item.accountCategory))]),_vm._v(" "),_c('v-spacer'),_vm._v("  \n                    Account Holder Name :- "),_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(item.accountHolderName))]),_vm._v(" "),_c('v-spacer'),_vm._v("\n                    Account Type :- "),_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(item.accountType))])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs5":""}},[_vm._v("\n                    Account Number :- "),_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(item.accountnumber))]),_vm._v(" "),_c('v-spacer'),_vm._v("\n                    IFSC Code :- "),_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s((item.ifsccode).toUpperCase()))]),_vm._v(" "),_c('v-spacer'),_vm._v(" \n                    Location :- "),_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(item.accountLocation))]),_vm._v(" "),_c('v-spacer'),_vm._v("\n                    Available Balance :- "),_c('b',{staticClass:"font-weight-bold"},[_vm._v("₹"+_vm._s(_vm._f("amount")(item.amount)))])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('v-btn',{staticClass:"primary white--text",attrs:{"flat":"","icon":""},on:{"click":function($event){return _vm.editAccount(item)}}},[_c('v-icon',{staticClass:"white--text",attrs:{"primary":"","title":""}},[_vm._v("edit")])],1)],1)],1),_vm._v(" "),_c('v-spacer')],1)]})],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"400"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-form',{ref:"addAccount",attrs:{"lazy-validation":""},model:{value:(_vm.addNewAccountValid),callback:function ($$v) {_vm.addNewAccountValid=$$v},expression:"addNewAccountValid"}},[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":"","title":""}},[_c('span',{staticClass:"headline"},[_vm._v("Add New Bank Account")])]),_vm._v(" "),_c('v-card-text',[_c('v-select',{attrs:{"item-text":"name","item-value":"id","items":_vm.items,"rules":_vm.requiredRule,"label":"Select Firms"},on:{"change":_vm.firmChange},model:{value:(_vm.currentFirm),callback:function ($$v) {_vm.currentFirm=$$v},expression:"currentFirm"}}),_vm._v(" "),_c('v-select',{attrs:{"item-text":"name","item-value":"id","items":_vm.currentBankName,"rules":_vm.requiredRule,"label":"Choose Bank"},model:{value:(_vm.bankName),callback:function ($$v) {_vm.bankName=$$v},expression:"bankName"}}),_vm._v(" "),_c('v-select',{attrs:{"item-text":"name","item-value":"id","items":_vm.currentAccountCategory,"rules":_vm.requiredRule,"label":"Choose account category"},on:{"change":_vm.categoryChange},model:{value:(_vm.accountCategory),callback:function ($$v) {_vm.accountCategory=$$v},expression:"accountCategory"}}),_vm._v(" "),_c('v-select',{attrs:{"item-text":"name","item-value":"id","items":_vm.currentAccountType,"rules":_vm.requiredRule,"label":"Choose Account Type"},model:{value:(_vm.accountType),callback:function ($$v) {_vm.accountType=$$v},expression:"accountType"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Account Holder Name","rules":_vm.requiredRule,"disabled":_vm.accholderdisabled},model:{value:(_vm.accountHolderName),callback:function ($$v) {_vm.accountHolderName=$$v},expression:"accountHolderName"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Account Number","rules":_vm.requiredRule},model:{value:(_vm.accountnumber),callback:function ($$v) {_vm.accountnumber=$$v},expression:"accountnumber"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"IFSC code","rules":_vm.IFSC_Rules},on:{"change":function($event){return _vm.getBankDetailsFromIFSC(false)}},model:{value:(_vm.ifsccode),callback:function ($$v) {_vm.ifsccode=$$v},expression:"ifsccode"}}),_vm._v(" "),_c('v-textarea',{attrs:{"background-color":"grey darken-1","color":"black","label":"Location","box":"","rules":_vm.requiredRule},model:{value:(_vm.accountLocation),callback:function ($$v) {_vm.accountLocation=$$v},expression:"accountLocation"}}),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.gTehsil,"label":"Tehsil"},model:{value:(_vm.tehsil.value),callback:function ($$v) {_vm.$set(_vm.tehsil, "value", $$v)},expression:"tehsil.value"}}),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.gDistrict,"label":"District"},model:{value:(_vm.district.value),callback:function ($$v) {_vm.$set(_vm.district, "value", $$v)},expression:"district.value"}}),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.gState,"item-text":"state","label":"State"},model:{value:(_vm.state.value),callback:function ($$v) {_vm.$set(_vm.state, "value", $$v)},expression:"state.value"}}),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.gCountry,"label":"Country"},model:{value:(_vm.country.value),callback:function ($$v) {_vm.$set(_vm.country, "value", $$v)},expression:"country.value"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Amount"},model:{value:(_vm.initialamount),callback:function ($$v) {_vm.initialamount=_vm._n($$v)},expression:"initialamount"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Opening Balance","rules":_vm.requiredRule},model:{value:(_vm.openingBalance),callback:function ($$v) {_vm.openingBalance=$$v},expression:"openingBalance"}}),_vm._v(" "),_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker1),callback:function ($$v) {_vm.datepicker1=$$v},expression:"datepicker1"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Opening Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.openingDate),callback:function ($$v) {_vm.openingDate=$$v},expression:"openingDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepicker1 = false}},model:{value:(_vm.openingDate),callback:function ($$v) {_vm.openingDate=$$v},expression:"openingDate"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"warning white--text",attrs:{"primary":"","title":"","flat":"flat"},on:{"click":_vm.cancelDialog}},[_vm._v("\n          Cancel\n        ")]),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text",attrs:{"primary":"","title":"","flat":"flat"},on:{"click":_vm.addNewAccount}},[_vm._v("\n          Save\n        ")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"400"},model:{value:(_vm.dialogEdit),callback:function ($$v) {_vm.dialogEdit=$$v},expression:"dialogEdit"}},[_c('v-card',[_c('v-form',{ref:"editAccount",attrs:{"lazy-validation":""},model:{value:(_vm.addNewAccountValid),callback:function ($$v) {_vm.addNewAccountValid=$$v},expression:"addNewAccountValid"}},[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":"","title":""}},[_c('span',{staticClass:"headline"},[_vm._v("Edit Bank Account")])]),_vm._v(" "),_c('v-card-text',[_c('v-select',{attrs:{"item-text":"name","item-value":"id","rules":_vm.requiredRule,"items":_vm.itemsEdit,"label":"Select Firms"},on:{"change":_vm.firmChangeEdit},model:{value:(_vm.currentFirmEdit),callback:function ($$v) {_vm.currentFirmEdit=$$v},expression:"currentFirmEdit"}}),_vm._v(" "),_c('v-select',{attrs:{"item-text":"name","item-value":"id","rules":_vm.requiredRule,"items":_vm.currentBankName,"label":"Choose Bank"},model:{value:(_vm.bankNameEdit),callback:function ($$v) {_vm.bankNameEdit=$$v},expression:"bankNameEdit"}}),_vm._v(" "),_c('v-select',{attrs:{"item-text":"name","item-value":"id","rules":_vm.requiredRule,"items":_vm.currentAccountCategory,"label":"Choose account category"},on:{"change":_vm.categoryChangeEdit},model:{value:(_vm.accountCategoryEdit),callback:function ($$v) {_vm.accountCategoryEdit=$$v},expression:"accountCategoryEdit"}}),_vm._v(" "),_c('v-select',{attrs:{"item-text":"name","item-value":"id","rules":_vm.requiredRule,"items":_vm.currentAccountType,"label":"Choose Account Type"},model:{value:(_vm.accountTypeEdit),callback:function ($$v) {_vm.accountTypeEdit=$$v},expression:"accountTypeEdit"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Account Holder Name","rules":_vm.requiredRule,"disabled":_vm.accholderdisabledEdit},model:{value:(_vm.accountHolderNameEdit),callback:function ($$v) {_vm.accountHolderNameEdit=$$v},expression:"accountHolderNameEdit"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Account Number","rules":_vm.requiredRule},model:{value:(_vm.accountnumberEdit),callback:function ($$v) {_vm.accountnumberEdit=$$v},expression:"accountnumberEdit"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"IFSC code","rules":_vm.IFSC_Rules},on:{"change":function($event){return _vm.getBankDetailsFromIFSC(true)}},model:{value:(_vm.ifsccodeEdit),callback:function ($$v) {_vm.ifsccodeEdit=$$v},expression:"ifsccodeEdit"}}),_vm._v(" "),_c('v-textarea',{attrs:{"background-color":"grey darken-1","color":"black","label":"Location","box":"","rules":_vm.requiredRule},model:{value:(_vm.accountLocationEdit),callback:function ($$v) {_vm.accountLocationEdit=$$v},expression:"accountLocationEdit"}}),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.gCountry,"label":"Country"},model:{value:(_vm.country.value),callback:function ($$v) {_vm.$set(_vm.country, "value", $$v)},expression:"country.value"}}),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.gState,"item-text":"state","label":"State"},model:{value:(_vm.state.value),callback:function ($$v) {_vm.$set(_vm.state, "value", $$v)},expression:"state.value"}}),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.gDistrict,"label":"District"},model:{value:(_vm.district.value),callback:function ($$v) {_vm.$set(_vm.district, "value", $$v)},expression:"district.value"}}),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.gTehsil,"label":"Tehsil"},model:{value:(_vm.tehsil.value),callback:function ($$v) {_vm.$set(_vm.tehsil, "value", $$v)},expression:"tehsil.value"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Amount"},model:{value:(_vm.initialamountEdit),callback:function ($$v) {_vm.initialamountEdit=$$v},expression:"initialamountEdit"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Opening Balance","rules":_vm.requiredRule},model:{value:(_vm.openingBalanceEdit),callback:function ($$v) {_vm.openingBalanceEdit=$$v},expression:"openingBalanceEdit"}}),_vm._v(" "),_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker2),callback:function ($$v) {_vm.datepicker2=$$v},expression:"datepicker2"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Opening Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.openingDateEdit),callback:function ($$v) {_vm.openingDateEdit=$$v},expression:"openingDateEdit"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepicker2 = false}},model:{value:(_vm.openingDateEdit),callback:function ($$v) {_vm.openingDateEdit=$$v},expression:"openingDateEdit"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"warning white--text",attrs:{"primary":"","title":"","flat":"flat"},on:{"click":_vm.cancelDialog}},[_vm._v("\n          Cancel\n        ")]),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text",attrs:{"primary":"","title":"","flat":"flat"},on:{"click":_vm.updateNewAccount}},[_vm._v("\n          Update\n        ")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(519);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1821fba_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1560);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a1821fba_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","offset-sm":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"text-xs-center"},[_vm._v("\n              ASSET ACCOUNTS\n          ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{staticClass:"primary white--text",on:{"click":_vm.getFirms}},[_vm._v("\n                  ADD NEW ASSET ACCOUNT\n              ")])],1)],1),_vm._v(" "),_c('v-card',[_vm._l((_vm.getAssetAccount),function(item,index){return [_c('v-divider',{key:item['.key']}),_vm._v(" "),_c('v-card',{key:index},[_c('v-card-title',[_c('v-card-text',[_vm._v(" \n                Firm :- "),_c('b',[_vm._v(_vm._s(_vm.firmbyId(item.firm)))]),_vm._v("       \n                "),_vm._v("\n                Asset Category :- "),_c('b',[_vm._v(_vm._s(item.assetCategory))]),_vm._v("       \n                Asset Name :- "),_c('b',[_vm._v(_vm._s(item.assetName))]),_vm._v("       \n                Asset Type :- "),_c('b',[_vm._v(_vm._s(item.assetType))]),_vm._v("       \n                Account Number :- "),_c('b',[_vm._v(_vm._s(item.accountnumber))]),_vm._v("       \n                ")]),_vm._v(" "),_c('v-card-text',[_vm._v("\n                  Available Balance :- "),_c('b',[_vm._v("₹"+_vm._s(item.amount))]),_vm._v("      \n                  Opening Balance :- "),_c('b',[_vm._v("₹"+_vm._s(item.openingBalance))])])],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{staticClass:"primary white--text",attrs:{"flat":"","icon":""},on:{"click":function($event){return _vm.editAssetAccount(item['.key'])}}},[_c('v-icon',{attrs:{"color":"grey white--text"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text",attrs:{"flat":"","icon":""},on:{"click":function($event){return _vm.deleteAssetAccount(item['.key'])}}},[_c('v-icon',[_vm._v("delete")])],1)],1)],1)]})],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"400"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":"","title":""}},[_c('span',{staticClass:"headline"},[_vm._v("Add New Asset Account")])]),_vm._v(" "),_c('v-card-text',[_c('v-select',{attrs:{"item-text":"name","item-value":"id","items":_vm.items,"label":"Select Firms"},model:{value:(_vm.currentFirm),callback:function ($$v) {_vm.currentFirm=$$v},expression:"currentFirm"}}),_vm._v(" "),_c('v-select',{attrs:{"item-text":"name","item-value":"id","items":_vm.currentAssetCategory,"label":"Choose asset category"},model:{value:(_vm.assetCategory),callback:function ($$v) {_vm.assetCategory=$$v},expression:"assetCategory"}}),_vm._v(" "),_c('v-select',{attrs:{"item-text":"name","item-value":"id","items":_vm.currentAssetType,"label":"Choose Asset Type"},model:{value:(_vm.assetType),callback:function ($$v) {_vm.assetType=$$v},expression:"assetType"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Asset Name"},model:{value:(_vm.assetName),callback:function ($$v) {_vm.assetName=$$v},expression:"assetName"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Account Number"},model:{value:(_vm.accountnumber),callback:function ($$v) {_vm.accountnumber=$$v},expression:"accountnumber"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Amount"},model:{value:(_vm.initialamount),callback:function ($$v) {_vm.initialamount=$$v},expression:"initialamount"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Opening Balance"},model:{value:(_vm.openingBalance),callback:function ($$v) {_vm.openingBalance=$$v},expression:"openingBalance"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":_vm.cancelDialog}},[_vm._v("\n          Cancel\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":_vm.addNewAssetAccount}},[_vm._v("\n          Save\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(520);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3cc6dd8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1562);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d3cc6dd8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","offset-sm":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"text-xs-center"},[_vm._v("\n          LOAN ACCOUNTS\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{staticClass:"primary white--text",on:{"click":_vm.getFirms}},[_vm._v("\n            ADD NEW LOAN ACCOUNT\n          ")])],1)],1),_vm._v(" "),_c('v-card',[_vm._l((_vm.getLoanAccount),function(item,index){return [_c('v-divider',{key:item['.key']}),_vm._v(" "),_c('v-card',{key:index},[_c('v-card-title',[_c('v-card-text',[_vm._v(" \n                Firm :- "),_c('b',[_vm._v(_vm._s(_vm.firmbyId(item.firm)))]),_vm._v("        \n                Account Holder Name :- "),_c('b',[_vm._v(_vm._s(item.accountHolderName))]),_vm._v("      \n                "),_vm._v("\n                Opening Balance :- "),_c('b',[_vm._v("₹"+_vm._s(item.amount)+" ")])]),_vm._v(" "),_c('v-card-text',[_vm._v("\n                Account Number :- "),_c('b',[_vm._v(_vm._s(item.accountnumber))]),_vm._v("      \n                Loan Category :- "),_c('b',[_vm._v(_vm._s(item.loanCategory))]),_vm._v("      \n              ")])],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{staticClass:"primary white--text",attrs:{"flat":"","icon":""},on:{"click":function($event){return _vm.editLoanAccount(item['.key'])}}},[_c('v-icon',{attrs:{"color":"grey white--text"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text",attrs:{"flat":"","icon":""},on:{"click":function($event){return _vm.deleteLoanAccount(item['.key'])}}},[_c('v-icon',[_vm._v("delete")])],1)],1)],1)]})],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"400"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":"","title":""}},[_c('span',{staticClass:"headline"},[_vm._v("Add New Loan Account")])]),_vm._v(" "),_c('v-card-text',[_c('v-select',{attrs:{"item-text":"name","item-value":"id","items":_vm.items,"label":"Select Firms"},model:{value:(_vm.currentFirm),callback:function ($$v) {_vm.currentFirm=$$v},expression:"currentFirm"}}),_vm._v(" "),_c('v-select',{attrs:{"item-text":"name","item-value":"id","items":_vm.currentLoanCategory,"label":"Choose Loan category"},model:{value:(_vm.loanCategory),callback:function ($$v) {_vm.loanCategory=$$v},expression:"loanCategory"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Account Holder Name"},model:{value:(_vm.accountHolderName),callback:function ($$v) {_vm.accountHolderName=$$v},expression:"accountHolderName"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Account Number"},model:{value:(_vm.accountnumber),callback:function ($$v) {_vm.accountnumber=$$v},expression:"accountnumber"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Amount"},model:{value:(_vm.initialamount),callback:function ($$v) {_vm.initialamount=$$v},expression:"initialamount"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text",attrs:{"primary":"","title":"","flat":"flat"},on:{"click":_vm.cancelDialog}},[_vm._v("\n          Cancel\n        ")]),_vm._v(" "),_c('v-btn',{staticClass:"success white--text",attrs:{"primary":"","title":"","flat":"flat"},on:{"click":_vm.addNewLoanAccount}},[_vm._v("\n          Save\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(521);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7841230_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1564);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7841230_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","offset-sm":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"text-xs-center"},[_vm._v("\n              LOAN & ADVANCES ACCOUNTS\n          ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{staticClass:"primary white--text",on:{"click":_vm.getFirms}},[_vm._v("\n                  ADD NEW LOAN & ADVANCES ACCOUNT\n              ")])],1)],1),_vm._v(" "),_c('v-card',[_vm._l((_vm.getLoanAdvancesAccount),function(item,index){return [_c('v-divider',{key:item['.key']}),_vm._v(" "),_c('v-card',{key:index},[_c('v-card-title',[_c('v-card-text',[_vm._v(" \n                Firm :- "),_c('b',[_vm._v(_vm._s(_vm.firmbyId(item.firm)))]),_vm._v("        \n                Account Holder Name :- "),_c('b',[_vm._v(_vm._s(item.accountHolderName))]),_vm._v("      \n                Opening Balance :- "),_c('b',[_vm._v("₹"+_vm._s(item.openingBalance))]),_vm._v("     \n                Available Balance :- "),_c('b',[_vm._v("₹"+_vm._s(item.amount))])])],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{staticClass:"primary white--text",attrs:{"flat":"","icon":""},on:{"click":function($event){return _vm.editLoanAccount(item['.key'])}}},[_c('v-icon',{attrs:{"color":"grey white--text"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text",attrs:{"flat":"","icon":""},on:{"click":function($event){return _vm.deleteLoanAccount(item['.key'])}}},[_c('v-icon',[_vm._v("delete")])],1)],1)],1)]})],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"400"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":"","title":""}},[_c('span',{staticClass:"headline"},[_vm._v("Add New Loan Advances Account")])]),_vm._v(" "),_c('v-card-text',[_c('v-select',{attrs:{"item-text":"name","item-value":"id","items":_vm.items,"label":"Select Firms"},model:{value:(_vm.currentFirm),callback:function ($$v) {_vm.currentFirm=$$v},expression:"currentFirm"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Account Holder Name"},model:{value:(_vm.accountHolderName),callback:function ($$v) {_vm.accountHolderName=$$v},expression:"accountHolderName"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Opening Balance"},model:{value:(_vm.openingBalance),callback:function ($$v) {_vm.openingBalance=$$v},expression:"openingBalance"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Amount"},model:{value:(_vm.initialamount),callback:function ($$v) {_vm.initialamount=$$v},expression:"initialamount"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":_vm.cancelDialog}},[_vm._v("\n          Cancel\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":_vm.addNewLoanAdvancesAccount}},[_vm._v("\n          Save\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(522);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76af6bc5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1566);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76af6bc5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","offset-sm":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"headline text-xs-center"},[_vm._v("\n          Store Management\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[(_vm.$route.path!='/godown-reports')?_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":"/godown-reports"}},[_c('v-btn',{staticStyle:{"margin":"0px 15px"},attrs:{"outlined":""}},[_c('v-icon',{attrs:{"left":"","color":"teal"}},[_vm._v("store")]),_vm._v("\n                Store Reports\n            ")],1)],1):_vm._e(),_vm._v(" "),(_vm.$route.path!='/godawn')?_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":"/godawn"}},[_c('v-btn',{staticStyle:{"margin":"0px 15px"},attrs:{"outlined":""}},[_c('v-icon',{attrs:{"left":"","color":"teal"}},[_vm._v("store")]),_vm._v("\n                Visit Stores\n            ")],1)],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"outlined":""},on:{"click":_vm.getFirms}},[_c('v-icon',{attrs:{"left":"","color":"teal"}},[_vm._v("add")]),_vm._v(" \n            New Store\n          ")],1)],1)],1),_vm._v(" "),_c('v-card',[_vm._l((_vm.getGodawnAccount),function(item,index){return [_c('v-divider',{key:item['.key']}),_vm._v(" "),_c('v-card',{key:index},[_c('v-card-title',[_vm._v("\n                Godawn Name :-   "),_c('b',{staticClass:"primary--text font-weight-bold"},[_vm._v(_vm._s(item.godawnName))]),_vm._v("      \n                Godawn Address :-   "),_c('b',{staticClass:"primary--text font-weight-bold"},[_vm._v(_vm._s(item.godawnAddress))]),_vm._v("      \n                Godawn Pincode :-   "),_c('b',{staticClass:"primary--text font-weight-bold"},[_vm._v(_vm._s(item.godawnPincode))]),_vm._v("             \n                "),_c('v-btn',{staticClass:"yellow white--text",attrs:{"flat":"","icon":""},on:{"click":function($event){return _vm.editGodawnAccount(item)}}},[_c('v-icon',{attrs:{"color":"grey white--text"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"error white--text",attrs:{"flat":"","icon":""},on:{"click":function($event){return _vm.deleteGodawnAccount(item['.key'])}}},[_c('v-icon',[_vm._v("delete")])],1)],1)],1)]})],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"400"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":"","title":""}},[_c('span',{staticClass:"headline"},[_vm._v("Add New Godawn Account")])]),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"label":"Godawn Name"},model:{value:(_vm.godawnName),callback:function ($$v) {_vm.godawnName=$$v},expression:"godawnName"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Address"},model:{value:(_vm.godawnAddress),callback:function ($$v) {_vm.godawnAddress=$$v},expression:"godawnAddress"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Pincode"},model:{value:(_vm.godawnPincode),callback:function ($$v) {_vm.godawnPincode=$$v},expression:"godawnPincode"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":_vm.cancelDialog}},[_vm._v("\n          Cancel\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":_vm.addNewGodawnAccount}},[_vm._v("\n          Save\n        ")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"400"},model:{value:(_vm.dialogEdit),callback:function ($$v) {_vm.dialogEdit=$$v},expression:"dialogEdit"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":"","title":""}},[_c('span',{staticClass:"headline"},[_vm._v("Edit Godawn Details")])]),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"label":"Edit Godawn Name"},model:{value:(_vm.godawnNameEdit),callback:function ($$v) {_vm.godawnNameEdit=$$v},expression:"godawnNameEdit"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Edit Address"},model:{value:(_vm.godawnAddressEdit),callback:function ($$v) {_vm.godawnAddressEdit=$$v},expression:"godawnAddressEdit"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Edit Pincode"},model:{value:(_vm.godawnPincodeEdit),callback:function ($$v) {_vm.godawnPincodeEdit=$$v},expression:"godawnPincodeEdit"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":_vm.cancelDialogEdit}},[_vm._v("\n          Cancel\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":_vm.updateNewGodawnAccount}},[_vm._v("\n          Update\n        ")])],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"top":"","color":"error","timeout":3000},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n "+_vm._s(_vm.snackbarText)+"\n  ")]),_vm._v(" "),_c('v-snackbar',{attrs:{"top":"","color":"success","timeout":3000},model:{value:(_vm.snackbarSuccess),callback:function ($$v) {_vm.snackbarSuccess=$$v},expression:"snackbarSuccess"}},[_vm._v("\n "+_vm._s(_vm.snackbarSuccessText)+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(523);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9082cae4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1569);
function injectStyle (ssrContext) {
  __webpack_require__(1568)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9082cae4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1568 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-cotainer',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"headline text-xs-center"},[_vm._v("\n          Staff Information\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"prepend-inner-icon":"search","solo":"","outlined":"","clearable":"","label":"Search Staff"},nativeOn:{"keyup":function($event){return _vm.keymonitor($event)}}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{attrs:{"outlined":"","disabled":!_vm.hasHrAddPermission},on:{"click":_vm.addHr}},[_c('v-icon',{attrs:{"left":"","color":"teal"}},[_vm._v("add")]),_vm._v("\n              New Staff \n          ")],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.hrListHeader,"items":_vm.hrListByBrand,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',[_vm._v(_vm._s(props.item['.key']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['name']))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b',{staticClass:"font-weight-light"},[_vm._v(_vm._s(props.item['description']))]),_vm._v(" \n              -\n            "),_c('b',{staticClass:"font-weight-light"},[_vm._v(_vm._s(props.item['gender']))]),_vm._v("\n              -\n            "),_c('b',{staticClass:"font-weight-light"},[_vm._v(_vm._s(props.item['marital']))]),_vm._v("\n              -\n            "),_c('b',{staticClass:"font-weight-light"},[_vm._v(_vm._s(props.item.staffDesignationCategory))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['fatherName']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['motherName']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['guardianName']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['employerName']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['Designation']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.staffDesignationCategory))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['age'])+" - "+_vm._s(props.item['Gender']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"info--text font-weight-bold"},[_vm._v(_vm._s(props.item['basicSalary'])+" ")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"primary--text font-weight-bold"},[_vm._v(_vm._s(props.item['netSalary']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['epfAmount']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['esiAmount']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['tdsAmount']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['casualLeave']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['hra']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['generalConveyance']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['medicalConveyance']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['specialConveyance']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['bankName']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['accountHolderName']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['accountType']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['accountNumber']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['accountLocation']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['ifsccode']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['email']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['mobile']))])]),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"disabled":!_vm.hasHrTransferPermission,"icon":""},on:{"click":function($event){return _vm.openTansferDialog(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("double_arrow")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"disabled":!_vm.hasHrEditPermission,"icon":""},on:{"click":function($event){return _vm.editHr(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"disabled":!_vm.hasHrDeletePermission,"icon":""},on:{"click":function($event){return _vm.deleteHr(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.openDamageDialog(props.item)}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("warning")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","fullscreen":"","hide-overlay":""},model:{value:(_vm.addHrDialog),callback:function ($$v) {_vm.addHrDialog=$$v},expression:"addHrDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Staff Details")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.addHrDialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-stepper',{attrs:{"vertical":""},model:{value:(_vm.stepper),callback:function ($$v) {_vm.stepper=$$v},expression:"stepper"}},[_c('v-stepper-step',{attrs:{"complete":_vm.stepper > 1,"step":"1"}},[_vm._v("Step 1: Enter Personal Information "),_c('h3',{staticClass:"error--text text--darken-4"},[_vm._v(_vm._s(_vm.duplicateError))])]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-card',{staticClass:"mb-12",staticStyle:{"height":"100%"}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-combobox',{attrs:{"prepend-icon":"account_box","items":_vm.hrListByBrand,"return-object":false,"item-text":"name","item-value":"name","label":"Staff Name","placeholder":"Enter Staff Name"},on:{"change":function($event){return _vm.duplicateCheck()}},model:{value:(_vm.currentHr.name),callback:function ($$v) {_vm.$set(_vm.currentHr, "name", $$v)},expression:"currentHr.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-combobox',{attrs:{"prepend-icon":"account_box","return-object":false,"item-text":"name","item-value":"name","label":"Employee Father Name","placeholder":"Enter Father Name"},model:{value:(_vm.currentHr.fatherName),callback:function ($$v) {_vm.$set(_vm.currentHr, "fatherName", $$v)},expression:"currentHr.fatherName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-combobox',{attrs:{"prepend-icon":"account_box","return-object":false,"item-text":"name","item-value":"name","label":"Employee Mother Name","placeholder":"Enter Mother Name"},on:{"change":function($event){return _vm.duplicateCheck()}},model:{value:(_vm.currentHr.motherName),callback:function ($$v) {_vm.$set(_vm.currentHr, "motherName", $$v)},expression:"currentHr.motherName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-combobox',{attrs:{"prepend-icon":"account_box","return-object":false,"item-text":"name","item-value":"name","label":"Guardian Name","placeholder":"Enter Guardian Name"},model:{value:(_vm.currentHr.guardianName),callback:function ($$v) {_vm.$set(_vm.currentHr, "guardianName", $$v)},expression:"currentHr.guardianName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-text-field',{ref:"age",attrs:{"prepend-icon":"font_download","type":"number","rules":_vm.age.rules,"label":"Age","maxlength":"3"},model:{value:(_vm.currentHr.age),callback:function ($$v) {_vm.$set(_vm.currentHr, "age", $$v)},expression:"currentHr.age"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-select',{attrs:{"prepend-icon":"wc","items":_vm.gGender,"label":"Gender"},model:{value:(_vm.currentHr.gender),callback:function ($$v) {_vm.$set(_vm.currentHr, "gender", $$v)},expression:"currentHr.gender"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-select',{attrs:{"prepend-icon":"nature_people","items":_vm.gMarital,"label":"Marital Status"},model:{value:(_vm.currentHr.marital),callback:function ($$v) {_vm.$set(_vm.currentHr, "marital", $$v)},expression:"currentHr.marital"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-select',{attrs:{"prepend-icon":"perm_identity","items":_vm.gIdentityType,"clearable":"","label":"Identity Type"},model:{value:(_vm.identityType.value),callback:function ($$v) {_vm.$set(_vm.identityType, "value", $$v)},expression:"identityType.value"}})],1),_vm._v(" "),(_vm.identityType.value)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{ref:"identityNumber",attrs:{"prepend-icon":"picture_in_picture","error-messages":_vm.identityNumeberError,"rules":_vm.identityNumber.rules,"label":"Identity Number"},model:{value:(_vm.identityNumber.value),callback:function ($$v) {_vm.$set(_vm.identityNumber, "value", $$v)},expression:"identityNumber.value"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{ref:"mobile",attrs:{"prepend-icon":"phone","type":"number","rules":_vm.mobile.rules,"label":"Mobile"},model:{value:(_vm.currentHr.mobile),callback:function ($$v) {_vm.$set(_vm.currentHr, "mobile", $$v)},expression:"currentHr.mobile"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{ref:"email",attrs:{"prepend-icon":"email","type":"email","rules":_vm.email.rules,"label":"Email"},model:{value:(_vm.currentHr.email),callback:function ($$v) {_vm.$set(_vm.currentHr, "email", $$v)},expression:"currentHr.email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-select',{attrs:{"dense":"","prepend-icon":"policy","items":_vm.firmsByBrand,"label":"Select Firm","item-text":"text","item-value":"value"},model:{value:(_vm.currentHr.firm),callback:function ($$v) {_vm.$set(_vm.currentHr, "firm", $$v)},expression:"currentHr.firm"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm5":"","md5":""}},[_c('v-text-field',{attrs:{"prepend-icon":"info","type":"text","label":"Employee Specialization"},model:{value:(_vm.currentHr.description),callback:function ($$v) {_vm.$set(_vm.currentHr, "description", $$v)},expression:"currentHr.description"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker),callback:function ($$v) {_vm.datepicker=$$v},expression:"datepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date of Birth ","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.currentHr.dateOfBirth),callback:function ($$v) {_vm.$set(_vm.currentHr, "dateOfBirth", $$v)},expression:"currentHr.dateOfBirth"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepicker = false}},model:{value:(_vm.currentHr.dateOfBirth),callback:function ($$v) {_vm.$set(_vm.currentHr, "dateOfBirth", $$v)},expression:"currentHr.dateOfBirth"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-textarea',{staticClass:"address",attrs:{"background-color":"grey lighten-1","color":"black","box":"","name":"input-7-1","prepend-icon":"store","type":"text","label":"Current Address"},model:{value:(_vm.currentHr.currentAddressDescription),callback:function ($$v) {_vm.$set(_vm.currentHr, "currentAddressDescription", $$v)},expression:"currentHr.currentAddressDescription"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-textarea',{attrs:{"background-color":"grey darken-1","color":"black","box":"","name":"input-7-1","prepend-icon":"store","type":"text","label":"Permanent Address"},model:{value:(_vm.currentHr.currentPermanentDescription),callback:function ($$v) {_vm.$set(_vm.currentHr, "currentPermanentDescription", $$v)},expression:"currentHr.currentPermanentDescription"}})],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.stepper = 2}}},[_vm._v("Next")])],1)],1)],1),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.stepper > 2,"step":"2"}},[_vm._v("Step 2 : Enter your Bank Details")]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-card',{staticClass:"mb-12",staticStyle:{"height":"100%"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-select',{attrs:{"dense":"","items":[
                        {
                          text: 'Yes',
                          value: true
                        },
                        {
                          text: 'No',
                          value: false
                        } ],"label":"Enter Bank Details?"},model:{value:(_vm.isBankDetails),callback:function ($$v) {_vm.isBankDetails=$$v},expression:"isBankDetails"}})],1)],1),_vm._v(" "),(_vm.isBankDetails)?_c('v-layout',{attrs:{"wrap":""}},[(_vm.isBankDetails)?_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"item-text":"name","item-value":"id","items":_vm.currentBankName,"label":"Choose Bank"},model:{value:(_vm.currentHr.bankName),callback:function ($$v) {_vm.$set(_vm.currentHr, "bankName", $$v)},expression:"currentHr.bankName"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"item-text":"name","item-value":"id","items":_vm.currentAccountType,"label":"Choose Account Type"},model:{value:(_vm.currentHr.accountType),callback:function ($$v) {_vm.$set(_vm.currentHr, "accountType", $$v)},expression:"currentHr.accountType"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Account Holder Name","disabled":_vm.accholderdisabled},model:{value:(_vm.currentHr.accountHolderName),callback:function ($$v) {_vm.$set(_vm.currentHr, "accountHolderName", $$v)},expression:"currentHr.accountHolderName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Account Number"},model:{value:(_vm.currentHr.accountNumber),callback:function ($$v) {_vm.$set(_vm.currentHr, "accountNumber", $$v)},expression:"currentHr.accountNumber"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"IFSC code","rules":_vm.IFSC_Rules},on:{"change":function($event){return _vm.getBankDetailsFromIFSC(false)}},model:{value:(_vm.ifsccode),callback:function ($$v) {_vm.ifsccode=$$v},expression:"ifsccode"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-textarea',{attrs:{"background-color":"grey darken-1","color":"black","label":"Location","box":""},model:{value:(_vm.accountLocation),callback:function ($$v) {_vm.accountLocation=$$v},expression:"accountLocation"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('v-card-text',[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.stepper = 3}}},[_vm._v("Next")]),_vm._v(" "),_c('v-btn',{attrs:{"text":""},on:{"click":function($event){_vm.stepper = 1}}},[_vm._v("Back")])],1)],1)],1),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.stepper > 3,"step":"3"}},[_vm._v("Step 3 : Enter your Professional Details")]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"3"}},[_c('v-card',{staticClass:"mb-12",staticStyle:{"height":"100%"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-select',{attrs:{"dense":"","items":[
                        {
                          text: 'Yes',
                          value: true
                        },
                        {
                          text: 'No',
                          value: false
                        } ],"label":"Enter Professional Details?"},model:{value:(_vm.isProfessionalDetails),callback:function ($$v) {_vm.isProfessionalDetails=$$v},expression:"isProfessionalDetails"}})],1)],1),_vm._v(" "),(_vm.isProfessionalDetails)?_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.Designations,"label":"Select Role"},model:{value:(_vm.currentHr.Designation),callback:function ($$v) {_vm.$set(_vm.currentHr, "Designation", $$v)},expression:"currentHr.Designation"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[(_vm.currentHr.Designation === 'Teacher')?_c('v-select',{attrs:{"type":"number","dense":"","items":['PPRT','PRT','TGT','PGT'],"disabled":_vm.currentHr.Designation != 'Teacher',"label":"Teacher Classification"},model:{value:(_vm.currentHr.staffDesignationCategory),callback:function ($$v) {_vm.$set(_vm.currentHr, "staffDesignationCategory", $$v)},expression:"currentHr.staffDesignationCategory"}}):_vm._e()],1),_vm._v(" "),(_vm.isProfessionalDetails)?_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"EPF Number"},model:{value:(_vm.epfnumber),callback:function ($$v) {_vm.epfnumber=$$v},expression:"epfnumber"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"item-text":"name","item-value":"id","items":_vm.currentContractType,"label":"Choose Contract Type"},model:{value:(_vm.contractType),callback:function ($$v) {_vm.contractType=$$v},expression:"contractType"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"item-text":"name","item-value":"id","items":_vm.currentWorkShift,"label":"Choose WorkshiftType"},model:{value:(_vm.workShift),callback:function ($$v) {_vm.workShift=$$v},expression:"workShift"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{ref:"age",attrs:{"type":"number","rules":_vm.workExperience.rules,"label":"Work Experience(in Years)","maxlength":"3"},model:{value:(_vm.workExperience.value),callback:function ($$v) {_vm.$set(_vm.workExperience, "value", $$v)},expression:"workExperience.value"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Staff ID"},model:{value:(_vm.currentHr.StaffId),callback:function ($$v) {_vm.$set(_vm.currentHr, "StaffId", $$v)},expression:"currentHr.StaffId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker1),callback:function ($$v) {_vm.datepicker1=$$v},expression:"datepicker1"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date of Joining ","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.currentHr.dateOfJoining),callback:function ($$v) {_vm.$set(_vm.currentHr, "dateOfJoining", $$v)},expression:"currentHr.dateOfJoining"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepicker1= false}},model:{value:(_vm.currentHr.dateOfJoining),callback:function ($$v) {_vm.$set(_vm.currentHr, "dateOfJoining", $$v)},expression:"currentHr.dateOfJoining"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-combobox',{attrs:{"prepend-icon":"account_box","return-object":false,"item-text":"name","item-value":"name","label":"Previous Employer","placeholder":"Enter Previous Employer Name"},model:{value:(_vm.currentHr.employerName),callback:function ($$v) {_vm.$set(_vm.currentHr, "employerName", $$v)},expression:"currentHr.employerName"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('v-card-text',[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.stepper = 4}}},[_vm._v("Next")]),_vm._v(" "),_c('v-btn',{attrs:{"text":""},on:{"click":function($event){_vm.stepper = 2}}},[_vm._v("Back")])],1)],1)],1),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.stepper > 4,"step":"4"}},[_vm._v("Step 4 : Enter your Salary Details")]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"4"}},[_c('v-card',{staticClass:"mb-12",staticStyle:{"height":"100%"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-select',{attrs:{"dense":"","items":[
                        {
                          text: 'Yes',
                          value: true
                        },
                        {
                          text: 'No',
                          value: false
                        } ],"label":"Enter Salary Details?"},model:{value:(_vm.isSalaryDetails),callback:function ($$v) {_vm.isSalaryDetails=$$v},expression:"isSalaryDetails"}})],1)],1),_vm._v(" "),(_vm.isSalaryDetails)?_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Basic Salary"},model:{value:(_vm.currentHr.basicSalary),callback:function ($$v) {_vm.$set(_vm.currentHr, "basicSalary", $$v)},expression:"currentHr.basicSalary"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"HRA(House Rent Allowance)"},model:{value:(_vm.currentHr.hra),callback:function ($$v) {_vm.$set(_vm.currentHr, "hra", $$v)},expression:"currentHr.hra"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Genreal Conveyance"},model:{value:(_vm.currentHr.generalConveyance),callback:function ($$v) {_vm.$set(_vm.currentHr, "generalConveyance", $$v)},expression:"currentHr.generalConveyance"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Medical Conveyance"},model:{value:(_vm.currentHr.medicalConveyance),callback:function ($$v) {_vm.$set(_vm.currentHr, "medicalConveyance", $$v)},expression:"currentHr.medicalConveyance"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Special Conveyance"},model:{value:(_vm.currentHr.specialConveyance),callback:function ($$v) {_vm.$set(_vm.currentHr, "specialConveyance", $$v)},expression:"currentHr.specialConveyance"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Casual Leave"},model:{value:(_vm.currentHr.casualLeave),callback:function ($$v) {_vm.$set(_vm.currentHr, "casualLeave", $$v)},expression:"currentHr.casualLeave"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"EPF Amount"},model:{value:(_vm.currentHr.epfAmount),callback:function ($$v) {_vm.$set(_vm.currentHr, "epfAmount", $$v)},expression:"currentHr.epfAmount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"ESI[Employee State Tax]"},model:{value:(_vm.currentHr.esiAmount),callback:function ($$v) {_vm.$set(_vm.currentHr, "esiAmount", $$v)},expression:"currentHr.esiAmount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"TDS[Tax Deduction at Source]"},model:{value:(_vm.currentHr.tdsAmount),callback:function ($$v) {_vm.$set(_vm.currentHr, "tdsAmount", $$v)},expression:"currentHr.tdsAmount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Professional Tax"},model:{value:(_vm.currentHr.professionalTaxAmount),callback:function ($$v) {_vm.$set(_vm.currentHr, "professionalTaxAmount", $$v)},expression:"currentHr.professionalTaxAmount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Net Salary"},model:{value:(_vm.currentHr.netSalary),callback:function ($$v) {_vm.$set(_vm.currentHr, "netSalary", $$v)},expression:"currentHr.netSalary"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('v-card-text',[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.stepper = 5}}},[_vm._v("Next")]),_vm._v(" "),_c('v-btn',{attrs:{"text":""},on:{"click":function($event){_vm.stepper = 3}}},[_vm._v("Back")])],1)],1)],1),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.stepper > 5,"step":"5"}},[_vm._v("Step 5 Do you want to Upload Documents ")]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"5"}},[_c('v-card',{staticClass:"mb-12",staticStyle:{"height":"100%"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-select',{attrs:{"dense":"","items":[
                        {
                          text: 'Yes',
                          value: true
                        },
                        {
                          text: 'No',
                          value: false
                        } ],"label":"Do you want to add Documents like Resume,CV,Certificates,Letters,etc?"},model:{value:(_vm.isDocumentAvailable),callback:function ($$v) {_vm.isDocumentAvailable=$$v},expression:"isDocumentAvailable"}})],1),_vm._v(" "),(_vm.isDocumentAvailable)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-select',{attrs:{"dense":"","disabled":true,"items":_vm.units,"label":"Select unit","value":this.currentHr.unitsDeatilsAdded ? this.getLastUnit : this.currentHr.unit}})],1):_vm._e(),_vm._v(" "),(_vm.isDocumentAvailable)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-select',{attrs:{"dense":"","items":['PGT','TGT','UGT'],"disabled":true,"label":"Teacher Classification"},model:{value:(_vm.currentHr.staffDesignationCategory),callback:function ($$v) {_vm.$set(_vm.currentHr, "staffDesignationCategory", $$v)},expression:"currentHr.staffDesignationCategory"}})],1):_vm._e()],1),_vm._v(" "),(_vm.isDocumentAvailable)?_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Purchasing Price [Excluding GST]"},model:{value:(_vm.currentHr.purchasingPrice),callback:function ($$v) {_vm.$set(_vm.currentHr, "purchasingPrice", $$v)},expression:"currentHr.purchasingPrice"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","disabled":true,"value":_vm.currentHr.staffDesignationCategory ? (Number.parseFloat((_vm.currentHr.purchasingPrice * _vm.currentHr.staffDesignationCategory)/100) + Number.parseFloat(_vm.currentHr.purchasingPrice)).toFixed(2) : _vm.currentHr.purchasingPrice,"label":"Purchasing Price [Including GST]"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Selling Price [Excluding GST]"},model:{value:(_vm.currentHr.sellingPrice),callback:function ($$v) {_vm.$set(_vm.currentHr, "sellingPrice", $$v)},expression:"currentHr.sellingPrice"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","disabled":true,"value":_vm.currentHr.staffDesignationCategory ? (Number.parseFloat((_vm.currentHr.sellingPrice * _vm.currentHr.staffDesignationCategory)/100) + Number.parseFloat(_vm.currentHr.sellingPrice)).toFixed(2) : _vm.currentHr.sellingPrice,"label":"Selling Price [Including GST]"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('v-card-text',[(!_vm.currentHr['.key'])?_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.saveHr}},[_vm._v("Save")]):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"text":""},on:{"click":function($event){_vm.stepper = 4}}},[_vm._v("Back")]),_vm._v(" "),(!!_vm.currentHr['.key'])?_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.updateHr}},[_vm._v("Update")]):_vm._e()],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.timeout,"top":"","color":"primary"},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    Thank You so Much \n    "),_vm._v("\n      To make you serve Better.\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_staffAttendance_vue__ = __webpack_require__(524);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d47f4ca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_staffAttendance_vue__ = __webpack_require__(1572);
function injectStyle (ssrContext) {
  __webpack_require__(1571)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_staffAttendance_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d47f4ca_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_staffAttendance_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1571 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-cotainer',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"headline text-xs-center"},[_vm._v("\n          Staff Attendance\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"prepend-inner-icon":"search","solo":"","outlined":"","clearable":"","label":"Search Staff"},nativeOn:{"keyup":function($event){return _vm.keymonitor($event)}}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{staticClass:"white--text",attrs:{"outline":"","disabled":!_vm.hasHrAddPermission},on:{"click":_vm.addHr}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("add")]),_vm._v("\n              New Staff \n          ")],1)],1)],1),_vm._v(" "),_c('v-toolbar',{staticStyle:{"margin-top":"8px"}},[_c('v-flex',{staticStyle:{"margin-left":"-10px"},attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.items1,"label":"Search Role","outline":""}})],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"10px"},attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.items2,"label":"Search Month","outline":""}})],1)],1),_vm._v(" "),_c('v-toolbar',{staticClass:"white--text"},[_c('v-radio-group',{staticStyle:{"margin-top":"18px"},attrs:{"row":""}},[_c('v-radio',{attrs:{"label":"Present","value":"radio-1"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Absent","value":"radio-2"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Leave","value":"radio-3"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Half Day","value":"radio-4"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Late","value":"radio-4"}})],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.hrListHeader,"items":_vm.hrListByBrand,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',[_vm._v(_vm._s(props.item['.key']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['name']))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b',{staticClass:"font-weight-light"},[_vm._v(_vm._s(props.item['description']))]),_vm._v(" \n              -\n            "),_c('b',{staticClass:"font-weight-light"},[_vm._v(_vm._s(props.item['gender']))]),_vm._v("\n              -\n            "),_c('b',{staticClass:"font-weight-light"},[_vm._v(_vm._s(props.item['marital']))]),_vm._v("\n              -\n            "),_c('b',{staticClass:"font-weight-light"},[_vm._v(_vm._s(props.item.staffDesignationCategory))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['Designation']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.staffDesignationCategory))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['age'])+" - "+_vm._s(props.item['Gender']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"info--text font-weight-bold"},[_vm._v(_vm._s(props.item['basicSalary'])+" ")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"primary--text font-weight-bold"},[_vm._v(_vm._s(props.item['netSalary']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['epfAmount']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['esiAmount']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['tdsAmount']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['casualLeave']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['hra']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['generalConveyance']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['medicalConveyance']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['specialConveyance']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['bankName']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['accountHolderName']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['accountType']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['accountNumber']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['accountLocation']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['ifsccode']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['email']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['mobile']))])]),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"disabled":!_vm.hasHrTransferPermission,"icon":""},on:{"click":function($event){return _vm.openTansferDialog(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("double_arrow")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"disabled":!_vm.hasHrEditPermission,"icon":""},on:{"click":function($event){return _vm.editHr(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"disabled":!_vm.hasHrDeletePermission,"icon":""},on:{"click":function($event){return _vm.deleteHr(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.openDamageDialog(props.item)}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("warning")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","fullscreen":"","hide-overlay":""},model:{value:(_vm.addHrDialog),callback:function ($$v) {_vm.addHrDialog=$$v},expression:"addHrDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Staff Details")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.addHrDialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-stepper',{attrs:{"vertical":""},model:{value:(_vm.stepper),callback:function ($$v) {_vm.stepper=$$v},expression:"stepper"}},[_c('v-stepper-step',{attrs:{"complete":_vm.stepper > 1,"step":"1"}},[_vm._v("Step 1: Enter Personal Information "),_c('h3',{staticClass:"error--text text--darken-4"},[_vm._v(_vm._s(_vm.duplicateError))])]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-card',{staticClass:"mb-12",staticStyle:{"height":"100%"}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-combobox',{attrs:{"prepend-icon":"account_box","items":_vm.hrListByBrand,"return-object":false,"item-text":"name","item-value":"name","label":"Staff Name","placeholder":"Enter Staff Name"},on:{"change":function($event){return _vm.duplicateCheck()}},model:{value:(_vm.currentHr.name),callback:function ($$v) {_vm.$set(_vm.currentHr, "name", $$v)},expression:"currentHr.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-text-field',{ref:"age",attrs:{"prepend-icon":"font_download","type":"number","rules":_vm.age.rules,"label":"Age","maxlength":"3"},model:{value:(_vm.currentHr.age),callback:function ($$v) {_vm.$set(_vm.currentHr, "age", $$v)},expression:"currentHr.age"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-select',{attrs:{"prepend-icon":"wc","items":_vm.gGender,"label":"Gender"},model:{value:(_vm.currentHr.gender),callback:function ($$v) {_vm.$set(_vm.currentHr, "gender", $$v)},expression:"currentHr.gender"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-select',{attrs:{"prepend-icon":"nature_people","items":_vm.gMarital,"label":"Marital Status"},model:{value:(_vm.currentHr.marital),callback:function ($$v) {_vm.$set(_vm.currentHr, "marital", $$v)},expression:"currentHr.marital"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-select',{attrs:{"prepend-icon":"perm_identity","items":_vm.gIdentityType,"clearable":"","label":"Identity Type"},model:{value:(_vm.identityType.value),callback:function ($$v) {_vm.$set(_vm.identityType, "value", $$v)},expression:"identityType.value"}})],1),_vm._v(" "),(_vm.identityType.value)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{ref:"identityNumber",attrs:{"prepend-icon":"picture_in_picture","error-messages":_vm.identityNumeberError,"rules":_vm.identityNumber.rules,"label":"Identity Number"},model:{value:(_vm.identityNumber.value),callback:function ($$v) {_vm.$set(_vm.identityNumber, "value", $$v)},expression:"identityNumber.value"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{ref:"mobile",attrs:{"prepend-icon":"phone","type":"number","rules":_vm.mobile.rules,"label":"Mobile"},model:{value:(_vm.currentHr.mobile),callback:function ($$v) {_vm.$set(_vm.currentHr, "mobile", $$v)},expression:"currentHr.mobile"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{ref:"email",attrs:{"prepend-icon":"email","type":"email","rules":_vm.email.rules,"label":"Email"},model:{value:(_vm.currentHr.email),callback:function ($$v) {_vm.$set(_vm.currentHr, "email", $$v)},expression:"currentHr.email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-select',{attrs:{"dense":"","prepend-icon":"policy","items":_vm.firmsByBrand,"label":"Select Firm","item-text":"text","item-value":"value"},model:{value:(_vm.currentHr.firm),callback:function ($$v) {_vm.$set(_vm.currentHr, "firm", $$v)},expression:"currentHr.firm"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm5":"","md5":""}},[_c('v-text-field',{attrs:{"prepend-icon":"info","type":"text","label":"Staff Description"},model:{value:(_vm.currentHr.description),callback:function ($$v) {_vm.$set(_vm.currentHr, "description", $$v)},expression:"currentHr.description"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker),callback:function ($$v) {_vm.datepicker=$$v},expression:"datepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date of Birth ","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.currentHr.dateOfBirth),callback:function ($$v) {_vm.$set(_vm.currentHr, "dateOfBirth", $$v)},expression:"currentHr.dateOfBirth"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepicker = false}},model:{value:(_vm.currentHr.dateOfBirth),callback:function ($$v) {_vm.$set(_vm.currentHr, "dateOfBirth", $$v)},expression:"currentHr.dateOfBirth"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-textarea',{staticClass:"address",attrs:{"background-color":"grey lighten-1","color":"black","box":"","name":"input-7-1","prepend-icon":"store","type":"text","label":"Current Address"},model:{value:(_vm.currentHr.currentAddressDescription),callback:function ($$v) {_vm.$set(_vm.currentHr, "currentAddressDescription", $$v)},expression:"currentHr.currentAddressDescription"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-textarea',{attrs:{"background-color":"grey darken-1","color":"black","box":"","name":"input-7-1","prepend-icon":"store","type":"text","label":"Permanent Address"},model:{value:(_vm.currentHr.currentPermanentDescription),callback:function ($$v) {_vm.$set(_vm.currentHr, "currentPermanentDescription", $$v)},expression:"currentHr.currentPermanentDescription"}})],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.stepper = 2}}},[_vm._v("Next")])],1)],1)],1),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.stepper > 2,"step":"2"}},[_vm._v("Step 2 : Enter your Bank Details")]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-card',{staticClass:"mb-12",staticStyle:{"height":"100%"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-select',{attrs:{"dense":"","items":[
                        {
                          text: 'Yes',
                          value: true
                        },
                        {
                          text: 'No',
                          value: false
                        } ],"label":"Enter Bank Details?"},model:{value:(_vm.isBankDetails),callback:function ($$v) {_vm.isBankDetails=$$v},expression:"isBankDetails"}})],1)],1),_vm._v(" "),(_vm.isBankDetails)?_c('v-layout',{attrs:{"wrap":""}},[(_vm.isBankDetails)?_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"item-text":"name","item-value":"id","items":_vm.currentBankName,"label":"Choose Bank"},model:{value:(_vm.currentHr.bankName),callback:function ($$v) {_vm.$set(_vm.currentHr, "bankName", $$v)},expression:"currentHr.bankName"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"item-text":"name","item-value":"id","items":_vm.currentAccountType,"label":"Choose Account Type"},model:{value:(_vm.currentHr.accountType),callback:function ($$v) {_vm.$set(_vm.currentHr, "accountType", $$v)},expression:"currentHr.accountType"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Account Holder Name","disabled":_vm.accholderdisabled},model:{value:(_vm.currentHr.accountHolderName),callback:function ($$v) {_vm.$set(_vm.currentHr, "accountHolderName", $$v)},expression:"currentHr.accountHolderName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Account Number"},model:{value:(_vm.currentHr.accountNumber),callback:function ($$v) {_vm.$set(_vm.currentHr, "accountNumber", $$v)},expression:"currentHr.accountNumber"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"IFSC code","rules":_vm.IFSC_Rules},on:{"change":function($event){return _vm.getBankDetailsFromIFSC(false)}},model:{value:(_vm.ifsccode),callback:function ($$v) {_vm.ifsccode=$$v},expression:"ifsccode"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-textarea',{attrs:{"background-color":"grey darken-1","color":"black","label":"Location","box":""},model:{value:(_vm.accountLocation),callback:function ($$v) {_vm.accountLocation=$$v},expression:"accountLocation"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('v-card-text',[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.stepper = 3}}},[_vm._v("Next")]),_vm._v(" "),_c('v-btn',{attrs:{"text":""},on:{"click":function($event){_vm.stepper = 1}}},[_vm._v("Back")])],1)],1)],1),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.stepper > 3,"step":"3"}},[_vm._v("Step 3 : Enter your Professional Details")]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"3"}},[_c('v-card',{staticClass:"mb-12",staticStyle:{"height":"100%"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-select',{attrs:{"dense":"","items":[
                        {
                          text: 'Yes',
                          value: true
                        },
                        {
                          text: 'No',
                          value: false
                        } ],"label":"Enter Professional Details?"},model:{value:(_vm.isProfessionalDetails),callback:function ($$v) {_vm.isProfessionalDetails=$$v},expression:"isProfessionalDetails"}})],1)],1),_vm._v(" "),(_vm.isProfessionalDetails)?_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.Designations,"label":"Select Role"},model:{value:(_vm.currentHr.Designation),callback:function ($$v) {_vm.$set(_vm.currentHr, "Designation", $$v)},expression:"currentHr.Designation"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[(_vm.currentHr.Designation === 'Teacher')?_c('v-select',{attrs:{"type":"number","dense":"","items":['PPRT','PRT','TGT','PGT'],"disabled":_vm.currentHr.Designation != 'Teacher',"label":"Teacher Classification"},model:{value:(_vm.currentHr.staffDesignationCategory),callback:function ($$v) {_vm.$set(_vm.currentHr, "staffDesignationCategory", $$v)},expression:"currentHr.staffDesignationCategory"}}):_vm._e()],1),_vm._v(" "),(_vm.isProfessionalDetails)?_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"EPF Number"},model:{value:(_vm.epfnumber),callback:function ($$v) {_vm.epfnumber=$$v},expression:"epfnumber"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"item-text":"name","item-value":"id","items":_vm.currentContractType,"label":"Choose Contract Type"},model:{value:(_vm.contractType),callback:function ($$v) {_vm.contractType=$$v},expression:"contractType"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"item-text":"name","item-value":"id","items":_vm.currentWorkShift,"label":"Choose WorkshiftType"},model:{value:(_vm.workShift),callback:function ($$v) {_vm.workShift=$$v},expression:"workShift"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{ref:"age",attrs:{"type":"number","rules":_vm.workExperience.rules,"label":"Work Experience(in Years)","maxlength":"3"},model:{value:(_vm.workExperience.value),callback:function ($$v) {_vm.$set(_vm.workExperience, "value", $$v)},expression:"workExperience.value"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Staff ID"},model:{value:(_vm.currentHr.StaffId),callback:function ($$v) {_vm.$set(_vm.currentHr, "StaffId", $$v)},expression:"currentHr.StaffId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker1),callback:function ($$v) {_vm.datepicker1=$$v},expression:"datepicker1"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date of Joining ","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.currentHr.dateOfJoining),callback:function ($$v) {_vm.$set(_vm.currentHr, "dateOfJoining", $$v)},expression:"currentHr.dateOfJoining"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepicker1= false}},model:{value:(_vm.currentHr.dateOfJoining),callback:function ($$v) {_vm.$set(_vm.currentHr, "dateOfJoining", $$v)},expression:"currentHr.dateOfJoining"}})],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-card-text',[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.stepper = 4}}},[_vm._v("Next")]),_vm._v(" "),_c('v-btn',{attrs:{"text":""},on:{"click":function($event){_vm.stepper = 2}}},[_vm._v("Back")])],1)],1)],1),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.stepper > 4,"step":"4"}},[_vm._v("Step 4 : Enter your Salary Details")]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"4"}},[_c('v-card',{staticClass:"mb-12",staticStyle:{"height":"100%"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-select',{attrs:{"dense":"","items":[
                        {
                          text: 'Yes',
                          value: true
                        },
                        {
                          text: 'No',
                          value: false
                        } ],"label":"Enter Salary Details?"},model:{value:(_vm.isSalaryDetails),callback:function ($$v) {_vm.isSalaryDetails=$$v},expression:"isSalaryDetails"}})],1)],1),_vm._v(" "),(_vm.isSalaryDetails)?_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Basic Salary"},model:{value:(_vm.currentHr.basicSalary),callback:function ($$v) {_vm.$set(_vm.currentHr, "basicSalary", $$v)},expression:"currentHr.basicSalary"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"HRA(House Rent Allowance)"},model:{value:(_vm.currentHr.hra),callback:function ($$v) {_vm.$set(_vm.currentHr, "hra", $$v)},expression:"currentHr.hra"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Genreal Conveyance"},model:{value:(_vm.currentHr.generalConveyance),callback:function ($$v) {_vm.$set(_vm.currentHr, "generalConveyance", $$v)},expression:"currentHr.generalConveyance"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Medical Conveyance"},model:{value:(_vm.currentHr.medicalConveyance),callback:function ($$v) {_vm.$set(_vm.currentHr, "medicalConveyance", $$v)},expression:"currentHr.medicalConveyance"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Special Conveyance"},model:{value:(_vm.currentHr.specialConveyance),callback:function ($$v) {_vm.$set(_vm.currentHr, "specialConveyance", $$v)},expression:"currentHr.specialConveyance"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Casual Leave"},model:{value:(_vm.currentHr.casualLeave),callback:function ($$v) {_vm.$set(_vm.currentHr, "casualLeave", $$v)},expression:"currentHr.casualLeave"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"EPF Amount"},model:{value:(_vm.currentHr.epfAmount),callback:function ($$v) {_vm.$set(_vm.currentHr, "epfAmount", $$v)},expression:"currentHr.epfAmount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"ESI[Employee State Tax]"},model:{value:(_vm.currentHr.esiAmount),callback:function ($$v) {_vm.$set(_vm.currentHr, "esiAmount", $$v)},expression:"currentHr.esiAmount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"TDS[Tax Deduction at Source]"},model:{value:(_vm.currentHr.tdsAmount),callback:function ($$v) {_vm.$set(_vm.currentHr, "tdsAmount", $$v)},expression:"currentHr.tdsAmount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Professional Tax"},model:{value:(_vm.currentHr.professionalTaxAmount),callback:function ($$v) {_vm.$set(_vm.currentHr, "professionalTaxAmount", $$v)},expression:"currentHr.professionalTaxAmount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Net Salary"},model:{value:(_vm.currentHr.netSalary),callback:function ($$v) {_vm.$set(_vm.currentHr, "netSalary", $$v)},expression:"currentHr.netSalary"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('v-card-text',[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.stepper = 5}}},[_vm._v("Next")]),_vm._v(" "),_c('v-btn',{attrs:{"text":""},on:{"click":function($event){_vm.stepper = 3}}},[_vm._v("Back")])],1)],1)],1),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.stepper > 5,"step":"5"}},[_vm._v("Step 5 Do you want to Upload Documents ")]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"5"}},[_c('v-card',{staticClass:"mb-12",staticStyle:{"height":"100%"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-select',{attrs:{"dense":"","items":[
                        {
                          text: 'Yes',
                          value: true
                        },
                        {
                          text: 'No',
                          value: false
                        } ],"label":"Do you want to add Documents like Resume,CV,Certificates,Letters,etc?"},model:{value:(_vm.isDocumentAvailable),callback:function ($$v) {_vm.isDocumentAvailable=$$v},expression:"isDocumentAvailable"}})],1),_vm._v(" "),(_vm.isDocumentAvailable)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-select',{attrs:{"dense":"","disabled":true,"items":_vm.units,"label":"Select unit","value":this.currentHr.unitsDeatilsAdded ? this.getLastUnit : this.currentHr.unit}})],1):_vm._e(),_vm._v(" "),(_vm.isDocumentAvailable)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-select',{attrs:{"dense":"","items":['PGT','TGT','UGT'],"disabled":true,"label":"Teacher Classification"},model:{value:(_vm.currentHr.staffDesignationCategory),callback:function ($$v) {_vm.$set(_vm.currentHr, "staffDesignationCategory", $$v)},expression:"currentHr.staffDesignationCategory"}})],1):_vm._e()],1),_vm._v(" "),(_vm.isDocumentAvailable)?_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Purchasing Price [Excluding GST]"},model:{value:(_vm.currentHr.purchasingPrice),callback:function ($$v) {_vm.$set(_vm.currentHr, "purchasingPrice", $$v)},expression:"currentHr.purchasingPrice"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","disabled":true,"value":_vm.currentHr.staffDesignationCategory ? (Number.parseFloat((_vm.currentHr.purchasingPrice * _vm.currentHr.staffDesignationCategory)/100) + Number.parseFloat(_vm.currentHr.purchasingPrice)).toFixed(2) : _vm.currentHr.purchasingPrice,"label":"Purchasing Price [Including GST]"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Selling Price [Excluding GST]"},model:{value:(_vm.currentHr.sellingPrice),callback:function ($$v) {_vm.$set(_vm.currentHr, "sellingPrice", $$v)},expression:"currentHr.sellingPrice"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","disabled":true,"value":_vm.currentHr.staffDesignationCategory ? (Number.parseFloat((_vm.currentHr.sellingPrice * _vm.currentHr.staffDesignationCategory)/100) + Number.parseFloat(_vm.currentHr.sellingPrice)).toFixed(2) : _vm.currentHr.sellingPrice,"label":"Selling Price [Including GST]"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('v-card-text',[(!_vm.currentHr['.key'])?_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.saveHr}},[_vm._v("Save")]):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"text":""},on:{"click":function($event){_vm.stepper = 4}}},[_vm._v("Back")]),_vm._v(" "),(!!_vm.currentHr['.key'])?_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.updateHr}},[_vm._v("Update")]):_vm._e()],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.timeout,"top":"","color":"primary"},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    Thank You so Much \n    "),_vm._v("\n      To make you serve Better.\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LetterHead_vue__ = __webpack_require__(525);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3c3c596_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LetterHead_vue__ = __webpack_require__(1576);
function injectStyle (ssrContext) {
  __webpack_require__(1574)
  __webpack_require__(1575)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c3c3c596"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LetterHead_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3c3c596_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LetterHead_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1574 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1575 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-cotainer',{attrs:{"fluid":"","grid-list-md":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"text-xs-center"},[_vm._v("\n            Letter Head\n          ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"outlined":""},on:{"click":function($event){_vm.letterHeadDialog = true}}},[_c('v-icon',{attrs:{"left":"","color":"teal"}},[_vm._v("add")]),_vm._v(" New Letter Head\n          ")],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.letterHeadHeader,"items":_vm.letterHeadsByBrand,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('v-icon',{attrs:{"disabled":_vm.getCustomerName(props.item.buyerId) == 'DELETED CUSTOMER',"color":"primary"},on:{"click":function($event){return _vm.openProd(props.item)}}},[_vm._v("remove_red_eye")])],1),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['letterHeadNumber']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(new Date(props.item.date).toLocaleDateString('en-GB')))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.getCustomerName(props.item.buyerId)))])]),_vm._v(" "),_c('td',[(props.item['status'] == 'IN PROGRESS')?_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editLetterHead(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("edit")])],1):_vm._e()],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteLetterHead(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.printLetterHead(props.item)}}},[_c('v-icon',{attrs:{"color":"blue"}},[_vm._v("print")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"1000px"},model:{value:(_vm.letterHeadDialog),callback:function ($$v) {_vm.letterHeadDialog=$$v},expression:"letterHeadDialog"}},[_c('v-card',{attrs:{"persistent":""}},[_c('v-card-title',{staticClass:"primary white--text"},[(_vm.isEdit)?_c('span',{staticClass:"headline"},[_vm._v("Edit LetterHead")]):_c('span',{staticClass:"headline"},[_vm._v("Create LetterHead")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-switch',{attrs:{"disabled":_vm.isEdit,"label":("" + (_vm.isBuyer ? 'Customer Letter Head' : 'Supplier Letter Head'))},model:{value:(_vm.isBuyer),callback:function ($$v) {_vm.isBuyer=$$v},expression:"isBuyer"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-select',{attrs:{"items":_vm.isBuyer ? _vm.buyersByBrand : _vm.sellersByBrand,"label":_vm.isBuyer ? 'Select or add Buyer' : 'Select or add Seller',"autocomplete":"","disabled":_vm.isEdit,"item-text":"name","return-object":""},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.addCustomer($event)}},model:{value:(_vm.selectedBuyer),callback:function ($$v) {_vm.selectedBuyer=$$v},expression:"selectedBuyer"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerLetterHead),callback:function ($$v) {_vm.datepickerLetterHead=$$v},expression:"datepickerLetterHead"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Letter Head Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerLetterHead = false}},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-text-field',{attrs:{"prefix":"#","label":"Letter Head Number","placeholder":"Enter Letter Head Number","required":""},model:{value:(_vm.letterHeadNumber),callback:function ($$v) {_vm.letterHeadNumber=$$v},expression:"letterHeadNumber"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-textarea',{attrs:{"background-color":"grey darken-1","color":"black","label":"Content","box":""},model:{value:(_vm.letterHeadContent),callback:function ($$v) {_vm.letterHeadContent=$$v},expression:"letterHeadContent"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){_vm.letterHeadDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","disabled":!_vm.selectedBuyer || !_vm.selectedFirm,"flat":""},on:{"click":function($event){return _vm.addLetterHead()}}},[_vm._v(_vm._s(_vm.isEdit ? 'Save' : 'Create'))])],1)],1)],1),_vm._v(" "),(_vm.selectedLetterHead && _vm.selectedLetterHead['.key'])?_c('v-dialog',{attrs:{"width":"800"},model:{value:(_vm.invoiceLetterHead),callback:function ($$v) {_vm.invoiceLetterHead=$$v},expression:"invoiceLetterHead"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline grey lighten-2",attrs:{"primary-title":""}},[_vm._v("Letter Head Content \n        ")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-title',[_vm._v("  \n          "+_vm._s(_vm.selectedLetterHead['letterHeadContent'])+"\n        ")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.invoiceLetterHead = false}}},[_vm._v("Confirm")])],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_vue__ = __webpack_require__(526);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ffe3af6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_vue__ = __webpack_require__(1580);
function injectStyle (ssrContext) {
  __webpack_require__(1578)
  __webpack_require__(1579)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ffe3af6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_todo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ffe3af6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_todo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1578 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1579 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-cotainer',{attrs:{"fluid":"","grid-list-md":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"text-xs-center"},[_vm._v("\n            To Do List\n          ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"outlined":""},on:{"click":function($event){_vm.todoDialog = true}}},[_c('v-icon',{attrs:{"left":"","color":"teal"}},[_vm._v("add")]),_vm._v(" New To Do List\n          ")],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.todoHeader,"items":_vm.todosByBrand,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',[_vm._v(_vm._s(new Date(props.item.date).toLocaleDateString('en-GB')))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['todoNumber']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['todoContent']))])]),_vm._v(" "),_c('td',[(props.item['status'] == 'IN PROGRESS')?_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editTodo(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("edit")])],1):_vm._e()],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteTodo(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"1000px"},model:{value:(_vm.todoDialog),callback:function ($$v) {_vm.todoDialog=$$v},expression:"todoDialog"}},[_c('v-card',{attrs:{"persistent":""}},[_c('v-card-title',{staticClass:"primary white--text"},[(_vm.isEdit)?_c('span',{staticClass:"headline"},[_vm._v("Edit Todo List")]):_c('span',{staticClass:"headline"},[_vm._v("Create Todo List")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerTodo),callback:function ($$v) {_vm.datepickerTodo=$$v},expression:"datepickerTodo"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"To Do List Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerTodo = false}},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-text-field',{attrs:{"prefix":"#","label":"Purpose","placeholder":"Enter Purpose","required":""},model:{value:(_vm.todoNumber),callback:function ($$v) {_vm.todoNumber=$$v},expression:"todoNumber"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-textarea',{attrs:{"background-color":"grey darken-1","color":"black","label":"Enter Content To Remember","box":""},model:{value:(_vm.todoContent),callback:function ($$v) {_vm.todoContent=$$v},expression:"todoContent"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){_vm.todoDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){return _vm.addTodo()}}},[_vm._v(_vm._s(_vm.isEdit ? 'Save' : 'Create'))])],1)],1)],1),_vm._v(" "),(_vm.selectedTodo && _vm.selectedTodo['.key'])?_c('v-dialog',{attrs:{"width":"800"},model:{value:(_vm.invoiceTodo),callback:function ($$v) {_vm.invoiceTodo=$$v},expression:"invoiceTodo"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline grey lighten-2",attrs:{"primary-title":""}},[_vm._v("To Do List Content \n        ")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-title',[_vm._v("  \n          "+_vm._s(_vm.selectedTodo['todoContent'])+"\n        ")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.invoiceTodo = false}}},[_vm._v("Confirm")])],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_payroll_vue__ = __webpack_require__(527);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_663589cf_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_payroll_vue__ = __webpack_require__(1583);
function injectStyle (ssrContext) {
  __webpack_require__(1582)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_payroll_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_663589cf_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_payroll_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1582 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-cotainer',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"headline text-xs-center"},[_vm._v("\n          Payroll Report\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"prepend-inner-icon":"search","solo":"","outlined":"","clearable":"","label":"Search Staff"},nativeOn:{"keyup":function($event){return _vm.keymonitor($event)}}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{staticClass:"white--text",attrs:{"outline":"","disabled":!_vm.hasHrAddPermission},on:{"click":_vm.addHr}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("add")]),_vm._v("\n              New Staff \n          ")],1)],1)],1),_vm._v(" "),_c('v-toolbar',{staticStyle:{"margin-top":"8px"}},[_c('v-flex',{staticStyle:{"margin-left":"-10px"},attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.items1,"label":"Search Role","outline":""}})],1),_vm._v(" "),_c('v-flex',{staticStyle:{"margin-left":"10px"},attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.items2,"label":"Search Month","outline":""}})],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.hrListHeader,"items":_vm.hrListByBrand,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',[_vm._v(_vm._s(props.item['.key']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['name']))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b',{staticClass:"font-weight-light"},[_vm._v(_vm._s(props.item['description']))]),_vm._v(" \n              -\n            "),_c('b',{staticClass:"font-weight-light"},[_vm._v(_vm._s(props.item['gender']))]),_vm._v("\n              -\n            "),_c('b',{staticClass:"font-weight-light"},[_vm._v(_vm._s(props.item['marital']))]),_vm._v("\n              -\n            "),_c('b',{staticClass:"font-weight-light"},[_vm._v(_vm._s(props.item.staffDesignationCategory))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['Designation']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.staffDesignationCategory))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['age'])+" - "+_vm._s(props.item['Gender']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"info--text font-weight-bold"},[_vm._v(_vm._s(props.item['basicSalary'])+" ")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"primary--text font-weight-bold"},[_vm._v(_vm._s(props.item['netSalary']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['epfAmount']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['esiAmount']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['tdsAmount']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['casualLeave']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['hra']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['generalConveyance']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['medicalConveyance']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['specialConveyance']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['bankName']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['accountHolderName']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['accountType']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['accountNumber']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['accountLocation']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['ifsccode']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['email']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text font-weight-bold"},[_vm._v(_vm._s(props.item['mobile']))])]),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"disabled":!_vm.hasHrTransferPermission,"icon":""},on:{"click":function($event){return _vm.openTansferDialog(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("double_arrow")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"disabled":!_vm.hasHrEditPermission,"icon":""},on:{"click":function($event){return _vm.editHr(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"disabled":!_vm.hasHrDeletePermission,"icon":""},on:{"click":function($event){return _vm.deleteHr(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.openDamageDialog(props.item)}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("warning")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","fullscreen":"","hide-overlay":""},model:{value:(_vm.addHrDialog),callback:function ($$v) {_vm.addHrDialog=$$v},expression:"addHrDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Staff Details")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.addHrDialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-stepper',{attrs:{"vertical":""},model:{value:(_vm.stepper),callback:function ($$v) {_vm.stepper=$$v},expression:"stepper"}},[_c('v-stepper-step',{attrs:{"complete":_vm.stepper > 1,"step":"1"}},[_vm._v("Step 1: Enter Personal Information "),_c('h3',{staticClass:"error--text text--darken-4"},[_vm._v(_vm._s(_vm.duplicateError))])]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"1"}},[_c('v-card',{staticClass:"mb-12",staticStyle:{"height":"100%"}},[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-combobox',{attrs:{"prepend-icon":"account_box","items":_vm.hrListByBrand,"return-object":false,"item-text":"name","item-value":"name","label":"Staff Name","placeholder":"Enter Staff Name"},on:{"change":function($event){return _vm.duplicateCheck()}},model:{value:(_vm.currentHr.name),callback:function ($$v) {_vm.$set(_vm.currentHr, "name", $$v)},expression:"currentHr.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-text-field',{ref:"age",attrs:{"prepend-icon":"font_download","type":"number","rules":_vm.age.rules,"label":"Age","maxlength":"3"},model:{value:(_vm.currentHr.age),callback:function ($$v) {_vm.$set(_vm.currentHr, "age", $$v)},expression:"currentHr.age"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-select',{attrs:{"prepend-icon":"wc","items":_vm.gGender,"label":"Gender"},model:{value:(_vm.currentHr.gender),callback:function ($$v) {_vm.$set(_vm.currentHr, "gender", $$v)},expression:"currentHr.gender"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-select',{attrs:{"prepend-icon":"nature_people","items":_vm.gMarital,"label":"Marital Status"},model:{value:(_vm.currentHr.marital),callback:function ($$v) {_vm.$set(_vm.currentHr, "marital", $$v)},expression:"currentHr.marital"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-select',{attrs:{"prepend-icon":"perm_identity","items":_vm.gIdentityType,"clearable":"","label":"Identity Type"},model:{value:(_vm.identityType.value),callback:function ($$v) {_vm.$set(_vm.identityType, "value", $$v)},expression:"identityType.value"}})],1),_vm._v(" "),(_vm.identityType.value)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{ref:"identityNumber",attrs:{"prepend-icon":"picture_in_picture","error-messages":_vm.identityNumeberError,"rules":_vm.identityNumber.rules,"label":"Identity Number"},model:{value:(_vm.identityNumber.value),callback:function ($$v) {_vm.$set(_vm.identityNumber, "value", $$v)},expression:"identityNumber.value"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{ref:"mobile",attrs:{"prepend-icon":"phone","type":"number","rules":_vm.mobile.rules,"label":"Mobile"},model:{value:(_vm.currentHr.mobile),callback:function ($$v) {_vm.$set(_vm.currentHr, "mobile", $$v)},expression:"currentHr.mobile"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{ref:"email",attrs:{"prepend-icon":"email","type":"email","rules":_vm.email.rules,"label":"Email"},model:{value:(_vm.currentHr.email),callback:function ($$v) {_vm.$set(_vm.currentHr, "email", $$v)},expression:"currentHr.email"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-select',{attrs:{"dense":"","prepend-icon":"policy","items":_vm.firmsByBrand,"label":"Select Firm","item-text":"text","item-value":"value"},model:{value:(_vm.currentHr.firm),callback:function ($$v) {_vm.$set(_vm.currentHr, "firm", $$v)},expression:"currentHr.firm"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm5":"","md5":""}},[_c('v-text-field',{attrs:{"prepend-icon":"info","type":"text","label":"Staff Description"},model:{value:(_vm.currentHr.description),callback:function ($$v) {_vm.$set(_vm.currentHr, "description", $$v)},expression:"currentHr.description"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker),callback:function ($$v) {_vm.datepicker=$$v},expression:"datepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date of Birth ","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.currentHr.dateOfBirth),callback:function ($$v) {_vm.$set(_vm.currentHr, "dateOfBirth", $$v)},expression:"currentHr.dateOfBirth"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepicker = false}},model:{value:(_vm.currentHr.dateOfBirth),callback:function ($$v) {_vm.$set(_vm.currentHr, "dateOfBirth", $$v)},expression:"currentHr.dateOfBirth"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-textarea',{staticClass:"address",attrs:{"background-color":"grey lighten-1","color":"black","box":"","name":"input-7-1","prepend-icon":"store","type":"text","label":"Current Address"},model:{value:(_vm.currentHr.currentAddressDescription),callback:function ($$v) {_vm.$set(_vm.currentHr, "currentAddressDescription", $$v)},expression:"currentHr.currentAddressDescription"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-textarea',{attrs:{"background-color":"grey darken-1","color":"black","box":"","name":"input-7-1","prepend-icon":"store","type":"text","label":"Permanent Address"},model:{value:(_vm.currentHr.currentPermanentDescription),callback:function ($$v) {_vm.$set(_vm.currentHr, "currentPermanentDescription", $$v)},expression:"currentHr.currentPermanentDescription"}})],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.stepper = 2}}},[_vm._v("Next")])],1)],1)],1),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.stepper > 2,"step":"2"}},[_vm._v("Step 2 : Enter your Bank Details")]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"2"}},[_c('v-card',{staticClass:"mb-12",staticStyle:{"height":"100%"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-select',{attrs:{"dense":"","items":[
                        {
                          text: 'Yes',
                          value: true
                        },
                        {
                          text: 'No',
                          value: false
                        } ],"label":"Enter Bank Details?"},model:{value:(_vm.isBankDetails),callback:function ($$v) {_vm.isBankDetails=$$v},expression:"isBankDetails"}})],1)],1),_vm._v(" "),(_vm.isBankDetails)?_c('v-layout',{attrs:{"wrap":""}},[(_vm.isBankDetails)?_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"item-text":"name","item-value":"id","items":_vm.currentBankName,"label":"Choose Bank"},model:{value:(_vm.currentHr.bankName),callback:function ($$v) {_vm.$set(_vm.currentHr, "bankName", $$v)},expression:"currentHr.bankName"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"item-text":"name","item-value":"id","items":_vm.currentAccountType,"label":"Choose Account Type"},model:{value:(_vm.currentHr.accountType),callback:function ($$v) {_vm.$set(_vm.currentHr, "accountType", $$v)},expression:"currentHr.accountType"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Account Holder Name","disabled":_vm.accholderdisabled},model:{value:(_vm.currentHr.accountHolderName),callback:function ($$v) {_vm.$set(_vm.currentHr, "accountHolderName", $$v)},expression:"currentHr.accountHolderName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Account Number"},model:{value:(_vm.currentHr.accountNumber),callback:function ($$v) {_vm.$set(_vm.currentHr, "accountNumber", $$v)},expression:"currentHr.accountNumber"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"IFSC code","rules":_vm.IFSC_Rules},on:{"change":function($event){return _vm.getBankDetailsFromIFSC(false)}},model:{value:(_vm.ifsccode),callback:function ($$v) {_vm.ifsccode=$$v},expression:"ifsccode"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-textarea',{attrs:{"background-color":"grey darken-1","color":"black","label":"Location","box":""},model:{value:(_vm.accountLocation),callback:function ($$v) {_vm.accountLocation=$$v},expression:"accountLocation"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('v-card-text',[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.stepper = 3}}},[_vm._v("Next")]),_vm._v(" "),_c('v-btn',{attrs:{"text":""},on:{"click":function($event){_vm.stepper = 1}}},[_vm._v("Back")])],1)],1)],1),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.stepper > 3,"step":"3"}},[_vm._v("Step 3 : Enter your Professional Details")]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"3"}},[_c('v-card',{staticClass:"mb-12",staticStyle:{"height":"100%"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-select',{attrs:{"dense":"","items":[
                        {
                          text: 'Yes',
                          value: true
                        },
                        {
                          text: 'No',
                          value: false
                        } ],"label":"Enter Professional Details?"},model:{value:(_vm.isProfessionalDetails),callback:function ($$v) {_vm.isProfessionalDetails=$$v},expression:"isProfessionalDetails"}})],1)],1),_vm._v(" "),(_vm.isProfessionalDetails)?_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.Designations,"label":"Select Role"},model:{value:(_vm.currentHr.Designation),callback:function ($$v) {_vm.$set(_vm.currentHr, "Designation", $$v)},expression:"currentHr.Designation"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[(_vm.currentHr.Designation === 'Teacher')?_c('v-select',{attrs:{"type":"number","dense":"","items":['PPRT','PRT','TGT','PGT'],"disabled":_vm.currentHr.Designation != 'Teacher',"label":"Teacher Classification"},model:{value:(_vm.currentHr.staffDesignationCategory),callback:function ($$v) {_vm.$set(_vm.currentHr, "staffDesignationCategory", $$v)},expression:"currentHr.staffDesignationCategory"}}):_vm._e()],1),_vm._v(" "),(_vm.isProfessionalDetails)?_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"EPF Number"},model:{value:(_vm.epfnumber),callback:function ($$v) {_vm.epfnumber=$$v},expression:"epfnumber"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"item-text":"name","item-value":"id","items":_vm.currentContractType,"label":"Choose Contract Type"},model:{value:(_vm.contractType),callback:function ($$v) {_vm.contractType=$$v},expression:"contractType"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"item-text":"name","item-value":"id","items":_vm.currentWorkShift,"label":"Choose WorkshiftType"},model:{value:(_vm.workShift),callback:function ($$v) {_vm.workShift=$$v},expression:"workShift"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{ref:"age",attrs:{"type":"number","rules":_vm.workExperience.rules,"label":"Work Experience(in Years)","maxlength":"3"},model:{value:(_vm.workExperience.value),callback:function ($$v) {_vm.$set(_vm.workExperience, "value", $$v)},expression:"workExperience.value"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Staff ID"},model:{value:(_vm.currentHr.StaffId),callback:function ($$v) {_vm.$set(_vm.currentHr, "StaffId", $$v)},expression:"currentHr.StaffId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker1),callback:function ($$v) {_vm.datepicker1=$$v},expression:"datepicker1"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date of Joining ","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.currentHr.dateOfJoining),callback:function ($$v) {_vm.$set(_vm.currentHr, "dateOfJoining", $$v)},expression:"currentHr.dateOfJoining"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepicker1= false}},model:{value:(_vm.currentHr.dateOfJoining),callback:function ($$v) {_vm.$set(_vm.currentHr, "dateOfJoining", $$v)},expression:"currentHr.dateOfJoining"}})],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-card-text',[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.stepper = 4}}},[_vm._v("Next")]),_vm._v(" "),_c('v-btn',{attrs:{"text":""},on:{"click":function($event){_vm.stepper = 2}}},[_vm._v("Back")])],1)],1)],1),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.stepper > 4,"step":"4"}},[_vm._v("Step 4 : Enter your Salary Details")]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"4"}},[_c('v-card',{staticClass:"mb-12",staticStyle:{"height":"100%"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-select',{attrs:{"dense":"","items":[
                        {
                          text: 'Yes',
                          value: true
                        },
                        {
                          text: 'No',
                          value: false
                        } ],"label":"Enter Salary Details?"},model:{value:(_vm.isSalaryDetails),callback:function ($$v) {_vm.isSalaryDetails=$$v},expression:"isSalaryDetails"}})],1)],1),_vm._v(" "),(_vm.isSalaryDetails)?_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Basic Salary"},model:{value:(_vm.currentHr.basicSalary),callback:function ($$v) {_vm.$set(_vm.currentHr, "basicSalary", $$v)},expression:"currentHr.basicSalary"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"HRA(House Rent Allowance)"},model:{value:(_vm.currentHr.hra),callback:function ($$v) {_vm.$set(_vm.currentHr, "hra", $$v)},expression:"currentHr.hra"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Genreal Conveyance"},model:{value:(_vm.currentHr.generalConveyance),callback:function ($$v) {_vm.$set(_vm.currentHr, "generalConveyance", $$v)},expression:"currentHr.generalConveyance"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Medical Conveyance"},model:{value:(_vm.currentHr.medicalConveyance),callback:function ($$v) {_vm.$set(_vm.currentHr, "medicalConveyance", $$v)},expression:"currentHr.medicalConveyance"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Special Conveyance"},model:{value:(_vm.currentHr.specialConveyance),callback:function ($$v) {_vm.$set(_vm.currentHr, "specialConveyance", $$v)},expression:"currentHr.specialConveyance"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Casual Leave"},model:{value:(_vm.currentHr.casualLeave),callback:function ($$v) {_vm.$set(_vm.currentHr, "casualLeave", $$v)},expression:"currentHr.casualLeave"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"EPF Amount"},model:{value:(_vm.currentHr.epfAmount),callback:function ($$v) {_vm.$set(_vm.currentHr, "epfAmount", $$v)},expression:"currentHr.epfAmount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"ESI[Employee State Tax]"},model:{value:(_vm.currentHr.esiAmount),callback:function ($$v) {_vm.$set(_vm.currentHr, "esiAmount", $$v)},expression:"currentHr.esiAmount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"TDS[Tax Deduction at Source]"},model:{value:(_vm.currentHr.tdsAmount),callback:function ($$v) {_vm.$set(_vm.currentHr, "tdsAmount", $$v)},expression:"currentHr.tdsAmount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Professional Tax"},model:{value:(_vm.currentHr.professionalTaxAmount),callback:function ($$v) {_vm.$set(_vm.currentHr, "professionalTaxAmount", $$v)},expression:"currentHr.professionalTaxAmount"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"label":"Net Salary"},model:{value:(_vm.currentHr.netSalary),callback:function ($$v) {_vm.$set(_vm.currentHr, "netSalary", $$v)},expression:"currentHr.netSalary"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('v-card-text',[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.stepper = 5}}},[_vm._v("Next")]),_vm._v(" "),_c('v-btn',{attrs:{"text":""},on:{"click":function($event){_vm.stepper = 3}}},[_vm._v("Back")])],1)],1)],1),_vm._v(" "),_c('v-stepper-step',{attrs:{"complete":_vm.stepper > 5,"step":"5"}},[_vm._v("Step 5 Do you want to Upload Documents ")]),_vm._v(" "),_c('v-stepper-content',{attrs:{"step":"5"}},[_c('v-card',{staticClass:"mb-12",staticStyle:{"height":"100%"}},[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-select',{attrs:{"dense":"","items":[
                        {
                          text: 'Yes',
                          value: true
                        },
                        {
                          text: 'No',
                          value: false
                        } ],"label":"Do you want to add Documents like Resume,CV,Certificates,Letters,etc?"},model:{value:(_vm.isDocumentAvailable),callback:function ($$v) {_vm.isDocumentAvailable=$$v},expression:"isDocumentAvailable"}})],1),_vm._v(" "),(_vm.isDocumentAvailable)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-select',{attrs:{"dense":"","disabled":true,"items":_vm.units,"label":"Select unit","value":this.currentHr.unitsDeatilsAdded ? this.getLastUnit : this.currentHr.unit}})],1):_vm._e(),_vm._v(" "),(_vm.isDocumentAvailable)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-select',{attrs:{"dense":"","items":['PGT','TGT','UGT'],"disabled":true,"label":"Teacher Classification"},model:{value:(_vm.currentHr.staffDesignationCategory),callback:function ($$v) {_vm.$set(_vm.currentHr, "staffDesignationCategory", $$v)},expression:"currentHr.staffDesignationCategory"}})],1):_vm._e()],1),_vm._v(" "),(_vm.isDocumentAvailable)?_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Purchasing Price [Excluding GST]"},model:{value:(_vm.currentHr.purchasingPrice),callback:function ($$v) {_vm.$set(_vm.currentHr, "purchasingPrice", $$v)},expression:"currentHr.purchasingPrice"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","disabled":true,"value":_vm.currentHr.staffDesignationCategory ? (Number.parseFloat((_vm.currentHr.purchasingPrice * _vm.currentHr.staffDesignationCategory)/100) + Number.parseFloat(_vm.currentHr.purchasingPrice)).toFixed(2) : _vm.currentHr.purchasingPrice,"label":"Purchasing Price [Including GST]"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Selling Price [Excluding GST]"},model:{value:(_vm.currentHr.sellingPrice),callback:function ($$v) {_vm.$set(_vm.currentHr, "sellingPrice", $$v)},expression:"currentHr.sellingPrice"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"number","disabled":true,"value":_vm.currentHr.staffDesignationCategory ? (Number.parseFloat((_vm.currentHr.sellingPrice * _vm.currentHr.staffDesignationCategory)/100) + Number.parseFloat(_vm.currentHr.sellingPrice)).toFixed(2) : _vm.currentHr.sellingPrice,"label":"Selling Price [Including GST]"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('v-card-text',[(!_vm.currentHr['.key'])?_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.saveHr}},[_vm._v("Save")]):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"text":""},on:{"click":function($event){_vm.stepper = 4}}},[_vm._v("Back")]),_vm._v(" "),(!!_vm.currentHr['.key'])?_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.updateHr}},[_vm._v("Update")]):_vm._e()],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.timeout,"top":"","color":"primary"},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    Thank You so Much \n    "),_vm._v("\n      To make you serve Better.\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(528);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11961914_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1585);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11961914_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","offset-sm":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"text-xs-center"},[_vm._v("Permission Access")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{attrs:{"outlined":""},on:{"click":function($event){_vm.dialog = true}}},[_c('v-icon',{attrs:{"left":"","color":"teal"}},[_vm._v("add")]),_vm._v("New User Account\n          ")],1)],1)],1),_vm._v(" "),_c('v-card',[_vm._l((_vm.getAdmins),function(item,index){return [_c('v-divider',{key:item['.key']}),_vm._v(" "),_c('v-card',{key:index},[_c('v-card-title',[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_vm._v("\n                    Email :-\n                    "),_c('b',[_vm._v(_vm._s(item.email))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-switch',{attrs:{"label":("Active: " + (item.isActive ? 'Granted' : 'Denied'))},on:{"change":function($event){return _vm.toggleUserActive(item)}},model:{value:(item.isActive),callback:function ($$v) {_vm.$set(item, "isActive", $$v)},expression:"item.isActive"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-btn',{staticClass:"primary white--text",attrs:{"round":"","large":"","primary-title":"","type":"submit"},on:{"click":function($event){return _vm.openPermissionDialog(item)}}},[_vm._v("\n                      Permissions & Settings\n                      "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("report_problem")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions')],1)]})],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"400"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","offset-sm":""}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text headline",attrs:{"primary-title":""}},[_vm._v("\n              Create User Account\n              "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("mdi-close")])],1)],1),_vm._v(" "),_c('form',[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"prepend-icon":"person","name":"email","label":"Email","id":"email","type":"email","rules":_vm.emailRules,"required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"prepend-icon":"lock","name":"password","label":"Password","id":"password","type":"password","rules":_vm.passwordRules,"required":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('v-text-field',{attrs:{"prepend-icon":"lock","name":"confirmPassword","label":"Confirm Password","id":"confirmPassword","type":"password","rules":_vm.passwordRules,"required":""},model:{value:(_vm.rePassword),callback:function ($$v) {_vm.rePassword=$$v},expression:"rePassword"}})],1)],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text",attrs:{"round":"","large":"","primary-title":"","type":"submit"},on:{"click":_vm.signUp}},[_vm._v("\n                Create Account\n                "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_done")])],1),_vm._v(" "),_c('v-spacer')],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"1200"},model:{value:(_vm.permissionDialog),callback:function ($$v) {_vm.permissionDialog=$$v},expression:"permissionDialog"}},[(_vm.currentUser)?_c('v-card',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","offset-sm":""}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text headline",attrs:{"primary-title":""}},[_vm._v("Access Permissions for "+_vm._s(_vm.currentUser.email)+" "+_vm._s(_vm.currentUser.superAdmin ? '(USER is Super Admin. You can`t change settings for super admin)' : '')+"\n              "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.permissionDialog = false}}},[_c('v-icon',[_vm._v("mdi-close")])],1)],1),_vm._v(" "),_c('form',[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-text-field',{ref:"zipCode",attrs:{"prepend-icon":"location_city","type":"number","label":"ZipCode"},on:{"change":function($event){return _vm.setLocationBasedOnZipCode()}},model:{value:(_vm.currentUser.zipCode),callback:function ($$v) {_vm.$set(_vm.currentUser, "zipCode", $$v)},expression:"currentUser.zipCode"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-text-field',{ref:"mobile",attrs:{"prepend-icon":"dialpad","type":"number","rules":_vm.mobileRules,"label":"Mobile"},model:{value:(_vm.currentUser.mobile),callback:function ($$v) {_vm.$set(_vm.currentUser, "mobile", $$v)},expression:"currentUser.mobile"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-select',{attrs:{"items":_vm.gCountry,"label":"Country"},model:{value:(_vm.currentUser.country),callback:function ($$v) {_vm.$set(_vm.currentUser, "country", $$v)},expression:"currentUser.country"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-select',{attrs:{"items":_vm.gState,"item-text":"state","label":"State"},model:{value:(_vm.currentUser.state),callback:function ($$v) {_vm.$set(_vm.currentUser, "state", $$v)},expression:"currentUser.state"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-select',{attrs:{"items":_vm.gDistrict,"label":"District"},model:{value:(_vm.currentUser.district),callback:function ($$v) {_vm.$set(_vm.currentUser, "district", $$v)},expression:"currentUser.district"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-select',{attrs:{"items":_vm.gTehsil,"label":"Tehsil"},model:{value:(_vm.currentUser.tehsil),callback:function ($$v) {_vm.$set(_vm.currentUser, "tehsil", $$v)},expression:"currentUser.tehsil"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-select',{attrs:{"items":_vm.gBlock,"label":"Block"},model:{value:(_vm.currentUser.block),callback:function ($$v) {_vm.$set(_vm.currentUser, "block", $$v)},expression:"currentUser.block"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-select',{attrs:{"items":_vm.gVillage,"label":"Village"},model:{value:(_vm.currentUser.village),callback:function ($$v) {_vm.$set(_vm.currentUser, "village", $$v)},expression:"currentUser.village"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-switch',{attrs:{"label":("Whatsapp Notifications: " + (_vm.currentUser.notificationWSAPP ? 'ON' : 'OFF'))},model:{value:(_vm.currentUser.notificationWSAPP),callback:function ($$v) {_vm.$set(_vm.currentUser, "notificationWSAPP", $$v)},expression:"currentUser.notificationWSAPP"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-radio-group',{attrs:{"disabled":_vm.currentUser.superAdmin},model:{value:(_vm.currentUser.role),callback:function ($$v) {_vm.$set(_vm.currentUser, "role", $$v)},expression:"currentUser.role"}},[_c('v-radio',{attrs:{"label":"Admin user","value":'admin'}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Staff user","value":'staff'}})],1),_vm._v(" "),(_vm.currentUser.role == 'admin')?_c('h3',{staticStyle:{"color":"#ff3b3b"}},[_vm._v("\n                      Admin User has all permissions\n                    ")]):_vm._e(),_vm._v(" "),_c('h2',[_vm._v("Permissions")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('h3',[_vm._v("Products Permissions")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-switch',{attrs:{"disabled":_vm.currentUser.role == 'admin',"label":("Product add: " + (_vm.permissionsObj.PRODUCT_ADD ? 'Granted' : 'Denied'))},model:{value:(_vm.permissionsObj.PRODUCT_ADD),callback:function ($$v) {_vm.$set(_vm.permissionsObj, "PRODUCT_ADD", $$v)},expression:"permissionsObj.PRODUCT_ADD"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-switch',{attrs:{"disabled":_vm.currentUser.role == 'admin',"label":("Product edit: " + (_vm.permissionsObj.PRODUCT_EDIT ? 'Granted' : 'Denied'))},model:{value:(_vm.permissionsObj.PRODUCT_EDIT),callback:function ($$v) {_vm.$set(_vm.permissionsObj, "PRODUCT_EDIT", $$v)},expression:"permissionsObj.PRODUCT_EDIT"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-switch',{attrs:{"disabled":_vm.currentUser.role == 'admin',"label":("Product delete: " + (_vm.permissionsObj.PRODUCT_DELETE ? 'Granted' : 'Denied'))},model:{value:(_vm.permissionsObj.PRODUCT_DELETE),callback:function ($$v) {_vm.$set(_vm.permissionsObj, "PRODUCT_DELETE", $$v)},expression:"permissionsObj.PRODUCT_DELETE"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-switch',{attrs:{"disabled":_vm.currentUser.role == 'admin',"label":("Product transfer: " + (_vm.permissionsObj.PRODUCT_TRANSFER ? 'Granted' : 'Denied'))},model:{value:(_vm.permissionsObj.PRODUCT_TRANSFER),callback:function ($$v) {_vm.$set(_vm.permissionsObj, "PRODUCT_TRANSFER", $$v)},expression:"permissionsObj.PRODUCT_TRANSFER"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('h3',[_vm._v("Invoices Permissions")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-switch',{attrs:{"disabled":_vm.currentUser.role == 'admin',"label":("Invoice Edit: " + (_vm.permissionsObj.INVOICE_EDIT ? 'Granted' : 'Denied'))},model:{value:(_vm.permissionsObj.INVOICE_EDIT),callback:function ($$v) {_vm.$set(_vm.permissionsObj, "INVOICE_EDIT", $$v)},expression:"permissionsObj.INVOICE_EDIT"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-switch',{attrs:{"disabled":_vm.currentUser.role == 'admin',"label":("Invoice Delete: " + (_vm.permissionsObj.INVOICE_DELETE ? 'Granted' : 'Denied'))},model:{value:(_vm.permissionsObj.INVOICE_DELETE),callback:function ($$v) {_vm.$set(_vm.permissionsObj, "INVOICE_DELETE", $$v)},expression:"permissionsObj.INVOICE_DELETE"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-switch',{attrs:{"disabled":_vm.currentUser.role == 'admin',"label":("Invoice Transfer: " + (_vm.permissionsObj.INVOICE_TRANSFER ? 'Granted' : 'Denied'))},model:{value:(_vm.permissionsObj.INVOICE_TRANSFER),callback:function ($$v) {_vm.$set(_vm.permissionsObj, "INVOICE_TRANSFER", $$v)},expression:"permissionsObj.INVOICE_TRANSFER"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('h3',[_vm._v("Brand Permissions")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-switch',{attrs:{"disabled":_vm.currentUser.role == 'admin',"label":("Settings : " + (_vm.permissionsObj.BRAND_SETTINGS ? 'Granted' : 'Denied'))},model:{value:(_vm.permissionsObj.BRAND_SETTINGS),callback:function ($$v) {_vm.$set(_vm.permissionsObj, "BRAND_SETTINGS", $$v)},expression:"permissionsObj.BRAND_SETTINGS"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-switch',{attrs:{"disabled":_vm.currentUser.role == 'admin',"label":("Dashboard : " + (_vm.permissionsObj.BRAND_DASHBOARD ? 'Granted' : 'Denied'))},model:{value:(_vm.permissionsObj.BRAND_DASHBOARD),callback:function ($$v) {_vm.$set(_vm.permissionsObj, "BRAND_DASHBOARD", $$v)},expression:"permissionsObj.BRAND_DASHBOARD"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-switch',{attrs:{"disabled":_vm.currentUser.role == 'admin',"label":("Buyers : " + (_vm.permissionsObj.BRAND_BUYER ? 'Granted' : 'Denied'))},model:{value:(_vm.permissionsObj.BRAND_BUYER),callback:function ($$v) {_vm.$set(_vm.permissionsObj, "BRAND_BUYER", $$v)},expression:"permissionsObj.BRAND_BUYER"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-switch',{attrs:{"disabled":_vm.currentUser.role == 'admin',"label":("Records : " + (_vm.permissionsObj.BRAND_RECORDS ? 'Granted' : 'Denied'))},model:{value:(_vm.permissionsObj.BRAND_RECORDS),callback:function ($$v) {_vm.$set(_vm.permissionsObj, "BRAND_RECORDS", $$v)},expression:"permissionsObj.BRAND_RECORDS"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-switch',{attrs:{"disabled":_vm.currentUser.role == 'admin',"label":("Transaction : " + (_vm.permissionsObj.BRAND_TRANSACTION ? 'Granted' : 'Denied'))},model:{value:(_vm.permissionsObj.BRAND_TRANSACTION),callback:function ($$v) {_vm.$set(_vm.permissionsObj, "BRAND_TRANSACTION", $$v)},expression:"permissionsObj.BRAND_TRANSACTION"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-switch',{attrs:{"disabled":_vm.currentUser.role == 'admin',"label":("Reports : " + (_vm.permissionsObj.BRAND_REPORTS ? 'Granted' : 'Denied'))},model:{value:(_vm.permissionsObj.BRAND_REPORTS),callback:function ($$v) {_vm.$set(_vm.permissionsObj, "BRAND_REPORTS", $$v)},expression:"permissionsObj.BRAND_REPORTS"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-switch',{attrs:{"disabled":_vm.currentUser.role == 'admin',"label":("Product : " + (_vm.permissionsObj.BRAND_PRODUCTS ? 'Granted' : 'Denied'))},model:{value:(_vm.permissionsObj.BRAND_PRODUCTS),callback:function ($$v) {_vm.$set(_vm.permissionsObj, "BRAND_PRODUCTS", $$v)},expression:"permissionsObj.BRAND_PRODUCTS"}})],1),_vm._v(" "),_c('v-switch',{attrs:{"disabled":_vm.currentUser.role == 'admin',"label":("Transfer : " + (_vm.permissionsObj.AMOUNT_TRANSFER ? 'Granted' : 'Denied'))},model:{value:(_vm.permissionsObj.AMOUNT_TRANSFER),callback:function ($$v) {_vm.$set(_vm.permissionsObj, "AMOUNT_TRANSFER", $$v)},expression:"permissionsObj.AMOUNT_TRANSFER"}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('h3',[_vm._v("Product Rate Settings Permissions")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-switch',{attrs:{"disabled":_vm.currentUser.role == 'admin',"label":("Selling Rate : " + (_vm.permissionsObj.SALE_RATE_VIEW_EDIT ? 'Granted' : 'Denied'))},model:{value:(_vm.permissionsObj.SALE_RATE_VIEW_EDIT),callback:function ($$v) {_vm.$set(_vm.permissionsObj, "SALE_RATE_VIEW_EDIT", $$v)},expression:"permissionsObj.SALE_RATE_VIEW_EDIT"}}),_vm._v(" "),_c('v-switch',{attrs:{"disabled":_vm.currentUser.role == 'admin',"label":("Purchasing Rate : " + (_vm.permissionsObj.PURCHASE_RATE_VIEW_EDIT ? 'Granted' : 'Denied'))},model:{value:(_vm.permissionsObj.PURCHASE_RATE_VIEW_EDIT),callback:function ($$v) {_vm.$set(_vm.permissionsObj, "PURCHASE_RATE_VIEW_EDIT", $$v)},expression:"permissionsObj.PURCHASE_RATE_VIEW_EDIT"}}),_vm._v(" "),_c('v-switch',{attrs:{"disabled":_vm.currentUser.role == 'admin',"label":("Order Edit : " + (_vm.permissionsObj.INDIVIDUAL_ORDER_EDIT ? 'Granted' : 'Denied'))},model:{value:(_vm.permissionsObj.INDIVIDUAL_ORDER_EDIT),callback:function ($$v) {_vm.$set(_vm.permissionsObj, "INDIVIDUAL_ORDER_EDIT", $$v)},expression:"permissionsObj.INDIVIDUAL_ORDER_EDIT"}}),_vm._v(" "),_c('v-switch',{attrs:{"disabled":_vm.currentUser.role == 'admin',"label":("Order Delete : " + (_vm.permissionsObj.INDIVIDUAL_ORDER_DELETE ? 'Granted' : 'Denied'))},model:{value:(_vm.permissionsObj.INDIVIDUAL_ORDER_DELETE),callback:function ($$v) {_vm.$set(_vm.permissionsObj, "INDIVIDUAL_ORDER_DELETE", $$v)},expression:"permissionsObj.INDIVIDUAL_ORDER_DELETE"}}),_vm._v(" "),_c('v-switch',{attrs:{"disabled":_vm.currentUser.role == 'admin',"label":("Order Change Rate : " + (_vm.permissionsObj.ORDER_RATE_EDIT ? 'Granted' : 'Denied'))},model:{value:(_vm.permissionsObj.ORDER_RATE_EDIT),callback:function ($$v) {_vm.$set(_vm.permissionsObj, "ORDER_RATE_EDIT", $$v)},expression:"permissionsObj.ORDER_RATE_EDIT"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('h3',[_vm._v("Brand Live Settings Permissions")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-switch',{attrs:{"disabled":_vm.currentUser.role == 'admin',"label":("Change Financial year : " + (_vm.permissionsObj.CHANGE_FIN_YEAR ? 'Granted' : 'Denied'))},model:{value:(_vm.permissionsObj.CHANGE_FIN_YEAR),callback:function ($$v) {_vm.$set(_vm.permissionsObj, "CHANGE_FIN_YEAR", $$v)},expression:"permissionsObj.CHANGE_FIN_YEAR"}}),_vm._v(" "),_c('v-switch',{attrs:{"disabled":_vm.currentUser.role == 'admin',"label":("Change Default Firm : " + (_vm.permissionsObj.CHANGE_DEFAULT_FIRM ? 'Granted' : 'Denied'))},model:{value:(_vm.permissionsObj.CHANGE_DEFAULT_FIRM),callback:function ($$v) {_vm.$set(_vm.permissionsObj, "CHANGE_DEFAULT_FIRM", $$v)},expression:"permissionsObj.CHANGE_DEFAULT_FIRM"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('h3',[_vm._v("Branch")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"item-text":"text","item-value":"value","items":_vm.branchByBrand,"disabled":_vm.currentUser.role == 'admin',"label":"Select Branch"},model:{value:(_vm.currentUser.branch),callback:function ($$v) {_vm.$set(_vm.currentUser, "branch", $$v)},expression:"currentUser.branch"}})],1)],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text",attrs:{"round":"","large":"","primary-title":"","type":"submit"},on:{"click":function($event){return _vm.savePermission()}}},[_vm._v("\n                Save\n                "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cloud_done")])],1),_vm._v(" "),_c('v-spacer')],1)],1)],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.timeout,"top":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v(_vm._s(_vm.message))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_productGroup_vue__ = __webpack_require__(529);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cdc2754_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_productGroup_vue__ = __webpack_require__(1587);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_productGroup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2cdc2754_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_productGroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","offset-sm":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"headline text-xs-center"},[_vm._v("\n          Product Group Management\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{attrs:{"outlined":""},on:{"click":function($event){_vm.dialog = true}}},[_c('v-icon',{attrs:{"left":"","color":"teal"}},[_vm._v("add")]),_vm._v("\n            New Product Group  \n          ")],1)],1)],1),_vm._v(" "),_c('v-card',[_vm._l((_vm.getGroups),function(item,index){return [_c('v-divider',{key:item['.key']}),_vm._v(" "),_c('v-card',{key:index},[_c('v-card-title',{attrs:{"col":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('v-card-text',[_vm._v(" \n                  Name :- "),_c('b',[_vm._v(_vm._s(item.name))]),_vm._v("       \n                ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-card-text',[_vm._v(" \n                  Quantity :- "),_c('b',[_vm._v(_vm._s(item.quantity))]),_vm._v("       \n                ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-card-text',[_vm._v(" \n                  Weight (Grams) :- "),_c('b',[_vm._v(_vm._s(item.weight))]),_vm._v("       \n                ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('v-card-text',[_vm._v(" \n                  Amount :- "),_c('b',[_vm._v(_vm._s(item.openingBalance))]),_vm._v("       \n                ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('v-btn',{staticClass:"primary white--text",attrs:{"flat":"","icon":""},on:{"click":function($event){return _vm.editGroup(item)}}},[_c('v-icon',{staticClass:"white--text",attrs:{"primary":"","title":""}},[_vm._v("edit")])],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions')],1)]})],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"400"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","offset-sm":""}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text headline",attrs:{"primary-title":""}},[_vm._v("\n        "+_vm._s(!_vm.isEdit ? 'Create Product Group' : 'Edit Product Group')+"\n      ")]),_vm._v(" "),_c('form',[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"name":"name","label":"Group Name","type":"text","required":""},model:{value:(_vm.currentGroup.name),callback:function ($$v) {_vm.$set(_vm.currentGroup, "name", $$v)},expression:"currentGroup.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"name":"name","label":"Quantity","type":"number","required":""},model:{value:(_vm.currentGroup.quantity),callback:function ($$v) {_vm.$set(_vm.currentGroup, "quantity", $$v)},expression:"currentGroup.quantity"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"name":"name","label":"Group weight","type":"number","required":""},model:{value:(_vm.currentGroup.weight),callback:function ($$v) {_vm.$set(_vm.currentGroup, "weight", $$v)},expression:"currentGroup.weight"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"name":"name","label":"Opening Balance","type":"number","required":""},model:{value:(_vm.currentGroup.openingBalance),callback:function ($$v) {_vm.$set(_vm.currentGroup, "openingBalance", $$v)},expression:"currentGroup.openingBalance"}})],1)],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(!_vm.isEdit)?_c('v-btn',{staticClass:"primary white--text",attrs:{"round":"","large":"","primary-title":"","type":"submit"},on:{"click":_vm.addNewGroup}},[_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("add_task")]),_vm._v(" Save \n        ")],1):_c('v-btn',{staticClass:"primary white--text",attrs:{"round":"","large":"","primary-title":"","type":"submit"},on:{"click":_vm.editGroupSave}},[_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("add_task")]),_vm._v(" Update \n        ")],1),_vm._v(" "),_c('v-spacer')],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.timeout,"top":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n        "+_vm._s(_vm.message)+"\n      ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_productCategory_vue__ = __webpack_require__(530);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a335520_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_productCategory_vue__ = __webpack_require__(1589);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_productCategory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a335520_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_productCategory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","offset-sm":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"headline text-xs-center"},[_vm._v("\n          Product Category Management\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{attrs:{"outlined":""},on:{"click":function($event){_vm.dialog = true}}},[_c('v-icon',{attrs:{"left":"","color":"teal"}},[_vm._v(" add ")]),_vm._v("\n            New Product Category\n          ")],1)],1)],1),_vm._v(" "),_c('v-card',[_vm._l((_vm.getCategories),function(item,index){return [_c('v-divider',{key:item['.key']}),_vm._v(" "),_c('v-card',{key:index},[_c('v-card-title',{attrs:{"col":""}},[_c('v-flex',{attrs:{"xs11":""}},[_c('v-card-text',[_vm._v(" \n                  Name :- "),_c('b',[_vm._v(_vm._s(item.name))]),_vm._v("       \n                ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('v-btn',{staticClass:"primary white--text",attrs:{"flat":"","icon":""},on:{"click":function($event){return _vm.editCategory(item)}}},[_c('v-icon',{staticClass:"white--text",attrs:{"primary":"","title":""}},[_vm._v("edit")])],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions')],1)]})],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"400"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","offset-sm":""}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text headline",attrs:{"primary-title":""}},[_vm._v("\n        "+_vm._s(!_vm.isEdit ? 'Create Product Category' : 'Edit Product Category')+"\n      ")]),_vm._v(" "),_c('form',[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"name":"name","label":"Category Name","type":"text","required":""},model:{value:(_vm.currentCategory.name),callback:function ($$v) {_vm.$set(_vm.currentCategory, "name", $$v)},expression:"currentCategory.name"}})],1)],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(!_vm.isEdit)?_c('v-btn',{staticClass:"primary white--text",attrs:{"round":"","large":"","primary-title":"","type":"submit"},on:{"click":_vm.addNewCategory}},[_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("add_task")]),_vm._v(" Save \n        ")],1):_c('v-btn',{staticClass:"primary white--text",attrs:{"round":"","large":"","primary-title":"","type":"submit"},on:{"click":_vm.editCategorySave}},[_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("add_task")]),_vm._v(" Update \n        ")],1),_vm._v(" "),_c('v-spacer')],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.timeout,"top":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n        "+_vm._s(_vm.message)+"\n      ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_productRateCategory_vue__ = __webpack_require__(531);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7295897c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_productRateCategory_vue__ = __webpack_require__(1591);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_productRateCategory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7295897c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_productRateCategory_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","offset-sm":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"headline text-xs-center"},[_vm._v("\n          Rate Category Management\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{attrs:{"outlined":""},on:{"click":function($event){_vm.dialog = true}}},[_c('v-icon',{attrs:{"left":"","color":"teal"}},[_vm._v(" add ")]),_vm._v("\n            New Rate Category\n          ")],1)],1)],1),_vm._v(" "),_c('v-card',[_vm._l((_vm.getCategories),function(item,index){return [_c('v-divider',{key:item['.key']}),_vm._v(" "),_c('v-card',{key:index},[_c('v-card-title',{attrs:{"col":""}},[_c('v-flex',{attrs:{"xs11":""}},[_c('v-card-text',[_vm._v(" \n                  Name :- "),_c('b',[_vm._v(_vm._s(item.name))]),_vm._v("       \n                ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('v-btn',{staticClass:"primary white--text",attrs:{"flat":"","icon":""},on:{"click":function($event){return _vm.editCategory(item)}}},[_c('v-icon',{staticClass:"white--text",attrs:{"primary":"","title":""}},[_vm._v("edit")])],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions')],1)]})],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"400"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","offset-sm":""}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text headline",attrs:{"primary-title":""}},[_vm._v("\n        "+_vm._s(!_vm.isEdit ? 'Create Product Rate Category' : 'Edit Product Rate Category')+"\n      ")]),_vm._v(" "),_c('form',[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"name":"name","label":"Category Name","type":"text","required":""},model:{value:(_vm.currentCategory.name),callback:function ($$v) {_vm.$set(_vm.currentCategory, "name", $$v)},expression:"currentCategory.name"}})],1)],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(!_vm.isEdit)?_c('v-btn',{staticClass:"primary white--text",attrs:{"round":"","large":"","primary-title":"","type":"submit"},on:{"click":_vm.addNewCategory}},[_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("add_task")]),_vm._v(" Save \n        ")],1):_c('v-btn',{staticClass:"primary white--text",attrs:{"round":"","large":"","primary-title":"","type":"submit"},on:{"click":_vm.editCategorySave}},[_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("add_task")]),_vm._v(" Update \n        ")],1),_vm._v(" "),_c('v-spacer')],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.timeout,"top":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n        "+_vm._s(_vm.message)+"\n      ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_productSet_vue__ = __webpack_require__(532);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9dfe39d2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_productSet_vue__ = __webpack_require__(1593);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_productSet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9dfe39d2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_productSet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-cotainer',{attrs:{"fluid":"","grid-list-md":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"headline text-xs-center"},[_vm._v("\n          Product Set Management\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"outlined":""},on:{"click":function($event){_vm.productSetDialog = true,_vm.selectedProductSet = null}}},[_c('v-icon',{attrs:{"left":"","color":"teal"}},[_vm._v("add")]),_vm._v("\n            New Product Set \n        ")],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.productSetHeader,"items":_vm.productSetsByBrand,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.openProd(props.item)}}},[_vm._v("remove_red_eye")])],1),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['name']))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"font-weight-bold primary--text"},[_vm._v(_vm._s(_vm._f("amount")(_vm.getTotal(props.item) || 0)))])]),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editProductSet(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("edit")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteProductSet(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"1000px"},model:{value:(_vm.productSetDialog),callback:function ($$v) {_vm.productSetDialog=$$v},expression:"productSetDialog"}},[_c('v-card',{attrs:{"persistent":""}},[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Create Product Set")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"label":"Product Set Name"},model:{value:(_vm.productSetName),callback:function ($$v) {_vm.productSetName=$$v},expression:"productSetName"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-combobox',{attrs:{"items":_vm.productListByBrand,"return-object":true,"item-text":"name","label":"Product","multiple":""},on:{"change":function($event){return _vm.addToBucket()}},model:{value:(_vm.productsToProductSet),callback:function ($$v) {_vm.productsToProductSet=$$v},expression:"productsToProductSet"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-layout',{attrs:{"wrap":""}},[_vm._l((_vm.items),function(item){return [_c('v-flex',{key:item.productId,attrs:{"xs3":"","sm3":"","md3":""}},[_vm._v("\n                    "+_vm._s(item.productName)+"\n                  ")]),_vm._v(" "),_c('v-flex',{key:item.productName,attrs:{"xs3":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Quantity"},model:{value:(item.quantity),callback:function ($$v) {_vm.$set(item, "quantity", _vm._n($$v))},expression:"item.quantity"}})],1),_vm._v(" "),_c('v-flex',{key:item.productId+'a',attrs:{"xs3":"","sm3":"","md3":""}},[_c('v-select',{attrs:{"dense":"","item-text":"text","item-value":"value","items":_vm.units,"label":"Select unit"},model:{value:(item.unit),callback:function ($$v) {_vm.$set(item, "unit", $$v)},expression:"item.unit"}})],1),_vm._v(" "),_c('v-flex',{key:item.productName+'RATE',attrs:{"xs3":"","sm3":"","md3":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Rate"},model:{value:(item.rate),callback:function ($$v) {_vm.$set(item, "rate", _vm._n($$v))},expression:"item.rate"}})],1)]})],2)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){_vm.productSetDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),(_vm.selectedProductSet && _vm.selectedProductSet['.key'])?_c('v-btn',{attrs:{"color":"blue darken-1","disabled":!_vm.items.length,"flat":""},on:{"click":function($event){return _vm.updateProductSet()}}},[_vm._v("Update")]):_c('v-btn',{attrs:{"color":"blue darken-1","disabled":!_vm.items.length,"flat":""},on:{"click":function($event){return _vm.addProductSet()}}},[_vm._v("Create")])],1)],1)],1),_vm._v(" "),(_vm.selectedProductSet && _vm.selectedProductSet['.key'])?_c('v-dialog',{attrs:{"width":"800"},model:{value:(_vm.viewProductSetDialog),callback:function ($$v) {_vm.viewProductSetDialog=$$v},expression:"viewProductSetDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline grey lighten-2",attrs:{"primary-title":""}},[_vm._v("ProductSet details: - "+_vm._s(_vm.selectedProductSet['.key']))]),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.productInvoiceHeader,"items":_vm.selectedProductSet.items},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',[_vm._v(_vm._s(props.item['productName']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['quantity']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.unit))])]),_vm._v(" "),_c('td',[_c('b',[_c('v-text-field',{attrs:{"type":"number","label":"Product Rate"},model:{value:(props.item.rate),callback:function ($$v) {_vm.$set(props.item, "rate", _vm._n($$v))},expression:"props.item.rate"}})],1)]),_vm._v(" "),_c('td',[_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.fetchLatestRate(props.item)}}},[_vm._v("Fetch Rate")])],1)]}}],null,false,3600251349)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.fetchLatestRateBulk()}}},[_vm._v("Fetch Latest Rates")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.viewProductSetDialog = false}}},[_vm._v("Back")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.saveUpdatedSet()}}},[_vm._v("Update ")])],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductType_vue__ = __webpack_require__(533);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f247adb8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductType_vue__ = __webpack_require__(1595);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductType_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f247adb8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductType_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","offset-sm":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"headline text-xs-center"},[_vm._v("\n          Product Type Management\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{attrs:{"outlined":""},on:{"click":function($event){_vm.dialog = true}}},[_c('v-icon',{attrs:{"left":"","color":"teal"}},[_vm._v("add")]),_vm._v("\n            New Product Type\n          ")],1)],1)],1),_vm._v(" "),_c('v-card',[_vm._l((_vm.getTypes),function(item,index){return [_c('v-divider',{key:item['.key']}),_vm._v(" "),_c('v-card',{key:index},[_c('v-card-title',{attrs:{"col":""}},[_c('v-flex',{attrs:{"xs11":""}},[_c('v-card-text',[_vm._v(" \n                  Name :- "),_c('b',[_vm._v(_vm._s(item.name))]),_vm._v("       \n                ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('v-btn',{staticClass:"primary white--text",attrs:{"flat":"","icon":""},on:{"click":function($event){return _vm.editType(item)}}},[_c('v-icon',{staticClass:"white--text",attrs:{"primary":"","title":""}},[_vm._v("edit")])],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions')],1)]})],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"400"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","offset-sm":""}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text headline",attrs:{"primary-title":""}},[_vm._v("\n        "+_vm._s(!_vm.isEdit ? 'Create Product Type' : 'Edit Product Type')+"\n      ")]),_vm._v(" "),_c('form',[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"name":"name","label":"Type Name","type":"text","required":""},model:{value:(_vm.currentType.name),callback:function ($$v) {_vm.$set(_vm.currentType, "name", $$v)},expression:"currentType.name"}})],1)],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(!_vm.isEdit)?_c('v-btn',{staticClass:"primary white--text",attrs:{"round":"","large":"","primary-title":"","type":"submit"},on:{"click":_vm.addNewType}},[_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("add_task")]),_vm._v(" Save \n        ")],1):_c('v-btn',{staticClass:"primary white--text",attrs:{"round":"","large":"","primary-title":"","type":"submit"},on:{"click":_vm.editTypeSave}},[_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("add_task")]),_vm._v(" Update \n        ")],1),_vm._v(" "),_c('v-spacer')],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.timeout,"top":""},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n        "+_vm._s(_vm.message)+"\n      ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductUniqueId_vue__ = __webpack_require__(534);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19949852_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductUniqueId_vue__ = __webpack_require__(1597);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductUniqueId_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19949852_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductUniqueId_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-cotainer',{attrs:{"fluid":"","grid-list-md":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"headline text-xs-center"},[_vm._v("\n          Product Unique Id ( HUID | RFID )\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"outlined":""},on:{"click":function($event){return _vm.addProductSet()}}},[_c('v-icon',{attrs:{"left":"","color":"teal"}},[_vm._v("add")]),_vm._v("\n          New Item\n        ")],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.productSetHeader,"items":_vm.productUniqueIds,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',[_vm._v(_vm._s(props.item["unqId"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["barcode"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["grossWeight"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["purity"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["lessStone"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["sold"] ?  'Yes' : 'No'))])]),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":props.item.sold || props.item.autoGenerated},on:{"click":function($event){return _vm.edit(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("edit")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.printBarcode(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("print")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":"","disabled":props.item.sold || props.item.autoGenerated},on:{"click":function($event){return _vm.deleteProductSet(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"1000px"},model:{value:(_vm.productSetDialog),callback:function ($$v) {_vm.productSetDialog=$$v},expression:"productSetDialog"}},[(_vm.currentSet)?_c('v-card',{attrs:{"persistent":""}},[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Create Product Barcode and HUID")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-select',{attrs:{"items":_vm.productListByBrand,"item-text":"title","item-value":"value","label":"Product"},model:{value:(_vm.currentSet.product),callback:function ($$v) {_vm.$set(_vm.currentSet, "product", $$v)},expression:"currentSet.product"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"type":"text","label":"Unique ID (HUID|RFID)"},model:{value:(_vm.currentSet.unqId),callback:function ($$v) {_vm.$set(_vm.currentSet, "unqId", $$v)},expression:"currentSet.unqId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Net Weight","suffix":"Gram"},model:{value:(_vm.currentSet.grossWeight),callback:function ($$v) {_vm.$set(_vm.currentSet, "grossWeight", _vm._n($$v))},expression:"currentSet.grossWeight"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-text-field',{attrs:{"type":"text","label":" Barcode"},model:{value:(_vm.currentSet.barcode),callback:function ($$v) {_vm.$set(_vm.currentSet, "barcode", $$v)},expression:"currentSet.barcode"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md3":""}},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.generateBarcode(null)}}},[_vm._v("Generate New Barcode")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"type":"text","label":"Purity","suffix":"%"},model:{value:(_vm.currentSet.purity),callback:function ($$v) {_vm.$set(_vm.currentSet, "purity", $$v)},expression:"currentSet.purity"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-text-field',{attrs:{"type":"number","label":"less","suffix":"%"},model:{value:(_vm.currentSet.lessStone),callback:function ($$v) {_vm.$set(_vm.currentSet, "lessStone", $$v)},expression:"currentSet.lessStone"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datePicker),callback:function ($$v) {_vm.datePicker=$$v},expression:"datePicker"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date","readonly":""},slot:"activator",model:{value:(_vm.currentSet.date),callback:function ($$v) {_vm.$set(_vm.currentSet, "date", $$v)},expression:"currentSet.date"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datePicker = false}},model:{value:(_vm.currentSet.date),callback:function ($$v) {_vm.$set(_vm.currentSet, "date", $$v)},expression:"currentSet.date"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","flat":""},on:{"click":function($event){_vm.productSetDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),(_vm.currentSet['.key'])?_c('v-btn',{attrs:{"color":"primary darken-1","flat":""},on:{"click":function($event){return _vm.update()}}},[_vm._v("Update")]):_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){return _vm.save()}}},[_vm._v("Create")])],1)],1):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticStyle:{"visibility":"hidden"},attrs:{"xs12":"","sm4":"","md4":""}},[_vm._v("\n    Barcode Image\n    "),_c('br'),_vm._v(" "),_c('svg',{attrs:{"id":"barcode"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductOffers_vue__ = __webpack_require__(535);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e4527bb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductOffers_vue__ = __webpack_require__(1599);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductOffers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3e4527bb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductOffers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-cotainer',{attrs:{"fluid":"","grid-list-md":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"headline text-xs-center"},[_vm._v("\n          Product Offers Management\n        ")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.productOffersHeader,"items":_vm.productListByBrand,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v("\n            "+_vm._s(props.item.name)+"\n          ")]),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editProduct(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("edit")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"1000px"},model:{value:(_vm.productOfferDialog),callback:function ($$v) {_vm.productOfferDialog=$$v},expression:"productOfferDialog"}},[(_vm.selectedProduct['.key'])?_c('v-card',{attrs:{"persistent":""}},[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Create Product Set")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs10":"","sm10":"","md10":""}},[_vm._v("\n              Add Update Offers for "+_vm._s(_vm.selectedProduct.name)+"\n            ")]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}},[(_vm.selectedProduct.offers.length == 0)?_c('v-btn',{attrs:{"icon":"","color":"primary"},on:{"click":function($event){return _vm.addProd()}}},[_c('v-icon',[_vm._v("add_circle")])],1):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},_vm._l((_vm.selectedProduct.offers),function(offer,index){return _c('v-layout',{key:index,attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Min Quantity"},model:{value:(offer.minQuantity),callback:function ($$v) {_vm.$set(offer, "minQuantity", _vm._n($$v))},expression:"offer.minQuantity"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Offer Free Quantity"},model:{value:(offer.offerQuantity),callback:function ($$v) {_vm.$set(offer, "offerQuantity", _vm._n($$v))},expression:"offer.offerQuantity"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker1[index]),callback:function ($$v) {_vm.$set(_vm.datepicker1, index, $$v)},expression:"datepicker1[index]"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Offer Start Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(offer.startDate),callback:function ($$v) {_vm.$set(offer, "startDate", $$v)},expression:"offer.startDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepicker1[index] = false}},model:{value:(offer.startDate),callback:function ($$v) {_vm.$set(offer, "startDate", $$v)},expression:"offer.startDate"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker2[index]),callback:function ($$v) {_vm.$set(_vm.datepicker2, index, $$v)},expression:"datepicker2[index]"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Offer End Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(offer.endDate),callback:function ($$v) {_vm.$set(offer, "endDate", $$v)},expression:"offer.endDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepicker2[index] = false}},model:{value:(offer.endDate),callback:function ($$v) {_vm.$set(offer, "endDate", $$v)},expression:"offer.endDate"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[(index == _vm.selectedProduct.offers.length - 1)?_c('v-btn',{attrs:{"icon":"","color":"primary"},on:{"click":function($event){return _vm.addProd()}}},[_c('v-icon',[_vm._v("add_circle")])],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","color":"primary"},on:{"click":function($event){return _vm.removeProd(index)}}},[_c('v-icon',[_vm._v("cancel")])],1)],1)],1)}),1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){_vm.productOfferDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){return _vm.updateProduct()}}},[_vm._v("Update")])],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductReplacement_vue__ = __webpack_require__(536);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5254b444_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductReplacement_vue__ = __webpack_require__(1601);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductReplacement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5254b444_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductReplacement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-cotainer',{attrs:{"fluid":"","grid-list-md":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"headline text-xs-center"},[_vm._v("\n          Product Replacement\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"outlined":""},on:{"click":function($event){return _vm.addDamage()}}},[_c('v-icon',{attrs:{"left":"","color":"teal"}},[_vm._v("add")]),_vm._v("\n          New Item\n        ")],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.manufHeader,"items":_vm.productMenufsList,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',[_vm._v(_vm._s(_vm.getProductName(props.item.productId)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.getProductName(props.item.newProductId)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.getCustomerName(props.item.buyerId)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(new Date(props.item["date"]).toLocaleDateString("en-GB")))])]),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.edit(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("edit")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteMenuf(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"1000px"},model:{value:(_vm.menufDialog),callback:function ($$v) {_vm.menufDialog=$$v},expression:"menufDialog"}},[(_vm.currentMenuf)?_c('v-card',{attrs:{"persistent":""}},[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Replace Product")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-switch',{attrs:{"label":("" + (_vm.currentMenuf.isBuyer ? 'Sale Order' : 'Purchase Order'))},model:{value:(_vm.currentMenuf.isBuyer),callback:function ($$v) {_vm.$set(_vm.currentMenuf, "isBuyer", $$v)},expression:"currentMenuf.isBuyer"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-select',{attrs:{"items":_vm.currentMenuf.isBuyer ? _vm.buyersByBrand : _vm.sellersByBrand,"label":_vm.currentMenuf.isBuyer
                    ? 'Select or add Buyer'
                    : 'Select or add Seller',"autocomplete":"","item-text":'text',"item-value":'value'},model:{value:(_vm.currentMenuf.buyerId),callback:function ($$v) {_vm.$set(_vm.currentMenuf, "buyerId", $$v)},expression:"currentMenuf.buyerId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datePicker),callback:function ($$v) {_vm.datePicker=$$v},expression:"datePicker"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.currentMenuf.date),callback:function ($$v) {_vm.$set(_vm.currentMenuf, "date", $$v)},expression:"currentMenuf.date"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datePicker = false}},model:{value:(_vm.currentMenuf.date),callback:function ($$v) {_vm.$set(_vm.currentMenuf, "date", $$v)},expression:"currentMenuf.date"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-select',{attrs:{"dense":"","autocomplete":"","items":_vm.productsByBrand,"label":"Old Product"},model:{value:(_vm.currentMenuf.productId),callback:function ($$v) {_vm.$set(_vm.currentMenuf, "productId", $$v)},expression:"currentMenuf.productId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Old Product Quantity"},model:{value:(_vm.currentMenuf.quantity),callback:function ($$v) {_vm.$set(_vm.currentMenuf, "quantity", _vm._n($$v))},expression:"currentMenuf.quantity"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-select',{attrs:{"dense":"","autocomplete":"","items":_vm.productsByBrand,"label":"New Product"},model:{value:(_vm.currentMenuf.newProductId),callback:function ($$v) {_vm.$set(_vm.currentMenuf, "newProductId", $$v)},expression:"currentMenuf.newProductId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-text-field',{attrs:{"type":"number","label":"New Product Quantity"},model:{value:(_vm.currentMenuf.newProductQuantity),callback:function ($$v) {_vm.$set(_vm.currentMenuf, "newProductQuantity", _vm._n($$v))},expression:"currentMenuf.newProductQuantity"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){_vm.menufDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),(_vm.currentMenuf['.key'])?_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){return _vm.update()}}},[_vm._v("Update")]):_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){return _vm.save()}}},[_vm._v("Create")])],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_productDrawer_vue__ = __webpack_require__(537);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_218316d5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_productDrawer_vue__ = __webpack_require__(1603);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_productDrawer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_218316d5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_productDrawer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-cotainer',{attrs:{"fluid":"","grid-list-md":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"headline text-xs-center"},[_vm._v("\n          Product Drawer Management\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"outlined":""},on:{"click":function($event){return _vm.addDrawer()}}},[_c('v-icon',{attrs:{"left":"","color":"teal"}},[_vm._v("add")]),_vm._v("\n          New Drawer\n        ")],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.productDrawerHeader,"items":_vm.productDrawersByBrand,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.viewDrawer(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("remove_red_eye")])],1)],1),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["name"]))])]),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editProductDrawer(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("edit")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"1000px"},model:{value:(_vm.productDrawerDialog),callback:function ($$v) {_vm.productDrawerDialog=$$v},expression:"productDrawerDialog"}},[(_vm.currentDrawer)?_c('v-card',{attrs:{"persistent":""}},[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Create Product Drawer")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"label":"Product Drawer Name"},model:{value:(_vm.currentDrawer.name),callback:function ($$v) {_vm.$set(_vm.currentDrawer, "name", $$v)},expression:"currentDrawer.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},_vm._l((_vm.currentDrawer.items),function(item,index){return _c('v-layout',{key:index + '1',attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-select',{attrs:{"dense":"","autocomplete":"","item-text":"text","item-value":'value',"items":_vm.productListByBrand,"label":"Product","clearable":""},model:{value:(item.product),callback:function ($$v) {_vm.$set(item, "product", $$v)},expression:"item.product"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[(
                      index == _vm.currentDrawer.items.length - 1 && item.product
                    )?_c('v-btn',{attrs:{"icon":"","color":"primary"},on:{"click":function($event){return _vm.addProd()}}},[_c('v-icon',[_vm._v("add_circle")])],1):(item.product)?_c('v-btn',{attrs:{"icon":"","color":"primary"},on:{"click":function($event){return _vm.removeProd(index)}}},[_c('v-icon',[_vm._v("cancel")])],1):_vm._e()],1)],1)}),1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){_vm.productDrawerDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),(_vm.currentDrawer && _vm.currentDrawer['.key'])?_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){return _vm.updateProductDrawer()}}},[_vm._v("Update")]):_c('v-btn',{attrs:{"color":"blue darken-1","disabled":!_vm.currentDrawer.name,"flat":""},on:{"click":function($event){return _vm.save()}}},[_vm._v("Create")])],1)],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"1000px"},model:{value:(_vm.productViewDialog),callback:function ($$v) {_vm.productViewDialog=$$v},expression:"productViewDialog"}},[(_vm.currentDrawer)?_c('v-card',{attrs:{"persistent":""}},[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Product Drawer")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-text-field',{attrs:{"label":"Product Drawer Name","disabled":"","readonly":""},model:{value:(_vm.currentDrawer.name),callback:function ($$v) {_vm.$set(_vm.currentDrawer, "name", $$v)},expression:"currentDrawer.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},_vm._l((_vm.currentDrawer.items),function(item,index){return _c('v-layout',{key:index + '1',attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-select',{attrs:{"dense":"","autocomplete":"","item-text":"text","item-value":'value',"disabled":"","items":_vm.productListByBrand,"label":"Product","readonly":"","clearable":""},model:{value:(item.product),callback:function ($$v) {_vm.$set(item, "product", $$v)},expression:"item.product"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","sm1":"","md1":""}},[_c('v-btn',{attrs:{"icon":"","color":"primary"},on:{"click":function($event){return _vm.viewTransactions(item.product)}}},[_c('v-icon',[_vm._v("remove_red_eye")])],1)],1)],1)}),1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){_vm.productViewDialog = false}}},[_vm._v("Cancel")])],1)],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"1000px"},model:{value:(_vm.productTransactionDialog),callback:function ($$v) {_vm.productTransactionDialog=$$v},expression:"productTransactionDialog"}},[_c('v-card',{attrs:{"persistent":""}},[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Transactions")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!_vm.isAddEditMode)?_c('v-btn',{attrs:{"outlined":""},on:{"click":function($event){return _vm.addEntry()}}},[_c('v-icon',{attrs:{"left":"","color":"teal"}},[_vm._v("add")]),_vm._v("\n          New Entry\n        ")],1):_vm._e()],1),_vm._v(" "),_c('v-card-text',[(!_vm.isAddEditMode)?_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.productTransactionHeader,"items":_vm.transactions,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',[_vm._v(_vm._s(new Date(props.item["date"]).toLocaleDateString("en-GB")))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["invoiceId"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["quantity"]))])]),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editEntry(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("edit")])],1)],1)]}}],null,false,2105681445)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1):(_vm.currentEntry && _vm.isAddEditMode)?_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"label":"Quantity","type":"number"},model:{value:(_vm.currentEntry.quantity),callback:function ($$v) {_vm.$set(_vm.currentEntry, "quantity", $$v)},expression:"currentEntry.quantity"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm6":"","md6":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datePicker),callback:function ($$v) {_vm.datePicker=$$v},expression:"datePicker"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Order Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.currentEntry.date),callback:function ($$v) {_vm.$set(_vm.currentEntry, "date", $$v)},expression:"currentEntry.date"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datePicker = false}},model:{value:(_vm.currentEntry.date),callback:function ($$v) {_vm.$set(_vm.currentEntry, "date", $$v)},expression:"currentEntry.date"}})],1)],1)],1)],1):_vm._e()],1),_vm._v(" "),(!_vm.isAddEditMode)?_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){_vm.productTransactionDialog = false}}},[_vm._v("Cancel")])],1):_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){_vm.isAddEditMode = false}}},[_vm._v("Cancel")]),_vm._v(" "),(_vm.currentEntry && _vm.currentEntry['.key'])?_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){return _vm.udpateTransaction()}}},[_vm._v("Update")]):_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){return _vm.saveTrnasaction()}}},[_vm._v("Create")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dataManagement_vue__ = __webpack_require__(538);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0aa4cc8a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dataManagement_vue__ = __webpack_require__(1605);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dataManagement_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0aa4cc8a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_dataManagement_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","offset-sm":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"headline text-xs-center"},[_vm._v("\n          Data Management\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"outlined":"","disabled":!_vm.selectedBrand},on:{"click":function($event){return _vm.exportAllData()}}},[_c('v-icon',{attrs:{"left":"","color":"teal"}},[_vm._v(" arrow_circle_up ")]),_vm._v(" \n            Export All Data \n          ")],1),_vm._v(" "),_c('input',{attrs:{"type":"file","accept":"application/JSON","id":"importDataFile","hidden":""},on:{"change":_vm.loadImportedFile}}),_vm._v(" "),_c('v-btn',{attrs:{"outlined":""},on:{"click":function($event){return _vm.uploadFile()}}},[_c('v-icon',{attrs:{"left":"","color":"teal"}},[_vm._v(" arrow_circle_down ")]),_vm._v(" \n            Import All Data \n          ")],1),_vm._v(" "),_c('v-btn',{attrs:{"disabled":"","outline":"","large":""},on:{"click":function($event){return _vm.removeAllData()}}},[_c('v-icon',{attrs:{"left":"","color":"teal"}},[_vm._v(" delete ")]),_vm._v(" \n            Delete All Data \n          ")],1),_vm._v(" "),_c('router-link',{attrs:{"to":"/Dashboard"}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("close")])],1)],1)],1),_vm._v(" "),_c('v-card',[_c('v-card',[_c('v-card-title',{attrs:{"col":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('v-card-text',[_c('b',{staticClass:"primary--text font-weight-bold"},[_vm._v("Customers")])])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-btn',{staticClass:"ma-2 white--text",attrs:{"color":"blue-grey"},on:{"click":function($event){return _vm.deleteIndividualDataSet('buyer')}}},[_vm._v("\n                  Delete Customers\n                  "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("\n                      delete\n                  ")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"top":"","color":"success","timeout":3000},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n "+_vm._s(_vm.snackbarSuccessText)+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FirmSettings_vue__ = __webpack_require__(539);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d268be7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FirmSettings_vue__ = __webpack_require__(1607);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FirmSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d268be7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FirmSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"headline text-xs-center"},[_vm._v("\n          Invoice Management\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{staticClass:"white--text",attrs:{"outline":"","large":""},on:{"click":_vm.addSettings}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v(" add ")]),_vm._v("\n            NEW INVOICE SETTINGS\n          ")],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.settingsListHeader,"items":_vm.settingsListByBrand,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',[_vm._v(_vm._s(_vm.getFirmName(props.item.firm)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["invoiceIdPrefix"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["roundOff"] ? "Yes" : "No"))])]),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editSetting(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteSetting(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"1000px"},model:{value:(_vm.addSettingsDialog),callback:function ($$v) {_vm.addSettingsDialog=$$v},expression:"addSettingsDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Settings")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.addSettingsDialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[(!_vm.currentSettings['.key'])?_c('v-select',{attrs:{"dense":"","items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.currentSettings.firm),callback:function ($$v) {_vm.$set(_vm.currentSettings, "firm", $$v)},expression:"currentSettings.firm"}}):_c('v-text-field',{attrs:{"dense":"","value":_vm.getFirmName(_vm.currentSettings.firm),"disabled":true,"label":"Select Firm"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-select',{attrs:{"dense":"","items":[
                  {
                    text: 'Due',
                    value: 'Debit',
                  },
                  {
                    text: 'Full Paid',
                    value: 'Credit',
                  } ],"label":"Default Transaction type"},model:{value:(_vm.currentSettings.transactionType),callback:function ($$v) {_vm.$set(_vm.currentSettings, "transactionType", $$v)},expression:"currentSettings.transactionType"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"label":("" + ('Invoice Alert Notification : ' +
                  (_vm.currentSettings.alert ? 'YES' : 'NO')))},model:{value:(_vm.currentSettings.alert),callback:function ($$v) {_vm.$set(_vm.currentSettings, "alert", $$v)},expression:"currentSettings.alert"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{ref:"name",attrs:{"type":"text","autocomplete":"new-password","label":"Invoice ID Prefix"},model:{value:(_vm.currentSettings.invoiceIdPrefix),callback:function ($$v) {_vm.$set(_vm.currentSettings, "invoiceIdPrefix", $$v)},expression:"currentSettings.invoiceIdPrefix"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"label":("" + ('Invoice ID Date Wise Counter : ' +
                  (_vm.currentSettings.invoiceIdByDate ? 'YES' : 'NO')))},model:{value:(_vm.currentSettings.invoiceIdByDate),callback:function ($$v) {_vm.$set(_vm.currentSettings, "invoiceIdByDate", $$v)},expression:"currentSettings.invoiceIdByDate"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"label":("" + ('Invoice ID Reset for Finacial Year : ' +
                  (_vm.currentSettings.invoiceResetFinYear ? 'YES' : 'NO')))},model:{value:(_vm.currentSettings.invoiceResetFinYear),callback:function ($$v) {_vm.$set(_vm.currentSettings, "invoiceResetFinYear", $$v)},expression:"currentSettings.invoiceResetFinYear"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"disabled":"","label":("" + ('Verified Invoice : ' +
                  (_vm.currentSettings.verifiedInvoice ? 'YES' : 'NO')))},model:{value:(_vm.currentSettings.verifiedInvoice),callback:function ($$v) {_vm.$set(_vm.currentSettings, "verifiedInvoice", $$v)},expression:"currentSettings.verifiedInvoice"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"label":("" + ('Invoice Round off : ' +
                  (_vm.currentSettings.roundOff ? 'YES' : 'NO')))},model:{value:(_vm.currentSettings.roundOff),callback:function ($$v) {_vm.$set(_vm.currentSettings, "roundOff", $$v)},expression:"currentSettings.roundOff"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"label":("" + ('Invoice ID Auto Counter: ' +
                  (_vm.currentSettings.autoCounter ? 'YES' : 'NO')))},model:{value:(_vm.currentSettings.autoCounter),callback:function ($$v) {_vm.$set(_vm.currentSettings, "autoCounter", $$v)},expression:"currentSettings.autoCounter"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"label":("" + ('E-Way Bill Invoice: ' +
                  (_vm.currentSettings.ewayBill ? 'YES' : 'NO')))},model:{value:(_vm.currentSettings.ewayBill),callback:function ($$v) {_vm.$set(_vm.currentSettings, "ewayBill", $$v)},expression:"currentSettings.ewayBill"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"label":("" + ('Image Upload with Create Invoice: ' +
                  (_vm.currentSettings.invoiceImage ? 'YES' : 'NO')))},model:{value:(_vm.currentSettings.invoiceImage),callback:function ($$v) {_vm.$set(_vm.currentSettings, "invoiceImage", $$v)},expression:"currentSettings.invoiceImage"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"label":("" + ('Hide Negetive Stock Alert: ' +
                  (_vm.currentSettings.hideNegetiveStockAlert ? 'YES' : 'NO')))},model:{value:(_vm.currentSettings.hideNegetiveStockAlert),callback:function ($$v) {_vm.$set(_vm.currentSettings, "hideNegetiveStockAlert", $$v)},expression:"currentSettings.hideNegetiveStockAlert"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"label":("" + ('Individual Product Brokerage: ' +
                  (_vm.currentSettings.individualProdBrokerage ? 'YES' : 'NO')))},model:{value:(_vm.currentSettings.individualProdBrokerage),callback:function ($$v) {_vm.$set(_vm.currentSettings, "individualProdBrokerage", $$v)},expression:"currentSettings.individualProdBrokerage"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"label":("" + ('Delete Invoice With Password: ' +
                  (_vm.currentSettings.deleteWithPassword ? 'YES' : 'NO')))},model:{value:(_vm.currentSettings.deleteWithPassword),callback:function ($$v) {_vm.$set(_vm.currentSettings, "deleteWithPassword", $$v)},expression:"currentSettings.deleteWithPassword"}})],1),_vm._v(" "),(_vm.currentSettings.deleteWithPassword)?_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{attrs:{"type":"password","autocomplete":"new-password","label":"Delete Invoice Password"},model:{value:(_vm.currentSettings.deleteInvoicePassword),callback:function ($$v) {_vm.$set(_vm.currentSettings, "deleteInvoicePassword", $$v)},expression:"currentSettings.deleteInvoicePassword"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-select',{attrs:{"dense":"","items":['simple','basic','detailed','trail','theme1'],"label":"Select Print Formats (By default it shows all when not selected any)","multiple":"","clearable":""},model:{value:(_vm.currentSettings.supportedPrintFormats),callback:function ($$v) {_vm.$set(_vm.currentSettings, "supportedPrintFormats", $$v)},expression:"currentSettings.supportedPrintFormats"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.stockReportTypes,"label":"Closing Stock","item-text":'text',"item-value":'value',"return-object":false},model:{value:(_vm.currentSettings.stockReportView),callback:function ($$v) {_vm.$set(_vm.currentSettings, "stockReportView", $$v)},expression:"currentSettings.stockReportView"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"label":("" + ('ReceiptId Reset for Finacial Year : ' +
                  (_vm.currentSettings.receiptNumberFinReset ? 'YES' : 'NO')))},model:{value:(_vm.currentSettings.receiptNumberFinReset),callback:function ($$v) {_vm.$set(_vm.currentSettings, "receiptNumberFinReset", $$v)},expression:"currentSettings.receiptNumberFinReset"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(!_vm.currentSettings['.key'])?_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":_vm.saveSettings}},[_vm._v("Save")]):_vm._e(),_vm._v(" "),(!!_vm.currentSettings['.key'])?_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":_vm.updateSettings}},[_vm._v("Update")]):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Branch_vue__ = __webpack_require__(540);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46540848_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Branch_vue__ = __webpack_require__(1609);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Branch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46540848_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Branch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","offset-sm":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"headline text-xs-center"},[_vm._v("\n          Branch Management \n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[(_vm.$route.path!='/offshoot')?_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":"/offshoot"}},[_c('v-btn',{staticStyle:{"margin":"0px 15px"},attrs:{"large":"","outlined":""}},[_c('v-icon',{attrs:{"left":"","color":"teal"}},[_vm._v("store")]),_vm._v("\n                Visit Branch\n            ")],1)],1):_vm._e(),_vm._v(" "),_c('v-btn',{attrs:{"outlined":"","large":""},on:{"click":_vm.getFirms}},[_c('v-icon',{attrs:{"left":"","color":"teal"}},[_vm._v("add")]),_vm._v(" \n            New Branch  \n          ")],1)],1)],1),_vm._v(" "),_c('v-card',[_vm._l((_vm.getBranchAccount),function(item,index){return [_c('v-divider',{key:item['.key']}),_vm._v(" "),_c('v-card',{key:index},[_c('v-card-title',{staticClass:"body-1 primary--text font-weight-light",attrs:{"col":""}},[_c('v-flex',{attrs:{"xs11":""}},[_vm._v(" \n                  Firm:    "),_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.firmbyId(item.firm)))]),_vm._v(" "),_c('v-spacer'),_vm._v("\n                  Branch Name:   "),_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(item.branchName))]),_vm._v(" "),_c('v-spacer'),_vm._v("\n                  Branch Address:   "),_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(item.branchAddress))]),_vm._v(" "),_c('v-spacer'),_vm._v("\n                  Branch Pincode:   "),_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(item.branchPincode))]),_vm._v(" "),_c('v-spacer'),_vm._v("\n                  Mobile Number:   "),_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(item.branchMobileNumber))]),_vm._v(" "),_c('v-spacer'),_vm._v("\n                  Email:   "),_c('b',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(item.branchEmail || '-'))])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}},[_c('v-btn',{staticClass:"primary white--text",attrs:{"flat":"","icon":""},on:{"click":function($event){return _vm.editBranchAccount(item)}}},[_c('v-icon',{attrs:{"color":"grey white--text"}},[_vm._v("edit")])],1),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text",attrs:{"flat":"","icon":""},on:{"click":function($event){return _vm.deleteBranchAccount(item['.key'])}}},[_c('v-icon',[_vm._v("delete")])],1)],1)],1)],1)]})],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"400"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":"","title":""}},[_c('span',{staticClass:"headline"},[_vm._v("Add New Branch")])]),_vm._v(" "),_c('v-card-text',[_c('v-select',{attrs:{"item-text":"name","item-value":"id","items":_vm.items,"label":"Select Firms"},model:{value:(_vm.currentFirm),callback:function ($$v) {_vm.currentFirm=$$v},expression:"currentFirm"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Branch Name"},model:{value:(_vm.branchName),callback:function ($$v) {_vm.branchName=$$v},expression:"branchName"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Branch Address"},model:{value:(_vm.branchAddress),callback:function ($$v) {_vm.branchAddress=$$v},expression:"branchAddress"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Branch Pincode"},model:{value:(_vm.branchPincode),callback:function ($$v) {_vm.branchPincode=$$v},expression:"branchPincode"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Mobile Number","rules":_vm.branchMobileNumber.rules},model:{value:(_vm.branchMobileNumber.value),callback:function ($$v) {_vm.$set(_vm.branchMobileNumber, "value", $$v)},expression:"branchMobileNumber.value"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Email","rules":_vm.branchEmail.rules},model:{value:(_vm.branchEmail.value),callback:function ($$v) {_vm.$set(_vm.branchEmail, "value", $$v)},expression:"branchEmail.value"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":_vm.cancelDialog}},[_vm._v("\n          Cancel\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":_vm.addNewBranchAccount}},[_vm._v("\n          Save\n        ")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"400"},model:{value:(_vm.dialogEdit),callback:function ($$v) {_vm.dialogEdit=$$v},expression:"dialogEdit"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":"","title":""}},[_c('span',{staticClass:"headline"},[_vm._v("Edit Branch Details")])]),_vm._v(" "),_c('v-card-text',[_c('v-select',{attrs:{"item-text":"name","item-value":"id","items":_vm.itemsEdit,"label":"Edit Firm"},model:{value:(_vm.currentFirmEdit),callback:function ($$v) {_vm.currentFirmEdit=$$v},expression:"currentFirmEdit"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Edit Branch Name"},model:{value:(_vm.branchNameEdit),callback:function ($$v) {_vm.branchNameEdit=$$v},expression:"branchNameEdit"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Edit Branch Address"},model:{value:(_vm.branchAddressEdit),callback:function ($$v) {_vm.branchAddressEdit=$$v},expression:"branchAddressEdit"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Edit Branch Pincode"},model:{value:(_vm.branchPincodeEdit),callback:function ($$v) {_vm.branchPincodeEdit=$$v},expression:"branchPincodeEdit"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Edit Mobile Number","rules":_vm.branchMobileNumberEdit.rules},model:{value:(_vm.branchMobileNumberEdit.value),callback:function ($$v) {_vm.$set(_vm.branchMobileNumberEdit, "value", $$v)},expression:"branchMobileNumberEdit.value"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Edit Email","rules":_vm.branchEmailEdit.rules},model:{value:(_vm.branchEmailEdit.value),callback:function ($$v) {_vm.$set(_vm.branchEmailEdit, "value", $$v)},expression:"branchEmailEdit.value"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":_vm.cancelDialogEdit}},[_vm._v("\n          Cancel\n        ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"green darken-1","flat":"flat"},on:{"click":_vm.updateNewBranchAccount}},[_vm._v("\n          Update\n        ")])],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"top":"","color":"error","timeout":3000},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n "+_vm._s(_vm.snackbarText)+"\n  ")]),_vm._v(" "),_c('v-snackbar',{attrs:{"top":"","color":"success","timeout":3000},model:{value:(_vm.snackbarSuccess),callback:function ($$v) {_vm.snackbarSuccess=$$v},expression:"snackbarSuccess"}},[_vm._v("\n "+_vm._s(_vm.snackbarSuccessText)+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transfer_vue__ = __webpack_require__(541);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_613907ea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Transfer_vue__ = __webpack_require__(1611);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Transfer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_613907ea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Transfer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"headline text-xs-center"},[_vm._v("\n          Transfer\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{staticClass:"white--text",attrs:{"outline":"","large":""},on:{"click":_vm.addTerm}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v(" add ")]),_vm._v("\n            NEW TRANSFER\n          ")],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.transferHeader,"items":_vm.transferListByBrand,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',[_vm._v(_vm._s(_vm.getFirmName(props.item.firm)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(new Date(props.item.date).toLocaleDateString("en-GB")))])]),_vm._v(" "),_c('td',[(props.item.transferCategory == 'B2B')?_c('b',[_vm._v("Bank Account -To- Bank Account")]):(props.item.transferCategory == 'B2C')?_c('b',[_vm._v("Bank Account -To- Cash Account")]):(props.item.transferCategory == 'C2B')?_c('b',[_vm._v("Cash Account -To- Bank Account")]):_vm._e()]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["amount"]))])]),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editTransfer(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteTerm(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"1000px"},model:{value:(_vm.transferDialog),callback:function ($$v) {_vm.transferDialog=$$v},expression:"transferDialog"}},[(_vm.currentTransfer)?_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Transfer")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.transferDialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-radio-group',{attrs:{"mandatory":false,"disabled":_vm.currentTransfer['.key']},model:{value:(_vm.currentTransfer.transferCategory),callback:function ($$v) {_vm.$set(_vm.currentTransfer, "transferCategory", $$v)},expression:"currentTransfer.transferCategory"}},[_c('v-radio',{staticClass:"font-weight-bold",attrs:{"label":"From Bank Account -To- Bank Account","value":"B2B"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"From Bank Account -To- Cash Account","value":"B2C"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"From Cash Account -To- Bank Account","value":"C2B"}})],1),_vm._v(" "),_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.transferdatepicker),callback:function ($$v) {_vm.transferdatepicker=$$v},expression:"transferdatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.currentTransfer.date),callback:function ($$v) {_vm.$set(_vm.currentTransfer, "date", $$v)},expression:"currentTransfer.date"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.transferdatepicker = false}},model:{value:(_vm.currentTransfer.date),callback:function ($$v) {_vm.$set(_vm.currentTransfer, "date", $$v)},expression:"currentTransfer.date"}})],1),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.firmsByBrand,"label":"Select Firm","required":""},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n            "+_vm._s(data.item.text)+"\n          ")]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(
                  ("" + (data.item.firm.name) + (data.item.firm.proprietor
                      ? ' | ' + data.item.firm.proprietor
                      : '') + " | ₹: " + ((data.item.firm.amount || 0).toLocaleString()))
                )}})],1)]}}],null,false,3601820041),model:{value:(_vm.currentTransfer.firm),callback:function ($$v) {_vm.$set(_vm.currentTransfer, "firm", $$v)},expression:"currentTransfer.firm"}}),_vm._v(" "),(
            _vm.currentTransfer.firm &&
            (_vm.currentTransfer.transferCategory == 'B2C' ||
              _vm.currentTransfer.transferCategory == 'B2B')
          )?_c('v-autocomplete',{attrs:{"items":_vm.banksByFirms,"flat":"","hide-no-data":"","hide-details":"","label":"From Account","clearable":""},on:{"change":_vm.checkForSameAccount},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n            "+_vm._s(((data.item.text) + "\n                          " + (data.item.account.bankName
                              ? " | " + data.item.account.bankName
                              : "") + "\n                          " + (data.item.account.accountType
                              ? " | " + data.item.account.accountType
                              : "") + "\n                          | ₹: " + ((
                            data.item.account.amount || 0
                          ).toLocaleString())))+"\n          ")]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(
                  ((data.item.text) + "\n                          " + (data.item.account.bankName
                              ? ' | ' + data.item.account.bankName
                              : '') + "\n                          " + (data.item.account.accountType
                              ? ' | ' + data.item.account.accountType
                              : '') + "\n                          | ₹: " + ((
                            data.item.account.amount || 0
                          ).toLocaleString()))
                )}})],1)]}}],null,false,3692651341),model:{value:(_vm.currentTransfer.bankFrom),callback:function ($$v) {_vm.$set(_vm.currentTransfer, "bankFrom", $$v)},expression:"currentTransfer.bankFrom"}}):_vm._e(),_vm._v(" "),(
            _vm.currentTransfer.firm &&
            (_vm.currentTransfer.transferCategory == 'C2B' ||
              _vm.currentTransfer.transferCategory == 'B2B')
          )?_c('v-autocomplete',{attrs:{"items":_vm.banksByFirms,"flat":"","hide-no-data":"","hide-details":"","label":"To Account","clearable":""},on:{"change":_vm.checkForSameAccount},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_vm._v("\n            "+_vm._s(((data.item.text) + "\n                          " + (data.item.account.bankName
                              ? " | " + data.item.account.bankName
                              : "") + "\n                          " + (data.item.account.accountType
                              ? " | " + data.item.account.accountType
                              : "") + "\n                          | ₹: " + ((
                            data.item.account.amount || 0
                          ).toLocaleString())))+"\n          ")]}},{key:"item",fn:function(data){return [_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(
                  ((data.item.text) + "\n                          " + (data.item.account.bankName
                              ? ' | ' + data.item.account.bankName
                              : '') + "\n                          " + (data.item.account.accountType
                              ? ' | ' + data.item.account.accountType
                              : '') + "\n                          | ₹: " + ((
                            data.item.account.amount || 0
                          ).toLocaleString()))
                )}})],1)]}}],null,false,3692651341),model:{value:(_vm.currentTransfer.bankTo),callback:function ($$v) {_vm.$set(_vm.currentTransfer, "bankTo", $$v)},expression:"currentTransfer.bankTo"}}):_vm._e(),_vm._v(" "),(_vm.currentTransfer.firm)?_c('v-text-field',{attrs:{"label":"Amount"},model:{value:(_vm.currentTransfer.amount),callback:function ($$v) {_vm.$set(_vm.currentTransfer, "amount", $$v)},expression:"currentTransfer.amount"}}):_vm._e(),_vm._v(" "),(
            _vm.currentTransfer.amount &&
            _vm.currentTransfer.transferCategory == 'C2B'
          )?_c('v-select',{attrs:{"items":[
            {
              text: 'Atm Deposit',
              value: 'Atm Deposit',
            },
            {
              text: 'Cash Counter',
              value: 'Cash Counter',
            } ],"label":"Deposit Via","required":""},model:{value:(_vm.currentTransfer.depositVia),callback:function ($$v) {_vm.$set(_vm.currentTransfer, "depositVia", $$v)},expression:"currentTransfer.depositVia"}}):_vm._e(),_vm._v(" "),(
            _vm.currentTransfer.amount &&
            _vm.currentTransfer.transferCategory == 'B2C'
          )?_c('v-select',{attrs:{"items":[
            {
              text: 'Atm Withdrawn',
              value: 'Atm',
            },
            {
              text: 'Cash Counter',
              value: 'Cash Counter',
            } ],"label":"withdrawn Via","required":""},model:{value:(_vm.currentTransfer.depositVia),callback:function ($$v) {_vm.$set(_vm.currentTransfer, "depositVia", $$v)},expression:"currentTransfer.depositVia"}}):_vm._e(),_vm._v(" "),(
            _vm.currentTransfer.amount &&
            _vm.currentTransfer.transferCategory == 'B2B'
          )?_c('v-select',{attrs:{"dense":"","items":[
            {
              text: 'Cheque',
              value: 'Cheque',
            },
            {
              text: 'NEFT',
              value: 'NEFT',
            },
            {
              text: 'RTGS',
              value: 'RTGS',
            },
            {
              text: 'IMPS',
              value: 'IMPS',
            } ],"label":"Select Transfer type"},model:{value:(_vm.currentTransfer.bankTransferType),callback:function ($$v) {_vm.$set(_vm.currentTransfer, "bankTransferType", $$v)},expression:"currentTransfer.bankTransferType"}}):_vm._e(),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Remark"},model:{value:(_vm.currentTransfer.remark),callback:function ($$v) {_vm.$set(_vm.currentTransfer, "remark", $$v)},expression:"currentTransfer.remark"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(!_vm.currentTransfer['.key'])?_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.saveTerms}},[_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("swap_horiz")]),_vm._v("Save\n        ")],1):_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.updateTransfer}},[_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("swap_horiz")]),_vm._v("Update\n        ")],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.transferDialog = false}}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v("cancel")]),_vm._v("Cancel\n        ")],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-snackbar',{attrs:{"top":"","color":"error","timeout":3000},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.snackbarText)+"\n  ")]),_vm._v(" "),_c('v-snackbar',{attrs:{"top":"","color":"success","timeout":3000},model:{value:(_vm.snackbarSuccess),callback:function ($$v) {_vm.snackbarSuccess=$$v},expression:"snackbarSuccess"}},[_vm._v("\n    "+_vm._s(_vm.snackbarSuccessText)+"\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShopSettings_vue__ = __webpack_require__(542);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac57b72e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShopSettings_vue__ = __webpack_require__(1617);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShopSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac57b72e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShopSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1613 */,
/* 1614 */,
/* 1615 */,
/* 1616 */,
/* 1617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"headline text-xs-center"},[_vm._v("\n          Shop Settings\n        ")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"label":("" + ('Shop Active: ' + (_vm.currentSettings.active ? 'YES' : 'NO')))},model:{value:(_vm.currentSettings.active),callback:function ($$v) {_vm.$set(_vm.currentSettings, "active", $$v)},expression:"currentSettings.active"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.firmsByBrand,"label":"Select Firm","item-text":"text","item-value":"value"},model:{value:(_vm.currentSettings.firm),callback:function ($$v) {_vm.$set(_vm.currentSettings, "firm", $$v)},expression:"currentSettings.firm"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('span',[_c('label',{staticClass:"title mat-raised-button",attrs:{"for":"filesLogo"}},[_c('span',{staticStyle:{"font-weight":"bold","color":"#2727b0"}},[_vm._v(_vm._s(_vm.currentSettings.logo
                        ? "Change Logo Image"
                        : "Upload Logo Image"))])]),_vm._v(" "),_c('input',{staticStyle:{"visibility":"hidden"},attrs:{"id":"filesLogo","accept":".png,.jpg","type":"file"},on:{"change":function($event){return _vm.uploadChangeLogo($event)}}})]),_vm._v(" "),(_vm.brandLogo)?_c('span',[_vm._v(_vm._s(_vm.brandLogo.name))]):_vm._e(),_vm._v(" "),(_vm.uploadValue != 0)?_c('span',[_vm._v(_vm._s(_vm.uploadValue)+"%")]):_vm._e()]),_vm._v(" "),(_vm.currentSettings.logo)?_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('img',{staticStyle:{"object-fit":"cover"},attrs:{"src":_vm.currentSettings.logo,"height":"250px","width":"250px"}})]):_vm._e(),_vm._v(" "),(_vm.currentSettings.firm)?_c('v-flex',{attrs:{"xs-12":""}},[_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){return _vm.addAllProds()}}},[_vm._v("RESET Product List")])],1):_vm._e(),_vm._v(" "),(_vm.currentSettings.firm)?_c('v-flex',{attrs:{"xs12":""}},[_vm._l((_vm.currentSettings.items),function(item,index){return [_c('v-layout',{key:index + item.productId + 'name',attrs:{"wrap":""}},[(item.orignal)?_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}},[_c('v-text-field',{attrs:{"disabled":true,"label":"Product Name","value":_vm.getProd(item.productId).name}})],1):_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}},[_c('v-select',{attrs:{"dense":"","item-text":"name","item-value":'name',"items":_vm.productsByFirm,"label":"Product Name"},on:{"change":function($event){return _vm.restructureProductList(index)}},model:{value:(item.productName),callback:function ($$v) {_vm.$set(item, "productName", $$v)},expression:"item.productName"}})],1),_vm._v(" "),(item.orignal)?_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}},[_c('v-text-field',{attrs:{"disabled":true,"label":"Unit","value":_vm.getProd(item.productId).unit}})],1):_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}},[(item.productName)?_c('v-select',{attrs:{"dense":"","item-text":"text","item-value":"value","items":_vm.units,"label":"Select unit","disabled":item.orignal},model:{value:(item.unit),callback:function ($$v) {_vm.$set(item, "unit", $$v)},expression:"item.unit"}}):_vm._e()],1),_vm._v(" "),(item.orignal)?_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}},[_c('v-text-field',{attrs:{"disabled":true,"label":"Rate (MRP)","value":_vm.getProd(item.productId).MRPRate}})],1):_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}},[(item.productName)?_c('v-text-field',{attrs:{"type":"number","label":"Rate (MRP)","disabled":item.orignal},model:{value:(item.MRPRate),callback:function ($$v) {_vm.$set(item, "MRPRate", _vm._n($$v))},expression:"item.MRPRate"}}):_vm._e()],1),_vm._v(" "),(item.orignal)?_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}},[_c('v-text-field',{attrs:{"disabled":true,"label":"Rate After Discount","value":_vm.getProd(item.productId).sellingPrice}})],1):_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}},[(item.productName)?_c('v-text-field',{attrs:{"type":"number","disabled":item.orignal,"label":"Rate After Discount"},model:{value:(item.rate),callback:function ($$v) {_vm.$set(item, "rate", _vm._n($$v))},expression:"item.rate"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}},[(item.image.documentName)?_c('a',{on:{"click":function($event){return _vm.downloadURI(item.image.filePath, item.image.documentName)}}},[_vm._v(_vm._s(item.image.documentName))]):_vm._e(),_vm._v(" "),_c('label',{staticClass:"title mat-raised-button",attrs:{"for":'prod-image' + index}},[(item.image.filePath)?_c('v-icon',{attrs:{"large":"","color":"primary"}},[_vm._v("\n                            mode\n                          ")]):_c('v-icon',{attrs:{"large":"","color":"primary"}},[_vm._v("\n                            file_upload\n                          ")])],1),_vm._v(" "),_c('input',{staticStyle:{"visibility":"hidden","width":"5px"},attrs:{"id":'prod-image' + index,"type":"file"},on:{"change":function($event){return _vm.uploadChangeProduct($event, item.image, index)}}})]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":"","sm2":"","md2":""}},[(
                          index == _vm.currentSettings.items.length - 1 &&
                          (item.productName || item.productId)
                        )?_c('v-btn',{attrs:{"icon":"","color":"primary"},on:{"click":function($event){return _vm.addProd()}}},[_c('v-icon',[_vm._v("add_circle")])],1):(item.productName || item.productId)?_c('v-btn',{attrs:{"icon":"","color":"primary"},on:{"click":function($event){return _vm.removeProd(index)}}},[_c('v-icon',[_vm._v("cancel")])],1):_vm._e()],1)],1)]})],2):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(!_vm.currentSettings['.key'])?_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":_vm.uploadAndSave}},[_vm._v("Save")]):_vm._e(),_vm._v(" "),(!!_vm.currentSettings['.key'])?_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":_vm.uploadAndSave}},[_vm._v("Update")]):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":3000},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n  Shop Settings updated!\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Infrastructure_vue__ = __webpack_require__(543);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69699ec8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Infrastructure_vue__ = __webpack_require__(1619);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Infrastructure_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69699ec8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Infrastructure_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"headline text-xs-center"},[_vm._v("\n          Properties & Infrastructures\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{staticClass:"white--text",attrs:{"outline":"","large":""},on:{"click":_vm.addSettings}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v(" add ")]),_vm._v("\n            NEW\n          ")],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.settingsListHeader,"items":_vm.settingsListByBrand,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',[_vm._v(_vm._s(_vm.getFirmName(props.item.firm)))])]),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.editSetting(props.item)}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteSetting(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"1000px"},model:{value:(_vm.addSettingsDialog),callback:function ($$v) {_vm.addSettingsDialog=$$v},expression:"addSettingsDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Settings")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.addSettingsDialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[(!_vm.currentSettings['.key'])?_c('v-select',{attrs:{"dense":"","items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.currentSettings.firm),callback:function ($$v) {_vm.$set(_vm.currentSettings, "firm", $$v)},expression:"currentSettings.firm"}}):_c('v-text-field',{attrs:{"dense":"","value":_vm.getFirmName(_vm.currentSettings.firm),"disabled":true,"label":"Select Firm"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_vm._l((_vm.currentSettings.floorDetails),function(floor,index){return [_c('v-layout',{key:'floor' + index,attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-text-field',{key:index + 'fee',staticStyle:{"margin-top":"10px"},attrs:{"label":'Name of floor Number : ' + (index + 1)},model:{value:(floor.name),callback:function ($$v) {_vm.$set(floor, "name", $$v)},expression:"floor.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},_vm._l((floor.tables),function(room,index1){return _c('v-layout',{key:'room' + index + '_' + index1,staticStyle:{"padding":"0 45px"},attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md4":""}},[_c('v-text-field',{attrs:{"label":index1+1 + '. Table - Name/Number',"type":"text"},model:{value:(room.name),callback:function ($$v) {_vm.$set(room, "name", $$v)},expression:"room.name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md4":""}},[_c('v-text-field',{attrs:{"type":"Number","label":"Table Capacity"},model:{value:(room.capacity),callback:function ($$v) {_vm.$set(room, "capacity", $$v)},expression:"room.capacity"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm12":"","md4":""}},[(index1 == floor.tables.length - 1)?_c('v-btn',{attrs:{"icon":"","color":"primary"},on:{"click":function($event){return _vm.addTables(index, index1)}}},[_c('v-icon',[_vm._v("add_circle")])],1):_c('v-btn',{attrs:{"icon":"","color":"primary"},on:{"click":function($event){return _vm.removeTables(index, index1)}}},[_c('v-icon',[_vm._v("cancel")])],1)],1)],1)}),1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[(index == _vm.currentSettings.floorDetails.length - 1)?_c('v-btn',{attrs:{"icon":"","color":"primary"},on:{"click":function($event){return _vm.addFloor(index)}}},[_c('v-icon',[_vm._v("add_circle")])],1):(index != 0)?_c('v-btn',{attrs:{"icon":"","color":"primary"},on:{"click":function($event){return _vm.removeFloor(index)}}},[_c('v-icon',[_vm._v("cancel")])],1):_vm._e()],1)],1)]})],2)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(!_vm.currentSettings['.key'])?_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":_vm.saveSettings}},[_vm._v("Save")]):_vm._e(),_vm._v(" "),(!!_vm.currentSettings['.key'])?_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":_vm.updateSettings}},[_vm._v("Update")]):_vm._e()],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BulkTransfer_vue__ = __webpack_require__(544);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb3d4c12_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BulkTransfer_vue__ = __webpack_require__(1621);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BulkTransfer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb3d4c12_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BulkTransfer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"white primary--text"},[_c('v-toolbar-title',{staticClass:"headline text-xs-center"},[_vm._v("\n          Bulk Transfer\n        ")]),_vm._v(" "),_c('v-radio-group',{staticStyle:{"flex":"unset","margin-left":"10px","padding-top":"25px"},attrs:{"row":""},model:{value:(_vm.transferType),callback:function ($$v) {_vm.transferType=$$v},expression:"transferType"}},[_c('v-radio',{staticClass:"font-weight-bold",attrs:{"label":"Product -To- Godown","value":"P2G"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Godawn -To- Godown","value":"G2G"}})],1),_vm._v(" "),_c('v-menu',{staticStyle:{"margin-left":"10px"},attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerTransfer),callback:function ($$v) {_vm.datepickerTransfer=$$v},expression:"datepickerTransfer"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Transfer Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.transferDate),callback:function ($$v) {_vm.transferDate=$$v},expression:"transferDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerTransfer = false}},model:{value:(_vm.transferDate),callback:function ($$v) {_vm.transferDate=$$v},expression:"transferDate"}})],1),_vm._v(" "),_c('v-select',{staticStyle:{"margin-left":"10px"},attrs:{"items":_vm.godawns,"item-text":"godawnName","return-object":"","label":_vm.transferType == 'P2G' ? 'Selected Godown' : 'Select Godown From'},model:{value:(_vm.selectedGodownFrom),callback:function ($$v) {_vm.selectedGodownFrom=$$v},expression:"selectedGodownFrom"}}),_vm._v(" "),(_vm.transferType == 'G2G')?_c('v-select',{staticStyle:{"margin-left":"10px"},attrs:{"items":_vm.godawns,"label":"Select Godown To","item-text":"godawnName"},model:{value:(_vm.selectedGodownTo),callback:function ($$v) {_vm.selectedGodownTo=$$v},expression:"selectedGodownTo"}}):_vm._e()],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(
          _vm.transferType == 'P2G'
            ? _vm.selectedGodownFrom
            : _vm.selectedGodownFrom && _vm.selectedGodownTo
        )?_c('v-btn',{staticStyle:{"float":"right"},attrs:{"color":"blue darken-1","return-object":"","flat":""},on:{"click":function($event){return _vm.transfer()}}},[_vm._v("Transfer")]):_vm._e(),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.productsHeader,"items":_vm.products,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',[_vm._v(_vm._s(props.item.name)+" ")])]),_vm._v(" "),_c('td',[_c('v-text-field',{attrs:{"type":"number","label":"Transfer Quantity"},model:{value:(props.item.transferQuantity),callback:function ($$v) {_vm.$set(props.item, "transferQuantity", $$v)},expression:"props.item.transferQuantity"}})],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":3000},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    Transfer Successfully\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImportFromExcel_vue__ = __webpack_require__(545);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0978d81a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImportFromExcel_vue__ = __webpack_require__(1623);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImportFromExcel_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0978d81a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImportFromExcel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"text-xs-center"},[_vm._v("\n          Import Products\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('a',{staticStyle:{"display":"none"},attrs:{"id":"xlsxfile","href":"/static/files/acuify-bulk-import.xlsx","download":""}},[_vm._v("www")]),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"color":"primary","outlined":"","large":""},on:{"click":function($event){return _vm.downloadFile()}}},[_c('v-icon',{attrs:{"left":"","dark":""}},[_vm._v(" download_for_offline ")]),_vm._v("\n            Download Template\n          ")],1)],1)],1),_vm._v(" "),_c('v-card',[(_vm.selectedBrand)?_c('v-card-text',{staticStyle:{"min-height":"500px","padding":"20% 35%"}},[_c('v-select',{attrs:{"item-text":"name","return-object":"","items":_vm.firmsByBrand,"label":"Select Firms"},model:{value:(_vm.currentFirm),callback:function ($$v) {_vm.currentFirm=$$v},expression:"currentFirm"}}),_vm._v(" "),_c('input',{attrs:{"type":"file","disabled":!_vm.currentFirm},on:{"change":function($event){return _vm.dataImport($event)}}})],1):_vm._e(),_vm._v(" "),_c('v-snackbar',{scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attrs = ref.attrs;
return [_c('v-btn',_vm._b({attrs:{"color":"pink","text":""},on:{"click":function($event){_vm.snackbar = false}}},'v-btn',attrs,false),[_vm._v("\n              Close\n            ")])]}}]),model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n          Product Data imported Successfully\n\n          ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImportCustomerFromExcel_vue__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImportCustomerFromExcel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImportCustomerFromExcel_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a3a5947_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImportCustomerFromExcel_vue__ = __webpack_require__(1625);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImportCustomerFromExcel_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a3a5947_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImportCustomerFromExcel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"text-xs-center"},[_vm._v("\n          Customer Import\n        ")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card',[_c('v-card-text',{staticStyle:{"min-height":"500px","padding":"20% 35%"}},[_c('h1',[_vm._v("\n                  Work In Progress !!\n                  Soon you will be able to Import Customers.\n              ")])])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImportSupplierFromExcel_vue__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImportSupplierFromExcel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImportSupplierFromExcel_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5127f6cb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImportSupplierFromExcel_vue__ = __webpack_require__(1627);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ImportSupplierFromExcel_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5127f6cb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ImportSupplierFromExcel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"text-xs-center"},[_vm._v("\n          Supplier Import\n        ")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card',[_c('v-card-text',{staticStyle:{"min-height":"500px","padding":"20% 35%"}},[_c('h1',[_vm._v("\n                  Work In Progress !!\n                  Soon you will be able to Import Suppliers. \n              ")])])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductManufacturing_vue__ = __webpack_require__(548);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ab632e5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductManufacturing_vue__ = __webpack_require__(1629);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductManufacturing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ab632e5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductManufacturing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-cotainer',{attrs:{"fluid":"","grid-list-md":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"headline text-xs-center"},[_vm._v("\n          Product Manufacturing\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"outlined":""},on:{"click":function($event){return _vm.addMenufacturing()}}},[_c('v-icon',{attrs:{"left":"","color":"teal"}},[_vm._v("add")]),_vm._v("\n          New Item\n        ")],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.manufHeader,"items":_vm.productMenufsList,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',[_vm._v(_vm._s(_vm.getProductName(props.item.productId)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(new Date(props.item["date"]).toLocaleDateString("en-GB")))])]),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.edit(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("edit")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteMenuf(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"1000px"},model:{value:(_vm.menufDialog),callback:function ($$v) {_vm.menufDialog=$$v},expression:"menufDialog"}},[(_vm.currentMenuf)?_c('v-card',{attrs:{"persistent":""}},[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Manufacture Product")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datePicker),callback:function ($$v) {_vm.datePicker=$$v},expression:"datePicker"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.currentMenuf.date),callback:function ($$v) {_vm.$set(_vm.currentMenuf, "date", $$v)},expression:"currentMenuf.date"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datePicker = false}},model:{value:(_vm.currentMenuf.date),callback:function ($$v) {_vm.$set(_vm.currentMenuf, "date", $$v)},expression:"currentMenuf.date"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-select',{attrs:{"dense":"","autocomplete":"","items":_vm.productsByBrand,"label":"Result Product"},model:{value:(_vm.currentMenuf.productId),callback:function ($$v) {_vm.$set(_vm.currentMenuf, "productId", $$v)},expression:"currentMenuf.productId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Quantity"},model:{value:(_vm.currentMenuf.quantity),callback:function ($$v) {_vm.$set(_vm.currentMenuf, "quantity", _vm._n($$v))},expression:"currentMenuf.quantity"}})],1)],1),_vm._v(" "),_vm._l((_vm.currentMenuf.rawMaterials),function(item,index){return _c('v-layout',{key:index + 'a',attrs:{"wrap":""}},[_c('v-flex',{staticStyle:{"display":"inline-flex"},attrs:{"xs4":"","sm4":"","md4":""}},[_c('v-select',{attrs:{"dense":"","autocomplete":"","items":_vm.productsByBrand,"label":"Raw Product"},model:{value:(item.productId),callback:function ($$v) {_vm.$set(item, "productId", $$v)},expression:"item.productId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":"","sm4":"","md4":""}},[(item.productId)?_c('v-text-field',{attrs:{"type":"number","label":"Quantity"},model:{value:(item.quantity),callback:function ($$v) {_vm.$set(item, "quantity", _vm._n($$v))},expression:"item.quantity"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{key:index + item.productId + 'add',attrs:{"xs4":"","sm4":"","md4":""}},[(
                  index == _vm.currentMenuf.rawMaterials.length - 1 &&
                  item.productId
                )?_c('v-btn',{attrs:{"icon":"","color":"primary"},on:{"click":function($event){return _vm.addProd()}}},[_c('v-icon',[_vm._v("add_circle")])],1):_vm._e(),_vm._v(" "),(index != 0 && item.productId)?_c('v-btn',{attrs:{"icon":"","color":"primary"},on:{"click":function($event){return _vm.removeProd(index)}}},[_c('v-icon',[_vm._v("cancel")])],1):_vm._e()],1)],1)})],2)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){_vm.menufDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),(_vm.currentMenuf['.key'])?_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){return _vm.update()}}},[_vm._v("Update")]):_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){return _vm.save()}}},[_vm._v("Create")])],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductDamage_vue__ = __webpack_require__(549);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70c0b948_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductDamage_vue__ = __webpack_require__(1631);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductDamage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70c0b948_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductDamage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-cotainer',{attrs:{"fluid":"","grid-list-md":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"headline text-xs-center"},[_vm._v("\n          Product Damage\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"outlined":""},on:{"click":function($event){return _vm.addDamage()}}},[_c('v-icon',{attrs:{"left":"","color":"teal"}},[_vm._v("add")]),_vm._v("\n          New Item\n        ")],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.manufHeader,"items":_vm.productMenufsList,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',[_vm._v(_vm._s(_vm.getProductName(props.item.productId)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(new Date(props.item["date"]).toLocaleDateString("en-GB")))])]),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.edit(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("edit")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deleteMenuf(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"1000px"},model:{value:(_vm.menufDialog),callback:function ($$v) {_vm.menufDialog=$$v},expression:"menufDialog"}},[(_vm.currentMenuf)?_c('v-card',{attrs:{"persistent":""}},[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Damage Product")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datePicker),callback:function ($$v) {_vm.datePicker=$$v},expression:"datePicker"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.currentMenuf.date),callback:function ($$v) {_vm.$set(_vm.currentMenuf, "date", $$v)},expression:"currentMenuf.date"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datePicker = false}},model:{value:(_vm.currentMenuf.date),callback:function ($$v) {_vm.$set(_vm.currentMenuf, "date", $$v)},expression:"currentMenuf.date"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-select',{attrs:{"dense":"","autocomplete":"","items":_vm.productsByBrand,"label":"Product"},model:{value:(_vm.currentMenuf.productId),callback:function ($$v) {_vm.$set(_vm.currentMenuf, "productId", $$v)},expression:"currentMenuf.productId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Quantity"},model:{value:(_vm.currentMenuf.quantity),callback:function ($$v) {_vm.$set(_vm.currentMenuf, "quantity", _vm._n($$v))},expression:"currentMenuf.quantity"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){_vm.menufDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),(_vm.currentMenuf['.key'])?_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){return _vm.update()}}},[_vm._v("Update")]):_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){return _vm.save()}}},[_vm._v("Create")])],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductRepair_vue__ = __webpack_require__(550);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_666ecd20_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductRepair_vue__ = __webpack_require__(1633);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductRepair_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_666ecd20_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductRepair_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-cotainer',{attrs:{"fluid":"","grid-list-md":"","fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"headline text-xs-center"},[_vm._v("\n          Product Repair\n        ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"outlined":""},on:{"click":function($event){return _vm.addDamage()}}},[_c('v-icon',{attrs:{"left":"","color":"teal"}},[_vm._v("add")]),_vm._v("\n          New Item\n        ")],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.manufHeader,"items":_vm.productMenufsList,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',[_vm._v(_vm._s(_vm.getProductName(props.item.productId)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.getCustomerName(props.item.buyerId)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(new Date(props.item["date"]).toLocaleDateString("en-GB")))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.status))])]),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.edit(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("edit")])],1)],1),_vm._v(" "),_c('td',[_c('v-btn',{staticClass:"mx-0",attrs:{"icon":""},on:{"click":function($event){return _vm.deletefinal(props.item)}}},[_c('v-icon',{attrs:{"color":"pink"}},[_vm._v("delete")])],1)],1)]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"1000px"},model:{value:(_vm.menufDialog),callback:function ($$v) {_vm.menufDialog=$$v},expression:"menufDialog"}},[(_vm.currentMenuf)?_c('v-card',{attrs:{"persistent":""}},[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Damage Product")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-switch',{attrs:{"label":("" + (_vm.currentMenuf.isBuyer ? 'Sale Order' : 'Purchase Order'))},model:{value:(_vm.currentMenuf.isBuyer),callback:function ($$v) {_vm.$set(_vm.currentMenuf, "isBuyer", $$v)},expression:"currentMenuf.isBuyer"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-select',{attrs:{"items":_vm.currentMenuf.isBuyer ? _vm.buyersByBrand : _vm.sellersByBrand,"label":_vm.currentMenuf.isBuyer
                    ? 'Select or add Buyer'
                    : 'Select or add Seller',"autocomplete":"","item-text":'text',"item-value":'value'},model:{value:(_vm.currentMenuf.buyerId),callback:function ($$v) {_vm.$set(_vm.currentMenuf, "buyerId", $$v)},expression:"currentMenuf.buyerId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datePicker),callback:function ($$v) {_vm.datePicker=$$v},expression:"datePicker"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.currentMenuf.date),callback:function ($$v) {_vm.$set(_vm.currentMenuf, "date", $$v)},expression:"currentMenuf.date"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datePicker = false}},model:{value:(_vm.currentMenuf.date),callback:function ($$v) {_vm.$set(_vm.currentMenuf, "date", $$v)},expression:"currentMenuf.date"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-select',{attrs:{"dense":"","autocomplete":"","items":_vm.productsByBrand,"label":"Product"},model:{value:(_vm.currentMenuf.productId),callback:function ($$v) {_vm.$set(_vm.currentMenuf, "productId", $$v)},expression:"currentMenuf.productId"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-text-field',{attrs:{"type":"number","label":"Quantity"},model:{value:(_vm.currentMenuf.quantity),callback:function ($$v) {_vm.$set(_vm.currentMenuf, "quantity", _vm._n($$v))},expression:"currentMenuf.quantity"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-radio-group',{key:'deposite-amount-total',attrs:{"row":""},model:{value:(_vm.currentMenuf.status),callback:function ($$v) {_vm.$set(_vm.currentMenuf, "status", $$v)},expression:"currentMenuf.status"}},[_c('v-radio',{attrs:{"label":"Pending","value":"Pending"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Completed","value":"Completed"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Not Completed","value":"Not Completed"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-textarea',{attrs:{"name":"input-7-1","outlined":"","label":"Remark"},model:{value:(_vm.currentMenuf.remark),callback:function ($$v) {_vm.$set(_vm.currentMenuf, "remark", $$v)},expression:"currentMenuf.remark"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){_vm.menufDialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),(_vm.currentMenuf['.key'])?_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){return _vm.updateFinal()}}},[_vm._v("Update")]):_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":function($event){return _vm.saveFinal()}}},[_vm._v("Create")])],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderSettings_vue__ = __webpack_require__(551);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7e4e00a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSettings_vue__ = __webpack_require__(1635);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a7e4e00a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"headline text-xs-center"},[_vm._v("\n          Order Management\n        ")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"label":("" + ('Show Order Time: ' +
                      (_vm.currentSettings.isOrderTime ? 'YES' : 'NO')))},model:{value:(_vm.currentSettings.isOrderTime),callback:function ($$v) {_vm.$set(_vm.currentSettings, "isOrderTime", $$v)},expression:"currentSettings.isOrderTime"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"label":("" + ('Show Staff Selection: ' +
                      (_vm.currentSettings.isStaffSelection ? 'YES' : 'NO')))},model:{value:(_vm.currentSettings.isStaffSelection),callback:function ($$v) {_vm.$set(_vm.currentSettings, "isStaffSelection", $$v)},expression:"currentSettings.isStaffSelection"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(!_vm.currentSettings['.key'])?_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":_vm.update}},[_vm._v("Save")]):_vm._e(),_vm._v(" "),(!!_vm.currentSettings['.key'])?_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":_vm.update}},[_vm._v("Update")]):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":3000},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n  Shop Settings updated!\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LeadSettings_vue__ = __webpack_require__(552);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81ae2ab2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LeadSettings_vue__ = __webpack_require__(1637);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LeadSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81ae2ab2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LeadSettings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"headline text-xs-center"},[_vm._v("\n          Lead Management\n        ")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"label":("" + ('Show Lead Time: ' +
                      (_vm.currentSettings.isLeadTime ? 'YES' : 'NO')))},model:{value:(_vm.currentSettings.isLeadTime),callback:function ($$v) {_vm.$set(_vm.currentSettings, "isLeadTime", $$v)},expression:"currentSettings.isLeadTime"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md6":""}},[_c('v-switch',{attrs:{"label":("" + ('Show Staff Selection: ' +
                      (_vm.currentSettings.isStaffSelection ? 'YES' : 'NO')))},model:{value:(_vm.currentSettings.isStaffSelection),callback:function ($$v) {_vm.$set(_vm.currentSettings, "isStaffSelection", $$v)},expression:"currentSettings.isStaffSelection"}})],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(!_vm.currentSettings['.key'])?_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":_vm.update}},[_vm._v("Save")]):_vm._e(),_vm._v(" "),(!!_vm.currentSettings['.key'])?_c('v-btn',{attrs:{"color":"blue darken-1","flat":""},on:{"click":_vm.update}},[_vm._v("Update")]):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":3000},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n  Shop Settings updated!\n  ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ViewInvoice = function ViewInvoice() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1751));
};

/* harmony default export */ __webpack_exports__["a"] = ([{
  name: 'ViewInvoice',
  path: 'viewinvoice',
  component: ViewInvoice,
  meta: { requiresAuth: true }
}]);

/***/ }),
/* 1639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PermissionDenied_vue__ = __webpack_require__(553);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_408c6e32_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PermissionDenied_vue__ = __webpack_require__(1640);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PermissionDenied_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_408c6e32_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PermissionDenied_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","text-xs-center":"","fluid":""}},[_c('h3',{staticStyle:{"text-align":"center"}},[_c('v-icon',{staticClass:"primary--text",staticStyle:{"margin-top":"10%","font-size":"128px"},attrs:{"dark":"","left":""}},[_vm._v("warning")])],1),_vm._v(" "),_c('h3',{staticStyle:{"text-align":"center"}},[_vm._v("\n    You Don't have Permission to view this page.\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(1642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(1643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getters__ = __webpack_require__(1644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__initialState__ = __webpack_require__(1645);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: Object(__WEBPACK_IMPORTED_MODULE_3__initialState__["a" /* default */])(),
  mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
  getters: __WEBPACK_IMPORTED_MODULE_2__getters__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */]
});

/***/ }),
/* 1642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(555);



var _this = this;



/* harmony default export */ __webpack_exports__["a"] = ({
  SET_CUSTOMER: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2, payload) {
      var commit = _ref2.commit;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit(__WEBPACK_IMPORTED_MODULE_2__types__["a" /* SET_CUSTOMER */], payload);

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function SET_CUSTOMER(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(),
  SET_SELECTED_CUSTOMER: function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4, payload) {
      var commit = _ref4.commit;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit(__WEBPACK_IMPORTED_MODULE_2__types__["b" /* SET_SELECTED_CUSTOMER */], payload);

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function SET_SELECTED_CUSTOMER(_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }()
});

/***/ }),
/* 1643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(555);


var _Types$SET_CUSTOMER$T;



/* harmony default export */ __webpack_exports__["a"] = (_Types$SET_CUSTOMER$T = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Types$SET_CUSTOMER$T, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* SET_CUSTOMER */], function (state, payload) {
  state.buyer = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Types$SET_CUSTOMER$T, __WEBPACK_IMPORTED_MODULE_1__types__["b" /* SET_SELECTED_CUSTOMER */], function (state, payload) {
  state.selectedBuyer = payload;
}), _Types$SET_CUSTOMER$T);

/***/ }),
/* 1644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  getFilter: function getFilter(state) {
    return state.filter;
  },
  selectedBuyer: function selectedBuyer(state) {
    return state.selectedBuyer;
  }
});

/***/ }),
/* 1645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  return {
    buyer: [],
    selectedBuyer: null
  };
});

/***/ }),
/* 1646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(1647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getters__ = __webpack_require__(1648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mutations__ = __webpack_require__(1649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__initialState__ = __webpack_require__(1650);





/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  state: Object(__WEBPACK_IMPORTED_MODULE_3__initialState__["a" /* default */])(),
  getters: __WEBPACK_IMPORTED_MODULE_1__getters__["a" /* default */],
  actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_2__mutations__["a" /* default */]
});

/***/ }),
/* 1647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(556);



var _this = this;



/* harmony default export */ __webpack_exports__["a"] = ({
  SET_BRANDS: function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(_ref2, payload) {
      var commit = _ref2.commit;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit(__WEBPACK_IMPORTED_MODULE_2__types__["b" /* SET_BRANDS */], payload);

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function SET_BRANDS(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(),
  SET_SELECTED_BRAND: function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(_ref4, payload) {
      var commit = _ref4.commit;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit(__WEBPACK_IMPORTED_MODULE_2__types__["f" /* SET_SELECTED_BRAND */], payload);

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function SET_SELECTED_BRAND(_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }(),
  SET_BRAND_FIN_YEAR: function () {
    var _ref5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(_ref6, payload) {
      var commit = _ref6.commit;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit(__WEBPACK_IMPORTED_MODULE_2__types__["c" /* SET_BRAND_FIN_YEAR */], payload);

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this);
    }));

    return function SET_BRAND_FIN_YEAR(_x5, _x6) {
      return _ref5.apply(this, arguments);
    };
  }(),
  SET_ADMIN_EMAIL: function () {
    var _ref7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(_ref8, payload) {
      var commit = _ref8.commit;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              commit(__WEBPACK_IMPORTED_MODULE_2__types__["a" /* SET_ADMIN_EMAIL */], payload);

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this);
    }));

    return function SET_ADMIN_EMAIL(_x7, _x8) {
      return _ref7.apply(this, arguments);
    };
  }(),
  SET_FIN_YEAR: function () {
    var _ref9 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(_ref10, payload) {
      var commit = _ref10.commit;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              commit(__WEBPACK_IMPORTED_MODULE_2__types__["d" /* SET_FIN_YEAR */], payload);

            case 1:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this);
    }));

    return function SET_FIN_YEAR(_x9, _x10) {
      return _ref9.apply(this, arguments);
    };
  }(),
  SET_ROLE_AND_PERMISSIONS: function () {
    var _ref11 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(_ref12, payload) {
      var commit = _ref12.commit;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              commit(__WEBPACK_IMPORTED_MODULE_2__types__["e" /* SET_ROLE_AND_PERMISSIONS */], payload);

            case 1:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this);
    }));

    return function SET_ROLE_AND_PERMISSIONS(_x11, _x12) {
      return _ref11.apply(this, arguments);
    };
  }()
});

/***/ }),
/* 1648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  getFilter: function getFilter(state) {
    return state.filter;
  },
  relationshipType: function relationshipType(state) {
    return state.relationshipType;
  },
  casteType: function casteType(state) {
    return state.casteType;
  },
  identityType: function identityType(state) {
    return state.identityType;
  },
  village: function village(state) {
    return state.village;
  },
  block: function block(state) {
    return state.block;
  },
  tehsil: function tehsil(state) {
    return state.tehsil;
  },
  district: function district(state) {
    return state.district;
  },
  state: function state(_state) {
    return _state.state;
  },
  country: function country(state) {
    return state.country;
  },
  brands: function brands(state) {
    return state.brands;
  },
  gender: function gender(state) {
    return state.gender;
  },
  marital: function marital(state) {
    return state.marital;
  },
  selectedBrand: function selectedBrand(state) {
    return state.selectedBrand;
  },
  brandFinYear: function brandFinYear(state) {
    return state.brandFinYear;
  },
  GST_Type: function GST_Type(state) {
    return state.GST_Type;
  },
  firmType: function firmType(state) {
    return state.firmType;
  },
  purchaseType: function purchaseType(state) {
    return state.purchaseType;
  },
  productUnit: function productUnit(state) {
    return state.productUnit;
  },
  adminEmail: function adminEmail(state) {
    return state.adminEmail;
  },
  finYear: function finYear(state) {
    return state.finYear;
  },
  roleAndPermission: function roleAndPermission(state) {
    return state.roleAndPermission;
  },
  brandPackageTypes: function brandPackageTypes(state) {
    return state.brandPackageTypes;
  },
  stockReportTypes: function stockReportTypes(state) {
    return state.stockReportTypes;
  }
});

/***/ }),
/* 1649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(556);


var _Types$SET_BRANDS$Typ;



/* harmony default export */ __webpack_exports__["a"] = (_Types$SET_BRANDS$Typ = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Types$SET_BRANDS$Typ, __WEBPACK_IMPORTED_MODULE_1__types__["b" /* SET_BRANDS */], function (state, payload) {
  state.brands = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Types$SET_BRANDS$Typ, __WEBPACK_IMPORTED_MODULE_1__types__["f" /* SET_SELECTED_BRAND */], function (state, payload) {
  state.selectedBrand = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Types$SET_BRANDS$Typ, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* SET_ADMIN_EMAIL */], function (state, payload) {
  state.adminEmail = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Types$SET_BRANDS$Typ, __WEBPACK_IMPORTED_MODULE_1__types__["d" /* SET_FIN_YEAR */], function (state, payload) {
  state.finYear = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Types$SET_BRANDS$Typ, __WEBPACK_IMPORTED_MODULE_1__types__["e" /* SET_ROLE_AND_PERMISSIONS */], function (state, payload) {
  state.roleAndPermission = payload;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_Types$SET_BRANDS$Typ, __WEBPACK_IMPORTED_MODULE_1__types__["c" /* SET_BRAND_FIN_YEAR */], function (state, payload) {
  state.brandFinYear = payload;
}), _Types$SET_BRANDS$Typ);

/***/ }),
/* 1650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  return {
    identityType: ['Adhaar ID', 'Voter ID', 'Driving License', 'Pan Card', 'Samagra Id'],
    // financialYear: [
    //   '2017-2018',
    //   '2018-2019',
    //   '2019-2020',
    //   '2020-2021',
    //   '2021-2022'
    // ],
    casteType: ['2017-2018', '2018-2019', '2019-2020', '2020-2021', '2021-2022'],
    // casteType: [
    //   'General',
    //   'Other Backward Class/OBC',
    //   'Schedule Caste/SC',
    //   'Schedule Tribe/ST',
    //   'NOT TO DISCLOSE'
    // ],
    relationshipType: ['SON/OF', 'DAUGHTER/0F', 'WIFE/0F', 'HUSBAND/0F', 'CARE/OF'],
    productUnit: [{
      text: "Bags",
      value: "Bags"
    }, {
      text: "Bale",
      value: "Bale"
    }, {
      text: "Buckets",
      value: "Buckets"
    }, {
      text: "Buckles",
      value: "BuckleS"
    }, {
      text: "Bundles",
      value: "Bundles"
    }, {
      text: "BOU",
      value: "Billion of Units"
    }, {
      text: "Box",
      value: "Box"
    }, {
      text: "Can",
      value: "Can"
    }, {
      text: "CBM",
      value: "Cubic Meter"
    }, {
      text: "CCM",
      value: "Cubic Centimeter"
    }, {
      text: "CMS",
      value: "Centimeter"
    }, {
      text: "CTN",
      value: "Cartoons"
    }, {
      text: "DOZ",
      value: "Dozens"
    }, {
      text: "DRM",
      value: "Drums"
    }, {
      text: "DZN",
      value: "Dozens"
    }, {
      text: "FTS",
      value: "Feet"
    }, {
      text: "GAL",
      value: "Gallon"
    }, {
      text: "GGK",
      value: "Great Gross"
    }, {
      text: "GMS",
      value: "Gram"
    }, {
      text: "GRS",
      value: "Gross"
    }, {
      text: "GYD",
      value: "Gross Yards"
    }, {
      text: "JAR",
      value: "Jar"
    }, {
      text: "KGS",
      value: "Kilogram"
    }, {
      text: "KLR",
      value: "Kiloliter"
    }, {
      text: "KME",
      value: "Kilometer"
    }, {
      text: "LTR",
      value: "Liter"
    }, {
      text: "MLT",
      value: "Mililiter"
    }, {
      text: "MTR",
      value: "Meter"
    }, {
      text: "MTS",
      value: "Metric Tons"
    }, {
      text: "NOS",
      value: "Numbers"
    }, {
      text: "PAC",
      value: "Packs"
    }, {
      text: "Pieces",
      value: "Pieces"
    }, {
      text: "PRS",
      value: "Pairs"
    }, {
      text: "QTL",
      value: "Quintal"
    }, {
      text: "ROL",
      value: "Rolls"
    }, {
      text: "SET",
      value: "Sets"
    }, {
      text: "SQF",
      value: "SquareFeet"
    }, {
      text: "SQM",
      value: "SquareMeter"
    }, {
      text: "SQY",
      value: "SquareYards"
    }, {
      text: "Stripe",
      value: "Stripe"
    }, {
      text: "TBS",
      value: "Tablets"
    }, {
      text: "TGM",
      value: "TenGross"
    }, {
      text: "THD",
      value: "Thousands"
    }, {
      text: "TIN",
      value: "Tin"
    }, {
      text: "TON",
      value: "Tonnes"
    }, {
      text: "TUB",
      value: "Tubes"
    }, {
      text: "UGS",
      value: "US Gallons"
    }, {
      text: "UNT",
      value: "Units"
    }, {
      text: "YDS",
      value: "Yards"
    }, {
      text: "OTH",
      value: "Others"
    }],

    village: ['Amoda', 'Attaisa', 'Bamhori', 'BarhyaBada', 'banwari', 'Baskheda', 'Bhainsa', 'Bhatera', 'Chadon', 'Dhana', 'Jiriya', 'Kamti', 'khakariya', 'Khakariyakheda/guzar-kheda', 'Kheri', 'Paloha', 'Panagar', 'Sadumar', 'Sasbahu', 'Supari', 'Tekapar', 'Thareri', 'Udni Pipariya', 'Utni'],
    block: ['Saikheda', 'Chirahkala', 'Banwari', 'Salichouka', 'Chichli', 'Bohani', 'Kodiya', 'Sehora'],
    tehsil: ['Babai', 'Bankhedi', 'Bareli', 'Begumganj', 'Gadarwara', 'Gairatganj', 'Goharganj', 'Gotegao', 'Hoshangabad', 'Itarsi', 'Kareli', 'Narsinghpur', 'Pipariya', 'Raisen', 'Tendukheda', 'Seoni-Malwa', 'Silwani', 'Sohagpur', 'Udaipura'],
    district: ['Agar Malwa', 'Alirajpur', 'Anuppur', 'Ashoknagar', 'Balaghat', 'Barwani', 'Betul', 'Bhind', 'Bhopal', 'Chatarpur', 'Chindwara', 'Damoh', 'Datia', 'Dewas', 'Dhar', 'Dindori', 'East Nimar', 'Guna', 'Gwalior', 'Harda', 'Hoshangabad', 'Indore', 'Jabalpur', 'Jhabua', 'Katni', 'Khandwa', 'Khargone', 'Mandla', 'Mandsaur', 'Murena', 'Narsinghpur', 'Neemach', 'Panna', 'Raisen', 'Rajgarh', 'Ratlam', 'Reewa', 'Sagar', 'Satna', 'Sehore', 'Seoni', 'Shahdol', 'Shajapur', 'Sheopur', 'Shivpuri', 'Sidhi', 'Singhrauli', 'Tikamgarh', 'Ujjain', 'Umaria', 'Vidisha', 'West Nimar'],
    state: [{
      "code": "01",
      "state": "Jammu & Kashmir"
    }, {
      "code": "19",
      "state": "West Bengal"
    }, {
      "code": "02",
      "state": "Himachal Pradesh"
    }, {
      "code": "20",
      "state": "Jharkhand"
    }, {
      "code": "03",
      "state": "Punjab"
    }, {
      "code": "21",
      "state": "Orissa"
    }, {
      "code": "04",
      "state": "Chandigarh"
    }, {
      "code": "22",
      "state": "Chhattisgarh"
    }, {
      "code": "05",
      "state": "Uttarakhand"
    }, {
      "code": "23",
      "state": "Madhya Pradesh"
    }, {
      "code": "06",
      "state": "Haryana"
    }, {
      "code": "24",
      "state": "Gujarat"
    }, {
      "code": "07",
      "state": "Delhi"
    }, {
      "code": "25",
      "state": "Daman & Diu"
    }, {
      "code": "08",
      "state": "Rajasthan"
    }, {
      "code": "26",
      "state": "Dadra & Nagar Haveli"
    }, {
      "code": "09",
      "state": "Uttar Pradesh"
    }, {
      "code": "27",
      "state": "Maharashtra"
    }, {
      "code": "10",
      "state": "Bihar"
    }, {
      "code": "28",
      "state": "Andhra Pradesh"
    }, {
      "code": "11",
      "state": "Sikkim"
    }, {
      "code": "29",
      "state": "Karnataka"
    }, {
      "code": "12",
      "state": "Arunachal Pradesh"
    }, {
      "code": "30",
      "state": "Goa"
    }, {
      "code": "13",
      "state": "Nagaland"
    }, {
      "code": "31",
      "state": "Lakshadweep"
    }, {
      "code": "14",
      "state": "Manipur"
    }, {
      "code": "32",
      "state": "Kerala"
    }, {
      "code": "15",
      "state": "Mizoram"
    }, {
      "code": "33",
      "state": "Tamil Nadu"
    }, {
      "code": "16",
      "state": "Tripura"
    }, {
      "code": "34",
      "state": "Puducherry"
    }, {
      "code": "17",
      "state": "Meghalaya"
    }, {
      "code": "35",
      "state": "Andaman & Nicobar Islands"
    }, {
      "code": "18",
      "state": "Assam"
    }, {
      "code": "36",
      "state": "Telangana "
    }, {
      "code": "37",
      "state": "Andhra Pradesh(New) "
    }],
    GST_Type: ['Regular', 'Composite'],
    firmType: ['Normal', 'Government Entity', 'SEZ', 'Deemed'],
    purchaseType: ['Goods', 'Services'],
    country: ["Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Anguilla", "Antigua &amp; Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia &amp; Herzegovina", "Botswana", "Brazil", "British Virgin Islands", "Brunei", "Bulgaria", "Burkina Faso", "Burundi", "Cambodia", "Cameroon", "Cape Verde", "Cayman Islands", "Chad", "Chile", "China", "Colombia", "Congo", "Cook Islands", "Costa Rica", "Cote D Ivoire", "Croatia", "Cruise Ship", "Cuba", "Cyprus", "Czech Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Estonia", "Ethiopia", "Falkland Islands", "Faroe Islands", "Fiji", "Finland", "France", "French Polynesia", "French West Indies", "Gabon", "Gambia", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea Bissau", "Guyana", "Haiti", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kuwait", "Kyrgyz Republic", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macau", "Macedonia", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Mauritania", "Mauritius", "Mexico", "Moldova", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Namibia", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Norway", "Oman", "Pakistan", "Palestine", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romania", "Russia", "Rwanda", "Saint Pierre &amp; Miquelon", "Samoa", "San Marino", "Satellite", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "South Africa", "South Korea", "Spain", "Sri Lanka", "St Kitts &amp; Nevis", "St Lucia", "St Vincent", "St. Lucia", "Sudan", "Suriname", "Swaziland", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Timor L'Este", "Togo", "Tonga", "Trinidad &amp; Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks &amp; Caicos", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "Uruguay", "Uzbekistan", "Venezuela", "Vietnam", "Virgin Islands (US)", "Yemen", "Zambia", "Zimbabwe"],
    gender: ['Male', 'Female', 'Not to disclose'],
    marital: ['Single', 'Married', 'Widow', 'Not to disclose'],
    brands: null,
    selectedBrand: null,
    finYear: null,
    adminEmail: null,
    roleAndPermission: null,
    brandFinYear: null,
    stockReportTypes: [{
      text: "Last Purchasing Price",
      value: "LPP"
    }, {
      text: "Last Sale Price",
      value: "LSP"
    }, {
      text: "Average Purchasing Price",
      value: "APP"
    }, {
      text: "Average Sale Price",
      value: "ASP"
    }, {
      text: "First In First Out",
      value: "FIFO"
    }, {
      text: "Last In First Out",
      value: "LIFO"
    }],
    brandPackageTypes: ['BASIC', 'ADVANCED', 'PREMIUM', 'EXCLUSIVE']
  };
});

/***/ }),
/* 1651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Informations_Balancesheet_index_vue__ = __webpack_require__(1652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Informations_Bsheet_Bsheet_vue__ = __webpack_require__(1657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Informations_Tradingaccount_Tradingaccount_vue__ = __webpack_require__(1663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Informations_PandL_index_vue__ = __webpack_require__(1666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Informations_Profitandloss_Profitandloss_vue__ = __webpack_require__(1669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Informations_Prop_index_vue__ = __webpack_require__(1672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Informations_Proprietor_Proprietor_vue__ = __webpack_require__(1675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Informations_Itemsheet_index_vue__ = __webpack_require__(1678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Informations_Interestsheet_index_vue__ = __webpack_require__(1680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Informations_Alertsheet_index_vue__ = __webpack_require__(1682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Informations_Defaultersheet_index_vue__ = __webpack_require__(1684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_Informations_Unpickupsheet_index_vue__ = __webpack_require__(1686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Informations_Firmsheet_index_vue__ = __webpack_require__(1688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Informations_Bankstatement_index_vue__ = __webpack_require__(1690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Informations_CashAccount_CashAccounts_vue__ = __webpack_require__(1692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_GSTReports_gstAccounts_vue__ = __webpack_require__(1695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Discounts_DiscountAccounts__ = __webpack_require__(1698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_InterestAccount_InterestAccounts__ = __webpack_require__(1701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Informations_TrailBalanceAccount_TrailBalanceAccount_vue__ = __webpack_require__(1704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Informations_CollectionBook_collectionBook_vue__ = __webpack_require__(1707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Informations_HelpBook_helpBook_vue__ = __webpack_require__(1711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Informations_DeletedInvoices_DeletedInvoice_vue__ = __webpack_require__(1714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Informations_ExtraCharges_ExtraChargesInvoices_vue__ = __webpack_require__(1717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Informations_IncentiveInvoices_IncentiveInvoices_vue__ = __webpack_require__(1720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_Informations_SMSBook_SmsBook_vue__ = __webpack_require__(1723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_Informations_ProductReports_ProductGroupReports__ = __webpack_require__(1726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_Informations_ProductReports_ProductSetReports__ = __webpack_require__(1728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Informations_ProductReports_ProductTypeReports__ = __webpack_require__(1730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_Informations_ProductReports_ProductCategoryReports__ = __webpack_require__(1732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_Informations_MultiPrintInvoices_MultiPrintInvoices_vue__ = __webpack_require__(1734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_Informations_ProductOrderReport_ProductOrderReport_vue__ = __webpack_require__(1737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_Informations_ProductLeadReport_ProductLeadReport_vue__ = __webpack_require__(1740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_Informations_ProductEstimateReport_ProductEstimateReport_vue__ = __webpack_require__(1743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_Informations_BatchReport_BatchReport_vue__ = __webpack_require__(1746);



































/* harmony default export */ __webpack_exports__["a"] = ([{
  path: 'balancesheet',
  name: 'Balancesheet',
  component: __WEBPACK_IMPORTED_MODULE_0__components_Informations_Balancesheet_index_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'bsheet',
  name: 'Bsheet',
  component: __WEBPACK_IMPORTED_MODULE_1__components_Informations_Bsheet_Bsheet_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'tradingaccount',
  name: 'Tradingaccount',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Informations_Tradingaccount_Tradingaccount_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'pandl',
  name: 'PandL',
  component: __WEBPACK_IMPORTED_MODULE_3__components_Informations_PandL_index_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'prop',
  name: 'Prop',
  component: __WEBPACK_IMPORTED_MODULE_5__components_Informations_Prop_index_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'profitandloss',
  name: 'Profitandloss',
  component: __WEBPACK_IMPORTED_MODULE_4__components_Informations_Profitandloss_Profitandloss_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'proprietor',
  name: 'Proprietor',
  component: __WEBPACK_IMPORTED_MODULE_6__components_Informations_Proprietor_Proprietor_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'itemsheet',
  name: 'Itemsheet',
  component: __WEBPACK_IMPORTED_MODULE_7__components_Informations_Itemsheet_index_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'interestsheet',
  name: 'Interestsheet',
  component: __WEBPACK_IMPORTED_MODULE_8__components_Informations_Interestsheet_index_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'alertsheet',
  name: 'Alertsheet',
  component: __WEBPACK_IMPORTED_MODULE_9__components_Informations_Alertsheet_index_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'defaultersheet',
  name: 'Defaultersheet',
  component: __WEBPACK_IMPORTED_MODULE_10__components_Informations_Defaultersheet_index_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'unpickupsheet',
  name: 'Unpickupsheet',
  component: __WEBPACK_IMPORTED_MODULE_11__components_Informations_Unpickupsheet_index_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'firmsheet',
  name: 'Firmsheet',
  component: __WEBPACK_IMPORTED_MODULE_12__components_Informations_Firmsheet_index_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'bankstatement',
  name: 'Bankstatement',
  component: __WEBPACK_IMPORTED_MODULE_13__components_Informations_Bankstatement_index_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'cashaccount',
  name: 'CashAccount',
  component: __WEBPACK_IMPORTED_MODULE_14__components_Informations_CashAccount_CashAccounts_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'gst-accounts',
  name: 'GSTAccounts',
  component: __WEBPACK_IMPORTED_MODULE_15__components_GSTReports_gstAccounts_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: '/discount-accounts',
  name: 'DiscountAccounts',
  component: __WEBPACK_IMPORTED_MODULE_16__components_Discounts_DiscountAccounts__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'trail-balance-accounts',
  name: 'TrailBalanceAccounts',
  component: __WEBPACK_IMPORTED_MODULE_18__components_Informations_TrailBalanceAccount_TrailBalanceAccount_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'interest-accounts',
  name: 'interestAccounts',
  component: __WEBPACK_IMPORTED_MODULE_17__components_InterestAccount_InterestAccounts__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'collection-book',
  name: 'CollectionBook',
  component: __WEBPACK_IMPORTED_MODULE_19__components_Informations_CollectionBook_collectionBook_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'help-book',
  name: 'HelpBook',
  component: __WEBPACK_IMPORTED_MODULE_20__components_Informations_HelpBook_helpBook_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'deleted-invoice-book',
  name: 'DeletedInvoiceBook',
  component: __WEBPACK_IMPORTED_MODULE_21__components_Informations_DeletedInvoices_DeletedInvoice_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'extra-charges-book',
  name: 'ExtraChargesInvoices',
  component: __WEBPACK_IMPORTED_MODULE_22__components_Informations_ExtraCharges_ExtraChargesInvoices_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'Incentive-book',
  name: 'IncentiveInvoices',
  component: __WEBPACK_IMPORTED_MODULE_23__components_Informations_IncentiveInvoices_IncentiveInvoices_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'SMS-book',
  name: 'SMSBook',
  component: __WEBPACK_IMPORTED_MODULE_24__components_Informations_SMSBook_SmsBook_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'Product-Group-Reports',
  name: 'ProductGroupReports',
  component: __WEBPACK_IMPORTED_MODULE_25__components_Informations_ProductReports_ProductGroupReports__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'batch-report',
  name: 'BatchReport',
  component: __WEBPACK_IMPORTED_MODULE_33__components_Informations_BatchReport_BatchReport_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'product-order-report',
  name: 'ProductOrderReport',
  component: __WEBPACK_IMPORTED_MODULE_30__components_Informations_ProductOrderReport_ProductOrderReport_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'product-lead-report',
  name: 'ProductLeadReport',
  component: __WEBPACK_IMPORTED_MODULE_31__components_Informations_ProductLeadReport_ProductLeadReport_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'product-estimate-report',
  name: 'ProductEstimateReport',
  component: __WEBPACK_IMPORTED_MODULE_32__components_Informations_ProductEstimateReport_ProductEstimateReport_vue__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'Product-Type-Reports',
  name: 'ProductTypeReports',
  component: __WEBPACK_IMPORTED_MODULE_27__components_Informations_ProductReports_ProductTypeReports__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'Product-Category-Reports',
  name: 'ProductCategoryReports',
  component: __WEBPACK_IMPORTED_MODULE_28__components_Informations_ProductReports_ProductCategoryReports__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'Product-Set-Reports',
  name: 'ProductSetReports',
  component: __WEBPACK_IMPORTED_MODULE_26__components_Informations_ProductReports_ProductSetReports__["a" /* default */],
  meta: { requiresAuth: true }
}, {
  path: 'multi-print-invoices',
  name: 'MultiPrintInvoices',
  component: __WEBPACK_IMPORTED_MODULE_29__components_Informations_MultiPrintInvoices_MultiPrintInvoices_vue__["a" /* default */],
  meta: { requiresAuth: true }
}]);

/***/ }),
/* 1652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(557);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3790911e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1656);
function injectStyle (ssrContext) {
  __webpack_require__(1653)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3790911e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1653 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1654 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasItems)?_c('v-expansion-panel',{staticClass:"app-expand-card",class:_vm.containerClass,attrs:{"expand":""}},[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-list',{attrs:{"dense":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_c('b',[_vm._t("header")],2)]),_vm._v(" "),(!_vm.onlyTitle)?_c('v-list-tile-content',{staticClass:"align-end"},[_c('b',[_c('h3',[_vm._v(" "+_vm._s(_vm._f("localeAmount")(_vm.value))+" ")])])]):_vm._e()],1)],1)],1),_vm._v(" "),(_vm.hasItems)?_c('v-list',{staticClass:"no-padding",attrs:{"dense":""}},[_vm._t("items")],2):_vm._e()],1)],1):_c('v-list-tile',{staticClass:"app-expand-card"},[_c('v-list-tile-content',[_c('b',[_vm._t("header")],2)]),_vm._v(" "),(!_vm.onlyTitle)?_c('v-list-tile-content',{staticClass:"align-end"},[_c('b',[_c('h3',[_vm._v(" "+_vm._s(_vm._f("localeAmount")(_vm.value))+" ")])])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-iterator',{staticClass:"balance",attrs:{"items":['expense', 'income'],"content-tag":"div","content-class":'layout row wrap',"hide-actions":""},scopedSlots:_vm._u([{key:"item",fn:function(props){return [(props.item === 'expense')?_c('v-flex',{attrs:{"xs12":"","sm6":"","md":""}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_vm._v("Liabilities "),_c('v-spacer'),_vm._v(" Amount")],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[(_vm.selectedFirm)?_c('expand-card',{attrs:{"value":_vm._f("amount")(_vm.propCapitalAC || 0)}},[_c('h3',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Prop capital A/C : ")])]):_vm._e(),_vm._v(" "),_c('expand-card',{attrs:{"hasItems":true,"value":_vm._f("amount")(_vm.securedLoansBankListTotal + _vm.totalLoan)}},[_c('template',{slot:"header"},[_c('h3',[_vm._v("Loans:")])]),_vm._v(" "),_c('template',{slot:"items"},[[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-light"},[_vm._v("Unsecured Loans")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm._f("amount")(_vm.totalLoan || 0)))])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_vm._l((_vm.sellerList.concat(_vm.buyerList)),function(creditor){return [(!!creditor.totalLoanGiven)?_c('v-list-tile',{key:creditor['.key']},[_c('v-list-tile-content',[_c('h3',{staticClass:"primary--text font-weight-light"},[_c('router-link',{attrs:{"target":"_blank","to":{
                      path: ("/customers/" + (creditor['.key']))
                    }}},[_vm._v("\n                      "+_vm._s(creditor['name'])+"\n                    ")]),_vm._v(" :\n                  ")],1)]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(creditor.totalLoanGiven))])],1):_vm._e()]})],2)],1)],_vm._v(" "),[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-light"},[_vm._v("Secured Loans (Bank Account) :")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm._f("amount")(_vm.securedLoansBankListTotal || 0)))])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_vm._l((_vm.securedLoansBankList),function(bank){return [_c('v-list-tile',{key:bank['.key']},[_c('v-list-tile-content',[_vm._v("\n               "+_vm._s(bank.bankName)+"\n              ")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(bank.amount))])],1)]})],2)],1)]],2)],2),_vm._v(" "),_c('expand-card',{attrs:{"hasItems":true,"value":(Number.parseFloat(_vm.liabilityTotal) + Number.parseFloat(_vm.totalSundryCreditors) + Number.parseFloat(_vm.expenseTotal) + Number.parseFloat(_vm.ITCData.liabilities.IGST) + Number.parseFloat(_vm.ITCData.liabilities.SGST) + Number.parseFloat(_vm.ITCData.liabilities.CGST)).toFixed(2)}},[_c('template',{slot:"header"},[_c('h3',[_vm._v("Current Liabilities:")])]),_vm._v(" "),_c('template',{slot:"items"},[[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-light"},[_vm._v("Current Liabilities:")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm._f("amount")(_vm.liabilityTotal || 0)))])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_vm._l((_vm.liabilitiesWPro),function(liability){return [(liability.paymentTypeStatus === 'yet to confirm' && (liability.totalAmount || liability.openingBalance )> 0)?_c('v-list-tile',{key:liability['.key']},[_c('v-list-tile-content',[_vm._v("\n               "+_vm._s(liability.liability)+"\n              ")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(Number.parseFloat(liability.totalAmount + liability.openingBalance)))])],1):_vm._e()]})],2)],1)],_vm._v(" "),[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-light"},[_vm._v("Sundry Creditors:")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm._f("amount")(_vm.totalSundryCreditors || 0)))])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_vm._l((_vm.sellerList),function(creditor){return [(!!creditor.totalRemainingAmount)?_c('v-list-tile',{key:creditor['.key']},[_c('v-list-tile-content',[_c('h3',{staticClass:"primary--text font-weight-light"},[_c('router-link',{attrs:{"target":"_blank","to":{
                      path: ("/customers/" + (creditor['.key']))
                    }}},[_vm._v("\n                      "+_vm._s(creditor['name'])+"\n                    ")]),_vm._v(" :\n                  ")],1)]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(creditor.totalRemainingAmount))])],1):_vm._e()]})],2)],1)],_vm._v(" "),[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-light"},[_vm._v("Provisions:")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm._f("amount")(_vm.expenseTotal || 0)))])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_vm._l((_vm.expensesWPro),function(expense){return [(expense.paymentTypeStatus === 'yet to confirm' && expense.totalAmount > 0)?_c('v-list-tile',{key:expense['.key']},[_c('v-list-tile-content',[_c('h3',{staticClass:"primary--text font-weight-light"},[_vm._v(_vm._s(expense.expense))])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(expense.totalAmount))])],1):_vm._e()]})],2)],1)],_vm._v(" "),[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-light"},[_vm._v(" GST Liabilities:")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm._f("amount")((Number.parseFloat(_vm.ITCData.liabilities.IGST) + Number.parseFloat(_vm.ITCData.liabilities.SGST) + Number.parseFloat(_vm.ITCData.liabilities.CGST)).toFixed(2) || 0)))])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_c('h3',{staticClass:"primary--text font-weight-light"},[_vm._v(_vm._s('IGST'))])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(_vm.ITCData.liabilities.IGST))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('h3',{staticClass:"primary--text font-weight-light"},[_vm._v(_vm._s('CGST'))])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(_vm.ITCData.liabilities.CGST))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('h3',{staticClass:"primary--text font-weight-light"},[_vm._v(_vm._s('SGST'))])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(_vm.ITCData.liabilities.SGST))])],1)],1)],1)]],2)],2)],1)],1),_vm._v(" "),_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_vm._v("\n          Total \n          "),_c('v-spacer'),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm._f("amount")(((_vm.propCapitalAC + _vm.totalSundryCreditors + _vm.totalLoan + _vm.securedLoansBankListTotal) + Number.parseFloat(_vm.expenseTotal) + Number.parseFloat(_vm.ITCData.liabilities.IGST) + Number.parseFloat(_vm.ITCData.liabilities.SGST) + Number.parseFloat(_vm.ITCData.liabilities.CGST)) || 0)))])],1),_vm._v(" "),_c('v-divider')],1)],1):_vm._e(),_vm._v(" "),(props.item === 'income')?_c('v-flex',{attrs:{"xs12":"","sm6":"","md":""}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_vm._v("Assets "),_c('v-spacer'),_vm._v(" Amount")],1),_vm._v(" "),_c('v-divider')],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_c('expand-card',{attrs:{"value":_vm._f("amount")(_vm.totalLoanAndAdvances || 0),"hasItems":_vm.buyerList.length > 0}},[_c('template',{slot:"header"},[_c('h3',[_vm._v("Loans & Advances :")])]),_vm._v(" "),_c('template',{slot:"items"},[_vm._l((_vm.buyerList.concat(_vm.sellerList)),function(creditor){return [(!!creditor.totalLoanTaken)?_c('expand-card',{key:creditor['.key'],attrs:{"header":creditor.name,"value":creditor.totalLoanTaken,"containerClass":"no-shadow"}},[_c('template',{slot:"header"},[_c('h3',{staticClass:"primary--text font-weight-light"},[_c('router-link',{attrs:{"target":"_blank","to":{
                      path: ("/customers/" + (creditor['.key']))
                    }}},[_vm._v("\n                      "+_vm._s(creditor['name'])+"\n                    ")]),_vm._v(" :\n                  ")],1)])],2):_vm._e()]})],2)],2),_vm._v(" "),_c('expand-card',{attrs:{"hasItems":_vm.getAssetAccount.length > 0,"value":_vm._f("amount")(_vm.totalAssetAmount || 0)}},[_c('template',{slot:"header"},[_c('h3',[_vm._v("Fixed Asset:")])]),_vm._v(" "),_c('template',{slot:"items"},[_vm._l((_vm.getAssetAccount),function(asset,e){return [(asset.details.type != 'investments')?_c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-light"},[_vm._v(_vm._s(asset.details.asset))]),_vm._v(" / "+_vm._s(asset.details.category)+" "+_vm._s(asset.details.type)+"\n                "),_c('v-spacer'),_vm._v(" "),_c('h3',[_vm._v(_vm._s(((Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance)) -  Number.parseFloat(((asset.details.totalAmount + asset.details.openingBalance)  * (_vm.isDepriciation ? asset.details.depriciation : 0)) / 100) || 0 | _vm.amount ) || ((Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance)) || 0 | _vm.amount )))])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((asset.invoices),function(section,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_vm._v(_vm._s(new Date(section.date).toLocaleDateString('en-IN')))]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(section.totalAmount || section.openingBalance || '-'))])],1)}),1)],1):_vm._e()]})],2)],2),_vm._v(" "),_c('expand-card',{attrs:{"hasItems":_vm.getInvestmentAccount.length > 0,"value":_vm._f("amount")(_vm.totalInvestmentAmount || 0)}},[_c('template',{slot:"header"},[_c('h3',[_vm._v("Investments:")])]),_vm._v(" "),_c('template',{slot:"items"},[_vm._l((_vm.getInvestmentAccount),function(asset,e){return [(asset.details.type === 'investments')?_c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-light"},[_vm._v(_vm._s(asset.details.asset))]),_vm._v(" / "+_vm._s(asset.details.category)+" "+_vm._s(asset.details.type)+"\n                "),_c('v-spacer'),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance) || 0)))])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((asset.invoices),function(section,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_vm._v(_vm._s(new Date(section.date).toLocaleDateString('en-IN')))]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(section.totalAmount || section.openingBalance || '-'))])],1)}),1)],1):_vm._e()]})],2)],2),_vm._v(" "),_c('expand-card',{attrs:{"hasItems":true,"value":_vm._f("amount")((Number.parseFloat(_vm.totalSundryDebitors)+ Number.parseFloat(_vm.savingsCurrentBankListTotal)+ Number.parseFloat(_vm.cashInHand)+Number.parseFloat(_vm.ITCData.assets.IGST) + Number.parseFloat(_vm.ITCData.assets.SGST) + Number.parseFloat(_vm.ITCData.assets.CGST)).toFixed(2) || 0)}},[_c('template',{slot:"header"},[_c('h3',[_vm._v("Current Assets:")])]),_vm._v(" "),_c('template',{slot:"items"},[[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-light"},[_vm._v("Sundry Debtors:")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm._f("amount")(_vm.totalSundryDebitors || 0)))])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_vm._l((_vm.buyerList),function(creditor){return [(!!creditor.totalRemainingAmount)?_c('v-list-tile',{key:creditor['.key']},[_c('v-list-tile-content',[_c('h3',{staticClass:"primary--text font-weight-light"},[_c('router-link',{attrs:{"target":"_blank","to":{
                      path: ("/customers/" + (creditor['.key']))
                    }}},[_vm._v("\n                      "+_vm._s(creditor['name'])+"\n                    ")]),_vm._v(" :\n                  ")],1)]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(creditor.totalRemainingAmount))])],1):_vm._e()]})],2)],1)],_vm._v(" "),[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-light"},[_vm._v("Bank Account :")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm._f("amount")(_vm.savingsCurrentBankListTotal || 0)))])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_vm._l((_vm.savingsCurrentBankList),function(bank){return [_c('v-list-tile',{key:bank['.key']},[_c('v-list-tile-content',[_c('template',{slot:"header"},[_c('h3',{staticClass:"primary--text font-weight-light"},[_vm._v(_vm._s(bank.bankName))])])],2),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(bank.amount))])],1)]})],2)],1)],_vm._v(" "),[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-light"},[_vm._v("Cash in Hand :")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm._f("amount")(_vm.cashInHand || 0)))])],1)],1)],1)])],_vm._v(" "),[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-light"},[_vm._v(" GST Assets:")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm._f("amount")((Number.parseFloat(_vm.ITCData.assets.IGST) + Number.parseFloat(_vm.ITCData.assets.SGST) + Number.parseFloat(_vm.ITCData.assets.CGST)).toFixed(2) || 0)))])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_c('h3',{staticClass:"primary--text font-weight-light"},[_vm._v(_vm._s('IGST'))])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(_vm.ITCData.assets.IGST))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('h3',{staticClass:"primary--text font-weight-light"},[_vm._v(_vm._s('CGST'))])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(_vm.ITCData.assets.CGST))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('h3',{staticClass:"primary--text font-weight-light"},[_vm._v(_vm._s('SGST'))])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(_vm.ITCData.assets.SGST))])],1)],1)],1)]],2)],2),_vm._v(" "),_c('v-card',[_c('v-spacer'),_vm._v(" "),_c('v-card-title',{staticClass:"primary white--text"},[_vm._v("Total"),_c('v-spacer'),_c('h2',[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(_vm.cashInHand  + _vm.savingsCurrentBankListTotal + _vm.totalSundryDebitors  + _vm.totalLoanAndAdvances + _vm.totalInvestmentAmount + _vm.totalAssetAmount + Number.parseFloat(_vm.ITCData.assets.IGST) + Number.parseFloat(_vm.ITCData.assets.SGST) + Number.parseFloat(_vm.ITCData.assets.CGST) ) || 0)))])],1)],1)],1)],1):_vm._e()]}}])},[_c('template',{slot:"header"},[_c('v-toolbar',{staticClass:"mb",attrs:{"color":"primary","dark":"","flat":""}},[_c('v-toolbar-title',[_vm._v("BALANCE SHEET")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-toolbar',{staticClass:"mb",attrs:{"color":"white white--text","flat":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-autocomplete',{staticClass:"mx-3",attrs:{"items":_vm.firmsByBrand,"search-input":_vm.searchInput,"flat":"","hide-no-data":"","hide-details":"","label":"Select Firm","clearable":""},on:{"update:searchInput":function($event){_vm.searchInput=$event},"update:search-input":function($event){_vm.searchInput=$event}},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',[_c('v-menu',{attrs:{"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.fromdatepicker),callback:function ($$v) {_vm.fromdatepicker=$$v},expression:"fromdatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","clearable":"","single-line":"","label":"From Date","readonly":""},slot:"activator",model:{value:(_vm.filterInvoiceFrom),callback:function ($$v) {_vm.filterInvoiceFrom=$$v},expression:"filterInvoiceFrom"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.fromdatepicker = false}},model:{value:(_vm.filterInvoiceFrom),callback:function ($$v) {_vm.filterInvoiceFrom=$$v},expression:"filterInvoiceFrom"}})],1)],1),_vm._v(" "),_c('v-flex',[_c('v-menu',{attrs:{"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.todatepicker),callback:function ($$v) {_vm.todatepicker=$$v},expression:"todatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","clearable":"","label":"To Date","single-line":"","readonly":""},slot:"activator",model:{value:(_vm.filterInvoiceTo),callback:function ($$v) {_vm.filterInvoiceTo=$$v},expression:"filterInvoiceTo"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.todatepicker = false}},model:{value:(_vm.filterInvoiceTo),callback:function ($$v) {_vm.filterInvoiceTo=$$v},expression:"filterInvoiceTo"}})],1)],1),_vm._v(" "),_c('v-flex',[_c('v-switch',{staticStyle:{"margin-top":"13px"},attrs:{"label":("Calculate Depriciation: " + (_vm.isDepriciation ? 'Yes' : 'No'))},model:{value:(_vm.isDepriciation),callback:function ($$v) {_vm.isDepriciation=$$v},expression:"isDepriciation"}})],1)],1)],1)],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bsheet_vue__ = __webpack_require__(559);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8603af2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bsheet_vue__ = __webpack_require__(1662);
function injectStyle (ssrContext) {
  __webpack_require__(1658)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Bsheet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e8603af2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Bsheet_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1658 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expandCard_vue__ = __webpack_require__(560);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_601e7cae_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_expandCard_vue__ = __webpack_require__(1661);
function injectStyle (ssrContext) {
  __webpack_require__(1660)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-601e7cae"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_expandCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_601e7cae_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_expandCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1660 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasItems)?_c('v-expansion-panel',{staticClass:"app-expand-card",class:_vm.containerClass,attrs:{"expand":""}},[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-list',{attrs:{"dense":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_c('b',{staticClass:"print-field"},[_vm._t("header")],2)]),_vm._v(" "),(!_vm.onlyTitle)?_c('v-list-tile-content',{staticClass:"align-end"},[_c('b',[_c('h3',{staticClass:"print-field"},[_vm._v(" "+_vm._s(_vm._f("localeAmount")(_vm.value))+" ")])])]):_vm._e()],1)],1)],1),_vm._v(" "),(_vm.hasItems)?_c('v-list',{staticClass:"no-padding",attrs:{"dense":""}},[_vm._t("items")],2):_vm._e()],1)],1):_c('v-list-tile',{staticClass:"app-expand-card"},[_c('v-list-tile-content',[_c('b',[_c('h3',{staticClass:"print-field"},[_vm._t("header")],2)])]),_vm._v(" "),(!_vm.onlyTitle)?_c('v-list-tile-content',{staticClass:"align-end"},[_c('b',[_c('h3',[_c('h3',{staticClass:"print-field"},[_vm._v(" "+_vm._s(_vm._f("localeAmount")(_vm.value))+" ")])])])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-iterator',{staticClass:"balance",attrs:{"items":['expense', 'income'],"content-tag":"div","content-class":'layout row wrap',"hide-actions":""},scopedSlots:_vm._u([{key:"item",fn:function(props){return [(props.item === 'expense')?_c('v-flex',{staticStyle:{"display":"flex","flex-direction":"column"},attrs:{"xs12":"","sm6":"","md":""}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"print-field"},[_vm._v("Liabilities")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',{staticClass:"print-field"},[_vm._v("Amount")])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[(!!_vm.selectedFirm)?_c('v-card'):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"-10px"}},[_c('template',{slot:"items"},[_vm._l((_vm.groupExpensesOfPropCapital),function(expense,e){return [(expense.totalAmount > 0)?_c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-bold"},[_vm._v(_vm._s(expense.expense))]),_vm._v(" / "+_vm._s(expense.category)+"\n                      "),_c('v-spacer'),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(expense.totalAmount) + Number.parseFloat(expense.openingBalance) || 0)))])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((expense.invoices),function(section,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_vm._v(_vm._s(new Date(section.date).toLocaleDateString('en-GB')))]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(section.totalAmount || section.openingBalance || '-'))])],1)}),1)],1):_vm._e()]})],2)],2),_vm._v(" "),_c('v-expansion-panel',{attrs:{"expand":""}},[_c('v-expansion-panel-content',{key:'12-a'},[_c('v-list',{attrs:{"dense":""}},_vm._l((_vm.propassetByBrand),function(asset,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_vm._v(_vm._s(asset.asset)+"/ "+_vm._s(asset.category))]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(_vm._f("amount")(asset.depAmount || 0)))])],1)}),1)],1)],1),_vm._v(" "),_c('v-card'),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"3px"}},[_c('template',{slot:"items"},[_vm._l((_vm.groupExpensesOfTradingAccount),function(expense,e){return [(expense.totalAmount > 0 || expense.openingBalance > 0)?_c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card')],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((expense.invoices),function(section,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_vm._v(_vm._s(new Date(section.date).toLocaleDateString('en-GB')))]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(_vm._f("amount")(section.totalAmount || section.openingBalance || '-' || 0)))])],1)}),1)],1):_vm._e()]})],2)],2),_vm._v(" "),_c('v-card'),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"3px"}},[_c('template',{slot:"items"},[_vm._l((_vm.groupExpensesOfPandL),function(expense,e){return [(expense.totalAmount > 0 || expense.openingBalance > 0)?_c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card')],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((expense.invoices),function(section,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_vm._v(_vm._s(new Date(section.date).toLocaleDateString('en-GB')))]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(section.totalAmount || section.openingBalance || '-'))])],1)}),1)],1):_vm._e()]})],2)],2),_vm._v(" "),_c('v-expansion-panel',{attrs:{"expand":""}},[_c('v-expansion-panel-content',[_c('v-expansion-panel',{attrs:{"expand":""}},_vm._l((_vm.getStaffAccount),function(staff,e){return _c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card')],1)])}),1)],1)],1),_vm._v(" "),_c('v-expansion-panel',{attrs:{"expand":""}},[_c('v-expansion-panel-content',{key:'12-e'},[_c('v-list',{attrs:{"dense":""}},_vm._l((_vm.plassetByBrand),function(asset,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_vm._v(_vm._s(asset.asset)+"/ "+_vm._s(asset.category))]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(_vm._f("amount")(asset.depAmount || 0)))])],1)}),1)],1)],1),_vm._v(" "),_c('v-card'),_vm._v(" "),(!!_vm.selectedFirm)?_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"print-field"},[_vm._v("Prop Capital A/C")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(_vm.closingBalance || 0)))])],1)],1):_vm._e(),_vm._v(" "),_c('expand-card',{attrs:{"hasItems":true,"value":_vm._f("amount")(_vm.securedLoansBankListTotal + _vm.totalLoan)}},[_c('template',{slot:"header"},[_c('h3',[_vm._v("Loans:")])]),_vm._v(" "),_c('template',{slot:"items"},[[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-bold print-field"},[_vm._v("Unsecured Loans:")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('b',{staticClass:"primary--text font-weight-bold print-field"},[_vm._v(_vm._s(_vm._f("amount")(_vm.totalLoan || 0)))])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_vm._l((_vm.sellerList.concat(_vm.buyerList)),function(creditor){return [(!!creditor.totalLoanTaken)?_c('v-list-tile',{key:creditor['.key']},[_c('v-list-tile-content',[_c('h3',{staticClass:"font-weight-bold"},[_c('router-link',{attrs:{"to":{
                            path: ("/buyers/" + (creditor['.key']))
                            }}},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(creditor['name']))])])],1)]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end print-field"},[_vm._v(_vm._s(_vm._f("amount")(creditor.totalLoanTaken || 0)))])],1):_vm._e()]})],2)],1)],_vm._v(" "),[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-bold print-field"},[_vm._v("Secured Loans:")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('b',{staticClass:"primary--text font-weight-bold print-field"},[_vm._v(_vm._s(_vm._f("amount")(_vm.securedLoansBankListTotal || 0)))])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_vm._l((_vm.securedLoansBankList),function(bank){return [_c('v-list-tile',{key:bank['.key']},[_c('v-list-tile-content',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(bank.bankName))])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(bank.amount || 0)))])])],1)]})],2)],1)]],2)],2),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"3px"}},[_c('expand-card',{attrs:{"hasItems":_vm.groupLiabilities.length > 0,"value":_vm._f("amount")(_vm.liabilityTotal || 0)}},[_c('template',{slot:"header"},[(_vm.groupLiabilities.length != 0)?_c('h3',[_vm._v("Long-term Borrowings")]):_vm._e(),_vm._v(" "),(_vm.groupLiabilities.length === 0)?_c('h3',[_vm._v("No Long-term Borrowings")]):_vm._e()]),_vm._v(" "),_c('template',{slot:"items"},[_vm._l((_vm.groupLiabilities),function(liability,e){return [((liability.totalAmount > 0 || liability.openingBalance > 0 ) && liability.underHead === 'Long-term Borrowing' )?_c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-bold print-field"},[_vm._v(_vm._s(liability.liability))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('b',{staticClass:"primary--text font-weight-bold print-field"},[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(liability.totalAmount) + Number.parseFloat(liability.openingBalance) || 0)))])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((liability.invoices),function(section,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_vm._v(_vm._s(new Date(section.date).toLocaleDateString('en-GB')))]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end "},[_vm._v(_vm._s(_vm._f("amount")(section.totalAmount || section.openingBalance || '-' || 0)))])],1)}),1)],1):_vm._e()]})],2)],2)],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"3px"}},[_c('expand-card',{attrs:{"hasItems":_vm.groupLiabilitiesShortTerm.length > 0,"value":_vm._f("amount")(_vm.shortTermLiabilityTotal || 0)}},[_c('template',{slot:"header"},[(_vm.groupLiabilitiesShortTerm.length != 0)?_c('h3',[_vm._v("short-term Borrowings")]):_vm._e(),_vm._v(" "),(_vm.groupLiabilitiesShortTerm.length === 0)?_c('h3',[_vm._v("No short-term Borrowings")]):_vm._e()]),_vm._v(" "),_c('template',{slot:"items"},[_vm._l((_vm.groupLiabilitiesShortTerm),function(liability,e){return [((liability.totalAmount > 0 || liability.openingBalance > 0 ) && liability.underHead === 'Short-Term Borrowing' )?_c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-bold print-field"},[_vm._v(_vm._s(liability.liability))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('b',{staticClass:"primary--text font-weight-bold print-field"},[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(liability.totalAmount) + Number.parseFloat(liability.openingBalance) || 0)))])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((liability.invoices),function(section,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(new Date(section.date).toLocaleDateString('en-GB')))])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(section.totalAmount || section.openingBalance || '-' || 0)))])])],1)}),1)],1):_vm._e()]})],2)],2)],1),_vm._v(" "),_c('expand-card',{attrs:{"hasItems":true,"value":_vm._f("amount")((Number.parseFloat(_vm.liabilityTotalWPro) + Number.parseFloat(_vm.totalSundryCreditors) + Number.parseFloat(_vm.expenseProvisionTotal) + Number.parseFloat(_vm.ITCData.liabilities.IGST) + Number.parseFloat(_vm.ITCData.liabilities.SGST) + Number.parseFloat(_vm.ITCData.liabilities.CGST)) || 0)}},[_c('template',{slot:"header"},[_c('h3',[_vm._v("Current Liabilities:")])]),_vm._v(" "),_c('template',{slot:"items"},[[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v("Other Liabilities:")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('b',{staticClass:"primary--text font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(_vm.liabilityTotalWPro || 0)))])])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_vm._l((_vm.liabilitiesWPro),function(liability){return [(liability.paymentTypeStatus === 'yet to confirm')?_c('v-list-tile',{key:liability['.key']},[_c('v-list-tile-content',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(liability.liability))])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_c('b',{staticClass:"font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(" "+_vm._s(_vm._f("amount")((Number.parseFloat(liability.totalAmount || 0 | _vm.amount) + Number.parseFloat(liability.openingBalance || 0 | _vm.amount )) || 0)))])])])],1):_vm._e()]})],2)],1)],_vm._v(" "),[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v("Sundry Creditors:")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('b',{staticClass:"primary--text font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(_vm.totalSundryCreditors || 0)))])])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_vm._l((_vm.sellerList),function(creditor){return [(!!creditor.totalRemainingAmount)?_c('v-list-tile',{key:creditor['.key']},[_c('v-list-tile-content',[_c('b',{staticClass:"font-weight-bold"},[_c('router-link',{attrs:{"to":{
                        path: ("/buyers/" + (creditor['.key']))
                      }}},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(creditor['name']))])]),_vm._v(" :\n                    ")],1)]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"font-weight-bold align-end"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(creditor.totalRemainingAmount || 0)))])])],1):_vm._e()]})],2)],1)],_vm._v(" "),[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v("Provisions:")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('b',{staticClass:"primary--text font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(_vm.expenseProvisionTotal || 0)))])])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_vm._l((_vm.expenseWithProvision),function(expense){return [(expense.paymentTypeStatus === 'yet to confirm')?_c('v-list-tile',{key:expense['.key']},[_c('v-list-tile-content',[_c('b',{staticClass:"font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(expense.expense))])])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_c('b',{staticClass:"font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")((Number.parseFloat(expense.totalAmount || 0 | _vm.amount) + Number.parseFloat(expense.openingBalance || 0 | _vm.amount )) || 0))+" ")])])])],1):_vm._e()]})],2)],1)],_vm._v(" "),[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(" GST Liabilities:")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('b',{staticClass:"primary--text font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")((Number.parseFloat(_vm.ITCData.liabilities.IGST) + Number.parseFloat(_vm.ITCData.liabilities.SGST) + Number.parseFloat(_vm.ITCData.liabilities.CGST)).toFixed(2) || 0)))])])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_c('h3',{staticClass:"font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s('IGST'))])])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(_vm.ITCData.liabilities.IGST || 0)))])])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('h3',{staticClass:"font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s('CGST'))])])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(_vm.ITCData.liabilities.CGST || 0)))])])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('h3',{staticClass:"font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s('SGST'))])])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(_vm.ITCData.liabilities.SGST || 0)))])])],1)],1)],1)]],2)],2)],1)],1),_vm._v(" "),_c('v-card',{staticStyle:{"margin-top":"auto"}},[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"print-field"},[_vm._v("Total ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h2',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(((_vm.totalSundryCreditors + _vm.totalLoan + _vm.securedLoansBankListTotal) + Number.parseFloat(_vm.liabilityTotalWPro) + Number.parseFloat(_vm.closingBalance) + Number.parseFloat(_vm.expenseProvisionTotal) + Number.parseFloat(_vm.shortTermLiabilityTotal) + Number.parseFloat(_vm.liabilityTotal) + Number.parseFloat(_vm.ITCData.liabilities.IGST) + Number.parseFloat(_vm.ITCData.liabilities.SGST) + Number.parseFloat(_vm.ITCData.liabilities.CGST)) || 0)))])])],1),_vm._v(" "),_c('v-divider')],1)],1):_vm._e(),_vm._v(" "),(props.item === 'income')?_c('v-flex',{attrs:{"xs12":"","sm6":"","md":""}},[_c('v-card',{staticStyle:{"display":"flex","flex-direction":"column"}},[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"print-field"},[_vm._v("Assets")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',{staticClass:"print-field"},[_vm._v("Amount")])],1),_vm._v(" "),_c('v-divider')],1),_vm._v(" "),(!!_vm.selectedFirm)?_c('v-card'):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"3px"}},[_c('template',{slot:"items"},[_vm._l((_vm.groupIncomesOfPropCapital),function(income,e){return [_c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-bold print-field"},[_vm._v(_vm._s(income.income))]),_vm._v(" / "+_vm._s(income.category)+"\n                      "),_c('v-spacer'),_vm._v(" "),_c('h3',{staticClass:"primary--text font-weight-bold  print-field"},[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(income.totalAmount) + Number.parseFloat(income.openingBalance) || 0)))])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((income.invoices),function(section,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(new Date(section.date).toLocaleDateString('en-GB')))])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(section.totalAmount || section.openingBalance || 0)))])])],1)}),1)],1)]})],2)],2),_vm._v(" "),_c('v-card'),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"3px"}},[_c('template',{slot:"items"},[_vm._l((_vm.groupIncomesOfTradingAccount),function(income,e){return [(income.totalAmount > 0 || income.openingBalance > 0)?_c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card')],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((income.invoices),function(section,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(new Date(section.date).toLocaleDateString('en-GB')))])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(section.totalAmount || section.openingBalance || 0)))])])],1)}),1)],1):_vm._e()]})],2)],2),_vm._v(" "),_c('v-card'),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"3px"}},[_c('template',{slot:"items"},[_vm._l((_vm.groupIncomesOfPl),function(income,e){return [(income.totalAmount > 0 || income.openingBalance >0 )?_c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card')],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((income.invoices),function(section,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(new Date(section.date).toLocaleDateString('en-GB')))])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(section.totalAmount || section.openingBalance || 0)))])])],1)}),1)],1):_vm._e()]})],2)],2),_vm._v(" "),_c('v-card'),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_c('expand-card',{attrs:{"value":_vm._f("amount")(_vm.totalLoanAndAdvances || 0),"hasItems":_vm.buyerList.length > 0}},[_c('template',{slot:"header"},[_c('h3',[_vm._v("Loans & Advances :")])]),_vm._v(" "),_c('template',{slot:"items"},[_vm._l((_vm.buyerList.concat(_vm.sellerList)),function(creditor){return [(!!creditor.totalLoanGiven)?_c('expand-card',{key:creditor['.key'],staticClass:"primary--text font-weight-bold",attrs:{"header":creditor.name,"value":creditor.totalLoanGiven,"containerClass":"no-shadow"}},[_c('template',{slot:"header"},[_c('h3',{staticClass:"primary--text font-weight-bold"},[_c('router-link',{attrs:{"to":{
                        path: ("/buyers/" + (creditor['.key']))
                      }}},[_vm._v("\n                      "+_vm._s(creditor['name'])+" :\n                      ")])],1)])],2):_vm._e()]})],2)],2),_vm._v(" "),_c('expand-card',{attrs:{"hasItems":_vm.getAssetAccount.length > 0,"value":_vm._f("amount")(_vm.totalAssetAmount || 0)}},[_c('template',{slot:"header"},[_c('h3',[_vm._v("Fixed Asset:")])]),_vm._v(" "),_c('template',{slot:"items"},[_vm._l((_vm.getAssetAccount),function(asset,e){return [(asset.details.type != 'investments')?_c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(asset.details.asset))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('b',{staticClass:"primary--text font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")((((Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance)) -  Number.parseFloat(((asset.details.totalAmount + asset.details.openingBalance)  * asset.details.depriciation) / 100) || 0 | _vm.amount ) || ((Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance)) || 0 | _vm.amount )) || 0)))])])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((asset.invoices),function(section,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(new Date(section.date).toLocaleDateString('en-GB')))])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(section.totalAmount || section.openingBalance || '-' || 0)))])])],1)}),1)],1):_vm._e()]})],2)],2),_vm._v(" "),_c('expand-card',{attrs:{"hasItems":_vm.getIntangibleAssetAccount.length > 0,"value":_vm._f("amount")(_vm.totalIntangibleAssetAmount || 0)}},[_c('template',{slot:"header"},[_c('h3',[_vm._v("Intangible asset:")])]),_vm._v(" "),_c('template',{slot:"items"},[_vm._l((_vm.getIntangibleAssetAccount),function(asset,e){return [(asset.details.type === 'intangibleAssets')?_c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(asset.details.asset))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('b',{staticClass:"primary--text font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")((((Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance)) -  Number.parseFloat(((asset.details.totalAmount + asset.details.openingBalance)  * asset.details.depriciation) / 100) || 0 | _vm.amount ) || ((Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance)) || 0 | _vm.amount )) || 0)))])])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((asset.invoices),function(section,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(new Date(section.date).toLocaleDateString('en-GB')))])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(section.totalAmount || section.openingBalance || '-' || 0)))])])],1)}),1)],1):_vm._e()]})],2)],2),_vm._v(" "),_c('expand-card',{attrs:{"hasItems":_vm.getInvestmentAccount.length > 0,"value":_vm._f("amount")(_vm.totalInvestmentAmount || 0)}},[_c('template',{slot:"header"},[_c('h3',[_vm._v("Investments:")])]),_vm._v(" "),_c('template',{slot:"items"},[_vm._l((_vm.getInvestmentAccount),function(asset,e){return [(asset.details.type === 'investments')?_c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(asset.details.asset))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('b',{staticClass:"primary--text font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")((Number.parseFloat(asset.details.totalAmount || 0 | _vm.amount)) + (Number.parseFloat(asset.details.openingBalance) || 0 | _vm.amount) || 0)))])])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((asset.invoices),function(section,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(new Date(section.date).toLocaleDateString('en-GB')))])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(section.totalAmount || section.openingBalance || '-' || 0)))])])],1)}),1)],1):_vm._e()]})],2)],2),_vm._v(" "),_c('expand-card',{attrs:{"hasItems":true,"value":_vm._f("amount")((Number.parseFloat(_vm.totalSundryDebitors) + Number.parseFloat(_vm.incomeProvisionTotal) + Number.parseFloat(_vm.savingsCurrentBankListTotal)+ Number.parseFloat(_vm.cashInHand)+Number.parseFloat(_vm.ITCData.assets.IGST) + Number.parseFloat(_vm.ITCData.assets.SGST) + Number.parseFloat(_vm.ITCData.assets.CGST) + Number.parseFloat((_vm.isJwelleryBussiness
                ? _vm.closingStockWeight
                : _vm.closingStock))).toFixed(2) || 0)}},[_c('template',{slot:"header"},[_c('h3',[_vm._v("Current Assets:")])]),_vm._v(" "),_c('template',{slot:"items"},[[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v("Sundry Debtors:")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('b',{staticClass:"primary--text font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(_vm.totalSundryDebitors || 0)))])])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_vm._l((_vm.buyerList),function(creditor){return [(!!creditor.totalRemainingAmount)?_c('v-list-tile',{key:creditor['.key']},[_c('v-list-tile-content',[_c('b',{staticClass:"primary--text font-weight-bold"},[_c('router-link',{attrs:{"to":{
                        path: ("/buyers/" + (creditor['.key']))
                      }}},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(creditor['name'])+" :")])])],1)]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(creditor.totalRemainingAmount || 0)))])])],1):_vm._e()]})],2)],1)],_vm._v(" "),[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v("Provisions:")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('b',{staticClass:"primary--text font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(_vm.incomeProvisionTotal || 0)))])])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_vm._l((_vm.incomesWPro),function(income){return [(income.paymentTypeStatus === 'yet to confirm')?_c('v-list-tile',{key:income['.key']},[_c('v-list-tile-content',[_c('b',{staticClass:"font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(income.income))])])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_c('b',{staticClass:"font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")((Number.parseFloat(income.totalAmount || 0 | _vm.amount) + Number.parseFloat(income.openingBalance || 0 | _vm.amount )) || 0))+" ")])])])],1):_vm._e()]})],2)],1)],_vm._v(" "),[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v("Bank Account :")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('b',{staticClass:"primary--text font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(_vm.savingsCurrentBankListTotal || 0)))])])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_vm._l((_vm.savingsCurrentBankList),function(bank){return [_c('v-list-tile',{key:bank['.key']},[_c('v-list-tile-content',[[_c('b',{staticClass:"font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(bank.bankName))])])]],2),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_c('b',{staticClass:"font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(" "+_vm._s(_vm._f("amount")(bank.amount || 0))+" ")])])])],1)]})],2)],1)],_vm._v(" "),[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v("Cash in Hand :")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('b',{staticClass:"primary--text font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(_vm.cashInHand || 0)))])])],1)],1)],1)])],_vm._v(" "),[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v("GST Assets:")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('b',{staticClass:"align-end primary--text font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")((Number.parseFloat(_vm.ITCData.assets.IGST) + Number.parseFloat(_vm.ITCData.assets.SGST) + Number.parseFloat(_vm.ITCData.assets.CGST)).toFixed(2) || 0)))])])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_c('b',{staticClass:"font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s('IGST'))])])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end font-weight-bold "},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(_vm.ITCData.assets.IGST || 0)))])])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('b',{staticClass:"font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s('CGST'))])])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(_vm.ITCData.assets.CGST || 0)))])])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('b',{staticClass:"font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s('SGST'))])])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(_vm.ITCData.assets.SGST || 0)))])])],1)],1)],1)],_vm._v(" "),[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v("Closing Stock :")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('b',{staticClass:"primary--text font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")((_vm.isJwelleryBussiness
                ? _vm.closingStockWeight
                : _vm.closingStock) || 0)))])])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_vm._l(((_vm.isJwelleryBussiness
                ? _vm.filteredGroups
                : _vm.filteredProduct)),function(prod2,e){return [_c('v-list-tile',{key:e+'pcC'},[_c('v-list-tile-content',[[_c('b',{staticClass:"font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(prod2.name))])])]],2),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_c('b',{staticClass:"font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(" "+_vm._s(_vm._f("amount")(prod2.closingAmount || 0)))])])])],1)]})],2)],1)]],2)],2)],1),_vm._v(" "),_c('v-card',{staticStyle:{"margin-top":"auto"}},[_c('v-spacer'),_vm._v(" "),_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"print-field"},[_vm._v("Total")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h2',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(_vm.cashInHand + _vm.savingsCurrentBankListTotal + _vm.totalSundryDebitors  + _vm.totalLoanAndAdvances + _vm.totalInvestmentAmount + _vm.totalAssetAmount + _vm.totalIntangibleAssetAmount + Number.parseFloat(_vm.incomeProvisionTotal) + Number.parseFloat(_vm.ITCData.assets.IGST) + Number.parseFloat(_vm.ITCData.assets.SGST) + Number.parseFloat(_vm.ITCData.assets.CGST)) + Number.parseFloat((_vm.isJwelleryBussiness
                ? _vm.closingStockWeight
                : _vm.closingStock)) || 0)))])])],1)],1)],1):_vm._e()]}}])},[_c('template',{slot:"header"},[_c('v-toolbar',{staticClass:"mb",attrs:{"color":"primary","dark":"","flat":""}},[_c('v-toolbar-title',{staticClass:"font-weight-light headline"},[_vm._v("\n        Balance Sheet\n      ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-switch',{staticStyle:{"margin-top":"15px"},attrs:{"label":("Depriciation: " + (_vm.isDepriciation ? 'Yes' : 'No'))},model:{value:(_vm.isDepriciation),callback:function ($$v) {_vm.isDepriciation=$$v},expression:"isDepriciation"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.print()}}},[_c('v-icon',[_vm._v("print")])],1),_vm._v(" "),_c('router-link',{attrs:{"to":"/Dashboard"}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("close")])],1)],1)],1),_vm._v(" "),_c('v-toolbar',{staticClass:"mb",attrs:{"color":"white white--text","flat":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","md4":"","sm4":""}},[_c('v-autocomplete',{attrs:{"dense":"","flat":"","clearable":"","item-text":"name","return-object":true,"items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":"","sm3":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.fromdatepicker),callback:function ($$v) {_vm.fromdatepicker=$$v},expression:"fromdatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","clearable":"","single-line":"","label":"From Date","readonly":""},slot:"activator",model:{value:(_vm.filterInvoiceFrom),callback:function ($$v) {_vm.filterInvoiceFrom=$$v},expression:"filterInvoiceFrom"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.fromdatepicker = false}},model:{value:(_vm.filterInvoiceFrom),callback:function ($$v) {_vm.filterInvoiceFrom=$$v},expression:"filterInvoiceFrom"}})],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":"","sm3":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.todatepicker),callback:function ($$v) {_vm.todatepicker=$$v},expression:"todatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","clearable":"","label":"To Date","single-line":"","readonly":""},slot:"activator",model:{value:(_vm.filterInvoiceTo),callback:function ($$v) {_vm.filterInvoiceTo=$$v},expression:"filterInvoiceTo"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.todatepicker = false}},model:{value:(_vm.filterInvoiceTo),callback:function ($$v) {_vm.filterInvoiceTo=$$v},expression:"filterInvoiceTo"}})],1)],1)],1)],1)],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tradingaccount_vue__ = __webpack_require__(561);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b029ea5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tradingaccount_vue__ = __webpack_require__(1665);
function injectStyle (ssrContext) {
  __webpack_require__(1664)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Tradingaccount_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b029ea5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Tradingaccount_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1664 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-iterator',{staticClass:"profit",attrs:{"items":_vm.tradingAccount,"content-tag":"div","content-class":'layout row wrap',"hide-actions":""},scopedSlots:_vm._u([{key:"item",fn:function(props){return [(props.item.expense)?_c('v-flex',{staticStyle:{"display":"flex","flex-direction":"column"},attrs:{"xs6":"","md6":"","sm6":""}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("Particulars")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',{staticClass:"print-field"},[_vm._v("Amount")])],1)],1),_vm._v(" "),(!!_vm.selectedFirm)?_c('expand-card',{attrs:{"hasItems":_vm.filteredProduct.length > 0,"value":_vm._f("amount")((_vm.isJwelleryBussiness
                ? _vm.totalOpeningStockWeight
                : _vm.totalOpeningStock) || 0)}},[_c('template',{slot:"header"},[_c('h3',[_vm._v("Opening Stock")])]),_vm._v(" "),_c('template',{slot:"items"},[_vm._l(((_vm.isJwelleryBussiness
                ? _vm.filteredGroups
                : _vm.filteredProduct)),function(prod,e){return [(prod.openingBalance > 0)?_c('v-expansion-panel-content',{key:e + 'p'},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-light"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(prod.name))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('b',{staticClass:"primary--text font-weight-light"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(prod.openingBalance || 0)))])])],1)],1)],1)]):_vm._e()]})],2)],2):_vm._e(),_vm._v(" "),_c('v-card',[_c('v-card-title',{on:{"click":function($event){return _vm.$router.push({ path: "/purchase-register" })}}},[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("Purchase")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(_vm.purchase || 0)))])])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"3px"}},[_c('expand-card',{attrs:{"hasItems":_vm.groupExpenses.length > 0,"value":_vm._f("amount")(_vm.expenseTotal || 0)}},[_c('template',{slot:"header"},[(_vm.groupExpenses.length != 0)?_c('h3',[_vm._v("Expenses")]):_vm._e(),_vm._v(" "),(_vm.groupExpenses.length === 0)?_c('h3',[_vm._v("No Expense !")]):_vm._e()]),_vm._v(" "),_c('template',{slot:"items"},[_vm._l((_vm.groupExpenses),function(expense,e){return [(expense.totalAmount > 0 || expense.openingBalance > 0)?_c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('h3',{staticClass:"primary--text font-weight-light"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(expense.expense)+" /\n                            "+_vm._s(expense.category))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',{staticClass:"primary--text font-weight-light"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(expense.totalAmount) +
                              Number.parseFloat(expense.openingBalance) ||
                            0)))])])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((expense.invoices),function(section,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(new Date(section.date).toLocaleDateString("en-IN")))])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(section.totalAmount || section.openingBalance || "-"))])])],1)}),1)],1):_vm._e()]})],2)],2)],1),_vm._v(" "),_c('v-card',[(_vm.grossProfit >= 0)?_c('v-card-title',[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("Gross Profit c/d")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(_vm.grossProfit || 0)))])])],1):_vm._e()],1),_vm._v(" "),_c('v-card',{staticStyle:{"margin-top":"auto"}},[_c('v-card-title',{staticClass:"primary white--text"},[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("Total")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")((Number.parseFloat(_vm.expenseTotal) +
                  Number.parseFloat(_vm.purchase) +
                  Number.parseFloat(
                    _vm.selectedFirm ? _vm.selectedFirm.openingStock || 0 : 0
                  ) +
                  Number.parseFloat((_vm.isJwelleryBussiness
                ? _vm.totalOpeningStockWeight
                : _vm.totalOpeningStock)) +
                  Number.parseFloat(_vm.grossProfit > 0 ? _vm.grossProfit : 0)))))])])],1)],1)],1):_vm._e(),_vm._v(" "),(!props.item.expense)?_c('v-flex',{staticStyle:{"display":"flex","flex-direction":"column"},attrs:{"xs6":"","md6":"","sm6":""}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("Particulars")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',{staticClass:"print-field"},[_vm._v("Amount")])],1)],1),_vm._v(" "),_c('v-card',[_c('v-card-title',{on:{"click":function($event){return _vm.$router.push({ path: "/sale-register" })}}},[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("Sales")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(_vm.sales)))])])],1)],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"3px"}},[_c('expand-card',{attrs:{"hasItems":_vm.groupIncomes.length > 0,"value":_vm._f("amount")(_vm.incomeTotal || 0)}},[_c('template',{slot:"header"},[(_vm.groupIncomes.length != 0)?_c('h3',{staticClass:"subheading font-weight-bold"},[_vm._v("\n                Incomes\n              ")]):_vm._e(),_vm._v(" "),(_vm.groupIncomes.length === 0)?_c('h3',{staticClass:"subheading font-weight-bold"},[_vm._v("\n                No Other Income !\n              ")]):_vm._e()]),_vm._v(" "),_c('template',{slot:"items"},[_vm._l((_vm.groupIncomes),function(income,e){return [(income.totalAmount > 0 || income.openingBalance > 0)?_c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('h3',{staticClass:"primary--text font-weight-light"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(income.income)+" / "+_vm._s(income.category))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',{staticClass:"primary--text font-weight-light"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(income.totalAmount) +
                              Number.parseFloat(income.openingBalance) ||
                            0)))])])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((income.invoices),function(section,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(new Date(section.date).toLocaleDateString("en-GB")))])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(section.totalAmount ||
                          section.openingBalance ||
                          0)))])])],1)}),1)],1):_vm._e()]})],2)],2)],1),_vm._v(" "),_c('expand-card',{attrs:{"hasItems":_vm.filteredProduct.length > 0,"value":_vm._f("amount")((_vm.isJwelleryBussiness
                ? _vm.closingStockWeight
                : _vm.closingStock) || 0)}},[_c('template',{slot:"header"},[(!_vm.editClosingStock)?_c('div',{staticStyle:{"display":"flex","margin-top":"25px"}},[_c('h3',[_vm._v("Closing Stock")]),_vm._v(" "),_c('v-btn',{staticClass:"mx-0",staticStyle:{"padding-bottom":"27px"},attrs:{"icon":""},on:{"click":function($event){_vm.editClosingStock = true}}},[_c('v-icon',{attrs:{"color":"teal"}},[_vm._v("edit")])],1)],1):_c('div',{staticStyle:{"display":"flex","margin-top":"25px"}},[_c('v-text-field',{attrs:{"type":"number","label":"Closing Stock"},model:{value:(_vm.brandClosingStockAmount),callback:function ($$v) {_vm.brandClosingStockAmount=$$v},expression:"brandClosingStockAmount"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.saveClosingStock()}}},[_vm._v("Save")])],1)]),_vm._v(" "),_c('template',{slot:"items"},[_vm._l(((_vm.isJwelleryBussiness
                ? _vm.filteredGroups
                : _vm.filteredProduct)),function(prod2,e){return [_c('v-expansion-panel-content',{key:e + 'pcC'},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',{key:prod2.name + 's'},[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-light"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(prod2.name))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('b',{staticClass:"primary--text font-weight-light"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(prod2.closingAmount || 0)))])])],1)],1)],1)])]})],2)],2),_vm._v(" "),_c('v-card',[(_vm.grossProfit < 0)?_c('v-card-title',[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("Gross Loss c/d")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(_vm.grossProfit || 0)))])])],1):_vm._e()],1),_vm._v(" "),_c('v-card',{staticStyle:{"margin-top":"auto"}},[_c('v-card-title',{staticClass:"primary white--text"},[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("Total")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(_vm.incomeTotal || 0 |_vm.amount) + Number.parseFloat(_vm.sales || 0 |_vm.amount) + Number.parseFloat((_vm.isJwelleryBussiness
                ? _vm.closingStockWeight
                : _vm.closingStock)) - Number.parseFloat(_vm.grossProfit < 0 ? _vm.grossProfit : 0))))])])],1)],1)],1):_vm._e()]}}])},[_c('template',{slot:"header"},[_c('v-toolbar',{staticClass:"mb",attrs:{"color":"primary","dark":"","flat":""}},[_c('v-toolbar-title',[_vm._v("Trading Account")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.print()}}},[_c('v-icon',[_vm._v("print")])],1),_vm._v(" "),_c('router-link',{attrs:{"to":"/Dashboard"}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("close")])],1)],1)],1),_vm._v(" "),_c('v-toolbar',{staticClass:"mb",attrs:{"color":"white white--text","flat":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","md4":"","sm4":""}},[_c('v-autocomplete',{attrs:{"dense":"","flat":"","clearable":"","item-text":"name","return-object":"","items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":"","sm3":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.fromdatepicker),callback:function ($$v) {_vm.fromdatepicker=$$v},expression:"fromdatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","clearable":"","single-line":"","label":"From Date","readonly":""},slot:"activator",model:{value:(_vm.filterInvoiceFrom),callback:function ($$v) {_vm.filterInvoiceFrom=$$v},expression:"filterInvoiceFrom"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.fromdatepicker = false}},model:{value:(_vm.filterInvoiceFrom),callback:function ($$v) {_vm.filterInvoiceFrom=$$v},expression:"filterInvoiceFrom"}})],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":"","sm3":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.todatepicker),callback:function ($$v) {_vm.todatepicker=$$v},expression:"todatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","clearable":"","label":"To Date","single-line":"","readonly":""},slot:"activator",model:{value:(_vm.filterInvoiceTo),callback:function ($$v) {_vm.filterInvoiceTo=$$v},expression:"filterInvoiceTo"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.todatepicker = false}},model:{value:(_vm.filterInvoiceTo),callback:function ($$v) {_vm.filterInvoiceTo=$$v},expression:"filterInvoiceTo"}})],1)],1)],1)],1)],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(562);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_425c1484_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1668);
function injectStyle (ssrContext) {
  __webpack_require__(1667)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_425c1484_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1667 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-iterator',{staticClass:"profit",attrs:{"items":_vm.pandlAccount,"content-tag":"div","content-class":'layout row wrap',"hide-actions":""},scopedSlots:_vm._u([{key:"item",fn:function(props){return [(props.item.expense)?_c('v-flex',{attrs:{"xs6":"","md6":"","sm6":""}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('b',[_vm._v("Particulars")]),_vm._v(" "),_c('v-spacer'),_vm._v(" Amount\r\n            ")],1)],1),_vm._v(" "),(!!_vm.selectedFirm)?_c('v-card'):_vm._e(),_vm._v(" "),_c('v-card'),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"3px"}},[_c('template',{slot:"items"},[_vm._l((_vm.groupExpensesOfTradingAccount),function(expense,e){return [(expense.totalAmount > 0 || expense.openingBalance > 0)?_c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card')],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((expense.invoices),function(section,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_vm._v(_vm._s(new Date(section.date).toLocaleDateString('en-IN')))]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(section.totalAmount || section.openingBalance || '-'))])],1)}),1)],1):_vm._e()]})],2)],2),_vm._v(" "),_c('v-card',[(_vm.grossProfit < 0)?_c('v-card-title',[_c('b',[_vm._v("Gross Loss c/d")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm._f("amount")(_vm.grossProfit || 0)))])],1):_vm._e()],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"3px"}},[_c('expand-card',{attrs:{"hasItems":_vm.groupExpensesOfPandL.length > 0,"value":_vm._f("amount")(_vm.pandlexpenseTotal  || 0)}},[_c('template',{slot:"header"},[(_vm.groupExpensesOfPandL.length != 0)?_c('h3',{staticClass:"font-weight-bold"},[_vm._v("Expenses")]):_vm._e(),_vm._v(" "),(_vm.groupExpensesOfPandL.length === 0)?_c('h3',{staticClass:"font-weight-bold"},[_vm._v("No Expense !")]):_vm._e()]),_vm._v(" "),_c('template',{slot:"items"},[_vm._l((_vm.groupExpensesOfPandL),function(expense,e){return [(expense.totalAmount > 0 || expense.openingBalance > 0)?_c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-light"},[_vm._v(_vm._s(expense.expense))]),_vm._v(" / "+_vm._s(expense.category)+"\r\n                          "),_c('v-spacer'),_vm._v(" "),_c('h3',{staticClass:"primary--text font-weight-light"},[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(expense.totalAmount) + Number.parseFloat(expense.openingBalance) || 0)))])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((expense.invoices),function(section,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_vm._v(_vm._s(new Date(section.date).toLocaleDateString('en-IN')))]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(section.totalAmount || section.openingBalance || '-'))])],1)}),1)],1):_vm._e()]})],2)],2)],1),_vm._v(" "),_c('v-expansion-panel',{attrs:{"expand":""}},[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',[_vm._v("Staff")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm._f("amount")(_vm.totalSalary)))])],1)],1)],1),_vm._v(" "),_c('v-expansion-panel',{attrs:{"expand":""}},_vm._l((_vm.getStaffAccount),function(staff,e){return _c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-light"},[_vm._v(_vm._s(staff.staffName))]),_vm._v(" | "+_vm._s(staff.staffRole)+"\r\n                      "),_c('v-spacer'),_vm._v(" "),_c('h3',{staticClass:"primary--text font-weight-light"},[_vm._v(_vm._s(_vm._f("amount")(staff.creditTotal - staff.debitTotal)))])],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation",attrs:{"items":staff.salaryList,"headers":_vm.salaryListHeaders,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(new Date(props.item.date).toLocaleDateString('en-GB')))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(props.item.isCredited)?[_c('td',[_c('h4',{staticClass:"success--text align-end"},[_vm._v("₹ "+_vm._s(_vm._f("amount")(props.item.amount)))])])]:_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!props.item.isCredited)?[_c('td',[_c('h4',{staticClass:"error--text align-end"},[_vm._v(" ₹ "+_vm._s(_vm._f("amount")(props.item.amount)))])])]:_vm._e()]}}],null,true)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("\r\n                    no record found\r\n                  ")])],2)],1)}),1)],1)],1),_vm._v(" "),_c('v-expansion-panel',{attrs:{"expand":""}},[_c('v-expansion-panel-content',{key:'12-e'},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',[_vm._v("Depriciation")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm._f("amount")(_vm.totalAsset || 0)))])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((_vm.assetByBrand),function(asset,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_vm._v(_vm._s(asset.asset)+"/ "+_vm._s(asset.category))]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(_vm._f("amount")(asset.depAmount || 0)))])],1)}),1)],1)],1),_vm._v(" "),_c('v-card',[(_vm.netProfit > 0)?_c('v-card-title',[_c('b',[_vm._v("Net Profit c/d")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm._f("amount")(_vm.netProfit || 0)))])],1):_vm._e()],1),_vm._v(" "),_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('b',[_vm._v("Total")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(_vm.pandlexpenseTotal) + Number.parseFloat(_vm.totalAsset) + Number.parseFloat(_vm.totalSalary) - Number.parseFloat((_vm.grossProfit < 0 ? _vm.grossProfit : 0 ) | _vm.amount) + Number.parseFloat(_vm.netProfit > 0 ? _vm.netProfit : 0 ))))])],1)],1)],1):_vm._e(),_vm._v(" "),(!props.item.expense)?_c('v-flex',{attrs:{"xs6":"","md6":"","sm6":""}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('b',[_vm._v("Particulars")]),_vm._v(" "),_c('v-spacer'),_vm._v(" Amount\r\n            ")],1)],1),_vm._v(" "),_c('v-card'),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"3px"}},[_c('template',{slot:"items"},[_vm._l((_vm.groupIncomesOfTradingAccount),function(income,e){return [(income.totalAmount > 0 || income.openingBalance > 0)?_c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-light"},[_vm._v(_vm._s(income.income))]),_vm._v(" / "+_vm._s(income.category)+"\r\n                        "),_c('v-spacer'),_vm._v(" "),_c('h3',{staticClass:"primary--text font-weight-light"},[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(income.totalAmount) + Number.parseFloat(income.openingBalance) || 0)))])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((income.invoices),function(section,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_vm._v(_vm._s(new Date(section.date).toLocaleDateString('en-GB')))]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(_vm._f("amount")(section.totalAmount || section.openingBalance || 0)))])],1)}),1)],1):_vm._e()]})],2)],2),_vm._v(" "),_c('v-card'),_vm._v(" "),_c('v-card',[(_vm.grossProfit >= 0)?_c('v-card-title',[_c('b',[_vm._v("Gross Profit c/d")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm._f("amount")(_vm.grossProfit || 0)))])],1):_vm._e()],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"3px"}},[_c('expand-card',{attrs:{"hasItems":_vm.groupIncomes.length > 0,"value":_vm._f("amount")(_vm.pandlincomeTotal || 0)}},[_c('template',{slot:"header"},[(_vm.groupIncomes.length != 0)?_c('b',{staticClass:"subheading font-weight-bold"},[_vm._v("Incomes")]):_vm._e(),_vm._v(" "),(_vm.groupIncomes.length === 0)?_c('b',{staticClass:"subheading font-weight-bold"},[_vm._v("No Other Income !")]):_vm._e()]),_vm._v(" "),_c('template',{slot:"items"},[_vm._l((_vm.groupIncomes),function(income,e){return [(income.totalAmount > 0 || income.openingBalance >0 )?_c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',[_vm._v(_vm._s(income.income))]),_vm._v(" / "+_vm._s(income.category)+"\r\n                          "),_c('v-spacer'),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(income.totalAmount) + Number.parseFloat(income.openingBalance) || 0)))])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((income.invoices),function(section,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_vm._v(_vm._s(new Date(section.date).toLocaleDateString('en-GB')))]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(_vm._f("amount")(section.totalAmount || section.openingBalance || 0)))])],1)}),1)],1):_vm._e()]})],2)],2)],1),_vm._v(" "),_c('v-card',[(_vm.netProfit < 0)?_c('v-card-title',[_c('b',[_vm._v("Net Loss c/d")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm._f("amount")(_vm.netProfit || 0)))])],1):_vm._e()],1),_vm._v(" "),_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('b',[_vm._v("Total")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(_vm.pandlincomeTotal || 0 |_vm.amount) + + Number.parseFloat((_vm.grossProfit > 0 ? _vm.grossProfit : 0 ) | _vm.amount) + Number.parseFloat(_vm.netProfit < 0 ? _vm.netProfit : 0))))])],1)],1)],1):_vm._e()]}}])},[_c('template',{slot:"header"},[_c('v-toolbar',{staticClass:"mb",attrs:{"color":"primary","dark":"","flat":""}},[_c('v-toolbar-title',[_vm._v("P&L Account")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-toolbar',{staticClass:"mb",attrs:{"color":"white white--text","flat":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-autocomplete',{attrs:{"dense":"","flat":"","clearable":"","item-text":"name","return-object":"","items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',[_c('v-menu',{attrs:{"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.fromdatepicker),callback:function ($$v) {_vm.fromdatepicker=$$v},expression:"fromdatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","clearable":"","single-line":"","label":"From Date","readonly":""},slot:"activator",model:{value:(_vm.filterInvoiceFrom),callback:function ($$v) {_vm.filterInvoiceFrom=$$v},expression:"filterInvoiceFrom"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.fromdatepicker = false}},model:{value:(_vm.filterInvoiceFrom),callback:function ($$v) {_vm.filterInvoiceFrom=$$v},expression:"filterInvoiceFrom"}})],1)],1),_vm._v(" "),_c('v-flex',[_c('v-menu',{attrs:{"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.todatepicker),callback:function ($$v) {_vm.todatepicker=$$v},expression:"todatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","clearable":"","label":"To Date","single-line":"","readonly":""},slot:"activator",model:{value:(_vm.filterInvoiceTo),callback:function ($$v) {_vm.filterInvoiceTo=$$v},expression:"filterInvoiceTo"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.todatepicker = false}},model:{value:(_vm.filterInvoiceTo),callback:function ($$v) {_vm.filterInvoiceTo=$$v},expression:"filterInvoiceTo"}})],1)],1)],1)],1)],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profitandloss_vue__ = __webpack_require__(563);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_078b86ce_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profitandloss_vue__ = __webpack_require__(1671);
function injectStyle (ssrContext) {
  __webpack_require__(1670)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profitandloss_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_078b86ce_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profitandloss_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1670 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-iterator',{staticClass:"profit",attrs:{"items":_vm.pandlAccount,"content-tag":"div","content-class":'layout row wrap',"hide-actions":""},scopedSlots:_vm._u([{key:"item",fn:function(props){return [(props.item.expense)?_c('v-flex',{staticStyle:{"display":"flex","flex-direction":"column"},attrs:{"xs6":"","md6":"","sm6":""}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('b',[_c('span',{staticClass:"print-field"},[_vm._v("Particulars")])]),_vm._v(" "),_c('v-spacer'),_c('span',{staticClass:"print-field"},[_vm._v(" Amount")])],1)],1),_vm._v(" "),(!!_vm.selectedFirm)?_c('v-card'):_vm._e(),_vm._v(" "),_c('v-card'),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"3px"}},[_c('template',{slot:"items"},[_vm._l((_vm.groupExpensesOfTradingAccount),function(expense,e){return [(expense.totalAmount > 0 || expense.openingBalance > 0)?_c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card')],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((expense.invoices),function(section,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(new Date(section.date).toLocaleDateString('en-IN')))])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(section.totalAmount || section.openingBalance || '-'))])])],1)}),1)],1):_vm._e()]})],2)],2),_vm._v(" "),_c('v-card',[(_vm.grossProfit < 0)?_c('v-card-title',[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("Gross Loss c/d")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(_vm.grossProfit || 0)))])])],1):_vm._e()],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"3px"}},[_c('expand-card',{attrs:{"hasItems":_vm.groupExpensesOfPandL.length > 0,"value":_vm._f("amount")((_vm.pandlexpenseTotal) || 0)}},[_c('template',{slot:"header"},[(_vm.groupExpensesOfPandL.length != 0)?_c('h3',{staticClass:"font-weight-bold"},[_vm._v("Expenses")]):_vm._e(),_vm._v(" "),(_vm.groupExpensesOfPandL.length === 0)?_c('h3',{staticClass:"font-weight-bold"},[_vm._v("No Expense !")]):_vm._e()]),_vm._v(" "),_c('template',{slot:"items"},[_vm._l((_vm.groupExpensesOfPandL),function(expense,e){return [(expense.totalAmount > 0 || expense.openingBalance > 0)?_c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('h3',{staticClass:"primary--text font-weight-light"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(expense.expense)+" / "+_vm._s(expense.category))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',{staticClass:"primary--text font-weight-light"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(expense.totalAmount) + Number.parseFloat(expense.openingBalance) || 0)))])])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((expense.invoices),function(section,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(new Date(section.date).toLocaleDateString('en-IN')))])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(section.totalAmount || section.openingBalance || '-'))])])],1)}),1)],1):_vm._e()]})],2)],2)],1),_vm._v(" "),_c('v-expansion-panel',{attrs:{"expand":""}},[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("Staff")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(_vm.totalSalary || 0)))])])],1)],1)],1),_vm._v(" "),_c('v-expansion-panel',{attrs:{"expand":""}},_vm._l((_vm.getStaffAccount),function(staff,e){return _c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-light"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(staff.staffName)+" | "+_vm._s(staff.staffRole))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',{staticClass:"primary--text font-weight-light"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(staff.creditTotal - staff.debitTotal)))])])],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation",attrs:{"items":staff.salaryList,"headers":_vm.salaryListHeaders,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(new Date(props.item.date).toLocaleDateString('en-GB')))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(props.item.isCredited)?[_c('td',[_c('h4',{staticClass:"success--text align-end"},[_c('span',{staticClass:"print-field"},[_vm._v("₹ "+_vm._s(_vm._f("amount")(props.item.amount)))])])])]:_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!props.item.isCredited)?[_c('td',[_c('h4',{staticClass:"error--text align-end"},[_c('span',{staticClass:"print-field"},[_vm._v(" ₹ "+_vm._s(_vm._f("amount")(props.item.amount)))])])])]:_vm._e()]}}],null,true)},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("\r\n                    no record found\r\n                  ")])],2)],1)}),1)],1)],1),_vm._v(" "),_c('v-expansion-panel',{attrs:{"expand":""}},[_c('v-expansion-panel-content',{key:'12-e'},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("Depriciation")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(_vm.totalAsset || 0)))])])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((_vm.assetByBrand),function(asset,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(asset.asset)+"/ "+_vm._s(asset.category))])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(asset.depAmount || 0)))])])],1)}),1)],1)],1),_vm._v(" "),_c('v-card',[(_vm.netProfit > 0)?_c('v-card-title',[_c('b',[_c('span',{staticClass:"print-field"},[_vm._v("Net Profit c/d")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(_vm.netProfit || 0)))])])],1):_vm._e()],1),_vm._v(" "),_c('v-card',{staticStyle:{"margin-top":"auto"}},[_c('v-card-title',{staticClass:"primary white--text"},[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("Total")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(_vm.pandlexpenseTotal) + Number.parseFloat(_vm.totalAsset) + Number.parseFloat(_vm.totalSalary) - Number.parseFloat((_vm.grossProfit < 0 ? _vm.grossProfit : 0 ) | _vm.amount) + Number.parseFloat(_vm.netProfit > 0 ? _vm.netProfit : 0 ))))])])],1)],1)],1):_vm._e(),_vm._v(" "),(!props.item.expense)?_c('v-flex',{staticStyle:{"display":"flex","flex-direction":"column"},attrs:{"xs6":"","md6":"","sm6":""}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('b',[_c('span',{staticClass:"print-field"},[_vm._v("Particulars")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',{staticClass:"print-field"},[_vm._v("Amount")])],1)],1),_vm._v(" "),_c('v-card'),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"3px"}},[_c('template',{slot:"items"},[_vm._l((_vm.groupIncomesOfTradingAccount),function(income,e){return [(income.totalAmount > 0 || income.openingBalance > 0)?_c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-light"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(income.income)+" / "+_vm._s(income.category))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',{staticClass:"primary--text font-weight-light"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(income.totalAmount) + Number.parseFloat(income.openingBalance) || 0)))])])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((income.invoices),function(section,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(new Date(section.date).toLocaleDateString('en-GB')))])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(section.totalAmount || section.openingBalance || 0)))])])],1)}),1)],1):_vm._e()]})],2)],2),_vm._v(" "),_c('v-card'),_vm._v(" "),_c('v-card',[(_vm.grossProfit >= 0)?_c('v-card-title',[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("Gross Profit c/d")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(_vm.grossProfit || 0)))])])],1):_vm._e()],1),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"3px"}},[_c('expand-card',{attrs:{"hasItems":_vm.groupIncomes.length > 0,"value":_vm._f("amount")(_vm.pandlincomeTotal || 0)}},[_c('template',{slot:"header"},[(_vm.groupIncomes.length != 0)?_c('b',{staticClass:"subheading font-weight-bold"},[_vm._v("Incomes")]):_vm._e(),_vm._v(" "),(_vm.groupIncomes.length === 0)?_c('b',{staticClass:"subheading font-weight-bold"},[_vm._v("No Other Income !")]):_vm._e()]),_vm._v(" "),_c('template',{slot:"items"},[_vm._l((_vm.groupIncomes),function(income,e){return [(income.totalAmount > 0 || income.openingBalance >0 )?_c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(income.income))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(income.totalAmount) + Number.parseFloat(income.openingBalance) || 0)))])])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((income.invoices),function(section,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(new Date(section.date).toLocaleDateString('en-GB')))])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(section.totalAmount || section.openingBalance || 0)))])])],1)}),1)],1):_vm._e()]})],2)],2)],1),_vm._v(" "),_c('v-card',[(_vm.netProfit < 0)?_c('v-card-title',[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("Net Loss c/d")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(_vm.netProfit || 0)))])])],1):_vm._e()],1),_vm._v(" "),_c('v-card',{staticStyle:{"margin-top":"auto"}},[_c('v-card-title',{staticClass:"primary white--text"},[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("Total")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v(" "+_vm._s(_vm._f("amount")((Number.parseFloat(_vm.pandlincomeTotal || 0 | _vm.amount) + Number.parseFloat((_vm.grossProfit > 0 ? _vm.grossProfit : 0 ) | _vm.amount) - Number.parseFloat((_vm.netProfit < 0 ? _vm.netProfit : 0) | _vm.amount)) || 0)))])])],1)],1)],1):_vm._e()]}}])},[_c('template',{slot:"header"},[_c('v-toolbar',{staticClass:"mb",attrs:{"color":"primary","dark":"","flat":""}},[_c('v-toolbar-title',[_vm._v("Profit and Loss Account")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.print()}}},[_c('v-icon',[_vm._v("print")])],1),_vm._v(" "),_c('router-link',{attrs:{"to":"/Dashboard"}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("close")])],1)],1)],1),_vm._v(" "),_c('v-toolbar',{staticClass:"mb",attrs:{"color":"white white--text","flat":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","md4":"","sm4":""}},[_c('v-autocomplete',{attrs:{"dense":"","flat":"","clearable":"","item-text":"name","return-object":"","items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":"","sm3":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.fromdatepicker),callback:function ($$v) {_vm.fromdatepicker=$$v},expression:"fromdatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","clearable":"","single-line":"","label":"From Date","readonly":""},slot:"activator",model:{value:(_vm.filterInvoiceFrom),callback:function ($$v) {_vm.filterInvoiceFrom=$$v},expression:"filterInvoiceFrom"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.fromdatepicker = false}},model:{value:(_vm.filterInvoiceFrom),callback:function ($$v) {_vm.filterInvoiceFrom=$$v},expression:"filterInvoiceFrom"}})],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":"","sm3":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.todatepicker),callback:function ($$v) {_vm.todatepicker=$$v},expression:"todatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","clearable":"","label":"To Date","single-line":"","readonly":""},slot:"activator",model:{value:(_vm.filterInvoiceTo),callback:function ($$v) {_vm.filterInvoiceTo=$$v},expression:"filterInvoiceTo"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.todatepicker = false}},model:{value:(_vm.filterInvoiceTo),callback:function ($$v) {_vm.filterInvoiceTo=$$v},expression:"filterInvoiceTo"}})],1)],1)],1)],1)],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(564);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20b7bb6e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1674);
function injectStyle (ssrContext) {
  __webpack_require__(1673)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20b7bb6e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1673 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-iterator',{staticClass:"profit",attrs:{"items":_vm.propAccount,"content-tag":"div","content-class":'layout row wrap',"hide-actions":""},scopedSlots:_vm._u([{key:"item",fn:function(props){return [(props.item.expense)?_c('v-flex',{attrs:{"xs6":"","md6":"","sm6":""}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('b',[_vm._v("Particulars")]),_vm._v(" "),_c('v-spacer'),_vm._v(" Amount\r\n            ")],1)],1),_vm._v(" "),(!!_vm.selectedFirm)?_c('v-card'):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"3px"}},[_c('expand-card',{attrs:{"hasItems":_vm.groupExpensesOfPropCapital.length > 0,"value":_vm._f("amount")(_vm.propexpenseTotal  || 0)}},[_c('template',{slot:"header"},[(_vm.groupExpensesOfPropCapital.length != 0)?_c('b',{staticClass:"subheading font-weight-bold"},[_vm._v("Expenses")]):_vm._e(),_vm._v(" "),(_vm.groupExpensesOfPropCapital.length === 0)?_c('b',{staticClass:"subheading font-weight-bold"},[_vm._v("No Expense !")]):_vm._e()]),_vm._v(" "),_c('template',{slot:"items"},[_vm._l((_vm.groupExpensesOfPropCapital),function(expense,e){return [(expense.totalAmount > 0)?_c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-light"},[_vm._v(_vm._s(expense.expense))]),_vm._v(" / "+_vm._s(expense.category)+"\r\n                    "),_c('v-spacer'),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(expense.totalAmount) + Number.parseFloat(expense.openingBalance) || 0)))])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((expense.invoices),function(section,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_vm._v(_vm._s(new Date(section.date).toLocaleDateString('en-IN')))]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(section.totalAmount || section.openingBalance || '-'))])],1)}),1)],1):_vm._e()]})],2)],2)],1),_vm._v(" "),_c('v-expansion-panel',{attrs:{"expand":""}},[_c('v-expansion-panel-content',{key:'12-a'},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('h3',[_vm._v("Depriciation")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm._f("amount")(_vm.proptotalAsset || 0)))])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((_vm.propassetByBrand),function(asset,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_vm._v(_vm._s(asset.asset)+"/ "+_vm._s(asset.category))]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(_vm._f("amount")(asset.depAmount || 0)))])],1)}),1)],1)],1),_vm._v(" "),_c('v-card'),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"3px"}},[_c('template',{slot:"items"},[_vm._l((_vm.groupExpensesOfTradingAccount),function(expense,e){return [(expense.totalAmount > 0 || expense.openingBalance > 0)?_c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card')],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((expense.invoices),function(section,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_vm._v(_vm._s(new Date(section.date).toLocaleDateString('en-IN')))]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(section.totalAmount || section.openingBalance || '-'))])],1)}),1)],1):_vm._e()]})],2)],2),_vm._v(" "),_c('v-card'),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"3px"}},[_c('template',{slot:"items"},[_vm._l((_vm.groupExpensesOfPandL),function(expense,e){return [(expense.totalAmount > 0 || expense.openingBalance > 0)?_c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card')],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((expense.invoices),function(section,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_vm._v(_vm._s(new Date(section.date).toLocaleDateString('en-IN')))]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(section.totalAmount || section.openingBalance || '-'))])],1)}),1)],1):_vm._e()]})],2)],2),_vm._v(" "),_c('v-expansion-panel',{attrs:{"expand":""}},[_c('v-expansion-panel-content',[_c('v-expansion-panel',{attrs:{"expand":""}},_vm._l((_vm.getStaffAccount),function(staff,e){return _c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card')],1)])}),1)],1)],1),_vm._v(" "),_c('v-expansion-panel',{attrs:{"expand":""}},[_c('v-expansion-panel-content',{key:'12-e'},[_c('v-list',{attrs:{"dense":""}},_vm._l((_vm.assetByBrand),function(asset,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_vm._v(_vm._s(asset.asset)+"/ "+_vm._s(asset.category))]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(_vm._f("amount")(asset.depAmount || 0)))])],1)}),1)],1)],1),_vm._v(" "),_c('v-card',[(_vm.netProfit < 0)?_c('v-card-title',[_c('b',[_vm._v("Net Loss c/d")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm._f("amount")(_vm.netProfit || 0)))])],1):_vm._e()],1),_vm._v(" "),(!!_vm.selectedFirm)?_c('v-card',[_c('v-card-title',[_c('b',[_vm._v("Closing Balance")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm._f("amount")(_vm.closingBalance || 0)))])],1)],1):_vm._e(),_vm._v(" "),_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('b',[_vm._v("Total")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(_vm.propexpenseTotal) + Number.parseFloat(_vm.proptotalAsset) + Number.parseFloat(_vm.closingBalance)   -  Number.parseFloat(_vm.netProfit < 0 ? _vm.netProfit : 0 ))))])],1)],1)],1):_vm._e(),_vm._v(" "),(!props.item.expense)?_c('v-flex',{attrs:{"xs6":"","md6":"","sm6":""}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('b',[_vm._v("Particulars")]),_vm._v(" "),_c('v-spacer'),_vm._v(" Amount\r\n            ")],1)],1),_vm._v(" "),(!!_vm.selectedFirm)?_c('v-card',[_c('v-card-title',[_c('b',[_vm._v(" Opening Balance")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm._f("amount")(_vm.selectedFirm.openingBalance || 0)))])],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"3px"}},[_c('expand-card',{attrs:{"hasItems":_vm.groupIncomesOfPropCapital.length > 0,"value":_vm._f("amount")(_vm.propincomeTotal || 0)}},[_c('template',{slot:"header"},[(_vm.groupIncomesOfPropCapital.length != 0)?_c('b',{staticClass:"subheading font-weight-bold"},[_vm._v("Incomes")]):_vm._e(),_vm._v(" "),(_vm.groupIncomesOfPropCapital.length === 0)?_c('b',{staticClass:"subheading font-weight-bold"},[_vm._v("No Other Income !")]):_vm._e()]),_vm._v(" "),_c('template',{slot:"items"},[_vm._l((_vm.groupIncomesOfPropCapital),function(income,e){return [(income.totalAmount > 0)?_c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-light"},[_vm._v(_vm._s(income.income))]),_vm._v(" / "+_vm._s(income.category)+"\r\n                        "),_c('v-spacer'),_vm._v(" "),_c('h3',{staticClass:"primary--text font-weight-light"},[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(income.totalAmount) + Number.parseFloat(income.openingBalance) || 0)))])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((income.invoices),function(section,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_vm._v(_vm._s(new Date(section.date).toLocaleDateString('en-GB')))]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(_vm._f("amount")(section.totalAmount || section.openingBalance || 0)))])],1)}),1)],1):_vm._e()]})],2)],2)],1),_vm._v(" "),_c('v-card'),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"3px"}},[_c('template',{slot:"items"},[_vm._l((_vm.groupIncomesOfTradingAccount),function(income,e){return [(income.totalAmount > 0 || income.openingBalance > 0)?_c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card')],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((income.invoices),function(section,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_vm._v(_vm._s(new Date(section.date).toLocaleDateString('en-GB')))]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(_vm._f("amount")(section.totalAmount || section.openingBalance || 0)))])],1)}),1)],1):_vm._e()]})],2)],2),_vm._v(" "),_c('v-card'),_vm._v(" "),_c('v-card'),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"3px"}},[_c('template',{slot:"items"},[_vm._l((_vm.groupIncomes),function(income,e){return [(income.totalAmount > 0 || income.openingBalance >0 )?_c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card')],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((income.invoices),function(section,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_vm._v(_vm._s(new Date(section.date).toLocaleDateString('en-GB')))]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(_vm._f("amount")(section.totalAmount || section.openingBalance || 0)))])],1)}),1)],1):_vm._e()]})],2)],2),_vm._v(" "),_c('v-card',[(_vm.netProfit > 0)?_c('v-card-title',[_c('b',[_vm._v("Net profit c/d")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm._f("amount")(_vm.netProfit || 0)))])],1):_vm._e()],1),_vm._v(" "),_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('b',[_vm._v("Total")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(_vm.propAllTotal) + Number.parseFloat(_vm.netProfit > 0 ? _vm.netProfit : 0 ))))])],1)],1)],1):_vm._e()]}}])},[_c('template',{slot:"header"},[_c('v-toolbar',{staticClass:"mb",attrs:{"color":"primary","dark":"","flat":""}},[_c('v-toolbar-title',[_vm._v("Prop Account")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-toolbar',{staticClass:"mb",attrs:{"color":"white white--text","flat":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-autocomplete',{attrs:{"dense":"","flat":"","clearable":"","item-text":"name","return-object":"","items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',[_c('v-menu',{attrs:{"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.fromdatepicker),callback:function ($$v) {_vm.fromdatepicker=$$v},expression:"fromdatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","clearable":"","single-line":"","label":"From Date","readonly":""},slot:"activator",model:{value:(_vm.filterInvoiceFrom),callback:function ($$v) {_vm.filterInvoiceFrom=$$v},expression:"filterInvoiceFrom"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.fromdatepicker = false}},model:{value:(_vm.filterInvoiceFrom),callback:function ($$v) {_vm.filterInvoiceFrom=$$v},expression:"filterInvoiceFrom"}})],1)],1),_vm._v(" "),_c('v-flex',[_c('v-menu',{attrs:{"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.todatepicker),callback:function ($$v) {_vm.todatepicker=$$v},expression:"todatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","clearable":"","label":"To Date","single-line":"","readonly":""},slot:"activator",model:{value:(_vm.filterInvoiceTo),callback:function ($$v) {_vm.filterInvoiceTo=$$v},expression:"filterInvoiceTo"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.todatepicker = false}},model:{value:(_vm.filterInvoiceTo),callback:function ($$v) {_vm.filterInvoiceTo=$$v},expression:"filterInvoiceTo"}})],1)],1)],1)],1)],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Proprietor_vue__ = __webpack_require__(565);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a1bc140_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Proprietor_vue__ = __webpack_require__(1677);
function injectStyle (ssrContext) {
  __webpack_require__(1676)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Proprietor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a1bc140_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Proprietor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1676 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-iterator',{staticClass:"profit",attrs:{"items":_vm.propAccount,"content-tag":"div","content-class":'layout row wrap',"hide-actions":""},scopedSlots:_vm._u([{key:"item",fn:function(props){return [(props.item.expense)?_c('v-flex',{staticStyle:{"display":"flex","flex-direction":"column"},attrs:{"xs6":"","md6":"","sm6":""}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('b',[_c('span',{staticClass:"print-field"},[_vm._v("Particulars")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',{staticClass:"print-field"},[_vm._v("Amount")])],1)],1),_vm._v(" "),(!!_vm.selectedFirm)?_c('v-card'):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"3px"}},[_c('expand-card',{attrs:{"hasItems":_vm.groupExpensesOfPropCapital.length > 0,"value":_vm._f("amount")(_vm.propexpenseTotal  || 0)}},[_c('template',{slot:"header"},[(_vm.groupExpensesOfPropCapital.length != 0)?_c('b',{staticClass:"subheading font-weight-bold"},[_vm._v("Expenses")]):_vm._e(),_vm._v(" "),(_vm.groupExpensesOfPropCapital.length === 0)?_c('b',{staticClass:"subheading font-weight-bold"},[_vm._v("No Expense !")]):_vm._e()]),_vm._v(" "),_c('template',{slot:"items"},[_vm._l((_vm.groupExpensesOfPropCapital),function(expense,e){return [(expense.totalAmount > 0)?_c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('b',{staticClass:"primary--text font-weight-light"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(expense.expense)+" / "+_vm._s(expense.category))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(expense.totalAmount) + Number.parseFloat(expense.openingBalance) || 0)))])])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((expense.invoices),function(section,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(new Date(section.date).toLocaleDateString('en-IN')))])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(section.totalAmount || section.openingBalance || '-'))])])],1)}),1)],1):_vm._e()]})],2)],2)],1),_vm._v(" "),_c('v-expansion-panel',{attrs:{"expand":""}},[_c('v-expansion-panel-content',{key:'12-a'},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("Depriciation")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s('62571.11'))])])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((_vm.propassetByBrand),function(asset,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_c('span',{staticClass:"print-field-1"},[_vm._v(_vm._s(asset.asset)+"/ "+_vm._s(asset.category))])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_c('span',{staticClass:"print-field-1"},[_vm._v(_vm._s(_vm._f("amount")(asset.depAmount || 0)))])])],1)}),1)],1)],1),_vm._v(" "),_c('v-card'),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"3px"}},[_c('template',{slot:"items"},[_vm._l((_vm.groupExpensesOfTradingAccount),function(expense,e){return [(expense.totalAmount > 0 || expense.openingBalance > 0)?_c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card')],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((expense.invoices),function(section,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(new Date(section.date).toLocaleDateString('en-IN')))])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(section.totalAmount || section.openingBalance || '-'))])])],1)}),1)],1):_vm._e()]})],2)],2),_vm._v(" "),_c('v-card'),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"3px"}},[_c('template',{slot:"items"},[_vm._l((_vm.groupExpensesOfPandL),function(expense,e){return [(expense.totalAmount > 0 || expense.openingBalance > 0)?_c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card')],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((expense.invoices),function(section,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(new Date(section.date).toLocaleDateString('en-IN')))])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(section.totalAmount || section.openingBalance || '-'))])])],1)}),1)],1):_vm._e()]})],2)],2),_vm._v(" "),_c('v-expansion-panel',{attrs:{"expand":""}},[_c('v-expansion-panel-content',[_c('v-expansion-panel',{attrs:{"expand":""}},_vm._l((_vm.getStaffAccount),function(staff,e){return _c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card')],1)])}),1)],1)],1),_vm._v(" "),_c('v-expansion-panel',{attrs:{"expand":""}},[_c('v-expansion-panel-content',{key:'12-e'})],1),_vm._v(" "),_c('v-card',[(_vm.netProfit < 0)?_c('v-card-title',[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("Net Loss c/d")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(_vm.netProfit || 0)))])])],1):_vm._e()],1),_vm._v(" "),(!!_vm.selectedFirm)?_c('v-card',[_c('v-card-title',[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("Closing Balance")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(_vm.closingBalance || 0)))])])],1)],1):_vm._e(),_vm._v(" "),_c('v-card',{staticStyle:{"margin-top":"auto"}},[_c('v-card-title',{staticClass:"primary white--text"},[_c('b',[_c('span',{staticClass:"print-field"},[_vm._v("Total")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(_vm.propexpenseTotal) + Number.parseFloat(62571.11) + Number.parseFloat(_vm.closingBalance)   -  Number.parseFloat(_vm.netProfit < 0 ? _vm.netProfit : 0 ))))])])],1)],1)],1):_vm._e(),_vm._v(" "),(!props.item.expense)?_c('v-flex',{staticStyle:{"display":"flex","flex-direction":"column"},attrs:{"xs6":"","md6":"","sm6":""}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('b',[_c('span',{staticClass:"print-field"},[_vm._v("Particulars")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('span',{staticClass:"print-field"},[_vm._v("Amount")])],1)],1),_vm._v(" "),(!!_vm.selectedFirm)?_c('v-card',[_c('v-card-title',[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("Opening Balance")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(_vm.selectedFirm.openingBalance || 0)))])])],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"3px"}},[_c('expand-card',{attrs:{"hasItems":_vm.groupIncomesOfPropCapital.length > 0,"value":_vm._f("amount")(_vm.propincomeTotal || 0)}},[_c('template',{slot:"header"},[(_vm.groupIncomesOfPropCapital.length != 0)?_c('b',{staticClass:"subheading font-weight-bold"},[_vm._v("Incomes")]):_vm._e(),_vm._v(" "),(_vm.groupIncomesOfPropCapital.length === 0)?_c('b',{staticClass:"subheading font-weight-bold"},[_vm._v("No Other Income !")]):_vm._e()]),_vm._v(" "),_c('template',{slot:"items"},[_vm._l((_vm.groupIncomesOfPropCapital),function(income,e){return [_c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('h3',{staticClass:"primary--text font-weight-light"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(income.income)+"  / "+_vm._s(income.category))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',{staticClass:"primary--text font-weight-light"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(income.totalAmount) + Number.parseFloat(income.openingBalance) || 0)))])])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((income.invoices),function(section,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(new Date(section.date).toLocaleDateString('en-GB')))])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(section.totalAmount || section.openingBalance || 0)))])])],1)}),1)],1)]})],2)],2)],1),_vm._v(" "),_c('v-card'),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"3px"}},[_c('template',{slot:"items"},[_vm._l((_vm.groupIncomesOfTradingAccount),function(income,e){return [(income.totalAmount > 0 || income.openingBalance > 0)?_c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card')],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((income.invoices),function(section,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(new Date(section.date).toLocaleDateString('en-GB')))])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(section.totalAmount || section.openingBalance || 0)))])])],1)}),1)],1):_vm._e()]})],2)],2),_vm._v(" "),_c('v-card'),_vm._v(" "),_c('v-card'),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"3px"}},[_c('template',{slot:"items"},[_vm._l((_vm.groupIncomes),function(income,e){return [(income.totalAmount > 0 || income.openingBalance >0 )?_c('v-expansion-panel-content',{key:e},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card')],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((income.invoices),function(section,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(new Date(section.date).toLocaleDateString('en-GB')))])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(section.totalAmount || section.openingBalance || 0)))])])],1)}),1)],1):_vm._e()]})],2)],2),_vm._v(" "),_c('v-card',[(_vm.netProfit >= 0)?_c('v-card-title',[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("Net profit c/d")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(_vm.netProfit || 0)))])])],1):_vm._e()],1),_vm._v(" "),_c('v-card',{staticStyle:{"margin-top":"auto"}},[_c('v-card-title',{staticClass:"primary white--text"},[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("Total")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(_vm.propAllTotal) + Number.parseFloat(_vm.netProfit > 0 ? _vm.netProfit : 0 ))))])])],1)],1)],1):_vm._e()]}}])},[_c('template',{slot:"header"},[_c('v-toolbar',{staticClass:"mb",attrs:{"color":"primary","dark":"","flat":""}},[_c('v-toolbar-title',[_vm._v("Proprietor Capital Account")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.print()}}},[_c('v-icon',[_vm._v("print")])],1),_vm._v(" "),_c('router-link',{attrs:{"to":"/Dashboard"}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("close")])],1)],1)],1),_vm._v(" "),_c('v-toolbar',{staticClass:"mb",attrs:{"color":"white white--text","flat":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","md4":"","sm4":""}},[_c('v-autocomplete',{attrs:{"dense":"","flat":"","clearable":"","item-text":"name","return-object":"","items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":"","sm3":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px","clearable":""},model:{value:(_vm.fromdatepicker),callback:function ($$v) {_vm.fromdatepicker=$$v},expression:"fromdatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","clearable":"","single-line":"","label":"From Date","readonly":""},slot:"activator",model:{value:(_vm.filterInvoiceFrom),callback:function ($$v) {_vm.filterInvoiceFrom=$$v},expression:"filterInvoiceFrom"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.fromdatepicker = false}},model:{value:(_vm.filterInvoiceFrom),callback:function ($$v) {_vm.filterInvoiceFrom=$$v},expression:"filterInvoiceFrom"}})],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":"","sm3":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.todatepicker),callback:function ($$v) {_vm.todatepicker=$$v},expression:"todatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","clearable":"","label":"To Date","single-line":"","readonly":""},slot:"activator",model:{value:(_vm.filterInvoiceTo),callback:function ($$v) {_vm.filterInvoiceTo=$$v},expression:"filterInvoiceTo"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.todatepicker = false}},model:{value:(_vm.filterInvoiceTo),callback:function ($$v) {_vm.filterInvoiceTo=$$v},expression:"filterInvoiceTo"}})],1)],1)],1)],1)],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(566);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3447096_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1679);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c3447096_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","align":"center"}},[_c('v-flex',{staticClass:"d-flex",attrs:{"cols":"24","sm":"24"}},[_c('v-data-iterator',{attrs:{"items":_vm.processedItems,"content-tag":"v-layout","hide-actions":""},scopedSlots:_vm._u([{key:"item",fn:function(props){return [_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('h2',[_vm._v(_vm._s(props.item.name))])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((props.item.values),function(item){return _c('v-list-tile',{key:item.key},[_c('v-list-tile-content',[_c('h2',[_vm._v(_vm._s(item.key)+":")])]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_c('h2',[_vm._v(_vm._s(item.value))])])],1)}),1)],1)],1)]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(567);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44aafb86_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1681);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44aafb86_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","offset-sm":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"text-xs-center"},[_vm._v("Interest Account")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{staticClass:"primary white--text",on:{"click":function($event){$event.stopPropagation();_vm.dialog = true}}},[_c('v-icon',[_vm._v("close")])],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.filteredInvoices},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item['.key']))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.date))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.firmName))])]),_vm._v(" "),_c('td',{staticClass:"nowrap"},[_c('b',[_vm._v(_vm._s(props.item.rate)+" ")]),_vm._v("%")]),_vm._v(" "),_c('td',{staticClass:"nowrap"},[_c('b',[_vm._v("₹ "+_vm._s(props.item.totalAmount))])]),_vm._v(" "),_c('td',{staticClass:"nowrap"},[_c('b',[_vm._v("₹ "+_vm._s(props.item.interestValue))])]),_vm._v(" "),_c('td',{staticClass:"nowrap"},[_c('b',[_vm._v("₹ "+_vm._s(props.item.totalValue))])])]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(568);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b2644c2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1683);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b2644c2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","offset-sm":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"text-xs-center"},[_vm._v("Alert List")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('router-link',{attrs:{"to":"/Dashboard"}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("close")])],1)],1)],1),_vm._v(" "),_c('v-toolbar',{staticClass:"mb",attrs:{"color":"white--text","flat":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","md4":"","sm4":""}},[_c('v-autocomplete',{attrs:{"dense":"","flat":"","clearable":"","item-text":"name","return-object":"","items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":"","sm3":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.fromdatepicker),callback:function ($$v) {_vm.fromdatepicker=$$v},expression:"fromdatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","clearable":"","single-line":"","label":"From Date","readonly":""},slot:"activator",model:{value:(_vm.filterInvoiceFrom),callback:function ($$v) {_vm.filterInvoiceFrom=$$v},expression:"filterInvoiceFrom"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.fromdatepicker = false}},model:{value:(_vm.filterInvoiceFrom),callback:function ($$v) {_vm.filterInvoiceFrom=$$v},expression:"filterInvoiceFrom"}})],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":"","sm3":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.todatepicker),callback:function ($$v) {_vm.todatepicker=$$v},expression:"todatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","clearable":"","label":"To Date","single-line":"","readonly":""},slot:"activator",model:{value:(_vm.filterInvoiceTo),callback:function ($$v) {_vm.filterInvoiceTo=$$v},expression:"filterInvoiceTo"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.todatepicker = false}},model:{value:(_vm.filterInvoiceTo),callback:function ($$v) {_vm.filterInvoiceTo=$$v},expression:"filterInvoiceTo"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.filteredAlerts},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.date))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"primary--text"},[_vm._v(" "+_vm._s(props.item.buyerName))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item['invoiceId']))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',{staticClass:"red--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item.totalAmount || 0)))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.daysLeft))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.duration))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.mobile))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.propName))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.tehsil))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.district))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.firmName))])])]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(569);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_023d7d1b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1685);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_023d7d1b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","offset-sm":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"text-xs-center"},[_vm._v("Bad Debts")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{staticClass:"primary white--text",on:{"click":function($event){$event.stopPropagation();_vm.dialog = true}}},[_c('v-icon',[_vm._v("close")])],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.filteredInvoices},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.buyerName))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.propName))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.buyerId))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.mobile))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.village))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.block))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.tehsil))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.district))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.mobileNo))])])]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(570);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21389ab4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1687);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_21389ab4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","offset-sm":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"text-xs-center"},[_vm._v("Unpaid Invoices")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('router-link',{attrs:{"to":"/Dashboard"}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("close")])],1)],1)],1),_vm._v(" "),_c('v-toolbar',{staticClass:"mb",attrs:{"color":"white--text","flat":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","md4":"","sm4":""}},[_c('v-autocomplete',{attrs:{"dense":"","flat":"","clearable":"","item-text":"name","return-object":"","items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":"","sm3":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.fromdatepicker),callback:function ($$v) {_vm.fromdatepicker=$$v},expression:"fromdatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","clearable":"","single-line":"","label":"From Date","readonly":""},slot:"activator",model:{value:(_vm.filterInvoiceFrom),callback:function ($$v) {_vm.filterInvoiceFrom=$$v},expression:"filterInvoiceFrom"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.fromdatepicker = false}},model:{value:(_vm.filterInvoiceFrom),callback:function ($$v) {_vm.filterInvoiceFrom=$$v},expression:"filterInvoiceFrom"}})],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":"","sm3":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.todatepicker),callback:function ($$v) {_vm.todatepicker=$$v},expression:"todatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","clearable":"","label":"To Date","single-line":"","readonly":""},slot:"activator",model:{value:(_vm.filterInvoiceTo),callback:function ($$v) {_vm.filterInvoiceTo=$$v},expression:"filterInvoiceTo"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.todatepicker = false}},model:{value:(_vm.filterInvoiceTo),callback:function ($$v) {_vm.filterInvoiceTo=$$v},expression:"filterInvoiceTo"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.unpickItems},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.date))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.buyerName))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.invoiceId))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',{staticClass:"font-weight-bold red--text"},[_vm._v(_vm._s(_vm._f("amount")(props.item.totalAmount || 0)))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',{domProps:{"innerHTML":_vm._s(props.item.daysLeft ? ((props.item.daysLeft) + " days") : '')}})]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.status))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.mobile))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.propName))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.tehsil))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.district))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.firmName))])])]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(571);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38525ed9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1689);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38525ed9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-iterator',{attrs:{"items":_vm.items,"content-tag":"v-layout","hide-actions":""},scopedSlots:_vm._u([{key:"item",fn:function(props){return [_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":"","lg3":""}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Expense Account:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.expaccount))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Asset Account:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.assetaccount))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Other Income Account:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.otherincomeaccount))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Item Account:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.itemaccount))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Interest Account:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.intaccount))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Buyer Account:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.custaccount))])],1)],1)],1)],1)]}}])},[_c('template',{slot:"header"},[_c('v-toolbar',{staticClass:"mb-2",attrs:{"color":"primary","dark":"","flat":""}},[_c('v-toolbar-title',[_vm._v("Firms Sheet")])],1)],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(572);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a33a9284_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(1691);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a33a9284_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","offset-sm":""}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',{staticClass:"text-xs-center"},[_vm._v("Bank Transactions")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-title',{staticClass:"text-xs-center"},[_vm._v("A/C Holder Name")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-title',{staticClass:"text-xs-center"},[_vm._v("Financial Year")])],1),_vm._v(" "),_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-sub-title',{staticClass:"text-xs-center"},[_vm._v("Bank Name")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-sub-title',{staticClass:"text-xs-center"},[_vm._v("Account Holder Name")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-sub-title',{staticClass:"text-xs-center"},[_vm._v("Account Number")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-sub-title',{staticClass:"text-xs-center"},[_vm._v("Account Type")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-sub-title',{staticClass:"text-xs-center"},[_vm._v("Firm Name")])],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.desserts},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.date))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.transactionID))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.transactionType))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v("₹"+_vm._s(props.item.debited))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v("₹"+_vm._s(props.item.credited))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v("₹"+_vm._s(props.item.balance))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.description))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.remark))])])]}}])})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CashAccounts_vue__ = __webpack_require__(573);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c63a60e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CashAccounts_vue__ = __webpack_require__(1694);
function injectStyle (ssrContext) {
  __webpack_require__(1693)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CashAccounts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c63a60e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CashAccounts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1693 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-iterator',{staticClass:"profit",attrs:{"items":_vm.cashBook,"content-tag":"div","content-class":'layout row wrap',"hide-actions":""},scopedSlots:_vm._u([{key:"item",fn:function(props){return [(props.item.expense)?_c('v-flex',{staticStyle:{"display":"flex","flex-direction":"column"},attrs:{"xs6":"","md6":"","sm6":""}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("Particulars")])]),_vm._v(" "),_c('v-spacer'),_c('span',{staticClass:"print-field"},[_vm._v("Amount")])],1)],1),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("Opening Balance")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.selectedFirm)?_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingAmount || 0)))])]):_vm._e()],1)],1),_vm._v(" "),_c('expand-card',{attrs:{"hasItems":_vm.cashSale.invoice.length > 0,"value":_vm._f("amount")(_vm.cashSale.total || 0)}},[_c('template',{slot:"header"},[_c('b',[_c('span',{staticClass:"print-field"},[_vm._v("Cash Sale")])])]),_vm._v(" "),_c('template',{slot:"items"},[_vm._l((_vm.cashSale.invoice),function(cash,c){return [_c('v-expansion-panel-content',{key:c},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('h3',{staticClass:"primary--text font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(cash.userName))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',{staticClass:"primary--text font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(cash.amount || 0)))])])],1)],1)],1)])]})],2)],2),_vm._v(" "),_c('expand-card',{attrs:{"hasItems":_vm.receipts.invoice.length > 0,"value":_vm._f("amount")(_vm.receipts.total || 0)}},[_c('template',{slot:"header"},[_c('b',[_c('span',{staticClass:"print-field"},[_vm._v("Receipts")])])]),_vm._v(" "),_c('template',{slot:"items"},[_vm._l((_vm.receipts.invoice),function(receipt,r){return [_c('v-expansion-panel-content',{key:r},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('h3',{staticClass:"primary--text font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(receipt.userName))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',{staticClass:"primary--text font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(receipt.amount || 0)))])])],1)],1)],1)])]})],2)],2),_vm._v(" "),_c('v-card',{staticStyle:{"margin-top":"auto"}},[_c('v-card-title',{staticClass:"primary white--text"},[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("Total")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(_vm.receipts.total) + Number.parseFloat(_vm.cashSale.total) + 
               Number.parseFloat(_vm.getClosingAmount))))])])],1)],1)],1):_vm._e(),_vm._v(" "),(!props.item.expense)?_c('v-flex',{staticStyle:{"display":"flex","flex-direction":"column"},attrs:{"xs6":"","md6":"","sm6":""}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("Particulars")])]),_vm._v(" "),_c('v-spacer'),_c('span',{staticClass:"print-field"},[_vm._v(" Amount ")])],1)],1),_vm._v(" "),_c('expand-card',{attrs:{"hasItems":_vm.expenses.invoice.length > 0,"value":_vm._f("amount")(_vm.expenses.total || 0)}},[_c('template',{slot:"header"},[_c('b',[_c('span',{staticClass:"print-field"},[_vm._v("Expenses")])])]),_vm._v(" "),_c('template',{slot:"items"},[_vm._l((_vm.expenses.invoice),function(exp,ex){return [_c('v-expansion-panel-content',{key:ex},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('h3',{staticClass:"primary--text font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(exp.name))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',{staticClass:"primary--text font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(exp.amount || 0)))])])],1)],1)],1)])]})],2)],2),_vm._v(" "),_c('expand-card',{attrs:{"hasItems":_vm.payments.invoice.length > 0,"value":_vm._f("amount")(_vm.payments.total || 0)}},[_c('template',{slot:"header"},[_c('b',[_c('span',{staticClass:"print-field"},[_vm._v("Payments")])])]),_vm._v(" "),_c('template',{slot:"items"},[_vm._l((_vm.payments.invoice),function(pay,p){return [_c('v-expansion-panel-content',{key:p},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-card',[_c('v-card-title',[_c('h3',{staticClass:"primary--text font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(pay.userName))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',{staticClass:"primary--text font-weight-bold"},[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(pay.amount || 0)))])])],1)],1)],1)])]})],2)],2),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("Closing Balance")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingAmountOfDay || 0)))])])],1)],1),_vm._v(" "),_c('v-card',{staticStyle:{"margin-top":"auto"}},[_c('v-card-title',{staticClass:"primary white--text"},[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("Total")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(_vm.getClosingAmountOfDay) + Number.parseFloat(_vm.payments.total) + Number.parseFloat(_vm.expenses.total) || 0)))])])],1)],1)],1):_vm._e()]}}])},[_c('template',{slot:"header"},[_c('v-toolbar',{staticClass:"mb",attrs:{"color":"primary","dark":"","flat":""}},[_c('v-toolbar-title',{staticClass:"font-weight-light"},[_vm._v("Cash Book")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.print()}}},[_c('v-icon',[_vm._v("print")])],1),_vm._v(" "),_c('router-link',{attrs:{"to":"/Dashboard"}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("close")])],1)],1)],1),_vm._v(" "),_c('v-toolbar',{staticClass:"mb",attrs:{"color":"white white--text","flat":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-autocomplete',{attrs:{"dense":"","flat":"","clearable":"","item-text":"name","return-object":"","items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker),callback:function ($$v) {_vm.datepicker=$$v},expression:"datepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","clearable":"","single-line":"","label":"Date","readonly":""},slot:"activator",model:{value:(_vm.selectedDate),callback:function ($$v) {_vm.selectedDate=$$v},expression:"selectedDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepicker = false}},model:{value:(_vm.selectedDate),callback:function ($$v) {_vm.selectedDate=$$v},expression:"selectedDate"}})],1)],1)],1)],1)],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gstAccounts_vue__ = __webpack_require__(574);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_658df617_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gstAccounts_vue__ = __webpack_require__(1697);
function injectStyle (ssrContext) {
  __webpack_require__(1696)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_gstAccounts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_658df617_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_gstAccounts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1696 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('h2',{staticClass:"font-weight-light headline"},[_vm._v("\n          GST Reports \n        ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-select',{staticClass:"select-firm",attrs:{"items":[
            {
                    text: 'All Accounts',
                    value: 'All Accounts'
                  }, {
                    text: 'CGST Accounts',
                    value: 'CGST Accounts'
                  }, {
                    text: 'SGST Accounts',
                    value: 'SGST Accounts'
                  }, {
                    text: 'IGST Accounts',
                    value: 'IGST Accounts'
                  }, {
                    text: 'CGST+SGST Accounts',
                    value: 'CGST+SGST Accounts'
                  }
            ],"label":"Select GST Category","clearable":""},model:{value:(_vm.selectedAccount),callback:function ($$v) {_vm.selectedAccount=$$v},expression:"selectedAccount"}})],1)],1),_vm._v(" "),_c('v-toolbar',{staticClass:"mb",attrs:{"color":"white white--text","flat":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-select',{attrs:{"item-text":"name","return-object":"","items":_vm.firmsByBrand,"label":"Select Firm","clearable":""},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerFrom),callback:function ($$v) {_vm.datepickerFrom=$$v},expression:"datepickerFrom"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"From Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.fromDate),callback:function ($$v) {_vm.fromDate=$$v},expression:"fromDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerFrom = false}},model:{value:(_vm.fromDate),callback:function ($$v) {_vm.fromDate=$$v},expression:"fromDate"}})],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerTo),callback:function ($$v) {_vm.datepickerTo=$$v},expression:"datepickerTo"}},[_c('v-text-field',{attrs:{"slot":"activator","clearable":"","label":"To Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.toDate),callback:function ($$v) {_vm.toDate=$$v},expression:"toDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerTo = false}},model:{value:(_vm.toDate),callback:function ($$v) {_vm.toDate=$$v},expression:"toDate"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":""}},[_c('table',{staticClass:"fl2-table"},[_c('thead',[_c('tr',[_c('th',{attrs:{"colspan":"6"}},[_c('h2',{staticStyle:{"display":"contents"}},[_vm._v("OUTWARDS")]),_vm._v(" "),_c('v-btn',{staticStyle:{"float":"right"}},[_c('v-icon',[_vm._v("add")]),_vm._v("\n                    Add\n                ")],1)],1)]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Date")]),_vm._v(" "),_c('th',[_vm._v("3%")]),_vm._v(" "),_c('th',[_vm._v("5%")]),_vm._v(" "),_c('th',[_vm._v("12%")]),_vm._v(" "),_c('th',[_vm._v("18%")]),_vm._v(" "),_c('th',[_vm._v("28%")])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.buyerInvoices),function(item,index){return _c('tr',{key:'outward'+index},[(item.date)?_c('td',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(new Date(item.date).toLocaleDateString('en-GB')))]):_vm._e(),_vm._v(" "),(item.val_3)?_c('td',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(item.val_3 || 0)))]):_c('td',[_vm._v("0")]),_vm._v(" "),(item.val_5)?_c('td',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(item.val_5  || 0)))]):_c('td',[_vm._v("0")]),_vm._v(" "),(item.val_12)?_c('td',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(item.val_12  || 0)))]):_c('td',[_vm._v("0")]),_vm._v(" "),(item.val_18)?_c('td',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(item.val_18  || 0)))]):_c('td',[_vm._v("0")]),_vm._v(" "),(item.val_28)?_c('td',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(item.val_28  || 0)))]):_c('td',[_vm._v("0")])])}),_vm._v(" "),_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v("Total")]),_vm._v(" "),(_vm.totalBuyer && _vm.totalBuyer.val_3)?_c('td',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(_vm.totalBuyer.val_3 || 0)))]):_c('td',[_vm._v("0")]),_vm._v(" "),(_vm.totalBuyer && _vm.totalBuyer.val_5)?_c('td',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(_vm.totalBuyer.val_5 || 0)))]):_c('td',[_vm._v("0")]),_vm._v(" "),(_vm.totalBuyer && _vm.totalBuyer.val_12)?_c('td',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(_vm.totalBuyer.val_12 || 0)))]):_c('td',[_vm._v("0")]),_vm._v(" "),(_vm.totalBuyer && _vm.totalBuyer.val_18)?_c('td',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(_vm.totalBuyer.val_18 || 0)))]):_c('td',[_vm._v("0")]),_vm._v(" "),(_vm.totalBuyer && _vm.totalBuyer.val_28)?_c('td',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(_vm.totalBuyer.val_28 || 0)))]):_c('td',[_vm._v("0")])])],2)])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('table',{staticClass:"fl2-table"},[_c('thead',[_c('tr',[_c('th',{attrs:{"colspan":"6"}},[_c('h2',{staticStyle:{"display":"contents"}},[_vm._v("INWARD")]),_vm._v(" "),_c('v-btn',{staticStyle:{"float":"right"}},[_c('v-icon',[_vm._v("add")]),_vm._v("\n                    Add \n                ")],1)],1)]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("Date")]),_vm._v(" "),_c('th',[_vm._v("3%")]),_vm._v(" "),_c('th',[_vm._v("5%")]),_vm._v(" "),_c('th',[_vm._v("12%")]),_vm._v(" "),_c('th',[_vm._v("18%")]),_vm._v(" "),_c('th',[_vm._v("28%")])])]),_vm._v(" "),_c('tbody',[_vm._l((_vm.sellerInvoices),function(item,index){return _c('tr',{key:'inward'+index},[(item.date)?_c('td',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(new Date(item.date).toLocaleDateString('en-GB')))]):_vm._e(),_vm._v(" "),(item.val_3)?_c('td',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(item.val_3 || 0)))]):_c('td',[_vm._v("0")]),_vm._v(" "),(item.val_5)?_c('td',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(item.val_5 || 0)))]):_c('td',[_vm._v("0")]),_vm._v(" "),(item.val_12)?_c('td',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(item.val_12 || 0)))]):_c('td',[_vm._v("0")]),_vm._v(" "),(item.val_18)?_c('td',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(item.val_18 || 0)))]):_c('td',[_vm._v("0")]),_vm._v(" "),(item.val_28)?_c('td',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(item.val_28 || 0)))]):_c('td',[_vm._v("0")])])}),_vm._v(" "),_c('tr',[_c('td',{staticClass:"font-weight-bold"},[_vm._v("Total")]),_vm._v(" "),(_vm.totalSeller && _vm.totalSeller.val_3)?_c('td',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(_vm.totalSeller.val_3   || 0)))]):_c('td',[_vm._v("0")]),_vm._v(" "),(_vm.totalSeller && _vm.totalSeller.val_5)?_c('td',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(_vm.totalSeller.val_5   || 0)))]):_c('td',[_vm._v("0")]),_vm._v(" "),(_vm.totalSeller && _vm.totalSeller.val_12)?_c('td',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(_vm.totalSeller.val_12 || 0)))]):_c('td',[_vm._v("0")]),_vm._v(" "),(_vm.totalSeller && _vm.totalSeller.val_18)?_c('td',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(_vm.totalSeller.val_18 || 0)))]):_c('td',[_vm._v("0")]),_vm._v(" "),(_vm.totalSeller && _vm.totalSeller.val_28)?_c('td',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(_vm.totalSeller.val_28 || 0)))]):_c('td',[_vm._v("0")])])],2)])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DiscountAccounts_vue__ = __webpack_require__(575);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a2ae32c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DiscountAccounts_vue__ = __webpack_require__(1700);
function injectStyle (ssrContext) {
  __webpack_require__(1699)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DiscountAccounts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a2ae32c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DiscountAccounts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1699 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-flex',{attrs:{"xs12":""}},[_c('h2',{staticClass:"headline font-weight-light"},[_vm._v("\n          Discount Account\n        ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('router-link',{attrs:{"to":"/Dashboard"}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("close")])],1)],1)],1),_vm._v(" "),_c('v-toolbar',{staticClass:"mb",attrs:{"color":"white--text","flat":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-autocomplete',{attrs:{"dense":"","flat":"","clearable":"","item-text":"name","return-object":"","items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.fromdatepicker),callback:function ($$v) {_vm.fromdatepicker=$$v},expression:"fromdatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","clearable":"","single-line":"","label":"From Date","readonly":""},slot:"activator",model:{value:(_vm.filterInvoiceFrom),callback:function ($$v) {_vm.filterInvoiceFrom=$$v},expression:"filterInvoiceFrom"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.fromdatepicker = false}},model:{value:(_vm.filterInvoiceFrom),callback:function ($$v) {_vm.filterInvoiceFrom=$$v},expression:"filterInvoiceFrom"}})],1)],1),_vm._v(" "),_c('v-flex',[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.todatepicker),callback:function ($$v) {_vm.todatepicker=$$v},expression:"todatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","clearable":"","label":"To Date","single-line":"","readonly":""},slot:"activator",model:{value:(_vm.filterInvoiceTo),callback:function ($$v) {_vm.filterInvoiceTo=$$v},expression:"filterInvoiceTo"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.todatepicker = false}},model:{value:(_vm.filterInvoiceTo),callback:function ($$v) {_vm.filterInvoiceTo=$$v},expression:"filterInvoiceTo"}})],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.invoiceHeader,"items":_vm.getInvoice},scopedSlots:_vm._u([{key:"items",fn:function(props){return [(props.item['type'] != 'total')?[_c('td',{staticClass:"primary--text font-weight-bold",domProps:{"innerHTML":_vm._s(_vm.renderDate(props.item.date))}}),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['invoiceId']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.getCurrentUserName(props.item.buyerId)))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text"},[_vm._v(_vm._s(_vm._f("amount")(props.item['debit'] || 0)))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"red--text"},[_vm._v(_vm._s(_vm._f("amount")(props.item['credit']  || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.paymentType))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.getFirmName(props.item.firm)))])])]:[_c('td',[_c('b',[_vm._v("Total")])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text"},[_vm._v(_vm._s(_vm._f("amount")(props.item['debit']  || 0)))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"red--text"},[_vm._v(_vm._s(_vm._f("amount")(props.item['credit']  || 0)))])]),_vm._v(" "),_c('td')]]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InterestAccounts_vue__ = __webpack_require__(576);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d1c989c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InterestAccounts_vue__ = __webpack_require__(1703);
function injectStyle (ssrContext) {
  __webpack_require__(1702)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InterestAccounts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d1c989c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InterestAccounts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1702 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-flex',{attrs:{"xs12":""}},[_c('h2',{staticClass:" headline font-weight-light"},[_vm._v("\n          Interest Account\n        ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('router-link',{attrs:{"to":"/Dashboard"}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("close")])],1)],1)],1),_vm._v(" "),_c('v-toolbar',{staticClass:"mb",attrs:{"color":"white--text","flat":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-autocomplete',{attrs:{"dense":"","flat":"","clearable":"","item-text":"name","return-object":"","items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.fromdatepicker),callback:function ($$v) {_vm.fromdatepicker=$$v},expression:"fromdatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","clearable":"","single-line":"","label":"From Date","readonly":""},slot:"activator",model:{value:(_vm.filterInvoiceFrom),callback:function ($$v) {_vm.filterInvoiceFrom=$$v},expression:"filterInvoiceFrom"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.fromdatepicker = false}},model:{value:(_vm.filterInvoiceFrom),callback:function ($$v) {_vm.filterInvoiceFrom=$$v},expression:"filterInvoiceFrom"}})],1)],1),_vm._v(" "),_c('v-flex',[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.todatepicker),callback:function ($$v) {_vm.todatepicker=$$v},expression:"todatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","clearable":"","label":"To Date","single-line":"","readonly":""},slot:"activator",model:{value:(_vm.filterInvoiceTo),callback:function ($$v) {_vm.filterInvoiceTo=$$v},expression:"filterInvoiceTo"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.todatepicker = false}},model:{value:(_vm.filterInvoiceTo),callback:function ($$v) {_vm.filterInvoiceTo=$$v},expression:"filterInvoiceTo"}})],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.invoiceHeader,"items":_vm.getInvoice},scopedSlots:_vm._u([{key:"items",fn:function(props){return [(props.item['type'] != 'total')?[_c('td',{staticClass:"primary--text font-weight-bold",domProps:{"innerHTML":_vm._s(_vm.renderDate(props.item.date))}}),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.getCurrentUserName(props.item.buyerId)))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"primary--text"},[_vm._v(_vm._s(_vm._f("amount")(props.item.amount || 0)))])]),_vm._v(" "),_c('td',[(props.item['type']=='LoanGiven')?_c('b',{staticClass:"green--text"},[_vm._v(_vm._s(_vm._f("amount")(props.item.paidInterest || 0)))]):(props.item['type']=='Opening Balance' && props.item['parentType']=='LoanGiven')?_c('b',{staticClass:"green--text"},[_vm._v(_vm._s(_vm._f("amount")(props.item.paidInterest || 0)))]):_vm._e()]),_vm._v(" "),_c('td',[(props.item['type']=='LoanTaken')?_c('b',{staticClass:"red--text"},[_vm._v(_vm._s(_vm._f("amount")(props.item.paidInterest || 0)))]):(props.item['type']=='Opening Balance' && props.item['parentType']=='LoanTaken')?_c('b',{staticClass:"red--text"},[_vm._v(_vm._s(_vm._f("amount")(props.item.paidInterest || 0)))]):_vm._e()]),_vm._v(" "),_c('td',[_c('b',{staticClass:"success--text"},[_vm._v(_vm._s(_vm._f("amount")((Number.parseFloat(props.item.paidInterest) + Number.parseFloat(props.item.amount))|| 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.paymentType))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.getFirmName(props.item.firm)))])])]:[_c('td',[_c('b',[_vm._v("Total")])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text"},[_vm._v(_vm._s(_vm._f("amount")(props.item['debit'] || 0)))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"red--text"},[_vm._v(_vm._s(_vm._f("amount")(props.item['credit'] || 0)))])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')]]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrailBalanceAccount_vue__ = __webpack_require__(577);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7979418_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrailBalanceAccount_vue__ = __webpack_require__(1706);
function injectStyle (ssrContext) {
  __webpack_require__(1705)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrailBalanceAccount_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c7979418_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrailBalanceAccount_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1705 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"trail-balance",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"mb",attrs:{"color":"primary","dark":"","flat":""}},[_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('h2',{staticClass:"font-weight-light headline"},[_vm._v("\n          Trail Balance\n        ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-switch',{staticClass:"filter-switch1",attrs:{"label":("Enlarge View: " + (_vm.detailedView ? 'Yes' : 'No'))},model:{value:(_vm.detailedView),callback:function ($$v) {_vm.detailedView=$$v},expression:"detailedView"}})],1)],1),_vm._v(" "),_c('v-toolbar',{staticClass:"mb",attrs:{"color":"white white--text","flat":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":"","md4":""}},[_c('v-select',{attrs:{"item-text":"name","return-object":"","items":_vm.firmsByBrand,"label":"Select Firm","clearable":""},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerFrom),callback:function ($$v) {_vm.datepickerFrom=$$v},expression:"datepickerFrom"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"From Date","prepend-icon":"event","readonly":"","clearable":""},slot:"activator",model:{value:(_vm.fromDate),callback:function ($$v) {_vm.fromDate=$$v},expression:"fromDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerFrom = false}},model:{value:(_vm.fromDate),callback:function ($$v) {_vm.fromDate=$$v},expression:"fromDate"}})],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerTo),callback:function ($$v) {_vm.datepickerTo=$$v},expression:"datepickerTo"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"To Date","prepend-icon":"event","readonly":"","clearable":""},slot:"activator",model:{value:(_vm.toDate),callback:function ($$v) {_vm.toDate=$$v},expression:"toDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerTo = false}},model:{value:(_vm.toDate),callback:function ($$v) {_vm.toDate=$$v},expression:"toDate"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('table',{staticClass:"fl2-table"},[_c('thead',[_c('tr',[_c('th',{attrs:{"rowspan":"2"}},[_vm._v("S.No")]),_vm._v(" "),_c('th',{attrs:{"rowspan":"2"}},[_vm._v("DESCRIPTION")]),_vm._v(" "),_c('th',{attrs:{"colspan":_vm.detailedView ? 4 : 2}},[_vm._v("BALANCE")])]),_vm._v(" "),_c('tr',[(_vm.detailedView)?_c('th',{staticStyle:{"text-align":"right"}},[_vm._v("OPENING")]):_vm._e(),_vm._v(" "),_c('th',[_vm._v("DEBIT")]),_vm._v(" "),_c('th',[_vm._v("CREDIT")]),_vm._v(" "),(_vm.detailedView)?_c('th',{staticStyle:{"text-align":"right"}},[_vm._v("CLOSING")]):_vm._e()])]),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_c('h3',[_vm._v("1")]),_vm._v(" "),_c('span',{staticStyle:{"display":"grid"}},[(!_vm.firmObj.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.firmObj)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.firmObj.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.firmObj)}}},[_vm._v("expand_less")]):_vm._e()],1)]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h3',[_vm._v(" PROP CAPITAL ACCOUNT")])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.firmObj.total || 0)))]):_vm._e(),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h3',{staticClass:"red--text"},[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.firmObj.total || 0)))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance(_vm.firmObj.total,0,_vm.firmObj.total) || 0)))]):_vm._e()]),_vm._v(" "),(_vm.firmObj.expand)?[_vm._l((_vm.firmObj.list),function(firm){return [_c('tr',{key:firm['.key']},[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h4',[_vm._v(_vm._s(firm.name))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(firm.openingBalance || 0)))]):_vm._e(),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('b',{staticClass:"red--text"},[_c('h4',[_vm._v(" "+_vm._s(_vm._f("amount")(firm.openingBalance || 0)))])])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance(firm.openingBalance,0,firm.openingBalance) || 0)))]):_vm._e()])]})]:_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_c('h3',[_vm._v("2")]),_vm._v(" "),_c('span',{staticStyle:{"display":"grid"}},[(!_vm.loanObj.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.loanObj)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.loanObj.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.loanObj)}}},[_vm._v("expand_less")]):_vm._e()],1)]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h3',[_vm._v("LOANS")])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")((_vm.securedLoansBankListTotalOpening + _vm.totalUnsecuredLoanOpening) || 0)))]):_vm._e(),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h3',{staticClass:"red--text"},[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.securedLoansBankListTotal + _vm.totalLoan || 0)))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance((_vm.securedLoansBankListTotalOpening + _vm.totalUnsecuredLoanOpening),0,(_vm.securedLoansBankListTotal+_vm.totalLoan)) || 0)))]):_vm._e()]),_vm._v(" "),(_vm.loanObj.expand)?[_c('tr',[_c('td',[_c('h3'),_vm._v(" "),_c('span',{staticStyle:{"display":"grid"}},[(!_vm.loanObj.securedLoanObj.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.loanObj.securedLoanObj)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.loanObj.securedLoanObj.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.loanObj.securedLoanObj)}}},[_vm._v("expand_less")]):_vm._e()],1)]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h3',[_vm._v("Secured Loans")])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")((_vm.securedLoansBankListTotalOpening ) || 0)))]):_vm._e(),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h3',{staticClass:"red--text"},[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.securedLoansBankListTotal || 0)))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance((_vm.securedLoansBankListTotalOpening),0,(_vm.securedLoansBankListTotal)) || 0)))]):_vm._e()]),_vm._v(" "),(_vm.loanObj.securedLoanObj.expand)?[_vm._l((_vm.securedLoansBankList),function(bank){return [_c('tr',{key:bank['.key']},[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h4',[_vm._v(_vm._s(bank.bankName))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(" "+_vm._s(_vm._f("amount")(bank.openingBalance || 0)))]):_vm._e(),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('b',{staticClass:"red--text"},[_c('h4',[_vm._v(" "+_vm._s(_vm._f("amount")(bank.amount || 0)))])])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance(bank.openingBalance,0,bank.amount) || 0)))]):_vm._e()])]})]:_vm._e()]:_vm._e(),_vm._v(" "),(_vm.loanObj.expand)?[_c('tr',[_c('td',[_c('h3'),_vm._v(" "),_c('span',{staticStyle:{"display":"grid"}},[(!_vm.loanObj.unsecuredLoanObj.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.loanObj.unsecuredLoanObj)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.loanObj.unsecuredLoanObj.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.loanObj.unsecuredLoanObj)}}},[_vm._v("expand_less")]):_vm._e()],1)]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h3',[_vm._v("Unsecured Loans")])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.totalUnsecuredLoanOpening || 0)))]):_vm._e(),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h3',{staticClass:"red--text"},[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.totalLoan || 0)))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance(_vm.totalUnsecuredLoanOpening,0,_vm.totalLoan) || 0)))]):_vm._e()]),_vm._v(" "),(_vm.loanObj.unsecuredLoanObj.expand)?[_vm._l((_vm.sellerList.concat(_vm.buyerList)),function(creditor){return [(!!creditor.totalLoanGiven)?_c('tr',{key:creditor['.key']},[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h4',[_vm._v(_vm._s(creditor['name']))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(creditor.totalOpeningBal || 0)))]):_vm._e(),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('b',{staticClass:"red--text"},[_c('h4',[_vm._v(" "+_vm._s(_vm._f("amount")(creditor.totalLoanGiven || 0)))])])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance(creditor.totalOpeningBal,0,creditor.totalLoanGiven) || 0)))]):_vm._e()]):_vm._e()]})]:_vm._e()]:_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_c('h3',[_vm._v("3")]),_vm._v(" "),_c('span',{staticStyle:{"display":"grid"}},[(!_vm.liabilitiesObj.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.liabilitiesObj)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.liabilitiesObj.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.liabilitiesObj)}}},[_vm._v("expand_less")]):_vm._e()],1)]),_vm._v(" "),_c('td',[_c('h3',{staticStyle:{"text-align":"left"}},[_vm._v("CURRENT LIABILIITIES")])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(_vm.totalUnsecuredLoanOpening) + Number.parseFloat(_vm.provisionOpeningBal) + Number.parseFloat(_vm.liabilityOpeningBalanace) || 0)))]):_vm._e(),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h3',{staticClass:"red--text"},[_vm._v(" "+_vm._s(_vm._f("amount")((Number.parseFloat(_vm.liabilityTotal) + Number.parseFloat(_vm.totalSundryCreditors) + Number.parseFloat(_vm.expenseTotal) + Number.parseFloat(_vm.ITCData.liabilities.IGST) + Number.parseFloat(_vm.ITCData.liabilities.SGST) + Number.parseFloat(_vm.ITCData.liabilities.CGST)).toFixed(2))))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance((Number.parseFloat(_vm.totalUnsecuredLoanOpening) + Number.parseFloat(_vm.provisionOpeningBal) +Number.parseFloat(_vm.liabilityOpeningBalanace)),0,(Number.parseFloat(_vm.liabilityTotal) + Number.parseFloat(_vm.totalSundryCreditors) + Number.parseFloat(_vm.expenseTotal) + Number.parseFloat(_vm.ITCData.liabilities.IGST) + Number.parseFloat(_vm.ITCData.liabilities.SGST) + Number.parseFloat(_vm.ITCData.liabilities.CGST))) || 0)))]):_vm._e()]),_vm._v(" "),(_vm.liabilitiesObj.expand)?[_c('tr',[_c('td',[_c('h3'),_vm._v(" "),_c('span',{staticStyle:{"display":"grid"}},[(!_vm.liabilitiesObj.sundryCreditorsObj.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.liabilitiesObj.sundryCreditorsObj)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.liabilitiesObj.sundryCreditorsObj.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.liabilitiesObj.sundryCreditorsObj)}}},[_vm._v("expand_less")]):_vm._e()],1)]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h3',[_vm._v("Sundry Creditors")])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.totalUnsecuredLoanOpening || 0)))]):_vm._e(),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h3',{staticClass:"red--text"},[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.totalSundryCreditors || 0)))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance(_vm.totalUnsecuredLoanOpening,0,_vm.totalSundryCreditors) || 0)))]):_vm._e()]),_vm._v(" "),(_vm.liabilitiesObj.sundryCreditorsObj.expand)?[_vm._l((_vm.sellerList),function(creditor){return [(!!creditor.totalRemainingAmount)?_c('tr',{key:creditor['.key']},[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h4',[_vm._v(_vm._s(creditor['name']))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(creditor.totalOpeningBal || 0)))]):_vm._e(),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('b',{staticClass:"red--text"},[_c('h4',[_vm._v(" "+_vm._s(_vm._f("amount")(creditor.totalRemainingAmount || 0)))])])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance(creditor.totalOpeningBal,0,creditor.totalRemainingAmount) || 0)))]):_vm._e()]):_vm._e()]})]:_vm._e()]:_vm._e(),_vm._v(" "),(_vm.liabilitiesObj.expand)?[_c('tr',[_c('td',[_c('h3'),_vm._v(" "),_c('span',{staticStyle:{"display":"grid"}},[(!_vm.liabilitiesObj.provisionObj.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.liabilitiesObj.provisionObj)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.liabilitiesObj.provisionObj.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.liabilitiesObj.provisionObj)}}},[_vm._v("expand_less")]):_vm._e()],1)]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h3',[_vm._v("Provisions")])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.provisionOpeningBal || 0)))]):_vm._e(),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h3',{staticClass:"red--text"},[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.expenseTotal || 0)))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance(_vm.provisionOpeningBal,0,_vm.expenseTotal) || 0)))]):_vm._e()]),_vm._v(" "),(_vm.liabilitiesObj.provisionObj.expand)?[_vm._l((_vm.expensesWPro),function(expense){return [(expense.paymentTypeStatus === 'yet to confirm' && expense.totalAmount > 0)?_c('tr',{key:expense['.key']},[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h4',[_vm._v(_vm._s(expense.expense))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(expense.openingBalance || 0)))]):_vm._e(),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('b',{staticClass:"red--text"},[_c('h4',[_vm._v(" "+_vm._s(_vm._f("amount")(expense.totalAmount || 0)))])])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance(expense.openingBalance,0,expense.totalAmount) || 0)))]):_vm._e()]):_vm._e()]})]:_vm._e()]:_vm._e(),_vm._v(" "),(_vm.liabilitiesObj.expand)?[_c('tr',[_c('td',[_c('h3'),_vm._v(" "),_c('span',{staticStyle:{"display":"grid"}},[(!_vm.liabilitiesObj.liabilitiesObj.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.liabilitiesObj.liabilitiesObj)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.liabilitiesObj.liabilitiesObj.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.liabilitiesObj.liabilitiesObj)}}},[_vm._v("expand_less")]):_vm._e()],1)]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h3',[_vm._v("Liabilities")])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.liabilityOpeningBalanace || 0)))]):_vm._e(),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h3',{staticClass:"red--text"},[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.liabilityTotal || 0)))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance(_vm.liabilityOpeningBalanace,0,_vm.liabilityTotal) || 0)))]):_vm._e()]),_vm._v(" "),(_vm.liabilitiesObj.liabilitiesObj.expand)?[_vm._l((_vm.liabilitiesWPro),function(liability){return [(liability.paymentTypeStatus === 'yet to confirm' && (liability.totalAmount || liability.openingBalance )> 0)?_c('tr',{key:liability['.key']},[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h4',[_vm._v(_vm._s(liability.liability))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(liability.openingBalance || 0)))]):_vm._e(),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('b',{staticClass:"red--text"},[_c('h4',[_vm._v(" "+_vm._s(_vm._f("amount")(Number.parseFloat(liability.totalAmount + liability.openingBalance) || 0)))])])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance(liability.openingBalance,0,Number.parseFloat(liability.totalAmount + liability.openingBalance)) || 0)))]):_vm._e()]):_vm._e()]})]:_vm._e()]:_vm._e(),_vm._v(" "),(_vm.liabilitiesObj.expand)?[_c('tr',[_c('td',[_c('h3'),_vm._v(" "),_c('span',{staticStyle:{"display":"grid"}},[(!_vm.liabilitiesObj.gstObj.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.liabilitiesObj.gstObj)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.liabilitiesObj.gstObj.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.liabilitiesObj.gstObj)}}},[_vm._v("expand_less")]):_vm._e()],1)]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h3',[_vm._v("Payable")])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}}):_vm._e(),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h3',{staticClass:"red--text"},[_vm._v(" "+_vm._s(_vm._f("amount")((Number.parseFloat(_vm.ITCData.liabilities.IGST) + Number.parseFloat(_vm.ITCData.liabilities.SGST) + Number.parseFloat(_vm.ITCData.liabilities.CGST)).toFixed(2) || 0)))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}}):_vm._e()]),_vm._v(" "),(_vm.liabilitiesObj.gstObj.expand)?[[_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h4',[_vm._v("IGST")])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}}):_vm._e(),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('b',{staticClass:"red--text"},[_c('h4',[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.ITCData.liabilities.IGST || 0)))])])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}}):_vm._e()])],_vm._v(" "),[_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h4',[_vm._v("CGST")])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}}):_vm._e(),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('b',{staticClass:"red--text"},[_c('h4',[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.ITCData.liabilities.CGST || 0)))])])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}}):_vm._e()])],_vm._v(" "),[_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h4',[_vm._v("SGST")])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}}):_vm._e(),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('b',{staticClass:"red--text"},[_c('h4',[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.ITCData.liabilities.SGST || 0)))])])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}}):_vm._e()])]]:_vm._e()]:_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_c('h3',[_vm._v("4")]),_vm._v(" "),_c('span',{staticStyle:{"display":"grid"}},[(!_vm.loanAdvancesObj.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.loanAdvancesObj)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.loanAdvancesObj.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.loanAdvancesObj)}}},[_vm._v("expand_less")]):_vm._e()],1)]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h3',[_vm._v("LOAN & ADVANCES")])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.totalUnsecuredLoanOpening || 0)))]):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h3',{staticClass:"green--text"},[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.totalLoanAndAdvances || 0)))])]),_vm._v(" "),_c('td'),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance(_vm.totalUnsecuredLoanOpening,_vm.totalLoanAndAdvances,0) || 0)))]):_vm._e()]),_vm._v(" "),(_vm.loanAdvancesObj.expand)?[_c('tr',[_c('td',[_c('h3'),_vm._v(" "),_c('span',{staticStyle:{"display":"grid"}},[(!_vm.loanAdvancesObj.unsecuredLoanAdvancesObj.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.loanAdvancesObj.unsecuredLoanAdvancesObj)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.loanAdvancesObj.unsecuredLoanAdvancesObj.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.loanAdvancesObj.unsecuredLoanAdvancesObj)}}},[_vm._v("expand_less")]):_vm._e()],1)]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h3',[_vm._v("Loans and Advances")])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.totalUnsecuredLoanOpening || 0)))]):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h3',{staticClass:"green--text"},[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.totalLoanAndAdvances || 0)))])]),_vm._v(" "),_c('td'),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance(_vm.totalUnsecuredLoanOpening,_vm.totalLoanAndAdvances,0) || 0)))]):_vm._e()]),_vm._v(" "),(_vm.loanAdvancesObj.unsecuredLoanAdvancesObj.expand)?[_vm._l((_vm.buyerList.concat(_vm.sellerList)),function(creditor){return [(!!creditor.totalLoanTaken)?_c('tr',{key:creditor['.key']},[_c('td'),_vm._v(" "),_c('td',[_c('h4',{staticStyle:{"text-align":"left"}},[_vm._v(_vm._s(creditor['name']))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(creditor.totalOpeningBal || 0)))]):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('b',{staticClass:"green--text"},[_c('h4',[_vm._v(" "+_vm._s(_vm._f("amount")(creditor.totalLoanTaken || 0)))])])]),_vm._v(" "),_c('td'),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance(creditor.totalOpeningBal,creditor.totalLoanTaken,0) || 0)))]):_vm._e()]):_vm._e()]})]:_vm._e()]:_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_c('h3',[_vm._v(" 4 ")]),_vm._v(" "),_c('span',{staticStyle:{"display":"grid"}},[(!_vm.fixedAssetsObj.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.fixedAssetsObj)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.fixedAssetsObj.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.fixedAssetsObj)}}},[_vm._v("expand_less")]):_vm._e()],1)]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h3',[_vm._v("FIXED ASSETS")])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.totalAssetOpening || 0)))]):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h3',{staticClass:"green--text"},[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.totalAssetAmount || 0)))])]),_vm._v(" "),_c('td'),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance(_vm.totalAssetOpening,_vm.totalAssetAmount,0) || 0)))]):_vm._e()]),_vm._v(" "),(_vm.fixedAssetsObj.expand)?[_vm._l((_vm.getAssetAccount),function(asset,e){return [(asset.details.type != ('investments' && 'intangibleAssets'))?_c('tr',{key:e},[_c('td',[_c('h3'),_vm._v(" "),_c('span',{staticStyle:{"display":"grid"}})]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h3',[_vm._v(_vm._s(asset.details.asset)+" / "+_vm._s(asset.details.category)+" "+_vm._s(asset.details.type))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(Number.parseFloat(asset.details.openingBalance)))]):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h3',{staticClass:"green--text"},[_vm._v(_vm._s(((Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance)) -  Number.parseFloat(((asset.details.totalAmount + asset.details.openingBalance)  * (asset.details.depriciation )) / 100) || 0 | _vm.amount ) || ((Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance)) || 0 | _vm.amount )))])]),_vm._v(" "),_c('td'),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance(asset.details.openingBalance,((Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance)) -  Number.parseFloat(((asset.details.totalAmount + asset.details.openingBalance)  * (asset.details.depriciation )) / 100) || 0 | _vm.amount ) || ((Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance))),0) || 0)))]):_vm._e()]):_vm._e(),_vm._v(" "),[_vm._l((asset.invoices),function(section,i){return [_c('tr',{key:i},[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v(_vm._s(new Date(section.date).toLocaleDateString('en-IN')))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(Number.parseFloat(section.openingBalance)))]):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('b',{staticClass:"green--text"},[_c('h4',[_vm._v(" "+_vm._s(_vm._f("amount")(section.totalAmount || section.openingBalance || 0)))])])]),_vm._v(" "),_c('td'),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance(section.openingBalance,section.totalAmount,0) || 0)))]):_vm._e()])]})]]})]:_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_c('h3',[_vm._v(" 5 ")]),_vm._v(" "),_c('span',{staticStyle:{"display":"grid"}},[(!_vm.intangibleAssetsObj.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.intangibleAssetsObj)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.intangibleAssetsObj.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.intangibleAssetsObj)}}},[_vm._v("expand_less")]):_vm._e()],1)]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h3',[_vm._v("INTANGIBLE ASSETS")])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.totalIntangibleOpening || 0)))]):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h3',{staticClass:"green--text"},[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.totalIntangibleAmount || 0)))])]),_vm._v(" "),_c('td'),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance(_vm.totalIntangibleOpening,_vm.totalIntangibleAmount,0) || 0)))]):_vm._e()]),_vm._v(" "),(_vm.intangibleAssetsObj.expand)?[_vm._l((_vm.getIntangibleAccount),function(asset,e){return [(asset.details.type === 'intangibleAssets')?_c('tr',{key:e},[_c('td',[_c('h3'),_vm._v(" "),_c('span',{staticStyle:{"display":"grid"}})]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h3',[_vm._v(_vm._s(asset.details.asset)+" / "+_vm._s(asset.details.category)+" "+_vm._s(asset.details.type))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(Number.parseFloat(asset.details.openingBalance)))]):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h3',{staticClass:"green--text"},[_vm._v(_vm._s(((Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance)) -  Number.parseFloat(((asset.details.totalAmount + asset.details.openingBalance)  * (asset.details.depriciation )) / 100) || 0 | _vm.amount ) || ((Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance)) || 0 | _vm.amount )))])]),_vm._v(" "),_c('td'),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance(asset.details.openingBalance,(((Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance)) -  Number.parseFloat(((asset.details.totalAmount + asset.details.openingBalance)  * (asset.details.depriciation )) / 100) || 0 | _vm.amount ) || ((Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance)))),0) || 0)))]):_vm._e()]):_vm._e(),_vm._v(" "),[_vm._l((asset.invoices),function(section,i){return [_c('tr',{key:i},[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v(_vm._s(new Date(section.date).toLocaleDateString('en-IN')))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(Number.parseFloat(section.openingBalance)))]):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('b',{staticClass:"green--text"},[_c('h4',[_vm._v(" "+_vm._s(section.totalAmount || section.openingBalance || '-'))])])]),_vm._v(" "),_c('td'),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance(section.openingBalance,section.totalAmount,0) || 0)))]):_vm._e()])]})]]})]:_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_c('h3',[_vm._v("6")]),_vm._v(" "),_c('span',{staticStyle:{"display":"grid"}},[(!_vm.investmentsObj.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.investmentsObj)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.investmentsObj.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.investmentsObj)}}},[_vm._v("expand_less")]):_vm._e()],1)]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h3',[_vm._v("INVESTMENTS")])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.totalInvestmentOpening || 0)))]):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h3',{staticClass:"green--text"},[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.totalInvestmentAmount || 0)))])]),_vm._v(" "),_c('td'),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance(_vm.totalInvestmentOpening,_vm.totalInvestmentAmount,0) || 0)))]):_vm._e()]),_vm._v(" "),(_vm.investmentsObj.expand)?[_vm._l((_vm.getInvestmentAccount),function(asset,e){return [(asset.details.type === 'investments')?_c('tr',{key:e},[_c('td',[_c('h3'),_vm._v(" "),_c('span',{staticStyle:{"display":"grid"}})]),_vm._v(" "),_c('td',[_c('h3',[_vm._v(_vm._s(asset.details.asset)+" / "+_vm._s(asset.details.category)+" "+_vm._s(asset.details.type))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(Number.parseFloat(asset.details.openingBalance)))]):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h3',{staticClass:"green--text"},[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance) || 0)))])]),_vm._v(" "),_c('td'),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance(asset.details.openingBalance,( Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance)),0) || 0)))]):_vm._e()]):_vm._e(),_vm._v(" "),[_vm._l((asset.invoices),function(section,i){return [_c('tr',{key:i},[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v(_vm._s(new Date(section.date).toLocaleDateString('en-IN')))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(Number.parseFloat(section.openingBalance)))]):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('b',{staticClass:"green--text"},[_c('h4',[_vm._v(" "+_vm._s(section.totalAmount || section.openingBalance || '-'))])])]),_vm._v(" "),_c('td'),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance(section.openingBalance,(section.totalAmount || section.openingBalance ),0) || 0)))]):_vm._e()])]})]]})]:_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_c('h3',[_vm._v("7")]),_vm._v(" "),_c('span',{staticStyle:{"display":"grid"}},[(!_vm.currentAssetsObj.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.currentAssetsObj)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.currentAssetsObj.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.currentAssetsObj)}}},[_vm._v("expand_less")]):_vm._e()],1)]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h3',[_vm._v("CURRENT ASSETS")])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")((Number.parseFloat(_vm.totalSundryDebitorsOpening) +Number.parseFloat(_vm.cashInHand.totalOpeningBal)+Number.parseFloat(_vm.savingsCurrentBankListTotalOpening) )|| 0)))]):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('b',{staticClass:"green--text"},[_c('h3',[_vm._v(" "+_vm._s(_vm._f("amount")((Number.parseFloat(_vm.totalSundryDebitors)+ Number.parseFloat(_vm.savingsCurrentBankListTotal)+ Number.parseFloat(_vm.cashInHand.total)+Number.parseFloat(_vm.ITCData.assets.IGST) + Number.parseFloat(_vm.ITCData.assets.SGST) + Number.parseFloat(_vm.ITCData.assets.CGST)).toFixed(2) || 0)))])])]),_vm._v(" "),_c('td'),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance((((Number.parseFloattotalSundryDebitorsOpening) +Number.parseFloat(_vm.cashInHand.totalOpeningBal)+Number.parseFloat(_vm.savingsCurrentBankListTotalOpening) )),((Number.parseFloat(_vm.totalSundryDebitors)+ Number.parseFloat(_vm.savingsCurrentBankListTotal)+ Number.parseFloat(_vm.cashInHand.total)+Number.parseFloat(_vm.ITCData.assets.IGST) + Number.parseFloat(_vm.ITCData.assets.SGST) + Number.parseFloat(_vm.ITCData.assets.CGST)) ),0) || 0)))]):_vm._e()]),_vm._v(" "),(_vm.currentAssetsObj.expand)?[_c('tr',[_c('td',[_c('h3'),_vm._v(" "),_c('span',{staticStyle:{"display":"grid"}},[(!_vm.currentAssetsObj.sundryDebtorsObj.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.currentAssetsObj.sundryDebtorsObj)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.currentAssetsObj.sundryDebtorsObj.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.currentAssetsObj.sundryDebtorsObj)}}},[_vm._v("expand_less")]):_vm._e()],1)]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h3',{staticClass:"primary--text"},[_vm._v("Sundry Debtors")])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.totalSundryDebitorsOpening || 0)))]):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('b',{staticClass:"green--text"},[_c('h3',[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.totalSundryDebitors || 0)))])])]),_vm._v(" "),_c('td'),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance(_vm.totalSundryDebitorsOpening,(_vm.totalSundryDebitors),0) || 0)))]):_vm._e()]),_vm._v(" "),(_vm.currentAssetsObj.sundryDebtorsObj.expand)?[_vm._l((_vm.buyerList),function(creditor){return [(!!creditor.totalRemainingAmount)?_c('tr',{key:creditor['.key']},[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h4',[_vm._v(_vm._s(creditor['name']))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(creditor.totalOpeningBal || 0)))]):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('b',{staticClass:"green--text"},[_c('h4',[_vm._v(" "+_vm._s(_vm._f("amount")(creditor.totalRemainingAmount || 0)))])])]),_vm._v(" "),_c('td'),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance( creditor.totalOpeningBal,(creditor.totalRemainingAmount ),0) || 0)))]):_vm._e()]):_vm._e()]})]:_vm._e()]:_vm._e(),_vm._v(" "),(_vm.currentAssetsObj.expand)?[_c('tr',[_c('td',[_c('h3'),_vm._v(" "),_c('span',{staticStyle:{"display":"grid"}},[(!_vm.cashInHand.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.cashInHand)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.cashInHand.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.cashInHand)}}},[_vm._v("expand_less")]):_vm._e()],1)]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h3',{staticClass:"primary--text"},[_vm._v("Cash in hand")])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.cashInHand.totalOpeningBal|| 0)))]):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h3',{staticClass:"green--text"},[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.cashInHand.total || 0)))])]),_vm._v(" "),_c('td'),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance( _vm.cashInHand.totalOpeningBal,_vm.cashInHand.total,0) || 0)))]):_vm._e()]),_vm._v(" "),(_vm.cashInHand.expand)?[_vm._l((_vm.cashInHand.list),function(firm){return [_c('tr',{key:firm['.key']},[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h4',[_vm._v(_vm._s(firm.name))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(firm.openingStock || 0)))]):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('b',{staticClass:"green--text"},[_c('h4',[_vm._v(" "+_vm._s(_vm._f("amount")(firm.amount || 0)))])])]),_vm._v(" "),_c('td'),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance( firm.openingStock,firm.amount,0) || 0)))]):_vm._e()])]})]:_vm._e()]:_vm._e(),_vm._v(" "),(_vm.currentAssetsObj.expand)?[_c('tr',[_c('td',[_c('h3'),_vm._v(" "),_c('span',{staticStyle:{"display":"grid"}},[(!_vm.currentAssetsObj.bankAccountsObj.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.currentAssetsObj.bankAccountsObj)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.currentAssetsObj.bankAccountsObj.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.currentAssetsObj.bankAccountsObj)}}},[_vm._v("expand_less")]):_vm._e()],1)]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h3',{staticClass:"primary--text"},[_vm._v("Bank accounts")])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.savingsCurrentBankListTotalOpening || 0)))]):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h3',{staticClass:"green--text"},[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.savingsCurrentBankListTotal || 0)))])]),_vm._v(" "),_c('td'),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance( _vm.savingsCurrentBankListTotalOpening,_vm.savingsCurrentBankListTotal,0) || 0)))]):_vm._e()]),_vm._v(" "),(_vm.currentAssetsObj.bankAccountsObj.expand)?[_vm._l((_vm.savingsCurrentBankList),function(bank){return [_c('tr',{key:bank['.key']},[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h4',[_vm._v(_vm._s(bank.bankName))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(bank.openingBalance || 0)))]):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('b',{staticClass:"green--text"},[_c('h4',[_vm._v(" "+_vm._s(_vm._f("amount")(bank.amount || 0)))])])]),_vm._v(" "),_c('td'),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance( bank.openingBalance,bank.amount,0) || 0)))]):_vm._e()])]})]:_vm._e()]:_vm._e(),_vm._v(" "),(_vm.currentAssetsObj.expand)?[_c('tr',[_c('td',[_c('h3'),_vm._v(" "),_c('span',{staticStyle:{"display":"grid"}},[(!_vm.currentAssetsObj.gstReceivableObj.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.currentAssetsObj.gstReceivableObj)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.currentAssetsObj.gstReceivableObj.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.currentAssetsObj.gstReceivableObj)}}},[_vm._v("expand_less")]):_vm._e()],1)]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h3',[_vm._v("Payable")])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}}):_vm._e(),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h3',{staticClass:"red--text"},[_vm._v(" "+_vm._s(_vm._f("amount")((Number.parseFloat(_vm.ITCData.assets.IGST) + Number.parseFloat(_vm.ITCData.assets.SGST) + Number.parseFloat(_vm.ITCData.assets.CGST)).toFixed(2) || 0)))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}}):_vm._e()]),_vm._v(" "),(_vm.currentAssetsObj.gstReceivableObj.expand)?[[_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h4',[_vm._v("IGST")])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}}):_vm._e(),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('b',{staticClass:"red--text"},[_c('h4',[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.ITCData.assets.IGST || 0)))])])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}}):_vm._e()])],_vm._v(" "),[_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h4',[_vm._v("CGST")])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}}):_vm._e(),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('b',{staticClass:"red--text"},[_c('h4',[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.ITCData.assets.CGST || 0)))])])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}}):_vm._e()])],_vm._v(" "),[_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h4',[_vm._v("SGST")])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}}):_vm._e(),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('b',{staticClass:"red--text"},[_c('h4',[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.ITCData.assets.SGST || 0)))])])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}}):_vm._e()])]]:_vm._e()]:_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_c('h3',[_vm._v("8")]),_vm._v(" "),_c('span',{staticStyle:{"display":"grid"}},[(!_vm.sale.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.sale)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.sale.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.sale)}}},[_vm._v("expand_less")]):_vm._e()],1)]),_vm._v(" "),_c('td',[_c('h3',{staticStyle:{"text-align":"left"}},[_vm._v("SALE")])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}}):_vm._e(),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h3',{staticClass:"red--text"},[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.sale.total || 0)))])])]),_vm._v(" "),(_vm.sale.expand)?[_vm._l((_vm.sale.list),function(sal){return [_c('tr',{key:sal['.key']},[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h4',[_vm._v(_vm._s(sal.name))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}}):_vm._e(),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('b',{staticClass:"red--text"},[_c('h4',[_vm._v(" "+_vm._s(_vm._f("amount")(sal.totalAmount || 0)))])])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}}):_vm._e()])]})]:_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_c('h3',[_vm._v("9")]),_vm._v(" "),_c('span',{staticStyle:{"display":"grid"}},[(!_vm.purchase.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.purchase)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.purchase.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.purchase)}}},[_vm._v("expand_less")]):_vm._e()],1)]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h3',[_vm._v("PURCHASE")])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}}):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h3',{staticClass:"green--text"},[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.purchase.total || 0)))])]),_vm._v(" "),_c('td'),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}}):_vm._e()]),_vm._v(" "),(_vm.purchase.expand)?[_vm._l((_vm.purchase.list),function(purchas){return [_c('tr',{key:purchas['.key']},[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h4',[_vm._v(_vm._s(purchas.name))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}}):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('b',{staticClass:"green--text"},[_c('h4',[_vm._v(" "+_vm._s(_vm._f("amount")(purchas.totalAmount || 0)))])])]),_vm._v(" "),_c('td'),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}}):_vm._e()])]})]:_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_c('h3',[_vm._v("10")]),_vm._v(" "),_c('span',{staticStyle:{"display":"grid"}},[(!_vm.saleReturn.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.saleReturn)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.saleReturn.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.saleReturn)}}},[_vm._v("expand_less")]):_vm._e()],1)]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h3',[_vm._v("SALE RETURN")])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}}):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h3',{staticClass:"green--text"},[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.saleReturn.total || 0)))])]),_vm._v(" "),_c('td'),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}}):_vm._e()]),_vm._v(" "),(_vm.saleReturn.expand)?[_vm._l((_vm.saleReturn.list),function(saleRetur){return [_c('tr',{key:saleRetur['.key']},[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h4',[_vm._v(_vm._s(saleRetur.name))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}}):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('b',{staticClass:"green--text"},[_c('h4',[_vm._v(" "+_vm._s(saleRetur.remainingAmount))])])]),_vm._v(" "),_c('td'),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}}):_vm._e()])]})]:_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_c('h3',[_vm._v("11")]),_vm._v(" "),_c('span',{staticStyle:{"display":"grid"}},[(!_vm.purchaseReturn.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.purchaseReturn)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.purchaseReturn.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.purchaseReturn)}}},[_vm._v("expand_less")]):_vm._e()],1)]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h3',[_vm._v("PURCHASE RETURN")])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}}):_vm._e(),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h3',{staticClass:"red--text"},[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.purchaseReturn.total || 0)))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}}):_vm._e()]),_vm._v(" "),(_vm.purchaseReturn.expand)?[_vm._l((_vm.purchaseReturn.list),function(purchaseRetur){return [_c('tr',{key:purchaseRetur['.key']},[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h4',[_vm._v(_vm._s(purchaseRetur.name))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}}):_vm._e(),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('b',{staticClass:"red--text"},[_c('h4',[_vm._v(" "+_vm._s(_vm._f("amount")(purchaseRetur.remainingAmount || 0)))])])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}}):_vm._e()])]})]:_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_c('h3',[_vm._v("12")]),_vm._v(" "),_c('span',{staticStyle:{"display":"grid"}},[(!_vm.expensesObj.direct.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.expensesObj.direct)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.expensesObj.direct.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.expensesObj.direct)}}},[_vm._v("expand_less")]):_vm._e()],1)]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h3',[_vm._v("DIRECT EXPENSES")])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.expensesObj.direct.totalOpeningBal)))]):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h3',{staticClass:"green--text"},[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.expensesObj.direct.total)))])]),_vm._v(" "),_c('td'),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance(_vm.expensesObj.direct.totalOpeningBal,_vm.expensesObj.direct.total,0) || 0)))]):_vm._e()]),_vm._v(" "),(_vm.expensesObj.direct.expand)?[_vm._l((_vm.expensesObj.list),function(expense){return [(expense.category == 'Direct')?_c('tr',{key:expense['.key']},[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h4',[_vm._v(_vm._s(expense.expense))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(expense.openingBalance || 0)))]):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('b',{staticClass:"green--text"},[_c('h4',[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(expense.totalAmount) + Number.parseFloat(expense.openingBalance) || 0))+"  ")])])]),_vm._v(" "),_c('td'),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance(expense.openingBalance,(Number.parseFloat(expense.totalAmount) + Number.parseFloat(expense.openingBalance)),0) || 0)))]):_vm._e()]):_vm._e()]})]:_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_c('h3',[_vm._v("13")]),_vm._v(" "),_c('span',{staticStyle:{"display":"grid"}},[(!_vm.incomes.direct.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.incomes.direct)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.incomes.direct.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.incomes.direct)}}},[_vm._v("expand_less")]):_vm._e()],1)]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h3',[_vm._v(" DIRECT INCOMES")])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.incomes.direct.totalOpeningBal || 0)))]):_vm._e(),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h3',{staticClass:"red--text"},[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.incomes.direct.total || 0)))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.getClosingBalance(_vm.incomes.direct.totalOpeningBal,_vm.incomes.direct.total,0) || 0)))]):_vm._e()]),_vm._v(" "),(_vm.incomes.direct.expand)?[_vm._l((_vm.incomes.list),function(income){return [(income.category == 'Direct')?_c('tr',{key:income['.key']},[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h4',[_vm._v(_vm._s(income.income))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.incomes.openingBalance || 0)))]):_vm._e(),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('b',{staticClass:"red--text"},[_c('h4',[_vm._v(" "+_vm._s(_vm._f("amount")(income.openingBalance)))])])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance(income.openingBalance,income.openingBalance,0) || 0)))]):_vm._e()]):_vm._e()]})]:_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_c('h3',[_vm._v("14")]),_vm._v(" "),_c('span',{staticStyle:{"display":"grid"}},[(!_vm.expensesObj.indirect.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.expensesObj.indirect)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.expensesObj.indirect.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.expensesObj.indirect)}}},[_vm._v("expand_less")]):_vm._e()],1)]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h3',[_vm._v("INDIRECT EXPENSES")])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.expensesObj.indirect.totalOpeningBal)))]):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h3',{staticClass:"green--text"},[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.expensesObj.indirect.total)))])]),_vm._v(" "),_c('td'),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance(_vm.expensesObj.indirect.totalOpeningBal,_vm.expensesObj.indirect.total,0) || 0)))]):_vm._e()]),_vm._v(" "),(_vm.expensesObj.indirect.expand)?[_vm._l((_vm.expensesObj.list),function(expense){return [(expense.category != 'Direct')?_c('tr',{key:expense['.key']},[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h4',[_vm._v(_vm._s(expense.expense))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(expense.openingBalance || 0)))]):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('b',{staticClass:"green--text"},[_c('h4',[_vm._v(" "+_vm._s(_vm._f("amount")(expense.openingBalance || 0)))])])]),_vm._v(" "),_c('td'),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance(expense.openingBalance,expense.openingBalance,0) || 0)))]):_vm._e()]):_vm._e()]})]:_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_c('h3',[_vm._v("15")]),_vm._v(" "),_c('span',{staticStyle:{"display":"grid"}},[(!_vm.incomes.indirect.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.incomes.indirect)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.incomes.indirect.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.incomes.indirect)}}},[_vm._v("expand_less")]):_vm._e()],1)]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h3',[_vm._v(" INDIRECT INCOMES")])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.incomes.indirect.totalOpeningBal || 0)))]):_vm._e(),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h3',{staticClass:"red--text"},[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.incomes.indirect.total || 0)))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance(_vm.incomes.indirect.totalOpeningBal,_vm.incomes.indirect.total,0) || 0)))]):_vm._e()]),_vm._v(" "),(_vm.incomes.indirect.expand)?[_vm._l((_vm.incomes.list),function(income){return [(income.category != 'Direct')?_c('tr',{key:income['.key']},[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h4',[_vm._v(_vm._s(income.income))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.incomes.openingBalance || 0)))]):_vm._e(),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('b',{staticClass:"red--text"},[_c('h4',[_vm._v(" "+_vm._s(_vm._f("amount")(income.openingBalance || 0)))])])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.getClosingBalance(_vm.incomes.openingBalance,_vm.incomes.openingBalance,0) || 0)))]):_vm._e()]):_vm._e()]})]:_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_c('h3',[_vm._v("16")]),_vm._v(" "),_c('span',{staticStyle:{"display":"grid"}},[(!_vm.discount.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.discount)}}},[_vm._v("expand_more")]):_vm._e(),_vm._v(" "),(_vm.discount.expand)?_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.toggle(_vm.discount)}}},[_vm._v("expand_less")]):_vm._e()],1)]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h3',[_vm._v("DISCOUNT RECEIVEABLE")])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}}):_vm._e(),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h3',{staticClass:"red--text"},[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.discount.total || 0)))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}}):_vm._e()]),_vm._v(" "),(_vm.discount.expand)?[_vm._l((_vm.discount.list),function(discoun){return [_c('tr',{key:discoun['.key']},[_c('td'),_vm._v(" "),_c('td',[_c('h4',[_vm._v(_vm._s(discoun.name))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}}):_vm._e(),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('b',{staticClass:"red--text"},[_c('h4',[_vm._v(" "+_vm._s(discoun.discountAmount))])])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}}):_vm._e()])]})]:_vm._e(),_vm._v(" "),_c('tr',[_c('td'),_vm._v(" "),_c('td',{staticStyle:{"text-align":"left"}},[_c('h3',[_vm._v("TOTAL")])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.totalOpening|| 0)))]):_vm._e(),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h3',{staticClass:"green--text"},[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.totalDebit || 0)))])]),_vm._v(" "),_c('td',{staticStyle:{"text-align":"right"}},[_c('h3',{staticClass:"red--text"},[_vm._v(" "+_vm._s(_vm._f("amount")(_vm.totalCredit || 0)))])]),_vm._v(" "),(_vm.detailedView)?_c('td',{staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm._f("amount")(_vm.totalClosing|| 0)))]):_vm._e()])],2)])])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_collectionBook_vue__ = __webpack_require__(578);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c7fe731_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_collectionBook_vue__ = __webpack_require__(1710);
function injectStyle (ssrContext) {
  __webpack_require__(1708)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_collectionBook_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c7fe731_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_collectionBook_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1708 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return collectionBookReport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float__);


// playground requires you to assign document definition to a variable called dd
var collectionBookReport = function collectionBookReport(_ref) {
	var buyers = _ref.buyers;

	var dd = {
		content: [{ text: 'COLLECTION BOOK\n', style: "topHeader1" }, {
			table: {
				body: [[{ text: 'Buyer Name', style: "gstHeader" }, { text: 'Remaining Amount', style: "gstHeader" }, { text: 'Mobile No.', style: "gstHeader" }, { text: 'Address', style: "gstHeader" }, { text: 'Tehsil', style: "gstHeader" }, { text: 'District', style: "gstHeader" }, { text: 'State', style: "gstHeader" }]]
			}
		}],
		styles: {
			gstHeader: {
				fontSize: 12,
				bold: true,
				alignment: 'center'
			},
			data: {
				fontSize: 9,
				alignment: 'center'
			},
			data2: {
				fontSize: 9,
				alignment: 'right',
				color: '#FF0000'
			},
			data3: {
				fontSize: 10,
				alignment: 'right',
				color: '#FF0000',
				bold: true
			},
			topHeader1: {
				fontSize: 14,
				alignment: 'center',
				bold: true,
				fillColor: '#15155d'
			}
		}
	};

	buyers.map(function (buyer) {
		if (!!parseInt(buyer.remainingBalance) && !buyer.isTotal) {
			dd.content[1].table.body.push([{ text: buyer.name || '-', style: "data" }, { text: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(buyer.remainingBalance).toFixed(2), style: "data2" }, { text: buyer.mobile || '-', style: "data" }, { text: buyer.localAddress, style: "data" }, { text: buyer.tehsil, style: "data" }, { text: buyer.district, style: "data" }, { text: buyer.state, style: "data" }]);
		} else {
			dd.content[1].table.body.push([{ text: 'Total', style: "data" }, { text: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_float___default()(buyer.total).toFixed(2), style: "data3" }, { text: '', style: "data" }, { text: '', style: "data" }, { text: '', style: "data" }, { text: '', style: "data" }, { text: '', style: "data" }]);
		}
	});

	return dd;
};

/***/ }),
/* 1710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-flex',{attrs:{"xs3":""}},[_c('h2',{staticClass:"headline font-weight-light"},[_vm._v("Collection Book")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-autocomplete',{staticClass:"white--text",attrs:{"solo":"","autofocus":true,"label":"Search Customer","prepend-inner-icon":"search","items":_vm.getBuyerName,"clearable":"","flat":"","hide-details":"","hide-no-data":"","single-line":""},nativeOn:{"keyup":function($event){return _vm.keymonitor($event)}},model:{value:(_vm.selectedBuyer),callback:function ($$v) {_vm.selectedBuyer=$$v},expression:"selectedBuyer"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.printReport()}}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("print")])],1),_vm._v(" "),_c('router-link',{attrs:{"to":"/Dashboard"}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("close")])],1)],1)],1),_vm._v(" "),_c('v-toolbar',{staticClass:"mb",attrs:{"color":"white--text","flat":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-autocomplete',{attrs:{"dense":"","flat":"","clearable":"","item-text":"text","items":_vm.getBuyerAddress,"label":"Select Address"},model:{value:(_vm.selectedAddress),callback:function ($$v) {_vm.selectedAddress=$$v},expression:"selectedAddress"}})],1),_vm._v(" "),_c('v-flex',[_c('v-autocomplete',{attrs:{"dense":"","flat":"","clearable":"","item-text":"text","items":_vm.getBuyerTehsil,"label":"Select Tehsil"},model:{value:(_vm.selectedTehsil),callback:function ($$v) {_vm.selectedTehsil=$$v},expression:"selectedTehsil"}})],1),_vm._v(" "),_c('v-flex',[_c('v-autocomplete',{attrs:{"dense":"","flat":"","clearable":"","item-text":"text","items":_vm.getBuyerDistrict,"label":"Select District"},model:{value:(_vm.selectedDistrict),callback:function ($$v) {_vm.selectedDistrict=$$v},expression:"selectedDistrict"}})],1),_vm._v(" "),_c('v-flex',[_c('v-autocomplete',{attrs:{"dense":"","flat":"","clearable":"","item-text":"text","items":_vm.getBuyerStates,"label":"Select State"},model:{value:(_vm.selectedState),callback:function ($$v) {_vm.selectedState=$$v},expression:"selectedState"}})],1),_vm._v(" "),_c('v-flex',[_c('v-text-field',{attrs:{"label":"Day Difference","dense":"","flat":"","type":"number","clearable":""},model:{value:(_vm.dayDiff),callback:function ($$v) {_vm.dayDiff=$$v},expression:"dayDiff"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{attrs:{"color":"primary","dark":""},on:{"click":function($event){_vm.expand = !_vm.expand}}},[_vm._v("\n          "+_vm._s(_vm.expand ? "Close" : "Keep")+" other rows\n        ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.buyerHeader,"items":_vm.getBuyers,"item-key":"name","expand":_vm.expand},scopedSlots:_vm._u([{key:"items",fn:function(props){return [(
                !!parseInt(props.item.remainingBalance) && !props.item.isTotal
              )?[_c('tr',{on:{"click":function($event){props.expanded = !props.expanded}}},[_c('td',{staticClass:"text-xs-left nowrap"},[_c('router-link',{staticStyle:{"text-decoration":"none"},attrs:{"to":'/buyers/' + props.item['.key']}},[_c('b',{staticClass:"font-weight-bold primary--text"},[_vm._v(_vm._s(props.item.name || "-"))])])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',{staticClass:"font-weight-bold red--text"},[_vm._v(_vm._s(_vm._f("amount")(props.item.remainingBalance)))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.mobile || "-"))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.localAddress || "-"))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.tehsil || "-"))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.district || "-"))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.state || "-"))])]),_vm._v(" "),_c('td',[_c('router-link',{attrs:{"to":{
                      name: 'CustomerPayments',
                      params: { customerId: props.item['.key'] },
                    }}},[_c('v-btn',{attrs:{"color":"primary"}},[_vm._v("RECEIPT")])],1)],1)])]:(props.item.isTotal)?[_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',{staticClass:"font-weight-bold primary--text"},[_vm._v("Total")])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',{staticClass:"font-weight-bold red--text"},[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(props.item.total).toFixed(2))))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b')]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b')]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b')]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b')]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b')]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b')]),_vm._v(" "),_c('td')]:_vm._e()]}},{key:"expand",fn:function(props){return _vm._l((props.item.invoices),function(inv,index){return _c('div',{key:inv['.key'] + index},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('span',[_vm._v(_vm._s(new Date(inv.date).toLocaleDateString("en-GB")))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('span',{staticClass:"success--text text--darken-1"},[_vm._v(_vm._s(inv.credit))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('span',{staticClass:"error--text text--darken-1"},[_vm._v(_vm._s(inv.debit))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[_c('span',[_vm._v(_vm._s(inv.RunningBal))])])],1)],1)})}}])},[_vm._v(" "),_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_helpBook_vue__ = __webpack_require__(579);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_367ccfb7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_helpBook_vue__ = __webpack_require__(1713);
function injectStyle (ssrContext) {
  __webpack_require__(1712)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_helpBook_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_367ccfb7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_helpBook_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1712 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-iterator',{staticClass:"profit",attrs:{"items":_vm.helpBook,"content-tag":"div","content-class":'layout row wrap',"hide-actions":""},scopedSlots:_vm._u([{key:"item",fn:function(props){return [(props.item.expense)?_c('v-flex',{staticStyle:{"display":"flex","flex-direction":"column"},attrs:{"xs6":"","md6":"","sm6":""}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("ACTION")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v(" SHORTCUT ")])])],1)],1),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("1. Dashboard")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("alt + a")])])],1),_vm._v(" "),_c('v-card-title',[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("2. Buyer")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("alt + b")])])],1),_vm._v(" "),_c('v-card-title',[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("3. Reports")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("alt + z ")])])],1),_vm._v(" "),_c('v-card-title',[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("4. Transactions")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("alt + t")])])],1),_vm._v(" "),_c('v-card-title',[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("5. Setting")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("alt + s")])])],1),_vm._v(" "),_c('v-card-title',[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("6. Information")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("alt + r")])])],1),_vm._v(" "),_c('v-card-title',[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("7. New Product")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("alt + p")])])],1),_vm._v(" "),_c('v-card-title',[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("8. Product List ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("alt + a")])])],1)],1)],1):_vm._e(),_vm._v(" "),(!props.item.expense)?_c('v-flex',{staticStyle:{"display":"flex","flex-direction":"column"},attrs:{"xs6":"","md6":"","sm6":""}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("ACTION")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v(" SHORTCUT ")])])],1)],1),_vm._v(" "),_c('v-card',[_c('v-card-title',[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("1. New Invoice")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("alt + i")])])],1),_vm._v(" "),_c('v-card-title',[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("2. New Receipt")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("alt + r")])])],1),_vm._v(" "),_c('v-card-title',[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("3. Manage Order")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("alt + o")])])],1),_vm._v(" "),_c('v-card-title',[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("4. Manage Estimate")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("alt + e")])])],1),_vm._v(" "),_c('v-card-title',[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("5. Manage Portfolio")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v(" * ")])])],1),_vm._v(" "),_c('v-card-title',[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("6. Manage Godown")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("alt + g")])])],1),_vm._v(" "),_c('v-card-title',[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("7. Day Book")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("alt + a")])])],1),_vm._v(" "),_c('v-card-title',[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("8. Cash Book")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("alt + a")])])],1),_vm._v(" "),_c('v-card-title',[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("9. Bank Book")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v(" * ")])])],1),_vm._v(" "),_c('v-card-title',[_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v("10. Financial Book")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h3',[_c('span',{staticClass:"print-field"},[_vm._v(" * ")])])],1)],1)],1):_vm._e()]}}])},[_c('template',{slot:"header"},[_c('v-toolbar',{staticClass:"mb",attrs:{"color":"primary","dark":"","flat":""}},[_c('v-toolbar-title',[_c('router-link',{attrs:{"to":"/Dashboard"}},[_c('b',{staticClass:"white--text font-weight-light"},[_vm._v("HELP_BOOK")])])],1)],1)],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeletedInvoice_vue__ = __webpack_require__(580);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d661bc0c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeletedInvoice_vue__ = __webpack_require__(1716);
function injectStyle (ssrContext) {
  __webpack_require__(1715)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DeletedInvoice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d661bc0c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DeletedInvoice_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1715 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-flex',{attrs:{"xs12":""}},[_c('h2',{staticClass:" headline font-weight-light"},[_vm._v("\n          Deleted Invoices\n        ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('router-link',{attrs:{"to":"/Dashboard"}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("close")])],1)],1)],1),_vm._v(" "),_c('v-toolbar',{staticClass:"mb",attrs:{"color":"white--text","flat":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-autocomplete',{attrs:{"dense":"","flat":"","clearable":"","item-text":"name","return-object":"","items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.fromdatepicker),callback:function ($$v) {_vm.fromdatepicker=$$v},expression:"fromdatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","clearable":"","single-line":"","label":"From Date","readonly":""},slot:"activator",model:{value:(_vm.filterInvoiceFrom),callback:function ($$v) {_vm.filterInvoiceFrom=$$v},expression:"filterInvoiceFrom"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.fromdatepicker = false}},model:{value:(_vm.filterInvoiceFrom),callback:function ($$v) {_vm.filterInvoiceFrom=$$v},expression:"filterInvoiceFrom"}})],1)],1),_vm._v(" "),_c('v-flex',[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.todatepicker),callback:function ($$v) {_vm.todatepicker=$$v},expression:"todatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","clearable":"","label":"To Date","single-line":"","readonly":""},slot:"activator",model:{value:(_vm.filterInvoiceTo),callback:function ($$v) {_vm.filterInvoiceTo=$$v},expression:"filterInvoiceTo"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.todatepicker = false}},model:{value:(_vm.filterInvoiceTo),callback:function ($$v) {_vm.filterInvoiceTo=$$v},expression:"filterInvoiceTo"}})],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.invoiceHeader,"items":_vm.getInvoice},scopedSlots:_vm._u([{key:"items",fn:function(props){return [[_c('td',{staticClass:"primary--text font-weight-bold",domProps:{"innerHTML":_vm._s(_vm.renderDate(props.item.date))}}),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['invoiceId']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.getCurrentUserName(props.item.buyerId)))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"success--text"},[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(props.item.totalAmount)|| 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.status))])]),_vm._v(" "),_c('td',[_c('b',[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.restoreInvoice(props.item)}}},[_vm._v("RESTORE")])],1)]),_vm._v(" "),_c('td',[_c('b',[_c('v-btn',{attrs:{"color":"warning"},on:{"click":function($event){return _vm.deleteInvoice(props.item)}}},[_vm._v("DELETE")])],1)]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.getFirmName(props.item.firm)))])])]]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExtraChargesInvoices_vue__ = __webpack_require__(581);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7517a27a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtraChargesInvoices_vue__ = __webpack_require__(1719);
function injectStyle (ssrContext) {
  __webpack_require__(1718)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExtraChargesInvoices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7517a27a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExtraChargesInvoices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1718 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-flex',{attrs:{"xs12":""}},[_c('h2',{staticClass:"headline font-weight-light"},[_vm._v("\n          Extra Charges\n        ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('router-link',{attrs:{"to":"/Dashboard"}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("close")])],1)],1)],1),_vm._v(" "),_c('v-toolbar',{staticClass:"mb",attrs:{"color":"white--text","flat":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-autocomplete',{attrs:{"dense":"","flat":"","clearable":"","item-text":"name","return-object":"","items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-flex',[_c('v-autocomplete',{attrs:{"dense":"","flat":"","clearable":"","item-text":"text","items":_vm.chargeList,"label":"Select Charge"},model:{value:(_vm.selectedCharge),callback:function ($$v) {_vm.selectedCharge=$$v},expression:"selectedCharge"}})],1),_vm._v(" "),_c('v-flex',[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.fromdatepicker),callback:function ($$v) {_vm.fromdatepicker=$$v},expression:"fromdatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","clearable":"","single-line":"","label":"From Date","readonly":""},slot:"activator",model:{value:(_vm.fromDate),callback:function ($$v) {_vm.fromDate=$$v},expression:"fromDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.fromdatepicker = false}},model:{value:(_vm.fromDate),callback:function ($$v) {_vm.fromDate=$$v},expression:"fromDate"}})],1)],1),_vm._v(" "),_c('v-flex',[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.todatepicker),callback:function ($$v) {_vm.todatepicker=$$v},expression:"todatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","clearable":"","label":"To Date","single-line":"","readonly":""},slot:"activator",model:{value:(_vm.toDate),callback:function ($$v) {_vm.toDate=$$v},expression:"toDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.todatepicker = false}},model:{value:(_vm.toDate),callback:function ($$v) {_vm.toDate=$$v},expression:"toDate"}})],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.invoiceHeader,"items":_vm.getInvoice},scopedSlots:_vm._u([{key:"items",fn:function(props){return [[(!props.item.isTotal)?_c('td',{staticClass:"primary--text font-weight-bold",domProps:{"innerHTML":_vm._s(_vm.renderDate(props.item.date))}}):_c('td',[_vm._v("Total")]),_vm._v(" "),(!props.item.isTotal)?_c('td',[_c('b',[_vm._v(_vm._s(props.item['invoiceId']))])]):_c('td'),_vm._v(" "),(!props.item.isTotal)?_c('td',[_c('b',[_vm._v(_vm._s(_vm.getCurrentUserName(props.item.buyerId)))])]):_c('td'),_vm._v(" "),(!props.item.isTotal)?_c('td',[_c('b',{staticClass:"green--text"},[_vm._v(_vm._s(props.item['ext']['name']))])]):_c('td'),_vm._v(" "),(props.item.isTotal)?[_c('td',[_c('b',{staticClass:"green--text"},[_vm._v(_vm._s((props.item.totalCredit).toFixed(2)))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"red--text"},[_vm._v(_vm._s((props.item.totalDebit).toFixed(2)))])])]:[(props.item.isBuyer)?[_c('td',[_c('b',{staticClass:"green--text"},[_vm._v(_vm._s(Number.parseFloat(props.item['ext']['amount']).toFixed(2)))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"red--text"},[_vm._v("0.00")])])]:[_c('td',[_c('b',{staticClass:"green--text"},[_vm._v("0.00")])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"red--text"},[_vm._v(_vm._s(Number.parseFloat(props.item['ext']['amount']).toFixed(2)))])])]],_vm._v(" "),(!props.item.isTotal)?_c('td',[_c('b',[_vm._v(_vm._s(_vm.getFirmName(props.item.firm)))])]):_c('td')]]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IncentiveInvoices_vue__ = __webpack_require__(582);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_865c7224_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IncentiveInvoices_vue__ = __webpack_require__(1722);
function injectStyle (ssrContext) {
  __webpack_require__(1721)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IncentiveInvoices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_865c7224_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IncentiveInvoices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1721 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-flex',{attrs:{"xs12":""}},[_c('h2',{staticClass:"headline font-weight-light"},[_vm._v("\n          Incentive Invoices\n        ")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('router-link',{attrs:{"to":"/Dashboard"}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("close")])],1)],1)],1),_vm._v(" "),_c('v-toolbar',{staticClass:"mb",attrs:{"color":"white--text","flat":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-autocomplete',{attrs:{"dense":"","flat":"","clearable":"","item-text":"name","return-object":"","items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.fromdatepicker),callback:function ($$v) {_vm.fromdatepicker=$$v},expression:"fromdatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","clearable":"","single-line":"","label":"From Date","readonly":""},slot:"activator",model:{value:(_vm.filterInvoiceFrom),callback:function ($$v) {_vm.filterInvoiceFrom=$$v},expression:"filterInvoiceFrom"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.fromdatepicker = false}},model:{value:(_vm.filterInvoiceFrom),callback:function ($$v) {_vm.filterInvoiceFrom=$$v},expression:"filterInvoiceFrom"}})],1)],1),_vm._v(" "),_c('v-flex',[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.todatepicker),callback:function ($$v) {_vm.todatepicker=$$v},expression:"todatepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","clearable":"","label":"To Date","single-line":"","readonly":""},slot:"activator",model:{value:(_vm.filterInvoiceTo),callback:function ($$v) {_vm.filterInvoiceTo=$$v},expression:"filterInvoiceTo"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.todatepicker = false}},model:{value:(_vm.filterInvoiceTo),callback:function ($$v) {_vm.filterInvoiceTo=$$v},expression:"filterInvoiceTo"}})],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.invoiceHeader,"items":_vm.getInvoice},scopedSlots:_vm._u([{key:"items",fn:function(props){return [[_c('td',{staticClass:"primary--text font-weight-bold",domProps:{"innerHTML":_vm._s(_vm.renderDate(props.item.date))}}),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item['invoiceId']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.getCurrentUserName(props.item.buyerId)))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"green--text"},[_vm._v(_vm._s(props.item['inc']['percentage']))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.paymentType))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.getFirmName(props.item.firm)))])])]]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SmsBook_vue__ = __webpack_require__(583);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7f3324a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SmsBook_vue__ = __webpack_require__(1725);
function injectStyle (ssrContext) {
  __webpack_require__(1724)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SmsBook_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7f3324a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SmsBook_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1724 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-flex',{attrs:{"xs2":""}},[_c('h2',{staticClass:"headline font-weight-light"},[_vm._v("SMS Book")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-switch',{staticClass:"white-switch",attrs:{"label":("" + (!_vm.selectAll ? 'Select All' : 'Unselect All'))},on:{"change":function($event){return _vm.toggleSelect()}},model:{value:(_vm.selectAll),callback:function ($$v) {_vm.selectAll=$$v},expression:"selectAll"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-btn',{staticClass:"primary--text subheading font-weight-bold",staticStyle:{"text-align":"center"},on:{"click":function($event){_vm.dialog=true}}},[_vm._v(" \n          Compose SMS\n        ")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.buyerHeader,"items":_vm.getBuyers,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [[_c('td',[_c('v-checkbox',{attrs:{"primary":"","hide-details":""},model:{value:(props.item.selected),callback:function ($$v) {_vm.$set(props.item, "selected", $$v)},expression:"props.item.selected"}})],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',{staticClass:"font-weight-bold primary--text"},[_vm._v(_vm._s(props.item.name || '-'))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.mobile || '-'))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.prefix || '-'))])])]]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"900"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text",attrs:{"primary":"","title":""}},[_c('span',{staticClass:"headline"},[_vm._v("Compose SMS (160 Characters)")])]),_vm._v(" "),_c('v-card-text',[_c('v-textarea',{attrs:{"name":"input-7-1","outlined":"","label":'SMS (' +(160-_vm.smsText.length)+' left)'},model:{value:(_vm.smsText),callback:function ($$v) {_vm.smsText=$$v},expression:"smsText"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"warning white--text",attrs:{"primary":"","title":"","flat":"flat"},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("\n          Cancel\n        ")]),_vm._v(" "),_c('v-btn',{staticClass:"primary white--text",attrs:{"primary":"","title":"","flat":"flat"},on:{"click":_vm.sendSMS}},[_vm._v("\n          SEND\n        ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductGroupReports_vue__ = __webpack_require__(584);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_668b14bf_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductGroupReports_vue__ = __webpack_require__(1727);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductGroupReports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_668b14bf_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductGroupReports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-cotainer',[_c('v-data-iterator',{attrs:{"items":_vm.items,"rows-per-page-items":_vm.rowsPerPageItems,"pagination":_vm.pagination,"search":_vm.search,"content-tag":"v-layout","row":"","wrap":""},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"item",fn:function(props){return [_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":"","lg3":""}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('h4',[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h4',[_vm._v("Total")])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Calories:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.calories))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Fat:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.fat))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Carbs:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.carbs))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Protein:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.protein))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Sodium:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.sodium))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Calcium:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.calcium))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Iron:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.iron))])],1)],1)],1)],1)]}}])},[_c('template',{slot:"header"},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',[_vm._v("Product Group-wise Reports")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"clearable":"","outlined":"","solo":"","prepend-inner-icon":"mdi-magnify","label":"Search"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":"","disabled":""},on:{"click":function($event){return _vm.print()}}},[_c('v-icon',[_vm._v("print")])],1)],1),_vm._v(" "),_c('v-toolbar',{staticClass:"mb",attrs:{"color":"white white--text","flat":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-autocomplete',{attrs:{"dense":"","flat":"","clearable":"","item-text":"name","return-object":"","items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker),callback:function ($$v) {_vm.datepicker=$$v},expression:"datepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","clearable":"","single-line":"","label":"Date","readonly":""},slot:"activator",model:{value:(_vm.selectedDate),callback:function ($$v) {_vm.selectedDate=$$v},expression:"selectedDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepicker = false}},model:{value:(_vm.selectedDate),callback:function ($$v) {_vm.selectedDate=$$v},expression:"selectedDate"}})],1)],1)],1)],1)],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductSetReports_vue__ = __webpack_require__(585);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c72bd342_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductSetReports_vue__ = __webpack_require__(1729);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductSetReports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c72bd342_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductSetReports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-cotainer',[_c('v-data-iterator',{attrs:{"items":_vm.items,"rows-per-page-items":_vm.rowsPerPageItems,"pagination":_vm.pagination,"search":_vm.search,"content-tag":"v-layout","row":"","wrap":""},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"item",fn:function(props){return [_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":"","lg3":""}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('h4',[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h4',[_vm._v("Total")])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Calories:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.calories))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Fat:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.fat))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Carbs:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.carbs))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Protein:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.protein))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Sodium:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.sodium))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Calcium:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.calcium))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Iron:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.iron))])],1)],1)],1)],1)]}}])},[_c('template',{slot:"header"},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',[_vm._v("Product Set-wise Reports")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"clearable":"","outlined":"","solo":"","prepend-inner-icon":"mdi-magnify","label":"Search"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":"","disabled":""},on:{"click":function($event){return _vm.print()}}},[_c('v-icon',[_vm._v("print")])],1)],1),_vm._v(" "),_c('v-toolbar',{staticClass:"mb",attrs:{"color":"white white--text","flat":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-autocomplete',{attrs:{"dense":"","flat":"","clearable":"","item-text":"name","return-object":"","items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker),callback:function ($$v) {_vm.datepicker=$$v},expression:"datepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","clearable":"","single-line":"","label":"Date","readonly":""},slot:"activator",model:{value:(_vm.selectedDate),callback:function ($$v) {_vm.selectedDate=$$v},expression:"selectedDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepicker = false}},model:{value:(_vm.selectedDate),callback:function ($$v) {_vm.selectedDate=$$v},expression:"selectedDate"}})],1)],1)],1)],1)],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductTypeReports_vue__ = __webpack_require__(586);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bad63dfe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductTypeReports_vue__ = __webpack_require__(1731);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductTypeReports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bad63dfe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductTypeReports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-cotainer',[_c('v-data-iterator',{attrs:{"items":_vm.items,"rows-per-page-items":_vm.rowsPerPageItems,"pagination":_vm.pagination,"search":_vm.search,"content-tag":"v-layout","row":"","wrap":""},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"item",fn:function(props){return [_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":"","lg3":""}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('h4',[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h4',[_vm._v("Total")])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Calories:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.calories))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Fat:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.fat))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Carbs:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.carbs))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Protein:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.protein))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Sodium:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.sodium))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Calcium:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.calcium))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Iron:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.iron))])],1)],1)],1)],1)]}}])},[_c('template',{slot:"header"},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',[_vm._v("Product Type-wise Reports")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"clearable":"","outlined":"","solo":"","prepend-inner-icon":"mdi-magnify","label":"Search"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":"","disabled":""},on:{"click":function($event){return _vm.print()}}},[_c('v-icon',[_vm._v("print")])],1)],1),_vm._v(" "),_c('v-toolbar',{staticClass:"mb",attrs:{"color":"white white--text","flat":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-autocomplete',{attrs:{"dense":"","flat":"","clearable":"","item-text":"name","return-object":"","items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker),callback:function ($$v) {_vm.datepicker=$$v},expression:"datepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","clearable":"","single-line":"","label":"Date","readonly":""},slot:"activator",model:{value:(_vm.selectedDate),callback:function ($$v) {_vm.selectedDate=$$v},expression:"selectedDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepicker = false}},model:{value:(_vm.selectedDate),callback:function ($$v) {_vm.selectedDate=$$v},expression:"selectedDate"}})],1)],1)],1)],1)],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductCategoryReports_vue__ = __webpack_require__(587);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f598fee_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductCategoryReports_vue__ = __webpack_require__(1733);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductCategoryReports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f598fee_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductCategoryReports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-cotainer',[_c('v-data-iterator',{attrs:{"items":_vm.items,"rows-per-page-items":_vm.rowsPerPageItems,"pagination":_vm.pagination,"search":_vm.search,"content-tag":"v-layout","row":"","wrap":""},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"item",fn:function(props){return [_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":"","lg3":""}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('h4',[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('h4',[_vm._v("Total")])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Calories:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.calories))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Fat:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.fat))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Carbs:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.carbs))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Protein:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.protein))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Sodium:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.sodium))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Calcium:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.calcium))])],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_vm._v("Iron:")]),_vm._v(" "),_c('v-list-tile-content',{staticClass:"align-end"},[_vm._v(_vm._s(props.item.iron))])],1)],1)],1)],1)]}}])},[_c('template',{slot:"header"},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-toolbar-title',[_vm._v("Product Category-wise Reports")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-text-field',{attrs:{"clearable":"","outlined":"","solo":"","prepend-inner-icon":"mdi-magnify","label":"Search"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":"","disabled":""},on:{"click":function($event){return _vm.print()}}},[_c('v-icon',[_vm._v("print")])],1)],1),_vm._v(" "),_c('v-toolbar',{staticClass:"mb",attrs:{"color":"white white--text","flat":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-autocomplete',{attrs:{"dense":"","flat":"","clearable":"","item-text":"name","return-object":"","items":_vm.firmsByBrand,"label":"Select Firm"},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',[_c('v-menu',{attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepicker),callback:function ($$v) {_vm.datepicker=$$v},expression:"datepicker"}},[_c('v-text-field',{attrs:{"slot":"activator","clearable":"","single-line":"","label":"Date","readonly":""},slot:"activator",model:{value:(_vm.selectedDate),callback:function ($$v) {_vm.selectedDate=$$v},expression:"selectedDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepicker = false}},model:{value:(_vm.selectedDate),callback:function ($$v) {_vm.selectedDate=$$v},expression:"selectedDate"}})],1)],1)],1)],1)],1)],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiPrintInvoices_vue__ = __webpack_require__(588);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34be6ca0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultiPrintInvoices_vue__ = __webpack_require__(1736);
function injectStyle (ssrContext) {
  __webpack_require__(1735)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiPrintInvoices_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34be6ca0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultiPrintInvoices_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1735 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"invoiceList"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-toolbar',{staticClass:"primary white--text",staticStyle:{"margin-top":"10px"}},[_c('v-flex',{attrs:{"xs12":"","md3":"","sm3":""}},[_c('h3',{staticClass:"title font-weight-light"},[_vm._v("Multi-Print Invoices")])]),_vm._v(" "),[_c('v-flex',{attrs:{"xs12":"","md2":"","sm2":""}},[_c('v-select',{staticClass:"select-firm",attrs:{"dense":"","items":_vm.firmsByBrand,"label":"Select Firm","clearable":""},model:{value:(_vm.selectedFirm),callback:function ($$v) {_vm.selectedFirm=$$v},expression:"selectedFirm"}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-menu',{staticClass:"white-datepicker",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerFrom),callback:function ($$v) {_vm.datepickerFrom=$$v},expression:"datepickerFrom"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"From Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.dateFrom),callback:function ($$v) {_vm.dateFrom=$$v},expression:"dateFrom"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerFrom = false}},model:{value:(_vm.dateFrom),callback:function ($$v) {_vm.dateFrom=$$v},expression:"dateFrom"}})],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm2":"","md2":""}},[_c('v-menu',{staticClass:"white-datepicker",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerTo),callback:function ($$v) {_vm.datepickerTo=$$v},expression:"datepickerTo"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"To Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.dateTo),callback:function ($$v) {_vm.dateTo=$$v},expression:"dateTo"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerTo = false}},model:{value:(_vm.dateTo),callback:function ($$v) {_vm.dateTo=$$v},expression:"dateTo"}})],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"text-align":"center"},attrs:{"xs12":"","md2":"","sm2":""}},[_c('v-menu',{attrs:{"offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"warning white--text",attrs:{"flat":""}},on),[_vm._v("\n                      Print\n                    ")])]}}])},[_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){return _vm.print('printInvoice4')}}},[_c('v-list-tile-title',[_vm._v("\n                        Simple Print\n                      ")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.print('printBasicInvoice')}}},[_c('v-list-tile-title',[_vm._v("\n                        Basic Print\n                      ")])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){return _vm.print('printHorizontalInvoice')}}},[_c('v-list-tile-title',[_vm._v("\n                        Detailed Print\n                      ")])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"text-align":"end"},attrs:{"xs12":"","md1":"","sm1":""}},[_c('router-link',{attrs:{"to":"/Dashboard"}},[_c('v-btn',{attrs:{"icon":"","dark":""}},[_c('v-icon',[_vm._v("close")])],1)],1)],1)]],2)],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation transaction-table",attrs:{"items":_vm.normalData,"pagination":_vm.pagination,"headers":_vm.invoiceHeader},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('tr',[_c('td',[_c('v-checkbox',{staticStyle:{"margin":"14px 0 -14px 0"},model:{value:(props.item.selectedForPrint),callback:function ($$v) {_vm.$set(props.item, "selectedForPrint", $$v)},expression:"props.item.selectedForPrint"}})],1),_vm._v(" "),_c('td',{staticClass:"primary--text font-weight-bold",domProps:{"innerHTML":_vm._s(_vm.renderDate(props.item.date))}}),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.buyerById(props.item.buyerId).name))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["invoiceId"]))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"success--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item["totalAmount"] || 0)))])]),_vm._v(" "),_c('td',{staticClass:"nowrap"},[_c('b',{staticClass:"text-xs-left "},[_vm._v(" "+_vm._s(_vm._f("amount")(((props.item.totalAmount - (props.item.totalExtraCharges || 0 | _vm.amount) - (props.item.roundOffAmount || 0 | _vm.amount)) - _vm.getGSTtotal(props.item)) || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(_vm.getGSTtotal(props.item) || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item.totalExtraCharges || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item["discountAmount"] || 0)))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"primary--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item["paidAmount"] || 0)))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"error--text font-weight-bold"},[_vm._v(_vm._s(_vm._f("amount")(props.item["remainingAmount"] || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["duration"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["paymentType"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["status"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["gstType"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")((props.item["gstType"] == "IGST" ? _vm.getGSTtotal(props.item) || 0 : 0))))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")((props.item["gstType"] == "SGST|CGST" ? _vm.getGSTtotal(props.item) / 2 || 0 : 0))))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")((props.item["gstType"] == "SGST|CGST" ? _vm.getGSTtotal(props.item) / 2 || 0 : 0))))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item["GST_Percentage_total"]
        ? props.item["GST_Percentage_total"]["GST_3"]
        : "" || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item["GST_Percentage_total"]
        ? props.item["GST_Percentage_total"]["GST_5"]
        : "" || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item["GST_Percentage_total"]
        ? props.item["GST_Percentage_total"]["GST_12"]
        : "" || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item["GST_Percentage_total"]
        ? props.item["GST_Percentage_total"]["GST_18"]
        : "" || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item["GST_Percentage_total"]
        ? props.item["GST_Percentage_total"]["GST_28"]
        : "" || 0)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["adminEmail"] ? props.item["adminEmail"] : ""))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(_vm.firmNameById(props.item.firm)))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.voucherType))])])])]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No rows to Show")])],2)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductOrderReport_vue__ = __webpack_require__(589);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fcc9f21_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductOrderReport_vue__ = __webpack_require__(1739);
function injectStyle (ssrContext) {
  __webpack_require__(1738)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductOrderReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fcc9f21_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductOrderReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1738 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-flex',{attrs:{"xs3":""}},[_c('h2',{staticClass:"headline font-weight-light"},[_vm._v("Product Order Report")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('router-link',{attrs:{"to":"/Dashboard"}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("close")])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.headers,"items":_vm.getFilteredProducts,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',{staticClass:"primary--text font-weight-bold"},[_vm._v(_vm._s(props.item["name"]))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"red--text font-weight-bold"},[_vm._v(_vm._s(props.item["orderQuantity"] || "-"))])])]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductLeadReport_vue__ = __webpack_require__(590);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_122df4d0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductLeadReport_vue__ = __webpack_require__(1742);
function injectStyle (ssrContext) {
  __webpack_require__(1741)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductLeadReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_122df4d0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductLeadReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1741 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-flex',{attrs:{"xs3":""}},[_c('h2',{staticClass:"headline font-weight-light"},[_vm._v("Lead Product Report")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('router-link',{attrs:{"to":"/Dashboard"}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("close")])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.headers,"items":_vm.getFilteredProducts,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',{staticClass:"primary--text font-weight-bold"},[_vm._v(_vm._s(props.item["name"]))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"red--text font-weight-bold"},[_vm._v(_vm._s(props.item["leadQuantity"] || "-"))])])]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductEstimateReport_vue__ = __webpack_require__(591);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d855b486_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductEstimateReport_vue__ = __webpack_require__(1745);
function injectStyle (ssrContext) {
  __webpack_require__(1744)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductEstimateReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d855b486_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductEstimateReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1744 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-flex',{attrs:{"xs3":""}},[_c('h2',{staticClass:"headline font-weight-light"},[_vm._v("Product Estimate Report")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('router-link',{attrs:{"to":"/Dashboard"}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("close")])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.headers,"items":_vm.getFilteredProducts,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',{staticClass:"primary--text font-weight-bold"},[_vm._v(_vm._s(props.item["name"]))])]),_vm._v(" "),_c('td',[_c('b',{staticClass:"red--text font-weight-bold"},[_vm._v(_vm._s(props.item["estimateQuantity"] || "-"))])])]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BatchReport_vue__ = __webpack_require__(592);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7189f0e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BatchReport_vue__ = __webpack_require__(1748);
function injectStyle (ssrContext) {
  __webpack_require__(1747)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BatchReport_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7189f0e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BatchReport_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1747 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm12":"","md12":""}},[_c('v-toolbar',{staticClass:"primary white--text"},[_c('v-flex',{attrs:{"xs3":""}},[_c('h2',{staticClass:"headline font-weight-light"},[_vm._v("Batch Report")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('router-link',{attrs:{"to":"/Dashboard"}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("close")])],1)],1)],1),_vm._v(" "),_c('v-toolbar',{staticClass:"mb",staticStyle:{"background":"#15155d !important"},attrs:{"color":"white--text","flat":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-menu',{staticClass:"ist-datepicker",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerFrom),callback:function ($$v) {_vm.datepickerFrom=$$v},expression:"datepickerFrom"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"From Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.fromDate),callback:function ($$v) {_vm.fromDate=$$v},expression:"fromDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerFrom = false}},model:{value:(_vm.fromDate),callback:function ($$v) {_vm.fromDate=$$v},expression:"fromDate"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":"","md3":""}},[_c('v-menu',{staticClass:"ist-datepicker",attrs:{"close-on-content-click":false,"nudge-right":40,"lazy":"","transition":"scale-transition","offset-y":"","full-width":"","min-width":"290px"},model:{value:(_vm.datepickerTo),callback:function ($$v) {_vm.datepickerTo=$$v},expression:"datepickerTo"}},[_c('v-text-field',{attrs:{"slot":"activator","label":"To Date","prepend-icon":"event","readonly":""},slot:"activator",model:{value:(_vm.toDate),callback:function ($$v) {_vm.toDate=$$v},expression:"toDate"}}),_vm._v(" "),_c('v-date-picker',{on:{"input":function($event){_vm.datepickerTo = false}},model:{value:(_vm.toDate),callback:function ($$v) {_vm.toDate=$$v},expression:"toDate"}})],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.batchReportHeader,"items":_vm.getFilteredBatches,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.openInvoice(props.item)}}},[_vm._v("remove_red_eye")])],1),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["batchNumber"]))])]),_vm._v(" "),_c('td',[(props.item['manufacturingDate'])?_c('b',[_vm._v(_vm._s(new Date(props.item["manufacturingDate"])
                  .toISOString()
                  .substr(0, 10)))]):_vm._e()]),_vm._v(" "),_c('td',[(props.item['expiryDate'])?_c('b',[_vm._v(_vm._s(new Date(props.item["expiryDate"]).toISOString().substr(0, 10)))]):_vm._e()]),_vm._v(" "),_c('td',[_c('b',{staticClass:"info--text font-weight-bold"},[_vm._v(_vm._s(props.item["quantity"]))])])]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},model:{value:(_vm.viewBatchDialog),callback:function ($$v) {_vm.viewBatchDialog=$$v},expression:"viewBatchDialog"}},[_c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.viewBatchDialog = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.filteredInvoices},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-left nowrap"},[_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.openProd(props.item)}}},[_vm._v("remove_red_eye")])],1),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(new Date(props.item.date).toLocaleDateString("en-GB") || "-"))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.buyerName || "-"))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('b',[_vm._v(_vm._s(props.item.invoiceId || "-"))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',{staticClass:"font-weight-bold success--text"},[_vm._v(_vm._s(_vm._f("amount")(props.item.totalAmount || 0)))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(_vm._f("amount")(Number.parseFloat(props.item.totalAmount) -
                  Number.parseFloat(props.item.GSTTotal) || 0)))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item.GSTTotal || 0)))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(_vm._f("amount")(props.item.discountAmount || 0)))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('b',{staticClass:"font-weight-bold primary--text"},[_vm._v(_vm._s(_vm._f("amount")(props.item.paidAmount || 0)))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_c('b',{staticClass:"font-weight-bold error--text"},[_vm._v(_vm._s(_vm._f("amount")(props.item.remainingAmount || 0)))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.duration || "-"))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.daysLeft || "-"))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.paymentType || "-"))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.status || "-"))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.gstType || "-"))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.mobile || "-"))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.tehsil || "-"))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.district || "-"))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.state || "-"))])]),_vm._v(" "),_c('td',{staticClass:"text-xs-left nowrap"},[_c('b',[_vm._v(_vm._s(props.item.firmName || "-"))])])]}}])})],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"800","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline primary--text",attrs:{"primary-title":""}},[_vm._v("\n          Product List\n          "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("mdi-close")])],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-data-table',{staticClass:"elevation-1 dashboardHead",attrs:{"headers":_vm.invoiceProductListHeader,"items":_vm.selectedInvoice.items},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_c('b',[_vm._v(_vm._s(props.item["productName"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["HSN_code"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["rate"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item.taxableGST_rate))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["productUnit"]))])]),_vm._v(" "),_c('td',[_c('b',[_vm._v(_vm._s(props.item["quantity"]))])])]}}])},[_vm._v(" "),_c('template',{slot:"no-data"},[_vm._v("No Items")])],2)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("Close")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
]),[593]);


// WEBPACK FOOTER //
// static/js/app.57f278e9391ff79f7940.js